import React from "react"

export default {
	AC: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#006" d="M640 480V0H0v480h640z" />
    <path
      fill="#fff"
      d="M0 73.3h76L0 26.8V0h43.5l106.4 64.8V0h59.9v64.8L316 0h44v26.8l-76.4 46.5H360v73.4h-76.4l76.4 46.6V220h-44l-106.4-64.7V220H150v-64.7L43.4 220H0v-26.7l76-46.6H0V73.3z"
    />
    <path
      fill="#ce1126"
      d="M331.7 0L211.5 73.4h28.8L360 0h-28.3zM360 220l-119.8-73.3H269l90.9 55.9V220zM120.4 73.4L0 0v17.5l91.4 55.9h29zm-.3 73.3L0 220h28.7L149 146.7h-29z"
    />
    <path
      fill="#ce1126"
      d="M0 88.6h162.6V0h35.2v88.6H360v43H197.8V220h-35.2v-88.5H0v-43z"
    />
    <path
      fill="#8fc5ff"
      stroke="#fff"
      strokeWidth={1.1}
      d="M399.7 640.8c0 16.3-2.6 33.9-23.8 42.3-21.1-8.4-23.7-26-23.8-42.3h47.6z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#366cc9"
      stroke="#000"
      strokeWidth={1.1}
      d="M375.9 683a34.3 34.3 0 0 0 18.8-16h-2c-.6-.1-20.3-2-22.7-3-2-.7-9.8.7-13.4 2a34 34 0 0 0 19.3 17z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#5d3100"
      stroke="#000"
      strokeWidth={0.1}
      d="M361.1 673h1.2c.3 0 .3 0 .4-.3s.4-.2.6-.1.6 0 .8-.2c.2-.2.2-.2.4 0s.3.1.5 0c.1 0 .5-.2.6-.5s.4-.4.5-.2.3.2.5.2.2.1.2.4c0 .2 0 .3.5-.1.4.4.5.2.5-.2s0-2-.2-2.1-.3-.8-.4-1.3c0-1 0-1-1-1.5 0-.3-.2-.4-1-.4.1-.1 0-.4-.2-.5s-.2-.2 0-.6c.2 0 .6 0 .7-.3.2-.2.8-.2 1.2 0s.8.2 1.5 0l1.2-.6c.5-.3.6-.4.6-.8 0-1-.3-2-.5-2.5-.3-.5-.3-1-.7-1.9-.4-.8-.4-1-.8-1.5-.2-.2-.3-.3-.3-.6a1.5 1.5 0 0 0-.5-1c-.8-.7-1-3-1.4-4.7-.2-1 0-3.3-.4-3.7-.7-.5-1-.4-1.5-.6-.4-.5-.5-1.4-.9-2.3-.5.1-.8.6-1.1.8s-.4.2-.4.7c0 .4-.3 1-.7 1.8s-1.3.5-2 1.6c-1.4-1.7-1.4-2.2-1.5-2.7 0-.5-.3-.6-1.1-1.3v-1.5c-.7-.5-1.1-.4-1.4 0-.3.3-.5.8-1 1-.2.4-1 1.2-1.6 2.3.6 9 2.6 18 8.7 25.2z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#ff0"
      stroke="#fff"
      strokeWidth={1.1}
      d="M399.7 640.8c0-6.2-.3-12.2-.2-17.4a63.6 63.6 0 0 0-23.6-4.3c-5.3 0-15.7.8-23.6 4.3.2 5.2-.2 11.2-.2 17.4h47.6z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#cf6200"
      d="M394.6 297.9c1.2 1.9 3.3 5 3.5 6.8.8-1.7 1.5-2.4 1.6-3.5s1.5-3 1-4.2-.8-2 .4-1.2c1.3.9 1 2.3.8 4.4-.8 5.7-3.1 6.8-3.5 10.7 3.4 8 .9 11 4.6 19 .6.3 2.1-.3 2.6-.2 2-1.4 3.5-1 6.3-.3 2.8.5 4.3 2.5 4.3 4.3s0 2.2.6 3.2 1.7 2.7 1.5 3.9c-.3 1.2.2 1.9.6 2.4s-.2 2-.5 2.7-.2 1.9 1.2 3.6c1.4 1.8 4.6 9.1 4.6 13.4 0 4.4.3 6.4 2 7.2 1.8.8 2.3 1.5 2.1 3.3s.8 11.6 1 13.1.9 1.2 1.6 2c.7.8 1.1 1.7 3.5 1.7s4.6-.3 6 0c2.2 2.9 3.5 6.8 4 9.3s.4 5.8 1.2 5.8 1.6 0 1.4-3-.5-3.4-1.5-5c-1.1-1.5-1.7-2.2-1.1-3.1s.7-2.4.5-3.6-.6-3 1.4-.6l3.1 3.7c.6.7.8 2.4.7 3.8-.1 1.4.1 2 1 1.2.8-.7 1.8.5 1.3 2s.2 2.5 1.6 3 2 .8 2.3 1.8 1.5 1.5 1.5-.6c0-2-.8-6.5-1.4-7.9-.6-1.4-1-4.4-1.2-6.2s-.4-2.2-1.2-2.5-1.6-1-1.7-1.8-.8-1.1-1.3-1.1-1-.4-1.3-1-.6-.6-1.2-.7-1.5.3-1.8-.6-.7-2.3-1.3-3-1-1-1.1-3.7c0-2.6-.1-3-1-3.9s-2.2-3.4-2.8-4.4c-.5-1-1.1-2.1-1.1.1s0 3.4 1.4 4.2c1.4.8 1.7.8 1.1 2s0 2 .3 2.8.7 1.6 0 2.4c-.7.8-1.4.6-1.3-.7a7.3 7.3 0 0 0-1-3.8c-.5-1-1-1.8-1.7-1.2s-1.3-.1-.8-.6.3-.8 0-1.1-.5-.7.1-1.4.6-1 .2-2.7c-.3-1.6-2.9-9.8-4-11.7s-1-3.2.4-1.4 2.8 3.5 3 5c0 1.6.4 2.5.9 3s.8.4 1-.9 1.2-.8-.4-3.2c-1.7-2.5-4.7-6.6-5.9-14s-1.6-12.1-2.8-14.1c-1.1-2-1.5-2.5-1.6-4.3s0-3.8-.8-5.2c-.8-1.4-1.4-1.6-1.5.5-.1 2 0 6.8.7 7.6s.2 2.9 0 4-1.9 2.4 2 4.7c1.5 1 1.2 2.2 1 3-.2.9-.5.8-1.3-.5s-1.6-2.4-2.4-3-1-1.2-.8-2.9.4-2.8 0-3.3c-.5-.6-.7-.2-1 .8-.2.9-.4 3.5-1 4.2s-.6.2-1-1.3.2-3.9 1-6.5 1.3-5.5.6-9c-.7-3.5-.4-4.6-3-7.5-2.7-2.9-5.8-5.7-7-9.3-1.3-3.6-1.6-6.8-3-8.4a19.4 19.4 0 0 0-4.6-4.3v-5.4c0-1.3-.6-2-2.1-1.8s-2.5 1.5-3.4 3.2c-1 1.8-1.6 1-3 4s-3 4.5-3 7.8z"
    />
    <path
      fill="#cf6200"
      d="M403 332c1 .7 1.9 1 3.3.3s3-2.7 5-.7c1.8 2 2.8 5.3 2.8 7.8 0 2.6 0 7.4 3 10 2.9 2.7 4.4 5.5 4.5 9a61 61 0 0 0 1.7 10.3c.4 1.4 1.2 3 2.1 4s1.7 3.6 1.8 6.4c.1 2.8-.4 4.7 0 6.1s0 2.6-1 2-1.3-1.1-2-2.3-1.2-1-.6.8 2.3 3.4 3.8 3.4 2 .2 3 1.2c.9.9 1 1.4 2.6 1.4s1.9 0 3.4.4 1.5.3 2.3 0 1.7.5 2.2 2 2 5.7 2 6.9 0 2.3.8 3.5.6 2.3-.3 1.6-1-.5-1.6-.3-1.2-.3-2.1-.9c-1-.5-.4-.4-1.3-1.8s-1.5-1.9-1.5-.8-.2 2.3-.9 1.7-1-.6-1.6 0-.8 1-1.5-.1-1.5-1.2-2.2-1.4-.7-.2-1-1.3c-.4-1-1.5-1.3-2.4-1.3s-1.4-.4-1.5-1.1c-.1-.7-.7-1.2-1.2-1.5s-.2-1.2-.3-2-.8-.5-1.3-.7-.8-.1-.8-1.3-.5-1.5-.8-2.3c-.4-.9 0-1.7.2-2.6.2-1 .1-1.5-.6-2.3-.7-.8-.1-1.7-2-3.3s-2.8-.2-3.4-4c-.5-4-1.7-11.9-2.8-13.1s-1.7-2.3-2.8-2.6-1.7-.1-1.8-2.3c-.1-2.2-.8-5-2.2-6.4l-2.7-2.5c-.7-.5-1-1.6 0-3.6s.6-4.7.5-6c-.2-1.2-.5-2.9-.3-4.3s.1-3.1-.2-4-.8-1.2-.2-2zm28.1-33a25.4 25.4 0 0 1-5.4 5.2c-2.2 1.6-5 2.8-3.4 5.4 1.5 2.7 2.8 3 3 5 .4 2 .9 3.8 2.4 4.2 1.6.5 2.2.2 2.2 3.4s0 4.6 1.4 5.8 1.2 2.5 1.8 5.4c.7 3 .7 9.4 2.5 13.7s6.1 12.6 5.6 14.3-1 3 .8 5c1.9 2 3.1 5 3.3 6.7.1 1.7.4 2.3 2.3 1.7a6.8 6.8 0 0 0 3.4-2c.6-.8 1.9-.6 3.6.3 1.7 1 4.4 1.8 6 1 1.5-1 2.2-2.4 3.6-2.4 2.2-1.6 3-4.8 3.5-5.8.4-.9.1-.9-.8-1.8s-.5-2.5-.6-4c-.2-1.6-.8-4-2.7-7.4-1.8-3.4-3-7.6-4.2-8.7-1.2-1-1.8-3.7-2-5-.1-1.2-1.5-2.3-2.5-3.2-1-1-1.8-2.4-3-7.8-1-5.4-1.8-9.3-1.8-10.3s-.2-1-1.1-1.4-1.4-1.8-1-2.6c.2-.8-.4-1.6-.7-2.5s0-2.6.6-3.6.5-3.5-.1-5.7-1.3-4-3.8-4.4c-2.4-.3-3-1-3.8-3-1-2-2-5.5-2.2-6.3-.3-.8-.8-1-2.7.6-1.8 1.6-2.5 2-2.5 5 0 1.9.4 2.5 1 3.6.6 1 .8 1.4 1.2 4.3s3.1 7.6-.3 10.3c-3.4 2.6-3 3.3-2.8 5.1.2 1.9-1 3.1-1.5.5-.7-2.7 0-4.2 1.8-5.5 1.9-1.2 3.6-2.8 2.4-4.5-1.3-1.7-1.8-5.7-2-7.6s-.4-2.5-1.5-1z"
    />
    <path
      fill="#00b800"
      d="M403.4 338.5c0 1.3.2 2.7.3 3.8.1 1.3.5 4-.5 6-.9 2-.7 3 0 3.6h.1c2-.6 2.2-2.7 1.7-3.7a3.7 3.7 0 0 1 .2-3.5c.6-1.1.6-1.7.1-2.5-.6-.8-.6-.8 0-3 .6-1.9-.8-1.9-1.9-.7zm20 30.2c-.4-1.4-1.7-6.8-1.8-10.3-.1-3.5-1.7-6.3-4.6-9-2.2-2-2.7-5.4-2.9-8-1.7-1-2.4-.6-2.2 1.4.1 2 2.2 3 2 6.1-.4 3-.4 2.3 1 3.7s2 3 1.3 3.5c-.8.6-.8 1.7.2 2.1 1.1.4 1.2 1.6 1 2.7-.1 1 1 1.3 1.5 2 .7.8.7 2.7.1 3.8-.6 1-.7 2.8.4 1.9 1-1 1.6-.1 2.4 1.4.7 1.2 1.4.8 2.2.5a9.8 9.8 0 0 1-.7-1.8zm15 27.1c-.6 1.4-1.4 1-2.1.3s-1.5-.7-1.2-2 .2-1.5-.7-2.2l-.3-.3h-1c-1.7 0-1.8-.4-2.8-1.4a7.8 7.8 0 0 0-.6-.5v.9c0 1.3 0 1-1.2 1.4s-1-1.3-1.3-2.3a3.9 3.9 0 0 0-.2-.7c-1.4-.2-3-1.7-3.4-3.3-.6-1.8 0-2 .7-.8s.8 1.5 1.8 2.2 1.4-.5 1-1.9a6 6 0 0 1 0-1.5c-.3-.5-.6-.8-1-1-2-.9-1.4-1-1.3-2.6.2-1.5-.2-1.5-1.4-.7-1.1.8-1.2-.1-1.2-2.5s-1.6-2.3-1.9-.7c-.4 1.7-1 .6-1.6-1.7s-1.7-3-1.8-.7c0 1.9-.6 2.3-1.8 1.3l.5 3.6c.6 3.8 1.5 2.4 3.4 4s1.3 2.5 2 3.3c.7.9.8 1.4.6 2.4-.3.9-.6 1.7-.3 2.5.4.9.9 1.2.9 2.4s.3 1 .8 1.3l1 .1.8-1.2c1.4-1.4 3.5.1 4.2 1.9s1.5 2.2 2.6.8.7-1.2 1.9.1 1.6 1 1.6 1 1.2-.4 2 .3 1.3.6 2.8-1.6c1.5-2.3-.7-1.6-1.4-.2zm4.2-64c.5-3.4.2-6.8 1.6-8 1.4-1.3 3-3.8 3 1.5-.2 5.3-.4 5-1.5 6.2-1 1.3-2 1.6-1 3.6 1.2 2 1.3 2.2 1.2 5.3-.2 3.1-.2 4.4 1 6 1.3 1.5 1.6 1.6 2 3.3.2 1.7 1.3 4 2.7 5.3s3 4.8 3.1 7.3c.2 2.5 2.4 3.1 4.4 4.9 2 1.7-.5 2.9-2 2.1-1.6-.7-1 0-1.9 1.1-1 1.1-1.2 1.3-2-.6s-3.4-3.1-4.7-3.6-2.3-2.5-3.4-4.5a6 6 0 0 0-4.5-3.1c.5 1.3.7 2.3.6 2.8-.5 1.7-1 3 .8 5 1.9 2 3.1 5 3.3 6.7.1 1.7.4 2.3 2.3 1.7a8.3 8.3 0 0 0 3.4-2c.6-.8 1.9-.7 3.6.3 1.7.9 4.3 1.8 5.9.9 1.5-1 2.3-2.3 3.7-2.3 2.2-1.6 3-4.9 3.4-5.8.5-1 .2-1-.7-1.9s-.5-2.5-.7-4c-.1-1.6-.7-3.9-2.6-7.3s-3-7.6-4.2-8.7c-1.2-1.1-1.9-3.7-2-5-.2-1.2-1.6-2.3-2.5-3.3-1-.9-1.9-2.3-3-7.7-.8-4.3-1.5-7.6-1.7-9.3-1.1 1.8-1.9 2.3-2.3 1-.5-1.4-1-2.1-1.7-1.2-.6 1-.8-.8-.8-1.6s-.1-.9-1-.9 0-1.2-.4-3.6c-.3-2.3-.8-2.6-1 .2-.4 2.8-2 4.5-1.3 5.1.6.6.3 1.9-.3 3.7-.6 1.9-.3 3 .1 4.2s-.3 3.6-.6 5.6c-.3 2 1.3 4 1.7.7zM414.2 304c-1.1.1-2 1.1-1.3 4.7.5 2.2-1.2 1.7-1.8.6-.6-1.1-1.1-3.4-2.4-5.4-1.2-2-.6 1.3-.7 3.2-.2 1.9 1 1.9 2.1 3.4 1.1 1.6.2 2.2-1 2.2s-.7 2.5-.4 4.2-.3 2-1.2.6c-1-1.4-.3-3.5-.2-6.2.2-2.6.4-2-1.4-2.6-1.7-.7-1.4-1-.7-2.5.6-1.6 1.2-2.4.4-3.1-.7-.8-.6-1.3.7-1.4 1.2-.2.7-1.1 1.8-1.4 1.1-.3 1.6.1 1.7-1.9.2-1.7.7-2.7 2-2.2.8 2.6 1.7 6.6 2.4 7.8zm15.7 18.4c0 3.2 0 4.5 1.4 5.7s1.2 2.5 1.8 5.4c.7 3 .7 9.4 2.5 13.7l2.1 4.7a8.8 8.8 0 0 0 2.3-3c.4-1-1-3.2-2-5-1.1-2 .1-2.6 1.2-5 1.1-2.2-.1-2.4-1.9-3-1.7-.6-1.7-2.2-2.6-4.7s-.8-3.6-.2-5 .2-2.5-1-2.8c-1.3-.3-1-1.2-.5-2.8.5-1.5.8-1.8-1.1-1.4-1.4.4-1.8.7-2.2 1.2l.2 2z"
    />
    <path
      fill="#5d3100"
      d="M447.8 328.8c-.2 1.8-.2 2.8-.7 3.4-.4.6-.1 1.5.4 2.5s.7 2.1.3 3.9.3 3 1.2 3.5 1.4 0 1.1 2.2a6.7 6.7 0 0 0 2 5.5c1.1.9 1.9 2.4 1.7 3.4-.1.9.8 1.8 1.9 2.3 1.1.5 1 .6 1 1.2s.4.7 1.6 1 2.2 1 3.6 2.8 3.4 2.6 3.1.8 0-3.2-1.8-4c-1.9-1-3.3-5.5-4-8.6-.9-3.2-3.3-7.3-4.7-8.1-.2-2.2.1-3.3-1.3-4.4a4.5 4.5 0 0 1-1.9-3.6c0-1-.7-2.4-1.4-2.8-.6-.3-.9-1-.9-2s-1-.8-1.2 1z"
    />
    <path
      fill="#00d860"
      d="M439.5 412.2a45 45 0 0 0 11.2-3.2c1.9 1.3 5.1 3 6.5 3-2.6.6-4.4.3-5-.2.3.8 1.2 2.1 1.8 2.2-2.6 0-5.5-.7-6.4-1.6-2.3 1-6 1.2-8-.2zm5 3.5c1 .3 6 1 6.6 1-1.6 1.5-.2 2.8 2.5 2.6-1.3.2-2.8.7-1.8.9a28 28 0 0 0 10.2-2c-2.2 2.8-13 5.5-17.5-2.5zm4.5 7c1.3-.6 4.6-.4 6.2.3-1.7.7-5.2.7-6.2-.2z"
    />
    <path d="M454 422.7c2.4-.4 9.1 1.2 11.5-.3-.8 2.2-5 2.5-6.5 2-1.5-.4-2.9-1-3.9-1 .6-.3-.3-.3-1.1-.7z" />
    <path
      fill="#00d860"
      d="M456.4 426a35 35 0 0 0 10.3-1.3c2 .7 6.2 1.8 7.2 1.7-2 1.2-5.8.5-7 0a12.5 12.5 0 0 1-10.5-.4z"
    />
    <path
      fill="#00d860"
      d="M459.5 427c2.6.6 4.8.2 7.4-.6.8.3 2.6.7 4.4.7 1.2.6 2.7 1.5 4.3 1.7a19 19 0 0 1-8.6-.7 22 22 0 0 0-9.1 1.7c0-.8.5-2 1.6-2.7z"
    />
    <path d="M456.4 414c2 .6 9.4.3 13-1.5 1.6-.7 2.5.5.8 1-6 2.2-10.9 3-14.3 1.1-1.4-.7-1.6-1.4.5-.7z" />
    <path
      fill="#00d860"
      d="M492.2 404c-9 4.2-14.9 5.5-27.4 1.6-1.1-.3-2 0-.7.8 1.3.9 8.2 2.7 9.8 2.9s1 .8 0 1.1-1.2 1 .1.5 8.9-.7 12 .9c1.3.7 1.6.5 1.5 0s.6-.9 1.6-1 1.6-.4.8-.7-.9-.5-.3-.8.7-.6-.2-.8-1.5-.4-.7-.8c.9-.4 2-.7 3-.8.2-.6-.2-2.3.5-2.9z"
    />
    <path d="M477.3 405c5.1.4 14.6-2 19.6-6.8 1.7 1 4.2 2.2 5.5 2.4s2.4 1.4.4 1.4-4.7-.8-6-1.4a33.8 33.8 0 0 1-19.4 5c-1.4 0-1.7-.6-.1-.5z" />
    <path
      fill="#00d860"
      d="M462.1 377c1.8 1.3 4.9 3.3 8.9 3a19.5 19.5 0 0 0 6.5 3.3c-2.7 1-5.6 2-6.4 2.9-1.2-1.2-2.8-1-3.2-1.6-1.2 1-1 1.5-.2 2s6.6 1.4 8 1 2 .8.7 1.3c-3.1 1-9.2 0-11.3-3.4-2.2-3.3-4-4.6-9.7-1.5-.6-1.7-.6-2-1.7-2s-3.2-1.5-1.6-1.5 6.2-.6 10-3.4z"
    />
    <path
      fill="#00d860"
      d="M463.5 384.6c-1 .2-3.7 1.7-4.7 1.8-1 .2-2.7 1.6-1 1.6 1.9 0 4.2-2 5.5-2s1.4-1.7.2-1.4zm5.7 5.9c-.7.1-3.7.8-4.5.8s-1.7.1-1.6.7.3 1-1 .8-2.2.4-2.5.7-.5.7.7.8 1.9.3 3.3-.4 2.7-1.6 4.2-1.7c1.5 0 3-2 1.4-1.7z"
    />
    <path d="M465 394c1.3 1 7.6 3 9.8 2.9s1.9.9.2 1.3a14 14 0 0 1-11-3.2c-1.4-1.1 0-1.6.9-1z" />
    <path
      fill="#00d860"
      d="M494.8 397.2c-4.8 1.5-9.7 1-11.7.4s-3.8-.6-2.4.7c1.3 1.3 5.6 2.1 8 1.5-8.6 2-10.9 1.8-13 1.5-2.2-.4-6.2-.3-8-.2-1.2.2-3 0-3.8-.5s-1-1.3 1.3-1c2.3.1 2.6-.3.6-.6s-4.7.5-2 2.2 8.5-.1 12.3 1a21.4 21.4 0 0 0 19.1-4.3c.4-.3 1-1.2-.4-.7zm-23.7-7.1c.2.6.2 1.2 0 1.6s-.1 1 .6.4 1.2-1.3 2-.9 2.7.4 3.6.2c.8 0 1.1-.3-.2-.8-1.2-.5-2.5-.7-3.2-.6s-1.6-.1-2.2-.4-.7 0-.6.5z"
    />
    <path
      fill="#00d860"
      d="M483.6 392.3c-1 0-2.8-.6-3.7-1s-2.3-.4-1.3 1 5.3 2 6.8 1.4 1-1.4 2.4-.4c1.5.9 3.1 1.5 4.2 1.5s1.5 0 .3-.7-1.8-.8-2-1.4-.2-1 1-.6 2.3 1 3.2.5 2.5-1.5 4-1.5l.3-.9c-2.1-.1-3.5.5-4 .7s-1.7.4-2.8.2-2.5-.3-2.9-.6-.3-.5.6-.7 1.2-.8 0-.6-4.8.2-6.6-.4c-1.8-.6-2.6-.7-3.3-.4-.8.3-.7 1.1.4 1.2s3.7.3 4.5 1.1.8.9-.2.5-2.8-.2-1 1.1z"
    />
    <path
      fill="#00d860"
      d="M498.8 390.2l-.4.9c2.2 0 7.4.5 9.1 1.5 1.7-1.3 1.4-1.7 2.5-1.4s2.7.6 3.3.3 1.1-.3 1.8-.2 2.2-.2 3.1-.7 2.7-1.2 3.7-1.2 2.3-.3.4-.6-4.8.3-5.8.7c-1 .3-4 .6-5.7.6s-4.1.8-6.1.3-4.8-.2-6-.2z"
    />
    <path d="M525.8 389.2c-3.5 2.6-7.7 3.1-12.7 3.5-1.5.1-1 .5.2.6 5.3.6 11.3-1.4 13.3-3.5.6-.6.5-1.6-.8-.6z" />
    <path
      fill="#00d860"
      d="M502 395.2a54 54 0 0 1 8.4 2c1.3-.2 1.7-.5 1.4-1s-.4-1 2-.8h8.6c.9-.3 2.7-1.7 3.5-1.7-2.1 0-10.9.5-12 .4s-1.7 0-2.4.4-1 .6-2 .2-2.4-.8-3.3-.2c-.8.5-2.7 0-4.2.7z"
    />
    <path
      fill="#00d860"
      d="M522.4 395.4c.8-.3 2.6-1.7 3.5-1.8 1.5-.1 3.2.5 4 .7s1.7-.1 1.2-.7-.1-1.8 2.3-1.5c2.4.3 3.6.7 6 .5s3.3 1.5 7.7-.3c-.3 1.8.5 1.9 1.3 1.6s1.8-.3 3.2.8 9.9 1.1 11.9.8c2-.4 3 .7 1.5 1.2-1.5.4-1.9 1.1-1.5 1.6.3.5.7 1-1.2.8-1.9-.2-2.2.4-3.1 1s-1.2 1-3.8.5c-2.5-.4-3-.1-4.4.1s-1.8.3-3.2-.2-4.4-1-6.3-.3-3.2 1.1-4.9.7-1.7-.3-.7-1.3 1.3-1 3.3-1.2c2-.2 3.5-.8 2.1-1.6s-1.8-.7-3.7.2-2.8 1.5-5 .4c-2-1.2-3-1-4.5-.6s-3.7-.5-5.7-1.4zm7 3.5c-2.7.4-3.4-1.3-6.2-1-.9.2-2.5 1.3-.3 1.1 2.1-.1 4.5 1 6.6.9s1.2-1.1 0-1zm-3 2c1.3-.5 4.2.5 5.5.3s2.4.5 1 1-4.3-.8-5.7-.4-2.8-.2-.9-.9zm-28 7.6c2 0 9-.3 11.7-6 .2-.5.4-.7 1.2-.1s4.1 2.5 10.1 3c1.7.1 3.5 1 .1.8s-8.7-1.2-10.5-2.3c-3 4.8-8.5 5.3-12.5 5.2-2.5 0-1.9-.7 0-.6z"
    />
    <path
      fill="#00d860"
      d="M513.5 400.5c-1 1.3-4.2 3.5-5.6 3.7-1.5 0-5.9-.3-7-.7s-2.4-.3-.9.8 5.5 1.8 7 1.5c1.7-.4 3.5-.9 4.7-.1s3.5 2.2 4.8 1.9c1.4-.3 4.1-.3 5 .1.9.4 2.4 1.7.1 1s-4.1-.2-5.2-.6c1.2 1.6 3.8 4.2 6 4.2.6 0 1 1-.1 1.5 1 .5 3.6 1 5-.3-.4.5-.2.8.4 1s1.3.7.2.9-3.4.4-4.1 0c2.2 1.5 8.1 3.9 14.1 2.7 1.2-.2 1.8-.7 0-.6-4 0-4.2 0-4.9-.4-.7-.4-.5-.8.6-1.1 1-.3 3.9-.8 5-.8s2.4-.4 0-.4-5.3 0-6.5-.4-2-1-.8-1.8 2.5-.6 3-1.3c-3.8 0-8.5-2.1-5.9-4 .6-.4.4-.5-.5-.6s-4-1-5.2-1.6-.4-1.3.6-1.5c-2.3.4-6.8-.8-9.8-3zm34.1 0c-2 1.5-6 2.2-7.7 2.2s-2 .6-.6.7 2.8.4 3.4.2 1-.2 1.8.2c.9.4 2.7.6 4.4.1s4.3-.8 5.4-.7 2.3.1.1-.5-5.8-.2-6.7 0-3.3 0-2-.3 2.4-1 3-1.6l-1-.3zm-1 4.5a13.5 13.5 0 0 1-7.1 2.7c2.4.9 4.4 3.4 6 3.3-.8.5-1.7 1.2-2.7 1.3 1.6.4 4.1 0 6.2-1.2 3.5 1 8 .3 9.6-1-2.3 0-5-.8-6.3-1.9 1.1 0 2.2-.6 2.7-1.3-2.6.5-7-.8-8.4-2z"
    />
    <path
      fill="#00d860"
      d="M542.8 412.3c1-.1 2-.8 2.7-1.3a22 22 0 0 1-12.8-2.9c-2.5-2.2-2.5-.5-.8 1s4.9 4 11 3.2zm6.2 5.3c-1 .6-6 1-7.7.6s-2.3-.2-2 .5.7 1.2-.7 1-3.7.2-4.7.5-2.2 1.2-.1.9 4-.8 5.6-.4 7.1.5 8.2 0 .4-.4-.1-.4-.8-.3 0-.7 1.3-1.3 1.5-2zm-48.5-6.7c-2.1.9-9.1 2.8-11 2.9-2.3 1-4.2 1.6-5.3 1.6.8.7 4 1.4 5.2 1-.7.8-2.3 1.6-2.9 2 1.9-.3 4 .2 5 .3a14 14 0 0 1-7.6 1.6c.6.8 1.4 1.6 2.5 1.6a13 13 0 0 1-6.3.2c.6 1.1 1.1 1.8 2 2-1.9.2-4.2.5-6.2-.6 1.5 2 4.9 2.6 9.9 2 5-.5 9.2-2.7 10.4-3.7-2.1.3-5 .4-6.3.1a37 37 0 0 0 9.9-4.3 5.6 5.6 0 0 1-3.2-1 31 31 0 0 0 9.1-1 6.7 6.7 0 0 1-4-2.6 39.2 39.2 0 0 0 19.5.6c1-.3 1-1.5-.8-1.3-3.2.2-9.5-.7-11.2-1.5a11.6 11.6 0 0 0 4.7 2c-3 .9-7.2 1.5-13.4-2z"
    />
    <path
      fill="#00d860"
      d="M486.5 418.4c.6-.4 2.2-1.2 2.9-2-1.3.4-4.4-.3-5.2-1 1.1 0 3-.5 5.3-1.6-4.2-.1-7-.1-8.6-1s-4.3-.5-5.4-.3-.7 2 3.8 1.5a15.4 15.4 0 0 1-8.8 1.3c.5 1.5.8 3 .4 3.9 2.4 1.4 8.8 3.1 12 2.9-2.8-1-4.3-2.2-2-2.5s3.6-.7 5.6-1.2z"
    />
    <path d="M479.3 426c5.5-.5 13-.6 19-5.7 1.5-1.2 2.5-.8 1 .5a33 33 0 0 1-18.4 6.8c-3 0-4.4-1.4-1.6-1.7z" />
    <path
      fill="#00d860"
      d="M521 416.7c-1.3.5-5.2 1.2-6.4 1-1.2-.2-2.9-.2-3.8.3s-1 1 .3 1l3.7.3a6.2 6.2 0 0 0-2 1.7c2-.4 5.4.4 6.4 1a3 3 0 0 1-2.3-.5c3.1 3.4 12.5 3.4 14 2.8-.7.5-1.4 1-2 1.2 2.6.5 5.6.4 8.6-1.3-1 .1-4-.1-4.8-.2a5.6 5.6 0 0 1 2.3-1.3c-1.2-.3-4.8-.2-5.7.3a4 4 0 0 1 1.7-1.9c-4.6 0-10.2 0-12.2-1.1 3.2.3 6.8-1.6 8.3-1.6-2.5 0-5.3-.6-6-1.7zm-11.6 2.5c-2.3.5-5.7 1.5-6.7 2s-1.9.8.1.8a125.5 125.5 0 0 1 .7-.2c-.8 0-1.7 0-.2-.5s3.5-1.5 6-2zm-4.6 5.5c.8 0 4.3 0 5.7-1.2 1.5 1 4.3 2.6 6 2.6 1.9 0 1.7.5.1.7a12 12 0 0 1-6.2-2c-2.1.8-3.8.2-5.7-.1zm-27 15.7c3.6 1.4 8.3 2.4 11.8 1.3 2 1.7 6.1 1.8 8.3 1.4 2.2-.5 4.2-.7 6.7 0 2.4.9 7.4 1 8.8 2.1-1.3 0-4 0-4.7.2-.6.2-.3.6 1 1.2-4-.2-10.9 1.5-13 3.3a7.3 7.3 0 0 1 6.8-4.3c-2-.7-8.8-.8-11 .6a6.7 6.7 0 0 1-1.4-2.4c-3.6 2-10.6-.9-13.4-3.4zm-9.3-6.6a16 16 0 0 0 8.5-3.2c.8.7 4 1.4 7.4.3-.7.5-.8 1.5-.5 2a26.2 26.2 0 0 0-8 2c-1.5.7-5.8 1.3-7.2.5-1.4-.7-1.4-1.4-.2-1.6z"
    />
    <path
      fill="#00d860"
      d="M483.9 433a26.2 26.2 0 0 0-8 2l.5 2a51 51 0 0 1 17.5-1.8c-1.8.1-5.1 2-7 2.1 4.6-.3 9 .6 10.2 1 1.1.2 1.4 1 .5 2s-1.3.8.6 1c1.8 0 5.7-.3 7.4-2-.7-.7-2.5-.4-3-1a8 8 0 0 0 3.1-1.9 29 29 0 0 1-5.3-.3c-1-.3-1.8-.6-.5-1.3a7.6 7.6 0 0 0 2.2-1.7c-2.2.6-5.8 1.2-8.8-1.2 1.1.3 3.8.1 4.7-.3a6 6 0 0 0-2.6-.9c2.4-1.2 7-2.2 13 .1 2.8-.2 6 0 8.2.5 1-1 2.9-3.2 4-3.7-7 .5-19.3-.7-19-4.4-2.3 3-7.4 4.6-9.6 4.1-.2 1 .7 2.4 1.5 3-2.3.5-6.3.9-8.2.5 1.1 1 3 2 4.2 1.9-2.4 0-3.7.5-5.6.3z"
    />
    <path
      fill="#00d860"
      d="M498.1 441.2c2 0 5.8-.2 7.5-1.9-.7-.7-2.5-.4-3-1a8 8 0 0 0 3.1-1.9c5-.4 9.3-.2 11.4-.8 2.1-.6 7.5-.3 8.5-.6-4.7.8-5.6 1.2-5.8 2s1.5 1.3 2.6 1.3c-2 0-4.7 2.1-5 3-2.8-1.6-4 .3-4.4 1-1.1-.5-5-.4-7 1.3-2.5-.8-4.2-1.2-6.8-.8 1.6-.3 1.3-1.4-1-1.6zm22.4-13.7c1.6 0 5 .2 6.3 0a7.5 7.5 0 0 0-2.1 1.5c4-.5 9.4-.8 11-.5-2-.3-4 1-5 1.6s-.4 1 1 1.2 3.1 1.2.7.9-7.3-.4-8.5-.2-1.8-.4 0-.7 2.8-.8 3.6-1.2c-1.4.3-4.1.3-5 0s-1.3-.6-.3-.9.3-.5-.7-.4-3.5 1.1-5 2.5c1.6-1.6 3-3 4-3.7z"
    />
    <path d="M502.8 430.2a10 10 0 0 0 7.8 3.5c.7 0 2.2 1 .3 1.1-4.9.2-7.3-1-9.5-4.1-.4-.7.4-1.6 1.4-.5zm29.2-40.8c2.6 1.2 7.7 2.3 11.8 2.1.7 0 2 .7.3.9a21 21 0 0 1-12.4-2.3c-1-.6-.7-1.2.3-.7z" />
    <path
      fill="#00d860"
      d="M534.6 389.4c4-.1 7 0 8.1 1 2.3-.6 6.4-1 7.3-.8s2-.3-.2-.8-7.1-.7-8.7-.4c-1.6.3-6.5.5-8 .3.6 0 1 .2 1.5.7zm15.4 1.5c1.8-1 7.2 0 8.8-.7-1.1 1.4 3.8 1.5 8 .4-1.6 1-5.1 1.2-6.6 1.9s-2.4.1-3.5-.4-4.2-1.6-6.7-1.2z"
    />
    <path
      fill="#00d860"
      d="M566.8 390.6c-4.2 1-9.1 1-8-.4-1.6.7-7-.3-8.8.7 2-1.1 3.4-.2 4.8-2.6.9.2 2.9.3 3.6-.6 1.2.3 3.4.8 4 1.4.6.7 1.6-.2.8-1.1 2-.7.7.8 5.2-.3 1-.3 3.2-.7 4-.7a27.6 27.6 0 0 1-5.6 3.6z"
    />
    <path
      fill="#ff0"
      stroke="#000"
      strokeWidth={0.1}
      d="M373.4 664.2l-.2-22.2c0-1-.5-.8-.5 0v22l.7.2zm7.2-23.4l.8 23.4-.1.2h-.5l-.5-23.6h.3zm6.8 19.8l-.4-19c0-.6-.5-.5-.5.1l.4 18.9h.5z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M376.6 644.7l-7-.1c-.3 1.4 1.4 1.3 2 1 .8.5 1.4.5 1.8 0 .6.5 1.4.4 1.7 0 .8.7 1.7 0 1.5-1zm.5 3.4h-7c-1.3 1.2.3 1.8 1.7 1 .2.4 1 .6 1.6.3.6.4 1.4.1 1.8-.3.7.3 1.6.4 2-1zm-.2 4.5h-6.8c-.1 1.1 1.3 1 1.8.7.5.8 1.7.6 2.1.1.7.5 1.3.4 1.6 0 .7.6 1.4-.2 1.3-.8zm.4 4.4l-7.7-.1c-.4 1.3.8 1.5 1.3 1.2.2.7 1.2.5 1.5 0 .4.3.9.1 1.1-.2.1.7 1 .8 1.7.2 1.4 1 2.7-.2 2-1.1zm6.7-1.8h-6.3c.3 1.2.9 1.5 1.9.8.8.8 2 .5 2.3.1 1.4 1.1 2.1-.2 2.1-1zm-.6-4.4l-6.2-.2c.1 1.6 1.6 1.5 2.4.9.5.7 1.5.5 2 0 .7.8 2 .3 1.8-.7zm.8-4.9h-6.6c0 1.1 1.5 1.7 2.6.7.3 1.3 1.5.9 2 .4.8 1 2.5-.2 2-1zm-.4-3.3l-6 .1c0 1 1.4 1.4 1.9.6.3.5 1.3.4 1.6 0 .4.7 1 .2 1.2 0 .7.5 1.4.2 1.3-.7zm6.9 2.2l-7.2-.1c0 .7.7 1 1.2.7 0 .8 1 1 1.7.4.4.7 1.7.8 2.2 0 1 .9 2.2.2 2-1zm-.1 5.9h-7c0 1 1.1 1.3 1.8.8.1.8 1 .9 1.5.4.7.7 1.7.8 2.3 0 .8.3 1.5-.4 1.4-1.2zm-.4 5.3h-5.6c0 1 1.2 1 1.7.5.6.7 1.4.7 1.9.2.7.6 1.9.4 2-.7z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M381.3 664.4c-3 0-6.1 0-8.2-.2s-2.7-.6-4.2-1.5l-5.6-3.4c-.5-.2-1 .1-.3.5l5.6 3.7c1.5 1 2.5 1.9 3.4 3 1.2 1.3 2 1.3 2.6 1.1s1.4-.5 2.3-.3c.8.2 2 .3 2.6.2.5.5 1.8.4 2.5.2s1.2-.2 1.7-.1h1.7c.5 0 1.8-.3 2.7-.2 1 .2 1.9 0 2.5 0a5 5 0 0 1 2-.1c.6-.4.8-.9 1-1.4.6-.1.8-.2.9-.5l.6-1.6h.2v-.6l-.4-.6.2-1 .5-.2-.2-1-8.8.2a2 2 0 0 0-.6 1.1l-2.6.4c-.3.1-.6.1-.9.5l-1.2 1.8z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M391.8 660.5l1.3-4.9c.2-.5-.3-.6-.5 0l-1.3 4.9h.5z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M396.9 655c-1.1.5-1.7.8-2.2.6-.5-.2-1.1-.3-1.5-.1a.5.5 0 0 1 0 .1 493.3 493.3 0 0 1-1.1 3.8c.8.3 2.2.3 2.5 0 .4-.4 1.3-.3 1.8-.3.3-.4.4-.9.3-1.1s0-.7 0-1 .4-1.4.2-2z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M371.7 645.6a53.2 53.2 0 0 1-8 14m2 1.2a54.5 54.5 0 0 0 11.4-12.6m-7 4.3c-.3 2.7-1.1 7.5-1.5 10m2.6-4c-1 1-2.3 2.6-3.4 3.5m12.7-8.9c-.8.8-1.7 1.8-2.6 2m3.1-1.8a7 7 0 0 0 2.7 1.9m-3.2-6.2a8.5 8.5 0 0 1-3 1.7m3.4-1.6c.6.6 1.3 1.3 2.2 1.7m-5.4-4.9a7 7 0 0 0 2.7-1.5m.3 0c.7.7 2 1.4 2.7 1.6m-5.5-3.3a4 4 0 0 0 2.4-1.4m.3-.2c.7.6 2 1.4 2.7 1.5m3.2.8c-.4.5-1.5 1.3-2.2 1.3m2.7-1.3c.3.5 1.1 1.3 1.6 1.3m-4.8 6a7.2 7.2 0 0 0 2.8-1.9m.5.1a5.6 5.6 0 0 0 1.9 1.8m-4.1 5.2c.4 0 1.5-.6 1.8-1.3m.6-.3a7 7 0 0 0 2 1.7m-18.7.9c1.3-.4 3.8-2 5.1-3.5m-2.4 1.9c1 .7 2.3 1.5 3.2 1.7m-6.2-4.5a8 8 0 0 0 2.4-1.5m.5-.1c.3.4 2.4 1.7 3.3 1.7m-3.8-5.9a9.8 9.8 0 0 1-2.5 1.4m3-1.4c.7.5 2.2 1.4 3.1 1.4m-3.6-5.4c-.6.6-1.6 1.6-2.4 1.9m2.9-1.8c.4.7 1.6 1.7 2.4 1.8m8 2.6c1.9 3.3 5.3 7.4 8.7 9.6m-14.1-13.3c2.8 4 8.2 12.7 13.4 15.9m1-3.4a18.4 18.4 0 0 1-4.9 4.6m4.5-3.5c-1.7-2.8-2.6-6.3-4-11m-14 12.4l2 6m-2.4-6.1l1.9 6m-2.4-6.3l1.8 6.2m-2-6.1l1.4 6.1m0-.2h1.7m-.2-.6h-1.6m1.4-.5h-1.6m1.4-.5H374m1.3-.6H374m-.1-.5h1.3m-1.4-.4h1.3m-1.4-.5h1.2m-1.3-.4h1.1m-1.2-.5h1m-1.1-.4h1m-1.1-.3h1m-1-.4h.9m-2.6 0l-1.2 5m1.5-5l-1 5.2m1.3-5.4l-.8 5.5m1.2-5.6l-.6 5.8m.7-.4h-2m2-.5h-2.3m2.3-.6h-2.1m2-.5h-1.9m2-.5h-1.9m1.9-.6H371m1.7-.5H371m1.6-.5h-1.5m1.5-.5h-1.3m1.3-.5h-1.2m1.2-.3h-1.1m1 5.5v-5.9m6.5-2l-4 8.1m4.3-8.2l-3.4 8.3m3.6-8.4l-2.7 8.4m3-8.2l-2.2 8.2m.1-.3h-2.5m2.7-.8h-2.4m2.5-.6h-2m2.4-.6h-2m2.1-.6h-1.9m2.1-.6h-1.8m2-.7h-1.6m1.7-.5h-1.5m1.7-.6h-1.4m1.5-.4H378m1.4-.4H378m1.3-.4h-1m1-.3h-.9m1-.4h-.8m1-.4h-.8m.8-.3h-.7m3.4-.1l1.7 5.6m-1.4-5.5l2.1 5.4m-1.8-5.4l2.5 5.3m.6-.5l-2.8-4.9m2.8 5h-2m1.8-.8h-2m1.7-.6h-1.9m1.5-.7h-1.7m1.3-.6h-1.5m1.1-.7H383m1-.7h-1.2m.8-.6h-1m3.2.1L384 662m2.3-5.4l-1.6 5.3m.7-.1l1.2-5m.3.2l-1 4.7m-1.7-.3h1.7m-1.5-.6h1.7m-1.5-.7h1.6m-1.3-.6h1.5m-1.3-.7h1.4m-1.2-.6h1.3m-1-.7h1.2m-1-.6h1m.9.1l.8 3.6m-.5-3.8l1.1 3.7m-.7-3.7l1.2 3.7m-.7-3.5l1.3 3.5m-.1-.3h-1.7m1.5-.5h-1.6m1.4-.5h-1.5m1.3-.6H388m1.2-.5h-1.4m1.2-.5h-1.3m1.1-.5h-1.2"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#00b800"
      d="M479.6 380.3c3.6-2.3 9.8-1.9 13 .5 3.7-2.1 10.5-1.5 13.6 1.3 4.8-3.3 8.9-3.8 13.5-.6a12 12 0 0 1 13.6.2c4.2-2 8.8-3.6 12.9.7a10.7 10.7 0 0 0-13 .8c-4-4-11.1-2.5-13.5.3a8.8 8.8 0 0 0-13.3.2c-4.2-3.5-10.4-3.6-13.8-1a15 15 0 0 0-13-2.4z"
    />
    <path
      fill="#cf6200"
      d="M543.3 375.3c-18.5 3.2-59 1-67.8-1.3-3-.7-2.2-1.8.4-1.2 10.2 2.3 32 2.3 44 1.7 2.3-3 6-8.3 7.1-9.8s1.6-1.6 4-2l10-1.7v1.4c-.2.3-.5.7-.8.8 0 2.4.5 8.2 1 10.3l1.3-.3c.8-.2 1.6 1.9.8 2.1z"
    />
    <path
      fill="#cf6200"
      d="M573.7 376.2h2.5c.7 0 1.8-.6 2.2-1.7l2.5-7.3-1.9-2.8 1-6.1 2.4-1c.1-.4-.1-1.9-.6-2.3l-36.2 1.2c-1.1 0-1.6 0-2 1.4a27 27 0 0 0 9.2 26.6c.6.5 1.4 0 .4-.8a29.8 29.8 0 0 1-5-6.5l6-.1c.4 2 1.9 6 2.2 6.8s1 .8.6-.3c-.8-2.4-1.2-5.2-1.5-6.6h6l.5 6c0 .8.7.8.7-.1v-6l5.5-.2-.5 6c-.1 1 .4 1.4.6 0l.8-6 3.8-.2c-.1 1.3-1.3 5-1.6 6s.2 1 .6.1a35 35 0 0 0 1.8-6z"
    />
    <path d="M547.2 375.3c-.6-1.3-2.6-5.9-2.8-9.2l8-.1c.3 2.5 1 7.9 1.5 9.1l-6.7.2zm6.6-9.4c.2 2 1.2 8.5 1.4 9.2l6.4-.1-.4-9.3-7.4.2zm-9-8.1a38 38 0 0 0-.3 6.8l7.7-.2-.6-6.8-6.8.2zm8.3-.2c0 1.6.4 5.6.5 6.8l7.6-.2-.4-6.9-7.7.3zm9.2-.3l.3 6.9c1.8 0 5.4 0 6.5-.2.1-1.5.3-5.9.2-7l-7 .3zm8.3-.3l-.2 7 7.1-.3c.3-1.5 1-5.4 1-7l-7.9.3zm7.2 8.3l-7.5.2-.7 9.2 7.2-.2a61.6 61.6 0 0 0 2.6-7c-.5-1-1-1.4-1.6-2.2zm-15.2.4l.2 9.2 5.5-.2.7-9.2-6.4.2zm-31-1.8l-3 .5a224.8 224.8 0 0 1-7.2 10.1l10.6-.3-.3-10.3zm1.4-.3l.4 10.5 6.4-.5-1-11-5.8 1z" />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M377.3 657h-7.7v-.2l7.7.1zm6-6.2c.1 0 .1 0 0 0l-6-.1c-.1 0-.1 0 0 0h6zm-6.4 1.7c.1 0 .1.1 0 .1h-6.8c-.1 0 0-.1 0-.1h6.8zm.2-4.4c.1 0 .1.1 0 .1H370c-.1 0-.1-.1 0-.1h7.1zm-.5-3.5c.1 0 .1.1 0 .1h-6.9c-.1 0 0-.2 0-.2l7 .1z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M383.8 642.6l-6 .1 6-.1z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M384.1 646c.1 0 .1 0 0 0h-6.5c-.1 0-.1 0 0 0h6.5zm6.5 4.6v.1h-7c-.2 0-.2 0 0 0h7zm0-5.9c.2 0 .2.1 0 .1h-7.1c-.1 0-.1-.1 0-.1h7.2zm-6.6 10.4c.1 0 .1.1 0 .1h-6.4v-.1h6.4zm6.2.9c.1 0 .1 0 0 0h-5.6 5.6z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#ef072d"
      stroke="#000"
      strokeWidth={0.1}
      d="M395.3 657a3 3 0 0 0 0-1.4 1.1 1.1 0 0 1-.6 0 3 3 0 0 0-.3-.2c0 .4-.2 1.5-.4 1.9-.3 0-1 0-1.3-.2l-.3 1a3.5 3.5 0 0 0 1.5 0c0 .6-.1 1.1-.4 1.5.5 0 1 0 1.1-.3.3-.4.3-1 .4-1.3l.5-.1.5-.2.7-.1v-.6l.2-.4-1.6.5z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M370.5 623.2c-.8 0-2.6 0-3 .2-.3.2-.4.3.2.4s1.7.5 2.3.8c.6.4 1 1 1 2a6 6 0 0 0 3 6.3c.1.1.2.2.1.6l-.3 1.1c0 .2-.1.4.2.3a20 20 0 0 1-1 1.6c-1.6-.2-3 0-3 1.8 0 .2 0 .4.2 0 .3-.4.6-.8 1.3-1-.4.7-.6 1.3-.5 1.7 0 .3.2.5.4 0 .1-.4.5-.8.8-1.1.2-.1.2-.1.1.2s.1.9.3 1.1c.2.2.3.1.2-.2 0-.4 0-1.1.5-1.3.6-.4 1.2-.2 1.4.2.3.5.5 0 .2-.4s-.6-.9-1-.9l1-1.7c0-.2.2-.3.4-.2 0 .1.2.1.3-.2l.7-1.4.6-.2 1 1.5v.6c0 .4-.4 1.3-.5 1.6-1.2 0-1.8 0-2.2.7-.2.3.1.4.4.3a2 2 0 0 1 1-.3c.2 0 .3.2 0 .3-.7.3-1.2.8-1.2 1.5 0 .2.2.3.3 0 .3-.5.8-.9 1.3-1 0 .5.1 1.3.5 1.5.3.2.3 0 .2-.3-.2-.5 0-1 .3-1.3.5-.6 1.7.2 2 .4.2.2.4.3.2-.3-.1-.7-1.1-1-2-1.2l1.2-4.2c.5.3 1-.5 1.8-.2 1.4.6 3.5 1.9 3.8 2.2.4.3.5.2.7 0 .2-.1.5 0 .8 0 .2.1.4.2.1-.4a7.2 7.2 0 0 0-2.4-2.6c.8 0 1.8 0 1.8-.2s-1.2-.6-1.7-.6a3.3 3.3 0 0 0 1.6-.8c.2-.2 0-.3-.8-.3-2.1 0-3.2 0-4.3-.6-1.8-1-2.9-2.2-3.8-2.6-.4-.3-.7-.9-1-1.4-.5-1.5-.5-2.3-1.8-2.8s-3 .1-3.7.8z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M370.6 623.6h-1.7s-.2 0 0 0l1.5.4c.3 0 .2.3 0 .2s-.4 0-.2.2c1 .7 1.2 1 1 3.7l.5.4c.2 0 .1.2 0 .1s-.5 0-.2.2.5.2.2.2-.6.2 0 .1c.5 0 .8.2 0 .3-.6 0-.4.2 0 .2.7 0 .5.2.3.2s-.3.2.2.2h.7c.1 0 .2 0 0 .1-.2 0-.2.2.1.2s.5 0 .2.1c-.1 0-.3.1 0 .2.7 0 .8.2.6.3s-.3.1 0 .1.6.1.3.2c-.2 0-.3.2 0 .2s.5.2.3.3-.3.2 0 .2.4.1.2.2c-.2.2-.3.2-.5 0 0-.2-.2-.2-.2 0l-.2-.3c-.1-.3-.3-.3-.3 0s-.2.1-.4 0a3.3 3.3 0 0 0 4 .8c.1 0 .2 0 .3.3l.6 1.1c.1.2.3 0 .3-.2l.6-1.7c0-.3.4-.5.3.3.3-.2 1.5-.3 2.5 0a12.2 12.2 0 0 1 2.7 1.5.6.6 0 0 0 .5.1c.3 0 .4 0-.1-.5s-.3-.7 0-.5c.3.2.5.1.2-.2l-1-.9c-.1 0-.1-.2-.6-.2h-1.5c-.2 0-.4 0 .2.2.6.2 1.7 1 2 1.2s.4.6-.1.2-2.4-1.5-3.6-2c-2.7.3-4.9.6-6.5-1.1-.8-.9-.8-2.8.5-3.6-.2-.2-.2-.4-.1-.4v-.6c-.2-.1-.4-.3-.4-.5-.3 0-.5-.5-1-.3s-.6 0-.8-.1c-.1-.2-.2-.2-.5-.2s-.5 0-.5-.2.2-.2.6 0c.7.3 1.3.5 1.8-.2.4-.6-.2-1.1-1-1.3-.9-.2-1.5.5-1.9.8z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M375 623.3a2.8 2.8 0 0 0-1-.6c-.3 0-.3.2-.2.3v.6c.2.1.3.3 0 .3-.2.2 0 .9.3.7h.2s0 .3.2.3 0 .2 0 .3h.2c.2 0 .1.4-.1.5.3 0 .4 0 .4.2.1.2.4.3.4.6s0 .3-.4.2-.4 0-.5.2-.2.3 0 .3.4.1.1.2-.6 0-.7.3c0 .3 0 .4.2.3l.7-.4.5.1c.2.1 0 .5-.2.3s-.4 0-.5.1l-.5.2c-.2 0-.4 0-.3.5 0 1.4 1.1 2.4 3.1 2.4h3.3c-.6-.4-1-.6-1.3-.6h-.3c.1-.1 0-.3-.1-.3s-.3-.2-.5 0l-1 .5c-.2 0-.5 0-.2-.2l.9-.4c.2 0 .1-.2.1-.2s0-.3.3-.2c.6.4 1.5.9 1.8.9s.4-.2.2-.3-.3-.3-.3-.4.1-.2.5 0c.4.3 1 .5 1.3.6s.5.1 0-.2l-2.3-1.7c-.3-.3-.3 0-.2.2s-.3.3-.5.1-.3-.3 0-.4.2-.2-.1-.5c-.4-.3-.5-.3-.4 0 .1.3.1.5-.2.4s-.6-.3-.3-.4c.2-.2.5-.3 0-.6s-.2 0-.3.2-.4.2-.5 0-.3-.3-.2-.4.1-.2.3 0 .4 0 .1-.3-.4-.2-.3 0-.2.4-.6 0c-.2-.1-.2-.3 0-.4.2 0 .2-.1 0-.3-.7-1.2-.4-2.1-1.2-3z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#cf6200"
      d="M491.6 188.4c-.3.5-.4.4-1 .8-.6.5-.8 1.8.4 1.7.8-.2 1.3-.6 1.6-1a10 10 0 0 0-1-1.5zm-3.6-2.9c-.9.9-1 1.3-.6 1.3.6 0 .3 0 0 .7-.5.6.7.9 1.2.4s.5-.6.8 0c.1.5 1 0 1.4-.4-.8-.8-1.9-1.5-2.8-2zm-1.6 5c-1.2.6-.8 3.7 1 2.8.6-.3 1-.1 1 .3-.1.3-.1.5 0 .8a5.4 5.4 0 0 0 2-1.4c1-1.3 0-1.2-1.6-1.2s-2-.3-.5-1.2c1.4-.9.4-1.4-1.5-1.2.3.4.2.8-.4 1.1zm6.7 6.9c-.9-1-.3-1.4.6-1.9a1.2 1.2 0 0 0 .5-.4l-.8-3c-.4.2-1 1.3-1.2 1.8-.2.8-.4 1.2-1.2 1-.7-.2-1.4.6-1.5 1.4h.5c.3.1.4.6.3 1 2.1 0 2.5 1.4 2.9 2.4.4 1.1.8 1 1.1.3.3-.6-.4-1.7-1.2-2.6z"
    />
    <path
      fill="#ff0"
      d="M493.7 209.6c-.4.9-.4.8-1.7.8-1.2.1-2.8.3-3.5 1-.3.4-2.5.6-2.5 1.5 0 1 0 1.7 1 1.8.9 0 1 .2.7.9-.4.7-.6 1.8 1 2 1.6 0 2.8-.4 3.2.5.4 1 0 2.4.3 3s1.4.9 3.1 1.4c1.2.3 5.5.6 6.8.4 1.3-.2.8-1-.5-1-1.3-.2-2.3-.4-2.6-1.3-.3-1-.6-1.5.2-2.3.7-.9 1.4-1.5 1-2.9-.4-1.3-1.1-2.9-2.7-3.3-1.5-.5-1-2.6-2.6-2.8-.6 0-1 0-1.2.3z"
    />
    <path
      fill="#cf6200"
      d="M486.1 222.2c1.4.2 2.5.6 1.4.9-1 .3-1.7.9-.3 1 1.4.1 2.6.7 1.5 1s-1.2 1 .1 1 1.9.6 1 1.2c-1 .5-1.6.8-2.2-.1-.6-1-1-1.2-1.1-.5-.2.7-.6.2-1-.8s-1.4-1.4-1.1-.6-.8 1-1.8.6c1 1 2 2 3.3 2.7 1.4-.5 3 0 3.5 0 .6 0 2.4.5 3.4 1s1.7-.4 1.3-1.5c-.5-1-.5-.7-1 0-.6.5-.7-.3-.6-1.5 0-1-.7-.8-.9-.2s-.8-.4-.5-1 0-.9-.5-.7-.6 0-.7-1.2-.6-1-.7-.5-.7-.2-1.4-1.1c-.6-.8-1.3-.3-2.5.1l.8.2z"
    />
    <path
      fill="#ff0"
      d="M500.3 229.5c-6.4 2.5-11 1.4-14.4-.9 1.4-.5 3 0 3.6 0 .5 0 2.4.5 3.3 1s1.7-.4 1.3-1.5c.8 1.1 1.5 1.9 2.5 1.8 1 0 2.8-.2 3.7-.4zM486.7 200c-.4-1.3-.8-1.6-1.5-1.5-.7 0-1-.1-1.8-.4-.7-.3-1.7 0-1.9 1.5s-1 2-2.2 3c-1.1.8-1.8 1.5-1.8 2.9s-.3 1.7-1.1 2.8l-1.3 1.5 1.4.8c.9.4.6 1-.2.8s-1.7.2-.3.5 2 1 .7 1c-1.4-.2-3 1-.3.7 2.6-.3 3.6 1 .6 1-3.1 0-2 1-.3 1 2.9 0 2 .9 1.2.9-.7 0-1 1 .9.8l.7-1.1c.3-1 .6-3.7 1.7-4.4 1-.8 1.6-2 1.6-2.7s1.7-4.2 2.7-5 1.6-2.7 1.2-4z"
    />
    <path
      fill="#cf6200"
      d="M484.4 200.2c-1-.8-2.1-.3-2.1 1s-.8 1.8-1.7 2.3a4 4 0 0 0-2 2.7c0 1.1.2 1.8-.5 2.7-.8.8-.9 1.5-.4 2 .6.5.6.5.8 1.2.3.7 1.6 0 1.6-.8s.3-.8 1.1-1.3c.9-.4 2.3-2.7 2-3.3-.3-.6-1.1-1.2 0-2 1-.9 2-1 2-1.8 0-.9.3-1.2.6-1.5.3-.3-.7-.8-1.4-1.2z"
    />
    <path d="M484.4 199c-.7-.2-1.1 1.3-.1 1.5s1.1-1 .1-1.4zm-.1 2c-.8.1-1.7 1.1-.4 1s1.8-1.1.3-1zm-1.6 1.9c-.8.4-.6 1.5.6.7s1.4-1.7-.6-.7zm-1.2 1.6c-.8.4-.7 1.5.5.7 1.2-.7 1.5-1.7-.5-.7z" />
    <path d="M479.9 205.3c-.8.4-.3 1.4.8.7s1.1-1.7-.8-.7zm1 1c-.9.4-.4 1.4.8.7s1.1-1.7-.9-.7z" />
    <path d="M479.4 206.7c-.7.4-.2 1.4 1 .7s1-1.7-1-.7zm1 1.1c-.9.4-.4 1.4.8.7 1.2-.8 1.1-1.7-.9-.7z" />
    <path d="M479 208.5c-.8.4-.3 1.4.9.7s1-1.7-.9-.7z" />
    <path d="M479 209.5c-.7.4-.2 1.5 1 .7s1-1.7-1-.7z" />
    <path
      fill="#cf6200"
      d="M478.5 219.3c-.8.1-1.4 1.3-.4 1.5s1.3.3 1.3 1 .3 2 1.4 2c1 .1 2-1.1 1-1.5-.9-.4-1.7-.7-1.8-1.6 0-.8-1-1.4-1.5-1.4z"
    />
    <path
      fill="#ff0"
      d="M507 212.6l.6.6c.8.6 2.2 0 2-.5s-1-2.3 1-.9l10.6 7.4c2.2 1.6.8 1.8-.2 1.3s-4-1.7-5.7-2.7c-1.7-1-2-.6-2.2-.3-.2.3 0 1 .6 1.6-1 .1-2.7 0-3.2-1.2-.6-1.3-2-3-3-4.2-.4-.5-.5-.8-.4-1z"
    />
    <path
      fill="#00d860"
      d="M564.9 403.6c-1.4 1-3.4 2.8-2.1 5.2l.5-.2a142.4 142.4 0 0 0 14.7-21.7l.1-.7a20.5 20.5 0 0 1-5.2 3.1c.7 1.9-2.6 4.3-4.3 5 .7 1.2.5 3-1 3.3.3 1-.9 1-2.3 1.6s-2 1-2.5 1.8c.7-.5 1.8-.8 2.3-.6s.7 1-.3 1.3-1.7.8-2.1 1.2c1.5-.5 3.7-.3 2.2.7z"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M376 628.4c-.4-.3-.5-.1-.4 0s0 .4-.3.5h-1c-.2 0-.5.4 0 .3l1.6-.3c.2 0 .4-.2 0-.5zm.7.6c-.3-.3-.4-.2-.3 0s-.1.3-.3.3l-1.4.4c-.4 0-.4.3.1.3s1.5-.5 1.6-.5.2-.3.3-.2.3 0 0-.3zm.3.8l-1 .5c-.3 0-.5.3 0 .3s1-.5 1.2-.6l.4-.2s.4-.1 0-.4-.8 0-.6.1 0 .3 0 .3z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path d="M482 187.5c-2.8-1.9-6 2-2.9 4.2 2.8 1.9 5.7-2.4 3-4.2z" />
    <path
      fill="#fff"
      d="M478.5 189.2h.8c-.1 1 .8 2.3 2 2-1 .8-3-.2-2.8-2zm11 42.5c.9.3 3.9.6 5 .6l-1.4 2.5c-.3.8-.4.9-.5-.3 0-1.2-.7-2-1.3-.7l-1.2 2.2c-.3.5-.8.7-.6-.6s.1-2.6 0-3.7z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M399.7 640.8c0 16.3-2.6 33.9-23.8 42.3-21.1-8.4-23.7-26-23.8-42.3h47.6zm0 0c0-6.2-.3-12.2-.2-17.4a63.6 63.6 0 0 0-23.6-4.3c-5.3 0-15.7.8-23.6 4.3.2 5.2-.2 11.2-.2 17.4h47.6z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
  </svg>
	),
	AD: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#d0103a" d="M0 0h640v480H0z" />
    <path fill="#fedf00" d="M0 0h435.2v480H0z" />
    <path fill="#0018a8" d="M0 0h204.8v480H0z" />
    <path
      fill="#c7b37f"
      d="M300.4 136.6c7.7 0 10.9 6.6 18.6 6.6 4.7 0 7.5-1.5 11.7-3.9 2.9-1.6 4.7-2.5 8-2.5 3.4 0 5.5 1 7.3 4 1 1.6 1.8 4.9 1.3 6.7a40 40 0 0 1-2.7 8.3c-.7 1.6-1.3 2.5-1.3 4.2 0 4.1 5.6 5.5 9.4 5.6.8 0 7.7 0 12-4.2-2.3-.1-4.9-2-4.9-4.3 0-2.6 1.8-4.3 4.3-5.1.5-.1 1.3.3 1.7 0 .7-.3.4-1 1-1.4 1.2-1 2-1.6 3.6-1.6 1 0 1.6.1 2.5.7.4.4.6.8 1 .8 1.2 0 1.8-.8 3-.8a5 5 0 0 1 2.3.6c.6.3.6 1.5 1.4 1.5.4 0 2.4-.9 3.5-.9 2.2 0 3.4.8 4.8 2.5.4.5.6 1.4 1 1.4a6.2 6.2 0 0 1 4.8 3c.3.4.7 1.4 1.1 1.5.6.3 1 .2 1.7.7a6 6 0 0 1 2.8 4.8c0 .7-.3 1.6-.5 2.2-1.8 6.5-6.3 8.6-10.8 14.3-2 2.4-3.5 4.3-3.5 7.4 0 .7 1 2.1 1.3 2.7-.2-1.4.5-3.2 2-3.3a4 4 0 0 1 4 3.6 4.5 4.5 0 0 1-.3 1.8 9.6 9.6 0 0 1 4-1.4h1.9c3.3 0 7 1.9 9.3 3.8a21 21 0 0 1 7.3 16.8c-.8 5.2-.3 14.8-13.8 18.6 2.5 1 4.2 3 4.2 5.2a4.5 4.5 0 0 1-4.4 4.7 4.4 4.4 0 0 1-3.5-1.4c-2.8 2.8-3.3 5.7-3.3 9.7 0 2.4.4 3.8 1.4 6 1 2.2 1.8 3.5 3.7 5.1 1-1.5 2.1-2.6 4-2.6 1.7 0 3.2.6 3.9 2.2.2.5 0 .9.3 1.4.3.6.8.7 1.1 1.3.5 1 0 1.8.5 2.7.3.7.9.8 1.2 1.4.4 1 .5 1.6.5 2.7 0 3-2.7 5.2-5.7 5.2-1 0-1.4-.4-2.3-.3 1.7 1.7 3 2.5 4.3 4.5a17.7 17.7 0 0 1 3 10.3 22 22 0 0 1-2.8 11.2 20 20 0 0 1-7 8.5 35 35 0 0 1-16 6.4 74.4 74.4 0 0 1-11 1.4l-14.1.8c-7.2.4-12.2 1.5-17.3 6.6 2.4 1.7 4 3.5 4 6.4 0 3-1.8 5.3-4.7 6.2-.7.2-1.2 0-1.9.4s-.7 1.3-1.4 1.7a6.2 6.2 0 0 1-3.8 1 8 8 0 0 1-6.4-2.5c-2.2 1.8-3 3.4-5.5 4.9-.8.4-1.2 1-2.1 1-1.5 0-2.2-1-3.4-1.8a23 23 0 0 1-4.4-4c-2.3 1.3-3.6 2.4-6.3 2.4a7 7 0 0 1-4-1c-.6-.5-.8-1.2-1.5-1.6-.7-.5-1.3-.3-2.1-.7-3-1.3-5-3.5-5-6.8 0-2.9 1.8-4.7 4.4-6-5-5-10-5.8-17-6.2l-14-.8c-4.4-.3-6.8-.7-11-1.4-3.3-.5-5.2-.7-8.2-2.1-10.2-4.8-16.8-11.3-18-22.5-.2-1-.2-1.5-.2-2.5 0-5.8 2.3-9.4 6.4-13.5-1-.3-1.7 0-2.8-.3-2.5-1-4.4-2.7-4.4-5.5 0-1 0-1.7.5-2.6.4-.6 1-.7 1.2-1.4.2-1 0-1.6.4-2.5.3-.5.8-.6 1-1.2 1-1.9 2-3.4 4.1-3.4 1.8 0 3 1 3.8 2.5 1.8-.8 2.2-2.1 3.2-3.7a15.5 15.5 0 0 0 1.4-13.3c-.4-1.5-.6-2.5-1.8-3.7-1 1-2 1.4-3.4 1.4-2.9 0-5-2.5-5-5.3a4.8 4.8 0 0 1 3-4.6c-1.6-1.4-3-1.5-4.7-2.6-2.6-1.6-3.5-3.4-5.2-6-1.2-1.6-1.5-2.8-2-4.7a19 19 0 0 1-1-7.8c.6-5 1.5-8 4.6-11.9 1.8-2.3 3-3.7 5.8-4.9 2.3-1 3.7-1.7 6.2-1.7l2 .1a6.9 6.9 0 0 1 2.8.8c.4.2 1.1.9 1.1.4s-.3-.8-.3-1.3c0-2 1.5-4 3.6-4 1.5 0 2.1 1.4 2.9 2.7.4-.8.7-1.4.7-2.3 0-3.4-1.9-5.2-4-7.9-4.7-5.8-10.5-8.5-10.5-16 0-2.2 1-3.7 3-4.9.5-.3 1.3 0 1.8-.3s.4-1 .7-1.4c.5-.7 1-1 1.6-1.6 1-1 2-.6 3.1-1.5.6-.4.8-1 1.2-1.4 1.3-1.6 2.5-2.4 4.6-2.4 1 0 1.6 0 2.5.4l1 .5c.3-.2.8-.8 1.5-1.1a4 4 0 0 1 2.2-.6c1.1 0 1.8.6 3 .6.3 0 .4-.4.8-.6 1-.7 1.5-1 2.7-1 1.2 0 1.8.3 2.8 1 1 .5 1 1.3 2 1.8.5.3 1 .2 1.5.4 2.6.9 4.5 2.6 4.5 5.3 0 1.5-.3 2.5-1.4 3.5-.9.7-1.7.6-2.8 1a16 16 0 0 0 11.3 3.5c4.2 0 9.3-1.7 9.3-5.9 0-2-1-3-1.8-4.8a18.8 18.8 0 0 1-2.1-8.5c0-2.8.3-4.5 1.9-6.7 1.6-2.3 3.6-2.9 6.5-2.9z"
    />
    <g fill="none" stroke="#703d29">
      <path
        strokeLinejoin="round"
        strokeWidth={0.7}
        d="M272.4 159a3.6 3.6 0 0 0 2.4 2.4c.8.3 2.7.2 3.8-1.4 1-1.2 1-2.8.6-4a4.7 4.7 0 0 0-1.7-2.2l-5.1 5.2z"
      />
      <path
        strokeLinecap="round"
        strokeWidth={0.7}
        d="M401 236.1c-1.2-2.9-4.3-1.6-4.4 0-.5 3.7 2.7 4.8 5 4.2a4 4 0 0 0 2.5-2c.6-1 .8-2.4.4-3.7a4.9 4.9 0 0 0-.8-1.6 5 5 0 0 0-1.3-1.2c-.9-.6-1.9-.6-3.4-.6-5.5 0-10.4 6.5-12 13.4-.6 2.2-1.3 7.3-.3 12a22.4 22.4 0 0 0 5.9 11.3 25.7 25.7 0 0 0 9.9 5.8 7.9 7.9 0 0 0 4 .1c3.2-.7 4.7-3.8 3-7-1.3-2.5-5.3-4-7.2-.6-.1.3-.4.9-.4 1.5 0 .9.4 2 1 2.4 1.5.9 3.8.6 3.7-2"
      />
      <path
        strokeWidth={0.8}
        d="M383.8 274a11.3 11.3 0 0 1 6.6-3.7c3-.4 5.6.5 8.2 2a18.5 18.5 0 0 1 10.8 17c0 3.6-1 7.5-2 9.4-.8 1.7-3 9-15.3 14-7.1 3-18 3.6-25.7 4-10.4.3-20 .7-25.5 7.6"
      />
      <g strokeWidth={0.7}>
        <path d="M386.4 285.7c-.3-1 0-2.1.8-3.3 1.2-1.6 3.7-2.1 6-1a7.4 7.4 0 0 1 2.5 2.2l1.1 1.6c.7 1.1 1 2 1 2.5 2.5 7-1.4 14.5-6.5 17.6-4 2.4-8.7 3.4-14.4 4-2.5.4-4 .3-6.5.5h-9.6a70.1 70.1 0 0 0-7.2 0c-2.9.3-5 .4-7.6.8-1.6.2-3.4.5-5.4 1-.6 0-1.2.2-1.8.4l-1.2.3c-3.6 1.1-7 2.4-9.8 4.2-.8.5-1.8 1-2.5 1.7l-1.3 1.2c-2 2-3.9 4-4.4 6.7v1.6c0 1.8 1.4 4.3 5.4 5m5.5-170c.8 1.4 1.3 2.3.8 3.9-.6 1.7-1.8 2.8-3.6 2.8-4 0-6.3-4.8-4.5-7.8 3.2-5.3 9.3-2.3 15 .3-.3-1.3-.8-1.8-.7-3.5.1-4.2 3.2-6 4.5-10 .7-2.3 1-4.3-.7-6-1.5-1.3-3.2-1.3-5.1-.6-3.8 1.5-8.5 5.9-16.6 6-8.2-.1-12.8-4.5-16.7-6-2-.7-3.6-.7-5.1.7-1.7 1.6-1.4 3.6-.7 6 1.3 3.8 4.4 5.7 4.5 10 0 1.6-.4 2-.7 3.4 5.7-2.6 12-5.9 15-.3 1.7 3.2-.5 7.7-4.5 7.7-1.8 0-3-1-3.6-2.7-.4-1.5 0-2.8.8-4" />
        <path
          strokeLinecap="round"
          d="M314.6 159.9a5.3 5.3 0 0 1 2.4 5c-.2 2.5-.8 3.1-2.8 4.5m2.4-3.8c-.1 1.5-.7 2.5-2.3 3.1"
        />
      </g>
      <path
        fill="#c7b37f"
        d="M276.7 153.3l.7.5.8.8.5 1 .2.8v1.9l-.2.8-.5.6-.6.6-.9.5-1 .2-1 .2-1-.5-.9-.6-.5-.8-.4-1v-.4l4.8-4.6z"
        stroke="none"
      />
      <path
        strokeLinecap="round"
        strokeWidth={0.7}
        d="M275.2 157.2c-.3-1.7-2.2-2-3-1-1.1 1.5-.3 4 2 4.7a4 4 0 0 0 3.9-1.4c1-1.3.9-2.8.5-4a4.5 4.5 0 0 0-1.7-2.2c-2.7-2-7.1-1.6-8.6 2-1.8 4.4 2.2 7.8 6 10.3 4.6 3.2 10 3.8 14 3.8 9.2-.1 16.2-4.5 20.7-7 1-.6 2.1-.5 2.7.2a2 2 0 0 1-.3 2.7"
      />
      <path
        strokeWidth={0.7}
        d="M248 281.2l-2 .7-2 1.6-1 1.3-1.1 2-.5 1.5-.4 1.8-.2 1.4m19-10.1l-.1 1.8-.3 1.2-1 2.2-1.3 1.8-1.5 1.2-1.1.5-1.6.4"
      />
      <path strokeWidth={0.8} d="M319.7 329.1c-.3 1.7-1.9 3.6-5.3 4.2l-.6.2" />
      <path
        strokeWidth={0.9}
        d="M404.2 276.2a18.3 18.3 0 0 1 5.6 13.5c0 3.6-1 7.5-2 9.4-.8 1.7-3 9-15.3 14a85 85 0 0 1-25.6 4c-10.3.3-19.8.7-25.4 7.3"
      />
      <path
        strokeWidth={0.6}
        d="M387.5 282.9c.8-1 3.5-2.4 5.8-1.1a6.2 6.2 0 0 1 2.3 2"
      />
      <path
        strokeWidth={0.9}
        d="M401.6 273.8l1.4.5a7 7 0 0 0 4 0c2.8-.8 4.6-3.4 3.2-6.9a6 6 0 0 0-1.8-2.1"
      />
      <path
        strokeLinecap="round"
        strokeWidth={0.7}
        d="M240.3 199.8c-2 1.1-3.3 1.4-4.8 3.1a28.1 28.1 0 0 0-2.6 6.8m46-51.7c0 1.8-1.2 2.8-3 3.2"
      />
      <path
        strokeWidth={0.6}
        d="M397.1 192a19 19 0 0 1 18.6 19.8c0 16-9.9 18.5-13.8 19.6"
      />
      <path
        strokeWidth={0.7}
        d="M398.4 192c8.1-.3 16.5 5.7 16.9 20.7.3 11.7-8 17-12 18"
      />
      <path
        strokeWidth={0.6}
        d="M393.8 248.4l.1-1.6.6-2.5.7-2 .9-1.6 1-1.3m7.8-3.4v1.5l-.5 1-.7 1.1-.8.6-1.2.5h-1.1l-.8-.1m-14.3-52.8l.3-1.7.8-1.6 1-1.5 1.6-2.2 1.4-1.4 2-2.2 2-1.9 1.1-1.3 1.5-1.9 1.4-2 .8-1.7.5-2.2.1-2.7-.2-.8m-12.3 128.2l1.6-.4 1.2-.6.7-.7.5-.8.3-1.2v-.9m-158.2-12.1h2.7l1.6-.6m5-36.5l-.2 1.4-.4.6-.4.6-.7.5-.7.3-1 .1h-.6m9.9-15.5l-.3 2.1-.5 1-.8 1.2-1.2.9-1.2.6-2.3.5m15.3-39.7l-.5 1.3-.5 1-.8 1-1 1-1.2.5-1.1.3-.6-.1m.3-6.2v1"
      />
      <g strokeWidth={0.6}>
        <path
          strokeLinecap="round"
          d="M254.3 224a6.9 6.9 0 0 1-2.1 1.4m150.5 44.8l.5.2c1.4.8 4.2-.2 3.4-2.4"
        />
        <path d="M397.8 239.6c1 1.3 2.9 1.7 4.4 1.3a4 4 0 0 0 2.5-2c.6-1 .8-2.4.4-3.7a4.9 4.9 0 0 0-.9-1.6 6.8 6.8 0 0 0-1.3-1.5l-.4-.2m6.4 34a4 4 0 0 0 .1-.7 4 4 0 0 0-1.3-3l-.8-.8m.4.5c0-1.8-1.5-3.2-3.4-3.5m-4.2 2.8l-1.3-1a15.7 15.7 0 0 1-4.3-10.7c0-4.2 1.6-8.4 3.6-10M341.2 324l1.8-1.6 1.2-1 2.3-1.4 2.2-1 1.6-.5 3-.6 3.6-.6m-29.5 19.4a17 17 0 0 1-7.6 6.1 17.7 17.7 0 0 1-7.6-6.1" />
        <path strokeLinecap="round" d="M314.4 332.6a10 10 0 0 1-2.2 4.2" />
        <path d="M314.7 330.5l-.4 2.2M312 337l-1 1-1.7.9-2 .6m-5.6-177.8c.3-.8.5-1.4.5-2.6-.1-4.2-3.2-6.1-4.5-10-.7-2.3-1-4.3.7-6 1.4-1.4 3.2-1.4 5-.6 4 1.5 8.6 5.8 16.7 6-8.1-.2-12.8-4.5-16.6-6-2-.8-3.8-1-5.3.5-1.7 1.6-1.2 3.8-.5 6.1 1.3 3.9 4.2 5.8 4.3 10 0 1.2-.3 1.8-.5 2.6M320 148c8-.4 14.9-5.8 17.1-6.3 2-.4 3-.2 4.5 1.1-1.4-1.3-3-1.2-5-.5-3.8 1.5-8.4 5.8-16.6 6m79.6 112.9a15.5 15.5 0 0 1-6.2-12.4c0-4.1 1.7-8.4 3.6-10m-70 97.6c-1.3 2-4.3 5-7.6 6.2a17.7 17.7 0 0 1-7.6-6.2" />
        <path
          strokeLinecap="round"
          d="M306.7 163.7l2.3-1.3c1-.6 2.3-.5 2.9.2.6.7.7 2-.2 2.8"
        />
        <path d="M294.7 169.3c5.5-1.2 10-3.6 13.4-5.5M340.3 328c.5.3.8 1 .8 1 .1.2.3.5.3.8.3 1.5-.7 2.4-2 2.6-1.7.2-3-.8-3.5-2M294.4 169c5.5-1.1 10-3.6 13.4-5.5m97.6 106.9c-1 .4-1.6.3-3-.2l-1.8-1a20.7 20.7 0 0 1-8.4-9 18.8 18.8 0 0 1-1.7-4.6 12 12 0 0 1-.5-3.3 25.6 25.6 0 0 1 4.7-15.3c1.1-1.6 2.1-2.5 4.2-2.6m-143.7-39.3a7.1 7.1 0 0 1 2.7 5.7c0 3.1-2.6 8.2-9 10a8.3 8.3 0 0 1-6.3-.8" />
        <path d="M256.3 205.6c1.1.8 1.6 1.7 1.6 3.3 0 1-.7 2.4-1.9 3.7a12.4 12.4 0 0 1-8.8 4c-2 0-4-.4-6-1.7a9 9 0 0 1-3.8-5.4" />
        <path d="M256.2 212.3c1.3 1.2 1.7 2.7 1.7 4.6 0 2.7-1.1 4.8-3.7 7-.6.6-1.2 1-2 1.5m129.5-22.1v3.5m-.3-4.4v5m.3-15.8v6.6m-.3-8v8.9m-1.9 82a18.7 18.7 0 0 1-4.2 5.6 19.6 19.6 0 0 1-5.8 4.1 24.6 24.6 0 0 1-6.6 2.2 33 33 0 0 1-6.8.9c-2.5 0-3.9 0-6.4-.2-2.6-.2-4-.6-6.7-.8-2.2-.2-3.4-.4-5.6-.3a28.3 28.3 0 0 0-11 1.8c-2.6 1-5.7 3-6.3 3.8a22 22 0 0 0-6.4-3.8 22 22 0 0 0-5.1-1.4c-2.3-.4-3.5-.4-5.8-.4-2.2 0-3.4.1-5.6.3-2.6.3-4 .6-6.7.8-2.5.2-3.9.3-6.4.2a33 33 0 0 1-13.4-3 19.5 19.5 0 0 1-6.4-4.8m42.1 53.4l1.8-.2m30.3-2.4l1.8-.1 1.7-.7 1.2-.8 1.7-2 .3-.6.3-1.7v-.8m47-136.7c.7-2.6-.2-5.4-2.8-5.3m-132 46.5a8.2 8.2 0 0 1-3.5 4.7m3.6-46.7a6.5 6.5 0 0 1-3.6 4c-1.9.8-4 0-5.2-.8" />
        <path
          strokeLinecap="round"
          d="M243.8 202.4c1.5.8 3.1-.4 2.8-2.4a2.9 2.9 0 0 0-2.5-2.2"
        />
        <path d="M250.2 286.6c.3.3.4.7.8.8.7.2 1.2.4 1.9-.5.8-1.1.3-2.8-.5-3.9a5 5 0 0 0-5.8-1c-.8.5-1.7 1-2.6 2.2l-1.1 1.6c-.7 1.1-1 2-1.1 2.4-2 5.9.4 12 4.1 15.7" />
        <path
          strokeLinecap="round"
          d="M340.2 327.8l.7.8.2.9c.3 1.5-.7 2.4-2 2.6-1.6.2-2.8-.8-3.3-2"
        />
        <path d="M389.4 154.8a7.4 7.4 0 0 1 6.3 7c0 4.4-1.5 6-3.8 9.2-2.5 3.4-10.7 9.6-10.7 16.7 0 4.3 1.2 7 4.3 8.4 2 1 4.3 0 5.4-1 2.6-2.4 1.5-6.5-1.2-7-3.2-.6-3.9 4.6-.7 4.3m17.9 69a3.7 3.7 0 0 0-3.6-3 3.7 3.7 0 0 0-3.7 3.7c0 1 .4 2 1 2.6" />
        <path d="M383.9 195.1a7.1 7.1 0 0 0-2.7 5.7c0 3.1 2.6 8.2 9 10 2.4.7 4.8.6 6.2-.3m-156-10.3a9.4 9.4 0 0 0-4.8 3.5 16.9 16.9 0 0 0-2.2 12.7 15.8 15.8 0 0 0 2.3 5.6 8 8 0 0 0 1 1.2l1.2 1m64 92c4.9 2.1 8.4 3.7 11.4 8.5a10 10 0 0 1 1.2 4.9c0 2.7-1 5.7-3.3 7.6a8.3 8.3 0 0 1-6.7 2c-1.9-.2-3.7-1.6-4-2.6M254 224.1c2.7 2.2 3.9 4.2 3.9 7.5a8.4 8.4 0 0 1-4 7.5" />
        <path
          strokeLinecap="round"
          d="M251.5 236.4c4 5.1 6.3 8.1 6.4 14.1.1 5.7-1.7 9.6-5 13.7"
        />
        <path d="M329.8 169.3a4.1 4.1 0 0 0 1.5-2.2c.5-1.5.5-2.8-.2-4 1 1.4 1 2.5.7 4-.1 1-.8 1.5-1.6 2.3m51.5 86.1v16.2l-.1 2.5a34.4 34.4 0 0 1-.3 1.7" />
        <path d="M381.4 254v19.9l-.5 2.6m.5-43v14.6m.3-13.4v11.8m0-26.8v8.8m-.3-9.9v11m.3-19v3.5m-.3-4.2v5m-1.8 65.2l-.4.7a18.7 18.7 0 0 1-4.1 5.7 19.6 19.6 0 0 1-5.9 4 24.6 24.6 0 0 1-6.5 2.2c-2.7.6-4.2.8-6.9.9-2.5 0-3.9 0-6.3-.2-2.7-.2-4.1-.5-6.8-.8-2.2-.2-3.4-.3-5.6-.3-2.2 0-3.5 0-5.7.4a22 22 0 0 0-5.2 1.4c-2.7 1.1-5.7 3-6.4 3.8-.6-.8-3.7-2.7-6.3-3.8a22 22 0 0 0-5.2-1.4c-2.2-.4-3.5-.4-5.8-.4-2.2 0-3.4.1-5.6.3-2.6.3-4 .6-6.7.8-2.5.2-3.9.3-6.3.2a33 33 0 0 1-13.5-3 19.5 19.5 0 0 1-5.8-4.1 22 22 0 0 1-2.5-2.8m-2-3.2a10.1 10.1 0 0 1-2.3 7.7c-.8.9-2.6 2.6-5 2.6-3.7 0-4.8-2.5-5-3.2" />
        <path d="M255.6 278.9c.7.7 1.3 1.5 1.9 2.5 1 1.8.6 4.8-.1 6.2a4.4 4.4 0 0 1-.3.4m-20.3 18c2.3 2.4 5.7 5 10.9 7.1 7.1 3 18.1 3.6 25.7 4 10 .3 19.3.7 25 7m17.3-4a12 12 0 0 1 4 5.5m-7.3 11.5a8.2 8.2 0 0 1-.7.7 8.3 8.3 0 0 1-6.6 2c-2-.2-3.8-1.6-4.3-2.6m-5.4-2.9l.3.4a7.6 7.6 0 0 0 5.1 2.4m27 0a18 18 0 0 1-7.7 6.1 17.7 17.7 0 0 1-7.6-6.1l-.3-.5m15.6.4l.7.7a8.3 8.3 0 0 0 6.7 2 5.5 5.5 0 0 0 4-2.5l.5-.7" />
        <path d="M339 336.6l-.7 1.2-1.1 1-1.7.7h-1.6" />
        <path d="M343 325.3a7.7 7.7 0 0 1 2.4 2.9c.3.7.4 1.5.5 2.3a5.8 5.8 0 0 1-1.5 4.2 7.5 7.5 0 0 1-5.4 2.4 5.5 5.5 0 0 1-.4 0m.2-.2a6.8 6.8 0 0 1-5.2-2.2m63.7-67.9a23.8 23.8 0 0 1-4.8-6.4 18.8 18.8 0 0 1-1.7-4.5 12 12 0 0 1-.5-3.3 26 26 0 0 1 4.6-15.3c.7-.8 1.4-1.8 2.1-2.2m-1.3-75.9c2.5.2 4.8 3 4.8 5.7 0 3.8-1.3 5.5-4.4 9.3-2.6 3.2-10.6 9-10.3 14.5 0 1 .5 2 1.1 2.8m-3.2 3.5a7 7 0 0 0 2 1.4 5 5 0 0 0 4.3-.3M369 153a6 6 0 0 1 2.2 2.6c1.8 4.5-2.2 7.9-6 10.4a21.3 21.3 0 0 1-8.3 3.3" />
        <path d="M364.6 161.6a4.2 4.2 0 0 1-3.1-1.5 3.4 3.4 0 0 1-.7-1m-15 4.9a4.6 4.6 0 0 1-1.2-1c-1-1-1.5-2.3-.8-4.4.6-1.9 3.7-7.2 3.8-10.9.2-5.6-2-9-5.3-10.2" />
        <path
          strokeLinecap="round"
          d="M347.3 146.5l-.1 2-.6 2.2-1 3-1 1.9-.8 1.9-.4 1.3-.2 1 .1.9m38 126.3l.6.8c.7 1 3.2 3 5.5 3 3.7 0 4.6-2.6 4.7-3.2.5-2.9-.5-3.6-2-4.5 0 0-.8-.4-1.9-.2"
        />
        <path d="M237 274.4a6.9 6.9 0 0 1-3.7 0c-2.9-.9-5.2-3.6-4-7m13.4-31.8c.3.3.4.7.4 1 .4 3.8-2.8 4.8-5 4.2a5.6 5.6 0 0 1-3-2.3 4.7 4.7 0 0 1-.7-2.3m22-23.6c.6.5 1 1 1.3 1.7m-1.1-8.5c.5.4.9.9 1.1 1.3" />
        <path
          strokeLinecap="round"
          d="M257.9 210.5a8.5 8.5 0 0 1-1.6 2.4 12.4 12.4 0 0 1-8.8 4c-2 0-4-.4-6-1.7a9.5 9.5 0 0 1-4-5.6"
        />
        <path d="M255.4 195.3a7.8 7.8 0 0 1 2.4 3.4" />
        <path
          strokeLinecap="round"
          d="M257.8 203.2c-.9 3-3.5 6.6-8.6 7.9-2.4.6-5.6-.2-6.6-1"
        />
        <path d="M240 202.6c.3 2.6 2 4.6 5.4 4.6 4.7.1 7.6-6.7 3.4-11.5" />
        <path
          strokeLinecap="round"
          d="M229.4 225.5c.7.9 1.5 1.7 2.4 2.4a16.8 16.8 0 0 0 6 3.3m5.2.5c4.2-.5 6.6-3.7 6-7.3-.3-2.8-2.8-5-4.6-5.1"
        />
        <path d="M249.8 188.1c1.9 0 3 1.6 2.9 3" />
        <path
          strokeLinecap="round"
          d="M249.4 163a11.5 11.5 0 0 0 5 5.9m144.2 31c1.7 2.3.6 7-4 7a5.2 5.2 0 0 1-4.5-2.5"
        />
        <path d="M381.7 169.1V185" />
        <path
          strokeLinecap="round"
          d="M243.8 202.3c1.4 1 3.3-.7 2.5-2.6-.5-1.2-2.2-2.6-4.7-.9-2.8 1.9-2 7.8 3.2 7.9 4.7 0 7.6-6.8 3.4-11.6-4-4.6-11.3-3.6-16 .2A21.4 21.4 0 0 0 225 207a22.5 22.5 0 0 0 0 9.2 20.9 20.9 0 0 0 3 7.5l1.3 1.7c.8.8 1 1.2 2 2a15 15 0 0 0 10.4 3.7c4.6-.2 7.3-3.4 6.8-7.3-.4-3.8-4.2-5.7-6.7-3.9-1.7 1.2-2.3 4.9.7 5.8 1.6.5 3.1-1.7 2-3M374 150.9c2.7-1.4 4.8-1.2 6.3 1a9.9 9.9 0 0 1 1.6 7.2 9.2 9.2 0 0 1-3.5 5.8"
        />
        <path
          strokeLinecap="round"
          d="M380.5 152c3.1-2 6.5-1.1 8.3 1.6 1.3 2 1.7 3.6 1.6 6.1a11.2 11.2 0 0 1-5.7 9.2"
        />
        <path d="M395 159.2c2.6.2 4.6 2.5 4.6 5.1 0 3.8-1 5.5-4 9.3-2.7 3.3-10.6 9-10.4 14.6 0 2.1 1.8 4 3.3 4.2" />
        <path
          strokeLinecap="round"
          d="M395.4 202.3c-1.5 1-3.3-.6-2.5-2.4.5-1.2 2.2-2.8 4.7-1.1 2.7 1.9 2 7.8-3.3 7.9-4.7 0-8-6.6-3.4-11.6 4-4.6 11.7-3.7 16.5.1 2 1.6 6.1 6 7 12 1 7 .9 15.6-6.4 21-3 2.1-7 3.1-10.6 3-4.6-.2-7.3-3.5-6.8-7.4.5-3.8 4-5.4 6.7-3.9 2.8 1.5 2.3 5.4-.7 5.8-1.7.2-3.1-1.7-2-3"
        />
        <path d="M392.9 199.9c.8-3.5 3.7-3.8 6.2-3.8 6.5.1 11.1 8 11.2 15.5 0 9.5-4 15.2-11 15.5-1.9 0-5-.8-5-3" />
        <path
          strokeLinecap="square"
          d="M397 198.3c6.9 1.6 9.3 7.8 9.3 13.8 0 4.9-.5 11.6-10 13.9"
        />
        <path d="M408.4 265.3a3.9 3.9 0 1 0-6.3 2.4" />
        <path
          strokeLinecap="round"
          d="M394.4 259.4c1.4 2 3 4.1 6.3 6m-1.3 10.5c-3.2-2.2-9.5-5-15-2.2a7.6 7.6 0 0 0-4.4 4.4 10 10 0 0 0 1.8 9.5c.9 1 2.7 2.6 5 2.7 3.8 0 4.7-2.6 4.8-3.2.4-2.8-1.2-3.9-2-4.1-.7-.3-2.8-.2-3.2 1.3-.2.5-.2 1.3.2 2"
        />
        <path
          strokeLinecap="round"
          d="M340.5 328.4c1 2.2-.2 3.2-1.6 3.4-2.2.3-3.3-1.4-3.4-3a4.4 4.4 0 0 1 4.3-4.7c2.3 0 4.1 1.5 5 3.5.3.7.5 1.5.5 2.4a5.8 5.8 0 0 1-1.4 4.1 7.5 7.5 0 0 1-5.4 2.5c-4.2.1-7.5-3.8-7.5-7.8 0-7.7 11.4-12 16-13a84 84 0 0 1 17.9-2.4c3.5-.1 6.2 0 10.1-.5 3.5-.3 5.4-.5 9-1.3a27.2 27.2 0 0 0 12.6-6.4c2.9-2.7 4.5-4.5 5.9-8.2a17 17 0 0 0-1.3-13.9 14.3 14.3 0 0 0-10.3-6.8c-3.7-.5-7 1.1-9 4.8-1 1.8-.6 4.8.1 6.2a6 6 0 0 0 4.8 3c3.8 0 4.7-2.6 4.8-3.2.4-2.8-1.2-3.9-2-4.2-.7-.2-2.8-.1-3.2 1.4-.2.5-.2 1.3.2 2"
        />
        <path
          strokeLinecap="round"
          d="M337.2 316.2c-4.8 2.1-8.4 3.7-11.4 8.5a9.9 9.9 0 0 0-1.2 4.9c0 2.7 1.1 5.7 3.3 7.6a8.3 8.3 0 0 0 6.7 2c2-.2 3.7-1.6 4-2.6"
        />
        <path d="M385.1 224.1c-2.3.8-3.9 4.2-3.9 7.5a8.4 8.4 0 0 0 4 7.5" />
        <path
          strokeLinecap="round"
          d="M387.6 236.4c-4 5.1-6.3 8.1-6.4 14.1 0 5.7 1.7 9.6 5.1 13.7"
        />
        <path d="M365.9 152l.3-.5c1.7-2.4 4.7-3.1 6.9-1.5 2.6 2 3.3 5.4 2.6 9-.5 2.2-2 4.1-4 5.5" />
        <path
          strokeLinecap="round"
          d="M265.1 150.8c-2.6-1.2-4.7-1-6.3 1a8.7 8.7 0 0 0-1.6 7.2c.6 2.7 1.4 3.8 3.5 5.8"
        />
        <path d="M258.6 152a5.8 5.8 0 0 0-8.3 1.6 9.1 9.1 0 0 0-1.6 6.1c.2 4.2 2.8 7.6 5.8 9.2" />
        <path d="M249.7 154.8a6.8 6.8 0 0 0-6 6.6c0 4.5 1 6.3 3.5 9.6 2.5 3.4 10.7 9.6 10.7 16.7 0 4.3-1.2 7-4.3 8.4-2 1-4.3 0-5.4-1-2.6-2.4-1.5-6.5 1.2-7 3.3-.6 3.9 4.6.7 4.3" />
        <path d="M244 159.2c-2.5.2-5 2.3-5 5 0 3.8 1.5 5.6 4.6 9.4 2.6 3.3 10.1 9 9.9 14.5 0 2-1.5 4.6-2.9 4.3" />
        <path
          strokeLinecap="round"
          d="M238 236.1c1.3-2.9 4.4-1.6 4.6 0 .4 3.7-2.8 4.8-5.1 4.2a4 4 0 0 1-2.5-2 4.8 4.8 0 0 1-.4-3.7 4.9 4.9 0 0 1 .9-1.6 5 5 0 0 1 1.2-1.2c1-.6 1.9-.6 3.4-.6 5.5 0 10.4 6.5 12 13.4.6 2.2 1.3 7.3.3 12a22.4 22.4 0 0 1-5.8 11.3 25.8 25.8 0 0 1-10 5.8 7 7 0 0 1-3.9.1c-2.8-.9-4.6-3.5-3.2-7 1.2-2.6 5.4-4 7.3-.6.2.3.4.9.4 1.5 0 .9-.4 2-1 2.4-1.4.9-3.7.6-3.6-2"
        />
        <path d="M233.8 270.4c1 .4 1.6.3 2.9-.2l1.8-1c2.6-1.5 5.6-3.8 8.4-9.1a18.8 18.8 0 0 0 1.7-4.5c.3-1 .5-2.2.6-3.3a25.6 25.6 0 0 0-4.8-15.3c-1.1-1.6-2-2.5-4.2-2.6m-9.5 31a3.9 3.9 0 1 1 6.3 2.3" />
        <path d="M232.2 261.4a3.7 3.7 0 0 1 3.7-3 3.7 3.7 0 0 1 3.6 3.7 3.8 3.8 0 0 1-1 2.6" />
        <path d="M239.4 261.3a15.5 15.5 0 0 0 6.2-12.4c0-4.1-1.6-8.4-3.6-10" />
        <path strokeLinecap="round" d="M244.7 259.4a16.5 16.5 0 0 1-6.3 6" />
        <path d="M254.6 273.7c-1-2.2-2.8-3.2-5.8-3.5-3-.3-5.5.5-8.2 1.9a18.6 18.6 0 0 0-10.8 17 25 25 0 0 0 2 9.5c.9 1.6 3 9 15.3 14a86.1 86.1 0 0 0 25.7 3.9c10.4.4 20 .8 25.6 7.6" />
        <path
          strokeLinecap="round"
          d="M239.7 275.9c3.3-2.2 9.5-5 15.1-2.2a8 8 0 0 1 4.3 4.4 10 10 0 0 1-1.8 9.5c-.9 1-2.7 2.6-5 2.7-3.8 0-4.7-2.6-4.8-3.2-.4-2.8 1.2-3.9 2-4.2.7-.2 2.8-.1 3.2 1.4.2.5.2 1.3-.2 2"
        />
        <path d="M252.7 285.7c.3-1 .2-2.2-.8-3.3a5.1 5.1 0 0 0-6-1c-.7.5-1.6 1-2.4 2.2-.4.4-1 1.1-1.2 1.6-.7 1.1-1 2-1 2.5-2.5 7 1.5 14.4 6.5 17.6 4.4 2.8 8.8 3.6 14.4 4 2.5.3 4 .3 6.5.5h9.6a70.1 70.1 0 0 1 7.2 0c3 .3 5.1.4 7.6.8 1.6.2 3.5.5 5.4 1 .6 0 1.2.2 1.8.4l1.2.3c3.6 1.1 7 2.4 9.8 4.2.8.5 1.8 1 2.5 1.7l1.3 1.2c2 2 4 4 4.4 6.7v1.6c0 1.8-1.4 4.3-5.3 5" />
        <path d="M298.6 328.4c-1 2.2.2 3.2 1.6 3.4 2.2.3 3.3-1.4 3.5-3a4.4 4.4 0 0 0-4.4-4.7 5.5 5.5 0 0 0-5 3.5 6.9 6.9 0 0 0-.5 2.4 5.8 5.8 0 0 0 1.4 4.1 7.5 7.5 0 0 0 5.4 2.5c4.2.1 7.5-3.8 7.5-7.8 0-7.7-11.4-12-16-13a84 84 0 0 0-17.9-2.4c-3.5-.1-6.2 0-10.1-.5-3.5-.3-5.4-.5-9-1.3a27.2 27.2 0 0 1-12.5-6.4 17 17 0 0 1-4.7-22 14.3 14.3 0 0 1 10.3-6.9c3.8-.5 7 1.1 9 4.8 1 1.8.6 4.8-.1 6.2a6 6 0 0 1-4.8 3c-3.8 0-4.7-2.6-4.8-3.2-.4-2.8 1.2-3.9 2-4.2.7-.2 2.8-.1 3.2 1.4.2.5.2 1.3-.2 2" />
        <path
          strokeLinecap="round"
          d="M273.3 152l-.4-.5c-1.7-2.4-4.7-3.1-6.9-1.5-2.6 2-3.3 5.4-2.5 9a9 9 0 0 0 4 5.5"
        />
        <path d="M366.8 159.6c-4 4.4-8.1 5.8-14.1 6-2 0-5.5-.6-7.6-2.1-1.3-1-2.8-2.6-1.9-5.5.6-1.9 3.7-7.2 3.8-10.9.3-5.6-1.9-8.7-5.3-9.9-6.2-2.2-13 4-17 5.4-2.1.7-3.2.8-5.1.8-2 0-3-.1-5.2-.8-4-1.4-10.7-7.6-17-5.4-3.4 1.2-5.5 4.3-5.3 10 .1 3.6 3.2 9 3.8 10.8 1 2.9-.5 4.5-1.9 5.5-2 1.5-5.7 2.1-7.5 2-6-.1-10.1-1.5-14.1-5.9" />
        <path
          strokeLinecap="round"
          d="M297.3 314.4c.8.3.2-.2 5.3 2a22 22 0 0 1 11.3 8.9 10.5 10.5 0 0 1 .9 7.3"
        />
        <path d="M297.7 336a8 8 0 0 0 3.2.9c4.2.1 7.5-3.8 7.5-7.8 0-2.8-1.5-5.2-3.6-7" />
        <path
          strokeLinecap="round"
          d="M298.6 328.4c-1 2.3.4 3.5 1.8 3.7 2.2.2 3.4-1.4 3.6-3a4.5 4.5 0 0 0-2.2-4.2"
        />
        <path d="M390.1 154.8c3.2 0 6 3.6 6 7.2 0 4.3-2.2 6.9-3.9 8.8-1.3 1.6-2.7 3-4.4 4.7" />
        <path
          strokeLinecap="round"
          d="M386.3 151.4a9 9 0 0 1 2.8 2.4c1.3 2 1.7 3.7 1.6 6.2-.2 4.2-3.2 7.1-6 9m-4.7-17.6l.6.7c1.9 2.2 2 5.4 1.6 7.2a8.2 8.2 0 0 1-3.8 5.4m-5-14.4c2.6 2 3.4 5.4 2.5 9-.6 2.5-2.2 4-4.2 5.2m11.1 41.1c.3 1 .9 1.3 1.5 2a13.5 13.5 0 0 0 6.2 3.5c2.4.7 4.6.2 6.3-.9m-163 54c1.2 0 2.5.9 3.3 2.3.1.2.4.8.4 1.5 0 .9-.4 1.8-1 2.2-1.5 1-4 .5-4-2"
        />
        <path d="M241.5 231.3c5 1 9.7 6.9 11.2 13.3.6 2.3 1.3 7.3.3 12a22.4 22.4 0 0 1-6 11.4 16.5 16.5 0 0 1-2.1 1.9l-1 .7m-8-12.1c2 0 3.8 1.9 3.8 4a3.8 3.8 0 0 1-1 2.6" />
        <path d="M234.6 260.7c2.1 0 4.1 2 4.1 4.2a3.9 3.9 0 0 1-1.4 3" />
        <path
          strokeLinecap="round"
          d="M254 239.5a18 18 0 0 1 3.8 7.7m0 8.5a17.3 17.3 0 0 1-1.5 4 17.8 17.8 0 0 1-3.6 4.7"
        />
        <path d="M254.3 224.3c1.8 1.5 3 3 3.5 4.8" />
        <path
          strokeLinecap="round"
          d="M257.9 219.5a10 10 0 0 1-3.4 4.6m-9.2-17.2l2.2-.6 1.3-1 .8-1.1.7-1.8.3-1.5"
        />
        <path d="M241 199.3c-.7.2-1.6.4-2.5.8a9 9 0 0 0-3.5 3 17 17 0 0 0-2.2 12.7 15.8 15.8 0 0 0 2.3 5.6l1 1.4c1.4 1.3 2.6 2 4.6 1.7" />
        <path strokeLinecap="round" d="M253 189.8c-.3 1.3-1 2.9-3 2.7" />
        <path d="M245.7 198.5c-2-1.9-6-2.4-10.1.2L234 200a8.8 8.8 0 0 0-1.4 1.6 17.5 17.5 0 0 0-2.4 5c-.7 3-.7 5.6-.6 6.3 0 1 .2 1.9.3 2.7.6 2.8 1.4 4.8 2.3 6.2.9 1.5 3 5 7.7 5.4 1.8.1 4.8-.7 5-3" />
        <path
          strokeLinecap="round"
          d="M363.8 157c.3-1.6 2.3-1.9 3-1 1.2 1.6.4 4.2-2 4.9a4 4 0 0 1-3.8-1.4c-1-1.3-.9-2.8-.5-4 .2-.8.9-1.5 1.7-2.2 2.7-2 7.1-1.6 8.6 2 1.8 4.4-2.2 7.8-6 10.3-4.6 3.2-10 3.8-14 3.7-9.2 0-16.1-4.4-20.7-7-1-.5-2.1-.4-2.7.3a2 2 0 0 0 .3 2.7"
        />
        <path
          strokeLinecap="round"
          d="M365.6 155.5c1 0 1.2.4 1.5.8 1.2 1.5.3 4.1-2 4.9m17.8 51.5c-3.5 3.8-.2 10.3 2.4 11.8.9.7 1.3.3 2 .7"
        />
        <path d="M383.1 205.4c-1.1.8-1.5 1.7-1.6 3.3a5.3 5.3 0 0 0 1.4 4 14 14 0 0 0 9.3 3.7c2 0 4-.4 6-1.7a9 9 0 0 0 3.8-5.4m-20.8 61.8l-.2 2.5a18.9 18.9 0 0 1-2 7 18.7 18.7 0 0 1-4.2 5.6 19.6 19.6 0 0 1-5.9 4 24.6 24.6 0 0 1-6.5 2.3 43.8 43.8 0 0 1-13.2.6c-2.7-.2-4.1-.5-6.8-.8-2.2-.1-3.4-.3-5.6-.3a28.3 28.3 0 0 0-10.9 1.9c-2.7 1-5.7 3-6.4 3.8-.6-.9-3.7-2.8-6.3-3.8a22 22 0 0 0-5.2-1.5c-2.2-.4-3.5-.4-5.8-.4-2.2 0-3.4.2-5.6.4-2.6.2-4 .6-6.7.7-2.5.2-3.9.3-6.3.2a33 33 0 0 1-7-.8 24.6 24.6 0 0 1-6.5-2.2 19.6 19.6 0 0 1-5.8-4.1 18.7 18.7 0 0 1-4.2-5.7 19 19 0 0 1-2-6.9c-.2-1-.2-2.5-.2-2.5V169.3h123.2v101.8z" />
      </g>
      <g fill="#c7b37f" stroke="#c7b37f">
        <path
          strokeWidth={0.3}
          d="M248 285.6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zM232.5 268c0-1.3.8-2.3 1.8-2.3s1.7 1 1.7 2.3c0 1.2-.8 2.2-1.7 2.2-1 0-1.8-1-1.8-2.2z"
        />
        <path
          d="M241.3 223.6c0-1 .8-1.8 1.7-1.8 1 0 1.7.8 1.7 1.8s-.7 1.8-1.7 1.8-1.7-.8-1.7-1.8zM272 158c0-1 .5-2 1.4-2 .9-.1 1.7.6 1.8 1.6 0 1-.5 2-1.4 2-.9.1-1.6-.6-1.8-1.6z"
          stroke="none"
        />
      </g>
      <g stroke="#c7b37f" strokeLinecap="round" strokeWidth={0.6}>
        <path d="M239.3 234c-.4.1-.6.2-.8.5-.3.3-.4.4-.6.9l-.2 1.2m4.7 26.7l1-1 .6-1 .5-1 .7-1.3m-1.3 14l-1.5.7-1.1.6a17.4 17.4 0 0 0-1.3.8l-1.2 1m15-37.9l-.8-.8-1-.8-.9-.8" />
        <path strokeLinecap="butt" d="M254.2 225l-1.2.5a5.1 5.1 0 0 1-1.5.3" />
        <path d="M237.4 208.4c.2.6.2 1 .5 1.5.2.7.5 1.1.9 1.7a8.3 8.3 0 0 0 2.6 2.7l1.5.8m-1-5.8l1.3.6a7.4 7.4 0 0 0 3 .6l1.8-.1m7.2-40.7l-2-1.2c-.9-.5-1.3-.9-2-1.5a9.3 9.3 0 0 1-1.1-1.3l-.8-1.3m7.5-4.6l.6 1.7a7.8 7.8 0 0 0 1.4 2c1 1 1.7 1.3 2.8 2.2m1.4-6c.3.7.3 1 .7 1.6.2.5.4.8.8 1.2l1.3 1.3c.7.6 1.2.7 2 1.1" />
      </g>
      <path
        fill="#703d29"
        strokeWidth={0.2}
        d="M333.3 151.6c0-1.7-1.7-1.8-2.4-1.8-1.8 0-2.3 1.1-4.6 2.3a11.9 11.9 0 0 1-6.7 2 12 12 0 0 1-6.7-2c-2.3-1.2-2.7-2.3-4.6-2.3a2.3 2.3 0 0 0-2.2 2.4v.9l.3.2c0-.8.1-1.2.5-1.7a2.2 2.2 0 0 1 1.6-.8c1.8 0 2.5 1.2 4.8 2.4 3 1.6 4.2 1.9 6.7 2a12 12 0 0 0 6.8-2c2.3-1.2 3-2.5 4.8-2.5.6 0 1 .4 1.3 1v.9l.2.1c0-.3.2-.4.2-1z"
      />
    </g>
    <g fill="#703d29">
      <path d="M264.4 294c.5-.5.9-.3 1-.6 0-.2 0-.2-.3-.3l-.9-.2-.8-.4c-.1 0-.4-.2-.5 0-.1.4 1 .4.6 1.4a3.7 3.7 0 0 1-.8 1.2l-2.6 3-.2.1v-4.3l.1-1.8c.2-.4.8 0 .9-.4 0-.1 0-.2-.3-.3-.2 0-.5 0-1.1-.3l-1-.5c-.2 0-.5-.2-.6 0l.1.3c.4.2.5.4.5 1v7.4c0 .5.1.6.2.7.1 0 .2 0 .4-.3l5.3-5.7z" />
      <path d="M267.5 295.2c.3-1.1 1-.4 1-.8.1-.2 0-.2-.2-.3l-1.3-.4c-.4 0-.8-.3-1.2-.4 0 0-.3-.1-.4 0-.1.5 1.1.5.8 1.5l-1.7 5.5c-.3 1-1 .6-1.1 1v.1l1.2.4 1.6.5h.3c.2-.4-1.2-.3-.7-1.7l1.7-5.4zm3.7 1c.2-.6.5-.5.9-.4 1 .3 1.4 1.3 1 2.5-.2.6-.4 1.2-2 .8-.3-.1-.7-.2-.6-.5l.7-2.3zm-2.8 5c-.5 1.4-1.2.8-1.3 1.2 0 .2.2.2.3.3l1.6.4.8.3h.4c.1-.5-1-.3-.7-1.5l.6-2c.1-.4.1-.5.6-.3.6.1.7.3.8.8l.3 2c.2.9.3 1.7 1 2 .5 0 1.2 0 1.4-.4l-.2-.2h-.3s-.3 0-.3-.3l-.7-3.6c0-.2.4-.2.8-.3a2 2 0 0 0 1-1.3c.1-.5.4-2.2-1.8-2.9l-2.1-.5-1.2-.4h-.3c-.1.5 1.1.4.7 1.7l-1.5 5zm8.4 2.5c-.4 1.4-1.4.5-1.5 1 0 .2.1.3.3.3l1.5.3 1.4.4c.3 0 .5.2.6-.1 0-.3-1.3-.3-1-1.8l1.3-5.2c0-.6.2-.6.6-.5l1 .2c1.1.3.5 1.5 1 1.6.2 0 .2-.4.2-.6l.1-1v-.4l-3.3-.7-3.2-.8c-.1 0-.2 0-.2.2l-.5 1.5c-.1.1-.2.4 0 .4.5.1.5-1.5 1.7-1.2l.9.2c.4.1.5.2.4.8l-1.3 5.4zm12.7-3.3c.4-.6.8-.5.9-.7 0-.2-.2-.2-.4-.3h-.9l-.9-.3c-.1 0-.4-.1-.4.1-.1.4 1 .2.8 1.3 0 .2-.1.6-.6 1.3l-2 3.3-.3.2v-.2l-.7-4a5.4 5.4 0 0 1-.1-1.8c0-.5.7-.2.7-.5 0-.2 0-.2-.4-.3l-1.1-.1c-.4 0-.7-.2-1-.3-.2 0-.5-.1-.6.1l.1.2c.5.2.6.4.7.9l1.3 7.3c.1.5.2.7.3.7.1 0 .2 0 .4-.3l4.2-6.6zm.6 6.8c0 .3 0 .3.2.5.6.2 1 .6 1.7.7 1.4.2 2.6-.7 2.8-2.2.3-1.5-.3-2.1-1.4-2.9-1.3-.9-1.8-1.1-1.7-2 .1-.7.7-1 1.4-1 1.8.3 1.6 2.6 1.8 2.6.3 0 .3-.1.3-.4l.2-1.6v-.4h-.6c-.4 0-.7-.5-1.6-.7-1.2-.2-2.3.7-2.5 2-.2 1.2.4 1.8 1.2 2.4 1.6 1.1 2.2 1.4 2 2.4-.1 1-.9 1.4-1.7 1.3-1.2-.2-1.6-1.4-1.8-2.6 0-.2 0-.3-.2-.3s-.2.3-.2.5v1.7zm15.8-4.5c.3-.7.8-.6.8-.9 0-.2-.1-.1-.4-.2h-.9l-.9-.1c-.1 0-.4 0-.4.2 0 .4 1 0 1 1.1 0 .2-.1.6-.5 1.4l-1.8 3.5-.1.3-.1-.3-1.1-4a5.4 5.4 0 0 1-.3-1.6c0-.5.7-.3.7-.6 0-.2 0-.2-.4-.2h-1.2l-1-.2c-.2 0-.5-.1-.6.1l.2.2c.4.2.6.3.7.8l2.1 7.1.4.7c.1 0 .2 0 .3-.4l3.5-7z" />
      <path d="M307.6 308.5c0 1.2-1 1-1 1.5 0 .2.1.1.3.1h2.2l.4-.1c0-.6-1.4.2-1.4-2v-4.2l.1-.1.2.1 5.1 6.3.3.1.2-.3v-6.7c0-1.3 1-1 1-1.3 0 0 0-.2-.3-.2h-2.3c-.2 0-.2.1-.2.2 0 .4 1.3.2 1.3 1.3v4l-.1.4-.4-.3-4.2-5.3c-.2-.3-.1-.3-.4-.3h-1.8l-.2.1c0 .6 1.2-.2 1.2 2.1v4.6zM318 303c0-1.1.8-.7.8-1.1 0-.1 0-.2-.4-.2h-2.6s-.3 0-.3.2c0 .4 1.1 0 1.1 1.2v5.7c0 1.1-.8.8-.8 1.2 0 0 0 .2.2.2h2.8c.2 0 .3 0 .3-.2 0-.4-1.2.2-1.2-1.3l.1-5.7zm4.5 5.5c0 1.5-1.2 1-1.2 1.4 0 .2.2.2.4.2h3c.3 0 .5 0 .5-.3s-1.4 0-1.4-1.4V303c0-.6 0-.6.5-.6h1c1.2-.1.8 1.2 1.3 1.2.2 0 .1-.4.1-.6l-.1-1c0-.2 0-.4-.2-.4l-3.3.1h-3.3l-.2.3-.1 1.6.1.4c.5 0 .2-1.6 1.4-1.6h.9c.4 0 .5 0 .6.6v5.6zm6.3-2.2h-.4l.1-.5.7-2.2v-.2l.2.1 1 2.1.2.4c0 .2-.2.2-.4.2h-1.4zm1.8.5c.3 0 .3 0 .8 1l.2.8c0 .7-.7.6-.7 1 0 .1.2.1.4 0h1.2l1.3-.1c.3 0 .4 0 .4-.2 0-.4-.6 0-1-.7l-3.4-7-.3-.4c-.2 0-.2.2-.3.4L327 309c-.2.7-.8.7-.7 1h2.3c.2-.1.5 0 .5-.3s-1.2 0-1.3-.9l.2-1c.2-.8.4-.8.6-.8l2.1-.2zm8.3-5c-.1-.8 0-.8 1.2-1 2-.2 1.4 1.3 2 1.2.2 0 0-.4 0-.6l-.1-1.1c0-.1-.1-.2-.3-.2-1 0-1.7.2-2.4.3l-2.8.4c-.2 0-.3 0-.3.2.1.5 1.3 0 1.4 1l.7 5.5c.2 1.5-.7 1-.6 1.5 0 0 0 .1.2 0l1.4-.1 1.2-.1c.3 0 .5 0 .5-.3s-1.2.1-1.4-1.2l-.2-1.7c-.1-.7-.1-.9.3-1h.8c1.1-.2 1 1.1 1.3 1 .3 0 .2-.4.1-.5l-.3-2.1c0-.3-.2-.3-.2-.3-.3 0-.1 1.1-1 1.2l-.7.1c-.5.1-.5 0-.6-.5l-.2-1.7zm4 2.8c.4 2.3 2.1 3.7 4.2 3.3 3.4-.7 3.5-3.6 3.2-5.3-.5-2.5-2.3-3.7-4.4-3.3-2.5.5-3.5 2.7-3 5.3zm1.1-1c-.3-1.6 0-3.4 1.7-3.7 1.4-.3 3 .8 3.4 3.4.3 2 0 3.6-1.8 4-1.9.4-3-2-3.3-3.6zm8.3-4.1c-.1-.7.2-.8.6-.9 1-.2 1.8.5 2.1 1.6.2.7.3 1.4-1.3 1.8-.3 0-.7.1-.8-.2l-.5-2.3zm0 5.7c.4 1.4-.5 1.3-.5 1.6.1.3.3.2.4.1.6 0 1-.3 1.6-.4l1-.2c.2 0 .2-.1.2-.2 0-.4-1 .3-1.3-1l-.5-2c0-.4-.2-.4.4-.5.5-.2.7-.1 1.1.3l1.3 1.6c.5.6 1 1.3 1.8 1.1.5-.1 1-.5 1-.9l-.2-.1-.3.1s-.3.1-.4 0l-2.4-2.9.5-.6c.2-.4.4-.9.2-1.6-.1-.5-.7-2.1-3-1.6l-2.1.6-1.2.2c-.2 0-.3.1-.2.2 0 .5 1.1-.2 1.4 1l1.2 5.2zm8.7-2c.3 1.4-1 1.2-.9 1.6 0 .3.3.2.5.2l1.4-.5 1.5-.3c.3 0 .5 0 .4-.4 0-.3-1.3.4-1.7-1l-1.3-5.3c-.2-.5 0-.6.3-.7l1-.2c1.1-.4 1.1 1 1.5.9.3 0 0-.5 0-.7l-.4-1s0-.3-.2-.2l-3.2.9-3.2.7v.3l.1 1.6c0 .2 0 .4.3.4.5-.1-.3-1.6 1-1.9l.8-.2c.4-.1.6 0 .7.5l1.4 5.3zm5.5-7.3c-.3-1 .6-.9.4-1.3h-.3l-1.4.4-1.2.3s-.3 0-.3.2c.1.4 1.2-.2 1.5.8l1.6 5.6c.2 1-.6 1-.5 1.3 0 .1 0 .2.2.1l1.1-.3 1.6-.4c.3 0 .3-.1.3-.3-.1-.3-1.1.5-1.5-.9l-1.5-5.5zm2.3 2.7c.7 2.3 2.6 3.4 4.7 2.7 3.2-1.1 3-4.1 2.4-5.7-.8-2.4-2.8-3.3-4.8-2.7-2.4.9-3.2 3.2-2.3 5.7zm1-1c-.6-1.7-.6-3.5 1.1-4 1.3-.5 3 .4 3.9 2.9.6 1.8.5 3.6-1.2 4.2-1.8.6-3.2-1.5-3.8-3.2zm7.6-5.5c-.2-.7 0-.8.4-1 1-.3 2 .3 2.4 1.4.2.6.4 1.3-1.1 1.9-.3 0-.7.2-.8 0l-.9-2.3zm.8 5.6c.6 1.4-.4 1.4-.2 1.7 0 .3.2.1.4.1l1.5-.7.9-.2c.2-.1.2-.2.2-.3-.2-.4-1 .4-1.4-.8l-.8-1.9c-.2-.4-.2-.5.3-.7.5-.2.7-.1 1.1.3l1.6 1.4c.5.5 1.1 1.1 2 .8.3-.2.9-.7.7-1l-.2-.1-.2.2h-.5l-2.8-2.5.4-.7a2 2 0 0 0 0-1.6c-.1-.6-1-2-3.1-1.2l-2 .9-1.2.4-.2.2c.2.4 1.1-.4 1.6.8l2 5z" />
    </g>
    <g fill="#fedf00" transform="matrix(.64 0 0 .64 0 16)">
      <path fill="#d52b1e" d="M412.7 249.3h82.1v82h-82.1z" />
      <path
        id="prefix__a"
        fill="#fff"
        d="M451.2 313.8s0 3-.8 5.3c-1 2.7-1 2.7-1.9 4a13.2 13.2 0 0 1-3.8 4c-2 1.2-4 1.8-6 1.6-5.4-.4-8-6.4-9.2-11.2-1.3-5.1-5-8-7.5-6-1.4 1-1.4 2.8-.3 4.6a9 9 0 0 0 4.1 2.8l-2.9 3.7s-6.3-.8-7.5-7.4c-.5-2.5.7-7.1 4.9-8.5 5.3-1.8 8.6 2 10.3 5.2 2.2 4.4 3.2 12.4 9.4 11.2 3.4-.7 5-5.6 5-7.9l2.4-2.6 3.7 1.2h.1z"
      />
      <use
        width="100%"
        height="100%"
        transform="matrix(-1 0 0 1 907.5 0)"
        xlinkHref="#prefix__a"
      />
      <path d="M461.1 279l10.8-11.7s1.6-1.3 1.6-3.4l-2.2.4-.5-1.2-.1-1.1 3-.7V260l.3-1.3-3.2.2.3-1.4.5-1 1.9-.4h1.9c1.8-3.4 9.2-6.4 14.4-1 3.8 4 3 11.2-2 13.2a6.3 6.3 0 0 1-6.8-1.1l2-4c2.7 1.7 5-.3 4.8-2.4-.2-2.7-2-4.3-4.3-4.5-2.3-.2-4 1-5 3-.6 1.3-.3 2.2-.5 3.6-.2 1.5 0 2.3-.5 3.8a8.8 8.8 0 0 1-2.4 3.6l-11 12-43 46.4-3.2-3 43.2-46.7z" />
      <path
        fill="#fff"
        d="M429.5 283s2.7 13.4 11.9 33.5c4.7-1.7 7.4-2.8 12.4-2.8 4.9 0 7.6 1 12.3 2.8A171 171 0 0 0 478 283l-24.2-31-24.4 31z"
      />
      <path d="M456.1 262.4l16.8 21.7s-2.2 10.5-9 26.3c-2.7-.6-5-1.1-7.8-1.3v-46.7zm-4.7 0l-16.8 21.7s2.2 10.5 9 26.3c2.7-.6 5-1.1 7.8-1.3v-46.7z" />
    </g>
    <g fill="#d52b1e">
      <path fill="#fedf00" d="M322.3 175.5h52.6V228h-52.6z" />
      <path d="M329.7 175.5h7.8V228h-7.8zm15 0h7.8V228h-7.8zm15 0h7.9V228h-7.9z" />
    </g>
    <g fill="#d52b1e" stroke="#d52b1e" strokeWidth={0.5}>
      <path
        fill="#fedf00"
        d="M264.3 273.5c.1 1 .5 2.6 1.4 4.3 1 1.5.6 1.4 2.7 3.8a15.3 15.3 0 0 0 4 2.9 32.7 32.7 0 0 0 15 2.6c2.7-.1 4.8-.4 6.6-.7a71 71 0 0 1 11-.6c1.5 0 3 .3 4.7.6 3.5.7 7 2 7 2v-54.7h-52.6V271l.2 2.4z"
        stroke="none"
      />
      <path
        strokeWidth={0.3}
        d="M270.4 283.1l2.5 1.5 3.4 1.2v-52.2h-5.9zm29.2 2.4v-51.9h-5.8v52.8l5.8-.7zm11.7-51.9h-5.8v52.1c1.9.2 3.8.6 5.8 1v-53zm-23.4 0V287s-3.8.2-5.8 0v-53.4z"
      />
    </g>
    <g transform="matrix(.64 0 0 .64 0 16)">
      <path
        fill="#fedf00"
        d="M585.5 402.4a20.8 20.8 0 0 1-2.2 6.6c-1.5 2.3-1 2.3-4.3 6a26.3 26.3 0 0 1-13 7 51.8 51.8 0 0 1-16.6 1.6c-4.3-.2-7.5-.7-10.3-1-3.8-.6-6.7-.9-11-1a62.9 62.9 0 0 0-6.2 0 83.3 83.3 0 0 0-18.3 4.2V340h82.2v58.5l-.3 3.8z"
      />
      <g id="prefix__b">
        <path
          fill="#d52b1e"
          d="M524.6 347l-.6.2-.8.8c-.4.4-.7.5-1.2.8l-.6.5c-.3.3 0 .6-.3 1-.1.4-.3.6-.6 1-.4.4-.7.5-1 1l-1.2 1-.3.1h-.6c-.4.2-.5.6-.8.8l.3.6.8 1.4c.2.3.2.7.5.8.5.2.9.2 1.3.1.8.2 1.3.2 2 .5l1.5.8c.5.3.8.4 1.3.5h1.8v.3l2 1a1.7 1.7 0 0 0-.1.4c-.1.3-.2.7-.1.8.6 1.9 1.2 3 1.5 3.2.6.2.8.9 1.1 1.5l-.3.3c-.6.6-1.2 1-1.7 1.8-.7 1.2-1.2 1.2-.3 2.8l1.5 2.4c.4.7.6 1.2.8 2 .2.7.3 1.2.3 2l1 .3.7-.6.6-1.2v-1c-.2-.1-.3-.4-.2-.7 0-.4.5-.3.7-.6.3-.5-.4-.8-.7-1.1-.6-.7-1.4-.9-1.6-1.9 0-.2 0-.4.4-.7l2-1.8c.2.1.6.2 1 .1l1.3.4c.6.2.9 0 1.2 0h.4l.1.6c.1 1-.1 3 .2 3.5l.3.6.2.6v2l-.2 1.7c0 .4-.2.7-.5 1-.2.4-.6.4-1 .7v1l1.1.5 1.3.3.7-.3.1-.6.5-.5c.4-.2.8 0 .9-.1.2-.3 0-.4 0-.8 0-.6-.2-1-.3-1.6a11.8 11.8 0 0 1-.1-2.8c0-.6 0-1 .2-1.5.1-1 .4-1.4.6-2.2.3-1 .3-1.6.4-2.5a24.4 24.4 0 0 0 10.1-.6c.8.7 1.7 1.2 2.7 1.6v1c0 .3 0 .4.2.7l.3.3c.3 0 .5 0 .7-.2.2-.2.2-.4.2-.7v-.7h1.8v1.1c.1.3.3.4.5.4a.7.7 0 0 0 .6 0c.3-.2.2-.6.3-1v-.7l1-.4a5.1 5.1 0 0 1 0 .9l-.3.9c-.2.6-.5.8-.8 1.4-.4.6-.5 1-1 1.5l-.6.7-.6.9-.9 1c-.7.6-1.2.2-2 .9l-.3 1 1.4.6 1.3.2.4-.2c0-.3 0-.6.3-.8.2-.3.4-.3.7-.4.4 0 .8 0 1-.2.4-.3.4-1 .7-1.5a12.7 12.7 0 0 1 3-3.9l1.7-1.4c.2-.4.5-.5.5-1l-.2-.6-.2-1c1.5.7 1 .7 1.2 1.4.3.6 0 1 .1 1.7.1.8.5 1.1.5 1.9.1.9-.1 1.4-.3 2.3-.1.8-.1 1.3-.5 2a3.8 3.8 0 0 1-1.1 1.5l-.6.5-.1 1 1.1.4 1.6.4.4-.3c.2-.7 0-1.7.4-1.7.4-.1.7 0 .8-.3v-.7l.7-4.5.4-1.9.4-1.7c.7-2-.2-2.3-1-3.6-.5-.7-.7-1-.7-1.5V362a42.7 42.7 0 0 1 0-2.8l.4-.2c1.2-.7 1.7-.9 2.4-2.5a3.4 3.4 0 0 0 .3-1.5v-1l-.4-1a3.2 3.2 0 0 0-.6-.8c-.7-1-1.7-1.1-2.7-1.5-1.5-.5-2.5-.4-4-.5-1.8-.2-2.7-.2-4.4 0-2 0-3.1.4-5.1.7l-4.9.4c-2.3 0-4.4-.5-5.8-.4-2.4.2-2.5.8-6.2 1.1a67 67 0 0 1-3.8.2l-2.2-.7c.9-.3 1.1-.5 1.5-1 .3-.4.2-.7.6-1.1l.7-1a2.2 2.2 0 0 0-.9-.4h-1a3 3 0 0 0-1.2.3l-.8.6-2.2-1.2a8.8 8.8 0 0 0-3-.9zm2 11.8z"
        />
        <g fill="none" stroke="#fedf00" strokeLinecap="round">
          <path d="M568.8 359.5l-.8.3c-.9.4-1.6.4-2.6.5-2.6.2-4.3-1.1-7-.9-1.4.1-2 1.2-3.5 1.6a9.3 9.3 0 0 1-1.7.2l.5-1s-1.2.3-2 .3a7.5 7.5 0 0 1-1.6-.2l1-1-1.3-.2a4 4 0 0 1-1-.7 20.5 20.5 0 0 0 1.7-.3c1.5-.4 2-1.2 3.9-1.4 1.1 0 3 0 7.6.8 3 .5 4.4.2 5.5-.3.8-.3 1-1 1.1-1.8.1-.8-.4-1.4-.8-1.8-.1 0-.5-.3-1.1-.4" />
          <path
            fill="#fcd900"
            strokeLinecap="butt"
            strokeWidth={0.5}
            d="M524.8 350.6c-.5 0-.9 0-1.3.3-.5.3-.6.7-1 1.1.5.1.8.4 1.2.3.4 0 .5-.2.8-.5.3-.4.4-.7.4-1.2h-.1z"
          />
          <path d="M536 363.8a13.6 13.6 0 0 0 1 2.3c.2.8 0 1.2.2 2v1.6m6.8-7l-.3 1.3-1 3.5v.7m-11-4c.9.2.6 3.3 1.9 4" />
          <path
            strokeLinecap="butt"
            d="M560.1 369.8l.4-.3a8.2 8.2 0 0 0 2.7-1.8"
          />
          <path d="M552.4 368c3.5-.9 5.9-2.6 7.6-2.9m-4-1.5h.8c1.5-.3 1.7.6 2.7 1.2 1.9 1 2.1 2.3 4.3 3.4l.4.1.8.4" />
          <path
            fill="#fcd900"
            strokeLinecap="butt"
            strokeWidth={0.5}
            d="M517.7 354.5h.7l.8-.2c.3 0 .5 0 .7.2.2 0 .2.1.3.3 0 .2.2.3.1.5 0 .2-.3.4-.6.4-.2 0-.4 0-.5-.3a.5.5 0 0 1 0-.4 1 1 0 0 1-.9 0 1 1 0 0 1-.6-.5z"
          />
        </g>
        <path
          fill="#0065bd"
          d="M525.1 364.2l-2-.9c.4-.2.7-.2 1-.5.3-.4.3-.8.5-1.3s.2-1 .7-1.4c.3-.2.8-.2 1.1-.1.4 0 .8.4.9.7 0 .6-.2 1-.3 1.5 0 .6-.3.9-.2 1.4 0 .4.2.6.4 1l-2-.4zm-1 1a.6.6 0 1 1 .7.5.6.6 0 0 1-.7-.6zm-1.7-16.6h-.2c-.4-.4-.4-.8-.6-1.2a4 4 0 0 1-.3-1.2v-2c0-.3 0-.6-.2-.9 0-.2-.4-.3-.3-.4 0-.1.3 0 .4 0 .4 0 .6.1 1 .4.3.3.5.6.6 1l.4 1.5.3.8.5.6-.7.8-.9.6zm3.6 10.6l2.2 1a9.2 9.2 0 0 0 3.5-3.8c.9-1.8 1-2.7 1.4-4.4l-1.8-.5h-.4c-.5 1.8-.7 2.7-1.6 4.2-.8 1.3-1.7 2.3-2.6 3l-.7.5zm5 18.2l.8-1.3 1.4-1.1h.4a8.7 8.7 0 0 1-.5 2.8l-.4 1-.5.5c-.5-.8-1.3-1.3-1.3-2zm33 1.8l1.4.6 1.5.9v.5l-1.5.2a8.4 8.4 0 0 1-1.3 0h-1l-.6-.4c.5-.7.8-1.6 1.4-1.8zm-9.8-2l1.4.5 1.5 1c0 .1.1.3 0 .4a9 9 0 0 1-2.7.3l-1-.1-.7-.3c.6-.7.9-1.7 1.5-1.8zm-17.4 2.1l1.5.5 1.5 1v.5a9 9 0 0 1-2.8.2h-1l-.6-.4c.5-.7.8-1.6 1.4-1.8zm-9-29.8c-.6-.3-1-1-.6-1.6.1-.2.4-.2.6-.4.2-.3.1-.5 0-.8l-.1-1-.2-1c0-.6 0-1 .4-1.6.2-.3.7-.6.8-.6.2.1 0 .5 0 .8 0 .5.1.7.3 1.2l.7 1.3c.2.6.4.8.4 1.4 0 .5 0 .7-.2 1.2a2 2 0 0 1-.6.8 2 2 0 0 1-.8.4 1.1 1.1 0 0 1-.6 0z"
        />
      </g>
      <use width="100%" height="100%" y={36.6} xlinkHref="#prefix__b" />
    </g>
    <path
      fill="none"
      stroke="#703d29"
      strokeWidth={0.5}
      d="M264.1 175.5h52.6V228h-52.6zm58.2 0h52.6V228h-52.6zm-58 98c.1 1 .5 2.6 1.4 4.3 1 1.5.6 1.4 2.7 3.8a15.3 15.3 0 0 0 4 2.9 32.7 32.7 0 0 0 15 2.6c2.7-.1 4.8-.4 6.6-.7a71 71 0 0 1 11-.6c1.5 0 3 .3 4.7.6 3.5.7 7 2 7 2v-54.7h-52.6V271l.2 2.4zm110.4 0a13 13 0 0 1-1.4 4.3c-1 1.5-.6 1.4-2.7 3.8a15.4 15.4 0 0 1-4 2.9c-1.3.7-2.3 1-4.4 1.6a32.6 32.6 0 0 1-10.6 1c-2.7-.1-4.8-.5-6.5-.7a71 71 0 0 0-7.2-.6 40.5 40.5 0 0 0-3.9 0c-1.5 0-3 .3-4.7.6-3.5.7-7 2-7 2v-54.8H375v37.5l-.2 2.4z"
    />
  </svg>
	),
	AE: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#00732f" d="M0 0h640v160H0z" />
    <path fill="#fff" d="M0 160h640v160H0z" />
    <path d="M0 320h640v160H0z" />
    <path fill="red" d="M0 0h220v480H0z" />
  </svg>
	),
	AF: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path d="M0 0h640v480H0z" />
      <path fill="#090" d="M426.7 0H640v480H426.7z" />
      <path fill="#bf0000" d="M213.3 0h213.4v480H213.3z" />
    </g>
    <g
      fill="#fff"
      fillRule="evenodd"
      stroke="#bd6b00"
      strokeWidth={0.5}
      transform="translate(1 27.3) scale(1.06346)"
    >
      <path d="M319.5 225.8h8.3c0 3.2 2 6.6 4.5 8.5h-16c2.5-2.2 3.2-5 3.2-8.5z" />
      <path
        d="M266.7 178.5l4.6 5 57 .2 4.6-5-14.6-.3-7-5h-23l-6.6 5.1h-15z"
        stroke="none"
      />
      <path d="M290 172.7h19.7c2.6-1.4 3.5-5.9 3.5-8.4 0-7.4-5.3-11-10.5-11.2-.8 0-1.7-.6-1.9-1.3-.5-1.6-.4-2.7-1-2.6-.4 0-.3 1-.7 2.4-.3.8-1.1 1.5-2 1.6-6.4.3-10.6 5-10.5 11.1.1 4 .6 6.4 3.4 8.4z" />
      <path d="M257.7 242.8H342l-7.5-6.1h-69.4l-7.5 6.1z" stroke="none" />
      <path d="M296.4 219.7l1.5 4.6h3.5l-2.8-4.6h-2.2zm-2 4.6l1 4.6h4l-1.5-4.6h-3.5zm7 0l2.8 4.6h5.9l-4.6-4.6h-4.1zm-34.5 10.4c3.1-2.9 5.1-5.3 5.1-8.8h7.6c0 2 .7 3.1 1.8 3h7.7v-4.5h-5.6v-24.7c-.2-8.8 10.6-13.8 15-13.8h-26.3v-.8h55.3v.8H301c7.9 0 15.5 7.5 15.6 13.8v7h-1l-.1-6.9c0-6.9-8.7-13.3-15.7-13.1-6 .1-15.4 5.9-15.3 13v2.2l14.3.1-.1 2.5 2.2 1.4 4.5 1.4v3.8l3.2.9v3.7l3.8 1.7v3.8l2.5 1.5-.1 3.9 3.3 2.3h-7.8l4.9 5.5h-7.3l-3.6-5.5h-4.7l2.1 5.4h-5l-1.3-5.4h-6.2v5.8H267zm22.2-15v4.6h5.3l-1-4.6H289z" />
      <path fill="none" d="M289.4 211.7h3.3v7.6h-3.3z" />
      <path
        fill="none"
        d="M284.7 219.8h3.2v-5.6c0-2.4 2.2-4.9 3.2-5 1.2 0 2.9 2.3 3 4.8v5.8h3.4v-14.4h-12.8v14.4zm25.6 3.3h4v3.2h-4zm-2.4-5.3h4v3.1h-4zm-3.9-5.4h4v3.1h-4zm-3.3-4.5h4v3.1h-4z"
      />
      <path
        fill="none"
        d="M298 219.8l4.2.2 7.3 6.4v-3.8l-2.5-1.8v-3l-3.6-2v-3.3l-3.5-1.2V207l-1.7-1.5-.1 14.4z"
      />
      <path d="M315.4 210.3h1v7.1h-1z" />
      <g id="prefix__a">
        <path d="M257.3 186.5c-1.2-2-2.7 2.8-7.8 6.3-2.3 1.6-4 5.9-4 8.7 0 2 .2 3.9 0 5.8-.1 1.1-1.4 3.8-.5 4.5 2.2 1.6 5.1 5.4 6.4 6.7 1.2 1 2.2-5.3 3-8 1-3 .6-6.7 3.2-9.4 1.8-2 6.4-3.8 6-4.6l-6.3-10z" />
        <path
          fill="#bf0000"
          d="M257 201.9a10 10 0 0 0-1.6-2.6 6.1 6.1 0 0 0-2.4-1.8 5.3 5.3 0 0 1-2.4-1.5 3.6 3.6 0 0 1-.8-1.5 5.9 5.9 0 0 1 0-2l-.3.3c-2.3 1.6-4 5.9-4 8.7a28.5 28.5 0 0 0 0 2.3c.2.5.3 1 .6 1.3l1.1.8 2.7.7a7.1 7.1 0 0 1 2.6 2 10.5 10.5 0 0 1 1.8 2.6l.2-.8c.8-2.7.7-5.9 2.6-8.5z"
        />
        <path
          fill="none"
          d="M249.8 192.4c-.5 3.3 1.4 4.5 3.2 5.1 1.8.7 3.3 2.6 4 4.4m-11.7 1.5c.8 3 2.8 2.6 4.6 3.2 1.8.7 3.7 3 4.5 4.8"
        />
        <path d="M255.6 184.5l1-.6 17.7 29.9-1 .6-17.7-30z" />
        <path d="M257.5 183.3a2 2 0 1 1-4 0 2 2 0 1 1 4 0zm15.2-24h7.2v1.6h-7.2zm0 3.1h7.2v13.8h-7.2zm-.4-5h8c.2-2.7-2.5-5.6-4-5.6-1.6.1-4.1 3-4 5.6z" />
        <path
          fill="#bd6b00"
          stroke="none"
          d="M292.6 155.8c-1.5.6-2.7 2.3-3.4 4.3-.7 2-1 4.3-.6 6.1 0 .7.3 1.1.5 1.5.2.3.4.5.6.5.3 0 .6 0 .7-.3l.2-.8c-.1-2-.1-3.8.3-5.4a7.7 7.7 0 0 1 3-4.4c.3-.2.4-.5.5-.7a1 1 0 0 0-.3-.7c-.4-.3-1-.4-1.5-.1zm.2.4c.4-.2.8 0 1 .1l.1.2c0 .1 0 .2-.3.4a8.2 8.2 0 0 0-3.1 4.6 16.7 16.7 0 0 0-.3 5.6 1 1 0 0 1-.2.6s0 .1-.2 0c0 0-.2 0-.4-.3a3.9 3.9 0 0 1-.4-1.2c-.3-1.8 0-4 .7-6 .7-1.8 1.8-3.4 3-4z"
        />
        <path
          fill="#bd6b00"
          stroke="none"
          d="M295.2 157.7c-1.5.7-2.5 2.3-3 4.2a13.6 13.6 0 0 0-.3 5.9c.2 1.3 1 2 1.6 2 .3.1.6 0 .8-.3.2-.3.3-.6.2-1-.4-1.6-.5-3.4-.3-5.1.3-1.7 1-3.2 2.2-4.1.3-.3.5-.5.5-.8a.8.8 0 0 0-.2-.6c-.4-.3-1-.4-1.5-.2zm.2.5c.4-.2.8-.1 1 0l.1.3-.3.4a6.5 6.5 0 0 0-2.4 4.4c-.3 1.8-.1 3.7.2 5.2.1.4 0 .6 0 .8l-.5.1c-.3 0-1-.5-1.2-1.7-.3-1.7-.2-3.9.3-5.7.5-1.8 1.5-3.3 2.8-3.8z"
        />
        <path d="M272.3 187.4h8v11h-8zm.5 17.4h7.7v2.4h-7.7zm-.2 4.1h8v8.7h-8zm-.6 10.5h8.7v4.9H272zm1.1-16.6h7l1.4-2.4h-9.6l1.2 2.4zm9.4-8.6l.1-6h4.8a17.4 17.4 0 0 0-4.9 6z" />
        <path
          fill="none"
          d="M273.6 196.7c0 1.3 1.5.8 1.5.1v-5.6c0-1 2.4-.8 2.4-.1v6c0 1 1.7.9 1.6 0v-7c0-2.2-5.5-2.1-5.5-.1v6.7zm0 13.3h5.7v7h-5.7z"
        />
        <path d="M277.2 213h2v1h-2zm-3.5 0h2v1h-2zm2-3h1.5v3h-1.5zm0 4h1.5v3.1h-1.5zM244 139c.4 5.5-1.4 8.6-4.3 8.1-.8-3 1-5.1 4.3-8.1zm-6.5 12.3c-2.6-1.3-.7-11.5.3-15.8.7 5.5 2 13.3-.3 15.8z" />
        <path d="M238.4 151.8c4.4 1.5 8-3.2 9.1-8.7-3.6 5-9.5 5-9 8.7zm-3.3 5.1c-3.4-.9-1.4-11.7-.7-16 .7 4.5 3.1 14.5.7 16zm1.2-.3c.2-3.7 3.9-2.7 6.5-4.7-.5 2-2 5.2-6.5 4.7zm-4.2 5c-3.4-1-1.4-12.6-1.6-17.4 1 4.2 4.2 16.3 1.6 17.4zm1.6-.5c2.8.9 6.5-1 6.8-4.3-2.5 1.7-6.3.4-6.8 4.3z" />
        <path d="M229.5 166.7c-3.2.3-1.8-9.6-1.8-18.8 1.2 8.6 4.5 16.5 1.8 18.8z" />
        <path d="M230.7 166.3c2.2 1 6.1-.7 7.2-4.4-4 1.7-6.6 0-7.2 4.4zm25.6-22.2c-.6 4.9-2.6 7.7-5.5 7.2-.8-3 1.6-5 5.5-7.2zm-7.8 12.4c4.9.7 6.6-3 10-7.9-4.7 3.4-10.2 4-10 8z" />
        <path d="M247 156c-2.6-3.2 0-7.3 2-10.7-.4 5.1 1.3 8-2 10.7zm-1 5.3c-.4-3.2 5-3.9 7.4-5.6-.9 1.8-2 6.7-7.5 5.6z" />
        <path d="M244.8 161.3c-3.7-.4-2.2-6.7.5-10.1-1.1 4.8 2 8.1-.5 10.1z" />
        <path d="M242 166.6c-4.2-2-1.5-7.2 0-10.3-.6 4.1 2.8 7.2 0 10.2z" />
        <path d="M242.8 166c2.2 3 6.5-.8 7.4-5.2-3.7 3.1-6.5 2.6-7.4 5.3zm-9.6 20.3c-.4-4.3 2.8-12 .5-16.2-.3-.6.7-2.1 1.4-1.2 1 1.5 2 5.7 2.5 4.1.4-1.7.5-4.6 2-5.2 1-.3 2.3-.6 1.9 1-.4 1.4-1.2 3.4-.3 3.5.5 0 2-2 3.3-3 1-.8 2.6.6 1 1.8-4.8 4-9.5 5.9-12.3 15.2zm-8.7 64.5c-.6 0-1.3-.3-.6.6 5.7 7 7.3 9 15.6 8 8.3-1.1 10.3-3.4 16.2-6.7a14.6 14.6 0 0 1 11.2-1c1.6.5 2.6.5 1.4-.7-1.2-1.1-2.5-2.7-4-3.8a17.5 17.5 0 0 0-12.7-2.7c-6 1-11.1 4.9-17.2 6.4a25 25 0 0 1-9.9 0zm47.8 12.5c1 .2 1.7 2.2 2.3.9.8-2.3.2-4-.8-3.9-1.2.3-3.1 3-1.5 3z" />
        <path
          stroke="none"
          d="M220.6 183c-1.2-1.4-.9-1.8 1-1.9 1.4 0 4.2 1 5.3.1 1-.7.5-3.7 1-5 .2-.9.7-2 2-.2 3.6 5.8 8 12.8 10 19.6 1 3.8 0 9.8-3.4 13.8 0-3.4-1.2-5.7-2.7-8.6-2-3.7-9.1-14-13.2-17.9z"
        />
        <path d="M235.5 213.4c4 0 4.7-5.3 4.7-6.8-2 .4-5.4 3.7-4.7 6.8zm34.5 51.9c2.8.6 2.7-6.2-.2-9.1 1.3 4.4-2 8.4.1 9zm-1.2-.1c.2 3.2-8-.4-10-3 4.8 2.1 9.8.4 10 3zm-3.5-4.6c.3 3.1-7 .3-9.3-2.1 4.9 1.6 9-.5 9.3 2zm1.3.4c2.9.7 2.4-6.4-.4-8.8 1.4 4.7-1.8 8.1.4 8.8zm-3-4.3c2.9.7 1.2-5.4-.9-7.8.4 4.4-1 7.5 1 7.8zm-1.5 0c.3 3.2-5.4.8-7.6-2.3 4.8 1.5 7.3-.3 7.6 2.3zm-1.5-2.5c1.8-1.3-.1-4.8-3.7-4.6.4 2.1 1.6 5.9 3.7 4.6zm14 14.7c.1 3.2-8 1.6-10.6-1.8 5.2 1 10.3-.8 10.5 1.8zm-32.4-5.8c.3 3.2-8.6-.4-10.8-3.4 4.7 1.6 10.5.8 10.8 3.4zm5.4 1.3c1.9-1.3-1.9-4.7-5-5.5.4 2.1 3 6.8 5 5.6zm.6 2.3c.2 2.9-9.5 1.3-12-1.4 8.3 1.5 11.7-1.1 12 1.4z" />
        <path d="M252.8 268.6c1 2.7-8.3 2-11.6.5 5.3 0 10.8-2.4 11.6-.5z" />
        <path d="M257.1 270.6c1 2.4-7.6 2.4-11.8 1 5.6 0 10.8-3.4 11.8-1zm6.3 1.3c1.6 2.9-7.6 3.1-10.5 1.7 5.2-.7 9.2-4 10.5-1.7zm-10.7-4.9c-2.9 1.8-2.7-3.6-5-7.3 3.6 3.3 7 5.6 5 7.3z" />
        <path d="M257.9 269c-2.4 2.1-4.4-5.3-6.6-9.5 3.6 4 8.8 7.7 6.6 9.4zm6.8 2c-2 2.4-8-7-10.2-12 3.3 3.9 11.8 10 10.2 12zm-5.8 7.2c-1 3.6-16.2-3.4-18-7.1 8.8 4.6 18.2 3.6 18 7zm-48.7-73.8c-.4-.5-1.4 0-1.2 1.1.3 1.5 2.5 9.2 6.3 11.8 2.7 2 17 5.1 23.4 6.5 3.6.7 6.5 2.5 8.9 5.3a94.4 94.4 0 0 0-3-9.8c-1.2-3-4.4-6.2-7.8-6.3-6.1-.3-14.1-.8-20-3.3a16 16 0 0 1-6.7-5.3z" />
        <path d="M245.5 234.9c2 1.4 4.1-3.7 1.7-8.6-.1 4.7-3.8 6.3-1.7 8.6z" />
        <path d="M247.4 239.6c2.7.8 3.5-4 1.8-7.8.3 4.1-4.3 6.6-1.8 7.8z" />
        <path d="M249.5 243.4c2.6 1.3 3.5-3.6 1.7-7.1.2 4.5-3.7 5.9-1.7 7z" />
        <path d="M248.4 243.7c-1 3-7-2.7-8-5.8 3.7 3.7 8.7 3.2 8 5.7z" />
        <path d="M245.7 239c-1.2 3-8.7-5-10.4-8.7 3.7 3.7 11.2 6.5 10.4 8.6z" />
        <path d="M244.2 234.3c-1.2 3.5-9.3-5.8-11.7-9.1 4 3.6 12.6 6.6 11.7 9.1zm-.3-3.4c3-.6-.1-3-3.7-6.9-.1 4.1.5 7 3.7 6.9z" />
        <path d="M239 228.5c1.3-1.3-1.1-1.9-4.1-5.3-.5 2.3 2.8 6.5 4.2 5.3zm14 15.2c1.6 1 2.6-2.3.7-5.2-.5 3.2-2.1 4-.7 5.2zm-34.2-20.3c-3.3 2-8.6-6-10-9.3 2.9 3.8 10.6 7.2 10 9.3z" />
        <path d="M221.7 228c-1.9 2-7.7-3.5-9.7-6.3 3 2.7 10.5 3 9.7 6.3z" />
        <path d="M224.8 232.2c-.6 2.8-9-3.5-11-6.5 3.6 3.5 11.6 3.2 11 6.5z" />
        <path d="M223.5 235.3c-1.3 2.5-8.2-3.8-9.9-7 4.3 3.6 11 4.5 10 7zM220 223c2.1-2.3 1.2-3.4-.4-7-.8 3.7-2.1 5.2.4 7zm2.9 4.3c4 .2 0-4.6-1-8.7.4 4.6-1 8.3 1 8.7z" />
        <path d="M225.4 231.1c2.7-.6 2-4.5-.2-9.2.5 5.1-2.3 8 .2 9.2zm-1 7.7c-1 3-8.8-4-10-6.8 4 3.4 10.7 4.5 10 6.8z" />
        <path d="M229.1 243.6c-1.1 3-9.3-3.2-11.8-6.6 4.9 4 12.4 3.6 11.8 6.6z" />
        <path d="M233.9 248.5c-1.3 4.3-9.9-2.6-12.4-6 5.4 4.2 13 3 12.4 6zm-8-11c2.3 1.1 3.2-5.4 1.9-10.1 0 5-4.7 8.8-2 10z" />
        <path d="M229.8 242.7c2.8.8 2-6.3-.5-11-.3 4.7-2.3 9 .5 11zm5 4.9c3 .1 1-6.1-1.6-9.6.4 4.5-1 9 1.6 9.6zm-5.5 2.6c-1 1.6-3.2-1.3-7-3.5 3.4 1 7.4 2 7 3.5zm-1.8-52.7c3-2.2.7-6.2 0-10-1 3.6-3.4 8.4 0 10zm0 5.3c-4.5-.5-3.8-6.1-4-9.7 1.4 4.9 5 5.7 4 9.8zm.6-.7c3.7-.2 3.5-4.4 3.7-8.6-1.9 3.9-4 4.5-3.7 8.6z" />
        <path d="M228 207.3c-3 .3-4.4-2.6-5-7 2.7 4.1 5.1 2.8 5 7zm1-.3c3.7.5 3-3.8 3-7-1.2 3-4.2 4-3 7z" />
        <path d="M223.2 205.2c.3 2.8 2.1 7.6 5 6.5 1.1-3.4-2.6-4.1-5-6.5z" />
        <path d="M229 212c-1.2-2.4 3-3.7 3.8-6.9.5 4.6.1 7.6-3.8 7zm-11.9-29.2c2.3-2.4.3-6.4-.4-10.2-1 3.6-2.5 8.4.4 10.2zm0 4.6c-4 .5-5-7.7-5.5-11.3 1.4 4.9 6 7 5.5 11.4zm.8 0c2.8-1.5 2.2-4.7 3-7-1.8 2.9-3.6 3.3-3 7z" />
        <path d="M217 192.8c-4.1.3-6.6-8.8-6.8-12.4 1.3 4.9 7.4 7.5 6.9 12.4zm.9-.2c4-.9 3.5-3.5 2.9-7.6-1.3 4.2-3.5 3.3-2.9 7.6z" />
        <path d="M217 198c-4.6.8-4.3-6.6-8-11.9 3.2 4 9 9 8 11.9zm1-.3c3.6.2 4-5.1 3.8-7.3-.9 2.2-5 4.2-3.7 7.4z" />
        <path d="M209.8 192.3c1.7 5.7 4.2 11.4 7.2 11 1.5-3.3-2.9-3.7-7.2-11z" />
        <path d="M218.1 202.4c-1.2-2.5 3-3.7 3.8-6.9.5 4.6.1 7.6-3.8 6.9zm-7.1-3.6c2.5 5.1 3.6 11 7 10.1 1.3-4-3.8-4.8-7-10.1z" />
        <path d="M218.7 208c-1.5-2.8 2.7-3.7 3.8-7.4.5 4.8 0 8.3-3.8 7.3zm7.2-34.5c2.4.6 5-2.1 4.1-6.2-2.8.6-4 3.2-4.1 6.2zm-7.9-2.1c.2 1.2 1.7 1.3 1.2-.4a5.3 5.3 0 0 1 0-3.4 7.5 7.5 0 0 0 0-4.6c-.4-1-1.8-.4-1.2.4.6.9.7 2.8.2 3.7-.6 1.3-.4 3-.2 4.3zm22.9 16c-1 1.3-2.9.4-1.4-1.5 1.2-1.5 3-2.8 3-4.4.2-2 1.3-5 2.4-6.1 1.1-1.1 2.4.4 1.2 1.2-1.3.8-2.2 4.4-2.1 5.8-.1 2-2 3.5-3.1 5zm-3-2.3c-1 1.4-2.4.5-1.6-1.7.7-1.5.8-3.5 1.6-4.6 1.2-1.7 3-3.1 4.1-4.2 1.2-1 2 0 1 1a27 27 0 0 0-3.3 4c-1.4 2.2-.8 4-1.8 5.5zm-15.7-7.2c-.1 2 1.5 2.4 1.4-.4 0-3-2.2-5.8-1-10.3.8-2.2.8-6.3.4-8.4-.4-2.2-2-.8-1.3.9.6 2-.1 5.6-.6 7.5-1.5 5.4 1.2 8 1 10.7zm4.3-11c-.2 1.9-1.8 2-1.3-.5.4-2 .4-3.6 0-5.3-.6-2.1-.4-5.7 0-7.2.5-1.6 2-.7 1.4.5a9.9 9.9 0 0 0-.3 5.9c.6 2 .5 4.8.2 6.7zM210.9 204c.8.9 2 .3 1-1-1-1-.7-1.2-1.3-2.4-.6-1.4-.5-2.1-1.2-3-.7-1-1.6 0-1 .7.8 1 .6 1.6 1 2.5 1 1.5.7 2.3 1.5 3.2zm20.4 24.6a8.6 8.6 0 0 1 4.4 6.7 16 16 0 0 0 2 7.1c-2-.5-3-3.7-3.3-6.8-.3-3.2-2-4.5-3-7zm5.1 5.9c1.7 3.1 4 4.3 4.2 6.6.2 2.7.4 2.8 1.1 5.4-2-.5-2.5-.7-3-4.7-.3-2.8-2.6-4.7-2.3-7.3z" />
        <path
          stroke="none"
          d="M289 263.3c1 1.8 2 4.5 4 4 0-1.3-2.1-2.3-4-4zm3 .6c3.7 1.6 7 1.2 7.5 3.6-3.6.4-5-1-7.6-3.6zm-16.1-12.7a14 14 0 0 1 5 7.7 29 29 0 0 0 3.6 7.8 13 13 0 0 1-5.3-7.4c-.7-3-1.6-5.3-3.3-8zm3.1 0c2.8 2.2 5.4 4.8 6.2 7.9.8 2.9 1.3 5.1 3.2 8-3-1.9-4.1-4.7-5-7.8-.7-3-2.5-5.2-4.4-8zm9.2 7.3a1.1 1.1 0 0 1 .7-1.2 33.4 33.4 0 0 1 2.6-.8c1-.3 1.6.4 1.6.9v2c0 .7-.2.8-.7.9-.7.1-1.7.2-2.4.7-.6.4-1.2.1-1.5-.5l-.3-2zm10.6 0c0-.6-.2-1.1-.6-1.2a5.4 5.4 0 0 0-2.4-.4c-1 0-1.1.2-1.1.6v2.1c0 .8 0 .8.4 1 .7 0 1.8 0 2.5.6.5.3 1 0 1.1-.6l.1-2.1z"
        />
      </g>
      <use
        width="100%"
        height="100%"
        x={-600}
        transform="scale(-1 1)"
        xlinkHref="#prefix__a"
      />
      <g stroke="none">
        <path d="M328.5 286.6c0 1.2.2 2.2 1 3.1a19 19 0 0 0-13.8 1.1c-1.8.8-4-1-1.9-2.7 3-2.3 9.7-1 14.7-1.5zm-57.5 0a7 7 0 0 1-.4 3c4.4-1.7 9.1-.2 13.6 1.6 3 1.3 3.3-1 2.8-1.7a6.5 6.5 0 0 0-5-2.9h-11zm3.8-21.7c-1.3-.5-2.7 0-4 1.4-4.3 4.2-9.4 8.3-13.5 11.6-1.5 1.3-3 3.7 3.4 6 .3.2 5 2 8 2 1.3 0 1.3 1.8 1 2.3-.5 1-.1 1.4-1.1 2.3-1.1 1 0 2.1 1 1.3 3.6-3.2 9.6-1.1 15.3.7 1.4.4 3.8.3 3.8-1.6 0-2 1.5-3.4 2.4-3.5 2.4.4 14 .5 17.5.1 2-.3 2.2 2.9 3.3 4 .8.9 3.7 1.1 5.8.2 4-1.8 10-1.8 12.5 0 1 .7 1.9 0 1.3-.7-.8-1-.7-1.6-1.1-2.4-1-2-.2-2.4.8-2.5 11-1.5 14.6-5.2 11.2-8.3-4.4-3.8-9.2-7.7-13.4-12.2-1.2-1.2-2-1.7-4.3-.7a66.5 66.5 0 0 1-25.3 5.9 76 76 0 0 1-24.6-5.8z" />
        <path
          fill="#bd6b00"
          d="M326.6 265.5l-1.6.4c-9 3.2-17.2 5.4-25.7 5.4-8.3 0-17-2.4-24.9-5.6a2.3 2.3 0 0 0-1.5 0c-.5.1-1 .4-1.3.7a115.5 115.5 0 0 1-11.8 10.3c-.7.5-.6 1.8.5 2.2 8.3 3 16.4 8.5 39.6 8.3 23.5-.2 31.8-5.6 39.2-8.1.5-.2 1-.5 1.3-1a1 1 0 0 0 .1-.8 2 2 0 0 0-.6-.8c-4.3-3.5-8.8-6.3-11.8-10.4-.3-.5-.9-.6-1.5-.5zm0 .5c.5 0 1 0 1.1.3 3 4.3 7.7 7 11.9 10.5l.4.7a.5.5 0 0 1 0 .4c-.1.3-.6.6-1 .7-7.6 2.6-15.7 8-39 8.2-23.2.2-31.2-5.3-39.5-8.3-.8-.4-.7-1.2-.4-1.4 4.2-3.2 8.2-6.8 11.8-10.4a2.5 2.5 0 0 1 1.1-.6h1.2a68 68 0 0 0 25 5.6c8.7 0 17-2.2 26-5.3a6.7 6.7 0 0 1 1.5-.4z"
        />
        <path d="M269.7 114.6c0-1.4 2-1.5 1.8.4-.3 2.3 4.5 8.3 4.9 12 .3 2.5-1.5 4.6-3.2 6a6.6 6.6 0 0 1-6.8.5c-.9-.8-1.7-3.3-1-4.3.2-.3 1.3 3.7 3.7 3.7 3.3 0 6-2.5 6-4.7.2-3.8-5.3-9.8-5.4-13.6zm9.5 9.4c.6-.4 1.4 1.3.8 1.7-.5.3-1.5-1.3-.8-1.8zm1.5-3.5c-.3.2-.8 0-.7-.2a12 12 0 0 1 3.6-3.3c.4-.2 1 .4.8.7a11 11 0 0 1-3.7 2.8zm12.6-10c.3-.6 2.1-1.3 2.6-1.7.4-.5.6.4.4.7-.3.7-1.9 1.7-2.6 1.8-.3 0-.6-.4-.4-.7zm4.3.3a8.3 8.3 0 0 1 2.5-3.4c.5-.3 1.3 0 1.1.4a9 9 0 0 1-2.9 3.3c-.3.3-.8 0-.7-.3zm-3.7 2.7c-.3.2-.1.7.1.8.6.2 1.5.2 2 0 .6-.4.3-2.9-.5-1.6-.6.8-1 .6-1.6.8zm-7.3 5.6c-1.3-1 .4-2.4 1.7-1.4 2.7 2-4 9.8-7.6 13.4-.7.7-1.3-1-.4-1.9a33.7 33.7 0 0 0 6.7-7.6c.4-.5.7-1.6-.4-2.5zm15.3-6.6c.1-1-1.6 0-1.6-1.3 0-.7 1.9-1.2 2.7-.4 1.3 1.4.3 3.7-2 3.9-1.8 0-5 2.7-4.5 3.2.5.7 5.4 1.1 8.3.7 1.8-.3 1.4 1.3-.4 1.5-1.8.2-3.2 0-4.8.6-2 .5-2.8 3-3.9 4-.2.2-.8-.8-.6-1.2.8-1.2 2-3 3.4-3.6.8-.3-2.4-.4-3.4-.7-.8-.2-.6-1.3-.3-1.9.4-.8 3.4-3.9 4.7-3.8 1.1 0 2.3-.3 2.4-1zm5 .2c.6-.5 1-1.3 1.5-1.8.3-.3.9 0 .8.8-.1.7-1 1.2-1.5 1.7-.5.3-1-.4-.7-.7zm6.5-2.3c.9 0 1 1.6.2 1.8-.6.2-1-1.7-.2-1.8zm-2.1 5c0 1.5.7 1.4 2 1.3 1.3 0 2.4 0 2.4-1.2 0-1.3-.7-2.5-1-1.6-.1.8-.3 2.2-.8 1.6-.4-.5-.2-.6-1 .2-.5.5-.5-.2-.8-.6-.2-.3-.8.2-.8.4zm-9.2 7.2c-.3 1.9 0 4.5.9 4.5 1.2 0 3.6-4 4.8-6.2.7-1.2 1.8-1.4 1.3-.1-.7 1.9-.6 6 0 7.2.4.6 3-.6 3.4-1.5.8-1.7.1-4.8.4-6.7.1-1.2 1.3-1.5 1.2-.3a75.6 75.6 0 0 0-.1 7.5c0 1 2.9 2.4 3.3-.6.2-1.8 1.2-3.7 0-5.7-.8-1.3 1.1-1.2 2.1.6.7 1.2-.6 3.2-.5 4.7 0 2.4-1.8 3.8-3.1 3.8-1.2 0-2-1.5-3-1.5s-2.2 1.7-3 1.6c-3.6-.2-1.7-5.3-2.8-5.4-1.2 0-2.5 5-4 4.9-1.4-.2-3-4.2-2.3-5.8.5-1.6 1.5-2 1.4-1zm16.9-8c-1.7-1 0-3.7.9-2.8 1.6 2 3.2 6.5 4.4 6.9.7.2.6-3.4 1.1-5 .4-1.3 1.8-.9 1.6.7-.1.5-2 6.4-1.8 6.6a47.1 47.1 0 0 1 3.3 7.8c.3 1.2-1.1.4-1.3.2-.9-1.4-2.4-6.5-2.4-6.2l-1.7 7.7c-.2 1-1.7.8-1.3-1 .3-1.4 2.3-8.3 2.2-8.6a17.2 17.2 0 0 0-5-6.3z" />
        <path d="M322 131.2c-.4 0-1.2 1 1.2 1.5 3.1.6 6.6-.5 7.6-3.6 1.3-3.7 2-7.2 2.7-8.5.8-1.5 1.8-1.4 1-3.6-.5-1.7-1.5-1.2-1.7-.3-.5 2.3-2.6 10-3.3 11.3-1.2 2.6-3.7 3.6-7.5 3.2z" />
        <path d="M328.4 119c-.4-.7-1.2 0-1 .7a1.2 1.2 0 0 0 1.2 1c.7 0 2.2.1 2.2-1 0-.8-.7-1.5-1.1-.6-.5.8-1 .7-1.3 0zm.7-3c-.2.2 0 1.1.3 1a7 7 0 0 0 3.3-.8c.2-.2.1-.7-.2-.7-1 0-2.6 0-3.4.5zm8.8 2.3c.8-1.2 2.8-1.3 2 .4a614.3 614.3 0 0 1-6.3 12.3c-.8 1.4-1.4.7-.8-.4.7-1.4 4.9-12 5.1-12.3z" />
        <path d="M330.2 133c-.2-.8-1.5-2-1.3.2.2 3.8 5.5 2.6 7 1.3s.3 4.3 2.2 4.9c1 .3 3-1.1 4-2.4 2.7-3.5 4.5-8.6 7-12 1-1.4-.5-2.4-1-1.3-2.4 3.8-5.2 11.6-8.3 13.6-2.5 1.6-1.7-2-1.8-3.2-.1-.8-1.1-2-2.4-.9a5.5 5.5 0 0 1-3.7 1.2c-.7 0-1.4 0-1.7-1.4z" />
        <path d="M339.6 126c0-.3-1.1-.4-1 .7 0 .8 1 1 1.1 1 1.5-1.2-.3-.6-.1-1.8zm-2.3 4.4c-.3 0-.6 1 .2 1.1l3.9-.2c.4 0 .6-.9-.4-.8-1.2 0-2.7-.3-3.7 0zm-62-16.6c.5 0 1.6 1.4 1.5 1.9 0 .2-1.2 0-1.5-.3-.3-.3-.2-1.6 0-1.6zm-5.3 10.4c-1 .6.2 1.7 1 1.2 2.8-1.9 7-3.8 8-7.5.3-1.2 1.4-3.1 2.5-3.5 1-.5 2.6 1.9 3.6 0 .6-1 2.7.7 3.2-.4.6-1.3.3-2 .3-3.4 0-.8-.7-1-1.2.3-.2.6 0 1.2-.1 1.6-.2.2-.6.4-1 .2-.2-.2 0-.7-.6-1-.2 0-.6-.1-.8.2-.7 1.3-1 2.5-2.1 1-.9-1-1.4-3.1-2-.3-.2 1-1.7 2.4-2.6 2.4-1.1 0-.8-3-3.2-2.5-1.3.3-1.2 2.7-1 3.5.3 1.3 4 .4 3.7 1.2-.6 2.7-4.4 5.4-7.7 7zm-22.7 13.2c-.1.5.5 1.7 1.1 1.8.6 0 1-1.3.8-1.8-.2-.3-1.8-.3-1.9 0zm3.3 4.9c-.4-.4-1.6.7-.6 1.5.5.5 2.5 1.1 3 .2.8-1.2-.7-5.5 0-6 .5-.5 2.8 2.8 4 3 2.7.4 2-4.6 5-4.2 1.9.2 2.1-2.2 1.8-3.8-.2-1.5-2.6-3.6-3.7-4.6-1.4-1.2-2.1 1-1.2 1.6 1.2 1 3.3 2.9 3.6 4.1.1.6-1.4 1.8-2 1.5-1.4-.8-2.6-4-3.8-4.7-.4-.2-1.4.3-1 1.3.6 1.1 3 2.7 3.1 3.9.1 1-1 3.2-1.8 3.2-.9 0-3-2.7-3.7-4-.4-.5-1.5-.5-1.7.4a22 22 0 0 0 .5 5.5c.2 1.6-.9 1.7-1.5 1.1zm-4-8.6c-.4.4.8 1.2 1 1 .4-.4 2.1-2.3 1.8-3-.3-.6-2.6-2-3-1.3-.7 1.1 2.2 1.7 1.7 2a7 7 0 0 0-1.5 1.3zm4.1-8.4s.8 2.5 1.4 1.4c.4-.7-1.4-1.4-1.4-1.4zm1.2 4c-.2 0-1 .7-.5 1 .8.4 2.9.8 2.4-.7-.3-.9 3.2 0 2.3-2.4a3.7 3.7 0 0 0-1.7-1.7c-.4 0-1.5.5-.8.9.5.2 2 1.1 1.5 1.7-.7.6-1.1-.3-1.9-.1-.4 0-.1 1.2-.4 1.5 0 .2-.7-.4-.9-.3zm5.5-9.5a3.5 3.5 0 0 0-1.2 2c0 .2.3.6.5.5a3.2 3.2 0 0 0 1.2-1.9c0-.3-.2-.8-.5-.6zm2.8-.3c-.8-1 1-2.6 1.7-.5.5 1.3 5.5 7.9 6.5 10.1.8 1.5 0 2.1-.9 1-2.5-3.2-4.6-7.2-7.3-10.6zm5.2.1c.9-1 2.7-3 2.2-4-.4-1-1.5-1-1.7-.7-1 1.3.8 1 .5 1.4-.5 1-1 1.6-1.3 2.6-.1.3.1.9.3.7zm77.8 3.2c-.7-.5.6-3 1.5-2 2.3 2.7 3.4 11.6 4.1 18.3 0 0-1 .9-1 .7 0-3.5-1.5-14.4-4.6-17zm-53.1-8.6c-.8-1.8 1.1-2.4 1.4-1.2 1.3 5.8 4.5 10.2 7 14.1.7 1.2 0 2-1.7.8-1.2-.8-2.5-3.9-3-4-1.2-.2-3.8 5-9.1 3.5-1.4-.4-1.3-4.5-1.4-6.3 0-.9 1-1 1 0 0 1.7 0 5.2 2.1 5.4 1.8 0 5.6-2.4 6.4-4.4.8-2-1.9-5.9-2.7-8z" />
        <path d="M344.6 138.4c.4-1.2 6.1-10.8 6.9-12.9.4-1 2 1.8.4 3.3-1.4 1.2-5.5 8-6.3 10.4-.4 1-1.4.5-1-.8z" />
        <path d="M354.3 129.3c1-4 3.6.6 1.3 2.8-3.4 3.4-4.5 9.9-10 10.9-1.4.3-4-.7-4.8-1.3-.3-.2.2-1.6 1.1-.9 1.3 1 4.1 1.3 5.6.1a25.4 25.4 0 0 0 6.8-11.6zm-57 12.7c-.3.3-1 .3-1.1.7-.3 1.4 0 2.2-.3 3.6s-1.3 1.4-1.2.3c0-1.4 1.3-3.5.4-3.6-.6-.1-1-.9-.4-1.3 1.1-.7 1.7-.6 2.4-.4.3.1.4.5.2.7z" />
        <path d="M296.5 140c-1.4 1.4-2.8 1.9-4.1 3.5-.6.6-.5 1.5-.9 2.4-.3.9-1.4 1-1.7.9-.5-.4-.4-2-1-1.2-.6.9-.9 2-1.7 2-.7 0-2-1.5-1.3-1.5 2.3-.3 2.2-2 3-2.2 1-.1 1 1.5 1.7 1.2.4-.2.7-2.1 1.2-2.6 1.5-1.6 2.7-2.4 4.3-3.6.7-.6 1.3.5.5 1.2zm5.3 5c-1.2.2-1 1.7-.6 1.8.5.3 1.4.4 1.7-1.3.2-.7.3 3.5 1.8 1.9 1-1 3.1.2 4-1 .7-.9 1-1.5.4-2.7-.2-.3-1-.2-1 .7 0 .8-.5 1.7-1.3 1.6-.4-.1.2-1.9-.2-2.4a.5.5 0 0 0-.7 0c-.3.4.3 2.2-.6 2.4-1.2.2-.6-1.2-1-1.4-1.7-.8-1.8.2-2.5.3zm9-3c.9-.2.6-.2 2-1.3.5-.4.6.8.5 1.3 0 .7-1 .2-1.3.9-.4.9-.2 3-.4 3.8 0 .4-.8.4-.8 0-.2-1 .1-2 0-3.3 0-.4-.5-1.1 0-1.3zm-5-2.5c-.2.9-.2 1.6-.2 2.3 0 .5 1 .2 1 .1 0-.8.2-2 0-2.3-.2-.1-.7-.3-.8-.1z" />
        <path d="M299.5 130.2l-1.4 5.6-2-3.8v3.9l-4.4-5.2 1.5 5.6-4-3.4 2.2 3.8-7-4.5 4.4 5.2-5.6-2.8 4 3.4-9-3.4 8.7 4.3a29 29 0 0 1 12.6-2.6c4.9 0 9.3 1 12.5 2.6l8.8-4.3-9 3.4 4-3.4-5.5 2.8 4.3-5.2-7 4.5 2.2-3.8-4 3.3 1.5-5.5-4.3 5.2V132l-2 3.8-1.5-5.6z" />
      </g>
    </g>
    <path
      fill="#fff"
      d="M311.3 295l-.3 2.6h-.4l-.1-1.8a9.3 9.3 0 0 0-.5-1.6 7.3 7.3 0 0 0-.5-1.3l-1-1.4.8-2.2a6.6 6.6 0 0 1 1.5 2.4 9.4 9.4 0 0 1 .5 3.2m7-4.2c0 .7-.2 1.2-.5 1.5-.2.3-.6.6-1.3.7l.4 1.5a6.7 6.7 0 0 1 0 2 22.5 22.5 0 0 1-.1 1.3h-.4a8.2 8.2 0 0 0-.1-1.3 5.5 5.5 0 0 0-.2-1l-.4-1a10.5 10.5 0 0 0-.7-1.4l-1-1.7.6-2 1 1c.3.2.6.3 1 .3.8 0 1.2-.4 1.2-1.3h.4v1.4m6.4 4.8l-.5 2.1c-.4 0-.6-.3-.8-.7l-.4-1.3a12.4 12.4 0 0 1-.1-1.7 4 4 0 0 1-1 .2 2 2 0 0 1-1.3-.4 1.3 1.3 0 0 1-.5-1c0-.9.3-1.7.7-2.3.5-.7 1-1 1.5-1.1.5 0 .8.1 1 .4a2 2 0 0 1 .3.9v2c0 .9.1 1.5.3 1.9 0 .3.3.6.8 1m-2-3.5c0-.6-.3-.8-.8-.8a1 1 0 0 0-.6.1c-.2.1-.2.2-.2.3 0 .3.3.5 1 .5l.6-.1m8.7 3l-.3 2.6c-.5-.4-1-1-1.4-2a25.4 25.4 0 0 1-1.3-4.1 52.8 52.8 0 0 1-1.8 5.5 2.9 2.9 0 0 1-.8.7v-2.5c.6-.7.9-1.1 1-1.5a7.6 7.6 0 0 0 .8-1.7l.5-2.7h.4l.9 2.7c.2.6.5 1.2.9 1.6l1 1.4"
    />
    <path
      fill="#bf0000"
      d="M350.8 319.4c.4.4.6.8.7 1.2l.4 1.6-.8.1a7.8 7.8 0 0 0-1-1.5 18.8 18.8 0 0 0-1.1-1.2 46 46 0 0 0-1.7-1.5 34.4 34.4 0 0 0-2-1.7c-.4-.2-.6-.4-.6-.5a1.9 1.9 0 0 1-.3-.8 11.2 11.2 0 0 1-.2-1.6l2.7 2.2a44.3 44.3 0 0 1 2.5 2.2l1.4 1.5m-9.5-5.8l-.2 2H338l.3-2h3m8.4 8.9l-7.6 2.3-1.3-2 6.5-2-.7-.8a2.8 2.8 0 0 0-.9-.6 1.4 1.4 0 0 1-.4 1 2 2 0 0 1-1 .6 3.4 3.4 0 0 1-1.8 0 2 2 0 0 1-1.3-.7 4 4 0 0 1-.7-2.2c0-1 .3-1.6.9-1.8.7-.2 1.8 0 3 .7a8.1 8.1 0 0 1 3 2.4l2.3 3.1m-5.8-4a3.8 3.8 0 0 0-.8-.3 1.1 1.1 0 0 0-.6 0 .7.7 0 0 0-.5.3.5.5 0 0 0 0 .6l.5.2h.6l.4-.3.4-.5m-8-1.6l-.5 2-3.2-.3.5-2 3.1.3m7.5 7.7l-1.7.4a5.3 5.3 0 0 1-1.7 0 3.6 3.6 0 0 1-1.5-.4c-.3.5-.8 1-1.5 1.2a7.4 7.4 0 0 1-1.6.6l-1.2.3-1-2 1.1-.3a9.1 9.1 0 0 0 1.3-.4l.9-.5-1-.5h-.7a.4.4 0 0 0-.2 0 .6.6 0 0 0-.2.3h-.5c-.5-.8-.6-1.5-.3-2s.9-.8 2-1a6.8 6.8 0 0 1 2.6-.2c.8.1 1.3.4 1.5.9.2.2.2.5.2.7l-.4 1.2h.5a2 2 0 0 0 .6 0l1.7-.3 1 2m-8 1.8l-1.6.3a3 3 0 0 1-2.2-.4 5.5 5.5 0 0 1-1.7-2.6l-.8-2.2a2 2 0 0 0-.8-1 4.6 4.6 0 0 0-.9-.5l.6-2.1c.6.3 1 .6 1.4 1l1 1.7.5 1.5 1.1 2.2c.3.3.7.4 1 .3l1.7-.2.7 2m-7-7.5l-1 1.9-3-.7 1-1.9 3 .7m1.8 8.4l-7.5.7-.4-2 6.2-.7a2.3 2.3 0 0 0-.6-.8 8.3 8.3 0 0 0-1-.6l.5-2c.7.4 1.2.9 1.6 1.3.3.5.6 1.2.8 2.1l.4 2m-6 1a17 17 0 0 1-2.2-.2 10.5 10.5 0 0 1-1.7-.5 5.6 5.6 0 0 1-1.3.4 9.9 9.9 0 0 1-1.7 0h-2a2.5 2.5 0 0 1-1.2-.3c-.3-.2-.5-.5-.8-1a4.1 4.1 0 0 1-1.5 1l-1.7.1h-1.7l.2-2.1h1.7c.8 0 1.5 0 2.1-.4a2 2 0 0 0 1.3-1.8l.7.1a30.2 30.2 0 0 0-.1 1.3c0 .3 0 .5.3.7.3.2.6.3 1 .3h1.5c1 0 1.6 0 2-.2.6-.2.9-.5 1-1.1l.1-.4s.3 0 .5-.2l.5-.2v.4a8.9 8.9 0 0 1 0 .3l-.3 1.1a12.4 12.4 0 0 0 2 .5c.1-.2 0-.4-.1-.7l-.3-.6a.5.5 0 0 1 .1-.3l.3-.2 1-.9.5 1v1l-.2 2.9m-11.3-8.7l-2 1.3-1.3-.9-1.4 1-1.9-1 1.8-1.3 1.5.8 1.5-1 1.8 1m-3 8.2l-7.3-1.2.8-2 6.2 1c0-.4 0-.7-.2-1a5.2 5.2 0 0 0-.5-.8l1.6-1.7c.4.6.6 1 .7 1.6 0 .5-.2 1.2-.5 2.1l-.8 2m-6.1-1l-1.6-.3c-.9-.2-1.4-.6-1.5-1.2-.2-.6.1-1.5.8-2.8l1.2-2c.3-.5.4-.9.3-1.2a2.2 2.2 0 0 0-.3-.7l2.2-1.6c.3.5.3 1 .3 1.4 0 .5-.3 1.1-.7 1.8l-.8 1.4a5.8 5.8 0 0 0-.9 2.2c0 .4.2.6.5.7l1.6.4-1.1 2m-3.8-8l-2.5 1.1-1.8-1.7 2.6-1 1.7 1.7m-1 6.6a6.8 6.8 0 0 1-1.6 1.4 4.2 4.2 0 0 1-1.7.6l-2.4-.1a14.8 14.8 0 0 1-2.8-.7 7.7 7.7 0 0 1-3.4-2c-.6-.8-.6-1.5 0-2.2a7 7 0 0 1 2-1.6c.8-.5 2-1 3.8-1.6l.4.5-2.8 1.2c-.5.3-1 .6-1.3 1-.4.4-.3 1 .2 1.6a10.5 10.5 0 0 0 6.3 2.2c1.2 0 2-.3 2.3-.7.3-.3.4-.6.5-1l.2-1.6 2.5-1.5a8 8 0 0 1-.1 1.5 4.4 4.4 0 0 1-1 1.6l-1.2 1.4"
    />
  </svg>
	),
	AG: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-79.7 0H603v512H-79.7z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(74.7) scale(.9375)"
    >
      <path fill="#fff" d="M-120 0h763.3v511.5H-120z" />
      <path d="M-118.3.6h760.9v216.1h-761z" />
      <path fill="#0061ff" d="M21.3 203.2h505V317h-505z" />
      <path
        fill="#e20000"
        d="M642.8 1.8V512H262L642.8 1.7zm-761.5 0V512H262L-118.7 1.7z"
      />
      <path
        fill="#ffd600"
        d="M440.4 203.3L364 184l64.9-49-79.7 11.4 41-69.5-70.7 41L332.3 37l-47.9 63.8-19.3-74-21.7 76.3-47.8-65 13.7 83.2L138.5 78l41 69.5-77.4-12.5 63.8 47.8L86 203.3h354.3z"
      />
    </g>
  </svg>
	),
	AI: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h640v480H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)">
      <path fill="#fff" fillRule="evenodd" d="M.4.4h402.7v240H.4z" />
      <path fill="#c00" d="M.4.4v18l96.1 59.3 36.1 1.3L.5.4z" />
      <path fill="#006" d="M41.6.4l116.5 73V.5H41.6z" />
      <path
        fill="#c00"
        d="M173.6.4v93.3H.4V147h173.2v93.2H227V147h173.2V93.7H226.9V.4h-53.3z"
      />
      <path fill="#006" d="M242.4.4v68.8L356.4 1l-114-.5z" />
      <path fill="#c00" d="M246 76.8l32-.3L402.7.9l-33 .7L246 76.7z" />
      <path
        fill="#006"
        d="M401.3 21l-95 56.7 93.8.4v84.4h-80l79.2 51.5 1.2 26.2-42.3-.6-115.8-68.2v68.8h-84.3v-68.8L49.5 240l-49 .2V480h799.2V.4L402.2 0M.4 27L0 77l84.2 1L.4 27.1zm0 135.5v51l80-50.5-80-.5z"
      />
      <path
        fill="#c00"
        d="M308.2 164.6l-33.3-.3 125.6 75-.8-17.1-91.5-57.6zm-276.6 76l117.8-74.2-31 .3-118 73.8"
      />
      <path fill="#49497d" d="M525.4 247.8l2 2-2-2z" />
      <path fill="#0e0e6e" d="M527.4 247.8l2 2-2-2z" />
      <path fill="#262678" d="M521.3 249.8l2 2-2-2z" />
      <path fill="#808067" d="M523.4 249.8l2 2-2-2z" />
      <path fill="#58587b" d="M529.4 249.8l2 2-2-2z" />
      <path fill="#0e0e6e" d="M454.3 251.9l2 2-2-2z" />
      <path fill="#1b1b74" d="M517.3 251.9l2 2-2-2z" />
      <path fill="#6e6c70" d="M519.3 251.9l2 2-2-2z" />
      <path
        fill="#cc3"
        d="M457.9 255.5c0 52.5-6 111.6 33 152.7 8 8.4 23.4 27.7 36.5 27 13.7-.8 31.4-21.1 39.2-31 34-44.8 28.7-98.2 29.8-150.2-15.3 6.9-23 9.2-36.4 9.1-10 1-25.3-5.6-34.5-10-6 4-14.7 8.8-30.4 9.3-18 .8-23.8-2.3-37.2-6.9z"
      />
      <path fill="#99994e" d="M531.5 251.9l2 2-2-2z" />
      <path fill="#49497d" d="M533.5 251.9l2 2-2-2z" />
      <path fill="#0e0e6e" d="M596.4 251.9l2 2-2-2z" />
      <path fill="#a4a43d" d="M456.4 253.9l2 2-2-2z" />
      <path fill="#6e6c70" d="M458.4 253.9l2 2-2-2z" />
      <path fill="#3a3a7c" d="M460.4 253.9l2 2-2-2z" />
      <path fill="#1b1b74" d="M513.2 253.9l2 2-2-2z" />
      <path fill="#6e6c70" d="M515.2 253.9l2 2-2-2z" />
      <path fill="#a4a43d" d="M517.3 253.9l2 2-2-2z" />
      <path fill="#d0d045" d="M525.4 253.9l2 2-2-2z" />
      <path fill="#a4a43d" d="M533.5 253.9l2 2-2-2z" />
      <path fill="#8d8d5b" d="M535.5 253.9l2 2-2-2z" />
      <path fill="#3a3a7c" d="M537.6 253.9l2 2-2-2z" />
      <path fill="#262678" d="M590.3 253.9l2 2-2-2z" />
      <path fill="#53527c" d="M592.4 253.9l2 2-2-2z" />
      <path fill="#8d8d5b" d="M594.4 253.9l2 2-2-2z" />
      <path fill="#737370" d="M464.5 256l2 2-2-2z" />
      <path fill="#53527c" d="M466.5 256l2 2-2-2z" />
      <path fill="#1b1b74" d="M468.5 256l2 2-2-2z" />
      <path fill="#262678" d="M509.1 256l2 2-2-2z" />
      <path fill="#6e6c70" d="M511.2 256l2 2-2-2z" />
      <path fill="#a4a43d" d="M513.2 256l2 2-2-2z" />
      <path fill="#e5e59d" d="M523.4 256l2 2-2-2z" />
      <path
        fill="#fff"
        d="M462 261.2c-1 27.6-.2 58.6 4.1 88.1 4.8 15.4 4.1 23.9 11.2 33.1l99-.8c6-9.7 10.5-24.4 11-30.3 5.6-29.7 5.7-62.6 5.9-92a62 62 0 0 1-35.7 7.4 69 69 0 0 1-30.5-9.2c-9.5 5.6-12.8 8.2-28.4 8.9-12.2.6-22 1.6-36.6-5.2z"
      />
      <path fill="#f2f1d7" d="M527.4 256l2 2-2-2z" />
      <path fill="#d9d868" d="M529.4 256l2 2-2-2z" />
      <path fill="#a4a43d" d="M537.6 256l2 2-2-2z" />
      <path fill="#99994e" d="M539.6 256l2 2-2-2z" />
      <path fill="#49497d" d="M541.6 256l2 2-2-2z" />
      <path fill="#0e0e6e" d="M543.6 256l2 2-2-2z" />
      <path fill="#3a3a7c" d="M584.3 256l2 2-2-2z" />
      <path fill="#667" d="M586.3 256l2 2-2-2z" />
      <path fill="#99994e" d="M588.3 256l2 2-2-2z" />
      <path fill="#a4a43d" d="M590.3 256l2 2-2-2m-121.8 2l2 2-2-2z" />
      <path fill="#99994e" d="M470.6 258l2 2-2-2z" />
      <path fill="#6e6c70" d="M472.6 258l2 2-2-2z" />
      <path fill="#49497d" d="M474.6 258l2 2-2-2z" />
      <path fill="#1b1b74" d="M476.6 258l2 2-2-2m26.4 0l2 2-2-2z" />
      <path fill="#53527c" d="M505 258l2.1 2-2-2z" />
      <path fill="#8d8d5b" d="M507.1 258l2 2-2-2z" />
      <path fill="#a4a43d" d="M509.1 258l2 2-2-2z" />
      <path fill="#e5e59d" d="M519.3 258l2 2-2-2z" />
      <path fill="#fbfaf2" d="M521.3 258l2 2-2-2z" />
      <path fill="#f2f1d2" d="M531.5 258l2 2-2-2z" />
      <path fill="#d9d868" d="M533.5 258l2 2-2-2z" />
      <path fill="#a4a43d" d="M543.6 258l2 2-2-2z" />
      <path fill="#6e6c70" d="M545.7 258l2 2-2-2z" />
      <path fill="#3a3a7c" d="M547.7 258l2 2-2-2z" />
      <path fill="#0e0e6e" d="M574.1 258l2 2-2-2z" />
      <path fill="#32327b" d="M576.1 258l2 2-2-2z" />
      <path fill="#58587b" d="M578.2 258l2 2-2-2z" />
      <path fill="#808067" d="M580.2 258l2 2-2-2z" />
      <path fill="#a4a43d" d="M583.6 258.6l1.3.7-1.3-.7z" />
      <path fill="#dddc7a" d="M460.4 260l2 2-2-2z" />
      <path fill="#d0d045" d="M462.4 260l2 2-2-2z" />
      <path fill="#a4a43d" d="M478 260.6l1.4.7-1.4-.7z" />
      <path fill="#808067" d="M480.7 260l2 2-2-2z" />
      <path fill="#667" d="M482.7 260l2 2-2-2z" />
      <path fill="#58587b" d="M484.8 260l2 2-2-2z" />
      <path fill="#49497d" d="M486.8 260l2 2-2-2z" />
      <path fill="#737370" d="M499 260l2 2-2-2z" />
      <path fill="#99994e" d="M501 260l2 2-2-2z" />
      <path fill="#a4a43d" d="M503 260l2 2-2-2z" />
      <path fill="#e5e59d" d="M515.2 260l2 2-2-2z" />
      <path fill="#fbfaf2" d="M517.3 260l2 2-2-2z" />
      <path fill="#f2f1d2" d="M535.5 260l2 2-2-2z" />
      <path fill="#d9d868" d="M537.6 260l2 2-2-2z" />
      <path fill="#a4a43d" d="M549 260.6l1.4.7-1.3-.7z" />
      <path fill="#808067" d="M551.8 260l2 2-2-2z" />
      <path fill="#667" d="M553.8 260l2 2-2-2z" />
      <path fill="#58587b" d="M555.8 260l2 2-2-2z" />
      <path fill="#3a3a7c" d="M557.9 260l2 2-2-2z" />
      <path fill="#58587b" d="M567.3 260.6l1.4.7-1.4-.7z" />
      <path fill="#737370" d="M570 260l2 2-2-2z" />
      <path fill="#99994e" d="M572 260l2.1 2-2-2z" />
      <path fill="#a4a43d" d="M574.1 260l2 2-2-2z" />
      <path fill="#dddc7a" d="M590.3 260l2 2-2-2z" />
      <path fill="#d0d045" d="M592.4 260l2 2-2-2z" />
      <path fill="#f2f1d7" d="M464.5 262l2 2-2-2z" />
      <path fill="#e0dea1" d="M466.5 262l2 2-2-2z" />
      <path fill="#dddc7a" d="M468.5 262l2 2-2-2z" />
      <path fill="#d9d868" d="M509.1 262l2 2-2-2z" />
      <path fill="#e5e3af" d="M511.2 262l2 2-2-2z" />
      <path fill="#f6f6e4" d="M539.6 262l2 2-2-2z" />
      <path fill="#e1e18c" d="M541.6 262l2 2-2-2z" />
      <path fill="#d4d456" d="M582.2 262l2 2-2-2z" />
      <path fill="#e1e18c" d="M584.3 262l2 2-2-2z" />
      <path fill="#eeedc1" d="M586.3 262l2 2-2-2z" />
      <path fill="#f2f1d2" d="M472.6 264l2 2-2-2z" />
      <path fill="#e0dea1" d="M474.6 264l2 2-2-2z" />
      <path fill="#dddc7a" d="M476.6 264l2 2-2-2z" />
      <path fill="#d0d045" d="M478.7 264l2 2-2-2z" />
      <path fill="#dddc7a" d="M503 264l2 2-2-2z" />
      <path fill="#e5e3af" d="M505 264l2.1 2-2-2z" />
      <path fill="#f6f6e4" d="M507.1 264l2 2-2-2z" />
      <path fill="#eeedc1" d="M545.7 264l2 2-2-2z" />
      <path fill="#e1e18c" d="M547.7 264l2 2-2-2z" />
      <path fill="#d4d456" d="M549.7 264l2 2-2-2z" />
      <path fill="#d9d868" d="M574.1 264l2 2-2-2z" />
      <path fill="#e1e18c" d="M576.1 264l2 2-2-2z" />
      <path fill="#eeedc1" d="M578.2 264l2 2-2-2z" />
      <path fill="#f6f6e4" d="M580.2 264l2 2-2-2z" />
      <path fill="#f2f1d7" d="M482.7 266l2 2.1-2-2z" />
      <path fill="#f2f1d2" d="M484.8 266l2 2.1-2-2z" />
      <path fill="#eeedc1" d="M486.8 266l2 2.1-2-2z" />
      <path fill="#f2f1d2" d="M496.3 266.7l1.3.7-1.3-.7z" />
      <path fill="#fbfaf2" d="M499 266l2 2.1-2-2z" />
      <path fill="#fef8f1" d="M509.1 266l4 4.1v-4h-4z" />
      <path fill="#f2f1d7" d="M553.8 266l2 2.1-2-2z" />
      <path fill="#f2f1d2" d="M555.8 266l2 2.1-2-2z" />
      <path fill="#e5e3af" d="M557.9 266l2 2.1-2-2z" />
      <path fill="#e5e59d" d="M561.3 266.7l1.3.7-1.4-.7z" />
      <path fill="#e0dea1" d="M564 266l2 2.1-2-2z" />
      <path fill="#f2f1d2" d="M567.3 266.7l1.4.7-1.4-.7z" />
      <path fill="#fbfaf2" d="M570 266l2 2.1-2-2z" />
      <path fill="#fef8f1" d="M505 268.1l2.1 2-2-2z" />
      <path fill="#fbbe66" d="M507.1 268.1l2 2-2-2z" />
      <path fill="#fbc477" d="M505 270.1l2.1 2-2-2z" />
      <path fill="#fcb144" d="M509.1 270.1l2 2-2-2z" />
      <path fill="#fe9f11" d="M505 272.2l2.1 2-2-2z" />
      <path fill="#fea522" d="M509.1 272.2l2 2-2-2z" />
      <path fill="#fae3c9" d="M503 274.2l2 2-2-2m8.2 0l2 2-2-2z" />
      <path fill="#fbead6" d="M521.3 274.2l2 2-2-2z" />
      <path fill="#f9d6aa" d="M523.4 274.2l2 2-2-2z" />
      <path fill="#fae3c9" d="M531.5 274.2l2 2-2-2z" />
      <path fill="#fef8f1" d="M533.5 274.2l2 2-2-2z" />
      <path fill="#f9d099" d="M503 276.2l2 2-2-2z" />
      <path fill="#fdab33" d="M511.2 276.2l2 2-2-2z" />
      <path fill="#fcf1e4" d="M515.2 276.2l2 2-2-2z" />
      <path fill="#fbc477" d="M517.3 276.2l2 2-2-2z" />
      <path fill="#fea522" d="M519.3 276.2l2 2-2-2z" />
      <path fill="#fcb755" d="M535.5 276.2l2 2-2-2z" />
      <path fill="#f9d6aa" d="M537.6 276.2l2 2-2-2z" />
      <path fill="#faca88" d="M503 278.3l2 2-2-2z" />
      <path fill="#fea522" d="M513.2 278.3l2 2-2-2m26.4 0l2 2-2-2z" />
      <path fill="#f8dcbb" d="M541.6 278.3l2 2-2-2z" />
      <path fill="#f6f6e4" d="M460.4 280.3l2 2-2-2z" />
      <path fill="#fbc477" d="M503 280.3l2 2-2-2z" />
      <path fill="#fbbe66" d="M543.6 280.3l2 2-2-2z" />
      <path fill="#f8dcbb" d="M545.7 280.3l2 2-2-2z" />
      <path fill="#faca88" d="M503 282.3l2 2-2-2z" />
      <path fill="#fcb755" d="M549.7 282.3l2 2-2-2z" />
      <path fill="#f8dcbb" d="M551.8 282.3l2 2-2-2z" />
      <path fill="#fef8f1" d="M501 284.4l2 2-2-2z" />
      <path fill="#fe9f11" d="M503 284.4l2 2-2-2z" />
      <path fill="#fdab33" d="M559.9 284.4l2 2-2-2z" />
      <path fill="#fcb144" d="M562 284.4l2 2-2-2z" />
      <path fill="#fbc477" d="M564 284.4l2 2-2-2z" />
      <path fill="#f9d6aa" d="M566 284.4l4 4-4-4z" />
      <path fill="#fef8f1" d="M568 284.4l2 2-2-2z" />
      <path fill="#fcb144" d="M501 286.4l2 2-2-2z" />
      <path fill="#fdab33" d="M529.4 286.4l2 2-2-2z" />
      <path fill="#fbc477" d="M531.5 286.4l2 2-2-2zm8 0l2.1 2-2-2z" />
      <path fill="#fea522" d="M541.6 286.4l2 2-2-2z" />
      <path fill="#fae3c9" d="M499 288.4l2 2-2-2z" />
      <path fill="#fcb144" d="M525.4 288.4l2 2-2-2z" />
      <path fill="#fae3c9" d="M527.4 288.4l2 2-2-2z" />
      <path fill="#f8dcbb" d="M543.6 288.4l2 2-2-2z" />
      <path fill="#fdab33" d="M545.7 288.4l2 2-2-2z" />
      <path fill="#fe9f11" d="M557.9 288.4l2 2-2-2z" />
      <path fill="#fcb755" d="M559.9 288.4l2 2-2-2z" />
      <path fill="#f9d099" d="M562 288.4l2 2-2-2z" />
      <path fill="#fbead6" d="M564 288.4l2 2-2-2z" />
      <path fill="#fcb144" d="M499 290.4l2 2-2-2z" />
      <path fill="#fbbe66" d="M523.4 290.4l2 2-2-2z" />
      <path fill="#f9d099" d="M547.7 290.4l2 2-2-2z" />
      <path fill="#fbead6" d="M555.8 290.4l2 2-2-2z" />
      <path fill="#fcf1e4" d="M497 292.5l2 2-2-2z" />
      <path fill="#fbbe66" d="M521.3 292.5l2 2-2-2z" />
      <path fill="#f9d099" d="M549.7 292.5l2 2-2-2z" />
      <path fill="#fae3c9" d="M555.8 292.5l2 2-2-2z" />
      <path fill="#fbc477" d="M497 294.5l2 2-2-2z" />
      <path fill="#fcb144" d="M519.3 294.5l2 2-2-2m32.5 0l2 2-2-2z" />
      <path fill="#fbbe66" d="M555.8 294.5l2 2-2-2z" />
      <path fill="#f6f6e4" d="M460.4 296.5l2 2-2-2z" />
      <path fill="#fea522" d="M497 296.5l2 2-2-2z" />
      <path fill="#fbead6" d="M519.3 296.5l2 2-2-2z" />
      <path fill="#fcf1e4" d="M551.8 296.5l2 2-2-2z" />
      <path fill="#fef8f1" d="M557.9 296.5l2 2-2-2z" />
      <path fill="#fcf1e4" d="M495 298.6l2 2-2-2z" />
      <path fill="#fbbe66" d="M517.3 298.6l2 2-2-2z" />
      <path fill="#faca88" d="M553.8 298.6l2 2-2-2z" />
      <path fill="#f9d099" d="M557.9 298.6l2 2-2-2z" />
      <path fill="#f9d6aa" d="M495 300.6l2 2-2-2z" />
      <path fill="#fcf1e4" d="M517.3 300.6l2 2-2-2z" />
      <path fill="#fae3c9" d="M527.4 300.6l2 2-2-2z" />
      <path fill="#fea522" d="M529.4 300.6l2 2-2-2z" />
      <path fill="#fcb144" d="M531.5 300.6l2 2-2-2z" />
      <path fill="#f9d6aa" d="M533.5 300.6l2 2-2-2z" />
      <path fill="#fef8f1" d="M553.8 300.6l2 2-2-2z" />
      <path fill="#fea522" d="M555.8 300.6l2 2-2-2z" />
      <path fill="#fdab33" d="M557.9 300.6l2 2-2-2z" />
      <path fill="#faca88" d="M495 302.6l-2.1 6.1 2-6z" />
      <path fill="#fea522" d="M515.2 302.6l2 2-2-2z" />
      <path fill="#fef8f1" d="M517.3 302.6l2 2-2-2z" />
      <path fill="#f9d099" d="M527.4 302.6l2 2-2-2z" />
      <path fill="#fdab33" d="M535.5 302.6l2 2-2-2z" />
      <path fill="#fae3c9" d="M537.6 302.6l2 2-2-2z" />
      <path fill="#f8dcbb" d="M555.8 302.6l2 2-2-2z" />
      <path fill="#f90" d="M557.9 302.6l2 2-2-2z" />
      <path fill="#fbead6" d="M560.6 304l.6 1.3-.6-1.3z" />
      <path fill="#fea522" d="M519.3 304.6l2 2-2-2z" />
      <path fill="#fbbe66" d="M521.3 304.6l2 2-2-2z" />
      <path fill="#faca88" d="M523.4 304.6l2 2-2-2z" />
      <path fill="#fcb144" d="M525.4 304.6l2 2-2-2z" />
      <path fill="#fae3c9" d="M527.4 304.6l2 2-2-2z" />
      <path fill="#fe9f11" d="M529.4 304.6l2 2-2-2z" />
      <path fill="#fdab33" d="M539.6 304.6l2 2-2-2z" />
      <path fill="#fbc477" d="M541.6 304.6l2 2-2-2z" />
      <path fill="#faca88" d="M543.6 304.6l2 2-2-2z" />
      <path fill="#f9d6aa" d="M545.7 304.6l2 2-2-2z" />
      <path fill="#fae3c9" d="M549 305.3l1.4.7-1.3-.7z" />
      <path fill="#fef8f1" d="M551.8 304.6l2 2-2-2z" />
      <path fill="#fbc477" d="M557.9 304.6l2 2-2-2z" />
      <path fill="#fef8f1" d="M470.6 306.7l2 2-2-2z" />
      <path fill="#fcf1e4" d="M472.6 306.7l2 2-2-2z" />
      <path fill="#fcb755" d="M525.4 306.7l2 2-2-2z" />
      <path fill="#fbead6" d="M529.4 306.7l2 2-2-2z" />
      <path fill="#fea522" d="M531.5 306.7l2 2-2-2z" />
      <path fill="#fe9f11" d="M547.7 306.7l2 2-2-2z" />
      <path fill="#fcb144" d="M549.7 306.7l-2 4 2-4z" />
      <path fill="#fe9f11" d="M553.8 306.7l2 2-2-2z" />
      <path fill="#fbbe66" d="M555.8 306.7l2 2-2-2z" />
      <path fill="#fcf1e4" d="M557.9 306.7l2 2-2-2z" />
      <path fill="#fae3c9" d="M470.6 308.7l2 2-2-2z" />
      <path fill="#fe9f11" d="M472.6 308.7l4 4-4-4z" />
      <path fill="#fbead6" d="M474.6 308.7l2 2-2-2zm18.3 0l2 2-2-2z" />
      <path fill="#fae3c9" d="M495 308.7l2 2-2-2z" />
      <path fill="#fe9f11" d="M513.2 308.7l2 2-2-2z" />
      <path fill="#fbc477" d="M515.2 308.7l2 2-2-2z" />
      <path fill="#fea522" d="M517.3 308.7l2 2-2-2z" />
      <path fill="#fbc477" d="M523.4 308.7l2 2-2-2z" />
      <path fill="#fef8f1" d="M525.4 308.7l2 2-2-2z" />
      <path fill="#fbc477" d="M533.5 308.7l2 2-2-2z" />
      <path fill="#fff" d="M549.7 308.7l2 2-2-2z" />
      <path fill="#fdab33" d="M551.8 308.7l2 2-2-2z" />
      <path fill="#fbc477" d="M559.9 308.7l2 2-2-2z" />
      <path fill="#fef8f1" d="M470.6 310.7l2 2-2-2z" />
      <path fill="#fbead6" d="M476.6 310.7l2 2-2-2z" />
      <path fill="#f9d6aa" d="M486.8 310.7l2 2-2-2z" />
      <path fill="#fe9f11" d="M497 310.7l2 2-2-2z" />
      <path fill="#f9d6aa" d="M500.3 311.4l1.4.7-1.4-.7z" />
      <path fill="#f8dcbb" d="M513.2 310.7l2 2-2-2z" />
      <path fill="#fcf1e4" d="M519.3 310.7l2 2-2-2z" />
      <path fill="#f9d6aa" d="M535.5 310.7l2 2-2-2z" />
      <path fill="#fdab33" d="M549.7 310.7l2 2-2-2z" />
      <path fill="#fcb755" d="M562 310.7l2 2-2-2z" />
      <path fill="#fef8f1" d="M564 310.7l2 2-2-2z" />
      <path fill="#53527c" d="M454.3 312.8l2 2-2-2z" />
      <path fill="#fcb755" d="M472.6 312.8l2 2-2-2z" />
      <path fill="#fea522" d="M476.6 312.8l2 2-2-2z" />
      <path fill="#fbead6" d="M484.8 312.8l2 2-2-2z" />
      <path fill="#fe9f11" d="M488.8 312.8l2 2-2-2z" />
      <path fill="#fcf1e4" d="M490.9 312.8l2 2-2-2z" />
      <path fill="#fbbe66" d="M497 312.8l2 2-2-2z" />
      <path fill="#fbc477" d="M499 312.8l2 2-2-2z" />
      <path fill="#fbbe66" d="M501 312.8l2 2-2-2z" />
      <path fill="#fea522" d="M511.2 312.8l2 2-2-2z" />
      <path fill="#f9d6aa" d="M537.6 312.8l2 2-2-2z" />
      <path fill="#fcb144" d="M564 312.8l2 2-2-2z" />
      <path fill="#8d8d5b" d="M596.4 312.8l2 2-2-2z" />
      <path fill="#e5e3af" d="M460.4 314.8l2 2-2-2z" />
      <path fill="#f8dcbb" d="M472.6 314.8l2 2-2-2z" />
      <path fill="#fdab33" d="M478.7 314.8l2 2-2-2z" />
      <path fill="#fe9f11" d="M484.8 314.8l2 2-2-2z" />
      <path fill="#faca88" d="M488.8 314.8l2 2-2-2z" />
      <path fill="#fcf1e4" d="M497 314.8l2 2-2-2z" />
      <path fill="#f9d099" d="M511.2 314.8l2 2-2-2m28.4 0l2 2-2-2z" />
      <path fill="#fbbe66" d="M566 314.8l2 2-2-2z" />
      <path fill="#fea522" d="M474.6 316.8l2 2-2-2z" />
      <path fill="#fdab33" d="M480.7 316.8l2 2-2-2z" />
      <path fill="#fea522" d="M482.7 316.8l2 2-2-2z" />
      <path fill="#fe9f11" d="M486.8 316.8l2 2-2-2z" />
      <path fill="#fef8f1" d="M488.8 316.8l2 2-2-2z" />
      <path fill="#fbbe66" d="M499 316.8l2 2-2-2z" />
      <path fill="#fef8f1" d="M511.2 316.8l2 2-2-2z" />
      <path fill="#fbbe66" d="M541.6 316.8l2 2-2-2z" />
      <path fill="#f9d099" d="M568 316.8l2 2-2-2z" />
      <path fill="#f9d6aa" d="M474.6 318.9l2 2-2-2z" />
      <path fill="#f9d099" d="M486.8 318.9l2 2-2-2z" />
      <path fill="#fcf1e4" d="M499 318.9l2 2-2-2z" />
      <path fill="#fdab33" d="M509.1 318.9l2 2-2-2m34.5 0l2 2-2-2z" />
      <path fill="#fbead6" d="M570 318.9l2 2-2-2z" />
      <path fill="#fea522" d="M476.6 320.9l2 2-2-2z" />
      <path fill="#fe9f11" d="M484.8 320.9l2 2-2-2z" />
      <path fill="#fcb144" d="M501 320.9l2 2-2-2z" />
      <path fill="#faca88" d="M509.1 320.9l2 2-2-2z" />
      <path fill="#f8dcbb" d="M543.6 320.9l2 2-2-2z" />
      <path fill="#fcb144" d="M570 320.9l2 2-2-2z" />
      <path fill="#d3d079" d="M460.4 323l2 2-2-2z" />
      <path fill="#faca88" d="M476.6 323l2 2-2-2zm24.4 0l2 2-2-2z" />
      <path fill="#fae3c9" d="M509.1 323l2 2-2-2m34.5 0l2 2-2-2z" />
      <path fill="#f8dcbb" d="M572 323l2.1 2-2-2z" />
      <path fill="#f2f1d7" d="M590.3 323l2 2-2-2z" />
      <path fill="#58587b" d="M597.1 324.3l.7 1.3-.7-1.3z" />
      <path fill="#d9d868" d="M461 326.3l.8 1.4-.7-1.4z" />
      <path fill="#f8dcbb" d="M476.6 325l2 2-2-2z" />
      <path fill="#f9d6aa" d="M541.6 325l2 2-2-2z" />
      <path fill="#fe9f11" d="M543.6 325l2 2-2-2z" />
      <path fill="#fcb144" d="M572 325l2.1 2-2-2z" />
      <path fill="#f2f1d2" d="M591 326.3l.7 1.4-.7-1.4z" />
      <path fill="#fcf1e4" d="M476.6 327l2 2-2-2z" />
      <path fill="#fef8f1" d="M539.6 327l2 2-2-2z" />
      <path fill="#fe9f11" d="M541.6 327l2 2-2-2z" />
      <path fill="#fdab33" d="M547.7 327l-2 4 2-4z" />
      <path fill="#fcb755" d="M549.7 327l2 2-2-2z" />
      <path fill="#fea522" d="M574.1 327l2 2-2-2z" />
      <path fill="#f9d099" d="M576.1 327l2 2-2-2z" />
      <path fill="#53527c" d="M596.4 327l2 2-2-2z" />
      <path fill="#808067" d="M457 330.4l.7 1.3-.7-1.3z" />
      <path fill="#fea522" d="M478.7 329l2 2-2-2m6 0l2.1 2-2-2z" />
      <path fill="#fe9f11" d="M507.1 329l2 2-2-2z" />
      <path fill="#fae3c9" d="M539.6 329l2 2-2-2z" />
      <path fill="#fef8f1" d="M547.7 329l2 2-2-2z" />
      <path fill="#fcb144" d="M551.8 329l2 2-2-2z" />
      <path fill="#fcb755" d="M578.2 329l2 2-2-2z" />
      <path fill="#fef8f1" d="M580.2 329l4 4-4-4z" />
      <path fill="#e5e59d" d="M591 330.4l.7 1.3-.7-1.3z" />
      <path fill="#32327b" d="M597.1 330.4l.7 1.3-.7-1.3z" />
      <path fill="#fcb755" d="M479.4 332.4l.6 1.4-.6-1.4z" />
      <path fill="#fef8f1" d="M486.8 331l2 2-2-2z" />
      <path fill="#fbbe66" d="M507.1 331l2 2-2-2z" />
      <path fill="#fbead6" d="M539.6 331l2 2-2-2z" />
      <path fill="#fe9f11" d="M543.6 331l2 2-2-2z" />
      <path fill="#fcf1e4" d="M545.7 331l2 2-2-2z" />
      <path fill="#fbead6" d="M551.8 331l2 2-2-2z" />
      <path fill="#fdab33" d="M580.2 331l2 2-2-2z" />
      <path fill="#667" d="M456.4 333l2 2.1-2-2z" />
      <path fill="#f6f6e4" d="M462.4 333l2 2.1-2-2z" />
      <path fill="#f9d6aa" d="M486.8 333l2 2.1-2-2z" />
      <path fill="#fdab33" d="M503 333l2 2.1-2-2z" />
      <path fill="#fe9f11" d="M505 333l2.1 2.1-2-2z" />
      <path fill="#fcf1e4" d="M507.1 333l2 2.1-2-2z" />
      <path fill="#fea522" d="M541.6 333l2 2.1-2-2z" />
      <path fill="#faca88" d="M543.6 333l2 2.1-2-2m10.2 0l2 2-2-2z" />
      <path fill="#fcb144" d="M582.2 333l2 2.1-2-2z" />
      <path fill="#dddc7a" d="M590.3 333l2 2.1-2-2z" />
      <path fill="#58587b" d="M456.4 335.1l2 2-2-2z" />
      <path fill="#f2f1d2" d="M462.4 335.1l2 2-2-2z" />
      <path fill="#fcb144" d="M479.4 336.5l.6 1.3-.6-1.3z" />
      <path fill="#fea522" d="M486.8 335.1l2 2-2-2z" />
      <path fill="#fef8f1" d="M507.1 335.1l2 2-2-2z" />
      <path fill="#fea522" d="M509.1 335.1l2 2-2-2z" />
      <path fill="#fcb144" d="M513.2 335.1l2 2-2-2z" />
      <path fill="#fbead6" d="M515.2 335.1l2 2-2-2z" />
      <path fill="#f8dcbb" d="M541.6 335.1l2 2-2-2z" />
      <path fill="#fcf1e4" d="M543.6 335.1l2 2-2-2z" />
      <path fill="#fef8f1" d="M553.8 335.1l2 2-2-2z" />
      <path fill="#fe9f11" d="M555.8 335.1l2 2-2-2z" />
      <path fill="#fbead6" d="M584.3 335.1l2 2-2-2z" />
      <path fill="#d9d868" d="M590.3 335.1l2 2-2-2z" />
      <path fill="#3a3a7c" d="M456.4 337.1l2 2-2-2z" />
      <path fill="#e5e3af" d="M462.4 337.1l2 2-2-2z" />
      <path fill="#faca88" d="M488.8 337.1l2 2-2-2z" />
      <path fill="#fbead6" d="M509.1 337.1l2 2-2-2z" />
      <path fill="#fe9f11" d="M515.2 337.1l2 2-2-2z" />
      <path fill="#fcf1e4" d="M517.3 337.1l2 2-2-2z" />
      <path fill="#fbead6" d="M539.6 337.1l2 2-2-2z" />
      <path fill="#fae3c9" d="M541.6 337.1l2 2-2-2z" />
      <path fill="#fbead6" d="M543.6 337.1l2 2-2-2z" />
      <path fill="#fbbe66" d="M555.8 337.1l2 2-2-2m16.3 0l2 2-2-2z" />
      <path fill="#fcf1e4" d="M574.1 337.1l2 2-2-2z" />
      <path fill="#fef8f1" d="M576.1 337.1l2 2-2-2z" />
      <path fill="#f8dcbb" d="M578.2 337.1l2 2-2-2z" />
      <path fill="#fcb755" d="M580.2 337.1l2 2-2-2z" />
      <path fill="#fae3c9" d="M584.3 337.1l2 2-2-2z" />
      <path fill="#808067" d="M594.4 337.1l2 2-2-2z" />
      <path fill="#32327b" d="M456.4 339.2l2 2-2-2z" />
      <path fill="#a4a43d" d="M459 340.5l.7 1.4-.6-1.4z" />
      <path fill="#e5e59d" d="M462.4 339.2l2 2-2-2z" />
      <path fill="#fbc477" d="M478.7 339.2l2 2-2-2z" />
      <path fill="#f9d6aa" d="M490.9 339.2l2 2-2-2z" />
      <path fill="#fbbe66" d="M511.2 339.2l2 2-2-2z" />
      <path fill="#f9d099" d="M517.3 339.2l2 2-2-2z" />
      <path fill="#fae3c9" d="M535.5 339.2l2 2-2-2z" />
      <path fill="#fcb144" d="M537.6 339.2l2 2-2-2z" />
      <path fill="#fae3c9" d="M545.7 339.2l2 2-2-2z" />
      <path fill="#f8dcbb" d="M555.8 339.2l2 2-2-2z" />
      <path fill="#f9d099" d="M572 339.2l2.1 2-2-2z" />
      <path fill="#fbc477" d="M582.2 339.2l2 2-2-2z" />
      <path fill="#fbead6" d="M584.3 339.2l2 2-2-2z" />
      <path fill="#737370" d="M594.4 339.2l2 2-2-2z" />
      <path fill="#d9d868" d="M462.4 341.2l2 2-2-2z" />
      <path fill="#f9d099" d="M478.7 341.2l2 2-2-2z" />
      <path fill="#f9d6aa" d="M492.9 341.2l2 2-2-2m18.3 0l2 2-2-2z" />
      <path fill="#fbc477" d="M517.3 341.2l2 2-2-2z" />
      <path fill="#fef8f1" d="M527.4 341.2l2 2-2-2z" />
      <path fill="#f8dcbb" d="M529.4 341.2l2 2-2-2z" />
      <path fill="#fbc477" d="M531.5 341.2l2 2-2-2z" />
      <path fill="#fea522" d="M533.5 341.2l2 2-2-2z" />
      <path fill="#fbead6" d="M545.7 341.2l2 2-2-2z" />
      <path fill="#f2f1d2" d="M588.3 341.2l2 2-2-2z" />
      <path fill="#58587b" d="M594.4 341.2l2 2-2-2z" />
      <path fill="#99994e" d="M458.4 343.2l2 2-2-2z" />
      <path fill="#d0d045" d="M462.4 343.2l2 2-2-2z" />
      <path fill="#fcb144" d="M495 343.2l2 2-2-2z" />
      <path fill="#fae3c9" d="M497 343.2l2 2-2-2z" />
      <path fill="#fef8f1" d="M511.2 343.2l2 2-2-2z" />
      <path fill="#fcb755" d="M519.3 343.2l2 2-2-2z" />
      <path fill="#fbc477" d="M521.3 343.2l2 2-2-2z" />
      <path fill="#fcb144" d="M523.4 343.2l2 2-2-2z" />
      <path fill="#fea522" d="M525.4 343.2l2 2-2-2z" />
      <path fill="#fe9f11" d="M541.6 343.2l2 2-2-2z" />
      <path fill="#f9d6aa" d="M543.6 343.2l2 2-2-2z" />
      <path fill="#fef8f1" d="M572 343.2l2.1 2-2-2z" />
      <path fill="#e0dea1" d="M588.3 343.2l2 2-2-2z" />
      <path fill="#3a3a7c" d="M594.4 343.2l2 2-2-2z" />
      <path fill="#737370" d="M458.4 345.3l2 2-2-2z" />
      <path fill="#fbfaf2" d="M464.5 345.3l2 2-2-2z" />
      <path fill="#fea522" d="M480.7 345.3l2 2-2-2z" />
      <path fill="#fe9f11" d="M499 345.3l2 2-2-2z" />
      <path fill="#fcb144" d="M501 345.3l2 2-2-2z" />
      <path fill="#fbc477" d="M503 345.3l2 2-2-2z" />
      <path fill="#faca88" d="M505 345.3l2.1 2-2-2z" />
      <path fill="#fbc477" d="M507.1 345.3l2 2-2-2z" />
      <path fill="#fcb144" d="M509.1 345.3l2 2-2-2z" />
      <path fill="#fdab33" d="M511.2 345.3l2 2-2-2z" />
      <path fill="#fbc477" d="M539.6 345.3l2 2-2-2z" />
      <path fill="#fef8f1" d="M541.6 345.3l2 2-2-2z" />
      <path fill="#fdab33" d="M570 345.3l2 2-2-2z" />
      <path fill="#e1e18c" d="M588.3 345.3l2 2-2-2z" />
      <path fill="#a4a43d" d="M593 346.6l.7 1.4-.7-1.4z" />
      <path fill="#262678" d="M594.4 345.3l2 2-2-2z" />
      <path fill="#58587b" d="M458.4 347.3l2 2-2-2z" />
      <path fill="#f2f1d2" d="M464.5 347.3l2 2-2-2z" />
      <path fill="#faca88" d="M480.7 347.3l2 2-2-2z" />
      <path fill="#fe9f11" d="M535.5 347.3l2 2-2-2z" />
      <path fill="#fbead6" d="M537.6 347.3l2 2-2-2z" />
      <path fill="#fbc477" d="M555.8 347.3l2 2-2-2z" />
      <path fill="#faca88" d="M570 347.3l2 2-2-2z" />
      <path fill="#d4d456" d="M588.3 347.3l2 2-2-2z" />
      <path fill="#32327b" d="M458.4 349.3l2 2-2-2z" />
      <path fill="#e5e59d" d="M464.5 349.3l2 2-2-2z" />
      <path fill="#fef8f1" d="M480.7 349.3l2 2-2-2z" />
      <path fill="#fe9f11" d="M482.7 349.3l2 2-2-2z" />
      <path fill="#fbead6" d="M535.5 349.3l2 2-2-2z" />
      <path fill="#fea522" d="M555.8 349.3l2 2-2-2z" />
      <path fill="#fcf1e4" d="M570 349.3l2 2-2-2z" />
      <path fill="#808067" d="M592.4 349.3l2 2-2-2z" />
      <path fill="#0e0e6e" d="M458.4 351.3l2 2-2-2z" />
      <path fill="#a4a43d" d="M460.4 351.3l2 2-2-2z" />
      <path fill="#d9d868" d="M464.5 351.3l2 2-2-2z" />
      <path fill="#f8dcbb" d="M482.7 351.3l2 2-2-2z" />
      <path fill="#f9d6aa" d="M553.8 351.3l2 2-2-2z" />
      <path fill="#faca88" d="M568 351.3l2 2-2-2z" />
      <path fill="#f2f1d2" d="M586.3 351.3l2 2-2-2z" />
      <path fill="#58587b" d="M592.4 351.3l2 2-2-2z" />
      <path fill="#8d8d5b" d="M460.4 353.4l2 2-2-2z" />
      <path fill="#f9d6aa" d="M484.8 353.4l2 2-2-2z" />
      <path fill="#fdab33" d="M525.4 353.4l2 2-2-2z" />
      <path fill="#fff" d="M527.4 353.4l2 2-2-2z" />
      <path fill="#fcb144" d="M530.8 354l1.4.7-1.4-.7z" />
      <path fill="#fef8f1" d="M551.8 353.4l-2 4 2-4z" />
      <path fill="#fe9f11" d="M553.8 353.4l2 2-2-2z" />
      <path fill="#fdab33" d="M566 353.4l-2 4 2-4z" />
      <path fill="#e5e59d" d="M586.3 353.4l2 2-2-2z" />
      <path fill="#3a3a7c" d="M592.4 353.4l2 2-2-2z" />
      <path fill="#667" d="M460.4 355.4l2 2-2-2z" />
      <path fill="#f2f1d2" d="M466.5 355.4l2 2-2-2z" />
      <path fill="#f9d6aa" d="M486.8 355.4l2 2-2-2z" />
      <path fill="#fe9f11" d="M525.4 355.4l2 2-2-2z" />
      <path fill="#faca88" d="M527.4 355.4l2 2-2-2z" />
      <path fill="#fea522" d="M529.4 355.4l2 2-2-2z" />
      <path fill="#fcf1e4" d="M531.5 355.4l2 2-2-2z" />
      <path fill="#fdab33" d="M551.8 355.4l2 2-2-2z" />
      <path fill="#fef8f1" d="M566 355.4l2 2-2-2z" />
      <path fill="#d9d868" d="M586.3 355.4l2 2-2-2z" />
      <path fill="#a4a43d" d="M590.3 355.4l2 2-2-2z" />
      <path fill="#0e0e6e" d="M592.4 355.4l2 2-2-2z" />
      <path fill="#3a3a7c" d="M460.4 357.4l2 2-2-2z" />
      <path fill="#e5e59d" d="M466.5 357.4l2 2-2-2z" />
      <path fill="#fae3c9" d="M488.8 357.4l4 4-4-4z" />
      <path fill="#fe9f11" d="M490.9 357.4l2 2-2-2z" />
      <path fill="#f8dcbb" d="M529.4 357.4l2 2-2-2z" />
      <path fill="#fcf1e4" d="M547.7 357.4l2 2-2-2z" />
      <path fill="#fdab33" d="M549.7 357.4l2 2-2-2z" />
      <path fill="#fcb144" d="M562 357.4l2 2-2-2z" />
      <path fill="#fef8f1" d="M564 357.4l2 2-2-2z" />
      <path fill="#fbfaf2" d="M584.3 357.4l2 2-2-2z" />
      <path fill="#8d8d5b" d="M590.3 357.4l2 2-2-2z" />
      <path fill="#0e0e6e" d="M460.4 359.5l2 2-2-2z" />
      <path fill="#a4a43d" d="M462.4 359.5l2 2-2-2z" />
      <path fill="#d4d456" d="M466.5 359.5l2 2-2-2z" />
      <path fill="#f9d6aa" d="M527.4 359.5l2 2-2-2z" />
      <path fill="#f9d099" d="M545.7 359.5l2 2-2-2z" />
      <path fill="#fe9f11" d="M547.7 359.5l2 2-2-2z" />
      <path fill="#faca88" d="M559.9 359.5l2 2-2-2z" />
      <path fill="#eeedc1" d="M584.3 359.5l2 2-2-2z" />
      <path fill="#58587b" d="M590.3 359.5l2 2-2-2z" />
      <path fill="#737370" d="M462.4 361.5l2 2-2-2z" />
      <path fill="#f6f6e4" d="M468.5 361.5l2 2-2-2z" />
      <path fill="#fbbe66" d="M490.9 361.5l2 2-2-2z" />
      <path fill="#fcb144" d="M523.4 361.5l2 2-2-2z" />
      <path fill="#f8dcbb" d="M526 362.9l.7 1.3-.7-1.3z" />
      <path fill="#fbbe66" d="M541.6 361.5l2 2-2-2z" />
      <path fill="#fe9f11" d="M543.6 361.5l2 2-2-2z" />
      <path fill="#fbc477" d="M555.8 361.5l2 2-2-2z" />
      <path fill="#fcf1e4" d="M557.9 361.5l2 2-2-2z" />
      <path fill="#d3d079" d="M584.3 361.5l2 2-2-2z" />
      <path fill="#a4a43d" d="M588.3 361.5l2 2-2-2z" />
      <path fill="#262678" d="M590.3 361.5l2 2-2-2z" />
      <path fill="#49497d" d="M462.4 363.5l2 2-2-2z" />
      <path fill="#e0dea1" d="M468.5 363.5l2 2-2-2z" />
      <path fill="#fae3c9" d="M488.8 363.5l2 2-2-2z" />
      <path fill="#fdab33" d="M517.3 363.5l2 2-2-2z" />
      <path fill="#fbc477" d="M519.3 363.5l2 2-2-2z" />
      <path fill="#fbead6" d="M521.3 363.5l2 2-2-2z" />
      <path fill="#fcb144" d="M527.4 363.5l2 2-2-2z" />
      <path fill="#f9d6aa" d="M553.8 363.5l2 2-2-2z" />
      <path fill="#99994e" d="M588.3 363.5l2 2-2-2z" />
      <path fill="#0e0e6e" d="M462.4 365.6l2 2-2-2z" />
      <path fill="#a4a43d" d="M464.5 365.6l2 2-2-2z" />
      <path fill="#d4d456" d="M468.5 365.6l2 2-2-2z" />
      <path fill="#f9d099" d="M486.8 365.6l2 2-2-2z" />
      <path fill="#fe9f11" d="M488.8 365.6l2 2-2-2m10.2 0l2 2-2-2z" />
      <path fill="#f9d6aa" d="M501 365.6l2 2-2-2z" />
      <path fill="#f9d099" d="M503 365.6l2 2-2-2z" />
      <path fill="#f9d6aa" d="M511.2 365.6l2 2-2-2z" />
      <path fill="#fae3c9" d="M513.2 365.6l2 2-2-2z" />
      <path fill="#fef8f1" d="M515.2 365.6l2 2-2-2z" />
      <path fill="#fbead6" d="M531.5 365.6l2 2-2-2z" />
      <path fill="#fae3c9" d="M533.5 365.6l2 2-2-2z" />
      <path fill="#faca88" d="M535.5 365.6l2 2-2-2z" />
      <path fill="#fbc477" d="M537.6 365.6l2 2-2-2z" />
      <path fill="#fdab33" d="M539.6 365.6l2 2-2-2z" />
      <path fill="#fe9f11" d="M549.7 365.6l2 2-2-2z" />
      <path fill="#f9d6aa" d="M551.8 365.6l2 2-2-2z" />
      <path fill="#e5e3af" d="M582.2 365.6l2 2-2-2z" />
      <path fill="#667" d="M588.3 365.6l2 2-2-2z" />
      <path fill="#737370" d="M464.5 367.6l2 2-2-2z" />
      <path fill="#f2f1d7" d="M470.6 367.6l2 2-2-2z" />
      <path fill="#fea522" d="M484.8 367.6l2 2-2-2z" />
      <path fill="#fe9f11" d="M495 367.6l2 2-2-2z" />
      <path fill="#fbbe66" d="M497 367.6l2 2-2-2z" />
      <path fill="#fcf1e4" d="M499 367.6l2 2-2-2z" />
      <path fill="#fea522" d="M547.7 367.6l2 2-2-2z" />
      <path fill="#fbead6" d="M549.7 367.6l2 2-2-2z" />
      <path fill="#dddc7a" d="M582.2 367.6l2 2-2-2z" />
      <path fill="#a4a43d" d="M586.3 367.6l2 2-2-2z" />
      <path fill="#262678" d="M588.3 367.6l2 2-2-2z" />
      <path fill="#49497d" d="M464.5 369.6l2 2-2-2z" />
      <path fill="#a4a43d" d="M467.2 371l.7 1.3-.7-1.3z" />
      <path fill="#d3d079" d="M470.6 369.6l2 2-2-2z" />
      <path fill="#f9d099" d="M486.8 369.6l2 2-2-2z" />
      <path fill="#fcb144" d="M488.8 369.6l2 2-2-2z" />
      <path fill="#faca88" d="M490.9 369.6l2 2-2-2z" />
      <path fill="#f8dcbb" d="M492.9 369.6l2 2-2-2z" />
      <path fill="#fef8f1" d="M495 369.6l2 2-2-2z" />
      <path fill="#f8dcbb" d="M539.6 369.6l2 2-2-2z" />
      <path fill="#fcf1e4" d="M547.7 369.6l2 2-2-2z" />
      <path fill="#f6f6e4" d="M580.2 369.6l2 2-2-2z" />
      <path fill="#8d8d5b" d="M586.3 369.6l2 2-2-2z" />
      <path fill="#fbfaf2" d="M472.6 371.6l2 2-2-2z" />
      <path fill="#fbbe66" d="M539.6 371.6l2 2-2-2z" />
      <path fill="#faca88" d="M545.7 371.6l2 2-2-2z" />
      <path fill="#e1e18c" d="M580.2 371.6l2 2-2-2z" />
      <path fill="#49497d" d="M586.3 371.6l2 2-2-2z" />
      <path fill="#58587b" d="M466.5 373.7l2 2-2-2z" />
      <path fill="#e5e59d" d="M472.6 373.7l2 2-2-2z" />
      <path fill="#fe9f11" d="M539.6 373.7l2 2-2-2z" />
      <path fill="#fdab33" d="M543.6 373.7l2 2-2-2z" />
      <path fill="#fbfaf2" d="M578.2 373.7l2 2-2-2z" />
      <path fill="#a4a43d" d="M584.3 373.7l2 2-2-2z" />
      <path fill="#0e0e6e" d="M586.3 373.7l2 2-2-2z" />
      <path fill="#1b1b74" d="M466.5 375.7l2 2-2-2z" />
      <path fill="#a4a43d" d="M468.5 375.7l2 2-2-2z" />
      <path fill="#d0d045" d="M472.6 375.7l2 2-2-2z" />
      <path fill="#fbead6" d="M537.6 375.7l2 2-2-2z" />
      <path fill="#fe9f11" d="M541.6 375.7l2 2-2-2z" />
      <path fill="#fbead6" d="M543.6 375.7l2 2-2-2z" />
      <path fill="#e5e59d" d="M578.2 375.7l2 2-2-2z" />
      <path fill="#667" d="M584.3 375.7l2 2-2-2z" />
      <path fill="#6e6c70" d="M468.5 377.7l2 2-2-2z" />
      <path fill="#e5e3af" d="M474.6 377.7l2 2-2-2z" />
      <path fill="#faca88" d="M538.2 379.1l.7 1.4-.7-1.4z" />
      <path fill="#fae3c9" d="M541.6 377.7l2 2-2-2z" />
      <path fill="#fbfaf2" d="M576.1 377.7l2 2-2-2z" />
      <path fill="#a4a43d" d="M582.2 377.7l2 2-2-2z" />
      <path fill="#1b1b74" d="M584.3 377.7l2 2-2-2m-115.8 2l2 2-2-2z" />
      <path fill="#a4a43d" d="M470.6 379.8l2 2-2-2z" />
      <path fill="#d0d045" d="M474.6 379.8l2 2-2-2z" />
      <path fill="#fbfaf2" d="M476.6 379.8l2 2-2-2z" />
      <path fill="#f9d6aa" d="M539.6 379.8l2 2-2-2z" />
      <path fill="#e5e59d" d="M576.1 379.8l2 2-2-2z" />
      <path fill="#6e6c70" d="M582.2 379.8l2 2-2-2m-111.6 2l2 2-2-2z" />
      <path fill="#8cbf84" d="M476.6 381.8l2 2-2-2z" />
      <path
        fill="#0cf"
        d="M477.5 381.8c7 14.8 32 49.8 51 49.2 18.6-.7 39.5-34.9 47.6-49.2h-98.6z"
      />
      <path fill="#a4a43d" d="M580.2 381.8l2 2-2-2z" />
      <path fill="#1b1b74" d="M582.2 381.8l2 2-2-2m-111.6 2l2 2-2-2z" />
      <path fill="#a4a43d" d="M472.6 383.8l2 2-2-2z" />
      <path fill="#adb333" d="M476.6 383.8l2 2-2-2z" />
      <path fill="#1ac5b5" d="M478.7 383.8l2 2-2-2z" />
      <path fill="#68b070" d="M574.1 383.8l2 2-2-2z" />
      <path fill="#667" d="M580.2 383.8l2 2-2-2z" />
      <path fill="#58587b" d="M472.6 385.9l2 2-2-2z" />
      <path fill="#7fb15c" d="M478.7 385.9l2 2-2-2z" />
      <path fill="#27c2aa" d="M572 385.9l2.1 2-2-2z" />
      <path fill="#a4a43d" d="M578.2 385.9l-2 4 2-4z" />
      <path fill="#0e0e6e" d="M580.2 385.9l2 2-2-2m-107.6 2l2 2-2-2z" />
      <path fill="#a4a43d" d="M474.6 387.9l4 4-4-4z" />
      <path fill="#34be9e" d="M480.7 387.9l2 2-2-2z" />
      <path fill="#96b247" d="M572 387.9l2.1 2-2-2z" />
      <path fill="#53527c" d="M578.2 387.9l2 2-2-2z" />
      <path fill="#3a3a7c" d="M474.6 390l2 2-2-2z" />
      <path fill="#a2b23d" d="M480.7 390l2 2-2-2z" />
      <path fill="#0dc9c1" d="M482.7 390l2 2-2-2z" />
      <path fill="#5bb47c" d="M570 390l2 2-2-2z" />
      <path fill="#8d8d5b" d="M576.1 390l2 2-2-2z" />
      <path fill="#737370" d="M476.6 392l2 2-2-2z" />
      <path fill="#74b166" d="M482.7 392l2 2-2-2z" />
      <path fill="#27c2aa" d="M568 392l2 2-2-2z" />
      <path fill="#a4a43d" d="M574.1 392l-2 4 2-4z" />
      <path fill="#262678" d="M576.1 392l2 2-2-2z" />
      <path fill="#0e0e6e" d="M476.6 394l2 2-2-2z" />
      <path fill="#a4a43d" d="M478.7 394l4 4-4-4z" />
      <path fill="#42bb92" d="M484.8 394l2 2-2-2z" />
      <path fill="#0dc9c1" d="M566 394l2 2-2-2z" />
      <path fill="#96b247" d="M568 394l2 2-2-2z" />
      <path fill="#58587b" d="M574.1 394l2 2-2-2z" />
      <path fill="#3a3a7c" d="M478.7 396l2 2-2-2z" />
      <path fill="#adb333" d="M484.8 396l2 2-2-2z" />
      <path fill="#27c2aa" d="M486.8 396l2 2-2-2z" />
      <path fill="#74b166" d="M566 396l2 2-2-2z" />
      <path fill="#8d8d5b" d="M572 396l2.1 2-2-2z" />
      <path fill="#6e6c70" d="M480.7 398l2 2-2-2z" />
      <path fill="#96b247" d="M486.8 398l2 2-2-2z" />
      <path fill="#0dc9c1" d="M488.8 398l2 2-2-2z" />
      <path fill="#42bb92" d="M564 398l2 2-2-2z" />
      <path fill="#a4a43d" d="M570 398l-4 6.1 4-6z" />
      <path fill="#1b1b74" d="M572 398l2.1 2-2-2z" />
      <path fill="#0e0e6e" d="M480.7 400l2 2.1-2-2z" />
      <path fill="#8d8d5b" d="M482.7 400l2 2.1-2-2z" />
      <path fill="#7fb15c" d="M488.8 400l2 2.1-2-2z" />
      <path fill="#34be9e" d="M562 400l2 2.1-2-2z" />
      <path fill="#3a3a7c" d="M570 400l2 2.1-2-2z" />
      <path fill="#1b1b74" d="M482.7 402.1l2 2-2-2z" />
      <path fill="#a4a43d" d="M484.8 402.1l22.3 22.3-22.3-22.3z" />
      <path fill="#74b166" d="M490.9 402.1l2 2-2-2z" />
      <path fill="#27c2aa" d="M559.9 402.1l2 2-2-2z" />
      <path fill="#adb333" d="M562 402.1l2 2-2-2z" />
      <path fill="#667" d="M568 402.1l2 2-2-2z" />
      <path fill="#32327b" d="M484.8 404.1l2 2-2-2z" />
      <path fill="#42bb92" d="M492.9 404.1l2 2-2-2z" />
      <path fill="#0dc9c1" d="M557.9 404.1l-8.2 10.2L558 404z" />
      <path fill="#adb333" d="M559.9 404.1l2 2-2-2z" />
      <path fill="#737370" d="M566 404.1l2 2-2-2z" />
      <path fill="#49497d" d="M486.8 406.2l2 2-2-2z" />
      <path fill="#42bb92" d="M495 406.2l2 2-2-2z" />
      <path fill="#96b247" d="M557.9 406.2l2 2-2-2z" />
      <path fill="#8d8d5b" d="M564 406.2l-2 4 2-4z" />
      <path fill="#0e0e6e" d="M566 406.2l2 2-2-2z" />
      <path fill="#53527c" d="M488.8 408.2l2 2-2-2z" />
      <path fill="#42bb92" d="M497 408.2l2 2-2-2z" />
      <path fill="#96b247" d="M555.8 408.2l2 2-2-2z" />
      <path fill="#0e0e6e" d="M564 408.2l2 2-2-2z" />
      <path fill="#6e6c70" d="M490.9 410.2l2 2-2-2z" />
      <path fill="#42bb92" d="M499 410.2l2 2-2-2z" />
      <path fill="#96b247" d="M553.8 410.2l2 2-2-2z" />
      <path fill="#a4a43d" d="M559.9 410.2l-4 6.1 4-6z" />
      <path fill="#262678" d="M562 410.2l2 2-2-2z" />
      <path fill="#6e6c70" d="M492.9 412.3l2 2-2-2z" />
      <path fill="#42bb92" d="M501 412.3l2 2-2-2z" />
      <path fill="#96b247" d="M551.8 412.3l2 2-2-2z" />
      <path fill="#262678" d="M559.9 412.3l2 2-2-2z" />
      <path fill="#6e6c70" d="M495 414.3l2 2-2-2z" />
      <path fill="#68b070" d="M503 414.3l2 2-2-2z" />
      <path fill="#27c2aa" d="M547.7 414.3l2 2-2-2z" />
      <path fill="#adb333" d="M549.7 414.3l2 2-2-2z" />
      <path fill="#262678" d="M557.9 414.3l2 2-2-2z" />
      <path fill="#667" d="M497 416.3l2 2-2-2z" />
      <path fill="#74b166" d="M505 416.3l2.1 2-2-2z" />
      <path fill="#34be9e" d="M545.7 416.3l2 2-2-2z" />
      <path fill="#adb333" d="M547.7 416.3l2 2-2-2z" />
      <path fill="#8d8d5b" d="M553.8 416.3l-2 4 2-4z" />
      <path fill="#262678" d="M555.8 416.3l2 2-2-2z" />
      <path fill="#49497d" d="M499 418.3l2 2-2-2z" />
      <path fill="#96b247" d="M507.1 418.3l2 2-2-2z" />
      <path fill="#0dc9c1" d="M509.1 418.3l2 2-2-2z" />
      <path fill="#42bb92" d="M543.6 418.3l2 2-2-2z" />
      <path fill="#0e0e6e" d="M553.8 418.3l2 2-2-2z" />
      <path fill="#49497d" d="M501 420.4l2 2-2-2z" />
      <path fill="#a2b23d" d="M509.1 420.4l2 2-2-2z" />
      <path fill="#27c2aa" d="M511.2 420.4l2 2-2-2z" />
      <path fill="#74b166" d="M541.6 420.4l2 2-2-2z" />
      <path fill="#a4a43d" d="M547.7 420.4l-6 8 6-8z" />
      <path fill="#808067" d="M549.7 420.4l2 2-2-2z" />
      <path fill="#0e0e6e" d="M551.8 420.4l2 2-2-2z" />
      <path fill="#262678" d="M503 422.4l2 2-2-2z" />
      <path fill="#adb333" d="M511.2 422.4l2 2-2-2z" />
      <path fill="#42bb92" d="M513.2 422.4l2 2-2-2z" />
      <path fill="#0dc9c1" d="M537.6 422.4l2 2-2-2z" />
      <path fill="#96b247" d="M539.6 422.4l2 2-2-2z" />
      <path fill="#6e6c70" d="M547.7 422.4l2 2-2-2z" />
      <path fill="#1b1b74" d="M505 424.4l2.1 2-2-2z" />
      <path fill="#8d8d5b" d="M507.1 424.4l2 2-2-2z" />
      <path fill="#74b166" d="M515.2 424.4l2 2-2-2z" />
      <path fill="#0dc9c1" d="M517.3 424.4l2 2-2-2z" />
      <path fill="#34be9e" d="M535.5 424.4l2 2-2-2z" />
      <path fill="#adb333" d="M537.6 424.4l2 2-2-2z" />
      <path fill="#49497d" d="M545.7 424.4l2 2-2-2z" />
      <path fill="#0e0e6e" d="M507.1 426.5l2 2-2-2z" />
      <path fill="#6e6c70" d="M509.1 426.5l2 2-2-2z" />
      <path fill="#a4a43d" d="M511.2 426.5l4 4-4-4z" />
      <path fill="#96b247" d="M517.3 426.5l2 2-2-2z" />
      <path fill="#27c2aa" d="M519.3 426.5l2 2-2-2z" />
      <path fill="#68b070" d="M533.5 426.5l2 2-2-2z" />
      <path fill="#32327b" d="M543.6 426.5l2 2-2-2z" />
      <path fill="#49497d" d="M511.2 428.5l2 2-2-2z" />
      <path fill="#5bb47c" d="M521.3 428.5l2 2-2-2z" />
      <path fill="#27c2aa" d="M529.4 428.5l2 2-2-2z" />
      <path fill="#96b247" d="M531.5 428.5l2 2-2-2z" />
      <path fill="#a4a43d" d="M537.6 428.5l-2 4 2-4z" />
      <path fill="#808067" d="M539.6 428.5l2 2-2-2z" />
      <path fill="#0e0e6e" d="M541.6 428.5l2 2-2-2z" />
      <path fill="#262678" d="M513.2 430.5l2 2-2-2z" />
      <path fill="#8d8d5b" d="M515.2 430.5l2 2-2-2z" />
      <path fill="#8bb252" d="M523.4 430.5l2 2-2-2z" />
      <path fill="#1ac5b5" d="M525.4 430.5l2 2-2-2z" />
      <path fill="#5bb47c" d="M527.4 430.5l2 2-2-2z" />
      <path fill="#58587b" d="M537.6 430.5l2 2-2-2z" />
      <path fill="#0e0e6e" d="M515.2 432.6l2 2-2-2z" />
      <path fill="#667" d="M517.3 432.6l2 2-2-2z" />
      <path fill="#a4a43d" d="M519.3 432.6l2 2-2-2z" />
      <path fill="#99994e" d="M533.5 432.6l2 2-2-2z" />
      <path fill="#32327b" d="M535.5 432.6l2 2-2-2m-16.2 2l2 2-2-2z" />
      <path fill="#99994e" d="M521.3 434.6l2 2-2-2z" />
      <path fill="#a4a43d" d="M529.4 434.6l2 2-2-2z" />
      <path fill="#667" d="M531.5 434.6l2 2-2-2z" />
      <path fill="#0e0e6e" d="M533.5 434.6l2 2-2-2m-12.2 2l2 2-2-2z" />
      <path fill="#667" d="M523.4 436.6l2 2-2-2z" />
      <path fill="#a4a43d" d="M525.4 436.6l2 2-2-2z" />
      <path fill="#99994e" d="M527.4 436.6l2 2-2-2z" />
      <path fill="#32327b" d="M529.4 436.6l2 2-2-2z" />
      <path fill="#262678" d="M525.4 438.6l2 2-2-2z" />
      <path fill="#0e0e6e" d="M527.4 438.6l2 2-2-2z" />
      <path
        fill="#f90"
        d="M529.4 302.6c3.2 7.4 13.2 15.5 16 19.5-3.5 4-4.2 3.6-3.8 11 6.1-6.4 6.2-7 10.2-6.1 8.6 8.6 1.5 27-5.6 31-7.1 4.3-5.8-.1-16.5 5.2 4.9 4.2 10.6-.6 15.2.7 2.5 3-1.2 8.4.7 13.6 4.1-.4 3.6-8.7 4.6-11.7 3-11 21-18.6 21.9-28.7 3.8-1.7 7.5-.5 12.1 2-2.3-9.4-9.8-9.3-11.9-12.2-4.8-7.4-9.1-15.8-19.4-18-7.9-1.7-7.3.5-12.3-3-3.2-2.4-12.7-7-11.2-3.3z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M552 311a1.6 1.6 0 1 1-3.3 0 1.6 1.6 0 0 1 3.3 0z"
      />
      <path
        fill="#f90"
        d="M504.3 333.9c5-6.2 7.6-19 9.8-23.2 5.2 1.2 5.1 2 11.5-1.8-8.5-2.4-9.2-2.2-10.2-6.1 3.6-11.7 23.2-14 30.1-9.6 7.1 4.3 2.6 5.2 12.3 12.1 1.4-6.3-5.5-9-6.5-13.7 1.5-3.7 8-3 11.6-7-2.2-3.5-9.3.8-12.4 1.4-11 2.5-26.3-9.8-35.6-6-3.3-2.5-4-6.4-3.9-11.7-7.2 6.5-3.6 13.1-5.3 16.3-4.2 7.7-9.7 15.5-6.8 25.6 2.2 7.8 3.8 6.2 3.2 12.3-.7 3.9-.4 14.5 2.2 11.4z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M501.2 310c.8-.4 1.8-.1 2.2.7a1.6 1.6 0 1 1-2.2-.7z"
      />
      <path
        fill="#f90"
        d="M545.4 338.2c-8-1-20.1 3.3-25 3.7-1.5-5.1-.8-5.5-7.4-9 2.3 8.6 2.8 9 0 12-11.8 2.9-24-12.7-23.8-20.8 0-8.3 3.2-5 4-16.9-6 2-4.8 9.4-8.3 12.7-3.9.6-6.6-5.3-12-6.3-1.8 3.7 5.5 7.5 7.6 9.9 7.9 8.2 5.2 27.5 13.3 33.5-.4 4.2-3.4 6.8-8 9.4 9.3 2.9 13.1-3.7 16.7-3.9 8.8-.3 18.3.3 25.5-7.4 5.4-5.9 3.3-6.5 8.8-9 3.7-1.4 12.6-7.2 8.6-7.9z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M526.6 353.3a1.6 1.6 0 1 1 1.7-2.8 1.6 1.6 0 0 1-1.7 2.8z"
      />
    </g>
  </svg>
	),
	AL: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#e41e20" d="M0 0h640v480H0z" />
    <path
      id="prefix__a"
      d="M272 93.3c-4.6 0-12.3 1.5-12.2 5-13-2.1-14.3 3.2-13.5 8 1.2-1.9 2.7-3 3.9-3.1 1.7-.3 3.5.3 5.4 1.4a21.6 21.6 0 0 1 4.8 4.1c-4.6 1.1-8.2.4-11.8-.2a16.5 16.5 0 0 1-5.7-2.4c-1.5-1-2-2-4.3-4.3-2.7-2.8-5.6-2-4.7 2.3 2.1 4 5.6 5.8 10 6.6 2.1.3 5.3 1 8.9 1 3.6 0 7.6-.5 9.8 0-1.3.8-2.8 2.3-5.8 2.8-3 .6-7.5-1.8-10.3-2.4.3 2.3 3.3 4.5 9.1 5.7 9.6 2 17.5 3.6 22.8 6.5a37.3 37.3 0 0 1 10.9 9.2c4.7 5.5 5 9.8 5.2 10.8 1 8.8-2.1 13.8-7.9 15.4-2.8.7-8-.7-9.8-2.9-2-2.2-3.7-6-3.2-12 .5-2.2 3.1-8.3.9-9.5a273.7 273.7 0 0 0-32.3-15.1c-2.5-1-4.5 2.4-5.3 3.8a50.2 50.2 0 0 1-36-23.7c-4.2-7.6-11.3 0-10.1 7.3 1.9 8 8 13.8 15.4 18 7.5 4.1 17 8.2 26.5 8 5.2 1 5.1 7.6-1 8.9-12.1 0-21.8-.2-30.9-9-6.9-6.3-10.7 1.2-8.8 5.4 3.4 13.1 22.1 16.8 41 12.6 7.4-1.2 3 6.6 1 6.7-8 5.7-22.1 11.2-34.6 0-5.7-4.4-9.6-.8-7.4 5.5 5.5 16.5 26.7 13 41.2 5 3.7-2.1 7.1 2.7 2.6 6.4-18.1 12.6-27.1 12.8-35.3 8-10.2-4.1-11 7.2-5 11 6.7 4 23.8 1 36.4-7 5.4-4 5.6 2.3 2.2 4.8-14.9 12.9-20.8 16.3-36.3 14.2-7.7-.6-7.6 8.9-1.6 12.6 8.3 5.1 24.5-3.3 37-13.8 5.3-2.8 6.2 1.8 3.6 7.3a53.9 53.9 0 0 1-21.8 18c-7 2.7-13.6 2.3-18.3.7-5.8-2-6.5 4-3.3 9.4 1.9 3.3 9.8 4.3 18.4 1.3 8.6-3 17.8-10.2 24.1-18.5 5.5-4.9 4.9 1.6 2.3 6.2-12.6 20-24.2 27.4-39.5 26.2-6.7-1.2-8.3 4-4 9 7.6 6.2 17 6 25.4-.2 7.3-7 21.4-22.4 28.8-30.6 5.2-4.1 6.9 0 5.3 8.4-1.4 4.8-4.8 10-14.3 13.6-6.5 3.7-1.6 8.8 3.2 9 2.7 0 8.1-3.2 12.3-7.8 5.4-6.2 5.8-10.3 8.8-19.9 2.8-4.6 7.9-2.4 7.9 2.4-2.5 9.6-4.5 11.3-9.5 15.2-4.7 4.5 3.3 6 6 4.1 7.8-5.2 10.6-12 13.2-18.2 2-4.4 7.4-2.3 4.8 5-6 17.4-16 24.2-33.3 27.8-1.7.3-2.8 1.3-2.2 3.3l7 7c-10.7 3.2-19.4 5-30.2 8l-14.8-9.8c-1.3-3.2-2-8.2-9.8-4.7-5.2-2.4-7.7-1.5-10.6 1 4.2 0 6 1.2 7.7 3.1 2.2 5.7 7.2 6.3 12.3 4.7 3.3 2.7 5 4.9 8.4 7.7l-16.7-.5c-6-6.3-10.6-6-14.8-1-3.3.5-4.6.5-6.8 4.4 3.4-1.4 5.6-1.8 7.1-.3 6.3 3.7 10.4 2.9 13.5 0l17.5 1.1c-2.2 2-5.2 3-7.5 4.8-9-2.6-13.8 1-15.4 8.3a17 17 0 0 0-1.2 9.3c.8-3 2.3-5.5 4.9-7 8 2 11-1.3 11.5-6.1 4-3.2 9.8-3.9 13.7-7.1 4.6 1.4 6.8 2.3 11.4 3.8 1.6 5 5.3 6.9 11.3 5.6 7 .2 5.8 3.2 6.4 5.5 2-3.3 1.9-6.6-2.5-9.6-1.6-4.3-5.2-6.3-9.8-3.8-4.4-1.2-5.5-3-9.9-4.3 11-3.5 18.8-4.3 29.8-7.8l7.7 6.8c1.5.9 2.9 1.1 3.8 0 6.9-10 10-18.7 16.3-25.3 2.5-2.8 5.6-6.4 9-7.3 1.7-.5 3.8-.2 5.2 1.3 1.3 1.4 2.4 4.1 2 8.2-.7 5.7-2.1 7.6-3.7 11-1.7 3.5-3.6 5.6-5.7 8.3-4 5.3-9.4 8.4-12.6 10.5-6.4 4.1-9 2.3-14 2-6.4.7-8 3.8-2.8 8.1 4.8 2.6 9.2 2.9 12.8 2.2 3-.6 6.6-4.5 9.2-6.6 2.8-3.3 7.6.6 4.3 4.5-5.9 7-11.7 11.6-19 11.5-7.7 1-6.2 5.3-1.2 7.4 9.2 3.7 17.4-3.3 21.6-8 3.2-3.5 5.5-3.6 5 1.9-3.3 9.9-7.6 13.7-14.8 14.2-5.8-.6-5.9 4-1.6 7 9.6 6.6 16.6-4.8 19.9-11.6 2.3-6.2 5.9-3.3 6.3 1.8 0 6.9-3 12.4-11.3 19.4 6.3 10.1 13.7 20.4 20 30.5l19.2-214L320 139c-2-1.8-8.8-9.8-10.5-11-.7-.6-1-1-.1-1.4.9-.4 3-.8 4.5-1-4-4.1-7.6-5.4-15.3-7.6 1.9-.8 3.7-.4 9.3-.6a30.2 30.2 0 0 0-13.5-10.2c4.2-3 5-3.2 9.2-6.7a86.3 86.3 0 0 1-19.5-3.8 37.4 37.4 0 0 0-12-3.4zm.8 8.4c3.8 0 6.1 1.3 6.1 2.9 0 1.6-2.3 2.9-6.1 2.9s-6.2-1.5-6.2-3c0-1.6 2.4-2.8 6.2-2.8z"
    />
    <use
      width="100%"
      height="100%"
      transform="matrix(-1 0 0 1 640 0)"
      xlinkHref="#prefix__a"
    />
  </svg>
	),
	AM: () => (
  <svg viewBox="0 0 640 480">
    <path fill="red" d="M0 0h640v160H0z" />
    <path fill="#00f" d="M0 160h640v160H0z" />
    <path fill="orange" d="M0 320h640v160H0z" />
  </svg>
	),
	AO: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="red" d="M0 0h640v243.6H0z" />
      <path d="M0 236.4h640V480H0z" />
    </g>
    <path
      fill="#ffec00"
      fillRule="evenodd"
      d="M228.7 148.2c165.2 43.3 59 255.6-71.3 167.2l-8.8 13.6c76.7 54.6 152.6 10.6 174-46.4 22.2-58.8-7.6-141.5-92.6-150l-1.3 15.6z"
    />
    <path
      fill="#ffec00"
      fillRule="evenodd"
      d="M170 330.8l21.7 10.1-10.2 21.8-21.7-10.2zm149-99.5h24v24h-24zm-11.7-38.9l22.3-8.6 8.7 22.3-22.3 8.7zm-26-29.1l17.1-16.9 16.9 17-17 16.9zm-26.2-39.8l22.4 8.4-8.5 22.4-22.4-8.4zM316 270l22.3 8.9-9 22.2-22.2-8.9zm-69.9 70l22-9.3 9.5 22-22 9.4zm-39.5 2.8h24v24h-24zm41.3-116l-20.3-15-20.3 14.6 8-23-20.3-15h24.5l8.5-22.6 7.8 22.7 24.7-.3-19.6 15.3 7 23.4z"
    />
    <path
      fill="#fe0"
      fillRule="evenodd"
      d="M336 346.4c-1.2.4-6.2 12.4-9.7 18.2l3.7 1c13.6 4.8 20.4 9.2 26.2 17.5a7.9 7.9 0 0 0 10.2.7s2.8-1 6.4-5c3-4.5 2.2-8-1.4-11.1-11-8-22.9-14-35.4-21.3z"
    />
    <path
      fillRule="evenodd"
      d="M365.3 372.8a4.3 4.3 0 1 1-8.7 0 4.3 4.3 0 0 1 8.6 0zm-21.4-13.6a4.3 4.3 0 1 1-8.7 0 4.3 4.3 0 0 1 8.7 0zm10.9 7a4.3 4.3 0 1 1-8.7 0 4.3 4.3 0 0 1 8.7 0z"
    />
    <path
      fill="#fe0"
      fillRule="evenodd"
      d="M324.5 363.7c-42.6-24.3-87.3-50.5-130-74.8-18.7-11.7-19.6-33.4-7-49.9 1.2-2.3 2.8-1.8 3.4-.5 1.5 8 6 16.3 11.4 21.5A5288 5288 0 0 1 334 345.6c-3.4 5.8-6 12.3-9.5 18z"
    />
    <path
      fill="#ffec00"
      fillRule="evenodd"
      d="M297.2 305.5l17.8 16-16 17.8-17.8-16z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={3}
      d="M331.5 348.8l-125-75.5m109.6 58.1L274 304.1m18.2 42.7L249.3 322"
    />
  </svg>
	),
	AR: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#74acdf" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M0 160h640v160H0z" />
    <g id="prefix__c" transform="translate(-64) scale(.96)">
      <path
        id="prefix__a"
        fill="#f6b40e"
        stroke="#85340a"
        strokeWidth={1.1}
        d="M396.8 251.3l28.5 62s.5 1.2 1.3.9c.8-.4.3-1.5.3-1.5l-23.7-64m-.7 24.1c-.4 9.4 5.4 14.6 4.7 23-.8 8.5 3.8 13.2 5 16.5 1 3.3-1.3 5.2-.3 5.7s3-2.1 2.4-6.8c-.7-4.6-4.2-6-3.4-16.3.8-10.3-4.2-12.7-3-22"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(22.5 400 250)"
        xlinkHref="#prefix__a"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(45 400 250)"
        xlinkHref="#prefix__a"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(67.5 400 250)"
        xlinkHref="#prefix__a"
      />
      <path
        id="prefix__b"
        fill="#85340a"
        d="M404.3 274.4c.5 9 5.6 13 4.6 21.3 2.2-6.5-3.1-11.6-2.8-21.2m-7.7-23.8l19.5 42.6-16.3-43.9"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(22.5 400 250)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(45 400 250)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(67.5 400 250)"
        xlinkHref="#prefix__b"
      />
    </g>
    <use
      width="100%"
      height="100%"
      transform="rotate(90 320 240)"
      xlinkHref="#prefix__c"
    />
    <use
      width="100%"
      height="100%"
      transform="rotate(180 320 240)"
      xlinkHref="#prefix__c"
    />
    <use
      width="100%"
      height="100%"
      transform="rotate(-90 320 240)"
      xlinkHref="#prefix__c"
    />
    <circle
      cx={320}
      cy={240}
      r={26.7}
      fill="#f6b40e"
      stroke="#85340a"
      strokeWidth={1.4}
    />
    <path
      id="prefix__h"
      fill="#843511"
      d="M329.1 234.3c-1.8 0-3.6.8-4.6 2.4 2 1.9 6.6 2 9.7-.2a7 7 0 0 0-5.1-2.2zm0 .4c1.7 0 3.4.8 3.6 1.6-2 2.3-5.3 2-7.4.4a4.3 4.3 0 0 1 3.8-2z"
    />
    <use
      width="100%"
      height="100%"
      transform="matrix(-1 0 0 1 640.2 0)"
      xlinkHref="#prefix__d"
    />
    <use
      width="100%"
      height="100%"
      transform="matrix(-1 0 0 1 640.2 0)"
      xlinkHref="#prefix__e"
    />
    <use
      width="100%"
      height="100%"
      transform="translate(18.1)"
      xlinkHref="#prefix__f"
    />
    <use
      width="100%"
      height="100%"
      transform="matrix(-1 0 0 1 640.2 0)"
      xlinkHref="#prefix__g"
    />
    <path
      fill="#85340a"
      d="M316 243.7a1.9 1.9 0 1 0 1.8 2.9 4 4 0 0 0 2.2.6h.2a3.9 3.9 0 0 0 2.3-.6 1.9 1.9 0 1 0 1.8-3c.5.3.8.7.8 1.3 0 .6-.5 1.2-1.2 1.2a1.2 1.2 0 0 1-1.2-1.2 3 3 0 0 1-2.6 1.7 3 3 0 0 1-2.5-1.7 1.2 1.2 0 0 1-1.3 1.2c-.6 0-1.2-.6-1.2-1.2s.3-1 .8-1.2zm2 5.5c-2.1 0-3 1.8-4.8 3 1-.4 1.9-1.2 3.3-2s2.7.2 3.5.2c.8 0 2-1 3.5-.2 1.4.8 2.3 1.6 3.3 2-1.9-1.2-2.7-3-4.8-3a5.5 5.5 0 0 0-2 .6 5.5 5.5 0 0 0-2-.7z"
    />
    <path
      fill="#85340a"
      d="M317.2 251.6c-.8 0-1.8.2-3.4.6 3.7-.8 4.5.5 6.2.5 1.6 0 2.4-1.3 6.1-.5-4-1.2-4.9-.4-6.1-.4-.8 0-1.4-.3-2.8-.2z"
    />
    <path
      fill="#85340a"
      d="M314 252.2h-.8c4.3.5 2.3 3 6.8 3s2.5-2.5 6.8-3c-4.5-.4-3.1 2.3-6.8 2.3-3.5 0-2.4-2.3-6-2.3zm9.7 6.7a3.7 3.7 0 0 0-7.4 0 3.8 3.8 0 0 1 7.4 0z"
    />
    <path
      id="prefix__e"
      fill="#85340a"
      d="M303.4 234.3c4.7-4.1 10.7-4.8 14-1.7a8 8 0 0 1 1.5 3.5c.4 2.3-.3 4.8-2.1 7.4l.8.4a14.6 14.6 0 0 0 1.6-9.4 13.3 13.3 0 0 0-.6-2.3c-4.5-3.7-10.7-4-15.2 2z"
    />
    <path
      id="prefix__d"
      fill="#85340a"
      d="M310.8 233c2.7 0 3.3.7 4.5 1.7 1.2 1 1.9.8 2 1 .3.2 0 .8-.3.6-.5-.2-1.3-.6-2.5-1.6s-2.5-1-3.7-1c-3.7 0-5.7 3-6.2 2.8-.3-.2 2.1-3.5 6.2-3.5z"
    />
    <use
      width="100%"
      height="100%"
      transform="translate(-18.4)"
      xlinkHref="#prefix__h"
    />
    <circle id="prefix__f" cx={310.9} cy={236.3} r={1.9} fill="#85340a" />
    <path
      id="prefix__g"
      fill="#85340a"
      d="M305.9 237.5c3.5 2.7 7 2.5 9 1.3 2-1.3 2-1.7 1.6-1.7-.4 0-.8.4-2.4 1.3-1.7.8-4.1.8-8.2-.9z"
    />
  </svg>
	),
	AS: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h640v480H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)">
      <path fill="#006" d="M-374-16H650v512H-374z" />
      <path
        fill="#bd1021"
        fillRule="evenodd"
        d="M-374 240L650 496V-16L-374 240z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M650 11.4v457.2L-264.3 240 650 11.4z"
      />
      <g stroke="#000">
        <path
          fill="#9c3900"
          fillRule="evenodd"
          strokeLinejoin="round"
          strokeWidth={1.8}
          d="M478 297.4s-6.4-5.2 1.2-13.7c-4.1-3.4-.3-10.1-.3-10.1s-7-2.6.3-13.4c-5.3-3.5-3-11.3-3-11.3s-17-6.4-.8-12.5c-13.4 5.8-25.9-7.9-25.9-7.9l-19.4.6c-3.3-16.2-29-2.1-10-48.5-4.9-.9-10.4-2.3-16 1.7-5.4 4.1-21.1 12.8-30.4 4.1s6-21.2 6.4-21.5c.3-.3 20.6-10.8 23.5-17.7-.3-5.3-6.7-9.3-.9-20.7 6.7-10.7 47.7-20.9 66.3-24.4a29.5 29.5 0 0 0 13-11.9l2.1 7.6s41.3-12.2 43.3-18 .9 5.2.9 5.2c16.2-1.5 36.9-15.4 39.8-9 13.6-2.6 39.8-14.3 39.8-14.3s9-.3 2.6 9.6c4 6.4-1.2 12-1.5 12-.2 0 1.8 6.3-3.4 9.8 1.7 5.5-3.2 10-3.2 10s2.3 6.6-7 10c.9 5.9-5.2 7-5.2 7s.8 6.1-3.2 8.8c0 4.6-4.7 7-4.7 7s3 1.7-1.2 4.6a1568 1568 0 0 1-46.2 28.5c0-.3 30.8 5.5 32.9 6.6s25.3 16.6 25.3 16.6l-23.6 29s-26.1-2.8-27.3-1.4 5.5 2 7 4.4c1.4 2.3 3.8 7.8 8.4 7.2 4.7-.5-8.7 8.5-17.4 9.3 0 3.2 11 3.5 14 1 2.8-2.7-7 7.5-8.2 9s13-2.1 13-2.1-2.3 9.6-14.7 12.5c4.9 8.1 2.9 13.3 2.6 13.3s-8.2-8-15.7-6.6c2 7.8 8.1 15 9.9 16.2 1.7 1.2-13.7 1-15.7-3.5s-3.8 10.5 1.7 15.2c-6.4.3-11.9-3.5-11.9-3.5s-3.8 8.7-1.2 13c2.6 4.4-9-8.7-9-8.7l-22 9.3-5-8.4z"
        />
        <path
          fill="#ffc221"
          fillRule="evenodd"
          strokeWidth={1.9}
          d="M307.3 280.1c.5 0 32.1-.5 46.6-8.8a86.3 86.3 0 0 0 17 19.1l4.7-16.5s11.4.5 12.4 3c-1.5 3.2-2 7.3-2 7.3s7.7.6 8.3 1.6c.5 1-2.1 9.8-2.1 9.8l33.1 7.8s2.6-13 5.2-11.4c2.6 1.6 14 17.6 30 18.6s17-13.4 17-13.4l3.7 2s6.7-14.4 7.8-14.4 2.5 2 11.3 2c2.6 3.1 3.7 10.4 3.7 10.4s-9.9 9.8-6.8 17.6 3.7 5.7 3.7 5.7l71.4 17s3.6 5.7-2.6 8.8c0 .5-72-16.5-72-16.5s-6.7 7.7-11.9 6.2-1.5 3-1.5 3l77.6 6.3s5.7 7.2 1.6 9.3c-5.2.5-83.9-5.2-83.9-5.2s-4.6 9.9-9.8 1.6c-3.6 5.7-7.8-1.6-7.8-1.6s-6.7 5.2-7.7-.5c-5.7 4.2-9.3-2.6-9.3-2.6l-33.2-2-2 3s5.7 1.6-3.1 5.2c-8.8 3.7 52.8 2.1 54.3 2.6 1.6.6-4.1 5.2-4.1 5.2s31.5 2 37.2-4.6c5.7-6.8-2 8.8-2 8.8s24.8-1 24.8-2.1-.5 7.7-17.6 6.7a112 112 0 0 0 23.3 10.9s-13 3-28-.5c2.6 6.7 14 12.9 14 12.9s-8.3 7.2-26.9-10.4c5.2 9.4 1 13 .5 12a48 48 0 0 0-30-18.7c13 8.3 7.3 12 7.3 12s-6.8-12-17.6 0c-4.2-11-20.2-17.2-39.9-18.2-6.2-7.2-9.8-5.2-24.3-9.3-8.3-9.3-20.2-19.7-20.2-19.7s.5-14 14.5-12.4c1.6 4.7 1.6 3.1 1.6 3.1s15.5-5.7 20.1 2c6.8-11.8 16-1.7 17.6 2.4 4.5.7 27 1.3 27 1.3s-2.7-4.7-1-4.1c1.5.5 13.9-4.7 13.4-6.2-.6-1.6-1-6.8 1-6.3 2 .6-17.6-2.5-28.5 5.7-3.6-3.6-1-13.4-1-13.4l-32-6.7-1.6 8.2s-9.4 1.6-8.8-.5l-2.1 7.3s-12.4-3.1-12.4-3.7 3.6-18.6 3.6-18c0 .4-10.4 1-24.8 11.8-4.2-13-36.8-30-36.8-30.5z"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M386 284.8l-6.7 30m12.9-18.7l-2 9.9m35.1-2l-3 9.2m60.4 53.8c-.5 0-16.5 2.1-18.6 1.6-2-.5 25.4 8.3 25.4 11.9m-35.7-9.8s-16-10.4-18.7-9.4c-2.5 1 16-.5 17.6-2m-32-.5s-16.6.5-18.2-1 16 11.3 19.2 10.3m-33.1-16.6c-.5 0-11.4-4.1-16-5.2 4 4.2 7.2 9.9 17.5 12m2.6-13.5c-.5-1-20.7-7.3-20.7-10.4a32.6 32.6 0 0 0 17.6 2.1M499.8 321l-2 9.3"
        />
        <path
          fill="#ffc221"
          fillRule="evenodd"
          strokeWidth={1.9}
          d="M347.7 237.7s-21.7 18.6 0 29.5c1-7.3 2.6-8.3 2.6-8.3s18 6.7 29-9.3c-4.7-6.8-13-4.2-13-4.2s-17 0-18.6-7.7z"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M365.8 246l-15 12.9m61.2 76.9s3.5 3.8.4 8.5m72.4-4.7l-5.7.5m-40.9-3.6l10.4 1.6m17.5-28.2s.3 10.5-8.4 10.2c-8.8-.3-5.9.3-5.9.3"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M472.8 308.1s3.5 1.2 2.6 3.8c-.9 2.6.9 10.2-9.3 17.5-10.8 2.3-9.6-9-9.6-9"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M476.6 311.4s6.3-3.8 7.2 2.3c.9 6-5.2 17.4-9.6 19.2-4.3 1.7-9.3-.3-8.7-3.2m18.9-15.7s5.8-4.7 7.6 1.4c1.7 6.1-4.7 19.8-7.3 20m7.8-20s3-1.4 5 .3m-14.3 20.6c-1.1.3-6 .6-7.8-3.2m-18.3-7l-6.1.4m28.4 22.6l-.5-9.6-2.4-3.2-4 4.1s-.6 9.6-2.4 10.5m2.4-10.8l-3.2-6-5 6s-.5 8.7-2.3 9.6m2.3-9.9l-2-5.8s-5.8 3.2-6.4 5.5c-.6 2.4-.9 8.7-2.3 9.3m2.3-10.4s.6-5.3-1.2-5.3c-1.7 0-9.5 7.3-9.8 13.7"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          strokeLinejoin="round"
          strokeWidth={1.9}
          d="M348.4 237.8s2.9-2.9 3.8-6.4c.8-3.4-1.2-7.2 2.3-10.4s49.4-22.7 53.2-26.5a115 115 0 0 0 11.6-13.6c.9-1.8 3.5 8.7-4.4 13.3 8.5-2.3 14-4.9 17.5-3.7-3.5 4.9-12.8 13-17.2 13 10.2-3.7 19.5-7 22.1-4.9 2.6 2-12.5 12.2-18.6 12.8 10.2-2.6 23.8-6.7 25.6-2.3-5.5 1.7-3.8 3.2-15.1 9.6a28.5 28.5 0 0 1-8.7 1.4c8.7-.9 20.6-4.4 21.8 2-7 2.7-9.6 6.1-15.4 7.6-5.9 1.4-19.2 4-27.4 7.3-8 3.2-20 12.5-20 12.5s-25.9.8-25.9.5c0-.3-5-11.9-5.2-12.2z"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M360.6 235.8s.3-5.8 3-7.8c2.5-2 15.6-7 18.5-11.4 3-4.3-4.3 7.6-3.2 10.8m-13-.3s6.3 2.3 4.9 7.2"
        />
        <path
          fill="none"
          strokeWidth={1.6}
          d="M373.4 230.4a4.8 4.8 0 1 1-9.6 0 4.8 4.8 0 0 1 9.6 0z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          strokeWidth={1.9}
          d="M570.1 220.1l50.3 9.6s5.5-6.4 2.6-9.9c7.6-1.7 5.5-11.6 5.5-11.6s8.7-3.8 1.5-12.5c5-5-1.2-8.7-1.2-8.7s2-8.7-4.3-9.6c1.7-7-11-9.3-11-9.3s-26.5 7.3-45.1 7.8c6 6.1-2.3 10-2.3 10s4.9 3.4 3.4 6.3c-1.4 3 1 6.1-5.5 8.2 8.4 3.7-.9 10.1-.9 10.1s9.3 6.4 7 9.6z"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M565.2 209.4s44.4 5.2 46.5 5.2 9.8 2.6 11.3 5.2m-55.5-13l61.9 1.4m-61.6-3s58.7-3.4 62.8-9.5m-61-3.2s59-6.4 59.5-5.5m-61.6-1.8s57.2-9 57.8-7.5m-221.1-29.4s18 19.8 16.3 33.2"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M419.3 171s5.8 8.4 8.1 9.3 22.7 2 23.9 10.8c1.1 5.5-4.4 3.7-3.5 7.8 1.4 5.2 15 12 30 4M464 207s12.2 18 30.2-1.4m-9.3 7.8s14.8 7.9 27-12.5m-15.7 14.3s7.3 6 22.4-2m20.9-8.2s22.4 4.6 23.8 6M548 200l15.7.6m-25.3-9.3s26.8-1.7 30.3 3.8M526.8 183s37.5 1.5 39.2 3.5m-30.8 34.9s6.4-1.8 7.3-1M520.7 237s8.4 7.2 19.2 4m-14.5 8.2s9.6 4.3 20.9 1.7m-17.7 5.5s9.6 6.4 16 5.3m-20.4-1.5s6.7 5 7 7.6m-16.3-1.8s2 10.5 9.3 14.3m-14.2-9.6s-3.2 13.6 4.9 22m-13.4-11.3c0 .3-.5 6.4-.2 7m-52-59.9l15.6-.8s5.8-2.4 1.8-6.1m2 3.5c.3 0 14.8 1.1 18.6 5.5 3.8 4.3 8.4 13 11 14.5 2.7 1.5 3.2-.6 3.2-.6m-6.4-2.3s-7.8 13.4-1.7 17.4m-2.6-2.6s-7 9.3-1.5 14m-1.4-1.2s-5.5 9 1.1 15.1m-3.6-39c-.3.4-6.7 4.9-9 3.8m2.3 10.4s2.6 2.7 4.9 2.3m-4.6 11.4l4.2 2.8m-3.6 7.6l3.6 2.2m-69.3-144.7s7.7 4 13.8 0c6.1-4 35.4-19 43-21.4 7.7-2.4 12-16.5 13.5-22.6m-5.8 16.5l42.8-12.5s7-5.8 7.3-16.5m-3 11.6s42.7-4.3 42.7-20.2m-6.7 11s45-12.2 49.2-16.8"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M436.2 151.5s27.2-14 31.5-15.6c4.3-1.5 14-13.8-.6-13.8"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M449.4 157c.3 0 22.3-14.4 29.6-16.2 4-5.5 1.8-11.3-4.9-10.1"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M480.9 137.1c.6-.3 11.9-.6 7.9 8.3-5.8 4.2-30.9 16.8-30.9 16.8m17.1-34.5l47.7-16s4-8.2-1.8-9.4m39.7-14.4c0 .3 6.1 3.7 2.4 9.2-6.7 4-38.4 11.6-38.4 11.6M608.9 83l-45 12.6m41.6-2.5l-39 12m35.7-2.2l-34.6 10.4m28.1-.6c-.9 0-25.6 7.6-25.6 7.6m20.2 0l-16 6.4m12 2.2a321 321 0 0 0-13.8 5.8m9.8 1.2l-12.2 5.8m-8.9 7.3s1.5.6 1.2 2.5m-32 14.3s5.1 1.9.3 6.8c-2.5 3.3-9.5 2.4-13.8 8.5m46.8-83.7s6.4 1.5 1.5 9.8c-12.8 4.9-38.8 12.8-38.8 12.8s-1.2 2.2-4.6 4a758.6 758.6 0 0 1-40.3 12.2m84.3-29.3s7 3 0 8.2c-8 4.6-35.7 13.2-35.7 13.2s-.4 2.4-1.6 3.3c-1.2 1-37.9 13.2-37.9 13.2"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M567.6 115.1s7.4 2.2 1 8.3a289 289 0 0 1-32.1 12.8s-2.5 3-6.5 4.3a919 919 0 0 0-29.3 11.6m68.8-28.7c2.1.9 8 1.8.9 7.3-8.3 3.7-28.4 11.6-28.4 11.6l-1.9 3.4-32 13.7m63.2-27.8s3 3.7-3.7 8c-7.3 4-23.2 10-23.2 10m23.2-9.4s3.4 2.1-.9 5.2c-4.9 2.4-24.1 12.5-24.1 12.5l-12.5 8.3"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M523.6 112c0 .4 5.2 4.6 3.4 9.5 4.6 3.4 3.7 7 3.7 7s6.4 3.7 5.5 9c6.4 1.5 6 5.1 6 5.1l-2 3.4s6.3-.3.8 8c3.4 1.8 1.9 3.9 1.9 3.9m-1.9-3.7c-.9 0-22.3 8-27.8 12.9"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M489.4 144.8s6.4-.3 5.5 6.7c7.4-2.5 5.8 4.6 5.8 4.6s8.6-3.4 7 7.3c5.6-1.2 4.6 4.3 4.6 4.3s5-.3 5 2.4c3.3-3 7-1.5 7-1.5s2.4-3.4 5.8-2.4m-34.9-15c0 .6-28.7 16.5-28.7 16.5m34.2-11.3L479 169.8m29-6.7c0 .3-18.9 11.3-18.9 11.3m23.2-7s-13.4 11-16.5 10.4m21.1-7s-7.6 5.7-14 8.5m22-11s2.4 3-12.9 11"
        />
      </g>
    </g>
  </svg>
	),
	AT: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#fff" d="M640 480H0V0h640z" />
      <path fill="#df0000" d="M640 480H0V320h640zm0-319.9H0V.1h640z" />
    </g>
  </svg>
	),
	AU: () => (
  <svg viewBox="0 0 640 480">
    <g strokeWidth="1pt">
      <path fill="#006" d="M0 0h640v480H0z" />
      <path
        fill="#fff"
        d="M0 0v28l307 222h38.7v-28L38.7 0H0zm345.7 0v28l-307 222H0v-28L307 0h38.7z"
      />
      <path fill="#fff" d="M144 0v250h57.6V0H144zM0 83.3v83.4h345.7V83.3H0z" />
      <path
        fill="#c00"
        d="M0 100v50h345.7v-50H0zM155.6 0v250H190V0h-34.5zM0 250l115.2-83.3H141L25.8 250H0zM0 0l115.2 83.3H89.5L0 18.6V0zm204.7 83.3L319.9 0h25.8L230.5 83.3h-25.8zm141 166.7l-115.2-83.3h25.7l89.5 64.7V250z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M299.8 392.5l-43.7 3.8 6 43.4L232 408l-30.1 31.7 6-43.4-43.7-3.8 37.7-22.3-24.3-36.5 41 15.5 13.4-41.7 13.5 41.7 41-15.5-24.3 36.5m224.4 62.3L476 416.7l17.8 6.7 5.8-18.1 5.8 18.1 17.8-6.7-10.5 15.8 16.4 9.7-19 1.7 2.6 18.9-13-13.9-13.2 13.9 2.6-18.9-19-1.6m16.4-291.9L476 134.6l17.8 6.7 5.8-18.1 5.8 18.1 17.8-6.7-10.5 15.8 16.4 9.8-19 1.6 2.6 18.9-13-13.8-13.2 13.7 2.6-18.8-19-1.6M380.8 265l-10.5-15.8 17.8 6.7 5.8-18.1 5.9 18.1 17.8-6.7L407 265l16.4 9.7-19 1.7 2.7 18.9-13.2-13.9-13 13.9 2.5-18.9-19-1.6m216.3-38L570 221l17.8 6.7 5.8-18.1 5.9 18.1 17.8-6.7-10.5 15.8 16.3 9.7-19 1.7 2.6 18.8-13-13.8-13.2 13.8 2.6-18.8-19-1.7M542 320l-10.3 6.5 2.9-11.9-9.3-7.8 12.1-1 4.6-11.2 4.7 11.3 12.1.9-9.3 7.8 2.9 11.9"
      />
    </g>
  </svg>
	),
	AW: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h288v216H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="scale(2.2222)">
      <path fill="#39c" d="M0 0v216h324V0H0z" />
      <path fill="#ff0" d="M0 144v12h324v-12H0zm0 24v12h324v-12H0z" />
    </g>
    <path fill="#9cc" d="M142.7 28l2.9 3-3-3zm-3 6l3 3-3-3m5.9 0l3 3-3-3z" />
    <path fill="#ccf" d="M139.7 37l3 2.9-3-3m5.9 0l3 3-3-3z" />
    <path fill="#6cc" d="M136.7 42.8l3 3-3-3z" />
    <path fill="#c66" d="M142.7 42.8l2.9 3-3-3z" />
    <path fill="#6cc" d="M148.6 42.8l2.9 3-3-3z" />
    <path fill="#ccf" d="M136.7 45.8l3 3-3-3zm11.9 0l2.9 3-3-3z" />
    <path fill="#fcc" d="M139.7 48.7l3 3-3-3m5.9 0l3 3-3-3z" />
    <path fill="#6cc" d="M133.8 51.7l3 3-3-3z" />
    <path
      fill="#c00"
      stroke="#fff"
      strokeWidth={3.7}
      d="M142.2 34l-20.7 78.5L42.8 134l78.4 20.5 21 78.4 20.9-78.4 78.4-21-78.4-20.9-21-78.4z"
    />
    <path fill="#6cc" d="M151.5 51.7l3 3-3-3z" />
    <path fill="#9cf" d="M133.8 54.6l3 3-3-3m17.7 0l3 3-3-3z" />
    <path fill="#fcc" d="M136.7 57.6l3 3-3-3m11.9 0l2.9 3-3-3z" />
    <path fill="#69c" d="M130.8 60.5l3 3-3-3z" />
    <path fill="#c33" d="M137.7 62.5l1 2-1-2m11.8 0l1 2-1-2z" />
    <path fill="#69c" d="M154.5 60.5l3 3-3-3z" />
    <path fill="#9cf" d="M130.8 63.5l3 3-3-3m23.7 0l3 3-3-3z" />
    <path fill="#fcc" d="M133.8 66.4l3 3-3-3m17.7 0l3 3-3-3z" />
    <path fill="#69c" d="M127.9 69.4l3 3-3-3zm29.5 0l3 3-3-3z" />
    <path fill="#9cc" d="M127.9 72.3l3 3-3-3m29.5 0l3 3-3-3z" />
    <path fill="#cff" d="M127.9 75.3l3 3-3-3m29.5 0l3 3-3-3z" />
    <path fill="#69c" d="M125 78.3l2.9 2.9-3-3z" />
    <path fill="#fcc" d="M130.8 78.3l3 2.9-3-3m23.7 0l3 3-3-3z" />
    <path fill="#69c" d="M160.4 78.3l3 2.9-3-3z" />
    <path fill="#9cc" d="M125 81.2l2.9 3-3-3z" />
    <path fill="#c33" d="M131.8 83.2l1 2-1-2m23.6 0l1 2-1-2z" />
    <path fill="#9cc" d="M160.4 81.2l3 3-3-3z" />
    <path fill="#cff" d="M125 84.2l2.9 3-3-3m35.5 0l3 3-3-3z" />
    <path fill="#fcc" d="M127.9 87.1l3 3-3-3m29.5 0l3 3-3-3z" />
    <path fill="#9cc" d="M122 90l3 3-3-3z" />
    <path fill="#c33" d="M128.9 92l1 2-1-2m29.5 0l1 2-1-2z" />
    <path fill="#9cc" d="M163.3 90l3 3-3-3z" />
    <path fill="#ccf" d="M122 93l3 3-3-3m41.3 0l3 3-3-3z" />
    <path fill="#fcc" d="M125 96l2.9 3-3-3m35.5 0l3 3-3-3z" />
    <path fill="#9cc" d="M119 99l3 2.9-3-3z" />
    <path fill="#c33" d="M126 100.9l.9 2-1-2m35.4 0l1 2-1-2z" />
    <path fill="#9cc" d="M166.3 99l3 2.9-3-3z" />
    <path fill="#ccf" d="M119 101.9l3 3-3-3m47.3 0l3 3-3-3z" />
    <path fill="#fcc" d="M122 104.8l3 3-3-3m41.3 0l3 3-3-3z" />
    <path fill="#9cc" d="M116 107.8l3 3-3-3z" />
    <path fill="#c33" d="M122 107.8l3 3-3-3m41.3 0l3 3-3-3z" />
    <path fill="#9cc" d="M169.2 107.8l3 3-3-3m-62 3l3 2.9-3-3z" />
    <path fill="#ccf" d="M110.2 110.7l3 3-3-3m65 0l2.9 3-3-3z" />
    <path fill="#9cc" d="M178 110.7l3 3-3-3m-79.6 3l3 3-3-3z" />
    <path fill="#ccf" d="M101.3 113.7l3 3-3-3z" />
    <path fill="#fcc" d="M113.1 113.7l3 3-3-3z" />
    <path fill="#c33" d="M116 113.7l3 3-3-3m53.2 0l3 3-3-3z" />
    <path fill="#fcc" d="M172.2 113.7l3 3-3-3z" />
    <path fill="#ccf" d="M184 113.7l3 3-3-3z" />
    <path fill="#9cc" d="M187 113.7l2.9 3-3-3z" />
    <path fill="#69c" d="M86.6 116.6l3 3-3-3z" />
    <path fill="#9cc" d="M89.5 116.6l3 3-3-3z" />
    <path fill="#cff" d="M92.5 116.6l3 3-3-3z" />
    <path fill="#fcc" d="M104.3 116.6l3 3-3-3z" />
    <path fill="#c33" d="M109.2 117.6l2 1-2-1m67.9 0l2 1-2-1z" />
    <path fill="#fcc" d="M181 116.6l3 3-3-3z" />
    <path fill="#cff" d="M192.8 116.6l3 3-3-3z" />
    <path fill="#9cc" d="M195.8 116.6l3 3-3-3z" />
    <path fill="#69c" d="M198.7 116.6l3 3-3-3m-121 3l3 3-3-3z" />
    <path fill="#9cc" d="M80.7 119.6l3 3-3-3z" />
    <path fill="#cff" d="M83.6 119.6l3 3-3-3z" />
    <path fill="#fcc" d="M95.4 119.6l3 3-3-3z" />
    <path fill="#c33" d="M100.3 120.6l2 1-2-1m85.6 0l2 1-2-1z" />
    <path fill="#fcc" d="M189.9 119.6l3 3-3-3z" />
    <path fill="#cff" d="M201.7 119.6l3 3-3-3z" />
    <path fill="#9cc" d="M204.6 119.6l3 3-3-3z" />
    <path fill="#69c" d="M207.6 119.6l3 3-3-3m-138.8 3l3 2.9-3-3z" />
    <path fill="#9cf" d="M71.8 122.5l3 3-3-3z" />
    <path fill="#fcc" d="M86.6 122.5l3 3-3-3z" />
    <path fill="#c33" d="M91.5 123.5l2 1-2-1m103.3 0l2 1-2-1z" />
    <path fill="#fcc" d="M198.7 122.5l3 3-3-3z" />
    <path fill="#9cf" d="M213.5 122.5l3 3-3-3z" />
    <path fill="#69c" d="M216.4 122.5l3 3-3-3z" />
    <path fill="#6cc" d="M60 125.5l3 3-3-3z" />
    <path fill="#9cf" d="M63 125.5l2.9 3-3-3z" />
    <path fill="#fcc" d="M74.8 125.5l2.9 3-3-3zm135.8 0l2.9 3-3-3z" />
    <path fill="#9cf" d="M222.3 125.5l3 3-3-3z" />
    <path fill="#6cc" d="M225.3 125.5l3 3-3-3m-174.2 3l3 2.9-3-3z" />
    <path fill="#ccf" d="M54 128.4l3 3-3-3z" />
    <path fill="#fcc" d="M65.9 128.4l3 3-3-3z" />
    <path fill="#c33" d="M70.8 129.4l2 1-2-1m144.7 0l2 1-2-1z" />
    <path fill="#fcc" d="M219.4 128.4l3 3-3-3z" />
    <path fill="#ccf" d="M231.2 128.4l3 3-3-3z" />
    <path fill="#6cc" d="M234.2 128.4l3 3-3-3z" />
    <path fill="#9cc" d="M42.3 131.4l3 3-3-3z" />
    <path fill="#ccf" d="M45.2 131.4l3 3-3-3z" />
    <path fill="#fcc" d="M57 131.4l3 3-3-3zm171.3 0l3 3-3-3z" />
    <path fill="#ccf" d="M240 131.4l3 3-3-3z" />
    <path fill="#9cc" d="M243 131.4l3 3-3-3m-206.6 3l3 2.9-3-3z" />
    <path fill="#c66" d="M51.1 134.3l3 3-3-3zm183 0l3 3-3-3z" />
    <path fill="#9cc" d="M249 134.3l2.9 3-3-3m-206.6 3l3 3-3-3z" />
    <path fill="#ccf" d="M45.2 137.3l3 3-3-3z" />
    <path fill="#fcc" d="M57 137.3l3 3-3-3m171.3 0l3 3-3-3z" />
    <path fill="#ccf" d="M240 137.3l3 3-3-3z" />
    <path fill="#9cc" d="M243 137.3l3 3-3-3z" />
    <path fill="#6cc" d="M51.1 140.3l3 2.9-3-3z" />
    <path fill="#ccf" d="M54 140.3l3 2.9-3-3z" />
    <path fill="#fcc" d="M65.9 140.3l3 2.9-3-3z" />
    <path fill="#c33" d="M70.8 141.2l2 1-2-1m144.7 0l2 1-2-1z" />
    <path fill="#fcc" d="M219.4 140.3l3 2.9-3-3z" />
    <path fill="#ccf" d="M231.2 140.3l3 2.9-3-3z" />
    <path fill="#6cc" d="M234.2 140.3l3 2.9-3-3m-174.2 3l3 3-3-3z" />
    <path fill="#9cf" d="M63 143.2l2.9 3-3-3z" />
    <path fill="#fcc" d="M74.8 143.2l2.9 3-3-3zm135.8 0l2.9 3-3-3z" />
    <path fill="#9cf" d="M222.3 143.2l3 3-3-3z" />
    <path fill="#6cc" d="M225.3 143.2l3 3-3-3z" />
    <path fill="#69c" d="M68.8 146.2l3 2.9-3-3z" />
    <path fill="#9cf" d="M71.8 146.2l3 2.9-3-3z" />
    <path fill="#fcc" d="M86.6 146.2l3 2.9-3-3z" />
    <path fill="#c33" d="M91.5 147.1l2 1-2-1m103.3 0l2 1-2-1z" />
    <path fill="#fcc" d="M198.7 146.2l3 2.9-3-3z" />
    <path fill="#9cf" d="M213.5 146.2l3 2.9-3-3z" />
    <path fill="#69c" d="M216.4 146.2l3 2.9-3-3m-138.7 3l3 3-3-3z" />
    <path fill="#9cc" d="M80.7 149.1l3 3-3-3z" />
    <path fill="#cff" d="M83.6 149.1l3 3-3-3z" />
    <path fill="#fcc" d="M95.4 149.1l3 3-3-3z" />
    <path fill="#c33" d="M100.3 150l2 1-2-1m85.6 0l2 1-2-1z" />
    <path fill="#fcc" d="M189.9 149.1l3 3-3-3z" />
    <path fill="#cff" d="M201.7 149.1l3 3-3-3z" />
    <path fill="#9cc" d="M204.6 149.1l3 3-3-3z" />
    <path fill="#69c" d="M207.6 149.1l3 3-3-3m-121 3l2.9 2.9-3-3z" />
    <path fill="#9cc" d="M89.5 152l3 3-3-3z" />
    <path fill="#cff" d="M92.5 152l3 3-3-3z" />
    <path fill="#fcc" d="M104.3 152l3 3-3-3z" />
    <path fill="#c33" d="M109.2 153l2 1-2-1m67.9 0l2 1-2-1z" />
    <path fill="#fcc" d="M181 152l3 3-3-3z" />
    <path fill="#cff" d="M192.8 152l3 3-3-3z" />
    <path fill="#9cc" d="M195.8 152l3 3-3-3z" />
    <path fill="#69c" d="M198.7 152l3 3-3-3z" />
    <path fill="#9cc" d="M98.4 155l3 3-3-3z" />
    <path fill="#ccf" d="M101.3 155l3 3-3-3z" />
    <path fill="#fcc" d="M113.1 155l3 3-3-3z" />
    <path fill="#c33" d="M116 155l3 3-3-3m53.2 0l3 3-3-3z" />
    <path fill="#fcc" d="M172.2 155l3 3-3-3z" />
    <path fill="#ccf" d="M184 155l3 3-3-3z" />
    <path fill="#9cc" d="M187 155l2.9 3-3-3m-79.7 3l3 3-3-3z" />
    <path fill="#ccf" d="M110.2 158l3 3-3-3m65 0l2.9 3-3-3z" />
    <path fill="#9cc" d="M178 158l3 3-3-3m-62 3l3 2.9-3-3z" />
    <path fill="#c33" d="M122 161l3 2.9-3-3m41.3 0l3 3-3-3z" />
    <path fill="#9cc" d="M169.2 161l3 2.9-3-3z" />
    <path fill="#fcc" d="M122 163.9l3 3-3-3m41.3 0l3 3-3-3z" />
    <path fill="#ccf" d="M119 166.8l3 3-3-3z" />
    <path fill="#c33" d="M126 168.8l.9 2-1-2m35.4 0l1 2-1-2z" />
    <path fill="#ccf" d="M166.3 166.8l3 3-3-3z" />
    <path fill="#9cc" d="M119 169.8l3 3-3-3m47.3 0l3 3-3-3z" />
    <path fill="#fcc" d="M125 172.7l2.9 3-3-3m35.5 0l3 3-3-3z" />
    <path fill="#ccf" d="M122 175.7l3 3-3-3z" />
    <path fill="#c33" d="M128.9 177.6l1 2-1-2m29.5 0l1 2-1-2z" />
    <path fill="#ccf" d="M163.3 175.7l3 3-3-3z" />
    <path fill="#9cc" d="M122 178.6l3 3-3-3m41.3 0l3 3-3-3z" />
    <path fill="#fcc" d="M127.9 181.6l3 3-3-3m29.5 0l3 3-3-3z" />
    <path fill="#cff" d="M125 184.5l2.9 3-3-3z" />
    <path fill="#c33" d="M131.8 186.5l1 2-1-2m23.6 0l1 2-1-2z" />
    <path fill="#cff" d="M160.4 184.5l3 3-3-3z" />
    <path fill="#9cc" d="M125 187.5l2.9 3-3-3m35.5 0l3 3-3-3z" />
    <path fill="#69c" d="M125 190.4l2.9 3-3-3z" />
    <path fill="#fcc" d="M130.8 190.4l3 3-3-3m23.7 0l3 3-3-3z" />
    <path fill="#69c" d="M160.4 190.4l3 3-3-3z" />
    <path fill="#cff" d="M127.9 193.4l3 3-3-3zm29.5 0l3 3-3-3z" />
    <path fill="#9cc" d="M127.9 196.3l3 3-3-3m29.5 0l3 3-3-3z" />
    <path fill="#69c" d="M127.9 199.3l3 3-3-3m29.5 0l3 3-3-3z" />
    <path fill="#fcc" d="M133.8 202.2l3 3-3-3m17.7 0l3 3-3-3z" />
    <path fill="#9cf" d="M130.8 205.2l3 3-3-3z" />
    <path fill="#c33" d="M137.7 207.2l1 2-1-2m11.8 0l1 2-1-2z" />
    <path fill="#9cf" d="M154.5 205.2l3 3-3-3z" />
    <path fill="#69c" d="M130.8 208.2l3 2.9-3-3m23.7 0l3 3-3-3z" />
    <path fill="#fcc" d="M136.7 211.1l3 3-3-3m11.9 0l2.9 3-3-3z" />
    <path fill="#9cf" d="M133.8 214l3 3-3-3zm17.7 0l3 3-3-3z" />
    <path fill="#6cc" d="M133.8 217l3 3-3-3m17.7 0l3 3-3-3z" />
    <path fill="#fcc" d="M139.7 220l3 3-3-3m5.9 0l3 3-3-3z" />
    <path fill="#ccf" d="M136.7 222.9l3 3-3-3m11.9 0l2.9 3-3-3z" />
    <path fill="#6cc" d="M136.7 225.9l3 3-3-3z" />
    <path fill="#c66" d="M142.7 225.9l2.9 3-3-3z" />
    <path fill="#6cc" d="M148.6 225.9l2.9 3-3-3z" />
    <path fill="#ccf" d="M139.7 231.8l3 3-3-3m5.9 0l3 3-3-3z" />
    <path fill="#9cc" d="M139.7 234.7l3 3-3-3m5.9 0l3 3-3-3m-3 6l3 2.9-3-3z" />
  </svg>
	),
	AX: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M106.3 0h1133.3v850H106.3z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="matrix(.56472 0 0 .56482 -60 -.1)">
      <path fill="#0053a5" d="M0 0h1300v850H0z" />
      <g fill="#ffce00">
        <path d="M400 0h250v850H400z" />
        <path d="M0 300h1300v250H0z" />
      </g>
      <g fill="#d21034">
        <path d="M475 0h100v850H475z" />
        <path d="M0 375h1300v100H0z" />
      </g>
    </g>
  </svg>
	),
	AZ: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#3f9c35" d="M.1 0h640v480H.1z" />
    <path fill="#ed2939" d="M.1 0h640v320H.1z" />
    <path fill="#00b9e4" d="M.1 0h640v160H.1z" />
    <circle cx={304} cy={240} r={72} fill="#fff" />
    <circle cx={320} cy={240} r={60} fill="#ed2939" />
    <path
      fill="#fff"
      d="M384 200l7.7 21.5 20.6-9.8-9.8 20.7L424 240l-21.5 7.7 9.8 20.6-20.6-9.8L384 280l-7.7-21.5-20.6 9.8 9.8-20.6L344 240l21.5-7.7-9.8-20.6 20.6 9.8L384 200z"
    />
  </svg>
	),
	BA: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-85.3 0h682.6v512H-85.3z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(80) scale(.9375)"
    >
      <path fill="#009" d="M-85.3 0h682.6v512H-85.3V0z" />
      <path fill="#FC0" d="M56.5 0l511 512.3V.3L56.5 0z" />
      <path
        fill="#FFF"
        d="M439.9 481.5L412 461.2l-28.6 20.2 10.8-33.2-28.2-20.5h35l10.8-33.2 10.7 33.3h35l-28 20.7 10.4 33zm81.3 10.4l-35-.1-10.7-33.3-10.8 33.2h-35l28.2 20.5-10.8 33.2 28.6-20.2 28 20.3-10.5-33 28-20.6zM365.6 384.7l28-20.7-35-.1-10.7-33.2-10.8 33.2-35-.1 28.2 20.5-10.8 33.3 28.6-20.3 28 20.4-10.5-33zm-64.3-64.5l28-20.6-35-.1-10.7-33.3-10.9 33.2h-34.9l28.2 20.5-10.8 33.2 28.6-20.2 27.9 20.3-10.4-33zm-63.7-63.6l28-20.7h-35L220 202.5l-10.8 33.2h-35l28.2 20.4-10.8 33.3 28.6-20.3 28 20.4-10.5-33zm-64.4-64.3l28-20.6-35-.1-10.7-33.3-10.9 33.2h-34.9L138 192l-10.8 33.2 28.6-20.2 27.9 20.3-10.4-33zm-63.6-63.9l27.9-20.7h-35L91.9 74.3 81 107.6H46L74.4 128l-10.9 33.2L92.1 141l27.8 20.4-10.3-33zm-64-64l27.9-20.7h-35L27.9 10.3 17 43.6h-35L10.4 64l-11 33.3L28.1 77l27.8 20.4-10.3-33zm-64-64L9.4-20.3h-35l-10.7-33.3L-47-20.4h-35L-53.7 0l-10.8 33.2L-35.9 13l27.8 20.4-10.3-33z"
      />
    </g>
  </svg>
	),
	BB: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#00267f" d="M0 0h640v480H0z" />
    <path fill="#ffc726" d="M213.3 0h213.4v480H213.3z" />
    <path
      id="prefix__a"
      d="M319.8 135.5c-7 19-14 38.6-29.2 53.7 4.7-1.6 13-3 18.2-2.8v79.5l-22.4 3.3c-.8 0-1-1.3-1-3-2.2-24.7-8-45.5-14.8-67-.5-2.9-9-14-2.4-12 .8 0 9.5 3.6 8.2 1.9a85 85 0 0 0-46.4-24c-1.5-.3-2.4.5-1 2.2 22.4 34.6 41.3 75.5 41.1 124 8.8 0 30-5.2 38.7-5.2v56.1H320l2.5-156.7z"
    />
    <use
      width="100%"
      height="100%"
      transform="matrix(-1 0 0 1 639.5 0)"
      xlinkHref="#prefix__a"
    />
  </svg>
	),
	BD: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#006a4e" d="M0 0h640v480H0z" />
    <circle cx={280} cy={240} r={160} fill="#f42a41" />
  </svg>
	),
	BE: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path d="M0 0h213.3v480H0z" />
      <path fill="#ffd90c" d="M213.3 0h213.4v480H213.3z" />
      <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	BF: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#de0000" d="M640 479.6H.4V0H640z" />
      <path fill="#35a100" d="M639.6 480H0V240.2h639.6z" />
      <path
        fill="#fff300"
        d="M254.6 276.2l-106-72.4h131L320 86.6 360.4 204l131-.1-106 72.4 40.5 117.3-106-72.6L214 393.4"
      />
    </g>
  </svg>
	),
	BG: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#d62612" d="M0 320h640v160H0z" />
      <path fill="#fff" d="M0 0h640v160H0z" />
      <path fill="#00966e" d="M0 160h640v160H0z" />
    </g>
  </svg>
	),
	BH: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h640v480H0z" />
      </clipPath>
    </defs>
    <g fillRule="evenodd" strokeWidth="1pt" clipPath="url(#prefix__a)">
      <path fill="#e10011" d="M-32.5 0h720v480h-720z" />
      <path
        fill="#fff"
        d="M114.3 479.8l-146.8.2V0h146l94.3 30.4-93.5 29.5 93.5 30.5-93.5 29.5 93.5 30.5-93.5 29.5 93.5 30.5-93.5 29.5 93.5 30.5-93.5 29.5 93.5 30.5-93.5 29.5 93.5 30.5-93.5 29.5 93.5 30.5-93.5 29.5"
      />
    </g>
  </svg>
	),
	BI: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-90.5 0H592v512H-90.5z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(84.9) scale(.9375)"
    >
      <path
        fill="#00cf00"
        d="M-178 0l428.8 256L-178 512zm857.6 0L250.8 256l428.8 256z"
      />
      <path
        fill="red"
        d="M-178 0l428.8 256L679.6 0zm0 512l428.8-256 428.8 256z"
      />
      <path fill="#fff" d="M679.6 0h-79.9L-178 464.3V512h79.9L679.6 47.7z" />
      <path
        fill="#fff"
        d="M398.9 256a148 148 0 1 1-296.1 0 148 148 0 0 1 296 0z"
      />
      <path fill="#fff" d="M-178 0v47.7L599.7 512h79.9v-47.7L-98.1 0z" />
      <path
        fill="red"
        stroke="#00de00"
        strokeWidth={3.9}
        d="M280 200.2l-19.3.3-10 16.4-9.9-16.4-19.2-.4 9.3-16.9-9.2-16.8 19.2-.4 10-16.4 9.9 16.5 19.2.4-9.3 16.8zm-64.6 111.6l-19.2.3-10 16.4-9.9-16.4-19.2-.4 9.3-16.9-9.2-16.8 19.2-.4 10-16.4 9.9 16.5 19.2.4-9.3 16.8zm130.6 0l-19.2.3-10 16.4-10-16.4-19.1-.4 9.3-16.9-9.3-16.8 19.2-.4 10-16.4 10 16.5 19.2.4-9.4 16.8z"
      />
    </g>
  </svg>
	),
	BJ: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fill="gray" d="M67.6-154h666v666h-666z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="matrix(.961 0 0 .7207 -65 111)">
      <g fillRule="evenodd" strokeWidth="1pt">
        <path fill="#319400" d="M0-154h333v666H0z" />
        <path fill="#ffd600" d="M333-154h666v333H333z" />
        <path fill="#de2110" d="M333 179h666v333H333z" />
      </g>
    </g>
  </svg>
	),
	BL: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#00267f" d="M0 0h213.3v480H0z" />
      <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	BM: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#cf142b" d="M0 0h640v480H0z" />
    <path fill="#00247d" d="M0 0h320v160H0z" />
    <path
      fill="#fff"
      d="M0 0v17.9L284.2 160H320v-17.9L35.8 0H0zm320 0v17.9L35.8 160H0v-17.9L284.2 0H320z"
    />
    <path fill="#fff" d="M133.3 0v160h53.4V0h-53.4zM0 53.3v53.4h320V53.3H0z" />
    <path
      fill="#cf142b"
      d="M0 64v32h320V64H0zM144 0v160h32V0h-32zM0 160l106.7-53.3h23.8L23.8 160H0zM0 0l106.7 53.3H82.8L0 12V0zm189.5 53.3L296 0h24L213.3 53.3h-23.8zM320 160l-106.7-53.3h23.9L320 148v12z"
    />
    <path
      fill="#fff"
      d="M553.8 148.3v135.5c0 36.2-72.3 48-72.3 48S409 320 409 283.7V148.3h144.7z"
    />
    <path
      fill="#2f8f22"
      d="M553.8 283.8c0 36.2-72.3 48-72.3 48S409 320 409 283.7c0 0 0-3 1.5-4.6 0 0-.8 6 3.8 10.6 0 0-3.6-6.5 0-12.8 0 0-1.4 8.2 3.7 12.8 0 0-2.8-6.6.3-14 0 0-1.5 12 4 14.5 0 0 1.5-7-.7-11.4 0 0 3.8 1.5 3.6 11.6 0 0 1.2-1.5 1.5-8.8 0 0 .2 8.4 3 10.3 0 0 1-.9-.3-4.6s.5-5.1.8-5c0 0-.6 4.1 2.9 7.3 0 0-1.5-6.6.6-7.5 0 0-.5 5.6 4 6.8 0 0 .3-1.6-.7-3.4 0 0-.8-2.1-.2-3.8 0 0 1.4 5 3.3 5.9 0 0-1.1-3 0-5.9 0 0 .2 4.2 4 6 0 0-2.5-3.3-1.6-6.9l24.1 1.2 12.5.6 37.5-2.6 6.4-5.6s2.6 3.5-1.5 9.1c0 0 4-.7 5.3-7 0 0 1.6 3.5-.6 7.4 0 0 4.4-4.5 5-9.5 0 0 1.8 4.9-2.4 10.1 0 0 3.7-1.3 5.3-6.8 0 0 1.3 3.3-2.3 8 0 0 6.8-3.5 6.6-11 0 0 2.8 4.1-.4 9.8 0 0 3.4-3.1 3.8-7.8 0 0 1.9 2.1-.2 7.9 0 0 4.2-4 4.9-8.3 0 0 .9 4-2.7 9 0 0 2.4-.6 4.8-5.5 0 0 .6 2-1.5 5.5 0 0 2.3-.4 3.8-4.9 0 0 .3 2.7-.4 5 0 0 1.8-1.1 2.2-6.1 0 0 1 1.6 1 3.7v.7z"
    />
    <path
      fill="#d40000"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M516.6 205.4s-2.5.5-5.8-.5c-3.2-1-4.5-.6-5.5 0 0 0 1.3-2.6-1.9-4.7 0 0 1 2.7-.4 3.9 0 0-.6.6-1.4-.3 0 0-1.1-1.2-2.3-2 0 0 2.7-1 2.2-3.8-.5-2.7-2-3-2.7-3.4a5 5 0 0 0 0 2s-3-1.6 1-3.9 3.3-3.7 2.6-4.9a11 11 0 0 0-3-3s.8 1.3.6 2.4c-.1 1-2 1.7-1.6-.1.4-2 0-1.6 0-3.6 0 0 3.5 1.2 5-2.3 0 0 1.3-3.6-3.2-5.4 0 0 1.1 1.5.6 2.6 0 0-1 1.8-2.1.4s-1.9-1.8-1.8-3.5c0 0 4.1.6 3-3.9 0 0-.7 3-6-1 0 0 3.5-3.6 2.1-6.4 0 0-.4-1.3-4.1-.6 0 0 3.2-2 1.9-3.8 0 0-.7-1.1-3.8.4 0 0 1.2-2-1.8-4.2 0 0-2 1-3 2 0 0-2-2.6-3.3-3.6 0 0-2.4.9-3 3.6 0 0-1.1-1.3-3.6-2 0 0-1.2 2.3.4 4.2 0 0-1.2 0-3.3-1 0 0-2.4-1-2 1 .3 2 .5 2.5 1 3.5 0 0-5.4-1.3-5.2 1.7a7.4 7.4 0 0 0 2.6 5.2s-3 4-5.6 1c0 0-1 1 1 3.5 0 0 2 2.1.3 3.5 0 0-2.1 1.7-3.1-1.6 0 0-3.5 3.4.6 6 0 0 2.6 1.5 5.3-.8 0 0-.9 6.6-3.4 5.3 0 0-1.5-1 1.2-2.4 0 0-4-.5-4.6 3.3 0 0-.5 3 3 4.2 0 0 2.6 1-.1 3 0 0-2 1.5-.7 3.7 0 0 1.5 2.4-2.4 2.7 0 0-2 0-2.8-.3 0 0-.9 1.6-.3 3.4 0 0-2-1.5-6.3.1-4.4 1.6-4.1.5-4.4 1l-1.3 2s2.3 3 2.4 2.8l-.5 3.3 1.2.5 9-4 9.3-4.8 7.4.4 4.7 1.1 6.1.5 4.5-2.4h6.4l7 3.5 8 4.8 4.2.8 3.2-.2v-6.5l-1.5-2.4z"
    />
    <path
      fill="#d40000"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M443.5 213s3.5 1.8 5-.3c0 0 1.9-3.7-2.3-5 0 0 2.3-2.7-.2-5.2 0 0-1.3-1.4-3.5-.4 0 0-1-2-3.1-1.9 0 0-2 0-2.6 2.1 0 0-2.6-1-4 .5 0 0-2.5 2.7.9 4.9l2.4.2 2.4-1.1 2.7.7s-.7 2.7 2.3 5.5z"
    />
    <path
      fill="#64b4d1"
      stroke="#000"
      strokeWidth={0.4}
      d="M521.8 206.6a5.6 5.6 0 0 1 5.8 3.2c2.2 5.2-2.5 8-2.5 8 .3 1.1.4 2.7.4 2.7 6.6.8 5.4 8.2 5.4 8.2l-2.2-1.8c-3.8-1.5-7.8 1.8-10.6 7.2-2.8 5.5-1.5 8-1 14.5s11 10.4 11 10.4l-8.2 21c-3.2 8.3-10 4.9-12 3.1-1.9-1.7-2.4-.7-3.3 0-1 .8 4.4 5-5.5 9-9.8 4-11.5 7-13.2 8-1.6 1-8.4.4-9-.5-.8-.8-.4-.8-3-2.4-2.5-1.5-6.8-3-11.5-5.2-4.7-2.3-4.6-5.2-4.5-5.8 0-.6 1.6-5.5-3.9-1.6s-10.2-1.9-10.2-1.9c-1-1.4-5.7-13.7-5.7-13.7a77.5 77.5 0 0 0-3.6-10s-.3.6 3.8-1.7c4-2.3 5.9-6.2 7.3-10 1.4-3.9 0-10.5-.5-11.8s-3.5-7.4-7.3-8.7c-3.7-1.3-6.3 2-6.3 2s-1.1-7.5 5.5-8.3c0 0 0-1.6.4-2.7 0 0-4.7-2.8-2.5-8 0 0 1.5-3.6 5.7-3.2l-1 2s-1 10.6 14.5 3.5c15.5-7.2 15-8.5 24-4l6.4-.1s9.3-4.4 12.3-2.5c3 1.9 13.7 7.9 13.7 7.9s10.4 3.9 12.5-3.3l-1.2-3.5z"
    />
    <path
      fill="#fff"
      stroke="#00247d"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M475 252.7s-.5-3.3-1-5.4c0 0-1.2-3.3.8-5.7l2.4-2.8s1.5-2 3.4-2.3c0 0 1.9 0 2-.4.2-.4 2.3-3.8 7.2 0 0 0 1.5-2.5 4-3 0 0 2.5-.7 3.8 1.2 0 0 2.9-2.2 5.4 1.4 0 0 3.4-2 6 1.9 0 0 3.3-1.7 5.4 1.8 2.1 3.6 1.7 5 1.7 5l1.6 5.7 5.5 6.8-12.8 4.8h-5.8l-11.5 3-20.4 1.6-5.6-6.7 8-7z"
    />
    <path
      fill="#d40000"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M457.8 286.6s-3 .1-4.6 1c-1.5.7-2.7 1.5-4.5 2.7 0 0-.9 1.1-4.4.4 0 0-6-1.4-6 3.3 0 0-7.4.6-4.4 7 0 0 2 5 6.2 1.5 0 0-2.7 3.8 2.5 5.3 0 0 3.7 1 4.8-2.9 0 0 .6-1.5-.8-3.3 0 0 1.8-.4 3-2.3 0 0-3.8 4.8.4 6.6 0 0 5.3 1.3 5.6-4.2 0 0-.5-2.6 1.6-3.5 0 0 4.2-1 6-5.6 0 0-6-3.2-5.4-6zm-12.3-48.2s-4.7-2.1-7 0c0 0-3-1.9-6.3 0 0 0-3.1 2-5.3 4.3 0 0-1.5 1.3-1 5.4 0 0 .9 2.9.4 4.3 0 0-1-.2-3.1 2.3 0 0-2.6 3-5 .3 0 0 .8 3.8 5.1 3.2 0 0-2.1 1.6-.3 5.9 0 0 1.4 3-.8 6.8 0 0 3.8-1.5 3.7-6 0 0-.4-3 .8-5.1 0 0-1.2 1.9 1.4 6 0 0 2 3 .4 6 0 0 3.7-1.3 3.4-5.8-.4-4.6-2.6-2.7-1.2-6.9 0 0 .4 2.2 1.5 3.3a6 6 0 0 1 2 5.9s2.2-2.8 1.7-5.7a11 11 0 0 0-1.1-3.7l7-4 3.6-6.3.1-10.2z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M434.8 256.4s-3-.2-3.4-2.5m-5.1-1.5s1 0 2 1c0 0 .6 1 1.6.8"
    />
    <path d="M439.1 247.8s-1.5 0-2.4-.7c0 0-.8-.6-1.3.3 0 0-.8 1.4.6 2 0 0 1.9 1-1 2.8 0 0 3.4-1.3 2-3 0 0-1.5-1-1-1.4 0 0 .2-.4.8 0 .6.5 1.8.3 2.3 0z" />
    <path
      fill="#784421"
      stroke="#000"
      strokeWidth={0.4}
      d="M484.9 256l1.8-.5-11.7-40.3-.4.1z"
    />
    <path d="M446 300.7s-2.7-1.6-5 .2c0 0 .3-1 2-1.4 0 0 1-2.7 3.6-2.4 0 0-1.1 1.3-2.5 2.3 0 0 1.5.2 2 1.3z" />
    <path
      fill="#64b4d1"
      stroke="#00247d"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M436.4 307s-4.4-2.7-2-7.3c0 0 .7-1.3 2-1 0 0 2.7.8.6 4.6 0 0-1.1 2.4-.6 3.8zm8.8 4.4s-6.2-2.8-4.3-7.7c0 0 .6-1.6 2-1.5 0 0 2.4.2 1.9 3.4 0 0-.7 3 .4 5.8z"
    />
    <path d="M443.9 293.4s-1.9 1.4-2.6 2.3c0 0-.8-1-1.8-1.5 0 0 1.2-.2 1.8.3 0 0 1-.9 2.6-1.1z" />
    <path
      fill="#64b4d1"
      stroke="#00247d"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M449.4 310.2s5-1.2 4-6.3c0 0-.5-2.2-2.5-1.9 0 0-2.5.7-.9 3.9 0 0 1 2.2-.6 4.3z"
    />
    <path
      fill="#f5ce00"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M471.5 203.7l4.8 1.6s4.5 2 10.3 0l4.4-1.7-3 4.6v2.4l1.8 2.7s-1.1.5-4.5-1.6c0 0-3.7-2.9-8.1 0 0 0-2.5 1.6-4.5 1.6l2.9-3.2-1.1-2.9-3-3.6z"
    />
    <path
      fill="#fff"
      d="M451.3 304.2s.2-.3 0-.4l-.4.2s-.5.8 0 2c0 0 .4.7.2 1.5l.1.3s.2-.1.2-.3c0 0 .3-.7-.2-1.5 0 0-.5-1.2.1-1.8z"
    />
    <path
      fill="#d40000"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M518.8 213s-3.5 1.8-5-.3c0 0-1.8-3.7 2.4-5 0 0-2.3-2.7.1-5.2 0 0 1.3-1.4 3.5-.4 0 0 1-2 3.1-1.9 0 0 2 0 2.6 2.1 0 0 2.7-1 4.1.5 0 0 2.4 2.7-1 4.9l-2.4.2-2.4-1.1-2.6.7s.7 2.7-2.4 5.5z"
    />
    <path
      fill="#f5ce00"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M491 210.2s0 .7-.7.8c0 0-.8.3-1.3-.7v-.3c0-.4-.2-1.7 1.2-2.7 0 0 2.2-1.8 6.4.4A161 161 0 0 0 509 214s2.6 1.3 6.6 1.5c0 0 5.5.4 7.8-3.5 0 0 1.8-2.9 0-4.8 0 0-.7-.8-1.9-.7-.4.1-1 .3-1.5 1 0 0-.9 1.2.1 2.1 0 0 1.3.8 1.8-.9 0 .2.4 1.5-.3 2.5 0 0-3.4 5-12.5-.1l-12-6.8s-6-3.1-9.7 1.8c0 0-2.9 4 .9 6.6 0 0 2.8 1.7 4.5-1 0 0 1.5-2.6-.8-3.7 0 0-2-1-2.8 1-.8 2 1.5 2.6 1.7 1.1 0 0 0-.3.2 0z"
    />
    <path
      fill="#e4cb5e"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M443.3 231v-7.6c0-.6 0-1 1-1.8.8-.7 1.8-1.9 3.1 1.4 0 0 2.7-2.9 3.6-3.3 0 0 1.6-1.3 2.7.6 0 0 1.4-2.2 2.5-2.7 0 0 2.7-1.7 2.8 3.5l2.1-2s1.7-1.3 3.5.6c0 0 3 3 3.4 3.8 0 0 .7.9.8 2.3 0 0 0 1.6.8 2.5 0 0 1 .9 1.9 1 0 0 2.1.1 3 2.2 0 0 .3-.4 1.4 9.4v18l-12.1 14.4-19.4-5.6-7.7-3.2-1.8-5.6 7.5-4.9 4-11-1.2-7.7-1.9-4.4z"
    />
    <path
      fill="#784421"
      stroke="#000"
      strokeWidth={0.4}
      d="M496.7 240.4l1-1.3 2.1-1.7s3.4 8.8 3.5 10.7v2.7s5 1.3 6 9l-4.2 7.7-6.5-3.7-1.9-1.3v-22z"
    />
    <path
      fill="#fff"
      d="M435.2 300.8s.2-.3 0-.5l-.4.3s-1.3 1.4-.2 3.7c0 0 0 .3.3.2 0 0 .2 0 0-.3 0 0-1-2 .3-3.4z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M454.8 299.3s.1-.7-.3-1.4c0 0-.3-.5-.2-1.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M459 221.1s0 1.9.6 3.3c.5 1.4 2.4 3.8 2.5 5"
    />
    <path
      fill="#d40000"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M504.6 286.6s3 .1 4.6 1c1.6.7 2.8 1.5 4.6 2.7 0 0 .8 1.1 4.3.4 0 0 6.1-1.4 6.1 3.3 0 0 7.3.6 4.3 7 0 0-2 5-6.2 1.5 0 0 2.7 3.8-2.5 5.3 0 0-3.7 1-4.8-2.9 0 0-.6-1.5.9-3.3 0 0-1.8-.4-3-2.3 0 0 3.8 4.8-.4 6.6 0 0-5.3 1.3-5.6-4.2 0 0 .4-2.6-1.6-3.5 0 0-4.2-1-6.1-5.6 0 0 6-3.2 5.4-6z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M456.6 229.5l5 40.1m-3.8-40.2l5.6 37.4m-4.6-37.6l6.5 37.1"
    />
    <path
      fill="#784421"
      stroke="#000"
      strokeWidth={0.4}
      d="M469 263.1l1.8-.6-11.7-40.2h-.4z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M462.4 227.7l11.8 29.8m-12.6-29.3l11.4 31"
    />
    <path
      fill="#fff"
      d="M443 308.5s-1.4-1.3-1.2-3.6c0 0 0-.5-.2-.6 0 0-.3-.1-.3.5 0 0-.4 2.4 1.3 3.8 0 0 .1.2.3.1 0 0 .2 0 0-.2z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M463 227.3l12 27.2M459.7 229l7.5 36.6"
    />
    <path
      fill="#f5ce00"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M520.5 256c-5.3-3-6.5-9.6-6.5-9.6a20.6 20.6 0 0 1 1.4-12c3.4-7.2 9.3-8.6 9.3-8.6s-5.8 4-7.4 9.4c0 0-1.2 4.6-.5 9 .7 4.6.4 3.4 1.5 6.9l2.2 5z"
    />
    <path
      fill="#784421"
      stroke="#000"
      strokeWidth={0.2}
      d="M497.6 239l-22.3 7.1-1.2 10c-5.3 7.7-16.1 9-16.1 9l8.4 9 16 3.3 8.5-6.5 7.7-7c-.8-3.8-.4-9.4-.4-9.4 0-1 .4-3.2.4-3.2s-1.3-9-1-12.2z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M474.4 253.6s14.7-4.6 23.5-8.3M467.3 262s18.4-3.3 31.3-10.7l4.7-3.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M503.3 250.8l-5 3.7s-20.6 9.4-36.3 9.7m36.2-3s-15.8 8.1-24.8 8.2"
    />
    <path
      fill="#d40000"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M517 238.4s4.7-2.1 7 0c0 0 3-1.9 6.4 0 0 0 3 2 5.2 4.3 0 0 1.5 1.3 1 5.4 0 0-.8 2.9-.3 4.3 0 0 1-.2 3 2.3 0 0 2.7 3 5 .3 0 0-.7 3.8-5 3.2 0 0 2 1.6.2 5.9 0 0-1.3 3 .8 6.8 0 0-3.8-1.5-3.6-6 0 0 .3-3-.8-5.1 0 0 1.1 1.9-1.5 6 0 0-2 3-.3 6 0 0-3.8-1.3-3.4-5.8.3-4.6 2.6-2.7 1.1-6.9 0 0-.3 2.2-1.4 3.3a6 6 0 0 0-2 5.9s-2.2-2.8-1.7-5.7 1-3.7 1-3.7l-7-4-3.5-6.3-.2-10.2z"
    />
    <path
      fill="#fff"
      stroke="#00247d"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M437.1 263.9s.7-3.1 3.6-2c0 0 1-5 6.5-5.2 5.4-.2 5.7 5.3 5.7 5.7 0 0 1.7-2.4 4.3-2.1 0 0 4.6-.3 3 7.1l.8 1s3.5-8.3 10.7-6.2c0 0 7 2.2 2.5 9 0 0 3.5 4.6 6.4 4.1 3-.4 5.6-1.3 8.5-6.5 3-5.2 9.8-6 11.5-5.7 1.7.3 3.1 1.5 3.4 2.7 0 0 3.6-12 16.6-10.2l5.2 2.7 2 .9-3 8.3-7.1 16.2-5.5 1.6-5.7-3.2-2 1-.1 4.9-7.5 5.4-5.2 2.1-5.7 4-1.4 3.5s-3.1-1.4-6.7 0l-1.2-3-3.4-3.1-13-6.2-2.3-7.6-2.4-1-2.7 3-3.8.5-5.8-4L437 264z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M493.8 204.9s-5-.2-4.8 5"
    />
    <path
      fill="#f5ce00"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M526.4 259.6c-8.6-2.7-11-12-11-12a21.4 21.4 0 0 1 1.1-13c4-9.3 10.6-9.3 10.6-9.3a3.4 3.4 0 0 1 3.8 2.8c.3 2-1.1 2.7-1.1 2.7-2.3 1.3-3.8-.4-3.8-.4-1-1.3-.2-2.4-.2-2.4.6-.8 1.7-.4 1.7-.4 1 .2.8 1.4.8 1.4s.3-1.4-1-1.5c0 0-2.7-.6-5.7 3.2 0 0-4 5.1-4 11.8 0 0-.5 12.4 12.4 15.6 0 0-1.4 2-3.9 9.3 0 0-2.8 9.4-5.4 14.5 0 0-3.6 7.2-11.6 4.3 0 0-4.7-2.1-4.7-5.5 0 0-.3-3.2 2.5-3.4 0 0 2.8-.2 2.8 2.2 0 0 0 2.5-3 2 0 0-1-.3-.9-1.3 0 0 .2-1 1.5-.5s0 0 0-.1c0 0-.5-.2-1 0 0 0-.5.1-.5.9 0 0 0 .5.6.9l1.4.2s.8 1.6 2.6 2.2c2.5.7 4.6 0 5.9-1a9 9 0 0 0 2.5-3.6 95 95 0 0 0 4.4-11.3s1.5-4.8 2.8-7.3l.4-1z"
    />
    <path
      fill="#f5ce00"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M502 283.2s1.7-.2 1.7 1.2c0 0-.1 2-2.7 1.6 0 0-2.5-.5-1.6-3.3 0 0 .6-2 3-1.7 0 0 2.3 0 3.3 3.2 0 0 .8 2.7-.6 5-1.5 2.5-5.2 4.2-7 5 0 0-7.3 2.8-9.5 4.5 0 0-3.3 2.4-1.8 4.7 0 0 .6.9 1.4.9 0 0 1 0 1.1-1 0 0 0 .6-.6.9 0 0-.7.3-1.4-.3 0 0-.8-.8-.2-2 0 0 .9-1.4 3-.5 0 0 1.7.9 1 2.7 0 0-.7 1.8-2.8 1.7 0 0-1.6 0-2.7-1-1.6-1.8-1.7-5-.2-6.7 0 0 1.3-1.8 4-3l7.5-3c2.2-.9 4.1-1.9 5.4-3.4 0 0 1.1-1.2 1.5-3.4 0 0 .3-1.6-.7-2l-1-.2z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M502.2 283.2s1.8-.4 2.9 1.8c0 0 .6 1.3.7 2.1m.6-7.6s-1.8.3-.9 2.9c1 2.4 2.5 3.1 3 3.5"
    />
    <path
      fill="#f5ce00"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M471.5 210.2s0 .7.8.8c0 0 .7.2 1.1-.7l.1-.3c0-.4.2-1.7-1.1-2.7 0 0-2.3-1.8-6.5.4 0 0-3.3 1.6-5.6 3 0 0-6 3.2-6.8 3.4 0 0-2.6 1.3-6.6 1.5 0 0-5.5.4-7.8-3.5 0 0-1.8-2.9 0-4.8 0 0 .7-.8 1.9-.7.5.1 1 .3 1.5 1 0 0 .9 1.2-.1 2.1 0 0-1.3.8-1.8-.9 0 .2-.3 1.4.4 2.5 0 0 3.3 5 12.4-.2l12-6.7s6-3.1 9.7 1.7c0 0 2.9 4-.8 6.7 0 0-2.8 1.7-4.6-1 0 0-1.4-2.6.8-3.7 0 0 2-1 2.9 1 .8 2-1.6 2.6-1.8 1.1 0 0 0-.3-.1 0zM442 256.1c5.3-3 6.5-9.7 6.5-9.7 1.2-6.7-1.4-12-1.4-12-3.4-7.2-9.3-8.6-9.3-8.6s5.8 4 7.4 9.4c0 0 1.3 4.6.5 9-.7 4.6-.4 3.4-1.5 6.9l-2.2 5z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M468.8 204.9s5-.2 4.7 5"
    />
    <path
      fill="#f5ce00"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M436 259.6c8.7-2.7 11-12 11-12a21.4 21.4 0 0 0-1-13c-4-9.3-10.6-9.3-10.6-9.3a3.4 3.4 0 0 0-3.8 2.8c-.3 2 1.1 2.7 1.1 2.7 2.3 1.3 3.8-.4 3.8-.4 1-1.3.2-2.4.2-2.4-.6-.8-1.7-.4-1.7-.4-1 .2-.8 1.4-.8 1.4s-.3-1.4 1-1.5c0 0 2.7-.6 5.7 3.2 0 0 4 5.1 4 11.8 0 0 .5 12.4-12.4 15.6 0 0 1.4 2 3.9 9.3 0 0 2.8 9.4 5.5 14.5 0 0 3.5 7.2 11.5 4.3 0 0 4.7-2.1 4.7-5.5 0 0 .3-3.2-2.5-3.4 0 0-2.8-.2-2.8 2.2 0 0 0 2.5 3 2 0 0 1-.3.9-1.3 0 0-.2-1-1.5-.5s0 0 0-.1c0 0 .5-.2 1 0 0 0 .5.1.5.9 0 0 0 .5-.6.9l-1.3.2s-.8 1.6-2.7 2.2a6.3 6.3 0 0 1-5.9-1 9 9 0 0 1-2.5-3.6 95.2 95.2 0 0 1-4.4-11.3s-1.5-4.8-2.7-7.3l-.5-1z"
    />
    <path
      fill="#f5ce00"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M460.5 283.2s-1.6-.2-1.6 1.2c0 0 0 2 2.6 1.6 0 0 2.5-.5 1.6-3.3 0 0-.6-2-3-1.7 0 0-2.3 0-3.3 3.2 0 0-.8 2.7.6 5 1.5 2.5 5.2 4.2 7 5 0 0 7.3 2.8 9.5 4.5 0 0 3.3 2.4 1.8 4.7 0 0-.5.9-1.4.9 0 0-1 0-1.1-1 0 0 0 .6.6.9 0 0 .7.3 1.4-.3 0 0 .8-.8.2-2 0 0-.9-1.4-2.9-.5 0 0-1.8.9-1 2.7 0 0 .6 1.8 2.7 1.7 0 0 1.6 0 2.7-1 1.6-1.8 1.7-5 .3-6.7 0 0-1.4-1.8-4-3-1.6-.5-4.6-1.8-7.6-3-2.2-.9-4.1-1.9-5.4-3.4 0 0-1.1-1.2-1.5-3.4 0 0-.3-1.6.7-2l1-.2h.1z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M460.3 283.2s-1.8-.4-2.9 1.8c0 0-.6 1.3-.7 2.1m-.6-7.6s1.8.3.9 2.9c-1 2.4-2.5 3.1-3 3.5m23-76.4s4.3-2.7 8.7.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M452.4 236s.6-2.5-2.2-6.7c0 0-1.8-3.9-2.7-6.3m6.2-2.7l2 5.5 2.4 5.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M454.4 238.6s1.7 1.8 1.5 4.7m-6.8-6.6s1.8.9 1.6 5.7c0 0-.1 3.4 2.5 5.2m-4.4 1.2s5.6-.6 6 2.9c0 0 0 3.3 2 3.6 0 0 2.8.3 3.4 3m-9.6-5.7s1 1.5 2 2.2m5.2-5.8s1.4 2.2 1.7 3.4M464 223s1.3 1.8 2.6 2.6m2.6 8s2.8 1.3 2.4 8.4c0 0-.4 4.1.8 6.4"
    />
    <path
      fill="#784421"
      stroke="#000"
      strokeWidth={0.4}
      d="M456 228.8l.3.7s5 .2 7.7-3.2l-.3-.7s-4.4-.2-7.6 3.2z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M474.1 255.6s17.3-5.1 24-8.1"
    />
    <path
      fill="#784421"
      stroke="#000"
      strokeWidth={0.2}
      d="M472.3 223.7l-.2-.5 8.5-3.3.2.6z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.4}
      d="M473 223.4l5.7 27.9m-4.7-28.2l6.5 27.7m-5.4-28.2l7.1 27.6m-4.3-28.6l9.7 20.6m-8.4-21l10.3 20.4m-9.4-20.9l11.2 20.4m-13 10.4l4.4-1.4m-7.7-1.3s12.8-3.8 22.6-7.7m-22.8 9s16.3-4.2 22.8-7.4m-17.8 20.7l.8 2.7 2.4-.8-.8-2.6m4.2-1.1l.8 2.6 2.3-.8-.8-2.6m-13.4-14.7l-.2-3.5 21.4-6.5 1.1 3m-13.4.7l1.1 3.2m6.3-5.4l1.4 3m.4-3.6l1.3 2.8m.4-3.3l1.3 3m0-3.4l2.4-1.3 1 2.6m-2.2-2l1.2 2.8"
    />
    <path
      fill="none"
      stroke="#00247d"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M444.6 276.2s-4.2-4.3 0-8.4c0 0-4.6-2.2-3.9-5.8m11.4 17.5s-4.4.6-3.1-7.8c0 0-1.8 3.3-2.4 5a3.9 3.9 0 0 0 1.7 4.5c.7.5 4.6 1.5 5.8-1m-6.9-13.6s-1.8 1.6-.5 4.6m2.3-4.2s.2 2.9 1.7 4.5m-.4-5.6s0 3.4 2.4 5.5m-1.2-6.7s0 3.8 2.8 6.2m11.3-.6s1.4-3.2 4.4-3c0 0-1.4.7-1.4 2.1 0 0-.2 2.5 2.4 2.7 0 0 2.1.3 3.2-.9"
    />
    <path
      fill="none"
      stroke="#00247d"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M472.8 284.6s-7.5-3.5-6.7-8.5c0 0 .3-3 3.3-4.5m-1.6 3.2s-.7 2.1.8 3.6m.9-5.1s-1 2.4.6 4.1m1.2-5.3s-1.1 2 .2 3.8m-7 9.2s4 3.6 7.2 3.6m-8.5-2.4s3.8 3 6.2 3.5m-7.6-2.7s4.7 4.1 7.6 4.4m11.5 3.8s-4.6 2.5-1 5.2m-2-7.9l7.6-3.8m-5.7 5.2s7.6-4.6 9.8-5.6m-5.9 6s6.5-4.4 10-6.3m-5.7 6s4.5-3.4 8.8-6m1.5-4.3s-2.2-3.2-9.4 0c0 0 2.7-2.4 7.9-4.3m7.2-13.7s.6 2.6 0 4.2"
    />
    <path
      fill="none"
      stroke="#00247d"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M492.4 278.4s1.5-2.2 5.3-3.3c0 0 1 2.5 4 2 0 0 4.4-.9 3-5.8 0 0-.9-3.6-6-4m15.2-6.1s5.1 1 5 5.1c0 0 .5 6.4-6.2 7.6m5.5-10.1s1.4-3.1 4.6-4.4m-3.8-1.8s1.4 2.3 2.3 2.6m-3-.8s1.3 1.7 1.7 2m-2.2-.4s.7 1 1.3 1.4m-28-25.9s1-1.6 3.6-1m10.2 13.3s1.6-6.6 7.1-4.2m-2.2-.5s.5-3-.8-4.6m-3 4.3s.7 1.3.1 2.3"
    />
    <path
      fill="#64b4d1"
      stroke="#00247d"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M517.3 311.4s6.2-2.8 4.3-7.7c0 0-.6-1.6-2-1.5 0 0-2.4.1-2 3.3 0 0 .8 3.2-.4 5.9z"
    />
    <path
      fill="#fff"
      d="M519.5 308.5s1.4-1.3 1.2-3.6c0 0-.1-.5.1-.6 0 0 .3-.1.3.5 0 0 .4 2.4-1.2 3.8 0 0-.1.2-.3.1 0 0-.2 0-.1-.2z"
    />
    <path
      fill="#64b4d1"
      stroke="#00247d"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M526.1 307s4.4-2.7 2-7.3c0 0-.7-1.3-2-1 0 0-2.7.8-.6 4.6 0 0 1 2.4.6 3.8z"
    />
    <path
      fill="#fff"
      d="M527.2 300.8s-.2-.3 0-.5l.3.3s1.3 1.4.3 3.7c0 0-.1.3-.4.2v-.3s1-2-.2-3.4z"
    />
    <path
      fill="#64b4d1"
      stroke="#00247d"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M513 310.2s-4.9-1.2-4-6.3c0 0 .5-2.2 2.6-1.9 0 0 2.5.7.9 3.9 0 0-1 2.2.5 4.3z"
    />
    <path
      fill="#fff"
      d="M511.1 304.2s-.1-.3 0-.4c0 0 .3 0 .4.2 0 0 .5.8.1 2 0 0-.4.7-.2 1.5 0 0 0 .2-.2.3l-.2-.3s-.2-.7.2-1.5c0 0 .5-1.2 0-1.8z"
    />
    <path d="M516.5 300.7s2.8-1.6 5 .2c0 0-.2-1-2-1.4 0 0-.9-2.7-3.5-2.4 0 0 1 1.3 2.5 2.3 0 0-1.5.2-2 1.3zm2-7.3s2 1.4 2.7 2.3c0 0 .7-1 1.7-1.5 0 0-1.1-.2-1.7.3 0 0-1-.9-2.6-1.1z" />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M507.7 299.3s-.2-.7.3-1.4c0 0 .3-.5.2-1.2m19.6-40.3s2.9-.2 3.4-2.5m5-1.5s-1 0-1.9 1c0 0-.7 1-1.7.8"
    />
    <path d="M523.5 247.8s1.5 0 2.3-.7c0 0 .9-.6 1.4.3 0 0 .8 1.4-.7 2 0 0-1.8 1 1.1 2.8 0 0-3.5-1.3-2-3 0 0 1.5-1 .9-1.4 0 0-.2-.4-.8 0-.6.5-1.8.3-2.2 0z" />
    <path
      fill="#64b4d1"
      stroke="#00247d"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M525.5 211.2s.7-1 .4-3.7 2.2-3.1 3.1-2.3c0 0 1 .8 0 2.6a7 7 0 0 1-3.5 3.4z"
    />
    <path
      fill="#fff"
      d="M526.4 209.1s1-1 .5-3.1l.1-.2.3.1s.5 2.3-.5 3.5c0 0-.2.2-.4 0v-.3z"
    />
    <path
      fill="#64b4d1"
      stroke="#00247d"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M524.8 210.2s-.1-1.2-2-3c-2-2-.4-3.7.8-3.7 0 0 1.2 0 1.7 1.9a7 7 0 0 1-.5 4.8z"
    />
    <path
      fill="#fff"
      d="M524.5 207.7s0-1.4-1.8-2.8v-.3h.3s1.9 1.5 1.9 3.2c0 0 0 .2-.2.2 0 0-.2 0-.2-.3z"
    />
    <path
      fill="#64b4d1"
      stroke="#00247d"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M522.1 209.3s-.5-.9-2.9-1.8c-2.4-.8-1.8-2.9-.8-3.4 0 0 1.1-.4 2.2 1a6.4 6.4 0 0 1 1.5 4.2z"
    />
    <path
      fill="#fff"
      d="M521 207.6s-.5-1.2-2.7-1.8c0 0-.2 0-.2-.2 0 0 0-.2.3-.1 0 0 2.4.5 3.1 2l-.1.3s-.2 0-.3-.2z"
    />
    <path
      fill="#64b4d1"
      stroke="#00247d"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M523.6 210.2s-1.1.4-3.7-.9c-2.6-1.2-3.7 1-3.2 2 0 0 .4 1.3 2.4 1a7 7 0 0 0 4.5-2z"
    />
    <path
      fill="#fff"
      d="M517.6 211s1.2.8 3.3 0h.3s0 .2-.2.3c0 0-2.2 1-3.7.1 0 0-.2-.1 0-.3h.3z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M519.9 202.1s1.2.6 1 2.1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M525.5 202.3s.5 1.6 0 2.5"
    />
    <path
      fill="#64b4d1"
      stroke="#00247d"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M436.8 211.2s-.7-1-.4-3.7c.3-2.8-2.1-3.1-3-2.3 0 0-1 .8-.1 2.6a7 7 0 0 0 3.5 3.4z"
    />
    <path
      fill="#fff"
      d="M435.9 209.1s-.9-1-.5-3.1v-.2l-.4.1s-.4 2.3.6 3.5c0 0 .2.2.3 0v-.3z"
    />
    <path
      fill="#64b4d1"
      stroke="#00247d"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M437.6 210.2s0-1.2 2-3c2-2 .4-3.7-.8-3.7 0 0-1.3 0-1.7 1.9a7 7 0 0 0 .5 4.8z"
    />
    <path
      fill="#fff"
      d="M437.9 207.7s0-1.4 1.7-2.8c0 0 .2-.2 0-.3 0 0 0-.1-.2 0 0 0-2 1.5-2 3.2 0 0 0 .2.3.2 0 0 .2 0 .2-.3z"
    />
    <path
      fill="#64b4d1"
      stroke="#00247d"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M440.2 209.3s.5-.9 3-1.8c2.3-.8 1.7-2.9.7-3.4 0 0-1-.4-2.2 1a6.4 6.4 0 0 0-1.5 4.2z"
    />
    <path
      fill="#fff"
      d="M441.3 207.6s.5-1.2 2.7-1.8c0 0 .2 0 .2-.2 0 0 0-.2-.2-.1 0 0-2.4.5-3.1 2v.3s.3 0 .4-.2z"
    />
    <path
      fill="#64b4d1"
      stroke="#00247d"
      strokeMiterlimit={2.6}
      strokeWidth={0.4}
      d="M438.7 210.2s1.2.4 3.7-.9c2.6-1.2 3.7 1 3.3 2 0 0-.5 1.3-2.5 1a7 7 0 0 1-4.5-2z"
    />
    <path
      fill="#fff"
      d="M444.7 211s-1.1.8-3.3 0h-.2v.3s2.4 1 3.8.1c0 0 .2-.1 0-.3h-.3z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.5}
      d="M442.5 202.1s-1.3.6-1 2.1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M436.8 202.3s-.5 1.6 0 2.5"
    />
    <path d="M492.6 187.7s.8 2.3.5 4.4c-.3 2 .1 2.4.8 2.8.6.3 2-.3 2.1-1.8 0 0 1.6 3.2-1.5 5.3 0 0-2.3 1.4-4.2-.4-.7-.7-1-2.5-.6-4.2 0 0 .5-2.2-.4-4.6 0 0 1.3 1.4 1 4.1 0 0-.7 5 3 4.7 0 0 2.5 0 2.6-3 0 0-1 1-2.1.7a2 2 0 0 1-1.5-2.4c.1-1.3.5-3.6.3-5.6zm-4 8s-.3 4-3.8 4.9c0 0 .5-.7-.3-2.7 0 0-.8-1-.8-2.8 0 0-1 .9.2 3.2.8 1.4.1 3-.1 3.1-.3.1 5.8-.8 4.7-5.6zm-4.7-3.8s-.9-1-1-3.2c0-2.2-.4-2.8-.7-3 0 0 .4 1.9.3 3 0 1.3.1 2 .3 2.5 0 0-2 .3-3.2-2.5-1.1-2.7-2.3-2.5-2.9-2.5 0 0 .7.1 2 2.6 1.4 2.4 1.8 3 5.2 3zm-9-5.8s1 2.6 1.1 4c0 0-2.6-.8-3.3-3 0 0-2.7.9-1.7 4 0 0-2.4-.8-3.5-2.7 0 0 1.3 1 2.6 1.4 0 0-.2-2.6 3-3.5 0 0 .5 2.3 2.2 2.8l-.4-3zm4.2-4.6s1 1.3 2.8 1.3a3 3 0 0 0 2.7-1.3s-.1 2.2-2.7 2.3c0 0-2.8 0-2.8-2.3zM467.8 197l1.7 1.6s1 1 1.7-.2c0 0 1.1-2 2.4-1.9 0 0-1 .6-2 2.5 0 0-.2.6-1 .7-.4 0-.8.2-1.5-.6 0 0-.6-.7-1.3-2zm14-24.6c-2.7 0-.4 2-.4 2 0 3.4-2.6 4.5-4.4 3.5-1.9-1-.4-3.4-.4-3.4s-2 1.3-.8 3.3c1.3 2 4.8 1 6-.7 1.3 1.8 4.8 2.7 6 .7 1.4-2-.7-3.3-.7-3.3s1.5 2.4-.4 3.4c-1.8 1-4.5 0-4.4-3.4 0 0 2.3-2.1-.4-2.1zm1.7-3.7s1 1.7.8 4.1c0 0 .8-2.4-.8-4zm-8.4 3.9s-.2-1.8-2-2c0 0 1.6 1.1 2 2zm13.5 0s.2-1.8 2-2c0 0-1.5 1.1-2 2zm-16.2 2.7s1.4.4 2.2-.6l-2.2.6zm-4.5-11s1.6-.1 3.2 2.3c0 0-1.6.8-2 1.3 0 0 0-.8.8-1.4 0 0-.3-1.2-2-2.1zm26.8 0s-1.6-.1-3.2 2.3c0 0 1.6.8 2 1.3 0 0 0-.8-.8-1.4 0 0 .3-1.2 2-2.1zm-12.3 1.9s1.4.4 3.2-.6c0 0 2.2-1.2 3.6 0 0 0-1.2-.6-3.6.6 0 0-2.3 1.3-3.2 0z" />
    <path fill="#fff" d="M483.9 167.6s1.2-2.1 5-1.7c0 0-1 3-5 1.7z" />
    <ellipse cx={486.4} cy={166.9} fill="#784421" rx={0.7} ry={0.9} />
    <ellipse cx={486.4} cy={166.9} rx={0.4} ry={0.6} />
    <path d="M475.9 163s2.3.2 3.8 1c0 0 1.5 1 3.2-.3 0 0 1.9-1.1 3.1-2.6 0 0-2.9 2-4 2.3 0 0-1-.8-1.3-1.9 0 0 .1-.8 1.7-2.3 0 0-2.1.7-2.5 2.4a6 6 0 0 0 1.2 2s-.4.2-1.4-.5c0 0-2.3-.7-3.8 0zm6 14.2c-2 1.8 0 1.6 0 1.6s2 .2 0-1.6zm-1.2-11s-1.5.4-3.3-.6c0 0-2.2-1.2-3.6 0 0 0 1.2-.6 3.6.6 0 0 2.4 1.3 3.3 0z" />
    <path fill="#fff" d="M479.2 167.6s-1.2-2.1-5-1.7c0 0 1 3 5 1.7z" />
    <ellipse cx={476.6} cy={166.9} fill="#784421" rx={0.7} ry={0.9} />
    <ellipse cx={476.6} cy={166.9} rx={0.4} ry={0.6} />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={1.3}
      d="M554 148.3v135.5c0 36.2-72.3 48-72.3 48s-72.4-11.8-72.4-48V148.3h144.8z"
    />
  </svg>
	),
	BN: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#f7e017" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M0 33.3v213.4l640 100V233.3z" />
    <path d="M0 146.7v100l640 200v-100z" />
    <g fill="#cf1126" transform="translate(-160) scale(.66667)">
      <path d="M695.7 569.7a117.2 117.2 0 0 1-49.4-17.2c-2.4-1.6-4.6-3-5-3-.4 0-.6 1.9-.6 4.1 0 6.4-2.6 9.6-9 11.3-6.2 1.6-15.6-1.6-23.2-8a68.3 68.3 0 0 0-24.7-13.5 39.9 39.9 0 0 0-28 3.6 8.7 8.7 0 0 1-2.8 1.3c-1.1 0-1-6.9.2-9 1.5-3 5.1-5.8 9.4-7.3 2.2-.8 4-1.8 4-2.3 0-.4-.8-2-1.7-3.6-2.9-5.1-1.7-10 3.4-13.9 5.2-4 14-4.6 21.7-1.7a32 32 0 0 0 4 1.4c1 0 .4-1.5-2.4-5.6-3.2-4.7-3.9-7-3.5-12.7a14.7 14.7 0 0 1 13.5-13.5c5.8-.4 9.4 1.6 18 9.7a144 144 0 0 0 86 41.6c8.3 1 24.8.5 34.5-1a156 156 0 0 0 81.8-40.8c6.4-6 9.4-7.6 14.7-7.6 4.5 0 7.7 1.4 11 5 3 3.3 4 6.4 3.6 11.5-.2 3.2-.7 4.7-2.6 7.9-2.8 4.5-2.3 5 3.2 2.8 7.6-3 16.9-1.6 21.9 3.2 4.4 4.2 4.8 8.4 1.4 14-1.3 2.1-2.3 4-2.3 4.4 0 .6 1 .8 5.5 1.6 6 1 9.5 5.4 9.5 12.2 0 2-.3 3.7-.6 3.7s-2.6-.9-5-1.9c-7-2.9-11-3.6-19.2-3.5-6.2 0-8.3.3-12.6 1.7a57.5 57.5 0 0 0-19.5 11.5c-6.4 5.7-10.4 7.5-16.6 7.4-5.8 0-9.7-1.7-11.8-5-1.1-1.8-1.3-2.8-1-6.8.2-2.6.1-4.7 0-4.7-.3 0-2.5 1.4-5 3.1A80.5 80.5 0 0 1 778 560a181.6 181.6 0 0 1-82.3 9.7z" />
      <path d="M706.3 525.2a136.4 136.4 0 0 1-97.9-55.7c-24.4-33.2-32-77.1-24.6-117.2 4-18.3 12-36.6 25.5-49.6a114.6 114.6 0 0 0-8.7 74.3c9 49.8 51 91.9 101.3 99.2 20 5.7 40.5-.4 59.5-6.5 42-14.8 74-54.6 77.8-99.1 3.3-24-.3-49.1-11.2-71 6.2 3.3 14 16.2 18.6 24.8 16 31 16.7 68.1 7.3 101.2-12.8 42.1-45 79-87.5 92.4a165.7 165.7 0 0 1-60 7.2z" />
      <g id="prefix__a">
        <path d="M512 469.9c-2.5-.4-5.3 2.1-4.3 4.7 1.8 2.6 5 4 7.8 5.2a54.2 54.2 0 0 0 23.2 3.6 49.6 49.6 0 0 0 17-3c3-1 6.8-2 8-5.4 1.3-2.1-1-4.3-3.1-3.9-3 .7-6 2-9 2.9a57.7 57.7 0 0 1-20.3 2 54 54 0 0 1-14.4-4.2c-1.6-.7-3.1-1.7-4.9-1.9z" />
        <path d="M514.8 459.5c-2.5-.4-4.7 2.6-3.7 5 2 2.8 5.3 4.3 8.4 5.6a42.4 42.4 0 0 0 17 2.9h1.5a37.6 37.6 0 0 0 14.4-2.8c2.7-1.1 6.1-2.2 7.3-5.2.9-1.7.2-4.1-2-4.3-1.8 0-3.5 1.2-5.3 1.7a44.3 44.3 0 0 1-20.6 3.2c-4.4-.5-8.5-2.1-12.5-4-1.5-.7-2.8-1.8-4.5-2z" />
        <path d="M518.3 449.6c-2.2-.3-3.7 2.2-3.3 4.1.3 1.8 1.8 3 3.1 4a30 30 0 0 0 18.6 5.3h1.6a28 28 0 0 0 12-2.8c2.5-1 5.4-2.3 6.3-5.2.4-1.3.6-3.2-.9-4-1.6-.8-3.1.5-4.5 1a34 34 0 0 1-15.5 3.9 27 27 0 0 1-13.1-4c-1.5-.7-2.7-2-4.3-2.3z" />
        <path d="M481.5 302.7c-3.2 3.3-.7 9.3-1 13.5 1.8 13.2 3.9 26.5 8.8 39 6 12 18.8 18.5 26.5 29.2 2.8 5.1 1.8 11.3 2.4 17 .4 15.3.3 30.7 0 46 7 3.6 14.5 7 22.5 5.7 4.7-1.1 13.5-1.8 14.5-6.5l-1-79.5c-2.7-8.1-11-12.3-17.1-17.5a155.5 155.5 0 0 1-14.2-16.1c-2.6-4.5-12.9-6-9.2 1.6 2.2 6.7 7.7 11.6 9.1 18.6.3 3.9 5 11 1 13.2a24.5 24.5 0 0 0-10.7-10c-4.4-3.3-11.7-4.7-13.3-10.5a42.9 42.9 0 0 0-11-22c1.5-7.4 0-16.7-6.4-21.5l-.9-.2z" />
        <path d="M491.4 304.2c-3 .5-2.8 4.2-1.5 6.2a27.2 27.2 0 0 1 1.1 13.4 44.1 44.1 0 0 1 10.6 21.7c0 3 3.2 4 5.3 5.5 4.9 3.1 10.3 5.4 14.7 9.3.9 1 1.6 2 1 0-.7-2.6-1-5.4-3-7.3-2.8-3-6.2-5.6-10.2-6.4-.3-4.2-2.3-8-4.1-11.6-2-3.5-4.1-7.2-7.5-9.4 0-6.1 0-12.5-2.6-18.2-.8-1.4-2-3.1-3.8-3.2z" />
        <path d="M499.7 306.6c-2 .6-1.6 3.2-1 4.7a54 54 0 0 1 1 13.2c3.9 3 6.2 7.4 8.4 11.6 1.4 2.8 2.6 5.8 3.1 8.9 3.1 1 5.8 3 8.2 5-1-2.8-3-5-4.5-7.7s-3-5.6-3.7-8.7c-3-3.1-4.6-7.6-4-12 .2-4.7-1.3-9.6-4.5-13.2-.8-.8-1.8-1.7-3-1.8z" />
        <path d="M509.2 308c-1.2.2-1.8 1.2-2.4 2.1-.3.9.8 1.8 1 2.8a21.8 21.8 0 0 1 1.4 10.4c-.1 2.5.8 5 2 7a3.9 3.9 0 0 1 3.5-2.8c.5 0 1.4.2 1-.7-.4-4.8-1.1-9.6-2.8-14a9.6 9.6 0 0 0-2.8-4.5c-.2-.2-.6-.4-1-.3z" />
      </g>
      <use
        width="100%"
        height="100%"
        transform="matrix(-1 0 0 1 1440 0)"
        xlinkHref="#prefix__a"
      />
      <path d="M715.7 476a35.6 35.6 0 0 1-29.9-24c.3-2.2 3 1.2 4.3 1.5a19 19 0 0 0 8 2.6c3.5 1.5 5.7 5 9.1 6.9 1.6 1.2 7.2 3.6 6.1-.3-1.3-2-2.2-4.6-1-7 1.8-4.1 4.7-7.7 7.7-11.2 2.1-.7 3.6 3.6 5.1 5 2.1 3.3 4.7 7.3 3.4 11.3-1.2 1.5-2 6 1.3 4.6 4-1.8 7.3-4.8 10.6-7.6 3-2 6.7-2.1 9.7-4 1.5-.3 4.4-3.1 5-1.6a44.9 44.9 0 0 1-7.4 12.3 32.1 32.1 0 0 1-18.8 10.9c-4.4.8-8.8 1-13.2.6z" />
      <path d="M731.5 460.2c.3-2.7-.3-5.4-1.7-8-2.1-4.2-5-8-8-11.9-2.8-1.6-4.3 3.7-6.1 5.2-2.9 4.3-6.5 8.7-6.7 14-1.6 2.5-4.6-2-5.9-3.5a19 19 0 0 1-4-12 50.8 50.8 0 0 1 3.6-20.6c2-5.6 5.1-11 4.8-17 .2-4.7-.7-9.7-4.4-12.8-3.6-2.8 2.3-3.4 4.1-2 3.2.3 4.9 5.5 7.8 4.2 1.1-2.7 1.4-6 3.8-8.1 2.3-3.2 4.7 1.3 5.5 3.5 1.7 1.8 0 6.5 2.6 6.6 3.2-2.3 5.5-6 9.6-6.9 1.7-1 4.5 0 2.3 1.8-3 2.9-5.6 6.4-6.2 10.7-.9 5.3.4 10.7 2.7 15.4 4.5 9.4 8 20 5.7 30.5-1 4.6-4.2 8.6-8 11.3-.5.3-1.3.3-1.5-.4z" />
      <path d="M726.7 389.6a21.2 21.2 0 0 0-5.6-7c-2.4 0-3.9 3-5.5 4.6-1.1 2.1-2.5 5.6-5.3 2.9-4.5-2.6-5.2-8.3-5.2-13-.3-7.6 2.8-14.7 5.5-21.6 1.7-4.3 1.3-9.2.2-13.6-1.3-5-5.4-8.6-8.5-12.6.2-1.5 4.2-.7 5.7-.4 3.4.9 5.4 3.8 7.9 6 1.8-.6 1-4.2 1.9-5.9 0-2.4 3.2-5.5 4.5-2.1 2 2.2 0 6.5 2.5 7.8 2.4-.9 3.6-3.5 5.8-4.7a8 8 0 0 1 7.8-.5c.9 2.2-2.6 4-3.6 6a20.4 20.4 0 0 0-3.8 18c1.4 5 3.8 9.5 4.7 14.5a40.1 40.1 0 0 1-.5 17.2c-.9 3.4-3.8 5.6-6.8 7-.8-.7-1.2-1.7-1.7-2.6z" />
      <path d="M711.6 326.9c-3.4-2.5-4.5-4.8-4.5-9.5 0-2.3.5-3.6 2-5.8 2.4-3.2 2-4.2-1.3-3.3-5.3 1.5-7.8.2-8-4.3 0-2.2.4-3.1 3.3-6.7 2.4-2.8 3.3-4.3 2.8-4.8-.5-.4-3.3 2-9 7.8a124 124 0 0 1-11.4 10.6c-9.8 6.6-19.2 7.6-23.5 2.5-2.2-2.6-2.1-4 .4-5.6a27.4 27.4 0 0 0 4.4-3.7 86 86 0 0 1 16.1-11.6c3.6-1.8 4.4-3 2.1-3-3 0-12.5 6.2-19.8 12.8-2.1 2-5.2 4.2-6.8 5a25.4 25.4 0 0 1-13.9 1c-2.2-.7-6.3-4.5-6.3-5.9 0-.3 1-1.1 2-1.8a30 30 0 0 0 4.6-3.2c5.8-5 16.8-10.3 25.5-12.2 2.8-.5 1.7-2-1.4-1.8a56 56 0 0 0-25 11.7c-8.3 6.9-20.8 6.2-24.8-1.3-.7-1.3-1.2-2.5-1-2.7a92.8 92.8 0 0 0 20.4-7.8 51.5 51.5 0 0 1 18.1-6.5c2.8-.5 3-1.9.3-2.2-3.6-.4-9 1.4-18.5 6-12.3 6.1-15.8 7.2-22.2 6.8-6-.4-9.3-1.9-14-6.4-3.2-3-7.6-10.5-6.8-11.4a63.5 63.5 0 0 0 15.8 1.3c8.3 0 10.6-.2 15-1.5a84.3 84.3 0 0 0 24-12.1 57.5 57.5 0 0 1 36.8-13.6c12.4 0 20.2 2.8 27.2 9.9 2.4 2.4 4.4 3.9 4.7 3.6.3-.3.6-4.5.7-9.3 0 0 3.7-.4 4.5.7 0 7.7 0 8.4 1.2 8.4.7 0 1.5-.8 2-2 1-2.5 5-6 9.2-8.2 9-4.5 24.7-4.7 37.3-.3a62.4 62.4 0 0 1 16.7 9.5 90.2 90.2 0 0 0 24 12c6.8 2 19 2.5 25.1 1a61.9 61.9 0 0 1 5.4-1c2.3 0-1.6 7.6-6.2 12.1-8.4 8.2-19.3 8.1-34.6-.1-9.6-5.2-21-8-21-5.2 0 .6.6 1 1.5 1 3.3 0 9.7 2.2 18.7 6.5a53.7 53.7 0 0 0 18.3 6.5c2.3 0 2.4 1.5.2 4.7-2.3 3.4-6.2 5-11.7 5-5.3 0-8.3-1.1-13-5-8-6.6-27.6-14-26.9-10 .2.7 1.1 1.2 3.2 1.5a56 56 0 0 1 23.1 11l5.9 4.3c1.1.6 1.1.8.2 2.5-1.4 2.8-5.2 4.9-9.2 5.3-5.2.6-9.8-1-14.5-5-10-8.3-19.3-14.3-22.3-14.3-2.5 0-1.4 1.4 3 3.7a79.7 79.7 0 0 1 15.8 11c2 1.9 4.3 3.7 5 4.1 1.9 1 1.8 2.4-.2 5s-5.4 3.8-9.7 3.3c-8.6-.9-15.4-5-26-16a70.7 70.7 0 0 0-8.2-7.8c-1.4 0-.5 1.9 2.2 5 3.4 3.7 4 5.8 2.7 9-1.1 2.6-3 3.3-6.8 2.2-4-1-4.6 0-2 3.1 3.8 4.9 3.3 10.7-1.5 14.8a12 12 0 0 1-3.4 2.3c-.4 0-1.4-1-2.3-2.4-3-4.6-5.7-4.6-8.7 0a53.6 53.6 0 0 1-2 3 113.1 113.1 0 0 1-3-2.2z" />
      <path d="M726.7 233l-5.2 4-4.6-3.4v27.8h9.8z" />
      <path d="M694.9 204.3a88.3 88.3 0 0 1-9 32.3l11.1-10.3 7.7 9.2 8.4-9.4 8.5 8 8.2-8.3 8.5 10 7.4-8.2 12.6 9c-4.6-10-10.7-18.6-10-32.8-12.1 9-41 10.6-53.4.4z" />
      <path d="M717 197.6c-4.5 0-9.2.1-13.4 1a20.1 20.1 0 0 0-7.8 3c.3 8.6 41 12.1 51.9.2a20 20 0 0 0-8.2-3.3c-4-.8-8.6-.8-12.9-1v7.1H717v-7z" />
      <path d="M724.9 154h-6.3v49.4h6.4z" />
      <path d="M724.9 155.2l-2.4 23.7 24.3 11.9-12.3-16.5 16.8-5.5zm-2.7-6.1c-3.7 0-6.4 1.4-6.4 3s2.7 3 6.4 3 6.4-1.4 6.4-3-2.7-3-6.4-3z" />
    </g>
    <g fill="#f7e017">
      <path d="M314 375.9c2.7-.9 4.2-2.5 5.3-5.6.5-1.6.9-3.2.8-3.6-.2-1-1.4-1-2.6.1-.9.7-1 1.1-.8 2.6.7 3.7-.7 4.7-7.7 5.4-.7 0-2.8 0-4.5-.3-3.4-.4-4.6 0-3.4 1a7 7 0 0 0 2.1.9c1.9.5 8.8.2 10.8-.5zm14.7-.6c.4-.4 1.7-1 3-1.5 1.7-.5 2.6-1 3.3-2.2 2.1-3 1.7-5.7-1.3-9.3-1.7-2-2.4-1.9-3.7.3-1.2 1.8-1.1 2 .5 2.4.9.2 1.7.8 2.1 1.6 1.8 3.1 1.3 5-1.4 5-2.4 0-3 .4-3.7 2l-.6 1.9c0 .6 1 .5 1.8-.2zm-4.8-3.5c.4-1.3.6-3.5.5-8a33 33 0 0 0-.3-6.4c-.4-.4-2.3.8-2.6 1.7a3 3 0 0 0 .5 2.1c.6 1.2.7 2.4.5 7-.3 6 .1 7 1.4 3.6z" />
      <path d="M312.6 369l.7-5c.1-1.7.5-3.8.7-4.7.7-2.3 0-2.9-1.8-1.6l-1.3 1 .2 3.3c.3 3-.2 8.5-.9 10.7-.2.6.1.4.9-.5.6-.7 1.3-2.2 1.5-3.3zm-10 1.6c2.4-2 2.1-5.6 2.7-8.4 0-1.9 1.2-4.1.4-5.8-2.3.4-3.7 2.6-2.5 4.7 0 2.5 0 5.2-1.3 7.4-1 1.5-4.4 1.1-4.2-1 .8-3-2.9-1.5-4.3-.7-1.1.8-3.5.9-2.6-1-.6-2.7-3.9-1-5.7-1-1.7 0-.1-3.5-2.6-3-4.5-.3-9.5.1-13.5-2.6-2.3-1.1-2-3.9-.7-5.7 1.4-2.4 1.8-5.5 4-7.4 2.3-2.1-2-1.2-3-.5-2.2 1.2-.2 4.3-2 6-1 1.8-2.4 4.2-4.8 3.9-3.5-.7-5.5-4-8-6-2.2-.5-1 3.4.2 4.2a21.9 21.9 0 0 0 7.4 3.6c2.6-.5 2.7 3 5 3.5 4 2 8.6 2.5 13.1 2.8 1.8.1.8 3.3 3.1 2.6 1.3.4 4.3-.5 4.4 1-2 2.4 1.9 2.3 3.3 2 1.9-.4 4.2-1 4.7 1.4 1.5 1.7 4.3 1.4 6.2.5l.7-.5z" />
      <path d="M262.8 350.4a23.9 23.9 0 0 0 2.4-4.2 16 16 0 0 1 2-3.6c1.2-1.2.5-2-1.4-1.6-1 .2-1.4.6-1.5 1.5a23 23 0 0 1-2.5 7c-1.7 2.5-1.7 2.6-1 2.6.3 0 1.2-.8 2-1.7zm-25-15.7c-1.9 0-2 1.2-.2 1.8 1 .3 1.7 1 2.3 2.3 1.7 3.5 2.8 4.2 7.5 4.6l3 .2.2 1.9c0 1 .3 1.8.5 1.8l2.6-1c2.2-1.2 4.3-3.8 4.3-5.5 0-1-1.8-2.2-3.4-2.2-.7 0-2 .6-3.1 1.4-3.4 2.4-7 2-9-1.2-1.5-2.6-3.2-4-4.7-4zm16.3 6.5c.9 0 1 .7.6 2a.9.9 0 0 1-1.7 0c-.4-1 .1-2 1-2zm126.5-4c-1.3 0-1.6.2-2.4 1.4-1.3 1.9-1.4 6-.2 7.4.7.9.8.9 2.3.2 2.2-.9 2.6-.8 2.5.3 0 3-4.2 8.7-8.6 11.7a9.7 9.7 0 0 0-2.4 2c-.3.8 1.3.7 3.3-.4a21 21 0 0 0 7.9-8c1.1-2.3 1.3-3 1.5-7 0-3.8 0-5-.6-6.2-.8-1.4-1-1.5-2.8-1.5h-.5zm.1 2.5c1 0 1 .2 1.2 1.6 0 1-.1 1.7-.7 2.3-.8.7-1 .7-1.6-.4-1-1.6-.4-3.5 1.1-3.5zm-20.2 28.5c3.9-2 6.2-4.1 7.6-7.2a20 20 0 0 0 1.3-3.1c0-.6-1.9-1.5-3-1.5s-1.4-.8-1-3c.5-2.1 0-4.8-1-4.8-.3 0-1 .5-1.3 1.1-.6 1-.7 1.4-.2 2.7.7 2 .1 3.6-1.7 4.9-.9.6-1.3 1.3-1.3 2l.1 1 2.1-1 2-1.2 1.1 1c.7.4 1.2 1.2 1.2 1.7 0 2.4-6.8 6.4-11.4 6.8-2.5.2-3 0-3.8-.8-.7-.7-.9-1.3-.7-2l.5-2.6c.4-2.1-.4-1.8-2 .6-1.2 2-1.6 4.1-.9 5.2.6 1 4.4 1.8 7.2 1.6 1.7 0 3.4-.5 5.2-1.4zm26-14.5c2.4-2.5 3.5-5.5 3.5-10v-3.5l2-1c2.7-1.2 5.2-3.7 5.2-5.1 0-1.4-.7-1.4-1.8.2-.9 1.1-2 1.8-6 3.7-1 .4-1.1.7-1.4 5-.2 5-1 6.8-3.7 10.2-1.7 2-1.8 2.4-.6 2.4.5 0 1.8-.9 2.8-2zm-26.7-2.8c.2-.7-1.2-1.2-1.7-.6-.3.2-.4.6-.2.9.4.6 1.6.4 1.9-.3zm36.8-9.5c.3-.8-1.1-1.3-1.7-.7-.2.3-.3.7-.1 1 .4.6 1.6.4 1.8-.3zm-44.3-25.9c-1 .5-1.5 1.5-2.1 2.3-.5.3-.1.6.1 1 1.7 1.7 2.4 4.2 3.2 6.5.8 2.7 1.8 5.6 1 8.4-.3 1-1.2 2.1-2.4 1.8-2-.1-4-.7-6-.7-1.9.1-3.3 1.8-5.1 1.6-1.2 0-1.2-2.4-2.2-1.7-.6 1.3-.3 2.7-.4 4 .2.3.8.1 1.1.2h3.7c.2 1.2.2 2.7 1 3.7 1.3.4 2.8 0 4-.5 1.2-.6 1.4-2.1 1.8-3.3.4-1.3 2-1 3-1.5a5.7 5.7 0 0 0 4-5.7c-.2-3.9-1.6-7.4-2.8-11-.5-1.6-.9-3.3-1.5-4.9l-.4-.2zm-6 21.8c1.3 0 1.9 1.6 1.6 2.7-.5 1.5-2.4.6-2.7-.5-.7-1-.3-2.3 1-2.2z" />
      <path d="M296 324.8c-.6 0-1.3.2-2 .7-3.5 2.5-4.5 5.4-2 6.6 1.7.8 1.3 1.8-1.5 3.2-4 2-7.5 1.7-14.2-1-1.6-.7-2-.4-1.7 1 .4 1.5 1.8 2.3 5.1 3 3.6 1 8 .7 10.8-.5a14 14 0 0 0 4.3-3.4l2.2-2.3 2.5.3c3.1.4 3.2.4 3.2 1.9 0 1.2 0 1.2 2.9 1.5l4.7.2c1.3 0 2 .3 2.4.9.6.7.9.8 5.6.4 4.4-.4 5.2-.4 7.2.3 1.4.4 3 .6 4.1.5 3.4-.4 8-3.1 8.7-5.1 0-.3 1.3-.7 2.7-1 3.4-.7 3.5-1.4.4-1.8a22.9 22.9 0 0 1-4.6-1.1 12.2 12.2 0 0 0-3.5-.9c-1.7 0-3.3 1-3.3 2.2 0 .7.2.8 2.3.6 1.8-.2 2.4-.1 3.4.7.7.5 1.1 1.1 1 1.3-.5.8-4.5 2.6-6.2 2.9a4.7 4.7 0 0 1-3-.5c-1.6-.8-3.8-.9-4.3-.2-.2.3-.6.1-1.3-.5l-1-1-2.4 1c-2.4 1-3.3 1-3.3-.2 0-.5-.7-.6-4.2-.3-3.9.2-4.3.1-5-.7-.7-.7-.7-1-.2-1.7.4-.8.4-1 0-1.5-.4-.4-1-.4-2.5 0-3.9 1-5 .5-5-2.5 0-1.9-1-3-2.3-3zm-1 2.8c.2 0 .4.1.7.4.3.3.5 1 .3 1.3-.3.9-2 .9-2.3 0-.2-.5 0-1 .5-1.3l.8-.4z" />
      <path d="M288 330.4c2.4-1.5 2.4-1.4 2.7-5.5.2-3 .2-3.2-.6-3.2-1.2 0-1.8 1.3-1.8 3.7 0 1.6-.2 2.3-1 3-2 2-6.8 1.1-7.5-1.3-.2-.8.1-1.6 1.1-3 2.1-3 1.7-3.8-1-1.5-1.7 1.6-2 1.6-1.7.3.3-1.3-.3-1.8-1.8-1.4-.7.2-1.2.6-1.3 1.6-.2.8-.6 1.3-1.3 1.5-1.2.3-3.2-.8-3.2-1.8 0-.7 3-4.4 6.9-8.4 1.4-1.5 2.6-3 2.6-3.1 0-.2-.8-.4-1.7-.4-1.4 0-1.8.2-1.8.8 0 .4-1.9 3-4.3 5.7-5 5.6-5.4 6.7-3 8.2a6 6 0 0 0 6.6-.2l1.6-1.1v2c0 2.5.5 3.5 2.5 4.5a8 8 0 0 0 8-.4zm104.4-34.6c-1.8 1.1-.4 3.4 0 5-.8 2-3.5 2.6-5.5 3-2.8.5-4.8 2.8-5.8 5.3-.6 1.6-2 4-3.5 1.6-1.3-1.3-3.7-2.4-5.2-.8-1.2 1.1-1.5 2.7-2 4.2-.7-1.1-1-2.8-2.4-3.2-2.4.3-1.5 3.3-.4 4.5 1 1.5 2 3.3 1 5-1 2-4 3.4-5.7 1.7-1.6-.9-.5-4-2.2-4.2-.8.6-.8 3.9-2.1 2.1-1-1.5-.4-3.6-1.6-4.9-1.3.2-2.4 2.5-2 3.7 1.8 2.4 2.6 5.4 3.3 8.3.4 1.2-.1 3.5 1 4 .7-1.9 0-4 .6-5.9 1.8-.2 3.7.6 5.5.2 2.7-.3 4.7-2.6 5.6-4.9.3-1.8 0-3.6-.1-5.4 2 .4 4.2.4 6.2 1 1 1.5-.3 3.7-.6 5.3-1 3.4-3.7 5.8-6.2 8-1.1.7-1.2 2.4.3 1.5a15 15 0 0 0 7.5-8c1.1-2.6.2-5.5 1-8.1 1-2 3.5-1.6 5.4-1.6 1.9 0 3.5-2.3 2.9-4.2-.6-2.2 1.7-3.2 3.2-4 2.1-1 3.7-3.1 3.5-5.5 0-1.3 0-3.6-1.7-3.7zm-7.3 12.5c2.2.6-.4 4.8-1.6 2.1-.4-1 .5-2.1 1.6-2.1zm-10.3 3c2.9-.1 1.8 4-.6 2.2-1.3-.7-.9-2.2.6-2.2zM270 327.6c0-.4-.2-.7-.6-.7-.7 0-1.2.7-.9 1.3.4.7 1.3.3 1.5-.6zm34-3.6c0-.7-.3-.9-.8-.8-1.1.2-1.3 1.7-.1 1.7.6 0 .9-.3.9-1zm-42-20.4c-1.3-.3-2.2.9-2.7 2-1 1.7-2.2 3.4-4 4.3-1.3.4-2.7-.1-3.9-.8-1.3-.7-1-2.3-1.6-3.4-1-.8-2.7.3-2.6 1.5-.1 1.6 1.3 2.5 2.6 3.1 1 .7 2.6 1 3 2.3 0 1.1.4 2.4 1.7 2 1.5 0 2 1.8 1.3 2.9a6.3 6.3 0 0 0-.7 4c.7.7 1.4-1 2-1.4l1-1.4c2.7.1 5.3.5 8 .4 2 0 3.5-1.2 4.7-2.6 1.8-1.8 3.2-3.9 5.1-5.4 1.4-.4.7-3-.8-2.2-1.3.5-1.7 2-2.6 2.9a31 31 0 0 1-5 5.2c-1.5.6-3.1.3-4.6 0-.6-.5 1.2-1 1.5-1.6.8-.8 1.8-1.6 2.3-2.7-.5-1-1.9-1-2.9-1-2.4.2-4.3 2.3-6.8 2.5-1.9 0-.9-2 0-2.7 1.6-2 3.4-3.8 5.1-5.7.5-.6 2.3-1.2 1.2-2-.4-.2-.9-.2-1.3-.2zm1.2 10c1.3.7-.8 1.8-1.6 1.7-1.1.3-1.2-.8-.2-1 .6-.4 1.2-.7 1.8-.7zm-3.8 2.6c.7 0 2.2.7.8 1.1-1 .8-2-.8-.8-1.1z" />
      <path d="M289.4 317.8c0-1-1.6-.8-1.8.2-.2.6 0 .7.8.6.6 0 1-.4 1-.8zm74.7-6.6c.2-.9-1-1.5-1.7-.8-.7.6 0 1.9.8 1.7.4 0 .8-.5 1-.9zM248 302.1c1.1-1 1.2-1.1.7-3.3-.8-3.1-.7-3.5.5-3.8 1.5-.3 5.3 1.7 6 3.3.8 1.3.7 1.4-.4 2.4-1.2 1.1-1.2 2.4 0 2.4 1 0 3.7-2.6 3.7-3.5 0-1.3-3-4.4-5.4-5.5a10.7 10.7 0 0 0-4.6-1c-3.1 0-3.5.7-2.7 4.2 1 4.2-.3 4.8-3.7 1.6a10.4 10.4 0 0 1-3.5-8.6c0-4 1.6-6.1 5.1-6.6 2.4-.3 2.3-.9 0-1.2-3.6-.6-6.6 1.8-7.7 6-1.3 4.7 1.6 10.4 6.7 13.3 2.7 1.5 3.7 1.6 5.3.3zm139.2-5.2c.3-.2.5-.9.5-1.4s.5-1.6 1.1-2.4c.6-.8 1-1.6 1-1.8 0-.8-1.3-.8-2.3 0-1.1.9-2 1-2 0l1.2-.9c1.6-.7 1.7-1.5.4-2.1-1.7-.8-3.5.6-3.6 3-.1 1.6 0 1.8 1.2 2.5 1.1.7 1.3 1 1.1 2-.3 1.6.4 2.2 1.4 1.1zm13-1.4c1-1 1.8-1.9 1.8-2.2 0-.3.9-1.2 1.9-2 2.8-2 3.5-4 2.2-7.3-.5-1.3-2-3-5.5-6a26 26 0 0 0-5.4-4.4c-.9 0-.7 3.4.2 3.7 1.7.6 2.8 1.3 5.4 3.7 3.2 2.8 4.6 5.5 3.8 7-.7 1.4-1.7 1-4.5-2a13.8 13.8 0 0 0-3.2-2.9c-.3 0-.5.6-.5 1.4 0 1 .5 2 2 3.5 2.3 2.6 2.5 4.1.7 5.5a5 5 0 0 1-1.4 1 33.2 33.2 0 0 0-9-10c-.3 0-.5.4-.5 1.4 0 1.3.2 1.7 1.2 2.2a38 38 0 0 1 7 7l1.8 2a9 9 0 0 0 2-1.7zm6-16.8c-.5-1.2-8.4-9.4-9.3-9.4-.4 0-.5.5-.4 1.8 0 1.6.3 1.8 1.4 2.1a20 20 0 0 1 4.6 3.7 17 17 0 0 0 3.7 3v-1.2zm-47.8 92.6a1.2 1 0 1 1-2.3 0 1.2 1 0 1 1 2.3 0zm4.2-1.4a1.2 1 0 1 1-2.4 0 1.2 1 0 1 1 2.4 0z" />
    </g>
  </svg>
	),
	BO: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#007934" d="M0 0h640v480H0z" />
    <path fill="#ffe000" d="M0 0h640v320H0z" />
    <path fill="#d52b1e" d="M0 0h640v160H0z" />
    <path
      fill="#a05a2c"
      stroke="#000"
      strokeWidth={0.1}
      d="M368.6 210.7l-98 97.9a91.8 91.8 0 0 0-1.3-1l98-97.8a6.3 6.3 0 0 1 1.3 1z"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M374.7 204.5c-.4.7-1.4 2.5-1 3.8l-2-1.5c.5 1 .4 1.4-.1 1.8-.3.4-1.4.3-2.1.2.7.4 1.5.8 2.4 1h2c-.7.3-2.2.8-3.3 1-.5.1-1.6.2-2 0-.6.5-1.9-.4-1.3-1-.3-.3-.3-.8-.4-1.4 0-.7.1-1.9.7-3l.5 1.7c.2.5.7 1 1.1 1.4-.2-.5-.4-1.2.1-1.8.5-.5 1.3-.5 2-.2l-1.9-1.3c.8 0 3.3-1 4.1-1.5a62.3 62.3 0 0 0 4.9-3.8 57 57 0 0 0-3.7 4.6z"
    />
    <path
      fill="#a05a2c"
      stroke="#000"
      strokeWidth={0.1}
      d="M387 222.8l-125.7 70.9a85 85 0 0 0-.9-1.2l125.7-71a5.6 5.6 0 0 1 1 1.3z"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M394.9 218.3c-.6.6-2.2 2-2.2 3.4l-1.4-2c.2 1-.1 1.5-.7 1.7-.4.4-1.4 0-2-.3a5.1 5.1 0 0 0 2 1.5l1.7.6c-.6.1-2.3.3-3.4.2-.5 0-1.5-.2-1.9-.6-.7.4-1.6-.8-1-1.2 0-.4 0-.8.2-1.4.2-.7.7-1.8 1.6-2.8a7.8 7.8 0 0 0 0 1.8c0 .5.3 1 .5 1.6 0-.5 0-1.3.7-1.7.7-.4 1.4-.2 2 .3l-1.4-1.7c.8.1 3.5-.2 4.4-.5 1-.2 4.1-1.6 6-2.5-1.7 1-4.6 3-5.1 3.6z"
    />
    <path
      fill="#a05a2c"
      stroke="#000"
      strokeWidth={0.1}
      d="M376.3 217.5l-113 85.2-1-1.1 112.9-85.2a6 6 0 0 1 1.1 1z"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M383.4 212.1c-.5.6-1.8 2.3-1.6 3.6L380 214c.3 1 .1 1.5-.4 1.7-.4.4-1.5.2-2.1 0 .6.5 1.3 1 2.2 1.2l1.9.3c-.7.3-2.3.6-3.4.6-.5 0-1.6 0-2-.3-.6.5-1.7-.6-1.1-1.1-.2-.3-.1-.8-.1-1.4a6 6 0 0 1 1.1-3 7.8 7.8 0 0 0 .2 1.8c.2.6.5 1 .9 1.6-.2-.5-.2-1.3.4-1.8.6-.4 1.3-.3 2 0l-1.6-1.5c.7 0 3.3-.6 4.2-1 1-.4 3.8-2 5.5-3.1-1.4 1.2-4 3.5-4.4 4z"
    />
    <path
      fill="#a05a2c"
      stroke="#000"
      strokeWidth={0.1}
      d="M271.4 210.7l98 97.9 1.3-1-98-97.8a6.3 6.3 0 0 0-1.3 1z"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M265.3 204.5c.4.7 1.4 2.5 1 3.8l2-1.5c-.5 1-.4 1.4.1 1.8.3.4 1.4.3 2.1.2-.7.4-1.5.8-2.4 1h-2c.7.3 2.2.8 3.3 1 .5.1 1.6.2 2 0 .6.5 1.9-.4 1.3-1 .3-.3.3-.8.4-1.4 0-.7-.1-1.9-.7-3a8 8 0 0 1-.5 1.7c-.2.5-.7 1-1.1 1.4.2-.5.4-1.2-.1-1.8-.5-.5-1.3-.5-2-.2l1.9-1.3c-.8 0-3.3-1-4.1-1.5a62.3 62.3 0 0 1-4.9-3.8 57 57 0 0 1 3.7 4.6z"
    />
    <path
      fill="#a05a2c"
      stroke="#000"
      strokeWidth={0.1}
      d="M253 222.8l125.7 70.9c.2-.3.6-1 .9-1.2l-125.7-71a5.6 5.6 0 0 0-1 1.3z"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M245.1 218.3c.6.6 2.2 2 2.2 3.4l1.4-2c-.2 1 .1 1.5.7 1.7.4.4 1.4 0 2-.3a5.1 5.1 0 0 1-2 1.5l-1.8.6c.7.1 2.3.3 3.4.2.6 0 1.6-.2 2-.6.7.4 1.6-.8 1-1.2 0-.4 0-.8-.2-1.4a6.3 6.3 0 0 0-1.6-2.8v1.8c0 .5-.3 1-.5 1.6 0-.5 0-1.3-.7-1.7-.7-.4-1.4-.2-2 .3l1.4-1.7a17 17 0 0 1-4.4-.5 70.5 70.5 0 0 1-6-2.5c1.7 1 4.6 3 5.1 3.6z"
    />
    <path
      fill="#a05a2c"
      stroke="#000"
      strokeWidth={0.1}
      d="M263.7 217.5l113 85.2 1-1.1-112.9-85.2a6 6 0 0 0-1.1 1z"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M256.6 212.1c.5.6 1.8 2.3 1.6 3.6l1.7-1.7c-.3 1-.1 1.5.4 1.7.4.4 1.5.2 2.1 0a5.4 5.4 0 0 1-2.2 1.2l-1.9.3c.7.3 2.3.6 3.4.6.5 0 1.6 0 2-.3.6.5 1.7-.6 1.1-1.1.2-.3.1-.8.1-1.4a6 6 0 0 0-1.1-3 7.8 7.8 0 0 1-.2 1.8c-.2.6-.5 1-.9 1.6.2-.5.2-1.3-.4-1.8-.6-.4-1.3-.3-2 0l1.6-1.5a15 15 0 0 1-4.2-1c-1-.4-3.8-2-5.5-3.1 1.4 1.2 4 3.5 4.4 4z"
    />
    <path
      fill="#00e519"
      stroke="#000"
      strokeWidth={0.1}
      d="M300.1 283.4c4-2.6 15.1-4 16.7-3.6-8 6-16 6.3-16.7 3.7z"
    />
    <path
      fill="#ffe533"
      stroke="#000"
      strokeWidth={0.1}
      d="M300.2 283.5c.7 2.6 8.7 2.4 16.6-3.6a69 69 0 0 1-16.6 3.6z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.1}
      d="M300.2 283.5c.7 2.6 8.7 2.4 16.6-3.6a69 69 0 0 1-16.6 3.6z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M300.1 283.4a40.6 40.6 0 0 1 16.7-3.6c-8 6-16 6.3-16.7 3.6z"
    />
    <path
      fill="#a05a2c"
      stroke="#000"
      strokeWidth={0.1}
      d="M347.6 220.2L322 272.5c-1.3 1-2.3-.3-2.7-.2-1.5 1.7-3.6 2-4 2.5-1.8 2.4-.8 4.3-.7 4.5 1.3 1.8-1.6 3.5-1.5 4-.6 1-2.7.9-3.1 2l-4.8 9.3c-.6.5-3.7 6.1-3.7 6.1-2 0-10.2-5.2-10.4-5.1 4.6-7.3 15.6-18.5 15.3-19.2 3.1-5.2 8-10.9 10.1-10.8 3-1.6 4.5-5.7 4-6.6 2.2 0 3.5-1.4 3.6-1.5l18.8-37.6c1.6-.5 1.4.1 1.9 1 0 0 1-1.2.9-1.3.9-.4 1.8.2 1.8.6z"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M348.6 208.8c-.6 1 .2 1 .5 1.1l1 .3c1.3 0 2 .7 2 1l-30 61.3c-1.3 1-2.5-.3-2.9-.1l20.6-41.8 10-18.8-2.8-1.2c-.8-.2-1-.8-.7-1.6l12.6-21.6-10.2 21-.1.4"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M348.6 208.8c-.6 1 .2 1 .5 1.1l1 .3c1.3 0 2 .7 2 1l-30 61.3c-1.3 1-2.5-.3-2.9-.1l20.6-41.8 10-18.8-2.8-1.2c-.8-.2-1-.8-.7-1.6l12.6-21.6-10.2 21-.1.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M308.8 272.4c-3 0-4.6 2-2.7 4.7m1.4-2.4c-1 .6-1.7-.3-1.7-.3m15.2-13c-1.5 5.6-4.3 9.3-5 10.4-2 2.2-3.9 7.2-3.5 8.1l-8.1 13.3"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M322 272.7c-1.4-.5-5.7-4.5-10-3.8-3.3 3.8-5.3 7.7-5.9 8.2 4 3.3 6.7 5 7.6 5.4.7-.4 1-1.5 1-1.5.9-1-.2-1.7-.2-1.7.2-2.5 2-4.2 3.8-4.3 2.2-.2 1.6-.4 1.9-.4 1-.6 1.8-1.9 1.8-1.9z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M322 272.7c-1.4-.5-5.7-4.5-10-3.8-3.3 3.8-5.3 7.7-5.9 8.2 4 3.3 6.7 5 7.6 5.4.7-.4 1-1.5 1-1.5.9-1-.2-1.7-.2-1.7.2-2.5 2-4.2 3.8-4.3 2.2-.2 1.6-.4 1.9-.4 1-.6 1.8-1.9 1.8-1.9z"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M317.6 272.8c-2 0-4 .9-4.8 2.6l4.8-2.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M317.6 272.8c-2 0-4 .9-4.8 2.6m-3.5.7c.1.4.7.6 1.1.5.6-.2.8-.7.6-1-.2-.5-.7-.7-1.2-.5-.5.1-.7.6-.5 1zm2.5-3.4c.1.4.7.6 1.2.4.5-.1.7-.6.5-1-.2-.4-.7-.6-1.2-.5-.5.2-.7.7-.5 1z"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M345.3 226.1c.8-.2 1.2-1.1.8-2l-4.7-1.7s-.6 0-1 .7c-.5.7.1 1.2.1 1.2l4.8 1.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M345.3 226.1c.8-.2 1.2-1.1.8-2l-4.7-1.7s-.6 0-1 .7c-.5.7.1 1.2.1 1.2l4.8 1.8"
    />
    <path
      fill="#00e519"
      stroke="#000"
      strokeWidth={0.1}
      d="M294.5 286c3.9-2.7 15-4.2 16.6-3.8-7.8 6.2-15.8 6.5-16.6 3.9z"
    />
    <path
      fill="#ffe533"
      stroke="#000"
      strokeWidth={0.1}
      d="M294.6 286c.7 2.7 8.7 2.3 16.5-3.8a62.4 62.4 0 0 1-16.5 3.9z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.1}
      d="M294.6 286c.7 2.7 8.7 2.3 16.5-3.8a62.4 62.4 0 0 1-16.5 3.9z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M294.6 286a40 40 0 0 1 16.6-3.9c-7.9 6.2-16 6.6-16.6 4z"
    />
    <path
      fill="#a05a2c"
      stroke="#000"
      strokeWidth={0.1}
      d="M340.7 222l-24.4 52.8c-1.3 1-2.4-.3-2.7-.2-1.5 1.7-3.6 2.1-4 2.5-1.8 2.5-.7 4.4-.6 4.6 1.3 1.8-1.5 3.5-1.4 4-.6 1-2.7.9-3.1 2.1-.1-.1-4.2 8.4-4.6 9.3-.6.5-3.5 6.2-3.5 6.2-2.1 0-10.3-5-10.5-5 4.4-7.3 15.1-18.7 14.9-19.4 3-5.3 7.7-11 9.9-11 3-1.6 4.3-5.7 3.7-6.6 2.3-.1 3.5-1.5 3.7-1.6l18-37.8c1.6-.6 1.3 0 1.9 1 0 0 1-1.2.9-1.4.9-.4 1.7.2 1.8.6z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M340.7 222l-24.4 52.8c-1.3 1-2.4-.3-2.7-.2-1.5 1.7-3.6 2.1-4 2.5-1.8 2.5-.7 4.4-.6 4.6 1.3 1.8-1.5 3.5-1.4 4-.6 1-2.7.9-3.1 2.1-.1-.1-4.2 8.4-4.6 9.3-.6.5-3.5 6.2-3.5 6.2-2.1 0-10.3-5-10.5-5 4.4-7.3 15.1-18.7 14.9-19.4 3-5.3 7.7-11 9.9-11 3-1.6 4.3-5.7 3.7-6.6 2.3-.1 3.5-1.5 3.7-1.6l18-37.8c1.6-.6 1.3 0 1.9 1 0 0 1-1.2.9-1.4.9-.4 1.7.2 1.8.6z"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M341.4 210.6c-.5 1 .3 1 .6 1.2l1 .3c1.3 0 2 .6 2 1l-28.7 61.7c-1.3 1-2.5-.3-2.9 0l19.7-42.2 9.6-19-2.8-1c-.8-.3-1-.8-.7-1.7l12-21.8-9.6 21.1-.2.4"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M341.4 210.6c-.5 1 .3 1 .6 1.2l1 .3c1.3 0 2 .6 2 1l-28.7 61.7c-1.3 1-2.5-.3-2.9 0l19.7-42.2 9.6-19-2.8-1c-.8-.3-1-.8-.7-1.7l12-21.8-9.6 21.1-.2.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M303 275c-3-.2-4.6 2-2.6 4.6m1.3-2.4c-1 .6-1.7-.3-1.7-.3m15-13.3c-1.5 5.7-4.2 9.4-4.7 10.6-2.2 2.2-3.9 7.3-3.5 8.1l-7.8 13.4"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M316.1 275c-1.3-.5-5.8-4.5-10-3.7-3.3 3.9-5.1 7.8-5.7 8.3a50 50 0 0 0 7.7 5.3c.7-.4 1-1.5 1-1.5.8-1-.2-1.8-.2-1.8 0-2.4 1.8-4.2 3.6-4.3 2.2-.2 1.6-.4 1.9-.4 1-.6 1.7-2 1.7-2z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M316.1 275c-1.3-.5-5.8-4.5-10-3.7-3.3 3.9-5.1 7.8-5.7 8.3a50 50 0 0 0 7.7 5.3c.7-.4 1-1.5 1-1.5.8-1-.2-1.8-.2-1.8 0-2.4 1.8-4.2 3.6-4.3 2.2-.2 1.6-.4 1.9-.4 1-.6 1.7-2 1.7-2z"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M311.8 275.1c-2 0-4 1-4.7 2.7l4.7-2.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M311.8 275.1c-2 0-4 1-4.7 2.7m-3.6.8c.2.4.7.6 1.2.4.5-.2.7-.6.5-1-.2-.5-.7-.6-1.2-.5-.5.2-.7.6-.5 1zm2.4-3.5c.2.4.8.6 1.3.5.5-.2.7-.7.5-1-.2-.5-.7-.7-1.2-.5-.5.1-.8.6-.6 1z"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M338.5 228c.8-.2 1.1-1.1.7-2l-4.7-1.6s-.5 0-1 .7c-.4.7.2 1.2.2 1.2l4.8 1.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M338.5 228c.8-.2 1.1-1.1.7-2l-4.7-1.6s-.5 0-1 .7c-.4.7.2 1.2.2 1.2l4.8 1.8"
    />
    <path
      fill="#00e519"
      stroke="#000"
      strokeWidth={0.1}
      d="M340.6 283.3a39 39 0 0 0-16.8-3.7c8 6.1 16.1 6.3 16.8 3.7z"
    />
    <path
      fill="#ffe533"
      stroke="#000"
      strokeWidth={0.1}
      d="M340.6 283.3c-.7 2.7-8.8 2.4-16.8-3.6a63.4 63.4 0 0 0 16.8 3.6z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.1}
      d="M340.6 283.3c-.7 2.7-8.8 2.4-16.8-3.6a63.4 63.4 0 0 0 16.8 3.6z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M340.6 283.3c-4.2-3-15.8-4-16.9-3.7 8 6 16.2 6.3 16.9 3.6z"
    />
    <path
      fill="#a05a2c"
      stroke="#000"
      strokeWidth={0.1}
      d="M292.7 219.3l25.7 52.9c1.3 1 2.4-.3 2.7-.2 1.6 1.7 3.7 2.1 4.2 2.5 1.8 2.4.8 4.4.7 4.6-1.4 1.8 1.5 3.5 1.4 4.1.6 1 2.7.8 3.2 2l4.8 9.3c.7.5 3.7 6.2 3.7 6.2 2.1 0 10.3-5.3 10.5-5.2-4.6-7.3-15.7-18.7-15.4-19.4-3.1-5.2-8.1-11-10.2-10.9-3-1.6-4.5-5.7-4-6.6-2.3 0-3.6-1.5-3.7-1.6l-19-37.9c-1.6-.5-1.3.1-1.9 1 0 0-1-1.2-.9-1.3-.9-.5-1.8.2-1.8.5z"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M291.7 207.8c.5 1-.2 1-.5 1.2l-1.1.3c-1.2 0-1.9.7-1.9 1l30.2 61.9c1.3 1 2.5-.3 3-.1l-20.8-42.3-10-19 2.7-1.1c.8-.2 1-.8.7-1.6l-12.7-21.9 10.2 21.2.2.4"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M291.7 207.8c.5 1-.2 1-.5 1.2l-1.1.3c-1.2 0-1.9.7-1.9 1l30.2 61.9c1.3 1 2.5-.3 3-.1l-20.8-42.3-10-19 2.7-1.1c.8-.2 1-.8.7-1.6l-12.7-21.9 10.2 21.2.2.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M331.9 272.1c3 0 4.6 2.1 2.7 4.7m-1.4-2.3c1 .6 1.7-.4 1.7-.4M319.5 261c1.6 5.7 4.4 9.5 5 10.6 2.2 2.2 4 7.3 3.7 8.2l8.1 13.4"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M318.6 272.4c1.3-.4 5.7-4.6 10-3.8 3.4 3.8 5.4 7.7 6 8.2-4 3.4-6.7 5-7.7 5.5-.7-.4-1-1.5-1-1.5-.9-1 .2-1.8.2-1.8-.1-2.4-2-4.2-3.8-4.3-2.3-.2-1.6-.4-2-.4-1-.6-1.7-1.9-1.7-1.9z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M318.6 272.4c1.3-.4 5.7-4.6 10-3.8 3.4 3.8 5.4 7.7 6 8.2-4 3.4-6.7 5-7.7 5.5-.7-.4-1-1.5-1-1.5-.9-1 .2-1.8.2-1.8-.1-2.4-2-4.2-3.8-4.3-2.3-.2-1.6-.4-2-.4-1-.6-1.7-1.9-1.7-1.9z"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M323 272.5c2 0 4 1 4.8 2.7l-4.8-2.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M323 272.5c2 0 4 1 4.8 2.7m3.6.6a1 1 0 0 1-1.2.5.7.7 0 0 1-.5-1c.1-.5.7-.6 1.2-.5.5.2.7.6.5 1zm-2.5-3.4c-.2.4-.8.6-1.3.5-.4-.2-.7-.7-.5-1 .2-.5.7-.7 1.2-.5.5.1.8.6.6 1z"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M295 225.4a1.4 1.4 0 0 1-.8-2l4.8-1.8s.5.1 1 .7c.5.7-.2 1.2-.2 1.2l-4.8 1.9"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M295 225.4a1.4 1.4 0 0 1-.8-2l4.8-1.8s.5.1 1 .7c.5.7-.2 1.2-.2 1.2l-4.8 1.9"
    />
    <path
      fill="#00e519"
      stroke="#000"
      strokeWidth={0.1}
      d="M345.6 286a38 38 0 0 0-16.6-3.8c7.9 6.2 15.9 6.5 16.6 3.9z"
    />
    <path
      fill="#ffe533"
      stroke="#000"
      strokeWidth={0.1}
      d="M345.6 286c-.8 2.7-8.7 2.3-16.5-3.8a62.4 62.4 0 0 0 16.5 3.9z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.1}
      d="M345.6 286c-.8 2.7-8.7 2.3-16.5-3.8a62.4 62.4 0 0 0 16.5 3.9z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M345.6 286a40.1 40.1 0 0 0-16.6-3.9c7.8 6.2 15.9 6.6 16.6 4z"
    />
    <path
      fill="#a05a2c"
      stroke="#000"
      strokeWidth={0.1}
      d="M299.5 222l24.4 52.8c1.3 1 2.3-.3 2.7-.2 1.5 1.7 3.6 2.1 4 2.5 1.7 2.5.7 4.4.6 4.6-1.4 1.7 1.5 3.5 1.4 4 .5 1 2.6.9 3 2.1.2-.1 4.2 8.4 4.7 9.3.6.5 3.5 6.2 3.5 6.2 2 0 10.3-5 10.5-5-4.4-7.4-15.2-18.7-15-19.4-2.9-5.3-7.7-11-9.8-11-3-1.6-4.3-5.7-3.7-6.6-2.3-.1-3.6-1.5-3.7-1.6L304 222c-1.6-.6-1.4 0-2 1 0 0-.9-1.2-.8-1.4-.9-.4-1.8.2-1.8.6z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M299.5 222l24.4 52.8c1.3 1 2.3-.3 2.7-.2 1.5 1.7 3.6 2.1 4 2.5 1.7 2.5.7 4.4.6 4.6-1.4 1.7 1.5 3.5 1.4 4 .5 1 2.6.9 3 2.1.2-.1 4.2 8.4 4.7 9.3.6.5 3.5 6.2 3.5 6.2 2 0 10.3-5 10.5-5-4.4-7.4-15.2-18.7-15-19.4-2.9-5.3-7.7-11-9.8-11-3-1.6-4.3-5.7-3.7-6.6-2.3-.1-3.6-1.5-3.7-1.6L304 222c-1.6-.6-1.4 0-2 1 0 0-.9-1.2-.8-1.4-.9-.4-1.8.2-1.8.6z"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M298.8 210.6c.4 1-.3 1-.6 1.2l-1 .3c-1.3 0-2 .6-2 1l28.7 61.7c1.3 1 2.5-.3 2.9 0L307 232.5l-9.6-19 2.7-1c.9-.3 1.2-.8.8-1.7L288.8 189l9.7 21.1.2.4"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M298.8 210.6c.4 1-.3 1-.6 1.2l-1 .3c-1.3 0-2 .6-2 1l28.7 61.7c1.3 1 2.5-.3 2.9 0L307 232.5l-9.6-19 2.7-1c.9-.3 1.2-.8.8-1.7L288.8 189l9.7 21.1.2.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M337.2 275c3-.2 4.5 2 2.6 4.6m-1.4-2.4c1 .6 1.8-.3 1.8-.3m-15-13.3c1.4 5.7 4.2 9.4 4.7 10.6 2.1 2.2 3.8 7.3 3.5 8.1l7.8 13.4"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M324 275c1.4-.5 5.8-4.5 10.1-3.7 3.2 3.9 5.1 7.8 5.7 8.3a54.1 54.1 0 0 1-7.8 5.3c-.6-.4-1-1.5-1-1.5-.7-1 .3-1.8.3-1.8 0-2.4-1.8-4.2-3.6-4.3-2.3-.2-1.6-.4-2-.4-1-.6-1.7-2-1.7-2z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M324 275c1.4-.5 5.8-4.5 10.1-3.7 3.2 3.9 5.1 7.8 5.7 8.3a54.1 54.1 0 0 1-7.8 5.3c-.6-.4-1-1.5-1-1.5-.7-1 .3-1.8.3-1.8 0-2.4-1.8-4.2-3.6-4.3-2.3-.2-1.6-.4-2-.4-1-.6-1.7-2-1.7-2z"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M328.4 275.1c2 0 4 1 4.7 2.7l-4.7-2.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M328.4 275.1c2 0 4 1 4.7 2.7m3.6.8a1 1 0 0 1-1.2.4c-.5-.2-.8-.6-.6-1 .2-.5.8-.6 1.3-.5.4.2.7.6.5 1zm-2.5-3.5c-.2.4-.7.6-1.2.5-.5-.2-.7-.7-.5-1 .2-.5.7-.7 1.2-.5.5.1.7.6.5 1z"
    />
    <path
      fill="#cce5e5"
      stroke="#000"
      strokeWidth={0.1}
      d="M301.6 228c-.8-.2-1-1.1-.7-2l4.7-1.6s.6 0 1 .7c.5.7-.2 1.2-.2 1.2l-4.8 1.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M301.6 228c-.8-.2-1-1.1-.7-2l4.7-1.6s.6 0 1 .7c.5.7-.2 1.2-.2 1.2l-4.8 1.8"
    />
    <path
      fill="#a05a2c"
      stroke="#000"
      strokeWidth={0.1}
      d="M315.3 250.7l35.5-38a97.4 97.4 0 0 1-1.4-.9l-35.6 38a7.5 7.5 0 0 0 1.5.9z"
    />
    <path
      fill="#e7e7e7"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M349.8 212.2c-1.2-1-3.4-2.2-5-1.8-.5-2.2 2.5-4.4 3.8-4-.3 2.3 3.2 3.8 3.1 3.8l-1.9 2z"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M352.1 210.4c1 .8 1.4.8 2.8 1.6 1.4.7 3.2-1.1 4.1-1.7 0 0 1 3.4-1.1 5.6-2 2.3-4.6 2.8-6.5 2.1 0 0 2.6-2.5 1.5-3.6-1-1.1-1.4-1.2-2.5-1.9"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M-27.7-406.5h4.1v2.2h-4.1z"
      transform="matrix(-.67726 .73575 -.82314 -.56784 0 0)"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M308.2 290.3l-1 9 1.8-2.2c.3-.6 1.5-2.1 1.8-7.4 0 0-1-2.9-1.4-2.9-.7-.4-1.2 3.5-1.2 3.5zm2.2-20.1l-2.7 15.8c0 .5 1.3 1.6 2.1-1.2l1.5-10.5-1-4.1z"
    />
    <path
      fill="#d52b1e"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M315.9 284.6a8.7 8.7 0 0 1-1.4-2l-.4 3.1s2 1.5 1.7 4.3l.4-.6.2-1s.5-2 .5-3.1c0 0-.5-.2-1-.7z"
    />
    <path
      fill="#ffe000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M307.3 299.4s3.3-3 3.5-9.7l.4-1.9s0 1.5.8.4c.6-1.5.6-2.8.6-2.8s1.2-1.6 1.6.3l-1.2 9.6a51.4 51.4 0 0 1-.3 2s-.7-1-1.4.1c-.7 1.2-1.8 2.7-4 2zm4-25.1l-1.5 10.5s1.2.6 1.4 3c.1 1.2.6.6.8.4.2-.8 0-2.3 0-2.3l.6-7.3s-1.2-3.4-1.3-4.3z"
    />
    <path
      fill="#ffe000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M310.1 298.8l-.2 2.6s1 0 1.7-1.2c.8-1.1 1-2.8 1-2.8s-.7-1.1-1.3 0c-.5 1-1.2 1.4-1.2 1.4zm1.8-10.6c.6-1 .8-2.6.7-2.8l-.7.5c.2 1.2 0 2.3 0 2.3z"
    />
    <path
      fill="#d52b1e"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M315.3 287.1a4.4 4.4 0 0 0-1.3-1.5l-1.5 12s-.4 3-2.3 3.7c0 0 1.1 10.3 4.5 7.5.4-.4 1-3.6.9-5.5l-.9-6a26.8 26.8 0 0 1 .5-4.7l.6-2.6c.2-.2 0-1.8-.5-2.9z"
    />
    <path
      fill="#d52b1e"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M316.9 285.3l1 1c.3 0-2.3 19.3-2.3 19.3s0-2-.7-6c-.6-3.2.2-7.5.9-9.6 0 0 .8-.5 1-4.7z"
    />
    <path
      fill="#f7e214"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M312.6 278.8l-.7 7.1s1.8-2.4 2.2-.2l.4-3.2s-1.5-2.4-2-3.7z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M311.3 287.8s-.6-6.1-3.6-1.8a10 10 0 0 0 0 3c0 .8.9 1.8 1.2 2.3.7 1 1.3-.2 1.3-.2s.7-1 1-3.3z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M287.8 237c-.1-3.5-1.2-9.3-1.3-13.3l-12-12.2s-1.4 9.9-5.8 15.5l19 10"
    />
    <path
      fill="#ffe000"
      stroke="#000"
      strokeWidth={0.1}
      d="M288.7 237.3c.5-2.4 1-5 1.5-10.2l-7.7-7.6c0 3.2-3.6 8.1-3.9 14"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M295.3 244.7c1-4.3-1.3-4.8 2-10.8l-7.2-6.8c-1.3 4-2.2 6.6-2 10l6 4.4"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M267.6 270c-1.5-4.2.5-12.7.2-18-.1-3.5 2.5-16.7 2.4-20.6l-14.1-8.8s-.6 14.3-2.3 29.9c-1.4 8-1.4 15.3-.4 21.5 1.5 8.7 3 12.2 6.5 15.9 6.3 6.5 19.7 2.7 19.7 2.7 11.3-2.3 17.8-9.4 17.8-9.4s-3.7.8-9.6 1.4c-13-.9-18.2 2.4-18.6-11"
    />
    <path
      fill="#f7e214"
      stroke="#000"
      strokeWidth={0.1}
      d="M305.4 278.8l.2-.1-5.9 1.9-8 .6c-17.2.4-15-10.3-14.3-27.5.1-6.6 1.4-14.8 1-17.7l-11.5-6.6c-3.8 10.6-2.6 18-3.3 23.5-.4 6-1.7 17.4.2 22.4 2.7 11.6 11.8 11.2 24.2 10.1 6.1-.5 9.4-2 9.4-2l8-4.6"
    />
    <path
      fill="#007a3d"
      stroke="#000"
      strokeWidth={0.1}
      d="M305.6 278.5a34.4 34.4 0 0 1-6 2.2l-8 .8c-12.5 1-19.8-7.7-18.2-27.6 0-7 .2-10.2 2.6-19.5l7 4v.7c-.5 2-1.5 7-1.5 9.2 0 16 10.1 28.2 23.9 30.3h.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M260 230.6c1 2 8 12.5 12 14.5m-11-7.6c1.3 2 9.8 14 13.6 14.6m-15.5 3.6c2 2.4 4 7 9.7 10m-7 3.3c4 3.7 13.6 11.6 23 12m-23-6c2 2.3 6.2 13.3 24 8.3m-26.7-6.3c1.2 2.6 10.1 17.3 26 11.6"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M277.8 264.8c-1.5-4.3.5-12.7.2-18.1-.1-3.5 1.5-15.5 1.5-19.5l-13.2-9.9s-.6 14.3-2.3 30a84 84 0 0 0-1.5 23.9c1.8 10 6.6 12.8 7.5 13.6 6.7 6 22 5.4 23.5 4.9 10.8-4 15.6-10.8 15.6-10.8s-5.2-.1-11.1.5c-13-1-19.7-.4-20.1-13.8"
    />
    <path
      fill="#ffe000"
      stroke="#000"
      strokeWidth={0.1}
      d="M315.6 273.5h.2l-5.9 1.8-8 .6c-17.2.5-15-10.2-14.3-27.5.1-6.5.3-12.4 0-15.3l-10.3-7.6c-3.8 10.7-2.8 16.7-3.5 22.2-.4 5.8-1.7 17.3.2 22.3 2.7 11.7 11.8 11.2 24.2 10.2 6.1-.5 9.4-2.1 9.4-2.1l8-4.6"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M315.9 273.4c-2.4 1.2-6 2.1-6 2.1l-8 .8c-12.5 1-19.8-7.7-18.2-27.6 0-7-.3-7.5 2.2-16.9 3.8 2.5 11.1 8.8 11.1 8.8s-2 2.8-1.5 6.7c0 16 6.4 24 20.2 26.1l1.5-13"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M270.1 225.3c1.2 2 8.1 12.6 12 14.6m-10.8-7.7c1.2 2 9.7 14 13.5 14.7m-15.5 3.6c2 2.3 4 7 9.7 10m-7 3.3c4 3.6 13.6 11.6 23 12m-23-6c2 2.3 6.2 13.2 24 8.3m-26.7-6.4c1.2 2.7 10.1 17.3 26 11.7"
    />
    <path
      fill="#e8a30e"
      stroke="#000"
      strokeWidth={0.1}
      d="M256.2 224l-.7 6c-.2 4.4-.1 7.7.1 9.8 0 .2.9 5.5.6 5.8-1 1.1-1.1 1.2-2.2.4-.1-.2.5-5.6.5-6.3l.4-9.9c0-1 1-6.4 1-6.4s0-1.2.3.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M256.2 224l-.7 6c-.2 4.4-.1 7.7.1 9.8l.7 5.8c-1 1.1-1.2 1.6-2.3.7-.1-.2.5-5.9.5-6.6l.4-9.9c0-1 1-6.4 1-6.4s0-1.2.3.5z"
    />
    <path
      fill="#f7e214"
      stroke="#000"
      strokeWidth={0.1}
      d="M256 222.2s-1 6-1.2 9.6l-.3 7.9-.5 4.5c-.1.7.1.2 0 .2-.9.5-1.5.1-2-.3-.2-.1 1.4-3.8 1.4-4.5.9-10.8 2.4-17 2.4-17s-.6 3.7.3-.4"
    />
    <path
      fill="#e8a30e"
      stroke="#000"
      strokeWidth={0.1}
      d="M256 222.2s-1 6-1.2 9.6l-.3 7.9-.5 4.5c-.1.7.1.2 0 .2-.9.5-1.5.1-2-.3-.1-.1 1.4-3.8 1.5-4.5.8-10.8 2.3-17.1 2.3-17.1s-.6 3.8.3-.3zm-.4 17.3s-1 .4-1 .2m0-1.3s.7 0 .8-.2m0-1s-.6.3-.8 0m.8-1.6h-.6m.6-1.5h-.6m.5-2.1s-.3.1-.4-.1m.5-1.7h-.5m-.5 9.5s-.9.2-1-.1m1.1-2s-.9.1-1-.1m1-1.3h-.7m.9-1.5h-.7m.7-1.7h-.5m.7-1.5h-.6m.6-1.7s-.4.3-.4 0m0 9s-.9 0-.9-.3m12.8-19.8l-.7 6a63.4 63.4 0 0 0 0 9.8c0 .3 1 5.5.7 5.8-1 1.2-1.1 1.3-2.2.4-.1-.1.5-5.5.5-6.3l.4-9.8c0-1.1 1-6.5 1-6.5s0-1.1.3.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M266.4 218.7l-.7 6a73 73 0 0 0 .1 9.8l.7 5.8c-1 1.2-1.2 1.6-2.3.7-.1-.1.5-5.8.5-6.6l.4-9.8c0-1.1 1-6.5 1-6.5s0-1.1.3.6z"
    />
    <path
      fill="#e8a30e"
      stroke="#000"
      strokeWidth={0.1}
      d="M266.3 217s-1.2 6-1.3 9.5l-.3 8-.5 4.4v.3c-.9.5-1.5 0-2-.4-.2 0 1.4-3.7 1.4-4.5a127 127 0 0 1 2.4-17l.3-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M266.3 217s-1.2 6-1.3 9.5l-.3 8-.5 4.4v.3c-.9.5-1.5 0-2-.4-.2 0 1.4-3.7 1.4-4.5.9-10.8 2.4-17 2.4-17l.3-.4zm-.5 17.2s-1 .5-1 .2m0-1.2s.7 0 .8-.3m0-1s-.6.4-.8.1m.7-1.7h-.5m.6-1.5h-.6m.5-2s-.4 0-.4-.2m.5-1.7h-.5m-.5 9.6s-.9.1-1-.2m1.1-1.9s-.9 0-1-.2m1-1.3h-.7m.9-1.4h-.7m.7-1.7l-.5-.1m.7-1.4l-.6-.1m.6-1.6s-.4.2-.4 0m0 9s-.9 0-.9-.4"
    />
    <path
      fill="#e8a30e"
      stroke="#000"
      strokeWidth={0.1}
      d="M274.3 211.3s.5 5.1.2 8c-.3 3.5-.3 4.5-.6 6.6v3.9c.8.5 1.5.2 2 0 .3-.1-1-3.3-1-4 .5-8.9-.4-14.3-.4-14.3l-.2-.2"
    />
    <path
      fill="#e8a30e"
      stroke="#000"
      strokeWidth={0.1}
      d="M274.3 211.3s.5 5.1.2 8c-.3 3.5-.3 4.5-.6 6.6v3.8c0 .5-.1 0 0 .1.8.5 1.4.2 2 0 .2-.1-1-3.3-1-4 .5-9-.4-14.3-.4-14.3l-.2-.2zm-.3 14.6s.9.2 1 0m-.8-1.7s.9.2 1 0m-1-1.2h.9m-.8-1.2h.7m-.5-1.4h.5m-.5-1.3h.5m-.4-1.4s.4.2.4 0m-1 7.4s1 .1 1-.1"
    />
    <path
      fill="#005000"
      stroke="#000"
      strokeWidth={0.1}
      d="M306 221.7h.8-.8z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M316.7 256.4s-.3-.2-.4 0l.1.2.3-.2zm-1 1.1l2.1-.1"
    />
    <path
      fill="#e8a30e"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M292.2 284.2c-.2 3-7.4 6.6-12.7.1-5.7-4.5-4.5-11.4 0-12.3l54.7-53.3c2.2-1.2 2.4-2.3 3.5-3.5 2.3 2.5 7 6.8 9.6 9-1.6 1.2-2.9 2.5-3.2 3.5l-52 56.5z"
    />
    <path
      fill="#e7e7e7"
      fillRule="evenodd"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.1}
      d="M337.8 215c2.6-3.5 12.8 5.8 10 8.7-2.6 2.8-12.4-5-10-8.6z"
    />
    <path
      fill="#cccccf"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M347 223c-2 1.4-9.3-4.8-8.1-7.2 2-2.2 10.1 5.7 8 7.2z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M344 227.9a15.8 15.8 0 0 1-9.9-9m-23 44.8a16.3 16.3 0 0 1-11.4-11.6m9.1 14.3a16.3 16.3 0 0 1-11.4-11.6m-2.1 25.8c-5.8-1.8-10.4-6-12.2-12.1m9.8 14.8a18 18 0 0 1-12.3-12.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.1}
      d="M279.4 285c-.3 1.4-1 1.8-2.1 1.4m13.7-2c-2.1 3.5-4.5 2.4-6.5 2.5"
    />
    <path
      fill="#e8a30e"
      stroke="#000"
      strokeWidth={0.1}
      d="M276.4 285.2c0 1 .8 1.6 1.7 1.6a1.7 1.7 0 0 0 1.7-1.6c0-1-.7-1.6-1.7-1.6s-1.7 1-1.7 1.9"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.1}
      d="M279.5 284.9c-.3 1.3-1 1.7-2 1.3m13.5-1.7c-2.1 3.4-4.5 2.3-6.5 2.4"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M331.8 290.3l1 9-1.8-2.2c-.3-.6-1.5-2.1-1.8-7.4 0 0 1-2.9 1.4-2.9.7-.4 1.2 3.5 1.2 3.5zm-2.2-20.1l2.7 15.8c0 .5-1.3 1.6-2.1-1.2l-1.5-10.5 1-4.1z"
    />
    <path
      fill="#d52b1e"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M324.1 284.6l1.4-2 .4 3.1s-2 1.5-1.7 4.3l-.4-.6-.2-1s-.5-2-.5-3.1c0 0 .5-.2 1-.7z"
    />
    <path
      fill="#ffe000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M332.8 299.4s-3.4-3-3.6-9.7l-.4-1.9s0 1.5-.8.4c-.6-1.5-.6-2.8-.6-2.8s-1.2-1.6-1.6.3l1.2 9.6.3 2s.7-1 1.4.1c.7 1.2 1.8 2.7 4 2zm-4.1-25.1l1.5 10.5s-1.2.6-1.4 3c-.1 1.2-.6.6-.8.4-.2-.8 0-2.3 0-2.3l-.6-7.3s1.2-3.4 1.3-4.3z"
    />
    <path
      fill="#ffe000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M329.9 298.8l.2 2.6s-1 0-1.7-1.2c-.8-1.1-1-2.8-1-2.8s.7-1.1 1.3 0c.5 1 1.2 1.4 1.2 1.4zm-1.8-10.6a6 6 0 0 1-.7-2.8l.7.5c-.2 1.2 0 2.3 0 2.3z"
    />
    <path
      fill="#d52b1e"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M324.8 287.1a4.4 4.4 0 0 1 1.2-1.5l1.5 12s.4 3 2.3 3.7c0 0-1.1 10.3-4.5 7.5-.4-.4-1-3.6-.9-5.5l.9-6a26.8 26.8 0 0 0-.5-4.7 31 31 0 0 0-.6-2.6c-.2-.2 0-1.8.5-2.9z"
    />
    <path
      fill="#d52b1e"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M323.1 285.3l-1 1c-.3 0 2.3 19.3 2.3 19.3s0-2 .7-6c.6-3.2-.2-7.5-.9-9.6 0 0-.8-.5-1-4.7z"
    />
    <path
      fill="#f7e214"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M327.4 278.8l.7 7.1s-1.8-2.4-2.2-.2l-.4-3.2s1.5-2.4 2-3.7z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M328.7 287.8s.6-6.1 3.6-1.8c0 0 .2 2.4 0 3 0 .8-.9 1.8-1.2 2.3-.7 1-1.3-.2-1.3-.2s-.7-1-1-3.3z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M352.2 237c.1-3.5 1.2-9.3 1.3-13.3l12-12.2s1.4 9.9 5.8 15.5l-19 10"
    />
    <path
      fill="#ffe000"
      stroke="#000"
      strokeWidth={0.1}
      d="M351.3 237.3c-.5-2.4-1-5-1.5-10.2l7.7-7.6c0 3.2 3.6 8.1 3.9 14"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M344.7 244.7c-1-4.3 1.3-4.8-2-10.8l7.2-6.8c1.3 4 2.2 6.6 2 10l-6 4.4"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M372.4 270c1.5-4.2-.5-12.7-.2-18 .1-3.5-2.5-16.7-2.4-20.6l14.1-8.8s.6 14.3 2.3 29.9c1.4 8 1.4 15.3.4 21.5-1.5 8.7-3 12.2-6.5 15.9-6.3 6.5-19.7 2.7-19.7 2.7-11.3-2.3-17.8-9.4-17.8-9.4s3.7.8 9.6 1.4c13-.9 18.2 2.4 18.6-11"
    />
    <path
      fill="#f7e214"
      stroke="#000"
      strokeWidth={0.1}
      d="M334.6 278.8l-.2-.1 5.9 1.9 8 .6c17.2.4 15-10.3 14.3-27.5-.1-6.6-1.4-14.8-1-17.7l11.5-6.6c3.8 10.6 2.6 18 3.3 23.5.4 6 1.7 17.4-.2 22.4-2.7 11.6-11.8 11.2-24.2 10.1-6.1-.5-9.4-2-9.4-2l-8-4.6"
    />
    <path
      fill="#007a3d"
      stroke="#000"
      strokeWidth={0.1}
      d="M334.4 278.5a34.4 34.4 0 0 0 6 2.2l8 .8c12.5 1 19.8-7.7 18.2-27.6 0-7-.2-10.2-2.6-19.5l-7 4v.7c.5 2 1.5 7 1.5 9.2 0 16-10.1 28.2-23.9 30.3h-.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M380 230.6c-1 2-8 12.5-12 14.5m11-7.6c-1.3 2-9.8 14-13.6 14.6m15.5 3.6c-2 2.4-4 7-9.7 10m7 3.3c-4 3.7-13.6 11.6-23 12m23-6c-2 2.3-6.2 13.3-24 8.3m26.7-6.3c-1.2 2.6-10.1 17.3-26 11.6"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M362.3 264.8c1.4-4.3-.6-12.7-.4-18.1.2-3.5-1.4-15.5-1.4-19.5l13.2-9.9s.6 14.3 2.3 30a84 84 0 0 1 1.5 23.9c-1.8 10-6.6 12.8-7.5 13.6-6.7 6-22 5.4-23.5 4.9-10.8-4-15.6-10.8-15.6-10.8s5.2-.1 11.1.5c13-1 19.7-.4 20.1-13.8"
    />
    <path
      fill="#ffe000"
      stroke="#000"
      strokeWidth={0.1}
      d="M324.4 273.5h-.2l5.9 1.8 8 .6c17.2.5 15-10.2 14.3-27.5-.1-6.5-.3-12.4 0-15.3l10.3-7.6c3.8 10.7 2.8 16.7 3.5 22.2.4 5.8 1.7 17.3-.2 22.3-2.7 11.7-11.8 11.2-24.2 10.2-6.1-.5-9.4-2.1-9.4-2.1l-8-4.6"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M324.1 273.4a34.4 34.4 0 0 0 6 2.1l8 .8c12.5 1 19.8-7.7 18.2-27.6 0-7 .3-7.5-2.2-16.9-3.8 2.5-11.1 8.8-11.1 8.8s2 2.8 1.5 6.7c0 16-6.4 24-20.2 26.1l-1.5-13"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M369.9 225.3c-1.2 2-8.1 12.6-12 14.6m10.8-7.7c-1.2 2-9.7 14-13.5 14.7m15.5 3.6c-2 2.3-4 7-9.7 10m7 3.3c-4 3.6-13.6 11.6-23 12m23-6c-2 2.3-6.2 13.2-24 8.3m26.7-6.4c-1.2 2.7-10.1 17.3-26 11.7"
    />
    <path
      fill="#f7e214"
      stroke="#000"
      strokeWidth={0.1}
      d="M383.8 224l.7 6c.2 4.4.1 7.7-.1 9.8 0 .2-.8 5.5-.6 5.8 1 1.1 1.1 1.2 2.2.4.1-.2-.5-5.6-.5-6.3l-.4-9.9c0-1-1-6.4-1-6.4s0-1.2-.3.5"
    />
    <path
      fill="#e8a30e"
      stroke="#000"
      strokeWidth={0.1}
      d="M383.8 224l.7 6c.2 4.4.1 7.7-.1 9.8l-.7 5.8c1 1.1 1.2 1.6 2.3.7.1-.2-.5-5.9-.5-6.6l-.4-9.9c0-1-1-6.4-1-6.4s0-1.2-.3.5z"
    />
    <path
      fill="#f7e214"
      stroke="#000"
      strokeWidth={0.1}
      d="M384 222.2s1 6 1.2 9.6l.3 7.9.5 4.5c.1.7 0 .2 0 .2.9.5 1.5.1 2-.3.2-.1-1.4-3.8-1.4-4.5-.9-10.8-2.4-17-2.4-17s.6 3.7-.3-.4"
    />
    <path
      fill="#e8a30e"
      stroke="#000"
      strokeWidth={0.1}
      d="M384 222.2s1 6 1.2 9.6l.3 7.9.5 4.5c.1.7-.1.2 0 .2.9.5 1.5.1 2-.3.2-.1-1.4-3.8-1.4-4.5-.9-10.8-2.4-17.1-2.4-17.1s.6 3.8-.3-.3zm.4 17.3s1 .4 1 .2m0-1.3s-.7 0-.8-.2m0-1s.6.3.8 0m-.7-1.6h.5m-.6-1.5h.6m-.5-2.1s.4.1.4-.1m-.5-1.7h.5m.5 9.5s.9.2 1-.1m-1.1-2s.9.1 1-.1m-1-1.3h.7m-.9-1.5h.7m-.7-1.7h.5m-.7-1.5h.6m-.6-1.7s.4.3.4 0m0 9s.9 0 .9-.3"
    />
    <path
      fill="#f7e214"
      stroke="#000"
      strokeWidth={0.1}
      d="M373.6 218.7l.7 6a73 73 0 0 1-.1 9.8c0 .3-.8 5.5-.6 5.8 1 1.2 1.1 1.3 2.2.4.1-.1-.5-5.5-.5-6.3l-.4-9.8c0-1.1-1-6.5-1-6.5s0-1.1-.3.6"
    />
    <path
      fill="#e8a30e"
      stroke="#000"
      strokeWidth={0.1}
      d="M373.6 218.7l.7 6a73 73 0 0 1-.1 9.8l-.7 5.8c1 1.2 1.2 1.6 2.3.7.1-.1-.5-5.8-.5-6.6l-.4-9.8c0-1.1-1-6.5-1-6.5s0-1.1-.3.6z"
    />
    <path
      fill="#f7e214"
      stroke="#000"
      strokeWidth={0.1}
      d="M373.7 217s1.2 6 1.3 9.5l.3 8 .5 4.4v.3c.9.5 1.5 0 2-.4.2 0-1.4-3.7-1.4-4.5a127 127 0 0 0-2.4-17l-.3-.4"
    />
    <path
      fill="#e8a30e"
      stroke="#000"
      strokeWidth={0.1}
      d="M373.7 217s1.2 6 1.3 9.5l.3 8 .5 4.4v.3c.9.5 1.5 0 2-.4.2 0-1.4-3.7-1.4-4.5-.9-10.8-2.4-17-2.4-17l-.3-.4zm.5 17.2s1 .5 1 .2m0-1.2s-.7 0-.8-.3m0-1s.6.4.8.1m-.7-1.7h.5m-.6-1.5h.6m-.5-2s.4 0 .4-.2m-.5-1.7h.5m.5 9.6s.9.1 1-.2m-1.1-1.9s.9 0 1-.2m-1-1.3h.7m-.9-1.4h.7m-.7-1.7l.5-.1m-.7-1.4l.6-.1m-.6-1.6s.4.2.4 0m0 9s.9 0 .9-.4m-10.5-22s-.5 5.2-.2 8.1c.3 3.5.3 4.5.6 6.6v3.9c-.8.5-1.4.2-2 0-.2-.1 1-3.3 1-4-.5-8.9.4-14.3.4-14.3l.2-.2"
    />
    <path
      fill="#e8a30e"
      stroke="#000"
      strokeWidth={0.1}
      d="M365.7 211.3s-.5 5.1-.2 8c.3 3.5.3 4.5.6 6.6v3.8c0 .5.1 0 0 .1-.8.5-1.4.2-2 0-.2-.1 1-3.3 1-4-.5-9 .4-14.3.4-14.3l.2-.2zm.3 14.6s-.9.2-1 0m.8-1.7s-.9.2-1 0m1-1.2h-.9m.8-1.2h-.7m.5-1.4h-.5m.5-1.3h-.5m.4-1.4s-.4.2-.4 0m1 7.4s-1 .1-1-.1"
    />
    <path
      fill="#005000"
      stroke="#000"
      strokeWidth={0.1}
      d="M334 221.7h-.8.8z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M323.3 256.4s.3-.2.4 0l-.1.2-.3-.2zm1 1.1l-2.1-.1"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M291.7 215.5c0-2.1 2-3.3 2.2-3.6 1-.6 1.7-1.2 3.7-1.5l.2.9c0 .3-.5 1.6-2 2.7a11.5 11.5 0 0 1-4.1 1.5z"
    />
    <path
      fill="#a05a2c"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M291.6 214.7l29.7 38.4 1.4-1.3-30.2-39.1-.9 2z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M291.2 207.2s3.2-.4 2.8-2.2c-.5-1.8-2.6-1.8-3.5-1.9-1 0-4 .7-4.8 1.5-.9 1-2.7 2.5-2.1 5s1.3 4.4 2.3 6c.9 1.6.7 3.2.4 3.9 0 .3-.4 1.3.4 1.6 1.2.5 1.5.5 2.5-.6s2.5-3 2.5-5c0-2.1 2-3.3 2.2-3.6 1-.6 1.7-1.2 3.7-1.5 0 0-.7-1.2-1.8-1-1.1 0-3.4-1-4.6-2.2z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M291.2 207.2s3.2-.4 2.8-2.2c-.5-1.8-2.6-1.8-3.5-1.9-1 0-4 .7-4.8 1.5-.9 1-2.7 2.5-2.1 5s1.3 4.4 2.3 6c.9 1.6.7 3.2.4 3.9 0 .3-.4 1.3.4 1.6 1.2.5 1.5.5 2.5-.6s2.5-3 2.5-5c0-2.1 2-3.3 2.2-3.6 1-.6 1.7-1.2 3.7-1.5 0 0-.7-1.2-1.8-1-1.1 0-3.4-1-4.6-2.2z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M291.2 207.2c-.4 0-1.7-.6-2.6-.3-.9.4-2.7 1.4-2.4 3m10.4-.3s-1.8.8-3.1 1.7c-.6.3-2.4 2-3.5 3.2-1 1-1.3 2.4-3.5 3.9m9-9l-1.4 1c-.7.3-.9.9-1.2 1.3"
    />
    <path
      fill="#e8a30e"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M347.8 284.2c.2 3 7.4 6.6 12.7.1 5.7-4.5 4.5-11.4 0-12.3l-54.7-53.3c-2.2-1.2-2.4-2.3-3.5-3.5a133 133 0 0 1-9.6 9 9.9 9.9 0 0 1 3.2 3.5l51.9 56.5z"
    />
    <path
      fill="#e7e7e7"
      fillRule="evenodd"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.1}
      d="M302.2 215c-2.6-3.5-12.8 5.8-10 8.7 2.6 2.8 12.4-5 10-8.6z"
    />
    <path
      fill="#cccccf"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M293 223c2 1.4 9.3-4.8 8.1-7.2-2-2.2-10.1 5.7-8 7.2z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M296 227.9a16 16 0 0 0 9.9-9m23 44.8c5.7-1.7 9.6-5.5 11.4-11.6m-9.1 14.3c5.7-1.8 9.7-5.5 11.4-11.6m2.1 25.8c5.8-1.8 10.4-6 12.2-12.1m-9.8 14.8a18 18 0 0 0 12.3-12.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.1}
      d="M360.6 285c.3 1.4 1 1.8 2.1 1.4m-13.7-2c2.1 3.5 4.5 2.4 6.5 2.5"
    />
    <path
      fill="#e8a30e"
      stroke="#000"
      strokeWidth={0.1}
      d="M363.6 285.2c0 1-.8 1.6-1.7 1.6a1.7 1.7 0 0 1-1.7-1.6c0-1 .7-1.6 1.7-1.6s1.7 1 1.7 1.9"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.1}
      d="M360.5 284.9c.3 1.3 1 1.7 2 1.3m-13.5-1.7c2.1 3.4 4.5 2.3 6.5 2.4"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M339.6 175.5c1.8 2.9 4.4 8 5.2 12a22.5 22.5 0 0 1-7 20.8c-5.2 4.7-13.3 6-16.7 6.8-3.3.7-5.7 1.8-6.3 2.5 0-.5 0-1 .5-1.6 1.6-.7 4.1-1 7.8-1.8 7.2-1.5 14.8-4.2 19-12.2 5.4-10.3 2.2-18.4-2.5-26.4z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M341.6 206.2a.4.6 49.9 0 1-.6-.6.4.6 49.9 1 1 .6.6z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M346.6 205c-1.1.6-2.2.7-3 1a65.7 65.7 0 0 0-3.7 1.4c-.8.3-1.6 1.3-1.6 1.3s1.2 1.3 2.6 1.1c1.2-.1 1.7-.4 2.3-.7.6-.3.6-.6 1.4-1.2 1-.7 1.6-2 2-3zm-5.7 1.1c-.3.6-1.1.5-1.6.5l-.2.2c.6 0 1.5 0 2-.5l-.2-.2z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M346.6 205c-1 1-2.8 2-4.7 2.8a14 14 0 0 1-5 1l-.2.3c1.4-.1 3.4-.4 5-1.1a14.9 14.9 0 0 0 4.9-3zm-2.4 4.6c-2-.1-3 .5-4.8.9-1.7.4-3.7-.5-4.8 1.1 4.4 2.9 7.6 1 9.6-2z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M340.2 213.6c-.8-.8-8-3.2-9.2-.5 1.7 2 6.8 2.4 9.2.5z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M338.5 215.5l-2.5-.4c-1-.1-1.3-.3-1.9-.4-1-.1-2.3-1.6-6-.5 1.4 3.4 6.4 4 10.4 1.3zm1.6-1.9c-3.8.8-8.3 0-10.1-1l-.3.2a16.3 16.3 0 0 0 10.4.8zm4-4c-2.2 1.5-5.2 2.6-11.4 1.8v.2c8.5.7 9.3-.8 11.4-2z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M338.5 215.5c-3 .1-4.7 1.4-10.3-1.3l-1.4-.6-.5.2 1.4.4c7 3 6.8 1.6 10.8 1.3z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M327.3 211.6a.4.6 66.2 1 0 .4.7.4.6 66.2 0 0-.4-.7z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M327.1 212.3c-.6.1-.8.9-.8 1.3l-.4.2c.2-.6.4-1.4 1.2-1.7v.1z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M346 186.8a.4.6 15.8 1 1-1-.2.4.6 15.8 0 1 1 .2z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M341.6 203.2c-.1-2.1-1.1.8-3.2-3.9-.6-1.4-.6-2.2-1-4.3 1.2 1.8 3 2.3 3.8 3.6.7 1.4.5 3.5.4 4.6z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M337.5 195.2s1 2.4 2.4 4a7.9 7.9 0 0 1 1.8 3.7"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M338.5 197.2c1.3 1.7 3 3.8 3 6h.3c-.3-2.8-2-4.1-3-5.6l-.3-.4zm10.8 2.7c-1 .7-2 1-2.7 1.4l-1.4.9c-.4.2-1 .2-1.4.5-.7.5-2 2-2 2s1.3 1.1 2 1c2.4-.5 3.1-1.4 4.3-2.3 1-.8 1-2.5 1.2-3.5z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M340.7 204.8l-.2.4c1.3-.2 3.5-1.5 5-2.2 1.8-1 3-1.7 3.7-3a8.9 8.9 0 0 1-3.9 3c-1.5.7-3.7 2-4.6 1.8zm9.4-9.5c-.8.9-1.7 1.3-2.4 1.8l-1.3 1.1-1.2.8c-.6.6-1.5 2.2-1.5 2.2s.7.7 1.4.4c2.4-.3 3.1-1.4 4-3.5.5-1 1-1.8 1-2.8z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M341.5 199.4a.6.4 62 1 0 .8-.3.6.4 62 0 0-.8.3z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M342.5 201.6l-.2.3c2.9-1.3 6.6-3.9 7.8-6.5a17.2 17.2 0 0 1-7.6 6.2zm8.3-10.7c-.7 1-1.6 1.4-2.2 2l-1 1.1-1.2.9c-.5.6-1.2 2.2-1.2 2.2s.8.9 1.5.5a12 12 0 0 0 2.1-1.6c.5-.4.6-1.4 1.2-2.2.7-1 .8-1.9.8-2.9z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M348.7 193.8c-1.4 1.6-3 3.1-4.6 3.8l-.2.4c2.6-1.5 3.7-2.8 4.9-4.1zm1-5.6c-.4 1-1 1.5-1.6 2l-.8 1.2-1 .9-.7 2.1s.6.6 1.2.2a12 12 0 0 0 1.8-1.6c.4-.5.6-1.4 1-2.2a4 4 0 0 0 .2-2.6zm-4.3-1.1l-.5 1.6v-.4c0-.4.2-.9.4-1.3l.1.1z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M348.4 191a13 13 0 0 1-3.8 4v.3c2.2-1.6 3-3 3.8-4.2zm-5.6 10c-.2-.6-.3-1-.6-1.4.2.5.4 1 .4 1.6l.1-.3z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M341.9 181.3a.4.3 39.5 0 1-.5.5.4.3 39.5 0 1 .5-.5z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M343.1 182.5l-1.2-.8 1.3 1v-.2zm5.6.4c-1.2 2.4-3.9 4-2.8 7.5 2.8 2.6 3-4.5 2.8-7.5z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M346.1 177.7c-.5 2.4-2.6 4.4-1.2 7.6 4 1 2-4.3 1.2-7.6z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M343.7 174c2 3.7 2.5 5.9.2 8.3 0 0-1.3-1.1-1.6-3.3-.2-1.8 1.2-4 1.4-5z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M340.4 171.8c.5 2.4-1.5 3.5 1.4 6.5 2.1-2.4 1.1-3-1.4-6.5z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M339.6 176c-3.3.3-2-2.6-3-5.3 2 1.5 4.7 2.1 3 5.3zm2.2 4.4c-1-4.4-4-2.6-5.6-4.6.9 2.9 2.1 4.8 5.6 4.6zm1.4 4.1c-2.6-.1-4.8-1.4-6.2-4.4 2.7 1.2 5.7 1.4 6.2 4.4z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M343.6 188.3c-1-1.2-1-2-1.5-2.7a9 9 0 0 0-3-3.7c0 3 .4 6.5 4.5 6.4z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M344.2 191.6a20 20 0 0 0-5.6-5.7c1 2.2.6 6.3 5.6 5.7z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M343.7 196c-5-.1-4.5-4.8-4.5-7 .9 1.4 2 2.5 2.8 3.5.9 1 1.8 2.2 1.7 3.5z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M343.1 198.8c-.4-1 0-1.4-1-2.3-1-1-2.8-2.7-3.7-4.6-.1 1.7-.2 4.4 1.2 5.3 1 .7 2 .9 3.5 1.6zm-4.3 7.3c-3.9-3-1.6-5.6-1.2-7.9 1 2.6 3.7 4.8 1.2 7.9zm1.6-29.2c-1.3-2.3-2-3.6-3.7-6 2 2.7 2.8 4.5 3.9 6.4"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M338.9 206.8c.1-3-.7-5.7-1.3-8.5.5 3 1.3 6 1 8.8l.3-.3zm4.6-7.4c-.4-1.8-4.1-3-5-7.5.7 4.4 4.5 5.5 4.8 8l.2-.5zm.8-2.5l-.1.5c-.6-3-4-4.4-5-8.4 1.5 4.3 4.3 4.9 5.1 7.9zm.7-4.4c-1.7-2.6-4.1-3.6-6.4-6.7 2.1 3 4.8 4.4 6.4 7v-.3zm0-3.5c-2-.8-3.9-3-6-7.1 1.4 3 3 5.8 6 7.6v-.5zm-1-4c-2.1-1.7-5-2.8-7-4.9 1.7 2 5 3.3 7.1 5.2v-.3zm-1.6-4.3c-2.2-1.5-4.4-2-6.2-4.8 1.5 2.8 3.8 3.5 6.3 5l-.1-.2zm6.3 2.2c-.8 3.1-1.5 6.3-3.6 8.4v-.4c1-.5 2.5-3.7 3.6-8zm-2.6-5.1c-.1 3.2 0 6.5-1.7 8.3l-.1-.3c1.6-1.4 1.5-5 1.8-8zm-2.2-3.6c.5 2.8.6 5.3-.2 9.5l-.1-.3c.4-2.4 1-5 .3-9.2zm-3.4-2.3c1.1 2.4 2 4.8 1.2 7.4l-.2-.3c.9-2.4-.1-4.7-1-7zm-4.4 31.2c1.4 3.2-.4 5.6-2.5 7-1.6-4.7 1.8-4.2 2.5-7z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M336.2 203.1c.2 2-2 4.2-2.6 7.6l-.3.2c1-4 3-5.6 2.9-7.8z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M343.7 181.2a.3.4 1.9 1 1-.6-.1.3.4 1.9 0 1 .6.1z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M343.5 183v-1.6h-.2v1.7l.2-.1z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M342.8 180.9a.3.4 2 0 1-.5.2.3.4 2 0 1 .5-.2z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M343.2 182.3l-.5-1.1.4 1.4v-.2z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M344.7 186.9a.4.3 80.5 1 1-.7 0 .4.3 80.5 0 1 .7 0z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M344.9 188.6a9.3 9.3 0 0 0-.4-1.4h-.1l.4 1.6v-.2z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M343.6 187.2a.4.3 57 1 1-.5.5.4.3 57 0 1 .5-.5z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M344.8 188.6a8.8 8.8 0 0 0-1.2-1v.1l1.3 1.1-.1-.2z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M343.4 199.1a.3.4 12.7 1 1-.7-.2.3.4 12.7 0 1 .7.2z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M342.8 200.8c.2-.5.2-1 .2-1.5a9 9 0 0 1-.4 1.7l.2-.2z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M344 199.9a.3.4 50.5 1 0 .5.4.3.4 50.5 1 0-.5-.4z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M342.7 201l1.3-.8v.1a8.7 8.7 0 0 0-1.3 1v-.2z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M340.7 205a.3.4 40.4 1 1-.4-.6.3.4 40.4 0 1 .4.5z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M339.5 206.2l.9-1.3h-.1l-1 1.3h.2z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M338.8 204.5a.5.6 10 0 0 1 .1.5.6 10 1 0-1 0z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M339.4 205c-.3.7 0 1 0 1.2l-.1.3c-.2-.4-.3-.8-.1-1.5h.2zm-12.1 9.5c-.7 0-1-.4-1.3-.8h-.3c.4.5.8 1 1.5 1v-.3z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M327.3 215.2a.6.4 9.5 0 1 .2-.9.6.4 9.5 1 1-.2.8z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M332.7 206a5.5 5.5 0 0 1-4 6.4c-.9-4 2.8-4 4-6.3z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M332.7 206.1a21 21 0 0 1-4.8 7.2h-.5c2.7-2.1 4.2-4.9 5.3-7.2z"
    />
    <path
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M327.8 213.3a.5.4 9.8 1 1-.4-.7.5.4 9.8 0 1 .4.7z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M326 213.8a8 8 0 0 0 1.4-.7h-.1l-1.7.6h.3zm2.5-5c0 1.2-1 2.4-2 3.2-.9.9-1 1.2-2.2 1.6-1.2-2.8 2.8-3.3 4.2-4.8z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M328.5 208.8c-1.3 2.5-3.5 3.8-4.7 5.4h-.1c1.6-2.2 3-2.7 4.8-5.4z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M300.4 175.5c-1.7 2.9-4.4 8-5.1 12a22.5 22.5 0 0 0 7 20.8c5.2 4.7 13.3 6 16.6 6.8 3.4.7 5.8 1.8 6.4 2.5 0-.5 0-1-.5-1.6-1.6-.7-4.2-1-7.8-1.8-7.2-1.5-14.9-4.2-19-12.2-5.4-10.3-2.2-18.4 2.5-26.4z"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M314.1 213.6c-.2.4-4 3.7-7.5 3.5-2.5-.2-2.9-.8-2.9-.8s-.2-.7 2-1.1c2.3-.5 6.2-2 8.4-1.6z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M303.8 216.3c2.7.3 5.5-.8 7.7-1.6"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M311.2 208.7a11 11 0 0 1 4.6 3.7c.9 1.5.7 1.9.7 1.9s-.2.3-1.3-1c-1-1.2-3.4-3.3-4-4.6z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M316.5 214.2c-.9-1.7-2.5-3-3.7-4.2"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M300.3 175.8c-.1-.3.3-3.4 2-4.4 1.3-.7 1.8-.5 1.8-.5s.3.3-.5 1.3c-1 1-2.1 3.2-3.3 3.7z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M304 171c-1.4.7-2.3 2.2-3 3.4"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M299.4 177.4c-.2-.2-1-3-.2-4.7.5-1.3.9-1.4.9-1.4s.3 0 .1 1.3c-.2 1.3-.2 3.8-.8 4.8z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M300 171.4c-.6 1.3-.6 3-.6 4.4"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M299.4 177.5c.2 0 2.7-.8 3.9-2.1.8-1 .8-1.3.8-1.3s-.2-.2-1.1.5c-1 .8-3 2-3.6 2.9z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M304 174.1c-.9 1.1-2.2 2-3.3 2.6"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M298.2 179.6a10 10 0 0 1-.9-5.2c.3-1.6.6-1.7.6-1.7s.4 0 .4 1.4c0 1.5.3 4.2-.1 5.5z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M298 172.7c-.5 1.7-.2 3.6 0 5"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M297.3 181.6c-.3-.2-2.3-3-2-5.2 0-1.7.5-2 .5-2s.3-.1.6 1.4c.3 1.6 1.2 4.3.9 5.8z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M295.7 174.5c-.2 1.8.5 3.7 1 5.2"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M296.2 184.1a9.9 9.9 0 0 1-2.4-4.7c-.2-1.5 0-1.8 0-1.8s.4-.1.8 1.3c.4 1.4 1.6 3.9 1.6 5.2z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M293.9 177.7c.1 1.7 1 3.4 1.5 4.8"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M298.2 179.6c.3 0 3.2-.2 4.6-1.7 1-1 1-1.5 1-1.5s-.2-.3-1.4.4c-1.1.8-3.4 1.8-4.2 2.8z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M303.7 176.5c-1 1.2-2.7 1.9-4 2.5"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M297.3 181.6c.2 0 3.2 0 4.6-1.4 1.1-1 1-1.4 1-1.4s0-.3-1.2.3c-1.2.7-3.6 1.5-4.4 2.5z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M303 178.9c-1.2 1-2.8 1.7-4.1 2.2"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M296.4 184.2c.2 0 3.4-.2 4.9-1.7 1-1.1 1-1.5 1-1.5s-.1-.4-1.4.3c-1.2.8-3.7 1.8-4.5 2.9z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M302.3 181c-1.2 1.3-2.9 2-4.3 2.5"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M296.8 183s-.3-.5-.3-1c0-.6.2-.8.2-.8l-.2-.2-.1.9v.3l-.5-.5a10.8 10.8 0 0 1-.1-.4h-.2l.3.7c.5.4.8 1.1.8 1.1"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M295.6 180.3a.5.4 83.5 1 1 .1 1 .5.4 83.5 1 1-.1-1z"
      overflow="visible"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M296.8 180.3a.4.5 19.3 1 1-.3 1 .4.5 19.3 1 1 .3-1z"
      overflow="visible"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M296.7 183l1-.7c.3-.4.3-.7.3-.7h.2l-.4.8-.2.2.6-.1.4-.2.1.1-.6.4c-.6 0-1.3.3-1.3.3"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M299.4 181.6a.4.5 45.6 1 0-.8.8.4.5 45.6 1 0 .8-.8z"
      overflow="visible"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M298.4 180.8a.4.5 19.8 1 0-.3 1 .4.5 19.8 1 0 .3-1z"
      overflow="visible"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M295.4 186.9c-.2-.2-2.4-2.6-2.8-4.8-.3-1.6 0-1.9 0-1.9s.3-.1.8 1.3c.6 1.5 2 4 2 5.4z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M292.6 180.3c.2 1.8 1.2 3.5 2 4.9"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M295.6 186.9c.3 0 3.5-.4 5-2 1-1.3 1-1.7 1-1.7s-.2-.4-1.4.5-3.8 2-4.6 3.2z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M301.5 183.2c-1 1.4-2.8 2.2-4.2 3"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M295.2 189.6c.3 0 3.5-.9 5-2.6 1.1-1.3 1-1.7 1-1.7s-.1-.2-1.4.7c-1.2 1-3.8 2.5-4.6 3.6z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M301.2 185.4c-1.1 1.4-3 2.4-4.3 3.2"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M295 189.6c-.3 0-3.3-2.2-3.8-4.5-.3-1.7 0-2 0-2s.5-.3 1.2 1.2c.7 1.4 2.5 3.8 2.7 5.3z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M291.3 183.2c.3 1.8 1.5 3.5 2.5 4.8"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M295.2 193a11 11 0 0 0 4.6-3.6c.9-1.5.7-1.8.7-1.8s-.2-.3-1.3 1c-1 1.2-3.4 3.1-4 4.5z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M300.5 187.7c-1 1.6-2.5 3-3.8 4"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M295 193.2c-.3 0-3.6-1.7-4.4-4-.7-1.6-.4-2-.4-2s.4-.4 1.3 1c1 1.3 3.1 3.5 3.5 5z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M290.3 187.2c.5 1.8 2 3.4 3.2 4.6"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M295 191.6s-.4-.5-.5-1c-.2-.6 0-.9 0-.9h-.3v.8l.2.4-.6-.4-.3-.5-.2.2.5.6c.6.2 1.1 1 1.1 1"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M293 189a.6.4 69.4 1 1 .4 1.2.6.4 69.4 1 1-.4-1.1z"
      overflow="visible"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M294.3 188.7a.4.6 5.2 1 1 0 1.2.4.6 5.2 1 1 0-1.2z"
      overflow="visible"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M295 191.6s.6-.5.8-1c.3-.5.2-.8.2-.8h.3l-.3.8-.1.4.6-.3.4-.4.1.2-.6.5c-.6.1-1.2.7-1.2.7"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M297.5 189.4a.4.6 31.5 1 0-.6 1 .4.6 31.5 1 0 .6-1z"
      overflow="visible"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M296.3 188.9a.4.6 5.7 1 0-.1 1.1.4.6 5.7 1 0 0-1.1z"
      overflow="visible"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M295.4 196.2a12 12 0 0 1-5.1-4c-1-1.7-.8-2.1-.8-2.1s.2-.3 1.4 1c1.3 1.4 3.8 3.6 4.5 5.1z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M289.5 190.2c1 1.8 2.8 3.3 4.2 4.6"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M295.6 196.2c.4 0 4-1.9 5-4.4.6-1.8.3-2.3.3-2.3s-.4-.3-1.4 1.2c-1 1.4-3.4 3.8-3.9 5.5z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M300.9 189.6c-.7 2-2.3 3.7-3.6 5"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M296.6 199.3c.3-.1 3.7-2.3 4.5-4.8.7-1.9.4-2.3.4-2.3s-.4-.3-1.3 1.3c-1 1.5-3.2 4-3.6 5.7z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M301.5 192.3c-.7 2-2.2 3.8-3.4 5.2"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M296.3 199.3c-.4 0-4.7-1.3-6.2-3.8-1-2-.9-2.5-.9-2.5s.4-.4 1.8 1c1.5 1.4 4.5 3.5 5.3 5.2z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M289.3 193.1c1.1 2 3.3 3.6 5 4.8"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M300.1 205.7c.3-.2 2.6-3 2.8-5.6.2-1.8-.2-2-.2-2s-.3-.2-.8 1.4c-.5 1.7-1.8 4.6-1.8 6.2z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M302.8 198.1c-.1 2-1 4-1.8 5.6"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M300 205.6c-.5.2-5.4 0-7.7-2.1-1.6-1.6-1.5-2.2-1.5-2.2s.2-.5 2.1.5c2 1 5.7 2.3 7 3.8z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M290.9 201.4c1.7 1.7 4.4 2.6 6.5 3.4"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M298.2 203c-.4.1-4.8-1-6.8-3.1-1.6-1.6-1.5-2.1-1.5-2.1s.2-.4 2 .8c1.6 1.2 5 3 6.3 4.5z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M290 197.9c1.6 1.7 4 3 5.8 4"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M298.4 203c.4-.2 3.6-2.9 4-5.6.2-2-.2-2.5-.2-2.5s-.5-.2-1.2 1.5c-.7 1.8-2.6 4.7-2.6 6.5z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M302.2 195c-.2 2.2-1.5 4.3-2.5 6"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M297.4 201.5l-1-.8c-.4-.5-.5-.9-.5-.9h-.3a8 8 0 0 0 .8 1.2l-.8-.1-.5-.3v.2l.7.4c.7 0 1.6.5 1.6.5"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M294.2 199.8a.7.5 45.9 1 1 1 1 .7.5 45.9 1 1-1-1z"
      overflow="visible"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M295.4 198.8a.7.5 71.6 1 1 .4 1.3.7.5 71.6 1 1-.4-1.3z"
      overflow="visible"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M297.5 201.4s.4-.6.4-1.3l-.1-1h.2a7.8 7.8 0 0 0 .1 1.3l.6-.5.2-.6.2.1-.4.8c-.6.5-1 1.4-1 1.4"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M299.1 198.2a.5.7 8 1 0-.2 1.3.5.7 8 1 0 .2-1.3z"
      overflow="visible"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M297.6 198.1a.7.5 72.2 1 0 .4 1.3.7.5 72.2 1 0-.4-1.3z"
      overflow="visible"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M301.8 207.6c-.3.2-4.3 1-6.8-.3-1.8-.9-2-1.4-2-1.4s0-.5 2 0c1.8.4 5.2.7 6.8 1.7z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M293.1 206c2 1 4.4 1.2 6.3 1.4"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M302 207.5c.2-.1 2-2.5 1.9-4.8 0-1.7-.4-2-.4-2s-.3-.2-.6 1.3c-.2 1.5-1 4-.9 5.5z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M303.5 200.8c.2 1.8-.4 3.6-.9 5"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M305.5 210.3c-.3.3-5 1.5-8 .3-2-1-2.1-1.5-2.1-1.5s0-.5 2.2-.1c2.1.3 6.2.4 8 1.3z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M295.5 209.2c2.2 1 5 1 7.3 1.1"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M305.8 210.3c.2-.3 1.2-3.8 0-5.6-1-1.4-1.5-1.3-1.5-1.3s-.4 0 0 1.5c.3 1.5.5 4.3 1.5 5.4z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M304.4 203.4c1 1.4 1.1 3.4 1.3 5"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M303.3 208.7s-.5.4-1.2 0c-.6-.3-.8-.7-.8-.7l-.3.2 1 .7.3.2-.9.2-.6-.1v.3h1a13.6 13.6 0 0 0 1.5-.5"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M299.5 208.7a.8.5 24.1 1 1 1.4.7.8.5 24.1 1 1-1.4-.7z"
      overflow="visible"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M300.3 207.2a.8.5 49.9 1 1 1 1.2.8.5 49.9 1 1-1-1.2z"
      overflow="visible"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M303.4 209s.6-.5.2-1.2l-.6-.9.1-.2.7 1 .2.3.2-.9v-.6h.2v1l-.5 1.5"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M303.7 205.1a.8.5 69.5 1 0 .6 1.5.8.5 69.5 1 0-.6-1.5zm-1.5.8a.8.5 43.7 1 0 1 1 .8.5 43.7 1 0-1-1z"
      overflow="visible"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M308.3 211.8c-.3.4-4.2 3-7.4 2.3-2.3-.4-2.6-1-2.6-1s-.1-.6 2-.8c2.2-.1 6-1 8-.5z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M298.4 213.1c2.5.6 5.2 0 7.3-.5"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M310.8 212.6s-.5.7-1.3.5a3 3 0 0 1-1.2-.5l-.3.3 1.3.4.5.1-.9.6-.7.1v.3l1.2-.3c.2 0 1.4-1 1.4-1"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M306.6 214a.9.6 5.4 1 1 1.7.2.9.6 5.4 1 1-1.7-.1zm.4-2a.9.6 31.2 1 1 1.5 1 .9.6 31.2 1 1-1.5-1z"
      overflow="visible"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M309.5 212.2c.2-.3.7-4-1-5.6-1.1-1.2-1.7-1-1.7-1s-.5.1.1 1.5c.7 1.4 1.4 4.2 2.6 5.1z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M306.8 205.6c1.4 1.2 1.9 3.2 2.3 4.7"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M311.4 213s.2-.7-.5-1.2c-.6-.5-1.1-.6-1.1-.6v-.4l1.2.7.4.3c.4.3 0-.8-.2-1l-.4-.7.3-.2.5 1 .2 2"
    />
    <path
      style={{
        marker: "none"
      }}
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M309.7 209a.9.6 42.7 1 0 1.3 1.1.9.6 42.7 1 0-1.3-1.2zm-1.2 1.5a.9.6 17 1 0 1.7.6.9.6 17 1 0-1.7-.6z"
      overflow="visible"
    />
    <path
      fill="#452c25"
      d="M319.1 209s-2.3 5.4-1.5 6c0 0 2.4-4.3 4.4-5.8 1.1-1 1.8 0 2-1 0-.8-3-2.1-3-2.1l-1.8 2.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.2}
      d="M319.1 209s-2.3 5.4-1.5 6c0 0 2.4-4.3 4.4-5.8 1.1-1 1.8 0 2-1 0-.8-3-2.1-3-2.1l-1.8 2.7"
    />
    <path
      fill="#452c25"
      d="M310.6 213.1s-3.4 6-2.5 6c.8 0 4.5-7.5 4.5-7.5l-1.3.2-.7 1.3z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M310.6 213.1s-3.4 6-2.5 6c.8 0 4.5-7.5 4.5-7.5l-1.3.2-.7 1.3z"
    />
    <path
      fill="#452c25"
      d="M311.6 211.5s-3.6 5.8-2.7 5.9c1 .1 4.8-7.4 4.8-7.4l-1.3.1-.8 1.4z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M311.6 211.5s-3.6 5.8-2.7 5.9c1 .1 4.8-7.4 4.8-7.4l-1.3.1-.8 1.4z"
    />
    <path
      fill="#452c25"
      d="M312.3 210.5s-4 5.4-3.2 5.6c1 .2 5.4-7 5.4-7l-1.3.1-.9 1.3z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M312.3 210.5s-4 5.4-3.2 5.6c1 .2 5.4-7 5.4-7l-1.3.1-.9 1.3z"
    />
    <path
      fill="#452c25"
      d="M313.4 209.5s-4.8 4.9-3.9 5.2c.8.3 6.2-6.2 6.2-6.2l-1.2-.1-1.1 1.1z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M313.4 209.5s-4.8 4.9-3.9 5.2c.8.3 6.2-6.2 6.2-6.2l-1.2-.1-1.1 1.1z"
    />
    <path
      fill="#452c25"
      d="M313.6 207.7s-4.2 5.4-3.3 5.6c.9.2 5.5-6.9 5.5-6.9l-1.3.1-1 1.2z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M313.6 207.7s-4.2 5.4-3.3 5.6c.9.2 5.5-6.9 5.5-6.9l-1.3.1-1 1.2z"
    />
    <path
      fill="#452c25"
      d="M312.5 212.4s-4 5.5-3.2 5.6c1 .2 5.4-7 5.4-7l-1.3.1-.9 1.3z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M312.5 212.4s-4 5.5-3.2 5.6c1 .2 5.4-7 5.4-7l-1.3.1-.9 1.3z"
    />
    <path
      fill="#452c25"
      d="M314.8 211.3s-2.4 4.5-2.1 4.6c.3.2 3.1-2.5 4.6-5.2 1.4-2.6-2.6.5-2.6.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M314.8 211.3s-2.4 4.5-2.1 4.6c.3.2 3.1-2.5 4.6-5.2 1.4-2.6-2.6.5-2.6.5"
    />
    <path
      fill="#452c25"
      d="M315 210.8s-2.3 5.5-1.5 6c0 0 3-3.3 3.7-5.9.8-2.6 0-.1 0-.1l-.2-2.9-2 2.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.2}
      d="M315 210.8s-2.3 5.5-1.5 6c0 0 3-3.3 3.7-5.9.8-2.6 0-.1 0-.1l-.2-2.9-2 2.7"
    />
    <path
      fill="#452c25"
      d="M313.8 210.4s-4.7 4.8-3.9 5.1c.9.3 6.3-6.1 6.3-6.1l-1.3-.1-1 1z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M313.8 210.4s-4.7 4.8-3.9 5.1c.9.3 6.3-6.1 6.3-6.1l-1.3-.1-1 1z"
    />
    <path
      fill="#452c25"
      d="M314.2 211s-4.7 5-3.9 5.2c.8.3 6.2-6.2 6.2-6.2h-1.2l-1.1 1z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M314.2 211s-4.7 5-3.9 5.2c.8.3 6.2-6.2 6.2-6.2h-1.2l-1.1 1z"
    />
    <path
      fill="#452c25"
      d="M314.6 211.8s-4.8 4.9-4 5.2c1 .3 6.3-6.2 6.3-6.2h-1.2l-1.1 1z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M314.6 211.8s-4.8 4.9-4 5.2c1 .3 6.3-6.2 6.3-6.2h-1.2l-1.1 1z"
    />
    <path
      fill="#452c25"
      d="M315 205.1s-3.6 4.5-3 5.3c.4.8 3.6-2 4.7-4 1-2-1.7-1.4-1.7-1.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M315 205.1s-3.6 4.5-3 5.3c.4.8 3.6-2 4.7-4 1-2-1.7-1.4-1.7-1.4"
    />
    <path
      fill="#452c25"
      d="M314.8 209.9s-3 5.8-2.2 5.5c.8-.4 3.8-4.7 4.2-5.7.3-1 .2-2 .2-2l-2.3 1.5.2 1.1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M314.8 209.9s-3 5.8-2.2 5.5c.8-.4 3.8-4.7 4.2-5.7.3-1 .2-2 .2-2l-2.3 1.5.2 1.1"
    />
    <path
      fill="#452c25"
      d="M314.8 208s2.5-4.6 0 .9-3.4 4.5-3.4 4.5c-.2-.3 2.2-4 2.2-4s1.7-2.8 2.1-3.1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M314.8 208s2.5-4.6 0 .9-3.4 4.5-3.4 4.5c-.2-.3 2.2-4 2.2-4s1.7-2.8 2.1-3.1"
    />
    <path
      fill="#452c25"
      d="M317.5 207.4s2.8-4.6 0 .9c-2.8 5.4-3.9 4.5-3.9 4.5-.2-.3 2.5-4 2.5-4s2-2.8 2.4-3.1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M317.5 207.4s2.8-4.6 0 .9c-2.8 5.4-3.9 4.5-3.9 4.5-.2-.3 2.5-4 2.5-4s2-2.8 2.4-3.1"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M316.5 205.5s-3.5 4.5-3 5.2c.5.8 3.7-2 4.7-4s-1.7-1.4-1.7-1.4"
    />
    <path
      fill="#e8a30e"
      d="M352.8 251a32.8 37 0 1 1-65.6 0 32.8 37 0 1 1 65.6 0z"
    />
    <path
      style={{
        lineHeight: "normal",
        InkscapeFontSpecification: "Sans",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        blockProgression: "tb",
        marker: "none"
      }}
      fill="none"
      stroke="#390"
      strokeWidth={0.8}
      d="M293.7 251c0-17 12-30.2 26.3-30.2s26.3 13.1 26.3 30.3"
      color="#000"
      fontFamily="Sans"
      fontWeight={400}
      overflow="visible"
    />
    <path
      fill="#007934"
      stroke="#eee"
      strokeWidth={0.1}
      d="M287.2 253c1 19.5 15.3 35 32.8 35s31.9-15.5 32.8-35h-65.6z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M352.8 251a32.8 37 0 1 1-65.6 0 32.8 37 0 1 1 65.6 0z"
    />
    <path
      style={{
        marker: "none"
      }}
      fill="#d52b1e"
      stroke="#000"
      strokeWidth={0.1}
      d="M314.5 225.4c-.3 1.4 0 2.5.7 3.6.6.9 1 1.8.9 2.7a7.9 7.9 0 0 0-.7.5l-5.5-3.7 3.7 5.5a8 8 0 0 0-.2.2 4.9 4.9 0 0 0-3-.3 5 5 0 0 1-3.7-.8 4.5 4.5 0 0 0 3.1 2.1 5 5 0 0 1 2.6 1.3 8 8 0 0 0-.2.8l-6.6 1.3 6.6 1.3v.3a4.9 4.9 0 0 0-2.4 1.9 5 5 0 0 1-3 2c1.3.4 2.5 0 3.6-.7a5 5 0 0 1 2.7-.9l.4.7-3.6 5.6 5.4-3.7.3.2a4.9 4.9 0 0 0-.4 3 5 5 0 0 1-.7 3.6 4.5 4.5 0 0 0 2-3.1 4.9 4.9 0 0 1 1.4-2.5l.8.2 1.3 6.5 1.3-6.5h.3a4.9 4.9 0 0 0 1.8 2.3 5 5 0 0 1 2.1 3.1 4.4 4.4 0 0 0-.7-3.6 4.9 4.9 0 0 1-.9-2.8l.7-.4 5.5 3.7-3.7-5.5.2-.3c1 .5 2 .6 3 .4a5 5 0 0 1 3.7.7 4.5 4.5 0 0 0-3.1-2 4.9 4.9 0 0 1-2.6-1.4l.2-.8 6.6-1.3-6.6-1.2a7.9 7.9 0 0 0 0-.4 4.9 4.9 0 0 0 2.4-1.8 5 5 0 0 1 3-2 4.5 4.5 0 0 0-3.6.7 4.9 4.9 0 0 1-2.7.8 7.9 7.9 0 0 0-.4-.7l3.7-5.5-5.5 3.7a8 8 0 0 0-.3-.2c.5-1 .6-2 .4-3a5 5 0 0 1 .7-3.6 4.5 4.5 0 0 0-2 3 5 5 0 0 1-1.4 2.6 8 8 0 0 0-.8-.2l-1.3-6.5-1.2 6.5h-.4a4.9 4.9 0 0 0-1.8-2.3 5 5 0 0 1-2-3.1z"
      overflow="visible"
    />
    <use
      width={330}
      height={330}
      fill="#fcbf49"
      strokeWidth={1.1}
      transform="rotate(22.5 -417.9 955.8) scale(.14262)"
    />
    <use
      width={330}
      height={330}
      fill="#fcbf49"
      strokeWidth={1.1}
      transform="matrix(-.14262 0 0 .14262 334 232.7)"
    />
    <path d="M325.9 236.7c-1.7-1.4-3.8-1.6-4.9-.6-.8 1.1-.8 2.4.2 3.8a.5.5 0 0 0-.3.2 4.9 4.9 0 0 1-.3-4.1c1.5-1.3 3.7-1.4 5.2.7" />
    <path d="M323.3 236.3c-1 0-1.2.2-1.6.5-.4.4-.6.3-.7.4 0 0 0 .3.1.2.2 0 .5-.2.9-.6.4-.3.8-.3 1.3-.3 1.3 0 2 1 2.1 1 .2 0-.7-1.2-2.1-1.2" />
    <path d="M325 237.5c-1-1-2.7-1-3.4 0h.2c.8-1 2.5-.6 2.6 0" />
    <circle cx={323.1} cy={237.4} r={0.6} />
    <path d="M321.6 237.6c.7.6 2.2.7 3.3-.1h-.5c-.7.7-1.8.6-2.5 0" />
    <path d="M325 237.8c-1.2 1-2.4.9-3.1.5-.7-.5-.7-.6-.6-.6l.8.4c.6.3 1.5.3 2.9-.2m-3.5 2a.4.4 0 1 1-.6.5c0 .1-.3.6-.9.6h-.1l.1.2c.1 0 .6 0 .9-.2a.6.6 0 1 0 .6-1m.9 3c-.7-.5-1-1-1.7-1a2 2 0 0 0-.7.1h-.1l.1.2c.3 0 .7-.3 1.2 0l1.2.7m-.3 0c-1.4-.5-1.7-.2-2.1-.2h-.1l.1.3c.6 0 .9-.4 2.1-.1" />
    <path d="M322.4 243c-1.6-.2-1.1.8-2.4.8h-.1l.1.2c1.6 0 .9-.9 2.4-1m-8.2-6.3c1.6-1.4 3.7-1.6 4.8-.6.8 1.1.8 2.4-.2 3.8a.5.5 0 0 1 .3.2 5 5 0 0 0 .3-4.1c-1.5-1.3-3.7-1.4-5.2.7" />
    <path d="M316.7 236.3c1 0 1.2.2 1.6.5.4.4.6.3.7.4 0 0 0 .3-.1.2a4.1 4.1 0 0 1-.9-.6c-.4-.3-.8-.3-1.3-.3-1.3 0-2 1-2.1 1-.2 0 .7-1.2 2.1-1.2" />
    <path d="M315 237.5c1-1 2.7-1 3.4 0h-.2c-.8-1-2.5-.6-2.6 0" />
    <circle cx={-316.9} cy={237.4} r={0.6} transform="scale(-1 1)" />
    <path d="M318.4 237.6c-.7.6-2.2.7-3.3-.1h.5c.7.7 1.8.6 2.5 0" />
    <path d="M315 237.8c1.2 1 2.4.9 3.1.5.8-.5.8-.6.6-.6l-.8.4c-.5.2-1.5.3-2.9-.2m3.5 2a.4.4 0 1 0 .6.5c0 .1.3.6.9.6h.1l-.1.2c-.1 0-.6 0-.9-.2a.6.6 0 1 1-.6-1m-.9 3c.7-.5 1-1 1.7-1l.7.1h.1l-.1.2c-.3 0-.7-.3-1.2 0l-1.2.7m.3 0c1.4-.5 1.7-.2 2.1-.2h.1l-.1.3c-.6 0-.9-.4-2.1-.1" />
    <path d="M317.6 243c1.6-.2 1.1.8 2.4.8h.1l-.1.2c-1.6 0-.9-.9-2.4-1" />
    <path
      fill="#007934"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.1}
      d="M323.2 258.4c1.6.2 3.3.2 4.7-.3a9.9 9.9 0 0 1 4.2-.6c0-.2.5-.3.2-.5-.5-.3-1.2-.3-1.8-.6-1-.5-1.7-1.3-2.7-2-.1 0-.6-.3-.6-.5 2.2 3.2 7.5 1.5 12 1.2.4.1 1.5-.2 2.4-.5 1-.4 3.6 0 4.3-.5l-1.3-1c-.6-.8-2.3-.7-3-1.5-1.3-1.5-3.3-1.9-4.9-3-.3-.3-1-.2-1.6-.3-.6-.6 0-.5-5-4.7-4.5-1.8-4.2-3.2-7-4.3-1-.5-1.9-1.4-2.7-1.1a30 30 0 0 0-6.3 3c-1.2.6-2.7 2-3.8 2.8-.2.2-3.4 2.9-7 4.8a115 115 0 0 1-9.2 4.8c8-.4-7.3 2.3 29.1 4.8z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M303.3 249c2-1 10-5.3 12.4-8.4-.4 0 .6 1 .5 1.4.8 0 .4-1 1-1 .5 0 .9-.1 1.3-.3.5 0 .2.2.2.4-.7 1.2-2 2-3.2 2.9l.2.4c.4 0 .9 0 1.1-.2l.1-.3c.4.1.3.5.1.7-.3.6-1.4.5-1.8 1a6.2 6.2 0 0 1-1.5 1.7c.5-.4 1-1 1.7-1 1 0 1.3-.7 2.2-.9.9-.1 1.5-.9 2.2-1.4-.3.4-.9.7-.7 1.2a.6.6 0 0 0 .6.2c-.7.8-2 1.4-2.4 2.4-.4-.2-.7.2-1 .2-.4.1-.3.8-.6 1-1.2.7-1.8 1.8-2.3 2.7l-1.3.7c-.7.3-4.6 3.4-4.7 3-.3-2.1-4.3 1.6-13.3-1.6m30.6-.1l-.2-.2c.1-.3-.5-.4-.5-.7 1 0 1.8 1.2 2.5.5.1-.1-.3-.4.4-.6 0 0-.2-.1-.1-.2h-.8l-.8-.3c-.3-.1-.5-.5 0-.6 1-.1 1.9.5 2.6.2.6-.3 1.1-.3 1.7-.5.3-.1 1.2 0 .9.2-.2.2-.7.1-1 .2-.5.1-1 .4-1.4.6.3 0 .2.3.7.2a6 6 0 0 1 2-.4v-.5h.3c-.3-.5.6-.2 1-.6l.1.1c-.5.2-.3.5-.4.8 0 0-.3 0-.2.2.2.2.2-.2.5 0h.6c.3 0 .7-.1.5-.4-.3-.2-.6-.5-.6-.8l-.1-.1c.5 0 1 .2 1.1.4.3.3.3.6.8.7.8.2.7-.2.7-.6.7 0 1.6.3 1.4.6 0 .3-.6.5-1 .5s-.2.3-.4.3c-.4 0-.9 0-1 .2-.2.2 0 .7.3.9.4.2 1.2 0 1.8 0 .1-.3.5-.4.9-.6.4-.3-.2-.5-.5-.7-.3 0 0-.1 0-.3.3-.3.9 0 1-.2.1-.3-.1-.6.1-.8.2-.1.5.1.4.3l.7-.2c.3 0 .5.3.4.4-.5.2-.8.4-.7.8 0 .2-.5.3-.3.5.4.3.4.5.5.9.2.3 1 .4 1.6.3-.2-.7 1.4-.4 2-.5.1 0 .1-.1 0-.2-.3-.2-.3-.3-.3-.6l-.1-.1c1 .3 2.8.8 3.6 1.4-1 .2-2.8-.2-3.8 0a15 15 0 0 1-3.7.6c-.5 0-1-.3-1.6-.3m-11.3-.7l-.4-.1"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M321.2 259.1c2 0 2.2 1.4 3.5.1 1.1.2 2.2-.2 2.2-.3 2.7.6 11.1-.2 10.6-.8-.9-1-2.3-1.4-3.4-2.2l-1.1-.4c-.7-.2-1.5 0-2-.3l-2.6-1.5c-.5-.4-.7-1-1.2-1.4-.6-.4-1.4-.5-2-.7-.9-.4-1.4-1.2-2.2-1.9l-1.1-.4c-.7-.3-1.2-1.1-1.9-1-1 .2-1.7 1-2.8 1.6-1 .4-1.4 1.1-2.2 1.6-.2.2-2.6 1.8-5.3 2.9a72.6 72.6 0 0 1-6.6 2.5s2.4 1.7 8 1.5l3.4 1 1.9-.3h4.8z"
    />
    <path
      fill="#007934"
      stroke="#000"
      strokeWidth={0.1}
      d="M309.8 254.8c1.2-.6 6-2.9 7.4-4.5-.1 0 .5.5.4.7.5 0 .2-.4.6-.5l.8-.1c.3 0 .1 0 .1.2-.4.6-1.3 1-2 1.5l.2.2h.7v-.3c.3.1.2.3.1.4-.2.4-.9.3-1.1.6a3 3 0 0 1-1 .9c.4-.2.7-.5 1.1-.5.6 0 .8-.4 1.3-.5.6-.1 1-.5 1.4-.8-.2.2-.5.4-.4.7l.4.1c-.4.4-1.2.7-1.5 1.2l-.6.1c-.3.1-.2.5-.4.6-.7.3-1 1-1.4 1.4l-.8.4c-.4.2-2.8 1.8-2.8 1.6-.2-1.1-2.6.5-8-1.2"
    />
    <path
      style={{
        lineHeight: "normal",
        InkscapeFontSpecification: "Sans",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        blockProgression: "tb",
        marker: "none"
      }}
      fill="#00a6de"
      stroke="#000"
      strokeWidth={0.1}
      d="M320 214.2c-18.1 0-32.8 16.5-32.8 36.9S301.9 288 320 288s32.8-16.5 32.8-37c0-20.3-14.7-36.9-32.8-36.9zm0 8.2c13.2 0 24.7 12.3 24.7 28.7s-11.5 28.6-24.7 28.6-24.7-12.2-24.7-28.6c0-16.4 11.5-28.7 24.7-28.7z"
      color="#000"
      fontFamily="Sans"
      fontWeight={400}
      overflow="visible"
    />
    <path
      fill="#e8a30e"
      d="M324.7 266.8c0 .2 0 .2-.4.3-.4 0-.5 0-.5-.2s.1-.2.5-.2c.3-.1.4-.1.4 0z"
    />
    <path
      fill="#e8a30e"
      d="M324.8 266.8l-.5.2h-.5c0-.2.2-.2.5-.3h.5zm-2.8 9c.8-2.2 1-3.8-.2-6 2-1.9 3.3-1.2 4.6 0-1.2 2.3-1 4-.2 6a4 4 0 0 1-4.2 0z"
    />
    <path fill="#e8a30e" d="M324 268.6v7.7h.1v-7.7z" />
    <path
      fill="#e8a30e"
      d="M324.4 268.6a44.6 44.6 0 0 0-.3 7.7c0-2.9.2-5.3.4-7.6zm.7-2.4c-.4.4-.6.4-.4 1 .4-.3.4-.5.4-1z"
    />
    <path fill="#e8a30e" d="M324.3 266.4c.2.3.6.4.3 1-.4-.3-.3-.4-.3-1z" />
    <path fill="#e8a30e" d="M324.3 267c.2.3.5.3.3.9-.3-.3-.4-.3-.4-.8z" />
    <path fill="#e8a30e" d="M324.2 267.4c.2.2.5.4.3 1-.4-.4-.3-.4-.3-1z" />
    <path fill="#e8a30e" d="M324 267.9c.3.2.7.3.4 1-.4-.4-.2-.5-.4-1z" />
    <path
      fill="#e8a30e"
      d="M324 268.4c.2.2.6.3.4 1-.3-.4-.4-.4-.4-1zm1.3-1.7c-.2.1-.6.1-.6.8.5-.3.5-.3.6-.8z"
    />
    <path fill="#e8a30e" d="M325.3 267.1c-.2.2-.7.2-.7.7.6-.2.5-.2.7-.7z" />
    <path fill="#e8a30e" d="M325.2 267.6c-.2.1-.6 0-.7.7.6-.3.6-.2.7-.8z" />
    <path fill="#e8a30e" d="M325.2 268.1c-.2 0-.7 0-.7.7.4-.1.4-.3.7-.7z" />
    <path
      fill="#e8a30e"
      d="M325 268.6c-.4.1-.5 0-.6.7.5-.3.4-.2.5-.7zm.2.3c-.7 2.1-.8 4-.7 7.4h.1c0-3.4.1-5.2.8-7.3a2.8 2.8 0 0 0-.1 0zm1.2-2.2c-.4.3-.6.2-.5.8.4-.1.4-.3.5-.8z"
    />
    <path fill="#e8a30e" d="M325.6 266.8c.2.2.5.4.1 1-.3-.4-.2-.5 0-1z" />
    <path fill="#e8a30e" d="M325.4 267.4c.3.3.5.3.2.8-.2-.3-.3-.3-.2-.8z" />
    <path fill="#e8a30e" d="M325.3 267.7c.1.3.4.4.1 1-.3-.4-.3-.4-.1-1z" />
    <path fill="#e8a30e" d="M325 268.1c.3.3.6.5.3 1-.4-.4-.2-.5-.3-1z" />
    <path
      fill="#e8a30e"
      d="M324.9 268.6c.2.3.5.5.2 1-.3-.4-.3-.4-.2-1zm1.6-1.4c-.2.2-.6 0-.7.7.5-.2.5-.2.7-.6z"
    />
    <path fill="#e8a30e" d="M326.4 267.7c-.2 0-.6 0-.8.5.6-.1.6 0 .8-.5z" />
    <path fill="#e8a30e" d="M326.3 268c-.3.2-.7 0-.9.7.7-.2.6-.2.9-.6z" />
    <path fill="#e8a30e" d="M326.1 268.6c-.2 0-.6-.2-.8.5.4 0 .4-.2.8-.5z" />
    <path
      fill="#e8a30e"
      d="M325.8 269c-.3 0-.5 0-.7.6.5-.2.5-.1.7-.6zm.1.4c-1 1.9-1.1 3.6-.7 6.8l.2-.1c-.4-3-.2-4.7.6-6.6zm1.6-2.2c-.5.2-.7.2-.7.8.4-.2.5-.4.7-.8z"
    />
    <path fill="#e8a30e" d="M326.7 267.2c.1.3.4.5 0 1-.3-.5-.2-.5 0-1z" />
    <path fill="#e8a30e" d="M326.4 267.8c.2.2.4.4 0 .8 0-.4-.2-.4 0-.9z" />
    <path fill="#e8a30e" d="M326.2 268c.1.3.4.5 0 1-.3-.4-.2-.4 0-1z" />
    <path fill="#e8a30e" d="M326 268.5c0 .3.4.5 0 1-.3-.5 0-.5 0-1z" />
    <path
      fill="#e8a30e"
      d="M325.7 268.9c.2.3.5.5 0 1-.1-.4-.2-.5 0-1zm1.8-1.1c-.2 0-.6-.1-.8.5.6-.1.5 0 .8-.5z"
    />
    <path fill="#e8a30e" d="M327.3 268.2c-.2 0-.6-.1-.8.4.6 0 .6 0 .8-.4z" />
    <path fill="#e8a30e" d="M327.1 268.5c-.2 0-.6 0-.8.5.6 0 .5 0 .8-.5z" />
    <path
      fill="#e8a30e"
      d="M327 269c-.3 0-.7-.3-1 .4.5 0 .5-.1 1-.4zm-.5.4c-.3 0-.4 0-.7.5.5-.1.5 0 .7-.5zm-3-.7c.2 2.4.4 4.8.4 7.6h.1c.1-2.9 0-5.3-.4-7.6zm-.6-2.6c.4.4.5.4.4 1-.4-.3-.4-.5-.4-1z"
    />
    <path fill="#e8a30e" d="M323.7 266.4c-.3.2-.6.4-.4 1 .4-.3.4-.4.4-1z" />
    <path fill="#e8a30e" d="M323.7 267c-.3.3-.5.3-.3.8.2-.3.3-.2.3-.7z" />
    <path fill="#e8a30e" d="M323.8 267.4c-.2.2-.5.3-.3 1 .4-.4.3-.4.3-1z" />
    <path fill="#e8a30e" d="M324 267.9c-.3.2-.7.3-.5 1 .5-.4.2-.5.4-1z" />
    <path
      fill="#e8a30e"
      d="M324 268.4c-.3.2-.6.3-.4.9.3-.3.4-.4.4-.9zm-1.3-1.8c.2.2.6.2.6.8-.5-.3-.5-.2-.6-.8z"
    />
    <path fill="#e8a30e" d="M322.7 267.1c.2.1.6.1.6.7-.5-.3-.5-.2-.6-.7z" />
    <path fill="#e8a30e" d="M322.8 267.5c.2.1.6.1.6.8-.5-.3-.5-.3-.6-.8z" />
    <path fill="#e8a30e" d="M322.8 268c.2.1.7 0 .7.8-.4-.1-.4-.4-.7-.7z" />
    <path
      fill="#e8a30e"
      d="M323 268.5c.3.2.5.1.5.8-.4-.3-.4-.3-.5-.8zm-.2.5a3.8 3.8 0 0 0-.2.1c.7 2 1 3.9.9 7.2h.1a19 19 0 0 0-.8-7.3zm-1.2-2.4c.4.3.5.3.5.8-.4-.1-.4-.3-.5-.8z"
    />
    <path fill="#e8a30e" d="M322.4 266.7c-.2.3-.5.4-.2 1 .3-.4.3-.4.2-1z" />
    <path fill="#e8a30e" d="M322.6 267.3c-.3.3-.6.4-.2.9.2-.4.3-.4.2-.9z" />
    <path fill="#e8a30e" d="M322.7 267.6c-.2.3-.5.5-.1 1 .3-.4.2-.4.1-1z" />
    <path fill="#e8a30e" d="M323 268.1c-.3.3-.6.4-.3 1 .4-.5.1-.5.2-1z" />
    <path
      fill="#e8a30e"
      d="M323 268.6c-.1.2-.5.4-.1 1 .2-.4.3-.5.2-1zm-1.5-1.5c.2.1.6 0 .7.7-.6-.2-.5-.2-.7-.7z"
    />
    <path fill="#e8a30e" d="M321.6 267.6c.2 0 .6 0 .7.5-.5-.1-.5 0-.7-.5z" />
    <path fill="#e8a30e" d="M321.7 268c.2 0 .7 0 .8.6-.6-.2-.6-.2-.8-.7z" />
    <path fill="#e8a30e" d="M321.9 268.5c.2 0 .6-.2.8.6-.4 0-.5-.3-.8-.6z" />
    <path
      fill="#e8a30e"
      d="M322.2 269c.3 0 .4 0 .6.5-.5-.2-.4-.1-.6-.6zm0 .5a4.1 4.1 0 0 0-.2 0c.9 2 1 3.6.7 6.6h.2c.3-3 .2-4.6-.8-6.6zm-1.7-2.5c.4.3.6.2.6.8-.4-.1-.5-.3-.6-.8z"
    />
    <path fill="#e8a30e" d="M321.3 267c-.1.3-.4.6 0 1 .3-.4.2-.4 0-1z" />
    <path fill="#e8a30e" d="M321.6 267.6c-.2.3-.5.4-.1.9.1-.4.3-.4 0-.9z" />
    <path fill="#e8a30e" d="M321.8 268c-.2.2-.4.4 0 1 .2-.5.2-.5 0-1z" />
    <path fill="#e8a30e" d="M322 268.4c-.1.3-.4.5 0 1 .3-.5 0-.5 0-1z" />
    <path
      fill="#e8a30e"
      d="M322.3 268.8c-.2.3-.5.5-.1 1 .2-.4.2-.5 0-1zm-1.8-1.2c.2 0 .6 0 .8.5-.6 0-.6 0-.8-.5z"
    />
    <path fill="#e8a30e" d="M320.6 268c.3 0 .7 0 .9.5-.6-.1-.6 0-.9-.5z" />
    <path fill="#e8a30e" d="M320.8 268.4c.3 0 .7 0 1 .5-.7-.1-.7 0-1-.5z" />
    <path fill="#e8a30e" d="M321 268.9c.3 0 .7-.3 1 .5-.5 0-.5-.3-1-.5z" />
    <path
      fill="#e8a30e"
      d="M321.4 269.3c.3 0 .5 0 .7.5-.5-.1-.4 0-.7-.5zm2.2-3.2c.3.4.5.4.3 1-.4-.3-.3-.5-.3-1z"
    />
    <path fill="#e8a30e" d="M324.3 266.4c-.2.2-.5.3-.4 1 .5-.3.4-.4.4-1z" />
    <path fill="#e8a30e" d="M324.4 267c-.3.2-.6.3-.4.8.2-.3.3-.2.4-.7z" />
    <path fill="#e8a30e" d="M324.4 267.4c-.2.2-.5.3-.4 1 .4-.4.4-.4.4-1z" />
    <path fill="#e8a30e" d="M324.5 268c-.3.1-.6.2-.5.8.5-.3.3-.4.5-.9z" />
    <path
      fill="#e8a30e"
      d="M324.5 268.4c-.2.2-.6.3-.4.9.3-.3.4-.3.4-.9zm-1.2-1.8c.2.2.6.2.6.8-.5-.3-.5-.3-.6-.8z"
    />
    <path fill="#e8a30e" d="M323.3 267c.2.2.6.2.6.8-.5-.3-.5-.3-.6-.8z" />
    <path fill="#e8a30e" d="M323.4 267.4c.2.2.6.2.6.9-.5-.4-.5-.3-.6-.9z" />
    <path fill="#e8a30e" d="M323.4 268c.2.1.7 0 .6.8-.4-.2-.3-.4-.6-.8z" />
    <path
      fill="#e8a30e"
      d="M323.6 268.5c.2.1.4.1.4.8-.4-.4-.4-.3-.4-.8zm-.4.3a2.7 2.7 0 0 0-.1 0c.5 2.5.7 4.7.6 7.5h.2c0-2.5 0-5-.7-7.5zm-1-2.4c.4.4.6.3.5 1-.4-.3-.4-.5-.5-1z"
    />
    <path fill="#e8a30e" d="M323 266.6c-.2.2-.5.4-.2 1 .3-.4.3-.4.2-1z" />
    <path fill="#e8a30e" d="M323.1 267.2c-.2.2-.5.3-.2.8.2-.3.3-.3.2-.8z" />
    <path fill="#e8a30e" d="M323.3 267.5c-.2.3-.5.4-.2 1 .3-.3.3-.4.2-1z" />
    <path fill="#e8a30e" d="M323.5 268c-.3.3-.6.4-.3 1 .4-.4.2-.5.3-1z" />
    <path
      fill="#e8a30e"
      d="M323.6 268.5c-.2.3-.6.4-.3 1 .3-.4.3-.5.3-1zM322 267c.3 0 .7 0 .8.6-.6-.2-.6-.1-.8-.6z"
    />
    <path fill="#e8a30e" d="M322.1 267.4c.2.1.7 0 .8.6-.6-.2-.6-.1-.8-.6z" />
    <path fill="#e8a30e" d="M322.3 267.8c.2.1.6 0 .7.7-.6-.2-.6-.2-.7-.7z" />
    <path fill="#e8a30e" d="M322.4 268.3c.2 0 .6-.1.8.7-.5-.1-.5-.3-.8-.7z" />
    <path
      fill="#e8a30e"
      d="M322.7 268.8c.3 0 .4 0 .6.6-.5-.2-.5-.1-.6-.6zm-.8.9c.6 1.4.8 2.6.7 3.7l-.3 2.5h.1c.6-2.5.5-4.4-.5-6.2z"
    />
    <path
      fill="#e8a30e"
      d="M322.5 269.2l-.1.1c.8 2.1.9 4 .7 7h.1c.2-3 .1-5-.7-7zm-1.4-2.4c.4.3.5.2.5.8-.4-.1-.4-.3-.5-.8z"
    />
    <path fill="#e8a30e" d="M321.8 266.9c-.1.2-.4.4 0 1 .3-.4.2-.5 0-1z" />
    <path fill="#e8a30e" d="M322 267.4c-.1.3-.4.4 0 1 .1-.4.2-.4 0-1z" />
    <path fill="#e8a30e" d="M322.3 267.8c-.2.2-.5.4 0 1 .2-.5.1-.5 0-1z" />
    <path fill="#e8a30e" d="M322.5 268.2c-.2.3-.5.5 0 1 .2-.5 0-.5 0-1z" />
    <path
      fill="#e8a30e"
      d="M322.7 268.7c-.1.2-.5.5-.1 1 .2-.4.3-.5.1-1zm-1.7-1.3c.2 0 .6 0 .8.5-.6-.1-.6 0-.8-.5z"
    />
    <path fill="#e8a30e" d="M321.1 267.8c.3 0 .7 0 .8.5-.5-.1-.5 0-.8-.5z" />
    <path fill="#e8a30e" d="M321.3 268.1c.2.1.7 0 .9.6-.6-.1-.6 0-.9-.6z" />
    <path fill="#e8a30e" d="M321.5 268.7c.2 0 .6-.3.9.5-.5 0-.5-.2-.9-.5z" />
    <path
      fill="#e8a30e"
      d="M321.9 269c.3.1.4 0 .6.6-.4-.1-.4 0-.6-.5zm-2-1.6c.5.2.7.2.8.7-.4 0-.5-.2-.7-.7z"
    />
    <path fill="#e8a30e" d="M320.7 267.4c0 .3-.3.5.2 1 .2-.5.1-.5-.2-1z" />
    <path fill="#e8a30e" d="M321 267.9c0 .3-.3.5.1.9.1-.4.2-.4 0-.9z" />
    <path fill="#e8a30e" d="M321.3 268.2c0 .3-.3.5.1 1 .2-.5.2-.5 0-1z" />
    <path fill="#e8a30e" d="M321.6 268.6c0 .3-.4.5.1 1 .2-.6 0-.5 0-1z" />
    <path
      fill="#e8a30e"
      d="M322 269c-.2.3-.5.6 0 1 .1-.4.2-.5 0-1zm-2-1c.2 0 .6-.1.9.4-.6 0-.6 0-1-.4z"
    />
    <path fill="#e8a30e" d="M320.2 268.4c.2 0 .6-.2.9.4-.6 0-.6 0-.9-.4z" />
    <path fill="#e8a30e" d="M320.4 268.7c.3 0 .7-.1 1 .4-.6 0-.6 0-1-.4z" />
    <path fill="#e8a30e" d="M320.7 269.2c.2 0 .6-.3 1 .4-.5 0-.5-.2-1-.4z" />
    <path
      fill="#e8a30e"
      d="M321.1 269.5c.3 0 .5 0 .8.5-.5 0-.5 0-.8-.5zm3.8-.7a25.9 25.9 0 0 0-.7 7.5 2.5 2.5 0 0 0 .2 0c0-2.8 0-5 .7-7.4a2.8 2.8 0 0 0-.2-.1zm1-2.3c-.4.3-.5.3-.5.9.4-.2.5-.4.5-.9z"
    />
    <path fill="#e8a30e" d="M325.1 266.6c.2.3.5.5.2 1-.3-.4-.3-.4-.2-1z" />
    <path fill="#e8a30e" d="M325 267.3c.3.2.5.3.2.8-.2-.3-.3-.3-.2-.9z" />
    <path fill="#e8a30e" d="M324.9 267.6c.2.2.5.4.2 1-.4-.4-.3-.5-.2-1z" />
    <path fill="#e8a30e" d="M324.7 268c.2.3.5.5.2 1-.4-.4-.1-.5-.2-1z" />
    <path
      fill="#e8a30e"
      d="M324.5 268.5c.2.3.6.5.3 1-.3-.4-.3-.4-.3-1zm1.6-1.5c-.2.2-.6 0-.7.7.5-.2.5-.2.7-.7z"
    />
    <path fill="#e8a30e" d="M326 267.5c-.2 0-.6 0-.7.6.5-.2.5-.1.7-.6z" />
    <path fill="#e8a30e" d="M325.9 267.9c-.2 0-.7 0-.8.6.6-.2.6-.1.8-.6z" />
    <path fill="#e8a30e" d="M325.7 268.4c-.2 0-.6-.2-.7.6.4 0 .4-.3.7-.6z" />
    <path
      fill="#e8a30e"
      d="M325.4 268.8c-.2.1-.4 0-.5.7.4-.2.4-.2.5-.7zm.2.4c-.9 2.1-1 4.1-.8 7h.2c-.2-3-.1-4.9.7-7zm1.5-2.3c-.5.3-.6.2-.6.8.4-.1.4-.3.6-.8z"
    />
    <path fill="#e8a30e" d="M326.3 267c.1.2.4.5 0 1-.3-.5-.2-.5 0-1z" />
    <path fill="#e8a30e" d="M326 267.5c.3.3.5.5.1 1-.1-.5-.2-.5 0-1z" />
    <path fill="#e8a30e" d="M325.9 267.8c.1.3.4.5 0 1-.3-.4-.2-.4 0-1z" />
    <path fill="#e8a30e" d="M325.6 268.3c.2.3.5.5.1 1-.3-.5 0-.5-.1-1z" />
    <path
      fill="#e8a30e"
      d="M325.4 268.7c.2.3.5.5.1 1-.2-.4-.3-.4-.1-1zm1.7-1.2c-.2.1-.6 0-.8.5.6 0 .6 0 .8-.5z"
    />
    <path fill="#e8a30e" d="M327 268c-.2 0-.6-.1-.8.4.6-.1.5 0 .8-.5z" />
    <path fill="#e8a30e" d="M326.8 268.3c-.2 0-.7 0-.8.5.6-.1.5 0 .8-.5z" />
    <path fill="#e8a30e" d="M326.6 268.8c-.2 0-.6-.3-.8.5.4 0 .4-.3.8-.5z" />
    <path
      fill="#e8a30e"
      d="M326.3 269.2c-.4 0-.5 0-.7.5.4-.1.4 0 .6-.5zm0 .5c-1.1 2-1 4-.6 6.3h.2l-.3-2.9a6 6 0 0 1 .8-3.3h-.1zm1.9-2c-.5.1-.7 0-.8.6.5 0 .5-.2.8-.7z"
    />
    <path fill="#e8a30e" d="M327.4 267.5c0 .3.3.6-.2 1-.2-.5-.1-.5.2-1z" />
    <path fill="#e8a30e" d="M327 268c.2.3.4.5 0 .9-.1-.4-.2-.4 0-.9z" />
    <path fill="#e8a30e" d="M326.8 268.3c.1.3.3.5-.1 1-.2-.5-.2-.5.1-1z" />
    <path fill="#e8a30e" d="M326.5 268.7c0 .3.4.6-.1 1-.2-.6 0-.5 0-1z" />
    <path
      fill="#e8a30e"
      d="M326.2 269c.1.4.4.7 0 1-.2-.4-.2-.4 0-1zm2-.8c-.3 0-.6-.2-1 .4.6 0 .6 0 1-.4z"
    />
    <path fill="#e8a30e" d="M327.9 268.6c-.2 0-.6-.2-.9.3.6 0 .6 0 .9-.3z" />
    <path fill="#e8a30e" d="M327.7 268.9c-.3 0-.7-.2-1 .4.7 0 .6 0 1-.4z" />
    <path fill="#e8a30e" d="M327.4 269.4c-.2 0-.6-.4-1 .3.5 0 .6-.2 1-.3z" />
    <path
      fill="#e8a30e"
      d="M327 269.7c-.3 0-.5-.1-.8.4.5 0 .5 0 .8-.4zm-3.5 2.7h1.1c.7 0 1.2.2 1.2.4s-.5.3-1.2.3h-1.1c-.7 0-1.3-.2-1.3-.4s.6-.3 1.3-.3z"
    />
    <path
      fill="#e8a30e"
      d="M322.7 272.4l-.4.6a.3.3 0 0 0 .2 0h.2l.4-.6h-.4zm.9 0l-.4.6h.4l.4-.6h-.4zm.9 0l-.4.7h.4l.4-.7h-.4zm.8 0l-.3.7h.4l.3-.6a.3.3 0 0 0-.2 0h-.2z"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M316.5 268.8l.5 2.7.2.2v1.1c.3.5.3 1.1.5 1.6l.3.6h.4l.1.2-.2.2h-.6l-.3-.1v-.3h-.2l-.1-.6-.8-1c0-.1 0-.4-.2-.5l-.3-.3c-.5-1-1-3-1-3m-6.4-1l1.8.4-.5 2.6c-.3.8-.3.9-.2 1 .2.5.4 1.2 1.1 2.3l.6.4.5.3h.5l.1-.2c0-.1-.3 0-.5-.2 0-.3-.5-.8-.5-1.2-.3-.7-.2-.7-.2-1.5l.5-1.6c.2-.5.5-1.4.5-2l-.8-1.7-.5-.7m-1.6-1.1c-2.9 1-1.7 3.5-.9 3.6m9.2-8.1l.4-1v-.4l-.7.9"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M319.2 262.4c.2 0 .4.1.4 0v-.6c-.6-.4-1-.4-1-.7v-.2c0-.2-.8-.3-1-.4l-.4-.2h-.2c-.8 0-1.1.7-1.2 1.2 0 0-.2 2.1-.5 3a.7.7 0 0 1-.2.3l-.2.2c-2-.2-3.4-.2-4.2-.2-.8 0-1.8.7-1.8.7s-1 .6-1.1 1.6c-.1.3 0 .7.1 1 1 2.7 1.8 0 2.1.1h.4c.5 0 1.4 1.5 2.7 1.8 4 .9 5-1.2 5-5.8v-.2l.2-.4v-.8l1-.2.2-.1"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M317.3 261l.4-1v-.4l-.9 1m-8.9 7.6c.3.8.7 1.5.7 1.8 0 .4-.3.6-.3.7h-.2l-.2.6a1.3 1.3 0 0 0 0 .6c0 .7.4 2.2.4 2.3 0 0 .3 0 .3.2v1.2c0 .2.3.3.3.3h.6l-.4-.4a.4.4 0 0 1 0-.2c0-.2.2-.4.3-.5v-.3l-.1-.2a8.3 8.3 0 0 1-.1-.9v-1.1l.2-.2.1-.2 1-.6.8-1 .2-.5a.5.5 0 0 0 0-.2 3.8 3.8 0 0 0-.3-.9 3.2 3.2 0 0 0-.6-.8m5.9 1.8c-.5.4-1.8.7-1.8 1 0 0 0 1.6-.2 2.2l-.3.6-.2.7-.3 1v.3l.4.3h-.4l-.6-.2V274l-.2-1.4.1-1-.1-3.6m4.7-5.4c.2.2.6.4 1.3.1.2.1.3.2.6-.2m-.3-.5h.2s.1 0 0 0c0 0 0-.1 0 0h-.2z"
    />
    <path d="M317.8 261.4c.2.3.4.3.6.1-.2-.3-.4-.1-.5-.1h-.1z" />
    <path
      fill="#e7e7e7"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.1}
      d="M329.1 272.9a2 2 0 0 0 0 .7v.8a2 2 0 0 0 0 .7 2 2 0 0 0 0 .7c.2.2 1 .2 1.2 0a2.2 2.2 0 0 0 0-.7v-.7a2 2 0 0 0 0-.7v-.8a2.3 2.3 0 0 0 0-.8v-.7a2.2 2.2 0 0 0 0-.8v-.8a2.4 2.4 0 0 0 0-.8v-.7a2.2 2.2 0 0 0 0-.8 1.9 1.9 0 0 0 0-.8 2.5 2.5 0 0 0 0-.8 2.3 2.3 0 0 0 0-.8 3.3 3.3 0 0 0 0-.8 2.9 2.9 0 0 0 0-.7v-.8a2.6 2.6 0 0 0 0-.8 2.7 2.7 0 0 0 0-.8v-.8a2.3 2.3 0 0 0 0-.8v-.7a2 2 0 0 0 0-.3h-.9v1a2.3 2.3 0 0 0 0 .8v.8a2.7 2.7 0 0 0 0 .8 2.6 2.6 0 0 0 0 .8 3 3 0 0 0 0 .7l-.1.8v.8a2.4 2.4 0 0 0 0 .8 2.5 2.5 0 0 0 0 .8 1.9 1.9 0 0 0 0 .8c-.1.3-.1.5 0 .8v.7a2.4 2.4 0 0 0-.1.8 2.6 2.6 0 0 0 0 .8 2.2 2.2 0 0 0 0 .8 2 2 0 0 0 0 .7 2.3 2.3 0 0 0 0 .8z"
    />
    <path
      fill="#e7e7e7"
      fillRule="evenodd"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.1}
      d="M329.1 273.6c.3.2 1 .1 1.2 0m-1.2-.7h1.2m-1.2-.8h1.2m-1.1-.7h1.1m-1.1-.8h1.1m-1.1-.8h1.1m-1-.8h1m-1-.7h1m-1-.8h1m-1-.8h1m-1-.8h1m-1-.8h1m-1-.8h1m-1-.7h1m-1-.8h1m-1-.8h1m-.9-.8h.8m-.8-.8h.8m-.8-.8h.8m-.8-.7h.8m-1 15.5h1.1m-1.2.7h1.2"
    />
    <path
      fill="#007934"
      fillRule="evenodd"
      stroke="#e7e7e7"
      strokeWidth={0.1}
      d="M331.5 257a13 13 0 0 1 2.1 0 13.7 13.7 0 0 0-.8-.3h2.2a5 5 0 0 0-1-.5 8 8 0 0 1 2.2.1l-1-.5c.9 0 1.2 0 2 .2a2.6 2.6 0 0 0-.9-.5 8 8 0 0 1 2.5-.2 8.6 8.6 0 0 0-8 .8 6 6 0 0 1 1-1.1 2.5 2.5 0 0 0-.7 0c.3-.3.8-.8 1.2-1l-.7.1 1.4-1a3.1 3.1 0 0 0-.9.1 5.2 5.2 0 0 1 1.6-1.1 4 4 0 0 0-1 0 8.7 8.7 0 0 1 2-1.3c-3.3.4-5.1 2.8-5.3 4.8a7 7 0 0 0-6.6-3.6c1 .3 1.8.7 2.4 1a4.4 4.4 0 0 0-1 .1c.7.2 1.5.6 2 1a3.4 3.4 0 0 0-1 0l1.8.8-.8.1a5 5 0 0 1 1.5.8h-.8c1 .4 1.1.6 1.3.7a8 8 0 0 0-7.3 3 10 10 0 0 1 2.2-1l-.5.8c.5-.4 1.3-.8 2-1a4.8 4.8 0 0 0-.4.7l1.8-1-.4.8 1.7-.7-.5.7 1-.4a6.2 6.2 0 0 0-2.9 5.8l.9-2v1a8.5 8.5 0 0 1 1-2v1l1-2v1l1.1-1.9v.8l.3-.6.7-.9.2.3c.3.4.4 1.1.5 1.8a3.2 3.2 0 0 0 .2-.9c.3.7.7 1.8.7 2.4a3.6 3.6 0 0 0 .2-1c.3.5.6 1.8.7 2.3l.3-.9c.3.8.4 1.7.5 2.3.8-3-.4-4.9-1.8-6.3.4.1.8.5 1.3 1a4.9 4.9 0 0 0-.3-.9l1.5 1.4-.2-.8c.6.4 1.1 1.2 1.5 1.6a5.4 5.4 0 0 0-.2-1 6 6 0 0 1 1.3 1.8l-.1-1c.7.6 1 1.3 1.3 1.7 0-2.7-3.1-5-6-5.3z"
    />
    <path
      fill="none"
      stroke="#e7e7e7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.1}
      d="M330.3 257.1c3.1-.5 7.2 2.3 7.2 5.3-.3-.4-.6-1.1-1.3-1.8l.1 1a6 6 0 0 0-1.3-1.7l.2 1c-.4-.4-.9-1.2-1.5-1.6l.2.8-1.5-1.4.3 1c-.5-.6-1-1-1.3-1.1m-1.8-1.5c-1.9-1.2-5.8-1-8.7 2.3a10 10 0 0 1 2.2-.9l-.5.8c.5-.4 1.3-.8 2-1a4.8 4.8 0 0 0-.4.7l1.8-1-.4.8 1.7-.7-.5.7 1-.4"
    />
    <path
      fill="none"
      stroke="#e7e7e7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.1}
      d="M329.7 256.6c-.4-2.2-3-4.8-6.9-4.6 1 .3 1.8.7 2.4 1a4.3 4.3 0 0 0-1 .1c.7.2 1.5.6 2 1a3.4 3.4 0 0 0-1 0l1.8.8a3.2 3.2 0 0 0-.8.1 5 5 0 0 1 1.5.7l-.7.1c1 .4 1 .6 1.2.7m1.5 1c-2.6.8-5.1 3.3-4.7 6.7 0-.4.5-1.5.8-2v1l1-2v1l1-2v1a13.3 13.3 0 0 1 1.1-1.9v.8a5 5 0 0 1 1-1.5m-1.6.2a8.7 8.7 0 0 0-.5 1.4m-.5-.8a9.7 9.7 0 0 0-.5 1.9m-.5-1a9 9 0 0 0-.5 2"
    />
    <path
      fill="none"
      stroke="#e7e7e7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.1}
      d="M329.9 258.6v-.6"
      className="prefix__fil1 prefix__str2"
    />
    <path
      fill="none"
      stroke="#e7e7e7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.1}
      d="M332.6 261.3v1.3m-1-3l.1 1.6m-1-2.7l.1 1.3m4.8-.4l.6 1.2m-2-2.1l.8 1.4m-2-1.8c.3.3.5.7.7 1.2m-10.6-.8a4.7 4.7 0 0 1 1.7-1.2m-.2 1c.4-.6.6-.9 1.6-1.3m-.2 1c.4-.4.9-.8 1.7-1.1m-.4 1.2c.5-.5 1-.7 1.6-1m-3.7-4c.7 0 1.6.2 2.2.6m-1.2.4c.6 0 1.4.2 1.8.4m-1 .4c.6 0 1.3.3 2 .6m-1.3.2a4 4 0 0 1 1.7.6m.9.2a8.6 8.6 0 0 1 8.5-1.2 8 8 0 0 0-2.4.2c.4 0 .7.3.8.4h-2c.4 0 .7.2 1 .4a7.3 7.3 0 0 0-2.2 0l1 .3h-2.2l.8.3c-1 0-1.6 0-2 .2m4.8-1.6a6 6 0 0 0-2.2-.4m1 .7a5.8 5.8 0 0 0-2.5-.2m1.3.6a6.8 6.8 0 0 0-2.5-.2m1.3.7a5 5 0 0 0-2-.1m.8 1c.4.3.6.7.8 1.1m-3-3.1c.2-2 2-4.4 5.3-4.8a9 9 0 0 0-2 1.3h1c-.5.2-1.2.7-1.6 1.1a3.1 3.1 0 0 1 .9 0 6.7 6.7 0 0 0-1.4 1l.7-.1a4.1 4.1 0 0 0-1.2.9h.7l-1 1.1m2-4c-.5.1-1.1.4-1.6.7m1 .4a4.5 4.5 0 0 0-1.5.5m.9.4c-.5.1-1 .4-1.5.7m1 .2a3.2 3.2 0 0 0-1.4.8m-.5 2.4a6 6 0 0 0-.3 1.1m1.2-2c1.8 1.6 4.1 3.7 3 7.6a6 6 0 0 0-.4-2.2l-.3.9a6.8 6.8 0 0 0-.7-2.4 3.5 3.5 0 0 1-.2 1 8.3 8.3 0 0 0-.7-2.4c0 .2 0 .6-.2.9 0-.9-.3-1.7-.7-2"
    />
    <path
      fontSize={100}
      style={{
        lineHeight: "125%",
        InkscapeFontSpecification: "'Linux Biolinum Bold'",
        textAlign: "center"
      }}
      fill="#e8a30e"
      stroke="#000"
      strokeWidth={0.1}
      d="M293.3 233.5l1.3.7.3-.6c.1-.3.2-.5.1-.6 0-.2-.2-.4-.5-.5-.3-.2-.6-.3-.7-.2-.2 0-.4.2-.5.4l-.2.5c0 .1 0 .2.2.3m1.6 1l1.7.8h.3l.3-.5.3-.6a.6.6 0 0 0 0-.4.7.7 0 0 0-.2-.2 1.9 1.9 0 0 0-.3-.2c-.8-.4-1.3-.3-1.7.3l-.4.7m-2.6-.8a33 33 0 0 0 .6-1.2 3.3 3.3 0 0 1 .6-.7l.6-.4h.9c.2.1.3.3.4.6.1.2.2.5.1.7a2 2 0 0 1 1-.6l1 .1c.3.2.5.6.6 1 .1.5 0 1-.4 1.7a32.4 32.4 0 0 1-.7 1.3l-.3.7-1.4-.9-1.8-1-1.5-.7.3-.6m9-10.8c-.8.6-.7 1.5.3 2.6.5.6 1 1 1.5 1 .4.2.9 0 1.3-.3.3-.3.5-.6.4-1a3.1 3.1 0 0 0-.8-1.5c-.5-.7-1-1-1.4-1.2-.5 0-1 0-1.4.4m3.8-.2c.5.6.7 1.3.7 2a2.8 2.8 0 0 1-1.2 2 2.9 2.9 0 0 1-2 .7 2.4 2.4 0 0 1-1.8-1 2.8 2.8 0 0 1-.7-2c0-.7.4-1.4 1-2a2.9 2.9 0 0 1 2-.7c.8 0 1.4.4 2 1m8-2.6l.3 1a14.4 14.4 0 0 0 1.9-.7h.3a4.5 4.5 0 0 0 .3.7l-.5.1-2.4.7-.7.2-.4-1.6-.5-2a12 12 0 0 0-.5-1.5l.6-.2.7-.2.3 1.6.6 2m9.2-3a12.2 12.2 0 0 0 0-1.6h.8l.7.1c-.2.5-.2 1-.3 1.7l-.2 2a11.9 11.9 0 0 0-.1 1.6h-.7l-.7-.1.3-1.7.2-2m9.9 5.3c1.6-1.3 2.7-2.2 3.1-2.7l.4.2.4.2a230 230 0 0 0-4.7 3.6l-.5-.3a316.2 316.2 0 0 1 .2-2 362.5 362.5 0 0 0 .4-3.8 7.7 7.7 0 0 0 1.2.7 34.8 34.8 0 0 0-.5 4m8.4 4l1.2-1.3.4.6.5.4a11.1 11.1 0 0 0-1.3 1.1l-1.5 1.4a12 12 0 0 0-1.1 1.1l-.5-.5-.5-.5 1.3-1 1.5-1.4m5 10l1.3-1.4h-2a18 18 0 0 0 .7 1.4m-1.1-1.3l-2 .1a1.9 1.9 0 0 0-.1-.3 2.6 2.6 0 0 0-.2-.4h5.9l.3.6a82.5 82.5 0 0 0-4 4.3l-.2-.7a5.4 5.4 0 0 0-.3-.6 23.9 23.9 0 0 0 1.4-1.3 35 35 0 0 0-.4-.8 39.5 39.5 0 0 0-.4-1"
      fontFamily="Linux Biolinum"
      fontWeight={700}
      letterSpacing={60}
      textAnchor="middle"
      wordSpacing={0}
    />
    <path
      fill="#e8a30e"
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth={0.1}
      d="M325 280.6l-.8 2.2h-2.4l1.9 1.5-.7 2.2 2-1.3 1.8 1.3-.6-2.2 1.8-1.4h-2.3zm9-3.9l-.7 2.2H331l1.8 1.5-.7 2.2 2-1.3 1.9 1.3-.7-2.2 1.9-1.4h-2.4zm14.2-25l-.8 2.3h-2.3l1.8 1.4-.6 2.3 1.9-1.4 1.9 1.4-.7-2.3 1.9-1.4h-2.4zm-6.7 17.9l.7 2.2h2.4l-1.9 1.4.7 2.3-2-1.4-1.9 1.4.7-2.3-1.8-1.4h2.3zm4.7-8.2l.8 2.2h2.3l-1.9 1.5.7 2.2-1.9-1.3-2 1.3.8-2.2-1.9-1.4h2.3zm-31.1 19.2l.8 2.2h2.3l-1.9 1.5.7 2.2-2-1.3-1.8 1.3.6-2.2-1.8-1.4h2.3zm-9.2-3.9l.8 2.2h2.4l-2 1.5.8 2.2-2-1.3-1.9 1.3.7-2.2-1.9-1.4h2.4zm-14-25l.7 2.3h2.3l-1.8 1.4.6 2.3-1.9-1.4-1.9 1.4.7-2.3-1.9-1.4h2.4zm6.6 17.9l-.7 2.2h-2.4l1.9 1.4-.7 2.3 2-1.4 1.9 1.4-.7-2.3 1.8-1.4h-2.3zm-4.7-8.2l-.8 2.2h-2.3l1.9 1.5-.7 2.2 1.9-1.3 2 1.3-.8-2.2 1.9-1.4h-2.3z"
    />
    <path fill="#e7e7e7" d="M321 248.1v-.5h.1l-.8-.5h-.7l-.8.5v.5h2.3" />
    <path
      fill="#e7e7e7"
      d="M321 248.1v-.5h.1l-.8-.5v-.7h-.6v.7l-.9.5v.5h2.3zm.3.6v.2h-2.6v-.2h2.6"
    />
    <path
      fill="#e7e7e7"
      d="M321.3 248.7v.2h-2.6v-.2h2.6zm-2.5 0v-.5h.1v.5-.5h-.1v-.1h2.4v.1h-.2v.5-.5h.1v.5"
    />
    <path
      fill="#e7e7e7"
      d="M318.9 248.7v-.5.5-.5h-.1v-.1h2.4v.1h-.2v.5-.5h.1v.5"
    />
    <path fill="#e7e7e7" d="M319.4 248.6v-.4h-.4v.4h.4" />
    <path fill="#e7e7e7" d="M319.1 248.3v.2h.2v-.2h-.2m1.8.3v-.4h-.3v.4h.3" />
    <path fill="#e7e7e7" d="M320.7 248.3v.2h.1v-.2h-.1m.2-.3v-.3h-.3v.3h.3z" />
    <path fill="#e7e7e7" d="M320.7 247.7v.2h.1v-.2h-.1m-1.3.3v-.3h-.4v.3h.4z" />
    <path fill="#e7e7e7" d="M319.1 247.7v.2h.2v-.2h-.2m.8.3v-.3h-.3v.3h.3" />
    <path fill="#e7e7e7" d="M319.7 247.7v.2h.1v-.2h-.1m.7.3v-.3h-.3v.3h.3" />
    <path fill="#e7e7e7" d="M320.1 247.7v.2h.2v-.2h-.2m.4.2v.8h-1v-.8h1" />
    <path
      fill="#e7e7e7"
      d="M320.5 247.9v.8h-1v-.8h1zm-1 .2h1m-.9.6v-.6m.7.6v-.6m.5-.5l-.5-.4h-.6l-.5.4h1.6m-1-.5h.4m-.3-.1h.2-.2m0 1zm.1 0h.1zm.3 0h.1"
    />
    <path fill="#e7e7e7" fillRule="evenodd" d="M319.8 246h.4v.4h-.4v-.4z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M320 245.6v.4m-.2-.2h.4"
    />
    <path
      fill="#452c25"
      d="M317.1 210.3s-2.3 5.4-1.5 6c0 0 3-3.3 3.7-5.9.8-2.6 0-.2 0-.2l-.2-2.8-2 2.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.2}
      d="M317.1 210.3s-2.3 5.4-1.5 6c0 0 3-3.3 3.7-5.9.8-2.6 0-.2 0-.2l-.2-2.8-2 2.7"
    />
    <path
      fill="#452c25"
      d="M317.6 207.7s-2.8 6-2.1 6.4c0 0 2.3-2.7 3-4.8.5-2.1 0-.1 0-.1l.7-3.9"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M317.6 207.7s-2.8 6-2.1 6.4c0 0 2.3-2.7 3-4.8.5-2.1 0-.1 0-.1l.7-3.9"
    />
    <path
      fill="#452c25"
      d="M320.5 206.4s-2.8 6-2.1 6.4c0 0 2.3-2.7 3-4.8.5-2.2 0-.2 0-.2l.7-3.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M320.5 206.4s-2.8 6-2.1 6.4c0 0 2.3-2.7 3-4.8.5-2.2 0-.2 0-.2l.7-3.8"
    />
    <path
      fill="#452c25"
      d="M356.8 195.6l3.4 1.9s.8.7-1 .3a42 42 0 0 1-12.8-6.4c-3.3-2-4.3-2-4.3-2l4.5.1 10.2 6.1z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M356.8 195.6l3.4 1.9s.8.7-1 .3a42 42 0 0 1-12.8-6.4c-3.3-2-4.3-2-4.3-2l4.5.1 10.2 6.1z"
    />
    <path
      fill="#452c25"
      d="M358 194.8l3.3 1.9s.8.7-1 .3a45 45 0 0 1-12.8-6.4c-3.3-2.1-.6 1.7-.6 1.7l.5-2.5 10.5 5z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M358 194.8l3.3 1.9s.8.7-1 .3a45 45 0 0 1-12.8-6.4c-3.3-2.1-.6 1.7-.6 1.7l.5-2.5 10.5 5z"
    />
    <path
      fill="#452c25"
      d="M363.5 196.6s-4-.7-5.4-1.8c0 0 .2.5-1.7-.4 0 0 .7 1.7-4.8-2-5.5-3.8-3.6-2-3.6-2l1.6-.3 9.3 3.7a53 53 0 0 1 4.6 2.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M363.5 196.6s-4-.7-5.4-1.8c0 0 .2.5-1.7-.4 0 0 .7 1.7-4.8-2-5.5-3.8-3.6-2-3.6-2l1.6-.3 9.3 3.7a53 53 0 0 1 4.6 2.8z"
    />
    <path
      fill="#452c25"
      d="M342.6 198.1l1.4 1.9s-.5 1.8-5.1-1.7-4.4-3.2-4.4-3.2l2.6-.3 5.6 3.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M342.6 198.1l1.4 1.9s-.5 1.8-5.1-1.7-4.4-3.2-4.4-3.2l2.6-.3 5.6 3.2"
    />
    <path
      fill="#452c25"
      d="M336.6 199s2.2 2.9 1.7 3.2c-.5.4-3 .2-4.8-2.5-1.9-2.8 0-.2 0-.2v-4.4l3.2 3.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M336.6 199s2.2 2.9 1.7 3.2c-.5.4-3 .2-4.8-2.5-1.9-2.8 0-.2 0-.2v-4.4l3.2 3.8"
    />
    <path
      fill="#452c25"
      d="M338.8 197.8s2.1 2.6 1.9 3c-.2.4-3.2.2-5.5-2.5-2.3-2.6-.3-3.4-.3-3.4l3.9 2.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M338.8 197.7s2.1 2.7 1.9 3.1c-.2.4-3.2.2-5.5-2.5-2.3-2.6-.3-3.4-.3-3.4l4 2.8z"
    />
    <path
      fill="#452c25"
      d="M350.6 196.2s6 2.5 1.6 2.4c0 0-8.6-2.3-13-6.2l1.2-1.6 10.2 5.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M350.6 196.2s6 2.5 1.6 2.4c0 0-8.6-2.3-13-6.2l1.2-1.6 10.2 5.2"
    />
    <path
      fill="#452c25"
      d="M353.8 195.4s3.1 2 3.4 2.7c.2.8-10-1.9-15.3-6.3l2.4-1.2 9.4 4.8z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M353.8 195.4s3.1 2 3.4 2.7c.2.8-10-1.9-15.3-6.3l2.4-1.2 9.4 4.8z"
    />
    <path
      fill="#452c25"
      d="M344.5 197.2s2.3 1.9 2 2.1c-.3.2-5-.5-8.6-3.3l.4-1.7 6.2 2.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M344.5 197.2s2.3 1.9 2 2.1c-.3.2-5-.5-8.6-3.3l.4-1.7 6.2 2.8"
    />
    <path
      fill="#452c25"
      d="M348.4 197s2.3 1.6 1.8 1.8c-.4.1-2.2 1.6-10.7-3.4l-1-.6 1.3-2 8.6 4.1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M348.4 197s2.3 1.6 1.8 1.8c-.4.1-2.2 1.6-10.7-3.4l-1-.6 1.3-2 8.6 4.2z"
    />
    <path
      fill="#452c25"
      d="M339.7 192.4s2.8 2.4 2.4 2.8c-.4.4-3.6-.4-5-1.5-1.5-1-2.6-2.4-2.6-2.4l3-.7 2.2 1.8z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M339.7 192.4s2.8 2.4 2.4 2.8c-.4.4-3.6-.4-5-1.5-1.5-1-2.6-2.4-2.6-2.4l3-.7 2.2 1.8z"
    />
    <path
      fill="#452c25"
      d="M336.4 188.3l5 3s4.1 2.8 3.7 3.1c-.4.3-3.7-.8-6-2-2.2-1.3-5-4-5-4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M336.4 188.3l5 3s4.1 2.8 3.7 3.1c-.4.3-3.7-.8-6-2-2.2-1.3-5-4-5-4"
    />
    <path
      fill="#452c25"
      d="M333.2 202.4s1 2.4.4 2.6c-.6.3-2-.2-3-2.3-1.2-2.2 1-1.3 1-1.3l1.6 1z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M333.2 202.4s1 2.4.4 2.6c-.6.3-2-.2-3-2.3-1.2-2.2.7-1.3.7-1.3l2 1z"
    />
    <path
      fill="#452c25"
      d="M334.9 200.9s1.4 2.3 1.1 2.6c-.3.2-2.2 1-4.2-2s2.1-2.3 2.1-2.3l1 1.7z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M334.9 200.9s1.4 2.3 1.1 2.6c-.3.2-2.2 1-4.2-2s2.1-2.3 2.1-2.3l1 1.7z"
    />
    <path
      fill="#452c25"
      d="M330.7 190.4s4.8 9.3 4.4 9.8c-.4.5-2.3 0-3.4-2.5s-1.9-5.6-1.9-5.6l.9-1.7z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M330.7 190.4s4.8 9.3 4.4 9.8c-.4.5-2.3 0-3.4-2.5s-1.9-5.6-1.9-5.6l.9-1.7z"
    />
    <path
      fill="#452c25"
      d="M336.3 192.8s4 3.3 3.2 3.8c-.8.4-2.4-.2-4.8-2.5-2.3-2.3 1.6-1.5 1.6-1.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M336.3 192.7s4 3.5 3.2 3.9c-.9.4-2.5-.2-4.8-2.5s1.6-1.4 1.6-1.4z"
    />
    <path
      fill="#452c25"
      d="M334.4 192.8s2.8 5.3 2.5 5.8c-.4.5-2.5-1.3-3.6-2.7-1-1.3-1.9-3.3-1.9-3.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M334.4 192.8s2.8 5.3 2.5 5.8c-.4.5-2.5-1.3-3.6-2.7-1-1.3-1.9-3.3-1.9-3.3"
    />
    <path
      fill="#452c25"
      d="M312.9 203.6s-.2 3.1 0 3.3c.2.3 1.7.3 1.8-2 .1-2.4-.3-2.5-.3-2.5l-1.5 1.1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M312.9 203.6s-.2 3.1 0 3.3c.2.3 1.7.3 1.8-2 .1-2.4-.3-2.5-.3-2.5l-1.5 1.1"
    />
    <path
      fill="#452c25"
      d="M313.8 199.9s-1 3.4 0 4.1c1 .7 1.9-3.4 2-4.3 0-1-2 .2-2 .2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M313.8 199.9s-1 3.4 0 4.1c1 .7 1.9-3.4 2-4.3 0-1-2 .2-2 .2z"
    />
    <path
      fill="#452c25"
      d="M314.6 204.3s.2 3.2.8 3.4c.6.1 1.6-1 1.6-1.8s-1-2.8-1-2.8l-1.4 1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M314.6 204.3s.2 3.2.8 3.4c.6.1 1.6-1 1.6-1.8s-1-2.8-1-2.8l-1.4 1"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M314.6 200.4s-1 3.5 0 4.2c1 .7 1.9-3.4 2-4.4 0-.9-2 .2-2 .2z"
    />
    <path
      fill="#452c25"
      d="M314.7 194.8s-1.6 1.7-1.6 2.6c0 1 2.4-1.2 2.6-1.6.2-.4-1-1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M314.7 194.8s-1.6 1.7-1.6 2.6c0 1 2.4-1.2 2.6-1.6.2-.4-1-1-1-1z"
    />
    <path
      fill="#452c25"
      d="M313.6 194s-1.3 2.3-1 3c.4.8 1.6-.5 2.2-1.4.6-.8-1.2-1.7-1.2-1.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M313.6 194s-1.3 2.3-1 3c.4.8 1.6-.5 2.2-1.4.6-.8-1.2-1.7-1.2-1.7z"
    />
    <path
      fill="#452c25"
      d="M331.5 190.8s2 3.8 1.5 4c-.6.2-1.4-.7-2.3-1.9-.8-1.1.8-2.1.8-2.1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M331.5 190.8s2 3.8 1.5 4c-.6.2-1.4-.7-2.3-1.9-.8-1.1.8-2.1.8-2.1z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M331.6 198.6s.7 3.3 0 3.6c-1.2.5-2-2.3-2-3.4 0-1.2 2-.2 2-.2zm-2.6 5.1s.2 2.5-.2 2.7c-.3.2-1.2.2-2.1-1.8-1-2-.5-1.2-.5-1.2l2.3-1.2.5 1.3"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M331.4 203.2s.2 2.5-.3 2.6c-.5 0-1.9-.8-2.5-2.3-.6-1.8 2.4-1.3 2.4-1.3l.4 1z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M329 195.3s2.6 6 2.1 6.7c-.8 1.7-3.2-3.5-3.9-5.6-.8-2.2 1.7-1 1.7-1z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M327.7 196.3s3.6 6.5 2.1 6.6c-1.5.2-4.3-4.6-4.7-5.8-.5-1 2.6-.8 2.6-.8z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M327.5 197.7s1.8 6.2.6 5.6c-1-.5-2.5-5.2-2.6-6.2-.2-1 2 .6 2 .6zm6.2-8.8s2.7 4.1 1.8 4.2c-.8.2-4-2.7-4-3.2-.1-.5 2.2-1 2.2-1z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M332 189s3.5 4.8 2.4 5c-1 .2-1.1-.5-1.1-.5s-2.8-2.5-3-3.1c-.1-.6 1.6-1.4 1.6-1.4m3.5.1s2.4 2.5 1.8 3.3c-.6.8-4-3.1-4.4-3.6-.4-.5 2.9.2 2.9.2m-6 3.5s3.8 7.5 3 8.2c-.6.8-4.9-5.6-5-6.5-.2-.9 2-1.8 2-1.8"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M327.5 193.2s1.5 2.3 1.4 3.6c0 1.2-2.3-1.8-2.5-2.4-.2-.6 1-1.2 1-1.2zm3.1-1.2s1.2 2.4.8 3.1c-.3.8-2-1.4-2.5-2.3-.6-.8 1.7-.8 1.7-.8z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.2}
      d="M325 194.4s2 2 1.9 3.1c-.1 1.1-2.8-1.6-3-2-.3-.6 1.2-1.1 1.2-1.1z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M337.2 188.4s2.8 2.5 2.4 3c-.5.3-4.3-2.4-4.9-3-.6-.5 2.5 0 2.5 0z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M334.8 188.2l2.2 1.9s2 1.3 1.7 1.7c-.3.3-3.6-1.1-4.1-1.8-.6-.7-.6-1.4-.6-1.4l.8-.4zm7.3.6s8.4 3.4 8 4.2c-.3.8-8.8-2.7-10-3.7-1.4-.9 1.8-.6 1.8-.6"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M342.4 189.8s6.3 3.6 5.5 4c-.7.3-5.2-1-7.5-2.5a36.6 36.6 0 0 1-3.3-2.5l2.8-.6 2.5 1.7zm-15.5 4.4s1.2 2.4.8 3c-.4.8-1.5-.5-2.1-1.4-.6-.8 1.3-1.6 1.3-1.6zm.3 5.4s1 3.5-.1 4.2c-1.1.6-1.8-3.6-1.8-4.5 0-.9 1.9.3 1.9.3z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M322.3 193.8s3.5-1.5 4.1-1.4c0 0 .8-.2 1.1-.5l1.3-1s-.6-4.3 3.9-3.8l11.5 1.1a45 45 0 0 1 6.5 2l9 3.9a30 30 0 0 1 4 2.3c.8.5-.1.1-.1.1s-10.7-5.7-14.5-6.4c-1-.2 0 1 0 1l-3.4-1.3a6 6 0 0 0-2.9-.6 5.8 5.8 0 0 1-2.2-.3c-.6-.2-3.8-.3-4.4-.4a7.3 7.3 0 0 1-1-.2l.3.4-1.6-.2-.5.6s-1.5.3-1.6-.2c-.1-.4-1 2.3-1.3 3-.4.9-1.9.9-2.3 1.4l-1 .9c-.2.1-1.3.8-1.7.8l-2.9.2-.6-1 .3-.4zm4.6 10l-.1 3.3c-.2.2-1.8.1-1.8-2.2s.5-2.4.5-2.4l1.5 1.2"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M327.3 201.4s-.3-1.4-.5-1.6c-.3-.2 0-.3 0-.3s-.5-1.4-.9-1.6c-.3-.2.1-.4.1-.4s-.6-1-1-1.2c-.4-.3 0-.4 0-.4s-.5-1.2-1.5-1.8c0 0-.7-.7-1.4-.9-.7-.2-2.4-.4-4.5-.3-2.2 0-3.2 1.5-3.2 1.5l-.1 1.8.3-.2-.5 2.2c0 .5.5 1.4.5 2.5v1c.1 1 .4 2 .8 2.9v.2c.2-.2.5.6.7 1 0 0 0 1 .2.6l.6 1.1c0 .2.5 1.4.5.9 0-.6.4 1.3.4 1.5l.5-.7.2.8h.5l-.2.8s1.2-1 1.3-1.4v-.6l.4-.4.6-1s1.5 1.2 1.7 1.7l.3.7.4-.3.3.8.3-.4.2.6.1.3c.1.1.4.2.8-.6.6-1 .6-1.9.6-2 0-.3.3.2.3.2s.6-1 .5-1.6c0-.7.3-.4.3-.4v-2.2c0-.4.3-.3.3-.3l-.2-2.3c-.2-.2.3-.2.3-.2z"
    />
    <path d="M324.3 196.7c.3 0 .4.4.6.6-.1-.4-.3-.7-.6-.8v.2m.3 1.2c.5.5.6 1.1.5 1.8v.1c0-.7 0-1.5-.5-2v.1m1.1.7a3 3 0 0 1 .4 1.6c0-.6 0-1.2-.4-1.7m.4 2.5c0 .4 0 .7-.2 1a.4.4 0 0 0 0 .2 11 11 0 0 0 .2-1.2m-.4 1.9v.7a3.8 3.8 0 0 0 0-.8m.7 0c.2.1.3.3.3.6a.4.4 0 0 0 0-.1 1.2 1.2 0 0 0-.3-.7v.2m0-2.6l.4.5v-.2a3.1 3.1 0 0 0-.5-.5v.2m-1.4 2a5.9 5.9 0 0 1 0 1 6.6 6.6 0 0 0 0-1m-.7.7a5.2 5.2 0 0 1 0 1 6.2 6.2 0 0 0 0-1.1v.1" />
    <path
      fill="#452c25"
      d="M310.7 194.3s-.8 3.2-.2 3.5c1.3.7 2-2.2 2.2-3.2.1-1.2-2-.3-2-.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M310.7 194.3s-.8 3.2-.2 3.5c1.3.7 2-2.2 2.2-3.2.1-1.2-2-.3-2-.3z"
    />
    <path
      fill="#452c25"
      d="M312.6 194.3s-1.6 1.7-1.6 2.6c0 1 2.4-1.3 2.6-1.7.2-.4-1-.9-1-.9"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M312.6 194.3s-1.6 1.7-1.6 2.6c0 1 2.4-1.3 2.6-1.7.2-.4-1-.9-1-.9z"
    />
    <path
      fill="#452c25"
      d="M285 194.5s-3.3 1.7-3.6 2.4c-.3.7 10-1 15.8-5l-2.3-1.4-9.8 4z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M285 194.5s-3.3 1.7-3.6 2.4c-.3.7 10-1 15.8-5l-2.3-1.4-9.8 4z"
    />
    <path
      fill="#452c25"
      d="M289 195.2s-6 2.2-1.7 2.3c0 0 8.7-1.8 13.3-5.4l-1.1-1.7-10.5 4.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M289 195.1s-6 2.3-1.7 2.4c0 0 8.7-1.8 13.3-5.4l-1.1-1.7-10.5 4.7z"
    />
    <path
      fill="#452c25"
      d="M298 189s-6.5 3.4-5.8 3.7c.7.4 5.3-.6 7.7-2l3.4-2.4-2.9-.8-2.5 1.6z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M298 189s-6.5 3.4-5.8 3.7c.7.4 5.3-.6 7.7-2l3.4-2.4-2.9-.8-2.5 1.6z"
    />
    <path
      fill="#452c25"
      d="M295.5 196.3s-2.3 1.9-2 2.1c.2.2 5-.5 8.6-3.4l-.5-1.7-6.2 2.9"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M295.5 196.3s-2.3 1.9-2 2.1c.2.2 5-.5 8.6-3.4l-.5-1.7-6.2 2.9"
    />
    <path
      fill="#452c25"
      d="M291.5 196s-2.2 1.7-1.7 1.8c.5.1 2.3 1.5 10.6-3.9l1-.6-1.5-2-8.4 4.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M291.5 196s-2.2 1.7-1.7 1.8c.5.1 2.3 1.5 10.6-3.9l1-.6-1.5-2-8.4 4.6z"
    />
    <path
      fill="#452c25"
      d="M289.8 189.6a66 66 0 0 0-13.9 7.2l17.9-7m11.2 10.6s-1.5 2.3-1.2 2.5c.3.3 2.1 1.2 4.3-1.7 2-3-2-2.5-2-2.5l-1.1 1.7z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M305 200.4s-1.5 2.3-1.2 2.5c.3.3 2.1 1.2 4.3-1.7 2-3-2-2.5-2-2.5l-1.1 1.7z"
    />
    <path
      fill="#452c25"
      d="M306.6 202s-1 2.4-.5 2.6c.6.3 2-.1 3.2-2.2 1.2-2.2-.6-1.1-.6-1.1l-2 .7zm-3.3-3.5s-2.2 2.7-1.7 3.1c.4.4 3 .3 4.9-2.4 1.9-2.6 0 0 0 0l-.5-2.5-2.7 1.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M306.6 202s-1 2.4-.5 2.6c.6.3 2-.1 3.2-2.2 1.2-2.2-.6-1.1-.6-1.1l-2 .7zm-3.3-3.5s-2.2 2.7-1.7 3.1c.4.4 3 .3 4.9-2.4 1.9-2.6 0 0 0 0l-.5-2.5-2.7 1.7"
    />
    <path
      fill="#452c25"
      d="M301.2 197.1s-2.2 2.6-2 3c.2.5 3.2.3 5.6-2.2s.5-3.5.5-3.5l-4 2.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M301.2 197.1s-2.2 2.6-2 3c.2.5 3.2.3 5.6-2.2s.5-3.5.5-3.5l-4 2.6"
    />
    <path
      fill="#452c25"
      d="M297.4 197.3l-1.4 1.9s.3 1.8 5.1-1.5l4.5-3-2.5-.5-5.8 3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M297.3 197.2l-1.3 2s.3 1.8 5.1-1.5l4.5-3-2.6-.5-5.7 3z"
    />
    <path
      fill="#452c25"
      d="M282.2 194.5l-3 1.3s-.7.6 1 .7c1.8 0 5.5-.5 11.9-4 2.8-1.7 4.7-3.3 4.7-3.3l-2.4-.8-12.2 6z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M282.2 194.5l-3 1.3s-.7.6 1 .7c1.8 0 5.5-.5 11.9-4 2.8-1.7 4.7-3.3 4.7-3.3l-2.4-.8-12.2 6z"
    />
    <path
      fill="#452c25"
      d="M277 196.4s4.4-.5 6-1.6c0 0-.3.5 2-.4 0 0-1.2 2 5.3-2 6.5-3.8 0 0 0 0l7.2-4.1-.4-.8-14.7 6.2c-1 .3-5.4 2.7-5.4 2.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M290.3 192.4l7.2-4.1-.4-.8-14.7 6.2c-1 .3-5.4 2.7-5.4 2.7s4.4-.5 6-1.6c0 0-.3.5 2-.4 0 0-1.1 2 5.3-2z"
    />
    <path
      fill="#452c25"
      d="M308.5 202s-.4 3.4.1 3.5c.5.1 2-1 2.6-3 .6-2.2-2.4-2-2.4-2l-.4 1.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.2}
      d="M308.5 202s-.4 3.4.1 3.5c.5.1 2-1 2.6-3 .6-2.2-2.4-2-2.4-2l-.4 1.3"
    />
    <path
      fill="#452c25"
      d="M310.8 203.5s-.3 2.4 0 2.6c.4.3 1.3.4 2.3-1.6 1-2 .5-1.3.5-1.3l-2.3-1.2-.5 1.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M310.8 203.4s-.3 2.5 0 2.7c.4.3 1.3.4 2.3-1.6 1-2 .5-1.3.5-1.3l-2.3-1.2-.5 1.4z"
    />
    <path
      fill="#452c25"
      d="M311.4 199s-1.9 4-.8 4c1 0 2.5-3 2.7-3.7.2-.7-1.9-.3-1.9-.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M311.4 199s-1.9 4-.8 4c1 0 2.5-3 2.7-3.7.2-.7-1.9-.3-1.9-.3z"
    />
    <path
      fill="#452c25"
      d="M311.3 199s-.8 4.5.2 4c1-.3 1.6-3.7 1.7-4.4 0-.7-2 .4-2 .4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M311.3 199s-.8 4.5.2 4c1-.3 1.6-3.7 1.7-4.4 0-.7-2 .4-2 .4z"
    />
    <path
      fill="#452c25"
      d="M312.8 199.4s-1.1 3.5 0 4.2c1 .7 1.8-3.4 1.9-4.3 0-1-2 .1-2 .1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M312.8 199.4s-1.1 3.5 0 4.2c1 .7 1.8-3.4 1.9-4.3 0-1-2 .1-2 .1z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M308.4 198.3s-1 3.2-.4 3.5c1.2.6 2.3-2.2 2.4-3.3.1-1.2-2-.2-2-.2zm-7.9-6.6s-2.8 2.4-2.5 2.7c.3.4 3.6-.2 5.1-1.3l2.1-1.5-2.5-1.6-2.2 1.7z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M303 189.3s-1.8 1.5-1.5 1.9c.4.3 3.6-1 4.2-1.7.6-.6.6-1.3.6-1.3l-3.3 1.1z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M304.9 189s-2.5 2.1-1.9 2.9c.6.7 4-2.6 4.5-3 .5-.4-2.9 0-2.9 0"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M303.8 188.2l-5 2.3s-4.2 2.7-3.8 3c.4.3 3.7-.6 6-1.7a37.9 37.9 0 0 0 5-3.1m-.9 2.1s-5.3 4.7-4.5 5.1c.8.5 4.4-1.4 6.8-3.7"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M305.8 192.4s-3 5-2.7 5.6c.4.5 2.6-1.2 3.7-2.5s2-3.2 2-3.2"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M307.6 192.8s-3.3 6.1-3 6.6c.4.5 2.4.1 3.5-2.3 1.2-2.4 1-4 1-4l-1.5-.3z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M309.5 193.1s-3.7 7.6-3 8.3c.8.8 4.8-5.7 5-6.6.3-1.6-2-1.8-2-1.8m-7.7-4.9s-3.3 1.6-2.7 2c.7.2 3.8-1.2 4.2-1.3.5-.1-1.5-.7-1.5-.7z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M302.3 188.6s-2 1.6-1.6 2c.4.5 3.5-1.2 4-1.7.7-.5-2.4-.3-2.4-.3zm4.3.2s-2.8 3.7-2 3.8c.9.2 4.1-2.4 4.2-2.8 0-.5-2.2-1-2.2-1z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M307.8 189.6s-3 3.7-2.1 4c.8.2 1-.4 1-.4s2.3-2 2.4-2.5c.2-.5-1.2-1.2-1.2-1.2"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M308.7 190.5s-2.1 3.7-1.6 4c.6.2 1.5-.8 2.4-1.9.9-1-.8-2.1-.8-2.1z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M309.3 192.2s-1.3 2.3-1 3c.4.8 1.6-.5 2.2-1.3.6-.8-1.2-1.7-1.2-1.7zm.5 6.5s-.8 3.2-.2 3.5c1.3.7 2-2.2 2.2-3.2.1-1.2-2-.3-2-.3z"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M315.7 194.4s-.9-.3-1.5-.3c0 0-1.9-1.4-3-1.6-1-.1 0-.2 0-.2s-.2-2.4-.5-2.6c0 0-.1-2.5-1.7-2.6-1.6-.2-5.1.1-5.7-.1-.7-.3-2.6-1-6.3 0-3.8 1-11.2 4.3-11.6 4.4-.4 0 8.5-2 11-3l3.3-.5s-2.8 1.4-.2.8c2.6-.6 2 0 2 0s-.2.6 1.3.3c1.4-.4 1.4 0 1.4 0s1.7.6 3-.2c0 0 .7 2.3 1.6 2.6 0 0 1 2.2 3.1 2.6l1.2.9 1.2.4 1.3-1"
    />
    <path
      fill="#452c25"
      stroke="#000"
      strokeWidth={0.1}
      d="M298.3 188s-8.6 3-8.3 3.9c.4.8 9-2.4 10.3-3.2 1.4-1-2-.7-2-.7"
    />
    <path d="M321.8 194.6l.5.2a1.5 1.5 0 0 0-.3-.3l-.7-.3.1.2.4.2M315 201c.2.2.2.5.3.8v-.2c-.1-.2-.1-.5-.3-.7v.1m1.2-6.5l.9-.2v-.1l-.9.1v.2m1.7-.2l.8-.1a.3.3 0 0 0 0-.1 2 2 0 0 0-.8.1v.1m-3 1.5a.3.3 0 0 0 0 .2v-.2m-.1 4.6a4.8 4.8 0 0 0 0 .7.4.4 0 0 0 0-.1v-.6" />
    <path
      fill="#bd8759"
      d="M316.6 213.9s-1 .7-1 1a3.8 3.8 0 0 0-.2.8s.8-.1.7.3c0 0 .3.2.8-.8.4-1 .8-1.5 1.1-1.5.4 0 .8.4 1 .6.2.2.4.4.8.3 0 0-.4-.6-.2-.7l.6-.1s-.3-.7-.9-.8c-.6-.1-1-.3-1-.6.2-.2 1-2.4 1-2.4l-1-1.5-.5 1.3.2 1-1 2.1c0 .1-2.4 1-2.7 1l-.8.9v.5s.3-.4.4-.2c0 0 .3-.3.6-.2.2.1.1.2.1.2l.5-.4.1-.1.6-.1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M316.6 213.9s-1 .7-1 1a3.8 3.8 0 0 0-.2.8s.8-.1.7.3c0 0 .3.2.8-.8.4-1 .8-1.5 1.1-1.5.4 0 .8.4 1 .6.2.2.4.4.8.3 0 0-.4-.6-.2-.7l.6-.1s-.3-.7-.9-.8c-.6-.1-1-.3-1-.6.2-.2 1-2.4 1-2.4l-1-1.5-.5 1.3.2 1-1 2.1c0 .1-2.4 1-2.7 1l-.8.9v.5s.3-.4.4-.2c0 0 .3-.3.6-.2.2.1.1.2.1.2l.5-.4.1-.1.6-.1"
    />
    <path
      fill="#bd8759"
      d="M323.1 209.2v2.1c0 .3 0 .8-.2 1.1-.2.3-.4.5-.7.5-.3 0-1 0-1.2.3l-.3.4s.5-.3.6 0l-.2.6.9-.2.8-.3.4.2v1c0 .4 0 1.2.3 1.2l.4-.5.5.5-.1-1.2a6.7 6.7 0 0 1-.3-1l1.5.6c0 .2.4.5.5.5.1 0 0-.5.2-.5.3-.1.4 0 .4 0s-.4-.8-1-1c-.5-.4-1-.4-1.2-.6l-.3-.9v-2.8l-1-.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M323.1 209v2.3c0 .3 0 .8-.2 1.1-.2.3-.4.5-.7.5-.3 0-1 0-1.2.3l-.3.4s.5-.3.6 0l-.2.6.9-.2.8-.3.4.2v1c0 .4 0 1.2.3 1.2l.4-.5.5.5-.1-1.2-.3-1s1.4.5 1.5.7l.5.4c.1 0 0-.5.2-.5.3-.1.4 0 .4 0s-.4-.8-1-1c-.5-.4-1-.4-1.2-.6l-.3-.9v-2.8l-1-.2z"
    />
    <path
      fill="#dcddde"
      d="M315 197.3s0-1.3.3-1.4c0 0 .1-1.2 1.7-1 0 0 .5-.9 1.4-.4 0 0 .8-.4 1.3-.2l1 .7s.7-.1 1 .1c.3.3.2 1.1.2 1.1s.8.6.8 1.1v.9s.3.3.2.7c0 .4-.4 1-.4 1-.1 0 0 1-.3 1.3l-.8.5c-.2 0-.6.6-1 .6-.3 0-.8-.5-.8-.7 0-.2-.6-.4-.6-.4s-1 1.2-1.8 1c-.8-.2-1.1-.8-1.2-1l-.3-1s-.8-.4-.7-.9c0-.4.4-1 .4-1l-.3-1z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M317.8 212l-.2-.1m.6-.9a.8.8 0 0 1-.3-.1m0 .6h.2m5.5.5l.5.2m-.2-.6h-.3m.4-.5a.9.9 0 0 1-.5 0m0 1.8l.4.1m-.4.5a.2.2 0 0 1 .2 0m-.1 1.6a.4.4 0 0 1 .3 0m-5.1-2a.3.3 0 0 0-.3.1m1-.1c-.1.1-.3.2-.3.4m-4.5.5l.4.3m10-1a.3.3 0 0 0-.3.3m.7-.1a.2.2 0 0 0 0 .2"
    />
    <path fill="#d9c0b9" d="M313.4 215h.6s-.3.7-.2.8c0 .2-.5-.3-.3-.7" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M313.4 215h.6s-.3.7-.2.8c0 .2-.5-.3-.3-.7z"
    />
    <path fill="#d9c0b9" d="M315.6 215.5s-.7 1 .1 1.5c0 0 0-1 .6-1.1l-.8-.4z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M315.6 215.5s-.7 1 .1 1.5c0 0 0-1 .6-1.1l-.8-.4z"
    />
    <path
      fill="#d9c0b9"
      d="M319.6 214.5l-.2-.5.2-.3h.6s.4.9 0 1.3c0 0 0-.5-.2-.5h-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M319.6 214.5l-.2-.5.2-.3h.6s.4.9 0 1.3c0 0 0-.5-.2-.5h-.4z"
    />
    <path
      fill="#d9c0b9"
      d="M321 213.4h.3l.1.3v.3l-.3.2s-.5-.2-.4.5c0 0-.3-1.2.2-1.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M321 213.4h.3l.1.3v.3l-.3.2s-.5-.2-.4.5c0 0-.3-1.2.2-1.3z"
    />
    <path fill="#d9c0b9" d="M323.5 215.9l.4-.4.4.2-.3 1.2-.2-.3-.3-.7" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M323.5 215.9l.4-.4.4.2-.3 1.2-.2-.3-.3-.7z"
    />
    <path fill="#d9c0b9" d="M326 214.8l.5 1s.6-.6-.2-1.5l-.4.5z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M326 214.8l.5 1s.6-.6-.2-1.5l-.4.5z"
    />
    <path d="M323.3 195.9l.2.2v-.1l-.2-.2m.1 2.2l.4.7v-.2a1.7 1.7 0 0 0-.4-.7v.2m-.4-1.6l.5.6v-.2l-.5-.5v.1m.5 3.5c0 .3 0 .6-.2.8v.2c.2-.4.2-.7.2-1.1a.5.5 0 0 0 0 .1m.5 1v.5a.4.4 0 0 0 0 .1 2.2 2.2 0 0 0 0-.6m1.8 3.9a4.8 4.8 0 0 1 .1 1.3l-.1-1.5v.2m-.3.8l-.4 1 .4-.8v-.2m-10.3-2.9l.7 1.2v-.1l-.7-1.2v.1m1.8 0c-.2 0-.3-.3-.5-.4v.2c.2 0 .3.4.5.4v-.2m-1 1.8l.5 1v-.2l-.5-1v.2m1.2.4l.5.8v-.1c0-.3-.3-.6-.5-.8m0 1.3l.2.7v-.1l-.3-.7v.1m1.1.3a2.8 2.8 0 0 1 .1.7 3.3 3.3 0 0 0 0-.9v.2m-.5 1c0 .3.1.7.3 1v-.2a3.2 3.2 0 0 1-.3-.9.4.4 0 0 0 0 .1m.2-4.4l.8.3v-.1a8 8 0 0 1-.8-.3v.1m.2 1.2l1 .4c-.3-.3-.7-.4-1-.6v.2m.3 1.2l.6.6v-.1a4.5 4.5 0 0 1-.6-.6v.1m.4 1.6l.2.7a1.8 1.8 0 0 0-.2-.8v.1m1-4v.5a10 10 0 0 1 0-.5m2.3-.9a3.6 3.6 0 0 1-.2.5v.1l.2-.4v-.2m1 0v.8a.4.4 0 0 0 0 .1 4.2 4.2 0 0 0 0-1m.2 1.6v.7a3.7 3.7 0 0 0 0-.8m.7 1.5c0 .3-.2.6-.5.8v.1c.3-.2.5-.4.5-.8m-2.4-1.5l-.2.4v.1l.2-.4m.3 1.8a1.9 1.9 0 0 1-.4.4v.1c.2 0 .3-.2.4-.3v-.1m-.9 1c-.3-.4-.4-.8-.3-1.3v-.1c-.2.5 0 1 .3 1.5v-.2m-1-1l-.1.5v-.6m2.6 1.3c0 .3-.2.5-.3.7v.1l.3-.6v-.2m1.7.7a9.2 9.2 0 0 1-.5.7v.2l.5-.8m.8.8a17 17 0 0 0-.2 1.3v.1l.2-1.3a.6.6 0 0 0 0-.1m1-1.6v.5-.5M315 202l.1 1.3v-.2a2.2 2.2 0 0 1-.1-1 .6.6 0 0 0 0-.1" />
    <path
      fill="#fff"
      d="M318.8 196.3c.7-.6 1.7-1.3 2.7-1v-.2c-1-.2-2 .5-2.7 1.1v.1m3.5.8c-.8-.5-2-.6-2.7 0 .7-.5 2-.3 2.7.2v-.2m-2.8 1.1c.3 1 .7 2 .5 3 .2-1-.2-2-.5-3m-1.1.6v3c0-1 .2-2 0-3.1a.4.4 0 0 0 0 .1m1.5-.7c1 .2 1.9.9 2.4 1.7v-.1a3.9 3.9 0 0 0-2.4-1.7v.1m-.8 1.3c0 .6 0 1.2-.2 1.8.2-.5.2-1.2.2-1.8m1.4-.1a3.1 3.1 0 0 1 1.2 2v-.1a3.2 3.2 0 0 0-1.2-2m-4.3 1.7c.2-.3.4-.6.8-.7v-.1c-.4 0-.6.4-.8.7v.1m1.4-5c-.1-.6-.5-1-1-1.2v.1c.5.3.9.6 1 1.2v-.2m-.8 0c-.5-.2-1-.2-1.5-.2a.3.3 0 0 0 0 .1c.5 0 1 0 1.5.3v-.2m1.5 0c0-.6 0-1-.4-1.3.3.3.5.7.4 1.2m1.8.7c.5-.3 1-.2 1.5-.2v-.2c-.5 0-1 0-1.5.2v.2m.9 1.2a2.6 2.6 0 0 1 1.7 1v-.3a2.6 2.6 0 0 0-1.7-1v.3m-3.1 2c-.2.6 0 1.5-.9 1.8v.2c.8-.3.7-1.1.9-1.8v-.3"
    />
    <path
      fill="#fff"
      d="M319.5 199c.3.7.7 1.4.5 2.2a.9.9 0 0 0 0 .3c.2-1-.1-1.8-.5-2.7v.2m1-.1c.7 0 1.3.7 1.4 1.4a1 1 0 0 0 0-.2 1.7 1.7 0 0 0-1.4-1.5v.3m0 1c.1.6.3 1.2.1 1.8v.2c.3-.7 0-1.5 0-2.2a1 1 0 0 0 0 .2m-.4-2.6c.7-.1 1.5-.2 2.2.3v-.3c-.7-.5-1.5-.4-2.2-.2v.2m-1.4-1.5c0-.6.6-1 1.2-1.3v-.2c-.6.2-1.2.6-1.3 1.3a1 1 0 0 0 0 .2m-.6.4c0-.7-.4-1.3-.7-1.9v.2c.3.6.6 1.1.6 1.8v-.1m-.6.4a2 2 0 0 0-1-1.4v.3c.5.3.9.7 1 1.3a.8.8 0 0 0 0-.2m-1-.3a2.9 2.9 0 0 0-1.2-.5v.2c.5 0 .8.3 1.2.5v-.2m2.2 3c0 .6.2 1.3-.2 1.9v.2c.4-.7.3-1.6.2-2.3v.1"
    />
    <path
      fill="#fff"
      d="M319.4 198.9c.2.6.5 1.3.4 2a5.8 5.8 0 0 0-.4-2.3v.3m.5-1c.6.3 1.3.5 1.7 1v-.3a3.6 3.6 0 0 0-1.7-.9v.3m-1.7-1.4a14.8 14.8 0 0 0 0-1.7 11.8 11.8 0 0 1 0 1.7m-1.2-.4a5.6 5.6 0 0 1-1.2-.8v.2l1.2.9v-.3m-.2 3.3c-.3.2-.5.5-.6.8v.2a1.6 1.6 0 0 1 .6-.7v-.3m.9.5c0 .5-.3.9-.6 1.2v.2c.4-.4.6-.8.6-1.3 0 0 0-.3 0 0m2.1-3.6c.4-.6 1.3-.7 1.9-.9v-.2c-.6.2-1.5.2-2 .8v.3m-4 0a2 2 0 0 1-.5-.3v.2l.4.2v-.2m.1 3l-.4.3v.1a.7.7 0 0 0 0 .1.8.8 0 0 1 .4-.2.7.7 0 0 0 0-.2m.5.1l-.6.6v.2l.6-.6v-.2m1 .3c-.1.6-.8 1.2-.3 1.8v-.2c-.3-.5.2-1 .4-1.4v-.2m.7 0c0 .6 0 1.1-.2 1.7a.9.9 0 0 0 0 .2 9.8 9.8 0 0 0 .2-2m1.9-.6c.4.5.8 1.1 1 1.8v-.2a5 5 0 0 0-1-1.9v.3m.2-.5c.7.6 1.5 1 2 1.8v-.2c-.5-.8-1.3-1.3-2-1.8v.2"
    />
    <path
      fill="#fff"
      d="M320.5 197.8h.8l.6.5.6.4c.2.2.2.6.3.9a.7.7 0 0 0 0-.2l-.2-.7c0-.2-.3-.4-.5-.5l-.7-.4a1.4 1.4 0 0 0-.9-.2v.2"
    />
    <path
      fill="#fff"
      d="M322.3 199.3l.2.6v-.1l-.2-.7v.2m-2-3.6l1.5-.4v-.3l-1.5.4v.3m-2 .2c0-.2.1-.5.3-.7l.4-.8v-.3l-.4.7c0 .3-.3.5-.4.9v.2m-1.7 4.6l.1 1.3v-.2a1.4 1.4 0 0 1 0-.8.7.7 0 0 0 0-.2s0-.1 0 0m1 .7c-.2.3-.2.6-.1 1a.3.3 0 0 0 0-.2v-.7m.8-.5l-.2.7v.2l.2-.8s0-.2 0 0m0-1.5v.4-.5.1m-.3.2v.1a.7.7 0 0 0 0 .3v-.7.4m-.5-.2l-.1.5a.8.8 0 0 0 0 .2 3.3 3.3 0 0 1 .1-.4v-.2m-.4 0l-.8.6v.3l.8-.7v-.2m-.6 0a1.6 1.6 0 0 1-.5.3v.3c.2 0 .3-.2.5-.3v-.2m-1-.3l-.4.2v.2c.2 0 .3 0 .4-.2v-.2m2.9 0v.4a.8.8 0 0 0 0-.2v-.4.1m.4-.2l.1.6v-.3a1 1 0 0 1 0-.3v-.1.1m.3 0v.3h.1a.8.8 0 0 0-.1-.6v.2m.4-.2l.4.2v-.2a.8.8 0 0 0-.4-.2v.2m.2-.3l.6.3v-.3a1.2 1.2 0 0 1-.6-.3v.2m.5-1h.4v-.2a2.3 2.3 0 0 0-.4-.1v.3m-.3-.6l.4-.3v-.3l-.4.4v.2m-.4-.5a1 1 0 0 1 .2-.5v-.2a1 1 0 0 0-.2.7m-.3-.2l.4-.8v-.2l-.4.7v.2"
    />
    <path
      fill="#fff"
      d="M318.6 195.3v.9a.7.7 0 0 0 0-.3 3.7 3.7 0 0 1 0-.7v.1m-1.3.2l.2.3v.6l.1-.5-.3-.6v.2m-.2.5a4.5 4.5 0 0 0-.6-.4v.2l.6.5v-.2m.8.2c0-.6 0-1.2-.2-1.7v.3c.2.4.3.7.2 1.2a.8.8 0 0 0 0 .1m1.2-.7v-.2.2"
    />
    <path
      fill="#fff"
      d="M317.7 196.3l.2-1v-.2l-.2 1v.2m3.5 2c.3 0 .6.3.7.6v-.4c-.1-.3-.4-.5-.7-.6v.4m-1 2a1 1 0 0 1 0 .4 1.2 1.2 0 0 0 0 .3h.1v-1 .3m-.8-.5v1.2s0 .2 0 0v-1.4.2m-.4.4l-.3 1.2a1 1 0 0 0 0 .3s0 .1 0 0l.3-1.2v-.3m.5.2v1.1a1.3 1.3 0 0 0 0 .3v-1.6.2m-2.6.2a.6.6 0 0 1 0 .1v.4c.1-.2.1-.6 0-.8 0-.1 0 0 0 0v.3m1.2-.8v.4c0-.3.1-.6 0-.8v.3m.3 0a.4.4 0 0 1 .1 0v.1a.8.8 0 0 0 0 .1v-.2l-.1-.5a1.3 1.3 0 0 0 0 .2v.2m.4-.3l.1.3v-.3l-.1-.4a.9.9 0 0 0 0 .1v.2m.8-.2l.5.6v-.4a9.3 9.3 0 0 1-.5-.6v.4m.5-.8l.3.6v-.4a4.1 4.1 0 0 1-.3-.5v.3m-4.3-2a1.7 1.7 0 0 0-.4-.2 1.1 1.1 0 0 0 0 .2v.2l.4.3v-.4m1.3-.5a.5.5 0 0 1 0 .1.8.8 0 0 0 0 .2v-.3a1 1 0 0 0 0-.4.8.8 0 0 0 0 .2v.2m1-1v.8c-.1 0-.1.1 0 .2v.1l.1-1.2a.6.6 0 0 0 0-.1v.2m.2 1.5l.5-.7v-.3l-.5.6v.4m.7 0l.2-.3v-.4l-.2.2a1.3 1.3 0 0 0 0 .2v.2m1 .2a7.6 7.6 0 0 1-.8 0v.4h.8v-.4m-.3.9l1 .6v-.4l-1-.6v.4"
    />
    <path
      fill="#fff"
      d="M320 198l.8.5v-.4l-.8-.5a2 2 0 0 0 0 .2v.2m-2-1.4l.1-.5v-.2.6m-2.3-1c.2.3.5.6.9.8l.6.7s.1-.4 0-.4l-.6-.6-1-.9c.1 0 0 .3 0 .4m.6 1a7.7 7.7 0 0 1-.4-.4 1.6 1.6 0 0 0 0 .2v.1l.4.5v-.3m-.3 2.5l-.3.6v.4l.3-.6v-.4m.3.4l-.1.6a1.3 1.3 0 0 0 0 .3l.1-.8v-.2a.6.6 0 0 0 0 .1m1 1.8c.2-.6.2-1.3.2-2v.2c0 .5 0 1-.2 1.4v.4m.6-1.5v.6a1.3 1.3 0 0 0 0 .3v-1.3a.6.6 0 0 0 0 .2v.2m.6-.2c.2.2.3.6.2 1v.1c.1-.5.1-1-.2-1.5v.4"
    />
    <path
      fill="#fff"
      d="M318.6 199.3a12.6 12.6 0 0 1 .3 1.7v-.3l-.2-1.7v.3m.5-.1l.6 1v-.3l-.6-1v.3m1.1-1c0-.1-.3-.2-.5-.1v.3c.2 0 .4 0 .5.2v-.3"
    />
    <path
      fill="#fff"
      d="M319.7 198.1a7.5 7.5 0 0 1 1.1 0v-.4a7.5 7.5 0 0 0-1 0c-.1 0 0 .4 0 .4m.6-3c-.3.4-.4.9-.5 1.3v.3s0 .1 0 0c0-.4.2-.8.5-1.1v-.5m-1.5.4l.2 1a.7.7 0 0 0 0-.2v-.2l-.2-1v.4m-.3.5a1.6 1.6 0 0 1-.3-.5.8.8 0 0 0 0 .2v.2l.2.5v-.3m-.5.2a4 4 0 0 1-1.2-.6v.4l1.2.6s.1-.4 0-.4"
    />
    <path
      fill="#dba05f"
      d="M318.5 196.2l-2.2.4-1.8.2-1.3-.4c-.3 0-1.6-.2-2 .3l-.9.8c-.1.1-.7.6-.7.9 0 .2.1.5.4.5.3 0 .9.6.9.7 0 .3.8.5 1.5.5 1.3 0 2-.7 4-.5 1 .2 3-.7 3.4-1.2.4-.5.6-1 .2-1.7-.3-.6-1.4-.5-1.5-.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M318.5 196.2l-2.2.4-1.8.2-1.3-.4c-.3 0-1.6-.2-2 .3l-.9.8c-.1.1-.7.6-.7.9 0 .2.1.5.4.5.3 0 .9.6.9.7 0 .3.8.5 1.5.5 1.3 0 2-.7 4-.5 1 .2 3-.7 3.4-1.2.4-.5.6-1 .2-1.7-.3-.6-1.4-.5-1.5-.5z"
    />
    <path d="M311.4 198.1v-.1l.1-.1.1-.2a.8.8 0 0 1 .4-.3h.5-.2.2-.2l-.3.1c-.3 0-.3.4-.6.6" />
    <path fill="none" d="M311.3 198l.4-.4.6-.3h.3" />
    <path fill="none" d="M312 197.4l-.4.3c0 .2-.3.3-.3.3m.7-.5h.5m-.6 0h.5" />
    <path d="M312.4 197.9v-.1l-.2.1-.1.1-.3.2-.3.1.4-.2-.4.2.4-.1-.3.1h.1s.3 0 .7-.4" />
    <path
      fill="none"
      d="M312.3 197.8l-.3.2-.3.2-.2.1m.4-.1l.2-.2.2-.2m-.4.4l-.3.1m.4-.1l-.3.1"
    />
    <path
      fill="#c6262c"
      d="M312.9 196.5s0-.6-.6-.8c-.5-.2-1-.2-1.3-.2l-.5.2a2.5 2.5 0 0 0-.6.2l-.1.2c-.1.2-.4.4-.3.6.2.3 0 .3.2.3s-1 .3-.8.8c.3.6.5.4.6.3l.5-.2.7-.7 1-.4h.5l.7-.3z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M312.9 196.5s0-.6-.6-.8c-.5-.2-1-.2-1.3-.2l-.5.2a2.5 2.5 0 0 0-.6.2l-.1.2c-.1.2-.4.4-.3.6.2.3 0 .3.2.3s-1 .3-.8.8c.3.6.5.4.6.3l.5-.2.7-.7 1-.4h.5l.7-.3z"
    />
    <path d="M312.2 197.8c0 .1-.1.3-.3.3h-.3s.1-.4.3-.4h.3" />
    <path
      fill="#d9c0b9"
      d="M308.6 200.2s-.7-1.2 1.2-1.8c0 0 .6.3.8.6 0 0-.4.5-1.5.7 0 0-.5.1-.5.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M308.6 200.2s-.7-1.2 1.2-1.8c0 0 .6.3.8.6 0 0-.4.5-1.5.7 0 0-.5.1-.5.5z"
    />
    <path
      fill="#d9c0b9"
      d="M308.8 200s.8.2 1.3-.2c.5-.3.6-.2.7-.1 0 0 0-.4-.2-.7l-1 .5c-.4.2-.7.1-.8.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M308.8 200s.8.2 1.3-.2c.5-.3.6-.2.7-.1 0 0 0-.4-.2-.7l-1 .5c-.4.2-.7.1-.8.5z"
    />
    <path
      fill="#7a2e26"
      d="M311 199.6h.5v-.1h-.5a.3.3 0 0 0 0 .1m-.3-2l-.1.2v.1l.1-.2v-.1m.5.2l.3-.2v-.1c-.2 0-.3 0-.3.2v.1m.5.8a.3.3 0 0 0 .2-.2.3.3 0 0 1-.2 0v.2m.4-.2a.8.8 0 0 0 .4-.3v-.1a.7.7 0 0 1-.4.3v.1m-.7-.7c0 .2-.2.2-.3.4v.1c0-.1.3-.2.3-.4m.3 2c.4 0 .7 0 1-.2a3.1 3.1 0 0 1-1 0v.2m1.6 0c.4-.4.8-.7 1-1.3a2 2 0 0 1-1 1v.2m.3-.8c.3-.2.5-.4.6-.8v-.1a1.6 1.6 0 0 1-.6.8v.1m-.2-2l.7.4v-.1l-.7-.4v.2m6.3 1c.2-.5 0-1-.2-1.4.2.4.4.8.2 1.2v.2m-4.8-.7c.3.2 1 .7.8 1.2.3-.5-.4-1-.8-1.3v.1m2.1 2a1.4 1.4 0 0 0 .1-.3 1.3 1.3 0 0 1 0 .3"
    />
    <path
      fill="#5e3f17"
      d="M317.9 199.2l.5-.2m-8.5-.3c-.3.2-.8.2-1 .7.2-.5.7-.5 1-.6"
    />
    <path
      fill="#842116"
      d="M309.7 197.3c.1 0 .3 0 .3.2a.4.4 0 0 0 0 .1.7.7 0 0 0 0-.3l-.3-.1m.7.4a.7.7 0 0 0-.1-.6v.5m.6-.5c0-.3-.1-.5-.3-.6v.1c.2.1.3.4.3.6a.4.4 0 0 0 0-.1m.5-.1c0-.3 0-.5-.2-.6v.1l.2.3a.4.4 0 0 0 0 .1m-.8-.7c.4-.2 1.4-.3 1.8.2v-.2c-.4-.4-1.4-.3-1.8 0"
    />
    <path
      fill="#7a2e26"
      d="M309.5 198.1v-.5s-.1 0 0 .1v.4m4.7 1.4a.6.6 0 0 0 .3-.5.6.6 0 0 1-.3.3v.2m.7 0a.4.4 0 0 0 .1-.3v-.1.3m4.3-2.4a1 1 0 0 1 0 .7.4.4 0 0 0 0 .1v-.9.1m-.5.5v.7c.1-.3.2-.6 0-.9v.2m-.4.3"
    />
    <path fill="#452c25" d="M324.3 210.5v.2l.1.1-.1-.4z" />
    <path
      fill="#dcddde"
      d="M314.4 195c-1.7 0-3.3-1-3.3-1a2.7 2.7 0 0 1-2.3-2.4c-.8-.4-1.6-2.5-1.6-2.5-1.3.7-3 0-3 0s0-.4-1.4 0c-1.5.3-1.3-.3-1.3-.3s.6-.6-2 0 .2-.8.2-.8c-.8.2-3.3.4-3.3.4-.9 0-1.8.5-2.8.8l-2.3.6-6.8 3-5.5 2.1c.2 0 3.4-2.1 7.5-4a87.8 87.8 0 0 1 10.3-3.9 9.9 9.9 0 0 1 6.5 0c.6.2 4.2 0 5.7 0 1.6.3 1.8 2.9 1.8 2.9.3.1.4 2.6.4 2.6s-1 0 .1.1c1 .2 2.9 1.7 2.9 1.7h.7s.4-.5.9-.7l1.5-.5a11.6 11.6 0 0 1 2 0l2 .3 1.2.3h.5c1-.5 3-1.2 3.4-1.1 0 0 .7-.2 1.1-.5a105 105 0 0 0 1.3-1s-.6-4.5 3.9-4l11.5 1.2a43.9 43.9 0 0 1 6.5 1.8l5.2 2.4 4 1.7c2.3 1 4 2.4 4 2.4-1.5-.6-2.6-1.3-3.7-1.8-.9-.4-1.8-.5-2.6-.9l-3.6-1.7c-3.5-1.6-3.5-1.7-4.9-1.8-1 0 .7 1.2.7 1.2l-4.1-1.7a6 6 0 0 0-2.9-.5 5.8 5.8 0 0 1-2.2-.3c-.6-.2-3.8-.3-4.4-.4a7.3 7.3 0 0 1-1-.2l.2.4-1.5-.3-.5.7s-1.5.3-1.6-.2c-.1-.5-1 2.2-1.3 3-.4.8-2.2.6-2.7 1-.4.5-1.4.9-1.6 1h-1.3c-.6 0-.1 0-1 .3 0 0-.9 0-1.2-.2l-1.4-.4a27.5 27.5 0 0 0-3.5-.2 5.4 5.4 0 0 0-2.7 1.1"
    />
    <path
      fill="#e7e7e7"
      stroke="#000"
      strokeWidth={0.1}
      d="M314.4 195c-1.7 0-3.3-1-3.3-1a2.7 2.7 0 0 1-2.3-2.4c-.8-.4-1.6-2.5-1.6-2.5-1.3.7-3 0-3 0s0-.4-1.4 0c-1.5.3-1.3-.3-1.3-.3s.6-.6-2 0 .2-.8.2-.8c-.8.2-3.3.4-3.3.4-.9 0-1.8.5-2.8.8l-2.3.6-6.8 3-5.5 2.1c.2 0 3.4-2.1 7.5-4a87.8 87.8 0 0 1 10.3-3.9 9.9 9.9 0 0 1 6.5 0c.6.2 4.2 0 5.7 0 1.6.3 1.8 2.9 1.8 2.9.3.1.4 2.6.4 2.6s-1 0 .1.1c1 .2 2.9 1.7 2.9 1.7h.7s.4-.5.9-.7l1.5-.5a11.6 11.6 0 0 1 2 0l2 .3 1.2.3h.5c1-.5 3-1.2 3.4-1.1 0 0 .7-.2 1.1-.5l1.3-1s-.6-4.5 3.9-4l11.5 1.2a43.9 43.9 0 0 1 6.5 1.8l5.2 2.4 4 1.7c2.3 1 4 2.4 4 2.4-1.5-.6-2.6-1.3-3.7-1.8-.9-.4-1.8-.5-2.6-.9l-3.6-1.7c-3.5-1.6-3.5-1.7-4.9-1.8-1 0 .7 1.2.7 1.2l-4.1-1.7a6 6 0 0 0-2.9-.5 5.8 5.8 0 0 1-2.2-.3c-.6-.2-3.8-.3-4.4-.4a7.3 7.3 0 0 1-1-.2l.2.4-1.5-.3-.5.7s-1.5.3-1.6-.2c-.1-.5-1 2.2-1.3 3-.4.8-2.2.6-2.7 1-.4.5-1.4.9-1.6 1h-1.3c-.6 0-.1 0-1 .3 0 0-.9 0-1.2-.2a17.9 17.9 0 0 0-1.4-.4c-.5-.2-3.1-.2-3.5-.2a5.4 5.4 0 0 0-2.7 1.1"
    />
    <path fill="#452c25" d="M314.6 194.4s-.2.2-.2.5v.2" />
    <path
      fill="#574f4c"
      d="M323.3 194l.7.5a.5.5 0 0 0-.1-.1 6.5 6.5 0 0 0-.7-.6.6.6 0 0 0 0 .1"
    />
  </svg>
	),
	BQ: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#21468b" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M0 0h640v320H0z" />
    <path fill="#ae1c28" d="M0 0h640v160H0z" />
  </svg>
	),
	BR: () => (
  <svg viewBox="0 0 640 480">
    <g strokeWidth="1pt">
      <path fill="#229e45" fillRule="evenodd" d="M0 0h640v480H0z" />
      <path
        fill="#f8e509"
        fillRule="evenodd"
        d="M321.4 436l301.5-195.7L319.6 44 17.1 240.7 321.4 436z"
      />
      <path
        fill="#2b49a3"
        fillRule="evenodd"
        d="M452.8 240c0 70.3-57.1 127.3-127.6 127.3A127.4 127.4 0 1 1 452.8 240z"
      />
      <path
        fill="#ffffef"
        fillRule="evenodd"
        d="M283.3 316.3l-4-2.3-4 2 .9-4.5-3.2-3.4 4.5-.5 2.2-4 1.9 4.2 4.4.8-3.3 3m86 26.3l-3.9-2.3-4 2 .8-4.5-3.1-3.3 4.5-.5 2.1-4.1 2 4.2 4.4.8-3.4 3.1m-36.2-30l-3.4-2-3.5 1.8.8-3.9-2.8-2.9 4-.4 1.8-3.6 1.6 3.7 3.9.7-3 2.7m87-8.5l-3.4-2-3.5 1.8.8-3.9-2.7-2.8 3.9-.4 1.8-3.5 1.6 3.6 3.8.7-2.9 2.6m-87.3-22l-4-2.2-4 2 .8-4.6-3.1-3.3 4.5-.5 2.1-4.1 2 4.2 4.4.8-3.4 3.2m-104.6-35l-4-2.2-4 2 1-4.6-3.3-3.3 4.6-.5 2-4.1 2 4.2 4.4.8-3.3 3.1m13.3 57.2l-4-2.3-4 2 .9-4.5-3.2-3.3 4.5-.6 2.1-4 2 4.2 4.4.8-3.3 3.1m132-67.3l-3.6-2-3.6 1.8.8-4-2.8-3 4-.5 1.9-3.6 1.7 3.8 4 .7-3 2.7m-6.7 38.3l-2.7-1.6-2.9 1.4.6-3.2-2.2-2.3 3.2-.4 1.5-2.8 1.3 3 3 .5-2.2 2.2m-142.2 50.4l-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2M419 299.8l-2.2-1.1-2.2 1 .5-2.3-1.7-1.6 2.4-.3 1.2-2 1 2 2.5.5-1.9 1.5"
      />
      <path
        fill="#ffffef"
        fillRule="evenodd"
        d="M219.3 287.6l-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2"
      />
      <path
        fill="#ffffef"
        fillRule="evenodd"
        d="M219.3 287.6l-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m42.3 3l-2.6-1.4-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .5-2.3 2.1m-4.8 17l-2.6-1.5-2.7 1.4.6-3-2.1-2.3 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m87.4-22.2l-2.6-1.6-2.8 1.4.6-3-2-2.3 3-.3 1.4-2.7 1.2 2.8 3 .5-2.2 2.1m-25.1 3l-2.7-1.5-2.7 1.4.6-3-2-2.3 3-.3 1.4-2.8 1.2 2.9 3 .5-2.2 2.1m-68.8-5.8l-1.7-1-1.7.8.4-1.9-1.3-1.4 1.9-.2.8-1.7.8 1.8 1.9.3-1.4 1.3m167.8 45.4l-2.6-1.5-2.7 1.4.6-3-2.1-2.3 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m-20.8 6l-2.2-1.4-2.3 1.2.5-2.6-1.7-1.8 2.5-.3 1.2-2.3 1 2.4 2.5.4-1.9 1.8m10.4 2.3l-2-1.2-2.1 1 .4-2.3-1.6-1.7 2.3-.3 1.1-2 1 2 2.3.5-1.7 1.6m29.1-22.8l-2-1-2 1 .5-2.3-1.6-1.7 2.3-.3 1-2 1 2.1 2.1.4-1.6 1.6m-38.8 41.8l-2.5-1.4-2.7 1.2.6-2.8-2-2 3-.3 1.3-2.5 1.2 2.6 3 .5-2.3 1.9m.6 14.2l-2.4-1.4-2.4 1.3.6-2.8-1.9-2 2.7-.4 1.2-2.5 1.1 2.6 2.7.5-2 2m-19-23.1l-1.9-1.2-2 1 .4-2.2-1.5-1.7 2.2-.2 1-2 1 2 2.2.4-1.6 1.6m-17.8 2.3l-2-1.2-2 1 .5-2.2-1.6-1.7 2.3-.2 1-2 1 2 2.1.4-1.6 1.6m-30.4-24.6l-2-1.1-2 1 .5-2.3-1.6-1.6 2.2-.3 1-2 1 2 2.2.5-1.6 1.5m3.7 57l-1.6-.9-1.8.9.4-2-1.3-1.4 1.9-.2.9-1.7.8 1.8 1.9.3-1.4 1.3m-46.2-86.6l-4-2.3-4 2 .9-4.5-3.2-3.3 4.5-.6 2.2-4 1.9 4.2 4.4.8-3.3 3.1"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M444.4 285.8a124.6 124.6 0 0 0 5.8-19.8c-67.8-59.5-143.3-90-238.7-83.7a124.5 124.5 0 0 0-8.5 20.9c113-10.8 196 39.2 241.4 82.6z"
      />
      <path
        fill="#309e3a"
        d="M414 252.4l2.3 1.3a3.4 3.4 0 0 0-.3 2.2 3 3 0 0 0 1.4 1.7c.7.5 1.4.8 2 .7.6 0 1-.3 1.3-.7a1.3 1.3 0 0 0 .2-.9 2.3 2.3 0 0 0-.5-1c-.2-.3-.7-1-1.5-1.8a7.7 7.7 0 0 1-1.8-3 3.7 3.7 0 0 1 2-4.4 3.8 3.8 0 0 1 2.3-.2 7 7 0 0 1 2.6 1.2c1.4 1 2.3 2 2.6 3.2a4.1 4.1 0 0 1-.6 3.3l-2.4-1.5c.3-.6.4-1.2.2-1.7-.1-.5-.5-1-1.2-1.4a3.2 3.2 0 0 0-1.8-.7 1 1 0 0 0-.9.5c-.2.3-.2.6-.1 1s.6 1.2 1.6 2.2c1 1 1.6 1.9 2 2.5a3.9 3.9 0 0 1-.3 4.2 4.1 4.1 0 0 1-1.9 1.5 4 4 0 0 1-2.4.3c-.9-.2-1.8-.6-2.8-1.3-1.5-1-2.4-2.1-2.7-3.3a5.4 5.4 0 0 1 .6-4zm-11.6-7.6l2.5 1.3a3.4 3.4 0 0 0-.2 2.2 3 3 0 0 0 1.4 1.6c.8.5 1.4.7 2 .6.6 0 1-.3 1.3-.8a1.3 1.3 0 0 0 .2-.8c0-.3-.2-.7-.5-1a34.6 34.6 0 0 0-1.6-1.8c-1.1-1.1-1.8-2-2-2.8a3.7 3.7 0 0 1 .4-3.1 3.6 3.6 0 0 1 1.6-1.4 3.8 3.8 0 0 1 2.2-.3 7 7 0 0 1 2.6 1c1.5 1 2.4 2 2.7 3.1a4.1 4.1 0 0 1-.4 3.4l-2.5-1.4c.3-.7.4-1.2.2-1.7s-.6-1-1.3-1.4a3.2 3.2 0 0 0-1.9-.6 1 1 0 0 0-.8.5c-.2.3-.2.6-.1 1s.7 1.2 1.7 2.2c1 1 1.7 1.8 2 2.4a3.9 3.9 0 0 1 0 4.2 4.2 4.2 0 0 1-1.8 1.6 4 4 0 0 1-2.4.3 8 8 0 0 1-2.9-1.1 6 6 0 0 1-2.8-3.2 5.4 5.4 0 0 1 .4-4zm-14.2-3.8l7.3-12 8.8 5.5-1.2 2-6.4-4-1.6 2.7 6 3.7-1.3 2-6-3.7-2 3.3 6.7 4-1.2 2-9-5.5zm-20.7-17l1.1-2 5.4 2.7-2.5 5c-.8.2-1.8.3-3 .2a9.4 9.4 0 0 1-3.3-1 7.7 7.7 0 0 1-3-2.6 6 6 0 0 1-1-3.5 8.6 8.6 0 0 1 1-3.7 8 8 0 0 1 2.6-3 6.2 6.2 0 0 1 3.6-1.1c1 0 2 .3 3.2 1 1.6.7 2.6 1.7 3.1 2.8a5 5 0 0 1 .3 3.5l-2.7-.8a3 3 0 0 0-.2-2c-.3-.6-.8-1-1.6-1.4a3.8 3.8 0 0 0-3.1-.3c-1 .3-1.9 1.2-2.6 2.6-.7 1.4-1 2.7-.7 3.8a3.7 3.7 0 0 0 2 2.4c.5.3 1.1.5 1.7.5a6 6 0 0 0 1.8 0l.8-1.6-2.9-1.5zm-90.2-22.3l2-14 4.2.7 1.1 9.8 3.9-9 4.2.6-2 13.8-2.7-.4 1.7-10.9-4.4 10.5-2.7-.4-1.1-11.3-1.6 11-2.6-.4zm-14.1-1.7l1.3-14 10.3 1-.2 2.4-7.5-.7-.3 3 7 .7-.3 2.4-7-.7-.3 3.8 7.8.7-.2 2.4-10.6-1z"
      />
      <g strokeOpacity={0.5}>
        <path
          fill="#309e3a"
          d="M216.5 191.3c0-1.5.3-2.6.7-3.6a6.7 6.7 0 0 1 1.4-1.9 5.4 5.4 0 0 1 1.8-1.2c1-.3 2-.5 3-.5 2.1 0 3.7.8 5 2a7.4 7.4 0 0 1 1.6 5.5c0 2.2-.7 4-2 5.3a6.5 6.5 0 0 1-5 1.7 6.6 6.6 0 0 1-4.8-2 7.3 7.3 0 0 1-1.7-5.3z"
        />
        <path
          fill="#f7ffff"
          d="M219.4 191.3c0 1.5.3 2.7 1 3.6.7.8 1.6 1.3 2.8 1.3a3.5 3.5 0 0 0 2.8-1.1c.7-.8 1-2 1.1-3.7 0-1.6-.2-2.8-1-3.6a3.5 3.5 0 0 0-2.7-1.3 3.6 3.6 0 0 0-2.8 1.2c-.8.8-1.1 2-1.2 3.6z"
        />
      </g>
      <g strokeOpacity={0.5}>
        <path
          fill="#309e3a"
          d="M233 198.5l.2-14h6c1.5 0 2.5.2 3.2.5.7.2 1.2.7 1.6 1.3s.6 1.4.6 2.3a3.8 3.8 0 0 1-1 2.6 4.5 4.5 0 0 1-2.7 1.2l1.5 1.2c.4.4.9 1.2 1.5 2.3l1.7 2.8h-3.4l-2-3.2-1.4-2a2.1 2.1 0 0 0-.9-.6 5 5 0 0 0-1.4-.2h-.6v5.8H233z"
        />
        <path
          fill="#fff"
          d="M236 190.5h2c1.4 0 2.3 0 2.6-.2.3 0 .6-.3.8-.5s.3-.7.3-1c0-.6-.1-1-.4-1.2-.2-.3-.6-.5-1-.6h-2l-2.3-.1v3.5z"
        />
      </g>
      <g strokeOpacity={0.5}>
        <path
          fill="#309e3a"
          d="M249 185.2l5.2.3c1.1 0 2 .1 2.6.3a4.7 4.7 0 0 1 2 1.4 6 6 0 0 1 1.2 2.4c.3.9.4 2 .3 3.3a9.3 9.3 0 0 1-.5 3c-.4 1-1 1.8-1.7 2.4a5 5 0 0 1-2 1c-.6.2-1.5.2-2.5.2l-5.3-.3.7-14z"
        />
        <path
          fill="#fff"
          d="M251.7 187.7l-.5 9.3h3.8c.5 0 .9-.2 1.2-.5.3-.3.6-.7.8-1.3.2-.6.4-1.5.4-2.6l-.1-2.5a3.2 3.2 0 0 0-.8-1.4 2.7 2.7 0 0 0-1.2-.7 13 13 0 0 0-2.3-.3h-1.3z"
        />
      </g>
      <g strokeOpacity={0.5}>
        <path
          fill="#309e3a"
          d="M317.6 210.2l3.3-13.6 4.4 1 3.2 1c.7.4 1.3 1 1.6 1.9.4.8.4 1.7.2 2.8-.2.8-.5 1.5-1 2a3.9 3.9 0 0 1-3 1.4c-.7 0-1.7-.2-3-.5l-1.7-.5-1.2 5.2-2.8-.7z"
        />
        <path
          fill="#fff"
          d="M323 199.6l-.8 3.8 1.5.4c1 .2 1.8.4 2.2.3a1.9 1.9 0 0 0 1.6-1.5c0-.5 0-.9-.2-1.3a2 2 0 0 0-1-.9l-1.9-.5-1.3-.3z"
        />
      </g>
      <g strokeOpacity={0.5}>
        <path
          fill="#309e3a"
          d="M330.6 214.1l4.7-13.2 5.5 2c1.5.5 2.4 1 3 1.4.5.5.9 1 1 1.8s.2 1.5 0 2.3c-.4 1-1 1.7-1.8 2.2-.8.4-1.8.5-3 .3.4.5.8 1 1 1.6l.8 2.7.6 3.1-3.1-1.1-1-3.6a19.5 19.5 0 0 0-.7-2.4 2.1 2.1 0 0 0-.6-.8c-.2-.3-.6-.5-1.3-.7l-.5-.2-2 5.6-2.6-1z"
        />
        <path
          fill="#fff"
          d="M336 207.4l1.9.7c1.3.5 2.1.7 2.5.7.3 0 .6 0 .9-.3.3-.2.5-.5.6-.9.2-.4.2-.8 0-1.2a1.7 1.7 0 0 0-.8-.9l-2-.7-2-.7-1.2 3.3z"
        />
      </g>
      <g strokeOpacity={0.5}>
        <path
          fill="#309e3a"
          d="M347 213.6a9 9 0 0 1 1.7-3.2 6.6 6.6 0 0 1 1.8-1.5 6 6 0 0 1 2-.7c1 0 2 0 3.1.4a6.5 6.5 0 0 1 4.2 3.3c.8 1.6.8 3.5.2 5.7a7.4 7.4 0 0 1-3.4 4.5c-1.5.9-3.3 1-5.2.4a6.6 6.6 0 0 1-4.2-3.3 7.3 7.3 0 0 1-.2-5.6z"
        />
        <path
          fill="#fff"
          d="M349.8 214.4c-.4 1.5-.5 2.8 0 3.8s1.2 1.6 2.3 2c1 .3 2 .2 3-.4 1-.5 1.6-1.6 2.1-3.2.5-1.5.5-2.7 0-3.7a3.5 3.5 0 0 0-2.2-2 3.6 3.6 0 0 0-3 .3c-1 .6-1.7 1.6-2.2 3.2z"
        />
      </g>
      <g strokeOpacity={0.5}>
        <path
          fill="#309e3a"
          d="M374.3 233.1l6.4-12.4 5.3 2.7a10 10 0 0 1 2.7 1.9c.5.5.8 1.1.8 1.9s0 1.5-.4 2.2a3.8 3.8 0 0 1-2 2c-1 .2-2 .2-3.1-.2.4.6.6 1.2.8 1.7.2.6.3 1.5.4 2.8l.2 3.2-3-1.5-.4-3.7a20 20 0 0 0-.3-2.5 2 2 0 0 0-.5-1l-1.2-.7-.5-.3-2.7 5.2-2.5-1.3z"
        />
        <path
          fill="#fff"
          d="M380.5 227.2l1.9 1c1.2.6 2 1 2.3 1 .3 0 .7 0 1-.2.3-.1.5-.4.7-.8.2-.4.3-.8.2-1.2a2 2 0 0 0-.7-1 23.7 23.7 0 0 0-1.8-1l-2-1-1.6 3.2z"
        />
      </g>
      <g strokeOpacity={0.5}>
        <path
          fill="#309e3a"
          d="M426.1 258.7a8.9 8.9 0 0 1 2.5-2.6 6.6 6.6 0 0 1 2.2-.9 5.5 5.5 0 0 1 2.2 0c1 .2 1.9.6 2.8 1.2a6.6 6.6 0 0 1 3 4.4c.3 1.7-.2 3.6-1.4 5.5a7.3 7.3 0 0 1-4.5 3.3 6.5 6.5 0 0 1-5.2-1.1 6.6 6.6 0 0 1-3-4.4c-.3-1.8.2-3.6 1.4-5.4z"
        />
        <path
          fill="#fff"
          d="M428.6 260.3c-1 1.3-1.3 2.5-1.1 3.6a3.6 3.6 0 0 0 1.6 2.5c1 .7 2 .9 3 .6 1-.3 2-1 2.9-2.4.9-1.4 1.3-2.6 1.1-3.6-.1-1-.7-1.9-1.6-2.6s-2-.8-3-.5c-1 .2-2 1-3 2.4z"
        />
      </g>
      <path
        fill="#309e3a"
        d="M301.8 204.5l2.3-9.8 7.2 1.7-.3 1.6-5.3-1.2-.5 2.2 4.9 1.1-.4 1.7-4.9-1.2-.6 2.7 5.5 1.3-.4 1.6-7.5-1.7z"
      />
    </g>
  </svg>
	),
	BS: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-12 0h640v480H-12z" />
      </clipPath>
    </defs>
    <g fillRule="evenodd" clipPath="url(#prefix__a)" transform="translate(12)">
      <path fill="#fff" d="M968.5 480h-979V1.8h979z" />
      <path fill="#ffe900" d="M968.5 344.5h-979V143.3h979z" />
      <path fill="#08ced6" d="M968.5 480h-979V320.6h979zm0-318.7h-979V2h979z" />
      <path d="M-11 0c2.3 0 391.8 236.8 391.8 236.8L-12 479.2-10.9 0z" />
    </g>
  </svg>
	),
	BT: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#ffd520" d="M.1 0h640.1v480H.1z" />
    <path fill="#ff4e12" d="M.1 480h640.1V0z" />
    <g stroke="#000" strokeWidth={0.5}>
      <g fill="#fff" strokeWidth={0.4}>
        <path d="M345.4 150c-4-1.3-6.6.7-6.4 5.9 0 5.1 2.8 8 6.8 6.1l-.4-12z" />
        <path d="M348.9 140.4c-3.3-2.6-6.4-1.5-8 3.4-1.5 5 .1 8.6 4.5 8l3.5-11.4z" />
        <path d="M354.4 131c-2.8-3-6-2.4-8.4 2.2-2.3 4.6-1.3 8.5 3.2 8.7l5.2-10.8zm-3.6 45.5c-4.9 1.8-5.4 8.5-2.3 12.6 3 4.1 8.7 4.9 11.8 0l-9.5-12.6z" />
        <path d="M345.1 162.3c-4.6-1.5-8.8 4.7-9.5 10.3-.9 7-11 9.4-5.4 20.1 1.2-6.8 5.7-10.6 9.3-10.8 3.6-.3 9-1 11.3-5.4l-5.7-14.2zm14.7 27.6c-5.4 1.3-6.2 8.5-2.3 13.6 3.3 4.4 13.7 3.4 13.4-1l-11-12.6zm15.3 43.4c.3-4.7-7.2-6.5-10.8-5.6-3.6 1-10.5-.1-12-4-1.4 3.1.5 6.5 5.7 8.2 4 1.2 3.9 4 2.7 5.4 3 .5 11.7.5 14.4-4z" />
        <path d="M370.9 203.7c-5.3-2.4-8.4 1.2-10.4 4.6-3 5-12.1-1.4-15.2 5.3 4.2-1.8 8.4 2 10.4 3.3 5.7 3.7 16.6 2.6 18.2-6.2l-3-7z" />
        <path d="M374 209.8c-5.3 4-7.4 8.8-7.2 12 .1 3.2 4.6 10.3 9.5 10.7 2.8-5.8 4.3-18-2.3-22.7zm-22 24.9c0-2 2.8-2.7 4.8-2 1.9.6 4.9 2.5 3.8 4.6l-8.6-2.6zM323 224c-.5-2.3 3.2-6.3 8.2-4.1 5 2.2 5.7 6.4 3.6 8.1l-11.8-4z" />
        <path d="M335.2 228.4c-.4-1.3 3.3-3.9 9.4-2.4 6.2 1.6 7.7 5.6 7.5 8.7l-16.9-6.3zm-12.9-4.3c3.3-2.4 2-7-.9-8.5-5.2-2.6-3.3-9.2-6.7-10.5-3.3-1.3-6.5-3.6-6.7-6-1.6 3.3-.6 6.2 1.7 8.3 2.3 2-1.8 10.4 1.2 12.6l11.4 4.1zm-69-1.8c-2.7-4.2-9.1-3.5-11.8-.5-2.7 3-2.3 7.3.2 9.3l11.6-8.8zm15.5-6.3c-1-5.7-7.9-6.3-11.6-4.9-3.8 1.4-6.3 7.1-3.9 11.2l15.5-6.3z" />
        <path d="M279 215.2c2.5-4.7-2.3-11.8-7.7-12.8-4.5-1-9.8-.9-11.6-5.3-1 3.8 1.8 6.3 5.2 8.5 3.3 2.2-.6 7.8 4.8 11l9.4-1.4z" />
        <path d="M278.6 215.4c-1.2-3.4 1.1-8 5.7-7.6 4.7.3 7.3 3.6 5.3 7.9l-11-.3z" />
        <path d="M288.9 215.7c-.7-3.6 2.2-7.8 6.8-6.8 4.5 1 6.6 4.7 4 8.5l-10.8-1.8z" />
        <path d="M299 217.3c-.4-3.6 2.7-7.6 7.2-6.4 4.5 1.2 6.4 5 3.6 8.7l-10.7-2.3zm-77.6 59c-8.7 0-10.8 2-12 11-1.6 11 13.5 12.3 12-11z" />
        <path d="M225.2 264.7c-13.2-5-20.4 16-33.6 12.2 4.7 7.5 16.1 0 20.4.8 7.2 1.3 22.8-1.4 13.2-13zm-8.6 28.7c-6.6-3-13.6 7-12.4 11.5 1.7 5.5 16.7 1 12.4-11.5zM186 336.7c3.6 1 8 3 7.2 10-.8 7-14 21.1-25.8 22-11.8.7-16 15-26.3 11 9.6-1.8 9.6-12.6 17-16-5.4-2-8.2 10.3-15.2 10.3s-10.3 11.1-18.8 10.3c-8.5-.7-9.3 13.5-26.4 13.7-13 .1-29 15.3-34.9 8.7 12.7-1.8 17.8-8.8 25.3-16.5 12-12.3 25.7-6.8 30.4-17.7a31.6 31.6 0 0 1-18.3 5.4c-8-.2-16.6 12.6-25.5 7 5.1-.7 8.5-2.9 13.9-8.6 5.5-5.8 13.7-2 20.1-8 10-9.2 18.7-1.5 28.3-13-2.7-1.4-8.5-.5-13.9 2.4-5.4 2.8-12.3-2-18.5 1.4.7-7.6 15.2-3.3 24.2-8.5 10.2-6 18.6-4.2 26.6-3.5-11.2 0-15.5-10.7-31-7.6-6.7 1.4-12.1-9.3-18.8-3.9.2-4 7.2-7.2 14.4-3.3 7.2 3.9 10.1-3.4 24.5 5.7 6 3.7 16.1-2.4 22.5 1.6-.8-2.4-4.5-4-8.8-3.6 2.7-5.6 20.2-4.9 27.8.7z" />
        <path d="M197.4 328.3c-5.6-4.4-13.5.9-19-1.2 0 3.6 1.9 9 7.8 11.1 1.8-1.3 10-8.4 11.2-9.9z" />
        <path d="M206.3 315.8c-8.9-4.5-10.4 6.7-17.4 4.4.3 3.2 2.9 7.2 8.5 8.1l9-12.5z" />
        <path d="M211.6 305.6c-13.1-5.1-14.8 7.5-22.5 5 1.8 4.4 12.8 6.8 18.5 5.2l4-10.2zm18-55.2c-3.5-5-10.8-1-12 4.9-1.1 5.8 1.7 13.9 6.6 12l5.4-17z" />
        <path d="M238.5 235c-6-1.5-13-.8-12.2 5-2.4 1.1-3 8.7 3.3 10.4l8.9-15.5z" />
        <path d="M242.5 231c-6-7-12.5-6.9-16.2-4-6.9 5.5-13.5 2.4-13.7 7.8 4.1-3.2 7.8.6 11-.5 3.4-1.2 5.9 5.3 15.2 2.6l3.7-6zm-14.3 103.9c.9 1.7 6.4 2.4 9.1-.4 3.6-3.8-.3-14.2-6-15-5.7-.7-6.2 11.8-3.1 15.4z" />
        <path d="M221.8 335.1c8 3 11.5-3.7 7.2-8a80 80 0 0 1-7.2 8z" />
        <path d="M191.4 346.2c-1.6 4.7-9.6 5.4-18.6 19.8-9 14.5-17.6 8.4-19.8 18.3 10.8-8.7 19.3-3 25.8-11.6 9.7-13.1 17.8-11.2 21.6-20 5.4-12.7 29-12.4 30.4-32.3-8-1.5-33.3 19.9-39.4 25.8zm203.2-194.7c10.3 3.4 10.5 16.7 22.4 21.1 11.8 4.4 13 15 22.7 12.4-9-2.5-8.4-12.9-17.8-15.5-11-3-15.2-19.8-24-22.4m44 74.3c1.8 4.2 1.5 11.5-5 13.4 3.5 2.2 8.7.2 11.5-4.6-4.2 9.4-1.4 17.9 5.3 19.6-3.2-6.6 4-9.7 1.7-14 4.2 1.9 8 7.7 7.8 11.3 5.6-6.2-4-14.5-2.3-20.3l-19-5.4zM375 287.6c-6.3-5.5-9 1.5-12-1-3-2.2-6.8-2.5-8.3-.3 5.4.2 2.8 4.4 13.3 5.4-10.5.7-8.6 12.5-15.6 11.9 7.4 7 11.3-6.3 17.4-4.1-1.8.5 2.8 4.7-.4 10.4 5.2-.1 7.3-7.3 8-11l-2.4-11.3zm-139 60.2c-2.2-2-9-2.9-11.5-1.3-2.6 1.5-1.7 2 1.4 2.2 3.1.2 7 5.2.4 5.5-3.1.1-2 7.6-8.5 8.1 2.6 3.2 10.2 1.1 12.9-2.4-.5 2.9 3.3 5.5 1.8 9 4.7.5 2-9.7 9.5-9.2-3 .4-1.8 7.4 3.6 5.6-3.2 1.5-1.5 5.3 2 4.4-2.2.7-3 3.7.2 5.4 3.1-4.3-.4-19.5-11.7-27.3zm280.6-142.1a17.9 17.9 0 1 0 0-35.7 17.9 17.9 0 0 0 0 35.7z" />
        <path d="M423.4 227.2c5.5-5.1 13.7-7.7 19.4-3.8 5.6 3.8 24.4 8.4 33.7 2 9.3-6.4 13.7-9.8 17.8-9 3 4.6 6.8 6.8 11.4 7.2 1.4 1.6 6.5 2.8 9.3 2.5 4.1 1 9.1-.3 13.1-4.7 6.2 1 12-3.7 14.2-10.7 6.6-.7 7-8 2.8-13-3.8-.7-.9-13.8-14.9-11.2 6 3.6 1.4 10.8 6.3 14.2-3.3 0-7.7 1.4-8.7 6.4 1.3-3.4-.2-5.8-1-6.5 0-3-6.5-10.3-12.7-7.6 4.4 1 2 8 5.2 10.8a8.1 8.1 0 0 0-6.2 3.3c-1.7-3-7.6-6-11.2-6.3 0-1-.2-3-.7-4.1-1.6-3.1-3-6.8-2.3-11.5a48 48 0 0 0-7.2 11.4c-4.9-3.4-17 1.5-22.7 2.8-5.6 1.3-24.7-1.8-29-6.4a49.2 49.2 0 0 0-21-9.8c-11-3.2-11-15.2-23.1-23.5-.3 15 22.4 62.4 27.5 67.5zM297.2 341.1a17.3 17.3 0 1 0 0-34.6 17.3 17.3 0 0 0 0 34.6z" />
        <path d="M256 327.8c3.5 4.5 9.4 4.2 11.9 3.9 2 5.4 8.6 5.2 11.4 8.2 2.9 3 12.5 2.7 15.3 1-2.5-.2-5.9-1.8-9-4.5-4-3.2-2.2-9.8-5.2-12a11 11 0 0 0 2.2-8.6c2.4-1.4 4.2-3.7 4.4-4.9a15 15 0 0 0 9.6-4.1c2.2 2 7.7-.6 10.7 2.8.6-8.5-7.5-13-13-10.1-2.1-1.2-7.9-.4-9 1.1-1.7-.8-6.8 1.8-9 3.5 2.5-1.4 2.9-5.7 1.9-7.2 2.2-1 4.6-3.9 4.9-6 3 .5 7.7-1.6 9.7-1.1-3.3-4.4-8.8-6-14.5-5.5-5.9.3-8.4 4.4-9.2 8.8-3.4 2.1-4.6 9-3.3 11.5-2 0-3.9 1.9-4.6 3a26.7 26.7 0 0 0-9.4-2m1.3-7c-1.2-3.4.3-6.4 1.1-9 2-6.8.8-8.6-5.3-7.7a47 47 0 0 0 4.2 16.7z" />
        <path d="M248.6 282.3c1.6 1.6 7 2.3 7.6-2.6.7-5.6-1.6-7.8-6.5-5.6-.4 1.3-.8 6.5-1 8.2z" />
        <path d="M249.8 273.9c2 .8 6.5 2.5 9-2.3 2-4-.7-7-5-6.8-1 1.2-3 5.3-4 9.1z" />
        <path d="M253.6 264.4c.5 1.6 5.8 6.7 9.6 3 3.9-3.7 3.9-9.3-1.9-11.3-1.5.2-6.2 5.6-7.7 8.3z" />
        <path d="M261.3 256c1.1 3.3 4.8 8.8 11.5 6.3 6.7-2.6 3.8-11 .7-12.7a33 33 0 0 0-12.2 6.5z" />
        <path d="M273.5 249.6c-.5 2.9 0 10.6 9.2 10.5 9.1-.2 6.6-10.9 4.2-12.4-3.7 0-10 .1-13.4 2z" />
        <path d="M287.3 248c-1 2.3-3.3 16.7 14.6 12.7 2.3-.5 8.3-13.8-14.6-12.6z" />
        <path d="M297.1 249.4c-1.8 1.8 2.8 16.3 15 13.9 12-2.5 1.9-16.3-15-14z" />
        <path d="M307.4 251.6c-2 4 1 15.8 15.9 15.8 13.5 0-.7-15.6-15.9-15.8z" />
        <path d="M319.1 255c-1 2.3-2.1 14.8 15.5 15.9 12.7.8 9.6-17.3-15.5-15.9z" />
        <path d="M338 260.3c-2.1 3.9-4.4 13.5 14.9 14.3 12.3.5 4.7-14-14.8-14.3z" />
        <path d="M354.1 263.3c-2.8 3.8-.7 11.4 6.5 12.8 9 1.8 10.3-6.7 4.1-10.8-6.2-4-10.6-2-10.6-2z" />
        <path d="M363 265c-2.1 3.7-.9 12.4 12.8 12.4 2.8 0 13.6-11-12.9-12.3zM257.1 433a20 20 0 1 0 0-40 20 20 0 0 0 0 40z" />
        <path d="M404.1 141.7a35.2 35.2 0 0 0-5.4 8c-6.7 20 11.2 35 21.6 56.7a63 63 0 0 1-5.6 60.7c-4.4 5.8-3.1 7.5-8.8 13.4-2.2 2.3-4.6 5.2-3.8 13.4 3.6-1.3 8.7 2 9.7 5 2.6-1.4 6.2-.9 7.5.7 4.4-2 8-1 11.9 3 3.3-.4 7 0 10.3 3.7 1.8-3.6 5.4-5 8-4.1-.3-4.7 4.3-8 8.4-6.2a7.6 7.6 0 0 1 9.8-9c4.7-3.6 14-3.9 18.6 1.5-8.3-2.3-8 6.5-15 5.7 1.8 5.1-2.8 8.1-7.4 9.8 3-1.4 6.2-3.1 7.2-1.3 2.6-2.3 7.7-1.4 9-.3 3.4-1 6.7-.2 8.2 3.9 4.7 2.8 7.8 10 4.4 15.4-1-5.6-4.9-5.4-6.4-7.7-3.6 1.3-7.2 1.3-8.3-1-2 2-9 3.9-12 .8-1.2 4.6-5.2 8.5-9.9 8.5 1.3 3.6-2.3 9.7-5.1 12.8 4.4 2.3 3 7.5 2 10.6 6.8 1 1 7 12.7 10.8-5.7 1.8-16.8 0-18.3-7-5.7-.2-9.5-5.9-9.3-11.8-4.4-4.1-5-10 1-14.2-5.1 1.6-8-6.7-15.4-3.3-3.7 1.7-13.5-1.2-13.4-4.6-1.5 2.5-11 1.5-12.2-2.9-3.1 1.7-10.3-1.1-10.2-5.4-4 1.8-9.4-1.4-9.1-5.5-3.8-.5-4.2-3.9-4-6.7-3.3-1.6-2.4-4.8-1-8.6-2.4-2.6-1.4-6.2.4-9.6-2.5-2.6-2-5.6-1.3-9.3-12.3-1-27.8-4-63.3-14.9-53.6-16.5-68 22.2-56.2 46.4 13.7 28-1.5 34 3.1 54.8 5 1 7.5 5.2 7.2 9.6 3 .1 5 2.8 4 8a9 9 0 0 1 7.6 2.3c1.8-3.4 7.8-4.2 10.8-.3 6.7-.5 10.1 5 9.8 11.6a18 18 0 0 1-1.5 19.3c.4-2.7 0-6.5-.1-8.9-.3-4.2-6.2-5.1-5.6-8.6-3 .3-6-1.4-7-3.7a6.8 6.8 0 0 1-6.6 1.3c3.4 1.5 6.2 7.7 5.1 11.8 1.8 3.1 1.4 8.8-.7 11.2-1 5-5 6.8-10 4.6 2.9-1.8 3.9-5 3.8-7.7a10 10 0 0 1-2.9-6.3c-5 .8-12-3.5-13.2-5.2a20 20 0 0 0-20 20.1c-.6-4.1-5.8-8.2-5.1-11.7-3.1-9.5 1.3-18.4 13.9-20.2-1.6-3.6 3.8-7.3 1.8-11.4a97 97 0 0 0-14.7-20.1c4.4-7.5 3-17.5.5-23.7-3.7-8.9-7.2-6.7-20.3 7.7-21.4 23.5-50 17-75.2 32.5-6.7 4-13.4 5.6-6.2-1.6s26.2-14.4 38.6-20.6c23.2-11.6 42.8-30.9 50.5-68.5 18.1-88.4 85-59.2 127.2-42.8 39.7 15.5 32.5-19.5 12.4-40.7-24.2-25.3-19.3-45.3-8-61.3 20.3-2.8 59.4 4.3 51.5 11.1z" />
        <path d="M475.9 358.8a22 22 0 1 0 0-44.1 22 22 0 0 0 0 44z" />
      </g>
      <g fill="none" strokeWidth={0.4}>
        <path d="M391.8 142.7c-5 21.7-.8 31.5 6.4 41 14.9 19.7 26.8 64.6 9.8 94" />
        <g strokeLinecap="round">
          <path d="M417.5 252.3c2-.7 6-3.2 6.8-7.4m-5.2-2c.6-3.7 6.4-5.3 6.5-9.3m-6.4-5.2c-.4-3.9 5.8-7.4 4.9-11.2m-8.3-2.7c-.5-2.2 5.2-6.3 3.6-9.8m-7.8-3.8c-1.2-2.4 2.7-5.2 1-7.8m-7.2-3c-.4-1.6 2-5.3.7-7.5m-6.9-5.2c.5-.7 2.6-2.2 1.8-4.1m-6-5.3c.8-.4 3.3-1.2 3-3" />
          <path
            strokeLinejoin="round"
            d="M266 410.9c-5-1.8-11.5.7-12.8 5.1m3.9 4c.6-4.4 7.3-6.3 9.3-4.3-4.2-2.3-6.3 6-2.5 6.2m34.6-103.8c-3 1.6-4 7.2 0 11.5m4.6-10.2c-2.1 1.8-2 7.2 1.2 8.5-2.7-2 0-5.3 2-5.4 1.9-.1 3.2 2.2.8 4.5m177 5.2c-7.2-2-13 6.4-6.4 13.9-.2-7.2 5-12 11.3-10.7m-3 5a2.7 2.7 0 0 0-2.7 2.7c0 1.4 1.2 2.8 3.2 2.8 1.3 0 2.4-1.5 2.4-2.7m22.6-161c1.2 4.4 7.2 6.3 12 5.2m0-2.8c-3.7.1-6.8-3.4-6.6-6.3 0 2.2 5 3.2 6.6 1.8"
          />
          <path d="M267.9 331.7c-1-2.6 3-5.2 3.2-7.6.1-2.5 4.6-4.4 9.3.2m-2.2-27.4l-2.5 1.2m11.4 12.8c-1.1 0-3.4 0-4.6-.9m0 5.8c-.8.5-2.8 1.2-4 1.5m-40.1 76.3c-.2 2.3 2.2 5.7 3.4 6.7m6.6-12.2a10 10 0 0 0-1.3 7.6m20.5 0c-2.3-1.5-.8-5.4-1-8-.3-2.6 2.7-6.7 8.5-3.2M246 381c2.3-.4 4.7-.3 6.3.4m23-7.7a8.3 8.3 0 0 0-1.4 4m12.3-4.3c-1.8 0-3.4 1.3-4.2 2.6m-20.8-68.5c2 .7 7.4 4 7.6 7.4m14.3-24.2c-6.3-.1-8.8-6.5-4-6.5m15.3 15.2c-2.4 1-1.3 5.2 2.2 7.3m-17.3 33.1c-1.2-1.6.4-6 4.4-4.7m5 51.7c.3-4 5.2-6.2 7.2-1.8m-25.5 13c-.3-4.3 2-5.7 3.8-6 2-.2 4.7 1.4 6 4.2m-48.1 5c.2-2.6 2.4-5.3 4.7-4.9m231-109.4c-1.7 1.2-2.8 6.7 3.5 7.2M458 296c0 .6.8 1.5 1.3 2m29 8.3c-1.6-1.3-6 4-2 7.7m-39 35.6c-.9-3.7 2.5-4.7 5.8-3.9m-14-22.2c2-1.2 4-2.7 6.4-3.3m-7.4 17.5c0-3 1.6-5.7 3-6.4m8.4-29.1a16 16 0 0 0 2.4 9.2m28.2-9c-1.9.6-3.5 1.3-4.2 2.9m2.1 7.7c1-.8 2-1.7 2.4-2.3m46.3-110.2c0 3.6-4.5 5.6-7.5 3.3m17.3-3.1c2 1.5 8.9 0 7.3-4M528 221.4a11 11 0 0 1-4.9-3m19.1-7.7c-2.3.5-3.9 0-5-.5m-31.6 13.4a17 17 0 0 0 6.5-1.6M502 200.8c-1.7-.2-3 .1-3.9.8m29.8 5.5a11 11 0 0 1-3 5.2" />
          <path
            strokeLinejoin="round"
            d="M497.5 212.8c3.2-1.4 7.2 9.5 15 5.7m.6-11.4a11.3 11.3 0 0 0-1.8 5.6"
          />
        </g>
        <path d="M359 190.4c1-.2 2.9-.5 3.3-1.8M226.5 310.3c3.9 2.2 6.6 5.9 5 11.4m172.1-143.2c1.2.8 5.5.8 8 0m3 2.6c0 1.8.5 8.6-3 10m1.3-.8c3.2 1 9.6.6 11.7-5.3m-4.5 5c1.7 2.6 2.2 7.6-2.8 10.3m4-6c3.8 1.2 12.4 1.4 11.5-6m-3 6c2.7 3.5 14 7.8 12.2.3m-22.5 10c4.3 1.1 10.5-1.9 8-9.6m12.3 3.9c.6 3 15 6 13.1-.7m-2.7 3.9c2.7 6.2 17 5.7 12.5-2.6m-2.3 6.5c2.8 3.4 15.5 1.4 10.4-7m-.1 6.8c7.9 6 17-2.5 7-8.7m4.6 6.8c7 5.5 15.5-4.5 9.4-7.3m-64.4 5c2.2.6 6.8.4 7.9-3.6m-1.8 2.7c-.2 5.8 9.6 8 12.1 1.3m-3.3 3.7c1.8 3.9 10.5 5.4 11.9-.1m-1.4 2.6c1.4 3.8 8.9 3.4 11-.6m-2.8 2.6c2.3 5 11.9 5 14-2.3m-1.6 3.2c3.7 2.3 11.7 1.4 11-5.8m-1.5 5.2c5.6 4.5 13.4.1 9.5-7.5m-.3 13.4c3-.5 4.5-6.4 1.4-8m-70 9c6-3.3 7.3-9 3-14.5m2.2 8.9c3.9 2.3 11.2-.2 12.5-5.8m-7.2 6.4c2.2 2.8 2.6 6.3-.3 9.5m2-5.9c6.9-4.2 15.4 3.6 9 8.4m-1-8.8c1.5-.4 4.2-3.2 4.4-6.4m-1.4 9.4c2.9-3 22.2 3 10 9.3m-1-17.4c3.8 1.4 5.7 6.7 0 8.5m5 4.4c4-4.3 17-1.6 12.3 3.8m-3.1-5.5c2.3-7.9 16.1-3 11.6.2m-14.4-8c.4 1.5.5 5.3-2 7.4m13.6-9a6.1 6.1 0 0 1-.8 5.3m9.5-5.2c.8 1.4 2 4.1-.8 6.3m-109.4-65.5c.1 7.3 2.7 12.2 12.6 7.6m-9.5 1.1c-5 6.6.6 13.7 10.3 6.6M365 165c6.7 7.2 18.7 2 11-9m8 15.2c-1.2 7.1 4.6 8.5 9.3 5.3m-34.2-10.3c1.2 7.1 8.5 12.7 15.6 8.4m-6.9 1.4c0 10.2 14 11.3 17.3.8m-5 6.4c4.5 9.3 14.3 5.5 17.5-.1m-27.4-14.7c1.8 4.5 5.4 9.5 13.7 5.8m-39.5-8c1.2 3.7 7.9 8.2 15.6 3m-10.8 1.8c-4.2 6 4 11.7 14 2.7m-9.1 4.7c1.6 8.5 5 15.4 17 4.4m-6 4.4c4.4 5.4 11.1 8.7 17.4-.4" />
        <path d="M387.3 188.8c-.4 6.5.8 9.7 5.9 9.4 4-.2 7.7-3.3 9.9-6.7m-10.8 6.7c-.2 7.4 5.6 13.2 16.5 5.7m-12 3c-2 5.5 4.1 14.5 16.2 9.9m-41.9-24.6c-.7 7 5.8 11.8 16.4 2.7m-11.2 5.1c.4 5.8 7 12.8 16.6 2.7m-12 4.7c-.7 9.9 8.4 12.7 16.1 5.1M367.2 200c2 .2 3.7-1.6 4.7-3m-.4 10.2c1.8.4 5-1.2 6-3.3m-1.4 15c2 2.3 9 .7 9.9-2.3m-2.2 2.2c3.8 9 14.1 8.7 18.4-1.5m-2 3.6c2 5.3 6.9 8.6 14.9 6.8m-11-1.4c-4.5 7.3 1.4 16 11.5 7.5m-9 3.5c-.5 4.6 3.7 9.9 9.5 10.5m-28.6-24c-1.5 10.4 6 15.4 15.3 9.8m-26.2-4.8c2.4 1.9 6.8 2.1 11 .6m5 6c-2.4 8.8 6.6 15.1 14.3 5.3M380 230.2c.2 4.5 4.5 9.4 12.1 8m21.3 9c-5.2 3.4-6.2 9.6 1 13.6m-13.6-15.4c.2 5.2 2.7 8.2 8.5 8.7m-16.1-11.4c-7.8 7-.2 15.3 9 8.3m-3.6 2.2c-2.6 8.1 7 13 12.2 4.8m-28.2-22c-2.8 8 .8 13.2 7.4 12.7m-17.6-14.3c.4 4.8 4.5 6.5 9.2 5.4m-6.2-.4c-3.5 6.7 1.8 10.3 8.8 7.8m21 15c-1 4.2-.4 7.2 5.9 8.7m-5.4-2.7c-7.6 3.4-8.3 10.8-2.4 15.5m-3.8-23.7a7.6 7.6 0 0 0 1.2 12.3m-35-35.8c-4.3 4.3-.2 16.2 9.5 9.7m15.7 5.3c-6 5-3.3 13.8 6.5 11.4m-16.3-15c-3.1 8.7-.2 11.8 6.8 11.9" />
        <path d="M359.3 236.1a8.2 8.2 0 0 0-1.5 12.2c2.3 2.6 6.7 1.4 8-1.9m-17.6-13.8c-5.9 7.6 0 16.6 8.4 14m23.3 8.6c-6 2.1-10.7 7.6-7 12.5 2.3 2.8 11.8 3.2 14.5-7.8M369 248.1c-3.5 5-2.4 9.8 4 12.2m-4.4-2.8c-3.8 2-6.2 4.5-5.3 9m-3.1-16.9c-1.4 6 .3 9.8 4 11.6m-4.1-4.4c-5.8-.4-8.8 2-6.8 7.8m.5-6.4c-5.7-2-6.6-7-4.1-12m-.8 7.6c-6.2.2-9 3.3-9 7.5" />
        <path d="M340.5 229.7c-4.5 1.9-6 8-4.3 11.3 1.7 3.3 7 3.6 10.2 1.4M328 224.9c-4.1 4.6.6 13.7 8 11.5m-18.6-15.1c-3.8 5.4.4 14.4 10.3 11.8m.5 25.1c-1-6.4 5.7-10.6 14-2.3m-4-13a10.1 10.1 0 0 0-3.3 8.5m-28-33.2c-4.3 7.2.9 13.8 10 11.2m13.8 6.7c-6 6-4 12.1.5 15.6m-4.4-8.5c-9.1.1-9.6 10.7-2.2 14m-4.7-24.6c-3.8 2.6-5 9.7 1.5 12.5m-1.8 3.4c-3.9-1.8-8.5.4-8.1 4.9m2.3-4.8c-3.5-8.2-13.6-6.8-12.7 1.7m15.5-11.9c-2.1.4-6.5 1.7-8.2 5m.6-14.3a7 7 0 0 0 2.5 11.4M296.7 216c-.8 5.6 1.4 8.3 8.4 7.8m-6-.7c-2.6 6.7 1 9.7 8 9.3m-6.4-1c-4.1 4.9-1.3 10.1 2.7 12.3m-4.6-6.1c-7.4-1-8.5 7.6-6 11.5" />
        <path d="M292.9 215.5c-4.5 2-7.1 7.6-4.7 11 2.5 3.5 7.4 2.4 10 .6m-8.4 1c-3.8 5.7-.4 10 3.6 11.6" />
        <path d="M275.3 214.8c-3 3.1-1.1 9.4 6 9.6 5.9 0 8.8-5.4 7-9.3m-8 9.3c-2.3 5.1-.8 10.7 8 9.8m3.6 8c-5.3-2.4-12.6 0-9.5 6.5m-.7-15.6c-2.2 3.1-1.5 7.5 1 10.2m-1.4-2c-3.6.7-7.1 2.6-5 8.3m-.5-4.6c-4.6-1.4-10.5 2-7 6.7m-.7-4.5c-4-.7-8.7 3.6-4.9 7.8m-1.5-3.5c-3.6 1-7.9 5-4.1 8.3m22.3-28.5c-5.2 2.3-5.7 8.1-3.3 12.4m-2.2-23c-7.7 3-7.6 13.2 1 16.4m-3.7-2.3c-4.6 2.7-5.5 7.9-2.4 11.2m-5.7-29.2c-3 1-2.8 10.5 5.4 10.3m-13.9-7.1c-6.2 4.1 1.3 14.5 11.3 7m-5.5 2.7c-.9 4.2.3 8.8 7.1 9.4m-6.7-3.8c-4.9 1.8-5.8 11.9 3 12.7m-18.6-21.8c-6.3 5.8 5.2 10.8 9.4 2.4m-18.1 7.2c-3.1 3.8 7.7 13.6 12.5-2.8m1.1-.3c.3 4 2.6 6.2 7.3 6.5m0 3.7c-7.7 1.2-10.1 10.7-1.6 12.8m-12.5-14c-.3 3.5 3.5 6.5 7.7 5.9m3.9 7.8c-7 1.6-7.9 10.6-1.7 10m-3.2 8.4c-5.8-1.7-6-8.6-.8-11.2" />
        <path d="M245.7 267.8c-4.9 3-3 10-.4 11s4.7-.2 5-2.4m-.5 10c.6 3.3-11.9 2-5.5-8.4m0 8.9c-4.2 6.6 2.6 12 6.9 6.3m-6.4 1.6c-1.7 5.3 4.7 9.1 8.8 5M231 245.4c-2.3 4.7 9.3 6.5 10-3.3m-13.2 10.3c-2.3 9.3 15.2 7.4 10.7-4.6m.4 6.2a8.2 8.2 0 0 0 11.6-6.3m-5.3 6.6a10 10 0 0 0 4.7 6.3m-13.1-3.9c-.8 5 4.3 9.2 10 8.8m-9.1-3.9c-2.8 3.9-3.7 11.3 5.2 11.8M224 263c-1.4 4 7 8.1 11.8 1.5m-14.4 8.7c-.7 3 6.8 7 11-5.8m-3.3 6.5c1.8 3.2 7.9 5.8 11.6-.5m-6 3.9c-1.6 4.5 2.7 8.7 7.8 7.5m-17.5-8.5c-1 6.4 6.5 10.1 11 6.8m-15.9-4c-2.2 8.2 8.4 11.3 12.4 5.1m-2.7 2.5c.4 4.6 7.6 8.6 13.2 4.8m-26.1-1c-.5 2.1 8.1 4.2 9.4-3m-4.4 4.9c2 5.2 9 6.5 13 0m-2.3 2.6c1 5 7.2 7.7 12.8 4.3m2.3 2c-1.4 6.5 5.4 11.8 9.6 8.2m-20.6-9.4c-2 7.2 7 11.3 12 7.3m-22.8-11c-.5 6.8 4.8 10.8 10.8 7.8m-22.3-7c-1.8 4.3 7.8 7.9 12.3 4.2m-18.2 7.7c2.5 2.8 11 0 11.7-6.3m-2.3 4.6c3.1 3.6 10.5 5.6 13.4-2.2m-2.6 4c0 5.6 9.8 9.6 13-.6m11.7 2c-1 2.7 1.2 7 5.7 7.5m-13.9-9.2c-.6 3 3.9 7.4 8.7 5.7m.9 1.3c-1.3 3.3-.2 8.1 4.3 8m-3.9-1.8c-3.4 2.8-2 7.9 2.9 8m-4.6-3.2c-4.8 3.2-3.1 10.3 3.2 9.9M239 313c0 7 8.7 8 10.3 1.6m-3.3 4c-1.3 4.2 2 8.2 7.3 7m-6.3 42.8c1.2 1.7 6-1.2 4.7-4-1.3-2.8-6.4-1.3-5.8 1.7m4.6-2.9c.6-5.6-6-6.5-7.7-1.6m2.4-2.9c1.7-2.8-4-6.7-6.3-2.5m2-1.7c1.6-4.1-4.8-6-5.3-2.2m-1.5-5.4c.8-2 8-.8 5 3.5m5.5 5.1c2.8-2.6-2-7.8-5-6m24 13.9c-2.2.2-4.5 1.7-2.9 6.5 1.2 3.3 6.1 3.4 6.9 1.5" />
        <path d="M260.5 365.9c-2.2-1.5-7 1-4.8 5.6 1.6 3.5 5.8 2 6.4.2m-14 .8c1.2 2 6.6 1 7.6-1m-3.8-5.4c1.2-.8 3.3.2 3.7 1.2m-4-33c-3.8 2.5-1.5 10 4.3 8m-5.6-1.9c-3 2.3-.2 9.6 5.3 6.8m-4.3 0c-2.1 2.1-.1 7.8 5.2 6.7m-6-3.8c-1.2-.5-4.2-.2-5.5 1.8m2.1-28c-2.8 2.8-1.4 8.3 3.8 8.8m-4.8-3c-4 2-4 10 4 10.3m-4.3-1.3c-2.3 1.8-1.2 8.8 4.6 7.9m-2.8-.3c-.8.9-1 3-.2 3.9m-2.3-6.5c-2 0-4.8 1.5-5.5 3.7m-3.7-7.5c.7-2 7.1-2 7.6 4.1m.6-7.2c-.9.2-2.6 1-3 2.8m.2-21.7c-2.7 2.6-4 10.5 4.3 12m-9.9 4.4c0-2.1 5.8-4 7.8-.8M232 322.8c.8 1.6 4.8 3.8 7.2 2m-28-14.6a6.3 6.3 0 0 0 7.2 6.5c4.3-.5 5.2-4.2 3.9-6.7m-3.2 6.9c-2.9 3.4.6 8.3 3.8 6.9m-.6-9.4c1.7-.6 7.2-1.4 8.9 1.2m-26.8-.2c-1.3 2 6.7 3.9 9.4.2m-2.7 1.9c-.3 2.6 1 7 7.6 5.1" />
        <path d="M219.8 326.6c1-2.2-3.8-5.8-7.6-1.8-3.7 4 .6 8.5 2.9 7M202.7 318c-2 3.4 5.5 9.5 9.8 3.8" />
        <path d="M197.7 323.8c-2.7 2.8.7 7.9 4.7 6.3 4.1-1.5 3.7-5.8 2.7-6.9" />
        <path d="M192.5 329c-2.2 2 0 6.6 3 6.6s4.9-2.3 4.3-5.4m5-1.6c-.4 3 4 5 6.9 2.2m0-5.4c.5-.6.2-1.7-.5-2.3m-23.4 9.8c-2.5 2 3 7.6 6.3 2.5m13.1-3.5c-1.6 1.5 1 5.5 3.6 4.3m-12.4-1.5c.4 2.7 5.8 4.8 9.2.6m-6.3 2.1c-.8 1.8.9 4.5 3 4.2m48.3 11.8c-2 3.9 4.4 8.5 9 3.7m-4.4 2.1c-1 2.1.2 5.1 2 6.2m-8-1.7c.4-2 3.2-3.8 5.7-2.9m-9-2.2c.3-1.8 2.6-3.5 4.4-3m147.2-77.4c-9.2.1-5.3 14.8 2.6 11.9m-5.6-1c-1.8 2.9 1.7 7.6 5.6 4.8m-1 .6c-2.8 4.5 6.9 11.4 10.8 4.3m-3.1 2.7c0 4.3 12.5 7 10.7-1.5m-1.2 4.6c3 5 14 5.5 12.9-2m-2.5 5.2c2.3 3.4 13.2 5.4 12.8-1.5m-56.7-40.8c1.5 4 6.8 5.4 12.6 3m-16-.2c3.7 2.3-1.6 12.9-7.1 8.6m7.2-2c4 1.9 8.9.5 10.3-5.2m-2.5 4.4c.4 3 4.7 5.3 10.2 4.1m-20.1-1c5.2 4.4-2.3 13.4-5.7 9.3m7.6-6c2.5 1.8 8.8.8 9.4-4m-2.8 4c.5 3.1 3 4.3 6.4 4.4m-14.4-.1c2.6 3.6 9 4.6 11.9-.1m-2.9 2.7c-.2 3.4 3.6 6.3 7.6 5.5M375 295c3.3 1.7 7-4.7 4.1-9m-.2 15.7c4 .2 4.5-5.8.7-9.2m8.4 14.7c3.4-.8 2.3-8.1-5.8-8.7m16 14.1c3.2-.9.6-9-8.3-8.5m20.5 11.4c2.2-3.4-5-9-11-6m17 10.6c4 1.2 6.8-9.4-5.9-7.7m13.3 7.7c3.5-1 6-7.2-4.2-5.2m12 5.7c3 1.6 4.4-7.5-5-5m-47-23c3.9 2.1 10-.4 9.4-5.3m-1.5 4.2c1.3 2.3.8 6.8-1.7 8m2-2.6c2.6 1 6.1.1 8.2-4m-3.6 4c.7 1.8 1 5.4-.7 7.2m1.3-4.1c2.9 1.6 6.2-.5 7.6-3.5m-1.8 2.6c2 1.3 3.9 7.3.4 9.8m2-2.8c2.4 0 6 0 8.3-3m-1.7 1.7c2.2.6 4.8 4.2 3.9 7.4m.1-1.1c2.5-.3 6.7-2 7.9-5m-1.2 2a6.6 6.6 0 0 1 3.2 6.5m0-2.1c2.5-.1 4.7-1.4 5.3-4.1m-.6 1.8c1.8.6 4 2.7 4.1 5.1m-.3-1.5c1.8-.3 3.1-1.4 4.3-3.2m4.9-.3c2.3 2.3-.8 10-5.6 8.6m-43.9-164.7c-4.7 2.9-18.3 2-11.6-9.2m13 1.6c-9.5 3.8-21-3.5-9-11.3m-3.2-2.6c-7.8 0-13.1 12.6-2.6 17M348.6 138c-2 4 5.3 8.4 10.3 4.4 3.9-3.1 3.6-11.5 1.3-14.7m-15.6 19.8c-2.6 8.5 16.4 9 13.4-4.5m-14.4 17.2c.6 6.4 18.1 4.3 12.5-8.7m2-3.6c1.4 2 5.3 5.3 11.9 4.6m-9-13.5c.6 2.3 4.5 4 9.5 2.3M185.4 334.8c-4.5 3.1 2.4 8.1 4.9 2.6m-8.4-.2c-4.4 3.2 2.4 8.2 4.9 2.7m-8.6-.3c-4.4 3.2 2.4 8.1 5 2.7m-8.8-.5c-4.3 2.3.7 7.8 5 3m-9.2-.9c-4.3 2.3.7 7.8 5 3m16.6-9.6c-.1 3.3 6.1 4.6 8.4-.3m-4.5 3.3c-2 2.5 1.6 5.5 3.5 4.4m-11.8-4.8c-.2 2.8 5.2 4.4 7.8 1.3m-4.9 1.6c-1.7 2.2 1.7 5.3 4 4.4m-10.5-4.8c.2 2.2 3.3 4.7 6.6 3.3m-4.6-.3c-1.3 1.1-.7 3.8 1.1 4.7m-7.8-5c-.5 2 2.9 5.6 6.4 3.3m-5.7-1c-2 1.7-1.8 4.1.8 4.5m-5.8-4.7c-.2 1.4 1.5 3.6 3.7 3.3m-14.7-3.4c-2 1.1 3.2 6.7 6.5 1.5m-11.6.8c-2.6 1.2 3.8 7.4 6.7 1.1m10-1.3c-2 .4-3.3 3.3-1.6 4.5m-5-3.5c-.2 1.2 2.3 3 4.3 2.4m-5.9-1.9c-2 1.2-.9 4.6 1.4 4.1m-8.3-1.8c-1.8 1.3-.5 4 2 3.4m1.3-3.6c0 .7 1.7 1.8 3 1.3m-12.5-2.5c-2.3 1-2.1 6.6 5.5 3.6m-10.6-1.3c-3.2 1.5-2.1 5.8 4.8 1.7m.5.3c-.8.7-1.7 3.5 1.5 2.4m-7.2-1c-1.3 1.1-.5 3.5 2.3 2.6m-9-2.2c-2.3 1.3 2.8 3.1 6.2-.5m-4.6 2.1c-1 1-1 4.1 1.6 3m-8.2-1.7c-1.5 1.1 1 2.7 6 .5m-4 1.1c-1.9 1.5-1.7 3.4 1 2.8m-6.4-2c-2 1.9.9 3.1 4.4 1.6m-4.4.5c-3.4 1.5-1.9 4.4.2 3.3m113.8 6.5c-.8 1.7 1.8 3.1 4.3 2.7 2.3-.3 4.6-2.3 2.8-5m.1 3.4c2.4 1.8 6.5-.3 6.5-3" />
      </g>
      <g fill="#fff" strokeWidth={0.4}>
        <path d="M396.8 103c-10.3-5-31.7-14.6-37.8-6.9 5.6-2.3 21.8.1 35.2 12.5l2.6-5.5z" />
        <path d="M403 102.5c-11.9-13.9-19-10.8-27.5-15.5-8-4.5-20.8-5.4-23.3 1.7 11.7-5.7 22.5 3 29.2 4.2 9 1.4 14.2 8.5 16.9 11.7l4.7-2zm44.9-1.8c-6.2-14.1-19.4-10.4-25.2-16.4-8.5-8.8-30-17-39-10.9 19.6-1 28 13.5 38.4 18.6 7.5 3.6 15.5 11.3 25.8 8.7z" />
        <path d="M424.7 99.2c-10.5-13.1-26.8-24.7-34.2-20.4 9.8.6 12.9 7.4 19.8 11.8 7 4.3 3.9 10.7 14.4 8.6zm-50.2 23.2c-11-4.1-32.7-6.2-42.8 6.4 16.8 2.9 42 1.3 42.8-6.4z" />
        <path d="M372.4 127.3c-11-5.2-19.7 2-30.1 1-19.8-2-34-.8-35.8 8.8 11.3-10.2 30.4-1.8 38.1-3.9 7.7-2 36.3-.3 45.3 3.6-4.6-5.7-11.8-7.2-17.5-9.5zm34.8-29.5c-2.6-8.5-2.4-17.5 10.3-16.9-3.2-4-15-6-17 8.9-14-10.3-29.4-12.1-32.2-3.2 7.2-6.2 18.4-1.7 31.8 13.5a23.8 23.8 0 0 1 7.1-2.3z" />
        <path d="M387.9 109.5c-8-5.2-18.8-13.5.1-16.9-8-4.3-20-2.4-18.7 12.5-21.6-8.7-37.1-5.8-40.4 2.9-3.6 9.5 9.8 14.8 12.1 8.7-2.4 1-10.8-1.8-6.4-7.2s26.8-1.3 48.1 9.8c6 3 26.3 2.6 5.2-9.8z" />
        <path d="M382.2 123.7c-6.1-12.6-26.1-1.2-30.1-13.4-5.6 17.9 28.4 8 30.1 13.4zm127.1 13.6c4.2 2.1 7.8-1.2 1.4-3.7 4.2 2 7.9-1.1 1.5-3.7 4.2 2 7.8-1.1 1.4-3.7-1.7 1.7-4.1 8-4.3 11.1zm2.2-24.2c9.3-9.8-.7-13.1 10.6-23.2 9.3-8.2 1.8-13.7 10.5-20 2.9-2.1 9-6.2 9.6-10.4 3.7 9.3-11.6 10.6-10.6 25.5.7 9.5-5.8 8.7-8.2 24.8-.5 3.3-2.9 10.8-11.9 3.3z" />
        <path d="M515.6 117.5c5.2-11 11.1-10.9 14-15.2 5.4-8.3 16.8 1.4 26.5-6-1.7 10.5-14.7 6.8-20.4 13.5-5.6 6.7-10.3 9.7-20 7.7z" />
        <path d="M517 121.1c9-7.2 15.6-2.4 21.8-6.2 15.7-9.5 22 2 36-2.6-3.6 9-24.4 1.3-33.4 8s-40.7 13.2-24.5.8zm-26.3 51.4c-.2-4.1-4-9.4-9.4-10-5.4-.7-7.8-6.4-11.9-6.6-4.1-.3-6.8-8.5-12.5-8.4-5.6.1-8 7.5 5.3 14.2 13.3 6.7 28 14.4 28.5 10.8zm-16.8 3.5c-5.6.2-6.4 8.5-11.8 8.7 7.4 4 12.9-1.8 16.7-7L474 176z" />
        <path d="M478.6 177c-5 4.1-6.4 12.7.7 15.2-4.2-5.9 7.5-8.5 3.9-14l-4.6-1.2z" />
        <path d="M483.4 177.3c-3.8 7.4 6.1 8.3 3.5 14 5.7-1.3 6.6-12 1.4-14.8l-4.9.7z" />
        <path d="M445.6 161.3c9.3-.5 17.7 4.5 23.4 12.6 3.6 5.1 15.7 7.2 19.9 3 4-4 1.8-12.8-8.5-10-2.6-4.3-10-2.8-13.7-6.4-3.6-3.6-17.5-13.9-21.1.8z" />
        <path
          strokeLinecap="round"
          d="M480.4 167c-2.5.5-3.3 4.7-1.7 6.9m7-4.4c.7 1.3.2 3.1-.2 4m-25.2-11.8c4.7.2 5.6 3.7 10.8 5"
        />
        <path d="M457.1 150a161 161 0 0 1 37.6 12.3c8.1 4.6 20.7 6 31.6 2.8 11-3 32.2-5.9 31.1 7.8 5.8-6.9-1.5-14.2-16.2-15.5.3-6.7-6.9-12.7-12-8.7 4.7-.7 8.8 8.2-.6 11.8a8.4 8.4 0 0 0-11.7-9.8c4.4 1.3 9 8.8-1 11.6-6.3 1.8-15.4-.5-22.2-4.6-6.8-4.1-45-19-36.6-7.8z" />
        <path d="M498.6 143.3c-5.1 2.3-1.8 7.7-9.7 10.8-8 3-13.6 10.1-11.8 16.2 5.4-11.9 15-11.3 18.3-16 3.4-4.6 8.3-11.4 3.2-11z" />
        <path d="M500 144c-.2 9.4-7.6 6-4.7 19.2.9 4.1 2.6 10.8-.3 17.5 8.3-6 3-18.7 6.7-23.5 1.8-2.4 4.2-6 5-9-1.9 5.3-1.7 15.4 3.5 18-4.2-10 11.5-18.3.7-30-1.6 3-6.5 8-10.8 7.8zm-26.2-9.4c1.3 2 2.6 6.8 1.4 9.6 2.6-1.6 6.3-5.6 7.5-8.3 5.3.8 7.3 7.3 2.3 10.2 3 0 8.4 0 11.3-3.5-3.6-4-14.8-10.2-22.5-8z" />
        <path d="M393.7 116.1a10 10 0 0 0-4.8-2c-7.8-1.6-3.7-8.6 2.9-8.5 14.2-15.5 22.1-3.6 39.4-8.4 6-1.8 10.2-1.3 13.4.2 7.8-5.2 16.8-3.8 23.4 2.3a5.3 5.3 0 0 1 3-2.4c6.1-1.7 11 3.4 12.7 10.1 4.7-.8 10.1 1.5 13.7 4.7 4.9-2.5 8.2-2.6 9.5 0 4.4-2 10-3.4 12.9 3.6s-6.7 4.9-8.3 19.6c-1 9-11 12.6-19 7.2-12.8-8.7-25.3-10-31.5 3-6.1 13.2-11 20.8-26 16.5a16 16 0 0 0-16.7 6.5c-4.4 6-11 .4-19 1 10-1.5 6.1-4 14.9-4.6 8-.5 5.9-8 11-9-20 5.1-19.3-2.4-35.8 2.8 7.2-9.3 18.6-4.1 24.2-9.5-14.9-.3-21.6-10-28.3-6-10.5 6.5-6 24.8-33.5 23.2-13.4-.7-21.9 1-29.8 9 13.9-28.8 32.8-13 42-22.1a68 68 0 0 0 12.3-14.7 6.1 6.1 0 0 1 4-3.2c-22.9-7.2-9-18.5 13.4-19.3z" />
        <path
          strokeLinecap="round"
          d="M506.9 112c.3.8.5 1.8.5 3 0 5.6-8.5 5.8-9 14.2-.3 4.4-.8 6.8-3.7 6.3-3-.5-5.6-5.1-2.8-10.5"
        />
        <path d="M398 107.7a10.9 10.9 0 0 0-6.2-2.1m52.8-8.3c6.8 3 10.1 10 20 10.4 9.6.3 15.5 14.2 31.5 5.1a38 38 0 0 1 1.2-.6M468 99.7a12.7 12.7 0 0 0-1.4 8.2m-29.8 21c-12 0-15.2 6.1-15.2 12 0 6 5.7 13.7 15.7 13.7s15.5-6.2 15.5-12.9-6.2-12.9-16-12.9z" />
        <path d="M439 154.3c-.2-3.3-6.3-2.8-6-5.4.2-2.6 3.3-3.6 3.3-7.2s5.4-3.9 7.2-1c1.8 2.8 7.2 8.3 8.4 5.5m-8.4-5.5a9.9 9.9 0 0 0-.4 13.1m4.3-8.8c-1 2-1.2 5-.1 6.8" />
        <path
          fill="none"
          d="M495.5 135.6c9.5.8 11-9.7 4-10.3m-15.7-17.8c-3.2-4.2-10.8-5.6-11 3.2"
        />
        <path d="M472 120.8c-3.2-8-11.5-9.1-15.8-5.1-3.7 3.3-3.8 12 4 13.8 2.8-3.3 8-7.5 11.8-8.7zm-3.5-5c-4.7-4.1-11.5 3.7-5.3 10.8m-83 8.7c3.2-.7 7.7.8 14.7 4 4.3 2.1 17.5 6.5 25.7 2.1-8.5 3.1-15-9.7-21.4-8.2-6.4 1.6-18.2 4-23.1-.8 12 .8 18.5-8.8 32.4-.5a24 24 0 0 0 13.1 3.6c-11.3-13.6-26.2-4.9-27.8-16 6.8 7.4 23.5-1.6 32 12.1m-29.5-10c-1.6-2-1-4-2.6-5.5" />
      </g>
      <path
        d="M483.8 107.5c-2.8-3-9-.7-7.2 5.4a9.6 9.6 0 0 1 7.2-5.5zM466.3 124a21.1 21.1 0 0 1 5.7-3.2 12.4 12.4 0 0 0-3.8-5.2c-1.5-1-5.7 4.7-1.9 8.3z"
        stroke="none"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeWidth={0.4}
        d="M458.7 113.5c-4.6-3.1-8.9-2.8-10.3-.3-3.3 0-6.1 2.4-6.2 7.2m7.1 2.1c-5.5-3.8-13.1-2.4-12.6 6.1m-3.4 4.9c2.7-2.2 6.6-3.8 9.6 0m31.8-8.4c-1 1.4-1.8 3.6-.1 7-2-2.8-7.2-2.8-12.8 4.4m25.1-11.8c-6.7.8-6.5 5.2-1.1 7m-46.5-23.4c-5.7-1.1-9.8 2.2-2 5m12.8-8.8c-8-2-11.2.1-7.6 2m-15.5 30c-.2 2.9 1.3 6.6 6 2.4m-4.4 6.1c0 .8-.1 1.7-.7 2.4m-17.9-40c-4.9-1.5-5.8-6 0-5.6m-1.6 16c-5.4-1.9-5.4-7.1-1-6.6m11 3.8c-6.3-1.5-6.5-5.9-1.8-5.2m2.6-8.2c-3.4-.2-8.5 3.5.1 5.7m9.3 1.8c-7.9-1.1-7.7 2-3.1 4.1m9-11.6c-6-1.1-8.1 2.5-4 4m-15 18.3c-1.5-1.2-2.7-7 4.3-5.3m10.3 3.5c-4.7-1.3-9.2 3.4-4.9 6m11.2-11.5c-5-1-9.2.5-6.5 2.3"
      />
      <path
        fill="#fff"
        strokeWidth={0.4}
        d="M483.6 107.5a9.6 9.6 0 0 0-7 5.4"
      />
    </g>
  </svg>
	),
	BW: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#00cbff" d="M0 0h640v480H0z" />
      <path fill="#fff" d="M0 160h640v160H0z" />
      <path d="M0 186h640v108H0z" />
    </g>
  </svg>
	),
	BY: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.6v512H0z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="scale(.9376 .9375)"
    >
      <path fill="#b20000" d="M0 0h1024v340.1H0z" />
      <path fill="#429f00" d="M0 340.1h1024V512H0z" />
      <path fill="#fff" d="M0 0h113.4v512H0z" />
      <g fill="#b20000" strokeWidth="1pt">
        <path d="M5.4 8.7h5.4v8.7H5.4zm16.2 0h16.2v8.7H21.6zM27 0h5.4v8.7H27zm27 0h5.4v8.7H54zm21.6 8.7h16.2v8.7H75.6zM81 0h5.4v8.7H81zM16.2 17.4H27V26H16.2zm16.2 0h10.8V26H32.4zm37.8 0H81V26H70.2zm16.2 0h10.8V26H86.4zM10.8 26h10.8v8.7H10.8zm27 0h10.8v8.7H37.8zm27 0h10.8v8.7H64.8zm27 0h10.8v8.7H91.8zm10.8-17.3h5.4v8.7h-5.4zm-97.2 26h10.8v8.7H5.4zm37.8 0H54v8.7H43.2zm54 0H108v8.7H97.2zm-86.4 26h10.8v8.7H10.8zm5.4 8.7H27v8.7H16.2zm21.6-8.6h10.8v8.6H37.8zm-5.4 8.6h10.8v8.7H32.4zm-10.8 8.7h16.2v8.7H21.6z" />
        <path d="M27 86.8h5.4v8.7H27zm37.8-26h10.8v8.6H64.8zm5.4 8.6H81v8.7H70.2zm21.6-8.6h10.8v8.6H91.8zm-5.4 8.6h10.8v8.7H86.4zm-10.8 8.7h16.2v8.7H75.6zm5.4 8.7h5.4v8.7H81zM54 78h5.4v8.7H54zM0 78h5.4v8.7H0zm108 0h5.4v8.7H108zm-81 43.4h5.4v8.7H27zm-5.4 8.8h16.2v8.6H21.6zm-5.4 8.6h27v8.7h-27zM81 121.5h5.4v8.7H81zm-5.4 8.7h16.2v8.6H75.6zm-5.4 8.6h27v8.7h-27zm5.4 43.4h27v8.7h-27zm-10.8-34.7h37.8v8.7H64.8zm-54 0h37.8v8.7H10.8zm5.4 43.4h16.2v8.7H16.2zm-5.4-8.7h27v8.7h-27zM86.4 165h27v8.7h-27zM81 191h16.2v8.7H81z" />
        <path d="M21.6 199.6H27v8.7h-5.4zm64.8 0h5.4v8.7h-5.4zM0 164.9h27v8.7H0zm48.6 17.3h16.2v8.7H48.6zM54 191h5.4v8.7H54zm-16.2-26h37.8v8.7H37.8zM59.4 34.7h10.8v8.7H59.4zm-10.8 8.7h16.2v8.7H48.6zm-5.4 8.7H54v8.6H43.2zm16.2 0h10.8v8.6H59.4zM0 43.4h10.8v8.7H0zm5.4 8.7h10.8v8.6H5.4zm97.2-8.7h10.8V52h-10.8zM97.2 52H108v8.6H97.2zM0 130h5.4v8.7H0zm108 0h5.4v8.7H108zm-59.4 69.5h16.2v8.7H48.6zm-5.4 8.7H54v8.6H43.2zm16.2 0h10.8v8.6H59.4zm-21.6 8.6h10.8v8.7H37.8zm27 0h10.8v8.7H64.8zm-32.4 8.7h10.8v8.7H32.4zm37.8 0H81v8.7H70.2zM27 234.3h10.8v8.7H27zm48.6 0h10.8v8.7H75.6zM16.2 243h16.2v8.7H16.2zm64.8 0h16.2v8.7H81zm10.8-8.7h10.8v8.7H91.8zm5.4-8.7H108v8.7H97.2zm5.4-8.7h10.8v8.7h-10.8zm-91.8 17.4h10.8v8.7H10.8zm-5.4-8.7h10.8v8.7H5.4zM0 217h10.8v8.7H0zm21.6 34.8H27v8.6h-5.4zm64.8 0h5.4v8.6h-5.4zm-32.4-26h5.4v8.6H54zm-16.2 26h5.4v8.6h-5.4zm32.4 0h5.4v8.6h-5.4zm-16.2 0h5.4v8.6H54zm-54 0h5.4v8.6H0zm108 0h5.4v8.6H108zM54 130.2h5.4v8.6H54zM27 43.4h5.4v8.7H27zm54 0h5.4v8.7H81zm-32.4 60.7h16.2v8.7H48.6zm-10.8 8.7H54v8.7H37.8zm5.4 8.7h5.4v8.7h-5.4zm-10.8-17.4h10.8v8.7H32.4zm5.4-8.6H54v8.6H37.8zm5.4-8.7h5.4v8.7h-5.4zm16.2 8.7h16.2v8.6H59.4zm5.4-8.7h5.4v8.7h-5.4zm5.4 17.3H81v8.7H70.2zm-10.8 8.7h16.2v8.7H59.4zm5.4 8.7h5.4v8.7h-5.4zm21.6-17.4h10.8v8.7H86.4zm5.4-8.6H108v8.6H91.8zm10.8 8.6h10.8v8.7h-10.8zm-10.8 8.7H108v8.7H91.8zm5.4 8.7h5.4v8.7h-5.4zm0-34.7h5.4v8.7h-5.4zM0 104h10.8v8.7H0zm5.4-8.6h16.2v8.6H5.4zm10.8 8.6H27v8.7H16.2zm-10.8 8.7h16.2v8.7H5.4z" />
        <path d="M10.8 121.5h5.4v8.7h-5.4zm0-34.7h5.4v8.7h-5.4zm-5.4 69.4H27v8.7H5.4zm27 0H54v8.7H32.4zm27 0H81v8.7H59.4zm27 0H108v8.7H86.4zm-43.2 17.4h27v8.6h-27zm-37.8 0h27v8.6h-27zm75.6 0h27v8.6H81zm27 34.7h5.4v8.6H108zm-108 0h5.4v8.6H0zm5.4 295h5.4v-8.6H5.4zm16.2 0h16.2v-8.6H21.6zM27 512h5.4v-8.7H27zm27 0h5.4v-8.7H54zm21.6-8.7h16.2v-8.7H75.6zM81 512h5.4v-8.7H81zm-64.8-17.4H27V486H16.2zm16.2 0h10.8V486H32.4zm37.8 0H81V486H70.2zm16.2 0h10.8V486H86.4zM37.8 486h10.8v-8.7H37.8zm27 0h10.8v-8.7H64.8zm27 0h10.8v-8.7H91.8zm10.8 17.3h5.4v-8.7h-5.4zm-97.2-26h10.8v-8.7H5.4zm37.8 0H54v-8.7H43.2zm54 0H108v-8.7H97.2zm-86.4-26h10.8v-8.7H10.8zm5.4-8.7H27v-8.7H16.2zm21.6 8.7h10.8v-8.7H37.8zm-5.4-8.7h10.8v-8.7H32.4zm-10.8-8.7h16.2v-8.7H21.6zm5.4-8.7h5.4v-8.6H27zm37.8 26h10.8v-8.6H64.8zm5.4-8.6H81v-8.7H70.2zm21.6 8.7h10.8v-8.7H91.8zm-5.4-8.7h10.8v-8.7H86.4zm-10.8-8.7h16.2v-8.7H75.6zm5.4-8.7h5.4v-8.6H81zM54 434h5.4v-8.7H54zm-54 0h5.4v-8.7H0zm108 0h5.4v-8.7H108zm-81-43.4h5.4v-8.7H27zm-5.4-8.8h16.2v-8.6H21.6zm-5.4-8.6h27v-8.7h-27zM81 390.5h5.4v-8.7H81z" />
        <path d="M75.6 381.8h16.2v-8.6H75.6zm-5.4-8.6h27v-8.7h-27zm5.4-43.4h27V321h-27zm-10.8 34.7h37.8v-8.7H64.8zm-54 0h37.8v-8.7H10.8zm5.4-43.4h16.2v-8.7H16.2zm-5.4 8.7h27V321h-27zM86.4 347h27v-8.7h-27zM81 321h16.2v-8.7H81zM0 347h27v-8.7H0zm48.6-17.3h16.2V321H48.6zM54 321h5.4v-8.7H54zm-16.2 26h37.8v-8.7H37.8zm21.6 130.2h10.8v-8.7H59.4zm-10.8-8.7h16.2V460H48.6zm-5.4-8.7H54v-8.7H43.2zm16.2 0h10.8v-8.7H59.4zM0 468.6h10.8V460H0zm5.4-8.7h10.8v-8.6H5.4zm97.2 8.7h10.8V460h-10.8zm-5.4-8.7H108v-8.6H97.2zM0 382h5.4v-8.7H0zm108 0h5.4v-8.7H108zm-64.8-78.2H54v-8.6H43.2zm16.2 0h10.8v-8.6H59.4zm-21.6-8.6h10.8v-8.7H37.8zm27 0h10.8v-8.7H64.8zm-32.4-8.7h10.8v-8.7H32.4zm37.8 0H81v-8.7H70.2zM27 277.7h10.8V269H27zm48.6 0h10.8V269H75.6zM16.2 269h16.2v-8.7H16.2zm64.8 0h16.2v-8.7H81zm10.8 8.7h10.8V269H91.8zm5.4 8.7H108v-8.7H97.2zm5.4 8.7h10.8v-8.7h-10.8zm-91.8-17.4h10.8V269H10.8zm-5.4 8.7h10.8v-8.7H5.4zM0 295h10.8v-8.7H0zm21.6-34.8H27v-8.6h-5.4zm32.4 26h5.4v-8.6H54zm0 95.5h5.4v-8.6H54zm-27 86.8h5.4V460H27zm54 0h5.4V460H81zM48.6 408h16.2v-8.7H48.6zm-10.8-8.7H54v-8.7H37.8zm5.4-8.7h5.4v-8.7h-5.4zM32.4 408h10.8v-8.7H32.4zm5.4 8.5H54V408H37.8zm5.4 8.7h5.4v-8.6h-5.4zm16.2-8.7h16.2V408H59.4zm5.4 8.7h5.4v-8.6h-5.4zm5.4-17.3H81v-8.7H70.2zm-10.8-8.7h16.2v-8.7H59.4zm5.4-8.7h5.4v-8.7h-5.4zM86.4 408h10.8v-8.7H86.4zm5.4 8.5H108V408H91.8zm10.8-8.6h10.8v-8.7h-10.8zm-10.8-8.7H108v-8.7H91.8zm5.4-8.7h5.4v-8.7h-5.4zm0 34.7h5.4v-8.6h-5.4zM0 408h10.8v-8.7H0zm5.4 8.5h16.2V408H5.4z" />
        <path d="M16.2 407.9H27v-8.7H16.2zm-10.8-8.7h16.2v-8.7H5.4zm5.4-8.7h5.4v-8.7h-5.4zm0 34.7h5.4v-8.6h-5.4zm-5.4-69.4H27v-8.7H5.4zm27 0H54v-8.7H32.4zm27 0H81v-8.7H59.4zm27 0H108v-8.7H86.4zm-43.2-17.4h27v-8.6h-27zm-37.8 0h27v-8.6h-27zm75.6 0h27v-8.6H81zm27-34.6h5.4V295H108zm-108 0h5.4V295H0zm48.6-43.5H54v8.7h-5.4zm10.8 0h5.4v8.7h-5.4zm0-17.3h5.4v8.7h-5.4zm-10.8 0H54v8.7h-5.4zM10.8 477.3h10.8v8.7H10.8zm75.6-164.9h5.4v-8.7h-5.4zm-64.8 0H27v-8.7h-5.4zm27-8.7h16.2v8.7H48.6z" />
      </g>
    </g>
  </svg>
	),
	BZ: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <radialGradient id="prefix__a">
        <stop offset={0} stopColor="#ffef5d" />
        <stop offset={1} stopColor="#ea5700" />
      </radialGradient>
      <radialGradient id="prefix__b">
        <stop offset={0} stopColor="#952d1a" />
        <stop offset={1} stopColor="#570a00" />
      </radialGradient>
      <radialGradient
        id="prefix__c"
        cx={247.1}
        cy={238.3}
        r={36}
        fx={247.1}
        fy={238.3}
        gradientTransform="scale(1.22624 .8155)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <radialGradient
        id="prefix__d"
        cx={322}
        cy={152.9}
        r={10.6}
        fx={322}
        fy={152.9}
        gradientTransform="scale(.93615 1.06821)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <radialGradient
        id="prefix__e"
        cx={364.2}
        cy={237.8}
        r={36}
        fx={364.2}
        fy={237.8}
        gradientTransform="scale(1.2242 .81686)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__b"
      />
      <radialGradient
        id="prefix__f"
        cx={468.1}
        cy={156.1}
        r={10.7}
        fx={468.1}
        fy={156.1}
        gradientTransform="scale(.95596 1.04607)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__b"
      />
    </defs>
    <path fill="#ce1126" d="M0 0h640v480H0z" />
    <path fill="#003f87" d="M0 34.3h640v411.4H0z" />
    <circle cx={320} cy={240} r={188.6} fill="#fff" />
    <circle
      cx={320}
      cy={239}
      r={156.3}
      fill="none"
      stroke="#552300"
      strokeWidth={3.9}
    />
    <path
      fill="#007f00"
      d="M302 73.2c14-15.2 26.9 2.3 26.5 10.6C328.2 92 314 110 301 95.5c13.4 3.4 17.4-11.5 24.1-11.7-6.7.2-9.5-14.6-23.2-10.6zm-147.2 119c-7.4-19.4 14-23 21.3-19 7.3 3.9 17.3 24.6-1.6 29.6 9-10.4-2.7-20.5.2-26.6-2.9 6-17.5 2-19.9 16zM471.9 173c19.4 7.6 7.6 25.8-.2 28.4-7.9 2.7-30-4-21-21.2 1.6 13.6 17 12 19.7 18.1-2.6-6.2 10.3-14 1.5-25.3zM218.8 377.4c-20.7-2-14.3-22.7-7.5-27.4 6.8-4.7 30-4.3 26 14.7-5.3-12.6-19.7-6.8-24-12 4.3 5.2-6 16.3 5.5 24.7zm209.3-15c.3 20.7-21.1 16.8-26.6 10.6-5.4-6.2-7.7-29 11.8-27.3-12 6.6-4.6 20.2-9.4 25 4.8-4.8 17.1 4 24.2-8.2zM170 153c-1.9-20.6 19.8-18.3 25.7-12.6 6 5.8 10 28.4-9.6 28.2 11.5-7.6 3-20.5 7.4-25.6-4.4 5-17.3-2.8-23.5 10zm22.2 193c-20.5-3.5-12.7-23.7-5.6-27.9 7-4.2 30.1-2.3 25 16.4-4.5-13-19.3-8-23.1-13.6 3.8 5.5-7.2 16 3.7 25zM354.3 74c18.6-9.2 24.3 11.7 21 19.3-3.2 7.5-23 19.4-29.8 1.3 11.2 7.9 20.3-4.7 26.7-2.4-6.4-2.3-3.7-17-17.9-18.2zM394 388.3c-9.3 18.5-26.5 5.3-28.5-2.7s6.5-29.3 23-19c-13.8.5-13.4 16-19.8 18 6.4-2 13.3 11.4 25.3 3.7zm90.5-178.7c15.6 13.7-1.7 26.8-10 26.7-8.2-.1-26.8-13.8-12.5-27-3 13.4 12 17 12.4 23.6-.3-6.7 14.5-9.8 10-23.3zm-263-108.8c4.7-20 24.5-11.2 28.4-3.9 3.8 7.3.5 30-18 23.8 13.3-3.7 9.3-18.6 15-22-5.7 3.4-15.5-8-25.4 2.1zm-61.6 172.5c-18.2-10-4.2-26.5 4-28.1 8-1.7 29.2 7.7 18 23.7.2-13.7-15.4-14-17.2-20.5 1.8 6.5-12 12.7-4.8 25zm263.6-159.6c20.6-3 19.4 18.7 14 24.8-5.5 6.2-28 11.4-28.9-8 8.2 11 20.8 1.9 26.2 6-5.4-4.1 1.9-17.3-11.3-22.8zM306.3 408.1c-19 8.4-23.8-12.7-20.3-20 3.6-7.5 23.9-18.6 30-.1-11-8.4-20.5 3.8-26.8 1.3 6.3 2.5 3 17.2 17.1 18.8zM476.8 293c8.6 18.8-12.6 23.7-20.1 20.2-7.5-3.5-18.8-23.6-.2-29.7-8.4 10.9 4 20.3 1.4 26.6 2.5-6.3 17.3-3 19-17.1zm-325.1-60.6c-12-17 8-25.7 16-23.6 8 2 22.8 19.8 5.7 29.2 6.2-12.3-7.6-19.3-6.3-25.9-1.3 6.6-16.5 6.1-15.4 20.2zM264 395.6c-19.6 7.1-23-14.2-18.9-21.4 4-7.2 25-16.9 29.9 2-10.3-9.1-20.7 2.4-26.8-.5 6 2.9 1.8 17.3 15.8 19.9zm-5.7-314c11.6-17.2 27-2 28 6.3.9 8.1-10.3 28.2-25.4 15.8 13.8 1.3 15.4-14 22-15.2-6.6 1.2-11.7-13-24.6-7zm200.2 252.1c1.3 20.6-20.3 17.7-26 11.7-5.8-5.9-9.1-28.6 10.4-27.8-11.7 7.2-3.6 20.4-8.2 25.4 4.6-5 17.3 3.3 23.8-9.3zm-5.3-194.4c20.4 4 12 24 4.7 28-7.2 4-30.2 1.3-24.4-17.2 4 13.1 19 8.7 22.6 14.4-3.6-5.7 7.7-15.7-3-25.2zm-258.4-14.6c.2-20.6 21.5-16.2 26.8-9.9 5.3 6.3 7 29.3-12.4 27 12.2-6.3 5-20 10-24.7-5 4.7-17-4.5-24.4 7.6zM169 311c-18.6-9.4-5.1-26.4 2.9-28.3 8-2 29.5 6.7 19 23-.4-13.7-16-13.4-18-19.8 2 6.4-11.6 13.1-4 25zM392 91c19.5-7.3 23 14 19 21.2-4 7.2-24.9 17.1-29.9-1.7 10.4 9 20.7-2.6 26.9.3-6.2-2.9-2-17.3-16-19.8zm-41.3 314.8c-15.2 14.2-26.7-4.1-25.8-12.3.9-8.2 16.3-25.3 28.2-9.9-13-4.3-18 10.4-24.9 10 6.8.4 8.5 15.3 22.5 12.2zm132.7-158c14.2 15.1-4.4 26.5-12.6 25.5-8.2-.9-25.4-16.3-9.8-28-4.4 13 10.3 18 10 24.7.3-6.7 15.4-8.4 12.4-22.2z"
    />
    <path
      fill="#005800"
      d="M301 95.5c13.4 3.4 16.7-11.3 23.5-11.5-4 4.7-14.2 16.7-23.5 11.5zm1-22.3c14-15.2 26.9 2.3 26.5 10.6-11.5-20-15-17-26.6-10.6zM174.4 202.8c9-10.4-2.8-19.9 0-26 2.6 5.6 8.9 20.1 0 26zm-19.7-10.7c-7.4-19.3 14-22.9 21.3-19-23.1 1.4-22 6-21.3 19zm295.9-11.8c1.6 13.5 16.7 11.3 19.3 17.5-5.9-2-21-7.1-19.3-17.6zm21.2-7.3c19.4 7.6 7.6 25.8-.3 28.4 14.7-17.8 10.5-20 .3-28.4zM237.3 364.7c-5.3-12.6-19.2-6.4-23.4-11.7 6.2.3 22 1.2 23.4 11.7zm-18.5 12.7c-20.7-2-14.3-22.7-7.5-27.4-9.2 21.1-4.6 22.1 7.5 27.4zm194.5-31.7c-12 6.6-4.2 19.6-9 24.3-.4-6-1.3-21.8 9-24.3zm14.8 16.7c.3 20.7-21.1 16.8-26.6 10.6 22.3 6.6 22.7 2 26.6-10.6zM186 168.4c11.5-7.5 2.7-19.8 7-25 1 6.1 3 21.8-7 25zM169.9 153c-1.9-20.6 19.8-18.3 25.7-12.6-22.7-4.9-22.8-.2-25.7 12.6zm41.5 181.5c-4.4-13-18.7-7.6-22.5-13.2 6.1.7 21.9 2.7 22.5 13.2zM192.1 346c-20.5-3.5-12.7-23.7-5.6-27.9-10.6 20.5-6 21.8 5.6 27.9zM345.4 94.6c11.3 7.9 19.7-4.7 26.1-2.5-5.4 3-19.3 10.6-26 2.5zm8.9-20.6c18.6-9.2 24.3 11.7 21 19.3-3.5-22.8-8-21.1-21-19.3zm34.2 292.6c-13.8.5-12.8 15.6-19.3 17.6 2.5-5.6 9-20 19.3-17.5zm5.5 21.7c-9.3 18.5-26.5 5.3-28.5-2.7 16.7 16 19.2 12 28.5 2.7zm68-179c-3.1 13.4 11.9 16.3 12.2 23-4.9-3.8-17.2-13.7-12.2-23zm22.5.3c15.6 13.7-1.7 26.8-10 26.7 19.9-12 16.7-15.4 10-26.7zm-252.6-89c13.3-3.6 8.8-18 14.6-21.5-1 6-4 21.5-14.6 21.6zm-10.4-19.8c4.7-20 24.5-11.2 28.4-3.9-20-11.7-21.6-7.2-28.4 4zm-39.5 168c.1-13.6-15.2-13.3-17-19.8 5.6 2.7 19.9 9.7 17 19.9zm-22 4.5c-18.3-10-4.3-26.5 3.9-28.1-16.8 15.9-13 18.6-4 28.1zm248.6-142.8c8.2 11 20.2 1.6 25.6 5.7-6.1 1.2-21.7 4.1-25.6-5.7zm14.9-16.8c20.6-3 19.4 18.7 14 24.8 3.7-22.7-1-22.5-14-24.8zM316 388c-11-8.4-19.9 3.9-26.1 1.4 5.5-2.8 19.7-9.8 26-1.4zm-9.7 20.1c-19 8.4-23.8-12.7-20.3-20 2.7 22.8 7.2 21.4 20.3 20zm150.2-124.7c-8.4 10.9 4 19.7 1.5 25.9-2.8-5.4-10-19.5-1.5-26zm20.3 9.5c8.6 18.8-12.6 23.7-20.1 20.2 23-2.8 21.6-7.2 20.1-20.2zm-303.3-55c6.2-12.3-7.7-18.6-6.4-25.2 3.8 4.8 13.5 17.3 6.4 25.2zm-21.8-5.7c-12-16.9 8-25.5 16-23.5-22.1 7-19.8 11-16 23.6zm123.3 144c-10.3-9.1-20 2.5-26.2-.4 5.7-2.4 20.4-8.5 26.2.3zm-11 19.4c-19.6 7.1-23-14.2-18.9-21.4 1.1 23 5.7 21.9 18.9 21.4zm-3-291.9c13.7 1.3 14.7-13.8 21.3-15-3.1 5.3-11.4 18.8-21.4 15zm-2.7-22.2c11.6-17.1 27-1.8 28 6.3-14.5-18-17.6-14.3-28-6.3zM443 317.6c-11.7 7.2-3.3 19.8-7.9 24.8-.7-6.1-2.3-21.8 8-24.8zm15.6 16.1c1.3 20.6-20.3 17.7-26 11.7 22.4 5.7 22.7 1 26-11.7zm-25-183.6c4 13.1 18.5 8.3 22.1 14-6-1-21.8-3.5-22-14zm19.7-10.8c20.4 4 12 24 4.7 28 11.3-20.1 6.8-21.6-4.7-28zm-244 2.6c12.2-6.4 4.7-19.6 9.6-24.2.3 6.1.8 21.9-9.6 24.2zm-14.4-17.2c.2-20.6 21.5-16.2 26.8-9.9-22-7.1-22.6-2.4-26.8 10zm-4 181c-.3-13.7-15.6-12.8-17.6-19.2 5.7 2.4 20.2 9 17.6 19.2zM169 311c-18.5-9.4-5-26.4 3-28.3-16.2 16.4-12.3 19-3 28.3zm212.2-200.4c10.4 9 20-2.8 26.2 0-5.7 2.6-20.3 8.7-26.2 0zM392 91c19.5-7.3 23 14 19 21.3-1.2-23-5.8-21.9-19-21.3zm-38.9 292.6c-13-4.3-17.4 10.2-24.2 10 4.3-4.5 15.4-15.8 24.2-10zm-2.4 22.2c-15.2 14.2-26.7-4.1-25.8-12.3 10 20.7 13.8 17.9 25.8 12.3zM461 245.3c-4.4 13 10.2 17.3 9.9 24-4.5-4.2-15.8-15.3-9.9-24zm22.4 2.5c14.2 15.1-4.4 26.5-12.6 25.5 21-9.9 18.1-13.6 12.6-25.5z"
    />
    <g fill="#730000" stroke="#000" strokeWidth={0.5}>
      <path d="M349 120.3s.6-1.3 1.7-.6c1 .8 1.3 4.2 1.3 4.2l-1.6.8s.9-1.3-1.3-4.4zm-8.8 30.7s.8-1-.3-3.4l1.5-.5s.6 1.8-.2 3.9h-1m27-5.4l-3.7 2.3 1.9.8 4.5-2.6-2.7-.5m-49.7 14.6c-1 .8-1 2.1-1.7 3-.4.7-2 1.8-2 3-.2 1.1-.3 1.9.2 3.5.6 1.5 3 8.5 2 13.7-1 5.3-.6 7.5-.3 8.3.4.8 1.6 3 2.3 3 1.6-.2.9-.7 1.5-1.7 1.4-2.5 0-22.2-.7-27.6-.5-4.2-2.5-8-2.7-8.4l-.8-2.6c-1.5-3.5-3.3-6.5-3.3-13.9 0 0-4.7 1.1-8.8-8.2-2.2-4.7-5.3-4.2-9-5.7l1.6-1.1s3.2 1.6 4.7 1.6c1.6 0 1-3.2 1-3.2l1.7-1.5v6.8c0 3.1 4.3 7.4 6.8 8.7 1.6.8 3.6-2.4 3.1-5.6-.5-3 0-7.3 0-7.3l2.2 1.3s-.8 1.3-.6 2.1c.3.8 1.3-.7 2.1-1.5 0 0 .2.2 1 .2l-2.3 4c-.8 1.2-.8 6.2-.8 8 0 2 .7 6.2.7 7.6 0 1 1.8 5 3.3 7.4l1.6 3.5c1.2 1.9 1.3 3.2 2 4.7.4.8 1 3 1.6 7l.7 7c.2 2.4 2.2.6 4.5-1 2.4-1.8 2.4-6 2.4-6s1.8-1.6 1.5-.7c-.2 1 1 2 1 2-1.4 3.3-.6 2.9.9 2.8 1.5-.2 6.5-4 6.5-4 .7-.2 3.8-.2 3.3 0-.6.3-1.4 1.7-1.4 1.7l3.3-.4c-1.1.9-5.5 3.4-6.5 4a90.6 90.6 0 0 1-8.6 4.1c-2.3 1-6.7 3.2-6.9 5.4 0 2.3.3 8.3 0 10.3l-1 10.6h-10.4s2-7.6 0-9.7c-2.1-2.1-7-8.4-10-10.5-3.2-2 2-.5 2-.5v-2.1l4.8 5.7s8.3-7.3 0-17.3c-2.6-3.1-5.3-7.9-7.3-8.4-2.2-.6-3.3-1-6.9 0-3.7 1.1-12.6 1.1-16.3-4.8l3.1-.5 2.7-1s-1.1 3.7 6.3 3.7 8.4 0 7.8-6.8l2.2-1.1 1.6 1.5s-1.1 3.8-.5 5.3c.5 1.6 3 2.7 5.1 4.2 1 .7 1.6.8 2.2.8.9-.1 1-.1 2.2-1.3 1.8-2 1.4-1.8 3.2-3.4l1-1.6 1.1 2.9z" />
      <path d="M319 155c.5-.4 1.2-1.9 2-3.1 1.1-2 2.5-3.2 4-5.6 1.5-2.2 2-5.6 1.5-7.9l1.4.8v3.7l2.7-2 .8.4s-5.9 6-11.3 15.9l-1-2.2zm-51.3-20.3c.8 1.4 1.6 4 3.9 6l1.6-.4s-3.6-4.2-3.6-6l-1.9.4m9.2-2.4s.5 5-.8 6.9l1.6-.8s1-3.4.7-5.3l-1.5-.7zm51.4-15.7s-.3 7 1.1 11.3l1.9-.5s-.3-1.3 1.2-1.9c1.6-.5 5.3-2 7.2-3.6l-.6-1.6s-2.8 2.3-4.2 2.9c-1.3.5-2 1-3.1.7-1.1-.3-2.4-2-1.6-6l-1.9-1.3m20.7 32.8s-.4 5-.2 7.2l1.7.4s-.4-6 .7-6.5l-2.2-1m7.5 3.7s-1.9 3.2-4 3.5l3.4-.7s1-.5 2.4-2l-1.8-.8" />
    </g>
    <g fill="#289400" stroke="#030" strokeWidth={0.5}>
      <path d="M326.6 138.4l1.3.8 1.3.2 3.2 2.6c1.2 1 1.2-.2 1.2-.2l.8 3.1h1l-.2 3.2 1.8-1.6 2.2 1.9s1.5-1.4 2.3-1.4c.8 0 1.1-.8 1.1-.8h.1c-5.2-2.4-7.4-5-5.9-7.6 2.6-4.4 6.8-1.6 8.1-1l19 10.2s1.3-.8.4-1.6c-1-.8-1.4-2.7-1-3.5.2-.8 2.4 2.4 3.4 2.7l3.5.7v-1s3 2.2 3 3.3c0 0 2.3-1.2 1.5-1.9-.7-.7 3.5 1.7 3.7 3l1-1c-.2 0 .2-3.2 1.3-4.6a4.8 4.8 0 0 1 2-1.9s1-1.7 2-1.7c0 0-1-.6-1.4-1.4-.5-.8-1.6-1.2-1.6-1.2s1.4-1 1.8-1.5c.4-.6.8-.7.8-.7s-2.2-1.9-3.8-2.2c0 0-.1-2.5-2-2.7h.8s-1.4-2.8-2.8-2.8c0 0 .9-1 1.6-1.1 0 0-1.6-2.2-3.9-1.4l1.5-.6s-1-1.1-4.4-.6c0 0 .3-1.3-1.2-2.4 0 0-1.2 0-1.2 1 0 0-1.2-1-2.7-1-1.4 0 .5 1.6.5 1.6s-2-1.3-3.1-1c0 0 .5-2.2-.8-3.3 0 0-1.4.7-1.8 1.7l-.4-1s-2 2.4-2.4 1.7c-.3-.4-.6-2-.6-2l-1.1 1.7.2-2.4s-1.4.8-2.5 3.3c0 0-1.3 1.3-1.3 2.4 0 0-1.1-1.2-2 0-1 1.4 0 1.1 0 1.1s-.5.5-1.5.7l.2.8s-1.2-.7-2.2-.4l.5 1.2s-2.6.2-2.7-2c0 0-2.1-1-2.4.2l-1.6 1s-.5-1-1.3-1.2c-1-.3-.2 1.3-.2 1.3s-.3-1.2-1.5-1.8c-1.2-.5-.2 1-.2 1s-1.5-1.2-.8-2.2c0 0-1.4 1.4-.7 2.7l-1 .7s-.5-.5-.4-1c0-.3-1.7 1.3-1.7 1.3s-1-2.6 0-2.6c.1 0-1.8 0-2.1 2.2 0 0-1.3 0-2.5.4s1 1.3 1 1.3-2-.4-3 .2l.7.9s-.7-.7-2.4-.1c-1.7.5.4.8.4.8s-1.7-.4-2.6 0c-.9.4.3 1 .3 1s-3.2-1-3.7-.6c-.5.3 1 1.8 1 1.8s-2 .5-2.3 2l1.8.7s-.8.4-1.2 1.1c-.4.8 1.2.4 1.2.4s-2.2 1.6-2.2 2.8c0 0 1.6.5 2.7-.7 1.2-1.2.4-.8.4-.8l.1.8s2.3-1 2.3-1.6c0-.5-.4.8-.4.8l2.2-1.2 1.5 1z" />
      <path d="M324.7 108l-.5-2.2 5 .6.9-2s2.4 1 3.1 1.8c0 0 4.6-1.2 6-.7l-.6 2.1s4.2.3 5.6.8c1.2.5-.6 1.6-.6 1.6s4.8.6 6.8 1.8c2.2 1.3 2.2 2.4 1.1 2.7l2.6 4.2s-4.2.5-5 1.5c-.7 1.1-1.5-1-1.5-1l-.8 2.9s-2.6-1.4-3.7-2.4c0 0-1.3 1.6-.5 2.4l-4.8-3.1s-2-.3-2 1.5l-3-3.4-2.6.8s-.8-1-1.7-1.4c-1.1-.2-.3 1.4-.3 1.4l-1.6-1.9-1.6-1.8s-1.3 1.8-2.4 1.8c-1 0-1-1.2-.8-2.1.3-.8-3.1-1-3.4 0 0 0-1-4 2.6-5l3.7-1zm-19 13.3l-1.6 1.6-1-.5-1.9 2.1-.4-1.1-1 1.7-1.7-.6-.8 1.3-1.5-.3s-1.2 1.2-2 1.5c-.8.2 0-1.8 0-1.8s-1.2 2-2 2c-.9 0-.6-1-.6-1s-.5 1.4-1.4 1.6c-.9 0-.5-1-.5-1l-1.6 1.2v-1l-.7-.3s.4-1.8 1.1-2.2c.7-.4-.7-1.5-.7-1.5l.7-.8s-2-.5-2-.1c0 0 1-2.6 2.4-3.1l.1-3s1.4-1.1 2.6-1.2c1.4-.2-.4-2.3-.4-2.3l3.2-1.8.4-2.3 4.7.4 1-2 3.8 1 3.3-1.7 2.3 2.7 3.5.3v3.1s4.1 1.3 4.6 1.7c0 0-.8 2.5-.8 3 0 0 3-.8 3.8-.6l.4 3.4s5 1.6 5.3 2.5c0 0-1 .7-1.7 1.6 0 0 .6 3 .6 4l-.4.5s-1.4-1.3-2.6-1.5l-1 2.1-1.7-1.1h-1.1s-.9-1-1.6-1v-1l-1.4.9s-2.2-1.1-2.2-1.8l.1-1.5-2.2 1.5s-.5-1.1-.4-1.6c0-.5-.9 1.1-.9 1.1s-1.2-2-1-2.4l-.4 1.7s-2.3-.8-2.6-2.4z" />
      <path d="M274.5 130.9s4.1 2 4.1 3c0 0 1.1-2.1.5-3l1.6 1.1s.5-1.9-.1-2.5c-.5-.5 3.5-2.1 4.4.5 0 0 2.4-2.5-2.3-4.7 0 0-.4-1.6 2.5-1.2 0 0-.2-1-.9-1.3h2.7s-1.6-1.4-4-1.8c-2.4-.4-1-.7-1-1.2-.2-.5 0-2.2 0-2.2s-1.4-.5-2.5 0l.4-.4s-2.5-.7-3.5-.1c0 0-1.5-.6-1.3-2.1 0 0-1.5-.1-2.1 1.4 0 0-1.4 1.6-3.3 1.6-.3 0-1.7-.8-1.7-.8l-1.2 2.7H265l.5 1s-2.8-.8-3.7 0c0 0 1.1 1.7.8 2.8 0 0-2.2.4-2.7.8-.6.4.8.7.8.7s-2.6.8-3.2 1.6l1 .7-1.2 1.6 1 .2-2.5.8c-.9.3 1.5.5 1.5.5l-1.1 1 1.8.3s-1.4 4-1.5 5.8c0 0 2.2-2.7 2.8-3l-1.8 3s3.4-1 3.7-1.6l.5-1 .1 1.6s1.3-1.7 1.5-2.4c.1-.7 2 .7 2 .7v-1l2.4.7c.7 0 .8-.3.8-.3l1.6-.2-.3 1.4s1.2-.8 1.5-1.6c.2-.8.8 0 .8 0l.8-3.1h1.6zm-13.4 13.8l1.6 3.3c-1.3 0-3.1 1.5-3.1 1.5.3 5.4-1 5.1-1 5.1.3 1-.3 2.8-.3 2.8l7.7-4.6.1-.5 9.2-4.3.3.5 2.6-1.5 1.9 4.9-1.9 1c.1 1.7 2.1 4.6 2.1 4.6l2.4-.6 2.7-1v1c0-.3 2.9-1.3 2.9-1.3l1.3 1.3c1-.1 2.7-2.5 2.7-2.5l2 .8s.7-1.2.7-2 2.6-.8 2.6-.8l1.7 1.2 2.3-1.8s.7 1.3 1.6 1.5c1 .1 3.4 2 3.4 1.6 0-.4 1-2.5 1-2.5l4.1 1.6c-.5-1.8-2-4-2-4s2-1.6 1.7-2c-.4-.4-1.6 0-1.6 0l1.2-2.4h-1.6l.5-.6-2.5-1 1.3-2.8c-.6-.7-7.3-2-7.3-2l1.6-1.5s-.8-1.2-1.6-1.2-4.9.1-5-.3l-1.8-1.8-2.6 1.9-1.3-.4-2.2.8s0 1.3-.3.4c-.3-.8-2.3-2.8-2.3-2.8-.4.7-3 3.8-3 3.8s-.5 1.7-1.3.5c-1-1.2-3-2.4-3.4-1.5-.2 1.1-2.1 2-2.5 1.8-.4-.3-2.5-.1-2.7.5-.1.7-2.5 2.4-2.5 2.4-1.4-.7-3.8-.3-3.8-.3s-.7 1.1-.8 2l-4.7 1.2zm44.2 39.6v-2l2.3 1.5 1.4-1.5 1.8 1.7 1-1.7v2.8l2.7-2.3 1.5.6v-2.2s1.9-3.1 1.1-3.7l1.6-.5s-2.7-2.6-3.4-3.1c-.8-.6-1.9-.6-1.9-.6s-2-2-3.4-2.7c-1.3-.5-2 .6-2 .6s-.8-1.5-2.2-1.8c-1.3-.3-1.3 1-1.3 1s-1-1-2.2-1.4c-1.3-.6-.4 1.2-.4 1.2l-4.5-1.4.6 1.4-4.2-1.1.5 1.5-3-.5-.2 1.3-4.2.8.8 1.4-2.6-1.1v1.9l-3 1 1.1 1-4.7 2.4c-.7.5 1.6 1.6 1.6 1.6l-4.2-.6 1.6 1.4-3.7 3.4 2.6 1.9-1.6 2.3 4 .8 1.5 2.6 3.2-.6v3l4.7-3.7s3.4 3 3.7 2.1c.2-.8.2-3.4.2-3.4h1.7V187l1.2 1 2.2-3.1 2.8 3.9 2.2-5 3.1.5zm19.1-11.8l-.4-4.5-1.4 1.4.6-4.2-2.2-.4.8-4.1-1.6-.8.4-2 1.6-1.1 2.8-2.8 6.6.1.7-2.1 4.7.8c.8.8 3.3-1.8 3.3-1.8h1l1 2s3.4-.4 5 .6l-1.9 2.6 3.5.3 2.3.5 2.4-.8 3.2-.2.7 1.3h3l-1 1.1 3.8 1.8-.8.8s2.2.8 3.7.8h.8s.8 1.8-.3 2.6c0 0 1.1 2.6 3.4 3.1 2.4.5 2.4.5 2.7 1 .3.6 0 3.2-2.7 3.2v2.7s-2 1.8-2.3 2.6l-1.6-1s-1.3 1.5-1.3 2.5c0 0-3.5-4.5-4.7-4.7-1.4-.2-1 2.6-1 2.6l-3.8-3.1-.5 2.1-3.1-2.6-1.9 1.3-3.3-3.5-3.2.4 1.2-1.6h-3.9l-.7-3.4-.6 2.8-2.4-1.6-3 3.3s-.4-.4-.9-2c-.5-1.5-1.8 2-1.8 2l-1.1-2.5-1.3 2.4s-1-1.8-2.1-2.4c-1-.5-2 3-2.4 4.5zm.6 10.3l.2-1.6 5.6-2.2 4.7-1.7 2.3-1.1 1.1 1.9 1.4-2.7 2.1 2.8 1.2-1.5 1.8 1.4h1.6l.3 2s3.9.3 4.2-.5c.3-.8.8 2.7.8 2.7l3.7.5.8 4.2s1.8 3.9 1.2 5.4c-.5 1.7-2-2-2-2s-.3 2.9-.6 3.7c-.2.8-5-.8-5-.8l-2 3.9s-2.2-3.1-3.2-3.1-1 3.1-1 3.1l-4.5-5.3c-1.3-1.5-1.6 1.6-1.6 1.6s-2-3.4-2-4.4c0-1-1.9-2.2-1.9-2.2s-3.2 3.7-5.6 4.7c0 0 .3-2.3-.5-3-.7-.9-3 1.5-3 1.5s-1.7-3.6 0-7.4z" />
    </g>
    <g fill="none" stroke="#004b00" strokeWidth={0.5}>
      <path d="M350.8 124.5l.5 2s1.8-.4 3-.3l-.7 2.2s2.3-.4 3.4.3l-.5 1.2 2.7 1.2-2.5 2s4 1.5 4.9 2.7c0 0-2.7 1.8-3 1.7-.5-.2-.2.8.5 1.7l-2.2-.1s.9 2 .8 2.8c-.2.8-3.8.6-3.8.6m14.1-5.3s.7-3.9-.4-4.9c0 0 2.5 2.2 4.2 2.3 1.8 0 0-3.2 0-3.2s2.3 1.2 3.5 1.5c1.2.2-.9-2.4-.9-2.4s.7-1.3 2.7-.1m-45.4-15.5s0-1-.3-1.4c-2.4-3.2 2.4 2.4 3.4 2.6m4.5 0s1.6 1.2 2.3 1.2c.8 0-.5-3.1-.9-3.5-.3-.4 2.9 1.3 4 1.4 1.2.3 1.4-2 1.4-2s3.6.7 4.4 1.2m-25-.7l-.5-3m-24.2 12.7c-.2-.3 1-2 .5-2.9 0 0 .7.6 1.4.7.6.1.4-2.2.4-2.2l.7.3s2-1 1.7-1.8c-.4-.8 1.4 1.2 1.4 1.2s1.1-1.2 1.1-1.7 1.4 1.2 1.4 1.2 1.5-.3 1.5-1.2c0-.9 1.8.3 1.8.3s.8-1 .7-1.8m-19.7 9.8s.9-2-.1-3.4m-23.6 9.8c0-1 .5-3.6 0-4-.4-.4 1 .4 2.2.7m9.3-.4c-1.2-1.1-1.9-1.7-3.7-1.7m-16.2 8.3c.3-.7.8-2.4.5-3.3m25 51.7l1.3-2.6 1.6 3.7 1-2.3.4.7 2.4-2.5 2.5 3.8m40.7-16.5l1.7-3.3 2.3 1.2 1-3.3 2.4 1.5 1.3-3 2.7.7.2-2.2s1.8 1 2.3 1.9c.6.7 0-2.7 0-2.7l2.2 1s1.5-1.6-.6-2.4" />
      <path d="M343.6 163.1l2.3 3.4 2-2.2 1.7 3.8 2.3-1.4 3.2 1.9 1.5-1.2 3.5 2.5 1.4-3 3.2 1 2-3.5m-84.4-9.2s1.4-2.3 1-3.4c-.7-1 2.8 1.8 2.8 1.8s.7-2.3.3-3.4c-.6-1 3.9 3.2 3.9 3.2s.7-3.7 0-4.4c-.8-.8 4.3 1 4.3 1s2-.6 1.2-1.6c-.8-1.1 3.4 1.5 3.4 1.5s1-2.6 0-3.6 3.2 1.3 3.2 1.3l-1.6-2.8 3.4.2-.3-3.2m30.3 45.1l2.2-1 2 2 2.2-3.5 2.6 2.5.4-2.5 2.8 1.2.6-1.6 3.1 1.7.3-2.4 1.6.5.3-1.5" />
    </g>
    <path
      fill="#9dd7ff"
      d="M283.1 298.1a69.8 69.8 0 0 1-6-13l42.4-37.2 42.3 37.1a64.7 64.7 0 0 1-6.2 13.3l-.3.5-3.2-1.2s-1.4 1.3-2.5 1.4c-1.4.2-2.7-1.3-2.7-1.3s-1.8 1.6-3.7 1.3c-1.9-.2-2.6-1.4-2.6-1.4s-2 1.6-3.4 1.3c-1.2-.3-2.1-1.2-2.1-1.2s-1.2 1.5-2.8 1.2c-1.6-.3-3-1.2-3-1.2s-2.5 1-4 1.3c-1.6.3-3-1.4-3-1.4s-2 1.4-2.8 1.4c-.8 0-3.7-1.4-3.7-1.4s-3 1-4.1 1c-1 0-4-1.3-4-1.3s-2.9.8-4.1.8c-1.4 0-3.4-.8-3.4-.8s-2.3 1.1-3.6.8c-1.4-.3-2.4-.8-2.4-.8s-2.6 1.1-4.2.8c-1.6-.3-3.4-1.4-3.4-1.4s-.3.8-3.4 1.4"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.7}
      d="M319.5 205.1V248l-42.3 37.4a84.2 84.2 0 0 1-4.4-27.1V205h46.7"
    />
    <path
      fill="#ffd83c"
      stroke="#000"
      strokeWidth={0.7}
      d="M319.5 205.1V248l42.2 37.4a84.2 84.2 0 0 0 4.3-27.1V205h-46.5"
    />
    <g stroke="#000" strokeWidth={0.5}>
      <path
        fill="#730000"
        d="M292.2 289.2c3.2 1.7 2 1.2 8.7 3.5a61.8 61.8 0 0 0 20.7 2.8c8 0 12.4-.7 15-1.4 2.5-.7 3.1-1.8 3.1-1.8l-6.5 6.7s-26.3 1.4-31-1.7c-2-1-6-4.2-10-8z"
      />
      <path
        fill="none"
        d="M330.8 276.8s8.4 4.8 0 14m-37.8-1l12-11.6-1.3 15.4m6.3 1.4v-25.8m20.8 25.8v-27.4m-10.5 27.9V266"
      />
      <path
        fill="#ff0018"
        d="M310 270.6l-5.4 1.7 5.4.6v-2.3m10.3-4l-5.8 2.1 5.8.2v-2.4m10.5 1.6l-5.8 2.2 5.8.3V268zm3.4 12.4c-.3-1.1 3.4-1 3.4-1s1 3.9 0 6.3l-3.1-.6s.3-2.6-.3-4.7z"
      />
      <g fill="#fff">
        <path d="M294.8 288.1l10.3-10-.5 6s-5.3 3.5-5.3 5.9l-4.5-1.9m5.5 2.1s1-3.1 4-4.7l-.3 6.3-3.7-1.6zm14.7-17.3s4.2-.6 7.4 0c0 0-.5 4.2 0 5 0 0-5.8-1.4-8.1.8 0 0-.8-4 .7-5.8zm-8.9 1s4.2-.5 7.4 0c0 0-.8 4.8-.3 5.5 0 0-4.7-2.6-7-.4 0 0-1.6-3.3 0-5z" />
        <path d="M305.9 279.4s4.2-.4 7.3 0c0 0-.5 4.3 0 5 0 0-5.5-1.2-7.8.8 0 0-1.1-3.9.5-5.8zm8.4-.7s6-.8 9.1-.3c0 0-1.2 3.4.3 5.7 0 0-6.5-1.7-9 .3 0 0-2-3.9-.4-5.7zm-9 6.5l8.2.6s-.8 6-.3 6.7c0 0-6.6-1.5-7.8.6 0 0-2.2-5.4 0-7.9zm9.2 0s7-.5 10.3 0c0 0-1.9 4.5.2 8.4 0 0-9.2-2.6-10.5-.5 0 0-2.1-5.4 0-7.9zm10.8-12.3s4.2-.6 7.3 0c0 0-.5 4.2 0 5 0 0-5.8-1.4-8 .8 0 0-.9-4 .7-5.8zm0 5.8s4.2-.5 7.3 0c0 0-.5 4.2 0 5 0 0-5.8-1.3-8 .7 0 0-.9-3.9.7-5.7zm.5 6s4.2-.6 7.4 0c0 0-1 6.6-.6 7.4 0 0-4.8-2.3-7-.3 0 0-1.4-5.2.2-7z" />
        <path d="M334.5 285.2s1.3 5 3 5.6l-2.2 2.8s-2.9-2-3.2-4.4c0 0 1.9-2.1 2.4-4z" />
      </g>
    </g>
    <g stroke="#000" strokeWidth={0.6}>
      <path
        fill="#006ac8"
        d="M355.4 298.7a66.2 66.2 0 0 1-36 28.3 67.3 67.3 0 0 1-36.3-28.8h.1c3-.7 3.4-1.5 3.4-1.5s1.8 1.1 3.4 1.4c1.6.3 4.2-.8 4.2-.8s1 .5 2.4.8c1.3.3 3.6-.8 3.6-.8s2 .8 3.3.8c1.3 0 4.1-.8 4.1-.8s3 1.3 4 1.3c1.1 0 4.2-1 4.2-1s2.9 1.4 3.7 1.4c.7 0 2.8-1.4 2.8-1.4s1.4 1.7 3 1.4c1.5-.2 4-1.3 4-1.3s1.4.9 3 1.2c1.6.3 2.8-1.2 2.8-1.2s.9.9 2.1 1.2c1.4.3 3.3-1.3 3.3-1.3s.8 1.2 2.7 1.4c1.8.3 3.7-1.3 3.7-1.3s1.3 1.5 2.7 1.3c1.1-.1 2.5-1.4 2.5-1.4l3.3 1"
        stroke="none"
      />
      <path
        fill="none"
        strokeWidth={0.5}
        d="M353.7 301.2c-1.4.1-1.6-.8-1.6-.8s-2 1.6-3.8 1.3c-2-.3-2.9-1.5-2.9-1.5s-2 1.6-3.4 1.3a5 5 0 0 1-2.3-1.1s-1.3 1.4-3 1.1c-1.6-.2-3-1.1-3-1.1s-2.7 1-4.4 1.3c-1.6.3-3-1.5-3-1.5s-3.8 1.2-4.6 1.2c-.9 0-3.6-1.2-3.6-1.2s-1.9 1.1-3 1.1-4.2-1.3-4.2-1.3-3 .8-4.3.8c-1.4 0-3.5-.8-3.5-.8s-2.5 1-3.9.8l-2.4-.8s-2.7 1-4.4.8c-1.6-.4-3.6-1.4-3.6-1.4s-.3.7-3.5 1.4h-.1"
      />
      <path
        fill="#5ac800"
        d="M293.1 305.2s-.3.7-2.8 1.2l-.7.2.6-.2-.7.3a44 44 0 0 0 11.7 11c4.5 3 9.6 6.6 18.4 9.2a71 71 0 0 0 17.8-9c6-4.5 9.2-7.2 12.6-11.7-2.7 1.5-2.3 1.5-3.7 1.3-1.3-.3-2.3-1.3-2.3-1.3s-1.3 1.5-3 1.3c-1.6-.3-3-1.3-3-1.3s-2.2 1.5-4.4 1.4c-1.6-.1-3-1.6-3-1.6s-3.8 1.3-4.6 1.3c-.9 0-3.6-1.3-3.6-1.3s-1.9 1.2-3 1.2-4.2-1.4-4.2-1.4-3 .8-4.3.8-3.4-.8-3.4-.8-2.5 1-4 .8c-1.3-.3-2.4-.8-2.4-.8s-2.7 1-4.4.8c-1.6-.3-3.6-1.4-3.6-1.4z"
      />
      <path
        fill="#ffd800"
        d="M319.6 326.9a89 89 0 0 0 17.1-8.6c-1 0-4-1-2.9-1.2 0 0-1.2 1-2.3 1-1.1 0-4.2-1.3-4.2-1.3s-3 .7-4.3.7c-1.4 0-3.4-.7-3.4-.7s-2.6 1-4 .7l-2.4-.7s-2.8 1-4.4.7c-1.6-.3-3.6-1.3-3.6-1.3s-2.4 1.3-4 1.4a55 55 0 0 0 18.4 9.3z"
      />
    </g>
    <g stroke="#000" strokeWidth={0.5}>
      <path
        fill="#b34b00"
        d="M313.2 249c1.9-1.6 3-3 2.3-4.2-.7-1-1.8.6-3 .2 0 0-2-1.1-2.5-2-1-1.2-2.5-2.3-3.3-3.4-.9-1-4.2-5.3-9.1-10.3-1.5-.9-1.1-4.4-2.2-5.5 0-.8-10-10.6-13.4-14-1.5-1.1-2.2-1.8-4.7.5-2 1.7-2.7 3.6-.1 5.8l12.8 11.7c1.9 1.8 4.5 2.1 5.6 3l13 13.4c1.7 1.4 2.5 2.4 1.5 3.6-1 2 .1 2.3.3 2.3.2.1 1.1.1 1.7-.4l1-.7z"
      />
      <path fill="none" d="M280.7 214l13.4 13.2" />
      <path
        fill="#fff"
        strokeWidth={0.6}
        d="M298.8 220l1.1-2.5c.2-.4 3.8-6.2 5.6-6.3l11.3 8.2c0 .5-5 7.8-5.3 7.2 0 0-13.2-5.5-12.7-6.6z"
      />
      <path
        fill="#ccb8c8"
        d="M306 222c-1.6-1.2-4.1-2.4-6.2-3.8l-.9 2c.7.8 10 5.1 11.6 6 0 0-1.8-2-4.6-4.2z"
        stroke="none"
      />
      <path
        fill="none"
        strokeWidth={0.4}
        d="M299.8 218a73 73 0 0 0 5 3.1c2.7 2 4.4 4 6.4 5.2"
      />
      <path
        fill="#782121"
        d="M277.1 253l25.5-31.7c.5-.4 2.9-.4 3.2 2l-24.2 33s-2.7-.3-4.5-3.4z"
      />
      <path
        fill="#730000"
        d="M362.7 253.3c-1 .7-2.4.8-2.4.8-1.7-1.9-3-4-5.4-6.5l-25.5-31.3 2.7-2.6 23 26.9c.6.7 4.6 4.9 8.4 9.8 0 0 .3 2-.8 2.9z"
      />
      <path
        fill="#fff"
        d="M338.1 220.3l-4-5s-3.2.5-3.8 2.1c0 0-2.2 3.7-8.2 4.1 0 0 1.7 7 8.6 10.7 0 0 2.5-7.2 5-8.4 0 0 2.5-1.9 2.4-3.6z"
      />
      <path
        fill="#730000"
        d="M327.9 242c-.6-.3-1.2 0-2 .4-.9.5-1.8.3-1.7-.7 0-.8 0-.7 1-1.4a6.3 6.3 0 0 1 5-.5l-2.3 2.1m27.8-27.7c-.2-.7-.4-1.4.3-2.2.7-.8.7-2.2-1-1.5-1.7.7-2.2 2.5-.9 5.4l1.6-1.7z"
      />
      <path
        fill="#fff"
        d="M327.3 242.5l28.9-28.7 7.1 7.6s-1.5-.6-2-.2c-.5.4.5 1.9.5 1.9s-1.3-.5-1.9-.1c-.7.4 0 2 0 2s-1.2-.8-1.8-.5c-.5.4 0 2.3 0 2.3s-1.5-.5-2-.1c-.3.4 0 2 0 2s-1.5-.7-2.3 0 .4 1.9.4 1.9-2-.8-2.7.4c-.8 1.2.1 2.2.1 2.2s-1.6-.7-2-.4c-.4.4 0 2.3 0 2.3s-1.3-.8-2.2.2c-.9 1 .1 2 .1 2s-1.3-.8-2-.4c-.6.4.2 2.2.2 2.2s-1.2-.9-2.1 0c-.9 1 0 2 0 2s-1-1-2.2 0c-1 1 0 2.1 0 2.1s-1.5-.8-2.1 0c-.7.8.2 1.9.2 1.9s-1.2-.7-2-.3c-.7.4 0 2.1 0 2.1s-1.1-1.3-1.6-.6c-.6.7 0 2.4 0 2.4s-1-1.3-1.6-.6c-.7.6.4 2 .4 2s-2-.8-1.5-.8z"
      />
      <path
        fill="#7e4b7e"
        d="M354.5 216.2l-2.2 2.2.5 7.7s.5-2.2 1.1-.7c0 0 .2-1.8.7-1.5-.4-.2 0-7.8 0-7.8m-4.3 4.3l-1.6 1.5.6 7.7s.4-2.9 1.1-.6v-8.6m-17.6 17.2l-1.5 1.7.4 4.7s.5-3 1.1-.7l-.2-2.6.2-3"
        stroke="none"
      />
      <g fill="none" stroke="#7e4b7e" strokeWidth={0.9}>
        <path d="M330.9 218.3c1 1 4 5 4 5m-2.6-2.9c-.2.6-.6 2.3-1.5 3.2m2-2.8c-.2.4-.2 1.7-1.5 3m2-2.4c-.3.7-.4 1.2-.8 1.7m1-1c0 .4-.3.5-.4.8m-3.2-2.7a29 29 0 0 1-4.8 2.8m4-1.8a14 14 0 0 1-3.1 2.2m2.8-1c-.5.4-1.5 1.4-2.3 1.7m1.8-.5c-.4.5-1 .8-1.5 1.1" />
        <path
          strokeLinecap="square"
          d="M311.3 224.7c.3-.6.9-1.8 1.6-2.8 1-1.4 1.3-1.6 1.8-2"
        />
      </g>
    </g>
    <path
      fill="#289400"
      stroke="#060"
      strokeWidth={0.5}
      d="M217 303.4c1.5.7 0-4.8.5-6.8.6-2.2 4.8 5.2 6.8 6.2 2.2 1 15.3-5.2 15.3-5.2l3.1-5.8 1.7 4.8s3.6-4.2 4.6-5.8c1.1-1.6 0 3.1-1 4.7-1.1 1.5 3.1 2.1 2.6 5.3-.5 3 4.2-2.2 4.2-2.2l12.1 1s2-7.3 5.3-11.5l1 4.8 5-5.1a65.9 65.9 0 0 0 41.3 39.2 66.6 66.6 0 0 0 40.2-36.6l6.7 7s5.3-1.6 6.3-2.2a70.3 70.3 0 0 1 15.5 5.6c1 .7.3-3.5.3-3.5s5.8 1.1 5.3 4.2c0 0 1.2-2.9 2.3-3.4 1.1-.5 3.6 2.7 4.2 3.7.5 1 13 2.6 14.7 3.6 0 0 1.3 1.6 1.3 2.7 0 0 2.7-.3 4.7-.3 0 0-1.5.8-1.5 2.4 0 1.6-.8 2.9-2.4 3.6-1.5.8 0 1.4 2 1.6 2.2.3 0 3-4.1 4.5 0 0-1 2.3.8 3.1 0 0-3.7.3-4.2-.8 0 0-1.3 2.5-1.3 3.8 0 0-4-1.3-5-1.9 0 0-1.6 1.6-.5 2.3 0 0-7.1-.7-8.5-3.4 0 0-2.5.8-2 1.7 0 0-5-3.4-6.6-3.4l-1 1.7s-3.5-2-4.5-2-.2 1.5-.2 1.5l-4.8-2.9-1.9 3-5-2.7c-1-.8-1.2 1.6-2 1.9 0 0-1.6-2.2-3.7-1.9 0 0-.8 2.6-.5 3.4l-7.1-1.5c-1.1-.3-.5 1.2 0 2.3 0 0-4.5-1.3-5.5-2l-.3 2s-3.7-.3-4.5-1l-2.3 3.1h-3.5l-.7 2.9s-6.6-1.9-7.2-.8c-.5 1 .3 2.6.3 2.6l-5.7-.7-.5 2.3s-6.7-2-8.2-1c0 0-2 2-3.4 2.6-1.3.5 0-.8 0-.8l-2-2.9s-2.4 1.3-3.8.8c-1.3-.6-5.5 2-6.8 1.3 0 0 0-1.9-1.1-2.4-1-.4-2.8-.4-3.6.8l-2.2-3c-1.2-2.2-3.1.1-3.1.1l-.3-2.5-3.6-.3c-2.2-.3-2.6-2.2-2.6-2.2s-5.6.6-6.4.3l1.4-1.3s-7.6 1.6-9.2 1c-1.7-.5 1.8-2.6 1.8-2.6l-8.4-2c-1.3-.4-9 1.2-10 1.2s-1.6-1.8-1.6-1.8-1.8 1.6-3.4 2.1c0 0-1.3-3.1-.5-3.4 0 0-5 1.3-5.3 2.6 0 0-1.2-2-1-3 0 0-2.4 3.8-3.5 4.6-1 .8-.2-1.9-.2-1.9s-2.9 3.7-4 4v-2.6s-8.4 4.5-10.7 3.9c0 0 0-1.9.8-2.4l-5.3-.2c-1.3-.2-2.8-.8-4.2-1.1-1.3-.2 1.9-1.6 4-1 0 0-5.8-2.1-7.6-1 0 0-.8-2.2 2.3-3 0 0-4-3.9-6.3-3.6 0 0 2.6-1.6 4.8-.8 0 0-2.5-6.6-4-7.4 0 0 5.5-1 7.1-.2z"
    />
    <path
      fill="#730000"
      stroke="#000"
      strokeWidth={0.5}
      d="M208.9 188.8L280 152c.3-2-.7-3.4-1.9-5-20.3 10-38.8 22.2-61.4 29.5-1.3.5-12.5 5.2-18.3 12.1a7.7 7.7 0 0 0-2 4.5s.2 3.1.9 4c0 0 .1.8 1.2 1.5 0 0 .7.3 1.1.2.5 0 1.4 0 2.6-2a52.4 52.4 0 0 1 6.7-8z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.5}
      d="M266.1 152.4l9.2-4.4s3.1 2.3 2.8 5c0 0 .7 6 8.2 10.2 0 0-6.3 8-17.4 8.6 0 0 1.2-10.4-1.1-13.5 0 0-.4.4-.2-.1.3-1-.2-4.5-1.7-5.3l.2-.5z"
    />
    <path
      fill="none"
      stroke="#7e4b7e"
      strokeWidth={0.8}
      d="M276.9 153.6c-2 .8-8.3 4.1-8.3 4.1m5.2-2.1c0 1-.6 3.3 0 5m-.8-4.7c0 .5-.8 2.2 0 4.6m-1-4.1c-.2 1-.4 1.5 0 2.6m-.8-2c-.2.5 0 .8 0 1.2m5.8-1.5c.3.7 2.9 4.8 4.5 6.5m-4.1-4.7c.3.8 1.7 3.6 2.8 4.7m-3-3c.4 1 1.1 2.7 2 3.7m-2-1.8a8 8 0 0 0 1.1 2.5"
    />
    <g stroke="#000" strokeWidth={0.5}>
      <path
        fill="#b34b00"
        d="M342.3 148.3l26.1 12.8c5.2 2.5 7.1.2 10 1.5l51.6 26.2c4.5 2 7 2.5 6.3 4.8-.1 3.7 1.7 3.7 2.2 3.8.4 0 2.1-.2 2.8-1.2l.6-.6c.6-.6.5-.7.7-1 2.1-3 3.3-5.8 1-7.5-2.5-1.3-2.8 1.5-5.6 1.2 0 0-4.8-1.8-6.6-3.1-3.2-1.8-7.8-3.9-8.8-5-3.3-.6-28-14.6-42.1-21.6-1.5-1.2-2.3-5.9-5.3-7.4-.8-1.3-19.8-10-29.8-15-3.6-1.3-5.7-2.2-8.3 2.3-2.3 4.4-1.8 6.8 5.2 9.8z"
      />
      <path fill="none" d="M344.5 142.8l29.2 14.6" />
    </g>
    <g
      fill="#ffa54b"
      stroke="#000"
      strokeWidth={0.5}
      transform="translate(-40) scale(.96)"
    >
      <path
        fill="url(#prefix__c)"
        d="M309.7 165.1c-.2.6-.7.2-.7.4-.4 2.2-.3 3.3-.8 4.5a7.1 7.1 0 0 1-3.1 2.6c-2 .7-4.5 3.1-8.5.9l-.6-.5s1.1 4.1-3 6.2l-15.7 8.2s-1.5 2.8-.5 6.5c0 .6.3 1.1-.3 1.5-1 .7-2.7 2.8-3.7 6 0 0-3-1.3-3-3.2 0-2 1.2-3 1.5-4.4.3-1.3 1-4.7.7-5.7-.4-1.1-2.3-1.5-3-2-.6-.3-1.4.5-1.3 1.4.1 1 .8.8 1.6 1 0 0-.9 2-.8 3.4l-9.2 4.8 1.6 2.3c.4.7 1.3 10.2 4 14.7s3.7 3.2 4.3 3.8l2 2c.8.5 4 .8 4.5-1a9 9 0 0 1 3.2-4.1c2-1.6 6-5.4 6-7.2 0 0 2.3 6.8 2 12.4 0 0 8.5 1.7 16.1 1.9 7.6 0 11.5-1.5 11.5-1.5s1-6.4.6-7.7c0 0 1.2 4.2 2.2 5.6 1 1.8 2.1 5.3 4.3 5.5 2.2.1 4-2.1 4.2-3v-6.8h8.7s3.8 1.5 5 1.3c1.3-.1 2-1.3.8-1.7l-.4-.3c1.2 0 2.6.7 2.6.7h4.3l-.1-.5c-.3-1.2-2.6-2.2-4.2-3-1.6-.5-3.5-1.2-4.7-1.3a20 20 0 0 0-6.2.4c-.8 0-3.9.4-5.8 1.3-.5.3-1 .4-.8-1 .3-1.3.2-7.8-1.3-10.5-1.2-2-1-3.6-.9-5.2a87 87 0 0 0 0-8.8c-.3-1.7-2.5-4-6.6-4.4-3.8-.5-7-3.7-7.3-6.2-.3-2.6.4-7.2.8-9.3"
      />
      <g fill="none">
        <path
          fill="url(#prefix__d)"
          d="M292.4 153.6c-.7 3.3-.7 6.1-.6 9.3.1 2.1 1.1 4.6 2 6.7a10 10 0 0 0 2.8 3.9c3.6 2.3 7-.2 8.9-1a6.4 6.4 0 0 0 2.7-2.5c.5-1.2.3-2.1.8-4.5l.7-.4c1-1.5.7-2 1.2-3 .6-1-.5-2.2-1.8-2 .6-1.9 1-4 .4-5.9-.2-.6.5-2.2-.6-1.8-4.6 1.8-10 1.4-14.8 1.4-.4 0-.8-.8-1.4-.7l-.3.5"
        />
        <path
          fill="#000"
          d="M292 155.3c-.5-.4-.6-1.3 0-3.2.7-2 0-2 1.1-3.2s.9-1.6 1.6-1.9c.7-.2 2.8-.2 3.5-.5a11 11 0 0 1 9-.3c1.5.8 2.5 2.8 3.4 3.6 1 .7 1.7 3.6 1.5 7.9-.3 4.3-1.2 3.5-1.2 3.5s-1.2-2-2.2-.3c0 0 0-1.7.2-3 .1-1.1-.6-3.4.1-4.9 0 0-5.8 1.8-8.7 1.7-3-.2-7.4-.9-7.6-1.6l-.7 2.2"
        />
        <path
          fill="#fff"
          stroke="#fff"
          d="M295 151.8c-.3-.6-1.8-2.9-.6-3.6 1-.6.4 2.8 2 3.5 0 0-.6 1.5-1.4.1z"
        />
        <path d="M298.3 160.1l-.9 3.2m10.6 1.6c.2.6.4.3 1 .4m.3-4c.5-.5 1.2-.2.8 1.3m-17.7-4.9l2.8 1c1.5.6.6 2.9.2 4.3-.2.7-1 2-.6 2.5.5.8 1.1.3 2 .4 0-.3.6-.5.8-.5.7 0 1.1.5 1.7.3.6-.3.5-1.2.3-1.7m-.1-4.5c0-.4 1-.8 1.5-.9 2.1-.4 3.6-.7 5.4.5m-5.7 11.1c-1.8.4-3.6.7-5.2-.2m0-.8c.8-.4 1.1-.8 2.1-.3a5 5 0 0 1 1.1-.4c.8 0 1.4.3 2.2.8m-5.5.3c1-.3 3.3-.3 5.4.1" />
        <path
          fill="#fff"
          strokeWidth={0.3}
          d="M292.3 160.1c.7 0 1.6-.9 3.2.3 1.1.8-1.8 1.5-1.3 1.4-1.4.2-1.8-.5-1.9-1.2 0-.1-.2-.5 0-.5zm8.4.8c.7-1.4 1.8-1 2.8-.8 1 .3.7.1 1.7.7-1.2.1-.9.2-1.7.6-.9.5-1.7.7-2.3.3-.2-.2-.7-.5-.7-1 0 .2 0 .3.2.3z"
        />
        <path
          fill="#000"
          strokeWidth={0.3}
          d="M293.8 161.4c.4 0 .7-.4.7-.8 0-.6-.3-1-.7-1-.5 0-.9.4-.9 1 0 .4.4.8.9.8zm8.6.2c.4 0 .7-.4.7-1a.8.8 0 0 0-.8-.8c-.4 0-.7.3-.7.8 0 .6.4 1 .8 1z"
        />
      </g>
      <g id="prefix__g">
        <g fill="none">
          <path d="M345.9 213.7a3.9 3.9 0 0 0-1.9-1.4l-2-1c-.7-.4-1.7-.5-2.4-.9m.5 2.6l-.9-.5c-.3 0-.7 0-1-.2 0 0 0-.2-.2-.2a3.5 3.5 0 0 1-2.4-1.3m-62.8-9.3c1 .7 3.2 2.2 3.4 5.1a10.5 10.5 0 0 0 1 3M264 202c.5 1.7.6 7.4 6 13.4m-5-21.4c-.4 1.1-1 2.2.2 3m14.4 10.7c1.1-2.6 4.6-2.4 4.6-4.8" />
          <path d="M284.8 207.3c-.3-2.9-1-4.5-.4-8.7.2-1.2.4-5.9 0-8.1 0 0 1.6 7.8-3.7 9.3m34.4 12.5c0-4 1-6.2 1-6.2 1.2-5.6-1.2-7.7-.3-9.1.9-1.2 2-3.8.5-8.9 0 0 2.8 10.5-4.5 10.5-7.5 0-7.2-2.7-7.2-2.7" />
          <path d="M284.4 190.5c0 2 0 8.4 9 8.4 2.8 0 5.8-2 7.4-3.3m2.2-2.7c-.3-2-.3-4.4-.3-7m-13.6-3.4c2.4-.3 4.4-.6 9-.6m.2-6.3c.5 2.2-.3 5.8 4 6.3m4.3-7.1c-.6 1.6-.6 3.3-.8 4.4m.2 2.7c1.7 0 5-1.1 9-.3m1.4 22.8c.9 1.6 1 3.8 3.6 6.2m-31.7-11.4c.2 1.3-1.8 5.7-.3 9.3a12.3 12.3 0 0 1-1.2 11m6.7-19c-.9 1.7-2.3 3.3-2.6 4.7m6.6-1.6c0 1-2.7 8.7-4.7 10.9 0 0 3.6 1.4 3 6.6m7.4-21c0 1.2-.2 1.6 1 2.4m2.4 0c1.3 1.6 5.5 6.5 4.6 9.2m-7.4-6.5c.3 1 .3 6.3-.6 9m-2.1-.2c-1.1 0-2.8.8-3 2.7m8.7-3c1.1-.3 3.3 1.6 3.3 7m15.7-10.2c-2.1.6-3 1.7-2.4 1.1-1.1 1-2.2 1.6-2.2 1.6" />
        </g>
        <path
          fill="#000"
          strokeWidth={0.3}
          d="M289.8 198c.6 0 1.1-.4 1.1-1 0-.3-.5-.7-1.1-.7-.5 0-1 .4-1 .8 0 .5.5.9 1 .9zm23 .3c.6 0 1.1-.4 1.1-1 0-.4-.5-.7-1-.7-.6 0-1.1.3-1.1.8s.5.9 1 .9z"
        />
        <path
          fill="#fff"
          d="M280.5 239.8c1.3-8 5-14.5 5.1-15.2 0 0 3.9.9 10.6 1.5 6.6.7 8.4.4 11.5.2l6.8-.8s1.2 2.4 1.3 4.8c.3 5.2 2.3 27.7 2.5 33.7 0 0 .8 3.6.8 12.3 0 9.6 2.6 29 2.6 39.4l-2.6.5s-14.5 1.1-14.5-.8c0-2.1-.8-27 1.4-42.1 0 0-.5-3-1.4-5.5-.8-2.5-4.3-10-4.3-11.7 0 0-5.7 16-6 18.8-.3 2.6-1.2 38.4-1.7 41.3 0 0-8.2 6.3-9.3 7-1.1.4-9-3.4-9.3-4.4a211 211 0 0 1 4.6-33.2c1.4-7.1.6-8.4.6-10.4s.1-27.5 1.3-35.4z"
        />
        <path
          fill="none"
          d="M294.3 275c-.6 2.2-1.7 4.3-3.6 5.7m-2.7-53.6c-.3 1.3-2.3 7.3-7.2 10.9m14.3-9.8c-1.1 3.6-5.5 22.7-6.3 45.4m-.3 7.1l-1.7 20.8m-.8 3a71.3 71.3 0 0 0-2.7 18.7m32.2-36c-.2 2-1 15.7 3.6 28m-18.5-86c-.3 2.3-.8 16.7-.8 17.8 0 1.2 1.6 2.8 2.4 3 0 0-1.6.6-2 6m-4-12.8c-.3 1.7-2 8.5-3 11.3m13-25.5s5 1 5.3 0c0 0 1.6 29.5 3.8 46m-11.2-42.2l-.6 16.5m2.5 2.1s1.9 2.8 1.4 4m-17.8-28l3 .8m5.2 1.6c-.3.9-.6 4.6-.6 4.6m8.8 38.9c.6.8 1.4 2 .8 4.4"
        />
        <path
          fill="#9b5f00"
          d="M285 224.4s0-3.2 1.1-4.8c0 0 3.5.7 8.4 1.2 5 .5 9 .9 12.6.5 3.7-.4 7.4-1.3 7.4-1.3s1 4.8.5 5.5c0 0-4 .8-8.3 1a86 86 0 0 1-14.5-.8 57 57 0 0 1-7.3-1.3z"
        />
        <path
          fill="#fff"
          d="M288 224.8l.7-4.8h1l-.2 5.1-1.4-.2m22-4.1l.1 5.5 1.3-.2-.1-5.6-1.3.3m-15.6 0l-.4 5.3h.7l.7-5.3h-1"
        />
        <path d="M276.8 320.8c-.3 1.3-.8 3.2-1 5.5 0 .5-.6 3.3 1 3.4 1 0 1.4-2.9 1.4-2.9s-1 3.3.3 3.7c1.8.4 2-3.6 2-3.6-.2 1.1-1.4 4 .3 4.3 1.9.3 2.4-3.9 2.4-3.9s-1.6 4.2.3 4.3c1.7 0 1.7-4 1.7-4s-.9 5 1.5 4.5c1.4-.2 1.7-2 2-3 .4-1.5 1.3-3.4.2-6.6-.8-2.3-.5-3-.5-3s-2.9 2.2-5.1 3.6c-1 .6-6.5-2.3-6.5-2.3zm29.7-4.4c-.5-.3-.4 1.9-.6 2.9-.1 1 .2 3.2 3.6 3 3.4-.3 6.7-1 8.9-.5 2.1.6 5.3.7 7 .7 1.7 0 2.8-.2 3.7-.5.7-.3 2.2.4 3 .4s1.7-1 1.6-1.8c0-1.3-1.3-1.3-3-1.4a22 22 0 0 1-5-1c-1.1-.3-3.1-1.5-5.7-2l-5.9.2c-1 0-7 .3-7.6 0z" />
      </g>
      <g fill="none">
        <path
          fill="#ffb366"
          d="M255.7 189.8c-.5.3-1.1-2 .4-2.9 0 0 .4-2 2-2.1 0 0 1.4-1.9 3.3-1.7 0 0 2.2-1.5 3-1.3.9.1 3 2.1 3 2.9.2.7 0 1.9-.5 2.4-.6.6-1-.1-1.1-1 0 0 .4 1.6-.8 2.2-1.2.7-1.1.2-1.2-.6 0 0-.4 1.6-1.2 1.9-.8.3-1.3-.5-2-.5 0 0 1.1.9.4 1.5-.7.5-1.5.3-2-.1-.5-.5-1.2-1.9-3.3-.6z"
        />
        <path d="M265.7 186c-.5-1.5-2.2-3-4-2.8m2.2 4.4c-.3-.4-.4-.8-.8-1.2-.9-1.5-2.8-1.4-4.4-1.8m2.4 4.5c-.6-.4-.8-1.2-1.4-1.5-1-.4-2-.9-3.3-.7" />
      </g>
    </g>
    <g stroke="#000" strokeWidth={0.5} transform="translate(-40) scale(.96)">
      <path
        fill="url(#prefix__e)"
        d="M439.1 165.1c.7-.3.5.6.6 1 .4 1.3.4 2.7.9 3.9.6 1.1.8 1.5 1.8 2 1.6 1 6.4 3.6 9.8 1.5a3.1 3.1 0 0 0 .7-.5s-1.3 4.1 3 6.2l15.6 8.2s1.5 2.7.6 6.5c-.2.6-.4 1.1.2 1.5 1 .7 2.6 2.8 3.8 6 0 0 3-1.3 3-3.2 0-2-1.3-3-1.6-4.4-.2-1.3-1-4.7-.6-5.7.4-1.1 2.1-1.5 2.8-2 .7-.3 1.6.5 1.3 1.4 0 1-.8.8-1.6 1 0 0 1 2 .8 3.4l9.4 4.8-1.6 2.3c-.5.7-1.5 10.2-4.2 14.6-2.8 4.5-3.7 3.3-4.2 4l-2.1 1.8c-.6.5-3.8.9-4.5-.9a9 9 0 0 0-3.1-4.1c-2-1.6-6-5.4-6-7.2 0 0-2.3 6.8-2 12.4 0 0-8.4 1.7-16.2 1.9-7.6 0-11.5-1.5-11.5-1.5s-1-6.4-.6-7.7c0 0-1.2 4.2-2 5.6-1.1 1.8-2.2 5.3-4.4 5.5-2.2.1-4-2.1-4.2-3v-6.8h-8.7s-3.8 1.5-5 1.3c-1.3-.1-1.9-1.3-.9-1.7l.4-.3a7 7 0 0 0-2.5.7H402l.1-.5c.3-1.2 2.6-2.2 4.3-3 1.6-.5 3.3-1.2 4.6-1.3 1.9-.2 3.2-.1 6.2.4.8 0 4 .4 5.8 1.3.5.3 1 .4.8-1-.3-1.3-1.2-5.5.3-8.3 1-1.9.9-3.5.8-5.2-.2-1.7-1.1-5.6-1.1-7.3 0-5.7 4.4-8 8.2-9.2 4.3-1.4 7.1-2.8 7-5.3-.2-2.7.5-7 .1-9"
      />
      <g fill="none">
        <path
          fill="url(#prefix__f)"
          d="M456.3 153.6a20 20 0 0 1 1.2 5.3c0 1.2-.5 1.4-.1 2.8.7 2.4-.8 5-2.5 8-.8 1.2-1.4 3-2.7 3.8-3.4 2.1-7.5-.4-9.6-1.3a3.7 3.7 0 0 1-2-2.2c-.4-1.2-.5-2.3-.8-4 0-.3 0-1.2-.6-.9-1.3-1.4-1-2-1.6-3-.5-1 1-2.2 2-2a10 10 0 0 1-.2-5.9c.2-.6-.6-2.2.5-1.8 4.5 1.8 10 1.4 14.8 1.4.4 0 .7-.8 1.3-.7l.3.5"
        />
        <path
          fill="#000"
          d="M456.8 155.3c.4-.4.1-2.3-.4-4.3-.1-1-1-1.5-2-2.6s-1.6-1-2.3-1.4c-.6-.2-2-.2-2.8-.5-.6-.3-2.2-.1-3.7.1-2 .3-3.2.2-4.7 1s-2.8 1.8-3.3 3.3c-.4 1-1 2.5-.8 6.8.2 4.3 1 3.5 1 3.5s1.1-1.7 1.9-.6l-.3-3.6c-.1-1.2 0-2.8.5-4.6 0 0 4.6 1.7 9 1.7 3 0 7-.3 7.1-1l.7 2.2z"
        />
        <path d="M450.4 160.1c.7 1.8.1 1.3.4 2.4m-10.2 2c0 .8-.6.6-1 .6" />
        <path d="M456.9 158.8c-1-.7-2.7-.2-3.5.1-1.5.7-.7 2.3-.2 3.7.2.7 1 1.7.5 2.4-.4.8-.7.4-1.6.5 0-.3-.8 0-1.1 0-.6 0-1 .4-1.5.2-.6-.3-.5-1.2-.3-1.7m.1-4.5c0-.4-1.3-.8-2.7-.9-2.3 0-2.5.1-4.2 1.3m11.5 9c-.4-.6-1-1-2.1-.4 0-.2-1.6-.4-1.6-.4-.8 0-1.3.3-2.1.7m5.6.6c-1-.6-3.3-.2-5.6-.2m.2.8c1.7.5 3.5.8 5.2 0" />
        <path
          fill="#fff"
          strokeWidth={0.3}
          d="M456.4 160.1c-.7 0-1-.9-3.1.3-1.1.7 1.8 1.5 1.4 1.4 1.2.2 1.6-.5 1.7-1.2 0-.1.2-.5 0-.5zm-8.3.8c0-.8-1.8-1-2.9-.8-1 .3-.5.1-1.5.7 1 .1.7.2 1.6.6.9.5 1 .9 2.3.3.3-.1.7-.5.8-1 0 .2-.2.3-.3.3z"
        />
        <path
          fill="#000"
          strokeWidth={0.3}
          d="M455.1 161.4a.8.8 0 0 1-.8-.8c0-.6.3-1 .8-1 .4 0 .7.4.7 1 0 .4-.3.8-.7.8zm-8.7.2c-.4 0-.7-.4-.7-1 0-.5.4-.8.8-.8s.7.3.7.8c0 .6-.3 1-.8 1z"
        />
      </g>
      <use
        width="100%"
        height="100%"
        fill="#730000"
        transform="matrix(-1 0 0 1 748.8 0)"
        xlinkHref="#prefix__g"
      />
      <g fill="none">
        <path
          fill="#730000"
          d="M491.6 193.5c.5.2 2-2 .5-3 0 0-.5-2-2-2 0 0-1.4-2-3.4-1.7 0 0-2-1.5-2.9-1.4-1 .2-3 2.2-3 3-.2.5 0 1.8.5 2.4.6.5 1-.1 1-1 0 0-.3 1.5.9 2.2 1.2.7 1.1 0 1.2-.7 0 0 .3 1.6 1.1 2 .9.2 1.4-.5 2-.5 0 0-1 .8-.3 1.3.7.6 1.5.3 2 0 .6-.5.3-1.8 2.4-.6z"
        />
        <path d="M482.5 189.8c.5-1.8 2.2-3.2 4-2.9m-2 4.4c.1-.4.2-.8.5-1.2 1-1.6 3-1.6 4.6-1.9m-2.5 4.5c.6-.4.8-1.1 1.4-1.4a5.3 5.3 0 0 1 3.2-.7" />
        <path
          fill="#730000"
          d="M482.3 186.8c-.9.7-1.8 1.8-1.9 2.2 0 .7 0 1.9.5 2.5.6.5 1 0 1.1-.8 0 .5 0 1.5.8 2 1.3.7 1.2.1 1.3-.7 0 0 .3 1.6 1 2 .9.2 1.4-.5 2-.5 0 0-1 .8-.3 1.3.7.6 1.5.3 2 0 .6-.5.3-1.8 2.5-.6.2.2.8-.4 1-1.1l-7.7-5.5-2.3-.8z"
          stroke="none"
        />
        <path d="M480.7 188.2c-1.5 2.6.5 4.1 1.1 2.6-.1 2.4 1.7 2.3 2.3 1.5.7 2.5 1.9 1.4 3 1.2-1.3 2.3 1.4 1.6 2 1 1-1.3 1.4-.2 2-.3l1.3-1.3m-8-5.7c-1.7 1-2.5 2.2-2.6 3.7m5-2.2c-1.8 1-2.6 2.2-2.6 3.7m5.4-1.7c-1.7.9-1.8 1.7-2.5 2.8" />
      </g>
    </g>
    <path
      fill="#5ac800"
      d="M238.5 310.7l-.2-4.5 1.9 1.6.4-3.4c.8-.2 2.1 1.3 2.1 1.3l-.2-3.4 2.8 3.1s-.2-2.6.8-4.2c0 0 2.2 1.9 2.2 4 0 1.9 1.8-2.6 1.8-2.6a3116.2 3116.2 0 0 0 1.6 5l1.3-1.9 1 4 2.4-3.5 1.8 4 4.2-.3.5 2.4 1.9-2 2.4 1.5s2-.6 3.1-.6 2.4 1.4 2.4 1.4.8-1.4 1.5-1.9 1.9.8 2.2 1.6l1.6-2.9s2 2 2.3 2.9c0 0 .3-2.4.8-3.2.5-.7 1.2.3 1.8 1.3l1.3-4.2s1.4.3 2.3 1.9c1.1 1.5 1.1-2.4 1.1-2.4s2.4 3.2 3 5.3c0 0-16.2 5.6-27.6 4a306 306 0 0 1-24.5-4.3m110.9-.5s.7-2.1 1.8-3.2c0 0 2 2.4 2 3.2l1.7-1 1.6 1.5 1.8-1.3 1.8 1.6 3.2-1.4 1.3 1.4 5-.6 1.8.8 1.8-2.3 1.6 1.8 2.7-2.6s1.3 1 1.5 1.8c0 0 2.2-1 2.7-1.8 0 0 2-.8 2.3.5 0 0 1.3-1 1.2-2-.1-1.2 1.5-.4 2 1 0 0 .5-2.2 2-2.4 0 0 1.2 1.3.9 3.7 0 0 2.3-1.9 3.4-2.1 0 0 .5 2.6-.3 5 0 0 2.4-4 3-2.7.1.8.7 3.5.1 5.3l2.2-1.3.8 2.6 2.3-.5s-13.9 2.1-27 .9c-13-1.3-25.3-5.9-25.3-5.9m-9.6 9.7c.6-.4-4.4 10.3-16.5 10.9-16.9.8-31.3-7.7-31.3-7.7s1.8-2.9 2.9-3.7c0 0 2.3 1.9 3 4.2 0 0 .4-1.5 1.2-2.9 0 0 2.9 1.4 3.4 3.2 0 0 1-1.8 1.8-2.3.8-.6 1.6 2 1.6 3.6 0 0 1.9-2 3-2 0 0 2 1 2.6 4.3 0 0 2-1.8 2.6-1.5 0 0 2.3 1.5 1.8 3.7-.3 1.2 2.3-1.4 5.5-2.2l2.9 2.2 3.4-4.7s2.1.8 2.1 2c0 0 1-3.7 1.8-4 .8-.5 1.8 1.1 1.8 2.2 0 0 .3-2.8 1.9-3.4 0 0 1.6 1 1.6 2.1 0 0 1.6-3.2 2.9-4z"
    />
    <path
      fill="none"
      stroke="#060"
      strokeWidth={0.5}
      d="M238.5 310.7l-.2-4.5 1.9 1.6.4-3.4c.8-.2 2.1 1.3 2.1 1.3l-.2-3.4 2.8 3.1s-.2-2.6.8-4.2c0 0 2.2 1.9 2.2 4 0 1.9 1.8-2.6 1.8-2.6l1.6 5 1.3-1.9 1 4 2.4-3.5 1.8 4 4.2-.3.5 2.4 1.9-2 2.4 1.5s2-.6 3.1-.6 2.4 1.4 2.4 1.4.8-1.4 1.5-1.9c.8-.5 1.9.8 2.2 1.6l1.6-2.9s2 2.1 2.3 2.9c0 0 .3-2.4.8-3.2.5-.7 1.2.3 1.8 1.3l1.3-4.2s1.4.3 2.3 1.9c1.1 1.5 1.1-2.4 1.1-2.4s2.4 3.2 3 5.3m58.7-.8s.8-2.1 1.9-3.2c0 0 2 2.4 2 3.2l1.7-1 1.6 1.5 1.8-1.3 1.8 1.6 3.2-1.4 1.3 1.4 5-.6 1.8.8 1.8-2.2 1.6 1.7 2.7-2.6s1.2 1 1.5 1.8c0 0 2.2-1 2.7-1.8 0 0 2-.8 2.3.5 0 0 1.3-1 1.2-2-.1-1.2 1.5-.4 2 1 0 0 .5-2.2 2-2.4 0 0 1.2 1.3.9 3.7 0 0 2.3-1.9 3.4-2 0 0 .5 2.5-.3 4.9 0 0 2.4-4 3-2.7.1.8.7 3.5.1 5.3l2.2-1.3.8 2.6 2.3-.5m-109.8 8s1.8-3 2.9-3.7c0 0 2.3 1.8 3.1 4.2 0 0 .3-1.6 1-3 0 0 3 1.4 3.5 3.2 0 0 1-1.8 1.9-2.3.7-.6 1.5 2 1.5 3.6 0 0 1.9-2 3-2 0 0 2 1 2.6 4.4 0 0 2-1.9 2.6-1.6 0 0 2.4 1.6 1.8 3.7-.3 1.2 2.3-1.4 5.5-2.1l2.9 2.1 3.4-4.7s2.1.8 2.1 2c0 0 1-3.6 1.8-4 .8-.5 1.9 1.1 1.9 2.2 0 0 .3-2.8 1.8-3.4 0 0 1.6 1 1.6 2.1 0 0 1.6-3.2 3-4"
    />
    <g fill="#fff">
      <path d="M319.5 361.9c22 .2 35-7.8 42-12.6 16.8-11.2 20.3-11.6 23-11.4 3.1.3 7.7 1.3 8 4 .2 4.3-6.6 6.1-10.5 6.1-4 0-14.5-2.6-14.5-2.6l-2.7 1.9c1.8.8 23.2 8 27.3 1.2 4.2-6.8 8.4-17.9 8.4-17.9s-4.7-8.4-15.1-8.4c-10.6 0-20.8 6.7-27.6 11.7-6.9 5-15.5 11.8-38.3 11.8-22.9 0-31.6-6.8-38.4-11.8-6.9-5-17.1-11.7-27.6-11.7a18 18 0 0 0-15.2 8.4s4.2 11 8.4 18c4.1 6.7 25.5-.5 27.3-1.4l-2.6-1.8S261 348 257 348s-10.9-1.8-10.6-6c.2-2.8 4.8-3.8 8-4.1 2.7-.2 6.2.2 22.9 11.4a72 72 0 0 0 42.2 12.6" />
      <path d="M284.1 336s0-1.9-.3-4.6c-.4-3.5-2.4-4.4-4-3.9-1.2.4-3.3 3-3.3 3v.1a31 31 0 0 0-3-1.8 18 18 0 0 1 6.3-3.6c1 0 14.5 5.4 18.8 9.1 1 1 1.8 7 1.2 9a46.5 46.5 0 0 1-15.7-7.2m-6.5 13.6s-2.9 3-3 8.3c0 6.3 4.5 6.6 7.5 6.5 3.7 0 6.6-2.1 6.5-8.9 0 0-6-2.5-11-6m77.1-13.6l.4-4.6c.4-3.5 2.4-4.4 4-3.9 1 .4 3.2 3 3.2 3v.1l3-1.8c-.7-1-5.2-3.6-6.2-3.6s-14.5 5.4-18.8 9.1c-1 1-1.8 7-1.3 9a45.5 45.5 0 0 0 15.7-7.2v-.1m6.5 13.7s2.9 3 3 8.3c.2 6.3-4.5 6.6-7.5 6.5-3.6 0-6.5-2.1-6.5-8.9 0 0 6-2.5 11-6" />
    </g>
    <path
      fill="#69f"
      d="M271.3 345.4S260.9 348 257 348c-4 0-10.9-1.8-10.6-6 .2-2.8 4.8-3.8 8-4.1 2.3-.2 5.3 0 17 7.5m96.1 0S378 348 382 348c3.9 0 10.7-1.8 10.4-6-.2-2.8-4.8-3.8-7.9-4.1-2.3-.2-5.4 0-17 7.5m-83.4-9.3a93.7 93.7 0 0 1-3.1-2.3c-1.5-1.1-3-2-4.5-3.2 0 0 2.1-2.7 3.2-3 1.7-.6 3.7.3 4.1 3.8.3 2.7.3 4.7.3 4.7m-7.1 27.6c1.8 1 3.9 1 5.1.8 3.7 0 6.6-2.1 6.5-8.9 0 0 4.5 2.3 11.8 4 0 0 1.2 1.5 1.4 4.4.3 2.5-1.4 5.1-3.3 5 0 0-10.3-2-16.5-3-3.7-.7-5-2.3-5-2.3m77.7-27.6l3.2-2.3 4.4-3.2s-2.1-2.7-3.2-3c-1.6-.6-3.6.3-4 3.8l-.4 4.7m7.1 27.6c-1.8 1-3.9 1-5.1.8-3.6 0-6.5-2.1-6.5-8.9 0 0-4.5 2.3-11.7 4 0 0-1.3 1.5-1.5 4.4-.2 2.5 1.5 5.1 3.4 5 0 0 10.3-2 16.5-3 3.6-.7 5-2.3 5-2.3"
    />
    <g fill="none" stroke="#000" strokeWidth={0.7}>
      <path d="M319.5 361.9c22 .2 35-7.8 42-12.6 16.8-11.2 20.3-11.6 23-11.4 3.1.3 7.7 1.3 8 4 .2 4.3-6.6 6.1-10.5 6.1-4 0-14.5-2.6-14.5-2.6l-2.7 1.9c1.8.8 23.2 8 27.3 1.2 4.2-6.8 8.4-17.9 8.4-17.9s-4.7-8.4-15.1-8.4c-10.6 0-20.8 6.7-27.7 11.7-6.8 5-15.4 11.8-38.2 11.8s-31.6-6.8-38.4-11.8c-6.9-5-17.1-11.7-27.6-11.7s-15.2 8.4-15.2 8.4 4.2 11 8.4 18c4.1 6.7 25.5-.5 27.4-1.4l-2.7-1.8S261 348 257 348s-10.9-1.8-10.6-6c.2-2.8 4.8-3.8 8-4.1 2.7-.2 6.2.2 22.9 11.4a72 72 0 0 0 42.2 12.6z" />
      <path d="M271.3 345.4S260.9 348 257 348c-4 0-10.9-1.8-10.6-6 .2-2.8 4.8-3.8 8-4.1 2.3-.2 5.3 0 17 7.5zm96.2 0S378 348 382 348c3.9 0 10.7-1.8 10.4-6-.2-2.8-4.8-3.8-7.9-4.1-2.3-.2-5.4 0-17 7.5zm-83.4-9.3a92.6 92.6 0 0 1-3.1-2.3c-1.5-1.1-3-2-4.5-3.2 0 0 2.1-2.7 3.2-3 1.7-.6 3.7.3 4.1 3.8.3 2.8.3 4.7.3 4.7z" />
      <path d="M284.1 336s0-1.9-.3-4.6c-.4-3.5-2.4-4.4-4-3.9-1.2.4-3.3 3-3.3 3v.1a31.9 31.9 0 0 0-3-1.8 18 18 0 0 1 6.3-3.6c1 0 14.5 5.4 18.8 9.1 1 1 1.8 7 1.2 9a46.6 46.6 0 0 1-15.7-7.2m-6.5 13.6s-2.9 3-3 8.3c0 6.3 4.5 6.6 7.5 6.5 3.7 0 6.6-2.1 6.5-8.9 0 0-6-2.5-11-6z" />
      <path d="M280.1 351.1s-2.3 2.5-2.7 6.5c-.2 3.1 1.8 4.9 4.5 4.7 3.7-.2 5.1-5.3 3.4-8.1l-5.2-3" />
      <path d="M277 363.7c1.8 1 3.9 1 5.2.8 3.6 0 6.5-2.1 6.4-8.9 0 0 4.5 2.3 11.8 4 0 0 1.2 1.5 1.4 4.5.3 2.4-1.4 5-3.3 4.8L282 366c-3.7-.7-5-2.3-5-2.3zm77.7-27.6l3.3-2.3c1.3-1.1 2.8-2 4.4-3.2 0 0-2.2-2.7-3.3-3-1.6-.6-3.6.3-4 3.8l-.4 4.7z" />
      <path d="M354.7 336l.4-4.6c.4-3.5 2.4-4.4 4-3.9 1 .4 3.2 3 3.2 3v.1a31.9 31.9 0 0 1 3-1.8c-.7-.9-5.2-3.6-6.2-3.6s-14.5 5.4-18.8 9.1c-1 1-1.8 7-1.3 9a45.7 45.7 0 0 0 15.7-7.2m6.5 13.6s2.9 3 3 8.3c.2 6.3-4.5 6.6-7.5 6.5-3.6 0-6.5-2.1-6.5-8.9 0 0 6-2.5 11-6z" />
      <path d="M358.7 351.1s2.4 2.5 2.8 6.5c.3 3.1-1.9 4.9-4.5 4.7-3.7-.2-5.1-5.3-3.4-8.1l5.1-3" />
      <path d="M361.9 363.7c-2 1-4 1-5.2.8-3.6 0-6.5-2.1-6.5-8.9 0 0-4.5 2.3-11.7 4 0 0-1.3 1.5-1.5 4.5-.2 2.4 1.5 5 3.4 4.8l16.5-2.9c3.6-.7 5-2.3 5-2.3z" />
    </g>
    <path
      fill="none"
      stroke="#fff"
      strokeWidth={0.7}
      d="M299.6 361.4s3.3 2.4-.7 5.3m-9-6.8l10 4.3m-8.3-2.1l7.2 3.1m-4.6-5l5.4 2.5m39.7-1.3s-3.3 2.4.6 5.3m9-6.8l-10 4.3m8.4-2.1l-7.2 3.1m4.6-5l-5.4 2.5"
    />
    <path
      stroke="#000"
      strokeWidth={0.7}
      d="M261 331.4c.2.2.2.4.3.7a2.5 2.5 0 0 1 0 .8 2.4 2.4 0 0 1-1.2 1.6 3 3 0 0 1-2.2.4 3.7 3.7 0 0 1-1-.4 4.3 4.3 0 0 1-1-.6l-.3.4-.4-.1.4-2.9.5.1c0 .4 0 .7.2 1l.3 1 .7.6c.2.2.5.3.9.4h.7a1.2 1.2 0 0 0 .9-.6 1.8 1.8 0 0 0 .2-.6 1.7 1.7 0 0 0-.1-1 1.8 1.8 0 0 0-.7-.7 48.3 48.3 0 0 0-.8-.5l-.8-.6c-.5-.3-.8-.6-1-1-.2-.4-.2-.8-.1-1.4 0-.3.2-.6.4-.8a2.5 2.5 0 0 1 1.5-1 2.9 2.9 0 0 1 1 0l1 .4.8.6.3-.4.5.1-.5 2.8-.5-.1a11.2 11.2 0 0 0 0-1 3.6 3.6 0 0 0-.4-.8 2 2 0 0 0-.5-.7 2 2 0 0 0-.8-.4 1.4 1.4 0 0 0-1 .2c-.4.2-.6.5-.6.8v1l.7.7.8.5a14.1 14.1 0 0 1 1.3 1c.2 0 .4.3.5.5m12 1.6l-.5-.1a1.4 1.4 0 0 0-.5-.1c-.2 0-.4.1-.5.3a5.7 5.7 0 0 0-.6 1l-1.8 3.1a2.4 2.4 0 0 1-1.9 1.3h-1.1a4.2 4.2 0 0 1-1-.5 4.3 4.3 0 0 1-1-.8 3 3 0 0 1-.7-1 2.2 2.2 0 0 1-.1-1 2 2 0 0 1 .2-.8l2.4-4.3a.9.9 0 0 0 .1-.4v-.3a1.5 1.5 0 0 0-.3-.3l-.4-.3.2-.3 3.1 1.7-.2.3-.3-.1a2 2 0 0 0-.4-.1h-.4a.9.9 0 0 0-.2.3l-2.2 4a3.3 3.3 0 0 0-.3.7 1.8 1.8 0 0 0 0 .8c0 .2 0 .5.2.7l.9.8 1 .3a1.9 1.9 0 0 0 1.5-.5l.5-.6 1.6-3 .5-1v-.6c0-.2-.2-.3-.4-.5a3.6 3.6 0 0 0-.4-.3l.2-.4 3 1.7a19.2 19.2 0 0 1-.2.3m4.3 7.5a1.9 1.9 0 0 1 0 1.8 2 2 0 0 1-.8.8 2.2 2.2 0 0 1-1 .3l-1-.1a4 4 0 0 1-.9-.4l-3.5-2 .2-.4a5 5 0 0 0 .8.3.5.5 0 0 0 .3 0 .7.7 0 0 0 .3-.3l3-5.3a1 1 0 0 0 .1-.3.6.6 0 0 0-.1-.4 1.7 1.7 0 0 0-.3-.3l-.3-.2.2-.4 3.4 2 .7.5.6.7a1.6 1.6 0 0 1 0 1.6 1.8 1.8 0 0 1-.6.6l-.7.3a2.5 2.5 0 0 1-.7 0 3.3 3.3 0 0 1-.8-.2v.1a5 5 0 0 1 .6.6l.5.7zm-.6-1.8c.2 0 .4-.2.5-.3a2.7 2.7 0 0 0 .5-.6c.2-.4.3-.8.2-1.2-.1-.3-.4-.6-.9-.9l-.4-.2-.4-.3-1.6 2.8.6.4.8.3h.7zm-.6 2.7c.2-.4.3-.8.1-1.3 0-.4-.4-.8-1-1.1a29 29 0 0 0-.5-.4l-.4-.1-1.5 2.5a.6.6 0 0 0 0 .7c.1.2.4.4.7.5.5.3 1 .4 1.4.3.5-.2.8-.5 1.2-1zm18.9 4.3a3.5 3.5 0 0 0-.5 0 1.4 1.4 0 0 0-.6-.1c-.1 0-.3.1-.4.4a5.9 5.9 0 0 0-.5 1l-1.5 3.3c-.1.4-.4.7-.7 1a2.6 2.6 0 0 1-1 .4 3.2 3.2 0 0 1-1.1 0 4.3 4.3 0 0 1-2.2-1 3.1 3.1 0 0 1-.7-.8 2.2 2.2 0 0 1-.3-1 2 2 0 0 1 .2-.9l2-4.5a.9.9 0 0 0 0-.4.7.7 0 0 0-.1-.3 1.6 1.6 0 0 0-.3-.3l-.4-.2.2-.4 3.3 1.4-.2.4a3.5 3.5 0 0 0-.4-.1 2.3 2.3 0 0 0-.4 0h-.3a1 1 0 0 0-.2.3l-1.9 4.3-.2.7a1.7 1.7 0 0 0 .4 1.4c.2.3.5.5 1 .7l1 .2a1.9 1.9 0 0 0 1.5-.7 2.5 2.5 0 0 0 .4-.6l1.3-3.1.3-1v-.7l-.4-.4a3.7 3.7 0 0 0-.5-.3l.2-.4 3.1 1.4-.1.3m9.2 10.8l-3.6-1v-.4a9 9 0 0 0 .6 0l.4.1a.8.8 0 0 0 .4-.2.7.7 0 0 0 .2-.3l1.7-5.8a1.4 1.4 0 0 0-.1 0l-4.8 6h-.3l-.6-7.9-1.5 4.8-.2 1.1.1.6.5.4a3.2 3.2 0 0 0 .5.3l-.2.4-3.2-1v-.4h.6a1 1 0 0 0 .5 0c.2 0 .3-.2.5-.4l.3-1 1.2-4.2a1.7 1.7 0 0 0 .1-.6 1 1 0 0 0-.1-.4 1.2 1.2 0 0 0-.4-.4 2 2 0 0 0-.5-.2l.1-.4 2.8.8.6 6.7 3.5-4.5.3-.5a2.8 2.8 0 0 0 .2-.4l2.7.8-.1.4a3.9 3.9 0 0 0-.5 0 2.4 2.4 0 0 0-.4-.1.4.4 0 0 0-.3.1 1 1 0 0 0-.1.4l-1.7 5.8a.8.8 0 0 0 0 .3l.1.3a3.4 3.4 0 0 0 .8.4l-.1.4m8.7-2.6a1.9 1.9 0 0 1 .7 1.7l-.4 1c-.2.3-.5.4-.8.6-.3.2-.6.2-1 .3h-1l-4-.5v-.4h.5a1.7 1.7 0 0 0 .4 0 .5.5 0 0 0 .3-.2.7.7 0 0 0 .1-.4l.8-6a1 1 0 0 0 0-.3.6.6 0 0 0-.3-.3 1.7 1.7 0 0 0-.4-.2h-.3v-.5l3.9.5c.3 0 .6 0 .9.2l.7.4a1.6 1.6 0 0 1 .6 1.5l-.2.8a1.7 1.7 0 0 1-.6.5 2.6 2.6 0 0 1-.6.3 3.4 3.4 0 0 1-.8.2l.8.3.7.5zm-1.3-1.5l.4-.5.2-.7a1.5 1.5 0 0 0-.3-1.1c-.2-.3-.6-.5-1.1-.5a27.3 27.3 0 0 0-1-.1l-.4 3.2h.8c.3.1.6 0 .8 0a1.3 1.3 0 0 0 .6-.3zm.5 2.8c0-.5 0-1-.3-1.3-.3-.3-.8-.5-1.4-.6l-.7-.1h-.4l-.3 2.9a.6.6 0 0 0 .2.6l.8.3c.6 0 1 0 1.5-.4.3-.3.5-.7.6-1.4zm11.4 2.6h-2.2a44 44 0 0 0-1.4-2l-1.3-1.8h-1v2.7l.1.4.3.2h.4l.5.1v.4h-3.6v-.4h.4l.4-.1a.5.5 0 0 0 .2-.2.7.7 0 0 0 .1-.4v-6.4l-.3-.3a2.2 2.2 0 0 0-.4 0l-.4-.1v-.4h4.9a2.8 2.8 0 0 1 .9.4l.6.6a2.3 2.3 0 0 1 0 1.8 2 2 0 0 1-.4.7 2.5 2.5 0 0 1-.7.4 5.3 5.3 0 0 1-.8.3l1 1.4c.3.4.7.8 1 1.4a2.5 2.5 0 0 0 1 .8 3 3 0 0 0 .8.1v.4zm-3.1-6.2c0-.5-.2-1-.4-1.2-.3-.3-.8-.5-1.3-.5h-1v3.6h.8c.5 0 1-.1 1.3-.5.4-.3.6-.8.6-1.4zm13 5.6l-3.6.3v-.4l.7-.2c.2 0 .3-.2.3-.2v-.2a.5.5 0 0 0 0-.1l-.9-1.8-3 .2a9.6 9.6 0 0 0-.2.7l-.1.6a3.4 3.4 0 0 0-.1.4v.3c0 .2.1.3.4.3l.9.1v.4l-3.2.3v-.4a2 2 0 0 0 .4-.1 1.3 1.3 0 0 0 .7-.6l.2-.5 1.1-3.6 1.1-3.6h.5l3.4 7 .2.3a1.2 1.2 0 0 0 .7.4h.4v.4zm-3.7-3.1l-1.6-3.2-1 3.4 2.6-.2zm15.7-6.7a27.9 27.9 0 0 0-.4.2 3.1 3.1 0 0 0-.8-.9c-.4-.2-.7-.4-1-.3a6.3 6.3 0 0 0-.3 0l-.6.2-1.4.4.9 3.2 1-.2.6-.3.3-.4.1-.4v-.6l.4-.2.9 3.2-.4.1a2.9 2.9 0 0 0-.3-.5l-.4-.4a.9.9 0 0 0-.5-.2 2.3 2.3 0 0 0-.6.1l-1 .3.8 2.8s0 .2.2.3a.6.6 0 0 0 .3.2h.4l.4-.1.1.4-3.5 1-.1-.4a9.5 9.5 0 0 0 .4-.2l.4-.2a.5.5 0 0 0 .2-.3.8.8 0 0 0 0-.3l-1.6-5.9a1.1 1.1 0 0 0-.2-.3l-.3-.2a2.4 2.4 0 0 0-.4 0 2.4 2.4 0 0 0-.5 0l-.1-.3 6.4-1.8.6 2m9.4-.7l1 2.4-6 2.8-.2-.3.4-.3a1.4 1.4 0 0 0 .3-.2.5.5 0 0 0 .1-.3.8.8 0 0 0 0-.4l-2.7-5.4a1 1 0 0 0-.2-.3.5.5 0 0 0-.4 0h-.4a2 2 0 0 0-.4 0l-.2-.3 3.3-1.6.2.4a2.8 2.8 0 0 0-.4.2 2.2 2.2 0 0 0-.3.3.4.4 0 0 0-.2.3.8.8 0 0 0 .1.4l2.5 5c0 .3.2.5.3.6l.3.2h.4l.7-.3.4-.2.4-.3.3-.2a.6.6 0 0 0 .2-.3 6.3 6.3 0 0 0 .2-2l.3-.2m4.5-8.3a4.2 4.2 0 0 1 1.5.8l1.2 1.4a5 5 0 0 1 .6 1.7 4.1 4.1 0 0 1 0 1.6 4 4 0 0 1-.7 1.5 4 4 0 0 1-1.2 1 4 4 0 0 1-3.2.4 4 4 0 0 1-1.4-.7 5 5 0 0 1-1.2-1.4 5 5 0 0 1-.6-1.7 4.3 4.3 0 0 1 0-1.7 4 4 0 0 1 2-2.4 4 4 0 0 1 1.5-.6 3.9 3.9 0 0 1 1.5.1zm2.3 5.6a4 4 0 0 0-.2-1.3 7 7 0 0 0-.7-1.4 7.2 7.2 0 0 0-1-1.3 4 4 0 0 0-1-.8 2.4 2.4 0 0 0-1-.2c-.5 0-.8.1-1.2.3-.4.3-.7.6-.9 1a2.6 2.6 0 0 0-.3 1c0 .5.1.9.3 1.3a7.2 7.2 0 0 0 1.5 2.6c.3.4.7.6 1 .8a2.4 2.4 0 0 0 1.2.3c.3 0 .7 0 1.1-.3a2.3 2.3 0 0 0 1.2-2zm10.5-5.7l-1.9 1.3-2.3-.9-2-.6-.8.5 1.6 2.1.2.3h.4a1.8 1.8 0 0 0 .3-.1l.4-.3.3.4-3 2-.2-.3a8.6 8.6 0 0 0 .6-.5.5.5 0 0 0 0-.4.7.7 0 0 0 0-.3l-3.6-5a1 1 0 0 0-.2-.2.3.3 0 0 0-.4 0 3 3 0 0 0-.7.3l-.3-.4 3.2-2.2a4.6 4.6 0 0 1 .9-.5 2.7 2.7 0 0 1 .9-.2l.8.1a2.2 2.2 0 0 1 1.1 1.4v.8a2.5 2.5 0 0 1-.2.7 4.9 4.9 0 0 1-.5.8l1.6.5 1.6.5a2.5 2.5 0 0 0 1.2.1h.4a2.6 2.6 0 0 0 .4-.3l.2.4zm-6.2-3.3c-.3-.4-.6-.6-1-.7-.4-.1-.9 0-1.3.3l-.8.6 2 3 .7-.5c.4-.3.7-.7.8-1.2 0-.5 0-1-.4-1.5zm13.2-2l.7 2.4-6.6 2.4-.2-.4a4.3 4.3 0 0 0 .8-.4.6.6 0 0 0 .2-.3.7.7 0 0 0 0-.4l-2.2-5.6a1 1 0 0 0-.1-.3l-.4-.1h-.4a2.2 2.2 0 0 0-.5 0l-.1-.3 6.1-2.3.7 1.9-.4.1a2.7 2.7 0 0 0-.8-.7l-.9-.3a4.3 4.3 0 0 0-.4.2l-.6.2-1.2.4 1.1 3.1 1-.3c.2 0 .4-.2.5-.3a.9.9 0 0 0 .3-.4v-1.1l.4-.1 1.1 3-.4.2a3.2 3.2 0 0 0-.3-.5 1.5 1.5 0 0 0-.4-.3.9.9 0 0 0-.5-.2c-.2 0-.4 0-.6.2l-.9.3.9 2.4.2.5a.5.5 0 0 0 .3.3h.5l.7-.3.5-.2a3.9 3.9 0 0 0 1-.4l.2-.3.2-1v-1l.5-.1m7.1-5.8c.4.3.8.7 1 1.3.3.5.5 1 .6 1.7a4.9 4.9 0 0 1 0 1.8 4.1 4.1 0 0 1-.8 1.5 3.9 3.9 0 0 1-2.7 1.6 3.9 3.9 0 0 1-3-.9 4.1 4.1 0 0 1-1-1.2 4.9 4.9 0 0 1-.6-1.7 5 5 0 0 1 0-1.9l.8-1.5a4 4 0 0 1 2.7-1.5 4 4 0 0 1 1.6 0l1.4.8zm-.1 6c.2-.4.3-.8.3-1.3v-1.5a7 7 0 0 0-.4-1.5 3.9 3.9 0 0 0-.7-1.2 2.4 2.4 0 0 0-.9-.7 2.3 2.3 0 0 0-1.1-.1c-.5 0-1 .2-1.2.5-.3.2-.6.6-.7 1a4 4 0 0 0-.3 1.2 7 7 0 0 0 .4 3l.7 1.1c.2.4.5.6.9.7.3.2.7.2 1.2.2a2.3 2.3 0 0 0 1-.5 2.4 2.4 0 0 0 .8-1z"
    />
    <path
      fill="none"
      stroke="#000"
      d="M366 205.1v53c0 10.6-1.4 52.6-46.5 69-45.3-16.4-46.7-58.4-46.7-69v-53H366"
    />
  </svg>
	),
	CA: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#fff" d="M150.131 0h339.656v480H150.132z" />
    <path
      fill="red"
      d="M-19.65 0h169.781v480H-19.65zm509.438 0h169.78v480H489.882zm-288.75 231.938l-13.313 4.5 61.406 53.906c4.688 13.781-1.593 17.812-5.625 25.125l66.563-8.438-1.594 67.031 13.875-.375-3.094-66.562 66.75 7.969c-4.125-8.719-7.781-13.313-4.031-27.188l61.313-51.094-10.688-3.937c-8.813-6.75 3.75-32.531 5.625-48.844 0 0-35.719 12.281-38.063 5.813l-9.187-17.532-32.531 35.813c-3.563.844-5.063-.563-5.906-3.563l15-74.812-23.813 13.406c-1.969.938-3.938.188-5.25-2.156l-22.969-45.938-23.625 47.72c-1.781 1.687-3.562 1.874-5.062.75l-22.688-12.75 13.688 74.155c-1.125 3-3.75 3.75-6.75 2.157L239.85 171.75c-4.031 6.562-6.75 17.156-12.187 19.594-5.344 2.25-23.438-4.5-35.532-7.125 4.125 14.906 17.063 39.656 8.907 47.812z"
    />
  </svg>
	),
	CC: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <path
        id="prefix__a"
        d="M0-360l69.4 215.8 212-80.3L156-35.6 351 80.1 125 99.8l31.1 224.6L0 160l-156.2 164.3 31.1-224.5L-351 80l195-115.7-125.5-188.9 212 80.3z"
      />
      <path
        id="prefix__b"
        d="M0-210L54.9-75.5l144.8 10.6-111 93.8 34.7 141L0 93.3-123.4 170l34.6-141-111-93.8 145-10.6z"
      />
    </defs>
    <path fill="green" d="M0 0h640v480H0z" />
    <circle cx={320} cy={240} r={66.7} fill="#ffe000" />
    <circle cx={340.8} cy={240} r={54.9} fill="green" />
    <circle cx={109.8} cy={173.3} r={69.8} fill="#ffe000" />
    <path
      fill="#802000"
      stroke="#7b3100"
      strokeWidth={1.5}
      d="M105 226h17.5s.7-1.6-.2-2.4c-1-.8-4.7-1-3.7-3.8 2-5.8 2.4-4 3.7-17.8a739 739 0 0 0 2-35.5h-2.6s.5 6.7-1 15.5c-1.4 8.8-1.9 9.5-3.5 16.3a63.5 63.5 0 0 1-3.3 11.2c-1.4 4-1.6 4.1-3.8 7.8-2.3 3.6-1.5 2.2-2.7 4.4-.7 1.1-1.4.8-1.9 1.6-.4.8-.5 2.7-.5 2.7z"
    />
    <path
      fill="green"
      d="M118.3 122.5a23 23 0 0 1-1.2 9.2 26.5 26.5 0 0 0-2.3 9.8c-1.8.6-3.7-3.9-5.5-1.2 1.3 3.7 4.4 6.6 6.4 9.9.4 1 3.4 3.7 1.6 4.3-4.3-1.5-5.4-7-8-10.3a19 19 0 0 0-15.5-10c-2.5.1-10.4-.5-8.4 3.7 3 2 6.8 3.4 9.8 5.7 2.3.2 6.3 4 6.1 5.4-4-1.6-5.8-3.5-10-5.2-5.8-2.2-13.7-.9-17 4.8-.5 1.5-1.4 5.8.5 6.3 2.2-3.4 5.3-7.3 9.9-6.2 3.6.3-4 6.7-1.1 5.4 1-.4 3-1.8 4.6-2 1.5 0 2.3 1 3.4 1.2 2.3.3 3 1.2 2.7 1.8-.2.6-1 0-3.3.8-1.1.4-1.7 1.4-3 1.9-1.4.4-4.2.5-5.2 0-3.7-1.5-9.7-1.3-10.8 3.3 0 2-1.8-.2-2.6.7-.7 2.2-.8 4.4-4 4.2-2 2-4 4.2-6.6 5.7 1.5 3.4 7.3-3.4 7-.5-2.5 3.5 1.4 4.2 3 1.5 2.9-3 6.5-6.7 10.7-3.6 2 1.9 3.2-1 4.7-1 1 2.5 2.1.2 3.2-.5 1.7-.2 1.2 2.2 3.2.7 4.1-2.7 9.1-.4 13.1-3 4.3-2 .6 1.5-.5 2.9-1.9 3.6-.3 8.4-4.3 10.6-1.7 4.3 1.9 10-1.7 13.2-.5 2 4.6 1.8 6 2.6 2.6 0 0-5.8 2.5-6.6 3.4 2 3.2-3.8 2.5-5.6.4-4 .6-8.6 2.6-12.3 2.2-4.5 4.2 1.9 1.8 3.7-1.4 4.1-3.4 9.4-.3 13.3 1 .2 1.7 2.4 2.8 3 1.2.7 2.8-.1 3-2.1 1.6-6 .8-12.4 3-18.3 1.5-1.8 3.6-.3 4.5 1.4 3 3.5 5.1 7.8 8.7 10.7a15 15 0 0 1 7.8 7.3c0 2.6 7.4 3 5.2 0-2.1-2.7-.7-5.6 1.4-7.5 1.2.3.9-1.8 0-1-1.5-.3-1.6-3 .4-1.7 3.5 1.1-.2-2.5-1.5-2.6-2.9-1.8-6.2-3.8-7.6-7 3.8 0 7.7 2.1 11.5.9 3.1-1.6 6.2 0 7.3 2.8 2.4-.4 1.4-2.8 0-3.6 1.7-.7 3-2.2.8-3.5-1-1.4 1.5-4-1.7-3.8.1-2.5-.8-4.7-3.5-5.6-2.7-2.2-10.6 3.4-10.3-1.7-.8-2.8 3.2-.4 4.3-1.8 1.1-3-5.5-2.6-3.3-5 1.4-.8 8.1-2.1 2.9-3.1a8.3 8.3 0 0 1-7-1.1c-1.9 3.1-7.2-1.8-6.3 3.8-.7 2.1-5.5 7.6-6.8 3.4 1-3.3 6.8-4.3 5-8.8-.3-2.7-2.6.5-3.6.3-.6-1.7 1.6-3.8 3.2-4.2 3 2.4 3-3 6-2.5 2.1-.5-.7-1.4-1.3-1.8.6-1.5 3.9-2.3.7-3.7-2.9-2-5 2.1-7.3 2.3-2.2-2.5 2-3.7 3.2-5 .1-1-2.4-.3-1.7-1.2.7-1.1 5.2-1.2 3-3a14.7 14.7 0 0 0-10.2.6c-2 .6-2.5 5-4.2 4.8-.7-2 .3-5.8-2.4-6.3zm15 42.3c2.4-.4 0 3.7-1 3.6 0-1.4-3.6-1.3-1.3-2.6a7.3 7.3 0 0 1 2.3-1z"
    />
    <g fill="#ffe000" transform="translate(0 80) scale(.0635)">
      <use
        width="100%"
        height="100%"
        x={7560}
        y={4200}
        xlinkHref="#prefix__a"
      />
      <use
        width="100%"
        height="100%"
        x={6300}
        y={2205}
        xlinkHref="#prefix__a"
      />
      <use width="100%" height="100%" x={7560} y={840} xlinkHref="#prefix__a" />
      <use
        width="100%"
        height="100%"
        x={8680}
        y={1869}
        xlinkHref="#prefix__a"
      />
      <use
        width="100%"
        height="100%"
        x={8064}
        y={2730}
        xlinkHref="#prefix__b"
      />
    </g>
  </svg>
	),
	CD: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#007fff" d="M0 0h640v480H0z" />
    <path
      fill="#f7d618"
      d="M28.8 96H96l20.8-67.2L137.6 96h67.2l-54.4 41.6 20.8 67.2-54.4-41.6-54.4 41.6 20.8-67.2L28.8 96zM600 0L0 360v120h40l600-360V0h-40"
    />
    <path fill="#ce1021" d="M640 0L0 384v96L640 96V0" />
  </svg>
	),
	CF: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-12.4 32h640v480h-640z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(12.4 -32)"
    >
      <path fill="#00f" d="M-52 32h719.3v119H-52z" />
      <path fill="#ff0" d="M-52 391.6h719.3V512H-52z" />
      <path fill="#009a00" d="M-52 271.3h719.3v120.3H-52z" />
      <path fill="#fff" d="M-52 151h719.3v120.3H-52z" />
      <path fill="red" d="M247.7 32.5h119.9V512H247.7z" />
      <path
        fill="#ff0"
        d="M99.3 137.7l-31.5-21.8-31.3 22L47.4 101 16.9 78l38.2-1 12.5-36.3L80.3 77l38.1.7L88.2 101"
      />
    </g>
  </svg>
	),
	CG: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-79.5 32h640v480h-640z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="translate(79.5 -32)"
    >
      <path fill="#ff0" d="M-119.5 32h720v480h-720z" />
      <path fill="#00ca00" d="M-119.5 32v480l480-480h-480z" />
      <path fill="red" d="M120.5 512h480V32l-480 480z" />
    </g>
  </svg>
	),
	CH: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#d52b1e" d="M0 0h640v480H0z" />
      <g fill="#fff">
        <path d="M170 195h300v90H170z" />
        <path d="M275 90h90v300h-90z" />
      </g>
    </g>
  </svg>
	),
	CI: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#00cd00" d="M426.8 0H640v480H426.8z" />
      <path fill="#ff9a00" d="M0 0h212.9v480H0z" />
      <path fill="#fff" d="M212.9 0h214v480h-214z" />
    </g>
  </svg>
	),
	CK: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#006" d="M0 0h640v480H0z" />
    <g strokeWidth="1pt">
      <path
        fill="#fff"
        d="M0 0v24.8L319.8 222H360v-24.8L40.2 0H0zm360 0v24.8L40.2 222H0v-24.8L319.8 0H360z"
      />
      <path fill="#fff" d="M150 0v222h60V0h-60zM0 74v74h360V74H0z" />
      <path
        fill="#c00"
        d="M0 88.8v44.4h360V88.8H0zM162 0v222h36V0h-36zM0 222l120-74h26.8l-120 74H0zM0 0l120 74H93.2L0 16.5V0zm213.2 74l120-74H360L240 74h-26.8zM360 222l-120-74h26.8l93.2 57.4v16.5z"
      />
    </g>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M471.6 213l5.2-16.7-14-10.6 17.6-.2 6-16.5 5.6 16.5 17.7.5-14.1 10.5 5 16.7-14.5-10m27.1 13l10.4-13.9-9.7-14.8 16.7 5.8 11-13.5v17.6l16.4 6.4-16.8 5-.8 17.5-10.2-14.4m-98.4 15l-.7-17.5-16.8-5.2L431 198v-17.4l10.9 13.5 16.8-5.6-9.8 14.7 10.3 14-17-4.5m-39.6 40.9l-7.4-15.8-17.4 1.8 12.8-12.3L384 211l15.2 8.2 13.3-11.8-3.4 17.4 14.9 8.9-17.3 2.5M389 291.8l-13.3-11.1-15 9.2 6.4-16.7-12.9-11.6 17.3.7 7-16.4 4.3 17.2 17.2 1.5-14.6 9.8m3.2 60.4l-16.5-4.8-10.1 14.5-.7-17.9-16.4-5.5 16.1-6.2v-18l10.7 14.1 16.4-5.6-9.6 15m29.5 50.8l-17 2.4-3.5 17.4-7.8-16-17.1 1.6 12.2-12.3-7.1-16.4 15.3 8.5 12.8-11.8L393 362m45 38l-15.1 8.2 2.6 17.6-12.7-12.4-15.6 7.6 7.3-15.9-12.3-12.9 17.3 2.6 8-15.5 3.4 17.4m53.8 9l-8.3 15.3 11.7 13.2-17.4-3.3-8.9 15-2.4-17.3-17.2-4 15.8-7.4-1.7-17.5 12.2 12.8m57.4-13.1l-.5 17.4 16.3 6.4-17 5-1.2 17.5-10-14.3-17 4.4 10.8-13.9-9.4-14.7 16.6 5.7M559 209.8l12 12.6 15.9-7.4-8.3 15.8 11.5 13.1-17-2.8-9 15.5L562 239l-17-3.5 15.7-8m34.2 21l5.5 16.6 17.5.3-14.2 10.7 4.7 16.8-14.1-10-14.6 10.1 5.4-16.8-13.8-10.6 17.6-.4m19.5 33.2l-2 17.4 15.7 7.7-17.3 3.6-2.7 17.3-8.7-15.1-17.4 2.9 12-13-8.1-15.5 16 7.2m3 39.8l-7.8 15.6L603 379l-17.4-2.7-8.4 15.3-3-17.3-17.4-3.3 15.6-8-2.3-17.4 12.6 12.3m-9.8 39.1l-14.7 9.2 3.8 17.3-13.5-11.5-15 8.6 6.3-16.3-13.1-12.1 17.4 1.5 7-16 4.4 17.2"
    />
  </svg>
	),
	CL: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g fillRule="evenodd" clipPath="url(#prefix__a)" transform="scale(.9375)">
      <path fill="#fff" d="M256 0h512v256H256z" />
      <path fill="#0039a6" d="M0 0h256v256H0z" />
      <path
        fill="#fff"
        d="M167.8 191.7L128.2 162l-39.5 30 14.7-48.8L64 113.1l48.7-.5L127.8 64l15.5 48.5 48.7.1-39.2 30.4 15 48.7z"
      />
      <path fill="#d52b1e" d="M0 256h768v256H0z" />
    </g>
  </svg>
	),
	CM: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#007a5e" d="M0 0h213.3v480H0z" />
    <path fill="#ce1126" d="M213.3 0h213.4v480H213.3z" />
    <path fill="#fcd116" d="M426.7 0H640v480H426.7z" />
    <g fill="#fcd116" transform="translate(320 240) scale(7.1111)">
      <g id="prefix__b">
        <path id="prefix__a" d="M0-8L-2.5-.4 1.3.9z" />
        <use
          width="100%"
          height="100%"
          transform="scale(-1 1)"
          xlinkHref="#prefix__a"
        />
      </g>
      <use
        width="100%"
        height="100%"
        transform="rotate(72)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(144)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(-144)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(-72)"
        xlinkHref="#prefix__b"
      />
    </g>
  </svg>
	),
	CN: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <path id="prefix__a" fill="#ffde00" d="M-.6.8L0-1 .6.8-1-.3h2z" />
    </defs>
    <path fill="#de2910" d="M0 0h640v480H0z" />
    <use
      width={30}
      height={20}
      transform="matrix(71.9991 0 0 72 120 120)"
      xlinkHref="#prefix__a"
    />
    <use
      width={30}
      height={20}
      transform="matrix(-12.33562 -20.5871 20.58684 -12.33577 240.3 48)"
      xlinkHref="#prefix__a"
    />
    <use
      width={30}
      height={20}
      transform="matrix(-3.38573 -23.75998 23.75968 -3.38578 288 95.8)"
      xlinkHref="#prefix__a"
    />
    <use
      width={30}
      height={20}
      transform="matrix(6.5991 -23.0749 23.0746 6.59919 288 168)"
      xlinkHref="#prefix__a"
    />
    <use
      width={30}
      height={20}
      transform="matrix(14.9991 -18.73557 18.73533 14.99929 240 216)"
      xlinkHref="#prefix__a"
    />
  </svg>
	),
	CO: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#ffe800" d="M0 0h640v480H0z" />
      <path fill="#00148e" d="M0 240h640v240H0z" />
      <path fill="#da0010" d="M0 360h640v120H0z" />
    </g>
  </svg>
	),
	CR: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#0000b4" d="M0 0h640v480H0z" />
      <path fill="#fff" d="M0 75.4h640v322.3H0z" />
      <path fill="#d90000" d="M0 157.7h640v157.7H0z" />
    </g>
  </svg>
	),
	CU: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-32 0h682.7v512H-32z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(30) scale(.94)"
    >
      <path fill="#0050f0" d="M-32 0h768v512H-32z" />
      <path fill="#fff" d="M-32 102.4h768v102.4H-32zm0 204.8h768v102.4H-32z" />
      <path fill="#ed0000" d="M-32 0l440.7 255.7L-32 511V0z" />
      <path
        fill="#fff"
        d="M161.8 325.5L114.3 290l-47.2 35.8 17.6-58.1-47.2-36 58.3-.4 18.1-58 18.5 57.8 58.3.1-46.9 36.3 18 58z"
      />
    </g>
  </svg>
	),
	CV: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-123.4 0h682.6v512h-682.6z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(115.7) scale(.94)"
    >
      <path fill="#fff" d="M-123.4 233H723v206h-846.5z" />
      <path
        fill="#081873"
        d="M-122.8 0h846v256.6h-846zm.3 385.9h852.1V512h-852.1z"
      />
      <path fill="#de3929" d="M-122.5 302.6h846v39.6h-846z" />
      <path
        fill="#ffce08"
        d="M131 399.2l6.6 20.4H159l-17.4 12.7 6.6 20.5L131 440l-17.4 12.7 6.7-20.5-17.4-12.7h21.5M317 250.4l6.7 20.5H345l-17.4 12.6 6.6 20.5-17.4-12.7-17.4 12.7 6.6-20.5-17.4-12.6h21.6m-222 64.4l6.6 20.5h21.5L99 368.6l6.7 20.4-17.4-12.6L70.9 389l6.6-20.4-17.4-12.7h21.5M317 329.5l6.7 20.4H345l-17.4 12.7 6.6 20.4-17.4-12.6-17.4 12.7 6.6-20.5-17.4-12.7h21.6m-40.5-161.7l6.7 20.4H298l-17.4 12.7 6.6 20.5-17.4-12.7-17.4 12.7 6.7-20.5-17.5-12.7h21.6m-64.5-45.2l6.7 20.5h21.5l-17.4 12.6 6.6 20.5-17.4-12.6-17.4 12.6 6.7-20.5-17.4-12.6H192m-64.5 2.9l6.7 20.5h21.5l-17.4 12.6 6.7 20.5-17.5-12.7-17.4 12.7 6.7-20.5-17.4-12.6H121m-34.8 43.2l6.6 20.5h21.6l-17.5 12.6 6.7 20.5-17.4-12.7-17.4 12.7 6.6-20.5L58 271h21.5m119.2 149.4l6.7 20.5h21.5l-17.4 12.6 6.7 20.5-17.5-12.7-17.4 12.7 6.7-20.5-17.4-12.6H192m82.2-41.7l6.6 20.4h21.5L285 432.3l6.7 20.5-17.4-12.7-17.5 12.7 6.7-20.5-17.4-12.7h21.5"
      />
    </g>
  </svg>
	),
	CW: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <path
        id="prefix__b"
        d="M0-1l.2.7H1L.3 0l.2.7L0 .4l-.6.4.2-.7-.5-.4h.7z"
      />
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="scale(.94)">
      <path fill="#002b7f" d="M0 0h768v512H0z" />
      <path fill="#f9e814" d="M0 320h768v64H0z" />
      <use
        width={13500}
        height={9000}
        x={2}
        y={2}
        fill="#fff"
        transform="scale(42.67)"
        xlinkHref="#prefix__b"
      />
      <use
        width={13500}
        height={9000}
        x={3}
        y={3}
        fill="#fff"
        transform="scale(56.9)"
        xlinkHref="#prefix__b"
      />
    </g>
  </svg>
	),
	CX: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#0021ad" d="M0 0h640v480H0z" />
    <path fill="#1c8a42" d="M0 0h640v480z" />
    <circle cx={320} cy={240} r={57.8} fill="#ffc639" />
    <path
      fill="#1c8a42"
      d="M284.7 214c4 5.5 10 14.6 14.8 12.2 3.7 0 5.7.3 6.2 2.8a37 37 0 0 0 33-14.3s.8 0 .5-4.5c0-2 2.8-1.6 2.8-1 .4 1 .4 1.7.9 1.8 1-.4 2.7-3 4-4.6.3-.7.1-1.5.2-2.4.7-1.7 2.4-1.3 2.8-.4l.6 1.6c1.8 1.2 5 0 5.2 0 .3-1.4 1.2-1.2 1.2-1.2 1.2-.3.7-.2 1.5.2-.7 7.7 1.5 8 1.3 12 .1 4.4-1.3 5.6-1.3 7.3.4 2 7 2.1 4.6 3.9-2 1 0 3-3 3.8-8.8 4.5-10.4 8.3-10.4 8.3s-2.2 4.2-2.5 4.2c-1.5 2.8-3.3 1.2-4.4 2.6-.5 1.7-1 5.5 0 7.4.5 2.7 0 4.2-.7 6.9-.6 5.6-2.8 6.5-3.1 8.4-1 2.2.2 12-.8 12-6.5.2-11.5-1.2-14.1-1.7 2.5-10.9 1.5-20.4 1.5-21.4-.6-7.8-11.6-5.9-13.3-7-1.4-.2-2.3-1.3-2.7-1.8-1.6-.2-2.2-.6-3.7-.7-.8.4-.3.8-2 1.3-4.5.5-6.4-3.8-6.4-3.8.2-1.5-9.9.3-15.3-1-2.3 1.3-3.3 5-5.1 5.4 0 1.1-3-1-3.6-2-.2-3.4 2.8-4.8 2.8-4.8 2.4-1.7 3.8-2 5-3.1.5-2.9.2-5 1.5-7.1 1-1.7 2.5-1 3.5-1.6 1.1-.8 1.6-5.6.6-7l-4.7-4.2c-1.4-4.1 1.7-6.8 2.6-6.5z"
    />
    <path
      fill="#ffc639"
      d="M561.9 142.4c-2.6-10.3-26-32.7-43.7-46.9-4.2-2.8-7-1.1-6.4 3 2.2 3.6 3.8 7.6 6 11.3.6 2.5 1.8 4.2 2.4 6.6 0 0 .2 4.2.6 4.6 5.4 6 6.2 11.1 6.2 11.1a49 49 0 0 0 11.5 15.6c6.2 3.9 1.6 16 1.8 22.5 0 4-2.9 3.6-5.5 3-20.1-18.5-40.1-18.5-57.8-23.9-6.8-.7-7 2.6-4.7 4.4a129 129 0 0 0 39.1 29.6l7.7 4.8 8.8 7.3c6.8 4.4 7.3 8.4 7.3 8.8.2 8.2-4.2 14.6-5.5 17.2-2.3 8.7-7 10.2-7 10.2-37.6 25.4-57.4 32-118.4 24.1-1-.4-6.8.5 0 3 15.5 5.2 53.7 13.5 90.6-4 9-6.2 14.8-4.2 21.3-8a287.3 287.3 0 0 1 28.3-15.4c8.3-4.5 31.3-9.4 36.6-13.8 6.1-.5 12.4-1.3 12.8-6.5 2-1.3 5-.3 7.2-4.6 4.8-.9 4-2.6 4-2.6-1.2-3.4-5.8-4.8-9-7.3-4.8-1.6-8-2-11.5-.4l-3.3 1.5s-5.1-.7-5.1-1.1c-11.4-.6-10.3-38.3-14.3-54z"
    />
    <path
      fill="#1c8a42"
      d="M588.6 204.2a2.8 1.8 16 1 1-5.4-1.7 2.8 1.8 16 0 1 5.4 1.7z"
    />
    <g fill="#fff" transform="matrix(.64 0 0 .64 0 80)">
      <path
        id="prefix__a"
        d="M188.2 191l-12.8-12-12.9 11.8 1.4-17.4-17.3-2.8 14.5-9.8-8.6-15.2 16.7 5.3 6.5-16.2L182 151l16.7-5-8.8 15 14.4 10-17.3 2.5 1.2 17.4z"
      />
      <path d="M233.4 335.5l-13.8-9.1-13.4 9.6 4.8-15.5-13.6-9.5 16.6-.4 5-15.5 5.6 15.3 16.7-.1L228 320l5.3 15.4z" />
      <use
        width="100%"
        height="100%"
        x={2.5}
        y={269.1}
        xlinkHref="#prefix__a"
      />
      <use
        width="100%"
        height="100%"
        x={-112.1}
        y={123.2}
        xlinkHref="#prefix__a"
      />
      <use width="100%" height="100%" x={108.4} y={85} xlinkHref="#prefix__a" />
    </g>
  </svg>
	),
	CY: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path
      id="prefix__a"
      fill="#435125"
      d="M307.8 398.6a.8.8 0 0 1-.2-.2h-.1l-1.3-1.4-3.8-4.5-4.9-6.3-.6-.9-6.2-1.9-4.6-2.1 2.4-2.7 8.4 3.5 6.2 1.3 11.5 8.5-3.3 2.9a37.2 37.2 0 0 0-3.3 3.5l.7-.5.8.6-1.6.2zm-42.6-12.8a31.7 31.7 0 0 1-16-4.5s.7-1.3 2.3-2.4c1.6-1.2 4.4-2.5 9-2.6 5.4 0 12 1.9 19.5 5.4a28.8 28.8 0 0 1-14.8 4zm-23.5-5.2c-1 0-2-.4-2.6-1a5.2 5.2 0 0 1-1.1-2.4 11.7 11.7 0 0 1-.3-3.4 3.5 3.5 0 0 1 1.3-.2c2 0 3.6 1.7 4.3 3.4.4 1 .5 1.8.2 2.5-.2.6-1 1-1.8 1zm41.3-4.8c-13.9-2-19.8-7-22.3-10.9-2.6-4.1-2-8-2-8s.8-.2 2-.2c3.8 0 13.2 1.9 22.3 19zm-28.5-2.8c-5.9 0-10.4-1-13.4-3a8.3 8.3 0 0 1-3-3.3 5.4 5.4 0 0 1-.4-1.6 18.2 18.2 0 0 1 7.2-1.4 27 27 0 0 1 18.9 8.7c-3.4.4-6.5.6-9.3.6zm-28.7-1c-6.2 0-14.8-2-20.2-7.3 0 0 5.9-1.5 12.4-1.7h1.2c5.9 0 10.4 1.1 13.4 3.4 1 .8 1.6 1.5 1.7 2.2.1.6-.2 1.2-.8 1.7-1.4 1-3.8 1.6-7.2 1.6h-.5zm-20.3-10.5a2.6 2.6 0 0 1-2-1 4.7 4.7 0 0 1-.8-2c-.3-1.4-.2-2.8-.2-2.9a2.4 2.4 0 0 1 1-.2c.9 0 1.6.5 2 1a5.6 5.6 0 0 1 1.4 2c.2.9.3 1.6 0 2.2 0 .4-.6 1-1.3 1zm46.9-1c-1 0-2-.4-2.6-1a5.2 5.2 0 0 1-1.1-2.4 11.7 11.7 0 0 1-.3-3.4 3.5 3.5 0 0 1 1.3-.2c2 0 3.7 1.7 4.3 3.4.4 1 .5 1.8.3 2.5-.3.6-1 1-2 1zm-22.8-1c-12.6-.4-19.2-4-22.4-7a14.6 14.6 0 0 1-3.4-4.3c-.5-1-.7-1.8-.7-2s1.2-.4 3-.4h.4c4.2 0 12.9 1.8 23 13.7zm13.6-1.2a30.8 30.8 0 0 1-18.9-9.3 19.4 19.4 0 0 1-4.1-7s1.2-.3 3-.4a14.2 14.2 0 0 1 1 0c5 .1 14.3 2.4 19 16.7zm-52-5a42 42 0 0 1-9.5-1c-5.3-1.4-7.6-3.4-8.6-4.9a5 5 0 0 1-.8-2 3.4 3.4 0 0 1 0-.8s3.5-1 8.4-1.1a35 35 0 0 1 7.4.6 21.7 21.7 0 0 1 12.8 8.1s-4 1.2-9.7 1.2zm23.5-8.4a3.4 3.4 0 0 1-2.5-1 5.2 5.2 0 0 1-1.1-2.4c-.4-1.6-.3-3.2-.3-3.4a3.5 3.5 0 0 1 1.2-.3h.1c2 0 3.6 1.8 4.3 3.5.4 1 .4 1.8.2 2.4-.3.7-1 1.1-1.9 1.1zm-17.6-2.5a38.6 38.6 0 0 1-9.6-4.2c-4.4-2.7-9.9-7.5-10.5-15l1-.1h.3c1.3 0 4 .3 7.3 2.8 4.2 3.2 8 8.8 11.5 16.5zm11.5-.4a31.2 31.2 0 0 1-7.6-4.9 48.5 48.5 0 0 1-13.3-18.6s.9-.5 2.3-.6a3.3 3.3 0 0 1 .2 0h.4c2 0 4.9.9 8.1 4.4 3.8 4 7.1 10.6 10 19.7zm-29.9-.9c-3.9 0-5.2-2-5.6-3a6 6 0 0 1-.4-3 8.5 8.5 0 0 1 2-.2 8 8 0 0 1 6.5 3c.2.4.8 1.4.3 2.3-.4.6-1.3 1-2.8 1zm-8.5-10.8a51.1 51.1 0 0 1-9-.7c-3.4-.6-5.3-3.5-6.4-5.9-1-2.5-1.4-5-1.4-5 10.6.3 15.7 3.4 18 6a9.4 9.4 0 0 1 2.6 5.5s-1.6.2-3.8.2zm11-11a42.7 42.7 0 0 1-2.4-3.4c-1.3-2-2.4-4-2.4-5.6 0-1.7-.4-5-.6-7l-.6-4.5c.3 0 6.6 2.4 6.6 8.4s-.6 12-.6 12v.1zm-8.2-.6h-.2a43.7 43.7 0 0 1-18.2-10.8c-1.7-2-2.8-5.2-3.1-9.4-.2-3 0-5.5 0-5.8a3.3 3.3 0 0 1 1.1-.1c1.4 0 3 .6 5 2a39.6 39.6 0 0 1 5.2 4.4c3.2 3.2 5.7 6.4 5.7 6.4.3.4 2 3.7 3.5 6.9a22 22 0 0 1 1.6 4.6c.1.6.2 1 0 1.4a.7.7 0 0 1-.3.4.9.9 0 0 1-.4 0z"
    />
    <use
      width="100%"
      height="100%"
      transform="matrix(-1 0 0 1 593.7 0)"
      xlinkHref="#prefix__a"
    />
    <path
      fill="#d47600"
      d="M519 76.4l-1.8.7-.8.3-2.2-.1-2.2 1-3.8 2.6-.1.1-1.5.4-1.3-.6-.7.4-.3 1.5-.7 1.1-.9.6-3 .3-2.5 1.4-3.4-1-1.5.7-3.3 3-1.7.7h-.5l-2.3-.1-.9.3-1.4 1.3-2.6.2-.9.6-1.3 2.6L476 96l-.8.1-.8-.3-.7.1-.3 1.7-.6.7-1.8.6-1.4 1.2-1.3.6h-2l-1.7 1-3.1.2-1.3 1.2-.3.3-.6.3-1 .6-.2.2-1.2-.2-1.4.5-.6-.8-1 .5-1.2.1-1.6-.7-1.3-.6-.9.2-.3 1.5v.2l-1 1.2-1.7 1.1-.2.3-2 2.6-3.8 4-3.2 1.6-3.3 1-2.3 1.9-6 3-9.7 4.8-2 .6-2.8.4-5 1.9-4.4 1.3-.3.1-.8.3-6.3 1.9-2.9-.4-1.7.7-4.5-.5h-3.1l-2 .4-3.7 1.8-6.3 3-2 2-3.2 1.6-3.8 1.2v-1.6l-1.3.4-1 .3-3 .4h-1.7l-1.1-.3h-.2l-6.2 2.1-7 .7-3.5 1.1H333l-1.6.5-3.2.4-1.2-.3-.2-.1-9.4.4-4.3-.5-2 .5-3.5-1.2-5-.6-1.2-.3-2.6-.8-1.2.7-1 .1-2-.8h-.8l-1.8.6-1-.2-1-.8-2.1-.3-1.4-1.1-7.5 1-2-.6-6.9-2h-1l-1.4 1-2 .8-1.9.4-2.4.1-2.8-.7-2.8-1.4-1.1-.3-2.4.3h-.7l-4.4-2.3-5.6-3.5-3.8-1.9-1.5-.2-.2.7.7 2.2.3 2.3v2l-.1 1.3.3 1.1 1.4 1.6.6 1.5.4 4.2v4.3l-.7 6.8-.2 1-.8 3.6-.7 3.3-2.9 8.7-.7 1-2 1.3-4.3 3-3.2 1.8-1 .4-2.6.2H219l-2-1.1-2-.5-2.6-1.9-2.8-.6-3.2-1.8-.8-1-1.7-.2-2.4-.7-.9-.3-.6-.1-3-.1-2.9-1.3-1.5-.4h-2l-2.1 1-1.1.4-1.4-.5h-1l-1 1.7-.2.3-.8.4h-1.7l-.8.3-1.1.5-1 .4-.5.2h-.3l-.5.2h-.6l-1.2-.6-.6-.3-1-.2-.5.3-.1 1.9-.5 1.1-1.6 1.4-1.6 1.4-1 1.6-3 6.7-1.9 2.7-.5.7-2 2.1-1.7 1.3-3.9 3-3.7 1.5-3.2.6h-1.6l-3-.4-2.6-.8-3-1.8-3.1-2.6-4.7-4.5-.6-.4-.2-.1-1.4-1h-1.1l-.4.8-.3 1-.2.9-.5 5v.3l.3 2.1 3.6 5 1 2.6.2.3.7 1.2.6 1 1.3 3.6-.9 2 .4 1.4-1 .8-.2 1.2 3.1 4 .7 1.7-.7 2.4-1.3 1.4-.3.3.2 1 1.4 1.4 2.5 2.2 1.3 3.2 1 1 1.2-.3.6.5h1l1 1 .6.2 1 .5.8 1 .1 3.2 1.5 3.8v2.5l1 1.5.2 1.2-.5 3.3 1.2 1 1.2-.2.8.1 1.3 1.1 1.6 2.4 1.6-.2 1 .4 4.7 4.3 1 .6.9.4 1 1 1.4-1h.2l1.6-.2.7.5 1.4.9h1.7l4 1.2 1.6.4 3.4 2.1 1.5.9.8.7 1.2 1 2.2 1 2 .4 1 .2.9.3 4.2 1.7 2.3.5 2 .8 1.6.5h1.2l1.6-1.3h1.5l1.3.2 1.3-.2 2-1.2.3-.6 1.4-.6 4.8-.6 1.4.4 3.6-1.5 2.4.6 2-.7 4.7 1 1.2.9 1.4 1.5h1.7l-.7 1.1 2 2.2 1.9 2.7.1.4 1.3 3.9 1 1.4.7 1.9v1.2l-1 .9-.2.4v.2l.2.5.4-.2.7-.4 1-.2 1.6.2 1.1.1 1.7-.8 1.2-.6 1.8.8h2l.9.3 2.4 1.1 1.2.1.4-.3.3-.6-.1-.8-1-1.1-2-2.4-.8-1.2-.6-1.7-.2-2.2-.2-1.5.3-2 .5-.7.4-1.6.1-.4 1.2-1.5 3-2 3.2-2.8 2.5-1.7 2.6-1.1v-.3l.4.1 6.6-2.3 3-.5 20 1.4.7-.2.7-1.9.3-.3.3-.2 2.2-1 1-.2 2.8.7 1.2.3 1.9-1h1.3l2.7-1.5h1.7l.7-.2 3.3-2.4 3.1-.9.8-.4.3-.2 3.3-1.7 2-1.6 1.8-1 2-.4 5-.4 1.1-1.7 2.2-.3 1.3-1.5 1.5-.6 1.1-1.6 1-1.3 1.2-.7 4.1-.3 4.8.6.7-.4 1-3.9 1.2-.7 3-4.5v-1.6l.1-1.4.5-2-.3-3.4.4-3.6 1.9-4.5 1.7-1.8 2.7-1.9 1.4-.6 2-.3h.2l.5-.2h9.2l2.3-.1 5.7 1h.4l1.9.7 2.2 1.7 2.4 2.3.4.4 1.5.7.5.2 1.2-.2 1.8-1 1.4-1 1.8-1v-.2l1.1-1.5.4-.7 3.6-1.4 4.2-.2.5-.3h.2l1.1-1.4h1l2.6 1 1.7-.4 1.4.5 1.1-.1 2-.3 2.3 1.6 1.3.2 4.5 2.6h.4l.2.1.5-.2.8-.2h.1l.1.1.6.7.7.1.8-1-.3-.6-.1-.2-1.7-.3-1.4-2.5 1.4-1.5-2.2-2.6-.4-.5v-.1l-.8-1.2-3.8-5.8-5-4-1.7-1.3-.6-.5-2.7-2.7-1.9-2.5-.2-.5-.4-.9-1.1-2.4-2-1.5-1.6-1.8-3.4-4.6-.5-.7-.8-.5h-1.7l-.1-.2h-.1v-.1l.8-.8 1-.2.3-.9-1.7-4.9v-.2l-.1-1.5 1.3-7.1.2-.9 2.4-4.7 1.4-1.2 1.6-3.1 1.4-2 1.3-1.3.2-.1 2.3-1.4 2-.3 1.9-.3 3.3 1h3l.7-.1 1.4-.2 2.3-.7 1.1-.7.6-.8 1.2-4 .4-1.3.7-1.4 4.3-4.9 3.2-3 7.2-5.2 3.5-2.1 1.8-1.1 16.1-7.2 4.2-4.2 2.2-2.2 3.8-2.6 4.5-1.9 4-3 .8-1.1 1-3.5 1-.2.7-1.7.3-.5 3.1-2.2.4-.2 12.3-6.2 1.8.3 1-1.5 3.5-.6h.7l.9-.5.7-1.3v-.3l.1-3.4.8-.9.4-2.2.4-.6.4-.5 1-.7-.2-.4z"
    />
  </svg>
	),
	CZ: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-74 0h682.7v512H-74z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="translate(69.4) scale(.94)"
    >
      <path fill="#e80000" d="M-74 0h768v512H-74z" />
      <path fill="#fff" d="M-74 0h768v256H-74z" />
      <path fill="#00006f" d="M-74 0l382.7 255.7L-74 511V0z" />
    </g>
  </svg>
	),
	DE: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#ffce00" d="M0 320h640v160H0z" />
    <path d="M0 0h640v160H0z" />
    <path fill="#d00" d="M0 160h640v160H0z" />
  </svg>
	),
	DJ: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-40 0h682.7v512H-40z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(37.5) scale(.94)"
    >
      <path fill="#0c0" d="M-40 0h768v512H-40z" />
      <path fill="#69f" d="M-40 0h768v256H-40z" />
      <path fill="#fffefe" d="M-40 0l382.7 255.7L-40 511V0z" />
      <path
        fill="red"
        d="M119.8 292L89 270l-30.7 22.4L69.7 256l-30.6-22.5 37.9-.3 11.7-36.3 12 36.2h37.9l-30.5 22.7 11.7 36.4z"
      />
    </g>
  </svg>
	),
	DK: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#c8102e" d="M0 0h640.1v480H0z" />
    <path fill="#fff" d="M205.7 0h68.6v480h-68.6z" />
    <path fill="#fff" d="M0 205.7h640.1v68.6H0z" />
  </svg>
	),
	DM: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-85 0h682.7v512H-85z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(79.7) scale(.94)"
    >
      <path fill="#108c00" d="M-258.3 0H769.2v512H-258.3z" />
      <path fill="#ffd600" d="M-260 178.2H772.6v50.1H-260z" />
      <path fill="#ffd600" d="M181 0h48.5v512h-48.4z" />
      <path d="M227.8 0h48.4v512h-48.4z" />
      <path d="M-260 226.6H772.6v50.2H-260z" />
      <path fill="#fff" d="M-260 276.8H772.6v50.1H-260z" />
      <path fill="#fff" d="M276.2 0h48.5v512h-48.5z" />
      <rect
        width={273.8}
        height={275}
        x={-394.6}
        y={-393.9}
        fill="#e72910"
        ry={137.5}
        transform="scale(-1)"
      />
      <g strokeWidth="1pt">
        <path d="M250.5 137l5.6-16 5.1 15.7s17.1.5 17.1.2-13.5 10.3-13.5 10.3l6.1 17.6c-.2-.5-14.8-10.9-14.8-10.9s-14.8 10.4-14.5 10.4 5.6-17 5.6-17l-13.3-10.1 16.6-.3z" />
        <path
          fill="#ffe700"
          d="M251.3 137.7L256 124l4.4 13.6s14.9.4 14.9.2-11.7 9-11.7 9l5.2 15.2c-.2-.5-12.8-9.4-12.8-9.4s-12.8 9-12.6 9 5-14.8 5-14.8l-11.6-8.8 14.4-.2z"
        />
        <path
          fill="#108c00"
          d="M253.3 140l2.8-8 2.6 7.9s8.5.2 8.5 0-6.7 5.2-6.7 5.2l3 8.8c-.1-.3-7.4-5.4-7.4-5.4l-7.2 5.2c.2 0 2.8-8.5 2.8-8.5l-6.6-5 8.2-.2z"
        />
      </g>
      <g strokeWidth="1pt">
        <path d="M356.9 211.8l5.6-16 5 15.7s17.2.6 17.2.3-13.5 10.3-13.5 10.3l6 17.6c-.2-.5-14.7-10.9-14.7-10.9s-14.8 10.4-14.5 10.4 5.6-17 5.6-17L340.3 212l16.6-.3z" />
        <path
          fill="#ffe700"
          d="M357.6 212.6l4.9-13.9 4.4 13.7s14.8.4 14.8.2-11.7 9-11.7 9l5.3 15.1c-.2-.4-12.8-9.4-12.8-9.4s-12.8 9-12.6 9 4.9-14.8 4.9-14.8l-11.5-8.7 14.3-.2z"
        />
        <path
          fill="#108c00"
          d="M359.7 214.9l2.8-8 2.5 7.8 8.6.2-6.8 5.1s3.2 9 3 8.8c0-.3-7.3-5.4-7.3-5.4l-7.3 5.1 2.8-8.5-6.6-5 8.3-.1z"
        />
      </g>
      <g strokeWidth="1pt">
        <path d="M325.9 330.6l5.6-16 5 15.8s17.2.5 17.2.3-13.5 10.3-13.5 10.3l6 17.5c-.2-.5-14.7-10.8-14.7-10.8S316.7 358 316.9 358s5.7-17 5.7-17l-13.3-10 16.6-.3z" />
        <path
          fill="#ffe700"
          d="M326.6 331.4l4.9-13.8 4.4 13.6s14.8.5 14.8.2-11.7 9-11.7 9l5.3 15.2c-.2-.5-12.8-9.4-12.8-9.4s-12.8 9-12.6 9 4.9-14.8 4.9-14.8l-11.5-8.7 14.3-.3z"
        />
        <path
          fill="#108c00"
          d="M328.7 333.7l2.8-8 2.5 7.9s8.6.3 8.6.1-6.8 5.2-6.8 5.2l3 8.7c0-.2-7.3-5.4-7.3-5.4l-7.3 5.2 2.8-8.5-6.6-5 8.3-.2z"
        />
      </g>
      <g strokeWidth="1pt">
        <path d="M177.2 330.6l5.6-16 5 15.8s17.1.5 17.1.3-13.5 10.3-13.5 10.3l6.2 17.5c-.3-.5-14.8-10.8-14.8-10.8S168 358 168.2 358s5.7-17 5.7-17l-13.3-10 16.6-.3z" />
        <path
          fill="#ffe700"
          d="M178 331.4l4.8-13.8 4.4 13.6s14.8.5 14.8.2-11.7 9-11.7 9l5.3 15.2c-.2-.5-12.8-9.4-12.8-9.4s-12.8 9-12.6 9 4.9-14.8 4.9-14.8l-11.5-8.7 14.3-.3z"
        />
        <path
          fill="#108c00"
          d="M180 333.7l2.8-8 2.5 7.9s8.6.3 8.6.1-6.8 5.2-6.8 5.2l3 8.7c0-.2-7.3-5.4-7.3-5.4l-7.3 5.2 2.8-8.5-6.6-5 8.3-.2z"
        />
      </g>
      <g strokeWidth="1pt">
        <path d="M150 208.7l5.6-16 5.1 15.8s17.1.5 17.1.2-13.5 10.4-13.5 10.4l6.1 17.5c-.3-.5-14.8-10.8-14.8-10.8S140.8 236 141.1 236s5.6-17 5.6-17l-13.3-10 16.6-.3z" />
        <path
          fill="#ffe700"
          d="M150.8 209.5l4.8-13.8 4.5 13.6s14.7.5 14.7.2-11.7 9-11.7 9l5.3 15.2c-.2-.5-12.8-9.4-12.8-9.4s-12.8 9-12.5 9 4.8-14.8 4.8-14.8l-11.5-8.7 14.4-.3z"
        />
        <path
          fill="#108c00"
          d="M152.8 211.8l2.8-8 2.6 7.9 8.5.1-6.7 5.2 3 8.7c-.1-.2-7.4-5.4-7.4-5.4l-7.2 5.2c.2 0 2.8-8.5 2.8-8.5l-6.6-5 8.2-.2z"
        />
      </g>
      <g strokeWidth="1pt">
        <path d="M324.6 174.1l-5.6 16-5-15.7s-17.2-.5-17.2-.3 13.5-10.3 13.5-10.3l-6-17.5c.2.5 14.7 10.8 14.7 10.8s14.8-10.3 14.5-10.3-5.6 17-5.6 17l13.3 10-16.6.3z" />
        <path
          fill="#ffe700"
          d="M323.9 173.3c0 .3-5 13.9-5 13.9l-4.3-13.6s-14.8-.5-14.8-.3 11.7-8.9 11.7-8.9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.9 14.8-4.9 14.8l11.5 8.7-14.4.2z"
        />
        <path
          fill="#108c00"
          d="M321.8 171l-2.8 8-2.5-7.8s-8.6-.3-8.6-.1 6.8-5.2 6.8-5.2l-3-8.7c0 .2 7.3 5.4 7.3 5.4l7.3-5.2c-.2 0-2.9 8.5-2.9 8.5l6.7 5-8.3.2z"
        />
      </g>
      <g strokeWidth="1pt">
        <path d="M367.3 290.3l-5.6 16-5-15.8s-17.2-.5-17.2-.2S353 280 353 280l-6-17.6c.2.5 14.7 10.8 14.7 10.8s14.8-10.3 14.5-10.3-5.6 17-5.6 17L384 290l-16.6.3z" />
        <path
          fill="#ffe700"
          d="M366.6 289.5l-4.9 13.8-4.4-13.6s-14.8-.4-14.8-.2 11.7-9 11.7-9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.9 14.8-4.9 14.8l11.5 8.8-14.4.2z"
        />
        <path
          fill="#108c00"
          d="M364.5 287.2l-2.8 8-2.5-7.9s-8.6-.2-8.6 0 6.8-5.2 6.8-5.2l-3-8.8c0 .3 7.3 5.4 7.3 5.4l7.3-5.2c-.2 0-2.9 8.6-2.9 8.6l6.7 5-8.3.1z"
        />
      </g>
      <g strokeWidth="1pt">
        <path d="M261.4 375.3l-5.6 16-5-15.8s-17.2-.5-17.2-.3 13.5-10.3 13.5-10.3l-6-17.5c.2.5 14.7 10.8 14.7 10.8s14.8-10.3 14.5-10.3-5.6 17-5.6 17L278 375l-16.6.3z" />
        <path
          fill="#ffe700"
          d="M260.7 374.4l-4.9 14-4.4-13.7s-14.8-.5-14.8-.2 11.7-9 11.7-9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.9 14.8-4.9 14.8l11.5 8.7-14.3.3z"
        />
        <path
          fill="#108c00"
          d="M258.6 372.2l-2.8 8-2.5-7.9s-8.6-.3-8.6-.1 6.8-5.2 6.8-5.2l-3-8.7c0 .2 7.3 5.4 7.3 5.4l7.3-5.2-2.8 8.5 6.6 5-8.3.2z"
        />
      </g>
      <g strokeWidth="1pt">
        <path d="M162 290.3l-5.7 16-5-15.8s-17.2-.5-17.2-.2 13.5-10.3 13.5-10.3l-6-17.6c.2.5 14.7 10.8 14.7 10.8L171 263l-5.7 17 13.3 10.1-16.6.3z" />
        <path
          fill="#ffe700"
          d="M161.2 289.5l-4.9 13.8-4.4-13.6s-14.8-.4-14.8-.2 11.7-9 11.7-9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.9 14.8-4.9 14.8l11.5 8.8-14.3.2z"
        />
        <path
          fill="#108c00"
          d="M159.1 287.2l-2.8 8-2.5-7.9s-8.6-.2-8.6 0 6.8-5.2 6.8-5.2l-3-8.8c0 .3 7.3 5.4 7.3 5.4l7.3-5.2-2.8 8.6 6.6 5-8.3.1z"
        />
      </g>
      <g strokeWidth="1pt">
        <path d="M198.7 175.8l-5.6 16-5.2-15.7s-17-.5-17-.3 13.5-10.3 13.5-10.3l-6.1-17.5c.2.5 14.7 10.8 14.7 10.8s14.8-10.3 14.6-10.3-5.6 17-5.6 17l13.2 10-16.5.4z" />
        <path
          fill="#ffe700"
          d="M197.9 175l-4.9 14-4.4-13.7s-14.8-.5-14.8-.2 11.7-9 11.7-9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.8 14.8-4.8 14.8l11.4 8.7-14.3.3z"
        />
        <path
          fill="#108c00"
          d="M195.8 172.8l-2.8 8-2.5-7.9s-8.5-.3-8.5-.1 6.7-5.2 6.7-5.2l-3-8.7c0 .2 7.3 5.4 7.3 5.4l7.3-5.2-2.8 8.5 6.6 5-8.3.2z"
        />
      </g>
      <g transform="matrix(1.04 0 0 1.04 -250.6 359.4)">
        <g
          fill="#009200"
          stroke="#000"
          strokeWidth={2.5}
          transform="matrix(.16 -.02 0 .18 429.8 -215.6)"
        >
          <ellipse
            cx={680.2}
            cy={586.1}
            rx={30.8}
            ry={189.8}
            transform="matrix(1.4 0 0 1 -534.3 263.7)"
          />
          <ellipse
            cx={680.2}
            cy={586.1}
            rx={30.8}
            ry={189.8}
            transform="matrix(1.5 0 0 1 -547.2 267)"
          />
          <ellipse
            cx={680.2}
            cy={586.1}
            rx={30.8}
            ry={189.8}
            transform="matrix(1.2 0 0 1.1 -365 214.1)"
          />
        </g>
        <g stroke="#000" transform="translate(72.9 -9.8)">
          <path
            fill="#a95600"
            strokeWidth={0.5}
            d="M388.5-53c6-.3 3.4-3.3 6.4-5 3-1.6 7.3-.6 8.6 1.4 1.3 2 .3 4 2 4s47-2.5 48.6-.9c1.6 1.7 2 5 .3 6.3-1.6 1.4-58.9 3-60.9 1.6s-5-7-5-7.4z"
          />
          <path
            fill="#ff0"
            strokeWidth={3.9}
            d="M529.6 405.5c0 40 45.6 27.8 46.8 61.2-.7 35.4-76.7 3.5-78.6-61.2 1.9-64.8 75-98 76.7-61 1.2 30.6-45 21-45 61z"
            transform="matrix(.15 0 0 .1 340.4 -81.7)"
          />
          <path
            fill="#ff0"
            strokeWidth={3.9}
            d="M529.6 405.5c0 40 45.6 27.8 46.8 61.2-.7 35.4-76.7 3.5-78.6-61.2 1.9-64.8 75-98 76.7-61 1.2 30.6-45 21-45 61z"
            transform="matrix(.15 0 0 .1 344.4 -81.6)"
          />
          <path
            fill="#ff0"
            strokeWidth={3.9}
            d="M529.6 405.5c0 40 45.6 27.8 46.8 61.2-.7 35.4-76.7 3.5-78.6-61.2 1.9-64.8 75-98 76.7-61 1.2 30.6-45 21-45 61z"
            transform="matrix(.15 0 0 .1 348.7 -81.8)"
          />
          <path
            fill="#ff0"
            strokeWidth={3.9}
            d="M529.6 405.5c0 40 45.6 27.8 46.8 61.2-.7 35.4-76.7 3.5-78.6-61.2 1.9-64.8 75-98 76.7-61 1.2 30.6-45 21-45 61z"
            transform="matrix(.15 0 0 .1 352.7 -81.8)"
          />
          <ellipse
            cx={478.4}
            cy={-41.1}
            fill="#a95600"
            strokeWidth={0.4}
            rx={3.5}
            ry={3.4}
            transform="matrix(1.1 .02 -.02 1.15 -75.6 4.7)"
          />
        </g>
        <g
          fill="#009200"
          stroke="#000"
          strokeWidth={2.5}
          transform="rotate(-5.8 688.4 -625.2)"
        >
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.17 0 0 .32 369.8 -361.6)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.17 0 0 .32 364 -362.7)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.17 0 0 .32 360.6 -370.6)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.16 0 0 .35 369.3 -399.4)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.16 0 0 .33 377.4 -379)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.16 0 0 .33 373.2 -382.2)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.16 0 0 .33 368 -386.7)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.16 0 0 .33 363 -389.5)"
          />
        </g>
        <path
          fill="#804bff"
          stroke="#000"
          strokeWidth={0.5}
          d="M482.6-141s-11.7 10-10.1 36.9c1.8 27 26.5 39.5 26.5 39.5s6.2-7.7 5.2-29.5c-2-31.8-13.8-45.7-13.8-45.7l-7.8-1.3z"
        />
        <g
          fill="#009200"
          stroke="#000"
          strokeWidth={2.5}
          transform="rotate(4.5 181 769.9)"
        >
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.17 0 0 .32 369.8 -361.6)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.17 0 0 .32 364 -362.7)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.17 0 0 .32 360.6 -370.6)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.16 0 0 .35 369.3 -399.4)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.16 0 0 .33 377.4 -379)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.16 0 0 .33 373.2 -382.2)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.16 0 0 .33 368 -386.7)"
          />
          <ellipse
            cx={427.1}
            cy={905}
            rx={20.8}
            ry={24.1}
            transform="matrix(.16 0 0 .33 363 -389.5)"
          />
        </g>
        <ellipse
          cx={624.4}
          cy={606.1}
          fill="#c90000"
          stroke="#000"
          strokeWidth="1pt"
          rx={58.3}
          ry={186.5}
          transform="matrix(.16 -.06 .06 .15 369.6 -145)"
        />
        <g fill="#009200" stroke="#000" transform="rotate(1 242.4 -1957.8)">
          <ellipse
            cx={218.1}
            cy={356.8}
            strokeWidth={1.5}
            rx={10.8}
            ry={12.9}
            transform="matrix(.4 0 0 .3 445 -230.5)"
          />
          <ellipse
            cx={218.1}
            cy={356.8}
            strokeWidth={1.6}
            rx={10.8}
            ry={12.9}
            transform="matrix(.35 0 0 .3 457.2 -236)"
          />
          <ellipse
            cx={218.1}
            cy={356.8}
            strokeWidth={1.6}
            rx={10.8}
            ry={12.9}
            transform="matrix(.35 0 0 .3 452 -236)"
          />
          <ellipse
            cx={218.1}
            cy={356.8}
            strokeWidth={1.6}
            rx={10.8}
            ry={12.9}
            transform="matrix(.37 0 0 .27 449.5 -233.5)"
          />
          <ellipse
            cx={218.1}
            cy={356.8}
            strokeWidth={1.6}
            rx={10.8}
            ry={12.9}
            transform="matrix(.37 0 0 .27 449 -238)"
          />
          <ellipse
            cx={218.1}
            cy={356.8}
            strokeWidth={1.6}
            rx={10.8}
            ry={12.9}
            transform="matrix(.35 0 0 .3 447 -238.8)"
          />
          <ellipse
            cx={218.1}
            cy={356.8}
            strokeWidth={1.6}
            rx={10.8}
            ry={12.9}
            transform="matrix(.35 0 0 .3 448 -241.6)"
          />
          <ellipse
            cx={218.1}
            cy={356.8}
            strokeWidth={1.5}
            rx={10.8}
            ry={12.9}
            transform="matrix(.4 0 0 .3 432.8 -243.5)"
          />
          <ellipse
            cx={218.1}
            cy={356.8}
            strokeWidth={1.6}
            rx={10.8}
            ry={12.9}
            transform="matrix(.37 0 0 .27 446 -243.5)"
          />
          <ellipse
            cx={218.1}
            cy={356.8}
            strokeWidth={1.6}
            rx={10.8}
            ry={12.9}
            transform="matrix(.35 0 0 .3 444.2 -247)"
          />
          <ellipse
            cx={218.1}
            cy={356.8}
            strokeWidth={1.6}
            rx={10.8}
            ry={12.9}
            transform="matrix(.35 0 0 .3 436.1 -243.2)"
          />
          <ellipse
            cx={218.1}
            cy={356.8}
            strokeWidth={1.6}
            rx={10.8}
            ry={12.9}
            transform="matrix(.35 0 0 .3 437.4 -243.9)"
          />
          <ellipse
            cx={218.1}
            cy={356.8}
            strokeWidth={1.6}
            rx={10.8}
            ry={12.9}
            transform="matrix(.35 0 0 .3 439 -247)"
          />
        </g>
        <g
          fill="#009200"
          stroke="#000"
          transform="matrix(.18 0 0 .2 421 -216.8)"
        >
          <ellipse
            cx={528.7}
            cy={564.5}
            strokeWidth={2.5}
            rx={67.4}
            ry={205.6}
            transform="matrix(.98 -.3 .36 .87 -245.8 324.4)"
          />
          <ellipse
            cx={528.7}
            cy={646.1}
            strokeWidth={2.5}
            rx={13.3}
            ry={40.8}
            transform="rotate(-23.4 630.5 660.9)"
          />
          <path
            strokeWidth={1.5}
            d="M139.9 644c0 57.7-18.8 86.2-34.6 110.3 7.5-32.5 13-52.6 13-110.3 0-57.7 29.5-85.3 40.3-102-4.2 16.7-18.7 44.3-18.7 102z"
            transform="matrix(1.88 -.46 .95 1.18 -352.3 -10)"
          />
          <path
            strokeWidth={1.5}
            d="M139.9 644c0 57.7-18.8 86.2-34.6 110.3 7.5-32.5 13-52.6 13-110.3 0-57.7 29.5-85.3 40.3-102-4.2 16.7-18.7 44.3-18.7 102z"
            transform="matrix(1.88 -.46 .95 1.18 -348.4 44)"
          />
          <path
            strokeWidth={1.5}
            d="M139.9 644c0 57.7-18.8 86.2-34.6 110.3 7.5-32.5 13-52.6 13-110.3 0-57.7 29.5-85.3 40.3-102-4.2 16.7-18.7 44.3-18.7 102z"
            transform="matrix(1.87 -.5 .98 1.16 -362 105.8)"
          />
          <ellipse
            cx={528.7}
            cy={646.1}
            strokeWidth={1.4}
            rx={13.3}
            ry={40.8}
            transform="matrix(1.8 -.4 .7 1.64 -915.6 -221)"
          />
          <ellipse
            cx={528.7}
            cy={646.1}
            strokeWidth={1.6}
            rx={13.3}
            ry={40.8}
            transform="matrix(1.63 -.23 .54 1.35 -739.5 -91.8)"
          />
          <ellipse
            cx={528.7}
            cy={646.1}
            strokeWidth={1.6}
            rx={13.3}
            ry={40.8}
            transform="matrix(1.63 -.2 .5 1.36 -750.6 -91.8)"
          />
          <ellipse
            cx={528.7}
            cy={646.1}
            strokeWidth={2.1}
            rx={13.3}
            ry={40.8}
            transform="matrix(1.3 -.2 .47 1 -531 47.6)"
          />
          <ellipse
            cx={528.7}
            cy={646.1}
            strokeWidth={2.1}
            rx={13.3}
            ry={40.8}
            transform="matrix(1.33 -.13 .4 1.03 -517.9 12.2)"
          />
          <path
            strokeWidth={2.1}
            d="M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6"
            transform="matrix(1.03 -.5 .46 1.18 12.8 -14.5)"
          />
          <ellipse
            cx={528.7}
            cy={646.1}
            strokeWidth={2.1}
            rx={13.3}
            ry={40.8}
            transform="matrix(1.33 -.13 .4 1.03 -519.5 -34.4)"
          />
          <ellipse
            cx={528.7}
            cy={646.1}
            strokeWidth={2.1}
            rx={13.3}
            ry={40.8}
            transform="matrix(1.33 -.1 .38 1.04 -534 -40.1)"
          />
          <path
            strokeWidth={2.9}
            d="M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6"
            transform="matrix(.67 -.47 .46 .8 39.5 143.3)"
          />
          <path
            strokeWidth={2.9}
            d="M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6"
            transform="matrix(.67 -.47 .46 .8 51.1 125.8)"
          />
          <path
            strokeWidth={2.1}
            d="M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6"
            transform="matrix(.94 -.64 .64 1.1 -40.2 -10.7)"
          />
          <path
            strokeWidth={2.7}
            d="M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6"
            transform="matrix(.67 -.52 .46 .88 68.6 71.2)"
          />
        </g>
        <g fill="#804bff" stroke="#000" strokeWidth={2.5}>
          <path
            d="M276.3 345.4c-12.3 9.2.4 25.2 12 30.7 13 7.7 86.6 58.2 136.3 12-40.8.8-118.7-63.2-148.3-42.7z"
            transform="matrix(.16 0 0 .22 458 -214.3)"
          />
          <path
            d="M276.3 345.4c-12.3 9.2.4 25.2 12 30.7 13 7.7 86.6 58.2 136.3 12-40.8.8-118.7-63.2-148.3-42.7z"
            transform="matrix(.16 0 0 .22 456.6 -220.2)"
          />
          <path
            d="M276.3 345.4c-12.3 9.2.4 25.2 12 30.7 13 7.7 86.6 58.2 136.3 12-40.8.8-118.7-63.2-148.3-42.7z"
            transform="matrix(.16 0 0 .22 454.8 -225.8)"
          />
          <path
            d="M276.3 345.4c-12.3 9.2.4 25.2 12 30.7 13 7.7 86.6 58.2 136.3 12-40.8.8-118.7-63.2-148.3-42.7z"
            transform="matrix(.16 0 0 .22 450.9 -232.2)"
          />
        </g>
        <g transform="rotate(1 -589.6 681.6)">
          <path
            fill="#804bff"
            stroke="#000"
            strokeWidth={2.5}
            d="M211.2 247.3c21.7-12 56.6-9.8 79.7 11.2 19.4 17 45.3 75.2 70.3 92.8a57.7 57.7 0 0 1-42.2-15.2c-28.8 15.5-38.1 16.7-64 15.7-35.8-1.4-62.4-17.7-68-40.6-6.3-21.8 4.8-52.5 24.2-63.9z"
            transform="matrix(.2 -.04 .05 .18 407.8 -213.6)"
          />
          <ellipse
            cx={287.2}
            cy={323}
            fill="red"
            stroke="#000"
            strokeWidth={2.5}
            rx={14.2}
            ry={15}
            transform="matrix(.25 0 0 .13 401.8 -215.2)"
          />
          <ellipse
            cx={204.6}
            cy={348.3}
            fill="#ff0"
            stroke="#000"
            strokeWidth={2.5}
            rx={23.3}
            ry={15.9}
            transform="matrix(.2 -.08 .07 .17 398.7 -208)"
          />
          <ellipse
            cx={283.9}
            cy={333.9}
            rx={5.8}
            ry={5.8}
            transform="matrix(.2 0 0 .2 411.3 -233.7)"
          />
          <path
            fill="#ff0"
            stroke="#000"
            strokeWidth={6.6}
            d="M516.8 260.3c4.4 18-6.7 43-33.1 52.6-26.8 13.2-46.1 41.8-55.7 88-47.2-103.2-23-148.3 20.6-160.3 37.4-14.4 60.4-13.4 68.2 19.7z"
            transform="matrix(.1 0 0 .08 417.9 -191.5)"
          />
          <ellipse
            cx={199}
            cy={362.4}
            rx={4.7}
            ry={4.7}
            transform="matrix(.2 0 0 .2 418.7 -235)"
          />
        </g>
      </g>
    </g>
  </svg>
	),
	DO: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-222.6-115.2h958v718.4h-958z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="matrix(.67 0 0 .67 148.7 77)">
      <path fill="#00319c" fillRule="evenodd" d="M322 329h446.5v273.9H322z" />
      <path
        fill="#d62918"
        fillRule="evenodd"
        d="M-256.7 329.8h445.2v273h-445.2z"
      />
      <path
        fill="#00319c"
        fillRule="evenodd"
        d="M-255.8-115.2h445.2v305.4h-445.2z"
      />
      <path fill="#d62918" fillRule="evenodd" d="M324.6-112.7h443V193h-443z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M-256.4 190.1H769.5v141.7h-1026z"
      />
      <path fill="#fff" fillRule="evenodd" d="M187.4-113.7h138.3v717H187.4z" />
      <path fill="#cecece" d="M246.5 194.3l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M247.2 194.3l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M247.9 194.3l.7.6-.7-.6z" />
      <path fill="#848c9c" d="M252.8 194.3l.7.6-.7-.6z" />
      <path fill="#848ca5" d="M254 194.5l.4.2-.4-.2z" />
      <path fill="#848c9c" d="M254.9 194.3l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M259.8 194.3l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M260.5 194.3l.7.6-.7-.6z" />
      <path fill="#cecece" d="M261.2 194.3l.7.6-.7-.6z" />
      <path fill="#efefef" d="M241.5 195l.7.6-.7-.7z" />
      <path fill="#bdbdbd" d="M242.2 195l.7.6-.7-.7z" />
      <path fill="#8c8c8c" d="M243 195l.6.6-.7-.7z" />
      <path fill="#42425a" d="M243.7 195l.7.6-.8-.7z" />
      <path fill="#425a84" d="M244.3 195l.7.6-.7-.7z" />
      <path fill="#00184a" d="M245.5 195.2l.5.2-.5-.2z" />
      <path fill="#002984" d="M247 195.2l.4.2-.5-.2z" />
      <path
        fill="#003994"
        d="M235.7 201.5a59 59 0 0 0-26.7 4.9c-4.8 2.8-4.3 10.7 2.1 10.5v.6h-1.4v.7l10.6-2.7v-.6H216v-.7h5l-1.4-2.7 25.3-2.7-1.4-4.7a69 69 0 0 1 26 2v.7l-5.6-1.3c.6 2.9 4 2.2 6.3 1.3l-7 1.4v.6l16.2 1.5 16.8 3.9v.7l-9.1-1.4v.7l11.2 3.3-2-2v-.6l2.7 3.3c4.5.2 7.9 1.2 10.6 4.7l-9.8-4 5.6 12.7h.7v-2h.7v2l6.3-1.3c-1.6-6.8-4.5-14.8-11.2-18.1.6-2.6 0-3.7-2.2-5.4 2.6 5.2-1.7 7.3-5.6 3.4l-1.4 1.3 1.4-4.7-4.2 4 .7-4.6h-.7l-.7 4-2.1-2-.7 2-11.3-1.4v-6l1.4 2h.7v-2l3.5 2h.7l14.1.7.7 5.3h.7l2.1-4.6a74.3 74.3 0 0 0-26.7-4.7c.5-4.6-4.5-5.4-8.4-6-6.8-1-27.4-3.3-28.2 6z"
      />
      <path fill="#002984" d="M261 195.2l.5.2-.5-.2z" />
      <path fill="#00184a" d="M262.4 195.2l.5.2-.5-.2z" />
      <path fill="#314a7b" d="M263.4 195l.7.6-.8-.7z" />
      <path fill="#42425a" d="M264 195l.8.6-.8-.7z" />
      <path fill="#8c8c8c" d="M264.8 195l.6.6-.6-.7z" />
      <path fill="#ada5a5" d="M265.5 195l.7.6-.7-.7z" />
      <path fill="#dedede" d="M266.2 195l.7.6-.7-.7z" />
      <path fill="#ada5a5" d="M239.4 195.6l.7.7-.7-.7z" />
      <path fill="#63636b" d="M240.1 195.6l.7.7-.7-.7z" />
      <path fill="#21315a" d="M240.8 195.6l.7.7-.7-.7z" />
      <path fill="#00215a" d="M241.5 195.6l.7.7-.7-.7z" />
      <path fill="#002984" d="M242.2 195.6l.7.7-.7-.7m23.3 0l.6.7-.7-.7z" />
      <path fill="#00216b" d="M266.2 195.6l.7.7-.7-.7z" />
      <path fill="#10295a" d="M266.9 195.6l.7.7-.7-.7z" />
      <path fill="#636b7b" d="M267.6 195.6l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M268.3 195.6l.7.7-.7-.7z" />
      <path fill="#efefef" d="M237.3 196.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M238 196.3l.7.7-.7-.7z" />
      <path fill="#10214a" d="M238.7 196.3l.7.7-.7-.7z" />
      <path fill="#00216b" d="M239.4 196.3l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M246.5 196.3l.7.7-.7-.7z" />
      <path fill="#5a6b63" d="M247.2 196.3l.7.7-.7-.7z" />
      <path
        fill="#295284"
        d="M247.9 196.3l.7.7-.7-.7m1.4 0l.7.7-.7-.7zm4.2 0l.7.7-.7-.7z"
      />
      <path fill="#4a636b" d="M257.7 196.3l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M259.8 196.3l.7.7-.7-.7z" />
      <path fill="#5a6b63" d="M260.5 196.3l.7.7-.7-.7z" />
      <path fill="#002984" d="M268.3 196.3l.7.7-.7-.7z" />
      <path fill="#10295a" d="M269 196.3l.7.7-.7-.7z" />
      <path fill="#63636b" d="M269.7 196.3l.7.7-.7-.7z" />
      <path fill="#dedede" d="M270.4 196.3l.7.7-.7-.7z" />
      <path fill="#efefef" d="M236 197l-.8 1.3.7-1.3z" />
      <path fill="#8c8c8c" d="M236.6 197l.7.6-.7-.6z" />
      <path fill="#10295a" d="M237.3 197l.7.6-.7-.6z" />
      <path fill="#5a6b63" d="M241.5 197l.7.6-.7-.6z" />
      <path fill="#7b7b52" d="M242.2 197l.7.6-.7-.6z" />
      <path fill="#ad9431" d="M243 197l.6.6-.7-.6z" />
      <path fill="#9c8c42" d="M243.7 197l.7.6-.8-.6z" />
      <path fill="#395273" d="M244.3 197l.7.6-.7-.6z" />
      <path fill="#8c8442" d="M246.5 197l.7.6-.7-.6z" />
      <path fill="#9c8c42" d="M247.9 197l.7.6-.7-.6z" />
      <path fill="#395273" d="M249.3 197l.7.6-.7-.6zm4.2 0l.7.6-.7-.6z" />
      <path fill="#9c8c42" d="M260.5 197l.7.6-.7-.6z" />
      <path fill="#bd9c29" d="M263.8 197.2l.5.2-.5-.2z" />
      <path fill="#295284" d="M264.8 197l.6.6-.6-.6z" />
      <path fill="#00184a" d="M270.4 197l.7.6-.7-.6z" />
      <path fill="#63636b" d="M271 197l.8.6-.7-.6z" />
      <path fill="#dedede" d="M271.8 197l.7.6-.7-.6z" />
      <path fill="#31394a" d="M236 197.6l.6.7-.7-.7z" />
      <path fill="#deb518" d="M241.5 197.6l.7.7-.7-.7z" />
      <path fill="#efbd08" d="M244.3 197.6l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M246.5 197.6l.7.7-.7-.7z" />
      <path fill="#efbd08" d="M247.9 197.6l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M255.6 197.6l.7.7-.7-.7z" />
      <path fill="#003994" d="M256.3 197.6l.7.7-.7-.7z" />
      <path fill="#4a636b" d="M257 197.6l.7.7-.7-.7z" />
      <path fill="#395273" d="M258.4 197.6l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M262.6 197.6l.7.7-.7-.7z" />
      <path fill="#4a636b" d="M264.8 197.6l.6.7-.6-.7z" />
      <path fill="#10214a" d="M271.8 197.6l1.4 1.4-1.4-1.4z" />
      <path fill="#cecece" d="M272.5 197.6l.7.7-.7-.7z" />
      <path fill="#212139" d="M235.2 198.3l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M241.5 198.3l.7.7-.7-.7z" />
      <path fill="#cead21" d="M242.2 198.3l.7.7-.7-.7z" />
      <path fill="#003994" d="M243.2 198.7l.2.5-.2-.5z" />
      <path fill="#395273" d="M243.9 198.7l.2.5-.2-.5z" />
      <path fill="#6b735a" d="M245 198.3l.8.7-.7-.7z" />
      <path fill="#cead21" d="M247.2 198.3l.7.7-.7-.7z" />
      <path fill="#5a6b63" d="M248.6 198.3l.7.7-.7-.7z" />
      <path fill="#9c8c42" d="M255.6 198.3l.7.7-.7-.7z" />
      <path fill="#395273" d="M256.3 198.3l.7.7-.7-.7z" />
      <path fill="#9c8c42" d="M257 198.3l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M258.4 198.3l.7.7-.7-.7z" />
      <path fill="#295284" d="M259.1 198.3l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M262.6 198.3l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M264.8 198.3l.6.7-.6-.7z" />
      <path fill="#efefef" d="M273.2 198.3l.7.7-.7-.7z" />
      <path fill="#cecece" d="M234.5 199l.7.6-.7-.6z" />
      <path fill="#00216b" d="M235.2 199l.7.6-.7-.6z" />
      <path fill="#7b7b52" d="M241.5 199l.7.6-.7-.6z" />
      <path fill="#395273" d="M245 199l.8.6-.7-.6z" />
      <path fill="#295284" d="M245.8 199l.7.6-.7-.6z" />
      <path fill="#4a636b" d="M247.2 199l.7.6-.7-.6z" />
      <path fill="#deb518" d="M247.9 199l.7.6-.7-.6z" />
      <path fill="#ad9431" d="M248.6 199l.7.6-.7-.6m9.1 0l.7.6-.7-.6z" />
      <path fill="#395273" d="M259.4 199.4l.2.5-.2-.5z" />
      <path fill="#efbd08" d="M262.6 199l.7.6-.7-.6z" />
      <path fill="#ad9431" d="M263.4 199l.7.6-.8-.6z" />
      <path fill="#cead21" d="M264 199l.8.6-.8-.6z" />
      <path fill="#ad9431" d="M264.8 199l.6.6-.6-.6z" />
      <path fill="#002984" d="M272.5 199l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M273.2 199l.7.6-.7-.6m-38.7.6l.7.7-.7-.7z" />
      <path fill="#002984" d="M235.4 200l.3.5-.3-.4z" />
      <path fill="#6b735a" d="M241.5 199.6l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M243 199.6l.6.7-.7-.7z" />
      <path fill="#184a8c" d="M245 199.6l.8.7-.7-.7z" />
      <path fill="#5a6b63" d="M245.8 199.6l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M247.2 199.6l.7.7-.7-.7z" />
      <path fill="#cead21" d="M247.9 199.6l.7.7-.7-.7z" />
      <path fill="#9c8c42" d="M255.6 199.6l.7.7-.7-.7z" />
      <path fill="#4a636b" d="M256.3 199.6l.7.7-.7-.7z" />
      <path fill="#deb518" d="M257 199.6l.7.7-.7-.7z" />
      <path fill="#5a6b63" d="M262 199.6l.6.7-.7-.7z" />
      <path fill="#4a636b" d="M263.4 199.6l.7.7-.8-.7z" />
      <path fill="#bd9c29" d="M264.5 199.9l.5.2-.5-.2z" />
      <path fill="#bdbdbd" d="M234.5 200.3l.7.7-.7-.7z" />
      <path fill="#395273" d="M241.5 200.3l.7.7-.7-.7z" />
      <path fill="#cead21" d="M243 200.3l.6.7-.7-.7z" />
      <path fill="#8c8442" d="M243.7 200.3l.7.7-.8-.7z" />
      <path fill="#395273" d="M244.3 200.3l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M245.8 200.3l.7.7-.7-.7z" />
      <path fill="#5a6b63" d="M249.3 200.3l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M255.8 200.8l.3.4-.3-.5m1.2-.4l1.4 2-1.4-2z" />
      <path fill="#4a636b" d="M259.1 200.3l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M262 200.3l.6.7-.7-.7z" />
      <path fill="#deb518" d="M264 200.3l.8.7-.8-.7z" />
      <path fill="#ada5a5" d="M231.7 201l.7.6-.7-.6z" />
      <path fill="#42425a" d="M234.5 201l.7.6-.7-.6z" />
      <path fill="#00216b" d="M235.2 201l.7.6-.7-.6z" />
      <path fill="#7b7b52" d="M243 201l.6.6-.7-.6z" />
      <path fill="#bd9c29" d="M245.8 201l.7.6-.7-.6z" />
      <path fill="#cead21" d="M246.5 201l.7.6-.7-.6z" />
      <path fill="#395273" d="M247.2 201l.7.6-.7-.6z" />
      <path fill="#295284" d="M247.9 201l.7.6-.7-.6z" />
      <path fill="#deb518" d="M248.6 201l.7.6-.7-.6z" />
      <path fill="#bd9c29" d="M249.3 201l.7.6-.7-.6z" />
      <path fill="#7b7b52" d="M259.1 201l.7.6-.7-.6z" />
      <path fill="#ad9431" d="M262.6 201l.7.6-.7-.6z" />
      <path fill="#cead21" d="M264 201l.8.6-.8-.6z" />
      <path fill="#184a8c" d="M265.5 201l.7.6-.7-.6z" />
      <path fill="#002984" d="M272.5 201l.7.6-.7-.6z" />
      <path fill="#42425a" d="M273.2 201l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M276 201l.7.6-.7-.6z" />
      <path fill="#efefef" d="M278.8 201l.7.6-.7-.6z" />
      <path fill="#cecece" d="M223.3 201.6l.6.7-.7-.7z" />
      <path fill="#bdbdbd" d="M224 201.6l.6.7-.7-.7z" />
      <path fill="#8c8c8c" d="M225.1 201.9l.5.2-.5-.2z" />
      <path fill="#42425a" d="M226 201.6l.8.7-.7-.7z" />
      <path fill="#314a7b" d="M226.8 201.6l.7.7-.7-.7z" />
      <path fill="#00184a" d="M228 201.9l.4.2-.5-.2z" />
      <path fill="#00216b" d="M228.9 201.6l.7.7-.7-.7z" />
      <path fill="#9c8c42" d="M243 201.6l.6.7-.7-.7z" />
      <path fill="#ffce08" d="M245.8 201.6l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M246.5 201.6l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M248.6 201.6l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M249.3 201.6l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M250.7 201.6l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M251.4 201.6l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M252 201.6l.8.7-.7-.7z" />
      <path fill="#395273" d="M254.9 201.6l.7.7-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#5a6b63" d="M259.1 201.6l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M259.8 201.6l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M261.2 201.6l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M262.6 201.6l.7.7-.7-.7z" />
      <path fill="#395273" d="M264 201.6l.8.7-.8-.7m1.5 0l.7.7-.7-.7z" />
      <path fill="#00216b" d="M278.8 201.6l.7.7-.7-.7z" />
      <path fill="#00184a" d="M280 201.9l.5.2-.5-.2z" />
      <path fill="#314a7b" d="M281 201.6l.6.7-.7-.7z" />
      <path fill="#42425a" d="M281.6 201.6l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M282.3 201.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M283 201.6l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M283.8 201.6l.6.7-.6-.7z" />
      <path fill="#cecece" d="M284.4 201.6l.8.7-.8-.7m-65.4.7l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M219.7 202.3l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M220.4 202.3l.7.7-.7-.7z" />
      <path fill="#42425a" d="M221.1 202.3l.7.7-.7-.7z" />
      <path fill="#29396b" d="M221.8 202.3l.7.7-.7-.7z" />
      <path fill="#00184a" d="M222.5 202.3l.7.7-.7-.7z" />
      <path fill="#00216b" d="M223.3 202.3l.6.7-.7-.7z" />
      <path fill="#002984" d="M224 202.3l.6.7-.7-.7z" />
      <path fill="#00216b" d="M234.5 202.3l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M242.2 202.3l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M243 202.3l.6.7-.7-.7z" />
      <path fill="#184a8c" d="M264 202.3l.8.7-.8-.7z" />
      <path fill="#7b7b52" d="M264.8 202.3l.6.7-.6-.7z" />
      <path fill="#295284" d="M265.5 202.3l.7.7-.7-.7z" />
      <path fill="#00184a" d="M271.8 202.3l.7.7-.7-.7z" />
      <path fill="#002984" d="M284.2 202.5l.5.3-.5-.3z" />
      <path fill="#00184a" d="M285.1 202.3l.7.7-.7-.7z" />
      <path fill="#10295a" d="M285.9 202.3l.7.7-.7-.7z" />
      <path fill="#42425a" d="M286.6 202.3l.7.7-.7-.7z" />
      <path fill="#636b7b" d="M287.3 202.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M288 202.3l.7.7-.7-.7z" />
      <path fill="#cecece" d="M288.7 202.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M216.2 203l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M217 203l.6.6-.7-.6z" />
      <path fill="#525a6b" d="M217.6 203l.7.6-.7-.6z" />
      <path fill="#10295a" d="M218.3 203l.7.6-.7-.6z" />
      <path fill="#00216b" d="M219 203l.7.6-.7-.6z" />
      <path fill="#395273" d="M226.8 203l.7.6-.7-.6z" />
      <path fill="#00184a" d="M234.5 203l.7.6-.7-.6z" />
      <path fill="#00215a" d="M271.8 203l-.7 1.3.7-1.3z" />
      <path fill="#395273" d="M275.3 203l.7.6-.7-.6z" />
      <path fill="#184a8c" d="M276 203l.7.6-.7-.6z" />
      <path fill="#395273" d="M277.4 203l.7.6-.7-.6z" />
      <path fill="#00216b" d="M288.7 203l.7.6-.7-.6z" />
      <path fill="#00184a" d="M289.4 203l.7.6-.7-.6z" />
      <path fill="#42425a" d="M290 203l.8.6-.7-.6z" />
      <path fill="#8c8c8c" d="M290.8 203l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M291.5 203l.7.6-.7-.6z" />
      <path fill="#efefef" d="M292.2 203l.7.6-.7-.6z" />
      <path fill="#dedede" d="M213.4 203.7l.7.6-.7-.7z" />
      <path fill="#7b7373" d="M214.1 203.7l.7.6-.7-.7z" />
      <path fill="#314a7b" d="M214.8 203.7l.7.6-.7-.7z" />
      <path fill="#00184a" d="M215.5 203.7l.7.6-.7-.7z" />
      <path fill="#002984" d="M216.2 203.7l.7.6-.7-.7z" />
      <path fill="#184a8c" d="M221.1 203.7l.7.6-.7-.7z" />
      <path fill="#6b735a" d="M221.8 203.7l.7.6-.7-.7z" />
      <path fill="#395273" d="M222.5 203.7l.7.6-.7-.7z" />
      <path fill="#5a6b63" d="M225.4 203.7l.7.6-.7-.7z" />
      <path fill="#efbd08" d="M226 203.7l.8.6-.7-.7z" />
      <path fill="#ffce08" d="M227.2 203.9l.5.2-.5-.2z" />
      <path fill="#4a636b" d="M228.2 203.7l.7.6-.7-.7z" />
      <path fill="#00215a" d="M234.5 203.7l.7.6-.7-.7z" />
      <path fill="#002984" d="M246.2 203.9l.5.2-.5-.2z" />
      <path fill="#00215a" d="M247.2 203.7l.7.6-.7-.7z" />
      <path fill="#00184a" d="M247.9 203.7l.7.6-.7-.7z" />
      <path fill="#29396b" d="M248.6 203.7l.7.6-.7-.7z" />
      <path fill="#425a84" d="M249.3 203.7l.7.6-.7-.7z" />
      <path fill="#636b7b" d="M253.5 203.7l.7.6-.7-.7z" />
      <path fill="#737b94" d="M254.2 203.7l.7.6-.7-.7z" />
      <path fill="#29396b" d="M259.1 203.7l.7.6-.7-.7z" />
      <path fill="#00184a" d="M260.3 203.9l.5.2-.5-.2z" />
      <path fill="#002984" d="M261.7 203.9l.5.2-.5-.2z" />
      <path fill="#6b6b4a" d="M271.8 203.7l.7.6-.7-.7z" />
      <path fill="#7b7b52" d="M276 203.7l1.4 5.3-1.4-5.3z" />
      <path fill="#cead21" d="M279.5 203.7l.7.6-.7-.7z" />
      <path fill="#4a636b" d="M280.2 203.7l.7.6-.7-.7z" />
      <path fill="#8c8442" d="M281.6 203.7l.7.6-.7-.7z" />
      <path fill="#395273" d="M284.4 203.7l-.6 2.6.6-2.6z" />
      <path fill="#002984" d="M291.5 203.7l.7.6-.7-.7z" />
      <path fill="#00215a" d="M292.2 203.7l.7.6-.7-.7z" />
      <path fill="#314a7b" d="M292.9 203.7l.7.6-.7-.7z" />
      <path fill="#7b7373" d="M293.6 203.7l.7.6-.7-.7z" />
      <path fill="#cecece" d="M294.3 203.7l.7.6-.7-.7z" />
      <path fill="#efefef" d="M211.3 204.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M212 204.3l.7.7-.7-.7z" />
      <path fill="#31425a" d="M212.7 204.3l.7.7-.7-.7z" />
      <path fill="#00216b" d="M213.4 204.3l.7.7-.7-.7z" />
      <path fill="#5a6b63" d="M220.4 204.3l.7.7-.7-.7z" />
      <path fill="#cead21" d="M223.3 204.3l.6.7-.7-.7z" />
      <path fill="#deb518" d="M225.8 204.5l.5.3-.5-.3z" />
      <path fill="#7b7b52" d="M226.8 204.3l.7.7-.7-.7z" />
      <path fill="#deb518" d="M228 204.5l.4.3-.5-.3z" />
      <path fill="#00216b" d="M235.2 204.3l.7.7-.7-.7m8.5 0l.7.7-.8-.7z" />
      <path fill="#63636b" d="M244.3 204.3l.7.7-.7-.7z" />
      <path fill="#cecece" d="M261.2 204.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M262 204.3l.6.7-.7-.7z" />
      <path fill="#ada5a5" d="M262.6 204.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M263.4 204.3l.7.7-.8-.7z" />
      <path fill="#00184a" d="M264.3 204.8l.2.4-.2-.4z" />
      <path fill="#001039" d="M271 204.3l.8.7-.7-.7z" />
      <path fill="#deb518" d="M271.8 204.3l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M278.1 204.3l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M278.8 204.3l-.7 1.4.7-1.4z" />
      <path fill="#deb518" d="M279.5 204.3l.7.7-.7-.7z" />
      <path
        fill="#bd9c29"
        d="M281.6 204.3l1.4 1.4-1.4-1.4zm4.3 0l.7.7-.7-.7z"
      />
      <path fill="#ffce08" d="M286.6 204.3l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M287.3 204.3l.7.7-.7-.7z" />
      <path fill="#ad9431" d="M288 204.3l.7.7-.7-.7z" />
      <path fill="#4a636b" d="M288.7 204.3l.7.7-.7-.7z" />
      <path fill="#00216b" d="M294.3 204.3l.7.7-.7-.7z" />
      <path fill="#21315a" d="M295 204.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M295.7 204.3l.7.7-.7-.7z" />
      <path fill="#dedede" d="M296.4 204.3l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M209.9 205l.7.7-.7-.7z" />
      <path fill="#525a6b" d="M210.6 205l.7.7-.7-.7z" />
      <path fill="#00215a" d="M211.3 205l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M217.6 205l.7.7-.7-.7z" />
      <path fill="#deb518" d="M221.1 205l.7.7-.7-.7z" />
      <path fill="#4a636b" d="M221.8 205l.7.7-.7-.7z" />
      <path fill="#9c8c42" d="M222.5 205l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M224 205l.6.7-.7-.7z" />
      <path fill="#ffce08" d="M225.4 205l1.4 1.3-1.4-1.3z" />
      <path fill="#8c8442" d="M226 205l.8.7-.7-.7z" />
      <path fill="#003994" d="M226.8 205l.7.7-.7-.7z" />
      <path fill="#295284" d="M227.5 205l.7.7-.7-.7z" />
      <path fill="#5a6b63" d="M228.2 205l.7.7-.7-.7z" />
      <path fill="#001039" d="M235.2 205l.7.7-.7-.7z" />
      <path fill="#00216b" d="M241.5 205l.7.7-.7-.7z" />
      <path fill="#00184a" d="M242.2 205l.7.7-.7-.7z" />
      <path fill="#00216b" d="M243 205l.6.7-.7-.7z" />
      <path fill="#8c8c8c" d="M244.3 205l.7.7-.7-.7z" />
      <path fill="#dedede" d="M262.6 205l.7.7-.7-.7z" />
      <path fill="#63636b" d="M263.6 205.4l.2.5-.2-.5z" />
      <path fill="#002984" d="M265 205.4l.2.5-.2-.5z" />
      <path fill="#313931" d="M271 205l.8.7-.7-.7z" />
      <path fill="#295284" d="M276.7 205l.7.7-.7-.7z" />
      <path fill="#003994" d="M278.8 205l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M279.5 205l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M281 205l.6.7-.7-.7z" />
      <path fill="#efbd08" d="M281.6 205l.7.7-.7-.7z" />
      <path fill="#003994" d="M283 205l.7.7-.7-.7m2.4.4l.2.5-.2-.5z" />
      <path fill="#cead21" d="M285.9 205l.7.7-.7-.7z" />
      <path fill="#efbd08" d="M286.6 205l.7.7-.7-.7z" />
      <path fill="#cead21" d="M287.3 205l.7.7-.7-.7z" />
      <path fill="#295284" d="M289.4 205l.7.7-.7-.7z" />
      <path fill="#ffce08" d="M290 205l.8.7-.7-.7z" />
      <path fill="#cead21" d="M290.8 205l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M291.5 205l.7.7-.7-.7z" />
      <path fill="#5a6b63" d="M292.2 205l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M292.9 205l.7.7-.7-.7z" />
      <path fill="#00216b" d="M296.4 205l.7.7-.7-.7z" />
      <path fill="#31394a" d="M297.1 205l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M297.8 205l.7.7-.7-.7z" />
      <path fill="#efefef" d="M298.5 205l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M208.5 205.7l.7.6-.7-.6z" />
      <path fill="#212139" d="M209.2 205.7l.7.6-.7-.6z" />
      <path fill="#002984" d="M209.9 205.7l.7.6-.7-.6z" />
      <path fill="#5a6b63" d="M212.7 205.7l.7.6-.7-.6z" />
      <path fill="#9c8c42" d="M213.4 205.7l.7.6-.7-.6z" />
      <path fill="#deb518" d="M214.1 205.7l.7.6-.7-.6z" />
      <path fill="#bd9c29" d="M215.5 205.7l.7.6-.7-.6z" />
      <path fill="#7b7b52" d="M217.6 205.7l.7.6-.7-.6z" />
      <path fill="#184a8c" d="M219 205.7l.7.6-.7-.6z" />
      <path fill="#395273" d="M219.7 205.7l.7 2-.7-2z" />
      <path fill="#7b7b52" d="M221.1 205.7l.7.6-.7-.6z" />
      <path fill="#003994" d="M221.8 205.7v2.6h1.4v-2.6h-1.4z" />
      <path fill="#efbd08" d="M223.3 205.7l.6.6-.7-.6z" />
      <path fill="#deb518" d="M224 205.7l.6.6-.7-.6z" />
      <path fill="#bd9c29" d="M225.4 205.7l.7.6-.7-.6z" />
      <path fill="#efbd08" d="M226.8 205.7l.7.6-.7-.6z" />
      <path fill="#bd9c29" d="M227.5 205.7l-.7 1.3.7-1.3z" />
      <path fill="#7b7b52" d="M228.2 205.7l.7.6-.7-.6z" />
      <path fill="#00215a" d="M235.2 205.7l.7.6-.7-.6z" />
      <path fill="#002984" d="M238 205.7l.7.6-.7-.6z" />
      <path fill="#00184a" d="M239.7 206.6v1.6h3.3l-3.3-1.6z" />
      <path fill="#00215a" d="M240.8 205.7l.7.6-.7-.6z" />
      <path fill="#002984" d="M241.5 205.7l.7.6-.7-.6z" />
      <path fill="#31394a" d="M244.3 205.7l.7.6-.7-.6z" />
      <path fill="#00216b" d="M267.6 205.7l1.4 1.3-1.4-1.3z" />
      <path fill="#002984" d="M268.3 205.7l.7.6-.7-.6z" />
      <path fill="#00184a" d="M270.6 206.1l.2.5-.2-.5z" />
      <path fill="#8c8442" d="M271 205.7l.8.6-.7-.6z" />
      <path fill="#9c8c42" d="M280.2 205.7l.7.6-.7-.6z" />
      <path fill="#003994" d="M281.2 206.1l.2.5-.2-.5z" />
      <path fill="#deb518" d="M282.3 205.7l.7.6-.7-.6z" />
      <path fill="#6b735a" d="M283 205.7l.7.6-.7-.6z" />
      <path fill="#295284" d="M284.4 205.7l.8.6-.8-.6z" />
      <path fill="#ad9431" d="M286.6 205.7l.7.6-.7-.6z" />
      <path fill="#003994" d="M287.3 205.7l.7.6-.7-.6z" />
      <path fill="#295284" d="M288 205.7l.7.6-.7-.6z" />
      <path fill="#8c8442" d="M289.4 205.7l.7.6-.7-.6z" />
      <path fill="#9c8c42" d="M290 205.7l.8.6-.7-.6z" />
      <path fill="#deb518" d="M290.8 205.7l.7.6-.7-.6z" />
      <path fill="#ffce08" d="M291.5 207l2.1-.7-2.1.7z" />
      <path fill="#6b735a" d="M293.6 205.7l.7.6-.7-.6z" />
      <path fill="#295284" d="M295 205.7l-.7 1.3.7-1.3z" />
      <path fill="#10214a" d="M298.5 205.7l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M299.2 205.7l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M207 206.3l.8.7-.7-.7z" />
      <path fill="#42425a" d="M207.8 206.3l.7.7-.7-.7z" />
      <path fill="#002984" d="M208.5 206.3l.7.7-.7-.7z" />
      <path fill="#ad9431" d="M212.7 206.3l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M214.6 206.6l.4.2-.4-.3m1.6-.2l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M217.6 206.3l.7.7-.7-.7z" />
      <path fill="#395273" d="M221.1 206.3l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M225.6 206.8l.2.4-.2-.4z" />
      <path fill="#9c8c42" d="M226 206.3l.8.7-.7-.7z" />
      <path fill="#ffce08" d="M228 206.6l.4.2-.5-.3z" />
      <path fill="#8c8442" d="M228.9 206.3l.7.7-.7-.7z" />
      <path fill="#00184a" d="M236.1 206.8l.3.4-.3-.4z" />
      <path fill="#002984" d="M236.6 206.3l.7.7-.7-.7z" />
      <path fill="#001039" d="M237.3 206.3l.7.7-.7-.7z" />
      <path fill="#00216b" d="M238 206.3l.7.7-.7-.7z" />
      <path fill="#00215a" d="M244.3 206.3l.7.7-.7-.7z" />
      <path fill="#efefef" d="M245 206.3l.8.7-.7-.7z" />
      <path fill="#21315a" d="M263.4 206.3l.7.7-.8-.7z" />
      <path fill="#00184a" d="M269 206.3l.7.7-.7-.7z" />
      <path fill="#9c8c42" d="M278.1 206.3l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M278.8 206.3l.7.7-.7-.7z" />
      <path fill="#efbd08" d="M279.5 206.3l.7.7-.7-.7z" />
      <path fill="#deb518" d="M280.2 206.3l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M284.4 206.3l.8.7-.8-.7z" />
      <path fill="#184a8c" d="M285.1 206.3l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M286.6 206.3l.7.7-.7-.7z" />
      <path fill="#4a636b" d="M287.3 206.3l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M288 206.3l.7.7-.7-.7z" />
      <path fill="#4a636b" d="M289.4 206.3l.7.7-.7-.7z" />
      <path fill="#5a6b63" d="M290.8 206.3l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M292.2 206.3l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M292.9 206.3l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M293.6 206.3l.7.7-.7-.7z" />
      <path fill="#efbd08" d="M295.7 206.3l.7.7-.7-.7z" />
      <path fill="#002984" d="M299.2 206.3l.7.7-.7-.7z" />
      <path fill="#212139" d="M300 206.3l.6.7-.7-.7z" />
      <path fill="#ada5a5" d="M300.6 206.3l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M206.4 207l-.7 1.3.7-1.3z" />
      <path fill="#00215a" d="M207 207l.8.7-.7-.7z" />
      <path fill="#6b735a" d="M212.7 207l.7.7-.7-.7z" />
      <path fill="#295284" d="M214.1 207l.7.7-.7-.7z" />
      <path fill="#003994" d="M214.8 207v2.7h.7l-.7-2.7z" />
      <path fill="#9c8c42" d="M215.5 207l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M217 207l1.3 1.3-1.4-1.3z" />
      <path fill="#395273" d="M217.6 207l.7.7-.7-.7zm8.5 0l.7.7-.7-.7z" />
      <path fill="#003994" d="M227.2 207.2l.5.2-.5-.2z" />
      <path fill="#deb518" d="M228.2 207l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M228.9 207l.7.7-.7-.7z" />
      <path fill="#001039" d="M236.8 207.4l.3.5-.3-.5z" />
      <path fill="#002984" d="M244.3 207l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M245 207l.8.7-.7-.7z" />
      <path fill="#cecece" d="M262.6 207l.7.7-.7-.7z" />
      <path fill="#00216b" d="M263.4 207l.7.7-.8-.7z" />
      <path fill="#000818" d="M269.7 207l.7.7-.7-.7z" />
      <path fill="#395273" d="M278.1 207l.7.7-.7-.7z" />
      <path fill="#003994" d="M278.8 207l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M279.5 207l-.7 1.3.7-1.3z" />
      <path fill="#ffce08" d="M280.2 207l.7.7-.7-.7z" />
      <path fill="#9c8c42" d="M282.3 207l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M283.8 207l.6.7-.6-.7z" />
      <path fill="#395273" d="M285 207.2l.4.2-.5-.2z" />
      <path fill="#9c8c42" d="M290.8 207l.7.7-.7-.7z" />
      <path fill="#efbd08" d="M291.5 207l.7.7-.7-.7z" />
      <path fill="#cead21" d="M294.3 207l.7.7-.7-.7z" />
      <path fill="#395273" d="M298.5 207l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M299.2 207l.7.7-.7-.7z" />
      <path fill="#00216b" d="M300.6 207l.7.7-.7-.7z" />
      <path fill="#63636b" d="M301.3 207l1.4 1.3-1.4-1.3z" />
      <path fill="#00216b" d="M206.4 207.7l.7.6-.7-.6z" />
      <path fill="#295284" d="M212.7 207.7l.7.6-.7-.6z" />
      <path fill="#184a8c" d="M215.5 207.7l.7.6-.7-.6z" />
      <path fill="#5a6b63" d="M217 207.7l.6.6-.7-.6z" />
      <path fill="#7b7b52" d="M219 207.7l.7.6-.7-.6z" />
      <path fill="#cead21" d="M221.1 207.7l.7.6-.7-.6m2.1 0l.8.6-.8-.6z" />
      <path fill="#7b7b52" d="M225.4 207.7l.7.6-.7-.6z" />
      <path fill="#6b735a" d="M226.8 207.7l.7.6-.7-.6z" />
      <path fill="#efbd08" d="M228.4 208.1l.2.5-.2-.5z" />
      <path fill="#ad9431" d="M228.9 207.7l.7.6-.7-.6z" />
      <path fill="#00216b" d="M237.3 207.7l.7.6-.7-.6z" />
      <path fill="#002984" d="M237.3 209l2.1-1.3-2 1.3z" />
      <path fill="#00216b" d="M239.4 207.7l.7.6-.7-.6z" />
      <path fill="#525a6b" d="M245 207.7l.8.6-.7-.6z" />
      <path fill="#63636b" d="M262.6 207.7l.7.6-.7-.6z" />
      <path fill="#00216b" d="M266.9 207.7l.7.6-.7-.6z" />
      <path fill="#002984" d="M266.9 209l2-1.3-2 1.3z" />
      <path fill="#00184a" d="M269 207.7l.7.6-.7-.6z" />
      <path fill="#00216b" d="M269.7 207.7l.7.6-.7-.6z" />
      <path fill="#5a6b63" d="M276.7 207.7l.7.6-.7-.6z" />
      <path fill="#9c8c42" d="M278.1 207.7l.7.6-.7-.6z" />
      <path fill="#efbd08" d="M279.5 207.7l.7.6-.7-.6z" />
      <path fill="#deb518" d="M280.2 207.7l.7.6-.7-.6z" />
      <path
        fill="#6b735a"
        d="M282.3 207.7l.7.6-.7-.6zm2.8 0l.7.6-.7-.6m1.4 0l.8.6-.7-.6z"
      />
      <path fill="#5a6b63" d="M287.3 207.7l.7.6-.7-.6z" />
      <path fill="#efbd08" d="M288 207.7l.7.6-.7-.6z" />
      <path fill="#cead21" d="M290.8 207.7l.7.6-.7-.6z" />
      <path fill="#bd9c29" d="M291.5 207.7l.7.6-.7-.6z" />
      <path fill="#6b735a" d="M293.6 207.7l.7.6-.7-.6z" />
      <path fill="#9c8c42" d="M300 207.7l.6.6-.7-.6z" />
      <path fill="#002984" d="M301.3 207.7l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M205 208.3l.7.7-.7-.7z" />
      <path fill="#00216b" d="M205.7 208.3l.7.7-.7-.7z" />
      <path fill="#efbd08" d="M213.4 208.3l.7.7-.7-.7z" />
      <path fill="#9c8c42" d="M214.1 208.3l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M217.2 208.8l.2.4-.3-.4z" />
      <path fill="#ad9431" d="M219 208.3l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M220.4 208.3l.7.7-.7-.7z" />
      <path fill="#ad9431" d="M222.3 208.6l.5.2-.5-.2m1.6-.3l.7.7-.7-.7z" />
      <path fill="#efbd08" d="M226 208.3l.8.7-.7-.7z" />
      <path fill="#4a636b" d="M228.9 208.3l.7.7-.7-.7z" />
      <path fill="#00184a" d="M243.7 208.3l.7.7-.8-.7z" />
      <path fill="#636b7b" d="M245 208.3l.8.7-.7-.7z" />
      <path fill="#8c8c8c" d="M262 208.3l.6.7-.7-.7z" />
      <path fill="#424242" d="M262.6 208.3l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M271 208.3l.8.7-.7-.7z" />
      <path fill="#5a6b63" d="M280.2 208.3l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M284.4 208.3l.8.7-.8-.7z" />
      <path fill="#7b7b52" d="M285.1 208.3l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M286.6 208.3l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M291.5 208.3l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M292.9 208.3l.7.7-.7-.7z" />
      <path fill="#efbd08" d="M293.6 208.3l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M294.3 208.3l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M295 208.3l-.7 1.4.7-1.4z" />
      <path fill="#5a6b63" d="M297.8 208.3l.7.7-.7-.7z" />
      <path fill="#ffce08" d="M298.5 208.3l.7.7-.7-.7z" />
      <path fill="#efbd08" d="M300.6 208.3l.7.7-.7-.7z" />
      <path fill="#002984" d="M302 208.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M302.7 208.3l.7.7-.7-.7z" />
      <path fill="#525a6b" d="M205 209l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M213.4 209l.7.7-.7-.7z" />
      <path fill="#deb518" d="M214.1 209l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M215.5 209l.7.7-.7-.7z" />
      <path fill="#cead21" d="M218.3 209l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M219 209l-.7 1.3.7-1.3z" />
      <path fill="#ad9431" d="M221.1 209l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M223.3 209l.6.7-.7-.7z" />
      <path fill="#4a636b" d="M226.8 209l.7.7-.7-.7z" />
      <path fill="#5a6b63" d="M227.5 209l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M228.2 209l.7.7-.7-.7z" />
      <path fill="#292921" d="M244.3 209l.7.7-.7-.7z" />
      <path fill="#cecece" d="M245 209l.8.7-.7-.7m16.8 0l.7.7-.7-.7z" />
      <path fill="#efefef" d="M262.6 209l1.4 1.3-1.4-1.3z" />
      <path fill="#31394a" d="M263.4 209l.7.7-.8-.7z" />
      <path fill="#7b7b52" d="M281.6 209l.7.7-.7-.7z" />
      <path fill="#9c8c42" d="M282.3 209l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M284.4 209l.8.7-.8-.7z" />
      <path fill="#ad9431" d="M285.1 209l.7.7-.7-.7z" />
      <path fill="#deb518" d="M288 209l.7.7-.7-.7z" />
      <path fill="#395273" d="M290 209l.8.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M292.9 209l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M295 209l.7.7-.7-.7z" />
      <path fill="#cead21" d="M295.7 209l.7.7-.7-.7z" />
      <path fill="#003994" d="M299.2 209l-.7 2.7h.7V209z" />
      <path fill="#7b7b52" d="M300 209l.6.7-.7-.7z" />
      <path fill="#5a6b63" d="M301.3 209l.7.7-.7-.7z" />
      <path fill="#425a84" d="M303 209.4l.2.5-.2-.5z" />
      <path fill="#42425a" d="M205 209.7l.7.6-.7-.6z" />
      <path fill="#7b7b52" d="M213.4 209.7l.7.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#deb518" d="M215.5 209.7l.7.6-.7-.6z" />
      <path fill="#5a6b63" d="M217 209.7l.6.6-.7-.6z" />
      <path fill="#ffce08" d="M219 209.7l.7.6-.7-.6z" />
      <path fill="#00216b" d="M242.2 209.7l.7.6-.7-.6z" />
      <path fill="#21315a" d="M243 209.7l.6.6-.7-.6z" />
      <path fill="#63636b" d="M243.7 209.7l.7.6-.8-.6z" />
      <path fill="#efefef" d="M244.3 209.7l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M264 209.7l.8.6-.8-.6z" />
      <path fill="#21315a" d="M264.8 209.7l.6.6-.6-.6z" />
      <path fill="#00216b" d="M265.5 209.7l.7.6-.7-.6z" />
      <path fill="#395273" d="M285.9 209.7l.7.6-.7-.6z" />
      <path fill="#8c8442" d="M288 209.7l.7.6-.7-.6z" />
      <path fill="#6b735a" d="M288.7 209.7l.7.6-.7-.6z" />
      <path fill="#7b7b52" d="M290 209.7l.8.6-.7-.6z" />
      <path fill="#6b735a" d="M292.2 209.7l.7.6-.7-.6z" />
      <path fill="#bd9c29" d="M295.7 209.7l-.7 2 .7-2z" />
      <path fill="#5a6b63" d="M297.1 209.7l.7.6-.7-.6z" />
      <path fill="#ffce08" d="M297.8 209.7l.7.6-.7-.6z" />
      <path fill="#5a6b63" d="M298.5 209.7l.7.6-.7-.6z" />
      <path fill="#395273" d="M300 209.7l.6.6-.7-.6z" />
      <path fill="#6b735a" d="M301.3 209.7l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M205 210.3l.7.7-.7-.7z" />
      <path fill="#395273" d="M213.4 210.3l.7.7-.7-.7z" />
      <path fill="#9c8c42" d="M216.2 210.3l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M218.3 210.3l.7.7-.7-.7z" />
      <path fill="#002984" d="M226.8 210.3l.7.7-.7-.7z" />
      <path fill="#00216b" d="M227.5 210.3l.7.7-.7-.7z" />
      <path fill="#00184a" d="M228.2 210.3l.7.7-.7-.7z" />
      <path fill="#10295a" d="M228.9 210.3l.7.7-.7-.7z" />
      <path fill="#525a6b" d="M238 210.3l.7.7-.7-.7z" />
      <path fill="#848c9c" d="M238.7 210.3l.7.7-.7-.7z" />
      <path fill="#cecece" d="M242.2 210.3l.7.7-.7-.7z" />
      <path fill="#dedede" d="M265.5 210.3l.7.7-.7-.7z" />
      <path fill="#848c9c" d="M269 210.3l.7.7-.7-.7z" />
      <path fill="#636b7b" d="M269.7 210.3l.7.7-.7-.7z" />
      <path fill="#10295a" d="M278.8 210.3l.7.7-.7-.7z" />
      <path fill="#00184a" d="M279.5 210.3l.7.7-.7-.7z" />
      <path fill="#00216b" d="M280.2 210.3l.7.7-.7-.7z" />
      <path fill="#002984" d="M281 210.3l.6.7-.7-.7z" />
      <path fill="#4a636b" d="M290 210.3l.8.7-.7-.7z" />
      <path fill="#6b735a" d="M290.8 210.3l.7.7-.7-.7z" />
      <path fill="#efbd08" d="M292.2 210.3l.7.7-.7-.7z" />
      <path fill="#cead21" d="M292.9 210.3l.7.7-.7-.7z" />
      <path fill="#4a636b" d="M294.3 210.3l.7.7-.7-.7z" />
      <path fill="#deb518" d="M295 210.3l.7.7-.7-.7m2.6.3l.4.2-.4-.2z" />
      <path fill="#8c8442" d="M300 210.3l.6.7-.7-.7z" />
      <path fill="#184a8c" d="M301.3 210.3l.7.7-.7-.7z" />
      <path fill="#525a6b" d="M302.7 210.3l.7.7-.7-.7z" />
      <path fill="#cecece" d="M205 211l.7.7-.7-.7z" />
      <path fill="#00216b" d="M205.7 211l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M214.1 211l.7.7-.7-.7z" />
      <path fill="#4a636b" d="M214.8 211l.7.7-.7-.7z" />
      <path fill="#002984" d="M219.7 212.3l2.1-.6-2 .7z" />
      <path fill="#00215a" d="M221.8 211l.7.7-.7-.7z" />
      <path fill="#00184a" d="M222.5 211l.7.7-.7-.7z" />
      <path fill="#314a7b" d="M223.3 211l.6.7-.7-.7z" />
      <path fill="#42425a" d="M224 211l.6.7-.7-.7z" />
      <path fill="#636b7b" d="M224.7 211l.7.7-.8-.7z" />
      <path fill="#8c8c8c" d="M225.4 211l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M226 211l.8.7-.7-.7z" />
      <path fill="#bdbdbd" d="M226.8 211l.7.7-.7-.7z" />
      <path fill="#cecece" d="M227.5 211l.7.7-.7-.7z" />
      <path fill="#dedede" d="M280.2 211l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M281 211l.6.7-.7-.7z" />
      <path fill="#9c9494" d="M281.6 211l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M282.3 211l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M283 211l.7.7-.7-.7z" />
      <path fill="#42425a" d="M283.8 211l.6.7-.6-.7z" />
      <path fill="#314a7b" d="M284.4 211l.8.7-.8-.7z" />
      <path fill="#00184a" d="M285.1 211l.7.7-.7-.7z" />
      <path fill="#00215a" d="M285.9 211l.7.7-.7-.7z" />
      <path fill="#002984" d="M287 211.2l.5.3-.5-.3z" />
      <path fill="#184a8c" d="M292.9 211l.7.7-.7-.7z" />
      <path fill="#5a6b63" d="M296.4 211l.7.7-.7-.7zm1.4 0l.7.7-.7-.7z" />
      <path fill="#295284" d="M299.2 211l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M300.6 211l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M302.7 211l.7.7-.7-.7z" />
      <path fill="#dedede" d="M205 211.7l.7.7-.7-.7z" />
      <path fill="#001039" d="M205.7 211.7l.7.7-.7-.7z" />
      <path fill="#63636b" d="M220.4 211.7l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M221.1 211.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M221.8 211.7l-.7 1.3.7-1.3z" />
      <path fill="#bdbdbd" d="M286.6 211.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M287.3 211.7l.7.7-.7-.7z" />
      <path fill="#00216b" d="M288 211.7l.7.7-.7-.7z" />
      <path fill="#395273" d="M295 211.7l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M295.7 211.7l.7.7-.7-.7z" />
      <path fill="#deb518" d="M296.4 211.7l.7.7-.7-.7z" />
      <path fill="#bd9c29" d="M297.8 211.7l.7.7-.7-.7z" />
      <path fill="#7b7b52" d="M298.5 211.7l.7.7-.7-.7z" />
      <path fill="#00215a" d="M302 211.7l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M302.7 211.7l.7.7-.7-.7z" />
      <path fill="#dedede" d="M203.6 212.3l.7.7-.8-.7z" />
      <path fill="#63636b" d="M204.3 212.3l.6.7-.7-.7z" />
      <path fill="#001039" d="M205.2 212.8l.2.5-.2-.5z" />
      <path fill="#00216b" d="M217.6 212.3l-.7 1.4.7-1.3z" />
      <path fill="#00184a" d="M218.3 212.3l.7.7-.7-.7z" />
      <path fill="#00216b" d="M219 212.3l.7.7-.7-.7z" />
      <path fill="#10214a" d="M220.4 212.3l.7.7-.7-.7z" />
      <path fill="#dedede" d="M286.6 212.3l.7.7-.7-.7z" />
      <path fill="#212139" d="M287.3 212.3l.7.7-.7-.7z" />
      <path fill="#00184a" d="M288 212.3l.7.7-.7-.7z" />
      <path fill="#002984" d="M289 212.8l.1.5-.2-.5z" />
      <path fill="#184a8c" d="M296.4 212.3l.7.7-.7-.7z" />
      <path fill="#9c8c42" d="M297.1 212.3l.7.7-.7-.7z" />
      <path fill="#295284" d="M300 212.3l.6.7-.7-.7z" />
      <path fill="#00216b" d="M302.7 212.3l.7.7-.7-.7z" />
      <path fill="#42425a" d="M303.4 212.3l.8.7-.8-.7z" />
      <path fill="#bdbdbd" d="M304.1 212.3l.7.7-.7-.7z" />
      <path fill="#cecece" d="M202.8 213l-1.4 2 1.4-2z" />
      <path fill="#10214a" d="M203.6 213l-1.4 2 1.4-2z" />
      <path
        fill="#003994"
        d="M204.3 213c-2 2.1-5 4.5-3.6 7.4-3.7 2-4.4 6.4-5.6 10l7.7 1.4 5.7-12.7-7.8.6v-.6l7-.7-3.5-5.4z"
      />
      <path fill="#002984" d="M214.1 213l.7.7-.7-.7z" />
      <path fill="#00215a" d="M214.8 213l.7.7-.7-.7z" />
      <path fill="#00184a" d="M216 213.2l.4.3-.4-.3z" />
      <path fill="#002984" d="M217.6 213l.7.7-.7-.7z" />
      <path fill="#63636b" d="M221.1 213l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M286.6 213l.7.7-.7-.7z" />
      <path fill="#002984" d="M287.3 213l.7.7-.7-.7z" />
      <path fill="#00216b" d="M291.5 213l.7.7-.7-.7z" />
      <path fill="#184a8c" d="M297.8 213l.7.7-.7-.7z" />
      <path fill="#395273" d="M298.5 213l.7.7-.7-.7z" />
      <path fill="#00215a" d="M304.1 213l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M304.9 213l2 2-2-2z" />
      <path fill="#00216b" d="M205 213.7l.7.7-.7-.7z" />
      <path fill="#002984" d="M205.7 213.7l.7.7-.7-.7z" />
      <path fill="#00216b" d="M212 213.7l.7.7-.7-.7z" />
      <path fill="#00184a" d="M213.2 214l.4.1-.4-.2z" />
      <path fill="#00216b" d="M214.1 213.7l.7.7-.7-.7z" />
      <path fill="#42425a" d="M221.1 213.7l.7.7-.7-.7z" />
      <path fill="#636b7b" d="M286.6 213.7l.7.7-.7-.7z" />
      <path fill="#002984" d="M291.5 213.7l.7.7-.7-.7z" />
      <path fill="#00215a" d="M292.2 213.7l.7.7-.7-.7z" />
      <path fill="#00184a" d="M293.4 214l.4.1-.4-.2z" />
      <path fill="#00216b" d="M294.5 214.1l.3.5-.3-.5m10.3-.4l.7.7-.7-.7z" />
      <path fill="#001039" d="M205.7 214.4l.7.6-.7-.6z" />
      <path fill="#00216b" d="M210.1 214.8l.2.5-.2-.5z" />
      <path fill="#00184a" d="M211 214.6l.5.2-.4-.2z" />
      <path fill="#00215a" d="M216.2 214.4l.7.6-.7-.6z" />
      <path fill="#002984" d="M220.4 214.4l.7.6-.7-.6z" />
      <path fill="#21315a" d="M221.1 214.4l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M285.9 214.4l.7.6-.7-.6z" />
      <path fill="#101810" d="M286.6 214.4l.7.6-.7-.6z" />
      <path fill="#00184a" d="M287.7 214.6l.5.2-.5-.2z" />
      <path fill="#00215a" d="M288.7 214.4l.7.6-.7-.6z" />
      <path fill="#00184a" d="M289.4 214.4l.7.6-.7-.6z" />
      <path fill="#00216b" d="M290 214.4l.8.6-.7-.6z" />
      <path fill="#00184a" d="M295.5 214.6l.4.2-.4-.2z" />
      <path fill="#00216b" d="M305.6 214.4l.7.6-.7-.6z" />
      <path fill="#efefef" d="M200.7 215l.7.7-.7-.7z" />
      <path fill="#212139" d="M201.4 215l.7.7-.7-.7z" />
      <path fill="#00216b" d="M205.7 215l.7.7-.7-.7z" />
      <path fill="#002984" d="M206.4 215l.7.7-.7-.7z" />
      <path fill="#00184a" d="M209 215.3l.4.2-.5-.3z" />
      <path fill="#00216b" d="M214.1 215l.7.7-.7-.7z" />
      <path fill="#00184a" d="M214.8 215l.7.7-.7-.7z" />
      <path fill="#00216b" d="M215.5 215l.7.7-.7-.7z" />
      <path fill="#001039" d="M220.4 215l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M221.1 215l-.7 1.4.7-1.4z" />
      <path fill="#7b7373" d="M285.9 215l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M286.6 215l.7.7-.7-.7z" />
      <path fill="#00215a" d="M287.3 215l.7.7-.7-.7z" />
      <path fill="#002984" d="M290 215l.8.7-.7-.7z" />
      <path fill="#00184a" d="M291.3 215.3l.4.2-.4-.3z" />
      <path fill="#002984" d="M292.2 215l.7.7-.7-.7z" />
      <path fill="#00216b" d="M296.4 215l.7.7-.7-.7z" />
      <path fill="#00184a" d="M297.1 215l.7.7-.7-.7z" />
      <path fill="#002984" d="M297.8 215l.7.7-.7-.7z" />
      <path fill="#00184a" d="M306.3 215l.7.7-.7-.7z" />
      <path fill="#cecece" d="M307 215l.7.7-.7-.7z" />
      <path fill="#52525a" d="M200.7 215.7l.7.7-.7-.7z" />
      <path fill="#002984" d="M208.5 215.7l.7.7-.7-.7z" />
      <path fill="#00184a" d="M213.2 216l.4.1-.4-.2z" />
      <path fill="#002984" d="M214.1 215.7l.7.7-.7-.7z" />
      <path fill="#10214a" d="M219.7 215.7l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M287.3 215.7l.7.7-.7-.7z" />
      <path fill="#21315a" d="M288 215.7l.7.7-.7-.7z" />
      <path fill="#00216b" d="M292.2 215.7l.7.7-.7-.7z" />
      <path fill="#001039" d="M292.9 215.7l.7.7-.7-.7z" />
      <path fill="#002984" d="M293.6 215.7l.7.7-.7-.7z" />
      <path fill="#31425a" d="M307 215.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M307.7 215.7l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M200 216.4l.7.6-.7-.6z" />
      <path fill="#00216b" d="M200.7 216.4l.7.6-.7-.6m5.7 0l.7.6-.7-.6z" />
      <path fill="#00184a" d="M211.8 216.6l.4.2-.4-.2z" />
      <path fill="#00216b" d="M217.6 216.4l.7.6-.7-.6z" />
      <path fill="#21315a" d="M218.3 216.4l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M219 216.4l.7.6-.7-.6z" />
      <path fill="#efefef" d="M219.7 216.4l.7.6-.7-.6m68.3 0l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M288.7 216.4l.7.6-.7-.6z" />
      <path fill="#314a7b" d="M289.4 216.4l.7.6-.7-.6z" />
      <path fill="#00216b" d="M290 216.4l.8.6-.7-.6m3.5 0l-.7 1.3.7-1.3z" />
      <path fill="#001039" d="M294.3 216.4l.7.6-.7-.6z" />
      <path fill="#002984" d="M295 216.4l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M307.7 216.4l.7.6-.7-.6z" />
      <path fill="#efefef" d="M199.3 217l.7.7-.7-.7z" />
      <path fill="#10214a" d="M200 217l.7.7-.7-.7z" />
      <path fill="#002984" d="M207.8 217l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#00184a" d="M210.3 217.3l.5.2-.5-.2z" />
      <path fill="#002984" d="M214.1 217l.7.7-.7-.7z" />
      <path fill="#00216b" d="M214.8 217l.7.7-.7-.7z" />
      <path fill="#00184a" d="M215.5 217l.7.7-.7-.7z" />
      <path fill="#42425a" d="M216.2 217l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M217 217l.6.7-.7-.7z" />
      <path fill="#cecece" d="M217.6 217l.7.7-.7-.7z" />
      <path fill="#dedede" d="M290 217l.8.7-.7-.7z" />
      <path fill="#8c8c8c" d="M290.8 217l.7.7-.7-.7z" />
      <path fill="#525a6b" d="M291.5 217l.7.7-.7-.7z" />
      <path fill="#10295a" d="M292.2 217l.7.7-.7-.7z" />
      <path fill="#002984" d="M293.6 217l.7.7-.7-.7z" />
      <path fill="#003994" d="M294.3 217l.7.7-.7-.7z" />
      <path fill="#00216b" d="M295 217l.7.7-.7-.7z" />
      <path fill="#001039" d="M295.7 217l.7.7-.7-.7z" />
      <path
        fill="#00216b"
        d="M296.4 217l.7.7-.7-.7m2.8 0l.7.7-.7-.7m8.5 0l.7.7-.7-.7z"
      />
      <path fill="#bdbdbd" d="M308.4 217l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M199.3 217.7l.7.7-.7-.7z" />
      <path fill="#00215a" d="M207.8 217.7l.7.7-.7-.7z" />
      <path fill="#00216b" d="M209.2 217.7l.7.7-.7-.7m2 0l.8.7-.7-.7z" />
      <path fill="#21315a" d="M212 217.7l.7.7-.7-.7z" />
      <path fill="#525a6b" d="M212.7 217.7l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M214.1 217.7l.7.7-.7-.7z" />
      <path fill="#dedede" d="M214.8 217.7l.7.7-.7-.7m78 0l.8.7-.7-.7z" />
      <path fill="#bdbdbd" d="M293.6 217.7l.7.7-.7-.7z" />
      <path fill="#525a6b" d="M295 217.7l.7.7-.7-.7z" />
      <path fill="#21315a" d="M295.7 217.7l.7.7-.7-.7z" />
      <path fill="#002984" d="M298.5 217.7l.7.7-.7-.7z" />
      <path fill="#42425a" d="M308.4 217.7l.7.7-.7-.7z" />
      <path fill="#dedede" d="M198.6 218.4l.7.6-.7-.6z" />
      <path fill="#10295a" d="M199.3 218.4l.7.6-.7-.6z" />
      <path fill="#00215a" d="M205 218.4l.7.6-.7-.6z" />
      <path fill="#21315a" d="M209.9 218.4l.7.6-.7-.6z" />
      <path fill="#52525a" d="M210.6 218.4l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M211.3 218.4l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M214.1 218.4l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M292.2 218.4l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M292.9 218.4l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M295.5 218.6l.4.2-.4-.2z" />
      <path fill="#8c8c8c" d="M296.4 218.4l.7.6-.7-.6z" />
      <path fill="#292921" d="M297.1 218.4l.7.6-.7-.6z" />
      <path fill="#080829" d="M297.8 218.4l.7.6-.7-.6z" />
      <path fill="#00216b" d="M301.3 218.4l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M309 218.4l.8.6-.7-.6z" />
      <path fill="#63636b" d="M198.6 219l.7.7-.7-.6z" />
      <path fill="#00215a" d="M200.7 219l.7.7-.7-.6z" />
      <path fill="#00184a" d="M202 219.3l.4.2-.5-.2z" />
      <path fill="#00216b" d="M202.8 219l.7.7-.7-.6z" />
      <path fill="#8c8c8c" d="M209.2 219l.7.7-.7-.6z" />
      <path fill="#efefef" d="M209.9 219l.7.7-.7-.6z" />
      <path fill="#8c8c8c" d="M298.5 219l.7.7-.7-.6z" />
      <path fill="#10295a" d="M299.2 219l.7.7-.7-.6z" />
      <path fill="#00216b" d="M303.4 219l.8.7-.8-.6z" />
      <path fill="#00184a" d="M304.6 219.3l.5.2-.5-.2z" />
      <path fill="#002984" d="M305.8 219.5l.2.4-.2-.4z" />
      <path fill="#212139" d="M309 219l.8.7-.7-.6z" />
      <path fill="#dedede" d="M198 219.7l.6.7-.7-.7z" />
      <path fill="#10214a" d="M207.8 219.7l.7.7-.7-.7z" />
      <path
        fill="#cecece"
        d="M208.5 219.7l-.7 1.4.7-1.4m90.7 0l1.4 1.4-1.4-1.4z"
      />
      <path fill="#10214a" d="M300 219.7l.6.7-.7-.7z" />
      <path fill="#00184a" d="M306.3 219.7l.7.7-.7-.7z" />
      <path fill="#00216b" d="M307 219.7l2.8 2.7-2.8-2.7z" />
      <path fill="#002984" d="M309 219.7l.8.7-.7-.7z" />
      <path fill="#9c9494" d="M309.8 219.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M198 220.4l.6.6-.7-.6z" />
      <path fill="#001039" d="M198.6 220.4l.7.6-.7-.6z" />
      <path fill="#10295a" d="M207 220.4l.8.6-.7-.6z" />
      <path fill="#101831" d="M300.6 220.4l.7.6-.7-.6z" />
      <path fill="#42425a" d="M309.8 220.4l.7.6-.7-.6z" />
      <path fill="#efefef" d="M197.2 221l.7.7-.7-.6z" />
      <path fill="#101829" d="M198 221l.6.7-.7-.6z" />
      <path fill="#002984" d="M206.4 221l.7.7-.7-.6z" />
      <path fill="#9c9494" d="M207 221l.8.7-.7-.6z" />
      <path fill="#cecece" d="M213.4 221l.7.7-.7-.6z" />
      <path
        fill="#bdbdbd"
        d="M214.1 221v.7H295l-24.6-.6H214m86.5 0l.7.6-.7-.6z"
      />
      <path fill="#00215a" d="M301.3 221l.7.7-.7-.6z" />
      <path fill="#00216b" d="M309.8 221l.7.7-.7-.6z" />
      <path fill="#dedede" d="M310.5 221l.7.7-.7-.6z" />
      <path fill="#424242" d="M197.2 221.7l.7.7-.7-.7z" />
      <path fill="#002984" d="M198 221.7l.6.7-.7-.7z" />
      <path fill="#52525a" d="M206.4 221.7l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M213.4 221.7l3.5 3.4-3.5-3.4z" />
      <path fill="#00216b" d="M214.1 221.7l2.1 2-2.1-2z" />
      <path
        fill="#003994"
        d="M214.8 221.7l5.9 7.4.4 26h6.4c0-8.2 1.8-16.8-4.3-23.3l8.5 5.3-3.5-10 19.7 18.7-14.8-22.7 14 18h.8v-19.4h-33.1z"
      />
      <path fill="#00184a" d="M247.9 221.7v20.1h.7l-.7-20z" />
      <path fill="#631808" d="M259.8 221.7v20.1h.7l-.7-20z" />
      <path
        fill="#de2110"
        d="M260.5 221.7v18.8l14.8-17.4-14.8 22.7 20.4-18.7-4.2 9.3 8.4-5.3c-4.5 8.3-4.2 14.5-4.2 24h6.4l.4-26 5.9-7.4h-33z"
      />
      <path fill="#b51010" d="M293.6 221.7l.7.7-.7-.7z" />
      <path fill="#63636b" d="M294.3 221.7l-1.4 2 1.4-2z" />
      <path fill="#8c8c8c" d="M301.3 221.7l.7.7-.7-.7z" />
      <path fill="#002984" d="M302 221.7l.7.7-.7-.7z" />
      <path fill="#63636b" d="M310.5 221.7l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M196.5 222.4l.7.7-.7-.7z" />
      <path fill="#000818" d="M197.2 222.4l.7.7-.7-.7z" />
      <path fill="#00184a" d="M205.7 222.4l.7.7-.7-.7z" />
      <path fill="#efefef" d="M206.4 222.4l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M292.9 222.4l.7.7-.7-.7z" />
      <path fill="#21315a" d="M302 222.4l.7.7-.7-.7z" />
      <path fill="#00184a" d="M309 222.4l.8.7-.7-.7z" />
      <path fill="#10214a" d="M310.5 222.4l.7.7-.7-.7z" />
      <path fill="#efefef" d="M311.2 222.4l.7.7-.7-.7z" />
      <path fill="#313931" d="M196.5 223l.7.7-.7-.6z" />
      <path fill="#00216b" d="M197.2 223l.7.7-.7-.6z" />
      <path fill="#63636b" d="M205.7 223l.7.7-.7-.6z" />
      <path fill="#002984" d="M233.1 223l.7.7-.7-.6z" />
      <path fill="#8c8c8c" d="M302 223l.7.7-.7-.6z" />
      <path fill="#00184a" d="M310 223.5l.2.5-.2-.5z" />
      <path fill="#9c9494" d="M311.2 223l.7.7-.7-.6M196 224l.3.5-.3-.4z" />
      <path fill="#292921" d="M196.5 223.7l.7.7-.7-.7z" />
      <path fill="#00216b" d="M205 223.7l.7.7-.7-.7z" />
      <path fill="#cecece" d="M205.7 223.7l.7.7-.7-.7z" />
      <path fill="#00215a" d="M216.2 223.7l.7.7-.7-.7z" />
      <path fill="#001039" d="M233.1 223.7l.7.7-.7-.7z" />
      <path fill="#212139" d="M233.8 223.7l1.4 1.4-1.4-1.4z" />
      <path fill="#100808" d="M274.6 223.7l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M292.2 223.7l-4.2 4.7 4.2-4.7z" />
      <path fill="#efefef" d="M302 223.7l.7.7-.7-.7z" />
      <path fill="#10295a" d="M302.7 223.7l.7.7-.7-.7z" />
      <path fill="#31425a" d="M311.2 223.7l.7.7-.7-.7z" />
      <path fill="#10295a" d="M196.5 224.4l.7.7-.7-.7z" />
      <path fill="#42425a" d="M205 224.4l.7.7-.7-.7z" />
      <path fill="#001039" d="M217 224.4l.6.7-.7-.7z" />
      <path fill="#002984" d="M233.1 224.4l.7.7-.7-.7z" />
      <path fill="#6b5a00" d="M233.8 224.4l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M273.2 224.4l.7.7-.7-.7z" />
      <path fill="#7b5a00" d="M273.9 224.4l.7.7-.7-.7z" />
      <path fill="#63636b" d="M302.7 224.4l.7.7-.7-.7z" />
      <path fill="#00216b" d="M311.2 224.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M311.9 224.4l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M195.8 225l.7.7-.7-.6z" />
      <path fill="#002984" d="M204.3 225l.6.7-.7-.6z" />
      <path fill="#9c9494" d="M205 225l.7.7-.7-.6z" />
      <path fill="#cecece" d="M217 225l3.4 3.4-3.5-3.3z" />
      <path fill="#10214a" d="M217.6 225l.7.7-.7-.6z" />
      <path fill="#392121" d="M233.8 225l.7.7-.7-.6z" />
      <path fill="#cea508" d="M234.7 225.5l.3.5-.3-.5z" />
      <path fill="#293129" d="M235.2 225l1.4 1.4-1.4-1.3z" />
      <path fill="#631808" d="M272.5 225l.7.7-.7-.6z" />
      <path fill="#634a00" d="M273.9 225l.7.7-.7-.6z" />
      <path fill="#ce2110" d="M274.6 225l.7.7-.7-.6z" />
      <path fill="#dedede" d="M302.7 225l.7.7-.7-.6z" />
      <path fill="#00216b" d="M303.4 225l.8.7-.8-.6z" />
      <path fill="#636b7b" d="M311.9 225l.7.7-.7-.6z" />
      <path fill="#42425a" d="M195.8 225.7l.7.7-.7-.7z" />
      <path fill="#21315a" d="M204.3 225.7l.6.7-.7-.7z" />
      <path fill="#10214a" d="M218.3 225.7l.7.7-.7-.7z" />
      <path fill="#00216b" d="M233.8 225.7l.7.7-.7-.7z" />
      <path fill="#efbd08" d="M235.2 225.7l.7.7-.7-.7z" />
      <path fill="#5a2908" d="M271.8 225.7l.7.7-.7-.7z" />
      <path fill="#efbd08" d="M273.2 225.7l.7.7-.7-.7z" />
      <path fill="#631808" d="M273.9 225.7l.7.7-.7-.7z" />
      <path fill="#42425a" d="M303.4 225.7l.8.7-.8-.7z" />
      <path fill="#10214a" d="M311.9 225.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M195.1 226.4l.7.7-.7-.7z" />
      <path fill="#00215a" d="M195.8 226.4l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M204.3 226.4l.6.7-.7-.7z" />
      <path fill="#10214a" d="M219 226.4l.7.7-.7-.7z" />
      <path fill="#634a00" d="M234.5 226.4l.7.7-.7-.7z" />
      <path fill="#deb508" d="M235.2 226.4l.7.7-.7-.7z" />
      <path fill="#292100" d="M236 226.4l.6.7-.7-.7z" />
      <path fill="#211800" d="M271.8 226.4l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M273.9 226.4l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M303.4 226.4l.8.7-.8-.7z" />
      <path fill="#002984" d="M304.1 226.4l.7.7-.7-.7z" />
      <path fill="#00216b" d="M311.9 226.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M312.6 226.4l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M195.1 227l.7.8-.7-.7z" />
      <path fill="#002984" d="M195.8 227l.7.8-.7-.7z" />
      <path fill="#00216b" d="M203.6 227l.7.8-.8-.7z" />
      <path fill="#cecece" d="M204.3 227l.6.8-.7-.7z" />
      <path fill="#10214a" d="M219.7 227l.7.8-.7-.7z" />
      <path fill="#00184a" d="M228.4 227.5l.2.5-.2-.5z" />
      <path fill="#10295a" d="M234.5 227l.7.8-.7-.7z" />
      <path fill="#000818" d="M235.2 227l.7.8-.7-.7z" />
      <path fill="#392100" d="M236 227l1.3 1.4-1.4-1.3z" />
      <path fill="#00184a" d="M236.6 227l.7.8-.7-.7z" />
      <path fill="#7b1008" d="M271 227l.8.8-.7-.7z" />
      <path fill="#392100" d="M271.8 227l.7.8-.7-.7z" />
      <path fill="#210800" d="M272.5 227l.7.8-.7-.7z" />
      <path fill="#5a1008" d="M273.2 227l.7.8-.7-.7z" />
      <path fill="#631808" d="M279.5 227l.7.8-.7-.7z" />
      <path fill="#ce2110" d="M280.2 227l.7.8-.7-.7z" />
      <path fill="#7b1008" d="M288 227l.7.8-.7-.7z" />
      <path fill="#00184a" d="M304.1 227l.7.8-.7-.7z" />
      <path fill="#7b7373" d="M312.6 227l.7.8-.7-.7z" />
      <path fill="#636b7b" d="M195.1 227.8l.7.6-.7-.7z" />
      <path fill="#21315a" d="M203.6 227.8l.7.6-.8-.7z" />
      <path fill="#10295a" d="M220.4 227.8l.7.6-.7-.7z" />
      <path fill="#102110" d="M228.9 227.8l.7.6-.7-.7z" />
      <path fill="#002984" d="M229.6 227.8l.7.6-.7-.7z" />
      <path fill="#101810" d="M236 227.8l.6.6-.7-.7z" />
      <path fill="#00216b" d="M237.3 227.8l.7.6-.7-.7z" />
      <path fill="#b51010" d="M270.4 227.8l.7.6-.7-.7z" />
      <path fill="#211800" d="M271.6 228l.4.2-.4-.2z" />
      <path fill="#b51010" d="M272.5 227.8l.7.6-.7-.7z" />
      <path fill="#bd2110" d="M278.1 227.8l.7.6-.7-.7z" />
      <path fill="#5a2908" d="M278.8 227.8l.7.6-.7-.7z" />
      <path fill="#310000" d="M279.5 227.8l.7.6-.7-.7z" />
      <path fill="#7b1008" d="M287.3 227.8l.7.6-.7-.7z" />
      <path fill="#42425a" d="M304.1 227.8l.7.6-.7-.7z" />
      <path fill="#314a7b" d="M312.6 227.8l.7.6-.7-.7z" />
      <path fill="#10214a" d="M195.1 228.4l.7.7-.7-.7z" />
      <path fill="#636b7b" d="M203.6 228.4l.7.7-.8-.7z" />
      <path fill="#42425a" d="M220.4 228.4V256h.7c0-7.9 2.5-20.3-.7-27.5z" />
      <path fill="#634a00" d="M228.9 228.4l.7.7-.7-.7z" />
      <path fill="#8c7300" d="M229.6 228.4l.7.7-.7-.7z" />
      <path fill="#10214a" d="M230.3 228.4l.7.7-.7-.7z" />
      <path fill="#002984" d="M236 228.4l.6.7-.7-.7z" />
      <path fill="#211800" d="M236.6 228.4l.7.7-.7-.7z" />
      <path fill="#181000" d="M237.3 228.4l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M269.7 228.4l.7.7-.7-.7z" />
      <path fill="#311000" d="M270.4 228.4l.7.7-.7-.7z" />
      <path fill="#392100" d="M271 228.4l-1.3 2 1.4-2z" />
      <path fill="#7b1008" d="M271.8 228.4l.7.7-.7-.7m5.6 0l.7.7-.7-.7z" />
      <path fill="#7b5a00" d="M278.1 228.4l.7.7-.7-.7z" />
      <path fill="#6b5a00" d="M278.8 228.4l.7.7-.7-.7z" />
      <path fill="#b51010" d="M279.5 228.4l.7.7-.7-.7z" />
      <path fill="#631808" d="M287.3 228.4v26.8h.7c0-7.7 2.4-19.7-.7-26.8z" />
      <path fill="#8c8c8c" d="M304.1 228.4l.7.7-.7-.7z" />
      <path fill="#00216b" d="M312.6 228.4l.7.7-.7-.7z" />
      <path fill="#dedede" d="M313.3 228.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M194.4 229l.7.8-.7-.7z" />
      <path fill="#00216b" d="M195.1 229l.7.8-.7-.7z" />
      <path fill="#002984" d="M202.8 229l.7.8-.7-.7z" />
      <path fill="#9c9494" d="M203.6 229l.7.8-.8-.7z" />
      <path fill="#00215a" d="M228.9 229l.7.8-.7-.7z" />
      <path fill="#bd9408" d="M229.6 229l.7.8-.7-.7z" />
      <path fill="#cea508" d="M230.3 229l.7.8-.7-.7z" />
      <path fill="#293129" d="M231 229l.7.8-.7-.7z" />
      <path fill="#002984" d="M231.7 229l.7.8-.7-.7z" />
      <path fill="#00184a" d="M236.6 229l.7.8-.7-.7z" />
      <path fill="#392100" d="M237.3 229l1.4 1.4-1.4-1.3z" />
      <path fill="#101829" d="M238 229l.7.8-.7-.7z" />
      <path fill="#5a1008" d="M269.7 229l.7.8-.7-.7z" />
      <path fill="#420000" d="M271 229l.8.8-.7-.7z" />
      <path fill="#ce2110" d="M276 229l.7.8-.7-.7z" />
      <path fill="#5a2908" d="M276.7 229l.7.8-.7-.7z" />
      <path fill="#bd9408" d="M277.4 229l.7.8-.7-.7z" />
      <path fill="#efbd08" d="M278.1 229l.7.8-.7-.7z" />
      <path fill="#631808" d="M278.8 229l.7.8-.7-.7z" />
      <path fill="#cecece" d="M304.1 229l.7.8-.7-.7z" />
      <path fill="#00216b" d="M304.9 229l.7.8-.8-.7z" />
      <path fill="#8c8c8c" d="M313.3 229l.7.8-.7-.7m-118.9.7l.7.6-.7-.6z" />
      <path fill="#00215a" d="M202.8 229.8l.7.6-.7-.6z" />
      <path fill="#dedede" d="M203.6 229.8l.7.6-.8-.6z" />
      <path fill="#313918" d="M229.6 229.8l.7.6-.7-.6z" />
      <path fill="#ffce08" d="M230.3 229.8l.7.6-.7-.6z" />
      <path fill="#ad8c08" d="M231 229.8l.7.6-.7-.6z" />
      <path fill="#00215a" d="M231.7 229.8l.7.6-.7-.6z" />
      <path fill="#101829" d="M237.3 229.8l.7.6-.7-.6z" />
      <path fill="#00184a" d="M238.7 229.8l.7.6-.7-.6z" />
      <path fill="#941808" d="M269 229.8l.7.6-.7-.6z" />
      <path fill="#ce2110" d="M271 229.8l.8.6-.7-.6z" />
      <path fill="#ad1810" d="M276 229.8l.7.6-.7-.6z" />
      <path fill="#7b5a00" d="M276.7 229.8l.7.6-.7-.6z" />
      <path fill="#ffce08" d="M277.4 229.8l.7.6-.7-.6z" />
      <path fill="#634a00" d="M278.1 229.8l-.7 1.3.7-1.3z" />
      <path fill="#ce2110" d="M278.8 229.8l.7.6-.7-.6z" />
      <path fill="#10214a" d="M304.9 229.8l.7.6-.8-.6z" />
      <path fill="#00216b" d="M306.3 229.8l.7.6-.7-.6z" />
      <path fill="#525a6b" d="M313.3 229.8l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M193.7 230.4l.7.7-.7-.7z" />
      <path fill="#dedede" d="M194.4 230.4l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M195.1 230.4l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M195.8 230.4l.7.7-.7-.7z" />
      <path fill="#42425a" d="M196.5 230.4l.7.7-.7-.7z" />
      <path fill="#00184a" d="M197.2 230.4l.7.7-.7-.7z" />
      <path fill="#002984" d="M198 230.4l.6.7-.7-.7z" />
      <path fill="#314a7b" d="M202.8 230.4l.7.7-.7-.7z" />
      <path fill="#002984" d="M229.6 230.4l.7.7-.7-.7z" />
      <path fill="#423100" d="M230.3 230.4l.7.7-.7-.7z" />
      <path fill="#211800" d="M231 230.4l.7.7-.7-.7z" />
      <path fill="#181000" d="M231.7 230.4l.7.7-.7-.7z" />
      <path fill="#002984" d="M232.4 230.4l.7.7-.7-.7z" />
      <path fill="#181000" d="M238 230.4l.7.7-.7-.7z" />
      <path fill="#211800" d="M238.7 230.4l.7.7-.7-.7z" />
      <path fill="#002984" d="M239.4 230.4l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M268.3 230.4l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M270.4 230.4l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M275.3 230.4l-.7 1.4.7-1.4z" />
      <path fill="#211800" d="M276.7 230.4l.7.7-.7-.7z" />
      <path fill="#631808" d="M278.1 230.4l.7.7-.7-.7z" />
      <path fill="#636b7b" d="M304.9 230.4l.7.7-.8-.7z" />
      <path fill="#000818" d="M306.3 230.4l.7.7-.7-.7z" />
      <path fill="#002984" d="M309.8 230.4l.7.7-.7-.7z" />
      <path fill="#00184a" d="M310.5 230.4l.7.7-.7-.7z" />
      <path fill="#314a7b" d="M311.2 230.4l.7.7-.7-.7z" />
      <path fill="#636b7b" d="M311.9 230.4l.7.7-.7-.7z" />
      <path fill="#63636b" d="M312.6 230.4l.7.7-.7-.7z" />
      <path fill="#cecece" d="M313.3 230.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M195.1 231l.7.8-.7-.7z" />
      <path fill="#dedede" d="M195.8 231l.7.8-.7-.7z" />
      <path fill="#bdbdbd" d="M196.5 231l.7.8-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M198.6 231l.7.8-.7-.7z" />
      <path fill="#314a7b" d="M199.3 231l.7.8-.7-.7z" />
      <path fill="#00216b" d="M200 231l.7.8-.7-.7z" />
      <path fill="#7b7373" d="M202.8 231l.7.8-.7-.7z" />
      <path fill="#cecece" d="M204.3 231l.6.8-.7-.7z" />
      <path fill="#efefef" d="M205 231l.7.8-.7-.7z" />
      <path fill="#001039" d="M231 231l2.1 2-2.1-2z" />
      <path fill="#392100" d="M231.7 231l5 4.8-5-4.7z" />
      <path fill="#001010" d="M232.4 231l.7.8-.7-.7z" />
      <path fill="#00216b" d="M238 231l.7.8-.7-.7z" />
      <path fill="#392100" d="M238.7 231l2.1 2-2-2z" />
      <path fill="#101810" d="M239.4 231l.7.8-.7-.7z" />
      <path fill="#310000" d="M268.3 231l1.4 1.4-1.4-1.3z" />
      <path fill="#392100" d="M269 231l.7.8-.7-.7z" />
      <path fill="#631808" d="M269.7 231l.7.8-.7-.7z" />
      <path fill="#420000" d="M276.7 231l.7.8-.7-.7z" />
      <path fill="#ce2110" d="M277.4 231l.7.8-.7-.7m7 0l.8.7-.7-.7z" />
      <path fill="#9c9494" d="M304.9 231l.7.8-.8-.7z" />
      <path fill="#001000" d="M306.3 231l.7.8-.7-.7z" />
      <path fill="#00216b" d="M307.7 231l.7.8-.7-.7z" />
      <path fill="#21315a" d="M308.4 231l.7.8-.7-.7z" />
      <path fill="#7b7373" d="M309 231l.8.8-.7-.7z" />
      <path fill="#bdbdbd" d="M311.6 231.3l.5.2-.5-.2z" />
      <path fill="#cecece" d="M193 231.8l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M193.7 231.8l.7.6-.7-.6z" />
      <path fill="#cecece" d="M195.8 231.8l1.4 1.3-1.4-1.3z" />
      <path fill="#ada5a5" d="M196.5 231.8l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M197.2 231.8l2.1 2.6-2-2.6z" />
      <path fill="#9c9494" d="M198 231.8l.6.6-.7-.6z" />
      <path fill="#efefef" d="M199 232l.6.2-.5-.2z" />
      <path fill="#dedede" d="M200 231.8l-.7 1.3.7-1.3z" />
      <path fill="#8c8c8c" d="M200.7 231.8l2.1 3.3-2-3.3z" />
      <path fill="#314a7b" d="M201.4 231.8l.7.6-.7-.6z" />
      <path fill="#00184a" d="M202.1 231.8l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M202.8 231.8l.7.6-.7-.6z" />
      <path fill="#6b735a" d="M204.3 231.8l.6.6-.7-.6z" />
      <path fill="#63636b" d="M205 231.8l.7.6-.7-.6z" />
      <path fill="#002984" d="M284 231.3l.7.7-.7-.7z" />
      <path fill="#000818" d="M224 231.8l.6.6-.7-.6z" />
      <path fill="#00216b" d="M224.7 231.8l.7.6-.8-.6z" />
      <path fill="#001010" d="M233.1 231.8l.7.6-.7-.6z" />
      <path fill="#001039" d="M238.7 231.8l.7.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#631808" d="M267.6 231.8l.7.6-.7-.6z" />
      <path fill="#392100" d="M268.3 231.8l.7.6-.7-.6z" />
      <path fill="#5a1008" d="M274.6 231.8l-1.4 2 1.4-2z" />
      <path fill="#392100" d="M275.3 231.8l-2.1 2.6 2.1-2.6z" />
      <path fill="#ce2110" d="M276.7 231.8l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M283 231.8l.7.6-.7-.6z" />
      <path fill="#310000" d="M283.8 231.8l.6.6-.6-.6z" />
      <path fill="#941808" d="M284.4 231.8l.8.6-.8-.6z" />
      <path fill="#8c8c8c" d="M296.6 232.2l.3.5-.3-.5z" />
      <path fill="#dedede" d="M300 231.8l.6.6-.7-.6z" />
      <path fill="#7b7373" d="M300.6 231.8l.7.6-.7-.6z" />
      <path fill="#dedede" d="M304.9 231.8l.7.6-.8-.6z" />
      <path fill="#080829" d="M305.6 231.8l.7.6-.7-.6z" />
      <path fill="#184a00" d="M306.3 231.8l.7.6-.7-.6z" />
      <path fill="#424242" d="M307 231.8l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M307.7 231.8l1.4 1.3-1.4-1.3z" />
      <path fill="#cecece" d="M308.4 231.8l.7.6-.7-.6z" />
      <path fill="#424242" d="M310.5 231.8l.7.6-.7-.6z" />
      <path fill="#cecece" d="M311.2 231.8l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M193 232.4l.7.7-.7-.7z" />
      <path fill="#dedede" d="M193.7 232.4l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M195.8 232.4l.7.7-.7-.7m5 0l.6.7-.7-.7z" />
      <path fill="#dedede" d="M202 232.7l.4.2-.5-.2z" />
      <path fill="#cecece" d="M203.6 232.4l.7.7-.8-.7z" />
      <path fill="#294200" d="M204.3 232.4l.6.7-.7-.7z" />
      <path fill="#295200" d="M205 232.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M205.7 232.4l.7.7-.7-.7z" />
      <path fill="#00184a" d="M224 232.4l.6.7-.7-.7z" />
      <path fill="#8c7300" d="M224.7 232.4l.7.7-.8-.7z" />
      <path fill="#392121" d="M225.4 232.4l.7.7-.7-.7z" />
      <path fill="#002984" d="M226 232.4l.8.7-.7-.7z" />
      <path fill="#00184a" d="M231.7 232.4v4.7h.7l-.7-4.7z" />
      <path fill="#001010" d="M233.8 232.4l.7.7-.7-.7m5.6 0l.7.7-.7-.7z" />
      <path fill="#00215a" d="M240.8 232.4l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M266.9 232.4l.7.7-.7-.7z" />
      <path fill="#211800" d="M266.9 233.8l2-.7-2 .7z" />
      <path fill="#bd2110" d="M269 232.4l.7.7-.7-.7z" />
      <path fill="#001010" d="M275.3 232.4l-.7 1.4.7-1.4z" />
      <path fill="#6b1821" d="M276 232.4l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M281.6 232.4l.7.7-.7-.7z" />
      <path fill="#5a2908" d="M282.3 232.4l1.4 1.4-1.4-1.4z" />
      <path fill="#8c7300" d="M283 232.4l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M283.8 232.4l.6.7-.6-.7z" />
      <path fill="#ada5a5" d="M297.1 232.4l-.7 1.4.7-1.4z" />
      <path fill="#101810" d="M300.6 232.4l.7.7-.7-.7z" />
      <path fill="#efefef" d="M301.3 232.4l.7.7-.7-.7m3.3.3l.5.2-.5-.3z" />
      <path d="M305.6 232.4l.7.7-.7-.7z" />
      <path fill="#297b00" d="M306.3 232.4l.7.7-.7-.7z" />
      <path fill="#313931" d="M307 232.4l.7.7-.7-.7z" />
      <path fill="#cecece" d="M307.7 232.4l.7.7-.7-.7z" />
      <path fill="#52525a" d="M310.5 232.4l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M311.2 232.4l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M193 233.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M194.2 233.3l.4.3-.4-.3m2.8 0l.4.3-.4-.3z" />
      <path fill="#ada5a5" d="M199.3 233.1l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M200 233.1l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M201.4 233.1l.7.7-.7-.7z" />
      <path fill="#efefef" d="M202.8 233.1l.7.7-.7-.7z" />
      <path fill="#314231" d="M203.6 233.1l.7.7-.8-.7z" />
      <path fill="#397b00" d="M204.3 233.1l.6.7-.7-.7z" />
      <path
        fill="#428c00"
        d="M205 233.1l-1.4 5.4h-.7l1.3-4.7h-.6l-.7 5.3 2.8-1.3-3.5 5.3 2.8-2-3.6 2.7-.7 3.4h.7l7-8-2 .6v-.7l2-.6v-.7h-2.7l-.7-4.7z"
      />
      <path fill="#5a6b52" d="M205.7 233.1l.7.7-.7-.7z" />
      <path fill="#102121" d="M224.7 233.1l.7.7-.8-.7z" />
      <path fill="#efbd08" d="M225.4 233.1l.7.7-.7-.7z" />
      <path fill="#ad8c08" d="M226 233.1l.8.7-.7-.7z" />
      <path fill="#102121" d="M226.8 233.1l.7.7-.7-.7z" />
      <path fill="#002984" d="M227.5 233.1l.7.7-.7-.7z" />
      <path
        fill="#003994"
        d="M232.4 233.1c0 5.4 3.2 7.9 7.7 10.7-.3-4.5-4.1-8-7.7-10.7z"
      />
      <path fill="#001010" d="M233.1 233.1l.7.7-.7-.7z" />
      <path fill="#001039" d="M234.5 233.1l.7.7-.7-.7z" />
      <path fill="#002984" d="M239.4 233.1l.7.7-.7-.7z" />
      <path fill="#211800" d="M240.6 233.3l.5.3-.5-.3z" />
      <path fill="#002984" d="M241.5 233.1l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M266.2 233.1l.7.7-.7-.7z" />
      <path fill="#392100" d="M267.6 233.1l-1.4 2 1.4-2z" />
      <path fill="#941808" d="M268.3 233.1l.7.7-.7-.7z" />
      <path fill="#003994" d="M275.3 233.1l-7 10.7c3.9-2.3 9.2-5.8 7-10.7z" />
      <path fill="#ce2110" d="M280.2 233.1l.7.7-.7-.7z" />
      <path fill="#6b2908" d="M281 233.1l.6.7-.7-.7z" />
      <path fill="#9c7b08" d="M281.6 233.1l.7.7-.7-.7z" />
      <path fill="#ffce08" d="M282.3 233.1l-.7 1.3.7-1.3z" />
      <path fill="#ce2110" d="M283.8 233.1l.6.7-.6-.7z" />
      <path fill="#294221" d="M300.6 233.1l1.4 1.3-1.4-1.3z" />
      <path fill="#8c8c8c" d="M301.3 233.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M304.6 233.3l.5.3-.5-.3z" />
      <path fill="#103910" d="M305.6 233.1l.7.7-.7-.7z" />
      <path
        fill="#319400"
        d="M306.3 233.1l.7 14h.7l2-12h-.6l-1.4 8h-.7l-.7-10z"
      />
      <path fill="#424242" d="M307 233.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M307.7 233.1l.7.7-.7-.7z" />
      <path fill="#185200" d="M309.8 233.1l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M311.2 233.1l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M312.6 233.1l.7.7-.7-.7z" />
      <path fill="#cecece" d="M313.3 233.1l-.7 1.3.7-1.3z" />
      <path fill="#ada5a5" d="M315.4 233.1l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M193 233.8l2.1 2-2.1-2z" />
      <path fill="#cecece" d="M194.4 233.8l.7 2h.7l-1.4-2z" />
      <path fill="#9c9494" d="M195.1 233.8l.7.6-.7-.6z" />
      <path fill="#dedede" d="M197.2 233.8l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M198 233.8l-.8 1.3.7-1.3z" />
      <path fill="#425242" d="M199.3 233.8l.7.6-.7-.6z" />
      <path fill="#213918" d="M200 233.8l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M200.7 233.8l.7.6-.7-.6z" />
      <path fill="#63636b" d="M202.8 233.8l.7.6-.7-.6z" />
      <path fill="#294200" d="M204.5 234.2l.2.5-.2-.5z" />
      <path fill="#295200" d="M205.7 233.8l.7.6-.7-.6z" />
      <path fill="#dedede" d="M206.4 233.8l.7.6-.7-.6z" />
      <path fill="#4a4208" d="M225.4 233.8l.7.6-.7-.6z" />
      <path fill="#ffce08" d="M226 233.8l.8.6-.7-.6z" />
      <path fill="#bd9408" d="M226.8 233.8l.7.6-.7-.6z" />
      <path fill="#00184a" d="M227.5 233.8l.7.6-.7-.6z" />
      <path fill="#001010" d="M233.8 233.8l.7.6-.7-.6z" />
      <path fill="#001039" d="M235.2 233.8l.7.6-.7-.6z" />
      <path fill="#00215a" d="M240.1 233.8l.7.6-.7-.6z" />
      <path fill="#392100" d="M240.8 233.8l1.4 1.3-1.4-1.3z" />
      <path fill="#001010" d="M241.5 233.8l.7.6-.7-.6z" />
      <path fill="#efefef" d="M255.6 233.8l.7.6-.7-.6z" />
      <path fill="#420000" d="M266.2 233.8l.7.6-.7-.6z" />
      <path fill="#5a1008" d="M267.6 233.8l.7.6-.7-.6z" />
      <path fill="#7b1008" d="M272.5 233.8l.7.6-.7-.6z" />
      <path fill="#181000" d="M273.9 233.8l-1.4 2 1.4-2z" />
      <path fill="#002984" d="M274.6 233.8l.7.6-.7-.6z" />
      <path fill="#941808" d="M280.2 233.8l.7.6-.7-.6z" />
      <path fill="#7b5a00" d="M281 233.8l.6.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#b51010" d="M283 233.8l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M296.4 233.8l.7.6-.7-.6z" />
      <path fill="#103910" d="M297.1 233.8l.7.6-.7-.6z" />
      <path fill="#dedede" d="M297.8 233.8l.7.6-.7-.6z" />
      <path fill="#4a6342" d="M300.6 233.8l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M304.9 233.8l.7.6-.8-.6z" />
      <path fill="#185200" d="M305.6 233.8l.7.6-.7-.6z" />
      <path fill="#7b8c73" d="M307 233.8l.7.6-.7-.6z" />
      <path fill="#395231" d="M309 233.8l.8.6-.7-.6z" />
      <path fill="#319400" d="M309.8 233.8l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M313.3 233.8l.7.6-.7-.6z" />
      <path fill="#63636b" d="M314.7 233.8l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M315.4 233.8l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M193 234.4l.7.7-.7-.7z" />
      <path fill="#cecece" d="M198 234.4l.6.7-.7-.7z" />
      <path fill="#424242" d="M198.6 234.4l.7.7-.7-.7z" />
      <path fill="#295200" d="M199.3 234.4l.7.7-.7-.7z" />
      <path fill="#294200" d="M200 234.4l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M200.7 234.4l1.4 1.4-1.4-1.4z" />
      <path fill="#397b00" d="M202.8 234.4l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M206.4 234.4l.7.7-.7-.7z" />
      <path fill="#002984" d="M225.4 234.4l1.4 1.4-1.4-1.4z" />
      <path fill="#6b5a00" d="M226 234.4l.8.7-.7-.7z" />
      <path fill="#211800" d="M226.8 234.4l2 1.4-2-1.4z" />
      <path fill="#00216b" d="M228.2 234.4l.7.7-.7-.7z" />
      <path fill="#001010" d="M234.5 234.4l.7.7-.7-.7z" />
      <path fill="#001039" d="M236 234.4l.6.7-.7-.7m5 0l.6.7-.7-.7z" />
      <path fill="#00184a" d="M242.2 234.4l.7.7-.7-.7z" />
      <path fill="#bd9408" d="M253.5 234.4v.7l1.4 2.7h.7l-2.1-3.4z" />
      <path fill="#7b1008" d="M265.5 234.4l.7.7-.7-.7z" />
      <path fill="#311000" d="M266.9 234.4l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M267.6 234.4l.7.7-.7-.7z" />
      <path fill="#941808" d="M271.8 234.4l-.7 1.4.7-1.4z" />
      <path fill="#211800" d="M272.5 234.4l.7.7-.7-.7z" />
      <path fill="#002984" d="M273.9 234.4l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M279.5 234.4l.7.7-.7-.7z" />
      <path fill="#211800" d="M280.2 234.4l-1.4 2 1.4-2z" />
      <path fill="#181000" d="M281 234.4l.6.7-.7-.7z" />
      <path fill="#6b5a00" d="M281.6 234.4l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M282.3 234.4l.7.7-.7-.7z" />
      <path fill="#dedede" d="M296.4 234.4l.7.7-.7-.7z" />
      <path fill="#185200" d="M297.1 234.4l.7.7-.7-.7z" />
      <path fill="#425242" d="M297.8 234.4l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M300.6 234.4l.7.7-.7-.7z" />
      <path fill="#296300" d="M301.3 234.4l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M302 234.4l.7.7-.7-.7z" />
      <path fill="#313931" d="M304.9 234.4l.7.7-.8-.7z" />
      <path fill="#297b00" d="M305.6 234.4l.7.7-.7-.7z" />
      <path fill="#4a6342" d="M307 234.4v3.4h.7l-.7-3.4z" />
      <path fill="#7b7373" d="M308.4 234.4l.7.7-.7-.7z" />
      <path fill="#297b00" d="M309.5 234.7l.5.2-.5-.2z" />
      <path fill="#63636b" d="M310.5 234.4l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M311.2 234.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M312.4 234.7l.4.2-.4-.2z" />
      <path fill="#8c8c8c" d="M313.3 234.4l-.7 1.4.7-1.4z" />
      <path fill="#7b7373" d="M314 234.4l.7.7-.7-.7z" />
      <path fill="#103910" d="M314.7 234.4l.7.7-.7-.7z" />
      <path fill="#efefef" d="M315.4 234.4l.7.7-.7-.7z" />
      <path fill="#cecece" d="M192.3 235.1l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M193 235.1l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M195.8 235.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M198 235.1l.6.7-.7-.7z" />
      <path fill="#001000" d="M198.6 235.1l.7.7-.7-.7z" />
      <path fill="#397b00" d="M199.3 235.1v2l2.1-.6v-.7l-2-.7z" />
      <path fill="#213918" d="M200.7 235.1l.7.7-.7-.7z" />
      <path fill="#294200" d="M202.1 235.1l.7.7-.7-.7z" />
      <path fill="#397b00" d="M204 235.3l.5.3-.5-.3z" />
      <path fill="#8c8c8c" d="M206.4 235.1l.7.7-.7-.7z" />
      <path fill="#00216b" d="M226.8 235.1l.7.7-.7-.7z" />
      <path fill="#00184a" d="M228.9 235.1l.7.7-.7-.7z" />
      <path fill="#002984" d="M234.5 235.1l2.1 2-2.1-2z" />
      <path fill="#181000" d="M235.2 235.1l.7.7-.7-.7z" />
      <path fill="#00184a" d="M236.6 235.1l.7.7-.7-.7z" />
      <path fill="#181000" d="M241.5 235.1l.7.7-.7-.7z" />
      <path fill="#211800" d="M242.5 235.6l.2.4-.2-.4z" />
      <path fill="#00216b" d="M243 235.1l.6.7-.7-.7z" />
      <path fill="#7b5a00" d="M252.8 235.1v2.7h.7l-.7-2.7z" />
      <path
        fill="#ffce08"
        d="M253.5 235.1v3.4h-2.8v2h2.8v8h.7l.7-8h3.5v-2H255V235h-1.4z"
      />
      <path fill="#b51010" d="M264.8 235.1l.6.7-.6-.7z" />
      <path fill="#211800" d="M266 235.3l.4.3-.5-.3z" />
      <path fill="#b51010" d="M266.9 235.1l.7.7-.7-.7z" />
      <path fill="#211800" d="M271.8 235.1l-2.1 2.7 2-2.7z" />
      <path fill="#002984" d="M273.2 235.1l.7.7-.7-.7z" />
      <path fill="#941808" d="M278.8 235.1l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M281 235.1l.6.7-.7-.7z" />
      <path fill="#b51010" d="M281.6 235.1l.7.7-.7-.7z" />
      <path fill="#214210" d="M297.1 235.1l.7.7-.7-.7z" />
      <path fill="#296300" d="M297.8 235.1l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M298.5 235.1l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M300.6 235.1l.7.7-.7-.7z" />
      <path fill="#319400" d="M301.3 235.1l.7.7-.7-.7z" />
      <path fill="#425242" d="M302 235.1l.7.7-.7-.7z" />
      <path fill="#52525a" d="M304.9 235.1l.7.7-.8-.7z" />
      <path fill="#395231" d="M308.4 235.1l.7.7-.7-.7z" />
      <path fill="#296300" d="M309.8 235.1l.7.7-.7-.7z" />
      <path fill="#424242" d="M310.5 235.1l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M311.2 235.1l.7.7-.7-.7z" />
      <path fill="#cecece" d="M311.9 235.1l.7.7-.7-.7z" />
      <path fill="#52525a" d="M313.3 235.1l.7.7-.7-.7z" />
      <path fill="#185200" d="M314 235.1l.7.7-.7-.7z" />
      <path fill="#63636b" d="M314.7 235.1l.7.7-.7-.7z" />
      <path fill="#dedede" d="M193.7 235.8l.7.6-.7-.6z" />
      <path fill="#efefef" d="M194.4 235.8l.7.6-.7-.6z" />
      <path fill="#dedede" d="M195.6 236l.5.2-.5-.2z" />
      <path fill="#9c9494" d="M196.5 235.8l.7.6-.7-.6z" />
      <path fill="#424242" d="M198 235.8l.6.6-.7-.6z" />
      <path
        fill="#428c00"
        d="M198.6 235.8c-1.9 4-1.6 6.6 0 10.7h1.4l1.4-10h-.7l-.7 8h-1.4v-8.7z"
      />
      <path fill="#313931" d="M201.4 235.8l.7.6-.7-.6z" />
      <path fill="#294200" d="M203.8 236.2l.2.5-.2-.5z" />
      <path fill="#6b735a" d="M206.4 235.8l.7.6-.7-.6z" />
      <path fill="#00216b" d="M227.5 235.8l1.4 1.3-1.4-1.3z" />
      <path fill="#100808" d="M228.2 235.8l.7.6-.7-.6z" />
      <path fill="#392100" d="M228.9 235.8l2.8 2.7-2.8-2.7z" />
      <path fill="#001039" d="M229.6 235.8l.7.6-.7-.6z" />
      <path fill="#181000" d="M236 235.8l1.3 1.3-1.4-1.3z" />
      <path fill="#211800" d="M236.6 235.8l2.8 3.3-2.8-3.3z" />
      <path fill="#00216b" d="M237.3 235.8l.7.6-.7-.6z" />
      <path fill="#002984" d="M241.5 235.8l.7.6-.7-.6z" />
      <path fill="#181000" d="M243 235.8l.6.6-.7-.6z" />
      <path fill="#311000" d="M264.8 235.8l.6.6-.6-.6z" />
      <path fill="#392100" d="M265.5 235.8l-.7 1.3.7-1.3z" />
      <path fill="#7b1008" d="M266.2 235.8l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M270.4 235.8l.7.6-.7-.6z" />
      <path fill="#00216b" d="M272.5 235.8l.7.6-.7-.6z" />
      <path fill="#631808" d="M278.1 235.8l.7.6-.7-.6z" />
      <path fill="#5a1008" d="M280.2 235.8l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M297.1 235.8l.7.6-.7-.6z" />
      <path fill="#319400" d="M297.8 235.8l.7.6-.7-.6z" />
      <path fill="#103910" d="M298.5 235.8l.7.6-.7-.6z" />
      <path fill="#efefef" d="M299.2 235.8l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M300.6 235.8l.7.6-.7-.6z" />
      <path fill="#297b00" d="M301.3 235.8l.7.6-.7-.6z" />
      <path fill="#185200" d="M302 235.8l.7.6-.7-.6z" />
      <path fill="#cecece" d="M302.7 235.8l.7.6-.7-.6z" />
      <path fill="#315221" d="M304.9 235.8l.7.6-.8-.6z" />
      <path fill="#185200" d="M308.4 235.8l.7.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M310.5 235.8l.7.6-.7-.6z" />
      <path fill="#efefef" d="M311.6 236l.5.2-.5-.2z" />
      <path fill="#ada5a5" d="M312.6 235.8l.7.6-.7-.6z" />
      <path fill="#214210" d="M313.3 235.8l.7.6-.7-.6z" />
      <path fill="#296300" d="M314 235.8l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M314.7 235.8l.7.6-.7-.6z" />
      <path fill="#397b00" d="M198 236.4l.6.7-.7-.7z" />
      <path fill="#103900" d="M201.4 236.4l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M206.4 236.4l.7.7-.7-.7z" />
      <path
        fill="#002984"
        d="M227.5 236.4v18.8H221v.7l7-.7v3.3h.8c0-5.7 2.3-17.4-1.4-22z"
      />
      <path fill="#001010" d="M228.9 236.4l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#00216b" d="M238 236.4l.7.7-.7-.7z" />
      <path fill="#00184a" d="M242.2 236.4l.7.7-.7-.7z" />
      <path fill="#392100" d="M243 236.4l1.3 1.4-1.4-1.4z" />
      <path fill="#101829" d="M243.7 236.4l.7.7-.8-.7z" />
      <path fill="#631808" d="M264 236.4l.8.7-.8-.7z" />
      <path fill="#420000" d="M265.5 236.4l.7.7-.7-.7z" />
      <path fill="#b51010" d="M269.7 236.4l.7.7-.7-.7z" />
      <path fill="#00216b" d="M271.8 236.4l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M276.7 236.4l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M277.4 236.4l.7.7-.7-.7z" />
      <path fill="#392100" d="M278.1 236.4l-2 2.7 2-2.6z" />
      <path fill="#181000" d="M278.8 236.4l.7.7-.7-.7z" />
      <path fill="#002984" d="M279.5 236.4l.7.7-.7-.7z" />
      <path fill="#631808" d="M280.2 236.4v18.8h.7l-.7-18.7z" />
      <path fill="#8c8c8c" d="M297.1 236.4l.7.7-.7-.7z" />
      <path fill="#297b00" d="M298.3 236.7l.5.2-.5-.2z" />
      <path fill="#52525a" d="M299.2 236.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M300.6 236.4l.7.7-.7-.7z" />
      <path fill="#296300" d="M301.3 236.4l.7.7-.7-.7z" />
      <path
        fill="#319400"
        d="M302 236.4l2.9 16.8h.7a21.2 21.2 0 0 0-3.6-16.8z"
      />
      <path fill="#63636b" d="M302.7 236.4l.7.7-.7-.7z" />
      <path fill="#cecece" d="M304.1 236.4l.7.7-.7-.7z" />
      <path fill="#185200" d="M304.9 236.4l.7.7-.8-.7z" />
      <path fill="#297b00" d="M308.4 236.4l.7.7-.7-.7z" />
      <path fill="#184a00" d="M309.8 236.4l.7.7-.7-.7z" />
      <path fill="#314231" d="M312.6 236.4l.7.7-.7-.7z" />
      <path fill="#319400" d="M313.3 236.4l.7.7-.7-.7z" />
      <path fill="#294221" d="M314 236.4l.7.7-.7-.7z" />
      <path fill="#efefef" d="M196.5 237.1l.7.7-.7-.7z" />
      <path fill="#214210" d="M197.2 237.1l.7.7-.7-.7z" />
      <path fill="#295200" d="M199.6 237.6l.2.4-.2-.4z" />
      <path fill="#294200" d="M201.4 237.1l.7.7-.7-.7z" />
      <path fill="#397b00" d="M203.3 237.3l.5.3-.5-.3z" />
      <path fill="#294200" d="M205.7 237.1l.7.7-.7-.7z" />
      <path fill="#315221" d="M206.8 237.3l.5.3-.5-.3z" />
      <path fill="#294200" d="M207.8 237.1l.7.7-.7-.7z" />
      <path fill="#8c8442" d="M208.5 237.1l.7.7-.7-.7z" />
      <path fill="#63636b" d="M209.2 237.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M209.9 237.1l.7.7-.7-.7z" />
      <path
        fill="#003994"
        d="M228.9 237.1c0 5-2.5 18.3.7 22.3 1.4 1.8 4.9 2 7 2.5 0-10.3 2-18.4-7.7-24.8z"
      />
      <path fill="#101829" d="M229.6 237.1l.7.7-.7-.7z" />
      <path fill="#100808" d="M231 237.1l.7.7-.7-.7z" />
      <path fill="#001039" d="M231.7 237.1l.7.7-.7-.7z" />
      <path fill="#00216b" d="M236.6 237.1l.7.7-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#001010" d="M243 237.1l.6.7-.7-.7z" />
      <path fill="#00184a" d="M244.3 237.1l.7.7-.7-.7z" />
      <path fill="#941808" d="M263.4 237.1l.7.7-.8-.7z" />
      <path fill="#211800" d="M263.4 238.5l2-1.4-2 1.4z" />
      <path fill="#ce2110" d="M265.5 237.1l.7.7-.7-.7z" />
      <path fill="#b51010" d="M269 237.1l.7.7-.7-.7z" />
      <path fill="#00216b" d="M271 237.1l.8.7-.7-.7z" />
      <path fill="#5a1831" d="M276 237.1l.7.7-.7-.7z" />
      <path fill="#311000" d="M276.7 237.1l.7.7-.7-.7z" />
      <path fill="#001010" d="M278.1 237.1l.7.7-.7-.7z" />
      <path
        fill="#003994"
        d="M271.8 261.9c2.3-.6 5.6-.8 7.3-2.5 3.6-3.6 1.1-17.4 1.1-22.3-11 4.9-8.4 15-8.4 24.8z"
      />
      <path fill="#dedede" d="M297.1 237.1l.7.7-.7-.7z" />
      <path fill="#185200" d="M297.8 237.1l.7.7-.7-.7z" />
      <path
        fill="#319400"
        d="M298.5 237.1l5.6 21.4h-.7c-1-3.7-5.5-18-11.2-12.7 7.5.3 10 13.1 11.2 18.8h.7l9.2-26.8h-.7l-7 17.4h-.8c-1.9-5.7-1.7-13.7-6.3-18z"
      />
      <path fill="#296300" d="M299.2 237.1l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M300 237.1l.6.7-.7-.7z" />
      <path fill="#dedede" d="M300.6 237.1l.7.7-.7-.7z" />
      <path fill="#185200" d="M301.3 237.1l.7.7-.7-.7z" />
      <path fill="#184a00" d="M302.7 237.1l.7.7-.7-.7z" />
      <path fill="#dedede" d="M303.4 237.1l.8.7-.8-.7z" />
      <path fill="#8c8c8c" d="M304.1 237.1l-.7 1.4.8-1.4z" />
      <path fill="#297b00" d="M304.9 237.1l.7.7-.8-.7z" />
      <path fill="#395231" d="M307.7 237.1l.7.7-.7-.7z" />
      <path fill="#4a6342" d="M309.8 237.1l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M311.9 237.1l.7.7-.7-.7z" />
      <path fill="#297b00" d="M313 237.3l.5.3-.4-.3z" />
      <path fill="#8c8c8c" d="M314 237.1l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M196.5 237.8l.7.7-.7-.7z" />
      <path fill="#295200" d="M201.4 237.8l.7.7-.7-.7z" />
      <path fill="#294200" d="M202.8 237.8l.7.7-.7-.7z" />
      <path fill="#397b00" d="M204.3 237.8l-2.9.7v.6l2.8-1.3z" />
      <path fill="#103900" d="M205 237.8l.7.7-.7-.7z" />
      <path fill="#397b00" d="M208.7 238.2l.2.5-.2-.5z" />
      <path fill="#428c00" d="M209.2 237.8l.7.7-.7-.7z" />
      <path fill="#294200" d="M209.9 237.8l.7.7-.7-.7z" />
      <path fill="#313931" d="M210.6 237.8l.7.7-.7-.7z" />
      <path fill="#001039" d="M230.3 237.8l.7.7-.7-.7z" />
      <path fill="#181000" d="M231.7 237.8l.7.7-.7-.7z" />
      <path fill="#00216b" d="M232.4 237.8l1.4 1.3-1.4-1.3m5 0l.6.7-.7-.7z" />
      <path fill="#181000" d="M238.7 237.8l2.1 2-2-2z" />
      <path fill="#002984" d="M239.4 237.8l.7.7-.7-.7z" />
      <path fill="#211800" d="M244.1 238l.5.2-.5-.2z" />
      <path fill="#002984" d="M245 237.8l.8.7-.7-.7z" />
      <path fill="#dedede" d="M249.3 237.8l.7.7-.7-.7z" />
      <path fill="#ada584" d="M250 237.8l.7.7-.7-.7z" />
      <path fill="#9c7b08" d="M252.8 237.8l.7.7-.7-.7z" />
      <path fill="#cea508" d="M254.9 237.8l.7.7-.7-.7z" />
      <path fill="#9c9463" d="M255.6 237.8l.7.7-.7-.7z" />
      <path fill="#bdb584" d="M256.3 237.8v.7h2.1l-2-.7z" />
      <path fill="#bdbdbd" d="M258.4 237.8l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M262.6 237.8l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M264.8 237.8l.6.7-.6-.7z" />
      <path fill="#bd2110" d="M268.3 237.8l.7.7-.7-.7z" />
      <path fill="#210800" d="M269 237.8l.7.7-.7-.7z" />
      <path fill="#392100" d="M269.7 237.8l-1.4 2 1.4-2z" />
      <path fill="#00184a" d="M270.4 237.8l.7.7-.7-.7z" />
      <path fill="#002984" d="M275.3 237.8l.7.7-.7-.7z" />
      <path fill="#100808" d="M276 237.8l.7.7-.7-.7z" />
      <path fill="#101829" d="M277.4 237.8l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M294.3 237.8l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M295 237.8l.7.7-.7-.7z" />
      <path fill="#315221" d="M297.8 237.8l.7.7-.7-.7z" />
      <path fill="#103910" d="M300 237.8l.6.7-.7-.7z" />
      <path fill="#efefef" d="M300.6 237.8l.7.7-.7-.7z" />
      <path fill="#184a00" d="M301.3 237.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M302.7 237.8l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M304.1 237.8l.7.7-.7-.7z" />
      <path fill="#294221" d="M307 237.8l.7.7-.7-.7z" />
      <path fill="#185200" d="M307.7 237.8l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M309.8 237.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M311.2 237.8l.7.7-.7-.7z" />
      <path fill="#184a00" d="M311.9 237.8l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#efefef" d="M314 237.8l.7.7-.7-.7z" />
      <path fill="#5a5231" d="M196.5 238.5l.7.6-.7-.6z" />
      <path
        fill="#294200"
        d="M199.3 238.5v2h.7l-.7-2m5 0l.6.6-.7-.6m3.3.2l.5.2-.5-.2z"
      />
      <path fill="#214210" d="M209.2 238.5l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M209.9 238.5l.7.6-.7-.6z" />
      <path fill="#00215a" d="M231 238.5l.7.6-.7-.6z" />
      <path fill="#211800" d="M231.7 238.5v.6l2.1.7-2.1-1.3z" />
      <path fill="#00216b" d="M238 238.5l.7.6-.7-.6z" />
      <path fill="#002984" d="M240.1 238.5l.7.6-.7-.6z" />
      <path fill="#00216b" d="M243.7 238.5l.7.6-.8-.6z" />
      <path fill="#392100" d="M244.3 238.5l2.2 2-2.1-2z" />
      <path fill="#101810" d="M245 238.5l.8.6-.7-.6z" />
      <path fill="#bd9408" d="M250 238.5v2h.7l-.7-2z" />
      <path fill="#310000" d="M262.6 238.5l.7.6-.7-.6z" />
      <path fill="#392100" d="M263.4 238.5l-.7 1.3.7-1.3z" />
      <path fill="#631808" d="M264 238.5l.8.6-.8-.6z" />
      <path fill="#ce2110" d="M267.6 238.5l-.7 1.3.7-1.3z" />
      <path fill="#311000" d="M268.3 238.5l.7.6-.7-.6z" />
      <path fill="#001039" d="M269.7 238.5l.7.6-.7-.6z" />
      <path fill="#00216b" d="M274.6 238.5l-.7 1.3.7-1.3z" />
      <path fill="#181000" d="M275.3 238.5l.7.6-.7-.6z" />
      <path fill="#001039" d="M276.7 238.5l.7.6-.7-.6z" />
      <path fill="#101810" d="M295 238.5l.7.6-.7-.6z" />
      <path fill="#efefef" d="M295.7 238.5l.7.6-.7-.6z" />
      <path fill="#63636b" d="M297.8 238.5l.7.6-.7-.6z" />
      <path fill="#297b00" d="M300 238.5l.6.6-.7-.6z" />
      <path fill="#7b7373" d="M300.6 238.5l.7.6-.7-.6z" />
      <path fill="#315221" d="M301.3 238.5l.7.6-.7-.6z" />
      <path fill="#214210" d="M303.4 238.5l.8.6-.8-.6z" />
      <path fill="#103900" d="M304.1 238.5l.7.6-.7-.6z" />
      <path fill="#184a00" d="M307 238.5v4h.7l-.7-4z" />
      <path fill="#297b00" d="M307.7 238.5l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M309.8 238.5l.7.6-.7-.6z" />
      <path fill="#63636b" d="M311.2 238.5l.7.6-.7-.6z" />
      <path fill="#297b00" d="M311.9 238.5l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M313.3 238.5l.7.6-.7-.6z" />
      <path
        fill="#294200"
        d="M196.5 239.1l.7.7-.7-.7m5.6 0l.7.7-.7-.7m1.4 0l.7.7-.7-.7z"
      />
      <path fill="#103900" d="M206.4 239.1l.7.7-.7-.7z" />
      <path fill="#397b00" d="M207 239.1l.8.7-.7-.7z" />
      <path fill="#294200" d="M208.5 239.1l.7.7-.7-.7z" />
      <path fill="#cecece" d="M209.2 239.1l.7.7-.7-.7z" />
      <path fill="#00216b" d="M231.7 239.1l.7.7-.7-.7z" />
      <path fill="#001039" d="M233.8 239.1l1.4 1.4-1.4-1.4z" />
      <path fill="#00184a" d="M238.7 239.1l.7.7-.7-.7z" />
      <path fill="#392100" d="M239.4 239.1l5.7 5.4-5.7-5.4z" />
      <path fill="#001039" d="M244.3 239.1l.7.7-.7-.7m1.4 0l.8.7-.7-.7z" />
      <path fill="#631808" d="M262 239.1l.6.7-.7-.7z" />
      <path fill="#311000" d="M263.4 239.1l.7.7-.8-.7m4.3 0l.7.7-.7-.7z" />
      <path fill="#001039" d="M269 239.1l.7.7-.7-.7z" />
      <path fill="#211800" d="M273.9 240.5l2.1-.7-2.1.7z" />
      <path fill="#00215a" d="M276 239.1l.7.7-.7-.7z" />
      <path fill="#103900" d="M295 239.1l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M295.7 239.1l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M297.8 239.1l.7.7-.7-.7z" />
      <path fill="#297b00" d="M298.5 239.1l.7.7-.7-.7z" />
      <path fill="#295210" d="M300.6 239.1l.7.7-.7-.7z" />
      <path fill="#395231" d="M301.3 239.1l.7.7-.7-.7z" />
      <path fill="#297b00" d="M303.4 239.1l.8.7-.8-.7z" />
      <path fill="#185200" d="M304.1 239.1l.7.7-.7-.7z" />
      <path fill="#297b00" d="M309 239.1l.8.7-.7-.7z" />
      <path fill="#9c9494" d="M309.8 239.1l.7.7-.7-.7z" />
      <path fill="#dedede" d="M310.5 239.1l.7.7-.7-.7z" />
      <path fill="#184a00" d="M311.2 239.1l.7.7-.7-.7z" />
      <path fill="#296300" d="M312.6 239.1l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M313.3 239.1l.7.7-.7-.7z" />
      <path fill="#cecece" d="M195.8 239.8l.7.7-.7-.7z" />
      <path fill="#397b00" d="M196.5 239.8l.7.7-.7-.7z" />
      <path fill="#295200" d="M202.1 239.8l.7.7-.7-.7z" />
      <path fill="#103900" d="M202.8 239.8l-.7 2h.8v-2m2.8 0l-.7 1.3.7-1.3z" />
      <path fill="#397b00" d="M207.8 239.8l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M208.5 239.8l.7.7-.7-.7m2.8 0l.7.7-.7-.7z" />
      <path fill="#002984" d="M232.4 239.8l.7.7-.7-.7z" />
      <path fill="#392100" d="M233.8 239.8l2.8 2.7-2.8-2.7z" />
      <path fill="#001039" d="M239.4 239.8l.7.7-.7-.7z" />
      <path fill="#001010" d="M240.8 239.8l.7.7-.7-.7z" />
      <path fill="#101810" d="M245 239.8l.8.7-.7-.7z" />
      <path fill="#00216b" d="M246.5 239.8l.7.7-.7-.7z" />
      <path fill="#b51010" d="M261.2 239.8l.7.7-.7-.7z" />
      <path fill="#211800" d="M261.2 241.1l2.2-.6-2.2.6z" />
      <path fill="#bd2110" d="M263.4 239.8l.7.7-.8-.7z" />
      <path fill="#310000" d="M266.9 239.8l.7.7-.7-.7z" />
      <path fill="#422100" d="M267.6 239.8l.7.7-.7-.7z" />
      <path fill="#101829" d="M268.3 239.8l.7.7-.7-.7z" />
      <path fill="#001039" d="M273.2 239.8l-.7 1.3.7-1.3z" />
      <path fill="#181000" d="M274.6 239.8l-.7 1.3.7-1.3z" />
      <path fill="#00216b" d="M275.3 239.8l.7.7-.7-.7z" />
      <path fill="#426331" d="M295 239.8l.7.7-.7-.7z" />
      <path fill="#214210" d="M295.7 239.8l.7.7-.7-.7z" />
      <path fill="#efefef" d="M296.4 239.8l.7.7-.7-.7z" />
      <path fill="#103900" d="M298.5 239.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M300.6 239.8l.7.7-.7-.7z" />
      <path fill="#001000" d="M301.3 239.8l.7.7-.7-.7z" />
      <path fill="#103900" d="M304.1 239.8l.7.7-.7-.7z" />
      <path fill="#296300" d="M309 239.8l.8.7-.7-.7z" />
      <path fill="#bdbdbd" d="M309.8 239.8l.7.7-.7-.7z" />
      <path fill="#63636b" d="M310.5 239.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M311.2 239.8l.7.7-.7-.7z" />
      <path fill="#315221" d="M312.6 239.8l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M196 241l.3.4-.3-.5z" />
      <path fill="#295200" d="M199.3 240.5l.7.6-.7-.6z" />
      <path fill="#397b00" d="M201.7 241l.2.4-.2-.5m1.1-.4l.7.6-.7-.6z" />
      <path fill="#425242" d="M207.8 240.5l.7.6-.7-.6z" />
      <path fill="#001000" d="M211.3 240.5l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M212 240.5l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M217.6 240.5l.7.6-.7-.6z" />
      <path fill="#52525a" d="M218.3 240.5l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M219 240.5l.7.6-.7-.6z" />
      <path fill="#001010" d="M233.8 240.5l.7.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#001039" d="M240.1 240.5l.7.6-.7-.6z" />
      <path fill="#001010" d="M241.5 240.5l.7.6-.7-.6z" />
      <path fill="#002984" d="M245 240.5l.8.6-.7-.6z" />
      <path fill="#211800" d="M246.2 240.7l.5.2-.5-.2z" />
      <path fill="#dedede" d="M249.3 240.5l.7.6-.7-.6z" />
      <path fill="#ada584" d="M250 240.5l.7.6-.7-.6z" />
      <path fill="#9c7b08" d="M252.8 240.5l.7.6-.7-.6z" />
      <path fill="#cea508" d="M254.9 240.5l.7.6-.7-.6z" />
      <path fill="#9c9463" d="M255.6 240.5l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M258.4 240.5l.7.6-.7-.6z" />
      <path fill="#ce2110" d="M260.5 240.5l.7.6-.7-.6z" />
      <path fill="#392100" d="M262 240.5l-1.5 2 1.4-2z" />
      <path fill="#941808" d="M262.6 240.5l.7.6-.7-.6z" />
      <path fill="#5a1008" d="M266.2 240.5l-1.4 2 1.4-2z" />
      <path fill="#392100" d="M266.9 240.5l-1.4 2 1.4-2z" />
      <path fill="#001010" d="M267.6 240.5l.7.6-.7-.6z" />
      <path fill="#392100" d="M273.2 240.5L271 243l2-2.6z" />
      <path fill="#002984" d="M274.6 240.5l.7.6-.7-.6z" />
      <path fill="#4a6342" d="M295 240.5l.7.6-.7-.6z" />
      <path fill="#297b00" d="M295.7 240.5l.7.6-.7-.6z" />
      <path fill="#52525a" d="M296.4 240.5l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M298.5 240.5l.7.6-.7-.6z" />
      <path fill="#103900" d="M301.3 240.5l.7.6-.7-.6z" />
      <path fill="#185200" d="M304.1 240.5l.7.6-.7-.6z" />
      <path fill="#297b00" d="M304.9 240.5l-.7 1.3.7-1.3z" />
      <path fill="#185200" d="M309 240.5l.8.6-.7-.6z" />
      <path fill="#dedede" d="M309.8 240.5l.7.6-.7-.6z" />
      <path fill="#184a00" d="M310.5 240.5l.7.6-.7-.6z" />
      <path fill="#297b00" d="M311.9 240.5l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M312.6 240.5l.7.6-.7-.6z" />
      <path fill="#cecece" d="M314.7 240.5l.7.6-.7-.6z" />
      <path fill="#294221" d="M315.4 240.5l.7.6-.7-.6z" />
      <path fill="#103900" d="M316.1 240.5l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M316.8 240.5l.7.6-.7-.6z" />
      <path fill="#397b00" d="M198.6 241.1v3.4h1.4V241h-1.4z" />
      <path fill="#103900" d="M204.3 241.1l.6.7-.7-.7z" />
      <path fill="#295200" d="M207 241.1l.8.7-.7-.7z" />
      <path fill="#bdbdbd" d="M207.8 241.1l.7.7-.7-.7z" />
      <path fill="#efefef" d="M210.6 241.1l.7.7-.7-.7z" />
      <path fill="#295200" d="M211.3 241.1l1.4 1.4-1.4-1.4z" />
      <path fill="#425242" d="M212 241.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M216.2 241.1l.7.7-.7-.7z" />
      <path fill="#5a5231" d="M217 241.1l.6.7-.7-.7z" />
      <path fill="#397b00" d="M217.6 241.1l.7.7-.7-.7z" />
      <path fill="#396b10" d="M218.3 241.1l.7.7-.7-.7z" />
      <path fill="#efefef" d="M219 241.1l.7.7-.7-.7z" />
      <path fill="#001039" d="M234.5 241.1l.7.7-.7-.7z" />
      <path fill="#181000" d="M236 241.1l1.3 1.4-1.4-1.4z" />
      <path fill="#002984" d="M236.6 241.1l.7.7-.7-.7z" />
      <path fill="#52525a" d="M240.8 241.1l.7.7-.7-.7z" />
      <path fill="#001010" d="M242.2 241.1l.7.7-.7-.7z" />
      <path fill="#00184a" d="M245.8 241.1l.7.7-.7-.7z" />
      <path fill="#392100" d="M246.5 241.1l1.4 1.4-1.4-1.4z" />
      <path fill="#001010" d="M247.2 241.1l.7.7-.7-.7z" />
      <path fill="#7b5a00" d="M252.8 241.1v7.4h.7l-.7-7.4z" />
      <path fill="#420000" d="M260.5 241.1l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M262 241.1l.6.7-.7-.7z" />
      <path fill="#313931" d="M266.9 241.1l.7.7-.7-.7z" />
      <path fill="#314a7b" d="M267.6 241.1l.7.7-.7-.7z" />
      <path fill="#001010" d="M271.8 241.1l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M295 241.1l.7.7-.7-.7z" />
      <path fill="#319400" d="M295.7 241.1l3.5 6h.7l-4.2-6z" />
      <path fill="#296300" d="M296.4 241.1l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M297.1 241.1l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M298.5 241.1l.7.7-.7-.7z" />
      <path fill="#297b00" d="M299.2 241.1l.7.7-.7-.7z" />
      <path fill="#296300" d="M301.3 241.1l1.4 1.4-1.4-1.4z" />
      <path fill="#297b00" d="M302 241.1l.7.7-.7-.7z" />
      <path fill="#184a00" d="M304.9 241.1l.7.7-.8-.7z" />
      <path fill="#214210" d="M309 241.1l.8.7-.7-.7z" />
      <path fill="#63636b" d="M309.8 241.1l.7.7-.7-.7z" />
      <path fill="#297b00" d="M310.5 241.1l.7.7-.7-.7z" />
      <path fill="#185200" d="M311.9 241.1l.7.7-.7-.7z" />
      <path fill="#dedede" d="M312.6 241.1l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M314 241.1l.7.7-.7-.7z" />
      <path fill="#184a00" d="M314.7 241.1l.7.7-.7-.7z" />
      <path fill="#319400" d="M311.2 245.8l7-2-1.4-2.7-5.6 4.7z" />
      <path fill="#214210" d="M316.8 241.1l.7.7-.7-.7z" />
      <path fill="#cecece" d="M317.5 241.1l.7.7-.7-.7m-121.7.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M196.5 241.8l.7.7-.7-.7z" />
      <path fill="#294200" d="M201.7 242.3l.2.4-.2-.5m1.8-.4l.7.7-.7-.7z" />
      <path fill="#397b00" d="M204.3 241.8l.6.7-.7-.7z" />
      <path fill="#425242" d="M207 241.8l.8.7-.7-.7z" />
      <path fill="#bdbdbd" d="M210.6 241.8l.7.7-.7-.7z" />
      <path fill="#397b00" d="M211.3 241.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M212.7 241.8l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M215.5 241.8l.7.7-.7-.7z" />
      <path fill="#295200" d="M216.2 241.8l.7.7-.7-.7z" />
      <path
        fill="#428c00"
        d="M214.1 251.8h-.7v-7.3h-.7l-.7 3.3h-.7v-3.3h-.7l-4.2 15.4h.7l1.4-2.7h.7l-1.4 3.4h.7l3.5-4.7-2.8 6h.7l7-10 1.4-10c-4.6 2-4.2 5.6-4.2 10z"
      />
      <path fill="#63636b" d="M218.3 241.8l.7.7-.7-.7z" />
      <path fill="#001039" d="M235.2 241.8l.7.7-.7-.7z" />
      <path fill="#00216b" d="M237.3 241.8l1.4 1.3-1.4-1.3z" />
      <path fill="#efefef" d="M240.8 241.8l2.1 2-2-2z" />
      <path fill="#313931" d="M241.5 241.8l.7.7-.7-.7z" />
      <path fill="#001039" d="M243 241.8l.6.7-.7-.7z" />
      <path fill="#101829" d="M246.5 241.8l.7.7-.7-.7z" />
      <path d="M247.9 241.8l.7.7-.7-.7z" />
      <path fill="#210800" d="M259.8 241.8l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M262 241.8l.6.7-.7-.7z" />
      <path fill="#292921" d="M266.2 241.8l.7.7-.7-.7z" />
      <path fill="#efefef" d="M266.9 241.8l.7.7-.7-.7z" />
      <path fill="#002984" d="M270.4 241.8l.7.7-.7-.7z" />
      <path fill="#181000" d="M271 241.8l.8.7-.7-.7z" />
      <path fill="#001039" d="M272.5 241.8l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M295.2 242.3l.3.4-.3-.5z" />
      <path fill="#297b00" d="M295.7 241.8l.7.7-.7-.7z" />
      <path fill="#103910" d="M297.1 241.8l.7.7-.7-.7z" />
      <path fill="#efefef" d="M297.8 241.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M298.5 241.8l.7.7-.7-.7z" />
      <path fill="#185200" d="M299.2 241.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M301.3 241.8l.7.7-.7-.7z" />
      <path fill="#103900" d="M304.9 241.8l.7.7-.8-.7z" />
      <path fill="#294221" d="M309 241.8l.8.7-.7-.7z" />
      <path fill="#184a00" d="M309.8 241.8l.7.7-.7-.7z" />
      <path fill="#425242" d="M311.9 241.8l.7.7-.7-.7z" />
      <path fill="#63636b" d="M313.3 241.8l-1.4 2 1.4-2z" />
      <path fill="#297b00" d="M314 241.8l.7.7-.7-.7z" />
      <path fill="#425242" d="M317.5 241.8l.7.7-.7-.7z" />
      <path fill="#396b10" d="M196.5 242.5l.7.6-.7-.6z" />
      <path fill="#295200" d="M202.8 242.5l.7.6-.7-.6z" />
      <path fill="#397b00" d="M203.6 242.5l.7.6-.8-.6z" />
      <path fill="#314231" d="M206.4 242.5l.7.6-.7-.6z" />
      <path fill="#efefef" d="M207 242.5l-.6 1.3.7-1.3z" />
      <path fill="#7b7373" d="M210.6 242.5l.7.6-.7-.6z" />
      <path fill="#428c00" d="M211.8 242.7l.4.2-.4-.2z" />
      <path fill="#7b7373" d="M212.7 242.5l.7.6-.7-.6z" />
      <path fill="#63636b" d="M214.8 242.5l-.7 1.3.7-1.3z" />
      <path fill="#397b00" d="M215.5 242.5l.7.6-.7-.6m2.1 0l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M218.3 242.5l.7.6-.7-.6z" />
      <path fill="#00216b" d="M236 242.5l.6.6-.7-.6z" />
      <path fill="#211800" d="M237 242.7l.6.2-.5-.2z" />
      <path fill="#313931" d="M242.2 242.5l.7.6-.7-.6z" />
      <path fill="#001039" d="M243.7 242.5l.7.6-.8-.6z" />
      <path fill="#181000" d="M247.2 242.5l.7.6-.7-.6z" />
      <path fill="#211800" d="M248.1 243l.2.4-.2-.5z" />
      <path fill="#bdbdbd" d="M248.6 242.5l.7.6-.7-.6z" />
      <path fill="#dedede" d="M259.1 242.5l.7.6-.7-.6z" />
      <path fill="#b51010" d="M261.2 242.5l.7.6-.7-.6z" />
      <path fill="#941808" d="M264 242.5l-1.3 2 1.4-2z" />
      <path fill="#211800" d="M264.8 242.5l-3.6 4 3.6-4z" />
      <path fill="#212118" d="M265.5 242.5l-.7 1.3.7-1.3z" />
      <path fill="#cecece" d="M266.2 242.5l-1.4 2 1.4-2z" />
      <path fill="#00216b" d="M269.7 242.5l-.7 1.3.7-1.3z" />
      <path fill="#181000" d="M270.4 242.5l.7.6-.7-.6z" />
      <path fill="#001039" d="M271.8 242.5l.7.6-.7-.6z" />
      <path fill="#cecece" d="M293.6 242.5l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M294.3 242.5l.7.6-.7-.6z" />
      <path fill="#296300" d="M295.7 242.5l.7.6-.7-.6z" />
      <path fill="#297b00" d="M297.1 242.5l.7.6-.7-.6z" />
      <path fill="#52525a" d="M297.8 242.5l.7.6-.7-.6z" />
      <path fill="#395231" d="M299.2 242.5l.7.6-.7-.6z" />
      <path fill="#184a00" d="M302 242.5v2h.7l-.7-2z" />
      <path fill="#296300" d="M305.3 242.7l.5.2-.5-.2m1.7-.2l.7.6-.7-.6z" />
      <path fill="#001000" d="M309 242.5l.8.6-.7-.6z" />
      <path fill="#297b00" d="M309.8 242.5l.7.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M311.9 242.5l.7.6-.7-.6z" />
      <path fill="#297b00" d="M313.3 242.5l.7.6-.7-.6z" />
      <path fill="#296300" d="M317.5 242.5l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M318.2 242.5l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M196.5 243.1l.7.7-.7-.7z" />
      <path fill="#397b00" d="M200.7 243.1v.7h2.1l-2-.7z" />
      <path fill="#294200" d="M202.8 243.1l.7.7-.7-.7z" />
      <path fill="#295200" d="M205 243.1l.7.7-.7-.7z" />
      <path fill="#52525a" d="M205.7 243.1l.7.7-.7-.7z" />
      <path fill="#efefef" d="M209.9 243.1l.7.7-.7-.7z" />
      <path fill="#214210" d="M210.6 243.1l.7.7-.7-.7z" />
      <path fill="#397b00" d="M210.6 243.8v.7l2 .6v-2l-2 .7z" />
      <path fill="#5a5231" d="M212.7 243.1l.7.7-.7-.7z" />
      <path fill="#397b00" d="M214.8 243.1l.7.7-.7-.7z" />
      <path fill="#295200" d="M217.4 243.4l.4.2-.4-.2z" />
      <path fill="#dedede" d="M218.3 243.1l.7.7-.7-.7z" />
      <path fill="#424242" d="M236.6 243.1l.7.7-.7-.7z" />
      <path fill="#212118" d="M237.3 243.1l.7.7-.7-.7z" />
      <path fill="#392100" d="M238 243.1l2.8 2.7-2.8-2.7z" />
      <path fill="#001039" d="M238.7 243.1l.7.7-.7-.7z" />
      <path fill="#292921" d="M243 243.1l.6.7-.7-.7z" />
      <path fill="#001039" d="M244.3 243.1l.7.7-.7-.7z" />
      <path fill="#00216b" d="M247.2 243.1l.7.7-.7-.7z" />
      <path fill="#211810" d="M248.6 243.1l.7.7-.7-.7z" />
      <path fill="#efefef" d="M249.3 243.1l.7.7-.7-.7z" />
      <path fill="#313931" d="M259.1 243.1l.7.7-.7-.7z" />
      <path fill="#392100" d="M259.8 243.1l-.7 1.4.7-1.4z" />
      <path fill="#631808" d="M260.5 243.1l.7.7-.7-.7z" />
      <path fill="#211800" d="M270.1 243.4l.5.2-.5-.2z" />
      <path fill="#313931" d="M271 243.1l.8.7-.7-.7z" />
      <path fill="#63636b" d="M292.9 243.1l.7.7-.7-.7z" />
      <path fill="#185200" d="M293.6 243.1l.7.7-.7-.7z" />
      <path fill="#297b00" d="M294.3 243.1l.7.7-.7-.7z" />
      <path fill="#295210" d="M295 243.1l.7.7-.7-.7z" />
      <path fill="#103900" d="M295.7 243.1l.7.7-.7-.7z" />
      <path fill="#296300" d="M297.8 243.1l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M298.5 243.1l1.4 1.4-1.4-1.4z" />
      <path fill="#8c8c8c" d="M299.2 243.1l.7.7-.7-.7z" />
      <path fill="#103900" d="M305.6 243.1l.7.7-.7-.7z" />
      <path fill="#297b00" d="M308.4 243.1l1.4 1.4-1.4-1.4z" />
      <path fill="#184a00" d="M309 243.1l.8.7-.7-.7z" />
      <path fill="#214210" d="M311.2 243.1l.7.7-.7-.7z" />
      <path
        fill="#297b00"
        d="M312.6 243.1l.7.7-.7-.7m1.4 0l-4.2 2.7v.7l1.4.7 2.8-4z"
      />
      <path fill="#214210" d="M314.7 243.1l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M315.4 243.1l.7.7-.7-.7z" />
      <path fill="#214210" d="M316.1 243.1l.7.7-.7-.7z" />
      <path fill="#296300" d="M316.8 243.1l.7.7-.7-.7z" />
      <path fill="#294221" d="M318.2 243.1l-.7 1.4.7-1.4z" />
      <path fill="#bdbdbd" d="M196.5 243.8l.7.7-.7-.7z" />
      <path fill="#295200" d="M197.2 243.8l.7.7-.7-.7z" />
      <path fill="#103900" d="M200.7 243.8l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#397b00" d="M203.6 243.8l-.7 1.3.7-1.3z" />
      <path fill="#5a5231" d="M204.3 243.8l.6.7-.7-.7z" />
      <path fill="#bdbdbd" d="M205 243.8l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M209.9 243.8l.7.7-.7-.7z" />
      <path fill="#295200" d="M212.7 243.8l1.4 1.3-1.4-1.3z" />
      <path fill="#52525a" d="M213.4 243.8l.7.7-.7-.7z" />
      <path fill="#397b00" d="M214.1 243.8l.7.7-.7-.7z" />
      <path fill="#294200" d="M216.4 244.3l.3.4-.3-.4m1.2-.5v4.7h.7l-.7-4.7z" />
      <path fill="#8c8c8c" fillOpacity={0.5} d="M236.6 243.8v18h.7l-.7-18z" />
      <path fill="#cecece" d="M237.3 243.8l.7.7-.7-.7z" />
      <path fill="#211810" d="M238 243.8l.7.7-.7-.7z" />
      <path fill="#001039" d="M239.4 243.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M243 243.8l2 2-2-2z" />
      <path fill="#212118" d="M243.7 243.8l.7.7-.8-.7z" />
      <path fill="#00215a" d="M245 243.8l.8.7-.7-.7z" />
      <path fill="#001039" d="M247.9 243.8l.7.7-.7-.7z" />
      <path fill="#392100" d="M248.6 243.8l1.4 1.3-1.4-1.3z" />
      <path fill="#424242" d="M249.3 243.8l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M258.4 243.8l.7.7-.7-.7z" />
      <path fill="#310000" d="M259.8 243.8l.7.7-.7-.7z" />
      <path fill="#001039" d="M268.3 243.8l.7.7-.7-.7z" />
      <path fill="#392100" d="M269 243.8l-2.1 2.7 2-2.7z" />
      <path fill="#212118" d="M269.7 243.8l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M270.4 243.8l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M271 243.8v18h.8l-.7-18m21 0l.8.7-.7-.7z" />
      <path fill="#296300" d="M292.9 243.8l.7.7-.7-.7z" />
      <path fill="#185200" d="M295.7 243.8l.7.7-.7-.7z" />
      <path fill="#296300" d="M296.4 243.8l.7.7-.7-.7z" />
      <path fill="#214210" d="M298.5 243.8l.7.7-.7-.7z" />
      <path fill="#296300" d="M300 243.8l.6.7-.7-.7z" />
      <path fill="#184a00" d="M305.6 243.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M306.3 243.8l-.7 1.3.7-1.3z" />
      <path fill="#185200" d="M308.4 243.8l.7.7-.7-.7z" />
      <path fill="#314231" d="M314 243.8l-1.4 2 1.4-2z" />
      <path fill="#efefef" d="M314.7 243.8l-2.1 2.7 2.1-2.7z" />
      <path fill="#bdbdbd" d="M316.8 243.8l.7.7-.7-.7z" />
      <path fill="#185200" d="M318.2 243.8l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M319 243.8l.6.7-.7-.7z" />
      <path fill="#63636b" d="M197.2 244.5l.7.6-.7-.6z" />
      <path fill="#295200" d="M200.7 244.5l.7.6-.7-.6z" />
      <path fill="#397b00" d="M201.4 244.5l.7.6-.7-.6z" />
      <path fill="#63636b" d="M203.6 244.5l-.7 1.3.7-1.3z" />
      <path fill="#7b7373" d="M204.3 244.5l.6.6-.7-.6z" />
      <path fill="#8c8c8c" d="M205 244.5l.7.6-.7-.6z" />
      <path fill="#efefef" d="M205.7 244.5l.7.6-.7-.6m3.5 0l.7.6-.7-.6z" />
      <path fill="#214210" d="M209.9 244.5l.7.6-.7-.6z" />
      <path fill="#efefef" d="M238 244.5l1.4 1.3-1.4-1.3z" />
      <path fill="#313931" d="M238.7 244.5l.7.6-.7-.6z" />
      <path d="M240.1 244.5l.7.6-.7-.6z" />
      <path fill="#efefef" d="M240.8 244.5l.7.6-.7-.6z" />
      <path fill="#212118" d="M244.3 244.5l1.4 1.3-1.3-1.3z" />
      <path fill="#211800" d="M245 244.5l2.9 3.3-2.8-3.3z" />
      <path fill="#00216b" d="M245.8 244.5l.7.6-.7-.6z" />
      <path fill="#00184a" d="M247.9 244.5v2h.7l-.7-2z" />
      <path fill="#313931" d="M248.6 244.5l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M250 244.5l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M257.7 244.5l.7.6-.7-.6z" />
      <path fill="#211800" d="M258.7 245l.2.4-.2-.5z" />
      <path fill="#211810" d="M259.1 244.5l.7.6-.7-.6z" />
      <path fill="#b51010" d="M262 244.5l.6.6-.7-.6z" />
      <path fill="#9c9494" d="M264 244.5l-1.3 2 1.4-2z" />
      <path fill="#efefef" d="M266.9 244.5l-.7 1.3.7-1.3z" />
      <path fill="#292921" d="M267.6 244.5l.7.6-.7-.6z" />
      <path fill="#211810" d="M269 244.5l.7.6-.7-.6z" />
      <path fill="#cecece" d="M269.7 244.5l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M291.5 244.5l.7.6-.7-.6z" />
      <path fill="#185200" d="M292.2 244.5l.7.6-.7-.6z" />
      <path fill="#103900" d="M296.4 244.5l2.1 2-2-2z" />
      <path fill="#297b00" d="M297.1 244.5l.7.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#314231" d="M299.2 244.5l.7.6-.7-.6z" />
      <path fill="#185200" d="M300 244.5l.6.6-.7-.6m2.1 0l.7.6-.7-.6z" />
      <path fill="#297b00" d="M302.7 244.5l.7.6-.7-.6z" />
      <path fill="#296300" d="M306.3 244.5l.7.6-.7-.6z" />
      <path fill="#103900" d="M308.4 244.5l.7.6-.7-.6z" />
      <path fill="#185200" d="M310.5 244.5l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M318.2 244.5l.7.6-.7-.6z" />
      <path fill="#63636b" d="M319 244.5l.6.6-.7-.6z" />
      <path fill="#dedede" d="M197.2 245.2l.7.6-.7-.7z" />
      <path fill="#294200" d="M198 245.2l.6.6-.7-.7z" />
      <path fill="#397b00" d="M200.5 245.4l.5.2-.5-.2z" />
      <path fill="#295200" d="M202.1 245.2l.7.6-.7-.7z" />
      <path fill="#6b735a" d="M204.3 245.2l.6.6-.7-.7z" />
      <path fill="#295200" d="M205 245.2l.7.6-.7-.7z" />
      <path fill="#396b10" d="M205.7 245.2l.7.6-.7-.7z" />
      <path fill="#7b7373" d="M206.4 245.2l.7.6-.7-.7z" />
      <path fill="#efefef" d="M207 245.2l.8.6-.7-.7z" />
      <path fill="#8c8c8c" d="M209.2 245.2l.7.6-.7-.7z" />
      <path fill="#295200" d="M211.3 245.2l.7.6-.7-.7z" />
      <path fill="#294200" d="M213.4 245.2v6h.7l-.7-6z" />
      <path fill="#397b00" d="M216 245.4l.4.2-.4-.2z" />
      <path fill="#52525a" d="M239.4 245.2l.7.6-.7-.7z" />
      <path fill="#211810" d="M240.8 245.2l.7.6-.7-.7z" />
      <path fill="#cecece" d="M241.5 245.2l.7.6-.7-.7z" />
      <path fill="#00216b" d="M246.5 245.2l.7.6-.7-.7z" />
      <path fill="#cecece" d="M248.6 245.2l.7.6-.7-.7z" />
      <path fill="#392121" d="M249.3 245.2l.7.6-.7-.7z" />
      <path fill="#211800" d="M250 245.2l.7.6-.7-.7z" />
      <path fill="#cecece" d="M250.7 245.2l.7.6-.7-.7z" />
      <path fill="#efefef" d="M257 245.2l.7.6-.7-.7z" />
      <path fill="#211810" d="M257.7 245.2l.7.6-.7-.7z" />
      <path fill="#ada5a5" d="M259.1 245.2l.7.6-.7-.7z" />
      <path fill="#b51010" d="M261.2 245.2l.7.6-.7-.7z" />
      <path fill="#313931" d="M266.9 245.2l.7.6-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#efefef" d="M269 245.2l-.7 1.3.7-1.3z" />
      <path fill="#294221" d="M291.5 245.2l.7.6-.7-.7z" />
      <path fill="#297b00" d="M292.9 245.2l.7.6-.7-.7z" />
      <path fill="#185200" d="M293.6 245.2l.7.6-.7-.7z" />
      <path fill="#184a00" d="M294.3 245.2l.7.6-.7-.7z" />
      <path fill="#297b00" d="M297.8 245.2l.7.6-.7-.7z" />
      <path fill="#296300" d="M299.2 245.2l.7.6-.7-.7z" />
      <path fill="#103900" d="M300 245.2l.6.6-.7-.7z" />
      <path fill="#296300" d="M302.5 245.4l.5.2-.5-.2z" />
      <path fill="#184a00" d="M306.3 245.2l.7.6-.7-.7z" />
      <path fill="#297b00" d="M307.7 245.2l.7.6-.7-.7z" />
      <path fill="#185200" d="M308.4 245.2l.7.6-.7-.7z" />
      <path fill="#103900" d="M310.5 245.2l.7.6-.7-.7z" />
      <path fill="#9c9494" d="M315 245.6l.2.5-.3-.5z" />
      <path fill="#63636b" d="M198 245.8l.6.7-.7-.7z" />
      <path fill="#294200" d="M200.3 246.3l.2.4-.2-.4z" />
      <path fill="#8c8c8c" d="M202.1 245.8l.7.7-.7-.7m2.4.5l.2.4-.2-.4z" />
      <path fill="#397b00" d="M205.4 246l.5.3-.5-.3z" />
      <path fill="#428c00" d="M206.4 245.8l.7 6h.7l-1.4-6z" />
      <path fill="#315221" d="M207 245.8l.8.7-.7-.7z" />
      <path fill="#cecece" d="M207.8 245.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M208.5 245.8l.7.7-.7-.7z" />
      <path fill="#63636b" d="M240.1 245.8l.7.7-.7-.7z" />
      <path fill="#211800" d="M240.8 245.8l2.1 1.4v-.7l-2-.7z" />
      <path fill="#212118" d="M241.5 245.8l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M245 245.8l.8.7-.7-.7z" />
      <path fill="#002984" d="M247.2 245.8l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M249.3 245.8l.7.7-.7-.7z" />
      <path fill="#392100" d="M250 245.8l2 2-2-2z" />
      <path fill="#313931" d="M250.7 245.8l.7.7-.7-.7z" />
      <path fill="#efefef" d="M251.4 245.8l.7.7-.7-.7z" />
      <path fill="#424242" d="M257 245.8l.7.7-.7-.7z" />
      <path fill="#392100" d="M257.7 245.8l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M258.4 245.8l.7.7-.7-.7z" />
      <path fill="#b51010" d="M260.5 245.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M265.5 245.8l.7.7-.7-.7z" />
      <path fill="#211810" d="M266.2 245.8l.7.7-.7-.7z" />
      <path fill="#52525a" d="M267.6 245.8l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M290.8 245.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M291.5 245.8l.7.7-.7-.7z" />
      <path fill="#185200" d="M292.2 245.8l.7.7-.7-.7z" />
      <path fill="#63636b" d="M292.9 245.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M293.6 245.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M294.3 245.8l.7.7-.7-.7z" />
      <path fill="#214210" d="M295 245.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M297.1 245.8l.7.7-.7-.7z" />
      <path fill="#184a00" d="M300 245.8l.6.7-.7-.7z" />
      <path fill="#297b00" d="M302 245.8l.7.7-.7-.7z" />
      <path fill="#185200" d="M302.7 245.8l.7.7-.7-.7z" />
      <path fill="#103900" d="M306.3 245.8l.7.7-.7-.7z" />
      <path fill="#184a00" d="M307.7 245.8l.7.7-.7-.7z" />
      <path fill="#185200" d="M310.5 245.8l.7.7-.7-.7z" />
      <path fill="#293129" d="M311.9 245.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M313.3 245.8l.7.7-.7-.7z" />
      <path fill="#292921" d="M314 245.8l.7.7-.7-.7z" />
      <path fill="#424242" d="M195.1 246.5l1.4 1.3-1.4-1.3z" />
      <path fill="#dedede" d="M195.8 246.5l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M198 246.5l.6.7-.7-.7z" />
      <path fill="#292100" d="M198.6 246.5l.7.7-.7-.7z" />
      <path fill="#295200" d="M199.3 246.5l.7.7-.7-.7z" />
      <path fill="#315221" d="M201.4 246.5l.7.7-.7-.7z" />
      <path fill="#428c00" d="M205 246.5c-.2 3.6-1 6.7 2.8 8.7l-2.8-8.7z" />
      <path fill="#294200" d="M205.9 247l.2.4-.2-.5z" />
      <path fill="#214210" d="M207.8 246.5l.7.7-.7-.7z" />
      <path fill="#424242" d="M208.5 246.5l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M240.8 246.5l.7.7-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M245.8 246.5l.7.7-.7-.7z" />
      <path fill="#181000" d="M247.2 246.5l1.4 1.3-1.4-1.3z" />
      <path fill="#001039" d="M247.9 246.5l.7.7-.7-.7z" />
      <path fill="#52525a" d="M250 246.5l.7.7-.7-.7z" />
      <path fill="#63636b" d="M251.4 246.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M256.3 246.5l.7.7-.7-.7z" />
      <path fill="#211800" d="M257 246.5l.7.7-.7-.7z" />
      <path d="M257.7 246.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M258.4 246.5l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M259.1 246.5l-.7 2 .7-2z" />
      <path fill="#5a1008" d="M259.8 246.5l.7.7-.7-.7z" />
      <path fill="#210800" d="M260.5 246.5l.7.7-.7-.7z" />
      <path fill="#392100" d="M261.2 246.5l-.7 1.3.7-1.3z" />
      <path fill="#63636b" d="M262 246.5l.6.7-.7-.7z" />
      <path fill="#ada5a5" d="M264.8 246.5l.6.7-.6-.7z" />
      <path fill="#212118" d="M265.5 246.5l.7.7-.7-.7z" />
      <path fill="#211800" d="M266.2 246.5l-1.4 2 1.4-2z" />
      <path fill="#63636b" d="M266.9 246.5l.7.7-.7-.7z" />
      <path fill="#efefef" d="M290 246.5l.8.7-.7-.7z" />
      <path fill="#214210" d="M291.3 246.7l.4.2-.4-.2z" />
      <path fill="#9c9494" d="M292.2 246.5l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M295 246.5l.7.7-.7-.7z" />
      <path fill="#296300" d="M295.7 246.5l.7.7-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#185200" d="M298.5 246.5l.7.7-.7-.7m1.4 0l1.4 1.3-1.4-1.3z" />
      <path fill="#297b00" d="M300.6 246.5l.7.7-.7-.7z" />
      <path fill="#184a00" d="M302.7 246.5l.7.7-.7-.7m3.6 0l1.4 1.3-1.4-1.3z" />
      <path fill="#103900" d="M307.7 246.5l.7.7-.7-.7z" />
      <path fill="#184a00" d="M309.8 246.5l1.4 1.3-1.4-1.3z" />
      <path fill="#214210" d="M311.2 246.5l.7.7-.7-.7z" />
      <path fill="#cecece" d="M311.9 246.5l-.7 1.3.7-1.3z" />
      <path fill="#9c9494" d="M312.6 246.5l.7.7-.7-.7z" />
      <path fill="#184a00" d="M313.3 246.5l.7.7-.7-.7z" />
      <path fill="#294221" d="M314 246.5l.7.7-.7-.7z" />
      <path fill="#dedede" d="M317.5 246.5l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M318.2 246.5l.7.7-.7-.7z" />
      <path fill="#214210" d="M195.1 247.2l.7.6-.7-.6z" />
      <path fill="#efefef" d="M196.5 247.2l.7.6-.7-.6z" />
      <path fill="#5a1010" d="M198 247.2l.6.6-.7-.6z" />
      <path fill="#ce2110" d="M198.6 247.2l.7.6-.7-.6z" />
      <path fill="#bd2110" d="M199.3 247.2l.7.6-.7-.6z" />
      <path fill="#311000" d="M200 247.2l.7.6-.7-.6z" />
      <path fill="#397b00" d="M200.7 247.2l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M201.4 247.2l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M204.3 247.2l.6.6-.7-.6z" />
      <path fill="#295200" d="M208.5 247.2l-.7 1.3.7-1.3m2.8 0l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M241.5 247.2l.7.6-.7-.6z" />
      <path fill="#212118" d="M242.2 247.2l.7.6-.7-.6z" />
      <path fill="#392100" d="M243 247.2l2.7 2.6-2.8-2.6z" />
      <path fill="#63636b" d="M243.7 247.2l.7.6-.8-.6z" />
      <path fill="#bdbdbd" d="M246 247.6l.2.5-.2-.5z" />
      <path fill="#520808" d="M246.5 247.2l.7.6-.7-.6z" />
      <path fill="#cecece" d="M248.6 247.2l.7.6-.7-.6z" />
      <path fill="#efefef" d="M250 247.2l.7.6-.7-.6z" />
      <path fill="#392121" d="M250.7 247.2l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M252 247.2l.8.6-.7-.6z" />
      <path fill="#9c7b08" d="M254.9 247.2l.7.6-.7-.6z" />
      <path fill="#424242" d="M255.6 247.2l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M256.3 247.2l.7.6-.7-.6z" />
      <path fill="#cecece" d="M257 247.2l.7.6-.7-.6z" />
      <path d="M259.8 247.2l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M262.2 247.6l.2.5-.2-.5z" />
      <path fill="#9c9494" d="M264 247.2l.8.6-.8-.6m2.2 0l.7.6-.7-.6z" />
      <path fill="#63636b" d="M290 247.2l.8.6-.7-.6z" />
      <path fill="#425242" d="M290.8 247.2l.7.6-.7-.6z" />
      <path fill="#cecece" d="M291.5 247.2l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M295.7 247.2l.7.6-.7-.6z" />
      <path fill="#297b00" d="M296.4 247.2l.7.6-.7-.6z" />
      <path fill="#184a00" d="M298.5 247.2l.7.6-.7-.6z" />
      <path fill="#297b00" d="M298.5 248.5l2.1-.7-2 .7z" />
      <path fill="#103900" d="M302.7 247.2l.7.6-.7-.6z" />
      <path fill="#296300" d="M306.3 247.2v2h.7l-.7-2m1.4 0l.7.6-.7-.6z" />
      <path fill="#103900" d="M309.8 247.2l-.7 2 .7-2z" />
      <path fill="#8c8c8c" d="M311.9 247.2l.7.6-.7-.6z" />
      <path fill="#185200" d="M312.6 247.2l-.7 1.3.7-1.3z" />
      <path fill="#296300" d="M313.3 247.2l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M314 247.2l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M316.1 247.2l.7.6-.7-.6z" />
      <path fill="#424242" d="M316.8 247.2l.7.6-.7-.6z" />
      <path fill="#313931" d="M317.5 247.2l.7.6-.7-.6z" />
      <path fill="#efefef" d="M318.2 247.2l-1.4 2 1.4-2z" />
      <path fill="#295200" d="M195.1 247.8l.7.7-.7-.7z" />
      <path fill="#397b00" d="M195.8 247.8l.7.7-.7-.7z" />
      <path fill="#314231" d="M196.5 247.8l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M197.2 247.8l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M198 247.8l.6.7-.7-.7z" />
      <path fill="#941808" d="M200 247.8l.7.7-.7-.7z" />
      <path fill="#313931" d="M200.7 247.8l.7.7-.7-.7z" />
      <path fill="#526b42" d="M204.3 247.8l.6.7-.7-.7z" />
      <path fill="#397b00" d="M206.1 248l.5.3-.5-.3m2.4-.2l.7.7-.7-.7z" />
      <path fill="#295200" d="M210.6 247.8l.7.7-.7-.7z" />
      <path fill="#524242" d="M242.2 247.8l.7.7-.7-.7z" />
      <path fill="#210800" d="M243 247.8l.6.7-.7-.7z" />
      <path fill="#424242" d="M244.3 247.8l.7.7-.7-.7z" />
      <path fill="#efefef" d="M245 247.8l.8.7-.7-.7z" />
      <path fill="#ad1810" d="M246.7 248.3l.2.4-.2-.4z" />
      <path fill="#5a1008" d="M247.2 247.8l1.4 1.4-1.4-1.4z" />
      <path fill="#392100" d="M247.9 247.8l1.4 1.4-1.4-1.4z" />
      <path fill="#211810" d="M248.6 247.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M249.3 247.8l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M250.7 247.8l-.7 1.4.7-1.4z" />
      <path fill="#211800" d="M251.4 247.8l.7.7-.7-.7z" />
      <path fill="#212118" d="M252 247.8l.8.7-.7-.7z" />
      <path fill="#6b5a10" d="M254.2 247.8l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M254.9 247.8l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M256.3 247.8l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M257 247.8l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M257.7 247.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M259.1 247.8l.7.7-.7-.7z" />
      <path fill="#313931" d="M259.8 247.8l.7.7-.7-.7z" />
      <path fill="#de2110" d="M261.5 248.3l.2.4-.2-.4z" />
      <path fill="#63636b" d="M263.4 247.8l.7.7-.8-.7z" />
      <path fill="#392100" d="M264 247.8l-2 2.7 2-2.7z" />
      <path fill="#524242" d="M265.5 247.8l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M290 247.8l.8.7-.7-.7z" />
      <path fill="#bdbdbd" d="M293.6 247.8l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M294.3 247.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M295.7 247.8l-.7 1.4.7-1.4z" />
      <path fill="#214210" d="M296.4 247.8l.7.7-.7-.7z" />
      <path fill="#103900" d="M299.2 247.8l.7.7-.7-.7z" />
      <path fill="#319400" d="M300 247.8l.6.7-.7-.7z" />
      <path fill="#103900" d="M300.6 247.8l-.7 2 .7-2z" />
      <path fill="#184a00" d="M302.7 247.8l.7.7-.7-.7z" />
      <path fill="#082108" d="M307 247.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M309 247.8l.8.7-.7-.7z" />
      <path fill="#8c8c8c" d="M310.7 248.3l.2.4-.2-.4z" />
      <path fill="#63636b" d="M311.2 247.8l.7.7-.7-.7z" />
      <path fill="#319400" d="M312.6 247.8l-5 7.4 5-7.4z" />
      <path fill="#294221" d="M313.3 247.8l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M314.7 247.8l.7.7-.7-.7z" />
      <path fill="#425242" d="M315.4 247.8l.7.7-.7-.7z" />
      <path fill="#184a00" d="M316.1 247.8l.7.7-.7-.7z" />
      <path fill="#314231" d="M316.8 247.8l.7.7-.7-.7z" />
      <path fill="#294200" d="M195.1 248.5v1.3l1.4-1.3h-1.4z" />
      <path
        fill="#428c00"
        d="M196.5 248.5l1.4 2.7-2-1.4c.6 2.7 1.3 4.4 4.1 5.4v.7l-2.8-.7 1.4 2-2-.7 6.2 6 .7-2.6 2.2 1.3-4.3-4v-.7l2.1.7a12.3 12.3 0 0 0-7-8.7z"
      />
      <path fill="#294200" d="M197.2 248.5l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M198 248.5l.6.7-.7-.7z" />
      <path fill="#ce2110" d="M198.6 248.5l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M200 248.5l1.4 1.3-1.4-1.3z" />
      <path fill="#7b7373" d="M200.7 248.5l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M201.4 248.5l.7.7-.7-.7z" />
      <path fill="#294200" d="M204.3 248.5l.6.7-.7-.7z" />
      <path fill="#295200" d="M206.4 248.5l.7.7-.7-.7z" />
      <path fill="#294200" d="M207.8 248.5v6h.7l-.7-6m3 .5l.3.4-.3-.5z" />
      <path fill="#295200" d="M215.5 248.5l.7.7-.7-.7z" />
      <path fill="#527b31" d="M217.6 248.5l.7.7-.7-.7z" />
      <path
        fill="#734a42"
        fillOpacity={0.6}
        d="M242.2 248.5v14.7h.7l-.7-14.7z"
      />
      <path fill="#ce2110" d="M243 248.5l1.3 1.3-1.4-1.3z" />
      <path fill="#311000" d="M243.7 248.5l.7.7-.8-.7z" />
      <path fill="#313931" d="M245 248.5l.8.7-.7-.7z" />
      <path fill="#9c9494" d="M245.8 248.5l.7.7-.7-.7z" />
      <path fill="#de2110" d="M247.2 248.5v1.3h1.4l-1.4-1.3z" />
      <path fill="#313931" d="M249.3 248.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M250.7 248.5l.7.7-.7-.7z" />
      <path fill="#52525a" d="M251.4 248.5l.7.7-.7-.7z" />
      <path fill="#392121" d="M252 248.5l.8.7-.7-.7z" />
      <path fill="#423100" d="M252.8 248.5l.7.7-.7-.7z" />
      <path fill="#5a5231" d="M253.5 248.5l.7.7-.7-.7z" />
      <path fill="#cecece" d="M254.2 248.5l.7.7-.7-.7z" />
      <path fill="#dedede" d="M254.9 248.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M255.6 248.5l-.7 1.3.7-1.3z" />
      <path fill="#9c9494" d="M256.3 248.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M259.8 248.5l-2.8 1.3v.7l3.5-1.3-.7-.7z" />
      <path fill="#ada5a5" d="M262 248.5l.6.7-.7-.7z" />
      <path fill="#424242" d="M262.6 248.5l.7.7-.7-.7z" />
      <path fill="#210800" d="M264 248.5l.8.7-.8-.7z" />
      <path fill="#b51010" d="M264.8 248.5l.6.7-.6-.7z" />
      <path
        fill="#734a42"
        d="M265.5 248.5l-.7 15.4h.7a26.7 26.7 0 0 0 0-15.4z"
      />
      <path d="M294.3 248.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M296.4 248.5l.7.7-.7-.7z" />
      <path fill="#297b00" d="M297.1 248.5l.7.7-.7-.7z" />
      <path fill="#296300" d="M299.2 248.5l.7.7-.7-.7z" />
      <path fill="#185200" d="M300 248.5l.6.7-.7-.7z" />
      <path fill="#296300" d="M303.2 248.7l.5.2-.5-.2z" />
      <path fill="#103900" d="M307 248.5l.7.7-.7-.7z" />
      <path fill="#52525a" d="M309.8 248.5l.7.7-.7-.7z" />
      <path fill="#296300" d="M311.2 248.5l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M313.3 248.5l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M314 248.5l.7.7-.7-.7z" />
      <path fill="#185200" d="M314.7 248.5l.7.7-.7-.7z" />
      <path fill="#297b00" d="M315.4 248.5l-1.4.7v.6l1.4-1.3z" />
      <path fill="#52525a" d="M316.1 248.5l.7.7-.7-.7z" />
      <path fill="#397b00" d="M195.8 249.2l.7.6-.7-.6z" />
      <path fill="#295200" d="M196.5 249.2l.7.6-.7-.6z" />
      <path fill="#293100" d="M198.6 249.2l.7.6-.7-.6z" />
      <path fill="#311000" d="M199.3 249.2l.7.6-.7-.6z" />
      <path fill="#103900" d="M200 249.2l.7.6-.7-.6z" />
      <path fill="#941808" d="M201.4 249.2l.7.6-.7-.6z" />
      <path fill="#5a2121" d="M202.1 249.2l.7.6-.7-.6z" />
      <path fill="#cecece" d="M202.8 249.2l.7.6-.7-.6z" />
      <path fill="#dedede" d="M203.6 249.2l.7.6-.8-.6z" />
      <path fill="#295200" d="M204.3 249.2l.6.6-.7-.6z" />
      <path fill="#397b00" d="M215.3 249.4l.4.2-.4-.2z" />
      <path fill="#526b42" d="M217.6 249.2l.7.6-.7-.6z" />
      <path
        fill="#de2110"
        d="M243 249.2v14l7.7 1.4c-1.7-5-2.7-12.8-7.8-15.4z"
      />
      <path fill="#5a1008" d="M244.3 249.2l.7.6-.7-.6z" />
      <path fill="#100808" d="M245.8 249.2l.7.6-.7-.6z" />
      <path fill="#941808" d="M246.5 249.2l.7.6-.7-.6z" />
      <path fill="#310000" d="M248.6 249.2l.7.6-.7-.6z" />
      <path fill="#524242" d="M249.3 249.2l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M250.2 249.6l.2.5-.2-.5z" />
      <path fill="#efefef" d="M252.8 249.2l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M253.7 249.6l.3.5-.3-.5z" />
      <path fill="#bdbdbd" d="M254.2 249.2l.7.6-.7-.6z" />
      <path fill="#dedede" d="M257 249.2l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M259.8 249.2l.7.6-.7-.6z" />
      <path fill="#100808" d="M260.5 249.2l.7.6-.7-.6z" />
      <path fill="#bd2110" d="M261.2 249.2l.7.6-.7-.6z" />
      <path fill="#101810" d="M262 249.2l.6.6-.7-.6z" />
      <path fill="#311000" d="M263.4 249.2l.7.6-.8-.6z" />
      <path fill="#ce2110" d="M264 249.2l-.6 1.3.7-1.3z" />
      <path
        fill="#de2110"
        d="M264.8 249.2l-2.9 2 2.9 8.7-5 1.3.7 2.7 5-.7-.8-14z"
      />
      <path fill="#214210" d="M294.3 249.2l.7.6-.7-.6z" />
      <path fill="#425242" d="M295 249.2l.7.6-.7-.6z" />
      <path fill="#395231" d="M297.1 249.2l.7.6-.7-.6z" />
      <path fill="#184a00" d="M300.6 249.2l.7.6-.7-.6z" />
      <path fill="#297b00" d="M301.3 249.2l.7.6-.7-.6z" />
      <path fill="#184a00" d="M303.4 249.2v2h.8l-.8-2z" />
      <path fill="#185200" d="M306.3 249.2l.7.6-.7-.6z" />
      <path fill="#297b00" d="M307 249.2l.7.6-.7-.6z" />
      <path fill="#292921" d="M309 249.2l.8.6-.7-.6z" />
      <path fill="#bdbdbd" d="M309.8 249.2l.7.6-.7-.6z" />
      <path fill="#184a00" d="M310.5 249.2l.7.6-.7-.6z" />
      <path fill="#102110" d="M312.6 249.2l.7.6-.7-.6z" />
      <path fill="#314231" d="M313.3 249.2l.7.6-.7-.6z" />
      <path fill="#63636b" d="M314.7 249.8v.7h2.1l-2.1-.7z" />
      <path fill="#426331" d="M195.1 249.8l.7.7-.7-.7z" />
      <path fill="#294200" d="M196.5 249.8l.7.7-.7-.7z" />
      <path fill="#397b00" d="M197.2 249.8l.7.7-.7-.7z" />
      <path fill="#295200" d="M199.3 249.8l2.1 2-2-2z" />
      <path fill="#211800" d="M200 249.8l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M202.4 250.3l.2.4-.2-.4z" />
      <path fill="#7b7373" d="M203 250.3l.3.4-.2-.4z" />
      <path fill="#bdbdbd" d="M203.6 249.8l.7.7-.8-.7z" />
      <path fill="#397b00" d="M204.3 249.8l.6.7-.7-.7z" />
      <path fill="#295200" d="M210.6 249.8l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M217.6 249.8l.7.7-.7-.7z" />
      <path fill="#631808" d="M245 249.8l.8.7-.7-.7z" />
      <path fill="#211800" d="M245.8 249.8l1.4 1.4v-1.4h-1.4z" />
      <path fill="#631808" d="M247.2 249.8l.7.7-.7-.7z" />
      <path fill="#5a2121" d="M247.9 249.8l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M248.8 250.3l.2.4-.2-.4z" />
      <path fill="#8c8c8c" d="M250.7 249.8v.7h2l-2-.7z" />
      <path fill="#bdbdbd" d="M252.8 249.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M255.6 249.8l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M256.3 249.8l.7.7-.7-.7z" />
      <path fill="#efefef" d="M257.7 249.8l.7.7-.7-.7z" />
      <path fill="#313931" d="M260.5 249.8l.7.7-.7-.7z" />
      <path fill="#211800" d="M261.2 249.8l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M262.6 249.8l.7.7-.7-.7z" />
      <path fill="#4a6342" d="M294.3 249.8l.7.7-.7-.7z" />
      <path fill="#296300" d="M295 249.8l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M295.7 249.8l.7.7-.7-.7m1.6.5l.3.4-.3-.4z" />
      <path fill="#185200" d="M297.8 249.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M300 249.8l.6.7-.7-.7z" />
      <path fill="#082108" d="M300.6 249.8l.7.7-.7-.7z" />
      <path fill="#185200" d="M301.3 249.8l.7.7-.7-.7z" />
      <path fill="#184a00" d="M306.5 250.3l.2.4-.2-.4z" />
      <path fill="#296300" d="M308.4 249.8l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M309 249.8l.8.7-.7-.7z" />
      <path fill="#314231" d="M309.8 249.8l.7.7-.7-.7z" />
      <path fill="#185200" d="M311.9 249.8l.7.7-.7-.7z" />
      <path fill="#184a00" d="M312.6 249.8l.7.7-.7-.7z" />
      <path fill="#319400" d="M313.3 249.8l-.7 1.4.7-1.4z" />
      <path fill="#296300" d="M314 249.8l.7.7-.7-.7z" />
      <path fill="#efefef" d="M315.4 249.8l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M316.8 249.8l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M195.1 250.5l.7.7-.7-.7z" />
      <path fill="#103900" d="M197.2 250.5l.7.7-.7-.7z" />
      <path fill="#941808" d="M200.7 250.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M203.6 250.5l.7.7-.8-.7z" />
      <path fill="#397b00" d="M210.3 250.7l.5.3-.5-.3z" />
      <path fill="#8c8c8c" d="M217.6 250.5l.7.7-.7-.7z" />
      <path fill="#941808" d="M245.8 250.5l.7.7-.7-.7z" />
      <path d="M247.2 250.5l3.5 13.4c4.3-1.5 10.9-2 13.4-6l-12.7 4-4.2-11.4z" />
      <path fill="#ada5a5" d="M247.9 250.5l.7.7-.7-.7z" />
      <path fill="#63636b" d="M249.3 250.5l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M250 250.5l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M253.5 250.5l.7.7-.7-.7z" />
      <path fill="#cecece" d="M254.2 250.5l.7.7-.7-.7z" />
      <path fill="#efefef" d="M256.3 250.5l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M258.7 251l.2.4-.2-.5z" />
      <path fill="#9c9494" d="M259.1 250.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M260.3 250.7l.5.3-.5-.3z" />
      <path d="M261.2 250.5l.7.7-.7-.7z" />
      <path fill="#631808" d="M262 250.5l.6.7-.7-.7z" />
      <path fill="#6b735a" d="M294.3 250.5l.7.7-.7-.7z" />
      <path
        fill="#319400"
        d="M295 250.5l5.6 21.4h-.7v-1.3h-.7l.7 6h-.7v-1.3h-.7v5.3h-.7c0-6.8-2.7-12.9-6.3-18.7l-1.4 1.3v.7c5.1 4.9 6.7 15.4 7 22h-1.4l-2.8-14h-.7l2 18.8h-.6l-2.8-14h-.7l2 21.3h-.6l-1.4-17.4h-.7l1.4 17.4h-.7l-.7-9.3h-.7l.7 11.4h-.7l-.7-9.4h-.7l-2.1 12.7 7.7-.7v-.6l-5-.7v-.7l18.4 4.7v-.7l-8.5-2.7v-.6l12.7 2.7c-4-4.9-9-4-14.8-3.4v-.7l16.2.7v-.7l-11.3-2.6v-.7l11.3.7v-.7c-8-1.8-12-.8-18.3 4.7l1.4-6.7h-.7l-.7 2h-.7l3.5-10h.7l-.7 7.3 16.2-6v-.7l-14.8 4a42.2 42.2 0 0 1 21.1-8.7v-.6c-8.4 0-13 1.9-19.7 6.7 5.3-6.6 13.5-7.3 21.1-10v-.8c-9.5.8-14 3-21.8 8 4.8-4.5 13-12.4 20.4-10.6l-1.4-3.4c-6.5 1.5-12.1 5-16.9 9.4 3.3-4.4 14.8-16.5 20.4-16-5.7-5-16.6 10.1-20.4 13.3l15.5-16.7-13.4 11.4 14.8-18.8v-.7c-7 2.5-9 10.8-14 15.4l10.5-16.7a26.8 26.8 0 0 0-9.9 14.7c-3.2.4-2 5.5-2 8h-.8c0-8-1-18-6.3-24.7z"
      />
      <path fill="#314231" d="M295.7 250.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M296.4 250.5l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M297.8 250.5l.7.7-.7-.7z" />
      <path fill="#184a00" d="M300.6 250.5l.7.7-.7-.7z" />
      <path fill="#103900" d="M301.3 250.5l.7.7-.7-.7m7 0l.8.7-.7-.7z" />
      <path fill="#63636b" d="M309 250.5l.8.7-.7-.7z" />
      <path fill="#297b00" d="M309.8 250.5l.7.7-.7-.7m1.4 0l1.4 1.3-1.4-1.3z" />
      <path fill="#103900" d="M311.9 250.5l.7.7-.7-.7z" />
      <path fill="#185200" d="M313.3 250.5L309 254v.6l4.2-4z" />
      <path fill="#8c8c8c" d="M314 250.5l-.7 1.3.7-1.3z" />
      <path fill="#ada5a5" d="M314.7 250.5l.7.7-.7-.7z" />
      <path fill="#102110" d="M315.4 250.5l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M316.1 250.5l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M195.1 251.2l.7.7-.7-.7z" />
      <path fill="#397b00" d="M195.8 251.2l.7.7-.7-.7z" />
      <path fill="#103900" d="M198 251.2l2 2-2-2z" />
      <path fill="#5a1008" d="M201.4 251.2l.7.7-.7-.7z" />
      <path fill="#733939" d="M202.1 251.2l.7.7-.7-.7z" />
      <path fill="#dedede" d="M202.8 251.2l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M203.6 251.2l.7.7-.8-.7z" />
      <path fill="#295200" d="M206.4 251.2l1.4 1.3-1.4-1.3z" />
      <path fill="#294200" d="M209.9 251.2l.7.7-.7-.7z" />
      <path fill="#397b00" d="M213.4 251.2l.7.7-.7-.7m3.5 0l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M217.6 251.2l.7.7-.7-.7z" />
      <path fill="#100808" d="M246.5 251.2l.7.7-.7-.7z" />
      <path fill="#63636b" d="M247.9 251.2l.7.7-.7-.7z" />
      <path fill="#cecece" d="M250.7 251.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M251.4 251.2v.7h2.1l-2.1-.7z" />
      <path fill="#efefef" d="M253.5 251.2l.7.7-.7-.7z" />
      <path fill="#dedede" d="M256.3 251.2l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M257.5 251.4l.5.2-.5-.2z" />
      <path fill="#dedede" d="M259.1 251.2l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#210800" d="M261.2 251.2l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M292.9 251.2l.7.7-.7-.7z" />
      <path fill="#efefef" d="M293.6 251.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M294.3 251.2l-.7 1.3.7-1.3z" />
      <path fill="#185200" d="M295.7 251.2l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M296.4 251.2l.7.7-.7-.7z" />
      <path fill="#292921" d="M297.1 251.2l.7.7-.7-.7z" />
      <path fill="#cecece" d="M297.8 251.2l.7.7-.7-.7z" />
      <path fill="#185200" d="M298.5 251.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M300.6 251.2l.7.7-.7-.7z" />
      <path fill="#082108" d="M301.3 251.2l.7.7-.7-.7z" />
      <path fill="#185200" d="M303.4 251.2l1.5 1.3-1.5-1.3z" />
      <path fill="#297b00" d="M304.1 251.2l.7.7-.7-.7z" />
      <path fill="#296300" d="M306 251.4l.5.2-.5-.2z" />
      <path fill="#102110" d="M308.4 251.2l.7.7-.7-.7z" />
      <path fill="#296300" d="M309 251.2l.8.7-.7-.7z" />
      <path fill="#184a00" d="M311.2 251.2l.7.7-.7-.7z" />
      <path fill="#425242" d="M314 251.2l.7.7-.7-.7z" />
      <path fill="#185200" d="M314.7 251.2l.7.7-.7-.7z" />
      <path fill="#314231" d="M315.4 251.2l.7.7-.7-.7z" />
      <path fill="#efefef" d="M195.1 251.8l.7.7-.7-.7z" />
      <path fill="#295200" d="M195.8 251.8l.7.7-.7-.7z" />
      <path fill="#214210" d="M201.4 251.8l.7.7-.7-.7z" />
      <path fill="#efefef" d="M202.1 251.8l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M203.6 251.8l.7.7-.8-.7z" />
      <path fill="#397b00" d="M204.3 251.8l.6.7-.7-.7m2.2 0l.7.7-.7-.7z" />
      <path fill="#295200" d="M209.9 251.8l.7.7-.7-.7z" />
      <path fill="#103900" d="M212.7 251.8l.7.7-.7-.7z" />
      <path fill="#397b00" d="M214.6 252l.4.3-.4-.2z" />
      <path fill="#315221" d="M217 251.8l.6.7-.7-.7z" />
      <path fill="#420000" d="M246.5 251.8l.7.7-.7-.7z" />
      <path fill="#101810" d="M247.9 251.8l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M249.3 251.8l-.7 1.4.7-1.3z" />
      <path fill="#7b7373" d="M250 251.8l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M250.7 251.8l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M256 252l.5.3-.4-.2z" />
      <path fill="#efefef" d="M257 251.8l1.4 4h.7l-2-4m2 0l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M260 252.3l.3.4-.2-.4z" />
      <path fill="#ada5a5" d="M260.5 251.8l.7.7-.7-.7z" />
      <path fill="#313931" d="M261.2 251.8l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M262 251.8l.6.7-.7-.7z" />
      <path fill="#ada5a5" d="M292.9 251.8l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#297b00" d="M295 251.8l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M296.4 251.8l.7.7-.7-.7z" />
      <path fill="#103900" d="M297.1 251.8l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M297.8 251.8l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M298.5 251.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M299.2 251.8l.7.7-.7-.7z" />
      <path fill="#103900" d="M301.3 251.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M303.4 251.8l.8.7-.8-.7z" />
      <path fill="#184a00" d="M305.6 251.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M307.7 251.8l1.4 1.4-1.4-1.3z" />
      <path fill="#103900" d="M308.4 251.8l.7.7-.7-.7z" />
      <path fill="#296300" d="M310.5 251.8l.7.7-.7-.7z" />
      <path fill="#313931" d="M312.6 251.8l.7.7-.7-.7z" />
      <path fill="#214210" d="M313.3 251.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M314 251.8l.7.7-.7-.7z" />
      <path fill="#103910" d="M314.7 251.8l.7.7-.7-.7z" />
      <path fill="#efefef" d="M315.4 251.8l.7.7-.7-.7z" />
      <path fill="#425242" d="M195.8 252.5l.7.7-.7-.7z" />
      <path fill="#63636b" d="M202.1 252.5l.7.7-.7-.7z" />
      <path fill="#dedede" d="M203.6 252.5l-.7 1.4.7-1.4z" />
      <path fill="#396b10" d="M204.3 252.5l.6.7-.7-.7z" />
      <path fill="#397b00" d="M209.9 252.5l.7.7-.7-.7m1.4 1.4l2.1-.7-2.1.7z" />
      <path fill="#103900" d="M214.1 252.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M217 252.5l.6.7-.7-.7z" />
      <path fill="#941808" d="M246.5 252.5l.7.7-.7-.7z" />
      <path fill="#cecece" d="M249.3 252.5l.7.7-.7-.7z" />
      <path fill="#dedede" d="M251.4 252.5l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M252 252.5l.8.7-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#cecece" d="M254.9 252.5l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M257.7 252.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M258.9 252.7l.5.3-.5-.3z" />
      <path fill="#efefef" d="M260.5 252.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M261.2 252.5l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M262 252.5l.6.7-.7-.7z" />
      <path fill="#dedede" d="M292.9 252.5l.7.7-.7-.7z" />
      <path fill="#101810" d="M293.6 252.5l.7.7-.7-.7z" />
      <path fill="#cecece" d="M294.3 252.5l.7.7-.7-.7z" />
      <path fill="#296300" d="M295 252.5l.7.7-.7-.7z" />
      <path fill="#184a00" d="M296.4 252.5l.7.7-.7-.7z" />
      <path fill="#082108" d="M297.1 252.5l.7.7-.7-.7z" />
      <path fill="#185200" d="M297.8 252.5l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M298.5 252.5l.7.7-.7-.7z" />
      <path fill="#184a00" d="M299.2 252.5l.7.7-.7-.7z" />
      <path fill="#296300" d="M301.8 252.7l.5.3-.5-.3z" />
      <path
        fill="#103900"
        d="M304.1 252.5l.7.7-.7-.7m1.4 0l.8.7-.7-.7m2 0l.8.7-.7-.7m2.8 0l.7.7-.7-.7z"
      />
      <path d="M311.9 252.5l.7.7-.7-.7z" />
      <path fill="#296300" d="M312.6 252.5l.7.7-.7-.7z" />
      <path fill="#184a00" d="M314 252.5l.7.7-.7-.7z" />
      <path fill="#cecece" d="M314.7 252.5l.7.7-.7-.7z" />
      <path fill="#dedede" d="M195.1 253.2l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M195.8 253.2l.7.7-.7-.7z" />
      <path fill="#295200" d="M196.5 253.2l.7.7-.7-.7z" />
      <path fill="#292100" d="M200 253.2l.7.7-.7-.7z" />
      <path fill="#294200" d="M202.1 253.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M204.3 253.2l.6.7-.7-.7z" />
      <path fill="#397b00" d="M205 253.2l.7.7-.7-.7z" />
      <path fill="#294200" d="M212 253.2l.7.7-.7-.7z" />
      <path fill="#428c00" d="M212.7 253.2l-.7 1.3.7-1.3z" />
      <path fill="#295200" d="M213.4 253.2l.7.7-.7-.7z" />
      <path fill="#397b00" d="M214.1 253.2l.7.7-.7-.7z" />
      <path fill="#213918" d="M216.2 253.2l.7.7-.7-.7z" />
      <path fill="#efefef" d="M217 253.2l.6.7-.7-.7z" />
      <path fill="#ce2110" d="M246.5 253.2l.7.7-.7-.7z" />
      <path fill="#63636b" d="M248.6 253.2l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M250 253.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M251.2 253.4l.4.2-.4-.2z" />
      <path fill="#cecece" d="M252 253.2l2.2 2-2.1-2z" />
      <path fill="#8c8c8c" d="M254.9 253.2l.7.7-.7-.7z" />
      <path fill="#efefef" d="M255.6 253.2l1.4 2-1.4-2z" />
      <path fill="#8c8c8c" d="M256.8 253.4l.4.2-.4-.2z" />
      <path fill="#dedede" d="M260.5 253.2l1.4 1.3-1.4-1.3z" />
      <path fill="#bdbdbd" d="M261.2 253.2l.7.7-.7-.7z" />
      <path fill="#210800" d="M262 253.2l.6.7-.7-.7z" />
      <path fill="#103910" d="M293.6 253.2l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M294.3 253.2l.7.7-.7-.7z" />
      <path fill="#184a00" d="M295 253.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M296.4 253.2l.7.7-.7-.7z" />
      <path fill="#001000" d="M297.1 253.2l.7.7-.7-.7z" />
      <path fill="#319400" d="M297.8 253.2l.7.7-.7-.7z" />
      <path fill="#103910" d="M298.5 253.2l.7.7-.7-.7z" />
      <path fill="#425242" d="M299.2 253.2l.7.7-.7-.7z" />
      <path fill="#103900" d="M302 253.2l.7.7-.7-.7z" />
      <path fill="#184a00" d="M304.1 253.2l.7.7-.7-.7z" />
      <path fill="#185200" d="M305.6 253.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M307 253.2l1.4 1.3-1.4-1.3z" />
      <path fill="#184a00" d="M307.7 253.2l.7.7-.7-.7z" />
      <path fill="#103900" d="M309.8 253.2l.7.7-.7-.7z" />
      <path fill="#001000" d="M311.2 253.2l-.7 1.3.7-1.3z" />
      <path fill="#297b00" d="M311.9 253.2l.7.7-.7-.7m1.4 0l-.7 1.3.7-1.3z" />
      <path fill="#8c8c8c" d="M314 253.2l.7.7-.7-.7z" />
      <path fill="#dedede" d="M314.7 253.2l.7.7-.7-.7z" />
      <path fill="#63636b" d="M315.4 253.2l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M316.1 253.2l.7.7-.7-.7z" />
      <path fill="#8c9c84" d="M316.8 253.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M317.5 253.2l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M318.2 253.2l.7.7-.7-.7z" />
      <path fill="#313931" d="M195.1 253.8l.7.7-.7-.7z" />
      <path fill="#63636b" d="M195.8 253.8l.7.7-.7-.7z" />
      <path fill="#425242" d="M196.5 253.8l.7.7-.7-.7z" />
      <path fill="#397b00" d="M200 253.8l.7.7-.7-.7z" />
      <path fill="#294200" d="M200.7 253.8l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M202.8 253.8l.7.7-.7-.7z" />
      <path fill="#425242" d="M205 253.8l.7.7-.7-.7z" />
      <path fill="#103900" d="M211.3 253.8l.7.7-.7-.7z" />
      <path fill="#397b00" d="M212.7 253.8l-.7 1.4.7-1.3z" />
      <path fill="#294200" d="M213.4 253.8l.7.7-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#cecece" d="M216.2 253.8l.7.7-.7-.7z" />
      <path fill="#420000" d="M247.2 253.8l.7.7-.7-.7z" />
      <path fill="#101810" d="M248.6 253.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M249.3 253.8l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M250 253.8l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M253.5 253.8l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M254.2 253.8l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M254.9 253.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M256.3 253.8l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M258.4 253.8v.7h2.1l-2-.7z" />
      <path fill="#ada5a5" d="M260.5 253.8l.7.7-.7-.7z" />
      <path fill="#313931" d="M262 253.8l.6.7-.7-.7z" />
      <path fill="#bd2110" d="M262.6 253.8l.7.7-.7-.7z" />
      <path fill="#4a6342" d="M293.6 253.8l.7.7-.7-.7z" />
      <path fill="#294221" d="M294.3 253.8l.7.7-.7-.7z" />
      <path fill="#4a6342" d="M295 253.8l.7.7-.7-.7z" />
      <path fill="#103900" d="M297.1 253.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M297.1 255.2l2.1-.7-2 .7z" />
      <path fill="#313931" d="M299.2 253.8l.7.7-.7-.7z" />
      <path fill="#296300" d="M300 253.8l.6.7-.7-.7z" />
      <path fill="#185200" d="M302 253.8l1.4 1.4-1.4-1.3z" />
      <path fill="#297b00" d="M302.7 253.8l.7.7-.7-.7z" />
      <path fill="#103900" d="M307 253.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M311.2 253.8l.7.7-.7-.7z" />
      <path fill="#425242" d="M313.3 253.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M314 253.8l.7.7-.7-.7z" />
      <path fill="#214210" d="M314.7 253.8l.7.7-.7-.7z" />
      <path fill="#297b00" d="M315.4 253.8l.7.7-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#296300" d="M318.2 253.8l.7.7-.7-.7z" />
      <path fill="#184a00" d="M319 253.8l.6.7-.7-.7z" />
      <path fill="#425242" d="M319.6 253.8l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M320.6 254.3l.2.5-.2-.5z" />
      <path fill="#8c8c8c" d="M195.1 254.5l.7.7-.7-.7z" />
      <path fill="#428c00" d="M195.8 254.5l.7.7-.7-.7z" />
      <path fill="#294200" d="M196.5 254.5l.7.7-.7-.7z" />
      <path fill="#103900" d="M197.2 254.5l.7.7-.7-.7z" />
      <path fill="#397b00" d="M198 254.5l.6.7-.7-.7z" />
      <path fill="#295200" d="M200.7 254.5l.7.7-.7-.7z" />
      <path fill="#397b00" d="M201.7 255l.2.4-.2-.4z" />
      <path fill="#315221" d="M202.8 254.5l.7.7-.7-.7z" />
      <path fill="#cecece" d="M205 254.5l.7.7-.7-.7z" />
      <path fill="#294200" d="M205.7 254.5l.7.7-.7-.7z" />
      <path fill="#295200" d="M207.8 254.5l.7.7-.7-.7z" />
      <path fill="#103900" d="M210.6 254.5l.7.7-.7-.7z" />
      <path fill="#294200" d="M212.7 254.5l.7.7-.7-.7z" />
      <path fill="#295200" d="M214.8 254.5l-.7 1.4.7-1.4z" />
      <path fill="#9c9494" d="M215.5 254.5l-.7 1.4.7-1.4z" />
      <path fill="#941808" d="M247.2 254.5l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M249.3 254.5l.7.7-.7-.7z" />
      <path fill="#dedede" d="M250.7 254.5l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M251.9 254.8l.4.2-.4-.3z" />
      <path fill="#ada5a5" d="M252.8 254.5l.7.7-.7-.7m2.6.2l.4.3-.4-.3z" />
      <path fill="#8c8c8c" d="M257 254.5l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M257.7 254.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M262 254.5l-2.9.7v.7l3.5-.7-.7-.7z" />
      <path fill="#7b1008" d="M262.6 254.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M293.6 254.5l.7.7-.7-.7z" />
      <path fill="#296300" d="M294.3 254.5l.7.7-.7-.7z" />
      <path fill="#001000" d="M295 254.5l.7.7-.7-.7z" />
      <path fill="#185200" d="M297.8 254.5l.7.7-.7-.7z" />
      <path
        fill="#319400"
        d="M298.5 254.5l2.8 11.4h.7c0-4.1-.5-8.2-3.5-11.4z"
      />
      <path fill="#184a00" d="M299.2 254.5l.7.7-.7-.7z" />
      <path fill="#103900" d="M300 254.5l.6.7-.7-.7z" />
      <path fill="#297b00" d="M302 254.5l.7.7-.7-.7z" />
      <path fill="#103900" d="M304.9 254.5l.7.7-.8-.7z" />
      <path fill="#184a00" d="M307 254.5l.7.7-.7-.7m2 0l.8.7-.7-.7z" />
      <path fill="#103900" d="M309.8 254.5l.7.7-.7-.7z" />
      <path fill="#297b00" d="M310.5 254.5l.7.7-.7-.7z" />
      <path fill="#214210" d="M312.6 254.5l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M313.3 254.5l.7.7-.7-.7z" />
      <path fill="#214210" d="M314 254.5l.7.7-.7-.7z" />
      <path fill="#297b00" d="M316.1 254.5l.7.7-.7-.7z" />
      <path fill="#185200" d="M316.8 254.5l.7.7-.7-.7z" />
      <path fill="#184a00" d="M317.5 254.5l.7.7-.7-.7z" />
      <path fill="#295210" d="M318.2 254.5l.7.7-.7-.7z" />
      <path fill="#4a6342" d="M319 254.5l.6.7-.7-.7z" />
      <path fill="#5a6b52" d="M319.6 254.5l.7.7-.7-.7z" />
      <path fill="#dedede" d="M195.1 255.2l.7.7-.7-.7z" />
      <path fill="#295200" d="M195.8 255.2l2.1 1.3-2-1.3m2 0l.7.7-.7-.7z" />
      <path fill="#103900" d="M198.6 255.2l.7.7-.7-.7z" />
      <path fill="#295200" d="M199.3 255.2l.7.7-.7-.7z" />
      <path fill="#397b00" d="M202.8 255.2l.7.7-.7-.7z" />
      <path fill="#cecece" d="M203.6 255.2l.7.7-.8-.7z" />
      <path fill="#8c8c8c" d="M205.7 255.2l.7.7-.7-.7z" />
      <path fill="#397b00" d="M206.4 255.2v.7h2l-2-.7z" />
      <path fill="#103900" d="M209.9 255.2l.7.7-.7-.7m2 0l.8.7-.7-.7z" />
      <path fill="#00215a" d="M227.5 255.2l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M247.2 255.2l.7.7-.7-.7z" />
      <path fill="#63636b" d="M249.3 255.2l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M250 255.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M250.7 255.2l.7.7-.7-.7z" />
      <path fill="#efefef" d="M251.6 255.6l.3.5-.3-.5z" />
      <path fill="#bdbdbd" d="M254.4 255.6l.3.5-.3-.5z" />
      <path fill="#dedede" d="M255.1 255.6l.3.5-.3-.5z" />
      <path fill="#7b7373" d="M255.8 255.6l.3.5-.3-.5z" />
      <path fill="#bdbdbd" d="M256.3 255.2l.7.7-.7-.7z" />
      <path fill="#dedede" d="M257 255.2l.7.7-.7-.7z" />
      <path fill="#cecece" d="M262 255.2l.6.7-.7-.7z" />
      <path fill="#210800" d="M262.6 255.2l.7.7-.7-.7z" />
      <path fill="#520808" d="M280.2 255.2l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M281 255.2v.7h6.3l-6.4-.7z" />
      <path fill="#520808" d="M287.3 255.2l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M291.5 255.2l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M293.6 255.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M294.3 255.2l.7.7-.7-.7z" />
      <path fill="#082108" d="M295 255.2l.7.7-.7-.7z" />
      <path fill="#103900" d="M297.8 255.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M299.2 255.2l.7.7-.7-.7z" />
      <path fill="#001000" d="M300 255.2l.6.7-.7-.7z" />
      <path fill="#297b00" d="M300.6 255.2l.7.7-.7-.7z" />
      <path fill="#184a00" d="M303 255.6l.2.5-.2-.5z" />
      <path fill="#103900" d="M306.3 255.2l.7.7-.7-.7m2 0l1.5 1.3-1.4-1.3z" />
      <path fill="#185200" d="M309 255.2l.8.7-.7-.7z" />
      <path fill="#296300" d="M309.8 255.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M311.9 255.2l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M312.6 255.2l.7.7-.7-.7z" />
      <path fill="#314231" d="M313.3 255.2l-.7 1.3.7-1.3z" />
      <path fill="#297b00" d="M314 255.2l.7.7-.7-.7z" />
      <path fill="#214210" d="M315.4 255.2l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M316.1 255.2l-.7 1.3.7-1.3z" />
      <path fill="#5a5231" d="M195.8 255.9l.7.6-.7-.6z" />
      <path fill="#294200" d="M200.5 256l.5.3-.5-.2z" />
      <path fill="#8c8c8c" d="M203.6 255.9l.7.6-.8-.6z" />
      <path fill="#314231" d="M206.4 255.9l.7.6-.7-.6z" />
      <path fill="#294200" d="M207 255.9l.8.6-.7-.6z" />
      <path fill="#295200" d="M209.2 255.9l.7.6-.7-.6z" />
      <path fill="#397b00" d="M209.9 255.9l.7.6-.7-.6z" />
      <path fill="#103900" d="M211.3 255.9l.7.6-.7-.6z" />
      <path fill="#214210" d="M213.4 255.9l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M214.1 255.9l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M220.4 255.9l.7.6-.7-.6z" />
      <path
        fill="#bdbdbd"
        fillOpacity={0.3}
        d="M221.1 255.9v.6h6.4v10c3.8-6 .2-10.6-6.4-10.6z"
      />
      <path fill="#8c8c8c" d="M227.5 255.9l.7.6-.7-.6z" />
      <path fill="#420000" d="M247.9 255.9l.7.6-.7-.6z" />
      <path fill="#101810" d="M249.3 255.9l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M250.7 256.5v.7l3.5-.7h-3.5m7-.6l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M258.4 255.9l.7.6-.7-.6z" />
      <path fill="#dedede" d="M259.1 255.9l.7.6-.7-.6z" />
      <path fill="#292921" d="M262.6 255.9l.7.6-.7-.6z" />
      <path fill="#bd2110" d="M263.4 255.9l.7.6-.8-.6z" />
      <path fill="#63636b" d="M280.2 255.9l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M281 255.9v.6h6.3l-6.4-.6z" />
      <path fill="#63636b" d="M287.3 255.9l.7.6-.7-.6z" />
      <path fill="#292921" d="M291.5 255.9l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M292.2 255.9l.7.6-.7-.6m1.6.4l.3.5-.3-.5z" />
      <path fill="#296300" d="M294.3 257.2l2.1-.7-2.1.7z" />
      <path fill="#185200" d="M297.8 255.9l1.4 1.3-1.4-1.3z" />
      <path fill="#297b00" d="M298.5 255.9l.7.6-.7-.6z" />
      <path fill="#296300" d="M300 255.9l.6.6-.7-.6z" />
      <path fill="#185200" d="M300.6 255.9l.7.6-.7-.6z" />
      <path fill="#184a00" d="M306.3 255.9l.7.6-.7-.6z" />
      <path fill="#319400" d="M307 255.9l.7.6-.7-.6z" />
      <path fill="#184a00" d="M307.7 255.9l.7.6-.7-.6z" />
      <path fill="#214210" d="M311.9 255.9l.7.6-.7-.6z" />
      <path fill="#297b00" d="M313.3 255.9l.7.6-.7-.6z" />
      <path fill="#296300" d="M314.7 255.9l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M195.8 256.5l.7.7-.7-.7z" />
      <path fill="#397b00" d="M197.2 256.5l.7.7-.7-.7z" />
      <path fill="#294200" d="M198 256.5l.6.7-.7-.7m4 .2l.5.3-.5-.2z" />
      <path fill="#5a6b52" d="M203.6 256.5l.7.7-.8-.7z" />
      <path fill="#9c9494" d="M206.4 256.5l.7.7-.7-.7z" />
      <path fill="#292100" d="M207 256.5l.8.7-.7-.7z" />
      <path fill="#294200" d="M209.2 256.5l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#397b00" d="M211.3 256.5l.7.7-.7-.7z" />
      <path fill="#314231" d="M212.7 256.5l.7.7-.7-.7z" />
      <path fill="#cecece" d="M213.4 256.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M220.4 256.5v5.4h.7l-.7-5.4z" />
      <path fill="#941808" d="M247.9 256.5l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M250 256.5l.7.7-.7-.7z" />
      <path fill="#dedede" d="M252 256.5l.8.7-.7-.7z" />
      <path fill="#efefef" d="M254.9 256.5l1.4 1.4-1.4-1.4z" />
      <path fill="#bdbdbd" d="M255.6 256.5l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M256.8 256.8l.4.2-.4-.2z" />
      <path fill="#dedede" d="M257.7 256.5l.7.7-.7-.7z" />
      <path fill="#efefef" d="M259.1 256.5l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M259.8 256.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M261 256.8l.5.2-.5-.2z" />
      <path fill="#9c9494" d="M262 256.5l.6.7-.7-.7z" />
      <path fill="#7b7373" d="M262.6 256.5l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M263.4 256.5l.7.7-.8-.7z" />
      <path fill="#8c8c8c" d="M280.2 256.5v8.7h.7l-.7-8.7m7 0v10h.8l-.7-10z" />
      <path fill="#6b735a" d="M291.5 256.5l.7.7-.7-.7z" />
      <path fill="#395231" d="M292.2 256.5l.7.7-.7-.7z" />
      <path fill="#319400" d="M295 256.5l3.5 12h.7l-4.2-12z" />
      <path fill="#103900" d="M295.7 256.5l.7.7-.7-.7z" />
      <path fill="#297b00" d="M297.8 256.5l.7.7-.7-.7z" />
      <path fill="#184a00" d="M300.9 257l.2.4-.2-.4z" />
      <path fill="#296300" d="M302.7 256.5l.7.7-.7-.7z" />
      <path fill="#297b00" d="M303.4 256.5l-.6 1.4.6-1.4z" />
      <path fill="#184a00" d="M305.6 256.5l.7.7-.7-.7z" />
      <path fill="#296300" d="M307.4 256.8l.5.2-.5-.2z" />
      <path fill="#185200" d="M308.4 256.5l.7.7-.7-.7z" />
      <path fill="#297b00" d="M311.2 256.5l.7.7-.7-.7z" />
      <path d="M311.9 256.5l.7.7-.7-.7z" />
      <path fill="#297b00" d="M312.6 256.5l.7.7-.7-.7z" />
      <path fill="#425242" d="M314.7 256.5l.7.7-.7-.7z" />
      <path fill="#efefef" d="M195.8 257.2l.7.7-.7-.7z" />
      <path fill="#315221" d="M196.5 257.2l.7.7-.7-.7z" />
      <path fill="#103900" d="M198.6 257.2l.7.7-.7-.7z" />
      <path fill="#397b00" d="M199.6 257.6l.2.5-.2-.5m2.5-.4l.7.7-.7-.7z" />
      <path fill="#103900" d="M202.8 257.2l1.4 1.3-1.3-1.3z" />
      <path fill="#213918" d="M203.6 257.2l.7.7-.8-.7z" />
      <path fill="#dedede" d="M206.4 257.2l.7.7-.7-.7z" />
      <path fill="#295200" d="M207 257.2l.8.7-.7-.7z" />
      <path fill="#103900" d="M208.5 257.2l.7.7-.7-.7z" />
      <path fill="#397b00" d="M209.9 257.2l.7.7-.7-.7z" />
      <path fill="#295200" d="M210.6 257.2l.7.7-.7-.7z" />
      <path fill="#213918" d="M212 257.2l.7.7-.7-.7z" />
      <path fill="#efefef" d="M212.7 257.2l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M247.9 257.2l.7.7-.7-.7z" />
      <path fill="#63636b" d="M250 257.2l.7.7-.7-.7z" />
      <path fill="#efefef" d="M252 257.2l.8.7-.7-.7z" />
      <path fill="#9c9494" d="M252.8 257.2l.7.7-.7-.7z" />
      <path
        fill="#8c8c8c"
        d="M253.5 257.2v.7h2.1l-2.1-.7m2.8 0l-2 1.3v.7l2-2m2.1 0l.7.7-.7-.7z"
      />
      <path fill="#7b7373" d="M259.1 257.2l.7.7-.7-.7z" />
      <path fill="#cecece" d="M259.8 257.2l.7.7-.7-.7m2.8 0l-.7 1.3.7-1.3z" />
      <path fill="#210800" d="M263.4 257.2l.7.7-.8-.7z" />
      <path fill="#8c8c8c" d="M291.5 257.2l.7.7-.7-.7z" />
      <path fill="#296300" d="M292.4 257.6l.3.5-.3-.5z" />
      <path fill="#8c8c8c" d="M292.9 257.2l.7.7-.7-.7z" />
      <path fill="#185200" d="M294.3 257.2l.7.7-.7-.7z" />
      <path fill="#184a00" d="M295.7 257.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M296.4 257.2l-.7 1.3.7-1.3z" />
      <path fill="#103900" d="M298.5 257.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M301.3 257.2l-.7 1.3.7-1.3z" />
      <path fill="#184a00" d="M303.7 257.6l.2.5-.2-.5z" />
      <path fill="#103900" d="M305.6 257.2l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#184a00" d="M308.4 257.2l.7.7-.7-.7m2.8 0l.7.7-.7-.7z" />
      <path fill="#296300" d="M311.9 257.2l.7.7-.7-.7z" />
      <path fill="#184a00" d="M314 257.2l.7.7-.7-.7z" />
      <path fill="#cecece" d="M314.7 257.2l.7.7-.7-.7z" />
      <path fill="#efefef" d="M317.4 260.4l-2.8 4.7c1.9-1.3 3.7-2.4 2.8-4.7z" />
      <path fill="#dedede" d="M321.7 257.2l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M196.5 257.9l.7.6-.7-.6z" />
      <path fill="#295200" d="M197.2 257.9l.7.6-.7-.6z" />
      <path fill="#294200" d="M200 257.9l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M204.3 257.9l.6.6-.7-.6z" />
      <path fill="#8c8c8c" d="M206.4 257.9l.7.6-.7-.6z" />
      <path fill="#295200" d="M207.8 257.9l.7.6-.7-.6z" />
      <path fill="#397b00" d="M208.5 257.9l.7.6-.7-.6z" />
      <path fill="#294200" d="M209.9 257.9l.7.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#cecece" d="M212 257.9l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M214.6 258l.4.3-.4-.2z" />
      <path fill="#420000" d="M248.6 257.9l.7.6-.7-.6z" />
      <path fill="#101810" d="M250 257.9l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M251.4 257.9l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M252 257.9l.8.6-.7-.6z" />
      <path fill="#dedede" d="M252.8 257.9l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M257.7 257.9l.7.6-.7-.6z" />
      <path fill="#cecece" d="M258.4 257.9l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M262.6 257.9l.7.6-.7-.6z" />
      <path fill="#ce2110" d="M264 257.9l.8.6-.8-.6z" />
      <path fill="#cecece" d="M291.5 257.9l.7.6-.7-.6z" />
      <path fill="#184a00" d="M292.9 257.9l-.7 1.3.7-1.3z" />
      <path fill="#dedede" d="M293.6 257.9l.7.6-.7-.6z" />
      <path fill="#184a00" d="M294.5 258.3l.3.5-.3-.5z" />
      <path fill="#185200" d="M296.4 257.9l.7.6-.7-.6m2.1 0l.7.6-.7-.6z" />
      <path fill="#297b00" d="M299.2 257.9l.7.6-.7-.6z" />
      <path fill="#296300" d="M301.3 257.9l.7.6-.7-.6z" />
      <path fill="#185200" d="M304.9 257.9l.7.6-.8-.6z" />
      <path fill="#296300" d="M305.6 257.9l.7.6-.7-.6z" />
      <path fill="#184a00" d="M306.3 257.9l.7.6-.7-.6z" />
      <path fill="#103900" d="M307.7 257.9l.7.6-.7-.6z" />
      <path fill="#185200" d="M311.2 257.9l.7.6-.7-.6z" />
      <path fill="#297b00" d="M313.3 257.9l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M314 257.9l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M320.3 257.9l.7.6-.7-.6z" />
      <path fill="#424242" d="M321 257.9l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M197.2 258.5l.7.7-.7-.7z" />
      <path fill="#294200" d="M200.7 258.5l1.4 1.4-1.4-1.4z" />
      <path fill="#397b00" d="M201.4 258.5l.7.7-.7-.7z" />
      <path fill="#315221" d="M204.3 258.5l.6.7-.7-.7z" />
      <path fill="#efefef" d="M205.4 258.8l.5.2-.5-.2z" />
      <path fill="#214210" d="M206.4 258.5l.7.7-.7-.7z" />
      <path fill="#103900" d="M207.8 258.5l.7.7-.7-.7z" />
      <path fill="#295200" d="M209.2 258.5l.7.7-.7-.7z" />
      <path fill="#397b00" d="M209.9 258.5l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M211.3 258.5l.7.7-.7-.7z" />
      <path fill="#315221" d="M214.1 258.5l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M214.8 258.5l.7.7-.7-.7z" />
      <path fill="#00216b" d="M228.2 258.5l.7.7-.7-.7z" />
      <path fill="#941808" d="M248.6 258.5l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M250.7 258.5l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M253.5 258.5l.7.7-.7-.7z" />
      <path fill="#cecece" d="M256.3 258.5l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M257 258.5l.7.7-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#52525a" d="M259.8 258.5l.7.7-.7-.7z" />
      <path fill="#313931" d="M260.5 258.5l.7.7-.7-.7z" />
      <path fill="#941808" d="M264 258.5l.8.7-.8-.7z" />
      <path fill="#319400" d="M292.9 258.5l5 16.1h.6c0-5.6-1.8-11.7-5.6-16z" />
      <path fill="#425242" d="M293.6 258.5l.7.7-.7-.7z" />
      <path fill="#103900" d="M296.4 258.5l.7.7-.7-.7z" />
      <path fill="#184a00" d="M299.2 258.5l.7.7-.7-.7z" />
      <path fill="#103900" d="M301.6 259l.2.4-.2-.4m3.2-.5l.7.7-.7-.7z" />
      <path fill="#319400" d="M305.6 258.5l.7.7-.7-.7z" />
      <path fill="#103900" d="M306.3 258.5l.7.7-.7-.7z" />
      <path fill="#184a00" d="M307.7 258.5l.7.7-.7-.7z" />
      <path fill="#103900" d="M310.5 258.5l.7.7-.7-.7z" />
      <path fill="#103910" d="M313.3 258.5l.7.7-.7-.7z" />
      <path fill="#efefef" d="M314 258.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M315.4 258.5l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M316.1 258.5l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M319 258.5l.6.7-.7-.7z" />
      <path fill="#314231" d="M319.6 258.5l-1.4 2.7 1.4-2.7z" />
      <path fill="#313931" d="M320.3 258.5l.7.7-.7-.7z" />
      <path fill="#efefef" d="M197.2 259.2l2.1 2-2-2z" />
      <path fill="#314231" d="M198 259.2l.6.7-.7-.7z" />
      <path fill="#397b00" d="M202.1 259.2l.7.7-.7-.7z" />
      <path fill="#63636b" d="M205 259.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M205.7 259.2l.7.7-.7-.7z" />
      <path fill="#397b00" d="M207 259.2l.8.7-.7-.7z" />
      <path fill="#295200" d="M207.8 259.2l.7.7-.7-.7z" />
      <path fill="#294200" d="M209.2 259.2l.7.7-.7-.7z" />
      <path fill="#295200" d="M210.6 259.2l.7.7-.7-.7z" />
      <path fill="#cecece" d="M211.3 259.2l.7.7-.7-.7z" />
      <path fill="#63636b" d="M213.4 259.2l.7.7-.7-.7z" />
      <path fill="#5a5231" d="M214.8 259.2l.7.7-.7-.7z" />
      <path fill="#101829" d="M228.2 259.2l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M248.6 259.2l.7.7-.7-.7z" />
      <path fill="#63636b" d="M250.7 259.2l.7.7-.7-.7z" />
      <path fill="#efefef" d="M251.6 259.7l.3.4-.3-.4z" />
      <path fill="#9c9494" d="M252 259.2l.8.7-.7-.7z" />
      <path fill="#7b7373" d="M252.8 259.2l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M253.5 259.2l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M257 259.2l.7.7-.7-.7z" />
      <path fill="#cecece" d="M257.7 259.2l.7.7-.7-.7z" />
      <path fill="#313931" d="M258.4 259.2l.7.7-.7-.7z" />
      <path fill="#210800" d="M263.4 259.2l.7.7-.8-.7z" />
      <path fill="#7b1008" d="M264 259.2l.8.7-.8-.7z" />
      <path fill="#10214a" d="M279.5 259.2l.7.7-.7-.7z" />
      <path fill="#4a6342" d="M292.4 259.7l.3.4-.3-.4z" />
      <path fill="#296300" d="M293.6 259.2l.7.7-.7-.7z" />
      <path fill="#103900" d="M294.5 259.7l.3.4-.3-.4z" />
      <path fill="#296300" d="M296.9 259.4l.5.3-.5-.3z" />
      <path fill="#103900" d="M299.2 259.2l.7.7-.7-.7z" />
      <path fill="#185200" d="M305.3 259.4l.5.3-.5-.3m1.7-.2l.7.7-.7-.7z" />
      <path fill="#103900" d="M309.8 259.2l.7.7-.7-.7z" />
      <path fill="#296300" d="M312.6 259.2l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M313.3 259.2l.7.7-.7-.7z" />
      <path fill="#dedede" d="M314 259.2l.7.7-.7-.7z" />
      <path fill="#425242" d="M314.7 259.2l.7.7-.7-.7z" />
      <path fill="#313931" d="M315.4 259.2l.7.7-.7-.7z" />
      <path fill="#efefef" d="M316.1 259.2l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#63636b" d="M318.2 259.2l.7.7-.7-.7z" />
      <path fill="#185200" d="M319 259.2l.6.7-.7-.7z" />
      <path fill="#ada5a5" d="M189.5 259.9l.7.7-.7-.7z" />
      <path fill="#efefef" d="M190.2 259.9l.7.7-.7-.7z" />
      <path fill="#314231" d="M198.6 259.9l.7.7-.7-.7z" />
      <path
        fill="#397b00"
        d="M199.3 259.9l1.4 1.3-1.4-1.3m4.3 0l.7.7-.8-.7m1.5 0l.7.7-.7-.7z"
      />
      <path fill="#214210" d="M205.7 259.9l.7.7-.7-.7z" />
      <path fill="#295200" d="M206.4 259.9l.7.7-.7-.7z" />
      <path fill="#292100" d="M207 259.9l.8.7-.7-.7z" />
      <path fill="#397b00" d="M208.5 259.9v1.3h1.4l-1.4-1.3z" />
      <path fill="#295200" d="M209.2 259.9l.7.7-.7-.7z" />
      <path fill="#5a5231" d="M210.6 259.9l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M212.7 259.9l.7.7-.7-.7z" />
      <path fill="#294200" d="M214.8 259.9l.7.7-.7-.7z" />
      <path fill="#efefef" d="M215.5 259.9l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M228.2 259.9l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M228.9 259.9l.7.7-.7-.7z" />
      <path fill="#10214a" d="M229.6 259.9l.7.7-.7-.7z" />
      <path fill="#420000" d="M249.3 259.9l.7.7-.7-.7z" />
      <path fill="#101810" d="M250.7 259.9l.7.7-.7-.7z" />
      <path fill="#dedede" d="M252 259.9l.8.7-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M254.9 259.9l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M256 260.1l.5.2-.4-.2z" />
      <path fill="#313931" d="M257 259.9l.7.7-.7-.7z" />
      <path fill="#101810" d="M257.7 259.9l.7.7-.7-.7z" />
      <path fill="#310000" d="M261.2 259.9l.7.7-.7-.7z" />
      <path fill="#941808" d="M262 259.9l.6.7-.7-.7z" />
      <path fill="#00184a" d="M278.1 259.9l.7.7-.7-.7z" />
      <path fill="#636b7b" d="M278.8 259.9l.7.7-.7-.7z" />
      <path fill="#efefef" d="M279.5 259.9l.7.7-.7-.7z" />
      <path fill="#297b00" d="M295 259.9l-.7 1.3.7-1.3z" />
      <path fill="#184a00" d="M297.1 259.9l.7.7-.7-.7z" />
      <path fill="#185200" d="M299.2 259.9l1.4 1.3-1.4-1.3z" />
      <path fill="#297b00" d="M300 259.9l.6.7-.7-.7z" />
      <path fill="#296300" d="M301.3 259.9l.7.7-.7-.7z" />
      <path fill="#297b00" d="M302 259.9l-.7 1.3.7-1.3z" />
      <path fill="#184a00" d="M304.4 260.3l.2.5-.2-.5z" />
      <path fill="#103900" d="M305.6 259.9l.7.7-.7-.7z" />
      <path fill="#319400" d="M306.3 259.9l.7.7-.7-.7z" />
      <path fill="#103900" d="M307 259.9l.7.7-.7-.7z" />
      <path fill="#296300" d="M309.5 260.1l.5.2-.5-.2z" />
      <path fill="#425242" d="M312.6 259.9l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M313.3 259.9l.7.7-.7-.7z" />
      <path fill="#184a00" d="M314.5 260.1l.4.2-.4-.2z" />
      <path fill="#cecece" d="M315.4 259.9l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M316.8 259.9l.7.7-.7-.7z" />
      <path fill="#214210" d="M317.5 259.9l.7.7-.7-.7z" />
      <path fill="#297b00" d="M318.2 259.9l.7.7-.7-.7z" />
      <path fill="#8c9c84" d="M189.5 260.6l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M190.2 260.6l.7.6-.7-.6z" />
      <path fill="#63636b" d="M199.3 260.6l.7.6-.7-.6z" />
      <path fill="#001000" d="M203.6 260.6l.7.6-.8-.6z" />
      <path fill="#295200" d="M204.3 260.6l.6.6-.7-.6z" />
      <path fill="#292100" d="M205.7 260.6l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M206.8 260.8l.5.2-.5-.2z" />
      <path fill="#311000" d="M207.8 260.6l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M210.6 260.6l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M212 260.6l.7.6-.7-.6z" />
      <path fill="#295200" d="M212.7 260.6l.7.6-.7-.6z" />
      <path
        fill="#428c00"
        d="M209.7 267.4h-.7c-.1-3.8-1.6-6.3-5.6-7.4 0 2 1.6 10 5 7.4h.6l-1.4 6c2.1-2.2 10.8-10 7-13.5-3.2-2.9-4.8 6-4.9 7.5z"
      />
      <path fill="#295200" d="M214.1 260.6l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M215.5 260.6l.7.6-.7-.6z" />
      <path fill="#efefef" d="M229.6 260.6l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M230.3 260.6l.7.6-.7-.6z" />
      <path fill="#31425a" d="M231 260.6l.7.6-.7-.6z" />
      <path fill="#00216b" d="M231.7 260.6l.7.6-.7-.6z" />
      <path fill="#941808" d="M249.3 260.6l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M251.4 260.6l.7.6-.7-.6z" />
      <path fill="#efefef" d="M252.8 260.6l.7.6-.7-.6z" />
      <path fill="#63636b" d="M253.5 260.6l.7.6-.7-.6z" />
      <path fill="#310000" d="M259.8 260.6l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M260.5 260.6l.7.6-.7-.6z" />
      <path fill="#00216b" d="M276 260.6l.7.6-.7-.6z" />
      <path fill="#21315a" d="M276.7 260.6l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M277.4 260.6l.7.6-.7-.6z" />
      <path fill="#efefef" d="M278.1 260.6l.7.6-.7-.6m12 0l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M290.8 260.6l.7.6-.7-.6z" />
      <path fill="#cecece" d="M291.5 260.6l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M292.2 260.6l.7.6-.7-.6z" />
      <path fill="#184a00" d="M295 260.6l.7.6-.7-.6z" />
      <path fill="#103900" d="M297.1 260.6l.7.6-.7-.6z" />
      <path fill="#297b00" d="M297.8 260.6l-.7 1.3.7-1.3m1.4 0l.7.6-.7-.6z" />
      <path fill="#185200" d="M305.6 260.6l.7.6-.7-.6z" />
      <path fill="#103900" d="M309 260.6l.8.6-.7-.6z" />
      <path fill="#185200" d="M311.9 260.6l.7.6-.7-.6z" />
      <path fill="#102110" d="M312.6 260.6l.7.6-.7-.6z" />
      <path fill="#296300" d="M313.8 260.8l.4.2-.4-.2z" />
      <path fill="#8c8c8c" d="M314.7 260.6l.7.6-.7-.6z" />
      <path fill="#dedede" d="M315.4 260.6l.7.6-.7-.6z" />
      <path fill="#425242" d="M316.1 260.6l.7.6-.7-.6z" />
      <path fill="#297b00" d="M316.8 260.6l-2.1 3.3 3.5-3.3h-1.4z" />
      <path fill="#295200" d="M190.2 261.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M190.9 261.2l.7.7-.7-.7z" />
      <path fill="#dedede" d="M199.3 261.2l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M200 261.2l.7.7-.7-.7z" />
      <path fill="#295200" d="M200.7 261.2l.7.7-.7-.7z" />
      <path fill="#397b00" d="M202.8 261.2v.7h2.2l-2.1-.7z" />
      <path fill="#294200" d="M205 261.2l.7.7-.7-.7z" />
      <path fill="#103900" d="M205.7 261.2l.7.7-.7-.7z" />
      <path fill="#941808" d="M208 261.7l.2.4-.2-.4z" />
      <path fill="#292100" d="M208.5 261.2l.7.7-.7-.7z" />
      <path fill="#295200" d="M209.9 261.2l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M210.6 261.2l.7.7-.7-.7z" />
      <path fill="#cecece" d="M211.3 261.2l.7.7-.7-.7z" />
      <path fill="#214210" d="M212 261.2l.7.7-.7-.7z" />
      <path fill="#294200" d="M213.6 261.7l.3.4-.3-.4z" />
      <path fill="#8c8c8c" d="M215.7 261.7l.3.4-.3-.4z" />
      <path fill="#dedede" d="M231.7 261.2l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M232.4 261.2l.7.7-.7-.7z" />
      <path fill="#636b7b" d="M233.1 261.2l.7.7-.7-.7z" />
      <path fill="#21315a" d="M233.8 261.2l.7.7-.7-.7z" />
      <path fill="#00216b" d="M234.5 261.2l.7.7-.7-.7z" />
      <path fill="#002984" d="M235.2 261.2l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M249.3 261.2l.7.7-.7-.7z" />
      <path fill="#424242" d="M251.4 261.2l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M252 261.2l.8.7-.7-.7z" />
      <path fill="#101810" d="M252.8 261.2l.7.7-.7-.7z" />
      <path fill="#100808" d="M257.7 261.2l.7.7-.7-.7z" />
      <path fill="#310000" d="M258.4 261.2l.7.7-.7-.7z" />
      <path fill="#210800" d="M259.1 261.2l.7.7-.7-.7z" />
      <path fill="#002984" d="M272.5 261.2l.7.7-.7-.7z" />
      <path fill="#00216b" d="M273.2 261.2l.7.7-.7-.7z" />
      <path fill="#10295a" d="M273.9 261.2l.7.7-.7-.7z" />
      <path fill="#525a6b" d="M274.6 261.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M275.3 261.2l.7.7-.7-.7z" />
      <path fill="#cecece" d="M276 261.2l.7.7-.7-.7z" />
      <path fill="#63636b" d="M290 261.2l.8.7-.7-.7z" />
      <path fill="#297b00" d="M290.8 261.2l1.4 1.4-1.4-1.4z" />
      <path fill="#103910" d="M291.5 261.2l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M292.2 261.2l.7.7-.7-.7z" />
      <path fill="#103900" d="M295 261.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M295.7 261.2l-.7 1.4.7-1.4z" />
      <path fill="#185200" d="M297.8 261.2l.7.7-.7-.7z" />
      <path fill="#103900" d="M300 261.2l.6.7-.7-.7z" />
      <path fill="#184a00" d="M304.9 261.2l.7.7-.8-.7z" />
      <path fill="#103900" d="M308.4 261.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M311.2 261.2v.7h2.8v-.7h-2.8z" />
      <path fill="#425242" d="M314 261.2l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M314.7 261.2l.7.7-.7-.7z" />
      <path fill="#214210" d="M315.4 261.2l.7.7-.7-.7z" />
      <path fill="#52525a" d="M317.5 261.2l.7.7-.7-.7z" />
      <path fill="#428c00" d="M190.2 261.9l.7.7-.7-.7z" />
      <path fill="#397b00" d="M191.1 262.3l.3.5-.3-.5z" />
      <path fill="#314231" d="M191.6 261.9l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M192.3 261.9l.7.7-.7-.7z" />
      <path fill="#dedede" d="M195.1 261.9l.7.7-.7-.7z" />
      <path fill="#efefef" d="M198.6 261.9l.7.7-.7-.7z" />
      <path fill="#101810" d="M199.3 261.9l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M200.7 261.9l.7.7-.7-.7z" />
      <path fill="#315221" d="M201.4 261.9l.7.7-.7-.7z" />
      <path fill="#295200" d="M202.8 261.9l.7.7-.7-.7z" />
      <path fill="#292100" d="M205.7 261.9l.7.7-.7-.7z" />
      <path fill="#941808" d="M206.4 261.9l.7.7-.7-.7z" />
      <path fill="#103900" d="M208.5 261.9l.7.7-.7-.7z" />
      <path fill="#5a2908" d="M209.2 261.9l-.7 1.3.7-1.3z" />
      <path fill="#7b1008" d="M209.9 261.9l.7.7-.7-.7z" />
      <path fill="#5a3131" d="M210.6 261.9l.7.7-.7-.7z" />
      <path fill="#314231" d="M211.3 261.9l.7.7-.7-.7z" />
      <path fill="#cecece" d="M219.7 261.9l.7.7-.7-.7z" />
      <path fill="#52525a" d="M220.4 261.9l.7.7-.7-.7z" />
      <path fill="#dedede" d="M221.1 261.9l.7.7-.7-.7m13.4 0l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M235.2 261.9l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M236 261.9l.6.7-.7-.7z" />
      <path fill="#bdbdbd" d="M236.6 261.9l.7.7-.7-.7z" />
      <path fill="#420000" d="M250 261.9l.7.7-.7-.7z" />
      <path fill="#100808" d="M256.3 261.9l.7.7-.7-.7z" />
      <path fill="#7b0008" d="M257 261.9l.7.7-.7-.7z" />
      <path
        fill="#de2110"
        d="M254.2 262.6v.6h2.1c-5.4 8.4-1.5 19.7-.7 28.8h.7c2-8.2 2.2-20 0-28.1l2.8 1.3.7-2.6-.7-.7-4.9.7z"
      />
      <path fill="#940008" d="M259.1 261.9l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M259.8 261.9l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M271 261.9l.8.7-.7-.7z" />
      <path fill="#9c9494" d="M271.8 261.9l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M272.5 261.9l.7.7-.7-.7z" />
      <path fill="#dedede" d="M273.2 261.9l.7.7-.7-.7z" />
      <path fill="#cecece" d="M289.4 261.9l.7.7-.7-.7z" />
      <path fill="#185200" d="M290 261.9l.8.7-.7-.7z" />
      <path fill="#313931" d="M292.2 261.9l.7.7-.7-.7z" />
      <path fill="#297b00" d="M292.9 261.9l.7.7-.7-.7z" />
      <path fill="#184a00" d="M295.7 261.9l.7.7-.7-.7z" />
      <path fill="#103900" d="M297.8 261.9l.7.7-.7-.7z" />
      <path fill="#184a00" d="M300 261.9l.6.7-.7-.7z" />
      <path fill="#297b00" d="M300.6 261.9l-.7 1.3.7-1.3z" />
      <path fill="#103900" d="M304.9 261.9l.7.7-.8-.7z" />
      <path fill="#185200" d="M307.7 261.9l.7.7-.7-.7z" />
      <path fill="#184a00" d="M311.2 261.9l.7.7-.7-.7z" />
      <path fill="#319400" d="M312.6 261.9l-.7 1.3.7-1.3z" />
      <path fill="#082108" d="M313.5 262.3l.3.5-.3-.5z" />
      <path fill="#52525a" d="M314 261.9l.7.7-.7-.7z" />
      <path fill="#296300" d="M314.7 261.9l.7.7-.7-.7z" />
      <path fill="#63636b" d="M316.8 261.9l-2.1 2.7 2.1-2.7z" />
      <path fill="#295200" d="M190.2 262.6l.7.6-.7-.6z" />
      <path fill="#428c00" d="M191.6 262.6l1.4 4h.7l.7-2.7-2.8-1.3z" />
      <path fill="#295200" d="M192.3 262.6l.7.6-.7-.6z" />
      <path fill="#63636b" d="M193 262.6l.7.6-.7-.6z" />
      <path fill="#efefef" d="M193.7 262.6l.7.6-.7-.6z" />
      <path fill="#101810" d="M195.1 262.6l.7.6-.7-.6z" />
      <path fill="#efefef" d="M195.8 262.6l.7.6-.7-.6z" />
      <path fill="#425242" d="M198.6 262.6l.7.6-.7-.6z" />
      <path fill="#294200" d="M199.3 262.6l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M202.1 262.6l.7.6-.7-.6z" />
      <path fill="#001000" d="M202.8 262.6l.7.6-.7-.6z" />
      <path fill="#294200" d="M206.4 262.6l.7.6-.7-.6z" />
      <path fill="#4a1000" d="M207 262.6l.8.6-.7-.6z" />
      <path fill="#294200" d="M207.8 262.6l.7.6-.7-.6z" />
      <path fill="#631808" d="M210.6 262.6l.7.6-.7-.6z" />
      <path fill="#397b00" d="M213.2 262.8l.4.2-.4-.2z" />
      <path fill="#6b735a" d="M215.5 262.6l.7.6-.7-.6z" />
      <path fill="#efefef" d="M217 262.6l.6.6-.7-.6z" />
      <path fill="#8c8c8c" d="M217.6 262.6l.7.6-.7-.6z" />
      <path fill="#526b42" d="M218.3 262.6l.7.6-.7-.6z" />
      <path fill="#396b10" d="M219 262.6l.7.6-.7-.6z" />
      <path fill="#295200" d="M219.7 262.6l.7.6-.7-.6z" />
      <path fill="#213918" d="M220.4 262.6l.7.6-.7-.6z" />
      <path fill="#efefef" d="M221.1 262.6l.7.6-.7-.6z" />
      <path fill="#941808" d="M250 262.6l.7.6-.7-.6z" />
      <path fill="#520808" d="M252.8 262.6l-.7 1.3.7-1.3z" />
      <path fill="#ad0008" d="M253.5 262.6l.7.6-.7-.6z" />
      <path fill="#520808" d="M259.8 262.6l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M289.4 262.6l.7.6-.7-.6z" />
      <path fill="#297b00" d="M290 262.6l.8.6-.7-.6z" />
      <path fill="#184a00" d="M292.2 262.6l.7.6-.7-.6z" />
      <path fill="#296300" d="M292.9 262.6l.7.6-.7-.6z" />
      <path fill="#103900" d="M295.7 262.6l.7.6-.7-.6z" />
      <path fill="#297b00" d="M296.4 262.6l-.7 1.3.7-1.3z" />
      <path fill="#185200" d="M297.8 262.6l1.4 1.3-1.4-1.3z" />
      <path fill="#297b00" d="M298.5 262.6l.7.6-.7-.6z" />
      <path fill="#185200" d="M300.6 262.6l.7.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#297b00" d="M302.7 262.6l.7.6-.7-.6m1.4 0l1.4 1.3-1.3-1.3z" />
      <path fill="#185200" d="M304.9 262.6l.7.6-.8-.6z" />
      <path fill="#297b00" d="M307 262.6l.7.6-.7-.6z" />
      <path fill="#184a00" d="M307.7 262.6l.7.6-.7-.6z" />
      <path
        fill="#297b00"
        d="M310.5 262.6l1.4 1.3-1.4-1.3zm3.5 0l.7.6-.7-.6z"
      />
      <path fill="#dedede" d="M317.5 262.6l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M318.2 262.6l.7.6-.7-.6z" />
      <path fill="#425242" d="M319 262.6l.6.6-.7-.6z" />
      <path fill="#ada5a5" d="M319.6 262.6l.7.6-.7-.6z" />
      <path fill="#8c9c84" d="M189.5 263.2l.7.7-.7-.7z" />
      <path fill="#428c00" d="M190.2 263.2l2 3.4-2-3.4z" />
      <path fill="#103900" d="M190.9 263.2l.7.7-.7-.7z" />
      <path fill="#314231" d="M193.7 263.2l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M194.4 263.2l.7.7-.7-.7z" />
      <path fill="#295200" d="M195.1 263.2l.7.7-.7-.7z" />
      <path fill="#314231" d="M195.8 263.2l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M198 263.2l.6.7-.7-.7z" />
      <path fill="#397b00" d="M199 263.4l.6.3-.5-.2z" />
      <path fill="#dedede" d="M200 263.2l.7.7-.7-.7z" />
      <path fill="#7b8c73" d="M202.8 263.2l.7.7-.7-.7z" />
      <path fill="#295200" d="M207 263.2l1.5 1.4v-1.4H207z" />
      <path fill="#4a1000" d="M208.5 263.2l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M209.9 263.2l.7.7-.7-.7z" />
      <path fill="#526b42" d="M215.5 263.2l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M216.2 263.2l.7.7-.7-.7z" />
      <path fill="#214210" d="M217 263.2l.6.7-.7-.7z" />
      <path
        fill="#428c00"
        d="M214.8 268.6l1.4-.7v.7l-5 4c4.5-1.7 6.7-4 8.5-8l-2 1.3 1.3-2.7-4.2 5.4z"
      />
      <path fill="#294200" d="M219 263.2l-.7 1.4.7-1.4z" />
      <path fill="#397b00" d="M219.7 263.2l-.7 1.4.7-1.4z" />
      <path fill="#424242" d="M220.4 263.2l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M242.2 263.2l.7.7-.7-.7z" />
      <path fill="#845a52" d="M243 263.2l.6.7-.7-.7z" />
      <path fill="#734a42" d="M243.7 263.2l.7.7-.8-.7z" />
      <path fill="#842118" d="M244.3 263.2l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M245 263.2l.8.7-.7-.7z" />
      <path fill="#b51010" d="M245.8 263.2l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M250 263.2l.7.7-.7-.7z" />
      <path fill="#310000" d="M251.4 263.2l.7.7-.7-.7z" />
      <path fill="#310010" d="M252.8 263.2l.7.7-.7-.7z" />
      <path fill="#180821" d="M253.5 263.2l.7.7-.7-.7z" />
      <path fill="#310010" d="M254.2 263.2l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M254.9 263.2l.7.7-.7-.7z" />
      <path fill="#b51010" d="M255.6 263.2l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M259.8 263.2l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M262 263.2l.6.7-.7-.7z" />
      <path fill="#7b1008" d="M262.6 263.2l.7.7-.7-.7z" />
      <path fill="#631808" d="M263.4 263.2l.7.7-.8-.7z" />
      <path fill="#8c4a4a" d="M264 263.2l.8.7-.8-.7z" />
      <path fill="#9c9494" d="M265.5 263.2l.7.7-.7-.7z" />
      <path fill="#214210" d="M289.4 263.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M292.2 263.2l.7.7-.7-.7z" />
      <path fill="#103900" d="M292.9 263.2l.7.7-.7-.7z" />
      <path fill="#185200" d="M296.4 263.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M297.8 263.2l.7.7-.7-.7z" />
      <path fill="#184a00" d="M300.6 263.2l.7.7-.7-.7z" />
      <path fill="#103900" d="M304.4 263.7l.2.4-.2-.4m2.6-.5l.7.7-.7-.7z" />
      <path fill="#184a00" d="M312.6 263.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M316.8 263.2l.7.7-.7-.7z" />
      <path fill="#184a00" d="M317.5 263.2l.7.7-.7-.7z" />
      <path fill="#296300" d="M319.6 263.2l.7.7-.7-.7z" />
      <path fill="#63636b" d="M320.3 263.2l1.4 1.4-1.4-1.4z" />
      <path fill="#8c8c8c" d="M189.7 264.3l.2.5-.2-.5z" />
      <path fill="#295200" d="M190.9 263.9l.7.7-.7-.7z" />
      <path fill="#397b00" d="M191.6 263.9l.7.7-.7-.7z" />
      <path fill="#102110" d="M194.4 263.9l.7.7-.7-.7z" />
      <path fill="#397b00" d="M195.1 263.9v.7l2.1.6-2-1.3z" />
      <path fill="#63636b" d="M196.5 263.9l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M198 263.9l.6.7-.7-.7z" />
      <path
        fill="#428c00"
        d="M198.6 263.9v3.3h-.7l-.7-2h-.7l.7 6.7h-.7l-.7-7.3h-.7l-.7 5.3h-.7l-3.5-2.7 2 4h-.6l-2.8-3.3c2.3 8 5.7 6.8 11.3 11.3 2.1 1.6 3.5 5.2 4.9 7.4l-2.9-2 1.4 2-3.5-2 4.3 4 .7-2h.7c-1.8 3.2-5 3.6-8.5 4v-.6l1.4-1.3 3.5.6c-2.5-2.5-5.6-3-9.1-2l4.2 3.4v.6L193 296l8.4-1.3-.7 1.3h.7l4.3-2-8.5 4v.7c7.1-.9 8-3.2 12-8-.6 2.1-.6 3.3 1.4 4.7l-1.1-8 9.5-10.8-3.5 2.7 2.8-4c-4 .8-5.7 3.6-5.6 7.3l-4.2 4h-.7c1.5-4.1 5.6-6.5 4.2-11.3-3.7 2.6-4.7 5.8-5 10l-2.7-13.4.7 2.7h-.7v-1.3h-.7l.7 9.3h-.7c-2.2-5-.3-15.4-5-18.7z"
      />
      <path fill="#9c9494" d="M200 263.9l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M203 264.3l.3.5-.2-.5z" />
      <path fill="#397b00" d="M205 263.9l1.4 1.3-1.4-1.3z" />
      <path fill="#5a1008" d="M209.2 263.9l.7.7-.7-.7z" />
      <path fill="#311000" d="M209.9 263.9l.7.7-.7-.7z" />
      <path fill="#213918" d="M215.5 263.9l.7.7-.7-.7z" />
      <path fill="#295200" d="M216.2 263.9l.7.7-.7-.7z" />
      <path fill="#315221" d="M219.7 263.9l.7.7-.7-.7z" />
      <path fill="#efefef" d="M245 263.9l.8.7-.7-.7z" />
      <path fill="#9c9494" d="M245.8 263.9l.7.7-.7-.7z" />
      <path fill="#736b6b" d="M246.5 263.9l.7.7-.7-.7z" />
      <path fill="#6b2908" d="M247.2 263.9l.7.7-.7-.7z" />
      <path fill="#941808" d="M247.9 263.9l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M250.7 263.9l.7.7-.7-.7z" />
      <path fill="#000818" d="M251.4 263.9l.7.7-.7-.7z" />
      <path fill="#00216b" d="M252 263.9l-.6 1.3.7-1.3z" />
      <path
        fill="#003994"
        d="M250 287.3h.7a35.9 35.9 0 0 1 3.5-23.4c-8.3 4-7.8 16.8-4.2 23.4z"
      />
      <path fill="#52525a" d="M254.2 263.9l.7.7-.7-.7z" />
      <path fill="#9c2118" d="M254.9 263.9l.7.7-.7-.7z" />
      <path fill="#ce0008" d="M257.7 263.9l.7.7-.7-.7z" />
      <path fill="#bd0008" d="M259.1 263.9l.7.7-.7-.7z" />
      <path fill="#520808" d="M259.8 263.9l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M260.5 263.9l.7.7-.7-.7z" />
      <path fill="#7b5252" d="M261.2 263.9l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M262 263.9l.6.7-.7-.7z" />
      <path fill="#dedede" d="M262.6 263.9l.7.7-.7-.7z" />
      <path fill="#efefef" d="M279.5 263.9l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M288.7 263.9l.7.7-.7-.7z" />
      <path fill="#296300" d="M289.4 263.9l.7.7-.7-.7z" />
      <path fill="#314231" d="M290 263.9l.8.7-.7-.7z" />
      <path fill="#185200" d="M290.8 263.9l.7.7-.7-.7z" />
      <path fill="#184a00" d="M292.9 263.9l.7.7-.7-.7z" />
      <path fill="#297b00" d="M293.6 263.9l-.7 1.3.7-1.3z" />
      <path fill="#103900" d="M296.4 263.9l.7.7-.7-.7z" />
      <path fill="#184a00" d="M298.8 264.3l.2.5-.2-.5z" />
      <path fill="#185200" d="M300.6 263.9l.7.7-.7-.7z" />
      <path fill="#184a00" d="M306.5 264.3l.2.5-.2-.5z" />
      <path fill="#297b00" d="M307 263.9l.7.7-.7-.7m2.8 0l.7.7-.7-.7z" />
      <path fill="#296300" d="M314 263.9l.7.7-.7-.7z" />
      <path fill="#dedede" d="M315.4 263.9l.7.7-.7-.7z" />
      <path fill="#425242" d="M316.1 263.9l.7.7-.7-.7z" />
      <path fill="#297b00" d="M316.8 263.9l.7.7-.7-.7m3.5 0l.7.7-.7-.7z" />
      <path fill="#294200" d="M191.6 264.6l.7.6-.7-.6m2.8 0l.7.6-.7-.6z" />
      <path fill="#295200" d="M196 265l.3.5-.3-.5z" />
      <path fill="#ada5a5" d="M197.2 264.6l.7.6-.7-.6z" />
      <path fill="#526b42" d="M198 264.6l.6.6-.7-.6z" />
      <path fill="#5a6b52" d="M200 264.6l.7.6-.7-.6z" />
      <path fill="#294200" d="M205 264.6l.7.6-.7-.6m3.5 0l.7.6-.7-.6z" />
      <path fill="#397b00" d="M209.2 264.6l.7.6-.7-.6z" />
      <path fill="#295200" d="M209.9 264.6l.7.6-.7-.6z" />
      <path fill="#294200" d="M215.7 265l.3.5-.3-.5z" />
      <path fill="#397b00" d="M217.6 264.6l.7.6-.7-.6z" />
      <path fill="#295200" d="M218.3 264.6l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M219.7 264.6l.7.6-.7-.6z" />
      <path fill="#313931" d="M228.2 264.6l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M247.9 264.6l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M248.6 264.6l.7.6-.7-.6z" />
      <path fill="#733939" d="M249.3 264.6l.7.6-.7-.6z" />
      <path fill="#7b1008" d="M250 264.6l.7.6-.7-.6z" />
      <path fill="#631808" d="M250.7 264.6l.7.6-.7-.6z" />
      <path fill="#00184a" d="M253.5 264.6l.7.6-.7-.6z" />
      <path fill="#6b5252" d="M254.2 264.6l.7.6-.7-.6z" />
      <path fill="#310000" d="M257.7 264.6l.7.6-.7-.6z" />
      <path fill="#5a1010" d="M259.1 264.6l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M259.8 264.6l.7.6-.7-.6z" />
      <path fill="#63636b" d="M279.5 264.6l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M288.7 264.6l.7.6-.7-.6z" />
      <path fill="#214210" d="M289.4 264.6l.7.6-.7-.6z" />
      <path fill="#dedede" d="M290 264.6l.8.6-.7-.6z" />
      <path fill="#425242" d="M290.8 264.6l.7.6-.7-.6z" />
      <path fill="#103900" d="M293.6 264.6l.7.6-.7-.6z" />
      <path fill="#185200" d="M296.4 264.6l.7.6-.7-.6z" />
      <path fill="#297b00" d="M297.1 264.6l-.7 1.3.7-1.3z" />
      <path fill="#184a00" d="M300.9 265l.2.5-.2-.5z" />
      <path fill="#297b00" d="M303.4 264.6l1.5 1.3-1.5-1.3z" />
      <path fill="#185200" d="M304.1 264.6l.7.6-.7-.6z" />
      <path fill="#297b00" d="M305.6 264.6l1.4 1.3-1.4-1.3z" />
      <path fill="#103900" d="M310.5 264.6l.7.6-.7-.6z" />
      <path fill="#185200" d="M313.3 264.6l-2.8 3.3 2.8-3.3z" />
      <path fill="#7b7373" d="M314 264.6l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M314.7 264.6l.7.6-.7-.6z" />
      <path fill="#214210" d="M315.4 264.6l.7.6-.7-.6z" />
      <path fill="#297b00" d="M316.1 264.6l.7.6-.7-.6z" />
      <path fill="#184a00" d="M317.5 264.6l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M318.2 264.6l.7.6-.7-.6z" />
      <path fill="#395231" d="M319 264.6l.6.6-.7-.6z" />
      <path fill="#296300" d="M319.6 264.6l.7.6-.7-.6z" />
      <path fill="#297b00" d="M321.3 265l.2.5-.2-.5z" />
      <path fill="#8c8c8c" d="M321.7 264.6l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M189.7 265.7l.2.4-.2-.4z" />
      <path fill="#397b00" d="M190.2 265.2l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#295200" d="M192.3 265.2l.7.7-.7-.7z" />
      <path fill="#397b00" d="M194.2 265.5l.4.2-.4-.2z" />
      <path fill="#213918" d="M197.2 265.2l.7.7-.7-.7z" />
      <path fill="#5a5231" d="M198 265.2l.6.7-.7-.7z" />
      <path fill="#295200" d="M200 265.2l.7.7-.7-.7z" />
      <path fill="#efefef" d="M200.7 265.2l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M202.8 265.2l.7.7-.7-.7z" />
      <path fill="#397b00" d="M203.6 265.2l.7.7-.8-.7z" />
      <path fill="#103900" d="M205.7 265.2l.7.7-.7-.7z" />
      <path fill="#001000" d="M209.2 265.2l.7.7-.7-.7z" />
      <path fill="#295200" d="M212.7 265.2l-.7 1.4.7-1.4z" />
      <path fill="#103900" d="M217.6 265.2l.7.7-.7-.7z" />
      <path fill="#214210" d="M219 265.2l.7.7-.7-.7z" />
      <path fill="#efefef" d="M219.7 265.2l.7.7-.7-.7z" />
      <path fill="#b51010" d="M228.2 265.2l.7.7-.7-.7z" />
      <path fill="#733939" d="M228.9 265.2l.7.7-.7-.7z" />
      <path fill="#cecece" d="M229.6 265.2l.7.7-.7-.7m20.4 0l.7.7-.7-.7z" />
      <path fill="#001039" d="M250.7 265.2l.7.7-.7-.7z" />
      <path fill="#002984" d="M252.8 265.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M253.5 265.2l.7.7-.7-.7z" />
      <path fill="#842118" d="M254.2 265.2l.7.7-.7-.7z" />
      <path d="M257.7 265.2l.7.7-.7-.7z" />
      <path fill="#ad0008" d="M258.4 265.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M259.1 265.2l.7.7-.7-.7z" />
      <path fill="#debdb5" d="M278.1 265.2l.7.7-.7-.7z" />
      <path fill="#8c4a4a" d="M278.8 265.2l.7.7-.7-.7z" />
      <path fill="#ce1810" d="M279.5 265.2l.7.7-.7-.7z" />
      <path fill="#946b63" d="M280.5 265.7l.2.4-.2-.4z" />
      <path fill="#001000" d="M288.7 265.2l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M289.4 265.2l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#296300" d="M291.5 265.2l.7.7-.7-.7z" />
      <path fill="#184a00" d="M293.6 265.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M294.3 265.2l-.7 1.4.7-1.4z" />
      <path fill="#184a00" d="M297.1 265.2l.7.7-.7-.7z" />
      <path fill="#296300" d="M298.5 265.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M299.2 265.2l-.7 1.4.7-1.4z" />
      <path fill="#103900" d="M303.7 265.7l.2.4-.2-.4m1.9-.5l.7.7-.7-.7z" />
      <path d="M309.8 265.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M310.5 265.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M313.3 265.2l.7.7-.7-.7z" />
      <path fill="#63636b" d="M314 265.2l.7.7-.7-.7z" />
      <path fill="#296300" d="M314.7 265.2l.7.7-.7-.7z" />
      <path fill="#103900" d="M316.8 265.2l.7.7-.7-.7z" />
      <path fill="#cecece" d="M317.5 265.2l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M319.6 265.2l.7.7-.7-.7z" />
      <path fill="#294221" d="M320.3 265.2l.7.7-.7-.7z" />
      <path fill="#184a00" d="M321.7 265.2l.7.7-.7-.7z" />
      <path fill="#cecece" d="M322.4 265.2l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M186.7 265.9l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M187.8 266.1l.5.2-.5-.2z" />
      <path fill="#9c9494" d="M188.8 265.9l.7.7-.7-.7z" />
      <path fill="#294200" d="M190.2 265.9l1.4 1.3-1.4-1.3z" />
      <path fill="#103900" d="M192.3 265.9l.7.7-.7-.7z" />
      <path fill="#294200" d="M193.7 265.9l-.7 2 .7-2m2.1 0v2h.7l-.7-2z" />
      <path fill="#292100" d="M198 265.9l.6.7-.7-.7z" />
      <path fill="#9c9494" d="M200.7 265.9l.7.7-.7-.7z" />
      <path fill="#294200" d="M203.6 265.9l.7.7-.8-.7m2.9 0l.7.7-.7-.7z" />
      <path fill="#103900" d="M209.2 265.9l.7.7-.7-.7z" />
      <path fill="#397b00" d="M212.7 265.9l.7.7-.7-.7m2.6.2l.4.2-.4-.2z" />
      <path fill="#103900" d="M217 265.9l.6.7-.7-.7z" />
      <path fill="#7b7373" d="M219 265.9l.7.7-.7-.7z" />
      <path
        fill="#de2110"
        d="M228.9 265.9v10.7h-.7l-.7-9.4H221v19.4l2.9-1.3 1.4 4.7 3.5-2 .7 7.4 6.3-2c3 2 4.9 2 6.3-1.4h1.4l4.3 4-.7-12.7-12.7-.7v-.6l12 .6v-2c-9-.2-9.9-5.5-9.9-12.7l-7.7-2z"
      />
      <path fill="#b51010" d="M229.6 265.9l.7.7-.7-.7z" />
      <path fill="#7b5252" d="M230.3 265.9l.7.7-.7-.7z" />
      <path fill="#cecece" d="M231 265.9l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M250 265.9l.7.7-.7-.7z" />
      <path fill="#002984" d="M250.7 265.9l.7.7-.7-.7z" />
      <path fill="#10214a" d="M252.8 265.9l.7.7-.7-.7z" />
      <path fill="#c6b5b5" d="M253.5 265.9l.7.7-.7-.7z" />
      <path fill="#ce1810" d="M254.2 265.9l.7.7-.7-.7z" />
      <path fill="#6b0808" d="M257 265.9l.7.7-.7-.7z" />
      <path fill="#100808" d="M257.7 265.9l.7.7-.7-.7z" />
      <path fill="#5a3131" d="M258.4 265.9l.7.7-.7-.7z" />
      <path fill="#dedede" d="M276.7 265.9l.7.7-.7-.7z" />
      <path fill="#a56363" d="M277.4 265.9l.7.7-.7-.7z" />
      <path fill="#b51010" d="M278.1 265.9l.7.7-.7-.7z" />
      <path
        fill="#de2110"
        d="M271.8 268c0 6.7-.7 12.2-9.1 12.6 1.8 5.1 11 1.9 14-.8 4.1-3.7 3.5-9 3.5-13.9l-8.4 2z"
      />
      <path fill="#bdbdbd" d="M288 265.9l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M288.7 265.9l.7.7-.7-.7z" />
      <path fill="#315221" d="M291.5 265.9l.7.7-.7-.7z" />
      <path fill="#103900" d="M294.3 265.9l.7.7-.7-.7m2.8 0l.7.7-.7-.7z" />
      <path fill="#184a00" d="M299.2 265.9l.7.7-.7-.7z" />
      <path fill="#296300" d="M304.9 265.9l.7.7-.8-.7z" />
      <path fill="#185200" d="M305.6 265.9l.7.7-.7-.7z" />
      <path fill="#297b00" d="M304.1 272l6.4-6c-3.5.8-5 3-6.4 6z" />
      <path fill="#103900" d="M309 265.9l.8.7-.7-.7z" />
      <path fill="#7b7373" d="M312.6 265.9l.7.7-.7-.7z" />
      <path fill="#294221" d="M313.3 265.9l.7.7-.7-.7z" />
      <path fill="#297b00" d="M314 265.9l.7.7-.7-.7z" />
      <path fill="#185200" d="M316.1 265.9l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M316.8 265.9l.7.7-.7-.7z" />
      <path fill="#efefef" d="M320.3 265.9l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M321 265.9l.7.7-.7-.7z" />
      <path fill="#185200" d="M321.7 265.9l.7.7-.7-.7z" />
      <path fill="#294221" d="M322.4 265.9l.7.7-.7-.7z" />
      <path fill="#efefef" d="M323.1 265.9l.7.7-.7-.7m-136.4.7l.7.6-.7-.6z" />
      <path fill="#293129" d="M187.4 266.6l.7.6-.7-.6z" />
      <path fill="#428c00" d="M188.5 266.8l.5.2-.5-.2z" />
      <path fill="#397b00" d="M189.7 267l.2.5-.2-.5z" />
      <path fill="#295200" d="M190.2 266.6l.7.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#397b00" d="M192.3 266.6l.7.6-.7-.6z" />
      <path fill="#294200" d="M198 266.6l.6.6-.7-.6z" />
      <path fill="#425242" d="M200.7 266.6l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M203.6 266.6l.7.6-.8-.6z" />
      <path fill="#295200" d="M206.4 266.6l.7.6-.7-.6z" />
      <path
        fill="#294200"
        d="M209.2 266.6v2h.7l-.7-2m3 .4l.3.5-.3-.5m2.6-.4l.7.6-.7-.6z"
      />
      <path fill="#397b00" d="M216.7 266.8l.5.2-.5-.2z" />
      <path fill="#295200" d="M218.3 266.6l.7.6-.7-.6z" />
      <path fill="#dedede" d="M219 266.6l.7.6-.7-.6z" />
      <path fill="#52525a" d="M220.4 266.6l.7.6-.7-.6z" />
      <path fill="#5a3131" d="M227.5 266.6l.7.6-.7-.6z" />
      <path fill="#b51010" d="M231 266.6l.7.6-.7-.6z" />
      <path fill="#842118" d="M231.7 266.6l.7.6-.7-.6z" />
      <path fill="#8c6363" d="M232.4 266.6l.7.6-.7-.6z" />
      <path fill="#cecece" d="M233.1 266.6l.7.6-.7-.6z" />
      <path fill="#dedede" d="M249.3 266.6l.7.6-.7-.6z" />
      <path fill="#00184a" d="M250 266.6l.7.6-.7-.6z" />
      <path fill="#002984" d="M252 266.6l.8.6-.7-.6z" />
      <path fill="#8c8c8c" d="M252.8 266.6l.7.6-.7-.6z" />
      <path fill="#8c6363" d="M253.5 266.6l.7.6-.7-.6z" />
      <path fill="#941808" d="M257 266.6l.7.6-.7-.6z" />
      <path fill="#4a2129" d="M257.7 266.6l.7.6-.7-.6z" />
      <path fill="#efefef" d="M258.4 266.6l.7.6-.7-.6z" />
      <path fill="#d6a5a5" d="M274.6 266.6l.7.6-.7-.6z" />
      <path fill="#946b63" d="M275.3 266.6l.7.6-.7-.6z" />
      <path fill="#a52921" d="M276 266.6l.7.6-.7-.6z" />
      <path fill="#b51010" d="M276.7 266.6l.7.6-.7-.6z" />
      <path fill="#4a2129" d="M280.2 266.6l.7.6-.7-.6z" />
      <path fill="#42425a" d="M281 266.6v.6h6.3l-6.4-.6z" />
      <path fill="#212139" d="M287.3 266.6l.7.6-.7-.6z" />
      <path fill="#dedede" d="M290 266.6l2.2 1.3v-.7l-2.1-.6z" />
      <path fill="#8c8c8c" d="M291.5 266.6l.7.6-.7-.6z" />
      <path fill="#297b00" d="M292.2 266.6l.7.6-.7-.6z" />
      <path fill="#184a00" d="M294.3 266.6l.7.6-.7-.6z" />
      <path fill="#297b00" d="M295 266.6l-.7 1.3.7-1.3m2.1 0l.7.6-.7-.6z" />
      <path fill="#296300" d="M297.8 266.6l.7.6-.7-.6z" />
      <path fill="#103900" d="M299.2 266.6l.7.6-.7-.6z" />
      <path fill="#297b00" d="M300.6 266.6l.7.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#296300" d="M303.4 266.6l.8.6-.8-.6z" />
      <path fill="#103900" d="M304.9 266.6l.7.6-.8-.6m3.6 0l.7.6-.7-.6z" />
      <path fill="#313931" d="M311.9 266.6l.7.6-.7-.6z" />
      <path fill="#184a00" d="M312.6 266.6l.7.6-.7-.6z" />
      <path fill="#296300" d="M315.4 266.6l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M316.1 266.6l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M321.7 266.6l.7.6-.7-.6z" />
      <path fill="#424242" d="M322.4 266.6l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M323.1 266.6l.7.6-.7-.6z" />
      <path fill="#cecece" d="M187.4 267.2l.7.7-.7-.7z" />
      <path fill="#294200" d="M188 267.2l.8.7-.7-.7z" />
      <path fill="#103900" d="M188.8 267.2l.7.7-.7-.7z" />
      <path fill="#292100" d="M192.3 267.2l.7.7-.7-.7z" />
      <path
        fill="#295200"
        d="M193.7 267.2l.7.7-.7-.7m5.2.5l.2.4-.2-.4m1.8-.5l.7.7-.7-.7z"
      />
      <path fill="#dedede" d="M201.4 267.2l.7.7-.7-.7m2.1 0l.8.7-.8-.7z" />
      <path fill="#294200" d="M204.3 267.2l.6.7-.7-.7m2.9 0l.7.7-.7-.7z" />
      <path fill="#397b00" d="M214.1 267.2l.7.7-.7-.7z" />
      <path fill="#295200" d="M214.8 267.2l.7.7-.7-.7z" />
      <path fill="#294200" d="M216.2 267.2l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M218.3 267.2l.7.7-.7-.7z" />
      <path fill="#ce1810" d="M233.1 267.2l.7.7-.7-.7z" />
      <path fill="#a51008" d="M233.8 267.2l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M234.5 267.2l.7.7-.7-.7z" />
      <path fill="#943131" d="M235.7 267.5l.5.2-.5-.2z" />
      <path fill="#c6b5b5" d="M236.6 267.2l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M249.3 267.2l.7.7-.7-.7z" />
      <path fill="#001039" d="M252 267.2l.8.7-.7-.7z" />
      <path fill="#efefef" d="M252.8 267.2l.7.7-.7-.7z" />
      <path fill="#943131" d="M253.5 267.2l.7.7-.7-.7z" />
      <path fill="#ce1810" d="M256.3 267.2l1.4 6-1.4-6z" />
      <path fill="#6b0808" d="M257 267.2l1.4 1.4-1.4-1.4z" />
      <path fill="#733939" d="M257.7 267.2l.7.7-.7-.7z" />
      <path fill="#c69c94" d="M271 267.2l.8.7-.7-.7z" />
      <path fill="#ad3931" d="M272.3 267.5l.4.2-.4-.2z" />
      <path fill="#bd2110" d="M273.2 267.2l.7.7-.7-.7z" />
      <path fill="#b51010" d="M273.9 267.2l.7.7-.7-.7z" />
      <path fill="#ce1810" d="M274.6 267.2l.7.7-.7-.7z" />
      <path fill="#00184a" d="M280.2 267.2v5.4h.7l-.7-5.4z" />
      <path
        fill="#003994"
        d="M281 267.2c0 12.5-7.3 17-19.8 16.1l-.7 12.7c2.7 0 6.4.2 7-2.7l2.9 2 2.8-2.6-.7 2.6 1.4-1.3h.7l4.2-.7-.7 2 2.1-2.6 1.4 1.3h2.1v-2l1.5.7.7-6c3.5-3 1.4-15 1.4-19.5h-6.4z"
      />
      <path fill="#424242" d="M290 267.2l.8.7-.7-.7z" />
      <path fill="#185200" d="M292.2 267.2l.7.7-.7-.7m2.8 0l.7.7-.7-.7z" />
      <path fill="#184a00" d="M297.8 267.2v2h.7l-.7-2z" />
      <path fill="#185200" d="M299.2 267.2l.7.7-.7-.7z" />
      <path fill="#184a00" d="M301.3 267.2v3.4h.7l-.7-3.4z" />
      <path fill="#185200" d="M304.1 267.2l.7.7-.7-.7z" />
      <path fill="#296300" d="M304.9 267.2l.7.7-.8-.7z" />
      <path fill="#082108" d="M307.7 267.2l.7.7-.7-.7z" />
      <path d="M311.2 267.2l.7.7-.7-.7z" />
      <path fill="#296300" d="M311.9 267.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M314.7 267.2l-1.4 2 1.4-2z" />
      <path fill="#63636b" d="M315.4 267.2l.7.7-.7-.7m-127.3.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M189.5 268l1.4 1.3-1.4-1.4z" />
      <path fill="#295200" d="M190.2 268l.7.6-.7-.7z" />
      <path fill="#103900" d="M193 268l.7.6-.7-.7z" />
      <path fill="#397b00" d="M193.7 268l.7.6-.7-.7m2.1 0v1.4h1.4v-1.4h-1.4z" />
      <path fill="#8c8c8c" d="M201.4 268l.7.6-.7-.7z" />
      <path fill="#7b7373" d="M204.3 268l.6.6-.7-.7z" />
      <path fill="#103900" d="M215.5 268l.7.6-.7-.7z" />
      <path fill="#396b10" d="M217.6 268l.7.6-.7-.7z" />
      <path fill="#dedede" d="M218.3 268l.7.6-.7-.7z" />
      <path fill="#8c7373" fillOpacity={0.5} d="M236.6 268v6h.7l-.7-6z" />
      <path fill="#efefef" d="M248.6 268l.7.6-.7-.7z" />
      <path fill="#10214a" d="M249.3 268l.7.6-.7-.7z" />
      <path fill="#636b7b" d="M252 268l.8.6-.7-.7z" />
      <path fill="#ad1810" d="M253.5 268l.7.6-.7-.7z" />
      <path fill="#420000" d="M257 268l.7.6-.7-.7z" />
      <path fill="#8c8c8c" d="M290 268l.8.6-.7-.7z" />
      <path fill="#63636b" d="M290.8 268l.7.6-.7-.7z" />
      <path fill="#425242" d="M292.2 268l.7.6-.7-.7z" />
      <path fill="#103900" d="M295 268l.7.6-.7-.7z" />
      <path fill="#184a00" d="M299.2 268l.7.6-.7-.7z" />
      <path fill="#297b00" d="M303.4 268l1.5 1.3-1.5-1.4z" />
      <path
        fill="#103900"
        d="M304.1 268l.7.6-.7-.7m2.9 0l.7.7-.7-.7m2.8 0l-3.5 4 3.5-4z"
      />
      <path fill="#082108" d="M310.5 268l.7.6-.7-.7z" />
      <path fill="#297b00" d="M311.2 268l.7.6-.7-.7z" />
      <path fill="#314231" d="M314.7 268l-.7 1.3.7-1.4z" />
      <path fill="#bdbdbd" d="M188 268.6l.8.6-.7-.6z" />
      <path fill="#397b00" d="M188.8 268.6l.7.6-.7-.6m2 0l.8.6-.7-.6z" />
      <path fill="#294200" d="M194 269l.2.5-.3-.5m5 0l.2.5-.2-.5z" />
      <path fill="#526b42" d="M201.4 268.6l.7.6-.7-.6z" />
      <path fill="#efefef" d="M204.3 268.6l.6.6-.7-.6z" />
      <path fill="#314231" d="M205 268.6l.7.6-.7-.6z" />
      <path
        fill="#397b00"
        d="M209.2 268.6l.7.6-.7-.6m4.2.6v.7h2.1l-2-.6m2-.7l.7.6-.7-.6m1.4 0l.7.6-.7-.6z"
      />
      <path fill="#8c8c8c" d="M217.6 268.6l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M242.7 268.8l.5.2-.5-.2z" />
      <path fill="#8c8c8c" d="M243.7 268.6l.7.6-.8-.6z" />
      <path fill="#bdbdbd" d="M244.3 268.6l.7.6-.7-.6z" />
      <path fill="#cecece" d="M245 268.6l.8.6-.7-.6z" />
      <path fill="#9c9494" d="M248.6 268.6l.7.6-.7-.6z" />
      <path fill="#00216b" d="M249.3 268.6l.7.6-.7-.6z" />
      <path fill="#00215a" d="M251.4 268.6l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M252 268.6l.8.6-.7-.6z" />
      <path fill="#a51008" d="M253.5 268.6l.7.6-.7-.6z" />
      <path fill="#310000" d="M257 268.6l.7.6-.7-.6z" />
      <path fill="#940008" d="M257.7 268.6l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M258.4 268.6l.7.6-.7-.6z" />
      <path fill="#cecece" d="M262.6 268.6l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M263.4 268.6l.7.6-.8-.6z" />
      <path fill="#8c8c8c" d="M264.5 268.8l.5.2-.5-.2z" />
      <path fill="#7b7373" d="M265.5 268.6l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M290 268.6l.8.6-.7-.6z" />
      <path fill="#103900" d="M290.8 268.6l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M291.5 268.6l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M292.2 268.6l.7.6-.7-.6z" />
      <path fill="#297b00" d="M292.9 268.6l.7.6-.7-.6z" />
      <path fill="#296300" d="M295.5 268.8l.4.2-.4-.2z" />
      <path fill="#297b00" d="M298.5 268.6l.7.6-.7-.6z" />
      <path fill="#185200" d="M299.2 268.6l.7.6-.7-.6z" />
      <path fill="#297b00" d="M300 268.6l.6.6-.7-.6z" />
      <path fill="#103900" d="M303.4 268.6l.8.6-.8-.6m2.9 0l.7.6-.7-.6z" />
      <path fill="#efefef" d="M314.7 268.6l.7.6-.7-.6z" />
      <path fill="#396b10" d="M188.8 269.3l.7.6-.7-.6z" />
      <path fill="#103900" d="M190.9 269.3l.7.6-.7-.6z" />
      <path fill="#294200" d="M196.8 269.7l.2.5-.3-.5z" />
      <path fill="#396b10" d="M201.4 269.3l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M203.6 269.3l.7.6-.8-.6z" />
      <path fill="#dedede" d="M205 269.3l.7.6-.7-.6z" />
      <path fill="#214210" d="M205.7 269.3l2 2-2-2z" />
      <path fill="#294200" d="M208.7 269.7l.2.5-.2-.5z" />
      <path fill="#103900" d="M214.1 269.3l.7.6-.7-.6z" />
      <path fill="#314231" d="M217 269.3l.6.6-.7-.6z" />
      <path
        fill="#003994"
        d="M243 269.3c0 3.3.3 5 4.2 5.3.6-3.6-.6-4.6-4.3-5.4z"
      />
      <path fill="#002984" d="M244.3 269.3l.7.6-.7-.6z" />
      <path fill="#00216b" d="M245 269.3l.8.6-.7-.6z" />
      <path fill="#10214a" d="M245.8 269.3l.7.6-.7-.6z" />
      <path fill="#636b7b" d="M246.5 269.3l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M247.2 269.3l.7.6-.7-.6z" />
      <path fill="#efefef" d="M247.9 269.3l.7.6-.7-.6z" />
      <path fill="#31425a" d="M248.6 269.3l.7.6-.7-.6z" />
      <path fill="#21315a" d="M251.4 269.3l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M252.8 269.3l.7.6-.7-.6z" />
      <path fill="#ce1810" d="M253.5 269.3l.7.6-.7-.6z" />
      <path fill="#420000" d="M257 269.3l.7.6-.7-.6z" />
      <path fill="#ce0008" d="M257.7 269.3l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M258.4 269.3l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M260.5 269.3l.7.6-.7-.6z" />
      <path fill="#63636b" d="M261.2 269.3l.7.6-.7-.6z" />
      <path fill="#21315a" d="M262 269.3l.6.6-.7-.6z" />
      <path fill="#00216b" d="M262.6 269.3l.7.6-.7-.6z" />
      <path fill="#002984" d="M263.4 269.3l.7.6-.8-.6z" />
      <path fill="#003994" d="M259.1 270.6c1.7 5.8 6.3 4 6.3-1.4l-6.3 1.4z" />
      <path fill="#efefef" d="M290 269.3l.8.6-.7-.6z" />
      <path fill="#185200" d="M290.8 269.3l.7.6-.7-.6z" />
      <path fill="#425242" d="M291.5 269.3l.7.6-.7-.6z" />
      <path fill="#efefef" d="M292.2 269.3l.7.6-.7-.6z" />
      <path
        fill="#103900"
        d="M292.9 269.3l.7.6-.7-.6m2.8 0l.7.6-.7-.6zm9.9 0l.7.6-.7-.6z"
      />
      <path fill="#185200" d="M309 269.3l.8.6-.7-.6z" />
      <path fill="#214210" d="M313.3 269.3l.7.6-.7-.6z" />
      <path fill="#cecece" d="M314 269.3l-.7 1.3.7-1.4z" />
      <path fill="#5a6b52" d="M188.8 270l.7.6-.7-.7z" />
      <path fill="#397b00" d="M190.9 270l.7.6-.7-.7z" />
      <path
        fill="#295200"
        d="M191.6 270l.7.6-.7-.7m2.8 0l.7.7-.7-.7m4.2 0l.7.7-.7-.7z"
      />
      <path fill="#425242" d="M203.6 270l.7.6-.8-.7z" />
      <path fill="#cecece" d="M205.7 270l2 2-2-2z" />
      <path fill="#397b00" d="M212.7 270l.7.6-.7-.7z" />
      <path fill="#214210" d="M216.2 270l-.7 1.3.7-1.4z" />
      <path fill="#cecece" d="M217 270l-.8 1.3.7-1.4z" />
      <path fill="#002984" d="M247.2 270l.7.6-.7-.7z" />
      <path fill="#001039" d="M247.9 270l.7.6-.7-.7z" />
      <path fill="#00184a" d="M248.6 270l.7.6-.7-.7z" />
      <path fill="#7b7373" d="M251.4 270l.7.6-.7-.7z" />
      <path fill="#b5adad" d="M252.8 270l.7.6-.7-.7z" />
      <path fill="#6b0808" d="M257 270l.7.6-.7-.7z" />
      <path fill="#de2110" d="M257.7 270l.7.6-.7-.7z" />
      <path fill="#524242" d="M258.4 270l.7.6-.7-.7z" />
      <path fill="#525a6b" d="M259.1 270l.7.6-.7-.7z" />
      <path fill="#00184a" d="M259.8 270l.7.6-.7-.7z" />
      <path fill="#002984" d="M260.5 270l.7.6-.7-.7z" />
      <path fill="#395231" d="M290.8 270l.7.6-.7-.7z" />
      <path fill="#296300" d="M291.5 270l.7.6-.7-.7z" />
      <path fill="#9c9494" d="M292.2 270l.7.6-.7-.7z" />
      <path fill="#5a6b52" d="M292.9 270l.7.6-.7-.7z" />
      <path fill="#185200" d="M295.7 270l1.4 1.3-1.4-1.4z" />
      <path fill="#297b00" d="M296.4 270l.7.6-.7-.7z" />
      <path fill="#103900" d="M298.8 270.4l.2.4-.2-.4z" />
      <path fill="#297b00" d="M299.2 270l.7.6-.7-.7z" />
      <path fill="#103900" d="M304.9 270l.7.6-.8-.7z" />
      <path fill="#296300" d="M308.4 270l.7.6-.7-.7z" />
      <path fill="#103900" d="M312.6 270l.7.6-.7-.7z" />
      <path fill="#9c9494" d="M188.8 270.6l.7.7-.7-.7z" />
      <path fill="#294200" d="M191.6 270.6l.7.7-.7-.7m3 .4l.3.5-.3-.5z" />
      <path fill="#295200" d="M196.5 270.6l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M204.3 270.6l.6.7-.7-.7z" />
      <path fill="#397b00" d="M207.8 270.6l.7.7-.7-.7z" />
      <path fill="#295200" d="M208.5 270.6l.7.7-.7-.7z" />
      <path fill="#397b00" d="M212 270.6l.7.7-.7-.7z" />
      <path fill="#00215a" d="M247.9 270.6l.7.7-.7-.7z" />
      <path fill="#002984" d="M248.6 270.6l.7.7-.7-.7z" />
      <path fill="#00216b" d="M250.7 270.6l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M251.4 270.6l.7.7-.7-.7z" />
      <path fill="#ad0008" d="M257.7 270.6l.7.7-.7-.7z" />
      <path fill="#390821" d="M258.4 270.6l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M290.8 270.6l.7.7-.7-.7z" />
      <path fill="#319400" d="M291.5 270.6l.7.7-.7-.7z" />
      <path fill="#103910" d="M292.2 270.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M292.9 270.6l.7.7-.7-.7z" />
      <path fill="#297b00" d="M293.6 270.6l.7.7-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#184a00" d="M300 270.6l.6.7-.7-.7z" />
      <path fill="#185200" d="M301.3 270.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M304.1 270.6l.7.7-.7-.7z" />
      <path fill="#297b00" d="M307.7 270.6l.7.7-.7-.7z" />
      <path fill="#185200" d="M311.9 270.6l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M312.6 270.6l.7.7-.7-.7z" />
      <path fill="#dedede" d="M188.8 271.3l.7.6-.7-.6z" />
      <path fill="#295200" d="M189.5 271.3l.7.6-.7-.6m2.8 0l.7.6-.7-.6z" />
      <path fill="#397b00" d="M196.5 271.3l.7.6-.7-.6z" />
      <path fill="#6b735a" d="M202.8 271.3l.7.6-.7-.6z" />
      <path fill="#214210" d="M204.3 271.3l1.3 1.3-1.3-1.3z" />
      <path fill="#cecece" d="M205 271.3l1.4 1.3-1.4-1.3z" />
      <path fill="#001000" d="M207.8 271.3l.7.6-.7-.6z" />
      <path fill="#103900" d="M210.6 271.3l.7.6-.7-.6z" />
      <path fill="#397b00" d="M211.3 271.3l.7.6-.7-.6m2.1 0l.7.6-.7-.6z" />
      <path fill="#214210" d="M214.1 271.3l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M214.8 271.3l.7.6-.7-.6z" />
      <path fill="#dedede" d="M215.5 271.3l.7.6-.7-.6z" />
      <path fill="#001039" d="M247.9 271.3l.7.6-.7-.6z" />
      <path fill="#00184a" d="M250.7 271.3l.7.6-.7-.6z" />
      <path fill="#7b0008" d="M257 271.3l.7.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#efefef" d="M289.1 271.5l.5.2-.5-.2z" />
      <path fill="#9c9494" d="M290.8 271.3l.7.6-.7-.6z" />
      <path fill="#297b00" d="M292 271.5l.4.2-.4-.2z" />
      <path fill="#7b7373" d="M292.9 271.3l.7.6-.7-.6z" />
      <path fill="#185200" d="M293.6 271.3l.7.6-.7-.6z" />
      <path fill="#184a00" d="M296.6 271.7l.3.5-.3-.5m2.1 0l.3.5-.2-.5z" />
      <path fill="#296300" d="M300 271.3l.6.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#184a00" d="M303.4 271.3l.8.6-.8-.6z" />
      <path fill="#297b00" d="M307 271.3l.7.6-.7-.6z" />
      <path fill="#296300" d="M311.2 271.3l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M311.9 271.3l.7.6-.7-.6z" />
      <path fill="#dedede" d="M314.7 271.3l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M315.4 271.3l.7.6-.7-.6z" />
      <path fill="#214210" d="M316.1 271.3l.7.6-.7-.6z" />
      <path fill="#395231" d="M316.8 271.3l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M317.5 271.3l.7.6-.7-.6z" />
      <path fill="#5a5231" d="M189.5 272l.7.6-.7-.7z" />
      <path fill="#294200" d="M192.3 272l.7.6-.7-.7z" />
      <path fill="#295200" d="M194.4 272l1.4 1.3-1.4-1.4z" />
      <path
        fill="#397b00"
        d="M195.1 272l.7.6-.7-.7m3.5 0l-.7 1.4h1.4l-.7-1.4z"
      />
      <path fill="#396b10" d="M201.4 272l.7.6-.7-.7z" />
      <path fill="#526b42" d="M203 272.4l.3.4-.2-.4z" />
      <path fill="#efefef" d="M207 272l-.6 1.3.7-1.4z" />
      <path fill="#294200" d="M207.8 272l.7.6-.7-.7m2.3.5l.3.4-.3-.4z" />
      <path fill="#295200" d="M210.6 272l.7.6-.7-.7z" />
      <path fill="#294200" d="M212 272l.7.6-.7-.7z" />
      <path fill="#63636b" d="M212.7 272l.7.6-.7-.7z" />
      <path fill="#ada5a5" d="M213.4 272l.7.6-.7-.7z" />
      <path fill="#00184a" d="M247.9 272l.7.6-.7-.7z" />
      <path fill="#31425a" d="M250.7 272l.7.6-.7-.7z" />
      <path fill="#6b0808" d="M258 272.4l.2.4-.2-.4z" />
      <path fill="#bd0008" d="M258.4 272l.7.6-.7-.7z" />
      <path fill="#00215a" d="M259.1 272l.7.6-.7-.7z" />
      <path fill="#bdbdbd" d="M288.7 272l.7.6-.7-.7z" />
      <path fill="#7b7373" d="M289.4 272l.7.6-.7-.7z" />
      <path fill="#dedede" d="M290.8 272l.7.6-.7-.7z" />
      <path fill="#185200" d="M291.5 272l.7.6-.7-.7z" />
      <path fill="#184a00" d="M292.9 272l.7.6-.7-.7z" />
      <path fill="#314231" d="M293.6 272l.7.6-.7-.7z" />
      <path fill="#184a00" d="M301.3 272v2.6h.7l-.7-2.7z" />
      <path fill="#185200" d="M303.2 272.1l.5.3-.5-.2m2.4-.3l-1.5 2 1.4-2z" />
      <path fill="#296300" d="M306.3 272l.7.6-.7-.7z" />
      <path fill="#297b00" d="M310.5 272l-1.4 3.3h.7l.7-3.4z" />
      <path fill="#63636b" d="M311.2 272l.7.6-.7-.7z" />
      <path fill="#9c9494" d="M313.3 272l.7.6-.7-.7z" />
      <path fill="#425242" d="M314 272l.7.6-.7-.7z" />
      <path fill="#185200" d="M314.7 272l.7.6-.7-.7z" />
      <path fill="#297b00" d="M315.4 272l.7.6-.7-.7z" />
      <path fill="#184a00" d="M317.5 272l.7.6-.7-.7z" />
      <path fill="#cecece" d="M318.2 272l.7.6-.7-.7z" />
      <path fill="#8c8c8c" d="M189.5 272.6l.7.7-.7-.7z" />
      <path fill="#397b00" d="M192.8 272.8l.4.2-.4-.2z" />
      <path fill="#526b42" d="M201.4 272.6l.7.7-.7-.7z" />
      <path fill="#397b00" d="M204 272.8l.5.2-.5-.2z" />
      <path fill="#314231" d="M205.7 272.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M207 272.6l-.6 1.3.7-1.3z" />
      <path fill="#397b00" d="M209.2 272.6v2l2-2h-2z" />
      <path fill="#5a6b52" d="M211.3 272.6l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M212 272.6l.7.7-.7-.7z" />
      <path fill="#525a6b" d="M242.2 272.6l.7.7-.7-.7z" />
      <path fill="#00216b" d="M247.6 272.8l.5.2-.5-.2z" />
      <path fill="#7b7373" d="M250.7 272.6l.7.7-.7-.7z" />
      <path fill="#de2110" d="M258.7 273l.2.5-.2-.5z" />
      <path fill="#390821" d="M259.1 272.6l.7.7-.7-.7z" />
      <path fill="#00215a" d="M280.2 272.6l.7.7-.7-.7z" />
      <path fill="#292921" d="M289.4 272.6l.7.7-.7-.7z" />
      <path fill="#315221" d="M291.5 272.6l.7.7-.7-.7z" />
      <path fill="#297b00" d="M292.9 272.6l.7.7-.7-.7z" />
      <path fill="#001000" d="M293.6 272.6l.7.7-.7-.7z" />
      <path fill="#297b00" d="M294.3 272.6l.7.7-.7-.7z" />
      <path fill="#296300" d="M296.9 272.8l.5.2-.5-.2z" />
      <path fill="#185200" d="M298.5 272.6l.7.7-.7-.7z" />
      <path fill="#296300" d="M302.7 272.6l.7.7-.7-.7z" />
      <path fill="#425242" d="M310.5 272.6l.7.7-.7-.7z" />
      <path fill="#efefef" d="M311.2 272.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M311.9 272.6l.7.7-.7-.7z" />
      <path fill="#315221" d="M312.6 272.6l.7.7-.7-.7z" />
      <path fill="#297b00" d="M313.3 272.6l.7.7-.7-.7z" />
      <path fill="#314231" d="M318.2 272.6l.7.7-.7-.7z" />
      <path fill="#dedede" d="M189.5 273.3l.7.6-.7-.6z" />
      <path fill="#295200" d="M190.2 273.3l.7.6-.7-.6z" />
      <path fill="#103900" d="M193 273.3l.7.6-.7-.6z" />
      <path fill="#294200" d="M195.1 273.3l.7.6-.7-.6z" />
      <path fill="#295200" d="M198 273.3l.6.6-.7-.6z" />
      <path fill="#6b735a" d="M201.4 273.3l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M202.8 273.3l.7.6-.7-.6z" />
      <path fill="#294200" d="M204.5 273.7l.2.5-.2-.5z" />
      <path fill="#315221" d="M207 273.3l.8.6-.7-.6z" />
      <path fill="#103900" d="M209.2 273.3l.7.6-.7-.6z" />
      <path fill="#63636b" d="M210.6 273.3l-.7 1.3.7-1.3z" />
      <path fill="#292921" d="M212 273.3l.7.6-.7-.6z" />
      <path fill="#dedede" d="M212.7 273.3l.7.6-.7-.6z" />
      <path fill="#733939" d="M220.4 273.3l.7.6-.7-.6z" />
      <path fill="#bd2110" d="M227.5 273.3l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M242.2 273.3l.7.6-.7-.6z" />
      <path fill="#002984" d="M250 273.3l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M250.7 273.3l.7.6-.7-.6z" />
      <path fill="#b51010" d="M257 273.3l.7.6-.7-.6z" />
      <path fill="#520808" d="M257.7 273.3l.7.6-.7-.6z" />
      <path fill="#7b0008" d="M259.1 273.3l.7.6-.7-.6z" />
      <path fill="#636b7b" d="M265.5 273.3l.7.6-.7-.6z" />
      <path fill="#002984" d="M280.5 273.7l.2.5-.2-.5z" />
      <path fill="#001000" d="M289.4 273.3l.7.6-.7-.6z" />
      <path fill="#dedede" d="M290 273.3l.8.6-.7-.6z" />
      <path fill="#6b735a" d="M291.5 273.3l.7.6-.7-.6z" />
      <path fill="#185200" d="M294 273.5l.5.2-.4-.2z" />
      <path fill="#103900" d="M297.1 273.3l.7.6-.7-.6z" />
      <path fill="#297b00" d="M299.2 273.3l.7.6-.7-.6z" />
      <path fill="#293129" d="M309.8 273.3l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M310.5 273.3l.7.6-.7-.6z" />
      <path fill="#214210" d="M311.2 273.3l.7.6-.7-.6z" />
      <path fill="#297b00" d="M311.9 273.3l.7.6-.7-.6z" />
      <path fill="#185200" d="M318.2 273.3l.7.6-.7-.6z" />
      <path fill="#cecece" d="M319 273.3l.6.6-.7-.6z" />
      <path fill="#314231" d="M190.2 274l.7.6-.7-.7z" />
      <path fill="#295200" d="M193 274l.7.6-.7-.7z" />
      <path fill="#397b00" d="M195.1 274l.7.6-.7-.7z" />
      <path fill="#295200" d="M195.8 274l.7.6-.7-.7z" />
      <path fill="#294200" d="M198 274l.6.6-.7-.7z" />
      <path fill="#8c8c8c" d="M201.7 274.4l.2.4-.2-.4m1.1-.5l.7.7-.7-.7z" />
      <path fill="#294200" d="M206.4 274l.7.6-.7-.7z" />
      <path fill="#397b00" d="M207 274l-.6 3.3h.7v-3.4z" />
      <path fill="#294200" d="M208.7 274.4l.2.4-.2-.4z" />
      <path fill="#bdbdbd" d="M211.3 274l.7.6-.7-.7z" />
      <path fill="#294200" d="M212.2 274.4l.3.4-.3-.4z" />
      <path fill="#bdbdbd" d="M212.7 274l.7.6-.7-.7m5.6 0l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M219 274l.7.6-.7-.7z" />
      <path fill="#315221" d="M219.7 274l.7.6-.7-.7z" />
      <path fill="#310000" d="M220.4 274l.7.6-.7-.7z" />
      <path fill="#a51008" d="M228.2 274l.7.6-.7-.7z" />
      <path fill="#845a52" d="M236.6 274l.7.6-.7-.7z" />
      <path fill="#dedede" d="M242.2 274l.7.6-.7-.7z" />
      <path fill="#10214a" d="M243 274l.6.6-.7-.7z" />
      <path fill="#00216b" d="M250 274l.7.6-.7-.7z" />
      <path fill="#bdbdbd" d="M250.7 274l.7.6-.7-.7z" />
      <path fill="#a51008" d="M257 274l.7.6-.7-.7z" />
      <path fill="#940008" d="M257.7 274l1.4 1.3-1.4-1.4z" />
      <path fill="#bd0008" d="M258.9 274.2l.5.2-.5-.2z" />
      <path fill="#00215a" d="M259.8 274l.7.6-.7-.7z" />
      <path fill="#10214a" d="M264.8 274l.6.6-.6-.7z" />
      <path fill="#cecece" d="M265.5 274l-.7 1.3.7-1.4z" />
      <path fill="#103900" d="M289.4 274l.7.6-.7-.7z" />
      <path fill="#8c8c8c" d="M290 274l.8.6-.7-.7z" />
      <path fill="#9c9494" d="M291.5 274l.7.6-.7-.7z" />
      <path fill="#297b00" d="M292.2 274l.7.6-.7-.7z" />
      <path fill="#103900" d="M294.3 274l.7.6-.7-.7z" />
      <path fill="#184a00" d="M297.1 274l.7.6-.7-.7zm7 0l.8.6-.7-.7z" />
      <path fill="#103900" d="M309 274l.8.6-.7-.7z" />
      <path fill="#184a00" d="M309.8 274l.7.6-.7-.7z" />
      <path
        fill="#297b00"
        d="M310.5 274l.7.6-.7-.7m6 .3l.6.2-.5-.2m1.6-.3l.7.7-.7-.7z"
      />
      <path fill="#7b7373" d="M319 274l.6.6-.7-.7z" />
      <path fill="#bdbdbd" d="M190.2 274.6l.7.7-.7-.7z" />
      <path fill="#295200" d="M190.9 274.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M193.7 274.6l.7.7-.7-.7z" />
      <path fill="#294200" d="M195.8 274.6l1.4 1.3-1.4-1.3z" />
      <path fill="#397b00" d="M196.5 274.6l.7.7-.7-.7z" />
      <path fill="#295200" d="M198 274.6l-.8 2 .7-2z" />
      <path fill="#bdbdbd" d="M202.8 274.6l.7.7-.7-.7z" />
      <path fill="#397b00" d="M203.6 274.6l.7.7-.8-.7z" />
      <path fill="#295200" d="M205 274.6l.7.7-.7-.7z" />
      <path fill="#738c63" d="M209.2 274.6l.7.7-.7-.7z" />
      <path fill="#cecece" d="M210.6 274.6l-2.8 3.4 2.8-3.4z" />
      <path fill="#214210" d="M211.3 274.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M213 275l.2.5-.3-.5z" />
      <path fill="#efefef" d="M215.5 274.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M216.2 274.6l.7.7-.7-.7z" />
      <path fill="#315221" d="M217 274.6l.6.7-.7-.7z" />
      <path fill="#294200" d="M217.6 274.6v2h.7l-.7-2z" />
      <path fill="#397b00" d="M218.8 274.8l.5.2-.5-.2z" />
      <path fill="#214210" d="M219.7 274.6l.7.7-.7-.7z" />
      <path fill="#733939" d="M220.4 274.6l.7.7-.7-.7z" />
      <path fill="#941808" d="M228.2 274.6l.7.7-.7-.7z" />
      <path fill="#943131" d="M236.6 274.6l.7.7-.7-.7z" />
      <path fill="#cecece" d="M243 274.6l.6.7-.7-.7z" />
      <path fill="#636b7b" d="M243.7 274.6l.7.7-.8-.7z" />
      <path fill="#10295a" d="M244.3 274.6l.7.7-.7-.7z" />
      <path fill="#00184a" d="M245.5 274.8l.5.2-.5-.2z" />
      <path fill="#001039" d="M246.5 274.6l.7.7-.7-.7z" />
      <path fill="#00215a" d="M250 274.6l.7.7-.7-.7z" />
      <path fill="#efefef" d="M250.7 274.6l.7.7-.7-.7z" />
      <path fill="#b51010" d="M257 274.6l.7.7-.7-.7z" />
      <path fill="#bd0008" d="M257.7 274.6l.7.7-.7-.7z" />
      <path fill="#de2110" d="M259.1 274.6l2.8 7.4-2.8-7.4z" />
      <path fill="#391810" d="M259.8 274.6l.7.7-.7-.7z" />
      <path fill="#636b7b" d="M260.5 274.6l.7.7-.7-.7z" />
      <path fill="#21315a" d="M261.2 274.6l.7.7-.7-.7z" />
      <path fill="#525a6b" d="M264 274.6l.8.7-.8-.7z" />
      <path fill="#9c4a42" d="M271 274.6l.8.7-.7-.7z" />
      <path fill="#ce1810" d="M279.5 274.6l.7.7-.7-.7z" />
      <path fill="#184a00" d="M289.6 275l.2.5-.2-.5z" />
      <path fill="#395231" d="M290 274.6l.8.7-.7-.7z" />
      <path fill="#dedede" d="M291.5 274.6l-.7 1.3.7-1.3z" />
      <path fill="#296300" d="M292.2 274.6l.7.7-.7-.7z" />
      <path fill="#184a00" d="M294.3 274.6l.7.7-.7-.7z" />
      <path fill="#185200" d="M297.1 274.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M303.4 274.6l.8.7-.8-.7z" />
      <path fill="#296300" d="M307.9 275l.2.5-.2-.5z" />
      <path fill="#103900" d="M308.4 274.6l.7.7-.7-.7z" />
      <path fill="#185200" d="M314.7 274.6l.7.7-.7-.7z" />
      <path fill="#425242" d="M315.4 274.6l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M316.1 274.6l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M316.8 274.6l.7.7-.7-.7z" />
      <path fill="#185200" d="M317.5 274.6l1.4 1.3-1.4-1.3z" />
      <path fill="#315221" d="M319 274.6l.6.7-.7-.7z" />
      <path fill="#7b7373" d="M190.9 275.3l.7.6-.7-.6z" />
      <path
        fill="#397b00"
        d="M191.6 275.3l1.4 1.3-1.4-1.3m2.1 0l2.1 1.3v-.7l-2.1-.6z"
      />
      <path fill="#294200" d="M194.4 275.3l.7.6-.7-.6z" />
      <path fill="#397b00" d="M197.2 275.3l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M201.4 275.3l.7.6-.7-.6z" />
      <path fill="#efefef" d="M202.8 275.3l.7.6-.7-.6z" />
      <path fill="#295200" d="M203.6 275.3l.7.6-.8-.6z" />
      <path fill="#294200" d="M205 275.3v2h.7l-.7-2z" />
      <path fill="#295200" d="M207.8 275.3l.7.6-.7-.6z" />
      <path fill="#396b10" d="M208.5 275.3l.7.6-.7-.6z" />
      <path fill="#efefef" d="M209.2 275.3l.7.6-.7-.6z" />
      <path fill="#214210" d="M210.6 275.3l.7.6-.7-.6z" />
      <path fill="#295200" d="M212 275.3l.7.6-.7-.6z" />
      <path fill="#efefef" d="M214.1 275.3l-.7 1.3.7-1.3z" />
      <path fill="#63636b" d="M214.8 275.3l.7.6-.7-.6z" />
      <path fill="#396b10" d="M215.5 275.3l.7.6-.7-.6z" />
      <path fill="#295200" d="M219 275.3l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M219.7 275.3l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M228.2 275.3l.7.6-.7-.6z" />
      <path fill="#a51008" d="M236.6 275.3l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M246.5 275.3l.7.6-.7-.6z" />
      <path fill="#00216b" d="M247.2 275.3l.7.6-.7-.6z" />
      <path fill="#00184a" d="M250 275.3l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M252.8 275.3l.7.6-.7-.6z" />
      <path fill="#a51008" d="M257 275.3l.7.6-.7-.6z" />
      <path fill="#6b0808" d="M258.7 275.7l.2.5-.2-.5z" />
      <path fill="#7b0008" d="M259.8 275.3l.7.6-.7-.6z" />
      <path fill="#dedede" d="M260.5 275.3l.7.6-.7-.6z" />
      <path fill="#ad3931" d="M271 275.3l.8.6-.7-.6z" />
      <path fill="#842118" d="M279.5 275.3l.7.6-.7-.6z" />
      <path fill="#185200" d="M290 275.3l.8.6-.7-.6z" />
      <path fill="#184a00" d="M292.2 275.3l.7.6-.7-.6z" />
      <path fill="#296300" d="M294.8 275.5l.4.2-.4-.2z" />
      <path fill="#185200" d="M299.2 275.3l.7.6-.7-.6z" />
      <path fill="#297b00" d="M306.3 275.3l1.4 1.3-1.4-1.3z" />
      <path fill="#103900" d="M307 275.3l.7.6-.7-.6z" />
      <path fill="#296300" d="M313.3 275.3l.7.6-.7-.6z" />
      <path fill="#425242" d="M314 275.3l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M314.7 275.3l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M317.5 275.3l.7.6-.7-.6z" />
      <path fill="#296300" d="M319 275.3l.6.6-.7-.6z" />
      <path fill="#cecece" d="M319.6 275.3l.7.6-.7-.6z" />
      <path fill="#dedede" d="M324.6 275.3l.6.6-.6-.6z" />
      <path fill="#8c8c8c" d="M325.5 275.7l.2.5-.2-.5z" />
      <path fill="#63636b" d="M191.6 276l.7.6-.7-.7z" />
      <path fill="#001000" d="M198 276l.6.6-.7-.7z" />
      <path fill="#397b00" d="M200.7 276l.7.6-.7-.7z" />
      <path fill="#bdbdbd" d="M201.4 276l.7.6-.7-.7z" />
      <path fill="#294200" d="M203.6 276l.7.6-.8-.7z" />
      <path fill="#103900" d="M207.8 276l.7.6-.7-.7z" />
      <path fill="#bdc6ad" d="M208.5 276l.7.6-.7-.7z" />
      <path fill="#214210" d="M209.9 276l.7.6-.7-.7z" />
      <path fill="#295200" d="M211.3 276l.7.6-.7-.7z" />
      <path fill="#526b42" d="M213 276.4l.2.4-.3-.4z" />
      <path fill="#314231" d="M214.1 276l.7.6-.7-.7z" />
      <path fill="#397b00" d="M218.3 276l.7.6-.7-.7z" />
      <path fill="#214210" d="M219 276l.7.6-.7-.7z" />
      <path fill="#ce2110" d="M228.2 276l.7.6-.7-.7z" />
      <path fill="#ce1810" d="M236.6 276l.7.6-.7-.7z" />
      <path fill="#a59494" d="M237.3 276l.7.6-.7-.7z" />
      <path fill="#9c9494" d="M246.5 276l.7.6-.7-.7z" />
      <path fill="#002984" d="M247.2 276l.7.6-.7-.7z" />
      <path fill="#10295a" d="M250 276l.7.6-.7-.7z" />
      <path fill="#c6b5b5" d="M252.8 276l.7.6-.7-.7z" />
      <path fill="#ce1810" d="M253.7 276.4l.3.4-.3-.4z" />
      <path fill="#bd0008" d="M259.8 276l.7.6-.7-.7z" />
      <path fill="#8c8c8c" d="M260.5 276l.7.6-.7-.7z" />
      <path fill="#debdb5" d="M270.4 276l.7.6-.7-.7z" />
      <path fill="#ce1810" d="M271 276l.8.6-.7-.7z" />
      <path fill="#00184a" d="M279.5 276l.7.6-.7-.7z" />
      <path fill="#5a7b42" d="M289.4 276l.7.6-.7-.7z" />
      <path fill="#297b00" d="M290 276l.8.6-.7-.7z" />
      <path fill="#8c8c8c" d="M290.8 276l.7.6-.7-.7z" />
      <path fill="#315221" d="M292.2 276l.7.6-.7-.7z" />
      <path fill="#297b00" d="M294.3 276l.7.6-.7-.7z" />
      <path fill="#184a00" d="M295 276v2h.7l-.7-2z" />
      <path fill="#185200" d="M298 276.4l.3.4-.2-.4z" />
      <path fill="#296300" d="M299.2 276l.7.6-.7-.7z" />
      <path fill="#184a00" d="M302 276l.7.6-.7-.7z" />
      <path fill="#185200" d="M305.6 276l.7.6-.7-.7z" />
      <path fill="#184a00" d="M306.3 276l.7.6-.7-.7z" />
      <path fill="#296300" d="M311.9 276l.7.6-.7-.7z" />
      <path fill="#395231" d="M312.6 276l.7.6-.7-.7z" />
      <path fill="#bdbdbd" d="M313.3 276l.7.6-.7-.7z" />
      <path fill="#63636b" d="M318.2 276l.7.6-.7-.7z" />
      <path fill="#297b00" d="M319 276l.6.6-.7-.7z" />
      <path fill="#63636b" d="M319.6 276l.7.6-.7-.7z" />
      <path fill="#dedede" d="M322.4 276l.7.6-.7-.7z" />
      <path fill="#8c8c8c" d="M323.1 276l.7.6-.7-.7z" />
      <path fill="#314231" d="M323.9 276l.7.6-.8-.7z" />
      <path fill="#001000" d="M324.6 276l.6.6-.6-.7z" />
      <path fill="#8c8c8c" d="M192.3 276.6l.7.7-.7-.7z" />
      <path fill="#214210" d="M193 276.6l.7.7-.7-.7z" />
      <path fill="#397b00" d="M198 276.6l.6.7-.7-.7z" />
      <path fill="#294200" d="M198.9 277l.2.5-.2-.4z" />
      <path fill="#8c8c8c" d="M201.4 276.6l.7.7-.7-.7z" />
      <path fill="#5a5231" d="M203.6 276.6l.7.7-.8-.7z" />
      <path fill="#295200" d="M207 276.6l-.6 1.3.7-1.3z" />
      <path fill="#425242" d="M207.8 276.6l.7.7-.7-.7z" />
      <path fill="#214210" d="M209.2 276.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M211.3 276.6l.7.7-.7-.7z" />
      <path fill="#425242" d="M213.4 276.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M217 276.6l.6.7-.7-.7z" />
      <path fill="#397b00" d="M217.6 276.6l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M219 276.6l.7.7-.7-.7z" />
      <path fill="#a51008" d="M228.9 276.6l.7.7-.7-.7z" />
      <path fill="#842118" d="M237.3 276.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M246.5 276.6l.7.7-.7-.7z" />
      <path fill="#42425a" d="M250 276.6v5.4h.7l-.7-5.4z" />
      <path fill="#bdbdbd" d="M252.8 276.6l.7.7-.7-.7z" />
      <path fill="#a51008" d="M257 276.6l.7.7-.7-.7z" />
      <path fill="#ad0008" d="M259.1 276.6l.7.7-.7-.7z" />
      <path fill="#733939" d="M260.5 276.6l.7.7-.7-.7z" />
      <path fill="#9c4239" d="M270.4 276.6l.7.7-.7-.7z" />
      <path fill="#ce1810" d="M278.8 276.6l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M288 276.6l1.4 1.3-1.4-1.3z" />
      <path fill="#4a6342" d="M289.6 277l.2.5-.2-.4z" />
      <path fill="#314231" d="M290.8 276.6l.7.7-.7-.7z" />
      <path fill="#4a6342" d="M292.2 276.6l.7.7-.7-.7z" />
      <path fill="#296300" d="M301.3 276.6l.7.7-.7-.7z" />
      <path fill="#185200" d="M302 276.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M304.9 276.6l.7.7-.8-.7z" />
      <path fill="#296300" d="M305.6 276.6l.7.7-.7-.7m4.9 0l.7.7-.7-.7z" />
      <path fill="#294221" d="M311.2 276.6l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M311.9 276.6l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M319 276.6l.6.7-.7-.7z" />
      <path fill="#52525a" d="M319.6 276.6l.7.7-.7-.7z" />
      <path fill="#cecece" d="M320.3 276.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M321 276.6l.7.7-.7-.7z" />
      <path fill="#314231" d="M321.7 276.6l.7.7-.7-.7z" />
      <path fill="#185200" d="M322.7 277l.2.5-.2-.4z" />
      <path fill="#296300" d="M323.1 276.6l.7.7-.7-.7z" />
      <path fill="#294221" d="M323.9 276.6l.7.7-.8-.7z" />
      <path fill="#bdbdbd" d="M324.6 276.6l.6.7-.6-.7z" />
      <path fill="#efefef" d="M193 277.3l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M193.7 277.3l.7.6-.7-.6z" />
      <path fill="#5a5231" d="M194.4 277.3l.7.6-.7-.6z" />
      <path fill="#295200" d="M195.1 277.3l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M201.4 277.3l.7.6-.7-.6z" />
      <path fill="#526b42" d="M203.6 277.3l.7.6-.8-.6z" />
      <path fill="#213918" d="M207 277.3l.8.6-.7-.6z" />
      <path fill="#315221" d="M208.5 277.3l.7.6-.7-.6z" />
      <path fill="#295200" d="M210.6 277.3l.7.6-.7-.6z" />
      <path fill="#397b00" d="M211.3 277.3l.7.6-.7-.6z" />
      <path fill="#292100" d="M212.7 277.3l.7.6-.7-.6z" />
      <path fill="#397b00" d="M213.4 277.3l.7.6-.7-.6z" />
      <path fill="#295200" d="M216.2 277.3l.7.6-.7-.6z" />
      <path fill="#397b00" d="M217 277.3l.6.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M219 277.3l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M228.9 277.3l.7.6-.7-.6z" />
      <path fill="#ce1810" d="M237.3 277.3l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M238 277.3l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M246.5 277.3l.7.6-.7-.6z" />
      <path fill="#efefef" d="M252.8 277.3l.7.6-.7-.6z" />
      <path fill="#b51010" d="M253.5 277.3l.7.6-.7-.6z" />
      <path fill="#ad0008" d="M257.7 277.3l.7.6-.7-.6z" />
      <path fill="#bd0008" d="M258.4 277.3l.7.6-.7-.6z" />
      <path fill="#7b0008" d="M259.1 277.3l.7.6-.7-.6z" />
      <path fill="#940008" d="M260.5 277.3l.7.6-.7-.6z" />
      <path fill="#dedede" d="M261.2 277.3l.7.6-.7-.6z" />
      <path fill="#a5847b" d="M269.7 277.3l-.7 1.3.7-1.3z" />
      <path fill="#ce1810" d="M270.4 277.3l.7.6-.7-.6z" />
      <path fill="#392121" d="M278.8 277.3l.7.6-.7-.6z" />
      <path fill="#103910" d="M288 277.3l.7.6-.7-.6z" />
      <path fill="#185200" d="M290.8 277.3l.7.6-.7-.6z" />
      <path fill="#efefef" d="M291.5 277.3l.7.6-.7-.6z" />
      <path fill="#6b735a" d="M292.2 277.3l.7.6-.7-.6z" />
      <path fill="#184a00" d="M298 277.7l.3.5-.2-.5z" />
      <path fill="#297b00" d="M300.6 277.3l1.4 1.3-1.4-1.3z" />
      <path fill="#103900" d="M301.3 277.3l.7.6-.7-.6m2.8 0l.7.6-.7-.6z" />
      <path fill="#297b00" d="M309 277.3l.8.6-.7-.6z" />
      <path fill="#214210" d="M309.8 277.3l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M310.5 277.3l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M316.6 277.5l.4.2-.4-.2z" />
      <path fill="#8c8c8c" d="M317.5 277.3l.7.6-.7-.6z" />
      <path fill="#6b735a" d="M318.2 277.3l.7.6-.7-.6z" />
      <path fill="#4a6342" d="M319 277.3l.6.6-.7-.6z" />
      <path fill="#184a00" d="M319.6 277.3l.7.6-.7-.6z" />
      <path fill="#296300" d="M320.3 277.3l.7.6-.7-.6z" />
      <path fill="#297b00" d="M321 277.3l-.7 1.3.7-1.3z" />
      <path fill="#319400" d="M321.7 277.3l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M323.1 277.3l.7.6-.7-.6z" />
      <path fill="#efefef" d="M323.9 277.3l.7.6-.8-.6z" />
      <path fill="#dedede" d="M195.1 278l.7.6-.7-.7z" />
      <path fill="#8c8c8c" d="M195.8 278l.7.6-.7-.7z" />
      <path fill="#5a5231" d="M196.5 278l.7.6-.7-.7z" />
      <path fill="#295200" d="M197.2 278l.7.6-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#315221" d="M201.4 278l.7.6-.7-.7z" />
      <path fill="#292100" d="M206.4 278l.7.6-.7-.7z" />
      <path fill="#8c8c8c" d="M207 278l.8.6-.7-.7z" />
      <path fill="#63636b" d="M207.8 278l.7.6-.7-.7z" />
      <path fill="#294200" d="M210.6 278l.7.6-.7-.7m2 0l.8.7-.7-.7z" />
      <path fill="#397b00" d="M215.5 278l.7.6-.7-.7z" />
      <path fill="#294200" d="M216.2 278l.7.6-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#941808" d="M229.6 278l.7.6-.7-.7z" />
      <path fill="#b51010" d="M238 278l1.4 1.3-1.4-1.4z" />
      <path fill="#a59494" d="M238.7 278l.7.6-.7-.7z" />
      <path fill="#a51008" d="M253.5 278l.7.6-.7-.7z" />
      <path fill="#de2110" d="M258.4 278v9.3h2.1l-2-9.4z" />
      <path fill="#6b0808" d="M259.4 278.4l.2.5-.2-.5z" />
      <path fill="#ce0008" d="M260.5 278l.7.6-.7-.7z" />
      <path fill="#7b7373" d="M261.2 278l.7.6-.7-.7z" />
      <path fill="#ce1810" d="M269.7 278l.7.6-.7-.7z" />
      <path fill="#ad1810" d="M278.1 278l.7.6-.7-.7z" />
      <path fill="#5a6b52" d="M288 278l.7.6-.7-.7z" />
      <path fill="#185200" d="M288.7 278l.7.6-.7-.7z" />
      <path fill="#103910" d="M289.4 278l.7.6-.7-.7z" />
      <path fill="#297b00" d="M290.8 278l.7.6-.7-.7z" />
      <path fill="#9c9494" d="M291.5 278l.7.6-.7-.7z" />
      <path fill="#8c9c84" d="M292.4 278.4l.3.5-.3-.5z" />
      <path fill="#296300" d="M295 278l.7.6-.7-.7z" />
      <path fill="#297b00" d="M295.7 278l-.7 1.3.7-1.4z" />
      <path fill="#185200" d="M300.6 278l.7.6-.7-.7m2.1 0l-2 2.7 2-2.7z" />
      <path fill="#184a00" d="M303.4 278l.8.6-.8-.7z" />
      <path fill="#297b00" d="M307.7 278l.7.6-.7-.7z" />
      <path fill="#214210" d="M308.4 278l.7.6-.7-.7z" />
      <path fill="#8c8c8c" d="M309 278l.8.6-.7-.7z" />
      <path fill="#cecece" d="M309.8 278l.7.6-.7-.7z" />
      <path fill="#bdbdbd" d="M310.5 278l.7.6-.7-.7z" />
      <path fill="#8c8c8c" d="M311.6 278.2l.5.2-.5-.2z" />
      <path fill="#6b735a" d="M312.6 278l.7.6-.7-.7z" />
      <path fill="#4a6342" d="M313.3 278l.7.6-.7-.7z" />
      <path fill="#426331" d="M314 278l.7.6-.7-.7z" />
      <path fill="#184a00" d="M314.7 278l.7.6-.7-.7z" />
      <path fill="#185200" d="M315.4 278l.7.6-.7-.7z" />
      <path fill="#296300" d="M316.6 278.2l.4.2-.4-.2z" />
      <path fill="#184a00" d="M321 278l.7.6-.7-.7z" />
      <path fill="#63636b" d="M321.7 278l.7.6-.7-.7z" />
      <path fill="#dedede" d="M322.4 278l.7.6-.7-.7m-125.2.7l.7.7-.7-.7z" />
      <path fill="#52525a" d="M198 278.6l.6.7-.7-.7z" />
      <path fill="#103900" d="M198.6 278.6l.7.7-.7-.7z" />
      <path fill="#422100" d="M199.3 278.6l.7.7-.7-.7z" />
      <path fill="#294200" d="M200 278.6l1.4 1.4-1.4-1.4z" />
      <path fill="#397b00" d="M201.4 278.6l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M202.1 278.6l.7.7-.7-.7z" />
      <path fill="#293129" d="M206.4 278.6l.7.7-.7-.7z" />
      <path fill="#dedede" d="M207 278.6l.8.7-.7-.7z" />
      <path fill="#295200" d="M207.8 278.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M209.9 278.6l.7.7-.7-.7z" />
      <path fill="#295200" d="M212.7 278.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M215.5 278.6l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M218.3 278.6l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M229.6 278.6l.7.7-.7-.7z" />
      <path fill="#b51010" d="M230.3 278.6l1.4 2-1.4-2z" />
      <path fill="#8c7373" d="M239.4 278.6l.7.7-.7-.7z" />
      <path fill="#efefef" d="M240.1 278.6l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M253.5 278.6l.7.7-.7-.7z" />
      <path fill="#a51008" d="M258 279l.2.5-.2-.4z" />
      <path fill="#6b2131" d="M261.2 278.6l.7.7-.7-.7z" />
      <path fill="#946b63" d="M268.3 278.6l.7.7-.7-.7z" />
      <path fill="#ce1810" d="M269 278.6l.7.7-.7-.7m8.4 0l-.7 1.4.7-1.4z" />
      <path fill="#00216b" d="M278.1 278.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M288 278.6l.7.7-.7-.7z" />
      <path fill="#319400" d="M288.7 278.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M289.4 278.6l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M291.5 278.6l.7.7-.7-.7z" />
      <path fill="#185200" d="M296 279l.2.5-.3-.4m2-.5l.6.7-.7-.7z" />
      <path fill="#297b00" d="M306.3 278.6l.7.7-.7-.7z" />
      <path fill="#184a00" d="M307 278.6l.7.7-.7-.7z" />
      <path fill="#001000" d="M307.7 278.6l.7.7-.7-.7z" />
      <path fill="#395231" d="M308.4 278.6l.7.7-.7-.7z" />
      <path fill="#184a00" d="M309 278.6l.8.7-.7-.7z" />
      <path fill="#185200" d="M309.8 278.6l.7.7-.7-.7z" />
      <path fill="#296300" d="M310.5 278.6l.7.7-.7-.7z" />
      <path fill="#297b00" d="M319 278.6l.6.7-.7-.7z" />
      <path fill="#184a00" d="M319.6 278.6l.7.7-.7-.7z" />
      <path fill="#63636b" d="M320.3 278.6l.7.7-.7-.7z" />
      <path fill="#dedede" d="M321 278.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M198 279.3l.6.7-.7-.7z" />
      <path fill="#bd2110" d="M198.6 279.3l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M200 279.3l.7.7-.7-.7z" />
      <path fill="#425242" d="M202.1 279.3l.7.7-.7-.7z" />
      <path fill="#397b00" d="M205.7 279.3l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M206.4 279.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M207 279.3l.8.7-.7-.7z" />
      <path fill="#397b00" d="M209.7 279.5l.4.2-.4-.2m2.8 0l.4.2-.4-.2z" />
      <path fill="#103900" d="M214.8 279.3l.7.7-.7-.7z" />
      <path fill="#397b00" d="M217.6 279.3l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M218.3 279.3l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M240.1 279.3l.7.7-.7-.7z" />
      <path fill="#8c7373" d="M240.8 279.3l.7.7-.7-.7z" />
      <path fill="#efefef" d="M241.5 279.3l.7.7-.7-.7z" />
      <path fill="#943131" d="M253.7 279.7l.3.5-.3-.5z" />
      <path fill="#940008" d="M259.1 279.3l.7.7-.7-.7z" />
      <path fill="#ad0008" d="M259.8 279.3l.7.7-.7-.7z" />
      <path fill="#940008" d="M261.2 279.3l.7.7-.7-.7z" />
      <path fill="#cecece" d="M262 279.3l.6.7-.7-.7z" />
      <path fill="#a5847b" d="M266.9 279.3l.7.7-.7-.7z" />
      <path fill="#9c2118" d="M267.6 279.3l.7.7-.7-.7z" />
      <path fill="#00216b" d="M277.4 279.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M288.2 279.7l.2.5-.2-.5z" />
      <path fill="#297b00" d="M288.7 279.3v.7h2v-.7h-2z" />
      <path fill="#185200" d="M289.4 279.3l.7.7-.7-.7z" />
      <path fill="#184a00" d="M291.5 279.3l.7.7-.7-.7z" />
      <path fill="#395231" d="M292.2 279.3l.7.7-.7-.7z" />
      <path fill="#184a00" d="M297.8 279.3l.7.7-.7-.7m7.8 0l.7.7-.7-.7z" />
      <path fill="#082108" d="M306.3 279.3l.7.7-.7-.7z" />
      <path fill="#185200" d="M307 279.3l.7.7-.7-.7z" />
      <path fill="#297b00" d="M317.5 279.3l.7.7-.7-.7z" />
      <path fill="#214210" d="M318.2 279.3l.7.7-.7-.7z" />
      <path fill="#63636b" d="M319 279.3l.6.7-.7-.7z" />
      <path fill="#dedede" d="M319.6 279.3l.7.7-.7-.7z" />
      <path fill="#52525a" d="M198 280l.6.6-.7-.6z" />
      <path fill="#422100" d="M200.7 280l.7.6-.7-.6z" />
      <path fill="#295200" d="M202.1 280l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M202.8 280l.7.6-.7-.6z" />
      <path fill="#214210" d="M205.7 280l.7.6-.7-.6z" />
      <path fill="#314231" d="M207 280l.8.6-.7-.6z" />
      <path fill="#294200" d="M209.2 280l.7.6-.7-.6z" />
      <path fill="#103900" d="M212 280l.7.6-.7-.6z" />
      <path fill="#294200" d="M214.1 280l.7.6-.7-.6z" />
      <path fill="#397b00" d="M214.8 280l.7.6-.7-.6z" />
      <path fill="#396b10" d="M217.6 280l.7.6-.7-.6z" />
      <path fill="#efefef" d="M218.3 280l.7.6-.7-.6z" />
      <path fill="#a51008" d="M231.7 280l.7.6-.7-.6m9.8 0l.7.6-.7-.6z" />
      <path fill="#9c2929" d="M242.2 280l.7.6-.7-.6z" />
      <path fill="#845a52" d="M243 280l.6.6-.7-.6z" />
      <path fill="#a59494" d="M243.7 280l.7.6-.8-.6z" />
      <path fill="#c6b5b5" d="M244.3 280l.7.6-.7-.6z" />
      <path fill="#8c7373" d="M245.5 280.2l.5.2-.5-.2z" />
      <path fill="#212139" d="M246.5 280l.7.6-.7-.6z" />
      <path fill="#b51010" d="M257.7 280l.7.6-.7-.6z" />
      <path fill="#ce0008" d="M259.1 280l.7.6-.7-.6z" />
      <path fill="#6b0808" d="M259.8 280l.7.6-.7-.6z" />
      <path fill="#ce0008" d="M261.2 280l.7.6-.7-.6z" />
      <path fill="#734a42" d="M262 280l.6.6-.7-.6z" />
      <path fill="#946b63" d="M262.6 280l.7.6-.7-.6z" />
      <path fill="#bd8c8c" d="M263.4 280l.7.6-.8-.6z" />
      <path fill="#a5847b" d="M264 280l.8.6-.8-.6z" />
      <path fill="#9c5a52" d="M264.8 280l.6.6-.6-.6z" />
      <path fill="#ad3931" d="M265.5 280l.7.6-.7-.6z" />
      <path fill="#b51010" d="M266.2 280l.7.6-.7-.6m9.8 0l.7.6-.7-.6z" />
      <path fill="#00216b" d="M276.7 280l.7.6-.7-.6z" />
      <path fill="#296300" d="M288.7 280l.7.6-.7-.6z" />
      <path fill="#103900" d="M290.3 280.4l.2.5-.2-.5z" />
      <path fill="#297b00" d="M291.5 280l.7.6-.7-.6z" />
      <path fill="#082108" d="M292.2 280l.7.6-.7-.6z" />
      <path fill="#184a00" d="M295.7 280v2h.7l-.7-2z" />
      <path fill="#103900" d="M304.9 280l.7.6-.8-.6z" />
      <path fill="#297b00" d="M315.4 280l.7.6-.7-.6z" />
      <path fill="#185200" d="M316.1 280l.7.6-.7-.6z" />
      <path fill="#425242" d="M316.8 280l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M317.5 280l.7.6-.7-.6z" />
      <path fill="#efefef" d="M318.2 280l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M198 280.6l.6.7-.7-.7z" />
      <path fill="#7b1008" d="M198.6 280.6l.7.7-.7-.7z" />
      <path fill="#941808" d="M200 280.6l.7.7-.7-.7z" />
      <path fill="#213918" d="M200.7 280.6l.7.7-.7-.7z" />
      <path fill="#314231" d="M202.8 280.6l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M205.7 280.6l.7.7-.7-.7z" />
      <path fill="#efefef" d="M206.4 280.6l.7.7-.7-.7z" />
      <path
        fill="#295200"
        d="M207 280.6l.8.7-.7-.7m2 0l.8.7-.7-.7m2 0l-1.3 2.7h.7l.7-2.7z"
      />
      <path fill="#397b00" d="M212 280.6l.7.7-.7-.7z" />
      <path fill="#295200" d="M213.9 280.9l.4.2-.4-.2z" />
      <path fill="#397b00" d="M217 280.6l.6.7-.7-.7z" />
      <path fill="#8c8c8c" d="M217.6 280.6l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M231.7 280.6l.7.7-.7-.7z" />
      <path fill="#941808" d="M232.4 280.6l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M246.5 280.6l.7.7-.7-.7z" />
      <path fill="#8c6363" d="M253.5 280.6l.7.7-.7-.7z" />
      <path fill="#a51008" d="M258 281l.2.5-.2-.4z" />
      <path fill="#520808" d="M259.8 280.6l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M262 280.6l.6.7-.7-.7z" />
      <path fill="#7b1008" d="M275.3 280.6l.7.7-.7-.7z" />
      <path fill="#002984" d="M276 280.6l.7.7-.7-.7z" />
      <path fill="#185200" d="M288.7 280.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M292.2 280.6l.7.7-.7-.7z" />
      <path fill="#297b00" d="M300.6 280.6l.7.7-.7-.7z" />
      <path fill="#296300" d="M303.4 280.6l.8.7-.8-.7z" />
      <path fill="#103900" d="M304.1 280.6l.7.7-.7-.7z" />
      <path fill="#297b00" d="M314 280.6l.7.7-.7-.7z" />
      <path fill="#214210" d="M314.7 280.6l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M315.4 280.6l.7.7-.7-.7z" />
      <path fill="#dedede" d="M316.1 280.6l.7.7-.7-.7z" />
      <path fill="#cecece" d="M198.6 281.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M199.3 281.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M200 281.3l.7.7-.7-.7z" />
      <path fill="#cecece" d="M200.7 281.3l.7.7-.7-.7z" />
      <path fill="#294200" d="M201.4 281.3l.7.7-.7-.7z" />
      <path fill="#397b00" d="M202.8 281.3l.7.7-.7-.7z" />
      <path fill="#292921" d="M203.6 281.3l.7.7-.8-.7z" />
      <path fill="#8c8c8c" d="M205.7 281.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M206.4 281.3l.7.7-.7-.7z" />
      <path fill="#397b00" d="M207 281.3l.8.7-.7-.7z" />
      <path fill="#294200" d="M211.3 281.3l.7.7-.7-.7z" />
      <path fill="#103900" d="M212.7 281.3l.7.7-.7-.7z" />
      <path fill="#397b00" d="M213.4 281.3l.7.7-.7-.7z" />
      <path fill="#314231" d="M217 281.3l-1.5 2 1.4-2z" />
      <path fill="#ad1810" d="M233.1 281.3l.7.7-.7-.7z" />
      <path fill="#941808" d="M233.8 281.3l.7.7-.7-.7z" />
      <path fill="#a51008" d="M246.5 281.3l.7.7-.7-.7z" />
      <path fill="#8c7373" d="M253.5 281.3l.7.7-.7-.7z" />
      <path fill="#6b0808" d="M259.8 281.3l.7.7-.7-.7z" />
      <path fill="#b51010" d="M262 281.3l.6.7-.7-.7z" />
      <path fill="#ad1810" d="M273.9 281.3l.7.7-.7-.7z" />
      <path fill="#291029" d="M274.6 281.3l.7.7-.7-.7z" />
      <path fill="#29396b" d="M287.3 281.3l.7.7-.7-.7z" />
      <path fill="#184a00" d="M288.7 281.3l.7.7-.7-.7z" />
      <path fill="#296300" d="M290 281.3l.8.7-.7-.7z" />
      <path fill="#297b00" d="M290.8 281.3l.7.7-.7-.7z" />
      <path fill="#184a00" d="M292.2 281.3l.7.7-.7-.7m10.5 0l.7.7-.7-.7z" />
      <path fill="#185200" d="M303.4 281.3l.8.7-.8-.7z" />
      <path fill="#297b00" d="M309 281.3l1.5 1.3-1.4-1.3z" />
      <path fill="#185200" d="M309.8 281.3l.7.7-.7-.7z" />
      <path fill="#184a00" d="M310.5 281.3v.7h2.8l-2.8-.7z" />
      <path fill="#185200" d="M313.3 281.3l.7.7-.7-.7z" />
      <path fill="#296300" d="M314 281.3l.7.7-.7-.7z" />
      <path fill="#184a00" d="M314.7 281.3v.7h2.1l-2.1-.7z" />
      <path fill="#4a6342" d="M316.8 281.3v.7h2.1l-2-.7z" />
      <path fill="#7b8c73" d="M319 281.3l.6.7-.7-.7z" />
      <path fill="#8c8c8c" d="M319.6 281.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M320.3 281.3l.7.7-.7-.7z" />
      <path fill="#efefef" d="M198.6 282l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M201.4 282l.7.6-.7-.6z" />
      <path fill="#294200" d="M203.6 282l.7.6-.8-.6z" />
      <path fill="#295200" d="M205 282l.7.6-.7-.6z" />
      <path fill="#5a1008" d="M205.7 282l.7.6-.7-.6z" />
      <path fill="#733939" d="M206.4 282l.7.6-.7-.6z" />
      <path fill="#397b00" d="M211.3 282l.7.6-.7-.6z" />
      <path fill="#103900" d="M212 282l.7.6-.7-.6z" />
      <path fill="#efefef" d="M217 282l-.8 1.3.7-1.3z" />
      <path fill="#b51010" d="M234.5 282l.7.6-.7-.6z" />
      <path fill="#941808" d="M235.2 282l.7.6-.7-.6z" />
      <path fill="#b51010" d="M236 282l1.3 1.3-1.4-1.3z" />
      <path fill="#ce1810" d="M246.5 282l.7.6-.7-.6z" />
      <path fill="#00216b" d="M247.2 282l.7.6-.7-.6z" />
      <path fill="#425a84" d="M250 282l.7.6-.7-.6z" />
      <path fill="#b5adad" d="M253.5 282l.7.6-.7-.6z" />
      <path fill="#b51010" d="M257.7 282l.7.6-.7-.6z" />
      <path fill="#940008" d="M260.3 282.2l.5.2-.5-.2z" />
      <path fill="#ad0008" d="M261.2 282l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M262 282l1.3 1.3-1.4-1.3z" />
      <path fill="#ce1810" d="M271.8 282l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M272.5 282l.7.6-.7-.6z" />
      <path fill="#00184a" d="M273.2 282l.7.6-.7-.6z" />
      <path fill="#42425a" d="M287.3 282l.7.6-.7-.6z" />
      <path fill="#396321" d="M288.7 282l.7.6-.7-.6z" />
      <path fill="#184a00" d="M290.8 282v2h.7l-.7-2z" />
      <path fill="#296300" d="M292.2 282l.7.6-.7-.6z" />
      <path fill="#297b00" d="M292.9 282l-.7 1.3.7-1.3z" />
      <path fill="#296300" d="M295.7 282v3.3h1.4l-1.4-3.3z" />
      <path fill="#297b00" d="M296.4 282l.7.6-.7-.6z" />
      <path fill="#103900" d="M302 282l-1.4 2 1.4-2z" />
      <path fill="#297b00" d="M302.7 282l.7.6-.7-.6z" />
      <path fill="#296300" d="M307.9 282.4l.2.5-.2-.5z" />
      <path fill="#103900" d="M308.4 282l.7.6-.7-.6z" />
      <path fill="#185200" d="M309 282l.8.6-.7-.6z" />
      <path fill="#297b00" d="M319 282l.6.6-.7-.6z" />
      <path fill="#184a00" d="M319.6 282l.7.6-.7-.6z" />
      <path fill="#313931" d="M320.3 282l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M198.6 282.6l.7.7-.7-.7z" />
      <path fill="#63636b" d="M199.3 282.6l.7.7-.7-.7z" />
      <path fill="#efefef" d="M200 282.6l.7.7-.7-.7z" />
      <path fill="#cecece" d="M201.4 282.6l.7.7-.7-.7z" />
      <path fill="#295200" d="M202.1 282.6l.7.7-.7-.7z" />
      <path fill="#397b00" d="M204.5 283l.2.5-.2-.4z" />
      <path fill="#7b1008" d="M205 282.6l.7.7-.7-.7z" />
      <path fill="#de2110" d="M205.9 283l.2.5-.2-.4z" />
      <path fill="#631808" d="M206.6 283l.2.5-.2-.4z" />
      <path fill="#294200" d="M209.2 282.6l.7.7-.7-.7z" />
      <path fill="#397b00" d="M214.8 282.6l.7.7-.7-.7z" />
      <path fill="#946b63" d="M220.4 282.6l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M236 282.6l.6.7-.7-.7z" />
      <path fill="#941808" d="M237.3 282.6l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M238 282.6l.7.7-.7-.7z" />
      <path fill="#a51008" d="M238.7 282.6l.7.7-.7-.7z" />
      <path fill="#ce1810" d="M239.4 282.6v.7h5.7l-5.7-.7z" />
      <path fill="#941808" d="M245 282.6l.8.7-.7-.7z" />
      <path fill="#a51008" d="M245.8 282.6l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M246.5 282.6l.7.7-.7-.7z" />
      <path fill="#00184a" d="M247.2 282.6l.7.7-.7-.7m3 .5l.3.4-.3-.4z" />
      <path fill="#bdbdbd" d="M253.5 282.6l.7.7-.7-.7z" />
      <path fill="#ce1810" d="M254.4 283l.3.5-.3-.4z" />
      <path fill="#000818" d="M260.5 282.6l.7.7-.7-.7z" />
      <path fill="#00184a" d="M261.2 282.6l.7.7-.7-.7z" />
      <path fill="#080829" d="M262 282.6l.6.7-.7-.7z" />
      <path fill="#ce1810" d="M263.4 282.6l.7.7-.8-.7z" />
      <path fill="#b51010" d="M269 282.6l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M269.7 282.6l.7.7-.7-.7z" />
      <path fill="#5a1021" d="M270.4 282.6l.7.7-.7-.7z" />
      <path fill="#00215a" d="M271 282.6l.8.7-.7-.7z" />
      <path fill="#292921" d="M287.3 282.6l.7.7-.7-.7z" />
      <path fill="#5a7b42" d="M288.7 282.6l.7.7-.7-.7z" />
      <path fill="#185200" d="M292.9 282.6l.7.7-.7-.7z" />
      <path fill="#297b00" d="M302 282.6l.7.7-.7-.7m3.6 0l1.4 1.4-1.4-1.4z" />
      <path fill="#185200" d="M306.3 282.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M307 282.6l.7.7-.7-.7z" />
      <path fill="#297b00" d="M315.4 282.6l.7.7-.7-.7z" />
      <path fill="#296300" d="M316.1 282.6l.7.7-.7-.7z" />
      <path fill="#185200" d="M316.8 282.6l.7.7-.7-.7z" />
      <path fill="#395231" d="M317.5 282.6l.7.7-.7-.7z" />
      <path fill="#63636b" d="M318.2 282.6l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M319 282.6l.6.7-.7-.7z" />
      <path fill="#dedede" d="M319.6 282.6l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M198.6 283.3l.7.7-.7-.7z" />
      <path fill="#397b00" d="M199.3 283.3l.7.7-.7-.7z" />
      <path fill="#294200" d="M200 283.3l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M200.7 283.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M201.4 283.3l.7.7-.7-.7z" />
      <path fill="#5a5231" d="M202.1 283.3l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M205 283.3l.7.7-.7-.7z" />
      <path fill="#397b00" d="M209 283.5l.4.2-.5-.2z" />
      <path fill="#396b10" d="M214.1 283.3l.7.7-.7-.7z" />
      <path fill="#b51010" d="M239.4 283.3l.7.7-.7-.7zm5 0l.6.7-.7-.7z" />
      <path fill="#391810" d="M247.2 283.3l.7.7-.7-.7z" />
      <path fill="#dedede" d="M253.5 283.3l.7.7-.7-.7z" />
      <path fill="#291029" d="M260.5 283.3l.7.7-.7-.7z" />
      <path fill="#002984" d="M264 283.3v.7h5l-5-.7z" />
      <path fill="#082108" d="M287.3 283.3l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M288 283.3l.7.7-.7-.7z" />
      <path fill="#4a6342" d="M289 283.8l.1.4-.2-.5z" />
      <path fill="#184a00" d="M293.1 283.8l.3.4-.3-.5z" />
      <path fill="#297b00" d="M301.3 283.3l.7.7-.7-.7z" />
      <path fill="#185200" d="M304.9 283.3l.7.7-.8-.7z" />
      <path fill="#103900" d="M305.6 283.3l.7.7-.7-.7z" />
      <path fill="#297b00" d="M311.9 283.3l.7.7-.7-.7z" />
      <path fill="#296300" d="M312.6 283.3l.7.7-.7-.7z" />
      <path fill="#184a00" d="M313.3 283.3l.7.7-.7-.7z" />
      <path fill="#4a6342" d="M314 283.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M314.7 283.3l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M315.4 283.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M316.1 283.3l.7.7-.7-.7z" />
      <path fill="#cecece" d="M198.6 284l.7.7-.7-.7z" />
      <path fill="#295200" d="M199.3 284l.7.7-.7-.7z" />
      <path fill="#292100" d="M200 284l.7.7-.7-.7z" />
      <path fill="#397b00" d="M200.7 284l1.4 1.3V284h-1.4z" />
      <path fill="#292100" d="M202.1 284l.7.7-.7-.7z" />
      <path fill="#397b00" d="M202.8 284l.7.7-.7-.7z" />
      <path fill="#392100" d="M205 284l.7.7-.7-.7z" />
      <path fill="#b51010" d="M205.7 284l.7.7-.7-.7z" />
      <path fill="#5a2908" d="M206.4 284l.7.7-.7-.7z" />
      <path fill="#294200" d="M208.5 284l.7.7-.7-.7z" />
      <path fill="#214210" d="M212.7 284l.7.7-.7-.7z" />
      <path fill="#63636b" d="M213.4 284l.7.7-.7-.7z" />
      <path fill="#dedede" d="M214.1 284l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M247.2 284l.7.7-.7-.7z" />
      <path fill="#00215a" d="M247.9 284l.7.7-.7-.7m2 0l.8.7-.7-.7z" />
      <path fill="#dedede" d="M250.7 284l.7.7-.7-.7z" />
      <path fill="#a51008" d="M254.2 284l.7.7-.7-.7z" />
      <path fill="#390821" d="M260.5 284l.7.7-.7-.7z" />
      <path fill="#184a00" d="M287.3 284l1.4 1.3-1.4-1.3z" />
      <path fill="#5a6b52" d="M288 284l.7.7-.7-.7z" />
      <path fill="#185200" d="M290.8 284l.7.7-.7-.7z" />
      <path fill="#297b00" d="M291.5 284l-.7 1.3.7-1.3z" />
      <path fill="#185200" d="M299.2 286l2.1-2-2 2z" />
      <path fill="#297b00" d="M303.4 284l1.5 1.3-1.5-1.3z" />
      <path fill="#103900" d="M304.1 284l.7.7-.7-.7z" />
      <path fill="#296300" d="M304.9 284l.7.7-.8-.7m5.7 0l.7.7-.7-.7z" />
      <path fill="#315221" d="M311.2 284l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M311.9 284l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M312.6 284l.7.7-.7-.7z" />
      <path fill="#dedede" d="M190.9 284.6l.7.7-.7-.7z" />
      <path fill="#efefef" d="M191.6 284.6l.7.7-.7-.7z" />
      <path fill="#315221" d="M199.3 284.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M200.7 284.6l.7.7-.7-.7z" />
      <path fill="#295200" d="M202.8 284.6l.7.7-.7-.7z" />
      <path fill="#294200" d="M203.6 284.6l.7 2h.6l-1.4-2z" />
      <path fill="#397b00" d="M205.7 284.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M206.4 284.6l.7.7-.7-.7z" />
      <path fill="#397b00" d="M208.2 284.9l.5.2-.5-.2m2.4-.2l.7.6-.7-.7z" />
      <path fill="#315221" d="M211.3 284.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M212 284.6l.7.7-.7-.7z" />
      <path fill="#dedede" d="M212.7 284.6l.7.7-.7-.7z" />
      <path fill="#391810" d="M247.9 284.6l.7.7-.7-.7z" />
      <path fill="#00216b" d="M250 284.6l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M250.7 284.6l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M254.2 284.6l.7.7-.7-.7z" />
      <path fill="#b51010" d="M257.7 284.6l.7.7-.7-.7z" />
      <path fill="#6b0808" d="M260.5 284.6l.7.7-.7-.7z" />
      <path fill="#395231" d="M288.7 284.6l.7.7-.7-.7z" />
      <path fill="#296300" d="M291.5 284.6l.7.7-.7-.7z" />
      <path fill="#185200" d="M292.9 284.6l.7.7-.7-.7z" />
      <path fill="#297b00" d="M293.6 284.6l-.7 1.4.7-1.4z" />
      <path fill="#296300" d="M302.7 284.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M303.4 284.6l.8.7-.8-.7z" />
      <path fill="#185200" d="M309 284.6l.8.7-.7-.7z" />
      <path fill="#425242" d="M309.8 284.6l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M310.5 284.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M190.9 285.3l.7.7-.7-.7z" />
      <path fill="#293129" d="M191.6 285.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M192.3 285.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M193 285.3l.7.7-.7-.7z" />
      <path fill="#efefef" d="M193.7 285.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M199.3 285.3l.7.7-.7-.7z" />
      <path fill="#295200" d="M201.4 285.3l.7.7-.7-.7z" />
      <path fill="#294200" d="M202.1 285.3l.7.7-.7-.7z" />
      <path fill="#397b00" d="M203.6 285.3l.7.7-.8-.7z" />
      <path fill="#294200" d="M207.8 285.3l.7.7-.7-.7z" />
      <path fill="#295200" d="M209.9 285.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M210.6 285.3l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M212 285.3l.7.7-.7-.7z" />
      <path fill="#314231" d="M212.7 285.3l.7.7-.7-.7z" />
      <path fill="#dedede" d="M218.3 285.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M219 285.3l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M223.3 285.3l.6.7-.7-.7z" />
      <path fill="#10214a" d="M248.6 285.3l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M250.7 285.3l.7.7-.7-.7z" />
      <path fill="#943131" d="M254.4 285.8l.3.4-.3-.4z" />
      <path fill="#a51008" d="M257.7 285.3l.7.7-.7-.7z" />
      <path fill="#297b00" d="M288 285.3l.7.7-.7-.7z" />
      <path fill="#082108" d="M288.7 285.3l.7.7-.7-.7z" />
      <path fill="#184a00" d="M291.7 285.8l.3.4-.3-.4z" />
      <path fill="#296300" d="M293.6 285.3l.7.7-.7-.7z" />
      <path fill="#297b00" d="M296.2 285.5l.5.3-.5-.3m2.3-.2l.7.7-.7-.7z" />
      <path fill="#184a00" d="M302 285.3l.7.7-.7-.7z" />
      <path fill="#185200" d="M302.7 285.3l.7.7-.7-.7z" />
      <path fill="#297b00" d="M307.7 285.3l.7.7-.7-.7z" />
      <path fill="#294221" d="M308.4 285.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M309 285.3l.8.7-.7-.7z" />
      <path fill="#cecece" d="M190.9 286l.7.7-.7-.7z" />
      <path fill="#295200" d="M191.6 286l.7.7-.7-.7zm2.1 0l.7.7-.7-.7z" />
      <path fill="#294200" d="M194.9 286.2l.4.2-.4-.2z" />
      <path fill="#526b42" d="M195.8 286l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M196.5 286l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M197.2 286l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M198 286l.6.7-.7-.7z" />
      <path fill="#dedede" d="M198.6 286l.7.7-.7-.7z" />
      <path fill="#efefef" d="M199.3 286l.7.7-.7-.7z" />
      <path fill="#315221" d="M200 286l-.7 1.3.7-1.3z" />
      <path fill="#397b00" d="M202.1 286l.7.7-.7-.7z" />
      <path fill="#103900" d="M202.8 286l.7.7-.7-.7z" />
      <path fill="#295200" d="M207.8 286l.7.7-.7-.7z" />
      <path fill="#397b00" d="M209.2 286l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M209.9 286l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M212 286l.7.7-.7-.7z" />
      <path fill="#397b00" d="M212.7 286v2.7h.7l-.7-2.7z" />
      <path fill="#63636b" d="M213.4 286l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M218.3 286l.7.7-.7-.7z" />
      <path fill="#213918" d="M219 286l1.4 1.3-1.4-1.3z" />
      <path fill="#cecece" d="M219.7 286l.7.7-.7-.7z" />
      <path fill="#941808" d="M222.5 286l-1.4 2 1.4-2z" />
      <path fill="#181000" d="M223.3 286l.6.7-.7-.7z" />
      <path fill="#8c8c8c" d="M248.6 286l.7.7-.7-.7z" />
      <path fill="#00216b" d="M249.3 286l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M250.7 286l.7.7-.7-.7z" />
      <path fill="#b51010" d="M257.7 286l.7.7-.7-.7z" />
      <path fill="#319400" d="M288 286v2h.7l-.7-2z" />
      <path fill="#103900" d="M288.7 286l.7.7-.7-.7z" />
      <path fill="#184a00" d="M293.8 286.4l.3.5-.3-.5z" />
      <path fill="#297b00" d="M299.2 288l3.5-2-3.5 2z" />
      <path fill="#103900" d="M301.3 286l.7.7-.7-.7z" />
      <path fill="#296300" d="M307 286l.7.7-.7-.7z" />
      <path fill="#52525a" d="M307.7 286l.7.7-.7-.7z" />
      <path fill="#efefef" d="M308.4 286l.7.7-.7-.7z" />
      <path fill="#315221" d="M191.6 286.6l.7.7-.7-.7z" />
      <path fill="#397b00" d="M198 286.6l.6.7-.7-.7z" />
      <path fill="#295200" d="M198.6 286.6l.7.7-.7-.7z" />
      <path fill="#52525a" d="M200 286.6l.7.7-.7-.7z" />
      <path fill="#295200" d="M200.7 286.6l2.1 2-2-2z" />
      <path fill="#294200" d="M203.6 286.6l.7.7-.8-.7z" />
      <path fill="#103900" d="M205 286.6l.7.7-.7-.7z" />
      <path fill="#52525a" d="M209.2 286.6l.7.7-.7-.7z" />
      <path fill="#dedede" d="M211.3 286.6l.7.7-.7-.7z" />
      <path fill="#294200" d="M212 286.6l.7.7-.7-.7z" />
      <path fill="#428c00" d="M212.7 286.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M214.1 286.6l.7.7-.7-.7z" />
      <path fill="#63636b" d="M218.3 286.6l.7.7-.7-.7z" />
      <path
        fill="#428c00"
        d="M219 286.6c-2.2 4.7-4.7 9.8 1.4 12.8 0-4 1.5-9.7-1.4-12.7z"
      />
      <path fill="#bd2110" d="M221.1 286.6l.7.7-.7-.7z" />
      <path fill="#295200" d="M222.5 286.6l.7.7-.7-.7z" />
      <path fill="#397b00" d="M223.3 286.6l-.8 1.4h1.5l-.7-1.4z" />
      <path fill="#b51010" d="M224 286.6l.6.7-.7-.7z" />
      <path fill="#31394a" d="M249.3 286.6l.7.7-.7-.7z" />
      <path fill="#525a6b" d="M250.7 286.6l.7.7-.7-.7z" />
      <path fill="#8c7373" d="M254.4 287.1l.3.5-.3-.5z" />
      <path fill="#a51008" d="M257.7 286.6l.7.7-.7-.7z" />
      <path fill="#002984" d="M286 287.1l.3.5-.2-.5z" />
      <path fill="#00216b" d="M286.6 286.6l.7.7-.7-.7z" />
      <path fill="#001000" d="M287.3 286.6l.7.7-.7-.7z" />
      <path fill="#184a00" d="M288.7 286.6l.7.7-.7-.7z" />
      <path fill="#185200" d="M291.5 286.6l.7.7-.7-.7z" />
      <path fill="#297b00" d="M296.4 286.6l-.7 1.4.7-1.4z" />
      <path fill="#103900" d="M300.6 286.6l.7.7-.7-.7z" />
      <path fill="#297b00" d="M305.6 286.6l.7.7-.7-.7z" />
      <path fill="#103900" d="M306.3 286.6l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M307 286.6l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M307.7 286.6l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M308.8 286.9l.5.2-.5-.2z" />
      <path fill="#4a6342" d="M310.3 286.9l.4.2-.4-.2z" />
      <path fill="#295210" d="M311.2 286.6l.7.7-.7-.7z" />
      <path fill="#184a00" d="M311.9 286.6l.7.7-.7-.7z" />
      <path fill="#296300" d="M312.6 286.6v.7h3.5l-3.5-.7z" />
      <path fill="#184a00" d="M316.1 286.6l.7.7-.7-.7z" />
      <path fill="#082108" d="M316.8 286.6l.7.7-.7-.7z" />
      <path fill="#313931" d="M317.5 286.6l.7.7-.7-.7z" />
      <path fill="#63636b" d="M318.2 286.6l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M319 286.6l.6.7-.7-.7m-127.3.7l.7.7-.7-.7z" />
      <path fill="#295200" d="M193.7 287.3l.7.7-.7-.7z" />
      <path fill="#294200" d="M194.9 287.6l.4.2-.4-.2z" />
      <path fill="#397b00" d="M196 287.8l.3.4-.3-.4z" />
      <path fill="#292100" d="M200.7 287.3l.7.7-.7-.7z" />
      <path fill="#397b00" d="M205 287.3l-.7 2h.7v-2m3.5 0l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M209.2 287.3l.7.7-.7-.7z" />
      <path fill="#425242" d="M211.3 287.3l.7.7-.7-.7z" />
      <path
        fill="#428c00"
        d="M212 287.3c-1.7 4.3-1.2 6.9 1.4 10.7h.7v-10.7h-.7v8H212v-8z"
      />
      <path fill="#315221" d="M214.1 287.3l.7.7-.7-.7z" />
      <path fill="#efefef" d="M217.6 287.3l.7.7-.7-.7z" />
      <path fill="#396b10" d="M218.3 287.3l.7.7-.7-.7z" />
      <path fill="#293129" d="M220.4 287.3l.7.7-.7-.7z" />
      <path fill="#293100" d="M221.8 287.3l.7.7-.7-.7z" />
      <path fill="#631808" d="M224 287.3l.6.7-.7-.7z" />
      <path fill="#cecece" d="M249.3 287.3l.7.7-.7-.7z" />
      <path fill="#001039" d="M250 287.3l.7.7-.7-.7z" />
      <path fill="#42425a" d="M250.7 287.3l.7.7-.7-.7z" />
      <path fill="#520808" d="M257.7 287.3l.7.7-.7-.7z" />
      <path fill="#6b5252" d="M258.4 287.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M259.1 287.3l.7.7-.7-.7z" />
      <path fill="#290018" d="M259.8 287.3l.7.7-.7-.7z" />
      <path fill="#420000" d="M260.5 287.3l.7.7-.7-.7z" />
      <path fill="#001010" d="M286.6 287.3l.7.7-.7-.7z" />
      <path fill="#292921" d="M287.3 287.3l.7.7-.7-.7z" />
      <path fill="#185200" d="M288.7 287.3l1.4 1.4-1.4-1.4z" />
      <path fill="#297b00" d="M289.4 287.3l.7.7-.7-.7z" />
      <path fill="#184a00" d="M291.5 287.3v2h.7l-.7-2z" />
      <path fill="#185200" d="M293.6 287.3l.7.7-.7-.7z" />
      <path fill="#103900" d="M300 287.3l.6.7-.7-.7z" />
      <path fill="#297b00" d="M303.4 287.3l.8.7-.8-.7z" />
      <path fill="#184a00" d="M304.1 287.3v.7h2.2l-2.2-.7z" />
      <path fill="#296300" d="M306.7 287.6l.5.2-.5-.2z" />
      <path fill="#297b00" d="M307.7 287.3l.7.7-.7-.7m4.9 0l.7.7-.7-.7z" />
      <path fill="#185200" d="M313.3 287.3l.7.7-.7-.7z" />
      <path fill="#315221" d="M314 287.3l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M314.7 287.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M315.4 287.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M316.1 287.3l.7.7-.7-.7z" />
      <path fill="#425242" d="M192.3 288l.7.7-.7-.7z" />
      <path fill="#103900" d="M201.4 288l.7.7-.7-.7z" />
      <path fill="#294200" d="M205 288l.7.7-.7-.7m3.5 0l1.4 1.3-1.4-1.3z" />
      <path fill="#5a5231" d="M209.2 288l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M210.6 288l.7.7-.7-.7z" />
      <path fill="#397b00" d="M211.3 288l.7.7-.7-.7m2.8 0l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M214.8 288l.7.7-.7-.7z" />
      <path fill="#52525a" d="M217.6 288l.7.7-.7-.7z" />
      <path fill="#294200" d="M219.3 288.4l.2.5-.2-.5z" />
      <path fill="#295200" d="M220.4 288l.7.7-.7-.7z" />
      <path fill="#100808" d="M221.1 288l.7.7-.7-.7z" />
      <path
        fill="#428c00"
        d="M221.8 288l-.7 10.7 2.1-2h.8l-.7 2.7c5.5-1.6 6.5-5.2 4.9-10l-3.5 7.3h-.7V288h-.7l-1.4 7.4V288z"
      />
      <path fill="#295200" d="M222.5 288l.7.7-.7-.7z" />
      <path fill="#293100" d="M224 288l.6.7-.7-.7z" />
      <path fill="#ce2110" d="M227.5 288l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M228.2 288l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M250 288l.7.7-.7-.7z" />
      <path fill="#080829" d="M250.7 288l.7.7-.7-.7z" />
      <path fill="#c6b5b5" d="M254.2 288l.7.7-.7-.7z" />
      <path fill="#b51010" d="M257 288l.7.7-.7-.7z" />
      <path fill="#cecece" d="M257.7 288l.7.7-.7-.7z" />
      <path fill="#103900" d="M286.6 288l.7.7-.7-.7z" />
      <path fill="#63636b" d="M287.3 288l.7.7-.7-.7z" />
      <path fill="#297b00" d="M288.4 288.2l.5.2-.5-.2z" />
      <path fill="#184a00" d="M293.6 288l.7.7-.7-.7z" />
      <path fill="#185200" d="M295.7 288l.7.7-.7-.7z" />
      <path fill="#184a00" d="M299.2 288l.7.7-.7-.7z" />
      <path fill="#185200" d="M302 288l.7.7-.7-.7z" />
      <path fill="#103900" d="M302.7 288l.7.7-.7-.7z" />
      <path fill="#185200" d="M303.4 288l.8.7-.8-.7z" />
      <path fill="#297b00" d="M309.8 288l.7.7-.7-.7z" />
      <path fill="#185200" d="M310.5 288l.7.7-.7-.7z" />
      <path fill="#315221" d="M311.2 288l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M311.9 288l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M312.6 288l.7.7-.7-.7z" />
      <path fill="#dedede" d="M313.3 288l.7.7-.7-.7z" />
      <path fill="#cecece" d="M192.3 288.7l1.4 1.3-1.4-1.3z" />
      <path fill="#214210" d="M193 288.7l.7.6-.7-.6z" />
      <path fill="#397b00" d="M202.1 288.7l1.4 1.3v-1.3h-1.4z" />
      <path fill="#103900" d="M203.6 288.7l.7.6-.8-.6m2.9 0l-.7 1.3.7-1.3z" />
      <path fill="#397b00" d="M207 288.7l.8.6-.7-.6z" />
      <path fill="#295200" d="M208.5 288.7l.7.6-.7-.6z" />
      <path fill="#213918" d="M210.6 288.7l.7.6-.7-.6z" />
      <path fill="#294200" d="M212.7 288.7v3.3h.7l-.7-3.3z" />
      <path fill="#526b42" d="M214.8 288.7l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M217 288.7l.6.6-.7-.6z" />
      <path fill="#397b00" d="M217.6 288.7l.7.6-.7-.6z" />
      <path fill="#103900" d="M221.1 288.7l.7.6-.7-.6z" />
      <path fill="#294200" d="M222.5 288.7v2.6h.7l-.7-2.6z" />
      <path fill="#397b00" d="M224 288.7l.6.6-.7-.6z" />
      <path fill="#941808" d="M224.7 288.7l.7.6-.8-.6m2.2 0l-.7 1.3.7-1.3z" />
      <path fill="#293100" d="M227.5 288.7l.7.6-.7-.6z" />
      <path fill="#103900" d="M228.2 288.7l.7.6-.7-.6z" />
      <path fill="#efefef" d="M250 288.7l.7.6-.7-.6z" />
      <path fill="#292921" d="M250.7 288.7l.7.6-.7-.6z" />
      <path fill="#efefef" d="M251.4 288.7l.7.6-.7-.6z" />
      <path fill="#842118" d="M257 288.7l.7.6-.7-.6z" />
      <path fill="#293129" d="M287.3 288.7l.7.6-.7-.6z" />
      <path fill="#296300" d="M288 288.7l.7.6-.7-.6z" />
      <path fill="#103900" d="M289.4 288.7l.7.6-.7-.6z" />
      <path fill="#185200" d="M293.6 288.7l.7.6-.7-.6z" />
      <path fill="#103900" d="M295.7 288.7l.7.6-.7-.6z" />
      <path fill="#296300" d="M300.6 288.7l.7.6-.7-.6z" />
      <path fill="#103900" d="M301.3 288.7l.7.6-.7-.6z" />
      <path fill="#296300" d="M302 288.7l.7.6-.7-.6z" />
      <path fill="#297b00" d="M307.7 288.7l.7.6-.7-.6z" />
      <path fill="#103900" d="M308.4 288.7l.7.6-.7-.6z" />
      <path fill="#001000" d="M309 288.7l.8.6-.7-.6z" />
      <path fill="#101810" d="M309.8 288.7l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M310.5 288.7l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M311.6 288.9l.5.2-.5-.2z" />
      <path fill="#214210" d="M193.7 289.3l1.4 1.4-1.4-1.4z" />
      <path fill="#397b00" d="M199.6 289.8l.2.4-.2-.4m9.6-.5l.7.7-.7-.7z" />
      <path fill="#63636b" d="M209.9 289.3l.7.7-.7-.7z" />
      <path fill="#397b00" d="M210.6 289.3l.7.7-.7-.7z" />
      <path fill="#294200" d="M215 289.8l.3.4-.3-.4z" />
      <path fill="#dedede" d="M216.2 289.3l.7.7-.7-.7z" />
      <path fill="#214210" d="M217 289.3l.6.7-.7-.7z" />
      <path fill="#295200" d="M219 289.3l.7.7-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#422100" d="M224.7 289.3l.7.7-.8-.7z" />
      <path fill="#295200" d="M226.8 289.3l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M228.9 289.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M250.7 289.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M251.6 289.8l.3.4-.3-.4z" />
      <path fill="#736b6b" d="M257 289.3l.7.7-.7-.7z" />
      <path fill="#185200" d="M287.3 289.3l.7.7-.7-.7z" />
      <path fill="#184a00" d="M288 289.3l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#296300" d="M291.5 289.3l.7 2.7h.7l-1.4-2.7z" />
      <path fill="#297b00" d="M292.2 289.3l.7.7-.7-.7z" />
      <path fill="#184a00" d="M293.6 289.3l.7.7-.7-.7z" />
      <path fill="#297b00" d="M295 289.3l.7.7-.7-.7zm4.2 0l1.4 1.4-1.4-1.4z" />
      <path fill="#184a00" d="M300 289.3l.6.7-.7-.7z" />
      <path fill="#185200" d="M300.6 289.3l.7.7-.7-.7z" />
      <path fill="#297b00" d="M305.6 289.3l.7.7-.7-.7z" />
      <path fill="#184a00" d="M306.3 289.3v.7l2.8.7v-.7l-2.8-.7z" />
      <path fill="#103900" d="M307 289.3l.7.7-.7-.7z" />
      <path fill="#185200" d="M307.7 289.3l.7.7-.7-.7z" />
      <path fill="#319400" d="M308.4 289.3v.7h2l-2-.7z" />
      <path fill="#297b00" d="M310.7 289.8l.2.4-.2-.4z" />
      <path fill="#296300" d="M311.2 289.3v.7l2.8.7v-.7l-2.8-.7z" />
      <path fill="#185200" d="M312.6 289.3l.7.7-.7-.7z" />
      <path fill="#103900" d="M313.3 289.3l.7.7-.7-.7z" />
      <path fill="#4a6342" d="M314 289.3l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M314.7 289.3l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M315.4 289.3l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M193.7 290l.7.7-.7-.7z" />
      <path fill="#294200" d="M197.7 290.2l.5.2-.5-.2z" />
      <path fill="#295200" d="M198.6 290l.7.7-.7-.7z" />
      <path fill="#292100" d="M205 290l.7.7-.7-.7z" />
      <path fill="#001000" d="M209.9 290l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M216.2 290l.7.7-.7-.7z" />
      <path fill="#294200" d="M219.3 290.4l.2.5-.2-.5z" />
      <path fill="#397b00" d="M220.9 290.2l.5.2-.5-.2z" />
      <path fill="#294200" d="M224.7 290l.7.7-.8-.7z" />
      <path fill="#bd2110" d="M225.4 290l.7.7-.7-.7z" />
      <path fill="#294200" d="M226 290l.8.7-.7-.7z" />
      <path fill="#397b00" d="M228.2 290l.7.7-.7-.7z" />
      <path fill="#941808" d="M228.9 290l.7.7-.7-.7z" />
      <path fill="#efefef" d="M252 290l-.6 1.3.7-1.3z" />
      <path fill="#ce1810" d="M256.3 290l.7.7-.7-.7z" />
      <path fill="#cecece" d="M257 290l.7.7-.7-.7z" />
      <path fill="#297b00" d="M287.3 290l.7.7-.7-.7z" />
      <path fill="#082108" d="M288 290l.7.7-.7-.7z" />
      <path fill="#185200" d="M289.4 290l.7.7-.7-.7z" />
      <path fill="#297b00" d="M290 290l.8.7-.7-.7z" />
      <path fill="#185200" d="M293.6 290l.7.7-.7-.7z" />
      <path fill="#103900" d="M299.2 290l.7.7-.7-.7z" />
      <path fill="#297b00" d="M303.4 290l1.5 1.3-1.5-1.3z" />
      <path fill="#185200" d="M304.1 290l.7.7-.7-.7z" />
      <path fill="#103900" d="M304.9 290l.7.7-.8-.7z" />
      <path fill="#185200" d="M306 290.2l.5.2-.5-.2m3-.2l.8.7-.7-.7z" />
      <path fill="#296300" d="M310 290.4l.2.5-.2-.5z" />
      <path fill="#319400" d="M311.2 290l.7.7-.7-.7z" />
      <path fill="#297b00" d="M311.9 290l.7.7-.7-.7z" />
      <path fill="#185200" d="M314 290l.7.7-.7-.7z" />
      <path fill="#184a00" d="M314.7 290l.7.7-.7-.7z" />
      <path fill="#082108" d="M315.4 290l.7.7-.7-.7z" />
      <path d="M316.1 290l.7.7-.7-.7z" />
      <path fill="#313931" d="M316.8 290l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M317.5 290l.7.7-.7-.7z" />
      <path fill="#dedede" d="M194.6 291.1l.3.5-.3-.5z" />
      <path fill="#52525a" d="M195.1 290.7l.7.6-.7-.6z" />
      <path fill="#294200" d="M195.8 290.7l.7.6-.7-.6z" />
      <path fill="#295200" d="M196.5 290.7l.7.6-.7-.6z" />
      <path fill="#294200" d="M204.3 290.7l.6.6-.7-.6z" />
      <path fill="#397b00" d="M205 290.7l.7.6-.7-.6m3.2.2l.5.2-.5-.2z" />
      <path fill="#294200" d="M210.1 291.1l.2.5-.2-.5z" />
      <path fill="#397b00" d="M214.8 290.7l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M215.5 290.7l.7.6-.7-.6z" />
      <path fill="#295200" d="M216.2 290.7l.7.6-.7-.6z" />
      <path fill="#294200" d="M220.4 290.7v2h.7l-.7-2z" />
      <path fill="#397b00" d="M224.7 290.7v1.3h1.4l-1.4-1.3z" />
      <path fill="#211800" d="M225.4 290.7l.7.6-.7-.6z" />
      <path fill="#294200" d="M227.5 290.7l.7.6-.7-.6z" />
      <path fill="#5a2908" d="M228.9 290.7l.7.6-.7-.6z" />
      <path fill="#63636b" d="M252 290.7l.8.6-.7-.6z" />
      <path fill="#9c2118" d="M256.3 290.7l.7.6-.7-.6z" />
      <path fill="#00216b" d="M285.9 290.7l.7.6-.7-.6z" />
      <path fill="#103910" d="M286.6 290.7l.7.6-.7-.6z" />
      <path fill="#103900" d="M288.2 291.1l.2.5-.2-.5z" />
      <path fill="#296300" d="M289.8 290.9l.5.2-.5-.2z" />
      <path fill="#103900" d="M297.8 290.7l.7.6-.7-.6z" />
      <path fill="#296300" d="M302.3 291.1l.2.5-.2-.5z" />
      <path fill="#103900" d="M303.2 290.9l.5.2-.5-.2z" />
      <path
        fill="#319400"
        d="M295 298.7a38 38 0 0 1 19.7-6c-6.5-3.8-17.5-1.5-19.7 6z"
      />
      <path fill="#297b00" d="M309 290.7l.8.6-.7-.6z" />
      <path fill="#185200" d="M310.5 290.7l.7.6-.7-.6z" />
      <path fill="#103900" d="M311.2 290.7l.7.6-.7-.6z" />
      <path fill="#293129" d="M311.9 290.7l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M312.6 290.7l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M313.3 290.7l.7.6-.7-.6z" />
      <path fill="#314231" d="M195.1 291.3l.7.7-.7-.7z" />
      <path fill="#295200" d="M201.4 291.3l.7.7-.7-.7z" />
      <path fill="#294200" d="M202.1 291.3l.7.7-.7-.7z" />
      <path fill="#397b00" d="M203.6 291.3l.7.7-.8-.7z" />
      <path fill="#295200" d="M204.3 291.3l.6.7-.7-.7m3.6 0l.7.7-.7-.7z" />
      <path fill="#294200" d="M214.8 291.3l.7.7-.7-.7z" />
      <path fill="#63636b" d="M215.5 291.3l.7.7-.7-.7z" />
      <path fill="#397b00" d="M218.8 291.6l.5.2-.5-.2m3.7-.3v2h.7l-.7-2z" />
      <path fill="#295200" d="M226.8 291.3l.7.7-.7-.7z" />
      <path fill="#293100" d="M228.9 291.3l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M252 291.3l.8.7-.7-.7z" />
      <path fill="#bdbdbd" d="M252.8 291.3l.7.7-.7-.7z" />
      <path fill="#8c6363" d="M256.3 291.3l.7.7-.7-.7z" />
      <path fill="#00184a" d="M285.1 291.3l.7.7-.7-.7z" />
      <path fill="#21315a" d="M285.9 291.3l.7.7-.7-.7z" />
      <path fill="#5a7b42" d="M286.6 291.3l.7.7-.7-.7z" />
      <path fill="#184a00" d="M290 291.3l.8.7-.7-.7z" />
      <path fill="#297b00" d="M291.5 291.3l.7.7-.7-.7z" />
      <path fill="#185200" d="M300.6 291.3l.7.7-.7-.7z" />
      <path fill="#103900" d="M301.3 291.3l.7.7-.7-.7z" />
      <path fill="#297b00" d="M312.6 291.3l.7.7-.7-.7z" />
      <path fill="#103900" d="M313.3 291.3l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M314 291.3l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M314.7 291.3l.7.7-.7-.7z" />
      <path fill="#dedede" d="M315.4 291.3l.7.7-.7-.7z" />
      <path fill="#efefef" d="M193.7 292l.7.7-.7-.7z" />
      <path fill="#314231" d="M194.4 292l.7.7-.7-.7z" />
      <path fill="#295200" d="M200 292l.7.7-.7-.7z" />
      <path fill="#103900" d="M200.7 292l.7.7-.7-.7z" />
      <path fill="#397b00" d="M201.4 292l.7.7-.7-.7z" />
      <path fill="#103900" d="M203.6 292l.7.7-.8-.7z" />
      <path fill="#294200" d="M208 292.5l.2.4-.2-.4z" />
      <path fill="#295200" d="M209.9 292l.7.7-.7-.7m2.8 0l.7.7-.7-.7z" />
      <path fill="#526b42" d="M215.3 292.2l.4.3-.4-.3z" />
      <path fill="#295200" d="M218.3 292l.7.7-.7-.7z" />
      <path fill="#294200" d="M224.9 292.5l.2.4-.2-.4m2.1 0l.2.4-.2-.4z" />
      <path fill="#397b00" d="M228.9 292l.7.7-.7-.7z" />
      <path fill="#b51010" d="M242.2 292l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M243 292l.6.7-.7-.7z" />
      <path fill="#63636b" d="M252.8 292l.7.7-.7-.7z" />
      <path fill="#dedede" d="M256.3 292l.7.7-.7-.7z" />
      <path fill="#00216b" d="M283.8 292l.6.7-.6-.7z" />
      <path d="M285.1 292l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M285.9 292l.7.7-.7-.7z" />
      <path fill="#396321" d="M286.6 292l.7.7-.7-.7z" />
      <path fill="#185200" d="M288 292l.7.7-.7-.7z" />
      <path fill="#297b00" d="M288.7 292l.7.7-.7-.7z" />
      <path
        fill="#185200"
        d="M290 292l.8.7-.7-.7m2 0l.8.7-.7-.7m3.5 0l.7.7-.7-.7z"
      />
      <path fill="#296300" d="M299.2 292l.7.7-.7-.7z" />
      <path fill="#103900" d="M300 292l.6.7-.7-.7z" />
      <path fill="#296300" d="M300.6 292l.7.7-.7-.7z" />
      <path fill="#297b00" d="M314.7 292l.7.7-.7-.7z" />
      <path fill="#185200" d="M315.4 292l.7.7-.7-.7z" />
      <path fill="#314231" d="M316.1 292l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M316.8 292l.7.7-.7-.7z" />
      <path fill="#424242" d="M193.7 292.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M198 292.7l.6.7-.7-.7z" />
      <path fill="#294200" d="M199 292.9l.6.2-.5-.2z" />
      <path fill="#397b00" d="M200 292.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M202.8 292.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M210.1 293.1l.2.5-.2-.5z" />
      <path fill="#397b00" d="M212 292.7v2.7h1.4v-2.7H212z" />
      <path fill="#6b735a" d="M214.8 292.7l.7.7-.7-.7z" />
      <path fill="#396b10" d="M215.5 292.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M218.3 292.7v3.3h.7l-.7-3.3z" />
      <path fill="#295200" d="M220.7 293.1l.2.5-.2-.5z" />
      <path fill="#392100" d="M242.2 292.7l.7.7-.7-.7z" />
      <path fill="#292100" d="M243 292.7l.6.7-.7-.7z" />
      <path fill="#9c9494" d="M252.8 292.7l.7.7-.7-.7z" />
      <path fill="#cecece" d="M253.5 292.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M254.2 292.7l-.7 1.3.7-1.3z" />
      <path fill="#bd0008" d="M254.9 292.7l.7.7-.7-.7z" />
      <path fill="#63636b" d="M255.6 292.7l.7.7-.7-.7z" />
      <path fill="#00216b" d="M271.8 292.7l-.7 1.3.7-1.3z" />
      <path fill="#002984" d="M272.7 293.1l.3.5-.3-.5m7.5-.4l.7.6-.7-.6z" />
      <path fill="#00184a" d="M281 292.7l2.7 2v-.7l-2.8-1.3z" />
      <path fill="#001010" d="M283.8 292.7l.6.7-.6-.7z" />
      <path fill="#002984" d="M284.4 292.7l.8.7-.8-.7z" />
      <path fill="#103900" d="M285.1 292.7l.7.7-.7-.7z" />
      <path fill="#dedede" d="M285.9 292.7l.7.7-.7-.7z" />
      <path fill="#184a00" d="M286.8 293.1l.2.5-.2-.5z" />
      <path fill="#296300" d="M288.4 292.9l.5.2-.5-.2z" />
      <path fill="#184a00" d="M290 292.7l.8.7-.7-.7z" />
      <path fill="#297b00" d="M291.5 292.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M292.2 292.7l-.7 2.7.7-2.7z" />
      <path fill="#103900" d="M294.3 292.7l.7.7-.7-.7z" />
      <path fill="#319400" d="M295.2 293.1l.3.5-.3-.5z" />
      <path fill="#103900" d="M295.7 292.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M297.1 293.4v.6h2.1l-2-.6z" />
      <path fill="#103900" d="M298.5 292.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M299.2 292.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M307 292.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M307.7 292.7l.7.7-.7-.7z" />
      <path fill="#184a00" d="M308.4 292.7l-1.4.7v.6l1.4-1.3z" />
      <path fill="#315221" d="M309 292.7l.8.7-.7-.7z" />
      <path fill="#4a6342" d="M309.8 292.7v.7h4.9l-5-.7z" />
      <path fill="#295210" d="M314.7 292.7l.7.7-.7-.7z" />
      <path fill="#184a00" d="M315.4 292.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M316.1 292.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M316.8 292.7l.7.7-.7-.7z" />
      <path fill="#294221" d="M317.5 292.7l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M318.2 292.7l.7.7-.7-.7m-125.2.7l.7.6-.7-.6z" />
      <path fill="#397b00" d="M193.7 293.4l.7.6-.7-.6z" />
      <path fill="#295200" d="M196.5 293.4l.7.6-.7-.6z" />
      <path fill="#294200" d="M197.2 293.4l.7.6-.7-.6z" />
      <path fill="#295200" d="M198 293.4l.6.6-.7-.6z" />
      <path fill="#292100" d="M202.1 293.4l.7.6-.7-.6m5.7 0l.7.6-.7-.6z" />
      <path fill="#397b00" d="M214.1 293.4l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M214.8 293.4l.7.6-.7-.6z" />
      <path fill="#294200" d="M215.5 293.4l.7.6-.7-.6m7 0l.7.6-.7-.6z" />
      <path fill="#397b00" d="M224.4 293.6l.5.2-.5-.2z" />
      <path fill="#295200" d="M226.8 293.4l.7.6-.7-.6z" />
      <path fill="#bd2110" d="M236 293.4l.6.6-.7-.6z" />
      <path fill="#631808" d="M241.5 293.4l.7.6-.7-.6z" />
      <path fill="#397b00" d="M242.2 293.4l1.4 1.3-1.4-1.3z" />
      <path fill="#428c00" d="M243 293.4l.6.6-.7-.6z" />
      <path fill="#631808" d="M243.7 293.4l.7.6-.8-.6z" />
      <path fill="#8c7373" d="M254.2 293.4l.7.6-.7-.6z" />
      <path fill="#6b0808" d="M254.9 293.4l.7.6-.7-.6z" />
      <path fill="#dedede" d="M255.6 293.4l.7.6-.7-.6z" />
      <path fill="#000818" d="M267.6 293.4l.7.6-.7-.6z" />
      <path fill="#082108" d="M271.8 293.4l.7.6-.7-.6z" />
      <path fill="#002984" d="M277.4 293.4l1.4 1.3v-1.3h-1.4z" />
      <path fill="#001039" d="M280.2 293.4l.7.6-.7-.6m2.1 0l.7.6-.7-.6z" />
      <path fill="#103900" d="M283.8 293.4l.6.6-.6-.6z" />
      <path d="M284.4 293.4l.8.6-.8-.6z" />
      <path fill="#296300" d="M285.1 293.4l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M285.9 293.4l.7.6-.7-.6z" />
      <path fill="#185200" d="M290.3 293.8l.2.4-.2-.4z" />
      <path fill="#297b00" d="M293.6 293.4v.6l3.5 1.4v-.7l-3.5-1.3z" />
      <path fill="#185200" d="M294.3 293.4l.7.6-.7-.6z" />
      <path fill="#184a00" d="M295.7 293.4l.7.6-.7-.6z" />
      <path fill="#103900" d="M297.8 293.4l.7.6-.7-.6z" />
      <path fill="#296300" d="M304.9 293.4l.7.6-.8-.6z" />
      <path fill="#103900" d="M306 293.6l.5.2-.5-.2z" />
      <path fill="#214210" d="M308.4 293.4l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M309 293.4l.8.6-.7-.6z" />
      <path fill="#8c8c8c" d="M309.8 293.4l.7.6-.7-.6z" />
      <path fill="#cecece" d="M310.5 293.4l.7.6-.7-.6m5.6 0l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M316.8 293.4l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M317.5 293.4l.7.6-.7-.6z" />
      <path fill="#292921" d="M318.7 293.6l.5.2-.5-.2z" />
      <path fill="#315221" d="M193 294l.7.7-.7-.7z" />
      <path fill="#295200" d="M195.1 294l.7.7-.7-.7z" />
      <path fill="#294200" d="M195.8 294l.7.7-.7-.7m5.6 0l.7.7-.7-.7z" />
      <path fill="#397b00" d="M202.1 294l.7.7-.7-.7z" />
      <path fill="#294200" d="M204.3 294l-.8 1.4.8-1.4z" />
      <path fill="#397b00" d="M205 294l.7.7-.7-.7z" />
      <path fill="#295200" d="M207 294l.8.7-.7-.7z" />
      <path fill="#63636b" d="M207.8 294l.7.7-.7-.7z" />
      <path fill="#397b00" d="M208.5 294l.7.7-.7-.7m1.8.2l.5.3-.5-.3z" />
      <path fill="#295200" d="M214.1 294l.7.7-.7-.7z" />
      <path fill="#efefef" d="M214.8 294l.7.7-.7-.7z" />
      <path fill="#426331" d="M215.5 294l.7.7-.7-.7z" />
      <path fill="#294200" d="M220.7 294.5l.2.4-.2-.4z" />
      <path fill="#295200" d="M222.5 294l.7.7-.7-.7m1.4 0l.7.7-.6-.7z" />
      <path fill="#397b00" d="M226.5 294.2l.5.3-.5-.3m2.4-.2l.7.7-.7-.7z" />
      <path fill="#b51010" d="M235.2 294l.7.7-.7-.7z" />
      <path fill="#211800" d="M236 294l.6.7-.7-.7z" />
      <path fill="#ce2110" d="M236.6 294l1.4 1.4-1.4-1.4z" />
      <path fill="#b51010" d="M240.8 294l.7.7-.7-.7z" />
      <path fill="#294200" d="M241.5 294l.7.7-.7-.7z" />
      <path
        fill="#428c00"
        d="M242.2 294l-1.4 4-2-1.3 2 5.3h.7v-2.6h.7v4.7c3.4-2.2 3-6 2.2-9.4h-.7v6.7h-.7l-.8-7.4z"
      />
      <path fill="#294200" d="M243.7 294l.7.7-.8-.7z" />
      <path fill="#ce2110" d="M244.3 294l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M253.5 294l.7.7-.7-.7z" />
      <path fill="#6b4242" d="M254.2 294l.7.7-.7-.7z" />
      <path fill="#63636b" d="M254.9 294l.7.7-.7-.7z" />
      <path fill="#103910" d="M267.6 294l.7.7-.7-.7z" />
      <path fill="#10214a" d="M268.3 294l.7.7-.7-.7z" />
      <path fill="#002984" d="M270.4 294l.7.7-.7-.7z" />
      <path fill="#103900" d="M271 294l.8.7-.7-.7z" />
      <path fill="#184a00" d="M271.8 294l.7.7-.7-.7z" />
      <path fill="#002984" d="M273.9 294l.7.7-.7-.7z" />
      <path fill="#001010" d="M277.4 294l.7.7-.7-.7z" />
      <path fill="#184a00" d="M280.2 294l.7.7-.7-.7z" />
      <path fill="#296300" d="M283.8 294l.6.7-.6-.7z" />
      <path fill="#424242" d="M284.4 294l.8.7-.8-.7z" />
      <path fill="#319400" d="M285.1 294l-4.2 12c4-2 6-8 4.2-12z" />
      <path fill="#293129" d="M285.9 294l.7.7-.7-.7z" />
      <path fill="#296300" d="M286.6 294l.7.7-.7-.7z" />
      <path fill="#184a00" d="M293.6 294l.7.7-.7-.7z" />
      <path fill="#185200" d="M296.2 294.2l.5.3-.5-.3z" />
      <path fill="#184a00" d="M297.1 294l.7.7-.7-.7z" />
      <path fill="#185200" d="M302.7 294l.7.7-.7-.7z" />
      <path fill="#184a00" d="M302.7 294.7v.7h3.6l-3.6-.7z" />
      <path fill="#297b00" d="M304.9 294l.7.7-.8-.7z" />
      <path fill="#319400" d="M305.6 294v.7h4.9l-5-.7z" />
      <path fill="#296300" d="M310.5 294l.7.7-.7-.7z" />
      <path fill="#315221" d="M311.2 294l-.7 1.4.7-1.4z" />
      <path fill="#7b7373" d="M311.9 294l.7.7-.7-.7z" />
      <path fill="#cecece" d="M312.6 294l.7.7-.7-.7z" />
      <path fill="#dedede" d="M319 294l.6.7-.7-.7z" />
      <path fill="#bdbdbd" d="M192.3 294.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M193 294.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M194.4 294.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M195.1 294.7l.7.7-.7-.7m5 0v2h.6l-.7-2z" />
      <path fill="#103900" d="M200.7 294.7l.7.7-.7-.7z" />
      <path fill="#295200" d="M204.3 294.7l.6.7-.7-.7z" />
      <path fill="#425242" d="M207 294.7l.8.7-.7-.7z" />
      <path fill="#315221" d="M208.5 294.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M210.6 294.7l.7.7-.7-.7z" />
      <path fill="#5a5231" d="M214.1 294.7l.7.7-.7-.7z" />
      <path fill="#526b42" d="M215.5 294.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M222.3 295l.5.1-.5-.2z" />
      <path
        fill="#294200"
        d="M224.2 295.1l.2.5-.2-.5m1.9-.4l.7.7-.7-.7m2.8 0l.7.7-.7-.7z"
      />
      <path fill="#631808" d="M235.2 294.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M236 294.7l1.3 3.3h2.1l-3.5-3.3z" />
      <path fill="#311000" d="M236.6 294.7l.7.7-.7-.7z" />
      <path fill="#422100" d="M240.8 294.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M243 294.7v2.7h.6l-.7-2.7z" />
      <path fill="#5a1008" d="M244.3 294.7l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M253.5 294.7l.7.7-.7-.7z" />
      <path fill="#101810" d="M254.2 294.7l.7.7-.7-.7z" />
      <path fill="#dedede" d="M254.9 294.7l.7.7-.7-.7z" />
      <path fill="#083121" d="M267.6 294.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M268.3 294.7l.7.7-.7-.7z" />
      <path fill="#002984" d="M269 294.7l.7.7-.7-.7z" />
      <path fill="#102110" d="M270.4 294.7l.7.7-.7-.7z" />
      <path fill="#319400" d="M271 294.7l-.6 6h.7v-6z" />
      <path fill="#083121" d="M271.8 294.7l.7.7-.7-.7z" />
      <path fill="#000818" d="M273.9 294.7l.7.7-.7-.7z" />
      <path fill="#00216b" d="M276.7 294.7l.7.7-.7-.7z" />
      <path fill="#082108" d="M277.4 294.7l-.7 1.3.7-1.3z" />
      <path fill="#00215a" d="M279.5 294.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M280.2 294.7l.7.7-.7-.7z" />
      <path fill="#00215a" d="M281 294.7l.6.7-.7-.7z" />
      <path fill="#103910" d="M281.6 294.7l.7.7-.7-.7z" />
      <path fill="#424242" d="M282.3 294.7l.7.7-.7-.7z" />
      <path fill="#103910" d="M283 294.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M283.8 294.7l-.8 1.3.8-1.3z" />
      <path fill="#294221" d="M284.4 294.7l.8.7-.8-.7z" />
      <path fill="#103900" d="M285.9 294.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M286.6 294.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M290.3 295.1l.2.5-.2-.5z" />
      <path fill="#103900" d="M293.6 294.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M295 294.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M301.3 294.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M302 294.7l.7.7-.7-.7m4.3 0l.7.7-.7-.7z" />
      <path fill="#082108" d="M307 294.7v.7h2l-2-.7z" />
      <path fill="#4a6342" d="M309.5 295l.5.1-.5-.2z" />
      <path fill="#184a00" d="M311.2 294.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M311.9 294.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M312.6 294.7l.7.7-.7-.7z" />
      <path fill="#425242" d="M313.3 294.7l.7.7-.7-.7z" />
      <path fill="#dedede" d="M314 294.7l1.4 1.3-1.4-1.3z" />
      <path fill="#7b7373" d="M192.3 295.4l.7.6-.7-.6z" />
      <path fill="#397b00" d="M197.2 295.4l.7 2.6h.7l-1.4-2.6z" />
      <path fill="#294200" d="M199 295.6l.6.2-.5-.2z" />
      <path fill="#295200" d="M202.1 295.4l.7.6-.7-.6z" />
      <path fill="#103900" d="M202.8 295.4l.7.6-.7-.6z" />
      <path fill="#397b00" d="M203.6 295.4l.7.6-.8-.6z" />
      <path fill="#213918" d="M206.4 295.4l.7.6-.7-.6z" />
      <path fill="#efefef" d="M207 295.4l.8.6-.7-.6z" />
      <path fill="#8c8c8c" d="M208.5 295.4l.7.6-.7-.6z" />
      <path fill="#294200" d="M209.2 295.4l.7.6-.7-.6z" />
      <path fill="#5a2908" d="M209.9 295.4l.7.6-.7-.6z" />
      <path fill="#7b1008" d="M210.6 295.4l.7.6-.7-.6z" />
      <path fill="#292100" d="M211.3 295.4l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M214.1 295.4l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M215.5 295.4l.7.6-.7-.6z" />
      <path fill="#295200" d="M220.4 295.4l.7.6-.7-.6z" />
      <path fill="#103900" d="M226 295.4l.8.6-.7-.6z" />
      <path fill="#181000" d="M228.9 295.4l.7.6-.7-.6z" />
      <path fill="#310000" d="M229.6 295.4l.7.6-.7-.6z" />
      <path fill="#313918" d="M235.2 295.4l.7.6-.7-.6z" />
      <path fill="#295200" d="M236 295.4l.6.6-.7-.6z" />
      <path fill="#293100" d="M237.3 295.4l.7.6-.7-.6z" />
      <path fill="#5a1010" d="M238 295.4l.7.6-.7-.6z" />
      <path fill="#734a42" d="M239.2 295.6l.5.2-.5-.2z" />
      <path fill="#5a2121" d="M240.1 295.4l.7.6-.7-.6z" />
      <path fill="#397b00" d="M240.8 295.4l.7.6-.7-.6z" />
      <path fill="#295200" d="M244.3 295.4l.7.6-.7-.6z" />
      <path fill="#bd2110" d="M245 295.4l.8.6-.7-.6z" />
      <path fill="#bdbdbd" d="M253.5 295.4l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M254.2 295.4l.7.6-.7-.6z" />
      <path fill="#002984" d="M264 295.4l.8.6-.8-.6z" />
      <path fill="#00216b" d="M264.8 295.4l.6.6-.6-.6z" />
      <path fill="#103921" d="M267.6 295.4l.7.6-.7-.6z" />
      <path fill="#319400" d="M268.3 295.4l-.7 8.7c2.6-2.5 2.5-5.8.7-8.7z" />
      <path fill="#102121" d="M269 295.4l.7.6-.7-.6z" />
      <path fill="#212139" d="M269.7 295.4l.7.6-.7-.6z" />
      <path fill="#296300" d="M270.4 295.4l.7.6-.7-.6z" />
      <path fill="#293129" d="M271.8 295.4l.7.6-.7-.6z" />
      <path fill="#42425a" d="M272.5 295.4l.7.6-.7-.6z" />
      <path fill="#31425a" d="M273.2 295.4l.7.6-.7-.6z" />
      <path fill="#103900" d="M273.9 295.4l.7.6-.7-.6z" />
      <path fill="#31425a" d="M274.6 295.4l.7.6-.7-.6z" />
      <path fill="#42425a" d="M275.8 295.6l.4.2-.4-.2z" />
      <path fill="#184a00" d="M277.6 295.8l.3.5-.2-.5z" />
      <path fill="#42425a" d="M278.1 295.4l.7.6-.7-.6z" />
      <path fill="#636b7b" d="M278.8 295.4l.7.6-.7-.6z" />
      <path fill="#082108" d="M279.5 295.4l.7.6-.7-.6z" />
      <path fill="#292921" d="M281 295.4l.6.6-.7-.6z" />
      <path fill="#185200" d="M281.6 295.4l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M282.3 295.4l.7.6-.7-.6z" />
      <path fill="#184a00" d="M283.8 295.4l.6.6-.6-.6z" />
      <path fill="#214210" d="M284.4 295.4l.8.6-.8-.6z" />
      <path fill="#185200" d="M291.5 295.4l.7.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#297b00" d="M293.6 295.4l.7.6-.7-.6z" />
      <path fill="#103900" d="M295 295.4l.7.6-.7-.6z" />
      <path fill="#185200" d="M300 295.4l.6.6-.7-.6z" />
      <path fill="#103900" d="M300.6 295.4l.7.6-.7-.6z" />
      <path fill="#296300" d="M301.3 295.4l.7.6-.7-.6z" />
      <path fill="#297b00" d="M307.7 295.4l.7.6-.7-.6z" />
      <path fill="#296300" d="M308.4 295.4l.7.6-.7-.6z" />
      <path fill="#214210" d="M309 295.4l.8.6-.7-.6z" />
      <path fill="#7b7373" d="M309.8 295.4l.7.6-.7-.6z" />
      <path fill="#dedede" d="M310.5 295.4l.7.6-.7-.6z" />
      <path fill="#cecece" d="M311.9 295.4l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M312.6 295.4l-.7 1.3.7-1.3z" />
      <path fill="#8c8c8c" d="M313.3 295.4l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M314 295.4l.7.6-.7-.6z" />
      <path fill="#314231" d="M192.3 296l.7.7-.7-.7z" />
      <path fill="#397b00" d="M193 296l.7.7-.7-.7z" />
      <path fill="#295200" d="M193.7 296l.7.7-.7-.7z" />
      <path fill="#396b10" d="M194.4 296l.7.7-.7-.7z" />
      <path fill="#213918" d="M195.1 296l.7.7-.7-.7z" />
      <path fill="#294200" d="M196.3 296.3l.4.2-.4-.2z" />
      <path fill="#428c00" d="M199 296.3l.6.2-.5-.2z" />
      <path fill="#294200" d="M201.2 296.3l.5.2-.5-.2z" />
      <path fill="#397b00" d="M202.1 296l.7.7-.7-.7z" />
      <path fill="#315221" d="M205.7 296l.7.7-.7-.7z" />
      <path fill="#cecece" d="M206.4 296l.7.7-.7-.7z" />
      <path fill="#420000" d="M209.2 296l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M211.5 296.5l.3.4-.3-.4z" />
      <path fill="#295200" d="M212 296l.7 2.7h.7L212 296z" />
      <path fill="#8c8c8c" d="M214.3 296.5l.3.4-.3-.4z" />
      <path fill="#efefef" d="M215.5 296l.7.7-.7-.7z" />
      <path fill="#214210" d="M216.2 296l.7.7-.7-.7z" />
      <path fill="#294200" d="M220.4 296l.7.7-.7-.7z" />
      <path fill="#295200" d="M224 296l.6.7-.7-.7z" />
      <path fill="#294200" d="M225.4 296l.7.7-.7-.7z" />
      <path fill="#295200" d="M228.2 296l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M228.9 296l.7.7-.7-.7z" />
      <path fill="#313931" d="M229.6 296l.7.7-.7-.7z" />
      <path fill="#213918" d="M230.3 296l.7.7-.7-.7z" />
      <path fill="#63636b" d="M231 296l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M231.7 296l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M232.4 296l.7.7-.7-.7z" />
      <path fill="#cecece" d="M233.1 296l.7.7-.7-.7z" />
      <path fill="#526b42" d="M235.2 296l.7.7-.7-.7z" />
      <path fill="#428c00" d="M236 296l1.3 1.4-1.4-1.4z" />
      <path fill="#103900" d="M236.6 296l.7.7-.7-.7z" />
      <path fill="#425242" d="M238.7 296l.7.7-.7-.7z" />
      <path fill="#dedede" d="M239.4 296l.7.7-.7-.7z" />
      <path fill="#5a5231" d="M240.1 296l.7.7-.7-.7z" />
      <path fill="#313931" d="M245 296l.8.7-.7-.7z" />
      <path fill="#7b5252" d="M245.8 296l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M246.5 296l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M247.2 296l.7.7-.7-.7z" />
      <path fill="#002984" d="M260.5 296l.7.7-.7-.7z" />
      <path fill="#00184a" d="M261.2 296l.7.7-.7-.7z" />
      <path fill="#42425a" d="M262 296l.6.7-.7-.7z" />
      <path fill="#8c8c8c" d="M262.6 296l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M263.4 296l.7.7-.8-.7z" />
      <path fill="#bdbdbd" d="M264 296l.8.7-.8-.7z" />
      <path fill="#dedede" d="M264.8 296l.6.7-.6-.7z" />
      <path fill="#214210" d="M269 296l.7.7-.7-.7z" />
      <path fill="#425242" d="M269.7 296l.7.7-.7-.7z" />
      <path fill="#63636b" d="M273.2 296l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M276 296l.7.7-.7-.7z" />
      <path fill="#296300" d="M276.7 296l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M278.8 296l.7.7-.7-.7z" />
      <path fill="#103900" d="M281 296l1.3 1.4-1.4-1.4z" />
      <path fill="#296300" d="M281.6 296l.7.7-.7-.7z" />
      <path fill="#313931" d="M282.3 296l.7.7-.7-.7z" />
      <path fill="#297b00" d="M283 296l.7.7-.7-.7z" />
      <path fill="#103900" d="M283.8 296l.6.7-.6-.7z" />
      <path fill="#185200" d="M284.4 296l.8.7-.8-.7m5.7 0l.7.7-.7-.7z" />
      <path fill="#184a00" d="M291.7 296.5l.3.4-.3-.4m1.2-.5l.7.7-.7-.7z" />
      <path fill="#297b00" d="M294.3 296l1.4 1.4-1.4-1.4z" />
      <path fill="#184a00" d="M295 296l.7.7-.7-.7z" />
      <path fill="#297b00" d="M298.5 296l.7.7-.7-.7z" />
      <path fill="#103900" d="M299.2 296l.7.7-.7-.7z" />
      <path fill="#296300" d="M300 296l.6.7-.7-.7z" />
      <path fill="#297b00" d="M309.8 296l.7.7-.7-.7z" />
      <path fill="#185200" d="M310.5 296l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M311.2 296l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M192.8 297l.4.1-.4-.2z" />
      <path fill="#efefef" d="M194.4 296.7l.7.7-.7-.7z" />
      <path fill="#214210" d="M195.1 296.7l.7.7-.7-.7z" />
      <path fill="#428c00" d="M196.5 299.4l1.4-2c-1.8-.4-2.9.6-1.4 2z" />
      <path fill="#294200" d="M199 297l.6.1-.5-.2z" />
      <path fill="#295200" d="M200 296.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M204.3 296.7l.6.7-.7-.7z" />
      <path fill="#63636b" d="M205 296.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M205.7 296.7l.7.7-.7-.7z" />
      <path fill="#5a2121" d="M209.2 296.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M216.2 296.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M217 296.7l.6.7-.7-.7z" />
      <path fill="#295200" d="M220.7 297.1l.2.5-.2-.5m2.5-.4l.8.7-.8-.7z" />
      <path fill="#63636b" d="M228.2 296.7l.7.7-.7-.7z" />
      <path fill="#dedede" d="M229.6 296.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M230.3 296.7l.7.7-.7-.7z" />
      <path
        fill="#428c00"
        d="M231 296.7l.7 4.7 3.5 2.7 5 .6.6-.6c-.5-1.9-6.2-9.7-7-5.4l-1.4-2H231z"
      />
      <path fill="#397b00" d="M232.4 296.7v1.3l1.4-1.3h-1.4z" />
      <path fill="#295200" d="M233.8 296.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M235 297l.4.1-.4-.2z" />
      <path fill="#397b00" d="M236.1 297.1l.3.5-.3-.5z" />
      <path fill="#294200" d="M237.3 296.7l.7.7-.7-.7z" />
      <path fill="#214210" d="M239.4 296.7l.7.7-.7-.7z" />
      <path fill="#295200" d="M240.1 296.7l.7.7-.7-.7z" />
      <path fill="#526b42" d="M245 296.7l.8.7-.7-.7z" />
      <path fill="#bdbdbd" d="M247.2 296.7l.7.7-.7-.7z" />
      <path fill="#63636b" d="M247.9 296.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M248.6 296.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M249.3 296.7l.7.7-.7-.7m9.1 0l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M259.1 296.7l.7.7-.7-.7z" />
      <path fill="#63636b" d="M259.8 296.7l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M260.5 296.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M261.2 296.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M269 296.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M269.7 296.7l.7.7-.7-.7z" />
      <path fill="#dedede" d="M272.5 296.7l.7.7-.7-.7z" />
      <path fill="#184a00" d="M273.2 296.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M275.3 296.7l.7.7-.7-.7z" />
      <path fill="#294221" d="M276 296.7l.7.7-.7-.7z" />
      <path
        fill="#319400"
        d="M276.7 296.7l-5 8c5.6 0 8-2.9 8.5-8h-.7l-4.9 7.4 2.1-7.4z"
      />
      <path fill="#4a6342" d="M277.4 296.7l.7.7-.7-.7z" />
      <path fill="#425242" d="M278.8 296.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M280.2 296.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M281 296.7l.6.7-.7-.7z" />
      <path fill="#184a00" d="M282.3 296.7l.7.7-.7-.7z" />
      <path fill="#319400" d="M283 296.7l-4.9 8.7c3.3-1.5 5.7-5.2 5-8.7z" />
      <path fill="#082108" d="M283.8 296.7l.6.7-.6-.7z" />
      <path fill="#297b00" d="M284.4 296.7l.8.7-.8-.7z" />
      <path fill="#184a00" d="M290 296.7l.8.7-.7-.7z" />
      <path fill="#185200" d="M294.3 296.7l.7.7-.7-.7m3.5 0l.7.7-.7-.7z" />
      <path fill="#184a00" d="M298.5 296.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M301.1 297l.5.1-.5-.2z" />
      <path fill="#296300" d="M302 296.7l.7.7-.7-.7z" />
      <path fill="#184a00" d="M302.7 296.7v.7h2.2l-2.2-.7z" />
      <path fill="#185200" d="M304.9 296.7l.7.7-.8-.7z" />
      <path fill="#184a00" d="M306 297l.5.1-.5-.2z" />
      <path fill="#185200" d="M307 296.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M307.9 297.1l.2.5-.2-.5z" />
      <path fill="#297b00" d="M308.4 296.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M311.9 296.7l.7.7-.7-.7z" />
      <path fill="#63636b" d="M312.6 296.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M313.3 296.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M194.4 297.4l.7.6-.7-.6z" />
      <path fill="#397b00" d="M196.5 297.4l-.7 1.3h1.4l-.7-1.3z" />
      <path fill="#103900" d="M197.2 297.4l.7.6-.7-.6z" />
      <path fill="#295200" d="M202.8 297.4l.7.6-.7-.6z" />
      <path fill="#5a5231" d="M203.6 297.4l.7.6-.8-.6z" />
      <path fill="#ada5a5" d="M204.3 297.4l.6.6-.7-.6z" />
      <path fill="#bdbdbd" d="M207 297.4l.8.6-.7-.6z" />
      <path fill="#8c8c8c" d="M207.8 297.4l.7.6-.7-.6z" />
      <path fill="#8c9c84" d="M208.5 297.4l.7.6-.7-.6z" />
      <path fill="#5a5231" d="M209.2 297.4l.7.6-.7-.6z" />
      <path fill="#422100" d="M209.9 297.4l.7.6-.7-.6z" />
      <path fill="#5a2908" d="M210.6 297.4l.7.6-.7-.6z" />
      <path fill="#311000" d="M211.3 297.4l.7.6-.7-.6z" />
      <path fill="#397b00" d="M212.7 297.4l.7.6-.7-.6z" />
      <path fill="#5a6b52" d="M214.1 297.4l.7.6-.7-.6z" />
      <path fill="#52525a" d="M217 297.4l.6.6-.7-.6z" />
      <path fill="#103900" d="M223.3 297.4l.6.6-.7-.6z" />
      <path fill="#314231" d="M227.5 297.4l-.7 1.3.7-1.3z" />
      <path fill="#dedede" d="M228.2 297.4l.7.6-.7-.6z" />
      <path fill="#63636b" d="M230.3 297.4l.7.6-.7-.6z" />
      <path fill="#295200" d="M231.7 297.4l.7.6-.7-.6z" />
      <path fill="#103900" d="M236.6 297.4l.7.6-.7-.6z" />
      <path fill="#294200" d="M238 297.4l-.7 1.3.7-1.3z" />
      <path fill="#103900" d="M240.1 297.4l.7.6-.7-.6z" />
      <path fill="#295200" d="M243.2 297.8l.2.5-.2-.5z" />
      <path fill="#294200" d="M245.3 297.8l.2.5-.2-.5z" />
      <path fill="#dedede" d="M248.6 297.4l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M249.3 297.4l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M250 297.4l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M257.7 297.4l.7.6-.7-.6z" />
      <path fill="#63636b" d="M258.4 297.4l.7.6-.7-.6z" />
      <path fill="#dedede" d="M259.1 297.4l.7.6-.7-.6z" />
      <path fill="#184a00" d="M269.7 297.4l.7.6-.7-.6z" />
      <path fill="#63636b" d="M272.5 297.4l-.7 1.3.7-1.3z" />
      <path fill="#297b00" d="M273.2 297.4l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M275.3 297.4l.7.6-.7-.6z" />
      <path fill="#297b00" d="M276 297.4l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M277.9 297.6l.5.2-.5-.2z" />
      <path fill="#296300" d="M278.8 297.4l.7.6-.7-.6z" />
      <path fill="#103900" d="M280.2 297.4l.7.6-.7-.6z" />
      <path fill="#319400" d="M281 297.4l.6.6-.7-.6z" />
      <path fill="#082108" d="M281.6 297.4l.7.6-.7-.6z" />
      <path fill="#297b00" d="M282.3 297.4l.7.6-.7-.6z" />
      <path fill="#103900" d="M283.8 297.4l.6.6-.6-.6z" />
      <path fill="#296300" d="M290 297.4l.8.6-.7-.6m1.4 0l.7.6-.7-.6z" />
      <path fill="#103900" d="M294.3 297.4l.7.6-.7-.6z" />
      <path fill="#297b00" d="M295.7 298v.7h2.1l-2-.7z" />
      <path fill="#103900" d="M297.1 297.4l.7.6-.7-.6z" />
      <path fill="#296300" d="M297.8 297.4l.7.6-.7-.6z" />
      <path fill="#082108" d="M308.4 297.4l.7.6-.7-.6z" />
      <path fill="#001000" d="M309 297.4l.8.6-.7-.6z" />
      <path fill="#395231" d="M309.8 297.4l.7.6-.7-.6z" />
      <path fill="#184a00" d="M310.5 297.4l.7.6-.7-.6z" />
      <path fill="#296300" d="M311.2 297.4l.7.6-.7-.6z" />
      <path fill="#297b00" d="M312.4 297.6l.4.2-.4-.2z" />
      <path fill="#214210" d="M313.3 297.4l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M314 297.4l.7.6-.7-.6z" />
      <path fill="#5a5231" d="M194.4 298l.7.7-.7-.7z" />
      <path fill="#397b00" d="M199.3 298l.7.7-.7-.7z" />
      <path fill="#295200" d="M200 298l.7.7-.7-.7z" />
      <path fill="#294200" d="M200.7 298l.7.7-.7-.7z" />
      <path fill="#5a5231" d="M201.4 298l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M202.1 298l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M202.8 298l.7.7-.7-.7z" />
      <path fill="#efefef" d="M204 298.3l.5.2-.5-.2z" />
      <path fill="#9c9494" d="M205 298l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M205.7 298l.7.7-.7-.7z" />
      <path fill="#396b10" d="M206.4 298l.7.7-.7-.7z" />
      <path fill="#397b00" d="M207 298l.8.7-.7-.7z" />
      <path
        fill="#428c00"
        d="M205.7 298.7v.7h6.3v.6h-6.3v.7h1.4v.7c-3.9.2-5.8 1.5-7.8 4.7l12-.7v.7c-3.3 1-8 .6-9.2 4 4.5-1.8 11-2.4 13.4-6.7l-4.2 2 2-2.7-6.2-.6v-.7l11.2.7v.6h-2v.7l9-.7v-.6h-2v-.7h4.2v-.7l-5.7 1.3-16.1-3.3z"
      />
      <path fill="#294200" d="M213.4 298l.7.7-.7-.7z" />
      <path fill="#315221" d="M214.1 298l.7.7-.7-.7z" />
      <path fill="#efefef" d="M217 298l.6.7-.7-.7z" />
      <path fill="#314231" d="M217.6 298l.7.7-.7-.7z" />
      <path fill="#294200" d="M220.4 298l1.4 1.4-1.4-1.4z" />
      <path fill="#397b00" d="M223 298.3l.5.2-.5-.2m3-.3l.8.7-.7-.7z" />
      <path fill="#efefef" d="M227.5 298l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M230.3 298l.7.7-.7-.7z" />
      <path fill="#397b00" d="M231 298l.7.7-.7-.7z" />
      <path fill="#294200" d="M232.9 298.3l.4.2-.4-.2z" />
      <path fill="#295200" d="M238 298l2.1 1.4v-.7l-2-.7z" />
      <path fill="#103900" d="M239 298.5l.2.4-.2-.4z" />
      <path fill="#294200" d="M240.8 298l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M250 298l.7.7-.7-.7z" />
      <path fill="#52525a" d="M250.7 298l.7.7-.7-.7z" />
      <path fill="#cecece" d="M251.4 298l.7.7-.7-.7m5 0l-1.5 2 1.4-2z" />
      <path fill="#63636b" d="M257 298l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M257.7 298l.7.7-.7-.7z" />
      <path fill="#185200" d="M269.7 298l.7.7-.7-.7z" />
      <path fill="#184a00" d="M272.5 298l.7.7-.7-.7z" />
      <path fill="#319400" d="M273.2 298l-4.2 6.7c2.6-1.3 5-3.7 4.2-6.7z" />
      <path fill="#184a00" d="M273.9 298l.7.7-.7-.7z" />
      <path fill="#cecece" d="M274.6 298l.7.7-.7-.7z" />
      <path fill="#184a00" d="M275.3 298l.7.7-.7-.7z" />
      <path fill="#296300" d="M276.7 298l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M277.4 298l.7.7-.7-.7z" />
      <path fill="#214210" d="M278.1 298l.7.7-.7-.7z" />
      <path fill="#184a00" d="M280.2 298l1.4 1.4-1.4-1.4z" />
      <path fill="#297b00" d="M281 298l1.3 1.4-1.4-1.4z" />
      <path fill="#103900" d="M281.6 298l.7.7-.7-.7z" />
      <path fill="#297b00" d="M283 298l.7.7-.7-.7z" />
      <path fill="#296300" d="M283.8 298l.6.7-.6-.7z" />
      <path fill="#185200" d="M288.7 298l.7.7-.7-.7zm5.6 0l.7.7-.7-.7z" />
      <path fill="#103900" d="M296.4 298l.7.7-.7-.7z" />
      <path fill="#296300" d="M309 298l.8.7-.7-.7z" />
      <path fill="#425242" d="M309.8 298l.7.7-.7-.7z" />
      <path fill="#efefef" d="M310.5 298l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M311.2 298l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M311.9 298l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M312.6 298l.7.7-.7-.7z" />
      <path fill="#185200" d="M313.3 298l.7.7-.7-.7z" />
      <path fill="#184a00" d="M314 298l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M314.7 298l.7.7-.7-.7z" />
      <path fill="#294200" d="M194.6 299.1l.3.5-.3-.5m2-.4l.6.7-.7-.7z" />
      <path fill="#526b42" d="M197.2 298.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M198.4 299l.5.2-.5-.3z" />
      <path fill="#bdbdbd" d="M199.3 298.7l.7.7-.7-.7z" />
      <path fill="#dedede" d="M200 298.7l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M202.8 298.7l.7.7-.7-.7z" />
      <path d="M203.6 298.7l.7.7-.8-.7z" />
      <path fill="#295200" d="M204.3 298.7l.6.7-.7-.7z" />
      <path fill="#397b00" d="M205 298.7l.7.7-.7-.7z" />
      <path fill="#292100" d="M214.1 298.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M214.8 298.7l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M217 298.7l.6.7-.7-.7z" />
      <path fill="#63636b" d="M217.6 298.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M218.3 298.7l.7.7-.7-.7z" />
      <path fill="#001000" d="M220.4 298.7l.7.7-.7-.7z" />
      <path fill="#295200" d="M221.8 298.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M222.5 298.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M224.7 298.7l.7.7-.8-.7z" />
      <path fill="#214210" d="M225.4 298.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M226 298.7l.8.7-.7-.7z" />
      <path fill="#efefef" d="M230.3 298.7l.7.7-.7-.7z" />
      <path fill="#295200" d="M231 298.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M233.8 298.7l1.4 1.3-1.4-1.3z" />
      <path fill="#295200" d="M240.8 298.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M243 298.7v2.7h.6l-.7-2.7z" />
      <path fill="#295200" d="M245 298.7l.8.7-.7-.7z" />
      <path fill="#7b7373" d="M251.4 298.7l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M252 298.7l2.2 2.7-2.1-2.7z" />
      <path fill="#7b7373" d="M256.3 298.7l-1.4 2 1.4-2z" />
      <path fill="#efefef" d="M257 298.7l.7.7-.7-.7z" />
      <path fill="#184a00" d="M270 299.1l.1.5-.2-.5z" />
      <path d="M271.8 298.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M272.5 298.7l.7.7-.7-.7z" />
      <path fill="#315221" d="M273.9 298.7l.7.7-.7-.7z" />
      <path fill="#314231" d="M274.6 298.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M276.7 298.7l.7.7-.7-.7z" />
      <path fill="#425242" d="M277.4 298.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M278.1 298.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M280.2 298.7l.7.7-.7-.7m2.8 0l.7.7-.7-.7z" />
      <path fill="#184a00" d="M288.7 298.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M295 298.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M295.7 298.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M309.8 298.7l.7.7-.7-.7z" />
      <path fill="#103910" d="M310.5 298.7l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M311.2 298.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M313.3 298.7l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M314 298.7l.7.7-.7-.7z" />
      <path fill="#52525a" d="M314.7 298.7l.7.7-.7-.7z" />
      <path fill="#424242" d="M315.4 298.7l.7.7-.7-.7z" />
      <path fill="#dedede" d="M193.7 299.4l.7.6-.7-.6z" />
      <path fill="#213918" d="M195.1 299.4l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M195.8 299.4l.7.6-.7-.6z" />
      <path fill="#efefef" d="M196.5 299.4l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M203.6 299.4l1.4 1.3-1.4-1.3z" />
      <path fill="#214210" d="M204.3 299.4l.6.6-.7-.6z" />
      <path fill="#294200" d="M205 299.4v.6h3.5l-3.5-.6z" />
      <path fill="#295200" d="M208.5 299.4l.7.6-.7-.6z" />
      <path fill="#397b00" d="M209.2 299.4l.7.6-.7-.6z" />
      <path fill="#295200" d="M209.9 299.4l.7.6-.7-.6z" />
      <path fill="#294200" d="M210.6 299.4l.7.6-.7-.6z" />
      <path fill="#295200" d="M211.3 299.4l.7.6-.7-.6z" />
      <path fill="#213918" d="M214.8 299.4l.7.6-.7-.6z" />
      <path fill="#cecece" d="M215.5 299.4l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M216.2 299.4l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M217 299.4l.6.6-.7-.6z" />
      <path fill="#941808" d="M218.3 299.4l.7.6-.7-.6z" />
      <path fill="#397b00" d="M219 299.4l.7.6-.7-.6z" />
      <path fill="#295200" d="M219.7 299.4l.7.6-.7-.6z" />
      <path fill="#941808" d="M220.4 299.4l.7.6-.7-.6z" />
      <path fill="#de2110" d="M221.1 299.4l-.7 1.3.7-1.3z" />
      <path fill="#b51010" d="M221.8 299.4l.7.6-.7-.6z" />
      <path fill="#294200" d="M222.5 299.4l.7.6-.7-.6z" />
      <path fill="#295200" d="M223.3 299.4l.6.6-.7-.6z" />
      <path fill="#102110" d="M224 299.4l.6.6-.7-.6z" />
      <path fill="#63636b" d="M224.7 299.4l.7.6-.8-.6z" />
      <path fill="#bdbdbd" d="M225.4 299.4l.7.6-.7-.6z" />
      <path fill="#315221" d="M231 299.4l.7.6-.7-.6z" />
      <path fill="#397b00" d="M235.2 299.4l2.1 2-2-2m4.1 0l.7.6-.7-.6z" />
      <path fill="#294200" d="M241.8 299.8l.2.5-.2-.5m3.2-.4l.8.6-.8-.6z" />
      <path fill="#6b735a" d="M267.6 299.4l.7.6-.7-.6z" />
      <path fill="#297b00" d="M271 299.4l.8.6-.7-.6z" />
      <path fill="#184a00" d="M271.8 299.4l.7.6-.7-.6z" />
      <path fill="#101810" d="M273.9 299.4l.7.6-.7-.6z" />
      <path fill="#297b00" d="M274.6 299.4l.7.6-.7-.6z" />
      <path fill="#001000" d="M276.7 299.4l.7.6-.7-.6z" />
      <path fill="#296300" d="M277.4 299.4l.7.6-.7-.6m2.1 0l.7.6-.7-.6z" />
      <path fill="#185200" d="M280.7 299.6l.5.2-.5-.2z" />
      <path fill="#184a00" d="M283 299.4l.7.6-.7-.6z" />
      <path fill="#297b00" d="M285.1 299.4l1.4 1.3-1.4-1.3z" />
      <path fill="#184a00" d="M295 299.4l.7.6-.7-.6z" />
      <path fill="#297b00" d="M297.1 299.4l1.4 1.3-1.4-1.3z" />
      <path fill="#185200" d="M297.8 299.4l.7.6-.7-.6z" />
      <path fill="#184a00" d="M298.5 299.4v.6h2.1l-2-.6z" />
      <path fill="#296300" d="M300.6 299.4l.7.6-.7-.6z" />
      <path fill="#184a00" d="M301.3 299.4v.6h3.5l-3.5-.6z" />
      <path fill="#296300" d="M304.9 299.4l.7.6-.8-.6z" />
      <path fill="#184a00" d="M305.6 299.4l.7.6-.7-.6z" />
      <path fill="#296300" d="M306.3 299.4l.7.6-.7-.6z" />
      <path fill="#297b00" d="M307 299.4l.7.6-.7-.6z" />
      <path fill="#185200" d="M311.2 299.4l1.4 1.3-1.4-1.3z" />
      <path fill="#9c9494" d="M311.9 299.4l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M193.7 300l.7.7-.7-.7z" />
      <path fill="#313931" d="M194.4 300l.7.7-.7-.7z" />
      <path fill="#efefef" d="M195.1 300l-1.4.7v.7l1.4-1.4z" />
      <path fill="#103900" d="M205 300l.7.7-.7-.7z" />
      <path fill="#295200" d="M212 300l.7.7-.7-.7z" />
      <path fill="#294200" d="M212.7 300l.7.7-.7-.7m2.8 0l.7.7-.7-.7z" />
      <path fill="#391810" d="M216.2 300l.7.7-.7-.7z" />
      <path fill="#423100" d="M219.5 300.3l.5.2-.5-.2z" />
      <path fill="#ce2110" d="M221.1 300l.7.7-.7-.7z" />
      <path fill="#631808" d="M221.8 300l.7.7-.7-.7z" />
      <path fill="#293100" d="M222.5 300l.7.7-.7-.7z" />
      <path fill="#397b00" d="M223.3 300v.7h2.8l-2.8-.7z" />
      <path fill="#294200" d="M226 300l.8.7-.7-.7z" />
      <path fill="#315221" d="M226.8 300l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M227.5 300l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M228.2 300l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M231 300l.7.7-.7-.7z" />
      <path fill="#294200" d="M235.2 300l.7.7-.7-.7m4.2 0l.7 2h.7l-1.4-2z" />
      <path fill="#315221" d="M245 300l.8.7-.7-.7z" />
      <path fill="#bdbdbd" d="M254.2 300l.7.7-.7-.7z" />
      <path fill="#4a6342" d="M267.6 300l.7.7-.7-.7z" />
      <path fill="#103900" d="M271 300l.8.7-.7-.7z" />
      <path fill="#185200" d="M273.2 300l.7.7-.7-.7z" />
      <path fill="#103900" d="M273.9 300l-.7 1.4.7-1.4z" />
      <path fill="#297b00" d="M276 300l1.4 1.4-1.4-1.4z" />
      <path fill="#103900" d="M276.7 300l.7.7-.7-.7z" />
      <path fill="#184a00" d="M279.5 300l.7.7-.7-.7z" />
      <path fill="#103900" d="M280.2 300l.7.7-.7-.7z" />
      <path fill="#297b00" d="M282.3 300l1.4 1.4-1.4-1.4z" />
      <path fill="#185200" d="M283 300l.7.7-.7-.7m2.2 0l.7.7-.7-.7z" />
      <path fill="#297b00" d="M295.7 300l.7.7-.7-.7z" />
      <path fill="#184a00" d="M296.4 300l.7.7-.7-.7z" />
      <path fill="#185200" d="M297.1 300l.7.7-.7-.7z" />
      <path fill="#297b00" d="M305.6 300l.7.7-.7-.7z" />
      <path fill="#103900" d="M306.3 300l.7.7-.7-.7z" />
      <path fill="#101810" d="M307 300l.7.7-.7-.7z" />
      <path fill="#425242" d="M307.7 300l.7.7-.7-.7z" />
      <path fill="#315221" d="M308.4 300l.7.7-.7-.7z" />
      <path fill="#185200" d="M309 300l.8.7-.7-.7z" />
      <path fill="#296300" d="M309.8 300l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M312.6 300l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M202.8 300.7l.7.7-.7-.7z" />
      <path fill="#5a5231" d="M203.6 300.7l.7.7-.8-.7z" />
      <path fill="#295200" d="M204.3 300.7l.6.7-.7-.7z" />
      <path fill="#397b00" d="M205 300.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M206.1 301l.5.2-.5-.3z" />
      <path fill="#397b00" d="M216.2 300.7l.7.7-.7-.7z" />
      <path fill="#293100" d="M217 300.7l.6.7-.7-.7z" />
      <path fill="#631808" d="M217.6 300.7l.7.7-.7-.7z" />
      <path fill="#941808" d="M218.3 300.7l.7.7-.7-.7z" />
      <path fill="#295200" d="M219 300.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M219.7 300.7l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M220.4 300.7l.7.7-.7-.7z" />
      <path fill="#392100" d="M221.1 300.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M227.5 300.7l-2.1 2 2-2z" />
      <path fill="#294200" d="M228.2 300.7v1.3h1.4l-1.4-1.3z" />
      <path fill="#213918" d="M228.9 300.7l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M229.6 300.7l1.4 1.3-1.4-1.3z" />
      <path fill="#8c8c8c" d="M231 300.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M236 300.7l.6.7-.7-.7z" />
      <path fill="#397b00" d="M239.4 300.7l.7.7-.7-.7z" />
      <path fill="#295200" d="M241.5 300.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M245 300.7l.8.7-.7-.7m9.1 0l.7.7-.7-.7z" />
      <path fill="#294221" d="M267.6 300.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M271 300.7l.8.7-.7-.7z" />
      <path fill="#297b00" d="M273.9 300.7l.7.7-.7-.7z" />
      <path fill="#184a00" d="M276 300.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M278.8 300.7l.7.7-.7-.7z" />
      <path d="M279.5 300.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M280.2 300.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M282.3 300.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M285.1 300.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M288 300.7l.7.7-.7-.7z" />
      <path fill="#184a00" d="M289.1 301l.5.2-.5-.3z" />
      <path fill="#185200" d="M290 300.7l.8.7-.7-.7z" />
      <path
        fill="#297b00"
        d="M290.8 300.7l-.7 1.3.7-1.3m2.8 0l.7.7-.7-.7m13.4 0l.7.7-.7-.7z"
      />
      <path fill="#103910" d="M307.7 300.7l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M308.4 300.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M309 300.7l.8.7-.7-.7z" />
      <path fill="#bdbdbd" d="M309.8 300.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M310.5 300.7l.7.7-.7-.7z" />
      <path fill="#294221" d="M311.2 300.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M311.9 300.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M312.6 300.7l.7.7-.7-.7z" />
      <path fill="#63636b" d="M313.3 300.7l1.4 1.3-1.4-1.3z" />
      <path fill="#efefef" d="M201.4 301.4l-1.4 2 1.4-2z" />
      <path fill="#425242" d="M202.1 301.4l.7.7-.7-.7z" />
      <path fill="#397b00" d="M202.8 301.4l.7.7-.7-.7z" />
      <path fill="#294200" d="M207.5 301.6l.5.2-.5-.2z" />
      <path fill="#397b00" d="M208.7 301.8l.2.5-.2-.5z" />
      <path fill="#294200" d="M218.8 301.6l.5.2-.5-.2z" />
      <path d="M220.4 301.4l.7.7-.7-.7z" />
      <path fill="#397b00" d="M221.1 301.4l.7.7-.7-.7z" />
      <path fill="#294200" d="M223.3 301.4v.7h2l-2-.7z" />
      <path fill="#103900" d="M229.6 301.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M231 301.4l.7.7-.7-.7z" />
      <path fill="#397b00" d="M231.7 301.4l.7.7-.7-.7z" />
      <path fill="#294200" d="M232.4 301.4l.7.7-.7-.7z" />
      <path fill="#422100" d="M233.1 301.4l.7.7-.7-.7z" />
      <path fill="#4a4208" d="M233.8 301.4l.7.7-.7-.7z" />
      <path fill="#103900" d="M236.6 301.4l.7.7-.7-.7z" />
      <path fill="#295200" d="M237.3 301.4v1.3h1.4l-1.4-1.3zm7 0l.7.7-.7-.7z" />
      <path fill="#dedede" d="M245 301.4l.8.7-.7-.7z" />
      <path fill="#cecece" d="M266.9 301.4l.7.7-.7-.7z" />
      <path fill="#185200" d="M267.6 301.4l.7.7-.7-.7z" />
      <path fill="#297b00" d="M269.7 301.4l1.4 1.3-1.4-1.3z" />
      <path fill="#185200" d="M272.5 301.4l.7.7-.7-.7z" />
      <path fill="#296300" d="M273.2 301.4l.7.7-.7-.7z" />
      <path fill="#297b00" d="M275.3 301.4l1.4 1.3-1.4-1.3z" />
      <path fill="#103900" d="M276 301.4l.7.7-.7-.7z" />
      <path fill="#184a00" d="M279.3 301.6l.5.2-.5-.2m3-.2l.7.7-.7-.7z" />
      <path fill="#297b00" d="M284.4 301.4l1.5 1.3-1.5-1.3z" />
      <path fill="#185200" d="M285.1 301.4l.7.7-.7-.7z" />
      <path fill="#296300" d="M290.8 301.4l.7.7-.7-.7z" />
      <path fill="#184a00" d="M291.5 301.4l.7.7-.7-.7z" />
      <path fill="#103900" d="M292.2 301.4l.7.7-.7-.7z" />
      <path fill="#296300" d="M292.9 301.4l.7.7-.7-.7z" />
      <path fill="#185200" d="M297.8 301.4l.7.7-.7-.7z" />
      <path fill="#184a00" d="M298.5 301.4l.7.7-.7-.7z" />
      <path fill="#296300" d="M299.2 301.4v1.3h1.4l-1.4-1.3z" />
      <path fill="#297b00" d="M300 301.4l.6.7-.7-.7z" />
      <path fill="#185200" d="M308.4 301.4l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M309 301.4l.8.7-.7-.7z" />
      <path fill="#bdbdbd" d="M311.9 301.4l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M312.6 301.4l.7.7-.7-.7z" />
      <path fill="#082108" d="M313.3 301.4l.7.7-.7-.7z" />
      <path fill="#efefef" d="M314.7 301.4l.7.7-.7-.7z" />
      <path fill="#314231" d="M201.4 302l.7.7-.7-.6z" />
      <path fill="#295200" d="M209.2 302l.7.7-.7-.6z" />
      <path fill="#294200" d="M209.9 302v.7h2.8l-2.8-.6z" />
      <path fill="#295200" d="M212.7 302l.7.7-.7-.6z" />
      <path fill="#397b00" d="M213.4 302v2l2.8-2h-2.8z" />
      <path fill="#294200" d="M216.7 302.3l.5.2-.5-.2z" />
      <path fill="#397b00" d="M217.6 302l.7.7-.7-.6z" />
      <path fill="#103900" d="M221.8 302l.7.7-.7-.6z" />
      <path fill="#295200" d="M222.5 302l.7.7-.7-.6z" />
      <path fill="#214210" d="M226 302l.8.7-.7-.6z" />
      <path fill="#63636b" d="M226.8 302l.7.7-.7-.6z" />
      <path fill="#8c8c8c" d="M227.5 302l-.7 1.4.7-1.3z" />
      <path fill="#bdbdbd" d="M228.2 302v1.4h1.4l-1.4-1.3z" />
      <path fill="#cecece" d="M230 302.3l.5.2-.4-.2z" />
      <path d="M231.7 302l.7.7-.7-.6z" />
      <path fill="#bd2110" d="M232.4 302l.7.7-.7-.6zm1.4 0l.7.7-.7-.6z" />
      <path fill="#294200" d="M234.5 302l.7.7-.7-.6z" />
      <path fill="#397b00" d="M240.6 302.3l.5.2-.5-.2z" />
      <path fill="#5a6b52" d="M244.3 302l.7.7-.7-.6z" />
      <path fill="#7b7373" d="M266.9 302l.7.7-.7-.6z" />
      <path fill="#103900" d="M269.7 302l.7.7-.7-.6z" />
      <path fill="#297b00" d="M271.8 302l1.4 1.4-1.4-1.3z" />
      <path fill="#103900" d="M272.5 302l.7.7-.7-.6z" />
      <path fill="#184a00" d="M275.5 302.5l.3.5-.3-.5z" />
      <path fill="#297b00" d="M278.1 302l1.4 1.4-1.4-1.3z" />
      <path fill="#082108" d="M278.8 302l.7.7-.7-.6z" />
      <path fill="#296300" d="M282.1 302.3l.5.2-.5-.2z" />
      <path fill="#185200" d="M284.4 302l.8.7-.8-.6m8.7.4l.3.4-.3-.4z" />
      <path fill="#103900" d="M293.8 302.5l.3.5-.3-.5z" />
      <path fill="#297b00" d="M294.3 302l.7.7-.7-.6z" />
      <path fill="#296300" d="M296.4 302l.7.7-.7-.6z" />
      <path fill="#297b00" d="M297.1 302l-1.4 2 1.4-2z" />
      <path fill="#184a00" d="M300.6 302v.7h2.1l-2-.6z" />
      <path fill="#185200" d="M302.7 302l1.4 1.4V302h-1.4z" />
      <path fill="#297b00" d="M304.1 302l.7.7-.7-.6m5 0l2 2-2-2z" />
      <path fill="#63636b" d="M309.8 302l2 2-2-2z" />
      <path fill="#efefef" d="M313.3 302l.7.7-.7-.6z" />
      <path fill="#8c8c8c" d="M314.5 302.3l.4.2-.4-.2z" />
      <path fill="#314231" d="M200.7 302.7l.7.7-.7-.7z" />
      <path fill="#292100" d="M213.4 302.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M223.3 302.7l2.8 1.4v-.7l-2.8-.7z" />
      <path fill="#103900" d="M224 302.7l.6.7-.7-.7z" />
      <path fill="#292921" d="M224.7 302.7l.7.7-.8-.7z" />
      <path fill="#7b7373" d="M225.4 302.7l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M226 302.7l.8.7-.7-.7z" />
      <path fill="#9c9494" d="M227.5 302.7l.7.7-.7-.7z" />
      <path fill="#dedede" d="M229.6 302.7l.7.7-.7-.7z" />
      <path fill="#734a42" d="M231.7 302.7l.7.7-.7-.7z" />
      <path fill="#423100" d="M234.5 302.7l.7.7-.7-.7z" />
      <path fill="#295200" d="M241 303.2l.3.4-.2-.4z" />
      <path fill="#397b00" d="M243.7 302.7l.7.7-.8-.7z" />
      <path fill="#9c9494" d="M244.3 302.7l.7.7-.7-.7z" />
      <path fill="#315221" d="M266.9 302.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M269.2 303.2l.2.4-.2-.4z" />
      <path fill="#296300" d="M269.7 302.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M271.8 302.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M274.6 302.7l.7.7-.7-.7z" />
      <path fill="#184a00" d="M278.4 303.2l.2.4-.2-.4m3.2-.5l.7.7-.7-.7z" />
      <path fill="#103900" d="M284.4 302.7l.8.7-.8-.7z" />
      <path fill="#297b00" d="M286.6 302.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M287.3 302.7l.7.7-.7-.7z" />
      <path fill="#184a00" d="M285.9 303.4v.7l6.3-.7h-6.3z" />
      <path fill="#296300" d="M292.2 302.7l-.7 1.4.7-1.4z" />
      <path d="M294.3 302.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M295 302.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M297.1 302.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M297.8 302.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M298.5 302.7l.7.7-.7-.7z" />
      <path d="M304.1 302.7l.7.7-.7-.7z" />
      <path fill="#52525a" d="M304.9 302.7l.7.7-.8-.7z" />
      <path fill="#315221" d="M305.6 302.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M306.3 302.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M307 302.7l.7.7-.7-.7z" />
      <path fill="#314231" d="M200 303.4l.7.7-.7-.7z" />
      <path fill="#295200" d="M209.2 303.4l-.7 1.3.7-1.3z" />
      <path fill="#294200" d="M209.9 303.4l.7.7-.7-.7z" />
      <path fill="#295200" d="M212.7 303.4l-.7 2 .7-2z" />
      <path fill="#103900" d="M215.5 303.4l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M216.2 303.4l.7.7-.7-.7z" />
      <path fill="#315221" d="M217 303.4l.6.7-.7-.7z" />
      <path fill="#295200" d="M217.6 303.4l.7.7-.7-.7z" />
      <path fill="#397b00" d="M218.3 303.4v.7h2.8l-2.8-.7z" />
      <path fill="#294200" d="M221.1 303.4l.7.7-.7-.7z" />
      <path fill="#103900" d="M221.8 303.4l.7.7-.7-.7z" />
      <path fill="#292100" d="M222.5 303.4l.7.7-.7-.7z" />
      <path fill="#428c00" d="M219.7 306.7l14.8-2c-4.6-1.8-11.3-1.6-14.8 2z" />
      <path fill="#397b00" d="M228.2 303.4v.7h2l-2-.7z" />
      <path fill="#294200" d="M230.3 303.4v.7h2l-2-.7z" />
      <path fill="#422100" d="M232.4 303.4l.7.7-.7-.7z" />
      <path fill="#5a2908" d="M233.1 303.4l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M233.8 303.4l.7.7-.7-.7z" />
      <path fill="#294200" d="M234.5 303.4l1.4 1.3-1.4-1.3z" />
      <path fill="#214210" d="M243.7 303.4l.7.7-.8-.7z" />
      <path fill="#bdbdbd" d="M266.2 303.4l.7.7-.7-.7z" />
      <path fill="#185200" d="M270.4 304.7l2-1.3-2 1.3z" />
      <path fill="#103900" d="M274.6 303.4l.7.7-.7-.7z" />
      <path fill="#297b00" d="M277.4 303.4l-1.4 2h2.1l-.7-2z" />
      <path fill="#296300" d="M281.4 303.6l.5.2-.5-.2z" />
      <path fill="#185200" d="M283.8 303.4l.6.7-.6-.7z" />
      <path fill="#296300" d="M285 303.6l.4.2-.5-.2z" />
      <path fill="#185200" d="M290 303.4l.8.7-.7-.7z" />
      <path fill="#297b00" d="M292.2 303.4l-.7 1.3.7-1.3z" />
      <path fill="#319400" d="M292.9 303.4v.7l9.8 2.6v-.6l-9.8-2.7z" />
      <path fill="#296300" d="M295 303.4l.7.7-.7-.7z" />
      <path fill="#185200" d="M298.5 303.4l.7.7-.7-.7z" />
      <path fill="#103900" d="M299.2 303.4l.7.7-.7-.7z" />
      <path fill="#185200" d="M300 303.4l.6.7-.7-.7z" />
      <path fill="#297b00" d="M304.1 303.4l1.4 1.3-1.4-1.3z" />
      <path fill="#314231" d="M304.9 303.4l.7.7-.8-.7z" />
      <path fill="#cecece" d="M305.6 303.4l1.4 1.3-1.4-1.3z" />
      <path fill="#dedede" d="M306.3 303.4l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M307 303.4l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M307.7 303.4l.7.7-.7-.7z" />
      <path fill="#214210" d="M308.4 303.4l.7.7-.7-.7z" />
      <path fill="#297b00" d="M309 303.4l.8.7-.7-.7z" />
      <path fill="#63636b" d="M199.3 304l.7.7-.7-.6z" />
      <path fill="#397b00" d="M200 304l.7.7-.7-.6m2.8 0v1.3h2.1v-1.3h-2z" />
      <path fill="#295200" d="M205 304l.7.7-.7-.6z" />
      <path fill="#294200" d="M205.7 304l.7.7-.7-.6z" />
      <path fill="#295200" d="M206.4 304l.7.7-.7-.6z" />
      <path fill="#294200" d="M207.5 304.3l.5.2-.5-.2z" />
      <path fill="#8c8c8c" d="M215.5 304l.7.7-.7-.6z" />
      <path fill="#dedede" d="M217.6 304l.7.7-.7-.6z" />
      <path fill="#bdbdbd" d="M218.3 304v.7h2.8l-2.8-.6z" />
      <path fill="#52525a" d="M221.1 304l.7.7-.7-.6z" />
      <path fill="#397b00" d="M221.8 304l.7.7-.7-.6m12.7 0l.7.6-.7-.6z" />
      <path fill="#292100" d="M236 304v.7h2l-2-.6z" />
      <path fill="#295200" d="M238 304l.7.7-.7-.6z" />
      <path fill="#397b00" d="M240.1 304l.7.7-.7-.6z" />
      <path fill="#103900" d="M240.8 304l.7.7-.7-.6z" />
      <path fill="#313931" d="M243.7 304l.7.7-.8-.6z" />
      <path fill="#bd8c8c" d="M244.8 304.3l.5.2-.5-.2z" />
      <path fill="#845a52" d="M245.8 304l.7.7-.7-.6z" />
      <path fill="#9c4a42" d="M253.5 304l.7.7-.7-.6z" />
      <path fill="#ad524a" d="M254.2 304l.7.7-.7-.6z" />
      <path fill="#845a52" d="M262 304l.6.7-.7-.6z" />
      <path fill="#bd8c8c" d="M263.1 304.3l.5.2-.5-.2z" />
      <path fill="#293129" d="M266.2 304l.7.7-.7-.6z" />
      <path fill="#082108" d="M268.3 304l.7.7-.7-.6z" />
      <path fill="#103900" d="M277.4 304l.7.7-.7-.6z" />
      <path fill="#297b00" d="M280.2 304l-.7 1.4.7-1.3z" />
      <path fill="#103900" d="M281 304l.6.7-.7-.6z" />
      <path fill="#297b00" d="M283 304l1.4 1.4-1.4-1.3z" />
      <path fill="#184a00" d="M283.8 304l.6.7-.6-.6z" />
      <path
        fill="#319400"
        d="M283.8 306l17.5 2.7v2.7c2-5.8-14.2-9.7-17.6-5.3z"
      />
      <path fill="#103900" d="M292.2 304l.7.7-.7-.6z" />
      <path fill="#184a00" d="M292.9 304l.7.7-.7-.6z" />
      <path fill="#185200" d="M293.6 304l1.4 1.4-1.4-1.3z" />
      <path fill="#297b00" d="M294.3 304l.7.7-.7-.6z" />
      <path fill="#296300" d="M300 304l.6.7-.7-.6z" />
      <path fill="#082108" d="M300.6 304l.7.7-.7-.6z" />
      <path fill="#103900" d="M301.3 304l.7.7-.7-.6z" />
      <path fill="#296300" d="M302 304l.7.7-.7-.6z" />
      <path fill="#214210" d="M305.6 304l.7.7-.7-.6z" />
      <path fill="#9c9494" d="M309 304l.8.7-.7-.6z" />
      <path fill="#425242" d="M309.8 304l.7.7-.7-.6z" />
      <path fill="#185200" d="M311 304.3l.4.2-.4-.2z" />
      <path fill="#9c9494" d="M311.9 304l.7.7-.7-.6m-113.3.6l-1.4 2 1.4-2z" />
      <path fill="#397b00" d="M199.3 304.7l.7.7-.7-.7z" />
      <path fill="#295200" d="M200.7 304.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M202 305l.4.2-.5-.2m9.4-.3l.7.7-.7-.7z" />
      <path fill="#315221" d="M214.8 304.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M219.7 304.7l-.7 1.4.7-1.4z" />
      <path fill="#293129" d="M220.4 304.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M232.9 305l.4.2-.4-.2z" />
      <path fill="#294200" d="M233.8 304.7l.7.7-.7-.7z" />
      <path fill="#423100" d="M234.5 304.7l.7.7-.7-.7z" />
      <path fill="#422100" d="M235.7 305l.5.2-.5-.2z" />
      <path fill="#5a2908" d="M236.6 304.7l.7.7-.7-.7z" />
      <path fill="#631808" d="M237.3 304.7v.7h2.1l-2-.7z" />
      <path fill="#ad1810" d="M239.4 304.7v.7h2.1l-2-.7z" />
      <path fill="#bd2110" d="M241.5 304.7l.7.7-.7-.7z" />
      <path
        fill="#de2110"
        d="M225.4 316.8v-.7l-4.3.7v-.7c19-5.7 47.1-5.7 66.2 0v.7l-3.6-.7c3.5 5 13 2 9.9-4-2.7-5-12.5-5.5-17.6-6.2-14.3-2-30-2.1-44.3.1-5 .8-11.3 1.2-15.3 4.6-3 2.4-1.9 7.3 2 8.4 2.4.7 5-1.1 7-2.2z"
      />
      <path fill="#ce2110" d="M266.2 304.7l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M269 304.7l.7.7-.7-.7z" />
      <path fill="#631808" d="M270.1 305l.5.2-.5-.2z" />
      <path fill="#6b2908" d="M271 304.7l.8.7-.7-.7z" />
      <path fill="#184a00" d="M273.9 304.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M274.6 304.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M275.3 304.7l.7.7-.7-.7z" />
      <path
        fill="#103900"
        d="M276.7 304.7l.7.7-.7-.7m3.5 0l-.7 1.4.7-1.4m2.8 0l.7.7-.7-.7z"
      />
      <path fill="#297b00" d="M293.6 304.7l.7.7-.7-.7z" />
      <path fill="#184a00" d="M295.5 305l.4.2-.4-.2z" />
      <path fill="#297b00" d="M296.4 304.7l-.7 1.4.7-1.4m4.2 0l.7.7-.7-.7z" />
      <path fill="#214210" d="M301.3 304.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M302 304.7l1.4 1.4-1.4-1.4z" />
      <path fill="#7b7373" d="M302.7 304.7l.7.7-.7-.7z" />
      <path fill="#315221" d="M303.4 304.7l.8.7-.8-.7z" />
      <path fill="#185200" d="M304.1 304.7l.7.7-.7-.7z" />
      <path fill="#103910" d="M306.3 304.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M307 304.7l1.4 1.4-1.4-1.4z" />
      <path fill="#cecece" d="M310.5 304.7l.7.7-.7-.7z" />
      <path fill="#63636b" d="M311.2 304.7l.7.7-.7-.7z" />
      <path fill="#102110" d="M311.9 304.7l.7.7-.7-.7z" />
      <path fill="#cecece" d="M312.6 304.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M198.6 305.4l4.2 2-4.2-2z" />
      <path fill="#397b00" d="M210.1 305.8l.2.5-.2-.5z" />
      <path fill="#294200" d="M210.6 305.4l.7.7-.7-.7z" />
      <path fill="#214210" d="M214.1 305.4l.7.7-.7-.7z" />
      <path fill="#cecece" d="M214.8 305.4l.7.7-.7-.7z" />
      <path fill="#314231" d="M219.7 305.4l.7.7-.7-.7z" />
      <path fill="#397b00" d="M228.2 305.4l.7.7-.7-.7z" />
      <path fill="#295200" d="M228.9 305.4l.7.7-.7-.7z" />
      <path fill="#294200" d="M229.6 305.4l.7.7-.7-.7z" />
      <path fill="#422100" d="M230.3 305.4l.7.7-.7-.7z" />
      <path fill="#520808" d="M231 305.4l.7.7-.7-.7z" />
      <path fill="#631808" d="M231.7 305.4l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M232.4 305.4l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M233.1 305.4l.7.7-.7-.7m41.5 0l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M275.3 305.4l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M276 305.4l.7.7-.7-.7z" />
      <path fill="#631808" d="M276.7 305.4l.7.7-.7-.7z" />
      <path fill="#422100" d="M277.4 305.4l.7.7-.7-.7z" />
      <path fill="#4a4208" d="M278.1 305.4l.7.7-.7-.7z" />
      <path fill="#184a00" d="M278.8 305.4l.7.7-.7-.7z" />
      <path fill="#296300" d="M280.2 305.4l.7.7-.7-.7z" />
      <path fill="#297b00" d="M282.3 305.4l.7.7-.7-.7z" />
      <path fill="#296300" d="M283 305.4l.7.7-.7-.7m1.4 0l3.6.7-3.6-.7z" />
      <path fill="#297b00" d="M287.3 305.4l.7.7-.7-.7z" />
      <path fill="#185200" d="M296.4 305.4l.7.7-.7-.7z" />
      <path fill="#082108" d="M297.1 305.4l.7.7-.7-.7z" />
      <path fill="#103900" d="M297.8 305.4l.7.7-.7-.7z" />
      <path fill="#297b00" d="M298.5 305.4l.7.7-.7-.7z" />
      <path fill="#185200" d="M302 305.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M304.1 305.4l.7.7-.7-.7z" />
      <path fill="#6b735a" d="M304.9 305.4l.7.7-.8-.7z" />
      <path fill="#184a00" d="M305.6 305.4l.7.7-.7-.7z" />
      <path fill="#297b00" d="M306.3 305.4l.7.7-.7-.7z" />
      <path fill="#314231" d="M307 305.4l.7.7-.7-.7z" />
      <path fill="#efefef" d="M311.9 305.4l.7.7-.7-.7z" />
      <path fill="#dedede" d="M312.6 305.4l.7.7-.7-.7z" />
      <path fill="#292100" d="M198 306l.6.7-.7-.6z" />
      <path fill="#397b00" d="M202.8 306v1.4h1.4v-1.3H203m5.1.4l.2.5-.2-.5z" />
      <path fill="#294200" d="M209 306.3l.4.2-.5-.2z" />
      <path fill="#397b00" d="M212.7 306l.7.7-.7-.6z" />
      <path fill="#314231" d="M213.4 306l.7.7-.7-.6z" />
      <path fill="#dedede" d="M214.1 306l.7.7-.7-.6z" />
      <path fill="#425242" d="M219 306l.7.7-.7-.6z" />
      <path fill="#397b00" d="M222.3 306.3l.5.2-.5-.2z" />
      <path fill="#294200" d="M223.7 306.3l.5.2-.5-.2z" />
      <path fill="#292100" d="M224.7 306l.7.7-.8-.6z" />
      <path fill="#181000" d="M225.4 306l.7.7-.7-.6z" />
      <path fill="#310000" d="M226 306l.8.7-.7-.6z" />
      <path fill="#631808" d="M226.8 306l.7.7-.7-.6z" />
      <path fill="#941808" d="M227.5 306l.7.7-.7-.6z" />
      <path fill="#ad1810" d="M228.2 306l.7.7-.7-.6z" />
      <path fill="#ce2110" d="M228.9 306l.7.7-.7-.6z" />
      <path fill="#de3110" d="M244.3 306l.7.7-.7-.6z" />
      <path fill="#e75a10" d="M245 306l.8.7-.7-.6z" />
      <path fill="#de3110" d="M245.8 306l.7.7-.7-.6z" />
      <path fill="#e75a10" d="M248.6 306l.7.7-.7-.6z" />
      <path fill="#de3110" d="M249.3 306l.7.7-.7-.6z" />
      <path fill="#e75a10" d="M254.7 306.3l.4.2-.4-.2z" />
      <path fill="#de3110" d="M255.6 306l.7.7-.7-.6z" />
      <path fill="#e75a10" d="M259.6 306.3l.5.2-.5-.2z" />
      <path fill="#de3110" d="M260.5 306l.7.7-.7-.6z" />
      <path fill="#ad1810" d="M279.5 306l.7.7-.7-.6z" />
      <path fill="#941808" d="M280.2 306l.7.7-.7-.6z" />
      <path fill="#631808" d="M281 306l.6.7-.7-.6z" />
      <path fill="#5a2908" d="M281.6 306l.7.7-.7-.6z" />
      <path fill="#293100" d="M282.3 306l.7.7-.7-.6z" />
      <path fill="#185200" d="M283 306l.7.7-.7-.6z" />
      <path fill="#297b00" d="M283.8 306l.6.7-.6-.6z" />
      <path fill="#184a00" d="M288 306v.7h2l-2-.6z" />
      <path fill="#185200" d="M290 306l1.5 1.4-1.4-1.3z" />
      <path fill="#297b00" d="M290.8 306l.7.7-.7-.6z" />
      <path fill="#185200" d="M297.8 306l.7.7-.7-.6z" />
      <path fill="#001000" d="M298.5 306l.7.7-.7-.6z" />
      <path fill="#293129" d="M299.2 306l.7.7-.7-.6z" />
      <path fill="#214210" d="M300 306l.6.7-.7-.6z" />
      <path fill="#296300" d="M300.6 306l.7.7-.7-.6m2.1 0l1.4 1.3-1.4-1.3z" />
      <path fill="#63636b" d="M303.4 306l.8.7-.8-.6z" />
      <path fill="#dedede" d="M305.6 306l.7.7-.7-.6z" />
      <path fill="#63636b" d="M306.3 306l.7.7-.7-.6z" />
      <path fill="#214210" d="M307 306l.7.7-.7-.6z" />
      <path fill="#63636b" d="M307.7 306l.7.7-.7-.6z" />
      <path fill="#cecece" d="M197.2 306.7l.7.7-.7-.7z" />
      <path fill="#295200" d="M204.3 306.7l.6.7-.7-.7z" />
      <path fill="#294200" d="M205 306.7l.7.7-.7-.7z" />
      <path fill="#295200" d="M205.7 306.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M206.8 307l.5.2-.5-.2z" />
      <path fill="#397b00" d="M211.3 306.7l.7.7-.7-.7z" />
      <path fill="#214210" d="M212 306.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M212.7 306.7l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M218.3 306.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M219.5 307l.5.2-.5-.2z" />
      <path fill="#294200" d="M218.3 308v.7l4.2-1.3-4.2.7z" />
      <path fill="#293100" d="M222.5 306.7l.7.7-.7-.7z" />
      <path fill="#5a2908" d="M223.3 306.7l.6.7-.7-.7z" />
      <path fill="#7b1008" d="M224 306.7l.6.7-.7-.7z" />
      <path fill="#b51010" d="M224.7 306.7l.7.7-.8-.7z" />
      <path
        fill="#de3110"
        d="M233.8 306.7l.7.7-.7-.7zm2.8 0l1.4 1.4-1.4-1.4z"
      />
      <path fill="#e75a10" d="M243.7 306.7l.7.7-.8-.7zm2.8 0l.7.7-.7-.7z" />
      <path fill="#f7b508" d="M249.3 306.7l.7.7-.7-.7z" />
      <path fill="#de3110" d="M257 306.7l1.4 1.4-1.4-1.4z" />
      <path fill="#ef9408" d="M258.4 306.7l1.4 1.4-1.4-1.4z" />
      <path fill="#e75a10" d="M261.2 306.7l1.4 1.4-1.4-1.4z" />
      <path fill="#de3110" d="M262 306.7l.6.7-.7-.7z" />
      <path fill="#e75a10" d="M264.8 306.7l.6.7-.6-.7z" />
      <path fill="#ef9408" d="M266.2 306.7l-.7 4.7.7-4.7z" />
      <path fill="#e75a10" d="M266.9 306.7l.7.7-.7-.7z" />
      <path fill="#de3110" d="M268.3 306.7l.7.7-.7-.7z" />
      <path fill="#ef9408" d="M269 306.7l.7.7-.7-.7z" />
      <path fill="#ef7b08" d="M269.7 306.7l.7.7-.7-.7z" />
      <path fill="#e75a10" d="M271 306.7l.8.7-.7-.7z" />
      <path fill="#de3110" d="M273.9 306.7l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M283 306.7l.7.7-.7-.7z" />
      <path fill="#941808" d="M283.8 306.7l.6.7-.6-.7z" />
      <path fill="#4a1000" d="M284.4 306.7l.8.7-.8-.7z" />
      <path fill="#293100" d="M285.1 306.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M286.6 306.7l.7.7-.7-.7z" />
      <path fill="#319400" d="M287.3 306.7v.7l7 1.4-7-2z" />
      <path fill="#297b00" d="M290 306.7l.8.7-.7-.7z" />
      <path fill="#184a00" d="M291.5 306.7l.7.7-.7-.7z" />
      <path fill="#103900" d="M292.2 306.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M293.1 307.2l.3.4-.3-.4m6.1-.5l.7.7-.7-.7z" />
      <path fill="#425242" d="M300 306.7l.6.7-.7-.7z" />
      <path fill="#8c8c8c" d="M300.6 306.7l.7.7-.7-.7z" />
      <path fill="#63636b" d="M301.3 306.7l.7.7-.7-.7z" />
      <path fill="#184a00" d="M302 306.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M302.7 306.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M304.1 306.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M307 306.7l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M307.7 306.7l.7.7-.7-.7z" />
      <path fill="#cecece" d="M308.4 306.7l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M201.4 307.4l.7.7-.7-.7z" />
      <path fill="#397b00" d="M202.1 307.4l.7.7-.7-.7m6.4 0l.7.7-.7-.7z" />
      <path fill="#295200" d="M209.2 307.4l.7.7-.7-.7z" />
      <path fill="#396b10" d="M209.9 307.4l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M210.6 307.4l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M211.3 307.4l.7.7-.7-.7m6.3 0l.7.7-.7-.7z" />
      <path fill="#295200" d="M218.3 307.4l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M221.1 307.4l.7.7-.7-.7z" />
      <path fill="#941808" d="M221.8 307.4l.7.7-.7-.7z" />
      <path fill="#ef9408" d="M230.3 307.4l.7.7-.7-.7z" />
      <path
        fill="#f7b508"
        d="M236.6 307.4l.7.7-.7-.7m2.1 0l.7.7-.7-.7m5.4.2l.5.3-.5-.3z"
      />
      <path fill="#e75a10" d="M245 307.4l.8.7-.7-.7z" />
      <path fill="#f7b508" d="M246.2 307.6l.5.2-.5-.2z" />
      <path fill="#ef9408" d="M257 307.4l.7.7-.7-.7z" />
      <path fill="#f7b508" d="M261 307.6l.5.2-.5-.2z" />
      <path fill="#de3110" d="M264 307.4l.8.7-.8-.7z" />
      <path fill="#de2110" d="M268.5 307.9l.2.4-.2-.5z" />
      <path fill="#ef9408" d="M275.3 307.4l1.4 1.4-1.4-1.4z" />
      <path fill="#ef7b08" d="M277.4 307.4l.7.7-.7-.7z" />
      <path fill="#de3110" d="M280.2 307.4l.7.7-.7-.7z" />
      <path fill="#b51010" d="M285.9 307.4l.7.7-.7-.7z" />
      <path fill="#631808" d="M286.6 307.4l.7.7-.7-.7z" />
      <path fill="#293100" d="M287.3 307.4l.7.7-.7-.7z" />
      <path fill="#296300" d="M288 307.4l.7.7-.7-.7z" />
      <path fill="#103900" d="M293.6 307.4l.7.7-.7-.7z" />
      <path fill="#001000" d="M294.3 307.4l.7.7-.7-.7z" />
      <path fill="#103900" d="M295 307.4l.7.7-.7-.7z" />
      <path fill="#185200" d="M295.7 307.4l.7.7-.7-.7z" />
      <path fill="#297b00" d="M296.4 307.4l.7.7-.7-.7m3.5 0l.7.7-.7-.7z" />
      <path fill="#184a00" d="M300.6 307.4l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M301.3 307.4l.7.7-.7-.7z" />
      <path fill="#cecece" d="M302 307.4l.7.7-.7-.7z" />
      <path fill="#63636b" d="M302.7 307.4l.7.7-.7-.7z" />
      <path fill="#184a00" d="M304 307.6l.4.2-.5-.2z" />
      <path fill="#bdbdbd" d="M304.9 307.4l.7.7-.8-.7z" />
      <path fill="#9c9494" d="M201.4 308l.7.7-.7-.6z" />
      <path fill="#397b00" d="M205.7 308l.7.7-.7-.6z" />
      <path fill="#396b10" d="M206.4 308l.7.7-.7-.6z" />
      <path fill="#526b42" d="M207 308l.8.7-.7-.6z" />
      <path fill="#8c8c8c" d="M207.8 308l.7.7-.7-.6z" />
      <path fill="#ada5a5" d="M208.5 308l.7.7-.7-.6z" />
      <path fill="#dedede" d="M209.2 308l.7.7-.7-.6z" />
      <path fill="#efefef" d="M217 308l.6.7-.7-.6z" />
      <path fill="#213918" d="M217.6 308l.7.7-.7-.6z" />
      <path fill="#4a1000" d="M219 308l.7.7-.7-.6z" />
      <path fill="#941808" d="M219.7 308l.7.7-.7-.6z" />
      <path fill="#de3110" d="M224.4 308.3l.5.2-.5-.2z" />
      <path fill="#ef7b08" d="M229.6 308l.7.7-.7-.6zm3.7.5l.3.5-.3-.5z" />
      <path fill="#de2110" d="M235.2 308l.7.7-.7-.6z" />
      <path fill="#de3110" d="M236 308l.6.7-.7-.6z" />
      <path fill="#e75a10" d="M237.3 308l.7.7-.7-.6z" />
      <path fill="#de3110" d="M245.8 308l.7.7-.7-.6z" />
      <path
        fill="#ef7b08"
        d="M246.5 308l.7.7-.7-.6m1.4 0l.7.6-.7-.6zm2 0l.8.6-.7-.6z"
      />
      <path fill="#de2110" d="M255.6 308v2h.7l-.7-2z" />
      <path fill="#ef9408" d="M256.3 308l.7.7-.7-.6z" />
      <path fill="#de3110" d="M259.1 308l.7.7-.7-.6z" />
      <path fill="#de2110" d="M259.8 308l.7 2-.7-2z" />
      <path fill="#e75a10" d="M264 308l.8.7-.8-.6z" />
      <path fill="#ef9408" d="M264.8 308l.6.7-.6-.6z" />
      <path fill="#ef7b08" d="M274.6 308l.7.7-.7-.6z" />
      <path fill="#ffce08" d="M275.3 308l.7.7-.7-.6z" />
      <path fill="#f7b508" d="M276.7 308l.7.7-.7-.6z" />
      <path fill="#de3110" d="M278.1 308l.7.7-.7-.6z" />
      <path fill="#ef7b08" d="M279.5 308l.7.7-.7-.6z" />
      <path fill="#ffce08" d="M280.2 308l-.7 2 .7-2z" />
      <path fill="#ef7b08" d="M281.2 308.5l.2.5-.2-.5z" />
      <path fill="#e75a10" d="M283 308l.7.7-.7-.6z" />
      <path fill="#de3110" d="M283.8 308l.6.7-.6-.6z" />
      <path fill="#941808" d="M288 308l.7.7-.7-.6z" />
      <path fill="#5a2908" d="M288.7 308l.7.7-.7-.6z" />
      <path fill="#184a00" d="M289.4 308l.7.7-.7-.6z" />
      <path fill="#297b00" d="M290 308l.8.7-.7-.6m4.4.4l.3.5-.3-.5z" />
      <path fill="#184a00" d="M295 308l.7.7-.7-.6z" />
      <path fill="#424242" d="M295.7 308l.7.7-.7-.6z" />
      <path fill="#8c8c8c" d="M296.4 308l.7.7-.7-.6z" />
      <path fill="#5a6b52" d="M297.1 308l.7.7-.7-.6z" />
      <path fill="#214210" d="M297.8 308l.7.7-.7-.6z" />
      <path fill="#296300" d="M298.5 308l.7.7-.7-.6z" />
      <path fill="#297b00" d="M301.3 308l1.4 1.4-1.4-1.3z" />
      <path fill="#314231" d="M302 308l.7.7-.7-.6z" />
      <path fill="#dedede" d="M303.4 308l.8.7-.8-.6z" />
      <path fill="#63636b" d="M304.1 308l.7.7-.7-.6z" />
      <path fill="#101810" d="M304.9 308l.7.7-.8-.6z" />
      <path fill="#8c8c8c" d="M201.4 308.7l.7.7-.7-.7z" />
      <path fill="#294200" d="M204.3 308.7l.6.7-.7-.7z" />
      <path fill="#6b735a" d="M205 308.7l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M205.7 308.7l.7.7-.7-.7z" />
      <path fill="#52525a" d="M217 308.7l.6.7-.7-.7z" />
      <path fill="#311000" d="M217.6 308.7l.7.7-.7-.7z" />
      <path fill="#b51010" d="M218.3 308.7l.7.7-.7-.7z" />
      <path fill="#ef7b08" d="M221.8 308.7l.7.7-.7-.7z" />
      <path fill="#ef9408" d="M222.5 308.7l.7.7-.7-.7z" />
      <path fill="#f7b508" d="M223.3 308.7l.6.7-.7-.7z" />
      <path fill="#ffce08" d="M224 308.7l.6.7-.7-.7z" />
      <path fill="#ef9408" d="M224.7 308.7l.7.7-.8-.7z" />
      <path fill="#de3110" d="M231 308.7l.7.7-.7-.7zm6.3 0l.7.7-.7-.7z" />
      <path fill="#ef9408" d="M249 309l.5.2-.5-.2z" />
      <path fill="#ef7b08" d="M256.3 308.7l.7.7-.7-.7m7.7 0l.8.7-.8-.7z" />
      <path fill="#de3110" d="M268.3 308.7l.7.7-.7-.7z" />
      <path fill="#ef9408" d="M269.7 308.7l.7.7-.7-.7z" />
      <path fill="#de2110" d="M276 308.7v2.7l2.8-.6-2.8-2z" />
      <path fill="#e75a10" d="M278.1 308.7l.7.7-.7-.7z" />
      <path fill="#f7b508" d="M279.5 308.7l.7.7-.7-.7m4 .3l.5.2-.5-.2z" />
      <path fill="#de3110" d="M285.1 308.7l.7.7-.7-.7z" />
      <path fill="#e75a10" d="M285.9 308.7l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M289.4 308.7l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M290 308.7l.8.7-.7-.7z" />
      <path fill="#184a00" d="M291.3 309l.4.2-.4-.2z" />
      <path fill="#185200" d="M292.2 308.7l.7.7-.7-.7z" />
      <path fill="#296300" d="M293.4 309l.4.2-.4-.2z" />
      <path fill="#319400" d="M295 308.7l.7.7-.7-.7z" />
      <path fill="#297b00" d="M295.7 308.7l.7.7-.7-.7z" />
      <path fill="#185200" d="M296.4 308.7l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M297.1 308.7l.7.7-.7-.7z" />
      <path fill="#efefef" d="M297.8 308.7l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M298.5 308.7l1.4 2-1.4-2z" />
      <path fill="#63636b" d="M299.2 308.7l.7.7-.7-.7z" />
      <path fill="#214210" d="M300 308.7l.6.7-.7-.7z" />
      <path fill="#297b00" d="M300.6 308.7l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M302.7 308.7l.7.7-.7-.7z" />
      <path fill="#397b00" d="M202.8 309.4l.7.7-.7-.7z" />
      <path fill="#425242" d="M203.6 309.4l.7.7-.8-.7z" />
      <path fill="#dedede" d="M204.3 309.4l.6.7-.7-.7m11.3 0l.7.7-.7-.7z" />
      <path fill="#524242" d="M216.2 309.4l.7.7-.7-.7z" />
      <path fill="#941808" d="M217 309.4l.6.7-.7-.7z" />
      <path fill="#de3110" d="M219.5 309.6l.5.3-.5-.3z" />
      <path fill="#f7b508" d="M221.8 309.4l.7.7-.7-.7z" />
      <path fill="#ef7b08" d="M223.3 309.4l.6.7-.7-.7z" />
      <path fill="#de2110" d="M227.5 309.4l.7.7-.7-.7z" />
      <path fill="#ef7b08" d="M228.2 309.4l.7.7-.7-.7z" />
      <path fill="#e75a10" d="M231.2 309.9l.3.4-.3-.4z" />
      <path fill="#ef7b08" d="M246.5 309.4l.7.7-.7-.7z" />
      <path fill="#de3110" d="M247.2 309.4l.7.7-.7-.7z" />
      <path fill="#ffce08" d="M248.1 309.9l.2.4-.2-.4m2.1 0l.2.4-.2-.4z" />
      <path fill="#ef9408" d="M256.8 309.6l.4.3-.4-.3z" />
      <path fill="#de3110" d="M259.1 309.4l.7.7-.7-.7z" />
      <path fill="#ef9408" d="M263.4 309.4l.7.7-.8-.7zm8.4 0l-.7 2.7.7-2.7z" />
      <path fill="#de3110" d="M273.9 309.4l.7.7-.7-.7z" />
      <path fill="#ffce08" d="M274.8 309.9l.3.4-.3-.4z" />
      <path fill="#ef7b08" d="M275.5 309.9l.3.4-.3-.4z" />
      <path fill="#e75a10" d="M278.8 309.4l.7.7-.7-.7z" />
      <path fill="#f7b508" d="M280.2 309.4l.7.7-.7-.7z" />
      <path fill="#ef9408" d="M281.2 309.9l.2.4-.2-.4z" />
      <path fill="#de3110" d="M282.3 309.4l.7.7-.7-.7z" />
      <path fill="#ef7b08" d="M285.1 309.4l.7.7-.7-.7z" />
      <path fill="#ffce08" d="M285.9 309.4l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M290.8 309.4l.7.7-.7-.7z" />
      <path fill="#210800" d="M291.5 309.4l.7.7-.7-.7z" />
      <path fill="#292921" d="M292.2 309.4l.7.7-.7-.7z" />
      <path fill="#313931" d="M292.9 309.4l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M293.6 309.4l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M294.3 309.4l1.4 1.4-1.4-1.4z" />
      <path fill="#8c8c8c" d="M295 309.4l.7.7-.7-.7z" />
      <path fill="#5a6b52" d="M295.7 309.4l.7.7-.7-.7z" />
      <path fill="#214210" d="M296.4 309.4l.7.7-.7-.7z" />
      <path fill="#184a00" d="M297.1 309.4l.7.7-.7-.7z" />
      <path fill="#293129" d="M297.8 309.4l.7.7-.7-.7z" />
      <path fill="#efefef" d="M300 309.4l.6.7-.7-.7z" />
      <path fill="#294221" d="M300.6 309.4l.7.7-.7-.7z" />
      <path fill="#296300" d="M302 309.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M302.7 309.4l.7.7-.7-.7z" />
      <path fill="#295200" d="M202.1 310l.7.7-.7-.6z" />
      <path fill="#63636b" d="M202.8 310l.7.7-.7-.6z" />
      <path fill="#9c9494" d="M214.8 310l.7.7-.7-.6z" />
      <path fill="#631808" d="M215.5 310l.7.7-.7-.6z" />
      <path fill="#ce2110" d="M216.2 310l.7.7-.7-.6z" />
      <path fill="#e75a10" d="M217.6 310l.7.7-.7-.6z" />
      <path fill="#ef9408" d="M218.3 310l.7.7-.7-.6zm2.1 0l.7.7-.7-.6z" />
      <path fill="#ef7b08" d="M221.8 310l.7.7-.7-.6z" />
      <path fill="#de3110" d="M223.3 310l.6.7-.7-.6z" />
      <path fill="#ef7b08" d="M226 310l.8.7-.7-.6z" />
      <path fill="#de3110" d="M229.6 310l.7.7-.7-.6z" />
      <path fill="#e75a10" d="M235.2 310l.7.7-.7-.6z" />
      <path fill="#de2110" d="M236 310l.6.7-.7-.6z" />
      <path fill="#f7b508" d="M244.1 310.3l.5.2-.5-.2m2.1 0l.5.2-.5-.2z" />
      <path fill="#e75a10" d="M247.2 310l-.7 1.4.7-1.3z" />
      <path fill="#ef9408" d="M249 310.3l.5.2-.5-.2z" />
      <path fill="#e75a10" d="M250.7 310l.7.7-.7-.6z" />
      <path fill="#ef7b08" d="M255.6 310l.7.7-.7-.6z" />
      <path fill="#e75a10" d="M257 310l.7.7-.7-.6z" />
      <path fill="#de3110" d="M257.7 310l.7.7-.7-.6z" />
      <path fill="#f7b508" d="M261 310.3l.5.2-.5-.2z" />
      <path fill="#ef7b08" d="M263.4 310l.7.7-.8-.6z" />
      <path fill="#f7b508" d="M264.8 310l.6.7-.6-.6z" />
      <path fill="#ef9408" d="M270.4 310l.7.7-.7-.6zm9.1 0l.7.7-.7-.6z" />
      <path fill="#ef7b08" d="M280.2 310l.7.7-.7-.6z" />
      <path fill="#e75a10" d="M282.3 310l.7.7-.7-.6m2.1 0l.8.6-.8-.6z" />
      <path fill="#f7b508" d="M285.1 310l.7.7-.7-.6z" />
      <path fill="#ef9408" d="M285.9 310l.7.7-.7-.6z" />
      <path fill="#e75a10" d="M288 310l.7.7-.7-.6z" />
      <path fill="#ffce08" d="M289 310.5l.1.5-.2-.5z" />
      <path fill="#7b1008" d="M292.2 310l.7.7-.7-.6z" />
      <path fill="#185200" d="M292.9 310l1.4 1.4v-1.3h-1.4z" />
      <path fill="#314231" d="M294.3 310l.7.7-.7-.6z" />
      <path fill="#dedede" d="M297.1 310l.7.7-.7-.6z" />
      <path fill="#9c9494" d="M297.8 310l.7.7-.7-.6z" />
      <path fill="#63636b" d="M298.5 310l.7.7-.7-.6z" />
      <path fill="#6b735a" d="M300.6 310l.7.7-.7-.6z" />
      <path fill="#184a00" d="M302 310l.7.7-.7-.6z" />
      <path fill="#52525a" d="M202.1 310.8l.7.6-.7-.6z" />
      <path fill="#cecece" d="M214.1 310.8l.7.6-.7-.6z" />
      <path fill="#631818" d="M214.8 310.8l.7.6-.7-.6z" />
      <path fill="#de3110" d="M217 310.8l.6.6-.7-.6z" />
      <path fill="#ffce08" d="M217.6 310.8l.7.6-.7-.6z" />
      <path fill="#ef7b08" d="M219 310.8l.7.6-.7-.6z" />
      <path fill="#ef9408" d="M219.7 310.8l.7.6-.7-.6z" />
      <path fill="#e75a10" d="M221.8 310.8l.7.6-.7-.6m4.3 0l.7.6-.7-.6z" />
      <path fill="#f7b508" d="M227.5 310.8l.7.6-.7-.6z" />
      <path fill="#e75a10" d="M228.2 310.8l.7.6-.7-.6z" />
      <path fill="#f7b508" d="M230.3 310.8l.7.6-.7-.6z" />
      <path fill="#ef9408" d="M231 310.8l-.7 1.3.7-1.4zm9.8 0l.7.6-.7-.6z" />
      <path fill="#e75a10" d="M243.7 310.8l.7.6-.8-.6z" />
      <path fill="#ef9408" d="M247.2 310.8l.7.6-.7-.6z" />
      <path fill="#f7b508" d="M247.9 310.8l.7.6-.7-.6m2 0l.8.6-.7-.6z" />
      <path fill="#ef9408" d="M250.7 310.8l.7.6-.7-.6z" />
      <path fill="#f7b508" d="M256.3 310.8l.7.6-.7-.6z" />
      <path fill="#ef9408" d="M258.4 310.8l.7.6-.7-.6z" />
      <path fill="#e75a10" d="M263.4 310.8l.7.6-.8-.6z" />
      <path fill="#ef7b08" d="M264.8 310.8l.6.6-.6-.6z" />
      <path fill="#f7b508" d="M274.6 310.8l.7.6-.7-.6z" />
      <path fill="#ef9408" d="M275.3 310.8l.7.6-.7-.6z" />
      <path fill="#ef7b08" d="M276.7 310.8l1.4 1.3-1.4-1.4z" />
      <path fill="#e75a10" d="M278.1 310.8l.7.6-.7-.6z" />
      <path fill="#ffce08" d="M278.8 310.8l.7.6-.7-.6z" />
      <path fill="#f7b508" d="M283 310.8l.7.6-.7-.6z" />
      <path fill="#ef7b08" d="M284.4 310.8l-.6 1.3.6-1.4zm1.5 0l.7.6-.7-.6z" />
      <path fill="#de3110" d="M287.3 310.8l.7.6-.7-.6z" />
      <path fill="#941808" d="M292.9 310.8l.7.6-.7-.6z" />
      <path fill="#319400" d="M294.3 310.8l.7.6-.7-.6z" />
      <path fill="#296300" d="M295.2 311.2l.3.5-.3-.5z" />
      <path fill="#314231" d="M295.7 310.8l.7.6-.7-.6z" />
      <path fill="#cecece" d="M296.4 310.8l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M300.6 310.8l.7.6-.7-.6z" />
      <path fill="#4a6342" d="M302 310.8l.7.6-.7-.6z" />
      <path fill="#dedede" d="M213.4 311.4l.7.7-.7-.7z" />
      <path fill="#631818" d="M214.1 311.4l.7.7-.7-.7z" />
      <path fill="#de2110" d="M219 311.4l.7.7-.7-.7z" />
      <path fill="#e75a10" d="M219.7 311.4l.7.7-.7-.7z" />
      <path fill="#de3110" d="M221.1 311.4l.7.7-.7-.7z" />
      <path fill="#de2110" d="M222 311.9l.3.4-.2-.4z" />
      <path fill="#ef9408" d="M223.5 311.9l.2.4-.2-.4z" />
      <path fill="#e75a10" d="M224 311.4l1.3 1.4-1.4-1.4z" />
      <path fill="#de3110" d="M226 311.4l.8.7-.7-.7z" />
      <path fill="#e75a10" d="M227.5 311.4l.7.7-.7-.7zm5.6 0l.7.7-.7-.7z" />
      <path fill="#de3110" d="M238 311.4l.7.7-.7-.7zm6.4 0l.7.7-.7-.7z" />
      <path fill="#e75a10" d="M245 311.4l.8.7-.7-.7z" />
      <path
        fill="#de3110"
        d="M245.8 311.4l.7.7-.7-.7m1.8.2l.5.3-.5-.3m2.8 0l.5.3-.5-.3zm8.7-.2l.7.7-.7-.7z"
      />
      <path fill="#e75a10" d="M259.8 311.4l.7.7-.7-.7z" />
      <path fill="#de3110" d="M260.5 311.4l.7.7-.7-.7z" />
      <path fill="#e75a10" d="M262.6 311.4l.7.7-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#de3110" d="M264.8 311.4v.7h2l-2-.7m3.5 0l.7.7-.7-.7z" />
      <path fill="#ef9408" d="M269 311.4l.7.7-.7-.7z" />
      <path fill="#ef7b08" d="M274.6 311.4l.7.7-.7-.7z" />
      <path fill="#ef9408" d="M279.5 311.4l.7.7-.7-.7z" />
      <path fill="#ffce08" d="M281.2 311.9l.2.4-.2-.4z" />
      <path fill="#f7b508" d="M282.3 311.4l.7.7-.7-.7m2.1 0l.8.7-.8-.7z" />
      <path fill="#e75a10" d="M285.9 311.4l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M293.6 311.4l.7.7-.7-.7z" />
      <path fill="#103900" d="M294.3 311.4l.7.7-.7-.7z" />
      <path fill="#297b00" d="M295.7 311.4l.7.7-.7-.7z" />
      <path fill="#185200" d="M296.4 311.4l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M297.1 311.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M300.9 311.9l.2.4-.2-.4z" />
      <path fill="#296300" d="M301.3 311.4l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M302 311.4l.7.7-.7-.7m-88.6.7l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M214.1 312l.7.8-.7-.7z" />
      <path fill="#e75a10" d="M217.6 312l.7.8-.7-.7z" />
      <path fill="#ffce08" d="M218.3 312l.7.8-.7-.7z" />
      <path fill="#ef7b08" d="M221.1 312l.7.8-.7-.7z" />
      <path fill="#f7b508" d="M222.5 312l.7.8-.7-.7z" />
      <path fill="#de2110" d="M224 312l.6.8-.7-.7z" />
      <path fill="#ef7b08" d="M225.4 312l.7.8-.7-.7z" />
      <path fill="#f7b508" d="M226.8 312l.7.8-.7-.7z" />
      <path fill="#ef7b08" d="M227.5 312l.7.8-.7-.7z" />
      <path fill="#e75a10" d="M231 312l.7.8-.7-.7z" />
      <path fill="#ef7b08" d="M231.7 312l.7.8-.7-.7z" />
      <path fill="#e75a10" d="M232.4 312l.7.8-.7-.7m42.9 0l.7.7-.7-.7z" />
      <path fill="#ef9408" d="M276 312l.7.8-.7-.7z" />
      <path fill="#e75a10" d="M276.7 312l.7.8-.7-.7z" />
      <path fill="#de3110" d="M277.4 312l.7.8-.7-.7z" />
      <path fill="#e75a10" d="M278.8 312l.7.8-.7-.7m1.4 0l.7.7-.7-.7z" />
      <path fill="#de3110" d="M281.6 312l.7.8-.7-.7z" />
      <path fill="#ffce08" d="M282.6 312.5l.2.5-.2-.5z" />
      <path fill="#e75a10" d="M283.5 312.3l.5.2-.5-.2z" />
      <path fill="#de2110" d="M285.9 312l.7.8-.7-.7z" />
      <path fill="#ef7b08" d="M286.6 312l.7.8-.7-.7z" />
      <path fill="#e75a10" d="M288 312l.7.8-.7-.7zm1.6.5l.2.5-.2-.5z" />
      <path fill="#736b6b" d="M294.3 312l.7.8-.7-.7z" />
      <path fill="#cecece" d="M295 312l.7.8-.7-.7z" />
      <path fill="#8c8c8c" d="M295.7 312l.7.8-.7-.7z" />
      <path fill="#294221" d="M296.4 312l.7.8-.7-.7z" />
      <path fill="#082108" d="M297.1 312l.7.8-.7-.7z" />
      <path fill="#8c8c8c" d="M297.8 312l.7.8-.7-.7z" />
      <path fill="#103900" d="M301.3 312l.7.8-.7-.7z" />
      <path fill="#dedede" d="M302 312l.7.8-.7-.7z" />
      <path fill="#6b4242" d="M213.4 312.8l.7.6-.7-.6z" />
      <path fill="#ef7b08" d="M219.7 312.8l.7.6-.7-.6z" />
      <path fill="#ef9408" d="M220.4 312.8l.7.6-.7-.6z" />
      <path fill="#ef7b08" d="M222.5 312.8l.7.6-.7-.6z" />
      <path fill="#f7b508" d="M225.4 312.8l.7.6-.7-.6z" />
      <path fill="#e75a10" d="M226.8 312.8l.7.6-.7-.6z" />
      <path fill="#de3110" d="M227.5 312.8l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M243 312.8v.6h4.2l-4.3-.6z" />
      <path fill="#7b1008" d="M247.2 312.8l.7.6-.7-.6z" />
      <path fill="#631808" d="M247.9 312.8v.6h13.3l-13.3-.6z" />
      <path fill="#ad1810" d="M261.2 312.8v.6h4.3l-4.3-.6z" />
      <path fill="#ce2110" d="M265.5 312.8l.7.6-.7-.6z" />
      <path fill="#de3110" d="M280.2 312.8l.7.6-.7-.6z" />
      <path fill="#ef7b08" d="M281 312.8l.6.6-.7-.6z" />
      <path fill="#e75a10" d="M281.6 312.8l.7.6-.7-.6z" />
      <path fill="#de3110" d="M283.5 313l.5.2-.5-.2z" />
      <path fill="#f7b508" d="M285.1 312.8l1.4 1.3-1.4-1.3z" />
      <path fill="#e75a10" d="M285.9 312.8l.7.6-.7-.6z" />
      <path fill="#ef9408" d="M288 312.8l.7.6-.7-.6z" />
      <path fill="#631818" d="M294.3 312.8l.7.6-.7-.6z" />
      <path fill="#cecece" d="M297.4 313.2l.2.5-.2-.5z" />
      <path fill="#7b7373" d="M297.8 312.8l.7.6-.7-.6z" />
      <path fill="#dedede" d="M298.5 312.8l.7.6-.7-.6m2.1 0l.7.6-.7-.6z" />
      <path fill="#52525a" d="M301.3 312.8l.7.6-.7-.6z" />
      <path fill="#dedede" d="M205 313.4l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M205.7 313.4l.7.7-.7-.7z" />
      <path fill="#6b4242" d="M206.4 313.4l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M209.2 313.4l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M209.9 313.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M210.6 313.4l.7.7-.7-.7z" />
      <path fill="#6b2908" d="M213.4 313.4l.7.7-.7-.7z" />
      <path fill="#ef9408" d="M218.3 313.4l.7.7-.7-.7z" />
      <path fill="#ffce08" d="M219.3 313.9l.2.4-.2-.4z" />
      <path fill="#f7b508" d="M221.1 313.4l.7.7-.7-.7z" />
      <path fill="#e75a10" d="M224 313.4l.6.7-.7-.7z" />
      <path fill="#de3110" d="M224.7 313.4l.7.7-.8-.7z" />
      <path fill="#ad1810" d="M234.3 313.6l.4.3-.4-.2z" />
      <path fill="#941808" d="M235.2 313.4l.7.7-.7-.7z" />
      <path fill="#631808" d="M236 313.4l.6.7-.7-.7z" />
      <path fill="#733129" d="M236.6 313.4l.7.7-.7-.7z" />
      <path fill="#734a42" d="M237.8 313.6l.5.3-.5-.2z" />
      <path fill="#845a52" d="M238.7 313.4l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M239.4 313.4v.7h2.8l-2.8-.7z" />
      <path fill="#ada5a5" d="M242.2 313.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M243 313.4v.7h2l-2-.7z" />
      <path fill="#cecece" d="M245 313.4l.8.7-.7-.7z" />
      <path fill="#63636b" d="M245.8 313.4l.7.7-.7-.7z" />
      <path fill="#295200" d="M246.5 313.4l2 2-2-2z" />
      <path fill="#428c00" d="M247.2 313.4c1.8 2.3 3.3 3.2 6.3 2.7l-6.3-2.7z" />
      <path fill="#397b00" d="M251.4 313.4l1.4 3.4h1.4l-2.8-3.4z" />
      <path fill="#63636b" d="M252 313.4l2.2 2-2.1-2z" />
      <path fill="#cecece" d="M254.9 313.4l-.7 1.4.7-1.4z" />
      <path fill="#214210" d="M255.6 313.4l.7.7-.7-.7z" />
      <path fill="#319400" d="M256.3 316.8l5.6-2.7c-2.8-1.1-6.2-.8-5.6 2.7z" />
      <path fill="#185200" d="M262 313.4l.6.7-.7-.7z" />
      <path fill="#8c8c8c" d="M262.6 313.4l.7.7-.7-.7z" />
      <path fill="#946b63" d="M269 313.4l.7.7-.7-.7z" />
      <path fill="#734a42" d="M270.1 313.6l.5.3-.5-.2z" />
      <path fill="#8c3939" d="M271 313.4l.8.7-.7-.7z" />
      <path fill="#631808" d="M271.8 313.4l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M272.5 313.4l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M273.7 313.6l.4.3-.4-.2z" />
      <path fill="#ce2110" d="M274.6 313.4l.7.7-.7-.7z" />
      <path fill="#ef9408" d="M285 313.6l.4.3-.5-.2m1.7-.3l.7.7-.7-.7z" />
      <path fill="#ef7b08" d="M287.3 313.4l.7.7-.7-.7z" />
      <path fill="#f7b508" d="M288 313.4l.7.7-.7-.7z" />
      <path fill="#de3110" d="M289.4 313.4l.7.7-.7-.7z" />
      <path fill="#631808" d="M294.3 313.4l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M297.8 313.4l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M298.5 313.4l.7.7-.7-.7zm3.5 0l.7.7-.7-.7z" />
      <path fill="#cecece" d="M302.7 313.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M204.3 314.1l.6.7-.7-.7z" />
      <path fill="#631818" d="M205 314.1l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M205.7 314.1l.7.7-.7-.7z" />
      <path
        fill="#de2110"
        d="M205 320.1c7.3-4.2 16.8 7.4 22.5-2l-.7-.7c-2.4.9-5.2 2.8-7.8 2.4-1.7-.2-19.4-11.7-14 .3z"
      />
      <path fill="#bd2110" d="M209.9 314.1l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M210.6 314.1l.7.7-.7-.7z" />
      <path fill="#631818" d="M211.3 314.1l.7.7-.7-.7z" />
      <path fill="#63636b" d="M212 314.1l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M212.7 314.1l.7.7-.7-.7z" />
      <path fill="#734a42" d="M213.4 314.1l.7.7-.7-.7z" />
      <path fill="#de3110" d="M218.3 314.1l.7.7-.7-.7z" />
      <path fill="#ef7b08" d="M219.7 314.1l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M228.2 314.1l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M228.9 314.1l.7.7-.7-.7z" />
      <path fill="#631808" d="M229.6 314.1l.7.7-.7-.7z" />
      <path fill="#733129" d="M230.3 314.1l.7.7-.7-.7z" />
      <path fill="#734a42" d="M231 314.1l.7.7-.7-.7z" />
      <path fill="#8c6363" d="M231.7 314.1l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M232.9 314.3l.4.2-.4-.2z" />
      <path fill="#bdbdbd" d="M234.3 314.3l.4.2-.4-.2z" />
      <path fill="#efefef" d="M235.2 314.1l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M246.5 314.1l2 2-2-2z" />
      <path fill="#103910" d="M254.9 314.1l.7.7-.7-.7z" />
      <path fill="#214210" d="M261.2 314.1l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M262 314.1l.6.7-.7-.7z" />
      <path fill="#bdbdbd" d="M273.7 314.3l.4.2-.4-.2z" />
      <path fill="#8c8c8c" d="M275 314.3l.5.2-.4-.2z" />
      <path fill="#8c7373" d="M276 314.1l.7.7-.7-.7z" />
      <path fill="#734a42" d="M276.7 314.1l.7.7-.7-.7z" />
      <path fill="#733939" d="M277.4 314.1l.7.7-.7-.7z" />
      <path fill="#631808" d="M278.1 314.1l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M278.8 314.1l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M279.5 314.1l.7.7-.7-.7z" />
      <path fill="#e75a10" d="M285.9 314.1l.7.7-.7-.7m2.3.5l.2.4-.2-.4z" />
      <path fill="#6b2908" d="M294.3 314.1l.7.7-.7-.7z" />
      <path fill="#cecece" d="M295 314.1l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M295.7 314.1l.7.7-.7-.7z" />
      <path fill="#733129" d="M296.4 314.1l.7.7-.7-.7z" />
      <path fill="#941808" d="M297.1 314.1l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M297.8 314.1l.7.7-.7-.7z" />
      <path
        fill="#de2110"
        d="M282.3 317.4c-1 9.4 16.6.1 21.1 2.7 2.5-5-3.2-7.4-7.6-4.7-2 1.3-3.1 3.9-5.8 4.4-2.6.4-5.4-1.4-7.7-2.4z"
      />
      <path fill="#ce2110" d="M302 314.1l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M302.7 314.1l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M303.4 314.1l.8.7-.8-.7m-99.8.7l.6.6-.7-.6z" />
      <path fill="#631808" d="M204.3 314.8l.6.6-.7-.6z" />
      <path fill="#941808" d="M212.7 314.8l.7.6-.7-.6z" />
      <path fill="#310000" d="M213.4 314.8l.7.6-.7-.6z" />
      <path fill="#ce2110" d="M214.1 314.8l.7.6-.7-.6z" />
      <path fill="#ef9408" d="M219 314.8l.7.6-.7-.6z" />
      <path fill="#e75a10" d="M219.7 314.8l.7.6-.7-.6z" />
      <path fill="#ce2110" d="M224 314.8l.6.6-.7-.6z" />
      <path fill="#ad1810" d="M224.7 314.8l.7.6-.8-.6z" />
      <path fill="#7b1008" d="M225.4 314.8l.7.6-.7-.6z" />
      <path fill="#6b2908" d="M226 314.8l.8.6-.7-.6z" />
      <path fill="#734a42" d="M226.8 314.8l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M227.5 314.8l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M228.2 314.8l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M228.9 314.8l.7.6-.7-.6z" />
      <path fill="#293129" d="M254.2 314.8l.7.6-.7-.6z" />
      <path fill="#297b00" d="M254.9 314.8l1.4 2-1.4-2m5 0l-.8 1.3.7-1.3z" />
      <path fill="#103910" d="M260.5 314.8l.7.6-.7-.6z" />
      <path fill="#cecece" d="M261.2 314.8l-.7 1.3.7-1.3z" />
      <path fill="#bdbdbd" d="M278.8 314.8l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M279.5 314.8l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M280.2 314.8l.7.6-.7-.6z" />
      <path fill="#734a42" d="M281 314.8l.6.6-.7-.6z" />
      <path fill="#733129" d="M281.6 314.8l.7.6-.7-.6z" />
      <path fill="#7b1008" d="M282.3 314.8l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M283 314.8l.7.6-.7-.6z" />
      <path fill="#ce2110" d="M283.8 314.8l.6.6-.6-.6z" />
      <path fill="#f7b508" d="M288.7 314.8l.7.6-.7-.6z" />
      <path fill="#420000" d="M294.3 314.8l.7.6-.7-.6z" />
      <path fill="#941808" d="M295 314.8l.7.6-.7-.6m8.4 0l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M304.1 314.8l.7.6-.7-.6z" />
      <path fill="#efefef" d="M202.8 315.4l.7.7-.7-.7z" />
      <path fill="#842118" d="M203.6 315.4l.7.7-.8-.7z" />
      <path fill="#bd2110" d="M213.4 315.4l.7.7-.7-.7z" />
      <path fill="#631808" d="M214.1 315.4l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M221.8 315.4l.7.7-.7-.7z" />
      <path fill="#520808" d="M224.7 315.4l.7.7-.8-.7z" />
      <path fill="#bdbdbd" d="M225.4 315.4l.7.7-.7-.7z" />
      <path fill="#214210" d="M248.6 315.4l.7.7-.7-.7z" />
      <path fill="#103900" d="M254.2 315.4l.7.7-.7-.7z" />
      <path fill="#293129" d="M259.8 315.4l.7.7-.7-.7z" />
      <path fill="#dedede" d="M282.3 315.4l.7.7-.7-.7z" />
      <path fill="#391810" d="M283 315.4l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M283.8 315.4l.6.7-.6-.7z" />
      <path fill="#5a1008" d="M284.4 315.4l.8.7-.8-.7z" />
      <path fill="#631808" d="M285.1 315.4l.7.7-.7-.7z" />
      <path fill="#941808" d="M285.9 315.4l1.4 1.4-1.4-1.4m7.7 0l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M294.3 315.4l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M304.1 315.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M304.9 315.4l.7.7-.8-.7z" />
      <path fill="#8c8c8c" d="M202.8 316.1l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M203.6 316.1l.7.7-.8-.7z" />
      <path fill="#7b1008" d="M214.1 316.1l.7.7-.7-.7z" />
      <path fill="#b51010" d="M214.8 316.1l.7.7-.7-.7z" />
      <path fill="#941808" d="M221.6 316.3l.5.2-.5-.2z" />
      <path fill="#631818" d="M225.4 316.1l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M226 316.1l.8.7-.7-.7z" />
      <path fill="#cecece" d="M245.8 316.1l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M246.5 316.1l.7.7-.7-.7z" />
      <path fill="#734a42" d="M247.2 316.1v.7h2l-2-.7z" />
      <path fill="#293100" d="M249.3 316.1l.7.7-.7-.7z" />
      <path fill="#397b00" d="M250 316.1l.7.7-.7-.7z" />
      <path fill="#295200" d="M254.2 316.1l.7.7-.7-.7z" />
      <path fill="#082108" d="M254.9 316.1l.7.7-.7-.7z" />
      <path fill="#296300" d="M257.7 316.1l.7.7-.7-.7z" />
      <path fill="#184a00" d="M258.4 316.1l.7.7-.7-.7z" />
      <path fill="#392100" d="M259.1 316.1l.7.7-.7-.7z" />
      <path fill="#733939" d="M259.8 316.1l.7.7-.7-.7z" />
      <path fill="#734a42" d="M260.5 316.1l.7.7-.7-.7z" />
      <path fill="#736b6b" d="M261.2 316.1l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M262 316.1l.6.7-.7-.7z" />
      <path fill="#cecece" d="M281.6 316.1l-.7 1.3.7-1.3z" />
      <path fill="#5a1010" d="M282.3 316.1l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M283 316.1l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M285.9 316.1l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M292.9 316.1l1.4 1.3-1.4-1.3z" />
      <path fill="#5a1008" d="M293.6 316.1l.7.7-.7-.7z" />
      <path fill="#736b6b" d="M304.9 316.1l.7.7-.8-.7z" />
      <path fill="#8c6363" d="M202.8 316.8l.7.6-.7-.6z" />
      <path fill="#520808" d="M214.8 316.8l.7.6-.7-.6z" />
      <path fill="#ce2110" d="M215.5 316.8l.7.6-.7-.6z" />
      <path fill="#bd2110" d="M224.7 316.8l.7.6-.8-.6z" />
      <path fill="#7b1008" d="M225.4 316.8l-.7 1.3.7-1.3z" />
      <path fill="#100808" d="M226 316.8l.8.6-.7-.6z" />
      <path fill="#9c9494" d="M226.8 316.8l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M243 316.8l.6.6-.7-.6z" />
      <path fill="#ada5a5" d="M243.7 316.8l.7.6-.8-.6z" />
      <path fill="#8c8c8c" d="M244.3 316.8l.7.6-.7-.6z" />
      <path fill="#52525a" d="M245 316.8l.8.6-.7-.6z" />
      <path fill="#7b1008" d="M245.8 316.8l.7.6-.7-.6z" />
      <path fill="#ce2110" d="M246.5 316.8l.7.6-.7-.6z" />
      <path fill="#de2110" d="M245.8 320.1l5.6.7c-.4-4.1-4.8-5.1-5.6-.7z" />
      <path fill="#b51010" d="M250 316.8l.7.6-.7-.6z" />
      <path fill="#7b1008" d="M250.7 316.8l.7.6-.7-.6z" />
      <path fill="#292100" d="M251.4 316.8l.7.6-.7-.6z" />
      <path fill="#422100" d="M252 316.8l.8.6-.7-.6z" />
      <path fill="#941808" d="M252.8 316.8l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M253.5 316.8v.6h2.1l-2.1-.6z" />
      <path fill="#311000" d="M255.6 316.8l.7.6-.7-.6z" />
      <path fill="#293100" d="M256.3 316.8l.7.6-.7-.6z" />
      <path fill="#631808" d="M257 316.8l.7.6-.7-.6z" />
      <path fill="#941808" d="M257.7 316.8l.7.6-.7-.6z" />
      <path
        fill="#de2110"
        d="M257 317.4l.7 3.4 5-.7c-.6-3.3-2.6-3.3-5.7-2.7z"
      />
      <path fill="#b51010" d="M262 316.8l.6.6-.7-.6z" />
      <path fill="#423131" d="M262.6 316.8l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M263.4 316.8l.7.6-.8-.6z" />
      <path fill="#9c9494" d="M264 316.8l.8.6-.8-.6z" />
      <path fill="#bdbdbd" d="M264.8 316.8l.6.6-.6-.6z" />
      <path fill="#efefef" d="M265.5 316.8l.7.6-.7-.6z" />
      <path fill="#101810" d="M281.6 316.8l.7.6-.7-.6z" />
      <path fill="#631808" d="M282.3 316.8l.7.6-.7-.6z" />
      <path fill="#b51010" d="M283 316.8l.7.6-.7-.6z" />
      <path fill="#520808" d="M292.9 316.8l.7.6-.7-.6z" />
      <path fill="#734a42" d="M305 317.2l.3.5-.2-.5z" />
      <path fill="#8c8c8c" d="M202.8 317.4l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M214.8 317.4l.7.7-.7-.7z" />
      <path fill="#631808" d="M215.5 317.4l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M223.3 317.4l.6.7-.7-.7z" />
      <path fill="#5a1008" d="M224 317.4l.6.7-.7-.7z" />
      <path fill="#ce2110" d="M225.4 317.4l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M226.8 317.4l.7.7-.7-.7z" />
      <path fill="#cecece" d="M227.5 317.4l.7.7-.7-.7z" />
      <path fill="#efefef" d="M240.1 317.4l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M240.8 317.4l.7.7-.7-.7z" />
      <path fill="#736b6b" d="M241.5 317.4l.7.7-.7-.7z" />
      <path fill="#631818" d="M242.2 317.4l.7.7-.7-.7z" />
      <path fill="#941808" d="M243 317.4l.6.7-.7-.7z" />
      <path fill="#b51010" d="M243.7 317.4l.7.7-.8-.7z" />
      <path fill="#de2110" d="M244.3 317.4l-2.8.7v4c2.5-1 3.9-2 2.8-4.7z" />
      <path fill="#5a1008" d="M245 317.4l.8.7-.7-.7z" />
      <path fill="#520808" d="M251.4 317.4l.7.7-.7-.7z" />
      <path fill="#de2110" d="M252 317.4v4h4.3v-4h-4.2z" />
      <path fill="#520808" d="M256.3 317.4l.7.7-.7-.7z" />
      <path fill="#941808" d="M262.6 317.4l.7.7-.7-.7z" />
      <path fill="#b51010" d="M263.4 317.4l.7.7-.8-.7z" />
      <path fill="#bd2110" d="M264 317.4l.8.7-.8-.7z" />
      <path fill="#ad1810" d="M264.8 317.4l.6.7-.6-.7z" />
      <path fill="#7b1008" d="M265.5 317.4l.7.7-.7-.7z" />
      <path fill="#6b4242" d="M266.2 317.4l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M266.9 317.4l.7.7-.7-.7z" />
      <path fill="#dedede" d="M267.6 317.4l.7.7-.7-.7z" />
      <path fill="#efefef" d="M280.2 317.4l.7.7-.7-.7z" />
      <path fill="#5a1010" d="M281 317.4l.6.7-.7-.7z" />
      <path fill="#ce2110" d="M281.6 317.4l.7.7-.7-.7z" />
      <path fill="#941808" d="M283 317.4l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M283.8 317.4l.6.7-.6-.7z" />
      <path fill="#941808" d="M284.4 317.4l.8.7-.8-.7z" />
      <path fill="#7b1008" d="M292.2 317.4l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M292.9 317.4l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M203 318.6l.3.4-.2-.4z" />
      <path fill="#ad1810" d="M203.6 318.1l.7.7-.8-.7z" />
      <path fill="#ce2110" d="M207 318.1l.8.7-.7-.7z" />
      <path fill="#bd2110" d="M207.8 318.1l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M215.5 318.1l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M216.2 318.1l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M221.8 318.1l.7.7-.7-.7z" />
      <path fill="#520808" d="M222.5 318.1l.7.7-.7-.7z" />
      <path fill="#941808" d="M223.3 318.1l.6.7-.7-.7z" />
      <path fill="#ada5a5" d="M227.5 318.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M240.4 318.6l.2.4-.2-.4z" />
      <path fill="#941808" d="M240.8 318.1l.7.7-.7-.7z" />
      <path
        fill="#631808"
        d="M245 318.1v2.7h.8l-.7-2.7m6.3 0v2.7h.7l-.7-2.7z"
      />
      <path fill="#941808" d="M256.3 318.1l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M257 318.1l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M262.6 318.1l-2 3.4h2V320l1.4.7V318h-1.4z" />
      <path fill="#de2110" d="M264 318.1v3.4l2.9.6.7-3.3-3.6-.7z" />
      <path fill="#bd2110" d="M266.9 318.1l.7.7-.7-.7z" />
      <path fill="#6b4242" d="M267.6 318.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M280.2 318.1l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M281 318.1l.6.7-.7-.7m3.6 0l.6.7-.7-.7z" />
      <path fill="#520808" d="M285.1 318.1l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M285.9 318.1l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M291.5 318.1l.7.7-.7-.7z" />
      <path fill="#631808" d="M292.2 318.1l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M300.4 318.3l.5.3-.5-.3m3.8-.2l.6.7-.7-.7z" />
      <path fill="#8c8c8c" d="M304.9 318.1l.7.7-.8-.7z" />
      <path fill="#cecece" d="M198 318.8l.6.6-.7-.6z" />
      <path fill="#bdbdbd" d="M198.6 318.8l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M202.1 318.8l.7.6-.7-.6z" />
      <path fill="#5a1010" d="M203.6 318.8l.7.6-.8-.6z" />
      <path fill="#bd2110" d="M205.7 318.8l.7.6-.7-.6z" />
      <path fill="#5a1008" d="M206.4 318.8l.7.6-.7-.6z" />
      <path fill="#631808" d="M207 318.8l.8.6-.7-.6z" />
      <path fill="#941808" d="M207.8 318.8l.7.6-.7-.6z" />
      <path fill="#631808" d="M208.5 318.8l.7.6-.7-.6z" />
      <path fill="#7b1008" d="M209.2 318.8l.7.6-.7-.6z" />
      <path fill="#5a1008" d="M209.9 318.8l.7.6-.7-.6z" />
      <path fill="#bd2110" d="M210.6 318.8l.7.6-.7-.6z" />
      <path fill="#5a1008" d="M216.2 318.8l.7.6-.7-.6z" />
      <path fill="#941808" d="M217.2 319.2l.2.5-.3-.5z" />
      <path fill="#b51010" d="M220.4 318.8l.7.6-.7-.6z" />
      <path fill="#5a1008" d="M221.1 318.8l.7.6-.7-.6z" />
      <path fill="#631808" d="M221.8 318.8l.7.6-.7-.6z" />
      <path fill="#ce2110" d="M222.5 318.8l.7.6-.7-.6z" />
      <path fill="#941808" d="M226.8 318.8l.7.6-.7-.6z" />
      <path fill="#cecece" d="M227.5 318.8l.7.6-.7-.6z" />
      <path
        fill="#ad1810"
        d="M240.8 318.8l.7.6-.7-.6m15.5 0v1.3h1.4v-1.3h-1.4z"
      />
      <path fill="#8c8c8c" d="M267.8 319.2l.2.5-.2-.5z" />
      <path fill="#dedede" d="M280.2 318.8l.7.6-.7-.6z" />
      <path fill="#631808" d="M281 318.8l.6.6-.7-.6z" />
      <path fill="#941808" d="M285.9 318.8l.7.6-.7-.6z" />
      <path fill="#5a1008" d="M286.6 318.8l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M287.3 318.8l.7.6-.7-.6z" />
      <path fill="#b51010" d="M290.8 318.8l.7.6-.7-.6z" />
      <path fill="#520808" d="M291.5 318.8l.7.6-.7-.6z" />
      <path fill="#ce2110" d="M292.2 318.8l.7.6-.7-.6m5 0l.6.6-.7-.6z" />
      <path fill="#7b1008" d="M297.8 318.8l.7.6-.7-.6z" />
      <path fill="#631808" d="M299 319l.5.2-.5-.2z" />
      <path fill="#941808" d="M300 318.8l.6.6-.7-.6z" />
      <path fill="#7b1008" d="M300.6 318.8l.7.6-.7-.6z" />
      <path fill="#5a1008" d="M301.3 318.8l.7.6-.7-.6z" />
      <path fill="#b51010" d="M302 318.8l.7.6-.7-.6z" />
      <path fill="#520808" d="M304.1 318.8l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M305.3 319l.5.2-.5-.2z" />
      <path fill="#bdbdbd" d="M309.5 319l.5.2-.5-.2z" />
      <path fill="#ada5a5" d="M195.8 319.4l.7.7-.7-.7z" />
      <path fill="#63636b" d="M196.5 319.4l.7.7-.7-.7z" />
      <path fill="#733129" d="M197.2 319.4l.7.7-.7-.7z" />
      <path fill="#941808" d="M198 319.4l.6.7-.7-.7z" />
      <path
        fill="#de2110"
        d="M194.4 321.5c2.8 5.7 17.6 7.3 21.1 1.3-8.2 1-13.4-5.2-21.1-1.3z"
      />
      <path fill="#ce2110" d="M202.1 319.4l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M202.8 319.4l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M203.6 319.4l.7.7-.8-.7z" />
      <path fill="#ce2110" d="M206.4 319.4l.7.7-.7-.7z" />
      <path fill="#de2110" d="M214.8 322.1c-6.6-5-10.9 1.3 0 0z" />
      <path fill="#ce2110" d="M209.9 319.4l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M210.6 319.4l.7.7-.7-.7z" />
      <path fill="#520808" d="M211.3 319.4l.7.7-.7-.7z" />
      <path fill="#941808" d="M212 319.4l.7.7-.7-.7zm8.4 0l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M221.1 319.4l.7.7-.7-.7z" />
      <path fill="#5a2121" d="M226.8 319.4l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M240.8 319.4l.7.7-.7-.7z" />
      <path fill="#736b6b" d="M281 319.4l.6.7-.7-.7z" />
      <path fill="#ce2110" d="M281.6 319.4l.7.7-.7-.7z" />
      <path fill="#941808" d="M287.3 319.4l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M288 319.4l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M295.7 319.4l.7.7-.7-.7z" />
      <path fill="#631808" d="M296.9 319.7l.5.2-.5-.2z" />
      <path fill="#bd2110" d="M297.8 319.4l.7.7-.7-.7z" />
      <path fill="#de2110" d="M293.6 321.5v.6c3.6.5 7.7 1.8 8.4-2.7l-8.4 2z" />
      <path fill="#520808" d="M302 319.4l.7.7-.7-.7z" />
      <path fill="#b51010" d="M303.4 319.4l.8.7-.8-.7z" />
      <path fill="#5a1008" d="M304.1 319.4l-.7 1.4.8-1.4z" />
      <path fill="#ad1810" d="M304.9 319.4l.7.7-.8-.7z" />
      <path fill="#ce2110" d="M305.6 319.4l.7.7-.7-.7z" />
      <path
        fill="#de2110"
        d="M292.9 322.8c3.5 6 18.3 4.4 21-1.3-7.6-3.9-12.8 2.3-21 1.3z"
      />
      <path fill="#941808" d="M309.8 319.4l.7.7-.7-.7z" />
      <path fill="#6b2908" d="M310.5 319.4l.7.7-.7-.7z" />
      <path fill="#736b6b" d="M311.2 319.4l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M311.9 319.4l.7.7-.7-.7z" />
      <path fill="#efefef" d="M312.6 319.4l.7.7-.7-.7z" />
      <path fill="#cecece" d="M194.4 320.1l-1.4 2 1.4-2z" />
      <path fill="#5a3131" d="M195.1 320.1l.7.7-.7-.7z" />
      <path fill="#941808" d="M195.8 320.1l.7.7-.7-.7z" />
      <path fill="#631808" d="M204.3 320.1l.6.7-.7-.7z" />
      <path fill="#ad1810" d="M212 320.1l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M213.2 320.4l.4.2-.4-.2z" />
      <path fill="#bd2110" d="M214.1 320.1l.7.7-.7-.7z" />
      <path fill="#631818" d="M226 320.1l.8.7-.7-.7z" />
      <path fill="#cecece" d="M226.8 320.1l-.7 1.4.7-1.4z" />
      <path fill="#631808" d="M240.8 320.1l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M245.8 320.1v.7l2.8.7-2.8-1.4z" />
      <path fill="#941808" d="M256.3 320.1l1.4 1.4-1.4-1.4z" />
      <path fill="#ce2110" d="M257 320.1l.7.7-.7-.7z" />
      <path fill="#b51010" d="M259.8 320.1l.7.7-.7-.7z" />
      <path fill="#941808" d="M262.6 320.1l1.4 1.4-1.4-1.4z" />
      <path fill="#ad1810" d="M266.9 320.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M267.6 320.1l.7.7-.7-.7z" />
      <path fill="#efefef" d="M281 320.1l.6.7-.7-.7z" />
      <path fill="#5a2121" d="M281.6 320.1l1.4 1.4-1.4-1.4z" />
      <path fill="#ce2110" d="M293.6 320.1l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M294.3 320.1l-.7 1.4.7-1.4z" />
      <path fill="#5a1008" d="M295 320.1l.7.7-.7-.7z" />
      <path fill="#941808" d="M295.7 320.1l.7.7-.7-.7z" />
      <path fill="#b51010" d="M302 320.1l.7.7-.7-.7z" />
      <path fill="#631808" d="M302.7 320.1l.7.7-.7-.7z" />
      <path fill="#b51010" d="M311.9 320.1l.7.7-.7-.7z" />
      <path fill="#5a2121" d="M312.6 320.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M313.3 320.1l.7.7-.7-.7z" />
      <path fill="#631818" d="M194.4 320.8l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M204.3 320.8l.6.7-.7-.7z" />
      <path fill="#210800" d="M205 320.8l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M205.7 320.8l-.7 1.3.7-1.3z" />
      <path fill="#ce2110" d="M213.4 320.8l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M214.1 320.8l.7.7-.7-.7z" />
      <path fill="#420000" d="M214.8 320.8l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M215.5 320.8l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M224.7 320.8l.7.7-.8-.7z" />
      <path fill="#5a1010" d="M225.4 320.8l.7.7-.7-.7z" />
      <path fill="#734a42" d="M240.8 320.8l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M244.3 320.8l.7.7-.7-.7z" />
      <path fill="#310000" d="M245 320.8l.8.7-.7-.7z" />
      <path fill="#941808" d="M246 321.2l.2.5-.2-.5z" />
      <path fill="#b51010" d="M247 321l.4.2-.5-.2z" />
      <path fill="#7b1008" d="M248.6 320.8l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M249.3 320.8l.7.7-.7-.7z" />
      <path fill="#631808" d="M250 320.8l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M250.7 320.8l.7.7-.7-.7z" />
      <path fill="#520808" d="M251.4 320.8l.7.7-.7-.7z" />
      <path fill="#420000" d="M256.3 320.8l.7.7-.7-.7z" />
      <path fill="#631808" d="M257.7 320.8v.7h2.1l-2-.7z" />
      <path fill="#941808" d="M259.8 320.8l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M261.2 320.8l.7.7-.7-.7z" />
      <path fill="#310000" d="M262.6 320.8l.7.7-.7-.7z" />
      <path fill="#941808" d="M266.9 320.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M267.6 320.8l.7.7-.7-.7m14 0l.7.7-.7-.7z" />
      <path fill="#b51010" d="M283 320.8l.7.7-.7-.7m9.2 0l.7.7-.7-.7z" />
      <path fill="#520808" d="M292.9 320.8l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M294.3 320.8l.7.7-.7-.7m7.7 0l.7.7-.7-.7z" />
      <path fill="#210800" d="M302.7 320.8l.7.7-.7-.7z" />
      <path fill="#bd2110" d="M303.4 320.8l.8.7-.8-.7z" />
      <path fill="#7b1008" d="M313.3 320.8l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M314 320.8l.7.7-.7-.7z" />
      <path fill="#631818" d="M193.7 321.5l3.5 4-3.5-4z" />
      <path fill="#420000" d="M205.7 321.5l.7.6-.7-.6z" />
      <path fill="#842118" d="M214.8 321.5l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M215.5 321.5l.7.6-.7-.6z" />
      <path fill="#524242" d="M216.2 321.5l.7.6-.7-.6z" />
      <path fill="#7b1008" d="M217 321.5l.6.6-.7-.6z" />
      <path fill="#b51010" d="M217.6 321.5l.7.6-.7-.6m5.7 0l.6.6-.7-.6z" />
      <path fill="#5a1008" d="M224 321.5l.6.6-.7-.6z" />
      <path fill="#7b7373" d="M224.7 321.5l.7.6-.8-.6z" />
      <path fill="#efefef" d="M225.4 321.5l.7.6-.7-.6z" />
      <path fill="#845a52" d="M240.8 321.5l.7.6-.7-.6z" />
      <path fill="#bd2110" d="M242.2 321.5l.7.6-.7-.6z" />
      <path fill="#631818" d="M243 321.5l.6.6-.7-.6z" />
      <path fill="#7b5252" d="M243.7 321.5l.7.6-.8-.6z" />
      <path fill="#8c8c8c" d="M244.3 321.5l.7.6-.7-.6z" />
      <path fill="#63636b" d="M245 321.5l.8.6-.7-.6z" />
      <path fill="#de2110" d="M246.5 321.5v.6h2.8l-2.8-.6z" />
      <path fill="#b51010" d="M249.3 321.5l.7.6-.7-.6z" />
      <path fill="#941808" d="M250 321.5l.7.6-.7-.6z" />
      <path fill="#5a1008" d="M250.7 321.5l.7.6-.7-.6z" />
      <path fill="#392100" d="M251.4 321.5l.7.6-.7-.6z" />
      <path fill="#292100" d="M252 321.5l.8.6-.7-.6z" />
      <path fill="#7b1008" d="M252.8 321.5l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M254 321.7l.4.2-.4-.2z" />
      <path fill="#941808" d="M254.9 321.5l.7.6-.7-.6z" />
      <path fill="#311000" d="M255.6 321.5l.7.6-.7-.6z" />
      <path fill="#292100" d="M256.3 321.5l.7.6-.7-.6z" />
      <path fill="#4a1000" d="M257 321.5l.7.6-.7-.6z" />
      <path fill="#7b1008" d="M257.7 321.5l.7.6-.7-.6z" />
      <path fill="#ad1810" d="M258.4 321.5l.7.6-.7-.6z" />
      <path fill="#de2110" d="M259.1 321.5v.6h2.8l-2.8-.6z" />
      <path fill="#b51010" d="M262 321.5l.6.6-.7-.6z" />
      <path fill="#5a1010" d="M262.6 321.5l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M263.4 321.5l.7.6-.8-.6z" />
      <path fill="#7b7373" d="M264 321.5l.8.6-.8-.6z" />
      <path fill="#6b2131" d="M264.8 321.5l.6.6-.6-.6z" />
      <path fill="#941808" d="M265.5 321.5l.7.6-.7-.6z" />
      <path fill="#631808" d="M266.9 321.5l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M283 321.5l.7.6-.7-.6z" />
      <path fill="#631818" d="M283.8 321.5l.6.6-.6-.6z" />
      <path fill="#ad1810" d="M284.4 321.5l.8.6-.8-.6z" />
      <path fill="#b51010" d="M290 321.5l.8.6-.7-.6z" />
      <path fill="#7b1008" d="M290.8 321.5l.7.6-.7-.6z" />
      <path fill="#733939" d="M291.5 321.5l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M292.2 321.5l.7.6-.7-.6z" />
      <path fill="#631818" d="M292.9 321.5l.7.6-.7-.6z" />
      <path fill="#941808" d="M314 321.5l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M314.7 321.5l.7.6-.7-.6z" />
      <path fill="#63636b" d="M193 322.1l2.8 2.7-2.8-2.7z" />
      <path fill="#941808" d="M205.7 322.1l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M206.4 322.1l1.4 1.4-1.4-1.4z" />
      <path fill="#ce2110" d="M212 322.1l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M213 322.6l.2.4-.3-.4z" />
      <path fill="#631808" d="M213.9 322.4l.4.2-.4-.2z" />
      <path fill="#7b1008" d="M214.8 322.1l.7.7-.7-.7z" />
      <path fill="#392121" d="M215.5 322.1l.7.7-.7-.7z" />
      <path fill="#efefef" d="M217 322.1l.6.7-.7-.7z" />
      <path fill="#ada5a5" d="M217.6 322.1l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M218.3 322.1l.7.7-.7-.7z" />
      <path fill="#6b2131" d="M219 322.1l.7.7-.7-.7z" />
      <path fill="#631808" d="M219.7 322.1l.7.7-.7-.7z" />
      <path fill="#9c4239" d="M220.4 322.1l.7.7-.7-.7z" />
      <path fill="#ad524a" d="M221.1 322.1l.7.7-.7-.7z" />
      <path fill="#734a42" d="M221.8 322.1l.7.7-.7-.7z" />
      <path fill="#63636b" d="M222.5 322.1l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M223.3 322.1l.6.7-.7-.7z" />
      <path fill="#efefef" d="M224 322.1l.6.7-.7-.7z" />
      <path fill="#8c8c8c" d="M240.8 322.1l.7.7-.7-.7z" />
      <path fill="#6b2131" d="M241.5 322.1l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M242.2 322.1l.7.7-.7-.7z" />
      <path fill="#efefef" d="M243 322.1l.6.7-.7-.7m2.1 0l.8.7-.8-.7z" />
      <path fill="#313931" d="M245.8 322.1l.7.7-.7-.7z" />
      <path fill="#184a00" d="M246.5 322.1v.7h2.8l-2.8-.7z" />
      <path fill="#296300" d="M249.3 322.1l.7.7-.7-.7z" />
      <path fill="#297b00" d="M250 322.1l-.7 2.7.7-2.7z" />
      <path fill="#319400" d="M251.2 322.4l.4.2-.4-.2z" />
      <path fill="#214210" d="M252 322.1l-.6 1.4.7-1.4z" />
      <path fill="#9c9494" d="M252.8 322.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M254 322.4l.4.2-.4-.2z" />
      <path fill="#efefef" d="M254.9 322.1l.7.7-.7-.7z" />
      <path fill="#63636b" d="M255.6 322.1l.7.7-.7-.7z" />
      <path fill="#397b00" d="M256.3 322.1l.7.7-.7-.7z" />
      <path fill="#428c00" d="M257 322.1c2.6 3 7 6.8 10.6 3.4L257 322z" />
      <path fill="#397b00" d="M258.4 322.1l.7.7-.7-.7z" />
      <path fill="#294200" d="M259.1 322.1v.7h2.8l-2.8-.7z" />
      <path fill="#103900" d="M262 322.1l.6.7-.7-.7z" />
      <path fill="#8c8c8c" d="M262.6 322.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M265.5 322.1l.7.7-.7-.7z" />
      <path fill="#524242" d="M266.2 322.1l.7.7-.7-.7z" />
      <path fill="#5a1010" d="M266.9 322.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M284.4 322.1l.8.7-.8-.7z" />
      <path fill="#7b7373" d="M285.1 322.1l.7.7-.7-.7z" />
      <path fill="#734a42" d="M285.9 322.1l.7.7-.7-.7z" />
      <path fill="#ad524a" d="M287 322.4l.5.2-.5-.2z" />
      <path fill="#631808" d="M288 322.1l.7.7-.7-.7z" />
      <path fill="#733129" d="M288.7 322.1l.7.7-.7-.7z" />
      <path fill="#736b6b" d="M289.4 322.1l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M290 322.1l.8.7-.7-.7z" />
      <path fill="#dedede" d="M290.8 322.1l.7.7-.7-.7z" />
      <path fill="#52525a" d="M292.2 322.1l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M292.9 322.1l.7.7-.7-.7z" />
      <path fill="#631808" d="M294 322.4l.5.2-.4-.2z" />
      <path fill="#ad1810" d="M295.2 322.6l.3.4-.3-.4z" />
      <path fill="#ce2110" d="M295.7 322.1l.7.7-.7-.7z" />
      <path fill="#941808" d="M301.3 322.1l.7.7-.7-.7z" />
      <path fill="#631818" d="M314 322.1l.7.7-.7-.7z" />
      <path fill="#63636b" d="M314.7 322.1l-.7 1.4.7-1.4z" />
      <path fill="#efefef" d="M315.4 322.1l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M192.3 322.8l2.8 2.7-2.8-2.7z" />
      <path fill="#cecece" d="M193 322.8l.7.7-.7-.7z" />
      <path fill="#b51010" d="M206.4 322.8l.7.7-.7-.7z" />
      <path fill="#631808" d="M208.2 323l.5.2-.5-.2z" />
      <path fill="#941808" d="M209.2 322.8l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M209.9 322.8l.7.7-.7-.7z" />
      <path fill="#941808" d="M210.6 322.8l.7.7-.7-.7z" />
      <path fill="#631808" d="M211.8 323l.4.2-.4-.2z" />
      <path fill="#5a1008" d="M215.5 322.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M216.2 322.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M240.8 322.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M244.3 322.8l.7.7-.7-.7z" />
      <path fill="#294221" d="M245 322.8l.8.7-.7-.7z" />
      <path fill="#297b00" d="M245.8 322.8l.7.7-.7-.7z" />
      <path fill="#319400" d="M241.5 325.5c3.3 3 6.8.2 9.2-2.7l-9.2 2.7z" />
      <path fill="#cecece" d="M252 322.8l-.6 1.3.7-1.3z" />
      <path fill="#8c8c8c" d="M256.3 322.8l.7.7-.7-.7z" />
      <path fill="#294200" d="M257 322.8l.7.7-.7-.7z" />
      <path fill="#397b00" d="M262.6 322.8l.7.7-.7-.7z" />
      <path fill="#52525a" d="M263.4 322.8l.7.7-.8-.7z" />
      <path fill="#efefef" d="M264 322.8l.8.7-.8-.7z" />
      <path fill="#dedede" d="M266.9 322.8l.7.7-.7-.7z" />
      <path fill="#420000" d="M292.2 322.8l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M295.7 322.8l.7.7-.7-.7z" />
      <path fill="#631808" d="M296.4 322.8l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M297.1 322.8l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M297.8 322.8l.7.7-.7-.7z" />
      <path fill="#941808" d="M298.5 322.8l.7.7-.7-.7z" />
      <path fill="#631808" d="M299.2 322.8v.7h2.1l-2-.7z" />
      <path fill="#ad1810" d="M301.3 322.8l.7.7-.7-.7z" />
      <path fill="#520808" d="M313.3 322.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M314.7 322.8l-1.4 2 1.4-2z" />
      <path fill="#8c8c8c" d="M315.4 322.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M191.6 323.5l.7.6-.7-.6z" />
      <path fill="#cecece" d="M193.7 323.5l.7.6-.7-.6z" />
      <path fill="#7b1008" d="M215.5 323.5l.7.6-.7-.6z" />
      <path fill="#dedede" d="M216.2 323.5l.7.6-.7-.6z" />
      <path fill="#8c8c8c" d="M243.7 323.5l.7.6-.8-.6z" />
      <path fill="#184a00" d="M244.3 323.5l.7.6-.7-.6z" />
      <path fill="#314231" d="M250.7 323.5l-.7 1.3.7-1.3z" />
      <path fill="#bdbdbd" d="M257 323.5l.7.6-.7-.6z" />
      <path fill="#213918" d="M257.7 323.5l.7.6-.7-.6m6.4 0l.6.6-.6-.6z" />
      <path fill="#bdbdbd" d="M264.8 323.5l.6.6-.6-.6z" />
      <path fill="#5a1008" d="M292.2 323.5l.7.6-.7-.6z" />
      <path fill="#631808" d="M312.6 323.5l.7.6-.7-.6z" />
      <path fill="#424242" d="M313.3 323.5l.7.6-.7-.6z" />
      <path fill="#7b7373" d="M314.7 323.5l-1.4 2 1.4-2z" />
      <path fill="#9c9494" d="M315.4 323.5l-.7 1.3.7-1.3z" />
      <path fill="#cecece" d="M192.3 324.1l.7.7-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#b51010" d="M214.8 324.1l-.7 1.4.7-1.4z" />
      <path fill="#63636b" d="M215.5 324.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M242.2 324.1l.7.7-.7-.7z" />
      <path fill="#294221" d="M243 324.1l.6.7-.7-.7z" />
      <path fill="#296300" d="M243.7 324.1l.7.7-.8-.7z" />
      <path fill="#efefef" d="M250.7 324.1l.7.7-.7-.7m7 0l.7.7-.7-.7z" />
      <path fill="#425242" d="M258.4 324.1l.7.7-.7-.7z" />
      <path fill="#397b00" d="M259.1 324.1l.7.7-.7-.7z" />
      <path fill="#295200" d="M264.8 324.1l.6.7-.6-.7z" />
      <path fill="#425242" d="M265.5 324.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M266.2 324.1l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M292.2 324.1l.7.7-.7-.7z" />
      <path fill="#ad1810" d="M292.9 324.1l.7.7-.7-.7z" />
      <path fill="#941808" d="M311.9 324.1l-1.4 2 1.4-2z" />
      <path fill="#424242" d="M312.6 324.1l-1.4 2 1.4-2z" />
      <path fill="#7b7373" d="M316.1 324.1l.7.7-.7-.7z" />
      <path fill="#dedede" d="M191.6 324.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M193 324.8l1.4 1.3-1.4-1.3z" />
      <path fill="#7b7373" d="M193.7 324.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M195.1 324.8l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M195.8 324.8l1.4 1.3-1.4-1.3z" />
      <path fill="#5a3131" d="M214.8 324.8l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M240.8 324.8l.7.7-.7-.7z" />
      <path fill="#425242" d="M241.5 324.8l.7.7-.7-.7z" />
      <path fill="#296300" d="M242.2 324.8l.7.7-.7-.7z" />
      <path fill="#185200" d="M248.6 324.8l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M249.3 324.8l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M259.1 324.8l.7.7-.7-.7z" />
      <path fill="#295200" d="M259.8 324.8l.7.7-.7-.7m6.4 0l.7.7-.7-.7z" />
      <path fill="#63636b" d="M266.9 324.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M267.6 324.8l.7.7-.7-.7z" />
      <path fill="#63636b" d="M292.9 324.8l.7.7-.7-.7z" />
      <path fill="#941808" d="M293.6 324.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M312.6 324.8l.7.7-.7-.7z" />
      <path fill="#a59494" d="M314 324.8l.7.7-.7-.7z" />
      <path fill="#63636b" d="M315.4 324.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M316.1 324.8l-.7 2 .7-2z" />
      <path fill="#bdbdbd" d="M192.3 325.5l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M194.4 325.5l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M195.1 325.5l5 4-5-4z" />
      <path fill="#9c9494" d="M195.8 325.5l.7.7-.7-.7z" />
      <path fill="#7b1008" d="M197.2 325.5l.7.7-.7-.7z" />
      <path fill="#941808" d="M203.6 325.5l.7.7-.8-.7z" />
      <path fill="#631808" d="M204.3 325.5l.6.7-.7-.7z" />
      <path fill="#8c3939" d="M205 325.5l.7.7-.7-.7z" />
      <path fill="#843129" d="M209.9 325.5l.7.7-.7-.7z" />
      <path fill="#6b5252" d="M213.4 325.5l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M214.1 325.5l.7.7-.7-.7m26 0l.7.7-.7-.7z" />
      <path fill="#184a00" d="M240.8 325.5l.7.7-.7-.7z" />
      <path fill="#297b00" d="M247.2 325.5l.7.7-.7-.7z" />
      <path fill="#294221" d="M247.9 325.5l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M248.6 325.5l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M259.8 325.5l.7.7-.7-.7z" />
      <path fill="#213918" d="M260.5 325.5l.7.7-.7-.7z" />
      <path fill="#103900" d="M267.6 325.5l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M268.3 325.5l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M293.6 325.5l.7.7-.7-.7z" />
      <path fill="#736b6b" d="M294.3 325.5l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M295 325.5l.7.7-.7-.7z" />
      <path fill="#842118" d="M297.8 325.5l.7.7-.7-.7z" />
      <path fill="#8c4a4a" d="M298.5 325.5l.7.7-.7-.7zm4.2 0l.7.7-.7-.7z" />
      <path fill="#631808" d="M303.4 325.5l.8.7-.8-.7z" />
      <path fill="#941808" d="M304.1 325.5l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M304.9 325.5l.7.7-.8-.7z" />
      <path fill="#cecece" d="M311.9 325.5l-2.1 2.7 2-2.7z" />
      <path fill="#8c8c8c" d="M312.6 325.5l-3.5 4.7 3.5-4.7z" />
      <path fill="#ada5a5" d="M313.8 325.7l.4.2-.4-.2z" />
      <path fill="#dedede" d="M192.3 326.1l.7.7-.7-.7z" />
      <path fill="#cecece" d="M193 326.1l1.4 2-1.4-2z" />
      <path fill="#efefef" d="M194.4 326.1l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M196.5 326.1l.7.7-.7-.7z" />
      <path fill="#52525a" d="M197.2 326.1l.7.7-.7-.7z" />
      <path fill="#941808" d="M198 326.1l.6.7-.7-.7z" />
      <path fill="#bd2110" d="M201.4 326.1l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M202.1 326.1l.7.7-.7-.7z" />
      <path fill="#736b6b" d="M202.8 326.1l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M203.6 326.1l.7.7-.8-.7z" />
      <path fill="#efefef" d="M240.1 326.1l.7.7-.7-.7z" />
      <path fill="#314231" d="M240.8 326.1l.7.7-.7-.7z" />
      <path fill="#297b00" d="M241.5 326.1l1.4 1.4-1.4-1.4z" />
      <path fill="#185200" d="M246.5 326.1l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M247.2 326.1l.7.7-.7-.7z" />
      <path fill="#efefef" d="M247.9 326.1l.7.7-.7-.7m12.6 0l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M261.2 326.1l.7.7-.7-.7z" />
      <path fill="#294200" d="M262 326.1l.6.7-.7-.7z" />
      <path fill="#397b00" d="M266.9 326.1l-.7 1.4.7-1.4z" />
      <path fill="#52525a" d="M267.6 326.1l.7.7-.7-.7z" />
      <path fill="#efefef" d="M268.3 326.1l.7.7-.7-.7z" />
      <path fill="#cecece" d="M304.1 326.1l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M304.9 326.1l.7.7-.8-.7z" />
      <path fill="#631818" d="M305.6 326.1l.7.7-.7-.7z" />
      <path fill="#b51010" d="M306.3 326.1l.7.7-.7-.7m3.5 0l-.7 1.4.7-1.4z" />
      <path fill="#292921" d="M310.5 326.1l.7.7-.7-.7z" />
      <path fill="#cecece" d="M313.3 326.1l.7.7-.7-.7m1.4 0l-2.1 2.7 2-2.7z" />
      <path fill="#bdbdbd" d="M193.7 326.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M195.1 326.8l.7.7-.7-.7z" />
      <path fill="#424242" d="M198 326.8l.6.7-.7-.7z" />
      <path fill="#ad1810" d="M198.6 326.8l.7.7-.7-.7m2.1 0l.7.7-.7-.7z" />
      <path fill="#63636b" d="M201.4 326.8l.7.7-.7-.7z" />
      <path fill="#efefef" d="M202.1 326.8l.7.7-.7-.7z" />
      <path fill="#63636b" d="M241.5 326.8l.7.7-.7-.7z" />
      <path fill="#296300" d="M245 326.8l.8.7-.7-.7z" />
      <path fill="#425242" d="M245.8 326.8l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M246.5 326.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M262 326.8l.6.7-.7-.7z" />
      <path fill="#425242" d="M262.6 326.8l.7.7-.7-.7z" />
      <path fill="#295200" d="M263.4 326.8l.7.7-.8-.7z" />
      <path fill="#63636b" d="M266.9 326.8l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M306.3 326.8l.7.7-.7-.7z" />
      <path fill="#941808" d="M307 326.8l.7.7-.7-.7z" />
      <path fill="#292921" d="M309.8 326.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M312.6 326.8l.7.7-.7-.7z" />
      <path fill="#ada5a5" d="M314.7 326.8l-1.4 2 1.4-2z" />
      <path fill="#cecece" d="M195.8 327.5l2.8 2.7-2.8-2.7z" />
      <path fill="#7b7373" d="M196.5 327.5l.7.7-.7-.7z" />
      <path fill="#292921" d="M198.6 327.5l.7.7-.7-.7z" />
      <path fill="#b51010" d="M199.3 327.5l.7.7-.7-.7z" />
      <path fill="#941808" d="M200 327.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M200.7 327.5l.7.7-.7-.7m41.5 0l.7.7-.7-.7z" />
      <path fill="#185200" d="M243 327.5l.6.7-.7-.7z" />
      <path fill="#296300" d="M243.7 327.5l.7.7-.8-.7z" />
      <path fill="#395231" d="M244.3 327.5l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M245 327.5l.8.7-.7-.7m18.3 0l.7.7-.8-.7z" />
      <path fill="#5a5231" d="M264 327.5l.8.7-.8-.7z" />
      <path fill="#397b00" d="M264.8 327.5l.6.7-.6-.7z" />
      <path fill="#295200" d="M265.5 327.5l.7.7-.7-.7z" />
      <path fill="#9c9494" d="M266.2 327.5l.7.7-.7-.7m40.8 0l.7.7-.7-.7z" />
      <path fill="#5a1008" d="M307.7 327.5l.7.7-.7-.7z" />
      <path fill="#ce2110" d="M308.4 327.5l.7.7-.7-.7z" />
      <path fill="#391810" d="M309 327.5l.8.7-.7-.7z" />
      <path fill="#cecece" d="M311.9 327.5l.7.7-.7-.7z" />
      <path fill="#7b7373" d="M197.2 328.2l.7.6-.7-.6z" />
      <path fill="#313931" d="M199.3 328.2l.7.6-.7-.6z" />
      <path fill="#9c9494" d="M200 328.2l.7.6-.7-.6z" />
      <path fill="#ada5a5" d="M243 328.2l.6.6-.7-.6z" />
      <path fill="#9c9494" d="M243.7 328.2l.7.6-.8-.6m21.2 0l.6.6-.6-.6z" />
      <path fill="#ada5a5" d="M265.5 328.2l.7.6-.7-.6z" />
      <path fill="#cecece" d="M307.7 328.2l1.4 1.3-1.4-1.3z" />
      <path fill="#292921" d="M308.4 328.2l.7.6-.7-.6z" />
      <path fill="#bdbdbd" d="M309 328.2l.8.6-.7-.6m2 0l.8.6-.7-.6z" />
      <path fill="#8c8c8c" d="M195.1 328.8l.7.7-.7-.7z" />
      <path fill="#cecece" d="M195.8 328.8l2.8 2.7-2.8-2.7z" />
      <path fill="#7b7373" d="M198 328.8l.6.7-.7-.7z" />
      <path fill="#bdbdbd" d="M310.5 328.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M311.9 328.8l-.7 1.4.7-1.4z" />
      <path
        fill="#7b7373"
        d="M312.6 328.8l-.7 1.4.7-1.4m-116.8.7l.7.7-.7-.7z"
      />
      <path fill="#8c8c8c" d="M198.6 329.5l.7.7-.7-.7z" />
      <path fill="#bdbdbd" d="M309.8 329.5l.7.7-.7-.7z" />
      <path fill="#8c8c8c" d="M196.5 330.2l1.4 1.3-1.4-1.3z" />
      <path fill="#efefef" d="M198.6 330.2l.7.6-.7-.6z" />
      <path
        fill="#dedede"
        d="M310.5 330.2l.7.6-.7-.6m-114 .6l1.4 1.4-1.4-1.4z"
      />
      <path fill="#efefef" d="M309.8 330.8l.7.7-.7-.7z" />
      <path fill="#dedede" d="M311.2 330.8l-.7 1.4.7-1.4z" />
      <path
        fill="#ecca5e"
        d="M230.9 207.5l1.1-.3a.8.8 0 0 0 .4.5h.6c.3 0 .6 0 .7-.2a.3.3 0 0 0 .1-.3.3.3 0 0 0-.1-.2 1 1 0 0 0-.4 0 6.5 6.5 0 0 1-1.8-.4 1 1 0 0 1-.7-.9c0-.4 0-.7.3-1 .3-.2.8-.4 1.4-.5.6 0 1 0 1.4.2.3.1.5.3.7.7l-1.1.3a.6.6 0 0 0-.3-.3 1 1 0 0 0-.6 0l-.6.1-.1.2.1.2c.1.1.5.2 1.1.2.7 0 1.1.2 1.4.4a1 1 0 0 1 .4.7c0 .4 0 .7-.3 1-.3.4-.8.6-1.5.6-.6.1-1 0-1.4-.1a1.6 1.6 0 0 1-.8-.9zm-5.1-.4a2.1 2.1 0 0 1 .1-1l.7-1c.4-.1.7-.3 1.2-.3a2 2 0 0 1 1.7.4c.4.4.7.8.8 1.5a2 2 0 0 1-.5 1.6c-.3.5-.8.7-1.5.8l-1.2-.1a1.9 1.9 0 0 1-.9-.7l-.4-1.2zm1.2 0c0 .4.2.7.4.9.2.2.5.2.8.2a1 1 0 0 0 .7-.4c.2-.3.2-.6.2-1s-.2-.7-.4-.9a1 1 0 0 0-.8-.2 1 1 0 0 0-.7.4c-.2.2-.3.5-.2 1zm-3.6-2.3l-.1-1 1.1-.1.1 1-1.1.1zm.6 4.7l-.5-4.1 1.1-.2.5 4.2-1.1.1zm-6.8-5l2.2-.3h1.2c.3 0 .7.2 1 .4l.7.9c.1.3.3.8.3 1.3v1.3a2.5 2.5 0 0 1-.5 1 2 2 0 0 1-.8.6l-1 .3-2.4.2-.7-5.7zm1.3.8l.5 3.8h1l.7-.2.4-.3.3-.6v-1a3.3 3.3 0 0 0-.3-1 1.3 1.3 0 0 0-.4-.6 1.2 1.2 0 0 0-.6-.2h-1l-.5.1z"
      />
      <path
        fill="#ecca5e"
        fillRule="evenodd"
        d="M233.4 223.4l17 21.4-.7 1-17.1-21.4zm44-1.6L258.3 247l-1.5-.5 19.1-25.2zm-48.4 5.8l20.2 18.8-.7 1-20.2-18.7zm-4.7 4.4l22.2 16.6-.5 1-22.3-16.5zm56-3.3l-20 19-1.2-.7 20-19zm4.4 3.5l-22.4 16.4-1-.8 22.4-16.4z"
      />
      <path
        fill="#7b5a00"
        fillOpacity={0.6}
        d="M271.3 229.6l4.6-5.9-.6-.4-4 6.3z"
      />
      <path
        fill="#7b5a00"
        fillOpacity={0.5}
        d="M260.8 243.5l4.6-5.9-.6-.4-4 6.3z"
      />
      <path
        fill="#7b5a00"
        fillOpacity={0.7}
        d="M266 236.8l4.6-5.9-.5-.4-4.1 6.3z"
      />
      <path
        fill="#7b5a00"
        fillOpacity={0.5}
        d="M276.8 237.6l6.5-4-.4-.6-6 4.6z"
      />
      <path
        fill="#7b5a00"
        fillOpacity={0.4}
        d="M268.3 240l5.8-5-.5-.5-5.3 5.4z"
      />
      <path
        fill="#428c00"
        d="M213.6 288.6h-.7c-.1-3.8-1.6-6.3-5.6-7.3.1 2 1.6 10 5 7.3h.6l-1.4 6c2.1-2.2 10.8-10 7-13.4-3.2-3-4.8 6-4.9 7.4zm-5.3-47.9h-.8c0-3.8-1.6-6.3-5.6-7.3.1 2 1.6 10 5 7.3h.6l-1.4 6c2.1-2.2 10.8-10 7-13.4-3.2-3-4.8 6-4.9 7.4z"
      />
      <path
        fill="#ecca5e"
        d="M299.5 210.8h-1v-.7l-.7.5a1.7 1.7 0 0 1-.7 0c-.5 0-1-.2-1.2-.7-.3-.4-.5-1-.4-1.6.1-.7.3-1.2.7-1.6.4-.3.9-.4 1.4-.4.5.1.9.3 1.2.8l.3-2.1 1.1.1-.7 5.7zm-2.8-2.5v1a.9.9 0 0 0 .8.5.9.9 0 0 0 .7-.2c.2-.2.4-.5.4-1l-.1-1a.9.9 0 0 0-.7-.4.9.9 0 0 0-.7.2c-.2.2-.4.5-.4 1zm-4.6-1.2l-1-.3c.1-.4.3-.7.7-.8l1.3-.2 1.1.3.5.5v1l-.2 1.3v.8l.1.6-1.1-.1a4.7 4.7 0 0 1 0-.4 2 2 0 0 1-1.5.3c-.5 0-.8-.2-1-.5a1.1 1.1 0 0 1-.3-.9 1.1 1.1 0 0 1 .8-1l1-.1 1-.1.1-.2-.1-.4-.6-.2a.9.9 0 0 0-.5 0 .8.8 0 0 0-.3.4zm1.4 1a8 8 0 0 1-.7.2h-.7l-.2.4a.5.5 0 0 0 0 .5.6.6 0 0 0 .5.2c.2 0 .4 0 .7-.2a.7.7 0 0 0 .3-.3v-.5l.1-.2zm-3-2.4v.8h-.8l-.2 1.6v.7l.2.1h.5v.8l-1 .1a1.5 1.5 0 0 1-.5-.2.8.8 0 0 1-.4-.3 1 1 0 0 1 0-.4v-.8l.2-1.8h-.5v-1l.6.1.1-.8 1.3-.5-.2 1.5h.8zm-4.6 3.6l-1.1-.1.5-4.1h1v.7l.5-.5.5-.1c.3 0 .5.1.8.3l-.5.9a1 1 0 0 0-.5-.2.7.7 0 0 0-.5 0l-.3.5-.2 1.4-.2 1.2zm-3-1.6l1 .3a1.8 1.8 0 0 1-.8.8 2 2 0 0 1-1.2.2c-.8-.1-1.3-.4-1.6-1-.2-.3-.3-.8-.3-1.4.1-.7.4-1.2.8-1.5.4-.4 1-.5 1.5-.4a2 2 0 0 1 1.5.7c.3.5.4 1.1.3 2l-2.9-.4c0 .4 0 .6.2.8.1.2.4.3.6.4l.5-.1a.9.9 0 0 0 .3-.4zm.1-1.1c0-.4 0-.6-.2-.8a.8.8 0 0 0-.5-.3.8.8 0 0 0-.7.2 1 1 0 0 0-.3.7l1.7.2zm-8 1.5l.7-5.7 1.1.1-.2 2c.4-.2.8-.4 1.3-.3.5 0 1 .3 1.2.7.3.4.4.9.4 1.6-.1.7-.4 1.2-.8 1.5a1.7 1.7 0 0 1-2 .2 1.8 1.8 0 0 1-.6-.6v.6H275zm1.4-2v1c.2.3.5.5.8.5a.8.8 0 0 0 .7-.2c.2-.2.3-.6.4-1 0-.5 0-.8-.2-1a.9.9 0 0 0-.6-.4.9.9 0 0 0-.7.2c-.2.2-.4.5-.4.9zm-3.1-3v-1l1.2.2v1l-1.2-.1zm-.6 4.8l.5-4.2 1.1.2-.5 4h-1.1zm-5-.6l.6-5.7 1.2.2-.6 4.7 3 .3v1l-4.3-.5z"
      />
      <path
        fill="#428c00"
        d="M201 254h-.6c-.1-3.8-1.6-6.2-5.6-7.3 0 2 1.5 10 4.9 7.4h.7l-1.4 6c2-2.2 10.7-10 7-13.5-3.2-3-4.9 6-5 7.5z"
      />
      <path
        fill="#fac349"
        fillRule="evenodd"
        d="M226 232.8c0 .5-.6 1-1.4 1s-1.3-.5-1.3-1 .6-1 1.3-1 1.3.5 1.3 1zm4.3-4.7c0 .6-.5 1-1.3 1s-1.3-.4-1.3-1c0-.5.6-.9 1.3-.9s1.3.4 1.3 1zm4.1-4.3c0 .5-.6 1-1.3 1s-1.3-.5-1.3-1 .6-1 1.3-1 1.3.5 1.3 1zm43.3-1.7c0 .5-.5 1-1.2 1s-1.4-.5-1.4-1 .6-1 1.3-1 1.4.5 1.4 1zm3.1 6c0 .6-.5 1-1.3 1s-1.3-.4-1.3-1c0-.5.6-.9 1.3-.9s1.3.4 1.3 1zm4.6 4c0 .4-.6.8-1.3.8s-1.3-.4-1.3-.9.6-1 1.3-1 1.3.5 1.3 1z"
      />
      <path
        fill="#ecca5e"
        d="M262.6 199.3l-1-.2c0-.4.3-.7.6-.9.3-.2.7-.3 1.3-.3l1.1.2.5.5.2 1v2.1l.2.5h-1.1a4 4 0 0 1-.1-.3 1.4 1.4 0 0 0 0-.1 1.9 1.9 0 0 1-1.5.5c-.4 0-.8-.1-1-.4a1.1 1.1 0 0 1-.4-.9 1.1 1.1 0 0 1 .7-1 4 4 0 0 1 1-.3l1-.2v-.1l-.1-.5-.6-.1-.5.1a.8.8 0 0 0-.3.4zm1.5.9l-.7.2-.6.2-.2.3c0 .2 0 .3.2.4a.7.7 0 0 0 .4.2c.2 0 .4 0 .6-.2.2 0 .2-.2.3-.3v-.8zm-4.7-2.8v-1h1.2v1h-1.2zm0 4.8V198h1.2v4.2h-1.2zm-2.2 0H256V198h1.1v.6l.5-.6a1 1 0 0 1 .5-.1c.3 0 .6 0 .8.2l-.4 1a1 1 0 0 0-.5-.2l-.4.1-.3.5-.1 1.4v1.2zm-1.9-4.2v.8h-.8v2.3l.1.1.2.1.5-.1v.9l-.9.1h-.5a.9.9 0 0 1-.4-.3 1 1 0 0 1-.1-.5 5.3 5.3 0 0 1 0-.8v-1.8h-.6v-.9h.6v-.8l1.1-.6v1.5h.8zm-5.8 1.2l-1-.2c0-.4.2-.7.5-.9.3-.2.8-.3 1.3-.3s1 0 1.2.2l.5.5.1 1v2l.3.6h-1.2a4.2 4.2 0 0 1 0-.3l-.1-.2a1.9 1.9 0 0 1-1.4.6c-.4 0-.8-.2-1-.4a1.1 1.1 0 0 1-.4-.9 1.1 1.1 0 0 1 .6-1 4 4 0 0 1 1-.3l1.1-.2v-.1l-.1-.5-.7-.1h-.4a.8.8 0 0 0-.3.5zm1.5.9a9 9 0 0 1-.7.2l-.6.1c-.2.1-.3.3-.3.4a.5.5 0 0 0 .2.4l.5.2c.2 0 .4 0 .6-.2l.3-.3v-.8zm-8 2v-5.8h3.4l.9.7c.2.3.3.6.3 1s0 .7-.2 1l-.5.5a1 1 0 0 1-.7.3h-2v2.2h-1.3zm1.2-4.8v1.6h1.7l.3-.4a.7.7 0 0 0 .2-.4.7.7 0 0 0-.2-.5.8.8 0 0 0-.5-.3 6.2 6.2 0 0 0-.9 0h-.6zm2.4 110.6h-.8c0-.3.2-.6.4-.7.2-.2.5-.3.9-.4h.9c.2 0 .3.2.4.3.1.1.2.3.2.7l.2 1 .1.5.2.4-.8.2a3.5 3.5 0 0 1-.1-.3 1.5 1.5 0 0 1-1 .5c-.4 0-.6 0-.9-.2a.9.9 0 0 1-.3-.6.8.8 0 0 1 0-.5.8.8 0 0 1 .3-.3l.7-.3.8-.3v-.1c0-.2-.1-.3-.2-.3h-.5a.6.6 0 0 0-.3 0 .6.6 0 0 0-.2.4zm1.3.5l-.5.2c-.3 0-.4.2-.5.2v.6h.5a.8.8 0 0 0 .4-.1.5.5 0 0 0 .1-.3v-.6zm-2.6-.3l-.8.2a.6.6 0 0 0-.3-.3.6.6 0 0 0-.4 0 .7.7 0 0 0-.5.2v.8c0 .3.1.6.3.7l.6.2a.6.6 0 0 0 .3-.2l.2-.5h.8a1.4 1.4 0 0 1-.3.9c-.2.2-.6.4-1 .4-.5 0-.9 0-1.2-.2a1.6 1.6 0 0 1-.6-1.2c0-.5 0-.9.2-1.2a2 2 0 0 1 1.1-.6l1 .1c.3.1.5.3.6.7zm-4.8-.7v-.8h.8l.1.7-.9.1zm.6 3.5l-.5-3 .9-.2.5 3-.9.2zm-1.7.3l-.7-4.3.8-.1.7 4.2-.8.2zm-3.9.5l-.7-4.3h.9l.2 1.5c.2-.4.5-.6.9-.6s.7 0 1 .3c.3.2.5.6.6 1 .1.6 0 1-.2 1.3a1.3 1.3 0 0 1-1.4.6 1.4 1.4 0 0 1-.6-.4l.1.5-.8.1zm.6-1.7c0 .3.1.5.3.7a.7.7 0 0 0 .6.2.6.6 0 0 0 .5-.3c0-.2.1-.4 0-.8 0-.3-.1-.6-.3-.7a.7.7 0 0 0-.5-.2.7.7 0 0 0-.5.3 1 1 0 0 0-.1.8zm-2.3 2v-.5a1.2 1.2 0 0 1-.4.5l-.6.2h-.6a.8.8 0 0 1-.5-.4l-.2-.7-.3-2h.9l.2 1.4.2.8a.5.5 0 0 0 .2.2.6.6 0 0 0 .3 0 .7.7 0 0 0 .4-.2.6.6 0 0 0 .2-.3v-.8l-.3-1.3.9-.1.5 3-.8.1zm-6.4-2.3h.8v.4a1.2 1.2 0 0 1 1-.7c.4 0 .7 0 1 .3.3.2.5.6.6 1.1 0 .5 0 1-.2 1.3-.2.3-.5.5-1 .5a1.2 1.2 0 0 1-.4 0 1.8 1.8 0 0 1-.5-.3l.2 1.6h-.8l-.7-4.2zm1 1.4c.1.3.2.6.4.7a.7.7 0 0 0 .6.2.6.6 0 0 0 .4-.3c.1-.2.2-.4.1-.8 0-.3-.2-.5-.3-.7a.7.7 0 0 0-.5-.1.7.7 0 0 0-.5.3c-.1.2-.2.4-.1.7zm-2.3 1h1l-.5.7c-.2.2-.5.3-.9.4-.5 0-1 0-1.3-.4a1.7 1.7 0 0 1-.5-1c0-.5 0-.9.2-1.2a1.4 1.4 0 0 1 1-.6c.5 0 1 0 1.3.3.3.2.5.7.6 1.3l-2.2.3c0 .3.2.4.3.5.2.2.4.2.6.2a.5.5 0 0 0 .3-.2.7.7 0 0 0 .1-.3zm0-.9c0-.2-.2-.4-.3-.5a.6.6 0 0 0-.5-.1.6.6 0 0 0-.4.3.7.7 0 0 0-.1.5l1.3-.2zm-6.2 2.8l-.7-4.3 2-.3h1l.6.3.3.7c0 .3 0 .6-.2.8-.2.2-.4.4-.8.5l.5.3.6.6.7.8-1 .1-.9-.8-.5-.6a.7.7 0 0 0-.3 0 1.6 1.6 0 0 0-.5 0h-.2l.3 1.7-.9.2zm.5-2.6l.7-.1.8-.2a.5.5 0 0 0 .2-.2.6.6 0 0 0 0-.3.5.5 0 0 0-.1-.4.6.6 0 0 0-.4 0h-1.4l.2 1.2zm67 .4l-.7-.2c.1-.3.3-.5.5-.6.3-.1.6-.2 1-.1l.9.2.3.4v.8l-.1 1a3.5 3.5 0 0 0 0 .5v.5l-.8-.1v-.3a1.6 1.6 0 0 1-.6.1 1.4 1.4 0 0 1-.6 0 1.1 1.1 0 0 1-.7-.3.8.8 0 0 1-.2-.7.8.8 0 0 1 .6-.7 3 3 0 0 1 .7 0l.9-.2v-.4l-.5-.2a.6.6 0 0 0-.4 0 .6.6 0 0 0-.2.3zm1.1.8l-.5.1h-.5l-.2.3a.4.4 0 0 0 0 .4.5.5 0 0 0 .4.1.8.8 0 0 0 .4 0 .5.5 0 0 0 .3-.3 1.6 1.6 0 0 0 .1-.4v-.2zm-2.9 1.2l-.8-.1.2-1.6v-.7a.4.4 0 0 0-.1-.2.5.5 0 0 0-.3-.2.7.7 0 0 0-.4.1.6.6 0 0 0-.3.3l-.2.7-.2 1.4-.8-.1.4-3.1h.8v.5c.3-.3.7-.4 1.1-.3l.5.1a.8.8 0 0 1 .3.3.9.9 0 0 1 .1.4v.5l-.3 2zm-5.5-3l-.7-.2c.1-.3.3-.5.5-.6h1c.4 0 .7 0 .9.2l.3.3v.8l-.1 1a3.4 3.4 0 0 0 0 .6v.4l-.8-.1a3.2 3.2 0 0 1 0-.3 1 1 0 0 0-.1 0l-.5.2a1.4 1.4 0 0 1-.6 0 1.1 1.1 0 0 1-.7-.4.8.8 0 0 1-.2-.7.9.9 0 0 1 .6-.7h.7l.9-.2v-.4l-.5-.2a.7.7 0 0 0-.4 0 .6.6 0 0 0-.3.3zm1.1.9h-.6l-.4.1c-.2 0-.2.2-.2.3a.4.4 0 0 0 0 .3.5.5 0 0 0 .4.2.8.8 0 0 0 .4-.1.5.5 0 0 0 .3-.3v-.5zm-2.4-1h-.8a.6.6 0 0 0-.2-.4.6.6 0 0 0-.3-.2.7.7 0 0 0-.6.2l-.3.6.1.8c.1.2.3.3.5.3a.6.6 0 0 0 .4 0l.3-.5.8.3c-.1.3-.3.6-.6.8-.3.1-.6.2-1 .1a1.5 1.5 0 0 1-1.1-.6 1.6 1.6 0 0 1-.3-1.2c.1-.5.3-1 .6-1.2.4-.2.8-.3 1.2-.2.4 0 .7.1 1 .3.2.2.3.5.3.8zm-4.3-2v-.8l1 .2-.2.7h-.8zm-.6 3.5l.5-3h.9l-.5 3.1h-.9zm-.8-.1l-.9-.1.2-1.6v-.6a.4.4 0 0 0 0-.3.5.5 0 0 0-.3-.1h-.5c-.2 0-.2.2-.3.3l-.1.7-.2 1.4h-.9l.5-3.2.8.1v.5a1.4 1.4 0 0 1 1.6-.2.8.8 0 0 1 .3.3.9.9 0 0 1 .1.3 2.4 2.4 0 0 1 0 .6l-.3 1.9zm-4.2-4.1l.1-.8.9.1-.1.8-.9-.1zm-.5 3.5l.4-3.1.9.1-.5 3.1-.8-.1zm-5.2-3.9l.8.1v.5c.3-.3.6-.4 1-.4l.5.2.4.4.5-.3h.5c.3 0 .5 0 .6.2a.8.8 0 0 1 .3.4v.7l-.3 2-.8-.2.2-1.7v-.6c0-.2-.2-.2-.3-.3a.6.6 0 0 0-.7.4l-.1.6-.2 1.5-.9-.1.3-1.7v-.6a.4.4 0 0 0-.1-.2.4.4 0 0 0-.3-.1.7.7 0 0 0-.3 0 .6.6 0 0 0-.3.3 2.1 2.1 0 0 0-.2.6l-.2 1.5h-.9l.5-3.2zm-4.2 1a1.6 1.6 0 0 1 1-1.3h1c.4 0 .8.2 1 .6.3.3.4.7.4 1.2a1.6 1.6 0 0 1-.7 1c-.4.4-.8.5-1.3.4a2 2 0 0 1-.8-.3 1.4 1.4 0 0 1-.5-.7v-.9zm.9.2l.1.7c.1.2.3.3.5.3a.8.8 0 0 0 .6-.1l.4-.7c0-.3 0-.6-.2-.8a.7.7 0 0 0-.5-.3.8.8 0 0 0-.6.2c-.2.1-.3.4-.3.7zm-4.8-3.5l1.6.3c.4 0 .7 0 .9.2.2 0 .4.2.6.4.2.3.3.5.3.8a3.2 3.2 0 0 1-.3 2 1.9 1.9 0 0 1-.5.6l-.7.3h-.8l-1.7-.3.6-4.3zm.8.9l-.4 2.8.6.1h.6a.8.8 0 0 0 .4 0c0-.2.2-.3.3-.5l.2-.7v-.8a1 1 0 0 0-.2-.5.9.9 0 0 0-.4-.2 4.4 4.4 0 0 0-.7-.2h-.4z"
      />
    </g>
  </svg>
	),
	DZ: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#fff" d="M320 0h320v480H320z" />
    <path fill="#006233" d="M0 0h320v480H0z" />
    <path
      fill="#d21034"
      d="M424 180a120 120 0 1 0 0 120 96 96 0 1 1 0-120m4 60l-108-35.2 67.2 92V183.2l-67.2 92z"
    />
  </svg>
	),
	EC: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#ffe800" d="M0 0h640v480H0z" />
      <path fill="#00148e" d="M0 240h640v240H0z" />
      <path fill="#da0010" d="M0 360h640v120H0z" />
    </g>
    <g fillRule="evenodd">
      <path d="M269.6 290.8L197 367.3l-1.2-1.6 72.4-76.5 1.2 1.6zm50.4 12.5l-94.8 100-1.6-1.6 94.7-100 1.7 1.6z" />
      <path
        fill="gray"
        stroke="#000"
        strokeWidth={4.1}
        d="M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2h-35.4z"
        transform="matrix(-.07 -.07 -.1 .1 265 429.6)"
      />
      <path
        fill="gray"
        stroke="#000"
        strokeWidth={4.1}
        d="M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2h-35.4z"
        transform="matrix(-.07 -.07 -.1 .1 240.6 390.5)"
      />
    </g>
    <path
      fill="#ffdf00"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M301.2 272.8s-17.7 336.6 53.1 336.6S460.6 574 460.6 574l-.8-185-158.6-116.2z"
      transform="matrix(.45 0 0 .64 72.4 -59.8)"
    />
    <path
      fill="#0000c4"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M344.5 304.2c0 17.7-7.9 269.8 27.5 269.8s88.6-17.7 88.6-17.7l-.8-167.3-115.3-84.8z"
      transform="matrix(.45 0 0 .64 72.4 -59.8)"
    />
    <path
      fill="#e10000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M367.5 321.2c0 17.7 4.5 217.4 40 217.4h53.1l-.8-149.6-92.3-67.8z"
      transform="matrix(.45 0 0 .64 72.4 -59.8)"
    />
    <path
      fillRule="evenodd"
      d="M206.2 116l72.4 76.5 1.3-1.6-72.4-76.5-1.3 1.6z"
    />
    <path
      fill="#ffdf00"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M301.2 272.8S265.8 609.4 372 609.4c88.5 0 88.5-53.1 106.2-53.1l-17.7-124-159.4-159.5z"
      transform="matrix(.58 0 0 .62 9.6 -10.2)"
    />
    <g stroke="#000">
      <path
        fill="none"
        strokeWidth={2.3}
        d="M269.6 155.2c1.1 0 28.3-94 119-147.2"
        transform="matrix(.4 -.03 -.05 .35 135.1 147.4)"
      />
      <path
        fill="#005b00"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z"
        transform="matrix(.14 -.22 .3 .14 175.9 257.4)"
      />
      <path
        fill="red"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z"
        transform="matrix(.18 -.1 .1 .17 177.6 256.7)"
      />
      <path
        fill="#005b00"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z"
        transform="matrix(.18 .12 -.13 .33 181 96.4)"
      />
      <path
        fill="#005b00"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z"
        transform="matrix(.17 -.03 -.03 .33 179.3 159.3)"
      />
      <path
        fill="#005b00"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z"
        transform="matrix(.06 .25 -.17 .2 228 45.5)"
      />
      <path
        fill="#005b00"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z"
        transform="matrix(.2 -.2 .2 .24 150.3 241)"
      />
      <path
        fill="#005b00"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z"
        transform="matrix(.22 -.22 .25 .2 135.6 282.1)"
      />
      <path
        fill="#005b00"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z"
        transform="matrix(.26 .1 -.2 .32 130.8 147.7)"
      />
      <path
        fill="#005b00"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z"
        transform="matrix(.15 .2 -.32 .22 178.5 103.3)"
      />
      <path
        fill="#005b00"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z"
        transform="matrix(.08 .1 -.14 .16 250.7 102.6)"
      />
      <path
        fill="#005b00"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z"
        transform="matrix(.1 0 -.08 .17 238 136.4)"
      />
      <path
        fill="#005b00"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z"
        transform="matrix(0 .14 -.14 .08 287.4 81.1)"
      />
      <path
        fill="#005b00"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z"
        transform="matrix(.07 .1 -.25 .15 220.7 115.6)"
      />
      <path
        fill="#005b00"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z"
        transform="matrix(.13 .22 -.33 .2 207 70.1)"
      />
      <path
        fill="none"
        strokeWidth={2.4}
        d="M269.6 155.2c1.1 0 28.3-94 119-147.2"
        transform="matrix(.35 -.2 .14 .28 111.8 227.8)"
      />
      <path
        fill="red"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z"
        transform="matrix(.18 -.1 .1 .17 200.3 224.6)"
      />
      <path
        fill="red"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z"
        transform="matrix(.18 -.1 .1 .17 211.1 218.3)"
      />
      <path
        fill="red"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z"
        transform="matrix(.2 -.1 .07 .13 166.8 232.7)"
      />
      <path
        fill="red"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z"
        transform="matrix(.2 -.1 .07 .13 170 231.3)"
      />
      <path
        fill="red"
        fillRule="evenodd"
        strokeWidth="1pt"
        d="M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z"
        transform="matrix(.2 -.1 .07 .13 168.1 234.3)"
      />
      <path
        fill="red"
        fillRule="evenodd"
        strokeWidth={0.3}
        d="M252.7 167.3c.4.8 0 1.8-1 2.3s-2 .2-2.4-.7 0-1.8 1-2.3 2-.2 2.3.7z"
      />
      <path
        fill="red"
        fillRule="evenodd"
        strokeWidth={0.3}
        d="M255 164.9c.3.8 0 1.8-1 2.3s-2 .2-2.5-.6 0-1.9 1-2.4 2-.1 2.4.7z"
      />
      <path
        fill="red"
        fillRule="evenodd"
        strokeWidth={0.3}
        d="M255.5 166c.4.8 0 1.9-1 2.3s-2 .2-2.4-.6 0-1.8 1-2.3 2-.2 2.4.6z"
      />
    </g>
    <path
      fill="#0000c4"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M336.6 308.3c0 17.7-35.4 212.6 53.2 265.7 35.4 17.7 88.5-17.7 88.5 0l-17.7-141.7-124-124z"
      transform="matrix(.58 0 0 .62 9.6 -10.2)"
    />
    <path
      fill="#e10000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M372 343.7c0 17.7-17.7 159.4 35.5 194.9 35.4 35.4 124 25.8 124 25.8l-70.9-132.1-88.6-88.6z"
      transform="matrix(.58 0 0 .62 9.6 -10.2)"
    />
    <path
      fillRule="evenodd"
      d="M183.8 158l94.8 100 1.7-1.6-94.8-99.9-1.6 1.6z"
    />
    <path
      fill="#cececc"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M460.6 184.3l17.7 35.4v17.7c-.8-1.3 0 17.7-17.7 17.7S443 219.7 443 219.7s-17.7 35.4-17.7 70.9 17.7 53.1 17.7 53.1-2.6-36.7 17.7-35.4c20.4 1.2 17.7 17.7 17.7 17.7v35.4h17.8V219.7l17.7-35.4-27.2-53.2-26 53.1z"
      transform="matrix(.14 -.14 .1 .1 86.3 192.2)"
    />
    <path
      fill="#cececc"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M557.8 95.7l-26.3 70.8 17.7 53.2-35.4-17.7 35.4 53.1v35.5H567V255l35.5-53.1-35.5 17.7 17.8-53.2-26.9-70.8z"
      transform="matrix(.1 -.16 .14 .1 114 183.8)"
    />
    <path
      fill="#e10000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c0 35.8 20.9 187.8 22.6 191.5.1 4.5-4.8 6.4-7.1.9-6.6-17.4-20.8-160-21.3-193.3-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z"
      transform="matrix(.4 0 0 .3 43.8 69.8)"
    />
    <path
      fill="#0000c4"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z"
      transform="matrix(.38 .1 -.15 .3 76 38.2)"
    />
    <path
      fill="#e10000"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.7}
      d="M186.7 151.5c0 1-1 2-2.2 2-1.2 0-2.2-1-2.2-2s1-1.8 2.2-1.8c1.2 0 2.1.8 2.1 1.8zm-3.2 4c0 17.9 10.5 93.9 11.3 95.8 0 2.2-2.3 3.2-3.5.4-3.3-8.7-10.4-80-10.7-96.6-.1-6.9 1.9-7.4 4.2-7.3 1.9.1 4.1 1.9 4.1 4 0 2.4-2.9 4.3-5.4 3.7z"
    />
    <path
      fill="#0000c4"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z"
      transform="matrix(.48 .15 -.2 .48 16.7 31.6)"
    />
    <g fillRule="evenodd">
      <path d="M370.4 290.8l72.5 76.5 1.3-1.6-72.5-76.5-1.3 1.6zM320 303.3l94.8 100 1.6-1.6-94.7-100-1.7 1.6z" />
      <path
        fill="gray"
        stroke="#000"
        strokeWidth={4.1}
        d="M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2h-35.4z"
        transform="matrix(.07 -.07 .1 .1 375 429.6)"
      />
      <path
        fill="gray"
        stroke="#000"
        strokeWidth={4.1}
        d="M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2h-35.4z"
        transform="matrix(.07 -.07 .1 .1 399.4 390.5)"
      />
    </g>
    <g fillRule="evenodd" strokeWidth="1pt">
      <path
        fill="#ffdf00"
        stroke="#000"
        d="M301.2 272.8s-17.7 336.6 53.1 336.6S460.6 574 460.6 574l-.8-185-158.6-116.2z"
        transform="matrix(-.45 0 0 .64 567.6 -59.8)"
      />
      <path
        fill="#0000c4"
        stroke="#000"
        d="M344.5 304.2c0 17.7-7.9 269.8 27.5 269.8s88.6-17.7 88.6-17.7l-.8-167.3-115.3-84.8z"
        transform="matrix(-.45 0 0 .64 567.6 -59.8)"
      />
      <path
        fill="#e10000"
        stroke="#000"
        d="M367.5 321.2c0 17.7 4.5 217.4 40 217.4h53.1l-.8-149.6-92.3-67.8z"
        transform="matrix(-.45 0 0 .64 567.6 -59.8)"
      />
      <path d="M433.8 116l-72.4 76.5-1.3-1.6 72.4-76.5 1.3 1.6z" />
      <g fill="#005b00" stroke="#000">
        <path
          d="M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z"
          transform="matrix(.16 -.07 .08 .35 309.5 211)"
        />
        <path
          d="M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z"
          transform="matrix(.2 -.05 .07 .4 291.5 182.6)"
        />
        <path
          d="M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z"
          transform="matrix(.23 .14 -.03 .4 296.5 69.4)"
        />
        <path
          d="M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z"
          transform="matrix(.25 .03 .02 .44 274.4 115)"
        />
        <path
          d="M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z"
          transform="matrix(.18 .17 -.04 .35 330 67)"
        />
        <path
          d="M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z"
          transform="matrix(.23 0 .03 .4 280.6 141.9)"
        />
        <path
          d="M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z"
          transform="matrix(.2 -.07 .07 .38 290.1 196.8)"
        />
        <path
          d="M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z"
          transform="matrix(.2 -.03 .05 .4 292.7 166.8)"
        />
        <path
          d="M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z"
          transform="matrix(.22 .15 -.05 .38 305 65.5)"
        />
        <path
          d="M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z"
          transform="matrix(.24 .05 0 .44 278.9 97.7)"
        />
        <path
          d="M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z"
          transform="matrix(.17 .17 -.06 .33 339 70)"
        />
        <path
          d="M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z"
          transform="matrix(.24 .02 0 .4 276.4 128)"
        />
      </g>
      <path
        fill="#ffdf00"
        stroke="#000"
        d="M301.2 272.8S265.8 609.4 372 609.4c88.5 0 88.5-53.1 106.2-53.1l-17.7-124-159.4-159.5z"
        transform="matrix(-.58 0 0 .62 630.4 -10.2)"
      />
      <path
        fill="#0000c4"
        stroke="#000"
        d="M336.6 308.3c0 17.7-35.4 212.6 53.2 265.7 35.4 17.7 88.5-17.7 88.5 0l-17.7-141.7-124-124z"
        transform="matrix(-.58 0 0 .62 630.4 -10.2)"
      />
      <path
        fill="#e10000"
        stroke="#000"
        d="M372 343.7c0 17.7-17.7 159.4 35.5 194.9 35.4 35.4 124 25.8 124 25.8l-70.9-132.1-88.6-88.6z"
        transform="matrix(-.58 0 0 .62 630.4 -10.2)"
      />
      <path d="M456.2 158l-94.8 100-1.7-1.6 94.8-99.9 1.7 1.6z" />
      <path
        fill="#cececc"
        stroke="#000"
        d="M460.6 184.3l17.7 35.4v17.7c-.8-1.3 0 17.7-17.7 17.7S443 219.7 443 219.7s-17.7 35.4-17.7 70.9 17.7 53.1 17.7 53.1-2.6-36.7 17.7-35.4c20.4 1.2 17.7 17.7 17.7 17.7v35.4h17.8V219.7l17.7-35.4-27.2-53.2-26 53.1z"
        transform="matrix(-.14 -.14 -.1 .1 553.7 192.2)"
      />
      <path
        fill="#cececc"
        stroke="#000"
        d="M557.8 95.7l-26.3 70.8 17.7 53.2-35.4-17.7 35.4 53.1v35.5H567V255l35.5-53.1-35.5 17.7 17.8-53.2-26.9-70.8z"
        transform="matrix(-.1 -.16 -.14 .1 526 183.8)"
      />
      <path
        fill="#e10000"
        stroke="#000"
        d="M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c0 35.8 20.9 187.8 22.6 191.5.1 4.5-4.8 6.4-7.1.9-6.6-17.4-20.8-160-21.3-193.3-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z"
        transform="matrix(-.4 0 0 .3 596.3 69.8)"
      />
      <path
        fill="#0000c4"
        stroke="#000"
        d="M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z"
        transform="matrix(-.38 .1 .15 .3 564 38.2)"
      />
      <path
        fill="#e10000"
        stroke="#000"
        strokeWidth={0.7}
        d="M453.4 151.5c0 1 1 2 2.1 2 1.2 0 2.2-1 2.2-2s-1-1.8-2.2-1.8c-1.2 0-2.1.8-2.1 1.8zm3 4a1152 1152 0 0 1-11.2 95.8c0 2.2 2.3 3.2 3.5.4 3.3-8.7 10.4-80 10.7-96.6.1-6.9-1.9-7.4-4.2-7.3-1.9.1-4.1 1.9-4.1 4 0 2.4 2.9 4.3 5.4 3.7z"
      />
      <path
        fill="#0000c4"
        stroke="#000"
        d="M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z"
        transform="matrix(-.48 .15 .2 .48 623.3 31.6)"
      />
    </g>
    <g fillRule="evenodd" stroke="#000" strokeWidth="1pt">
      <path
        fill="#e10000"
        d="M478.4 698a53.3 53.3 0 0 0 53.1 0V556.3h-35.4c17.7 53.1 17.7 106.3-17.8 141.7z"
        transform="matrix(.58 0 0 .62 9.6 -10.2)"
      />
      <path
        fill="#0000c4"
        d="M513.8 609.5c0 88.5-42.5 108.2-42.5 126 17.7 0 29.5-8.3 42.5-19.7 17.7-17.8 19.4-107.7 17.7-106.3h-17.7z"
        transform="matrix(.35 0 0 .7 123.5 -90)"
      />
      <path
        fill="#0000c4"
        d="M478.4 609.5c-.9 51.7-44.8 99.6-36.5 110.2 9.4 9.5 36.5-21.7 71.9-4 17.7-17.7 19.4-107.6 17.7-106.3h-53.1z"
        transform="matrix(.35 0 0 .7 123.5 -90)"
      />
      <path
        fill="#ffdf00"
        d="M513.8 609.5c0 88.5-40.7 94.4-40.7 118 17.7 0 40.6-12.9 40.7-11.7 17.7-17.8 19.4-107.7 17.7-106.3h-17.7z"
        transform="matrix(.35 0 0 .46 112.5 51)"
      />
      <path
        fill="#ffdf00"
        d="M478.4 609.5c-.9 51.7-43.8 95.7-35.5 106.3 9.5 9.4 35.5-17.8 70.9 0 17.7-17.8 19.4-107.7 17.7-106.3h-53.1z"
        transform="matrix(.35 0 0 .46 112.5 51)"
      />
      <path
        fill="#e10000"
        d="M478.4 698a53.3 53.3 0 0 0 53.1 0V556.3h-35.4c17.7 53.1 17.7 106.3-17.8 141.7z"
        transform="matrix(-.58 0 0 .62 630.4 -10.2)"
      />
      <path
        fill="#0000c4"
        d="M513.8 609.5c0 88.5-42.5 108.2-42.5 126 17.7 0 29.5-8.3 42.5-19.7 17.7-17.8 19.4-107.7 17.7-106.3h-17.7z"
        transform="matrix(-.35 0 0 .7 516.5 -90)"
      />
      <path
        fill="#0000c4"
        d="M478.4 609.5c-.9 51.7-44.8 99.6-36.5 110.2 9.4 9.5 36.5-21.7 71.9-4 17.7-17.7 19.4-107.6 17.7-106.3h-53.1z"
        transform="matrix(-.35 0 0 .7 516.5 -90)"
      />
      <path
        fill="#ffdf00"
        d="M513.8 609.5c0 88.5-40.7 94.4-40.7 118 17.7 0 40.6-12.9 40.7-11.7 17.7-17.8 19.4-107.7 17.7-106.3h-17.7z"
        transform="matrix(-.35 0 0 .46 527.5 51)"
      />
      <path
        fill="#ffdf00"
        d="M478.4 609.5c-.9 51.7-43.8 95.7-35.5 106.3 9.5 9.4 35.5-17.8 70.9 0 17.7-17.8 19.4-107.7 17.7-106.3h-53.1z"
        transform="matrix(-.35 0 0 .46 527.5 51)"
      />
    </g>
    <g fillRule="evenodd" stroke="#000">
      <path
        fill="#908f8a"
        strokeWidth={4.5}
        d="M198.6 78l-89.7 35.4 89.7 35.4 44.8-17.7 22.4 17.7 22.4 35.4 22.5-35.4 22.4-17.7H1535V95.7H333l-22.4-17.8c0-17.7 4.7-35.4 22.5-35.4h89.6c0-17.7-44.8-53.1-134.5-53.1-89.6 0-134.5 35.4-134.5 53.1h89.7c17.7 0 22.4 17.7 22.4 35.5l-22.4 17.7-44.9-17.8z"
        transform="matrix(.12 0 0 .22 217.8 324.4)"
      />
      <path
        fill="#b74d00"
        strokeWidth={1.8}
        d="M204.3 95.7H541v17.7H204.4zm0-17.8H541v17.8H204.4zm0-17.7H541V78H204.4zm0-17.7H541v17.7H204.4zm0-17.7H541v17.7H204.4zm0-17.8H541v17.8H204.4zm0-17.6H541V7H204.4z"
        transform="matrix(.28 0 0 .27 216 334.6)"
      />
      <path
        fill="#908f8a"
        strokeWidth={3.3}
        d="M423.2 60.2l137.8 124h19.7L443 60.3h-19.7z"
        transform="matrix(.25 0 0 .27 171.9 315.2)"
      />
      <path
        fill="#908f8a"
        strokeWidth={3.3}
        d="M423.2 60.2l137.8 124h19.7L443 60.3h-19.7z"
        transform="matrix(.25 0 0 -.27 171.9 382.2)"
      />
      <path
        fill="#908f8a"
        strokeWidth={3.1}
        d="M425.2 60.2v124h17.7v-124h-17.7z"
        transform="matrix(.28 0 0 .27 159.6 315.2)"
      />
      <path
        fill="#908f8a"
        strokeWidth={3.3}
        d="M423.2 60.2l137.8 124h19.7L443 60.3h-19.7z"
        transform="matrix(.25 0 0 .27 216.2 315.2)"
      />
      <path
        fill="#908f8a"
        strokeWidth={3.3}
        d="M423.2 60.2l137.8 124h19.7L443 60.3h-19.7z"
        transform="matrix(.25 0 0 -.27 216.2 382.2)"
      />
      <path
        fill="#908f8a"
        strokeWidth={3.1}
        d="M425.2 60.2v124h17.7v-124h-17.7z"
        transform="matrix(.28 0 0 .27 238.4 315.2)"
      />
      <path
        fill="#908f8a"
        strokeWidth={3.1}
        d="M425.2 60.2v124h17.7v-124h-17.7z"
        transform="matrix(.28 0 0 .27 204 315.2)"
      />
      <path
        fill="#908f8a"
        strokeWidth={3.1}
        d="M425.2 60.2v124h17.7v-124h-17.7z"
        transform="matrix(.28 0 0 .27 194 315.2)"
      />
    </g>
    <g fill="#ffdf00" fillRule="evenodd" stroke="#000" strokeWidth="1pt">
      <path
        d="M655.5 396.9c0 88-55.6 159.4-124 159.4s-124-71.4-124-159.4 55.5-159.5 124-159.5 124 71.4 124 159.4zm-17.7 0c0 78.2-47.6 141.7-106.3 141.7-58.7 0-106.3-63.5-106.3-141.7 0-78.3 47.6-141.8 106.3-141.8 58.7 0 106.3 63.5 106.3 141.8z"
        transform="matrix(.58 0 0 .62 9.6 -10.2)"
      />
      <path
        d="M579.8 250c-14.9-8.1-31.2-12.6-48.3-12.6s-33.4 4.5-48.3 12.5l7 16.4a82.8 82.8 0 0 1 82.7 0l6.9-16.4z"
        transform="matrix(.58 0 0 .62 9.6 -10.2)"
      />
      <path
        d="M579.8 250c-14.9-8.1-31.2-12.6-48.3-12.6s-33.4 4.5-48.3 12.5l7 16.4a82.8 82.8 0 0 1 82.7 0l6.9-16.4z"
        transform="matrix(.58 0 0 -.62 9.8 479.3)"
      />
    </g>
    <path
      fill="#a7cfff"
      fillRule="evenodd"
      d="M379.6 235.9c0 48.5-27.7 87.8-61.7 87.8s-61.6-39.3-61.6-87.8 27.6-88 61.6-88 61.7 39.4 61.7 88z"
    />
    <path
      fill="#afff7b"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M637.8 396.9c1.1 26.6-4.6 39.6-11.9 67.3-1.9 3-11-6.5-16.4-11.2s-7.8 4.2-14.6-3c-6.7-7.4-11 2-16-4.2s-51.3-7-51.3-7.6c4.6-2.2 28.2.2 24.4-11.1-4.3-11.8-31-.4-34.6-15.4-2.5-15-53.6-15.6-57.3-19.2 1.5 5.6 39.8 8 38.9 22.5-.9 6-37.7 7.7-41.3 12.7-3 6.3 29-1.7 30.1 6 0 3.2-4.7 0-21.3 5-8.4 2.5 15.4 10.3 6.4 14.6-9 4.3-28.3 6.2-27.5 8 3 9 44.7 19.6 40.6 21.1-14.8 6.6-22.6 10.9-29.7 14.7a167.9 167.9 0 0 1-31.1-100.2c31.7-11.4 25-13.8 83.6-13.8s78 2.3 129 13.8z"
      transform="matrix(.58 0 0 .62 9.6 -10.2)"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M637.8 396.9c-8 0-16.4 3.4-25 3.4-8.7 0-17.5-3.5-26.5-3.5s-19.3 4.6-28.5 4.6c-9.3 0-17.4-4.5-26.7-4.5s-18.6 3.4-27.8 3.4-18.3-3.5-27.2-3.5-17.7 3.5-26.2 3.5-16.8-3.5-24.7-3.5c0-19.5 3-38.1 8.4-55.1 27 2 11-15.7 27-15.7a33 33 0 0 1 25.3 9.8c2.4 0 14.4-11.4 27.9-9.8 13.4 1.6 8.5 27.3 26.4 28.6 9 6.8 14.3 11.1 26.7 13.9 17.7 1.6 68.4-2.5 68.7-.2a188.2 188.2 0 0 1 2.2 28.6z"
      transform="matrix(.58 0 0 .62 9.6 -10.2)"
    />
    <path
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M549.9 474c0-5.7 13.5-9.5 13.5-18.6s-12-9.3-12.4-17.8c-.2-3.5 10.3-7 14.9-7.4s8.5 7.4 8.5 9.1-4.7-4.2-8.6-4.3-12.3.6-12.3 2.3c0 3.4 14.8 7.6 13.7 19-1.1 11.2-12.7 14.6-12.7 18s5 12.8 5 12.8-9.7-7.5-9.7-13.2z"
      transform="matrix(.2 0 0 .48 217.2 59.5)"
    />
    <path
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M549.9 474c0-5.7 13.5-9.5 13.5-18.6s-12-9.3-12.4-17.8c-1-4 11.8-6.6 16.4-6.9s10 8 10 9.6-5.4-5.2-9.3-5.3-14.6.6-14.6 2.3c0 3.4 14.8 7.6 13.7 19-1.1 11.2-12.7 14.6-12.7 18s5 12.8 5 12.8-9.7-7.5-9.7-13.2z"
      transform="matrix(-.2 0 0 .48 445.8 59.1)"
    />
    <path
      fillRule="evenodd"
      d="M333 264.9c0 1.3-.7 2.4-1.5 2.4s-1.4-1.1-1.4-2.5.6-2.4 1.4-2.4c.8 0 1.5 1.1 1.5 2.5zm17 9h.4v19.5h-.5zm4.1-1.6h.5V292h-.5z"
    />
    <path fillRule="evenodd" d="M352.6 281.2v-.5l4 .7v.5z" />
    <path
      fill="#b74d00"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M497.3 478s26 11.4 31.7 18.2c5.6 6.8 3.4 6.8 3.4 6.8l57.7 2.3c0-3.4 10.2-3.4 12.5-11.4 2.3-7.9 2.3-10.2 2.3-10.2l-18.1 5.7 1-10.2H572l-2.3 10.2-34-1.1L538 461l-6.8 1.1-1 26c-1.2 0-31.8-7.9-33-10.1z"
      transform="matrix(.58 0 0 .62 7 -9.5)"
    />
    <path
      fill="#fede00"
      fillRule="evenodd"
      stroke="#fede00"
      strokeWidth="1pt"
      d="M440.5 316.3s37.7-11.2 92.1-10.4 92.1 12.8 91.3 12.8-10.4-18.4-10.4-18.4-38.4-10.5-81.7-11.3c-43.2-.8-80.9 8-80 8.8l-11.3 18.5z"
      transform="matrix(.58 0 0 .62 9.6 -10.2)"
    />
    <path
      fill="#38a9f9"
      fillRule="evenodd"
      d="M306 169.8l13.6-.2.2 7.9-13.6.3zm-31.2 4.3L270 182l16.2-2-1.3-7.7-10.1 2zm13.7-3l13.6-1.1.6 7.8-13.5 1.2zm48.9-.7l-13.5-1-.5 8 13.5.8zm29.2 5l4.9 9.6-14.6-3.6 1.6-7.7 8 1.6zm-11.8-3l-13.4-1.7-1 7.8 13.5 1.8z"
    />
    <path
      fill="#ffdf00"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M532.6 323.5l-2.5-13.5-7.6 11.5 2.8-13.5-11.3 7.7 7.6-11.3-13.4 2.8 11.5-7.6-13.5-2.5 13.5-2.6-11.5-7.6 13.4 2.8-7.7-11.3 11.4 7.7-2.8-13.5 7.6 11.5 2.5-13.5 2.6 13.5 7.5-11.5-2.7 13.5 11.3-7.7-7.7 11.3 13.5-2.8-11.5 7.6 13.5 2.6-13.5 2.5 11.5 7.6-13.5-2.8 7.7 11.3L540 308l2.8 13.5-7.6-11.5z"
      transform="matrix(.58 0 0 .62 9.6 -10.2)"
    />
    <path
      fill="#ffdf00"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M547 293.9c0 9.3-6.6 16.8-14.8 16.8s-14.8-7.5-14.8-16.8S524 277 532.2 277s14.8 7.6 14.8 17z"
      transform="matrix(.57 0 0 .5 18.3 21.8)"
    />
    <path
      fillRule="evenodd"
      d="M320.7 170.6c0 .5-1.3 1-2.8 1s-2.8-.5-2.8-1 1.2-1 2.8-1 2.8.4 2.8 1zm6 0c0 .5-.9 1-2 1s-2.2-.5-2.2-1c0-.6 1-1 2.1-1s2.1.4 2.1 1z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth="1pt"
      d="M529.4 297.9l.8.8c-1.9-2-1-1.2 1.6 3.2 2.4-.5 3.1-1.4 4.8-2.4"
      transform="matrix(.56 -.18 .17 .6 -26.7 90.6)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth="1pt"
      d="M527.8 304.3l.8.8c-1.9-2-1-1 3.2 1.6 4 .5 8.1-1.2 10.5-4"
      transform="matrix(.58 0 0 .62 8.7 -10.2)"
    />
    <path
      fill="#b7e1ff"
      fillRule="evenodd"
      d="M281.4 194.8s1 8-5.1 18c-6 9.9-5.1 6.4-5.1 6.4s2.8 5.5 2.3 5.5-4.7-5-4.7-5l-5 5.5s4.6-8.5 4.1-8.5-1.4-3-1.4-3l3.7-1.5s5.6-10.4 5.6-9.9-16.7 11.4-16.7 11.4l22.3-18.8zm3.7 3c-.5 0 2.3 8 4.7 12 2.3 4 2.3 8.9 2.3 8.9l7.9 4-10.2-15.4 6.5 2.4-11.2-11.9zm0 20.9s5.6 6 6 8 .5 6.4.5 6.4l-2.3-5-3.3 4.5s2.4-7 1.9-7.5-3.7 2.5-3.7 2.5 1.4-4 1.4-4.4 0-3-.5-4.5zm-27.9 13.9c1.9-1.5 5.6-2.5 5.6-2.5s-2.3 4-2.8 4-1.8 0-2.8-1.5zm64.1-21.8s12.1 7.4 12.1 7.9-7.9-3.5-7.9-3.5l-4.2-4.4zm-21.8-15.5c1 .5 17.7 14.4 17.2 14.4s-7.4-4-7.4-3.4v3.4l-3.8-7.9-.9 3-5-9.5zm4.2 22.4l4.6 9.4 4.7-1s-8.8-8.4-9.3-8.4zm14.4-6l.5 9s2.7 2.5 2.7 2-2.7-10.5-3.2-11z"
    />
    <path
      fill="#984000"
      fillRule="evenodd"
      d="M182.6 89.5s21-11.6 44.9-20.2a303.8 303.8 0 0 1 54.2-14.4c7 0 19.2 17.8 21.2 17.8s10.1-5 20.3-5 16.1 8 18.2 8h18.2c2 0-6.1-19.8 0-18.8 3 .5 28.8 4.5 52.8 12.2 24 7.8 58 21.6 58 21.6S414.9 98 400 95.9c-2 1 0 13-3 7.7-4.6-1-21.7-3.7-24.7-3.7s-8.7 3.4-16.8 5.4c-8 2-18.2 5-18.2 5l13.2 20.7-16.2 8s-10.1-23.8-14.2-23.8-6 16.8-11.1 15.8c-5-1-7-15.8-11.1-19.8-4-3.9-25.4-5.4-33.5-7.3-8-2-21.1-3.5-28.2-5.5-7-2-14.2 5-17.2 5s4-6 1-7-5 3-7 3-23.3-4-25.3-5 5-4.9 3-4.9h-8.1z"
    />
    <path
      fill="gray"
      fillRule="evenodd"
      stroke="#772600"
      strokeWidth={3.7}
      d="M463-65c0 21.2-20.6 38.4-45.9 38.4S371.3-43.8 371.3-65s20.5-38.3 45.8-38.3S463-86.1 463-65z"
      transform="matrix(.22 0 0 .26 231.6 96.5)"
    />
    <path
      fill="#984000"
      fillRule="evenodd"
      stroke="#772600"
      strokeWidth={5.3}
      d="M284.7-60c6.7-6.6 15-16.6 36.7-16.6 5-1.7 5-11.7 16.6-11.7 11.7 0 8.3 10 16.7 13.4 8.3 3.3 76.6-3.4 76.6-3.4s6.6 5 6.6 11.7-5 11.6-6.6 11.6-68.3-5-73.3-3.3c-5 1.7-8.3 3.3-20 3.3-11.6 0-15-11.6-23.3-11.6s-16.6-1.7-30 6.7z"
      transform="matrix(.27 0 0 .32 205.4 100.7)"
    />
    <path
      fill="none"
      stroke="#772600"
      strokeWidth={3.5}
      d="M487.9-76.6h26.6c9.6.1 12.9 3 21.7 3.3h23.3c8.5-.3 13-2.3 21.6-3.3 14.5-.2 9.6-1.3 6.7-10-2.6-6.5-3-9.6-6.7-13.3-1.4-8-4.6-10.8-5-20-1.5-7-4.3-11.7-1.6-20 3.8 5.7 5.3 8 15 8.4 10 0 13.9-.3 20 3.3 4.6 4.9 10.8 3.3 20 3.3 7.6 1.4 8.9 5.3 14.9 8.3 7.1 4 11.7 5 21.6 5 8 1.5 15 2.6 20 5 4.3 5.1 11 6.4 20 6.7 5 0 9-.5 13.3-1.7 7.7.4 15.5 0 25 0 6.2 7.2 7.6 9.9 18.3 10 7.4 5.2 13.6 6 20 8.3h25c9 .7 11.8 4.4 20 6.7a200.9 200.9 0 0 0 21.6 8.3 108 108 0 0 0 21.7 1.7c6.1 3.2 13.6 3.4 18.3 6.6 6.9 1.5 16.3 3.3 21.6 5 8.8 1.2 12.2 4 20 5 6.7 2-2.2 3.6-6.7 5-9.8-.3-10.5-4-20-5-5-2.9-12.6-2.5-20-5h-1.6c6.6 4 13 6.5 10 13.4-8.5 0-15.4-1.1-23.3-1.7-8.4-1.6-12.2-3.3-21.6-3.3 9.4-2.3 11.8.2 18.3 3.3 2.4 8-2.8 5-11.7 5-7.6-2.7-12.2-6-21.6-6.7h-20c9.9.4 12 4.1 18.3 8.4.5 2.6-.1 2.4-5 3.3-5.2-4.5-11.9-6-20-8.3-7.9-.3-16.2-1-23.3-3.4-4.9-.3-4.1-6.1 6.7 3.4 6.5 3.8 8.8 7 8.3 10-8.6-2.2-12.8-5.6-18.3-8.4a61.3 61.3 0 0 0-23.3-3.3c-8.6-2.3.9-3.6 6.6 5 12.4 8.8-1.6 5-6.6 3.3-7.5-2.1-15.3-5.2-21.7-6.6-5-1.5-9.4-2.9-15-3.4 8.7.8 11.6 3.9 15 10 8.8 6-.4 3.1-8.3 1.7-5-4.4-11.5-6.7-15-11.7-8.3-4.1-8.6-9-3.3 1.7 1.3 3.4 1 10.8 1.6 11.7-6.1-6.7-4.8-8.4-11.6-8.4-4.7-3.2-11.5-5.7-15-10-6.4-.6-6.8-2.9-13.3-5 5.3 6.3 12.4 12.5 16.6 18.4 7.6 4.2 9.7 8 15 11.6 2.1 3.7 8 6.7 1.7 1.7-7.2-7-12.5-8.7-23.3-13.3-6.2-5-8.4-7-15-11.7-9-2.9-5.5-4.5 0 5 6.3 5.8 11.1 12.2 16.6 16.7a67.8 67.8 0 0 0 15 13.3c1.5 2.2 6 2.6 0 3.3-5-4.6-12.4-7.5-18.3-11.7-8.3-2.3-12.2-6.6-18.3-11.6-4-5.9-10.4-10.4-15-15-9.6-3.8 1.9 3.6 5 8.3 2.1 6.1 4.8 11 6.6 16.7 2.8 5.5-8.4-1.3-11.6-3.3a57 57 0 0 0-21.7-8.4 298 298 0 0 0-20-3.3c-7.5-2 4.1 4.8 8.4 11.7 8.4 7.9-8.3 1.4-13.3 0a125 125 0 0 0-25-1.7c-10.7.6-3 2 0 6.6 3.3 2.6 5.6 8 5 10-7-1-13-3-21.7-3.3-7 2.3-15.3 1.7-23.3 1.7-.3 4.2 1.5.6 5 5 5.8 2.3 9.6 5.1 8.4 8.3h-48.3c-5.3 1.4 1.1.7 5 6.7-2.2 5.4-5 3.3-11.7 3.3-4.5-1.8-13.6-2.6-18.3-5-4.7 0-4.3-1.2-8.3-1.7 14 10 7 7.5 15 15 1.3.5 4.5 1.7 1.6 1.7M371.3 73.3c-1 0-3.2-5.4-6.6-10-2.4-6-5.4-2.6-8.4-11.7.4-9.4.7-11 0-20-6.8-4.8-9.7-6.2-15-15-8.4-7 1.3-19 2.9-27.8-7.4-1.6-11 11.5-22.3 16.2-8.2 5.5-1-11.4-5-21.2-2.7-13.9-10.8 7-13.8 12.9-5.5 3.7-7.2 8.5-15 1.6 0-5.1 4.9-19.5 2.8-22.3-7.8 3.9-18 15.5-26.1 17.3-8.2-1.7 1.7-14.8 1.7-24.5-3-1-14.7 25.8-19.5 26s-2.7-26-5-25.4c-3.5 5-10.6 15.4-15.5 19-9.5-1.3 1.4-17.5 2.8-23.5 1.6-7.2-8.9 13.8-14.5 15.1-4.1 3.6-12.2 6-15 6.7 3.2-6.2 19-18.7 18-22.3-9.3.3-23.4 12.5-31.3 14-5.2 0-12.4 1.7-13.3 1.6.4-8 19.4-14.6 22.4-19.5-9.3 1.5-27.2 9.7-32.4 16.2-6.2 1.3-14 3-20 0 .9-7.5 14.9-22 18-26.8-8.5 3.7-12.7 6.6-21.7 8.3-1.7 1.7-6.5 5.3-5 1.7 2.7-7 6.7-10 10-15-7.5 1.4-10.3 5.7-18.3 10-5.1.2-19.7 14.9-24.6 15.1a69.1 69.1 0 0 1-28.3 13.3c-7.6 1.4-11.3 3-15 6.7 3.8-6.7 9.6-13 15-16.6a29.8 29.8 0 0 1 15-13.4c1.9-2.3 7.1-2.9 1.6-3.3-4.7 4.2-12.7 9-16.6 11.7-5.1 3.2-11 6.4-13.4 5 2.7-7.2 7.5-9 11.7-15 8.8-5.6 0-2-6.7 0-4.3 3.8-12 6.7-18.3 10-7 1.8-11.7 6-20 8.3 0 2.4 2.4-4.3 3.4-6.7 6.8-7.4 8.6-9.5 16.6-11.6 2-2.9 4.4-1.7-1.6-1.7-4.6 4-10.8 6.2-16.7 10-5.9 1.3-13.6 1.7-21.6 1.7-10.4 1.2-9.5 2 0-3.4 5.3-5 9.7-3.7 10-10-6.3 4.6-14 8-21.7 11.7-6.4.2-8.1 1.7-15 1.7 3.3-3.4 5.3-7.7 10-10 7-7.7-4.4-1.5-6.7 0h-25c-4.4 5.6-.2 0 3.4-3.4 4.3-2.2 8.8-5.1 8.3-6.6-5 4.3-10.7 6.3-15 10-4.6 1.4-10 2-10 3.3 3.7-5.3 9.6-8.6 13.4-13.3 5.6-1.2 10.4-3 11.6-5h-23.3 16.6c8.5 0 15.7-.8 23.4-1.7 13.2-2.2-1.2-3.3-8.4-3.3-1.3-2.6 4.2-4 10-5C-6.7-69-.4-71.1 5-73.3a45.2 45.2 0 0 0 13.3-6.6c-5 .2-5 1.4-10 1.6 7.5-.5 12.8-1.6 21.7-1.6a239 239 0 0 0 21.6-8.3c3-3.6 4.2-3.4-3.3-3.4 6.7-2.1 16.2-3.2 21.6-5a94 94 0 0 0 20-6.6c4.9-3.3 7.7-7.2 13.3-10 6.5 4.4 6.6 5 18.3 5 9.4-.1 15.2-2.4 20-6.7 7.2-2 8.5-5.4 16.7-6.6a134 134 0 0 0 23.3 1.6c8-2.1 15.7-6 21.6-10 5.1-2.5 11.2-6.1 16.7-8.3 6 3.1 10.8 5.6 18.3 6.7 7.7-1.2 11.8-5 18.3-6.7a28 28 0 0 1 15-8.3c9.7-4.8 9 1.5 13.3 6.6 5 5.2 11.4 2.7 18.3 5 3.9 6 6.7 10 11.7 13.3 3.9 4.8 8.5 6 16.7 6.7 3 4 .6 6.8 6.6 8.3 2.4 2.6 6.5 3.6 10 5"
      transform="matrix(.27 0 0 .32 205.4 104.9)"
    />
    <path
      fill="none"
      stroke="#782600"
      strokeWidth={3.1}
      d="M468.7 30.8v.8c0-2.3 0-1 1.7 3.4.6 3.6-.8 3.2-2.5 5.8-.3 3.7-.8 6.4-.8 10.8-.6 3.6-2.6 7-4.2 10-1.6 3.1-8.5 4.9-8.3 9.2-4 1.1-4.1-1.5-4.2-5.9-2.4-2.7-3.2-6.4-5-10-1-3.4-3.4-6-5-10-2.4-3.7-4.5-4.8-6.6-9.1-.9-2-.7-4.6-2.5-5.8-2.7-3.5-4.5-4-9.2-4.2-3.6.8-5 2.4-8.3 3.3-2.6.9-7.6.6-10.8 1.7-.8 1.3 1.6 2 2.5 5-2.2 1.8-3 4.9-4.2 7.5-2 2.5-3.3 3.7-4.2 7.5 1.4 2.3.2 5.4-1.6 7.5-.6 3.8-2.5 5.9-3.4 9.1-2.6 1.9-3.6 3.6-5.8 6.7-1.9 2.7-3.6 2.5-8.3 2.5-3.7-1-4.2-3-7.5-4.2-.3-1-.6-1.3-1.7-1.6"
      transform="matrix(.27 0 0 .32 205.4 104.9)"
    />
    <path
      fill="#812e00"
      fillRule="evenodd"
      d="M307.6 125.5s-.4 5-3.6 8.3-9.8 7.1-9.8 7.1 8.9-4.2 9.8-3.3c1 1-5.7 8.3-5.7 8.3s8.7-7.7 9.8-7.7 3.6 7.5 4.6 7.3c.9-.2-2-9.5-1.6-11 .4-1.4 0-9.3 0-9.3l-3.4.3zm20.5-.6s-.4 5.3-3.6 8.8-9.8 7.6-9.8 7.6 8.9-4.5 9.8-3.5c1 1-5.7 8.8-5.7 8.8s8.7-8.2 9.8-8.2 3.6 8 4.6 7.8c.9-.2-2-10.2-1.6-11.7.4-1.6 0-10 0-10l-3.5.4zm-28.7-48c0 .9-1 1.7-2.1 1.7s-2.2-.8-2.2-1.8 1-1.8 2.2-1.8 2.1.8 2.1 1.8z"
    />
  </svg>
	),
	EE: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <rect width={640} height={477.9} rx={0} ry={0} />
      <rect width={640} height={159.3} y={320.7} fill="#fff" rx={0} ry={0} />
      <path fill="#1291ff" d="M0 0h640v159.3H0z" />
    </g>
  </svg>
	),
	EG: () => (
  <svg viewBox="0 0 640 480">
    <path d="M0 320h640v160H0z" />
    <path fill="#fff" d="M0 160h640v160H0z" />
    <path fill="#ce1126" d="M0 0h640v160H0z" />
    <g fill="#fff" stroke="#c09300" transform="matrix(.8 0 0 .8 -40 0)">
      <path
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M450.8 302.4l68.5 63.6-4.9-115.5c-.7-17.5-15.9-13.5-27-7.2-11.1 7.2-24 7.2-37.4 2.5-13.5 4.7-26.3 4.7-37.4-2.5-11-6.3-26.3-10.3-27 7.2L380.7 366l70.1-63.6z"
      />
      <path
        id="prefix__a"
        fill="#c09300"
        stroke="none"
        d="M393.5 246.5l-4.8 112.3-8 7.2 4.9-115.5a24 24 0 0 1 7.9-4zm9.6 8l-4 94-8 8.2 4.8-108.5c1.6 1.6 6.3 5.5 7.2 6.3zm8.7 7.2l-3.1 78.4-6.5 6.3 4-89.4c1.6 1.5 4.8 3.8 5.6 4.7zm9.5 4l-3.1 66.8-6.3 5.1 3.1-74.3c1.6.7 4.7 2.4 6.3 2.4zm8.8 0l-2.3 55.7-6.5 6.3 2.5-61.3c1.5 0 5.6 0 6.3-.7z"
      />
      <use
        width="100%"
        height="100%"
        transform="matrix(-1 0 0 1 900 0)"
        xlinkHref="#prefix__a"
      />
      <path
        fill="#c09300"
        strokeWidth={1.1}
        d="M453.2 315l9.6 43.8-3.2 3.2-3.3-2.5-5.4-39 2.3 39-3.2 4-3.1-4 2.3-39-5.5 39-3.3 2.5-3.2-3.2 9.6-43.7h6.4z"
      />
      <g id="prefix__b" fill="none" strokeLinejoin="round" strokeWidth={1.3}>
        <path
          fill="#fff"
          strokeWidth={1.2}
          d="M428.5 295.8l-19.1 67.7 26.3 4 11.1-50.9-18.3-20.8z"
        />
        <path d="M422.2 319l2.3 5.5 12.4-11.8" />
        <path d="M430.8 305l2.6 24.3 7.9-10.4m-3.2 4l4.3 15m1.7-5.5l-8.7 13.2m2.7 13.2l-2.8-13.2-2.4-13.4-5.9 7.9-2.5-9.1-8.2 8.4 4.1 15.2 5.8-9.4 3.1 9.6 6-9.2" />
        <path d="M415 362l5.3-7.5 3.4 11.5 4.8-8 3.1 9.6" />
      </g>
      <use
        width="100%"
        height="100%"
        transform="matrix(-1 0 0 1 900 0)"
        xlinkHref="#prefix__b"
      />
      <g strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.3}>
        <path
          strokeWidth={2.4}
          d="M450 393.8c20 0 39-1.6 50.2-4.7 4.7-.9 4.7-3.3 4.7-6.5 4.8-1.6 2.4-7.2 5.7-7.2-3.4 1-4-5.5-8-4.7 0-5.6-5.7-6.3-10.4-4.7-9.5 3.1-26.3 3.9-42.2 3.9-16-.8-32.6-.8-42.2-4-4.7-1.5-10.3-.8-10.3 4.8-4-.8-4.7 5.6-8 4.7 3.3 0 .8 5.7 5.6 7.2 0 3.2 0 5.6 4.8 6.5 11 3.1 30.2 4.7 50.1 4.7z"
        />
        <path d="M422.9 363.5c6.4.9 13.6 1.6 19.2.9 3.2 0 5.5 5.5-.9 6.3-5.5.7-14.3 0-19-.8a231 231 0 0 1-18.4-4c-5.6-2.4-1.6-7 1.6-6.4a105.3 105.3 0 0 0 17.5 4zm54.2 0c-6.4.9-13.6 1.6-19 .9-3.4 0-5.7 5.5.7 6.3 5.6.7 14.3 0 19-.8 4-.8 12.8-2.3 18.4-4 5.6-2.4 1.6-7-1.6-6.4a105.2 105.2 0 0 1-17.5 4z" />
        <path d="M403 360.4c-4.8-.9-7 4.7-5.5 7.9.7-1.6 4-1.6 4.7-3.2.9-2.4-.7-2.4.9-4.7zm19.2 14.7c0-3.2 3.1-2.8 3.1-6 0-1.5-.8-4-2.4-4a3.4 3.4 0 0 0-3.2 3.2c-.7 3.1 2.5 3.6 2.5 6.8zm22.7-9.1c4.7 0 4.2 6.3 2 9.5 0-2.3-4-3.2-4-4.8 0-2.4 3.6-2.4 2-4.7zm52-5.6c4.9-.9 7.2 4.7 5.6 7.9-.7-1.6-4-1.6-4.7-3.2-.9-2.4.7-2.4-.9-4.7zM478 375c0-3.2-3.2-2.8-3.2-6 0-1.5.8-4 2.4-4a3.4 3.4 0 0 1 3.2 3.2c.7 3.1-2.5 3.6-2.5 6.8zm-23-9c-4.7 0-4.2 6.3-2 9.5 0-2.3 4-3.2 4-4.8 0-2.4-3.6-2.4-2-4.7z" />
        <path
          strokeWidth={0.9}
          d="M404.7 362c1.6 0 4 .7 4.7 1.6l-4.7-1.6zm7.9 2.4c.8 0 4 .7 5.5 1.6l-5.5-1.6zm28.6 3.2c-1.5 0-4.7 0-5.5.7l5.5-.8zm-8.7 0c-.9-.9-4-.9-5.6 0h5.6zm62.8-5.6a8 8 0 0 0-4.7 1.6l4.7-1.6zm-7.8 2.4c-1 0-4 .7-5.6 1.6l5.6-1.6zm-28.7 3.2c1.5 0 4.7 0 5.6.7l-5.6-.8zm8.7 0c.9-.9 4-.9 5.6 0h-5.6z"
        />
        <g fill="#c09300" stroke="none">
          <path d="M403.3 374.6c-.5-.1-.8-.6-.6-1 .1-.7.6-1 1-.8.4 0 .9.6.9.8l-.4.7-.2.1c0 .2-.4.2-.7.2zm55 3.9c-.2 0-.6-.5-.6-.7 0-.4.6-1 1-1l.8.4c.3.3.3.9-.1 1.2-.2.2-.8.2-1.1 0zm.3 2.5c-.4-.2-.5-.4-.6-.8 0-.5 0-.6.5-.9l.4-.2.4.2c.4.2.7.4.7.8 0 .3-.3.6-.7.8-.3.2-.4.2-.7 0z" />
          <path d="M407.8 370c-.4 0-.9.4-1.2.6-.6.1-1.4.5-2 0-.6-.1-1.4 0-1.5.8.1.7 1 1 1.6.6.4-.5 1.5-.9 1.7 0-.5.8-.4 1.7-.8 2.4 0 .5-.3.9-.5 1.3-.5 0-1 0-1.4.3a2 2 0 0 0-1.6.8c-.4.6-.8 1.2-.9 2 .1.6 1 .8 1.6.9l2 .6 3.2.9c1.6.5 3.2.7 4.8 1.1l.5.1c.7.2 1-.5 1-1l1-3.6c.2-.5.5-1.5-.4-1.3-.5.3-1 .8-1.6.8-.9 0-.4 1 0 1.3 0 .6-.2 1.3-.5 1.8-.6.3-1.2 0-1.8-.2-.5 0-1.7-.3-1.2-1l.5-1.8c.3-.6.3-1.3.5-2-.4-.7-1 .3-1.5.4-.4.2-1.6.3-1 1 .6.4.2 1.1 0 1.7 0 .7-.8 1-1.4.7-.6 0-1.5-.5-1-1.1l.5-1.8.7-2c0-.7.3-1.2.6-1.8 0-.7.5-1.3.5-2 0-.3-.2-.4-.4-.4zm-3.7 7.3a.3.3 0 0 1 .3 0c.2.2.2.4 0 .6l-.3.2c-.5 0-.6-.1-.6-.3 0-.1 0-.2.3-.3a1.4 1.4 0 0 1 .4-.2zm-1 5c-.5-.4-.4-.7.3-1.3.4-.2.5-.2.9.1.6.5.6.8 0 1.3-.2.2-.3.2-.5.2-.3 0-.4 0-.7-.2zm3 1a.9.9 0 0 1-.6-1.1c.2-.4.3-.5.9-.5.7 0 .8.1.9.7 0 .4 0 .5-.3.7a1 1 0 0 1-.8.2zm89.2 0c-.2-.1-.3-.2-.3-.5 0-.4.2-.7.8-.9.6-.3 1-.3 1.2.2.3.6.3.8-.1 1.2-.2.3-.3.3-.8.3s-.6 0-.8-.2zm-85 1.2c-.4 0-.6-.4-.6-.8 0-.3 0-.4.2-.6l.6-.2.6.1c.5.4.6.8.3 1.2-.3.4-.6.4-1.2.3zm21.8 1l-.2-.3c0-.6 0-1.1.2-1.7.1-.5 0-1 .2-1.5l.4-2.8c0-.5 0-1 .2-1.4.1-.8 0-1.5.2-2.2 0-.3.3-1 .6-.6.4.6.9 1 1.4 1.5.4.3 0 .7-.3.8-.4.1-.5.6-.5 1l-.2 1.2c0 .7 0 1.3-.2 2l-.1 1.8-.2 1.2c0 .4 0 .9-.4 1.1-.3.2-.8.2-1-.1zm29.7-9.8l-1.3 1.2c-.6.5.5.7.6 1.1.2.6.2 1.2.2 1.8.2.6.3 1.1.2 1.7 0 .7-.8.5-1.2.9-.5.2-.7.7-1 1a4.2 4.2 0 0 0-.4 1.6c0 .5-.3 1 0 1.4l.1.2h.5l1.5-.1c1.2-.2 2.5-.2 3.7-.3l2.2-.2c.6.1.9-.5.9-1-.4-.7-.1-1.4-.4-2-.2-.8-.1-1.5-.2-2.2 0-.6-.7-.8-1-.4-.4.4-1 .5-1.2.9-.3.6.6.6.8 1l.1 1.5c.1.6-.5.6-1 .7-.5.2-1.2.3-1.5-.3-.2-.5-.2-1-.2-1.5 0-1-.3-1.8-.3-2.7 0-1-.3-2.1-.3-3.2 0-.5-.1-1.2-.8-1.1zm-.6 8.2h.3v.8l-.3.1a3.3 3.3 0 0 1-.4.1 2.5 2.5 0 0 1-.2 0c-.2-.2-.2-.5.1-.8l.5-.2zm-30-9.2c-.3 0-.8.7-1.2.6-.9.1-.8 1-.1 1.3v.8c.1.8-.4 1.5-.3 2.3 0 .8-.3 1.7-.3 2.6-.3.9-.3 1.8-.4 2.7-.1.8-.7.5-1.2.3v-1c.1-.9-.5-1.1-1.2-1.2-.7 0-1-.5-.8-1.1.3-.4 1-.3 1.5-.3 1 .2.9-1.1.4-1.6-.4-.6-1.2-1-1.4-1.6 0-.8-.5-1.7-1.2-2.1-1.1-.1-2 .8-2.3 1.8-.5 0-1 .2-1.4.4-.7.2-1.7 1.4-.7 1.9.5.1 2.2.5 1.4 1.2-.4.8-1.2.8-1.9.6-.7 0-1.5-.4-1.5-1.2-.1-.8-.1-1.6-.4-2.3-.2-.8-1.1-.6-1.2.2-.7.5-.6 1.4-.1 2 .3.7 0 1.6-.3 2.2-.2 1-1.2 1-1.9 1.2-.3.2-1.6 0-1.1.7a4 4 0 0 0 2.4.3c.8 0 1.5-.7 2-1.4.5-.5 1.4-.2 2.2-.2.7 0 1.5.5 2.3.1.2-.5 1.2-1.5 1.5-.5 0 .9.7 1.3 1.5 1.2.9 0 .5.6.5 1.2 0 .9.7 1.4 1.5 1.8h.8c.7-.3 1.5-.6 1.8-1.4.3-.7.3-1.5.5-2.2.2-1.1.4-2.3.4-3.4.3-1 .2-2.1.4-3.2l.3-2.3c0-.5-.2-.5-.5-.4zm-6.7 4.1c.1 0 .2.2.2.5 0 .4.2.7.5.8v.3l-.8.2c-.5 0-.9-.2-1.2-.5l-.2-.2.3-.2.5-.5c.3-.3.5-.4.7-.4zm66-7.9a8.4 8.4 0 0 0-1.7.3c-1 0-1.5 1-.5 1.6.6 1.5 1.5-.4 2.5-.2 1.4.2 1.5 1.8 1.8 3 0 1.1.4 2.2.7 3.3 1 1.1-.7 1.8-1.4 1-.6-.7-2-1.5-2.7-.6-.9.4-1 1.6-1.7 2-1.2.3-1.3-1.2-2-1.8-.6-.9-1.7-1-2.6-1.2-.4-.9-.2-2.4-1-3-.8.3-2.2 1.7-1 2.4 1 1-.5 1.4-1 2-.8.9-1 2-1 3-1.3.7-1.5-.8-1.7-1.7 0-1.1-1-.8-1.7-.4-1 .4-1.4 1.3-2 2v2c.2.9 1.2.5 1.8.4 1-.4 1.4.7.6 1.3-.6.6-2.2.3-2 1.4h1.6c1-.3 2.2-1.1 2.3-2.3.2-1 1.7-.9 2.5-1.1 1-.3 2.3-.4 2.6 1 .7.7 2.2 1.5 3 .5a2.4 2.4 0 0 0 1.1-2.3c-.1-.8 1.3-.8 1.7-.3.5.8 2.1.6 2.9 0 .8-.5 1-1.6 2.2-1.6l5.4-1.5c1.4-.3-.2-1.2-.6-1.8-1-.5-2 1.7-3.2.6-1-.7-.9-2-1.2-3.1-.3-1.4-.2-3-1.2-4-.6-.7-1.6-.9-2.5-.9zm-6.8 9.5c.1 0 .3 0 .5.2.4.2.7.6.7 1 0 .2 0 .2-.3.3l-.5.2c-.2 0-.7-.3-.7-.5v-.4c-.2-.4-.2-.4 0-.6l.3-.2zm6.5.4c.4 0 .6 0 .8.3.1.4 0 .6-.4.8l-.5.2-.4-.3c-.2-.1-.3-.2-.3-.4 0-.3.4-.6.8-.7zm-9 0c.2 0 .3 0 .4.2.2.2.3.3.3.6v.6c0 .3 0 .2-.6.2s-.7 0-.7-.6c0-.4 0-.5.3-.7.1-.2.3-.2.4-.2zm-5.4 1.5a.6.6 0 0 1 .4.4c0 .3 0 .5-.2.6-.3.1-.8.2-1 0a.6.6 0 0 1 0-.1c-.2-.1-.2-.2 0-.3v-.1l.2-.3a.5.5 0 0 1 .6-.2zm9.2 1.2l.5.1v.6h-1.2l-.1-.2c0-.2 0-.3.2-.4l.6-.1zm-17.1 4.8c-.1 0-.3-.1-.1-.2.1-.3.5-.4.8-.6a3.4 3.4 0 0 0 1.4-1c0-.4.4-.6.4-1l-.1-1.4a1.8 1.8 0 0 0-.8-1c-.3-.1-.7-.2-.8-.6 0-.3.3-.6.4-.9l.6-1.2c.3-.3.7 0 .8.2l.5 1c.3.3.5.6.6 1 .2.4.4.7.4 1l.2 1.3c0 .5 0 1.1-.2 1.6l-.6.8c-.3.3-.6.6-1 .7-.3.1-.5.4-.9.4H468l-.1-.1zm-6.9.4c-.2-.2-.3-.3-.3-.6s0-.3.3-.6c.4-.4.6-.4 1.4 0 .7.4 1 .4 1 .1.1-.2.5-.5 1-.5a.8.8 0 0 1 .5.2c.2.2.3.3.3.7 0 .5 0 .5-.3.8-.3.2-.3.2-.7.2a.9.9 0 0 1-.8-.6c0-.2 0-.3-.2-.1l-.2.1c-.2 0-.6.3-.8.5l-.5.1c-.4 0-.4 0-.7-.3zm-19.8-8.9c-.7 0-1.4.6-1.5 1.3.2.7.8 1.5.4 2.2.3 1-.8 1.4-1.5.9-.4-1-.6-2-1.3-3-.8-.2-1.1 1.1-1.7 1.6.3.7 1.1 1.4 1.2 2.3.2 1-.4 2-1.1 2.4-.7.7-1.7.5-2.5.6-1 .6.7.8 1.2.8 1 .1 2.1 0 3-.8.7-.3.6-1.7 1.5-1.8l4.8.3c.8.2 2.1-.1 2.7.5 0 1 1 1.8 1.9 2.2.5.2 1-.5 1.5-.6 1-.3.7-1.5 1.3-2h5c.2 0 .3-.5.6-.7l-.2-1.9c-.3-.8 0-1.8-.5-2.5-.9-.2-1.6.5-2.4.6-1 .4-1.7 1.3-1.8 2.3-.5.9-1.4-.2-1-1l-.1-1c-.5-.5-1.4-.3-2.1-.4l-3-.2c-1 0-1.9.1-2.7-.1-1 0-1-1-1-1.8a1 1 0 0 0-.7-.2zm2 3.7l1 .1h1.3c1 .2 2 .2 3 .2.2 0 .4.2.6.4v2c0 .3 0 .7-.2.8a.7.7 0 0 1-.2.2 1 1 0 0 1-.7-.5v-1.4a1.3 1.3 0 0 0-.7-.3l-2.6-.1-2-.1c-.3-.1-.7 0-.9-.4-.2-.2.1-.6.4-.7a2.3 2.3 0 0 1 1-.2zm11.3.3c.1 0 .2 0 .2.3l.2.5c0 .1 0 .2-.2.2-.5.2-1 .2-1.2 0 0-.1 0-.5.2-.6l.8-.4z" />
        </g>
      </g>
      <path
        strokeWidth={1.1}
        d="M450 327.2c32.6-25 29.8-61.8 29.8-61.8l-2.5.2c-6.9 0-23.2-4-27-8.9-4 4.5-20.8 9-27.6 9l-2.5-.3s-2.9 36.7 29.8 61.8z"
      />
      <path
        strokeWidth={0.9}
        d="M477.2 268h-.8c-6.2 0-20.6-3.1-26.2-7.9-5.8 4.4-20.5 8-26.6 8a4.7 4.7 0 0 1-.8-.1 73.1 73.1 0 0 0 2.6 18.7 71 71 0 0 0 24.6 37.1 71.2 71.2 0 0 0 24.6-37.2 73.1 73.1 0 0 0 2.6-18.6z"
      />
      <path
        fill="#c09300"
        d="M439.4 265a62.2 62.2 0 0 1-16.6 3l.1 4.1a72.8 72.8 0 0 0 2.5 14.5 71 71 0 0 0 14 26.8V265zm20.6 0v49.2a71.1 71.1 0 0 0 14.6-27.6 73 73 0 0 0 2.5-14.5l.1-4h-.8c-3.8 0-10.4-1.2-16.4-3.2z"
        stroke="none"
      />
      <g strokeWidth={1.3}>
        <path
          strokeWidth={1.2}
          d="M462.3 253c.7.1-.9-3.5-.9-3.5 1.8 1.8 8.4 2.3 8.4 2.3-4-1.8-8-15.1-7.5-25.8.4-10.6-1.5-14.8-3-16.4-2-2-8.5-3.8-12.7-4-2.5-.1-2 1.8-2 1.8-4.5-1.1-9-1.6-11-.2-1.8 1.2-2.2 7.5-.8 6.4 3.3-2.7 6.2-.2 8.2 2.7 1.8 2.5 1.7 9.7-.9 18.2a60 60 0 0 1-10 17.7c4 0 9.6-3.5 9.6-3.5l-1.3 5.5c4.2-2 7.5-5.1 7.5-5.1l4 4.2c1.3-1.8 4-4.2 4-4.2s3.3 3.5 8.4 4z"
        />
        <path
          fill="none"
          d="M446.1 227.6s-2.2 16.4-6.4 21m10-21.5s-1 16.7-3.8 22m6.9-21.3s0 18.2 1 21.3m3-20.4s.8 15.3 4.6 20.8"
        />
        <path
          fill="#c09300"
          strokeWidth={0.3}
          d="M442 219.6a8 8 0 0 0-1-3.3c-2-3-4.9-5.4-8.2-2.7 0 0 1.1-3.5 3.6-3.6 1.8-.1 6.1 1.4 9.9 7.8 0 0-2.8-.6-3.5 0-1.2 1-.7 1.8-.7 1.8z"
        />
        <path
          fill="#c09300"
          strokeWidth={0.3}
          d="M432.4 209.3c.3-1 .7-1.8 1.3-2.1 2-1.4 6.4-1 10.9.2 0 0-.4-1.9 2-1.8 4.2.2 10.6 2 12.6 4a7.9 7.9 0 0 1 1.5 2.4c-1-1.4-3.8-1.3-4.5-1.2-1 .1-1.7 0-3.1.4-.7.2-1.7.4-2.3.8-.4.4-.8 1.6-1.4 1.6-1 0-1-.2-1.3-.5-.3-.5-.5-1.1-.9-1-1 .1-2.8-.7-5-2.5-2.3-1.8-3.2-2.2-6-2-3 .2-3.8 1.9-3.8 1.9v-.2z"
        />
        <circle cx={448.8} cy={210.7} r={1.2} stroke="none" />
      </g>
    </g>
  </svg>
	),
	EH: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-158.7 0H524v512h-682.7z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(148.8) scale(.94)"
    >
      <path d="M-180 0H844v256H-180z" />
      <path fill="#107b00" d="M-180 256H844v256H-180z" />
      <path fill="#fff" d="M-180 169.3H844v176.1H-180z" />
      <path
        fill="#f0f"
        d="M310 195.6c-45.2-19.5-84.1 20.6-84 58 0 39.2 38 81 86 62.5-34-10-48-35.3-48-60.7-.3-25.2 15.8-54.6 46-59.9z"
      />
      <path
        fill="#ff1800"
        d="M363.1 294.2l-25.8-18.9-26 19 10-30.5-26-18.8h32l9.9-30.5 9.8 30.4h32.1l-25.9 18.8"
      />
      <path
        fill="red"
        d="M314.3 315.6a65.2 65.2 0 0 1-89.2-59.4 65 65 0 0 1 89.5-60.9 60.6 60.6 0 0 0-51.2 59.2 61.3 61.3 0 0 0 51 61.1zM-180 0l348.6 256.6L-180 512V0z"
      />
    </g>
  </svg>
	),
	ER: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#be0027" d="M0 0h640v480H0z" />
      <path fill="#b4d7f4" d="M0 480l640-.3V240L0 480z" />
      <path fill="#239e46" d="M0 0l640 .3V240L0 0z" />
      <path
        fill="#f3e295"
        d="M186.2 360.4c-10.7 3-16.8 11.3-16.7 19.1l52.8-.2c.4-8.4-6.5-16.2-17-19.3 51.6-1 96.4-20.4 104.6-32.8-8-3.5-17.4 2.1-24 .8 15.7-7.3 63-37.9 55.3-70.7-6 18.2-24 33.3-31.8 37.4 17.7-26.8 41.8-54.8 20.9-76.4 1 12.5-8 26.3-12 27.4 10.3-28.4 20-64-2.1-87.4 2.9 8.5 1.7 32.4-2.3 33.5-1.2-19.3-4.5-59.8-24.8-59.3 6.4 5.8 9.2 21.4 9.4 37.2a57.5 57.5 0 0 0-21.1-27 118.3 118.3 0 0 0-41.5-42.2c1.8 12.7 3.3 22.7 21 35.9-9.2-.6-18.4-18.1-28.3-18.6-7.9-.4-14 7.1-26.9 2.8 1.4 4.2 7.4 6.1 8.7 9.2-2.8 2-9.3-.3-14.7-3 7.5 10 19 16 28.8 14 11.7-2.2 24.2-1 36.2 5.8a63 63 0 0 1-22.5.6c6.9 7 11.5 11.7 23.6 11.6 10.7 0 16.4-5.8 19.1-2.2 6.8 8 11.3 16 17 25.4-12.5 1.3-8.7-14.1-22.6-22-7.9 16 9 35.2 20.3 43.2a65 65 0 0 0 7.1 31.5c3.5 6.5 8 13.2 6.3 27.9-6.9-5-13.5-21.8-11-35.1-8.6 2.3-12 17.4-8 25 3 5.7 5 16.8 1.6 21.7-3.4 4.6-3.7 4-3.7 14 .1 5.8-3.2 12.8-8.5 17.7a35.5 35.5 0 0 0 1.1-15.8c-4.2 7.2-14.9 14.6-18.2 22.4-3.3 7.7-4.1 21.2-20 24.3-20.6 4-27.7 7.6-40.8 13-1.5-10 2.9-31 11.3-29.7 8.1 1.4 33-8.6 24-29.5-1.7 6.6-7.5 13-13.9 13.3 6.9-8.8 19-18 13.1-32.8a42.6 42.6 0 0 1-16.3 18c8.4-16 1-21-9-7.6-3.8 5.1-6.1 15.4-8.5 28.5-4-10.6-3.7-24.6-8.4-36-4.8-12.3 6.5-15.5 11.8-14.5 13 3.5 34.9 3.5 33.3-18.1-5.7 7.3-15.5 9.5-26.2 7 12-8.8 21.4-25.3 8-34a31 31 0 0 1-16.9 24.1 50.8 50.8 0 0 1-.3-24.8c-5.2 5.6-9 17-12.1 30.2-.3-13 2.2-22.3 4-29.3 2.8-10.1 9.6-3.5 20-2.8 10.2.6 24-5 21.4-18.7-3.4 5.5-10.5 7.6-17.7 7 8.7-5.3 23.8-14.6 15.5-29-3.5 5.4-4.6 10-14.7 11.7 2.6-6 3-14.7 11-18-14-2.9-22 6.3-26.2 20.7-1.6-10-3.6-13.6-4-21 7.6-8.3 8.4-24.8-8-28.4a35 35 0 0 0 1.2 17.4c-7.7-4.6-18.5-7.1-25.8-.7 5 5.3 12.5 10 24.2 4.2-2.8 9-10 7.5-19.8 4 6 11.3 13.6 13.3 22 12 4.4 11.6 4.6 20.4-8.3 37.2.6-10.4-.1-18.2-8.4-26.7-7.2-7-13 .3-1.8 15.8-6.8-5-14.4-15-16.7-25.1-2.2 12.4-.2 27.1 6.7 35.4-3.3 3.5-7-.4-12.5-9 2 27.4 13.7 32.7 29.4 26.6.4 15 .4 28.9 1.3 47-9.1-13.2-20.7-23-27.1-25.4-2 7.3 5.5 17 9.8 22.3-6.5-1.4-20.5-12-20.5-12-1.4 12.1 14.3 23.4 24.5 28.4-12-.5-17.3-5-25-12.4.2 33.8 36.6 27.9 43.5 22.7l3 52.5c-10.3-1.8-9.5-5-18.3-5.7-24.5-1-43.9-29.4-50.3-50.3-1.9 3.4-.4 7-2.1 11.3-4-10.3-9-23.6-15.9-29.8 1.8 6 2 12.1 1.4 23.3-2.4-7.2-4.5-9.5-4.7-18 .1-6.5 6.3-11.3 6-20.5-.3-6.7-6.4-21.3-7.3-32.5-3 11.6-4.8 23.8-9.4 31 2.3-12.4 1.6-21 5.4-29.3 4.4-8.7 8.1-16.6 5.2-25.4-2.8 3.4-1.9 6.5-9 14.8-1.5-9 9.2-23.5 19.6-29.3 7.3-3.8 16.5-17.6 10.5-27-6.9 5-10 11.6-19.7 23 7-27 25-34.2 46.5-34.3 4.7 0 14.3-1.7 17-8-6 2.3-13.2 2.6-19.6 1.4 4.7-6.9 14.4-6 23.6-6 7.1 0 18.3-1 22.8-11.2a50.8 50.8 0 0 1-31 1.9c13.7-7 35-7.8 46-17.1-12.5-9.3-43.7 2.2-63.4 15.7 5.5-5 14.2-14 19-21.2-10.8-5.2-38 25-47.4 43-9 5-12.5 13-16 18.5 4.7-16.1 5.2-27.8 9.2-41C80 138 92.6 194.6 86 208.2c.8-15 .1-34.1-6-44-9.4 7.2-10.2 49.5-1.4 84.7-3.2-9.4-9.2-18.2-11.1-29.7-14 25.4 8.2 55.5 26.7 79.2-14-7.3-27.7-22.9-36.8-36 2.5 45.6 50 55 57.4 66.2-10-4.7-29.1-13.9-37.3-4.2a99 99 0 0 1 32.3 12.1c12.4 15.4 35.7 22.2 76.4 23.9z"
      />
    </g>
  </svg>
	),
	ES: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#c60b1e" d="M0 0h640v480H0z" />
    <path fill="#ffc400" d="M0 120h640v240H0z" />
    <path
      fill="#ad1519"
      d="M127.3 213.3l-.8-.1-1-1-.7-.4-.6-.8s-.7-1.1-.4-2c.3-.9.9-1.2 1.4-1.5a12 12 0 0 1 1.5-.5l1-.4 1.3-.3.5-.3c.2 0 .7 0 1-.2l1-.2 1.6.1h4.8c.4 0 1.2.3 1.4.4a35 35 0 0 0 2 .7c.5.1 1.6.3 2.2.6.5.3.9.7 1.1 1l.5 1v1.1l-.5.8-.6 1-.8.6s-.5.5-1 .4c-.4 0-4.8-.8-7.6-.8s-7.3.9-7.3.9"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.3}
      d="M127.3 213.3l-.8-.1-1-1-.7-.4-.6-.8s-.7-1.1-.4-2c.3-.9.9-1.2 1.4-1.5a12 12 0 0 1 1.5-.5l1-.4 1.3-.3.5-.3c.2 0 .7 0 1-.2l1-.2 1.6.1h4.8c.4 0 1.2.3 1.4.4a35 35 0 0 0 2 .7c.5.1 1.6.3 2.2.6.5.3.9.7 1.1 1l.5 1v1.1l-.5.8-.6 1-.8.6s-.5.5-1 .4c-.4 0-4.8-.8-7.6-.8s-7.3.9-7.3.9z"
    />
    <path
      fill="#c8b100"
      d="M133.3 207c0-1.3.6-2.3 1.3-2.3.8 0 1.4 1 1.4 2.4 0 1.3-.6 2.4-1.4 2.4s-1.3-1.1-1.3-2.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M133.3 207c0-1.3.6-2.3 1.3-2.3.8 0 1.4 1 1.4 2.4 0 1.3-.6 2.4-1.4 2.4s-1.3-1.1-1.3-2.5z"
    />
    <path
      fill="#c8b100"
      d="M134 207c0-1.2.3-2.1.7-2.1.3 0 .6 1 .6 2.1 0 1.3-.3 2.2-.6 2.2-.4 0-.6-1-.6-2.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M134 207c0-1.2.3-2.1.7-2.1.3 0 .6 1 .6 2.1 0 1.3-.3 2.2-.6 2.2-.4 0-.6-1-.6-2.2z"
    />
    <path
      fill="#c8b100"
      d="M133.8 204.5c0-.4.4-.8.8-.8s1 .4 1 .8c0 .5-.5.9-1 .9s-.8-.4-.8-.9"
    />
    <path
      fill="#c8b100"
      d="M135.3 204.2v.6h-1.4v-.6h.5V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2h.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M135.3 204.2v.6h-1.4v-.6h.5V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2h.4"
    />
    <path
      fill="#c8b100"
      d="M135.9 204.2v.6h-2.5v-.6h1V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2h1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M135.9 204.2v.6h-2.5v-.6h1V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2h1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M134.9 203.7c.4.1.6.4.6.8 0 .5-.4.9-.8.9s-1-.4-1-.9c0-.4.3-.7.7-.8"
    />
    <path
      fill="#c8b100"
      d="M134.7 213.2H130v-1.1l-.3-1.2-.2-1.5c-1.3-1.7-2.5-2.8-2.9-2.5.1-.3.2-.6.5-.7 1.1-.7 3.5 1 5.2 3.6l.5.7h3.8l.4-.7c1.8-2.7 4.1-4.3 5.2-3.6.3.1.4.4.5.7-.4-.3-1.6.8-2.9 2.5l-.2 1.5-.2 1.2-.1 1.1h-4.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M134.7 213.2H130v-1.1l-.3-1.2-.2-1.5c-1.3-1.7-2.5-2.8-2.9-2.5.1-.3.2-.6.5-.7 1.1-.7 3.5 1 5.2 3.6l.5.7h3.8l.4-.7c1.8-2.7 4.1-4.3 5.2-3.6.3.1.4.4.5.7-.4-.3-1.6.8-2.9 2.5l-.2 1.5-.2 1.2-.1 1.1h-4.7z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M126.8 206.8c1-.5 3 1.1 4.6 3.6m11-3.6c-.8-.5-2.8 1.1-4.5 3.6"
    />
    <path
      fill="#c8b100"
      d="M127.8 215.3l-.5-1a27.3 27.3 0 0 1 14.7 0l-.5.8a5.7 5.7 0 0 0-.3.8 22.9 22.9 0 0 0-6.6-.8c-2.6 0-5.2.3-6.5.8l-.3-.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M127.8 215.3l-.5-1a27.3 27.3 0 0 1 14.7 0l-.5.8a5.7 5.7 0 0 0-.3.8 22.9 22.9 0 0 0-6.6-.8c-2.6 0-5.2.3-6.5.8l-.3-.6"
    />
    <path
      fill="#c8b100"
      d="M134.6 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4-1.4-.5-4-.8-6.5-.8s-5 .3-6.4.8c-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M134.6 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4-1.4-.5-4-.8-6.5-.8s-5 .3-6.4.8c-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6z"
    />
    <path
      fill="#c8b100"
      d="M142.1 213.2l-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.4.6-1.1.7-1.4-.6-1.4-.6-.5.7-1 1c-.5 0-1.2-.4-1.2-.4l-.2.5-.3.1.2.5a27 27 0 0 1 7.2-.9c3 0 5.5.4 7.4 1l.2-.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M142.1 213.2l-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.4.6-1.1.7-1.4-.6-1.4-.6-.5.7-1 1c-.5 0-1.2-.4-1.2-.4l-.2.5-.3.1.2.5a27 27 0 0 1 7.2-.9c3 0 5.5.4 7.4 1l.2-.6z"
    />
    <path
      fill="#c8b100"
      d="M134.7 210.7h.2a1 1 0 0 0 0 .4c0 .6.4 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1v-.1l.4-.4.2.5a.9.9 0 0 0-.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4l.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6-.2.2-.4.2-.7.2-.6 0-1.2-.3-1.4-.8-.3.3-.7.5-1.1.5a1.6 1.6 0 0 1-1.2-.6 1.6 1.6 0 0 1-1 .4 1.6 1.6 0 0 1-1.3-.6 1.6 1.6 0 0 1-2.4.2 1.6 1.6 0 0 1-1.2.6 1.5 1.5 0 0 1-1.1-.5c-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2l-1-1 .1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 .9.9 0 0 0 0-.4v-.5l.4.4a.7.7 0 0 0 0 .1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.7 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M134.7 210.7h.2a1 1 0 0 0 0 .4c0 .6.4 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1v-.1l.4-.4.2.5a.9.9 0 0 0-.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4l.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6-.2.2-.4.2-.7.2-.6 0-1.2-.3-1.4-.8-.3.3-.7.5-1.1.5a1.6 1.6 0 0 1-1.2-.6 1.6 1.6 0 0 1-1 .4 1.6 1.6 0 0 1-1.3-.6 1.6 1.6 0 0 1-2.4.2 1.6 1.6 0 0 1-1.2.6 1.5 1.5 0 0 1-1.1-.5c-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2l-1-1 .1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 .9.9 0 0 0 0-.4v-.5l.4.4a.7.7 0 0 0 0 .1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.7 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.3z"
    />
    <path
      fill="#c8b100"
      d="M134.6 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3a27 27 0 0 1 7.5-1c3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27.3 27.3 0 0 0-7.4-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.3}
      d="M134.6 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3a27 27 0 0 1 7.5-1c3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27.3 27.3 0 0 0-7.4-1z"
    />
    <path
      fill="#fff"
      d="M131.8 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4c0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M131.8 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4c0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.4z"
    />
    <path
      fill="#ad1519"
      d="M134.7 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1-.3.3h-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M134.7 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1-.3.3h-1"
    />
    <path
      fill="#058e6e"
      d="M130 214.9h-.7c-.1 0-.3 0-.3-.2a.3.3 0 0 1 .2-.3l.7-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1-.3.4h-.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M130 214.9h-.7c-.1 0-.3 0-.3-.2a.3.3 0 0 1 .2-.3l.7-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1-.3.4h-.7"
    />
    <path fill="#ad1519" d="M127.3 215.3l.3-.4h.7l-.4.6-.6-.2" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M127.3 215.3l.3-.4h.7l-.4.6-.6-.2"
    />
    <path
      fill="#fff"
      d="M136.6 214.4c0-.3.2-.4.4-.4a.4.4 0 0 1 .5.4.4.4 0 0 1-.5.4.4.4 0 0 1-.4-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M136.6 214.4c0-.3.2-.4.4-.4a.4.4 0 0 1 .5.4.4.4 0 0 1-.5.4.4.4 0 0 1-.4-.4z"
    />
    <path
      fill="#058e6e"
      d="M139.3 214.9h.6a.3.3 0 0 0 .4-.2.3.3 0 0 0-.3-.3l-.6-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M139.3 214.9h.6a.3.3 0 0 0 .4-.2.3.3 0 0 0-.3-.3l-.6-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7"
    />
    <path fill="#ad1519" d="M142 215.4l-.3-.5h-.7l.3.6.6-.1" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M142 215.4l-.3-.5h-.7l.3.6.6-.1"
    />
    <path
      fill="#ad1519"
      d="M134.6 217.1a25 25 0 0 1-6-.6 25.5 25.5 0 0 1 12.1 0c-1.6.4-3.7.6-6 .6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.3}
      d="M134.6 217.1a25 25 0 0 1-6-.6 25.5 25.5 0 0 1 12.1 0c-1.6.4-3.7.6-6 .6z"
    />
    <path
      fill="#c8b100"
      d="M142 212l-.1-.3c-.2 0-.3 0-.4.2 0 .2 0 .4.2.4 0 0 .2 0 .3-.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M142 212l-.1-.3c-.2 0-.3 0-.4.2 0 .2 0 .4.2.4 0 0 .2 0 .3-.3z"
    />
    <path
      fill="#c8b100"
      d="M137.3 211.2c0-.2 0-.4-.2-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4l.3-.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M137.3 211.2c0-.2 0-.4-.2-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4l.3-.3z"
    />
    <path
      fill="#c8b100"
      d="M132 211.2l.1-.4c.2 0 .3.1.3.3 0 .2 0 .4-.2.4l-.2-.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M132 211.2l.1-.4c.2 0 .3.1.3.3 0 .2 0 .4-.2.4l-.2-.3z"
    />
    <path
      fill="#c8b100"
      d="M127.3 212l.1-.3c.2 0 .3 0 .4.2 0 .2 0 .4-.2.4 0 0-.2 0-.3-.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M127.3 212l.1-.3c.2 0 .3 0 .4.2 0 .2 0 .4-.2.4 0 0-.2 0-.3-.3z"
    />
    <path fill="#c8b100" d="M134.6 208.5l-.8.5.6 1.3.2.1.2-.1.7-1.3-.9-.5" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M134.6 208.5l-.8.5.6 1.3.2.1.2-.1.7-1.3-.9-.5"
    />
    <path fill="#c8b100" d="M132.8 210.5l.4.5 1.3-.4.1-.2-.1-.2-1.3-.3-.4.6" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M132.8 210.5l.4.5 1.3-.4.1-.2-.1-.2-1.3-.3-.4.6"
    />
    <path fill="#c8b100" d="M136.4 210.5l-.3.5-1.3-.4-.2-.2.2-.2 1.3-.3.3.6" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M136.4 210.5l-.3.5-1.3-.4-.2-.2.2-.2 1.3-.3.3.6"
    />
    <path fill="#c8b100" d="M129.3 209l-.7.7.9 1 .2.1.1-.1.3-1.3-.8-.3" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M129.3 209l-.7.7.9 1 .2.1.1-.1.3-1.3-.8-.3"
    />
    <path fill="#c8b100" d="M128 211.2l.4.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M128 211.2l.4.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6"
    />
    <path fill="#c8b100" d="M131.5 210.5l-.3.6H130l-.2-.2.1-.3 1.2-.6.5.5" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M131.5 210.5l-.3.6H130l-.2-.2.1-.3 1.2-.6.5.5"
    />
    <path fill="#c8b100" d="M126.6 211.4v.6l-1.4.2-.2-.1v-.2l1-.9.6.4" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M126.6 211.4v.6l-1.4.2-.2-.1v-.2l1-.9.6.4"
    />
    <path
      fill="#c8b100"
      d="M129.2 210.9c0-.3.2-.5.5-.5s.5.2.5.5a.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M129.2 210.9c0-.3.2-.5.5-.5s.5.2.5.5a.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4z"
    />
    <path fill="#c8b100" d="M140 209l.7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M140 209l.7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3"
    />
    <path fill="#c8b100" d="M141.4 211.2l-.5.5-1.2-.6v-.2l.1-.2 1.3-.1.3.6" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M141.4 211.2l-.5.5-1.2-.6v-.2l.1-.2 1.3-.1.3.6"
    />
    <path fill="#c8b100" d="M137.8 210.5l.3.6h1.3l.2-.2-.1-.3-1.2-.6-.5.5" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M137.8 210.5l.3.6h1.3l.2-.2-.1-.3-1.2-.6-.5.5"
    />
    <path fill="#c8b100" d="M142.5 211.4l.1.6 1.3.2.2-.1v-.2l-1-.9-.6.4" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M142.5 211.4l.1.6 1.3.2.2-.1v-.2l-1-.9-.6.4"
    />
    <path
      fill="#c8b100"
      d="M134.2 210.4a.5.5 0 0 1 .4-.4c.3 0 .5.2.5.4a.5.5 0 0 1-.5.5.5.5 0 0 1-.4-.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M134.2 210.4a.5.5 0 0 1 .4-.4c.3 0 .5.2.5.4a.5.5 0 0 1-.5.5.5.5 0 0 1-.4-.5z"
    />
    <path
      fill="#c8b100"
      d="M139.1 210.9c0-.3.3-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M139.1 210.9c0-.3.3-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4z"
    />
    <path
      fill="#c8b100"
      d="M124.8 212.2l-.6-.7c-.2-.2-.7-.3-.7-.3 0-.1.3-.3.6-.3a.5.5 0 0 1 .4.2v-.2s.3 0 .4.3v1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M124.8 212.2l-.6-.7c-.2-.2-.7-.3-.7-.3 0-.1.3-.3.6-.3a.5.5 0 0 1 .4.2v-.2s.3 0 .4.3v1z"
    />
    <path
      fill="#c8b100"
      d="M124.8 212c.1-.2.4-.2.5 0 .2.1.3.3.2.5l-.5-.1c-.2-.1-.3-.4-.2-.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M124.8 212c.1-.2.4-.2.5 0 .2.1.3.3.2.5l-.5-.1c-.2-.1-.3-.4-.2-.5z"
    />
    <path
      fill="#c8b100"
      d="M144.3 212.2l.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0-.4.2v-.2s-.3 0-.4.3v.7l.1.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M144.3 212.2l.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0-.4.2v-.2s-.3 0-.4.3v.7l.1.3z"
    />
    <path
      fill="#c8b100"
      d="M144.3 212c0-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M144.3 212c0-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5z"
    />
    <path fill="#c8b100" d="M124 223h21.4v-5.5H124v5.6z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M124 223h21.4v-5.5H124v5.6z"
    />
    <path
      fill="#c8b100"
      d="M126.2 226.8a1 1 0 0 1 .4 0h16.5a1.4 1.4 0 0 1-1-1.2c0-.6.5-1.1 1-1.3a1.7 1.7 0 0 1-.4 0h-16a1.4 1.4 0 0 1-.5 0c.6.2 1 .7 1 1.3a1.3 1.3 0 0 1-1 1.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M126.2 226.8a1 1 0 0 1 .4 0h16.5a1.4 1.4 0 0 1-1-1.2c0-.6.5-1.1 1-1.3a1.7 1.7 0 0 1-.4 0h-16a1.4 1.4 0 0 1-.5 0c.6.2 1 .7 1 1.3a1.3 1.3 0 0 1-1 1.2z"
    />
    <path
      fill="#c8b100"
      d="M126.6 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.5 0-1-.4-1-.8s.5-.8 1-.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M126.6 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.5 0-1-.4-1-.8s.5-.8 1-.8z"
    />
    <path
      fill="#c8b100"
      d="M126.6 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.5 0-1-.2-1-.6 0-.3.5-.6 1-.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M126.6 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.5 0-1-.2-1-.6 0-.3.5-.6 1-.6z"
    />
    <path
      fill="#005bbf"
      d="M149.6 317.4c-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8c-1.4 0-2.7.3-3.7.8a8.3 8.3 0 0 1-3.8.8c-1.5 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.7-.8 8 8 0 0 0-3.7.8 8.3 8.3 0 0 1-3.8.8v2.4c1.5 0 2.8-.4 3.8-.9a8.2 8.2 0 0 1 3.7-.8c1.4 0 2.7.3 3.7.8s2.2.9 3.7.9a8.4 8.4 0 0 0 3.8-.9c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.9 3.7.9v-2.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M149.6 317.4c-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8c-1.4 0-2.7.3-3.7.8a8.3 8.3 0 0 1-3.8.8c-1.5 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.7-.8 8 8 0 0 0-3.7.8 8.3 8.3 0 0 1-3.8.8v2.4c1.5 0 2.8-.4 3.8-.9a8.2 8.2 0 0 1 3.7-.8c1.4 0 2.7.3 3.7.8s2.2.9 3.7.9a8.4 8.4 0 0 0 3.8-.9c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.9 3.7.9v-2.4z"
    />
    <path
      fill="#ccc"
      d="M149.6 319.8a8 8 0 0 1-3.7-.9 8.3 8.3 0 0 0-3.8-.8c-1.4 0-2.7.3-3.7.8s-2.3.9-3.8.9-2.8-.4-3.7-.9a8.4 8.4 0 0 0-3.7-.8 8.2 8.2 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.4 3.8-.9a8.1 8.1 0 0 1 3.7-.7c1.4 0 2.7.2 3.7.7a8.3 8.3 0 0 0 7.5 0 8.5 8.5 0 0 1 7.5.1 8.1 8.1 0 0 0 3.7.8v-2.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M149.6 319.8a8 8 0 0 1-3.7-.9 8.3 8.3 0 0 0-3.8-.8c-1.4 0-2.7.3-3.7.8s-2.3.9-3.8.9-2.8-.4-3.7-.9a8.4 8.4 0 0 0-3.7-.8 8.2 8.2 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.4 3.8-.9a8.1 8.1 0 0 1 3.7-.7c1.4 0 2.7.2 3.7.7a8.3 8.3 0 0 0 7.5 0 8.5 8.5 0 0 1 7.5.1 8.1 8.1 0 0 0 3.7.8v-2.3"
    />
    <path
      fill="#005bbf"
      d="M149.6 322a7 7 0 0 1-3.7-.8 8.3 8.3 0 0 0-3.8-.7c-1.4 0-2.7.2-3.7.7-1 .6-2.3.9-3.8.9s-2.8-.4-3.7-.9a8.4 8.4 0 0 0-3.7-.8 8 8 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.3 3.8-.9a10.2 10.2 0 0 1 7.4 0 7 7 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.8 3.7.8V322"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M149.6 322a7 7 0 0 1-3.7-.8 8.3 8.3 0 0 0-3.8-.7c-1.4 0-2.7.2-3.7.7-1 .6-2.3.9-3.8.9s-2.8-.4-3.7-.9a8.4 8.4 0 0 0-3.7-.8 8 8 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.3 3.8-.9a10.2 10.2 0 0 1 7.4 0 7 7 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.8 3.7.8V322"
    />
    <path
      fill="#ccc"
      d="M149.6 326.7a8 8 0 0 1-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.9 10.2 10.2 0 0 1 7.4 0 8 8 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.8-.8 1.4 0 2.7.3 3.7.8s2.3.8 3.7.8v2.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M149.6 326.7a8 8 0 0 1-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.9 10.2 10.2 0 0 1 7.4 0 8 8 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.8-.8 1.4 0 2.7.3 3.7.8s2.3.8 3.7.8v2.3"
    />
    <path
      fill="#005bbf"
      d="M149.6 329a8.1 8.1 0 0 1-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.7.3 3.7.7a8.4 8.4 0 0 0 7.5 0c1-.4 2.3-.7 3.8-.7 1.4 0 2.7.3 3.7.8s2.2.8 3.7.8v2.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M149.6 329a8.1 8.1 0 0 1-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.7.3 3.7.7a8.4 8.4 0 0 0 7.5 0c1-.4 2.3-.7 3.8-.7 1.4 0 2.7.3 3.7.8s2.2.8 3.7.8v2.3z"
    />
    <path
      fill="#c8b100"
      d="M126.2 308l.2.5c0 1.5-1.3 2.6-2.7 2.6h22a2.7 2.7 0 0 1-2.7-2.6v-.5a1.3 1.3 0 0 1-.3 0h-16a1.4 1.4 0 0 1-.5 0"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M126.2 308l.2.5c0 1.5-1.3 2.6-2.7 2.6h22a2.7 2.7 0 0 1-2.7-2.6v-.5a1.3 1.3 0 0 1-.3 0h-16a1.4 1.4 0 0 1-.5 0z"
    />
    <path
      fill="#c8b100"
      d="M126.6 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.5 0-1-.3-1-.8 0-.4.5-.7 1-.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M126.6 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.5 0-1-.3-1-.8 0-.4.5-.7 1-.7z"
    />
    <path fill="#c8b100" d="M123.7 316.7h22V311h-22v5.6z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M123.7 316.7h22V311h-22v5.6z"
    />
    <path
      fill="#ad1519"
      d="M122 286.7c-2.2 1.2-3.7 2.5-3.4 3.2 0 .6.8 1 1.8 1.6 1.5 1.1 2.5 3 1.7 4a5.5 5.5 0 0 0-.1-8.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M122 286.7c-2.2 1.2-3.7 2.5-3.4 3.2 0 .6.8 1 1.8 1.6 1.5 1.1 2.5 3 1.7 4a5.5 5.5 0 0 0-.1-8.8z"
    />
    <path fill="#ccc" d="M126.8 305.6h15.6V229h-15.6v76.5z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M138 229.2v76.3m1.7-76.3v76.3m-12.9 0h15.6v-76.4h-15.6v76.5z"
    />
    <path
      fill="#ad1519"
      d="M158.4 257.7a49.6 49.6 0 0 0-23.3-2c-9.4 1.6-16.5 5.3-15.9 8.4v.2l-3.5-8.2c-.6-3.3 7.2-7.5 17.6-9.2a43 43 0 0 1 9.2-.7c6.6 0 12.4.8 15.8 2.1v9.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M158.4 257.7a49.6 49.6 0 0 0-23.3-2c-9.4 1.6-16.5 5.3-15.9 8.4v.2l-3.5-8.2c-.6-3.3 7.2-7.5 17.6-9.2a43 43 0 0 1 9.2-.7c6.6 0 12.4.8 15.8 2.1v9.4"
    />
    <path
      fill="#ad1519"
      d="M126.8 267.3c-4.3-.3-7.3-1.4-7.6-3.2-.3-1.5 1.2-3 3.8-4.5 1.2.1 2.5.3 3.8.3v7.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M126.8 267.3c-4.3-.3-7.3-1.4-7.6-3.2-.3-1.5 1.2-3 3.8-4.5 1.2.1 2.5.3 3.8.3v7.4"
    />
    <path
      fill="#ad1519"
      d="M142.5 261.5c2.7.4 4.7 1 5.7 1.9l.1.2c.5 1-1.9 3-5.9 5.4v-7.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M142.5 261.5c2.7.4 4.7 1 5.7 1.9l.1.2c.5 1-1.9 3-5.9 5.4v-7.5"
    />
    <path
      fill="#ad1519"
      d="M117.1 282c-.4-1.2 3.8-3.6 9.8-5.8l7.8-3.2c8.3-3.7 14.4-7.9 13.6-9.4v-.2c.4.4 1 8 1 8 .8 1.3-4.8 5.5-12.4 9.1-2.5 1.2-7.6 3-10 4-4.4 1.4-8.7 4.3-8.3 5.3l-1.5-7.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M117.1 282c-.4-1.2 3.8-3.6 9.8-5.8l7.8-3.2c8.3-3.7 14.4-7.9 13.6-9.4v-.2c.4.4 1 8 1 8 .8 1.3-4.8 5.5-12.4 9.1-2.5 1.2-7.6 3-10 4-4.4 1.4-8.7 4.3-8.3 5.3l-1.5-7.7z"
    />
    <path
      fill="#c8b100"
      d="M125.8 254c1.9-.6 3.1-1.5 2.5-3-.4-1-1.4-1-2.8-.6l-2.6 1 2.3 5.8.8-.3.8-.3-1-2.5zm-1.2-2.7l.7-.3c.5-.2 1.2.1 1.4.8.2.5.2 1-.5 1.5a4.4 4.4 0 0 1-.6.3l-1-2.3m7.3-2.5l-.9.3h-.8l1.3 6.1 4.3-.8-.2-.4v-.4l-2.5.6-1.2-5.3m8.4 5.2c.8-2.2 1.7-4.3 2.7-6.4a5.3 5.3 0 0 1-1 0 54.8 54.8 0 0 1-1.8 4.6l-2.4-4.3-1 .1h-1a131.4 131.4 0 0 1 3.5 6h1m8.8-4.7l.4-.9a3.4 3.4 0 0 0-1.7-.6c-1.7-.1-2.7.6-2.8 1.7-.2 2.1 3.2 2 3 3.4 0 .6-.7.9-1.4.8-.8 0-1.4-.5-1.4-1.2h-.3a7.3 7.3 0 0 1-.4 1.1 4 4 0 0 0 1.8.6c1.7.2 3-.5 3.2-1.7.2-2-3.3-2.1-3.1-3.4 0-.5.4-.8 1.3-.7.7 0 1 .4 1.2.9h.2"
    />
    <path
      fill="#ad1519"
      d="M277.9 211.6s-.7.8-1.3.9c-.5 0-1.1-.5-1.1-.5s-.5.5-1 .6c-.6.1-1.4-.6-1.4-.6l-1 1c-.6 0-1.1-.3-1.1-.3s-.3.4-.7.6h-.4l-.6-.4-.7-.7-.5-.3-.4-1v-.5c-.1-.6.8-1.4 2.2-1.7a3.9 3.9 0 0 1 2 0c.5-.5 1.7-.8 3-.8s2.4.3 3 .7a5.5 5.5 0 0 1 2.9-.7c1.3 0 2.5.3 3 .8.5-.2 1.2-.2 2 0 1.4.3 2.3 1 2.2 1.7v.5l-.4 1-.6.3-.6.7-.6.3s-.3.2-.4 0c-.4-.1-.7-.5-.7-.5s-.6.4-1 .2c-.5-.2-1-1-1-1s-.9.8-1.4.7c-.6-.1-1-.6-1-.6s-.7.6-1.2.5c-.5-.1-1.2-.9-1.2-.9"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M277.9 211.6s-.7.8-1.3.9c-.5 0-1.1-.5-1.1-.5s-.5.5-1 .6c-.6.1-1.4-.6-1.4-.6l-1 1c-.6 0-1.1-.3-1.1-.3s-.3.4-.7.6h-.4l-.6-.4-.7-.7-.5-.3-.4-1v-.5c-.1-.6.8-1.4 2.2-1.7a3.9 3.9 0 0 1 2 0c.5-.5 1.7-.8 3-.8s2.4.3 3 .7a5.5 5.5 0 0 1 2.9-.7c1.3 0 2.5.3 3 .8.5-.2 1.2-.2 2 0 1.4.3 2.3 1 2.2 1.7v.5l-.4 1-.6.3-.6.7-.6.3s-.3.2-.4 0c-.4-.1-.7-.5-.7-.5s-.6.4-1 .2c-.5-.2-1-1-1-1s-.9.8-1.4.7c-.6-.1-1-.6-1-.6s-.7.6-1.2.5c-.5-.1-1.2-.9-1.2-.9z"
    />
    <path
      fill="#c8b100"
      d="M276.5 207.6c0-1 .6-2 1.3-2 .8 0 1.3 1 1.3 2s-.5 1.8-1.3 1.8c-.7 0-1.3-.8-1.3-1.9"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M276.5 207.6c0-1 .6-2 1.3-2 .8 0 1.3 1 1.3 2s-.5 1.8-1.3 1.8c-.7 0-1.3-.8-1.3-1.9z"
    />
    <path
      fill="#c8b100"
      d="M277.3 207.6c0-1 .2-1.8.5-1.8.4 0 .7.8.7 1.8s-.3 1.7-.6 1.7c-.4 0-.6-.8-.6-1.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M277.3 207.6c0-1 .2-1.8.5-1.8.4 0 .7.8.7 1.8s-.3 1.7-.6 1.7c-.4 0-.6-.8-.6-1.8z"
    />
    <path
      fill="#c8b100"
      d="M271 215.3a4.5 4.5 0 0 0-.5-1 27.4 27.4 0 0 1 14.8 0l-.6.8a5.2 5.2 0 0 0-.3.8 22.9 22.9 0 0 0-6.6-.8c-2.6 0-5.2.3-6.6.8l-.2-.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M271 215.3a4.5 4.5 0 0 0-.5-1 27.4 27.4 0 0 1 14.8 0l-.6.8a5.2 5.2 0 0 0-.3.8 22.9 22.9 0 0 0-6.6-.8c-2.6 0-5.2.3-6.6.8l-.2-.6"
    />
    <path
      fill="#c8b100"
      d="M277.8 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4a24.1 24.1 0 0 0-6.5-.8c-2.5 0-5 .3-6.4.8-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M277.8 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4a24.1 24.1 0 0 0-6.5-.8c-2.5 0-5 .3-6.4.8-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6z"
    />
    <path
      fill="#fff"
      d="M283.5 208.4c0-.2.2-.4.4-.4s.5.2.5.4-.2.4-.5.4a.4.4 0 0 1-.4-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.2}
      d="M283.5 208.4c0-.2.2-.4.4-.4s.5.2.5.4-.2.4-.5.4a.4.4 0 0 1-.4-.4zm-.2-1.4a.4.4 0 0 1 .4-.4c.2 0 .4.1.4.4s-.2.4-.4.4a.4.4 0 0 1-.4-.4zm-1.1-1c0-.2.2-.3.4-.3s.4.1.4.4c0 .2-.2.4-.4.4a.4.4 0 0 1-.4-.5zm-1.4-.4c0-.2.2-.4.4-.4.3 0 .5.2.5.4s-.2.4-.4.4-.5-.2-.5-.4zm-1.4 0c0-.2.2-.3.5-.3s.4.1.4.4c0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.4z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.3}
      d="M287.8 211.2l.2-1a2.7 2.7 0 0 0-2.7-2.8c-.5 0-1 .1-1.3.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M283 209.2l.2-.8c0-1.1-1.1-2-2.5-2-.6 0-1.2.2-1.6.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.2}
      d="M288.2 210c0-.3.2-.5.4-.5s.4.2.4.4c0 .3-.2.4-.4.4s-.4-.1-.4-.4zm-.2-1.6c0-.2.2-.4.4-.4a.4.4 0 0 1 .5.4c0 .2-.2.4-.4.4-.3 0-.5-.2-.5-.4zm-1-1.1a.4.4 0 0 1 .5-.4c.2 0 .4.1.4.4a.4.4 0 0 1-.4.4.4.4 0 0 1-.5-.4zm-1.3-.7c0-.2.2-.4.5-.4s.4.2.4.4c0 .3-.2.5-.4.5a.4.4 0 0 1-.5-.5zm-1.4.1c0-.2.2-.4.5-.4s.4.2.4.4-.2.4-.4.4-.5-.2-.5-.4z"
    />
    <path
      fill="#c8b100"
      d="M285.3 213.2l-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.3.6-1.1.7-1.4-.6-1.4-.6-.4.7-1 1c-.5 0-1.2-.4-1.2-.4l-.1.5-.3.1.1.5a27 27 0 0 1 7.3-.9c2.8 0 5.4.4 7.3 1l.2-.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M285.3 213.2l-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.3.6-1.1.7-1.4-.6-1.4-.6-.4.7-1 1c-.5 0-1.2-.4-1.2-.4l-.1.5-.3.1.1.5a27 27 0 0 1 7.3-.9c2.8 0 5.4.4 7.3 1l.2-.6z"
    />
    <path
      fill="#fff"
      d="M271.3 208.4c0-.2.2-.4.4-.4s.4.2.4.4a.4.4 0 0 1-.4.4.4.4 0 0 1-.4-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.2}
      d="M271.3 208.4c0-.2.2-.4.4-.4s.4.2.4.4a.4.4 0 0 1-.4.4.4.4 0 0 1-.4-.4zm.2-1.4c0-.3.2-.4.4-.4s.5.1.5.4-.2.4-.5.4a.4.4 0 0 1-.4-.4zm1-1c0-.2.3-.3.5-.3s.5.1.5.4c0 .2-.2.4-.5.4a.4.4 0 0 1-.4-.5zm1.4-.4c0-.2.2-.4.5-.4s.4.2.4.4-.2.4-.4.4-.5-.2-.5-.4zm1.4 0c0-.2.2-.3.5-.3.2 0 .4.1.4.4 0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.4z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.3}
      d="M267.8 211.2a2.8 2.8 0 0 1-.2-1 2.7 2.7 0 0 1 2.7-2.8c.5 0 1 .1 1.4.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M272.7 209.2a1.7 1.7 0 0 1-.3-.8c0-1 1.2-2 2.6-2a3 3 0 0 1 1.5.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.2}
      d="M266.6 210c0-.3.2-.5.4-.5.3 0 .4.2.4.4a.4.4 0 0 1-.4.4c-.2 0-.4-.1-.4-.4zm.1-1.6c0-.2.3-.4.5-.4s.4.2.4.4-.2.4-.4.4-.4-.2-.4-.4zm1-1.1c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4.4.4 0 0 1-.5-.4zm1.3-.7c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.4.4 0 0 1-.5-.5zm1.4.1c0-.2.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4c-.3 0-.5-.2-.5-.4z"
    />
    <path
      fill="#c8b100"
      d="M277.9 210.7h.2a1 1 0 0 0 0 .4c0 .6.5 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1a.7.7 0 0 0 0-.1l.4-.4.2.5a1 1 0 0 0-.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4s.7-.7.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6a1.5 1.5 0 0 1-.7.2c-.6 0-1.2-.3-1.4-.8a1.5 1.5 0 0 1-1.1.5c-.5 0-1-.2-1.2-.6a1.5 1.5 0 0 1-1 .4c-.6 0-1-.2-1.4-.6-.2.4-.7.6-1.2.6-.4 0-.8-.1-1-.4a1.6 1.6 0 0 1-1.3.6c-.4 0-.8-.2-1.1-.5-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2a4.2 4.2 0 0 1-1-1l.1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 1 1 0 0 0 0-.4v-.5l.4.4v.1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.6 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M277.9 210.7h.2a1 1 0 0 0 0 .4c0 .6.5 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1a.7.7 0 0 0 0-.1l.4-.4.2.5a1 1 0 0 0-.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4s.7-.7.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6a1.5 1.5 0 0 1-.7.2c-.6 0-1.2-.3-1.4-.8a1.5 1.5 0 0 1-1.1.5c-.5 0-1-.2-1.2-.6a1.5 1.5 0 0 1-1 .4c-.6 0-1-.2-1.4-.6-.2.4-.7.6-1.2.6-.4 0-.8-.1-1-.4a1.6 1.6 0 0 1-1.3.6c-.4 0-.8-.2-1.1-.5-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2a4.2 4.2 0 0 1-1-1l.1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 1 1 0 0 0 0-.4v-.5l.4.4v.1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.6 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.2z"
    />
    <path
      fill="#c8b100"
      d="M277.8 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3c2-.6 4.6-1 7.5-1 3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27 27 0 0 0-7.4-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M277.8 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3c2-.6 4.6-1 7.5-1 3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27 27 0 0 0-7.4-1z"
    />
    <path
      fill="#fff"
      d="M275 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4c-.3 0-.5-.2-.5-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M275 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4c-.3 0-.5-.2-.5-.4z"
    />
    <path
      fill="#ad1519"
      d="M277.9 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1-.3.3h-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M277.9 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1-.3.3h-1"
    />
    <path
      fill="#058e6e"
      d="M273.2 214.9h-.6a.3.3 0 0 1-.4-.2.3.3 0 0 1 .3-.3l.6-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1-.3.4h-.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M273.2 214.9h-.6a.3.3 0 0 1-.4-.2.3.3 0 0 1 .3-.3l.6-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1-.3.4h-.7"
    />
    <path fill="#ad1519" d="M270.5 215.3l.3-.4h.7l-.4.6-.6-.2" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M270.5 215.3l.3-.4h.7l-.4.6-.6-.2"
    />
    <path
      fill="#fff"
      d="M279.8 214.4c0-.3.2-.4.4-.4.3 0 .5.1.5.4 0 .2-.2.4-.5.4a.4.4 0 0 1-.4-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M279.8 214.4c0-.3.2-.4.4-.4.3 0 .5.1.5.4 0 .2-.2.4-.5.4a.4.4 0 0 1-.4-.4z"
    />
    <path
      fill="#058e6e"
      d="M282.5 214.9h.7a.3.3 0 0 0 .3-.2.3.3 0 0 0-.2-.3l-.7-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M282.5 214.9h.7a.3.3 0 0 0 .3-.2.3.3 0 0 0-.2-.3l-.7-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7"
    />
    <path fill="#ad1519" d="M285.1 215.4l-.2-.5h-.7l.3.6.6-.1" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M285.1 215.4l-.2-.5h-.7l.3.6.6-.1"
    />
    <path
      fill="#ad1519"
      d="M277.8 217.1a25 25 0 0 1-6-.6 25.4 25.4 0 0 1 6-.7c2.4 0 4.5.3 6.1.7-1.6.4-3.7.6-6 .6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.3}
      d="M277.8 217.1a25 25 0 0 1-6-.6 25.4 25.4 0 0 1 6-.7c2.4 0 4.5.3 6.1.7-1.6.4-3.7.6-6 .6z"
    />
    <path
      fill="#c8b100"
      d="M285.2 212l-.1-.3c-.2 0-.3 0-.4.2l.1.4c.2 0 .3 0 .4-.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M285.2 212l-.1-.3c-.2 0-.3 0-.4.2l.1.4c.2 0 .3 0 .4-.3z"
    />
    <path
      fill="#c8b100"
      d="M280.6 211.2c0-.2-.1-.4-.3-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4l.3-.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M280.6 211.2c0-.2-.1-.4-.3-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4l.3-.3z"
    />
    <path
      fill="#c8b100"
      d="M275.2 211.2c0-.2 0-.4.2-.4l.3.3-.2.4c-.2 0-.3-.2-.3-.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M275.2 211.2c0-.2 0-.4.2-.4l.3.3-.2.4c-.2 0-.3-.2-.3-.3z"
    />
    <path
      fill="#c8b100"
      d="M270.5 212l.1-.3c.2 0 .3 0 .4.2l-.1.4c-.2 0-.3 0-.4-.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M270.5 212l.1-.3c.2 0 .3 0 .4.2l-.1.4c-.2 0-.3 0-.4-.3z"
    />
    <path fill="#c8b100" d="M277.8 208.5l-.8.5.6 1.3.2.1.3-.1.6-1.3-.9-.5" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M277.8 208.5l-.8.5.6 1.3.2.1.3-.1.6-1.3-.9-.5"
    />
    <path fill="#c8b100" d="M276 210.5l.4.5 1.3-.4.1-.2-.1-.2-1.3-.3-.4.6" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M276 210.5l.4.5 1.3-.4.1-.2-.1-.2-1.3-.3-.4.6"
    />
    <path fill="#c8b100" d="M279.6 210.5l-.3.5-1.3-.4-.1-.2v-.2l1.4-.3.4.6" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M279.6 210.5l-.3.5-1.3-.4-.1-.2v-.2l1.4-.3.4.6"
    />
    <path fill="#c8b100" d="M272.5 209l-.7.7.9 1 .2.1.2-.1.2-1.3-.8-.3" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M272.5 209l-.7.7.9 1 .2.1.2-.1.2-1.3-.8-.3"
    />
    <path fill="#c8b100" d="M271.1 211.2l.5.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M271.1 211.2l.5.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6"
    />
    <path fill="#c8b100" d="M274.7 210.5l-.3.6h-1.3l-.2-.2.1-.3 1.2-.6.5.5" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M274.7 210.5l-.3.6h-1.3l-.2-.2.1-.3 1.2-.6.5.5"
    />
    <path fill="#c8b100" d="M269.8 211.4v.6l-1.4.2-.2-.1v-.2l1-.9.6.4" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M269.8 211.4v.6l-1.4.2-.2-.1v-.2l1-.9.6.4"
    />
    <path
      fill="#c8b100"
      d="M272.4 210.9c0-.3.2-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M272.4 210.9c0-.3.2-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4z"
    />
    <path fill="#c8b100" d="M283.2 209l.7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M283.2 209l.7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3"
    />
    <path fill="#c8b100" d="M284.6 211.2l-.5.5-1.2-.6v-.2l.1-.2 1.3-.1.3.6" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M284.6 211.2l-.5.5-1.2-.6v-.2l.1-.2 1.3-.1.3.6"
    />
    <path fill="#c8b100" d="M281 210.5l.3.6h1.3l.2-.2-.1-.3-1.2-.6-.5.5" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M281 210.5l.3.6h1.3l.2-.2-.1-.3-1.2-.6-.5.5"
    />
    <path fill="#c8b100" d="M285.7 211.4v.6l1.4.2.2-.1v-.2l-1-.9-.6.4" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M285.7 211.4v.6l1.4.2.2-.1v-.2l-1-.9-.6.4"
    />
    <path
      fill="#c8b100"
      d="M277.4 210.4c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.5.5 0 0 1-.5-.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M277.4 210.4c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.5.5 0 0 1-.5-.5z"
    />
    <path
      fill="#c8b100"
      d="M282.3 210.9c0-.3.3-.5.5-.5.3 0 .5.2.5.5s-.2.4-.5.4a.5.5 0 0 1-.5-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M282.3 210.9c0-.3.3-.5.5-.5.3 0 .5.2.5.5s-.2.4-.5.4a.5.5 0 0 1-.5-.4z"
    />
    <path
      fill="#c8b100"
      d="M277 205.4c0-.5.4-.8.8-.8s1 .3 1 .8-.5.8-1 .8a.9.9 0 0 1-.8-.8"
    />
    <path
      fill="#c8b100"
      d="M278.5 205.1v.6H277v-.6h.4v-1.3h-.5v-.5h.5v-.6h.6v.6h.6v.6h-.6v1.2h.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M278.5 205.1v.6H277v-.6h.4v-1.3h-.5v-.5h.5v-.6h.6v.6h.6v.6h-.6v1.2h.4z"
    />
    <path
      fill="#c8b100"
      d="M279 205.1v.6h-2.4v-.6h1v-1.3h-.7v-.5h.6v-.6h.6v.6h.6v.6h-.6v1.2h1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M278.1 204.6c.4 0 .6.4.6.8 0 .5-.4.8-.9.8a.9.9 0 0 1-.8-.8c0-.4.2-.7.6-.8"
    />
    <path
      fill="#c8b100"
      d="M268 212.2l-.6-.7a2.3 2.3 0 0 0-.7-.3c0-.1.3-.3.6-.3.2 0 .3 0 .4.2v-.2s.3 0 .4.3v1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M268 212.2l-.6-.7a2.3 2.3 0 0 0-.7-.3c0-.1.3-.3.6-.3.2 0 .3 0 .4.2v-.2s.3 0 .4.3v1z"
    />
    <path
      fill="#c8b100"
      d="M268 212c.1-.2.4-.2.5 0 .2.1.3.3.1.5l-.5-.1c-.1-.1-.2-.4 0-.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M268 212c.1-.2.4-.2.5 0 .2.1.3.3.1.5l-.5-.1c-.1-.1-.2-.4 0-.5z"
    />
    <path
      fill="#c8b100"
      d="M287.5 212.2l.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0-.4.2v-.2s-.3 0-.4.3v.7l.1.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M287.5 212.2l.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0-.4.2v-.2s-.3 0-.4.3v.7l.1.3z"
    />
    <path
      fill="#c8b100"
      d="M287.5 212c-.1-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M287.5 212c-.1-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5z"
    />
    <path fill="#c8b100" d="M267.2 223h21.4v-5.5h-21.4v5.6z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M267.2 223h21.4v-5.5h-21.4v5.6z"
    />
    <path
      fill="#c8b100"
      d="M286.3 226.8a1 1 0 0 0-.4 0h-16.5c.6-.2 1-.7 1-1.2 0-.6-.4-1.1-1-1.3h17-.1c-.6.2-1 .7-1 1.3 0 .5.4 1 1 1.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M286.3 226.8a1 1 0 0 0-.4 0h-16.5c.6-.2 1-.7 1-1.2 0-.6-.4-1.1-1-1.3h17-.1c-.6.2-1 .7-1 1.3 0 .5.4 1 1 1.2z"
    />
    <path
      fill="#c8b100"
      d="M269.9 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.6 0-1-.4-1-.8s.5-.8 1-.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M269.9 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.6 0-1-.4-1-.8s.5-.8 1-.8z"
    />
    <path
      fill="#c8b100"
      d="M269.9 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.6 0-1-.2-1-.6 0-.3.4-.6 1-.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M269.9 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.6 0-1-.2-1-.6 0-.3.4-.6 1-.6z"
    />
    <path
      fill="#005bbf"
      d="M263 317.4c1.4 0 2.7-.3 3.7-.8a8.4 8.4 0 0 1 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.8a8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.8 3.8.8v2.4a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.8c-1.4 0-2.7.3-3.6.8-1 .5-2.3.9-3.8.9a8 8 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v-2.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M263 317.4c1.4 0 2.7-.3 3.7-.8a8.4 8.4 0 0 1 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.8a8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.8 3.8.8v2.4a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.8c-1.4 0-2.7.3-3.6.8-1 .5-2.3.9-3.8.9a8 8 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v-2.4z"
    />
    <path
      fill="#ccc"
      d="M263 319.8c1.4 0 2.7-.4 3.7-.9s2.3-.8 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8c1.5 0 2.8.3 3.7.8 1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1-3.8-.9 8.1 8.1 0 0 0-3.7-.7c-1.4 0-2.7.2-3.6.7-1 .5-2.3.9-3.8.9a7 7 0 0 1-3.7-.9c-1-.4-2.3-.7-3.8-.7a8.3 8.3 0 0 0-3.7.7 8.1 8.1 0 0 1-3.8.9v-2.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M263 319.8c1.4 0 2.7-.4 3.7-.9s2.3-.8 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8c1.5 0 2.8.3 3.7.8 1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1-3.8-.9 8.1 8.1 0 0 0-3.7-.7c-1.4 0-2.7.2-3.6.7-1 .5-2.3.9-3.8.9a7 7 0 0 1-3.7-.9c-1-.4-2.3-.7-3.8-.7a8.3 8.3 0 0 0-3.7.7 8.1 8.1 0 0 1-3.8.9v-2.3"
    />
    <path
      fill="#005bbf"
      d="M263 322c1.4 0 2.7-.2 3.7-.8 1-.4 2.3-.7 3.7-.7 1.4 0 2.8.2 3.8.7s2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .6-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.8-3.8.8V322"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M263 322c1.4 0 2.7-.2 3.7-.8 1-.4 2.3-.7 3.7-.7 1.4 0 2.8.2 3.8.7s2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .6-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.8-3.8.8V322"
    />
    <path
      fill="#ccc"
      d="M263 326.7a8 8 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.9a8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8a8.3 8.3 0 0 0 3.8.8v-2.3a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .5-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.8-3.8.8v2.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M263 326.7a8 8 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.9a8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8a8.3 8.3 0 0 0 3.8.8v-2.3a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .5-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.8-3.8.8v2.3"
    />
    <path
      fill="#005bbf"
      d="M263 329a8.1 8.1 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8 1 .5 2.4.8 3.8.8v-2.3a8.3 8.3 0 0 1-3.8-.8 8.2 8.2 0 0 0-3.7-.8 8.4 8.4 0 0 0-3.6.7 8.2 8.2 0 0 1-3.8.9c-1.4 0-2.8-.3-3.7-.8-1-.5-2.3-.8-3.8-.8-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v2.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M263 329a8.1 8.1 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8 1 .5 2.4.8 3.8.8v-2.3a8.3 8.3 0 0 1-3.8-.8 8.2 8.2 0 0 0-3.7-.8 8.4 8.4 0 0 0-3.6.7 8.2 8.2 0 0 1-3.8.9c-1.4 0-2.8-.3-3.7-.8-1-.5-2.3-.8-3.8-.8-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v2.3z"
    />
    <path
      fill="#c8b100"
      d="M286.3 308l-.1.5c0 1.5 1.2 2.6 2.7 2.6h-22c1.5 0 2.7-1.2 2.7-2.6l-.1-.5h16.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M286.3 308l-.1.5c0 1.5 1.2 2.6 2.7 2.6h-22c1.5 0 2.7-1.2 2.7-2.6l-.1-.5h16.8z"
    />
    <path
      fill="#c8b100"
      d="M269.9 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.6 0-1-.3-1-.8 0-.4.5-.7 1-.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M269.9 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.6 0-1-.3-1-.8 0-.4.5-.7 1-.7z"
    />
    <path fill="#c8b100" d="M266.9 316.7h22V311h-22v5.6z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M266.9 316.7h22V311h-22v5.6z"
    />
    <path
      fill="#ad1519"
      d="M290.6 286.7c2.1 1.2 3.6 2.5 3.4 3.2-.1.6-.8 1-1.8 1.6-1.6 1.1-2.5 3-1.8 4a5.5 5.5 0 0 1 .2-8.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M290.6 286.7c2.1 1.2 3.6 2.5 3.4 3.2-.1.6-.8 1-1.8 1.6-1.6 1.1-2.5 3-1.8 4a5.5 5.5 0 0 1 .2-8.8z"
    />
    <path fill="#ccc" d="M270.1 305.6h15.6V229h-15.6v76.5z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M281.4 229.1v76.3m1.8-76.3v76.3m-13 .2h15.5V229h-15.6v76.5z"
    />
    <path
      fill="#ad1519"
      d="M254.2 257.7a49.6 49.6 0 0 1 23.3-2c9.3 1.6 16.4 5.3 15.9 8.4v.2l3.5-8.2c.6-3.3-7.3-7.5-17.6-9.2a53.5 53.5 0 0 0-9.2-.7c-6.7 0-12.4.8-15.9 2.1v9.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M254.2 257.7a49.6 49.6 0 0 1 23.3-2c9.3 1.6 16.4 5.3 15.9 8.4v.2l3.5-8.2c.6-3.3-7.3-7.5-17.6-9.2a53.5 53.5 0 0 0-9.2-.7c-6.7 0-12.4.8-15.9 2.1v9.4"
    />
    <path
      fill="#ad1519"
      d="M285.7 267.3c4.4-.3 7.3-1.4 7.7-3.2.2-1.5-1.2-3-3.8-4.5-1.2.1-2.5.3-3.9.3v7.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M285.7 267.3c4.4-.3 7.3-1.4 7.7-3.2.2-1.5-1.2-3-3.8-4.5-1.2.1-2.5.3-3.9.3v7.4"
    />
    <path
      fill="#ad1519"
      d="M270 261.5a13 13 0 0 0-5.7 1.9v.2c-.5 1 1.8 3 5.8 5.4v-7.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M270 261.5a13 13 0 0 0-5.7 1.9v.2c-.5 1 1.8 3 5.8 5.4v-7.5"
    />
    <path
      fill="#ad1519"
      d="M295.4 282c.4-1.2-3.8-3.6-9.7-5.8-2.8-1-5-2-7.8-3.2-8.3-3.7-14.4-7.9-13.6-9.4v-.2c-.4.4-1 8-1 8-.8 1.3 4.8 5.5 12.4 9.1 2.4 1.2 7.6 3 10 4 4.3 1.4 8.7 4.3 8.3 5.3l1.4-7.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M295.4 282c.4-1.2-3.8-3.6-9.7-5.8-2.8-1-5-2-7.8-3.2-8.3-3.7-14.4-7.9-13.6-9.4v-.2c-.4.4-1 8-1 8-.8 1.3 4.8 5.5 12.4 9.1 2.4 1.2 7.6 3 10 4 4.3 1.4 8.7 4.3 8.3 5.3l1.4-7.7z"
    />
    <path
      fill="#c8b100"
      d="M263.9 254.4c.6-2.3 1.4-4.4 2.1-6.6h-.5a5.2 5.2 0 0 1-.5.1 52.8 52.8 0 0 1-1.4 4.8c-1-1.4-2-2.7-2.7-4.1l-1 .2h-1a131.3 131.3 0 0 1 4 5.7h.5l.5-.1m6-6.6h-1a8 8 0 0 1-.8 0v6.2h4.2v-.7h-2.6l.1-5.5m6.8 1l2 .3v-.7l-5.8-.5v.8a19.3 19.3 0 0 1 2 0l-.4 5.6h1.6l.5-5.4m2.4 6c.3 0 .5 0 .8.2l.8.2.7-2.9.6 1.2.8 2.1 1 .2c.4 0 .7.2 1 .3l-.3-.7c-.4-1-1-1.9-1.3-2.9 1 0 1.9-.3 2.1-1.2.1-.6 0-1-.7-1.5-.4-.3-1.2-.4-1.7-.5l-2.4-.5-1.4 6m3-5.2c.7.2 1.5.3 1.5 1v.5c-.3.9-1 1.2-2 .9l.5-2.4m8 7l-.2 2 .8.5.9.5.5-7a3.4 3.4 0 0 1-.7-.3l-6.1 3.8.5.3.4.2 1.7-1.2 2.3 1.3zm-1.7-1.5l2-1.4-.2 2.3-1.8-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M182.2 192.4c0-1 1-2 2-2s2.2 1 2.2 2c0 1.1-1 2-2.1 2a2 2 0 0 1-2.1-2z"
    />
    <path
      fill="#ad1519"
      stroke="#000"
      strokeWidth={0.3}
      d="M205.7 175.4c6.3 0 12 1 15.7 2.4a31.7 31.7 0 0 0 14.6 2.3c2.7 0 6.5.8 10.3 2.4a27.3 27.3 0 0 1 7.4 4.7l-1.5 1.4-.4 3.8-4.1 4.7-2 1.8-5 3.9-2.5.2-.7 2.1-31.6-3.7-31.7 3.7-.8-2.1-2.5-.2-4.9-4-2-1.7-4.1-4.7-.5-3.8-1.5-1.4a27.6 27.6 0 0 1 7.5-4.7 26 26 0 0 1 10.2-2.4c2 .2 4.2.1 6.6-.2a30 30 0 0 0 8-2c3.7-1.5 9-2.5 15.5-2.5z"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.4}
      d="M206.2 217.1c-11.8 0-22.4-1.4-29.9-3.6a1.1 1.1 0 0 1-.8-1.2c0-.5.3-1 .8-1.2a109 109 0 0 1 29.9-3.6c11.7 0 22.3 1.4 29.8 3.6a1.3 1.3 0 0 1 0 2.4c-7.5 2.2-18 3.6-29.8 3.6"
    />
    <path
      fill="#ad1519"
      d="M206.1 215.6c-10.6 0-20.2-1.2-27.5-3.1 7.3-2 16.9-3 27.5-3.1a115 115 0 0 1 27.6 3c-7.3 2-17 3.2-27.6 3.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M206.9 215.7v-6.3m-1.7 6.3v-6.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.2}
      d="M203.6 215.7v-6.3m-1.6 6.3v-6.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M200.6 215.7v-6.3m-2.8 5.9v-5.7m1.3 5.8v-6m-3.8 5.6v-5.2m1.3 5.4v-5.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M192 214.8V210m1 4.7V210m1.2 5v-5m-3.4 4.7v-4.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.5}
      d="M189.7 214.5v-4.2m-1.2 4.1v-4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.6}
      d="M186 214v-3m1.3 3.2v-3.5m-2.5 3.1V211"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.7}
      d="M183.7 213.6v-2.3m-1.3 2v-1.8m-1.2 1.6v-1.3"
    />
    <path fill="none" stroke="#000" strokeWidth={0.9} d="M179.8 212.8v-.7" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M213.7 215.3v-5.8m-2.9 6v-6.1m-2.1 6.2v-6.3"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.4}
      d="M206 207.4a108 108 0 0 0-30 3.9c.6-.3.5-1-.3-3-1-2.5-2.4-2.4-2.4-2.4 8.3-2.5 20-4 32.8-4a123 123 0 0 1 33 4s-1.5-.1-2.5 2.3c-.8 2-.8 2.8-.2 3-7.5-2.2-18.4-3.7-30.3-3.7"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.4}
      d="M206.1 201.9c-12.9 0-24.5 1.5-32.8 4a1 1 0 0 1-1.3-.6 1 1 0 0 1 .7-1.3 121 121 0 0 1 33.4-4.2c13.2 0 25.2 1.7 33.5 4.2.6.2.9.8.7 1.3-.2.5-.8.8-1.3.6-8.4-2.5-20-4-32.9-4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.4}
      d="M206.1 215.6c-10.6 0-20.2-1.2-27.5-3.1 7.3-2 16.9-3 27.5-3.1a115 115 0 0 1 27.6 3c-7.3 2-17 3.2-27.6 3.2z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.4}
      d="M197 204.8c0-.5.4-1 1-1 .5 0 1 .5 1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="#ad1519"
      stroke="#000"
      strokeWidth={0.4}
      d="M206.1 205.6H203a1 1 0 0 1 0-2h6.4c.5 0 1 .5 1 1s-.5 1-1 1h-3.2"
    />
    <path
      fill="#058e6e"
      stroke="#000"
      strokeWidth={0.4}
      d="M190.3 206.5l-2.3.2c-.6.1-1-.3-1.2-.8a1 1 0 0 1 1-1.1l2.2-.3 2.4-.3c.5 0 1 .3 1.1.9.1.5-.3 1-.9 1l-2.3.4"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.4}
      d="M181 206.7c0-.6.5-1 1.1-1 .6 0 1 .4 1 1 0 .5-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="#ad1519"
      stroke="#000"
      strokeWidth={0.4}
      d="M174 208.5l1.2-1.6 3.3.4-2.6 2-1.8-.8"
    />
    <path
      fill="#058e6e"
      stroke="#000"
      strokeWidth={0.4}
      d="M222 206.5l2.3.2c.5.1 1-.3 1.1-.8a1 1 0 0 0-.9-1.1l-2.2-.3-2.4-.3a1 1 0 0 0-1.1.9c-.1.5.3 1 .9 1l2.3.4"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.4}
      d="M213.3 204.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1m15.8 1.9c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="#ad1519"
      stroke="#000"
      strokeWidth={0.4}
      d="M238.2 208.5l-1.1-1.6-3.3.4 2.6 2 1.8-.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M177.3 212.8c7.4-2.1 17.6-3.4 28.8-3.4 11.3 0 21.4 1.3 28.9 3.4"
    />
    <path
      fill="#c8b100"
      d="M182.3 183.8l1.4 1 2-3.2a7.4 7.4 0 0 1-3.6-7.2c.2-4.1 5.2-7.6 11.7-7.6 3.3 0 6.3 1 8.5 2.4 0-.6 0-1.2.2-1.8a17.4 17.4 0 0 0-8.7-2.1c-7.4 0-13.2 4.1-13.5 9.1a8.9 8.9 0 0 0 3 7.6l-1 1.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M182.3 183.8l1.4 1 2-3.2a7.4 7.4 0 0 1-3.6-7.2c.2-4.1 5.2-7.6 11.7-7.6 3.3 0 6.3 1 8.5 2.4 0-.6 0-1.2.2-1.8a17.4 17.4 0 0 0-8.7-2.1c-7.4 0-13.2 4.1-13.5 9.1a8.9 8.9 0 0 0 3 7.6l-1 1.8"
    />
    <path
      fill="#c8b100"
      d="M182.4 183.8a9.3 9.3 0 0 1-4-7.3c0-3.2 2-6.1 5.3-8a8.5 8.5 0 0 0-3.4 6.8 8.9 8.9 0 0 0 3 6.7l-.9 1.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M182.4 183.8a9.3 9.3 0 0 1-4-7.3c0-3.2 2-6.1 5.3-8a8.5 8.5 0 0 0-3.4 6.8 8.9 8.9 0 0 0 3 6.7l-.9 1.8"
    />
    <path
      fill="#c8b100"
      d="M160.1 187.1a8.8 8.8 0 0 1-2.3-5.9c0-1.3.3-2.6 1-3.8 2-4.2 8.4-7.2 16-7.2 2 0 4 .2 5.9.6l-1 1.4a25.5 25.5 0 0 0-4.9-.4c-7 0-12.8 2.7-14.5 6.3a7 7 0 0 0-.7 3.1 7.3 7.3 0 0 0 2.7 5.6l-2.6 4.1-1.3-1 1.7-2.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M160.1 187.1a8.8 8.8 0 0 1-2.3-5.9c0-1.3.3-2.6 1-3.8 2-4.2 8.4-7.2 16-7.2 2 0 4 .2 5.9.6l-1 1.4a25.5 25.5 0 0 0-4.9-.4c-7 0-12.8 2.7-14.5 6.3a7 7 0 0 0-.7 3.1 7.3 7.3 0 0 0 2.7 5.6l-2.6 4.1-1.3-1 1.7-2.8z"
    />
    <path
      fill="#c8b100"
      d="M162.7 173.3a10.5 10.5 0 0 0-4 4.1 8.6 8.6 0 0 0-.9 3.8c0 2.3.9 4.3 2.3 5.9l-1.5 2.5a10.4 10.4 0 0 1-2.3-6.5c0-4 2.5-7.5 6.4-9.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M162.7 173.3a10.5 10.5 0 0 0-4 4.1 8.6 8.6 0 0 0-.9 3.8c0 2.3.9 4.3 2.3 5.9l-1.5 2.5a10.4 10.4 0 0 1-2.3-6.5c0-4 2.5-7.5 6.4-9.8z"
    />
    <path
      fill="#c8b100"
      d="M206 164.4c1.7 0 3.2 1.1 3.5 2.6.3 1.4.4 2.9.4 4.5v1.1c.1 3.3.6 6.3 1.3 8.1l-5.2 5-5.2-5c.7-1.8 1.2-4.8 1.3-8.1v-1.1c0-1.6.2-3.1.4-4.5.3-1.5 1.8-2.6 3.5-2.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M206 164.4c1.7 0 3.2 1.1 3.5 2.6.3 1.4.4 2.9.4 4.5v1.1c.1 3.3.6 6.3 1.3 8.1l-5.2 5-5.2-5c.7-1.8 1.2-4.8 1.3-8.1v-1.1c0-1.6.2-3.1.4-4.5.3-1.5 1.8-2.6 3.5-2.6z"
    />
    <path
      fill="#c8b100"
      d="M206 166c1 0 1.7.6 1.8 1.4.2 1.2.4 2.6.4 4.2v1c.1 3.2.6 6 1.2 7.7l-3.4 3.2-3.4-3.2c.7-1.7 1.1-4.5 1.2-7.7v-1a28.1 28.1 0 0 1 .4-4.2 2 2 0 0 1 1.8-1.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M206 166c1 0 1.7.6 1.8 1.4.2 1.2.4 2.6.4 4.2v1c.1 3.2.6 6 1.2 7.7l-3.4 3.2-3.4-3.2c.7-1.7 1.1-4.5 1.2-7.7v-1a28.1 28.1 0 0 1 .4-4.2 2 2 0 0 1 1.8-1.4z"
    />
    <path
      fill="#c8b100"
      d="M229.7 183.8l-1.3 1-2-3.2a7.4 7.4 0 0 0 3.6-6.3 7 7 0 0 0 0-.9c-.2-4.1-5.3-7.6-11.7-7.6a15 15 0 0 0-8.5 2.4 23 23 0 0 0-.2-1.8 17.4 17.4 0 0 1 8.7-2.1c7.4 0 13.2 4.1 13.4 9.1a8.9 8.9 0 0 1-3 7.6l1 1.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M229.7 183.8l-1.3 1-2-3.2a7.4 7.4 0 0 0 3.6-6.3 7 7 0 0 0 0-.9c-.2-4.1-5.3-7.6-11.7-7.6a15 15 0 0 0-8.5 2.4 23 23 0 0 0-.2-1.8 17.4 17.4 0 0 1 8.7-2.1c7.4 0 13.2 4.1 13.4 9.1a8.9 8.9 0 0 1-3 7.6l1 1.8"
    />
    <path
      fill="#c8b100"
      d="M229.6 183.8a9.1 9.1 0 0 0 4.1-7.3c0-3.2-2.1-6.1-5.3-8a8.5 8.5 0 0 1 3.4 6.8 8.9 8.9 0 0 1-3.2 6.7l1 1.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M229.6 183.8a9.1 9.1 0 0 0 4.1-7.3c0-3.2-2.1-6.1-5.3-8a8.5 8.5 0 0 1 3.4 6.8 8.9 8.9 0 0 1-3.2 6.7l1 1.8"
    />
    <path
      fill="#c8b100"
      d="M252 187.1a8.8 8.8 0 0 0 2.2-5.9 8.7 8.7 0 0 0-.9-3.8c-2-4.2-8.4-7.2-16-7.2a29 29 0 0 0-6 .6l1 1.4a25.4 25.4 0 0 1 5-.4c7 0 12.8 2.7 14.4 6.3.5 1 .7 2 .7 3.1a7.3 7.3 0 0 1-2.6 5.6l2.5 4.1 1.3-1-1.7-2.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M252 187.1a8.8 8.8 0 0 0 2.2-5.9 8.7 8.7 0 0 0-.9-3.8c-2-4.2-8.4-7.2-16-7.2a29 29 0 0 0-6 .6l1 1.4a25.4 25.4 0 0 1 5-.4c7 0 12.8 2.7 14.4 6.3.5 1 .7 2 .7 3.1a7.3 7.3 0 0 1-2.6 5.6l2.5 4.1 1.3-1-1.7-2.8z"
    />
    <path
      fill="#c8b100"
      d="M249.3 173.3a10.6 10.6 0 0 1 4 4.1 8.7 8.7 0 0 1 .9 3.8 8.8 8.8 0 0 1-2.3 5.9l1.6 2.5a10.4 10.4 0 0 0 2.3-6.5c0-4-2.6-7.5-6.5-9.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M249.3 173.3a10.6 10.6 0 0 1 4 4.1 8.7 8.7 0 0 1 .9 3.8 8.8 8.8 0 0 1-2.3 5.9l1.6 2.5a10.4 10.4 0 0 0 2.3-6.5c0-4-2.6-7.5-6.5-9.8z"
    />
    <path
      fill="#fff"
      d="M204.2 181.4c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 0 1-1.8-1.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M204.2 181.4c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 0 1-1.8-1.7z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.4}
      d="M204.2 178c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 0 1-1.8-1.7m.4-3.7c0-.7.6-1.3 1.4-1.3.8 0 1.5.6 1.5 1.3 0 .8-.7 1.4-1.5 1.4s-1.4-.6-1.4-1.4m.4-3.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1m.2-2.8c0-.5.4-.8.8-.8.5 0 .9.3.9.8 0 .4-.4.8-.9.8a.8.8 0 0 1-.8-.8"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.4}
      d="M206.2 191.8l1.2.2a4.6 4.6 0 0 0 4.5 6 4.7 4.7 0 0 0 4.4-3c.1 0 .5-1.7.7-1.7.2 0 .1 1.8.2 1.7.3 2.3 2.4 3.8 4.7 3.8a4.6 4.6 0 0 0 4.7-5l1.5-1.5.7 2a4 4 0 0 0-.4 1.9 4.4 4.4 0 0 0 4.5 4.2c1.6 0 3-.7 3.8-1.9l.9-1.2v1.5c0 1.5.6 2.8 2 3 0 0 1.7.1 4-1.6 2.1-1.7 3.3-3.1 3.3-3.1l.2 1.7s-1.8 2.8-3.8 4c-1 .6-2.7 1.3-4 1-1.4-.2-2.4-1.3-3-2.6a6.7 6.7 0 0 1-3.3 1 6.5 6.5 0 0 1-6.1-3.7 7 7 0 0 1-10.4-.3 7 7 0 0 1-4.6 1.8 6.9 6.9 0 0 1-5.7-3 6.9 6.9 0 0 1-5.7 3 7 7 0 0 1-4.7-1.8 7 7 0 0 1-10.4.3 6.5 6.5 0 0 1-6 3.7 6.7 6.7 0 0 1-3.4-1c-.6 1.3-1.5 2.4-3 2.7-1.2.2-2.9-.5-4-1.1-2-1.2-3.8-4-3.8-4l.2-1.7s1.2 1.4 3.4 3.1c2.2 1.8 3.9 1.6 3.9 1.6 1.4-.2 2-1.5 2-3v-1.5l1 1.2a4.6 4.6 0 0 0 3.7 2c2.5 0 4.5-2 4.5-4.3a4 4 0 0 0-.4-2l.8-1.9 1.5 1.5a4.4 4.4 0 0 0 0 .6c0 2.4 2 4.4 4.6 4.4 2.4 0 4.4-1.5 4.7-3.8 0 0 0-1.6.2-1.7.2 0 .6 1.7.7 1.6a4.7 4.7 0 0 0 4.5 3.1 4.6 4.6 0 0 0 4.5-6l1.2-.2"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.4}
      d="M238.6 197.7c.3-.8 0-1.6-.6-1.8-.5-.2-1.2.3-1.5 1.1-.3.8 0 1.6.6 1.8.5.2 1.2-.3 1.5-1.1m-20.5-4c0-.8-.3-1.6-1-1.6-.5-.1-1 .5-1.2 1.4-.1.8.3 1.5.9 1.6.6 0 1.2-.6 1.3-1.4m-23.9 0c0-.8.4-1.6 1-1.6.6-.1 1.1.5 1.2 1.4.1.8-.3 1.5-.9 1.6-.6 0-1.1-.6-1.2-1.4m-20.6 4c-.2-.8 0-1.6.6-1.8.6-.2 1.2.3 1.5 1.1.3.8 0 1.6-.5 1.8-.6.2-1.3-.3-1.6-1.1"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.4}
      d="M182.7 184a5.1 5.1 0 0 1 2.2 2.9s0-.3.6-.6 1-.3 1-.3l-.1 1.3-.3 2.2a7.4 7.4 0 0 1-.7 1.6 1.9 1.9 0 0 0-1.5-.4 1.8 1.8 0 0 0-1.2.9s-.7-.6-1.2-1.3l-1.1-2-.7-1.1s.5-.2 1.1 0c.6 0 .8.2.8.2a4.9 4.9 0 0 1 1-3.4m.4 9.8a1.8 1.8 0 0 1-.6-1c0-.5 0-.9.3-1.2 0 0-.9-.5-1.8-.7-.7-.2-2-.2-2.3-.2h-1l.2.5c.2.5.5.7.5.7a5 5 0 0 0-3 2 5.3 5.3 0 0 0 3.5 1l-.2.8v.6l1-.4c.3-.1 1.5-.5 2-1 .8-.4 1.5-1.1 1.5-1.1m2.7-.5a1.6 1.6 0 0 0 .2-1.1 1.7 1.7 0 0 0-.6-1l1.4-1.3a10 10 0 0 1 2-.9l1.1-.4v.6a5.7 5.7 0 0 1-.2.8 5 5 0 0 1 3.4 1 5 5 0 0 1-2.9 2 6.4 6.4 0 0 0 .7 1.2h-1c-.4 0-1.6 0-2.3-.2a11 11 0 0 1-1.8-.7"
    />
    <path
      fill="#ad1519"
      stroke="#000"
      strokeWidth={0.4}
      d="M182.2 192.4c0-1 1-2 2-2s2.2 1 2.2 2c0 1.1-1 2-2.1 2a2 2 0 0 1-2.1-2"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.4}
      d="M206.1 180.8a5.7 5.7 0 0 1 1.9 3.7s.2-.3.9-.5c.7-.3 1.2-.2 1.2-.2l-.5 1.4-.8 2.4a8.2 8.2 0 0 1-1 1.7 2.1 2.1 0 0 0-1.7-.7c-.6 0-1.2.3-1.6.7 0 0-.6-.7-1-1.7l-.8-2.4-.5-1.4 1.2.2c.7.2.9.5.9.5 0-1.4.8-2.8 1.8-3.7"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.4}
      d="M204.6 191.8a2 2 0 0 1-.5-1.2c0-.5.1-1 .4-1.3 0 0-.8-.7-1.8-1-.7-.4-2-.7-2.5-.7l-1.2-.2.2.6.4.9a5.9 5.9 0 0 0-3.7 1.7c1 .9 2.3 1.6 3.7 1.6l-.4 1-.2.6 1.2-.2c.4-.1 1.8-.4 2.5-.7 1-.4 1.9-1 1.9-1m3 0a1.9 1.9 0 0 0 .1-2.6s.9-.7 1.8-1a8 8 0 0 1 2.5-.7l1.2-.3-.1.7-.4.9c1.4 0 2.7.8 3.6 1.7a5.9 5.9 0 0 1-3.6 1.6 6.9 6.9 0 0 0 .5 1.6l-1.2-.2-2.5-.7c-1-.4-1.8-1-1.8-1m22-8a5.2 5.2 0 0 0-2.2 3l-.7-.6c-.6-.3-1-.3-1-.3l.2 1.3c0 .3 0 1.3.3 2.2.2 1 .6 1.6.6 1.6a2 2 0 0 1 1.5-.4c.6.1 1 .5 1.3.9l1.1-1.3c.6-.8 1-1.7 1.1-2l.7-1.1s-.4-.2-1 0c-.7 0-1 .2-1 .2a4.9 4.9 0 0 0-1-3.4m-.3 9.8c.3-.3.5-.6.6-1a1.6 1.6 0 0 0-.2-1.2s.8-.5 1.7-.7c.7-.2 2-.2 2.3-.2h1.1l-.3.5a6.2 6.2 0 0 1-.4.7 5 5 0 0 1 2.9 2 5.3 5.3 0 0 1-3.5 1l.2.8v.6l-1-.4c-.3-.1-1.4-.5-2-1-.8-.4-1.4-1.1-1.4-1.1m-2.8-.5a1.7 1.7 0 0 1-.2-1.1c0-.5.3-.8.6-1 0 0-.6-.8-1.4-1.3-.6-.4-1.7-.8-2-.9a171.4 171.4 0 0 1-1-.4v.6c0 .5.2.8.2.8a5.2 5.2 0 0 0-3.5 1c.7.9 1.7 1.7 3 2 0 0-.3.2-.5.7l-.3.5h1c.4 0 1.7 0 2.3-.2a11.1 11.1 0 0 0 1.8-.7"
    />
    <path
      fill="#ad1519"
      stroke="#000"
      strokeWidth={0.4}
      d="M226 192.4c0-1 1-2 2-2s2.1 1 2.1 2a2 2 0 0 1-2 2 2 2 0 0 1-2.1-2m23.2 4.4c-.4-.5-1.4-.4-2.2.2-.8.7-1 1.6-.5 2.2.5.5 1.5.4 2.3-.3.7-.6 1-1.6.5-2"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.4}
      d="M246.3 198l.7-1c.7-.6 1.8-.7 2.3-.2l.1.2s1-2 2.3-2.6c1.3-.7 3.4-.5 3.4-.5a2.8 2.8 0 0 0-2.9-2.8 3 3 0 0 0-2.4 1l-.2-1s-1.3.3-1.9 1.8c-.6 1.5 0 3.6 0 3.6s-.3-.9-.7-1.5a8 8 0 0 0-2.4-1.6l-1.3-.7-.1.5a5 5 0 0 0 0 .8 7.9 7.9 0 0 0-3.7.5 4.7 4.7 0 0 0 2.5 2.2l-.8.7a4 4 0 0 0-.4.5l1.3.2 2.5.2a14.5 14.5 0 0 0 1.7-.2m-80.3 0c0-.4-.3-.7-.7-1-.7-.7-1.7-.8-2.2-.3l-.2.3s-1-2-2.3-2.7c-1.2-.7-3.3-.5-3.3-.5a2.8 2.8 0 0 1 2.8-2.8c1 0 1.9.4 2.4 1l.2-1s1.3.3 2 1.8c.5 1.5-.1 3.6-.1 3.6s.3-.9.8-1.5a8 8 0 0 1 2.4-1.6l1.3-.7v1.3a7.9 7.9 0 0 1 3.7.5 4.7 4.7 0 0 1-2.5 2.2l.8.7.4.5-1.2.2-2.6.2a14.7 14.7 0 0 1-1.7-.2"
    />
    <path
      fill="#ad1519"
      stroke="#000"
      strokeWidth={0.4}
      d="M163 196.8c.6-.5 1.6-.4 2.4.3.7.6 1 1.5.4 2-.5.6-1.5.5-2.2-.2-.8-.6-1-1.6-.5-2m41-6.3c0-1.1.9-2 2-2s2.1.9 2.1 2c0 1-1 2-2 2a2 2 0 0 1-2.1-2"
    />
    <path
      fill="#005bbf"
      stroke="#000"
      strokeWidth={0.3}
      d="M201.8 160.6c0-2.2 1.9-4 4.3-4s4.2 1.8 4.2 4-1.9 4-4.3 4a4.1 4.1 0 0 1-4.2-4"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.3}
      d="M205 149.3v2.2h-2.4v2.2h2.3v6.3H202l-.2.6c0 .6.1 1.1.3 1.6h7.9c.2-.5.3-1 .3-1.6l-.2-.6h-2.8v-6.3h2.3v-2.2h-2.3v-2.2h-2.4z"
    />
    <path
      fill="#ccc"
      d="M206.5 330.6a82 82 0 0 1-35.5-8.2 22.7 22.7 0 0 1-12.8-20.4v-32h96.4v32a22.7 22.7 0 0 1-12.8 20.4 81 81 0 0 1-35.3 8.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.5}
      d="M206.5 330.6a82 82 0 0 1-35.5-8.2 22.7 22.7 0 0 1-12.8-20.4v-32h96.4v32a22.7 22.7 0 0 1-12.8 20.4 81 81 0 0 1-35.3 8.2z"
    />
    <path fill="#ccc" d="M206.3 270h48.3v-53.5h-48.3V270z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.5}
      d="M206.3 270h48.3v-53.5h-48.3V270z"
    />
    <path
      fill="#ad1519"
      d="M206.3 302c0 12.6-10.7 22.9-24 22.9s-24.2-10.3-24.2-23v-32h48.2v32"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.5}
      d="M168.6 320.9c1.5.8 3.6 2 5.8 2.6l-.1-54.7h-5.7v52z"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M158 301.6a24.4 24.4 0 0 0 5.5 15v-47.5h-5.4v32.5z"
    />
    <path
      fill="#c7b500"
      stroke="#000"
      strokeWidth={0.5}
      d="M179.4 324.7a26.6 26.6 0 0 0 5.6 0v-55.9h-5.6v56z"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.5}
      d="M190 323.5a19 19 0 0 0 5.8-2.5v-52.2H190l-.1 54.7z"
    />
    <path fill="#ad1519" d="M158.1 270h48.2v-53.5H158V270z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.5}
      d="M158.1 270h48.2v-53.5H158V270z"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.5}
      d="M201 316c2.4-2 4.6-6.8 5.4-12.2l.1-35H201l.1 47.3z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.5}
      d="M206.3 302c0 12.6-10.7 22.9-24 22.9s-24.2-10.3-24.2-23v-32h48.2v32"
    />
    <path
      fill="#ad1519"
      d="M254.6 270v32c0 12.6-10.8 22.9-24.1 22.9s-24.2-10.3-24.2-23v-32h48.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.5}
      d="M254.6 270v32c0 12.6-10.8 22.9-24.1 22.9s-24.2-10.3-24.2-23v-32h48.3"
    />
    <path
      fill="#c8b100"
      d="M215.1 294.1l.1.5c0 .6-.5 1-1.1 1a1 1 0 0 1-1.1-1v-.5h-1.5a2.5 2.5 0 0 0 1.8 2.9v3.9h1.6V297a2.6 2.6 0 0 0 1.7-1.6h4.4v-1.2h-6m21.8 0v1.2h-4a2.5 2.5 0 0 1-.3.6l4.6 5.2-1.2 1-4.6-5.3-.2.1v8.7h-1.6V297h-.2l-4.8 5.2-1.2-1 4.7-5.3a2.1 2.1 0 0 1-.2-.4h-4V294h13zm2.6 0v1.2h4.4c.3.8.9 1.4 1.7 1.6v3.9h1.6V297a2.5 2.5 0 0 0 1.8-2.4 2 2 0 0 0 0-.5h-1.6l.1.5c0 .6-.5 1-1 1-.7 0-1.2-.4-1.2-1a1 1 0 0 1 .1-.5h-5.9m-6.7 22.1a15.6 15.6 0 0 0 3.7-1l.8 1.4a17.6 17.6 0 0 1-4.3 1.2 2.6 2.6 0 0 1-2.6 2 2.6 2.6 0 0 1-2.5-2 17.5 17.5 0 0 1-4.6-1.2l.8-1.4c1.3.5 2.6.9 4 1a2.5 2.5 0 0 1 1.5-1.3v-6.7h1.6v6.7c.7.2 1.3.7 1.6 1.4zm-11-2.2l-.8 1.4a16.6 16.6 0 0 1-3.6-3.1c-.9.2-1.8 0-2.5-.5a2.4 2.4 0 0 1-.3-3.5l.1-.1a15.3 15.3 0 0 1-1.3-4.8h1.7a13.1 13.1 0 0 0 1 4c.5 0 1 0 1.4.2l4.1-4.5 1.3 1-4.1 4.5c.5.9.5 2-.1 2.8a15.2 15.2 0 0 0 3.1 2.6zm-6-4.8c.3-.4 1-.5 1.5 0s.5 1 .1 1.4a1.2 1.2 0 0 1-1.6.1 1 1 0 0 1 0-1.5zm-2.2-4.5l-1.6-.3-.3-4.3 1.7-.6v2.5c0 1 0 1.8.2 2.7zm1.4-5.3l1.7.4v2.2c0-.8.3 2.1.3 2.1l-1.7.6a14 14 0 0 1-.3-2.7v-2.6zm5.6 13.7a15.7 15.7 0 0 0 4.8 2.6l.4-1.6a13.7 13.7 0 0 1-4-2l-1.2 1m-.8 1.4a17.4 17.4 0 0 0 4.8 2.6l-1.2 1.1a18.7 18.7 0 0 1-4-2l.4-1.7m2.2-9.4l1.6.7 3-3.3-1-1.4-3.6 4m-1.3-1l-1-1.4 3-3.3 1.6.7-3.6 4m18.1 9.9l.8 1.4a16.7 16.7 0 0 0 3.6-3.1c.9.2 1.8 0 2.5-.5a2.4 2.4 0 0 0 .3-3.5l-.1-.1a15 15 0 0 0 1.3-4.8h-1.7a13.3 13.3 0 0 1-1 4 3 3 0 0 0-1.4.2l-4.1-4.5-1.3 1 4.1 4.5a2.4 2.4 0 0 0 .1 2.8 15 15 0 0 1-3.1 2.6zm6-4.8a1.2 1.2 0 0 0-1.5 0 1 1 0 0 0-.1 1.4 1.2 1.2 0 0 0 1.6.1 1 1 0 0 0 0-1.5zm2.2-4.5l1.6-.3.3-4.3-1.7-.6v2.5c0 1 0 1.9-.2 2.8zm-1.4-5.3l-1.7.4v2.2c0-.8-.3 2.1-.3 2.1l1.7.6.3-2.7v-2.6m-5.6 13.7a15.7 15.7 0 0 1-4.8 2.6l-.4-1.6a13.7 13.7 0 0 0 4-2l1.2 1m.8 1.4a17.4 17.4 0 0 1-4.8 2.6l1.2 1.1a18.6 18.6 0 0 0 4-2l-.4-1.7m-2.2-9.4l-1.6.7-2.9-3.3 1-1.4 3.5 4m1.3-1l1-1.4-3-3.3-1.6.7 3.6 4m-20.1-8.7l.5 1.6h4.5l.5-1.6h-5.5m21.1 0l-.5 1.6h-4.5l-.5-1.6h5.5m-11.6 21.9c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1-1.2-1zm1.9-7.8l1.7-.4v-4.3l-1.7-.5v5.2m-1.6 0l-1.7-.4v-4.3l1.7-.5v5.2"
    />
    <path
      fill="#c8b100"
      d="M211.5 294.2c.2-1 1-1.6 1.8-2V287h1.6v5.3c.8.3 1.5.9 1.7 1.6h4.4v.3h-6a1.2 1.2 0 0 0-1-.6c-.4 0-.7.3-1 .6h-1.5m12.2 0v-.3h4.1a2.4 2.4 0 0 1 .2-.3l-5-5.7 1.2-1 5 5.6.2-.1V285h1.6v7.3h.3l4.9-5.5 1.2 1-4.9 5.5.3.6h4v.3h-13zm21.6 0a1.1 1.1 0 0 1 1-.6c.5 0 .8.3 1 .6h1.6c-.2-1-.9-1.6-1.8-2V287h-1.6v5.3c-.8.3-1.4.8-1.7 1.6h-4.4v.3h6m-30.2-15l6 6.8 1.3-1-6.1-6.7.3-.6h4.4V276h-4.4a2.6 2.6 0 0 0-2.5-1.7 2.6 2.6 0 0 0-2.7 2.5 2.5 2.5 0 0 0 1.8 2.4v5.2h1.6v-5.2h.3zm32 0v5.3h-1.7v-5.2a2.5 2.5 0 0 1-.4-.2l-6 6.8-1.3-1 6.2-6.9-.1-.3h-4.5V276h4.5a2.6 2.6 0 0 1 2.4-1.7 2.6 2.6 0 0 1 2.7 2.5 2.5 2.5 0 0 1-1.9 2.4zm-16.1 0v3.3h-1.7v-3.2a2.6 2.6 0 0 1-1.7-1.6h-4V276h4a2.6 2.6 0 0 1 2.5-1.7c1.2 0 2.2.7 2.5 1.7h4v1.6h-4a2.5 2.5 0 0 1-1.6 1.6zm-17.8 4l-1.7.4v4.3l1.7.5v-5.2m1.6 0l1.7.4v4.3l-1.7.5v-5.2m30.6 0l-1.7.4v4.3l1.7.5v-5.2m1.6 0l1.7.4v4.3l-1.7.5v-5.2m-25.5.8l1.6-.7 2.9 3.3-1 1.4-3.5-4m-1.3 1l-1 1.4 3 3.3 1.6-.7-3.6-4m18.5-1.1l-1.6-.7-3 3.3 1 1.4 3.6-4m1.2 1l1 1.4-3 3.3-1.5-.7 3.5-4m-20.3 9l.5-1.6h4.5l.5 1.6h-5.5m-6.7-17c0-.6.5-1 1.2-1a1 1 0 0 1 1 1c0 .6-.4 1-1 1a1.1 1.1 0 0 1-1.2-1zm12.1.8l-.5 1.6h-4.5l-.5-1.6h5.5m0-1.6l-.5-1.6h-4.5l-.5 1.6h5.5m15.7 17.8l-.5-1.6h-4.5l-.5 1.6h5.5m4.4-17c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1-1.2-1zm-16.1 0c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1.1 1a1.1 1.1 0 0 1-1.1-1zm6.2.8l.5 1.6h4.6l.5-1.6h-5.6m0-1.6l.5-1.6h4.6l.5 1.6h-5.6m-5.9 5l-1.7.5v4.3l1.7.5V281m1.7 0l1.6.5v4.3l-1.6.5V281"
    />
    <path
      fill="none"
      stroke="#c8b100"
      strokeWidth={0.3}
      d="M232.7 316.3a15.6 15.6 0 0 0 3.7-1.1l.8 1.4a17.6 17.6 0 0 1-4.3 1.2 2.6 2.6 0 0 1-2.6 2 2.6 2.6 0 0 1-2.5-2 17.5 17.5 0 0 1-4.6-1.2l.8-1.4c1.3.5 2.6.9 4 1a2.5 2.5 0 0 1 1.5-1.3v-6.7h1.6v6.7c.7.2 1.3.7 1.6 1.4zm-4.7-20.4a2.3 2.3 0 0 1-.2-.5h-4V294h4a2.6 2.6 0 0 1 .2-.4l-5-5.6 1.2-1 5 5.5a2.2 2.2 0 0 1 .2 0V285h1.7v7.3h.2l4.9-5.5 1.2 1-4.9 5.5.3.6h4v1.5h-4c0 .2-.2.4-.3.5l4.7 5.3-1.3 1-4.6-5.3-.2.1v8.7h-1.6V297l-.2-.1-4.8 5.3-1.2-1 4.7-5.3m-12.8-16.7l6 6.8 1.3-1-6.1-6.7.3-.6h4.4V276h-4.4a2.6 2.6 0 0 0-2.5-1.7 2.6 2.6 0 0 0-2.6 2.5 2.5 2.5 0 0 0 1.7 2.4v5.2h1.6v-5.2h.3zm6.5 34.8l-.8 1.4a16.6 16.6 0 0 1-3.6-3.1c-.9.2-1.8 0-2.5-.5a2.4 2.4 0 0 1-.3-3.5l.1-.1a15.3 15.3 0 0 1-1.2-4.8h1.6a13.1 13.1 0 0 0 1 4c.5 0 1 0 1.4.2l4.1-4.5 1.3 1-4.1 4.5c.6.9.5 2-.1 2.8a15.2 15.2 0 0 0 3.1 2.6zm-8.4-13.1V297a2.5 2.5 0 0 1-1.8-2.4c0-1 .8-2 1.8-2.4V287h1.6v5.3c.8.2 1.5.8 1.7 1.6h4.4v1.5h-4.4a2.6 2.6 0 0 1-1.6 1.6v3.9h-1.7m2.3 8.3c.4-.4 1.1-.5 1.6 0s.5 1 .1 1.4a1.2 1.2 0 0 1-1.6.1 1 1 0 0 1 0-1.5zm-2-4.5l-1.7-.3-.3-4.3 1.7-.6v2.5c0 1 0 1.8.3 2.7zm1.4-5.3l1.6.4v2.2c0-.8.3 2.1.3 2.1l-1.7.6-.3-2.7v-2.6zm5.5 13.7a15.7 15.7 0 0 0 4.8 2.6l.4-1.6a13.7 13.7 0 0 1-4-2l-1.2 1m-.8 1.4a17.4 17.4 0 0 0 4.8 2.6l-1.2 1.1a18.7 18.7 0 0 1-4-2l.4-1.7"
    />
    <path
      fill="none"
      stroke="#c8b100"
      strokeWidth={0.3}
      d="M221.9 305.1l1.6.7 3-3.3-1-1.4-3.6 4m-1.3-1l-1-1.4 3-3.3 1.6.7-3.6 4m-7.6-9.5c0-.6.5-1 1-1 .7 0 1.2.5 1.2 1 0 .6-.5 1.1-1.1 1.1a1 1 0 0 1-1.1-1zm25.7 19.4l.8 1.4a16.7 16.7 0 0 0 3.6-3.1c.9.2 1.8 0 2.6-.5a2.4 2.4 0 0 0 .2-3.5l-.1-.1a15 15 0 0 0 1.3-4.8h-1.7a13.3 13.3 0 0 1-1 4 3 3 0 0 0-1.4.2l-4.1-4.5-1.3 1 4.1 4.5a2.4 2.4 0 0 0 .1 2.8 15 15 0 0 1-3 2.6zm8.4-13.1V297a2.5 2.5 0 0 0 1.8-2.4c0-1-.7-2-1.8-2.4V287h-1.6v5.3c-.8.2-1.4.8-1.7 1.6h-4.4v1.5h4.4c.3.8.9 1.3 1.7 1.6v3.9h1.6zm-2.3 8.3a1.2 1.2 0 0 0-1.6 0 1 1 0 0 0-.1 1.4 1.2 1.2 0 0 0 1.6.1 1 1 0 0 0 0-1.5zm2-4.5l1.7-.3.3-4.3-1.7-.6v2.5c0 1 0 1.8-.2 2.7zm-1.3-5.3l-1.7.4v2.2c0-.8-.3 2.1-.3 2.1l1.7.6.3-2.7v-2.6m1.6-20.1v5.2h-1.6v-5.2a2.3 2.3 0 0 1-.4-.2l-6 6.8-1.2-1 6-7v-.2h-4.5V276h4.4a2.6 2.6 0 0 1 2.5-1.7 2.6 2.6 0 0 1 2.6 2.5 2.5 2.5 0 0 1-1.8 2.4zm-16 0v3.2h-1.7v-3.2a2.6 2.6 0 0 1-1.7-1.6h-4V276h4c.4-1 1.3-1.7 2.5-1.7s2.2.7 2.5 1.7h4v1.6h-4a2.5 2.5 0 0 1-1.6 1.6zm8.8 33.8a15.7 15.7 0 0 1-4.8 2.6l-.4-1.6a13.7 13.7 0 0 0 4-2l1.2 1m.8 1.4a17.4 17.4 0 0 1-4.8 2.6l1.2 1.1a18.7 18.7 0 0 0 4-2l-.4-1.7m-27.4-31.4l-1.7.5v4.3l1.7.5v-5.2m1.7 0l1.6.4v4.3l-1.6.5V283m30.5 0l-1.7.5v4.3l1.7.5V283"
    />
    <path
      fill="none"
      stroke="#c8b100"
      strokeWidth={0.3}
      d="M247.1 283.1l1.7.5v4.3l-1.7.5V283m-8.6 22l-1.6.7-2.9-3.3 1-1.4 3.5 4m1.3-1l1-1.4-3-3.3-1.6.7 3.6 4m-18.2-20l1.6-.7 3 3.3-1 1.4-3.6-4m-1.3 1l-1 1.4 3 3.3 1.6-.7-3.6-4m18.5-1.1l-1.6-.7-3 3.3 1 1.4 3.6-4m1.2 1l1 1.4-3 3.2-1.5-.6 3.5-4m-20.3 9l.5-1.6h4.5l.5 1.6h-5.5m0 1.5l.5 1.6h4.5l.5-1.6h-5.5M213 277c0-.6.5-1 1.2-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1.2-1zm12.1.8l-.5 1.6h-4.5l-.5-1.6h5.5m0-1.6l-.5-1.6h-4.5l-.5 1.6h5.5m20.1 18.5c0-.5.5-1 1.1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1.1-1 1.1a1 1 0 0 1-1.2-1zm-4.4-.7l-.5-1.6h-4.5l-.5 1.6h5.5m0 1.5l-.5 1.6h-4.5l-.5-1.6h5.5m-11.6 21.9c0-.6.5-1 1.1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1.1 1.1 0 0 1-1.2-1zm1.9-7.8l1.7-.4v-4.3l-1.7-.5v5.2m-1.6 0l-1.7-.4v-4.3l1.7-.5v5.2m15.7-32.6c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1-1.2-1zm-16.1 0c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1-1.2-1zm6.2.8l.5 1.6h4.6l.5-1.6h-5.5m0-1.6l.4-1.6h4.6l.5 1.6h-5.5m-6 5l-1.6.5v4.3l1.6.5V281m1.7 0l1.6.5v4.3l-1.6.5V281"
    />
    <path
      fill="#058e6e"
      d="M227.7 294.7a2.6 2.6 0 0 1 2.6-2.5 2.6 2.6 0 0 1 2.6 2.5 2.6 2.6 0 0 1-2.6 2.4c-1.4 0-2.6-1-2.6-2.4"
    />
    <path
      fill="#db4446"
      d="M230.9 229.7v-.6l.1-.3-2.3-.1a5.9 5.9 0 0 1-2.3-1.2c-.8-.7-1.1-1-1.6-1.2-1.3-.2-2.3.4-2.3.4s1 .4 1.7 1.3 1.5 1.3 1.8 1.4c.6.2 2.6 0 3.1.1l1.8.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M230.9 229.7v-.6l.1-.3-2.3-.1a5.9 5.9 0 0 1-2.3-1.2c-.8-.7-1.1-1-1.6-1.2-1.3-.2-2.3.4-2.3.4s1 .4 1.7 1.3 1.5 1.3 1.8 1.4c.6.2 2.6 0 3.1.1l1.8.2z"
    />
    <path
      fill="#ed72aa"
      stroke="#000"
      strokeWidth={0.4}
      d="M238.1 227.5v1.4c.2.6-.1 1.2 0 1.5 0 .4.1.6.3.9l.2.9-.7-.5-.6-.4v1c.1.2.3.8.6 1.1l1 1.3c.2.5.1 1.4.1 1.4s-.4-.7-.8-.8l-1.2-.7s.7.8.7 1.5c0 .8-.3 1.6-.3 1.6s-.3-.7-.8-1.1l-1-.9s.4 1.2.4 2v2.3l-.9-1-1-.7c0-.2.5.6.6 1.1 0 .5.3 2.3 1.8 4.5 1 1.3 2.3 3.6 5.3 2.9 3-.8 1.9-4.8 1.3-6.7a16.8 16.8 0 0 1-1-4.6c0-.8.6-2.9.5-3.3a8 8 0 0 1 .2-3.1c.4-1.3.7-1.8.9-2.3.2-.6.4-.9.4-1.3l.1-1.3.7 1.3.1 1.5s.1-1 1-1.6c.8-.6 1.8-1.1 2-1.4.3-.3.3-.5.3-.5s0 1.8-.6 2.6l-1.7 2s.7-.3 1.2-.3h.9s-.6.4-1.4 1.6c-.8 1-.5 1.2-1 2.1-.6 1-1 1-1.7 1.5-1 .8-.5 4.2-.4 4.7.2.5 2 4.5 2 5.5s.2 3.2-1.5 4.6c-1.1 1-3 1-3.4 1.2-.4.3-1.2 1.1-1.2 2.8 0 1.7.6 2 1 2.4.6.5 1.2.2 1.3.6.2.3.2.5.5.7.2.2.3.4.2.8 0 .3-.8 1.1-1.1 1.7l-.8 2.4c0 .2-.1 1 .1 1.3 0 0 .9 1 .3 1.2-.4.2-.8-.2-1-.2l-.9.5c-.3-.1-.3-.3-.4-.8l-.1-.7c-.2 0-.3.2-.4.5 0 .2 0 .8-.3.8-.2 0-.5-.4-.8-.5-.2 0-.8-.2-.8-.4 0-.3.4-.9.7-1 .4 0 .8-.3.5-.5s-.5-.2-.7 0-.8 0-.7-.2v-.8c0-.2-.4-.5.1-.8.6-.3.8.2 1.4.1.6 0 .8-.3 1-.6.2-.3.2-1-.2-1.4-.4-.5-.7-.5-.9-.8l-.3-.9v2.2l-.7-.8c-.3-.3-.6-1.3-.6-1.3v1.3c0 .4.3.7.2.8-.1.1-.8-.7-1-.8a3.7 3.7 0 0 1-1-1l-.4-1.4a4.2 4.2 0 0 1 0-1.5l.4-1h-1.4c-.7 0-1.2-.3-1.5.2-.3.5-.2 1.5.2 2.8.3 1.2.5 1.9.4 2.1a3 3 0 0 1-.7.8h-.9a2.5 2.5 0 0 0-1.2-.3h-1.3l-1.1-.3c-.3.1-.8.3-.6.7.2.6-.2.7-.5.7l-.9-.2c-.4-.1-.9 0-.8-.4 0-.4.2-.4.4-.7.2-.3.2-.5 0-.5h-.6c-.2.2-.5.5-.8.4-.2-.1-.4-.4-.4-1s-.7-1.2 0-1.1c.5 0 1.3.4 1.4 0 .2-.3 0-.4-.2-.7s-.8-.4-.3-.7l.7-.5c.1-.2.4-.8.7-.6.6.2 0 .7.6 1.3.6.7 1 1 2 .8 1 0 1.3-.2 1.3-.5l-.1-1v-1s-.4.3-.5.6l-.4.8v-2a8 8 0 0 0-.2-.8l-.3.9-.1 1s-.7-.5-.5-1.5c.1-.7-.1-1.6.1-2 .2-.3.7-1.5 2-1.6h2.6l2-.3s-2.8-1.4-3.5-1.9a9.5 9.5 0 0 1-2-2l-.6-1.6s-.5 0-1 .3a5 5 0 0 0-1.2 1l-.7 1 .1-1.2v-.8s-.4 1.2-1 1.7l-1.4 1v-.8l.2-1s-.4.8-1.1 1c-.7 0-1.8 0-1.9.4 0 .5.2 1 0 1.4 0 .3-.4.5-.4.5l-.8-.4c-.4 0-.7.2-.7.2s-.3-.4-.2-.7c.1-.2.7-.6.5-.8l-.8.2c-.3.1-.8.3-.8-.2 0-.4.2-.7 0-1 0-.3 0-.5.2-.6l1.2-.1c0-.2-.2-.5-.8-.6-.6-.1-.8-.5-.5-.8.3-.2.3-.3.5-.6.1-.2.2-.7.7-.5.5.3.4.8 1 1a4 4 0 0 0 2-.2l1.5-1 1.5-1-1-.8c-.3-.3-.7-.9-1-1a8.3 8.3 0 0 0-1.8-.6 9 9 0 0 1-1.7-.5l.8-.3c.2-.2.6-.6.8-.6h.3-1.4c-.3-.1-1-.6-1.3-.6l-.8.1s.8-.4 1.4-.5l1-.1s-.9-.3-1.1-.6l-.6-1c-.2-.1-.3-.5-.6-.5l-1 .3c-.4 0-.6-.2-.6-.6l-.1-.5c-.2-.3-.6-.8-.2-1h1.4c0-.2-.5-.6-.8-.8-.4-.2-1-.5-.7-.8l.8-.5c.2-.3.3-1 .7-.7.4.2.8 1.2 1.1 1.1.3 0 .3-.8.3-1 0-.4 0-1 .2-.9.3 0 .5.4 1 .5.4 0 1-.1 1 .2 0 .3-.3.7-.6 1-.3.3-.4 1-.3 1.4.2.5.7 1.2 1.2 1.4.4.3 1.2.5 1.7.9.5.3 1.7 1.2 2.1 1.3l.8.4s.5-.2 1.1-.2c.7 0 2.1 0 2.6-.2.6-.2 1.3-.6 1-1-.1-.6-1.3-1-1.2-1.4 0-.4.5-.4 1.2-.4.8 0 1.8.1 2-1 .2-1 .2-1.5-.8-1.8-1-.2-1.8-.2-2-1-.2-.7-.4-.9-.2-1.1.3-.2.6-.3 1.4-.4.8 0 1.6 0 1.9-.2.2-.2.3-.7.6-.9.3-.2 1.4-.4 1.4-.4s1.4.7 2.7 1.7a15 15 0 0 1 2.2 2.1"
    />
    <path d="M228.1 226.8l-.2-.6v-.3s.8 0 .7.3c0 .2-.2.2-.3.3l-.2.3" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M228.1 226.8l-.2-.6v-.3s.8 0 .7.3c0 .2-.2.2-.3.3l-.2.3z"
    />
    <path d="M232 225.4v-.4s.7 0 1 .3c.5.4.9 1 .9 1l-.8-.4h-.5l-.3-.1v-.3h-.3" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M232 225.4v-.4s.7 0 1 .3c.5.4.9 1 .9 1l-.8-.4h-.5l-.3-.1v-.3h-.3z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M237.3 231.3l-.4-.7a8 8 0 0 1-.3-.4"
    />
    <path
      fill="#db4446"
      d="M217.4 226.6s.5.4.8.4h.8s.2-.5.1-.8c-.2-1.2-1.2-1.4-1.2-1.4s.3.7.1 1a2 2 0 0 1-.6.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M217.4 226.6s.5.4.8.4h.8s.2-.5.1-.8c-.2-1.2-1.2-1.4-1.2-1.4s.3.7.1 1a2 2 0 0 1-.6.8z"
    />
    <path
      fill="#db4446"
      d="M215.2 227.6s-.4-.7-1.3-.6c-.8 0-1.4.8-1.4.8h1.2c.3.3.4 1 .4 1l.7-.6a7.2 7.2 0 0 0 .4-.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M215.2 227.6s-.4-.7-1.3-.6c-.8 0-1.4.8-1.4.8h1.2c.3.3.4 1 .4 1l.7-.6a7.2 7.2 0 0 0 .4-.6z"
    />
    <path
      fill="#db4446"
      d="M214.2 230.6s-.8.1-1.2.6c-.4.5-.3 1.3-.3 1.3s.4-.5.9-.5l1 .2-.1-.8-.3-.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M214.2 230.6s-.8.1-1.2.6c-.4.5-.3 1.3-.3 1.3s.4-.5.9-.5l1 .2-.1-.8-.3-.8z"
    />
    <path d="M228.2 230.5l.3-.5.3.5h-.7" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M228.2 230.5l.3-.5.3.5h-.7"
    />
    <path d="M229 230.5l.3-.5.4.5h-.8" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M229 230.5l.3-.5.4.5h-.8"
    />
    <path d="M228.6 227.3l.8.3-.7.4-.1-.6" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M228.6 227.3l.8.3-.7.4-.1-.6"
    />
    <path d="M229.5 227.6l.7.2-.5.4-.2-.6" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M229.5 227.6l.7.2-.5.4-.2-.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M224.2 233.7s-.7.2-1 .6c-.4.5-.3 1-.3 1s.6-.5 1.5-.3l1.2.3 1.3-.3s-.7.8-.7 1.3l.2 1.1c0 .7-.6 1.6-.6 1.6l1-.3a4.6 4.6 0 0 0 1.7-.8l.9-1s-.2 1 0 1.4l.2 1.6.8-.6c.2-.1.7-.4.9-.7l.3-1s0 .8.4 1.3l.6 1.6s.3-.8.6-1.1c.3-.4.7-.8.7-1a4.3 4.3 0 0 0-.1-.9l.4.8m-11 .6s.5-.8 1-1l1.1-.8.9-.4m1 5l1.3-.8a4 4 0 0 0 1-1"
    />
    <path
      fill="#db4446"
      d="M216.6 240.4s-.4-.5-1.1-.3c-.7 0-1.2.9-1.2.9s.6-.2 1-.1.6.4.6.4l.4-.4.3-.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M216.6 240.4s-.4-.5-1.1-.3c-.7 0-1.2.9-1.2.9s.6-.2 1-.1.6.4.6.4l.4-.4.3-.6z"
    />
    <path
      fill="#db4446"
      d="M215.8 243.2s-.6 0-1.1.3c-.5.4-.5 1.2-.5 1.2s.4-.4.8-.3l.9.2v-.6c.2-.4-.1-.8-.1-.8"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M215.8 243.2s-.6 0-1.1.3c-.5.4-.5 1.2-.5 1.2s.4-.4.8-.3l.9.2v-.6c.2-.4-.1-.8-.1-.8z"
    />
    <path
      fill="#db4446"
      d="M217.2 245.8s0 .8.3 1.3c.4.5 1.1.5 1.1.5l-.3-.7c0-.4.3-.8.3-.8s-.3-.3-.7-.3h-.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M217.2 245.8s0 .8.3 1.3c.4.5 1.1.5 1.1.5l-.3-.7c0-.4.3-.8.3-.8s-.3-.3-.7-.3h-.7zm16 1.3s2 1.2 1.9 2.2c0 1-1 2.3-1 2.3"
    />
    <path
      fill="#db4446"
      d="M224.2 252.6s-.4-.6-1.1-.6c-.7 0-1.4.7-1.4.7s.8-.1 1 .2l.5.6.5-.3.5-.6"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M224.2 252.6s-.4-.6-1.1-.6c-.7 0-1.4.7-1.4.7s.8-.1 1 .2l.5.6.5-.3.5-.6z"
    />
    <path
      fill="#db4446"
      d="M222.2 255.3s-1-.1-1.4.3c-.4.5-.4 1.3-.4 1.3s.6-.6 1-.5c.5 0 1 .3 1 .3v-.7l-.3-.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M222.2 255.3s-1-.1-1.4.3c-.4.5-.4 1.3-.4 1.3s.6-.6 1-.5c.5 0 1 .3 1 .3v-.7l-.3-.7z"
    />
    <path
      fill="#db4446"
      d="M224 258.1s-.3.7 0 1.1c.3.5 1 .8 1 .8s-.3-.4-.2-.8c.1-.3.7-.8.7-.8l-1.4-.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M224 258.1s-.3.7 0 1.1c.3.5 1 .8 1 .8s-.3-.4-.2-.8c.1-.3.7-.8.7-.8l-1.4-.2z"
    />
    <path
      fill="#db4446"
      d="M236 259.3s-.8-.2-1.2 0c-.5.3-.8 1.4-.8 1.4s.7-.6 1.2-.5c.5 0 1 .3 1 .3v-.8l-.2-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M236 259.3s-.8-.2-1.2 0c-.5.3-.8 1.4-.8 1.4s.7-.6 1.2-.5c.5 0 1 .3 1 .3v-.8l-.2-.4z"
    />
    <path
      fill="#db4446"
      d="M236.4 262.2s-.6.6-.4 1.1l.6 1s0-.7.2-1l1-.3-.7-.5a15.8 15.8 0 0 1-.7-.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M236.4 262.2s-.6.6-.4 1.1l.6 1s0-.7.2-1l1-.3-.7-.5a15.8 15.8 0 0 1-.7-.3z"
    />
    <path
      fill="#db4446"
      d="M239.4 263s-.3.8.2 1.3c.6.5 1 .5 1 .5s-.3-.7-.2-1.1c.1-.5.5-.7.5-.7l-.8-.2-.7.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M239.4 263s-.3.8.2 1.3c.6.5 1 .5 1 .5s-.3-.7-.2-1.1c.1-.5.5-.7.5-.7l-.8-.2-.7.3z"
    />
    <path
      fill="#ffd691"
      stroke="#000"
      strokeWidth={0.5}
      d="M208.8 316.4c2 .6 3 2 3 3.8 0 2.3-2.2 4-5 4-3 0-5.3-1.7-5.3-4 0-1.7 1-3.6 3-3.8l-.2-.4-.7-.7h1.2l.8.5.5-.7c.3-.4.6-.5.6-.5l.6.6.3.5.7-.4.8-.3s0 .4-.2.7l-.1.7"
    />
    <path
      fill="#058e6e"
      stroke="#000"
      strokeWidth={0.5}
      d="M206.3 326.7s-3.8-2.6-5.5-3c-2-.4-4.5 0-5.5 0 0 0 1.2.8 1.8 1.4.5.5 2.3 1.5 3.3 1.8 3 .8 6-.2 6-.2m1 .2s2.4-2.5 5-2.9c3-.4 5 .3 6.2.6l-1.5.8c-.5.3-2 1.5-4 1.6-2 0-4.4-.3-4.8-.2l-.9.1"
    />
    <path
      fill="#ad1519"
      stroke="#000"
      strokeWidth={0.5}
      d="M206.7 323.8a4.8 4.8 0 0 1 0-7.1 4.8 4.8 0 0 1 1.5 3.5 4.9 4.9 0 0 1-1.5 3.6"
    />
    <path
      fill="#058e6e"
      stroke="#000"
      strokeWidth={0.5}
      d="M205.7 329s.6-1.5.6-2.7l-.1-2.1h.8s.3 1.1.3 2l-.1 2.4-.7.1-.8.3"
    />
    <path
      fill="#fff"
      d="M254 190.7c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M254 190.7c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M255.4 188.2c0-.6.5-1 1.1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M255.4 188.2c0-.6.5-1 1.1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M256.4 185.2c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M256.4 185.2c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    />
    <path
      fill="#fff"
      d="M256.5 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M256.5 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M255.7 179c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M255.7 179c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M254.1 176.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M254.1 176.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M252 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M252 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M249.4 171.8c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M249.4 171.8c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1z"
    />
    <path
      fill="#fff"
      d="M246.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M246.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M243.3 169.1c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M243.3 169.1c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M239.9 168.5c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M239.9 168.5c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M236.6 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M236.6 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M233.3 168.5c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M233.3 168.5c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M230.1 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M230.1 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.4}
      d="M231.7 171.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1m.6 3.1c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1-1-1m0 3c0-.5.6-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1m-1 2.8c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1 0 .6-.4 1-1 1a1 1 0 0 1-1-1m-1.9 2.6c0-.5.5-1 1-1 .7 0 1.2.5 1.2 1s-.5 1-1.1 1c-.6 0-1-.4-1-1"
    />
    <path
      fill="#fff"
      d="M227.6 166.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M227.6 166.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M224.8 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M224.8 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M221.6 164c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.5 1-1 1-.6 0-1.1-.5-1.1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M221.6 164c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.5 1-1 1-.6 0-1.1-.5-1.1-1z"
    />
    <path
      fill="#fff"
      d="M218.3 163.4c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M218.3 163.4c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    />
    <path
      fill="#fff"
      d="M215 163.5c0-.6.5-1 1.1-1 .6 0 1 .4 1 1 0 .5-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M215 163.5c0-.6.5-1 1.1-1 .6 0 1 .4 1 1 0 .5-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M211.7 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M211.7 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M208.6 165.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M208.6 165.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    />
    <path
      fill="#fff"
      d="M156 190.7c0-.5.4-1 1-1s1 .5 1 1c0 .6-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M156 190.7c0-.5.4-1 1-1s1 .5 1 1c0 .6-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M154.5 188.2c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M154.5 188.2c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M153.5 185.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M153.5 185.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M153.4 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M153.4 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M154.2 179c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M154.2 179c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M155.8 176.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M155.8 176.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M158 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M158 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M160.5 171.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M160.5 171.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M163.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M163.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M166.6 169.1c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M166.6 169.1c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M170 168.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M170 168.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1z"
    />
    <path
      fill="#fff"
      d="M173.4 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M173.4 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M176.6 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M176.6 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    />
    <path
      fill="#fff"
      d="M179.8 168.5c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M179.8 168.5c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.4}
      d="M178.2 171.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1m-.7 3.1c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1-1-1m-.2 3c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1m.9 2.8c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1.1-1m1.8 2.6c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    />
    <path
      fill="#fff"
      d="M182.3 166.5c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M182.3 166.5c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M185.2 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M185.2 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M188.3 164c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1 0 .5-.4 1-1 1s-1-.5-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M188.3 164c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1 0 .5-.4 1-1 1s-1-.5-1-1z"
    />
    <path
      fill="#fff"
      d="M191.6 163.4c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M191.6 163.4c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M194.9 163.5c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M194.9 163.5c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M198.2 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M198.2 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#fff"
      d="M201.3 165.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M201.3 165.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.4}
      d="M174.7 228.9h-1v-1h-1.5v3.6h1.6v2.5h-3.4v7h1.8v14.3h-3.5v7.3h27.2v-7.3h-3.5V241h1.8v-7h-3.4v-2.5h1.6V228h-1.6v.9h-.8v-1h-1.6v1h-1.1v-1h-1.6v3.6h1.6v2.5H184v-7.8h1.7v-3.5H184v.9h-1v-1h-1.5v1h-.9v-1H179v3.6h1.7v7.8h-3.3v-2.5h1.6V228h-1.6v.9h-.9v-1h-1.8v1zm-6 33.7H196m-27.3-1.8H196m-27.3-1.8H196m-27.3-1.7H196m-27.3-2H196m-23.8-1.6h20.2m-20.2-1.8h20.2m-20.2-2h20.2m-20.2-1.7h20.2m-20.2-1.8h20.2m-20.2-1.8h20.2m-20.2-1.7h20.2m-22-1.8h23.8m-23.8-1.8h23.8m-23.8-1.8h23.8m-23.8-1.8h23.8m-20.4-1.7h17m-10.2-1.8h3.4m-3.4-1.8h3.4m-3.4-1.8h3.4m-3.4-1.7h3.4m-5.1-2.2h6.8m-12 7.5h3.6m-5-2.2h6.6m-6.7 32.6v-1.8m0-1.8v-1.7m-1.8 1.7v1.8m3.4 0V259m1.7 3.6v-1.8m0-1.8v-1.7m0-2v-1.6m0-1.8v-2m-1.7 7.4v-2m-3.4 2v-2m7 0v2m1.5-2v-1.6m-5.1-1.8v1.8m3.5-1.8v1.8m3.3-1.8v1.8M179 252v-2m1.7-1.7v1.7m0-5.3v1.8m-1.7-3.6v1.8m1.7-3.5v1.7m-3.3-1.7v1.7m-3.5-1.7v1.7m-1.6-3.5v1.8m3.3-1.8v1.8m3.4-1.8v1.8m1.7-3.6v1.8m-3.3-1.8v1.8m-3.5-1.8v1.8m-1.6-3.6v1.8m6.7-1.8v1.8m-3.4-5.3v1.8m15.3-1.8h-3.5m5-2.2h-6.6m6.7 32.6v-1.8m0-1.8v-1.7m1.8 1.7v1.8m-3.4 0V259m-1.7 3.6v-1.8m0-1.8v-1.7m0-2v-1.6m0-1.8v-2m1.7 7.4v-2m3.4 2v-2m-7 0v2m-1.5-2v-1.6m5.1-1.8v1.8m-3.5-1.8v1.8m-3.3-1.8v1.8m1.7-1.8v-2m-1.7-1.7v1.7m0-5.3v1.8m1.7-3.6v1.8m-1.7-3.5v1.7m3.3-1.7v1.7m3.5-1.7v1.7m1.6-3.5v1.8m-3.3-1.8v1.8m-3.4-1.8v1.8m-1.7-3.6v1.8m3.3-1.8v1.8m3.5-1.8v1.8m1.6-3.6v1.8m-6.7-1.8v1.8m3.4-5.3v1.8m-7 18v-2m0-5.4v-1.8m0 5.4v-1.8m0-5.3v-1.8m0-1.8v-1.7m0-3.6v-1.8m0-1.7v-1.8m-8.3 4.6h3.5m3.3-5.3h3.4m3.3 5.3h3.5"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.4}
      d="M186.8 262.6v-4.7c0-.8-.4-3.5-4.6-3.5-4 0-4.4 2.7-4.4 3.5v4.7h9z"
    />
    <path
      fill="#c8b100"
      stroke="#000"
      strokeWidth={0.4}
      d="M179.3 258.2l-2.2-.3c0-.9.2-2.2.9-2.6l2 1.5c-.3.2-.7 1-.7 1.4zm6 0l2.2-.3c0-.9-.2-2.2-.9-2.6l-2 1.5c.3.2.7 1 .7 1.4zm-2.2-2.3l1-2a5.3 5.3 0 0 0-2-.4l-1.7.4 1.1 2h1.6zm-4.2-5.5v-4.9c0-1.3-1-2.4-2.5-2.4s-2.4 1-2.4 2.4v4.9h4.9zm6.8 0v-4.9c0-1.3 1-2.4 2.5-2.4s2.4 1 2.4 2.4v4.9h-4.9zm-1.7-12l.4-4.4h-4.2l.2 4.4h3.6zm3.3 0l-.4-4.4h4.4l-.5 4.4h-3.5zm-10 0l.2-4.4h-4.2l.5 4.4h3.5z"
    />
    <path
      fill="#0039f0"
      d="M185.3 262.6v-4c0-.7-.5-2.7-3.1-2.7-2.4 0-2.9 2-2.9 2.7v4h6zm-6.9-12.7v-4.2c0-1-.6-2.2-2-2.2s-2 1.1-2 2.2v4.3h4zm7.8 0v-4.2c0-1 .7-2.2 2-2.2s2 1.1 2 2.2v4.3h-4z"
    />
    <path
      fill="#ad1519"
      d="M190.8 269.8c0-9.7 7-17.6 15.6-17.6s15.6 7.9 15.6 17.6-7 17.5-15.6 17.5-15.6-7.8-15.6-17.5"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.6}
      d="M190.8 269.8c0-9.7 7-17.6 15.6-17.6s15.6 7.9 15.6 17.6-7 17.5-15.6 17.5-15.6-7.8-15.6-17.5z"
    />
    <path
      fill="#005bbf"
      d="M195.4 269.7c0-7 5-12.8 11-12.8s11 5.7 11 12.8c0 7.2-5 13-11 13s-11-5.8-11-13"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.6}
      d="M195.4 269.7c0-7 5-12.8 11-12.8s11 5.7 11 12.8c0 7.2-5 13-11 13s-11-5.8-11-13z"
    />
    <path
      fill="#c8b100"
      d="M201.2 260.9s-1.3 1.4-1.3 2.7a6 6 0 0 0 .6 2.4c-.2-.5-.8-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.1-.3.5-.5 1-.5s1 .4 1 1a.9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0-1.4-1.3c-.7 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.3}
      d="M201.2 260.9s-1.3 1.4-1.3 2.7a6 6 0 0 0 .6 2.4c-.2-.5-.8-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.1-.3.5-.5 1-.5s1 .4 1 1a.9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0-1.4-1.3c-.7 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z"
    />
    <path fill="#c8b100" d="M199.2 269.9h4.1v-1h-4.1v1z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M199.2 269.9h4.1v-1h-4.1v1z"
    />
    <path
      fill="#c8b100"
      d="M211.4 260.9s-1.3 1.4-1.3 2.7c0 1.3.6 2.4.6 2.4-.2-.5-.7-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.2-.3.5-.5 1-.5a1 1 0 0 1 1 1 .9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.8.8 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .8.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0-1.4-1.3c-.6 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.3}
      d="M211.4 260.9s-1.3 1.4-1.3 2.7c0 1.3.6 2.4.6 2.4-.2-.5-.7-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.2-.3.5-.5 1-.5a1 1 0 0 1 1 1 .9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.8.8 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .8.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0-1.4-1.3c-.6 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z"
    />
    <path fill="#c8b100" d="M209.4 269.9h4.1v-1h-4.1v1z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M209.4 269.9h4.1v-1h-4.1v1z"
    />
    <path
      fill="#c8b100"
      d="M206.3 269.6s-1.3 1.5-1.3 2.8.6 2.4.6 2.4c-.2-.5-.7-.9-1.4-.9-.8 0-1.4.6-1.4 1.4l.2.7.5 1c.1-.4.5-.6 1-.6a1 1 0 0 1 1 1 .9.9 0 0 1 0 .3h-1.2v1h1l-.8 1.5 1-.4.8.9.8-1 1 .5-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.2.9.6l.5-1 .2-.7a1.4 1.4 0 0 0-1.4-1.4c-.7 0-1.2.4-1.4 1 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.3}
      d="M206.3 269.6s-1.3 1.5-1.3 2.8.6 2.4.6 2.4c-.2-.5-.7-.9-1.4-.9-.8 0-1.4.6-1.4 1.4l.2.7.5 1c.1-.4.5-.6 1-.6a1 1 0 0 1 1 1 .9.9 0 0 1 0 .3h-1.2v1h1l-.8 1.5 1-.4.8.9.8-1 1 .5-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.2.9.6l.5-1 .2-.7a1.4 1.4 0 0 0-1.4-1.4c-.7 0-1.2.4-1.4 1 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z"
    />
    <path fill="#c8b100" d="M204.3 278.6h4.1v-1h-4.1v1z" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M204.3 278.6h4.1v-1h-4.1v1z"
    />
    <path
      fill="#c8b100"
      d="M237.6 223.4h-.3a1.5 1.5 0 0 1-.3.4c-.2.2-.6.2-.8 0a.5.5 0 0 1-.1-.4.5.5 0 0 1-.5 0c-.3-.1-.3-.5-.1-.7v-.5h-.3l-.1.2c-.2.3-.5.3-.7.2a.6.6 0 0 1 0-.2h-.3c-.5.2-.7-1-.7-1.2l-.2.2s.2.7.1 1.2c0 .6-.3 1.2-.3 1.2a9 9 0 0 1 2.9 1.6 9 9 0 0 1 2.2 2.3l1.2-.5c.6-.2 1.3-.2 1.3-.2l.2-.2c-.3 0-1.5.1-1.5-.4v-.2a.7.7 0 0 1-.2 0c-.2-.2-.2-.4 0-.7l.2-.1v-.3h-.3l-.2.1c-.2.3-.6.3-.8 0a.4.4 0 0 1-.1-.4.6.6 0 0 1-.5 0c-.2-.2-.3-.5 0-.8l.2-.3v-.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M237.6 223.4h-.3a1.5 1.5 0 0 1-.3.4c-.2.2-.6.2-.8 0a.5.5 0 0 1-.1-.4.5.5 0 0 1-.5 0c-.3-.1-.3-.5-.1-.7v-.5h-.3l-.1.2c-.2.3-.5.3-.7.2a.6.6 0 0 1 0-.2h-.3c-.5.2-.7-1-.7-1.2l-.2.2s.2.7.1 1.2c0 .6-.3 1.2-.3 1.2a9 9 0 0 1 2.9 1.6 9 9 0 0 1 2.2 2.3l1.2-.5c.6-.2 1.3-.2 1.3-.2l.2-.2c-.3 0-1.5.1-1.5-.4v-.2a.7.7 0 0 1-.2 0c-.2-.2-.2-.4 0-.7l.2-.1v-.3h-.3l-.2.1c-.2.3-.6.3-.8 0a.4.4 0 0 1-.1-.4.6.6 0 0 1-.5 0c-.2-.2-.3-.5 0-.8l.2-.3v-.3z"
    />
    <path d="M235.4 224h.2v.3h-.1c-.1 0-.1-.2 0-.2" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M235.4 224h.2v.3h-.1c-.1 0-.1-.2 0-.2z"
    />
    <path d="M236.3 224.8l-.3-.2v-.2h.1l.4.3.3.2v.2h-.2l-.3-.3" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M236.3 224.8l-.3-.2v-.2h.1l.4.3.3.2v.2h-.2l-.3-.3"
    />
    <path d="M234.6 223.7l-.2-.2s-.1 0 0-.1l.3.1.3.1v.2h-.1l-.3-.1" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M234.6 223.7l-.2-.2s-.1 0 0-.1l.3.1.3.1v.2h-.1l-.3-.1"
    />
    <path d="M233.7 223h.2v.2h-.2s-.1-.1 0-.2" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M233.7 223h.2v.2h-.2s-.1-.1 0-.2z"
    />
    <path d="M237.3 225.5v-.2h-.3l.1.2h.2" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M237.3 225.5v-.2h-.3l.1.2h.2z"
    />
    <path d="M237.9 226.2l.2.2h.1c.1 0 0-.1 0-.2l-.2-.2-.2-.2h-.1v.2l.2.2" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M237.9 226.2l.2.2h.1c.1 0 0-.1 0-.2l-.2-.2-.2-.2h-.1v.2l.2.2"
    />
    <path d="M238.8 227v-.3h-.3v.2h.3" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M238.8 227v-.3h-.3v.2h.3z"
    />
    <path fill="#c8b100" d="M236.2 221.1h-.6l-.1.9v.1h.2l.7-.5-.3-.5" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M236.2 221.1h-.6l-.1.9v.1h.2l.7-.5-.3-.5"
    />
    <path fill="#c8b100" d="M234.6 221.6v.5l.9.1h.1v-.2l-.5-.7-.5.3" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M234.6 221.6v.5l.9.1h.1v-.2l-.5-.7-.5.3"
    />
    <path fill="#c8b100" d="M236.4 222.6l-.4.3-.6-.7v-.1h1.1v.5" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M236.4 222.6l-.4.3-.6-.7v-.1h1.1v.5"
    />
    <path
      fill="#c8b100"
      d="M235.3 222a.3.3 0 0 1 .4 0 .3.3 0 0 1 0 .3.3.3 0 0 1-.3 0 .3.3 0 0 1-.1-.3"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M235.3 222a.3.3 0 0 1 .4 0 .3.3 0 0 1 0 .3.3.3 0 0 1-.3 0 .3.3 0 0 1-.1-.3z"
    />
    <path
      fill="#c8b100"
      d="M233.2 221.1l-.2-.7-.4-.4s.4-.2.8.1c.4.3 0 .9 0 .9l-.2.1"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M233.2 221.1l-.2-.7-.4-.4s.4-.2.8.1c.4.3 0 .9 0 .9l-.2.1z"
    />
    <path fill="#c8b100" d="M234.2 221.4l-.4.4-.6-.6v-.2h1v.4" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M234.2 221.4l-.4.4-.6-.6v-.2h1v.4"
    />
    <path fill="#c8b100" d="M233.1 221l.3-.1v.3c0 .2-.1.2-.2.2l-.1-.3" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M233.1 221l.3-.1v.3c0 .2-.1.2-.2.2l-.1-.3z"
    />
    <path fill="#c8b100" d="M238.3 222.5h-.5l-.3.7v.2h.2l.8-.4-.2-.5" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M238.3 222.5h-.5l-.3.7v.2h.2l.8-.4-.2-.5"
    />
    <path fill="#c8b100" d="M236.7 222.8v.5l.8.2h.1v-.2l-.4-.7-.5.2" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M236.7 222.8v.5l.8.2h.1v-.2l-.4-.7-.5.2"
    />
    <path fill="#c8b100" d="M238.4 224l-.5.2-.4-.7v-.2h.1l.9.2-.1.5" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M238.4 224l-.5.2-.4-.7v-.2h.1l.9.2-.1.5"
    />
    <path
      fill="#c8b100"
      d="M237.3 223.2h.4a.3.3 0 0 1 0 .4.3.3 0 0 1-.3 0 .3.3 0 0 1 0-.4"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M237.3 223.2h.4a.3.3 0 0 1 0 .4.3.3 0 0 1-.3 0 .3.3 0 0 1 0-.4z"
    />
    <path fill="#c8b100" d="M240.2 224.3l.1.5-.8.3h-.2v-.2l.4-.8.5.2" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M240.2 224.3l.1.5-.8.3h-.2v-.2l.4-.8.5.2"
    />
    <path fill="#c8b100" d="M240 225.8l-.5.1-.3-.8v-.1h.2l.8.3-.1.5" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M240 225.8l-.5.1-.3-.8v-.1h.2l.8.3-.1.5"
    />
    <path fill="#c8b100" d="M238.6 224.3l-.2.5.9.3h.1v-.1l-.3-.8-.5.1" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M238.6 224.3l-.2.5.9.3h.1v-.1l-.3-.8-.5.1"
    />
    <path
      fill="#c8b100"
      d="M239.5 225.2a.3.3 0 0 0 0-.3.3.3 0 0 0-.4 0 .3.3 0 0 0 0 .3.3.3 0 0 0 .4 0"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M239.5 225.2a.3.3 0 0 0 0-.3.3.3 0 0 0-.4 0 .3.3 0 0 0 0 .3.3.3 0 0 0 .4 0z"
    />
    <path
      fill="#c8b100"
      d="M240.8 227h.8l.5.3s.1-.4-.3-.7c-.3-.3-.8.2-.8.2l-.2.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M240.8 227h.8l.5.3s.1-.4-.3-.7c-.3-.3-.8.2-.8.2l-.2.2z"
    />
    <path fill="#c8b100" d="M240.3 226.1l-.3.5.8.5v-.1h.2l-.1-1-.6.1" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M240.3 226.1l-.3.5.8.5v-.1h.2l-.1-1-.6.1"
    />
    <path fill="#c8b100" d="M241 227s.1-.1 0-.2h-.3c-.2 0-.2.1-.1.2h.3" />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M241 227s.1-.1 0-.2h-.3c-.2 0-.2.1-.1.2h.3zm38-21.9v.6h-2.4v-.6h1v-1.3h-.7v-.5h.6v-.6h.6v.6h.6v.6h-.6v1.2h1"
    />
    <path
      fill="none"
      d="M134.4 217.1v-1.2m-.4 1.2v-1.2m-.2 1.2v-1.2m-.3 1.2v-1.2"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M133.2 217.1v-1.2m-.5 1.1v-1m.2 1v-1m-.7 1v-1m.2 1v-1m-.9 1v-1m.2 1v-1m.3 1v-1m-.7 1v-1m-.3.9v-.8m-.1.8v-.8m-.5.7v-.6m.2.6v-.6m-.4.5v-.5m-.2.5v-.4m-.3.3v-.3m-.3.3v-.2"
    />
    <path fill="none" stroke="#000" strokeWidth={0.2} d="M129.2 216.6v-.2" />
    <path
      fill="none"
      d="M135.7 217v-1m-.5 1v-1m-.4 1.2V216m143 1.1V216m-.4 1.1V216m-.3 1.1V216m-.3 1.2V216"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M276.6 217.1V216m-.6 1v-1m.3 1v-1m-.8 1v-1m.3 1v-1m-.9 1v-1m.2 1v-1m.2 1v-1m-.6 1v-1m-.3.9v-.8m-.2.8v-.8m-.4.7v-.6m.2.6v-.6m-.5.6v-.6m-.2.5v-.4m-.3.4v-.4m-.2.3v-.2"
    />
    <path fill="none" stroke="#000" strokeWidth={0.2} d="M272.6 216.6v-.2" />
    <path fill="none" d="M279.1 217v-1m-.6 1v-1m-.4 1.1V216" />
  </svg>
	),
	ET: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-61.3 0h682.7v512H-61.3z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="translate(57.5) scale(.94)"
    >
      <path fill="#ffc621" d="M-238 3.5H800v498H-238z" />
      <path fill="#ef2118" d="M-240 342.5H799.3V512H-240z" />
      <path fill="#298c08" d="M-238 0H800v180H-238z" />
      <ellipse
        cx={534.2}
        cy={353}
        fill="#006bc6"
        rx={199.7}
        ry={199.7}
        transform="matrix(.54 0 0 .54 -25.8 74)"
      />
      <path
        fill="#ffc621"
        d="M214.3 188.2l-6.5 4.5 23.5 33 6.3-4-23.4-33.5zm29.4 78l-9.7-6.8 4-12.7-48.1.7-14-10.7 65.7-.7 12.2-36.9 6.6 15-16.7 52zm76.5-70.7l-6.3-4.8-24.3 32.4 5.6 4.7 25-32.3zM254.8 247l3.5-11.2h13.3L256.4 190l6-16.5 20.5 62.4 38.8.5-12.2 10.7-54.7-.2zm90.6 51.2l2.7-7.4-38.3-13.3-2.8 7 38.4 13.7zm-69.1-46.4l11.7-.1 4.1 12.6 38.8-28.5 17.6.6-53.1 38.7 11.5 37.2-14-8.4-16.6-52.1zm-19.8 102l7.9.2.3-40.5-7.4-.5-.8 40.9zm22-80.3l3.8 11.1-10.7 8 39.4 27.7 5 16.8-53.6-38-31.5 22.7 3.5-16 44-32.3zm-103.3 13l2.3 7.5 38.7-12.2-2-7.2-39 11.9zm83.2-4l-9.4 7.1-10.8-7.7-14.2 46-14.4 10 19.5-62.7-31.4-23 16.3-1.6 44.4 31.9z"
      />
    </g>
  </svg>
	),
	FI: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path fill="#003580" d="M0 174.5h640v131H0z" />
    <path fill="#003580" d="M175.5 0h130.9v480h-131z" />
  </svg>
	),
	FJ: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#68bfe5" d="M0 0v480h640V0H0z" />
    <g strokeMiterlimit={4.8}>
      <path
        fill="#fff"
        d="M420.9 193.2v136.4c0 44.6 80.6 71 80.6 71s80.5-26.4 80.5-71V193.2z"
      />
      <path
        fill="#d21034"
        d="M490.3 241.2v61.4h-69.4v22.3h69.4v71.5l11.2 4.3 11.1-4.3V325H582v-22.4h-69.4v-61.4z"
      />
      <path fill="#d21034" d="M420.9 193.2H582V246H420.8z" />
      <g strokeMiterlimit={3}>
        <g
          fill="#fff"
          stroke="#000"
          strokeWidth={0.8}
          transform="translate(-96.9 97.5) scale(.66486)"
        >
          <ellipse cx={798.2} cy={192.2} rx={13.6} ry={11} />
          <ellipse cx={798.2} cy={186.5} rx={12.1} ry={6.1} />
          <ellipse cx={798.2} cy={198.8} rx={12.1} ry={6.1} />
          <ellipse cx={798.2} cy={192.2} rx={12.1} ry={6.1} />
        </g>
        <path
          fill="#ffd100"
          stroke="#000"
          strokeWidth={0.8}
          d="M578 235.4l-1.3-3.6s-3.6-1.5-3.9-3.4c-.6-5.1-2.4-7-5.2-7.8a6 6 0 0 0-4.5.5c-.8 1.2-5 1.2-7.2 1.3-2.3 0-2.4-1-2.4-1-1.7 0-2.5-1.3-2.5-1.3-1.1-2.3-2-3.2-2.6-3.5 3 0 5.2-1.3 8.6-4.8 3.6-3.8 6.2-2.4 6.2-2.4-1.8 3.6.6 3.3.6 3.3 4.8-2.5.6-8.7-.8-8.4-1.5.3-1.9-.7-1.9-.7 0 1.1-1.6 1.6-1.6 1.6 1.2-7.1-3-9-3-9-.6.6-1 1.9-1 1.9-1.2 4.3-5.1 3.6-9.5 1.5-4.4-2-16 2.2-19.7 3.7-3.7 1.5-10.4 3.7-16.4.4-6-3.4-7.5-2.8-9.9-2.1-2.3.6-6.5 1.6-8 .8a8.5 8.5 0 0 0-3.4-.9c.4-.2-.2-1.2-.2-1.2-1.9-2.5.2-4 .2-4s-3.4 1-2 6.8l.6.8s.4 1.9 1.4 2.4v.4s.9-.4 1.1.8c.3 1.2 1.6 0 2.1-1 0 0-.9 5.4 5.7 6.7 0 0-.7-.9-.5-1.4.3-.6-.8-1-.7-1.8.1-.9-1.6-1.2-.3-1.9 1.4-.6 2-1.9 5-.1 2.9 1.7 5.2 1.3 5.2 1.3s-1.8-3.6-.8-3.6 5.4 5.4 7.5 5.2c2.2-.3 6.4-2.8 8.5-1.9 0 0 .2-1 8.2-2.4 8-1.4 18-5.4 21.7-1.9 0 0 .4 2.8 2 3.5 0 0-.3 5.8-10.2 2.6l-3.6-1s-.6-1.7-19.5 3.2c0 0-1.1.4-1.9.9-.7.5-1.7-.3-5.5 1-3.7 1.5-17.7 6-26.3 4.4-1.9-.6-3.6-.3-3.7-.6 0-.3 1 .1 1 .1-.6-.7-.9-.8-.9-.8-7.2-.8-6-4-6-4l.4 1c1.2-1.6-.4-5.2-.4-5.2h-.1a3.8 3.8 0 0 0 0-.3l.5-.4c3.5-3 7.5-3.5 7.5-3.5-2.4-3-7.4-1.4-7.4-1.4.1-3.5-1.4-7.7-1.4-7.7a12 12 0 0 0-7.7 4.7c-.2-3.7-4.9-5.8-4.9-5.8 1.8 2.1.7 7.2.7 7.2h.2-.5l-.1 1.1h-.2s-1.7.6-3.7 5.2c0 0-.2 1-1 2v-.4s-2.3 3-7.4 0c0 0-7-4.1-9.6-4-2.4.2-4 1.3-3.9 2 0 0-5.7-.4-7.6 2.8 0 0-4.3 1.6-.6 5 0 0 .5 1.6 1.5 2.4 0 0-.1-3.2.7-2.3l.5.6c.1.4.5 1.6 1.2 2.3l.6-.2c0-.8.2-1.8.4-2.2h.2l1 1.6 1-.6c.6 0 1.3.5 1.3.5l1.3-1.1c1.3.2 1.7-2.4 1.7-2.4a4 4 0 0 0 3.1-.5c.6 2 5.2 4.3 5.2 4.3h.2l-.6.4c2.1 1.5 6 1.1 6 1.1-1.6.6-1.4 3.7-1.4 3.7-1 .4-1 1.3-1 1.3 3.2 1.3 5.3.2 5.3.2.2 1 0 1.2 0 1.2-1.3 2.7-1.9 5.4-1.9 5.4h.1v.2s-5.7 2-8.1 4.7c0 0-.3-.8-1-.8s-2.8-1.8-3.8-2.1c-1-.3-2.5.3-3-.2-.3-.4-.1-3.6-.8-4l-.7-2c-.4 1-2.4.8-2.4.8l-.8.6-.8-.1c-.2 0-.4.5-.5 1l-.3.3v-.6c-.3.3-1.1-.1-1.4-.1-.2 0-.4.4-.5.9l-1.9.1c-.3.2 0 2.6 0 2.6-2.3 1.2-1.2 3.1-1.2 3.1 1.2 6 11.5 3.3 12.3 4.1.8.8 2.6 1 3.5 1 1 0 2.1 2.2 3.4 2.4 1.3.2 0-1.8 6.1-3.2 6.1-1.5 8.2-4 8.2-4 1.9-.4 2.4-2.7 2.5-3.6l.2 1.4c.3 2.1-1.2 3-1.2 3l5.3-1.7c2.1-.5 1.8-2.4 1.8-2.4 2 5.8 5.7 6.2 5.7 6.2.7-2.2.6-2.9.6-2.9h1.7c0-1.3-1-2.2-1.7-2.6l2.6 1.5 1-.1c0 .9 1.3 1.7 1.3 1.7l.2-1.2c1.2 1.6 3.4 1 3.4 1a7.3 7.3 0 0 0-.2-.8c4.7 2.9 12.2-.8 12.2-.8 2 .4 2.3-.8 2.3-.8 2.2.3 2.8-1.3 2.8-1.3 5.3-.4 9.1-4.2 9.1-4.2 2.7-.2 2.8-2.1 2.8-2.1s2.6.5 5.2-2.7c6-8.5 14.8-4 14.8-4l-5.1.3c-13.5-.1-7.9 9-7.9 9h.8c1.3.2 5.7 3.7 4 6.2v.2c-2.8 3.7-7.8.2-9.3-3-1.4-3.2-4.4-2.5-4.4-2.5s-7.5 1.3-4.4 7.3c.1 1.5 1 3.2 3.8 4.8 1.5 2.2 6.5 2.4 10.1 1.6C524 244 533 240 533 240c.7-2 3-1.5 5-4.4 2-2.8-2.9-3.8-4-5.4-1-1.5.3-1.2.3-1.2 4.4 2.3 4.8-5.2 4.8-5.2a6.6 6.6 0 0 0 4.3 5.5c2.3-2.3.6-7.2.6-7.2 5.7 10.2 9.1 8.5 9.1 8.5-3-1.8-1.5-4.4-1.5-4.4 2.7 10.8 14 1.4 14 1.4-.6 1.6 0 2.5 1 3.5s2.2 1.4 1.6 3.3c-.5 1.8-5.8 1.4-5.8 1.4s-5-.2-4.6 4c.3 1 3.6 1.4 5 1.1 0 0-.6.2 1.3.4h2.2c2.1 0 4.5-.4 4.5-.4 2.9-.6 2.4-1.6 2.4-1.6 4.5-.8 5-3.8 5-3.8z"
        />
        <path d="M429.6 216.7s.3-.5.7-.6c.4 0 .8.2 1.2.8l.3-.2s-1.2-1.8-.8-3c.3-.6.8-1 1.6-1.1v-.3c-1 .2-1.6.6-1.8 1.3a2 2 0 0 0-.2.7c0 .6.2 1.2.5 1.7a1.1 1.1 0 0 0-.8-.2 1 1 0 0 0-.8.6zm141 24c-3 .5-7.5.7-7.9-.2 0-.2 0-.8 2.4-2.4l-.2-.5c-2.1 1.4-3 2.3-2.7 3 .7 1.8 7.2.8 8.5.6zm-58.4 1.7c-.7-1-.3-2.5 1-4.3l-.5-.3c-1.4 2-1.7 3.6-1 5z" />
        <path d="M508.1 237.8c0 1.9 1.4 3.6 3.9 5.1l.3-.5c-2.4-1.4-3.6-3-3.6-4.6-.2-2.5 2.5-4.5 2.6-4.5l-.3-.4c-.2 0-3 2.1-2.9 5zm52 .7c-.8 1.3-.5 2.8-.5 2.8h.5c0-.1-.2-1.4.5-2.5a3 3 0 0 1 2-1.2v-.5c-1.1.2-2 .7-2.4 1.4zM441 215.1h-.2v.2s-.2 1.6-1 2a.8.8 0 0 1-.6 0l-1.3-.7c-.2-.2-.4-.3-.8-.2a1.8 1.8 0 0 1-.4-1.4c.1-.7.6-1.4 1.6-2l-.2-.3c-1 .7-1.6 1.5-1.7 2.3 0 1 .5 1.6.5 1.6v.1h.2c.3-.1.3 0 .6.2l1.4.8h1c.7-.5 1-1.9 1-2.2 3.2.7 5.8-3.3 6-3.4l-.3-.2s-2.7 4-5.8 3.2z" />
        <path d="M433.1 214.5a3 3 0 0 0 .4 2c.3.5.7.8 1 .9.5 0 .8-.3 1.2-.6.2-.2.4-.4.6-.4l.3.2.2-.2-.5-.3c-.3 0-.6.2-.8.5s-.6.5-1 .5c-.2 0-.5-.3-.8-.8a2.2 2.2 0 0 1-.3-1.7c.4-1.4 2.1-2.5 2.1-2.5l-.1-.3c-.1 0-1.9 1.2-2.3 2.7zm-4.4 20.7c.1-.6.6-1 1.3-1.4-.2 0 .6.6 1.3.6l.5-.3c.2.2 1.4 1.3 1.4 2.7 0 .3 0 .6-.2.9l.3.1c.9-2.1-1.4-4-1.4-4h-.2l-.4.3c-.6 0-1.3-.6-1.3-.6-1 .4-1.4 1-1.6 1.6zm10.3-5.4c-.7.1-2.5.4-3.1 1.4-.2.4-.3.8-.1 1.2l.2.6c.6 1.6 1.2 3.2 1.9 3.6l.1-.3c-.6-.3-1.2-2-1.7-3.4l-.2-.6a1 1 0 0 1 0-1c.5-.7 2.2-1 3-1.1.4 0 .5 1.5.6 2.4h.3c-.1-1.4-.3-2.8-1-2.8z" />
        <path d="M433.9 231.4c-.4.3-.3.8-.3.9 0 .1.2 4 2 4.8l.1-.3c-1.6-.7-1.8-4.5-1.8-4.6 0 0 0-.4.2-.6.3-.2.8-.3 1.6 0l.1-.3c-.9-.3-1.5-.2-1.9 0z" />
        <path d="M432.4 231.7c-.8.6-.7 2.2-.7 2.3h.3s0-1.6.6-2c.3-.2.6-.2 1 0l.1-.4c-.5-.2-1-.2-1.3 0z" />
        <g transform="translate(-96.9 97.5) scale(.66486)">
          <path d="M862.3 169.5s1.3 3 1.3 5.3c0 .4-.2.7-.3 1l-.5-1.3-.3 1s-.6 1.4.3 2.9c1.2 2 4.2 3.2 9 3.7v.1a.8.8 0 0 0-.4.1l-.2.2v.4c.2.5.7.5 1.8.5l.7.1.6.2-.1-.1c1 0 2.3.3 3.6.8l-1 .2 1.1.5c.1 0 8.7 3.5 12.2 6.3-1 .9-5.3 4-12.7 2.2l-1.2-.3.8 1s4.9 5.6 5.9 9c-1.7 0-8.2 0-10.5-2l-.5.5s3 4.6 3.8 8.1c-1 .2-3 .3-4.3-1.4l-.6-.7-.3 2c-.6-.5-1.4-1.1-1.4-1.9v-.4l-1.8.3-3.8-2.3a8 8 0 0 0-.6-.4l-.4.7.6.3c.8.6 2.2 1.7 2.3 3.3H863v.5c0 .3 0 1.4-.9 3.7-1.1-.2-5.3-1.7-7.8-8.8l-.8.2v.2c0 .7-.2 2.3-2.4 2.9l-6.5 2a4.5 4.5 0 0 0 .8-2.8v-.8a20.3 20.3 0 0 1-.2-2.6c0-1.5.3-2.4 1.4-3l-.4-.8c-.1 0-9.6 3.9-14.3 2.3.2-1 1-4.2 2.6-7.6l-.2.2c.3-.2.6-.6.3-2.2v-.5l-.5.2s-3 1.4-7.4-.2c0-.4.3-1 1.2-1.4l.3-.1v-.8c0-1.2.1-4 1.8-4.6l-.2-.8s-5.1.4-8.2-1.3a11 11 0 0 1 4.5-1.9h.3v-.4a6 6 0 0 0-.5-2.3c1.2.4 2.6.7 3.1.3l.2-.1-.2-3.1h-.8l.1 2.6-3-.7-1.2-.4.8 1a4 4 0 0 1 .7 2.4 12.7 12.7 0 0 0-5 2.3l-.5.4.5.3c2.4 1.6 6.1 1.8 8 1.7a8.4 8.4 0 0 0-1.3 4.5v.4a3.1 3.1 0 0 0-1.5 2.2v.3l.2.1a11 11 0 0 0 7.9.5v.9c-2 4.2-3 8.3-3 8.3v.4h.3c3.9 1.6 10.7-.5 13.8-1.6-.4.7-.7 1.5-.7 2.5a22.1 22.1 0 0 0 .3 3.4c0 2.3-1.5 3.2-1.6 3.2l.3.8 8-2.4c1.8-.5 2.5-1.6 2.8-2.5 3.1 7.4 8 8 8.3 8.1h.3l.1-.3a14 14 0 0 0 1-4 439.6 439.6 0 0 0 2.4-.1v-.5c0-.7-.1-1.3-.4-1.8l1.4.8 1.3-.2c.3 1.3 1.9 2.4 2.1 2.5l.5.3.3-1.7c2 1.7 4.7 1.2 4.9 1.2l.3-.1v-.4c-.4-2.7-2.2-5.9-3.3-7.6 3.5 1.6 9.9 1.5 10.2 1.5h.4v-.5a30 30 0 0 0-5.6-9c8.2 1.5 12.6-2.8 12.8-3l.3-.3-.4-.2a53.8 53.8 0 0 0-11.6-6.3l.9-.2-1-.5a12.8 12.8 0 0 0-5.8-1.4c-1-1.2-1.5-1.3-1.6-1.4-5.6-.6-7.6-2.1-8.4-3.3v-.3l.2-.3c.5-.7.7-1.6.7-2.6 0-2.6-1.3-5.5-1.3-5.6l-.8.3z" />
          <path d="M836.8 167.9s-.6 3-3.2 4.5c-2 1-4.5 1-7.6-.3l-.4-.1v.4a5 5 0 0 0 2 3.2c1.3 1 3.3 1.4 5.9 1.2-.9 1-3.6 4.4-3.6 7.8v.5c.4.2 4.6 1.4 6.6-1.1 0 1 .4 4.5 1.7 5.8.8.8 1 1.8 1 2.7 0 .8-.2 1.4-.2 1.4l-.2.6.5-.4c.2-.1 4.1-3 5.3-6.7 0 0 .7-1 1.9-1.3v.5c0 1.5.6 4.1 4.8 5.7l.3.1v-.3a7.1 7.1 0 0 1 0-.7c0-1.1 0-3 1.1-4a2.8 2.8 0 0 0 .6-3.3c.9.2 2.9.9 3.7 2.4 1.2 2.2 5.3.4 5.5.4l-.1-.5s-1.8.4-2.9-.3a2.1 2.1 0 0 1-.8-1.5l-.2-2.4c0-1-.2-1.7-.7-2.2.5 0 1.6 0 2 1 .8 1.6 3.3 1.7 3.4 1.7l.9.1-.7-.5s-2.2-1.4-1.8-3.3l.3-1.4c.6-2.5 1.6-6.6.7-9.2l-.4.2c.2.6.3 1.4.3 2.2 0 2.2-.7 5-1 6.7l-.4 1.4a2.6 2.6 0 0 0 0 .5c0 1.3.7 2.2 1.3 2.7-.7-.1-1.7-.5-2-1.3-.7-1.4-2.3-1.4-3-1.3l-.6.1.4.4c.7.4.8 1 .8 2.3l.2 2.3c.1.8.5 1.4 1 1.8.6.4 1.2.4 1.7.5-1.2.3-2.9.5-3.5-.6-1.1-2.2-4.3-2.7-4.4-2.8h-.5l.2.4s.4.6.4 1.4c0 .5-.2 1.2-.7 1.7-1.1 1.1-1.3 3.2-1.3 4.3v.4c-3.6-1.5-4.2-3.7-4.2-5v-1l.2-.3h-.4a3.5 3.5 0 0 0-2.5 1.8 15 15 0 0 1-4.7 6.2 6.9 6.9 0 0 0 .1-1c0-.9-.2-2-1-2.9-1.5-1.4-1.7-6-1.7-6v-.8l-.4.7c-1.6 2.8-6.2 1.4-6.3 1.4-.2-3.5 4-8.1 4-8.2l.4-.4h-.6c-2.7.4-4.8 0-6.2-1a4.6 4.6 0 0 1-1.6-2.5c3 1.1 5.6 1.2 7.6.1a7.4 7.4 0 0 0 3.4-4.8c3-6.6 5.5-7.7 5.5-7.7l-.1-.4c-.2 0-2.8 1-5.8 8z" />
          <path d="M843.5 158h-.2l-2.4 3.3h.7a31 31 0 0 1 19.7 9.2l.3.3 2.3-2.5-.2-.3c-6.5-10.2-20.1-10-20.3-10zm.2.9c1.6 0 13.2.3 19.2 9.3l-1.3 1.4a33 33 0 0 0-19.3-8.9 631.2 631.2 0 0 1 1.4-1.8z" />
          <path d="M841.6 164.8a11 11 0 0 0-2.1 4.8l.1.4a7.3 7.3 0 0 0-2 5.5c0 1.3.2 2.6.6 3.8l.3.7c1.2 3.4 2.3 6.4 7.8 4.6 5.2-1.6 5.4-2 6.7-4.2l.4-.5c.7-1.2 1.5-1.4 2.3-1.7 1-.3 2-.6 3-2.4l.8-1.3c1-1.3 2.2-3 2.3-5h-.4a9.8 9.8 0 0 1-2.2 4.7l-1 1.4a3.6 3.6 0 0 1-2.6 2.2 3.9 3.9 0 0 0-2.6 1.8l-.4.6c-1.2 2.1-1.4 2.4-6.5 4-5 1.6-6-.9-7.2-4.4l-.3-.7c-1.4-3.8-.3-7.6 1.6-9l.6-.5-.9.1v-.1c0-.7.7-2.6 2-4.5 1.2-1.6 4-3.1 4-3.2l-.2-.4c-.2.1-2.9 1.7-4.1 3.3z" />
          <path d="M839.2 178.7c.9.6 2.1.5 3.7 0 0 .5 0 1.7 1 2.5 1.2 1 3 1.2 5.5.6v-.5c-2.4.6-4.2.4-5.2-.5a3 3 0 0 1-.9-2.4v-.4l-.3.2c-1.5.6-2.7.7-3.6 0-1.5-1-1.4-3.7-1.4-3.7h-.4s-.2 3 1.6 4.2z" />
          <path d="M842 175c-.6.2-.8.7-.8 1.1v.3c.2 1.2 1.5 2 2.6 2.3 1.2.3 2.6.4 3.1-.3.2-.3.4-.8 0-1.7a3.7 3.7 0 0 0-4.8-1.7zm2 3.3c-1-.3-2.2-1-2.3-2 0 0-.1-.7.5-.9a3.3 3.3 0 0 1 4.2 1.6c.3.4.3.8.1 1-.3.5-1.4.6-2.5.3zm-2-3.3zm1.6 6c-.3 2.5 0 2.6.1 2.6h.2l.2-.1 1.4-2-1.8-.8v.3zm.5.4l.7.3-.8 1.1v-1.4zm-4.2-2.4l-.1 2.3 2-2.4-2-.2v.3zm.4.2h.6l-.6.8v-.8z" />
          <path d="M838.5 178.2s1.5 2.9 1.8 4c.1.6 1 1.4 2 1.7 1 .4 2 .4 2.7-.1l1.3-1.1c.4-.5.6-.6 1-.5v-.5c-.6 0-.9.2-1.3.6l-1.3 1c-.8.6-1.7.4-2.2.2-1-.3-1.7-1-1.8-1.5-.3-1-1.7-3.9-1.8-4l-.4.2zm2-8.6a5 5 0 0 0-2.4 2.8l.4.1s.7-1.8 2.1-2.5a2.9 2.9 0 0 1 2.4 0l.1-.4c-1-.4-1.8-.4-2.7 0zm10.8 5.2c.2 0 3.2 2.4 1.5 5.2l.3.3c2-3.3-1.5-5.9-1.5-6l-.3.5zm-9.2.4s-.5 1.7 2 2.3c0 0-2.3 0-2.5-.6-.1-.6 0-1.9.5-1.7zm7.5 2c0 .2-.2.3-.3.3a.3.3 0 0 1-.3-.2c0-.2.1-.3.3-.3.1 0 .3.1.3.3zm.2 1.2c0 .1 0 .2-.2.2a.3.3 0 0 1-.3-.2.3.3 0 0 1 .3-.3c.1 0 .2.1.2.3z" />
          <circle cx={848} cy={177.8} r={0.3} />
          <path d="M848.8 179.4a.3.3 0 1 1-.6 0c0-.1.1-.2.3-.2l.3.2zm-7.1-7.3a.3.3 0 0 1-.6 0 .3.3 0 0 1 .5 0z" />
          <circle cx={841.6} cy={173.2} r={0.3} />
          <circle cx={840.1} cy={172.7} r={0.3} />
          <path d="M840.8 174.3a.3.3 0 0 1-.2.3.3.3 0 0 1 0-.6.3.3 0 0 1 .2.3zm4.8-9.6s3.5 2.2.1 6.3c0 0 1.7-1.3 1.8-3.4.2-2.1-1.2-3.8-2-2.9zm13.5 5.9c-1.2.6-2.8-.5-3.6-1.5-.8-1-2.5-1.3-3.6.6-1 1.8-2.5 2.5-2.5 2.5s1.5-.8 3-2.5c1.5-1.6 2.4-.3 3.9.5 1.4.8 1.7 1 2.7.5v-.1z" />
          <path d="M858.8 170.9a1.7 1.7 0 0 1-2.2-.1c-1-.8-1.7-1.8-2.8-1.2-1.2.6-3.3 2.2-3.3 2.2s3.5-2.4 4.2-1.8c.6.5 2.2 1.8 3.1 1.4l1-.5z" />
          <path d="M856.1 172.3c-1.1-.8-2.2 1-3.1.8-1-.2-1.7-1.8-1.7-1.8s.8 1.6 2 1.3c1.3-.4 2.1-1.2 2.9-.6.7.6-.1.3-.1.3z" />
          <path d="M854.4 172.6a2 2 0 0 1-2.4-1.9s.7 1.8 2.6 1.5l-.2.4z" />
          <path d="M854.3 171.2c.1.5.1.8-.5.8s-1-.2-1-.8c0-.5 1.4-.4 1.5 0zm-7.8-3a.7.7 0 0 1-.7.6c-.4 0-.5-.2-.5-.6s0-.7.5-.7.7.3.7.7z" />
          <path d="M844 165.7s3.8 0 2 4.7c0 0 1.4-2.3.5-4-1-1.6-2.3-1.2-2.3-1.2s-.4.3-.2.5z" />
          <path d="M844 167.6c0 1 .6 1.9 1.8 2.9l.3-.4c-1.1-.9-1.7-1.7-1.7-2.5s.6-1.3.6-1.3l-.3-.3s-.7.6-.8 1.6z" />
          <path d="M844.8 168.4c.1.5.6 1 1.2 1.2l.2-.4c-.5-.2-.9-.6-1-1-.2-.8.4-1.7.4-1.7l-.4-.3s-.7 1.2-.4 2.2zm5.1 2.6s.7 1.5-.3 3.1l-1 1.6s1.2-2.3.7-3.2c-.4-1 .6-1.5.6-1.5zm14.6 15.8c3.8.7 12.5 7.5 12.5 7.5l.5-.6c-.3-.3-8.9-7-12.9-7.7l-.2.8zm3.4 9.5c.2 3.5 4 5.6 4 5.7l.5-.7s-3.5-2-3.7-5h-.8zm-9.3.8c0 3.8 3.6 8.4 3.8 8.6l.6-.5s-3.6-4.6-3.6-8.1h-.8zm-12.1.4c.6 1.3.6 1.9.4 2.2-.2.4-.6.4-.6.4l.1.8c.3 0 .9-.2 1.2-.8.4-.7.3-1.7-.4-3l-.7.4z" />
        </g>
        <g fill="#fff" stroke="#000" strokeWidth={0.2}>
          <path d="M429.6 216.3s.1 1.7 1.4 2.7c0 0-.1-1.8.3-2.6 0 0-.7-.8-1.7-.1zm2.6 1s.3 1.6 1.2 2.3l.6-.1s.2-2 .5-2.2c.3-.2-1.3.7-2.3 0z" />
          <path d="M434.5 217.3l1 1.6 1.2-.7-.2-1.8s-.7-.2-2 .9zm4.7.3l-1.3 1.1s-.7-.5-1.2-.5l.2-1.7s1-.7 2.3 1.1zm-9.3 16s-.2-2.4 0-2.5c0 0 1 .3 1.4 0 0 0 .5 1.8.4 2.6-.2.8-1.1.5-1.8 0zm6-2.4s-.1-2 .2-2.3c0 0 2 .3 2.4-.8l.7 2s-2.1-.3-3.4 1z" />
          <path d="M433.8 231.6s.3-2.1.7-2.2c0 0 1 .3 1.3-.1v2.6s0-1.1-2-.3zm-2.3.3s.5-1.9.8-1.9 1 .5 1.4.2v1.4s-1.6-.4-1.9 1.9l-.3-1.6z" />
        </g>
      </g>
      <g fill="#00a651" stroke="#000" strokeWidth={0.8}>
        <path
          strokeWidth={0.5}
          d="M461.7 270.4s5.2 4.9 3.9 9.2c0 0 3.3-7.3-.3-9.5-3.6-2-3.7-.5-3.6.3z"
        />
        <path
          fill="#964b36"
          strokeWidth={0.5}
          d="M455 275.1s-1.3 2 .2 3.3c0 0-1.7 2.4-.4 4.4 0 0-1 2.1-.8 4.4 0 0-.8 3.5 1 5.1 0 0 2 1 3 .1 0 0 1.7-2.6.6-5.3 0 0 1.2-2.3-.2-5.2 0 0 .4-1.6-.7-3.5 0 0 .7-1.2.1-2.2 0 0-2.5-2.7-2.8-1z"
        />
        <path
          strokeWidth={0.5}
          d="M456.5 269s-6.2-12-10.6-12.5c-4.4-.5-4.6-4.8-4.6-4.8s.5 2 4 2 10.2 5 11 8.7c.7 3.7 1.5 3.2 1.5 3.2l-1.3 3.4z"
        />
        <path
          strokeWidth={0.5}
          d="M456.5 268.1s2.3-15.1 12.2-15.4c9.9-.2 6.6.8 9-.8 0 0-6.6 3.4-10.7 4-4.2.4-7.6 8.5-7.4 10 0 1.5-2.3 4.4-3.4 3.4-1.2-1 .3-1.2.3-1.2z"
        />
        <path
          strokeWidth={0.5}
          d="M458.8 273.8s2.3-6 6.1-4c0 0-3-5.8-8.4-.8 0 0 2.4 3.3 2.3 4.8zm-7.5-6s3.2 13.4-1.8 17.5c0 0 .2-6.9-2.9-11-3-4.2 3-8.7 4.7-6.5z"
        />
        <path
          strokeWidth={0.5}
          d="M451.7 270.1s5.9 5.7 6.2 7.6c.4 1.8 1.8-5.7-1-7.8s-5.7-2.5-5.7-2.5l.5 2.8z"
        />
        <path
          fill="#964b36"
          strokeWidth={0.5}
          d="M440.8 285s.5 2.3 2 2.8c0 0 0 1.7 1.4 2.2 0 0-.7 1.5.4 2.4 0 0-.2 3 .8 3.5 0 0 2.7-.1 3.6-.9 0 0 .5-1.9-1-3.8 0 0 .3-1.8-1.2-2.8 0 0 .5-2.5-1.4-3.4 0 0-.3-2-1.4-3 0 0-2.2 3.1-3.2 3z"
        />
        <path
          strokeWidth={0.5}
          d="M443.7 282s-7.7-2.8-12 1.2c0 0 6.6 1 7.4 2.3.8 1.3 4.9-2.2 4.6-3.5z"
        />
        <path
          strokeWidth={0.5}
          d="M441.3 286.8l-1.4-1c-.7-.6-7.2-2.3-8.1 4 0 0-2.4-6.3 1-7 3.5-1 6.2 1 8.5 4m-5-12.8s2.3 5.2 3.2 5.4c.9.3 1.5-.6 1.5-.6s-3.1-4.6-4.8-4.8zm-1.8-7.9s-2-6.6-4.4-4.8c-2.4 1.7-1.8 6.5-1.8 6.5s-4.7-5-2-8.8c2.8-3.9 8.2.4 8.2 7.1z"
        />
        <path
          fill="#964b36"
          strokeWidth={0.5}
          d="M439.9 279.8s0 1.3.9 1.6c.8.4 2.5 1 2.5.3s-1.3-3.7-1.8-3.3c-.5.4-1.4.4-1.6 1.4z"
        />
        <path
          strokeWidth={0.5}
          d="M438.4 272s-.3-5.7 3.5-7.9c0 0 .7.2 1.1-1 0 0-3 7.3-2.1 11l-.1.4"
        />
        <path
          strokeWidth={0.5}
          d="M439.1 265s6.8-14 15-9.1c0 0-8.6 1.7-11.7 7.9l-3.1 4.6-.2-3.4z"
        />
        <path
          strokeWidth={0.5}
          d="M435.5 270.1s-2-9.4-3.3-10.6c-1.2-1.3-3.3-2.6-5.9-.5 0 0 4.4-3.9 9-.6 4.7 3.2 3.7 8.4 3.7 8.4l-.5 6.5-3.1-2.9"
        />
        <path
          strokeWidth={0.5}
          d="M442.8 281.3s-8.3-15.7-13.7-4.5c0 0-1 2.9.1 4 0 0-3-2.3-1.6-7.8s10.5-3 13.2 1.5c2.6 4.5 3.3 6.8 3 7-.4.3-1-.2-1-.2zm23.3 4.5s6-12.4 9.5-6.8c0 0 1 2.8-.5 4 0 0-2.4-3-4.5.6-2.2 3.5-1.3 3.2-1.3 3.2s-2.2.6-3.2-1z"
        />
        <path
          strokeWidth={0.5}
          d="M475 283s3.3 1.7 2.2 5.2c0 0 4.4-8.4-1.6-9.2 0 0 1.1 2.7-.5 4zm.5-8.6s7.9 2.3 8.1 5.7c0 0 1.4-6.6-3.1-8.6 0 0-5.4 1-5 3z"
        />
        <path
          strokeWidth={0.5}
          d="M479 264c3.4-6.6 7.6 2.1 7.6 2.1s1.5-6.9-2.7-8.1c-4.3-1.3-7 14.7-7 14.7l-5 1s1.3-13.8 8.8-15h1"
        />
        <path
          strokeWidth={0.5}
          d="M473 268s-4.8-9.8-8-10.8 1.7-2.5 3.7-.6 5.8 4.3 5.4 9.3L473 268zm-5 13.4s1.4-6.6 5.2-8.6c3.8-2 7.3-1.3 7.3-1.3s-4.5 1-5.3 3.3c-.7 2.2-2 2.4-2 2.4l-5.1 4.2z"
        />
        <path
          fill="#964b36"
          strokeWidth={0.5}
          d="M466 285.8s-2 4-1.6 4.6c0 0-2.2 3.3-1.3 5 0 0 2.2 1.7 3.2 1 0 0 2.6-3.7 1.9-5.7 0 0 1.8-2.4 1.1-3.9 0 0-2.6.1-3.2-1z"
        />
        <path
          fill="#000"
          d="M455 278.6c.2.1 1.5.7 2.3.4l.6-.5-.5-.2c-.3.6-1.7.1-2.1-.1l-.2.4zm-.1 4l-.2.5c.1 0 2.7.5 3.9-.6l-.4-.4c-1 .9-3.3.4-3.4.4zm-.7 4.4l-.3.4s3 2.1 4.9-.2l-.5-.3c-1.5 1.9-4 .2-4.1 0zm-11.5.6l.1.3c.1 0 2.6-1 2.8-2.9h-.3c-.1 1.6-2.5 2.6-2.6 2.6zm1.4 2.3v.3c.2 0 2.5-.2 2.9-1.8h-.3c-.4 1.3-2.5 1.5-2.6 1.5zm.5 2.4v.3c.1 0 2.7.1 3.6-1.3l-.3-.2c-.8 1.3-3.3 1.2-3.3 1.2zm19.7-1.7s1.1 1.2 2.4 1.1a2.3 2.3 0 0 0 1.7-.8l-.4-.4c-.4.5-.8.7-1.3.7-1 0-2-1-2-1l-.4.4z"
          stroke="none"
        />
      </g>
      <g fill="#964b36" stroke="#000" strokeWidth={0.3}>
        <path d="M542 299.8a1.1 1.1 0 0 0-.3.3l.4-.3zm9.3-2.3c-.1-.2-.2-.1-.3-.2l-.4-.8h-.3l-.7-1.4a.4.4 0 0 0 0-.3 7.6 7.6 0 0 0 0-.4s-.2 0-.3-.2v-1.6l-.1-.5a2 2 0 0 1-.3-1.1v-1c.1-.4-.1-.6-.1-1l.1-.9v-5.4l-.1-1-.1-.4v-1.6 2.6l-.2-4.3-3.4-1.6s-.3 6.2-.2 7c0 .9.4 6.7.2 7.4l-.5 4.3s-1.6 1.2-2.2 2.4c-.7 1.3-.5 1.7-.7 1.7l1.5-.2-1.1.8a.7.7 0 0 1 .7.1l.2.2.2-.2c.3 0 .5.4.7.3l.4-.2.2-.4c.1-.1.3 0 .4 0h.7c.3 0 .6-.5.9-.7.2-.2.4-.3.7-.3.3 0 .6.3 1 .3.2 0 .3 0 .5-.2l.4-.6.8-.1.4.1h.6l.3.2.2-.4-.1-.4z" />
        <path d="M544.5 299.7h.6v.2a.2.2 0 0 0 .2 0l.3.2h.3l.4.1c.2.1.4 0 .6-.1.2-.2.3 0 .6.2.1.1.1.1.2 0l.1-.1.3-.1.3-.1.4-.2.4.2a.8.8 0 0 1 .2 0l.7-.5c.3-.2.5 0 .7 0h.3c.1-.1.2 0 .4 0 0-.1 0-.2.2-.3l.7.4c.1.1.7.2.6-.2 0-.4-.4-.1-.5-.4v-.6a.7.7 0 0 0-.3-.4c-.2 0-.2.1-.4 0l-.2-.6-.3.2c-.2 0-.2-.1-.3-.3-.3-.3-.4.2-.7.1-.2 0-.4-.5-.5-.7-.1-.1-.3-.5-.5-.4-.2.1 0 .5 0 .7h-.5c-.2 0-.2 0-.3.2-.2.4-.3.7-.7.6-.1 0-.3-.1-.4 0l-.5.2a1 1 0 0 1-.4 0l-.4-.4a.1.1 0 0 0-.2 0 8.7 8.7 0 0 0-.1-.2c-.2 0-.2 0-.3.3l-.1.5-.3.4-.4.1c-.2 0-.4.3-.4 0-.2-.4.3-1.1-.2-1-.1 0-.2 0-.3.2v.7c-.1.3-.7.8-.6 1 0 .3.4 0 .4 0l.2.4c.2.3.7-.4.7 0m-2.1-2.7v-.2l-.4-.1c-.2 0-.4.3-.5.4-.2.4-.2 1-.6 1h-.5v1s-.2 0-.2.2c-.1.4.2.2.4.2h1l.5-.1c.2 0 .4 0 .5-.2a2.2 2.2 0 0 0 .2-.4v-.4c0-.2.3-.1.3-.4.1-.7-.6-.2-.5-.9" />
      </g>
      <g stroke="#000" strokeWidth={0.5}>
        <path d="M550.8 277.9c0 .9-.6 1.6-1.4 1.6-.7 0-1.4-.7-1.4-1.6 0-.9.7-1.6 1.4-1.6.8 0 1.4.7 1.4 1.6zm-4.5-2c0 .9-.6 1.6-1.4 1.6s-1.4-.7-1.4-1.6c0-1 .7-1.6 1.4-1.6s1.4.7 1.4 1.6z" />
        <path d="M548.7 276.5c0 1-.6 1.6-1.4 1.6-.8 0-1.4-.7-1.4-1.6 0-.9.6-1.6 1.4-1.6.8 0 1.4.7 1.4 1.6z" />
        <path d="M546.4 278c0 .9-.6 1.6-1.4 1.6-.8 0-1.4-.7-1.4-1.6 0-.9.6-1.6 1.4-1.6.8 0 1.4.7 1.4 1.6z" />
        <path d="M548.5 279.3c0 .8-.6 1.6-1.4 1.6-.7 0-1.4-.7-1.4-1.6 0-1 .7-1.7 1.4-1.7.8 0 1.4.7 1.4 1.6z" />
      </g>
      <path
        fill="#00a651"
        stroke="#000"
        strokeWidth={0.5}
        d="M549.2 261.5s13.9-19.4 28.8.7c0 0 .1 2-1.3 4.2l-.3-1.7-1 .3-.2-1-1.6-.1.5-2.2-1.7 1.4.2-1.5-2 2 .3-4.3-2.2 3.7.3-2.5-.8 1.1-.4-1.5-.7 1.5-1-.7v1l-1.8-1.5-.6 2-.9-2.2-.2 1.5-.9-1.7-.1 1.9-2.9-1.3.6 1.8-1.3-1 .2 1-1.9-.4.2 1.1-2-.4.3 1-2.7-.3 1 1-.3.6s15-5 16 13.8l-2.7 1.3.8-1.5-.8-.5-2.3-1.7.7-2.4-.8.3-.1-1.4-.4.2-.9-1.3-.2.5-.6-1.7-.7 1.2-.3-2.8-1 1.8-.2-1-.3.6-1.3-1.5-.4 1-.5-.8-.3 1-1.4-1.4v1l-1-.7-.3.5-2.1-1.1-.1 1-1.2-1-.3 1s13.6 7.8 9.4 20.4l-.8 1.6-.2-4.2-1.3 2.2.9-4.9-.9 1-.1-2-1.1 2-.4-2.2-.5.6-.8-3.2-.6 1.3-1-3.6-.8 1.5-.5-3.1-.5 1.9-1.5-2.8-.2 1.1-.9-2.2-.5.7s-2.5-.1-3.3-.7c-.7-.7-2.8 3.7-2.8 3.7l.2-2.6-.9 1.8v-1.8l-1.6 5.3-.4-3.8-.8 3.3-.4-1-.3 1.3-.5-.5-.4 1.5-.8-.6v2l-.8-1-.6 3-.4-1.2v1.3l-.6-.7-.6 3-1-1.3v2.2l.3 1.6-1-.5.4 2.6s-3.9-7.2.8-14.2c4.6-7 10.9-9 10.9-9l-.7-.6v-.6l-3.8 1.9v-1.1l-1 .8-.2-1.2-.6 1.1-.1-.5-1 1.4-.4-2-.6 2.4-.6-1.7-1.3 3.5V270l-1 2.8-.4-3-.7 3.4v-3l-1.2 3-.7-3-.5 3-.8-2.3-.7 3.4-1.2-3-.6 4.5-.7-1.8-.2 3.3-.8-2 .8 4.2-1-1.6.3 2.6-1.6-2.9v3.4l-.8-1.1-.4 1.3s-.3-13 8.6-15.6c8.9-2.5 14.6.8 14.6.8l-3.4-2.8.4-.9h-1.2l.5-1-2.7.1.8-1-2 .3v-.6l-1.3 1 .5-1.2-1.7 1.2-.1-1.7-1 1.4-.4-1.5-4 4 1-4.1-.7.9-.1-1-1.1 1.8-.3-1.2-.5 1.5-.4-1.8-.8 1.8-1-1.6-.3 2.1-.6-1.1-.8 1.6-1-1v1l-2-.9.4 1.5-1.5-1.2-.4 2-.8-1-.7 2.5-.6-2.4-.6 1.9s7.8-20.2 27.6-7c0 0 2.2 2.1 2.7 3.6s.1.2.1.2l-.4-13.9.8 6 .5-2-.1 3 2-4.3s-2.4 7.2-1.5 9.9c0 0 .9-8.4 3.9-9.4l-2.8 6 .9-.1-.6 1.2h.7l-.9 2-.5 1 .5 1 .8-.7z"
      />
      <path d="M547.1 269.6l.4.4s1.3-1.4 3.4.4l.3-.4c-2.5-2.1-4-.4-4-.4zm-.6-6.8v.5l.9-.4-.7 1.2 1.5-.5-1.8 2.3.4.3 2.9-3.7-1.8.6.8-1.3-1.6.6.3-1.9h-.5l-.4 2.3z" />
      <path d="M543.9 263l.6 1.3-1-.4 2.9 5.2.4-.5-.6 1.5.5.2 1.2-3.2-.4-.3-1 1.3-1.8-3.1.8.3-.8-1.7 1.1.6v-1.9h-.5v1l-1.8-1.1.4.8zm-1.9 6.4l.2.5c.8-.3 1.5-.4 2-.2.5.3.7.9.7 1l.5-.2s-.2-.9-1-1.2c-.6-.3-1.4-.3-2.4.1zm2.3 5.4l-.5-2.8h.6l.4 2.7zm3.8-.4l-.7-2.2.5-.1.7 2zm1.4 1.5l-.5-2.1.5-.1.6 2.1z" />
      <path
        fill="#00a651"
        stroke="#000"
        strokeWidth={0.5}
        d="M442.6 340.2s-2.4-1-3.5-.2c-1 .7-.9 1.9-1.8 1.8 0 0 3.6.8 4.3-.1l1-1.2m.4.7s-1.6 2-1 3.3c.5 1.2 1.7 1.3 1.4 2.2 0 0 1.5-3.3.8-4.3s-1-1.1-1-1.1m-2.8-5.8s-2.5.8-2.8 2c-.2 1.4.6 2.1-.1 2.7 0 0 3.2-1.8 3.1-3v-1.5m1.2.7s1.2-2.3.5-3.4c-.8-1.2-2-1-1.8-2 0 0-1 3.5 0 4.4l1.1 1m-2.2-.9s0-2.6-1-3.2c-1.2-.7-2.2-.1-2.5-1 0 0 .7 3.6 1.8 4l1.5.3m4.4 4.2s2.7-1 3 2c.2 3-.2 2-.2 2s-1.4-3.2-3-3.7l.2-.3z"
      />
      <path d="M443 341.3l.2 2.2h.4l-.3-2.2 1-4.9h-.4l-1 4.9z" />
      <path d="M440.5 340.6l-.1.3c1.3.5 3-1 3.1-1l-.2-.3s-1.7 1.3-2.8 1zm3.4-2.9l-6-3 .2-.5 6 3z" />
      <path d="M439.5 337l-.4-.4 1.2-1.2.4.4zm2.1-.6l-1.3-2.8.5-.2 1.3 2.8zm1.8 3.4v.6c1.7-.1 2 1 2 1l.6-.2c0-.3-.7-1.5-2.6-1.4z" />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={0.7}
        d="M471.2 341c2-1 2.4-5 2.4-5-.5 1.4-4.2 2.9-4.2 2.9 2.7-1.7 6-9.4 6-9.4-.8 2.7-8 5-12.6 7.6-4.6 2.6-2.2 10-2.2 10-1.3-.9-3.8-4.8-4.3-8.3-.5-3.5-1.8-4.9-5-5.3-3.1-.4-5 3.2-5 3.2l-4.7 2.4 4.8.2s3.4 1.1 3.4 3.8c0 2.6-3 13.3 2 19.3 3.3 4.1 16 6.5 16 6.5"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={0.7}
        d="M461.9 349.3s1-4.8 4.1-4.6c3.1.2 4-3.6 5.9-4.1 1.9-.6 11.5-3.2 12.5-7.8 0 0-.9 7.6-9.7 11.4 0 0 7.1-2.3 8-3.9 0 0-3.2 6.8-10.9 7.9 0 0 7.2-.6 8.2-2.5 0 0-3.2 4.2-8.5 4.8 0 0 5 2 6.2.3 0 0-2.7 3.2-6 3.4l1 .2s-3.2 3.8-6.7 1.3-3.6.6-3.6.6"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={0.7}
        d="M469 356.5s4.1 6.8 4.5 10.4c0 0 7.8 8.5 10.7 9 0 0-1.4.6-4-1.5 0 0 2.2 2.2 2.6 2.3.4 0-1.7-.2-2-.8a6 6 0 0 0 1.4 1.5l-.5-.2s-1-.1-1.6-.5c-.5-.4-.1 1-.1 1s-1.2-.3-1.6-.7c-.4-.4.1.9.1.9l-1-.3-.8.5s0 .5-.5 0c-.5-.3-1.4 0-1.4 0s-.6.6-1 .2c-.3-.4-1.5 1.6-1.5 1.6l-5-12.3"
      />
      <path d="M473.9 378.7l-6.4-12.2.6-.4 6.4 12.3zm5.6-.8l-11-12.3.6-.5 11 12.3zm2.5-1L469.5 365l.5-.5 12.5 11.7z" />
      <g transform="translate(-96.9 97.5) scale(.66486)">
        <path d="M823.4 360.8s-1.2-2.2-2.3-1.3c-1 .8-1.6 1-1.8.9 0 0 1 0 1.7-.5.6-.6 1.6-.3 2.4 1zm-6.6-1l.7 1.4-.8 2.3.6.2.7-2.5-.7-1.6-.5.2z" />
        <path d="M823.2 360.5s-1 1-2.2.8l-1.3-.3h1.8c.7 0 1.6-.3 1.7-.5z" />
        <path d="M822.9 360.7s-1.2-1.2-2-.8c0 0 1.4-.5 2.2.7l-.2.1z" />
        <path d="M822.7 360.5s-1.3.9-2.7 0l-.1-.2h.2s1.7.7 2.6.2z" />
        <circle cx={821.6} cy={360.3} r={0.4} />
      </g>
      <path d="M450 359.6s-.7 1.2-.3 2c.3.7 2 1 2.1 2 .2 1 .8 1 1.5 1l.9-.3s-3.1-1.6-4-4.3l-.2-.4z" />
      <g fill="#964b36" stroke="#000" strokeWidth={0.5}>
        <path
          strokeWidth={0.3}
          d="M549.4 334.8s5.6-7.4 10.6-5.5c5 2 8.1 3 8.1 3s.1 4.9-2.5 4.9-5.2-5-7.6-3.5a13 13 0 0 0-4.5 4.2c-.1.7-6.3.8-4.1-3.1z"
        />
        <path d="M528.2 370.4s-1.6 1.6-.9 2c.7.4 2.1 0 2.1-.6s-1-1.6-1.2-1.4z" />
        <path d="M527 372s-3-1.7-5.2 2.2c-2.3 3.8-4.1 10.1-5.4 11-1.3.8 12.8-6.2 13-9.2 0 0 .9-3.8-.6-3.7-1.5 0-1.6.2-1.9-.4z" />
        <path
          strokeWidth={0.3}
          d="M527.3 372.4s-3 .7-3.6 4.9c-.6 4.2-4.7 6.3-5 6.5m49.4-51.6s-4.4 1.6-3.7 4.7"
        />
      </g>
      <path
        fill="#fff200"
        stroke="#000"
        strokeWidth={0.3}
        d="M533.7 341.3s.2-10.6 8.9-10.2c1.6.2.8 2.1.8 2.1s2-1.3 2.8.8c0 0 2.7-1.2 3 1.5 0 0 3-.4 2.6 2 0 0 2-.5 2 1.2 0 0 2.3-.9 2 1.5 0 0 2.6-1.7 2.3 1.4 0 0 2.6-1.9 3.5 1.2 1 3.2-2.6 9.8-6.1 11.5"
      />
      <path d="M557.9 342s1.1 8.2-3.5 11.3l.1.2c4.9-3 3.7-11.5 3.7-11.6h-.3zm-5.7 9l.2.2c3-2.9 3.7-10.6 3.7-11h-.3s-.7 8-3.6 10.8zm-2.7-1.9h.3a26 26 0 0 1 4.1-10.3l-.2-.1s-3.8 5.5-4.2 10.4zm-2.2-1.4h.3c.5-5.7 4.4-10 4.4-10.1l-.2-.2s-4 4.5-4.5 10.3zm-3-2h.3c.3-6.7 4.8-10 4.8-10l-.2-.3s-4.6 3.4-5 10.4zm-2.8-1.6h.3c-.2-6.2 4.5-10 4.6-10l-.2-.2s-5 3.8-4.7 10.2zm-5-2.3h.3a10.2 10.2 0 0 1 6.8-8.4v-.3a10.5 10.5 0 0 0-7.1 8.7z" />
      <path
        fill="#00a651"
        stroke="#000"
        strokeWidth={0.3}
        d="M528.6 354.2s-1.5-9.9 4.4-13c0 0 1.1-.2 1.7 1.2 0 0 3.1-1.3 3.2 1.3 0 0 1.6-1.2 2 .5 0 0 3.3-.7 2.7 1.8 0 0 2.8-.8 2.5 1.6 0 0 2.8-1 2.4 1 0 0 3-.6 2.2 1.8 0 0 3.7-.4 2.6 2.1 0 0 2.7-.7 2 1.4 0 0 3.6.7 2 3a24.1 24.1 0 0 1-9.8 7"
      />
      <path
        fill="#00a651"
        stroke="#000"
        strokeWidth={0.3}
        d="M525.4 364.1s-2.4-8.2 2.2-10.3c0 0 .9-.2 1 .6 0 0 1-1.3 1.8-.1 0 0 2.3-1.1 2.9.6 0 0 1.5-1.3 2.3.6 0 0 1.5-.6 1.5 1 0 0 2-1 2 1 0 0 2-.8 1.5 1.2 0 0 3 .5 2.1 1.9 0 0 2.7.7 1.7 1.8 0 0 2.8-.3 1.3 1.6 0 0 2.2-.7 1 1.7-1.3 2.4-5.2 5-8 5.4"
      />
      <path
        fill="#00a651"
        stroke="#000"
        strokeWidth={0.3}
        d="M528.3 370.6s-5.1-5-2.7-6.4c0 0 1 .3 1.5 1.4 0 0 1.2-1.8 2 0 0 0 1.8-.6 1.8.7l1.4 1s1.7-.1 1.4 1c0 0 1.9-.3 1.8.7 0 0 1.6.1 1.5 1.2 0 0 2.8.5 1.5 1.9 0 0-4.8 1-8.3-.4 0 0-1.7-.6-1.9-1.1z"
      />
      <path d="M545.9 362.4v.3a36 36 0 0 0 8.6-8.7l-.3-.2c0 .1-5.4 7.5-8.3 8.6zm-1.8-1.3l.2.3c2.6-1.5 7.9-8.5 8-8.8l-.1-.2c-.1.1-5.5 7.2-8 8.7zm-1.5-.6l.2.2a48 48 0 0 0 7-10.3l-.2-.1s-4.2 7.9-7 10.2zm-1.3-1.8h.3c.5-3.8 6-9.9 6-10l-.3-.1c-.2.2-5.5 6.2-6 10.1zm-10.9-4.7h.3c-.4-5.5 4.1-11.5 4.2-11.5l-.3-.2s-4.7 6.2-4.2 11.7zm2.9.5h.3c-.8-4.4 4.4-10.6 4.4-10.7l-.2-.2c-.2.3-5.3 6.4-4.5 10.9zm4.4 1.6h.3c-.2-5 4.6-10 4.7-10l-.2-.3c0 .1-5 5.2-4.8 10.3zm-10.5 9h.3c-1.8-4.7 1.2-10.6 1.3-10.6l-.3-.2s-3.1 6.1-1.3 10.9zm2 .4l.3-.1c-1.6-4.7 1-11 1-11l-.2-.2s-2.7 6.5-1.1 11.3zm8.3 4.7v.2c5-1.7 8.3-6.3 8.3-6.3l-.3-.2s-3.2 4.5-8 6.3zm-1-1.1v.3c4-1.8 7.7-6.8 7.7-6.8l-.2-.2s-3.7 5-7.5 6.7zm-1-.4l.2.3c3-2.3 7-8 7-8l-.2-.2s-4 5.7-7 7.9zm-5-2.9h.4a21 21 0 0 1 2.5-10.9l-.3-.1s-3.2 6-2.5 11zm2.2 1.4l.2.2c3.2-2.9 4.3-10.6 4.3-11h-.3s-1 8-4.2 10.8zm2.2.8l.2.3a17 17 0 0 0 5.7-9.5h-.3s-1.2 6-5.6 9.3zm.5-13.4v.9l-3.4 11 .3.1 3.4-11c-.5-5.4 4.2-11.3 4.3-11.3l-.3-.2s-4.3 5.3-4.3 10.5z" />
      <path d="M539 357.3c0 .2-1.1 7.7-5.2 10.5l.2.3c4.2-2.9 5.2-10.3 5.2-10.7 1.8-2.1 6-9.7 6-9.7l-.2-.2s-4.2 7.6-6 9.8zm-12 8.3c0 .1.6 4 1.4 5.2l.3-.1c-.8-1.3-1.5-5.1-1.5-5.2l-.3.1zm1.9 0l-.1 5.3h.3v-5.3h-.2z" />
      <path d="M529 371l.3.1c1.3-2.8 1.7-4.8 1.7-4.8h-.3s-.4 1.9-1.7 4.7zm.3.1l.2.3a6.6 6.6 0 0 0 3-4h-.3s-.6 2.4-2.9 3.7zm.5.2v.3c2.4-.2 4-3.1 4-3.3h-.2s-1.6 2.8-3.8 3z" />
      <path d="M530 371.5v.3c3.9-.3 5.6-2.6 5.6-2.7l-.2-.1s-1.7 2.2-5.4 2.5z" />
      <path d="M530.3 371.5v.3c.1 0 5 1.1 6.7-1.4l-.3-.2c-1.5 2.4-6.4 1.4-6.4 1.3z" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.8}
        d="M420.9 193.2v136.4c0 44.6 80.6 71 80.6 71s80.5-26.4 80.5-71V193.2z"
      />
    </g>
    <path fill="#002868" d="M0 0v240.3h358V0H0z" />
    <path
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        blockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal"
      }}
      fill="#fff"
      d="M0 0v26.9l139 93.3L0 213.5v26.8h40L179 147l139 93.3h40v-26.8l-139-93.3 139-93.3V0h-40L179 93.3 40 0H0z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
    />
    <path
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        blockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal"
      }}
      fill="#ce1126"
      d="M0 0v17.954l152.31 102.18L0 222.434v17.954h26.656l152.4-102.3 152.308 102.3h26.657v-18.075L205.71 120.254l152.31-102.18V0h-26.657L179.055 102.3 26.656 0H0z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
    />
    <path
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        blockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal"
      }}
      fill="#fff"
      d="M149.2 0v80.1H0v80.1h149.2v80.1h59.7v-80H358V80H208.8V0h-59.6z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
    />
    <path
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        blockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal"
      }}
      fill="#ce1126"
      d="M161.1 0v96.1H0v48.1h161.1v96.1H197v-96.1h161v-48H197V0h-36z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
    />
  </svg>
	),
	FK: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <linearGradient id="prefix__a">
        <stop offset={0} stopColor="#a43907" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="prefix__b"
        x1={444.4}
        x2={470.9}
        y1={592.2}
        y2={577.1}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__c"
        x1={458.2}
        x2={520.5}
        y1={562.5}
        y2={552.8}
        gradientTransform="scale(.94 1.07)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__d"
        x1={472.4}
        x2={445.3}
        y1={578.7}
        y2={580.2}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__e"
        x1={518}
        x2={456.4}
        y1={553.7}
        y2={558.1}
        gradientTransform="scale(.94 1.07)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__f"
        x1={851.8}
        x2={646.2}
        y1={369.9}
        y2={369.9}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__g"
        x1={388.5}
        x2={677.4}
        y1={507.2}
        y2={508.8}
        gradientTransform="scale(.82 1.22)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__h"
        x1={579.8}
        x2={556.8}
        y1={504.9}
        y2={505.9}
        gradientTransform="scale(.84 1.2)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__i"
        x1={581.4}
        x2={558.9}
        y1={512}
        y2={514.3}
        gradientTransform="scale(.82 1.22)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__j"
        x1={552}
        x2={589.8}
        y1={517.9}
        y2={503.9}
        gradientTransform="scale(.84 1.2)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
    </defs>
    <path fill="#006" d="M0 0h640v480H0z" />
    <path fill="#006" fillRule="evenodd" d="M0 0h400v200H0z" />
    <g strokeWidth="1pt">
      <path
        fill="#fff"
        d="M0 0v25.6l317.1 203h40v-25.5L39.9 0H0zm357 0v25.6l-317 203H0v-25.5L317.1 0h40z"
      />
      <path
        fill="#fff"
        d="M148.8 0v228.6h59.5V0h-59.5zM0 76.2v76.2h357V76.2H0z"
      />
      <path
        fill="#c00"
        d="M0 91.5v45.7h357V91.5H0zM160.7 0v228.6h35.7V0h-35.7zM0 228.6l119-76.2h26.6l-119 76.2H0zM0 0l119 76.2H92.4L0 17V0zm211.4 76.2L330.4 0h26.7L238 76.2h-26.7zm145.7 152.4l-119-76.2h26.6l92.4 59.2v17z"
      />
    </g>
    <path
      fill="url(#prefix__b)"
      fillRule="evenodd"
      stroke="#fff"
      strokeWidth={10}
      d="M671 321.6a13.2 13.2 0 0 0-2 .1c-3.4.6-8.8 11.7-11.7 18.2-4.7 5.6-7.1 10-9 13.2-.8 1.3-2 2.7-1.6 4.4-7 1.7-7.4 7.7-7.4 10 0 2.6.8 3.8.8 3.8l4.2 7.8v.1c4.5 9.3 11 21.7 14.8 22.7 5.2 1.5 18.8-3.5 29-12.2a164 164 0 0 0 62 12.6c23.8 0 45.2-5.7 61.9-12.6 10.2 8.7 23.7 13.7 29 12.2 3.7-1 10.3-13.5 14.8-22.7l4.1-7.9s.8-1.2.8-3.7c0-2.3-.4-8.4-7.4-10 .4-1.7-.7-3.2-1.5-4.5-2-3.3-4.4-7.7-9-13.4-3-6.5-8.4-17.4-11.7-18-4.8-.8-15 1.6-15 2.5v.5L795.4 344c0 .5 1 14.5 5 27a147 147 0 0 1-50.5 8.5c-19.8 0-36.7-3.5-50.4-8.6a136 136 0 0 0 5-27L684 324.7v-.5c0-.7-7.9-2.6-13-2.6zm5.2 24c2.6 0 5.3 2.2 7.6 4.5l-.2 1.4a78.7 78.7 0 0 1-3.2 10.6 85.8 85.8 0 0 1-14.3-10.3c2.2-2.4 5.8-5.6 9.6-6.1h.5zm147.6 0h.5c3.8.6 7.4 3.8 9.7 6.2a85.6 85.6 0 0 1-14.4 10.3 78.3 78.3 0 0 1-3.2-10.6 17 17 0 0 1-.2-1.4c2.2-2.4 5-4.5 7.6-4.5zm-166 27.4c2.7 2.1 6.3 4.5 10.6 7a12.3 12.3 0 0 1-3.8 1.7c-1.8.4-3.6.3-5.5-.1a17.5 17.5 0 0 1-1.2-5.7 70.3 70.3 0 0 1-.1-2.9zm184.5 0l-.2 2.9a17.6 17.6 0 0 1-1.2 5.7 12 12 0 0 1-9.3-1.6c4.4-2.5 8-4.9 10.7-7z"
      transform="matrix(1.17 0 0 1.17 -389.2 -22)"
    />
    <path
      fill="url(#prefix__b)"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.2}
      d="M445.6 595.5s5.7-8.8 10.3-8.1c4.7.6 9.1 6.2 9.4 6.5a41 41 0 0 0 6.9-7.5c-.3-.3-7.2-16.5-11-17.2s-11.8 1.2-11.8 1.8l-3.8 24.5z"
      transform="matrix(-1.48 0 0 1.54 1073.6 -525.4)"
    />
    <path
      fill="url(#prefix__c)"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.2}
      d="M433.1 586.1c0 .6 2 23.8 10 31.9s21.3 13.1 26 11.9c4.6-1.3 15.3-24.7 15.3-24.7s-11.3 11.2-19.7 9.3c-8.4-1.8-13.4-15.9-15-22.8-1.6-6.8-.3-20.3-.3-20.3L433 586.1z"
      transform="matrix(-1.48 0 0 1.54 1073.6 -525.4)"
    />
    <path
      fill="url(#prefix__d)"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.2}
      d="M445.6 595.5s5.7-8.8 10.3-8.1c4.7.6 9.1 6.2 9.4 6.5a41 41 0 0 0 6.9-7.5c-.3-.3-7.2-16.5-11-17.2s-11.8 1.2-11.8 1.8l-3.8 24.5z"
      transform="matrix(1.48 0 0 1.54 -99.8 -525.4)"
    />
    <path
      fill="url(#prefix__e)"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.2}
      d="M433.1 586.1c0 .6 2 23.8 10 31.9s21.3 13.1 26 11.9c4.6-1.3 15.3-24.7 15.3-24.7s-11.3 11.2-19.7 9.3c-8.4-1.8-13.4-15.9-15-22.8-1.6-6.8-.3-20.3-.3-20.3L433 586.1z"
      transform="matrix(1.48 0 0 1.54 -99.8 -525.4)"
    />
    <path
      fill="url(#prefix__f)"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.5}
      d="M656.4 338.6c-4.7 5.7-7.2 10.2-9.2 13.5-2 3.3-.8 8 3.7 14.5 5 7 45.4 34.7 98.1 34.7 52.7 0 93.1-27.6 98-34.7 4.6-6.6 5.8-11.2 3.8-14.5-2-3.3-4.5-7.8-9.2-13.5 0 8.6-33.5 40-92.6 40s-92.6-31.4-92.6-40z"
      transform="matrix(1.17 0 0 1.17 -388 -20.8)"
    />
    <path
      fill="url(#prefix__g)"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.2}
      d="M467.8 625.5l7.2-11.9-3.6-2.5c-1 3-5.1 4-5.8 7.8s2.8 7.5 2.2 6.6z"
      transform="matrix(1.48 0 0 1.54 -98.8 -524)"
    />
    <path
      fill="url(#prefix__h)"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.2}
      d="M475 623s1.3-5.3-2.8-6c-4-.6-6.2 3-5.6 1.6.6-1.6 3-3.1 3.4-8.4.3-5.3-.3-8.2-.3-8.2s1.6-6.8 8.1-5.9c6.6 1 6.9 6 6.9 7.8s-.6 2.8-.6 2.8L475 623z"
      transform="matrix(1.48 0 0 1.54 -99.8 -525.4)"
    />
    <path d="M568.3 406.3l2 3.5 1.3-.8-.9-2.3.2-.5 2.3-1.4 6 10.6v.5l-1.3.9.6 1 5.7-3.7-.5-1-1.3.8-.5-.1-6-10.6 2.2-1.5h.5l1.5 2 1.3-.9-2-3.4-11.1 7zm-14.3 8.2l.5 1 1.2-.5.5.1 5.2 10.8-.1.5-1.1.7.4 1 5.7-3-.5-1-1.2.5-.5-.1-2.5-5.1 5.8-3 2.5 5-.1.5-1.2.8.5 1 5.7-3-.5-1-1.2.5-.5-.2-5.2-10.7.1-.5 1.1-.7-.4-1-5.7 3 .5 1 1.2-.6.5.2 2.1 4.4-5.7 3-2.2-4.4.2-.5 1.1-.7-.5-1-5.7 3zm-3.3 9.2l.3 1 1.6-.4.5.2 1.2 4.5-1.1.4c-3.3 1-6-.6-7.2-4.5-1-3.8.3-6.7 3.5-7.7a4.8 4.8 0 0 1 1.9-.2l.4.3 1.1 2.1 1.6-.5-1-3.6c-1.8 0-3.4.2-4.8.6-4.8 1.6-7 5.5-5.8 10 1.3 4.5 5.3 6.6 9.8 5.2a15.4 15.4 0 0 0 4.6-2.4l-1.5-5 .3-.4 1.2-.5-.3-1.1-6.3 2zm-13.3 12.5l6.4-2-.3-1.1-1.5.3-.4-.2-3.5-11.6.2-.4 1.4-.6-.3-1-6.4 2 .3 1 1.5-.3.4.2 3.5 11.6-.3.4-1.4.6.4 1zm-34.8 5.7l11.3-1-.4-4.1-1.4.1-.2 2.4-.2.4-4.9.5-.5-6 2.8-.2.3.3.3 1.6h1.3l-.5-5.3h-1.2v1.7l-.4.4-2.7.2-.5-5.4 4.2-.3.3.2.5 2 1.5-.1-.3-3.6-10.6 1v1h1.4l.3.4 1 12-.2.4-1.3.2v1.2zm-16.9-15v1.1l1.3.1.3.4.2 12-.3.4-1.2.2v1h6V441l-1.3-.1-.4-.4v-5.7l6-.1.1 5.7-.3.4-1.2.1v1.1h6v-1.2h-1.3l-.3-.4-.2-12.1.3-.4 1.2-.1v-1.1h-6v1.2l1.3.1.3.3.1 5-6 .1-.2-5 .4-.3 1.2-.1v-1.1h-6zm-12.8-.4v4h1.4l.4-2.4.3-.3h2.5v12.4l-.4.4h-1.4v1.2h6.3v-1l-1.4-.2-.3-.4.1-12.3h2.5l.3.3.4 2.5h1.4v-4l-12.1-.2zm-19.5 12.9l11 .5.2-4-1.4-.1-.4 2.4-.3.3-4.8-.2.3-6 2.6.2.3.3.2 1.7h1.2l.2-5.2h-1.2l-.3 1.5-.3.3H458l.3-5.5 4 .2.3.3.2 2 1.5.1.1-3.6-10.3-.5v1.1l1.2.2.3.4-.6 12-.3.4h-1.3v1.1zm-25.4-6.6l6 2 .2-1-1.2-.6-.2-.5 3.5-11.5.4-.2 1.3.3.4-1-5.9-2-.3 1 1.2.6.3.4-3.6 11.5-.4.3-1.3-.4-.4 1.1zm-10.4-4a11.4 11.4 0 0 0 3.6 2c3.2 1 5.8-.2 6.5-2.7a4.2 4.2 0 0 0-.7-3.9c-1-1.2-1.9-1.9-2.4-2.5-.8-1-1.1-1.9-.8-2.9.3-1.1 1.5-1.7 3-1.2.5.2 1 .4 1.3.8l.1.4-.3 2.3 1.4.5 1-3.5a11 11 0 0 0-3.4-2c-2.8-1-5.2.3-6 2.7a4.3 4.3 0 0 0 .5 3.4c.6 1.1 1.5 1.8 2.1 2.5 1.2 1.2 1.6 2.3 1.3 3.4-.4 1.2-1.6 1.8-3.2 1.2a5.5 5.5 0 0 1-1.6-.9l-.2-.4.5-2.7-1.5-.5-1.2 4zm-13.3-5.6l10 5 1.7-3.7-1.3-.6-1.3 2-.4.2-4.3-2.2 2.5-5.3 2.4 1.2.1.4-.5 1.6 1.1.6 2.2-4.8-1.1-.5-.9 1.3-.4.2-2.4-1.2 2.2-4.9 3.7 1.9.2.4-.6 1.9 1.3.6 1.5-3.2-9.4-4.7-.5 1 1.1.7.2.5-5 10.9-.4.1-1.2-.4-.5 1zm-1.6-18.2l-5-3.5-.7 1 1 .8.1.5-6.3 10-.5.1-1-.6-.7 1 5 3.4c1.8 1.2 3.3 1.8 4.9 1.6 2.1-.2 4-1.4 5.4-3.7 2.5-4 1.8-7.9-2.2-10.6zm-2.1 0l1 .8c2.7 1.8 3 4.5.7 8s-4.7 4.4-7.4 2.5l-1-.6 6.7-10.6zm40 15.8l-.2 1 1.2.4.2.4-2.4 11.8-.4.3-1.2-.1-.2 1 5.7 1.3.2-1-1.2-.5-.3-.4 1-5 .4.1c2 .5 2.4 1.5 2.5 3.8.1 1.1.1 2.1 1 3.3.4.5 1 1 2 1.1a13.8 13.8 0 0 0 2 .3l.2-1-.2-.1c-1.4-.3-2-.8-2.1-2.1-.2-1.2 0-2.4-.5-3.6a3.5 3.5 0 0 0-1.8-1.8c2.3 0 3.8-1 4.2-3 .5-2.5-.8-4.2-4-4.9l-6-1.3zm4 2.1l.8.2c2 .5 2.8 1.7 2.4 3.5-.4 2.1-1.6 2.8-3.8 2.3-.2 0-.4 0-.7-.2l1.2-5.8zm74 1.3l.2 1.1h1.3l.4.2 1.9 12-.3.3-1.3.4.2 1 6.2-1-.1-1.1-1.4.1-.4-.3-.8-5h.4c2.2-.5 3 .4 4 2.4.5 1 .8 2 2.1 2.7.6.3 1.5.5 2.5.3a16.5 16.5 0 0 0 2.2-.6l-.2-1h-.3c-1.5.3-2.2 0-2.9-1.1-.6-1-1-2.2-1.8-3.1-.6-.6-1.4-1-2.5-1 2.4-.9 3.5-2.4 3.2-4.5-.4-2.5-2.4-3.5-5.8-3l-6.8 1.2zm4.8.5l1-.1c2.1-.4 3.4.4 3.7 2.3.3 2-.6 3.2-3 3.6h-.8l-1-5.8z" />
    <path
      fill="url(#prefix__i)"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.2}
      d="M467.8 625.5l7.2-11.9-3.6-2.5c-1 3-5.1 4-5.8 7.8s2.8 7.5 2.2 6.6z"
      transform="matrix(-1.48 0 0 1.54 1072.7 -524)"
    />
    <path
      fill="url(#prefix__j)"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.2}
      d="M475 623s1.3-5.3-2.8-6c-4-.6-6.2 3-5.6 1.6.6-1.6 3-3.1 3.4-8.4.3-5.3-.3-8.2-.3-8.2s1.6-6.8 8.1-5.9c6.6 1 6.9 6 6.9 7.8s-.6 2.8-.6 2.8L475 623z"
      transform="matrix(-1.48 0 0 1.54 1073.6 -525.4)"
    />
    <path
      fill="#0072c4"
      fillRule="evenodd"
      stroke="#fff"
      strokeWidth={3.9}
      d="M396.9 606s-75.5-21.4-75-102.2l.5-107h148.9l.5 106.4c.5 80.8-75 102.7-75 102.7z"
      transform="matrix(1.48 0 0 1.54 -99.3 -521.5)"
    />
    <g fillRule="evenodd">
      <path
        fill="#bcbcbc"
        d="M392.3 129c.2 0 1.5-1.3 2.8-2.4 1.7-1 3.3-2.1 5-3 1.4-.7 4-1.3 5.1-1.9a12.5 12.5 0 0 0 4.2-3.4c.2-2.1.5-3.7.5-6.2 1.8-1 3.4-1.8 5-2.4 2.3-.7 2.8-1.6 5.1-2 1.5-.5 3.9-.5 6-.5 2.3 0 3.7 1.7 5.8 2 2.5 1 3.6 1.7 5.6 3.4 1 1.4 1.7 2.6 3.6 3.6 1.5.8 2.9 2 4.6 2.4 2 1.1 3.6 1.8 5.1 3.4 1.4 1 2 2.4 3.2 3.4a36.1 36.1 0 0 0 4.7 3.4c2 1.3 4 2.3 7.1 2 1.7 0 3.5-.3 5.5 0 2.3 0 4.5 0 6.5.6 2.4 0 4.3.3 6.5.5 2 .3 4.1.4 6.4.4 2 .6 4.2.5 6.5.5h13c2.3 0 4.7.1 6.4.5a51 51 0 0 0 6.5-.5c2.5 0 4.4-.4 6.9-.5h7.8c2 .6 4.6 1 6 2 1.9.5 2.8 1.4 4.6 1.9 1.5.7 3.6 1.9 4.7 3.4a24.7 24.7 0 0 1 3.7 5.3c1.2 1.8 1.7 4 2.7 6.3.6 2.2 1 4.3 1 6.7.5 2.1.4 4.4.4 6.8-.5 2.2-.6 4.6-1.4 6.7 0 2.4-.5 4.5-.9 6.3-.4 2-.9 3.3-1 5.8v6.8c0 2.2-.6 3.8-.8 6.2a71 71 0 0 0-3.3 7.3 14.7 14.7 0 0 0-3.7 3.8c-1 .6-1.5 1.6-1.3 2 1.8.6 1.3 1.9 1.3 4.3.3 1.9.5 4.2 1 6.3.1 2.3.6 3.7 1.3 5.3.8 1 1 .5-.9.5-1.3 1-2.7.5-3.2-1.5a12 12 0 0 1-1.9-5.3c-.2-2.2-.6-4.4-1.3-5.8-.3-2.7-1-2.7-3.7-2.9-1.3-1.1-3-1.4-5.6-1.4-2.5 0-2.7-.3-2.7 2.4v6.8c-.5 2-1.4 3.5-1.9 5.3-1.4 1-2 2.7-3.7 3.8-.8 2.2-1.9 2.6-4.1 3l-2.8-3.4c1.3-2.2 2.4-2.5 3.2-4.9 1-1.9 1.6-3.1 2.3-4.8-1-1.5-1.8-2.2-2.7-4.3a26.3 26.3 0 0 1-2.3-5.3c-1.6-.6-4-.7-5.1-1.5-2.3-.5-2.9 2-5.6 2h-6.4c-2.9 0-3.6 1.5-6 1.4-.7.2-2.5-.1-5.1 0-2 .7-4.3.5-6.5.5-2.3 0-4.2-.6-6-1-2.1-.6-4.2-1.2-6.4-1.4-2.7 0-3.8.2-5.6 1.4-1.4.9-3.5 2.8-5 3.9-.7 1.6-1 4.3-2 6.2-.4 2-1.2 3.1-1.7 4.9a18.4 18.4 0 0 0-1.4 5.8c-.2 3.2-.9 2.8-2.8 1.9-.8-1.4-2-2.8-2.8-4.4.4-2.4 1-3.6 1-6.2-.5-2-1.5-1.8-2.8-.5 0 2.5 0 4.5-1 5.8a6 6 0 0 1-2.7 3.8c-.7 1.8-2.2 2.7-3.7 3.4-.2 0 0-.6 0-2-1.1-2.1 0-4 0-6.7 0-2.4-.2-4 .5-6.2 0-2.4-1-4.6-1.4-6.3-.9-1.8-1.4-2.7-3.7-3.4-1.7-.7-4-1.5-5.1-3a9.6 9.6 0 0 0-4.2-3.3c-2-.7-3.1-1.5-4.6-2.4-1.4-1.6-2.6-2.2-3.2-4.3-1-1.5-1.1-4.3-1.8-6.3a21.7 21.7 0 0 0-1.4-5.8 24.3 24.3 0 0 0-1.4-5.8c-.3-2-.8-4-1.4-6.3 0-2.3 0-4.6-.5-6.7v-6.8c-.3-2-.4-4.8-.9-6.3 0-2.6-.3-4-1-5.8-1-1.7-1-2.4-2.7-2.9-1.2 1.5-3.1 2.2-5.5 2.5-1.7-.4-4.1-.7-6-1.5-1.9-.4-3.1-1.2-4.6-2a43.2 43.2 0 0 0-2.8-3.8c-.3-2.5-.8-3.8-1-6.3 0-1.8.1-.8 2-3.3z"
      />
      <path
        fill="#fefefe"
        d="M419.6 146.4l.4-.4c-.8.8-.5.4 1.3-.3 1-.6 2.9-1.7 3.6-2.4.8-.4 2.2-1 3-1.7.8-1 1.7-1.8 2.9-2.7 1.2-1.1 2.4-1.5 3.9-2.4 1.8-.2 2.5-1 4.2-.4 1.6.4 2.3.4 3.6-1 1.3-.8 2.8-1.7 3.3-3V130c0 2.2-.5 3-2 3.7-1 1.3-2.4 2.6-3 3.8-1 1.5-1.2 2.3-2.2 3-.9 1.1-2.3 1.7-2.6 3.5.4.8 0 1.2 1 1.3.9.8 1.9.5 3.2 0a14.2 14.2 0 0 0 2.6-4c1.1-1.6 1.7-2.3 2.3-3.5 1.2-.8 1.9-1.4 2.3-2.7 1.3-.8 2.4-1.6 3.3-2.4 1-.6 1.5-1.1 2.9-1.4a6 6 0 0 1-1 3.8c-.3 1.9-.2 2.8.4 4 .9.7.7 1.2 1.3 2.5.5-1.2.8-3.4 1-4.8v-.3c0 1.4 0 3.4-.4 4.4 0 2 .5 2.9 1 4.4.5.8 1 1.3 1.6 1.7 0-2 .6-3.2.7-5 .4 1.3.3 3.2.6 4.7.1 1.6.7 2.8 1.3 4.1.8.4 1 1.8 1.3.7.8-2.4.8-5 1.3-7.5.1-1.3.2-3.2.7-4.1l-.7 4c.1-1.2.2-3 .7-4v-.4a39 39 0 0 1 .7 5.5c0 1.5-.1 3 .3 4.4 1-.5 1.7-1.7 2.3-3a18.2 18.2 0 0 1 2.6-3.8l-2.6 3.7a18.2 18.2 0 0 1 2.6-3.7v-.3a40.3 40.3 0 0 0-.3 4.7c0 1.6 0 3.4.3 4.5.4 1.8.9 2.1 1 4 0 1-.2 2 .3 2.5 1.4.3 1.4-.5 1.6-2.4 0-2.2.6-3.7.7-5.8 0-2.6.3.3.6 1.3a13 13 0 0 1 1 4.5c0 1-.1 1.9.3 2.4 1.3-.6 1.8-2 2.6-2.8.7-1.6 1.4-2.3 2-3.4 1.7-.3 1.6-1 1.6-3 0-1.7-.1-3.4.4-4.8a41 41 0 0 0 1.3-4.5c.6-.3 1.2.6 1.6 1.4.7 1.1.6 2.7.6 4.4.4 1.5 1 2.7 1.7 4.1a15 15 0 0 0 2.3 3.4c.3 1.1.3 3 .3 4.5 1.3-1.5 1.5-3.6 1.6-5.8-.2-1.5-.2-3.4-.6-4.8 0-1.5-.4-3-.7-4.1-1-.5-1.3-1-.3-2.4 1-.9 2.2-.5 3.9-.3.9.9 1.2 1.4 1.3 3.4 0 1.8 0 3.2.7 4.4.6 1 1.2 1.7 1.6 3.4.5.5.9 1.2 1.6.4.4-1 .7-3 1-4.1.3-1.3.9-2 1.6-2.4 0 1.9 0 3 .7 4.4.6 1.5 1 2.1 1.6 3.8.7.5.8 1.5 1.7 2 .2-1.6.3-3.4.3-5.4V145c.1-1.6.5-2.5 1-3.8 1 1.4 1 1.9 1 3.8 1-.4 1.2-1.2 1.6-2.4.7-.7 1-1 1.3.7.2 1.8.6 3.4 1 5.1.6.8 1.4 2.7 2.2 3.4a16.4 16.4 0 0 0 2 2.8c.5 1 .6 1.7 2 2 0-2.3 0-4.6-.4-6.8 0-2-.4-2.7-.6-4.5-.6-1.1-.9-2.9-.7-3.4a11 11 0 0 1 3 4.1c.7 1.7 1.4 2.8 2 4.5a20 20 0 0 1 2.5 3.4c1.2 1 1.8 2.1 3 3 .6.6 2 1 2.3.7-.1-2-.4-3.7-1-5.4a9 9 0 0 0-1-4.1c-1.3-1.1-2.3-1.9-3-3.4-.4-.5-.5-.8-.6-1.7a26.3 26.3 0 0 1 4.6 4.7 7 7 0 0 0 2.6 2.4c.6.8 2.5 1.7 3.9 2a5.6 5.6 0 0 0 3.3 2.1l-3.3-2a5.6 5.6 0 0 0 3.3 2v.4a13 13 0 0 0-2-5.5 8.8 8.8 0 0 0-3-3.8 9.3 9.3 0 0 0-3.2-3c-.9-1-2.2-2.8-3-3.4 1.5-1 3.1.6 4.6 1.3 1.3 1.4 2.5 3.2 3.3 4.1a18 18 0 0 0 3 4.5c1.4.8 2.3 1.6 3.5 2.7 2 .5 1.2-.2.7-1.7-.7-2 0-2 1.3-.7.9.7 2 1.7 3.3 2.4.5.7 1.4 1.2 2.2.7.4-.5.4-.5.4-1-.7-2.2-1.3-3.8-3-4.5-.7-1-2-2-3-3-.6-1-1.3-1.6-1.9-2.8l2 2.7c-.7-1-1.4-1.5-2-2.7h-.3c2 0 2.7.6 4.2 1.4a6.8 6.8 0 0 1 3 2.4c.6.8 1.6 1.7 2.3 2.7l3.2 2.4c1.1 1.4 1.3 2.3 1.3 4.4.7 1 .8 3 1 4.1-.2 1.9-.9.4-1-.7-.2-1.5-.8-1.4-2-1 0 2 .3 2.6 1 4.1a8 8 0 0 1-1.2 3.4c-.8.5-1-1-1.7-1.7 0-2-.6-2.3-2-3.4v1.4c.8 1.4 1.6 2.7 1.7 4.7a12 12 0 0 1 .7 4.5c0 1.7 0 3.3-.4 4.8 0 1.8-.3 2.6-.3 4.4v9.6a23.3 23.3 0 0 0-.3 4.4l.3-4.4c-.3 1.2-.3 2.7-.3 4.4v.3c-.6-1.7-1.3-3.2-1.7-5a10.3 10.3 0 0 1-2.2-3.5c-.3-1.5-.4-3.2-.7-4.4-.5-1.2-1-2.5-2-1.7-.4 2.5.1 4 1 6.4.5 1.6.5 3 1 4.5.8 1.8 1.4 2 0 4-.7 1.2-1 1.5-1.3 2.8-1.2.6-1.5 1-1.6 2.4-.4-1.3-1.4-2.9-2-4.4-.6-1.7-1.3-3.4-1.6-4.8-.8-1.2-1.8-3-2.6-3.8-.9-1-2-3-2.6-4-1.3-1.5-1.6-2.4-2.7-3.1-.2-.7-.6-1.6-1.3-1 0 1.6 0 3.3.4 4.7.3 2 .9 3.1 1 5.1v3.8c-.8-2-1.7-3.6-2.3-5.5-.8-1-1.5-3-2.3-3.7-.6-1.4-1-2.5-1.7-3.4-.1-1-.6-1-1-1.7 0 1.9.7 2.6 1 4 .7 1.4.9 3.5.7 4.2-.8-2.4-1.6-5-2.6-7.2-1-1.4-2-3.2-2.6-4.5-1-1.1-2-1.2-3-2a5.9 5.9 0 0 1-2.3-1.7c.3 1.8 1 3 1.3 4.4.3 1.7 1 3.1 1.3 4.5-.3 2.3-.8-.7-1.3-1.7-.3-2-1-3-1.6-4.1-.9-.7-1.7-1.8-2.6-2.4-1-.4-.6 0-.6 1.3 0 2.1 0 3.5.6 4.8.7 1 .7 2.3.7 4.1-.1 1.7-.4 3-.4 4.8v2.7c-.7-1.4-1.4-2.3-2-4.1-1-1.6-1.4-2.7-2.2-4.4-.7-.3-2-.6-2.6 0 .1 1.7.9 2.4 1 4.4-1.3 1.3-1.1 1.7-2-.3-.7-1.6-1.6-1.5-2.6-2.4-1.7-.2-1.1-1.3-1.6-2.8 0-1.3 0-2.6-.4-3.7-1.8 0-2.8 0-3.9 1-.5 1-.3 3 0 4.5v4.7c-.4 1.2-1 1.3-1.3 2.8-.6 1.4-.8 3-1.3 4-1.2 1.1-.7 1.2-1.3-.6v-11c0-1.8.3-2.7.3-4.4-.7-1.4-.8-1.7-3-1.7-.4.9-.2 2.5 0 3.4 0 1.7.2 3.3.4 4.5 0 1.8.2 2.9.3 4.4 0 1.8-.4 3.2-1.3 4-1.1.4-.1 1.2-1.3 1.5a15 15 0 0 1-3.6-2.4c-1.2-.4-2.4-.7-4.2-.7-2.2 0-2.2-.3-3-2a31.4 31.4 0 0 1-1.3-5.5c-.7-1.6-.8-2.7-1.3-4.5a6.2 6.2 0 0 0-2-2.4c-.4 1.8-.8 3.2-.9 5.2-.4.8-.5 2.8-.7 3.7-.6-1-.9-3-1.3-4.4-.6-2-1.1-3.4-3.2-2.7-2.2 0-2.3 0-2.3 2.4l2.6 4v4.8c0 2 .1 2.6-1.3 3-.5-2-1.7-4-3-5.7-.1-1.4-.5-1-1.9-1-.9 0-1.8-.2-2.3.3v3c-.8.2-1 0-1.6-.6-.6 1-.2 2.4 0 3.7-.4 1.6-1 3-1.6 3.8-.2-.5-.5-.3 0-.3-2.3-.9-4-1.4-6-2-1 0-1.9 1.1-2.5 2-1.7.5-2.4 1-4.3 1-1.8 0-2.6.3-4.2.3-1.2.3-2.7.4-4.3.4-.8-.3-2.4-.3-2.9-.7.7-1 1.4-1.5 2-3a20 20 0 0 0 2.6-2.5c.8-.6 1.8-1.9 2.6-2.7.5-1.7 1.2-2 2.3-2.7 2 0 2.3.7 4.2 1 1.9.7 3 1 4-.4 1.5-.6 2.8-1.7 4.5-2l3.3-2c1.4-.9 2-1.8 3.2-2.8.4-1.4 1.4-2.5 1-4-1.8-.5-2.9-.4-4 .6-1.3 1.2-1.6 1.7-3.2 2.7-1.3.4-2 1-3.6 1.4-1.3.5-3 .3-4.5.3s-3.4-.1-4.3.4c1.5-1 3.2-2 4.6-2.4 1.3-.9 1.8-1.3 3.6-1.4.8-1 1.6-1 2-2.7.5-2-1.3-1.4-2.7-.7-1.3.3-2.8 1.2-3.9 1.7a14.3 14.3 0 0 1-4.2.7c-.4-.6.3-1.1.6-2 1.5-.6 1.8-.8 2-2.4-1.8.2-2.4.8-4 1-1.6.4-3.3.6-5.2.7h-4.5c-1.6 0-2.5-.4-4.3-.4-1.3-.7-1.3-1-1.3-3 1-1.2 2-1 4-1l3.5-1.8c1.2-.2 2-.7 1.7-1.3h-4.6c-1.8-.8 0-1.1 1-1.7 1.5 0 3.2 0 4.2.6 2 0 2.7-.7 4.2-2 1.3-1 2-1.7 3.3-2.4 1-1.1 2-1.7 2.6-2.7 1.4-1.3 2.3-2 3-3.1.8-.5 1.4-1 1-1.7-2.1.2-3 1-4.3 2a10 10 0 0 1-2.6 2 8.2 8.2 0 0 1-4.3 1.5c-1.6 0-3-.3-4.5-.4-1.8-.2-.2-.6.3-1.4.7-.4 1.2-1.5.6-2.3-1.3-.5-3-.4-4.5-.4h-4.6c-1.7 0-2.4-.4-3.6-1-.3-1 0-.7 1.3-.7a18 18 0 0 0 4.3-.7c1.5-.4 1.7-1 2-2.7-1.6 0-3.3 0-4.3-.3h-3zm-28.2-7.8c-.3-2.5-.9-3.8-1-6.3 0-1.8.1-.8 1.9-3.3.2 0 1.5-1.3 2.8-2.4 1.7-1 3.3-2.1 5-3 1.3-.7 4-1.3 5.1-1.9a12.5 12.5 0 0 0 4.2-3.4c.1-2.1.4-3.7.4-6.2 1.9-1 3.5-1.8 5.1-2.4 2.3-.7 2.8-1.6 5.1-2 1.5-.5 3.9-.5 6-.5 2.3 0 3.7 1.7 5.8 2 2.5 1 3.6 1.7 5.5 3.4 1.1 1.4 1.8 2.6 3.7 3.6 1.5.8 2.9 2 4.6 2.4 0 1.8.4 1.5-.8 1.5-.2 1.8-.6 1.6-2.3 1.7a8 8 0 0 1-3-2.8c.7-1.7.3 1.5 0 2.1-.8.7-1.3 1.4-2.2.7-.6-1.7-1-2.8-1-4.8-.3-2.1-.9-.6-1.3.3-.5 1.8-.3 2.4.3 3.8-1.7 0-3-.2-4.2-.4-1.2-.3-2.6.1-4 .7-1.7 1.1-1.1 1.1-.3 2.4 1.5.5 2.6 1.3 4 2 1.4-.2 3-.6 4.5-1 1.6-.5 3-.2 4.6 0 .8.5 1.8.5 2.3 1 0 1.1 0 2.2-.4 2.8-.6.5-1.3 1.7-2.3 2a16.1 16.1 0 0 1-4.5 1.8c-2 0-2.8.5-4.3 1.3-.2 1.8-.7 2.2-2.3 2.8a10.3 10.3 0 0 1-4.5 1c-1 0-1.9.1-2.3-.4a12.8 12.8 0 0 0 2.6-4c.3-.8.9-1.2.3-1.8-1.9.1-2.4.1-2.6 2-.2 1.9-.9 2.2-2.3 2.8.4-1.7.5-3 1-4.4a25 25 0 0 1-4.2.3c-1 .6-1.4.9-1 2-1.3.5-3 .2-4.6 0-1.4 0-.6-.6-1.6-1.3-.7-1.3-1.4-1.6-3-1.7-.7 1-2 1.3-2.9 2-1.4.5-2.3.1-3.6-.6-1.6 0-1.4.5-1 1.7.7.4 0 .9 1 1 1 .8 1.8 1 3.6 1 1.4-.4 3-.3 4.6-.3 1.6 0 1.3.4 1.3 2-1 .8-2.6.7-4.3.7a16.6 16.6 0 0 1-3.9-1c-1.5-.1-2.7-.4-3.9 0-.5.6-2 .8-.3 1 .7.7 4.5.3 4.7 1.5 1 1 .7 2.3-.8 2.3a2.2 2.2 0 0 0-2.3 0c-1 .2-2.4 0-4.3.2 2.5.2-1.8-2.7-2.7-3.9z"
      />
      <path
        fill="#bcbcbc"
        d="M401.7 127.3l-2 1.3c-1.4.8-3 2-3.9 2.7-.7.6-.7 1-1.6 1 1.5-.2 2.2-.6 3.6-1.3 1.7-.2 3.3-.6 4.2-1.4.9-.3 0-1.6-.3-2.4zm15-16.1c.2 0 .6 1 1.3 1.7.5 1.3 1 2.2 1 3.8.4-1.7 1-3 1.3-4.8-.5-1-.5-1.3-2-1.4 0 1 .2.3-1.6.7z"
      />
      <path
        fill="#c4c4c2"
        stroke="#000"
        strokeWidth={0.9}
        d="M349.4 417.7c-.5 0 .8-.5 1.3-.6.4-.8.6-1.3 1.3-1.8 1.1 0 1.7.4 2.2 1.1 1 .3 1.3.7 2.4.9.5.4 1 .4 0 .7-.6.3-1.5.4-2.6.4a7.2 7.2 0 0 0-2.6.7c-1.5 0-1.3 0-2-1.4z"
        transform="matrix(1.48 0 0 1.54 -109.5 -520)"
      />
      <path
        fill="#bcbcbc"
        d="M422.6 111.5v.4c0-1 0-.5.3 1.4a9 9 0 0 1 .7 4 6.7 6.7 0 0 0 2-3c0-2.7-.5-2.6-3-2.8zm12 39.3h.4c-1 0-.4 0 1.3-1 1.1-.8 2-2 3.6-2.4a13 13 0 0 1 4.2-2.4c.8-.4 1.5-1 2.3-.3-.2 1.6-.5 2.3-2 3-.7 1-1.8 1.6-2.9 2-1 .6-2.2.6-2.6 1.8-1.8.8-2 .6-4.2-.7zm6.3 9.9c.5-.5 2.6-2.6 3.6-3.4a15 15 0 0 1 3.2-3.4c1-1.5 2.2-2.5 3-3.8l2.6-3.4c0 1.5-.2 3.5.3 4.4a7 7 0 0 1-1 4.1c-.7 1.2-1.3 2-3 2.8-1.4.8-2.3 1-3.5 2a26 26 0 0 1-3 1.7c-.9.4-.5.3-2.2-1zm-10.2 7.8h.4c-1 0-.5.1 1.3-1 1.4-1.4 2.5-2 4.2-2.7a10.3 10.3 0 0 0 4-1c.7-.2 1.3-.7 1.9 0 1 1.4 1.3 1.8-.3 2.7a9.4 9.4 0 0 1-3.3 1.7c-.8.7-2.4.7-4 1-1.2 0-2 .2-2.5-.7l2.6.7c-1.3 0-2 .2-4.3-.7zm14 0v-.3c0 1 0 .5.7-1.4 1.3-1.9 1.7-3 3.3-3.4.7-1 2-1.2 3.6-1.7.6 1 .1 2.2 0 3.4-.4 1.3-1.6 2.2-2.3 3.1-1 .7-1.4 1.4-3 1.7-1.2 0-.5 0-2.2-1.4z"
      />
      <path d="M412.8 124.2c0 .9-.7 1.7-1.6 1.7-1 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7c.9 0 1.6.7 1.6 1.7z" />
    </g>
    <g fill="#005120" fillRule="evenodd" stroke="#002b0d" strokeWidth="1pt">
      <path
        d="M351.8 479.6h.9c-2.8 0-1.1-.2 3.5 3.5 2-1.6 2-1.8 3.5 1 1 1.5 1.2-.2 2.7-1.8.7 3.2 1.1 6.5 3.5 3.5 2.8 0 5.6-.2 7.1.9 1.8 3.3 1.2-.6 2.6.9 4 .4 3.9-3.4 8.1-4.4 2.6 3.3 3.8.8 7-.8 2.5.6 4.8 4.3 5.3.7 2-3.2 2.1-3 3.5 0 2 1.8 2.8-.8 4.4-1.7 3 1.7 6.3 2 10.6.9.8 2.9 2.6 1.6 4.5.8 3.9 1.7 5.2 2.2 9.7 0 2.2-2.6 1 .1 2.6 1.8 3.3-1 2.4-1.2 6.2-.9 3.9 0 4.2 0 5.3-2.6 2 1.9 2.6 3.3 5.3.9 4.2 0 2.9.5 5.3-1 1.9 4 2.3 1.2 4.5 2.7a14.5 14.5 0 0 1-6.2 7c-1.7 3-2.8 6-6.2 7.2-2.5 2.5-5.2 4-8 6.2-3.8 1-8 .8-12.3.8H388c-2.6 1.4-7 2-10.6 2.7-4 0-8.7 0-11.5-.9-1.9-1.9-5.2-4-7-6.2-2-1.5-2-4.4-3.6-6.2-1.4-2.5-2-6.5-3.5-8.8v-6.2z"
        transform="matrix(1.48 0 0 1.54 -103 -521.4)"
      />
      <path
        d="M437.5 487.6v.8c0-2.4.1-1.1-1.8 3.6-.3 1.1-1.2 1.4-2.6 1.8m-3.5-2.7h.9c-3.3 3-5.5 4.5-6.2 8l6.2-8c-3.3 3-5.5 4.5-6.2 8m-7.1-12.4s-.1 3.1-.9 4.4m-2.6 1.8v.8-.8zm-7.1-5.3h.9-1c.4 0 .7 0 0 0zm-49.5 0c.4 0 2.2 2.8 4.4 4.4-.5 2.6-1.4 5.6 0 8m2.7-7.1c.4 0 2.1 2.8 4.4 4.4l-4.4-4.4c.4 0 2.1 2.8 4.4 4.4v.9c0-2.8-.2-5.6.9-7.1 1 1.7 2.2 4.3 2.6 1.8 5-.2 7.4-1.6 10.6-2.7 0 1.3-.2.7 1 1.8m60-3.6h.9c-1.7 1.4-3 4.3-4.4 6.2m-32.7-8.8h7"
        transform="matrix(1.48 0 0 1.54 -103 -521.4)"
      />
    </g>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M413.6 239.3c-15.7 0-20.9 16.4-36.6 16.4h-.9v1c0 11.4.8 22 2.5 31.9 14.5-1 19.8-16.4 35-16.4 15.7 0 21 16.4 36.7 16.4s20.9-16.4 36.6-16.4 21 16.4 36.7 16.4 20.9-16.4 36.6-16.4c15.1 0 20.5 15.2 35 16.3a189.8 189.8 0 0 0 2.5-32.7h-.9c-15.7 0-20.9-16.4-36.6-16.4s-21 16.4-36.6 16.4-21-16.4-36.7-16.4-21 16.4-36.6 16.4-21-16.4-36.7-16.4zm0 64.1c-12.2 0-18 10-27.5 14.3a151.4 151.4 0 0 0 11.7 24.9c4.5-3.4 9.2-6.3 15.8-6.3 15.7 0 21 16.4 36.6 16.4 15.8 0 21-16.4 36.7-16.4s21 16.4 36.6 16.4 21-16.4 36.7-16.4a25 25 0 0 1 15.5 6 152.8 152.8 0 0 0 11.7-24.7c-9.2-4.5-15.1-14.2-27.2-14.2-15.7 0-21 16.4-36.7 16.4s-20.9-16.4-36.6-16.4-21 16.4-36.6 16.4-21-16.4-36.7-16.4zm73.3 64c-15.7 0-21 16.5-36.6 16.5-14.9 0-20.4-14.7-34.2-16.3 18.5 20.6 39.4 33 53.7 40 4.9-3.8 9.9 4.5 17 4.5 7.3 0 12.2-8.4 17-4.7a176.2 176.2 0 0 0 53.3-39.7c-13.4 2-19 16.2-33.6 16.2-15.7 0-20.9-16.4-36.6-16.4z"
    />
    <g transform="matrix(1.18 0 0 1.18 -407 -18.2)">
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.5}
        d="M332.5 541.4a110 110 0 0 1 10.5-3l16.3 15.7-13.4 2.7-13.4-15.4z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.6}
        d="M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 31.3l6.7-31.1m-4.4 31.2l5.6-31.2m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5"
        transform="matrix(1.06 0 0 1.03 276.8 -178)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.4}
        d="M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1l6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5"
        transform="matrix(-1.25 0 0 1.76 1290.4 -502)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.5}
        d="M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1l6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5"
        transform="matrix(-1.25 0 0 1.3 1321.3 -302)"
      />
      <path
        fill="#dd8b59"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M395.3 572.2l.9-73s2.6-.3 2.6 0-.3 72.7-.6 73-3.2.5-2.9 0zm28.5-69.8l-.6 61.3-2 2.4.6-63.7h2z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#dd8b59"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M363 560.2s3 30 36.4 29.1 42.7-30.2 42.7-30.2l-14.5-.6c-.3 0-11.6 14-26.2 13.7s-19.2-3.8-22.4-6.7c-3.2-3-6-7.3-6-7.3l-17-6.7 1 6.4 6 2.3zm90.3-3l-1-4v-3.4l1.6-3.6s-25.3 3.7-25.3 4l-.1 6.8 24.8.1z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.5}
        d="M448.5 549.8l-.6 6h4.1l-.3-6h-3.2zm-4.3.3l-.3 6.4 2.6-.3.3-6.1h-2.6zm-4.4 6.4v-5l2.6-.9.3 5-2.9.9zm-5-.3l.6-4.4 3 .3.2 4.7-3.8-.6zm-5.5 0l.3-3.8 3-.3v4.4l-3.3-.3zm-67.4 3.7c.9 0 7.6 1.5 7.6 1.5l7 9.3"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.5}
        d="M366.8 561.1c.3.3 6.1 19.8 34 19.8s34.6-22.1 34.6-22.1"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.5}
        d="M439.8 559.4s-13.4 29-39 27c-25.5-2-29.6-11.6-31.6-16.6-2-5-3.2-9-3.2-9"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#dd8b59"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M373.2 558.2c.3-1.7.3-54.4.3-54.4l-1.7-.2-.3 53.7 1.7 1zm-41.5-17.1l22 10.7-.5 1.5S332 543.3 332 543c0-.3.2-1.5-.3-2z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#dd8b59"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M341.8 537.9c0 .8 3.2 18.6 3.2 18.6s2 .3 2 0l-3.4-18.3-1.8-.3zm20.4.5c1.1 0 21-3.2 21-3.2l-.4 3.2-19.5 2-1.1-2z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#fecf3e"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M365 514.3c.7 0 7 3.2 9.7 2.4s.9-3 1.4-3c.6 0 2.6 1.5 3.8.3 1.2-1.1 2-4.6 1.5-4.3-.6.3-16 5.8-16.3 4.6z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#dd8b59"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M362.5 521.6c1.1.3 23.8-6.1 23.8-6.1s0 2-.3 2l-23.5 6.1v-2z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#fecf3e"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M415 512.6s1.5 3.5 3 2.9 2.9-1.8 2.9-1.8 1.2 3 3.2 2.4c2-.6 3.2-3.8 3.2-3.8s2 .6 2.9.3c.9-.3 2-5 2-5l-17.1 5zm-1.7 28.2c-.3.6 1.5 2 3 2s2-2 2.3-1.4c.3.5.3 3.2 4 2.3s3.8-3.5 3.8-3.5-1.1.9 1.5 1.2c2.6.3 5.2-3.8 5-3.8-.4 0-19 3.5-19.6 3.2z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#dd8b59"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M363.4 513.1a5 5 0 0 0 .2 2.7l19-6.4s.8-1.5 0-1.5-19.5 5.8-19.3 5.3zm25-4c.5 0 19.4-6.1 19.4-6.1s.3 2.6 0 2.6l-17.7 5.2-1.8-1.7z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#fecf3e"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M413.3 521.9s-2.9 3.2-2 7.5c.9 4.4 2 8.2 2.3 8.2s3.5-5.8 7-6.1 9.9 3.2 9.9 3.2-.9-7-.6-10.2c.3-3.2 5.2-8.7 5.2-8.7l-21.8 6z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#dd8b59"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M386.9 516.6s-.6 2.7-.3 2.7l24.7-6.4V511l-24.4 5.5z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#b6b6b4"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M355.5 551.8s-5.8-.8-5.5.6c.3 1.5 2.9 2.9 3.2 3.8.3.9-.9 4 .9 3.8 1.7-.3 3.4-1.5 3.4-2.4l-.3-5-1.7-.8z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#dd8b59"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M387.8 537.3v2l20.9-2.9-.6-1.5-20.3 2.4z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#fecf3e"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M363 540.8c.4 0 0 2.6 2.4 2 2.3-.6 2.9-2 2.9-2s.6 3.2 3.8 2.9c3.2-.3 5-3.8 5-3.8s.2 2.6 2.2 1.7 2.6-2.9 2.6-2.9l-18.3 2.6-.5-.5zm0-17.2s-2.6.9-1.7 6.1 3 8.2 3.2 8.2c.3 0 2.6-5 6.1-5.8 3.5-1 9.6 2.6 9.6 2.6s-.6-4.7.3-9c.9-4.4 3.8-7.6 3.8-7.6s-20.4 5.5-21.2 5.5z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#dd8b59"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M411.9 538.7l.3 1.8s21-2.6 21-3c0-.2 0-2-.4-2-.3 0-20.6 3.5-21 3.2zm-.3-18.6l.3 2 24.7-6.6s.6-1.8.3-1.8-24.7 7.3-25.3 6.4z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.5}
        d="M414.2 510.8s-.3 1.8 0 1.8 18.3-4.4 18.3-4.7c0-.3 1.8-2 .3-1.7-1.4.3-18 5.5-18.6 4.6zm38.7 33.7l-18-28.4m-2.4 19.7c.3-.8 1.2-18.3 1.2-18.3"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="#fecf3e"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M389 510c1 .2 3.1 3.2 4.3 2.6 1.2-.6 2.9-2.4 2.9-2.4s-.3 3.5 2 3c2.4-.6 2.7-3 2.7-3s1.7 1 3.2 0c1.4-.8 2.8-5.2 2.3-5.2s-16.9 5.2-17.5 5zm-.6 8.4c0 .6-3 5.2-2 9.6s2.5 8.4 2.8 8.4 4.7-4.6 8.5-5.5c3.7-.9 9.3 2.9 9 2.9-.3 0-1.5-4.4-1.5-7.6 0-3.2 4.4-13 4.4-13l-21.2 5.2zm0 21c0 .2.8 2.2 2.9 2.2 2 0 2.3-2 2.3-2s-.3 3.5 2.9 3.2c3.2-.3 4.3-3.5 4.3-3.5s.3 1.8 3 .9c2.6-.9 6-3.8 5.8-3.8-.3 0-21 3.8-21.3 3z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <use
        width={992.1}
        height={496.1}
        transform="translate(-6.6 7.3)"
        xlinkHref="#prefix__k"
      />
      <use
        width={992.1}
        height={496.1}
        transform="translate(6.6 3.8)"
        xlinkHref="#prefix__k"
      />
      <use
        width={992.1}
        height={496.1}
        transform="translate(0 11)"
        xlinkHref="#prefix__k"
      />
      <path
        id="prefix__k"
        fill="#be0f17"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.6}
        d="M409 477a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0z"
        transform="matrix(.04 -1.07 1.02 .04 251.6 668)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.5}
        d="M398.2 500c0-.2 9 3.8 9 4.1 0 .3 32 42.8 32.3 42.8m-16-42.8l8.2 3.5 2.6 6.4m-61.4-10.4c-.3 0 9 7 9 7l1.2 5.7M341.3 546c4-1.7 32.2-26.4 32.2-26.4m-39.8 21.7l31.7-26.7m21.2 4l30 49.8m-3.6-29.2s3.5 11.7 7 13.5 7.6 4.6 7.6 4.6"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.5}
        d="M412.6 539.5s2.5 13.8 6 16.4 7 5.5 7 5.5"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.5}
        d="M391 439s3.4 19.2 10.4 23.6a950 950 0 0 1 12.8 8.1"
        transform="matrix(1.25 0 0 1.3 256.3 -299.5)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.5}
        d="M390.7 438.7s7.5 15.2 14 19.8c6.3 4.7 15 9 15 9M366.3 440c2 3.5 1.7 10.2 4 12.5a66 66 0 0 1 5.8 7.6m-9.3-19.9c1.2 1.7 4.4 10.4 6.4 13 1.5 2.4 16.3 17.2 16.3 17.2"
        transform="matrix(1.25 0 0 1.3 256.3 -299.5)"
      />
      <path
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M384.6 471.1a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm10.7 4.7a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0zM409 477a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0zm11.9-4.5c0 1-.7 1.7-1.6 1.7-.9 0-1.6-.8-1.6-1.7s.7-1.8 1.6-1.8c.9 0 1.6.8 1.6 1.8zm9.6-5.7c0 .9-.9 1.6-1.9 1.6s-1.9-.7-1.9-1.6c0-.9.9-1.6 1.9-1.6s1.9.7 1.9 1.6z"
        transform="matrix(1.25 0 0 1.3 256.3 -299.5)"
      />
      <path
        fill="red"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M374.1 404.4c-.9.6-15.4 4.1-13.4 3.8 2-.3 13.7 3 13.4 2s0-5.2 0-5.8zm24.7-4.3c-.6 0-9 3.2-8.7 3.2s9.6 2.6 9.3 2c-.3-.6-.3-4.4-.6-5.2zm25.3 2.9c-.6.3-10.5 2.6-8.7 2.9s8.4 2.6 8.4 2c0-.5 0-4.6.3-5z"
        transform="matrix(1.25 0 0 1.3 256.3 -299.5)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.5}
        d="M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1l6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5"
        transform="matrix(1.25 0 0 1.3 256.3 -299.5)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.5}
        d="M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 31.3l6.7-31.1m-4.4 31.2l5.6-31.2m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5"
        transform="matrix(1.25 0 0 1.36 225.3 -323.4)"
      />
      <path
        fill="none"
        stroke="#512007"
        strokeWidth={0.5}
        d="M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1l6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5"
        transform="matrix(-1.25 0 0 1.32 1259.2 -307.3)"
      />
      <path
        fill="#dd8b59"
        fillRule="evenodd"
        stroke="#512007"
        strokeWidth={0.5}
        d="M426.4 558.5l27.6.6.3-2-28.5-.3.6 1.7zm1.2-7.3c3.2 0 27.3-4.6 27.3-4.6s.9-3 0-3-27.3 5.6-27.3 5.6v2z"
        transform="matrix(1.25 0 0 1.3 259.4 -430)"
      />
      <use
        width={992.1}
        height={496.1}
        transform="translate(0 5.5)"
        xlinkHref="#prefix__k"
      />
    </g>
  </svg>
	),
	FM: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-81.3 0h682.6v512H-81.3z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="translate(76.3) scale(.94)"
    >
      <path fill="#6797d6" d="M-252 0H772v512H-252z" />
      <path
        fill="#fff"
        d="M259.8 123l-32.4 22.2 12.4-35.9-32.5-22.2h40.1l12.4-35.9 12.4 36h40l-32.4 22.1 12.4 35.9M259.8 390l-32.4-22.2 12.4 36-32.5 22.1h40.1l12.4 35.9 12.4-36 40 .1-32.4-22.2 12.4-35.9m-188.4-92.4L79.3 306l1.4-38-37.5-11.7 38.4-11.7 1.3-38 22.3 30.8 38.4-11.8-24.6 30.7 22.4 30.7m274.2-11.7l24.6 30.7-1.4-38 37.5-11.7-38.4-11.7-1.3-38-22.3 30.8-38.4-11.8 24.6 30.7-22.4 30.7"
      />
    </g>
  </svg>
	),
	FO: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-78 32h640v480H-78z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth={0}
      clipPath="url(#prefix__a)"
      transform="translate(78 -32)"
    >
      <path fill="#fff" d="M-78 32h663.9v480H-78z" />
      <path
        fill="#003897"
        d="M-76 218.7h185.9V32H216v186.7h371.8v106.6H216V512H109.9V325.3h-186V218.7z"
      />
      <path
        fill="#d72828"
        d="M-76 245.3h212.4V32h53.1v213.3H588v53.4H189.5V512h-53V298.7H-76v-53.4z"
      />
    </g>
  </svg>
	),
	FR: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#00267f" d="M0 0h213.3v480H0z" />
      <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	GA: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#ffe700" d="M640 480H0V0h640z" />
      <path fill="#36a100" d="M640 160H0V0h640z" />
      <path fill="#006dbc" d="M640 480H0V320h640z" />
    </g>
  </svg>
	),
	GB: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-85.3 0h682.6v512H-85.3z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="translate(80) scale(.94)">
      <g strokeWidth="1pt">
        <path fill="#012169" d="M-256 0H768v512H-256z" />
        <path
          fill="#fff"
          d="M-256 0v57.2L653.5 512H768v-57.2L-141.5 0H-256zM768 0v57.2L-141.5 512H-256v-57.2L653.5 0H768z"
        />
        <path
          fill="#fff"
          d="M170.7 0v512h170.6V0H170.7zM-256 170.7v170.6H768V170.7H-256z"
        />
        <path
          fill="#c8102e"
          d="M-256 204.8v102.4H768V204.8H-256zM204.8 0v512h102.4V0H204.8zM-256 512L85.3 341.3h76.4L-179.7 512H-256zm0-512L85.3 170.7H9L-256 38.2V0zm606.4 170.7L691.7 0H768L426.7 170.7h-76.3zM768 512L426.7 341.3H503l265 132.5V512z"
        />
      </g>
    </g>
  </svg>
	),
	GD: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <g id="prefix__c">
        <g id="prefix__b">
          <path
            id="prefix__a"
            fill="#fcd116"
            d="M0-1v1h.5"
            transform="rotate(18 0 -1)"
          />
          <use transform="scale(-1 1)" xlinkHref="#prefix__a" />
        </g>
        <use transform="rotate(72)" xlinkHref="#prefix__b" />
        <use transform="rotate(144)" xlinkHref="#prefix__b" />
        <use transform="rotate(216)" xlinkHref="#prefix__b" />
        <use transform="rotate(288)" xlinkHref="#prefix__b" />
      </g>
    </defs>
    <path fill="#ce1126" d="M0 0h640v480H0z" />
    <path fill="#007a5e" d="M67.2 67.2h505.6v345.6H67.2z" />
    <path fill="#fcd116" d="M67.2 67.3h505.6L67.2 412.9h505.6z" />
    <circle cx={319.9} cy={240.1} r={57.6} fill="#ce1126" />
    <use
      width="100%"
      height="100%"
      transform="matrix(52.8 0 0 52.8 320 240)"
      xlinkHref="#prefix__c"
    />
    <use
      width="100%"
      height="100%"
      x={-100}
      transform="translate(-30.3)"
      xlinkHref="#prefix__d"
    />
    <use
      id="prefix__d"
      width="100%"
      height="100%"
      transform="matrix(31.2 0 0 31.2 320 33.6)"
      xlinkHref="#prefix__c"
    />
    <use
      width="100%"
      height="100%"
      x={100}
      transform="translate(30.3)"
      xlinkHref="#prefix__d"
    />
    <path
      fill="#ce1126"
      d="M102.3 240.7a80.4 80.4 0 0 0 33.5 33.2 111 111 0 0 0-11.3-45l-22.2 11.8z"
    />
    <path
      fill="#fcd116"
      d="M90.1 194.7c10.4 21.7-27.1 73.7 35.5 85.9a63.2 63.2 0 0 1-10.9-41.9 70 70 0 0 1 32.5 30.8c16.4-59.5-42-55.8-57.1-74.8z"
    />
    <use
      width="100%"
      height="100%"
      x={-100}
      transform="translate(-30.3 414.6)"
      xlinkHref="#prefix__d"
    />
    <use
      width="100%"
      height="100%"
      transform="matrix(31.2 0 0 31.2 320 448.2)"
      xlinkHref="#prefix__c"
    />
    <use
      width="100%"
      height="100%"
      x={100}
      transform="translate(30.3 414.6)"
      xlinkHref="#prefix__d"
    />
  </svg>
	),
	GE: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path fill="red" d="M272 0h96v480h-96z" />
    <path fill="red" d="M0 192h640v96H0z" />
    <path
      fill="red"
      fillRule="evenodd"
      d="M146.8 373.1c1-16.8 4-31.1 4-31.1s-9.8 1-14.8 1c-4.9 0-14.8-1-14.8-1s3 14.3 4 31.2c-16.9-1-31.2-4-31.2-4s1 7.4 1 14.8-1 14.8-1 14.8 14.3-3 31.2-4c-1 16.9-4 31.2-4 31.2s7.4-1 14.8-1 14.8 1 14.8 1-3-14.3-4-31.2c16.9 1 31.2 4 31.2 4s-1-9.8-1-14.8c0-4.9 1-14.8 1-14.8s-14.3 3-31.1 4zm368-288c1-16.8 4-31.1 4-31.1s-9.8 1-14.8 1c-4.9 0-14.8-1-14.8-1s3 14.3 4 31.1c-16.9-1-31.2-3.9-31.2-3.9s1 7.4 1 14.8-1 14.8-1 14.8 14.3-3 31.2-4c-1 16.9-4 31.2-4 31.2s7.4-1 14.8-1 14.8 1 14.8 1-3-14.3-4-31.1c16.9 1 31.2 4 31.2 4s-1-10-1-14.9 1-14.8 1-14.8-14.3 3-31.2 4zm-368 0c1-16.8 4-31.1 4-31.1s-9.8 1-14.8 1c-4.9 0-14.8-1-14.8-1s3 14.3 4 31.2c-16.9-1-31.2-4-31.2-4s1 7.4 1 14.8-1 14.8-1 14.8 14.3-3 31.2-4c-1 16.9-4 31.2-4 31.2s7.4-1 14.8-1 14.8 1 14.8 1-3-14.3-4-31.2c16.9 1 31.2 4 31.2 4s-1-9.8-1-14.8c0-4.9 1-14.8 1-14.8s-14.3 3-31.1 4zm368 288c1-16.8 4-31.1 4-31.1s-9.8 1-14.8 1c-4.9 0-14.8-1-14.8-1s3 14.3 4 31.2c-16.9-1-31.2-4-31.2-4s1 7.4 1 14.8-1 14.8-1 14.8 14.3-3 31.2-4c-1 16.9-4 31.2-4 31.2s7.4-1 14.8-1 14.8 1 14.8 1-3-14.3-4-31.2c16.9 1 31.2 4 31.2 4s-1-9.8-1-14.8c0-4.9 1-14.8 1-14.8s-14.3 3-31.2 4z"
      style={{
        mixBlendMode: "multiply"
      }}
    />
  </svg>
	),
	GF: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#078930" d="M0 0h640v480z" />
    <path fill="#fcdd09" d="M0 0l640 480H0z" />
    <path fill="#da121a" d="M252.4 218h135.2l-109.4 79.5L320 169l41.8 128.6z" />
  </svg>
	),
	GG: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path fill="#e8112d" d="M256 0h128v480H256z" />
    <path fill="#e8112d" d="M0 176h640v128H0z" />
    <path
      id="prefix__a"
      fill="#f9dd16"
      d="M110 286.7l23.3-23.4h210v-46.6h-210L110 193.3z"
    />
    <use
      width={36}
      height={24}
      transform="rotate(90 320 240)"
      xlinkHref="#prefix__a"
    />
    <use
      width={36}
      height={24}
      transform="rotate(-90 320 240)"
      xlinkHref="#prefix__a"
    />
    <use
      width={36}
      height={24}
      transform="rotate(180 320 240)"
      xlinkHref="#prefix__a"
    />
  </svg>
	),
	GH: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#006b3f" d="M0 0h640v480H0z" />
    <path fill="#fcd116" d="M0 0h640v320H0z" />
    <path fill="#ce1126" d="M0 0h640v160H0z" />
    <path d="M320 160l52 160-136.1-98.9H404L268 320z" />
  </svg>
	),
	GI: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#da000c" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M0 0h640v321.6H0z" />
    <g stroke="#000" transform="translate(-160) scale(1.875)">
      <g id="prefix__a" fill="#da000c" strokeLinecap="square">
        <path fill="#000" stroke="none" d="M196.6 116.3h64v44h-64z" />
        <path d="M229.8 153.9h-39l-8.7 5.7v6h47.7m-16.3-37c5.6 0 10.2 4.7 10.2 10.5v14.7h7.3v-56h-40.3v56h12.6v-14.7c0-5.6 4.5-10.5 10.2-10.5z" />
        <path fill="#000" stroke="none" d="M204.5 60h18.6v34h-18.6z" />
        <path d="M223 88.7h-16.2v-5.8h-11.9v5.8h-8v-5.8H182v10.4h41m-36.2 0h35v4.5h-35zm14-45.7V83h6v-9.7c0-3.6 2.5-6.6 6.1-6.8h.4a6.8 6.8 0 0 1 6.8 6.8V83h5.7V47.6zm-2.3-4.8v4.8h29.3v-4.8zm-3.7-9.1v9.1h35v-9.1h-5.3v4.7h-6.6v-4.7h-10v4.7h-6.5v-4.7zM182 159.6h48m31-2.8h-32.4l-9.8 4.7v7H261" />
        <path strokeLinecap="butt" d="M218.8 161.5H262" />
      </g>
      <use
        width="100%"
        height="100%"
        transform="matrix(-1 0 0 1 512 0)"
        xlinkHref="#prefix__a"
      />
      <g fill="#f8d80e">
        <g strokeLinecap="round">
          <path
            strokeWidth={0.8}
            d="M273.3 150c-2.7 1-5 2.4-7.5 3.8a72.4 72.4 0 0 0-8.9 6c-1 .7-2 1.4-2.7 2.4-1 .8-2 2-1.8 3.5 0 .6.8-.8 1.4-.9a4.4 4.4 0 0 1 3.1-.4c1.3-1.4 3-2.3 4.4-3.4a77.4 77.4 0 0 1 13-7.6l-1-3.4z"
          />
          <path d="M260.4 157.4v3.9m2.4-5.6v3.9m2.4-5.4v3.8m2.5-5.3v4" />
          <path
            strokeWidth={0.8}
            d="M238.9 150.2l-1.2 3.3a86.6 86.6 0 0 1 15.8 8c1.7 1.2 3.5 2.3 4.8 3.9.3.8-.5 1.5-1.3 1.2-.7-.2-1.5-.5-2.2 0-1.1.5-2.1 2.2-.5 2.7 2.4 1.6 6.1.9 7.2-1.8.6-1.4.7-3.2-.5-4.4-2-2.3-4.8-4-7.4-5.7a89.2 89.2 0 0 0-14.7-7.2z"
          />
          <path d="M254 158l-.3 3.4m3.1-1.7l-.8 3.3m3.8-1l-1.8 2.6m2.7 3.6l-2.6-1.4m3.4-1.4l-3 .3m-.8 4l-.2-2.6m-1-.3l-2.4 1.8m-9.4-15.7v3.1m6.3.3v3.5m-3.2-5.2v3.3" />
        </g>
        <path d="M235.8 227.6v8h5v-4h6.9v4h5.4v-8zm0 11v8H253v-8h-5.4v4h-6.9v-4z" />
        <path d="M253 193.7h5v58h-5z" />
        <path d="M253 198.7h5v50h-5zm2.6-19.3l10.6 6.2-10.6 6.2-10.7-6.2zm-14.3 4h-2.7v4.4h2.7l14.3 8.3 14.2-8.3h2.8v-4.4h-2.8l-14.2-8.3z" />
        <path d="M255.3 164.3a5 5 0 0 0-4 5.1v11.2a5 5 0 0 0 4.6 4.6 4.9 4.9 0 0 0 4.8-2.8l-1.7-1a2.9 2.9 0 0 1-3 1.8c-1.6 0-2.9-1.6-2.7-3.1v-11.2a2.9 2.9 0 0 1 3-2.6c.6-.2 1.5.7 1.9 0 .6-.9-.4-1.5-1-2h-1.9zm5.8 3.9a5 5 0 0 1-1.9 1.6v7.5l2 1.1v-10.2z" />
      </g>
      <g fill="#da000c">
        <path fill="#000" d="M240.8 38.4h29.3v53.2h-29.3z" stroke="none" />
        <path d="M238.8 38.4v44.5h9.3V69.7c0-3 2-7.3 7.9-7.3s8 4.3 8 7.3V83h9.2V38.4zm15.8 5h2.8v15.2h-2.8zm-8.3 3h3v11.1h-3zm16.5 0h2.9v11.1h-3zM235.6 32v6.3h40.8V32zm-3.8-7.4V32h48.5v-7.4h-6.1v4h-7v-4h-7.8v4h-6.8v-4h-7.9v4H238v-4zm-9 73.2v4.6h66.5v-4.6z" />
        <path d="M220 82.9v15h72v-15h-6.8v5.8H276v-5.8h-12.2v5.8H248v-5.8h-12.2v5.8h-9v-5.8z" />
        <path
          strokeLinejoin="round"
          d="M228.7 102.4v54.4h12.8v-20.4c0-9.5 6.4-14 14.5-14 7.8 0 14.5 4.5 14.5 14v20.4h12.8v-54.4z"
        />
      </g>
    </g>
  </svg>
	),
	GL: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path
      fill="#d00c33"
      d="M0 240h640v240H0zm80 0a160 160 0 1 0 320 0 160 160 0 0 0-320 0"
    />
  </svg>
	),
	GM: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0-48h640v480H0z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="translate(0 48)"
    >
      <path fill="red" d="M0-128h640V85.3H0z" />
      <path fill="#fff" d="M0 85.3h640V121H0z" />
      <path fill="#009" d="M0 120.9h640V263H0z" />
      <path fill="#fff" d="M0 263.1h640v35.6H0z" />
      <path fill="#090" d="M0 298.7h640V512H0z" />
    </g>
  </svg>
	),
	GN: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="red" d="M0 0h213.3v480H0z" />
      <path fill="#ff0" d="M213.3 0h213.4v480H213.3z" />
      <path fill="#090" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	GP: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#00267f" d="M0 0h213.3v480H0z" />
      <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	GQ: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#e32118" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M0 0h640v320H0z" />
    <path fill="#3e9a00" d="M0 0h640v160H0z" />
    <path fill="#0073ce" d="M0 0v480l180-240z" />
    <g stroke="#000">
      <path
        fill="#fff"
        d="M281.6 191.8h76.6V272c0 27-35.2 6.2-38.2 20.6-5.2-14.8-38.2 6.6-38.2-22.2l-.2-78.6z"
      />
      <path
        fill="#73452b"
        strokeWidth={0.2}
        d="M325.4 279.8s-1 1-2.8.2c-1.8-.8-2-51.4-2-51.4 4-4.4 7.2-5.8 7.2-5.8l2.4 2c-9 4.6-8.2 11.2-7.4 22.6.2 4.2.2 9.6 1.2 14.8 1.4 6.6 4.2 12.2 4.4 16.4.2 2.6-3 1.2-3 1.2z"
      />
      <path
        fill="#73452b"
        strokeWidth={0.2}
        d="M319.2 221.6h3.6c-3 29-.4 46.2-.4 54.6 0 2.8 1.6 3.8 1.4 3.8-3.6 4-5.4-.2-5.4-.2z"
      />
      <path
        fill="#a36629"
        strokeWidth={0.2}
        d="M313.6 279.8c-3.4 1.6-3.8-1.6-3.6-2 7.4-15 10.6-48 3.8-51.6l.4-3.2c2.6.8 5 4.2 5 4.2 1 37 0 52.2-.6 52.8-3.6 3.8-5-.6-5.2-1"
      />
      <path
        fill="none"
        strokeWidth={0.2}
        d="M313.4 279.2c-.6-3.2 5.2-11.4 4.8-20m5 7c1.8 5 2.6 9.4 2.2 13.6"
      />
      <path
        fill="#009a3b"
        strokeWidth={0.2}
        d="M331 208c1.2-1.4 1.2-1.4 3.4-1.4.4-3 5.4-3 5.8.8 4-.8 4.8 1.6 3.2 4 3.8-1 7.2 0 6.2 4.4 6.8 1.8 4.2 6.6 1.2 7.6-.4 3-3.2 4-7 2.8-4.8 3.4-7.6 2.2-9.8-1.2-5.4.8-5.8-.4-8.2-3.4-4.2 1.8-5 1.8-8.6-.4-.2 2.8-1.2 2-3 1.8.2 3.6-1.2 5.2-4.4 4 2.4 5-3.8 7.2-6.8 3-2.8.2-3-.6-4.4-1.6-1.2 4-5.6 3.4-6.4 1.2-5.6-.8-5-3.8-.4-4 .4-3.2 3.2-2.6 5-2.2.2-2 1.4-1.6 2.4-1.2-.6-1.4-.2-2.2 1.6-2.6-2.6-3.4-1-4.6 1.6-5.8-1.4-3.2 1-3 2.8-3.2-.2-3.4.8-4 4.4-4.4-.4-1.2.2-2.2 2.2-2.2-1.2-3.4.4-4.2 4-3.6.6-5 11.2-2.6 10.4 4.2 3 .4 4 1 4.8 3.4z"
      />
      <path
        fill="none"
        strokeWidth={0.2}
        d="M309.6 206.2c.8.4 1.8 0 2 2.2 1.6-2.8 3.6-1.2 3.6 2m11-5.8c-.8 1.2-3.8 1.2-3.4 4.4-1-1.4-3-1.8-3.8-.4m12-.6c0 .8-.2 3.2-1 4.4m13.4-1c.2.2-2.8 0-4.2 1m11.6 11c-.8-.4-2.4-1.4-3.6.2 0-.8 0-3-2.2-3m-1.2 5.6c0-2-.4-2.6-.8-3.2m-5.8.4c-1.6-1.2-3.2.6-3.2 1.6m-8.4-3.4c0-.8-.6-2.4.8-3M302.8 230c.4-2 1.8-2 1.6-3-.2-1.6-2-3-4.2-.8m4.2.8c1.2-.4 2.4-.2 2.8.4m-6.2-7.8c.8-.8 2.8-.6 4 0m0-4.8c1 0 2.8-.4 3.4 1.4 2.2-3.4 3.8-3 4.2-2.2m4-.4c1.6-.6 4.4 1 6 3.8.8-2.2 2-1.8 3.2-2m7.6 2c2.6-1.2 4.2 1.2 5 2.2 1.2-1.6 2.2-1.6 3.4-1.6m-32.6 4.2c.6-1 2-1.2 3-.6-.2-1.8 1-2.6 1.8-2.2"
      />
      <path
        fill="gold"
        strokeWidth={0.7}
        d="M317.4 180.5l-4.4.2-2.2 4-2.4-3.8-4.4.2 2-4-2.4-3.7 4.6-.2 2-4 2.4 3.8 4.4-.2-2 4zm-18.8 1.5l-4.4 1-1.2 4.3-3.2-3.2-4.2 1 1.2-4.2-3-3.2 4.2-1.1 1.2-4.3 3.2 3.2 4.4-1-1.4 4.3zm-18.2 3.7l-4 2-.2 4.4-3.8-2.4-4 2 .4-4.5-3.8-2.4 4-2 .4-4.5 3.6 2.5 4-2-.2 4.4zm42.8-5.2l4.4.2 2 4 2.4-3.8 4.4.2-2-4 2.4-3.7-4.4-.2-2.2-4-2.4 3.8-4.4-.2 2 4zM342 182l4.2 1 1.2 4.3 3.2-3.2 4.2 1-1.2-4.2 3.2-3.2-4.4-1.1-1.2-4.3-3.2 3.2-4.2-1 1.2 4.3zm18 3.7l4 2 .2 4.4 3.8-2.4 4 2-.2-4.5 3.6-2.4-4-2-.2-4.5-3.8 2.5-4-2 .4 4.4z"
      />
      <g fill="#fff" strokeWidth={0.7}>
        <path d="M365.4 270.4l5 7.2 4.6-6.8-3.2-5.8zm-31.8 21l.4 7.2s2 0 3.8-.6c1.6-.6 3-1.8 3-1.8l-.2-3.8zm-26.8 0l-.4 7s-1.8 0-3.6-.4c-1.6-.4-3-1.4-3-1.4l-2-4.8zm-32.2-21l-5.2 7.2-5.6-9.2 4.2-4.4z" />
        <path d="M299.6 305.8c0 6.8 41.2 6.8 41.2 0v-9.6c0 5-41.2 4-41.2 0z" />
        <path d="M262.8 283.6c3.6 18.4 36.8 18.8 36.8 18.8v-6.2c-.8-2.4.6-3.2 6-4 2.2-.2 1.2-3.4 1.2-3.4s-14.4 2.6-24.6-1.4c-13.8-5.6-15.8-16.4-15.8-16.4s-1 8.4-3.6 12.6zm114.6 0c-3.4 18.4-36.6 18.8-36.6 18.8v-6.2c.6-2.4-.8-3.2-6.2-4-2.2-.2-1-3.4-1-3.4s14.4 2.6 24.6-1.4c13.6-5.6 15.2-16.4 15.2-16.4s1.4 8.4 4 12.6z" />
        <path d="M265.4 276.6c-9.2-5-2-10.2-1.2-25 1.4 9 11.6 12.8 10.4 18.6-4.2.2-6.2-6.2-8.2.8l-1 5.6zm109.4 0c9.2-5.2 1.6-10.2.8-25-1.4 9-11.4 12.8-10.2 18.6 4 .2 6-6.2 8 .8l1.4 5.4z" />
      </g>
      <path
        d="M271 283.4l1 .8-2.2 2.4c-1 1-1.1 1.6-.5 2.2.7.7 1.3.4 2-.4l2.5-2.6.8.8-2.4 2.8c-1.3 1.5-2.5 1.2-3.6.2-.8-.8-1.4-2 0-3.5l2.4-2.7zm4 3.4l1 .6-.2 4.8 2.2-3.4 1 .6-3.2 5.2-1.2-.6.2-4.8-2.2 3.4-1-.6zm1.8 8.4l2.8-5.6 1 .6-2.6 5.4zm4.4-4.8l-2.2 5.8 2.2.8c2 .7 3-.2 3.6-1.9.7-1.8.4-3-1.6-3.9l-2-.8zm.8 1.4c2 .7 2.2 1.5 1.6 3-.6 1.3-1 1.8-3 .8l1.4-3.8zm5.8.8l-3.6 5.4 1.4.4.8-1.4 2.4.6.2 1.4 1.4.2-1.4-6.4-1.2-.2zm.4 1.4l.4 2.4-1.6-.2 1.2-2.2zm3-.9l-.2 6.2h2.3c2.2.1 2.8-1 2.9-3 0-1.8-.7-3-2.9-3l-2.1-.2zm1.2 1c2.2.1 2.5.8 2.5 2.3-.1 1.5-.4 2.1-2.6 1.8v-4zm19.8 7.7v6.4h1.4v-2.4s1.2 0 2.2-.2c.7-.2 1.3-.7 1.3-2 0-1.2-.7-1.8-1.9-1.8h-3zm1.4 1h1.4c1.1 0 1 1.8 0 1.8h-1.4v-1.8zm5.8-1l-2.6 6.4h1.4l.6-1.6h2.6l.6 1.6h1.4l-2.6-6.4h-1.4zm.6 1.4l1 2.4h-1.8l.8-2.4zm3.4 3.8l3.4-4.2h-3v-1h4.8v1L325 307h3.6v1.2h-5.2zm20.2-12.4l1.2-.2.6 3.6c.2 1.3-.4 2.1-1.3 2.5-1 .4-2.4 0-2.5-1.7l1-.2c.2 1 .6 1.1 1 1 .5-.2.7-.8.6-1.4zm2-.4l1.1-.2.6 3c.2 1.3.6 1.8 1.5 1.7 1-.2 1.1-.8.9-2l-.7-3.1 1.2-.2.8 3.3c.4 2-.6 2.7-2 3-1.1.2-2.4 0-2.8-2zm6.2 2.8l1-.4c.5.9 1.2.8 1.8.6.8-.4 1-1.1.5-1.4-.6-.3-2 .2-2.7 0-.9-.4-1.3-1-1.2-1.7 0-1 .8-1.4 1.7-1.7 1-.3 2-.2 2.7 1l-1.2.4c-.4-.7-1-.6-1.4-.4-.4.2-1 .5-.6 1 .2.5 1.7.2 2.5.2s1.4.6 1.5 1.3c.2 1.1-.2 1.7-1.5 2.2-1.5.6-2.9 0-3.1-1.1zm5.4-5l-1.6.8-.4-1 4.4-1.8.4.8-1.6.8 1.8 4.4-1 .6zm2.6-2.2l1-.6 2.8 5.2-1 .6zm6.8.4l1.2-.4a2.4 2.4 0 0 1-2.4 3.3c-3 0-3.4-3.4-2.9-4.5.8-1.9 3-1.8 4-.8l-1 .8c-.6-.8-2-.3-2 .4a2.7 2.7 0 0 0 1.4 3c1 .4 2.4-.8 1.7-1.8zm-.6-4.2l1-.8 3.6 4.8-1 .8zm3.8-3l-1 .8 2.2 6 1-1-.6-1.2 1.8-1.6 1.2.6 1-.8-5.6-2.8zm.4 1.4l2 1-1.2 1.2-.8-2.2z"
        stroke="none"
      />
    </g>
  </svg>
	),
	GR: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h120v90H0z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="scale(5.33)"
    >
      <path fill="#0d5eaf" d="M0 0h135v10H0z" />
      <path fill="#fff" d="M0 10h135v10H0z" />
      <path fill="#0d5eaf" d="M0 20h135v10H0z" />
      <path fill="#fff" d="M0 30h135v10H0z" />
      <path fill="#0d5eaf" d="M0 40h135v10H0z" />
      <path fill="#fff" d="M0 50h135v10H0z" />
      <path fill="#0d5eaf" d="M0 60h135v10H0z" />
      <path fill="#fff" d="M0 70h135v10H0z" />
      <path fill="#0d5eaf" d="M0 80h135v10H0zM0 0h50v50H0z" />
      <g fill="#fff">
        <path d="M20 0h10v50H20z" />
        <path d="M0 20h50v10H0z" />
      </g>
    </g>
  </svg>
	),
	GT: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <radialGradient id="prefix__a">
        <stop offset={0.2} stopColor="#f9f0aa" />
        <stop offset={1} stopColor="#b07e09" />
      </radialGradient>
      <radialGradient
        id="prefix__d"
        cx={447.4}
        cy={308.3}
        r={16.5}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <radialGradient
        id="prefix__e"
        cx={451.6}
        cy={313}
        r={10.9}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <radialGradient
        id="prefix__f"
        cx={454.1}
        cy={308.6}
        r={9.8}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <radialGradient
        id="prefix__g"
        cx={458.4}
        cy={307.1}
        r={17.4}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <radialGradient
        id="prefix__j"
        cx={446}
        cy={252.4}
        r={13}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <radialGradient
        id="prefix__m"
        cx={477.9}
        cy={215.3}
        r={0.3}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.3} stopColor="#a50a0a" />
        <stop offset={1} stopColor="#4c0505" />
      </radialGradient>
      <radialGradient
        id="prefix__n"
        cx={489.1}
        cy={210.3}
        r={0.3}
        fx={489.1}
        fy={210.3}
        gradientTransform="scale(.97707 1.02346)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="prefix__h"
        x1={473.9}
        x2={472.4}
        y1={259.2}
        y2={232}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.2} stopColor="#b07e09" stopOpacity={0} />
        <stop offset={1} stopColor="#b07e09" />
      </linearGradient>
      <linearGradient
        id="prefix__i"
        x1={483.1}
        x2={485.5}
        y1={296.7}
        y2={326.6}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.2} stopColor="#b07e09" stopOpacity={0} />
        <stop offset={1} stopColor="#b07e09" />
      </linearGradient>
      <linearGradient
        id="prefix__k"
        x1={451.5}
        x2={455.4}
        y1={249.5}
        y2={240.6}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.2} stopColor="#f9f0aa" />
        <stop offset={1} stopColor="#b07e09" />
      </linearGradient>
      <linearGradient
        id="prefix__l"
        x1={473.3}
        x2={475.9}
        y1={237.3}
        y2={270.4}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.2} stopColor="#f9f0aa" />
        <stop offset={1} stopColor="#b07e09" />
      </linearGradient>
    </defs>
    <path fill="#4997d0" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M213.3 0h213.4v480H213.3z" />
    <g transform="translate(0 40) scale(.66667)">
      <g stroke="#24420e">
        <path
          fill="none"
          strokeWidth={0.4}
          d="M452.1 377.5c2.7-.4 4.2-1.2 6-1.8m2.3-4a13 13 0 0 1 3 4.6m-8.1-5.1a15.4 15.4 0 0 1 3 4.2m-49.5-136.6c-1 1.6-3.1 2.7-4.8 3.4m-.3-.2c0-1.4-.3-3 0-4.4m-2 5l.7 2m2 1l-2 .3m-4-.9c0 2.6.4 5.6.6 7.9m-1.8-1a6 6 0 0 0 1.6 1.9m-4.6 6.4c.5 1 1 2.2 1.3 4m3.7-4.6l-2 1.5m1.7 4.4c-1 .9-2.2 1.5-3.5 2.1m-3.8 40.4a16 16 0 0 0 4 4.7m.6 1.7a8 8 0 0 1-3-1m4.4 8.5l1.7 1m-.4 3.4c1.2.8 2.5 2.3 3.7 3.9m-1.4 2.8c1.4.3 2.5.7 3.2 1m-1 2.5h2m1.3-5.3l-.5 4.2m1 1.6l.4-1.6m4.7 6l-.1 3.2m39.2 28l-1.2 1.5m-2.4-4l-.7-1.7"
        />
        <g strokeWidth={0.2}>
          <path
            fill="#406325"
            d="M486.1 385c-.8-1.3-2-2.1-3.3-2.7-7.7-4-15.4-5.9-24-7.3-2.1-.3-4.1-2.2-6.2-3.2-5-2.3-10.5-3.2-15.3-5.7a7.8 7.8 0 0 1-2-1.5c-2-2.2-5.5-2.9-7.6-5-8.4-7.8-17.2-15-21.8-25.5-5.6-12.7-12.5-25.8-11.6-40.3.6-9-.7-18.3 1.5-27 3.4-12.9 7.6-25.6 15.4-36.3l-1.3.8a103.6 103.6 0 0 0-15.4 36.3c-2.3 8.7-1 18-1.5 27-1 14.5 6 27.6 11.5 40.3 4.6 10.4 13.5 17.7 21.8 25.6 2.2 2 5.6 2.7 7.6 5a10 10 0 0 0 2 1.5c4.9 2.4 10.4 3.3 15.4 5.7 2 1 4 2.8 6 3.1a76.4 76.4 0 0 1 24.2 7.3 8 8 0 0 1 3.3 2.6l1.3-.8"
          />
          <g fill="#67923d">
            <path d="M406.3 331.6a46.9 46.9 0 0 1-.2-23.5c6.7 13 4.5 23.7.2 23.5zm45.9 45.4c-7.1.4-20.6 9.3-21.9 11.4 15.1.1 24-7.3 21.9-11.4zm7.5-4.3a60 60 0 0 1-14-26.5c15 10.8 18.9 24.3 14 26.5z" />
            <path d="M454.6 372.8a55.1 55.1 0 0 1-16-22.8c15.3 8.2 20.3 20.2 16 22.8zM439 366c1-7.8-5.6-24.2-7.5-26-3 16.5 3 27.6 7.6 26zm-27.3-24.3a42 42 0 0 1 .5-21c5.5 11.7 3.3 21.2-.5 21zM398 265a51 51 0 0 1 21-16c-6.7 14.6-18 19.9-21 16z" />
            <path d="M398.7 259.3a51.7 51.7 0 0 1 17.4-20c-3.7 15.7-13.7 23.2-17.4 20zm27.9 99.2c-5-6.2-8-23.9-7.3-26.4 11.2 12.5 12 25.2 7.2 26.4zM397.9 322c-7 1.1-21.4-4.6-23-6.3 14.6-3.2 24.4 2 23 6.3zm-2.2-9.7c.8-5.5 8.6-15.8 10.3-16.6-1 12-7.4 18.6-10.3 16.6zM447 371a57.1 57.1 0 0 0-26.1 13.6c18 .1 28.7-8.7 26.1-13.6z" />
          </g>
          <g fill="#406325">
            <path d="M406.4 331.5c4.2.2 6.4-10.4-.3-23.4a79 79 0 0 1 .3 23.4zm11.2 20a48.8 48.8 0 0 0-21.7-11.2c8.9 12.1 19.9 15.1 21.7 11.2zm-24.4-53a57 57 0 0 0-14.8-24c1.5 17.2 10.6 26.7 14.8 24zm8.4 34.3c-5-3.7-19-5.4-21-4.7 10.2 8.2 20.2 8.4 21 4.7zm-9.4-24.9a42 42 0 0 0-16.9-13.7c5.5 12.4 14.6 17 16.9 13.7zm2.7-47.5c1-7.6-5.5-23.4-7.3-25.2-2.9 16 2.9 26.7 7.3 25.2zm4.5-15a48 48 0 0 0-.5-24.3c-6.4 13.5-3.8 24.6.5 24.4z" />
            <path d="M404.4 237.8a40.2 40.2 0 0 0 3.5-19.4c-7.2 9.7-7 18.9-3.5 19.4zm6-6.1a38.9 38.9 0 0 0 9-17.4c-9.7 7-12.2 15.8-9 17.4zm-16 43.2c0 .9-1-8.2-10.1-18.3.4 14.8 6.2 20.4 10 18.3zm32.5 85.8a53.1 53.1 0 0 0-25.8-6c12.6 10.4 24.9 10.6 25.8 6zm12 5.2c-4.5 1.6-10.4-9.4-7.5-25.9a99 99 0 0 0 7.5 26zm13.4 11.2c2 4-6.8 11.4-21.8 11.3 12-5 21.2-9.9 21.7-11.3zm7.3-4.5c5-2.3 1.1-15.5-14-26.4 8.6 13.2 14.5 24.6 14 26.4z" />
            <path d="M454.6 372.7c4.2-2.7-.7-14.5-16-22.7 9.5 11.2 16.2 21 16 22.7zm-42.8-31c3.7.2 6-9.3.5-21 .7 11 .4 20-.5 21zM398 264.9c3 4 14-1.3 20.9-15.9a90.6 90.6 0 0 1-20.9 16z" />
            <path d="M398.9 259.3c3.6 3.2 13.5-4.3 17.2-20-8 11.3-15.6 19.8-17.2 20zm27.7 99.1c4.7-1.1 4-13.8-7.3-26.3 5 13.5 8 24.8 7.3 26.3zM397.7 322c1.4-4.3-8.3-9.4-22.8-6.3 12.3 2.2 22 5 22.8 6.3zm-2-9.7c3 2 9.3-4.6 10.4-16.6a68.8 68.8 0 0 1-10.3 16.6zM447 371c2.6 5-8 13.7-26 13.5 14.2-5.8 25.3-11.7 26-13.5z" />
            <path d="M399.4 326.3a45.1 45.1 0 0 0-17-15.8c5 13.6 14.2 19.1 17 15.8z" />
          </g>
          <g fill="#67923d">
            <path d="M392.4 274c4-4.7 17.5-9.2 19.6-9-8 10.5-18 12.6-19.6 9zm25 77.5c-1.7 4-12.6 1-21.6-11.1a84.8 84.8 0 0 0 21.7 11.1zm-24.3-53c-4.2 2.7-13.1-6.8-14.7-24 6.6 13.3 13 23.5 14.7 24zm8.4 34.3c-.7 3.7-10.7 3.6-20.8-4.7a74.6 74.6 0 0 0 20.8 4.7zm-9.4-25c-2.4 3.3-11.3-1.2-16.8-13.6 8.2 8 15.5 13.7 16.8 13.6zm2.7-47.5c-4.4 1.6-10.1-9-7.3-25 2.7 13.5 6 24.2 7.3 25zm4.5-14.9c-4.3.3-6.9-10.8-.5-24.3-.8 12.8-.5 23.2.5 24.3zm5-7.6c-3.4-.6-3.7-9.7 3.6-19.4a66.2 66.2 0 0 0-3.6 19.4zm6-6.1c-3.1-1.7-.7-10.4 9-17.4a66.2 66.2 0 0 0-9 17.4z" />
            <path d="M394.3 274.9c-3.9 2.1-9.6-3.5-10-18.3 5 11.7 8.6 17.8 10 18.3zm32.5 85.8c-.9 4.6-13.1 4.4-25.7-5.9 13.2 4.3 24.3 6.7 25.7 5.9zm-8.2-9.5A41 41 0 0 1 412 332c9 8.7 10.2 18.1 6.8 19.2zm-16.8-25a44.3 44.3 0 0 1-3-23c8.3 11.9 7.3 22.7 3 23zm-2.7.1c-2.7 3.3-11.9-2.1-16.8-15.8a77.8 77.8 0 0 0 16.8 15.8z" />
          </g>
          <g fill="#406325">
            <path d="M392.4 274c1.6 3.6 11.4 1.5 19.5-8.9-12 6.8-16.7 9.8-19.5 8.9zm9.3 52c4.3-.3 5.3-11-3-22.8a72.8 72.8 0 0 1 3 22.9zm17 25.2c3.4-1 2.2-10.5-6.7-19.2 4.4 9.7 7.2 18 6.7 19.2z" />
            <path d="M394.2 291.8a41 41 0 0 0-4.3-25.6c-4.7 15.4-.2 26.6 4.3 25.6z" />
          </g>
          <path
            fill="#67923d"
            d="M394 293.8c-6 1.3-8.7-12-4.1-27.1 1 13.5 2.8 26.1 4 27z"
          />
          <path
            fill="#67923d"
            d="M392.7 293.7a53 53 0 0 1 9-24.7c2 15.8-4.5 26.3-9 24.7z"
          />
          <path
            fill="#406325"
            d="M392.8 293.6c4.4 1.6 10.9-8.8 8.9-24.6-3.5 13.3-7.5 23.8-8.9 24.6z"
          />
          <path
            fill="#67923d"
            d="M394.1 303.3a50 50 0 0 1 10.6-23.7c.8 16.2-6.3 25.9-10.6 23.7z"
          />
          <path
            fill="#406325"
            d="M394.2 303.4c4.2 2.2 11.3-7.3 10.5-23.5-4.4 12.8-9 22.9-10.5 23.5z"
          />
        </g>
        <g fill="#ba1f3e" stroke="#511124" strokeWidth={0.2}>
          <circle cx={396.8} cy={251.3} r={1.1} />
          <circle cx={405.2} cy={245.1} r={1.1} />
          <circle cx={401.6} cy={241.7} r={1.1} />
          <circle cx={392.5} cy={313.1} r={1.3} />
          <circle cx={395} cy={297.1} r={1.3} />
          <circle cx={408.2} cy={334.5} r={1.3} />
          <circle cx={402.4} cy={336.4} r={1.3} />
          <circle cx={446.7} cy={367.6} r={1.3} />
          <circle cx={449.6} cy={374.7} r={1.3} />
        </g>
      </g>
      <g stroke="#24420e">
        <path
          fill="none"
          strokeWidth={0.4}
          d="M561.1 259c.7.6 1.2.8 2.3 1.9m-6.6-19c0-1.3-.6-3.6-.9-5m3.5 3c0 2-.3 3.8-1.1 5.5m-4.2-.5c1.8 1.6 3.5 3 5.3 3.9m3.8 1.2c.1 2-.1 4-.7 6m.4 1.5l1.3-2.3m-1.9 12.2c1.4.3 2.8 2 3.5 3.5m.5-1.3l1.6-2.2m1.7 30.8a23.9 23.9 0 0 1-2.4 3.4m-4 0c.8 1.4 1.6 3 2.6 4m2.5 5.9a13.2 13.2 0 0 1-4.5 4m.2 4.5c-1.1.8-2.5 3-3.7 4.7m8.4-20.2l-2.1.9m-1.4-7.5l1.3 1.1m-9.3 37.4H555m-2-1.8l.7 1.6m-7.8 5.1c-.2 1.9 0 3.7.2 5.6m4.3-9l1 2.2m3.9-.2l-2.5.5m-30.9 25.2l-1 1.8m12-4c-1.5.2-2.8 0-4.1-.2m-5.5 6a27.3 27.3 0 0 0-3-1m-14.6 2.7c-1 .7-2 2.4-3.1 4m-.6-4.5c-2.4 1.3-3.1 3.7-4.4 5.8m2.8 2.9a52.4 52.4 0 0 1-5.3-2m16.7-.8c-2.3-1.2-4.7-1-7.1-1.4m10.8-.4c-3.7-.7-7-.6-10.3-.1m7.8-2.6l-1.4-.6m-5.6 5.5l-2.3-1.3m58-49.2c-1.3.8-2.6 2.3-3.8 3.9m1.8-79.6l-2.1-.8"
        />
        <g strokeWidth={0.2}>
          <path
            fill="#406325"
            d="M474.4 384.9a8 8 0 0 1 3.3-2.7c7.7-4 15.4-5.8 24-7.2 2.1-.4 4.1-2.3 6.2-3.2 5-2.4 10.5-3.3 15.3-5.7a7.8 7.8 0 0 0 2-1.6c2-2.2 5.5-2.9 7.6-5 8.4-7.8 17.2-15 21.8-25.5 5.6-12.7 12.5-25.8 11.6-40.2-.6-9.2.7-18.4-1.5-27a104.8 104.8 0 0 0-15.4-36.4l1.3.8a103.8 103.8 0 0 1 15.4 36.3c2.3 8.7 1 18 1.5 27.1 1 14.4-6 27.5-11.5 40.3-4.6 10.4-13.5 17.6-21.8 25.5-2.2 2-5.6 2.7-7.6 5a10 10 0 0 1-2 1.5c-4.9 2.5-10.4 3.4-15.4 5.7-2 1-4 2.8-6 3.2A76.4 76.4 0 0 0 479 383a8 8 0 0 0-3.3 2.7l-1.3-.9"
          />
          <g fill="#406325">
            <path d="M553.6 334.6c2.8-7.4 0-24.8-1.4-27-6.7 15.4-3.4 27.6 1.4 27z" />
            <path d="M546.5 341.6c2.3-5.6.6-19.3-.4-21-5.6 11.7-3.3 21.3.4 21zm16.8-74.1a47 47 0 0 0-19.2-14.6c6.2 13.3 16.5 18.2 19.2 14.6z" />
            <path d="M561.8 259.5a43.3 43.3 0 0 0-14.5-16.7c3 13 11.4 19.3 14.5 16.7zm4.7 15c-3.5-4.1-15.2-8-17-7.8 7 9 15.6 10.9 17 7.7zm-2.8 46.3a40 40 0 0 0 20.3-5.7c-12.9-2.8-21.5 1.9-20.3 5.7zm-.1-5.7c0-5.6-6.4-16.8-8-18-.6 12 4.8 19.5 8 18z" />
            <path d="M564 301.4a50 50 0 0 0-10.6-23.6c-.8 16.2 6.3 25.8 10.6 23.6zm-53 75.3a47.7 47.7 0 0 0 22.2 11c-8.8-12.3-20.1-15.1-22.1-11z" />
          </g>
          <g fill="#67923d">
            <path d="M553.6 334.4c-4.9.6-8.1-11.4-1.4-26.8-.5 14.2.2 25.7 1.4 26.8zm-53.4 43.7a48 48 0 0 1 21.8 11.4c-15 .1-24-7.3-21.8-11.4zm0-8c2-8 15-21.2 17.5-22.1-3.6 17.1-13.7 25.5-17.5 22.2zm21.3-4.2c-1-7.8 5.6-24.2 7.5-26 3 16.5-3 27.6-7.5 26zm21.4-14.5a48.8 48.8 0 0 1 21.7-11.2c-8.9 12.1-19.9 15.1-21.7 11.2zm25.8-53.3c1-6.3 9.7-17.9 11.6-18.9-1.2 13.6-8.3 21-11.6 19z" />
            <path d="M557 336.2a50.4 50.4 0 0 1 24.4-5.5c-11.8 9.7-23.5 9.8-24.4 5.5zm10.3-24.5a44 44 0 0 1 17.7-14.4c-5.8 13-15.3 17.8-17.7 14.4zm-1.5-45.6c0-7.6 8-22.7 10-24.2 1.1 16.1-5.7 26.2-10 24.2zm-7-26a40.6 40.6 0 0 1 0-20c5.5 11 3.7 20.2 0 20zm-4.1-2.1a49.8 49.8 0 0 1-10.5-22.1c11.8 9.3 14.4 20.4 10.4 22.1z" />
            <path d="M566.3 272.5c-.3.9 3-7.7 14.2-15.3-4 14.3-11 18.3-14.2 15.3zm-34.1 90c7-5.2 26.5-7.7 29.2-6.8-14.2 11.8-28.2 12-29.2 6.7zm14.3-20.9c-3.7.2-6-9.3-.5-21-.7 11-.4 20 .5 21zm16.9-74c-2.7 3.5-13-1.3-19.2-14.7a78.8 78.8 0 0 0 19.2 14.6zm-1.7-8.1c-3.1 2.6-11.3-3.6-14.4-16.7 6.7 9.4 13 16.5 14.4 16.7zm4.8 15c-1.4 3.2-9.9 1.3-16.9-7.7 10.4 5.9 14.5 8.5 17 7.7zm-2.6 46.2c-1.3-3.7 7.3-8.3 20.2-5.5a69 69 0 0 0-20.2 5.5zm-.4-5.6c-3.2 1.5-8.5-5.9-8-17.9a68.5 68.5 0 0 0 8 18z" />
            <path d="M563.9 301.6c-4.2 2.2-11.3-7.4-10.5-23.5 4.4 12.8 9 22.9 10.5 23.5zm-52.7 75c2-4 13.1-1.3 22 11a80.3 80.3 0 0 0-22-11z" />
          </g>
          <g fill="#406325">
            <path d="M521.5 365.8c4.6 1.6 10.5-9.4 7.6-25.9-2.8 14-6.2 25.1-7.6 26z" />
            <path d="M531.8 360.6a55 55 0 0 0 4.6-27c-10 13.6-9.4 26.3-4.6 27zM500.1 378c-2 4.1 6.7 11.5 21.8 11.3a80.2 80.2 0 0 1-21.8-11.3zm.2-8c3.8 3.3 13.8-5 17.4-22.1-8.1 12.4-15.7 21.8-17.4 22zm42.7-18.7c1.8 4 12.7 1 21.7-11.1a84.5 84.5 0 0 1-21.7 11.1zm25.8-53.3c3.3 2.1 10.3-5.3 11.5-18.8a74.6 74.6 0 0 1-11.5 18.8zM557 336.2c.9 4.4 12.4 4.2 24.3-5.5-12.5 4-23 6.2-24.3 5.5zm10.3-24.6c2.5 3.4 11.9-1.4 17.7-14.4a75.1 75.1 0 0 1-17.7 14.4zM566 266c4.3 2 11-8 10-24-4.2 13-8.5 23.3-10 24zm-7-25.9c3.6.1 5.5-9 0-20 .9 10.5.8 19.1 0 20zm-4.2-2.2c4-1.7 1.4-12.7-10.4-22a81.8 81.8 0 0 1 10.4 22zm11.6 34.7c3.2 3 10.2-1 14.2-15.4-7.8 10.1-12.7 15.2-14.2 15.4zm-34 89.9c1 5.2 14.9 5 29-6.7-14.9 4.8-27.4 7.6-29 6.7z" />
            <path d="M539.1 354.8a41 41 0 0 0 3.6-20.1c-7.5 10-7.2 19.5-3.6 20zm19.6-28.7a44.3 44.3 0 0 0 3-23c-8.3 11.9-7.3 22.7-3 23z" />
          </g>
          <path
            fill="#67923d"
            d="M531.8 360.5c-4.8-.6-5.3-13.3 4.5-26.8-3.6 13.8-5.4 25.4-4.5 26.8zm35.2-68.3c-1-7.7 4-20.1 6.6-22.5 2.5 14.4-2.7 24-6.7 22.5zm-28 62.5c-3.6-.5-3.9-10 3.5-20a67.5 67.5 0 0 0-3.5 20zm23.4-104.2c-2.2-6 0-20 1.2-21.8 5.3 12.2 2.6 22.1-1.2 21.8zm-58.1 120.1c2.5-8 16.2-21 18.8-21.9-4.3 17.4-15 25.5-18.8 22zm54.5-41.6a45.1 45.1 0 0 1 17-15.8c-5 13.6-14.3 19.1-17 15.8zm-.1-3c-4.3-.4-5.3-11 3-22.9a72.8 72.8 0 0 0-3 22.9z"
          />
          <path
            fill="#406325"
            d="M567 294c5.2 1.9 9-9.8 6.6-23.9a98.2 98.2 0 0 1-6.6 24z"
          />
          <path
            fill="#406325"
            d="M567.8 293.6c.5-7.5-7-23-9-24.7-2 15.8 4.5 26.3 9 24.7zm-5.2-43.2c3.8.4 6.4-9.4 1.1-21.7a73 73 0 0 1-1.2 21.7zm-58.1 120.1c3.8 3.6 14.4-4.4 18.7-21.8-8.8 12.3-17 21.6-18.7 21.8zm54.6-41.5c2.8 3.3 12-2.1 17-15.8a77.8 77.8 0 0 1-17 15.8z"
          />
          <path
            fill="#67923d"
            d="M567.7 293.5c-4.5 1.7-10.9-8.7-8.9-24.5 3.5 13.2 7.5 23.7 8.9 24.5z"
          />
        </g>
        <g fill="#ba1f3e" stroke="#511124" strokeWidth={0.2}>
          <circle cx={564.6} cy={254.9} r={1.1} />
          <circle cx={568.4} cy={266.8} r={1.1} />
          <circle cx={569.8} cy={304.3} r={1.3} />
          <circle cx={564.6} cy={297.3} r={1.3} />
          <circle cx={549.9} cy={337.2} r={1.3} />
          <circle cx={556.2} cy={339.9} r={1.3} />
          <circle cx={513.8} cy={372.3} r={1.3} />
          <circle cx={506.8} cy={377.3} r={1.3} />
          <circle cx={557} cy={249.3} r={1.1} />
        </g>
      </g>
      <g id="prefix__b" fill="#8c959d" stroke="#485654" strokeWidth={0.1}>
        <path d="M434.3 336.3c-.2 1 .8 2.3 2 2 .5 0 .7-.5.2-.5-.4.1-.9 0-1.2-.3a1.7 1.7 0 0 1-.4-2l-.6.8z" />
        <path
          stroke="none"
          d="M437.2 338.3c-1 1.2-2.5 1.7-3.4.9-.6-.6-.8-1.2-.5-2l-1 1.3a4.4 4.4 0 0 0 1.6 1.8c1.2.5 3-.3 4-1.6.8-1 1.6-2.4 1-3.6a4 4 0 0 0-2-1.7l-1 1c.5-.2 1.2 0 1.7.4 1.3 1 .5 2.5-.4 3.5z"
        />
        <path
          fill="#485654"
          stroke="none"
          d="M437.2 338.3a4 4 0 0 1-1.1 1c-.5.2-1 .4-1.5.3a1.5 1.5 0 0 1-.7-.3 2.4 2.4 0 0 1-.5-.6 1.6 1.6 0 0 1-.3-.7c0-.3 0-.5.2-.8l.1.1-1.1 1.2c.3.4.6.9 1 1.2l.7.5a2 2 0 0 0 .8.1 3 3 0 0 0 1.6-.5 5.1 5.1 0 0 0 1.3-1l1-1.4c.2-.5.3-1 .3-1.6a1.8 1.8 0 0 0-.2-.8 3 3 0 0 0-.5-.6 4.2 4.2 0 0 0-1.4-1h.1l-1 1.1h-.1c.2-.2.5-.2.8-.2a2 2 0 0 1 1.6 1.4c.1.5 0 1-.2 1.4a5.1 5.1 0 0 1-.9 1.2zm0 0c.4-.3.6-.7.8-1.2.2-.4.3-1 .2-1.4a2 2 0 0 0-.9-1c-.4-.3-1-.4-1.3-.2h-.1l1-1.2a4.2 4.2 0 0 1 2 1.6c.2.3.3.6.3 1 0 .5-.1 1-.4 1.6a6.4 6.4 0 0 1-1 1.4c-.3.5-.8.8-1.3 1.1-.5.3-1 .5-1.7.5a2.2 2.2 0 0 1-.8-.1 2.7 2.7 0 0 1-.8-.5 5 5 0 0 1-1-1.4l1-1.3h.2l-.1.8c0 .2 0 .5.2.7l.5.5.6.3c.5.1 1 0 1.5-.3a4 4 0 0 0 1.1-.9z"
        />
        <path
          fill="#6c301e"
          stroke="#351710"
          strokeLinejoin="round"
          strokeWidth={0.2}
          d="M515.2 249.3l-40.1 39.5L434 328l-4.6 5.4c-2 2.3-4.4 5.3-7.2 8-.4.6-1.1.4-1.7.8a23.4 23.4 0 0 0-5 4.3L403.2 360c-.7.9-1 1.4-.4 2l6.6 8.8c1.2 1.2 2.6 1.8 3.2.8 3.1-5.5 11-13.8 14-20.3 1.7-4 3.9-11.1 5.5-12.8 2-2.2 7.1-7.8 11.8-12.7l1-1 .9-1c23.5-24 50.7-53.1 70.5-73.6l-1-1z"
        />
        <path d="M431.9 328.1c-1.2 0-2-.7-2.9-1.4 1.2.4 2.4.8 3.5.4l-.6 1z" />
        <path
          fill="#b2b6ba"
          strokeWidth={0.2}
          d="M557 220.1l-31.8 26.2c-.3.4-.6.3-.9 0l-2.9-2.4v-.6l1.4-1.4c.2-.2 0-.3-.1-.6l-.6-.6c-.3-.1-.5 0-.7.2l-1.4 1.5c-.7 0-1.3.6-1.4 1.4-19.2 18.7-35.8 35.4-54.9 53.8l-22.6 21.6c-.8 1-4.3 2.9-6.6 4.4a5.6 5.6 0 0 0-1.8 1.5l-1.8 5.5-2.5 4.2c2.3 2.4 2.2 2.2 3.8 3.7l11.2-11.9.8-1a13.2 13.2 0 0 0-1.4-1.6 34.1 34.1 0 0 0-1.2-1l-.6-.6c-.2-.2.2-.5.4-.7 26.5-25.5 55-53.7 78.3-76.6a1.4 1.4 0 0 0 1 0l2.8 3.2c.6.6 1.2.6 1.7.4l31.9-28.6z"
        />
        <path
          fill="#485654"
          stroke="none"
          d="M431 330.4h.5a1.5 1.5 0 0 0 .6-.1 124.9 124.9 0 0 1 1.5-4.8 1.5 1.5 0 0 0-.7-.4c.3 0 .5.2.7.4l-.7 2.4-.7 2.4a1.4 1.4 0 0 1-.6.2 2.9 2.9 0 0 1-.7-.1z"
        />
        <circle cx={438.2} cy={328.1} r={0.6} fill="none" strokeWidth={0.2} />
        <circle cx={434.4} cy={331.9} r={0.6} fill="none" strokeWidth={0.2} />
        <path
          fill="#485654"
          stroke="none"
          d="M441 322.4l-1-.8a11.6 11.6 0 0 1-.8-.8 11.4 11.4 0 0 1 1.8 1.6z"
        />
        <path d="M502.2 259l3.5 3.5.6-.6-3.5-3.4-.6.6z" />
      </g>
      <use
        width="100%"
        height="100%"
        transform="rotate(-177.2 487 -.2)"
        xlinkHref="#prefix__b"
      />
      <g stroke="#24420e" strokeWidth={0.2}>
        <path
          fill="#67923d"
          d="M434 365.4a55.9 55.9 0 0 0-29.3.9c16.3 8 29.5 4.6 29.2-1zm89 3.3a55 55 0 0 1 29.2 1c-16.3 7.9-29.6 4.5-29.3-1z"
        />
        <path
          fill="#406325"
          d="M433.8 365.5c.3 5.5-12.8 8.9-29.1.9 15.3 1 27.8.4 29-1zm89.3 3.3c-.3 5.5 12.8 8.9 29 .9-15.2 1-27.7.4-29-1z"
        />
      </g>
      <g id="prefix__c">
        <path
          fill="#b2b6ba"
          stroke="#485654"
          strokeWidth={0.2}
          d="M508.5 360a237.5 237.5 0 0 0-76.1-68c3.6-.2 11.5 3.9 14.7 6 23.9 15.4 44.3 35.7 65.6 59.8a35.1 35.1 0 0 1-3.4 3l-.8-.8z"
        />
        <path
          fill="#8c959d"
          d="M510.6 359.8L509 361c-23-29.6-55.1-57.9-76.7-69.1 30.1 13.9 55.4 41.8 78 67.7h.2z"
        />
        <path
          fill="#485654"
          d="M510.6 359.8L509 361a302.3 302.3 0 0 0-16.9-19.7 336 336 0 0 0-18.3-18.3 284.2 284.2 0 0 0-19.8-16.8 195.9 195.9 0 0 0-10.6-7.6c-3.6-2.3-7.3-4.6-11.1-6.6v-.2a136 136 0 0 1 22.5 13.3 210.9 210.9 0 0 1 20 16.6 360 360 0 0 1 18.3 18.5c6 6.4 11.6 13 17.4 19.4zm0 0a899.3 899.3 0 0 0-17.5-19.4 360.2 360.2 0 0 0-18.3-18.5 212 212 0 0 0-20-16.6 134.7 134.7 0 0 0-22.4-13.2v-.2a200.9 200.9 0 0 1 21.7 14.3A285 285 0 0 1 474 323a336 336 0 0 1 18.3 18.3 302.3 302.3 0 0 1 16.8 19.8l1.5-1.4z"
        />
        <g fill="#fab81c" stroke="#6c301e" strokeWidth={0.1}>
          <path
            strokeWidth={0.2}
            d="M517.5 355a18.3 18.3 0 0 0-5.3 2.3c-.2 1.4-2 3-3.6 3.3l-.5-.8a.1.1 0 0 0-.2 0 7.2 7.2 0 0 0-.6.3c-.6 0-1.3.2-1.6 1-.4 1 .4 2.3 1.2 3.1 1 .7 1.4 1 2.4 1 1.1-.3 1.7-1.3 2-1.6 3.7 4.5 6.5 7 11.2 10.6 2.1 0 3.2-1.3 2.5-2.8-.2-.5-.8-.8-1.3-.6v-.5c2.4-2.2 3.5-5 .9-9.9-2.2-4-4.7-5.3-7-5.3zm6.3 4.6l1 2c1.5 3 .2 6.6-2.4 7.8h-.2c.4-.7-.8-2.2-1.4-1.7.3-.7-.7-2-1.5-1.7.4-.7-.5-1.9-1.4-1.5.4-.7-.3-1.8-1.3-1.6.3-.9-.4-1.8-1.3-1.6 0-.8-.2-1.2-.5-1.5 1-.8 2.3-2.1 3.4-2.7 2.7-1.2 4.4 1 5.5 2.5z"
          />
          <path d="M524.9 362.8c-.5-.3-.8-.8-.6-1.1.2-.4.7-.5 1.2-.2.5.2.8.7.6 1-.1.4-.7.5-1.2.3z" />
          <path d="M524.6 361.8c-.5-.3-.8-.8-.6-1.2.2-.3.7-.4 1.2-.1.5.2.8.7.6 1-.1.4-.7.5-1.2.3z" />
          <path d="M524 360.6c-.5-.2-.8-.7-.6-1 .2-.4.7-.5 1.2-.3.5.3.8.8.6 1.1-.1.4-.7.5-1.2.2z" />
          <path d="M523.2 359.6c-.5-.3-.8-.8-.6-1.1.2-.3.7-.4 1.2-.2.5.3.8.8.7 1.1-.2.3-.8.5-1.3.2z" />
          <path d="M522.2 358.6c-.6-.2-.8-.8-.6-1v-.2c.2.1.7.2.6-.1 0-.2-.1-.3 0-.2l.6.2c.5.3.8.8.6 1.1-.2.4-.7.5-1.2.2z" />
        </g>
        <path
          fill="#fab81c"
          d="M511.3 363.6c.6-1.8 2-3.4 3.5-3.8m-3.3 4c1.3.3 3.3-1.2 3.8-2.5m-2.6 4c1.6.4 3.3-1.2 4-2.4m-2.5 4c2 0 3.1-1.3 3.7-2.4m-2.2 4c1.6 0 3.2-1.4 3.6-2.5m-2.2 3.8a4 4 0 0 0 3.7-2m-2 3.4c1.6.1 3-.9 3.4-1.8m-1.6 3.3c1.6 0 2.7-1 3.1-2"
        />
        <path
          fill="#6c301e"
          d="M511.3 363.6a7.1 7.1 0 0 1 1.3-2.3l1-1 1.2-.5a4 4 0 0 0-1.2.6l-1 1a9.3 9.3 0 0 0-1.3 2.2zm.2.3c.4 0 .8 0 1.2-.2a4.9 4.9 0 0 0 1-.6l1-.8.6-1a2 2 0 0 1-.6 1 5 5 0 0 1-1 .9 4.6 4.6 0 0 1-1 .5 2.1 2.1 0 0 1-1.2.2zm1.2 1.4h1.2l1-.6a6.2 6.2 0 0 0 1.7-1.8 4.7 4.7 0 0 1-.7 1 5.2 5.2 0 0 1-.9.9 3.7 3.7 0 0 1-1 .5h-1.3zm1.5 1.6a4.2 4.2 0 0 0 1.1-.2 3.8 3.8 0 0 0 1-.5 4.7 4.7 0 0 0 1-.8l.6-1a4.5 4.5 0 0 1-1.5 1.9 3.4 3.4 0 0 1-2.2.6zm1.5 1.5a4.1 4.1 0 0 0 2.1-.8 5.1 5.1 0 0 0 1.5-1.6c-.1.3-.3.7-.6 1l-.8.7a4.2 4.2 0 0 1-1 .5c-.4.2-.8.2-1.2.2zm1.5 1.4a7 7 0 0 0 1-.2 4.6 4.6 0 0 0 1-.4 3.6 3.6 0 0 0 1.6-1.5l-.6 1c-.3.2-.6.5-1 .6a4.5 4.5 0 0 1-2 .5zm1.6 1.4h1a4 4 0 0 0 1-.5l.8-.5c.3-.3.5-.5.6-.8a2.5 2.5 0 0 1-.5.8 3.6 3.6 0 0 1-.9.6 3.7 3.7 0 0 1-2 .4zm1.8 1.5a4 4 0 0 0 1-.1 3.3 3.3 0 0 0 1.6-1 4 4 0 0 0 .5-.8 3 3 0 0 1-1.2 1.5 3 3 0 0 1-1 .3 3 3 0 0 1-1 0z"
        />
      </g>
      <use
        width="100%"
        height="100%"
        transform="rotate(-176.6 490 -.4)"
        xlinkHref="#prefix__c"
      />
      <g stroke="#24420e" strokeWidth={0.2}>
        <path
          fill="#406325"
          d="M409.2 240a52.4 52.4 0 0 0 19.5-17.9c-15.6 4.2-22.7 14.4-19.5 18zm145.8 4.7a50 50 0 0 0-15.6-19.9c2.8 15.2 12 22.8 15.6 20z"
        />
        <path
          fill="#67923d"
          d="M409.2 240c-3.3-3.5 3.8-13.6 19.4-17.8-11 8.4-19.2 16.2-19.4 17.8zm145.8 4.7c-3.7 3-12.7-4.6-15.5-19.7 7.2 11 14 19.5 15.5 19.7z"
        />
      </g>
      <g stroke="#999270" strokeWidth={0.2}>
        <path
          fill="url(#prefix__d)"
          d="M452.2 318.1s-6.2.7-7.9-7.8c-1.8-9.1 5.3-10 5.3-10s8.1-.9 13.2-1l2.2 18-12.8.8z"
        />
        <path
          fill="url(#prefix__e)"
          d="M453 315.4s-4 .7-4.8-5.6c-.6-4.5 2.2-5.1 2.2-5.1l9.2 1.6v8.2l-6.6.9z"
        />
        <path
          fill="url(#prefix__f)"
          d="M450.4 304.7s5.9-.4 9-.8l1.3 5.7-7.1.4s-.5-5.1-3.2-5.3z"
        />
        <path
          fill="url(#prefix__g)"
          d="M449.2 300.4s7.5-1.9 8.5 6.5c.2 2.1-1 7.1-4.7 8.5l13.9-1.5-1.3-15-4.6.4s-10 .3-11.8 1z"
        />
        <path
          fill="#f9f0aa"
          d="M452.2 318.1s51.9-3.5 57.2-3.3c15.8-8.6 0-42.5-13.3-61.5 1.5-4.3-29.9-13.9-44-13-1.9 0-3.6.2-5.2.3-7.7.8-7.8 10.7-4.7 17 3 6 30.3 55 11.2 60.3l-1.2.2z"
        />
        <path
          fill="url(#prefix__h)"
          d="M507.8 273.3a148.3 148.3 0 0 0-11.7-20c1.5-4.3-29.9-13.9-44-13-1.9 0-3.6.2-5.2.3-7.7.8-7.8 10.7-4.7 17 1 1.8 4.3 8 7.9 15.7"
        />
        <path
          fill="url(#prefix__i)"
          d="M455 285c5.6 14.6 8.7 30-1.6 32.8l-1.2.3s52-3.5 57.2-3.3c8.6-4.7 7.8-16.8 3.2-30"
        />
        <path
          fill="url(#prefix__j)"
          d="M447.4 243.5c-3.7 0-4.7 3.6-4.6 5.8.1 6 4.6 6.2 4.6 6.2l6-.3 2.8-12.2-8.8.5z"
        />
        <path
          fill="url(#prefix__k)"
          d="M447.4 243.5l8.8-.5 1 9.1-7.8.4s2.5-7.3-2-9z"
        />
        <path
          fill="url(#prefix__l)"
          d="M496.1 253.3c6.7-1 6.6-10 2-13.7-15.5-.5-35.9-.1-50.6 1 1.7 0 6.3.4 6.9 6.5a8.2 8.2 0 0 1-3 7c-2 1.4-4 1.4-4 1.4h3.6l3-.4c21-2.7 42-1.8 42-1.8h.1z"
        />
        <path
          fill="#b07e09"
          d="M458.5 267.4c-.2-.3-.3-.7-.8-.8-.2 0-.6 0-.5-.4h.8l1.6-.2c.4.1.3.6 0 .5-.5 0-.2.5-.1.8l1.3 3c.1.4.4.7.7.7l1.1-.1c.3-.2.2-.6.2-1-.1-.3.5-.2.5 0l.4 1.4c0 .2-.2.1-.4.1l-3 .2c-.3 0-.8.3-1 0 0-.4.6-.2.6-.5l-.3-1-1.1-2.7zm4.8-.3c-.1-.3-.3-.7-.7-.8-.2 0-.6 0-.6-.4h.7l1.7-.2c.3 0 .4.5 0 .4-.3 0-.3.4-.2.7l1.5 3.4c0 .2.2.5.5.6.3 0 .7 0 .7.3 0 .2-.4.1-.6.1a6.6 6.6 0 0 0-1.6.2c-.2 0-.5 0-.5-.3s.5 0 .6-.4c0-.3-.2-.6-.4-1l-1.1-2.6zm4.5.7c0 .2.4 0 .5 0 .3 0 .6-.1.6-.4a1.7 1.7 0 0 0-.7-1.2c-.3-.3-.8-.2-1.1-.2l.1.5.6 1.3zm.6 1.6c.2.3.3.7.6 1 .2.2.6.1.8 0 .3 0 .5-.3.4-.5-.1-.7-.5-1.3-1.2-1.5a2.4 2.4 0 0 0-1 0l.2.5.2.5zm-2-2.4c-.2-.3-.3-.7-.7-1-.2 0-.6.1-.7-.2 0-.3.6-.1.8-.2.9 0 1.7-.3 2.6 0 .7.2 1.4.8 1.5 1.6 0 .4-.3.7-.6.8l.5.1c.6.2 1.1.6 1.4 1.1.2.4.3 1 0 1.4-.4.4-1 .4-1.4.4-.8 0-1.5 0-2.3.2-.2 0-.4-.5 0-.5.3 0 .3-.4.2-.6l-1.3-3zm7.4-1.9c.3 0 .4.3.5.5l.3.9c-.3.2-.5-.2-.6-.4-.1-.2-.4-.5-.7-.4a8.3 8.3 0 0 0-1.2 0c-.2.2 0 .4.1.6l.6 1.3c.2 0 .6 0 .8-.2 0-.2-.3-.7.2-.6.3.2.2.6.4.9l.5 1.1c-.3.3-.5-.1-.6-.4-.2-.3-.7-.3-1-.3-.2 0 0 .2 0 .3l.6 1.5c.2.3.7.3 1 .3.4 0 .8 0 1-.4.2-.2-.3-.7 0-.8.4 0 .4.4.5.6 0 .3.2.6.3.8 0 .2-.3.2-.4.2l-3 .2c-.4 0-.9.2-1-.2 0-.3.6-.1.6-.6l-.4-1-1.1-2.6c-.2-.3-.4-.6-.8-.7-.2 0-.6 0-.4-.4h1l2.8-.2zm2.3 1.3c-.1-.3-.3-.7-.7-.9-.2 0-.7 0-.7-.4.3-.2.7 0 1 0 .8 0 1.6-.3 2.4 0 .8.2 1.5.9 1.6 1.8 0 .4-.3.7-.7.8-.3 0 .2.1.3.2.7.3 1 .9 1.4 1.5.1.2.5.7.6.2 0-.5.7 0 .5.3 0 .4-.3.6-.7.6-.4 0-.9-.2-1.1-.6-.4-.6-.7-1.3-1.3-1.7-.2-.2-.5-.3-.8-.1v.4l.6 1.2c.2.3.6.3 1 .3.3.1.2.6-.2.5h-1.7c-.3.2-.9 0-.7-.3.3 0 .7-.2.5-.5l-1-2.6-.3-.7zm1.4 1c.2.3.6 0 .9 0 .3 0 .3-.5.2-.7-.1-.5-.4-1-.9-1.2-.2 0-.8-.2-.9.1l.7 1.6v.1zm7.2 1.6c.2.3.3.6.6.7.2 0 .6 0 .7.3 0 .3-.4.1-.6.2a7 7 0 0 0-1.6 0c-.3.1-.6 0-.6-.3.2-.2.7 0 .7-.4l-.5-1.1-1.1-2.9c-.1-.3-.5-.3-.7-.3-.3 0-.7 0-.7.4 0 .3.2.7 0 .8-.3 0-.4-.3-.5-.5l-.3-1c0-.2.3-.1.4-.1l4.2-.2c.3 0 .5.2.5.5s.3.6.4 1c-.1.3-.5 0-.5-.3-.2-.3-.6-.6-1-.7-.2 0-.6 0-.8.2l.2.7 1.2 3zm3.8-.9c-.2 0-.1.3-.1.4v.8c.1.3.5.3.8.4.2 0 .1.5-.2.4h-1.2c-.3.1-.7-.1-.5-.4.2 0 .4-.1.5-.3v-5c.2-.3.6 0 .6.1l3.6 4.6c.2.2.5.4.8.4.3 0 .4.5 0 .4h-1.5c-.2 0-.5.2-.7 0-.2-.1 0-.4.2-.4.3 0 0-.4-.1-.6l-.6-.8h-1.6zm1.1-.5c.2 0 0-.1 0-.2l-1.3-1.7v2h1.3zm3.1-1.8c-.1-.4-.3-1-.8-1-.3 0-.7-.2-.5-.5h1.7c.7 0 1.4 0 2 .2a4.3 4.3 0 0 1 3 3.4c0 .6-.1 1.3-.6 1.6-.8.5-1.7.4-2.5.3l-1.4.1c-.3 0-.4-.5 0-.4.4 0 .4-.5.2-.7l-1.1-3zm2 2.5c.1.3.2.7.5 1h1c.5 0 .7-.5.7-.9a4.3 4.3 0 0 0-.6-2.1 2.7 2.7 0 0 0-1.8-1.4h-1c-.1 0 0 .2 0 .4l1.2 3zm-21.1 12.4c0 .3.4.6.8.6.2 0 .7 0 .7.4-.2.2-.5 0-.8 0a8.6 8.6 0 0 0-1.5.2h-.9c-.2 0-.2-.4.1-.4.3 0 .6-.1.7-.4 0-.3-.2-.6-.3-.8l-1.2-2.8c0-.3-.4-.3-.7-.3-.2 0-.6.1-.7-.2 0-.3.5-.2.7-.4l1-.3c.2 0 .3.1.4.3l1.7 4zm.7-4.5h2c.4 0 .2-.5.4-.5.4 0 .4.5.4.7a.5.5 0 0 1-.6.6H475l.5 1.2.6-.2a2.8 2.8 0 0 1 2.6 1.6c.2.4.3 1 0 1.5-.4.5-1 .6-1.6.6-.5 0-1-.1-1.4-.6-.1-.2-.1-.7.2-.6.4 0 .7.2.7.6.1.2.5.1.7.1.3 0 .6-.2.6-.6 0-.4-.2-1-.5-1.3-.2-.4-.7-.7-1.2-.7l-.9.1c-.3 0-.3-.3-.4-.5a23.9 23.9 0 0 1-.7-1.9s.1-.2.2-.1zm6.9 1c-.2-.4-.4-.9-.9-1-.2 0-.7-.2-.4-.4h1.6a3 3 0 0 1 2.1.1 4.3 4.3 0 0 1 3 3.4c0 .6-.1 1.2-.7 1.5-.7.5-1.6.4-2.4.4l-1.3.2c-.3 0-.4-.5 0-.5s.3-.4.2-.7l-1.2-3zm2 2.4c.2.4.3.8.6 1 .3.2.6.1 1 0 .4 0 .6-.5.6-.9a4 4 0 0 0-.7-2.1 2.6 2.6 0 0 0-1.8-1.3 3 3 0 0 0-1 0v.3l1.3 3zm6.4-4.2c.3 0 .4.3.5.5 0 .3.2.5.3.8-.2.3-.5 0-.6-.3-.1-.2-.3-.5-.6-.5a9.7 9.7 0 0 0-1.3 0c-.2.2 0 .5 0 .6l.6 1.4c.3 0 .6 0 .8-.2.2-.2-.2-.7.2-.6.4 0 .3.5.4.8l.5 1.1c-.1.4-.5 0-.6-.3-.1-.3-.5-.3-.8-.3-.2 0-.4 0-.2.2l.6 1.5c.2.4.7.3 1 .3.4 0 .8 0 1-.3.2-.2-.2-.6 0-.8.4 0 .5.3.5.5l.3 1c0 .1-.3 0-.4 0l-3.1.2c-.3 0-.7.2-.9 0-.2-.5.5-.3.6-.6l-.3-.9-1.1-2.9c-.2-.3-.4-.6-.8-.7-.2 0-.6 0-.4-.4h1l2.8-.1zm-27.2 14.3c.1.5.6.7 1 .8.8.2 1.7.5 2.2 1.1.3.4.5.9.5 1.4 0 .5-.5.9-1 1a2.5 2.5 0 0 1-1.7-.1c-.2-.1-.1.4-.4.2-.3-.1-.2-.5-.4-.8a9 9 0 0 0-.3-1c0-.3.4 0 .5.2.3.6.9 1 1.6 1.1.4 0 .8-.2.8-.6 0-.5-.4-1-.8-1.2-.7-.3-1.4-.4-2-.8a2 2 0 0 1-1-1.6c0-.4.4-.8.8-.9a2.6 2.6 0 0 1 1.6 0c.2 0 .3-.3.6-.1 0 .2 0 .4.2.6l.3.9c-.2.2-.5 0-.5-.2-.3-.4-.6-.8-1-.8s-.8 0-1 .3v.5zm6.6-1.7c.4 0 .4.3.5.5 0 .3.2.6.3.8-.2.3-.5 0-.6-.2-.1-.2-.3-.5-.7-.5h-1.2c-.2.2 0 .4 0 .6l.5 1.4c.3 0 .6 0 .8-.2.2-.2-.2-.6.1-.7.4 0 .4.4.5.7 0 .4.3.8.5 1.3-.2.3-.6 0-.6-.3-.1-.3-.5-.4-.8-.3-.2 0-.4 0-.3.2l.6 1.5c.1.3.4.3.7.3.4 0 .9 0 1.2-.3.2-.2 0-.6 0-.8.3-.2.6 0 .6.3l.2 1c0 .2-.3.2-.4.2l-3 .2c-.4 0-.8.3-1 0 0-.4.5-.3.6-.6 0-.3 0-.5-.2-.8l-1-3c0-.3-.3-.6-.7-.6-.2 0-.6-.2-.4-.4h1l2.8-.3zm4.2 4.2c.1.3.3.6.6.7.3 0 .7-.1.8.2 0 .4-.5.2-.7.2a6.3 6.3 0 0 0-1.6.1c-.2 0-.5.2-.6-.1 0-.4.5-.2.6-.4l-.1-.8-1-3c-.2-.3-.3-.7-.7-.7-.2 0-.6 0-.5-.4.1-.2.5 0 .7 0 .7 0 1.4-.3 2.2-.2a2 2 0 0 1 1.7 1.2c.2.4.2 1 0 1.3-.5.4-1.1.5-1.7.6-.2 0 0 .2 0 .3l.3 1zm-.5-1.8h.6c.3-.1.5-.4.4-.7a2.2 2.2 0 0 0-.5-1.2c-.3-.3-.8-.3-1.1-.2-.2.1 0 .3 0 .5l.5 1.6zm6.1 1.5c0 .2.2.6.5.6.2 0 .7 0 .7.3s-.5.2-.7.2a7 7 0 0 0-1.6.1c-.2 0-.5 0-.5-.3.2-.2.7 0 .7-.4l-.3-1.2-1-2.9c0-.3-.4-.3-.7-.2-.2 0-.6 0-.7.3v.8c-.2.2-.4 0-.4-.3a6.6 6.6 0 0 0-.4-1c0-.3.3-.3.5-.3l4.1-.2c.3 0 .5.2.5.5l.4 1c-.1.2-.5 0-.5-.2-.2-.3-.5-.7-1-.8-.2 0-.5 0-.8.2l.2.6 1 3.2zm2.1-3.3c-.1-.3-.2-.7-.6-.8-.2 0-.6 0-.6-.4.1-.2.4 0 .6 0l1.8-.2c.3-.1.5.4.2.4s-.6.2-.5.5l.5 1.6.7 2.2c0 .2.3.4.5.4.3 0 .7 0 .6.4h-.7l-1.6.2c-.2 0-.5-.2-.4-.4.2-.1.6 0 .6-.4l-.3-1.2-.8-2.3zm5.8-1.6c.3 0 .3.3.4.5l.2.8c-.1.3-.5 0-.5-.2-.1-.3-.3-.6-.7-.6a9.7 9.7 0 0 0-1.2 0c-.2.2 0 .5 0 .6l.5 1.4c.2 0 .5 0 .8-.2.2-.2-.2-.6.1-.7.4 0 .4.5.4.7l.5 1.3c-.1.3-.5 0-.5-.2-.1-.3-.5-.4-.8-.4-.1 0-.5 0-.3.2l.5 1.5c.1.3.4.4.7.3.4 0 .9 0 1.2-.2.2-.2 0-.6.1-.9.3-.2.5.1.5.4a9.3 9.3 0 0 0 .3 1c0 .2-.3.2-.5.2l-3 .1c-.3 0-.7.2-1 0-.1-.4.5-.3.6-.5a1 1 0 0 0-.1-.8l-1-3c0-.3-.3-.7-.7-.7-.2 0-.6-.2-.4-.4h1l2.9-.2zm2 1c-.1-.4-.4-.7-.8-.7-.3.1-.5-.6 0-.4h1.5l.7.9 2.1 2.9v-.3l.4-3.6c.2-.2.7 0 1-.2.3 0 1 0 .8.4-.4 0-.8.2-.6.6l1.2 3.6c0 .4.4.6.8.5.3 0 .3.6 0 .5H494c-.3.1-.8.1-.6-.3.3 0 .8-.2.5-.6l-1-3.2c.1.1 0 .3 0 .4l-.2 3-.1.8c-.3.1-.4-.1-.5-.3l-2.9-3.7.2.3c.3 1 .5 2 .9 2.9 0 .4.5.5.8.5.4.2.1.5-.2.4h-1.5c-.3 0-.3-.4 0-.4.5 0 .4-.5.2-.8l-1-3.3zm8.7.8c0 .2.4 0 .5 0 .3 0 .7 0 .7-.4 0-.5-.2-1-.5-1.2-.4-.3-.8-.2-1.2-.2l.1.5.4 1.3zm.5 1.6l.4 1c.3.2.6.1.9.1.2 0 .5-.2.4-.5 0-.6-.3-1.3-.9-1.5a2.4 2.4 0 0 0-1 0v.3l.2.6zM496 288c-.1-.4-.2-.8-.6-1-.2 0-.6 0-.6-.3s.5 0 .7-.1c1 0 1.8-.3 2.7 0 .7.2 1.3.9 1.3 1.6 0 .4-.3.7-.7.9 0-.2.4 0 .5 0 .5.2 1 .6 1.2 1.1.2.5.3 1 0 1.4-.4.4-1 .4-1.5.4l-2.3.1c-.3 0-.4-.5 0-.4.3 0 .4-.4.2-.7l-.9-3zm5-.2c0-.3-.2-.8-.6-1-.2 0-.6 0-.6-.3.2-.3.6 0 1-.1h2c.8 0 1.5.6 1.7 1.4.2.4 0 1-.3 1.2l-.5.2c.6.2 1.1.7 1.4 1.2l.5.8c.3.2.3-.1.3-.3.4-.2.6.3.4.6-.1.4-.7.5-1 .4-.4 0-.6-.3-.8-.6l-1-1.7a.9.9 0 0 0-.9-.2v.5l.5 1.1c.1.4.5.4.8.5.4 0 .4.5 0 .4h-1.8c-.2 0-.6.2-.7 0-.2-.5.4-.3.6-.6l-.2-.8-.8-2.7zm1.3 1c.1.2.6 0 .8 0 .3 0 .5-.3.4-.5 0-.5-.2-1-.5-1.3-.3-.2-.7-.2-1-.1-.2 0-.1.3 0 .5l.3 1.3zm7-2.6c.2 0 .3.3.3.5 0 .3.2.5.3.8-.2.3-.5 0-.5-.2-.2-.2-.3-.6-.7-.6a9.5 9.5 0 0 0-1.3 0c-.2.1 0 .4 0 .6l.4 1.3h.8c.3-.2-.1-.7.2-.8.4 0 .4.4.4.7 0 .4.3.9.4 1.3-.1.3-.5 0-.5-.2 0-.3-.4-.5-.7-.4-.1 0-.5-.2-.4 0l.5 1.7c0 .3.4.3.7.3.4 0 .9 0 1.2-.2.3-.2 0-.6.1-.8.3-.2.6 0 .5.3l.2 1c0 .2-.3.2-.4.2h-3.1c-.3 0-.6.2-.8 0-.3-.4.3-.3.4-.5.2-.2 0-.5 0-.7l-.9-3.1c0-.3-.3-.7-.6-.7s-.6-.1-.5-.4h1l3-.1zm-32.9 13.1c-.1-.4-.2-.8-.6-1-.3 0-.7 0-.5-.3.3-.2.6 0 1-.1.8 0 1.6-.2 2.4 0a3.5 3.5 0 0 1 2.6 2.3c.2.8.3 1.6-.2 2.3-.5.6-1.4.8-2.2.8-.7 0-1.3 0-1.9.2-.2.1-.6-.1-.4-.4.3 0 .7-.2.6-.5l-.4-1.5-.4-1.8zm1.6 2.5c.1.3.2.7.4.9.3.2.7.1 1 0 .4 0 .8-.4.9-.9a4 4 0 0 0-.4-2.2 2 2 0 0 0-1.5-1.2 3 3 0 0 0-1.1 0c-.1 0 0 .2 0 .4l.7 3zm7.1-4.5c.3 0 .3.3.4.5l.2.9c-.1.2-.5 0-.5-.2-.1-.3-.3-.6-.6-.6a9.3 9.3 0 0 0-1.3 0c-.2.1 0 .4 0 .6 0 .5.2 1 .3 1.4.3 0 .6 0 .8-.2.2-.2-.1-.6.2-.7.4 0 .3.5.4.7 0 .4.3.8.3 1.3 0 .3-.5 0-.5-.2 0-.4-.4-.5-.7-.4-.1 0-.5-.1-.3.1 0 .5.2 1 .4 1.6 0 .3.4.3.7.3.4 0 .9 0 1.2-.3.2-.2 0-.6.2-.8.3-.2.4.1.4.4 0 .3 0 .6.2 1l-.5.1-3 .2c-.3 0-.6.2-.9 0-.2-.2.1-.4.4-.4.3-.1.2-.5.2-.7l-.8-3.2c-.1-.3-.3-.7-.6-.7s-.6-.1-.5-.4l1-.1 2.9-.2zm6.5 4.1c0 .3.3.6.6.6.2.1.6 0 .7.3.1.3-.4.2-.6.2l-1.7.1c-.3 0-.6.1-.8 0-.3 0-.2-.4.1-.4.3 0 .6-.1.7-.4l-.1-.8-.7-2.8c0-.3-.4-.3-.6-.3-.2 0-.6.2-.7-.1 0-.4.5-.3.7-.4l1.1-.4c.2 0 .3.1.3.3l1 4.1zm3.7-3.3c0-.4-.3-.8-.7-.8-.3 0-.7 0-.8.3a1 1 0 0 0 .4 1l.9.5.2-.6a1.4 1.4 0 0 0 0-.4zm.8 3c0-.6-.5-.9-1-1-.2 0-.4-.3-.5-.2a1 1 0 0 0-.4 1c.2.6.5 1 1 1 .4.1.8 0 1-.4a1 1 0 0 0 0-.5zm1-.3a1.2 1.2 0 0 1-.6 1.3 2.4 2.4 0 0 1-2 .2 1.7 1.7 0 0 1-1.2-1.3c0-.4.1-1 .6-1.3 0 0 .4-.1.1-.2-.5-.2-1-.6-1-1.2-.2-.5 0-1 .5-1.3a2 2 0 0 1 2.6.7c.2.4.2.9 0 1.2l-.6.5c.5 0 1 .4 1.2.8.2.1.3.4.3.6zm3.2.5c.2 0 .5 0 .5-.4.1-.1 0-.6.3-.5.3 0 .2.3.3.6 0 .4 0 .8-.4 1.1-.2.2-.5.1-.8.1h-1.7c-.2 0-.5.2-.7 0-.2-.2 0-.5 0-.7.2-.7.6-1.2 1-1.6.4-.3.8-.6.9-1.1a2 2 0 0 0-.3-1.2 1 1 0 0 0-1.4-.3c-.3.1-.4.5-.3.7.2.2.6 0 .7.4.2.2 0 .6-.3.6-.4 0-.8-.3-1-.7a1.2 1.2 0 0 1 .6-1.4c.5-.3 1.1-.3 1.7-.2.5.2 1 .6 1.2 1.2.1.4.1.9-.1 1.3-.4.7-1.1 1-1.7 1.7-.1.1-.2.3-.1.6 0-.3.4-.2.5-.2h1zm4-.4c0 .3.2.6.5.7.2 0 .6 0 .7.2.1.3-.3.3-.5.3h-2.7c-.2-.1 0-.5.2-.4.3 0 .6-.1.7-.4v-.8l-.7-2.8c0-.3-.3-.3-.5-.3-.3 0-.6.2-.7 0-.2-.5.3-.4.5-.5l1.2-.4c.2 0 .3.1.4.3l.8 4.1z"
          stroke="none"
        />
      </g>
      <g fill="#448127" stroke="#34541f" strokeWidth={0.2}>
        <path
          fill="url(#prefix__m)"
          stroke="#4c0505"
          d="M475.8 219.4L472 224c-1.2 5.2 1.8 9.2 7.7 12.6 4.7 3 13.5 3.7 16.3 1.3l-13.7-13-6.5-5.4z"
        />
        <path d="M503.6 354.3a322.5 322.5 0 0 0-2-2.5 100.5 100.5 0 0 1-32.7 28.6c15.1-4.3 25-15.2 34.7-26.1zM488 390a460 460 0 0 1 18.2-32.3 274.3 274.3 0 0 0-2.1-2.7c-7.3 12.2-16 26.7-16 35zm42-114.5a62 62 0 0 0-4.3-13 126.5 126.5 0 0 0-43.8-44v-.3h.3l-.2-.1h.5l-.2-.3h.4l-.3-.4h.4l-.3-.3h.5l-.3-.4h.4l-.4-.3.6-.1-.5-.3.5-.1-.4-.3.6-.2-.5-.3.6-.3-.6-.4.7-.2-.7-.3.6-.4h-.8l.5-.7h-.7l.3-.5h-.6l.3-.5-.7.1.3-.6-.6.4.2-.7-.7.4.1-.7-.5.5v-.7l-.5.5v-.7l-.5.6v-.7l-.4.6-.2-.7-.3.6-.2-.7-.3.8-.2-.8-.3.8-.2-.7-.2.6-.1-.5-.3.7-.2-.7-.2.8-.3-.7-.2.8-.3-.7v.8l-.4-.6v.8l-.5-.6v.7l-.4-.3.2.7-.5-.3.2.7-.4-.3.1.6h-.4l.2.4h-.3l.2.4a9 9 0 0 0-.4 3.5c0 .2.6.4.7.6.3.4.2.6.2.6-1.6 2.6-3 4.6-3.1 7.6 1.2-1.6 2.6-3.6 4.4-3.6-.9 1.5-1.3 6.1-.3 6.9l.8-1.4c0 1 .1 1.8.4 2.3l1-1.7c0 1.5.2 2.7.6 3.3a6 6 0 0 1 1.6-1.6c-.2.9-.5 1.7-.4 2.7l2-2.5c-.4 1.6 0 2.8.4 4.5.4-2 .6-2.3 1.5-3.1.1 1.9-.2 3.6.2 4.7.8-1.7 1.4-1.5 2-2.6-.2 1.6-.5 3.3 0 4.7a4.5 4.5 0 0 1 1.9-2.6c0 2.2.5 1.8-.8 3.7.6.2 2.5-.4 3.6-.9-.5 1.2-.4 2.1-.9 3 1-.6 2-1.5 2.9-2.4-.4 1.4-1.5 2.8-1 4.1.3-1.3 1.3-2.3 2.3-2.5-.2.7-.3 2.2-1.3 2.9 2.4.2 3.4-1.4 4.6-2.7-.1 1.4 0 2.4 1.6 4.3-.3-2.4.2-1.9 1.3-3.3.6 2.1 1.2 4.4 3.4 6-1-2.3-1-3.5-.6-4.9.3 1.5 1.7 3.3 2 4.7.3-1.6.5-3.1 1-4.1a20.2 20.2 0 0 1 1.4 5.6c.5-1 .9-2 1.1-3.1 19.8 20.6 24.2 46.8 2.6 74.5 7.7-5.2 9.7-13.5 14-20.6-4.2 9.3-6 19.7-13.5 27.4 7.2-6.2 8.7-11.9 13-17.9-4.5 12.5-11 26.2-19.8 38.8a690.6 690.6 0 0 1 4.8 5.2l4-6.9c9.4-15.4 24.7-37.5 17-71.1z" />
      </g>
      <path
        fill="#eac102"
        stroke="#a08307"
        strokeWidth={0.2}
        d="M473.2 215.3c-1 .2-1.4.6-2.1 1.4.9.2 1.6.3 2.5.3.2 0 .3-.3.3-.6l-.2-1c0-.2-.6-.1-.8 0l.3-.1z"
      />
      <path
        fill="#a08307"
        d="M471 216.7a9.9 9.9 0 0 1 1-.3 9.8 9.8 0 0 1 1.2-.2 9.8 9.8 0 0 1-1 .3 10 10 0 0 1-1.2.2z"
      />
      <ellipse
        cx={477.7}
        cy={215.4}
        stroke="#000"
        strokeWidth={0.1}
        rx={0.8}
        ry={0.8}
      />
      <ellipse cx={477.9} cy={215.3} fill="url(#prefix__n)" rx={0.3} ry={0.3} />
      <g fill="#34541f">
        <path d="M488.2 389.7a83.4 83.4 0 0 1 1.5-4.4 96.2 96.2 0 0 1 1.8-4.4c1.2-2.9 2.7-5.7 4.1-8.4a199.6 199.6 0 0 1 4.7-8.2 354.4 354.4 0 0 1 2.4-4l2.5-4-2.4 4a400 400 0 0 0-2.4 4.1l-4.6 8.2a133.7 133.7 0 0 0-4.2 8.4 98.1 98.1 0 0 0-1.8 4.3 82.7 82.7 0 0 0-1.6 4.4zm-18.9-9.5a75.8 75.8 0 0 0 5-2.3 72.3 72.3 0 0 0 4.6-2.7 72 72 0 0 0 8.8-6.5 84.7 84.7 0 0 0 7.7-7.5 113.6 113.6 0 0 0 3.6-4.1l3.4-4.3a153.8 153.8 0 0 1-3.3 4.3 111.9 111.9 0 0 1-3.6 4.2 81.9 81.9 0 0 1-7.7 7.6 70 70 0 0 1-8.8 6.4 71.3 71.3 0 0 1-4.7 2.6 77 77 0 0 1-5 2.3zm37.3-29.3a138.7 138.7 0 0 0 4.3-6.7l4-6.8a341.8 341.8 0 0 0 3.7-7l3.7-7-1.7 3.5-1.8 3.6a256 256 0 0 1-3.7 7 160.5 160.5 0 0 1-4 6.8 93.5 93.5 0 0 1-4.5 6.6zm6-25.1a58.4 58.4 0 0 0 4.6-6.4 60.2 60.2 0 0 0 3.8-7 72.6 72.6 0 0 0 5-15l.4-2a61 61 0 0 0 .7-6 52 52 0 0 0 0-7.9 50.6 50.6 0 0 0-1.3-7.8 53.4 53.4 0 0 0-2.4-7.6 53.5 53.5 0 0 1 2.5 7.5 50.5 50.5 0 0 1 1.3 7.9c.2 2.6.2 5.3 0 8a61.3 61.3 0 0 1-.6 6 90.3 90.3 0 0 1-.4 1.9 72.7 72.7 0 0 1-5 15 59.9 59.9 0 0 1-4 7 58.2 58.2 0 0 1-4.7 6.4z" />
        <path d="M510.9 320a36 36 0 0 0 4.9-5.8 52 52 0 0 0 3.8-6.6 96 96 0 0 0 3-7c.4-1.2 1-2.4 1.3-3.6l.4-.9.3-.9.6-1.8c.5-2.5.7-5.1.8-7.7a45.8 45.8 0 0 0-.6-7.7c-.4-2.5-1-5-1.7-7.5a80.2 80.2 0 0 0-2.6-7.3 80.3 80.3 0 0 1 2.7 7.3 57.4 57.4 0 0 1 1.7 7.5 46 46 0 0 1 .6 7.7 41.4 41.4 0 0 1-.7 7.7l-.6 1.9-.3.9-.4.9-1.3 3.6a96 96 0 0 1-3.1 7 51.6 51.6 0 0 1-3.8 6.6 36 36 0 0 1-5 5.8z" />
        <path d="M505 349.2c1.3-1.6 2.4-3.3 3.6-5l1.8-2.5 1.7-2.5a68.8 68.8 0 0 0 3-5.4l2.6-5.5c1.8-3.7 3.5-7.4 5-11.3a75.3 75.3 0 0 0 3.5-11.7c.8-4 1.4-8 1.9-12.1.4-4.1.4-8.2 0-12.3a52.4 52.4 0 0 0-2.7-12 72.8 72.8 0 0 0-5.1-11.1 72.8 72.8 0 0 1 5.2 11.1 52.4 52.4 0 0 1 2.7 12c.5 4 .4 8.2 0 12.3-.4 4-1 8.1-1.8 12.1a75.5 75.5 0 0 1-3.5 11.8 145.1 145.1 0 0 1-5 11.2l-2.7 5.5a67.3 67.3 0 0 1-3 5.4c-.5 1-1.1 1.7-1.7 2.6l-1.8 2.5-3.6 5z" />
        <path d="M507.8 352.3l7-11.6a200.5 200.5 0 0 0 6.4-11.9 82 82 0 0 0 5-12.5c.7-2.2 1.2-4.3 1.7-6.5a59.3 59.3 0 0 0 .6-3.4 127.7 127.7 0 0 0 1.4-16.8c0-4.5-.4-9-1.2-13.4a57.5 57.5 0 0 0-4-12.9 54 54 0 0 0-7-11.5 54 54 0 0 1 7 11.5 57.6 57.6 0 0 1 4.1 12.9 73.4 73.4 0 0 1 1.2 13.4c0 4.5-.3 9-.9 13.5a134 134 0 0 1-.4 3.4 58.8 58.8 0 0 1-.6 3.3 74.3 74.3 0 0 1-1.7 6.5 82 82 0 0 1-5 12.6c-2 4-4.3 8-6.5 11.8a442.5 442.5 0 0 1-7 11.5zM480 220.8h1.4a18.7 18.7 0 0 1 4.1 1.3c1.7.8 3.4 1.8 4.9 3a35.8 35.8 0 0 1 4.3 3.7 45.3 45.3 0 0 1 1.8 2.1l1.8 2.3a60.9 60.9 0 0 0-1.8-2.2 42 42 0 0 0-2-2 37.8 37.8 0 0 0-4.2-3.8 26.8 26.8 0 0 0-4.9-3 18 18 0 0 0-5.4-1.4z" />
      </g>
      <g fill="#448127">
        <path d="M496.4 231.6s3 1.8 4.7 4.4c0 0-4.7-.9-8-4.6" />
        <path
          fill="#34541f"
          d="M496.4 231.6a14.1 14.1 0 0 1 2.6 1.9 13 13 0 0 1 2.2 2.4l.1.3h-.2a14.5 14.5 0 0 1-2.3-.8 15.7 15.7 0 0 1-2.1-1c-1.4-.8-2.6-1.8-3.7-3a15.2 15.2 0 0 0 3.8 2.8 18.3 18.3 0 0 0 2 1 14.4 14.4 0 0 0 2.3.7v.2a11.2 11.2 0 0 0-1-1.3l-1.2-1.2a17.7 17.7 0 0 0-1.2-1 18.6 18.6 0 0 0-1.3-1z"
        />
        <path d="M489.6 230.7s7.2 4.6 8.2 5c0 0-1.6-3.5-5-5" />
        <path
          fill="#34541f"
          d="M489.6 230.7l4.1 2.5a139.9 139.9 0 0 0 3.1 1.8l1 .6v.1a10.7 10.7 0 0 0-1-1.5l-1.1-1.4a10.7 10.7 0 0 0-1.4-1.2l-1.5-.9a8.4 8.4 0 0 1 1.6.9 11.1 11.1 0 0 1 3.5 4l.2.3-.3-.1-2.1-1.2-2-1.3a151.6 151.6 0 0 1-4.1-2.6z"
        />
        <path d="M492.5 228.4s3.7 1.6 4.6 4.3c0 0-6.8-2.8-8-4.3" />
        <path
          fill="#34541f"
          d="M492.5 228.4a10.7 10.7 0 0 1 2.8 1.6 7.2 7.2 0 0 1 1.1 1.2l.8 1.5v.2h-.2a79.6 79.6 0 0 1-2-1 49.8 49.8 0 0 1-2.1-1 34 34 0 0 1-2-1.1l-1-.6-.8-.8.9.7 1 .6 2 1a84.2 84.2 0 0 0 4.1 2h-.1a4.8 4.8 0 0 0-.8-1.3 7.8 7.8 0 0 0-1-1.2 12.5 12.5 0 0 0-2.8-1.8z"
        />
        <path d="M486.8 231.3s6.6 4.7 8.6 4.7c0 0-2-3.3-5.4-4.7" />
        <path
          fill="#34541f"
          d="M486.8 231.3a127 127 0 0 0 4.1 2.6 35 35 0 0 0 3.3 1.7l1.2.3-.1.2a15.5 15.5 0 0 0-2.3-2.8l-1.4-1.1a11 11 0 0 0-1.6-1c1.1.5 2.2 1.2 3 2a12.8 12.8 0 0 1 2.5 2.8v.1h-.1a3.7 3.7 0 0 1-1.3-.3 13.7 13.7 0 0 1-1.1-.5 33.3 33.3 0 0 1-2.1-1.2 63.9 63.9 0 0 1-2.1-1.4 56.3 56.3 0 0 1-2-1.4z"
        />
        <path d="M486.8 232.7s3.4 3 5.4 3c0 0-2-3.3-5.4-4.8" />
        <path
          fill="#34541f"
          d="M486.8 232.7a31.2 31.2 0 0 0 2.5 1.8l1.4.7a5.3 5.3 0 0 0 1.5.4l-.1.1a12.4 12.4 0 0 0-1-1.4 13.3 13.3 0 0 0-2.7-2.5 11 11 0 0 0-1.6-.9c1.1.5 2.2 1.1 3 2a12.9 12.9 0 0 1 2.5 2.7v.2h-.1c-.6 0-1-.2-1.6-.4a11.4 11.4 0 0 1-1.4-.8l-1.2-.9a17.6 17.6 0 0 1-1.2-1z"
        />
        <path d="M485 226.2s7.2 5.1 8 7.9c0 0-6.4-3-7.6-4.5" />
        <path
          fill="#34541f"
          d="M485 226.2a51.6 51.6 0 0 1 2.3 1.7 51 51 0 0 1 2.2 1.8 25.7 25.7 0 0 1 2 2l1 1 .7 1.4v.2l-.2-.1a77 77 0 0 1-2-1 50.3 50.3 0 0 1-2-1 34.8 34.8 0 0 1-1.9-1.2 15.4 15.4 0 0 1-1-.7 4 4 0 0 1-.7-.7l.8.7a36.7 36.7 0 0 0 3 1.7 87.3 87.3 0 0 0 4 2l-.2.1a4.6 4.6 0 0 0-.7-1.2 12.2 12.2 0 0 0-.9-1.1l-2-2a51.1 51.1 0 0 0-2.1-1.9 71.2 71.2 0 0 0-2.3-1.7z"
        />
      </g>
      <g stroke="#24420e" strokeWidth={0.2}>
        <path
          fill="#406325"
          d="M445 370.3a42.2 42.2 0 0 1-20.4 4.8c10-8.2 19.7-8.4 20.4-4.8zm69.8 4.5c5.2 4.7 21 8 23.5 7.4-10.6-10.7-22.1-11.8-23.5-7.4z"
        />
        <path
          fill="#67923d"
          d="M445 370.3c-.7-3.7-10.5-3.5-20.4 4.8a69.4 69.4 0 0 1 20.4-4.8zm69.9 4.4c1.4-4.4 12.8-3.3 23.4 7.5a84 84 0 0 0-23.4-7.5z"
        />
      </g>
    </g>
  </svg>
	),
	GU: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#be0027" fillRule="evenodd" d="M0 0h640v480H0z" />
    <path fill="#3b5aa3" fillRule="evenodd" d="M25.6 27.3h589.5v428.4H25.6z" />
    <path
      fill="#cbe0e5"
      fillRule="evenodd"
      d="M314.4 413.2a10 10 0 0 0 8.4.1c137.8-73.3 137.8-274.3.1-346.6a10 10 0 0 0-8.7.2c-134.3 73.4-134.7 272.1.1 346.3z"
    />
    <path
      fill="#add2d9"
      fillRule="evenodd"
      d="M314.4 416.9c2 1.7 6.4 1.5 8.4 0 101.5-76 102-123.3 97.6-123.3h-201c-3 0 1.8 48.2 95 123.3z"
    />
    <path
      fill="#fdf9a1"
      fillRule="evenodd"
      d="M235.3 331.2a39.2 39.2 0 0 1 27.9 1.7c7.6 4 12 4 20.2 4 8.6.2 15.3 6.5 24.6 6.8 17.1.4 24.3 8.9 11 9-6.2 0-19.7-4.3-26.2-3.4-13.6 1.4-22.2 4.4-35 18.7l14.8 10c12.8-5.1 14.9-11 22-11.2 8-.3 10.7-5.2 20-5.2a92.6 92.6 0 0 0 33-3.2c14.8-3.4 7.8-13.8-1.2-17.5-7.3-3.1-20.8-.1-29.2-3.2-6.4-2.5-1.2-6.5 2.3-7.3 3.4-.7 7.1.5 11.4 1.2 7.7.6 17.4-.1 24.1-1.2 14-2.1 13.4-6.2 20-6.3 5-.3 8.7-1.7 12-4.1 4-2.7 8.1-8 12.9-7.8l12.7.5-18 40.4-50.7 51.7-26.3 10-57.8-37.7-29.1-44.7 4.7-1.2z"
    />
    <path
      fill="#179a3b"
      fillRule="evenodd"
      d="M301.8 292l116-.6 2-10.3s-4.1-.6-7.5-.8c-4.1-.3-11.3 4.4-16 4.3-3.5 0-7.3-6-10.7-6-6 0-6.4 5.3-12 5.5-4.5-.2-6.4-3.6-12.3-3.2-6 .3-5.6 3.7-13.3 3.5-10.2-.3-14.3-9.1-22.5-9.2-13.6-.2-14 13-23.8 16.7z"
    />
    <path
      fill="#fdf9a1"
      fillRule="evenodd"
      d="M301.8 294.4l119.4-.6v-3.2l-122.2.6 2.7 3.2z"
    />
    <path
      fill="#a79270"
      fillRule="evenodd"
      d="M350.8 330.3c1.9 7 3.8 9.4 11.2 11.3 7.3 1.7 18.5-5.4 11.6-12.3-6.6-6.4-13.6-8-19.5-13.8-12.5-12.3-31.3-42.5-31.3-63.8 0-18.3-1.8-55.8-1.8-91.3 0-2.3-7 6.4-7 8.8.4 31.3.4 55 1.6 86.6 2 23.1 13 38.7 22.7 52.7 4.3 6.8 10.6 14 12.5 21.8z"
    />
    <text
      x={465.1}
      y={269.5}
      fill="#bd0728"
      stroke="#fff"
      strokeWidth={1.6}
      fontFamily="helvetica"
      fontSize={25.6}
      transform="matrix(1.33 0 0 1.33 -363 -108)"
    >
      <tspan>{"G"}</tspan>
    </text>
    <text
      x={488.1}
      y={269.6}
      fill="#bd0728"
      stroke="#fff"
      strokeWidth={1.6}
      fontFamily="helvetica"
      fontSize={25.6}
      transform="matrix(1.33 0 0 1.33 -363 -108)"
    >
      <tspan>{"U"}</tspan>
    </text>
    <text
      x={516}
      y={269.6}
      fill="#bd0728"
      stroke="#fff"
      strokeWidth={1.6}
      fontFamily="helvetica"
      fontSize={25.6}
      transform="matrix(1.33 0 0 1.33 -363 -108)"
    >
      <tspan>{"A"}</tspan>
    </text>
    <text
      x={539.5}
      y={269.5}
      fill="#bd0728"
      stroke="#fff"
      strokeWidth={1.6}
      fontFamily="helvetica"
      fontSize={25.6}
      transform="matrix(1.33 0 0 1.33 -363 -108)"
    >
      <tspan>{"M"}</tspan>
    </text>
    <path
      fill="#239e46"
      fillRule="evenodd"
      d="M259.6 160.9c-1.5 3 3.6-.9 4.8-1.3 6.7-2.4 9.3-10.8 20.8-5.7 9 3.9 21.1 1.6 14.8 5.6-7.8 4.7-23.5 9.9-23.8 33.2 1.3 2.2 1.4 1.9 2.5-.6 2.4-5.4 13.7-20.1 19.3-18.9 2.3.6 8.9-6.7 9-4.6.7 5.8-9 17.6-8.8 33.3 0 3.7 4.5 4.9 6.6 2.3 2.2-2.3 3.4-4.6 7.2-7.6 6.6-5.4 4.8-28.6 5.6-27.5 4.7 6 5.4 23.3 12.4 30.3 5.9 5.9 10.6 3 9.3-5-2.5-16.4-10.2-11.7-13.9-28.6-.8-3.3-1-6.2 3.4-4.9 5.3 1.6 8.5 4 12.4 10 4 5.8 11.4 11.3 15.7 14.6 7.5 5.8 10.2.8 6.6-6.6a39.6 39.6 0 0 0-21-18.2c-6.2-2.2-8.4-2.4-13.8-3.4-1.5-.3-3-3.4-.4-5.1a42.5 42.5 0 0 1 19.6-7.7c6.7-.2 12 5.2 16.7 6.6 9.4 2.4 9.4-3.5 5.2-8-3.4-3.7-10.6-10-17.3-9.1-13.5 1.7-12.6 1.3-21 6.8-3 1.8-6.4 3.8-5.1 1.6 3-5.5.2-4.5 4.9-10.1 3.6-4 6.3-7 10-8 3.4-.9 8-4.5 9.3-6.4 3.4-4.6.5-7.3-4.7-5.7-4.6 1.2-7 4.2-10 5-7.4 2.4-13.3 19-14.2 21.4-1.1 2.8-2.4 1.4-2.2-1 1-11.7 2-31.5-2-39.6-6.4-12-5.8-6.4-8.2-.7-3.6 9-2.3 17.5 0 26.3 1 4.4 4.6 9.4 5.3 12.9.5 2.7-1.6-.8-2.8-2.5-3.9-6-6.8-10-13.2-13.3a35.3 35.3 0 0 0-20.2-2c-1.8.6 2 3.2 3.5 4.4 4.3 3.4 12.4 4.5 18 7.9 4.6 2.9 8.2 4.7 9.8 8.7.6 3 1.6 7.4-.4 7.3-5.1-.3-13-4.8-29.4-3-8.4 1.2-15.6 8.3-20.3 16.9z"
    />
    <path fillRule="evenodd" d="M295.3 310.6h4.7v7.9h-4.7z" />
    <path
      fill="#fdf9ff"
      fillRule="evenodd"
      d="M271.7 257.9c18.8 26 49 41.2 49.6 53h-58.8c13.5-16.2 21.8-27.2 9.2-53z"
    />
    <path
      fill="#a68861"
      fillRule="evenodd"
      d="M254.6 311.5c25.6 5.7 56.1 8.9 75.6-.8.2 5.7-6.3 14-11.7 14h-49c5.7-.9 9-2.6 18.2-3l-26 .2c-3 .1-8-7.6-7.1-10.4z"
    />
    <path
      fill="#be0027"
      fillRule="evenodd"
      d="M312.6 425c2.6 1.5 6.7 1.4 9 .2 147.8-78.7 147.9-294.4.2-372a10.7 10.7 0 0 0-9.4.2c-144 78.8-144.4 292 .2 371.7zm.7-17.7a9.3 9.3 0 0 0 8 .1c123.6-72.8 125.1-265.1.1-334-2.4-1.8-5.9-1.2-8.3 0-118.4 70.1-125 254.5.2 333.9z"
    />
    <text
      x={465.1}
      y={269.5}
      fill="#bd0728"
      fontFamily="helvetica"
      fontSize={25.6}
      transform="matrix(1.33 0 0 1.33 -363 -108)"
    >
      <tspan>{"G"}</tspan>
    </text>
    <text
      x={488.1}
      y={269.6}
      fill="#bd0728"
      fontFamily="helvetica"
      fontSize={25.6}
      transform="matrix(1.33 0 0 1.33 -363 -108)"
    >
      <tspan>{"U"}</tspan>
    </text>
    <text
      x={516}
      y={269.6}
      fill="#bd0728"
      fontFamily="helvetica"
      fontSize={25.6}
      transform="matrix(1.33 0 0 1.33 -363 -108)"
    >
      <tspan>{"A"}</tspan>
    </text>
    <text
      x={539.5}
      y={269.5}
      fill="#bd0728"
      fontFamily="helvetica"
      fontSize={25.6}
      transform="matrix(1.33 0 0 1.33 -363 -108)"
    >
      <tspan>{"M"}</tspan>
    </text>
  </svg>
	),
	GW: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#ce1126" d="M0 0h220v480H0z" />
    <path fill="#fcd116" d="M220 0h420v240H220z" />
    <path fill="#009e49" d="M220 240h420v240H220z" />
    <g id="prefix__b" transform="matrix(80 0 0 80 110 240)">
      <path id="prefix__a" d="M0-1v1h.5" transform="rotate(18 0 -1)" />
      <use
        width="100%"
        height="100%"
        transform="scale(-1 1)"
        xlinkHref="#prefix__a"
      />
    </g>
    <use
      width="100%"
      height="100%"
      transform="rotate(72 110 240)"
      xlinkHref="#prefix__b"
    />
    <use
      width="100%"
      height="100%"
      transform="rotate(144 110 240)"
      xlinkHref="#prefix__b"
    />
    <use
      width="100%"
      height="100%"
      transform="rotate(-144 110 240)"
      xlinkHref="#prefix__b"
    />
    <use
      width="100%"
      height="100%"
      transform="rotate(-72 110 240)"
      xlinkHref="#prefix__b"
    />
  </svg>
	),
	GY: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#399408" d="M2.4 0H640v480H2.4z" />
      <path fill="#fff" d="M.2 0c-.9 0 619.6 241.5 619.6 241.5L0 479.8.2 0z" />
      <path
        fill="#ffde08"
        d="M.3 20.2c3.4 0 559 217.9 555.9 220L1.9 463.2.3 20.3z"
      />
      <path d="M1.9.8c1.8 0 290.9 240.9 290.9 240.9L1.8 477V.8z" />
      <path
        fill="#de2110"
        d="M.3 33.9c1.6-15 260.9 208.4 260.9 208.4L.2 451.7V33.9z"
      />
    </g>
  </svg>
	),
	HK: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-89 0h682.6v512H-89z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="translate(83.5) scale(.94)">
      <path fill="#ba0000" fillRule="evenodd" d="M618 512h-731.4V0H618z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M241.9 247.8s-51.6-22.2-44.2-79.8c7.1-27.7 19.8-46.6 42.7-56.9 10.8-3.3 21.8-4.8 33-5.7-3 2.8-5.4 5.6-6.7 9-2.4 6.4-.6 12.4 2.7 18.5 4.1 7 6.6 14.2 7.4 23.6a36.6 36.6 0 0 1-14.6 33.7c-6.6 5.1-14.4 6.9-20.8 12.7-5 4.8-8 9.7-9 18.1-.2 16.1 4.1 18.4 9.5 26.8z"
      />
      <path
        fill="#ba0000"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.1}
        d="M232 164.5v-.3"
      />
      <path
        fill="none"
        stroke="#ba0000"
        strokeWidth={2.1}
        d="M235.3 241.8c-20-17.7-18.3-62.4-3-77.3"
      />
      <path
        fill="#ba0000"
        fillRule="evenodd"
        d="M244.6 154.5l3.3 5.5-6-2.5-4.7 5 .8-6.5-6-2.5 6.5-1.5.8-6.4 3.3 5.5 6.6-1.5"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M246.3 244s6-55.9 63.3-65.7c28.6-1.2 50.4 5.3 67 24.3 6.3 9.3 10.9 19.4 15 29.8-3.5-2-6.8-3.5-10.6-3.7-6.7-.5-12 3-16.8 7.9a53.2 53.2 0 0 1-20.4 14 36.6 36.6 0 0 1-36.5-4c-6.8-4.9-10.8-11.8-18.2-16.2a28.2 28.2 0 0 0-20-3.4c-15.5 4.6-16.3 9.4-22.8 17z"
      />
      <path
        fill="#ba0000"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.1}
        d="M323 210.2h.3"
      />
      <path
        fill="none"
        stroke="#ba0000"
        strokeWidth={2.1}
        d="M250 236c11.2-24.4 54.4-35.8 73.1-25.6"
      />
      <path
        fill="#ba0000"
        fillRule="evenodd"
        d="M336.3 219.3L332 224l.6-6.5-6-3 6.3-1 .6-6.7 3.4 6 6.4-1.2-4.3 4.7 3.3 6"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M250.1 248s55-12 82.4 39.3c10.3 26.7 11 49.4-1.7 71.1-6.8 9-15 16.5-23.5 23.8.8-4 1.1-7.6.1-11.2-1.6-6.6-6.6-10.5-12.8-13.5a53.1 53.1 0 0 1-19.8-15 36.6 36.6 0 0 1-7.7-35.8c2.4-8 7.7-14 9.5-22.4a28 28 0 0 0-3.1-20c-9.3-13.2-14.1-12.5-23.4-16.3z"
      />
      <path
        fill="#ba0000"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.1}
        d="M306.5 310.1l.2.2"
      />
      <path
        fill="none"
        stroke="#ba0000"
        strokeWidth={2.1}
        d="M259 249c26.6 2.9 51.1 40.2 47.4 61.3"
      />
      <path
        fill="#ba0000"
        fillRule="evenodd"
        d="M302.1 325.6l-5.9-2.6 6.5-1.5.8-6.7 3.1 5.7 6.5-1.5-4.5 5 3 5.7-5.8-2.6-4.5 5.1"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M248.9 253.7s26.9 49.4-14.5 90c-22.8 17.4-44.4 24.5-68.8 18.4-10.5-4-20-9.7-29.5-15.9 4-.3 7.7-1 10.9-3 5.8-3.4 8.1-9.3 9.3-16a53 53 0 0 1 8.8-23.3 36.6 36.6 0 0 1 32.2-17.5c8.4.1 15.6 3.6 24.2 3 6.9-.9 12.3-2.8 18.4-8.8 10-12.5 8-17 9-27z"
      />
      <path
        fill="#ba0000"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.1}
        d="M205.1 325.3l-.1.2"
      />
      <path
        fill="none"
        stroke="#ba0000"
        strokeWidth={2.1}
        d="M250.3 262.4c4.9 26.4-24.1 60.5-45.4 62.7"
      />
      <path
        fill="#ba0000"
        fillRule="evenodd"
        d="M189 325.4l.9-6.4 3.3 5.7 6.6-1-4.6 4.6 3.3 5.7-6.1-2.9-4.6 4.6.8-6.4-6.1-2.9"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M242.8 252.6S205.2 294.4 153 269c-24-15.7-37.8-33.8-40.1-58.8.3-11.3 2.4-22.1 5.1-33 1.7 3.6 3.6 6.8 6.5 9.2 5.1 4.3 11.5 4.5 18.3 3.4a52 52 0 0 1 24.7.6 36.6 36.6 0 0 1 27.3 24.6c2.7 7.9 1.8 15.9 5.3 23.8 3 6.2 6.6 10.6 14.3 14.4 15.2 5.3 18.7 1.9 28.4-.5z"
      />
      <path
        fill="#ba0000"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.1}
        d="M160.7 235.2l-.2-.1"
      />
      <path
        fill="none"
        stroke="#ba0000"
        strokeWidth={2.1}
        d="M235 256.9c-23.2 13.3-65-2.7-74.2-22"
      />
      <path
        fill="#ba0000"
        fillRule="evenodd"
        d="M155.3 220l6.3-1.3-4.3 5 3.1 5.9-5.8-2.8-4.3 5 .7-6.8-5.9-2.8 6.3-1.3.7-6.8"
      />
    </g>
  </svg>
	),
	HN: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#0073cf" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M0 160h640v160H0z" />
    <g
      id="prefix__c"
      fill="#0073cf"
      transform="translate(320 240) scale(26.66665)"
    >
      <g id="prefix__b">
        <path id="prefix__a" d="M-.3 0l.5.1L0-1z" />
        <use
          width="100%"
          height="100%"
          transform="scale(-1 1)"
          xlinkHref="#prefix__a"
        />
      </g>
      <use
        width="100%"
        height="100%"
        transform="rotate(72)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(-72)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(144)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(-144)"
        xlinkHref="#prefix__b"
      />
    </g>
    <use
      width="100%"
      height="100%"
      transform="translate(133.3 -42.7)"
      xlinkHref="#prefix__c"
    />
    <use
      width="100%"
      height="100%"
      transform="translate(133.3 37.3)"
      xlinkHref="#prefix__c"
    />
    <use
      width="100%"
      height="100%"
      transform="translate(-133.3 -42.7)"
      xlinkHref="#prefix__c"
    />
    <use
      width="100%"
      height="100%"
      transform="translate(-133.3 37.3)"
      xlinkHref="#prefix__c"
    />
  </svg>
	),
	HR: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#171796" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M0 0h640v320H0z" />
    <path
      fill="red"
      d="M0 0h640v160H0zm320 364.1c51.3 0 93.3-42 93.3-93.3V160H226.7v110.8c0 51.4 42 93.4 93.3 93.4z"
    />
    <path
      fill="#fff"
      d="M320 362.6a91.8 91.8 0 0 0 91.6-91.5V161.8H228.5V271a91.8 91.8 0 0 0 91.5 91.5z"
    />
    <g fill="red">
      <path d="M267.1 165.2H232v38.7h35.2zm0 77.4h35.3v-38.7H267zM232 270.9c0 3.5.2 7 .6 10.4h34.6v-38.7H232v28.3zm105.7-28.3h-35.2v38.7h35.2zm0 77.4h35.2v-38.7h-35.2zm35.2 21.2A89.2 89.2 0 0 0 393 320h-20v21.2zM267.1 320h35.3v-38.7H267zm-20.1 0a89.2 89.2 0 0 0 20.1 21.2V320H247zm79.1 38.7c4-.3 7.7-.8 11.5-1.6V320h-35.2v37.1a87 87 0 0 0 11.4 1.6c4.1.3 8.2.2 12.3 0z" />
      <path d="M407.4 281.3c.4-3.4.6-6.9.6-10.4v-28.3h-35.2v38.7h34.6zm-69.8-38.7h35.2v-38.7h-35.2zm0-77.4h-35.2v38.7h35.2zm70.4 38.7v-38.7h-35.2v38.7z" />
    </g>
    <path
      fill="#fff"
      d="M410 158.8l21.8-49.5-16.6-26.8-27.6 10.2-19.4-22.2-25.4 14.7L320 66.5l-22.7 18.6-25.5-14.6-19.4 22.2-27.6-10.3-16.6 27 21.8 49.4a217.8 217.8 0 0 1 90-19.3c32 0 62.5 6.9 90 19.3z"
    />
    <path
      fill="#0093dd"
      d="M253 94.8l-27.4-10-15.3 24.7 5.9 13.3 14.8 33.7a219.7 219.7 0 0 1 34.6-12L253 94.8z"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.3}
      d="M251.4 119.3a13.3 13.3 0 0 1 1.6 6.2c0 7.3-6 13.3-13.4 13.3a13.4 13.4 0 0 1-13.1-10.8 13.4 13.4 0 0 0 11.7 6.9 13.4 13.4 0 0 0 13.2-15.6z"
    />
    <path d="M227.6 114l1-4.9-3.8-3.2-.1-.1.2-.1 4.6-1.6 1-4.8v-.2l.2.1 3.7 3.2 4.6-1.6h.2v.2l-1 4.8 3.7 3.2.2.2h-.3l-4.6 1.6-1 4.8v.2l-.1-.1-3.7-3.2-4.6 1.6h-.3z" />
    <path
      fill="#f7db17"
      d="M233.6 107.6l3.5 3 4.3-1.5zm0-.2l7.8 1.6-3.4-3zm-8.3-1.6l7.8 1.5-3.5-3zm7.8 1.7l-7.8-1.5 3.4 3zm.4-.3l5.2-6-4.3 1.5zm-5.6 6.4l5.2-6-4.3 1.5zm5.3-5.9l-5.2 6 4.3-1.5zm5.6-6.4l-5.2 6 4.3-1.5zm-5.6 6l-2.6-7.6-.9 4.5zm2.7 8l-2.5-7.5-.9 4.5zm-2.4-7.6l2.6 7.5.9-4.5zm-2.7-8l2.5 7.5 1-4.5z"
    />
    <path
      fill="#171796"
      d="M297.5 87.4L272.1 73 253 94.9l12.6 49.6a219.8 219.8 0 0 1 36.1-6l-4.2-51.1z"
    />
    <path
      fill="red"
      d="M262.5 132.2a232.3 232.3 0 0 1 38.2-6.4l-1-12.9a245.6 245.6 0 0 0-40.4 6.7l3.2 12.6zm-6.3-25a258 258 0 0 1 42.4-7l-1.1-12.7a270.7 270.7 0 0 0-44.5 7.4l3.2 12.3z"
    />
    <g transform="translate(-160) scale(.00237)">
      <path
        fill="#0093dd"
        d="M212105 36890l-23 13-9517-7794-9497 7778 1788 21560c2543-210 5113-322 7709-322 2608 0 5190 113 7744 325l1795-21560z"
      />
      <g id="prefix__a">
        <path d="M202545 46585c-18-2-44 10-69 45-186 250-359 469-545 720-195 61-242 180-167 348-261-26-291 193-302 432-250-379-522-482-814-307-11-230-187-338-439-392-180-10-319-65-436-145-60-42-110-64-170-106-126-88-226-5-172 74 267 434 535 868 802 1302-14 80 6 151 88 204 47 133 93 265 140 397-11 38-21 75-32 113-221-105-443-118-664-133-170-8-287-50-361-137-54-63-91-26-92 82-3 534 162 1014 599 1492-231 4-462 11-694 21-79 6-95 39-73 104 126 304 339 579 822 766-208 112-327 285-357 520-9 224-75 382-212 455-60 32-81 65-24 106 253 185 565 193 895 112-157 270-226 553-198 850 208 56 412 15 614-52-29 61-44 175-52 309-7 115-41 229-104 343-32 33-65 84 4 102 336 91 648 52 915-47 0 243 2 487 76 727 18 58 70 102 125 26 155-214 322-396 527-517 31 90 75 168 156 215 96 55 147 170 153 343 0 30-2 60 35 90 149 7 514-380 589-597 206 121 284 246 439 461 55 76 99 29 128-25 62-243 67-481 66-724 267 99 579 138 915 47 69-19 36-70 4-102-62-114-105-250-113-365-9-133-14-226-43-287 202 68 405 108 614 52 29-297-53-579-211-850 330 80 655 73 908-112 57-41 35-74-24-106-136-73-203-231-212-455-30-235-149-409-357-520 483-187 696-463 822-766 22-66 6-99-73-104-231-10-480-24-711-27 437-478 606-961 604-1495-1-108-38-146-92-82-74 87-179 137-348 146-222 15-435 24-656 128-11-38-21-75-32-113 46-132 106-260 153-393 82-53 102-123 88-204 267-434 513-868 781-1302 54-79-46-162-171-74-60 42-110 64-170 106-117 80-257 134-437 145-251 54-417 167-428 397-293-175-564-73-814 307-11-239-41-457-302-432 75-168 17-291-178-352-186-250-458-470-644-720-31-35-51-47-69-45z" />
        <g fill="#f7db17">
          <path d="M205075 47978c-51-26-124 17-162 95s-33 170 19 196c40 20 84-6 119-56l22-36c2-3 4-6 5-9 38-78 49-163-2-188zm-5008 0c52-26 124 17 162 95s39 165-13 191-103-24-141-102-60-158-9-184zm4539 905c-32 0-59 27-59 59s26 59 59 59 59-26 59-59c0-32-26-59-59-59zm-4032 0a59.1 59.1 0 1 0 .2 118.2 59.1 59.1 0 0 0-.2-118.2zm4294-304c-754-91-1506-133-2260-133s-1509 41-2269 115c-26 8-21 90 14 86 756-73 1507-113 2256-113 743 0 1485 40 2228 129 39 4 54-80 32-84z" />
          <path d="M200319 48495c768-75 1530-117 2289-116 754 0 1507 42 2261 133l111-184c-32 10-62 9-90-5-76-38-92-161-36-274 56-114 164-175 240-138 39 19 62 62 68 114l446-739c-204 130-328 214-581 252-281 41-409 139-368 307 38 156-57 133-201 54-314-171-541 71-652 353-73 186-159 181-168-13-4-70 0-131-7-200-21-223-89-286-216-224-161 78-175 25-137-58 28-60 86-128 66-221-9-67-66-92-151-98-182-244-467-483-649-727-182 244-374 483-556 727-86 5-142 30-152 98-20 93 52 157 80 217 38 82 23 135-137 57-127-61-186-3-207 220-7 69-10 139-13 209-9 194-95 199-168 13-111-282-352-524-667-353-145 79-203 102-182-54 23-172-107-266-388-307-253-37-377-122-581-252l419 682c12-25 29-45 53-57 76-38 184 24 240 138 56 113 40 237-36 274-10 5-21 8-32 10l100 163zm4389 911c-7 3-7 4-24 11-46 19-80 66-134 124-57 60-128 125-211 188-12 10-25 19-44-6s-7-35 6-44c80-62 149-124 204-182 30-32 56-63 77-92-95-11-190-21-284-30-79 24-157 55-222 95-59 35-107 77-137 125-8 14-16 27-44 11-27-16-19-30-11-44 35-58 91-107 158-147 33-20 69-38 106-54-107-9-214-18-321-25-22 13-42 29-61 47-20 19-39 42-56 67-9 13-18 26-44 8s-18-31-8-44c19-29 41-54 64-77l9-9c-80-5-161-10-241-14-2 2-5 5-8 7a340.4 340.4 0 0 0-93 126c-6 15-12 29-41 18-29-12-23-26-17-41 12-29 27-55 45-81 8-11 18-22 27-33-115-5-230-9-344-12-4 5-9 8-14 11-25 15-47 32-66 51s-35 40-48 63c-8 14-16 28-43 12-28-16-20-29-12-43 16-28 35-54 59-77 7-7 14-13 21-19-122-2-244-4-365-4-120 0-240 1-360 3 8 7 15 13 22 20 23 23 42 49 59 77 8 14 16 27-12 43s-35 2-44-12c-13-23-29-44-48-63s-41-36-66-51c-6-3-12-7-15-12-115 2-230 6-345 11 11 11 20 23 29 35 19 25 33 52 45 81 6 15 12 29-17 41s-35-3-41-18c-9-24-22-46-38-67-15-21-34-41-55-59-4-3-7-6-10-10-81 4-162 8-243 13 4 4 9 8 13 12 24 23 45 48 64 77 9 13 18 26-8 44s-35 5-44-8c-18-26-36-48-56-67s-41-35-64-49c-1-1-3-2-5-3-110 7-220 14-330 23 43 18 85 38 122 61 67 40 124 89 158 147 8 14 16 27-11 44-27 16-35 3-44-11-29-48-78-90-137-125-72-44-159-77-246-102h-2c-90 7-179 15-268 24 22 33 51 68 86 106 55 58 124 120 204 182 13 9 25 19 6 44s-32 15-44 6c-83-64-155-128-211-188-37-38-99-111-135-140-196-90-354-127-575-147-153-14-318-9-458-79 36 85 75 164 126 229 53 68 120 121 209 147 8 2 21 16 22 25 28 157 84 286 169 386 52 60 114 110 188 149-75-81-132-166-172-251-67-142-90-286-77-420 1-16 3-32 34-29 32 3 30 19 29 35-11 123 9 256 72 387 56 118 159 237 291 346 24 19 0 63-29 55-154-44-290-123-383-231-89-104-149-237-180-397-94-32-165-90-222-164-47-60-85-131-118-205 28 428 182 801 456 1137 61 75 165 182 255 216 92 35 95 100-20 101-34 1-69 1-105 1 84 31 164 66 233 105 127 73 217 162 224 273 1 16 2 32-29 34-32 2-33-14-34-29-6-86-82-160-192-223-113-65-259-117-402-160-154 0-312-1-459 3 39 28 80 57 131 84 82 44 188 86 343 122 89 21 166 52 233 91 71 42 130 93 177 150 10 12 20 25-5 45s-34 8-45-5c-42-52-95-98-159-135-61-36-133-64-216-84-161-38-272-81-358-128-75-40-131-82-184-123 180 393 450 573 835 689 23 7 43 13 61 19 3 1 6 1 9 2 86 21 175 40 266 55 92 15 166 28 261 37 16 1 32 3 29 34-3 32-19 30-34 29-99-9-174-22-266-38-58-10-115-21-171-33-26 6-64 9-107 12-232 14-420 225-435 494 0 5 0 11-1 16 88-80 179-157 273-212 117-68 239-103 364-69 15 4 31 8 22 39-8 31-23 27-39 22-106-28-212 3-316 63-108 63-213 158-315 253-24 147-82 285-205 377 61 34 104 65 163 45 86-39 172-78 261-108 91-31 184-52 282-57 16-1 32-1 33 31s-14 32-31 33c-91 4-179 24-264 53-75 26-149 58-222 91 221 47 460-1 667-79 60-22 105-42 133-41 51-30 112-53 172-79 66-28 132-51 182-57 16-2 32-4 35 28 4 32-12 33-28 35-112 13-127 21-222 79 0 21-66 57-126 96-36 24-70 52-87 67-95 86-144 181-188 287-29 70-52 145-68 224 55-108 121-211 201-303 94-108 208-201 345-265 14-7 29-13 42 15 13 29-1 35-15 42-129 60-236 147-324 250-90 103-161 222-219 345-31 64-8 1-42 86 110-122 212-224 323-307 132-100 283-157 418-133 15 3 31 6 26 37s-21 28-37 26c-116-21-250 32-369 121-121 92-244 223-366 361 184 26 366-26 542-85 91-30 183-135 239-152 19-24 38-46 57-67 33-37 67-71 102-100 12-10 24-20 45 4s8 34-4 45c-33 28-65 60-96 94-32 35-62 73-92 113-6 8-13 17-24 16-60 70-151 162-172 240-57 210-25 370-122 576 71-38 128-81 175-134 53-60 94-135 128-230 37-104 95-195 167-270 75-77 165-136 261-172 15-5 30-11 41 19s-4 35-19 41c-87 32-169 86-238 157-66 68-119 151-153 247-37 102-81 183-141 250-44 50-95 91-156 127 52-3 78-10 121-7 79-6 211-66 279-119 66-51 116-120 154-206 6-15 13-29 42-16s23 27 16 42c-42 96-99 174-173 231-56 43-121 75-196 93 161-5 311-42 467-100 65-24 87-168 127-208 32-58 66-112 105-158 47-56 101-101 164-127 15-6 29-12 41 18 12 29-3 35-17 41-52 21-98 60-139 108-36 42-68 93-98 147 10 73-51 228-53 305-7 205-2 409 53 612 53-71 107-134 162-192 0-5 0-10 1-15 18-106 33-219 40-332 7-112 7-223-6-329-2-16-4-32 27-35 32-4 34 12 35 28 14 111 14 226 7 340-6 90-16 180-30 269 54-51 53-51 77-103 37-80 59-159 67-237 9-80 5-157-13-230-4-15-7-31 24-38s35 8 38 24c19 80 25 165 14 252-8 65-24 132-49 199 56-42 114-82 178-122-4-75-5-153-3-227 2-68 7-134 18-190 4-20 7-40 47-33s37 27 33 48c-9 50-14 111-16 177-2 78 0 162 4 243 5 82 49 185 125 230 103 62 158 163 186 274 16-145 17-280 3-400-17-143-55-267-114-368-8-14-16-27 12-44 27-16 35-2 43 12 63 110 104 241 122 393 17 146 13 310-13 488 102-82 381-258 352-594-7-27-16-52-28-75-7-14-14-28 14-42s35 0 42 14c17 33 30 69 39 110 5 24 8 49 11 76 13-7 45-43 51-39 24 16 58 38 80 54-21-60-35-120-42-178-10-87-5-172 14-252 4-15 7-31 38-24s27 23 24 38c-18 73-22 151-13 230 9 77 31 157 67 237 4 8 8 16 5 25 24 21 47 42 70 65-13-84-22-170-28-255-8-115-7-230 7-341 2-16 4-32 35-28s29 20 27 35c-13 106-13 217-6 329 7 113 22 225 40 332 1 2 1 5 1 7 54 59 95 120 152 196 55-203 73-407 66-612-2-76-69-227-65-302-30-55-63-107-100-151-41-49-87-87-139-108-15-6-29-12-18-41 12-29 27-24 41-18 62 26 117 71 164 127 38 45 72 98 103 154 57 7 78 179 143 212 154 57 298 94 453 100-75-19-140-50-195-93-74-57-131-135-173-231-6-15-13-29 16-42s35 2 42 16c38 86 88 156 154 206 85 66 289 124 400 127-61-37-113-78-157-128-59-67-104-148-141-250-34-95-87-179-153-247a642 642 0 0 0-238-157c-15-6-29-11-19-41 11-29 26-24 41-19 96 36 186 94 261 172 72 74 130 166 167 270 34 95 75 169 128 230 47 54 105 98 177 135-98-207-66-367-122-577-35-129-232-277-193-320 45-51 133 88 248 127 175 59 357 111 540 85-122-138-244-269-366-361-119-90-237-140-352-120-16 3-31 6-37-26-5-31 10-34 26-37 135-24 269 32 401 132 111 84 201 175 311 298-18-47 0-14-30-77-59-123-130-241-220-345-89-102-196-189-324-250-14-7-28-13-15-42 13-28 28-22 42-15 137 65 251 157 345 265 81 93 147 198 203 307-15-81-39-157-68-227-44-106-93-201-188-287-62-56-209-140-208-179-29-15-33-11-63-24-61-26-121-46-164-52-16-2-32-4-28-35 4-32 19-30 35-28 50 6 115 28 182 56 33 14 66 43 98 60 53 4 139 47 208 74 206 78 446 126 666 79-73-33-147-65-223-91-85-29-172-49-264-53-16-1-32-1-31-33s17-31 33-31c98 4 191 26 282 57 89 30 175 69 261 108 59 27 101-7 163-45-123-92-181-230-205-376l-2-2c-102-95-207-190-315-253-104-60-210-91-316-63-15 4-31 8-39-22-8-31 7-35 22-39 125-33 247 1 364 69 94 55 186 132 274 213 0-6-1-11-1-17-15-270-203-480-435-494-78-5-189 21-186-32 4-59 97-44 234-86 385-116 655-296 836-690-54 41-110 83-186 124-86 47-198 91-358 128-82 19-154 48-216 84-64 38-117 84-159 135-10 12-20 25-45 5s-14-32-5-45c47-57 106-108 177-150 67-39 145-70 233-91 155-36 261-78 343-122 51-27 92-55 131-84-148-4-305-3-459-3-143 44-289 96-402 160-110 63-186 136-192 223-1 16-2 32-34 29-32-2-31-18-29-34 8-111 97-200 224-273 69-39 149-74 233-105-35 0-70 0-104-1-116-2-112-66-20-101 90-34 190-141 251-216 271-334 412-714 456-1130-33 72-69 140-115 198-57 73-128 131-222 164-31 160-91 293-180 397-92 108-216 185-369 230-29 8-52-35-29-55 132-109 221-226 278-344 62-131 83-264 72-387-1-16-3-32 29-35 31-3 33 13 34 29 12 134-10 278-78 420-40 85-97 170-172 251 73-39 136-89 187-149 85-100 141-229 170-386 1-8 14-22 22-25 89-27 155-79 209-147 51-65 90-143 126-228-140 69-304 64-457 78-213 19-369 68-554 152z" />
          <path d="M204649 49231c-680-88-1359-113-2041-114-684 0-1369 40-2058 112-20 6-15 33-14 46 2 28 37 35 121 27 643-60 1285-93 1932-93 674 0 1351 21 2038 102 33 9 77-85 22-81z" />
          <path
            fillRule="evenodd"
            d="M200570 49160c683-71 1362-110 2038-110 675 0 1349 40 2025 127l31-127c-17 9-37 15-58 15a123 123 0 1 1 113-171l60-170c-724-84-1446-122-2171-122-729 0-1459 38-2193 107l58 164c22-32 59-54 101-54a123 123 0 1 1 0 246c-12 0-25-2-36-6l33 94-2 7zm3067-416a123 123 0 1 0 0 246 123 123 0 1 0 0-246zm0 64a59.1 59.1 0 0 0 0 118c32 0 59-27 59-59s-26-59-59-59zm-1082-91a123 123 0 1 0 123 123c0-68-55-123-123-123zm0 64a59.1 59.1 0 1 0 .2 118.2 59.1 59.1 0 0 0-.2-118.2zm-1064-40a123 123 0 1 0-.2 245.8 123 123 0 0 0 .2-245.8zm0 64c-33 0-59 26-59 59s26 59 59 59a59.1 59.1 0 0 0 0-118z"
          />
        </g>
        <path d="M202601 47974c-14-68-49-129-100-175-51-47-116-78-187-88-33-4-39-58-7-68 60-20 114-67 157-133 45-69 79-157 95-256 5-34 64-35 69-1 15 84 51 153 97 208 55 66 125 112 193 138 31 12 25 63-8 68-59 9-105 42-141 87-50 62-81 145-100 221-8 33-62 31-69-2zm33-118c20-52 47-103 81-146 28-34 60-64 99-84-51-30-100-70-143-120-28-34-53-73-73-116-19 59-45 112-75 158-31 47-67 86-108 116 50 19 95 47 134 82 34 31 63 68 85 110zm799 5115l-515 206c-17 7-35 14-48-21-14-34 4-41 21-48l515-206c17-7 35-14 48 21 14 34-4 41-21 48zm59-326l-604 328c-16 9-33 18-51-15s-1-42 15-51l604-328c16-9 33-18 51 15s1 42-15 51zm-1826-65l604 328c16 9 33 18 15 51s-34 24-51 15l-604-328c-16-9-33-18-15-51s34-24 51-15zm51 322l515 206c18 7 35 14 21 48-14 35-31 28-49 21l-515-206c-17-7-34-14-21-48 14-35 31-28 48-21zm224 434c137 33 261 48 358 31 88-16 155-60 191-146v-493c-107-1-212-15-303-41-109-31-170-98-201-178-41-107-27-235-4-329 5-18 9-36 45-27s32 27 27 45c-20 82-33 194 1 284 23 60 69 110 152 133 91 25 198 38 307 38 107 0 214-13 304-40 82-24 148-69 192-123s65-117 57-176c-5-36-24-62-49-80-34-24-82-35-128-37-47-2-94 7-142 16-25 5-50 9-77 13-19 2-37 5-42-32s14-40 32-42c23-3 48-8 73-12 52-10 105-20 159-18 60 2 121 18 168 51 42 29 72 72 80 131 11 80-16 163-73 233-53 65-131 119-229 147-83 24-178 38-274 42v483c3 5 3 11 2 16 37 82 102 125 188 141 97 18 221 2 358-31 18-5 36-9 45 27 8 37-9 41-28 45-146 35-279 51-388 32-92-17-165-58-215-132-49 74-124 115-215 132-109 20-242 4-388-32-18-4-37-8-28-45 8-36 27-32 45-27zm356 210l402-9c19 0 38-1 38 37 1 38-18 38-37 38l-402 9c-19 0-37 1-38-37s18-38 37-38zm593-3082c151-125 293-227 423-297 133-72 254-111 359-106 19 1 37 1 36 39-1 37-20 37-39 36-92-4-200 32-322 97-125 67-263 166-410 289-14 12-29 24-53-5s-9-41 5-53zm-605 56c-141-130-298-240-445-314-139-71-268-108-363-100-19 2-37 4-40-34-4-37 15-39 34-40 110-10 252 31 404 107 152 77 315 191 461 325 14 13 28 25 2 53-25 27-39 15-53 2zm-213 1004c37-83 83-155 136-219 53-63 112-119 174-170 14-12 29-24 52 5 24 29 9 41-5 53-59 48-114 101-164 160-49 59-91 125-125 201-8 17-15 34-49 19s-27-32-19-49zm371-1734c49 66 88 139 114 223 26 82 40 175 39 279 5 80 6 165-7 249-13 86-42 170-97 246-43 60-101 97-165 113-53 13-109 10-164-7 29 100 51 208 6 308-8 18-33 27-51 18-43-22-86-43-128-62s-84-36-127-51l-1-1c-95-37-173-73-236-112-65-39-115-80-150-124l1 2c-44-49-72-106-88-170-14-55-20-114-22-174-72-39-138-78-194-116-64-43-118-87-161-131-13-14-26-27 1-53s40-12 53 1c39 40 89 80 150 121 60 40 128 81 204 121 124 13 247 51 370 109 106 50 211 115 317 192 13 7 19 16 27 20 8 6 16 13 25 19 51 22 104 28 152 16 47-11 90-39 122-84 48-66 72-139 84-214 12-77 11-157 6-234v-2c1-97-12-183-35-258-24-76-58-142-102-201-11-15-22-30 7-52s41-7 52 7zm-375 1047c-104-77-207-141-311-190-105-49-210-83-314-98 2 48 8 93 18 135 13 52 35 99 71 138l1 1c30 37 73 72 130 107 60 36 134 71 225 106l-1-1c45 16 89 34 133 54 31 14 61 28 93 44 19-83-10-179-37-267-2-8-5-15-9-29zm776-1003c-44 59-79 125-102 201-24 76-36 161-35 258v2c-5 77-6 158 6 234 12 75 37 148 84 214 32 45 75 72 122 84 48 12 101 6 152-16l25-19c6-4 13-12 27-20 105-77 211-143 317-192 123-58 246-95 370-109 75-40 144-80 204-121s111-81 149-121c13-13 26-27 53-1s14 39 0 53c-43 44-97 88-161 131-57 38-122 77-194 116-2 61-8 119-22 174-16 63-44 121-88 170l1-2c-35 44-85 85-150 124-63 38-141 75-237 112l-1 1c-43 15-85 32-127 51-43 19-85 40-128 62-18 9-43 0-51-18-45-100-23-208 6-308-55 18-111 20-164 7-64-15-122-53-165-113-55-76-84-160-97-246-13-85-12-169-7-249-1-104 13-196 39-279 26-84 65-158 114-223 11-15 22-30 52-7 30 22 19 37 7 52zm940 715c-105 15-209 49-314 98-104 49-207 113-311 190-4 13-6 21-8 29-27 88-56 184-37 267 31-15 62-30 93-44 44-20 87-38 133-54l-1 1c91-35 165-70 225-106 58-34 100-70 131-107l1-1c35-39 57-86 71-138 11-42 16-87 19-135z" />
        <path
          fillRule="evenodd"
          d="M203459 50602a216.4 216.4 0 0 0 0 433 216.6 216.6 0 0 0 0-433zm0 69c-81 0-147 66-147 147s66 147 147 147 147-66 147-147-66-147-147-147zm0 60a87 87 0 1 0 .1 174.1 87 87 0 0 0-.1-174.1zm-1697-124c119 0 217 97 217 216s-97 217-217 217a216.6 216.6 0 0 1 0-433zm0 69c81 0 147 66 147 147s-66 147-147 147-147-66-147-147 66-147 147-147zm0 60a87 87 0 1 1-.1 174.1 87 87 0 0 1 .1-174.1z"
        />
      </g>
      <use
        width="100%"
        height="100%"
        transform="rotate(-2.2 -55532.8 156275.8)"
        xlinkHref="#prefix__a"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(2.2 459865.8 156275.8)"
        xlinkHref="#prefix__a"
      />
    </g>
    <path
      fill="#171796"
      d="M387.2 94.9l-19.3-22-25.2 14.5-4.3 51.1a219.7 219.7 0 0 1 36.2 6L387.2 95z"
    />
    <path d="M347.7 98c.8-.2 1.7-.2 2.6.3.3.1.6.3.8.6.4-.3.7-.6 1.2-.8a4 4 0 0 1 1.8-1c.9-.5 1.8-.8 2.7-.9h2.8c.8 0 1.6.2 2.3.6l2 1c.8.4 1.5.8 2.2 1a9.1 9.1 0 0 0 4.5.5c.4-.2.7.1.2.4-3.3 2-5.9.2-8.1-.6a16.2 16.2 0 0 1 2.1 1.7c.8.8 1.8 1.6 3.5 2.4a8.4 8.4 0 0 0 5 .7l.4.1-.1.5a4.8 4.8 0 0 1-2.6.7 10 10 0 0 1-5.2-1.3c-1.4-.7-2.3-1.6-3.3-2.4a7.5 7.5 0 0 0-3-1.4 6 6 0 0 0-2.9 0c.3.1.5.2.6.4.5.3 1 .4 2 .5.4 0 .2.3-.5.7a2 2 0 0 1-1.6.8c-1 .6-1.3.2-1.7-.2 0 .3 0 .5-.2.8a.6.6 0 0 1 0 .4l.2.7c0 .2 0 .3.2.4.2.2.3.4.3.7 0 .2.1.3.3.4l.6.6c.6.2.8.7 1 1.2.4.2.6.5.7.9.2 0 .4.2.6.4l2.6.1c.8.1 1.4.6 2 1.2h1.2a4 4 0 0 1 1.3-.3h2.3c.5.2.9.4 1.2.8.5.5 1.2.4 1.8.2a2.7 2.7 0 0 1 2.4 0 2.3 2.3 0 0 1 1-.2c.4-.3.7-.4 1-.4.6 0 1 0 .9.8 0 .2-.2.4-.3.4-.3.6-.7.7-1.3.7-.1.4-.3.7-.5.8.3.9 0 1.3-.7 1.2 0 .3-.3.4-.6.4a1.4 1.4 0 0 1-1 .5l.4.6c.4.7-.2 1-.8 1v1.2c.7.4.8.8.2 1.2.4.7.3 1.3-.5 1.6 0 .4 0 .8-.3 1-.2.2-.5.3-.3.6.3.5.2 1.1-.2 1.2l-.2.1-.2.2a9.6 9.6 0 0 0-1.5 1c-.1 0-.2.1-.2 0a9.6 9.6 0 0 1-1.8 2.4c0 .5-.4 1-1 1.1a.4.4 0 0 1-.3.4c.3.3.5.6.2 1a3 3 0 0 1-1.3.8c-1 .3-1.7.2-2-.2-.4-.3-.3-.6 0-.7-.7 0-.8-.2-.8-.7 0-.2.1-.2.3-.1.4 0 .7-.2 1-.3l.5-.6c0-.7.5-1 1.1-1.3.5-.2 1-.6 1.4-1.2l.9-1.5a1.2 1.2 0 0 1-.3-.7 1.5 1.5 0 0 1-.5-.6c-.5 0-.7-.2-.7-.5a1.1 1.1 0 0 1-.3 0c-.3.1-.5.3-.7.2a6.9 6.9 0 0 1-1.1 1c-.2.3-.4.5-.7.5-1 .1-1.5 1.2-2 1.7-.2.1-.3.4-.4.7 0 .6-.1 1-.4 1h-.4a1.2 1.2 0 0 0-.4 0c.3.3.3.6 0 .9-.1.3-.4.4-.8.4a3.6 3.6 0 0 1-1.6-.2c-.4-.2-.5-.5-.5-.7-.3-.2-.4-.3-.3-.5 0-.2.2-.3.4-.2l.6-.2a5.2 5.2 0 0 1 1.8-1.4 3 3 0 0 1 .7-.7c0-.5.5-1 1-1.4l.1-.6v-.3c-.2-.3-.3-.7-.1-1a1.3 1.3 0 0 1 0-.6c-1.1.6-1.5.4-1.6-.1-.4.3-.8.5-1 0-.4.1-.8.3-1.2.1l-.8.2-.4.7c0 .5-.2 1-.5 1.5a9.3 9.3 0 0 1-.7 1.5 1 1 0 0 1-.1.5c0 .6-.2.9-.5 1a2.4 2.4 0 0 1-.4.8v.2c.1.3.1.7-.2 1l-1 .6h-1c-.4-.3-.4-.4-.3-.6a.6.6 0 0 1-.5 0l-.4-.3c-.1-.2-.1-.4.1-.5l.9-.6c0-.2.2-.3.4-.4.2-.4.4-.6.6-.7l.7-1.5c.1-.1.2-.3.1-.4l.1-.3s.2-.1 0-.2a1.4 1.4 0 0 1 .2-1.2c.3-.4.6-1.4.3-2v-.8h-.3c-.2-.2-.4 0-.6.2l-.4.6c-.1.8-.5 1.5-1 1.6v1.2c0 .4 0 .7-.2.7s-.4.2-.5.5a1 1 0 0 0-.1.3c.3.3.2.7-.1 1-.6.6-1.4.5-2.2.3-.6-.3-.8-.5-.7-.8-.8 0-.7-.7 0-.9.8-.2 1.4-.7 1.9-1.4 0-.8.2-1.3.7-1.4 0-.5.2-1 .4-1.4.2-.4.3-.8.2-1.3-.4-.3-.4-.6 0-1 .1 0 .1 0 0-.2-.3 0-.3-.3-.3-.5s0-.2-.2-.2c-.6-.1-.5-.4-.2-.7.1 0 .2-.3 0-.4l-.1-.4c-.4-.3-.2-.6 0-.9l-.4-.8c-.7 0-1-.4-.6-.9a3.4 3.4 0 0 1 .7-.6c.1-.3.3-.6.2-.8-.2-.6.5-1 1-1.4a.9.9 0 0 1-.1-.4c-.3-.3-.2-.6.1-.8a1 1 0 0 1-.1-.5c-.8.2-.8-.3-.4-1-.5-.3-.4-.8.5-1.5a1 1 0 0 1 0-.4 2 2 0 0 0-1 .3c-.3.3-.6.2-.9.1a1.5 1.5 0 0 0-.4-.4.6.6 0 0 1-.2-.6c-1 0-1.1-.7-.6-1 .3-.3.6-.6.7-.9.2-.6.7-1 1.3-1.5v-.5a1.6 1.6 0 0 0-.7-.3 1.2 1.2 0 0 0-.6-.7c-.1 0-.2-.2 0-.4-.6-.4-.5-.7-.3-1z" />
    <g fill="#f7db17">
      <path d="M364.5 122a1.4 1.4 0 0 1-.2 0 8.4 8.4 0 0 1-.8.7c-.2-.3-.5 0-.2.1l-.2.2c0 .3-.2.4-.5.4h-.1a3 3 0 0 1 0-.3 3.5 3.5 0 0 1 0-.4 3.9 3.9 0 0 0-.1.4 2.8 2.8 0 0 0 0 .4c-.8.3-1.3 1.1-1.9 1.7l-.4.8c0 .2 0 .9-.3.9h-.2c0-.1-.2-.1-.4 0h-1c-.2.2.4.2.7.3.1.1.2.3.1.5-.2.7-1.8.5-2.3.2-.2-.1-.2-.3-.2-.5h.3c.2 0 .4 0 .5-.2 0 0 .1 0 0-.1 0-.1 0-.1 0 0a1.3 1.3 0 0 1-.5 0 2.6 2.6 0 0 1-.5 0h-.2c0-.1.2 0 .2 0l.7-.3a5.3 5.3 0 0 1 1.9-1.4l.8-.7c0-.7.4-1 .8-1.5l.3-.7v-.3c-.2-.4-.3-.7-.1-1a1.5 1.5 0 0 1 0-.8.3.3 0 0 0 0-.1 6.2 6.2 0 0 1 .8-.6v.8a1.3 1.3 0 0 0-.2.3.5.5 0 0 0 0 .2v.1a.4.4 0 0 1 0-.3l.3-.2.7-.4.7-.6v1l-.6.7v.1h.1a2.3 2.3 0 0 1 .5-.7 3.2 3.2 0 0 1 1-.6v1a1.5 1.5 0 0 0 .5.9z" />
      <path d="M349 113l.2-.2.4-.6a4 4 0 0 1 .5-.6 4 4 0 0 0-.4.7 5.8 5.8 0 0 0-.4.5v.2c.1.3.1.5.3.7l.3-.4a1.6 1.6 0 0 1 .4-.4 1.8 1.8 0 0 0 .5-.6h.1l-.2.4a2 2 0 0 1-.3.3l-.4.3a1.3 1.3 0 0 0-.2.4v.3c-.2.3-.5.5 0 .7a.6.6 0 0 0 .1.5l-.1.7c-.3.2 0 .2.1.2l.4-.4a4.3 4.3 0 0 1 .3-.4l.4-.5.1-.5h.1a1.4 1.4 0 0 1-.1.6 2 2 0 0 1-.5.5 3.8 3.8 0 0 0-.2.4 2.6 2.6 0 0 0-.3.4c.2.1.2.4.2.7h.1l.2-.2.2-.4h.1l-.2.4-.2.3c.2.1.2.3 0 .5-.4.3-.3.4 0 .7v1.2l.1.3h-.1v-.3c-.4.7-.6 1.1-.7 1.8-.6.1-.5.8-.6 1.3a3.9 3.9 0 0 1-1.9 1.5c-.1 0-.5.1-.5.3 0 .1.2.3.4.2.4-.5.7-.2.2.2v.3c.5.4 1.6.5 2.2.2.3-.3.5-.5.2-.9 0-.5.2-1 .8-1.2v-.4l.1-1.3.2-.1c.2 0 .6-.7.7-1.3v-.4c.1-.2.2-.2.3 0 0-.2 0-.3.2-.4.2-.3.5-.6.8-.4a3 3 0 0 1-.1-.8 2.7 2.7 0 0 1 0-1l.2-.2.3-.7.3-.7h.1l-.3.7-.3.8v.1a2.5 2.5 0 0 0-.1 1l.2.9.2.4v.6c.4.6 0 1.7-.3 2.2a1 1 0 0 0-.1.8c.2.2 0 .4-.1.6v.1c0 .2 0 .4-.2.5l-.7 1.6c-.4.1-.5.3-.6.7-.3.1-.3.2-.4.4a2.7 2.7 0 0 1-.9.6c-.3.1 0 .2.2.4.2.1.4-.2.6-.4.2-.3.3-.2.2 0a2 2 0 0 0-.2.7l.7.3c.4 0 .9-.4 1.2-.6.3-.2.2-.5.1-.8a2 2 0 0 1-.5 0 3.4 3.4 0 0 1-.5-.3 2.8 2.8 0 0 0 1 .2v-.3a2.7 2.7 0 0 0 .5-.8c.4-.2.4-.4.4-.9l.1-.5a10 10 0 0 0 .7-1.6c.4-.4.5-.9.5-1.4 0-.2.1-.3.3-.3a3.8 3.8 0 0 0 .3-.5l.1-.4a.8.8 0 0 1 .2-.2 1 1 0 0 0 0-.5 1.1 1.1 0 0 0-.1-.4.5.5 0 0 1-.1-.2v-.2h.1c.1 0 0 0 0 0v.1a.5.5 0 0 0 0 .2c.2.2.2.3.2.5a1 1 0 0 1 0 .5.7.7 0 0 0-.2.2 1.7 1.7 0 0 0 0 .3l.6-.1.4-.5.2-.6c.1 0 0 0 0 0a2 2 0 0 1-.1.7l-.3.3c.4.2.7 0 1 0V119l.4-.7c.1 0 .1 0 0 0l-.2.8v1c.1.4.2.5.5.3l.4-.2v-.1a18.2 18.2 0 0 1 1.8-1.6c.1.1 0 .1 0 .1a6.5 6.5 0 0 0-.8.7l-.8.7v.3c0 .3.1.5.6.3l.6-.2a1.3 1.3 0 0 1 .3-.2 8 8 0 0 1 .5-.3l.5-.3a3 3 0 0 1 .1-.6l.7-1.3a2.3 2.3 0 0 0 1.1-1.1h.1l-.4.7a2.5 2.5 0 0 1-.7.5l-.7 1.2a2.7 2.7 0 0 0-.1.5v.1a2.8 2.8 0 0 0 0 .8c.2 0 .4 0 .7-.3l.7-.7a1.7 1.7 0 0 1 .2-.5 1 1 0 0 1 .4-.4h.1v.1a.9.9 0 0 0-.4.3 1.7 1.7 0 0 0-.2.5v1.1l1-.5v1c0 .3.2.6.4.8a2.8 2.8 0 0 1 .5-.6l.3-.3.2-.2.3-.2-.2.3-.2.2-.3.2v.5h.6c0 .5 0 .6.5.6a3.2 3.2 0 0 1 0-.5l.1-.5h.1a1.9 1.9 0 0 0-.1.5 3.1 3.1 0 0 0 0 .5c.2.3.3.4.7.6l.2-.5a1.4 1.4 0 0 0 0-.4h.1v.5l-.3.5v.5a3 3 0 0 1 .2-.3l.3-.4c.1 0 .1 0 0 0 0 .2 0 .3-.2.4a4 4 0 0 0-.2.4l.2.2c-.6 1-1.3 2.5-2.5 3-.6.2-.9.5-1 1.2a1 1 0 0 0-.5.6l-1.2.3c0 .3 0 .4.3.4l.7-.3c.1 0 0 .5-.5.8v.1c.4.6 1.4.4 1.9.2.4 0 1-.5 1.2-.9.1-.2 0-.4-.2-.6-.8.1-.6-.6 0-.3.2 0 .3 0 .3-.3.6-.2.9-.5 1-1 .6-.7 1.2-1.4 1.6-2.1.1-.2.2-.4.1-.5a1 1 0 0 0 .2-.5l.1-.4h.1v.5a4.5 4.5 0 0 1-.2.3c0 .1 0 .2.2.2l1.5-1c0-.3.2-.4.4-.4l.2-.1c.1-.4 0-.6-.2-.8-.1-.4.1-.5.4-.7.2-.2.2-.7.2-1v-.2a2.6 2.6 0 0 0 0-.3l.1.3v.1c.3-.1.6-.3.7-.6 0-.3-.1-.6-.3-.8a9.6 9.6 0 0 1-.6.2 10.2 10.2 0 0 0 .7-.4 1.3 1.3 0 0 0 .3-.2c.2-.3-.3-.5-.5-.6l-.7-.7v-.1l.7.6v-1.1l-.2-.4a1.1 1.1 0 0 1-.5-.4 1 1 0 0 1-.1-.5l.2.4.4.4h1c.3-.3-.2-.7-.3-.9l-.1-.5h.1a1 1 0 0 0-.2-.2.6.6 0 0 0-.1 0v-.2a.7.7 0 0 1 .2.1l.2.2a.9.9 0 0 0 .1 0c.3 0 .5-.2.7-.5a3.6 3.6 0 0 0-.3-.4 10 10 0 0 0-.5-.3v-.1h.1a4 4 0 0 1 .8.8c.4 0 .4 0 .6-.3a1.5 1.5 0 0 0-.2-.4 2.5 2.5 0 0 0-.3-.4c0-.1 0 0 0 0 .2 0 .3.2.4.3l.2.5.4-.1c.3-.2 0-.8 0-1a2.8 2.8 0 0 0-.1 0l-.2-.2c0-.1 0 0 0 0h.2l.2.1.4-.6c0-.4 0-.2.5-.3.4 0 .6 0 .9-.6.1 0 .2 0 .2-.3s0-.4-.3-.4c-.5 0-.8 0-1 .3v.3c0 .1 0 0 0 0l-.2-.2c-.4 0-.7 0-1.1.2h-.2l.2.3.1.4a1 1 0 0 0-.2-.4 1.8 1.8 0 0 0-.3-.4 2.6 2.6 0 0 0-1-.2l.2.1.2.2v.1a7.7 7.7 0 0 1-.2-.2 6.5 6.5 0 0 1-.2-.2 2.7 2.7 0 0 0-.9.2l-.6.2.4.5.2.6a2.1 2.1 0 0 0-.3-.6 1.9 1.9 0 0 0-.4-.4 1.8 1.8 0 0 1-.5 0l.2.3-.3-.4a1.4 1.4 0 0 1-.5-.2 8.3 8.3 0 0 1 .2 1.5 7.8 7.8 0 0 0-.2-.9 4.7 4.7 0 0 0-.1-.7 1.7 1.7 0 0 1-.2-.2 2.1 2.1 0 0 0-.6-.4 1 1 0 0 1-.2.7c-.1 0 0 0 0 0a.8.8 0 0 0 .1-.8 3.1 3.1 0 0 0-1-.2 5.3 5.3 0 0 1 .5.8l.3.5v.5a2 2 0 0 0-.1-.5.7.7 0 0 0-.3-.4 5.6 5.6 0 0 0-.3-.5 4.6 4.6 0 0 0-.3-.4h-.4.1a.6.6 0 0 1 0 .3.5.5 0 0 0 0-.2.7.7 0 0 0-.2-.1h-.8a5 5 0 0 1 1 2.3 4.8 4.8 0 0 0-.4-1.2 5.1 5.1 0 0 0-.7-1h-.6a1.7 1.7 0 0 1 .4.4c0 .1 0 .1 0 0a1.6 1.6 0 0 0-.3-.1 2.4 2.4 0 0 0-.3-.2 5 5 0 0 0-.3 0l-.1.1a4.7 4.7 0 0 1 1 1.1c0 .1 0 0 0 0a3.8 3.8 0 0 0-.6-.6 4.7 4.7 0 0 0-.6-.4h-.6a5 5 0 0 1 .5 1.7h-.1a3.5 3.5 0 0 0-.2-.8 6.2 6.2 0 0 0-.3-.9 8 8 0 0 1-.4 0 9.1 9.1 0 0 1 .3 1.6v.1a9.3 9.3 0 0 0-.2-1 9.3 9.3 0 0 0-.3-.8 3.9 3.9 0 0 0-1.3-1 1.7 1.7 0 0 1 .4 1.1v.1a1.6 1.6 0 0 0-.2-.7 1.7 1.7 0 0 0-.4-.6 2 2 0 0 0-.3 0 15.6 15.6 0 0 0-1 0c.2.1.4.4.4.6 0-.2-.3-.5-.6-.7h-.6l.3.3.2.5.2.6.4.4s.1 0 0 0c0 .1 0 .1 0 0a1.1 1.1 0 0 1-.5-.3 1.5 1.5 0 0 1-.2-.7 1.3 1.3 0 0 0-.2-.4 2.7 2.7 0 0 0-.3-.4h-.7l.2.8.1 1h-.1a7.1 7.1 0 0 0 0-1 4.5 4.5 0 0 0-.3-.8 1 1 0 0 0-.6-.5.6.6 0 0 1 0 .3h-.1a.5.5 0 0 0 0-.3c-.2-.5-.3-.7-.6-.8v.4l-.2.4h-.1l.1-.5v-.4c0-.6-.2-1-.8-1.2v.2l-.1.5h-.1v-.5a1.9 1.9 0 0 0 0-.3l-.5-.5a2.3 2.3 0 0 1 0 .7 3 3 0 0 1-.4.8h-.1a3 3 0 0 0 .3-.8 2.2 2.2 0 0 0 .1-.8 1 1 0 0 1-.2-.3v.2h-.1v-.2l.1-.1v-.1a.7.7 0 0 0-.3-.5 1.5 1.5 0 0 1-.2.5h-.1c-.1 0 0 0 0 0l.1-.3.1-.3a1 1 0 0 1-.1-.2.8.8 0 0 1-.1.2 1.2 1.2 0 0 1-.2.2c-.1-.1 0-.1 0-.1l.1-.2a.7.7 0 0 0 .1-.2v-.2c0-.3 0-.4-.2-.7a.9.9 0 0 0-.3 0 2.8 2.8 0 0 0-.5.4v-.1a3.2 3.2 0 0 1 .4-.3.9.9 0 0 1 .4-.1.4.4 0 0 0 0-.2l-1 .3a1.6 1.6 0 0 1-.9-.2h.8c.3 0 .7 0 1.1-.2l.2-.6a1.7 1.7 0 0 1-.5 0l.6-.1v-.2c0-.2.3-.2.4 0 .2 0 .3.2.4.3.3.2.6 0 .9-.2h-.2v-.1h.3c.6 0 1 0 1.4-.5a7 7 0 0 1-1 0c-.2 0-.4 0-.6-.2l.7.1h1l.5-.3a5.4 5.4 0 0 1-2-.6 1.4 1.4 0 0 0-.6-.3c-.5 0-1 0-1.4.3l-.3-.3-.4-.2h-.6s-.1 0 0 0h1.2a4.5 4.5 0 0 1 1.7-.3 5.7 5.7 0 0 1 1.7-.2v-.2c.3-.3.4-.6.3-.9-.1-.2-.4-.5-.8-.7h-1.3a4 4 0 0 0-.8.1l.6.4.4 1v.1h-.2a2 2 0 0 0-.4-1c-.1-.2-.6-.3-.7-.4l-1.3.2-.7.4c.3-.1.6 0 .8 0 .3.2.5.4.6.8v.1h-.2a1 1 0 0 0-.5-.7c-.4-.2-1.2 0-1.6.3a4.2 4.2 0 0 0-.6.6h-.2v-.2l.7-.6.7-.4a2 2 0 0 1 1-.5l1.3-.2a1 1 0 0 0-.5-.5 1.4 1.4 0 0 0-.8 0c-.5.1-1 .4-1.5.7h.5l.1.2h-.5a1.4 1.4 0 0 0-.4 0l-1.5 1.2c-.5 0-.8 0-1 .2l-.1.6-.2.7c-.5.5-1 .9-1.3 1.5a1.4 1.4 0 0 1-.3.5.5.5 0 0 1 .3.1v-.2l.2-.4h.1a1.2 1.2 0 0 0-.1.4v.5h-.2a.3.3 0 0 0-.1-.2.5.5 0 0 0-.3 0l-.3.2-.2.3c0 .3.2.3.5.3.6 0 .1.4.4.7l.5.4h.5c0-.4 0-.6.2-.6a.8.8 0 0 1 .2-.4.8.8 0 0 0 0 .2.8.8 0 0 0-.1.2v.4a2.4 2.4 0 0 1 1-.2c.7-.8 1-.6.4 0l-.1.2a1.4 1.4 0 0 0-.2.6c-.2.1-1 .8-.7 1 .2 0 .4 0 .3.2-.1.2-.4.6-.3.9h.3a6.2 6.2 0 0 0 .7-.6 3.8 3.8 0 0 0 .5-.8h.1a9 9 0 0 1 .3-.8c0-.2.1-.5.3-.7l.3.3a.4.4 0 0 0 .2 0 .4.4 0 0 0 .3 0l.2-.3h.1a1.2 1.2 0 0 1-.3.4.5.5 0 0 1-.3 0 .5.5 0 0 1-.2 0 1.1 1.1 0 0 1-.3-.3 12 12 0 0 0-.5 1.4v.1a5.6 5.6 0 0 1-1.2 1.4l.2.5 1-1 .8-1a6 6 0 0 1-.3.6v1.1h-.1v-.9l-.3.3a11.6 11.6 0 0 1-1 1c-.3.3-.6.3-.2.7l.3-.3.4-.3h.1v.1l-.4.3-.4.3a.6.6 0 0 0 .1.3.5.5 0 0 1 .1 0l.8-.6c.1 0 0 .1 0 .1l-.7.6a.7.7 0 0 1-.1 0c-.3.3-1.2.8-1 1.2l.6-.2.6-.5c.1 0 0 0 0 .1a2.5 2.5 0 0 1-.6.5v.2-.1a3.6 3.6 0 0 1-.7.1c.1.4 0 .7-.3 1 0 .1-1 .9-.6 1a1 1 0 0 0 .3.2z" />
      <path d="M349.4 100.1a2.2 2.2 0 0 0-.6-.3 1.4 1.4 0 0 0-.5-.5c-.2-.2-.2-.1-.1-.3l.2-.1a.9.9 0 0 1 .3 0 .4.4 0 0 1 .2.2h.1c.1 0 0 0 0 0a.5.5 0 0 0-.2-.2 1 1 0 0 0-.4-.1.7.7 0 0 0-.4 0l-.2-.5.4.1.2.1a.7.7 0 0 0-.2-.2 2 2 0 0 0-.2 0 2.9 2.9 0 0 1 2.1.2c.4.1.6.3.8.6l-.2.2c-.5 0-.8 0-1 .2-.2.1-.2.4-.2.6z" />
    </g>
    <path d="M365 121.8l-.4.2c0-.3.2-.4.3-.6v.2l.1.2zm2 4.2a2.3 2.3 0 0 1-.4.4 4 4 0 0 1-.5.4v-.1l.4-.4.4-.4zm1.3-1.6l-.2.3h-.1l.2-.3zm-.7 0a1.1 1.1 0 0 1-.2.3 1 1 0 0 1-.5.4v-.1a1 1 0 0 0 .4-.3 1 1 0 0 0 .1-.4h.1zm1.2-1.6a1 1 0 0 0-.1.2 1.1 1.1 0 0 0-.1.2h-.1a1.1 1.1 0 0 1 .3-.5zm1 0v.5l-.3.5c-.1 0 0 0 0 0l.1-.5.2-.5zm-.4-6c.3.5.4 1 .4 1.5a7.3 7.3 0 0 1 .1-.6 1.4 1.4 0 0 0 .3-1.1c0-.1.1 0 .1 0v.6a1.7 1.7 0 0 1-.3.6l-.2 1h-.1v-.1c0-.6 0-1.2-.4-1.8v-.1zm-.8 1v.3h-.1v-.4h.1zm-.2 1.4a6.2 6.2 0 0 1 .2 1.4 1 1 0 0 1 .1-.1l.3-.3h.1a1 1 0 0 0-.3.3.7.7 0 0 0-.2.4 5 5 0 0 0-.1-.9 5.9 5.9 0 0 0-.2-.8zm1 .5a3.6 3.6 0 0 1 .1 1.2v-.6a3.6 3.6 0 0 0-.1-.6zm1-.2v.6a1.5 1.5 0 0 1 0 .5 1.2 1.2 0 0 0 0 .6l.1.6a2.5 2.5 0 0 1-.3-.6 1.3 1.3 0 0 1 0-.6 1.4 1.4 0 0 0 .2-.5 2.3 2.3 0 0 0 0-.6zm.5-1.5l-.1.3v.2h-.1v-.6h.1zm-.5-2.6v.2c.1 0 .1 0 0 0 0 .1 0 0 0 0v-.2s-.1 0 0 0c0-.1 0 0 0 0zm.2-2v.8a.8.8 0 0 0-.2.3 1.4 1.4 0 0 0 0 .6h-.1a1.4 1.4 0 0 1 0-.6.9.9 0 0 1 .3-.4v-.7zm-2-.7c.4.2.6.4.8.7.2.2.3.5.3.9l-.6-.2v1.8c-.2.5-.5.8-1 1a3.8 3.8 0 0 0 0-1.8h.1a3.6 3.6 0 0 1 0 1.6 1.5 1.5 0 0 0 .7-.8 3.7 3.7 0 0 0 .1-1.9l.6.2c0-.3-.1-.5-.3-.8a2.5 2.5 0 0 0-.7-.6v-.1zm5.2-1v.2h-.1v-.2s0-.1 0 0h.1zm-1.2 0l.3.1a.8.8 0 0 1 .1.2v.1a.8.8 0 0 0-.2-.2.6.6 0 0 0-.2-.2zm-1.8.5l.3.5v.6c-.1 0-.1 0 0 0l-.1-.6a1 1 0 0 0-.3-.5h.1zm-6 .5v.4l-.1.1v-.5zm1-.6l.2.4v.1h-.1v-.1l-.1-.3zm2.4 1.6v.1a1.1 1.1 0 0 1 0 .2.8.8 0 0 0 0-.2.6.6 0 0 0-.1 0v-.1zm.8-1.8v.2a.2.2 0 0 1 0 .2.1.1 0 0 0 0-.2c-.1-.1-.1-.1 0-.1zm-5.5.3a1 1 0 0 0 .2.7c.2.1.2.3.3.4v.4h-.1v-.4a.9.9 0 0 0-.2-.3 1 1 0 0 1-.2-.4 1.1 1.1 0 0 1-.1-.4zm2.2 1.5l.2.7v.7c0 .3 0 .6.2.8l.6.7a2.9 2.9 0 0 1-.1-1l.3-1c.2 0 .2-.2.3-.3v-.4h.1v.4a1.5 1.5 0 0 1-.3.5 1.6 1.6 0 0 0-.3.9c0 .3 0 .6.2 1h-.1c-.4-.2-.6-.5-.8-.8a1.3 1.3 0 0 1-.2-.8v-.7a1.8 1.8 0 0 0-.2-.6c0-.1.1 0 .1 0zm-.9 1.4c0 .2 0 .5-.2.7a3.4 3.4 0 0 1-.4.6h.3a2.2 2.2 0 0 0 .7-.6l.3-.3c.1 0 0 0 0 0a3.6 3.6 0 0 1-.2.4 2.5 2.5 0 0 1-.3.2 24.5 24.5 0 0 1 0 .4v-.2a1.5 1.5 0 0 0-.1-.1 2.2 2.2 0 0 1-.4.2l-.4.2v-.1l.4-.7.2-.7h.1zm-1 0v.1h-.1c-.1 0 0 0 0 0v-.2z" />
    <path d="M363 113.7c.2.3.2.6.2 1a1.9 1.9 0 0 1-.4.8 1.9 1.9 0 0 0-.5.6 2.6 2.6 0 0 0-.2.6l.2-.3.5-.3a4.6 4.6 0 0 0 1.1-.9h.1c.1 0 0 0 0 0a4 4 0 0 1-1.2 1 1 1 0 0 0-.4.3 2.3 2.3 0 0 0-.4.5c0-.4 0-.7.2-1l.5-.6.4-.8c0-.3 0-.6-.2-.9h.1zm2.3 3.5l.1.4.1.1c.2.3.3.5.3.8l-.1 1h-.1a1.8 1.8 0 0 0-.4-1 3.4 3.4 0 0 0-.8-.6v-.1c.4.2.7.4.9.7l.3.6a3.4 3.4 0 0 0 0-.6 1.3 1.3 0 0 0-.1-.7l-.1-.2c-.2-.2-.3-.3-.2-.4zm1 0l.1.2c0 .1 0 0 0 0h-.1l-.2-.2h.1zm1 .3l-.2.7-.2.7.2-.7.2-.7zm.7 4v.1a.3.3 0 0 1 0-.2zm-.7-1.2v.3l-.2.4v-.4l.1-.4h.1zm-1 0h.1v.1h-.1v-.1zm-1.1-.6a7.3 7.3 0 0 1-.1.2v.2h-.1a5 5 0 0 1 0-.2 5 5 0 0 1 0-.2h.1c.1 0 0 0 0 0zm-1.7 1.8a.7.7 0 0 0-.1.2 1.3 1.3 0 0 0 0 .2s-.1.1-.2 0v-.2a.8.8 0 0 1 .2-.3h.1zm-4.8 4.6a.7.7 0 0 1 0 .2 1.1 1.1 0 0 1-.2.1c-.1 0-.1 0 0 0a.8.8 0 0 0 .1-.3h.1zm.8-.4a.3.3 0 0 1-.1.2.6.6 0 0 1-.2 0 .4.4 0 0 0 .1-.1.3.3 0 0 0 0-.1h.2zm1-.6a.5.5 0 0 1 0 .1.5.5 0 0 1-.2.1.4.4 0 0 0 0-.2h.2zm1.5-3.8l-.1.4a1.4 1.4 0 0 0 0 .4h-.1a1.4 1.4 0 0 1 0-.4v-.5h.1zm1-10.3a.9.9 0 0 1-.1.3 1.4 1.4 0 0 1-.2.3h-.1l.2-.3a.8.8 0 0 0 0-.3l.1-.1zm-1-1a1.9 1.9 0 0 1 .1 1 1.8 1.8 0 0 0 0-.5 1.5 1.5 0 0 0-.2-.4c0-.1 0 0 0 0zm-1.4 1.7a1.5 1.5 0 0 1-.4-.4.7.7 0 0 1-.1-.4l.2.4.3.4zm1.5 2.6v.2h-.1v-.2zm-2-2l.6 1 .1.8c.2 0 .3-.1.4-.3v-.9a1.9 1.9 0 0 0 .3-.6 3.5 3.5 0 0 0 .1-.5h.1l.4.8.3.9h-.1a2.9 2.9 0 0 0-.3-.9 3.9 3.9 0 0 0-.3-.6 2.9 2.9 0 0 1 0 .4 2 2 0 0 1-.3.5l-.1 1-.4.3v.4h-.1c0-.4 0-.8-.2-1.2a2 2 0 0 0-.5-1zm1.2 5v.3l-.1.4h-.1v-.8h.1c.1 0 .1 0 0 0zm-2.2.9v.3l-.1-.3c0-.1.1 0 .1 0zm1.9-2.5a2.3 2.3 0 0 1-.2.6l-.3.5a1.1 1.1 0 0 0-.3.6 1.8 1.8 0 0 0 0 .7c0 .1 0 0 0 0a1.9 1.9 0 0 1-.1-.7c0-.2.1-.5.3-.7a2.1 2.1 0 0 0 .3-.5 2.1 2.1 0 0 0 .2-.6c.1 0 0 0 0 0zm-.5-.8v.6a2.2 2.2 0 0 1-.5.6 1.8 1.8 0 0 0-.4.5l-.2.5h-.1l.2-.6.5-.5a2 2 0 0 0 .3-.5 1 1 0 0 0 .1-.6h.1zm-2.4 1.2c0 .4 0 .7-.2 1-.1.3-.3.6-.6.8h-.1v-.1c.3-.2.5-.5.6-.8.2-.2.2-.6.2-1zm-3 1.7v.2l.1.1v.1h-.1l-.1-.2v-.2s-.1 0 0 0zm-1.3 0a2.7 2.7 0 0 0 0 .7l.4.6.1.5v.4l.4-.5a1.4 1.4 0 0 0 .2-.6 1.6 1.6 0 0 1 0 .6l-.5.6h-.1a3.3 3.3 0 0 0 0-.5 1.8 1.8 0 0 0-.2-.4 2 2 0 0 1-.3-.7 2.7 2.7 0 0 1-.1-.7zm.2 4.2a2.6 2.6 0 0 1 .1-.8h.1a2.5 2.5 0 0 0-.1.8h-.1zm-.2 1.1v-.4s0-.1.1 0v.4zm-.8 2l.2-.3.2-.3h.1a4 4 0 0 1-.2.4l-.2.2c-.1 0-.1 0 0 0zm-1.1-6.6v.2h-.1v-.2zm-2 4.5a2.9 2.9 0 0 0 0-.1v-.2h.1v.3zm5-8l-.3 1c0 .3.1.6.3.7.3.2.4.4.5.7v-.4c.1-.1.1-.3 0-.4h.1a2.7 2.7 0 0 1 0 1h-.1a6 6 0 0 1 0-.2l-.5-.6c-.3-.2-.4-.4-.4-.8l.2-1h.1zm-.4-1.3a2.5 2.5 0 0 1 0 .8 4 4 0 0 1-.3.7 2.4 2.4 0 0 0-.2 1c0 .4.1.7.3 1v.1a2.5 2.5 0 0 1-.2-2.1 3.8 3.8 0 0 0 .2-.7c0-.3.1-.5 0-.8h.1c.1 0 0 0 0 0zm-2.3 3.3a.8.8 0 0 0 0 .4l.1.5c0 .1 0 0 0 0a1.5 1.5 0 0 1-.3-.5.9.9 0 0 1 .1-.5h.1zm-1-.4v.3a.9.9 0 0 1 0 .3.4.4 0 0 0-.1.3l.1.2v.1a.8.8 0 0 1-.2-.3.5.5 0 0 1 0-.4.8.8 0 0 0 .1-.2v-.3h.1zm5.8-8.6a2.3 2.3 0 0 0 .3 1.5 2.6 2.6 0 0 1-.4-.7 2.3 2.3 0 0 1 0-.8h.1zm-.7.7a4 4 0 0 1 .5 1.7h-.1a3.8 3.8 0 0 0-.5-1.6v-.1zm-3.6.1c-.4.5-.5 1-.6 1.3l.2.9.2.8a2.6 2.6 0 0 1-.2.8c-.1 0 0 0 0 0v-.8a2.3 2.3 0 0 0 0-.8 1.7 1.7 0 0 1-.3-1c0-.3.2-.7.6-1.2.1 0 0 0 0 0zm3.3-1.4v.5l-.4.4a.8.8 0 0 0-.3.4v.7c0 .1 0 0 0 0a1.9 1.9 0 0 1 0-.7 1 1 0 0 1 .3-.5 1 1 0 0 0 .3-.4.6.6 0 0 0 0-.4h.1zm-3.5.3v.7c0 .2-.2.4-.4.6a1.2 1.2 0 0 0-.4.6 2.9 2.9 0 0 0-.1.7h-.1a3 3 0 0 1 .1-.8c0-.2.2-.4.4-.6l.4-.6a1 1 0 0 0 0-.6zm2 .1a.8.8 0 0 0 0 .2.5.5 0 0 0 .1.3.6.6 0 0 1-.2-.2.8.8 0 0 1 0-.3h.1zm0-.5a.8.8 0 0 0-.5.4l-.2.7.2.5v.7a2.4 2.4 0 0 0 0-.7l-.3-.4a2 2 0 0 0-.5 1.2c0 .5.1 1 .5 1.5h-.1a2.7 2.7 0 0 1-.5-1.5c0-.5.2-.9.6-1.3 0-.3 0-.6.2-.8a1 1 0 0 1 .5-.4zm-.7-.8v.1c0 .3 0 .6-.2.7a.8.8 0 0 0-.2.3 1.6 1.6 0 0 0-.1.4h-.1a1.7 1.7 0 0 1 0-.4 1 1 0 0 1 .3-.4c.2-.1.2-.4.2-.6a2.7 2.7 0 0 0 0-.1h.1zm5.7 6l.1.5v.4a1.4 1.4 0 0 0 0-.4 1.9 1.9 0 0 0-.2-.4h.1zm0 2v.6l-.2.6-.3.6.2-.6a2.1 2.1 0 0 0 .2-.6 1.6 1.6 0 0 0 0-.7h.1zm-1.2-1.8a2.5 2.5 0 0 1 .7 2.5h-.1a2.4 2.4 0 0 0-.6-2.4v-.1c0-.1 0 0 0 0zm0 2a5.3 5.3 0 0 1-1 1.4 2.5 2.5 0 0 0-.5 1 1.4 1.4 0 0 0-.1-.6 1.9 1.9 0 0 0-.2-.4 1.4 1.4 0 0 1-.3-.9l.3-.8.3-.6a2.4 2.4 0 0 0 0-.6h.1c.1 0 0 0 0 0a2.6 2.6 0 0 1-.3 1.3 1 1 0 0 0-.3.7c0 .3 0 .6.2.8a2 2 0 0 1 .3.8 2.6 2.6 0 0 1 .5-.8 5 5 0 0 0 .5-.6l.3-.7h.1zm-3.2-1a2.8 2.8 0 0 0 .4 1.4v.1h-.1a2.3 2.3 0 0 1-.3-.7 3 3 0 0 1 0-.7zm-1.7 1v.3h-.1v-.3zm.6-1.6l-.1.5a1.4 1.4 0 0 1-.3.5c-.1 0 0 0 0 0l.2-.5a1.4 1.4 0 0 0 0-.5h.1zm-1.6 3.1a3.3 3.3 0 0 1-.3-1.7c0-.5.3-.8.6-1l.4-.7c.1-.2.2-.5.1-1s.1 0 .1 0v1l-.6.7a1.9 1.9 0 0 0-.5 1c0 .5 0 1 .3 1.7h-.1zm-1-1.1a.7.7 0 0 0 0 .3l.1.4a1 1 0 0 1-.2-.4.8.8 0 0 1 0-.4h.1zm4.6-3.2c.1.2.3.5.3.8 0 .3 0 .6-.2.9h-.1c-.1 0 0 0 0 0l.2-.9a1.5 1.5 0 0 0-.3-.8zm1.4-1.1a2.4 2.4 0 0 1 0 1.7 1.8 1.8 0 0 0-.2-.8 1.5 1.5 0 0 0-.5-.5c0-.1 0-.1.1 0a1.6 1.6 0 0 1 .6 1v-.6a2.3 2.3 0 0 0-.1-.8zm.8-1.2l.4.8v1a2 2 0 0 0 0 .5 1 1 0 0 0 .2.4 1 1 0 0 1-.2-.4 2.3 2.3 0 0 1 0-.5 3.5 3.5 0 0 0-.1-1 1.5 1.5 0 0 0-.4-.7c0-.1 0 0 .1 0zm-2.2-.2a1 1 0 0 0-.3.5v.7a2 2 0 0 1 0-.7c0-.2 0-.4.2-.5.1 0 .1 0 0 0zm-4.4 3a2 2 0 0 1-.3 1 2.5 2.5 0 0 1-.8.7c-.1 0 0 0 0 0l.7-.7c.2-.3.3-.6.3-1l.1-.1zm0-1.6v.5a2.2 2.2 0 0 1-.3.5l.1-.5v-.5h.1zm2.9-.2v1h-.1v-1zm.7-1.3c-.2.3-.3.5-.3.8l.2.7.3 1.2c0 .4-.2.7-.4 1.1l.3-1.1a1.9 1.9 0 0 0-.3-1.2l-.2-.7c0-.3 0-.6.3-.8.1 0 0 0 0 0zm-4.6-8.1a2 2 0 0 1 1-.5c.4 0 .8 0 1.2.3h.8-.8c-.4.5-.8.7-1.1.7a1 1 0 0 1-.9-.2c0-.1 0-.1 0 0a1 1 0 0 0 .9 0c.2 0 .6-.1 1-.5a1.9 1.9 0 0 0-1-.1 2 2 0 0 0-1 .4c-.1 0 0 0 0-.1z" />
    <path d="M351.6 101a.3.3 0 0 1 .3.3.3.3 0 0 1-.3.2.3.3 0 0 1-.2-.2.3.3 0 0 1 .2-.3zm1.8 1.6a2.2 2.2 0 0 0 .8-.7c.1 0 0 0 0 .1a2.3 2.3 0 0 1-.2.3l-.5.4c-.1-.1 0-.1 0-.1zm3.7-1.6a.5.5 0 0 1 .3 0 .8.8 0 0 1 .3.2.7.7 0 0 0-.3 0 .5.5 0 0 0-.2 0l-.1-.1zm-2 .1a.8.8 0 0 1 .3-.4l.7-.1v.1a1 1 0 0 0-.7 0 .7.7 0 0 0-.3.5c-.1 0-.1 0 0 0zm.2.4a.4.4 0 0 1 0-.3.6.6 0 0 1 .3-.1h.1a.5.5 0 0 0-.3.2.3.3 0 0 0 0 .2h-.1zm-3.6 1.1l-.1.3a.8.8 0 0 0 0 .3l-.1.1a1 1 0 0 1 0-.4c0-.1 0-.2.2-.3zm1 .5v.2-.2zm-.6-1.1a1 1 0 0 0 .3 0h.3a1.4 1.4 0 0 1-.3.1 1 1 0 0 1-.3 0s-.1 0 0-.1zm.6-2a.3.3 0 0 0-.2.1.4.4 0 0 0-.1.2h-.1a.5.5 0 0 1 .2-.3.4.4 0 0 1 .2 0h.1zm-1 .2a.8.8 0 0 0-.2 0 .3.3 0 0 0 0 .2h-.1c-.1 0 0 0 0 0a.4.4 0 0 1 0-.2.9.9 0 0 1 .3-.1zm-.7 0a.8.8 0 0 0-.1.1.7.7 0 0 0-.1.2h-.1a.7.7 0 0 1 .1-.2.9.9 0 0 1 .2-.2v.1zm-.8.7a1.7 1.7 0 0 0-.4.4v-.1a2 2 0 0 1 .4-.4zm0 .9v.1l-.2.2c-.1 0-.1 0 0 0v-.2l.2-.2c.1 0 .1 0 0 0zm-.7.2v.3l-.1.1c-.1 0 0 0 0 0v-.4zm1 1.4v.6h-.1v-.6h.1zm-.6-.4v.3h-.1v-.3h.1zm-.6-4.5a.7.7 0 0 1 .5.4v.1h-.1a.7.7 0 0 0-.2-.3.7.7 0 0 0-.2-.1v-.1zm5.2 6.7a1.6 1.6 0 0 1 0 1.4h-.1a1.6 1.6 0 0 0 0-1.3v-.1zm-1.7 2c0-.3.2-.5.3-.7l.4-.6c.2-.2.3-.4.3-.7a1.8 1.8 0 0 0 0-.7h.1a2 2 0 0 1-.3 1.5 6.3 6.3 0 0 0-.4.5l-.3.7h-.1zm-2.2-.6a.7.7 0 0 1 .2-.3.9.9 0 0 1 .3-.1.8.8 0 0 0-.2.2.6.6 0 0 0-.2.2zm-.4-.2l.3-.3.3-.2v.1a1 1 0 0 0-.3.2 2 2 0 0 0-.2.3c-.1 0-.1 0 0 0zm2.3-2.2h.2a.8.8 0 0 0 .3 0v.1a.8.8 0 0 1-.6 0c0-.1 0-.1 0 0zm-1.2-.1l.1-.1c.1 0 .1 0 0 0v.1c-.1 0 0 0 0 0zm24.2 7a1.1 1.1 0 0 1 .2.3h-.1a.8.8 0 0 0 0-.1.8.8 0 0 0-.2-.2c0-.1 0 0 0 0zm-26.8 12.5l.3.3a1 1 0 0 0 .5 0v.1a1 1 0 0 1-.5 0 1.7 1.7 0 0 1-.4-.3c0-.1 0-.1 0 0z" />
    <g fill="red">
      <path d="M368.9 99.6a8.2 8.2 0 0 0 1.7 0c-.6.3-1.2.6-2 .7a.8.8 0 0 0 .3-.4.4.4 0 0 0 0-.3zm-1.4-.1h1.2v.4s0 .2-.2.3c0 0-.1 0 0 .1a5.6 5.6 0 0 1-1.3 0 1 1 0 0 0 .3-.5.6.6 0 0 0 0-.4zm-10.5-3c.7-.2 1.3-.2 2-.2a1 1 0 0 1 .5.4c.1.2.2.5.1.8l.1.1h.1l-.1-1a1 1 0 0 0-.3-.2h.2a5 5 0 0 1 2.1.6c.2.2.3.3.2.5l-.3.5v.2h.2l.3-.7a.7.7 0 0 0 0-.3l1.7.8a.5.5 0 0 1 0 .5 1 1 0 0 1-.5.3v.1l.1.1c.3 0 .5-.2.6-.4a.6.6 0 0 0 0-.4l1.2.6v.3c0 .2-.1.3-.3.4 0 0-.1 0 0 .1 0 .1 0 0 0 0 .3 0 .5-.2.6-.4a.5.5 0 0 0 0-.3l.4.1a8.1 8.1 0 0 0 1.3.4.5.5 0 0 1 .1.4.7.7 0 0 1-.2.3v.2c-1.4-.1-2.7-.9-4.1-1.4l-.5-.2-1.6-.6-.1-.1a8.5 8.5 0 0 0-1.5-.4 6.1 6.1 0 0 0-1.6 0h-.1l-.1-.8a1.3 1.3 0 0 0-.5-.4z" />
      <path d="M354.6 97a8.7 8.7 0 0 1 2-.5c.4.1.6.3.7.5v.6a4.2 4.2 0 0 0-1.7.2 1.2 1.2 0 0 0-.7-.6 1.2 1.2 0 0 0-.3-.1zm7.4 3.9a9.4 9.4 0 0 0-.5-.4 7 7 0 0 0-3-.8c.3-.4.4-.8.3-1.1a1.7 1.7 0 0 0-.7-.8h1a8 8 0 0 1 2 .6c0 .3.1.6 0 .8 0 .3-.2.5-.5.7 0 0-.1 0 0 .1 0 .1 0 .1 0 0 .4-.1.6-.4.7-.7v-.8l1 .6 1 .8c0 .4 0 .6-.3.8h-.9v.2z" />
      <path d="M364 102.4l-1.8-1.4c.4 0 .7 0 1-.2.1-.1.3-.4.3-.8l1.1 1 .6.5v.4a.5.5 0 0 1 0 .2.6.6 0 0 1-.4.2h-.7z" />
      <path d="M366.2 103.8a11.8 11.8 0 0 1-2-1.3h.7a.8.8 0 0 0 .4-.2l.1-.4a1 1 0 0 0 0-.2 10.5 10.5 0 0 0 2.1 1.4c0 .3 0 .4-.3.5a3 3 0 0 1-1 .1z" />
      <path d="M368.4 104.7a11.9 11.9 0 0 1-2-.8c.4 0 .7 0 1-.2.2 0 .3-.2.3-.5a10.8 10.8 0 0 0 1.3.6v.4l-.5.4s-.1 0 0 0z" />
      <path d="M373.2 104.2s.4-.1.2 0c-1.4 1-3.1 1-4.8.5.3-.1.5-.2.6-.4a.6.6 0 0 0 0-.5l1.7.4a.4.4 0 0 1-.1.3l-.5.3s-.1 0 0 .1c0 .1 0 0 0 0 .3 0 .5-.2.6-.3a.6.6 0 0 0 .2-.4 9 9 0 0 0 2 0zm-9.7 24l-.2.4-1.2.3c0 .3 0 .4.3.4l.7-.3c.1 0 0 .5-.5.8v.1c.4.6 1.4.4 1.9.3a3 3 0 0 0 1.3-1l-.3-.6c-.4.1-.6 0-.5-.2a3.9 3.9 0 0 0-1.5-.2zm-15.1-4.8c-.3.3-.7.5-1 .6-.2 0-.6.1-.6.3 0 .1.2.3.4.2.4-.5.7-.2.2.2v.3c.5.4 1.6.5 2.2.2.3-.2.6-.5.2-.9a1.7 1.7 0 0 1 0-.2h-.6l-.4-.3-.4-.4zm10 3.5h-.1c-.2.2.3.2.6.3.2.1.2.3.2.5-.3.7-1.9.5-2.4.2-.2-.1-.2-.3-.2-.5h.3c.2 0 .4 0 .6-.2v-.2h-.2a1.3 1.3 0 0 1-.4.2 2.6 2.6 0 0 1-.5 0l-.2-.2h.2l.7-.2.1-.1c.5 0 1 0 1.3.2zm-7.2-.4l-.2.3a2.7 2.7 0 0 1-.9.6c-.2.1 0 .2.2.4.2.1.5-.2.6-.4.2-.3.3-.2.2 0l-.2.7.7.3c.4 0 1-.4 1.2-.6.3-.2.2-.5.1-.8a2 2 0 0 1-.5 0 3.4 3.4 0 0 1-.5-.3l-.7-.2zm2.8-26.4h.3l.6.1a4.5 4.5 0 0 1 1.7-.3 5.7 5.7 0 0 1 1.7-.2v-.2c.3-.3.4-.6.3-.9-.1-.2-.4-.5-.8-.7h-1.3a4 4 0 0 0-.8.1l.6.4.4 1c-.2.1-.2 0-.2 0 0-.4-.2-.6-.3-.9l-.8-.4a9 9 0 0 0-1.3.2c-.3 0-.5.2-.7.3l.8.1c.3.1.5.4.6.8-.1.1-.1 0-.1 0a1 1 0 0 0-.5-.6c-.4-.2-1.3 0-1.7.2a4.2 4.2 0 0 0-.6.6l2 .4zm-2.3-.4v-.1l.7-.6.7-.4a2 2 0 0 1 1-.5l1.3-.2a1 1 0 0 0-.5-.5l-.8-.1-1.5.8h.5l.1.2h-.4a1.4 1.4 0 0 0-.4 0h-.1l-1.3 1c.3.1.6.2.7.4z" />
    </g>
    <path
      fill="#0093dd"
      d="M409 156.5l20.8-47-15.3-24.7-27.3 10-12.7 49.8a219.4 219.4 0 0 1 34.5 11.9z"
    />
    <path
      fill="#fff"
      d="M382.6 113a251.7 251.7 0 0 1 39.6 13.7l-8 18.2a232 232 0 0 0-36.5-12.7z"
    />
    <path
      fill="red"
      d="M415.4 142l5.4-12.2a248.6 248.6 0 0 0-39-13.5l-3.2 12.4a235.9 235.9 0 0 1 37 12.8l-.1.4z"
    />
    <path d="M385.6 125.8c.3-.3.7-.2 1.1-.1.3-.2.7-.2 1-.2l.6-.2c.2 0 .2-.2 0-.3a.6.6 0 0 1 0-.3c-.7-.4-1-1-1.2-1.5-.3 0-.5-.2-.5-.3h-.5c-.8 0-1-.3-1.3-.5a1 1 0 0 1-.6-.4l-.3-.3c-.2-.3-.1-.7.2-.7h.7a2 2 0 0 1 .9-.1c.3 0 .5-.3.9-.6v-.4s0-.2.2-.1a1 1 0 0 1 .8.5c.5 0 1 .3 1.2.7.7 0 1.1.3 1.2.5 0 .2-.2.4-.5.6v.2l.4.4 1 .7c1-.1 2.6.6 4.8 2a18.6 18.6 0 0 1 4.1 1.2h.9c2.4-.4 4.7 0 6.8 1.5.8.1 1.5.4 2.2.7.5.2 1 .3 1.6.3a8 8 0 0 1 2.6.7c1 .2 1.9.6 2.4 1.2.4.5.3 1-.2 1.2-.3.6-.9.6-1.8.3-.6.1-1.3-.4-2-.9-.8-.2-1.6-.8-2.4-1.3l-1.3-.6h-.8v.2c.2.2.4.4.4.8v1c0 .4.3.6.7.9l1 .4c.2 0 .3.1.3.3l.4 1.7.4.3c.6.5.2 1-.3 1a3.1 3.1 0 0 1-1.3.8c-.4.2-.6 0-.7-.2a.5.5 0 0 1-.4-.2c-.5-.4-.1-1 1-.7l.2-.2a1.5 1.5 0 0 1 0-.9l-.3-.2a2.8 2.8 0 0 1-1-.6c-.6-.5-1.5-1-2.4-1.4-.7 0-1.2-.4-1.8-.7h-.8c-.2 0-.4 0-.5.2-.2.3-.5.2-.8.2h-1.6c-.4 0-.7 0-1 .3-.2.2-.4.2-.7 0a1 1 0 0 1-.3-.2c-.3 0-.5 0-.5-.2-.5-.1-.6-.2-.6-.4-.6-.1-.3-.6 0-.6l1.4.1c.4.1 1 0 1.2-.2l.5-.5a4 4 0 0 1-1.8-.5c-1.1-.7-2-.9-2.8-.3-.2.2-.3.2-.6.1a1 1 0 0 0-.5 0c-.5.1-.9 0-1.3-.1a4 4 0 0 1-1.8 0c-.6.3-1 .4-1.2.2a8.6 8.6 0 0 1-.6-.4c-.4-.1-.5-.2-.5-.3-.4 0-.5-.2-.5-.4-.2-.2 0-.3 0-.4.4-.2.7-.2 1 0 .3 0 .5.2.6.3h.6c.1-.2.5-.2 1-.2l.7-.2v-.2c-.4 0-.6-.4-.9-.7a3 3 0 0 1-1.5-.5c-.4 0-.7-.1-1-.3h-.7a2.5 2.5 0 0 1-1.4 0h-.8a1 1 0 0 1-1 .2 1.5 1.5 0 0 0-.8-.5c-.3-.1-.4-.2-.4-.4-.4-.2-.3-.4 0-.5.3-.1.5-.2 1 0l.5.2z" />
    <path
      fill="#fff"
      d="M401.2 130.5s0-.2-.3 0c-.8 0-1.6 0-2.2-.4-.7-.4-1.3-.8-2-.8l.7-.4h1.5c.7 0 1.4.2 2 .4.4.2.8.5 1 .8a3.4 3.4 0 0 1 .8.7 2.5 2.5 0 0 1-.7 0 2.9 2.9 0 0 1-.8-.3z"
    />
    <path d="M403 94.7v.2l.9 4.9-3.7 3.2-.2.1.2.1 4.7 1.6 1 4.9v.2l.2-.1 3.7-3.3 4.6 1.6h.3v-.1l-1-4.9 3.7-3.2.2-.2h-.3l-4.6-1.6-1-4.9V93l-.2.1-3.7 3.3-4.7-1.6z" />
    <path
      fill="#f7db17"
      d="M400.6 103l3.5-3 4.4 1.4zm8.5-1.7l3.4-3 4.4 1.5zm7.8-1.3l-3.4 3-4.4-1.5zm-8.4 1.6l-3.5 3-4.3-1.5zm-5-6.4l4.3 1.4.8 4.6zm5.5 6.4l4.4 1.5.9 4.5zm5.1 6.1l-4.3-1.5-.9-4.5zm-5.6-6.4l-4.3-1.5-.9-4.5zm3-7.7l1 4.6-3.5 3zm-2.7 8.1l.8 4.6-3.4 3zm-2.8 7.5l-.9-4.5 3.5-3zm2.8-8l-.9-4.6 3.5-3z"
    />
  </svg>
	),
	HT: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#d21034" d="M0 0h640v480H0z" />
    <path fill="#00209f" d="M0 0h640v240H0z" />
    <g fill="#f1b517" stroke="#000" strokeWidth={0.2}>
      <path fill="#fff" d="M244.3 179.7h151.4v120.5H244.3z" stroke="none" />
      <path
        fill="#016a16"
        stroke="#016a16"
        strokeWidth={0.3}
        d="M350.5 266.8l-31 1-30.7.3s-15.8 5.8-22.3 7.1c-6.4 1.3-5.6 3.4-10.5 4.6-4 .9-4.5 1.1-6.8 1.3-1.5 0-3.2 1.2-5 2.4v16.7h151.5v-15.9c-1.6-.9-3.2-1.5-4.8-2-2.2-.8-3.7-1.6-7.7-2.5-5-1.1-4.2-3.3-10.6-4.6-6.5-1.3-22.1-8.4-22.1-8.4z"
      />
      <g transform="translate(-80) scale(1.6)">
        <g id="prefix__a">
          <path d="M244.5 143.5h1.4l2.6 10.7-.6 3.4-3.4-14z" />
          <path fill="#fff" d="M243 136.3l1 8.3h1l-2-8.2z" />
          <path d="M245.7 154.6l-4.3-11.5 1.6-.1 5 14-2.3-2.4z" />
          <path fill="#fff" d="M239.4 136.5l1.8 8h1.4l-3.2-8z" />
          <path d="M241.9 150.6l-2.5-5.5 1-.2 4.7 9-3.2-3.3z" />
          <path fill="#fff" d="M236 138.8l2.9 7.6h1.4l-4.2-7.6z" />
          <path
            fill="#0a328c"
            d="M242.3 151.4l-11.5-12.5c-3.6 2.8-2.9 8-2.9 8l13 10.2 1.3-5.7z"
          />
          <path
            fill="#d20014"
            d="M248.9 158.2l-8.5-8.6c-3.6.2-.8 5.5-.6 6.2l9 7.7v-5.3z"
          />
          <path d="M248.1 156.8L230.6 138l-.7.5 18.6 20.6-.4-2.3zm-18.5-20l-.4-.5v-.9l-3.6-2.3 1.6 3.7 1.3.2.3.4.8-.6z" />
          <path d="M227.7 138.1a8.4 8.4 0 0 1 2.7-2.2l1 1.5-2.2 1.8-1.5-1z" />
          <path
            fill="#0a328c"
            stroke="#0a328c"
            d="M225.8 141.3l.6 1c.4-.1 4-3.5 4-3.5h2.7l.7-.9c-2-2-3.7.3-3.7.3l-4.3 3z"
          />
          <path
            fill="#d20014"
            stroke="#d20014"
            d="M228 143c0-1 1.8-3.2 2-3.3 1.3.4 2.5 1.2 3.9-1.8-1.2 1.4-3.5 0-3.5 0l-1 .8v.4l-3 2.8 1.5 1.1z"
          />
          <path
            fill="#0a328c"
            d="M237.3 154.7l-14.4-11.4c-2.5 2.5-.4 10.2-.4 10.2l14 7.6.7-6.4z"
          />
          <path
            fill="#d20014"
            d="M249.2 164l-11.9-9.6c-4 .6-.8 6.5-.6 7.2l12.5 6.8v-4.5z"
          />
          <path d="M248.7 162l-25.6-19.2-.5.6 26.8 21-.7-2.4zm-26.8-20.2l-.4-.4-.2-.8-4-1.7 2.3 3.3h1.3l.4.4.6-.8z" />
          <path d="M220.3 143.4a8.2 8.2 0 0 1 2.3-2.6l1.2 1.3-1.8 2.1-1.7-.8z" />
          <path
            fill="#0a328c"
            stroke="#0a328c"
            d="M219 146.6v1.1c.4-.2 3.7-3.7 3.7-3.7l2.5-.5.6-.8c-1.8-2.1-3.7.7-3.7.7l-3.2 3.2z"
          />
          <path
            fill="#d20014"
            stroke="#d20014"
            d="M221 148.5c-.2-1 1.2-3.8 1.4-4 1.6.5 3 1.2 3.5-2-1 1.6-3.5.4-3.5.4l-.8 1v.5l-2.5 3.3 1.9.8z"
          />
          <path
            fill="#0a328c"
            d="M236.2 161.7a2783.3 2783.3 0 0 1-18.5-10.5c-1.3 2.3-.1 5.5.5 6 0 1.5-.6 2.3.7 5.5.4 2 1.3 3.9 2.7 5 1.6 6.4 8.2 6.9 10.7 1.6l4-7.6z"
          />
          <path
            fill="#d20014"
            d="M248.3 168.5l-12.5-7.3c-4 .5 0 8 .3 8.7l12.2 4.3v-5.7z"
          />
          <path d="M246.2 165.8l-28.3-15-.5.6 30 16.7-1.2-2.3zM216.5 150l-.5-.3-.3-.8-4.1-1 2.7 2.9 1.2-.2.6.3.4-.9z" />
          <path d="M215.2 151.8c.4-1 .8-1.9 1.8-3l1.4 1.1-1.4 2.4-1.8-.5z" />
          <path
            fill="#0a328c"
            stroke="#0a328c"
            d="M214.1 155.2l.6 1.2 3-4.6 2.5-.9.5-1c-2-1.8-3.5 1.4-3.5 1.4l-3.1 3.9z"
          />
          <path
            fill="#d20014"
            stroke="#d20014"
            d="M216.8 156.8c-.2-1 .5-4.2.7-4.3 1.5.5 2.8.6 3.2-2.6-1 1.5-3.3 1-3.3 1l-.7 1 .1.4-2 4 2 .5z"
          />
        </g>
        <use
          width="100%"
          height="100%"
          transform="matrix(-1 0 0 1 499.9 0)"
          xlinkHref="#prefix__a"
        />
      </g>
      <g transform="translate(-80) scale(1.6)">
        <path
          fill="#016a16"
          stroke="#016a16"
          d="M248.8 125.6l-.5 9h2.9l-.4-9 3-.3-.3-3.6-7.5.3v3.2l2.8.4z"
        />
        <g id="prefix__b" fill="#016a16">
          <path d="M249.8 121.9c-7.8-7.8-13.9-4-15.3-2.9 1 .2 1.8-.4 2.3-.5l-1 1.2s2.5-1 2.8-1c-.4.3-.8 1-.8 1 .2 0 1.6-1.1 1.8-1.1-.4.4-.5 1.5-.5 1.5l1.2-.5c.3.2-.1.6.1.6 2-.2 4.7 1.7 5 2.3" />
          <path d="M247.9 123.3c-.8-1.8-15.6-5-18.6.3 1.2.3 2.3-1 2.3-1v1.2l1.9-1.6-.7 1.6 1.5-1.3v1.3l2-2-.3 1.1 1.7-.7-.2 1" />
          <path d="M247.2 123.6c-3.8-2.5-9.6-.8-9.6-.8-3.8 2-5.8 1.7-6.2 5.6.3-.1 1.3-1.4 1.3-1.4l.8 1.5.2-2.1.6 1.7 1-2.8.2 1.9 1.4-1.9.6.6.6-1.5.6 1s1-.6 1.5-.3l1-1.2.3.9 1-1 .3.7.9-.8v.6h3" />
          <path d="M246.4 124c-2.7 0-10.3 2.9-12.2 5.8a13.3 13.3 0 0 1 1.3-.6l.3 1.2.5-1.2.1 1c.3-.8.6-.8 1.2-.1l.2-1.1.3 1 .5-1.1s.3 1.2.5 1.2c0 0 .8-2.2 1.2-2.3l.1 1.4.5-1.4.5 1v-1.4l.6 1s.2-1 .6-1.2l.8.7 3.4-2.5" />
          <path d="M246.9 124.7c-3.5 1.3-6.7 6.2-6.4 8.2 1.5-2 1.2-1.7 1.9.6 0 0 .2-2 .5-2.2l.5 1.4.1-1.9h.5l-.1-1.1.7.5c-.2-.7-.3-.9.4-1.5 0 0-1 .1-.2-1.5l.7.6s-.2-.7 0-1l2.6-.8" />
          <path d="M247.2 125l-1.3 2.6.7.2-1.6 1.1 1.3-.1s-2 .7-2.2 2.7l2-1s-1.7 1.8-2 2.9l1.3-1s-1.2 1.2-1 3l.9-1c-.2 2.3-.2 2.5.8 4.2 0 0-.2-2.6 0-3l2.3 2.4-1.2-3.3s1.4 2 2.2 1.9l-1.8-2.7 1.8 1.4-2-3 1.8.6s-1.3-1.7-1.2-2.8l1.3 1.4s-.5-1.5-.4-2l.7.1-1.3-1.4.9-.2-.1-1 .6-.1v-1.1m-1.1 0c-2.2 3-1.1 7.5-2.4 9.9" />
        </g>
        <use
          width="100%"
          height="100%"
          transform="matrix(-1 0 0 1 499.9 0)"
          xlinkHref="#prefix__b"
        />
        <path d="M251 166.5s1.1-10 1.1-14.2c0-3.4-.8-10.8-.8-10.8H248s-.5 7.4-.4 10.8c0 4.2 1.1 14.2 1.1 14.2h2.3z" />
        <path d="M247.7 142h4l-.5-2.7h-2.9l-.6 2.6z" />
        <path d="M248 139.8h3.5l-.7-2.7h-2.2l-.7 2.7z" />
        <path d="M248.2 137.7h3l-.6-2.7h-1.9l-.5 2.7z" />
        <path d="M250.7 134.7h-2l-.3 1h2.5l-.2-1zm.4 29.7h-2.6m2.8-2h-3m3.4-2h-3.8m4-2.1h-4m4-2.2h-4.1m4.2-2h-4.4m4.4-1.7h-4.6m4.6-2.2h-4.6m4.5-2.1h-4.5m4.3-2.2h-4.1m3.9-2h-3.7" />
        <path
          fill="#0a328c"
          stroke="#0a328c"
          d="M250 119c-.8-.3-2.3-1.3-1.9-1.9l.7-1.2c1-2.2 0-1.4 0-2-.2-.8 3.8-.2 3.8 1.3 0 .5-.3.2-.2 2.6l-.8 1.5a3.5 3.5 0 0 1-1.7-.2z"
        />
        <path d="M250.4 125l-1-.9.3-7.1 1 .3-.3 7.6z" />
        <path
          fill="#d20014"
          stroke="#d20014"
          d="M251.7 119.3c.6-.4 1-1.5.6-2.1-1-1.3-1.7-.8-3.4-1.4-.3.4-1 1-.9 1.6 2.3 1 1.4.2 2.2.3.4 0 .6.5 1.5 1.5z"
        />
      </g>
      <g transform="translate(-80) scale(1.6)">
        <use
          width="100%"
          height="100%"
          transform="matrix(1 0 0 -1 0 320.4)"
          xlinkHref="#prefix__c"
        />
        <path
          fill="#016a16"
          stroke="#fff"
          strokeLinecap="round"
          d="M238.4 161.8c0 1.2-.9 2.3-1.9 2.3s-1.8-1-1.8-2.4v-1.2h3.7v1.2z"
        />
        <ellipse
          cx={236.5}
          cy={160.1}
          fill="#fff"
          rx={1.8}
          ry={0.9}
          stroke="none"
        />
        <path
          fill="#016a16"
          stroke="#f1b517"
          d="M236.1 161l-.3-3.2h1.4l-.2 3.3h-.9z"
        />
        <path
          id="prefix__c"
          fill="#016a16"
          stroke="#fff"
          strokeLinecap="round"
          d="M238.5 160.1c-.2.5-1 .9-2 .9s-1.7-.4-2-.9a.8.8 0 0 0 0 .4c0 .7.9 1.2 2 1.2 1.2 0 2.1-.5 2.1-1.2a.8.8 0 0 0 0-.4z"
        />
        <g id="prefix__d">
          <path d="M246 172.8l-7-2.2-3.1-5.3-10.9-.5.4 4 9.3 1.7.8 1.6 10.7 3-.2-2.3z" />
          <path fill="#503200" d="M238.7 174.3l-11.2-16.5-.5.5 11 16.4.7-.4z" />
          <path
            fill="#fff"
            d="M228.6 158.5l-1.2-2c-.3-.4-.6-.5-1.1-.2-.5.2-.4.7-.2 1.1l1 1.9 1.5-.8z"
          />
          <path d="M240 164.1l-22.5-2.3-.6 3.3 22.4 2.3.7-3.3z" />
          <path d="M217 161l-.5 4.5h1l.6-4.1-1-.4zm3.8.7l-.2 4.1h.6l.5-3.5-.8-.6zm15.3 1.8l-.6 3.8h1.1l.5-3.8h-1zm3.3.1l-.7 4.4 1.2.2.4-2.3c0 .5.5.8 1 .8.6 0 1-.5 1-1 0-.6-.4-1-1-1a1 1 0 0 0-1 .6l.3-1.6-1.2-.1zm-8 .7l-3.2 3.5.4.4 4-2.7-1.3-1.2zM224 173l3.1-3.5-.3-.4-4 2.7 1.2 1.2zm8.1-.9l-3.7-2.9-.4.3 3 3.8 1.1-1.2zm-9.3-6.7l3.9 2.8.4-.3-3-3.8-1.3 1.3zm4.2-2.3l.4 4.6h.5l1.2-4.5-2.1-.1zm1.2 11l-.3-4.5h-.6l-.7 4.6h1.6zm5.1-6l-4.8.4v.5l4.8.6V168zm-11.4 1.5l4.7-.7v-.4l-4.8-.5v1.6z" />
          <ellipse cx={227.7} cy={168.6} rx={1.3} ry={1.2} />
          <path
            fillRule="evenodd"
            strokeLinecap="round"
            d="M234.4 168.6c0 3.5-3 6.5-6.7 6.5a6.6 6.6 0 0 1-6.7-6.5c0-3.6 3-6.5 6.7-6.5a6.6 6.6 0 0 1 6.7 6.5zm-1.3 0a5.3 5.3 0 0 1-5.4 5.2 5.3 5.3 0 0 1-5.4-5.3 5.3 5.3 0 0 1 5.4-5.1 5.3 5.3 0 0 1 5.4 5.2z"
          />
          <path d="M223.5 165.3l-1-.8m8.5 0l1-1m1 9.2l-1.1-.9m-8.4 1.9l1-1m21.7-10.6l1.1 6-.9.4-1-6.3h.8z" />
          <path
            fill="#fff"
            d="M245.6 161.4c-.5-.3-1.2.1-2.4-1.3-1.9 1.7 0 2 .2 3.7.5.2.9-1.4 2.3-1.5l2.3-.2-.5-.7h-2z"
          />
          <path
            fill="#fff"
            d="M246.4 162.5l-.2-1.7c-.3-.7-1-.1-1 .2l.2 1.7 1-.2z"
          />
          <path
            fillRule="evenodd"
            d="M240.8 167.4v1.6c-.6.2-.5.6-.5 1.2v4.7c-.1.4-.7.4-1 .6-.3.3-.2.8 1 1l1 .1c1.5-.3 1.8-.8 1-1-.3-.2-.9-.4-1-.6v-1.2h1c.2 0 .7-.6.7-1.1v-2.5c0-1.4-1-1.6-1.4-1.5v-1.3h-.8zm1.6 2.7c0-.4-.6-.8-.8-.8-.2 0-.7.5-.7.9v1c0 .4.3 1.6.9 1.7.2 0 .6-.4.6-.8v-2z"
          />
          <path
            fill="#fff"
            d="M234.3 172.3c-.7-.2-.7 1.2-.7 1.2h1c.5.2.8.8.6 1.2-.3.2-2.2-.5-2.3 0 .3 1.9 2.9 2.6 3.8 1.8.9-.9 1.1-3-1.8-3.7l-.6-.5zm.6.6l-.3.6"
          />
          <path d="M215 173l-1-4m2.1 3.8l-1.5-3.1m4 2.3l-3.3-1.8m4.8 1.4l-6.2-2.7" />
          <path
            fill="#d20014"
            stroke="#d20014"
            d="M210.2 166l-2.6.1c-.2.1.5.9.4 1.1-.6 1.1-4.4 1-4.7.8-.5-.5 3.5-.8 3.6-1 0-.4-.6-1.2-.5-1.7 0-.7 1.7-1 1.7-1l2.1 1.7z"
          />
          <path
            fill="#503200"
            d="M213.2 168l-5-4.2s-.3-.2-.5 0 0 .4 0 .4l5.4 4.4.1-.5z"
          />
          <path d="M218.2 172.2l-4.2-3.6-.3-1-.8.6c-.3.2-.6.8-.6.8h1.1l3.6 3.4 1.1-.2z" />
          <ellipse cx={232.5} cy={177.1} rx={0.7} ry={0.7} />
          <ellipse cx={230.6} cy={175.7} rx={0.7} ry={0.7} />
          <ellipse cx={228.1} cy={176.6} rx={0.7} ry={0.7} />
          <ellipse cx={224.2} cy={177.4} rx={0.7} ry={0.7} />
          <ellipse cx={222.5} cy={177.6} rx={0.7} ry={0.7} />
          <ellipse cx={220.8} cy={177.6} rx={0.7} ry={0.7} />
          <ellipse cx={219.2} cy={177.6} rx={0.7} ry={0.7} />
          <ellipse cx={220} cy={176.3} rx={0.7} ry={0.7} />
          <ellipse cx={221.6} cy={176.4} rx={0.7} ry={0.7} />
          <ellipse cx={223.1} cy={176.2} rx={0.7} ry={0.7} />
          <ellipse cx={222.4} cy={175} rx={0.7} ry={0.7} />
          <ellipse cx={220.8} cy={174.9} rx={0.7} ry={0.7} />
          <path
            fillRule="evenodd"
            d="M236.5 178c0-.3-.8-.2-.8-.6 0-.4 1.2 0 1.3.3.7-.6 1-.2 1.4 0 .6-.8 1.3-.8 2-.2.4-.4 1.4-.3 1.7.2.7-.6 1.3-.5 1.7 0 .2-.3.5-.3.7 0 .3-.7 1.2-.5 1.6 0 .3-.4.7-.1 1.1.1.3-.2.8-.2.8 0 0 .4-.6.3-.6.6 0 .2.4 0 .4.4 0 .3-.6.4-.7 0-.3.4-1.1.2-1.2-.2a.8.8 0 0 1-1.2 0c-.3.2-.7.2-.8 0-.5.5-1.4.4-1.7-.2h-.3a1 1 0 0 1-1.5 0c-.9.6-1.4.4-1.9 0-.5.7-1.4.7-1.5 0-.4.3-1.2.4-1.2 0 0-.2.7-.1.7-.4zm1.6.1c0 .2-.2.3-.4.3s-.4-.1-.4-.3.1-.2.4-.2.4.1.4.2zm1.9-.2c0 .2-.3.3-.6.3s-.5-.1-.5-.3c0-.1.2-.3.5-.3s.5.2.5.3zm3.5.2c0 .2-.2.3-.5.3s-.4-.1-.4-.3c0-.1.2-.3.4-.3s.5.1.5.3zm-1.9 0c0 .2-.2.3-.5.3s-.4-.1-.4-.4c0-.2.2-.4.4-.4s.5.2.5.4zm4 0c0 .1-.1.3-.3.3-.3 0-.5-.2-.5-.4s.2-.3.5-.3c.2 0 .4.1.4.3zm-1.2 0c0 .2 0 .3-.2.3s-.3-.1-.3-.3.1-.2.3-.2l.2.2zm2.4.1c0 .2 0 .4-.3.4-.1 0-.3-.2-.3-.4s.2-.3.3-.3c.2 0 .3.1.3.3z"
          />
        </g>
        <use
          width="100%"
          height="100%"
          transform="matrix(-1 0 0 1 499.9 0)"
          xlinkHref="#prefix__d"
        />
        <path
          fill="#0a328c"
          stroke="#0a328c"
          d="M249.8 165.7c-2.5 0-4.5 1-4.5 2.1 0 .2 0 .4.2.6.5.6 2.3 1 4.4 1 2 0 3.6-.3 4.2-.9.2-.2.3-.4.3-.7 0-1.1-2-2-4.6-2z"
        />
        <path d="M254.4 168v7c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-7c0 .8 2 1.5 4.5 1.5 2.6 0 4.6-.7 4.6-1.5z" />
        <path
          fill="#d20014"
          stroke="#d20014"
          d="M245.3 168v1l2.2 7 1.8-5.4 2 5.5 1.3-5.2 1.8 3.5v-1.9l-1.6-3.4a8.3 8.3 0 0 1-.6.2l-1 3.8-1.5-3.6a14.5 14.5 0 0 1-.7 0l-1.5 3.6-1.6-4.4c-.4-.2-.6-.5-.6-.7z"
        />
        <path
          fill="#0a328c"
          stroke="#0a328c"
          d="M254.4 173.7v1.3c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-1.3c0 .9 2 1.5 4.5 1.5 2.6 0 4.6-.6 4.6-1.5z"
        />
        <path d="M251.7 175l-1.1.2v1.3l1.2-.1v-1.3zm-4.8-.1v1.3l1.1.2v-1.3a8.9 8.9 0 0 1-1.1-.2zm-1.6-1.2v1.3c0 .3.2.5.5.7v-1.3c-.3-.2-.5-.4-.5-.7zm9.1.2c0 .2-.4.5-.8.7v1.3c.5-.2.8-.5.8-.9v-1z" />
        <path
          fill="none"
          d="M254.4 168v7c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-7"
        />
        <path
          fill="#fff"
          stroke="#fff"
          d="M253.4 167.5c0 .5-1.6 1-3.5 1-2 0-3.6-.5-3.6-1s1.6-.9 3.5-.9c2 0 3.6.4 3.6 1z"
        />
        <path d="M248.7 168.2l.2 1.2h1l.1-1.2h-1.3zm4.1-.3l-1 .2.1 1.2 1-.2V168zm-5.4-2l-.7.3.1 1 .6-.2v-1zm2.4-.3h-.3l.2 1.2h.6l.2-1.2a9.7 9.7 0 0 0-.7 0zm2.7.4l-.1 1 .7.3v-1a5.3 5.3 0 0 0-.6-.3zm-6.5 2.8l.2-1.3-1-.5v1.5l.8.3zm8.4-.3v-1.3l-.8.3.8 1zm9.3-8.5c.8 0 2 1 2.1 2.5 0 1-1.7 1-1.7 1 0 .5-1 .9-1.8 1-.8 0 .2-1.5.2-1.5-.5-1.3.2-2.7.2-2.7l1-.3z" />
        <path d="M262.5 163h.8s0 .3.2.3.3-.4.3-.4h1.2" />
        <path
          fill="#d20014"
          stroke="#f1b517"
          d="M264.1 160.9c.7-.5.1-1.5-.4-1.5h-1c-.6 0-1.4.6-1.3 1 0 .5.4.7.8.6.2 0 .6-.6.8-.6.3 0 1 .6 1.1.5z"
        />
        <path
          fillRule="evenodd"
          d="M214.2 174.8c-.6.1-.7.8-.5 1.5-2.6.7-5 1.7-7.4 2.4-.1-.5 1.2-1.8 1.2-1.8.3.1.6.9.6.9 0-1.6 1.6-2.6 1.6-2.6-1-.2-3.7 1-4 1.4 0 0 1-.2 1.2 0 0 0-2.2 2.3-2.3 3 .4.7 4 1.3 4 1.3 0 .2-1 1-1 1 1.5.2 3.7-.8 4.3-1.4 0 0-1.7-.2-3-1.3 0 0 .2.7 0 1 0 0-2-.6-2.3-1 0 0 5-1.2 7.4-2 .1.5.6 1.3 1.2 1.1.3-.1.2-.8 0-1.4a.8.8 0 0 0 .6.2c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7a.8.8 0 0 0-.7.5c-.1-.5-.4-1.4-.8-1.3zm2 1.6c0 .2-.2.3-.4.3a.3.3 0 0 1-.4-.3c0-.2.2-.4.4-.4s.3.2.3.4z"
        />
        <path d="M293 177.9c.2-.4 0-2.2 0-2.2-.5 0-1 .7-1 .7.5-1.6-.8-4-.8-4 .9.1 3.9 3 4 3.6 0 0-1.3-.5-1.5-.4.3 1.5 1.3 2.2 1.7 3 0 0-1.7.3-1.6 1.8h-1.1c-.4-.5.1-1.3.1-1.3l-7.7-3.2c-.5-.2-1.6-.8-1.4-1.4.1-.5 2 .3 2.4.5l7 2.9z" />
        <path d="M285.6 176.5l1-1.6c.3-.5-.4-1-.9-.4l-1 1.5c-.4.9.5 1.1 1 .5z" />
      </g>
      <g fill="#fff" strokeWidth={0.3}>
        <path d="M290.2 288.6l-.1-3-3.5.3-.2 3.1 3.8-.4z" />
        <path d="M264.4 292.7l-4.7-2.7c19.4 1.8 23.4-5 28.1-5.3 3-.3 3.3 3.2-2.3 1.5l1.5 3.6s-13.8 7.8-27.4 4.6l4.8-1.7zm84.8-4.1l.1-3 4.3.2.2 3.1-4.6-.3z" />
        <path d="M375.9 292l4.5-2.5c-22.4.7-17.3-3.6-28.4-4.8-3-.4-5 3.4 2.2 1.5l-1.4 3.6h3.5c7.6 5 17.8 5.5 24.6 3.9l-5-1.7z" />
        <path d="M285.5 286.3v5s12.3 4.6 34.4 4.6c22.2 0 34.4-4.6 34.4-4.6v-5s-9.3 4.3-34.4 4.3c-25 0-34.4-4.3-34.4-4.3z" />
      </g>
      <path
        fill="#000"
        d="M287.3 291.3l1.1-3.7.5.2-1 3.2 2 .5-.2.5-2.4-.7zm3.6-1.6v-.7l.2-.7.6.2-.2.6-.3.7-.3-.1zm5.3-.3l.5.2-.4 2.1-.4 1a1.2 1.2 0 0 1-.5.4h-1a2 2 0 0 1-.9-.4 1 1 0 0 1-.4-.6l.1-1 .5-2.2.5.1-.5 2.2a2.1 2.1 0 0 0 0 .8.7.7 0 0 0 .2.4l.5.2h1l.4-1 .4-2.2zm.6 4l.6-3.7h.6l1.5 3.4.5-3h.5l-.6 3.9-.5-.1-1.6-3.3-.5 3-.5-.1zm4 .7l.6-3.8h.5l-.5 3.8h-.5zm1.6-1.7c0-.6.3-1.1.7-1.4a2 2 0 0 1 1.4-.4c.4 0 .7.1 1 .3l.5.8c.2.3.2.7.1 1a2.2 2.2 0 0 1-.3 1 1.7 1.7 0 0 1-.8.7 2 2 0 0 1-1 .1 2 2 0 0 1-1-.3 1.7 1.7 0 0 1-.5-.8 2.1 2.1 0 0 1-.1-1zm.5 0c0 .5 0 1 .3 1.2.2.3.5.5.9.5s.7 0 1-.3c.3-.2.4-.6.5-1a1.9 1.9 0 0 0 0-1 1.2 1.2 0 0 0-.5-.5 1.3 1.3 0 0 0-.7-.3c-.3 0-.7 0-1 .3-.2.2-.4.6-.5 1.2zm3.7 2.3l.3-3.8h.6l1.8 3.2.2-3h.5l-.3 3.9h-.5l-1.9-3.2-.2 3h-.5zm5.6.4l.1-3.8 2.7.1v.5l-2.1-.1-.1 1.1 1.9.1v.5l-2-.1v1.8h-.5zm3 .1l1.5-3.8h.6l1.5 4h-.6l-.4-1.3h-1.7l-.4 1.2h-.6zm1-1.5h1.4l-.4-1a9.8 9.8 0 0 1-.2-.9l-.2.8-.5 1.1zm3.1 1.6v-3.8h.6v3.8h-.6zm2.5 0V292h-1.3v-.4h3.1v.4h-1.3v3.4h-.5zm4 0l-.3-4h.6l.1 3.4h2v.4l-2.5.1zm2.6-.2l1.2-4h.6l2 3.7h-.7l-.5-1h-1.7l-.3 1.3h-.6zm1-1.7h1.4l-.5-1-.4-.9a4.8 4.8 0 0 1-.1.8l-.4 1.1zm4.7 1.2l-.4-3.8 2.6-.3.1.5-2.1.2v1.2l2-.2v.5l-1.9.2.2 1.7h-.5zm3-2.1a2 2 0 0 1 .2-1.6 2 2 0 0 1 1.3-.7l1 .1c.4.1.6.3.8.6l.4 1-.1 1a1.6 1.6 0 0 1-.6.8 2 2 0 0 1-.9.4 2 2 0 0 1-1-.1 1.7 1.7 0 0 1-.8-.6 2.1 2.1 0 0 1-.4-1zm.5-.1c0 .4.2.8.5 1 .3.3.6.3 1 .3s.7-.2 1-.5c.2-.3.2-.7.2-1.2a2 2 0 0 0-.3-.8 1.3 1.3 0 0 0-.6-.5 1.4 1.4 0 0 0-.7 0c-.4 0-.7.1-1 .4-.1.3-.2.7-.1 1.3zm4.1 1.3l-.6-3.8 1.7-.3h.8c.2 0 .4 0 .5.2l.3.6c0 .3 0 .5-.2.7-.1.2-.4.4-.7.5a1.4 1.4 0 0 1 .3.1l.5.5 1 .9h-.7l-.7-.6a7.4 7.4 0 0 0-.5-.5 1.2 1.2 0 0 0-.3-.2.8.8 0 0 0-.3 0h-.3l-.6.1.4 1.7h-.6zm.2-2.2l1-.2a1.7 1.7 0 0 0 .6-.2.6.6 0 0 0 .3-.6.6.6 0 0 0-.2-.4h-.7l-1.3.1.3 1.3zm6.3-.4h.5c0 .4-.1.8-.3 1a2 2 0 0 1-1 .6 2 2 0 0 1-1 0 1.6 1.6 0 0 1-.8-.6 2.6 2.6 0 0 1-.5-1 2.2 2.2 0 0 1 0-1c0-.4.3-.7.5-.9l.9-.4h1c.4.2.6.4.8.8l-.5.2a1.2 1.2 0 0 0-.5-.5 1.1 1.1 0 0 0-.7 0 1 1 0 0 0-.7.3 1.1 1.1 0 0 0-.3.7v.7a2.3 2.3 0 0 0 .4.8c.1.2.3.4.6.4h.7a1.1 1.1 0 0 0 .6-.3c.2-.2.3-.5.3-.8zm1.4 1l-1-3.7 2.7-.7.2.4-2.3.6.3 1.1 2.1-.5.2.4-2.2.6.4 1.2 2.4-.6v.4l-2.8.8z"
        stroke="none"
      />
    </g>
  </svg>
	),
	HU: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#fff" d="M640 480H0V0h640z" />
      <path fill="#388d00" d="M640 480H0V320h640z" />
      <path fill="#d43516" d="M640 160.1H0V.1h640z" />
    </g>
  </svg>
	),
	ID: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#e70011" d="M0 0h640v249H0z" />
      <path fill="#fff" d="M0 240h640v240H0z" />
    </g>
  </svg>
	),
	IE: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#009A49" d="M0 0h213.3v480H0z" />
      <path fill="#FF7900" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	IL: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-87.6 0H595v512H-87.6z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(82.1) scale(.94)"
    >
      <path fill="#fff" d="M619.4 512H-112V0h731.4z" />
      <path
        fill="#00c"
        d="M619.4 115.2H-112V48h731.4zm0 350.5H-112v-67.2h731.4zm-483-275l110.1 191.6L359 191.6l-222.6-.8z"
      />
      <path fill="#fff" d="M225.8 317.8l20.9 35.5 21.4-35.3-42.4-.2z" />
      <path fill="#00c" d="M136 320.6L246.2 129l112.4 190.8-222.6.8z" />
      <path
        fill="#fff"
        d="M225.8 191.6l20.9-35.5 21.4 35.4-42.4.1zM182 271.1l-21.7 36 41-.1-19.3-36zm-21.3-66.5l41.2.3-19.8 36.3-21.4-36.6zm151.2 67l20.9 35.5-41.7-.5 20.8-35zm20.5-67l-41.2.3 19.8 36.3 21.4-36.6zm-114.3 0L189.7 256l28.8 50.3 52.8 1.2 32-51.5-29.6-52-55.6.5z"
      />
    </g>
  </svg>
	),
	IM: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-77.6 0H605v512H-77.6z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="translate(72.8) scale(.94)">
      <path fill="#ba0000" fillRule="evenodd" d="M629.4 512H-102V0h731.4z" />
      <path
        fill="#ffef00"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.2}
        d="M281 376c.2-.6.6-6.8.4-6.8s-9.4-10.9-9.2-10.9c.2 0 11.8 2.6 11.8 2.2 0-.4 4.7-11.5 4.7-11.7l5.6 13.5 11.5 5-8 6.7 1.7 13c0 .3-8-7.6-8-7.6l-8.9 1s-1.2-4-1.6-4.4z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.6}
        d="M218.7 206.9c-7.7 4-37 37.5-41 42.7a77.3 77.3 0 0 1-16.8 23.4c-7.3 5.5-11.3 13-10.3 20 0 9 4.9 15 8.8 21.1 2.3 2.9 5.5 4.7 8.8 5 6.9.8 7.5 3 11 4.2 13.4 18.4 33.6 32 48 42.7a68.4 68.4 0 0 1 18 12.4c4.2 8.2 3.4 16 2.8 20L237.3 439c-1.9 11 7.8 8.6 8.3 6.4 4.3-5.7 10.8-1.7 20-34.3l12.8-17.1s4.9-2 4.9-2.5c7.5-9 1.8-14-2.5-15.7l-9.2-3.4s-10.8-10.8-11.3-10.8c-5.1-14.9-30.3-46.6-36.1-51-4-4.3-6-6-9.8-8.4-5.9-2.8-7.8-3.8-11.4-5.2-3-1.2-.9-4.5 1-6 20-10.9 35.7-22.9 54.8-35.1l3-2-6.9-39.2-31.8-11.2c-1.7 1.1-3 2.3-4.4 3.4z"
      />
      <path
        fill="#ffec00"
        fillRule="evenodd"
        d="M245.3 413.1c0-.4 20-4 20-4l-2.5 7.4-19.7 6 2.2-9.3z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.2}
        d="M193.6 338.5a37.9 37.9 0 0 1 21.6-20.4"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.4}
        d="M244.6 413.3c1.3-.3 7-2 8.6-2.3 1.8-.4 3.5-.8 5.2-1.4 2-.4 3.2-.8 5.2-1.1a39 39 0 0 1 5-1.4M241 425.6a14.6 14.6 0 0 1 2.5-2c1.1-.4 5-2 6.5-2.3a54 54 0 0 0 4.7-1.4l4.6-1.2c1.5-.6 2.9-1 4.4-1.4"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.2}
        d="M249 341.4h-.2c.8 0 .3 0-.9 1.4-.4 1.1-4 3.7-6.8 3.7a53 53 0 0 1-4.7.3l-1.3-.3m13.7 53.5h1.4c1.5 0 3 .3 4.2.3 1.5 0 2.9.4 4.3.4 1.5.2 3.2.1 4.7.4 1.6 0 3 .3 4.7.3 1.4.1 2.2.3 3.7.3l-3.7-.3c1.4.1 2.2.3 3.7.3m-32.7 33a13.6 13.6 0 0 1 2.3-2c1-.3 4.6-2 6-2.2a46.7 46.7 0 0 0 4.2-1.5l4.3-1c1.3-.7 2.6-1.1 4-1.5m5.8-41.2c-.8 2.3.3 2.9.7 3.9a12 12 0 0 0 5.7 3.4c1.2.3 2 .6 3.4 1.2.9 0 1.3.3 2 .5m-124.4-94.8h.3c-.9 0-.3.1 1.1-1 1-1.1 1.7-1.6 2.6-2.7m14.4 24c.2 0 16.6-8.2 18.3-10l3.7-2.9c1-.5 1.7-1.1 2.6-1.7.7-1 1.7-1.7 2.3-2.7 1-.9.5-1.8 1.4-2.9l1.3-3.8m20.8 12.2c.1.6-.2 2.4-.2 3.8 0 1.6-2.1 6.5-4.6 8"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.2}
        d="M192.6 307.8l6.7 2.1c5 1.8 15.4 8.4 16.5 9.3 1 .8 3 1.6 3.6 2.5 1.2 1 2 2.1 2.9 3.2 1 1.2 2 2.3 2.5 3.4a113.2 113.2 0 0 1 13.4 24.5c.7.7 1 1.7 1.7 2.8.6 1.4 1.3 2 2 3.1 1 .7 2.2 2 3.4 2.6 1.3 1.1 2.5 1.5 3.5 2.3 1.3.6 16.3 10 17 10.5 1.4 1.1 5.5 5.4 2.6 8.6-1.2 1-2.4 2.5-3.4 3-1.1 1.2-2.6 1.7-3.9 2.2-6.7 2-10.2 1.3-11.5 1.3h-1.4m-88.8-114.9c2 .8 1.2.2 2.9 1 1.2.5 2 .5 3 1 1.3.3 4.7 1 6.3 2.6 1.2 1 2 2 3.4 2.7a21.8 21.8 0 0 0 4.6 2.4c1.6.6 3.4 1.3 5 1.3h7.8-4 4"
      />
      <path
        fill="#ffe606"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.2}
        d="M159 293.3c4.2-.3 11.3 1 11.5 1l9.4-.2c5-.4 6-2.3 6.8-3.7 1.9-2.8 3.1-3.8 4.6-6 2.2-1.6 5.4 2.3 5.5 2.3 8 7.6 1.6 16.8 1.2 17.1-4 3.7-4.9 3.9-7.3 1.6-2.4-2.9-3.1-4.2-5.1-5.2-3.9-1.8-11.8-.4-12-.4l-4.1 1.6c-2 .7-3.2 2.4-6.5 3-3.5.2-4.6-.1-6.3-2.9-2.3-3.5-1.2-7.8 2.3-8.2z"
      />
      <path
        fill="#ffef00"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.2}
        d="M381.8 120.7c-.6 0-6.3 2.8-6.2 3 .1.1-4.8 13.5-4.9 13.4-.1-.2-3.5-11.7-3.9-11.5-.3.2-12.3 1.6-12.4 1.7l9-11.5-1.3-12.5 9.8 3.8 10.5-8c.2-.1-2.7 10.8-2.7 10.8l5.2 7.2s-3 3-3.1 3.6z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.6}
        d="M265 257.9c7.1 4.7 50.7 13.9 57.3 14.8a77 77 0 0 1 28.6 3.2c8.3 3.6 16.8 3.4 22.5-1 7.8-4.2 10.6-11.4 14-18a12 12 0 0 0 0-10c-2.6-6.4-1-8-1.6-11.6 9.4-20.8 11.4-45 13.6-62.9-.2-10.5.9-18.5 2-21.7a32 32 0 0 1 16-12.2l40.7-10.6c10.6-3.8 3.7-11 1.5-10.4-7-1-6.8-8.6-39.7-.7l-21.2-2.7s-4-3.3-4.5-3c-11.5-2.1-13.1 5.3-12.5 9.8l1.6 9.8s-4.1 14.6-3.9 15c-10.5 11.8-26 49.6-27 56.9-.5 6.8-3 5.5-2.4 12.2 0 5.2-.6 2 1.1 12.6.5 3.2-3.5 3-5.7 2-19.2-12-37.4-19.9-57.5-30.5l-3.1-1.6-30.8 25.2 5.8 33.2c1.8 1 3.4 1.5 5.1 2.2z"
      />
      <path
        fill="#ffec00"
        fillRule="evenodd"
        d="M431.7 133.6a375 375 0 0 1-13.3-15.4l7.6-1.5 14.8 14.3-9.1 2.6z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.2}
        d="M392 215.2a37.9 37.9 0 0 1-28.4-8.8"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.4}
        d="M432.2 134.1c-1-.9-5.2-5-6.2-6.4a66.5 66.5 0 0 0-3.8-3.8c-1.3-1.5-2.3-2.4-3.6-4a37.1 37.1 0 0 1-3.6-3.6m29.6 15c-.3 0-2-.7-3-1.2-.8-.9-4.2-3.4-5.1-4.6a54.2 54.2 0 0 0-3.5-3.4c-1.2-1.3-2.1-2-3.3-3.5a30.3 30.3 0 0 1-3.4-3"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.2}
        d="M367.3 165.5l.1.3c-.4-.8-.2-.3 1.7 0 1.2-.2 5.2 1.7 6.5 4.1.8 1.1 2 2.8 2.6 4 .2.3.2 1 .4 1.3m40-38.2l-.2-.2-.6-1-1.8-3.9c-.7-1.2-1-2.7-1.7-3.9-.6-1.4-1.5-2.8-2-4.2-.8-1.5-1.2-2.8-2-4.4-.7-1.2-.8-2-1.6-3.3l1.6 3.3c-.7-1.2-.8-2-1.6-3.3m44.8 12.3a12 12 0 0 1-2.8-1c-.8-.7-4-3-5-4a47 47 0 0 0-3.3-3c-1-1.3-1.9-2-3-3.3a26.2 26.2 0 0 1-3.2-2.7m-38.9 15c2.5-.4 2.5-1.6 3.1-2.5.5-1 .9-3.5.2-6.6l-.6-3.5c-.4-.9-.4-1.4-.5-2m-21.7 154.8l-.1-.2c.4.8.2.3-1.6-.5l-3.5-1m13.9-24.3c-.1-.2-15.3-10.4-17.7-11-1.4-.7-2.7-1-4.3-1.8l-2.8-1.4c-1.3-.2-2.4-.7-3.5-.7-1.2-.4-1.9.4-3.2.2l-4 .7m.5-24.1c.4-.4 2.2-1 3.4-1.7 1.4-.7 6.7-1.3 9.2.1"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.2}
        d="M365.7 231.2l-1.5-7a100 100 0 0 1 0-18.8c.2-1.3 0-3.4.5-4.5.3-1.4.8-2.7 1.3-4 .6-1.5 1.1-2.8 1.7-3.9.7-4 12-20.1 12.8-20.9a43 43 0 0 1 2-2.7c.3-1 1-1.8 1.6-3 1-1.1 1.2-2 1.8-3.2.1-1.1.6-2.9.6-4.2.3-1.7 0-3 .3-4.1-.2-1.5.7-19.2.8-20 .3-1.8 2-7.5 6.2-6.5 1.5.5 3.3.8 4.4 1.5 1.4.4 2.6 1.5 3.7 2.3 5 4.9 6.1 8.2 6.8 9.4l.7 1.2M352.6 276l-.1-.2c.4.7.2.3-.3-1.1-.1-1.3-.5-3-.7-4.2-.3-1.3-.9-2.7-.7-3.5-.5-1.3-.2-2.3 0-3.6.3-1.6.5-2.7.5-4.2.2-2 0-3.2.1-5-.5-1.5-.6-2.7-1.3-4.2l-2-4-2-3.5 2 3.4-2-3.4"
      />
      <path
        fill="#ffe606"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.2}
        d="M369.5 267.6c-2.3-3.6-4.7-10.4-4.8-10.5l-4.7-8.2c-2.8-4-5-4-6.6-4-3.4-.3-4.9-1-7.4-1.1-2.6-1.2-.7-5.9-.8-6 2.7-10.6 14-9.6 14.4-9.4 5.1 1.7 5.7 2.4 4.9 5.6-1.3 3.5-2 4.8-2 7 .3 4.2 5.5 10.5 5.5 10.6l3.4 2.8c1.6 1.4 3.7 1.6 5.8 4.3 1.9 2.9 2.2 4 .6 6.8-2 3.8-6.2 4.9-8.3 2.1z"
      />
      <path
        fill="#ffef00"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.2}
        d="M105.2 168.7c.5.4 5.8 3.7 6 3.5s14-3.4 13.8-3.2-7.8 9.3-7.4 9.5c.4.2 8 9.4 8.2 9.5l-14.5-1.2-9.8 7.8-2.2-10.2L87 180c-.2-.1 10.5-3.6 10.5-3.6l3.2-8.3s4.1.7 4.7.6z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.6}
        d="M284 191.3c0-8.7-16.2-50.2-19-56.1a77.2 77.2 0 0 1-13-25.7c-1.5-9-6.3-16-13-18.4-7.9-4.1-15.5-2.5-22.8-1.8-3.6.7-6.7 2.7-8.4 5.5-4 5.7-6.1 5.2-8.9 7.7-22.5 3.5-43.8 15.1-60 23a68 68 0 0 1-19.3 10.2 32 32 0 0 1-19-6.6l-31.1-28.3c-9-6.7-11.2 3-9.5 4.5 3 6.4-3.5 10.3 21.2 33.6l9.3 19.2s-.5 5.2 0 5.4c4.4 10.8 11.6 8.1 15 5.1l7.3-6.7s14.5-4.6 14.7-5c15.6 2.3 55.8-5.3 62.4-8.5 6-3.3 6.3-.5 11.5-4.7 4.3-2.9 2-.6 10-7.9 2.4-2 4.3 1.3 4.8 3.7.4 22.7 3.8 42.2 5.9 64.8l.4 3.5 38 12 24.6-23-1-5.6z"
      />
      <path
        fill="#ffec00"
        fillRule="evenodd"
        d="M88.7 119.8c.3.3-5.6 19.6-5.6 19.6l-5.4-5.5 3.8-20.3 7.2 6.2z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.2}
        d="M178.8 108.4c7.2 8 9.5 21.2 8.2 28.6"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.4}
        d="M89 119.1c-.3 1.3-1.5 7.2-2 8.7a66.8 66.8 0 0 0-1.2 5.3l-1.4 5.2c-.2 1.7-.5 3.3-1 5m-3.7-33c.1.3.5 2 .6 3.1-.2 1.2-.5 5.4-1 6.9a54.4 54.4 0 0 0-.9 4.8l-1 4.6a30.6 30.6 0 0 1-.8 4.6"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.2}
        d="M150.7 156.3l.1-.3c-.4.8 0 .3-.8-1.4-.9-1-1.4-5.3-.2-7.8a55 55 0 0 1 2-4.3c.1-.3.6-.7.8-1M98.8 129l-.1.2-.6 1c-.6 1.4-1.6 2.6-2.2 3.7-.6 1.3-1.7 2.3-2.3 3.6l-2.4 4c-.9 1.4-1.8 2.5-2.6 4l-2 3.2 2-3.2-2 3.2m-14.2-44.3c.2.2.7 1.9.8 3-.2 1-.4 5-.8 6.3l-.7 4.4c-.4 1.6-.5 2.7-1 4.3a26.2 26.2 0 0 1-.5 4.2M104 151c-1.7-1.9-2.7-1.2-3.8-1.3a12 12 0 0 0-5.7 3.5c-.8.9-1.5 1.6-2.6 2.5-.5.8-.9 1-1.4 1.5M232 90.4l-.1.3c.4-.8.1-.4.5 1.5.5 1.3.5 2.2 1 3.4m-27.9 1.8c0 .2-.3 18.5.5 20.9.2 1.5.6 2.7.8 4.6 0 1 .3 2 .4 3 .6 1.2.7 2.4 1.4 3.3.3 1.3 1.3 1.4 1.9 2.5.7.9 2 2.4 2.8 3m-20.5 12.9c-.6-.2-2-1.4-3.2-2-1.4-.8-4.9-4.9-5-7.8"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.2}
        d="M206.5 121.6l-5 5a94.3 94.3 0 0 1-15.8 10.3c-1.2.6-2.7 2-4 2.1-1.3.6-2.7.8-4 1.1a113.4 113.4 0 0 1-28.7 1.5 43.2 43.2 0 0 1-3.4-.2c-1 .2-2 .1-3.3.2-1.6-.1-2.4.2-3.7.3-1 .6-2.7 1.1-3.9 1.9-1.5.6-2.5 1.5-3.6 2-1 .9-16.4 9.8-17.2 10.2-1.6.7-7.3 2.5-8.8-1.6-.4-1.6-1-3.3-1.1-4.5-.5-1.4-.2-3-.2-4.4 1.4-6.9 3.6-9.6 4.2-10.8l.7-1.2M251 108l-.1.3c.3-.7.2-.4-.8.8-1 .8-2.2 2-3.1 3-1 .8-1.8 2-2.6 2.4-.8 1-1.8 1.4-3 2a20 20 0 0 0-3.8 1.9c-1.7.8-2.7 1.7-4.2 2.6-1 1.2-2 2-2.8 3.4-.8 1.3-1.6 2.4-2.3 3.9l-1.8 3.5 1.8-3.5-1.8 3.5m11.7 73.1l.3-.5c-.5 1-.4.7.1-.9 0-1.8.5-4.1.5-5.8.3-1.8.6-3.7.6-5.5-.1-2-.1-4-.4-6 0-1.8-.3-3.7-.3-5.6 0-1.8-.2-3.3-.6-5a29.5 29.5 0 0 0-.4-4.8c.1-1.2-.2-2.4-.5-3.4l-1.2-5.1-1-4.1c-.2-1.6-1-3.6-1.4-4.9a13.6 13.6 0 0 1-1.1-3.4c-.5-1.1-1.2-2.4-1.3-3.6l-1.6-3.7-1.4-3.6c-.5-1.4-1.1-2.6-1.5-4-.5-.5-.6-1-.8-1.4"
      />
      <path
        fill="#ffe606"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.2}
        d="M234.9 98.5a59 59 0 0 1-6.2 9.7l-4.2 8.4c-1.8 4.6-.7 6.5.1 7.8 1.7 3 2 4.6 3.2 6.8.5 2.8-4.5 3.8-4.5 3.9-10.4 3.6-15.7-6.4-15.7-6.9-1.4-5.2-1.2-6 2-7.1 3.6-.9 5-1 6.8-2.2 3.5-2.6 5.9-10.3 6-10.4l.4-4.4c.3-2-.6-4 .4-7.2 1.4-3.2 2.2-4 5.4-4.3 4.2-.3 7.5 2.6 6.3 5.9z"
      />
      <path
        fill="#ffef00"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={2.2}
        d="M221.3 199.7c-1.6-1.5 29.4 11.2 33.7 11.3 5.8-2.1 29.9-22.4 29.9-22.4.2 2 1.1 7.1 3.4 8.2-9.3 7.5-17.7 14.8-27 22.3.6 12-1.5 24.7 4.5 38 0 0-7.2.2-7.2 0-6.4-6.4-8.7-37.2-8.7-37.2l-30.6-13.6c1.5-1 2.6-3.9 2-6.7z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={2.2}
        d="M250.8 231.3c.5-.4-5.6 2.8-7.2 3.6-28.1 15-42.6 37-43.5 37.8l-2.2 3.4-2.3 3a60.6 60.6 0 0 1-3.6 4.7c-.2.6.4-.3.2.2m77.9-70.6a79 79 0 0 0 6.5 4.7c26.2 18.2 52.3 21.1 53.5 21.5 1 0 2.5.3 4 .5 1.2 0 2.6.4 3.8.5 1.4.2 4.4.8 5.8 1.2.6-.2-.5-.3 0-.4"
      />
    </g>
  </svg>
	),
	IN: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#f93" d="M0 0h640v160H0z" />
    <path fill="#fff" d="M0 160h640v160H0z" />
    <path fill="#128807" d="M0 320h640v160H0z" />
    <g transform="matrix(3.2 0 0 3.2 320 240)">
      <circle r={20} fill="#008" />
      <circle r={17.5} fill="#fff" />
      <circle r={3.5} fill="#008" />
      <g id="prefix__d">
        <g id="prefix__c">
          <g id="prefix__b">
            <g id="prefix__a" fill="#008">
              <circle r={0.9} transform="rotate(7.5 -8.8 133.5)" />
              <path d="M0 17.5L.6 7 0 2l-.6 5L0 17.5z" />
            </g>
            <use
              width="100%"
              height="100%"
              transform="rotate(15)"
              xlinkHref="#prefix__a"
            />
          </g>
          <use
            width="100%"
            height="100%"
            transform="rotate(30)"
            xlinkHref="#prefix__b"
          />
        </g>
        <use
          width="100%"
          height="100%"
          transform="rotate(60)"
          xlinkHref="#prefix__c"
        />
      </g>
      <use
        width="100%"
        height="100%"
        transform="rotate(120)"
        xlinkHref="#prefix__d"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(-120)"
        xlinkHref="#prefix__d"
      />
    </g>
  </svg>
	),
	IO: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="scale(.9375)">
      <path fill="#fff" fillRule="evenodd" d="M0 0h1024v512H0z" />
      <path
        fill="#000063"
        fillRule="evenodd"
        d="M1024 445.2c-11.5 7-21.3 23-51.8 23-61 0-76.2-33.9-122-33.9-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76 34-61 0-76.3-34-122-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-39.6 24.2-57.9 24.2v43.7c18.3 0 27.4-24.2 58-24.2 45.6 0 60.9 34 121.8 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 122 34 30.4 0 45.6-34 76.1-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 40.3-9.6 51.8-16.5v-50.3zm0-84.9c-11.5 7-21.3 23-51.8 23-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76 34-61 0-76.3-34-122-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-39.6 24.3-57.9 24.3v43.7c18.3 0 27.4-24.2 58-24.2 45.6 0 60.9 34 121.8 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 122 34 30.4 0 45.6-34 76.1-34 45.7 0 61 34 122 34 30.4 0 45.6-34 76.1-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 40.3-9.6 51.8-16.5v-50.3zm0-84.9c-11.5 7-21.3 23-51.8 23-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76 34-61 0-76.3-34-122-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-39.6 24.3-57.9 24.3v43.7c18.3 0 27.4-24.2 58-24.2 45.6 0 60.9 34 121.8 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 122 34 30.4 0 45.6-34 76.1-34 45.7 0 61 34 122 34 30.4 0 45.6-34 76.1-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 40.3-9.7 51.8-16.6v-50.2zm0-84.9c-11.5 6.9-21.3 23-51.8 23-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76 34-61 0-76.3-34-122-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-39.6 24.3-57.9 24.3v43.7c18.3 0 27.4-24.2 58-24.2 45.6 0 60.9 34 121.8 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 122 34 30.4 0 45.6-34 76.1-34 45.7 0 61 34 122 34 30.4 0 45.6-34 76.1-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 40.3-9.7 51.8-16.6v-50.2zm0-85c-11.5 7-21.3 23.1-51.8 23.1-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76 34-61 0-76.3-34-122-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34C27.4 94.7 18.3 119 0 119v43.7c18.3 0 27.4-24.2 57.9-24.2 45.7 0 61 34 122 34 30.4 0 45.6-34 76.1-34 45.7 0 61 34 122 34 30.4 0 45.6-34 76-34 45.8 0 61 34 122 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 40.3-9.7 51.8-16.6v-50.2zm0-84.8c-11.5 6.9-21.3 23-51.8 23-61 0-76.2-34-122-34-30.4 0-45.6 34-76.1 34-61 0-76.2-34-122-34-30.4 0-45.6 34-76 34-61 0-76.3-34-122-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34-30.5 0-45.7 34-76.2 34-61 0-76.2-34-121.9-34C27.4 9.7 18.3 34 0 34v43.8c18.3 0 27.4-24.2 57.9-24.2 45.7 0 61 34 122 34 30.4 0 45.6-34 76.1-34 45.7 0 61 34 122 34 30.4 0 45.6-34 76-34 45.8 0 61 34 122 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.5 0 45.7-34 76.2-34 45.7 0 61 34 121.9 34 30.4 0 40.3-9.7 51.8-16.6V20.7z"
      />
      <path fill="#000063" fillRule="evenodd" d="M0 0h261.3v158H0z" />
      <g strokeWidth="1pt">
        <path
          fill="#fff"
          d="M0 0v17.7L232.1 158h29.2v-17.7L29.3.1H0zm261.3 0v17.7L29.3 158H0v-17.7L232.1.1h29.2z"
        />
        <path
          fill="#fff"
          d="M108.9 0v158h43.5V0H109zM0 52.8v52.6h261.3V52.7H0z"
        />
        <path
          fill="#c00"
          d="M0 63.2v31.6h261.3V63.2H0zM117.6 0v158h26.1V0h-26.1zM0 158l87.1-52.7h19.5L19.5 158H0zM0 0l87.1 52.7H67.6L0 11.8V.1zm154.7 52.7L241.8.1h19.5l-87 52.6h-19.6zM261.3 158l-87-52.7h19.4l67.6 40.9V158z"
        />
      </g>
      <path
        fill="#a24300"
        fillRule="evenodd"
        stroke="#fff"
        strokeWidth={6.9}
        d="M815-301.2l-17.8 708.7c0 37.3 80.1 37.3 88.6 0l-17.7-708.7H815z"
        transform="matrix(.2064 0 0 .4902 211.6 267.4)"
      />
      <path
        fill="#006d00"
        fillRule="evenodd"
        stroke="#fff"
        strokeWidth={8.3}
        d="M496 549.2l17.8 70.9 35.4-53.2-17.7 88.6 35.4-35.4-35.4 88.6 35.4-35.5-35.4 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-35.4-88.6 35.4 35.5-35.4-88.6 35.4 35.4L443 567l35.4 53.2 17.8-70.9z"
        transform="matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M496 549.2v496m-70.8-177l70.9 106.2 70.8-106.3"
        transform="matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 797.2l70.9 106.3 70.8-106.3"
        transform="matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 726.4l70.9 106.3 70.8-106.3"
        transform="matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 673.2l70.9 88.6 70.8-88.6"
        transform="matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 620l70.9 88.7 70.8-88.6"
        transform="matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M443 567l53 106.2L549.3 567"
        transform="matrix(-.2354 .06743 -.1035 -.19501 591.3 322.6)"
      />
      <path
        fill="#006d00"
        fillRule="evenodd"
        stroke="#fff"
        strokeWidth={8.3}
        d="M496 549.2l17.8 70.9 35.4-53.2-17.7 88.6 35.4-35.4-35.4 88.6 35.4-35.5-35.4 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-35.4-88.6 35.4 35.5-35.4-88.6 35.4 35.4L443 567l35.4 53.2 17.8-70.9z"
        transform="matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M496 549.2v496m-70.8-177l70.9 106.2 70.8-106.3"
        transform="matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 797.2l70.9 106.3 70.8-106.3"
        transform="matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 726.4l70.9 106.3 70.8-106.3"
        transform="matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 673.2l70.9 88.6 70.8-88.6"
        transform="matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 620l70.9 88.7 70.8-88.6"
        transform="matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M443 567l53 106.2L549.3 567"
        transform="matrix(.17703 -.18126 .22077 .14638 73.8 93.5)"
      />
      <path
        fill="#006d00"
        fillRule="evenodd"
        stroke="#fff"
        strokeWidth={8.3}
        d="M496 549.2l17.8 70.9 35.4-53.2-17.7 88.6 35.4-35.4-35.4 88.6 35.4-35.5-35.4 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-35.4-88.6 35.4 35.5-35.4-88.6 35.4 35.4L443 567l35.4 53.2 17.8-70.9z"
        transform="matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M496 549.2v496m-70.8-177l70.9 106.2 70.8-106.3"
        transform="matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 797.2l70.9 106.3 70.8-106.3"
        transform="matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 726.4l70.9 106.3 70.8-106.3"
        transform="matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 673.2l70.9 88.6 70.8-88.6"
        transform="matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 620l70.9 88.7 70.8-88.6"
        transform="matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M443 567l53 106.2L549.3 567"
        transform="matrix(.1135 .2156 -.24917 .1076 581.8 -57.8)"
      />
      <path
        fill="#006d00"
        fillRule="evenodd"
        stroke="#fff"
        strokeWidth={8.3}
        d="M496 549.2l17.8 70.9 35.4-53.2-17.7 88.6 35.4-35.4-35.4 88.6 35.4-35.5-35.4 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-35.4-88.6 35.4 35.5-35.4-88.6 35.4 35.4L443 567l35.4 53.2 17.8-70.9z"
        transform="matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M496 549.2v496m-70.8-177l70.9 106.2 70.8-106.3"
        transform="matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 797.2l70.9 106.3 70.8-106.3"
        transform="matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 726.4l70.9 106.3 70.8-106.3"
        transform="matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 673.2l70.9 88.6 70.8-88.6"
        transform="matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 620l70.9 88.7 70.8-88.6"
        transform="matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M443 567l53 106.2L549.3 567"
        transform="matrix(-.15682 .19451 -.23555 -.12827 705.9 197.8)"
      />
      <path
        fill="#006d00"
        fillRule="evenodd"
        stroke="#fff"
        strokeWidth={8.3}
        d="M496 549.2l17.8 70.9 35.4-53.2-17.7 88.6 35.4-35.4-35.4 88.6 35.4-35.5-35.4 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-35.4-88.6 35.4 35.5-35.4-88.6 35.4 35.4L443 567l35.4 53.2 17.8-70.9z"
        transform="matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M496 549.2v496m-70.8-177l70.9 106.2 70.8-106.3"
        transform="matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 797.2l70.9 106.3 70.8-106.3"
        transform="matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 726.4l70.9 106.3 70.8-106.3"
        transform="matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 673.2l70.9 88.6 70.8-88.6"
        transform="matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 620l70.9 88.7 70.8-88.6"
        transform="matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M443 567l53 106.2L549.3 567"
        transform="matrix(-.15547 -.16616 .17678 -.15123 275.8 396)"
      />
      <path
        fill="#006d00"
        fillRule="evenodd"
        stroke="#fff"
        strokeWidth={8.3}
        d="M460.6 549.2l28.7 70.9 42.2-53.2-10.2 88.6 28-35.4-17.8 88.6 25.2-35.5-25.2 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-45.6-88.6 45.6 35.5-53.1-88.6 43 35.4-25.3-88.6 35.4 53.2v-70.9z"
        transform="matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M467.2 584.6l28.9 124v336.7"
        transform="matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M436.2 885.8l59.9 88.6 60.6-88.6"
        transform="matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M434.5 815l61.6 88.5 60.6-88.5"
        transform="matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M435.4 744.1l60.7 88.6 59.8-88.6"
        transform="matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M432.8 691l63.3 70.8 53.1-70.9"
        transform="matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 637.8l70.9 70.9 45.4-70.9"
        transform="matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M436.1 593.2l53.2 87 35.3-95.6"
        transform="matrix(-.27108 -.06397 -.15704 .20433 684.1 -32.2)"
      />
      <path
        fill="#006d00"
        fillRule="evenodd"
        stroke="#fff"
        strokeWidth={8.3}
        d="M460.6 549.2l28.7 70.9 42.2-53.2-10.2 88.6 28-35.4-17.8 88.6 25.2-35.5-25.2 88.6 35.4-35.4-35.4 106.3 35.4-35.5-35.4 106.3 35.4-35.4-35.4 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-35.4-106.3 35.4 35.4-35.4-106.3 35.4 35.5-35.4-106.3 35.4 35.4-45.6-88.6 45.6 35.5-53.1-88.6 43 35.4-25.3-88.6 35.4 53.2v-70.9z"
        transform="matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M467.2 584.6l28.9 124v336.7"
        transform="matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M436.2 885.8l59.9 88.6 60.6-88.6"
        transform="matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M434.5 815l61.6 88.5 60.6-88.5"
        transform="matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M435.4 744.1l60.7 88.6 59.8-88.6"
        transform="matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M432.8 691l63.3 70.8 53.1-70.9"
        transform="matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 637.8l70.9 70.9 45.4-70.9"
        transform="matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M436.1 593.2l53.2 87 35.3-95.6"
        transform="matrix(.27011 .06695 .00989 .24471 240.8 -138.4)"
      />
      <path
        fill="#006d00"
        fillRule="evenodd"
        stroke="#fff"
        strokeWidth={8.3}
        d="M354.3 531.5l88.6 88.6 17.7-53.2v88.6l35.5-35.4-17.8 88.6 35.5-35.5-17.7 88.6 35.4-35.4-17.7 106.3 35.4-35.4-35.4 106.3 35.4-35.5-17.7 106.3-17.7 53.2-17.7 17.7-17.8-17.7-17.7-53.2-53.1-82.3 35.4 11.5-35.4-106.3 35.4 35.4-53.1-106.3 35.4 35.4-53.2-88.6 53.2 35.5-70.9-88.6 53.2 35.4-70.9-70.8 70.9 35.4-53.2-88.6z"
        transform="matrix(.03453 -.23456 .24402 .04167 115.5 229.5)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M379 560l64 95.5 17.6 53.2 8.9 45.2 8.8 78.8 9.4 70.9 8.4 141.7"
        transform="matrix(.03453 -.23456 .24402 .04167 115.5 229.5)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M425.2 903.5l63.7 71 50.7-88.7"
        transform="matrix(.03453 -.23456 .24402 .04167 115.5 229.5)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M417 815l70.7 88.5 50.7-88.5"
        transform="matrix(.03453 -.23456 .24402 .04167 115.5 229.5)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M407.5 752.4l70.9 80.3 45.9-88.6M372.1 637.8l88.5 70.9 25.9-70.9"
        transform="matrix(.03453 -.23456 .24402 .04167 115.5 229.5)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="1pt"
        d="M360.6 602.4l82.3 53.1 10.5-53.1m-63.6 88.5l81 71 34-71"
        transform="matrix(.03453 -.23456 .24402 .04167 115.5 229.5)"
      />
      <g fillRule="evenodd">
        <path
          fill="#c00"
          stroke="#000"
          strokeWidth="1pt"
          d="M541.5 1173.3l-1.7-229.1-61.1-107c-15.3-52.6-7.8-78 17-79.8 24.7-1.6 49.2 13.6 84.8 15.3 35.6 1.7 28.9-59.4 81.5-57.7 52.6 1.7 144.3 32.3 222.3 37.4 78.1 5 118.8-27.2 208.8-30.6 90-3.4 113.7 42.4 118.8 42.4s30.6-18.6 56-22c25.5-3.4 34 10.2 34 10.2s-1.7 57.7-13.6 91.6c-11.9 34-54.3 90-56 90-1.7 0-15.3 249.5-15.3 251.2 0 1.7-675.5-6.8-675.5-11.9z"
          transform="matrix(.13659 0 0 .12573 266.4 208.2)"
        />
        <g stroke="#000" strokeWidth="1pt">
          <path
            fill="#fff100"
            d="M531.5 584.6s-68-52-69.8-177.1c-1-72 34.4-124 123-124 124 0 301.1 53.1 301.1 53.1v17.7s-141.7-53.1-301.2-53.1c-70.8 0-106.3 52-106.3 105.2 0 88.6 71 178.3 71 178.3v141.7h-17.8V584.6z"
            transform="matrix(-.13659 0 0 .12573 508.4 252.7)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 506.2 252.5)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 508.6 247.4)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 509.9 242.2)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 510.8 236.7)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 510.6 230.7)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 502.7 257)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 508.5 225)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 504 220.5)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 498 217.5)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 492 217.1)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 485.5 217.3)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 479 218.2)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 472.6 219)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 465.6 220)"
          />
          <path
            fill="#fff"
            d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
            transform="matrix(-.13659 0 0 .12573 459.6 221.6)"
          />
        </g>
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 268.6 252.5)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 266.1 247.4)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 264.9 242.2)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 264 236.7)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 264.2 230.7)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 266.2 225)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 270.6 220.5)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 276.7 217.5)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 282.7 217.1)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 289.2 217.3)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 295.7 218.2)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 302.2 219)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 309.1 220)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 315.1 221.6)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 272 257)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth="1pt"
          d="M531.5 584.6s-68-52-69.8-177.1c-1-72 34.4-124 123-124 124 0 301.1 53.1 301.1 53.1v17.7s-141.7-53.1-301.2-53.1c-70.8 0-106.3 52-106.3 105.2 0 88.6 71 178.3 71 178.3v141.7h-17.8V584.6z"
          transform="matrix(.13659 0 0 .12573 266.4 252.7)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth={3}
          d="M1240.2 531.5s15.3-35.4 70.9-35.4c37.8 0 70.8 35.4 70.8 70.8v70.9h35.5v-70.9c0-35.4 35.4-70.8 70.8-70.8 53.2 0 70.9 35.4 70.9 35.4s0-106.3-70.9-106.3c-53.1 0-70.8 35.4-70.8 35.4s17.7-53.1 17.7-106.3-35.4-88.6-35.4-88.6c0 6.8-35.5 35.5-35.5 88.6s17.7 106.3 17.7 106.3-17.7-35.4-70.8-35.4c-70.9 0-70.9 106.3-70.9 106.3z"
          transform="matrix(.04553 0 0 .0479 299.4 309)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth={3}
          d="M1240.2 531.5s15.3-35.4 70.9-35.4c37.8 0 70.8 35.4 70.8 70.8v70.9h35.5v-70.9c0-35.4 35.4-70.8 70.8-70.8 53.2 0 70.9 35.4 70.9 35.4s0-106.3-70.9-106.3c-53.1 0-70.8 35.4-70.8 35.4s17.7-53.1 17.7-106.3-35.4-88.6-35.4-88.6c0 6.8-35.5 35.5-35.5 88.6s17.7 106.3 17.7 106.3-17.7-35.4-70.8-35.4c-70.9 0-70.9 106.3-70.9 106.3z"
          transform="matrix(.04553 0 0 .0479 347.8 309)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth="1pt"
          d="M531.5 832.7V673.2s35.4 53.2 88.6 53.2c43.5 0 88.6-70.9 88.6-70.9s41.5 53.2 88.6 53.2c42 0 88.5-68.6 88.5-68.6s43.2 68.6 88.6 68.6c45.5 0 88.6-53.2 88.6-53.2s46.3 70.9 106.3 70.9c53.1 0 70.9-53.2 70.9-53.2v159.5H531.5z"
          transform="matrix(.13659 0 0 .12573 266.4 252.7)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth="1pt"
          d="M708.7 832.7v-124S815 744 815 832.7H708.7z"
          transform="matrix(.13659 0 0 .12573 242.2 252.7)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth="1pt"
          d="M708.7 832.7v-124S815 744 815 832.7H708.7z"
          transform="matrix(-.13659 0 0 .12573 532.5 252.7)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth="1pt"
          d="M602.4 832.7C602.4 744 708.7 688 708.7 688S815 744 815 832.7H602.4z"
          transform="matrix(.13659 0 0 .12573 266.4 252.7)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth="1pt"
          d="M602.4 832.7C602.4 744 708.7 688 708.7 688S815 744 815 832.7H602.4z"
          transform="matrix(.13659 0 0 .12573 314.8 252.7)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth="1pt"
          d="M584.6 847.5c0-88.6 124.1-159.4 124.1-159.4s124 70.8 124 159.4h-248z"
          transform="matrix(.13659 0 0 .12573 290.6 250.9)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M1275.6 655.5c-35.4-17.7-166-35.4-376.3-35.4s-350 17.7-385.5 35.4c-35.4 17.7-35.4 53.2 0 70.9 35.4 17.7 175.3 35.4 385.5 35.4s340.9-17.7 376.3-35.4c35.4-17.7 35.4-53.2 0-70.9z"
          transform="matrix(.13505 0 0 .12573 265.9 275)"
        />
        <path
          fill="gray"
          d="M435.8 366.3c0 4.5-40.3 4.5-48.4 4.5-8.8 0-48.4 1.2-48.4-4.5 0-4.4 39.9-4.4 48.4-4.4 8.4 0 48.4.9 48.4 4.4z"
        />
        <path
          fill="#c00"
          d="M343.8 350.3c0 1.5-1 2.7-2.4 2.7s-2.4-1.2-2.4-2.7 1-2.6 2.4-2.6c1.3 0 2.4 1.2 2.4 2.6zm92 0c0 1.5-1.1 2.7-2.5 2.7-1.3 0-2.4-1.2-2.4-2.7s1.1-2.6 2.4-2.6c1.4 0 2.4 1.2 2.4 2.6z"
        />
        <path d="M392.2 349c0 1.4-2.2 2.6-4.8 2.6s-4.9-1.2-4.9-2.7 2.2-2.6 4.9-2.6 4.8 1.2 4.8 2.6z" />
        <path
          fill="#006300"
          d="M415.4 349c0 1.4-1.6 2.6-3.6 2.6s-3.6-1.2-3.6-2.7 1.6-2.6 3.6-2.6 3.6 1.2 3.6 2.6zm-49.8 0c0 1.4-1.6 2.6-3.6 2.6s-3.7-1.2-3.7-2.7 1.6-2.6 3.7-2.6c2 0 3.6 1.2 3.6 2.6z"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth={2.2}
          d="M1257.9 496s35.4-53 70.9-53h35.4v35.3c0 53.2-53.1 71-53.1 71h141.7s-53.2-17.8-53.2-71V443h35.5c35.4 0 70.8 53.2 70.8 53.2V354.3s-35.4 53.2-70.8 53.2h-35.5V372c0-53.1 53.2-70.8 53.2-70.8H1311s53.1 17.7 53.1 70.8v35.5h-35.4c-35.5 0-70.9-53.2-70.9-53.2v141.8z"
          transform="matrix(.07805 0 0 .07185 279.5 298)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth={3.3}
          d="M1381.9 549.2h70.9s-53.2-17.7-53.2-70.9V443h35.4c35.5 0 71 53.2 71 53.2V354.3s-35.5 53.2-71 53.2h-35.4V372c0-53.1 53.2-70.8 53.2-70.8h-70.9v248z"
          transform="matrix(.03903 0 0 .06287 285 307.3)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth={3.3}
          d="M1381.9 549.2h70.9s-53.2-17.7-53.2-70.9V443h35.4c35.5 0 71 53.2 71 53.2V354.3s-35.5 53.2-71 53.2h-35.4V372c0-53.1 53.2-70.8 53.2-70.8h-70.9v248z"
          transform="matrix(-.03903 0 0 .06287 489.7 307.3)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M903.5 602.4a17.7 17.7 0 1 1-35.4 0 17.7 17.7 0 0 1 35.4 0z"
          transform="matrix(.13659 0 0 .12573 266.4 252.7)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth={2.2}
          d="M1257.9 496s35.4-53 70.9-53h35.4v35.3c0 53.2-53.1 71-53.1 71h141.7s-53.2-17.8-53.2-71V443h35.5c35.4 0 70.8 53.2 70.8 53.2V354.3s-35.4 53.2-70.8 53.2h-35.5V372c0-53.1 53.2-70.8 53.2-70.8H1311s53.1 17.7 53.1 70.8v35.5h-35.4c-35.5 0-70.9-53.2-70.9-53.2v141.8z"
          transform="matrix(.07805 0 0 .07185 279.5 251.2)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M903.5 602.4a17.7 17.7 0 1 1-35.4 0 17.7 17.7 0 0 1 35.4 0z"
          transform="matrix(.13659 0 0 .12573 266.6 206.3)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth="1pt"
          d="M850.4 655.5h70.9v53.2h-71z"
          transform="matrix(.13659 0 0 .12573 266.4 208.2)"
        />
        <path
          fill="#fff100"
          stroke="#000"
          strokeWidth="1pt"
          d="M850.4 683.3h70.9v202.5h-71z"
          transform="matrix(.13659 0 0 .12573 266.4 208.2)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 324.4 246)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 324.4 240.3)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 324.4 235)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth="1pt"
          d="M478.4 549.2a17.7 17.7 0 1 1-35.5 0 17.7 17.7 0 0 1 35.5 0z"
          transform="matrix(.13659 0 0 .12573 324.4 229.4)"
        />
        <path d="M392.5 357.5c0 1-2.2 1.8-5 1.8s-4.8-.8-4.8-1.8 2.2-1.8 4.9-1.8 4.9.8 4.9 1.8zm44.6 4.4c-.3.7-2.7.8-5.4.1-2.7-.6-4.6-1.6-4.4-2.3.3-.7 2.7-.8 5.4-.1 2.7.6 4.6 1.6 4.4 2.3zm-18.7-3c0 .9-2.4 1.4-5.2 1.3-2.7-.2-4.9-1.1-4.8-2 .1-.9 2.5-1.4 5.2-1.2 2.8.2 5 1 4.8 1.9zm-81.8 3c.2.7 2.6.8 5.3.1 2.7-.6 4.7-1.6 4.4-2.3-.3-.7-2.7-.8-5.4-.1-2.6.6-4.6 1.6-4.3 2.3zm19.5-3.4c.1.9 2.5 1.4 5.2 1.2 2.8-.2 5-1 4.8-2 0-.8-2.4-1.4-5.2-1.2-2.7.2-4.9 1-4.8 2z" />
      </g>
    </g>
  </svg>
	),
	IQ: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#fff" d="M0 160h640v160H0z" />
    <path fill="#ce1126" d="M0 0h640v160H0z" />
    <path d="M0 320h640v160H0z" />
    <g fill="#007a3d" transform="translate(-179.3 -92.8) scale(1.75182)">
      <path d="M325.5 173.2a5 5 0 0 1-1.4-1c-.3-.5-.1-.5 1.2-.2 2.3.7 3.8.4 5.3-.8l1.3-1.1 1.5.7c.9.5 1.8.8 2 .7.7-.2 2.1-2 2-2.6 0-.7.6-.5 1 .3.6 1.6-.3 3.5-2 3.9-.7.2-1.4.1-2.6-.3-1.4-.5-1.7-.5-2.4 0a5.4 5.4 0 0 1-5.9.4zm5.8-5.3a8 8 0 0 1-1-4c.1-.6.3-.8.8-.6 1 .3 1.2 1 1 3 0 1.8-.3 2.3-.8 1.6zm-67.6-1.9c-.1 1.3 2.4 4.6 3.5 5.2-.8.3-1.7.2-2.4.5-4 4-18.4 18-21 21.4 7.8.2 16.4-.1 23.7-.4 0-5.3 5-5.6 8.4-7.5 1.7 2.7 6 2.5 6.6 6.6v17.6H216a9.7 9.7 0 0 1-12.3 7.5c2-2 5.4-2.8 6.6-5.7 1-6.4-2-10.3-4-14a24 24 0 0 0 7-3.6c-2.3 7 6.2 6.3 12.4 6.1.2-2.4.1-5.2-1.7-5.6 2.3-.9 2.7-1.2 6.6-4.4v9.6l46.1-.1c0-3 .8-7.9-1.6-7.9-2.2 0 0 6.2-1.8 6.2h-35.7v-6c1.5-1.6 1.3-1.5 11.6-11.8 1-1 8.3-7.6 14.6-13.7zm89.1-.3c2.5 1.4 4.5 3.2 7.5 4-.3 1.3-1.5 1.8-1.8 3.1v27c3.4.7 4.2-1.3 5.8-2.3.4 4.3 3.2 8.5 3 12h-14.5v-43.7zm-19.4 14.5s5.3-4.5 5.3-4.7V199h3.8l-.1-26.3c1.5-1.6 4.6-3.8 5.3-5.4v42h-33.4c-.5-8.7-.6-17.7 9.6-15.8V190c-.3-.6-.9.1-1-.7 1.6-1.6 2.1-2 6.5-5.8l.1 15.5h3.9v-18.8zm-12.6 18.6c.7 1 3.2 1 3-.8-.3-1.5-3.5-1-3 .8z" />
      <circle cx={224} cy={214.4} r={2} />
      <path d="M287 165.8c2.5 1.3 4.5 3.2 7.6 4-.4 1.2-1.5 1.7-1.8 3v27c3.4.7 4.1-1.2 5.7-2.3.5 4.3 3.2 8.6 3.1 12H287v-43.7z" />
    </g>
  </svg>
	),
	IR: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-85.3 0h682.7v512H-85.3z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(80) scale(.9375)"
    >
      <path fill="#fff" d="M-192 0h896v512h-896z" />
      <path fill="#da0000" d="M-192 343.8h896V512h-896z" />
      <g fill="#fff" strokeWidth="1pt">
        <path d="M-21.6 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z" />
        <path d="M52.4 367.7v3.4H33.8v-3.4zm-34.6-7.9H21v11.3h-3.3z" />
        <path d="M49.6 351H53v20h-3.4zm-8.4 0h3.3v20h-3.3zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z" />
        <path d="M17.8 359.9H21V371h-3.3z" />
        <path d="M17.8 359.9H21V371h-3.3z" />
        <path d="M17.8 359.9H21V371h-3.3zm-39.3 0h3.3V371h-3.3zm28.8 0h3.4V371H7.3zm-14.3 0h3.4V371H-7z" />
        <path d="M9.6 367.7v3.4H-5.5v-3.4zm1-8.7v3.4H1V359z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M-102.2 351h49v3.3h-49zm7.3 16.8h3.4v3.3H-95zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z" />
        <path d="M-28.2 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z" />
        <path d="M-31 351h3.4v20H-31zm-8.4 0h3.3v20h-3.3zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z" />
        <path d="M-62.8 359.9h3.3V371h-3.3z" />
        <path d="M-62.8 359.9h3.3V371h-3.3z" />
        <path d="M-62.8 359.9h3.3V371h-3.3zm-39.3 0h3.3V371h-3.3zm28.8 0h3.3V371h-3.3zm-14.3 0h3.4V371h-3.4z" />
        <path d="M-71 367.7v3.4h-15v-3.4zm1-8.7v3.4h-9.6V359z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M58.3 351h49v3.3h-49zm7.3 16.8H69v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.3-16.8h3.4v20h-3.4z" />
        <path d="M132.3 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z" />
        <path d="M129.5 351h3.4v20h-3.4zm-8.4 0h3.4v20H121zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z" />
        <path d="M97.7 359.9h3.4V371h-3.4z" />
        <path d="M97.7 359.9h3.4V371h-3.4z" />
        <path d="M97.7 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z" />
        <path d="M89.6 367.7v3.4H74.4v-3.4zm1-8.7v3.4H81V359z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M622.7 351h49v3.3h-49zm7.3 16.8h3.4v3.3H630zm41.9 0v3.3H662v-3.4zm5.3-16.8h3.3v20h-3.4z" />
        <path d="M696.7 367.7v3.4H678v-3.4zm-34.6-7.9h3.4v11.3H662z" />
        <path d="M694 351h3.3v20h-3.4zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z" />
        <path d="M662 359.9h3.5V371H662z" />
        <path d="M662 359.9h3.5V371H662z" />
        <path d="M662 359.9h3.5V371H662zm-39.2 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z" />
        <path d="M654 367.7v3.4h-15.2v-3.4zm1-8.7v3.4h-9.6V359z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M138.7 351h49.1v3.3h-49zm7.4 16.8h3.3v3.3h-3.3zm41.8 0v3.3h-9.8v-3.4zm5.3-16.8h3.4v20h-3.4z" />
        <path d="M212.8 367.7v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z" />
        <path d="M210 351h3.4v20H210zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-17.9V359zm39.3 0v3.4h-17.9V359z" />
        <path d="M178.1 359.9h3.4V371h-3.4z" />
        <path d="M178.1 359.9h3.4V371h-3.4z" />
        <path d="M178.1 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.2 0h3.3V371h-3.3z" />
        <path d="M170 367.7v3.4h-15.1v-3.4zm1-8.7v3.4h-9.6V359z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M219.5 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zM274 351h3.3v20H274z" />
        <path d="M293.5 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z" />
        <path d="M290.7 351h3.4v20h-3.4zm-8.4 0h3.4v20h-3.4zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z" />
        <path d="M258.9 359.9h3.4V371h-3.4z" />
        <path d="M258.9 359.9h3.4V371h-3.4z" />
        <path d="M258.9 359.9h3.4V371h-3.4zm-39.3 0h3.3V371h-3.3zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371H234z" />
        <path d="M250.8 367.7v3.4h-15.2v-3.4zm1-8.7v3.4H242V359z" />
      </g>
      <path fill="#239f40" d="M-192 0h896v168.2h-896z" />
      <g fill="#fff" strokeWidth="1pt">
        <path d="M300.7 351h49v3.3h-49zm7.3 16.8h3.4v3.3H308zm41.9 0v3.3H340v-3.4zm5.3-16.8h3.3v20h-3.3z" />
        <path d="M374.7 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3H340z" />
        <path d="M372 351h3.3v20H372zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z" />
        <path d="M340 359.9h3.5V371H340z" />
        <path d="M340 359.9h3.5V371H340z" />
        <path d="M340 359.9h3.5V371H340zm-39.2 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z" />
        <path d="M332 367.7v3.4h-15.2v-3.4zm1-8.7v3.4h-9.6V359z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M381.4 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm42 0v3.3h-9.9v-3.4zm5.2-16.8h3.4v20h-3.4z" />
        <path d="M455.4 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z" />
        <path d="M452.7 351h3.3v20h-3.3zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-17.9V359zm39.3 0v3.4h-17.9V359z" />
        <path d="M420.8 359.9h3.4V371h-3.4z" />
        <path d="M420.8 359.9h3.4V371h-3.4z" />
        <path d="M420.8 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.3z" />
        <path d="M412.7 367.7v3.4h-15.1v-3.4zm1-8.7v3.4H404V359z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M462.2 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z" />
        <path d="M536.2 367.7v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z" />
        <path d="M533.4 351h3.4v20h-3.4zm-8.4 0h3.3v20H525zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z" />
        <path d="M501.6 359.9h3.3V371h-3.3z" />
        <path d="M501.6 359.9h3.3V371h-3.3z" />
        <path d="M501.6 359.9h3.3V371h-3.3zm-39.4 0h3.4V371h-3.4zm28.9 0h3.3V371h-3.3zm-14.3 0h3.4V371h-3.4z" />
        <path d="M493.4 367.7v3.4h-15.1v-3.4zm1-8.7v3.4h-9.6V359z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M543.4 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z" />
        <path d="M617.4 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z" />
        <path d="M614.6 351h3.4v20h-3.4zm-8.4 0h3.3v20h-3.3zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z" />
        <path d="M582.8 359.9h3.3V371h-3.3z" />
        <path d="M582.8 359.9h3.3V371h-3.3z" />
        <path d="M582.8 359.9h3.3V371h-3.3zm-39.3 0h3.3V371h-3.3zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371H558z" />
        <path d="M574.6 367.7v3.4h-15.1v-3.4zm1-8.7v3.4H566V359z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M-183.8 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm42 0v3.3h-9.9v-3.4zm5.2-16.8h3.4v20h-3.4z" />
        <path d="M-109.8 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z" />
        <path d="M-112.5 351h3.3v20h-3.3zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-17.9V359zm39.3 0v3.4h-17.9V359z" />
        <path d="M-144.4 359.9h3.4V371h-3.4z" />
        <path d="M-144.4 359.9h3.4V371h-3.4z" />
        <path d="M-144.4 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z" />
        <path d="M-152.5 367.7v3.4h-15.2v-3.4zm1-8.7v3.4h-9.6V359z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M-21.6 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z" />
        <path d="M52.4 160.2v3.4H33.8v-3.4zm-34.6-7.9H21v11.3h-3.3z" />
        <path d="M49.6 143.4H53v20.2h-3.4zm-8.4 0h3.3v20.2h-3.3zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z" />
        <path d="M17.8 152.3H21v11.3h-3.3z" />
        <path d="M17.8 152.3H21v11.3h-3.3z" />
        <path d="M17.8 152.3H21v11.3h-3.3zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.4v11.3H7.3zm-14.3 0h3.4v11.3H-7z" />
        <path d="M9.6 160.2v3.4H-5.5v-3.4zm1-8.7v3.3H1v-3.3z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M-102.2 143.4h49v3.4h-49zm7.3 17h3.4v3.2H-95zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z" />
        <path d="M-28.2 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z" />
        <path d="M-31 143.4h3.4v20.2H-31zm-8.4 0h3.3v20.2h-3.3zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z" />
        <path d="M-62.8 152.3h3.3v11.3h-3.3z" />
        <path d="M-62.8 152.3h3.3v11.3h-3.3z" />
        <path d="M-62.8 152.3h3.3v11.3h-3.3zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.3v11.3h-3.3zm-14.3 0h3.4v11.3h-3.4z" />
        <path d="M-71 160.2v3.4h-15v-3.4zm1-8.7v3.3h-9.6v-3.3z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M58.3 143.4h49v3.4h-49zm7.3 17H69v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.3-16.8h3.4v20.2h-3.4z" />
        <path d="M132.3 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z" />
        <path d="M129.5 143.4h3.4v20.2h-3.4zm-8.4 0h3.4v20.2H121zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z" />
        <path d="M97.7 152.3h3.4v11.3h-3.4z" />
        <path d="M97.7 152.3h3.4v11.3h-3.4z" />
        <path d="M97.7 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z" />
        <path d="M89.6 160.2v3.4H74.4v-3.4zm1-8.7v3.3H81v-3.3z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M622.7 143.4h49v3.4h-49zm7.3 17h3.4v3.2H630zm41.9-.2v3.4H662v-3.4zm5.3-16.8h3.3v20.2h-3.4z" />
        <path d="M696.7 160.2v3.4H678v-3.4zm-34.6-7.9h3.4v11.3H662z" />
        <path d="M694 143.4h3.3v20.2h-3.4zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z" />
        <path d="M662 152.3h3.5v11.3H662z" />
        <path d="M662 152.3h3.5v11.3H662z" />
        <path d="M662 152.3h3.5v11.3H662zm-39.2 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z" />
        <path d="M654 160.2v3.4h-15.2v-3.4zm1-8.7v3.3h-9.6v-3.3z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M138.7 143.4h49.1v3.4h-49zm7.4 17h3.3v3.2h-3.3zm41.8-.2v3.4h-9.8v-3.4zm5.3-16.8h3.4v20.2h-3.4z" />
        <path d="M212.8 160.2v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z" />
        <path d="M210 143.4h3.4v20.2H210zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-17.9v-3.3zm39.3 0v3.4h-17.9v-3.3z" />
        <path d="M178.1 152.3h3.4v11.3h-3.4z" />
        <path d="M178.1 152.3h3.4v11.3h-3.4z" />
        <path d="M178.1 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.2 0h3.3v11.3h-3.3z" />
        <path d="M170 160.2v3.4h-15.1v-3.4zm1-8.7v3.3h-9.6v-3.3z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M219.5 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.3-16.8h3.3v20.2H274z" />
        <path d="M293.5 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z" />
        <path d="M290.7 143.4h3.4v20.2h-3.4zm-8.4 0h3.4v20.2h-3.4zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z" />
        <path d="M258.9 152.3h3.4v11.3h-3.4z" />
        <path d="M258.9 152.3h3.4v11.3h-3.4z" />
        <path d="M258.9 152.3h3.4v11.3h-3.4zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3H234z" />
        <path d="M250.8 160.2v3.4h-15.2v-3.4zm1-8.7v3.3H242v-3.3z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M300.7 143.4h49v3.4h-49zm7.3 17h3.4v3.2H308zm41.9-.2v3.4H340v-3.4zm5.3-16.8h3.3v20.2h-3.3z" />
        <path d="M374.7 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3H340z" />
        <path d="M372 143.4h3.3v20.2H372zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z" />
        <path d="M340 152.3h3.5v11.3H340z" />
        <path d="M340 152.3h3.5v11.3H340z" />
        <path d="M340 152.3h3.5v11.3H340zm-39.2 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z" />
        <path d="M332 160.2v3.4h-15.2v-3.4zm1-8.7v3.3h-9.6v-3.3z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M381.4 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm42-.2v3.4h-9.9v-3.4zm5.2-16.8h3.4v20.2h-3.4z" />
        <path d="M455.4 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z" />
        <path d="M452.7 143.4h3.3v20.2h-3.3zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-17.9v-3.3zm39.3 0v3.4h-17.9v-3.3z" />
        <path d="M420.8 152.3h3.4v11.3h-3.4z" />
        <path d="M420.8 152.3h3.4v11.3h-3.4z" />
        <path d="M420.8 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.3z" />
        <path d="M412.7 160.2v3.4h-15.1v-3.4zm1-8.7v3.3H404v-3.3z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M462.2 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z" />
        <path d="M536.2 160.2v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z" />
        <path d="M533.4 143.4h3.4v20.2h-3.4zm-8.4 0h3.3v20.2H525zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z" />
        <path d="M501.6 152.3h3.3v11.3h-3.3z" />
        <path d="M501.6 152.3h3.3v11.3h-3.3z" />
        <path d="M501.6 152.3h3.3v11.3h-3.3zm-39.4 0h3.4v11.3h-3.4zm28.9 0h3.3v11.3h-3.3zm-14.3 0h3.4v11.3h-3.4z" />
        <path d="M493.4 160.2v3.4h-15.1v-3.4zm1-8.7v3.3h-9.6v-3.3z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M543.4 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z" />
        <path d="M617.4 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z" />
        <path d="M614.6 143.4h3.4v20.2h-3.4zm-8.4 0h3.3v20.2h-3.3zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z" />
        <path d="M582.8 152.3h3.3v11.3h-3.3z" />
        <path d="M582.8 152.3h3.3v11.3h-3.3z" />
        <path d="M582.8 152.3h3.3v11.3h-3.3zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3H558z" />
        <path d="M574.6 160.2v3.4h-15.1v-3.4zm1-8.7v3.3H566v-3.3z" />
      </g>
      <g fill="#fff" strokeWidth="1pt">
        <path d="M-183.8 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm42-.2v3.4h-9.9v-3.4zm5.2-16.8h3.4v20.2h-3.4z" />
        <path d="M-109.8 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z" />
        <path d="M-112.5 143.4h3.3v20.2h-3.3zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-17.9v-3.3zm39.3 0v3.4h-17.9v-3.3z" />
        <path d="M-144.4 152.3h3.4v11.3h-3.4z" />
        <path d="M-144.4 152.3h3.4v11.3h-3.4z" />
        <path d="M-144.4 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z" />
        <path d="M-152.5 160.2v3.4h-15.2v-3.4zm1-8.7v3.3h-9.6v-3.3z" />
      </g>
      <path
        fill="#d90000"
        d="M-68.8 339.5h6V350h-6zm160.5 0h6V350h-6zm-283.7 0h6V350h-6zm81.5 0h6V350h-6zm80.9 0h6V350h-6zm40 0h6V350h-6zm40.9 0h6V350h-6zm80.4 0h6V350h-6zm203 0h6.1V350h-6zm-162.1 0h6V350h-6zm40 0h6V350h-6zm40.5 0h6V350h-6zm40.4 0h6V350h-6zm323.2 0h6V350h-6zm-242.7 0h6V350h-6zm40.8 0h6V350h-6zm41.3 0h6V350h-6zm38.8 0h6V350h-6zm41.3 0h6V350h-6zm40.4 0h6V350h-6zm119.7 0h6V350h-6zm-38.8 0h6V350h-6zm-808.9 0h6V350h-6z"
      />
      <path
        fill="#239e3f"
        d="M-68.8 162.6h6v10.5h-6zm160.5 0h6v10.5h-6zm-283.7 0h6v10.5h-6zm81.5 0h6v10.5h-6zm80.9 0h6v10.5h-6zm40 0h6v10.5h-6zm40.9 0h6v10.5h-6zm80.4 0h6v10.5h-6zm203 0h6.1v10.5h-6zm-162.1 0h6v10.5h-6zm40 0h6v10.5h-6zm40.5 0h6v10.5h-6zm40.4 0h6v10.5h-6zm323.2 0h6v10.5h-6zm-242.7 0h6v10.5h-6zm40.8 0h6v10.5h-6zm41.3 0h6v10.5h-6zm38.8 0h6v10.5h-6zm41.3 0h6v10.5h-6zm40.4 0h6v10.5h-6zm119.7 0h6v10.5h-6zm-38.8 0h6v10.5h-6zm-808.9 0h6v10.5h-6z"
      />
      <g fill="#da0000">
        <path d="M279.8 197.5c8.4 10.4 34.5 67.6-15.7 105.2-23.7 17.8-9 18.6-8.3 21.6 38-20.1 50.3-47.5 50-72-.2-24.4-13.2-46-26-54.8z" />
        <path d="M284.8 194.8a73.3 73.3 0 0 1 15.7 112.4c27.2-6 62-86.4-15.7-112.4zm-57.6 0a73.3 73.3 0 0 0-15.6 112.4c-27.3-6-62-86.4 15.6-112.4z" />
        <path d="M232.2 197.5c-8.4 10.4-34.5 67.6 15.7 105.2 23.6 17.8 9 18.6 8.3 21.6-38-20.1-50.3-47.5-50-72 .2-24.4 13.2-46 26-54.8z" />
        <path d="M304.2 319.1c-14.9.2-33.6-2-47.5-9.3 2.3 4.5 4.2 7.3 6.5 11.7 13.2 1.3 31.5 2.8 41-2.4zm-95 0c14.9.2 33.6-2 47.5-9.3-2.3 4.5-4.2 7.3-6.5 11.7-13.2 1.3-31.5 2.8-41-2.4zm27.3-138.7c3 8 10.9 9.2 19.3 4.5 6.2 3.6 15.7 3.9 19-4.1 2.5 19.8-18.3 15-19 11.2-7.8 7.5-22.2 3.2-19.3-11.6z" />
        <path d="M256.4 331.6l7.8-9 1.1-120.1-9.3-8.2-9.3 7.8 1.9 121 7.8 8.5z" />
      </g>
    </g>
  </svg>
	),
	IS: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h640v480H0z" />
      </clipPath>
    </defs>
    <g fillRule="evenodd" strokeWidth={0} clipPath="url(#prefix__a)">
      <path fill="#003897" d="M0 0h666.7v480H0z" />
      <path
        fill="#fff"
        d="M0 186.7h186.7V0h106.6v186.7h373.4v106.6H293.3V480H186.7V293.3H0V186.7z"
      />
      <path
        fill="#d72828"
        d="M0 213.3h213.3V0h53.4v213.3h400v53.4h-400V480h-53.4V266.7H0v-53.4z"
      />
    </g>
  </svg>
	),
	IT: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#009246" d="M0 0h213.3v480H0z" />
      <path fill="#ce2b37" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	JE: () => (
  <svg viewBox="0 0 30 18">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-5.3-6h40v30h-40z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="matrix(.75 0 0 .75 4 2.3)">
      <path fill="#fff" d="M-10.3-6h50v30h-50z" />
      <path
        fill="#df112d"
        fillRule="evenodd"
        d="M-10.3-6v2L11.6 9l-21.8 13v2H-7l21.8-13 21.7 13h3.2v-2L18 9 39.8-4v-2h-3.3L14.7 7-7-6h-3.2z"
      />
      <g transform="translate(-9.7 -6) scale(.20361)">
        <path
          fill="#e8112d"
          stroke="#000"
          strokeWidth={0.1}
          d="M132.7 22.2c3.1 12.8 1.4 28.6-12.9 37.4-14.2-8.8-16-24.6-12.8-37.4 3.4-3 18.6-4.9 25.7 0z"
        />
        <path
          fill="#f9dd16"
          stroke="#000"
          strokeWidth={0.1}
          d="M119.8 19.7a26 26 0 0 1 13 3.1 28 28 0 0 1 4.9-12.1c-2.5 0-3.6 1.3-3.6 2.6-.6-1.7-3-1.6-3.8-.7 2.7 1.8.6 5-1.8 4.4-1.1-.3-1.7-1.1-2-2.3a1.3 1.3 0 1 0-.5 0 2.9 2.9 0 0 1-3.1 1.3c-1.3-.3-1.9-1.5-1.9-2.5 0-2.7 2.6-3.1 3.4-2.6 0-1.8-2.9-3.3-3.8-1.8a4.8 4.8 0 0 0-.8-5.8A4.8 4.8 0 0 0 119 9c-.9-1.5-3.7 0-3.7 1.8.7-.5 3.3-.1 3.3 2.6 0 1-.6 2.2-1.8 2.5a3 3 0 0 1-3.2-1.3 1.3 1.3 0 0 0 .6-.4 1.3 1.3 0 1 0-1.1.4c-.2 1.2-.9 2-2 2.3a2.4 2.4 0 0 1-1.8-4.4c-.8-1-3.2-1-3.8.7 0-1.3-1.1-2.6-3.6-2.6a28 28 0 0 1 5 12.1 26 26 0 0 1 13-3.1z"
        />
        <g id="prefix__b" stroke="#000">
          <g fill="#f9dd16" strokeWidth={0.1}>
            <path d="M130.7 32.2c-.4 0-.4.5-.5.5.8 0 1.2-.3 1.4-.7v.6c.6-.2.8-.7.6-1l.7.2c-.4-.3-.1-1-.8-1.4.2 0 .6.2.8.5-.1-.7-.2-1.1-.8-1.5h.5a.9.9 0 0 1-.4-.8c0-.4-.2-.4-.6-.3l-1.8.1c-1 0-2 0-2.8-.6 1.3.6 3-.6 3-1.5 0-1-1.4-2-4-1.4-2.6.6-5.8.4-5.8-.5s2.3-1 3.5-.8c1.2.2 2 .3 4.2-.5-.5.2-2.3.3-3.7-.1s-4.8-.4-4.8 1.4c0 1.9 3.6 1.7 6.8 1.2 1.8-.2 2.8 0 2.8.5 0 .6-1.7.8-3 .7a10 10 0 0 0-4.1.3c-1.3.4-2.2 0-3.6.3-.7 0-2.4 0-3.2-1.4-.5.4-2 1.1-2.3 1.9-.3.6 0 1.3.4 2 .6.8-.3.7-1 .7-.8 0-2 0-2.6-.8-.6-.6-1.3-1.1-1.9-.7-.3.3 0 .6.2.5l.8.2a1 1 0 0 0-1 .1c-.3.2 0 .6.3.5.2-.1.7-.2 1 0-.3 0-.7 0-.8.2s0 .4.3.4c.6 0 .7.4 1.3.3a.9.9 0 0 0-.7.4c.6-.3 1.1.4 1.8.2-.2.1-.7.4-.7.6.4-.5 3.2.4 3.2-.7l-.1.8c.3-.2 1.4-.3 1.8-1 0 .2 0 .5-.2.6.3 0 .8-.2 1.3-.9.2-.3.2-.5.2-.7.5 0 .8-.1 1.2-.4.4-.3.8.3 1.5-.2.6-.4 1.2 0 1.6-.2.3-.2.8 0 1.2-.2s1 .1 1.6-.4c1 .4 2.3 1 5.2.5 1.6-.3 2.2.3 2.2 1 0 .6-.4.6-.6.6-1 .1-1.3-.3-1.7-.2-.2.1-.4.5 0 .7-.3.1-.3.4-.1.5s.5 0 .8-.1c-.4.1-.7.4-.5.7.1.2.4.3.7 0 .3-.4.8-.7 1.2-.7zm-18.6-8c-.8-.3-1-.3-.9.4 0 .3.3.7.5.9 0-.3.1-1 .4-1.2z" />
            <path d="M114.8 24.3c.8-.4 1.1-.4.9.3 0 .3-.3.7-.5.9 0-.3 0-1-.4-1.2z" />
            <path d="M113.5 23.8c1.6 0 1.8.8 1.7 1.7 0 1-.5.6-.8 2-.1.4-.5.5-1 .5-.3 0-.7 0-.9-.6-.3-1.3-.8-1-.8-2 0-.8.2-1.6 1.8-1.6z" />
            <path d="M109.4 27.5c-.4-.2-.7 0-.9 0 .6.1.6.8 1.8 1-.3 0-.4.2-.7 0 .5.4 1 .9 2.2.9.7 0 .2.3-.2.1.4.5 1.3.1 1.9 1 0-.7-1-1.7-.5-2.4-1.7-.1-1.8-1-2.7-1.7-.8-.6-.9-1.2-1.2-2.3-.1-.5-.7-.8-1-.7-.3 0-.5.3-.2.5.2.2.6.2.6.7-.3-.4-.8-.5-1-.3-.1.2 0 .5.2.5.5 0 .2.6.7 1-.5-.5-.9-.6-1.2-.3-.1.2 0 .5.4.5.5 0 1 1.2 1.8 1.5zm13 4.6c-.2 0-.1.5-.5.5.8 0 1.3-.2 1.6-.5l-.2.5c.4-.3 1.5-.4 2-.3s.6-.1.8-.4c.2-.4 0-.6-.3-.8-.3-.3-.4-.7-.3-1.3-1.4-2-4-1-4-.2.9 1.1 1 1 1.8 1.1.7.2 1.2.2.7.6-.2.2-1 0-1.5.1-1.3 0-2-.9-2.3-.4-.3.4 0 .6.6.6-.4 0-1 0-.9.4.2.7.8-.1 1.1.1-.2 0-.6.1-.6.3 0 .2.5.5 1 0a1.6 1.6 0 0 1 1-.3z" />
          </g>
          <path
            fill="none"
            strokeWidth={0.1}
            d="M123.5 29.2c-.4-.2-.9-.3-1.4-.2m-5.6 0c-.4.8-.2 1.2-.1 1.6m-4-5.6c.2.2.4-.2.8.2-.1-.1-.3.3-.6 0m2-.1c-.3 0-.5-.3-.9.1.1-.1.3.3.6 0m-.6 0v.3c.1.7.3 1-.3 1-.5 0-.3-.3-.2-1v-.3"
          />
          <path
            fill="#ff0016"
            strokeWidth={0.1}
            d="M113.5 27.7c.4 0 .6 0 .6-.6 0-.2.3-.3.1-.7.2.4-.7.4-.7.2 0 .2-1 .2-.8-.2-.1.4.2.5.1.7 0 .6.2.6.7.6z"
          />
          <path
            strokeWidth={0.1}
            d="M113 26.5l-1-.3m1 .3h-1m1 .1l-.9.3m1.7-.4l1-.3m-1 .3h1.2m-1.2.1l1 .3"
          />
          <path
            fill="#0051ba"
            strokeWidth={0}
            d="M108.1 23.4c-.3-.4-1 0-1 .4.2-.3.6.1.9 0 .1 0 .3-.2.1-.4zm-.3.9c-.3-.4-1.1 0-1.1.4.2-.3.6.1.9 0 .1 0 .3-.3.2-.4zm-.2 1.2c-.4-.4-1.1 0-1 .5.2-.3.6 0 .8 0 .2-.1.3-.4.1-.5zm.3 3.7c-.4-.4-1 .1-1 .6.2-.4.7 0 1-.2 0 0 .2-.3 0-.5zm0 .7c-.5-.1-1 .6-.7 1 0-.5.6-.3.8-.5l-.1-.5zm.6.7c-.5-.2-1 .4-.7.8 0-.3.6-.2.7-.4v-.5zm11.7 1.1c-.5-.1-1 .5-.7 1 0-.5.6-.3.8-.5l-.1-.5zm.6.6c-.5-.1-.9.6-.6 1 0-.5.6-.4.7-.6.1-.1.1-.4 0-.4zm-.4-1.4c-.4-.2-1 .4-.9.8.2-.4.7-.1.9-.3V31zm8.3 1c-.4-.1-.8.6-.6 1 0-.4.6-.3.8-.5 0-.2 0-.5-.2-.5zm0-.7c-.4-.3-1 .3-.8.7.2-.3.7-.1.9-.3v-.5zm.4 1.3c-.5 0-.9.7-.6 1 0-.4.6-.3.7-.5.1-.2 0-.4-.1-.5zm-15.6-5.2c.3 0 .4.1.4.7 0 1 0 1.6-.4 1.6-.3 0-.3-.5-.3-1.3 0-.4 0-.7-.1-.6 0-.3.1-.4.4-.4z"
          />
        </g>
        <use
          width={30}
          height={18}
          transform="matrix(.9 0 0 .9 11.6 13.7)"
          xlinkHref="#prefix__b"
        />
        <use
          width={30}
          height={18}
          transform="matrix(.67 0 0 .75 39.2 27.5)"
          xlinkHref="#prefix__b"
        />
      </g>
    </g>
  </svg>
	),
	JM: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path d="M0 0l320 240L0 480zm640 0L320 240l320 240z" />
      <path fill="#090" d="M0 0l320 240L640 0zm0 480l320-240 320 240z" />
      <path fill="#fc0" d="M640 0h-59.6L0 435.3V480h59.6L640 44.7z" />
      <path fill="#fc0" d="M0 0v44.7L580.4 480H640v-44.7L59.6 0z" />
    </g>
  </svg>
	),
	JO: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-117.8 0h682.6v512h-682.6z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="translate(110.5) scale(.9375)">
      <g fillRule="evenodd" strokeWidth="1pt">
        <path d="M-117.8 0h1024v170.7h-1024z" />
        <path fill="#fff" d="M-117.8 170.7h1024v170.6h-1024z" />
        <path fill="#090" d="M-117.8 341.3h1024V512h-1024z" />
        <path fill="red" d="M-117.8 512l512-256-512-256v512z" />
        <path
          fill="#fff"
          d="M24.5 289l5.7-24.9H4.7l23-11-15.9-19.9 23 11 5.6-24.8 5.7 24.9L69 233.2l-16 19.9 23 11H50.6l5.7 24.9-15.9-20z"
        />
      </g>
    </g>
  </svg>
	),
	JP: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-88 32h640v480H-88z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="translate(88 -32)"
    >
      <path fill="#fff" d="M-128 32h720v480h-720z" />
      <ellipse
        cx={523.1}
        cy={344.1}
        fill="#d30000"
        rx={194.9}
        ry={194.9}
        transform="translate(-168.4 8.6) scale(.76554)"
      />
    </g>
  </svg>
	),
	KE: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <path
        id="prefix__a"
        strokeMiterlimit={10}
        d="M-28.6 47.5l1.8 1 46.7-81c2.7-.6 4.2-3.2 5.7-5.8 1-1.8 5-8.7 6.7-17.7a58 58 0 0 0-11.9 14.7c-1.5 2.6-3 5.2-2.3 7.9z"
      />
    </defs>
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path d="M0 0h640v144H0z" />
    <path fill="#060" d="M0 336h640v144H0z" />
    <g id="prefix__b" transform="matrix(3 0 0 3 320 240)">
      <use width="100%" height="100%" stroke="#000" xlinkHref="#prefix__a" />
      <use width="100%" height="100%" fill="#fff" xlinkHref="#prefix__a" />
    </g>
    <use
      width="100%"
      height="100%"
      transform="matrix(-1 0 0 1 640 0)"
      xlinkHref="#prefix__b"
    />
    <path
      fill="#b00"
      d="M640.5 168H377c-9-24-39-72-57-72s-48 48-57 72H-.2v144H263c9 24 39 72 57 72s48-48 57-72h263.5V168z"
    />
    <path
      id="prefix__c"
      d="M377 312c9-24 15-48 15-72s-6-48-15-72c-9 24-15 48-15 72s6 48 15 72"
    />
    <use
      width="100%"
      height="100%"
      transform="matrix(-1 0 0 1 640 0)"
      xlinkHref="#prefix__c"
    />
    <g fill="#fff" transform="matrix(3 0 0 3 320 240)">
      <ellipse rx={4} ry={6} />
      <path id="prefix__d" d="M1 5.8s4 8 4 21-4 21-4 21z" />
      <use
        width="100%"
        height="100%"
        transform="scale(-1)"
        xlinkHref="#prefix__d"
      />
      <use
        width="100%"
        height="100%"
        transform="scale(-1 1)"
        xlinkHref="#prefix__d"
      />
      <use
        width="100%"
        height="100%"
        transform="scale(1 -1)"
        xlinkHref="#prefix__d"
      />
    </g>
  </svg>
	),
	KG: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-85 0h682.7v512H-85z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(79.6) scale(.9375)"
    >
      <path fill="#be0027" d="M-128 0h768.8v512H-128z" />
      <path
        fill="#ff0"
        d="M105.5 261.1c13.6-16.6 41.9-.4 65-12.3-27.4 1.5-42.3-13.2-63.9-11.1 22.4-13.8 41.5 4.5 66.5-2.8-33.1-2.8-31.7-17.7-61.9-19.8 26.8-11.4 40 11.8 66.3 6.5-31-7.1-35-25.3-58-29.2 33.6-5 31.4 14.8 64.3 17.2-33.4-14.3-24.7-26.8-52.6-37.7 31.3-.7 29.2 21 61 26.6-27.2-17.2-23.9-32.9-46.2-45.2 26.5.5 29 27.6 56.1 36-24.1-19.1-17.8-35.3-38.6-52.4 26.4 6.2 22.5 29.6 50 44.6-20.4-22.6-12.6-38.8-30.3-57.3 25.4 8.1 15.7 30.4 42 51.6-15-24.9-5.7-40.8-20.6-61.7 23.6 12.1 12.2 34.9 34 57.5-10.3-25.5 0-41.3-10.5-63.9 20.2 15 8.2 39.3 24.5 62.5-6-32 7.8-37.2 3.5-65.2 15.3 18.8-1.8 37.6 10 65.3-1.5-31.5 15.3-38.8 12.4-64 15.1 22.6-8.5 42.3 1.4 66.5 2.5-29.8 22.1-37.6 22.4-60.8 12 21.3-14 36.7-9.8 65 8.5-31.2 29.4-35 32-56 7.1 24.6-21.4 36-19.7 63.4 8.5-27.7 34.6-31 40-51.4 3.3 26-22.4 30.7-29.7 59.5 13.5-23.5 37.2-25.4 47.8-44-.8 25.8-29.8 29.2-38.7 53.3 16.7-20.5 37.7-17 54.4-35.1-1.8 23.3-31.3 22-47 46.1 18.1-16.7 45.4-11.7 59.3-26.1-.7 20.6-36.9 19-54 37.5 21-11.6 47.8-4.8 63.2-15.5-2.8 18-41 13.8-59.3 28 25.2-7 44.7 3.7 65-4-9.9 17.5-44.6 6.4-63 17.8 22-3.7 45.2 9.6 65.1 5.3-6.5 15.2-44.6-1-65 8.5 24.4-.2 40.3 15.5 63 14.4-12.3 13.8-45.7-5.1-65.2-1.9 23.8 5 42 24.6 60 25.6-14.9 11.3-42.5-14.5-65-11.3 23.2 6.2 42.6 32.5 55.8 33.1-14.3 9.8-42.5-22.5-61.8-21.3 23.5 10.6 34.2 37.5 49.7 41.3-19.1 6.1-37.9-29.2-58.4-30.5 23.8 15 25.1 38 43.4 48.2-19.3 4.7-33-35.2-53.3-38.6 19.5 14.3 22.5 45 35.4 54.6-19.6 1-26.7-40.7-46.8-46.7 17.2 14.4 13.1 45.6 26.5 59-20.4-4.3-17.8-40.6-39.1-52.9 15.3 19.4 7.5 46.9 17.5 62.4-19.9-8-11.3-40.6-30.2-59 10.3 20.6-.8 44.6 7.4 64.5-18.2-8.9-6-47.4-19.9-62.7 6.4 23.8-5.4 43.5-.6 64.8-18.6-21.5 2.8-43.2-13.3-65.1 4.2 25.1-13.4 42.7-10.6 63.7-14.7-17.2 8-44.7-3.5-66.4 2.4 24.7-20.3 46.4-18.7 62-12-20 13.3-43.6 6.5-66.3-1.4 23.6-24.4 36.4-28.7 57.9-7.7-23.7 19.6-40.8 17.2-64.1-7.8 22.1-30 31-37.8 52.5-6.4-23.7 26-36.2 26.8-61-10 23.2-36.5 28.4-45.3 46.2-3.3-23.5 33.8-34 35.2-56.3-12 21.4-41 22.3-51 39.3-1.5-23.4 37.6-26.3 43.7-50.8-11.9 18.2-43.7 15.9-57 30.7 2.1-21.7 44.4-23 51.2-42.6-15.8 15.2-45 9-61.5 21 9.2-21.4 48.9-16.9 57.8-32.3-17.5 9.1-48.6.2-64 9.4 14-20.2 44.8-8.1 62.3-22-28.4 4.1-45.5-7.2-65.2-2z"
      />
      <path
        fill="#ff0"
        d="M356 256.1a99.2 99.2 0 1 1-198.5 0 99.2 99.2 0 0 1 198.4 0z"
      />
      <path
        fill="#be0027"
        d="M343.2 256.3a86.3 86.3 0 1 1-172.6 0 86.3 86.3 0 0 1 172.6 0z"
      />
      <path
        fill="#ff0"
        d="M331.2 256.5a74 74 0 1 1-148.2 0 74 74 0 0 1 148.2 0z"
      />
      <path
        fill="#be0027"
        d="M194 208c20.5-.5 46 1.4 62.9 14.8a97.1 97.1 0 0 1 60.5-14.3l11 20.1a101 101 0 0 0-50 8.2 85.3 85.3 0 0 1 34.6 72.1c-2.7 3.4-7 7.1-9.7 10.5 4-28.5-11-60.3-32.9-77 17.8 25.6 28.3 48.6 25.4 80.4l-10 6.4c4.6-28-2-61-22.7-80 12 17.5 23.8 49 16.4 81-3.2 1-8.2 3.7-11.4 4.6a96 96 0 0 0-10.8-78.7c-13.8 19.8-18.3 50-10.5 78-3.8-1-6.7-2.2-10.6-3.1-5.7-30 2.2-64 15.9-81.7-14 8.1-27.1 42.7-23.4 78l-9.3-4.3c-4.5-26.3 7.4-60.6 24.5-80.4-19.4 12.2-35.2 42.3-32.5 74.6-3-2.6-5.7-3.9-8.7-6.6-3.4-28.2 13-56.6 32.1-73.6-16.1-7.3-30-8.7-50-8.4 3.1-6.5 6-14.1 9.2-20.7z"
      />
    </g>
  </svg>
	),
	KH: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#032ea1" d="M0 0h640v480H0z" />
    <path fill="#e00025" d="M0 120h640v240H0z" />
    <g fill="#fff" stroke="#000" transform="matrix(1.2 0 0 1.2 85.6 -522)">
      <g strokeLinejoin="bevel">
        <path d="M139 623.5h113.8v43.8H139z" />
        <path d="M247 647.6h3.5v16.5H247zm-108-8.1h113.8v5H139zm0-7h113.8v4.6H139z" />
        <path strokeWidth={0.9} d="M139 625.7h113.8v4.3H139z" />
        <path d="M169 647.6h3.6v16.5H169zm49 0h3.6v16.5H218zm-78 0h3.5v16.5H140zm7 0h3.5v16.5H147zm7.5 0h3.5v16.5h-3.5zm7.5 0h3.5v16.5H162zm62.8 0h3.6v16.5h-3.6zm7.5 0h3.6v16.5h-3.6zm7.5 0h3.6v16.5h-3.6z" />
        <path
          strokeLinejoin="miter"
          d="M94.5 669.5a9.3 9.3 0 0 0 4.4-5.3H292a9.3 9.3 0 0 0 4.4 5.3z"
        />
      </g>
      <path d="M193 556.8s-.1-4.1 2.3-4.2c2.3 0 2.2 4.2 2.2 4.2zm-12.5 54.5v-5.5c0-2.8-2.8-3-2.8-5 0 0-.4-3 .4-4.4 1.1 4 3 3.3 3 1.6 0-1.4-1-2.8-3.3-6.3-.8-1.1-.3-4.6.7-5.9.4 3 .9 4.5 2.2 4.5.8 0 1.4-.5 1.4-2 0-2-1.3-3-2-4.8a5 5 0 0 1 1.1-5.3c.5 3 .4 4.2 1.7 4.2 2.7-.9 0-4.8-.6-5.8-.6-1.1 1-3.4 1-3.4.8 2.7 1 2.9 2 2.6 1.2-.3 1-2-.4-3.4-.9-1-.8-2.3.2-3.3 1 1.9 2.2 1.8 2.3.6l-.8-4.4H204l-.9 4.3c-.2 1.2 1.4 1.5 2.4-.5 1 1 1.1 2.4.2 3.3-1.4 1.4-1.6 3.1-.4 3.4 1 .3 1.2 0 2-2.6 0 0 1.5 1.5 1 3.4-.6 1-3.3 5-.6 5.8 1.3 0 1.2-1.2 1.7-4.2a5 5 0 0 1 1 5.3c-.6 1.8-2 2.8-2 4.8 0 1.5.7 2 1.5 2 1.3 0 1.8-1.4 2.2-4.5 1 1.3 1.5 4.8.7 6-2.3 3.4-3.4 4.8-3.4 6.2 0 1.7 2 2.4 3-1.6.9 1.4.5 4.4.5 4.4 0 2-2.7 2.2-2.8 5v5.5zm7.2-46l-.4-3.1h15.9l-.4 3.1zm1-3.2l-.2-2.5H202l-.3 2.5zm2.3-2.6l-.3-2.6h9l-.1 2.6zm33 110c-2-.7-5-2.9-5-5v-24.3l2.6-3.4H169l2.5 3.4v24.3c0 2.1-2 4.3-4 5z" />
      <path
        strokeLinejoin="bevel"
        d="M178.2 647.6h3.6v16.5h-3.6zm30.4 0h3.6v16.5h-3.6z"
      />
      <path d="M168 609.2v27.6h54v-27.6a4.2 4.2 0 0 0-2.6 2.8v11.8h-48.7V612s-.6-2-2.8-2.8z" />
      <path d="M214.6 669.5c-1.8-.7-5.6-2.9-5.6-5v-27.2c.4-1.5 2.4-2.4 3.7-3.4H177c1.7 1 3.6 1.7 4.3 3.4v27.2c0 2.1-3 4.3-4.8 5z" />
      <path d="M219.4 634.2v-19.6h-4.9v-1.9h-38.8v2h-5v19.5zM207 669.5c-1.8-.7-4.3-2.9-4.3-5v-23.2l1.4-2.1h-17.7l1.5 2v23.3c0 2.1-2.6 4.3-4.3 5z" />
      <path d="M190.7 639.2h9v30.3h-9z" />
      <path
        strokeLinejoin="bevel"
        d="M204.4 632.5c0-2 5.8-2.1 8.8-3.8h-36c3 1.7 8.7 1.8 8.7 3.8l1.2 3.9 15 .6z"
      />
      <path d="M211.4 611.3c0-4.9.2-6.7 1.7-6.7V620c-3.7 1.4-6.3 6-6.3 6h-23.2s-2.6-4.6-6.3-6v-15.5c1.8 0 1.8 2 1.8 6.7zm1.7-2c0-5.6 4.9-6.2 4.9-6.2v5c-1.9-.1-2.8 1.6-2.8 4 0 2.5 1.5 2.5 1.5 2.5v14.2h-3.6z" />
      <path d="M177.3 609.3c0-5.6-4.9-6.2-4.9-6.2v5c1.9-.1 2.8 1.6 2.8 4 0 2.5-1.5 2.5-1.5 2.5v14.2h3.6z" />
      <g fill="none" strokeWidth={0.8}>
        <path d="M186.8 570.6H204m-19.2 5.4h21m-23 6.5h24.9m-27 7.9h29.5m-30.2 9h30.4" />
        <path strokeWidth={1} d="M170.8 629h48.6m-33.2 0h18v6.6h-18z" />
      </g>
      <path d="M184 614.2c3 3.6 2.6 9.7 2.6 13.3H204c0-3.6-.4-9.7 2.6-13.3zm9.7-41l-2.4-1.3v-3.5c1 .3 2 .4 2.2 2 .3-2.3 1-2.1 1.9-3 1 .9 1.5.7 1.9 3 0-1.6 1.2-1.7 2.1-2v3.5l-2.3 1.2z" />
      <path d="M193.5 578.9l-4-2.8V573c1.5.3 3 .5 3.2 2.2.4-2.5 1.3-3.7 2.7-4.7 1.3 1 2.2 2.2 2.7 4.7.1-1.7 1.7-1.9 3-2.2v3.2l-3.9 2.7z" />
      <path d="M193.2 587.8l-4.5-4v-4.7c1.6.4 3.4.6 3.6 3.1.5-3.5 1.5-5.4 3-6.8 1.6 1.4 2.6 3.3 3.2 6.8.2-2.5 2-2.7 3.6-3.1v4.7l-4.6 4zm8.4 5.3l-4 5.7h-4.7l-4.1-5.7zm-15.2 9.5c2 1.1 2.8 3.4 3 7.6H201c.2-4.2 1-6.5 3-7.6z" />
      <path
        strokeLinejoin="bevel"
        d="M204.2 593v-5.6a5.2 5.2 0 0 0-3.8 3.3c0-2-2.5-6.3-5.2-8.5-2.7 2.4-5.3 6.4-5.2 8.4-.5-1.5-1.8-2.7-3.8-3.2v5.7z"
      />
      <path
        strokeLinejoin="bevel"
        d="M205 602.6V597c-2.1.6-3.5 1.7-4.1 3.3 0-2-2.7-6.3-5.7-8.5-3 2.5-5.8 6.4-5.7 8.5-.5-1.5-2-2.7-4.1-3.3v5.7z"
      />
      <path
        strokeLinejoin="bevel"
        d="M207.4 614.3v-6.6a9.6 9.6 0 0 0-5.1 3.8c0-3.5-4-9-7.1-10.7-3.2 1.8-7.1 7.4-7.1 10.7a9.7 9.7 0 0 0-5.2-3.8v6.6z"
      />
      <path
        strokeLinejoin="bevel"
        d="M206 629v-6.8c-2.4.9-3 3.1-3.8 4.7.3-6.9-3.8-14.2-7-16.1-3.2 1.9-7.4 9.4-7 16-.8-1.4-1.5-3.7-3.8-4.6v6.7z"
      />
      <path d="M204.4 639.2v-6.8c-2.5.6-2.6 1.5-3.4 3 .3-4.1-2.6-8.8-5.8-10.6-3.2 1.8-6 6.5-5.8 10.6-.8-1.5-.9-2.4-3.4-3v6.8z" />
      <g id="prefix__a">
        <path d="M99 664.2v-20.4c-.7-2.6-3-5-4.6-5.4v-18l3.7 2 4.3 18.9v23z" />
        <path d="M99 664.3v-20.5c-.7-2.6-3-5-4.6-5.4v-19.2c2.5 0 3.7 3.2 3.7 3.2l4.3 18.9v22.9z" />
        <path d="M96.3 669.5c1.7-.7 4.2-2.9 4.2-5v-25.6l-1.2-2H143l-1.7 2v25.6a6 6 0 0 0 3.4 5z" />
        <path d="M135.8 669.5c-1.7-.7-4.2-2.9-4.2-5v-24.3l3.6-3.4h-29.6l3.6 3.4v24.3c0 2.1-2.5 4.3-4.2 5z" />
        <path d="M131.7 669.5c-1.7-.7-4.3-2.9-4.3-5v-22l2.4-3.3H111l2.4 3.3v22c0 2.1-2.5 4.3-4.3 5z" />
        <path d="M116 639.2h8.9v30.4h-9z" />
        <path
          strokeLinejoin="bevel"
          d="M103.7 647.6h3.6v16.5h-3.6zm30.8 0h3.5v16.5h-3.6zm-33.9-27.8h4.4v17h-4.4zm0-3.2h4.3v3.2h-4.3zm35.6 6.9h6.1v13h-6.1z"
        />
        <path d="M104.9 636.6v-29c1.2 0 1.4 4.3 4.2 4.3 1.5 0 1.4-1.8.5-3.2-.7-1.3-1.6-3-.4-6.3.9 2.5 3.1 3.3 2.7 1.8-.7-2.7-2.8-3.2-1.2-7.3.5 3.4 2.7 3.3 2.2 1.3-.6-2.3-1.9-3.3-.3-6.5.9 3.7 2 3.5 2 1.2 0-3.4 0-7 4.2-8.3 0 0 .3-3 1.9-3 1.5 0 1.8 3 1.8 3 4.3 1.3 4.2 5 4.2 8.3 0 2.3 1.1 2.5 2-1.2 1.6 3.2.3 4.2-.3 6.5-.5 2 1.7 2.1 2.2-1.3 1.6 4.1-.5 4.6-1.2 7.3-.4 1.5 1.8.7 2.7-1.8 1.2 3.3.3 5-.4 6.3-.8 1.4-1 3.2.5 3.2 2.8 0 3-4.2 4.2-4.2v28.9zM98 614.7v22.1h2.5v-22.1c-.9-.5-1.7-.5-2.5 0z" />
        <path d="M98.2 629c3.1 1.6 6.2 3.5 7 7.8h-7zm43.2-6.6v14.4h2v-14.4c-.6-.3-1.5-.4-2 0z" />
        <path d="M143.4 629c-3.1 1.5-6.2 3.3-7 7.7h7zm-20.6-33.7l1.8-1.5v-2c-.6 0-1 .3-1.5 1a5 5 0 0 0-2.5-3 5 5 0 0 0-2.6 2.9c-.5-.7-.8-.8-1.5-1v2l1.8 1.6z" />
        <path d="M123.8 600.2l.8-1.9v-2.5c-.6 0-1 .3-1.5 1a5 5 0 0 0-2.5-3 5 5 0 0 0-2.6 2.9c-.5-.7-.8-.8-1.5-.9v2.5l.8 1.9z" />
        <path d="M124 606.8l2.6-3.3v-3.2c-1 0-1.5.5-2.2 1.6-.7-2.3-2-2.7-3.8-3.8-1.9 1-3.2 1.5-3.8 3.7-.8-1.1-1.3-1.4-2.3-1.5v3.2l2.7 3.3z" />
        <path d="M124.7 613.3s3.2-2.7 3.3-4.2v-3.5c-1.2.1-2.3.4-3.2 1.9-.8-2.9-2-3.7-4.2-5-2.3 1.3-3.5 2.1-4.2 5-1-1.5-2-1.8-3.3-2v3.6a15 15 0 0 0 3.3 4.2z" />
        <path d="M126 625.3s4.4-4.7 4.5-6.6v-5.4c-1.6.2-3.2 1.3-4.4 3.6-1-4.5-2.6-7.6-5.5-9.8-3 2.2-4.6 5.3-5.6 9.8-1.2-2.3-2.7-3.4-4.3-3.6v5.4c.3 1.9 4.4 6.6 4.4 6.6z" />
        <path d="M126 632.4s3.7-3.7 4.5-5.3v-5.4c-1.6.2-3.2 1.3-4.4 3.5a14 14 0 0 0-5.5-9.2c-3 2.2-4.6 4.7-5.6 9.2-1.2-2.2-2.7-3.3-4.3-3.5v5.4c1 1.6 4.4 5.3 4.4 5.3z" />
        <path d="M127.5 636.6c-1-4.7-2-8.2-7.1-11.7-5.2 3.5-6.1 7-7.2 11.7z" />
        <path d="M130.2 639.2v-6.8c-2.4 1-4.5 2.3-5.3 3.8-.8-3.8-2.5-5.4-4.6-7.7-2.1 2.3-3.5 4-4.4 7.7-.8-1.5-2.9-2.9-5.2-3.8v6.8z" />
      </g>
      <use
        width="100%"
        height="100%"
        transform="matrix(-1 0 0 1 390.7 0)"
        xlinkHref="#prefix__a"
      />
      <path d="M72.7 694.3H318v12.5H72.7zm-6.5 12.5h258.3v12.5H66.2zm19.4-31.3H305v8.1H85.6z" />
      <path d="M79.2 683.6h232.4v10.6H79.2zm10.2-14.3h212v6.2h-212z" />
      <path d="M112.4 669.3h16v50h-16z" />
      <path d="M116 669.3h8.9v50h-9zm71 0h16v50h-16z" />
      <path d="M190.7 669.3h9v50h-9zm71.5 0h16v50h-16z" />
      <path d="M265.7 669.3h9v50h-9z" />
      <path
        fill="none"
        d="M99 664.2h193M115.8 713h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m65.8 37.5h8.6m-8.6-6.3h8.6m-8.6-6.2h8.6m-8.6-6.3h8.6m-8.6-6.2h8.6m-8.6-6.3h8.6m-8.6-6.2h8.6m66.2 37.5h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2"
      />
    </g>
  </svg>
	),
	KI: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-86.3 0h682.6v512H-86.3z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="translate(81) scale(.9375)">
      <path
        fill="#e73e2d"
        fillRule="evenodd"
        d="M-164.3 0h835.8v306.5h-835.8z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M204.3 282.1c-19.4-15.2-55.6-10-61.6-51.3 27.7 21.5 22.7-1.2 64 19.3l-2.4 32z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M209.5 263.4c-13.9-20.4-50-26.6-43-67.7 19.9 28.9 22 5.7 55.2 37.9l-12.2 29.8z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M215.8 250c-5-24.1-36-43.6-13.8-79 7.2 34.4 18 13.8 36.4 56.2L215.8 250z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M230.3 237.6c2.7-24.5-20.8-52.6 11.1-79.4-3.6 34.9 13 18.7 17.5 64.6l-28.6 14.8z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M243.3 227.7c12.4-21.3 2.5-56.5 42.6-67.9-17.6 30.3 4.2 22.3-10.5 66l-32.1 1.9z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M262 230.3c18.6-16.2 20.4-52.8 62-50.9-26.3 23.2-3 22.5-31 59.4l-31-8.5z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M278.6 239.9c22.5-10.1 34.9-44.5 74.1-30.5-32 14.5-9.5 20.7-47 47.7l-27.1-17.2z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M292.5 255c24.4-3.4 46-33 79.7-8.4-34.7 4.9-15 17.1-58.5 32.5l-21.2-24.2z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M379.5 259.6l-112.1 2.5 4.7 30.2 107.4-32.7z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M363 218.4l-103.8 39.9 17.3 33.3 86.5-73.2z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M280.6 280.7l53.7-97.6-82.4 76.7 28.7 20.9z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M279.5 272.6l17.2-109.4-53.8 97.2 36.6 12.2z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M273 263.7l-18-110.2-20 110.7 38-.5z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M263.7 254.3l-52.3-92 20 111.8 32.3-19.8z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M255.6 253.6l-81.1-68.5 57.6 98 23.5-29.5z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M146 218.9l87 71.9 13.4-37.6L146 218.9z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M232.1 260.9l-102.3-1.5 101.9 34 .4-32.5z"
      />
      <path
        fill="#fec74a"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M315.1 279.2a61.4 61.4 0 1 1-122.7 0 61.4 61.4 0 0 1 122.7 0z"
      />
      <path
        fill="#005989"
        fillRule="evenodd"
        d="M-165.1 303.4h839.9V512h-840z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M-165.6 454c15.6 7.2 38 25.3 62 25.3 40-.3 41-27.4 81.6-26.1 40.7 1 33.3 29.6 88.2 29.5 45.4-.2 60-34.7 99.2-30.6 29-1.5 40.8 32.7 85.3 33.2 46.2 1 63.1-37.3 92-34.1 31 0 41 30.8 84.3 31 55.2.3 64.9-32 99.3-30 24.6-.5 44 23.7 80 24.3 28.6.5 52.7-21.2 69-29l.7-36.8c-17 6.3-42.4 27.1-67.7 27.3-36.6 1.4-59.1-24-84.5-23.7-30.4.3-42.5 31.3-94 31.3-47.2 0-58-31.3-88.4-31.3-29.7.2-38.8 34-90.3 33.4-42-.5-58.3-32.3-88-32-31.5 0-64 30.9-99 29.4-48-2-58.5-29.4-90-29.4-23.5 0-49 25.6-77.3 26-28.2.5-59.9-25.5-62.8-26l.4 38.3zm0-73c15.6 7.3 38 25.4 62 25.4 40-.3 41-27.4 81.6-26.2 40.7 1 33.3 29.7 88.2 29.5 45.4 0 60-34.6 99.2-30.5 29-1.5 40.8 32.7 85.3 33.1 46.2 1 63.1-37.2 92-34 31 0 41 30.8 84.3 31 55.2.3 64.9-32 99.3-30 24.6-.5 44 23.7 80 24.3 28.6.5 52.7-21.2 69-29l.7-36.8c-17 6.3-42.4 27-67.7 27.3-36.6 1.3-59.1-24-84.5-23.7-30.4.3-42.5 31.3-94 31.3-47.2 0-58-31.3-88.4-31.3-29.7.2-38.8 34-90.3 33.4-42-.5-58.3-32.3-88-32-31.5 0-64 30.8-99 29.3-48-2-58.5-29.4-90-29.4-23.5 0-49 25.7-77.3 26.1-28.2.4-59.9-25.5-62.8-26l.4 38.3z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M-165.6 309c15.6 7.2 38 25.2 61.9 25.2 40-.2 41-27.4 81.6-26.1 40.6 1 33.2 29.6 88.1 29.5 45.3-.1 60-34.7 99-30.5 29-1.5 40.8 32.7 85.3 33.1 46.1 1 63-37.3 92-34.1 30.8 0 41 30.8 84.2 31 55 .3 64.7-32 99.2-30 24.5-.5 43.9 23.7 79.8 24.3 28.7.5 52.7-21.2 69-29l.7-36.8c-17 6.4-42.3 27.1-67.7 27.3-36.4 1.4-59-23.9-84.4-23.7-30.3.3-42.4 31.3-94 31.3-47 0-57.8-31.3-88.2-31.3-29.7.3-38.8 34-90.1 33.4-42-.5-58.3-32.2-88-32-31.5 0-64 30.9-98.8 29.4-48.1-2-58.5-29.4-90-29.4-23.5 0-48.9 25.6-77.2 26-28.2.5-59.8-25.4-62.8-26l.4 38.3z"
      />
      <path
        fill="#ffc84b"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.8}
        d="M136.8 76c61-4.2 50-9.4 74.5-13.4 31 4.3 34.5 23 51.8 34.5 0 0-6.5 22-27.7 18.9-2.9-8.8 10.2-11.6-27.5-34.6-22-1.3-61.3 3.9-71-5.4zm189.3 33.9l-44 1.8v10.9c29.7 1 35-3 44-12.7z"
      />
      <path
        fill="#ffc84b"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeLinejoin="round"
        strokeWidth={1.7}
        d="M174.8 108c7.7-3.9 11.5-2.3 18.2-2.5 4.5 8.3 8.8 9 18.8 10a49.5 49.5 0 0 0 39.9 21.8c29.9-.8 39.4-21.7 59.5-24h21.2c-3.5-6-6.3-9.5-14-9.9-15.8-.8-36.2-.4-54 3.6l-25.1 6.3c-7.4-3.6-25.3-22.4-36.8-22-6.7 1.8-6.7 4.1-10 6.7-6.5 2.8-13 1.4-17.7 10z"
      />
      <path
        fill="#ffc84b"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.7}
        d="M205.1 99a3.2 3.2 0 1 1-6.3 0 3.2 3.2 0 0 1 6.3 0z"
      />
      <path
        fill="#ffc84b"
        fillRule="evenodd"
        stroke="#d8aa3f"
        strokeWidth={1.8}
        d="M225.6 107.8c44.9-54.1 84.1-47.5 135.3-51.2 1.7 6.3 1 15.7-23.3 24-33.4 5-93.1 40.2-93.4 40.2-11.1-.6-18.9-12.2-18.6-13z"
      />
      <path
        fill="none"
        stroke="#d9a43e"
        strokeLinecap="round"
        strokeWidth={1.8}
        d="M317.9 72.5L351 74m-36.7 4l24.1 2"
      />
    </g>
  </svg>
	),
	KM: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g fillRule="evenodd" clipPath="url(#prefix__a)" transform="scale(.9375)">
      <path fill="#ff0" d="M0 0h768.8v128H0z" />
      <path fill="#fff" d="M0 128h768.8v128H0z" />
      <path fill="#be0027" d="M0 256h768.8v128H0z" />
      <path fill="#3b5aa3" d="M0 384h768.8v128H0z" />
      <path fill="#239e46" d="M0 0v512l381.9-255.3L0 0z" />
      <path
        fill="#fff"
        d="M157.2 141.4c-85-4.3-123.9 63.5-123.8 115.9-.2 62 58.6 113 112.8 110C117 353.5 81.2 314.6 81 257c-.3-52.1 29.5-97.5 76.3-115.6z"
      />
      <path
        fill="#fff"
        d="M156 197l-12-9.3-14.6 4.6 5.2-14.4-8.8-12.4 15.2.6 9-12.3 4.3 14.7 14.4 4.8-12.6 8.5zm-.3 52.1l-12-9.4-14.6 4.6 5.3-14.3-8.9-12.4 15.3.5 9-12.2 4.2 14.6 14.5 4.9-12.7 8.5zm.2 52.6l-12-9.4-14.5 4.6 5.2-14.3-8.8-12.4 15.2.5 9-12.2 4.3 14.6 14.4 4.8-12.6 8.6zm-.2 53l-12-9.3L129 350l5.3-14.4-8.9-12.4 15.3.6 9-12.3 4.2 14.7 14.5 4.8-12.7 8.5z"
      />
    </g>
  </svg>
	),
	KN: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-80.1 0h682.7v512H-80.1z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(75.1) scale(.9375)"
    >
      <path fill="#ffe900" d="M-107.8.2h737.6v511.3h-737.6z" />
      <path fill="#35a100" d="M-108.2.2l.8 368.6L466.6 0l-574.8.2z" />
      <path fill="#c70000" d="M630.7 511.5l-1.4-383.2-579 383.5 580.4-.3z" />
      <path d="M-107.9 396.6l.5 115.4 125.3-.2 611.7-410.1L629 1.4 505.2.2l-613 396.4z" />
      <path
        fill="#fff"
        d="M380.4 156.6l-9.8-42.2 33.3 27 38-24.6-17.4 41.3 33.4 27-44.2-1.5-17.3 41.3-9.9-42.2-44.1-1.5zm-275.2 179l-9.9-42.3 33.3 27 38-24.6-17.4 41.3 33.4 27-44.1-1.5-17.4 41.3-9.8-42.2-44.1-1.5z"
      />
    </g>
  </svg>
	),
	KP: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M5 .1h682.6V512H5.1z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(-4.8 -.1) scale(.93768)"
    >
      <path fill="#fff" stroke="#000" d="M776 511.5H-76V.5h852z" />
      <path fill="#3e5698" d="M776 419H-76v92.5h852z" />
      <path fill="#c60000" d="M776 397.6H-76V114.4h852z" />
      <path fill="#3e5698" d="M776 .6H-76V93h852z" />
      <path
        fill="#fff"
        d="M328.5 256c0 63.5-53 115-118.6 115S91.3 319.5 91.3 256s53-114.8 118.6-114.8c65.5 0 118.6 51.4 118.6 114.9z"
      />
      <path
        fill="#c40000"
        d="M175.8 270.6l-57-40.7 71-.2 22.7-66.4 21.1 66.1 71-.4-57.9 41.2 21.3 66.1-57-40.7-58 41.3z"
      />
    </g>
  </svg>
	),
	KR: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-95.8-.4h682.7v512H-95.8z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(89.8 .4) scale(.9375)"
    >
      <path fill="#fff" d="M610.6 511.6h-730.2V-.4h730.2z" />
      <path
        fill="#fff"
        d="M251.9 256a112.5 112.5 0 1 1-225 0 112.5 112.5 0 0 1 225 0z"
      />
      <path
        fill="#c70000"
        d="M393 262.6c0 81-65 146.8-145.3 146.8s-145.2-65.8-145.2-146.8 65-146.9 145.3-146.9S393 181.6 393 262.6z"
      />
      <path d="M-49.4 126.4l83.6-96.7 19.9 17.1-83.7 96.8zm27.4 23.7l83.6-96.7 19.9 17-83.7 96.9z" />
      <path d="M-49.4 126.4l83.6-96.7 19.9 17.1-83.7 96.8z" />
      <path d="M-49.4 126.4l83.6-96.7 19.9 17.1-83.7 96.8zm55.4 48l83.6-96.9 19.9 17.2-83.7 96.8z" />
      <path d="M-49.4 126.4l83.6-96.7 19.9 17.1-83.7 96.8z" />
      <path d="M-49.4 126.4l83.6-96.7 19.9 17.1-83.7 96.8zm508.8-96.8l83 97.4-20 17-83-97.4zm-55.7 47.5l83 97.4-20 17-83-97.4z" />
      <path fill="#fff" d="M417.6 133.2L496 65.4l14.7 17-84 75.4-9.3-24.6z" />
      <path d="M514.2 372l-80.4 95.8-19.7-16.4 80.4-95.8zM431.8 53.1l83 97.4-19.9 17L412 70zm109.7 341.6L461 490.5l-19.8-16.4 80.5-95.8zm-55.1-45.8L406 444.7l-19.7-16.4 80.4-95.8z" />
      <path
        fill="#3d5897"
        d="M104.6 236.7c4.6 37 11.3 78.2 68.2 82.4 21.3 1.3 62.8-5 77-63.2 18.8-55.8 75-71.8 113.3-41.6C385 228.5 391 251 392.4 268c-1.7 54-32.9 101-72.8 122-46 27.3-109.6 27.9-165.3-13.5-25.1-23.5-60.2-67-49.7-139.8z"
      />
      <path fill="#fff" d="M436 370.6l78.6 67.6-14.6 17-87.1-71.8 23-12.8z" />
      <path d="M-1.9 357.2l83 97.3-20 17-83-97.3z" />
      <path fill="#fff" d="M-16.2 437.3l78.6-67.9 14.7 17-84 75.5-9.3-24.7z" />
      <path d="M25.7 333.7l83 97.3-20 17-83-97.3zM-30 381.2l83 97.3-20 17-83-97.3z" />
    </g>
  </svg>
	),
	KW: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="scale(.9375)"
    >
      <path fill="#fff" d="M0 170.6h1024v170.7H0z" />
      <path fill="#f31830" d="M0 341.3h1024V512H0z" />
      <path fill="#00d941" d="M0 0h1024v170.7H0z" />
      <path d="M0 0v512l255.4-170.7.6-170.8L0 0z" />
    </g>
  </svg>
	),
	KY: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#006" d="M0 0h640v480H0z" />
    <path fill="#006" fillRule="evenodd" d="M0 0h400v200H0z" />
    <g strokeWidth="1pt">
      <path
        fill="#fff"
        d="M0 0v27l334.4 215.3h42.1v-27L42.1 0H0zm376.5 0v27L42.1 242.4H0v-27L334.4 0h42.1z"
      />
      <path
        fill="#fff"
        d="M156.9 0v242.3h62.7V0H157zM0 80.8v80.7h376.5V80.8H0z"
      />
      <path
        fill="#c00"
        d="M0 97v48.4h376.5V96.9H0zM169.4 0v242.3h37.7V0h-37.7zM0 242.3l125.5-80.8h28L28.2 242.3H0zM0 0l125.5 80.8h-28L0 18V0zm223 80.8L348.3 0h28.1L251 80.8h-28zm153.5 161.5L251 161.5h28l97.5 62.7v18.1z"
      />
    </g>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M448.3 179.1c-1 .6-3 2.5-5 1.9-2-.6-6.6-8.6-11.6-7.4-5 1.3-8.1 3.1-10.1 3.1s-7.6 1.8-7.6 6.7.5 8.6 1.5 8.6 2.5-3.1 2.5-3.1.5 6.1 4 6.1 11.2.6 11.7 2.5c.5 1.8-3.5 6-2.5 9.7 1 3.7 5.5 9.8 5.5 9.8s-6.5 4.8-6.5 8 1 6 1 6l-29.3 1.2s-2 86.7-1 93.4l3.5 23.2s-6.6-2.2-12.1 3.3c-5.6 5.5-25 15-25.5 19.2-.5 4.3-2.3 8-.3 11 2 3 9.2 11.4 7.1 11-6.8-1.1-9.3-10.8-13.9-14.3-4.5-3.5-13.3-2.8-14.4.9-1 3.7-.5 9.8 0 11 .5 1.2 6.1 20.7 7.6 25s17.4 10.7 24.5 10c13.4.4 19.4-5.7 20-5.1.4.6 28.7 29.8 86.8 29.9 45.2 0 79.2-29.3 79.2-28.7 0 .6 18.7 6.1 25.3 4.3 6.5-1.9 16.1-6.1 18.1-10.4 2-4.3 7.6-26.2 8.1-29.9s0-8-4.5-9.2-7-.9-9.6.3-3.3 4.6-7 10.7c-2.1 1.9-7.4 6.7-5.9 5.5s4.8-10.3 5.3-13.4c.5-3 2-8.5-1.5-11.6-3.5-3-9-4.3-15.1-8.8-6-4-10.6-10.7-14.2-10.7-3.5 0-7.5-1.8-7-1.8s4.5-9 3.5-18c-1-9.2.5-96.8 0-96.8s-25.2 1.9-25.2.6 2-9.7 0-15.2-10.7-9.2-8.1-10.4c2.5-1.2 13.6-4.3 13-9.1-.4-5-7.5-4.3-10.5-6.1-3-1.9-12.1-10.4-13.1-10.4s26.2-16.5 24.2-16.5-12.6-3-16.2-1.2c0-3 14.7-12.2 12.2-13.4-2.6-1.3-14.2-2.5-11.1-3 3-.7 4-8 3.5-8l-13.1 1.8s-3-4.3-4-4.3-5.6 2.5-5.6 2.5l-2.6-6.7-5.5 3.6-2.5-3s-4.6 1.2-4.6 0c.2 0-.5-3-1.2-3s-5.7 3.8-5.9 3.6c-.2-.2-5.7-8-5.7-7.8l-4.1 14.7c-.2 0-4 .4-4.1.6-.2.3-20-11.4-19.8-11.2l5.1 11.2s-4.2 2.4-4.2 2.6l.7 5-13.2-4.5s5 10 4.6 10l-9.6.5 4.4 8.4-1.6 5s14.2 10 13.2 10.6zm84.3 212.4c1.3 1.8 8.1 10.4 7.1 10.4s-18 11.3-24.7 13.4a351 351 0 0 1-27.8 5.8c1.3-.3 20-10.5 27.5-15.4a119 119 0 0 0 18-14.2zm-105.5-.3c-1 1.2-5.8 10.7-5.8 10.7s13.9 9.7 24.2 13.4c10.4 3.6 28 4.9 27 4.6-1-.3-22.1-9.8-28.2-14.7-6-4.9-17-14-17.2-14z"
    />
    <g fill="#fec500" fillRule="evenodd" stroke="#6d6666">
      <path
        strokeWidth={1.4}
        d="M394.6-213l35.4 21.4c6.6 4.1 28 22.2 29.6 21.4 1.6-.8 13.2-9.9 13.2-9.9S448.9-199 434-203s-39.5-8.2-39.5-9.9z"
        transform="matrix(.307 0 0 .37108 317 244.3)"
      />
      <path
        strokeWidth={1.4}
        d="M390.5-231.9c2.5 0 47.7 23 61.7 34.6s19.7 26.3 21.4 26.3c1.6 0 23-3.3 22.2-3.3-.8 0-9.9-29.6-30.4-38.7-20.6-9-74-18.9-74.9-18.9z"
        transform="matrix(.307 0 0 .37108 317 244.3)"
      />
      <path
        strokeWidth={1.4}
        d="M603.5-296c-.8 0-9 24.7-11.5 32-2.5 7.5-6.6 23-6.6 23s-36.2 3.4-34.5-.7c1.6-4.2 55-54.3 52.6-54.3z"
        transform="matrix(.307 0 0 .37108 317 246)"
      />
      <path
        strokeWidth={1.4}
        d="M398.8-261.5s42.7 28.8 57.5 45.2c14.8 16.5 29.6 45.3 30.4 45.3.9 0 40.3-8.3 40.3-7.4s-46-46-68.2-60-59.2-21.4-60-23z"
        transform="matrix(.307 0 0 .37108 317 244.3)"
      />
      <path
        strokeWidth={1.4}
        d="M443.2-273.8s21.3 32.9 25.5 44.4a1347 1347 0 0 0 16.4 41h33.7s-16.4-37-34.5-55-40.3-28.8-41.1-30.4z"
        transform="matrix(.307 0 0 .37108 317 246)"
      />
      <path
        strokeWidth={1.4}
        d="M454.7-291.9c.8 2.5 31.2 31.2 38.6 50.1a402 402 0 0 1 13.2 42.8l29.6-7.4s-26.3-48.5-42.8-61.7c-16.4-13.1-37-22.2-38.6-23.8z"
        transform="matrix(.307 0 0 .37108 317 246)"
      />
      <path
        strokeWidth={1.4}
        d="M700.5-209.7s-61.7 6.6-83.9 12.3-34.5 27.2-34.5 27.2 28.8 10.7 30.4 9 19-18.9 37.8-25.5c19-6.5 51.9-22.2 50.2-23z"
        transform="matrix(.307 0 0 .37108 317 244.3)"
      />
      <path
        strokeWidth={1.4}
        d="M698-250c-1.6.9-51 41.1-66.6 54.3-15.6 13.1-30.4 27.1-32 28-1.7.8-32.1-4.2-30.5-5.8 1.7-1.6 45.3-37 74-52.6 28.8-15.7 52.7-22.2 55.1-23.9z"
        transform="matrix(.307 0 0 .37108 317 244.3)"
      />
      <path
        strokeWidth={1.4}
        d="M685.7-278.8c-5 5.8-53.4 45.3-66.6 59.3S584.6-181 584.6-181s-25.5-11.5-23.9-16.5c1.7-4.9 36.2-33.7 60.9-50.1 24.6-16.5 66.6-29.6 64.1-31.3z"
        transform="matrix(.307 0 0 .37108 317 244.3)"
      />
      <path
        strokeWidth={1.4}
        d="M636.4-282a725 725 0 0 0-35.4 39.4c-5.7 8.2-23 44.4-23 44.4s-25.5-22.2-25.5-23 32-34.5 51-47.7 33.7-10.7 32.9-13.1z"
        transform="matrix(.307 0 0 .37108 317 244.3)"
      />
      <path
        strokeWidth={1.5}
        d="M565-241.8a10.5 10.5 0 1 1-20.8 0 10.5 10.5 0 0 1 20.9 0zm21 14c0 5.1-4.7 9.3-10.4 9.3s-10.5-4.2-10.5-9.3 4.7-9.3 10.4-9.3 10.5 4.1 10.5 9.3zm-46.5-10.5c0 5.2-5.7 9.3-12.8 9.3-7 0-12.8-4.1-12.8-9.3s5.8-9.3 12.8-9.3c7 0 12.8 4.2 12.8 9.3z"
        transform="matrix(.307 0 0 .37108 317 246)"
      />
      <path
        strokeWidth={1.5}
        d="M573.2-219c0 9.9-6.5 18-14.5 18s-14.5-8.1-14.5-18 6.5-18.1 14.5-18.1 14.5 8 14.5 18zm-39.5.5c0 7.7-6.5 14-14.5 14s-14.6-6.3-14.6-14 6.5-14 14.6-14c8 0 14.5 6.3 14.5 14z"
        transform="matrix(.307 0 0 .37108 317 246)"
      />
      <path
        strokeWidth={1.5}
        d="M514-207.5c0 6.8-5 12.2-11.1 12.2s-11-5.4-11-12.2c0-6.7 4.9-12.2 11-12.2 6 0 11 5.5 11 12.2zm81.3-1.1c0 8-7.5 14.5-16.8 14.5-9.4 0-16.9-6.5-16.9-14.5s7.5-14.6 16.9-14.6c9.3 0 16.8 6.5 16.8 14.6zm-40.7-21c0 4.9-6 8.8-13.3 8.8s-13.4-4-13.4-8.8 6-8.7 13.4-8.7 13.3 4 13.3 8.7z"
        transform="matrix(.307 0 0 .37108 317 246)"
      />
      <path
        strokeWidth={1.5}
        d="M557-210.4c0 7-8.4 12.8-18.6 12.8s-18.6-5.7-18.6-12.8c0-7 8.3-12.8 18.6-12.8s18.6 5.8 18.6 12.8zm47.6 22.7c0 8.7-7.8 15.7-17.4 15.7s-17.5-7-17.5-15.7 7.8-15.7 17.5-15.7c9.6 0 17.4 7 17.4 15.7zm-95.3-4c0 5.7-4.4 10.4-9.9 10.4s-9.9-4.7-9.9-10.5 4.4-10.4 9.9-10.4 9.9 4.6 9.9 10.4z"
        transform="matrix(.307 0 0 .37108 317 246)"
      />
      <path
        strokeWidth={1.5}
        d="M579-193.5c0 7.4-6.7 13.4-15 13.4-8.4 0-15.2-6-15.2-13.4S555.6-207 564-207c8.4 0 15.1 6 15.1 13.4zm-47.6-.6c0 6.4-6 11.6-13.4 11.6s-13.4-5.2-13.4-11.6c0-6.4 6-11.6 13.4-11.6s13.4 5.2 13.4 11.6z"
        transform="matrix(.307 0 0 .37108 317 246)"
      />
      <path
        strokeWidth={1.5}
        d="M554.6-190.6c0 7-6.2 12.8-14 12.8-7.6 0-13.9-5.8-13.9-12.8 0-7 6.3-12.8 14-12.8s14 5.7 14 12.8zm-60.4-76.8c3.4 0 27.9 8.2 27.9 8.2s-30.3 11.6-25.6 10.4 33.7-4.6 31.4-4.6c-2.3 0-25.6 22.1-18.6 21 7-1.2 20.9-15.2 22-15.2 1.2 0 15.2 22.1 16.4 21 1.1-1.2 0-22.2 1.1-22.2s29 14 26.7 12.8a123.2 123.2 0 0 1-17.4-17.4c1.2 0 38.4 3.5 36 2.3l-24.4-11.6s16.3-15.1 12.8-15.1-30.2 15.1-27.9 14c2.3-1.2 29-31.5 29-31.5L557-282.5s4.7-18.6 2.4-17.4c-2.4 1.2-21 24.4-22.1 24.4s-5.8-23.2-5.8-23.2 1.1 25.5-5.9 26.7c-7 1.2-31.3 5.8-31.3 4.7z"
        transform="matrix(.307 0 0 .37108 317 246)"
      />
    </g>
    <g fillRule="evenodd">
      <path
        fill="#00389b"
        d="M445.5 216.5c.2.9 5.9 16.4 14.7 16s12.3-3 11.9-3.2a18 18 0 0 1-6.2-8.5 44 44 0 0 1-2.5-8l-17.9 3.7zm31.2-6s6.5 15.3 9.3 17.5c2.9 2.1 9.5 3.8 12.3 3.6 2.9-.2 6.3 0 6.3 0s-2.9-1.5-5.2-9.9l-3-11.2h-19.7zm39.3 5.6s-1.2 11.2 0 14c1.3 2.8 7.5 8 7.5 8s7.5-1 7.7-8a36 36 0 0 0-2.5-13.3L516 216z"
      />
      <path
        fill="#005120"
        stroke="#000"
        strokeWidth={1.5}
        d="M289 21s1.1 4.7 0 8.2-11.1 12.8-11.1 20.3c0 7.6 11.6 30.8 47 31.4 35.6.6 80.3-19.2 79.7-19.8-.6-.5-84.9-57-86-56.4-1.2.6-29.7 17.5-29.7 16.3zm234.2 40.1s7.6 20.4 10.5 22.7c2.9 2.3 4 7 4.7 7s48.8 10.4 48.8 10.4 4.6-13.3-2.3-23.8c-7-10.5-33.2-37.8-33.2-37.8l-28.5 21.5zm33.2-25c1.1 0 12.8 10 22 4.7 9.4-5.2 24.5-19.2 24.5-19.2s-12.8 4-22.1 3.5c-9.3-.6-23.8 11.6-24.4 11z"
        transform="matrix(.307 0 0 .37108 350.7 188.7)"
      />
      <path
        fill="#005120"
        stroke="#000"
        strokeWidth={1.5}
        d="M287.2 23.3s-3.5-9.8-12.8-10.4c-9.3-.6-26.2 1.1-32-3.5C236.6 4.7 235-6.3 232-5.7c-3 .5-10.5 0-11 0s-3.6-9.3 4.6-14 15-.6 19.7-4 11.7-5.9 21-6.5c9.3-.5 24.4 11.7 31.4 14.6 7 2.9 22 6.4 27.9 3.5 5.8-3 38.3-15.7 50-16.3 11.6-.6 36-1.2 45.3-.6s46 5.3 57 10.5S547.7 7 555.8 11.7c8.1 4.7 26.2 11.6 26.2 11.6S550 54.7 534.2 60a354.9 354.9 0 0 1-95.4 11.6c-29.6-1.7-52.9-4.7-75.5-16.3-22.7-11.6-47.1-22.7-48.3-28.5-1.2-5.8-.6-13.3-.6-13.3l-27.3 9.8z"
        transform="matrix(.307 0 0 .37108 350.7 188.7)"
      />
      <path
        fill="#005120"
        stroke="#000"
        strokeWidth={1.5}
        d="M251.2-14.4c-1.2.5-7 2.9-5.9 4 1.2 1.2 3.5 4.7 10.5 4 7-.5 14.5-4.6 14.5-4.6s-8.7-4-19.1-3.4z"
        transform="matrix(.307 0 0 .37108 350.7 188.7)"
      />
      <path
        stroke="#000"
        strokeWidth={1.5}
        d="M250.6-13.3v6.4s8.1 2.3 8.1.6c0-1.7.6-5.8-1.2-5.8s-6.4-.6-7-1.2z"
        transform="matrix(.307 0 0 .37108 350.7 188.7)"
      />
      <path
        fill="#001707"
        stroke="#000007"
        strokeWidth={1.5}
        d="M332-8.4c2-3.7 0-8.7 11.9-14.4 11.9-5.8 32.7-4.2 32.7-4.2s-6 4.6-6.2 9.3c-.2 4.7.4 6.8.4 6.8s-11.3-3.7-20-1.5-18.6 4.6-18.9 4zm53.4-20.2c-1.2.6-10.3 10.7-9.3 13.8 1 3 13.2 10.5 17.1 9.8 4-.6 21.8-9.2 22.8-13.5 1-4.3 1.9-10.1.4-11.3-1.4-1.3-30.8 1.6-31 1.2zm39.3-1.6c-2.3 2.2-1.5 13.1-.7 14.3.9 1.3 15 15.5 18.1 16.3 3.1.8 26-1.5 27.8-4s7.4-12.9 5.7-15.3c-1.6-2.5-6.5-5.8-21.8-9s-24.2-3-29.1-2.3zm58.1 13.7c3.7 1.9 25.3 12.4 38 20.8 12.8 8.4 18 18 21.6 18.9 3.7.8 18.7-8.2 19.3-10.7.7-2.5-18.3-15.6-31-21.6-12.7-6-47.9-6.7-47.9-7.4zm-4.5 8.9c-1.9 1.6 23 45 27.7 46.4 4.8 1.5 33.1-8.4 32.7-11.7-.4-3.3-7.8-9.9-25.3-19.5-17.4-9.7-31.6-16-35.1-15.2zM447.5 8.2c-4 2.3-10.1 41.1-6.2 43 3.9 1.8 52-4.8 53.9-9C497 37.7 475.4 3.4 469 3.4c-6.4 0-18 1.6-21.6 4.7zM397.7 0c-5.1 4.7-4 40.9-1.8 43.1 2.2 2.3 30.8 9.7 33.9 7 3-2.6 7.2-43.3 4.3-46.4-2.9-3.1-10.9-10.5-17-11.1-6.2-.6-16.5 6-19.4 7.4zm-64.5-.6c-4.7 3.7-5 13.3.2 15 5.1 1.6 17.9 7.2 29.8 12.3 12 5.1 18.7 11.3 22.2 11.1 3.5-.2 6.8-36.4 3-38.4A62 62 0 0 0 363.7-4a156 156 0 0 0-30.4 3.3z"
        transform="matrix(.307 0 0 .37108 350.7 188.7)"
      />
    </g>
    <path
      fill="#d40f0f"
      fillRule="evenodd"
      d="M388 359.2c2.6-2.5 6.6-8.7 12-9 5.5-.2 11.3 4.8 11.3 4.8s5.7 23.5 5.4 23.5c-.2 0-9.5 6.7-9.7 6.7-.3 0-4-9.2-7.5-8.3-3.5.8-3.2 13.4-3.8 12.6-.5-.9-15.2-18.2-14.6-18.8.5-.6 7.2-10.7 6.9-11.5zm151.9-3c1.7-.4 9.5-6.2 15-6 5.4.3 8.6 2.8 11.4 5.4 3 2.5 6.4 9 6.4 9s-7 19-7.5 19-3.5 1.6-4 .2-2.3-5.8-5.8-6.4c-3.4-.6-4.3 6.2-4.3 6.2L539.9 356z"
    />
    <path
      fill="#fddc59"
      fillRule="evenodd"
      d="M543.6 362c0 1.7 10.7 28 27.9 33 17.3 5.1 22.7-4.7 24.7-8 2-3.4 9.2-3.1 9.2-3.1s-1.7 24.6-4.6 27.7c-2.8 3-5.1 9.8-21.2 10-16.1.3-30.8-15-35.7-19.5a91.6 91.6 0 0 1-13.8-21.6c-2.6-5.3 13.8-18 13.5-18.5zM356 414.4c.3 0 7.8 8.1 18.8 7.3 10.9-.9 29.6-7.3 38.2-18.5a96 96 0 0 0 13-23.3s-12.7-22.4-13-22.4c-.3 0-1.4 7.3-3.7 12-2.3 4.8-8.7 18.3-19.3 22.5-10.6 4.2-10.6 5.9-15 5.3a59.3 59.3 0 0 1-15.5-7.6L354 403s-1.1 8.7 2 11.5z"
    />
    <path
      fill="#fddc59"
      fillRule="evenodd"
      d="M387.8 358.4c-.8 0-21.2 11.1-20.4 15.9.9 4.7 35 72 108.2 72.9 73.3.8 118-61 114.8-71.3-3.3-10.3-26-22.2-26-22.2s5.6 4.7 4.8 11c-.8 6.4-26 61-89.5 59.5-63.4-1.6-93.5-50-93.5-55.5s3.2-8.7 1.6-10.3z"
    />
    <path
      fill="#d40f0f"
      fillRule="evenodd"
      d="M586.2 407.4c1.7-1.4 12.3-30.5 18.4-29.7 6 .8 4 9.5 3.4 11.8-.5 2.2-6.6 22.4-6.6 22.4s.3-4.8-3.7-6-10.7 2-11.5 1.5zM356 414.7c0-1.6-4.8-7.2.9-8.7 5.7-1.6 13 1.5 13 1.5s-4-11.8-9-21.4c-4.9-9.5-6.5-7.9-10.6-6.3-4 1.6-4 5.8-1.5 12.1 2.5 6.4 7.2 24.4 7.2 22.8z"
    />
    <path
      fill="#fdc400"
      fillRule="evenodd"
      d="M423.2 360.4l7-24-19.6-15 24.6-.6 8-23.6 8.1 23.6 24.6.4-19.6 15.2 7.2 23.9-20.2-14.3z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M555.6 235.8v92c.2 45-45.7 84.4-76.1 92.1-30.5-7.6-76.3-47-76.2-92v-92h152.3z"
    />
    <path
      fill="#d40f0f"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.5}
      d="M177.2 326l.4 160.7s2.4-3.3 35-1.3c32.6 2 35.4 35.5 70.9 35.5 35.4 0 35.4-35.5 70.8-35.5s35.5 35.5 70.9 35.5 35.4-35.5 70.9-35.5 35.4 35.5 72.8 37.5c33.5-2 33.5-37.5 69-39.5l35.3 2V326h-496z"
      transform="matrix(.307 0 0 .35829 349 119)"
    />
    <path
      fill="#0062bb"
      fillRule="evenodd"
      d="M403.3 312v19h11c10 .8 10.8 12.8 21.7 12.8s10.8-12.8 21.7-12.8 11 12.8 21.8 12.8 10.9-12.8 21.7-12.8 10.3 12 21.8 12.8c10.3-.8 10.8-12 21.8-12.8h10.8v-19h-10.8c-11 0-11 12.7-21.8 12.7S512.1 312 501.2 312s-10.8 12.7-21.7 12.7-10.9-12.7-21.8-12.7-10.8 12.7-21.7 12.7-11-12.7-21.8-12.7h-10.9zm3.3 38l7.6 19.1c10 .8 10.9 12.7 21.8 12.7 10.8 0 10.8-12.7 21.7-12.7s11 12.7 21.8 12.7 10.9-12.7 21.7-12.7 10.3 12 21.8 12.7c10.3-.7 10.6-12 21.5-12.7l7.8-19.3-7.5.3c-11 0-11 12.7-21.8 12.7S512.1 350 501.2 350s-10.8 12.7-21.7 12.7-10.9-12.7-21.8-12.7-10.8 12.7-21.7 12.7-11-12.7-21.8-12.7h-7.6zm72.9 70c10.9 0 35.8-19.1 35.5-19.1.3 0-2.9-12.7-13.8-12.7s-10.8 12.7-21.7 12.7-10.9-12.7-21.8-12.7-13.6 12.7-13.7 12.7c-.5 0 24.6 19 35.5 19z"
    />
    <path
      fill="#fdc400"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.7}
      d="M90.8 117.6c.9 0 8.3 1.2 13.6.8 5.4-.4 7.4-2.5 7.4-2.9v-1.2h7s1.2 5.7.4 6.1-2.9 2.1-3.3 2.1 0-2.9-.8-2-1.2 2-1.2 2-.9-1.2-1.3-1.2-1.2 1.2-1.2 1.2 0-1.2-.4-1.2-2.5 2-2.5 2l-2-1.6s-1.3 2-1.7 2-2.9-1.6-2.9-1.6l-4 2.5s0-3.7-.9-3.3c-.8.4-5.3.4-5.3.4S90.4 124 90 124s-2-2-1.6-2 1.2-1.2.8-1.7c-.4-.4-2.5 0-2.5-.4s-.8-2.8-.4-2.8l2 .4V115h2.1l.4 2.5z"
      transform="matrix(1.5005 0 0 1.3054 287 126.3)"
    />
    <path
      fill="#fdc400"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.7}
      d="M98.3 94.1c-.5 0-3.3 3.3-3 7 .5 3.7 7.5 9 7.5 9s3.7-1.6 4.9 0 1.2 6.6.8 6.6-5.3 1.3-5.3.5c0-.9 0-1.7-.4-1.7l-5 .4.4-1.6-4-.8 1.6-1.7s-6.6-2.9-6.2-2.9 2.9-1.6 2.9-1.6l-5-3.3h3s-4.2-3.3-3.8-3.3l2.5.4-1.2-3.3h1.2L88 95.4l2-.9 1.3 2.1-.5-5 3 .5v4s1.2-2.4 1.2-2.8c0-.4 3.7 1.7 3.2.8z"
      transform="matrix(1.5005 0 0 1.3054 287 126.3)"
    />
    <path
      fillRule="evenodd"
      d="M530 282.4c-.8.7-3.1 2.2-3.1 2.2l5-.4a7 7 0 0 1-2-1.8zm4.4 2.6c-.3.4-1.2 4.6-.6 4.3a29 29 0 0 0 3.1-3.4l-2.5-.9zm7.1.5c.8.7 4.3 3.8 3.9 3.1-.5-.7-1-3.5-1.3-3.6-.3-.1-2.3.8-2.6.5zm-62.1-4.4c-.5.1-4.3 2.7-4.3 2.7l6.1-1c-.3 0-2-1.3-1.8-1.7zm4 3.2c-.6.6-2.6 4.3-1.9 4.2a27 27 0 0 0 4.2-2.6l-2.3-1.6zm-2.5-5.2l-3.5-1.5 4.3-1-.8 2.5zm-61-1.7l-4.7-3.3 5.9 1.6-1.2 1.7zm-4 2.1c-.7 0-6.5 3.2-6.4 3.2s8.2.2 8 0c-.1-.1-1.3-3-1.7-3.2zm3.7 4.7a40 40 0 0 0-5 3.4h7l-2-3.4zm-.7-33.4s-1.7-3.8-1.5-3.8l4.3 3-2.8.8zm4.7-4.7l.4-2.4s4.2 2.8 4 2.8c-.1 0-4.1 0-4.4-.4zm6.4 1.7l.5-3.5s3.9 4.6 3.5 4.7c-.3.2-3.7-.6-4-1.2z"
    />
    <path
      fill="#fdc400"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.7}
      d="M137.3 110.9c0 .2 4.3 3.7 4.4 4.5 0 .8-7.8 1-7.8 1s-2.3-1.7-3-1.6c-.7 0-1 1.8-1 1.8l1.8 1-3.5.2 1 2 2.7-.2-.6 1.8s1.6 1.3 2 1c.3-.1 1.3-2 2.1-2.3.8-.3 2.6-.3 2.6-.3s-1.4 2.3-.7 2.3c.6 0 3.4-2.4 3.4-2.4l.7 2.2 2-2.5s0 2 .3 2 3.2-2.5 3.2-2.5 2.3 2.8 2.6 2.6c.3-.2.6-3 1-3s2.2-.3 2.2-.5-1.3-1-1.5-2.5c-.2-1.5.2-4.8.1-4.8s-13.8.5-14 .2z"
      transform="matrix(1.5005 0 0 1.3054 286 126.6)"
    />
    <path
      fill="#fdc400"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.7}
      d="M115.4 104.6h40.3c4 0 7.8-1.6 7.8-4.1 0-2.5-6.6-2.9-9-2-2.5.8-13.2 5.7-17.7 5.3s-8.7-3.3-9.1-6.2c-.4-2.9 2-5.3 6.6-5.3s10.3 1.6 11.5 1.2 4.1-3.7 5.3-4.1c1.3-.4 5-.8 5-.8l-1.7 1.2 5.4-1.2s-4.1 4.5-8.3 5.7c-4 1.3-12.7.8-16 .8s-5-.4-4.5 2.1c.4 2.5 2.9 4.1 5 3.7 2-.4 8.1-2.5 8.1-2.5l-1.6-1.2 7.4-.4s-.4-1.2 0-1.2l4.1.4s-2.5-1.3-2-1.3 2 0 5.3.4 10.3 1.7 9.9 5c-.5 3.3-3 6.1-5.8 6.1s-5.3-.8-5.3.5c0 1.2 3.3 2 5.3 2s4.5-1.6 5-1.6 1.2 2.4 1.6 2.4 2.9-.8 2.9-.8l-1.7 4.5 2.9.8s-1.6 1.7-1.2 1.7 2.8 0 2.8.4-3.2 2.9-3.2 3.3 2.4 1.6 2.4 1.6-1.6 2.5-2 2.1l-2-2.5s-.5 1.7-1.3 1.7-2.5-.4-2.5-.4 1.2-2.5.8-2.5-2.4 1.6-2.4 1.2l-1.3-1.2s3.3-1.3 3.3-3.3c0-2-1.3-3.9-7.3-4.2-6-.3-6 1.4-10.5 1.2-4.4-.2-4.4-2-7.7-2s-13.4 4.2-18.2 4c-4.7 0-10.6-.3-10.4-.5.2-.2 3.9-9.7 4-10z"
      transform="matrix(1.5005 0 0 1.3054 286 126.6)"
    />
    <path
      fill="#fdc400"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.7}
      d="M106.9 102.5c-.4.2-4 .7-4.2 4.5-.2 3.8.3 3.8.7 3.6.4-.2 1.2-3.5 1.2-3.5s-1.2 4.5.1 5.5a9.3 9.3 0 0 0 2.8 1.5l.5-3.6s-1 3.5 1.5 4.7c2.4 1.2 3.4.3 3.1-.6a70 70 0 0 0-.9-3.3l2 2.4c.2.2 1 1.8 3.6 1 2.4-.6.7-2.3.7-2.3l-3-2.4s3 3.1 4.4 2-1-3.6-1-3.5 2 3.5 2.8 1.4-1.2-2.8-1.8-4.9c-.6-2-1.1-2.2-.5-3.5.6-1.2.7-3.6.7-3.6s2.6.7 2.4-1.5c-.2-2.2-2.8-2.7-3.3-2.8-.5 0-.4-2.2-.6-2.1-.2 0-1.9 1.3-1.9 1.3s-1.4-3.4-1.7-3.2-2 2-3.2 2c-1.2.2-2 2-2 2s-4.3-2.1-4.2 1.3c.1 3.4 2.6 2.5 2.6 2.6s-.4 4.8-.8 5z"
      transform="matrix(1.5005 0 0 1.3054 287 126.3)"
    />
    <path
      fillRule="evenodd"
      d="M450.9 253.3c.7-.3 1.8-1.2 3-1.1s3.4 1 2.4 1.6c-1 .5-1.8.8-3 .5-1-.3-2-.8-2.4-1zm12.6-.2c-.8-.2-1.9-1.1-3.2-1s-3.2 1-2.2 1.6a4 4 0 0 0 2.8.5c1.2-.3 2-.9 2.6-1z"
    />
    <path
      fill="#000039"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.4}
      d="M111 103.2c0 .5.4 4.8.6 4.5l1.7-4.4-2.3-.1z"
      transform="matrix(1.5005 0 0 1.3054 287.1 126.4)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.8}
      d="M110 103.2c0-1.3.8-1.2 2.4-1 1.7.2 2.5 1 2.4 1.3-.1.2-1.5.7-2.6.6-1.3-.4-2.3 0-2.2-1z"
      transform="matrix(1.5005 0 0 1.3054 287.1 126.6)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={1.5}
      d="M112.4 100l-.2 2m7.1-7.2s1.4.7 1.2 1.3c-.2.6-1.2.9-1.2.9m-11.2-2.7c-.3.1-.7.3-1 1.2-.1.8 1 1.3 1 1.3"
      transform="matrix(1.5005 0 0 1.3054 287.1 126.6)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={1.5}
      d="M111.2 136.1s-1.5 1.5 1 1.5.7-1.3.7-1.3"
      transform="matrix(1.5005 0 0 1.3054 287.4 77.6)"
    />
    <path
      fill="#fdc400"
      fillRule="evenodd"
      d="M462.4 403.8l6.4-21.1-17.9-13.2 22.4-.5 7.2-20.8 7.4 20.7 22.3.4-17.7 13.3 6.4 21-18.3-12.4z"
    />
    <path
      fill="#003017"
      fillRule="evenodd"
      d="M465.4 398.1l5.3-16.7-14.8-10.5 18.6-.4 6-16.5 6.2 16.4 18.5.4-14.7 10.5 5.4 16.7-15.3-9.9z"
    />
    <path
      fill="#fdc400"
      fillRule="evenodd"
      d="M425.7 361.1l6.3-19.9-17.6-12.5 22-.5 7.2-19.7 7.3 19.7 22 .3-17.5 12.6 6.5 20-18.2-11.9z"
    />
    <path
      fill="#003017"
      fillRule="evenodd"
      d="M428.7 355.8l5.3-15.9-14.7-9.9 18.4-.4 6-15.6 6 15.6 18.4.3-14.6 10 5.4 15.8-15.2-9.4z"
    />
    <path
      fill="#fdc400"
      fillRule="evenodd"
      d="M499.6 361.1l6.4-20-17.8-12.4 22.3-.5 7.3-19.7 7.4 19.7 22.3.3-17.8 12.6 6.5 20-18.3-12z"
    />
    <path
      fill="#003017"
      fillRule="evenodd"
      d="M502.6 355.8l5.4-15.9-15-9.9 18.6-.4 6-15.6 6.3 15.6 18.6.3-14.8 10 5.4 15.8-15.3-9.4z"
    />
    <path
      fill="none"
      d="M373.3 372.6c8 34.5 41.9 60.1 87.5 66.2 58.6 7.8 114.5-21.9 124.8-66.3"
    />
    <path d="M373.1 377.9l11-6.2 1 2.2-4.3 2.5 1.5 3.1 4.3-2.4 1 2.2-11 6.2-1-2.2 5-2.8-1.5-3.2-5 2.9-1-2.3m4.6 9.6L388 380l3.5 5.9-1.7 1.2-2.2-3.7-2.4 1.8 2 3.4-1.5 1.2-2.1-3.4-2.9 2 2.3 3.9-1.7 1.3-3.6-6m7.2 11l9-9.2 1.6 1.8-3.5 3.7 2.1 2.5 3.5-3.6 1.6 1.9-9 9.3-1.6-1.9 4-4.2-2-2.6-4.1 4.2-1.6-1.8m11.8 5.5l1.5 1.4 2.7-5-4.2 3.6m-5.7 1.7l10.2-8.3 2.3 2.3-6 12.4-1.9-1.9 1.6-3-2-2-2.5 2.2-1.7-1.7m9 8.3l6-9.2-2.1-1.8 1.2-1.8 6.1 5-1.2 1.8-2.1-1.7-6.1 9.2-1.9-1.5m5 4l6.5-11.7 1.9 1.3-2.5 4.6 2.7 1.8 2.5-4.6 2 1.4-6.5 11.7-2-1.3 3-5.4-2.7-1.8-3 5.3-1.9-1.3m12.1 7.7l5.2-12.5 5.9 3-.9 2-3.8-1.9-1.2 3 3.6 1.8-.9 2-3.5-1.9-2.3 5.5-2-1m11.4-2a15 15 0 0 0-1 4.2c0 .6.3 1 .9 1.3.6.3 1 .2 1.5-.3.4-.4 1-1.7 1.7-3.8s1-3.5 1-4.2a1.4 1.4 0 0 0-1-1.3c-.5-.3-1-.2-1.4.3-.4.4-1 1.7-1.7 3.9m-2.2-1a16 16 0 0 1 2.4-4.8 3 3 0 0 1 1.7-.7c.5 0 1.2 0 2 .4s1.2.7 1.6 1.1c.4.5.7 1 .8 1.8.1.5 0 1.2-.1 2a25.2 25.2 0 0 1-1 3.4l-1.2 3.2c-.4.7-.8 1.3-1.2 1.6-.5.4-1 .7-1.6.7-.6.1-1.2 0-2-.4s-1.3-.7-1.7-1.1a3.7 3.7 0 0 1-.8-1.8l.1-2 1-3.4m10.6-2.9l2.2.8-2.4 8.8a4.7 4.7 0 0 0-.2 2.2c.1.4.5.7 1 1 .6.1 1 0 1.4-.2.3-.3.6-1 .9-2l2.3-8.8 2.2.7-2.4 9a9.8 9.8 0 0 1-.7 2 2.9 2.9 0 0 1-.7.9 2.9 2.9 0 0 1-1.6.6 4.8 4.8 0 0 1-2-.3c-1.3-.4-2.1-1-2.5-1.9-.4-.8-.4-2 0-3.7l2.5-9m5.9 16.1l2.7-13.4 2.3.6 1.3 10.1 1.8-9.3 2 .5-2.6 13.4-2.3-.6-1.3-10.2-1.8 9.4-2.1-.5m12 .7l1 .2h1.2a1 1 0 0 0 .5-.3c.3-.3.5-.8.7-1.4a24.1 24.1 0 0 0 .8-5.8 3 3 0 0 0-.4-1.4 1 1 0 0 0-.4-.5l-1-.2-1-.2-1.3 9.6m-2.5 1.6l1.9-13.6 3.6.7c.8.1 1.3.3 1.8.5.4.2.7.5 1 .9.3.5.5 1.2.6 1.9 0 .7 0 1.8-.2 3.3a31 31 0 0 1-.7 4 6.4 6.4 0 0 1-1 2c-.3.5-.7.8-1.3 1-.5.1-1.4 0-2.6-.2l-3.1-.5m9.5 1.6l1.2-13.7 6.3.7-.2 2.3-4-.5-.3 3.2 3.8.4-.2 2.1-3.8-.4-.3 3.8 4.1.4-.2 2.3-6.4-.6m10.4-1.1h2.2a1 1 0 0 0 .5-.5c.2-.3.4-.8.5-1.4a23 23 0 0 0 .2-3v-3a3 3 0 0 0-.6-1.3 1 1 0 0 0-.5-.3l-1-.2h-1l-.3 9.7M470 441l.5-13.7 3.7.1a6 6 0 0 1 1.7.3c.5.2.8.4 1.1.8a4 4 0 0 1 .9 1.8l.2 3.3a31.6 31.6 0 0 1-.4 4.1 4 4 0 0 1-.7 2c-.3.6-.7 1-1.2 1.2-.5.2-1.4.3-2.6.2l-3.2-.1m13.8.2l-.5-13.7 2.3-.1.5 13.7h-2.3m6.1-.3l-.8-11.4-2.7.2-.1-2.2 7.5-.7.2 2.2-2.6.3.8 11.4-2.3.2M498 426l2.3-.4 1.4 9c.2 1.1.4 1.8.7 2.1.3.4.7.5 1.3.3.6 0 1-.3 1.1-.8.2-.4.2-1.1 0-2.2l-1.4-9 2.2-.5 1.5 9.4.2 2-.3 1.2a3.3 3.3 0 0 1-1.2 1.3 5 5 0 0 1-1.8.7c-1.4.3-2.4.1-3.1-.4-.7-.6-1.2-1.7-1.4-3.4L498 426m12.3 3.5l1-.3c.6-.2 1-.4 1.3-.8.2-.4.2-1 0-1.7 0-.7-.3-1.2-.7-1.4-.3-.2-.8-.3-1.5 0l-1 .2.9 4m-.5 8l-3-13.3 4-1c1.1-.3 2-.3 2.7.2.6.4 1.1 1.3 1.4 2.6.3 1.4.2 2.4-.2 3.2-.4.8-1.2 1.4-2.3 1.7l-1.7.4 1.3 5.7-2.2.6m8.8-9.7a15 15 0 0 0 1.5 4c.4.4.9.5 1.5.3s1-.6 1-1.2-.2-2-.9-4.2-1-3.5-1.5-4c-.3-.5-.8-.6-1.4-.4-.6.2-1 .7-1 1.3-.1.6.2 2 .8 4.2m-2.3.8c-.4-1.4-.6-2.5-.7-3.4a5.6 5.6 0 0 1 0-2c.2-.8.4-1.3.8-1.8a5 5 0 0 1 1.8-1 4.1 4.1 0 0 1 2-.3c.5.1 1 .4 1.6.9.4.3.7.9 1 1.6a24.7 24.7 0 0 1 1.9 6.6 6 6 0 0 1 0 2.1 3.7 3.7 0 0 1-.8 1.7 4 4 0 0 1-1.8 1.1c-.8.3-1.4.4-2 .3a3 3 0 0 1-1.5-.9 5 5 0 0 1-1.1-1.6c-.4-.8-.8-2-1.2-3.3m11.3 3.1l-4.6-12.7 2.2-1 6.2 7.6-3.2-8.9 2-.9 4.6 12.7-2.2 1-6.2-7.6 3.2 9-2 .8m14.3-7l-4.8-10.1-2.3 1.3-1-2 6.7-3.9 1 2-2.3 1.4 4.8 10.1-2 1.2m5.4-3.2l-6.6-11.6 2-1.4 2.5 4.6 2.7-2-2.6-4.5 2-1.3 6.5 11.6-2 1.3-3-5.2-2.6 1.8 3 5.3-2 1.4m8.3-6l-7.4-11 5-4.2 1.3 1.9-3.3 2.7 1.7 2.5 3-2.5 1.2 1.7-3 2.5 2 3 3.4-2.7 1.2 1.8-5 4.3M562 404l1.6-1.8.6.6c.5.6 1 1 1.2 1 .4 0 .7 0 1-.4.4-.4.6-.8.6-1.2a2 2 0 0 0-.5-1.2 2 2 0 0 0-.9-.5 4.2 4.2 0 0 0-1.5 0l-1.4.3a6.4 6.4 0 0 1-2.6.2 3.3 3.3 0 0 1-1.5-1 3.8 3.8 0 0 1-1.1-2.7 4.1 4.1 0 0 1 1.2-2.7c.8-1 1.7-1.3 2.5-1.3s1.7.5 2.6 1.4a3.8 3.8 0 0 1 .3.4l-1.6 1.7-.2-.3a3 3 0 0 0-1.3-.9c-.3 0-.7.1-1 .5-.3.3-.4.6-.4 1 0 .3.1.6.4 1 .3.3 1 .4 2.2.2l1.5-.3a5.3 5.3 0 0 1 2.5-.1c.6.1 1.2.6 1.8 1.2a4 4 0 0 1 1.1 2.8 4.5 4.5 0 0 1-1.3 2.9c-.9 1-1.8 1.4-2.6 1.4-1 0-1.8-.6-2.7-1.6l-.5-.6m9.5-3.9l-9.5-8.8 4.1-5.4 1.6 1.5-2.6 3.4 2.2 2 2.4-3.2 1.5 1.4-2.4 3.2 2.6 2.5 2.6-3.6 1.6 1.5-4 5.5m2.3-12.3l1.1-1.8-4.8-2.3 3.7 4.1m2.3 6.1l-8.7-10.2 1.7-2.8 11.8 5-1.4 2.3-2.9-1.3-1.5 2.4 2.3 2.5-1.3 2.1m1.4-11.1l1.1-2.3.7.4c.7.4 1.2.6 1.5.5.3 0 .6-.3.8-.7.2-.5.3-1 .2-1.3 0-.4-.4-.7-.8-1a1.5 1.5 0 0 0-1-.2c-.3 0-.8.3-1.4.6l-1.3.8a6.6 6.6 0 0 1-2.4 1 3 3 0 0 1-1.7-.5 3.5 3.5 0 0 1-1.8-2.1 4.3 4.3 0 0 1 .4-3c.5-1.1 1.2-1.8 2-2 .9-.4 1.8-.2 2.8.4a3.5 3.5 0 0 1 .4.2l-1 2.2-.3-.2c-.6-.3-1-.5-1.4-.4-.3 0-.6.3-.9.8-.1.4-.2.7 0 1 0 .4.2.6.6.8.4.3 1.2.1 2.2-.5l1.3-.8c1-.6 1.8-1 2.4-1 .6 0 1.3.2 2 .6 1 .5 1.6 1.3 1.9 2.2.2 1 0 2-.5 3.2-.5 1.3-1.2 2-2 2.3-1 .3-2 0-3.1-.6a11.5 11.5 0 0 1-.6-.4" />
  </svg>
	),
	KZ: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#6fdcff" d="M0 0h640v480H0z" />
      <g fill="#ffe400">
        <path d="M60.2 467c3.3 3.2 2.2 8.5 11.3 7.8 13.8 0 14.2-8.4 14.2-14.3S65 446.4 64 437.7c-1-8.7 4.8-11 9.6-11 4.7 0 8 2.7 8 5.1S79.4 435 76 435s1.5-1.7-1.4-3-4.8 2-4.8 4c0 2.2 7.2 2.8 12 1.3 1 4.7 1.4 5-5.3 13 4.8-3.1 5.2-3.8 10.5-2-5.3-4.6-1.3-13.8-1.2-16.1s-1-5.1-3-6.5c-3.9-3.5-12.2-3.7-17.2-1.4-7.3 3.2-7.7 12.8-5.8 16L80 460.7c1.4 2.4 2 9.2-6.6 9.5-9 .7-12.2-11.6-13.8-15.7-2.1 4.5-4.5 16.8-13.6 16.1-8.6-.3-10.2-7-8.8-9.5l20.7-21c2-3.2 1.6-12.8-5.7-16-5-2.3-13.3-2-17.1 1.4-2.2 1.4-3.4 4.1-3.2 6.5s4.1 11.5-1.1 16c5.2-1.7 5.7-1 10.5 2-6.7-7.9-6.2-8.2-5.3-13 4.8 1.6 12 1 12-1.1s-2-5.6-4.9-4.2c-2.8 1.4 2 3.1-1.4 3.1-3.3 0-5.7-.7-5.7-3s3.3-5.3 8.1-5.3 10.5 2.4 9.5 11.1-22 18.1-22 24c0 6 1.4 13.1 15.2 13.1 9 .7 10.1-4.6 13.4-7.8z" />
        <path d="M59.1 343.3c3.3-3.2 6-12.6 15-12 13.8 0 19 7.7 19 13.6 0 5.9-28 54-29 62.7-1 8.7 4.8 11.1 9.5 11.1 4.8 0 8.1-2.7 8.1-5.2s-2.4-3-5.7-3 1.4 1.7-1.4 3-4.8-2-4.8-4.1c0-2.1 7.2-2.8 12-1.2.9-4.7 1.3-5-5.3-13 4.8 3 5.2 3.8 10.5 2-5.3 4.6-1.4 13.7-1.2 16s-1 5.2-3.1 6.6c-3.8 3.5-12.2 3.6-17.2 1.4-7.2-3.3-7.6-12.8-5.7-16L87 346.6c1.5-2.4-2.3-10.4-10.9-10.7-9-.7-12.1 8.8-13.7 12.9l12.3-1s.5 2 0 3.2a110 110 0 0 0-12.3 1.6l-.5 6.2h6l-.4 2.8s-5.1-.4-5.6 0c-.5.3-1 6.2-1 6.2s-1 .4-2 .4-2-.4-2-.4-.4-5.9-.9-6.2c-.5-.4-5.6 0-5.6 0l-.5-2.8H56l-.5-6.2s-6-1.2-12.3-1.6c-.4-1.2 0-3.1 0-3.1l12.3.9c-1.6-4.1-4.7-13.6-13.7-13-8.6.4-12.4 8.4-11 10.8L58 405.2c1.9 3.1 1.5 12.7-5.7 16-5 2.2-13.4 2-17.2-1.4-2.1-1.4-3.3-4.2-3.1-6.5s4-11.6-1.2-16c5.3 1.7 5.8 1 10.5-2.1-6.6 8-6.2 8.3-5.2 13 4.7-1.6 11.9-1 11.9 1.2 0 2-2 5.5-4.8 4.1-2.8-1.4 2-3-1.4-3-3.3 0-5.7.6-5.7 3s3.3 5.2 8 5.2 10.5-2.4 9.6-11c-1-8.7-29-57-29-62.8 0-6 5.2-13.5 19-13.5 9-.7 12.3 8.7 15.5 11.9z" />
        <path d="M59.1 319.4c3.3 3.2 6 12.6 15 12 13.8 0 19-7.7 19-13.6 0-5.9-28-54-29-62.7-1-8.7 4.8-11.1 9.5-11.1 4.8 0 8.1 2.7 8.1 5.2s-2.4 3-5.7 3 1.4-1.6-1.4-3-4.8 2-4.8 4.1c0 2.1 7.2 2.8 12 1.2.9 4.7 1.3 5-5.3 13 4.8-3 5.2-3.8 10.5-2-5.3-4.6-1.4-13.7-1.2-16s-1-5.2-3.1-6.6c-3.8-3.4-12.2-3.6-17.2-1.4-7.2 3.3-7.6 12.8-5.7 16L87 316c1.5 2.4-2.3 10.4-10.9 10.7-9 .7-12.1-8.8-13.7-12.9l12.3 1s.5-2 0-3.2a110 110 0 0 1-12.3-1.6l-.5-6.2h6l-.4-2.8s-5.1.4-5.6 0c-.5-.3-1-6.2-1-6.2s-1-.4-2-.4-2 .4-2 .4-.4 5.9-.9 6.2c-.5.4-5.6 0-5.6 0l-.5 2.8H56l-.5 6.2s-6 1.2-12.3 1.6c-.4 1.2 0 3.1 0 3.1l12.3-.9c-1.6 4.1-4.7 13.6-13.7 13-8.6-.4-12.4-8.4-11-10.8L58 257.5c1.9-3.2 1.5-12.7-5.7-16-5-2.2-13.4-2-17.2 1.4-2.1 1.4-3.3 4.2-3.1 6.5s4 11.5-1.2 16c5.3-1.7 5.8-1 10.5 2.1-6.6-8-6.2-8.3-5.2-13 4.7 1.6 11.9 1 11.9-1.2 0-2-2-5.5-4.8-4.1-2.8 1.4 2 3-1.4 3-3.3 0-5.7-.6-5.7-3s3.3-5.2 8-5.2 10.5 2.4 9.6 11c-1 8.7-29 57-29 62.8 0 6 5.2 13.5 19 13.5 9 .7 12.3-8.7 15.5-11.9z" />
        <path d="M59.1 160.6c3.3-3.2 6-12.6 15-12 13.8 0 19 7.7 19 13.6 0 5.9-28 54-29 62.8-1 8.6 4.8 11 9.5 11 4.8 0 8.1-2.7 8.1-5.1s-2.4-3.2-5.7-3.2 1.4 1.8-1.4 3.2-4.8-2.1-4.8-4.2c0-2 7.2-2.8 12-1.2.9-4.7 1.3-5-5.3-13 4.8 3.1 5.2 3.8 10.5 2-5.3 4.6-1.4 13.8-1.2 16s-1 5.2-3.1 6.6c-3.8 3.5-12.2 3.6-17.2 1.4-7.2-3.3-7.6-12.8-5.7-16L87 164c1.5-2.4-2.3-10.4-10.9-10.7-9-.7-12.1 8.8-13.7 12.9l12.3-1s.5 2 0 3.2c-6.4.4-12.3 1.6-12.3 1.6l-.5 6.2h6l-.4 2.8s-5.1-.3-5.6 0-1 6.3-1 6.3-1 .3-2 .3-2-.3-2-.3-.4-6-.9-6.3c-.5-.3-5.6 0-5.6 0l-.5-2.8H56l-.5-6.2s-6-1.2-12.3-1.6c-.4-1.2 0-3.1 0-3.1l12.3.9c-1.6-4.1-4.7-13.6-13.7-13-8.6.4-12.4 8.4-11 10.8L58 222.5c1.9 3.2 1.5 12.7-5.7 16-5 2.2-13.4 2-17.2-1.4-2.1-1.4-3.3-4.2-3.1-6.5s4-11.5-1.2-16c5.3 1.7 5.8 1 10.5-2.1-6.6 8-6.2 8.3-5.2 13 4.7-1.6 11.9-.9 11.9 1.2 0 2-2 5.5-4.8 4.1-2.8-1.3 2-3-1.4-3-3.3 0-5.7.6-5.7 3s3.3 5.2 8 5.2 10.5-2.4 9.6-11c-1-8.7-29-56.9-29-62.8 0-5.9 5.2-13.5 19-13.5 9-.7 12.3 8.7 15.5 12z" />
        <path d="M59.1 136.7c3.3 3.2 6 12.7 15 12 13.8 0 19-7.7 19-13.6 0-5.9-28-54-29-62.7-1-8.7 4.8-11.1 9.5-11.1 4.8 0 8.1 2.8 8.1 5.2s-2.4 3.1-5.7 3.1 1.4-1.7-1.4-3.1-4.8 2-4.8 4.1c0 2.1 7.2 2.8 12 1.2.9 4.7 1.3 5-5.3 13 4.8-3 5.2-3.8 10.5-2-5.3-4.5-1.4-13.7-1.2-16s-1-5.2-3.1-6.6c-3.8-3.4-12.2-3.6-17.2-1.3-7.2 3.2-7.6 12.8-5.7 15.9L87 133.4c1.5 2.4-2.3 10.4-10.9 10.8-9 .6-12.1-8.8-13.7-13l12.3 1s.5-2 0-3.2a111.5 111.5 0 0 1-12.3-1.5l-.5-6.3h6l-.4-2.8s-5.1.4-5.6 0c-.5-.3-1-6.2-1-6.2s-1-.4-2-.4-2 .4-2 .4-.4 5.9-.9 6.2c-.5.4-5.6 0-5.6 0l-.5 2.8H56l-.5 6.3s-6 1.1-12.3 1.5c-.4 1.3 0 3.2 0 3.2l12.3-1c-1.6 4.2-4.7 13.6-13.7 13-8.6-.4-12.4-8.4-11-10.8L58 74.8c1.9-3.1 1.5-12.7-5.7-16-5-2.2-13.4-2-17.2 1.4-2.1 1.4-3.3 4.2-3.1 6.5s4 11.6-1.2 16c5.3-1.7 5.8-1 10.5 2.1-6.6-8-6.2-8.3-5.2-13 4.8 1.6 11.9 1 11.9-1.2 0-2-2-5.5-4.8-4.1-2.8 1.4 2 3.1-1.4 3.1-3.3 0-5.7-.7-5.7-3.1s3.3-5.2 8-5.2 10.6 2.4 9.6 11c-1 8.7-29 57-29 62.8 0 6 5.2 13.6 19 13.6 9 .7 12.3-8.8 15.5-12z" />
        <path d="M60.2 13c3.3-3.2 2.2-8.5 11.3-7.8 13.8 0 14.2 8.4 14.2 14.3S65 33.6 64 42.3c-1 8.7 4.8 11 9.6 11 4.7 0 8-2.7 8-5.1S79.4 45 76 45s1.5 1.7-1.4 3-4.8-2-4.8-4c0-2.2 7.2-2.9 12-1.3 1-4.7 1.4-5-5.3-13 4.8 3.1 5.2 3.8 10.5 2-5.3 4.6-1.3 13.8-1.2 16.1s-1 5.1-3 6.5c-4 3.7-12.3 3.7-17.3 1.5-7.3-3.2-7.7-12.8-5.8-16L80 19.3c1.4-2.4 2-9.2-6.6-9.5-9-.7-12.2 11.6-13.8 15.7C57.5 21 55.1 8.6 46 9.3c-8.6.3-10.2 7-8.8 9.5l20.7 21c2 3.2 1.6 12.8-5.7 16-5 2.3-13.3 2.1-17.1-1.4-2.2-1.4-3.4-4.1-3.2-6.5s4.1-11.5-1.1-16c5.2 1.7 5.7 1 10.4-2-6.6 7.9-6.1 8.2-5.2 13 4.8-1.6 12-1 12 1.1s-2 5.6-4.9 4.2c-2.8-1.4 2-3.1-1.4-3.1-3.3 0-5.7.7-5.7 3s3.3 5.3 8.1 5.3 10.5-2.4 9.5-11.1-22-18.1-22-24c0-6 1.4-13.1 15.2-13.1 9-.7 10.1 4.6 13.4 7.8z" />
      </g>
      <g fill="#ffe400" transform="translate(-194.7 8.3) scale(1.0673)">
        <rect
          width={170.2}
          height={161.3}
          x={425.9}
          y={104.5}
          rx={85.1}
          ry={80.7}
        />
        <path d="M507 56.4c-.8 0-4.6 26.8-6 32.8-1.4 13.5 18 13 14.8-.5L507 56.3zm6.8 259.8c.7 0 6.5-26.5 8.4-32.4 2.3-13.3-17.1-14-15-.4l6.6 32.8zM378.2 184.6c0 .7 27.9 6.3 34.1 8.1 14 2.3 15-16 .6-14l-34.7 6zm271.7 3.2c0-.7-28.2-5.3-34.5-6.9-14.1-1.7-14.2 16.6 0 14.1l34.5-7.2zM406.8 99.6c-.5.5 17.9 21.3 21.6 26.4 9.6 10 22.3-4 9.6-10.8l-31.2-15.5zm211.1 171c.5-.5-19.7-19.7-23.9-24.4-10.5-9.2-21.8 5.7-8.6 11.5l32.5 13zm-169-200c-.6.3 8 26.1 9.4 32.2 4.8 12.7 22.2 4.4 13.2-6.5L449 70.6zM572 303c.7-.3-6-26.6-6.9-32.7-3.9-13-21.8-6-13.7 5.6l20.7 27zm30.3-214.4c-.6-.5-22.8 16.6-28.2 20-10.7 9 3.8 21.2 11.2 9.3l17-29.3zm-183 193.7c.5.5 24-15 29.6-18.1 11.3-8.2-2.2-21.4-10.5-10l-19 28.1zm-35-144.1c-.3.6 24 14.7 29.3 18.4 12.5 6.5 19.8-10.5 5.5-13.2l-34.8-5.2zM638 236.6c.3-.6-23-16.3-28-20.3-12-7.4-20.5 9.1-6.4 12.7l34.4 7.6zM557.4 63.7c-.7-.2-14.6 23.4-18.3 28.5a7.8 7.8 0 0 0 14 4.7l4.3-33.2zM463.5 308c.7.3 16.3-22.4 20.3-27.3 7.3-11.6-10.4-19-13.7-5.6l-6.6 32.9zM386 238.7c.3.6 28-6 34.5-7 13.6-3.8 6-20.6-6-12.8L386 238.7zM638.1 136c-.2-.6-28.3 4.1-34.8 4.7-14 2.9-7.5 20.2 5 13.2l29.8-17.9z" />
        <path d="M534.6 58.1c-.7-.1-10.1 25.4-12.9 31-4.1 13 15 16.2 14.7 2.4L534.7 58zM486.1 314c.7.2 12-24.7 15.2-30.2 5-12.6-13.8-17-14.5-3.3L486 314zm-9.7-253.4c-.7.2 1.9 27.2 1.9 33.4 1.9 13.3 20.6 8.7 14.4-3.7l-16.3-29.7zm68 251.9c.7-.1 0-27.2.5-33.4-.9-13.5-20-10.1-14.6 2.7l14 30.7zM428.2 83c-.6.4 12.7 24.3 15.2 30 7.2 11.7 22.7.7 11.8-8.6l-27-21.4zM593 290.9c.6-.4-11-25.2-13-31-6.3-12.1-22.5-2.1-12.4 7.8l25.4 23.2zM393 116.6c-.4.6 21.1 18.4 25.6 23 11.1 8.4 21.4-7.2 7.8-12.1L393 116.6zm234.2 139.7c.4-.6-19.7-19.8-23.9-24.6-10.4-9.1-21.8 5.8-8.6 11.6l32.5 13zm-249.6-97.8c-.2.7 26.3 10.8 32.1 13.7 13.4 4.5 17.7-13.4 3.1-13.8l-35.2.1zM645 216.3c.3-.6-25.4-12.4-31-15.7-13-5.4-18.7 12.2-4.2 13.6l35.2 2.1zM376.7 210c.1.6 28.7.2 35.2.7 14.2-.7 10.8-18.8-2.8-13.9L376.7 210zm270.2-45c0-.7-28.6-2.2-35-3.1-14.3-.2-12.2 18.1 1.7 14l33.3-11zm-245.7 98.4c.4.6 26-11.6 32-13.9 12.4-6.5 1-21.4-8.9-11.3l-23.1 25.2zm222.3-152.3c-.4-.6-26.7 9.9-33 11.8-12.9 5.7-2.6 21.3 8 11.9l25-23.7zM442.8 298.8c.6.3 18.9-20.5 23.5-24.9 8.7-10.7-8-20-12.9-7l-10.6 31.9zM582.5 75c-.5-.4-20.3 19.1-25.2 23.2-9.4 10.1 6.6 20.5 12.4 7.9L582.4 75z" />
        <g transform="matrix(2.1824 0 0 2.0629 -405 -272.6)">
          <path d="M360.1 247.9c.7 2.5.8 16.5 14.9 30 14 13.4 38 16.4 38 16.4s.1 1.9-1.6 2c-1.7.2-9.9-1.5-14-2.8-4-1.2-7.6-3.4-8-3.3-.5.2-1.3 1.6-2.5 1.4s-7-6.2-9.6-7.8a80.6 80.6 0 0 1-13.7-15.3c-2.8-4.5-3.5-7.5-4.4-7.5s-4.2 2.2-4.2 2.2-3-4.5-5.6-11.7c-2.7-7.2-2.4-11.4-1.8-11.7.7-.3.7 5.3 2.7 10.4 2 5.2 4.8 6.8 4.8 6.8s-1.8-2.7-3.2-9.4-2-13.2-1-15.2 1.9-2.6 2-2.5c.2.2-1.7 3.1-.4 10.8s4.8 14.2 5.6 13.9c.8-.3-.5-1.9-1-6.4s.5-7.3 1.6-7.7c.5-.4 1.3 5 1.4 7.4zm-9.8 12.8c-2.7-2.5-6.9-11.2-7.8-10.8-1 .5 6.8 13 7 14 .2 1.2 1.9 4.6.6 4.1s-10.6-10.3-9.5-8.4 8.1 10.5 7.7 11-5.8-4.8-6-4.1c-.1.6 5.3 5.8 5.2 6.4s-3.5-3.3-3.5-2.5 3.5 4.7 3.5 5.3-3-2.8-2-1c.9 2 3.5 3.7 3.4 4.3s-2.2-.8-2.2-.5c0 .3 3.9 1.7 4.8 2.8 1 1.1 7.4 8.5 12.2 12.2s18.6 10.2 19.6 10.2c.9 0 2.3-2 2-2.8-.3-.8-13.8-5.4-17.5-8.8-3.8-3.4-13-11.6-13.8-12-.7-.5-2.8-.3-2.8-.8s2.7.3 2.5 0c-.1-.3-3.7-1.9-3.6-2.2.2-.3 2.5.6 2.5.3s-4.2-2.6-4-3.1c.1-.5 3.1 1.4 3.1 1 0-.2-4-3-3.9-3.5.1-.5 3.1 2.2 3 1.6s-2.4-4-2.4-4.4c0-.5 3.6 3.4 4 2.6.2-.7-1.3-7.2-1.2-7.3s2.7 1.4 3.1.5c.5-1-1.8-2.3-4-4.1zm46.1 49.2c-1.9.3-2.8-.4-1.7-2 1.5 0 5.5-1.3 6.9-1.9s2.9-1.4 4.1-2.5c1.2-1.3 2 .7 1.3 1.8-.5.7-2.8 2-4.5 2.7-2.5.8-4.7 2-6.1 1.9zm12.5-5.1c-1.3-1.4-.2-2.4 1.7-3.5 2.8-1.5 2-3.6 5.6-5.3 1.6-1 24-10 31.3-14.8s27.8-20.3 33.3-31c5.4-10.6 2.8-11.4 3.6-11.8.7-.5 1.5 1.5 1.4 3.9-.2 2.3-2 9.3-1.4 10s8.2-5.5 11.4-13 5.6-15.3 7.1-15.3c1.6 0-2.6 12.8-5.3 17.8-2.6 5-5.7 7.5-5 8.6.8 1 8.6-5.5 11.3-10.3 2.6-4.9 5.1-9.2 5.6-8.3a34 34 0 0 1-6.7 16.1c-4.2 4.8-9.2 8.3-8.4 9 .7.8 6.4 1.6 12.3-2.4 6-4.1 6.6-10 7.3-9.7.8.3-.7 8.4-6.4 13.4s-13.2 5.5-13 6.6c.4 1 16.3-4.6 16-3.3-.3 1.2-20.6 9.2-20.8 10 0 .6 3.5.8 9-.5 5.4-1.2 10.6-5.5 11.3-4.5.2 1.4-3.9 4.8-10.1 6.4-6.3 1.6-9.4 3.7-9.6 4.2-.1.5 11.2-1.4 11.2-.8s-14.8 3.5-14.9 4.3c-.2.7 14-2.9 13.8-2-.4.7-19.3 6.3-19.1 6.6.1.4 15.8-3.4 15.5-2.8-.4.7-26.4 8-26.6 8.5-.2.4 23-5.2 22.8-4.7s-12 3.4-12 3.7c0 .3 9.5-1.5 9.3-1-.1.4-24 6.5-24.5 7.4-.5 1 12.4-2.5 12.2-.7s-27.7 11-27.8 9.3c-.2-1.7 16.7-6 16.6-6.5-.2-.5-9.7 1-9.9.1-.1-1 6.3-3 5.8-3.4-.5-.5-5.3 1.4-4.9.3.5-1.1 9.6-5.3 9.4-5.6-.1-.3-3.3 1-3 0 .4-1.1 19.7-6.7 19.4-7.4-.3-.6-8.9 1.4-9.7 1.6-.3-.6 12-5.2 11.8-6-.4-.7-6.6 2.7-7 1.8-.2-1 10.9-5.3 10.2-6s-5.7 1.8-6.4 1.1 10.5-8.4 8.8-8.6c-1.7-.1-3.8 2.4-4 .8.2-2 8.7-5.3 6.8-6.9-3-.9-13.1.7-17.3 3.2s-18.2 16.4-21.6 18.6c-3.4 2.1-15 7-17.2 8-3.4 1.2-4 3-7.5 4.8-6.3 1.7-6.2 3.6-9.2 4.7-1.1.3-12.4 5.7-12.5 5.3zm-15.8 7c-1.9 1-3.6 3.4-2.5 4.4.6 1.2 2.5-2.7 4-2.5l8 .4c4.3.3 6.4-.9 8.8-.7s7.7-1.3 10.2-1.3 3 .3 3.2-.8c.3-1-7.8-.3-11.4-.4-3.6-.2-8.1.7-10.8.7-2.5-.1-6.8-.9-9.5.2z" />
          <rect width={3.4} height={3} x={401.7} y={309.1} rx={1.7} ry={1.5} />
          <path d="M445 307.7c1.7-.3 6.3 1.3 9.5 2 5.8 2.3 16.6 1.2 16.6 2.3s-.7 2.4-3.2 2.6-8.8-1-8.6-1 5 2.3 3.6 2.9-5.5-1.3-6.2-.8 3.8 1.4 3 1.7c-.6.3-3.7-.4-4.7-.3-1 .2.8 1.3-.4 1.7-1.2.5-3.2-.6-4-.3-.9.3 1.8 2 .6 2.2-1.2.2-4-.8-5.6-1-1.6 0 1.5 1.6.5 1.8-1 .1-3.8-1.3-4.5-1.3s0 2-1 2-2.2-1.7-2.8-1.7 0 2-1 2-1.4-2.1-2.2-2c-1 .2 0 2.7-1.4 2.5-1.3-.1-1.5-2.6-2.6-2.5-1 .2.2 2.5-.8 2.5s-1.2-2.3-2.2-2.5c-1-.1-.6 2.2-1.2 2.2s-1.2-2.2-1.6-2.2c-.3 0 0 2.2-1.2 2s-1.2-2.4-1.5-2.3c-.4.2-.4 1.8-1.2 1.8s-.9-1.6-1.2-1.4c-.4.1-1.6 2.1-2.4 1.8-.9-.3.2-1.9-.2-1.9s-1.4 1.1-2 1 0-1.4-.2-1.4-1.7.8-2.4.8-2.6 1-3.1.1c-.5-1 1.3-1 1.7-1.9.3-.9-1-3.6.4-4.5 1.3-1 5.6 1.3 12-.3 11.6-3.1 20.6-6.7 21.5-6.6z" />
        </g>
      </g>
    </g>
  </svg>
	),
	LA: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h640v480H0z" />
      </clipPath>
    </defs>
    <g fillRule="evenodd" clipPath="url(#prefix__a)">
      <path fill="#ce1126" d="M-40 0h720v480H-40z" />
      <path fill="#002868" d="M-40 119.3h720v241.4H-40z" />
      <path
        fill="#fff"
        d="M423.4 240a103.4 103.4 0 1 1-206.8 0 103.4 103.4 0 1 1 206.8 0z"
      />
    </g>
  </svg>
	),
	LB: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-85.3 0h682.6v512H-85.3z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="translate(80) scale(.9375)">
      <g fillRule="evenodd" strokeWidth="1pt">
        <path fill="red" d="M-128 384h768v128h-768zm0-384h768v128h-768z" />
        <path fill="#fff" d="M-128 128h768v256h-768z" />
      </g>
      <path
        fill="#007900"
        d="M252.1 130c-7.8 15.5-13 15.5-26 26-5.2 5.1-13 7.7-2.6 13-10.5 5.1-15.7 7.7-20.9 18.1l2.6 2.6s10-4.8 10.4-2.6c1.8 2.1-13 10-14.9 11.3l-11 7c-13.1 10.3-21 7.7-28.7 23.3l26-2.6c5.2 18.2-13 20.8-26 28.6l-20.9 13c5.3 18.2 20.9 7.8 33.9 2.6l2.6 2.6v5.2l-26 13s-30.8 17.6-31.3 18.2c-.2 1 0 5.2 0 5.2 10.4 2.6 26 5.2 36.5 0 13-5.2 15.6-10.4 31.2-10.4a100.6 100.6 0 0 1-52 20.8v10.4c15.6 0 26 0 39-2.6l33.8-10.4c7.8 0 15.7 7.8 13 15.6-7.7 28.6-39 23.4-49.4 46.8L213 369c10.4-5.2 20.8-10.3 33.8-7.7 15.6 5.2 15.6 15.6 36.4 20.8l-5.2-13c5.2 2.6 10.4 2.6 15.7 5.2 13 5.2 15.6 10.4 31.2 7.8-13-15.6-15.6-13-26-23.4-10.4-15.6-15.7-39 0-41.6l18.2 5.2c18.2 2.6 18.2-2.6 44.2 7.8 15.7 5.2 20.9 13 39 7.8-7.7-18.2-36.3-31.2-54.6-36.4 20.9-13 15.6 5.2 44.3-2.6v-5.2C369.3 278 361.4 265 332.8 265l44.3-5.2v-5.2s-43.7-11.4-44.7-11.9c.3-1.3 1.4-3.3 4.3-4.5 8.3 5.4 33.3 4.8 34.8 4.7-.8-6.4-12.7-11.7-23-16.9 0 0-44.7-27.5-44.9-29.9.9-7 18.3 1.1 37 6.5-5.2-10.4-15.6-15.6-26-18.2l15.6-2.6c-10.4-23.4-36.4-20.8-52-31.2-10.5-7.8-10.5-13-26.1-20.7z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3.2}
        d="M224 303c1.9-6.1 4.4-11.6-7.2-16.9-11.6-5.3 5.8 21.1 7.2 17zm13.7-12.3c-2.3.3-3.6 8.8 1.1 11.2 5.2.8 1-11.1-1.1-11.2zm13.5-1c-2.4.8-2.5 12.8 6 10.6 8.6-2.1 0-11.5-6-10.5zM267 259c1.8-3-.1-15-7.4-10-7.4 5.1 5 10.8 7.4 10zm-16-10c2.3-.9 2.5-8.3-4-6.3-6.3 1.9 2.3 7.8 4 6.3zm-14.4 2.9s-4.5-6.2-8-4.9c-4.3 4.2 8.3 5 8 4.9zM187 271.7c1.9.2 16-2.3 20.9-7.8 4.9-5.5-25.1 2.3-25.1 2.4 0 .1 2.8 4.9 4.2 5.4zm141.1-35c.7-1.3-7.5-7.1-12.4-4.8-1.3 4.3 12.4 5.7 12.4 4.8zm-27.8-14c1.6-2.2-3.5-11.3-13.7-6.2-10.2 5 10.7 9.8 13.7 6.3zm-32.1-5.3s2.5-8.2 8.6-6.6c7 5.3-8.3 6.9-8.6 6.6zm-6-6.2c-1-2.3-7.3-1-14.6 3.9-7.4 4.7 16.8 1.4 14.6-4zm18.7-22.1s6.5-3 8.5 0c2.7 4.3-8.6 0-8.5 0zm-5.5-2.9c-1.3-2.6-8.5-2.9-8.3 1-1.2 3 9.4 2.4 8.3-1zm-17.2 0c-.7-1.5-11 0-14 6.2 5 2.4 16.3-2.3 14-6.2zm-22 6.3s-13.4 8.3-14.3 14.3c.4 5.2 16.8-9.4 16.8-9.4s1.4-5.8-2.4-4.9zm-14.9-7.5c.4-1.7 6.7-5.6 7.2-5.3.5 1.7-5.1 6.3-7.2 5.3zm4.3 31.6c.3-2.5-16-2.3-9.9 5.2 5.2 6.3 11-4.1 9.9-5.2zm-15 10.7c-.8-1.6-2-6-4.2-6.4-1.9 0-11.7 2-12.5 3.6-.4 1.3 4.1 9.4 5.6 9.6 1.8.7 10.9-6 11.2-6.8zm88.4 55.2c.5-1.8 17.3-7.5 23-2 6.8 9.3-23.4 5-23 2zm46 10.9c3.7-6.2-11.3-13.6-17.6-6.5 2.2 8.5 14.6 11.6 17.6 6.5z"
      />
    </g>
  </svg>
	),
	LC: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#65cfff" d="M0 0h640v480H0z" />
      <path fill="#fff" d="M318.9 42l162.7 395.3-322.6.9L318.9 42z" />
      <path d="M319 96.5l140.8 340-279 .8L319 96.5z" />
      <path fill="#ffce00" d="M318.9 240.1l162.7 197.6-322.6.5 159.9-198.1z" />
    </g>
  </svg>
	),
	LI: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#002b7f" d="M0 0h640v240H0z" />
    <path fill="#ce1126" d="M0 240h640v240H0z" />
    <g
      fill="#ffd83d"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      transform="scale(.8)"
    >
      <g id="prefix__a">
        <path
          stroke="none"
          d="M216.4 122.3l-1.9 62.5h-63.4c-7.8-15.2-14.2-28-14.2-45.5 0-14.6 11.5-26.2 28-26.2 17.5 0 36.8 5.9 51.5 9.2z"
        />
        <g strokeWidth={1.5}>
          <path d="M144.5 125.2v36m5-39.7v48m5.2-50.5v57.2m5-58.4v44.9m5.1-45.1v45.3m5.1-47v47m5.1-47v47m5.1-46.5v47m5.1-46.5v46.9m5.1-44v47m5-46.5v52.9m5.2-52.9v47m5-47v47" />
          <path
            fill="#000"
            d="M176.4 118c10.8 1.7 34.4 12.8 31.7 27.7-3.8 21.2-16.2 12.7-32.6 9.7l-12.4 4.1c-4.5 4.5-11 8.7-15.4 3.2h-7.4v28.8h81.4V122z"
          />
        </g>
        <circle cx={212.8} cy={113} r={4.9} />
        <circle cx={201.7} cy={110.3} r={4.9} />
        <circle cx={190.4} cy={107.5} r={4.9} />
        <circle cx={179.1} cy={105.6} r={4.9} />
        <circle cx={167.8} cy={104.5} r={4.9} />
        <circle cx={156.8} cy={105.1} r={4.9} />
        <circle cx={146.2} cy={108.7} r={4.9} />
        <circle cx={137.3} cy={115.3} r={4.9} />
        <circle cx={131} cy={124.4} r={4.9} />
        <circle cx={127.9} cy={135.2} r={4.9} />
        <circle cx={128} cy={146.3} r={4.9} />
        <circle cx={130.2} cy={157.2} r={4.9} />
        <path d="M215 119.5l-.5 6.5c-12.3-2-29.7-8.8-46-8.8-15 0-26.6 6-26.6 21.2 0 14.9 6.3 28.5 14.7 42.3l-8.7 4c-7.8-15-14.3-28-14.3-45.4 0-14.6 11.5-29 31.3-29 17.5 0 35.4 6 50.1 9.2z" />
      </g>
      <use
        width="100%"
        height="100%"
        transform="matrix(-1 0 0 1 444 0)"
        xlinkHref="#prefix__a"
      />
      <path d="M222 53.1l-5.2 9.7 5.2 9.6 5.1-9.6L222 53zm0 24.4l-5.2 9.6 5.2 9.7 5-9.8-5.1-9.6zM203.6 75l8.1 5.1 8.1-5.1-8-5.2-8.2 5.2zm20.5 0l8.1 5.1 8.2-5.1-8.2-5.2-8 5.2z" />
      <circle cx={222} cy={75.1} r={3.9} />
      <circle cx={222} cy={100} r={10.5} />
      <path
        fill="none"
        strokeWidth={1.5}
        d="M219.3 89.9v6.6a62.5 62.5 0 0 0-7.4.8m20.2 0a62.1 62.1 0 0 0-7.5-.8v-6.6m-12.8 12.7a61.4 61.4 0 0 1 10.2-.9c3.4 0 6.8.3 10 .9"
      />
      <path d="M211.8 117.7c-1 17-3 34.5-9.7 47.1l10.8-4.4c3.8-14.3 4.6-32.8 5.7-41.6l-6.8-1.1zm20.4 0l-6.9 1.1c1.2 8.8 2 27.3 5.7 41.6l10.8 4.4c-6.6-12.6-8.6-30-9.6-47.1z" />
      <path d="M222 154.7c-13 0-22.5 6-23 21.6-3.2-5.6-16.5-23-29-20.7-7.4 1.4-14 11.7-12.8 23.4-6.2-17.6-24.1-20.5-37.3-10 11.7 9.5 16.9 37.8 26.7 50h150.7c9.8-12.2 15-40.5 26.7-50-13.1-10.5-31.1-7.6-37.2 10 1-11.7-5.5-22-13-23.4-12.4-2.3-25.7 15.1-28.9 20.7-.5-15.5-10-21.6-23-21.6z" />
      <g strokeWidth={1.5}>
        <path
          fill="#000"
          d="M297.1 219c0 5.6-33.6 11.7-75.1 11.7s-75.2-6-75.2-11.7c0-5.5 33.7-8.5 75.2-8.5 41.4 0 75.1 3 75.1 8.5z"
        />
        <circle cx={222} cy={114.4} r={3.5} />
        <circle cx={222} cy={122} r={3.7} />
        <circle cx={222} cy={130.2} r={4.1} />
        <circle cx={222} cy={139.3} r={4.7} />
        <circle cx={222} cy={149.4} r={5.1} />
        <path
          fill="#000"
          d="M220 159.2c-.6 0-1.1.5-1 1.4l.6 4.3c.2 1.5 1 1 1.3 0 .2-1.2.1-2 .2-4.1 0-1.1-.6-1.6-1.2-1.6zm4 0c-.6 0-1.1.5-1.1 1.6 0 2.1 0 2.9.2 4 .2 1.2 1 1.6 1.3 0l.5-4.2c.2-1-.4-1.4-.9-1.4zm-7.7.6a1 1 0 0 0-1 1c0 1 .3 2.3.4 3.8.2 1.5 1.3 1 1.4 0 0-.8.2-2.2 0-3.9 0-.6-.2-.9-.6-1a.8.8 0 0 0-.2 0zm11.1 0c-.3 0-.6.3-.7 1a20.1 20.1 0 0 0 .2 3.8c0 1 1.2 1.5 1.3 0 0-1.5.4-2.7.4-3.7 0-.6-.5-1-1-1.1a.8.8 0 0 0-.2 0zm-15.4 1.7c-.5.1-1 .7-.8 1.3.3 1.3.6 2.7.6 4 0 1.1.9.7 1 0a59.8 59.8 0 0 0 .1-4c0-1-.5-1.4-1-1.3zm19.6 0c-.3.1-.6.5-.6 1.3l.2 4c0 .7 1 1.1 1 0 0-1.3.2-2.7.5-4 .2-.6-.3-1.2-.7-1.3a.6.6 0 0 0-.3 0zm-59 .2c-.6 0-1 .7-.6 1.5.6 1.4 1.3 2.2 1.9 3.6.5 1.3 1.4.5 1.1-.4l-1.4-3.7c-.3-.7-.7-1-1-1zm98.8 0c-.4 0-.7.3-1 1-.9 1.9-1.2 2.8-1.5 3.7-.2 1 .6 1.7 1.2.4l1.8-3.6c.4-.8 0-1.5-.5-1.5zm-94.8 0c-.5.2-.7.7-.5 1.3.6 1.2 1.3 2.5 1.8 3.8.4 1.1 1.4.8 1-.2l-1-3.7c-.4-1-1-1.3-1.3-1.2zm90.5 0c-.4.1-.8.5-1 1.2-.7 2-.8 2.6-1.1 3.7-.4 1 .6 1.3 1 .2l1.8-3.8c.2-.6 0-1.1-.4-1.3a.6.6 0 0 0-.3 0zm-85.5 1c-.6.1-1 .9-.6 1.9.4 1.2 1 2.3 1.6 3.7.6 1.4 1.5 1.1 1.3.2-.3-.9-.5-2.3-1.2-4.5-.3-1-.7-1.4-1.1-1.3zm80.8 0c-.4 0-.9.3-1.2 1.3-.6 2.2-1 3.6-1.1 4.5-.3 1 .7 1.2 1.2-.2.6-1.4 1.2-2.5 1.6-3.7.4-1 0-1.8-.5-1.9zm-93.2.7c-.6 0-1 1-.7 1.7.5 1 .9 1.4 1.4 2.6.6 1.2 1.2.3 1-.5-.3-.8-.6-1.7-.8-2.8-.2-.8-.6-1-1-1zm105.6 0c-.4 0-.7.2-1 1l-.7 2.8c-.2.8.4 1.7 1 .5.5-1.2.8-1.5 1.4-2.6.3-.7-.2-1.6-.7-1.7zm-67 2.8c-.7 0-1.3.8-1 1.5.2 1.2.8 2.2 1.1 3.7.4 1.3 1.3.7 1.2-.2a28.7 28.7 0 0 0-.5-4c-.2-.7-.5-1-.9-1zm28.4 0c-.3 0-.7.3-.8 1a28.7 28.7 0 0 0-.6 4c0 .9.9 1.5 1.2.2l1.2-3.7c.2-.7-.4-1.5-1-1.5zm-14.2 1.2c-.8 0-.9 1-.9 1.7a12.3 12.3 0 0 1-2 6.4c-1 1.2-2.3.9-3.5.2a22.3 22.3 0 0 1-3.3-2.2c-1.4-1-2.4-.4-.8 1.9 4.6 6.6 9.6 12.2 9.6 23 0 1.3.3 1.7.9 1.7s.8-.4.8-1.8c0-10.7 5-16.3 9.6-23 1.6-2.2.6-2.8-.7-1.8a21 21 0 0 1-3.3 2.2c-1.3.7-2.6 1-3.5-.2a12.3 12.3 0 0 1-2-6.4c-.1-.7-.2-1.7-1-1.7zm-35.3-1.6a.6.6 0 0 0-.2 0c-.3.1-.4.4-.3 1l1.1 3.9c.3 1 1.4.7 1.2-.5l-.6-3.1c-.2-.8-.8-1.3-1.2-1.3zm70.6 0c-.5 0-1 .5-1.2 1.3-.4 1.4-.4 1.8-.6 3-.3 1.3.9 1.5 1.1.6l1.2-4c0-.5-.1-.8-.4-.9a.6.6 0 0 0-.2 0zm-91.6.4c-.6 0-1 .8-.4 1.8.6 1.2 1.7 2.6 2.2 3.5.5.8 1.4.2.8-.8-.6-1-.8-2.3-1.6-3.8a1 1 0 0 0-1-.7zm112.5 0c-.3 0-.7.2-1 .7-.7 1.5-1 2.7-1.5 3.8-.6 1 .2 1.6.7.8.5-.9 1.6-2.3 2.2-3.5.6-1 .2-1.8-.4-1.8zM134 169.5c-.6 0-.8 1.2-.2 2a19.2 19.2 0 0 0 2.6 2.7c.8.8 1-.2.6-1l-1.8-2.7c-.5-.7-.9-1-1.2-1zm175.9 0c-.3 0-.7.3-1.1 1l-1.9 2.7c-.4.8-.2 1.8.7 1a19 19 0 0 0 2.6-2.7c.6-.8.4-2-.3-2zm-170.8 1c-.6 0-1 .4-.5 1.3l1.9 3.8c.5 1 2 1.3 1.4-.2l-1.3-3.8c-.3-.7-1-1-1.5-1zm165.8 0c-.6 0-1.3.4-1.6 1.1l-1.2 3.8c-.6 1.5.9 1.2 1.4.2.5-1 1.3-2.5 1.8-3.8.5-.9.1-1.3-.4-1.3zm-175.6.4c-.8 0-.8.7-.1 1.2.9.7 2 1.4 3 2.3 1.3 1 1.7 0 1-.8-.6-.8-1.2-1.6-2.9-2.5-.4-.2-.7-.2-1-.2zm185.3 0c-.2 0-.6 0-1 .2-1.6.9-2.3 1.7-3 2.5-.6.9-.1 1.8 1.1.8 1-.9 2.2-1.6 3-2.3.8-.5.7-1.2 0-1.2zm-109.6.7c-.5 0-.8.5-.7 1.2l1 3.6c.2 1.1 1.5 1.1 1.3 0-.2-1-.3-2.3-.7-3.9-.1-.6-.4-.9-.8-1a.6.6 0 0 0-.1 0zm33.8 0c-.3 0-.6.3-.8 1-.4 1.5-.5 2.8-.7 3.9-.2 1 1.1 1 1.3-.1l1-3.6c.2-.7-.2-1.2-.6-1.2a.6.6 0 0 0-.2 0zm-64-2c-.3 0-.5.7-.2 1.7a26 26 0 0 1 1.6 9c-.3 1.2-1 1.3-1.9 1a18.8 18.8 0 0 1-2.8-1.7c-.8-.5-1.7.1-.5 1.1 6 5 10.3 10.7 12 17.6.2 1.4 1.1 1.6.9 0-1.4-8.7-1.7-15.9.4-20.3.8-1.7 0-3.3-1.2-.6-.9 1.8-2.2 2.5-3.3 1a47.9 47.9 0 0 1-4-7.7c-.2-.7-.5-1-.8-1.1a.3.3 0 0 0-.1 0zm94.1 0c-.3 0-.6.4-.8 1-.7 2-2.9 6.2-4 7.8s-2.4.8-3.2-1c-1.3-2.7-2-1.1-1.3.6 2.1 4.4 1.8 11.6.5 20.3-.3 1.6.6 1.4 1 0a32.4 32.4 0 0 1 11.8-17.6c1.2-1 .3-1.6-.5-1a18 18 0 0 1-2.8 1.5c-1 .4-1.6.3-1.9-1-.2-1.2.2-3.9 1.7-9 .2-.8 0-1.5-.3-1.6a.3.3 0 0 0-.2 0zM144.4 172c-.5 0-1 .4-.7 1.2.4 1.4 1.2 2.8 1.5 3.6.3.9 1.2.5 1-.7l-.5-3.1c0-.6-.7-1-1.3-1zm155.1 0c-.6 0-1.2.4-1.3 1l-.4 3.1c-.2 1.2.7 1.6 1 .7.2-.8 1-2.2 1.4-3.6.3-.8-.1-1.2-.7-1.2zm-136.3-1.7c-.6-.1-.7 1.5-.2 2.2l2.8 3.1c.8 1 1.3.1.8-.7l-2.6-3.8c-.3-.5-.6-.8-.8-.8zm117.5 0c-.2 0-.5.3-.8.8l-2.6 3.8c-.5.8 0 1.7.9.7l2.7-3.1c.5-.7.5-2.3-.2-2.2zm-132 4c-.4 0-.7.2-.5 1 .2 1.2.5 2 .8 3.1.3 1 1 .9 1-.1l-.3-3.2a1.1 1.1 0 0 0-1-.9zm146.5 0a1 1 0 0 0-1 .8l-.3 3.2c0 1 .8 1.2 1 .1l.9-3c.2-.9-.2-1.2-.6-1.2zm-133.4 1.4c-.6 0-1.1.7-.4 1.6 1.1 1.5 2.4 2.5 2.9 3 .4.6 1.5.4.8-.7l-2.3-3.5c-.2-.4-.6-.5-1-.4zm120 0c-.2 0-.5.1-.6.4l-2.4 3.5c-.7 1.1.4 1.3.9.8.4-.6 1.7-1.6 2.9-3.1.7-1 .1-1.6-.5-1.6a.9.9 0 0 0-.2 0zm-140.7 4.1c-.4 0-.6.4 0 1.3a17 17 0 0 1 3.3 6.4c.1 1.4-.5 1.4-1.1 1.4-1.9 0-2.8-1.4-4.4-1.8-1.7-.3-2 .5-.8 1.4a53.4 53.4 0 0 1 14.7 13.8c1 1.9 2.3 2.5 1.6.8a23.7 23.7 0 0 1-2.4-12.6c.5-2.8 1.2-4.6 1.1-6.2 0-1.5-1-1.4-1.3 0l-1 2.8c-.4.5-1.8.8-3-.9a48 48 0 0 0-5.6-5.8c-.3-.3-.7-.5-1-.6zm161.7 0c-.3 0-.7.2-1.1.6a48.2 48.2 0 0 0-5.5 5.8c-1.3 1.7-2.7 1.4-3 1a12 12 0 0 1-1-2.9c-.4-1.4-1.3-1.5-1.4 0 0 1.6.6 3.4 1.1 6.2s0 7.2-2.3 12.6c-.8 1.7.6 1 1.6-.8a53 53 0 0 1 14.6-13.8c1.2-.9 1-1.7-.7-1.4-1.7.4-2.6 1.8-4.4 1.8-.6 0-1.3 0-1.2-1.4.1-1.3 1.8-4.4 3.3-6.4.6-1 .5-1.3 0-1.3z"
          stroke="none"
        />
        <path d="M150.1 212.7l2 6.1m2-7.3l1.8 6.2m2.6-7l1.2 6.4m2.8-7.1l1.3 6.3m3.8-6.8l1 6.4m4.5-6.4l1.1 6.3m4.3-8.1l.8 6.4m4.2-6.1l.8 6.4m4.1-7l.8 6.4m4-7l.5 6.5m4.8-6.5l.4 6.5m4.4-6.8l.3 6.5m4.9-6.8l.3 6.4m5.7-6.6l.3 6.5m79 .2l-2 6.1m-2-7.3l-1.7 6.2m-2.6-7l-1.2 6.4m-2.8-7.1l-1.3 6.3m-4-6.8l-1 6.4m-4.4-6.4l-1.1 6.4m-4.2-8.2l-.8 6.4m-4.3-6.1l-.8 6.4m-4-7l-.9 6.4m-4-7l-.5 6.5m-4.8-6.5l-.4 6.5m-4.3-6.8l-.3 6.5m-5-6.8l-.2 6.4m-5.8-6.6l-.2 6.5m-7.2-7v7.2" />
      </g>
    </g>
  </svg>
	),
	LK: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#ffb700" d="M0 0h640v480H0z" />
    <path fill="#ff5b00" d="M26.7 240l88-213.3h88v426.6h-88z" />
    <path fill="#005641" d="M26.7 26.7h88v426.6h-88z" />
    <path fill="#8d2029" d="M229.3 26.7H616v426.6H229.3z" />
    <path
      id="prefix__a"
      fill="#ffb700"
      stroke="#000"
      strokeWidth={1.1}
      d="M579.3 408.6s3.6 7.3 7.6 10.4c6 4.4 18 4 23.3 9.3 6.1 6.1-.5 14.2-.5 15l.4 4.2s-4.2 0-6 .3c-2.6.4-3.6 2.6-8.6 2.3-12.3-.8-11.8-12-12.5-21.5-.6-3.6-2-8.4-2.9-12-.7-3-.8-8-.8-8z"
    />
    <use
      width="100%"
      height="100%"
      transform="matrix(-1 0 0 1 845.3 0)"
      xlinkHref="#prefix__a"
    />
    <use
      width="100%"
      height="100%"
      transform="matrix(1 0 0 -1 0 480)"
      xlinkHref="#prefix__a"
    />
    <use
      width="100%"
      height="100%"
      transform="rotate(180 422.7 240)"
      xlinkHref="#prefix__a"
    />
    <g transform="translate(0 -76)">
      <use
        width="100%"
        height="100%"
        stroke="#000"
        strokeWidth={5.6}
        xlinkHref="#prefix__b"
      />
      <g id="prefix__b" fill="#ffb700">
        <path d="M363.5 415.8l2.3-1.4 1 1.4c1.3 1.8 5 1.7 7.4 0l1.9-1.5 1.6 1.4c2 1.9 5.8 1.9 8.3 0 1.7-1.2 2-1.3 3-.3.7.6 2.7 1.2 4.4 1.5 3.2.4 3.2.4 5-2.4 1.6-2.3 1.8-3.2 1.5-5.5a59.4 59.4 0 0 1-.6-5.3c-.2-2.6-.1-2.6 3.6-4a50.5 50.5 0 0 0 5.4-2c1.5-.9 5.7-5.8 5.7-6.8 0-.2-1.6-.6-3.6-.8-8-1-9.3-5.2-4.1-13 8.3-13 13.4-25.5 13.4-33.4 0-3.6.3-4.8.7-4 1.9 3.1-1.5 16.4-6.5 26l-2 3.8 1.9-.4c1-.3 7.4-3 14-6 18.2-8.2 24.4-9.8 36.2-9.3 9.9.4 14 2.3 21 9.6 3.7 4 7.3 6.7 13.8 10.8 13.8 8.6 14.4 9.4 15.1 19.6.7 10.3.3 10.9-7.5 12.6-6.7 1.5-10.9 4.6-12 9-.6 2.2.7 2.3 4 .1l2.5-1.6 1.1 1.6c1.5 2.1 4.5 2.1 7 0l2-1.5 2 1.5c3 2.5 7 1.9 8.2-1.2.2-.5.8-.4 2 .7 2.3 2 8 2.8 8.6 1.2.2-.6-.2-2-1-3.2-3.3-5-4.4-7.3-4.4-10 0-3.8 1-5.7 5.4-8.7 5.2-3.8 6.8-8.6 2.8-8.6-2.4 0-4.9-2.2-6.5-5.7-3.2-7.2-2.5-15.2 2.3-28.6a57.6 57.6 0 0 0 5.4-25.2c0-7.4-.2-8.6-1.8-12.7a45.4 45.4 0 0 0-4.6-8.1l-2.8-3.7 3.5-3c10.8-8.9 8.6-23.5-4.4-29.1-4-1.8-5-1.9-12-1.9-4 0-10.5.6-14 1.3a98.2 98.2 0 0 1-14.2 1.2c-6.8 0-8-.2-10.6-1.6-2.7-1.4-3.2-2.1-3.7-5.5a2 2 0 0 0-1.1-1.5c-1-.3-5.2 3.4-5.8 5-.4.9-.6.8-1.5-.3a13.4 13.4 0 0 1-2-3.6c-1-3.3.3-5.7 4.2-7.6l3-1.4-1.8-1.1c-3.6-2.3-9.8-.7-12 3-.7 1-1.4 2-1.6 2-.2 0-1.4-1-2.6-2.3-4.7-4.6-3.1-11.4 3.2-13.4 3.3-1.1 6.3-.3 6.9 2 1 3.3 3.8-1.1 3.3-5.2-.3-2.7-.3-2.8 1.6-2.8 2.6 0 8 3.4 9.8 6 2 3.1 1.8 8-.4 11.6l-1.7 2.8 2.3-.4c3.2-.7 6.4-2.7 8-5.2a12 12 0 0 0 .4-10.4c-1.5-2.7-1.3-3.1.9-2.2 3.6 1.5 5.6 3.2 7 6.1 1.4 2.6 1.5 3.2.8 6a17 17 0 0 1-2.2 4.8c-1.2 1.6-1.3 1.9-.3 1.9 1.8 0 5.4-1.7 6.7-3 .7-.8 1.7-2.5 2.2-4l1-2.5 1 2c1.5 2.7 4.5 5.2 8.1 6.8 3.9 1.6 5.5 1.7 3.5.2-1.4-1-4-8.5-3.1-9.2a51 51 0 0 1 11.7 9c5.7 5.1 9.3 6.8 14.5 6.8 6.7 0 10.6-5.8 7.6-11.3-1.7-3.2-5.6-3.7-8-1-1 1.3-1.3 2.3-1 3.7.4 1.6.3 1.8-1.2 1.8-2 0-5.8-2.5-12.6-8.2a102 102 0 0 0-32.1-18.7 70.4 70.4 0 0 0-24.3-1.3c-6.4 1.2-14 4.9-18.2 8.8-7.3 7-7.4 16.3-.3 24.8l2 2.4-1.3 2.2a9.3 9.3 0 0 0 .4 10.4c1 1.4 2 2.5 2.3 2.5.2 0 .4-.9.5-2 .2-2.7 1.4-4.5 3.4-5.2 1.8-.7 3-.3 11.2 3 8.7 3.4 23 3.6 38.2.6a42.6 42.6 0 0 1 20 .2c7.2 3 8.8 10.7 3.6 16.5-2.3 2.6-4.4 3.6-11.7 5.6a54.3 54.3 0 0 1-19.5 1.5c-10.8-.1-14.7.1-19 1-4.9 1-7.8 1.1-21.8.8l-16.3-.4 1.8 1.4a22 22 0 0 0 3.1 2.3c1.3.7 1.2.8-.6 1.5-1 .4-3.4.7-5.3.7h-3.3l-.4 2.8a10 10 0 0 0 0 4c.4 1 .2 1.2-.8.8-.7-.3-2.6-.8-4.3-1.1a26.7 26.7 0 0 1-5-1.6c-1.9-1-2.1-1-2.8.3-.6 1-6.2 5.2-7 5.2a26.7 26.7 0 0 0-2.2-7.5c-1-2.1-1.9-4.5-2.2-5.2-.3-1.1-.5-1.2-1-.3-.3.5-.7 2-1 3.2a15.5 15.5 0 0 1-1.8 4.6l-1.5 2.2-1-1.9c-1-2-2.6-4.2-3.2-4.2-.2 0-.5.6-.7 1.5-.5 1.6-4.4 6.3-5.4 6.3-.3 0-.6-1.3-.6-3 0-1.5-.3-2.9-.7-2.9-.4 0-.7.5-.7 1 0 1.2-3.3 5-4.5 5-.4 0-1.2.4-1.7 1-1.2 1.3-2.2 1.1-1.7-.4a9 9 0 0 0-.4-3.8l-1-3.2c-.2-.5-1.4-.3-4 .5-4 1.3-5.4 1-3.3-.6.8-.6 2-2.7 2.6-4.6.7-2 1.7-3.7 2.2-3.9.7-.2.7 0-.2 1.2a5.7 5.7 0 0 0-1.1 2.6c0 .5-.5 1.8-1 2.9-.6 1-1 2-.9 2.1s1.7-.5 3.5-1.3l3.2-1.6v1.4c0 .8.4 2.8.9 4.5l.9 3 2.2-1c2.2-1 4.3-4.6 4.3-7.5 0-1.4.8-1.2 1.2.3 0 .4.6 2.1 1 3.7l1 2.8 1.5-1.8c.9-1 1.9-3 2.3-4.3.8-2.4 2-3.5 2-1.7 0 1.2 3.4 5.8 4 5.4.4-.2 1-1.9 1.5-3.8 1-4 2.5-6.6 3.5-6 .4.2.5.6.3 1-.2.2.6 2.8 1.8 5.6a2557.7 2557.7 0 0 1 2.6 6.3c.4 1 .8 1 3.3-1.3 1.5-1.4 3-2.9 3.1-3.4.3-.8.6-.7 2 .2a25 25 0 0 0 9.5 2.8c.2-.2.4-2 .4-4l.1-3.7 2 .4c1 .3 3.3.3 5 0l3-.4-2.7-2c-1.5-1-3-2.3-3.4-2.9-.3-.6-1.7-1.2-3.2-1.3-4.1-.4-11.4-4.4-11.4-6.4 0-.4 1 .3 2.2 1.4 2.8 2.5 6.6 4 10 4h2.4l-1.5-2a11.9 11.9 0 0 1-2-5.2c-.2-3-.5-3.4-3.6-5.5a35.2 35.2 0 0 1-5-4.3l-1.7-1.9-.9 2.3c-.5 1.3-1 2.3-1.3 2.3-.2 0-1.2-.8-2-1.7a7 7 0 0 0-2-1.6c-.3 0-1 1.2-1.8 2.7l-1.4 2.7-1-1.5a23.8 23.8 0 0 0-3-3.4c-1.2-1-1.7-1.8-1.3-1.8.4 0 1.7 1 3 2.3l2.2 2.3 1-1.7a6 6 0 0 0 .5-3.8c-.4-1.8-.3-1.9.3-.7a16 16 0 0 0 3 3l2.2 1.8 1.5-2.7c1.5-2.8 1.5-2.8 2.1-1.1 1 2.1 7.5 7.5 13 10.6 1 .5.6-1.1-1-5a12.7 12.7 0 0 1-.8-4c0-1.8-.5-2.6-2.8-4.4a10.9 10.9 0 0 1-5-8.4c-.3-1.7-.9-3.5-1.4-4.1-.6-1-.8-.4-.6 2.6.2 2.1-.1 4.7-.6 5.8l-.8 2-.6-1.7c-.4-.9-2-2.5-3.5-3.5s-2.6-2-2.4-2.2c.2-.2 1.8.7 3.5 2 2.7 2.1 3.2 2.3 3.6 1.4.4-1 0-5.6-.8-8.8-.4-1.6-.4-1.6 1.6.4 1.4 1.4 2.2 3.2 2.9 6.2.8 3.8 1.2 4.5 4.7 7.6 2.1 1.9 4 3.3 4.1 3.2.2-.2.4-5 .6-10.8.4-11.1 0-13.8-2.7-17.2l-1.4-1.8 2.2-2.3a16 16 0 0 0 4.7-8.8l.4-2.7-2.4 2.3c-2 1.9-3 2.3-5.3 2.3s-3.2-.4-4.7-2a20 20 0 0 0-8.3-4.8c-1.2-.4-1.6-.2-1.6.6 0 .6-.6 2.2-1.4 3.7l-1.4 2.6-3-3c-1.9-1.7-4-3.2-5.7-3.6-4.1-1-4.3-1-4.3 2.1 0 4.7-2 5.6-5.6 2.5-2.8-2.4-5-3-10.3-2.3l-4 .4.7 1.8c.6 1.5.5 2.2-.8 3.9-2.1 2.8-4.8 4-9 4-2 0-4.4.4-5.4.9s-3.6 1-5.7 1.2c-2 .2-4.3.6-5 .8-1 .4-1 0-.7-2.2.5-3.4-2-6-5.7-6-4.9 0-7.1 4.4-5.2 10.2a44.6 44.6 0 0 1 1 3.8 23 23 0 0 0 5.2 6.6c2.6 2.6 5 5.3 5.4 6a9 9 0 0 0 3 2.5l2.2 1.2-.3-2.4c-.3-2.6.2-3 1.6-1.1.5.6 1.8 1.7 2.8 2.3 1.7 1 2 1 2 .2 0-.6.3-1.9.7-2.9l.7-1.8 1.3 2.5c.7 1.4 3 4.5 5.1 7 4.1 4.7 6.7 10 5.4 11.2-.6.5-2 .5-5-.1-2.2-.4-5-.7-6.2-.5-2.3.3-2.5 0-1-1.8 1.5-2 1.2-2.3-1.8-2.3-3.5 0-12.2-1.7-15.6-3-3.2-1.3-4-1-5 2.1l-1.7 5.6-1 3 3.6-.3a37 37 0 0 0 5.5-1 6 6 0 0 1 2.2-.3c.2.1-.3 1.3-1 2.7l-1.4 2.4 2.2-.4c1.2-.3 3-.9 4-1.4 1.8-.8 2-.8 3.4 1.5 1.7 2.7 3 2.6 3.3-.3.3-3 1.3-2.6 3.2 1.4 1.8 3.8 3.6 5.2 4 3 .1-.8 1-2 2.1-2.8 2.2-1.5 3.8-1 4.7 1.3 1 2.5-1.2 5-7.4 8.8a43 43 0 0 0-21.7 31c-1.9 11.8 4 24 15.6 32.9 5.6 4.2 14.5 8.6 13.9 7-2.4-7.3-2.3-21 .1-23.3.4-.4.3 1-.3 3.1-2 7.9-1 14.1 4 28.7 4.4 13.2 3.8 18.9-2.6 22.6-2 1.2-3.3 1.4-8.8 1.3-6 0-6.7 0-8.6 1.6a15.7 15.7 0 0 0-4.3 8.6c0 1.3 1.4 1.1 4-.4z" />
        <path d="M460.5 415.5l2.5-1.6 1.7 1.6c2.2 2.1 4.9 2 7-.1 1-1 1.8-1.6 1.9-1.5l.9 1.6c.5.9 1.6 1.3 3.6 1.5 2.3.1 3 0 4-1.4l1-1.7 2.5 1.6c6.8 4.4 10.4-.2 7.3-9.3-1.5-4.6-.6-7.2 4.3-13 2.1-2.5 3.8-5.2 3.8-6 0-1.1-.4-1.3-3.2-1.2-2.6 0-3.4-.3-4.8-1.8-2.3-2.5-2.1-5.4.4-8.6l2-2.5-3.6-2.4a59.7 59.7 0 0 1-8-7.1 25.7 25.7 0 0 0-17.5-9l-4.7-.5v3.6c0 4.5 2.2 8.9 8 16.3 6.6 8.4 7 9.7 7.3 20.7l.3 9.3-2 1.8c-1.7 1.6-2.4 1.9-8 2.2-5.3.3-6.5.6-8 2a8.7 8.7 0 0 0-3.4 5.3c-.3 1.5-.2 1.8.9 1.8.7 0 2.4-.7 3.8-1.6zm-142.2-24a5.8 5.8 0 0 0 1-3c0-1 .6-1.4 3.2-1.8l3.1-.4-2-1.7c-2.5-2-2.8-3.5-.6-3.5s5.8-2.2 6.4-3.9c.3-.8 0-1.8-.4-2.3-1.2-1.4-3.5-1.2-3.9.4-.5 1.6-1.2 1.6-3 0-2.5-2.5-2.6-7.6 0-10.6 1.1-1.4 1.1-1.4-.4-2.9-1.6-1.6-2.8-4.6-2-5.4.2-.2 1.5 0 2.8.5 2 .6 2.7.6 3.5 0 2.3-1.9-.2-4.3-4-3.7-1.6.2-2.2 0-2.4-.8-.2-.6-1.5-1.4-3-1.8-2.7-.7-2.7-.7-2.7 1.2 0 2-1.2 2.4-3.4 1.1-1.8-1-3.5-.2-3.5 1.7 0 1.8 1.7 2.6 5 2.4 2.4-.1 2.5 1.7.2 4.3l-1.7 2 1.3 1.9c2 2.8 1.8 7.5-.3 9.9l-1.7 1.8-1.1-1.5c-1.6-2-3.7-1.9-4.3.3-.3 1.4 0 2 1.8 3.6 1.2 1 3 1.8 3.9 1.8 2.3 0 2.2 1.9-.2 3.7l-2 1.5 3 .4c1.6.3 3 .7 3 1 0 1.3 2 5.2 2.6 5.2.4 0 1.2-.7 1.8-1.5z" />
        <path d="M356.5 374.9c2.7-1 8.5-6 8.5-7.1 0-.4-1.6-2.2-3.6-4-4-3.6-8.5-9.9-9.7-13.5-.6-2-3.5-5.2-11.7-13.2l-10.9-10.5-3.1.8c-1.8.4-3.9.8-4.7.8-1.5 0-1.5 0 .5 1.6l2 1.6 3-1.6c2.7-1.6 2.8-1.6 3.1-.3.2.7-.2 2-1 2.9-.7.9-1.1 2-1 2.3.3.3-.4 1-1.5 1.6-2 1-3.5 4.3-1.9 4.3 1.5 0 4.7-4 4.3-5.3-.2-.7 0-1.4.2-1.6 1.3-.7 1.2 2.4 0 4-.8.8-1.2 1.8-1 2.2.2.3-.5 1-1.6 1.6-2 1-3.5 4.3-1.9 4.3s4.7-3.8 4.4-5.2c-.2-.7-.2-1.5.1-1.7.9-.4 1.3 2 .6 3.2a2.3 2.3 0 0 0 0 2.2c.7 1.3 0 3.7-1.3 4.5-.5.3-.2 1 1.2 2 2 1.4 2 1.6 2 8 0 5.4.2 6.8 1.2 7.7 1 1 1.2 1 1.2 0s2-2.4 3.5-2.4c.5 0 3.4 2.5 6.5 5.5s6.4 5.7 7.3 5.8l2.2.4c.3 0 1.7-.3 3.1-1zm-33.3-26.1c0-1.7-3.6-3.6-7.9-4-3.5-.5-3.5-.4-3.5 1.3 0 1.4.5 2 3 3 3.8 1.7 8.4 1.5 8.4-.3z" />
        <path d="M327.1 348.6c1.8-1.6 2.6-3.4 1.5-3.4-1.2 0-4.4 2.8-4.4 4 0 1.6.6 1.5 3-.6zm-3.7-5.1c.1-1-.5-1.6-2.3-2.5-4-1.7-8.6-2.6-9.7-1.7-2.1 1.7-.7 3.9 2.6 4.3 1.4.1 3.2.5 4.1.9 2.6 1 5 .5 5.3-1zm0-5.3c.2-1.3-.7-1.8-8-4.4-5.5-2-7.9-1-6.1 2.3.6 1.1 1.6 1.6 3.9 2 1.7.2 4 .7 5.1 1.1 3 1 4.8.6 5-1zm3.6-4.9c1.1-1.1 2-2.4 2-3 0-1.5-4.3 1.3-4.9 3.3-.6 2.3.5 2.2 3-.3zm-3.6-.3c.2-1.6-2.4-3-7.6-4.1-3.9-.9-5.6-.4-5.3 1.4.2 1 1.5 1.7 5 2.8 5.9 1.8 7.6 1.8 7.9-.1zm5-7.4c6.8-3 7.3-10.5 1-12.5-2.6-.8-4.2-.3-5.2 1.4-.8 1.4-.3 3.8.7 3.8.4 0 .7.5.7 1 0 2.7-10.2 3.8-14.4 1.7-1.5-.7-2-2.7-.9-2.7 1 0 1.6-2 1.1-3.3-.6-2-2.6-2.6-5.3-1.8-6.3 1.6-6.1 9 .3 12a33.6 33.6 0 0 0 22 .4z" />
        <path d="M324.3 319.8c.4-.4.2-1-.4-1.4-1.4-1.1-1.3-2.8.2-4.7 1.2-1.4 1.3-3.6 1.7-25.1.7-37.1 3.5-65 7.1-71.8 1.5-2.6 1.3-2.6-2.5 0a36 36 0 0 0-11.7 13.6c-6.2 11.5-8.3 27-8.3 60.2 0 18.8.1 21.3 1.2 23 1 1.8 1 2.4.4 4.2-.5 1.1-.7 2.3-.5 2.5 1.4 1.3 11.4 1 12.8-.5zm56.1-35.4c.3-.3-.2-2-1-3.6-1.2-2.6-1.7-3-3.4-3a65 65 0 0 1-23-6.4c-5.1-2.3-7-2.8-7.5-2.2-1.6 1.5 1 5 5 6.9a64 64 0 0 0 18.3 3.7c2.7 0 2.8 0 1.2 2.3l-1 1.6h3l5 .6c3 .7 3 .7 3.4.1z" />
        <path
          fill="#000"
          d="M412 301.1c0-1-2.9-3.5-5.7-5.2-2.3-1.3-2.7-1.4-2.7-.3 0 1.6-1.4 5.7-2 5.7-.3 0-.8-.8-1-1.7-.3-1-1.4-3-2.5-4.3l-2-2.5-1.4 2.3c-1.4 2.2-3.9 4.3-5 4.3-.2 0-.3-1.2 0-2.5.1-1.6 0-2.8-.5-3-.4-.3-.8-.2-.8.2 0 .8-3.4 4.6-4 4.6-.4 0-.8-1-1-2.4l-.8-4.8c-.2-1.2.3-.4 1 2l1.6 4.1 1.6-2.5a11 11 0 0 0 1.6-3.4c0-.5.3-.7.7-.5.4.2.9 1.9 1.1 3.7l.5 3.4 1.8-2a28.8 28.8 0 0 0 2.6-3.2c.7-1.2.8-1.2 2.3 0 .8.8 2.1 2.5 2.9 3.9s1.5 2.4 1.6 2.3l.6-3.2.4-3c.1-.5 5.4 3 7.4 4.7 1.2 1.1 2.4 1.9 2.6 1.7.2-.2.4-1.8.4-3.7 0-2.8-.3-3.6-2-5.1-2-1.8-2-1.8-2.8-.5-1 1.7-2.1 1.7-2.1 0 0-1.2-3.8-5.9-4.7-5.9-.3 0-1.1 1-1.8 2.3s-1.5 2.3-1.7 2.3c-1 0-6.3-6-6.3-7 0-.8.4-.6 1.3.8a21 21 0 0 0 3.1 3.6c2 1.8 2.8 1.4 3.6-2.1.3-1 .7-1.8 1-1.8.8 0 5.4 4.9 6 6.5l.7 1.6.5-1.8c.6-2.2 1.3-2.2 2.3-.2.4.8 2.4 2.6 4.4 3.8l3.7 2.4.7-2.4c.4-1.3 1-2 1.2-1.6.4.5-.6 4.5-1.3 5.3 0 .1-1.3-.6-2.6-1.5l-2.5-1.8v3.2c0 1.7-.2 3.8-.4 4.6-.5 1.6-1.7 2-1.7.6zm-18.5-25.4c-4.4-3.6-5-4.4-5-6.2l.1-1.8.3 1.7c.2 1 1.4 2.6 2.8 3.8l2.6 2 1.5-1.8c.9-1 1.6-2.2 1.6-2.6 0-1.2.2-1.1 3.2 1.5 2.6 2.3 2.7 2.3 3 .8.3-.8.2-2.4 0-3.5-1-3-.8-3.4.5-1.6l2.4 2.8c1 1.1 1.1 1.1 1.5-.3.3-.9.5-2.4.5-3.4v-1.9l2.3 2.7c2.3 2.6 2.5 2.7 3.1 1.4.5-.7.8-2.4.8-3.7 0-1.8.2-2.2.6-1.6.8 1.2.3 4.2-1.1 6.8l-1 2-1.3-2.1c-1.7-2.6-2.3-2.6-3.3.2-1 2.7-1.7 2.9-2.7.8-.6-1.3-.8-1.1-1.2 1.7l-.5 3-3-2.3-3-2.3-1.5 1.5c-.7.9-1.3 2-1.3 2.4 0 1-.8 1-1.9 0zm39-13.6c-1.5-1.4-2.6-2.8-2.4-3 .3-.3.5-.4.6-.2a67 67 0 0 0 3 3c3.4 3.6 2.7 3.7-1.1.2zm-52-5.4c-1.4-2-1.3-3.2.5-5.4 1.2-1.5 1.8-1.7 4-1.4 1.5.1 4.6 1.4 6.9 2.8a21.2 21.2 0 0 0 11 3l-1.7-2.8c-2.2-3.3-2.2-3.7.4-1.7 2.6 2.1 5.7 2.7 12.7 2.5l3.4-.1-2-2c-2.7-2.7-1.9-3 1.2-.3 2.8 2.5 2.7 2.7-3.4 3.3a23 23 0 0 1-7.6-.5c-3.4-1-3.6-.9-2.9.2.4.7 1 1.2 1.3 1.2.4 0 .7.4.7.8 0 1.3-7.4.1-11-1.6-8-4.1-9-4.5-11-3.9a4.3 4.3 0 0 0-2.4 2.3c-1.3 3.3 3.4 5.9 5.3 3 .6-.9.5-1.4-.5-2.5-1.4-1.4-1.2-1.6.6-1 1.3.5 1.4 3.6.2 4.8-1.3 1.3-4.5 1-5.7-.7z"
        />
        <path
          fill="#000"
          d="M412.4 248.6c-1-1-.2-1.2 4.3-1.3 5.6-.1 9-1 13-3.6 3.2-2 4.1-1.6 1 .5-2.7 2-7 3.4-11.3 3.8l-5.1.7c-.8.2-1.7.1-2-.1z"
        />
      </g>
    </g>
  </svg>
	),
	LR: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g fillRule="evenodd" clipPath="url(#prefix__a)" transform="scale(.9375)">
      <path fill="#fff" d="M0 0h767.9v512H0z" />
      <path fill="#006" d="M0 0h232.7v232.8H0z" />
      <path fill="#c00" d="M0 464.9h767.9V512H0z" />
      <path
        fill="#c00"
        d="M0 465.4h767.9V512H0zm0-92.9h767.9v46.2H0zm0-93.2h766V326H0zM232.7 0h535.1v46.5H232.7zm0 186h535.1v46.8H232.7zm0-92.7h535.1v46.5H232.7z"
      />
      <path
        fill="#fff"
        d="M166.3 177.5l-50.7-31-50.4 31.3 18.7-50.9-50.3-31.4 62.3-.4 19.3-50.7L135 95h62.3l-50.1 31.7 19.1 50.8z"
      />
    </g>
  </svg>
	),
	LS: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path fill="#009543" d="M0 336h640v144H0z" />
    <path fill="#00209f" d="M0 0h640v144H0z" />
    <path
      stroke="#000"
      strokeWidth={1.6}
      d="M319.6 153c-2.7 0-5.4 3-5.4 3l.3 32.4-10.3 10.7h8.3v18.5l-49 66-7.2-2.6-12.7 27s31.3 19.6 76.7 19c49.8-.5 76.9-19.9 76.9-19.9l-13-26.6-6.5 2.8-49.6-65.6v-19.1h8.2L325.1 188v-32.2s-2.7-3-5.5-2.9z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={8}
      d="M336.7 230.4h-33.9s-12.2-25.9-10.3-44c2-18.4 12.6-27.1 26.6-27.3 16.6-.1 25.2 8.1 27.8 26.6 2.6 18.3-10.2 44.7-10.2 44.7z"
    />
    <path
      fill="#fff"
      d="M260.5 292.1c-.6.7-4.7 8.9-4.7 8.9l7-1.5-2.3-7.4zm4 10.5l-7.4 2.4 8.9 3.5-1.5-5.9zm3.3-10.3l3.7 10.9 9-2.6-2.3-5.2-10.4-3.1zm5.8 14.8l1.2 4.4 12 3-4.8-10.2-8.4 2.8zm13.2-9.3l4.3 10.2 9-3.5-3-4.5-10.3-2.2zm6 13.9l1.4 3.8 14 2-5.9-9.2-9.6 3.4zm13.4-11l5.2 9.1 13-4.8-1.4-3.5-16.8-.7zm7.6 12.4l2.7 4.8 16.2-.5-6-9-13 4.7zm17.1-12l4.4 7.6 10.4-5-2.8-4-12 1.4zm17 5.8l-10.3 5.1 2.7 4.5 13.8-2.2-6.2-7.4zm3.3-8l5.3 6.7 8.7-6.9-3-3-11 3.2zm15.9 3.5l-8.3 6.3 2.2 3.9 11.4-3-5.3-7.2zm11.4-13l2 2.9-5.7 8.5-5.9-7.6 9.6-3.8zm3.9 7.3l3.5 7-7 2.4-.6-3.3 4-6z"
    />
  </svg>
	),
	LT: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt" transform="scale(.64143 .96773)">
      <rect
        width={1063}
        height={708.7}
        fill="#006a44"
        rx={0}
        ry={0}
        transform="scale(.93865 .69686)"
      />
      <rect
        width={1063}
        height={236.2}
        y={475.6}
        fill="#c1272d"
        rx={0}
        ry={0}
        transform="scale(.93865 .69686)"
      />
      <path fill="#fdb913" d="M0 0h997.8v164.6H0z" />
    </g>
  </svg>
	),
	LU: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#00a1de" d="M0 240h640v240H0z" />
    <path fill="#ed2939" d="M0 0h640v240H0z" />
    <path fill="#fff" d="M0 160h640v160H0z" />
  </svg>
	),
	LV: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#981e32" d="M0 0h640v192H0zm0 288h640v192H0z" />
    </g>
  </svg>
	),
	LY: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path d="M166.7-20h666.6v500H166.7z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="matrix(.96 0 0 .96 -160 19.2)">
      <path fill="#239e46" d="M0-20h1000v500H0z" />
      <path d="M0-20h1000v375H0z" />
      <path fill="#e70013" d="M0-20h1000v125H0z" />
      <path
        fill="#fff"
        d="M544.2 185.8a54.3 54.3 0 1 0 0 88.4 62.5 62.5 0 1 1 0-88.4M530.4 230l84.1-27.3-52 71.5v-88.4l52 71.5z"
      />
    </g>
  </svg>
	),
	MA: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#c1272d" d="M640 0H0v480h640z" />
    <path
      fill="none"
      stroke="#006233"
      strokeWidth={11.7}
      d="M320 179.4L284.4 289l93.2-67.6H262.4l93.2 67.6z"
    />
  </svg>
	),
	MC: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#f31830" d="M0 0h640v240H0z" />
      <path fill="#fff" d="M0 240h640v240H0z" />
    </g>
  </svg>
	),
	MD: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#00319c" d="M0 0h213.3v480H0z" />
      <path fill="#ffde00" d="M213.3 0h213.4v480H213.3z" />
      <path fill="#de2110" d="M426.7 0H640v480H426.7z" />
    </g>
    <path
      fill="#ff1900"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.7}
      d="M360.4 320.4l24.2 35c1.4 2 2.7 3.9.7 5.2-2 1.3-1.4 6.4 0 8.4 2.7 3.9 6 4.5 8 3.2l18.4-11.6c2-1.2 2.7-4.5 0-8.4-1.5-2-6-4.5-8-3.2-2.1 1.3-3.5-.7-4.8-2.6l-24.3-35"
    />
    <path
      fill="#a77b3b"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={2.5}
      d="M177.2 696.3c0 24.4-9.6 44.3-21.3 44.3-11.7 0-21.3-19.9-21.3-44.3S144.3 652 156 652s21.3 19.8 21.3 44.3z"
      transform="matrix(.52728 -.42386 .44358 .50386 -32.4 20)"
    />
    <path
      fill="#ff1900"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={0.7}
      d="M262 306.1l-21.5 36.7c-1.2 2-2.4 4-4.5 3-2.1-1.2-6.6 1.7-7.8 3.8-2.4 4-1.5 7.2.7 8.4l19.2 10.2c2 1.1 5.4.2 7.8-3.8 1.1-2.2 1.4-7.3-.7-8.4-2.1-1.1-1-3.2.3-5.2l21.4-36.7"
    />
    <path
      fill="#a77b3b"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.7}
      d="M331.2 280.6h-19.6c-.6.6-6.2 35.6-12.2 49-7.3 16.3-29.2 30.7-29.2 30.7s13.1 4 17 6.6c1-.3 22-4.7 24.4-30.3 2.4 25.6-14.6 37.3-14.6 37.3s24.4 7 24.4 23.3c0-16.3 24.4-23.3 24.4-23.3s-12.2-11.7-14.7-37.3c5 25.6 23.5 30 24.5 30.3 3.9-2.6 17-6.6 17-6.6s-21.9-14.4-29.2-30.7c-6-13.4-11.6-48.4-12.2-49zm-83-116.7l36.6 11.7c12.1 0 24.4-11.7 24.4-23.4.4-26-9.8-35-12.2-35l4.8-4.6-7.3-7s2.5-12.1 26.9-11.7c24.4.5 24.4 11.7 24.4 23.3s-12.2 11.7-12.2 35c0 11.7 12.2 23.4 24.4 23.4l36.6-11.7v116.7H248.1V163.9z"
    />
    <g fill="none" stroke="#000">
      <path
        strokeWidth={0.5}
        d="M302.2 292.2l14.6 15 14.7-15 14.6 15 29.3-15 14.3 15.8 15-15.8 21.6 15.8 22.3-15.8 14.6 15 14.7-15"
        transform="matrix(.16672 0 0 .46773 253.9 31.9)"
      />
      <path
        strokeWidth={0.2}
        d="M432.3 435.8l-7.1 39m10.6-39v39m7.1-39v39m7.1-39l3.5 39m3.6-39l3.5 39"
        transform="matrix(.68905 0 0 .65843 16.2 -144)"
      />
    </g>
    <g stroke="#000" strokeWidth={2.5}>
      <path
        fill="#a77b3b"
        fillRule="evenodd"
        d="M318.9 361.4c35.4 17.7 35.4 53.2 35.4 70.9-1.2 16.1 0 354.3 0 354.3s-2.3-20-17.7-35.4L319 733.5l-17.7-17.7c-13-11.8-17.7-35.5-17.7-53.2v-248s0-17.8 35.4-53.2z"
        transform="matrix(-.68905 0 0 .65843 443.4 -144)"
      />
      <path
        fill="none"
        d="M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7"
        transform="matrix(-.68905 0 0 .65843 443.4 -237.3)"
      />
      <path
        fill="none"
        d="M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7"
        transform="matrix(-.68905 0 0 -.65843 443.4 530.2)"
      />
      <path
        fill="none"
        d="M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7"
        transform="matrix(-.68905 0 0 .65843 443.4 -190.7)"
      />
      <path
        fill="none"
        d="M301.4 557l-.2 158.8"
        transform="matrix(-.68905 0 0 1.24911 443.4 -566.8)"
      />
      <path
        fill="none"
        d="M301.4 539.3l-.2 176.5"
        transform="matrix(-.68905 0 0 1.12111 431.4 -464)"
      />
      <path
        fill="none"
        d="M301.4 539.3l-.2 176.5"
        transform="matrix(-.68905 0 0 1.2559 419.2 -548.3)"
      />
    </g>
    <g stroke="#000" strokeWidth={2.5}>
      <path
        fill="#a77b3b"
        fillRule="evenodd"
        d="M318.9 361.4c35.4 17.7 35.4 53.2 35.4 70.9-1.2 16.1 0 354.3 0 354.3s-2.3-20-17.7-35.4L319 733.5l-17.7-17.7c-13-11.8-17.7-35.5-17.7-53.2v-248s0-17.8 35.4-53.2z"
        transform="matrix(.68905 0 0 .65843 199.3 -144)"
      />
      <path
        fill="none"
        d="M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7"
        transform="matrix(.68905 0 0 .65843 199.3 -237.3)"
      />
      <path
        fill="none"
        d="M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7"
        transform="matrix(.68905 0 0 -.65843 199.3 530.2)"
      />
      <path
        fill="none"
        d="M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7"
        transform="matrix(.68905 0 0 .65843 199.3 -190.7)"
      />
      <path
        fill="none"
        d="M301.4 557l-.2 158.8"
        transform="matrix(.68905 0 0 1.24911 199.3 -566.8)"
      />
      <path
        fill="none"
        d="M301.4 539.3l-.2 176.5"
        transform="matrix(.68905 0 0 1.12111 211.4 -464)"
      />
      <path
        fill="none"
        d="M301.4 539.3l-.2 176.5"
        transform="matrix(.68905 0 0 1.2559 223.6 -548.3)"
      />
    </g>
    <path
      fill="#a77b3b"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={2.5}
      d="M177.2 696.3c0 24.4-9.6 44.3-21.3 44.3-11.7 0-21.3-19.9-21.3-44.3S144.3 652 156 652s21.3 19.8 21.3 44.3z"
      transform="matrix(.63605 .25323 -.26502 .60778 361.1 -165.2)"
    />
    <path fill="red" fillRule="evenodd" d="M248.1 175.6h146.5v70H248.1z" />
    <path
      fill="#564dff"
      fillRule="evenodd"
      d="M248.1 245.6h146.5v35c0 23.3-36.6 23.3-73.2 46.6C284.7 304 248 304 248 280.6v-35z"
    />
    <path
      fill="none"
      stroke="#ff0"
      strokeWidth={2}
      d="M336.6 485.4h212.6V645c0 35.4-53.1 35.4-106.3 70.9-53.1-35.5-106.3-35.5-106.3-71V485.5z"
      transform="matrix(.68905 0 0 .65843 16.2 -144)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={2.5}
      d="M385.6 129.9S335 185.4 335 238.5c0 53.1 53.1 70.9 53.1 70.9s-17.7 0-17.7 70.8c0 35.5 53.1 17.8 53.1 35.5s-.7 60.5 0 88.6c0 17.7-35.4 0-35.4 17.7 0 8.8 26.6 53.1 53.2 53.1s53.1-44.3 53.1-53.1c0-17.7-35.4 0-35.4-17.7v-88.6c0-17.7 53.1 0 53.1-35.5 0-70.8-17.7-70.8-17.7-70.8s53.2-17.7 53.2-70.9-50.7-108.6-50.7-108.6 28.5 73.2 28.5 108.6c0 17.7-13.3 53.2-48.7 53.2 0 0-9-17.8-17.7 0 0 0-10.2-17.8-17.7 0-2.6 6-7.2-17.8-17.8 0-4.4 4.7-8-17.8-17.7 0-17.7 0-53.1-17.8-53.1-53.2s32.9-108.6 32.9-108.6z"
      transform="matrix(.48234 0 0 .30917 108.5 140.1)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={2.5}
      d="M382.7 248c-3.6 3.6 4.6 61.3 7 63.8 3.6 3.5 24.9 3.5 28.4 0 2.5-2.5 0-56.7-3.5-60.2-3.6-3.6-29.4-6-32-3.6z"
      transform="matrix(.48234 0 0 .30917 110.4 201.6)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={2.5}
      d="M382.7 248c-3.6 3.6 4.6 61.3 7 63.8 3.6 3.5 24.9 3.5 28.4 0 2.5-2.5 0-56.7-3.5-60.2-3.6-3.6-29.4-6-32-3.6z"
      transform="matrix(-.48234 0 0 .30917 532.4 201.6)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={2.5}
      d="M414.6 228.5a16 16 0 1 1-32 0 16 16 0 0 1 32 0z"
      transform="matrix(.5544 0 0 .38542 82.7 183.7)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={2.5}
      d="M414.6 228.5a16 16 0 1 1-32 0 16 16 0 0 1 32 0z"
      transform="matrix(.55441 0 0 .38543 118 183.7)"
    />
    <path
      fillRule="evenodd"
      d="M336.8 307.5c0 1.5-2 2.7-4.3 2.7-2.4 0-4.3-1.2-4.3-2.7s2-2.7 4.3-2.7 4.3 1.2 4.3 2.7zm-22.3 0c0 1.5-1.9 2.7-4.2 2.7-2.4 0-4.3-1.2-4.3-2.7s1.9-2.7 4.3-2.7c2.3 0 4.2 1.2 4.2 2.7z"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M439.4 550l-7.8-10.3-12.8 1.7 1.8-12.8-10.3-7.7 10.3-7.8-1.8-12.8 12.8 1.8 7.8-10.3 7.8 10.3 12.7-1.8-1.7 12.8 10.2 7.8-10.2 7.8 1.7 12.7-12.8-1.7z"
      transform="matrix(.67225 0 0 .64237 26 -133.3)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M496 591.7l21.3 10.7 21.3-10.7-21.3-10.6-21.2 10.6z"
      transform="matrix(.68905 0 0 .65843 16.2 -144)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M496 591.7l21.3 10.7 21.3-10.7-21.3-10.6-21.2 10.6z"
      transform="matrix(.68905 0 0 .65843 -88.8 -144)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M535 659c-3.5-7-14.1-10.6-21.2-10.6s-14.2 0-21.3 10.7c0-14.2 10.5-21.3 21.3-21.3a22.7 22.7 0 0 1 21.2 21.3z"
      transform="matrix(.59753 -.3279 .34316 .57097 -165.2 86.5)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z"
      transform="matrix(.68905 0 0 .65843 13.7 -155.7)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z"
      transform="matrix(.68905 0 0 .65843 8.8 -139.4)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z"
      transform="matrix(.68905 0 0 .65843 6.4 -148.7)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z"
      transform="matrix(.68905 0 0 .65843 18.6 -139.4)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z"
      transform="matrix(.68905 0 0 .65843 21 -148.7)"
    />
    <path
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z"
      transform="matrix(.68905 0 0 .65843 13.7 -146.4)"
    />
    <g fillRule="evenodd">
      <path
        fill="#da4500"
        d="M297.8 120.4c-12.4 0-14 2-19.6 3.9 0-5.4 13.8-11.7 26-11.7 0 3.9-3.2 7.8-6.4 7.8z"
      />
      <path
        fill="#cac9c7"
        d="M316.5 108c0 2.5-2.2 4.6-4.9 4.6s-4.9-2.1-4.9-4.7 2.2-4.6 4.9-4.6 4.9 2 4.9 4.6z"
      />
      <path
        fill="#ff0"
        stroke="#000"
        strokeWidth={1.1}
        d="M361.4 357.9v10.6h17.7v53.1h10.7v-53.1h17.7v-10.6h-17.7v-14.2H379v14.2h-17.7z"
        transform="matrix(.68905 0 0 .65843 16.2 -144)"
      />
      <path
        fill="#da4500"
        d="M304.3 112.6a78.5 78.5 0 0 0-29.3 3.9c0-7.2 8.4-15.6 22.8-15.6 3.2 0 6.5 7.8 6.5 11.7z"
      />
    </g>
    <g fillRule="evenodd">
      <path
        fill="#008500"
        stroke="#000"
        strokeWidth={0.7}
        d="M67.3 613c-14.2-14.2-16.6-21.4 3.6-10.1l283.7 247.5-3.4 7L67.4 613z"
        transform="matrix(.38821 .29653 -.14073 .23692 237.4 71.3)"
      />
      <path
        fill="#008f00"
        d="M228.4 330.4c.8-10.6-18.6-22-19.4-21.3-.7.8 1.2 7 4.9 10.1-7-3.6-14.4-5.8-14.6-4.3-.6 2.2 11 7.2 12 9.2 0 1.4-8.6 1.2-8.4 2.6.2 1.4 24.3 13.6 25.5 3.7zM209 299.6c.8-10.6-18.6-22-19.3-21.3-.8.7 1.1 6.9 4.8 10.1-7-3.6-14.4-5.9-14.6-4.3-.5 2.1 11 7.2 12 9.2.1 1.4-8.5 1.2-8.4 2.6.2 1.4 24.3 13.5 25.5 3.7zm-14.8-28c.8-10.6-18.6-22-19.4-21.3-.7.7 1.2 6.9 4.9 10.1-7-3.6-14.4-5.9-14.6-4.3-.5 2.1 11 7.2 12 9.2 0 1.4-8.5 1.2-8.4 2.6.2 1.4 24.3 13.6 25.5 3.7zm-14.6-30.4c.7-10.5-18.6-22-19.4-21.3-.8.8 1.2 7 4.8 10.2-7-3.7-14.4-5.9-14.5-4.3-.6 2.1 11 7.2 11.9 9.1.1 1.4-8.5 1.3-8.3 2.7.1 1.4 24.2 13.5 25.5 3.6z"
      />
      <path
        fill="#008f00"
        d="M184.6 239.9c9.4-5.7 7.5-27.4 6.5-27.6-1.1-.1-5.2 5-5.7 9.8-1.1-7.6-3.6-14.6-5-13.8-2.1.8.4 12.7-.7 14.6-1 1-6-5.8-7-4.8-1.2 1 2.8 26.7 12 21.8zm13.6 26.6c10.8-2.4 16.7-23.4 15.7-23.9s-6.6 3-8.7 7.4c1.6-7.5 1.7-14.9 0-14.6-2.3.1-4 12.1-5.7 13.5-1.3.6-3.7-7.3-5-6.8-1.4.6-6.6 26.1 3.7 24.4zm16.2 27.2c9.9-4.8 10-26.6 9-26.8-1-.3-5.5 4.5-6.5 9.2-.4-7.7-2.2-14.8-3.7-14.1-2.2.6-.8 12.6-2 14.4-1.2.9-5.5-6.3-6.7-5.4-1.2.8.4 26.8 10 22.7zm17.6 35.6c10.3-3.9 12.8-25.5 11.8-25.9-1-.3-6 4-7.5 8.6.4-7.7-.6-15-2.2-14.4-2.3.4-2.1 12.5-3.5 14.2-1.3.7-4.8-6.8-6-6-1.3.6-2.5 26.7 7.4 23.5z"
      />
    </g>
    <path
      fill="#ff1900"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M209 776c0 7.8-10.2 14.2-23 14.2s-23-6.4-23-14.2 10.3-14.2 23-14.2 23 6.4 23 14.2z"
      transform="matrix(.60164 .32097 -.3359 .5749 389.6 -146.8)"
    />
    <g fill="#ff0" fillRule="evenodd" stroke="#000" strokeWidth={0.5}>
      <path
        d="M156 414.6v-7.1h7v-7.1h7v7h7.2v7.2H170v17.7h-7v-17.7h-7zm7 60.2h7v205.5h-7z"
        transform="matrix(.49887 .1571 -.1826 .4713 451.4 -3.7)"
      />
      <path
        d="M159.4 676.8h14.2v56.7h-14.2zM156 439.4h21.3c14.1 0-3.6 39-3.6 39h-14.1s-17.8-39-3.6-39zm17.6-5.4c0 3-3.1 5.4-7 5.4s-7.1-2.4-7.1-5.3 3.1-5.4 7-5.4 7.1 2.4 7.1 5.4z"
        transform="matrix(.49887 .1571 -.1826 .4713 451.4 -3.7)"
      />
    </g>
    <path
      fill="#ff1900"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M209 776c0 7.8-10.2 14.2-23 14.2s-23-6.4-23-14.2 10.3-14.2 23-14.2 23 6.4 23 14.2z"
      transform="matrix(.57449 -.36357 .38048 .54895 -2.3 4.2)"
    />
  </svg>
	),
	ME: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#d3ae3b" d="M0 0h640v480H0z" />
    <path fill="#c40308" d="M24 24h592v432H24z" />
    <path
      fill="#b96b29"
      d="M424.5 236.1a58 58 0 0 0 19.4-9.2c7-5.6 8.3-10.1 8.8-12.5.6-2.4.8-4.3-1-3-1.8 1.4-7.1 5.6-10.7 7.6-3.7 2-7 3-9 3.6-2 .5-3.6.9-1.7.1 2-.7 8.1-2.9 13-7.7 4.7-4.8 8.5-12 8.6-16.4 0-4.4-.3-4-1.7-3-1.4 1.1-6.4 7.3-9.3 9.7a90 90 0 0 1-9.7 6.9c-2.3 1.3-5.5 2.8-1-.3 4.5-3 13-10.3 16.5-19.7a35.4 35.4 0 0 0 2.7-15.8c0-1-.8-2.8-1.6-1.1-.8 1.7-6.5 13-11 18-4.6 4.8-3.5 3.9-4.6 4.7-1 .8-2.7 2.2-.5-.6a51.2 51.2 0 0 0 12.2-31.7c0-3.6-1.5-8.6-2.2-10.1-.7-1.5-1.4-2.6-1.7-.9a191 191 0 0 1-5.8 18.4 75 75 0 0 1-6.7 12.8c-.8 1.1-2.8 3.6-.6-.5a77.4 77.4 0 0 0 7-27.6 44 44 0 0 0-2.6-20.9c-1.6-3.1-3-4.2-3-4.2s.3 7.8-2 19-5.7 17-5.7 17-1.5 1.7-.5-1a62.4 62.4 0 0 0 1.4-34.5c-2.3-7.5-6.2-11.3-6.2-11.3-1 10.7-.9 24.5-4.8 35.7-.7-.7-1.7-1.9-2.1.6a63.1 63.1 0 0 1-7 19.4c-4.8 8.8-6.8 10-6.8 10l-1.5-3.4c-.6-1.2-1-1.8-1.8-.2s-3.5 7.8-9.4 14.6-9.2 10.2-9 15.3c.1 5 2.8 7.7 6.4 10 3.6 2.3 4.2 3.6 3.7 6.4-.6 2.8-3.8 3.7-6.6 3.8-2.7.1-6.2-.1-7.5.6-1.2.7-1.3 2.5-2.6 3.7-1.2 1.3-1.8 2-3 2.2l-1 .1c-.2-13.5 5-19.5 5-19.5l-14.6-17.1a50.8 50.8 0 0 1-2.2 1 4 4 0 0 0-.4-.6 11 11 0 0 1-2.6-7.8c.7 0 2.2.6 3.5.3 1.3-.2.3-1.6 0-2.8-.5-1.3-.9-5.7-.6-7.3l.4-2.3s2.1 2.3 3.4 2.3c1.3 0 1.2-1.3 1.4-2.8.3-2.2 1.3-5 3-6.5 0 0 2.4 1.6 5 1.6s6.2-.7 9-3.5c3-2.7 2.9-3.3 2.9-3.3s5.3 1.8 9.3 2c4 .2 8.3-.4 10.4-4.7 2-4.2-.6-8.2-1-8.8-.6-.7-1.9-1.2-1.9 0s.1 4.4-2.4 6c-2.4 1.6-4.3 1.5-6.6.8a20.5 20.5 0 0 0-13.1-.4 17 17 0 0 1 6.1-4.2c3-.9 4.8.4 5.8 1.6 1 1.2 1.9 3 2.7.3.8-2.8.3-6-1-8a7.6 7.6 0 0 0-7.2-3c-3 .2-4 .7-4 .7s-1.5-4.3-5.3-5a21 21 0 0 0-14 3s-3.1.7-6.4-.2a21 21 0 0 1-5.4-2.8l1.1-3.5 1.9-.6c1-.4.7-.7.9-1.5.1-.8-1.8-2.2-1.8-2.2s-.3-2.5 2.9-4.1l2.8-1.4s1.9.3 2.6-.2c.8-.6.8-1 .8-1s1.4-.4 2-1.2c.4-.9.5-2.1.2-3.1-.4-1-.9-1.2-.4-1.7s1-1.6 1-2.4l.1-1s1.1-.4 1-2c0-1.7-.9-2.3-1.4-2.5l-.9-.1s0-1-.9-2.3c-.8-1.4-1.4-2-1.4-2s.6-.4.3-1.5-1.1-1.7-1.9-2c-.7-.2-1.5 0-1.5 0l-3.7-2.1-1.5-.8s0-1-.4-1.6c-.5-.5-1.5-.8-2-.8s-1 .3-1 .3l-6-1.4c-1.8-.2-1.9-.4-1.9-.4s-3.8-1.8-5.2-2l-2-.5s1.6-1.8 1.7-4a6 6 0 0 0-2.8-5l-1.6-.8V93l2.8.3.2-4.6-2.7.3.4-2.7h-5.8l.4 2.7-2.8-.2.3 4.5 3-.4-.4 1.7s-1 .2-2 .9a5.4 5.4 0 0 0-2.6 4.7c0 2.2 1.3 4 1.3 4l-1.8.4c-1.5.3-5.3 2.1-5.3 2.1s0 .2-1.8.4l-6 1.4s-.6-.3-1-.3-1.6.3-2 .8c-.4.6-.5 1.6-.5 1.6l-1.4.8-3.7 2.1s-.8-.2-1.6 0c-.7.3-1.5 1-1.8 2-.3 1.1.3 1.6.3 1.6s-.6.5-1.5 1.9a6 6 0 0 0-.9 2.3l-.8.1c-.6.2-1.5.8-1.5 2.5 0 1.6 1 2 1 2v1c.1.8.6 2 1.1 2.4.5.5 0 .7-.3 1.7-.4 1-.3 2.2.2 3 .5 1 2 1.4 2 1.4s0 .3.7.9 2.6.2 2.6.2l2.9 1.4c3.2 1.6 2.9 4 2.9 4s-2 1.5-1.8 2.3c.1.8 0 1.1.9 1.5l1.9.6 1 3.5a21 21 0 0 1-5.4 2.8c-3.2.9-6.4.2-6.4.2a21 21 0 0 0-13.9-3c-3.8.7-5.4 5-5.4 5s-1-.4-4-.8c-3-.3-5.8 1-7.1 3-1.4 2.1-1.8 5.3-1 8.1s1.6.9 2.6-.3 2.8-2.5 5.8-1.6c3 1 6 4 6.2 4.2 0 0-.5-.3-3.9-.8-3.7-.5-6.9.4-9.2 1.2-2.3.7-4.2.8-6.7-.8-2.4-1.6-2.4-4.8-2.4-6 0-1.2-1.3-.7-1.8 0-.4.6-3 4.6-1 8.8 2 4.3 6.3 5 10.4 4.7 4-.2 9.3-2 9.3-2s0 .6 2.8 3.3a13 13 0 0 0 9 3.5c2.7 0 5-1.6 5-1.6 1.7 1.5 2.7 4.3 3 6.5.2 1.5.1 2.8 1.4 2.8 1.4 0 3.5-2.3 3.5-2.3l.4 2.3a26 26 0 0 1-.6 7.3c-.4 1.2-1.4 2.6 0 2.8 1.3.3 2.7-.2 3.5-.3 0 3.2-.7 5.3-2.6 7.8a4.4 4.4 0 0 0-.4.6 53.9 53.9 0 0 1-2.2-1l-14.6 17.1s5.3 6 5 19.6a20.6 20.6 0 0 1-1-.2c-1.2-.2-1.8-1-3-2.2-1.3-1.2-1.4-3-2.6-3.7-1.3-.8-4.8-.5-7.5-.6-2.8 0-6-1-6.6-3.8-.5-2.8.1-4 3.7-6.4 3.6-2.3 6.3-5 6.4-10 .2-5.1-3-8.5-9-15.3-5.9-6.8-8.6-13-9.4-14.6-.8-1.6-1.2-1-1.8.2l-1.5 3.3s-2-1.2-6.8-10a63 63 0 0 1-7-19.3c-.4-2.5-1.4-1.3-2-.6-4-11.2-3.8-25-4.9-35.7 0 0-3.9 3.8-6.2 11.3-2 6.8-2 14.9-1.3 22 .6 6.7 2 10.7 2.7 12.5 1 2.7-.5 1-.5 1s-3.4-5.8-5.7-17c-2.3-11.2-2-19-2-19s-1.4 1-3 4.2a44 44 0 0 0-2.6 21 77.4 77.4 0 0 0 7 27.5c2.2 4 .2 1.6-.6.5a71 71 0 0 1-6.7-12.8c-2-5.5-5.6-16.6-5.8-18.4-.3-1.7-1-.6-1.7.9s-2.3 6.5-2.2 10.2a51.2 51.2 0 0 0 12.2 31.6c2.2 2.8.5 1.4-.5.6-1-.8 0 .1-4.5-4.7a91.7 91.7 0 0 1-11-18c-.9-1.7-1.6.1-1.7 1.1-.1 1-.7 6.5 2.7 15.8 3.5 9.4 12 16.7 16.5 19.7 4.5 3.1 1.3 1.6-1 .3a90 90 0 0 1-9.7-6.9c-2.9-2.4-7.9-8.6-9.3-9.7-1.4-1-1.7-1.4-1.7 3 .1 4.4 3.9 11.6 8.7 16.4 4.8 4.8 11 7 12.9 7.7 1.9.8.3.4-1.7-.1a40.2 40.2 0 0 1-9-3.6 93 93 0 0 1-10.7-7.6c-1.8-1.4-1.6.6-1 3 .5 2.4 1.9 6.9 8.8 12.5a57.7 57.7 0 0 0 19.4 9.2c2.9.8.9.8.9.8l-6.8-1.4a71.3 71.3 0 0 1-16.7-7.3c-2.3-1.5-2.7-2-2.4 1a20 20 0 0 0 8.9 12.9 49.6 49.6 0 0 0 17.2 4.8c2.5.1 1.8.4.7.5a50.5 50.5 0 0 1-19.2-3.2l-.5-2c-.2-1.2-.9-1-1.2-.8-.4.3-.7.5-2 1.1-1.3.7-1.3-.1-1.4-.5l-.3-3c0-.8-.5-.9-1.1-.6l-4.7 2c-1 .4 0 1.3.5 2.3a147.3 147.3 0 0 0 1.5 2.6l-3.7 1c-.8.2-.6.8-.3 1.4l1.9 4.6c.3.8 1.1.3 1.1.3l2.7-1.6 1 3.7s-1.3.3-2.7 1.2c-1.3 1-1 2.3.7 2.7 1.6.5 3.6 1.4 5.7 5.3 2.2 3.9 2.7 10.9 4 22 1.4 11 8.4 16.6 9.4 17.3 1 .7.4 1.3.4 1.3s-1 1.4-.5 3.5a5.3 5.3 0 0 0 3.2 3.8c1 .3.7 1.3.7 1.3s-.5 2.3 0 6.7c.5 4.3 4 9.1 5 10 1 .8 1 1.2 1 1.6-.2.3-.9 0-2 1a12.2 12.2 0 0 0-3.4 3.6c-.8 1.6-.5 2.5-.2 4.5.2 2.1 3.3 4 3.3 4s-.6.1-.7 1.7c-.1 1.5 1 3.2 2.4 4.4 1.3 1 4 1.6 4 1.6l.3 2.2c.2 1 1.9 1.9 3 2.5 1.1.6 3.3.3 4.2-.2.9-.4 1.5.1 2 1 .6 1 .4 4.4.4 5.8 0 1.4-.8 2.8-.4 3.5.5.7 1.8.2 3.2-.5 1.3-.8 1.6-.2 2.8.5a9 9 0 0 0 3.5 1.4c.5 0 .3-1.3.3-2.3s.2-3.4.7-3.8c.2-.2 2.3-.3 3.8-1 .7-.3 1.7-.6 1.7-1.3.1-.7-1-.7-3.2-1.9-2.3-1.1-2.7-1.8-4.2-2.8-1.4-1-.7-1.3-.7-1.8 0-.4.7-.9 1-1.4.2-.6 0-1.8 0-1.8l1.8-1.8 2-2.3c.8-.6 2-3.6 2.7-4.5.8-1 2.5-2 3.6-3.4a29.7 29.7 0 0 1 11.3-7.6s-.1 2.6 1 3.9 2.6-1 7.5-4.5c5-3.5 8.6-4.7 8.6-4.7l2.4 3.3c1.3 1.6 2.5-.1 8.5-8.5 4.8-6.5 11-12.6 13.5-14.8l1.3.6-.4 1c-.5 1.8-1.4 3-2.6 5.3-1.1 2.4-3 3-5 6.2s-2.4 5.5-2.6 8.8c-.2 3.3 1.7 4 1.7 4s-3 3-4 5.2c-.9 2.2-1.3 6.7-1.3 6.7s-.5.2-1.6 2.5-3.1 2.6-6 5.5c-3 3-6.2 4.2-7.7 5-1.5 1-1 1.9-.7 3 .4 1.2 2.5 2.4 5 3.3 2.3.9 3.2.5 4.8.5 1.7-.1.4 1.2-.3 1.9s-1.6 3.1-1.5 5.8c.2 2.7 2.2 2 4.7 1.6a28 28 0 0 0 5.3-1.6l-.2.8c-.3.7-.4 1.3-.4 3.4 0 2.1.3 3.2 1 3.7.5.6 1.8-.6 2.7-.9.9-.2 2.4-1.1 4.6-1.6 2.2-.5 3-1.5 3-1.5s-.5.7-.6 2.2c-.2 1.6-.1 3.8.2 5.2a9.4 9.4 0 0 0 2.9 4.2c1.5 1.4 1.8.8 3-1 1-1.7 3.3-3.9 3.3-3.9l1.7 5.5c1.5 4.9 6.5 9 6.5 9s5-4.1 6.5-9l1.6-5.5s2.3 2.2 3.4 4c1.1 1.7 1.5 2.3 3 1a9.4 9.4 0 0 0 2.8-4.3c.3-1.4.4-3.6.3-5.2-.2-1.5-.7-2.2-.7-2.2s.8 1 3 1.5 3.8 1.4 4.7 1.6c.9.3 2.1 1.5 2.7 1 .6-.6 1-1.7 1-3.8 0-2.1-.1-2.7-.4-3.4l-.3-.8s2.9 1.2 5.4 1.6c2.5.5 4.5 1 4.6-1.6a10 10 0 0 0-1.4-5.8c-.7-.7-2-2-.4-2 1.7.1 2.5.5 5-.4 2.3-1 4.4-2.1 4.8-3.3.4-1.1.9-2-.7-3-1.5-.8-4.7-2-7.6-5-3-2.9-5-3.2-6-5.5-1.1-2.3-1.6-2.5-1.6-2.5s-.5-4.5-1.4-6.7c-1-2.2-4-5.2-4-5.2s2-.7 1.7-4c-.2-3.3-.5-5.5-2.5-8.8-2.1-3.2-4-3.8-5-6.2-1.3-2.4-2.2-3.5-2.7-5.2l-.4-1a146 146 0 0 1 1.8-.8c2.4 2.2 8.7 8.2 13.5 14.8 6 8.4 7.2 10.1 8.5 8.4l2.4-3.2s3.7 1.2 8.6 4.7c5 3.5 6.4 5.7 7.5 4.4.6-.6.8-1.7.8-2.6a104 104 0 0 1 11.8 4.2c4.3 1.8 4.7 2.8 8.1 5.4 3.4 2.7 8.2 2.5 12.8 1a304 304 0 0 0 21.6-7.5c4.9-2 8.4-4 9-4.9.4-1 1-3.7 1-4.7s-1-2.4-1.4-2.7c-.4-.2-.2-1-.1-1.6 0-.6-.3-2.5-1-3.3-.8-.8-.7-1.1-.6-3.5.2-5-3.4-11.4-8.4-13.4 0 0-.2-.6-.6-1l-1-.6v-3.5c0-.6.2-.5.6-.4.3.2.9.9 1.7 1.1.8.2 1.3-.4 1.5-1.3.2-1 .8-2.8 1.2-3.7.3-1-.1-1-.5-1.2l-2.2-.4c-.6-.1-.6-.2-.4-.5l1-2c.8-1 .1-1.1-.6-1.4a58.4 58.4 0 0 0-4.9-1.3c-.9-.2-1 .6-1 1v2.6c0 .6-.5.4-.9.3a12.6 12.6 0 0 1-1.7-1.2c-.7-.4-1 0-1.3.7l-1.3 4.3c-.2.9-.1 1.5.2 1.6.3.2 2 0 3 0 .9 0 .3.6.3.6l-1.3 2.3c-.4.7-1 .8-1.8.8h-2s-5.3.2-9.2 3-5 5.3-5.6 6.7c-.6 1.4-1.3 1.1-1.9 1.6-.6.5-2.3 2.3-2.3 3.4s.4 1.7-1.3 2.8c-1.7 1.1-3 5.9-.8 8.3 2.3 2.5 3.2 5 4 6.2.6 1.2 0 1.7-.7 1.7s-1.8-1-2.9-1.8l-8.5-6.5c-2.3-1.7-.6-1.5-.6-1.5s.6 0 1.9-.5c1.3-.6 1.5-1.3.2-1.7a16.7 16.7 0 0 1-4.6-2.6c-.7-.7-1-1.4.3-2.1 1.3-.7 4.2-2.6 2-3.2-2.4-.7-5-1.1-7.3-1.8-2.2-.6-2.4-1.2-2.4-1.2l1.5-2.1s1.1-1.7-.2-1.9c-1.4-.2-4.8-.6-7.8-2a18.8 18.8 0 0 1-11.3-12.5v-.1c1.2 2.2 3.8 6.4 7.8 6.5 5.5.2 6.1-1.5 4.9-3.3-1.3-1.8-2.7-3.4-3-4-.4-.5-.5-1.2 1 .2 1.4 1.3 4 5.9 12.3 5.4 8.2-.6 8.2-2.2 8.2-2.6 0-1.6-1.7-1.9-2.7-2.9-.5-.5-.8-1.2.9-.6s5.7 1.4 11.3.2c2.1-.5 8-3 8.5-6 0 0-3.7-.2-6.3-1.3-2.5-1-4-2-1.3-1.4 2.7.5 8 1.6 12.7 0 2.7-.9 6.2-3 6.2-7.1 0 0-5-1-6.9-1.8-1.9-.6-2.5-1.2-2.5-1.2s7.3 2.3 13.8-1c6.6-3.3 6.9-7.9 6.9-9 0-1-.2-1.3-.2-1.3s-6 1.4-10.4 1.4c-4.5 0-5.9-.4-5.9-.4s12.5-.4 18.8-4.2c6.3-3.9 6.7-11.5 6.7-11.5s-7.1 2.6-11.6 3.1-7.2.5-8.3.4c-1.1 0-1.8-.4.7-.5a49 49 0 0 0 17.2-4.8c5.3-3.1 8.6-9.7 8.9-12.8.3-3.1 0-2.6-2.4-1-2.3 1.4-11 5.9-16.7 7.2l-6.8 1.4s-2.2-.1.7-.9zm-225.2 14.4l-2.5 1.4-1.3-2.7c-.2-.6-.1-.8.2-.8l2.3-.4h.3c.3.7.6 1.6 1.1 2.4h-.1zm76.8 45a20.1 20.1 0 0 1-8.8 7c-3 1.4-6.3 1.8-7.7 2-1.4.2-.2 2-.2 2l1.4 2s-.2.6-2.4 1.3c-2.2.6-5 1-7.2 1.7-2.3.6.6 2.5 2 3.2 1.2.7 1 1.5.2 2.1-.7.7-3.2 2.2-4.6 2.6-1.3.4-1 1.1.2 1.7 1.4.5 5 1.2 5 1.2l-2.3 1.8a18.9 18.9 0 0 1-8.7 3c-2.5.1-6.6.3-11.7 0l-5.8-.3-.5-4.3a21.5 21.5 0 0 0-3-7.8l-3.7-5 .2-1.5c.2-.8 0-1.7-.5-3.3-.6-1.5-3.6-3.8-3.6-3.8l-.2-3.2c0-1.6-1-7.7-2-10.6-1-2.9-5.7-10.5-7.8-14a39.2 39.2 0 0 1-4.3-19.8l.5-1.3a12.9 12.9 0 0 0 3.5 3.2c6.3 3.8 18.8 4.2 18.8 4.2s-1.4.4-5.9.4-10.4-1.4-10.4-1.4-.2.3-.2 1.4c0 1 .3 5.6 6.9 9 6.5 3.2 13.8 1 13.8 1s-.6.5-2.5 1.1c-1.8.7-7 1.8-7 1.8 0 4 3.6 6.2 6.3 7.2 4.7 1.5 10 .4 12.7-.1 2.8-.6 1.2.3-1.3 1.4-2.6 1.1-6.3 1.3-6.3 1.3.6 3 6.4 5.5 8.6 6 5.5 1.2 9.6.4 11.2-.2 1.7-.6 1.4.1.9.6-1 1-2.7 1.3-2.7 2.9 0 .4 0 2 8.2 2.6 8.2.5 11-4 12.4-5.4 1.4-1.4 1.3-.7 1-.1-.4.5-1.8 2.1-3 4-1.3 1.7-.7 3.4 4.8 3.2 4 0 6.6-4.4 7.8-6.6v.1l.3.3a51.7 51.7 0 0 1-2.4 5.3zm66.4-178.2l-1.1-2s3 1.4 5 3.5c1.8 2 1.7 3.2 2 4.2.3 1 0 2.9-.3 4.7-.3 1.7-.3 2.8.1 3.4.3.7.7 1 .7 1l-2.7.8c-1.3.6-3 1-4 .2-.9-.8-1.1-1.3-.5-1.8.6-.5 2.8-1.2 3-5 .3-3.7-1.5-7.6-2.2-9zm-17 10.3c.8-1.8 1-3.5.5-7.2-.4-3.1-1-5.7-1.2-9 0 0 2.3.4 5.6 3.4s4 6.1 4 7.6-.7 3.4-.9 4.8c0 1.5.4 2.8.4 2.8s-1.1.5-2.2 1.3c-1.1.7-1.9 1.2-3.5 1-1.7 0-2.7-.7-3.7-1.2l-1.5-.6s1.9-1.1 2.6-3zm-16-12.8a14 14 0 0 1 5.6-3.5c-.1 3.4-.7 6-1.2 9-.5 3.8-.3 5.5.5 7.3.7 1.8 2.6 2.9 2.6 2.9s-.6 0-1.6.6c-1 .5-2 1.2-3.6 1.3-1.7 0-2.4-.4-3.5-1.1a14 14 0 0 0-2.3-1.3s.5-1.3.4-2.7c-.1-1.5-1-3.3-1-4.8.1-1.6.8-4.6 4.1-7.7zm-11.8 18.3c-1 .8-2.7.4-4-.2l-2.6-.8s.3-.3.6-1c.4-.6.4-1.7.1-3.4-.3-1.8-.5-3.7-.3-4.7.3-1 .3-2.2 2.1-4.2 1.9-2.1 5-3.6 5-3.6l-1.2 2.1c-.7 1.4-2.5 5.3-2.2 9 .3 3.8 2.5 4.5 3 5 .6.5.4 1-.6 1.8zm43.8 31.7c-3.2 1.7-5 1.3-5 2.7.2 1.3 3.1 2.3 3.1 2.3s-3 3.2-5.3 4.6c-2.3 1.5-5 2.4-5 2.4s-1 .2-.4 1.6a5.4 5.4 0 0 0 2.2 2.9l1.1.5s-4 4.3-5.8 5.7a15.3 15.3 0 0 1-4.3 2.5c-1.4.6-.7 3-.4 4 .4 1 1.6 2.5 2.4 2.7.7.2 1 .8 0 2.2-.7 1.1-3 4-4 5.6h-.1l-4.2-5.6c-.9-1.4-.6-2 0-2.2.8-.2 2-1.6 2.4-2.7.3-1 1-3.4-.4-4a15.2 15.2 0 0 1-4.2-2.5 80.2 80.2 0 0 1-5.8-5.7l1-.5a5.4 5.4 0 0 0 2.3-2.9c.5-1.4-.4-1.6-.4-1.6s-2.7-1-5-2.4c-2.4-1.4-5.4-4.6-5.4-4.6s3-1 3-2.3c.2-1.4-1.6-1-4.9-2.7-3.2-1.8-4.3-4.1-4.3-4.1s3.8-1.3 5.7-5a7 7 0 0 0 .7-3.6h.1c6 2 13.1 2.8 19.4 2.8a63 63 0 0 0 19.3-2.8h.2a7 7 0 0 0 .7 3.6c1.9 3.7 5.6 5 5.6 5s-1 2.3-4.3 4z"
    />
    <path
      fill="#d4af3a"
      d="M361.2 237.8c0-10.2 4.7-16.7 4.7-16.7l-12.7-14.6c-12.2 4.7-23.3 5-33.2 0-9.9 5-21 4.7-33.1 0L274 221.1s4.7 6.5 4.7 16.6-2 17.8-3.1 22.7c-1.2 5-2.1 14.1.5 20.7a26.3 26.3 0 0 0 16.7 17c11.3 4.8 17.3 7.3 21.2 10.6 4 3.2 5.9 5.9 5.9 5.9s2-2.7 6-6c3.9-3.2 9.8-5.7 21-10.4a26.4 26.4 0 0 0 16.8-17.1c2.7-6.6 1.7-15.8.5-20.7-1.1-5-3-12.5-3-22.6z"
    />
    <path
      fill="#b96b29"
      d="M357.2 242c-1.6-9.8 4-18.3 4-18.3l-10.9-12.8c-8.4 4.7-20.1 4.1-30.3-.6-10.1 4.7-21.8 5.3-30.2.6l-11 12.8s5.7 8.5 4 18.3c-1.5 9.7-5 25-4.1 31.3.9 6.3 5.3 13.6 9.8 17.4a58 58 0 0 0 16.2 8.7 46.7 46.7 0 0 1 15.3 10s1.5-1.5 3.7-3.2c2.3-1.7 7-5 11.7-6.8a59 59 0 0 0 16.1-8.7c4.6-3.8 9-11.1 9.9-17.4.8-6.3-2.6-21.7-4.2-31.4z"
    />
    <path
      fill="#1d5e91"
      d="M356.1 243.1a32.5 32.5 0 0 1 3.2-19l-9.8-11c-8.4 4.4-18.5 3.3-29.5-.6-11 3.9-21.1 5-29.4.7l-9.9 11s4.7 8.4 3.2 18.9-4 22.4-3.6 29.4l.2 1.4h9s.5-.6 1.5-1 1.3-.7 1.3-.7.2-1.8 1.2-2.2c1.1-.4 1.6-.4 2-.4.5 0 .8-.1 1.3-.6.5-.6 2-1.8 2.6-3.6.6-1.9 1-2.6 1-3.8 0-1.2.4-3 .4-3s-.2-.6-1.1-.3c-1 .3-1-.6-1.2-1.5 0-.9 0-2.7.5-3.6l.7-1.1-.4-1.5s-5.7 1.2-6.7-3.3-1.1-6.5-1.3-7c-.1-.5-.3-.7-1-.7-.8 0-2.4-.4-3.6-2.7-1-2.3-1.2-3.3-.8-4.2.3-.9.9-.5 1-.3.3.3 1.8 2.5 2.4 1.9.6-.6.3-.6-.6-2.3-.8-1.8-.5-2.3-.4-3.2l-.3-2.5c0-.4.5-.8 1-.6.6.3 1 .6 1.3 1 .2.2.3.6.8.4.5-.3.2-1.9.2-2.4 0-.6.6-1 1.3-.5a2.2 2.2 0 0 1 1.2 1.8c0 .6 0 1.1.3 1.1s.6-.9.7-1.4c0-.6.4-1.5.9-.7.5.7.7 1.7.5 2.8-.2 1.1.2.5-.2 2.4-.4 2-.6 2.8-.5 4.2 0 1.5 0 2.3.8 4 .7 1.8 1.3 3.8 2.6 3.9h1.7s1.5-2.8 2.6-3.5c1.2-.6 2.8-.7 4-.9 1-.1 1.5-.5 1.5-.8 0-.2-.3-.3-1.7-.5s-2.5-.5-2.6-1.6c0-1 .3-2-.6-2-1 0-3.2-.8-4-2.2-.8-1.5-.6-1.8-.5-2.7 0-.8 1.1-2.4 1.8-.9.7 1.6 1.1 1.8 1.7 2 .5.4 1.3.5 1-.5-.5-1-.7-1.7-.6-2.5 0-.8.6-1.1 1.2-1.2l3.4-1 1-.2s.1-.7 1.4-1a9 9 0 0 1 3-.5c.8 0 1.5.1 2.7-.4a5.7 5.7 0 0 1 2.9-.7 3.7 3.7 0 0 1 1.9.8c.5.3.4.9.4 1.4 0 .5 0 .8.8.8.9 0 1.6 0 2.3.3.8.3 1.8.7 1.2 1.5-.7.8-.7 1.7-1.2 1.7-.4 0-.4.4-.5.7-.2.3-.4.5.1.8.5.3.5.6 1.2 1.2.6.6 1.6 1.3.6 2.3-1 1-2.7 1.8-2.7 1.8s-1 .5.1 1.1c1.2.7 1.7 2 2.1 2.3l1.2.8c.3.1.2 1 .2 1l-1.5.8c-.8.4-1.7.8-2.5.8s-1.3 0-1 .7c.4.8 1 1.6 1.1 2l.3 1.2s1.4.3 2.6.3l4.3-.2c2.6-.3 3.4-.4 5.9-.1 2.5.2 2.9.2 3.5.4l1.4.6s3.5 0 5.5-.5c2-.4 2.4-1.7 2.1-2.4-.3-.6-.2-1.6-3.6-2-3.5-.6-4.8-.4-7.5-.9-2.8-.5-7-1.9-7.7-5.3-.8-3.4 2-4.8 3.3-5.5l5.8-2.3c1.4-.5 3.9-1 6.5-.7 2.7.4 4.2 1 5.3.5 1-.7 1.9-.2 1.7.8-.2 1-1.3 2.9-4.3 3.8-3 .9-6.6 1-8.5.5-2-.6-3.4-1.3-4.6-.9-1.2.4-2.5 1.9-1.3 3.7 1.3 1.7 7.9 2.3 9.6 2.4 1.8.2 8.3-.2 10.2 3 1.8 3.2.3 6.9-1.8 7.7a29 29 0 0 1-5.7 1.5l-1.7.3s.8 1.7.8 2.4-.1 2 .7 2.6c.8.5 2 .9 3.3.7 1.4-.1 3 .8 3.1 2 .1 1.3.5 3 .6 5.5.2 2.5 0 4.5 0 4.5s0 1-.4 1.9c-.3 1-2 4.4-2 4.4h9.5l.2-1.4c.4-7.1-2-19-3.6-29.5z"
    />
    <path
      fill="#6d8c3e"
      d="M281.6 278.6a27.4 27.4 0 0 0 11.6 14.3c8.2 5 11.8 4.3 19.5 9.3 7.7 5 7.2 5.8 7.3 5.8.1 0-.4-.8 7.3-5.8s11.3-4.4 19.5-9.3a27.4 27.4 0 0 0 11.6-14.3h-76.7z"
    />
    <path
      fill="#d4af3a"
      d="M288.3 237.2c.9 1 1.5 1.2 2.9 1 1.3 0 1.7.9 1.9 2 .2 1 .2 3.5 1.2 5.8s4.2 2.5 4.2 2.5c0-1.1.5-2.6 1-3.9 0-.2.5-1.2-.7-1.2s-1.1-.5-1.8-1.6c-.7-1-2-4-2.4-6a16 16 0 0 1 .6-5.7c.4-1 .4-1.7 0-1.9h-1s.2 1-.1 1c-.3.2-.6-.4-.8-1-.3-.7-.5-.6-1-.6s-.5.5-.1 1c.3.4.1 1.3.1 1.3l-1.4-1c-.5-.2-1.4.2-1.5.8-.1.5.3 2 1.2 2.7s1 2.2.6 3c-.2.6-1.5.5-1.8.2a.8.8 0 0 0-1.2 0c-.4.5-.8.7.1 1.6zm-.5-2.5l-.7-.6a35.1 35.1 0 0 1-.5-.7l-.1.7c0 .5.6 1.2.6 1.2l.7-.6zm2-6.4c.4-.1.7-.2.4-.7-.4-.5-.6-1-1-1-.3-.2-.6-.1-.6-.1l.5 1.3c0 .5.2.7.6.5zm2.4-2c0 .5 0 .7.4.5.4-.2.5-.7.3-1a2 2 0 0 0-.6-.7l-.3-.2s.2 1 .1 1.5zm3.4.6l-.1-1s0 .6-.3 1c-.2.3-.1.2 0 .5.3.2.4 0 .4-.5zm5.4 23.5c.7 1.6 2.4-.9 4-2.9s1.5-.4 1.3 1.2a7.6 7.6 0 0 0 1 4.5c.7 1 1.2.4 1.5-.4.2-.7.5-2.4 1-3.2.5-.7 1 0 1 .6.1.7 1 2.2 1.7 3.1.8 1 1.2-.3 1.5-1.4l.7-3.5c.2-.6 1 0 1 0l1.6 1.5c1 1 1.1-.6 1.2-1.4.1-.8-.1-2.5.2-2.8.3-.3 1.2.4 2.5 1 1.4.7 1.3-.6 1.2-1.3a7.4 7.4 0 0 0-2-3.4c-1.2-1-1.3-2-1-2.5.4-.5 1.7 0 2.6-.1l1.8-.3c.7-.2.7-.8.7-.8s-.5-.8-1.4-1.6c-.9-.8-1.4-1.4-2.5-1.6-1.1-.3-2.6 0-2.6 0l-.2-.4c-.1-.3-.4-.3-.6 0l-1.2 1.1c-.4.4-.7.6-1 .5-.2-.2.3-.6.3-.6s.5-.4 1-1.4c.6-1 .7-2 .3-2.6-.4-.4-1.5 0-2.2 0-.6 0-1 .2-1-.2 0-.3.6-.1 1.4-.2.8-.1 1.3-1 1.5-1.9s.5-.6 1-.2c.4.5.9.4 1 0l1-1.8c.5-.8.8-1.9.3-2.6-.6-.8-2-.7-2.6-.2-.6.5-1 1-1.1 2.1-.2 1.2-.5.5-.5.2 0-.4-.4-1-.2-1.5.2-.4 0-1 0-1s-.1-1-1.2-1.1a8.6 8.6 0 0 0-3.5.3c-1 .2-.9 1.2-.9 1.2l-1.7.1c-.9.1-2 .5-2.8.7-.8.2-1.1.3-1.1.7l.1 1.1s.7 0 1 .3.2.5-.2.7c-.4.2-.6.2-.6.7s.2.7.7.7c.4 0 1.3 0 2.3.4s1.3 1.4 1.2 2c0 .5-1.5 1.2-2.3 1.2s-1 .1-1 .6 1 .4 1 .4l2.6.3c1.7.2 2 .6 2.8 1.2.7.7.2.9-.2 1-.4.3-1 .8-1.5 1-.6.2-1 .6-1.5.7-.5.1-1.8 0-4.2 1-2.4 1-3.3 4.1-3.3 4.1l1.4-.7c1.1-.5 2.5-1.2 3.8-2 1.2-.7 1.2.4.6 1.5s.6.9 1 .6l2-1.3c1.2-.6.8.4.8.4s-.4.7-.5 2.5c-.1 1.7 1.7 0 2.5-1 .9-1.1 1.2 0 .6 1.2-.6 1.3-1.8 2.3-2.5 2.3s-1.2-.8-1.3-1.2c0-.4.3-1.7-.1-2-.5-.3-1.7 0-2.6.6-.9.5-1 .1-1.3-.4-.2-.4.3-.6.1-1-.2-.2-.6 0-1 .2l-2.8 1.5c-1.7.9-1.6 1.3-1.6 2.5s.3 1.5 1 3z"
    />
    <path
      fill="#d4af3a"
      d="M316.7 224.2l1-.5 1.5-.3c.7 0 .6-.5.4-.8-.1-.4-.4-.5-1.4-.5-.9 0-1.5.5-2 .7l-1.1.4.4.6c.4.5.9.6 1.2.4zm3.8 3.7l.8-.2 1.3-.6c.6-.2.8-.3 1.2-1 .4-.8-.4-.8-1.5-1-1-.3-1.6 0-1.7.5-.1.4 0 .8-.5 1.6s0 .7.4.7zm-.3 1c-1 0-2.3 1.5-2.7 1.8-.4.3-.2.6-.2.6l.4 1.2c.2.7.2 1.7.2 1.7h.8c.6 0 1-.2 1.6-.7a4 4 0 0 1 1.8-.7c.9-.2 1.3-.3 2.2-.8 1-.5-.5-1.4-1.5-2.2a3.7 3.7 0 0 0-2.6-1zm-14 3.6c.8-.1 1.2-.5 1.2-1s-.4-1-1.5-.9c-2.6.3-5.1-.7-5.6-3.2 0 0-.8 1.6.8 3.4 1.6 1.8 4.3 1.8 5.1 1.7zm-8.9 41l.5.4h4c.7-.2.7-.8.7-1.2 0-.5.4-2 1-4.7.5-2.6 1.5-4.5 1.9-5.6.4-1-.4-1.4-.7-2l-.8-2.5c-.1-.6-1-.5-1.6-.5-.5 0-.6.9-.7 1.7 0 .8-.4 3.1-.8 5.1-.4 2-2.7 4.7-3.3 5.3-.6.6-1.2.8-1.6.8-.4 0-1.4 0-1.8.3a2.4 2.4 0 0 0-1 1.6c0 .6.9 1 .9 1l1-.8c.3-.4 1-.5 1.5-.6.7-.1.7.1.5.4-.2.3-.1.4.3 1.2zm-6-.2c-.4 0-.6.4-.7.6h2.6a1.4 1.4 0 0 0-.3-.7c-.3-.3-1.1-.1-1.7 0z"
    />
    <path
      fill="#d4af3a"
      d="M294.8 273.2a3 3 0 0 0-1 .7h2.9c0-.2.1-.6-.2-.9-.7-.5-1.3 0-1.7.2zM319 272c-.3 0-.6.3-1 .6-.5.3-.6.8-.7 1.2a.3.3 0 0 0 0 .1h1.3a.2.2 0 0 0 0-.1c0-.4.2-.7.7-1.1.5-.5 0-.7-.3-.7zm2.3 1.3c0-.4-.1-.7-.4-.7-.2 0-.7.5-1 .8a2.4 2.4 0 0 0-.5.5h1.7l.2-.6z"
    />
    <path
      fill="#d4af3a"
      d="M332.3 260.4c.8-.6.7-.8.7-1.5 0-.6 0-.8-.3-1a5.9 5.9 0 0 0-2.8-.8c-1.1 0-3.4.3-4.2.8-.9.6-1.3 2.7-1.3 3.8 0 1 .2 1.2.5 1.2s.8-.8.8-.8l1.8 2.5c.7 1 .4 1.4 0 2.2-.2.8-1.4 2.9-2.2 3.3-1 .5-1.6 0-2.6-.1-1.1-.2-1.7.1-2.3.7s0 1.1.4 1.1c.3 0 .8 0 1.2.5.3.3.1 1.2 0 1.6h5.2c.9-.4 1.5-1.6 1.7-2.3.3-.7 1.4-1.7 2-2.2.5-.5.5-.8.5-2s-.2-1.7-.6-2.5c-.5-.8-.8-2-.6-2.6 0-.7 1.2-1.4 2-2z"
    />
    <path
      fill="#d4af3a"
      d="M323.7 247.4c.6.9.3 1-.4 1.2a8.5 8.5 0 0 1-2.8.2c-1.1-.1-1.1 0-1.1.6a5 5 0 0 1-.8 2.7c-.7 1-1.6.6-2 .2-.6-.3-.9-.2-1 .4l-1.2 2.1c-.5 1-.9 1-1.3.9-.4-.1-.7-.7-1.1-.7-.4 0-1-.8-1.6-1.8-.6-.9-.9.1-1.3 1-.4.8-.7 1.3-1.5 1.2-.7 0-1.6-1.5-2-2.3-.4-.8-.7-1.6-1.3-1.6-.7 0-1.7 1.4-2.4 1.7-.7.4-1 .3-1.3-.2-.3-.4-.7.2-1.1 1.2-.4 1.1 0 2 .6 2.3.6.3 1.7-.5 2.5-1 .8-.6 1.1-.5 2-.5.8 0 .7 1.4 1 3.3.4 2 1.5 2.2 1.5 2.2s.4.3 1.3-1.1c.9-1.5 1-3 1.8-3 .9 0 1 .2 1.8 1.4.8 1.1 1.5 2 2 1.1.5-.8.9-2.1 1.5-2.6.5-.4 1-.6.4.3-.5.8-.8 1.7.4 1.4 1.2-.4 5.7-2.2 7.6-2.6l4.7-.5 4-.3c1 0 1 0 1.1-.7 0-.7-.5-.5-2.3-.5-1.8 0-3 .2-4.3.4-1.3.2-1.8.2-1.6-.2.2-.3.6-.5 2-.7a58 58 0 0 1 6-.5c1.6 0 1 .5 1 1.5-.2 1 0 2.6.2 3.5 0 1 .1 1.3 1 2.7s3.7 2.2 4.5 2.6c.9.5.7 0 .7-.8s.7-.8 1.4-.3c.7.4 2 .7 2.9 1 .8.2 1 .4 1 .8 0 .5 0 1.5.2 2.4 0 1 0 1.2-.4 1.8l-2 2.3s-.8 0-2.3.4c-1.6.3-2.1 1.1-2.3 1.7-.1.7.3.9.4 1.1v.8h.4c0-.2.3-.5.5-.8.6-.7 2-.9 2.9-.5.6.3.6 1 .5 1.3h3.6l2-3.9a6 6 0 0 0 .6-2.6c0-1.2.2-5.8 0-6-.3-.3 0-1.1 0-2.4-.1-1.3 0-2.3-2.4-2.5-2.4-.2-3.2-1.2-4-2-.8-.8-.6-2.7-1.2-5-.7-2.2-2.3-2.6-5-3.1a23.3 23.3 0 0 0-7-.5c-2.2.2-4.8.5-6.2.4-1.5-.2-1.2.2-.7 1z"
    />
    <path
      fill="#d4af3a"
      d="M337.3 273.4l-.5.5h2.4a1 1 0 0 0-.2-.7c-.4-.4-1-.2-1.7.2zm4.4-.2a2.2 2.2 0 0 0-.8.7h2.5a1 1 0 0 0 0-.3c-.1-.4-.9-.8-1.7-.4zm-61 1.6a24.1 24.1 0 0 0 .5 2.3h77.6l.6-2.3h-78.8zm52.3-37.1c2.4 1.6 10.2 1.7 13.9 2.4 3.6.8 3.4 3.6 2.3 5-1.2 1.5-6.3 1.7-7.2 1.8.5.3 1.2 1.4 1.2 1.4l2.1-.2a11 11 0 0 0 6.1-2c1.9-1.6 1.8-4 .1-5.8-1.6-1.6-4.3-1.8-7-2.1-2.8-.3-5-.5-8-1-3.2-.6-4.7-1.8-4.7-3.6s1.7-2.8 2.9-3.1c1.2-.4 3.1-.9 4.9-.2 1.7.6 3.7.7 7.1.3 3.4-.5 4.2-2.8 4.2-2.8s-.4.2-2.2.2c-1.7 0-3-.7-6-.7-3.2 0-4.3 1-5.8 1.6-1.5.5-5.4.9-6.5 3.4-1.2 2.5.1 3.7 2.6 5.4z"
    />
    <ellipse cx={312.6} cy={226} fill="#b96b29" rx={1.5} ry={1.4} />
    <path
      fill="#b96b29"
      d="M344 228.4c-2-.2-4.5.4-4.5.4s.5.4 1.2.3c.6 0 1.8 0 3.7.3 1.9.3 3.2-.6 3.2-.6l-3.6-.4z"
    />
    <path
      fill="#1d5e91"
      d="M325.6 264.6c-.5-.8-.6-.7-1.2-.2-.5.4-1-1.2-1.1-2.2l.4-4.1s-2.6.5-4 1l-4 .9c-1.1.2-1.8.5-2.4.4-.6-.2-1.9-.2-2.9-.2s-1 .2-2 1.2-1.3 1.5-2 3.4a20 20 0 0 0-1.4 6 15.6 15.6 0 0 1-.7 3.1h12.2l.5-1.2a3 3 0 0 1 1.4-1.4c.5-.2 1-.2 1.2-.8.2-.5.8-1 1.4-1.2.7-.3 1.8-.2 2.8.1 1 .3 1.4-.4 1.7-.8.3-.4.4-1 1-1.6.5-.7 0-1.3 0-1.3l-1-1.1zm19.5.3c-.1-.7 0-.8-.5-.9-.4 0-1.1-.2-1.7-.5-.6-.2-.5 1.4-.5 1.4s-1.5.2-3.1 0-3.5-1.7-4.2-2.2a5.5 5.5 0 0 1-1.4-1.5l-1 .7c-.5.3-.8 1.3-1 2.4 0 1 1.3 2.2 1.4 3.2 0 1-1.2 3.1-1.8 4a9 9 0 0 0-1.2 2.4h5.9a3 3 0 0 1 .6-1c.6-.6 1.6-.7 1.6-.7l.2-.8c.2-.5.9-1.2 2.3-1.8 1.5-.5 3.3-.6 3.3-.6s.7-.6 1.2-1.4c.5-.8 0-2 0-2.7z"
    />
    <path
      fill="#d4af3a"
      d="M296.2 329.6c1.1.4 3.2-.4 4.2-1.6 1-1.3 1.4-3.2 2.1-4.3l1.3-1.9s-.2 1.8-1.2 4.3a15.5 15.5 0 0 0-.8 6.8c.4 2.7 2.2 3.1 3.2 2.7.8-.2 2-1.4 3-3.2l1-2c.6-1.3 1.2-3.5 1.5-3.4.7.1.3 1.6 0 2.6-.5 2-1.5 5-1.6 7 0 1.7.2 5 2 5.2 1.8.1 2.8-1.5 3.8-5.2s1.2-5 1.7-5c.4 0 .4 2.6.4 3.7a18.2 18.2 0 0 0 1.6 7.4c.9.8 1.6.7 1.6.7s.7.1 1.6-.7c.9-.8 1.6-6.3 1.6-7.4 0-1 0-3.6.5-3.6s.6 1.2 1.6 4.9 2 5.3 3.8 5.2c1.9-.2 2-3.5 2-5.3 0-1.8-1.1-4.8-1.6-6.9-.5-2 .2-1.9 1.6.8l1.3 2.5c1 1.6 2 2.5 2.6 2.7 1 .4 2.8 0 3.2-2.7.5-2.7-1.6-10.5-1.6-10.5l1 1.3c.7 1.1 1 3 2 4.3 1 1.2 3.1 2 4.2 1.7 1-.4 1.2-2.4.4-6.1s-4-5.7-6.4-8.6a31.6 31.6 0 0 1-4-8.2 27 27 0 0 0-7.9 5.6l-5.9 6.3s-1-1.3-5.8-6.3a27 27 0 0 0-8-5.6c-.2.6-2.2 5.2-4.4 7.9-1 1.3-2.5 2.3-3.6 3.6a12.4 12.4 0 0 0-2.4 5.3c-.8 3.6-.6 5.7.5 6z"
    />
    <path
      fill="#d4af3a"
      d="M296 342c1.5-1.2 2.2-2 2.2-2s1-.8.8.9c-.3 1.6-.8 5-.5 6.4.4 1.4.5 2.7 2.3 1.6 1.8-1 2.3-1.7 3.1-2.6.9-.9 1.8-1.3 1.6.1-.3 1.4-.9 3.6-.6 6.4.3 3 1.7 3.3 3.6.9a32.3 32.3 0 0 0 3.5-5.9c.5-1.2 1.6-2.2 1.6 0 0 4.8 1.1 11.8 6.4 13.6 5.3-1.8 6.4-8.8 6.4-13.6 0-2.2 1.1-1.2 1.7 0a32.4 32.4 0 0 0 3.5 5.9c1.8 2.4 3.2 2 3.5-.9.3-2.8-.3-5-.5-6.4-.2-1.4.6-1 1.5-.1s1.3 1.5 3 2.6c1.9 1 2-.2 2.4-1.6.3-1.5-.2-4.8-.5-6.4-.2-1.7.8-.8.8-.8l2.1 2a6 6 0 0 0 3.4 1.2s.9-5-1.2-8c-2-3-2.9-4-2.9-4s-1.1 0-2-.4c-1-.3-1.8-1-1.8-1v2.8l3.1 3.1c.6.8 1.8 2 0 .8a50.5 50.5 0 0 1-3.1-2.4s-.4 2.5-1.1 3.2c-.7.6-1.8.7-2.2.5l-.4-.1-.2 1s1.6 3 1.8 4.1c.3 1.2 0 1-.8-.5-.7-1.5-2.2-3.5-2.8-4.5-.6-1.1-1.6-1.8-1.5-.5.1 1.4-.5 3.9-1 4.8-.4.9-.7 1.2-.7 1.2l1.1 4c.1.7 0 1.5-.5.6-.6-.8-2.1-4.2-2.1-4.2s-2.1 0-2.7-.7c-.6-.6-1.6-2.9-1.6-2.9s-.8 3-1.5 4c-.7.9-2.4 1.8-2.4 1.8l-.2 6c-.2 1-.2 1.3-.6 1.3s-.4-.4-.5-1.3l-.3-6s-1.6-1-2.3-1.9c-.7-1-1.6-3.9-1.6-3.9s-1 2.3-1.5 3c-.6.5-2.7.6-2.7.6s-1.6 3.4-2.2 4.2c-.5.9-.6.1-.5-.5l1.1-4.1s-.3-.3-.7-1.2c-.5-1-1-3.4-1-4.8.1-1.3-.8-.6-1.5.5s-2 3-2.8 4.5-1 1.7-.8.5c.2-1.2 1.8-4.1 1.8-4.1l-.1-1-.5.1c-.4.2-1.4.1-2.2-.5-.7-.6-1-3.2-1-3.2l-3.2 2.4c-1.8 1.2-.6 0 0-.8l3.2-3.1v-2.8s-1 .7-1.8 1c-1 .4-2.1.4-2.1.4l-2.9 4c-2 3-1.2 8-1.2 8s2 0 3.4-1.3zm25.8 33.5L320 373s-.4.8-1.8 2.4a43 43 0 0 1-4.5 4s.3 4.2 1.8 6.5c1.3 1.9 2.5 3.6 4.5 5 2-1.4 3.3-3.1 4.5-5 1.6-2.3 1.9-6.5 1.9-6.5s-3.2-2.4-4.6-4z"
    />
    <path
      fill="#b96b29"
      d="M319.4 380.6c0 1 0 3.4.6 3.4s.5-2.4.6-3.4l.2-3.3h-1.6s0 2.3.2 3.3z"
    />
    <path
      fill="#d4af3a"
      d="M320 151.3c-5.7.1-12.3-.7-16-2l-3.8.8a52 52 0 0 0 19.8 3.3c8.8-.1 13.8-1 19.8-3.3l-4-.8a50.7 50.7 0 0 1-15.8 2zm20.5-4.7c-.4-.4-3-2.2-3.7-2.5-.6-.4-.1-1.3 0-1.6.1-.4 3-1.2 4.6-1.7 1.6-.4 1.4-.7 1.4-.7s-1-1.1-6.8-1.7c-5.8-.7-16-.5-16-.5s-10.2-.2-16 .5c-5.8.6-6.8 1.7-6.8 1.7s-.2.3 1.4.7a19 19 0 0 1 4.6 1.6c.1.4.6 1.3 0 1.6a45 45 0 0 0-3.7 2.6c-.5.4-.5 1 .2 1s.7 0 2.7-.4a94.4 94.4 0 0 1 35.2 0c2 .4 2 .4 2.7.4.7 0 .7-.6.2-1z"
    />
    <path
      fill="#d4af3a"
      d="M333.9 149c-4-.4-6.5-1-13.9-.9-7.4.1-10 .5-13.9 1 2.5 1 6.6 1.5 13.9 1.5s11.4-.5 13.9-1.5zm-15-57.5l-.1 2.8 3-.2-.3-2.7 3.3.5.1-2.6-3.4.3.6-2.9h-3.8l.7 2.9-3.3-.3v2.6zm6.5 7.1h-4v-3.4a6 6 0 0 0-1.3-.2l-1 .1v3.5h-4.3a4.6 4.6 0 0 0-.2 2h11v-.6a5.4 5.4 0 0 0-.2-1.4z"
    />
    <path
      fill="#1d5e91"
      d="M320.1 105a5.5 5.5 0 0 0 5.2-3.4H315a5.5 5.5 0 0 0 5.2 3.5zm2.3-9.5v2.4h2.7a5.3 5.3 0 0 0-2.7-2.4zm-4.5 0a5.3 5.3 0 0 0-2.8 2.4h2.8v-2.4z"
    />
    <path
      fill="#b96b29"
      d="M323.3 140l-3.3-1.5-3.3 1.7c-1.2.5-1 .4-1.4 1.2-.3.9 0 1.2.6 1.4l4.1 2 4.6-2c.8-.4.7-.8.4-1.5-.2-.6-.7-.8-1.7-1.3z"
    />
    <path
      fill="#d4af3a"
      d="M320 139.3l-3.5 1.7 3.6 1.9 3.5-1.9zm0-12.3s-.3 1.2-.7 1.8c-.4.5-.7 1-.6 1.7 0 .6.8 1 1.3 1 .4 0 1.2-.4 1.3-1 0-.7-.2-1.2-.6-1.7-.4-.6-.7-1.8-.7-1.8z"
    />
    <circle cx={320} cy={132.8} r={0.7} fill="#d4af3a" />
    <path
      fill="#d4af3a"
      d="M317.6 129.4s1.1-1.3 1.6-2.2l.8-1.5.8 1.5c.4.9 1.6 2.2 1.6 2.2s1.6-1 2.6-4c1-3.2-.3-6.6-.7-10.1a208 208 0 0 1-.8-9.8 7.3 7.3 0 0 1-3.5 1 7.3 7.3 0 0 1-3.6-1s-.3 6.2-.8 9.8c-.4 3.6-1.6 6.9-.6 10 1 3.2 2.6 4 2.6 4z"
    />
    <ellipse cx={320} cy={122.3} fill="#b96b29" rx={2.8} ry={2.7} />
    <ellipse cx={320} cy={115.8} fill="#b96b29" rx={2.7} ry={2.6} />
    <ellipse cx={320} cy={109.7} fill="#b96b29" rx={2.6} ry={2.5} />
    <ellipse cx={320} cy={121.8} fill="#d4af3a" rx={1.5} ry={1.4} />
    <ellipse cx={320} cy={115.4} fill="#d4af3a" rx={1.4} ry={1.4} />
    <ellipse cx={320} cy={109.2} fill="#d4af3a" rx={1.3} ry={1.2} />
    <path
      fill="#b96b29"
      d="M319.9 336c.2.1.2-.3.2-1.2l.4-4c.2-1.2-.3-1.1-.6-1-.3 0-.5.9-.5 1.4l.1 4.2c0 .6.2.6.4.7z"
    />
    <path
      fill="#d4af3a"
      d="M290.4 359.1l5.2-3.6a11.8 11.8 0 0 0 4-4h-1c-.6 0-1-.7-1.1-1.5 0-.8 0-2.3.2-4.1.2-1.8-.3-3.3-.3-3.3s-1.2 1.1-3 2c-2 1-2.7.6-2.7.6l-.4-1.9-2 3.7c-1.1 2-4.2 4.2-6.4 5.8a28.6 28.6 0 0 1-6.4 4c-1.8.7-.7 1.5-.7 1.5s1.8 1.8 6.5 2.7c4.6.8 6.9-1 8.1-1.9z"
    />
    <path
      fill="#d4af3a"
      d="M306.8 357.3c-1.7-.2-2.7-.8-3-2.6-.2-1.2 0-5.7 0-5.7l-1.1 1.2c-.7.8-2 1-2 1l-1 1.6a9.3 9.3 0 0 1-3 3.2 50.7 50.7 0 0 0-4.6 3.2 28.1 28.1 0 0 1-4.3 3.1 7 7 0 0 0-3.6 4.7c-.5 2.4 0 3.1 1.8 3 1.8-.1 2 0 5-.7 3-.8 7.3-4.1 10.4-6 3-2 5.4-6 5.4-6z"
    />
    <path
      fill="#d4af3a"
      d="M315 360s-1.2-1.6-1.7-3.4l-1.3-5.4-1.5 3.3c-1 2.1-2.7 2.7-2.7 2.7s0 .9-1.5 2.7a21 21 0 0 1-5.7 4.8c-2.1 1.2-5 3-6.4 5.1-1.5 2.2-1.7 4.4-1 5.4.8 1 1.8-.1 3.2-.9 1.4-.7 5.5-1.3 11.2-4.4 5.6-3 7.4-9.9 7.4-9.9z"
    />
    <path
      fill="#d4af3a"
      d="M317.5 372.7c1.5-2.4 1.8-8 1.8-8l-1.3-1c-.8-.7-2.2-2.9-2.2-2.9l-2 3.8c-1 1.8-1.5 2.4-3.6 4.3-2.1 2-5 3.9-6.2 6-1.2 2-.5 6.1.3 7.5.8 1.5 2 1 3-.1l3.7-3.3c2.1-1.8 5-4 6.5-6.3z"
    />
    <path
      fill="#b96b29"
      d="M299 325.3c.8-1.7 1.7-3.7 2.5-4.8a15 15 0 0 0 1.3-2.2s-2 1.8-2.8 3.1c-.8 1.4-1.3 2.6-1.7 4-.3 1.4-.2 1.6.7 0zm8 1.5l.5-1.9s.3-1 .1-1.1c-.2-.1-1 .6-1.6 2.5-.5 1.8-1.4 4.5-1.2 4.6.2 0 1.8-3 2.2-4.1zm6.3 5l.3-.8s.7-2 .7-2.5c0-.4-.2-1-.8.1s-.6 2.2-.7 2.6c0 .5-.7 2.1-.5 2.3.2.1.6-.9 1-1.7zM293.7 351l-.8-.5-1.3 1.5c-.7.7-1.5 1-2 1.7a8 8 0 0 1-2.7 2.3c-1.3.7-1.8 1-1.6 1.1.3.2 1.2-.3 1.2-.3s.3 0 1.9-1c1.6-.9 2-1.4 3-2.3 1-.9 2.3-2.5 2.3-2.5zm6.8 8.1c.6-.6 1.3-1 1-1.4-.4-.3-.8-.3-1.4.2l-2.8 2.6-2 1.5c-.7.6-2.3 1.4-3 1.8-.8.5-.1.5-.1.5l1.2-.5 2.5-1s.7-.3 1.6-1c1-.7 2.4-2 3-2.7zm7.9 5.5c.5-1 0-.8-.9-.4-.8.3-2.7 2.4-3.8 3.1-1.1.8-2 1.1-3 1.6-.9.4-.9.7-.8.9 0 .2.4.2.8 0l1.6-.9 1-.2c.6 0 1.3-.6 2.4-1.6 1.2-1 2.2-1.5 2.7-2.5zm3.7 7.2c-1.4.8-3.8 2.7-4.5 4-.6 1.2-1 2.1-.8 2.3.2.2.9-.2 1.2-.7l.9-1.2s2.4-2.4 3.3-3a8.3 8.3 0 0 0 2.6-3c.4-1 .1-1.4.1-1.4s-1.5 2.1-2.8 3z"
    />
    <path
      fill="#c52126"
      d="M275 170a22.3 22.3 0 0 0-8.3-2.6c-3.7-.3-6.5.2-9.5 1-2.2.6-4 .7-5.7.3-2.6-.7-4.6-3-5.3-6 0 0-2.4 3.1 0 6.5a7.2 7.2 0 0 0 4.4 2.9c5 1 10-2 14.3-2.4 4-.2 7.3 2.4 7.3 2.4s1 .8 2.3 0c1.4-.8 1.8-1.4.5-2.2z"
    />
    <path
      fill="#d4af3a"
      d="M260.3 317.5l-1.2-.2c-.7 0-2.2-.6-2.7-.8-.4-.2-1.1-.2-1.6.3-.4.5-4 2.7-4 2.7h6c2 0 3.5-2 3.5-2z"
    />
    <path
      fill="#d4af3a"
      d="M277.4 316.4v-.5l-.8-1.8s-1 .6-1.9 1.5c-1.2 1.3-2.4 3-3 3.7-1 1.3-2.4 2.5-1.2.5s1.6-3 2.6-4.4c1-1.3 1.7-2 1.5-2l-3.4-.5c-2.5-.3-4.1-1.3-5.3-2l-3.3-1.9s-4.3 1.9-5.9 2.3c-1.6.4-2.6.6-1 1.4 1.6.8 2.9 1 3.7 1.5a11 11 0 0 0 4.6 1.2c1.4 0 3.9 0 3 1-1 1.1-2.1 3-3.2 6a20.3 20.3 0 0 0-1 7v2.5s1.8-2 6.6-5 6.6-4 7.5-4.4c.9-.4 1.3-.4 1.1-1.5l-.6-4.6z"
    />
    <path
      fill="#d4af3a"
      d="M295.6 302a68.5 68.5 0 0 1-.9-.4 1 1 0 0 0-.2 0 15 15 0 0 0-4.6 4.2c-1.2 1.9-2.4 2-1.1 0a17.9 17.9 0 0 1 3.2-4.2 23.5 23.5 0 0 1 1-.8 53.3 53.3 0 0 1-7.3-4.2l-1.6 2.5c-1 1-3.3 2-3.3 2s1.8-2 2.4-3.3l.8-2.5a31.6 31.6 0 0 1-4.8-4.6 17.8 17.8 0 0 1-4.1 7.4c-3.8 4.2-11.3 6.3-11.3 6.3s-2.6.3-.5.9c2.2.5 3.7 1.5 7.8.8l5-1.1c.6-.2 2 0 0 .7-2 .8-6.9 1.5-8.7 1.4-1.9-.2-4.4-.6-1.8.8 2.7 1.4 3.8 2 5.4 2s2.3.5 3.9.5 2-.3 3-.5c1.2-.3 2 .1 2 .6 0 .4-1.6 1.7-1.5 4.7 0 3.1.3 5.1.5 6 .3 1 1 2.4 1.4 3.2.5.8.7 1.7 1.1-.1.5-1.8 1.5-4.4 1.9-6.1.3-1.7.6-1.8.7-2.7.2-.9 1.2-1.6.7 0a133.4 133.4 0 0 0-1.3 5.2c-.3 1.5-1.1 4.2.2 2 1.4-2 6.4-7.7 7.3-8.8l2-2.8c.7-.8 2.4-1.9 3.3-3.1a28.5 28.5 0 0 1 3.9-4l-4.5-2zm-69.5-129.2c0 3.1 3.5 9 5.5 12.2 1.9 3.1 2.4 4.4 2 4.6-.2.2-1-1.4-2.1-2.8s-3.2-4.7-5-7.2c-1.6-2.5-4.2-8.4-4.5-8.9-.4-.5-.5-.9-1.4-.2-.8.7-2.5 7.2-.5 11.6 2 4.4 5 7.6 6.3 9.2 1.3 1.5 3 4 2.7 4.1-.3.2-.8-.4-2.3-2L221 187a51.6 51.6 0 0 1-3.8-6c-.2-.5-.6-.4-.8-.2-.5.6-1.4 1.9-1 5.4a17 17 0 0 0 5.3 10.2c2.3 2.4 4.6 4.5 4.2 4.9-.3.3-2.7-1.8-4.3-3.3-1.6-1.6-5.5-5.4-6.4-6.5-.9-1-2.1-.5-2 3.7 0 4.3 4.7 8.5 6.6 10.9 2 2.3 4.4 3.7 4.2 4.2-.2.5-2.2-.7-3.4-1.6l-7-4.6c-1-.7-1.4.6-.2 4.6 1.2 4 4.7 7.2 6.8 8.7 2 1.5 5.4 3.3 5.2 3.8-.2.4-1.6-.2-3.6-1.1a39.4 39.4 0 0 0-6-2.3c-1.6-.5-1.6.7-1.6.7s-.3 3.5 2.2 6.2a13.3 13.3 0 0 0 8 4.3c2.6.5 3 .6 3 1-.1.4-.4.5-1 .5l-5.4.2c-2.2 0-3.4.6-3.4 1.6s-.1 2.3 3.3 4.6 7.2 2.6 8.8 3c1.6.3 1.7.4 1.4.9-.4.5-1.1.4-3.6.7-2.6.2-4.1 1.2-4.5 2-.3.6.2 2.6 2.3 4 2 1.4 4.8 1.9 8.8 1.6 4-.3 5-.3 5.1.3.2.7-1.2 1-3.2 1.2-2 .4-3.5.4-4.7 1.3-1.1 1-.2 2.9 1.7 4.3 2 1.4 6.8 1.4 8.8 1.3 2-.2 5-.9 5.3-.4.2.6-1.5 1.4-3.6 2.1-2 .8-2.7 1.2-3 2.1-.5.9-.1 1.7 2.3 2.6 2.5 1 6.1 1 8 0 1.9-.8 2.9-1.1 3.2-.8.4.3 0 .7-.4 1.1-.4.5-2 1.8-4 2.3-2.1.6-2.3.6-3 2.2-.8 1.7 1 3 4.8 3.2 3.8.1 8.8-1.4 10.4-2.3 1.6-1 2.2-1.1 2.5-.8.2.3.2.5-.6 1.1-.8.6-3.4 2.5-4.7 2.8-1.2.3-1.4 1.3-1.4 2.1 0 1-.3 2.6 3 3.5 3.4.8 7.3.2 11-2.4a8.3 8.3 0 0 0 2.2-2 28 28 0 0 1 .2-8c-.7 0-2-.3-3.4-.9-2-.8-2.8-2.6-3.3-3.6-.4-1-1.1-1-2-.8-.7.3-1.5.6-2.6.6a7.9 7.9 0 0 1-5.3-2.8c-1.8-2-1.4-4-1.5-5 0-1-1.7-.3-2.5-.3s-3.1-.4-5.3-1.9c-2.1-1.4-2.1-3.4-2.3-4.3-.2-.8-1-1.3-1.7-1.6-.7-.2-1.8-.5-3.3-1.7a6.9 6.9 0 0 1-2-4.4c-.1-.8-1-.8-4-2.4-3-1.5-2.7-4.7-2.6-6 .1-1.3 1.5-2.3 1.5-2.8s-1-.6-2-1.2-3.5-1.6-3.6-5.4c0-3.7 2.4-4.1 2.4-4.1l-1.4-.8c-1-.6-3.8-2.5-3.8-4.7s1-3.2 1.8-3.8 2.7-1 2.7-1-1.3-.9-1.8-2.6c-.5-1.7-.7-3.9.5-5.4 1.3-1.6 3.4-1.6 4.6-1.6 1.1 0 2.1.6 2.5.3.4-.3.5-.6 0-1.5a6.6 6.6 0 0 1 0-3.7c.3-.8.4-2.2 3.2-3.2 2.9-.9 6 1 6.9 1.6.9.5.5-.8.5-1.7 0-1-2-3.3-4.2-6.6a73 73 0 0 1-5.6-10.2 65.7 65.7 0 0 1-4.5-13.4c-.3-1.6-1-.8-1-.8s-.6.2-2.2 4.1a25 25 0 0 0-1.6 10.5z"
    />
    <path
      fill="#d4af3a"
      d="M276.5 241.4c-1.7-.1-4-1-5.7-3.6-1.7-2.5-4.3-3-8.8-3-4.4.1-6.5-2-7.6-5.2-1.1-3 .1-6.6 4.7-8.9 4.6-2.2 6.7-4.7 6.8-8.6.2-3.9-4.5-8.7-9.3-14.1-4.7-5.5-8.4-13.2-8.4-13.2s-1.4 1.8-1.4 3.7c0 1.8.7 3.7 0 4.2s-1-.8-3.7-2c-2.8-1.2-5-1.4-6.7.6-1.8 2 0 5.4 1.5 7 1.6 1.7 2.9 3 2.4 3.5-.4.6-2.7-.9-3.5-1.4-.8-.5-2.6-2.5-5.3-2.3-2.6.3-3.6 1-3.8 3.3-.3 2.3 2.4 4.2 4.1 5.1 1.7.9 2.4 1.6 2 2-.5.3-.9 0-1.7-.3a8 8 0 0 0-4.3 0c-1.4.6-3.6 2.5-1.5 4.8s6.4 3.2 7.2 3.3c.9.2 1.3 0 1.4.6 0 .7-1.8.7-4.1.8-2.4.1-3 2.4-2.7 4 .3 1.8 4.2 3.7 6.4 4 2.1.4 2.9 0 3 .7.2.6-.2.8-1.4 1.2-1.2.3-3.5.6-4 2.5-.4 1.9-.5 2.7 1.3 4.4 1.8 1.6 4.8 1.4 5.6 1.2.9-.2 2-1.1 2.8-.3.9.9-.8 1.6-2.3 2.6-1.4 1-1.3 3 1.2 4.4 2.5 1.4 5 .9 6 .5 1-.3 2.4-2 3.1-1 .7 1.1-2.2 1.5-3.4 3-1.2 1.4-.7 3.8 1.7 5.3s6.4.4 7-.2c.7-.6 1.6-.8 2.1-.3s-.2 1.9-.8 3c-.5 1.3-1.4 4.8 2.2 6.2s6.9-1.7 7.5-2.3c.6-.6 1.2-.7 1.7-.5.5.3.3.8-.1 1.4-.5.6-1.4 3.2 1.2 5a6.3 6.3 0 0 0 4.7 1l2-7.2h-.6c-.3 0-.4.5-.4.7 0 .2 0 .4-.2.4-.3 0-.4.2-.8.5-.5.3-.9.7-1.1.5-.3-.2 1-.8 1.2-1.2.3-.4 1-1 1-1.4 0-.4.2-.6.9-1.1l.4-.6a100.5 100.5 0 0 0 1.7-12.7h-1.2zM203 187.6a37.3 37.3 0 0 0 9.3 12.1l-1-3.2c-.4-1.4-.2-2.9-.2-2.9s-1.3-1.7-3.8-5.6c-2.6-3.9-3.9-9.6-3.9-9.6s2.4 5.7 4.2 8.8c1.8 3 4 5.5 4 5.5s.6-2.7 1.2-2.8c.5-.2.9.2 1.3.8.5.6.9.6.9.6l-1.6-2.8-1.5-2.2c-1.5-2.3-4.6-6.6-6.1-10.9-1.6-4.3-5.1-15.1-5.7-18.3-.6-3.2-1.2-1.4-1.8.9a27.6 27.6 0 0 0-1 10.7 53.5 53.5 0 0 0 5.7 18.9zm5 21a135.9 135.9 0 0 0 3.5 2.5l-.6-1.7-.3-2.9-2.8-2.5a41.7 41.7 0 0 1-5.6-6c-3-3.6-.6-1.4 1.8 1.2s7 6.3 7 6.3v-.8a3.1 3.1 0 0 1 .7-1.9c.4-.6.2-.6-2.4-2.6a74.5 74.5 0 0 1-17.6-24.4s-1.4 9 4 18.7c5.4 9.9 10.8 13 12.2 14.1zm28.5 56.3c3-1.2 2.1-4.1 2.1-4.1s-1.8.5-3.5 1.2c-1.7.6-5.8 1.8-7.4 1.8-1.7 0-1.7-.2-1.7-.4s1.2 0 3.6-.4a29 29 0 0 0 7.2-3.1c.7-.5.6-.6-.4-.7a4.5 4.5 0 0 1-2.4-.9c-.4-.3-1.5.1-4.2.8a50.8 50.8 0 0 1-21.5.7c-.6-.2-1.3.2.7 3.7 2.1 3.5 9.4 5.3 14.4 5.3s10.1-2.8 13-3.9zm-13.4-7.2c5.2 0 7.1-1.5 7.1-1.5l-.7-1.3c-.7-1-.6-2.9-.6-2.9l-3.4.6c-2.1.3-4.6.6-7.4.1-2.8-.5-1.6-.8.6-.5 2.2.2 6.4-.6 7.8-1 1.4-.5.8-1-.1-1.3-1-.3-3.5-1.9-3.5-1.9s-6.3.8-12.1.2c-6-.7-9.6-2.2-10.8-2.4-1.2-.2-1.2.3-1.2.3s-.3.6 1.8 3.7c2 3.2 6 5.3 9.3 6.3 3.4 1 8 1.6 13.2 1.6zm-1.4-12.2l-.5-1.3c-.3-1 .6-1.9.6-1.9s-1.2-.3-5.1-.8c-3.9-.5-4.1-.8-6.5-1.3-2.4-.6-4-1.3-4-1.5.1-.3.9 0 2.3.6 1.4.5 7.4 1.2 9.9 1.5 2.5.4 3.9.6 4.3.4.5-.3 2-.7 2-.7l-2.4-.5a8.4 8.4 0 0 1-3.2-1.3c-.7-.5-.9-.6-4-1-3.3-.3-5.8-1.3-11.5-3.4-5.7-2-10-4.6-11.1-5.5-1.2-1-1-.3-.8 1 .3 1.1.3 2.6 3.2 6 2.8 3.3 4.2 4.8 11.5 7.4 7.2 2.7 15.3 2.3 15.3 2.3zM200.2 228a40.6 40.6 0 0 0 15.5 6.4c.4-.4-.4-2 0-2.8.4-1.1 1-1.1 2.6-1.2 1.6-.1.5-.4.2-.4l-3-.7c-2.6-.7-5.2-1.1-8.7-2.4-3.5-1.4-4.6-2.3-4.5-2.6.1-.3 1.6.8 5 2 3.2 1.3 7 1.8 9 2.3 2.1.4.3-.5-.7-1-1-.6-2.3-2.8-2.3-2.8s-2.3-.4-6-1.5a48.8 48.8 0 0 1-10-4.2c-1.1-.6-2.2-1.4-3.3-2.2l-5.1-3.7c-1.3-1-1-.2-.8.4s1 3.2 3 6.1c2 3 2.7 3.8 9.1 8.3zm-1-12.7c6.3 5 11.7 6.6 12.6 7 1 .4.9-.2.7-.7-.2-.5-.3-2.2-.3-2.2l-4.8-2.8a79.6 79.6 0 0 1-7.1-4.7c-1.9-1.3-.8-1.2-.2-.7.6.5 3.1 2 5.7 3.6l6.4 3.9s.1-.9.7-1.4c.5-.5 1.8-.4 1.8-.4l-1-1.3c-.4-.6-2.5-1.3-4.9-2.4a57.5 57.5 0 0 1-9.6-6.8c-3-2.6-9-9.1-9.5-9.7-.4-.5-.6-.4-.7.3 0 .6-.2 1 .4 4 .7 3 3.5 9.4 9.8 14.3zm22.3-47.2c.7 1.5 1.5 2.6 2 3.6a52 52 0 0 1 1.4 2.4s.2-.5 0-1.4c-.1-.8-.2-2 0-3.5l.3-2.3c0-.7-.4-1.4-.5-1.9l-1.5-7c-.5-2.7-1-6.4-.9-9.7 0-3.2.5-1.6.5 0a62.2 62.2 0 0 0 2.8 17.2s0-.9.5-2.1c.5-1.3 1.3-2.7 2-4.2.5-1.6.3-1.9.3-1.9s-2.2-10.6-2.8-15.6c-.6-5-1.5-18.1-1.5-18.1-3.3 3.2-5.7 11.8-6 20-.4 6 .6 11.7.9 14 .5 4.5 1.3 8 2.5 10.5zm-7.2 16.8c.1-2.4.7-4.3 2.2-4.8 0 0-1.3-2.4-2.5-5.8a45.7 45.7 0 0 1-1.9-7.7c-.8-5.6-1.5-11.5.2-2 1.7 9.7 3.7 13 3.7 13l2.5 4a17.3 17.3 0 0 1-.4-4.9c.1-1.9.4-4.5 1-6.5 0 0-3-6-4.9-13a82.2 82.2 0 0 1-3.2-22.7s-3 2.3-4 13.9a69 69 0 0 0 7.3 36.5zm33.3 88.6l-2-1.3c-1.4-.9-1-3.7-1-3.7l-1.4 1a19.2 19.2 0 0 1-3.7 2.2c-1.5.6-2.2 1-3 1.2-1 .3-.8 0 0-.5.8-.4 1-.7 3-1.4 1.9-.8 5.7-4.2 5.7-4.2l-2.5-.1c-1.6 0-3.6-.9-3.6-.9s-1.6 1.4-8 4.2a50 50 0 0 1-11.8 3.5s.7 3.2 3.8 4.3c2.5 1.1 6 1.8 12.9.2a43.5 43.5 0 0 0 11.6-4.5zm8.4 6.5c.5-2.7-1-4.6-1-4.6l-1.3 1.1c-1 .9-2.4 2.5-5 3.9-2.8 1.3-3.7 1.2-1.1-.2s6.4-5.3 6.4-5.3l-1-.4c-1-.4-2.8.3-10 4.6s-11.4 4.5-11.4 4.5 3.2 3.9 12 3.6c8.7-.3 11.8-4.5 12.4-7.2zm16.5-3.1s-1 1.3-2.3 2.2c-1.3.9-4.7 1.4-4.7 1.4l-.8 1.2c-.7 1-2.2 3-3.7 4-1.6 1.2-4 2-4.1 1.6-.1-.3 1.4-.8 2.9-1.8 1.5-.9 2.8-2.6 3.8-3.7 1-1.2-.4-1-.4-1h-3.5c-1.7-.2-1.4 0-1.9.7l-2.4 3-4.4 5.1c-1 1.2-.2 1.5-.2 1.5s.4.7 4.3 1.2c2.4.2 5 0 7.8-1.6a23 23 0 0 0 5.2-4.5c4.6-5.1 4.4-9.3 4.4-9.3zm2 10.5l-1.4 1.8 1.2-3c.3-.6.7-1 1-1.4-.7-1.4-1.3-3-1.6-4.7-.5 1.4-1.8 5.5-3.4 8.1-2 3.2-3.8 4.4-2.7 5.3 1.2.8 3.4 1 6-.2 2.4-1.2 3.1-3.3 3.5-5a24.8 24.8 0 0 1-1.2-2.1 5 5 0 0 0-1.3 1.2z"
    />
    <ellipse cx={274} cy={158.6} fill="#d4af3a" rx={1.8} ry={1.6} />
    <path
      fill="#d4af3a"
      d="M270.3 155.5c1.6 0 2.4-.8 4.2-.6 2.2.2 5 1.4 8.6 3.3a14.6 14.6 0 0 0 9.8.9c1-.3 2-.9 2.9-1.4 4.2-2.4 3.2-7.1 3.2-7.1a16.7 16.7 0 0 1-10.7 3.2l1 .8c.5.6 1.7 1.4 1.3 1.7-.4.3-2-1.2-3.2-2.2a19.4 19.4 0 0 0-6.5-3.2c-3.3-1-7-1-9.5.4-2.5 1.3-2.7 3-2.3 3.7.2.4.6.5 1.1.5zm46.2 34.7c-.8-.2-2.1-.4-3.8-2a71.4 71.4 0 0 1-6.3-7c-.5-.8-.3-1.5.9-2 1.1-.5 2-2 2-2s-2.6-1-4.3-2.2a44 44 0 0 1-6.2-5.7c-.6-1-.3-1 .5-1.3.8-.3 1-.8 1-.8s-1.8-1.2-3.5-2.6a71 71 0 0 1-4-3.6c-2.6 1-6.7.6-8.9.2-3.8-.7-6.6-2.3-6.6-2.3l-.6 1.8c-.5 1.2-2.3 1.8-4 .7-1.8-1.2-1.4-3.7-1.4-3.7s-1.5-1-4.4-2c-3-1.1-5.4-1.3-7.8-.2-2.4 1.1-3.6 4.4-3.6 7 0 2.4 1.4 1.3 1.6 1 .3-.3.9-2.1 3.9-2.6s5.7 1 9.2 3.8c3.4 2.8 4.1 3 5.9 4.8 1.7 1.8.3 2.7-2.6 3.7-3 1-6.8-1-6.9-.9-.6.3 1.3 3 3.8 4 2.6 1 5.8.3 8.3-.8 1.7-.6 2 0 2.6.6a15 15 0 0 1 4 9 4 4 0 0 0 2.6-3c0-.6.2-1.8 1.2-1 1 1 1.7 6 1.7 8.2s-.7 5.3-.7 5.3h.7l2.3-1.2c1.1-.7 1.2 0 1.2 1.3s.4 3.6 2 7.8c1.7 4.2 4.1 5.5 4.1 5.5s.5-.8 1-2.5.8-4.8.8-7.7c0-2.8-.8-8.8-.8-8.8s3.5 4.2 7 5.2c3.6 1 7.2.4 8.7-1.3 1.5-1.7.1-2.5-.6-2.7z"
    />
    <path
      fill="#d4af3a"
      d="M293 201s-1 2.5-1.7 3.3l-.8 1s1 1 2.6 1.4l3 .8s-1.8-2.4-2.4-4.1l-.7-2.3zm21.4-1.3a71.6 71.6 0 0 0-.8-2.1 15 15 0 0 1-8.2-1.7s1.7 3.3 3.3 4.5l1.9 1.2s-1.7.3-3.9-2c-2.2-2-3.1-4.6-3.1-4.6s.5 5.8-.4 9.3l-1.1 4s4.6.9 9.8-.6c5.2-1.4 5.6-1.9 5.6-1.9s.6-.1-.2-1.2a28 28 0 0 1-2.9-5z"
    />
    <path
      fill="#b96b29"
      d="M305 187a11 11 0 0 1-1.8-2.3s-.5.5 0 1.3a15 15 0 0 0 4.3 3.7 11.1 11.1 0 0 0 3 1.2v-.4s-3.9-1.7-5.5-3.5zm-6.3 12l-.4-8.3c0-1-.7-.8-.7-.8l-.8.3 1.6 10.6c.1 1.2.7 1 1 1-.6-.3-.7-2.5-.7-2.8zm-9.8-31.4c-.6-.6-2-1-.7.4s3 3.2 3.5 4.7c.5 1.4.8 3.3 0 2.9-.9-.4-1.5-.4-2.4-1.2a15 15 0 0 0-3.2-2.1c-.7-.2-2 0-1 1a24.8 24.8 0 0 0 4 3.6c1.8 1.3 3 2 4 2.6a36.9 36.9 0 0 0 1.9 1.3s-.9-6-2.5-8.5a26.3 26.3 0 0 0-3.6-4.7zm-32 99.2a7 7 0 0 1-2.8 1.3s-.8 0-.8.2 1 0 1.8-.1a8 8 0 0 0 2.6-1.4c.5-.4 1.2-.8 1-1.4-.3-.6-.6.5-1.8 1.4zm10.3 5.5l-2.2 1.8-1.3.7c-.7.2-.9.6-.9.6s.2.2.9 0 2.7-1.7 3.4-2.3c.7-.6 1-.7.7-1s-.4 0-.6.2zM225.3 198c.4.4.8 1 1 .9.2-.2 0-.5-.5-1l-.8-.9-1.1-1.5c-.4-.4-1-.7-.3.3l1.7 2.2zm-3.2 7l1.4 1.3c.5.5.8 1.1 1.1.8.3-.3-.7-.9-1.2-1.5a7.5 7.5 0 0 0-1.4-1.4 10 10 0 0 0-1.2-.8l1.3 1.6zm1.2 11.2c.8.9 2 1.1 2.1.8.2-.4 0-.6-.7-1a24 24 0 0 1-2.3-1.4l-1.4-1.1c-.4-.4-.8-.7-1-.6-.1.1 1.1 1.5 1.5 1.7.4.2 1 .8 1.8 1.6zm2.3 9c0-.3 0-.5-.6-.5a26.9 26.9 0 0 1-1.6-.2s-1.3-.5-1.3-.2c-.1.3 1 .8 1.5.8l1.4.4c.3.2.6 0 .6-.3zm1 9.8c-1.4 0-2.6-.3-2.7 0-.1.1.6.5 1.3.7.8.3 2 .3 3 .4 1 0 1-.2 1-.6 0-.5-1.2-.5-2.6-.5zm11 10.8c-.2-.2-.7 0-1.5 0-.8.3-2 .5-2.8.5l-2.4-.1-.9.2c0 .2 1.2.2 3 .4 1.7.2 2.9-.2 3.7-.3.8-.2 1.1-.5 1-.7zm4.6 7.6a5.6 5.6 0 0 1-2.2.4l-2.2.3s-.8 0-.6.4c0 .3.3 0 1-.1h2.3c1.1 0 1.8-.4 2.5-.5.7-.1 1.5-.5 1.2-1-.4-.4-1.2.2-2 .5zm8.9 5.8l-2.4 1.8-1.2.6c-.7.4-.7.6-.6.8.2.2.6-.3 1-.5.5-.1 1.8-1 2.5-1.6.7-.6 1.6-1 1.5-1.5-.2-.4-.3-.1-.8.4zm-14.8-74.8l1.7 2.3c1.6 1.9.7.1.3-.4l-3.4-4.5c-.8-.9-.9-.5-.5 0l1.9 2.6zm-3.2 9.8c.2-.2-.3-.4-1.2-1.5l-2.6-3.3s-.5-1-.7-1c-.1.1.6 1.8 1.3 2.5.7.7 1.7 2 2.2 2.7.5.6.7.9 1 .6zm4.2 18.5c0-.5-1.7-.5-2.5-.6l-2.2-.5s-1.6-.3-1.7 0c0 .1.3.3 1.2.5l3.4.8c1 .1 1.8.3 1.8-.2zm-4.2-10c1.1 1 1.9 1.4 2.5 1.7.6.4 1 .8 1.4.5.3-.4-.3-.7-1.3-1.1-1-.5-1.4-.9-1.4-.9l-1-.5c-.6-.3-1.4-.6-.2.3zm9.9-6.5l-1.4-1s-.8-.8-1-.5c-.2.3 1 1 1.5 1.6.6.5 1.6 1.9 2 1.6.6-.3-.4-1.1-1.1-1.7zm-6.5 25.7l-1.6.4c-.6.2-.7.4.5.4 1.1 0 1.5-.3 2.7-.5 1-.2 1.5-.3 1.3-.7-.2-.3-.8-.2-1.2 0l-1.7.4zm1.7 9.3c0 .2.8 0 1.4-.2.6-.2 1.8-.9 2.5-1 .7-.3.7-.4.7-.8s-.8 0-1.7.2c-.9.3-2 1.2-2 1.2s-.8.4-.9.6zm12 5.6c.9-.5 1-.8.7-1-.3-.3-.5-.3-1.2.2a51 51 0 0 1-2 1.5l-1 .5c-.6.2-1.2.7-1 1 .1.1 1.2 0 1.7-.6s2-1 2.8-1.6zm5.7 7.5c.3-.3 1.3-.6 1.8-1 .4-.3.7-1.3.3-1.4-.3-.1-.5.4-1.3 1l-3.5 2.4-.7.3c-.8.2-.4.5.2.4.6-.1 1-.1 1.8-.7l1.4-1zm8.3 7.1a10 10 0 0 0 2.3-1.7c.5-.4 1.1-1 .7-1.3-.3-.3-.7.1-1.3.6l-2.1 2.2s-.3 0-1 .7c-1 .7 0 .5.2.3a3 3 0 0 1 1.2-.8z"
    />
    <path fill="#d4af3a" d="M295.2 143.5l3.2 1.4 3.4-2.4-4-1z" />
    <ellipse cx={309.2} cy={142.1} fill="#b96b29" rx={3.2} ry={3.1} />
    <ellipse cx={309.2} cy={141.4} fill="#d4af3a" rx={1.9} ry={1.9} />
    <path
      fill="#d4af3a"
      d="M302.4 131.4c.9.3 2 .2 2 .2s.3-1.4-.5-2.1l-2-1.7-.5-.6-.1 2c0 .8.3 1.9 1.2 2.2z"
    />
    <ellipse cx={304.2} cy={133} fill="#d4af3a" rx={0.6} ry={0.6} />
    <path
      fill="#d4af3a"
      d="M299.8 132.4l-.8.9s.6 0 1.2.4c.5.4 1.2.7 1.8.6.7 0 1-.7.8-1-.1-.5-.4-1-1.5-1.3-1-.4-1.3 0-1.5.4zm2.2 3.7c-2 .2-4.7-2-4.7-2-.2 1.8-1.3 2.7-3 3l.1.1s1.6.8 3.5 1.1a7 7 0 0 0 2.5-.2c1-.2 2.3-.5 3-1 1.2-.7.8-2.6.8-2.6s-.2 1.5-2.2 1.6zm-7.9-2c-.8-.3-2-.9-2.6-1-.5 0-1.2 0-1.1.9.1 1 1.1 1.4 2 1.4 1 0 1.5-.3 2.1-.6.6-.3.5-.4-.4-.7zm-6.3-3.4c-.9-.7-1.7-.9-1.7-.9s-.6 1.6-.3 2.6c.4 1 1 1.2 2 1.2.8 0 2-.5 1.7-1.2a5 5 0 0 0-1.7-1.7z"
    />
    <ellipse cx={288.6} cy={135.1} fill="#d4af3a" rx={0.7} ry={0.5} />
    <path
      fill="#d4af3a"
      d="M290.6 127.3a11 11 0 0 1 2-9.3c2.5-3.6 7-5.1 7-5.1l1.5-1.8c1.4-1.5 4.2-3.4 4.2-3.4l-5.2 1.5a2.3 2.3 0 0 1-2.2 2.4c-.5 0-1-.2-1.3-.4-1 .1-4.4 2.2-5.3 2.9l.3 1.2a2.3 2.3 0 0 1-2.2 2.3c-.4 0-.7 0-1-.2a9.6 9.6 0 0 0-.3.5 23.4 23.4 0 0 0-1.7 3.7c.6.4 1 1.1 1 2 0 1.3-.9 2.3-2 2.3a7.9 7.9 0 0 0 0 1.5c.1.7.4 1.2 1.7 1.6 1.3.3 3.1 2.6 3.1 2.6.1 0 1-1.6.4-4.3z"
    />
    <path
      fill="#d4af3a"
      d="M298.6 110.3c.5-.4.6-1 .2-1.4-.4-.3-1-.3-1.5.1s-.6 1-.2 1.4c.3.3 1 .3 1.5-.1zm-8.5 5.7c.6-.5.7-1.3.3-1.7-.5-.4-1.2-.4-1.8.1s-.6 1.3-.2 1.7c.4.4 1.2.4 1.8-.1z"
    />
    <ellipse cx={285.1} cy={123.2} fill="#d4af3a" rx={1.3} ry={1.3} />
    <path
      fill="#d4af3a"
      d="M313.3 105c-.7.2-2 .6-3.8 1.6 1.3 0 2.3.8 2.3 1.9 0 1-1.1 2.2-2.4 2.2a2.2 2.2 0 0 1-2.2-2.2l.1-.7-1.7 1.2a17.6 17.6 0 0 0-7.2 8c-2 3.8-2.8 8-2 10.4 1 2.5 4.2 3 4.3 3 0 0-.4-.3-.5-.8l.3-1.6v-2.1s.8-.1 1.2.4l1.4 1.7 1.6 1.5s.6-1 .6-2.1-.7-2.3-.9-4.3c-.1-2 1-5.5 2.8-8 2-2.6 5.5-5 6.6-5.5a2.1 2.1 0 0 0 1.3-1.7l.3-2c0-1.2-1-1.1-2-.9z"
    />
    <path
      fill="#d4af3a"
      d="M309.2 109.5c.7 0 1.4-.7 1.4-1.3 0-.6-.6-1-1.3-1-.8 0-1.4.4-1.4 1s.6 1.3 1.3 1.3zm6.2 24.4c1 .4 2.1.1 2.6-.2.6-.4.7-1.3.1-1.8a2 2 0 0 0-2.1-.2l-2 1.3s.4.5 1.4.9z"
    />
    <path
      fill="#d4af3a"
      d="M318.6 135c-.4.6-.7.9-1.8 1-1 0-2.3 0-3-.8a7.7 7.7 0 0 1-1.3-1.7h-1.2s-.4 1.7-1 2.1c-.5.5-2.5.6-3.3 0-.9-.7-1.6-1.4-1.8-1.3-.1 0 0 .7.9 1.4s1.5 1.3 2.9 1.3h8s1.6 0 2-1c.5-.9.5-1.5.3-1.7-.2-.3-.4.1-.7.7z"
    />
    <path
      fill="#d4af3a"
      d="M306.4 133.7c1.2.6 1.9.2 2.3-.3l.6-.8-1.7-.7c-.6-.4-1-.7-1.5-.6l-.6.1s-.3 1.6 1 2.2z"
    />
    <ellipse cx={300.7} cy={121.9} fill="#b96b29" rx={2.7} ry={2.6} />
    <path
      fill="#b96b29"
      d="M305.3 112.7c-1-.7-2.6-.4-3.5.6-.9 1.1-.7 2.6.4 3.3 1 .7 2.6.4 3.5-.6.8-1.1.7-2.6-.4-3.3z"
    />
    <ellipse cx={300.6} cy={121.5} fill="#d4af3a" rx={1.6} ry={1.5} />
    <path
      fill="#d4af3a"
      d="M304.2 113a1.8 1.8 0 0 0-2 .8c-.3.6.1 1.2 1 1.4 1.7.3 2.5-1.8 1-2.2zm-40.7 206s-4.1 2-5.4 2.3l-1.6.4s-2.8 2.5-4.9 3.8a18.3 18.3 0 0 1-7.1 2.4c-3.2.4-12 .3-16 .1-4-.1-6.4.8-8.1 2.7-1.7 2-2.1 4.7 0 6.8 2.2 2.1 4.6 1 5.4-.2.8-1.3.4-3 0-3.7-.3-.8.7-1 1.8-1.1a24.3 24.3 0 0 1 10.7 2.3c1.3.7.6.8-.3.7-1-.2-2-.5-3.5-1.1-1.6-.6-3-1-4-1s-.7.5-.5.9l1 1.6c.1.4-.3 1.9-.3 1.9l.5 1 .8-1.5c.2-.5-.1-1.5.1-2 .2-.4 1-.4 1.7.4a6.7 6.7 0 0 1 1.8 3.5c.3 2-.3 3.3-.3 3.3s.8.7 1 1.1l-.3 2.3s.6.3 1-.7c.6-1 1.2-3 1.3-3.6.2-.7.6-1.9 1.4-1 .8 1 1.4 2 1.5 2.6l.2 1s1.8-1.7 2.4-2.8a17 17 0 0 1 3.6-3.9c1.7-1.4 4.6-4.2 6-5.2 1.5-1 5.2-3 6.4-3.6 1.1-.7 1.3-.8 1.5-2.7.2-2 1.2-3.8 1.6-5.1l.6-1.9zm-65.8-73.7c0-.4-.7-1.5-.8-2.1-.2-.6-.8-.3-.8-.3s-1.3.8-2.3 1c-1 .3-1 0-1.2-.6l-.5-3.2c-.2-1-.4-1-.8-.8l-2.4 1c-.9.3-.6.7-.3 1.2l1.6 3.1c.5.7 0 1-.4 1.3l-2.3.6c-1 .4-1 .6-.8 1 0 .3.8 1.7 1.1 2.3.4.6.7.2.7.2s1.1-1 2-1.4c.9-.4 1-.3 1.2.4l1.5 4.8c.2.7.5.6 1 .4l1.6-.4c.5-.2.7-1.3.7-1.3l-2.5-4.4c-.5-1 0-1.1.4-1.2.4 0 1.6-.2 2.6-.5 1-.2.7-.8.7-1.2zm22.3 96.5c-.1-.8 0-1.7-.6-2.3a8.1 8.1 0 0 1-1.8-3c-.3-1 .3-1.6.2-2.2-.1-.6-1-.6-1.7 0-.8.7-1.9 1.3-1.9 3.2 0 2 .7 4.2 3.4 5 2.6.8 2.6.2 2.4-.6zm2.7-.9s-.5-.3-.8.2c-.2.5-.2.7.5 1.9.7 1 1.2 1.3 2 1.8s.2-.5.1-.8c0-.3 0-.7-.2-1s-.3-.5-.3-1.3-1.3-.8-1.3-.8z"
    />
    <path
      fill="#d4af3a"
      d="M226 350c.5-.8 1-1 2.1-1.5a15.3 15.3 0 0 1 4.2-1c.7 0 2.5-1.4 2.2-3-.3-1.4-1.4-2-2.3-2.2-1-.3-1.8-.3-2.1.2-.3.5-.9 1-2 1.4s-1.1.7-1.8 1c-.6.1-.1.5-.7 1-.5.4-1.3 0-2.1-.3-.9-.2-1-.4-1.9-.4l-3.4-.2h-.7c-.6 0-.6 0-.9.6s.1 2.1.7 2.9c.6.7 2.6 1 3.9 1.5l3 .8c1.2.1 1.3 0 1.8-.8zm12.2 1.2c1-.7.4-2 .2-2.7-.3-.7-1.7-.9-2.5-.9-.7 0-1.1 0-1.5.4-.4.3-1 .8-2 1.2-1.2.3-2 .7-3.6 1.3-1.5.6-2 1.6-2.6 2-.6.4-1.9 0-1.9 0s-.9-.2-1.2 0c-.3.3 0 .8.6 1.5.6.6 1.8.6 3 1 1.4.4 1.6 0 2.1-.3s1-1 1.8-1.6c1-.6 3-.7 3.9-.8 1-.1 2.6-.4 3.7-1.1zm0-4.6c.4.4 1 1 1.3.3.4-.6 1-2 .6-2.8-.4-.8-1-1.5-1-1.5l-1 3c-.4.5-.4.6 0 1zm-4-7c0-1.2-1-2.8-1-2.8s-.3 1.2-.9 2.2c-.5 1-1 1.6-1 1.6l1.7.4c.5 0 1.1 0 1.1-1.3zm-7.6 2.8c1.4-.2 2.1-.8 2.7-1.3.6-.5 1-1.9.6-2.6-.4-.7-1.4-1.4-1.8-1.4h-.8s-.4 1.3-1 2c-.5.6-1.1 1-1 1.9 0 .8-.1 1.7 1.3 1.4zm2.8-6.3a2.4 2.4 0 0 0-.6-1.9l-.8-.7-.2 1.6-.1.6.7.6c.4.1 1 .4 1-.2zm-17.3-35.7l1-6a39 39 0 0 0-6.3-15.4c-2.4-3.8-5-10-6-13.2a37.4 37.4 0 0 1-2-10c0-2.3 1-3.5 1-3.5s.5-.6.1-1-1 0-1.7.6a7.5 7.5 0 0 0-1.5 2.6l-.3 1.1s-1.2-.3-3.3-.1c-2 .2-3 .3-3 .8 0 .4.3.7 1.7 1.4 1.5.6 2.4.9 3.1 1.7.8.9 2.6 5.2 3.2 7.3.6 2.1 1.8 7.8 2.3 12.2a49 49 0 0 0 4 14.4c.8 1.5 4.5 8.5 7.7 7zm3.7 10.4c-1.4.8-1.3 6.4-.7 9.3.6 2.9 3.4 6.5 4.3 7.5.9 1 1 1 1.5.7l.7-.2s1.2-.5 2.1-1.2c1-.7.6-2.5.4-4-.1-1.6-1.4-4.8-3.6-8.5-2.2-3.6-3.3-4.4-4.7-3.6zm1.5-4.5c0-1.9-1.6-3.2-3.4-3.2-.9 0-1.6.2-2.1.6-1.9 1.7-.7 5.8 2 5.8.9 0 2-.1 2.7-.8.7-.6.8-1.6.8-2.4zm26.5 52.7a7 7 0 0 1-2.2-1.2 10 10 0 0 1-3.1-3c-.3-.7-.3-.7-1.4-.4-1 .4-2.5.3-3.6.4-1 0 .2 1.3 1 2.4.7 1.2.4 5.1.4 5.1l-.1.9c-.2.6 0 1 .2 1 .3.2.5 0 1.3-1 .8-.9 2.2-3.2 2.2-3.2l1.4.3c1.2.3 3.1.1 4.1-.2 1-.3.6-1-.2-1.1z"
    />
    <path
      fill="#d4af3a"
      d="M239.2 362c-.5 0-.7-.1-1 .2l-.6 1.4c-.1.3 0 .6.2.9l.8.5s.4.5.8.7c.5.2.5-.4.5-.9l.3-1.9c0-.6-.4-.8-1-.9z"
    />
    <path
      fill="#1d5e91"
      d="M435 324.2c-1.3-.3-1.9-.8-1.9-.8s-.5 0-1 .7c-.3.8-2 1.8-2 1.8s-2.2.6-2.5 2.2c-.3 1.5.8 2 1.8 1.9 1.1-.2 3.7-.7 4.9-2.1 1.1-1.4 1.3-2.2 1.5-2.7.2-.5.4-.7-.9-1zm3.5-12.4a15 15 0 0 0-7.4-9.9l-2.1 7.5c-.5 1.8-.5 1.7.9 2l6.7 1.6c.9.3 2.4 1 1.9-1.2zm-20.6-3.2c1 .1 1-.3 1.3-1.7l2.1-8.2s-4.5-.1-8.5 1.8c-3.9 1.9-5.6 5.4-5.6 5.4s1 .4 3.7 1 6 1.5 7 1.6zm-10.5 9.3l-2.2-.4s1 3.8 2.7 6c1.7 2.2 3.5 3.2 7 3.3 3.5 0 6-1.9 6.5-3.4.4-1.5 1.1-2.6 1.1-2.6s-6.2-.8-8.8-1.4l-6.3-1.5z"
    />
    <path
      fill="#d4af3a"
      d="M406.3 315.5l15.5 3c1 .3 2 .5 2.2.2.3-.3.5-.5 1.6-.9 1.2-.4 1.1-1.5 1.1-1.5l.4-2.2c.2-1 .8-1.4 2-.1 1.3 1.3 1.5 3.2 1.7 5 .3 2 3.2 2.4 4.4 2.6 1.1.2 1.6-.2 2.3-1.3.7-1 1-3.2 1.2-4.6.2-1.4 0-1.2-1.4-1.6l-9.3-2.2c-1.2-.2-1-1-.7-1.9.1-.8 2.8-9.2 2.8-9.2a18.9 18.9 0 0 0-7.7-2.3l-2.3 10c-.3 1.3-1.2 1.3-2.5 1-1.4-.2-11.3-2.5-11.3-2.5l-.8 1.8a15.5 15.5 0 0 0-1.1 5.2c0 1.2.4 1.2 1.9 1.5z"
    />
    <path
      fill="#d4af3a"
      d="M440.3 323.3c-1.3-.9-2.3-1.1-3 .5-.7 1.6-.7 4-2.4 5.6-1.8 1.7-4.2 3.4-6.6 3.2-2.4-.2-3.7-.7-3.2-3.5.6-2.7 4.3-3.6 5.1-5 .9-1.5.7-3.1-.6-4.2-1.3-1.1-3.1-1.3-3.6-1a8 8 0 0 0-2.8 3.7c-.7 2-1.2 3.7-2.8 5a12.2 12.2 0 0 1-9 2c-3.1-.8-4.3-1.8-5.5-5-1.2-3.1-2.6-8.3-3.2-9-.7-.5-1.5-1-2.8 0-1.4 1-1.5 2.4-1.7 3.6-.2 1.1 0 2.5 1.4 4.1 1.4 1.7 2.8 3.3 3.3 5 .5 1.8 2 4.4-.1 4.5-2.2.2-3.2.2-4.8-1.4-1.7-1.6-8.2-6-10-7.4a29 29 0 0 0-2.5-2c-3 0-6-1.2-9-3.3 0 0 1.8 4.4 2.1 6.1.4 1.7.3 2.6.3 2.6l9.1 4.6a168 168 0 0 1 10.3 5.8c2.5 1.5 4.7 4 9.1 3 4.5-.9 13.5-3.6 16.5-4.5 2.9-.9 11-2.9 14-5 3-2 3.2-1.9 3.7-4 .5-2 0-3.1-1.3-4zm-17.2-31l2.2-.3c1.5-.1 1 1.3.7 1.9l-1.4 2.7c-.6 1 .2 1.2.6 1.4l2.3.6c1.3.3 1-.6 1-1l.3-3.8c.1-.9 1-.6 1.2-.5l1.7 1c.6.3 1 0 1-.4l.8-2c.2-1-.4-.8-1-.8h-2.4c-1 0-.4-1-.4-1l1.3-2.1c.6-.9.4-1-.2-1.2l-2.8-.7c-.5-.1-.7 0-.7.3l-.1 2.7c0 .7 0 1-1 1-.8.1-1.3-.4-2-1.1-.7-.8-1-.5-1-.2l-.8 3c-.2.7.1.6.6.6zm4.8 21.8s-.1 1.7-.3 2.3c-.2.7-.6 1.6.1 1.8.8.2 1.4.5 1.8.4.5-.1.3-1 0-1.7a6.4 6.4 0 0 0-1.1-2.2l-.5-.6zm10.5 7c.2.5.7.6 1 .7.4.1 1 .1 1-.5s0-1.5-.5-2.2c-.5-.8-.8-1.3-1.1-.2-.4 1-.6 1.6-.4 2.2zm-36.7-7l1.4.4s0-1.7.3-2.8c.2-1.2.7-2 .3-2-.4 0-.7.4-1 .9-.3.5-1.1.6-1.4 2-.3 1.3.1 1.4.4 1.4z"
    />
    <circle cx={408.9} cy={311.2} r={2.3} fill="#b96b29" />
    <circle cx={415.5} cy={312.8} r={2.4} fill="#b96b29" />
    <circle cx={434.6} cy={316.9} r={2.4} fill="#b96b29" />
    <circle cx={422.1} cy={314.4} r={2.4} fill="#b96b29" />
    <circle cx={423.8} cy={308.6} r={2.4} fill="#b96b29" />
    <circle cx={425.5} cy={302.9} r={2.4} fill="#b96b29" />
    <circle cx={409.1} cy={310.9} r={1.2} fill="#d4af3a" />
    <circle cx={415.6} cy={312.6} r={1.2} fill="#d4af3a" />
    <circle cx={434.8} cy={316.6} r={1.2} fill="#d4af3a" />
    <circle cx={422.2} cy={314.1} r={1.2} fill="#d4af3a" />
    <circle cx={424} cy={308.4} r={1.2} fill="#d4af3a" />
    <circle cx={425.7} cy={302.6} r={1.2} fill="#d4af3a" />
    <path
      fill="#d4af3a"
      d="M349.5 359.1l-5.2-3.6a11.8 11.8 0 0 1-3.9-4h1c.6 0 1-.7 1-1.5.1-.8 0-2.3-.2-4.1-.2-1.8.3-3.3.3-3.3s1.3 1.1 3.1 2c1.9 1 2.6.6 2.6.6l.5-1.9 2 3.7c1 2 4.1 4.2 6.3 5.8 2.2 1.7 4.6 3.4 6.4 4 1.8.7.8 1.5.8 1.5s-1.8 1.8-6.5 2.7c-4.7.8-7-1-8.2-1.9z"
    />
    <path
      fill="#d4af3a"
      d="M333.2 357.3c1.7-.2 2.7-.8 3-2.6.2-1.2-.1-5.7-.1-5.7l1.2 1.2c.6.8 2 1 2 1s.2.6.9 1.6a9.3 9.3 0 0 0 3 3.2c1.6 1 3.5 2.2 4.7 3.2a28.1 28.1 0 0 0 4.2 3.1 7 7 0 0 1 3.6 4.7c.6 2.4.1 3.1-1.7 3-1.9-.1-2 0-5-.7-3-.8-7.3-4.1-10.4-6-3.1-2-5.4-6-5.4-6z"
    />
    <path
      fill="#d4af3a"
      d="M325 360s1.2-1.6 1.6-3.4l1.4-5.4 1.4 3.3a4.9 4.9 0 0 0 2.8 2.7s0 .9 1.5 2.7a21 21 0 0 0 5.6 4.8c2.2 1.2 5 3 6.5 5.1 1.5 2.2 1.6 4.4 1 5.4-.8 1-1.8-.1-3.2-.9-1.5-.7-5.6-1.3-11.2-4.4-5.6-3-7.5-9.9-7.5-9.9z"
    />
    <path
      fill="#d4af3a"
      d="M322.5 372.7c-1.6-2.4-1.8-8-1.8-8l1.3-1c.7-.7 2.2-2.9 2.2-2.9l2 3.8c1 1.8 1.4 2.4 3.6 4.3 2 2 5 3.9 6.1 6 1.3 2 .6 6.1-.2 7.5-.8 1.5-2 1-3.1-.1L329 379c-2.1-1.7-5-4-6.5-6.3z"
    />
    <path
      fill="#b96b29"
      d="M341 325.3c-.8-1.7-1.8-3.7-2.5-4.8a15 15 0 0 1-1.3-2.2s2 1.8 2.8 3.1c.8 1.4 1.3 2.6 1.6 4 .4 1.4.2 1.6-.6 0zm-8 1.5l-.5-1.9s-.3-1-.2-1.1c.2-.1 1 .6 1.6 2.5.6 1.8 1.5 4.5 1.3 4.6-.2 0-1.9-3-2.2-4.1zm-6.3 5l-.4-.8s-.6-2-.6-2.5c0-.4.2-1 .7.1s.6 2.2.7 2.6c.1.5.7 2.1.5 2.3-.1.1-.5-.9-1-1.7zm19.5 19.2l.9-.5 1.2 1.5c.7.7 1.5 1 2 1.7a8 8 0 0 0 2.8 2.3c1.3.7 1.8 1 1.5 1.1-.2.2-1.1-.3-1.1-.3s-.4 0-2-1c-1.5-.9-1.9-1.4-2.9-2.3l-2.4-2.5zm-6.8 8.1c-.6-.6-1.2-1-.9-1.4.4-.3.8-.3 1.3.2l2.9 2.6 2 1.5c.7.6 2.3 1.4 3 1.8.8.5 0 .5 0 .5l-1.2-.5-2.4-1-1.7-1c-1-.7-2.4-2-3-2.7zm-7.8 5.5c-.5-1 0-.8.8-.4.9.3 2.8 2.4 3.9 3.1 1 .8 2 1.1 3 1.6.8.4.8.7.8.9 0 .2-.4.2-.8 0l-1.7-.9-1-.2c-.5 0-1.3-.6-2.4-1.6-1.1-1-2.1-1.5-2.6-2.5zm-3.7 7.2c1.4.8 3.8 2.7 4.4 4 .6 1.2 1 2.1.9 2.3-.3.2-1-.2-1.2-.7l-1-1.2s-2.4-2.4-3.2-3a8.3 8.3 0 0 1-2.7-3c-.3-1 0-1.4 0-1.4s1.4 2.1 2.8 3z"
    />
    <path
      fill="#c52126"
      d="M365 170a22.3 22.3 0 0 1 8.3-2.6c3.6-.3 6.4.2 9.5 1 2.1.6 3.9.7 5.6.3 2.6-.7 4.6-3 5.3-6 0 0 2.4 3.1 0 6.5a7.2 7.2 0 0 1-4.3 2.9c-5.1 1-10.1-2-14.3-2.4-4.1-.2-7.3 2.4-7.3 2.4s-1 .8-2.4 0c-1.3-.8-1.7-1.4-.4-2.2z"
    />
    <path
      fill="#d4af3a"
      d="M379.6 317.5l1.2-.2c.7 0 2.2-.6 2.7-.8.5-.2 1.2-.2 1.6.3.5.5 4.1 2.7 4.1 2.7h-6c-2.1 0-3.5-2-3.5-2z"
    />
    <path
      fill="#d4af3a"
      d="M362.6 316.4v-.5l.8-1.8s1 .6 1.8 1.5c1.2 1.3 2.5 3 3 3.7 1 1.3 2.5 2.5 1.3.5s-1.6-3-2.6-4.4l-1.6-2 3.4-.5c2.5-.3 4.2-1.3 5.3-2l3.3-1.9s4.3 1.9 6 2.3c1.6.4 2.5.6 1 1.4-1.6.8-3 1-3.7 1.5a12 12 0 0 1-4.6 1.2c-1.5 0-4 0-3 1a22 22 0 0 1 4.2 13l-.1 2.5s-1.8-2-6.6-5a71 71 0 0 0-7.4-4.4c-.9-.4-1.3-.4-1.2-1.5l.7-4.6z"
    />
    <path
      fill="#d4af3a"
      d="M344.4 302a68.5 68.5 0 0 0 .8-.4h.3c.5.3 3.4 2.3 4.6 4.2 1.2 1.9 2.4 2 1 0a17.9 17.9 0 0 0-3.2-4.2 23.4 23.4 0 0 0-1-.8 53.3 53.3 0 0 0 7.3-4.2c.4.6 1 1.7 1.7 2.5 1 1 3.2 2 3.2 2s-1.8-2-2.4-3.3l-.8-2.5a31.7 31.7 0 0 0 4.8-4.6c.3 1.3 1.3 4.2 4.2 7.4 3.7 4.2 11.2 6.3 11.2 6.3s2.6.3.5.9c-2.1.5-3.6 1.5-7.8.8l-5-1.1c-.5-.2-2 0 0 .7 2.1.8 7 1.5 8.8 1.4 1.8-.2 4.4-.6 1.7.8-2.6 1.4-3.7 2-5.3 2s-2.3.5-4 .5c-1.5 0-2-.3-3-.5-1.2-.3-1.9.1-1.9.6 0 .4 1.5 1.7 1.5 4.7 0 3.1-.3 5.1-.6 6-.3 1-1 2.4-1.4 3.2-.4.8-.6 1.7-1-.1-.5-1.8-1.5-4.4-1.9-6.1l-.8-2.7c-.1-.9-1.1-1.6-.6 0a133.4 133.4 0 0 1 1.2 5.2c.4 1.5 1.1 4.2-.2 2-1.3-2-6.4-7.7-7.2-8.8l-2.1-2.8c-.7-.8-2.4-1.9-3.2-3.1a28.5 28.5 0 0 0-4-4l4.5-2zm69.5-129.2c-.1 3.1-3.5 9-5.5 12.2-2 3.1-2.5 4.4-2.1 4.6.3.2 1.1-1.4 2.2-2.8l4.9-7.2c1.7-2.5 4.2-8.4 4.6-8.9.3-.5.4-.9 1.3-.2s2.6 7.2.5 11.6c-2 4.4-5 7.6-6.2 9.2-1.3 1.5-3 4-2.7 4.1.3.2.7-.4 2.3-2a47.3 47.3 0 0 0 9.6-12.5c.2-.4.5-.3.8 0 .5.5 1.4 1.8 1 5.3a17 17 0 0 1-5.3 10.2c-2.3 2.4-4.6 4.5-4.3 4.9.4.3 2.7-1.8 4.3-3.3 1.6-1.6 5.6-5.4 6.4-6.5 1-1 2.2-.5 2.1 3.7 0 4.3-4.7 8.5-6.7 10.9-2 2.3-4.3 3.7-4.1 4.2.2.5 2.1-.7 3.4-1.6l7-4.6c.9-.7 1.3.6.1 4.6-1.2 4-4.6 7.2-6.7 8.7-2 1.5-5.4 3.3-5.2 3.8.2.4 1.6-.2 3.5-1.1 2-1 4.3-1.8 6-2.3 1.6-.5 1.6.7 1.6.7s.4 3.5-2.1 6.2a13.3 13.3 0 0 1-8 4.3c-2.6.5-3 .6-3 1s.4.5 1 .5l5.3.2c2.3 0 3.5.6 3.5 1.6s0 2.3-3.3 4.6c-3.5 2.3-7.3 2.6-8.9 3-1.6.3-1.6.4-1.3.9.3.5 1 .4 3.6.7 2.5.2 4 1.2 4.4 2 .3.6-.2 2.6-2.3 4-2 1.4-4.7 1.9-8.7 1.6-4-.3-5-.3-5.2.3-.1.7 1.2 1 3.2 1.2 2 .4 3.6.4 4.7 1.3 1.2 1 .3 2.9-1.7 4.3-1.9 1.4-6.7 1.4-8.7 1.3-2-.2-5.1-.9-5.3-.4-.2.6 1.5 1.4 3.5 2.1 2.1.8 2.7 1.2 3.1 2.1.4.9 0 1.7-2.4 2.6a12 12 0 0 1-8 0c-1.8-.8-2.8-1.1-3.2-.8-.3.3 0 .7.4 1.1.4.5 2 1.8 4.1 2.3 2 .6 2.3.6 3 2.2.8 1.7-1.1 3-4.9 3.2-3.7.1-8.7-1.4-10.3-2.3-1.6-1-2.2-1.1-2.5-.8-.3.3-.2.5.6 1.1.8.6 3.3 2.5 4.6 2.8 1.3.3 1.4 1.3 1.4 2.1 0 1 .4 2.6-3 3.5-3.3.8-7.3.2-10.9-2.4a8.3 8.3 0 0 1-2.2-2 28 28 0 0 0-.3-8c.7 0 2-.3 3.4-.9 2-.8 2.8-2.6 3.3-3.6s1.2-1 2-.8c.8.3 1.6.6 2.7.6a7.9 7.9 0 0 0 5.3-2.8c1.7-2 1.4-4 1.5-5 0-1 1.6-.3 2.4-.3.8 0 3.2-.4 5.3-1.9 2.2-1.4 2.2-3.4 2.4-4.3.2-.8 1-1.3 1.7-1.6.7-.2 1.7-.5 3.2-1.7 1.5-1.2 2-3.5 2-4.4.2-.8 1-.8 4-2.4 3-1.5 2.8-4.7 2.6-6 0-1.3-1.5-2.3-1.5-2.8s1-.6 2-1.2 3.6-1.6 3.6-5.4c0-3.7-2.4-4.1-2.4-4.1l1.5-.8c1-.6 3.7-2.5 3.7-4.7s-1-3.2-1.7-3.8c-.7-.5-2.7-1-2.7-1s1.2-.9 1.8-2.6c.5-1.7.7-3.9-.6-5.4-1.2-1.6-3.4-1.6-4.5-1.6-1.2 0-2.2.6-2.6.3-.4-.3-.4-.6 0-1.5.4-.8.4-3 .1-3.7-.3-.8-.4-2.2-3.3-3.2-2.9-.9-5.9 1-6.8 1.6-1 .5-.5-.8-.5-1.7 0-1 1.9-3.3 4.1-6.6 2.2-3.4 3.2-5.1 5.7-10.2A65.7 65.7 0 0 0 409 159c.4-1.6 1-.8 1-.8s.7.2 2.2 4.1a25 25 0 0 1 1.7 10.5z"
    />
    <path
      fill="#d4af3a"
      d="M363.4 241.4c1.7-.1 4-1 5.7-3.6 1.7-2.5 4.3-3 8.8-3 4.5.1 6.6-2 7.7-5.2 1-3-.2-6.6-4.8-8.9-4.5-2.2-6.6-4.7-6.8-8.6-.1-3.9 4.6-8.7 9.3-14.1 4.8-5.5 8.5-13.2 8.5-13.2s1.4 1.8 1.4 3.7c0 1.8-.7 3.7 0 4.2s.9-.8 3.7-2c2.7-1.2 5-1.4 6.7.6 1.7 2 0 5.4-1.6 7-1.5 1.7-2.8 3-2.4 3.5.4.6 2.8-.9 3.5-1.4.8-.5 2.6-2.5 5.3-2.3 2.7.3 3.6 1 3.9 3.3.2 2.3-2.4 4.2-4.2 5.1-1.7.9-2.4 1.6-2 2 .5.3 1 0 1.7-.3a8 8 0 0 1 4.3 0c1.4.6 3.6 2.5 1.6 4.8-2.1 2.3-6.4 3.2-7.3 3.3-.8.2-1.3 0-1.4.6 0 .7 1.8.7 4.2.8 2.3.1 3 2.4 2.7 4-.4 1.8-4.3 3.7-6.4 4-2.2.4-3 0-3.1.7-.2.6.2.8 1.4 1.2 1.2.3 3.6.6 4 2.5.4 1.9.5 2.7-1.3 4.4-1.8 1.6-4.7 1.4-5.6 1.2-.9-.2-1.9-1.1-2.8-.3-.8.9.8 1.6 2.3 2.6 1.5 1 1.4 3-1.1 4.4-2.5 1.4-5 .9-6 .5-1-.3-2.5-2-3.2-1-.7 1.1 2.2 1.5 3.4 3 1.2 1.4.8 3.8-1.6 5.3-2.5 1.5-6.4.4-7.1-.2-.7-.6-1.6-.8-2-.3-.6.5.2 1.9.7 3 .5 1.3 1.5 4.8-2.2 6.2s-6.9-1.7-7.5-2.3c-.6-.6-1.2-.7-1.7-.5-.5.3-.2.8.2 1.4.4.6 1.4 3.2-1.2 5a6.3 6.3 0 0 1-4.7 1c-.6-2-1.3-4.2-2-7.2h.5c.4 0 .5.5.5.7 0 .2-.1.4.2.4.3 0 .3.2.8.5.4.3.8.7 1 .5.3-.2-.9-.8-1.2-1.2-.3-.4-1-1-1-1.4 0-.4-.2-.6-.8-1.1a2.4 2.4 0 0 1-.5-.6 97.9 97.9 0 0 1-1.2-7.2 57.1 57.1 0 0 1-.4-5.5h1.1zm73.7-53.8c-3.9 7.8-9.3 12.1-9.3 12.1l1-3.2c.3-1.4.1-2.9.1-2.9s1.4-1.7 3.9-5.6c2.5-3.9 3.8-9.6 3.8-9.6s-2.3 5.7-4.1 8.8c-1.9 3-4 5.5-4 5.5s-.7-2.7-1.2-2.8c-.5-.2-1 .2-1.4.8-.4.6-.8.6-.8.6l1.5-2.8 1.6-2.2c1.4-2.3 4.5-6.6 6-10.9a169 169 0 0 0 5.7-18.3c.7-3.2 1.3-1.4 1.9.9.6 2.3 1.4 5.7.9 10.7a53.5 53.5 0 0 1-5.6 18.9zm-5 21a135.9 135.9 0 0 1-3.5 2.5l.5-1.7.3-2.9 2.9-2.5a41.7 41.7 0 0 0 5.6-6c2.9-3.6.5-1.4-1.9 1.2-2.3 2.6-6.9 6.3-6.9 6.3v-.8a3.1 3.1 0 0 0-.7-1.9c-.4-.6-.2-.6 2.3-2.6a73.8 73.8 0 0 0 17.6-24.4s1.5 9-4 18.7c-5.4 9.9-10.8 13-12.2 14.1zm-28.5 56.3c-3-1.2-2.2-4.1-2.2-4.1s1.8.5 3.5 1.2a36 36 0 0 0 7.5 1.8c1.6 0 1.6-.2 1.7-.4 0-.2-1.3 0-3.7-.4a29 29 0 0 1-7.2-3.1c-.7-.5-.6-.6.5-.7a4.5 4.5 0 0 0 2.3-.9c.4-.3 1.5.1 4.2.8a50.6 50.6 0 0 0 21.5.7c.7-.2 1.4.2-.7 3.7-2 3.5-9.3 5.3-14.4 5.3-5 0-10-2.8-13-3.9zm13.4-7.2c-5.2 0-7.2-1.5-7.2-1.5l.7-1.3c.7-1.1.6-2.9.6-2.9l3.4.6c2.2.3 4.7.6 7.5.1s1.6-.8-.6-.5a29 29 0 0 1-7.8-1c-1.4-.5-.9-1 0-1.3 1-.3 3.5-1.9 3.5-1.9s6.3.8 12.2.2c5.9-.7 9.6-2.2 10.8-2.4 1.1-.2 1.1.3 1.1.3s.3.6-1.7 3.7c-2 3.2-6 5.3-9.4 6.3a50.3 50.3 0 0 1-13.1 1.6zm1.3-12.2l.6-1.3c.3-1-.6-1.9-.6-1.9s1.2-.3 5-.8c4-.5 4.2-.8 6.5-1.3 2.4-.6 4-1.3 4-1.5 0-.3-.8 0-2.2.6a94 94 0 0 1-14.3 1.9c-.4-.3-2-.7-2-.7l2.4-.5a8.4 8.4 0 0 0 3.2-1.3c.7-.5 1-.6 4.1-1 3.2-.3 5.8-1.3 11.5-3.4 5.6-2 10-4.6 11-5.5 1.2-1 1.1-.3.8 1-.3 1.1-.2 2.6-3.1 6-2.9 3.3-4.3 4.8-11.5 7.4-7.3 2.7-15.4 2.3-15.4 2.3zm21.4-17.6a40.5 40.5 0 0 1-15.5 6.4c-.3-.4.4-2 0-2.8-.3-1.1-1-1.1-2.6-1.2-1.5-.1-.5-.4-.1-.4l3-.7c2.5-.7 5.1-1.1 8.6-2.4 3.6-1.4 4.6-2.3 4.5-2.6 0-.3-1.6.8-4.9 2-3.2 1.3-7 1.8-9 2.3-2.2.4-.4-.5.6-1 1-.6 2.4-2.8 2.4-2.8s2.3-.4 6-1.5a48.8 48.8 0 0 0 10-4.2l3.2-2.2 5.2-3.7c1.3-1 .9-.2.7.4s-1 3.2-3 6.1c-2 3-2.7 3.8-9 8.3zm1-12.7c-6.2 5-11.7 6.6-12.6 7-1 .4-.8-.2-.7-.7.2-.5.3-2.2.3-2.2l4.8-2.8c2.5-1.4 5.3-3.4 7.2-4.7 1.8-1.3.7-1.2.1-.7-.5.5-3.1 2-5.7 3.6l-6.4 3.9s0-.9-.6-1.4c-.5-.5-1.9-.4-1.9-.4l1-1.3c.5-.6 2.6-1.3 4.9-2.4 2.3-1 6.5-4.2 9.6-6.8 3.1-2.6 9.1-9.1 9.5-9.7.4-.5.7-.4.7.3 0 .6.3 1-.4 4s-3.4 9.4-9.7 14.3zM418.5 168c-.7 1.5-1.5 2.6-2 3.6L415 174v-1.4c.1-.8.3-2 0-3.5 0-.8-.3-1.6-.2-2.3 0-.7.3-1.4.4-1.9l1.6-7c.4-2.7.9-6.4.8-9.7 0-3.2-.5-1.6-.5 0s-.1 4-.6 7.8c-.5 3.7-2.1 9.4-2.1 9.4s-.1-.9-.6-2.1l-1.9-4.2c-.6-1.6-.4-1.9-.4-1.9s2.3-10.6 2.8-15.6c.6-5 1.6-18.1 1.6-18.1 3.2 3.2 5.6 11.8 6 20 .4 6-.6 11.7-1 14-.5 4.5-1.3 8-2.5 10.5zm7.2 16.8c0-2.4-.6-4.3-2.2-4.8 0 0 1.4-2.4 2.6-5.8a45 45 0 0 0 1.8-7.7c.9-5.6 1.6-11.5-.1-2-1.7 9.7-3.8 13-3.8 13l-2.4 4c.3-1.7.4-3 .3-4.9 0-1.9-.3-4.5-1-6.5 0 0 3-6 5-13a81.4 81.4 0 0 0 3.1-22.7s3 2.3 4 13.9a68.4 68.4 0 0 1-7.3 36.5zm-33.2 88.6l1.9-1.3c1.5-.9 1-3.7 1-3.7a48.7 48.7 0 0 0 5.2 3.2c1.4.6 2.1 1 3 1.2 1 .3.7 0 0-.5-.8-.4-1-.7-3-1.4-2-.8-5.8-4.2-5.8-4.2l2.5-.1c1.6 0 3.6-.9 3.6-.9s1.6 1.4 8 4.2a50 50 0 0 0 11.8 3.5s-.6 3.2-3.7 4.3c-2.6 1.1-6 1.8-13 .2a43.5 43.5 0 0 1-11.5-4.5zm-8.4 6.5c-.6-2.7 1-4.6 1-4.6l1.3 1.1c1 .9 2.3 2.5 5 3.9 2.7 1.3 3.7 1.2 1-.2a39.3 39.3 0 0 1-6.3-5.3l1-.4c1-.4 2.7.3 10 4.6 7.1 4.3 11.4 4.5 11.4 4.5s-3.2 3.9-12 3.6c-8.7-.3-11.9-4.5-12.4-7.2zm-16.6-3.1s1 1.3 2.3 2.2c1.3.9 4.8 1.4 4.8 1.4l.8 1.2c.6 1 2.1 3 3.7 4 1.5 1.2 4 2 4 1.6.2-.3-1.3-.8-2.8-1.8-1.5-.9-2.9-2.6-3.9-3.7-1-1.2.5-1 .5-1h3.5c1.7-.2 1.3 0 1.8.7l2.4 3 4.4 5.1c1 1.2.3 1.5.3 1.5s-.5.7-4.4 1.2c-2.4.2-5 0-7.7-1.6a23.4 23.4 0 0 1-5.2-4.5c-4.7-5.1-4.5-9.3-4.5-9.3zm-2 10.5l1.5 1.8s-.7-2-1.3-3l-.9-1.4c.7-1.4 1.2-3 1.6-4.7.4 1.4 1.7 5.5 3.4 8.1 2 3.2 3.8 4.4 2.6 5.3-1.1.8-3.4 1-6-.2-2.4-1.2-3-3.3-3.4-5a24.8 24.8 0 0 0 1.2-2.1c.3.2.8.5 1.3 1.2z"
    />
    <ellipse
      cx={-365.9}
      cy={158.6}
      fill="#d4af3a"
      rx={1.8}
      ry={1.6}
      transform="scale(-1 1)"
    />
    <path
      fill="#d4af3a"
      d="M369.7 155.5c-1.6 0-2.5-.8-4.3-.6a26 26 0 0 0-8.5 3.3 14.6 14.6 0 0 1-9.8.9c-1-.3-2-.9-2.9-1.4-4.3-2.4-3.2-7.1-3.2-7.1a16.7 16.7 0 0 0 10.6 3.2l-.9.8c-.6.6-1.7 1.4-1.4 1.7.4.3 2-1.2 3.3-2.2 1.3-1 3.2-2.2 6.5-3.2s7-1 9.4.4c2.5 1.3 2.7 3 2.4 3.7-.2.4-.7.5-1.2.5zm-46.2 34.7c.8-.2 2-.4 3.8-2a69 69 0 0 0 6.3-7c.5-.8.3-1.5-1-2-1-.5-1.9-2-1.9-2s2.5-1 4.3-2.2c1.7-1.2 5.6-4.8 6.2-5.7.5-1 .3-1-.5-1.3-.9-.3-1-.8-1-.8s1.8-1.2 3.5-2.6a71 71 0 0 0 4-3.6c2.6 1 6.6.6 8.8.2 3.8-.7 6.7-2.3 6.7-2.3l.6 1.8c.5 1.2 2.2 1.8 4 .7 1.8-1.2 1.4-3.7 1.4-3.7s1.4-1 4.4-2c3-1.1 5.3-1.3 7.7-.2 2.4 1.1 3.6 4.4 3.6 7 0 2.4-1.3 1.3-1.6 1-.3-.3-.8-2.1-3.8-2.6s-5.8 1-9.2 3.8c-3.4 2.8-4.2 3-6 4.8-1.6 1.8-.3 2.7 2.7 3.7s6.7-1 6.9-.9c.5.3-1.3 3-3.9 4-2.5 1-5.8.3-8.3-.8-1.7-.6-2 0-2.5.6a15 15 0 0 0-4 9 4 4 0 0 1-2.6-3c-.1-.6-.3-1.8-1.2-1-1 1-1.8 6-1.8 8.2s.7 5.3.7 5.3h-.7l-2.3-1.2c-1-.7-1.2 0-1.2 1.3s-.4 3.6-2 7.8c-1.7 4.2-4 5.5-4 5.5s-.5-.8-1-2.5a33 33 0 0 1-.8-7.7c0-2.8.7-8.8.7-8.8s-3.4 4.2-7 5.2-7.1.4-8.6-1.3c-1.5-1.7-.2-2.5.6-2.7z"
    />
    <path
      fill="#d4af3a"
      d="M347 201s1 2.5 1.6 3.3c.6.9.9 1 .9 1s-1.1 1-2.7 1.4a35.5 35.5 0 0 1-3 .8s1.8-2.4 2.4-4.1l.7-2.3zm-21.5-1.3a71.6 71.6 0 0 1 .9-2.1 15 15 0 0 0 8.1-1.7s-1.6 3.3-3.3 4.5l-1.8 1.2s1.6.3 3.8-2c2.2-2 3.2-4.6 3.2-4.6s-.5 5.8.4 9.3l1 4s-4.6.9-9.8-.6c-5.2-1.4-5.6-1.9-5.6-1.9s-.6-.1.2-1.2a28 28 0 0 0 3-5z"
    />
    <path
      fill="#b96b29"
      d="M335 187l1.7-2.3s.6.5 0 1.3a16 16 0 0 1-4.2 3.7c-1.6.9-3.1 1.2-3.1 1.2v-.4s4-1.7 5.5-3.5zm6.3 12l.4-8.3c0-1 .6-.8.6-.8l.8.3-1.5 10.6c-.2 1.2-.7 1-1 1 .5-.3.6-2.5.7-2.8zm9.8-31.4c.6-.6 1.9-1 .6.4-1.3 1.4-3 3.2-3.4 4.7-.5 1.4-.8 3.3 0 2.9.8-.4 1.4-.4 2.3-1.2 1-.7 2.6-2 3.3-2.1.7-.2 2 0 1 1a24.8 24.8 0 0 1-4 3.6l-4 2.6a36.9 36.9 0 0 1-2 1.3s1-6 2.6-8.5a26.3 26.3 0 0 1 3.6-4.7zm32 99.2c1.2 1 2.8 1.3 2.8 1.3s.7 0 .7.2-.9 0-1.8-.1a8 8 0 0 1-2.6-1.4c-.4-.4-1.1-.8-.9-1.4.2-.6.6.5 1.8 1.4zm-10.4 5.5l2.3 1.8 1.3.7c.6.2.8.6.8.6s-.1.2-.8 0c-.7-.2-2.8-1.7-3.5-2.3-.6-.6-1-.7-.7-1 .3-.2.4 0 .6.2zm42-74.4c-.4.4-.9 1-1 .9-.3-.2 0-.5.4-1l.8-.9 1.1-1.5c.4-.4 1-.7.3.3l-1.7 2.2zm3.1 7l-1.3 1.3c-.5.5-.9 1.1-1.2.8-.3-.3.7-.9 1.2-1.5a7.5 7.5 0 0 1 1.4-1.4 10 10 0 0 1 1.3-.8l-1.4 1.6zm-1.2 11.2c-.8.9-2 1.1-2 .8-.2-.4 0-.6.7-1a24.4 24.4 0 0 0 4.6-3c.2 0-1 1.4-1.4 1.6-.4.2-1 .8-1.9 1.6zm-2.2 9c0-.3-.1-.5.5-.5l1.6-.2s1.3-.5 1.4-.2c0 .3-1 .8-1.6.8l-1.4.4c-.3.2-.5 0-.5-.3zm-1 9.8c1.4 0 2.6-.3 2.7 0 0 .1-.7.5-1.4.7-.7.3-2 .3-3 .4-.9 0-1-.2-1-.6 0-.5 1.3-.5 2.7-.5zm-11 10.8c.1-.2.6 0 1.4 0 .8.3 2.1.5 2.8.5l2.4-.1 1 .2c0 .2-1.3.2-3 .4-1.8.2-3-.2-3.8-.3-.8-.2-1-.5-.9-.7zm-4.6 7.6a6 6 0 0 0 2.1.4l2.3.3s.7 0 .6.4c-.1.3-.4 0-1-.1h-2.4c-1.2 0-1.8-.4-2.5-.5-.7-.1-1.5-.5-1.1-1 .4-.4 1.1.2 2 .5zm-9 5.8l2.5 1.8 1.1.6c.8.4.7.6.6.8-.1.2-.6-.3-1-.5a16.4 16.4 0 0 1-2.5-1.6c-.7-.6-1.6-1-1.4-1.5.1-.4.3-.1.8.4zm14.9-74.8l-1.7 2.3c-1.6 2-.7.1-.4-.4l3.4-4.5c.8-.9 1-.5.5 0l-1.8 2.6zm3.2 9.8c-.2-.2.3-.4 1.1-1.5l2.7-3.3.6-1c.2.1-.6 1.8-1.3 2.5-.7.7-1.6 2-2.1 2.7-.5.6-.8.9-1 .6zm-4.3 18.5c0-.5 1.8-.5 2.6-.6l2.2-.5s1.6-.3 1.6 0c0 .1-.3.3-1.2.5l-3.3.8c-1 .1-1.9.3-1.9-.2zm4.3-10a15.3 15.3 0 0 1-2.5 1.7c-.6.4-1.1.8-1.4.5-.4-.4.2-.7 1.2-1.1l1.5-.9 1-.5c.5-.3 1.3-.6.2.3zm-10-6.5l1.4-1s.9-.8 1-.5c.2.3-1 1-1.5 1.6-.5.5-1.5 1.9-2 1.6-.5-.3.5-1.1 1.2-1.7zm6.6 25.7l1.5.4c.7.2.7.4-.4.4s-1.6-.3-2.7-.5-1.5-.3-1.3-.7c.1-.3.7-.2 1.2 0l1.7.4zm-1.8 9.3c.1.2-.8 0-1.4-.2-.5-.2-1.7-.9-2.4-1-.7-.3-.7-.4-.7-.8s.7 0 1.6.2c1 .3 2 1.2 2 1.2l1 .6zm-12 5.6c-.8-.5-1-.8-.7-1 .3-.3.6-.3 1.2.2a51 51 0 0 0 2 1.5l1.1.5c.5.2 1.2.7 1 1-.2.1-1.2 0-1.7-.6s-2-1-2.9-1.6zm-5.6 7.5c-.4-.3-1.4-.6-1.8-1-.5-.3-.8-1.3-.4-1.4.4-.1.6.4 1.4 1l3.5 2.4.7.3c.7.2.4.5-.2.4-.7-.1-1-.1-1.8-.7l-1.4-1zm-8.4 7.1a9.2 9.2 0 0 1-2.2-1.7c-.5-.4-1.2-1-.8-1.3.4-.3.8.1 1.4.6l2.1 2.2s.2 0 1 .7c.9.7 0 .5-.3.3a3 3 0 0 0-1.2-.8z"
    />
    <path fill="#d4af3a" d="M338.2 142.5l4-1 2.5 2-3.1 1.4z" />
    <ellipse
      cx={-330.8}
      cy={142.1}
      fill="#b96b29"
      rx={3.2}
      ry={3.1}
      transform="scale(-1 1)"
    />
    <ellipse
      cx={-330.8}
      cy={141.4}
      fill="#d4af3a"
      rx={1.9}
      ry={1.9}
      transform="scale(-1 1)"
    />
    <path
      fill="#d4af3a"
      d="M337.5 131.4c-.8.3-1.9.2-1.9.2s-.3-1.4.5-2.1l2-1.7.5-.6v2c.1.8-.3 1.9-1.1 2.2z"
    />
    <ellipse
      cx={-335.8}
      cy={133}
      fill="#d4af3a"
      rx={0.6}
      ry={0.6}
      transform="scale(-1 1)"
    />
    <path
      fill="#d4af3a"
      d="M340.2 132.4l.8.9s-.7 0-1.2.4c-.6.4-1.2.7-1.9.6a.9.9 0 0 1-.8-1c.2-.5.5-1 1.5-1.3 1-.4 1.3 0 1.6.4zm-2.2 3.7c2 .2 4.6-2 4.6-2 .3 1.8 1.4 2.7 3 3v.1s-1.7.8-3.5 1.1a7 7 0 0 1-2.5-.2 10.6 10.6 0 0 1-3-1c-1.2-.7-.9-2.6-.9-2.6s.2 1.5 2.2 1.6zm7.8-2c.8-.3 2-.9 2.6-1 .5 0 1.3 0 1.1.9 0 1-1 1.4-2 1.4s-1.5-.3-2-.6c-.6-.3-.5-.4.3-.7zm6.3-3.4c1-.7 1.7-.9 1.7-.9s.6 1.6.3 2.6-1 1.2-1.9 1.2c-.8 0-2.1-.5-1.8-1.2.4-.6.8-1 1.7-1.7z"
    />
    <ellipse
      cx={-351.3}
      cy={135.1}
      fill="#d4af3a"
      rx={0.7}
      ry={0.5}
      transform="scale(-1 1)"
    />
    <path
      fill="#d4af3a"
      d="M349.4 127.3c.5-2.7.4-5.6-2-9.3a16 16 0 0 0-7-5.1L339 111c-1.4-1.5-4.3-3.4-4.3-3.4l5.2 1.5a2.3 2.3 0 0 0 2.3 2.4c.4 0 .9-.2 1.3-.4 1 .1 4.4 2.2 5.2 2.9a2.3 2.3 0 0 0-.3 1.2 2.3 2.3 0 0 0 2.3 2.3c.3 0 .7 0 1-.2l.3.5a23.4 23.4 0 0 1 1.6 3.7c-.6.4-1 1.1-1 2 0 1.3 1 2.3 2 2.3v1.5c0 .7-.4 1.2-1.7 1.6-1.3.3-3 2.6-3 2.6-.2 0-1.1-1.6-.4-4.3z"
    />
    <path
      fill="#d4af3a"
      d="M341.3 110.3c-.4-.4-.5-1-.1-1.4.3-.3 1-.3 1.5.1s.6 1 .2 1.4c-.4.3-1 .3-1.6-.1zm8.5 5.7c-.5-.5-.6-1.3-.2-1.7.4-.4 1.2-.4 1.7.1.6.5.7 1.3.2 1.7-.4.4-1.2.4-1.7-.1z"
    />
    <ellipse
      cx={-354.8}
      cy={123.2}
      fill="#d4af3a"
      rx={1.3}
      ry={1.3}
      transform="scale(-1 1)"
    />
    <path
      fill="#d4af3a"
      d="M326.6 105c.7.2 2 .6 3.8 1.6-1.3 0-2.3.8-2.3 1.9 0 1 1.2 2.2 2.5 2.2s2.2-1.1 2.2-2.2c0-.2 0-.5-.2-.7l1.8 1.2c4.2 2.8 5.1 4.1 7.2 8 2 3.8 2.8 8 1.9 10.4-.9 2.5-4.2 3-4.2 3s.4-.3.4-.8l-.2-1.6c-.2-1 0-2.1 0-2.1s-.8-.1-1.2.4l-1.5 1.7-1.5 1.5s-.7-1-.7-2.1.8-2.3 1-4.3c0-2-1-5.5-2.9-8a22 22 0 0 0-6.6-5.5 2.1 2.1 0 0 1-1.3-1.7l-.2-2c-.1-1.2 1-1.1 2-.9z"
    />
    <path
      fill="#d4af3a"
      d="M330.8 109.5c-.8 0-1.4-.7-1.4-1.3 0-.6.5-1 1.3-1 .7 0 1.3.4 1.3 1s-.5 1.3-1.2 1.3zm-6.2 24.4c-1 .4-2.2.1-2.7-.2-.5-.4-.7-1.3 0-1.8a2 2 0 0 1 2-.2l2 1.3s-.3.5-1.3.9z"
    />
    <path
      fill="#d4af3a"
      d="M321.4 135c.3.6.6.9 1.7 1 1.1 0 2.3 0 3-.8a7.7 7.7 0 0 0 1.3-1.7h1.3s.4 1.7 1 2.1c.5.5 2.4.6 3.3 0 .8-.7 1.6-1.4 1.7-1.3.2 0 0 .7-.8 1.4s-1.5 1.3-3 1.3H323s-1.6 0-2-1c-.5-.9-.6-1.5-.3-1.7.2-.3.3.1.7.7z"
    />
    <path
      fill="#d4af3a"
      d="M333.5 133.7c-1.2.6-1.9.2-2.3-.3l-.5-.8 1.7-.7c.5-.4.9-.7 1.5-.6l.6.1s.2 1.6-1 2.2z"
    />
    <ellipse
      cx={-339.3}
      cy={121.9}
      fill="#b96b29"
      rx={2.7}
      ry={2.6}
      transform="scale(-1 1)"
    />
    <path
      fill="#b96b29"
      d="M334.7 112.7c1-.7 2.6-.4 3.5.6.8 1.1.7 2.6-.4 3.3-1 .7-2.6.4-3.5-.6-.9-1.1-.7-2.6.4-3.3z"
    />
    <ellipse
      cx={-339.4}
      cy={121.5}
      fill="#d4af3a"
      rx={1.6}
      ry={1.5}
      transform="scale(-1 1)"
    />
    <path
      fill="#d4af3a"
      d="M335.8 113c.7-.2 1.5.2 1.9.8.3.6 0 1.2-1 1.4-1.7.3-2.5-1.8-1-2.2z"
    />
  </svg>
	),
	MF: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#00267f" d="M0 0h213.3v480H0z" />
      <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	MG: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#ff3319" d="M213.3 0H640v240H213.3z" />
      <path fill="#00cc28" d="M213.3 240H640v240H213.3z" />
      <path fill="#fff" d="M0 0h213.3v480H0z" />
    </g>
  </svg>
	),
	MH: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#3b5aa3" d="M0 0h639.9v480H0z" />
      <path fill="#e2ae57" d="M0 467L639.9 0v87L0 480v-13z" />
      <path
        fill="#fff"
        d="M22.4 480L640 179.2l-.1-95.5L0 480h22.4zm153-464.8L169 118l-27-65.6 10.4 69.8-41.9-56.4 27.5 64.3-55-42.6 42.8 53.6-62.1-27.6 54.4 41.2-67.7-9 64 25.4L14 180.3l100.6 6.7-63.7 26.2 67-9-54.3 40 63-27.6-43 54 54.6-41.3-27 62.9 43.6-54.7-11.8 68.1 27.5-63.7 6.2 100.7 9.7-100.4 23.7 64-9-69 43.4 54.8-28.6-64 54.6 44-43.4-54.9 64.9 27-57.4-41.9 69.9 11.8-67-25.7 104.1-6.5-104-9.7 68.5-22.8-71 9 58.6-41-66 26.5 45.6-55.3-55.6 43.4 26.7-66.4-43.1 56.4 9.3-70.4-25.7 66.5-9.6-102.8z"
      />
    </g>
  </svg>
	),
	MK: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#d20000" d="M0 0h640v480H0z" />
    <path
      fill="#ffe600"
      d="M0 0h96l224 231.4L544 0h96L0 480h96l224-231.4L544 480h96zm640 192v96L0 192v96zM280 0l40 205.7L360 0zm0 480l40-205.7L360 480z"
    />
    <circle
      cx={320}
      cy={240}
      r={77.1}
      fill="#ffe600"
      stroke="#d20000"
      strokeWidth={17.1}
    />
  </svg>
	),
	ML: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="red" d="M425.8 0H640v480H425.7z" />
      <path fill="#009a00" d="M0 0h212.9v480H0z" />
      <path fill="#ff0" d="M212.9 0h214v480h-214z" />
    </g>
  </svg>
	),
	MM: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <path
        id="prefix__a"
        fill="#fff"
        d="M0-.5l.2.5h-.4z"
        transform="scale(8.844)"
      />
      <g id="prefix__b">
        <use
          width={18}
          height={12}
          transform="rotate(-144)"
          xlinkHref="#prefix__a"
        />
        <use
          width={18}
          height={12}
          transform="rotate(-72)"
          xlinkHref="#prefix__a"
        />
        <use width={18} height={12} xlinkHref="#prefix__a" />
        <use
          width={18}
          height={12}
          transform="rotate(72)"
          xlinkHref="#prefix__a"
        />
        <use
          width={18}
          height={12}
          transform="rotate(144)"
          xlinkHref="#prefix__a"
        />
      </g>
    </defs>
    <path fill="#fecb00" d="M0-.1h640V160H0z" />
    <path fill="#ea2839" d="M0 320h640v160H0z" />
    <path fill="#34b233" d="M0 160h640v160H0z" />
    <use
      width={18}
      height={12}
      x={9}
      y={6.4}
      transform="matrix(40 0 0 40 -40 0)"
      xlinkHref="#prefix__b"
    />
  </svg>
	),
	MN: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#c4272f" d="M0 0h640v480H0z" />
    <path fill="#015197" d="M213.3 0h213.4v480H213.3z" />
    <circle cx={107} cy={189.1} r={35} fill="#f9cf02" />
    <circle cx={107} cy={173.2} r={38.2} fill="#c4272f" />
    <path
      fill="#f9cf02"
      fillRule="evenodd"
      d="M91.1 131.8a15.9 15.9 0 0 0 31.8 0c0-6.3-4-7.2-4-9.5 0-2.4 2.4-5.6-2.4-9.6 2.4 4-1.6 4.8-1.6 8.8 0 4 1.6 4 1.6 7.1a3.2 3.2 0 0 1-6.3 0c0-3.1 3.1-6.3 3.1-11 0-4.9-.7-6.5-3.1-10.4-2.4-4-6.4-7.2-3.2-10.4-4.8 1.6-2.4 8-2.4 12s-3.2 6.3-3.2 11 2.4 5.7 2.4 8.8a3.2 3.2 0 0 1-6.3 0c0-3.1 1.6-3.1 1.6-7.1s-4-4.8-1.6-8.8c-4.8 4-2.4 7.2-2.4 9.6 0 2.4-4 3.1-4 9.5z"
    />
    <circle cx={107} cy={179.5} r={25.4} fill="#f9cf02" />
    <path
      fill="#f9cf02"
      d="M37 230.4v152.7h31.8V230.4zm108.2 0v152.7H177V230.4zm-70 25.5v12.7h63.6v-12.7zm0 89v12.8h63.6V345zm0-114.5h63.6L107 249.5zm0 133.7h63.6L107 383z"
    />
    <circle
      cx={107}
      cy={306.8}
      r={33.7}
      fill="#f9cf02"
      stroke="#c4272f"
      strokeWidth={3.8}
    />
    <path
      fill="none"
      stroke="#c4272f"
      strokeWidth={3.8}
      d="M107 273a16.9 16.9 0 0 1 0 33.8 16.9 16.9 0 1 0 0 33.7"
    />
    <circle cx={107} cy={289.9} r={6.4} fill="#c4272f" />
    <circle cx={107} cy={323.6} r={6.4} fill="#c4272f" />
  </svg>
	),
	MO: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#00785e" d="M0 0h640v480H0z" />
    <path
      fill="#fbd116"
      d="M295 108.7l40.5 29.5L320 90.5l-15.5 47.7 40.6-29.5z"
    />
    <g id="prefix__a">
      <path
        fill="#fff"
        d="M320 331.6H217.5a146.3 146.3 0 0 1-3.8-4H320a2.1 2.1 0 0 1 1.4 2c0 .8-.5 1.7-1.4 2zm0-31.3a13 13 0 0 0 1.2-7.6 12.4 12.4 0 0 0-1.2-3.8 82 82 0 0 1-32.5 19 81 81 0 0 1-23.5 3.5h-63.1a144.4 144.4 0 0 0 5.8 8h61c20 0 38.2-7.2 52.3-19.1zm-109.6-24.7a32.3 32.3 0 0 1-9.7 2 81 81 0 0 0 60.8 27.5 80.9 80.9 0 0 0 58.5-25 441 441 0 0 0 4.5-58.8 441 441 0 0 0-4.5-67.7c-6.6 6-19 18.7-24.8 38.3A81 81 0 0 0 292 215a80.7 80.7 0 0 0 13.7 45 80.7 80.7 0 0 1-17-49.5c0-12.4 2.8-24.2 7.8-34.7a32.5 32.5 0 0 1-7.5-13 80.7 80.7 0 0 0-10.5 40c0 18 5.9 34.7 15.9 48.1a95 95 0 0 0-73.4-29.4 32.6 32.6 0 0 1 6.8 8.9 95 95 0 0 1 68.6 29.4 95 95 0 0 0-61-22.2 95 95 0 0 0-36.7 7.3 81.2 81.2 0 0 0 82.6 52.2c-4.7.8-9.5 1.3-14.4 1.3a80.8 80.8 0 0 1-56.4-22.8zM320 364.4h-53.1a143.5 143.5 0 0 0 53.1 10.1 11 11 0 0 0 1.3-5 11 11 0 0 0-1.3-5.1zm0-24.5h-93.6a143.8 143.8 0 0 0 7.8 6.2H320a4.6 4.6 0 0 0 1.3-3.1 4 4 0 0 0-1.3-3.1zm0 12.5h-76.7a143.6 143.6 0 0 0 14.4 8H320a7.6 7.6 0 0 0 1.2-4.2 7.5 7.5 0 0 0-1.2-3.8z"
      />
      <path
        fill="#fbd116"
        d="M200.5 174.8l25.4 23.6-6.7-34-14.6 31.4 30.3-16.8zm36.9-32l34.7.6-27.7-21 10.1 33.3 11.3-32.9z"
      />
    </g>
    <use
      width="100%"
      height="100%"
      transform="matrix(-1 0 0 1 640 0)"
      xlinkHref="#prefix__a"
    />
  </svg>
	),
	MP: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h640v480H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)">
      <path fill="#0071bc" fillRule="evenodd" d="M-160 0h960v480h-960z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={1.9}
        d="M370 365.7s15.2-16.1 29.8-13c4.4-17 21-18.4 21-18.4s-1.7-18.7 19.5-22.8c.6-12.7 13.5-23.3 13.5-23.3s-2.6-19.7 10.8-24.3c-8.2-15.6 2.8-27 2.7-27.3-.2-.3-14-24.8-1.6-31.8-13-11-8.8-23.4-8.8-23.4s-14.2-3.7-9.1-20.7c-11.7-2-14-20.9-14-20.9s-18 3.7-20.2-12c-12 1.9-13.2-9.8-13.4-9.8-.1 0-23.5 6.3-28.2-11.4-9.1 4.7-13-3.7-13-3.7s-13 6.5-20.8-6c-15.5 9.7-24.2-.4-24.2-.4s-20.3 13.4-27 3c-12 12.2-22.8 7-22.8 7s-9 16-23.7 12c-3.3 14.9-20.2 15.2-20.2 15.2s1.8 13.1-18.4 16.7c-2.6 15.5-13.2 18-13.2 18s1 15.2-8.5 20c3.4 8.5-5.4 18.9-5.4 18.9s9.4 11.7-3.4 24.9c12.3 3.2 3.4 24.4 3.4 24.4s17 7.6 6.3 21.7c12.2 4 8.4 13.6 8.5 19.3 7.8 3.5 14.6 1.8 11.3 17.4 23.8 2.7 12.6 15.8 12.6 15.8s11 .5 6.7 9.3c20.3-.5 23.3 15.2 23.3 15.2s18.8-5 21.3 2.3-8.2 56.7-8.2 56.7-16 0-27.8-12.8c-27.8-.7-21.6-19-22-19-.5 0-9.3 3.4-13.8-11.9-18.6 3.8-18-11.8-18.2-12-.1-.1-8.3-3.8-5.3-11.5-19.1 1.7-17.7-17-17.7-17-4.2-1.7-5.7-5.6-5.1-9.5-2.5-.9-19.5-1.2-10.7-23.6-16.2-9.8-6.1-21-6.1-21s-22.4-11.6-5.1-25c-13-19 1-28.5 1-28.5s-17.9-18.1.3-31c-3-27.5 13.4-34.1 13.4-34.1s-8.6-22.4 14.8-31.8c1.5-22.7 17.9-23.3 17.9-23.3s.4-18 26.2-16.2c5-16.1 22.5-12.9 22.5-12.9s5.4-19.5 29.3-10.1c12.1-23.7 30.2-11.6 30.2-11.6s11.4-7.4 17-5c7.3-12.5 22.8-.6 32.7 1.9 3.7-1.5 16.6-11.2 26.5 1 13.2-8.5 24.5 7 24.5 7s18.1-9.2 26.6 11.8c38.5-3.5 33 21.7 33 21.7s30.2-6.9 23.6 23.3c27.6 1.9 24.8 20 24.8 20s17.4 13.2 9.8 25c15.5.8 9.8 15.7 9.8 15.7s11.9 4.6 2 23c22.7 18.1 4.4 36.2 4.3 36-.2-.1 12.1 14.6 1 31.6 3.4 27-10.2 33.8-10.2 33.8s3.5 17.5-11.7 22.4c-.3 20.5-19.7 23-19.7 23s5.2 9-14 18.3c-.8 13.7-20.8 14.8-20.8 14.8s-1.9 25.2-27.4 18.4c-6.1 20.2-36 14.2-36.6 14-.5-.3-5.7-43.4-5.7-43.5z"
      />
      <path
        fill="#217900"
        fillRule="evenodd"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={1.9}
        d="M185 124s6.4 5.6 5.2 14c-1.2 8.3-6 19.9-5 28.5.6 3.5.3 9.7.3 9.7s-5.7-8.2-5.8-17 6.2-17.1 6.2-23.6-1.1-11.7-1-11.5zm-3.2 2.6s-8.4 8-9.5 15.7c-.8 4-1 22.7-1.2 31-.2 2.5-1.2 12.5-1.4 16.2-.3 3.6 6.1-6.2 6.5-14.3-.2-8.3-.2-25.8.6-28.5.8-3.4.6-7.1 1.8-10.5l3.2-9.6z"
      />
      <g fill="#ffd200" fillRule="evenodd" stroke="#ef8a10">
        <path
          strokeWidth={1.9}
          d="M366 100.5s10.8-5 14-14.4-9.5-9.4-11.1-6.4c-1.7 3 1.4 10.3.6 12.3-.8 2-5.2 6.6-3.5 8.4z"
        />
        <path
          strokeWidth={2.5}
          d="M269.8 103.9s7-9.7 5.2-19.4c-1.9-9.6-12.8-3.6-12.8-.2s6.2 8.3 6.5 10.4c.3 2.1-1.3 8.4 1 9.1zm-19.1 5.7s7-9.7 5.2-19.3c-1.8-9.7-12.8-3.7-12.8-.3 0 3.4 6.3 8.4 6.6 10.5.2 2-1.3 8.3 1 9.1zm-21.1 6.5s7-9.6 5.2-19.3c-1.9-9.7-12.8-3.7-12.8-.3 0 3.4 6.2 8.4 6.5 10.5.3 2-1.3 8.3 1 9.1zm-15 14.9s7.1-9.7 5.3-19.3c-1.8-9.7-12.8-3.7-12.8-.3 0 3.4 6.3 8.4 6.5 10.5.3 2-1.3 8.3 1 9.1zM199 145.4s7-9.7 5.2-19.4-12.8-3.6-12.8-.2 6.3 8.3 6.6 10.4c.2 2.1-1.3 8.4 1 9.2z"
        />
        <path
          strokeWidth={1.9}
          d="M235 61.7s-9.4 7.4-10.2 17.2c-.8 9.8 11.3 7 12.2 3.7 1-3.3-3.7-9.7-3.4-11.8.3-2 3.5-7.7 1.4-9zm31.3-9.6s-9.3 7.4-10.2 17.2c-.8 9.8 11.3 7 12.3 3.7.9-3.3-3.8-9.8-3.5-11.9.3-2 3.5-7.7 1.4-9zm-116.7 84.5s2 11.8 10.2 17.3c8.2 5.4 11.5-6.6 9.1-9s-10.3-1.4-12-2.6c-1.7-1.3-5-6.8-7.3-5.7zm-15.6 40s0 12 7.3 18.7c7.2 6.6 12.4-4.7 10.4-7.4s-10-3-11.4-4.5c-1.5-1.6-4-7.5-6.3-6.7zm36 44.8s-4.2-11.2-13.3-15c-9.1-3.6-10 8.8-7.2 10.7 2.9 1.8 10.4-.7 12.3.2 2 .9 6.3 5.6 8.3 4zm-7.4-19.4s7.2-9.5 5.6-19.1c-1.7-9.7-12.7-4-12.8-.6 0 3.4 6 8.5 6.3 10.6.2 2.1-1.5 8.3.9 9.2zm225.6-91.9s10.8-5 14-14.3-9.5-9.4-11.1-6.5c-1.7 3 1.4 10.4.6 12.3-.8 2-5.2 6.7-3.5 8.5zm32.8 16.4s6.4-10.1 3.9-19.6c-2.5-9.5-13-2.8-12.8.6.2 3.3 6.8 7.9 7.2 10 .4 2-.7 8.4 1.7 9zm89.6 93s-4.3-11.1-13.4-14.9c-9.1-3.7-10 8.8-7.2 10.6 2.9 1.9 10.5-.7 12.3.2 2 1 6.3 5.7 8.3 4.1zm-43.8 7s.2-12 7.5-18.6c7.3-6.6 12.4 4.9 10.4 7.6-2.1 2.7-10 2.8-11.6 4.3-1.4 1.5-4 7.4-6.3 6.6zm-7-126.8s-11.3-4.3-20 0c-9 4.4-.2 13.4 3 12.5 3.3-1 6.4-8.3 8.4-9.1 2-.8 8.4-1 8.5-3.4zM434 78.3s-11.1-4.3-20 0c-8.8 4.4-.1 13.4 3.2 12.5 3.2-1 6.4-8.3 8.3-9.1 2-.8 8.4-1 8.5-3.4zm-38-20.4s-9.5 7.3-10.4 17c-1 9.8 11.2 7.1 12.2 3.9 1-3.3-3.7-9.8-3.4-11.9.4-2 3.6-7.6 1.6-9zm-24.8-6s-4.4 11.1-.1 20c4.3 8.9 13.3.2 12.4-3-.9-3.3-8.2-6.5-9-8.4-.8-2-.9-8.5-3.3-8.6zm-70.5 43s7.7-9.2 6.6-19c-1.1-9.7-12.5-4.5-12.7-1.1-.3 3.4 5.6 8.8 5.7 10.9.1 2-1.9 8.2.4 9.1z"
        />
      </g>
      <path
        fill="#8c8a8c"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={1.9}
        d="M342.8 114.4s18.5 1.2 19.4 11.8-4.4 17.1-4.4 17.1 2.3 23-15.8 29.7c-19.4 2.3-49.9.5-49.9.5s-9 2.2-12.6-16.3a305 305 0 0 1-4.6-31.6s1.8-10.4 14.9-11c13-.7 52.8 0 53-.2z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeWidth={1.9}
        d="M357.7 143.2s-10 12.4-9 17.5"
      />
      <path
        fill="#8c8a8c"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={1.9}
        d="M344.3 172.3c2.5 2.1 4.8 4.4 5.3 12l1 15.4 13 116.6 11.4 84.3.8 13s-2.7 9.7-10.4 10.5c-5.5 11.6-35.7 15-38.7 14.9-2.7-.2-12.3-4.2-18.1-3.7-5.9.5-16 4.4-20.5 3.8-4.5-.7-14.8-4.2-16.6-11.6-12.7-4-14.7-13.7-14.7-13.7l13.7-97.5 13.3-123.4s1.6-16.4 8.2-18.9c6.9-.6 42.4.7 52.3-1.7z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.9}
        d="M274.4 341.1l-2.7 86.3m86.5-74.9l7.6 71.2"
      />
      <path fill="none" stroke="#000" d="M136.6 296.3l-.3 1m358.7-4.1l.3 1" />
      <path
        fill="none"
        stroke="#6b18b5"
        strokeLinejoin="round"
        strokeWidth={1.9}
        d="M127 179.8s5.6 7.9 6.7 12.4c1 4.5 2.9 13.4 5.3 17 2.5 3.7 16.6 23.9 17.4 32.3.1 5.6-5.9 15-14.7 15.2-5.6-.2-19.8-3.8-20.4-16-.6-12.3 4.3-12.5 5-20 .5-7.4.7-40.7.7-40.9z"
      />
      <path
        fill="none"
        stroke="#6b18b5"
        strokeLinejoin="round"
        d="M224.5 72.8s-6 .4-10.4 2.9c-3.5 2.1-9.5 5.3-13.6 11-10.6 8.2-26.5 12-31.5 19-3 4.6-2.8 15.7 4.7 20.5 4.8 2.7 19 7 25.8-3.1 6.8-10.2 2.7-13 6-19.6a117.4 117.4 0 0 1 19-30.7zM367 58s-4.4-4-9.3-5.5c-4-1-10.6-.6-17.5-1.3-13.3-1.8-27-11.4-35.3-10.2-5.4 1-13.3 9-11.5 17.6 1.3 5.4 7.3 16.2 19.4 14.1 12-2.1 12-4.8 19-7 17.4-9.7 35-7.7 35.2-7.7zm141.4 137.4c1-2.3-.9-6.6-2.2-11.5-1.2-4-3.1-10-7.7-15.5-5.4-12.2-4.5-29-10-35.4-3.7-4-14.6-6.6-21-.4-3.9 4-11.4 16.6-3.2 25.7 8.2 9 11.8 5.7 17.4 10.5 13.5 9 20 25 26.7 26.6zM503.5 302c1.9-2.5 5.2-7.4 4.8-11.5-.3-3.2 1.5-13 1.7-17.3 1.2-13.3 9.5-24.2 7.2-35.7-1.3-5.4-9.2-13-17.8-10.8-5.2 1.6-17 8-14.3 20 2.7 12 6.6 11.7 9.1 18.7 7.3 14.5 2.7 31.7 9.3 36.6z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.9}
        d="M405.5 386.8s-2.3 4.4 6.8 8.2m11.3-18.4s10-2.5 16.8 0m13.2-25.4c0 .2-1.4 4.5 6.6 10.8m-.8-22s5.9 4.3 15.8 4m-75.4 8.6s.3 11.5-5.6 16.8m25.4-34.5s9.7 2.4 17.7-1.6m44.6-15.3s2.1 3 12.9 2.5m-54.9-9.3c.3.2 12.7 4.2 20.5.6m4.2-47.8s.5-.7 4.3 12.7m5.2-50.4s-.5 7.1-6.2 10.2m42.9-39.4s-8.4 6.8-6.8 9.5m-34.7-14.4s4.3 7.3-2.8 12.3M448.2 161s7.5-.3 10.8 6.1m-24.8-27.3h5.7m24-26c0 .1 1.5 1.5-1.4 4.5m-52-3.8s4 6.2 3.3 13.9m19.8-35.1c1.8-.2 7.7-2.8 7.7-2.8m-33.4-22c-.1 0-2.2 7.7 1.6 10.5m-11.1 25c0 8.4 6.6 6.3 2 14.3M382.2 97a57 57 0 0 0-10.4 9.4m-16.4-13.7s4.4 4.3 3.3 10.2m-16-13.7s-2.2 6.6-5.1 8.3m-18-10c-.1.3-3.6 7.8-6 9.1m-25.6-9c.2 0 3.5 7-.8 12m-6.5-48c.2.2.7 5.4-2.6 10m-28.7 1.9c0 .1 1.4 5.9-7.8 7.8m-9.9 45.2c.2.3 8.9 1.7 8.9 1.7M210 136.6c.2-.2 10.6-3.3 10.6-3.3m-27.4 16.3c.3 0 7.3 1.3 9 .4m-14 6s2.3 1.3.4 13m-34.2-43.5l4.2 6.2m-18.5 26c0-.2 4.2 6.2 9.8 7.4m23 25.2a49 49 0 0 0 8-2M170 213.8c.2 0-.1-4.3 5.2-7.3M163 224.7c0 .2 5 6.4 8.5 7.3m-11.5 4.7c.6-.2 6-4.9 12.2-4.5m-13.9 20.6s.2 5.4 16.2 4m-14.6 15c0-.2 4.7-10.8 14.2-14.8m-1.4 28.4s1.4-4.6 9.4-7.7m-.5 25.5s5.7-4.7 7.8-5.3m-.7 19.3s3.5 3.6 12.2-2.7m-54 5.6c1-.2 13.7-3.1 18 3.5m-13 7s13.4-1.8 15.1-.4m32.7 3.1s-1.8 3.7 14.7-2.4m5.8 9c-3 5 .7 9-3.2 11.3m-47-4.3c.5-.4 6-2.3 5.2-10.3m-.2 22.3c.7-.2 9.9-4.2 11.8-2.1m6.3 13.7s1.2-8.2 3.8-9m10 21.3s7.7-.1 11-2.6m3.8-25c.2.2 7.1 3.8 22 .2m-16.4 33s2 10.6 2 13"
      />
      <g fill="#de2010" fillRule="evenodd" stroke="#000" strokeWidth={1.5}>
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(1.60885 -.2011 .2072 1.65762 94.8 75)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(1.60885 -.2011 .2072 1.65762 93.4 57.3)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(1.58497 -.3417 .35206 1.633 78 74)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(1.4455 -.73446 .7567 1.4893 55.9 163)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(1.4455 -.73446 .7567 1.4893 48.9 147.1)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(1.3781 -.85423 .88011 1.41987 40 167.4)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(1.28907 -.98346 1.01327 1.32812 33.8 193)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(1.1329 -1.15994 1.19508 1.16722 35.3 239)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(1.02138 -1.25922 1.29739 1.05234 34.3 262.7)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(.79817 -1.41132 1.45408 .82236 51.9 315)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(.66642 -1.4781 1.52289 .6866 56.8 337.4)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(.56582 -1.51945 1.5655 .58296 57.9 352.4)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(.4482 -1.5582 1.60543 .46178 63 370.4)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(.20288 -1.60864 1.65738 .20903 94.7 408.9)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(.06506 -1.62008 1.66918 .06703 106.3 427.4)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(.06506 -1.62008 1.66918 .06703 88.8 428)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(-.36132 -1.5806 1.62852 -.37226 172.5 473.5)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(-.49045 -1.54542 1.59227 -.50531 188.3 485.8)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(-.67103 -1.476 1.52073 -.69138 221.9 499.1)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(-.7945 -1.41337 1.4562 -.81858 241.4 508.3)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(-.94339 -1.31867 1.35863 -.97197 271.6 515.4)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(-1.05159 -1.2341 1.27151 -1.08344 292.4 520.2)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(-1.13737 -1.15553 1.19056 -1.17183 308.9 526.1)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(-1.2301 -1.05628 1.08829 -1.26738 331.4 529.6)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(-1.33573 -.91908 .94693 -1.3762 362.5 526.1)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(-1.47374 -.67597 .69645 -1.51841 415.9 504)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(-1.52895 -.53958 .55593 -1.5753 438.7 497.5)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(-1.61445 -.12005 .15429 -1.33344 500.5 406)"
        />
        <path
          d="M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z"
          transform="matrix(-1.58082 -.36035 .37125 -1.62873 468.4 480.8)"
        />
      </g>
      <path
        fill="#ffe300"
        fillRule="evenodd"
        d="M480 194.7c2.2-2.3 4.2-3 6.7-2.1-1-6.1-2.8-8.2-5.2-7.4-2.3.7-3.4 3.8-1.5 9.5zm3.3 18.2c2.3-2.1 4.3-2.6 6.8-1.6-.4-6-2.2-8.3-4.6-7.7-2.4.5-3.6 3.6-2.2 9.3zm-7.8-35c1.5-2.7 3.3-3.8 6-3.7-2.5-5.6-4.8-7.1-7-5.8-2 1.3-2.2 4.6 1 9.6zm-8.1-16.6c1.5-2.8 3.3-3.9 6-3.7-2.5-5.7-4.9-7.2-7-5.9-2 1.3-2.2 4.6 1 9.6zm-19.5-30.5c1-3 2.6-4.4 5.2-4.6-3.3-5.2-5.9-6.3-7.7-4.7s-1.5 5 2.5 9.3zM435 117.5c1-3 2.4-4.4 5-4.8-3.4-5-6-6-7.8-4.4-1.8 1.7-1.4 5 2.8 9.2zM408.3 95c0-3.2 1-5 3.3-6.2-4.8-3.7-7.7-3.8-8.8-1.7s.2 5.1 5.5 7.9zm14 10.5c.4-3.1 1.7-4.8 4.3-5.5-4.2-4.5-6.9-5.2-8.4-3.3-1.5 2-.7 5.1 4 8.8zm-30-19.3c-.3-3.1.5-5 2.7-6.5-5.2-3.2-8-3-9-.8-.9 2.3.8 5.1 6.4 7.3zM376.2 79c-.8-3-.3-5 1.7-6.8-5.6-2.4-8.4-1.9-9 .5-.6 2.4 1.5 4.9 7.3 6.3zm-17.5-5.4c-1.1-3-.8-5 1.1-7-5.8-1.9-8.5-1.1-9 1.3-.3 2.4 2 4.8 7.9 5.7zm-17.3-3.4c-1.2-2.8-1-5 .7-7-6-1.5-8.6-.5-8.8 2-.3 2.4 2.2 4.6 8.1 5zm-18.2-1.4c-1.6-2.7-1.6-4.8 0-7-6.1-.9-8.7.4-8.6 2.8 0 2.5 2.7 4.4 8.6 4.2zm-35.7 2.7c-2.2-2.2-2.7-4.3-1.8-6.8-6 .6-8.2 2.4-7.6 4.8.6 2.4 3.7 3.6 9.4 2zm17.6-2.3c-1.9-2.5-2.2-4.6-.9-7-6.1-.2-8.5 1.3-8.2 3.8.3 2.4 3.2 4 9 3.2zm-34.9 6c-2.4-1.9-3.3-3.8-2.7-6.4-6 1.5-7.8 3.6-6.9 5.8 1 2.3 4.2 3 9.6.6zm-33 15.2c-2.8-1.4-4-3.1-3.9-5.8-5.6 2.6-7 5-5.6 7 1.3 2 4.6 2.2 9.5-1.2zm16-8.1c-2.7-1.7-3.6-3.6-3.2-6.2-5.9 1.8-7.6 4-6.5 6.2 1.1 2.2 4.4 2.8 9.6 0zm-45.6 28.8c-3-.8-4.6-2.3-5-5-5 3.8-5.8 6.4-4.1 8.1 1.8 1.7 5 1.2 9-3.1zm14.1-11.6c-3-1-4.4-2.6-4.6-5.2-5.2 3.2-6.3 5.8-4.7 7.7 1.6 1.8 5 1.5 9.3-2.5zm-26.7 24c-3-.6-4.7-1.9-5.4-4.5-4.6 4.1-5.2 6.9-3.3 8.4 1.9 1.6 5 .7 8.7-4zM183.7 138c-3.2-.2-5-1.3-5.8-3.8-4.2 4.5-4.6 7.2-2.6 8.6 2 1.4 5.1.2 8.4-4.8zm-9.4 15c-3.2.2-5-.7-6.4-3-3.4 5.1-3.4 8-1.2 9s5.1-.6 7.6-6zm-8.3 16c-3 .6-5 0-6.7-2.2-2.7 5.5-2.3 8.3 0 9 2.3.8 5-1.2 6.7-6.9zm-6.6 16.3c-3 1.1-5 .8-7-1-1.8 5.8-1 8.5 1.5 8.9 2.4.3 4.7-2 5.5-8zm-4.5 18.2c-2.8 1.3-4.9 1.2-7-.5-1.4 6-.4 8.5 2 8.7 2.5.3 4.7-2.2 5-8.2zm-1.8 15.2c-2.6 1.4-4.7 1.6-7 .5-.7 4.9.6 6.8 3 6.6 2.4-.2 4.3-2.4 4-7.1zm307-72.2c1.1-3 2.7-4.4 5.3-4.6-3.2-5.2-5.7-6.3-7.6-4.8-1.9 1.6-1.6 5 2.3 9.4zm25.2 85c2.3-2.2 4.4-2.7 6.8-1.6-.4-6.1-2.2-8.3-4.6-7.8-2.3.6-3.6 3.6-2.2 9.4z"
      />
      <path
        fill="#217900"
        fillRule="evenodd"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={1.9}
        d="M461.3 132s-7 6.9-5.7 15.2c1.2 8.3 6.5 18.6 5.5 27.3-1 8.6-2.5 14.3-2.5 14.3s8-9.1 8-18c.2-8.7-5.4-20.3-5.4-26.7s.3-12.2.1-12zm12.7 28s-5.3 4-4.8 13c.5 9.1 10 25.8 10 25.8s6.8 14 6.5 17.7c-.2 3.7 1.3-3.5.6-11.5s-11-25.8-11-25.8-2.2-3.6-2-9.7c.2-6 .8-9.4.8-9.5z"
      />
      <path
        fill="#6b18b5"
        fillRule="evenodd"
        d="M313 47.4c0-1.8-2.2-3.4-4.8-3.4s-4.7 1.6-4.7 3.4 2 3.4 4.7 3.4 4.7-1.5 4.7-3.4zm2 8c0-1.8-2.2-3.3-5-3.3-2.6 0-4.8 1.4-4.8 3.2s2.2 3.3 4.9 3.3 4.8-1.5 4.8-3.3zm6-9.4s-5.6 4.1-3.3 5.8c2.3 1.7 8.6-3.6 8.6-3.6L321 46zm163.3 95.4c0-1.2-.5-2.3-1.4-2.9a2.6 2.6 0 0 0-3 0c-.9.6-1.4 1.7-1.4 2.9s.5 2.3 1.4 2.9a2.6 2.6 0 0 0 3 0c.9-.6 1.4-1.7 1.4-2.9zm-2.1-8c0-2-1.4-3.5-3-3.5s-3.1 1.6-3.1 3.6 1.4 3.5 3 3.5 3.1-1.6 3.1-3.5zm1.5 16.2c0-1-.6-1.8-1.2-1.8s-1.2.8-1.2 1.8.5 1.9 1.2 1.9 1.2-.9 1.2-1.9zm4.9-14.4c0-1.2-.6-2.1-1.2-2.1-.7 0-1.2.9-1.2 2s.5 2.2 1.2 2.2c.6 0 1.2-1 1.2-2.1zm-13.4 1.4c0-1-.6-1.7-1.2-1.7s-1.2.8-1.2 1.7.5 1.8 1.2 1.8 1.2-.8 1.2-1.8zm2.1 11.4c0-1.5-1.1-2.7-2.5-2.7s-2.5 1.2-2.5 2.7c0 1.6 1 2.8 2.5 2.8s2.5-1.2 2.5-2.8zm-6.6-5c0-1.3-1-2.4-2.1-2.4-1.2 0-2.2 1-2.2 2.4s1 2.4 2.2 2.4c1.1 0 2-1 2-2.4zm-1-6.8a2 2 0 0 0-1-1.7 1.8 1.8 0 0 0-1.9 0 2 2 0 0 0-.9 1.7 2 2 0 0 0 1 1.8 1.8 1.8 0 0 0 1.8 0c.6-.4 1-1 1-1.8zm30.1 34.4c-2.7-3.6-7.1-5.1-9.8-3.4-2.6 1.7-2.6 6 .2 9.7 2.7 3.6 7 5.1 9.7 3.4 2.7-1.8 2.7-6 0-9.7zm7.8 66.7c.5-4.5-1.6-8.4-4.8-8.8-3.2-.3-6.2 3-6.8 7.4-.5 4.4 1.7 8.3 4.9 8.7 3.2.4 6.2-3 6.7-7.3zm1.6 38.8c1-4.4-.9-8.5-4-9.2-3.2-.6-6.5 2.4-7.4 6.8-.9 4.3 1 8.4 4 9 3.2.7 6.5-2.3 7.4-6.7zm7.5-36.4c0-1.7-1.2-3.1-2.6-3.1s-2.7 1.4-2.7 3.1c0 1.8 1.2 3.2 2.7 3.2s2.6-1.4 2.6-3.2zm-6.5 7.3l-5.4 6.2s-5.1.1-4.8 1.8c.2 1.6 7 6.6 7 8.6-.1 2 4.4-.5 4.4-.5l3.7-11.1s-.2-7.7-2.2-7.6c-2 .2-2.5 2.5-2.7 2.6zm-357.4-2.4a2.6 2.6 0 1 0-5.1 0 2.6 2.6 0 0 0 5.1 0zm2.5-8c0-1.4-1.2-2.6-2.6-2.6s-2.6 1.2-2.6 2.7 1.2 2.7 2.6 2.7a2.7 2.7 0 0 0 2.6-2.7zM134 199.2c-1-2.2-3-3.4-4.5-2.7-1.5.7-2 3-1 5.2s3 3.4 4.5 2.7c1.6-.7 2-3 1-5.2zm6.5 23.4c-1.4-2.8-4.1-4.4-6.2-3.5s-2.7 3.9-1.4 6.7 4 4.4 6.2 3.5 2.7-3.9 1.4-6.7zm6.8 17.2c.5-3.5-1-6.8-3.2-7.2-2.3-.5-4.4 2-4.9 5.5-.4 3.5 1 6.7 3.3 7.2 2.2.5 4.4-2 4.8-5.5zm-11 2.5c1.4-3.3.9-6.8-1.1-7.8s-4.8.7-6.2 4-.9 6.7 1.2 7.8 4.7-.7 6.1-4z"
      />
      <path
        fill="#6b18b5"
        fillRule="evenodd"
        d="M131.3 234.8c0-1.7-1.3-3-2.9-3s-2.9 1.4-2.9 3 1.3 3 3 3 2.8-1.3 2.8-3zm-2.3-7.5c0-1.5-1.2-2.7-2.6-2.7a2.7 2.7 0 0 0-2.6 2.8c0 1.4 1.2 2.7 2.6 2.7s2.6-1.3 2.6-2.8zm2.4-14.3c0-2.6-1.1-4.6-2.5-4.6s-2.5 2-2.5 4.6c0 2.5 1.1 4.6 2.5 4.6s2.5-2 2.5-4.6zm7.8-1.1c.3-2.5-.5-4.7-2-5-1.3-.1-2.7 1.8-3 4.3-.4 2.5.5 4.7 1.9 4.9 1.3.2 2.7-1.7 3-4.2zm55-110c1.1-3.6 0-7.2-2.3-8-2.3-.9-5 1.3-6 4.9-1 3.6 0 7.2 2.3 8 2.3.9 5-1.3 6-4.9zm-10.4 15.9c3-2.7 4.4-6.3 3-8.1-1.5-1.9-5.2-1.2-8.3 1.4s-4.3 6.2-2.9 8c1.5 1.9 5.2 1.3 8.2-1.3zm-6-8.8c3-2.3 4.2-5.4 2.8-7s-5-1-8 1.2c-3.1 2.3-4.4 5.4-3 7s5 1 8.1-1.2zm23.5-15.5c2-1.6 2.9-3.8 2-4.9-1-1-3.5-.7-5.6.9s-2.9 3.7-1.9 4.8c1 1.1 3.4.7 5.5-.8z"
      />
      <path
        fill="#6b18b5"
        fillRule="evenodd"
        d="M189 108.5c1.4-2.2 1.5-4.5.2-5.2-1.3-.7-3.5.4-4.9 2.6s-1.5 4.5-.2 5.2c1.3.7 3.5-.5 4.9-2.6zm17.7-9.3c2.2-1.9 3-4.3 2-5.5-1.2-1.2-4-.6-6.2 1.2s-3 4.3-1.9 5.5c1.2 1.2 3.9.6 6.1-1.2zm-32 21.6c2 0 3.6-1.1 3.4-2.3 0-1.1-1.9-2-4-1.9-2 .1-3.6 1.2-3.4 2.3.1 1.2 2 2 4 2zm38.7-33.1c1.4-2.2 1.5-4.5.2-5.2-1.2-.7-3.4.4-4.8 2.6s-1.5 4.5-.2 5.2c1.3.7 3.4-.4 4.8-2.6z"
      />
      <path
        fill="#ffd200"
        fillRule="evenodd"
        stroke="#ef8a10"
        d="M446.8 153.4s6.4-10.1 4-19.7c-2.5-9.5-13-2.7-12.8.7.2 3.3 6.8 7.9 7.2 10 .4 2-.8 8.3 1.6 9z"
      />
      <path
        fill="#217900"
        fillRule="evenodd"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={2.3}
        d="M324.9 69.3s23 .9 23.1 15.8c0 2.3 0 5-.8 11.7 4.6-2.5 7.6-9.3 7-13.7.1-15.1-20.5-25.5-29.3-13.8z"
      />
      <path
        fill="#217900"
        fillRule="evenodd"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={2.3}
        d="M310.3 68.6s18.5-3.8 18.7 11c.1 15-6 17.3-6 17.3s14.3-3 14.4-18.1c0-15.2-18.3-21.9-27.1-10.2z"
      />
      <path
        fill="#f7df73"
        fillRule="evenodd"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={2.5}
        d="M373.3 390s86.8-24.6 113-131C471 368.1 376 403 376 403l-2.8-13z"
      />
      <path
        fill="#8c1800"
        fillRule="evenodd"
        d="M382.2 396.6c2.7 0 9.3-7.4 13.1-8.2 3.8-.8 4.2-4.7-.1-4.8-4.4-.2-8.2 5-8.2 5s-3.8 3.2-7.8 3.6c-4 .4-1.4 5.4 3 4.4z"
      />
      <path
        fill="#8c1800"
        fillRule="evenodd"
        stroke="#8c1800"
        strokeWidth={2.5}
        d="M432.2 359.3s-9 5.2-7.8 6.5c1.3 1.3 9.3-5 9.5-5 .1-.2 3.4-4.2-1.7-1.5z"
      />
      <path
        fill="#8c1800"
        fillRule="evenodd"
        d="M400.7 383s-2.7-1 4.2-3.6c7-2.7 6.5-5.8 8.8-7.1 2.2-1.3 7-4.7 8-2.7s-5 6-6.5 6.4c-1.4.4-8.3 6.8-10.3 7.3-2 .6-3.4.3-4.2-.3z"
      />
      <path
        fill="none"
        stroke="#8c1800"
        strokeLinecap="round"
        strokeWidth={3}
        d="M445.6 346c-6 6.7-6 6.5-6 6.5"
      />
      <path
        fill="none"
        stroke="#8c1800"
        strokeLinecap="round"
        strokeWidth={2.8}
        d="M454.5 335.2l-5.7 6.9"
      />
      <path
        fill="none"
        stroke="#8c1800"
        strokeLinecap="round"
        strokeWidth={2.5}
        d="M463.4 321l-6.4 10.2"
      />
      <path
        fill="none"
        stroke="#8c1800"
        strokeLinecap="round"
        strokeWidth={2.3}
        d="M470.9 306.6l-5.3 10.5m8.6-18l-1.6 3.6"
      />
      <path
        fill="none"
        stroke="#8c1800"
        strokeLinecap="round"
        strokeWidth={1.4}
        d="M478 289l-1.4 4.4"
      />
      <path
        fill="#f7df73"
        fillRule="evenodd"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M160.3 216s52-14.7 67.6-78.5c-9.1 65.5-66 86.2-66 86.2l-1.6-7.7z"
        transform="matrix(-1.65528 0 0 1.70062 524.8 20.4)"
      />
      <path
        fill="#8c1800"
        fillRule="evenodd"
        d="M250.7 394.4c-2.7 0-9.2-7.5-13-8.3-3.8-.9-4.2-4.8.1-5 4.4 0 8.1 5.1 8.1 5.1s3.8 3.3 7.7 3.8c4 .4 1.4 5.4-2.9 4.4z"
      />
      <path
        fill="#8c1800"
        fillRule="evenodd"
        stroke="#8c1800"
        strokeWidth={1.5}
        d="M195.5 197.6s-5.4 3.2-4.6 4c.7.7 5.5-3 5.6-3.1.1-.1 2-2.5-1-.9z"
        transform="matrix(-1.65528 0 0 1.70062 524.8 20.4)"
      />
      <path
        fill="#8c1800"
        fillRule="evenodd"
        d="M232.4 380.6s2.6-1-4.2-3.7-6.5-6-8.7-7.2c-2.2-1.3-7-4.7-8-2.7s5 6 6.5 6.4c1.4.5 8.2 7 10.2 7.5 2 .6 3.3.3 4.2-.3z"
      />
      <path
        fill="none"
        stroke="#8c1800"
        strokeLinecap="round"
        strokeWidth={1.8}
        d="M203.5 189.7l-3.5 3.9"
        transform="matrix(-1.65528 0 0 1.70062 524.8 20.4)"
      />
      <path
        fill="none"
        stroke="#8c1800"
        strokeLinecap="round"
        strokeWidth={1.7}
        d="M208.9 183.2l-3.4 4.1"
        transform="matrix(-1.65528 0 0 1.70062 524.8 20.4)"
      />
      <path
        fill="none"
        stroke="#8c1800"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M214.2 174.7l-3.8 6.1"
        transform="matrix(-1.65528 0 0 1.70062 524.8 20.4)"
      />
      <path
        fill="none"
        stroke="#8c1800"
        strokeLinecap="round"
        strokeWidth={1.4}
        d="M218.7 166.1l-3.2 6.3m5.2-10.9l-1 2.2"
        transform="matrix(-1.65528 0 0 1.70062 524.8 20.4)"
      />
      <path
        fill="none"
        stroke="#8c1800"
        strokeLinecap="round"
        strokeWidth={0.8}
        d="M223 155.5l-.9 2.7"
        transform="matrix(-1.65528 0 0 1.70062 524.8 20.4)"
      />
      <path
        fill="#217900"
        fillRule="evenodd"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={2.3}
        d="M490.4 239.3c.5 6.7 7 13 4.4 24.7-3.2 13.3-14.8 44.7-12.8 50.2-3.4-4.7-2.8-9-3-15.6-.4-6.5 9.4-30.9 10.3-39.1 0-7.4.7-17.5 1.1-20.2z"
      />
      <path
        fill="#217900"
        fillRule="evenodd"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={2.3}
        d="M490.4 239.4s10.7 13.5 10.1 24.2c-.5 10.7-6.5 23.2-4.5 28.7a21.7 21.7 0 0 1-4.6-14.2c-.3-6.5 5.3-13.8 4.1-20.9-1.1-7-5.2-17.8-5-17.8zm-349.3 3c-.4 6.7-5.4 12.7-2.8 24.3 3.2 13.3 15 30 13 49.2 3.5-4.7 4.5-10 4.8-16.5.2-6.5-13-28.5-13.8-36.8 0-7.4-.8-17.5-1.2-20.2z"
      />
      <path
        fill="#217900"
        fillRule="evenodd"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={2.3}
        d="M141.1 242.6s-10.4 13-9.8 23.7c.1 7.1 13.2 36.8 11.2 42.4 3.5-4.7 4.4-4.1 4.3-11.2-3.8-18.3-10.7-29.9-9.5-37 1.1-7.1 4-18 3.8-18z"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeDashoffset={1}
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeWidth={1.7}
        d="M100 125.8l22 68.2h72l-58 42.2 22.1 68.2-58-42.1-58 42.1 22-68.2L6 194h71.8z"
        transform="matrix(1.16516 0 0 1.16534 202 -23.6)"
      />
    </g>
  </svg>
	),
	MQ: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#00267f" d="M0 0h213.3v480H0z" />
      <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	MR: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#cd2a3e" d="M0 0h640v480H0z" />
    <path fill="#006233" d="M0 72h640v336H0z" />
    <path
      fill="#ffc400"
      d="M470 154.6a150 150 0 0 1-300 0 154.9 154.9 0 0 0-5 39.2 155 155 0 1 0 310 0 154.4 154.4 0 0 0-5-39.2z"
      className="prefix__st1"
    />
    <path
      fill="#ffc400"
      d="M320 93.8l-13.5 41.5H263l35.3 25.6-13.5 41.4 35.3-25.6 35.3 25.6-13.5-41.4 35.3-25.6h-43.6z"
    />
  </svg>
	),
	MS: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#006" d="M0 0h640v480H0z" />
    <g fillRule="evenodd">
      <path
        fill="#fff"
        d="M408.3 192.3h214.3l-.3 153.4c1.8 61.7-36.4 100-106.7 117.2-50-12.5-107.5-38.3-107.6-115.5l.3-155.2z"
      />
      <path
        fill="#00a2bd"
        stroke="#000"
        strokeWidth="1pt"
        d="M44 22.7h169.4l-.2 120.8c1.4 48.6-28.8 78.7-84.3 92.3-39.5-9.8-85-30.2-85-91l.2-122z"
        transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
      />
      <path
        fill="#a53d08"
        d="M616.3 361.3c-7.5 56.4-50.7 81.1-100.7 94.2-44.3-12-92-31-101.1-93.9l201.8-.3z"
      />
    </g>
    <g fillRule="evenodd" stroke="#000">
      <path
        fill="#ffc6b5"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M155.8 197.2s.6 9.3-4.4 14.9c4.5 1.4 7.5-.3 8.9-2 1.4-1.8 1.9-4.1 1.9-4.1s1.2-.8 1.4-2.5c0-2.3-1-2.3-1.8-2.8l.2-5.2s-5.1-3.1-6.2 1.7z"
        transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
      />
      <path
        fill="#ff9a08"
        strokeLinecap="round"
        strokeWidth="1pt"
        d="M155.5 210.3l-1.5-1.2"
        transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
      />
    </g>
    <path
      fill="#ffc6b5"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M141.6 69.4s.2 5.6-.2 6.2c-.4.6-3.6 2-3.6 2l2.8 5.9 7.7-1.1 3.3-8.7s-1.7-2.9-1.3-6c-2.5-8-8.6 1.7-8.7 1.7z"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="#005121"
      fillRule="evenodd"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M131.4 203s4.4 4.4 9.3 3.9c11.3-1.3 14.6-11.3 18-11.4s5.7 6 9 5.3a56.2 56.2 0 0 1-5.4-24.7c.5-8 .5-42 .5-42s-5.6-17.6-8.3-20.5a19 19 0 0 0 4.4-13.2V88.9s1.3-1.5 1.2-5.7c-.1-4.2-7.1-10.3-8-10-1 .2-9.9 7.8-10.6 9.6-.8 1.8-1.8-6.5-.1-7.2 1.7-.8-4-1.2-7.5 3-3.6 4.2-2.5 124.7-2.5 124.5z"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fillRule="evenodd"
      d="M467.5 224.1l40 .2-.3-18.6 14.6.2.1 18.4h39.8l.2 14.3-40 .2-.3 169.4h-14.2l-.2-169.6-39.7.2V224z"
    />
    <path
      fill="#ffc6b5"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M122 82s-2.2-.4-4 0 2.7-19.5 2.7-21.2c1.5-.7 9.2-2 9-7.5-.6-3.2-11.8.2-11.6 4.3-.8 2.1-8.1 23.1-6.7 30 2.6 2 7.4 1.7 10.6 1.1V82z"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.6}
      d="M124.2 53.2s-.6 3.7 2.7 4.3"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.4}
      d="M129.2 53.1l-4.4 2.8m4.1-1.1l-3 2.2m2-4.7l-3.4 2"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="#ff9a08"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M95.5 163.6l30.1 31.2c10.5-11.4 3.2-54.3-10.5-62.1-1.6 5-4.4 11.1-7.4 13-6.5 4.5-22.5 9.7-17.2 13 1.2-1.6 4.4-3.2 6 .5 1.7 6-6.7 6.3-6.7 6.3s-5.4-.6-6.3-6c-1-5.5 8-10.5 8.7-10.9.8-.2 12.4-3.3 14.4-13.7 2.4-10.1 5-8.6 5.4-8.8 15.2 1.5 25.2 28.7 25.7 47.9.6 19.1-7.7 31.8-9.3 32.7-1.5.8-36.2-41.3-36.2-41.3l3.3-1.8z"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth="1pt"
      d="M117.5 134.4l.1 56.5m-3.5-55.4l.2 51.2m-3.9-43.8l.2 40.8m-3.2-37.9l.2 33.7m-3.4-32.2v28.5m-3.5-26.2V172m-3-20.8v17.3"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="none"
      stroke="#ffdf00"
      strokeLinecap="round"
      strokeWidth={1.3}
      d="M95 167.1l31.1 35.6m1.5-58s14 30.8 1 56.1m-37.2-40.2s1-2.7 2.3-1.6m-4.8-6.2s-5.6 5-2.5 8.1"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth="1pt"
      d="M141 83s.5 4.3-.4 7.6 3.5 12.4 1.8 14.3m.5 8.8l11.8-.1"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth="1pt"
      d="M138.6 118.5c0 .2 1.4 6.2 1 10.3m2.8-8.2c-.3 1.3-5.2 15.2-5 15.7m8-22c0 .3-.4 8.9-1.7 10.1m7.7-10.7s7.7 17.8 7.6 24.9 2.6 21.3.8 27.6m-6-27.8s-.6 13.2-6.1 18.4c-5.5 5.2 13.2 19.9 13.2 19.9"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.3}
      d="M153.6 175.9s2 18.2 5.6 19.5m-22.6-50c.1.1-1.9 12.2-.3 14.2 1.6 2 14.9 20.5 14.3 39.6m-3.7-5.7s-.4 11.6-11.1 12.5m7.9-20s3.2 12-7.7 19.5"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth="1pt"
      d="M147.9 156.9s12.3 12.8 12.8 18.4m-9.2-61.3s2.1 9 1.3 10.7"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="#ffc6b5"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth="1pt"
      d="M113.5 132.7s-1.3-2.3-1.1-4.9-.5-6.5 7.8-9.7c5-5 10.6-8.1 13.6-9.7 4.5-2.9 7.4-2.2 10-3.2 1.7-2 1.6-6.3 3.5-10.2 1.8-3.9 5-11.9 8.4-10.6 3.5 1.2.8 11.6-.5 15.2s-2.5 7.4-4.8 9.6c-2.3 2.3-12.8 6.3-14.8 7s-11.5 3-13.9 6.2c-2.4 3.3-2.2 8.2-8.2 10.3z"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth="1pt"
      d="M112.8 125.8c.3-.1 4.2-1.3 6 2.1"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="#ffc6b5"
      fillRule="evenodd"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M142 55.2s-1.8 2.8-2.3 4.6c-.4 1.3-1.6-.1-2.2 2.7l1 .2c-.4.8-.5 2.2-.6 2.5-.1.3-.7 1.8-.6 3 0 .5 1.1 3 10.1-.8s-2.9-14.8-5.5-12.2z"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="#c59200"
      fillRule="evenodd"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M140.9 55.6c1-.5 7.5-1.1 6.4 11.7 1.2-.2 2-.4 2.7.9.8 1.2.7 2.7 2 2.7 1.4 0 1.5-.3 1.9-1.3.3-1 5.5 1.2 6.9-3.4-.3-1-3.2-2.3-3.6-4 .8-2.3-.3-9.8-9.9-10.2-4.9 0-5.9 2-6.4 3.6z"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth="1pt"
      d="M140.4 58.1c.1.1 3 1 3.3 2.3"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fillRule="evenodd"
      d="M531.7 244.1c0 .5-.4 1-.9 1s-.9-.5-.9-1 .4-1 1-1 .8.5.8 1z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M154.4 61.5s-1 5.1 3.6 7.1m-7-6.4s1.7 0 1.7 1.6c0 1.7-1.4 1.9-1.3 3.1 0 1.3 2.4 1.8 2.5 2.8m-10.5-16.9s8.2 1 7.8 3c-.5 2-1.8 1.2-1.7 3s3.2.6 3.2.6.2-1.4 1.6-1.3.7 1.6 2.6 1.6"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.3}
      d="M138.4 65.5l2-.1"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth="1pt"
      d="M143.4 73.7s.8 3.4-2 3"
      transform="matrix(1.2096 0 0 1.2172 359.7 169.2)"
    />
    <g strokeWidth="1pt">
      <path
        fill="#fff"
        d="M0 0v28.5l343.6 226H387V226L43.3 0H0zm386.9 0v28.5l-343.6 226H0V226L343.6 0H387z"
      />
      <path
        fill="#fff"
        d="M161.2 0v254.4h64.5V.1h-64.5zM0 85v84.7h386.9V84.8H0z"
      />
      <path
        fill="#c00"
        d="M0 101.8v50.9h386.9v-50.9H0zM174.1.1v254.3h38.7V.1h-38.7zM0 254.4l129-84.8h28.8l-129 84.8H0zM0 .1l129 84.8h-29L0 19V0zm229.1 84.8L358.1 0h28.8l-129 84.8h-28.8zm157.8 169.5l-129-84.8h28.9l100.1 65.9v19z"
      />
    </g>
  </svg>
	),
	MT: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#ce0000" d="M320 0h320v480H320z" />
      <path fill="#fff" d="M0 0h320v480H0z" />
    </g>
    <g transform="translate(-12.4 -30.8) scale(1.5986)">
      <path
        fill="#f1eeee"
        fillRule="evenodd"
        d="M104.8 108c0 .9-.9 1.5-2 1.5-1.2 0-2-.6-2-1.4 0-.8.8-1.5 2-1.5 1.1 0 2 .7 2 1.5z"
      />
      <path
        fill="#c00"
        fillRule="evenodd"
        d="M40.7 101v37.2H78c0 6.2 6.2 12.4 12.4 12.4v37.2h37.3v-37.2c6.2 0 12.4-6.2 12.4-12.4h37.2V101H140c0-6.2-6.2-12.4-12.4-12.4V51.4H90.4v37.2c-6.3 0-12.5 6.2-12.5 12.4H40.7z"
      />
      <path
        fill="#ffe600"
        fillRule="evenodd"
        d="M42 102.2V137h37.2c0 6.2 6.2 12.4 12.4 12.4v37.2h34.7v-37.1c6.2 0 12.4-6.2 12.4-12.4H176v-34.8h-37.2c0-6.2-6.2-12.4-12.4-12.4V52.6H91.6v37.2c-6.2 0-12.4 6.2-12.4 12.4H42z"
      />
      <path
        fill="#707070"
        fillRule="evenodd"
        d="M43.2 103.5v32.2h37.2c0 6.2 6.2 12.4 12.4 12.4v37.2h32.3v-37.2c6.2 0 12.4-6.2 12.4-12.4h37.2v-32.2h-37.2c0-6.2-6.2-12.4-12.4-12.4V53.9H92.8V91c-6.2 0-12.4 6.2-12.4 12.4H43.2z"
      />
      <path
        fill="#a0a0a0"
        fillRule="evenodd"
        d="M44.5 104.7v29.8h37.2c0 6.2 6.2 12.4 12.4 12.4V184h29.7v-37.2c6.2 0 12.4-6.2 12.4-12.4h37.2v-29.8h-37.2c0-6.2-6.2-12.4-12.4-12.4V55.1H94.1v37.2c-6.2 0-12.4 6.2-12.4 12.4H44.4z"
      />
      <g fillRule="evenodd">
        <path
          fill="#d0d0d0"
          d="M94.4 89.2c2.1 2.2.4 7.5-4 11.9s-9.6 6-11.8 4c-2.2-2.3-.4-7.6 4-12s9.6-6 11.8-3.9z"
        />
        <path
          fill="gray"
          d="M91.7 91.8c2.2 2.2 1.6 6.3-1.3 9.3s-7 3.5-9.2 1.3c-2.2-2.2-1.6-6.3 1.3-9.2s7-3.5 9.2-1.4z"
        />
        <path
          fill="#d0d0d0"
          d="M80.8 98.4l.8-.8 3.5 1.7-1.7-3.5.9-.9 3.5 7-7-3.5zm5.2-5.2l1-1 5.2 5.4-.9.8z"
        />
      </g>
      <g fillRule="evenodd">
        <path
          fill="#d0d0d0"
          d="M139.3 105c-2.2 2.2-7.5.4-11.8-4s-6.2-9.6-4-11.8c2.2-2.2 7.5-.4 11.9 4s6 9.6 4 11.8z"
        />
        <path
          fill="gray"
          d="M136.7 102.4c-2.2 2.2-6.3 1.6-9.2-1.3s-3.5-7-1.4-9.2c2.2-2.2 6.4-1.6 9.3 1.3s3.5 7 1.3 9.2z"
        />
        <path
          fill="#d0d0d0"
          d="M130.1 91.4l.9.9-1.8 3.5 3.5-1.8 1 1-7.1 3.4 3.5-7zm5.3 5.3l.8.8-5.2 5.3-.9-.9z"
        />
      </g>
      <g fillRule="evenodd">
        <path
          fill="#d0d0d0"
          d="M123.5 150c-2.2-2.2-.4-7.5 4-11.9s9.6-6.1 11.8-4c2.2 2.2.4 7.5-4 11.9s-9.6 6.1-11.8 4z"
        />
        <path
          fill="gray"
          d="M126.2 147.3c-2.2-2.2-1.6-6.3 1.3-9.2s7-3.5 9.2-1.3c2.2 2.2 1.6 6.3-1.3 9.2s-7 3.5-9.3 1.3z"
        />
        <path
          fill="#d0d0d0"
          d="M137.1 140.7l-.9 1-3.5-1.8 1.8 3.5-.9.8-3.5-7 7 3.5zM132 146l-1 .9-5.2-5.3.9-.9z"
        />
      </g>
      <g fillRule="evenodd">
        <path
          fill="#d0d0d0"
          d="M78.6 134.2c2.2-2.2 7.5-.4 11.8 3.9s6.1 9.7 4 11.8c-2.2 2.2-7.5.5-11.9-3.9s-6-9.7-4-11.8z"
        />
        <path
          fill="gray"
          d="M81.2 136.8c2.2-2.2 6.3-1.6 9.2 1.3s3.5 7 1.3 9.2c-2.1 2.2-6.3 1.6-9.2-1.3s-3.5-7-1.3-9.2z"
        />
        <path
          fill="#d0d0d0"
          d="M87.8 147.8l-.9-1 1.8-3.4-3.5 1.7-1-.9 7.1-3.5-3.5 7zm-5.3-5.3l-.8-.9 5.2-5.2.9.8z"
        />
      </g>
      <path
        fill="none"
        stroke="#707070"
        strokeWidth="1pt"
        d="M269.3 414.6c0 41-34.1 74.4-76.2 74.4S117 455.7 117 414.6s34.1-74.4 76.2-74.4 76.2 33.3 76.2 74.4z"
        transform="matrix(.34191 0 0 .35003 43 -25.5)"
      />
      <path
        fill="none"
        stroke="#707070"
        strokeWidth="1pt"
        d="M269.3 414.6c0 41-34.1 74.4-76.2 74.4S117 455.7 117 414.6s34.1-74.4 76.2-74.4 76.2 33.3 76.2 74.4z"
        transform="matrix(.2605 0 0 .26669 58.6 9)"
      />
      <path
        fill="#d0d0d0"
        fillRule="evenodd"
        d="M100.3 140.7a1.2 1.2 0 1 1-2.5 0 1.2 1.2 0 0 1 2.5 0zm19.8 0a1.2 1.2 0 1 1-2.5 0 1.2 1.2 0 0 1 2.5 0zm-12 0v1.3h-1.6c-1.7 0-1.7 1.3 0 1.3h1.6v1.2c0 1.4 1.5 1.5 1.6.1v-1.4h1.7c1.7 0 1.7-1.2 0-1.2h-1.6v-1.3c0-1.3-1.7-1.3-1.7 0z"
      />
      <path
        fill="#d0d0d0"
        fillRule="evenodd"
        stroke="#707070"
        strokeWidth={0.1}
        d="M102.8 122.3v.8s-.4.5-2.9.7c-2.5.2-2.9 0-2.9 0 .1.7.6 1.9.4 3.3.1 1.7-.4 3.2-.4 3.2 0 .1-.3.2-.8.1.4-.4.4-1.4.4-3 0-1.4-1.5-3.7-1.2-4.3.3-.6 7.4-.8 7.4-.8zm9.8-2.6l6.5-.1s1 2 .9 3c0 1-.4 2-.8 1.5-.5-.5.2-.4.3-1.5 0-1.2-.8-2.3-.8-2.3s-1.8.7-4.4.6c-2.6-.2-1.4-1.2-1.7-1.2z"
      />
      <path
        fill="#d0d0d0"
        fillRule="evenodd"
        stroke="#707070"
        strokeWidth={0.1}
        d="M113.4 121.6c2.4-.1 4 .2 4 .2s1 2 1 3c-.1 1-.4 2-.9 1.5-.4-.4.2-.3.3-1.5 0-1.1-.8-2.3-.8-2.3s-1.7.7-4.3.6c-2.6-.2-1.8-.3-2.1-.4-.3 0-.4.8-4.3.9-4 0-6-.9-6-.9s-.4.6-2.8.8h-3c.1.6.6 1.8.5 3.3 0 1.6-.5 3.2-.5 3.2h-.7c.4-.3.3-1.4.4-2.9 0-1.5-1.6-3.7-1.3-4.4.4-.6 2.2 0 2.5-.3.3-.4-1.6-2.7-1.2-4.8.3-2.1 2.4-1.5 4.9-1.5 2.5.1 8 .8 9.4 0 1.4-.7.8-3.4 2-5.1a4.1 4.1 0 0 1 3.3-1.5c.9 0 2 3 2 3.7l-.3.4h-.4v.3c-1 .1-1.1-.8-1.7-1.4-.2 1 .8 4.4.8 6.6 0 1.8-.7 2.6-.8 2.5z"
      />
      <path
        fill="#d0d0d0"
        fillRule="evenodd"
        stroke="#707070"
        strokeWidth={0.1}
        d="M105.5 118.4c0 .7-3.1 2.4-3.4 3-.2.7.8 1 .5 1.4-.3.4-.6.2-.7.3l-1.2-2.5s3-1.4 2.9-2c-.1-.6-2.2-1-2.6-2.4s-.2-4.3-.5-4.9c-.3-.6-4-1.2-4-2 0-1 3.8-3.4 4.2-3.8.4-.4.8.4.4.7-.4.4-3.3 2.7-3.3 3 0 .4 2.4.8 3.2.8.9 0 1.3-.4 1.3-.8 0-.3-.9-.3-.9-1s.5-1.2 1.3-1.2c.4 0 1.2.5 1.2 1.1s-.7.7-.8 1.1c-.1.5.8.8 1.6.8s3.6 2.1 4 2.5c.5.3.9.3.5.7-.4.4-.2.8-.6.4a1.5 1.5 0 0 1-.4-.7c0-.3-3-1.8-3.5-1.5-.4.4 0 4.8 0 5.2 0 .7.9.7.8 1.8z"
      />
      <path fill="#a7a7a7" fillRule="evenodd" d="M100.3 109.9h5v5.1h-5z" />
      <rect
        width={30.6}
        height={0.4}
        x={138.6}
        y={-25.7}
        fill="gray"
        fillRule="evenodd"
        rx={0.5}
        ry={0.2}
        transform="matrix(.55442 .83223 -.88237 .47055 0 0)"
      />
      <path
        fill="#d0d0d0"
        fillRule="evenodd"
        stroke="#707070"
        strokeWidth="1pt"
        d="M180.7 42.5a7 7 0 1 1-14.2 0 7 7 0 0 1 14.2 0z"
        transform="matrix(.11563 0 0 .10345 80.7 101.5)"
      />
      <path
        fill="gray"
        fillRule="evenodd"
        d="M115.9 112.5c0 .3-2 .7-4.1.7-2.2 0-4.1-.4-4.1-.7 0-.3 1.9.5 4 .5 2.3 0 4.2-.8 4.2-.5z"
      />
      <path fill="#a7a7a7" fillRule="evenodd" d="M100.7 115h4.1v1.5h-4z" />
      <path
        fill="gray"
        fillRule="evenodd"
        d="M114 111.4c-.4.8-.7 1.3-.8 1.2 0 0 .2-.8.6-1.5l.8-1.2c.1.1-.2.8-.6 1.5zm1 2l-.8.5a3.2 3.2 0 0 1 .8-.9c.5-.4.9-.6.9-.5l-.8.8z"
      />
      <path
        fill="gray"
        fillRule="evenodd"
        d="M114.6 112.4l.5 1.2-.8-1-.5-1.2.8 1zm-.4 3.2s-1.2.2-2.8.2-2.9-.1-2.9-.2l2.9-.2c1.6 0 2.8 0 2.8.2zm-9.4-.4c0 .1-.9.2-2 .2-1.2 0-2 0-2-.2 0 0 .8-.2 2-.2 1.1 0 2 .1 2 .2z"
      />
      <path
        fill="#d0d0d0"
        fillRule="evenodd"
        stroke="gray"
        strokeWidth={0.1}
        d="M95.8 128s.7 1.6 3.6 1.6c2.8 0 3.8-.5 2.7-1.3s-3.4-.6-3 .1c.2.8-.9 1-1.1.5-.3-.5-1.3-2.1.5-2.2 1.9-.1 5.8-.7 6.8.4s-1.1 2 .5 2.3c1.5.2 1.8-.3 4.5-.4 2.7-.2 3.8.5 4.7.4 1 0 .8-1.7 0-2-.7-.5-2.1-.6-2.5-1-.3-.5-1.3 0-1.2-.6 0-.5 1.4.3 1.4.1l.2-.2h-.3l.1-.2-.2.1.1-.2s-.3.2-.3 0h-.2c.2-.2.1-.2 0-.3h-.3v-.3c-.2 0-.2 0-.3.2v-.5c0-.1.2-.2.5-.2.7 0 1 .8 1.3.8.2 0 .5-.8 1.4-.5l1.5.6c.5.3-.3.6 0 1s2.1 1.7 1.6 3.2c-.5 1.4-2 1.6-2 2.2-.2.6 4.3.4 5.4.6a3 3 0 0 1 1.9 1.2l-2 .1s-1-.5-3.5-.6c-2.5 0-3.4-1-4.4-1.2l-4 .2-3-.3c-.6-.1-4.2 1.6-4.2 2h-2.4s.3-.9 1.7-1c1.3-.2 2.7-.8 2.6-1.2l.4-2.6c0-.6.6-1 .5-1.2-.1-.4-1.7-.7-3.2-.7-1.5 0-3.1.1-3.4.4-.2.4 0 1.5.3 1.3.3 0-.1-.8.2-.9a6.8 6.8 0 0 1 2-.3c.8 0 2.1.7 2.1 1 0 .1.4.8-.2 1.1a8.2 8.2 0 0 1-3.1.4 7.5 7.5 0 0 1-3-.8c-.4-.3-.7-1-.7-1.1z"
      />
      <path
        fillRule="evenodd"
        d="M114 125.5a.3.3 0 1 1-.6 0 .3.3 0 0 1 .6 0z"
      />
      <path
        fill="#d0d0d0"
        d="M129.5 120.8l1.6.3 2.7-1.8-.2 1-1.4.9-.8.4.5.8.9 1.4-.2 1-1.7-2.9-1.6-.3.2-.8zm-2.7-11.8l3-1.4-.8-1.8.4-.2 2 4.4-.3.2-.9-1.9-3 1.5-.4-.8zm-4.8-5.8l2.8-2.6.6.6v4.4l2.2-2 .5.6-2.8 2.6-.6-.6v-4.4l-2.2 2-.5-.6zm-12.4-5l.5-3.8h.8l-.5 3.5 3 .3v.5l-3.8-.5zm-6.1.6l-.7-3.8.8-.2.6 3.4 3-.6v.5l-3.7.7zm-11.3 5.5l-.3-.3 2-1.6 1 1a5.7 5.7 0 0 1-.8 1.2 5.7 5.7 0 0 1-.9 1 5.2 5.2 0 0 1-1.4.8c-.5.1-1 .2-1.3 0a1.6 1.6 0 0 1-1-.5 1.7 1.7 0 0 1-.3-1c0-.4.1-.9.4-1.3.2-.4.6-.8 1-1.1a4.8 4.8 0 0 1 1.1-.7l.9-.2c.2 0 .5 0 .7.2l-.4.5a1.3 1.3 0 0 0-.6-.1l-.6.1a3.2 3.2 0 0 0-.7.5c-.3.2-.6.4-.7.7a2 2 0 0 0-.4.6v.5c0 .3.1.6.3.8l.7.5 1-.1a4.1 4.1 0 0 0 2.1-2l-.4-.6-1.4 1.1zm-.1 27.7l-3.2 2.3-2.4-3.4.4-.3 2 2.7.9-.7-1.6-2.3.3-.2 1.7 2.3 1.4-1 .5.6zm-4.7-5c.5-.1.8-.4 1-.9v-1.5a2.6 2.6 0 0 0-.9-1.3c-.3-.3-.8-.4-1.2-.3a1.4 1.4 0 0 0-.8.5c-.1.2-.3.5-.3.8l.1 1.1c.2.6.4 1 .8 1.4.3.3.8.4 1.3.2zm.3.8a1.7 1.7 0 0 1-1.7-.4 3.7 3.7 0 0 1-1.1-1.8c-.2-.6-.2-1-.2-1.6s.2-.8.4-1.1a1.6 1.6 0 0 1 1-.7 1.6 1.6 0 0 1 1 .1c.4.2.7.4 1 .8a4.5 4.5 0 0 1 .8 3 2.3 2.3 0 0 1-.4 1.1c-.2.3-.5.5-.8.6zm.3-7.8h-4v-2.8l.2-1.2.4-.7a.8.8 0 0 1 .6-.2c.3 0 .5.1.7.4.1.3.3.7.3 1.3a2.5 2.5 0 0 1 .7-1.1l1.1-1v1l-.8.7-.6.6a1.7 1.7 0 0 0-.3.4 1.6 1.6 0 0 0 0 .4v.4l-.1 1H88v.8zm-2.2-.9v-1.7a4 4 0 0 0 0-.9 1 1 0 0 0-.2-.4.5.5 0 0 0-.3-.2c-.2 0-.4.1-.5.3l-.2 1v2h1.3zm10.7-16.9v-4.5l.8-.5 4.1 2-.8.5-1.2-.6-2.1 1.3v1.4l-.8.4zm.7-2.3l1.8-1-1-.6a8.3 8.3 0 0 1-.9-.5l.1.8v1.3zm18.6-1.2L120 97l.7.5-.3 4.6-.7-.6.1-1.3-2-1.5-1.3.5-.7-.5zm2.4-.2l1.7 1.2v-1.2a8.4 8.4 0 0 1 .2-1 3.7 3.7 0 0 1-.7.5l-1.2.5zm10.3 14.3l3.8-.9.6 2.7.2 1.2-.2.7a.8.8 0 0 1-.5.4c-.3 0-.6 0-.8-.2a2.8 2.8 0 0 1-.7-1.2 2.5 2.5 0 0 1 0 .5l-.4.8-.8 1.2-.2-1 .6-1 .4-.6a1.6 1.6 0 0 0 .2-.8 3.7 3.7 0 0 0-.1-.5l-.2-.9-1.7.4-.2-.8zm2.3.3l.4 1.7c0 .3.2.6.3.8 0 .2.2.3.3.4l.4.1c.1 0 .3-.2.3-.4a2.1 2.1 0 0 0 0-1l-.5-1.9-1.2.3z"
      />
    </g>
  </svg>
	),
	MU: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#00a04d" d="M0 360h640v120H0z" />
      <path fill="#151f6d" d="M0 120h640v120H0z" />
      <path fill="#ee2737" d="M0 0h640v120H0z" />
      <path fill="#ffcd00" d="M0 240h640v120H0z" />
    </g>
  </svg>
	),
	MV: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#d21034" d="M0 0h640v480H0z" />
    <path fill="#007e3a" d="M120 120h400v240H120z" />
    <circle cx={350} cy={240} r={80} fill="#fff" />
    <circle cx={380} cy={240} r={80} fill="#007e3a" />
  </svg>
	),
	MW: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#f41408" d="M0 0h640v480H0z" />
      <path fill="#21873b" d="M0 320h640v160H0z" />
      <path d="M0 0h640v160H0z" />
      <path
        fill="#f31509"
        d="M220.5 141c22.3-49.2 84.5-72.8 138.8-52.5a98.4 98.4 0 0 1 58 52.5H220.5zm-26 6.4a332.3 332.3 0 0 1-52.4-7.8c-4.1-1.3-4.3-3.6-3.8-5.3.5-1.7 3.1-3.6 6.2-3 5.6 1.4 28.8 7 50 16.1zm124.6-85.9c-4.2-21-5.2-44-4.8-48C314.7 9.6 317 9 319 9s4.7 1.8 4.7 4.7c0 5.3-.1 27-4.6 48zm11.6.5a249 249 0 0 1-.3-48.2c.8-3.9 3.2-4.4 5.1-4.2 2 .1 4.5 2.1 4.2 5-.5 5.3-2.6 26.9-9 47.4zm10.4 1.3c-.2-21.3 3-44.3 4.1-48 1.1-3.9 3.6-4.2 5.5-3.9 2 .3 4.3 2.5 3.8 5.3-1 5.3-5.2 26.6-13.4 46.6zm11 2.2c1.8-21.2 7.3-43.8 8.8-47.5 1.5-3.7 4-3.8 5.8-3.4 2 .5 4 2.8 3.3 5.6-1.6 5.1-7.7 26-17.8 45.3zm10.9 3.2c3.9-21 11.5-43.1 13.3-46.7 1.9-3.5 4.3-3.5 6.2-2.9 1.8.6 3.7 3.2 2.7 5.8A264 264 0 0 1 363 68.7zm10.1 3.8c5.8-20.7 15.5-42 17.7-45.5 2.2-3.4 4.6-3.1 6.4-2.3 1.8.7 3.4 3.4 2.1 6-2.5 4.8-12.5 24.4-26.2 41.8zm10 4.7a262.9 262.9 0 0 1 22-43.9c2.4-3.2 4.9-2.7 6.6-1.8a4.4 4.4 0 0 1 1.5 6.1c-3 4.6-14.9 23.4-30.1 39.6zm9.4 5.5c9.7-19.4 23.3-39 26.1-42 2.8-3 5.2-2.3 6.8-1.3a4.4 4.4 0 0 1 1 6.2c-3.5 4.4-17.2 22.1-34 37zm8.8 6.2c11.6-18.6 27-37 30.1-39.7 3-2.8 5.4-2 6.9-.8a4.3 4.3 0 0 1 .3 6.2c-3.8 4.1-19.1 20.7-37.3 34.3zm8.3 6.9a284 284 0 0 1 33.8-37.2c3.3-2.5 5.5-1.5 6.9-.3a4.3 4.3 0 0 1-.3 6.3c-4.1 3.8-21 19.1-40.4 31.2zm7.6 7.5A278.4 278.4 0 0 1 454.4 69c3.6-2.3 5.7-1.1 7 .3 1.2 1.3 1.5 4.4-1 6.2a306 306 0 0 1-43.2 27.8zm6.5 7.8A297.1 297.1 0 0 1 464 79.6c3.7-2 5.7-.6 6.8.9 1.2 1.4 1.1 4.5-1.4 6.1-4.8 3-24.3 15.6-45.7 24.5zm5.9 8.3a307 307 0 0 1 43-28.1c4-1.7 5.9-.2 6.9 1.3 1 1.6.6 4.6-2 6a320.8 320.8 0 0 1-48 20.8zm5.4 9.6a313.4 313.4 0 0 1 45.8-24.4c4.1-1.4 5.8.3 6.6 1.9.9 1.6.3 4.6-2.6 5.8-5.3 2.2-27 11.4-49.8 16.7zm4.2 9.2a320 320 0 0 1 48-20.8c4.2-1 5.7.8 6.4 2.5.6 1.6-.3 4.6-3.2 5.5-5.5 1.9-28 9.3-51.2 12.8zm3.4 9.8a324.5 324.5 0 0 1 49.8-16.9c4.2-.6 5.6 1.2 6.1 3 .5 1.7-.7 4.5-3.7 5.3-5.7 1.3-28.8 7-52.2 8.6zM307.8 62a252.4 252.4 0 0 1-9.7-47.4c0-3.9 2.3-4.8 4.2-5 2-.1 5 1.5 5.2 4.3.5 5.3 2.6 26.9.4 48.1zm-11 1.3a251 251 0 0 1-14.3-46.4c-.4-4 1.8-5 3.7-5.3 2-.3 5 1 5.6 3.8a263 263 0 0 1 5 47.9zm-11 2.2A259 259 0 0 1 267 20.3c-.8-3.9 1.3-5.1 3.2-5.6 1.9-.4 5 .6 5.9 3.4 1.5 5.1 7.7 26 9.6 47.3zm-10.5 3A264 264 0 0 1 252.5 25c-1.1-3.8.8-5.2 2.6-5.8 1.9-.6 5.1.2 6.2 2.8 2 5 10.2 25.4 14 46.4zM265.2 72a270.4 270.4 0 0 1-27-41.5c-1.4-3.7.4-5.3 2.2-6 1.8-.8 5-.2 6.4 2.4 2.5 4.8 12.5 24.5 18.4 45.1zm-10.3 5a275.6 275.6 0 0 1-31-39.2c-1.7-3.5-.1-5.2 1.6-6.1 1.7-.9 5-.6 6.6 1.9 3 4.6 15 23.3 22.8 43.4zm-9.4 5.4A285.2 285.2 0 0 1 211 45.7c-2.1-3.4-.7-5.2 1-6.3 1.5-1 5-1 6.7 1.4 3.4 4.3 17.1 22 26.8 41.5zm-8.7 6a292.2 292.2 0 0 1-37.9-33.9c-2.4-3.2-1.1-5 .4-6.2a5.5 5.5 0 0 1 6.8.8c3.8 4 19.2 20.7 30.7 39.3zm-8.5 7a299 299 0 0 1-41-30.7c-2.8-3-1.7-5-.3-6.3a5.5 5.5 0 0 1 6.9.3c4.2 3.7 21 19 34.4 36.6zm-7.4 7A306.6 306.6 0 0 1 177.2 75c-3-2.8-2.1-4.8-.8-6.2 1.2-1.4 4.5-2.1 6.9-.3a292 292 0 0 1 37.6 34zm-7 8.2a313 313 0 0 1-46.2-23.8c-3.3-2.5-2.6-4.7-1.5-6.1 1.1-1.5 4.3-2.5 6.9-.9 4.8 3.1 24.3 15.5 40.8 30.8zm-6.3 8.8c-22.2-7-44.9-17.6-48.4-19.9-3.6-2.2-3-4.4-2.1-6s4-2.8 6.8-1.4c5 2.7 25.8 13.5 43.7 27.3zm-5.3 9c-22.8-5.3-46.3-14-50.1-16-3.7-2-3.5-4.2-2.6-5.8.8-1.6 3.7-3.1 6.6-2 5.3 2.3 27 11.4 46.1 23.8zm-4.2 9a328.5 328.5 0 0 1-51.4-12.2c-4-1.6-3.8-3.9-3.2-5.5.7-1.7 3.5-3.4 6.4-2.5 5.6 1.9 28 9.3 48.2 20.2z"
      />
      <path
        fill="#f31509"
        d="M194.5 147.4a332.4 332.4 0 0 1-52.4-7.8c-4.1-1.3-4.3-3.6-3.8-5.3.5-1.7 3.1-3.6 6.2-3 5.6 1.4 28.8 7 50 16.1z"
      />
      <path d="M129.4 141.5h381.2v12.6H129.4z" />
    </g>
  </svg>
	),
	MX: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <linearGradient id="prefix__a">
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} stopColor="#f15770" />
      </linearGradient>
      <radialGradient
        id="prefix__b"
        cx={842.3}
        cy={103.7}
        r={25.9}
        gradientTransform="matrix(.14152 .03595 -.03453 .14198 213.1 162.4)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <radialGradient
        id="prefix__c"
        cx={651.5}
        cy={550.5}
        r={25.9}
        gradientTransform="matrix(-.13441 -.05384 .04964 -.12489 397.9 -24.3)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <radialGradient
        id="prefix__d"
        cx={380.8}
        cy={740.4}
        r={25.9}
        gradientTransform="matrix(.07536 .00282 -.00343 .14804 412.4 -203.6)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
    </defs>
    <path fill="#ce1126" d="M426.7 0H640v480H426.7z" />
    <path fill="#fff" d="M213.3 0h213.4v480H213.3z" />
    <path fill="#006847" d="M0 0h213.3v480H0z" />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M355.8 289.4l.2 4.5 1.7-1.1-1.3-3.7z"
    />
    <circle
      cx={355.6}
      cy={288.2}
      r={1.4}
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M361.1 296.4l-3.2-3.1-1.5 1.2 4.5 2.6z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      d="M360.9 298.2c-.5-.6-.3-1.5.3-2 .7-.5 1.6-.4 2 .2.5.6.3 1.5-.3 2-.7.5-1.6.4-2-.2z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M386.3 249.6l3.4 3.3.4-1.7-3.1-2z"
    />
    <circle
      cx={385.9}
      cy={248.7}
      r={1.4}
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M395.2 251.6L390 253l.5-1.7 4.4-.4z"
    />
    <circle
      cx={396}
      cy={250.8}
      r={1.4}
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M378 276.8l-3.2-4.8.5-.3 3.5 4.2z"
    />
    <circle
      cx={374.5}
      cy={270.8}
      r={1.4}
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M378.1 277l4 .7.1-.5-3.3-1.4z"
    />
    <circle
      cx={383.3}
      cy={277.7}
      r={1.4}
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      d="M284.6 288c0 .8-.5 1.2-1 1.2s-1-.5-1-1.2.5-1.3 1-1.3 1 .7 1 1.4z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M284.6 290.3l1 5-1.3-.5-.4-4.3z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      d="M285.7 288.6c.6.7-.4 1.9-1.4 2.2-1 .3-2.4-.2-2.4-1.2s1.6-.5 2-.6c.6-.2 1.2-1.2 1.8-.4z"
    />
    <ellipse
      cx={277}
      cy={296.3}
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      rx={1.6}
      ry={1.1}
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M279.6 296l4.8-.2-.8-1-4 .4z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      d="M280 295.4c.5 1.3.5 3-.9 2.7-1.4-.1-1-1.4-1.2-1.8-.2-.9-1-1.7-.2-2.5s2 .4 2.3 1.6z"
    />
    <ellipse
      cx={264.4}
      cy={269.2}
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      rx={0.9}
      ry={1.4}
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M264.4 272.4l.1 4.6-1.2-1v-3.8z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      d="M266.2 271c.3 1-1.3 1.6-2.4 1.4-1-.2-1.9-.7-1.7-1.7.1-1 1.5-.8 2-.5.4.3 1.8-.8 2.1.7z"
    />
    <ellipse
      cx={256.2}
      cy={276.5}
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      rx={1.6}
      ry={0.7}
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M259.1 276.5l3.6-.3 1.6 1.2-5.3-.2z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      d="M257.8 274.5c1 0 1.6 1.1 1.5 2.3-.2 1.1-1 2-2 2-.9-.2-.8-1-.8-1.2 0-.3.5-.7.6-1 0-.4-.3-1.3-.1-1.6 0-.4.3-.5.8-.5zm-3-28.3c-.4.6-1.2 1.1-1.6.9-.4-.3-.2-1.2.2-1.8.4-.7 1-1 1.4-.8.4.3.4 1 0 1.7z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M250.7 253.5l2-4.8-.2-.3-2.4 3.4z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      d="M252.4 248.7c-1-.7-1.2-1.5-1-2.3.4-.7 1.2-.2 1.2-.2l.8.7c.4.2 1 0 1.4.6.5.6.2 1.2-.1 1.4-.4.1-1.5.4-2.3-.2zm-8.5-.6c.7.4 1.1 1 .9 1.5-.3.5-1 .5-1.8 0-.7-.3-1-1-.8-1.5.2-.4 1-.5 1.7 0z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M246 250.2l3.8 2.2-.1 1.8-4.1-3.5z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      d="M246 250.6c-.8 1-1.6 1-2.3.7-.7-.5-.1-1.2-.1-1.2l.8-.7c.2-.4 0-1 .7-1.4.7-.4 1.2 0 1.3.3.1.4.3 1.5-.4 2.3z"
    />
    <path
      fill="#aa8c30"
      d="M356.6 289.8l-.4.4-.3 1v-1.5l.5-.3.2.4zm.2-.9s-.3.5-1.1.5-1.2-.4-1.3-.8c-.1-.4-.1-.7.2-1.2.2-.5-.4.4-.4.4v1l.6.6.5.2h.4l.7-.2.4-.3v-.2zm4.2 7.3s-.4.2-.7.1c-1.9-.6-3.5-1.8-3.5-1.8l3.8 2.4.4-.7zm2.4 1.1s0 .7-.8 1c-.7.3-1.2.2-1.5-.1s-.4-.6-.4-1.2l-.1.6.4.8.8.4.5-.1.5-.2.4-.5.3-.5-.1-.2zm24.3-47.6l-.1.4v.7l-.9-1 .4-.5.6.4zm-.5-1.2c0 .7-.9 1.6-1.6 1.3-.7-.3-1.2-1-.9-1.8l-.2.3.1 1.1.7.6h.9l.6-.3.4-.7v-.5zm10 1.8s-.1-.4 0 0-.6 1.7-1.4 1.6c-.7-.1-1-.8-1-1.4 0-.6-.1.2-.1.2v.8l.5.4.6.4.6-.2.7-.3.2-.6v-.9z"
    />
    <path
      fill="#aa8c30"
      d="M393.8 251s0 .4-.4.7l-1.3.7 2.8-.8-.2-.7-.9.2zm-17.1 22.5l-.1.5v.8l-1.6-2.5.5-.3 1.2 1.5zm-.9-2.4c-.2.7-1.4 1-2 .8-.5-.4-1-1.6-.3-2l-.4.2-.1.7.2.7.6.7.5.1.8-.2.6-.4s.4-1.3.1-.6zm5.6 5.7s0 .3-.5.3h-1.6l2.6.6.2-.6-.7-.3z"
    />
    <path
      fill="#aa8c30"
      d="M384.6 277.5c.3.8-.5 1.7-1.5 1.4-1-.3-1.3-1.3-1-1.8l-.2.6.2.8.6.6h1.3l.6-.7.2-.7-.1-.2zm-99 11.1c.3.3-.1 1.5-1.2 2-1.2.4-1.7 0-2-.4-.3-.4-.3-.8-.3-.8l-.2.2.2.6.5.5 1 .2.8-.1.7-.5.4-.3.3-.5v-.6l-.1-.3z"
    />
    <path
      fill="#aa8c30"
      d="M284.6 291.1l-.3.4-.3.8v-1.4l.5-.3.1.5zm-3.8 4s0 .3.2.5l1 .3h-1.8l-.2-.7h.8zm-.6 1.2v.2a1.4 1.4 0 0 1-.1.5c-.2.5-.3 1-1 .9a1.2 1.2 0 0 1-1-1.1c0-.4-.2-.6-.2-.6v.6l.4 1 .7.3h.5l.5-.2.2-.6.1-.5v-.5zm-4.7-.1s.2.8 1.2.8 1.2-.2 1.2-.2v.3l-.2.2H276l-.3-.3-.3-.5v-.3zm-9.4-25.4v.4c-.1.3-.7 1-1.8 1-1 0-1.5-.3-1.8-.7-.3-.3-.4-.8-.4-.8v.5l.4.7 1.1.5h1l1-.3.5-.5.1-.6-.1-.2zm-1.7 2.3s-.4 0-.6.2a4 4 0 0 0-.4.4v-1.3h1v.7zm-4.7 3.4l.5.3c.5.3 3.1.5 3.1.5h-4.1l.1-.8h.4zm-.5 0l-.2.6c-.2.5-.7 1.6-1.6 1.4-.9-.1-.7-.8-.7-.8v-.4l-.2.7.2.4.4.2.7.1.4-.2.6-.5.2-.5.2-.6v-.3zm-2.2.2s0 .2-.7.2-1.7-.3-1.7-.3l.4.4.5.2h1.3l.2-.5zm-2-29s0 .5-.3.8c-.4.3-1.3.5-1.8.2s-1.5-1.3-1.5-1.3l.4.8.7.6 1 .3 1-.2.4-.4.2-.3-.2-.4z"
    />
    <path
      fill="#aa8c30"
      d="M252 249.1v.6l-.2 1.1.9-2-.4-.2-.3.5zm-5.4 1.5l.2.5c.2.5 2.3 2.6 2.3 2.6l-3.3-2.9.4-.5.4.3zm-1 .3s-.5.3-1 .3c-.3 0-1 0-1-.4-.1-.5.1-.7.1-.7l-.3.6.1.4.5.3h.7l.6-.3.2-.2zm-1.5-1.4h-.5c-.7 0-1.4-.8-1.4-.8l.5.8 1 .5.4-.5z"
    />
    <path
      fill="#9ca168"
      d="M399.9 240.2c-.3 3.8-4.1 5.8-6.1 7.2-2 1.4-3 3.2-3 3.2l-.6 2.2-.3 1.5-.1.5c.1.4.3 1 .3 2l-.1 4.3 2.7-1.9 1.9-.7.6-.1s-2.2 2.1-3 4.4c-.8 2.3-2.4 7.2-5.3 8.8-3 1.6-4.8 1-5.7 1.8-1 .8-1 1-1 1l-1.3 1.8-1 1.2-.9.7-.6.4a7.5 7.5 0 0 1-.2 1.7l-.7 2.4s.6-.4 1.3-.5h1.3s-.5.6-.7 1.3c-.2.6.1 4.6-3.6 7-3.8 2.3-13.4 2-13.4 2l-1.8.7-1.7 1.3-1.6 1.7v.4s-1.3 1.5-2.1 2l-2.8 1.9 2.2.1 3.5 1.5s-2.2 0-3.6.5c-1.5.6-8.2 4.4-11.4 4.3-3.3-.1-8-4.9-8-4.9l-2-1.4-3.5-.7-4.3-.2v-.6l.1-.7s1.5-.2 3.8.1c2 .2 2.7 1 4.4 1.1 1.7.2 3 0 3.5-.3.7-.3 5.9-4.7 5.9-4.7l5.8-2 2.3.3 1 .2.9.3-1 1a7.3 7.3 0 0 1-1.4 1.1l.7.6 3.7-.6 1.2.3.3.2c0-.3.2-.8.6-1.3.4-.6 2.5-2.3 3.4-2.9l1.4-1c.3-.3 1.5-3.3 1.5-3.3l.1-1.6 4.1-4 2.8-2.9 1.2-3.3-.2-.7s1 1 .9 3c-.2 2.2-.7 2.9-.7 2.9s2.8-2 4.3-2.6c1.2-.5 2-.5 2.4-.5.4-.2 1.5-.9 2.1-1.8.8-1.2 1-1.5 1-2l.2-2.8-.3-7 2.4-5.4 3.5-3.1.7-.4-.4 1.2v1.5s1.8-2.5 2.7-2.9l.5-.3a7 7 0 0 0 .8-2l.3-3v-3l-.5-2.3-1.7-4.3v-5.8l-1.2-1.6s1.1 0 2.5 2a13.5 13.5 0 0 1 1.9 5l3.3-10.3s.9 1.2 1.5 3.3l.8 3.3 1.4-2.8.1 1c.2 1 2.3 2.1 2 6zm-67.3 65s-.7-1.6-3.9-3.2c-3.1-1.5-5.5-1.8-5.5-1.8v1.1l5 2.2 2.4 2 2-.3z"
    />
    <path
      fill="#717732"
      d="M355.4 295.6c.3-.4 3-2.8 4.4-3.5s3.2-.8 3.2-.8c1.9-.4 2.2-.1 6.6-2.5 4.3-2.4 5.3-5.2 6.2-5.9.8-.7 2.3-.8 2.3-.8l-3.4 3.9a28.5 28.5 0 0 1-5.8 4.5 17.8 17.8 0 0 1-7.6 1.8 7.7 7.7 0 0 0-4 2c-1.3 1-2 2.2-2 2.2s-.2-.5 0-.9zm12-12.7c-4 3.7-5.3 7.2-5.3 7.2l5.4-4.9c1.9-1.8 4.5-2.6 5.6-3.7 1.2-1.1 1.3-2 2-2.7l1.3-1s-1.8-1.4-9 5.1zm-8.5 8.6s1.7-.8 2.4-2.3c.5-1.2.2-1.5 1-2.8 0 0 4.2-4 5.7-5.8 2.6-3.1 1.4-5.7 1.4-5.7s.3 1.3-.8 2.7c-1 1.4-6.5 5-7.2 7.2-.6 2.2-.3 2.3-.6 3.4-.6 2.6-1.9 3.3-1.9 3.3zm-2.8 10.5s-2.1-1.4-4.5-1.3c-4.9.4-9 3.4-12.2 3.4-3.1.1-4.4-1.5-6.9-3.2-2.6-1.8-9.2-1.5-9.2-1.5v.3s4.4 0 6.4.6c3.6 1 5.6 4.8 9.7 4.6 5.5-.3 9.9-3.6 12-3.6 3.8 0 4.7.7 4.7.7zm-24-2.4s3.7.6 6.6-1.5c3-2.1 6.4-5 8.3-5.2 2 0 4 .4 4 .4s-2.5-1-4.4-1c-2 0-4 .2-5.8 1.3-1.8 1.1-2.7 3-4.6 4.3a12.8 12.8 0 0 1-4.1 1.7zm-.7 5c-.5 0-1.1.3-1.3.3-.2 0-1.3-1.2-3-2-1.6-1-4-1.4-4-1.4s-.3 0 .3.2l3.8 1.5a8.6 8.6 0 0 1 2.6 2.1c.1.3.6.9 1.5.8 1 0 1.3-.5 1.2-1 0-.3-.6-.5-1.1-.5zm2.6-3.6s1.5.8 4 .8c5.2-.2 8.6-3.8 12-5 3.4-1.4 5.2-.3 5.2-.3s.1-.2 0-.2a7 7 0 0 0-3.9-1.2c-5.7 0-11.2 3.7-13.5 4.7-2.3 1-3.8 1.2-3.8 1.2zm56-39.9c-1.8 1.9-4.5 7.7-5.6 9.3-1.2 1.6-2.7 2-3.3 2.7-.6.6-2.7 3.5-3.2 4.1-.5.7-.6.5-1 .8-.3.3-.5.3.1.2.6-.1.8-.5 1.6-1.5 1-1 .9-1.4 2.3-2.7 1.4-1.2 3.9-2.6 5.1-4.2 1.3-1.5 3.8-7.5 5.2-9 1.4-1.5 4-2.4 4-2.4s-2-.6-5.3 2.7zm-9 11.1s-.1-1 1.2-2.6 1.7-1.3 2.8-3.6c1-2.3 1.5-4.5 2.3-6.9.9-2.4 2.3-4.8 2.3-4.8s-1.3.2-2.7 2a34.5 34.5 0 0 0-4.8 8.7c-1.1 3.4-1.1 7.2-1.1 7.2zm-1.7 2.2s.5-.2.5-3.2c.1-2.9-.1-7 .7-9 .9-2 5.4-7 5.4-7s-1.9.5-4.5 2.5-3.7 4.7-3.6 6.7c.2 2 1.3 4.2 1.4 6.1l.1 4zm10.5-20.1s1.1-4 1.6-5 .5-1.5 2.7-4c1.3-1.5 2.6-2.4 3.1-4.4.6-2 .6-7.7.6-7.7s-.6.5-1.1 1.5c-.5 1-.1 4.7-1 6.4-.8 1.7-2.7 5.6-3.7 6.5 0 0-.2-2.9.2-5.7.3-3 1.3-3.8 1.7-5.7.4-1.9.2-6.7.2-6.7s-1.5 1.5-2.3 3.4c-.8 1.8-1.2 5-1.2 7.5s.5 4.5.6 5.9c.1 1.4.2 2-.4 3.6l-.6 2a34.8 34.8 0 0 1-.7 2.6l.3-.2zm-3.5-21.6s1.4 1.7 1.2 3.6c-.3 2-1 4.5-.2 6.5.7 2 1.9 2.2 2.2 3.4.3 1.2.3 3.4.3 3.4s.6-4.3.2-5.5c-.5-1.1-.7-.6-1.3-1.8s0-4.7-.4-6.7c-.5-2-2-2.9-2-2.9z"
    />
    <path
      fill="#9ca168"
      d="M306.7 304.8s.4-1 3.1-2.4a34 34 0 0 1 7.3-3c.3.3-.3 1.8-.3 1.8l-2.6.8-2.1 1.2-2.5 1.6h-2.9z"
    />
    <path
      fill="#9ca168"
      d="M313.6 297.7c-3.4.1-5.3 1-6 1-.2.1-.7.5-1.2.3a4.9 4.9 0 0 1-1.5-1.5l-.7-.7-.2 2.5-5-4.4-.6 3-.7 1.3-5-4.8.2 3.7-1.4.1-3.6-2.5-1 .4 1.2 2.2-4.6.3-1 .8a6.3 6.3 0 0 0-1 1v.4h1.9c.4-.2.6-.7.7-.5.2.2.3 1.2.9 1.1.6 0 2.7-1.7 4.2-1 1.7.8-2.2 2-1.8 3.1.4 1.2 3.2.7 4 .3.6-.3 2.7-3 3.6-2 1.2 1.4-2.5 2.5-1.8 3.9.6 1.3 2.7 1 3.7.4 1-.5 3.4-4.1 3.9-3.4.9 1.4-2 2.7-1.3 3.7.8 1 2.3 0 3.4-.8s1.5-2.5 3-3.3c1.4-.8 1.3-.5 1.7-.5.4 0 1.5-1.1 1.5-1.1l3.5-1.5 1.6.2.9.4 1.7.2.2-1.4s-2-1-3.3-1zm-27.4 0l.7-1.3-.4-.6s-1.2-.7-2.3-1.8a6.9 6.9 0 0 0-2-1.6L280 291l-.8-2.8-.5-.9-1.3.6-1.7-6.1-.3-1.1h-.7l-1.5 3.6-1.5-2.3-.4-5-1 1-1.3 1.4-2.3-4.6s-.1-.1-.3.3c0 .3-.3 1.8-.1 2.6a26.2 26.2 0 0 1-6-5.2l-1-2.5 1-2 .5-2.6-2.2.9-.4-5.7-.3-1.8-2.7 3.8-1-1.7v-3.6l-.7-.2-1 2s-1.1-2-1.6-2.5c.1-.8.2-2.9-.3-4.5-.6-2-1.3-3.1-1-4.8.2-1.6.9-1.8.8-2.5 0-.8-1.2.5-.8-.5.4-1 3.8-3.2 3.1-4.4-.7-1.1-4 1.9-3.3-.1.8-2 4-2 4.2-4.9.1-1.7-3 1.1-3.3.2-.3-.8 2-2.6 1.9-3.8 0-1 .4-1.2-.2-1.8-.6-.6-2.6 2.3-2.6 2.3l-2-.7-.8 3-.6 2.5-2.6-1.5.7 3.1.6 3-2.7-.7 1.4 2.6 1.9 2 1.1 1.5.9.4 1 1.1.5 1.7.6 1.9.1 1.8v2.4l-.1.4v1.1c-.5 0-1.4-.8-1.7-.3-.3.6 1.6 2 1.2 2.4-.3.4-3-.5-3.2.3-.2 1 .2 2.2 1.8 2.6s5.3 1.2 4.7 2c-.6.7-4.7-2.3-4.5-.1a3.8 3.8 0 0 0 2.6 3.4c1 .4 5.1 0 4.9 1-.3.9-3.3-.4-3.6 1-.3 1.4 2.1 1.6 2.6 1.6s2.2-.1 2.9.4l4.3 4.1a75.7 75.7 0 0 0 4.6 3.4c-.8 0-2.4-.3-2.6.3-.3.7 6 3 4.2 3.8-1.8.7-3.8-2-4.3-.4-.6 1.7 1.2 3 2.2 3.6 1 .6 6.7.1 5.6 1.4-1.1 1.3-5.3-.8-5.3.7s2.7 4 4.2 3.9c1.4 0 3-2.4 3.6-1.1.7 1.2-1 1.7.3 2 1.4.4 2.3-1.4 4-1 1.5.3 4 1.3 5.4 2.5a79 79 0 0 1 2.9 2.8z"
    />
    <path
      fill="#717732"
      d="M308.4 304.1c1 0 1 .6 1.2.6.1 0 1.8-1.5 3.3-2.3a17.5 17.5 0 0 1 4-1.4l.1.2s-2.8.7-4.2 1.7l-3 2.1c-.2.2-.8.7-1.7.7-1 0-1.4-.6-1.4-.9 0-.2.7-.7 1.7-.7zm8.5-4.3s-.9.1-1.3-.3a4.3 4.3 0 0 0-2.6-.8 7 7 0 0 0-4 1.8c0 .1-.3.6-1.4 1.3.4.1 1.1-.4 2-1a7.4 7.4 0 0 1 3.6-1.4c1-.2 1.7.4 2.2.7.5.4 1.4.3 1.4.3v-.6zm-50.5-20.6v-.7a16.1 16.1 0 0 1-2.2-1.1c-1.6-1-5-3.8-5-3.8l2.8 2.7c1.4 1.3 4 2.9 4 2.9h.4zm35.6 25.2l1.5-2.1c.9-1.5 1.7-2 1.9-2.2.1-.2-.4-.9-.7-1.4l-.2-1.2s.4.8 1 1.3a9.5 9.5 0 0 1 1.1 1s1.4-.2 1.4-.5c0-.2 0-.4-.2-.5-.3-.1-.5.2-1.1 0-1.3-.6-1.8-2.6-2.6-2.6-.8-.1-.2 2-.6 2-1.1.2-2-4.3-5-4.5-2 0-2.3.3-2.4.7 0 .5 2.5 3.1 1.6 3.5-.8.4-3.5-4.2-5.5-4.2-1.9 0-2 .7-2 1.1.2.4 2.2.8 1.8 2.2-.5 1.4-2.5-2-4.3-1.9-1.8.2-2 .3-2 .9-.1.5.6 1.2.3 1.4-.2.2-1.4.1-2.3.7-.9.7-2.1 2.4-2.1 2.4s1.2-1.7 2.7-1.9a50 50 0 0 1 5.6 0l-1.1-.8c-.6-.5-1.1-1.6-1.1-1.6l1.7 1.5c.8.7 1.9 1.2 1.9 1.2s1.7.2 1.8.4c.1.2 0 .6-.8 1.3l-1.7 1.7 2-1.6 1.5-1.2 1.4.2c.1 0 0-.5-.8-1.7l-1.6-2.5s1 .9 2 2.3c1.1 1.3 1 2 1.4 2 .4 0 1 .2 1.4.1.4 0 .3.6-.4 1.7s-1.2 2.5-1.2 2.5.8-1.2 1.6-2c.7-.8 1.1-1.7 1.5-1.8h1.5l-.8-1.6c-.6-1-.8-2.6-.8-2.6s.6 1.4 1.4 2.5l1.3 1.9 1.4-.1.3.1c0 .5-.2.7-.7 1.8a17.7 17.7 0 0 0-1 2.1zM280.5 292c1.2.5 1.7.5 1.7.5s-1.7-1-2.1-2.4c-.5-1.4 0-4.4-.8-4.3-.7 0-1.1 2.1-1.8 1.7-.8-.4.2-4.4-.6-6-.8-1.7-2.6-2.9-3-2.3-.4.6-.3 4.2-1.5 3.5-1.1-.8.1-4-.2-5.3-.4-1.5-1.2-2.5-1.9-2.1-.6.3.3 3-.7 3s-.9-1.9-1.3-2c-.5-.2-.6.3-.9 0-.2-.4 0-1.7-.6-1.6-.6.1-.5 1.2-.3 1.7.1.6.5 1.4.7 1.8.2.4 1 .9 1 1.2-.1.3-.5.6-1 .6h-1.9s1.4.4 1.9.4 1.4-.2 1.7.2c.2.5 1.4 2 1.4 2s.3-.8.4-2.2c.2-1.5 0-2.7 0-2.7s.5 1.6.4 2.7c0 1-.4 3-.4 3s1.1.8.8 1c-.3.3-1.5.3-2.8.3-1.4 0-3.3-.5-3.3-.5a13.7 13.7 0 0 0 6.7 1.3l1.8 2s.9-1.5 1-3v-3l.4 2.8c0 1.3-.4 3.6-.6 3.8a5 5 0 0 1-1.9 1l-3.5.5s2.2.3 3.8 0c1.5-.4 1.7-.9 2.2-.6l.8.7 1.3 1c.1.1-.7.4-1 .7l-1.5.7 2.2-.7a22.3 22.3 0 0 0 1.1-.4l.5.2-.1-1.2-.3-1.8s.5.8.7 1.6l.1 1.6s.2.2 1.4.6zm-31.1-35.6s.3-1.7.3-3.6a14.3 14.3 0 0 0-1.9-5.8l1-1.4-1.2 1-1.2-.5a3 3 0 0 1-.9-1l1.2.8c.6.2.7.1.7.1l-.5-2-1.9-1c-1.3-.6-2.5-1.8-2.5-1.8l2.8 1.5c1 .4 1.6.4 1.6.4l1.6-.6 1.7-1.1s-1 .6-1.8.7l-1.6.3-.3-2.4-1.1-1.1c-.9-1.2-1.6-2.9-1.6-2.9s1 1.2 1.7 1.7c.7.6 1.4 1.5 1.4 1.5l1.6-1 2.8-2-2.7 1.3-1.6.7s-.2-1 0-1.5c.3-.4.8-1.2.7-1.6 0-.5-.4-.3-.5-.7-.2-.3.4-2.6.4-2.6l.1 1.2c0 .5-.2 1 .4 1 .6 0 3.2-2.7 3.6-3.2.3-.5.8-1.8-.6-1.3-1.4.6-1 1.8-2.2 1.7-.4 0-.8-1.5-1.2-1.2-.4.4-1.4 1.3-1.6 2.4-.2 1 .2 2.6-.4 3.1-.6.5-1-1.8-2.2-1.5-1.2.3-1.5 2-1.3 2.6.2.6 2.7 3.5 2 4-.9.3-2.9-2.6-4-.6-1 1.9 3.4 4 4 4.4.5.5 0 .6.8 1.6s1.8 1.2 2.4 1.8a13 13 0 0 1 2.1 5.9l-.1 2.7zm11.7 17.1s-1-1.2-.7-3.3c.3-2 1.8-5.7 1.3-6.2s-2 2.2-2.4 1.6c-.4-.6.9-4.3.2-5.8-.6-1.5-.7-2.5-2-2.3-1.3.1-1.8 4.4-2.5 3.6-.6-.7.4-2.6 0-3.7-.5-1-.7-1.3-1.3-1.2-.7.2-1 2.2-1.4 2.1-.5 0-1.2-2.3-2.2-2-.9.3 2.3 4.5 2.3 4.5s.5-.5.8-1.2l.6-1.5s.3 1.3 0 1.9c-.2.5-.3 1.7-.3 1.7s-.8.3-2.1 0a8.8 8.8 0 0 1-2.3-.7s.8.6 2.1 1l2.7.7a44.9 44.9 0 0 0 2 2.7l.8-2.1 1.3-3.5-.6 3.9-.7 3s-1 0-2.6-.3l-3.6-.8 3.6 1.2 2.8.7 1.4 1.9 1-1.5 1-1.8s-.3 1.4-.7 2.3a27.4 27.4 0 0 1-.7 1.4l-1.8.2h-2.5a19.6 19.6 0 0 0 4.5.9s0 .5.7 1.3a4.6 4.6 0 0 0 1.3 1.3z"
    />
    <path
      fill="#fff"
      d="M314.4 310.8s-.6-.6-1.4-1c-.9-.5-1.2-.4-1.2-.4l-.4-.1.8-2 5.5-5.3.9-5.3h3.4v7.2l1 .5 6.2 3.7v1.6l-1 .4-.7.4-2.3.2-4-3-1.8-1.7-3 4-2 .8z"
    />
    <path
      fill="#016848"
      d="M318.8 296.7l-.1 1c0 .9 0 5.2-.2 5.8-.2.6-3.2 1.8-4.9 3.3-1.7 1.5-1.8 2.6-1.8 2.6s-.5 0-1.6.4c-1 .4-1.5 1-1.5 1s.6-2.6 3.4-5c2.7-2.6 4-2.8 4.4-3.2.3-.4 0-5 0-5.5.1-.4.5-.4.7-.4h1.6zm7 15.7l.8-1.1 1-.8-1.5-.8c-1.5-.6-2.3-.4-3.3-1.2a13.6 13.6 0 0 1-2.2-2l-1.5 1.2 1.7 2c.9.8 2.7 1.1 3.5 1.6a8.8 8.8 0 0 1 1.6 1.1z"
    />
    <path
      fill="#cd202a"
      d="M321.5 296.6s1.7 0 1.9.2l.2.6c0 .1 0 4-.2 5.3a8 8 0 0 1-1.4 3l-4 3.7c-1.2 1.2-2.4 2.8-2.4 2.8l-.8-1c-.3-.4-.7-.6-.6-.9a10 10 0 0 1 3.3-3.4c2-1.3 3.6-2.8 4-4.9.3-2 0-5.4 0-5.4z"
    />
    <path
      fill="#cd202a"
      d="M332.5 310s-.4-.4-1.8-.4l-1.5.1s-.8-1-2-1.7c-1.2-.8-2.1-.7-3.5-1.6-1.3-.8-2-2.1-2-2.1l1-2s1.2 1.5 2.4 2.4c1.1.9 3.7 1.7 4.6 2.4l2.8 2.9z"
    />
    <path
      fill="#30c2dc"
      stroke="#0872a7"
      strokeWidth={0.5}
      d="M345 286.4s-3.6-1.4-3.4-2.7c.3-1.2 8.3-3.3 8.3-3.3l.1-2.1s-1.2-.1-3.2.5c-2 .7-5.2 1.6-8.6 1.6a1735.4 1735.4 0 0 0-34.4-2.2c-3.7-.3-6-6-6-6l-1.8.4s.5 2.7-.4 3a65 65 0 0 1-13.9-6l-.6 2.6s7.3 4 7.1 5.5c-.2 1.4-2.4 1.3-2.4 1.3l1 1.8c.3 0 12 .6 12.3 4.1 0 1.5-3 2.3-3 2.3l1 1.2v.6s6.7 0 8.5 1c1.8 1 2.7 2.6 5 3.8 2.2 1.3 17.3 1 19.6.3 2.7-.7 4.3-3.7 8.7-5 4.3-1.4 5.7-1.4 5.7-1.4z"
    />
    <circle cx={284.5} cy={280.7} r={2.1} fill="#fff" stroke="#0872a7" />
    <circle cx={296.4} cy={270.9} r={2.1} fill="#fff" stroke="#0872a7" />
    <circle cx={346.5} cy={286.6} r={2.1} fill="#fff" stroke="#0872a7" />
    <path
      fill="#f8c83c"
      d="M275.1 267.8c-.7 1.6 2 4.6 4 5 1.8.2 2.8-.2 3.2-1.1a2.8 2.8 0 0 0-.4-2.5c-1.2-1.7-6-3-6.8-1.4z"
    />
    <path
      fill="#fff"
      d="M281 270.2c0-1-1.6-1.9-2.6-1.9s-2 0-1.8.5c.1.6 2.7 1.3 2.8 1.6 0 .3-.8.6-.4 1 .5.4 1 .1 1.4-.2.4-.3.7-.4.7-1z"
    />
    <path
      fill="#f8c83c"
      d="M297.7 288.3c.4 1.4-.7 2-2 2.7-1.5.6-4.3.2-5-.9-.6-1.1 1-3 2.8-3.4 1.7-.4 3.8.3 4.2 1.6z"
    />
    <path
      fill="#fff"
      d="M294.8 289c.5 0 .6 1 1 .8.5 0 1-.8.8-1.3-.1-.6-1-1.3-1.8-1.2-.8 0-3 2-2.8 2.5.2.5.8.5 1.2.3.4-.2 1-1 1.6-1z"
    />
    <path
      fill="#f8c83c"
      d="M349.2 281c1.3 1.7 3.6.2 4.2-.5.6-.6 2.4-1.7 1.7-2.8-.8-1.1-2-1-3-1-.8 0-2.6 1.4-2.9 2-.3.5-.6 1.6 0 2.4z"
    />
    <path
      fill="#fff"
      d="M349.6 280s.1-1.9 1.8-2c1 0 1 .3 1.8.7.7.4 1-.5 1-.5s0 1.3-1.1 1.3c-1.2 0-.8-.5-2-.7-1-.2-1.5 1.1-1.5 1.1z"
    />
    <path
      fill="#f9aa51"
      stroke="#953220"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M321.9 276.4l-.9-.6h-2.8l-3.4.1 3.4 9.9 4 5.8 1.6.6 3.1-.2.6-1.6-1.2-9.5-4.4-4.5z"
    />
    <path
      fill="#f9aa51"
      stroke="#953220"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M310.6 277l.2-1.1 1.8-.1a7.2 7.2 0 0 1 2.2.1s2.3 2.9 3.1 4.7c.8 1.8 1.7 4.8 2.7 6.6 1 1.9 3.2 5 3.2 5h-4l-2-.6-5.6-9-1.6-5.6z"
    />
    <path
      fill="#f9aa51"
      stroke="#953220"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M308.2 275.8h2.6a14 14 0 0 1 3.9 5.4c1 2.8.5 3.2 1.8 6.2 1.4 2.9 3.2 4.9 3.2 4.9s-3.9.2-6-.2c-2.3-.4-3-.3-3.6-1a9.2 9.2 0 0 0-1.7-1.3h-2.2l.5-3.1-.6-6.9.1-3.5 2-.5zm23.4 1.8l-3.7-1.5-7-.4.6 3.6a30.2 30.2 0 0 0 2.6 7.7c1.1 2 2.2 4.4 2.8 5 .6.5 4.6-1.1 4.6-1.1l2.6-.4-.3-2.8-.4-1 .6-8-.6-1.2-1.8.1z"
    />
    <path
      fill="#f9aa51"
      stroke="#953220"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M307.1 277.7c0 .8 1 .9 1.2.8.2 0 1-.3 1-1.5s-.7-2.1-2.2-2.2c-1.4 0-2.5 1.7-2.5 3 0 1.2 1.2 1.8 1.2 2.3 0 0-1.2 1.1-1.1 3.1 0 2 1.6 3.6 1.6 3.6s-1.7 1.3-1.7 2.7c0 1.4 1.3 2.3 2.6 2.3 1.2 0 2.8-.8 2.8-1.8s-1-1.7-1.7-1.7c-.8 0-1.1.5-1.1.8m25.6-10.9c0 .9-.6 1-1 1s-1.2-.4-1.2-1.5c0-1 1.4-1.6 2.4-1.6.9 0 2.4 1.2 2.4 2.7 0 1.5-1 2.6-1 2.6s.6.3.6 2.2c0 2-1.2 3.3-1.2 3.3s1.6.6 1.6 2.6-1.4 2.6-2.3 2.6c-1 0-2.6-.5-2.6-1.9 0-1.3.8-1.8 1.5-1.8.6 0 1.3.7 1.3 1.5"
    />
    <path
      fill="#953220"
      d="M309.5 288.6l.4.6c.2.4.3 1 .8 1.4.8.7 7.2 1 9.2 1 2 0 7.8.2 8.9-.4 1-.7 1.2-1.8 1.9-2.3l.9-.4-.9.7v1.4l.5.8s-.1.4-.8.8c-.7.4-1.3.5-2.3.6-1 .1-13.2.1-15.2-.2-2-.4-1.8-.3-2.4-.7a4.3 4.3 0 0 1-1-1l.3-.8-.3-1.4zm20-11.8l1 .5s-.9.3-1.6 2.3c-.7 2-.1 2.5-.6 2.7-.5.2-5.8 0-5.8 0l-1-2.1 8-3.3z"
    />
    <path
      fill="#231f20"
      d="M346.4 276s-.9-.3-1.3-1c-.4-.8-.8-1.7-.5-2 .4-.1 1 .5 1 1.1 0 .6.8 2 .8 2zm10.4-2.8s.7 1.2 1 1.3l1.2.6s-1.5 0-2-.4a8.3 8.3 0 0 1-1-1.5h.8z"
    />
    <path
      fill="#231f20"
      d="M360 274.2s-1 .5-1.6.2c-.8-.3-1.4-.7-1-1 .2-.4.4-.3.8.2.4.4 1.8.6 1.8.6zm5.3-4.5s-.8.6-1.3.6-1.5-.2-1.5-.4 1.3-.4 1.6-.3h1.2zm-8-10.5s-1.1.4-1.5 1c-.4.5-.3 1.2.2 1.2s.6-.7.6-1l.7-1.2zm-5.2 2.9s-.9.5-1 1c-.3.5-.5 1.6 0 1.6s.7-.8.7-1.2c0-.5.3-1.4.3-1.4z"
    />
    <path
      fill="#8cbebf"
      stroke="#04534e"
      strokeWidth={0.5}
      d="M342.8 268.4l-2.9 3s6.6 3.7 11.7 3.5c5-.1 10.8-4 11.2-5 .4-.7 0-4.3-.6-5.4-.7-1.1-4.2-3.8-5.5-3.7-1.3.1-3.7 1.9-5.8 4-2.2 2.1-2 3.9-5 3.7l-3.1-.1z"
    />
    <path
      fill="#0c8489"
      d="M342 269.6s7 1 9.1-.8c2-1.8 4.3-5.3 5.7-6 1.4-.9 2-.9 2-.9l1.6 1.1 1.8 1.5.6 3.4v1.8l-2.2 1.8-4 1.9-4 1.2-3.2-.1-6.7-2-1.7-1.1-.4-.4 1.4-1.4z"
    />
    <path
      fill="#04534e"
      d="M352.8 265.5c0-.6.4-.6 1-.6s1 .2 1 .8-.5 1.4-1 1.4c-.6 0-1-1-1-1.6zm2.8 1.8c0-.6.4-.8 1-.8.7 0 1.3.7 1.3 1.2s-.5 1-1.1 1c-.7 0-1.2-.9-1.2-1.4zm-1 4.2c0-.7.5-.8 1.1-.8.6 0 1 .3 1 1a1.2 1.2 0 0 1-1.1 1.2c-.7 0-1-.7-1-1.4zm-3.7-1.3c0-.7.7-1 1.3-1 .6 0 1 .7 1 1.4s-.4 1.3-1 1.3-1.3-1-1.3-1.7zm-5.9.7a1.4 1.4 0 1 1 3 0 1.4 1.4 0 0 1-3 0z"
    />
    <path
      fill="#8cbebf"
      d="M355.6 267.3c0-.5.7-.8 1-.8.5 0 .8.4.8.8s-.3 1-.7 1c-.4 0-1-.5-1-1zm-1 4c0-.5.6-.8 1.2-.8s1 .3 1 .8-.5 1-1 1c-.6 0-1.1-.4-1.1-1zm-3.7-1.2c0-.6 1-.9 1.5-.9.4 0 .3.4.3 1 0 .7-.3 1.2-.7 1.2s-1-.7-1-1.3zm1.8-4.7c0-.5.4-.5.8-.5s.6.1.6.7-.3 1-.6 1c-.4 0-.8-.6-.8-1.2zm-7.7 5.1c0-.6.6-1.3 1.4-1.3s1.7.3 1.7 1c0 .6-1 1.8-1.8 1.8-.9 0-1.3-.8-1.3-1.5z"
    />
    <path
      fill="#231f20"
      d="M347.7 269.4s-1 .1-1.5.6-.5 1-.3 1.2c.3.2.7-.3.8-.6 0-.2 1-1.2 1-1.2zm4.7-1s-1 .6-1 1.3c-.1.6 0 1 .2 1 .3 0 .5-.9.4-1.2-.1-.3.4-1.2.4-1.2z"
    />
    <path
      fill="#231f20"
      d="M353.2 269.3s-.6 0-1 .4c-.5.5-.9 1-.6 1 .3 0 .8-.2.8-.5 0-.2.8-.9.8-.9zm1-5.4l-.8.6c-.2.2-.5 1-.2 1 .3.2.5 0 .8-.5.2-.5.2-1.1.2-1.1zm3.5 2.3s-.9 0-1.2.5c-.3.4-.5.8 0 .8.3 0 .4-.2.6-.5.1-.4.6-.8.6-.8zm-.5 4.1s-.2.7-.8 1c-.5.3-.7.5-1 .1-.1-.4.2-.6.4-.7l1.4-.4z"
    />
    <path
      fill="#04534e"
      d="M362.8 267.5s.4 2-1.3 3c-1.7.9-6.4 4.2-10.9 3.8-4.5-.4-9.6-3-9.6-3l-.7.4 1.2.5 3.4 1.4 4 1.2 2.5.1 2.1-.2 4-1.3 3.3-1.7 1.8-1.4.4-.6v-1.9l-.2-.3z"
    />
    <path
      fill="#231f20"
      d="M274.9 242.2s1 .9 1 1.6c-.2.8-.4 1.1-.7 1-.3-.2-.3-1-.3-1.3v-1.3zm7.7 7.1s-.3 1.4-.9 1.5c-.5.1-.9-.4-.8-.7.1-.2.6 0 .8-.2l.9-.6zm-16.8 1s.4.8 1 1c.8 0 1-.4 1-.6-.1-.2-.4-.2-.8-.2l-1.2-.1zm3 6s.7.6 1.5.7a1.3 1.3 0 0 0 1.3-.7c0-.2-1-.2-1.3 0-.3.3-1.5 0-1.5 0zm5.3 4.4s1.4-.2 1.6-.6c.2-.4.6-1 .3-1.3-.3-.4-.5.5-.7.9-.1.3-1.2 1-1.2 1z"
    />
    <path
      fill="#8cbebf"
      stroke="#04534e"
      strokeWidth={0.5}
      d="M282.6 257.1s1-6-4-10.4c-5-4.3-8.1-3.2-9.8-1.6-1.7 1.6-3.2 6.7 2 11.3 5.3 4.5 11.7 3 11.7 3l.1-2.3z"
    />
    <path
      fill="#0c8489"
      d="M267.6 250.7s-.1-3.4 1.5-4.4c1.5-1 6.8-1.8 9.3 3.1 2.6 5 2.7 7.4 2 10h-2.7l-4.3-1.8-3.5-2.6-2.3-4.3z"
    />
    <path
      fill="#04534e"
      d="M282 258s-.9 1-2.7 1c-1.7-.2-10-2.3-12-9.8v1.7l.1.5.6 1.5 1.7 2.5 2.2 1.9 2.8 1.4 2 .6 2.5.4h1.5l1.3-1.7z"
    />
    <path
      fill="#04534e"
      d="M277.7 255.9c0-.7.3-.7.8-.7s1-.2 1 .4c0 .7-.4 1.6-1 1.6-.4 0-.8-.7-.8-1.3zm.3-4c0-.4.4-.8 1-.8.5 0 .9.4.9.9 0 .4-.4.8-1 .8-.5 0-.9-.4-.9-.8zm-3.7 4.4c0-.4.4-.7 1-.7s1 .3 1 .7c0 .3-1 .8-1.5.8-.6 0-.5-.5-.5-.8zm-.4-4.6c0-.6.3-.4.8-.4s1.2.1 1.2.7-.7 1.4-1.2 1.4-.8-1.2-.8-1.7zm-3.4.7c0-.5.3-1.1.9-1.1s1.3.6 1.3 1.1c0 .5-.5 1-1.1 1-.6 0-1.1-.5-1.1-1zm.6-4c0-.6.3-.5 1-.5.6 0 1.1.2 1.1.7 0 .5-.7 1.2-1.4 1.2-.6 0-.7-1-.7-1.5zm3.7-.5c0-.4.5-.3 1-.3.7 0 1.1.4 1.1 1s-.7 1-1.3 1c-.6 0-.8-1.2-.8-1.6z"
    />
    <path
      fill="#8cbebf"
      d="M271 248.3c.2-.4.4-.7.8-.7.5 0 .9.1.9.7 0 .4-.4.9-.8.9-.5 0-1-.5-.8-1zm-.6 4c0-.5.2-1 .7-1s1 0 1 .5-.5 1.1-1 1.1-.7-.1-.7-.6zm4.4-4.3c0-.4.3-.4.8-.4s.8 0 .8.5c0 .4-.4.7-.8.7s-.8-.4-.8-.8zm-.9 3.9c0 .5.5 1 1 1s1-.5 1-1c0-.6-.6-1-1-1s-1 .4-1 1zm4.3-.6c0 .5.4.9 1 .9.5 0 .9-.4.9-.9s-.5-.9-1-.9-1 .4-1 1zm-4.1 5c0-.5.5-.9.9-.9s.9.3.9.7c0 .4-.8 1-1.2 1-.5 0-.6-.4-.6-.9zm3.6-.7c0-.5.4-.6 1-.6.5 0 .8.1.8.6 0 .6-.5 1-1 1s-.8-.5-.8-1z"
    />
    <path
      fill="#231f20"
      d="M278.7 249.4s.5.7.6 1.3v1.2c-.3 0-.6-.4-.7-.9-.1-.5 0-1.6 0-1.6zm-3.2-3.3s.4.5.4 1 0 1-.3 1-.3-.4-.3-.8l.2-1.2zm-3.7.5s.4.5.4 1 0 1-.3 1-.3-.4-.3-.8l.2-1.2z"
    />
    <path
      fill="#231f20"
      d="M270.5 247.3l1 .4c.3.4.5.8.3 1-.1.2-.5-.1-.6-.4l-.7-1zm2.8 3.8s.7 0 1.1.5c.4.3.8.6.5.9-.2.2-.7-.2-1-.5l-.6-.9zm-3.4 0l1 .3c.3.2.4.7.2.8-.1.1-.4 0-.6-.4l-.6-.8zm8.3 2.5l.2 1.4c0 .5.1 1-.2 1s-.3-.7-.3-1c0-.5.3-1.4.3-1.4z"
    />
    <path
      fill="#231f20"
      d="M277.3 254.9l.8.5c.3.2.3.6.1.6l-.4-.5a9.2 9.2 0 0 1-.5-.6zm-3.7.2l.9.3c.2.2.3 1 .2 1.1 0 .1-.4 0-.6-.3l-.5-1z"
    />
    <path
      fill="#04534e"
      d="M272.1 243.8s-3.2.7-3.8 2.9c-.6 2-.7 4.4-.7 4.4l-.4-2.7.6-1.7 1-1.6 1.4-1 1.3-.4.6.1zm10.2 12.5s.4-.8-.6-3.4c-1-2.5-3-6-3-6l1.6 1.8 1.2 2 .6 1.8.5 1.7v1.6l-.3.6z"
    />
    <path
      fill="#231f20"
      d="M285.6 252.2s1.2.7 1.3 1.1c.1.4.2.6-.1.7-.3.1-.8-.4-1-.7a6.5 6.5 0 0 1-.2-1.1zm-4.8 12.8s.6-1 1.3-1.3c.7-.4 1.2-.4 1.4-.1.2.2-.4.7-1 .9l-1.7.6zm8.1 3.1s.8-.4 1.3-1c.5-.5.6-.9.4-1-.2-.3-.8 0-1.1.5-.3.4-.6 1.5-.6 1.5zm-.9-.7s.3-1 .6-1.4c.3-.3.6-.5 1-.3.2.2 0 .6-.2.9a7.8 7.8 0 0 1-1.4.8z"
    />
    <path
      fill="#8cbebf"
      stroke="#04534e"
      strokeWidth={0.5}
      d="M301.5 261.2s-5-7.2-12.8-7.6a7.4 7.4 0 0 0-8 7c.2 1.6 2.6 5.2 10.9 5.8 8.3.6 9.6-3.9 10-4.1.3-.2-.1-1-.1-1z"
    />
    <path
      fill="#0c8489"
      d="M295.6 256.3s2 1.5 3 2.8c.8 1.2 1 2.2.5 2.3-.5.2-5-4-8.8-4.9-3.7-.9-6.9 0-7.6 1.7s-.4 4.5 1.2 5.6c1.8 1 9.7 2.3 9.7 2.3l3.7-.5 2.3-1.3.5-1.3.6-1.6.2-.7-1.9-2-3.4-2.5z"
    />
    <path
      fill="#04534e"
      d="M289.2 257.3c0 .4-.5.7-1 .7s-.9-.3-.9-.7c0-.5.4-.9 1-.9s1 .4 1 .9zm-4.6 1.6c0-.5.6-.4 1-.4.6 0 1 .3 1 .8s-.8 1.1-1.3.9c-.6-.3-.7-.8-.7-1.3zm5 2.7c0-.6.4-1 1-1 .7 0 1.2.4 1.2 1s-.8 1.2-1.5 1.2-.7-.6-.7-1.2z"
    />
    <path
      fill="#8cbebf"
      d="M285.8 262.7c0-.5.6-.6 1-.6.5 0 1 .5 1 1s-.5.9-1 .9c-.4 0-1-.8-1-1.3z"
    />
    <path
      fill="#04534e"
      d="M292.5 264.5c0-.4.2-.8.7-.8.4 0 1 .3 1 .7 0 .4-.5.9-1 .9a.8.8 0 0 1-.7-.8zm3-2.3c0-.5.3-.4.8-.4s1 .2 1 .8-.6.8-1.1.8c-.5 0-.7-.6-.7-1.2z"
    />
    <path
      fill="#8cbebf"
      d="M289 256.9c0 .4-.2.6-.7.6s-.9-.2-.9-.6c0-.5.2-.6.6-.6s1 .1 1 .6zm-2.5 1.9c0 .5-.7.7-1 .7-.5 0-.8-.2-.8-.7 0-.5.3-.6.8-.6s1 .1 1 .6zm1 3.8c0 .4 0 .7-.5.7s-1-.3-1-.7c0-.4 0-.7.5-.7s1.1.3 1.1.7zm4-1.3c0 .4-.7 1-1.2 1-.4 0-.6-.9-.6-1.3s.4-.7.8-.7 1 .6 1 1zm5.8 1.3c0 .4-.7.4-1 .4-.5 0-.8-.5-.8-1 0-.4.1-.8 1-.7.5 0 .8.8.8 1.3zm-3.4 1.7c0 .5-.3.8-.7.8a.8.8 0 0 1-.8-.8c0-.4.4-.6.8-.6s.7.2.7.6z"
    />
    <path
      fill="#231f20"
      d="M294.4 262s.8-.3 1.5-.3c.6 0 .6.3.6.4 0 .1-.5.3-.7.2a86.2 86.2 0 0 1-1.4-.4zm-3.3 2.8s.6-.4 1.1-.5c.5-.1.9 0 .8.4 0 .3-.2.3-.6.3l-1.3-.2zm-2.2-5s1.4.6 1.7 1.1c.3.6.4.7.1.9-.3.2-.6-.2-.8-.5l-1-1.5z"
    />
    <path
      fill="#231f20"
      d="M288.5 261.6l1.6-.3c.5 0 .6 0 .7.2 0 .2-.1.3-.5.3l-1.8-.2zm-3.4 0s1.2.2 1.5.5c.3.3.3.6.1.7 0 .2-.6.1-.8 0l-.8-1.2z"
    />
    <path
      fill="#231f20"
      d="M285 263.3s.4-.7.8-.8 1-.1 1 .1c.1.2-.4.5-.7.6l-1.2.1zm-1-5.1l1.2.3c.4.3.5.6.4.7 0 .1-.5.2-.8 0-.5-.4-.7-1-.7-1zm2.6-3s1.2.4 1.6 1c.4.5.3.8.1.9l-.9-.4c-.3-.3-.8-1.4-.8-1.4z"
    />
    <path
      fill="#04534e"
      d="M300 263.7s-2.3 2-7.7 1.9c-5.5-.2-10.4-2.5-11.6-5l.5 1.2 1.2 1.6 3.8 2 4.3.9 3.3.2 3.2-.6 2.5-1.1.4-.7.2-.4zm.8-2.5s-.9-1.2-2.2-2.3c-1.2-1.2-6.2-4.4-6.2-4.4l4 1.8 2.7 2.2 1.8 2-.1.7z"
    />
    <path
      fill="#231f20"
      d="M301 256.4s1.4.5 1.6.8l.5.6s-.3 1-.6.6l-.8-.9-.7-1.1zm4-2.2s1.3.5 1.8 1.1c.5.7.4 1.2.2 1.3-.2 0-1-.7-1.2-1a47.3 47.3 0 0 0-.7-1.4z"
    />
    <path
      fill="#231f20"
      d="M306.4 254s1.2.8 1.4 1.2c.1.4.5 1 .1 1-.3.2-.9-.4-1-.8l-.6-1.5zm6.8 1.5s1 .4 1 1.2v1.3l-.7-.7v-.7l-.3-1zm1.8.7s.8.7.9 1.2c0 .5.2.8-.3 1-.4 0-.6-.5-.6-1v-1.2zm-12.3 15s.6.2 1.2 0c.5-.2 1-.7.9-1-.1-.4-.4-.7-.8-.2-.4.4-.2.6-.5.8l-.7.3zm6.8 1.8s.9-.2 1.5-.9c.6-.6.9-1 .5-1.2-.4-.2-1 0-1 .5l-1 1.6zm5.5.1l1.3-.9c.5-.4.7-.7.4-1-.3-.5-.6-.2-.8 0l-.2.7-.6 1.2z"
    />
    <path
      fill="#231f20"
      d="M316.7 273.1s.8-.9 1-1.4c.1-.5.2-1-.1-1-.4 0-.8.5-.8.9v1.5z"
    />
    <path
      fill="#8cbebf"
      stroke="#04534e"
      strokeWidth={0.5}
      d="M299.9 264.1c0-2.4 3.5-8 7.5-8 1.6 0 4.9 1 7.5 2.1 2.2 1 3 2 4.4 2.4 1.5.4 3.7.1 3.7.1l5-.5-4 5.7-1.4 1.2s-1.2 2.4-4.7 3.8c-3.6 1.4-9.5.4-12.2-.3-2.7-.7-6-3.2-5.8-6.5z"
    />
    <path
      fill="#04534e"
      d="M299.9 264.1h.2c0-.5.2-1.3.6-2.1a12.2 12.2 0 0 1 2.7-3.8c1.1-1 2.5-1.8 3.9-1.8.8 0 2 .2 3.4.6a29.4 29.4 0 0 1 4.1 1.4c1 .5 1.8 1 2.4 1.5.7.4 1.3.8 2 1a9 9 0 0 0 2 .2l1.8-.1 4.4-.5-3.6 5.2-1.4 1.2v.1a9 9 0 0 1-4.6 3.7c-1.3.4-2.8.6-4.5.6-2.8 0-5.9-.5-7.6-1a8.4 8.4 0 0 1-3.8-2.1 5.7 5.7 0 0 1-1.8-4h-.5c0 1.7.8 3.2 2 4.4a9 9 0 0 0 4 2.3c1.7.4 4.8 1 7.7 1a14 14 0 0 0 4.7-.7 9.4 9.4 0 0 0 4.9-4h-.3l.2.1 1.4-1.3 4.3-6.2-5.6.7h-.1a14.8 14.8 0 0 1-3.4-.1 5.5 5.5 0 0 1-1.9-1c-.6-.4-1.4-1-2.5-1.4a29 29 0 0 0-4.2-1.5c-1.3-.4-2.6-.6-3.4-.6h-.1c-1 0-2 .3-3 1a11.2 11.2 0 0 0-3.3 3.5 8.3 8.3 0 0 0-1.4 3.7h.3z"
    />
    <path
      fill="#0c8489"
      d="M324 264.9c-.4.3-1 .3-1.4.3-.5 0-11.6-6.7-15-6.4-3.5.3-6.8 1.7-6.9 5.3 0 3.5.8 3.5 1.5 4.5s7.5 2.5 7.5 2.5h4.1l3.3-.4 3-1.6 1.5-1.3 1.1-1.3 1.3-1.6z"
    />
    <path
      fill="#04534e"
      d="M306.5 263c0 .8-.3 1.3-1 1.3-.6 0-1.1-.3-1.1-1s.4-1 1-1c.7 0 1 .1 1 .8zm1.1-3c0-.6.6-.8 1.2-.8.7 0 1.2.2 1.2.8 0 .6-.5 1-1.2 1-.6 0-1.2-.4-1.2-1zm6.7 1.8c0-.5.4-.9 1-.9.5 0 .9.4.9 1s-.4.8-1 .8a1 1 0 0 1-1-.9zm1.3 4c0-.6.5-1 1-1 .6 0 1.2.2 1.2.8s-.2 1.3-.8 1.3c-.6 0-1.4-.4-1.4-1zm-3.2 2.7c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1 0 .5-.5.9-1 .9-.7 0-1.2-.4-1.2-1zm-6-1c0-.6.3-1 .9-1a1 1 0 1 1 0 1.9 1 1 0 0 1-1-1z"
    />
    <path
      fill="#8cbebf"
      d="M306.4 263c0 .5-.4 1-1 1a1 1 0 0 1-1-1c0-.6.4-.8 1-.8s1 .2 1 .7zm3.3-3.2c0 .5-.2.9-.8.9-.5 0-1.3-.4-1.3-.9s.5-1 1-1c.6 0 1 .5 1 1zm6.4 1.7c0 .5-.4.9-1 .9s-.9-.4-.9-.9c0-.4.4-.8 1-.8s.9.4.9.8z"
    />
    <path
      fill="#04534e"
      d="M312.7 264.2c0 .7-.3 1.2-1 1.2-.6 0-1.1-.3-1.1-1s.3-1 1-1 1 .2 1 .8z"
    />
    <path
      fill="#8cbebf"
      d="M308 267.2c0 .5-.4 1-1 1s-1-.5-1-1 .6-.8 1.2-.8.8.3.8.8zm4.5-3a1 1 0 0 1-1 1 1 1 0 0 1-1-1 1 1 0 0 1 1-1 1 1 0 0 1 1 1zm5.2 1.3c0 .6-.3 1-1 1-.6 0-1.1-.4-1.1-1s.2-.8.8-.8c.6 0 1.3.2 1.3.8zm-3.3 2.7c0 .6-.4 1-1 1s-1.1-.4-1.1-1c0-.5.5-.8 1-.8.6 0 1 .3 1 .8z"
    />
    <path
      fill="#231f20"
      d="M314.8 265s1.6-.2 1.9 0c.3.4.3.8.1 1-.1 0-.8.1-1-.1 0-.3-1-1-1-1zm-1.7-5.4s1.3.3 1.8.9c.5.5.4 1 .4 1.1-.2.1-.6.2-1-.2l-1.2-1.8zm-3.7 2.6s1.5.8 1.8 1.3c.3.4.4.8.2 1-.1.2-.8 0-1-.3 0-.3-1-2-1-2z"
    />
    <path
      fill="#231f20"
      d="M308.7 263.3s1.7.2 2 .5c.5.4.8.4.8.6 0 .3-.3.4-.5.4a3.6 3.6 0 0 1-1.2-.5l-1-1zm-1.9-4.8s1.7.2 2 .5c.4.3.5 1 .1 1.2-.4.2-.8-.2-1-.5a8.2 8.2 0 0 0-1-1.2zm-3.6 2.5s1.5.8 2 1.4c.3.4.5.7 0 1-.4 0-.9-.7-.9-1a9 9 0 0 0-1.1-1.4z"
    />
    <path
      fill="#231f20"
      d="M302.8 263l1.5-.2c.5 0 1.2-.1 1.2.2 0 .4-.6.5-1 .4l-1.7-.4zm8.6 5.6s1.1-.7 1.7-.6c.5.1.7.1.7.4 0 .4-.7.3-.9.3l-1.5-.1zm-6-.9s.4-.6.9-.7c.4 0 .6 0 .7.2 0 .2-.4.6-.6.6h-1z"
    />
    <path
      fill="#04534e"
      d="M322.6 266.6s-1.6 2-4 3a14 14 0 0 1-7.2 1.1 15.2 15.2 0 0 1-11.2-5.2l.4 1.1 2 2.6 2.3 1 3.5 1 3.3.3h2.5l3-.5 1.9-.7 1.3-.8 1-.8 1.2-2zm-3-5.9s-1 .3-3-.9-4.3-2.8-8.8-2.8c-4.5 0-5.9 3-6.2 3.2l2-2.6 2-1.1 1.7-.3h1.5l2 .6 1.7.6 2.1.7 1.8 1 2.2 1.1 1 .5zm6 1.4h-3.4c-.8 0-.8.2-1 .4a4 4 0 0 1-.2.4l-.8-1.7 3.5-.5 2 .7-.2.6z"
    />
    <path
      fill="#0c8489"
      stroke="#04534e"
      strokeWidth={0.5}
      d="M320.7 280.4c.2.5.6 1 1.1 1h1.6l3.6-.3 1.2-1.4.8-3.2 1-1.2 3.3-1.9 2.8-.8 1.9-.2 2.5-.8 1.9-1 .8-1.2.8-1.8-.8-2.5-2-2.7-3.4-1.3H335l-3 1.1-5.5 1.3s-3 1.3-4.3 3.7c-1.3 2.3-1.2 3-1.5 6-.2 3.2 0 7.2 0 7.2z"
    />
    <path
      fill="#8cbebf"
      d="M322.2 279.2c1 0 .2-1.7 1.4-3.8 1.2-2 2.6-4.6 3-4.6s.4.4.9.3c.4-.2 1.2-.8 1.2-1 0-.2 0-1.3 1-2 .8-.8 2.1-1.9 2.7-2 .6-.1 1-.3 1 0 .1.3-.3.7.1.8.4.2 1.4.1 1.6-.5l.2-1s.6-.5 1.8-.3c1.2.3 1.3.2 1.4.7.1.4-.5.5-.4.8v.6c.2.2.4 1 1.2 1 .8-.1 1.1-.6 1.1-.6l.3-.4s.2-.5-.1-.7c-.3-.2-.2-.4 0-.3.4.1 1.6 1.8 2 1.1.4-.7.5-1.7.2-2a91.2 91.2 0 0 1-1.9-2.7l-3-1-4 .3-4 2.2-3.6 2s-.2 2.9-.8 2.3c-.7-.5-1.6-2-1.9-1.5-.3.5-.9 2.7-1.3 3.8-.3 1-1.4 4.4-1.3 5.6.1 1.2.8 2.9 1.2 2.9z"
    />
    <path
      fill="#8cbebf"
      d="M325.8 274.4c-.3 0-.7.3-.8.5-.2.2-.3.5-.2 1 0 .3.7.7.7.7h.5l1-.3.3-.8c0-.5-.3-.6-.4-.6a29 29 0 0 1-1.1-.5zm6.2-5c-.6-.3-.8.1-1 .3v.5s.2.8.4 1c.3 0 1.1.3 1.3 0 .3-.2.5-.4.5-.9s-.7-.7-.7-.7l-.5-.3zm5 1.1c0-.2-.5-.3-.9-.2-.3 0-.7.4-.6 1 .2.7.8.7 1.2.6.5-.1.4-.8.4-.9l-.1-.5zm-14.4 1c0 .3.5 1 1.2.9a1.3 1.3 0 0 0 1.2-1c0-.4-.4.3-1 .5s-.7.2-1 0c-.2-.4-.4-.4-.4-.4z"
    />
    <path
      fill="#04534e"
      d="M327.3 275.5s0 .6-.4 1c-.5.3-.8.3-1 .3-.3 0-.6 0-.8-.3l-.3-.7s.5.8 1.3.6a2 2 0 0 0 1.2-.9zm13.3-8.3s0 .6-.5.9c-.5.3-.7.3-1 .3-.2 0-.6-.1-.7-.4-.6-1-.3-1.5-.3-1.5s.4 1.6 1.3 1.5a2 2 0 0 0 1.2-.8zm-11.9 2.9s-.4 1.2-1.2 1.2c-.9 0-.8-.2-.7-.4 0-.1.3.2.7 0 .4 0 1.2-.8 1.2-.8zm2.3-.3s0 1 .2 1.2c.3.4.7.5 1 .5s.6 0 .9-.4.1-.8.1-.8l-.2.5c-.3.3-.5.3-.8.3s-.7 0-.8-.3l-.4-1zm4.3-4.3s.2.7-.3 1.2c-.5.6-1.5.2-1.5.2s.8.3 1.2-.2c.4-.4.6-1.2.6-1.2z"
    />
    <path
      fill="#04534e"
      d="M321.7 281.1s5.3 0 5.7-.8c.4-.7-.4-3.6 2.7-5.8 3.2-2.2 5.7-2.2 7.4-2.3 1.7-.2 5.3-1.3 6-4.5.3-2-2.3-2.2-3.3-4-1-2-3.6-1.2-3.8-1.2-.1 0-3 0-4.3 1.3-.9.8-.8 1.8-1.1 2.2-.4.5-4 0-4.3.6-.4.6.1 1.7-.2 2-.2.3-1-.8-1-.8l.2-2.8 4.5-2.6 5-2.8 3.5.1 3.5 1.8 1.7 2s.3.8.5 2.3a5.3 5.3 0 0 1-.2 2c-.8 2.8-3.7 4.8-6.7 5a14 14 0 0 0-7 2.5c-1.4 1-2.1 5.3-2.1 5.9 0 .5-6.6.1-6.6.1v-.2z"
    />
    <path
      fill="#231f20"
      d="M324 270.8c-.3.3-.7.2-.8 0-.2-1 .3-2.2.3-2.2v1.6c.1.2.4.1.5.3v.3zm3.2-.6c-.2-.1-.1-1 0-1.3.2-.3 1.7-1.4 1.7-1.4l-.6 1.5c-.2.4-.7 1.3-1 1.2zm-1.2 5.3c-.3 0-.3-.4-.3-1s1-1.6 1-1.6l-.4 1.2.2 1c0 .3-.3.4-.5.4z"
    />
    <path
      fill="#231f20"
      d="M328.4 274s-.5.6-1 .9c-.5.3-1.1.7-1.4.6-.4 0 .1-.8.3-.9l2.1-.6zm4.5-6.4s-.6.5-.9 1.2c-.3.7-.4 1.3-.1 1.4.3.2.7-.8.8-1.1l.2-1.5z"
    />
    <path
      fill="#231f20"
      d="M334.6 269.9s-.5-.4-1.2-.6c-.8-.2-1 0-1.2.2 0 .2-.6.5-.3.7.2.2.6-.3.8-.3.2-.1.5-.3.9-.2l1 .2zm-1-4.5c.3.3.7-.2 1-.6.4-.4.7-1.2.7-1.2l-1 .7c-.4.3-.9 1-.7 1.1zm6.9-.1s-1 .4-1.2.8c-.3.4-.7.8-.4 1 .3.3.6-.2.8-.5l.8-1.3zm-2 4.6s-.3.6-.9 1c-.5.4-1.2.5-1.3.3-.1-.2.1-.6.3-.7l.8-.2a7.3 7.3 0 0 0 1.1-.4z"
    />
    <ellipse
      cx={328.8}
      cy={207.4}
      fill="url(#prefix__b)"
      rx={2.9}
      ry={4.3}
      transform="rotate(8.7)"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M295.4 247l-1.7 4.2 1.4-.2.7-3.8z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      d="M296.1 245.1c-.6 0-1.1.4-1.2 1 0 .7.4 1.3 1 1.4.6 0 1.1-.4 1.2-1 0-.7-.3-1.3-1-1.4z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M369.7 255.8l-4.2 4 1.7.4 2.9-3.8z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      d="M371.6 254.1a1.5 1.5 0 0 0-2 .6c-.5.7-.3 1.5.4 2 .7.3 1.6 0 2-.7.4-.6.2-1.5-.4-1.9z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.3}
      d="M262.8 233l2.2 4.9 1-1.4-2.6-3.7z"
    />
    <path
      fill="#fcca3e"
      stroke="#aa8c30"
      strokeWidth={0.2}
      d="M261.9 230.9c-.6.4-.6 1.3-.1 1.9.4.6 1.3.7 1.8.2.6-.5.6-1.3.1-2a1.3 1.3 0 0 0-1.8-.1z"
    />
    <path
      fill="#aa8c30"
      d="M296.6 245.3s.3.1 0 0c-.5 0-1.4.4-1.4 1a1 1 0 0 0 1 1c.5 0-.2.2-.2.2l-.7-.2-.2-.4-.2-.5.1-.6.4-.5.5-.2h.3l.4.2z"
    />
    <path
      fill="#aa8c30"
      d="M295.6 248.1s-.3 0-.5.3a49.4 49.4 0 0 1-.7 1.1l1-2.3.4.2-.2.7zm76.4 6.4s.3.4-.1 0c-.4-.3-1.8-.2-2.1.5-.4.8 0 1.4.6 1.7.6.2-.2 0-.2 0l-.7-.5-.1-.6v-.7l.5-.6.7-.3h.7l.3.2.4.3z"
    />
    <path
      fill="#aa8c30"
      d="M369.4 257.3s-.3-.2-.8 0l-1.4.9 2.3-2.2.5.6-.6.7zm-107-26.7s.4-.1 0 .1c-.5.3-.8 1.4-.3 2 .6.5 1.3.4 1.7 0 .4-.5 0 .2 0 .2l-.7.4h-.6l-.6-.3-.4-.6v-.8l.2-.5.3-.3.3-.2z"
    />
    <path fill="#aa8c30" d="M264 233.8s-.3.1-.2.6l.3 1.5-1.2-2.7.7-.2.4.8z" />
    <ellipse
      cx={337.6}
      cy={-128.1}
      fill="url(#prefix__c)"
      rx={4.6}
      ry={3.1}
      transform="rotate(62.9)"
    />
    <path
      fill="#e92736"
      d="M262.6 241.2s1 .2 1.5 0 .6-.7.7-.8.3-.6.2-1a3.8 3.8 0 0 0-1-1.4l-1-.1c-.1-.1 0-.4-.2-.5-.3 0-1.7 1.6-1.5 1.8.3.3.4 0 .5.1v1.1c0 .3.8.8.8.8z"
    />
    <path
      fill="#e92736"
      d="M264 238.1c.1.3.7 1 .9 1 .2.2.8.2 1 0 .3 0 1-.7 1-1a1.5 1.5 0 0 0-.1-.7c-.2-.3-.1-1-.4-1.1-.2 0-.3-.1-.5-.3v-.7c-.3-.3-2.6 1.1-2.4 1.4.2.2.4 0 .5.1v1.3z"
    />
    <path
      fill="#e92736"
      d="M269.2 237.6c.2-.4.1-1.5-.1-1.8s-.6-.3-.7-.4c0-.1.3-.2.3-.5s-2.6.1-2.4.4c.2.3.6.1.6.3 0 .2-.4.4-.5.6l.3 1.1c0 .2 0 .4.2.5l.6.2h1.4c.1-.1.2-.1.3-.5zm22 12.8s.3.7.8 1h1l.6-.5c.2-.2.4-1.2.3-1.4 0-.2-.5-.6-.5-.8 0-.2.3-.2.2-.4-.1-.2-2-.2-2 .2 0 .3.3.2.2.3 0 .2-.5.5-.6.7-.2.1 0 1 0 1z"
    />
    <path
      fill="#e92736"
      d="M293.8 249.5c0 .2-.2 1 0 1.1 0 .2.3.7.5.8h1.2a1.2 1.2 0 0 0 .4-.6c.1-.3.6-.7.5-.9-.1-.2-.2-.2-.1-.4 0-.2.3-.2.3-.5s-2.1-1-2.2-.7c0 .3.3.2.2.4 0 .2-.7.6-.8.8z"
    />
    <path
      fill="#e92736"
      d="M297.3 252.5c.3-.2 1-.9 1-1.1 0-.4-.3-.6-.2-.7l.5-.1c.1-.2-1.6-1.6-1.7-1.3 0 .3.3.4.2.5l-.7.1c-.1.1-.5.6-.5.8 0 .2-.3.2-.2.5l.2.4c.1.2.8.9 1 .9h.4zm66 5.5s0 .8.4 1.2c.3.3.6.3.8.4h.7a3 3 0 0 0 1-1c0-.3-.3-.8-.2-1s.3 0 .3-.2c0-.3-1.6-1.1-1.7-.8-.1.2.2.3 0 .4l-.8.2c-.2 0-.5.8-.5.8z"
    />
    <path
      fill="#e92736"
      d="M366 258.5l-.8.8c0 .2 0 .7.2.8 0 .2.7.6 1 .5.1 0 .3 0 .5-.2.2-.1.8-.2.8-.4l.1-.4c.1-.1.4 0 .6-.2.2-.2-1.2-1.7-1.4-1.5-.2.2 0 .3 0 .4-.2 0-.9 0-1 .2z"
    />
    <path
      fill="#e92736"
      d="M366.4 262.2h1.4l.4-.5c.1 0 .1.2.4.2.2 0 0-2-.3-1.8-.2.1-.1.5-.2.4-.2 0-.3-.3-.5-.3a2.4 2.4 0 0 0-1 .1s-.2 0-.3.2l-.2.4v1c.1.2 0 .2.3.3z"
    />
    <path
      fill="#f7e204"
      d="M264.2 239c.2.4-.1 1.2-.3 1.4-.1.2-1.3-.1-1.3-.3 0-.2-.1-.6 0-.8.2-.2.6-.7.9-.6.3 0 .6.3.7.4zm.3-1.3c-.2.3 0 .6.2.7.1.2 1 .4 1.2.3.2-.2.6-1.5.4-1.7-.2-.2-.6-.2-.7-.2-.2 0-1 .6-1.1.9zm2.7-1.3v.7c.2.1.7.5 1 .5.3 0 .5-1 .5-1.1 0-.2-.1-.3-.3-.4l-1.2.2zm26.1 13.7c0 .4-.7.7-.9.7-.2 0-.7-1-.6-1 .1-.2.3-.5.5-.5s.7 0 .9.2l.2.7zm1.1-.6c-.2.1-.3.4-.3.6 0 .2.3.8.5.9.2 0 1.2-.5 1.3-.7 0-.2-.2-.5-.4-.6l-1-.2zm2.4 1c-.2 0-.4.3-.4.5 0 0 0 .6.3.8.2.2.8-.2.9-.3v-.4c0-.2-.8-.6-.8-.6zm68.6 8.2c-.2.2-.9.2-1 0-.3 0-.3-1-.1-1 .1-.1.4-.3.6-.2.2 0 .6.3.6.6l-.1.6zm1 .1c-.3 0-.5.1-.6.3-.1.1-.2.7 0 .9.1.1 1.2.2 1.3 0v-.5l-.7-.7zm1 2h-.5c-.1 0-.4.4-.4.7 0 .2.7.3.8.3l.3-.2-.1-.8z"
    />
    <ellipse
      cx={438.6}
      cy={-93}
      fill="url(#prefix__d)"
      rx={2.2}
      ry={4.5}
      transform="rotate(47.9)"
    />
    <path
      fill="#a8ac71"
      d="M285.8 199.3s-3.8.3-6.5-.1-2-7.3-2.1-7.5c0-.2-1.6-1.8-1.4-3.3.3-1.5 5.2-5.5 5.8-5.8.5-.1 1.5.3 1.5.3s1.2-1.2 1.6-1.2c.4 0 .9.7.8 1-.2.3-1.9 1.3-2 2-.2.8 0 1.5-.5 2.3-.5.7-1.4 1.7-1.5 2.4-.1.6-.4 1.1 0 1.4.5.2 2.1 0 3.5-.6 1.4-.7 2-1.5 2.1-1.4.2 0-.8 1.7-2.3 2.4-1.5.6-2.5 1.3-3.3 1.2 0 0-.8 2 1.8 2.2 2.6 0 4-.6 4-.6l-1.5 5.3zm-15 16s2 .8 2 3-2.1 4.1-2 8c0 4 .6 4 5.8 8.3a5.7 5.7 0 0 1 1.6 2.5c.3 1.3 1.2 8.9 6.2 8.9s5.8-3.3 5.8-3.3l-2.2-3.1s-1.7.5-2.7.3a3.4 3.4 0 0 1-2.3-2.1c-.6-1.2-.7-4.1-1.6-5.4-2-3.2-5.8-3.7-5.9-7 0-3.4 2.3-3.7 1.7-7.7-.7-4-5.4-5.8-5.4-5.8l-1.9-.8-.7 4 1.6.2z"
    />
    <path
      fill="#f1a720"
      d="M284.7 187.6c1.7-.4.7-4.8.7-4.8l-1.2 1s.8 1 .8 2-.3 1.8-.3 1.8z"
    />
    <path
      fill="#a8ac71"
      d="M287.8 231.5l-.9-.7c-.6-.4-3.2-2.6-2.8-8.9.5-7.2 11-11 11.6-13.8.8-3.2 3.1-4.5-5.2-11l-2 2.2 3.5 2.6s.7-.4.8.6c0 1-1 1.7-1.2 2.5-.2.7-5.4 4.3-5.8 4.6l-3 2.4s-1.3 1.3-2.5 4.1c-1.3 2.8-.7 6.4-.7 6.4s0 7.6 8.2 9z"
    />
    <path
      fill="#78732e"
      d="M282.7 235.5l.6 2.7-1.7.6h-.7l-.5.2-1.3 1.2h-.3s-.2 0-.3-.8c0-.8-.2-1.5-.2-1.5l1.6.7h.6l.3-.1.7-1.5 1.2-1.5zm-4.8.5l-.8-1-1-.9 1.2-.6h1.2l-.2 1.5-.4 1zm2.7-4.3s.8.3 1 1l.6 1.2-2-.2-1.4-.4 1-1.4.8-.2zm-.7 11.9s-.4-.3-.7-.9l-.4-1.6 1.3-.3 1.5.7h.4l-.3.8-1.5 1.3h-.3zm5-4.1s-1-.4-1.2-1c-.2-.5-.4-.4-.4-.4l-.3 1.5-.5 1.5.2.2 1.1-.3.9-.9.3-.6zm-4.7 4.8l1.4.7c.8.5 1.2.5 1.2.5l.6-.6.7-1.3v-.1l-3 .3-.9.5zm4.4-1.2l2.7-1.6.1-1.4-.5-.4h-1.5l-.5 1.8-.3 1.6zm-1.8 2.5s1.8.8 5-.4c1.4-.5 1.7-1.2 1.7-1.2l-1.3-.5-1.2 1-4.2 1zm-2.5-20.3l-.4-1.4c-.2-.8-.1-1.1-.1-1.1l.9.5 1.3 1-1 .7-.7.3zm2.2 3.7l-.9-1a12.4 12.4 0 0 1-.6-1.2l1 .2 1.1.6-.5 1.4h-.1z"
    />
    <path
      fill="#c6c7a6"
      d="M276.6 187c-.2.7-.4 1.9.5 2 .4.2 2.3 0 4.5-2.4 1-1.2 1-2.4 1-2.4l.5-1.3s-.9-.6-2.2.2c-1.3.8-4.3 4-4.3 4z"
    />
    <ellipse cx={282.5} cy={183.6} fill="#1c242f" rx={0.4} ry={0.4} />
    <path
      fill="#a8ac71"
      d="M279.7 184a17.7 17.7 0 0 0-1.7 1.7s1.4-.4 2.6-1.5c.6-.6 2-.8 2.6-.7.4.1.2-.4 0-.5-.3-.3-1.4-.4-1.6-.3l-1.9 1.3z"
    />
    <path
      fill="#78732e"
      d="M284.1 224.5v-2.2l-.9.8-.8 1.1 1.3.5.4-.2zm-4.5-2.6v-2.3c0-1 .5-3.1.5-3.1l.6 1.4 1.5 2.4.5.4-1.3 1-1.4.4-.4-.2zm4.5-.6l.3-1c.1-.6.5-1.4.5-1.4v.1a25 25 0 0 0-2 1.7l.8.7h.5m-3.7-6s.2-.6 1-1.5l1.3-1.8.6 2.4.4 2v.4l-.7.2c-.2 0-1.6 0-1.8-.3l-.8-1.3zm4.8 2.9l.8-.9 1-1-3.2.6.5 1 .8.3zm-2-6.7s.3 0 1.2-1c.8-.8 1.3-.7 1.3-.7l.3 3.4-1.6-.5-1.2-1.2z"
    />
    <path
      fill="#78732e"
      d="M287.3 216.2l2-2-3.3-1 .6 2.3zm1.4-5.2l.2-3.3s-.7.3-1.5 1l-1.2.9.4.6 1 .7h1zm2.8-3.2V205s-.5.8-1 1.2l-.9.8.9.6h1zm1.2 3.5l1.6-1.3a6.5 6.5 0 0 0 1.5-1.7l-4.2-.3.2 1.7 1 1.6zm-9.6-13.8l-.2 1.8h3.5l-.9-1.2-1-.6-1-1zm6.6 16.2c.2 0 1.1-.8 1.6-1.2.4-.5 1.2-1 1.2-1l-3.3-.3v2.2l.5.3zm6.3-5.9s.4-1.3.3-2.6c0-1.2-.2-1.8-.2-1.8l-2.5 1.7.4 1.2 1 1 1 .5z"
    />
    <path
      fill="#78732e"
      d="M291.8 204.8s.7-1 .8-1.4v-.4h2l1.1.2h.2l-.9 1.1-1.2.7-1.5.2-.5-.4zm4-2l-1.3-2c-.4-.7-.8-1-.8-1l-1 2.7v.3h3z"
    />
    <path
      fill="#fff"
      d="M271.6 222.2l-.3.8s1.3-.7 2.3-.7c1 0 2.1 1.3 2.1 1.3l.2-.9s-1.3-1.3-2.2-1.3c-.8-.1-2 .8-2 .8zm.7-5.8l.3.4c0 .1.1-1 1.4-1.5 1.4-.6 2-.1 2-.1s-.2-.8-.8-1c-.6-.1-1.1 0-1.8.5a3.7 3.7 0 0 0-1.1 1.7zm4.4 4.4s-.6-1.4-1.6-1.6c-1.1-.3-2.5.5-2.5.5l-.2.7s1.5-.8 2.5-.4c1.1.5 1.5 1.7 1.5 1.7l.3-1zm-5-5.1l.4.5s-.2-1.4.5-2.1a4.9 4.9 0 0 1 1.1-1l-.6-.3s-.9.5-1.2 1.1a3.2 3.2 0 0 0-.2 1.8zm-.5-2.3c.3-.8 1.2-1 1.2-1l-.3-.3h-.5s-.5.3-.9 1c-.3.9-.3 2-.3 2l.6.3s-.1-1.4.2-2zm7.8-19.2c.9-.4 1.5-.3 1.5-.3s-1.3 1.3-.7 2.9c-.7 1.3-.9 2.3-.9 2.3h.7l.4-1.8c.8 1.3 2 2 2 2h1s0-1.3.4-2.4h.1a5 5 0 0 0 2 1.5v-.4s-1.1-.6-1.7-1.5l-.1-.1a4.2 4.2 0 0 1 1.8-1.7l.7.6.2-.2-.5-.7h-.6l-1.8 1.7a9.2 9.2 0 0 1-.8-1.5l-.4-.2s-1.1.1-2 1.7c-.2-1.2 1.1-2.4 1.1-2.4v-.5l-2.4.6c-1 .3-1.7 1.2-1.7 1.2v.8s1-1.1 1.7-1.6zm1.5 2.2c.6-1 2-1.5 2-1.5s0 .7.7 1.7c-.5.9-.8 2.2-.8 2.2s-1-.6-1.9-2a1.6 1.6 0 0 1-.2-.3l.2-.1zm-7.6 21.1v.8s.8-.9 2-1c1.2 0 2.3 1 2.3 1s0-1-.2-1.2c-.1 0-1.1-.6-2-.6s-2.1 1-2.1 1zm21.4-11.2l-.5-1 .6-.3a12.5 12.5 0 0 0 1.7-1.6l-.4-.6h-1.6l-1.4-.1.5-1.7.6-1.4-.6-.5s.2.5-.8.6c-1 .1-2.8-.8-2.8-.8v.4l2.5.7c.6 0 1-.1 1.2-.3l-.5 1.3-.3 1 .2.2v.8l1.4.1 1.6.1s-.8 1-1.7 1.5a2.3 2.3 0 0 1-.3 0l-1-1.5-.1.5.7 1.2a5 5 0 0 1-1.5-.1l-.4.4v2.5l-1.8-.6-.3.3v-.1l-.4.4s-.4 1.4-.3 3.1v.1a4.9 4.9 0 0 1-2.4-1.3l-.4.3s-.3 1.4 0 3.2c-1.3-.3-2.5-1.5-2.5-1.5l-.5.5a60 60 0 0 0 .7 4.7 4.9 4.9 0 0 1-.7 0c-1.4 0-2.3-1.3-2.3-1.3l-.4 1s.6 2.7 2 4l.4.2c-1.3 1-2.8 1.2-2.8 1.2v.9a44.7 44.7 0 0 0 2.2 1.5 4.8 4.8 0 0 1-1.6 1l.2.5 1.8-1.3 1.8.5v-.5l-1.5-.3.1-.1c.5-.4 1.4-1.8 1.4-1.8v-1s-.5 0-1.1-.6c1.8-1.2 1.9-1.8 1.9-1.8l.4-.6s-.7-.3-1.1-1.2l2.9-.7.2-.2s-.7-1.2-1-2.6l3 .6.4-.4-.5-2.4c1.8 0 3.2.2 3.2.2l.3-.3s-1-1.9-1-3a4.8 4.8 0 0 0 1 0h3l.3-.5s-1.4-1-1.7-1.5zm-10.5 15.5s-.5 1-1.4 2l-.2.2a4.6 4.6 0 0 1-.5-.2c-1.1-.6-1.4-1.3-1.4-1.3l2.5-1.6 1 .9zm.9-3.2l-2 2a4.1 4.1 0 0 1-.4-.5c-.8-1.2-2-2.1-1.8-3.8 0 0 .7 1.2 2.2 1a14 14 0 0 0 1-.1c.4 1 1 1.4 1 1.4zm2-2.5l-2.7.7a5.3 5.3 0 0 1-.1-.5c-.5-1.6-.5-4-.5-4s1 .8 2.6 1.2l.7 2.6zm-.5-3c-.2-1.4.1-2.9.1-2.9s.8.8 2.3 1c.1 1.5.3 2.1.3 2.1l-2.7-.1zm5.8-2.2s-1 .4-2.8.1a15.3 15.3 0 0 1 0-.5 23 23 0 0 1 0-3l2.3.7a10 10 0 0 0 .5 2.7zm0-3.1h-.2V205s1 .3 1.7.2c.2.4 0 .5.5 1.2.4.7 1.1 1.3 1.1 1.3s-2.3.2-3.2 0zm-7.6 18.6l-.1-.5s-1 .7-1.2 1.4a1.6 1.6 0 0 1-.3-.1l-2-.8.2.4 1.8.8h.2l-.5 1.4.2.3.5-1.7 1.2.1-.2.8-.4 1.5.5.3h2l-.3-.4-.7-.1h-1.1l.3-1.2.3-.8-.3-.7-1 .2a3 3 0 0 1 .9-.9zm-11.3-1.3c1.3 0 2.3.9 2.3.9v-.6s-1-1.4-2.1-1.4c-1.2 0-2.5 1.2-2.5 1.2v1.2s1-1.3 2.3-1.3zm13.3 19.4c-1.3.6-2.7.6-2.7.6l.8-1.5c2.5-.8 3-2.4 3-2.4l-.2-.7s-.6 1.6-2.6 2.4c.4-1.2.7-3.2.7-3.2l-.7-.2s-1 1.3-2 1.6a7.7 7.7 0 0 0 .8-2.7l-.3-.5s-.7.6-1.7.8a1.8 1.8 0 0 1-.6 0c.6-.8 1.7-3.2 1.7-3.2l-.2-.5s-.8 2.1-1.7 3.2a10.6 10.6 0 0 1-.3.4c-1-.3-2.2-1-2.2-1l.1.3s.8.6 1.8 1a27.3 27.3 0 0 1-1.3 1.2v1l3 .4c-1 1.6-2 2.1-2 2.1l.5.7s1.3 0 3.7-.6c-.6 1.2-1.2 1.8-1.2 1.8s2.2.2 3.7-.6 2-1.6 2-1.6l-.4-.4s-.4 1-1.7 1.6zm-6.9-4l1.2-1.5c1.6.3 2-.1 2-.1s.3.8-.6 2.3c-1.1 0-2.6-.8-2.6-.8zm1.4 3l1.3-1.6.3-.3c1.5 0 2.3-1.3 2.3-1.3s.2 1.2-.5 2.7c-1.9.7-3.4.5-3.4.5zm-1.9-9.8c1.5 0 3.3.7 3.3.7l-.2-.7-2.9-.6a3.6 3.6 0 0 1 1.6-1.6l-.5-.3s-.6.1-1.4 1.5a4.1 4.1 0 0 0-.2.4 4 4 0 0 0-.3 0 5 5 0 0 0-2.4.7l.2.4s1.1-.5 2.3-.5a25.7 25.7 0 0 0-.7 2.4l.3.6 1-3zm-3-6.2l-.3-.7s-1.5-.6-2.7 0c-1.1.5-2 1.9-2 1.9l.5.9s.8-1.5 1.9-1.9c1-.3 2.6-.2 2.6-.2zm3 2.4l-1-.6s-1.7.5-2.2 1.1c-.6.6-1.1 2.1-1 2.5.2.5.7.7.7.7s.3-1.5 1.1-2.3c.8-.8 2.4-1.4 2.4-1.4zm-3.9-.5a4.5 4.5 0 0 1 2-1l-.7-.5s-1.5.2-2.2.9c-.8.7-1.8 2.1-1.8 2.1l.9.9s1.2-1.8 1.8-2.4zm5.2-44.7v-.1c.8-1 1.6-1 1.9-1h.6a9.3 9.3 0 0 0-.8 2.5c-.2 1-.7 1.2-1 1.9-.4.7-1.1 1.8-1.2 2.8 0 1 .3 1.6.5 1.7.3.1.8-.4.7-.7 0-.3-.3 0-.4 0-.2 0-.2-.3-.3-.9-.1-.6.7-2.2 1-2.8.3-.5 1-1.1 1-2l.7-2.5c0-.1-.4-.2-1.3-.3-.6 0-1.5.5-1.9 1.2-.4.6-1.7 1.1-1.7 1.1s1.4 0 2.2-1z"
    />
    <path
      fill="#78732e"
      d="M285.2 194.5h-2.5l.7 2zm-3-.1l-.5-.4a1.5 1.5 0 0 0-.3-.3l-.9.5-.5 1.9.3.3 2-2zm-.3 5l-1.8-2.7-1 2.2.5.2 1.2.2h1.1zm7.4 44.7a9 9 0 0 1-4.8 1.5 6.7 6.7 0 0 1-3.4-1 4 4 0 0 1-1.5-1.7c-.6-1.1-.8-2.5-1-4-.3-1.3-.5-2.6-1.1-3.6-.8-1.3-2.4-2.1-3.8-3.3a7.3 7.3 0 0 1-2.8-5.2 8.1 8.1 0 0 1 0-.8c0-1.7.5-3.2 1-4.5s1.2-2.5 1.2-3.5v-.5c-.3-.7-1-1.4-1.5-1.9s-1.2-.8-1.2-.8l-1-.2-.1.3 1 .2v-.1.1l1.3 1c.5.4 1 1 1.1 1.5a1.9 1.9 0 0 1 0 .4c0 1-.5 2-1 3.3a11.7 11.7 0 0 0-1.2 4.7v.8a7.7 7.7 0 0 0 3 5.5c1.5 1.1 3 2 3.7 3.2.8 1.2 1 3 1.3 5 .2.8.4 1.7.8 2.5s.9 1.5 1.6 2a7 7 0 0 0 3.7 1c2.7 0 4.9-1.6 4.9-1.6l-.2-.3z"
    />
    <path
      fill="#78732e"
      d="M287.2 239.2a2.6 2.6 0 0 1-1.3.4c-.5 0-1.1-.2-1.7-.8a4 4 0 0 1-1.2-2.3c-.2-.9-.3-2-1-3.3-.5-1.5-2-2.6-3.5-3.7-1.3-1.1-2.6-2.2-2.9-3.4a3.3 3.3 0 0 1 0-.7c0-1 .4-2 .8-3.1a10.8 10.8 0 0 0 .9-4.8c-.2-2-1.7-3.5-3.2-4.5a14.1 14.1 0 0 0-2.8-1.4l-.1.3h.2c.5.3 1.8.9 3 1.8 1.3 1 2.4 2.2 2.6 3.8v.8c0 1.5-.4 2.7-.9 3.9s-.9 2.2-.9 3.2l.1.8c.3 1.3 1.6 2.4 3 3.6 1.5 1 3 2.2 3.5 3.5.6 1.3.7 2.4.9 3.2.2 1 .4 1.7 1.2 2.5.7.7 1.4.9 2 .9a2.8 2.8 0 0 0 1.4-.4l-.1-.3z"
    />
    <path
      fill="#a8ac71"
      d="M296.4 231.6s1.7.4 1.6 1.8a13.3 13.3 0 0 1-.8 3.4l-2.4-2.2 1.3-1.2.5-.7-.2-1.1z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M266.4 214.5s-1.7.6-2.1-.1c-.4-.8-.2-1.4-.2-1.5 0-.2-1-.3-1-1.3.1-1 1.4-.9 1.6-.9.3 0 .4-1.5 1.3-1.4.8 0 1.2 1 1.2 1l-.8 4.2z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M268.3 215s-1.5.8-2 0c-.4-.7 0-1.6-.1-1.8-.2-.1-1-.4-.9-1.3.2-.9 1.1-.6 1.4-.8.3-.1.6-1.4 1.5-1.2.9.3 1 1 1 1l-1 4.1z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M270.8 215.3s-.5 1-1.5.8c-1-.2-.7-1.7-.9-2-.1-.3-.9-.5-.8-1.4.2-1 1.1-.9 1.5-1 .3-.1.7-1.6 1.4-1.4.7.3 1.3 1.1 1.2 1.5 0 0-1.5.5-1.7 1.5-.2 1 .8 2 .8 2z"
    />
    <path
      fill="#af7029"
      d="M293.7 231.2l-2.2-2.6c-.9-1.3-2.3-2.7-2.3-2.7l-2.2-1.1-1.4-2.4-.2-2.8.6-1.6.8-1.2s-4.6 1.7-2.2 10.5c1 3.8 3.5 4.3 3.5 4.3l4.3-.3h1.3z"
    />
    <path
      fill="#816c2a"
      d="M291.6 201.7c.4 0 .6.2.8.4l.2.6v.4c-1.6 3.4-4.8 5-7.8 7a13.8 13.8 0 0 0-3.8 4 12 12 0 0 0-1.6 6.8c.1 5 2 7.8 4.2 9.3a9.7 9.7 0 0 0 5.2 1.5h.4l1.4-.1a35.8 35.8 0 0 1 3-.2l1.8.1.9.4a.8.8 0 0 1 .2.5c0 .4-.3.8-.6 1.2l-1 .7.2.3a4 4 0 0 0 1-.8c.4-.4.7-.9.7-1.4 0-.2 0-.5-.3-.7-.2-.3-.6-.4-1.1-.5l-1.8-.1c-2 0-4.5.3-4.5.3v.2-.2a6.8 6.8 0 0 1-.3 0 9.4 9.4 0 0 1-5-1.5c-2.1-1.4-4-4-4-9v-.4c0-2.7.5-4.7 1.5-6.3 1.4-2.4 3.7-3.8 6-5.3a14 14 0 0 0 5.5-5.7v-.5c0-.2 0-.6-.2-.8-.2-.3-.5-.5-1-.5v.3z"
    />
    <path
      fill="#fff"
      d="M297.8 232.7s-1 2-1.4 2c-.2 0 1 .3 1.3.8l-.3.5s-1.2-.9-2-1v-.6l1.1-.7a4 4 0 0 0 .9-1.7l.4.7z"
    />
    <path
      fill="#fcca3d"
      d="M302 234l-2.7.8-1.3-1s0-1-.5-1.5l-1.6-1c-.6-.2-2.5-.2-2.5-.2l-5-5.3 2 .2 2.8-.4 2.7-.2 1.4.2 1.6.4.8.7.8.8.8 1.3.6 1.6.2 1.7v1.9z"
    />
    <path
      fill="#af7029"
      d="M302.2 233.8s-1 .3-2.2.3c-1.3 0-2-.2-2-.2l-.2.9c-.2.9-.5 1.3-.5 1.3v3.2l2.6.5 1.4-.5.7-3.5.2-2z"
    />
    <path
      fill="#fcca3d"
      d="M301.5 232.5v1.2l.6.2v-1.2zm-2.5-30l-.3-2.1-.8-1.5-1.1-1.5-1.2-1.3-.6-.5-.3-.5-2.9.2-1.4 1.7s3.8 2.8 5.3 5.8a7 7 0 0 1 2.8 1.7l.1-.2.4-1.8z"
    />
    <path
      fill="#af7029"
      d="M296.3 205c0 2.2-.5 3.2-.8 3.7l1.8-2 1.2-2.2a7 7 0 0 0-2.8-1.7c.4.7.6 1.4.6 2.1z"
    />
    <path
      fill="#816c2a"
      d="M300.3 237.9l-1.4-1.6c-.6-.6-1.3-1-1.3-1l-.2.4h.1l1.2.8a17.6 17.6 0 0 1 1.3 1.6l.3-.2z"
    />
    <path
      fill="#6f5b24"
      d="M302 235.5s-.3 1-1.3 1.8c-1 1-2.2 1.5-2.2 1.5l2.8 1 1.9-1.7-1.2-2.6z"
    />
    <path fill="#404118" d="M302.4 237.8l-.2.3-.5.5-.4.5.6-3 .6 1v.4z" />
    <path
      fill="none"
      stroke="#78732e"
      strokeWidth={0.2}
      d="M285.8 199.3s-3.8.3-6.5-.1-2-7.3-2.1-7.5c0-.2-1.6-1.8-1.4-3.3.3-1.5 5.2-5.5 5.8-5.8.5-.1 1.5.3 1.5.3s1.2-1.2 1.6-1.2c.4 0 .9.7.8 1-.2.3-1.9 1.3-2 2-.2.8 0 1.5-.5 2.3-.5.7-1.4 1.7-1.5 2.4-.1.6-.4 1.1 0 1.4.5.2 2.1 0 3.5-.6 1.4-.7 2-1.5 2.1-1.4.2 0-.8 1.7-2.3 2.4-1.5.6-2.5 1.3-3.3 1.2 0 0-.8 2 1.8 2.2 2.6 0 4-.6 4-.6l-1.5 5.3z"
    />
    <path
      fill="#ab6d29"
      stroke="#4d2a15"
      strokeWidth={0.4}
      d="M318.7 170.6s-7-1.3-7 4.5c.1 1.9.5 2.5 2 3 1.5.3 4.4.5 7 2.7 2.5 2.3 2.7 4 2.7 5.3 0 1.4-.7 2.6-.7 2.6l1.6 7.7 1.6 5.7 4.8-2.7 2.8-8.5-3.6-15.2-11.2-5.1z"
    />
    <path
      fill="#4d2a15"
      d="M325.6 200s2.5-1 3-3c.3-.5-2.4-2.9-2.4-2.9-.1 0 1.3.7 2 1.3.6.6 1.1.9 1.3.8.2-.1 1.3-2.7.9-3.3-.4-.6-1.1-2-2.1-2.6-1-.7-2.4-.6-2.4-.6s1.9-.6 2.8 0c1 .5 1 1 1.1.9.1-.3-.2-2.9-.6-3.7-.4-1-.8-1.3-2-1.6-1.1-.2-2.3-.1-2.3-.1s1.6-.9 2.8-.6c1.3.3 1.3 1 1.4.8 0-.1-.6-2.4-1-3a6.7 6.7 0 0 0-2.1-1.8l-1.8-.2h-.6s1-.6 2.1-.5c1.2.1 1.3.5 1.4.4.2 0-.1-.2-.8-.7s-4.2-2-4.2-2h-3.3s0-.8 1-1c.9-.1 1.1.1 1-.1 0-.3-2.6-.8-2.6-.8H316l-3 .3s.2-.5.7-.9c.3-.3.9-.5 1.3-.6 1-.3-.6-1.1-.6-1.1l.9-1.3 3.9.3 8.2 4.8 3.9 3.3 2.4 6.2-.7 10.8-5.5 4.5-2.4.3.5-2.3z"
    />
    <path
      fill="#d2a567"
      d="M318.4 173.3s-.2-.7-.2-1.7.2-.9.2-.9-2.7-.3-4.6 1.2c-1.9 1.5-.8 4.1-.8 4.1s.8-.8 1.9-1.2c1-.4 3-.3 3-.3.2-.2-.4-1-1.1-1.1-.8-.2-2.1-.2-2.1-.2s.8-.5 2.2-.4c1.4.1 1.6.5 1.6.5z"
    />
    <path
      fill="#8f4620"
      d="M326.7 200.9l-1.8.6 1 7.5 7.2 12.1 3.7-.6 1.3-2.3 1 .5c.4.4 1.8 2.8 3 3.3 1.1.4 1.7.2 2.7 1 1 1 4.9 6.6 5 6.8.3.2-.1-2.4-.1-2.4l-1.2-3.4-1.4-2.4-.3-.6h2l1.2.8 2 1.5.9 1.2.5 1.2.2 1 .5 1.6 1 2.3 1.3 2.1.4-.9-.6-2.5-2-6-1-2 1.9 1.2c.4.1 1.8 2.2 1.8 2.2l.9 2.2.6 2 .4 1.7.7 1.9 1-.7-.1-1.3-1-4.2-.4-4.5s.6 0 1.2.7a9 9 0 0 1 1.2 2.3l.5 4.1.7 3.8 1.2 3.8 1.2 2.4.9 1.3v-2l-1.6-16 .2-.6s.2-.1.8.7c.5.7 1 1.9 1 1.9l.5 2.5.2 1.7.3 3.3.5 3.5 1.6 3.8.9 2 .5-2.4-.8-17.1.4-.5s.9.7 1.2 1.3l.8 1 .6 3.8.4 10.7.4 2.8 3.2-28.2 2-.4.2-.6-1.5-1-3.2-5-2.1-4.9-3.8-7-6.6-8-5.2-4.3a20 20 0 0 0-1.9-1.3l.4-1 1-1.7-.1-.1h-.9l-2.2.4-2.2-.7-4.4-3-4.6-2.3-2.8-1-6.6-1.6-6.6-1h-3l-2.6.5s-1.4.6-1.8 1.5c-.5.8-.5 1.4-.4 2.6.2 1.3 1 1.9 2.8 2.7 1.8.7 6.2 3.6 6.2 3.6l2 2.1.8 1 .2.8 1.4 11.1-2.8 6-2 1z"
    />
    <path
      fill="#ab6d29"
      d="M333.8 218.2s1.2 2 2.9.5c1.7-1.6-.8-6-.7-6.3 0-.3.7-.3.7-.3l1.3 2.2s.7 1.3.4 3.2c-.2 2-2.1 3.7-2.1 3.7l-2.2-.5-.3-2.5z"
    />
    <path
      fill="#4d2a15"
      d="M375.3 244.2l-1.6-4.5-.4-3.5c0-.6-.3-7.9-.5-9.3 0-1.4 0-3-.2-3.1l-1.6-2.2-.7-.7.5-.3s.6.6.7.3c.2-.4 0-2-.6-4.5-.7-2.5-3.9-8.3-3.9-8.3l.4.2.9 1 1.8 1.5 4.1 1.5 2.2.3 1.4 2.9s1 4.9 1 7.4c0 2.4-.2 4.5-1.2 7-1 2.4-1.2 10.3-1.3 11.5-.1 1.3-.6 2.5-.6 2.5l-.5.3z"
    />
    <path
      fill="#8f4620"
      d="M375.3 231.2s.8-1 1.2-2.4c.4-1.4.5-12.4-.8-13.7a10 10 0 0 0-4-2.3c-.2 0 1 3.5 1 3.5l.8 1.4.6 1.8c.1 1 .9 3.1 1 6l.2 5.7z"
    />
    <path
      fill="#4d2a15"
      d="M369.3 238s.5-5.1.3-9c-.3-3.7-.6-4.2-1-4.9a32.3 32.3 0 0 1-2.5-6.3c-.9-3.2-1.5-5.6-2-6.2-.6-.6-1.7-2-2-1.6-.3.3-.3 1.1-.3 1.1l-1.5-.4-.4-1 .5-1.6v-.7l-.3-1.1 2 1.6 4.2 2.8 2 8.6 2 5.3.2 9-.2 8-1-3.5zm2.4-24.7s1 1 1.7 1.4c.7.4 1.8 1.1 1.6 1.2a8 8 0 0 1-2-.8l-1.2-.8v-1z"
    />
    <path
      fill="#4d2a15"
      d="M363.7 236s.8-1.8.7-4.1a49 49 0 0 0-1.6-8.6c-.4-.7-2-1.7-3.5-4.8s-1.3-3.8-2.3-5c-1-1-2-2.4-2-2.4l.3-3.3 3.6 1.8 1.6.8 1.8 8.7 1.6 2.5.7 3.5.9 8 .4 6.6-.2.5-2-4.2zm-4.2-3.7s.1-2.5-.5-4.8c-.7-2.3-1.1-4-1.9-4.8-.7-.7-2.5-2.6-4.1-5-1.6-2.5-3.9-5-3.9-5v-3.3l2 1.5a57.1 57.1 0 0 1 2.4 1.2l1 3.7 1.2 2.7 1.8 2.4 1.2 1.1.7 4 .4 2.3 1 3.2-.4 1.7-.9-.9zm-3 0l-1-.9s.6-.6.3-2c-.3-1.2-.6-2.4-1.2-3.7-.6-1.2-.7-2-1-2.3a121 121 0 0 0-4.5-4c-1-1-2.7-2.6-3.7-3.3-1-.6-1.8-.8-1.8-.8l-.5-4s1.3 1.8 2.1 2a54.7 54.7 0 0 0 2.1.8l2.8 5 1 1.3 2.6 2 1 2.2.9 2.5 1 3.4.1 2-.2-.1zm-5.5-1s-1.7-2-2-3.2c-.2-1.2.2-1.2-.3-2.6-.5-1.4-2.3-3.5-3.7-4.6-1.4-1.2-3.4-2.8-3.3-3.8.1-.9.4-1 .4-1l.8.8 4.5 4.7 1.4 2.5 1 3.1.7 1.5.7 1.8-.2.7zm16-23.3s3.1 3.8 4 .3c.3-1.6-1.2-4.6-1.2-4.6s-2.8-5-3.8-6.2l-5.7-7.3-3.5-1.6 1.2 2s2.6 2.6 5.9 8.4c3.3 5.7 2.7 8.9 2.7 8.9h.5zm-17.8-23s6.1 5.2 10 10.8c4 5.7 5.5 9.4 4.7 10.2-1 .7-3.4-.4-4.4-2-1-1.6-1.8-4.4-5.5-8.6-3.7-4.2-5.5-4.8-5.5-4.8l-2.7-4.3 3.4-1.3zm-3.2 12.5s3.6 3 6 5.4a37.4 37.4 0 0 1 3.4 4.2l1.4 1.4s-.9-1.5-.4-2c.5-.6 1.1-.3 1.1-.3l-11.5-12v3.3zm-.7.3s1.2 2.3 3 4.1a464.6 464.6 0 0 0 4.1 4l.8 2.9s-5.2-4-5.2-3 1.2 3 1.2 3l-1.6-1-2.2-3.1-1.3-2.8-1.5-3.8 2.7-.3z"
    />
    <path
      fill="#4d2a15"
      d="M329.5 210.2s2.7 2.4 4.2 0c1.5-2.3.3-5 .3-5s3.9 5.6 5 .3c.2-1-2.4-4.6-2.4-4.6l1-.9 1.9 3.3s1.8-.8 1.8-3-1.9-5.3-1.9-5.3l1.8 2s3.6 0 3.7-2c0-2.2-3-4.5-3-4.5s2.4.1 2.4-1.3c0-1.4-3.4-2.4-3.4-3.3 0-.9 1-2.4 2.5-1.5 1.5.8 3.5 1.4 4.4-.2.8-1.6-.1-2-.1-2l-2.1-.4-3.4-1.8-2.7-1-2.8-.4 1 2 .8 5.8v2.6l.5 5.8-1.4 4.7-.7.9-.5.6-1.2 2.6-1.6 1.8-2.2 2.7-2 2.1z"
    />
    <path
      fill="#ab6d29"
      d="M348.8 220.9s-.7-1.7-2.2-2.9a7.8 7.8 0 0 0-3.8-1.2l4 4.2 2-.1zm5.6 1s-1.3-2.6-2.8-4.2c-1.5-1.6-2.5-3.6-3-3.6h-.6l.4 3.3 2.7 2.7s2.6 2 3.3 1.8zm4.6-.2s-.6-3-2.2-6c-1.5-2.8-3.1-4-3.1-4l.4 3 1.2 3 2 3 1.7 1zm3.8-1.7s1-6.2 0-8c-.9-1.6-2.7-2-2.7-2l-.6 1 .6 4.3 1.5 3.4 1.2 1.3zm3.7-10.3s.9.4 2 2.5a40 40 0 0 1 2.6 8.6c0 .3-.5.2-.7.2-.2-.1-3.9-6-3.9-6l-.6-5.4h.6z"
    />
    <path
      fill="#d2a567"
      d="M340.4 216.8s2-.4 2-1c0-.8-2.4-2.2-2.2-3.3 0-.5 2 .1 2.1-.3.1-.4-2-3.6-1.3-4.4.6-.8 2.4 3.5 2.4 3.5s1 2 .7 3.2c-1.2 3.6-3.7 2.3-3.7 2.3zm4.6-4.4c.1-.3 3.1.4 3.1.2.2-.7-2.7-3-2.7-3s-.6-1.2-.4-1.4c.2-.2 2 .2 2 0 .2-.3-2-3.2-2-3.7s.6 0 .6 0 1.7 1.7 2.6 3.2c1 1.4 1.8 2.6 1.5 4.9-.4 2.5-5 .6-4.7-.2zm13.6-4.6s-.5-2-.2-2.3l1.1-.5s-1.6-1-2.4-1c-.7 0-.8-.2-1 0-.2.4 1.3 2.4 1.3 2.4l1.2 1.4z"
    />
    <path
      fill="#d2a567"
      d="M349.4 209.4s4.7 1.2 4.9.8c.2-.3-3.7-4-3.7-4s-.3-.6-.2-.8c0-.2 1.7-.3 2.2.1s0 1.2.1 1.5c.2.3 1.7 2.5 2 2.1.2-.3-.4-3-.3-3.3.2-.2 1.8 1.6 2.3 1.9.4.3 3 2.3 3.3 1.4.3-1 .4-1.1.3-1.7 0-.6.9 2.6-.3 3-1.2.4-2.6-.4-2.6-.4l-1.1-.8-.6-.7s.7 2.5-.2 2.7c-.8.3-1.7.2-1.7.2l-2-.2-2.4-1.8zm10.7-3.2s5 3 5.4 2.5c.5-.5-1.2-7.5-1-8.2.3-.6 4 7.9 2.2 9-1.4 1-2 .3-2 .3l-2.5-1.3-2-2.3zm13.8 12.6l1 .5.7.2-1.4.2-.3-1zm-4.8-16.4l.7.3.7.3s-.4.3-.6.2h-.4l-.4-.8zm-1.4-2.5s.5.3 1.1-.2c.7-.4.7-.8.6-1 0-.2-1-.2-1.4-.5-.3-.2-.3-.6-.3-.6h-1.1l-.4.1 1.5 2.2zm4.3 14.4s1.5 1 2 1c.4 0 1.1.5 1 .6 0 .1-1.2.2-1.8-.1-.6-.3-.7-.1-.7-.1l-.5-1.4zm-8.1-22.5h.6c.3 0 .5-.2.6 0 .2.2 0 1.2-.3 1.5l-1 .5a48.4 48.4 0 0 1-1.6-2.2l1.7.2zm-7.1-6.4h1.5c.5 0 1 .3 1.5.6.4.3.9 3.3.6 3.8-.2.6-3.6-2-3.7-2.1 0-.3-1.5-2.5-1.5-2.5l1.6.2zm-3.2-1.4s2.5.2 2.2-1.3a3.2 3.2 0 0 0-1.3-2.3l-2.9 2.1 2 1.5zm-6.5-2.8s.7.4 1.4 0c.7-.2 2.6-2.7 4-3 1.4-.3 1.7-.3 2 0 .2.4 0 1.8-.2 2.2-.3.4-4.4 2-4.4 2l-1.5-.1a9.6 9.6 0 0 1-1.3-.5v-.6zm-.7-4.5c-.7-1.4-1.7-2-2.2-1.9-.4.1 1.4 1.5 1.7 3.5.3 2 .2 3.3.2 3.4l.8.1.2-.7.1-.5v-.5l-.1-1-.2-.9-.2-.6-.3-.9zm-5.8-2a15.4 15.4 0 0 0-5.5-3.7c-.2 0 4 2.5 5 4 .9 1.7.9 3.9 1.3 4.2.4.3.8-.2.9-.2 0 0 .3-.5.2-.7l-.2-1-.7-1-.4-.8-.6-.8zm-5.5-2.3c-2.4-2-6.6-3-10-3-3.5-.2-5.3.2-4.8 2s2 2.8 5 2.8c2.9 0 3.6-.3 5.2.2a9.7 9.7 0 0 1 3.6 2c.5.5-1.1-1.5-2.6-2.6-1.5-1.2-2.5-1.7-2.5-1.7s-.3-.7 1.7-.4c2 .3 4.7 1.6 5.5 3.3.7 1.7.6 2.6.6 3 0 .3.7-.2.7-.2l.3-.9s0-.6-.3-1.4c-.4-.7-.5-1-1.4-2-.9-1.1-1-1-1-1zm-9.6 28.5c1.5 0 4.8-2.8 5.2-6.7.5-4-1.9-11.9-2.5-12.7-.5-.9 1-.4 1.7.4a25 25 0 0 1 2.5 10.6c0 4.2-.8 5.3-3 7.5-2.2 2-4 1.8-4 1.8l.1-.9zm5.1 11.6s.7 1 1.6.6c1.5-.5 3.8-1.7 3.8-3.8 0-1.4-1.8-2.7-1.9-3.2v-1l1.6.4.5 2.2s.6.7 1.3.4c.6-.2 2.5-1.6 2.2-3-.3-1.2-2-2.9-2.2-3.5-.2-.7 0-1.2 0-1.2l1.6.2.4 2s.4.6 1.3.4c.8-.1 2.4-1.7 2-2.5l-1.5-2.6v-.9l.5.4s.6.2 1.8-.1c1.1-.4 2.3-1.2 2.3-2s-1-1.6-1-2v-.6h.8l1 1.2.1 1.4-.3 1.2-1.4 1.6-1.4.6h-.4l.8 1.4-.2 2-1.3 1.2-1.7 1-.1 1.9-1 2-2 1.2h-.7l-.2 1.2-1.4 2-2.3 1.5-1.7.3-1-1.4.1-.5z"
    />
    <path
      fill="#d2a567"
      d="M343.4 191.4s4 1.1 3.8-1.4c0-1.3-3.8-4.5-4-5-.3-.6-.2-1.3-.2-1.3l1.9 1.8s2.5.6 3.2-.9c.7-1.4.1-2.3 0-2.3l.6-.1 1.1.2-.1 2.2-1.3 5.5s.3 2.2-1.4 2.3c-1.7.2-3.6-1-3.6-1zm3.7 29.5s0-1.1-.8-2c-.9-.7-2.5-1.4-2.8-1.6a63 63 0 0 0 2.8 3.5h.8zm5.6.2s-2-2.4-2.3-3.3c-.5-.8-1.5-2.6-2.3-2.7-.8 0 .8 3 .8 3l3.2 2.9h.6zm5.4 0l-2.1-4.2c-.4-.9-1.3-3.4-2.3-4.1-1-.7.1 1.1.1 1.1l1.1 3.3 1.9 2.9 1.3 1zm3.9-2.4s-.1-2.7-.5-4.6c-.3-1.8-1.7-3.4-1.8-3.3v3.3l2.3 4.6zm8.1 2l-2-4.7c-.5-1.6-1.8-4.1-2-4.2l.4 3 1.7 4.7 2 1.2zm7-8.5s-1.2-1.2-3.9-2.3c-2.7-1-5.4-1.2-5.4-1.2l.3.4 1.3 1 2.8 1.5 3.7.9 1.3-.3z"
    />
    <path
      fill="#202020"
      d="M348.2 213.8s0 2.4 1.3 3.8c1.2 1.5 4 4 4.6 4.6.6.5 1 3.4 1.9 5.8.8 2.4 1 4.4 1.4 5.1.4.7 1.1 1.8.5 1.7-.5-.1-1-.8-1.4-1.7-.3-.9-.2-.9-.2-2 0-1.3-1.8-7.5-2.7-8.1-.9-.7-4.8-4-6.4-6.3-1.5-2.3-1.2-2.8-1.2-2.8h2.2z"
    />
    <path
      fill="#202020"
      d="M354.6 229.3c-.8-1.7-1-3.3-1.2-4.3a16 16 0 0 0-4.4-4.2c-.6-.3-1.9 0-2.4-.3l-3.7-4s-.5.5-.3.6c.1.1 3.4 3.7 4.6 4.8 1.2 1.2 1.9 3.7 2.7 5.7.9 2 .5 1.6.6 2.5.1 1 .7 1.5 1.3 1.5.6 0 .8-.2.6-.4a10.3 10.3 0 0 1-2.2-3.5c-.7-1.7-1.5-4.9-2.5-6l-.3-.3 1.3-.2c.8 0 4.1 3 4.4 4 .3.8 0 1.2 1.4 4.2s2 3.7 2 3.7h.2s-1.2-2-2-3.8zm-5.2-19.9s2.5 1.5 3.2 1.7a9.8 9.8 0 0 0 1.2.3s.4 4.4 2.1 6.8c1.8 2.5 3.2 3.4 3.2 3.4s0 4.8 1.4 8c1.3 3.3 1.5 7.3 1.2 8-.3.6-1.4-2-2-4.3l-2-6.2a13 13 0 0 0-2.5-4.4c-.8-.7-.2-.6.3-.2.4.4 1.7 2 2.5 4.5s1.1 5 1.5 5c.5 0 .8-.3.8-.9 0-.4-.6-1.8-1-4.1a17 17 0 0 0-1.2-4.7c-.4-.6-1-.7-2.4-3.4a20.3 20.3 0 0 1-2.5-5.3c-.2-1.2 0-1-.2-1.3-.2-.1-.4 0-1.6-.6-1.1-.6-2-2.3-2-2.3z"
    />
    <path
      fill="#202020"
      d="M355.7 208.5s1.4 1.2 2.3 1.5c.8.4 2 .4 2 .4s-.3 4.2 1.3 6.9 3.3 4.2 3.3 4.2.3 1 .8 6.8l.7 8.3c.1 2.3.2 10.6-.1 10.3-1.3-1-.2-5.4-.9-7.3-.6-1.8-1.6-2.1-2.8-7.4-1.2-5.2-.4-6.4-1.3-8.3-.9-2-2-2.2-2-2.2s1.6.4 2.3 2c.6 1.6.7 6 1.3 8.2 1.2 4.9 2.9 7.4 2.9 7.4s-.4-6.2-.8-9.7c-.5-3.5-.5-6.4-1.1-7.7-.7-1.4-2.1-2.4-3-4.2-.8-1.8-1.1-5.3-1.5-6.2-.4-.9-.6-.6-1.2-.8-2-.8-2.2-2.2-2.2-2.2z"
    />
    <path
      fill="#202020"
      d="M360.1 206.2s1.3 1.5 3.1 2.6c1.8 1 2.8.7 3 1 .3.2-.3 3.8 1.6 7.2 1.9 3.4 2.6 3.5 2.6 4l.6 13.9c.3 3.4.5 14.8-.9 14.8s-.1-8.5-.8-10.4c-.7-2-.7-1.4-1.3-3-.7-1.6-.7-7.8-1.8-11.5-.8-2.8-1.6-3.2-1.6-3.2s1.4.7 2 3c.6 2.2.8 10 1.5 11.1.8 1.3 1.8 2.8 2 4a157 157 0 0 0-.4-15.6c-.3-1-3.5-6.6-3.7-9.7-.3-3.2-.4-3.5-.7-3.7-.2-.3-1.1 0-2.6-1.5-1.5-1.4-2.6-3-2.6-3z"
    />
    <path
      fill="#202020"
      d="M367.3 208c0-.3 1 1.7 3.7 2.8 2.9 1.2 5.6 1 6 1.3.3.3 2 4.5 2.1 10.2.1 5.6-1 5.1-1.8 10-.9 4.9-1 14.8-1.5 16.3-.2.5-.5.8-.8 1.7-.3 1 .2 2.8-.7 2.8-.8 0-1-1.4-1-2.1 0-.8 1-3.5 1-6.2s-.6-3-1-6.2c-.4-3.3-.4-13.5-.8-14.5-.3-1-2.1-3.1-2.1-3.1s1.9 1.2 2.4 2.6c.4 1.3.5 12.7 1 15 .5 2.4.3-.5.5-1.8s.9-7 .8-10c-.1-3-1.4-9.4-2.4-10.5 0 0 .5.6 1.1 2 0 .1.4.5.8.7l1 .5s-.6 0-1-.3c-.4-.1-.6-.4-.6-.4a23.9 23.9 0 0 1 1.3 8c.1 5.2-.7 16.4.1 16.5.8.2.7-6 1.5-11.2.8-5 2-5.8 1.6-9.9-.3-4.1-1.4-8.6-2.3-9.2-.9-.5-3.4-.3-5.6-1.8-2.2-1.4-3.4-2.9-3.3-3.2zm-35.8 5.7s.8.4 1.7 0c1-.5 3.5-2.5 3.5-3.3v-1.6s0 .3.7.4c.8.1 2.8-1.4 3-2.4a8 8 0 0 0-.1-3.1c-.2-.4.6.3 1 0 .4-.4 2.4-1.7 2.4-3 0-1.4-1.1-2.6-1.1-2.6s1 .2 1.6 0c.5-.1 2.5-1.3 2.4-2.4 0-1.2-.7-3-2.3-3.2 0 0 1.2.3 2.3-.1 1-.4 1.5-1 1.5-2.3 0-1.2-2.3-4-2.6-4.2-.4-.2 2.4.8 3-.3.8-1.1.9-1.9.7-2.5-.2-.7-.8-.8-.8-.8s1.2.3 2.8-.5 3-2 3.8-1.9c.8 0-2.3 1.7-2.5 2.6 0 .4.9 1 2.3 2 0 .1 0 .2.2.3.7.3 3 .4 3.3.5.2.2-2.4.1-2.2.3a34.1 34.1 0 0 1 5.7 5.4c.1 0 .5.4 1 .5l1.3.3h-1.6a65.3 65.3 0 0 1 3.3 4.7c0 .1.4.6.9.8.5.2 1 .1 1.1.2.1.2-1.4 0-1.3.2a82 82 0 0 1 3.3 6s-3-5.3-6.7-9.5c-3.8-4.2-4.7-4.7-4.8-4.4-.2.4 2.7 4.1 4.3 6.7 1.6 2.6 3 5.9 3 5.9s-3.7-7.8-9-12.6c-5.2-4.8-5.8-5.5-6.3-5.4-.6.2-1 3.8-.7 4.5.3.7 4.2 3.6 7.4 7.5 3.3 3.8 7.5 10.4 7.5 10.4s-3-4.7-8-10-6.9-6.6-7.3-6.5c-.4 0-.4 1-1 1.8-.6.7-1.8.6-1.8 1s4.2 4.3 5 4.7c.9.5 1.4.3 2 .6l1.4 1-1.6-.5c-.6-.2-1.3-.3-1.3 0s3.5 4.3 4 4.6c.6.3 1 .1 1.7.4.8.3 2 1.1 2 1.1s-1.3-.7-2.1-.8c-.9-.2-1.2 0-1.2.2s2.6 3.6 2.5 3.6c-.1 0-4-4.6-7.3-7.5-3.3-3-4.8-3.6-5-3.5-.2.1 0 1-.9 1.3-.8.3-1.5.4-1.5.7 0 .3 3 3 5 5.4a149.4 149.4 0 0 1 4 4.5l-4.5-4.3c-2.3-2.2-3.5-3-3.8-3-.2.2-.2 1.3 0 1.6.2.3 4.6 5.4 4.4 5.5-.1.2-5-6-5.4-6-.3 0-.5.7-.8 1-.4.4-1.8.4-1.8 1 0 .4 7 7.3 6.9 7.5 0 0-5.8-5-6-4.7-.2.3 2.4 5 2.2 5.2-.1 0-3.4-5-3.7-5-.3 0-.2.6-1 1.3-1 .8-2 .4-2 .8 0 .3 4.8 5.7 4.7 5.8-.2.1-5-5.1-5-4.8-.1 0-.4.3-.2.7.3 1.3 1.4 3.6 1.3 3.8 0 0-1.6-3.2-2-3-.4 0-.4.7-1.2 1.1-.7.5-1.3.4-1.3.7 0 .3.8 1 1.2 1.7.4.7.7 2.4.7 2.4s-.5-1.4-1.1-2.3c-.7-.9-1.3-1.5-1.9-1.5s-.8.5-.8.5l-.5-1.2z"
    />
    <path
      fill="#202020"
      d="M377 212s1.5 0 1.7-.4c.2-.3-.6 0-2-1.6s-5-12.1-9-17.4c-6.6-8.7-12.7-12.7-12.7-12.7s7.3 4.2 13 12.4c5.6 8.4 7 14.9 8.6 16.6 1.6 1.7 3.2 2 3 2.5 0 .5-.3.8-.9 1l-2 .1.2-.4zm-48-2.2l.3.1c.3 0 2.3-1.9 2.2-2.5 0 0-1-.3-1.6-1-.7-.8-.9-1.9-.9-1.9s.7 1.3 1.2 1.6c.6.4 1.4.6 1.8.3.3-.2 3.2-2.4 3-3.2 0 0-.9 0-1.8-.6-.8-.6-1-2-1-2s.6 1.1 1.5 1.5c.8.4 1.7.3 2 0 .2-.3 2-3 1.8-3.7 0 0-1 0-1.8-.5-.9-.6-1.3-2.2-1.3-2.2s.6 1.3 1.7 1.5c1.1.3 2-.4 2.2-1.2.2-.8.8-3.7-.2-4.5 0 0-1.4.5-2.4 0-1-.6-1.4-1.9-1.4-1.9s.9 1.2 2 1.4c1.2.1 1.7-.5 1.9-1a5.9 5.9 0 0 0-.1-3c-.4-1-1.1-.8-1.3-2.2 0 0-.3.5-1.8.5s-2.3-1.6-2.3-1.6 1.2 1 2.4 1a1.9 1.9 0 0 0 1.6-1.9c0-.7-.6-1.4-1-2.1-.2-.8-.3-1.7-.5-1.6-.2 0-.5.8-2 .6-1.5-.3-1.8-1.3-1.8-1.3s1 .7 2 .7c.8 0 1.3-.5 1.3-1 0-.6-.3-1.7-2.2-3.3a58.1 58.1 0 0 0-3.5-2.7 21.8 21.8 0 0 0 6.6 5.3s1.7.6 2 0c.1-.6.1-1.4-.5-2.4-.5-1-2-2.6-2-2.6s1.6 1.3 2.3 2.7c.8 1.3.4 2.2.5 2.6 0 .3 3.3 1.6 4 1.1.8-.4.5-1.4-.2-2.3l-1-1.8s.7.8 1.2 1.8c.6 1 1 1.7.8 2.1-.2.5-.6.7-.6.9l2.3 1.3c1 .6 2.3 1 2.5.8.2-.4.3-1.1.2-2.2-.1-1-.7-2.7-.7-2.7s.7 1.6.8 2.7-.1 2 .1 2.4c.3.4 1.1.5 1.1.5s-.6.4-2 0c-1.5-.4-7.7-3.6-8-3.3-.3.4 2.9 2.3 4.3 3.7 1.5 1.3 2.2 2.8 2.2 2.8s-1.1-1-2.2-1.6c-1.1-.6-4.4-2.3-4.7-2-.2.2 1.3.5 1.4.7.1.3-1 1.3-1 1.8 0 .4 4.7 3.7 4.5 4-.1.4-1.2 1.3-1.4 1.2-.1 0-2.5-1.8-2.5-1.6s1.4 1.5 1.4 1.7c0 .3-1 .8-.8 1.4.2.6 2.6 2.6 2.6 3.3 0 .7-1.4 1.3-1.1 1.7l1.5 2s-1.4-.9-1.8-1.4c-.4-.4-1.3-1.5-1.5-1.3-.1.1-1 2-1 2.5.2.4 1.3 1 1.5 2.3.2 1.1-.2 2.4-.3 2.4 0 0-1.6-2-2-2.1-.2 0-.6.1-.9.6s-1.2 2.1-1 2.4c0 .3 1.6.7 1.6 1.9a3.4 3.4 0 0 1-1 2.3l-2.1-2.4c-.2 0-2.2 2.3-2.3 2.6 0 .2 1.4 1.3 1.2 1.7-.3.4-1.3-.2-1.8.1l-1.7.7c-.2 0-.5-.6-.5-.6z"
    />
    <path
      fill="#202020"
      d="M355 180l.5-1c.3-.3 1.5-1.7 1-2-.4-.2-2 .3-3 .2-1 0-1.7.2-4.6-2.3 0 0-9.3-6.4-23.6-7.3-4.6-.2-6.6 1.4-6.8 2.2 0 .2 1.2-1.8 5.7-1.7 2 0 16.5 1.1 24 7 .4.3 2.9 2.7 5.2 2.4 2.3-.2 2.8-.5 2.7-.2 0 .4-.7 1.2-.9 1.6a9.2 9.2 0 0 0-.3 1.1zm-25 2v-.2c-.2-.4-1.1-1.7-2.7-3.1a37.4 37.4 0 0 0-8-4.3c-.3-.1 6 2.9 7.7 4.5l3 3z"
    />
    <path
      fill="#d2a567"
      d="M330 192.2s-.4-.6-1.7-1.4a9.9 9.9 0 0 0-2.5-1.1l3 .7a4.8 4.8 0 0 1 1.1 1.8zm-.8-5.3s-.4-.6-2.1-1.2-2.2-.5-2.2-.5 1.6-.7 2.8 0a2.7 2.7 0 0 1 1.5 1.6zm-1-4.5s-.4-.8-2-1.3c-1.5-.6-2.6-.7-2.6-.7s1.6-.4 3.2.2c1.5.6 1.4 1.8 1.4 1.8zm-2-2.8s-.4-.6-3.3-1.3c-3-.7-4-.7-4-.7s4.1-.4 5.2.1c1.1.5 2.2 1.9 2.2 1.9zm-5.3-3s-1.8-.6-3.5-.7-4.4.1-4.4.1 5-.8 6.3-.5c1.4.3 1.6 1 1.6 1z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M304.5 238.4s.9 1.6 2.6 1.6c1.8.1 3.1 2.6 3.1 2.6l-1.9 1.9-4.6.2-1.5-2.4 2.3-3.9zm0-1.6c.2-.3-1.3-3.3-2.4-3.8-1-.5.4 1 .2 1.6-.3.6-.4 1.4-.3 1.5 0 0 .9 1.4.4 2-.4.5 2.2-1.3 2.2-1.3z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M303.8 241.4s.8.4 1.4.2c.7-.2 1.3-.9 1.3-.9m-3.6-.5s2.6-1.9 2.4-2.9c-.2-1-.7-1-1-.9a7 7 0 0 0-2.1 1.7c-.1.3.7 2.1.7 2.1z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M301 241.5s.6 1.3 1.4 1.3c.8 0 2-.7 2-1.2.1-.5-.8-1.5-1.3-1.7-.6-.3-1.9.4-1.9.4l-.1 1.2z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M303.4 239.8c0 .4-1.7 1.2-2.3 1.2-.5 0-1.6-1.3-1.2-1.5l1.5-.4c.4-.2.5-.8.7-.8.3 0 1 .1 1.1.5.2.5.4.6.2 1z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M301.8 240.9s-2.6 3.4-3.7 3.3c-1-.2.5-5 .5-5l1.2.6c.9.2 1.7.6 2 1z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M297.2 238.4s3.3.6 3.4 1.1c.2.6-1.5 1.3-2.5 1.3-.9 0-.9-2.4-.9-2.4z"
    />
    <path
      fill="#202220"
      d="M289 243.4s.5 1.6 1.9 1.7c1.4 0 2.8-1.5 2.8-1.5l-3.4-1.3-1.3 1.1z"
    />
    <path
      fill="#4b4139"
      d="M289 243.4l.4.9c.3.4.7.8 1.5.9h.1c1.4 0 2.7-1.6 2.7-1.6l-3.4-1.4-1.4 1.2h.1l1.3-1 3.3 1.3v-.1l-.2.2c-.4.4-1.4 1.2-2.4 1.2h-.1a1.8 1.8 0 0 1-1.4-.8 2.8 2.8 0 0 1-.3-.6v-.1l-.1-.1z"
    />
    <path
      fill="#202220"
      d="M290 243s.5 1.2 2.4 1.2 3.3-1.5 3.3-1.5l-3-2.3-2.7 2.6z"
    />
    <path
      fill="#4b4139"
      d="M290 243s.5 1.2 2.4 1.3c2 0 3.4-1.5 3.4-1.5l-3-2.5-3 2.7h.2l2.8-2.5 2.9 2.3v-.1a5 5 0 0 1-3.2 1.4 3 3 0 0 1-2-.6 2.2 2.2 0 0 1-.3-.4 1.1 1.1 0 0 1-.1-.1h-.1z"
    />
    <path
      fill="#4b4139"
      d="M290.2 243.3s.9.6 1.8.7c1 0 2.2-.3 2.2-.3l-1.1.4-.8.1-.8-.1-.6-.3-.6-.4v-.2z"
    />
    <path
      fill="#202220"
      d="M292.4 241.6s.8 2 2.6 1.8c1.7-.2 1.7-1.2 1.7-1.2l-2-2.8-2.3 2.2z"
    />
    <path
      fill="#4b4139"
      d="M292.4 241.6l.5 1c.4.4 1 1 1.8 1l.3-.1c.8-.1 1.3-.4 1.5-.7.3-.3.3-.6.3-.6l-2-3-2.5 2.4h.1l2.4-2.1 1.9 2.7c0 .2-.3 1-1.8 1.1h-.2a2.2 2.2 0 0 1-1.7-.8 4 4 0 0 1-.4-.6v-.2a1.5 1.5 0 0 1-.1-.1h-.1z"
    />
    <path
      fill="#4b4139"
      d="M292.6 242s1 1.3 2 1.3a3 3 0 0 0 1.5-.4v.1l-.5.3-.8.1h-.8l-.7-.5-.6-.9zm-3.2 2s.8.9 1.5.9a4.7 4.7 0 0 0 1.9-.6h.1l-.2.1-.8.4-.9.3-.7-.1-.6-.4-.3-.4v-.2z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M297 238.3c.8-.2 2.4 2 2.4 3.2s-.5 2.7-1.3 2.7-2.6-1.7-3-2.5c-.4-.9-.8-1.4-.5-1.9.3-.4 2.4-1.5 2.4-1.5zm-8 .2s-1.4-1-1.9-.5-.3 2.3 0 2.6c.4.4 2-.8 2-.8l-.2-1.3z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M288.8 239.7s-1.8.2-1.8 1 .9 1.6 1 1.8c.2.1 1.8-.7 1.8-.7l-1-2.1z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M289.5 241.1s-1.8.6-1.8 1.2.8 1.7 1.3 1.7 1-1 1.2-1.3c.3-.2-.7-1.6-.7-1.6zm.8-5.1s-.3-.5-1-.2c-.8.3-1.6 1-1.5 2.3.1 1.1.6 2 .6 2l2.7-1-.8-3.1z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M290.5 238s-2.2.8-2.3 1.7c-.1.9.5 1.7 1 2 .7 0 2.6-1.8 2.6-1.8l-1.3-1.8z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M292.5 241.7s-2.2 1.5-2.5 1.5c-.3 0-1.2-1.2-1-2 .2-.8 1.7-1.3 2.3-1.6.6-.2 1.2 2.1 1.2 2.1zm2-8.2s-.7-.6-2-.5c-1.4.1-2.4 2-2.6 2.8-.2.9 0 2.6.5 2.8.5.3 3.3-2 3.3-2l.8-3z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M291.8 240.3c-1-.1-1.8-1.5-1.7-2.3.2-.8 2-2.2 3-2 1 .1.8 2.5.8 2.5s-1.2 1.9-2.1 1.8z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M294.7 240s-.4 1.2-1.4 1.7c-1 .4-1.5 0-2-.7-.6-.8.2-1.2.6-1.6.5-.4 1.7-.7 1.7-.7l1.1 1.4z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M293.2 237.2s-1 .8-.4 1.8 1 1.4 1.8 1.5c.8.1 1.3-.2 1.9-.9.6-.7 1.5-1 1.4-2-.1-.9-.4-1.6-1-1.8-.5-.3-2.2 0-3.7 1.4z"
    />
    <path
      fill="#202220"
      d="M296.2 233s-1-.5-1.9 0c-.8.5-1.4 1.5-1.5 2.4l.2 2.3s1.2-.4 2-1c.7-.6 1-.8.8-1.1 0-.2-.4-.4-.4-1.2 0-1.4.8-1.5.8-1.5z"
    />
    <path
      fill="#4b4139"
      d="M296.2 233s-1.2-.3-1.9.1a3.2 3.2 0 0 0-1.3 1.9c-.3.8-.1 1-.1 1v-1.4c.4-.8 1-1.5 1.6-1.7.8-.3 1.7 0 1.7 0z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M328.8 257l1.6-.8 2-1.2.4 2.2-1.8 1.4h-1.5l-.9-.7.2-1z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M326.4 257.2h1c1.1 0 1.2-.3 1.4-.3.2.1.5 1.3.5 1.3l-.4.7-1.5.9-1.3-.8-.1-1.8h.4zm12.1-.8s-.3-.5-.9-1l-2.2-1.9v5l2.3-.1 1.1-1.5-.3-.5z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M326.4 257.2s-.4-.5-1.3-.4c-1 0-2 .9-2.1 1.5-.1.7 0 2.6.5 3 .5.4 1.2.5 2.2.3 1-.3 6.4-3.6 6.4-3.6l-1.4.3c-.7.2-1.4-.1-1.4-.1s-.7.8-1.6 1c-.8 0-1-.5-1.2-.9l-.1-1.1z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M330 258.9l-1.2.5-1.3.6.4 1.6 2.3.5 1.4-1.1v-1.6l-1.7-.5zm10.4-1.2l-.8-.8c-.4-.4-1-.5-1-.5l-1.3 1.5v1l1.2.7.9.2 1.1-.8-.1-1.3z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M332.6 257s-1 .4-1.5.8l-1.2 1c0 .2 1.1 1.4 1.1 1.4l1.2.1 2.5-1.7-.2-1.6h-1.9zm9.5 2l-.5-.7c-.4-.4-1-.6-1.2-.6-.3 0-1.3 1.5-1.3 1.5v.4l.8 1 1.6.5 1.1-1.2-.5-.9z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.3}
      d="M338 260.8l1.2.2s0 .3.3.5c.3.3.3 0 .3 0s.2 1.2 1.4 2c0 0 1.4.6 2 .2.8-.4.7 0 .7 0l2-2.4s0-.5-.5-.5c0 0 .4-1.6-1-2-1.2-.2-2.2.2-2.2.2s-1 1.8-1.6 1.6a2.4 2.4 0 0 1-.8-.5l-.7-.9s-.4.1-.9-.2c-.5-.3-.9-1.1-.9-1.1s-.7-.1-1-.4l-.5-.8-1.9 1.4s0 .5-1.1 1.3-1.7.8-1.7.8-.4 1.7-1.6 1.4c-1.2-.3-2-1.6-2-1.6s-.9-.2-1.4.6c-.6.7-.9 1-.9 1.7 0 .8.5 1.8 1 2.2.3.3 1.5 1.3 3 .6 1.4-.8.9-2 .9-2l.8-.5c.9-.6 1.8-1.5 2.5-1.7"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeWidth={0.3}
      d="M335.8 250.8v3.2s.4 2.9-.2 3.7c-.6 1-2.9.7-3.2 0-.3-.8-.2-3.2-.2-3.2l3.6-3.7z"
    />
    <path
      fill="#f8c83c"
      stroke="#977c2e"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.3}
      d="M333.3 260.5s-.5.8 1 1c.4 0 .7-.2.9-.4.4-.4.3-.8.3-.8s-.2 1.2 1.2 1.2c1.4.1 1.3-1.3 1.3-1.3"
    />
    <path
      fill="#202220"
      d="M321.2 263.1s-.8-1.4.1-1.9c1-.5 1.5 0 2.1 0 .6 0 .4-1.4.3-1.7a3.7 3.7 0 0 0-.7-1.2c-.2-.2-3.5.2-3.4 2.3 0 2.1 1.6 2.5 1.6 2.5zm5 5.2s-1-1.5-.4-2.4c.5-.9 1-.3 1.2-.4.3 0 .4-.6 0-1.6-.5-1-1.1-1.4-1.4-1.5-.4 0-2.3 1.4-2 3.2a3.5 3.5 0 0 0 2.6 2.7zm18.2-1.8s3.5 1.5 3.7-2c.2-2-1.5-3.3-2-3.3-.4 0-.7.3-1.3 1-.7.8-1.1 1.3-.9 1.6.3.3 1.3-.3 1.8.8.7 2-1.3 1.9-1.3 1.9z"
    />
    <path
      fill="#4b4139"
      d="M326.2 268.3s-2.7-.6-2.7-3.3c0-1.8 2-2.6 2-2.6s-1.8 1-1.8 2.6c-.1 2.7 2.5 3.3 2.5 3.3zm-5-5.2s-1.6-.3-1.7-2.6c-.2-2.3 3.5-2.2 3.5-2.2s-3.5.2-3.4 2.4c.2 2.2 1.6 2.4 1.6 2.4zm23.2 3.4s.7.3 1.5.3 1.8-.3 2-1.6c.4-1.3.3-2-.6-3.1-.6-.9-1.2-.8-1.2-.8s.6 0 1 .8c.6.8 1.3 1.6.8 3.1s-2 1.5-2.5 1.5a5.5 5.5 0 0 1-1-.2z"
    />
    <path
      fill="#904720"
      d="M302.6 192.4l-.6-.2.4-1 1.9-.7 1.8-.1 2-.1.8.6 1 2.3-3.6 2.2-.6.2-.2-1-.6-1.4z"
    />
    <path fill="#202020" d="M337 245.5l-.3-5.5-14.8 4.6 5.8 5.5z" />
    <path
      fill="#d2a567"
      d="M309.4 235.9l-1.2-1-1.4-.8h-1.1l-.2.3.2.5 1.3 1.6 2.3 1.2.8.7.5.2-1.1-2.7zm-.3 2.3l.8.2.9 1 .5 1 .7 1.3.2.8-1.6-.3-4.8-1.5.4-1.2.8-.7.7-.3 1-.2z"
    />
    <path
      fill="#d2a567"
      d="M312.2 242.2h.8l.6-.5-.3-1.8.3-5.8-3.9-4.6-.8 2.6 1.1 4.7.9 2.8z"
    />
    <path
      fill="#ab6d29"
      d="M309.4 231.7s-.2.4.1 2c.3 1.5.9 4.9 2.2 7.2l-1.3-1.9s-2-4.6-1.7-8.2c.3-3.5.7.8.7.8zm2.9 2.9s-.9 1-1 1.9v2.2s0-1 .8-1.3c.9-.3.7 2.3.8 2.6l.5-4.7-1.1-.7zm.4 9.6l-4.4-1c-2.3-1-3.5-1.8-3.4-2.3 0-.6 4 .1 4.6.2l2.4 1h1l1.9-.8.2 2-2.3 1zm-7.3-.8s1 .8.5 1a4.4 4.4 0 0 1-2.3.3l4.2 1 .9-.7-3.3-1.6z"
    />
    <path
      fill="#d2a567"
      d="M304.2 242.2c.2-.2.3.7 1.8.8 1.5.2 2.2-.2 2.2-.2l.7.4.8.2-.7 1.1-2.8-.8-1.5-.8-.5-.7z"
    />
    <path fill="#ab6d29" d="M314 240.3l.8 1 .5-2.4v-2.5l-1.6-1z" />
    <path
      fill="#4d2a15"
      d="M309.7 236.1l-1.3-2.1-1.7-3.1 1-1.8 1.3 1.8s-.4 1.3-.1 2.5c.2 1.2.8 2.7.8 2.7z"
    />
    <path
      fill="#d2a567"
      d="M300.8 244s.6-.9 1.9-1a7.6 7.6 0 0 1 2.4.2l2.6 1.4.6.9-5-.7-2.5-.8z"
    />
    <path
      fill="#8f4620"
      d="M314 235l.2 4c0 1 .7 2 .6 2.3-.2.4-.4.6-1 .9-.6.2-2 0-2 0s1.3-.2 1.4-.5c0-.2-.4-1.4-.5-2.4 0-1 .1-2.2-.3-2.2-.3 0-.7.4-.8.6 0 0 .4-3.8.8-4.2.4-.4 1.6 1.6 1.6 1.6z"
    />
    <path
      fill="#ab6d29"
      d="M304.7 243s-.5-.4-.5-.8c0-.3.6 1.6 3.4 1.5 2.8 0 2.6-.2 2.6-.2h1.3s-.3 1.3-.5 1.4a61 61 0 0 0-2.2 1.4l-.7.4v-.2l-.3-2.1-2.4-1-.7-.4z"
    />
    <path
      fill="#8f4620"
      d="M309.7 236.1s-3.2-3.3-4.3-5.5c-1-2.2-.4-5.2-.4-5.2l3 4s-.4.7-.3 2c.2 1.2 2 4.7 2 4.7z"
    />
    <path
      fill="#ab6d29"
      d="M307.6 248.3c0-.3-.2-1 .4-1.8 2-2.4 6.8-4 6.8-4v2.8l-6.2 3h-1z"
    />
    <path
      fill="#8f4620"
      d="M308 246c.3-.1 1.4-1 1.4-1.3 0-.4-.7-.4-2.1-.7-1.5-.3-2.6-1-2.6-1s1.7 1.4 2.4 1.7c.7.2.6.5.5.7l.4.6zm8.3.7s-.9-1.3-1.2-2.1c-.3-.8-.3-2.1-.3-2.2l-1 .7-2 .7s2 0 2 .6c0 .7-3 1-3 1 0 .1 2.4-.4 2.3.1-.2.6-1.2.7-2.5 1.2l-2.3 1-.7.5s.6.4 1.5.3c.9 0 2.9-.5 2.9-.5l3.8-1.5.5.2z"
    />
    <path
      fill="#ab6d29"
      d="M316.3 246.7s-1-.3-1.8-4.8-.6-5.7-.6-5.7l1.8 1.3 1.7 3-1.1 6.2z"
    />
    <path
      fill="#8f4620"
      d="M316.9 239.3s-.9 2.5-.9 4c0 1.4-.1 2.4.3 3.4s1.8 2.3 1.8 2.3l.7-.6.3-2 .1-3.4-2.3-3.7z"
    />
    <path
      fill="#202020"
      d="M319.4 242.7s.4 6.3-1.2 6.5c-.7 0-1.9-2.4-1.9-2.5 0 0 1.4 2.3 2 2.1 1-.4.6-6.6.6-6.6l.5.5zm-3.1 4s-.3 0-.7-.8c-.4-.7 0 .6-3.4 1.8-3.4 1.2-4.6.5-4.6.5s1.1 1 4.5 0 3.1-1.3 3.6-1.4h.6z"
    />
    <path
      fill="#ab6d29"
      d="M310 238.7s.6.5 1.2 1.7a363.3 363.3 0 0 0 1 2h.2s-.4-1.3-1-2.2l-2.2-3.1.8 1.6z"
    />
    <path
      fill="#8f4620"
      d="M308 246.5s.3-1.1 0-1.4c-.3-.2-.7 0-3-.2a34 34 0 0 1-4.2-.9s1.6 1 3 1.4l3.5.8.5.1.2.2z"
    />
    <path
      fill="#202020"
      d="M308 246.5l-.2-.5c-.3-.3-.7.1-3.5-.7-2.8-.7-3.5-1.3-3.5-1.3s1 1 3.4 1.5l3.8 1z"
    />
    <path
      fill="#ab6d29"
      d="M309.3 238.2s-2.1.1-2.8.7c-.7.5-1.6 2-1.6 2l1.3.1s-.1-1.2.5-1.9c.7-.6 1.7-.7 2.6-.9z"
    />
    <path
      fill="#8f4620"
      d="M305.3 234.2s.8 1.2 1.7 1.5c.9.4 1.8.8 2.2 1.2.4.4.9 1.8.9 1.8s-3-1.3-3.7-2a9.6 9.6 0 0 1-1.1-2.5z"
    />
    <path
      fill="#8f4620"
      d="M308.2 235s-.3-.5-1.1-.9-1.4-.3-1.7-.1-.1.2-.1.2l1 1.7.7-.2s-1.6-1-1.3-1.3c.8-.7 2.5.5 2.5.5z"
    />
    <path fill="#202020" d="M316.3 231.1l17-8.7 8 11.1-14.7 4-7.7.6-3.8-2.7z" />
    <path
      fill="#4d2a15"
      d="M339 235.9l21 18.2-2.3 1.6-5-1.4-10.2-10.1-3.8-3.8z"
    />
    <path
      fill="#4d2a15"
      d="M366 250.5l-12-9.1-15.3-11.5.4 5.5 17.4 16 5.7 2.7 3-.8 1.4-1.6-.6-1.2z"
    />
    <path
      fill="#803f1d"
      d="M339 237.6s6 6.9 10.6 10.4 9 7.3 10 6.7c.8-.5.5-1 .5-1l-21.3-17.5.1 1.4z"
    />
    <path fill="#4d2a15" d="M353.8 255.1l-2.1 1.7-2.5-1-13-13.2.7-2.5 1.8.3z" />
    <path
      fill="#202020"
      d="M366 250.5s-1.6 3.8-5 2.9c-3.4-.9-22-18.5-22-18.5v1.8s18.8 17.3 22.5 18c3.6.7 6.6-2.5 6.2-2.8a43.7 43.7 0 0 0-1.7-1.4z"
    />
    <path
      fill="#803f1d"
      d="M336.9 240.4s6 7.7 9.1 10.5c3.2 2.9 6 5 7.2 4.8 1.3-.2-.7-1.7-.7-1.7l-9.1-9-4.7-4.6s-1.8-.7-1.8 0z"
    />
    <path
      fill="#202020"
      d="M338.4 240.4s15.2 15.5 16.4 15.9c2.5.7 6.2-2 6.2-2l-1.3-.7-.2.5s-.7 1.6-4 .9c-3.2-.7-16.6-15.1-16.6-15.1l-.5.5z"
    />
    <path
      fill="#4d2a15"
      d="M344 255.3l-5.5-6.4-1.2-2.1-.3-2.7 11 11.1-1.5 1-1.4-.4z"
    />
    <path
      fill="#202020"
      d="M354.1 255.5s-1.3 2-3.2 1.6a5.4 5.4 0 0 1-2.8-1.7L337.5 245l-.3-1.6s11.7 12.3 13.7 12.8c1.6.4 2.7-1.4 2.7-1.4l.5.7z"
    />
    <path
      fill="#202020"
      d="M348.2 255.1s-.5 1.6-2 1.4c-1.6-.3-2-.9-2-.9l-6.6-7.7-.1-2s6.8 9.3 8.3 9.8c1.6.5 2-1 2-1l.4.4z"
    />
    <path
      fill="#b07229"
      d="M341.3 234.9s6.3 5.4 6.8 5.6c.5.3 2.7.4 2.8.7.2.3-1.4 0-1.5.3-.1.4 3.2 3 3.7 3.1.5 0 3.2 0 3.1.4 0 .3-1.8 0-1.9.4 0 .4 2.9 2.7 3.4 2.8.5 0 3.9 0 3.9.4 0 .3-2.7 0-2.7.5.1.6 4.6 3.4 4.4 3.8-.2.4-5.4-3.5-5.5-3.3-.2.2-.4 1.4-.7 1.6-.3.2 0-1.6-.2-2.4-.3-.8-3.4-3.1-3.7-2.9-.3.3 0 1.7-.4 1.7s.1-1.7-.2-2.3a16 16 0 0 0-3.6-3c-.4 0-.1 1.3-.4 1.5-.3.2-.2-1.5-.6-2-.4-.5-7-6.5-6.7-7z"
    />
    <path
      fill="#4d2a15"
      d="M330.5 252.3s0 2.4-1 2.8c-1.1.3-3.1-4.4-3.1-4.4l-.5-4.4 3.1 3 1.5 3zm8.4-1.2V250c0-.6-.3-1.5-.3-1.5l-.2-2.4-.6-1.7-.4-1h-.7l-1.7 1.2-.5 1.6.8 3 .8 2.7 1.3.4 1.5-1z"
    />
    <path
      fill="#4d2a15"
      d="M336.8 255.3c.3-.1-.4-3.4-.4-3.4l-2-4.8-.5-1.7-1.5-.6-1 1.2.2 1.9s1.5 3.2 2.2 4.3c.8 1.1 2.3 3.3 3 3.1z"
    />
    <path
      fill="#202020"
      d="M335 245a6 6 0 0 1 1.4 2.6s1.3 3.6 1.1 4c-.2.3-1 .3-1 .3s1.8 1.8 2.3 1.6c.5-.2.3-2 .1-2.4-.1-.4-.7 0-1-.5-.1-.4-.8-2.7-.8-4.2v-2.7c.2-.3 1.5 3 1.5 4.7l.6.7-.6-3.2-.7-2.3c0-.2.3-.8.3-1.5v-1s.6.5.9.5c.3 0 .7-.4.8-2 .2-1.5-.1-6-.1-6l-6.8 9 2 2.5z"
    />
    <path
      fill="#202020"
      d="M335 244.3s-.3 2.4.6 4.8l1.3 3c.2.3.2 2.9-.1 3.2 0 0-1.8-4.4-2.4-6.6-.5-2.1-.7-3-1-3.2l-.8-.2 2.4-1z"
    />
    <path
      fill="#4d2a15"
      d="M334.4 257c.2 0 0-1 0-1l-.2-2.3-2.4-4.9-2.6-2.3-1.4-2-.2 4s2 4 3.1 5c1.3 1.2 3.3 3.6 3.7 3.5z"
    />
    <path
      fill="#202020"
      d="M324.7 246s.4 1.1.4 1.8v1.4l1.8 3.5c.9 1.5 1.7 3.1 2.4 2.8.7-.4 1-1.5 1-1.7.1-.1-.8 1.3-1.2 1.1a40 40 0 0 1-2.3-6.6l-1-.8a18.4 18.4 0 0 1-1.1-1.4zm7 5.5l-1.7-3.1c-.5-1-1.2-1.7-1.4-1.7-.2 0-.5-2-.5-2s.7 1.3 1.6 1.7c1 .5 1.5.8 2 .7l.2 2-.2 2.4z"
    />
    <path
      fill="#5c3a1d"
      d="M327.4 248.3s.5 1.4 1.4 2.7c.8 1.3 2.3 2.9 2.3 2.9s-1.6-1.6-2.5-2.8a14 14 0 0 1-1.4-2.8h.2z"
    />
    <path
      fill="#202020"
      d="M332 246.7s.5-1.2.8-1.3l1.2-.3s-.7-.1-1.2-.8l-1.3-1.3.4 2 .1 1.7zm-.4.4s2 4 2.4 5.5c.5 1.3.4 3.4.4 3.4s-.2-1.5-.6-2.7l-2.4-5c-.1-.3.2-1.2.2-1.2z"
    />
    <path
      fill="#4d2a15"
      d="M334.2 244.4l.5-6-.5-2.2-2.7-6s-.1.8-.8.8a6.2 6.2 0 0 1-3.1-1.8 9.2 9.2 0 0 0-.2 4.8l5.3 9.9 1.5.5z"
    />
    <path
      fill="#8b441f"
      d="M323.8 248.3s.8 1 1.3 1c.4-.2.3-2.1-.3-3.2-.6-1-7-9.6-8-10.1s7 12.3 7 12.3z"
    />
    <path
      fill="#8b441f"
      stroke="#5c3a1d"
      strokeWidth={0.1}
      d="M328.1 244.8c.2.4.6 3.1-.5 3.4-1.5.3-8.5-9.4-9.6-10.7 0 0-4.4-2.8-4.5-3.5-.1-.7 4.7 1 4.7 1l9.5 9 .5.8z"
    />
    <path
      fill="#202020"
      d="M323.8 248.3s-.8-1.3-.9-2.3c0-1-.4-1.5-.4-1.9 0-.3-5.2-7.7-5.7-8.2-.6-.5-2.3-1.4-2.3-1.4a15.5 15.5 0 0 0 .3 2.4s1.6 3 4 5.7a458.4 458.4 0 0 0 5 5.8z"
    />
    <path
      fill="#4d2a15"
      d="M331.6 247c.7-.3.4-2.7.1-3.5a458.4 458.4 0 0 0-4.4-9.4l-1.3.4-2.3-1.8-1.4-1.5s.5 2.1.4 3.1v1.6l3.3 5.9 5.6 5.3zm4.7-5.2l1-1.3-.5-4.4-2.8-9.4s-.7.1-1.4-.3c-.6-.4-1.4-1.3-1.4-1.3l.7 5.7 2.9 8 .2 2.3 1.3.7z"
    />
    <path
      fill="#202020"
      d="M327.7 244s-2.8-3-3.7-4.5l-1.7-3s-.8.3-1.8 0c-1-.5-2.2-1.8-2.2-1.8s-.8 1.5 3.2 5.6c4.6 4.6 6.2 3.7 6.2 3.7z"
    />
    <path
      fill="#8b441f"
      d="M334.4 245c1.2-.4 1.1-5.4 0-8.7-1-3.3-2.9-6.2-2.9-6.2s2.3 5.4 2.8 7.5c.4 2.2 0 3.7-.4 3.6-.4-.1-.4-1.3-1.3-3.4-1-2-1.6-2.6-1.6-2.6s3.3 8.8 2.3 8.6c-.9-.2-5.3-9.9-5.5-10.2-.2-.2-.4.4-.4.4s4 12.2 7 11z"
    />
    <path
      fill="#4d2a15"
      d="M337 221.3l2 4.2.6 4.4.2 3.7s0 7.4-.8 7.6c-1 .1-1.4-.7-1.4-.9a2729 2729 0 0 1-1.7-8.3l-1.7-8.5.6-.6.2-1.2 1.3-.1.7-.3z"
    />
    <path
      fill="#8b441f"
      d="M331.6 247c.8 0 0-2 0-2s-.6 1-1.2.3c-.5-.7-1.3-3.1-1.3-3.1l-.5-1.5s-.6 1.6-1.3 1.6-4.6-6.4-4.6-6.4l-.4.6s5.4 11.1 9.3 10.6z"
    />
    <path
      fill="#202020"
      d="M329.1 242.2s.7-1.6.4-3c-.3-1.5-2.2-5.1-2.2-5.1s-.6.1-1.4-.2a9.6 9.6 0 0 1-2.2-1.2 38.3 38.3 0 0 0 5.4 9.5zm3.1-2.3s-.5-3.4-2-6.6c-1.6-3.1-2.6-4.1-2.6-4.1v3.5s1.5.5 2.6 2.4c1 2 2 4.8 2 4.8zm4.3-5.8s-.3-3.7-.8-5.8l-1.2-5s0-.2.3-.4h.6c.8.3 1.1 2.2 1.1 2.2l-.1-3.1-.3-.5h-1.4s.3 1-.1 1.3c-.3.3-.6-.2-.7-.3l-.2.4.4 2-.1 1.7s.5 2.2 1.2 3.5c.6 1.4 1.3 4 1.3 4zm3.3-.5s.6-5.3-.6-8.7c-1.2-3.4-2.2-4.2-2.2-4.2l-.6.6s1.8 3 2.4 5.6l1 6.7zm-5.4 2.7s-.6-4.1-1.3-6.8a82.8 82.8 0 0 1-1-3.6l-1.1-1s.7 2.7.6 3.6l-.1 1.4s.5 1.4 1.3 2.6a25.5 25.5 0 0 1 1.6 3.8z"
    />
    <path
      fill="#904720"
      d="M337.2 242.9c1 0 .1-6-.3-7.5-.4-1.6-3-8.8-3-8.8s3 10.3 2.8 10.8c-.3.8-1.5-3.1-1.7-3-.2 0 2.2 6.9 1.3 7-.8 0-1.3-1.5-1.3-1.5l.1 1.5s.6 1.4 2.1 1.5z"
    />
    <path
      fill="#904720"
      d="M338.5 239.9c.7 0-.2-5.7-.7-8.2l-2-7.5s1.5 3.5 2.3 7.5c.8 4 1.4 9 .6 9.2-.8 0-1.2-.8-1.2-.8v-.9s.3.7 1 .7z"
    />
    <path
      fill="#312317"
      d="M328.8 246.5c0 .4 0 2.4-1 2.2-1-.1-2.9-1.9-3.3-3 0 0 2.2 2.5 3 2.4.8 0 .8-2.5.6-3.2 0-.6.6 1.6.6 1.6z"
    />
    <path
      fill="#d2a567"
      d="M334.1 219.5s1.4.9 2.4.3a4 4 0 0 0 1.8-3c0-.8 0-1.5-.7-2.4-.7-.9 1 .7 1 2.3 0 1.6 0 4.3-2.5 5-2.5.5-1.4-.2-1.4-.2l-.6-2z"
    />
    <path
      fill="#8f4620"
      d="M332.1 214.7s1.6 2.6 2.2 5c.7 2.3.5 3.2.2 3.3-.4 0-.6-.3-.7-.9 0-.6-1.7-7.4-1.7-7.4z"
    />
    <path fill="#1e2121" d="M304.1 218l10.6 15.3 13.2-15-8.3-8.6z" />
    <path
      fill="#4d2a15"
      d="M317.5 208.5l-.6 2.4 1.3 4.1 2.2 2.3 2.5 1.7.6-2 .6-2.2.7-.2 1.6.6 1-1.5 1.8-3.1-.4-1.2-.4-.9-2.7-4.6-.9 1.7-.8.5-1.6-.8-1.8 2.4-2.3-1z"
    />
    <path
      fill="#5c3818"
      d="M323 219s.4-.3.6-1.6c.2-1.2.2-4.9-.1-6.4-.3-1.5-1.3-4.4-1.5-4.2-.2.3 1.5 3.3 1.3 7-.3 3.6-.2 4.6-1 5-.7.3.6.2.6.2z"
    />
    <path
      fill="#5c3818"
      d="M323.6 212.8s1.7 2.5 2.5 1.6c.9-.9.5-4 0-5.3l-1.2-3 .5-.6.9 3.4c.3 1.4 1.3 5.2.1 6-1.1.6-2.8-1.5-2.8-1.5v-.6z"
    />
    <path
      fill="#8f4620"
      d="M317.9 214.6s.6-1 1.4-1c.8 0 1 .3 1 .3l.6 2 1.2 2.2 1 1-.5.6-.9.2-2.5-1.4-.7-1-.6-3z"
    />
    <path
      fill="#d2a567"
      d="M322 236.3c-.8.5-2.7-.5-3.7-1.4l-6.8-6.7-.8-3.2 2.2.6 3.9-1.7.7-1.3 4.6-2.4 2.6-1.4 5.5-.1 1.4-2.7s1.8 3.2 2.1 4.5c.4 1.4.3 5.4-.2 5.7-.5.3-2.3-1.2-2.6-1.3-.2-.1 1.4 5.7 0 6-1.3.2-3.6-2.2-3.6-2.2s1 5.2-.2 5.2a10 10 0 0 1-5-2.6s1.3 4.3 0 5z"
    />
    <path
      fill="#8f4620"
      d="M321 229.6l1.1 1.7c.3.4 0 2.9-.2 3.4-.3.9-1.6-1.2-2.3-3l-2.2-3.8c0-.4 3.5 1.7 3.5 1.7zm10.8-12.9s2 8.1 1 8.4c-1 .3-3.6-2.6-4-3l-4-6.4-.8-.8.2-.4 1.7.6 6 1.6z"
    />
    <path
      fill="#8f4620"
      d="M317.9 232.3c-.4.3-1.3-1-1.7-1.4l-3-3.3a11.5 11.5 0 0 1-2.2-2.5c0-.3-.8-1.1-.8-1.1l.7-1h.9s5.4 4.2 5.7 5c.4.6.6 4.1.4 4.3zm8 0c-.2.3-3.7-2.3-5.2-4.4-1.5-2.2-3-4-3.5-5l-.6-1.9 1 .2s8.8 10.8 8.4 11.2zm1.3-3.7c-.2.3-1.7-.9-2.7-2.1-1-1.3-.4-2.9-.4-2.9s3.3 4.8 3.1 5zm2-.5c-.5.3-2.5-2.2-4.2-5-1.3-2-1.6-2.3-1.8-2.5-.5-.3-1.4-.4-1.4-.4l-.2-.3 1-.2.6-.8 1-1.3 4.3 8.5s1 1.9.7 2z"
    />
    <path
      fill="#ab6d29"
      d="M318.3 234.9c0 .3 0 .6-1.2.5a21 21 0 0 1-9.9-7.8l-3-5 1.1-1.4 9.6 11 3.4 2.7z"
    />
    <path
      fill="#8f4620"
      d="M318.3 234.9c0 .5-.5.6-1.1.5-.6-.2-3-1-6.9-5.3a33.3 33.3 0 0 1-5.3-7.4l-.2-1.8 1.2-.5 6.5 10 5.8 4.5z"
    />
    <path
      fill="#4d2a15"
      d="M324.6 230.6s-2-1.5-3.2-3a24 24 0 0 1-3.8-5.7c.1-.7 1.2-.7 1.2-.7v-1.8l.2-.6 1.9.8 2.3 2.9.9 1.1s1.5 3.7 1.2 4c-.3.3-2.4-2-2.7-1.7-.3.3 2.4 4.4 2 4.7zm-3.7-1s.7 1 .4 1.7c-.3.7-.5 1-1.5-.4a16 16 0 0 0-2.3-3c0 .1.1 2.3-.3 2.3-.5 0-2-1.9-3-3.3l-2.5-3.9v-2l-.1-2.5.3.9.4.7 3.6 4.2 1-.7 2.1 4 2 2zm-13.5-6.1s2.8 4.8 5.3 7.5a17.4 17.4 0 0 0 5.6 3.9l-8.4-9.9-2.5-1.5zm21.2 2.8a12 12 0 0 1-3-3.4c-1-1.6-1.9-4-1.8-5 0-1 .4-3.4.4-3.4s2.8 3 3.4 4.3c.5 1.4 1.7 3.3 1.4 3.5-.2.2-2.1-1.3-2.4-1-.2.4 2.3 4.8 2 5zm3.2-3c-.3.1-1.8-1.6-2.1-2.6a14.8 14.8 0 0 1-.6-3.2l-1.2-3v-3.3l1.4-.2 1.9 2.7s.7 1.5.7 3.7c0 2.3.3 5.6 0 5.8zm-22.5 8a41.8 41.8 0 0 1-4-6l-1-2.9.5.4s.8 3.2 4.7 7.1c4 4 4.9 4.2 4.9 4.2s.7 2.2.4 3c0 0-2.9-2.6-5.5-5.7z"
    />
    <path
      fill="#202020"
      d="M313.6 235.9s-3.4-3-6-6.4a46.6 46.6 0 0 1-4.4-6.6l1.2-1a46.3 46.3 0 0 0 9.2 14zm4.7-1l-6-6.1c-2-2.2-3-4.4-3-4.4l1.6.6s.7 1.7 2 3.5l5.4 6.4zm-.8-7s-2.1-2.6-3.1-4.2l-2-3.8s2.8 3.3 3.6 3.5c.9.2.9 0 .9 0s-.4 1.2-.1 2.2l.7 2.3zm.9-10.6s.3 1.9.1 3c-.2 1-.8 1-.8 1a15.7 15.7 0 0 0 4 4l-1.8-2.7c-.5-1-1.3-2-1-2.8.4-1 2.1.6 2.6 1l2.6 2.8s-.8-2.5-1.8-3.4a53.6 53.6 0 0 0-4-2.9z"
    />
    <path
      fill="#202020"
      d="M327 222.8l-1.7-4.2-1.6-5.2v2.8c-.1 1.2-.5 3-1 3.3-.6.2-.7.3-1.7 0-1-.2.7.5.7.5s1 0 1.4-.5c.4-.5.5-1.5 1-1.4.4.2 1 1.7 1.3 2.4l1.6 2.3z"
    />
    <path
      fill="#202020"
      d="M323.7 213.4s2 2.3 3 1.3c.8-1 .3-4 .3-4s1.2.5 1.6.2c.4-.4.2-1.5.2-1.5s2.3 3.2 3.3 5.3c1.1 2 1.6 5.8 1.6 5.8s-1.8-3-2.7-5.8c-.9-2.6-2.1-3.8-2.3-3.5a5.3 5.3 0 0 0-.3 3c.2 1 1 2.1 1.5 3.5l1.1 3.4-1.6-2.5c-.7-.8-1.3-1.2-1.7-1.6-.4-.4-1-1.2-1.7-1.4-.6-.3-1.8-.9-1.8-.4s-.3-1-.3-1l-.2-.8z"
    />
    <path
      fill="#171717"
      d="M316.8 223.3a27 27 0 0 0 4.2 6.3s-2-1.8-2.8-3a15.5 15.5 0 0 1-1.4-3.3z"
    />
    <path
      fill="#8f4620"
      d="M330.2 223.9c-.3 0-1.3-.3-1.4 0 0 .4.6 1.8 1.3 2.5.7.7 1 .7 1.1.6.2 0 0-.7-.2-1.4v-1.7c-.1-.3-.8 0-.8 0z"
    />
    <path
      fill="#d2a567"
      d="M306 209.4l-1.3.7-1.4 3 .4 5.3 2.1 3c.8 1.2 3.5 4.2 4.2 4 .7-.2 1.4-2.3 1.5-3.4l.2-3.2 1.8 2.3c1.1 1.3 2 2.4 2.6 2.3.5 0 2-3.2 2-3.6.1-.4-3.8-10-3.8-10l-1.8-1-6.6.6z"
    />
    <path
      fill="#ab6d29"
      d="M314.8 217.4l1 3.7c.5 1.2 0 2.3.3 2.3.2 0 2.3-2.7 2.3-4 0-1.2 0-2.5-.5-6.3s.2-5 .2-5l-1.2-1-2 4.2-.1 6.1zm-7-2.2l.7 5c.3 1.2 1 3.3 1.4 3.2.4 0 1.6-3.3 1.7-4.4 0 0-.9-1.6-.8-5.5 0-4-.4-4.4-.4-4.4l-2.6 6.1z"
    />
    <path
      fill="#45392d"
      d="M302.5 207.5s-3.1 4.6-3 7c0 2.5.4 2 1.1 4.2.7 2.3 1.1 5.6 1.2 5.9 0 .2.5-.2.5-.5l.2-16.6z"
    />
    <path
      fill="#ab6d29"
      d="M302.5 208s-2.7 4.3-2.5 6.6c.2 2.3.5 2.3 1.3 4.4.8 2 .8 5.4.8 5.4s1-.2 1.9-.9c1-.7 1.8-2.1 1.8-2.1l-1-2.1a8 8 0 0 1-.6-2l-.8-1 .2-4.1.7-3v-1l-1.8-.1z"
    />
    <path
      fill="#dbad6c"
      d="M317.2 215.3s-1.3-.3-1.9-.6c-.6-.3-.8-1.1-.8-1.1l.4-.8 2.3 2.5z"
    />
    <path
      fill="#d2a567"
      d="M303 208.5s-2 4.3-1.7 7.2 1.9 6.6 2 6.7c.2 0 0-.3.1-1v-8.7l.9-2.8v-1.5l-1.3.1z"
    />
    <path
      fill="#8f4620"
      d="M307.8 209.5s.3 1.2.1 1.8c-.2.5-1.2 1.2-1.6 2-.5.8-1 2.8-1 2.8s.4-1.1 1-1.8c.7-.7 1-1.2 1-.8.2.4.4 2 .3 2.3-.1.3-.7.8-1 2-.4 1.3 0 2.4 0 2.4l.5-2.2c.2-.6.7-1 .7-1l1 2.4s0-1.1.3-2c.1-.8 1-2 1.3-2 .3 0 .8-.1-.3-.7-.4-.2-.1-4.2.1-4.4.3-.2 1.9-.2 1.7-.8a11 11 0 0 0-1.6-2.2c-.1-.1-2.5 2.2-2.5 2.2z"
    />
    <path
      fill="#dbad6c"
      d="M317 218.1l-1.5-.3c-.5 0-.6-.6-.6-.6l.2-.6 1.2.7.7.8z"
    />
    <path
      fill="#8f4620"
      d="M304.4 218.6c0 .4-.3.9-.5 1.5-.3.7-.4 1.6-.4 1.6l-.4-3.3-.3-2.4c-.2 0-.7.7-.7.7s0-1.6.3-2.3c.3-.7.5-1.8.3-2-.3-.1-.8.3-1 .7a30.8 30.8 0 0 0-.8 1.3s.3-1.3.6-1.9c.3-.5 1.8-2.2 2-2.8.4-.7.4-1.4.4-1.4h1s1 .8 1 1.5c0 .4-1 .9-1 1 0 0-.8-.1-1 3.2-.2 3.4.6 3.2.5 4.6zm9.4-8.7s.2 1.8 0 2.4c-.2.6-.7 1-1.1 1.8-.4.7-.4 2.4-.4 2.4l.5-1.4.7-1c.1 0 .6.7.8 1.7l.8 2.5s-.2-1.2.1-1.2.5-.1.9.2l.9.8s0-.5-.7-1.1c-.6-.7-1-.6-1.1-1.5-.2-1-.3-1.8-.2-2.2 0-.3.5.3.9.7l1.5 1.4-.7-1v-3c0-1 0-1.9.4-2.1.3-.3.4-1.6.2-1.8-.1-.2-3.5 2.4-3.5 2.4z"
    />
    <path
      fill="#1e2121"
      d="M324.6 206.1a23.7 23.7 0 0 0 1.5 7.1s-1-2-1.6-3.6-.9-3.5-1.3-3.6c-.4-.2-1 .8-1 1.5s.5 3.3 1.1 4.2c.6 1-1-1.2-1.3-2.3l-.7-2.2s-.4 1-.3 2c.2 1.1 1.1 2.7 1.1 2.7l-1-1-.6-.7s0 1.5.4 2.1l1.2 1.7-1.3-1-.4-.8s.2 2.1.6 3.3l1.5 3s-1.2-1-2-2.9c-.8-1.8-1.2-7.3-1-8.1l1.1-1.9c.6-.8 1.3-4.7 1.3-4.7s.9 3.6 1.5 4.3c.6.7 1.2 1 1.2 1zm-8.6-1l.8 1.3.6 1s-1 1.1-2.3 2c-1.2 1-2.8 2-3.1 1.5-.4-.5-.4-1-.4-1s1.4-.8 2.4-1.8a6.6 6.6 0 0 0 1.6-2.2c.2-.6.5-.9.5-.9zm-10.9 3.5s.2 2.2 1.2 2.2c.9 0 3.7-2.9 3.9-3 .2-.1.4-.8.4-1l-.2-.8s-3 3-4 3.2c-.9 0-1.3-.6-1.3-.6zm.1-3l-.3 2c0 .5.2.9.2.9s-2.2.7-2.5 0c-.4-.6-.1-1.6-.1-1.6h1.5c.6-.2 1.2-1.3 1.2-1.3zm20.3-3.1l1.5 3.2 1.4 2.8s-1.4-1.7-1.9-2l-1.2-1 .2-1.1v-2z"
    />
    <path
      fill="#dbad6c"
      d="M302.1 207h1.3c.5 0 .8-.2.8-.2l.9-1.2s-.5 1.4-.2 2.5c.3 1 1 1.1 1.2 1.1a4 4 0 0 0 2.2-1.1c.9-1 2.1-1.9 2.1-1.9s-.3 1.3.2 2.7c.5 1.3 1.2 1.3 2.2.4 1-.8 2-2.2 2.6-2.8l.7-1 1.1-1 1-5.4-.5-.7-1.4.7-1.7-.7-.5-.7-1 1.7-1 .6-.5.1-1.2.3-.5-1.1-.3-.8-.6-.3-2.4 2.5-1.4-.1-1.3 2.2-1 1.3-1 2.4.2.5z"
    />
    <path
      fill="#8f4620"
      d="M313.9 201.5s.2 1.3-.5 3.6-1.6 3.9-1.6 3.9 2.4-1.5 3.6-4.2c1.1-2.6.9-5.7.9-5.7l-2.4 2.4zm3-2.5s.2.4 0 2.4l-.8 4 .6 1.2c.4.7 1.2 1.8 1.7 1.6.6-.2 1.6-.9 2.2-2.2.6-1.4 1.1-2.7 1.4-2.9.2-.2.3.1.4.2 0 .1.3 1.3.9 1.8.5.5 1.3 1.3 1.6 1 .4-.2.8-.9.7-1.2l-1.3-4-1.6-4-1-1.6-2.8.3-2 3.4z"
    />
    <path
      fill="#ab6d29"
      d="M321.7 195.3s.8 1.7.9 3.6c0 1.8-.4 3.8-.4 3.8s.2-2.3 0-3.7c-.3-1.4-.7-2.3-.7-2.7l.2-1z"
    />
    <path
      fill="#4d2a15"
      d="M325.6 202.6v2.3c-.2.8-1.3-.5-2-3-.6-2.5-.5-3-1-4.3l-.9-2.2 1.5-.3 2.4 7.5zm-7 4.6s2.8-1.5 3.1-6.2c.2-2.1-1.2-5.7-1.2-5.7s0 3.8-1 6.2a60.9 60.9 0 0 1-1.9 4s.7-.2 1-.6l.8-1.1s.1.7-.1 1.6l-.6 1.8zm-2.3-8.1s-.1 1-1.3 2c-1 .9-3.1 1.9-3.1 1.9s1.5-1.4 2-2.6c.6-1.2.1-2 .1-2s-.2.6-.8 1.1c-.6.5-1.6.6-1.6.6s0-.6.7-1.3c0-.1 0-.4.2-.7.3-1 1.1-2.3 1.1-2.3s.7 1.4 1.3 2l1.4 1.3z"
    />
    <path
      fill="#1e2121"
      d="M324.7 193.6a17.6 17.6 0 0 0 .9 9s-1.4-2.2-1.7-3c-.4-1-.4-2.3-.7-3a3.2 3.2 0 0 0-1-1c-.3-.2-1-.1-1-.1s.8-.4.8-1.1v-1l1.4.3h1.3zm-6 9.8s1.4-2 1.8-4.6c.4-2.6 0-3.5 0-3.5s-.6 0-1.1-.5c-.5-.5-1.3-1.8-1.3-1.8s.2 1.4 0 3c-.4 1.6-1.8 3-1.8 3s.8.4 1.4 0c1.5-.9 1.4-2.5 1.4-2.5s.3.2.3 2.2-.7 4.7-.7 4.7z"
    />
    <path
      fill="#8f4620"
      d="M301.2 206.9c-.3 0 1-2 1.8-3.4l2.1-3.4s.3.3.8.3a3.6 3.6 0 0 0 2.4-1.7 7 7 0 0 0 1-2.5c0-.3-.1 1.8 1 3 1 1.1.9 1 1.3 1 0 0 0 1.4-.4 2.7l-.8 3.3s.2-2.5-.3-3.2c-.4-.8-.6 0-1 1-.3.9-1.1 1.5-1.1 1.5s.6-1.1 1-2.3c.4-1.2.2-1.2 0-1.2 0 0-.2-.1-.6.4-.5.5-.9.6-.9.6s.5-.4.7-1a6 6 0 0 1 1-1.8c.2-.3.4-.7.4-1 0-.2 0-.7-.2-.7s-.5.3-1.4 1.2l-1.3 1.3-.9 2.6a17 17 0 0 1-1 2.8l-.6.4.9-2.4 1-3.4c-.2-.3-.7-.3-.8 0l-2 2.8c-1 1.4-1 3.1-1.2 3.2l-1-.1z"
    />
    <path
      fill="#874f20"
      d="M325.7 192.1c0 .2 0 1.2-1 1.5a3.5 3.5 0 0 1-2.3-.2c-.2 0-.2-1.4-.2-1.4l3.5.1z"
    />
    <path
      fill="#b27129"
      d="M306 195.4s-.2.9-.8 2c-.5 1.2-1.4 2.2-1.3 2.4 0 .1.6.7 1.4.6.8 0 1.1-4.8 1.1-4.8l-.1-.2h-.3z"
    />
    <path
      fill="#dbad6c"
      d="M318.4 192.7s-.3 6.4-2.1 6.4-2.7-3.2-2.7-3.2-.1 4.3-2.4 4.3c-1 0-2.1-3.4-1.9-4 0 0-.4 2.3-1.5 3.2-2.2 1.7-3.5.9-3.6.6 0-.3 1.8-2 2-4.6 0 0 .4.1 1-.6s.7-1.6 1.3-1.5c.5.2 3-1 3-1l1.4-1.7s.2.5 1.2-.2a3.6 3.6 0 0 0 1.3-1.7l2.7 2.3.3 1.7z"
    />
    <path
      fill="#b27129"
      d="M311.4 186.6l2.7 3.8.6-.5c.4.5.6.9.4 1.2-.4 1-1.3 2.3-.5 3.7 0 0-.3-.8.1-1.8s.7-1.4 1-1.3c.2 0 .6 5.8 1 5.8.3 0 .9-2.7.9-4.5 0-1.8.3-.3.5 0 .2.4 1.8 3 3.1 2.6 1.4-.4 1.2-2.8 1.2-3.3 0-.6-1-3.7-1-3.7l-6.1-3.9-.5 1.6c-.3 1-3.4.3-3.4.3z"
    />
    <path
      fill="#8f4620"
      d="M320 186s.4.4 1 1.9.7 6.4-.1 6.4c-.8 0-2.3-1-2.6-1.6-.3-.7 0-3.1-.4-3.8a8.1 8.1 0 0 1-1.2-2.7l.1-2 1.4-.5 1.9 2.3z"
    />
    <path
      fill="#4d2a15"
      d="M319.6 184.5l2.6 3.9 2.3 3.3 1.2.4a2.5 2.5 0 0 1-3.2.5c-.9-.5-.4-2-1.5-4.5-1.2-2.5-3.2-3.6-3.2-3.6l.7-.7 1.1.7z"
    />
    <path
      fill="#1e2121"
      d="M318.2 182.4s2.3 1.5 3.1 3.2c.9 1.7 1.3 2.7 2.3 4.3 1 1.6 2.1 2.1 2 2.2 0 .1-.7.3-1.2 0a4.7 4.7 0 0 1-1.4-1.6 35 35 0 0 0-2.4-4.2c-.5-.7-2.3-2-2.3-1.9 0 .1.5.5 1.5 2.1a7 7 0 0 1 1.2 3.1l-1.1-2c-1-1.5-2.8-3.3-2.9-3-.1.2 1 1.9 1.5 2.9l1.3 3.3-1.8-3c-1-1.5-1.2-1.3-1.6-1.8l-1.4-1.8s1 .3 1.8-.3c1-.6 1.4-1.5 1.4-1.5z"
    />
    <path
      fill="#8f4620"
      d="M312.3 186.7s1.5.3 2.3.2h1.1s.5.6.5 1.4c0 .7-.5 2.1-.8 2.2-.2 0-.2-1.3-.5-1.8l-2.6-2z"
    />
    <path
      fill="#b27129"
      d="M313.1 190.6s.5 1.6.1 3.9c-.4 2.2-1.7 4.6-2 4.6-.3 0-.2-2.6-.4-4a38.8 38.8 0 0 0 0-.4l-.5 1.6.4-2.6-.1-.8 1.6-2 .9-.3z"
    />
    <path
      fill="#8f4620"
      d="M310.3 192.3c-.5.5-1.2.4-1.8.6-.6.2-.9 1-.9 1s.5-.3.7-.2c.3.1.5.1.1 1.2-.5 1.1-2.2 3-2.1 3 0 0 2-1.5 2.5-2.5.7-.9.6-1.4.8-1.8 0-.3.8-.7 1-.7.1 0 .5 0 .6.7l.6 2.6.8-2.6c.2-1 .2-2.9.2-2.9l-.6-.1c-.5-.1-1.5-1-1.5-1s.2 2-.5 2.7z"
    />
    <path
      fill="#dbad6c"
      d="M318.3 180.8s.6 1.5-.7 2.6c-.4.3-.7.5-1.4.6a4.5 4.5 0 0 1-1.7-.6l-4-1.6-2-.6-1-.3.2-1.1h3l3 1.2 1.3.5 1.1.2h.9l.7-.2.4-.3.2-.4z"
    />
    <path
      fill="#ab6d29"
      d="M318.3 180.8c0 .3-.3 1.1-.6 1.3-.3 0-.8.3-2 0-1.1-.2-2.3-1-3.6-1.3-1.3-.4-2.3-.7-3.3-.7s-.5-.4-.5-.4 2.3-.3 4.3.5c2 .7 2.9 1.2 4 1.2 1.4 0 1.7-.6 1.7-.6z"
    />
    <path
      fill="#4d2a15"
      d="M307.6 179.6h.9c.4 0 .7-.3.7-.3s0 .5-.2.7c-.3.2-1 .1-1.2.1l-.2-.5z"
    />
    <path
      fill="#dbad6c"
      d="M315.3 184.4s1.3 1.3 1 2.4l-2.7-1.2-4.2-1.7-2.3-.7-.3-.4.6-.8.2-.8 2.8.4 3 1 1.9 1.8z"
    />
    <path
      fill="#dbad6c"
      d="M312.4 186.3s2.4 3.1 1.8 4.1l-5.6-3.5-2 3.3-4.7-2.3s3.8-3 4.2-3.5l.5-.7 2 .4 3.4 1 .4 1.2z"
    />
    <path
      fill="#ab6d29"
      d="M311 181.6s2 .5 3.3 1.2c1.3.6 3 .8 3 .8s-.6.7-2 .8c-.4 0-1.4-.8-2-1.3-.7-.4-2.6-1-2.6-1l.3-.5z"
    />
    <path
      fill="#4d2a15"
      d="M307.6 180.6s1.4.3 2.2.7c1 .3 1 .2 1.2.1.3 0 .3-.2.3-.2s.2 1-.5 1-1-.3-1.8-.7c-1-.4-1.5 0-1.5 0v-1z"
    />
    <path
      fill="#ab6d29"
      d="M315.4 186s1 .7.9.9c-.2 0-.7.3-1.6.4a3.4 3.4 0 0 1-2-.4c-.6-.2-1-1.3-2.5-2a18 18 0 0 0-2.8-.9l-1.3-.2 1-.4 3.2.6 2.8.9 1.7.8.6.4zm-5.4 2l.6 2.6-.4 1.5-.8.6-.8-.3-.3-.5s.4-.6 0-1.1c-.3-.6-2-1.2-2-1.2s.7-1.3 1.4-1.6c.8-.3.4-1.2.4-1.2l1.9 1.2z"
    />
    <path
      fill="#4d2a15"
      d="M306.8 182.8s.5.4 1.5.5c.5 0 1.3.2 2.2.5l1-.3-.5.4c.9.2 2 .7 2.5.9a5.8 5.8 0 0 1 2 1.3l-2-1a17.4 17.4 0 0 0-3-.9c-2-.3-4-.2-4.3-.4-.4 0 .1-.1.4-.3.2-.2.2-.7.2-.7z"
    />
    <path
      fill="#ab6d29"
      d="M314 189.8s.7.7 0 .9c-.6.2-2.4.2-3.2-.7l-.6-1.2a14 14 0 0 0-2.4-1.7c-.7-.5.3-.5.3-.5l3.6 1.5a13 13 0 0 1 2.3 1.7z"
    />
    <path
      fill="#4d2a15"
      d="M314 189.9s-1.2-1.8-4.9-3.3l1.2-.2h-2a24 24 0 0 0-.8-.3c-2-.6-2-.6-2.2-.8-.1-.3-.4 0-.6.3l-.7 1a5 5 0 0 1 2.5-.1c1.1.3 1 .7 1 1-.1.5-1.4 2-1.3 2.1.2 0 1-1.5 2-1.3 1 .3 1.2.8 1.2.8s0-.6-.2-.8c-.2-.2-1.3-1.3-1-1.3.3 0 1.6.3 3.3 1.2 1.8.9 2 1.1 2.6 1.7z"
    />
    <path
      fill="#dbad6c"
      d="M308.1 187s2.8.8 2.7 3.8c-.1 3-2.3 2.4-2.5 1.3-.2-1 .3.5 1 .4.9-.2 1-1 1-2.2 0-1-.3-1.6-1-2.2a12 12 0 0 0-1.2-1z"
    />
    <path
      fill="#6c3f18"
      d="M296 179.9s.4.2-.4 2.3c-.8 2.1-1.3 2.8-2.5 4.2-2.2 2.4-3.2 2.5-3 3.5.3 1 1.1.8 1.3.8.2 0 4.3-6 4.3-6l.9-3.5-.2-1-.3-.3z"
    />
    <path
      fill="#dbad6c"
      d="M306.1 175.6s1.2 1.8.8 5c-.3 3.4-4.7 6.3-4.7 6.3l-6.4 4.4-2.7-.2h-.8c-.4-.1-.8-.5-.9-.5l-.5-1.2.9-1 2.3-2.3 1.4-2s.7-1.3.8-2.5c0-1.1-.2-1.7-.2-1.7l.5.8.3 1.8-.2 2 1.6-1.2 2.2-1s.7 0 1-1.3c.5-1.2.9-3 .9-3.8l-.1-1.8h.3c.2 0 .7 1.2.7 1.7l.4 2.8 1-1 1-1.5c.2-.5.4-1.3.4-1.8z"
    />
    <path
      fill="#904720"
      d="M306.8 192.2s.5.4.3 1.6c-.2 1.2-1.1 1.8-1.6 1.8V194l-1.4-1.2-1.5-.4.3-.3c.1-.2 1.7-.8 1.7-.8l2.2.9z"
    />
    <path
      fill="#ab6d29"
      d="M305.7 192.2s.5.4 1.2.3c.7-.2 1-1.3.6-1.8-.4-.4-.2 1-.7 1.3-.4.1-1-1.2-1.5-1.3-.7-.1-1.6.3-1.9.7-.2.4 1 0 1 0l.7.3h.5l.1.5z"
    />
    <path
      fill="#904720"
      d="M296.5 187.6s.8.3 1.7.1l3.1-1 1.8-1.3c.7-.7 3.1-2.2 3.4-5.1.2-3-.4-4.7-.4-4.7s3.5 3.8.5 8.2c-2 2.8-3.8 3.7-3.8 3.7s3.4-1 3.7-.2c.3.8-.1 2-.2 2.3 0 0 1.9.4 2.2 1.4.1.6-2.2-.7-4-.2-1.8.4-2.5 1.4-2.5 1.4s-.4-.5-2-.5c-1.5 0-2.2.7-3.1.7-1 0-3.7-.6-4.2-1.4l1.8-2.2c.8-1.6 2-1.2 2-1.2z"
    />
    <path
      fill="#ab6d29"
      d="M303.8 179.7s1.3-1.3 1.8-2.3c.4-1 .5-1.8.5-1.8s.2 1-.6 2.3-1.7 2-1.7 2v-.2z"
    />
    <path
      fill="#904720"
      d="M303.4 176.7s1.1 4.4 0 6.1c-1.3 1.8-6.5 4.1-6.5 4.1s4-2.1 5.2-4.6 1.1-4.5 1.1-4.5l.2-1z"
    />
    <path
      fill="#1e2121"
      d="M298.2 187.7s1.7 0 2.6-.6c1-.5 2.3-1.7 2.3-1.7s-1.2 1-1.6 1c-.3 0-.6-.5-.5-.9 0 0-.3.8-1 1.4-.8.5-1.8.8-1.8.8zm3.9-5.4s1.4-1.4 1.4-4.4c0-3-1.2-2.5-1.2-2.5s1 .7.7 3c-.2 2.3-1 4-1 4zm1.7.3s1.6-.3 2.1-1.3.6-2.7.6-2.7-.2 1.7-.7 2.3c-.4.6-2 1.7-2 1.7zm-1 9.5s.8-1.5 1.9-1.1c1 .4 1 1.2 1 1.2s-.4-.6-1.2-.7c-.7 0-1.6.6-1.6.6zm-2.9-2.7l3.7-1 3-1s-1.2 1.3-3 2.3c-1.6 1-3 1-3 1s3.2-1.4 3.4-2c0 0-3 .9-4 .7z"
    />
    <path fill="#fff" d="M296.2 185.8a2.6 2.7 67.8 0 1-3 4.4" />
    <path fill="#f16e16" d="M296.1 186.1a2.3 2.4 67.8 0 1-2.7 3.8" />
    <path d="M295 187.4a1 1 0 1 1-.8 1.4" />
    <path
      fill="#d5d3ca"
      d="M295.2 188.6a.3.3 0 1 1-.6-.1.3.3 0 0 1 .3-.3.3.3 0 0 1 .3.4z"
    />
    <path
      fill="#ab6d29"
      d="M296.8 184.2s1.6-1.5 1.9-3.5c.3-2 .1-3.2.1-3.2l.9 1 .3 1.4-.5 2.6 1.6-.8c.6-.8 1.5-4.2 1.2-6.3 0 0 .4 1-.2 3.8-.6 2.9-1 3.2-3.2 4.4a9.6 9.6 0 0 0-3.8 4.2 19 19 0 0 1-2.3 3l1.6-2.6c.8-1.8 1.7-2.8 1.7-2.8l.7-1.2z"
    />
    <path
      fill="#904720"
      d="M296.1 185.4s.7-2 .7-3.1-.7-2.4-.7-2.4 1-.1 1 2.2c.1 2.4-.4 2.6-1 3.3z"
    />
    <path
      fill="#4d2a15"
      d="M299.2 182.8s.7-1.7.7-3c0-1.1-1-2.3-1-2.3s1.1.3 1.2 2.4c.1 2.2-.2 2.2-1 3z"
    />
    <path
      fill="#ab6d29"
      d="M292.1 191s-.6-.8-.5-1.3c0-.6 0-.7 1.4-2.2a13 13 0 0 0 2.5-3c.3-.9 1.5-3 .6-4.6 0 0 .6 2.4-.8 4.3a15.7 15.7 0 0 1-3.3 3.7c-1.1.8-1.3 1.2-1.2 1.7 0 .5.1 1 .3 1 .4.3 1 .3 1 .3z"
    />
    <path
      fill="#6c4119"
      d="M305.5 195.6s.3 0 .5-.3.2-1-.3-1.6a3.3 3.3 0 0 0-1.7-1.1l-2-.4s.4.8 1.3 1.3c.4.2 1.2 0 1.6.4.5.4.6 1.7.6 1.7z"
    />
    <path
      fill="#6c4119"
      d="M305.5 195.6s1.5-.5 1.6-2l-.1-1.2s.2.5.8.7l.6-.2s-1 2.8-3 2.7z"
    />
    <path
      fill="#bf802d"
      d="M294.8 195.3l.8.8.9 1 3.7-1 1.2-1.2-1-1.6h-2.7l-3 2z"
    />
    <path
      fill="#f9c83a"
      stroke="#8f4620"
      strokeWidth={0.4}
      d="M303.8 194l-.7-.9-.7-.6c-.6-.3-2.8-.3-2.8-.3l-1.6.3s-.5.5-1.3.3a22 22 0 0 1-2.6-1l-1.9-.7s-1.3-.6-1.6-.5c-.3.1-1.5 1.3-1.5 1.3s-.2.7.3.7c.4 0-.7.2-.7.2s-2.8 1.6-3.2 4.4c-.5 2.7 4.6 6.8 6.5 4.7 0 0-2.8-2-2.2-3.7.5-1.7 1.8-2.8 4-3 2.1 0 2.3-.3 3.2-1 1-.6 2.7-1 4 .3 1.3 1.4-5 2.7-5 2.7l.7 1s7.7-2.7 7-4.1z"
    />
    <path
      fill="#fcf3d8"
      d="M289.4 200.7s-3.1-.8-2.9-3.7c.3-2.8 3-3.9 3.4-4 .4-.2.3-1.6.8-1.8a2.4 2.4 0 0 1 2 .5l1.4.8s-5.5 2.4-5.5 5.6c0 2.1.8 2.5.8 2.5z"
    />
    <path
      fill="#fdeaaf"
      d="M303.8 193.8s-.4.2-.5 0c-.6-1-2-1.4-3-1.3-1.5 0-2.4.5-3.4.5s-.7-.1-1.8-.2c-1.1 0-3.5-1.8-4-1.6-.6.2-.8.8-.8 1.1.1.4-1 .4-1 .1-.2-.2.7-1.7 1.7-1.7 2.6 0 4.6 1.7 5.8 1.7 1.3 0 1.7-.7 3.4-.7s3.5.8 3.6 2z"
    />
    <path
      fill="#513625"
      d="M295.2 195.8s1.3-.2 2.2-.6l2.2-.8-2 1.2-2 .5-.4-.3z"
    />
    <path
      fill="#f9c83a"
      d="M290.8 202.3c-.2 0-1.3 0-3-1.1-1.8-1.2-2.3-3.2-2.3-3.2s-.4-1.9 1.4-3.8c1.8-1.9 2.1-1.3 2.2-1.2.1 0 0 .1 0 .1l-1.7 1.3-.7 1.3-.7 1.2v1.4l.8 1.5 2.5 1.5 1.5 1z"
    />
    <path
      fill="#8b5122"
      d="M289.8 191.4v-.2.3-.3.3-.3l-.3.2h.2v-.2l-.2.2.2-.2h-.2a.3.3 0 0 0 0 .2l.2-.2h-.2.2-.2.2-.2.2l-.2-.1.2.1-.2-.1-.1.1a4.6 4.6 0 0 0-.4.5l-.2.6v.1c0 .3.2.5.4.6h1.4a.3.3 0 0 0 .1-.4.3.3 0 0 0-.3-.2l-.7.1a.8.8 0 0 1-.3 0v-.2a.5.5 0 0 1 0-.2 3 3 0 0 1 .3-.5l.2-.1v-.1l.1-.2a.3.3 0 0 0-.3-.2.3.3 0 0 0-.2.3.3.3 0 0 0 .3.2z"
    />
    <path
      fill="#f9c83a"
      d="M295.1 194.1l-3.8 1.1c-.3.2 1.2 0 2.4 0l1.3.1.9-.2c1.4-.5 4.4-1.6 4.7-.3.2 1-4.1 2-4.1 2v.5l3.4-.9 1.9-1 .5-.9-1.7-1.2H298l-1.2.3-1.7.5z"
    />
    <path
      fill="#8f4620"
      d="M289.7 199.5c.3.8.9 2 1.6 2.3 0 0 .1 0 0 0 0 .1-.5.5-1.7.1-1.2-.3-3-.7-4.1-4v.7l.7 1.3 1.1 1.2 1.9 1.1 1.2.3 1-.2.6-.4-1.1-1-1.4-2.3.2 1z"
    />
    <path
      fill="#fcca3d"
      d="M302.1 232.6v1.2h-.7v-1.5zm-4.7-34.4l-1.2-1.4-.8.1 1.2 1.8z"
    />
    <path
      fill="#816c2a"
      d="M302 235.5l-1.7-1a10 10 0 0 0-2.4-.6v.3h.2l2.1.6a14.3 14.3 0 0 1 1.7 1l.1-.3zm0-3.1h-3a4 4 0 0 0-1.3.7l.1.2a3.8 3.8 0 0 1 2.6-.7 23 23 0 0 1 1.4.1v-.3zm-.4-2.7l-2.6 1.4-1.6 1.2.2.2.5-.4a16.5 16.5 0 0 1 2.6-1.6l1-.5-.1-.3zm-1.7-2.7s0 .7-.3 1.2a8.6 8.6 0 0 1-.6.8 86.3 86.3 0 0 1-2.5 2.6l.2.3a220.4 220.4 0 0 0 2.5-2.7l.7-.8c.3-.6.3-1.3.3-1.4h-.3zm-2.1-1.2a4.2 4.2 0 0 1-.2 2.2l-1 2.2-.4.9-.2.3.2.2s1.3-2.2 1.7-3.5c.2-.5.2-1 .2-1.5a4 4 0 0 0 0-.9h-.4zm-2.1-.3a8.7 8.7 0 0 0 0 1.2c0 .6 0 1.2-.2 1.7l-.7 1.8-.3 1 .3.1 1-2.8c.2-.5.2-1.2.2-1.8v-1.2h-.3zm-1.6 0v1.2l-.3 2a52.2 52.2 0 0 0-.5 2.5h.3l.2-.8.3-1.7c.3-1 .3-3.2.3-3.2h-.3zm-1.8.3a13 13 0 0 0 0 2.9 14 14 0 0 0-.4 2.5h.3a23.3 23.3 0 0 1 .4-2.4l.1-1.4v-1.6h-.4zm-1.3.2v.2a9 9 0 0 1-.3 2.2l-.6 1.9-.2 1h.3l.8-2.9a8.9 8.9 0 0 0 .3-2.2v-.2h-.3zm-1.6 0v.7c0 .6 0 1.4-.4 2a5.5 5.5 0 0 1-1.3 1.6 9.8 9.8 0 0 1-.7.4l-.2.2.1.3s1.7-1 2.4-2.3c.4-.7.5-1.6.5-2.2v-.7h-.4zm-.9-.3v.2a6.7 6.7 0 0 1-1 1.9c-.3.4-.9.8-1.3 1.1a12.1 12.1 0 0 1-.8.5l.2.3s1.4-.8 2.1-1.7a8 8 0 0 0 1.1-2.2h-.3zm-1.5-.7v.1a6.2 6.2 0 0 1-1 1.3c-.1.2-.5.4-.9.6l-.6.4.1.3.7-.4 1-.7.7-.9.3-.6-.3-.1zm-.7-1l-.3.3-.9 1a6.5 6.5 0 0 1-.5.4l-.4.3.1.3.7-.4c.7-.6 1.5-1.7 1.5-1.7l-.2-.2zm-.4-.6l-.2.2-.9.6a2 2 0 0 1-.8.3v.4l.6-.3c.7-.3 1.5-1 1.5-1l-.2-.2zm-.2-.7l-.8.4-.6.3a1.9 1.9 0 0 1-.4.2v.3c.2 0 .3 0 .5-.2l1.4-.7-.1-.3zm-.4-1.3l-.5.5-.9.3v.3a2 2 0 0 0 1.2-.5 3.8 3.8 0 0 0 .5-.4l-.3-.2zm.1-2.2l-.6.5c-.3.3-.6.6-.7 1a.6.6 0 0 1-.1 0v.5l.2-.2a.8.8 0 0 0 .2-.2c0-.2.4-.6.7-.9a7.9 7.9 0 0 1 .5-.5l-.2-.2zm10.7-12.8h1.6l.1-.2v-.1h-.1v.3-.1h-.2.1-.1v-.2l.1.1v-.1.1-.1h-1.5v.3zm0-1h.2c.2 0 .4 0 .6-.2.4-.1.7-.4 1-.6l.5-.3a.8.8 0 0 1 .3 0v-.4l-.6.2-1 .7-.8.3-.1.3zm0-1.5l.7-.2 1.2-.8c.4-.3.7-.4 1-.4v-.3c-.3 0-.5 0-.8.2l-1.2.7a3 3 0 0 1-1 .5v.3zm-.6-1.4l1.5-1 1.6-1.2-.1-.3-1.7 1.2c-.5.5-1.1.9-1.5 1l.2.4zm-1-1.5l3.2-2.3-.2-.3-3.2 2.3.1.3zm-1.5-1.6a20.7 20.7 0 0 1 3.4-2.3l-.2-.2-1.5 1-1.9 1.3.2.2zm-1-1a123.7 123.7 0 0 1 2.6-1.8l.8-.5-.1-.3a7.6 7.6 0 0 0-.8.5 113 113 0 0 0-2.7 2l.1.2z"
    />
    <path
      fill="#78732e"
      d="M294.5 195.4l.1.1a17.3 17.3 0 0 1 2.5 2.5c1 1.2 1.8 2.7 1.8 4.1v.5a9.5 9.5 0 0 1-2.5 5c-2 2.3-4.8 4.4-7 6.4a18 18 0 0 0-3 3.1 6.1 6.1 0 0 0-1.2 3.7 6.4 6.4 0 0 0 1.1 3.4 4.4 4.4 0 0 0 3.9 2c1.8 0 3.8-.7 5.6-.7 1.6 0 3 .4 4.4 1.9 1.3 1.4 1.7 3.6 1.7 5.7 0 1.6-.2 3-.4 4.2a25.6 25.6 0 0 1-.4 1.8h.3s.8-2.8.8-6c0-2.1-.4-4.5-1.8-6a5.8 5.8 0 0 0-4.6-1.9c-1.9 0-3.9.6-5.6.6a4 4 0 0 1-3.6-1.8 6 6 0 0 1-1-3.3v-.1c0-1.6.7-3 1.9-4.3 1.8-2 4.5-4 7-6.2 2.3-2.2 4.4-4.5 4.7-7.5v-.5c0-1.8-1.1-3.5-2.3-4.8a17.2 17.2 0 0 0-2.3-2.2l-.1.3z"
    />
    <path
      fill="#a8ac71"
      d="M292.1 198.4l-.4-.3-.3.1.6.5zm1 1l-.3-.3h-.1l.2.4z"
    />
    <path
      fill="#78732e"
      d="M294.5 201l-.2-.4-.2.2.3.3zm1 1.5l-.1-.3h-.3l.4.5zm.7 1.5l-.2-.4v.4zm0 1.5v-.4l-.2-.1v.5zm0 1v-.5l-.1-.1v.6zM284 221.1l.1-.7c.1-.3-.3.1-.3.1v.5l.2.1z"
    />
    <path fill="#fff" d="M284 222.1l-.3.1.1.5.1-.2v-.4z" />
    <path fill="#78732e" d="M284 223.9v-.4h-.2v.6z" />
    <path
      fill="#fff"
      d="M284 224.9v-.4h-.1v.4zm.3 1.4v-.4l-.2.1.1.4zm.4 1.4l-.1-.5h-.2l.2.6z"
    />
    <path
      fill="#a8ac71"
      d="M285.6 229.7l-.2-.3h-.2l.3.3zm1.5 1.4l-.5-.3c-.3-.3-.1.2-.1.2l.4.2h.2zm9.8.8l-.4-.3c-.2 0 0 0 .2.4.1.3.2-.1.2-.1z"
    />
    <path fill="#fff" d="M297.7 232.5l-.3-.3v.3h.2z" />
    <path
      fill="#a8ac71"
      d="M297.9 233c-.1-.2-.2.1-.2.1l.2.3v-.5zm0 1.3v-.5c0-.2-.1 0-.1 0v.5h.1z"
    />
    <path
      fill="#fff"
      d="M297.4 235.7l.2-.4h-.2v.4zm-14.8-52s.5-.2.1.4l.3-.5h-.5z"
    />
    <path fill="#f9c83a" d="M294.6 195l.4.3h-.5l.1-.3z" />
    <path fill="#8f4620" d="M295 195.3l-.7.1c-.2 0 .2-.2.2-.2l.4.1z" />
    <path fill="#977c2e" d="M301 239.1s.3 0 .5-.3-.1.4-.1.4l-.3.1-.2-.2z" />
  </svg>
	),
	MY: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#cc0001" d="M0 0h640v480H0z" />
    <path id="prefix__a" fill="#fff" d="M0 445.8h640V480H0z" />
    <use
      width="100%"
      height="100%"
      transform="translate(0 -68.6)"
      xlinkHref="#prefix__a"
    />
    <use
      width="100%"
      height="100%"
      transform="translate(0 -137.2)"
      xlinkHref="#prefix__a"
    />
    <use
      width="100%"
      height="100%"
      transform="translate(0 -205.8)"
      xlinkHref="#prefix__a"
    />
    <use
      width="100%"
      height="100%"
      transform="translate(0 -274.3)"
      xlinkHref="#prefix__a"
    />
    <use
      width="100%"
      height="100%"
      transform="translate(0 -343)"
      xlinkHref="#prefix__a"
    />
    <use
      width="100%"
      height="100%"
      transform="translate(0 -411.5)"
      xlinkHref="#prefix__a"
    />
    <path fill="#010066" d="M0 0h372.6v274.3H0z" />
    <g fill="#fc0">
      <path d="M149.7 48.5c-49 0-88.9 39.7-88.9 88.6a88.8 88.8 0 0 0 89 88.6 88.7 88.7 0 0 0 48-14 78.9 78.9 0 0 1-25.8 4.2 78.7 78.7 0 0 1-78.8-78.5 78.7 78.7 0 0 1 106.2-73.7 88.7 88.7 0 0 0-49.7-15.2z" />
      <path d="M297.1 183.2l-37.4-19.5 11 40-25-33.5-7.8 40.7-7.7-40.7-25.1 33.4 11.2-40-37.6 19.5 28-31.3-42.5 1.6 39-16.3-39-16.5 42.5 1.7L178.9 91l37.4 19.5-11-40 25 33.5 7.8-40.7 7.7 40.7 25.1-33.3-11.2 39.9 37.6-19.4-28 31.2 42.5-1.6-39 16.4 39 16.5-42.5-1.8z" />
    </g>
  </svg>
	),
	MZ: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="scale(.9375)">
      <path fill="#009a00" fillRule="evenodd" d="M0 0h768v160H0z" />
      <path fill="#fff" fillRule="evenodd" d="M0 160h768v16H0z" />
      <path fillRule="evenodd" d="M0 176h768v160H0z" />
      <path fill="#fff" fillRule="evenodd" d="M0 336h768v16H0z" />
      <path fill="#ffca00" fillRule="evenodd" d="M0 352h768v160H0z" />
      <path fill="red" fillRule="evenodd" d="M0 0v512l336-256L0 0z" />
      <path
        fill="#ffca00"
        fillRule="evenodd"
        d="M198.5 333l-51.2-37.5L96.1 333l19.9-60.3-51.5-37.1 63.5.2 19.3-60.4 19.4 60.5 63.5-.3-51.5 37.1z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.1}
        d="M102.8 290.9h37c3 3.3 9.5 4.7 15.8 0 11.6-6.4 34 0 34 0l4.4-4.7-10.7-35.2-3.9-4.2s-8.3-5-24-3.3c-15.7 1.7-21.2-.5-21.2-.5s-13.7 1.6-17.6 3.6l-4.4 4.4-9.4 39.9z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.1}
        d="M110.3 281.8s35.2-4.4 45.4 9.1c-5.7 4-10.8 4.3-16.2.3.8-1.5 12.6-13.8 42.7-9.7"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M148 246.6l-.3 38.8m31.7-38.3L186 278"
      />
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.1}
        d="M117 246.6l-3.7 16"
      />
      <path
        fillRule="evenodd"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.1}
        d="M78.9 295.1l8.6 10.2c1 .6 2 .6 2.9 0l12.8-15.4 5.4-6.7c.9-1 1.1-2.1 1-3l10.4-9.3 2.2.2c-1-.2-1.7-.7-1-1.8l2.4-1.8 1.8 2.3s-2.6 3.4-2.9 3.4h-2.8l-5.4 4.9 2.4 2 3.5 9.8 4.4-3.1-2.8-10 6.1-6.7-2.3-3.6 1.6-2s21.3 13.4 29.6 9.8c.2 0 .5-9.6.5-9.6s-22.2-2.3-22.7-6.7 5-5 5-5l-2.4-3.2.5-1.8 3.9 4.8 8.7-7.4 51.5 58.6c2.8-1.1 3.4-1.8 3.6-4.6L155 241.5l3.8-4.1c.8-.9 1-1.2 1-2.6l6-5.1a7.3 7.3 0 0 1 3.8 3L186 219c.4.4 1.7.8 2.6.4l26.9-25.9-29.3 20.7-1-.7c0-.9 1-1 0-2.6-1.2-1.4-2.9 1.3-3.1 1.3-.3 0-4.3-1.4-5.2-3.2l-.2 4.7-7.5 7-5.7-.3-8.2 8-1 3 1.3 2.7s-4.4 3.8-4.4 3.6c0-.3-.9-1.2-1-1.3l3.8-3.4.5-2.3-1.2-2c-.4.3-5.2 5.4-5.5 4.8l-14-15.5.8-2.9-8.7-9.5c-3.2-1.1-8.3-1.3-9.3 5.7-.8 1.6-7.4.2-7.4.2l-3.6.8L85.2 241l11.3 13.6 23.2-29.3.7-8.3 4.8 5.4c1.7.2 3.2.3 4.7-.5l13.7 15.3-2.3 2.3 2 2.2 2.4-1.6.9 1.3c-1.1.6-2 1.5-3.1 2.1-1.8-1.2-3.6-2.7-3.5-5l-7.7 6.4-.3 1.2-22.9 19-2 .3-.5 6 14.9-12.4v-1.8l1.5 1.3 11.6-9.3s.8 1 .5 1-10.3 9.3-10.3 9.3l-.2 1-1.8 1.6-1-.8-14 12.4h-2l-7.7 7.7c-2 .2-3.7.4-5.4 1.5l-13.8 12.2z"
      />
    </g>
  </svg>
	),
	NA: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h640v480H0z" />
      </clipPath>
    </defs>
    <g fillRule="evenodd" clipPath="url(#prefix__a)">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#3662a2" d="M-26.4.2l.8 345.6L512.5 0-26.4.2z" />
      <path fill="#38a100" d="M666.4 479.6L665 120.3 122.3 479.8l544-.2z" />
      <path
        fill="#c70000"
        d="M-26 371.8l.4 108.2 117.5-.1L665.4 95.4l-.7-94.1-116-1L-26 371.7z"
      />
      <path
        fill="#ffe700"
        d="M219.6 172l-21.8-13.2-12.6 22.1-12.2-22.2-22 12.9.6-25.4-25.4.2 13.2-21.8-22.1-12.5 22.2-12.3-12.8-22 25.4.6-.1-25.5 21.7 13.2L186.3 44l12.2 22.2 22-12.9-.6 25.4 25.4-.2-13.2 21.8 22.1 12.5-22.2 12.3 12.8 22-25.4-.6z"
      />
      <path
        fill="#3662a2"
        d="M232.4 112.4c0 25.6-20.9 46.3-46.6 46.3s-46.6-20.7-46.6-46.3 20.8-46.2 46.6-46.2 46.6 20.7 46.6 46.2z"
      />
      <path
        fill="#ffe700"
        d="M222.3 112.4a36.5 36.5 0 1 1-73 0 36.5 36.5 0 0 1 73 0z"
      />
    </g>
  </svg>
	),
	NC: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#00267f" d="M0 0h213.3v480H0z" />
      <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	NE: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#0db02b" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M0 0h640v320H0z" />
    <path fill="#e05206" d="M0 0h640v160H0z" />
    <circle cx={320} cy={240} r={68} fill="#e05206" />
  </svg>
	),
	NF: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#fff" d="M194.8 0h250.4v480H194.8z" />
      <path fill="#198200" d="M0 0h194.8v480H0zm445.2 0H640v480H445.2z" />
      <path
        fill="#198200"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.7}
        d="M313.5 351.3v52.6l21.3.2s-6.8-45.8-3.1-52c3.7-6 7.2-5.2 7.2-5.2s13.9 4.2 15.4 3.5c1.5-.6-.2-5.2 7.2-4.6 2.4-.9 1.1-5 3.3-5.2 2.2-.3 44.5 11.8 53.7.4-2.4-6.4-10.7-.5-12.9-.2-2 0-10.3-4-15.1 0-4.4-3.3-24.4-5.5-24.4-5.5-2.6-2.6 47.6 1.3 50.5-.7 5.9-5.9-11-5.2-13.6-3.3a14.8 14.8 0 0 0-14.2-.6c-1.7-4.1-18-2.4-27-3.5-3-1.7-2.5-2.7-.5-3.8 19 .8 37.8 3.3 56.8 2.5 5.1-6.7-6.5-9.3-13.6-3.5-4.2-7-12.7-.3-18.4-1-5.7-.6-3-7.6 4.2-6.5 7.2 1 20.1-.4 22.5-3.7s-1.4-6.7-13.3-3.5c-4-4-13 0-17.1 1.3-5.6-3.1-18.5-.5-22.8.6-4.3-2.6 22.5-7 22.5-7 10.4-.2 16.3-2 19.5-2.8 15.7-8.4-.2-9.3-8.4-3.2-5.1-4-10 .3-14.6 1.8a38.2 38.2 0 0 1-13.4 2c0-.6 12.6-8.3 12.6-8.3s15.3-1.1 18.4-1.5c3-.5 18.8-8.5-2.7-3.1-7.4.6-11.8.2-14.7.4-16.5-1.7 1.6-3.3 1.6-3.3s23.4-2.1 23.7-3.3c.4-9-19.1-4.8-19.3-4.8 0-6.5-18.2.2-18.2 0-3.5-2 2-4.1 2-4.1 4.8-1.2 12-1.6 13.9-3.1 0 0 13.6-.1 15.2-3.7-3.3-9.3-28.8 1.6-32.2 3.2-4.6 0 3-7.4 3.3-7.6.2-.3 21-1.1 30.9-14.5.7-8.1-11.6 4.6-11.6 4.6-1-10.6-13.4.7-20.6 1.5-7.3 1-7.5-3.3-2.5-4 5-.6 10.8-.1 13.6-7.8 2.9-7.7 11.4.4 13-2.4 1.5-2.9-3.1-5.3-3.1-5.3s6.4-6.6-4-6.3c-10.2.2-23.6-1.4-23.6-1.4s10.7-4.1 20.8-4c10 .3 4.6-7.1-5-7.1-9.7 0-14.7-3.3-14.7-3.3l16.4-6.2-1-4.6s9.6-7.7-4-5.9l-15.2 2-27.4 4.1c-.2 0-7.4-2.2-.4-4s31.8-6.7 35.5-5.4c3.7 1.3-.4-9.2-13.6-10.5-13.1-1.3-21.3 3.3-21.3 3.3s-8.5-3.1-.6-5.7c7.9-2.7 20.4.9 20.4.9s14-4.2 2.4-6c-11.6-1.7-15.3 1.6-20.6 1.8-2.1-2.7 18.2-3.3 19.5-5.5-2.2-4-14.8 0-22.2 0-3-1.3-3.3-3.5.3-4.8 7.5-.3 14.6.1 22.1-.2-.2-4 0-8.7-.2-12.8-9.6-1.7-20.8 1.3-26.1 1 1.4-4.3 22-5.5 24.3-6.7 4.8-6-20.1 0-20.4 0-4.3-.6-4-3.4-1.3-5 6.4-.7 20.6 1 19.6-3.4-.8-4-10-1.9-13.6-1-3.8.9-9.3.2-9.3.2-2.3-3.2 21.5-1.9 21.3-4.4-.3-2.8-15.1-.8-20.2-.6-3.9-2.7 19-4.5 19.3-4.8.9-7.3-15.3 0-18.4 0-3 0-1.5-4.6-1.5-4.6s6.3-2.9 6.1-3.3a22 22 0 0 0-5.2-2c-.5 0 0-5 0-5s5.2-4 4.8-5.1c-.5-1.1-6.2.9-6.2.9v-4.4s4.2-.4 4.6-2.4c.5-2-5-2.2-5-2.2l-2.2-23-2 21.5-7.2 1s5 2.9 6 5.8c.8 2.8-6.2 2-6.2 2s5.7 4.8 6.1 6.5c.5 1.8-7.9 2.2-7.9 2.2s7 5 7.5 7.9c.4 2.8 0 4.4 0 4.4s-11.6-10.1-19-7.3c-4 2 8.8 3 17.2 10.3 0 1.7-20.5-5-21.2-.8.4 1.1 21.9 4.2 23.4 7-7.8.3-24-1.7-23.4.9-1.7 3 15.2 1.3 22.3 3.7 2.1 2.4 1.9 4.4-1.7 4.6-6.9-3.3-22.1-5.7-22.2-1.5.1 1 15.8.4 21.5 4.1-7.6 1.8-33.4-3.5-33.5-1 .7 1.3 4.8 6.5 11.8 6.3 7-.2 23.3 2.8 24.4 5 1 2.2-21.1-4.6-29.4-.6-8.4 4 23.9 1.5 29.1 6.3 5.3 4.9-10.5-.4-10.5-.4s-22-3-25.2-1.5c-3.3 1.5-7 5-7 5s2.2 4.4 4.4 3.5c2.2-.9-.7 2.7-.7 2.7s30.7 7.4 37.5 14c6.8 6.6-39-10.3-39-10.3s-18.5 6.8 1 7.2c-2.2 3.3 1.2 5.3 1.2 5.3s32.4 6.8 35.7 12c3.3 5.3-22.1-5-27.9-7.9-5.7-2.8-21.9 1.8-21.7 2.9.3 1 8 2.6 8.1 4.6.3 2-9.4 2.6-9.4 4.4 0 1.7 41 10.3 52 19.5s-32.2-11-32.2-11 2.4 3.3 0 4.2c-2.5.9-11-12.3-25-4.2-2.6 3.4 12.2 6 16 6.4-1.3 3.3-2.4 4.4 2.8 7.7s-10.3-4.8-10.3-4.4l1.1 5.7c-4.8-4-10.7-5.1-16.2-1.1 0 0-.2 4 5.5 6.4-3.1 6.3 3.5 4.3 14 10.3-15.6-4.1-16.9 3.5-5.7 5.2s41.9 2.9 49.1 12.3c7.3 9.4-10.3-3.6-12.3-4-.4.3-.8 4.9-.8 4.9-4.7-2.7-9-5.2-14.6-6.3-.5.9-.3 2.1-.8 3-5-3.7-9.5-6.2-16.9-6.6l-.9 3.5s-6.1-7.7-18.2 0c-6.7 4.9 25.5 1.8 30.7 7.5 5.3 5.7 1.1 6.6 1.1 6.6l-13.1-4.9s-15.6-2.8-20 .7 64 12 66 21.5c1.4 5-16-5.4-31.1-9.9l-1.8 5s-6-6-12.7-7c-.2 0 1.3 6 1.3 6s-16.8-8-25.4-3.8c-8.5 4.2 29.8 6.4 33.3 10.3 3.5 4-11.6-2.6-13 0-1.2 2.7-19.9-4.8-19.6-1.3.2 3.5 2.6 5.5 2.6 5.5s38.8 3.7 40.1 8.3c1.3 4.6-21.5-2.6-21.5-2.6s-2.2 3.3-.4 4.8c1.7 1.6-13.2-8.7-11.8-2-4.9-1.9-17.4-7.8-15.6-3.2 1.7 4.6 35.3 11.2 35.3 11.2s-14.7 1-14 4.8c-19-11.5-18.5-4.2-18-4 .4.2-24.4-6.1-5.7 4s10 8.3 10.3 8.5c.2.2 2 5 1.5 5-.4 0-12.7-6.5-16.9-7-4.1-.4-23.9 5.5-2.8 14.8s34-2.2 45.6-1c11.6 1.4 17 3.4 16 7-1.1 3.8-11.9-12.1-23.2 1.7-13-2.6-21.7-4-15 5.4-21-7.9-34 2.4-7.4 6.6 26 .8 42-6.4 42-6.4s4.5 8.1 10.8 2.4c6.4-5.7 6.6 2.2 6.8 2.2l6.2-2.6h1.5z"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.8}
        d="M316 320.2v-3.7s-8.2-1.5-12.3-.7c-2.3-1.3-4.6-3.1-7.5-1.6-.5 1.2 5.3 4.3 7.2 4.3a41.1 41.1 0 0 0 12.7 1.7zm0 6s-8.3-3.1-11.6.4c.5 3.7 9.7 5.5 11.7 4.5 1.9-1 0-4.8-.1-5zm14 1.4v2.6s9.8 1.9 11.6-.2c1.7-2.1-8-3.5-11.7-2.4zm-.5-10.2l.3 2.9s8.6 1.9 11.9-2.8c3.3-4.7-7.5 0-12.2-.1zm.4-10v2s6.5 1 8-1.8c1.4-2.8-7.8 0-8-.2zm-13.4-6c-1-1.3-4.5-4.8-13.8-5.8-6.5 0 11.7 9.5 13.8 5.9zm13.2-9.7l-.2 2.7s22-6.6 27.1-6.1c4.6-1.3 5.6-4.5 5.4-4.5-4-2.9-22.9 2.3-32.3 7.9zm.5-7.8l-.3 2.6s15.5-3 19.7-6c4.1-3-19.2 3.5-19.4 3.4zm-.6-7.6v2.6s10.3-.4 12.5-2.4c1.3-2.1-9.2-.3-12.5-.2zm21.6 21.7s5.4.8 6.4-.8c-.2-2.8-6.4 1-6.4.8zM330 266.6l.1 5.7s24.9-7.9 26.5-9.3c1.5-1.5 5-6-26.6 3.6zm-.7-7.9v4.2s10-.8 14.6-4.5c4.6-3.8-14.6.4-14.6.3zm-12-9.3l.6 3.7-32.9-10.6c.1 0-1.6-5.4 32.3 6.9zm.5-13.3c0 .4 0 3.6-.2 3.5 0 0-22.8-9.5-23.7-8.7-3-7 24 5.4 24 5.2zm11.1 6l.4 3.1s14-2.9 14.8-4.3c.8-1.4-15.2 1.2-15.2 1.1zm.3 7.4c.2.7.4 3.3.4 3.3s5.6-.5 6.5-1.8c.8-1.3-6.9-1.5-6.9-1.5zm-.8-17v3s15.4-3 17-4.4c1.7-1.5-17.3 1.4-17 1.4zm0-8.5c0 .2-.5 3.1-.1 3.1s18.6-3 21.5-5.7c2.8-2.5-21 2.9-21.3 2.6zm-.2-14.9v3.3s11.8-2.5 14-5c2.2-2.5-14 2-14 1.7zm-2-21.6l.2 4.8s16-2.2 18.2-4.8c2.3-2.7-18.5 0-18.4 0zm-7.4-36.5v3s-7.5-.3-5.7-1.6 5.7-1.1 5.7-1.4zm7 4l.2 4.2s9.7-1 10.4-2.5c.8-1.5-10.4-1.6-10.6-1.6zm-.6 6s.2 2.6.4 2.6 3.9-.3 4.7-1.3c.8-1-4.7-1-5-1.3zm-8.2 11.8c0 .3.3 4 0 3.8s-21.2-6.1-23.2-6c-1.9 0-2.4-4.9 23.2 2.2zm1.7 6.9c0 .7.5 4.6-.3 4.4-.7-.2-14.3-4.5-12.9-5.8 1.4-1.3 13.2 1.7 13.2 1.4zm-1.2 29l.1 3.5s-23.7-7.2-24.5-8.4c-.8-1.2-3.1-6.8 24.4 4.9zm1 8.5v3.3l-32.2-11.3s-2.6-8.4 32.1 8z"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={0.8}
        d="M280.3 328.7l-.2 3.5s-6.2-1.8-8.2-5.3c3.6-1 8.5 1.9 8.4 1.8z"
      />
    </g>
  </svg>
	),
	NG: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#008753" d="M426.6 0H640v480H426.6zM0 0h213.3v480H0z" />
    </g>
  </svg>
	),
	NI: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <linearGradient
        id="prefix__f"
        x1={498.7}
        x2={500.6}
        y1={289.1}
        y2={283.4}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#510000" />
        <stop offset={0.3} stopColor="#8a0000" />
        <stop offset={1} stopColor="#a00" />
      </linearGradient>
      <linearGradient
        id="prefix__g"
        x1={501.4}
        x2={502.9}
        y1={291.4}
        y2={287.4}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ff2a2a" />
        <stop offset={1} stopColor="red" />
      </linearGradient>
      <linearGradient
        id="prefix__b"
        x1={484.8}
        x2={484.8}
        y1={311.7}
        y2={317.6}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#F5F549" />
        <stop offset={1} stopColor="#97C924" />
      </linearGradient>
      <linearGradient id="prefix__a">
        <stop offset={0} stopColor="#025" />
        <stop offset={0.5} stopColor="#04a" />
        <stop offset={1} stopColor="#025" />
      </linearGradient>
      <linearGradient
        id="prefix__h"
        x1={444.5}
        x2={634.4}
        y1={317.5}
        y2={317.5}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <clipPath id="prefix__c">
        <path d="M500 226.4l-63.7 110.3h127.4z" />
      </clipPath>
      <linearGradient
        id="prefix__n"
        x1={444.5}
        x2={634.4}
        y1={317.5}
        y2={317.5}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__p"
        x1={444.5}
        x2={634.4}
        y1={317.5}
        y2={317.5}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__q"
        x1={444.5}
        x2={634.4}
        y1={317.5}
        y2={317.5}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__r"
        x1={444.5}
        x2={634.4}
        y1={317.5}
        y2={317.5}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__u"
        x1={484.8}
        x2={484.8}
        y1={311.7}
        y2={317.6}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__b"
      />
      <linearGradient
        id="prefix__x"
        x1={98.9}
        x2={125}
        y1={1440.2}
        y2={1440.2}
        gradientTransform="scale(4.45715 .22436)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__j"
        x1={444.5}
        x2={634.4}
        y1={317.5}
        y2={317.5}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__k"
        x1={444.5}
        x2={634.4}
        y1={317.5}
        y2={317.5}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__m"
        x1={444.5}
        x2={634.4}
        y1={317.5}
        y2={317.5}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__i"
        x1={444.5}
        x2={634.4}
        y1={317.5}
        y2={317.5}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__s"
        x1={484.8}
        x2={484.8}
        y1={311.7}
        y2={317.6}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__b"
      />
      <linearGradient
        id="prefix__v"
        x1={484.8}
        x2={484.8}
        y1={311.7}
        y2={317.6}
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__b"
      />
      <linearGradient
        id="prefix__y"
        x1={47.9}
        x2={61.7}
        y1={3054.2}
        y2={3054.2}
        gradientTransform="scale(9.12405 .1096)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
    </defs>
    <path fill="#0067c6" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M0 160h640v160H0z" />
    <path
      fill="#c8a400"
      d="M248 239.5l8 .5v-1.2l-3-.2.2-3.8 3.3-2.4.1-1.5-3.5 2.5c-.1-.8-.6-1.7-1.4-2-.8-.2-1.6-.2-2.3.3-.8.6-1 1.6-1 2.5l-.4 5.3zm1.2-1.1l.3-4c.1-.6.2-1.4.8-1.8a1 1 0 0 1 1.5.5c.4 1 .2 2.1.1 3.2l-.1 2.2-2.6-.1zm-.2-11.2l7.8 1.8 1.8-7.6a198 198 0 0 1-1.1-.2l-1.5 6.4-2.4-.5 1.4-5.8-1.1-.3-1.4 5.8-2-.5 1.4-6.2-1.2-.2-1.7 7.3zm2.8-10.5l7.6 2.7.4-1.1-3-1 1.2-3.5c.2-1 .4-2-.1-3a2.5 2.5 0 0 0-2-1c-1 0-1.6.7-2 1.5-.6 1-1 2.2-1.3 3.4l-.8 2zm1.5-.7l1.2-3.4c.3-.6.6-1.3 1.3-1.5a1 1 0 0 1 1.2.9c.2 1-.3 2-.6 3l-.7 1.9-2.4-.9zm2.7-9l4.3 2.6c.8.4 1.8.6 2.7.2a6.5 6.5 0 0 0 2.4-3c.4-1 .8-2.2.2-3.2-.6-1-1.7-1.4-2.7-2l-2.7-1.6-.6 1 4 2.4c.7.4 1.2 1 1.1 1.9a6 6 0 0 1-1.2 2.5c-.4.6-1.2 1.1-2 1-.8-.2-1.5-.8-2.2-1.2l-2.7-1.5-.6 1zm5.8-9.3l6.3 4.8 3-3.8c.6-.9 1-2 .7-3a2.5 2.5 0 0 0-2-1.4c-.5 0-1 .3-1.2.4.2-.9-.5-1.7-1.2-1.9-1-.3-2 .3-2.6 1l-2 2.5-1 1.4zm1.6-.3c.7-1 1.4-2 2.2-2.8.4-.4 1-1 1.5-.6.5.2.7.9.4 1.3-.4.9-1 1.5-1.6 2.3l-.8 1.1-1.7-1.3zm2.6 2l2.3-3c.4-.4 1-1 1.6-.8.6.1 1 .7.8 1.3-.3 1-1.1 1.8-1.8 2.7l-1 1.3-2-1.5zm3-10.2l5.5 5.8 4.7-4.5-.8-.8-3.8 3.6h-.1l-4.7-5zm7-6.2l4.9 6.3 1-.7-5-6.3zm7.2-4.9a6.7 6.7 0 0 0-2 1.8 3.6 3.6 0 0 0-.1 4.2 4.1 4.1 0 0 0 1.6 1.5 3.6 3.6 0 0 0 2 .4 6.5 6.5 0 0 0 2.7-1 5.4 5.4 0 0 0 2-2c.4-.8.5-1.6.3-2.4l-1 .4c.2 1.6-.8 2.4-2 3-1.8 1.2-3.5 1.1-4.6-.5-1.1-1.9 0-3.4 1.6-4.4 1.1-.7 2.2-1.2 3.2-.5l.9-.8a3.2 3.2 0 0 0-2-.6c-.9 0-1.7.4-2.6 1zm9.5-4.7l-.9 9 1.3-.5.2-2.8 4-1.6 2.2 1.8 1.2-.5-6.8-5.9-1.2.5zm1 1l2.7 2.2-3 1.2.3-3.5zm16.5-6l.5 8 4.3-.2c1.2-.2 2.4-.4 3.1-1.4 1-1 1.2-2.7.7-4.1a3.5 3.5 0 0 0-2.7-2.4c-1.2-.2-2.4 0-3.6 0l-2.3.2zm1.2 1.1l3.5-.1a3 3 0 0 1 1.8.5c.8.6 1.3 1.5 1.2 2.5a2.7 2.7 0 0 1-2 2.4c-.6.2-1.3.2-1.9.3l-2.2.1-.4-5.7zm10-1.5l-.5 8 7.8.4v-1.1l-6.6-.4.1-2.4 6 .3v-1.1l-5.9-.3.1-2.2 6.4.4v-1.2l-7.5-.4zm20.8 3.3l-2.9 7.5 1 .4 2.4-6v-.2l.2.3 2.8 8 1.3.5 2.9-7.5-1-.4-2.3 6-.1.2-.2-.3-2.7-8zM353 176l-3.7 7-1-.5 3.6-7.1zm6 3.5a6.7 6.7 0 0 0-2.4-1 3.6 3.6 0 0 0-4 1.5 4.1 4.1 0 0 0-.6 2.1c0 .7.1 1.4.6 2.1.4.7 1 1.3 2 2a6 6 0 0 0 2.7 1 3.5 3.5 0 0 0 2.2-.7l-.8-.9c-1.4 1-2.5.3-3.6-.4-1.8-1.2-2.5-2.8-1.4-4.5 1.2-1.8 3.1-1.3 4.7-.3 1 .7 2 1.5 1.8 2.7l1 .4a3.2 3.2 0 0 0-.3-2c-.4-.8-1-1.4-1.9-2zm7.6 5.7l-8.3 3.4 1 .9 2.6-1 3.3 2.8-.7 2.7 1 .9 2.1-8.8-1-.9zm-.3 1.4l-.8 3.4-2.5-2 3.3-1.4zm6.4 4.2l-6.2 5 .7 1 2.5-2 2.4 3-.7 4 .9 1.1.8-4.2c.7.5 1.7.8 2.5.4.7-.4 1.4-1 1.4-1.8 0-1.1-.7-2-1.3-2.8l-3-3.7zm-.2 1.6l2.6 3.2c.4.6.9 1.4.4 2-.3.6-1.1.6-1.6.2-1-.7-1.6-1.7-2.4-2.6l-1-1.1 2-1.7zm9.5 11.1l-9 .4.7 1.2 2.8-.1 2.2 3.8-1.6 2.3.7 1.2 4.9-7.6-.7-1.2zm-.7 1.2l-2 3-1.5-2.8 3.5-.2zm5.9 9.4c-.5-1.3-1.3-2.7-2.7-3.4a3.8 3.8 0 0 0-4.5 1c-1 1-1 2.5-.7 3.9.3 1.5 1 3 2 4.1l-.6.2.4 1.1 3.8-1.3-1.5-4.1-.8.3 1 3-1.2.5a7 7 0 0 1-2.1-3.8c-.3-1.1-.3-2.4.5-3.2 1-1 2.6-1.3 3.7-.5s1.7 2.1 2 3.4c.3.9.2 1.9-.4 2.6-.2 0 0 .3.1.4l.3.5a2.8 2.8 0 0 0 1.1-2.2 7 7 0 0 0-.4-2.5zm2.3 6.3l-4.5.8a4.1 4.1 0 0 0-1.9.8 2.5 2.5 0 0 0-.8 1.5v2.4c.3 1 .6 1.7 1 2.3.3.6.7 1 1.2 1a4 4 0 0 0 2 0l4.5-.8-.2-1.1-4.4.8c-2 .4-2.6-.6-3-2.4-.3-1.8 0-3 1.9-3.3l4.4-.9-.2-1.1zm2.4 13.6l-8.3-3.6.1 1.4 2.6 1 .3 4.4-2.4 1.5.1 1.3 7.7-4.7-.1-1.3zm-1.2.7l-3 1.9-.2-3.2 3.2 1.3zm-136.5 20l-1.2.3 1.3 4.9 1.2-.3zm131.6 0l1.2.3-1.3 4.9-1.2-.3zm-119.2 20.5l-9 1 .8 1.1 2.8-.3 2.4 3.6-1.4 2.5.8 1 4.3-7.8-.7-1.1zm-.7 1.3l-1.7 3-1.8-2.6 3.5-.4zm4.1 3.6l-5.7 5.3.8.8 4.8-4.5-2.6 7 1 .9 6.8-2-4.7 4.3.8.8 5.7-5.3-1.2-1.2-7 2 2.6-6.7zm8.3 8.4l-4.8 6.5 6.2 4.6.7-.9-5.3-4 1.5-2 4.7 3.7.7-1-4.7-3.5 1.3-1.7 5 3.8.7-1-6-4.5zm7.8 5.8l-3.7 7 1 .6 1.5-2.8 3.4 1.8.8 4 1.3.7-.9-4.2c.9.3 2 .1 2.5-.6.5-.6.9-1.3.6-2.1-.2-1-1.3-1.6-2.1-2.1l-4.4-2.3zm.5 1.5l3.6 2c.6.4 1.3.9 1.2 1.6 0 .7-.7 1-1.3.9-1.2-.2-2.2-.9-3.2-1.4l-1.5-.8 1.2-2.3zm8.6 3.2l-3 7.4 1 .5 3-7.4zm7.2 2.5a6.7 6.7 0 0 0-2.6-.4 3.6 3.6 0 0 0-3.4 2.6 4.1 4.1 0 0 0 0 2.1c0 .8.4 1.4 1 2a6 6 0 0 0 2.4 1.3 5.4 5.4 0 0 0 2.9.2 3.4 3.4 0 0 0 2-1.2l-1-.6c-1 1.3-2.3 1-3.6.5-2-.7-3.1-2-2.5-4 .7-2 2.7-2 4.4-1.5 1.2.4 2.3 1 2.4 2.1l1.2.2a3.2 3.2 0 0 0-.9-2 5.4 5.4 0 0 0-2.3-1.3zm8 1.8l-5.2 7.3 1.3.2 1.6-2.3 4.4.7.9 2.6 1.3.2-3-8.5-1.3-.2zm.5 1.3l1.2 3.4-3.2-.5 2-2.9zm18.3-1.2c-1 .1-1.7.4-2.4.9a3.6 3.6 0 0 0-1.7 3.9c.1.7.4 1.3 1 2 .4.5 1 .8 1.8 1 .7.2 1.7.2 2.8 0 1-.2 2-.6 2.6-1.2a3.4 3.4 0 0 0 1.1-2h-1.2c-.3 1.6-1.5 2-2.8 2.2-2.1.4-3.7-.3-4.1-2.3-.4-2.1 1.3-3.1 3-3.5 1.3-.2 2.5-.3 3.2.7l1-.4a3.2 3.2 0 0 0-1.6-1.3 5.4 5.4 0 0 0-2.7 0zm5.3-1l2.3 7.7 7.5-2.2-.4-1.1-6.3 1.9-.7-2.4 5.7-1.7-.3-1-5.7 1.6-.6-2 6-1.8-.3-1.1-7.2 2.1zm8.7-2.7l3.3 7.3 1-.5-2.8-6 7.8 3.5h.5l1-.5-3.4-7.3-1 .5 2.8 6-8-3.6-1.2.6zm8.8-4.1l.6 1 2.8-2h.2l3.7 5.7 1-.7-3.7-5.6v-.1l2.9-2-.6-.9zm8-5.6l5.4 6 .9-.9-2.1-2.3 2.8-2.6 4 .6 1.2-1-4.3-.6c.5-.7.7-1.8.2-2.6-.4-.7-1-1.3-1.9-1.2-1 0-2 .8-2.7 1.4l-3.5 3.3zm1.6.1l3-2.8c.6-.4 1.4-.9 2-.5.7.3.7 1.1.3 1.6-.6 1-1.5 1.7-2.4 2.6l-1.1 1-1.8-2zm7.7-9.4l3.6 8.3.8-1-1-2.6 2.7-3.4 2.7.6.9-1-8.8-2-.9 1.1zm1.4.3l3.5.7-2 2.5-1.5-3.2zm2.1-4.8l6.7 4.3 3.5-5.4-1-.6-2.7 4.3-.1.2h-.1l-5.7-3.8z"
    />
    <g clipPath="url(#prefix__c)" transform="matrix(.8 0 0 .8 -80 0)">
      <path
        fill="#fff"
        d="M500 226.4l-31.5 54.5-15.4 26.7h93.8l-14.7-25.4-32.2-55.8z"
      />
      <g id="prefix__e">
        <g id="prefix__d">
          <path
            fill="#17c0eb"
            stroke="#17c0eb"
            strokeWidth={0.1}
            d="M500 226.4l-2.4 4 2.4 55 2.4-55z"
            opacity={0.6}
          />
          <path fill="#fff" d="M500 277.5h-.1l.1 3 .1-3h-.1z" />
        </g>
        <use
          width="100%"
          height="100%"
          transform="rotate(72 500 285.5)"
          xlinkHref="#prefix__d"
        />
        <use
          width="100%"
          height="100%"
          transform="rotate(144 500 285.5)"
          xlinkHref="#prefix__d"
        />
        <use
          width="100%"
          height="100%"
          transform="rotate(-144 500 285.5)"
          xlinkHref="#prefix__d"
        />
        <use
          width="100%"
          height="100%"
          transform="rotate(-72 500 285.5)"
          xlinkHref="#prefix__d"
        />
      </g>
      <use
        width="100%"
        height="100%"
        transform="rotate(8 500 285.5)"
        xlinkHref="#prefix__e"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(16 500 285.5)"
        xlinkHref="#prefix__e"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(24 500 285.5)"
        xlinkHref="#prefix__e"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(32 500 285.5)"
        xlinkHref="#prefix__e"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(40 500 285.5)"
        xlinkHref="#prefix__e"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(48 500 285.5)"
        xlinkHref="#prefix__e"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(56 500 285.5)"
        xlinkHref="#prefix__e"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(64 500 285.5)"
        xlinkHref="#prefix__e"
      />
      <path
        fill="red"
        d="M500 265.8a44.2 44.2 0 0 0-29 10.8L456.4 302a45 45 0 0 0-.8 8.3h5a39.4 39.4 0 0 1 78.7 0h5a45 45 0 0 0-.7-8.3L529 276.6a44.3 44.3 0 0 0-29-10.8z"
      />
      <path
        fill="#f60"
        d="M500 266.7a43.5 43.5 0 0 0-30.3 12.2l-12 20.9a43.6 43.6 0 0 0-1.3 10.4h4.3a39.4 39.4 0 0 1 78.6 0h4.3a43.9 43.9 0 0 0-1.3-10.5l-12-20.8a43.5 43.5 0 0 0-30.3-12.2z"
      />
      <path
        fill="#ff0"
        d="M500 267.5a42.7 42.7 0 0 0-32 14.3l-8.7 15a42.7 42.7 0 0 0-2 13.5h3.3a39.4 39.4 0 0 1 78.7 0h3.5c0-4.7-.8-9.2-2.1-13.4l-8.8-15.1a42.6 42.6 0 0 0-31.9-14.3z"
      />
      <path
        fill="#0f0"
        d="M500 268.3a42 42 0 0 0-34.9 18.6l-2.8 4.9a41.8 41.8 0 0 0-4.3 18.5h2.7a39.4 39.4 0 0 1 78.6 0h2.7a41.8 41.8 0 0 0-4.3-18.5l-2.8-5a42 42 0 0 0-34.9-18.6z"
      />
      <path
        fill="#0cf"
        d="M500 269a41.2 41.2 0 0 0-41.2 41.3h1.9a39.4 39.4 0 0 1 78.6 0h1.9A41.2 41.2 0 0 0 500 269z"
      />
      <path
        fill="#00f"
        d="M500 269.8a40.4 40.4 0 0 0-40.4 40.4h1.4a39 39 0 1 1 78 0h1.4A40.4 40.4 0 0 0 500 270z"
      />
      <path
        fill="purple"
        d="M500 270.7a39.6 39.6 0 0 0-39.6 40.3h.8v-.8a38.8 38.8 0 1 1 77.6.8h.8v-.8a39.6 39.6 0 0 0-39.6-39.6z"
      />
      <path
        fill="#510000"
        d="M500.4 288.1c-.7 0-1.2-.5-1.8-.6a2.2 2.2 0 0 0-.7 2.1c.3.1.3.4.9.9s.5.7.4 2c0 .4.1 1.5.6 1.6.5.1 1-.3 1.1-1.2.1-.7.4-1.2.7-1.6.3-1.9-.2-2.6-1.2-3.2z"
      />
      <path
        fill="red"
        d="M497.2 283.5c-.6 0-1.6 1-2 .5-.2-.3-.3-.9 0-1.4a4.8 4.8 0 0 1 2.2-2.3c2.3-1.4 3.9-1 5 1 1.1 1.8 2.2 3.8 2.3 5.4 0 .5.3 1.4-.2 1.9-1.3 1.4-4.6-1.5-6.5-1-.6.1-1.4.6-2 .2-.4-.3 0-1 .3-1.3.6-.5 1.5-2.4 1.4-3.2 0-.4 0 .2-.5.2z"
      />
      <path
        fill="url(#prefix__f)"
        d="M497 282.6c-1.2.4-1 1-1.6 1.5.2.1.8.3 1.4-.3.2-.2.5-.3.7-.3l-.7.7a5.2 5.2 0 0 0-1.4 1.8c-.3.8-.4 1.7-.3 1.8 0 0 .4.8 1.5 1.2 2 .8 2.4 2.5 4.5 2.5 1.6 0 1.4-1.1 2.7-.9 1 .2 1.7-.7.6-1.2a14 14 0 0 0-5.4 0c-.4-4 0-2.6-.1-4.4-.1-1.7-.7-1.8 0-3.3-.5 1-1.2.8-2 .8z"
      />
      <path
        fill="#ff2a2a"
        d="M501 279.8l-.1.6.3 1 .2 1c0 .3.4.4.7.6.4.3 0 1 .3 1.1.2 0 .5-1 .5-1.2v-.7a15.3 15.3 0 0 0-.5-.9 3.6 3.6 0 0 0-.2-.3 4.2 4.2 0 0 0-.8-.9 4 4 0 0 0-.3-.2l-.2-.1z"
      />
      <path
        fill="url(#prefix__g)"
        d="M501.3 287.4l-2-.7c-1.3-.4-2.6-1.2-3.5-.8-.3.1-.3.4-.4.9 0 .5-.5 1.3 0 1 .6-.4 2.4.8 3 1.1.3.2 1 .6 1.1 1 .2.6 0 1.8 0 2.4 0 .5.2 1.8.7 2 .6.1 1.1-.4 1.3-1.3.3-.9.4-1.4.8-1.9s.8-.8 1.3-.9c.6 0 1.4.5 1.4-.2 0-.4-.4-.8-.2-1.4.1-.5-.4-.4-.9-.6l-2.7-.6z"
      />
      <path
        fill="#910000"
        d="M498.4 288.9c-.4-.2-2.3-1.5-3-1-.3 0-.4 0-.4-.3l.2-.9c0-.3.2-.8.5-1 .7-.6 2.3.5 3.1.8l-.4 2.4z"
      />
      <path
        fill="#ff3a3a"
        d="M501.8 291.4c.9-1.6 1.5-1.4 2.6-1.4.4 0 .5-.3.4-.7-.3.6-1.7 0-2.5.3-1.5.7-1.2 3.7-2 4 .8.7 1.1-1.7 1.5-2.2z"
      />
      <g fill="url(#prefix__h)">
        <path fill="#fff" d="M453.1 307.6l-10 17.3H557l-10-17.2h-93.8z" />
        <g id="prefix__o" fill="url(#prefix__i)">
          <path
            id="prefix__l"
            fill="url(#prefix__j)"
            d="M449.7 321.4a36 36 0 0 0-4.7.3l-.5.9c2.4-.3 4.7-.7 7.2-.7 3.2 0 6.2.8 9.7.8h4.6c3.5 0 6.4-.8 9.7-.8 3.3 0 6.3.8 9.8.8h4.6c3.5 0 6.4-.8 9.7-.8 3.3 0 6.3.8 9.8.8h4.5c3.5 0 6.5-.8 9.8-.8 3.3 0 6.3.8 9.8.8h4.5c3.5 0 6.5-.8 9.8-.8 2.6 0 5 .5 7.5.7l-.5-1a38 38 0 0 0-4.4-.2h-4.5c-3.5 0-6.5.7-9.8.8-3.3 0-6.3-.8-9.8-.8H522c-3.5 0-6.5.7-9.8.8-3.3 0-6.3-.8-9.8-.8H498c-3.5 0-6.5.7-9.8.8-3.3 0-6.3-.8-9.8-.8h-4.5c-3.5 0-6.5.7-9.8.8-3.3 0-6.2-.8-9.7-.8h-4.6z"
          />
          <use
            width="100%"
            height="100%"
            y={-1.1}
            fill="url(#prefix__k)"
            xlinkHref="#prefix__l"
          />
          <use
            width="100%"
            height="100%"
            y={-2.2}
            fill="url(#prefix__m)"
            xlinkHref="#prefix__l"
          />
        </g>
        <use
          width="100%"
          height="100%"
          y={-3.3}
          fill="url(#prefix__n)"
          xlinkHref="#prefix__o"
        />
        <use
          width="100%"
          height="100%"
          y={-6.7}
          fill="url(#prefix__p)"
          xlinkHref="#prefix__o"
        />
        <path
          fill="url(#prefix__q)"
          d="M453.2 307.5v.2h93.7l-.1-.2h-93.6zm-.2.3l-.1.3H547l-.1-.3h-94zm-.2.4l-.2.3h94.8l-.2-.3h-94.4zm-.3.5l-.3.5h95.6l-.3-.5h-95zm-.4.7l-.3.5h96.4l-.3-.5h-95.8zm-.4.7l-.2.4h97l-.2-.4h-96.6zm-.4.7l-.2.4H549l-.3-.4h-97.4zm-.4.7l-.3.6h98.8l-.3-.6H451z"
        />
        <path
          fill="url(#prefix__r)"
          d="M457.4 312.3c3.4.7 3.7 0 3.7 0zm81.5 0s.3.7 3.7 0z"
        />
      </g>
      <g fill="#ccd11e">
        <g id="prefix__t">
          <path
            fill="url(#prefix__s)"
            d="M530.6 297c-1.7 0-2.2.9-2.2.9-2.7 10.6-11.8 21.3-22.6 21.3h-8V330h61.4l-6.2-11c-9.7-1.4-17.6-11.3-20.1-21.1 0 0-.6-.9-2.3-.9z"
          />
          <path
            fill="#97c924"
            d="M530.6 297.5c-.8 0-1.2.1-1.5.3l-.3.3a33.6 33.6 0 0 1-8.4 14.7c-4 4.1-9 6.9-14.6 6.9h-7.7v9.9H559l-5.7-10c-4.7-.7-9-3.2-12.4-6.8a33.6 33.6 0 0 1-8.4-14.7l-.3-.3a2.8 2.8 0 0 0-1.6-.3z"
          />
          <path
            fill="#ede71f"
            d="M530.6 297.5h.4v10.8a13 13 0 0 1-2 6.4c-.5 1.6-1 1-2.3 2.9a25.4 25.4 0 0 1-5.2 1.2c-2.5.4-8 .8-10.9.1a23 23 0 0 0 9.8-6 30.6 30.6 0 0 0 2.1-2.5 33.7 33.7 0 0 0 3-4.4l1-2a33.9 33.9 0 0 0 1.3-2.9 29.8 29.8 0 0 0 1-3l.3-.3.6-.2 1-.1z"
          />
          <path
            fill="#c6cb24"
            d="M530 298.9c-.5 6-2.3 13.2-6.7 17.8-1.6 1.3-3.7 2.6-5.6 2.3 6.7-5.5 10.8-14 12.2-20.1z"
          />
          <path
            fill="#9ecb34"
            d="M524.5 309.3c-1 2.7-4.8 6.7-8.8 10h-2.9c2.5-.2 8.3-5 11.7-10z"
          />
        </g>
        <use width="100%" height="100%" x={-15.3} xlinkHref="#prefix__t" />
        <g fill="#c6cb24">
          <path
            fill="url(#prefix__u)"
            d="M502.2 298c2.8 10.5 11.8 21.2 22.6 21.2h8.1V330h-65.8v-10.8h8c10.8 0 19.9-10.7 22.6-21.3 0 0 .6-.8 2.3-.8 1.7 0 2.2.8 2.2.8z"
          />
          <path
            fill="#97c924"
            d="M500 297.5c.8 0 1.2.2 1.5.3l.3.3a33.6 33.6 0 0 0 8.4 14.7c4 4.1 9 6.9 14.6 6.9h7.7v9.9h-65v-10h7.7c5.5 0 10.6-2.7 14.6-6.8a33.6 33.6 0 0 0 8.3-14.7l.3-.3a3 3 0 0 1 1.6-.3z"
          />
          <path
            fill="#ede71f"
            d="M499.3 297.5a3.4 3.4 0 0 0-.3 0l-.6.3-.3.3a28.9 28.9 0 0 1-1 3 34.2 34.2 0 0 1-1.2 3 34.2 34.2 0 0 1-1 1.9 33.6 33.6 0 0 1-3 4.4 30.7 30.7 0 0 1-2.1 2.4 23 23 0 0 1-9.8 6.1c2.8.7 4 0 6.5-.4 2-.3 4.2-.6 6-1.2 1.5-2 1-1.3 1.5-2.9 1.2-2.2 3-4.2 3.4-6.7 1.6-3 1.9-8.6 1.9-10.2z"
          />
          <path d="M499.3 298.9c-.4 6-2.3 13.2-6.7 17.8-1.6 1.3-3.6 2.6-5.6 2.3 6.8-5.5 10.9-14 12.3-20.1z" />
          <path
            fill="#9ecb34"
            d="M493.8 309.3a31 31 0 0 1-8.8 10h-2.8c2.5-.2 8.2-5 11.6-10z"
          />
          <path
            fill="#ede71f"
            d="M501 297.6l.5.2.4.3a32.3 32.3 0 0 0 1 3 33.6 33.6 0 0 0 1.2 3l1 1.9a33.6 33.6 0 0 0 3 4.4 30.7 30.7 0 0 0 2.1 2.4 24 24 0 0 0 9.8 6.5c-7.3 0-10.4-.6-13-4a19 19 0 0 1-4.2-7c-.5-2-2-6.5-1.9-10.7z"
          />
          <path d="M501.5 298.9c.4 6 2.2 12 6.6 16.6 1.6 1.4 3.6 2.6 5.6 2.3a31.1 31.1 0 0 1-12.2-18.9z" />
        </g>
        <g id="prefix__w">
          <path
            fill="url(#prefix__v)"
            d="M484.8 297c-1.8 0-2.3.9-2.3.9-2.5 9.8-11.8 22.3-21.5 23.8l-4.8 8.3h49v-11.3c-8.8-2.4-15.9-11.7-18.2-20.8 0 0-.5-.8-2.3-.8z"
          />
          <path
            fill="#97c924"
            d="M484.8 297.5c-.8 0-1.3.2-1.6.3l-.3.3a43.4 43.4 0 0 1-8.1 15c-3.4 4.3-9.7 8.6-14 9l-4.3 7.5h48v-10.7a23.2 23.2 0 0 1-9.5-6 33.6 33.6 0 0 1-8.4-14.8l-.3-.3a2.9 2.9 0 0 0-1.5-.3z"
          />
          <path
            fill="#93bc30"
            d="M483.4 298.9c-.6 9-5.6 20.5-11.3 22.4-1.9.7-5.1.9-6.2 1a36 36 0 0 0 17.6-23.4z"
          />
          <path
            fill="#ede71f"
            d="M484.8 297.5h-.5v10.8c0 2.3.9 4.2 2 6.4l.2.5c.5 1.1.8 1.5 2.3 2.7a22 22 0 0 0 14.8 4c-1.1-.9-2.3-1.7-3.4-2.4l4.5-.5a23 23 0 0 1-9.7-6.2 30.5 30.5 0 0 1-1.4-1.5l-.6-.8a35 35 0 0 1-3.2-4.5 34.2 34.2 0 0 1-1-2 34 34 0 0 1-1.6-3.9 31.7 31.7 0 0 1-.6-2l-.3-.3a2.2 2.2 0 0 0-.6-.2 3.6 3.6 0 0 0-1-.1z"
          />
          <path d="M485.4 298.9c.5 6 2.3 13.2 6.7 17.8 1.6 1.3 3.6 2.6 5.6 2.3a38.5 38.5 0 0 1-12.3-20.1z" />
          <path
            fill="#9ecb34"
            d="M489.6 307.3a35 35 0 0 0 14.6 14.9h2.5c-4.4-2.4-11.5-5.8-17-15z"
          />
        </g>
        <use
          width="100%"
          height="100%"
          x={-15.4}
          fill="#c6cb24"
          xlinkHref="#prefix__w"
        />
      </g>
      <path
        fill="#fff"
        d="M556.5 324.7c-.6.2-4.4-.2-6.4 0l-1.3.3h-3.3c-3.6 0-6.7 1-10.1 1-3.4 0-6.5-1-10-1H522c-3.6 0-6.7 1-10.1 1-3.4 0-6.5-1-10-1h-3.4c-3.6 0-6.7 1-10 1-3.5 0-6.5-1-10.1-1H475c-3.6 0-6.6 1-10 1-3.5 0-6.5-1-10.1-1h-3.4c-2.8 0-6.2.6-8.9.8l-6.3 10.9h127.4z"
      />
      <path
        fill="url(#prefix__x)"
        d="M548 323.1h-.6c-3.2.1-5.6 1.1-11.2 1.1s-6.2-1-12.6-.8c-6 0-8.4 1.2-11.7 1.2-3.2 0-8.4-.7-12.5-.3-4 .4-8.8 1.3-12 1.3-3.9 0-7.8-.7-11.8-.3-4.1.4-6 1.5-11.1 1.5-4.4 0-9-.7-12.8-.7-3.4 0-7.2 1-10 1.4l-.9 1.5c2.3-.3 8.6-1.3 10.8-1.3 2.4 0 10.7.5 15.3.3 4.7-.1 5.2-1.2 10.7-1.2 3.8 0 6.6.4 10.5.4 2.5 0 4.7-1.2 8.4-1.2l2.8-.1c3.1-.5 8.4 0 12 .2 3.3.2 5.5-.6 9-.7l4.4-.1c3.5-.2 6.4.6 9.7.6 3.2-.2 6.4-1 9.8-1l4.5-.2c2.3 0 5.9 0 8.3.5l-.8-1.4c-2.4-.1-5.3-.7-8.2-.7z"
      />
      <g id="prefix__A">
        <path
          id="prefix__z"
          fill="url(#prefix__y)"
          d="M450.3 334.8c-3.4 0-6.4.8-9.6.9a31.8 31.8 0 0 1-3.6-.3l-.5.8h6c3.5 0 6.4-.8 9.6-.9 3.3.1 6.2 1 9.7 1h4.5c3.4 0 6.4-.9 9.6-1 3.3.1 6.3 1 9.7 1h4.5c3.5 0 6.4-.9 9.7-1 3.2.1 6.1 1 9.6 1h4.5c3.4 0 6.4-.9 9.7-1 3.2.1 6.2 1 9.6 1h4.5c3.5 0 6.4-.9 9.6-1 3.3.1 6.2 1 9.7 1h4.5l1.8-.1-.5-.8c-1 .1-2.1.3-3.2.3-3.3 0-6.2-1-9.7-1h-4.5c-3.4 0-6.4 1-9.6 1-3.3-.1-6.2-1-9.7-1h-4.5c-3.4 0-6.4 1-9.6 1-3.3-.1-6.2-1-9.7-1h-4.5c-3.5 0-6.4 1-9.6 1-3.3-.1-6.2-1-9.7-1h-4.5c-3.4 0-6.4 1-9.6 1-3.3-.1-6.2-1-9.7-1h-4.5z"
        />
        <use width="100%" height="100%" y={-1.3} xlinkHref="#prefix__z" />
        <use width="100%" height="100%" y={-2.6} xlinkHref="#prefix__z" />
      </g>
      <use width="100%" height="100%" y={-3.9} xlinkHref="#prefix__A" />
      <use width="100%" height="100%" y={-7.7} xlinkHref="#prefix__A" />
      <path
        fill="#97c924"
        d="M443.9 324.7l-2.5 4.2c2.9-.5 7.1-1.7 10.7-1.7 3.6 0 8 .9 12.4 1 5 0 7-1.2 11-1.6 4.1-.4 8 .5 12 .6 3.1 0 7.9-1.1 12-1.5 4-.5 7.7.3 12.5.3 4.9.1 5.7-1.2 11.6-1.3 6.4-.1 7 .9 12.6.9 4.2.2 7.9-.9 11.7-1.1 3.8-.3 5.5 0 8.3 0l-1.9-3.2-101.3 2.3z"
      />
      <path
        fill="#fff"
        d="M550 324.6l4 .3a91.4 91.4 0 0 0 2.9.3l-.4-.5c-.6.2-4.4-.2-6.4 0z"
      />
    </g>
    <path
      fill="#c8a400"
      d="M320 179.9l-25.7 44.5L268 270h104l-25.7-44.6L320 180zm0 2.4l25.2 43.7 24.7 42.8h-99.8l25.2-43.8z"
    />
  </svg>
	),
	NL: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt" transform="scale(1.25 .9375)">
      <rect width={512} height={509.8} fill="#fff" rx={0} ry={0} />
      <rect width={512} height={169.9} y={342.1} fill="#21468b" rx={0} ry={0} />
      <path fill="#ae1c28" d="M0 0h512v170H0z" />
    </g>
  </svg>
	),
	NO: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#ed2939" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M180 0h120v480H180z" />
    <path fill="#fff" d="M0 180h640v120H0z" />
    <path fill="#002664" d="M210 0h60v480h-60z" />
    <path fill="#002664" d="M0 210h640v60H0z" />
  </svg>
	),
	NP: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0-16h512v512H0z" />
      </clipPath>
    </defs>
    <path fill="#fff" d="M0 0h640v480H0z" />
    <g clipPath="url(#prefix__a)" transform="translate(0 15) scale(.9375)">
      <g fillRule="evenodd">
        <path
          fill="#ce0000"
          stroke="#000063"
          strokeWidth={13.8}
          d="M6.5 489.5h378.8L137.4 238.1l257.3.3L6.6-9.5v499z"
        />
        <path
          fill="#fff"
          d="M180.7 355.8l-27 9 21.2 19.8-28.5-1.8 11.7 26.2-25.5-12.3.5 28.6-18.8-20.9-10.7 26.6-9.2-26.3-20.3 20.6 1.8-27.7L49 409l12.6-25-29.3.6 21.5-18.3-27.3-10.5 27-9L32.2 327l28.4 1.8L49 302.6l25.6 12.3-.5-28.6 18.8 20.9 10.7-26.6 9.1 26.3 20.4-20.6-1.9 27.7 27-11.4-12.7 25 29.4-.6-21.5 18.3zm-32.4-184.7l-11.3 8.4 5.6 4.6a93.8 93.8 0 0 0 30.7-36c1.8 21.3-17.7 69-68.7 69.5a70.6 70.6 0 0 1-71.5-70.3c10 18.2 16.2 27 32 36.5l4.7-4.4-10.6-8.9 13.7-3.6-7.4-12.4 14.4 1-1.8-14.4 12.6 7.4 4-13.5 9 10.8 8.5-10.3 4.6 14 11.8-8.2-1.5 14.3 14.2-1.7-6.7 13.2 13.7 4z"
        />
      </g>
    </g>
  </svg>
	),
	NR: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-54.7 0H628v512H-54.7z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="translate(51.3) scale(.9375)"
    >
      <path fill="#002170" d="M-140 0H884v512H-140z" />
      <path fill="#ffb20d" d="M-140 234.1H884V278H-140z" />
      <path
        fill="#fff"
        d="M161.8 438l-33-33-10.5 45.4-12-45-31.9 34 12.1-45L42 407.9l33-33-45.4-10.6 45-12-34-31.8 45 12L72 288l33 33 10.6-45.4 12 45 31.8-34-12 45 44.5-13.5-33 33 45.4 10.5-45 12 34 32-45-12.2z"
      />
    </g>
  </svg>
	),
	NU: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h496v372H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="scale(1.2902)">
      <path fill="#fff" fillRule="evenodd" d="M0 0h499.6v248.1H0z" />
      <path fill="#c00" d="M0 0v18.6L119.2 80l44.9 1.3L0 0z" />
      <path fill="#006" d="M51 0l144.6 75.5V0H51z" />
      <path
        fill="#c00"
        d="M214.9 0v96.4H0v55h215v96.4h66v-96.4h215v-55H281V0h-66z"
      />
      <path fill="#006" d="M300.2 0v71.1L441.6.6 300.2 0z" />
      <path fill="#c00" d="M304.7 78.9l39.8-.3L498.9.6l-41 .6L304.8 79z" />
      <path fill="#006" d="M0 167.5v52.8L99.2 168 0 167.6z" />
      <path
        fill="#c00"
        d="M381.9 169.7l-41.4-.3 155.8 77.5-1-17.7-113.5-59.5zM38.7 248.3l146.1-76.8-38.3.3L0 248.1"
      />
      <path
        fill="#006"
        d="M497.9 21.8l-118 58.5 116.4.5v87.1h-99.1l98.2 53.3 1.4 27-52.4-.6-143.6-70.5v71.2H196V177L61.3 248l-60.9.2V496H992V.4L499 0M.6 28L0 79.4l104.4 1.3L.5 28z"
      />
      <g fill="#ffd900" fillRule="evenodd" strokeWidth="1pt">
        <path d="M496 0h496.1v496h-496z" />
        <path d="M0 248h523.5v248H0z" />
      </g>
      <g fillRule="evenodd">
        <path
          fill="#000067"
          d="M290.9 125.3a42.8 42.8 0 1 1-85.5 0 42.8 42.8 0 0 1 85.5 0z"
        />
        <path
          fill="#fff40d"
          d="M240.2 114.3l8.2-24.6 8.2 24.6h26.7l-21.6 15.2L270 154l-21.6-15.3-21.6 15.2 8.3-24.5-21.6-15.2zm148.5 4l4.1-11.5 4 11.6h13.3l-10.7 7 4.1 11.5-10.7-7-10.7 7 4.1-11.5-10.7-7zM244.1 204l4-11.5 4.1 11.5h13.2l-10.7 7 4.1 11.6-10.7-7.1-10.7 7 4.1-11.4-10.7-7.1zm0-167l4-11.6 4.1 11.5h13.2L254.7 44l4.1 11.5-10.7-7-10.7 7 4.1-11.5-10.7-7zM98.9 118.2l4.1-11.5 4 11.5h13.3l-10.7 7.1 4.1 11.5-10.7-7-10.7 7 4.1-11.5-10.7-7z"
        />
      </g>
    </g>
  </svg>
	),
	NZ: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <g id="prefix__b">
        <g id="prefix__a">
          <path d="M0 0v.5L1 0z" transform="translate(0 -.3)" />
          <path d="M0 0v-.5L1 0z" transform="rotate(-36 .5 -.2)" />
        </g>
        <use transform="scale(-1 1)" xlinkHref="#prefix__a" />
        <use transform="rotate(72 0 0)" xlinkHref="#prefix__a" />
        <use transform="rotate(-72 0 0)" xlinkHref="#prefix__a" />
        <use transform="scale(-1 1) rotate(72)" xlinkHref="#prefix__a" />
      </g>
      <clipPath id="prefix__c">
        <path d="M0 0h600v300H0z" />
      </clipPath>
      <clipPath id="prefix__d">
        <path d="M0 0l300 150H0zm300 0h300L300 150zm0 150h300v150zm0 0v150H0z" />
      </clipPath>
    </defs>
    <path fill="#00247d" fillRule="evenodd" d="M0 0h640v480H0z" />
    <g transform="translate(-93 36.1) scale(.66825)">
      <use
        width="100%"
        height="100%"
        fill="#fff"
        transform="matrix(45.4 0 0 45.4 900 120)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        fill="#cc142b"
        transform="matrix(30 0 0 30 900 120)"
        xlinkHref="#prefix__b"
      />
    </g>
    <g transform="rotate(82 534.2 125) scale(.66825)">
      <use
        width="100%"
        height="100%"
        fill="#fff"
        transform="rotate(-82 519 -457.7) scale(40.4)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        fill="#cc142b"
        transform="rotate(-82 519 -457.7) scale(25)"
        xlinkHref="#prefix__b"
      />
    </g>
    <g transform="rotate(82 534.2 125) scale(.66825)">
      <use
        width="100%"
        height="100%"
        fill="#fff"
        transform="rotate(-82 668.6 -327.7) scale(45.4)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        fill="#cc142b"
        transform="rotate(-82 668.6 -327.7) scale(30)"
        xlinkHref="#prefix__b"
      />
    </g>
    <g transform="translate(-93 36.1) scale(.66825)">
      <use
        width="100%"
        height="100%"
        fill="#fff"
        transform="matrix(50.4 0 0 50.4 900 480)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        fill="#cc142b"
        transform="matrix(35 0 0 35 900 480)"
        xlinkHref="#prefix__b"
      />
    </g>
    <path
      stroke="#fff"
      strokeWidth={60}
      d="M0 0l600 300M0 300L600 0"
      clipPath="url(#prefix__c)"
      transform="scale(.60681 .73139)"
    />
    <path
      stroke="#cc142b"
      strokeWidth={40}
      d="M0 0l600 300M0 300L600 0"
      clipPath="url(#prefix__d)"
      transform="scale(.60681 .73139)"
    />
    <path
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        blockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal"
      }}
      fill="#fff"
      d="M151.7 0v79.4H0V140h151.7v79.4h60.7v-79.3H364V79.4H212.4V0z"
      clipPath="url(#prefix__c)"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
    />
    <path
      style={{
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        blockProgression: "tb",
        isolation: "auto",
        mixBlendMode: "normal"
      }}
      fill="#cc142b"
      d="M163.8 0v91.5H0v36.4h163.8v91.5h36.4V128h163.9V91.5H200.2V0z"
      color="#000"
      fontFamily="sans-serif"
      fontWeight={400}
      overflow="visible"
    />
  </svg>
	),
	OM: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h640v480H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)">
      <path fill="#ef2d29" fillRule="evenodd" d="M-3.3-21.6H699v553H-3.3z" />
      <path
        fill="#009025"
        fillRule="evenodd"
        d="M174.6 317.3h535.7V525H174.6z"
      />
      <path fill="#fff" fillRule="evenodd" d="M174.6-35.4h564.9v190h-565z" />
      <g stroke="#ef2d28">
        <g
          fill="#fff"
          fillRule="evenodd"
          transform="matrix(.19848 0 0 .17744 111.3 -13.4)"
        >
          <rect
            width={138.2}
            height={85}
            x={17.7}
            y={467.7}
            strokeWidth={1.4}
            rx={11.3}
            ry={11.8}
          />
          <rect
            width={131.1}
            height={78}
            x={21.3}
            y={471.3}
            strokeWidth={1.3}
            rx={10.7}
            ry={10.9}
          />
          <path
            strokeWidth={1.3}
            d="M65 396l9.7.5.4 5.8 8 5.3 6.2-6.7 7.5 5.3-7 5.8 1.7 8 8.8-.5V430l-7-.4-3.6 6.6 8 7.5-6.2 6.2-6.7-6.6-9.7 2.6.5 9.7-10.6 1-1.4-9.4-8.8-4.8-4.9 6.6-7.5-4.9 4.4-7.5-5.3-4.8H34l-.4-13.7 7.5.9 5.3-8-6.2-6.2 8-7 5.7 5.7 9.7-1.8L65 396z"
            transform="matrix(.68108 0 0 .5852 38 260.7)"
          />
          <ellipse
            cx={68.9}
            cy={426.8}
            strokeWidth={1.3}
            rx={11.1}
            ry={9.9}
            transform="matrix(.65819 0 0 .70224 38.8 209.6)"
          />
          <path
            strokeWidth={1.3}
            d="M39 474.8l-10.7 10.6m17.8-10.6l-10.7 10.6m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m17.7-10.6L78 485.4m17.7-10.6L85 485.4m17.8-10.6L92 485.4m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m-17.7-10.6L78 485.4m46-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m0-10.6l10.6 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.7 10.6M85 474.8l10.6 10.6m-17.8-10.6l10.7 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.6 10.6M85 474.8l10.6 10.6m-46-10.6l10.5 10.6m-17.7-10.6l10.7 10.6m-17.8-10.6L46 485.4m-17.8-10.6L39 485.4m0 49.6l-10.6 10.7M46 535l-10.7 10.7M53.2 535l-10.7 10.7M60.2 535l-10.6 10.7M67.3 535l-10.6 10.7M74.4 535l-10.6 10.7M81.5 535L71 545.7M88.6 535L78 545.7M95.7 535L85 545.7m17.7-10.7L92 545.7m18-10.7l-10.7 10.7M117 535l-10.6 10.7M88.6 535L78 545.7m46-10.7l-10.6 10.7m17.7-10.7l-10.6 10.7m17.7-10.7l-10.6 10.7m17.7-10.7l-10.6 10.7m0-10.7l10.6 10.7M127.6 535l10.6 10.7M120.5 535l10.6 10.7M113.4 535l10.6 10.7M106.3 535l10.6 10.7M99.2 535l10.7 10.7M92 535l10.7 10.7M85 535l10.6 10.7M78 535l10.6 10.7M70.9 535l10.6 10.7M63.8 535l10.6 10.7M56.7 535l10.6 10.7M85.1 535l10.6 10.7m-46-10.7l10.5 10.7M42.5 535l10.7 10.7M35.4 535l10.7 10.7M28.4 535L39 545.7"
          />
        </g>
        <g
          fill="#fff"
          fillRule="evenodd"
          transform="matrix(.19848 0 0 .17744 19.1 -14)"
        >
          <rect
            width={138.2}
            height={85}
            x={17.7}
            y={467.7}
            strokeWidth={1.4}
            rx={11.3}
            ry={11.8}
          />
          <rect
            width={131.1}
            height={78}
            x={21.3}
            y={471.3}
            strokeWidth={1.3}
            rx={10.7}
            ry={10.9}
          />
          <path
            strokeWidth={1.3}
            d="M65 396l9.7.5.4 5.8 8 5.3 6.2-6.7 7.5 5.3-7 5.8 1.7 8 8.8-.5V430l-7-.4-3.6 6.6 8 7.5-6.2 6.2-6.7-6.6-9.7 2.6.5 9.7-10.6 1-1.4-9.4-8.8-4.8-4.9 6.6-7.5-4.9 4.4-7.5-5.3-4.8H34l-.4-13.7 7.5.9 5.3-8-6.2-6.2 8-7 5.7 5.7 9.7-1.8L65 396z"
            transform="matrix(.68108 0 0 .5852 38 260.7)"
          />
          <ellipse
            cx={68.9}
            cy={426.8}
            strokeWidth={1.3}
            rx={11.1}
            ry={9.9}
            transform="matrix(.65819 0 0 .70224 38.8 209.6)"
          />
          <path
            strokeWidth={1.3}
            d="M39 474.8l-10.7 10.6m17.8-10.6l-10.7 10.6m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m17.7-10.6L78 485.4m17.7-10.6L85 485.4m17.8-10.6L92 485.4m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m-17.7-10.6L78 485.4m46-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m17.7-10.6l-10.6 10.6m0-10.6l10.6 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.7 10.6M85 474.8l10.6 10.6m-17.8-10.6l10.7 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.6 10.6m-17.7-10.6l10.6 10.6M85 474.8l10.6 10.6m-46-10.6l10.5 10.6m-17.7-10.6l10.7 10.6m-17.8-10.6L46 485.4m-17.8-10.6L39 485.4m0 49.6l-10.6 10.7M46 535l-10.7 10.7M53.2 535l-10.7 10.7M60.2 535l-10.6 10.7M67.3 535l-10.6 10.7M74.4 535l-10.6 10.7M81.5 535L71 545.7M88.6 535L78 545.7M95.7 535L85 545.7m17.7-10.7L92 545.7m18-10.7l-10.7 10.7M117 535l-10.6 10.7M88.6 535L78 545.7m46-10.7l-10.6 10.7m17.7-10.7l-10.6 10.7m17.7-10.7l-10.6 10.7m17.7-10.7l-10.6 10.7m0-10.7l10.6 10.7M127.6 535l10.6 10.7M120.5 535l10.6 10.7M113.4 535l10.6 10.7M106.3 535l10.6 10.7M99.2 535l10.7 10.7M92 535l10.7 10.7M85 535l10.6 10.7M78 535l10.6 10.7M70.9 535l10.6 10.7M63.8 535l10.6 10.7M56.7 535l10.6 10.7M85.1 535l10.6 10.7m-46-10.7l10.5 10.7M42.5 535l10.7 10.7M35.4 535l10.7 10.7M28.4 535L39 545.7"
          />
        </g>
        <path
          fill="#fff"
          fillRule="evenodd"
          strokeWidth={1.3}
          d="M538.6 531.5c1.7 166.6 24.8 202 3.5 202s-31.9-92.1-31.9-205.5 14.2-205.5 35.5-205.5-9 31.9-7.1 209z"
          transform="matrix(-.32136 -.12684 -.20158 .20221 345.9 61.4)"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          strokeWidth={1.2}
          d="M545.7 779.5l-60.3 17.7c56.7 60.3 120.5 85 138.2 74.4 17.7-10.6-31.9-35.4-78-92z"
          transform="matrix(-.19848 0 0 .17744 145.3 -13.4)"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          strokeWidth={1.3}
          d="M547.3 786.9l-51 14.7c56.7 60.3 112.8 77.4 127.3 70 14.6-7.3-30.3-28-76.3-84.7z"
          transform="matrix(-.19334 0 0 .17062 142.8 -8.1)"
        />
        <path
          fill="none"
          strokeWidth={1.8}
          d="M353.1 634.2c.2 1.3.8 7.1 1.3 9.4 0 3.2.3 5.6.6 8.1.8 2.2.7 4.2 3.1 5a9.9 9.9 0 0 0 5 4.4 27.7 27.7 0 0 0 6.3 3.8 11.6 11.6 0 0 0 7.5.6c2.2-1.5 3.8-3.1 5.6-4.4.4-2 .8-4.9 1.3-6.9a32.6 32.6 0 0 0-1.3 8.2c.2 3 1.3 4.4 2.5 6.8"
          transform="matrix(-.13978 0 0 .12414 123 20.4)"
        />
        <path
          fill="none"
          strokeWidth={1.8}
          d="M389.4 681.7l.6-.6c-1.5 1.5-.9.8 2.5-1.3 2.4-1.2 5-1.8 8.1-2.4h8.8c3.4 0 5.7.5 8.1 1.2 1.8 1.8 4.4 2.8 6.3 4.4a11 11 0 0 1 3.7 5c1.7 1.7 2.8 4.3 4.4 5.6.7 2.9 2.1 2.8 3.1 5-3 .2-5.3.6-6.9 2.5-2.6 1.3 2.2-1.3 3.2-2.5 2-.6 2.5-1.2 5.6-1.2 2.8-1 4.6.7 7.5 1.2 1.7 1 2.2 1.3 4.4 1.3"
          transform="matrix(-.13978 0 0 .12414 124.9 19.7)"
        />
        <path
          fill="none"
          strokeWidth={1.8}
          d="M438.1 724.9c1.3 0 7.1 1.1 9.4 0 2.6-.7 4-2 5.6-4.4.8-1.7 0 3 0 5 .3 3.7 1.4 3.7 3.2 6.2 1.8 1.2 3.7 2.8 5.6 3.8a18 18 0 0 0 5.6 3.1c2 1 4.1 1.8 5.6 3.1 2.1 1.5 2 3.3 3.2 5.7-.3 3-.8 4.8-2.5 6.2-.8 2.1-2.4 4.2-3.8 5.6-1.5 3-3.3 4.3.6 5 2.2 1 3.4.2 5.7 0"
          transform="matrix(-.13978 0 0 .12414 127 18.2)"
        />
        <path
          fill="none"
          strokeWidth={1.8}
          d="M480.6 771.7c1.6-.4 7-2.2 9.4-3.1h8.8c3.3.3 4 1.3 6.8 2.5 1.9 1.9 3.1 3.2 5.7 4.4 1.3 1.7 4 4.7 5 6.9a25.5 25.5 0 0 1 1.2 8c0 3.7-1 4.4-1.2 7.6a19.3 19.3 0 0 1-3.8 7.5c-.3.8-.5 1-1.2 1.2"
          transform="matrix(-.13978 0 0 .12414 127.4 17.8)"
        />
        <path
          fill="none"
          strokeWidth={2.3}
          d="M538.1 818c.4 0 1.2 2 2.5 3.7 2.9 3 3.2 3.2 7.5 3.2 4-.2 3.5-1.6 6.3-2.5 1.3-2 2.9-3.6 4.4-6.3 1-1.6 1.9-4.1 3-5.6 1.2-1.9 2.6-3.3 3.8-5 1.2-.5 1.6-1 3.2-1.3-3.6.6-4 1.9-6.3 3.8a58.9 58.9 0 0 0-3.1 5.6c-.4 2.7-1.2 4.8-1.3 8.1 0 3.5 0 5.9 1.3 8.8 1.5 1.5 2.5 3.1 4.4 4.4a36.7 36.7 0 0 1 4.3 5l5.7 3.7c1.8 1.1 3.9 2.2 6.8 2.5 3.7-.3 4.8-1.3 7.5-2.5 2.4-1.7 4.2-2.8 6.3-4.4a21 21 0 0 0 4.4-5c3.3-.8 5.5-.5 7.5 1.3a16.5 16.5 0 0 1 4.3 4.4c1 .5 2.8 2 3.8 2.5"
          transform="matrix(-.09924 0 0 .09799 109.5 38.8)"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M503.8 836.1c-.8.3-3.8 2.4-5 3.1-.8 2.7-2.1 4.1-2.5 7-.7 2.6-.7 5.6-.7 8.7.7 3.2 2 5.5 3.2 8 2 1.4 3 2.4 5.6 3.8 2.5.4 5 .7 8.1.7 2 .6 5.6.9 7.5 0 2.8-.4 4.9-1.5 6.9-2.5 2.3-1.3 3.7-2.6 6.2-3.8 1.3-1.8 3.2-3.5 5-5.6 1.6-2.1 2.7-3.3 3.8-5.6-1 2.6-2.3 5-3.1 7.5-1.5 2.6-2.3 3.6-2.5 6.8-1 2.6-.7 5.8-.7 8.8.3 2 .4 5.8 1.3 7.5v1.9"
          transform="matrix(-.12338 0 0 .12229 111.4 19.3)"
        />
        <path
          fill="none"
          strokeWidth={1.2}
          d="M541.3 799.2v.7c0-1.7 0-.9-.7 2.5-1.1 1.4-4 1.8-6.2 1.2-2-1.7-2-3-5.6-3.7-3.6.2-5 1.2-7 2.5a9.5 9.5 0 0 0-5 4.3c-.7 2.1-1.1 3.6 1.3 4.4a15.2 15.2 0 0 0 7 2.5c2.8 0 4.9-.3 6.2 1.3 2 2 1.8 3.2 1.8 6.8.7 1.1.8 4.4 1.3 5.7a10.6 10.6 0 0 0 5.6 1.2c.7-2 1.4-5.4 1.9-7.5.5-2.2.6-5.4 1.9-6.9a16.6 16.6 0 0 1 4.3-4.4 8 8 0 0 1 3.8-2.4c-2.5 1.2-2.8 2.6-3.1 5.6 2.1 1 2.7 1.8 6.2 1.9 3.5-.3 4.3-1.2 5.6-3.2.3 3.2 1.3 4.2 2 7 1.2 1.8 1.7 3.7 3 6.2-.5 3-1.7 3.1-1.8 6.8-.8 2.5-.8 4.8-2.5 6.3-.8 1-1.4 1.1-3.2 1.2 3.6 0 5.8-.4 8.2-1.8 1.8-1.2 3.2-2.6 5-3.8a23.9 23.9 0 0 1 7.5-3.8c2.9 0 5-.3 6.2 1.3 1.8 1.3 3 3.5 3.8 6.3.5 3.2.8 5.4-.7 7.5-1 2.4-1.3 3.3 0 6.2 1.5 2 3.6 2.3 7 3.1 2.3-.1 4.6-.6 6.2-1.2"
          transform="matrix(-.19848 0 0 .17744 145.3 -13.4)"
        />
        <g
          fillRule="evenodd"
          strokeWidth={1.3}
          transform="matrix(-.19848 0 0 .17744 145.3 -13.4)"
        >
          <path
            fill="#fff"
            d="M531.5 359.6c0-165.2 8-299.4 17.7-299.4 9.8 0 17.7 134.2 17.7 299.4h-35.4z"
            transform="matrix(1.4216 -.73423 .46161 .89375 -716.8 541)"
          />
          <path
            fill="#fff"
            d="M531.5 359.6c0-165.2 8-299.4 17.7-299.4 9.8 0 17.7 134.2 17.7 299.4"
            transform="matrix(1.1373 -.58739 .44532 .86221 -554.8 471.8)"
          />
          <path
            fill="#fff"
            d="M563.4 301.2c.2 18.9 0 40.2 0 60.2H535c0-20-.2-41.3 0-60.2h28.4z"
            transform="matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
          />
          <path
            fill="#fff"
            d="M559.8 304.7c.2 19 0 33.1 0 53.2h-21.2c0-20-.2-34.3 0-53.2h21.2z"
            transform="matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
          />
          <path
            fill="#fff"
            d="M542.1 311.8h14.2v39h-14.2zm0 0l14.2 39m-14.2 0l14.2-39m-14.2-198.4h14.2"
            transform="matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
          />
          <ellipse
            cx={545.7}
            cy={92.1}
            fill="#ef0000"
            rx={3.5}
            ry={3.5}
            transform="matrix(1.6046 .45375 -.36215 1.5787 -734.9 -170.8)"
          />
        </g>
        <path
          fill="#fff"
          fillRule="evenodd"
          strokeWidth={1.3}
          d="M538.6 531.5c1.7 166.6 24.8 202 3.5 202s-31.9-92.1-31.9-205.5 14.2-205.5 35.5-205.5-9 31.9-7.1 209z"
          transform="matrix(.32136 -.12684 .20158 .20221 -181.5 60.8)"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          strokeWidth={1.2}
          d="M545.7 779.5l-60.3 17.7c56.7 60.3 120.5 85 138.2 74.4 17.7-10.6-31.9-35.4-78-92z"
          transform="matrix(.19848 0 0 .17744 19.1 -14)"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          strokeWidth={1.3}
          d="M547.3 786.9l-51 14.7c56.7 60.3 112.8 77.4 127.3 70 14.6-7.3-30.3-28-76.3-84.7z"
          transform="matrix(.19334 0 0 .17062 21.6 -8.8)"
        />
        <path
          fill="none"
          strokeWidth={1.8}
          d="M353.1 634.2c.2 1.3.8 7.1 1.3 9.4 0 3.2.3 5.6.6 8.1.8 2.2.7 4.2 3.1 5a9.9 9.9 0 0 0 5 4.4 27.7 27.7 0 0 0 6.3 3.8 11.6 11.6 0 0 0 7.5.6c2.2-1.5 3.8-3.1 5.6-4.4.4-2 .8-4.9 1.3-6.9a32.6 32.6 0 0 0-1.3 8.2c.2 3 1.3 4.4 2.5 6.8"
          transform="matrix(.13978 0 0 .12414 41.4 19.7)"
        />
        <path
          fill="none"
          strokeWidth={1.8}
          d="M389.4 681.7l.6-.6c-1.5 1.5-.9.8 2.5-1.3 2.4-1.2 5-1.8 8.1-2.4h8.8c3.4 0 5.7.5 8.1 1.2 1.8 1.8 4.4 2.8 6.3 4.4a11 11 0 0 1 3.7 5c1.7 1.7 2.8 4.3 4.4 5.6.7 2.9 2.1 2.8 3.1 5-3 .2-5.3.6-6.9 2.5-2.6 1.3 2.2-1.3 3.2-2.5 2-.6 2.5-1.2 5.6-1.2 2.8-1 4.6.7 7.5 1.2 1.7 1 2.2 1.3 4.4 1.3"
          transform="matrix(.13978 0 0 .12414 39.5 19)"
        />
        <path
          fill="none"
          strokeWidth={1.8}
          d="M438.1 724.9c1.3 0 7.1 1.1 9.4 0 2.6-.7 4-2 5.6-4.4.8-1.7 0 3 0 5 .3 3.7 1.4 3.7 3.2 6.2 1.8 1.2 3.7 2.8 5.6 3.8a18 18 0 0 0 5.6 3.1c2 1 4.1 1.8 5.6 3.1 2.1 1.5 2 3.3 3.2 5.7-.3 3-.8 4.8-2.5 6.2-.8 2.1-2.4 4.2-3.8 5.6-1.5 3-3.3 4.3.6 5 2.2 1 3.4.2 5.7 0"
          transform="matrix(.13978 0 0 .12414 37.4 17.6)"
        />
        <path
          fill="none"
          strokeWidth={1.8}
          d="M480.6 771.7c1.6-.4 7-2.2 9.4-3.1h8.8c3.3.3 4 1.3 6.8 2.5 1.9 1.9 3.1 3.2 5.7 4.4 1.3 1.7 4 4.7 5 6.9a25.5 25.5 0 0 1 1.2 8c0 3.7-1 4.4-1.2 7.6a19.3 19.3 0 0 1-3.8 7.5c-.3.8-.5 1-1.2 1.2"
          transform="matrix(.13978 0 0 .12414 37 17.2)"
        />
        <path
          fill="none"
          strokeWidth={2.3}
          d="M538.1 818c.4 0 1.2 2 2.5 3.7 2.9 3 3.2 3.2 7.5 3.2 4-.2 3.5-1.6 6.3-2.5 1.3-2 2.9-3.6 4.4-6.3 1-1.6 1.9-4.1 3-5.6 1.2-1.9 2.6-3.3 3.8-5 1.2-.5 1.6-1 3.2-1.3-3.6.6-4 1.9-6.3 3.8a58.9 58.9 0 0 0-3.1 5.6c-.4 2.7-1.2 4.8-1.3 8.1 0 3.5 0 5.9 1.3 8.8 1.5 1.5 2.5 3.1 4.4 4.4a36.7 36.7 0 0 1 4.3 5l5.7 3.7c1.8 1.1 3.9 2.2 6.8 2.5 3.7-.3 4.8-1.3 7.5-2.5 2.4-1.7 4.2-2.8 6.3-4.4a21 21 0 0 0 4.4-5c3.3-.8 5.5-.5 7.5 1.3a16.5 16.5 0 0 1 4.3 4.4c1 .5 2.8 2 3.8 2.5"
          transform="matrix(.09924 0 0 .09799 55 38.2)"
        />
        <path
          fill="none"
          strokeWidth={1.9}
          d="M503.8 836.1c-.8.3-3.8 2.4-5 3.1-.8 2.7-2.1 4.1-2.5 7-.7 2.6-.7 5.6-.7 8.7.7 3.2 2 5.5 3.2 8 2 1.4 3 2.4 5.6 3.8 2.5.4 5 .7 8.1.7 2 .6 5.6.9 7.5 0 2.8-.4 4.9-1.5 6.9-2.5 2.3-1.3 3.7-2.6 6.2-3.8 1.3-1.8 3.2-3.5 5-5.6 1.6-2.1 2.7-3.3 3.8-5.6-1 2.6-2.3 5-3.1 7.5-1.5 2.6-2.3 3.6-2.5 6.8-1 2.6-.7 5.8-.7 8.8.3 2 .4 5.8 1.3 7.5v1.9"
          transform="matrix(.12338 0 0 .12229 53 18.6)"
        />
        <path
          fill="none"
          strokeWidth={1.2}
          d="M541.3 799.2v.7c0-1.7 0-.9-.7 2.5-1.1 1.4-4 1.8-6.2 1.2-2-1.7-2-3-5.6-3.7-3.6.2-5 1.2-7 2.5a9.5 9.5 0 0 0-5 4.3c-.7 2.1-1.1 3.6 1.3 4.4a15.2 15.2 0 0 0 7 2.5c2.8 0 4.9-.3 6.2 1.3 2 2 1.8 3.2 1.8 6.8.7 1.1.8 4.4 1.3 5.7a10.6 10.6 0 0 0 5.6 1.2c.7-2 1.4-5.4 1.9-7.5.5-2.2.6-5.4 1.9-6.9a16.6 16.6 0 0 1 4.3-4.4 8 8 0 0 1 3.8-2.4c-2.5 1.2-2.8 2.6-3.1 5.6 2.1 1 2.7 1.8 6.2 1.9 3.5-.3 4.3-1.2 5.6-3.2.3 3.2 1.3 4.2 2 7 1.2 1.8 1.7 3.7 3 6.2-.5 3-1.7 3.1-1.8 6.8-.8 2.5-.8 4.8-2.5 6.3-.8 1-1.4 1.1-3.2 1.2 3.6 0 5.8-.4 8.2-1.8 1.8-1.2 3.2-2.6 5-3.8a23.9 23.9 0 0 1 7.5-3.8c2.9 0 5-.3 6.2 1.3 1.8 1.3 3 3.5 3.8 6.3.5 3.2.8 5.4-.7 7.5-1 2.4-1.3 3.3 0 6.2 1.5 2 3.6 2.3 7 3.1 2.3-.1 4.6-.6 6.2-1.2"
          transform="matrix(.19848 0 0 .17744 19.1 -14)"
        />
        <g
          fillRule="evenodd"
          strokeWidth={1.3}
          transform="matrix(.19848 0 0 .17744 19.1 -14)"
        >
          <path
            fill="#fff"
            d="M531.5 359.6c0-165.2 8-299.4 17.7-299.4 9.8 0 17.7 134.2 17.7 299.4h-35.4z"
            transform="matrix(1.4216 -.73423 .46161 .89375 -716.8 541)"
          />
          <path
            fill="#fff"
            d="M531.5 359.6c0-165.2 8-299.4 17.7-299.4 9.8 0 17.7 134.2 17.7 299.4"
            transform="matrix(1.1373 -.58739 .44532 .86221 -554.8 471.8)"
          />
          <path
            fill="#fff"
            d="M563.4 301.2c.2 18.9 0 40.2 0 60.2H535c0-20-.2-41.3 0-60.2h28.4z"
            transform="matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
          />
          <path
            fill="#fff"
            d="M559.8 304.7c.2 19 0 33.1 0 53.2h-21.2c0-20-.2-34.3 0-53.2h21.2z"
            transform="matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
          />
          <path
            fill="#fff"
            d="M542.1 311.8h14.2v39h-14.2zm0 0l14.2 39m-14.2 0l14.2-39m-14.2-198.4h14.2"
            transform="matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
          />
          <ellipse
            cx={545.7}
            cy={92.1}
            fill="#ef0000"
            rx={3.5}
            ry={3.5}
            transform="matrix(1.6046 .45375 -.36215 1.5787 -734.9 -170.8)"
          />
        </g>
        <g
          fill="#fff"
          fillRule="evenodd"
          transform="matrix(.19848 0 0 .17744 19.1 -14)"
        >
          <path
            strokeWidth={1.3}
            d="M305.6 396.9c0 124 .5 170.7-5.6 177.1-5.8 6.9-167.1 0-167.1 35.4s132.8 71 172.7 71c53.2 0 79.7-35.5 79.7-106.4V397h-79.7z"
            transform="matrix(1.3333 0 0 1 -141.7 0)"
          />
          <path
            strokeWidth={1.3}
            d="M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z"
            transform="matrix(1 0 0 .99999 0 35.4)"
          />
          <path
            strokeWidth={1.3}
            d="M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z"
            transform="scale(1 .99999)"
          />
          <path
            strokeWidth={1.3}
            d="M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z"
            transform="matrix(1 0 0 .99999 0 17.7)"
          />
          <path
            strokeWidth={1.3}
            d="M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z"
            transform="matrix(1 0 0 .99999 0 53.1)"
          />
          <ellipse
            cx={256.9}
            cy={210.8}
            strokeWidth={4.4}
            rx={8.9}
            ry={26.6}
            transform="matrix(.54545 0 0 .14383 130.5 394.3)"
          />
          <ellipse
            cx={292.3}
            cy={246.3}
            strokeWidth={4.4}
            rx={8.9}
            ry={26.6}
            transform="matrix(.54545 0 0 .14383 130.5 391.1)"
          />
          <ellipse
            cx={327.8}
            cy={264}
            strokeWidth={4.4}
            rx={8.9}
            ry={26.6}
            transform="matrix(.54545 0 0 .14383 130.5 390.5)"
          />
          <ellipse
            cx={363.2}
            cy={264}
            strokeWidth={4.4}
            rx={8.9}
            ry={26.6}
            transform="matrix(.54545 0 0 .14383 130.5 390.5)"
          />
          <ellipse
            cx={398.6}
            cy={246.3}
            strokeWidth={4.4}
            rx={8.9}
            ry={26.6}
            transform="matrix(.54545 0 0 .14383 130.5 391.1)"
          />
          <ellipse
            cx={434.1}
            cy={210.8}
            strokeWidth={4.4}
            rx={8.9}
            ry={26.6}
            transform="matrix(.54545 0 0 .14383 130.5 394.3)"
          />
          <path
            strokeWidth={1.3}
            d="M265.8 485.4L372 581.1m-95.6-95.7l95.7 85M290.5 489l81.6 70.9m-71-71l71 60.3M311.8 489l60.2 49.6M322.4 489l49.6 39m-39-39l39 28.3M343.8 489l28.4 21.2M354.3 489l17.8 14.2M365 489l7 7m-106.2 0L372 591.8m0-106.3L255 591.7m106.3-106.3l-102.7 92.2m88.6-88.6l-81.5 70.8m70.8-70.8l-70.8 60.2M326 489l-60.2 49.6m49.6-49.6l-49.6 39m39-39l-39 28.3M294 489l-28.3 21.2m17.7-21.2l-17.7 14.2m7-14.2l-7 7m106.3 0L255 602.5m117-95.7L255 613m117-95.7L255 623.6m117-95.7L255 634.4m117-95.7L255 644.9m117-95.7L255 655.5m117-95.7L255 666.1m117-95.6L255 676.8m117-95.7l-109.9 99.2M372 591.7l-99.2 88.6m95.6-74.4l-78 70.9M365 620l-63.8 56.7m56.7-39l-32 28.3m-60.1-159.4l102.7 92.1m-102.7-81.5l102.7 92.2M265.8 528l99.2 88.5m-99.2-78l99.2 88.7m-99.2-78l95.6 85m-99.2-77.9l95.7 85M262.2 567l88.6 78m-92.1-71l88.6 78M255 581l85 74.4m-85-63.8l81.5 70.9M255 602.3l71 63.7"
          />
          <path
            strokeWidth={1.3}
            d="M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z"
            transform="matrix(1 0 0 .99999 0 70.9)"
          />
          <path
            strokeWidth={1.3}
            d="M255.1 613l63.8 56.7m-63.8-46l56.7 49.5m-56.7-39l49.6 42.6m-49.6-32l35.5 32M255 655.5l28.4 24.8M255 666.1l17.7 14.2"
          />
          <ellipse
            cx={256.9}
            cy={210.8}
            strokeWidth={4.4}
            rx={8.9}
            ry={26.6}
            transform="matrix(.54545 0 0 .14383 130.5 447.5)"
          />
          <ellipse
            cx={292.3}
            cy={246.3}
            strokeWidth={4.4}
            rx={8.9}
            ry={26.6}
            transform="matrix(.54545 0 0 .14383 130.5 444.3)"
          />
          <ellipse
            cx={327.8}
            cy={264}
            strokeWidth={4.4}
            rx={8.9}
            ry={26.6}
            transform="matrix(.54545 0 0 .14383 130.5 443.6)"
          />
          <ellipse
            cx={363.2}
            cy={264}
            strokeWidth={4.4}
            rx={8.9}
            ry={26.6}
            transform="matrix(.54545 0 0 .14383 130.5 443.6)"
          />
          <ellipse
            cx={398.6}
            cy={246.3}
            strokeWidth={4.4}
            rx={8.9}
            ry={26.6}
            transform="matrix(.54545 0 0 .14383 130.5 444.3)"
          />
          <ellipse
            cx={434.1}
            cy={210.8}
            strokeWidth={4.4}
            rx={8.9}
            ry={26.6}
            transform="matrix(.54545 0 0 .14383 130.5 447.5)"
          />
          <path
            strokeWidth={1.3}
            d="M113.4 652l127.5-74.4m-134.6 70.8l120.5-70.8m-124 63.7l109.8-63.7M99.2 634.3l95.7-56.7M92 627.2l88.6-49.6m-85 39l60.2-35.5M92 609.4l46-28.3m-46 17.7l32-17.7m0 74.4l120.4-70.9M134.7 659L248 591.7m-102.7 70.9l106.3-63.8m-95.7 67.3l88.6-53.1M170 666.1l78-46m-67.4 49.6l67.3-39m-56.7 42.5l53.2-31.9m-39 32l42.5-24.9m-28.3 28.4L248 659m-14 17.8l17.7-10.6"
          />
          <path
            strokeWidth={1.3}
            d="M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z"
            transform="matrix(0 1 -.99999 0 655.5 308.3)"
          />
          <path
            strokeWidth={1.3}
            d="M49.6 623.6l42.5-35.4m-42.5 10.6l42.5 42.5"
          />
          <path
            strokeWidth={1.3}
            d="M260.1 388l5.6 26.6c35.5 5.9 65.3 5.9 100.8 0l11.1-26.6c-35.4 5.9-82 5.9-117.5 0z"
            transform="matrix(0 .63333 -.8 0 423.8 416.3)"
          />
          <path
            strokeWidth={1.3}
            d="M258.7 350.8v-17.9c-10.7.2-17.8-10.5-17.8-21.2l-35.4.1c0 10.6-7 21.3-17.7 21.3v17.7h70.9z"
            transform="matrix(1.4983 0 0 1 -15.6 53.1)"
          />
          <path
            strokeWidth={1.4}
            d="M296 343.7h45.6V365H296zm3.9-21.3h37.9v21.3h-38zm0-21.2h37.9v21.2h-38zm3.8-28.4H334v28.4h-30.3zm-1.3-24.8h33v24.8h-33z"
          />
          <ellipse
            cx={237.4}
            cy={161.2}
            strokeWidth={1.3}
            rx={42.5}
            ry={33.7}
            transform="matrix(1.0333 0 0 1 75.3 63.8)"
          />
          <path
            strokeWidth={1.3}
            d="M258.7 159.4c0 9.3 10.6 24.8 10.6 24.8-7.7 6.2-20.2 10.7-31.9 10.7s-26.3-2.6-31.9-10.7c0 0 10.6-15.4 10.6-24.7s-10.6-21.3-10.6-21.3a54.6 54.6 0 0 1 32-10.6c11.6 0 24 4.5 31.8 10.6 0 0-10.6 12-10.6 21.3z"
            transform="matrix(1.0333 0 0 1 75.3 63.8)"
          />
          <path
            strokeWidth={1.3}
            d="M251.6 159.4c0 9.3 10.6 28.4 10.6 28.4-7.7 6-13 7-24.8 7s-19.2 1.1-24.8-7c0 0 10.6-19 10.6-28.4s-10.6-24.8-10.6-24.8c7.7-6 13-7 24.8-7 11.7 0 17.1 1 24.8 7 0 0-10.6 15.5-10.6 24.8z"
            transform="matrix(1.0333 0 0 1 75.3 63.8)"
          />
          <ellipse
            cx={194.9}
            cy={166.5}
            strokeWidth={1.3}
            rx={10.6}
            ry={10.6}
            transform="matrix(1.0333 0 0 1 75.3 60.2)"
          />
          <ellipse
            cx={194.9}
            cy={166.5}
            strokeWidth={1.3}
            rx={10.6}
            ry={10.6}
            transform="matrix(1.0333 0 0 1 163.2 60.2)"
          />
          <ellipse
            cx={194.9}
            cy={166.5}
            strokeWidth={1.3}
            rx={10.6}
            ry={10.6}
            transform="matrix(1.0333 0 0 1 119.3 60.2)"
          />
          <ellipse
            cx={194.9}
            cy={166.5}
            strokeWidth={1.3}
            rx={10.6}
            ry={10.6}
            transform="matrix(1.0333 0 0 1 119.3 24.8)"
          />
          <ellipse
            cx={194.9}
            cy={166.5}
            strokeWidth={1.3}
            rx={10.6}
            ry={10.6}
            transform="matrix(1.0702 0 0 1 80 226.8)"
          />
          <ellipse
            cx={194.9}
            cy={166.5}
            strokeWidth={1.3}
            rx={10.6}
            ry={10.6}
            transform="matrix(1.0702 0 0 1 140.6 226.8)"
          />
          <path
            strokeWidth={1.3}
            d="M212.6 311.8h49.6l-24.8 31.9-24.8-31.9z"
            transform="matrix(1.0702 0 0 1 64.8 53.1)"
          />
          <ellipse
            cx={194.9}
            cy={166.5}
            strokeWidth={1.3}
            rx={10.6}
            ry={10.6}
            transform="matrix(1.427 0 0 1.3333 40.7 167.7)"
          />
        </g>
        <g
          fill="#fff"
          fillRule="evenodd"
          transform="matrix(.19848 0 0 .17744 18.8 -19.1)"
        >
          <rect
            width={81.5}
            height={21.3}
            x={262.2}
            y={524.4}
            strokeWidth={1.2}
            rx={4.3}
            ry={3.7}
          />
          <path
            strokeWidth={1.2}
            d="M368.5 506.7c-9.8 0-17.7 8.3-17.7 18.5v16.1a18 18 0 0 0 17.7 18.5 18 18 0 0 0 17.7-18.5v-16a18 18 0 0 0-17.7-18.6zm0 7c-5.9 0-10.6 6.7-10.6 14.9v9.3c0 8.2 4.7 14.8 10.6 14.8 5.9 0 10.6-6.6 10.6-14.8v-9.3c0-8.2-4.7-14.8-10.6-14.8zm-92.1-3.5c-6 0-10.6 6.6-10.6 14.9v16.4c0 8.2 4.7 14.8 10.6 14.8 5.9 0 10.6-6.6 10.6-14.8V525c0-8.3-4.7-14.9-10.6-14.9zm0-7a18 18 0 0 0-17.7 18.5v23.2a18 18 0 0 0 17.7 18.5c9.8 0 17.7-8.3 17.7-18.5v-23.2a18 18 0 0 0-17.7-18.6z"
          />
          <path
            strokeWidth={1.2}
            d="M248 517.3c-5.9 0-10.6 6.6-10.6 14.8v3.9c0 8.2 4.7 14.8 10.6 14.8 6 0 10.7-6.6 10.7-14.8v-3.9c0-8.2-4.8-14.8-10.7-14.8zm0-7a18 18 0 0 0-17.7 18.5v10.6a18 18 0 0 0 17.7 18.5c9.8 0 17.8-8.3 17.8-18.5v-10.6a18 18 0 0 0-17.8-18.6z"
          />
          <path
            strokeWidth={0.9}
            d="M478.4 237.4c-6 0-10.7 6.6-10.7 14.8v16.5c0 8.1 4.8 14.8 10.7 14.8 5.8 0 10.6-6.6 10.6-14.9v-16.4c0-8.2-4.8-14.8-10.6-14.8zm0-7a18 18 0 0 0-17.8 18.4V272a18 18 0 0 0 17.7 18.6c9.9 0 17.8-8.3 17.8-18.6v-23.2a18 18 0 0 0-17.7-18.5z"
            transform="matrix(1.8 0 0 1.1176 -655.5 242.2)"
          />
          <path
            strokeWidth={0.9}
            d="M478.4 237.4c-6 0-10.7 6.6-10.7 14.8v16.5c0 8.1 4.8 14.8 10.7 14.8 5.8 0 10.6-6.6 10.6-14.9v-16.4c0-8.2-4.8-14.8-10.6-14.8zm0-7a18 18 0 0 0-17.8 18.4V272a18 18 0 0 0 17.7 18.6c9.9 0 17.8-8.3 17.8-18.6v-23.2a18 18 0 0 0-17.7-18.5z"
            transform="matrix(1.8 0 0 1.1176 -425.2 245.7)"
          />
          <rect
            width={42.5}
            height={21.3}
            x={375.6}
            y={524.4}
            strokeWidth={1.2}
            rx={2.3}
            ry={3.7}
          />
          <rect
            width={24.8}
            height={28.4}
            x={336.6}
            y={520.9}
            strokeWidth={1.2}
            rx={1.3}
            ry={4.9}
          />
          <rect
            width={24.8}
            height={28.4}
            x={219.7}
            y={520.9}
            strokeWidth={1.2}
            rx={1.3}
            ry={4.9}
          />
          <rect
            width={49.6}
            height={35.4}
            x={141.7}
            y={517.3}
            strokeWidth={1.2}
            rx={2.6}
            ry={6.1}
          />
          <rect
            width={46.1}
            height={35.4}
            x={450}
            y={520.9}
            strokeWidth={1.2}
            rx={2.5}
            ry={6.1}
          />
        </g>
      </g>
    </g>
  </svg>
	),
	PA: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h640v480H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#fff" fillRule="evenodd" d="M92.5 0h477.2v480H92.4z" />
      <path fill="#db0000" fillRule="evenodd" d="M323 3.6h358v221.7H323z" />
      <path
        fill="#0000ab"
        fillRule="evenodd"
        d="M3.2 225.3h319.9V480H3.2zm211.6-47.6l-42-29.4-41.7 29.6 15.5-48L105 100l51.6-.4 16-48 16.3 47.9h51.6l-41.5 30 15.9 48z"
      />
      <path
        fill="#d80000"
        fillRule="evenodd"
        d="M516.9 413.9l-42.4-27.7-42.1 28 15.6-45.6-42-28 52-.5 16.2-45.4 16.4 45.3h52l-41.8 28.5 16 45.4z"
      />
    </g>
  </svg>
	),
	PE: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#d91023" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M213.3 0h213.4v480H213.3z" />
    <g
      fill="#00a854"
      stroke="#d4af37"
      strokeWidth={2}
      transform="translate(245.3 154) scale(.17778)"
    >
      <g
        id="prefix__g"
        strokeWidth={4.3}
        transform="matrix(.44722 -.20656 .2582 .35777 89.4 -67.3)"
      >
        <path d="M480.2 566.9c31.3 33 62.4 68.1 79 111.2 25.1 69.7 18.3 151.5-22.6 214a328.2 328.2 0 0 1-142 116.4 224.7 224.7 0 0 1-164.8 3.5c-20-7.4-38.9-18-57.5-28.3-8.4-1.4-13.9 8.6-7 13.3 62.4 40.6 130.9 42.2 202 28.2a273.1 273.1 0 0 0 99-50.4c44.4-33.2 82.7-77.5 99.8-131 26.2-79 9.3-171.3-45.1-234.6a488.2 488.2 0 0 0-44.7-47.1l4 4.8z" />
        <path d="M170.6 983.3c-8.1-.8-12.2 11.8-5.1 13.6 4.2-1 10.7-12 5-13.6zm304.2-430.9c-4.5-5.6-14-2.9-17.7-7.3-4-4.7 2.9-6.5-.3-10-3-3.5-7.7-1.7-12-6.5-4.2-4.7-.4-8.8-4-12-3.7-3.4-4.2.8-8.4-3.8s-1.7-12.7-6.3-18.6c-4.5-5.7-3-12.5 2.5-11.2 3.6.8 5 4.4 10.4 5.7 5.4 1.4 7.6-2.5 11.2 1 3.5 3.4.3 9 4 14s5.9 1.2 8.6 5.5c2.7 4.4.5 6.6 2.2 11.7s8.4 3.1 10.9 10.8c2.5 7.6-1 20.7-1 20.7z" />
        <path d="M478.1 564.8c-5.5-26.2-27-57-52.6-79.5 15.3 12 44.9 40.5 54.4 79.3l-1.8.2z" />
        <path d="M460.2 524.4c-4.2-2.9-7.3-2.8-10.5-3.2 3-.2 5.9-.5 9.5 1.1l1 2.1zm-15.2-19c-4.5-1.4-7.4-.3-10.6.4 2.8-1.2 5.5-2.4 9.2-2l1.4 1.7zm4.4 3.5c-2.2-5.6-2.2-9.7-2.5-14-.1 3.9-.3 7.8.9 12.6l1.6 1.4zm13.5 18.1c-2.2-5.5-2.2-9.6-2.5-14-.1 4-.3 7.9 1 12.7l1.5 1.3zm92.3 155c-8.3-3.1-17.2 0-23.9-2.4-7.2-2.6 1.1-8.6-4.4-10.4-5.6-1.8-10.2 5.7-17.8 3.2-7.6-2.4-6.3-10-12.5-11.4-6.3-1.3-6.4 7.2-13.9 4.9-7.4-2.3-7.5-12.3-16-15.7-8.2-3.4-9-11.4-1.3-13.4 5.2-1.3 10.3 2 18 .2s7-8.7 13.1-7.1c6.1 1.5 4.4 10.4 11.4 13.2 7 2.8 11.4-4.9 16.7-2 5.3 3 .3 9.5 4.6 13.7 4.4 4.3 7.8-2.3 14.2 4.2 6.4 6.6 11.8 23 11.8 23z" />
        <path d="M563.5 691.6c-22.9-25.6-58.6-41.4-101.8-49.7 25 3.4 76.7 15 105.2 50l-3.4-.3z" />
        <path d="M524.3 661.5c-6.7-.6-10.8 1.3-15.2 2.8 3.8-2 7.5-4 13-4.4l2.2 1.6zm-27.9-10.9c-6.5 1.2-10 4-14 6.7 3.3-2.9 6.4-5.8 11.5-7.7l2.5 1zm7.2 1c-5.2-4.5-7-8.9-9.1-13.3 1.5 4.3 2.8 8.5 6.4 12.8l2.7.5zm25.3 11c-5.1-4.5-6.8-8.9-9-13.3a35 35 0 0 0 6.4 12.8l2.6.5zm25.8 223c7-5.4 9.2-15 14.7-19.4 5.8-4.7 6.2 5.9 10.6 2 4.4-3.7.9-12 6.9-17.2 6-5.2 11.4.2 15.8-4.4 4.3-4.7-2.4-9.7 3.4-14.8 5.8-5.2 13.9.5 21-5 7.1-5.3 14-1.4 11.5 6.4-1.7 5.3-7 7.9-9.7 15.6-2.6 7.8 3.2 11-1.2 15.5-4.5 4.4-10.7-2.2-16.7 2.3s-2 12.7-7.3 15.7c-5.1 3-7.6-5.1-13.4-3.8-5.7 1.4-2.2 8-10.9 10a67.8 67.8 0 0 1-24.7-2.9z" />
        <path d="M542.7 887.4c32.6-5.3 64.3-27.5 93.8-60.3-16 19.9-52.6 58.3-95.8 63.1l2-2.8z" />
        <path d="M587.6 870.5c4-5.6 4.7-10.2 5.8-15-.5 4.5-.8 9-3.3 14l-2.5 1zm23.5-18.1c2.5-6.4 2-11 2-16 .6 4.5 1.4 8.8.1 14.3l-2.1 1.6zm-4.6 5.7c6.4-2 10.8-1 15.5-.4-4.2-1.1-8.3-2.4-13.7-1.7l-1.8 2zm-22.2 15.8c6.3-2 10.7-1 15.4-.4-4.2-1.1-8.3-2.4-13.7-1.6l-1.7 2zm2.2-84c5.9-6.6 6.3-16.4 11-21.8 4.9-5.8 7.1 4.5 10.8 0 3.6-4.6-1.3-12.1 3.6-18.4 5-6.2 11.4-2 14.8-7.4 3.4-5.4-4-9 .7-15.2 4.8-6.2 13.7-2.1 19.9-8.9 6-6.6 13.4-4 12.3 4.2-.7 5.4-5.5 9-6.7 17.1-1.3 8.2 5.1 10.2 1.5 15.5-3.6 5.2-10.9-.1-16 5.5-5 5.6.3 12.9-4.3 16.8-4.6 3.9-8.5-3.6-13.9-1.2-5.4 2.5-.8 8.4-9 12s-24.7 1.8-24.7 1.8z" />
        <path d="M575 794c31.1-11.5 58.3-39.3 81.5-77.3-12.2 22.6-41.4 67.4-83 80.5l1.5-3.2z" />
        <path d="M616.1 768.7c3-6.2 2.8-10.8 3-15.7.4 4.4.9 8.8-.7 14.3l-2.2 1.4zm19.9-22.3c1.3-6.7 0-11.2-.9-16 1.4 4.2 3 8.4 2.7 14l-1.8 2zm-3.5 6.5c6-3.1 10.4-3 15.1-3.3-4.3-.3-8.5-.7-13.7 1l-1.4 2.3zm-19 19.8c5.8-3 10.3-3 15-3.3-4.3-.3-8.5-.7-13.7 1l-1.4 2.3zm-46.2-31.5c-7.9-5.6-18.3-4.8-24.7-9.3-6.9-4.6 3.6-8.6-1.8-12-5.4-3.4-12.4 3-19.8-1.6-7.4-4.7-3.8-12.4-10-15.5-6.3-3-9 5.7-16.2 1.2s-4.5-15-12.5-20.8c-7.9-5.8-6.4-14.4 2.4-14.3 5.8 0 10.4 4.9 19.1 5.2 8.7.2 5-4.4 11-1 6.2 3.2 5 12 11.6 17 6.7 4.8 15.2-4.7 20-.2s-2.4 10 1 15.6 9-.2 14 8.4 5.9 27.3 5.9 27.3z" />
        <path d="M573.4 753.5c-17-33.1-50.6-59.7-94.2-80.4 25.7 10.6 77.4 37 97.8 81.6l-3.6-1.2z" />
        <path d="M540.3 711c-7-2.4-11.9-1.6-17-1.2 4.6-1 9.2-2.1 15-1l2 2.2zm-26.6-19c-7.3-.7-11.8 1.4-16.7 3 4.2-2.1 8.3-4.3 14.3-4.8l2.4 1.7zm7.4 3c-4.3-6.2-4.8-11.3-6-16.4.4 4.8.7 9.6 3.3 15.1l2.7 1.2zm23.8 18.5c-4.2-6.2-4.8-11.2-5.9-16.4.4 4.9.6 9.6 3.3 15.2l2.6 1.2zm43.1 36.9c4.5-7.7 3-17.5 6.5-23.8 3.7-6.7 8 3 10.6-2.3 2.6-5.2-3.6-11.5 0-18.7s10.7-4.3 13-10.3c2.3-6-5.7-8-2.2-15 3.5-7.1 13-5 17.7-13 4.5-7.7 12.3-6.8 12.8 1.5.4 5.5-3.6 10-3.2 18.2.4 8.2 7 9 4.5 14.8-2.5 5.9-10.7 2.2-14.5 8.8-4 6.5 2.7 12.5-1 17.3-3.7 4.8-9-1.7-13.9 1.9-4.8 3.5 1 8.3-6.4 13.5s-23.9 7-23.9 7z" />
        <path d="M577.5 756.8C605.8 739 627 706 642.3 664c-7.6 24.7-27.4 74.7-65.6 96.3l.8-3.4z" />
        <path d="M613 723.3c1.6-6.6.5-11.2-.2-16 1.2 4.3 2.5 8.5 2 14.1l-1.9 2zm15-26c0-6.9-2.1-11-4-15.5 2.3 3.9 4.5 7.6 5.4 13.2l-1.4 2.3zm-2.1 7.1c5.2-4.3 9.6-5.1 14.1-6.5-4.3.7-8.5 1.1-13.2 4l-1 2.5zM611 727.8c5.1-4.3 9.6-5 14-6.4-4.2.6-8.4 1-13.2 3.9l-.8 2.5zM557.4 639c3.6-8.6.8-18.5 3.6-25.6 3-7.5 8.7 2 10.7-3.8 2.1-5.9-5.2-11.5-2.4-19.5s10.6-6 12.2-12.6c1.6-6.6-7-7.5-4.3-15.3 2.7-7.9 13-7.1 16.8-16 3.7-8.6 12-8.8 13.6-.3 1 5.7-2.5 11-1 19.5 1.4 8.4 8.4 8.2 6.6 14.7-1.9 6.5-10.8 3.8-14 11.2-3.2 7.3 4.4 12.6 1.2 18.2-3.2 5.5-9.6-.6-14.1 3.8-4.6 4.4 2 8.5-5 15-7 6.4-24 10.7-24 10.7z" />
        <path d="M547.3 647.1c27-22.6 44.8-59.9 55.3-105.8-4.6 26.8-18.8 81.6-55.7 109.5l.4-3.7z" />
        <path d="M579.8 607.3c.8-7.2-.9-11.7-2.2-16.7 1.8 4.3 3.7 8.5 4 14.4l-1.8 2.3zM592 578c-.9-7.2-3.7-11.1-6.1-15.6 2.7 3.7 5.6 7.3 7.2 13L592 578zm-1.3 7.7c4.8-5.2 9.3-6.7 13.9-8.7-4.4 1.2-8.7 2.3-13.3 5.9l-.6 2.8zm-12.4 26.4c4.8-5.2 9.3-6.7 13.9-8.7-4.4 1.3-8.7 2.4-13.3 6l-.6 2.7z" />
        <path d="M533.4 605.3c4.2-6.6-1-18.7 2.2-24 3.6-5.8 7.3 2.8 9.8-1.7 2.6-4.5-.4-10.3 3-16.4 3.6-6.2 8.6-1.7 10.9-6.9 2.2-5.2-2-5.3 1.3-11.4 3.4-6 12-3.9 16.5-10.6 4.4-6.6 11.5-5.5 11.8 1.9.2 4.8-2.9 7.1-2.7 14.4.1 7.2 4.6 9.5 2.2 14.6-2.5 5-9 1.5-12.6 7.1-3.8 5.6.3 7.8-3.2 11.8-3.5 4-6.4 1.5-10.9 4.4-4.5 3-.7 11.3-7.6 15.6s-20.7 1.2-20.7 1.2z" />
        <path d="M522.1 611.2c24.3-10.6 48.6-42.4 63.7-78.7-7.5 21.4-27.5 63.7-63 81l-.7-2.3z" />
        <path d="M556.9 582.6c1.7-5.8.8-9.8.3-14 1 3.8 2 7.5 1.5 12.5l-1.8 1.5zm14.4-22.2c.2-6-1.6-9.7-3.2-13.8 1.9 3.5 4 6.9 4.6 11.8l-1.4 2zm-2 6.2c4.8-3.6 8.9-4.1 13-5.1-3.9.4-7.8.6-12.2 2.8l-.9 2.3zm-14.2 20c4.8-3.6 8.9-4.2 13-5.2-3.8.4-7.7.6-12.2 2.9l-.8 2.2zm-173.3 425.7c3.6-9 1-19.7 3.7-27.1 2.9-7.9 8.4 2.5 10.4-3.6s-5-12.5-2.2-20.9c2.8-8.4 10.3-5.8 12-12.8 1.5-7-6.8-8.3-4.1-16.5 2.6-8.3 12.5-7 16.3-16.2 3.7-9 11.7-8.8 13.2.4 1 6-2.4 11.5-1 20.6 1.3 9.1 8.1 9.3 6.3 16-1.8 6.9-10.5 3.6-13.7 11.3-3.1 7.6 4.3 13.7 1.1 19.4-3.2 5.7-9.3-1-13.8 3.4-4.4 4.4 2 9.2-4.9 15.7-6.8 6.5-23.3 10.3-23.3 10.3z" />
        <path d="M375.2 1016.4c26.5-22.7 40.7-57.4 51.2-105.9-4.7 28.3-15.5 82-51.6 109.8l.4-3.9z" />
        <path d="M403.8 979.7c.8-7.6-.8-12.6-2-18 1.6 4.8 3.5 9.4 3.6 15.7l-1.6 2.3zm12-30.5c-.7-7.7-3.4-12-5.8-17 2.7 4.2 5.5 8.1 7 14.3l-1.1 2.7zm-1.2 8.1c4.7-5.3 9.1-6.6 13.5-8.6-4.2 1.1-8.5 2-13 5.7l-.5 3zM402.4 985c4.7-5.3 9.1-6.7 13.5-8.6-4.2 1.1-8.4 2-12.9 5.6l-.6 3zm158.7-152.7c-7.2-7.5-19.3-10.1-25.2-16-6.3-6.3 7-6.5 2-11.2-5-4.7-15.2-1.3-22-7.7-7-6.5-.4-12.1-6.5-16.8-6-4.7-12 2.2-18.7-4.1-6.8-6.3-.2-14.6-7.4-22.3-7-7.6-2.6-14.7 7.5-11.8 6.6 1.9 10.2 7.6 20 10.6 10 3 13.7-3 19.5 1.8 5.9 4.8-2 11.2 3.9 17.6 6 6.4 16 2.6 20 8.1 4 5.6-6 8-4 14 2 6.2 10.3 2.7 13.1 11.8 2.9 9.2-2.2 26-2.2 26z" />
        <path d="M540.3 797c-7.2-4.3-13-5.1-19-6.5 5.6.7 11.1 1.1 17.6 4l1.4 2.5zm-24-25.2c-8.2-2.9-14-2.5-20.2-2.6 5.6-.5 11-1.2 18 .3l2.1 2.3zm7.4 5c-2.8-6.8-1.8-11.4-1.4-16.3-1.1 4.4-2.5 8.6-1.3 14.3l2.7 2zm21 23.9c-2.7-6.8-1.7-11.4-1.3-16.3-1.1 4.4-2.5 8.7-1.3 14.4l2.6 1.9z" />
        <path d="M561.7 840c-8.5-34.5-35.7-63.7-78.5-95.8 25.8 17.5 73.7 52.4 82.2 98l-3.7-2.2z" />
        <g id="prefix__d">
          <path d="M527.3 890.5c-3.4-8.8-19.8-13-22.7-20.1-3-7.6 9.1-5.3 6.6-11-2.6-5.7-13.4-4-17-11.8-3.4-7.8 5-12.3 1.3-18.2-3.6-5.9-11.8 0-15.4-7.5-3.5-7.6 6-14.8 2.7-24-3.2-9 4-15.4 11.8-10.6 5.3 3.2 6.2 9.6 13.9 14.4 7.7 4.9 13.7-.6 17 5.4 3.2 6-6.7 11-4 18.5 2.8 7.6 13.6 5.6 15 12 1.2 6.3-9 6.9-9.7 13.4-.7 6.5 8.3 4.5 7 14.3s-6.5 25.2-6.5 25.2z" />
          <path d="M520 853.1c-4.7-5.7-13-9-18-11.4a58 58 0 0 1 17.8 8.5l.2 3zm-10-24.9c.4-7.3 3.2-11.8 5.7-16.7-2.9 4.2-5.9 8.3-7.2 14.3l1.6 2.4zm12.5 26c.3-7.3-.1-9.7 2.3-14.6-2.9 4.2-2.6 6.3-3.9 12.3l1.6 2.4z" />
          <path d="M525.2 906.6c6.8-36.5-12.8-78.4-38.3-118.7 16.1 22.4 52.2 73.9 40.7 121.6l-2.4-2.9z" />
          <path d="M505.4 821.9c-6.2-4.4-11.7-5.1-17.2-6.4 5.2.5 10.5.9 16.2 3.6l1 2.7z" />
        </g>
        <path d="M493.6 566.1c-2-7-11.8-8.6-13.4-14.2-1.8-6 5.2-4.7 3.7-9.2-1.5-4.5-6.4-4.9-8.4-11s3-8.2 1-12.8c-2-4.6-4.2-1-6.2-7s3.4-12.3 1.5-19.6c-1.9-7 2.1-12.6 6.6-9.2 3 2.3 3 6.2 7.4 9.7 4.4 3.6 7.9.9 9.8 5.5 1.8 4.7-3.3 8.5-1.8 14.5 1.6 6 4.9 3.7 5.6 8.8.8 5-2.1 6.2-2.5 11.6-.4 5.3 6.4 6.4 5.7 14.4-.7 8-9 18.5-9 18.5z" />
        <path d="M491.7 578.8c5.2-26.2-2.3-63.4-17-94.8 9.3 17.3 25.2 56 18.7 95.4l-1.7-.6z" />
        <path d="M491.1 534.4c-2.7-4.4-5.5-5.7-8.3-7.5 2.8 1.1 5.5 2 8.2 5.1l.1 2.4zm-6.5-23.8c-3.5-3.2-6.6-3.5-9.8-4.2 3 .1 6 .1 9.3 2l.6 2.2zm2.7 5c.2-6 1.8-9.8 3.2-14-1.6 3.7-3.3 7.1-4.1 12l1 2zm5.3 22.3c.1-6 1.7-9.8 3.1-13.9-1.6 3.6-3.3 7-4 12l.9 1.9zm17 37.3c-.1-6.9-6.8-11.4-7.1-16.9-.3-5.8 14.6-4.3 14.2-8.8-.4-4.4-5.4-4.8-6-10.8s5.4-8 4.4-12.5-4.1-1-4.7-6.9c-.6-5.8 2-12.4 1.8-19.5-.1-7 5.6-12.4 9.4-9 2.6 2.2 1.5 6 5.2 9.5s8.4 1 11.3 4.5c3 3.5 2.3 6.4 2.4 12.3 0 6 4.1 3.6 3.6 8.6-.5 5-3.9 6.1-5.7 11.4-1.8 5.2 5.2 6.2 2.3 14.1-2.8 7.9-31 24-31 24z" />
        <path d="M499.2 585.6c24.4-21.6 36.5-63.2 18.3-94a68.8 68.8 0 0 1 8.1 50.3 92.1 92.1 0 0 1-24.8 44.3l-1.6-.6z" />
        <path d="M522.3 550.8a31.2 31.2 0 0 0-8.7-11.5c2.6 1 7.1 6.2 9.2 9.2l-.5 2.3zm4-26.8c-3-3.2-6.1-3.5-9.2-4.2 3 .1 6.2.1 9.2 2v2.2zm1.1.2c1.8-6 4.4-9.6 7-13.7-2.7 3.5-5.4 7-7.4 11.8l.4 1.9zm-4.2 27.5c1.7-5.9 7.8-3.8 12.4-5.2-3.5 0-10.8-1.5-13 3.3l.6 1.9zm-44.3 24.2c-6.5-4.6-4.6-15.7-9.7-19.5-5.5-4-6.7 3.8-10.8.6-4-3.2-2.7-8.6-8.2-13-5.6-4.4-9.5.2-13.5-3.6-4-3.9.5-4.8-4.9-9.2-5.4-4.3-13.9-.8-20.6-5.5-6.7-4.6-13.8-2.3-11.9 3.8 1.3 4 5.2 5.4 7.3 11.4 2 6-2 8.8 2.1 12.5 4.1 3.7 9.9-.5 15.5 3.4s2 6.5 7 9.2 7.1 0 12.7 1.5c5.7 1.5 4.2 9.2 12.7 11.4 8.5 2.1 22.3-3 22.3-3z" />
        <path d="M492.6 578.5c-28.8-4-64.1-25.6-91.1-52.7 14.5 16.3 48.3 47.3 91 54.8l.1-2z" />
        <path d="M447.2 561.7c-3.5-4.5-3.8-8-4.6-11.6.2 3.3.1 6.7 2.3 10.6l2.3 1zm-22-15.6c-2-5-1.1-8.4-.7-12-1 3.2-2 6.4-1.3 10.7l2 1.4zm4.1 4.7c-6.2-2-10.6-1.6-15.3-1.6 4.2-.5 8.4-1 13.7 0l1.6 1.6zm21 13.8c-6.2-2-10.6-1.7-15.3-1.7 4.2-.4 8.4-1 13.7 0l1.6 1.7zm50.2 41c-8-3.5-6.6-15.4-13-18.4-6.8-3-7.7 5.4-12.7 2.9-5.1-2.6-3.9-8.5-10.8-12-7-3.4-11.3 2.3-16.3-1-5-3.2.3-5-6.5-8.5s-16.5 2-25-1.6c-8.1-3.4-16.4.4-13.7 6.4 1.8 4 6.6 4.5 9.5 10.4 2.9 5.8-1.7 9.6 3.5 12.6s11.7-2.5 18.6.4c7 3 2.9 6.4 9 8.2 6 1.8 8.5-1.5 15.3-1 6.8.4 5.7 8.7 16 9.2 10.2.6 26.1-7.6 26.1-7.6z" />
        <path d="M517 605.6c-34.5 1.6-78.1-13.7-112.2-36.4 18.4 14 61 39.5 112.3 38.5l-.1-2.1z" />
        <path d="M461.8 597.2c-4.5-3.9-5.1-7.5-6.3-11.1.4 3.5.6 7 3.5 10.6l2.8.5zm-27.3-11.7c-2.8-4.8-2-8.5-1.8-12.4-.9 3.6-2 7.1-.6 11.4l2.4 1zm5.3 4c-7.5-.8-12.8.5-18.4 1.4 5-1.3 10-2.7 16.3-2.8l2 1.4zm26 10c-7.6-.8-12.8.5-18.4 1.5 5-1.4 9.9-2.8 16.3-2.8l2 1.4z" />
        <path d="M517.5 629.7c-8.3-3-7.6-15-14.2-17.5-7-2.7-7.3 5.9-12.6 3.7-5.2-2.2-4.3-8.2-11.5-11.2s-11.1 3-16.3 0c-5.2-2.9 0-5-7-8s-16.4 3-25 0c-8.5-3-16.5 1.4-13.4 7.2 2 3.9 7 4.1 10.2 9.7 3.2 5.7-1 9.7 4.3 12.4 5.3 2.7 11.5-3.2 18.6-.8 7.2 2.5 3.3 6.2 9.5 7.6 6.1 1.4 8.4-2 15.2-2 6.8 0 6.3 8.3 16.5 8.2 10.3-.2 25.7-9.3 25.7-9.3z" />
        <path d="M534 628.6c-34.4 3.9-79-8.6-114.4-29 19.3 12.7 63.4 35.4 114.6 31.1l-.3-2z" />
        <path d="M478.3 623.9c-4.8-3.7-5.6-7.2-7-10.8.6 3.5 1 7 4.1 10.4l3 .4zm-28-10c-3-4.6-2.6-8.4-2.7-12.3-.6 3.7-1.4 7.3.2 11.4l2.5 1zm5.5 3.7c-7.6-.4-12.7 1.3-18.3 2.6 5-1.7 9.8-3.4 16.2-3.9l2 1.3zm26.6 8.3c-7.6-.3-12.7 1.3-18.3 2.6 5-1.6 9.8-3.4 16.2-3.8l2 1.2z" />
        <g id="prefix__a">
          <path d="M207.2 997.4c6.6-4.3 15.2-3.2 20.6-6.6 5.7-3.5-3-7 1.5-9.7 4.5-2.5 10.3 3 16.5-.5s3.3-9.9 8.5-12.1c5.2-2.3 7.3 5 13.4 1.5 6-3.3 3.8-12 10.6-16.4 6.6-4.4 5.5-11.4-1.8-11.7-4.9-.1-8.7 3.6-16 3.5-7.2 0-8-6-13.1-3.6-5 2.4-1.5 9.7-7.1 13.4-5.6 3.8-11.2-2-15.2 1.5s1.9 8-1 12.5-7.4-.5-11.6 6.3c-4.3 6.8-5.3 21.9-5.3 21.9z" />
          <path d="M202 1007c14.5-26 42.6-46.3 79-61.5-21.5 7.7-64.6 27.1-82 62.4l3-.8z" />
          <path d="M230 974c5.7-1.7 9.7-.9 14-.4a31 31 0 0 0-12.5-1.4l-1.6 1.8zm22.1-14.5c6.1-.2 9.8 1.6 13.9 3.1-3.5-1.8-7-3.8-11.9-4.4l-2 1.3zm-6.1 2.2c3.6-4.9 4.1-8.9 5.1-13-.4 3.8-.6 7.7-2.9 12l-2.2 1zm-20 14.1c3.6-4.8 4.1-8.9 5.1-13-.4 3.9-.6 7.7-2.8 12.1l-2.3 1z" />
        </g>
        <g id="prefix__b">
          <path d="M210.3 1024.5c9 3.6 19.3 0 26.7 2.7 7.8 3-1.9 9.7 4.2 11.8 6.2 2 11.9-6.4 20.2-3.7 8.4 2.8 6.5 11.5 13.4 13 6.9 1.4 7.6-8.2 15.8-5.6 8.2 2.6 7.6 14 17 17.8 9 3.8 9.4 12.9.6 15.1-5.9 1.5-11.5-2.1-20.2 0-8.8 2-8.4 9.7-15.2 8-6.8-1.7-4.2-11.8-12-15-7.6-3.2-13 5.6-18.8 2.3-5.8-3.4.3-10.7-4.3-15.6-4.6-4.8-8.8 2.7-15.7-4.7-6.8-7.4-11.7-26.1-11.7-26.1z" />
          <path d="M201.6 1013.7c24 29 63.2 46.9 111.1 56.2-27.9-3.8-85.2-16.8-115-56.5l3.9.3z" />
          <path d="M243.7 1047.8c7.5.6 12.2-1.5 17.3-3.3-4.5 2.2-8.8 4.6-15 5.1l-2.3-1.8zm30.6 12.2c7.4-1.3 11.5-4.6 16-7.6-3.7 3.3-7.4 6.7-13.3 8.8l-2.7-1.2zm-8-1c5.5 5.1 7.2 10 9.4 15-1.4-4.8-2.7-9.6-6.5-14.5l-3-.5zm-27.8-12.4c5.5 5 7.2 10 9.4 15-1.4-4.8-2.6-9.6-6.5-14.5l-2.9-.5z" />
        </g>
        <use
          width={744.1}
          height={1052.4}
          transform="translate(44 17.4)"
          xlinkHref="#prefix__a"
        />
        <use
          width={744.1}
          height={1052.4}
          transform="translate(59.3 11.2)"
          xlinkHref="#prefix__b"
        />
        <g id="prefix__e">
          <path d="M353.5 1034.1c9.8 1 18.8-5.3 26.7-4.7 8.4.6.7 9.8 7.2 10 6.4.3 9.9-9.3 18.7-9 8.8.4 9.2 9.2 16.3 8.7 7-.5 5.3-9.9 14-9.6s11 11.2 21 12.3c9.8 1.1 12.5 9.7 4.5 14.3-5.3 3-11.7 1-19.7 5.4s-5.7 11.7-12.7 12c-7 .1-7.1-10.2-15.5-11.2-8.3-.9-11.3 9-17.8 7.4-6.5-1.6-2.4-10.3-8.1-13.7-5.8-3.3-8 5-16.5-.2s-18-21.7-18-21.7z" />
          <path d="M342.3 1026.2c30.8 21 73.5 27.4 122.6 23.2-28.2 4-87.3 7.3-126.4-22.4l3.8-.8z" />
          <path d="M392 1047.2c7.4-1.4 11.5-4.8 16-7.9-3.8 3.4-7.4 6.8-13.2 9l-2.8-1zm33 3.3c6.8-3.3 10-7.6 13.6-11.7-2.8 4.2-5.5 8.4-10.7 12l-3-.3zm-8.1 1.2c6.6 3.4 9.5 7.6 13 11.7-2.7-4.1-5.1-8.4-10-12l-3 .3zm-30.3-4.2c6.7 3.3 9.6 7.6 13 11.7-2.6-4.2-5-8.4-10-12l-3 .3z" />
        </g>
        <path d="M292.7 1024.5c5-5 13.2-6.2 17.3-10.2 4.4-4.3-4.5-5.2-1-8.4s10.2 0 15-4.4c4.8-4.3.5-8.8 4.7-12 4.3-3 8 2.4 12.7-1.8 4.8-4.2.5-10.7 5.6-16 5-5.2 2.1-10.7-4.7-9.2-4.5 1-7 5-13.8 6.6-6.7 1.7-9-3-13 .2-4.1 3.2 1 8.4-3.1 12.7-4.2 4.4-10.8 1-13.7 4.8-2.8 3.9 3.8 6.2 2.3 10.6-1.5 4.4-7 1.3-9 7.9-2.2 6.6.7 19.3.7 19.3z" />
        <path d="M292 1030.3c6.7-25 25.7-44.8 55.3-65.9-17.7 11.3-50.8 34.2-57.7 67.3l2.5-1.4z" />
        <path d="M307.6 1000c5-2.9 8.9-3.1 13-3.8-3.8.2-7.6.2-12 1.9l-1 1.8zm16.8-17.3c5.5-1.6 9.4-1 13.6-.7-3.7-.7-7.4-1.5-12-.8l-1.6 1.5zm-5.1 3.3c2-4.8 1.5-8.3 1.3-12 .7 3.4 1.5 6.6.5 10.7l-1.8 1.3zm-14.8 16.3c2-4.8 1.5-8.2 1.4-11.9.6 3.3 1.4 6.5.5 10.7l-1.9 1.2zm41 15c4-6.2 12-9.1 15.4-14.1 3.5-5.3-5.7-4.4-2.8-8.4 3-4 10.4-2.1 14.3-7.6 4-5.5-1.2-9.3 2.4-13.3 3.7-4.1 8.6.8 12.5-4.5 4-5.4-1.7-11.2 2.4-17.7 4-6.4 0-11.5-6.6-8.6-4.4 2-6.1 6.6-12.6 9.7-6.4 3-9.8-1.4-13.2 2.8-3.5 4.1 2.8 8.4-.6 13.8-3.3 5.4-10.7 3.2-12.8 7.7-2.1 4.6 5 5.7 4.4 10.5-.6 4.8-6.7 2.7-7.6 10-.8 7.2 4.7 19.7 4.7 19.7z" />
        <path d="M346 1023.4c1.6-27.1 16.9-51.5 42.6-79.3-15.7 15.3-44.6 45.6-45 81.3l2.3-2z" />
        <path d="M355.6 988.8c4.4-3.8 8.3-4.9 12.3-6.4-3.8 1-7.6 1.7-11.7 4.3l-.6 2.1zm13.5-21.1c5.3-2.8 9.3-3 13.6-3.5-4 0-7.8 0-12.4 1.6l-1.2 1.9zm-4.6 4.3c1.2-5.3-.1-8.8-1-12.5 1.3 3.2 2.8 6.4 2.6 10.9l-1.6 1.6zM353 992c1-5.4-.2-8.9-1-12.6 1.3 3.3 2.7 6.4 2.6 10.9L353 992z" />
        <g id="prefix__f">
          <path
            d="M505.9 948.8c7.7-4.2 11.3-13.2 17.4-16.7 6.6-3.7 5.3 6.8 10.2 3.8 5-3 2.8-11.8 9.5-16 6.7-4 11.3 2.3 16.3-1.6s-.9-10 5.7-14c6.5-4.1 13.6 2.8 21.5-1.4 7.8-4 14 1 10.3 8.3-2.5 5-8.2 6.6-12 13.8-3.8 7.2 1.5 11.4-3.6 15-5.1 3.6-10.2-3.9-16.8-.5-6.6 3.5-4 12.2-9.6 14.3-5.6 2-6.8-6.4-12.7-6-5.9.3-3.5 7.6-12.3 8-8.8.3-24-7-24-7z"
            transform="translate(9.4 -7.9)"
          />
          <path
            d="M493.7 948.5c33 .2 67.7-16.3 102-43.7-18.9 17-61 48.6-104.4 46.2l2.4-2.5z"
            transform="translate(9.4 -7.9)"
          />
          <path
            d="M540.7 939.4c4.8-4.8 6.1-9.3 8-13.8-1.1 4.3-2.1 8.6-5.4 13.2l-2.6.6zm26-14c3.5-5.8 3.7-10.5 4.5-15.3-.1 4.5 0 8.9-2.2 14.1l-2.3 1.2zm-5.4 5c6.6-1 10.7.8 15.3 2.1-4-1.8-7.8-3.7-13.2-3.9l-2.1 1.7zm-24.4 11.8c6.5-.9 10.7.8 15.3 2.2-4-1.8-7.9-3.7-13.3-4l-2 1.8z"
            transform="translate(9.4 -7.9)"
          />
        </g>
        <path d="M583 716.2c3.6-8.6.8-18.5 3.6-25.6 3-7.5 8.7 2 10.7-3.9s-5.2-11.5-2.3-19.4 10.5-6 12.1-12.6c1.6-6.6-7-7.5-4.3-15.4 2.8-7.8 13-7 16.8-15.9 3.7-8.6 12-8.8 13.6-.3 1 5.7-2.5 11-1 19.4 1.4 8.5 8.4 8.3 6.6 14.8-1.9 6.5-10.8 3.8-14 11.2-3.2 7.3 4.4 12.6 1.2 18.2-3.2 5.5-9.6-.6-14.1 3.8-4.6 4.4 2 8.5-5 15-7 6.4-24 10.7-24 10.7z" />
        <path d="M573 724.4c27-22.6 44.7-59.9 55.2-105.8-4.6 26.8-18.8 81.6-55.7 109.4l.4-3.6z" />
        <path d="M605.4 684.6c.9-7.2-.9-11.7-2.2-16.7 1.8 4.3 3.7 8.5 4 14.4l-1.8 2.3zm12.3-29.2c-.9-7.2-3.7-11.2-6.1-15.6 2.7 3.7 5.6 7.3 7.2 13l-1.1 2.6zm-1.3 7.7c4.8-5.2 9.3-6.7 13.9-8.8-4.4 1.3-8.7 2.4-13.3 6l-.6 2.8zM604 689.5c4.8-5.2 9.3-6.7 13.9-8.7-4.4 1.3-8.7 2.4-13.3 6l-.6 2.7z" />
        <path d="M572.3 672c4.4-7.6 3-17.3 6.4-23.6 3.7-6.7 8 3 10.6-2.3 2.7-5.3-3.6-11.6 0-18.8 3.7-7.1 10.8-4.3 13-10.3 2.4-6-5.7-8-2.2-15 3.5-7.1 13-5 17.7-13 4.6-7.6 12.4-6.8 12.9 1.5.4 5.5-3.6 10-3.2 18.2.3 8.2 7 9 4.5 14.8-2.6 6-10.7 2.3-14.6 8.8-3.9 6.5 2.7 12.6-1 17.4-3.7 4.8-9-1.8-13.8 1.8-4.8 3.5.9 8.3-6.4 13.5s-24 7-24 7z" />
        <path d="M561.8 678.5c28.2-17.8 49.4-50.8 64.8-92.9C619 610.3 599 660.3 561 682l.8-3.4z" />
        <path d="M597.2 645c1.6-6.6.5-11.2-.1-16 1.1 4.3 2.5 8.5 2 14.1l-2 2zm15-26c0-6.9-2-11-3.9-15.5 2.2 3.9 4.5 7.6 5.3 13.2l-1.4 2.3zm-2 7.1c5.1-4.3 9.5-5.1 14-6.5-4.2.7-8.4 1.1-13.2 4l-.9 2.5zm-14.9 23.5c5.2-4.4 9.6-5.2 14.1-6.5-4.2.6-8.5 1-13.2 3.9l-.9 2.6zm-28.6 126.3c-7.8-5.6-18.2-4.8-24.7-9.2-6.8-4.7 3.7-8.6-1.7-12-5.4-3.5-12.5 3-19.9-1.7-7.3-4.7-3.8-12.3-10-15.4-6.3-3.1-8.9 5.7-16.1 1.2-7.3-4.5-4.5-15-12.6-21-7.8-5.7-6.4-14.3 2.4-14.2 5.9 0 10.4 4.9 19.1 5.2 8.8.3 5-4.3 11.1-1s4.9 12 11.5 17c6.7 4.9 15.2-4.7 20-.1 5 4.5-2.3 9.9 1 15.6 3.5 5.7 9-.3 14 8.3 5 8.6 6 27.3 6 27.3z" />
        <path d="M572.9 788.2c-17-33.1-50.6-59.6-94.2-80.4 25.7 10.6 77.4 37 97.7 81.6l-3.5-1.2z" />
        <path d="M539.7 745.8c-7-2.5-11.8-1.6-17-1.3 4.7-1 9.2-2 15.2-1l1.8 2.3zm-26.5-19.1c-7.4-.6-11.8 1.4-16.8 3 4.3-2 8.4-4.3 14.4-4.8l2.4 1.8zm7.3 3c-4.2-6.2-4.8-11.2-5.9-16.4.4 4.8.6 9.6 3.3 15.1l2.6 1.2zm23.9 18.5c-4.2-6.1-4.8-11.1-6-16.3.5 4.8.7 9.6 3.3 15.1l2.7 1.2zm30.3 95.2c5.8-6.6 6.3-16.4 11-21.9 4.8-5.8 7.1 4.6 10.7 0 3.7-4.6-1.2-12 3.7-18.3 5-6.3 11.3-2 14.8-7.4 3.4-5.4-4-9 .7-15.2 4.8-6.2 13.7-2.2 19.8-9 6-6.5 13.5-4 12.4 4.2-.7 5.5-5.5 9-6.7 17.2-1.3 8.1 5 10.2 1.5 15.4-3.6 5.2-10.9 0-16 5.5s.2 12.9-4.3 16.8c-4.6 4-8.5-3.6-13.9-1.1-5.4 2.4-.8 8.3-9 11.9-8.1 3.5-24.7 1.9-24.7 1.9z" />
        <path d="M563.2 847.5c31.1-11.6 58.3-39.4 81.5-77.3-12.2 22.6-41.4 67.4-83 80.5l1.5-3.2z" />
        <path d="M604.3 822.2c3-6.2 2.8-10.9 3-15.8.4 4.5.9 8.9-.7 14.3l-2.3 1.5zm19.9-22.3c1.3-6.8 0-11.3-.9-16 1.4 4.2 3 8.3 2.7 14l-1.8 2zm-3.5 6.5c6-3.2 10.4-3 15.1-3.4-4.3-.3-8.5-.7-13.7 1l-1.4 2.4zm-19 19.8c5.8-3.1 10.3-3 15-3.4-4.3-.2-8.5-.7-13.7 1l-1.4 2.4z" />
        <use
          width={744.1}
          height={1052.4}
          transform="rotate(15 310 758.4)"
          xlinkHref="#prefix__c"
        />
        <use
          id="prefix__c"
          width={744.1}
          height={1052.4}
          transform="rotate(5 93.2 577.1)"
          xlinkHref="#prefix__d"
        />
        <use
          width={744.1}
          height={1052.4}
          transform="rotate(-10 275 690.3)"
          xlinkHref="#prefix__e"
        />
        <use
          width={744.1}
          height={1052.4}
          transform="rotate(10 225.4 653.9)"
          xlinkHref="#prefix__f"
        />
      </g>
      <use
        width={1}
        height={1}
        transform="matrix(-1 0 0 1 840 .1)"
        xlinkHref="#prefix__g"
      />
    </g>
    <g stroke="#d4af37" strokeWidth={0.5}>
      <path
        fill="#007ea8"
        d="M291 195.6l-14 17.5a26.2 26.2 0 0 1 7.3 17.9 53.7 53.7 0 0 1-2.8 17.5v.2H320V196c-8.5 5.2-20.1 7.3-29-.4z"
      />
      <path
        fill="#fff"
        d="M349 195.6c-8.8 7.7-20.5 5.6-29 .4v52.7h38.5v-.2a53.7 53.7 0 0 1-2.8-17.5c0-6 2.7-13.5 7.3-17.9l-14-17.5z"
      />
      <path
        fill="#d91023"
        d="M281.5 248.7c-2.1 6.5-4.8 12.2-5.6 21.6-1.2 14 10 21.5 14.6 23.7 7.2 3.4 14.6 2.2 22.3 3.2 3.5.5 5.5 2.7 7.2 4.5 1.7-1.8 3.7-4 7.3-4.5 7.6-1 15 .2 22.2-3.2 4.6-2.2 15.8-9.8 14.6-23.7-.8-9.4-3.5-15.1-5.6-21.6h-77z"
      />
    </g>
    <g stroke="#d4af37" strokeWidth={3}>
      <g
        fill="#00a854"
        strokeWidth={6.2}
        transform="matrix(.08444 0 0 .08889 232.8 247.5)"
      >
        <g id="prefix__j" strokeWidth={3.1}>
          <path d="M1074.7-201.4s5.9-20.4 18-29.3c12-9 25.2-5.7 33.2-8.9-5.4 6.8-6 20.3-18 29.3s-33.2 8.9-33.2 8.9zm48.7-36.4c-8.3 2.3-13.5-.3-25 4m17.4 1.8c-8.4 2.2-14.1-1.4-25.4 3.4m16.2 3.4c-8 2.8-11.7-1.2-22.5 4m13.3 3c-8 2.7-9.6-1.8-17.5 4.2m9.3 1.8c-5.2 1.7-7.5-.2-12.2 5m46.4-30.5c-4.5 7.3-3.5 13-10.8 22.8m3.2-17.1c-4.5 7.3-2.8 13.9-10.5 23.3m1.3-16.5c-5 6.8-2.2 11.5-10.3 20.4m1-13.5c-4.9 6.8-1 9.7-9 15.6m.9-9.5c-3 4.5-2 7.3-8.3 10.2" />
          <path d="M1130.8-243.6l-24.2 18-31.6 24 32-23.5 24.2-18m-23-73.9s16.7 13 20.5 27.5c3.8 14.5-4 25.5-4 34.1-4.4-7.4-16.7-13-20.7-27.5s4.1-34.1 4.1-34.1zm15.6 58.7c1-8.6 5.3-12.4 5.7-24.6m-8.1 15.3c1-8.5 6.4-12.6 6.2-24.7m-9.2 13.7c.3-8.4 5.4-10.4 4.6-22.4m-7.6 11.3c.4-8.4 5.2-8.3 2.5-17.9m-5.1 8c.3-5.4 3-7-.2-13.2m11.2 54.5c-5.1-7-10.8-8.1-17.1-18.5m14.7 9.3c-5.2-7-12-7.8-17.8-18.4m14.8 7.3c-4.5-7.1-9.9-6.3-15.2-17.1m12.2 6c-4.5-7.1-8.6-4.6-11-14.2m8.4 4.3c-3-4.5-6-4.5-6.4-11.5" />
          <path d="M1126.6-249.3l-7.8-29.1-10.6-38.3 10 38.5a5074.4 5074.4 0 0 0 7.8 29" />
          <g id="prefix__h">
            <path d="M1206.4-261.9s16.8 13 20.6 27.6c3.8 14.5-4 25.5-4 34-4.4-7.4-16.7-13-20.6-27.4-4-14.5 4-34.2 4-34.2zm15.7 58.7c1-8.5 5.4-12.4 5.7-24.6m-8.1 15.4c1-8.6 6.4-12.6 6.2-24.8m-9.2 13.7c.3-8.4 5.4-10.4 4.6-22.4m-7.6 11.3c.4-8.4 5.2-8.2 2.5-17.8m-5.1 8c.4-5.5 3-7-.2-13.2m11.2 54.4c-5.1-6.9-10.8-8-17.1-18.5m14.7 9.3c-5.2-6.9-12-7.7-17.8-18.3m14.8 7.2c-4.5-7-9.9-6.3-15.1-17m12.1 6c-4.5-7.2-8.6-4.7-11-14.3m8.4 4.4c-3-4.5-6-4.6-6.4-11.5" />
            <path d="M1224.9-194.1l-7.8-29.2-10.6-38.2 10 38.4a5155 5155 0 0 0 7.8 29.1m-53.8 57.3s2.9-21 13.5-31.6c10.7-10.6 24.2-9.2 31.6-13.5-4.3 7.4-3 20.9-13.5 31.6-10.6 10.6-31.6 13.5-31.6 13.5zm43-43c-8 3.4-13.4 1.7-24.2 7.5m17.4-.7c-8 3.4-14.2.7-24.6 7m16.5 1.1c-7.4 3.9-11.7.5-21.7 7.2m13.6 1c-7.5 3.8-9.7-.4-16.7 6.7m9.5.4c-5 2.4-7.5 1-11.3 6.8m41.5-37c-3.4 8-1.7 13.4-7.5 24.1m.7-17.3c-3.4 7.9-.7 14.1-7 24.6m-1.1-16.5c-3.9 7.4-.5 11.7-7.2 21.7m-1-13.6c-3.8 7.5.4 9.7-6.7 16.7m-.5-9.5c-2.4 5-.9 7.5-6.7 11.3" />
            <path d="M1219.9-186.6l-21.3 21.4-27.9 28.2s18.9-18.4 28.3-27.8a5074.4 5074.4 0 0 0 21.4-21.3" />
          </g>
          <path d="M1057-278.6s20.6-5.1 34.4.9c13.8 6 17.5 19 24.3 24.3-8.5-1.2-20.5 5-34.4-.9-13.8-5.8-24.2-24.3-24.2-24.3zm55.9 24c-6-6-6.5-11.8-15.9-19.6m7.1 15.8c-6-6-5.9-12.9-15.6-20.2m5 15.7c-6.3-5.5-4.7-10.7-14.7-17.4m4.2 12.9c-6.4-5.5-3.3-9.2-12.5-13m3.1 9c-4-3.7-3.6-6.7-10.4-8m49.7 24.8c-8.6-.2-13 3.5-25.2 2m16.4-5.8c-8.6-.2-13.4 4.6-25.4 2.6m14.9-7.1c-8.4-.9-11 3.9-22.8 1.3m12.2-5.8c-8.3-.9-8.9 3.9-18-.1m8.6-4c-5.4-.4-7.2 2-13-2" />
          <path d="M1121.7-251.2L1094-263l-36.6-15.4 36.3 16a5135.7 5135.7 0 0 0 27.7 12M1072.3-384s14.7-15.3 29.5-17.5c14.9-2.3 25 6.7 33.5 7.6-7.8 3.5-14.7 15.2-29.5 17.6-14.9 2.4-33.5-7.7-33.5-7.7zm60-9.4c-8.4-2-11.8-6.6-23.9-8.2m14.5 9.7c-8.4-2-11.9-7.8-24-8.9m12.6 10.7c-8.3-1.3-9.7-6.5-21.7-7m10.4 8.7c-8.3-1.2-7.7-6-17.5-4.3m7.4 6c-5.4-1-6.6-3.8-13.1-1.3m55.3-5.4c-7.4 4.4-9.2 9.9-20.2 15.1m10.8-13.6c-7.4 4.4-9 11-20.2 15.7m8.8-14c-7.5 3.8-7.3 9.2-18.6 13.3m7.3-11.5c-7.5 3.7-5.5 8-15.3 9.5m5.2-7.9c-4.8 2.5-5.2 5.5-12.1 5.1" />
          <path d="M1141.6-395l-29.8 4.6c-13.1 2-39.2 6.4-39.2 6.4l39.3-5.8 29.8-4.6M1102-455s20 7 28.2 19.6c8.2 12.6 4.2 25.5 6.9 33.7-6.4-5.7-19.9-7.1-28.2-19.6-8.3-12.6-6.9-33.7-6.9-33.7zm33.4 50.8c-1.7-8.5 1.1-13.5-2.4-25.2m-2.8 17.2c-1.7-8.5 2.1-14-2-25.5m-4.3 15.9c-2.3-8 1.8-11.6-2.7-22.7m-3.7 13c-2.3-8 2.3-9.4-3.2-17.6m-2.4 9.2c-1.3-5.3.6-7.6-4.3-12.5m27.8 48.2c-7-5-12.8-4.4-22.1-12.2m16.9 4.2c-7.1-5-13.8-3.6-22.7-11.9m16.4 2.3c-6.5-5.3-11.4-2.9-19.8-11.5m13.4 1.9c-6.5-5.3-9.5-1.7-15-10m9.4 1.5c-4.3-3.4-7.1-2.4-9.6-9" />
          <path d="M1141-396.4l-16.6-25.2-22.1-33 21.6 33.3a5079.8 5079.8 0 0 0 16.5 25.2" />
          <g id="prefix__i">
            <path d="M1213.7-401.8s16.7 13 20.6 27.5c3.8 14.5-4.1 25.5-4.1 34.1-4.3-7.4-16.6-13-20.6-27.5s4-34.1 4-34.1zm15.7 58.7c1-8.6 5.3-12.4 5.6-24.6m-8 15.4c1-8.6 6.4-12.7 6.2-24.8m-9.2 13.7c.3-8.4 5.4-10.4 4.5-22.4m-7.5 11.3c.3-8.4 5.1-8.3 2.5-17.9m-5.2 8c.4-5.4 3-7-.2-13.1m11.3 54.4c-5.2-6.9-10.8-8.1-17.2-18.5m14.7 9.3c-5.2-7-11.9-7.7-17.8-18.4m14.9 7.3c-4.5-7.1-10-6.3-15.2-17.1m12.2 6c-4.5-7.1-8.6-4.6-11.1-14.2m8.4 4.3c-3-4.5-6-4.5-6.3-11.5" />
            <path d="M1232.1-334.1l-7.8-29.1-10.5-38.3s6.5 25.6 10 38.5a5074.4 5074.4 0 0 0 7.7 29m-64.4 39s8.2-19.5 21.3-27c13-7.4 25.7-2.6 34-4.8-6.1 6-8.3 19.4-21.3 27-13 7.6-34 4.9-34 4.9zm52.6-30.3c-8.5 1.2-13.4-1.9-25.2 1m17 3.8c-8.6 1.2-14-3-25.6.4m15.6 5.3c-8.2 1.9-11.4-2.5-22.8 1.4m12.9 4.4c-8.2 1.8-9.3-2.9-18 2.2m9.1 2.9c-5.3 1-7.4-1-12.6 3.6m49.6-25c-5.3 6.8-5 12.6-13.4 21.4m5.2-16.6c-5.4 6.8-4.4 13.5-13.2 22m3.2-16.3c-5.7 6.2-3.5 11.2-12.6 19m2.7-13.2c-5.7 6.1-2.2 9.4-10.9 14.3m2-9.2c-3.5 4-2.8 7-9.4 9.1" />
            <path d="M1227.7-330.3l-26 15.1-34.3 20.1 34.5-19.5a5074.4 5074.4 0 0 0 26.1-15.1" />
          </g>
          <path d="M1182.2-442s19.7-8 34.2-4c14.5 4 20 16.3 27.4 20.7-8.6 0-19.6 7.8-34.1 4-14.5-4-27.5-20.7-27.5-20.7zm58.7 15.9c-6.9-5.2-8.1-10.9-18.5-17.2m9.2 14.7c-6.8-5.2-7.6-12-18.2-17.9m7.2 14.9c-7.1-4.5-6.3-10-17-15.2m5.9 12.2c-7-4.5-4.6-8.6-14.2-11.1m4.3 8.4c-4.5-3-4.5-6-11.4-6.4m52.7 17.6c-8.6 1-12.5 5.2-24.6 5.5m15.4-8c-8.6 1-12.7 6.4-24.8 6.1m13.7-9.1c-8.4.3-10.4 5.4-22.4 4.5m11.3-7.5c-8.4.3-8.3 5-17.9 2.4m8-5c-5.4.2-7 2.8-13.1-.4" />
          <path d="M1250-424l-29-7.9-38.5-10 38.3 10.7a5074.4 5074.4 0 0 0 29 7.8m-34.7-73.7s19.5 8.2 27 21.3c7.4 13 2.6 25.7 4.8 34-6-6.1-19.4-8.3-27-21.3-7.5-13-4.8-34-4.8-34zm30.3 52.7c-1.2-8.6 2-13.4-.9-25.3m-3.9 17c-1.2-8.6 3-13.9-.3-25.6m-5.4 15.6c-1.8-8.2 2.6-11.4-1.3-22.8m-4.4 12.8c-1.8-8.2 2.8-9.3-2.2-17.8m-2.9 9c-1-5.3 1-7.5-3.6-12.7m24.9 49.8c-6.8-5.4-12.6-5.1-21.4-13.5m16.6 5.2c-6.8-5.4-13.5-4.4-21.9-13.2m16.2 3.2c-6.2-5.7-11.2-3.5-19-12.6m13.3 2.7c-6.2-5.7-9.5-2.3-14.4-11m9.3 2c-4-3.5-7-2.7-9.1-9.4" />
          <path d="M1250.3-436.4l-15-26.2-20-34.3 19.5 34.6a5040.8 5040.8 0 0 0 15 26.2" />
          <use
            width={744.1}
            height={1052.4}
            transform="translate(-32 -18)"
            xlinkHref="#prefix__h"
          />
          <path d="M1142.4-297.9s16.8 13 20.6 27.6c3.8 14.5-4 25.5-4 34-4.4-7.4-16.7-13-20.6-27.4-4-14.5 4-34.2 4-34.2zm15.7 58.7c1-8.5 5.4-12.4 5.7-24.6m-8.1 15.4c1-8.6 6.4-12.6 6.2-24.8m-9.2 13.7c.3-8.4 5.4-10.4 4.6-22.4m-7.6 11.3c.4-8.4 5.2-8.2 2.5-17.8m-5.1 8c.4-5.5 3-7-.2-13.2m11.2 54.4c-5.1-6.9-10.8-8-17.1-18.5m14.7 9.3c-5.2-6.9-12-7.7-17.8-18.3m14.8 7.2c-4.5-7-9.9-6.3-15.1-17m12.1 6c-4.5-7.2-8.6-4.7-11-14.3m8.4 4.4c-3-4.5-6-4.6-6.4-11.5" />
          <path d="M1160.9-230.1l-7.8-29.2-10.6-38.2 10 38.4a5155 5155 0 0 0 7.8 29.1m-53.8 57.3s2.9-21 13.5-31.6c10.7-10.6 24.2-9.2 31.6-13.5-4.3 7.4-3 20.9-13.5 31.6-10.6 10.6-31.6 13.5-31.6 13.5zm43-43c-8 3.4-13.4 1.7-24.2 7.5m17.4-.7c-8 3.4-14.2.7-24.6 7m16.5 1.1c-7.4 3.9-11.7.5-21.7 7.2m13.6 1c-7.5 3.8-9.7-.4-16.7 6.7m9.5.4c-5 2.4-7.5 1-11.3 6.8m41.5-37c-3.4 8-1.7 13.4-7.5 24.1m.7-17.3c-3.4 7.9-.7 14.1-7 24.6m-1.1-16.5c-3.9 7.4-.5 11.7-7.2 21.7m-1-13.6c-3.8 7.5.4 9.7-6.7 16.7m-.5-9.5c-2.4 5-.9 7.5-6.7 11.3" />
          <path d="M1155.9-222.6l-21.3 21.4-27.9 28.2s18.9-18.4 28.3-27.8a5074.4 5074.4 0 0 0 21.4-21.3" />
          <use
            width={744.1}
            height={1052.4}
            transform="translate(-62 -40)"
            xlinkHref="#prefix__i"
          />
          <use
            width={744.1}
            height={1052.4}
            transform="translate(-31 -20)"
            xlinkHref="#prefix__i"
          />
        </g>
        <use
          width={744.1}
          height={1052.4}
          transform="matrix(-1 0 0 1 2501 0)"
          xlinkHref="#prefix__j"
        />
        <path
          fill="#947245"
          d="M1250.5-437.1c-8.6 41.6-8.6 79.1-8.6 79.1-.5 14-7.4 23.7-13.8 20-54.9-31.7-60.3-37.5-89.1-59.6 24.3 26.4 31.2 38.2 86.7 70.2 10.7 6.2 12 16.4 11.6 29.5l-1.6 61.7c-.3 9 5.7 50.1-22.6 34.2-65.4-36.6-63.8-33.6-95.1-51.6 38 32.3 24.4 23.4 90.6 61.7 12 6.9 24.5 24.5 24.5 32.8 0 124.3 1.9 101.5-12.8 139.1h60.4c-14.7-37.6-12.8-14.8-12.8-139 0-8.4 12.6-26 24.5-33 66.2-38.2 51.5-29.3 89.6-61.6-31.3 18-28.7 15-94.1 51.6-28.3 15.9-22.3-25.2-22.6-34.2l-1.6-61.7c-.5-13.1.9-23.3 11.6-29.5 55.5-32 62.4-43.8 86.7-70.2-28.8 22-34.2 28-89.1 59.6-6.4 3.7-13.3-6-13.8-20 0 0 0-37.5-8.6-79.1z"
        />
      </g>
      <g strokeWidth={2.7}>
        <path
          fill="#e3e4e5"
          strokeLinecap="square"
          d="M264.4 424.6c-.2 1 1.6 12.4.6 15.7-.5 4.5-.6 5.2-1.7 11.1-1 5.9-2.4 17.3-4.4 24.2a37.3 37.3 0 0 0-.7 12.4l3.6 19.4s1.6 2 1.8 2.7c.3.8-.1 2 0 2.3 1 1.3 1.1 2.7 2.2 3.8.2.2 1 .1 1.1.4.2.2 1.5.3 1.8.4.8.8.6 1.3 1 2.4h-6.3c.2-2.8-2-3.9-2-3.9-.3-.3-2.9-1-3.2-2.7-.4-2.4 0-2.8 0-2.8s-2.2-9-3-11.4c-.6-1.7-.7-2.6-1-4-.7-4.3-1-6.2-3.2-12.5-.6-1-2-1.4-1.9-2.9l.7-1.4v-1.2l1.1-15.5a1.9 1.9 0 0 0 .3-.7c.6-8.8-4.1-17-7.1-25-.6-1.4-.1-3-.7-4.4-3.2-1-5.4-6.4-6.6-9.8a23 23 0 0 1-.7-11.6 5 5 0 0 1 1-2.5m63.2 36.7a8.3 8.3 0 0 1 2.5-.4l1 1.5c1.5 2.8 3.4 15.4 4.4 21.2l1.5 7.9s-.4 2 .3 4.3l.6 2.1c.8 3 1.7 3.8 1.7 3.8.2.8 1.4 6.8 1.7 7.5a75.2 75.2 0 0 1 2.6 16.7c-.1 4.7-.1 4.2.3 4.6 1 1 1.5.4 3.8 6.1 0 .5.2-.2.5.2.2.6.7.5 1.1.6.8 0 .6.2 1.2.3a6.3 6.3 0 0 0 1.6 0h5.5a5.4 5.4 0 0 0-4.9-3.4c-.8-.5-1.8-1.2-2.1-2.3l-2.3-3.3c.1-.7-.4-1.7-.6-2.5l-2-23.2s.4-2.3.4-4.7c-.2-12.8.6-25.6 1-38.5.2-1 4-4.7 4-4.7"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fill="#fff"
          strokeLinecap="square"
          d="M356.8 323.8a7.3 7.3 0 0 0-5.5 2.5 22 22 0 0 0-3 10.6c-.1.8.2 1.4 0 2.2a83.3 83.3 0 0 0-1.7 5c-.7 4.2-.9 19.7-2 25.6-1 6-6 14.6-8 17.4a9.7 9.7 0 0 1-4.5 2.2c-.8.2-7.2-.5-7.2-.5-8.4-.6-21-5.2-29.5-6.4-8.4-1.1-18.7-.6-26.6-1.4 0 0-10-3.7-19.1-1-9 2.6-14.1 7.5-22 19.5 0 0-3.4 4.1-3.4 5.5a17 17 0 0 0 5.2 12.8c1.1 1 .8.1.7-.1.4.7.7 2.4 1.2 3a43.7 43.7 0 0 1 3.2 5.2c.8 1.5.4 3.3 1.1 4.8 3.9 8.3 2 16.8 2 26.5a2 2 0 0 1-.1.8c-.1 5.7-5.7 13.3-5.7 19v1.2l-.7 1.6c0 1.6-2.1 1.9-1.5 3 3 6.7 3.4 8.7 4.5 13.2.4 1.7.6 2.6 1.3 4.5 1 2.4 4 12 4 12s-.3.6.3 3.2c.4 1.8 3.3 2.3 3.6 2.6a6 6 0 0 0 2.7 4.7c0 .4 2.5.3 2.8.3l3-.2c0-1.3-.4-2-1.3-2.8-.3-.1-1.5-.5-1.7-.7l-.6-1c-1.3-1.1-1.5-2.6-2.6-4-.2-.2.1-1.6-.2-2.4-.3-.9-2.2-2.8-2.2-2.8l-5.2-20.9c-.7-4.7 2.8-7.4 3.2-11.3 0-.8 4.6-12.2 4.8-12.8 3.3-8.9 8.8-22.8 8.7-28.7-.1-6.6-.3 1.3.3-3.7.5-3.8-1.7-13.8-1.5-14.8 12.4 20.7 24.5 28.2 44.5 26.2a9 9 0 0 1 2.5 0s.5 1.1.5 1.6c.8 2.9-1 15.3-1.7 21.2l-.8 7.8s-1 2-1 4.2v2.1c-.1 3 .6 4 .6 4l-.5 7.4a60.9 60.9 0 0 1-2.3 15.4c-.2.6-.7 1.5-1.3 1.6-.6.5-1.5 1.4-1.6 2.2 0 .6 0 1.2.2 1.8 0 .5.5 1.2.8 1.6.4 1.8.2 3.6.2 5.4l.3 1.7c.1.5.6.5 1 .6.7.2.5.6 1 .8l1.6.1h5.4c-.1-2-2-3-3.5-4-.7-.6-.6-.8-.6-1.8l-.1-4c0-.7.3-1 .5-1.5.3-.7.1-1.7.1-2.5 1-6.9 2.2-14 4-20.6 1.5-2 2.1-4.3 2.5-6.7 0 0 1.2-3.2.8-5l5-30a3.9 3.9 0 0 1 2.4-2.3c6.1-2.7 12.3-4.6 18-8.6 6.4-4.4 10.2-11.6 14.7-18 1-2 2.1-3.6 3.2-5.4a93 93 0 0 0 10-27.2c1.5-8.5 1-16.9 3.4-27 .5-2.1 2.4-3.8 2.8-6v-.5l1.2-.1 3.8-.5h3.2l1.8.1c.5 0 1.4.6 1.9.6s1-.1 1.3-.6c.7-.8.7-.5.9-1.3 0-.2.3 0 .4 0 .5-.2.9-.8 1.4-1 .4 0 .7-.2.8-.5v-1.6c0-.8 0-.8-.5-1h-.2c-.6-.2 0-1.4 0-2a3.8 3.8 0 0 0-.1-1.6 2.4 2.4 0 0 0-.9-1.1l-.9-1c-2.8-2.3-4-4.1-6-6 .3-.4.3-.6.2-1.3-1-2.7-2.7-3.2-5.6-5.4a25.6 25.6 0 0 0-10.1-3.7h-1.6a6.6 6.6 0 0 0-.4 0z"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fill="#d18219"
          d="M311.9 205.5a1.4 1.4 0 0 0-1 .5 4.6 4.6 0 0 0-.7 2v.5l-.3 1c-.1.8-.2 3.8-.4 5a10.9 10.9 0 0 1-1.5 3.4c-.2.3-.8.4-.9.4h-1.4c-1.6-.2-4.1-1-5.8-1.3-1.6-.2-3.6-.1-5.1-.3 0 0-2-.7-3.8-.2-1.7.5-2.7 1.5-4.3 3.8 0 0-.6.8-.6 1.1a3.4 3.4 0 0 0 1 2.5l.2.2c0-1.4.2-2 .2-2a5.7 5.7 0 0 0 .4 2l.7 1.1c.3 1 .6 3.7.8 4.8 0 .6-.4 2.6-.7 3.5-.5 1.7-.8 3.2-.1 2 .3-.4 1.4-2.6 2-4.6.6-2 1.2-3.2 1-3.6l-.3-3.1a1.7 1.7 0 0 1 0-.2v-.3l.2-1.5c2.9 5.4 7.5 6 10.5 2.3a15.6 15.6 0 0 0-.4 4.7v.8l-.5 5.1v.1l-.2.6v.8l.1.1v.8-.1c.3-.2.4-.6.4-1v-.1l.2-.3v-.5l1-6a.6.6 0 0 1 0-.2l.8-.7c.1-.2.7-2.6.6-4-.2-3.5 4.3-4.5 5.8-2.8.6-.3 1-.7 1.5-1.2a7.8 7.8 0 0 0 1-1.8v-.4a11.7 11.7 0 0 0 .2-.8 14.6 14.6 0 0 0 .2-1.3l.1-1.3.1-1.3a14.8 14.8 0 0 1 .3-1.4l.1-.3.2-.3.1-.3.1-.3v-.1h.2-1.7a2.1 2.1 0 0 1-.8-1l.3-1.7c.4-.8.8-.2 1.7 0a7.6 7.6 0 0 1 2.5 1.4h.9v-.3a1.7 1.7 0 0 0 0-.2v-.2a.5.5 0 0 0-.1-.1l-.2-.2-1.2-1.2v-.2c-.1-.6-.5-.7-1-1.1a5 5 0 0 0-2-.7h-.3a1.3 1.3 0 0 0-.1 0z"
          stroke="none"
        />
        <path
          fill="none"
          strokeLinecap="square"
          d="M356.8 323.8a7.3 7.3 0 0 0-5.5 2.5 22 22 0 0 0-3 10.6c-.1.8.2 1.4 0 2.2a83.3 83.3 0 0 0-1.7 5c-.7 4.2-.9 19.7-2 25.6-1 6-6 14.6-8 17.4a9.7 9.7 0 0 1-4.5 2.2c-.8.2-7.2-.5-7.2-.5-8.4-.6-21-5.2-29.5-6.4-8.4-1.1-18.7-.6-26.6-1.4 0 0-10-3.7-19.1-1-9 2.6-14.1 7.5-22 19.5 0 0-3.4 4.1-3.4 5.5a17 17 0 0 0 5.2 12.8c1.1 1 .8.1.7-.1.4.7.7 2.4 1.2 3a43.7 43.7 0 0 1 3.2 5.2c.8 1.5.4 3.3 1.1 4.8 3.9 8.3 2 16.8 2 26.5a2 2 0 0 1-.1.8c-.1 5.7-5.7 13.3-5.7 19v1.2l-.7 1.6c0 1.6-2.1 1.9-1.5 3 3 6.7 3.4 8.7 4.5 13.2.4 1.7.6 2.6 1.3 4.5 1 2.4 4 12 4 12s-.3.6.3 3.2c.4 1.8 3.3 2.3 3.6 2.6a6 6 0 0 0 2.7 4.7c0 .4 2.5.3 2.8.3l3-.2c0-1.3-.4-2-1.3-2.8-.3-.1-1.5-.5-1.7-.7l-.6-1c-1.3-1.1-1.5-2.6-2.6-4-.2-.2.1-1.6-.2-2.4-.3-.9-2.2-2.8-2.2-2.8l-5.2-20.9c-.7-4.7 2.8-7.4 3.2-11.3 0-.8 4.6-12.2 4.8-12.8 3.3-8.9 8.8-22.8 8.7-28.7-.1-6.6-.3 1.3.3-3.7.5-3.8-1.7-13.8-1.5-14.8 12.4 20.7 24.5 28.2 44.5 26.2a9 9 0 0 1 2.5 0s.5 1.1.5 1.6c.8 2.9-1 15.3-1.7 21.2l-.8 7.8s-1 2-1 4.2v2.1c-.1 3 .6 4 .6 4l-.5 7.4a60.9 60.9 0 0 1-2.3 15.4c-.2.6-.7 1.5-1.3 1.6-.6.5-1.5 1.4-1.6 2.2 0 .6 0 1.2.2 1.8 0 .5.5 1.2.8 1.6.4 1.8.2 3.6.2 5.4l.3 1.7c.1.5.6.5 1 .6.7.2.5.6 1 .8l1.6.1h5.4c-.1-2-2-3-3.5-4-.7-.6-.6-.8-.6-1.8l-.1-4c0-.7.3-1 .5-1.5.3-.7.1-1.7.1-2.5 1-6.9 2.2-14 4-20.6 1.5-2 2.1-4.3 2.5-6.7 0 0 1.2-3.2.8-5l5-30a3.9 3.9 0 0 1 2.4-2.3c6.1-2.7 12.3-4.6 18-8.6 6.4-4.4 10.2-11.6 14.7-18 1-2 2.1-3.6 3.2-5.4a93 93 0 0 0 10-27.2c1.5-8.5 1-16.9 3.4-27 .5-2.1 2.4-3.8 2.8-6v-.5l1.2-.1 3.8-.5h3.2l1.8.1c.5 0 1.4.6 1.9.6s1-.1 1.3-.6c.7-.8.7-.5.9-1.3 0-.2.3 0 .4 0 .5-.2.9-.8 1.4-1 .4 0 .7-.2.8-.5v-1.6c0-.8 0-.8-.5-1h-.2c-.6-.2 0-1.4 0-2a3.8 3.8 0 0 0-.1-1.6 2.4 2.4 0 0 0-.9-1.1l-.9-1c-2.8-2.3-4-4.1-6-6 .3-.4.3-.6.2-1.3-1-2.7-2.7-3.2-5.6-5.4a25.6 25.6 0 0 0-10.1-3.7h-1.6a6.6 6.6 0 0 0-.4 0z"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fill="#d39044"
          strokeLinecap="square"
          d="M382.3 343.8l-.3 1.2v.2l.3-1.2v-.2z"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M335 432.9c-2.1 8.3-7.2 10-3.5 17 0 0-1.6 0-2.6-2.8a17 17 0 0 1-.7-6.3 46.8 46.8 0 0 1 1.2-8.5"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M338.8 429.4c-2.1 8.4-7.2 10-3.5 17.1 0 0-2 0-3-2.7a19 19 0 0 1-.8-5.4c0-1.7.4-4.7.8-6a31 31 0 0 1 1.2-3.2"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M345.8 418.4c-3 5.5-5.3 10.2-6.6 14.3-1.2 4-2 6.3.4 10.6 0 0-1.6-.8-3.7-4.6a13 13 0 0 1-.8-6.6 30.6 30.6 0 0 1 .8-4.4 30 30 0 0 1 .8-2.6"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M348.5 414.9c-1.8 2.8-2.4 5.5-3.4 7.7a29 29 0 0 0-3.1 10.5c0 2-.3 3.7 1.9 7.1 0 0-1-.1-1.7-.5a6.2 6.2 0 0 1-2.3-2.7 15 15 0 0 1-1.3-6.5c0-1.5.5-3.7.9-5.2s1.8-4.5 1.8-4.5"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fill="#d18219"
          fillRule="evenodd"
          strokeWidth={1.4}
          d="M353.3 334.5c0-.2-11.6-3.6-13.3-13.8 2.3-2.2 14.3 5.7 14.5 13"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fillOpacity={0.5}
          fillRule="evenodd"
          strokeWidth={1.4}
          d="M340.4 320.8c.1.2 6.3.2 11.2 10.6-1.1-1.2-6 1.7-11.1-10.2"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fillRule="evenodd"
          strokeWidth={1.4}
          d="M368.7 335.6c.2-.2.4-.5.1-.8-5-3.2-4.8.7-8.4.7 1.7 0 1.7.2 2.3 1 2.3 2.4 4 2.2 6-.2"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fill="none"
          strokeLinecap="square"
          d="M381.2 349.8c-.6.6-2.5-.8-4-1"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fillRule="evenodd"
          strokeLinecap="square"
          d="M382.3 346s-.5-.5-4.3-1c0 0 2.6-2.7 2.8.3"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M302.7 436.9a33.6 33.6 0 0 0-1 1.8c-1 2.3-1.4 4.5.5 8 0 0-1.6 0-2.6-2.8-.5-1.3-.8-3.3-.7-6.3l.2-2.4"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
        <path
          fill="none"
          d="M230.7 419.1s-1.5-6.2 2.1-13"
          transform="matrix(.19494 0 0 .1962 242.4 142)"
        />
      </g>
      <g fill="#e7ca00" strokeWidth={2.3}>
        <path
          d="M401.4 879.5c-2-1.6-4-6.3-3.2-8.9-2.7-2.2-9.7 2.2-6.3 8.6 3.3 6.4 8 5.8 9.5.3zm19.1 6c.6-3.6-.7-9.7-7-10.8-6.1-1-8 4.6-6.9 10.3 4.5-3.4 11.7-1.6 14 .5z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M407.4 882c1-4.7 5.9-6 10.6-5.6-3-3.3-6-8.8-10.3-5.6-3.3 2.5-5.6 6.2-.3 11.2z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M404.8 879.3c.5-3.6 2-8.4 5.9-10.4-3.4-3-11.7-2.1-12.3 4.1-.6 6.2 3 7.5 6.4 6.3zm-16 40c5.4 1 12.4-1.7 10.4-13.6-1.9-11.3-10.2-14-10.8-11.4 4.8 1.7 4.1 17.7.5 25.1z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M396.8 918.1c5.3 1 13.7-2.1 9.9-13.8-3.7-11.5-12.2-10-12.8-7.2 4.7 1.9 6.5 13 2.8 21z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M376.7 918.2c3.9 3.4 13.9 4.7 17-6.9 3-10.9.3-14.4-3.6-16.1 2 5.6-5 21.6-13.4 23zm25.5-1c3.2-1.8 10.6-5 5.8-16-4-9-10.1-5.2-11.8-3.7 4.3 1.8 8.1 11.5 6 19.7z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M409.2 914.6c3-2 10.7-7 4.6-17.8-6.1-10.5-14.2-3.5-14.2-.7 3.5 1 9.6 10 9.7 18.5z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M416.7 907.3c2-2.8 7.2-9.8-.7-16.8a6.7 6.7 0 0 0-12 4.3c3.2-.5 10.6 5.2 12.7 12.5z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M421.2 896.3c.5-3.6 2-12.6-7-14.7-9-2-9.6 8.6-8.1 10.4 2.4-2.2 10.5-1 15 4.3zm-50.3 18.6c3.4 4.2 13.4 7 18.7-4.1 5-10.7 2.7-14.7-1-17.2 1 6.1-9 21.3-17.7 21.3z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M360.9 906.7c3.2 6.6 19.2 14 25.5 2 5.9-11.6 1-22.2-4-26.2 2.4 11.8-12 29.7-21.6 24.2z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M352.4 898.4c7.8 17.2 24.1 14.2 29.6 1.7 5.2-11.8 3.8-18.8-2.2-24.4-4 15.2-12.2 23.7-27.5 22.7z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M342 884c5.9 21.5 27 19 36 6.6 6.4-8.7 4.2-15.1 1-19-7 8.3-19 15.6-37.1 12.4z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M338 871c.6 21.8 26 24.3 37.4 11.7 8-8.8 7.3-15.4 5.2-19.3-8.4 8.4-25.3 18.4-42.6 7.5z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M332.7 850.2c-3.9 28.4 29.1 37.6 43.5 20.7 7.7-9 7.3-15.4 5.2-19.3-14.3 10-39.2 11.2-48.7-1.4z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M329.5 823.5c-9.5 30.7 19.2 41.6 38 38.6 14.9-2.4 23.2-20 21.1-23.8-18.6 13.1-55.4 1.8-59.2-14.7z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M329 799.7c-12.6 29.9 15.4 47.4 38.6 45.7 15.3-1.2 27.8-7.1 27.2-19.6-22.7 8-58.2-5.4-65.8-26.1z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M330 775c-12.7 30.5 14.7 55.6 43.4 56.3 14.7.3 21.4-3.6 27.2-13.3-20.7 3.5-64.9-28-70.6-43z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M329.6 765.3c-11.4 35.9 80.3 80.4 85 33.7-22 11.5-81.8-20.7-85-33.7z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M327.5 755.6c-15.4 19.8 93 78.2 95.5 28.4-9.7 5-29.8.7-49.2-8.1-19.4-8.8-33.2-22.9-46.3-20.3z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M311 751.1c19.6.5 61.3 31 89.3 36 17.8 3.3 32.4-4.2 24.1-35.5-28.5 29.1-83-17.8-111.8-6.8-3-1.4.7 8.4-1.6 6.3z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M314.7 755.5c19-11.8 58.4 10.1 86.2 11.3 17 .7 38.4-18.6 24.4-47-21.9 37.6-82.9 7.5-108.6 27.3-2 4.3-.9 10-2 8.4z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M307.1 756.8c20.2-14.8 61.6-6.2 88-8.4 17.6-1.4 43.8-32 19.9-57.5-14.9 53.9-64.5 27.3-107.3 58.3-2.1 5.5.8 8.9-.6 7.5z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M314.4 752c16.7-15.7 57.6-14.7 82-27.1 16.2-8.3 32.8-43.6 4.3-61.4-3 56.7-55.2 39-87.5 81-.7 6 2.8 8.4 1.2 7.5z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M316.1 744.5c12.4-22.1 50.3-27.6 70.8-46 18.4-16.5 23.4-46.4-7.6-56-2.6 59.3-43.8 46.8-60.7 82.3-3.2 7.8-1.6 20.5-2.5 19.7z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <path
          d="M325.5 722c12.7-20.2 22.2-13.3 42.4-34 17.3-17.7 22.6-60.3-7.8-61.3 4.5 51.5-15.3 52-29.2 79.7.5 6.1-3.6 16-5.4 15.5z"
          transform="matrix(.01896 -.24347 .22029 .02096 145.1 340.8)"
        />
        <g strokeWidth={3}>
          <path
            fillRule="evenodd"
            d="M310.4 602.7l-10.5 5.6L250 762.1l18.1 40 17.2 2.6L306 803l30.7-138.4 8.7-56.5-21-12.4-14 6.9z"
            transform="matrix(.01291 -.19952 .15288 .02036 190.6 323)"
          />
          <path
            d="M309.3 597.5l1.3 6.1c9.8-6.8 20.4-.2 23.3 15.6 2.9 15.8-3 39-13.7 56.7a167.2 167.2 0 0 0-17 56.2c-1.8 18.8 1.9 41.7-2.2 62.6-2.6 10-7.9 9.1-18.2 8.5 4.1 6.8 9.3 10.6 16 10.3 14.4-3.2 24.7-16.1 28.5-44.8a106 106 0 0 1 9.8-72 85.9 85.9 0 0 0 26.3-50 54 54 0 0 0-9.6-39.1c-11.5-17.4-20.8-18-29.6-16.4l-15 6.3z"
            transform="matrix(.01291 -.19952 .15288 .02036 190.6 323)"
          />
        </g>
        <path
          fillRule="evenodd"
          strokeWidth={0.5}
          d="M-325.7 629.7c0-3.1 2-5.6 4.5-5.6s4.5 2.5 4.5 5.6h-9z"
          transform="matrix(1.00994 .34063 .4261 -.98295 369.3 1013.3)"
        />
        <path
          d="M295.5 723c-3.8 7.3-11.3 10.6-16.7 7.5-5.4-3.2-6.7-11.7-3-19 3.8-7.3 11.3-10.6 16.8-7.4 5.4 3.1 6.7 11.7 2.9 19zm-19-82c-2.5-3.5-6.3-5.7-10.3-5a12 12 0 0 0-6.6 3.9l-.2-1c-1.4-7.7 4.8-16.8 11.4-18 3-.5 5.7.6 8 2.7a15.2 15.2 0 0 0-1.2 8.8 15.2 15.2 0 0 0 1 3.6 18.3 18.3 0 0 0-2 5z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M300.3 632.4c-2.9-3.6-6.7-5.8-11-5.2-4 .5-8 3.6-10.7 7.7a18.8 18.8 0 0 1-1.1-4.1c-1.4-9 6-19.1 13.7-20.2a9.8 9.8 0 0 1 5.6.8 15.6 15.6 0 0 0 0 4 18.3 18.3 0 0 0 5 10.2 18.6 18.6 0 0 0-1.5 6.8zm-42.3 45l-.4.6a14.5 14.5 0 0 1-8.5-4.7 13.4 13.4 0 0 0 9 4zm6.8-13.6a17 17 0 0 1-8.1-12.3c-1.4-8.7 5.8-18.6 13.3-19.6a9.1 9.1 0 0 1 2.2-.1 18.1 18.1 0 0 0-3.6 13c.4 2.8 1.5 5.4 3 7.6a20.8 20.8 0 0 0-6.8 11.3z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M258.3 689.2c-2 .6-4 .4-5.8-.8-4.4-2.9-5.6-10.5-2.6-17 3-6.3 9-9.2 13.3-6.3a9.3 9.3 0 0 1 3.6 5.1 7.5 7.5 0 0 0-5.4.4c-4.7 2.2-7.1 8.6-5.4 14.3a11 11 0 0 0 2.3 4.3z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M262.4 694c-3-1-5.8-3.5-7.4-7.3-3-7-.9-15.6 4.7-19.2a9.6 9.6 0 0 1 9-.9 17.5 17.5 0 0 0 1.1 9.7 12.7 12.7 0 0 0 6.2 6.7 9.6 9.6 0 0 0-7.7 1.3 14 14 0 0 0-5.9 9.6zm-5.1 49.4c-7-4.5-11.4-14-9.7-21.1 1.4-6 6.7-8.4 12.5-6.4a25.9 25.9 0 0 0-1.4 18.2 19 19 0 0 0 8 11.4c-2.7.7-6 0-9.4-2.1z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M251.7 770a12.3 12.3 0 0 1-1-1c-5.6-6.5-7-16.9-3.2-23 3.7-5.8 10.7-6 16.3-.7-3 6.5-2.3 15.4 1.6 22.2a11.9 11.9 0 0 0-10.3.2 14.1 14.1 0 0 0-3.4 2.2z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M268 783.8c-5.3-.3-10.6-6.3-12.4-14.5-2-9.1 1.3-17.6 7.3-18.9h.3c2.8 4.7 7.1 7.5 11.7 7.7v.2c-6.6 4.6-9.8 15.3-7 25l.2.5zm-2.8-66.2c-6.6 2-14.4-2.7-17.5-10.7-3-8 0-16.3 6.5-18.4 1.7-.5 3.5-.6 5.3-.3 1.5 4.7 4.3 8.4 7.6 10.5a26 26 0 0 0 1 17.5 10.8 10.8 0 0 1-2.9 1.4z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M270 727.9c-7-4.5-11.4-14-9.7-21.1 1.6-7.1 8.7-9.3 15.7-4.8a21.5 21.5 0 0 1 5.4 5 25 25 0 0 0-3 23.1c-2.6.4-5.5-.3-8.5-2.2z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M284.7 750.9c-3.7 7.6-11.2 10.5-16.7 6.3-5.5-4-7-13.7-3.3-21.3 3.7-7.7 11.2-10.5 16.7-6.4s7 13.7 3.3 21.4zm-9.3-47.8a12.2 12.2 0 0 1-11.2.4c-6.2-3.4-7.6-12.5-3.2-20.4a18 18 0 0 1 13.4-9.4 9.7 9.7 0 0 0 7.9 2.6l.5.5c-8 3.4-12.2 13.3-9.4 22a16 16 0 0 0 2 4.3z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M284.2 666c1.2 8-4.1 15.3-10.5 16.2-6.3.9-12.4-4.8-13.7-12.8a17.6 17.6 0 0 1 5.8-15c2.7 4.3 7 6.9 11.4 6.3 1.6-.3 3.2-.9 4.6-1.9a23.1 23.1 0 0 1 2.4 7.2z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M287.2 705.7c-5.7 3-12.2-1.4-14.5-9.6-2.3-8.3.5-17.5 6.2-20.4a8 8 0 0 1 5.4-.8 25.5 25.5 0 0 0-1.7 3.6c-3.4 9-1.7 20 3.8 24.3.9.7 1.8 1.2 2.8 1.5a10 10 0 0 1-2 1.4z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M304.5 668a14 14 0 0 1-1 7.8c-5.3-3.2-12.2 0-16 7.3a15 15 0 0 1-8.3-11.6c-1.2-7.7 5-16.4 11.7-17.4v1c1.2 7.4 7.2 12.9 13.6 12.4v.4z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M303.5 696.7c-4.3 9.2-12.9 13.3-19.2 9.2-6.3-4.2-8-15.1-3.7-24.4 4.2-9.2 12.9-13.4 19.2-9.2 6.3 4.2 8 15.1 3.7 24.4zm-14.1-41.5a14.8 14.8 0 0 1-6.4 6.9c-6.3 3.1-14-.3-17-7.8-3.1-7.4 1-18.5 7.2-21.7a9.2 9.2 0 0 1 8.2 0l-.1.6c-1.7 9.7 2 19.1 8 22zm31.2-41a14 14 0 0 1-.9 7.4c-2.5-3.1-5.8-5-9.4-4.5-4.4.6-8.6 4.6-10.7 9.4a15.9 15.9 0 0 1-4.4-8.8c-1.2-7.8 5.2-16.6 11.9-17.6 6.6-.9 12.3 6.2 13.5 14z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M322.4 630.6c1 6.6-3.1 12.8-8.5 14.7-2.4-3.5-5.9-5.7-9.6-5.1a9.6 9.6 0 0 0-2.9.8 15.3 15.3 0 0 1-3-7c-1.1-7.3 5-15.7 11.3-16.6 6.3-.9 11.7 5.9 12.8 13.2z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M293.2 654.4a8.5 8.5 0 0 1-9.4.2c-5.1-3.4-6.5-12.3-3-19.8 3.4-7.4 10.4-10.8 15.5-7.4a12 12 0 0 1 4.8 9c-5.1 3.8-9 11.1-8 17.7l.1.3zm-36.7 144.3c-5.8 2-12.1-2.4-14.4-10.5-2.4-8.7.6-18.3 6.6-21.4 5.7-2.9 12.2 1 15 8.5-6.2 4.5-9.3 14.2-7.2 23.3z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M270.6 803.8c-6.3 2.8-13.2-1.1-15.5-8.8-2.3-7.7 1-16.3 7.3-19.2 5.4-2.5 11.4 0 14.4 5.7a21.6 21.6 0 0 0-6.2 22.3z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M267.6 818c-5.7 2.5-12-1-14-7.9a15.9 15.9 0 0 1 1.9-13.3c4 3.4 9 4.4 13.8 2.1a14.5 14.5 0 0 0 3-2 14.3 14.3 0 0 1 1.7 3.8c.8 2.4.9 4.9.5 7.2a20.6 20.6 0 0 0-4.6 8.5c-.7.6-1.5 1.1-2.3 1.5zm8.5 29.3c-6.4 2.9-13.5-1-15.8-8.8-2.3-7.8 1-16.5 7.3-19.4l1.5-.5a26.6 26.6 0 0 0 .9 9.4c2 7.2 6.9 12 12.3 13a13.3 13.3 0 0 1-6.2 6.3z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M285.2 848.4c-6.2 2.8-13-1-15.2-8.4a17.7 17.7 0 0 1 0-10c4 3.6 9.2 4.7 14 2.4a16 16 0 0 0 6.6-6.2 16.6 16.6 0 0 1 1.6 3.6c2.3 7.4-.9 15.8-7 18.6z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M293.1 863.4c-6.1 2.8-13-1-15.2-8.5a17.8 17.8 0 0 1-.6-6.2c2.3.4 4.8 0 7.2-1a18 18 0 0 0 8.9-11.4c3 1.4 5.6 4.4 6.8 8.4 2.2 7.5-1 15.8-7 18.7zM273 786c-2.8-1.8-5-4.8-6.3-8.6-2.4-8.3 1-17.5 7.8-20.6 6.8-3.2 14.3 1 16.8 9.3 1.9 6.2.4 13-3.5 17.4a11 11 0 0 0-10.5-.8c-1.7.8-3.1 1.9-4.3 3.3zm46.8-134.5c1 6.6-5.5 17-12.1 18.4-6.7 1.4-11-1.9-14-6.2-3-4.4-4.3-10-2.6-15.2 1.7-5.2 6-10.4 10.4-12.3 4.4-2 7.4-1.2 11 1.7 3.5 3 6.3 7 7.3 13.6z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M285.2 808.6c-6.2 2.8-13-1-15.2-8.5-2.3-7.5.9-15.8 7-18.7 6.1-2.7 13 1 15.2 8.5 2.2 7.5-1 15.9-7 18.7z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
        <path
          d="M283.1 834.2c-6 2.7-12.8-1-15-8.4-2.2-7.3 1-15.6 7-18.4 6-2.8 12.8 1 15 8.4 2.2 7.3-.9 15.6-7 18.4z"
          transform="matrix(.01896 -.24408 .22029 .01391 146.3 342)"
        />
      </g>
    </g>
    <path
      fill="#e7ca00"
      stroke="#d4af37"
      strokeWidth={0.5}
      d="M291 194.8l-.4.5-14 17.5-.4.3.4.4a25.8 25.8 0 0 1 7.1 17.5 53.1 53.1 0 0 1-2.7 17.4c-2 6.5-4.8 12.3-5.6 21.9a22.5 22.5 0 0 0 5.2 16.6 29 29 0 0 0 9.7 7.6c7.3 3.5 14.8 2.3 22.4 3.2 3.3.5 5.2 2.6 7 4.4l.3.4.4-.4c1.7-1.8 3.6-4 7-4.4 7.4-1 15 .3 22.3-3.2a29.4 29.4 0 0 0 9.7-7.6c3.3-4 5.8-9.5 5.2-16.6-.8-9.6-3.5-15.4-5.6-22a53 53 0 0 1-2.7-17.3c0-5.9 2.6-13.2 7.1-17.5l.4-.4-.3-.3-14.1-17.5-.4-.5-.4.4a19.8 19.8 0 0 1-14.2 5c-5-.3-10-2.1-14.1-4.7l-.3-.2-.3.2a29.8 29.8 0 0 1-14 4.6 19.8 19.8 0 0 1-14.3-4.9l-.5-.4zm.1 1.5a21 21 0 0 0 14.6 4.9 30.4 30.4 0 0 0 13.8-4.3V248h-37.3a54 54 0 0 0 2.6-17.1c0-6-2.6-13.3-7.1-18l13.4-16.7zm57.8 0l13.4 16.8a26.9 26.9 0 0 0-7.1 17.9 54 54 0 0 0 2.6 17.1h-37.3V197a30.4 30.4 0 0 0 13.8 4.3 21 21 0 0 0 14.6-4.8zm-67 52.9H358c2.1 6.4 4.6 12 5.4 21.1a21.4 21.4 0 0 1-5 16 28.4 28.4 0 0 1-9.3 7.2c-7 3.3-14.3 2.2-22 3.2-3.5.4-5.6 2.5-7.2 4.3-1.7-1.8-3.7-3.9-7.2-4.3-7.7-1-15 .1-22-3.2-2.3-1-6.2-3.4-9.4-7.3s-5.6-9-5-15.9c.8-9.1 3.4-14.7 5.4-21.1z"
    />
    <g fill="#008f4c">
      <path
        fill="#00a854"
        d="M373.3 171.4l-.1.1-.6 4.2-.5 3.6-2.4-1c-3.1-1.4-9.5-2.1-10-1.2-.1.6.6 4 1.7 8 .3.8 0 1-1.8 1.6-1.3.4-2.6 1-3.1 1.4-1 .6-.8.8 1.4 2.8l2.4 2.1-1.2 1c-1 .8-1 .8 2.8 4.5 4.3 4 6.5 5.2 9.4 5.2.9 0 1.9.2 2.6 0 1-.2 1.7-.5 4-.7 2.6.2 5 1.4 6 2l.6 1.4c-1.8-2-5.8-2.7-6.6-2.8-.8 0-1.2.2-2.1.5s-1.3.7-2.1 1.9c-.6 1.5.6 3.1 2 3.3 1.9.3 3.2-.7 3.2-2.4 0-1.3-.7-2.3-.1-2.3 2.2.2 5.6 2 6.2 4.2.8 2.8.6 3-.7 1a12.8 12.8 0 0 0-3.9-3.4c-.4 0-1.5 2.5-1.5 3.6 0 .8-.2 1-.8.7-.5-.3-1.6-.5-2.5-.6l-1.6-.3.4 2.5c.2 1.4.9 3.5 1.4 4.6l1.1 2-2.4-.7c-5.3-1.6-4.9-1.7-4.5 1 .1 1.4.4 3 .6 3.4.3.7 0 .9-1.8.9-1.1 0-2 .1-2 .3 0 1.1 4 6.6 6.1 8.2 2.5 2 7.2 4 9 4 .7 0 2.3.5 3.9 1l2.8 1v3.1c0 3.3-1 10-1.6 10-.1 0-1-1.4-2-3.2-2-3.8-2-3.7-2.5-2.8-.4.6-.5.5-.5-.3a17 17 0 0 0-3.8-7.3l-1.2-1.1-.7 1.3-.6 1.3-2.7-3c-1.5-1.6-3-2.9-3.1-2.7-.3 0-.6 1.4-.8 3-.5 4.3-.7 4.6-2.4 3l-1.4-1.4-.4 1.3a40 40 0 0 0 1.2 13.9 48.8 48.8 0 0 1 1.7 6.4c.6 3.8 2.8 8 5.5 10.8 1 1 1 1.4.5 1.4-.4 0-1.2.4-1.6.9-2 2.1-.2 5 2.8 4.4 1.5-.2 1.8-.1 2.3 1 .8 1.6.8 4.5.1 5.7-.5 1-3.5 2.2-4 1.7-.1-.1-.2-1.8-.2-3.7v-3.5l-2.5 1.4a29.7 29.7 0 0 0-12.9 18.4c-.4 2.2-1.7 2.4-3.3 5a20.1 20.1 0 0 0-4.5 3.6c-2.5 2.4-3.2 2.8-7 3.7-4.7 1.2-14.7 2.8-22.2 3.6-6.5.6-27.1 4-28.4 4.5a90 90 0 0 1-3 1.2 6.8 6.8 0 0 0-2.6 2c-.8 1.1-.8 1.5-.2 2.5 1.3 2.6 4 2.5 9.6-.2a31 31 0 0 1 7.8-2.5c2-.3 4.9-1 6.4-1.3 1.5-.4 5.8-1.1 9.4-1.7a199 199 0 0 0 36.4-7.8c5.6-2 5.5-2 10.7-1.5 5.8.6 13-1.2 16-4 .7-.5 2.4-2.6 4-4.6 1.4-2 3.3-4 4-4.5 1.9-1.3.8-1.7-4.2-1.7h-4.2l1.5-3.1c1.6-3.6 3.3-8.4 3-8.7-.1-.1-1.6 0-3.2.5-1.7.3-3.1.6-3.2.5l.4-1.7c.4-1 1-1.7 1.9-1.9l2-.5a7 7 0 0 1 2.7.3c1.8.5 1.9.6 1.6 2.2-.2 2 .8 3.3 2.6 3.3 1.4 0 2.9-1.4 2.9-2.6 0-1.4-2-3-3.2-2.7a11 11 0 0 1-3.9-.6l-2.7-1 2.6-.5c4-.9 5.3-.7 6 .5.3.8 1 1.2 2 1.3 3.2.3 4.3-4.2 1.2-5.2-1.1-.3-3.6.9-3.6 1.8 0 .3-.8.5-1.8.5a17.3 17.3 0 0 0-6 1.1l3.9-1.9a60 60 0 0 0 6.7-2.5c4.6-2 9-7.3 10.7-12.3a54 54 0 0 0 2.2-13c-.3 0-2 .6-3.7 1.4-3.3 1.5-3.3 1.5-3.3.4 0-2 .9-8.1 1.2-9 .3-.5.2-.8-.3-.8a28 28 0 0 0-9.7 5.3c-3 2.5-3.4 2.6-3.4 1.6 0-.7.5-2 1-2.8 1-1.5 1.2-1.6 3-1.3 1.8.3 2 .1 2.8-1 1.1-1.6.5-3.6-1.2-4.1-1-.3-.9-.5 1-1.4a16 16 0 0 0 6.5-7l1.2-2-1.8.2c-1 0-1.8.2-1.8 0l.7-2.1c.4-1.2.8-3 .8-4.2 0-2-1.9-9.8-2.6-10.6-.3-.3-1.3.2-2.4 1.1l-2 1.6-1.9-4.1a58.7 58.7 0 0 0-2-4.3c-.2-.2-.8.3-1.6 1-1.5 1.4-1.6.6-.3-2.4 1.3-2.6 1.8-3 3.2-2 1.8 1 3.7 0 3.9-2 .1-1.3-.1-1.8-1-2.5-.7-.4-1.6-.6-2-.5-.5.2-1-.2-1.3-1.2a2.9 2.9 0 0 0-1.9-1.8c-2.6-.7-4.5 2.6-2.5 4.5.7.7.7 1.3.2 5-1 5.9-1.3 6.4-2 3.8-.8-3-.4-11.2.6-13.6 1.9-4.2.8-10.8-2.2-14.2a35.4 35.4 0 0 0-10.7-7.7zm-3.5 13.8a21 21 0 0 1 5.4 5.2c2.6 3 5.6 8.3 7.6 12.3-.7-.8-1.1-.9-3.2-3.7-1.6-2.3-4.4-7.4-7-10-2.3-2.4-3.2-3.8-2.9-3.8z"
      />
      <path d="M382.5 239c-.5 2-.9 2.3.1 3.8.5.7 1.3 1 2.2 1 1.4 0 2.1 1 3.3 4.6.1.6.3.6.3-.1 0-.6-.4-1.8-1-3-.6-1.1-.8-2-.5-2.2 1-.6.5-3.1-.6-4-1.6-1-2.1-.7-3.8 0z" />
    </g>
    <path
      fill="#9eab05"
      d="M288.6 321.4c-1 .9-1.3 2.2-.5 3 1.1 1.2 5.1.1 5.6-1.4.5-2.2-2.9-3.3-5-1.6z"
    />
    <path
      fill="#75b52b"
      d="M374.5 175.6a27 27 0 0 0 4.7 9.7c.7 1 1.4 1.6 1.6 1.5 0-.2-1.3-3.2-3.2-6.7-2.6-5-3.4-6-3.1-4.5zm-17 13.5a27 27 0 0 0 8.2 2.3c0-.9-2.4-2-5.3-2.3-1.7-.2-3-.2-2.8 0zm3.2 6.1c.6.6 9.5 4.7 12 5.5 1.4.5 3.4.8 4.3.7 1.5-.2 1.3-.3-1.9-1.3a53 53 0 0 1-5.8-2.4c-3-1.5-9.5-3.4-8.6-2.5zm29 13a93 93 0 0 0-2.4 15c-.3 3.3-.2 4.4.4 5.1.6.9.8.5 1.3-4a194 194 0 0 0 1.4-17.7c-.1 0-.5.6-.8 1.5zm-8.6 4c.2 4.1 2 8.4 2.6 6.5a15 15 0 0 0-1.2-5.5l-1.6-4.4.2 3.5zm-5.7.2l1.8 2.3 1.2 1.5v-1.3a3 3 0 0 0-1.3-2.3c-1.6-1.3-2.6-1.4-1.7-.2zm-7.2 12.4a76 76 0 0 0 7.4 5.6c1.5 1 1.5 1-.4-1.3-2-2.3-5-4.5-6.3-4.5-.4 0-.7 0-.7.2zm2.8 10.8c1.4 5.6 2.4 8.8 3 9.1.3.2.6.4.7.3.2-.3-2.4-8-3.2-9.3l-.8-1.3.3 1.2zm5.9 4.4c0 .8.4 2.3 1 3.4.5 1.1.9 1.7.8 1.2l-.6-3.1c-.4-2.7-1.2-3.7-1.2-1.5zm-10.3 3.8c1 3.2 3.4 8.2 7 14 2.5 4.2 2.5 4.2 2.7 2.4 0-1.4-.4-2.6-2.3-5.8a534.9 534.9 0 0 1-5-8.6 22.5 22.5 0 0 0-2.9-4.6c-.2 0 0 1.2.5 2.6zm31.5.7a75.5 75.5 0 0 0-8.2 11.5c-.5 1-.6 2-.4 2.8.3 1.2 1 .3 6-7.7 3.1-5 5.5-9 5.3-9-.3 0-1.4 1.1-2.7 2.4zm-8 37.3a2 2 0 0 0 1.8 3c1.5 0 2.4-1.7 1.6-3.1-.6-1.2-2.8-1.1-3.4.1z"
    />
    <path
      fill="#d91023"
      d="M375.1 205.2c-1.9 1.3.1 4.7 2.2 3.5 1.2-.8 1.4-2.7.3-3.5a4.2 4.2 0 0 0-1.2-.7l-1.3.7zm13.3-10.9c-1.1.3-1.6 1.9-.8 3.2 1 1.8 3.5 1 3.5-1 0-1.6-1.2-2.5-2.6-2.2zm3.4 3.9c-.2.4-.2 1.2 0 1.9 0 .9.4 1.1 1.5 1.1 1.9 0 2.9-1.3 2-2.6-.7-1.1-3-1.4-3.5-.4zm-19 75c-2 1.5-.1 4.2 2.2 3.3 1-.4 1.5-1.6.9-2.7-.7-1.4-1.9-1.6-3.1-.6zm10.3-33.6c-.6.5-.4 2.4.2 3 1.6 1.6 3.8 0 3.3-2.1-.3-1-.7-1.3-1.8-1.3-.7 0-1.6.2-1.7.4zm9.4 0c-.4 1.4.5 2.7 1.8 2.7s2.2-1.2 2-2.6c-.1-1-.5-1.2-1.8-1.3-1.4-.2-1.7 0-2 1.1zm1.3 37c-.3 1.4.5 2.7 1.9 2.7 1.2 0 2.1-1.2 1.9-2.6-.1-.9-.5-1.2-1.8-1.3-1.4-.1-1.7 0-2 1.2zm-3 4.6c-2 1.5-.2 4.2 2.2 3.3 1-.4 1.4-1.6.8-2.7-.7-1.4-1.8-1.6-3-.6z"
    />
    <path
      fill="#75b52b"
      d="M369.7 185.6l2.2 2.6a59 59 0 0 1 6.2 8.5c2 3.2 4.5 6.4 4.5 5.8 0-.6-4.5-8.2-6.2-10.5-2.4-3.2-6.1-7-6.8-7-.2 0-.1.2.1.6z"
    />
    <path
      fill="#eac102"
      fillOpacity={0.5}
      d="M382.7 249c0 .4-.6 3.8-.8 7.7a157.5 157.5 0 0 1-3 25.7l.1.9.9-1.2c.9-1.2 1.8-2.1 3.1-3a145.4 145.4 0 0 0 17-19.4c5.2-6.8 6.4-8.6 6.3-8.7-.2-.2-1.8 1.4-8.2 9.3a244 244 0 0 1-6.6 7.7c-4.5 5-9.5 9.5-10.8 11.3l.4-2.1a93 93 0 0 0 1.8-20.6v-8.2l-.2.6zM370 282.2l-2.7 4.7a69 69 0 0 1-10.4 14.6c-1 1-.7 1.2-1 1.4-1.2 1.2 3.6 2 7.3 2.5 4.9.4 7.6-.5 20.7-7.5 3-1.6 3.9-2 3.3-2a35 35 0 0 0-8.8 3.4c-5.6 2.6-8 3.8-10.6 4.3-2 .5-4.8.5-6.5.1h-1.2l.6-.3c.6 0 1.3-.1 1.6-.3.3-.3 1.3-1 2.3-1.5a82.5 82.5 0 0 0 16-14 39 39 0 0 0-5.5 4.3 46.9 46.9 0 0 1-15 10.1l-.9.2.8-.8 2.3-3.3a63.5 63.5 0 0 0 8.5-17l-.8 1.1zm.2-64.8a55 55 0 0 0 5.7 7.2c3.2 3.6 5 5 7.5 8.2 2.6 3.2 2.8 3.4 5.6 6 3.5-4.7 5.7-11 7.2-15 1.4-3.9 2.6-7.3 2.7-12.5-2 4.4-2.1 6-3.7 10.7-1.6 4.8-5 13-6.4 14.8-.1.2-7.4-8.8-10.6-12.5-3.4-4-8-7.3-8-6.9z"
    />
    <path
      fill="#cab313"
      fillOpacity={0.5}
      d="M372.7 174.8l-.6 4.5-1.9-.9c-1.9-.9-6.9-2-9.3-2-1.3 0-1.4.2-1.1 1.7.3 1.6 1.6 6.2 2 7.2.1.3-.7.8-2 1.1a11 11 0 0 0-3 1.4c-1 .7-.8.8 1.1 2.5 2.3 2 2.5 2.7 1.2 3.6-.7.5-.4 1 3 4.2 2 2 4.6 4 5.6 4.6 2.6 1.3 7.7 1.3 10.4 0 1.9-1 2-1 3.2-.2 1.3.8 1.3.8.7 0a30 30 0 0 0-5.3-3.2 32 32 0 0 1-15.3-17c-1.2-3.5-1.2-5.3 0-5.3 2.2 0 6.6 1 9 2.2 3.8 1.7 10.4 8 12.3 11.7 1.3 2.6 1.4 3.5 1.5 7.3 0 4.5.7 6.3.8 2.3.2-5 .4-6.2 1.1-8.2 1.6-3.7.8-9.4-1.7-12.8a36 36 0 0 0-6-5.1 41 41 0 0 1-4.7-3.6c-.2-.3-.7 1.5-1 4zm6.5.8c3.4 2.3 4.4 3.3 5.5 5.5 1.6 3.4 2 7.5 1.2 10.5l-.7 2.2-1.4-2.8a27 27 0 0 0-5.7-7.1 30.5 30.5 0 0 0-5-4.4c-.5 0-.3-3.4.5-6.4.3-1.3 0-1.5 5.6 2.5zm-16.4 12.3a8 8 0 0 0 1.8 2c.5.4 1 1.1 1.1 1.7.3.9 0 1-2.3 1-2.4 0-2.8-.2-4.7-2-1-1.1-1.9-2.1-1.7-2.2.4-.4 3.7-1.8 4.3-1.9.4 0 1 .6 1.5 1.4zm6.8 7.8c3 2.7 3.8 3.3 7.4 4.7 1.9.8 2 .9 1.2 1.6-1.1 1.1-6.7 1.5-9.3.7-2.2-.7-10.1-7.9-9.3-8.4a14 14 0 0 1 5.4-1.2c1.4 0 2.3.5 4.6 2.6zm14.7 9.3c-.2.2 0 1.4.4 2.5 1 2.5 1 3.3 0 5a10 10 0 0 0-.8 3.5 12 12 0 0 1-.6 3.6l-.5 1.6-1.7-1a5 5 0 0 1-2-2.2c-.4-1.5-.2-4.7.4-7.8.5-2.1.8-2.7 1.5-2.7.8.1.8 0 .3-.6-.5-.7-.7-.7-1.3.1a7 7 0 0 0-1 2.5c-.3 1.7-.3 1.7-1.7 1-2.2-1.2-3-1-3 .7s.8 4.3 1.9 6c1.2 1.7 1.2 1 0-1.3-1.3-2.7-1.8-5.7-.9-5.7.4 0 1.2.4 1.9.8.9.6 1 1.2 1 4.2-.1 4-.5 4.2-5.3 2.6-1.5-.6-3-1-3.1-.8-.2.2.6 4.5 1.1 5.8.3.6-.1.8-2 .6l-2.4-.2 1.4 2.4a20 20 0 0 0 14 10.1c2 .4 4.4 1.1 5.3 1.6 1.2.6 1.4.6 1 0-.3-.3-1.5-1-2.6-1.3-2.9-1-5.7-3.1-9.4-7s-5.5-7.1-5.5-9.6c0-1.4.2-1.7.8-1.4l3.9 1c4.3 1.2 5.4 1.8 8.1 4.7 3 3.1 3.9 5 4.8 9 .4 1.9.8 3.4 1 3.6.6.7.8-1.6.2-3.6-.9-3.3.5-9.8 3.4-15.5 1.3-2.5 5.2-6.3 5.8-5.6.2.2.9 2.4 1.5 4.8 1.4 5.1 1.2 6.6-1.2 11.7a18.5 18.5 0 0 1-6.1 7.7c-2 1.4-1.5 1.8 1.3 1.1 2.4-.6 6.4-4.2 8.5-7.7l1.1-2-2 .4-2 .3 1-2.7c1.2-3.4 1.2-4.7 0-8.8l-1.3-4.8-.3-1.4-1.7 1.1a9.4 9.4 0 0 0-1.9 1.6c-.6.9-1.3-.1-3-4l-2-3.7c-.3 0-1.1.6-1.9 1.4l-1.3 1.4.3-1.4c.3-1 .2-1.4-.2-1.1-.2 0-.5.8-.5 1.4 0 2.4-.9 2.4-1.6 0-.4-1.3-.9-2.2-1-2zm7.4 12.7a31.5 31.5 0 0 0-2.9 8.3l-.6 3.6-.8-2a17.6 17.6 0 0 0-2.2-3.7c-1.4-1.6-1.4-1.7-.8-5.3.9-5.7 2-8.7 4-11l1.9-2 1.8 3.7 2 3.7-2.4 4.7zm-19.3 8.3c6.2 6.5 8.4 9 7.3 8.6a17.4 17.4 0 0 1-10.3-7.5 19.5 19.5 0 0 1-1.8-3c0-.2.6-.3 1.4-.3.9 0 2 .7 3.4 2.2zm29 4c-2 3.2-3.3 4.4-5.5 5.5l-2 1 2-2.1a32.5 32.5 0 0 0 3.2-4.1c1-1.6 1.7-2.1 3.3-2.4.2 0-.2 1-1 2z"
    />
    <path
      fill="#005000"
      d="M382.9 209c.7 1.5 2 3 2 2.5 0-.3-.5-1.2-1.3-2-.7-.9-1-1-.7-.5z"
    />
    <path
      fill="#cab313"
      fillOpacity={0.5}
      d="M369.4 235.3l-.8 3.8-.5 2-1.5-1.4-1.4-1.4-.4 2.4a32 32 0 0 0 1.5 12.8 52 52 0 0 1 1.6 6.4c.6 4.6 4.4 10 9.4 13.4.9.7 1.2 1.5 1.5 3.8l.4 3v-2.9a64.6 64.6 0 0 0-1.4-8.3c-1.6-7.3-1-10.4 2.6-17.8l2.6-5.4 2.7 5.4c3.6 7.2 4 9.7 2 15.6a33.4 33.4 0 0 1-1.8 4.8c-.3.4-.4.8-.3 1.1.2.2 0 .7-.2 1.1-.4.6-.5.6-.2-.2.2-.6-.5 0-1.7 1.2a13.6 13.6 0 0 0-2.3 3.3c-.3.9-.2.9.6-.1l1.8-2.4c.5-.7 1.1-1.2 1.3-1 .8.4 1.5-1 3.2-5.6a28 28 0 0 1 7-12.4 27 27 0 0 1 7.8-5.2l5-2.3c.5 0-1 8.8-2 11.4a26.1 26.1 0 0 1-5.8 9.4c-2.2 2-6.4 4-10.5 5.2-1.7.5-3.3 1-3.4 1.3-.3.4 3.7-.7 7.5-2 5.4-2 10.5-7.3 12.5-12.8 1-2.5 3-13 2.5-13.3 0 0-1.7.6-3.8 1.6l-3.6 1.7.3-3.4c.2-1.9.6-4.4 1-5.8.5-2.3.5-2.4-.5-2a32 32 0 0 0-10 6l-3 2.7.2-4.7c.2-3 0-4.3-.2-3.6-.3.6-.5 2-.5 3.3 0 2.5-1.2 7.5-1.7 7.5-.2 0-1-1.4-2-3.2-1.7-3.2-2.4-4-2.5-2.7 0 .3-.5-.7-1.2-2.4a22.5 22.5 0 0 0-2.6-5l-1.5-1.9-.8 1.6-.8 1.5-2-2.5c-1-1.4-2.4-2.7-2.9-3-.8-.5-1-.2-1.2 1.4zm3.5 1.5c2 2.4 6.2 10.4 6.7 12.7l.3 1.3-.9-1.3c-1.6-2.3-6-6.3-8.8-7.8-1.3-.8-1.3-1-1-2.7l.7-3.2c.2-.8.5-1.4.7-1.4a13 13 0 0 1 2.3 2.4zm7 5c1.5 3 1.8 5 1 6.2-.6 1-4.8-7.7-4.4-9.4.3-1 .5-1.2 1.2-.6.4.4 1.4 2 2.3 3.7zm-9 1.5a25 25 0 0 1 7.5 7.4c.4 1 .3 1.7-.5 3.3a24 24 0 0 0-1.6 11.8v2.9c-.7 0-4.4-4.7-6-7.6a38.3 38.3 0 0 1-5-19.8l.4-2 1 1c.7.6 2.6 2 4.3 3zm30.8 0a75.1 75.1 0 0 0-.7 5.2c-.3 2.7-.4 2.8-3.3 4.7a23.9 23.9 0 0 0-5.2 4.6c-1.2 1.5-2.3 2.7-2.5 2.5-.3 0-.6-1.3-.8-2.6a20.8 20.8 0 0 0-1-4c-.6-1.6-.6-2 .4-3.3 2.1-3 11.2-9.4 13.2-9.4.2 0 .1 1 0 2.3zM374.4 268c1.8 1.9 3 3.4 2.8 4 0 .7-.7.4-2.7-1.6a19 19 0 0 1-5.6-8.5c-.3-1.3-.1-1.2 1 .7a30 30 0 0 0 4.5 5.4z"
    />
    <path
      fill="#cab313"
      fillOpacity={0.5}
      d="M369.4 280.5a31.6 31.6 0 0 0-11.6 17.4c0 1.6-1.8 3-1.5 2.8.2.7 1.8 0 2.5-2.5 1.3-4.7 5-13.2 9.9-16.6 1.4-1 3-1.8 3.2-1.8.2 0 .3 1.9.2 4.3 0 3.4-.4 5-1.4 6.9a28 28 0 0 1-8.5 9.3c-2.5 1.4-2.7 2-.4 1.1 2.5-1 8.4-7 10-10.3.8-1.7 1.4-3.3 1.4-3.7 0-.3.7-.9 1.5-1.2 1.8-.7 11-3 11.1-2.7.4.4-3.5 8.6-4.7 10.2-2 2.5-6.6 6-8.9 6.7-1 .3-3.4 1.6-5 1.9l-4.6.6-1.8 1 1.8-.3 5.3-.6c5.6-2 7.8-3.2 11.4-6l2.4-2 4.6.2 3.7.3-1.7 2.1a481.4 481.4 0 0 0-4 4.8 17.5 17.5 0 0 1-3.7 3.7 29.4 29.4 0 0 1-12.3 2.5c-4 0-4.2 0-6.2-1.8-2.1-1.8-3-2.2-3.2-1.4 0 .3-1.9 1-3.8 1.8-4 1.3-4.9 1-2.6-1.1.9-.8 1.8-.8 3.6-1 0 0 3.9 1 4 .1 0-.8-4-.7-4-.7-1.7.1-2.2 0-.7-1.8 1.6-1 2.3-3.1 1.4-2.7-2.2 2.7-3.7 3.8-7 7a18.3 18.3 0 0 1-8 3.6c-2.8.7-7.5 1.4-10.2 1.8-5.4.6-7.6 2-2.5 1 2.6-.5 6-.8 10.3-1.6 6.1-1.5 6.5-1.6 9.6-3.2 2.5-2.6 2.9-2.9 1.6-.8-.5 1.6.3 1.5 5.2-.3 3.8-1.5 4-1.5 5-.6.9 1 .8 1-1.1 1.8a124 124 0 0 1-20.4 5.6c-4.7 1-8.6 1.8-8.8 2-.4.4 5.6-.2 6.8-.8.6-.2 4.8-1.3 9.5-2.3 4.6-1.1 9.9-2.7 11.8-3.4 3.1-1.3 3.6-1.3 6.3-.8 3.4.6 9.1 0 13.2-1.3 3.2-1 5.4-2.9 8.6-7.4 1.3-1.9 3-3.8 3.7-4.3l1.3-1-4.4-.3c-2.5-.1-4.6-.4-4.7-.5a87 87 0 0 0 3-7.4l1.4-4.2-1.8.4-3.5.6-1.8.3.7-1.8c.4-1 .7-1.8.5-1.8l-1 1.7c-.8 2-1.8 2.4-1.5.6.2-.8 0-.6-.6.5a5.5 5.5 0 0 1-2.2 2.1l-2.2.8c-1 .5-1 .2-.8-3.4.1-2.4 0-3.9-.3-3.9s-1.7.8-3.1 1.8z"
    />
    <path
      fill="#cab313"
      fillOpacity={0.5}
      d="M321.8 313.9c-3 .2-9 1.1-18.9 2.7l-10 1.6c-.4 0-.5.2-.4.4.1.2-.6.5-1.5.7-2.3.4-4.9 2.5-4.9 4 0 1.4 1.7 3 3 2.7.7-.2.7-.3-.2-.3-2.2-.1-3-2.8-1.4-4.3 1.5-1.3 8.2-3.3 12-3.6a212.6 212.6 0 0 0 23.6-3.6c3.3-.5 2.7-.7-1.3-.3z"
    />
    <path
      fill="#cab313"
      fillOpacity={0.5}
      d="M313.4 318.8a80.2 80.2 0 0 0-17.6 4.6c-3.6 1.8-3.1 2 .7.2a32 32 0 0 1 6.8-2l9.3-1.8 8.7-1.7 2.8-.4h-2.3c-1.3 0-5 .4-8.4 1z"
    />
    <path
      fill="#fff"
      d="M353.6 305.4c-1.7 1-3.3 2.8-1.5 2.6 1.4-.2 6.4-1.7 6.8-2.7-2 .2-3.5-.3-5.3 0z"
    />
    <g stroke="#d4af37" strokeWidth={0.9}>
      <path
        fill="#fff"
        d="M367.7 432.4c-1.5.5-2.5 1-9 .5-4.6-.3-10.3-1.1-13.2-1.2-5.6 0-5.6.3-15.5 7.1-7 4.8-16 4.4-22.7 3-4-2-5.8-2.3-5.2-1.3 1.1 1.8 9 4.4 13.4 4.4 7 0 12.2-1.8 20.7-7.1 6.6-4.2 9.5-4.5 18.5-2.5 10.6 2.1 12.2 1.2 20.9-2.7-2.6 0-3.2 0-4 .4 1.4-1.6 1.5-3.2 1.8-4.2.4-.6-.8.2-2.1 1.2l-3.6 2.4z"
        transform="matrix(.59548 0 0 .58466 141.4 62.9)"
      />
      <path
        fill="#d91023"
        d="M354 429.8c-4.9-.7-8.2-1.4-11.3-1-3.4.3-5.8 2-9.9 4.5-4 2.7-7.7 4.6-8.1 4.6-.6 0-5.8 1.2-9.8 1.2-1.8 0-5.9-1.3-8.6-2.3-5.7-2.1-7.8 1.4-1.8 3.9a33.4 33.4 0 0 0 15.6 1.8c5-.8 9.6-3 13.4-5.8 7.7-5.6 3.2-3 6.2-4.2 3-1.3 5.9-.9 5.9-.9 4 .2 11.9 1.5 15.9 1.6 7.2-.7 6-.7 8.4-2 .8-.6 3.5-2.3 3.6-2.7.2-.4 1.4-2.7 1.2-2.8-7.5 5.1-11.2 5.1-20.7 4.1z"
        transform="matrix(.59548 0 0 .58466 141.4 62.9)"
      />
      <path
        fill="#d91023"
        d="M341 435.4l-7.1 4c-6.2 3.8-12 5.6-18.8 5.6-3 .5-13-3.6-11.5-3.1 1.6 3 4 3.4 9.6 4.5 4 .8 6.6.1 11.1-.8 5-.6 7-3 9-4.3a33.5 33.5 0 0 1 14-5.4c1 0 4.7 2.1 8.9 3 4.1.9 6.1 1.1 10.4.4s8.7-4.2 12.8-6.9c-.6.2-2 .2-4 .3-6 3.5-16 4.8-21.2 2.4-5.4-1.3-10.5-1-13.2.3z"
        transform="matrix(.59548 0 0 .58466 141.4 62.9)"
      />
    </g>
    <path
      fill="#00a854"
      d="M276.4 176.3a37.7 37.7 0 0 0-17.5 13.2c-1 1.2-1.8 2.2-1.9 2.1 0 0 .4-2.7 1.2-5.7.7-3 1.2-6.1 1.2-6.8 0-1.2-.1-1.1-2 1a41 41 0 0 0-7 13c-.7 2.2-1 4.7-1 9.3l.1 6.3-1.2-4.5c-1.3-4.7-2.6-8-4-9.6-.6-1-.8-1-1.3-.3-1 1.5-.3 7.8 1.4 12.4.1.6-.5-.2-1.4-1.7-1-1.6-2-2.7-2.3-2.6-.6.3-.6 5.3 0 7.4.4 1.4.4 1.4-1.3-.5-2.9-3.3-3.5-3.6-3.5-1.3 0 .9.3 2.4.7 3.4l.8 2-1.6.4c-2.3.4-3 1.1-3 3 0 2 1.4 6.8 2 7.2.9.5 1.1 0 1.8-3l.6-2.6 1.9 2.5a76.7 76.7 0 0 1 8.8 17.7c2.2 6.4 2.3 7.7.3 3.7a72 72 0 0 0-3.2-5.2c-2-2.8-12.6-13.9-13.3-13.9-.8 0 0 3.5 1.3 6.4.7 1.4 2.7 4.2 4.4 6.2l2.9 3.6c-.2 0-1.4-.8-2.7-1.7-2.6-2-5.3-3.5-5.6-3.2-.1.1.9 2.3 2.3 4.8l2.4 4.6-1.6-.3a6 6 0 0 0-2.8.3c-1 .6-1 1.1-1 3.5 0 3.3.8 6.7 1.5 6.7.8 0 2-3.2 2-4.9 0-1.3 0-1.3 2.6 1.1 3.7 3.6 8.6 9.6 13.4 16.6l4 6-4.7-3.6c-4.6-3.3-14-8.6-15.5-8.6-.4 0-.8.2-.8.5 0 .2 3 3.3 6.7 6.8l6.7 6.3-3.5-1.1a71 71 0 0 0-5.3-1.5c-1.7-.4-1.7-.3 2.2 3.3a68 68 0 0 0 8.7 6.7c2.6 1.6 4.3 2.8 3.7 2.7a35.1 35.1 0 0 0-11.5-1.9c0 .7 3.5 3.5 6 4.8 1.4.7 5 2 7.8 3 6 2.1 9.6 4 12.6 6.6l2 1.9-3.5-1.6c-4.1-1.8-15.3-5.5-16.5-5.5s3.8 5 8.8 8.7a80.2 80.2 0 0 0 19.5 9.7c5.2 1.7 9.6 2.6 18 3.6 3.6.5 7 1 7.8 1.3.6.3 5 1 10 1.5a99.7 99.7 0 0 1 30.7 7.2c1.7.8 3.5 1.1 7.2 1.3 5.5.3 5.8.1 4.2-2.9-1.3-2.5-3.7-3.9-8.7-4.8l-9.2-1.8a726.1 726.1 0 0 0-29-5c-14-2.3-20.1-4.7-26.7-10.7A43.3 43.3 0 0 1 269 263c.4-3 .6-5.5.5-5.6-.5-.4-3.7 6.3-4.6 9.4l-1 3.3.3-5.4c.3-8.3 3.5-16.1 8.2-20.6 1-1 1.8-2 1.8-2.2 0-.2-1 0-2.1.2-1.6.4-3 1.3-5 3.2l-2.6 2.7 1.3-2.4a27 27 0 0 1 8.3-9.6l2.9-1.9-1.7-.1c-3.4-.4-9.5 4-12.9 9.3-2 3-2 2.1 0-2.6a41.8 41.8 0 0 1 8-12.5c1.9-1.8 2.2-2.5 1.5-2.5-2.7 0-7.2 3.5-11 8.4-1 1.5-1 1.4.2-1.5a40 40 0 0 1 6.1-9.7c1.6-1.9 1.2-2.1-1.5-1a26.4 26.4 0 0 0-8.6 9.7c-1 2-1.8 3-1.7 2.5a61 61 0 0 0 .8-3.3 46.4 46.4 0 0 1 12.8-22.7c2.4-2.2 3-3.2 2.3-3.2-2 0-6.5 2.6-9.5 5.5-3.1 3-3.2 3-2 .9a57 57 0 0 1 18.3-18.6l4.3-3c0-.8-7.8 1.6-11.3 3.3a42.3 42.3 0 0 0-4.4 3.2c-2.5 2-2.7 2.1-1.8.8 1.7-2.4 7.6-7.7 10-8.9 1.7-.9 2-1.2 1-1.3-2.3-.4-8.9 3-14 7.4l-2.2 1.9 1.2-2a48 48 0 0 1 14.7-15.6 60.5 60.5 0 0 1 4.4-2.6c.3-.1.5-.4.4-.5-.2-.2-2 .2-4 1zm77 145a6 6 0 0 1 1.4 1.9c0 .2-1.1.4-2.5.4-2.5 0-2.6 0-2.6-1.4 0-2.6 1.6-2.9 3.8-.8z"
    />
    <path
      fill="#9eab05"
      d="M350.3 320.5c-1.3 1.2-1 3 .3 3.4 2.2.6 5 .4 5-.4s-3.3-3.8-4.1-3.8c-.3 0-.8.3-1.2.8z"
    />
    <path
      fill="#cab313"
      fillOpacity={0.5}
      d="M279 175.5a31.6 31.6 0 0 0-15 8.5c-.3.3-3 2.8-4.8 5.2-.8 1-2 2.5-2.5 3.5 0-1 .8-3.8 1.5-7 .9-4 1.2-7 1.1-7.2-.5-.5-4.2 4.4-6 8a30.9 30.9 0 0 0-3.6 16.7v6.4l-1.3-4.8c-1.3-5-3.6-10.3-4.7-10.6-.4-.1-.8.6-1 1.7-.3 1.6 0 3.3 2.1 12 .2.6-.4 0-1.2-1.6-2-3.4-2.7-4.1-3.2-3.8l1.4 2a44 44 0 0 1 3 6 85 85 0 0 1 5.7 19.1c-.1.1-.5-.3-.7-1l-1.6-4.2a74 74 0 0 0-3-6.7 38.2 38.2 0 0 1-4.6-12.7l-.3-2.5c-.7.6-.4 3.5.6 6.8l.9 3c-.1 0-1.3-1.3-2.6-3-1.8-2.4-2.6-3-3-2.5-.4.8-.1 2.3 1 5.2l.7 2H236c-1 0-2.1.2-2.7.6-.8.6-.9 1-.4 3.7.6 3.3 1.4 5.8 2 5.8 1.1 0 1-1 1.6-3.9l.6-1.8c.2.3.5.7 1 1.1a78 78 0 0 1 10 19.4 111 111 0 0 1 3.8 16c0 .2-.7-1.7-1.3-4.2-2-8.7-5-13.8-14-22.6 0 0-3-3.7-5.5-5.2 0 2.1.4 2.5.4 2.5.7 3.1 2.2 5.9 7 11.4a43 43 0 0 1 3.8 5l-2.7-2.2c-2.7-2.4-7-5.1-7.3-4.7-.2.1.8 2.3 2.2 5 1.8 3.2 2.3 4.5 1.7 4.3-2-.8-2.7-.8-4 0-1.3.9-1.3 1-1 4.4.1 2 .6 4 .9 4.7.6 1 .6 1 1.2-.2.3-.7.8-2.1 1-3.2.2-1 .5-1.9.6-1.9a48 48 0 0 1 4 4 80.9 80.9 0 0 0 1.8 2.1 332 332 0 0 1 13.6 17.8l1 1.8-1.7-1.3a74.7 74.7 0 0 0-19-11.7c-1-.3-1.2 0-.7.6 2.4 3.3 9.6 9.4 11.6 11 1.9 1.6 1.8 2.2 1.8 2.3-.1 0-1.4-.6-3.7-1.3-5.8-2-7.3-2.1-6.6-1.2a4 4 0 0 0 2.1.8 43 43 0 0 1 15.8 6.8c3.4 2.3 11.5 10 12.6 12 .6 1.2.4 1.1-1.7-.6a43.7 43.7 0 0 0-11-6.2c-.3.1-2.1-.2-4-.7-2-.5-5-1.1-6.8-1.3l-3-.4 1.8 1.7c2.4 2.1 6.3 4 13 6.3a58.6 58.6 0 0 1 7.3 3c2.5 1.5 7.6 5.5 7.3 5.7a123.6 123.6 0 0 0-20-7.1c-1.2-.3-.8.2 2.3 3.3a75.9 75.9 0 0 0 7.9 6.3c10.9 7.2 20.8 10.3 39.2 12.5 3 .3 5.1.8 5 1-.2.3 4.4 1 9.4 1.5 13.4 1.6 21.8 3.4 29.4 6.5a23.4 23.4 0 0 0 8.9 2c3.4.2 4.5.2 4.5-.3 0-1.2-1.4-3.4-3.2-5-1.5-1.3-2.6-2-8.6-3.1-3.8-.6-7.3-1.4-7.7-1.7-.5-.3-8.1-1.3-16.8-2.7-19.1-3-25-4.5-30-7a40.3 40.3 0 0 1-22-34.7 56.1 56.1 0 0 1 .3-9.2c.3-2 .5-3.6.4-3.7-.5-.5-4.4 7.3-5 10.3l-.3 2-.2-3.6a33.9 33.9 0 0 1 6.8-20.6s2.9-2.8 3.3-3.6v-.1c-2.1-.7-4.3 1-7.3 3.6-1.8 1.8-2 2.3-2.2 2.2.2-1.4 5.5-9.5 6.6-9.5.2 0 1.5-1.5 2-2 .6-1.5-3.2 2-5.9 5.7-6 8-7.4 16.1-7 26.9a36 36 0 0 1-.3 5.9c-.2 0-1.8-3.9-2.5-6.4-2-6.3 1-19.4 6.1-26.1l3.3-4.1c.8-1.4-3.5 3.4-5 5.7-.4.7-.8 1.2-1 1l.7-2.2a45.4 45.4 0 0 1 9.3-15.7c1.6-1.7 1.6-1.7.3-1.3-3 .9-5.8 3.2-8.7 6.6l-2.2 2.6c.3-1.3 3-7 5.2-10.1 1.4-1.9 2.7-3.2 2.7-3.6 0-.4-1.5 0-3.6 1.6a28 28 0 0 0-7.6 9c-1.3 2.6-1 1.9-1.5 2.3a43 43 0 0 1 12.8-25.9c2.8-2.9 3.4-3.7 2.4-3.4-3 1-6.3 3-9.2 5.9-1.7 1.7-2.4 2.2-2.4 2s.8-1.7 2.5-4.3a53.8 53.8 0 0 1 14.1-14.7c2.7-1.8 6.8-3.8 6.3-4a.5.5 0 0 0-.2-.1c.3-.5-1.1-.2-4.8 1a37.6 37.6 0 0 0-11.6 6.3c-1.5 1.4-1.2.3 2.6-3.5 2-2 5-4.5 6.6-5.3 2.6-1.6 2.4-2 .7-1.6a32 32 0 0 0-13.4 7.7l-.3.2c-1.2.7-2.3 2.3-2 1.6s.8-1.3 2.1-3.5a46.8 46.8 0 0 1 16.8-15.8c1.7-1 1.8-1.6.6-1.4zm-38.8 27zm34.8-25.1h.2a73 73 0 0 0-12 11.6 60 60 0 0 0-7.3 13.2c-1 2.4-1.6 4-1.6 3.6a85.6 85.6 0 0 1 2.3-12l1.3-1.8a42 42 0 0 1 2.6-3.5c1.1-1.4 4.7-5.1 4.6-5.2l1.2-1c3.4-2.4 7.8-5 8.7-5zm-16.9 2.7h.1c.1.4-.5 4.8-1.7 10a230.5 230.5 0 0 0-4.6 25c-.4 3.7-.5 4-.8 2.4-.3-1-.6-6-.8-11-.3-10 0-12.8 2.6-18.4a29 29 0 0 1 5.2-8zm13.9 8.4l-3 3a57 57 0 0 0-15.9 27.3l-1 3.5.4-3.3a44.8 44.8 0 0 1 3.5-14.8c1.1-3 2.2-5.5 4.5-7.8.4-.5 1.5-1.4 1.7-1.8l2.8-2.1c2-1.7 6.2-4 7-4zm6 2.5c.3 0 .4 0 .4.2l-3 2.1a70 70 0 0 0-13.8 14 83.8 83.8 0 0 0-7.8 15.5c-1.5 4.2-1.4 2 .2-4a68.6 68.6 0 0 1 7.4-17.3l1.5-2c.7-.8.9-1.2 1.2-1 .2.1 1.4-.6 2.6-1.6 2.7-2.3 9.7-5.8 11.4-5.9zm-34.4 3.9c.1-.1.3.1.6.6a38 38 0 0 1 2.2 5.2A93.8 93.8 0 0 1 251 226a82.5 82.5 0 0 0-2.8-9.6c-4.1-12.4-5.5-18.4-5-20.6l.4-1zm26.5 10.9s-1 1.2-2.5 2.6a49 49 0 0 0-13.1 27.7c-.5 2.8-1 5.3-1.3 5.5-.2.2-.6-1-.8-2.5a41.3 41.3 0 0 1 4.2-20.2l1.3-2.9c.4-.3.7-1 1.3-1.8 2.3-2.6 6.1-6.3 8.6-7.5l2.3-1zm-33.4 1.2l1 1.3a84.5 84.5 0 0 1 3.2 4.3c2.2 3.2 7.8 14.4 8.4 16.6.2.7-.5-.4-1.6-2.4a68.8 68.8 0 0 0-5.3-8c-4.2-5.6-5.7-8.2-5.7-10.2V207zm-1.1 7.4h.5c1.5 0 4.7 2.8 7.5 6.6a69 69 0 0 1 8.8 21.4c.9 4 2.4 14.2 2.4 16.5v1.6l-.9-1.5c-.4-.9-1.1-3.5-1.5-5.8a101.1 101.1 0 0 0-5.3-19c-2.3-5.8-7.1-14-9.3-16a2.5 2.5 0 0 0-.7-.6 7 7 0 0 0-1.5-1.5c-1.1-1-1.2-1.5 0-1.7zm-2.6.9l1.3.8c1.7 1.2 2.3 1.7 2 3.2-.3 1.5-.5 3-.8 3.4-.4.8-.8.2-1.2-1.4l-1-4-.3-2zm33.8 6.8c.2 0 .2.2 0 .6-.5.4-1.7 1.9-2.3 2.7a68.9 68.9 0 0 0-9 23.7c-.5 3.7-1.2 2-1.2-3a30.1 30.1 0 0 1 8.1-20.5c2-2.1 4-3.5 4.4-3.5zm-34.3 3.2c.5 0 2 1.5 5.4 5a72 72 0 0 1 7.6 8.7c1.9 3.3 4 8.2 4.5 10.7.2 1.4-.3.8-3.2-3.2a174.5 174.5 0 0 0-6.2-7.9c-5.5-6.4-7.6-9.5-8.2-12.7-.1-.4-.1-.7.1-.6zm38 1.3c.2 0-1 1.6-2.6 3.5a52.3 52.3 0 0 0-4.7 7c-2 4-5.1 13.3-6.2 19-1.1 6-1.2 5.9-1-.7.5-12.6 5-22.8 12-27.3l2.6-1.5zm-37.5 9.1l1.6.8c.9.5 3 2 4.6 3.3 1.7 1.5 3.2 2.4 3.4 2.2.3-.2.4-.1.2.2a16 16 0 0 0 3 4.8 68.3 68.3 0 0 1 9 16.5c.5 1.7 1 3 .8 3.2l-3.4-5.2a61.1 61.1 0 0 0-11.8-14.8 19.6 19.6 0 0 1-5-6.5l-2.4-4.5zm40.6 6.7c-.9.8-2.8 3-2.8 3a31.7 31.7 0 0 0-6.6 12.7 75 75 0 0 0 1.7 28.5 48 48 0 0 1-4-11c-.9-4.5-.8-14.9 0-18.4 1-4 3.2-8.6 5.2-10.8 1.7-2 5-4 6.5-4zm-39.4 1.8c.8 0 1.7.4 3.1 1.3 5.5 3.5 12.5 12.6 20.5 27 6.4 11.5 10.1 20.2 4.9 11.5a265.6 265.6 0 0 0-25.2-34.4l-.1-.2a20.3 20.3 0 0 0-3.6-3c-2-1.2-2.1-1.7-.4-2.1l.8-.1zm-2 2.3c.5 0 1 .3 1.4.7.6.8.3 4.7-.5 5.1-.6.4-.8-.1-1.3-3.1-.3-2.2-.2-2.7.5-2.7zm36.1 13.7v6a43 43 0 0 0 14 34.7c5.9 5.2 12.5 8 23 9.8 3.5.6 6.7 1 7 1.3.5.1 5.3.6 5 1.1-.1.2.3.3 1 .2 2.1-.4 8.5 1 10.2 1a186 186 0 0 1 23.7 5c1.4.6 4.4 4.1 4.4 5.2 0 .3-1.6.4-4.4.2a21 21 0 0 1-8.5-2.2c-6.7-3-16-5-27.2-6-5.8-.5-24.7-3.8-30.1-5a68.2 68.2 0 0 1-17.8-6 52 52 0 0 1-14.4-9.5l-3.3-3.2 2.8.8c8.3 2.4 15 5.4 23.4 10.7 6.7 4 8.9 5.2 12.5 6 3.3 1 4.3 1 4.3.4 0-.2-1.7-.9-3.8-1.5a37.2 37.2 0 0 1-24.6-41.3 54 54 0 0 1 2.8-7.7zM235 262l.7.2c3 .5 15.2 8.2 19.4 12.3a30.4 30.4 0 0 1 4.3 5.8l1.6 3-2.8-2.2a66.5 66.5 0 0 0-6.4-4.4 86 86 0 0 1-10-8.5L235 262zm8.4 21.4l1.1.2c1 .1 3.6.7 5.9 1.2 8 1.9 17.8 8 22.8 14.4l2.2 2.9-2.3-1.2c-1.2-.6-2.2-1.3-2-1.5.2-.5-5-4.8-7.7-6.2a92.8 92.8 0 0 0-8.8-3.6c-6.2-2.3-10-4.1-11.2-5.6-.3-.4-.4-.6 0-.6z"
    />
    <path
      fill="#cab313"
      fillOpacity={0.5}
      d="M272.2 234.2c-1.1.4-2.9 2-4 2.9-2.2 1.6-2.5 2.2-.4.7 1.6-1 4.3-3 6.6-3.4.3 0-.9 1.2-1.5 1.8-.9 1-.6 1 1.3-.3l2.4-1.8c0-.4-2.4-.6-4.4.1zm-34.7 38c0 1.2 15.8 12.9 16.5 12.1.1 0-2-1.5-4.6-3.1a65 65 0 0 1-7.8-5.8c-1.7-1.6-3.9-4-4.1-3.3z"
    />
    <g stroke="#d4af37" strokeWidth={0.9}>
      <path
        fill="#fff"
        d="M246.2 432.3a31 31 0 0 1-16.4.7 21 21 0 0 0-6.2 0l2.8 1.8c1.3.8.8.6 3.1 1.7-.4.4-.6.6-2.4 1.3 2.4.5 5.4.8 8.3.6a37 37 0 0 0 8.7-1.4 47 47 0 0 1 9-1.8c1.2 0 5.4 1.3 9.4 3.4 8.6 4.7 14.6 6 20.6 6 4.1 0 8.4-1 13.3-4.2 3.6-2.3.6-2.2-3-.7-5 2-15.2 3-27-3.2a44.4 44.4 0 0 0-14.6-5.6c-.4 0-3 .6-5.6 1.4z"
        transform="matrix(.59548 0 0 .58466 141.4 62.9)"
      />
      <path
        fill="#d91023"
        d="M219.9 429.5c1.4 1.2 1.2 1.5 3.8 3.5 3.5.4 10.6 1.1 13.2 1.1 2.4 0 6.8-.4 10-1.2 6.2-1.3 9.2-1 20.5 4 13.1 6.8 20.5 5.6 27.3 2.3 9.4-3.6.2-2-3.2-3-1.1.3-2.5 1.8-5.2 2.7-3.8 1.4-5.8 1.4-10.3-1-2.9-1.4-5.4-2-8-3.5-2.5-1.5-3.1-1.3-7.3-2.7l-6.2-1.2-9.4-.5a44 44 0 0 1-21.5-1.3c-5.4-1.7-6.4-1.4-3.7.8z"
        transform="matrix(.59548 0 0 .58466 141.4 62.9)"
      />
      <path
        fill="#d91023"
        d="M244.3 436.8a35 35 0 0 1-17.2 1l-3.9 1.3c-5 1.7-5 1.8-2.9 2.4 1.3.4 6.3.7 11.3.6 8.5 0 9.3-.1 14-2.4a24 24 0 0 1 7-2.5c1 0 4.5 2 7.7 3.7 8.8 4.6 12.1 6 19.4 5.9 7.3 0 16.7-5.3 17.9-7a28 28 0 0 1-17.3 4.8 41 41 0 0 1-19.8-7c-5.8-3.1-7.8-3.2-16.1-.8z"
        transform="matrix(.59548 0 0 .58466 141.4 62.9)"
      />
      <g strokeWidth={0.8}>
        <path
          fill="#fff"
          d="M293.5 417.7c1.2-1.4.8-2-2.5-2.4a47.2 47.2 0 0 1-23.1-10.9c-2.2-2.3-3.1-2.5-3.1-.7 0 2 6.7 8.1 11.6 10.6a45.6 45.6 0 0 0 14.5 4.7c.8 0 1.9-.5 2.6-1.3z"
          transform="matrix(-.20995 -.43098 -.90458 .22461 742 335.3)"
        />
        <path
          fill="#d91023"
          d="M290.7 421.4c.2-.4-.4-2.4-3.1-3a41.8 41.8 0 0 1-19-9.8c-3.6-3.5-5.3-3.9-4.1-.7 1.6 4.6 14.3 11 19.3 12.6 5 1.6 6.1 2 6.9.9z"
          transform="matrix(-.20995 -.43098 -.90458 .22461 742 335.3)"
        />
        <path
          fill="#ed1c24"
          d="M295.5 415.4l.8-1.4-4-2.6c-4.7-.6-13-3.6-18.6-6.7a21.5 21.5 0 0 0-6.1-2.6c-1.5 0-1.6 0 .1 1.9a44 44 0 0 0 21.8 10.4c2.3.4 4.7 2 6 1z"
          transform="matrix(-.20995 -.43098 -.90458 .22461 742 335.3)"
        />
        <path
          fill="#fff"
          d="M293.5 417.7c1.2-1.4.8-2-2.5-2.4a47.2 47.2 0 0 1-23.1-10.9c-2.2-2.3-3.1-2.5-3.1-.7 0 2 6.7 8.1 11.6 10.6a45.6 45.6 0 0 0 14.5 4.7c.8 0 1.9-.5 2.6-1.3z"
          transform="matrix(.23749 -.41683 .88814 .2813 -101.9 308.3)"
        />
        <path
          fill="#d91023"
          d="M289 420.6c0-.2 1.2-1.6-1.4-2.2a41.8 41.8 0 0 1-19-9.8c-4.2-4.6-6.3-5.6-4.1-.7 1.6 4.6 14.3 11 19.3 12.6 5 1.6 4.4 1.3 5.1.1z"
          transform="matrix(.23749 -.41683 .88814 .2813 -101.9 308.3)"
        />
        <path
          fill="#ed1c24"
          d="M295.5 415.4l.8-1.4-4-2.6c-4.7-.6-13-3.6-18.6-6.7a21.5 21.5 0 0 0-6.1-2.6c-1.5 0-1.6 0 .1 1.9a44 44 0 0 0 21.8 10.4c2.3.4 4.7 2 6 1z"
          transform="matrix(.23749 -.41683 .88814 .2813 -101.9 308.3)"
        />
      </g>
      <path
        fill="#fff"
        d="M319.7 402.7a30.7 30.7 0 0 0-16.7 13.1c-2 3-4 4.4-2.6 5 1.5.8 2.9-1.3 5.6-4 7-7 12.5-10 20-10h6l-1.8-2.5c-2.1-3-4.6-3.3-10.5-1.6zm-50.5 2.4c-1.2 1.4-.9 2 2.6 2.5A49.4 49.4 0 0 1 296 419c2.3 2.4 3.3 2.6 3.3.7 0-2-7.1-8.5-12.2-11-4.4-2.4-12.2-5-15.1-5-1 0-2 .5-2.8 1.4z"
        transform="matrix(.59517 .01882 -.01898 .58436 150 60.3)"
      />
      <path
        fill="#d91023"
        d="M318.6 399.5a52 52 0 0 0-5.4 2.3 48 48 0 0 0-9.9 9.6l-3 4.2c-1.3 2-1.5 3.2-.8 3.3.6.2 2-.7 3.5-2.7 6-8.4 11.6-12.2 19.8-13.9 4.2-.8 4.8-.8 6.3.7 1.2 1-.3-.2-.6-1-.5-1.8-1.8-2.7-4.5-3.2a13.3 13.3 0 0 0-5.4.7z"
        transform="matrix(.59517 .01882 -.01898 .58436 150 60.3)"
      />
      <path
        fill="#d91023"
        d="M272 403.3c-.2.4 1.8 1.2 4.5 1.7a42 42 0 0 1 19 9.9c3.5 3.5 5.3 3.8 4 .6-1.5-4.5-14.2-11-19.2-12.5-5-1.6-7.6-.8-8.3.3zm48.5 4A39.3 39.3 0 0 0 307 416c-4 3.9-5.8 6.3-4.2 6.3.3 0 2.7-1.9 4.3-3.3 7-6 19.8-9.4 25.4-7.3 2.8 1 1.5-2-.4-4.8-1.1-1.7-8-.7-11.5.6zm-53-.2l-3.4 3.1 5 .9c5 .6 14.3 4 20.5 7.4 2.7 1.6 5.8 2.9 6.7 2.9 1.7 0 1.8 0-.1-2.1a48.7 48.7 0 0 0-24-11.6c-2.7-.4-3.4-1.8-4.8-.6z"
        transform="matrix(.59517 .01882 -.01898 .58436 150 60.3)"
      />
      <path
        fill="#d91023"
        d="M304.5 422.4a33.6 33.6 0 0 0-1 14.1c1.6-.2 2.7-.2 5.3-.7.3-2.2.7-4.7.6-7.4.3-3.7 0-1.8 2.1-4.8-2.3-1.5-3-1.6-7-1.2z"
        transform="matrix(.59548 0 0 .58466 140.8 64.7)"
      />
      <path
        fill="#fff"
        d="M296.2 428.6c0 4.2.3 5.2.3 7.2 2.3.3 7.4 1 7 .2v-8l1-5.5-3.7-.6-3.2.4-1.4 6.3z"
        transform="matrix(.59548 0 0 .58466 140.8 64.7)"
      />
      <path
        fill="#d91023"
        d="M291 428.8c.1 3.4-.5 4.5-.1 6.5 1 .3 5 .2 6.3.5-.2-4.3-.2-.5-.6-6.2l1.2-7.3-3.6.3s-2.2-.7-3.7-.7c1.3 2.3.5 7 .5 7z"
        transform="matrix(.59548 0 0 .58466 140.8 64.7)"
      />
    </g>
  </svg>
	),
	PF: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h640v480H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#fff" d="M80 0h480v480H80z" />
      <path
        fill="#083d9c"
        fillRule="evenodd"
        stroke="#083d9c"
        strokeWidth="2pt"
        d="M277.3 340.8s10.8-8.8 21.4-8.8 13.4 7.3 20.8 7.9c7.3.6 13.4-7.3 22.5-7.6 9.1-.3 20.5 6.4 20.5 6.4l-39.8 12-45.4-10zm-22.9-13l135.4.7s-11.7-12.7-25.5-13c-13.8-.2-10 6-20.5 6.8-10.6.9-13.2-6.4-22.9-6.2-9.6.3-15.2 6.2-22.5 6.5-7.4.3-16.7-7.3-22.3-7-5.6.3-25.5 8.7-25.5 8.7l3.8 3.6zm-17.3-16l167 .5c2.7-3.8-8.2-12.9-18.1-13.7-8.2.3-14 8.5-20.8 8.8-6.8.3-14.4-8.5-22-8.2-7.6.3-15.5 8.2-23.1 8.2-7.7 0-13.2-8.5-22.9-8.5s-14 9.3-21.4 8.8c-7.3-.6-13.8-9.4-20.8-9.4s-18.7 10.5-21 10c-2.4-.7 2.9 4.3 3.1 3.4z"
      />
      <path
        fill="red"
        fillRule="evenodd"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={2.5}
        d="M301.3 218.9l38.4 10.2v-54.8c-17.6 1-32.2-33.4-1.2-35.7-30.5-4.4-34 3.5-37.5 12l.3 68.3z"
      />
      <path
        fill="#083d9c"
        fillRule="evenodd"
        stroke="#083d9c"
        strokeLinecap="round"
        strokeWidth={5}
        d="M277 258.7l86.7.3"
      />
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeWidth={4}
        d="M281.1 238l10.3 13.7m-10.3 0l11.1-13.5M287 237l-.3 8.5m10.8-7.6l10.3 13.8m-10.3 0l11.1-13.5m-5.2-1.2l-.3 8.5m11.1-7.6l10.3 13.8m-10.3 0l11.1-13.5m-5.2-1.2l-.3 8.5m11.7-7.6l10.2 13.8m-10.2 0l11.1-13.5m-5.3-1.2l-.2 8.5m11-7.6l10.3 13.8m-10.2 0l11.1-13.5M354 237l-.3 8.5"
      />
      <path
        fill="#ef7d08"
        fillRule="evenodd"
        d="M218.7 259.6l36.9.3v-23.1l-42.2-2.1 5.3 24.9zm-1.8-32l39.3 3.9-.3-16.4-38.4-15.3-.6 27.9zm8-32.7l30.1 14.6 4.3-4.5s-2.8-1.9-2.6-3.7c0-1.7 2.8-2 2.8-4 0-1.7-3-2-3.1-3.7-.2-2 2.4-4 2.4-4l-27.2-23.7-6.8 29zm198 65h-39l-.3-22.6 42.8-3.2-3.5 25.8zM384.2 232l46.3-5.6-10-26.7-36.6 15.6.3 16.7zm33.7-39.6L384.5 210c-.5-2-.9-3.8-3.2-5.3 0 0 2-1.2 2-3.2s-2.6-2.4-2.6-3.5 2.4-2.2 2.6-4.9c-.3-1.8-2.6-4.4-2.2-4.9l26-19.8 10.8 24zm-72.4 39.1l16.7-.7.3-6.7-17 7.4zm-51-.5l-17.5-.5v-7l17.6 7.5zm0-2l-17.5-9v-11.8s-2 .3-1.8-2c.1-4.9 12.9 8.9 19.4 13.4l-.1 9.4zm51-1.1v-7.7s15.8-14.2 19.1-16.9c0 3-1.8 5.2-1.8 5.2v11.2l-17.3 8.2zM243 163.8l17.8 19.7c.4-1.8 4.5-2.1 8.6-1.8 4 .3 7.3-.3 7.3 2.6s-2 2.5-2 4.6 3 1.9 3 4.5-2.2 2.1-2.2 4.1c0 1.7 2.4 1.8 2.4 1.8l16.6 16.1v-17.2l-34.2-53.7-17.3 19.3zm27.4-20.4l23.3 47.5s.2-43.8 4.1-46.1l-6.5-12-20.9 10.6zm101 1.9l-26 46.2V172s2.2-3.2-1.2-3c-3.4.3-7.5-.2-7.5-.2l10.4-36.6 24.3 13zM398 165c-.3.5-17.5 18-17.5 18-.8-2-6-1-11-1-4.9 0-5.6 1.6-5.3 2.9.5 3.3 2.2.8 2.2 4 0 3.1-2.4 2-2.7 4.2.3 2.7 3.8 2 1.7 4l-19.9 19.2v-18.2l37.1-57.6L398 165z"
      />
      <path
        fill="red"
        fillRule="evenodd"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={2.5}
        d="M309.8 268.4c-8.3 13.8-30.6 9.7-35.9 0-1.5-.4-.6-59.5-.6-59.5s-2.5-1.1-2.6-3c-.1-1.8 3.4-2 3.4-4.3s-3.6-1.4-3.7-3.8c0-2.2 3.9-2 3.7-4-.2-2.4-4.3-2-4.5-4.2 0-1.7 3-3.2 3.8-4a61.3 61.3 0 0 1-2.8 0l-6.4.1c-4.6 0 0 1 0 3.6 0 1.7-2.3 2.9-2.5 4.3-.1 1.6 3.2 2.6 3.3 4.5 0 1.6-3.3 1.7-3.2 3.3.2 2.5 3 3.1 2.9 4.7 0 1.5-3.6 2.1-3.7 3.3.2 2.4.6 60.8.6 60.8 5.7 29.8 38.8 37.3 48.2-1.8zm21.9 0c8.3 13.8 30.6 9.7 35.8 0 1.6-.4.7-59.5.7-59.5s2.5-1.1 2.6-3c.1-1.8-3.2-2-3.2-4.3s3.4-1.4 3.4-3.8c0-2.2-3.5-2-3.3-4.2.2-2.3 3-2 3.1-4.2.1-1.9-1.7-3-2.6-3.8h2.7l6.4.1c4.5 0 0 1 0 3.6 0 1.7 2.3 2.9 2.5 4.3 0 1.6-3.2 2.6-3.3 4.5 0 1.6 3.3 1.7 3.2 3.3-.2 2.5-3 3.1-3 4.7.1 1.5 3.7 2.1 3.7 3.3l-.5 60.8c-5.7 29.8-38.9 37.3-48.2-1.8z"
      />
      <path
        fill="#083d9c"
        fillRule="evenodd"
        stroke="#083d9c"
        strokeWidth="2pt"
        d="M301.7 295.6H339c.3-.3-8.4-13-18.6-12-11.5.3-19.3 12-18.7 12zm118.9-1h-51s6.6-3.8 8.4-7.4c3.3 1.8 2.4 3.6 9 3.9 6.6.3 12.9-7.5 19.2-7.2 6.3.3 14.4 11 14.4 10.8zm-201 0h51s-6.6-3.8-8.4-7.4c-3.3 1.8-2.4 3.6-9 3.9-6.6.3-13-7.5-19.2-7.2-6.3.3-14.4 11-14.4 10.8zm3.8-16l36.3.3s-2.3-5-2.6-11.1c-9.4-3.2-17 7-23.8 7.3-6.7.3-13.7-7.3-13.7-7.3l3.8 10.8zm194 0l-36.4.3s2.3-5 2.6-11.1c9.4-3.2 17 7 23.8 7.3 6.7.3 13.7-7.3 13.7-7.3l-3.8 10.8zM311 279l18.4-.5s.3-5.6-9.3-5.6-8.8 6.4-9.1 6.1zm-11.2-7.9a17 17 0 0 0 8.2-7.6l-12.6.3s-5.8 3.5-8.7 7.3h13.1zm40.8 0a17 17 0 0 1-8.2-7.6l12.6.3s5.8 3.5 8.7 7.3h-13.1z"
      />
      <path
        fill="#de2010"
        fillRule="evenodd"
        d="M-40 360h720v120H-40zm0-360h720v120H-40z"
      />
    </g>
  </svg>
	),
	PG: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path d="M1.6 0l-.5 480h640L1.6 0z" />
      <path fill="red" d="M640.6 480l.5-480H1.1l639.5 480z" />
    </g>
    <path
      fill="#fc0"
      stroke="#fc0"
      strokeWidth={1.1}
      d="M178 54l-3.8-.2c-1.2-2.8-4.5-3.8-6.6-2.6A333 333 0 0 1 156 51l7.1 3.1C165 59 171 60 171 60c-.6 8.8-8.9-1.1-15.9 3.9-5 3-5 6.5-7.7 12.3-.9 1.6-4.4 5.8-4.4 5.8l5.9-.5L147 84l7-1-1.5 1.4c1 .2 8-1.7 8-1.7L160 85l8-2.9s1.6 1.3 3 1.9l1-4 4 1 1-4c6 8 8 16 19 18l-1-4a262.2 262.2 0 0 1 8.7 4l.9-1.7c4.8 3.4 8.7 3.3 11.4 3.7l-2-5 2 1-3-8 3 1-4-6 1.5-1-.5-3c6 2 14 5 15 12 1 11-11 14-19 13 6 5 17 3 22-2 2-2 3-5 4-8 1 3 3 7 3 11-1 9-13 12-21 13 9 5 25-1 26-14 0-11-7-16-10-21l-1-5.4 3 1.4s-1.8-3.3-2-4c0 0-3.1-8.5-4.2-10.4l2.2.4-8.2-10.3 2.3-.2S215.6 44 213 43l3-1c-6-3-13-1-19 3l1-3-1.8.2v-3.5L198 36l-3-1 2-5-3 1 1-5s-2.2 1-3.6.9a51.7 51.7 0 0 0 1.6-3.4c-1-1.5 0-4.5 0-4.5-7 1-8 2-12 8-6 11-4 16-3 27z"
      transform="matrix(2.21989 0 0 2.21194 1.1 0)"
    />
    <path
      fill="red"
      fillRule="evenodd"
      stroke="red"
      strokeWidth={1.4}
      d="M215.8 70.4c.5.9 6.2 3.6 10.4 6-1.1-4.6-9.4-5.6-10.4-6z"
      transform="matrix(2.21989 0 0 2.21194 1.1 0)"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M175 399l-14.2-9-19 9.1 4.3-16.2-14.5-15.1 16.7-1 10-18.4 6.1 15.5 20.7 3.8-13 10.6zm36.2-79l-6.6-3-6.3 3.6 1-7.2-5.4-4.9 7.1-1.3 3-6.6 3.5 6.4 7.2.8-5 5.2zm32-45.2l-14.5-7-13.9 7.8 2.3-15.7-11.8-10.8 15.7-2.8 6.6-14.4 7.6 14 15.8 1.8-11 11.5zm-65.8-63l-17-8.5-16.5 9.1 2.8-18.6-13.8-13 18.7-3 8-17 8.7 16.7 18.8 2.3-13.3 13.4zm-60.8 65.4l-17-10-17 10.3 4.3-19.3-15.1-13 19.7-1.8 7.7-18.3 7.9 18.2 19.8 1.6-14.9 13z"
    />
  </svg>
	),
	PH: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#0038a8" d="M0 0h640v240H0z" />
    <path fill="#ce1126" d="M0 240h640v240H0z" />
    <path fill="#fff" d="M415.7 240L0 480V0" />
    <g fill="#fcd116">
      <path d="M26.7 42.4L41 55l16.6-9.2-7.4 17.5 14 13-19-1.6-8.1 17.2-4.3-18.5L14 71l16.3-10zm323.8 172.3l.4 19 18 6.3-18 6.2-.4 19-11.5-15.1-18.2 5.5 10.8-15.6-10.8-15.6 18.2 5.5zM37.2 388.1l8 17.2 19-1.6-13.9 13 7.4 17.5-16.6-9.1-14.4 12.4 3.6-18.7L14 409l18.9-2.4zM151.4 139.1l-6.2 6.2 3.1 47-3 .3-5.7-42.9-5.1 5 7.6 38.4a47.5 47.5 0 0 0-17.2 7.1l-21.7-32.4H96l26.4 34.3a48 48 0 0 0-2.4 2l-31.1-35.5h-8.8v8.8l35.4 31-2 2.5-34.3-26.3v7.1l32.5 21.7c-3.4 5.2-5.9 11-7.1 17.2L66.3 223l-5.1 5 42.9 5.7c-.2 1-.3 2.1-.3 3.1l-47-3-6.2 6.2 6.2 6.2 47-3.1.3 3.1-42.9 5.7 5 5 38.4-7.6a47.5 47.5 0 0 0 7.1 17.2l-32.5 21.7v7.2l34.3-26.3a48 48 0 0 0 2 2.4l-35.4 31v8.8H89l31-35.4 2.5 2L96 312.2h7.2l21.7-32.5c5.1 3.4 11 5.9 17.2 7.1l-7.6 38.4 5 5 5.7-42.9c1 .2 2 .3 3.1.3l-3 47 6.1 6.2 6.3-6.2-3.1-47 3-.3 5.7 43 5.1-5.1-7.6-38.4a47.5 47.5 0 0 0 17.2-7.1l21.7 32.5h7.2l-26.4-34.3a48 48 0 0 0 2.4-2l31.1 35.4h8.8v-8.8l-35.4-31 2-2.4 34.3 26.3v-7.2l-32.5-21.7c3.4-5.1 5.9-11 7.1-17.2l38.3 7.6 5.1-5-42.9-5.7c.2-1 .3-2 .3-3.1l47 3 6.2-6.1-6.2-6.2-47 3-.3-3 42.9-5.7-5-5-38.4 7.5a47.5 47.5 0 0 0-7.1-17.2l32.5-21.7v-7.1l-34.3 26.3a48 48 0 0 0-2-2.4l35.4-31v-8.9H214l-31 35.5a48 48 0 0 0-2.5-2l26.4-34.3h-7.2L178 200.2c-5.1-3.4-11-5.9-17.2-7.1l7.6-38.3-5-5-5.7 42.8-3.1-.3 3-47z" />
    </g>
  </svg>
	),
	PK: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-52.3 0h682.6v512H-52.3z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="translate(49) scale(.9375)"
    >
      <path fill="#0c590b" d="M-95 0h768v512H-95z" />
      <path fill="#fff" d="M-95 0H97.5v512H-95z" />
      <g fill="#fff">
        <path d="M403.7 225.4l-31.2-6.6-16.4 27.3-3.4-31.6-31-7.2 29-13-2.7-31.7 21.4 23.6 29.3-12.4-15.9 27.6 21 24z" />
        <path d="M415.4 306a121.2 121.2 0 0 1-161.3 59.4 122.1 122.1 0 0 1-59.5-162.1A118.6 118.6 0 0 1 266 139a156.2 156.2 0 0 0-11.8 10.9A112.3 112.3 0 0 0 415.5 306z" />
      </g>
    </g>
  </svg>
	),
	PL: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#fff" d="M640 480H0V0h640z" />
      <path fill="#dc143c" d="M640 480H0V240h640z" />
    </g>
  </svg>
	),
	PM: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#00267f" d="M0 0h213.3v480H0z" />
      <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	PR: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-37.3 0h682.7v512H-37.3z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(35) scale(.9375)"
    >
      <path fill="#ed0000" d="M-37.3 0h768v512h-768z" />
      <path
        fill="#fff"
        d="M-37.3 102.4h768v102.4h-768zm0 204.8h768v102.4h-768z"
      />
      <path fill="#0050f0" d="M-37.3 0l440.7 255.7L-37.3 511V0z" />
      <path
        fill="#fff"
        d="M156.4 325.5L109 290l-47.2 35.8 17.6-58.1-47.2-36 58.3-.4 18.1-58 18.5 57.8 58.3.1-46.9 36.3 18 58z"
      />
    </g>
  </svg>
	),
	PS: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-118 0h682.7v512H-118z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="translate(110.6) scale(.9375)">
      <g fillRule="evenodd" strokeWidth="1pt">
        <path d="M-246 0H778v170.7H-246z" />
        <path fill="#fff" d="M-246 170.7H778v170.6H-246z" />
        <path fill="#090" d="M-246 341.3H778V512H-246z" />
        <path fill="red" d="M-246 512l512-256L-246 0v512z" />
      </g>
    </g>
  </svg>
	),
	PT: () => (
  <svg viewBox="0 0 640 480">
    <path fill="red" d="M256 0h384v480H256z" />
    <path fill="#060" d="M0 0h256v480H0z" />
    <g
      fill="#ff0"
      fillRule="evenodd"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.6}
    >
      <path d="M339.5 306.2c-32.3-1-180-93.2-181-108l8.1-13.5c14.7 21.3 165.7 111 180.6 107.8l-7.7 13.7" />
      <path d="M164.9 182.8c-2.9 7.8 38.6 33.4 88.4 63.8 49.9 30.3 92.9 49 96 46.4l1.5-2.8c-.6 1-2 1.3-4.3.6-13.5-3.9-48.6-20-92.1-46.4-43.6-26.4-81.4-50.7-87.3-61a6.3 6.3 0 0 1-.6-3.1h-.2l-1.2 2.2-.2.3zm175.3 123.8c-.5 1-1.6 1-3.5.8-12-1.3-48.6-19.1-91.9-45-50.4-30.2-92-57.6-87.4-64.8l1.2-2.2.2.1c-4 12.2 82.1 61.4 87.2 64.6 49.8 30.8 91.8 48.9 95.5 44.2l-1.3 2.3z" />
      <path d="M256.2 207.2c32.2-.3 72-4.4 95-13.6l-5-8c-13.5 7.5-53.5 12.5-90.3 13.2-43.4-.4-74.1-4.5-89.5-14.8l-4.6 8.6c28.2 12 57.2 14.5 94.4 14.6" />
      <path d="M352.5 193.8c-.8 1.3-15.8 6.4-37.8 10.2a381.2 381.2 0 0 1-58.6 4.3 416.1 416.1 0 0 1-56.2-3.6c-23.1-3.6-35-8.6-39.5-10.4l1.1-2.2c12.7 5 24.7 8 38.7 10.2A411.5 411.5 0 0 0 256 206a391.8 391.8 0 0 0 58.3-4.3c22.5-3.7 34.8-8.4 36.6-10.5l1.6 2.7zm-4.4-8.1c-2.4 2-14.6 6.3-36 9.7a388.2 388.2 0 0 1-55.8 4c-22 0-40.1-1.6-53.8-3.6-21.8-2.8-33.4-8-37.6-9.4l1.3-2.2c3.3 1.7 14.4 6.2 36.5 9.3a385 385 0 0 0 53.6 3.4 384 384 0 0 0 55.4-4c21.5-3 33.1-8.4 34.9-9.8l1.5 2.6zM150.3 246c19.8 10.7 63.9 16 105.6 16.4 38 .1 87.4-5.8 105.9-15.6l-.5-10.7c-5.8 9-58.8 17.7-105.8 17.4-47-.4-90.7-7.6-105.3-17v9.5" />
      <path d="M362.8 244.5v2.5c-2.8 3.4-20.2 8.4-42 12a434 434 0 0 1-65.4 4.4 400 400 0 0 1-62-4.3 155 155 0 0 1-44.4-12v-2.9c9.7 6.4 35.9 11.2 44.7 12.6 15.8 2.4 36.1 4.2 61.7 4.2 26.9 0 48.4-1.9 65-4.4 15.7-2.3 38-8.2 42.4-12.1zm0-9v2.5c-2.8 3.3-20.2 8.3-42 11.9a434 434 0 0 1-65.4 4.5 414 414 0 0 1-62-4.3 155 155 0 0 1-44.4-12v-3c9.7 6.5 36 11.2 44.7 12.6a408 408 0 0 0 61.7 4.3c26.9 0 48.5-2 65-4.5 15.7-2.2 38-8.1 42.4-12zm-107 68.8c-45.6-.2-84.7-12.4-93-14.4l6 9.4a249.8 249.8 0 0 0 87.4 14.3c34.7-1 65-3.7 86.3-14.1l6.2-9.8c-14.5 6.9-64 14.6-93 14.6" />
      <path d="M344.9 297.3a143 143 0 0 1-2.8 4c-10 3.6-26 7.4-32.6 8.4a295.5 295.5 0 0 1-53.7 5c-40.4-.6-73.5-8.5-89-15.3l-1.3-2.1.2-.4 2.1.9a286.5 286.5 0 0 0 88.2 14.5c18.8 0 37.5-2.1 52.6-4.8 23.2-4.7 32.6-8.2 35.5-9.8l.7-.4zm5.3-8.8a287.2 287.2 0 0 1-2 3.5c-5.4 2-20 6.2-41.3 9.2-14 1.9-22.7 3.8-50.6 4.3a347.4 347.4 0 0 1-94.2-14L161 289a390 390 0 0 0 95.4 14c25.5-.5 36.4-2.4 50.3-4.3 24.8-3.8 37.3-8 41-9.1a2.9 2.9 0 0 0 0-.2l2.6-1z" />
      <path d="M350.8 237.6c.1 30-15.3 57-27.6 68.8a99.3 99.3 0 0 1-67.8 28.2c-30.3.5-58.8-19.2-66.5-27.9a101 101 0 0 1-27.5-67.4c1.8-32.8 14.7-55.6 33.3-71.3a99.6 99.6 0 0 1 64.2-22.7 98.2 98.2 0 0 1 71 35.6c12.5 15.2 18 31.7 20.9 56.7zM255.6 135a106 106 0 0 1 106 105.2 105.6 105.6 0 1 1-211.4 0c-.1-58 47.3-105.2 105.4-105.2" />
      <path d="M255.9 134.5c58.2 0 105.6 47.4 105.6 105.6S314.1 345.7 256 345.7s-105.6-47.4-105.6-105.6c0-58.2 47.4-105.6 105.6-105.6zM152.6 240c0 56.8 46.7 103.3 103.3 103.3 56.6 0 103.3-46.5 103.3-103.3s-46.7-103.3-103.3-103.3S152.6 183.2 152.6 240z" />
      <path d="M256 143.3a97 97 0 0 1 96.7 96.7 97.1 97.1 0 0 1-96.7 96.8c-53 0-96.7-43.6-96.7-96.8a97.1 97.1 0 0 1 96.7-96.7zM161.6 240c0 52 42.6 94.4 94.4 94.4s94.4-42.5 94.4-94.4c0-52-42.6-94.4-94.4-94.4a94.8 94.8 0 0 0-94.4 94.4z" />
      <path d="M260.3 134h-9.1v212.3h9z" />
      <path d="M259.3 132.8h2.3v214.7h-2.2V132.8zm-9 0h2.4v214.7h-2.3V132.8z" />
      <path d="M361.6 244.2v-7.8l-6.4-6-36.3-9.6-52.2-5.3-63 3.2-44.8 10.6-9 6.7v7.9l22.9-10.3 54.4-8.5h52.3l38.4 4.2 26.6 6.4z" />
      <path d="M256 223.8c24.9 0 49 2.3 68.3 6 19.8 4 33.7 9 38.5 14.5v2.8c-5.8-7-24.5-12-39-15-19-3.6-43-6-67.9-6-26.1 0-50.5 2.6-69.3 6.2-15 3-35.1 9-37.6 14.8v-2.9c1.3-4 16.3-10 37.3-14.3 18.9-3.7 43.3-6.1 69.6-6.1zm0-9.1a383 383 0 0 1 68.3 6c19.8 4 33.7 9 38.5 14.6v2.7c-5.8-6.9-24.5-12-39-14.9-19-3.7-43-6-67.9-6a376 376 0 0 0-69.2 6.2c-14.5 2.7-35.4 8.9-37.7 14.7v-2.8c1.4-4 16.6-10.3 37.3-14.3 19-3.7 43.3-6.2 69.7-6.2zm-.6-46.2c39.3-.2 73.6 5.5 89.3 13.5l5.7 10c-13.6-7.4-50.6-15-94.9-14-36.1.3-74.7 4-94 14.4l6.8-11.4c15.9-8.3 53.3-12.5 87.1-12.5" />
      <path d="M256 176.7a354 354 0 0 1 61.3 4.3c16 3 31.3 7.4 33.5 9.8l1.7 3c-5.3-3.4-18.6-7.3-35.6-10.5s-38.7-4.3-61-4.2c-25.3-.1-45 1.2-61.8 4.2a108.9 108.9 0 0 0-33.3 10.3l1.7-3.1c6-3 15.3-6.7 31.1-9.6 17.5-3.2 37.4-4.1 62.4-4.2zm0-9c21.4-.2 42.6 1 59.1 4a96 96 0 0 1 30.6 10l2.5 4c-4.2-4.7-20-9.2-34.1-11.6-16.4-2.9-36.7-4-58.1-4.2a361 361 0 0 0-59.5 4.4 97.3 97.3 0 0 0-29.6 9.1l2.2-3.3c5.8-3 15.2-5.8 27-8.1a357 357 0 0 1 59.9-4.4zM308.4 284a276.4 276.4 0 0 0-52.5-4c-65.5.8-86.6 13.5-89.2 17.3l-5-8c16.8-12 52.4-18.8 94.6-18.2 21.9.4 40.8 1.9 56.6 5l-4.5 8" />
      <path d="M255.6 278.9c18.2.3 36 1 53.3 4.2l-1.2 2.2c-16-3-33.2-4-52-4-24.3-.2-48.7 2.1-70 8.2-6.7 1.9-17.8 6.2-19 9.8l-1.2-2c.4-2.2 7-6.6 19.6-10 24.4-7 47.2-8.3 70.5-8.4zm.8-9.2a327 327 0 0 1 57.3 5l-1.3 2.3a299 299 0 0 0-56-4.9c-24.2 0-49.9 1.8-73.3 8.6-7.5 2.2-20.6 7-21 10.7l-1.2-2.2c.2-3.4 11.5-7.9 21.7-10.8 23.5-6.9 49.3-8.6 73.8-8.7z" />
      <path d="M349.4 290.5l-7.8 12.3-22.7-20.1-58.6-39.5-66.2-36.3-34.3-11.7 7.3-13.6 2.5-1.3 21.3 5.3 70.4 36.3 40.6 25.6L336 272l13.9 16z" />
      <path d="M158.6 195.5c6-4 50.2 15.6 96.6 43.6 46.1 28 90.3 59.6 86.3 65.5l-1.3 2.1-.6.5c.1-.1.8-1 0-3.1-2-6.5-33.4-31.5-85.3-62.9-50.7-30.1-92.9-48.3-97-43.1l1.3-2.6zM351 290.4c3.8-7.6-37.2-38.5-88.1-68.6-52-29.5-89.6-46.9-96.5-41.7L165 183c0 .1 0-.2.4-.5 1.2-1 3.3-1 4.2-1 11.8.2 45.5 15.7 92.8 42.8 20.8 12 87.6 55 87.3 67 0 1 .1 1.2-.3 1.8l1.7-2.6z" />
    </g>
    <g transform="translate(0 26.7) scale(1.06667)">
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={0.7}
        d="M180.6 211a58.7 58.7 0 0 0 17.5 41.7 59 59 0 0 0 41.8 17.6 59.4 59.4 0 0 0 42-17.4 59 59 0 0 0 17.4-41.8v-79.2l-118.7-.2V211z"
      />
      <path
        fill="red"
        stroke="#000"
        strokeWidth={0.5}
        d="M182.8 211.1a56.4 56.4 0 0 0 16.8 40 57 57 0 0 0 40.2 16.8 56.9 56.9 0 0 0 40.2-16.6 56.4 56.4 0 0 0 16.7-40v-77H183v76.8m91-53.7v48.9l-.1 5.1a33.2 33.2 0 0 1-10 24 34 34 0 0 1-24 10c-9.4 0-17.7-4-23.9-10.2a34 34 0 0 1-10-24v-54l68 .2z"
      />
      <g id="prefix__e">
        <g id="prefix__d" fill="#ff0" stroke="#000" strokeWidth={0.5}>
          <path
            stroke="none"
            d="M190.2 154.4c.1-5.5 4-6.8 4-6.8.1 0 4.3 1.4 4.3 6.9h-8.3"
          />
          <path d="M186.8 147.7l-.7 6.3h4.2c0-5.2 4-6 4-6 .1 0 4 1.1 4.1 6h4.2l-.8-6.4h-15zm-1 6.4h17c.3 0 .6.3.6.7 0 .5-.3.8-.6.8h-17c-.3 0-.6-.3-.6-.8 0-.4.3-.7.7-.7z" />
          <path d="M192 154c0-3.3 2.3-4.2 2.3-4.2s2.3 1 2.3 4.2H192m-5.8-9h16.3c.3 0 .6.4.6.8 0 .3-.3.6-.6.6h-16.3c-.3 0-.6-.3-.6-.7 0-.3.3-.6.6-.6zm.4 1.5H202c.3 0 .6.3.6.7 0 .4-.3.7-.6.7h-15.5c-.4 0-.6-.3-.6-.7 0-.4.2-.7.6-.7zm5-10.6h1.2v.8h.9v-.8h1.3v.9h.9v-1h1.2v2c0 .4-.2.6-.5.6h-4.4c-.3 0-.6-.2-.6-.5v-2zm4.6 2.7l.3 6.4h-4.3l.3-6.5h3.7" />
          <path id="prefix__a" d="M191 141.6v3.4h-4v-3.4h4z" />
          <use width="100%" height="100%" x={10.6} xlinkHref="#prefix__a" />
          <path
            id="prefix__b"
            d="M186.3 139h1.2v1h.9v-1h1.2v1h.9v-1h1.2v2c0 .4-.2.6-.5.6h-4.3a.6.6 0 0 1-.6-.6v-2z"
          />
          <use width="100%" height="100%" x={10.6} xlinkHref="#prefix__b" />
          <path
            fill="#000"
            stroke="none"
            d="M193.9 140.6c0-.6.9-.6.9 0v1.6h-.9v-1.6"
          />
          <path
            id="prefix__c"
            fill="#000"
            stroke="none"
            d="M188.6 142.8c0-.6.8-.6.8 0v1.2h-.8v-1.2"
          />
          <use width="100%" height="100%" x={10.6} xlinkHref="#prefix__c" />
        </g>
        <use width="100%" height="100%" y={46.3} xlinkHref="#prefix__d" />
        <use
          width="100%"
          height="100%"
          transform="rotate(-45.2 312.8 180)"
          xlinkHref="#prefix__d"
        />
      </g>
      <use width="100%" height="100%" x={45.7} xlinkHref="#prefix__d" />
      <use
        width="100%"
        height="100%"
        transform="matrix(-1 0 0 1 479.8 0)"
        xlinkHref="#prefix__e"
      />
      <g id="prefix__f" fill="#fff">
        <path
          fill="#039"
          d="M232.6 202.4a8.3 8.3 0 0 0 2.2 5.7 7.2 7.2 0 0 0 5.3 2.4c2.1 0 4-1 5.3-2.4a8.3 8.3 0 0 0 2.2-5.7v-10.8h-15v10.8"
        />
        <circle cx={236.1} cy={195.7} r={1.5} />
        <circle cx={244.4} cy={195.7} r={1.5} />
        <circle cx={240.2} cy={199.7} r={1.5} />
        <circle cx={236.1} cy={203.9} r={1.5} />
        <circle cx={244.4} cy={203.9} r={1.5} />
      </g>
      <use width="100%" height="100%" y={-26} xlinkHref="#prefix__f" />
      <use width="100%" height="100%" x={-20.8} xlinkHref="#prefix__f" />
      <use width="100%" height="100%" x={20.8} xlinkHref="#prefix__f" />
      <use width="100%" height="100%" y={25.8} xlinkHref="#prefix__f" />
    </g>
  </svg>
	),
	PW: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-70.3 0h640v480h-640z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="translate(70.3)"
    >
      <path fill="#4aadd6" d="M-173.4 0h846.3v480h-846.3z" />
      <path
        fill="#ffde00"
        d="M335.6 232.1a135.9 130.1 0 1 1-271.7 0 135.9 130.1 0 1 1 271.7 0z"
      />
    </g>
  </svg>
	),
	PY: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#0038a8" d="M0 319.7h640V480H0z" />
    <path fill="#fff" d="M0 160h640v160H0z" />
    <path fill="#d52b1e" d="M0 0h640v160H0z" />
    <g fill="none" stroke="#000" transform="translate(-116.4) scale(1.45455)">
      <circle cx={300} cy={165} r={42.2} strokeWidth={1.1} />
      <circle cx={300} cy={165} r={34.7} strokeWidth={0.5} />
      <circle cx={300} cy={165} r={26.6} strokeWidth={0.4} />
    </g>
    <path d="M287.3 263.7l-7.1 4.2-2.2-3.7a6.2 6.2 0 0 1-.7-1.6 2 2 0 0 1 .1-1.3c.2-.4.5-.7 1-1 .4-.2.7-.3 1.1-.3a2.3 2.3 0 0 1 1.1.2l.8.6v-1.3l.3-.5 1.5-2.3 1.4 2.5-1.4 2.4-.3.8.1.6.1.2 3-1.7zm-5.5.3l-.6-1-.4-.5a.7.7 0 0 0-.5-.2.8.8 0 0 0-.5.1l-.4.6c0 .2.1.5.4.9l.5 1zm-6.7-5.5l-2.2-6.5 1.7-.6 1.3 4.1 1.3-.4-1.3-3.8 1.6-.5 1.3 3.7 1.5-.5-1.4-4.2 1.8-.5 2.2 6.6zm-2.9-9.7l-.4-4.2c-.2-1 0-1.6.4-2.1.4-.6 1-.9 1.8-1 .8 0 1.5.1 2 .6.5.4.8 1.2 1 2.2l.1 1.4 3-.4.4 2.6zm3.3-3l-.1-.6c0-.5-.2-.8-.4-1a.8.8 0 0 0-.7-.2 1 1 0 0 0-.6.4c-.2.1-.2.5-.2 1l.1.7zm-3.5-12.5l.3-2.6 4.8.6a4.2 4.2 0 0 1 1.4.4c.4.2.8.4 1 .8.4.3.5.7.6 1 .2.6.2 1.2.1 1.9l-.2 1.3c-.1.5-.3.8-.5 1.1a3 3 0 0 1-1.8 1.3h-1.4l-4.9-.5.3-2.5 5 .5c.4 0 .8 0 1-.2.4-.2.5-.6.6-1a1.4 1.4 0 0 0-.3-1c-.2-.4-.6-.5-1-.6zm1-6l1.7-4.6c.2-.8.6-1.3 1.1-1.5a2 2 0 0 1 1.6-.2c.5.2.8.5 1 .9.2.3.3.6.3 1 .3-.5.7-.8 1.1-1a2 2 0 0 1 1.4 0 2.2 2.2 0 0 1 1.5 1.8v1l-.3 1-1.5 4.2zm4-1.4l.4-1.1c0-.4.1-.7 0-.8 0-.2-.2-.4-.4-.5a.7.7 0 0 0-.6 0c-.2.2-.4.4-.5.8l-.4 1zm3 1l.5-1.2c.1-.4.2-.7 0-1a.8.8 0 0 0-.4-.4.7.7 0 0 0-.7 0l-.5.9-.4 1.2zm-3-9.6l1.3-2.2 5.4 3.2 2-3.4 1.8 1-3.4 5.6zm5-7.6l1.6-2 6.4 5.3-1.6 2zm11.1-4.3l2.2-1c.3.6.4 1.2.5 1.7a3.1 3.1 0 0 1-.3 1.5 4.5 4.5 0 0 1-1.2 1.5 4 4 0 0 1-2 1.1 3.5 3.5 0 0 1-2 0 4.7 4.7 0 0 1-2-1.6c-1-1-1.4-2-1.3-3.1a4.2 4.2 0 0 1 1.6-2.9 4.2 4.2 0 0 1 2.3-1c.7-.1 1.5 0 2.3.5l-1.4 1.9a1.9 1.9 0 0 0-.6-.3 1.5 1.5 0 0 0-.7 0 1.5 1.5 0 0 0-.6.4 1.5 1.5 0 0 0-.6 1.4c0 .4.4.9.8 1.4.6.7 1.1 1.1 1.6 1.2.4 0 .8 0 1.2-.4.4-.3.6-.6.6-1s-.1-.8-.4-1.3zm8.8-3.2l-2.5 1.4.3 1.4-2.3 1.2-1.2-8.7 2.5-1.3 6.6 5.8-2.4 1.3zm-1.3-1.3l-2.2-2.2.6 3zm7.8-8.5l3.8-.6a4.6 4.6 0 0 1 1.8 0c.5.1 1 .3 1.3.7s.7.7.9 1.2c.2.4.4 1 .4 1.5.2.9.2 1.6.1 2a3.4 3.4 0 0 1-.6 1.4 2.7 2.7 0 0 1-1 .9 6 6 0 0 1-1.5.5l-3.7.6zm2.9 1.4l.8 4.5.6-.1c.5-.1.9-.2 1-.4.3-.1.4-.4.5-.7v-1.4c-.2-.9-.5-1.4-.8-1.7-.3-.3-.8-.4-1.5-.3zm7.8-2.8l6.8.3v1.8l-4.3-.2-.1 1.3 4 .2-.1 1.7-4-.2v1.6l4.4.2-.1 1.9-7-.3zm10 .8l2.4.6-1.5 6 4 1-.6 2-6.3-1.6zm13.2 4.4l3.7 2.2c.8.4 1.3 1 1.4 1.6.2.6 0 1.3-.3 2a2.5 2.5 0 0 1-1.7 1.3c-.6.1-1.4 0-2.3-.6l-1.2-.7-1.6 2.6-2.2-1.3zm.4 4.4l.6.3 1 .3a.8.8 0 0 0 .6-.4 1 1 0 0 0 0-.7c0-.3-.2-.5-.6-.8l-.6-.3zm7.2 9.6l-2.1-2-1.2.7-2-1.7 8-4 2 2-3.4 8.1-2-1.8zm.8-1.7l1.4-2.8-2.7 1.6zm1 5.5l6.9-4.7 2.3 3.5 1 1.7-.1 1.2a2.3 2.3 0 0 1-1 1.1c-.3.3-.7.4-1 .4a2.3 2.3 0 0 1-1.2-.2c-.2 0-.5-.3-.8-.5l.2.7-.2.6a3.3 3.3 0 0 1-.2.6l-1.3 2.3-1.6-2.3 1.3-2.6.3-.7a1 1 0 0 0-.2-.7l-.1-.2-2.8 2zm5.5-.6l.7.9.4.4c.2.2.3.2.5.2a.8.8 0 0 0 .5-.1.8.8 0 0 0 .3-.6c0-.2 0-.5-.3-.9l-.7-.9zm2.6 12.4l-1-2.8-1.5.2-1-2.5 8.9-.1 1 2.6-6.5 6-1-2.6zm1.5-1.2l2.4-2-3.1.3zm2.1 9l1.7-.2.6 3.9-3.5.5a8 8 0 0 1-1.3-1.8 6.8 6.8 0 0 1-.6-2 5 5 0 0 1 .1-2.5 4 4 0 0 1 1.3-1.6 4.9 4.9 0 0 1 2.2-.9 5 5 0 0 1 2.4.2 3.6 3.6 0 0 1 1.7 1.4c.4.6.6 1.3.8 2.2v2a2.7 2.7 0 0 1-.6 1.3c-.3.4-.7.6-1.2.9l-.8-2.4c.3-.1.5-.3.7-.6s.1-.6 0-1a1.7 1.7 0 0 0-.7-1.2c-.4-.3-1-.4-2-.2a3 3 0 0 0-1.7.7c-.4.4-.5 1-.4 1.5 0 .3.1.6.3.8l.5.8h.8zm5.4 12l-.2 2.6-5-.4a4.2 4.2 0 0 1-1.3-.4 3 3 0 0 1-1-.8 3 3 0 0 1-.6-1.1 5.1 5.1 0 0 1-.2-1.8l.2-1.3.5-1.2a3 3 0 0 1 .8-.8 2.6 2.6 0 0 1 1-.4 4.9 4.9 0 0 1 1.4-.2l5 .5-.3 2.5-5-.4c-.5 0-.9 0-1.1.3a1.4 1.4 0 0 0-.5 1c0 .4 0 .8.3 1 .2.3.5.5 1 .5zm-9.1 8.8l.9-2.8-1.2-.8.8-2.5 7 5.6-1 2.6-8.8.4.9-2.5zm1.9 0l3 .1-2.5-1.8zm3 6.8l-1.5 2.4h-3.3l1.5 2.9-1.4 2.4-2.5-5.2-3-1.8 1.4-2.2 3 1.8z" />
    <g fill="#009b3a" stroke="#000" strokeWidth={0.1}>
      <path d="M328.1 211.3s23.4 10.1 19.3 30.9c-4 20.8-17 20.6-22.2 23-5 2.2-8.6 5.5-10.6 5-2-.4-4.7-2-4.7-2s-.2 3.5 3.9 4c4.1.7 9.5-5.3 12-6 2.6-.6 18.5-2.4 22.4-23.5 4.5-22.6-20-30.7-20-31.4z" />
      <path d="M339.9 215.8a3.2.8 75.1 0 1-1.5 0 3.2.8 75.1 1 1 1.5 0z" />
      <path d="M339.1 216a3.3.7 63.3 1 1-1.4.5 3.3.7 63.3 0 1 1.4-.5zm-2.3 1.5a3.1.8 17 0 1-.2 1.6 3.1.8 17 0 1 .2-1.6z" />
      <path d="M337.1 216.7a3.3.7 34.2 1 1-.7 1.3 3.3.7 34.2 1 1 .7-1.3z" />
      <path d="M338.1 216.3a3.3.7 46.2 1 1-1 1 3.3.7 46.2 0 1 1-1z" />
      <path d="M339.7 219.2l-1 .6c-.3 0-.6-.3-1.2 0s-1 .9-1.1 1.2c-.1.3.2.5.9.1.7-.3.9-.9 1.2-1.1l1.3-.7.8-1.3c.3-.4 1.2-1 1.6-1.8.3-.6.2-1.1-.2-.9a3 3 0 0 0-1.2 1.3c-.2.4 0 1-.3 1.4l-.8 1.2zm7.3 2.4a1 4.8-1.6 1 1-2.2-.5 1 4.8-1.6 1 1 2.2.5z" />
      <path d="M345.8 221.5a5 1 77.5 1 1-2.2.1 5 1 77.5 1 1 2.1 0z" />
      <path d="M342 222.7a4.7 1.1 35 1 1-.7 2.2 4.7 1.1 35 1 1 .7-2.2z" />
      <path d="M342.8 221.6a5 1 50.9 0 1-1.4 1.6 5 1 50.9 1 1 1.4-1.5z" />
      <path d="M344.3 221.5a5.1 1 61.8 1 1-1.8 1 5.1 1 61.8 1 1 1.8-1z" />
      <path d="M345.6 226.4l-1.8.4c-.3 0-.6-.7-1.5-.5-.9.2-1.7.8-2 1.2-.2.4.1.8 1.2.6 1.2-.2 1.6-1 2.2-1 .5-.2 1.4-.4 2-.4.2-.4 1-1.2 1.5-1.6.5-.5 2-1 2.7-1.8.7-.8.7-1.6 0-1.5a4.8 4.8 0 0 0-2 1.3c-.5.6-.4 1.5-.9 2l-1.4 1.3zm5.1 4.9a1 4.8 8.7 1 1-2-1 1 4.8 8.7 1 1 2 1z" />
      <path d="M349.6 231a1 5-2 1 1-2-.3 1 5-2 1 1 2 .3z" />
      <path d="M345.7 231.4a4.7 1.1 46 1 1-1 2 4.7 1.1 46 1 1 1-2z" />
      <path d="M346.7 230.5a5 1 61.8 1 1-1.7 1.3 5 1 61.8 1 1 1.7-1.3z" />
      <path d="M348.1 230.7a5.1 1 72.5 1 1-1.9.7 5.1 1 72.5 1 1 2-.7z" />
      <path d="M348.5 235.8h-1.7c-.3 0-.5-.8-1.4-.8a3.3 3.3 0 0 0-2.1.8c-.4.4-.1.8 1 .8s1.7-.5 2.3-.6h2l1.8-1.2c.6-.4 2.1-.6 3-1.3.7-.6.9-1.4.3-1.4a5 5 0 0 0-2.3.9c-.5.4-.6 1.3-1.2 1.7-.4.2-1.6 1.1-1.7 1m2.5 6.4a1 4.8 31.3 0 1-1.4-1.7 1 4.8 31.3 0 1 1.4 1.7" />
      <path d="M350.1 241.3a1 5 20.6 0 1-1.8-1.1 1 5 20.6 0 1 1.8 1.1m-3.7-1.2a4.8 1 70 0 1-1.8 1.5 4.8 1 70 0 1 1.8-1.5" />
      <path d="M347.6 239.7a1 5.1-4.9 0 1-2 .5 1 5.1-4.9 1 1 2-.5" />
      <path d="M349 240.4a1 5.2 5.5 1 1-2-.1 1 5.2 5.5 1 1 2 .1" />
      <path d="M347.3 245.3s-1.4-.5-1.6-.7c-.3-.2-.1-.8-1-1.3a3.1 3.1 0 0 0-2.2 0c-.5 0-.4.6.6 1 1 .6 1.8.2 2.3.4l1.8.9c.5-.2 1.6-.3 2.2-.4.6-.1 2.1.4 3.2 0 .9-.3 1.3-1 .7-1.2a4.5 4.5 0 0 0-2.3 0c-.7.1-1.1 1-1.8 1-.5 0-1.9.4-2 .3m1 7.7a1.3 5.5 48.5 1 1-1.1-2.4 1.3 5.5 48.5 1 1 1 2.4" />
      <path d="M347.3 251.9a1.2 5.8 37.5 1 1-1.5-2 1.2 5.8 37.5 1 1 1.5 2" />
      <path d="M343.7 249.2a1.3 5.5-3.5 1 1-2.4 1 1.3 5.5-3.5 1 1 2.4-1" />
      <path d="M345.1 249.2a1.2 5.9 11.6 0 1-2.3-.2 1.2 5.9 11.6 1 1 2.3.1" />
      <path d="M346.3 250.4a1.2 6 22.1 1 1-2.1-.8 1.2 6 22.1 1 1 2.1.8" />
      <path d="M343 255.3a16.3 16.3 0 0 1-1.6-1.4c-.2-.3.1-1-.7-1.8s-1.8-1-2.4-1c-.6.1-.6.7.3 1.6 1 1 2 .8 2.4 1.2.6.4 1.4 1.1 1.7 1.6l2.6.4c.7 0 2.2 1.1 3.5 1.1 1 0 1.8-.5 1.2-1a5.3 5.3 0 0 0-2.6-1c-.8 0-1.5.8-2.2.6l-2.3-.3m-2.3 7.3a1.4 6 79.8 1 1 .3-2.9 1.4 6 79.8 1 1-.3 2.9" />
      <path d="M340.5 261a1.3 6.4 68.5 0 1-.5-2.6 1.3 6.4 68.5 0 1 .5 2.7" />
      <path d="M338.4 256.4a1.4 6 26.2 0 1-2.8-.5 1.4 6 26.2 1 1 2.8.5" />
      <path d="M339.9 257.2a1.3 6.5 41.8 0 1-2.3-1.5 1.3 6.5 41.8 0 1 2.3 1.5" />
      <path d="M340.3 259.1a1.3 6.5 52.7 1 1-1.6-2 1.3 6.5 52.7 0 1 1.6 2" />
      <path d="M334.4 261.7a18.1 18.1 0 0 1-.7-2.2c-.1-.4.6-.8.3-2a4.3 4.3 0 0 0-1.9-2.3c-.5-.3-.9.2-.5 1.6.4 1.4 1.4 1.9 1.7 2.6l.8 2.4 2.2 1.9c.6.5 1.5 2.4 2.7 3.1 1 .7 2 .5 1.8-.2a6.2 6.2 0 0 0-2-2.4c-.7-.6-1.8-.3-2.5-.8-.4-.5-2-1.6-2-1.7" />
      <path d="M330.8 268a1.8 6.1 89 0 1 0-3.5 1.8 6.1 89 0 1 0 3.5" />
      <path d="M330 262.5a1.7 6.3 37.6 0 1-2.7-2.2 1.7 6.3 37.6 1 1 2.6 2.2" />
      <path d="M330.8 265.3a1.7 6.2 66.5 0 1-1.2-3.3 1.7 6.2 66.5 0 1 1.2 3.3m1.7-53.4a3.8.8 41.1 0 1-1.5.8 3.8.8 41.1 1 1 1.5-.8m-1.9 1.5a3.9.8 8.2 0 1 .3 1.6 3.9.8 8.2 1 1-.3-1.6" />
      <path d="M331.4 212.4a4 .7 26.8 1 1-.8 1.3 4 .7 26.8 0 1 .8-1.3M303.7 262s5.1 1.1 9.6 2.7c4.5 1.7 11.3 7.2 13.1 7.6 2 0 4.9-.7 6-3.6-3.2.8-5 2.1-8 .5-1.1-.4-4.6-3.6-8.5-5.3-3.8-1.7-11.5-3.6-11.5-3.6l-.7 1.7m5.5-46.5l5.9-3.1-6.5 1.7-.8 1.1 1.4.3" />
      <path d="M314.8 217c-2.3-.5-5.8-1.3-8-1.4 1.5-1.7 3.6-4.7 5-6.4-1 1.7-2.3 4-2.8 5.5 1.5.9 4 1.6 5.8 2.2" />
      <path d="M308.1 215.9a314.4 314.4 0 0 1 5.3-4.1l-6.1 2.7-.6 1.3h1.4" />
      <path d="M313.7 216.9c-2.3-.5-5.8-1.3-8-1.5 1.4-1.7 3.5-4.7 4.8-6.6-.8 1.8-2.2 4.1-2.7 5.8 1.6.9 4.1 1.6 6 2.3" />
      <path d="M307.3 216.2l6.1-2.6-6.6 1.1-.9 1 1.3.5" />
      <path d="M313 217c-2.3-.3-6-.7-8.2-.6 1.3-2 3-5.3 4.1-7.3-.6 1.9-1.7 4.4-2 6.1 1.7.8 4.3 1.2 6.1 1.7" />
      <path d="M306.6 216.2l4.2-5-5.3 3.9-.3 1.3 1.4-.2" />
      <path d="M313 217.3c-2.5 0-6.4-.3-8.8 0 1.2-2.3 2.7-6 3.6-8.3-.4 2.1-1.3 5-1.4 6.9 1.8.6 4.6 1 6.6 1.4" />
      <path d="M305.8 217.4l5-4.9-6.1 3.5-.4 1.4h1.5" />
      <path d="M311.9 217.4c-2.7 0-6.8-.1-9.5.2 1.8-2.5 4.2-6.6 5.6-9.1-1 2.3-2.4 5.4-3 7.5 1.9.7 4.8 1 6.9 1.4" />
      <path d="M304 217.8l6.6-5.5-7.4 3.9-.8 1.6h1.6" />
      <path d="M311 217.6c-2.7.4-6.9.8-9.4 1.5 1.3-2.7 3.1-7 4.2-9.7-.6 2.4-1.7 5.6-2 7.8 2 .4 5 .3 7.1.4" />
      <path d="M303.2 218.9l5-7-6.3 5.7-.3 1.7 1.6-.4" />
      <path d="M309.4 218.4c-2.6.3-6.8.5-9.4 1 1.5-2.6 3.5-6.8 4.8-9.4-.8 2.3-2 5.5-2.4 7.7 2 .5 5 .5 7 .7" />
      <path d="M302.3 219.6l6.4-5.5-7.3 3.9-.7 1.6h1.6" />
      <path d="M308.7 218.7c-2.7.6-6.9 1.3-9.4 2.1 1.2-2.7 2.8-7.1 3.8-9.8-.5 2.4-1.4 5.6-1.6 7.8 2 .3 5 0 7.2-.1" />
      <path d="M301.2 220l4-7.7-5.4 6.6-.1 1.7 1.5-.7" />
      <path d="M308.7 219.1c-3 .8-7.4 1.8-10 2.8 1-3.1 2.1-8 2.9-11.1-.3 2.7-.9 6.3-.8 8.8 2.3.2 5.5-.3 7.8-.5" />
      <path d="M300.4 221.7l5.2-7.6-6.6 6.1-.3 2 1.7-.5" />
      <path d="M307.5 220c-2.8.9-7.2 2.1-9.8 3.3.8-3.2 1.8-8.1 2.4-11.2-.1 2.7-.5 6.3-.3 8.7 2.2.1 5.4-.6 7.7-.8" />
      <path d="M299.4 222.8l3.9-8.4-5.6 7.2v2l1.7-.8" />
      <path d="M306.4 221.2c-2.8.6-7.3 1.5-10 2.4 1.1-3 2.5-8 3.4-11-.4 2.7-1.1 6.4-1.1 8.7 2.2.3 5.4-.1 7.7-.2" />
      <path d="M298.4 223.6l6.4-6.6-7.5 4.9-.6 1.8 1.7-.1" />
      <path d="M305.2 222.3c-2.9.4-7.3.8-10 1.5 1.3-3 3-7.8 4-10.8-.6 2.7-1.5 6.3-1.7 8.7 2.2.5 5.4.4 7.7.6" />
      <path d="M297.2 223l4.3-8.3-5.9 7v1.9l1.6-.7" />
      <path d="M305.5 221.3c-3 1.3-8 3-10.9 4.6 1-3.7 2-9.5 2.6-13.1 0 3.1-.5 7.4-.3 10.1 2.5 0 6-1.1 8.6-1.6" />
      <path d="M296.6 225.4l5.2-9.4-6.9 8-.2 2.2 1.9-.8" />
      <path d="M304.3 222.5c-3 1.4-7.8 3.4-10.6 5.1.8-3.6 1.5-9.5 2-13 0 3-.2 7.3.1 10 2.5-.3 6-1.5 8.5-2.1" />
      <path d="M295.5 226.8l3.8-10.1-5.7 9 .2 2.3 1.7-1.2" />
      <path d="M303 223.3c-3 1.5-7.8 3.5-10.6 5.3.7-3.7 1.4-9.5 1.9-13.1 0 3-.2 7.3.2 10 2.5-.3 6-1.6 8.5-2.2" />
      <path d="M294.7 228l5.8-8.9-7.4 7.3-.3 2.2 1.9-.6" />
      <path d="M302.7 222.8c-2.7 2.2-7 5.4-9.4 7.8 0-3.8-.5-9.5-.8-13 .6 2.9 1.3 7 2.3 9.5 2.4-.9 5.5-3 8-4.2" />
      <path d="M295 228.5l.6-10.7-2.8 10.4.8 2 1.4-1.7" />
      <path d="M302 223.8c-2.8 2.2-7 5.3-9.5 7.7 0-3.7-.5-9.5-.8-13 .7 3 1.3 7 2.3 9.5 2.4-.8 5.5-3 8-4.2" />
      <path d="M294.3 230.3l2.7-10.5-4.7 9.6.3 2.2 1.7-1.3" />
      <path d="M301.6 224c-2.5 2.6-6.6 6.4-8.9 9-.4-3.7-1.5-9.6-2.2-13.2 1 3 2.1 7.1 3.4 9.5 2.3-1.1 5.4-3.6 7.7-5.2" />
      <path d="M294.3 231.6l.5-11.1-2.7 10.8.8 2 1.4-1.7" />
      <path d="M300.8 226c-2.7 2.2-7 5.5-9.6 8 0-3.8-.7-9.8-1-13.5.7 3 1.5 7.3 2.5 9.9 2.5-1 5.7-3.1 8.1-4.5" />
      <path d="M293.5 232.9l3.8-10.5-5.8 9.3.2 2.3 1.8-1.1" />
      <path d="M300.8 226c-2.5 2.5-6.3 6.4-8.5 9.1-.4-3.8-1.5-9.8-2.1-13.4 1 3 2 7.2 3.2 9.6 2.3-1.2 5.1-3.7 7.4-5.3" />
      <path d="M293.6 233.4l-.4-11-1.8 11 1 1.9 1.2-1.9" />
      <path d="M299.6 226.8c-2.4 2.6-6.1 6.5-8.2 9.3-.5-4-1.8-9.8-2.5-13.5 1 3 2.3 7.2 3.5 9.6 2.2-1.2 5-3.8 7.2-5.4" />
      <path d="M293 234.5l1.2-11.2-3.3 10.6.7 2.2 1.4-1.6" />
      <path d="M299 227.2c-2 2.9-5.5 7-7.4 10-.8-3.8-2.5-9.5-3.5-13 1.3 2.8 2.8 6.8 4.2 9.1 2.1-1.4 4.7-4.2 6.8-6" />
      <path d="M293 235.6l-.8-11.3-1.4 11.2 1 2 1.1-2" />
      <path d="M298.9 227.9c-2 3-5.3 7.3-7 10.4-1-3.8-3-9.5-4.2-13 1.4 2.8 3.1 6.8 4.7 9 2-1.5 4.5-4.5 6.5-6.4" />
      <path d="M293.6 236.6l1.2-11.3-3.2 10.6.6 2.3 1.4-1.6" />
      <path d="M298.4 229c-1.7 3.1-4.5 8-6 11.3-1.3-3.6-3.8-9-5.3-12.4 1.7 2.6 3.7 6.3 5.5 8.4 1.9-1.8 4-5.2 5.8-7.4" />
      <path d="M293.3 237.6l-3.2-10.8 1 11.3 1.5 1.6.6-2.1" />
      <path d="M298.4 230.2c-1.8 3.2-4.8 8-6.3 11.3-1.3-3.6-3.8-9-5.4-12.3 1.7 2.6 3.8 6.3 5.6 8.3 2-1.8 4.2-5.1 6-7.3" />
      <path d="M293.4 239.6l-1.2-11.3-1 11.3 1.1 2 1.1-2" />
      <path d="M298.6 231.2c-1.9 3.1-5 7.9-6.5 11.1-1.3-3.6-3.7-9-5.2-12.4 1.7 2.6 3.7 6.4 5.5 8.4 2-1.7 4.3-5 6.2-7.1" />
      <path d="M293.3 240.5l-2.1-11-.1 11.2 1.3 1.8.9-2" />
      <path d="M297.8 232.8c-2 3-5.3 7.5-7 10.7-1.1-3.7-3.3-9.4-4.6-12.8 1.5 2.7 3.4 6.6 5 8.8 2.1-1.6 4.6-4.7 6.6-6.7" />
      <path d="M292.3 241.7l1-11.3-3.1 10.7.7 2.2 1.4-1.6" />
      <path d="M297.9 233c-1.7 3.3-4.6 8.3-6 11.6-1.4-3.5-4-8.8-5.7-12 1.8 2.4 4 6 5.8 8 2-1.9 4-5.3 5.9-7.5" />
      <path d="M292 242.7l-3.5-10.6 1.3 11.2 1.5 1.6.6-2.2" />
      <path d="M297.4 233.9c-1.2 3.6-3.2 9-4 12.7-2-3.2-5.5-7.8-7.6-10.7 2.1 2.1 4.9 5.2 7 6.7 1.6-2.3 3.2-6 4.6-8.7" />
      <path d="M295 243.5l-3.7-10.4 1.6 11.2 1.5 1.4.6-2.2" />
      <path d="M297.4 235c-1.2 3.6-3.2 9.1-4 12.7-2-3.2-5.4-7.7-7.6-10.5 2.1 2 4.9 5 7 6.6 1.6-2.3 3.2-6.1 4.6-8.8" />
      <path d="M295 245.3l-4.8-9.7 2.8 10.8 1.7 1.2.4-2.3" />
      <path d="M297 235.9c-.7 3.7-2 9.5-2.5 13.2-2.3-2.9-6.3-7-8.7-9.4 2.3 1.7 5.4 4.4 7.7 5.5 1.3-2.5 2.4-6.5 3.5-9.3" />
      <path d="M295.4 246.8l-2.6-10.9.4 11.3 1.4 1.7.8-2" />
      <path d="M297 237c-.4 3.9-1.2 9.8-1.2 13.5-2.6-2.5-6.9-6-9.5-8.1 2.4 1.4 5.7 3.6 8.1 4.4 1-2.6 1.8-6.8 2.6-9.7" />
      <path d="M295.5 247.6l-6.9-7.8 5.2 9.5 2 .6-.3-2.3" />
      <path d="M297.2 238.4c-.4 3.8-1.2 9.7-1.3 13.4-2.6-2.5-6.9-6-9.5-8.2 2.5 1.4 5.8 3.7 8.1 4.5 1.1-2.6 1.8-6.8 2.7-9.7" />
      <path d="M296.3 249.4L291 240l3.3 10.7 1.7 1.1.3-2.3" />
      <path d="M297.5 240c-.3 3.8-.8 9.7-.8 13.5a117 117 0 0 0-9.8-7.6c2.6 1.2 6 3.3 8.3 4 1-2.7 1.6-7 2.3-10" />
      <path d="M297 251.2l-6.6-8.3 4.8 9.8 1.8.8v-2.3" />
      <path d="M297.6 241.8c-.3 3.8-.8 9.7-.7 13.5-2.7-2.4-7.1-5.6-9.9-7.6 2.6 1.3 6 3.3 8.4 4 1-2.7 1.5-7 2.2-10" />
      <path d="M297.5 252.6l-4.5-10 2.5 11 1.6 1.3.4-2.3" />
      <path d="M297.7 242.9c.2 3.9.2 9.8.6 13.6a134 134 0 0 0-10.4-6.2c2.6.9 6.1 2.4 8.6 2.8.7-2.9.8-7.1 1.2-10.2" />
      <path d="M298.3 252.2l-8.3-5.7 7 7.8 2 .1-.7-2.2" />
      <path d="M298 243.3c.3 3.9.7 9.8 1.3 13.5-3-1.9-7.8-4.3-10.8-5.8 2.7.8 6.3 2.2 8.8 2.5.5-2.9.4-7.1.7-10.2" />
      <path d="M299.3 254.3l-7-8 5.3 9.6 1.9.7-.3-2.3" />
      <path d="M298.6 244.8c.5 3.8 1 9.7 1.9 13.4-3-1.7-8-3.8-11-5.1 2.7.6 6.4 1.8 8.8 2 .4-3 .2-7.2.3-10.3" />
      <path d="M300.6 255.7l-8.3-5.9 7 8 2 .1-.7-2.2" />
      <path d="M298.9 246.4c.7 3.8 1.7 9.7 2.7 13.3-3.1-1.5-8.2-3.1-11.3-4.1 2.8.3 6.5 1.2 9 1 .2-2.9-.3-7-.4-10.2" />
      <path d="M301.6 256.9l-7-8.2 5.2 9.7 2 .8-.2-2.3" />
      <path d="M299.3 247.4c1.1 3.7 2.6 9.5 4 13-3.3-1-8.4-2-11.6-2.6 2.8 0 6.5.3 9-.1 0-3-1-7.1-1.4-10.2" />
      <path d="M302 256.9l-9.7-2 9.1 4.5 1.9-.7-1.4-1.8" />
      <path d="M300 248.6c1 3.7 2.5 9.4 3.8 12.9-3.2-1-8.3-2-11.5-2.6 2.8 0 6.5.3 9 0 0-3-1-7.2-1.3-10.3" />
      <path d="M303.5 257.9l-9.2-4.5 8.2 6.7 2-.2-1-2" />
      <path d="M299.5 249.2c1.8 3.4 4.5 8.7 6.5 11.7-3.4-.2-8.6 0-11.8 0 2.7-.5 6.4-1 8.7-2-.7-2.9-2.4-6.7-3.4-9.7" />
      <path d="M305 258.9l-9.6-2.6 9 5 1.8-.5-1.3-2" />
      <path d="M300.4 250.7c1.9 3.3 4.6 8.6 6.7 11.6-3.4-.2-8.6 0-11.8.2 2.6-.7 6.4-1.2 8.6-2.2-.6-2.9-2.4-6.7-3.4-9.6" />
      <path d="M306.1 259.7l-8.9-5.3 7.8 7.4h2l-.9-2.1" />
      <path d="M301.2 251.5c2.1 3.1 5.3 8 7.6 10.9a90 90 0 0 0-11.6 1.7c2.6-1 6.2-2 8.4-3.3-1-2.8-3.1-6.5-4.4-9.3" />
      <path d="M306.8 260.5l-9.6-.3 9.5 2.9 1.7-1.1-1.6-1.5m5.6-46.6l6.9-1.1-6.9.1-1.2.6 1.2.4" />
      <path d="M316.2 215.4c-2-.6-5-1.6-7.1-2l7.4-3.5c-1.5 1-3.8 2.2-5 3.2 1.2.8 3.3 1.6 4.7 2.3" />
      <path d="M312 214.1l6.8-1.8-7 .9-1 .7 1.3.2" />
      <path d="M316.5 215.9c-2.4-.3-6-.7-8.3-.7 1.8-1.6 4.2-4.1 5.7-5.7-1 1.5-2.6 3.4-3.3 4.8 1.6.7 4.1 1.1 5.9 1.6" />
      <path d="M309.6 214.6l7-.8-6.8-.2-1.3.6 1 .4" />
      <path d="M314.7 216.1l-7.5-1.3 6.9-3.8c-1.4 1-3.4 2.4-4.4 3.4 1.3.6 3.5 1.2 5 1.7" />
      <path d="M309 214.6l6.1-2.7-6.7 1.8-.8.8h1.4" />
      <path d="M314.5 216.9c-1.7-.7-4.5-2-6.2-2.5l4.4-4.8c-.8 1.3-2 3-2.6 4.4 1.2 1 3 2 4.4 2.9" />
      <path d="M309.3 215l4.8-2-5.2.6-.6 1 1 .4m-4 44.6h-9.8l10 2.5 1.6-1-1.8-1.5" />
      <path d="M307.1 260.2l-10-2.3 9.6 4.7 2-.6-1.6-1.8" />
      <path d="M308.8 260.9l-10-.5 10 3 1.7-1-1.7-1.5" />
      <path d="M302.5 253.9c2.5 2.8 6.4 7.4 9.1 9.9-3.3.5-8.3 1.8-11.4 2.7 2.4-1.2 6-2.6 8-4-1.4-2.6-4-6-5.7-8.6" />
      <path d="M310.1 261.4l-10-3.3 9.4 5.6 2-.4-1.4-2" />
      <path d="M303.4 254.5c2.8 2.6 7 6.7 10 9-3.2.9-8 2.8-11 4 2.3-1.4 5.6-3.2 7.4-5-1.6-2.4-4.5-5.5-6.4-8" />
      <path d="M311 262l-9.5 1.9 10 .6 1.4-1.3-2-1.2" />
      <path d="M309 261.4l-9.8.8 10.1 1.7 1.6-1.2-2-1.3" />
      <path d="M310.8 262l-10.2-1.7 10 4 1.8-.7-1.6-1.7z" />
      <path d="M312.5 262.5l-10 .2 10.2 2.3 1.6-1.1-1.8-1.4z" />
      <path d="M305.7 256c2.8 2.6 7 6.8 9.9 9.2-3.3.7-8.3 2.4-11.3 3.4 2.4-1.3 5.8-2.9 7.7-4.5-1.6-2.5-4.4-5.7-6.3-8.2z" />
      <path d="M313.9 262.9l-10.2-2.6 9.8 5 1.9-.6-1.5-1.8z" />
      <path d="M306.6 256.5c3 2.4 7.6 6.2 10.7 8.2-3.2 1.1-7.8 3.5-10.6 4.9 2.2-1.7 5.3-3.7 7-5.5-1.8-2.4-5-5.3-7-7.6z" />
      <path d="M314.8 263.4l-9.3 2.6h10l1.3-1.5-2-1z" />
    </g>
    <path
      fill="#fedf00"
      stroke="#000"
      strokeWidth={0.4}
      d="M327.6 249.5l-7.6-5.3-7.6 5.3 2.9-8.4-6.7-5.2h8.6l2.8-8.4 2.8 8.4h8.6l-6.7 5.2 2.9 8.4z"
    />
  </svg>
	),
	QA: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#8d1b3d" d="M0 0h640v480H0z" />
    <path
      fill="#fff"
      d="M0 0v480h158.4l97.8-26.7-97.8-26.6 97.7-26.7-97.7-26.7 97.7-26.6-97.7-26.7 97.8-26.7-97.8-26.6 97.7-26.7-97.7-26.7 97.7-26.6-97.7-26.7 97.8-26.7-97.8-26.6L256.1 80l-97.7-26.7 97.8-26.6L158.3 0H0z"
    />
  </svg>
	),
	RE: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#00267f" d="M0 0h213.3v480H0z" />
      <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	RO: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#00319c" d="M0 0h213.3v480H0z" />
      <path fill="#ffde00" d="M213.3 0h213.4v480H213.3z" />
      <path fill="#de2110" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	RS: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillRule="evenodd" d="M60 0h1200v900H60z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="translate(-32) scale(.53333)">
      <path fill="#fff" d="M0 0h1350v900H0z" />
      <path fill="#0c4076" d="M0 0h1350v600H0z" />
      <path fill="#c6363c" d="M0 0h1350v300H0z" />
      <g transform="matrix(1 0 0 1.00437 0 -.3)">
        <path
          fill="#21231e"
          d="M473.4 259.4v-.2h1v.2l-.5.5-.6-.6zm1 0v.5h-.5l.4-.6zm-93 5.2l-1 .2.3-.6 4.2-.2 4-.3 4-.2 3.8-.3 4-.2 3.6-.3 3.7-.2 3.7-.2 3.5-.2h3.4l3.3-.3 3.2-.2 3.2-.2 3-.2h3l3-.2 3-.2 2.7-.2h2.8l2.7-.2 2.5-.2h2.5l2.4-.3h2.2l2.2-.2h2.2l2-.2h2l2-.2h5.3v1h-5.5l-1.8.2h-2l-2 .2h-2.2l-2.2.2-2.4.2h-2.4l-2.5.2-2.5.2H446l-2.8.3h-2.8l-3 .3-2.8.2h-3l-3 .3-3.3.2-3.3.2-3.3.2h-3.5l-3.5.3-3.6.2-3.5.3-3.8.2-3.8.2-4 .3-4 .2-4 .3-4.2.2.5-.6zm-1 .2l-.3-.5h.7l-.4.5zm6.4 31l-6.5-31 1-.2 6.5 31-.5.7-.5-.4zm.5.5h-.4l-.2-.4.5.3zm95-4l-.2 1h.2-5.8l-3 .2h-3l-2.8.2h-3l-3 .2h-6l-3 .2h-3l-3 .2h-3l-3 .2h-3.2l-3 .2h-3l-3 .2h-3l-3 .2h-3l-3 .2h-3l-3 .2h-3l-3 .2h-3l-2.8.2h-5.8l-2.7.2h-2.7v-1h5.8l2.7-.2h5.8l3-.2h3l2.8-.2h3l3-.2h3l3-.2h3l3-.2h3l3-.2h3l3-.2h3.2l3-.2h3l3-.2h3l3-.2h3l3-.2h3l3-.2h3l2.8-.2h3l2.8-.2h.2zm-.2 0h.2zm94.5 3.4l1 .2-.5.3h-2.8l-2.8-.2h-8.8l-2.8-.2h-3l-3-.2H551l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3.2-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2H485l-3-.2.2-1h2.8l3 .2h3l2.8.2h3l3 .2h3l3 .2h3l3 .2h3l3 .2h3l3 .2h3l3 .2h3.2l3 .2h3l3 .2h3l3 .2h3l3 .2h3l3 .2h5.8l2.7.2h3l2.7.2h2.8l-.5.5zm1 .2v.3h-.5l.5-.4zm6.5-31.2l-6.5 31h-1l6.5-31.2.6-.4.4.6zm-.4-.6h.5v.6l-.4-.6zm-93.7-4.8h1l-.6-.5h5.4l2 .2h2l2 .2h2l2.4.2h2.4l2.4.3h5l2.6.3h2.7l3 .3 2.8.2h3l3 .3 3 .3 3.3.2 3.3.2 3.4.2h3.4l3.6.3 3.6.2 3.7.2 3.6.3 4 .2 3.8.3 4 .2 4 .3 4.2.2v1l-4.3-.2-4-.3-4-.2-4-.3-3.7-.2-3.8-.2-3.6-.3-3.6-.2-3.5-.2h-3.4l-3.3-.3-3.3-.2-3.2-.2-3-.2h-3l-3-.2-3-.2h-2.7l-2.6-.3h-2.6l-2.6-.3h-2.5l-2.4-.2-2.3-.2h-2.2l-2.2-.2h-2l-2-.2h-2l-1.8-.2h-3.3l-.5-.6zm.4.5h-.5v-.6l.4.5zm.5-.8v.2h-1v-.2l.3-.5.6.5zm-1 0v-.4h.3l-.4.4zm-8 .3l.2-1h8.8l.3.2v.8h-.5v.2h-.3l-.2-1h.2v.7h.2-8.2zm.2 0zm-8.3.2v-1l-.2 1h-.4l-.2-.2-.3-.3v-.5l.2-.2h9.4v1h-8.8l.2-.2v-.8h-.2.4v1zm0-1v1l-.6-.5.5-.5zm-.6.5v-.5h.5l-.6.5z"
        />
        <path
          fill="#edb92e"
          d="M583.5 264.2c3.2-6.6 6.7-13 11.2-18.7-11.7 8.8-18 7.5-18.7-4-.7-.2-1.7-.2-2.6-.2-9 14-17.7 12-26.2-5.8-11.5 18.4-21.4 18-29.2-1-13.3 16.6-24.5 16.7-33.6.2v-2c.5.2 0 .3-1 0l-.3-.3a69.3 69.3 0 0 1-1 .2c-.2 0-.5 0-.8-.2l-.2.4c-1.2.2-1.6 0-1 0v2c-9.2 16.4-20.4 16.3-33.7-.4-7.8 19-17.7 19.5-29.2 1-8.4 18-17 20-26 6-1 0-2 0-2.7.2-.8 11.4-7 12.7-18.8 4 4.6 5.5 8 12 11.3 18.6 34-1.4 67.6-3.2 101.3-5 34 1.8 67.6 3.6 101.5 5z"
        />
        <path
          fill="#21231e"
          d="M595 246l-.6-1 .7 1-.3.4-.4.5-.4.4-.5.6-.4.5-.3.6-.4.6-.4.6-.5.5-.3.6-.4.6-.4.4-.3.6-.3.6-.3.6-.4.6-.3.5-.3.6-.4.5-.3.6-.3.7-.4.6-.3.6-.3.5-.3.6-.2.8-.3.6-.4.6-.2.6-.3.6-.3.6-.3.6-1-.4.3-.6.3-.7.3-.6.2-.5.4-.6.3-.7.2-.6.3-.6.3-.6.4-.6.3-.6.3-.6.3-.6.5-.6.3-.6.4-.6.3-.6.4-.5.2-.5.4-.6.4-.7.3-.6.4-.5.4-.6.5-.6.4-.5.3-.6.4-.6.4-.6.5-.5.4-.6.4-.5.7.7zm-19.2-4l.3-1 .5.5v1l.2 1v1l.3.7.2.8.3.7.3.7.2.6.4.5.3.5.4.4.5.3.4.3.4.3.5.2h.4l.5.2h1.9l.7-.2.7-.2.8-.3.8-.3.8-.3 1-.5.8-.6 1-.5 1-.7 1-.7 1-.7 1-1 .7 1-1 .7-1 .8-1 .7-1 .6-1 .5-1 .5-1 .5-.8.4-1 .3-.7.3-.8.2h-.8l-.8.2h-2l-.7-.3-.5-.2-.6-.3-.5-.5-.6-.4-.5-.4-.5-.5-.3-.5-.4-.7-.3-.7-.2-.7-.3-.8-.2-1v-.8l-.2-1v-1l.2.3zm.3-1l.4.2v.3l-.3-.4zm-2.2.6l-.8-.6.4-.2h2v.2h.4l-.2 1h-1.2v-.2h-1.2l.4-.2zm-.8-.6v-.2h.4l-.4.2zm-25.3-5.2l-1-.6h1l.8 1.7.8 1.4.8 1.5.8 1.2.8 1.2.8 1.2.8 1 .8 1 .8.8.8.8.8.7.7.5 1 .4.7.3.8.3.7.3h2.3l.8-.2.8-.2.8-.3.8-.4.8-.6.8-.6.8-.7.8-.6 1-1 .7-1 .8-1 .8-1 1-1.4.8.6-.8 1.3-1 1-.7 1.2-1 1-.7 1-1 .7-.8.6-.8.6-1 .6-.7.4-1 .4-.8.2-1 .2h-3l-1-.4-.7-.3-1-.5-.7-.5-1-.6-.7-.7-1-.8-.8-1-.8-1-.8-1-.8-1.2-.8-1.3-.8-1.3-.8-1.5-.8-1.6-.8-1.7h1zm-1-.6l.6-.7.4.8h-1zm-28.3-.5l-.8-.6 1 .2.6 1.7.7 1.5.7 1.5.8 1.4.7 1.3.8 1.2.8 1 .8 1 .8.7.8.7.8.6 1 .5.7.4.8.2 1 .2h2.5l1-.3.8-.2 1-.4.8-.6 1-.7 1-.6 1-1 1-1 1-1 1-1.2 1-1.3 1-1.6 1-1.5 1.2-1.8 1 .6-1.2 1.7-1 1.5-1.2 1.5-1 1.3-1 1.3-1 1.2-1.2 1-1 1-1 .8-1 .7-1 .6-1 .4-1 .4-1 .4h-3l-1-.2-1-.3-.8-.6-1-.5-.8-.8-1-.8-.7-.8-1-1-.8-1-.8-1.3-.8-1.4-.8-1.5-.8-1.5-.7-1.7-.8-1.7h1zm-.8-.6l.5-.6.5.8h-1zm-33.8.7h1v-.2l.8 1.5 1 1.4.8 1.2 1 1.2.8 1 1 1 .8 1 1 .8.8.7 1 .6 1 .4 1 .4.8.3 1 .3 1 .2h2l1-.2 1-.3 1-.3 1.2-.4 1-.6 1.2-.6 1-.6 1.3-.8 1-1 1.3-1 1.2-1 1-1.3 1.4-1.3 1.2-1.4 1.2-1.5.8.7-1.3 1.5-1 1.5-1.3 1.3-1.2 1.3-1.2 1-1.2 1-1 1-1.3 1-1.2.7-1 .6-1.3.6-1 .5-1.3.3-1.2.3h-1l-1.2.2h-1l-1.2-.2-1-.2-1-.3-1-.4-1-.5-1-.7-1-.6-1-1-1-.8-1-1-1-1.2-.8-1.2-1-1.3-.8-1.5-1-1.5v-.3zm0 .3v-.3.3zm1-2.3v2h-1v-2l.8-.5.3.5zm-1 0v-.8l.8.2-.8.5zm-1 .3l1-.4-.4-.3h1l-.2.2v.4l.4-1h.2v.2l.2.2v.6h-1.8l-.5-.3zm.5.3h-.3v-.3l.3.3zm.3-1l.2.3-1 .4v-.4l.2-.7.6.2zm-.6-.4l.4-.2.2.4-.6-.3zm-1 1l.2-1h.8l.2 1h-1zm.2 0zm-.6-.4l-1-.4.7-.3h.8v1h-1l.4-.4zm-1-.4l.3-.4h.3l-.6.4zm0 .4v-.4l1 .4-.2.4-.4.3-.5-.7zm.8.4v.3h-.4l.4-.3zm-1-.3h-1l.7.4v.2h.2v-.8h-.2.2l.2-.2h.4l.2 1h-1.9v-.2h-.2v-.5h.2v-.2h.2l.8.4zm-.7-.5l.7-.3v.7l-.7-.5zm-.3 2.5v-2h1v2.3l-1-.3zm1 0v.2-.3zm-33.6 0l-1-.5h1l1 1.4 1.3 1.4 1.3 1.3 1.2 1.2 1.2 1 1.2 1.2 1 1 1.2.7 1 .7 1.2.7 1 .6 1.2.4 1 .3 1 .3h1l1 .2h1l1-.2 1-.2 1-.2 1-.4 1-.5 1-.7.8-.7 1-.8.8-1 1-1 .8-1 1-1.2.8-1.2.8-1.4 1-1.5.8.5-1 1.5-.8 1.4-1 1.2-.8 1.2-1 1.2-1 1-.8 1-1 .8-1 .7-1 .8-1 .5-1 .4-1 .4-1 .3-1.2.2h-2.2l-1-.2-1.3-.3-1-.3-1.2-.5-1-.6-1.2-.6-1.2-.8-1.2-.8-1.2-1-1.2-1-1.2-1-1.2-1.4-1.2-1.3-1.3-1.5-1-1.5h.8zm-1-.5l.3-.8.7.7-1 .2zm-28.3 1.5l-1-.4h1l1 1.6 1 1.4 1.2 1.5 1 1.2 1 1.2 1 1 1 1 1 1 1 .7 1 .8 1 .6.8.4 1 .3.8.4h2.8l.8-.2.8-.3.8-.5 1-.5.7-.6 1-.7.7-.8.8-1 .8-1 .8-1.3.8-1.3.8-1.4.8-1.5.7-1.6.8-1.8 1 .4-.8 1.7-.7 1.7-.8 1.5-.8 1.4-.8 1.3-1 1.2-.7 1-1 1-.7 1-1 .7-.8.7-1 .4-.8.5-1 .2-1 .2h-3l-1-.3-1-.3-1-.4-1-.6-1-.7-1-.8-1-1-1-1-1-1-1-1.4-1-1.3-1.2-1.5-1-1.5-1.2-1.7h1zm-1-.4l.5-.8.5.7h-1zm-25.6 6.5v-1l.3.2 1 1.3.7 1.2.8 1 .8 1 .8.8 1 .8.7.8 1 .6.7.5.7.3.8.3.8.2.8.2h2.3l.8-.4.8-.3.8-.4.7-.5 1-.6.7-.8.8-.8.8-.8.8-1 1-1 .7-1.2.7-1.2.8-1.3.8-1.6.8-1.5.8-1.7 1 .4-1 1.7-.7 1.5-1 1.4-.7 1.3-.8 1.3-.8 1.2-.8 1-1 1-.8 1-.8.8-.8.7-1 .6-.7.5-1 .5-1 .3-.7.3h-2.6l-1-.2-.8-.2-1-.4-.8-.4-1-.6-.8-.6-.8-.7-1-1-.7-.8-1-1-.8-1-1-1.3-.7-1.4.4.2zm0-1h.2v.2l-.3-.2zm-2.2.8h-1l.4-.5h1.2v-.2h1.5v1H389v.2h-.4l.2-.4zm-1 0v-.4h.4l-.4.3zm-18 3.6l-.6.7.6-1 1 1 1.2.6 1 .7 1 .6 1 .4.8.5 1 .4.7.3.8.3.8.3.8.2h.7l.7.2h1.7l.4-.2.5-.2.4-.3.4-.3.4-.3.4-.4.3-.5.2-.5.3-.6.3-.7.3-.7.3-.8v-.8l.3-1v-.8l.2-1h1v1l-.2 1-.2 1-.2 1-.2.7-.2.8-.3.8-.4.7-.2.6-.5.6-.4.5-.6.5-.5.4-.7.2-.6.2-.6.2h-3.3l-.8-.3-.8-.3-1-.3-.8-.4-1-.5-.8-.5-1-.5-1-.6-1-.7-1-.8-1.2-.8.7-.8zm11 18.5v1l-.4-.3-.3-.6-.2-.6-.3-.6-.3-.6-.4-.6-.3-.6-.3-.7-.3-.5-.4-.6-.4-.7-.3-.6-.4-.6-.3-.5-.4-.6-.4-.7-.4-.5-.3-.6-.4-.6-.4-.6-.4-.6-.3-.5-.4-.7-.3-.6-.3-.5-.4-.6-.4-.5-.4-.5-.4-.5-.4-.6-.4-.5-.4-.6-.4-.5.7-.8.4.5.4.6.4.5.4.6.4.5.4.5.4.5.4.6.4.6.4.5.3.6.4.6.4.5.4.6.4.6.3.6.5.6.3.6.3.6.5.6.3.6.3.6.5.6.3.7.3.7.4.6.3.6.4.5.4.6.3.7.3.7.3.6-.5-.3zm0 1h-.3v-.3l.4.3zm101.4-6v1l-3.2.2h-3.2l-3 .3h-3.3l-3 .3-3.3.2H460l-3 .3-3.3.3h-3.2l-3 .3H444l-3 .3h-3.3l-3.3.2-3 .2h-3.3l-3.2.3h-3l-3.3.3-3.3.2h-3l-3.3.3h-3.2l-3 .2-3.3.2h-3.3l-3.2.2h-3l-3.3.3H384l-3 .2-.2-1h3.2l3.2-.3h3l3.3-.2 3.2-.2h3l3.3-.3h3.2l3-.3h3.3l3.2-.3h3l3.3-.2h3.2l3-.3h3.3l3.2-.3 3-.2h3.3l3.2-.3h3l3.3-.3 3.2-.2h3l3.3-.3 3-.3h3.3l3.2-.3 3-.2h3.3l3.2-.3 3-.3h.2zm0 0zm101.2 5v1h-3l-3.3-.2-3-.2h-3.3l-3-.3h-3.3l-3.2-.3h-3l-3.3-.2-3.3-.2h-3l-3.3-.3-3.2-.2h-3l-3.3-.3h-3.3l-3-.3h-3.3l-3.2-.3-3-.3h-3.3l-3.3-.3h-3l-3.3-.3h-3l-3.3-.2-3-.2-3.2-.2h-3.2l-3.2-.3h-3l-3.3-.2.2-1h3l3.3.3 3.2.2 3 .2 3.3.2h3l3.3.3h3.2l3 .2 3.3.2 3.2.2h3l3.3.3h3l3.3.2 3.2.2h3l3.3.3h3.3l3 .3h3.3l3.2.3h3l3.3.3h3.3l3 .3h3.3l3.2.2h3.2l3 .2 3.3.2h3.2zm0 1zm0 0v-1l.5.7-.6.3zm.5-.3l-.2.3h-.4l.5-.3z"
        />
        <path fill="#edb92e" d="M459.4 276.2l22.7-11.5 23 11.5-23 11.4z" />
        <path
          fill="#edb92e"
          d="M474 259.2v.2c-17.6.7-48.6 2.5-93.2 5.3l6.5 31c29.6-.8 64.3-2 94.8-3 30.7 1 65.3 2.2 95 3l6.5-31c-44.6-2.8-75.6-4.6-93-5.3v-.2c1.7-.4-1-.4-8.4-.2-7-.2-10-.2-8 .2z"
        />
        <path
          fill="#edb92e"
          d="M597.3 236.7l-3.7-.6c-7 17.5-13.4 18-14.6 1.4 1.6-.6 1-3.3 2.8-2.2 1 .5 2-1 1.3-2-2-1.5-3.6-1.3-5.4.4-.8-2.7-3-4-5.4-2.8-1 .5-.7 2.5.4 2.4 1.8-.2 1 1.6 1.6 3-12.5 16.4-19 14.4-17.4-7.3-3-.7-6.5-1.3-9.6-2.4-11.5 23.3-19.7 24.3-26.4 3.4 1.4-1 1-3.8 3-3 1.3.6 2.3-1.5 1.2-2.4-2.4-2-5-1.3-6.8 1.3-1.4-3-4-4-6.6-2.2-1.2.7-.5 3 .8 2.6 2.3-.7 1.3 2.4 3 3.5-5 19.6-30.8 21-26.6-8.2-2.4 0-4.5 0-6.6.2l-6.7-.2c4.2 29-21.5 27.8-26.6 8 1.6-1 .6-4 3-3.4 1.2.3 2-2 .7-2.7-2.6-1.7-5.2-.7-6.6 2.2-1.7-2.7-4.3-3.4-6.7-1.4-1 1 0 3 1 2.5 2.2-.8 1.8 2 3.2 3-6.7 21-15 20-26.4-3.4-3 1-6.5 1.7-9.5 2.3 1.6 21.6-5 23.6-17.4 7 .6-1.2 0-3 1.7-2.8 1 0 1.5-2 .4-2.4-2.4-1-4.5 0-5.3 2.8-1.7-1.7-3.5-2-5.5-.4-.8 1 .4 2.5 1.3 2 1.8-1 1.2 1.6 2.8 2.2-1.2 16.5-7.6 16-14.6-1.3l-3.7.7c0 4 1.3 8.5 3.8 11.7 10.6 13.5 18.5 10.4 18.8-4.7 14 16.4 24.4 14.3 26.2-3 11.7 21.8 30.5 11.4 31-2 5 19.4 33.5 19.2 35.4-3 1.8 22.2 30.3 22.4 35.4 3 .4 13.4 19.2 23.8 31 2 1.7 17.3 12.3 19.4 26 3 .4 15 8.3 18.2 19 4.7 2.4-3.2 3.8-7.6 3.7-11.7z"
        />
        <path
          fill="#21231e"
          d="M593.7 235.6l3.7.6-.2 1-3.6-.6-.4-.7.5-.4zm-.5.3v-.4h.5l-.5.3zm-14.3 1l.2 1 .3-.6.2 1.4v1.4l.3 1.3.2 1.2.2 1 .3 1 .3 1 .3.7.3.7.3.6.3.5.3.5.4.2.3.2h1.3l.4-.3.4-.2.5-.4.4-.3.6-.6.5-.6.6-.7.7-1 .6-.8.7-1.2.6-1.2.6-1.3.7-1.3.5-1.5.7-1.6 1 .3-.8 1.6-.6 1.4-.7 1.4-.5 1.3-.7 1.3-.6 1-.6 1-.7 1-.7.8-.6.8-.6.6-.5.5-.6.3-.7.4-.5.2h-1.2l-.6-.2-.5-.2-.5-.4-.5-.4-.4-.6-.3-.6-.3-.8-.4-.8-.3-1-.2-1-.3-1-.2-1.3-.2-1.3-.2-1.5v-1.6l.3-.5zm-.5.4v-.4h.4l-.5.4zm3.5-2.7l-.5 1v-.2h-.4v.2h-.2v.2l-.2.2v.3l-.2.3-.2.3v.2h-.2v.3h-.3v.2h-.3l-.2.2-.3-1v-.2h.2v-.2h.2v-.2l.2-.2v-.5h.2v-.4l.2-.2v-.3l.2-.2.2-.2h.2l.2-.2h1l.2.2zm-.5 1zm1.3-2l.6-1v.2h.2l.2.3v1.6h-.2v.2h-.2v.2h-.2v.2h-.2v.2h-.5v.2h-.8l-.3-.2.5-1v.2h.4v-.2h.2v-.2h.2v-.8zm.6-1v.2-.2zm-6.3 1l1-.3-.8-.2h.2l.2-.3.2-.2.2-.2.3-.2h.2l.2-.2h.2v-.2h.4l.2-.2h2.3l.2.2h.2l.2.2h.2l.2.2h.2l.2.2.2.2-.6.8-.3-.2h-.2l-.2-.2-.2-.2h-.3l-.2-.2h-2.1v.2h-.3v.2h-.2l-.3.2v.2h-.3v.2l-.3.2-1-.3zm1 .3l-.7.5-.2-.8 1 .3zm-5.6-2.7l-.4-1h.5l.3-.2h2.1l.4.2h.4l.2.3h.2v.2l.3.2h.2l.2.2v.2l.2.2v.2l.2.2.2.2v.2l.2.3v.2l.2.2v.2l-1 .3v-.5h-.2v-.3l-.2-.2v-.2h-.3v-.3h-.2v-.4h-.3v-.2h-.3v-.2h-.6v-.2h-2l-.2.2h-.2zm0 1.4l.2 1h-.6v-.2h-.2l-.2-.2-.2-.2-.2-.2V231l.2-.2.2-.2.3-.2.4 1h-.2v1.2h.2zm2.2 3.7l-.8-.6v.5-.2h-.2v-1h-.2v-1l-.2-.2h-.7v-1.2h.6l.3.2.2.2h.2v.2l.2.3v.4h.2v1.5h.2v.8zm0-.5h.2l-.2.4v-.5zm-18-6.6l.3-1 .3.6v2l-.2 1.8v4.9l.3 1.4v1.3l.3 1 .2 1 .3 1 .4.8.3.8.4.5.5.5.4.3.4.3.5.2h1l.6-.2.7-.3.7-.4.8-.5 1-.4.7-.8 1-.8 1-1 1-1 1-1 1-1.4 1-1.4 1.3-1.4.8.6-1.2 1.5-1 1.3-1.2 1.3-1 1-1 1.2-1 1-1 .8-1 .8-.8.6-1 .5-.7.4-.8.3h-.8l-.8.2h-.7l-.7-.2-.6-.3-.6-.5-.5-.5-.4-.7-.5-.7-.4-1-.2-1-.2-1-.2-1.2-.2-1.3V229l.5.6zm.3-1h.3v.6l-.4-.6zm-9.3-1.6l-1-.4.7-.3.3.2h.3l.3.2h.3l.2.2h.3l.4.2h.6l.3.2h.3l.4.2h.6l.3.2h.5l.3.2h.7l.3.2h.6l.3.2h.5l.3.2h.8l.3.2h.3l-.3 1h-.8l-.2-.2h-.6l-.3-.2h-.8l-.3-.2h-.6l-.4-.2h-.7l-.4-.2h-.3l-.3-.2h-.6l-.3-.2h-.2l-.3-.2h-.6l-.4-.2h-.3l-.4-.2h-.4l-.3-.2h-.2l.7-.4zm-1-.4l.3-.4h.4l-.6.4zm-26.2 3.2l.6.8.3-.6.6 2 .5 1.7.7 1.6.6 1.6.7 1.4.7 1.2.6 1 .7 1 .7 1 .7.6.6.6.7.4.7.4.7.2h1.4l1-.2.6-.2.8-.4 1-.6.7-.6 1-.8 1-1 .8-1 1-1.2 1-1.3.8-1.4 1-1.6 1-1.7 1-1.8 1-2 1.2-2 1 .3-1.2 2.2-1 2-1 1.8-1 1.8-1 1.6-1 1.5-1 1.3-1 1.2-1 1-1 1-1 1-.8.7-1 .5-.8.4-1 .2-.8.2h-1.8l-.8-.3-.8-.3-.8-.5-.8-.6-.7-.8-.8-1-.7-1-.7-1-.7-1.4-.7-1.4-.7-1.5-.7-1.7-.6-1.7-.7-1.8.2-.6zm-.2.6v-.4l.2-.2-.2.5zm3.8-3.6l-.3 1h-.3l-.2-.2h-.2v.2h-.2v.2h-.2v.5h-.2v.4l-.2.3-.2.2v.2l-.2.3-.3.3-.2.3h-.2l-.5-.7.2-.2.2-.2v-.5h.2v-.4h.2v-.3l.2-.3v-.2l.2-.2.2-.3.2-.2h.2v-.2h.5v-.2h.7l.2.2zm.7-1.6l.6-.8.2.2.2.2v.2l.2.3v1.3l-.2.3v.2l-.2.2h-.2v.2h-.2v.2h-.2l-.2.2h-1.1l.4-1h.7v-.2h.2v-.6h.2v-.7h-.2v-.2zm-7 1l1-.3h-1l.2-.3v-.3h.3l.2-.3.2-.3.2-.2.3-.3.3-.3h.2l.2-.3h.3l.2-.2h.5l.2-.2h2.2l.3.2h.2l.3.2h.3l.3.3h.2l.3.3.3.2-.6.8-.2-.2h-.2l-.2-.3-.4-.2h-.2l-.2-.2H521v.2h-.5l-.2.3h-.2v.2h-.2l-.2.3-.2.2-.3.3v.2l-.2.3-.2.2h-1zm1 .2l-.6.7-.3-1 1 .2zm-7-2l-.4-1h.3l.2-.2h.3l.4-.2h.2l.3-.2h.4l.3-.2h1.6l.2.2h.2l.3.2h.2l.2.3.3.2.2.2v.2l.3.2.2.2.2.2v.2l.3.2.2.3.3.4v.3l-.8.4-.2-.4-.2-.2v-.2l-.3-.2v-.2l-.3-.2-.3-.3h-.2v-.2h-.3l-.3-.2h-.2l-.3-.2h-.4l-.2-.2h-1.2l-.2.2h-.5l-.2.2h-.2l-.2.2-.2.2zm.5 1.7l.3 1h-.5l-.2-.2h-.2l-.2-.2-.2-.2-.2-.2v-.2l-.2-.2V224l.2-.2.2-.3.3-.2.5 1h-.2v1.2h.2v.2h.4zm3.7 4l-1-.2.2.5h-.2l-.2-.2h-.2v-.3h-.2l-.2-.3v-.4l-.2-.2v-.3l-.2-.2v-.4l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2h-.6l-.4-1h1.1l.3.2h.2v.4h.2v.3l.2.2v.2h.2v.5l.2.3v.5h.2v.4h.2l.2.2.2.2.3.6zm-.3-.5l.3.2v.3l-.3-.5zm-27-7.2v-1l.6.5-.3 2.7-.2 2.4v2.2l.2 2 .3 2 .4 1.7.5 1.5.7 1.4.6 1 .8 1.2 1 1 1 .7 1 .6 1 .5 1 .4 1.3.3h2.4l1.3-.2 1.2-.3 1.2-.5 1.2-.5 1-.7 1.2-1 1-.8 1-1 1-1.3 1-1.3.8-1.3.8-1.5.6-1.7.5-1.7 1 .2-.6 2-.7 1.6-.8 1.6-1 1.5-1 1.4-1 1.3-1 1-1.2 1-1.2 1-1.2.8-1.3.7-1.2.5-1.3.3-1.4.2h-2.5l-1.2-.3-1.3-.4-1.2-.5-1-.7-1-1-1-1-1-1-.8-1.5-.7-1.5-.6-1.6-.4-1.8-.3-2-.2-2.2V227l.2-2.6.3-2.7.5.6zm0-1h.7v.5l-.6-.5zm-6.6 1.2l.2-1h4l.2-.2h2.1v1h-4.1l-.2.2h-2zm.2 0zm-6.2-.8h-1l.5-.4h5.1l.2.2h1.2v1h-4l-.3-.2h-2l.5-.6zm-1 0v-.5h.5l-.5.6zm-26.4 7.8l.5.8.3-.5.6 1.7.5 1.7.7 1.5 1 1.4.8 1.4 1 1.2 1 1 1 1 1.2 1 1.2.6 1.2.5 1.2.5 1.2.3 1.2.2h2.4l1.2-.3 1-.3 1.2-.4 1-.7 1-1 .8-.8 1-1 .6-1.3.6-1.5.6-1.6.4-1.8.3-2v-2l.2-2.3-.2-2.5-.3-2.7h1l.3 2.6.2 2.5v2.2l-.2 2.2-.3 2-.5 1.8-.5 1.6-.7 1.5-.8 1.4-1 1.2-1 1-1 .8-1 .7-1.2.5-1.3.4-1.3.3H463l-1.2-.2-1.3-.3-1.3-.5-1.3-.6-1.3-.7-1.2-1-1.2-1-1-1-1-1.2-1-1.3-1-1.5-.7-1.6-.7-1.7-.6-2 .2-.5zm-.2.5v-.3l.2-.2-.2.5zm3.7-4l-.2 1-.2-.2h-.7v.2l-.2.2v.4l-.2.2v.5l-.2.2v.2l-.2.3v.2l-.2.2v.2h-.2v.3h-.3l-.2.2h-.2l-.4-.7.2-.2.2-.2h.2v-.3l.2-.2v-.5l.2-.2v-.5l.2-.3v-.3l.2-.2.3-.3.2-.2h.2l.2-.2h1.1zm.4-1.8l.6-1v.2h.3v.3h.2v.2l.2.2v1.5l-.2.2v.2l-.2.2-.3.2-.2.2h-.9l.3-1h.4v-.4l.2-.2v-.8h-.2v-.2h-.2zm-6.7 2l.8-.6h-.8v-.2l.2-.3.3-.4v-.2l.3-.2.2-.2.2-.2.2-.2.2-.2.2-.2h.2l.3-.3.3-.2h.2l.3-.2h.5l.2-.2h1.6l.4.2h.2l.3.2h.2l.3.2.2.2h.3l-.6 1-.2-.2h-.2l-.2-.2h-.3l-.2-.2h-.5l-.2-.2h-1.3l-.2.2h-.3v.2h-.3l-.2.3-.2.2-.3.3-.3.3-.2.2v.2l-.2.2-.2.2v.3h-.2l-1 .2zm1 0l-.5.7-.5-.8h1zm-7-1.2l-.8-.8.2-.2.2-.2h.3l.2-.3h.2l.2-.2h.3l.3-.2h2.5l.3.2h.2l.3.2.2.2h.2l.2.3h.2l.2.2.2.2.2.3.2.2h.2v.4l.3.2-.8.6-.2-.2v-.3l-.3-.2-.2-.2-.3-.3-.2-.2h-.2l-.2-.2v-.2h-.2l-.2-.2h-.4l-.2-.2H441l-.2.2h-.2l-.2.2h-.2l-.2.3h-.2l-.2.3zm.5 1.6l.4 1h-1.3l-.2-.2-.3-.2h-.2v-.2l-.2-.3v-.2l-.2-.2v-1.6l.2-.2.2-.2v-.2l.8.8-.2.2v1l.2.2.2.2h.4zm3.8 3.6l-1-.4.2.6h-.2v-.3h-.3v-.2h-.2v-.3h-.2v-.5h-.2v-.6h-.2v-.5l-.2-.2-.2-.2h-.2v-.2h-.5v.2l-.5-1h.4l.2-.2h.6l.2.2.3.2h.2v.2l.2.2.2.3v.2l.2.2v.2l.2.3v.2l.2.2.2.2.2.2.2.2.2.6zm-.2-.6l.3.2v.4l-.2-.6zm-26.6-2.5l-.3-1 .5.4 1 2 1 2 1.2 2 1 1.6 1 1.6 1 1.5 1 1.4.8 1.2 1 1 .8 1 1 .8.7.6 1 .6.6.4.8.2.8.2h1.3l.7-.2.7-.4.7-.4.7-.6.7-.7.8-.7.6-1 .7-1 .8-1.3.6-1.4.7-1.5.7-1.5.7-1.8.6-2 1 .5-.7 2-.6 1.6-.7 1.7-.6 1.5-.7 1.4-.7 1.3-.7 1.2-.7 1-.8.8-.7.8-.7.6-.8.5-1 .4-.7.4H432l-1-.2-.7-.3-1-.5-1-.6-.8-.8-1-1-.8-1-1-1-1-1.2-1-1.3-1-1.5-1-1.6-1-1.8-1-1.8-1-2-1-2.2.5.3zm-.3-1h.3l.2.4-.6-.3zm-9 3h-1l.4-.6h.7l.3-.2h.6l.4-.2h.9l.3-.2h.5l.3-.2h.6l.4-.2h.3l.3-.2h.6l.3-.2h.5l.3-.2h.3l.4-.2h.3l.3-.2h.3l.3-.2h.3l.2 1h-.7l-.3.2h-.3l-.3.2h-.3l-.3.2h-.5l-.3.2h-.3l-.4.2h-.6l-.4.2h-.6l-.3.2h-.6l-.2.2h-.6l-.3.2h-.7l-.3.2h-.8v.2h-.4l.4-.5zm-1 0v-.5h.4l-.4.5zm-17.4 7l1 .3v-.5l1 1.4 1 1.4 1.2 1.3 1 1 1 1 1 1 1 .8.8.8 1 .6.6.4.8.4.7.3h.6l.6.2h.4l.5-.2.3-.2.5-.2.4-.5.3-.5.4-.7.2-.7.3-1 .2-1 .2-1v-2.7l.2-1.5v-5l-.2-1.8h1v2l.2 1.8v4.9l-.2 1.4v1.4l-.3 1.2-.3 1-.3 1-.2 1-.4.7-.4.7-.6.5-.5.5-.7.3-.7.2H402l-.6-.2-.8-.4-1-.5-.7-.5-1-.6-1-.8-1-.8-1-1-1-1-1-1.2-1-1.3-1.2-1.4-1-1.6-.2-.5zm0 .4v-.3.4zm2-3.7v1h-.6v.8l-.2.3v1h-.2v.3l-1-.4v-.4l.2-.2v-.9h.2v-.5l.2-.2v-.2h.4v-.2h1zm.3-1.4l.3-1 .2.2h.2v.2h.2v.7h.2v1.2l-.2.2v.3l-.2.2-.2.2h-.2l-.2.2h-.5v-1h.4v-.2h.2v-.8l-.2-.2zm-5.7 2.7l.7-.8-.8.2v-.2l.2-.3v-.3l.2-.3v-.2l.2-.2.2-.2v-.2l.3-.2v-.2l.3-.2h.2v-.3h.3l.3-.2.2-.2h.4v-.2h2.5l.3.2h.2l.3.2-.4 1-.3-.2h-.5l-.2-.2h-1.3l-.3.2h-.2v.2h-.2l-.2.2v.2h-.2l-.2.2v.2h-.2v.3l-.2.2v.2h-.2v.5l-.2.2-1 .3zm1-.3l-.4.8-.7-.5 1-.3zm-5.8-.2l-.7-.6v-.2l.3-.2h.3l.2-.2h.2l.2-.2.3-.2h.2l.2-.2h2.1l.2.2h.2l.2.2h.2l.2.2.3.2.2.2h.2l.2.3v.2l-.7.8v-.2h-.3v-.2l-.3-.2-.3-.2h-.3v-.2h-.2l-.2-.2h-2v.2h-.3l-.2.2-.2.2h-.2l-.2.2zm-.7-.6v-.2zm1.4 1.7l.6 1h-1.3l-.3-.2-.2-.2v-.2h-.2l-.2-.2v-.3l-.2-.2v-.8l.2-.3h.2l.7.5v.8h.2v.2h.2v.2h.2zm3.6 2.7h-1l.3.5v-.2h-.3v-.2h-.3v-.3h-.2v-.2h-.2v-.2l-.2-.2v-.3h-.2v-.2l-.2-.3v-.2h-.7l-.6-.8h.2l.2-.2h1.1l.3.2.2.2v.2h.2v.4l.2.2v.5h.2v.2l.2.2.2.2h.2l.4.6zm-.4-.5h.4v.4l-.4-.5zm-14.7-.4v-1l.4.3.8 1.5.6 1.5.7 1.3.7 1.3.6 1.2.6 1 .6 1 .6 1 .5.6.6.7.5.7.6.4.5.5.3.2.5.2h1.1l.3-.3.3-.2.4-.4.3-.4.4-.5.3-.6.3-.8.3-.8.2-1 .3-1 .3-1.3.2-1.3v-1.4l.2-1.4h1v1.5l-.2 1.4-.2 1.3-.2 1.2-.2 1-.2 1-.3 1-.4.8-.4.8-.4.6-.4.6-.5.4-.5.4-.5.2-.6.2h-1.1l-.6-.3-.7-.4-.6-.4-.5-.6-.6-.6-.7-.7-.7-.7-.6-1-.6-1-.6-1-.6-1.2-.6-1.2-.7-1.4-.7-1.5-.6-1.7.5.3zm0-1h.3v.3l-.4-.4zm-3.8.6l3.6-.6v1l-3.6.6-.5-.5.4-.5zm-.5.5v-.4h.4l-.5.4zm4.7 11.4l-.8.7-.3-.3v-.3l-.3-.3-.2-.3-.3-.3-.2-.3-.2-.3v-.4l-.3-.3-.2-.4-.2-.4v-.4l-.2-.4v-.4l-.3-.4v-.4l-.2-.3v-.4l-.2-.4v-.9l-.2-.3v-.8l-.2-.5V238l-.2-.5v-.7h1v1.9l.2.4v1.1l.2.5v.7l.2.3v.4l.2.4.2.3v.4l.2.5.2.3v.4l.2.3.2.4.2.2v.3l.3.4.2.2v.3l.3.3.2.4.2.3.2.3.2.3zm18.7-4.7l-.8.7 1-.3-.2 1.4v1.4l-.2 1.3-.2 1.2-.2 1-.3 1-.2 1-.3 1-.4.7-.4.8-.4.7-.6.6-.5.5-.5.4-.7.3-.6.3h-.7l-.8.2h-.7l-.8-.2-.8-.2-.8-.2-1-.4-.7-.5-1-.7-1-.6-.8-.8-1-1-1-1-1-1-.8-1-1-1.3.8-.6 1 1.3 1 1 .8 1 1 1 1 .8.7 1 1 .5.7.6.8.5.8.4.7.2h.7l.7.3h1.4l.6-.2.4-.2.6-.2.4-.3.5-.5.4-.5.4-.6.4-.7.3-.8.3-.8.3-1 .4-1 .2-1 .2-1.2v-1.2l.2-1.3v-1.3l1-.4zm-1 .4V242l1 1-1 .4zm27.3-3.2l-1 .4 1-.2-.2 1.6v1.5l-.4 1.3-.4 1.3-.4 1.2-.4 1.2-.5 1-.7 1-.6 1-.6.7-.6.7-.8.6-.7.5-1 .4h-.8l-1 .3h-2.8l-1-.3-1-.4-1.2-.4-1-.6-1.2-.6-1.2-.8-1-.8-1.3-1-1.2-1-1.3-1.2-1.2-1.3-1.3-1.5-1.3-1.5.7-.7 1.2 1.5 1.3 1.4 1.2 1.2 1.2 1.2 1 1 1.3 1 1 .8 1.2.7 1 .7 1 .6 1 .4 1 .3 1 .2h1l.8.2h.8l1-.2.7-.3.7-.4.7-.5.7-.4.6-.6.6-.7.5-.8.5-1 .4-1 .5-1 .2-1.2.4-1.3.3-1.3v-1.5l.3-1.6h1zm-1 0l.2-1.5.8 1.5h-1zm31.8-1.8l-.8.3h1v1l-.3 1.4-.4 1.2-.4 1.2-.5 1-.6 1.3-.6 1-.7 1-.8 1-1 1-1 .7-1 .7-1 .7-1 .6-1.2.5-1.2.4-1.2.3h-3.8l-1.3-.2-1.3-.4-1.4-.4-1.3-.7-1.3-1-1.3-.8-1.3-1.2-1.3-1.2-1-1.5-1.3-1.6-1.2-1.8-1-2 .8-.5 1 2 1.2 1.6 1.2 1.7 1.2 1.4 1 1.3 1.3 1 1.2 1 1.3.7 1.2.6 1.2.5 1.3.5 1.2.2h3.6l1.2-.3 1-.3 1-.3 1.2-.5 1-.6 1-.7.7-.8 1-1 .6-.7.6-1 .6-1 .6-1 .4-1 .4-1.2.3-1V239h1zm35.6-3l-1 .2h1l-.2 2-.4 2-.6 1.6-.6 1.7-.8 1.6-1 1.3-1 1.3-1 1-1.3 1-1.3 1-1.3.8-1.3.6-1.5.6-1.5.3-1.5.2h-1.5l-1.6.2-1.4-.2-1.6-.2-1.5-.3-1.5-.5-1.4-.6-1.4-.7-1.4-1-1.3-1-1.2-1-1-1.2-1-1.4-1-1.4-1-1.6-.6-1.6-.5-1.8 1-.3.5 1.7.6 1.6.8 1.5 1 1.3 1 1.3 1 1.2 1.2 1 1.2 1 1.3.8 1.3.7 1.4.5 1.4.5 1.4.3 1.5.2h4.4l1.5-.3 1.4-.4 1.3-.5 1.3-.5 1.3-.7 1-1 1.2-.8 1-1 1-1.3 1-1.4.6-1.4.7-1.7.5-1.7.4-1.8.2-2h1zm35.5 3l-1 .2h1l-.4 1.8-.7 1.6-1 1.6-1 1.4-1 1.4-1 1.2-1.3 1-1.2 1-1.4 1-1.3.6-1.5.6-1.4.5-1.6.3-1.5.2-1.5.2h-1.6l-1.5-.2-1.4-.3-1.5-.4-1.4-.6-1.4-.6-1.3-.8-1.4-1-1.2-1-1-1-1.2-1.3-1-1.4-.7-1.7-.7-1.7-.5-1.7-.4-2-.4-2 1-.2.3 2 .3 1.8.5 1.7.6 1.6.8 1.3 1 1.4.8 1.2 1 1 1.2 1 1.2.8 1.3.7 1.3.6 1.4.6 1.4.3 1.4.2h4.5l1.4-.2 1.5-.3 1.4-.5 1.3-.5 1.3-.7 1.3-.8 1-1 1.2-1 1-1 1-1.4 1-1.3.7-1.5.6-1.6.5-1.7h1zm31 2h-1l1 .2-1.2 2-1.2 1.7-1.2 1.6-1.2 1.5-1.3 1.2-1.4 1.2-1.3 1-1.3.7-1.3.6-1.3.5-1.4.5-1.3.2H530l-1.3-.3-1.2-.3-1.2-.4-1-.5-1-.6-1-.7-1-.8-1-1-.7-1-.8-1-.6-1-.6-1-.5-1.2-.3-1.2-.3-1.2-.2-1.3v-1l1-.2v1.2l.2 1.2.3 1 .4 1.2.5 1 .6 1 .7 1 .7 1 .7 1 1 .8.8.7 1 .6 1 .6 1 .5 1 .4 1 .4 1.3.2 1.2.2h2.4l1.2-.3 1.2-.4 1.3-.4 1.2-.6 1.3-.7 1.2-1 1.2-1 1.2-1.2 1.2-1.3 1.2-1.6 1-1.6 1.2-2 1 .2zm-1-.2l.8-1.5.2 1.6h-1zm27.2 3.2h-1l1 .3-1.4 1.5-1.3 1.4-1.2 1.2-1.3 1-1.2 1.2-1.2 1-1.2.8-1 .8-1.2.6-1 .6-1.2.4-1 .4-1 .2-1 .2h-2l-1-.3h-.8l-.8-.5-.8-.5-.7-.6-.8-.7-.6-.8-.6-1-.6-1-.5-1-.5-1-.4-1.4-.3-1.3-.3-1.4-.2-1.6-.3-1.6 1-.2.2 1.6.2 1.5.3 1.3.3 1.3.4 1.2.4 1 .5 1 .5 1 .6.8.6.7.6.6.6.5.7.6.6.3.8.2h.8l.8.2h.8l1-.2 1-.2.8-.3 1-.4 1-.6 1.2-.6 1-.6 1.2-.8 1.2-1 1-1 1.4-1.2 1.2-1.2 1.3-1.4 1.3-1.5 1 .4zm-1-.4l1-1v1.4l-1-.4zm19 4.8l.7.7-1 1.2-1 1-1 1-1 1-1 1-.8.7-1 .6-.8.6-.8.4-1 .4-.7.3-1 .3-.7.2h-1.5l-.7-.2-.6-.3-.6-.3-.6-.4-.6-.5-.5-.6-.4-.7-.4-.8-.4-.8-.3-1-.3-1-.3-1-.3-1-.2-1.3V246l-.2-1.3v-1.3h1v2.6l.2 1.3.2 1 .2 1.2v1l.4 1 .4.7.3.8.5.6.4.5.4.5.4.5.5.3.5.3.6.3h.6l.6.2h.6l.7-.2h.6l.7-.4.8-.5 1-.4.7-.5 1-.6.7-1 1-.7.8-1 1-1 1-1 1-1.2zm4-10.7v-1l.6.4v2.9l-.2.4v.7l-.2.4v.5l-.2.4v.3l-.2.4v.3l-.3.4v.4l-.2.4-.2.4v.3l-.3.3-.2.4-.2.3-.2.4-.2.3-.2.4-.2.4-.2.3-.2.4-.2.4-.3.3-1-.6.3-.2.3-.3.2-.3.2-.4.2-.3.2-.3.2-.3v-.5l.3-.3v-.3l.2-.5.2-.3v-.4l.3-.3v-.4l.2-.3v-.7l.2-.4v-.3l.2-.4v-.5l.2-.4v-1l.2-.4v-1.8l.5.5zm0-1h.6v.4l-.5-.5zm0 0v1-1zm0 1z"
        />
        <path
          fill="#edb92e"
          d="M482 263h-22.5l-1.3.2H451l-1.3.2h-4.4l-1.2.2h-2.3l-6.3.4h-.3c-3 0-6 .3-9 .4h-.8l-18.2 1.3h-.2a965 965 0 0 0-26.4 2.4c-5 .6-6-5.3 0-6a960.5 960.5 0 0 1 26.3-2.2 983.7 983.7 0 0 1 37-2.2h2.4l15.4-.5h16.8a1082.3 1082.3 0 0 1 7.2 0h16.6l15.2.5h3.3a984 984 0 0 1 37 2.3 960.5 960.5 0 0 1 26.2 2c5.8.7 5 6.6 0 6a965.6 965.6 0 0 0-26.4-2.3h-.3a978.4 978.4 0 0 0-18.3-1.2h-.6l-9.2-.5h-.3c-2.2 0-4.3-.2-6.4-.3h-2.3l-1.2-.2h-4.5l-1.3-.2H506l-1-.2h-23z"
        />
        <path
          fill="#0c4076"
          d="M482 105a17.3 17.3 0 0 1 .1 34.7c-9.3 0-17-7.8-17-17.3 0-9.6 7.7-17.3 17-17.3z"
        />
        <path
          fill="#edb92e"
          d="M485.3 85c1.6-.2 3-1.5 3-3.2 0-1.7-1.4-3-3-3.2 0-1.7-1.4-3-3.2-3a3 3 0 0 0-3 3c-1.6 0-3 1.5-3 3.2a3 3 0 0 0 3 3v6.5h-5.5a3 3 0 0 0-3-3c-1.8 0-3 1.3-3.2 3a3 3 0 0 0-3 3c0 1.8 1.3 3.2 3 3.2a3 3 0 0 0 3 3c1.8 0 3.2-1.2 3.2-3h5.5V119h6.3V97.6h5.5a3 3 0 0 0 3 3c1.8 0 3-1.4 3.2-3 1.7 0 3-1.5 3-3.2a3 3 0 0 0-3-3c0-1.8-1.4-3.2-3-3.2-2 0-3.2 1.4-3.2 3h-5.5V85z"
        />
        <path
          fill="#21231e"
          d="M487.8 81.8h1v1h-.2v.5h-.2v.3l-.2.3-.2.2v.2h-.2l-.2.2-.2.2h-.2v.2h-.2l-.2.2h-.2v.2h-.8l-.2.2h-.3v-1h.7V84h.2l.3-.2h.2v-.2h.2v-.2l.2-.2V83h.2l.2-.2v-.4l.2-.2v-.4zm-3-3.2h1l-.5-.5h.2l.3.2h.4l.3.2h.3l.2.2.2.2h.2v.2h.2l.2.2.2.3.2.2v.2h.2v.4h.2v.5l.2.2v.7h-1V81h-.2v-.4l-.2-.2V80h-.4v-.2h-.2v-.2h-.2l-.3-.2h-.2V79h-.8l-.4-.6zm.4.5h-.4v-.4l.4.5zm-3-3v-1h.7l.2.2h.2l.3.2h.2l.2.2.2.2h.2v.3l.2.2.2.3.2.2v.2h.2v.4h.2v.8h.2v.3h-1V78h-.2v-.5h-.2v-.2l-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2l-.2-.2h-.4l-.3-.2h-.4zm-3.2 3v-1l-.5.6v-.8l.2-.2V77h.2v-.6h.2v-.2l.2-.2.2-.2.2-.2h.2v-.2h.3v-.2h.3l.3-.2h.4l.2-.2h.4v1h-.5v.2h-.3l-.2.2h-.2v.2h-.2v.2h-.2v.2l-.2.2v.2h-.2v.5h-.2v1l-.6.5zm.5-.4v.5h-.5l.5-.4zm-3 3.2h-1V81l.2-.3v-.5l.2-.2v-.2l.2-.2.2-.3.2-.2h.2l.2-.2h.2v-.2h.3v-.2h.5l.3-.2h.7v1h-.7l-.2.2h-.2l-.2.2-.2.2-.2.2-.2.2v.2h-.2v.4l-.2.2v.8zm3 3h-1l.5.6h-1V85h-.7v-.2h-.3v-.2h-.2l-.2-.2-.2-.2V84h-.2v-.2l-.2-.2-.2-.3v-.5h-.2v-1h1v1h.2v.4h.2v.2h.2v.2l.2.2h.2v.2h.2l.3.2h.7v.2h.2l.5.5zm-.5-.4h.5v.5l-.5-.6zm-.5 7V85h1v6.3l-.5.5-.5-.5zm1 0v.4h-.5l.5-.5zm-6-.6h5.5v1h-5.5l-.5-.5.5-.5zm0 1h-.5v-.5l.5.5zm-3-3v-1h1.2v.2h.3l.3.2.3.2.3.2v.2l.2.2.2.3.2.3.2.3v.4l.2.2v.8h-1v-.7l-.2-.2V90h-.2v-.2h-.2v-.2l-.2-.2-.2-.2h-.2V89h-.4l-.2-.2h-.8zm-3.2 3v-1l-.5.4v-.8l.2-.3V90l.2-.3v-.2h.2v-.2l.2-.2h.2v-.3h.2l.2-.2.2-.2h.2V88h.7v-.2h1.1v1h-1l-.2.2h-.2v.2h-.2v.2h-.2l-.2.2v.2h-.2v.4h-.2v.8l-.2.2v.3l-.5.5zm.5-.5v.5h-.5l.5-.5zm-3 3h-1V93h.2v-.2h.2v-.3l.2-.3.3-.3v-.2h.2v-.2h.2v-.2h.2l.2-.2h.2V91h.7l.2-.2h.8v1h-.7l-.2.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2v.2h-.2v.5h-.2v.7zm3 3.2h-1l.5.5h-1v-.2h-.5l-.2-.2h-.2v-.2h-.2l-.2-.2-.2-.2v-.2h-.3v-.2l-.2-.2V96h-.2v-.4l-.2-.3v-.8h1v.9h.2v.2l.2.3h.2v.2h.2v.2h.2v.2h.2l.2.2h.5v.2h.4l.6.5zm-.5-.5h.5v.5l-.5-.5zm3 3v1h-1l-.2-.2h-.3v-.2h-.3v-.2h-.2l-.2-.2-.2-.3v-.2h-.2v-.3h-.2V99h-.2v-.5l-.2-.2V98h-.2v-.5h1v.7h.2v.4h.2v.2l.2.2v.2h.2v.2h.2v.2h.2l.2.2h.2l.3.2h.6zm3.2-3v1l.5-.4v.8l-.2.2v.3h-.2v.3l-.2.3-.2.2-.2.2-.2.2-.3.2-.2.2h-.2l-.2.2h-.2l-.3.2h-.8v-1h.9v-.2h.2l.2-.2h.2v-.2h.2l.2-.2V99h.2v-.2l.2-.3v-.2l.2-.2v-.4l.5-.5zm-.5.6V97h.5l-.5.6zm6 .5h-5.5v-1h5.5l.5.6-.5.5zm0-1h.5v.6l-.5-.5zm-.5 22V97.6h1V119l-.5.5-.5-.5zm.5.5h-.5v-.5l.5.5zm6.3 0H479v-1h6.3l.5.5-.5.5zm.5-.5v.5h-.5l.5-.5zm0-21.4V119h-1V97.6l.5-.5.5.6zm-1 0V97h.5l-.5.6zm6 .5h-5.5v-1h5.5l.5.6-.5.5zm0-1h.4v.6l-.4-.5zm3 3v1h-1l-.3-.2h-.2l-.3-.2-.2-.2h-.2v-.2h-.2l-.2-.2v-.2h-.2v-.2l-.2-.2V99h-.2v-.2h-.2v-1l-.2-.2h1v.4l.2.2v.2l.2.3v.2h.2v.2h.2l.2.2v.2h.2l.3.2h.2v.2h1.1zm3.2-3v1l.5-.5v.7h-.2v.5l-.2.3v.4h-.2v.3h-.2v.2h-.2v.2h-.3v.2l-.3.2h-.3l-.2.2h-.3l-.2.2h-.8v-1h.9v-.2h.2v-.2h.2l.2-.2.2-.2V99h.2v-.2l.2-.2v-.2l.2-.2v-.6l.6-.6zm-.5.5V97h.5l-.5.5zm3-3h1v.9l-.2.3v.2h-.2v.6h-.2l-.2.2v.2h-.2v.2h-.3v.2h-.2v.2h-.3l-.3.2h-.2l-.3.2h-.7v-1h.8V97h.2v-.2h.2l.2-.2.2-.2h.2V96l.2-.3v-.2h.2v-.7l.2-.3zm-3-3.2h1l-.5-.6h.7l.2.2h.4l.3.2.3.2.3.2.2.2.2.3.2.2v.5h.2v.3h.2v.7l.2.3v.4h-1v-.6h-.2v-.4l-.2-.2-.2-.2v-.2h-.2l-.2-.2-.2-.2h-.2V92h-.5l-.2-.2h-.5l-.5-.5zm.5.5h-.5v-.5l.5.5zm-3-3v-1h1.1l.2.2h.4v.2h.3v.2l.3.2.2.3h.2v.3h.2v.4l.2.2v.4h.2v.7h-1v-.8h-.2V90l-.2-.2-.2-.2-.2-.2-.2-.2h-.2V89h-.5v-.2h-.6zm-3.2 3v-1l-.6.5v-.9l.2-.2V90l.2-.3.2-.3.2-.3h.2v-.2l.2-.2h.2v-.2h.2l.2-.2h.3l.2-.2h.3l.2-.2h1v1h-1l-.3.2h-.2v.2h-.2l-.2.2v.2l-.2.2-.2.2v.2l-.2.2v.7l-.7.6zm.5-.5v.5h-.6l.6-.5zm-6-.5h5.5v1h-5.5l-.5-.5.5-.5zm0 1h-.5v-.5l.5.5zm.5-7v6.5h-1V85l.4-.6.6.5zm-1 0v-.4h.4l-.4.5zm.5 0v-.4.5zm-.5 0v-.4h.4l-.4.5z"
        />
        <path
          fill="#21231e"
          d="M499.8 122.4h-1v-1.7l-.2-1v-.7l-.3-.8-.2-.8-.2-.8-.3-.8-.3-.7-.4-.6-.4-.7-.4-.7-.5-.7-.5-.6-.5-.6-.6-.5-.7-.6-.6-.6-.6-.5-.5-.6-.7-.4-.7-.4-.6-.4-.8-.3-.7-.4-1-.3-.7-.2h-.8l-.8-.2h-.8l-1-.2h-1v-1h2l.8.2h1l.8.3.8.4.8.2.8.4.8.3.8.4.7.4.7.6.7.5.7.6.6.6.6.6.6.6.6.6.5.7.5.7.5.7.4 1 .4.6.4.8.3.8.3 1 .3.7.2.8v1l.2.7v2zM482 140.2v-1h1.8l1-.2.7-.2.8-.2.8-.2 1-.3.6-.2.8-.3.7-.4.8-.3.7-.4.6-.5.7-.5.6-.5.6-.6.5-.5.5-.6.5-.6.5-.6.4-.7.4-.6.4-.8.3-.7.3-1 .3-.6.3-.8.2-.8v-1l.2-.7v-1.6h1v2.8l-.2.8-.2.8-.3 1-.3.7-.3.8-.3.8-.3 1-.4.6-.5.7-.5.7-.5.7-.6.6-.6.7-.6.6-.6.5-.7.6-.7.5-.7.6-.7.4-.8.4-.8.4-.8.3-.8.4-.8.2-1 .2-.8.2h-.8l-1 .2h-1zm-17.5-17.8h1v1.8l.2.7v.8l.3.8.2.8.3.7.3 1 .3.6.5.8.4.7.3.8.5.6.5.6.5.7.6.5.5.6.5.5.7.5.6.5.7.4.7.4.7.5.7.3.7.3.8.4.8.2.8.2.8.2h1.8l.7.2v1h-1.8l-.7-.2-1-.2-.8-.2-.8-.2-1-.3-.7-.2-.8-.4-.8-.4-.7-.4-.7-.5-.7-.4-.7-.5-.7-.4-.7-.6-.5-.7-.5-.6-.5-.7-.5-.7-.5-.7-.4-.7-.4-1-.3-.7-.5-.8-.2-.8-.3-1-.2-.7v-1l-.2-.8v-1.8zm17.6-17.8v1h-1.7l-.7.2h-.8l-.8.3-.8.3-.8.3-.7.3-.8.2-.8.4-.7.4-.7.4-.6.5-.7.4-.6.5-.6.5-.6.6-.5.7-.5.6-.5.7-.4.7-.5.7-.4.7-.2.8-.3.8-.3.8-.2.8-.2.8v.8l-.2 1v1.7h-1v-2.8l.2-1 .2-.8.3-1 .2-.8.4-.8.2-.8.4-.7.4-1 .5-.6.5-.7.5-.7.6-.6.6-.6.7-.6.6-.6.6-.5.7-.4.7-.5.7-.3.8-.4.8-.3.8-.4 1-.2.7-.3h1l.8-.2h.8l1-.2h.8z"
        />
        <path
          fill="#edb92e"
          d="M499 118.8a17.6 17.6 0 0 1 0 6c-5.5-.2-11.2-.3-17-.3-5.5 0-11.2 0-17 .3a17.5 17.5 0 0 1 .3-6l16.8-.3c5.8 0 11.4.2 17 .3z"
        />
        <path
          fill="#21231e"
          d="M499.8 122.4h-1V120h-.2v-1l1-.2v1.7l.2.2v1.6zm-.7 3l.2-1-.6.3v-.8l.2-.2v-1.1h1v2.2h-.2l-.5.5zm.6-.5v.3h-.5l.6-.4zm-17.5 0v-1H494l.4.2h4.8v1h-10.6l-.5-.2h-6zm-17.4 0l1-.3-.5-.4h4.7l.4-.2H482v1h-11l-.5.2H465l-.5-.3zm.6.3h-.5v-.4l.5.3zm-.7-3h1v2.4l-1 .3v-2.6zm.8-4v1l.5-.3v.8l-.2.2v2.5h-1v-3h.2v-.4l.5-.5zm-.5.5v-.4h.5l-.5.4zm17.3-.8v1h-9.1l-.5.2H466l-.7.2v-1h2.5l.5-.2h9l.5-.2h4.2zm17.5.8l-1 .2.4.4h-3.6l-.5-.2h-10.3l-.5-.2h-2.1v-1h10l.5.2h6.1l.5.6zm-.5-.5h.4v.5l-.4-.5z"
        />
        <path
          fill="#edb92e"
          d="M468.8 133.2c-3.6-2.3-4.3 1.2-4.2 4.7.4 13.2 3 25.8-.6 42-1.4 6.4-3.7 10-1.5 11.3 5.7 3.2 8.3 6 7.4 7.7 1.5 3.2 5.7 2.6 12 1.6 6.6 1 10.7 1.6 12.4-1.6-1-1.6 1.7-4.5 7.4-7.7 2.2-1.2 0-5-1.5-11.3-3.5-16.2-1-28.8-.7-42 0-3.6-.5-7-4-4.8a28.6 28.6 0 0 1-26.8 0z"
        />
        <path
          fill="#21231e"
          d="M465 138h-1v-1.5l.2-.3v-1.6l.2-.3v-.3h.2v-.4l.2-.2v-.3h.2l.2-.3.2-.2.2-.2h.2l.2-.2h1.8l.4.2.4.2h.3l.4.3-.4 1-.4-.3h-.2l-.3-.2h-.3l-.2-.2h-1.2v.2h-.2v.2l-.2.2v.2l-.2.2v.4l-.2.3v.4l-.2.2v2.5zm-.5 42l-1-.2.3-1.5.3-1.4.3-1.6.2-1.4.2-1.5.2-1.4v-2.5l.2-1.4V154l-.2-1.2v-2.5l-.2-1.2V148l-.2-1.2v-1.2l-.2-1.3V142l-.2-1.3V138h1v3.5l.2 1.2v2.6l.2 1.2v1.3l.2 1.2v2.5l.2 1.2v1.3l.2 1.3v13.3l-.2 1.4v1.4l-.3 1.5-.2 1.4-.2 1.6-.2 1.4-.2 1.5-.3 1.6zm-1.8 11l-.4.8-.3-.2-.2-.2-.2-.2-.2-.2v-.2l-.2-.3V188l.2-.3v-.4l.2-.3v-.4l.2-.4v-.5l.3-.4.2-.4v-.5l.3-.3v-.5l.3-.5v-.6l.3-.4.2-.6v-.6l.3-.6 1 .3-.2.7v.6l-.3.5v.6l-.2.5-.2.4v.6l-.3.4v.5l-.3.4v.4l-.2.4v.4l-.2.4v.4l-.2.3v.4l-.2.4v1.9l.2.2.2.2zm7.6 7.8l-1 .4v-.4h.2v-1l-.2-.2v-.2l-.2-.2v-.4l-.3-.2-.2-.2-.2-.3h-.3l-.2-.4-.3-.2-.3-.3h-.3l-.4-.4-.4-.3-.3-.2-.5-.2-.4-.3-.3-.3-.5-.3-.5-.3-.4-.3-.5-.3-.6-.2.5-1 .6.4.5.3.5.3.4.3.5.4.4.3.5.3.5.2.3.3.4.3.4.3.3.4.2.2.3.3.3.2.2.2.2.3.3.2.2.2v.2l.3.3v.2l.3.2v.5l.2.2v1.1l-.2.3v-.5zm-1 .4v-.4.4zm13 1l-.2 1h.2-1.2l-.5.2h-1.2l-.6.2h-1l-.5.2h-4.7l-.4-.2h-.3l-.3-.2-.3-.2-.3-.2-.2-.2-.3-.2-.2-.2-.3-.3h-.2l-.2-.4-.2-.4 1-.4v.2l.2.3.2.2.2.2.2.2h.2l.2.2h.2l.3.2h.3l.3.2h.3l.2.2h4.3l.5-.2h1l.6-.2h1.1l.5-.2h.8zm-.2 0h.2zm12-1l1-.4v.4l-.3.4-.2.3h-.2l-.3.4-.2.2-.3.2-.3.2-.3.2-.4.2h-.3l-.3.2h-.4l-.4.2H486l-.6-.2h-.5l-.6-.2h-1.2l-.5-.2h-.6l.2-1h1.8l.5.2h.6l.6.2h1.1l.5.2h4.2l.3-.2h.3l.2-.2h.3l.2-.2.2-.2.3-.3.2-.2.2-.2v-.3l.3-.2v.5zm1-.4v.4-.4zm6.5-8l.5 1-.5.3-.5.4-.5.3-.4.2-.4.2-.4.3-.4.3-.4.3-.4.3-.3.3-.3.3h-.3l-.2.4-.3.2-.3.3h-.2l-.2.4-.2.2-.2.2v.2l-.3.2v.7h-.2v1.2l-.8.5v-.2l-.2-.2v-1.3l.2-.2v-.3l.3-.3v-.3l.3-.2.2-.3.2-.3.3-.3.2-.2.3-.3.3-.4.4-.2.3-.3.4-.2.4-.3.4-.3.4-.2.4-.3.5-.3.5-.3.5-.2.5-.3.5-.3.5-.3zm-1.7-10.7l1-.2v.6l.3.6.2.6.2.5v.7l.3.5v.5l.2.4v.6l.2.5.2.5v.4l.2.3v.4l.2.4v.5l.2.3v.7l.2.3v1.8l-.2.3v.2l-.3.3h-.2l-.2.3-.3.2-.5-1h.2l.2-.2v-.4h.2v-2.5l-.2-.3v-.3l-.2-.3v-.4l-.2-.4v-.4l-.2-.4v-.4l-.3-.5v-.6l-.2-.4v-.6l-.3-.5v-.6l-.3-.6v-.5l-.2-.6-.2-.6zm-.7-42h1v5.9l-.2 1.4v1.2l-.2 1.2v1.3l-.2 1.3v2.5l-.2 1.2v2.6l-.2 1.2v9.3l.2 1.4v1.4l.2 1.3.2 1.5.2 1.5.2 1.4.2 1.5.3 1.3.3 1.5-1 .3-.3-1.5-.3-1.5-.2-1.4-.2-1.5-.2-1.3-.2-1.5v-1.4l-.2-1.4V167l-.2-1.3v-10.3l.2-1.3v-2.5l.2-1.3V149l.2-1.2v-1.3l.2-1.2V143l.2-1.2V138zm-3.3-4.4l-.5-1h.4l.3-.2.2-.2h.3l.4-.2h1.2l.3.2h.2l.2.3v.2l.2.2h.2v.4l.2.2v.3h.2v.7l.2.3v1.5l.2.3v1.1h-1v-2.4l-.2-.3v-.8l-.2-.3v-.4l-.2-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-1.1l-.2.2h-.3l-.3.2-.3.2zm-27 0l.4-1 .8.5.7.5.7.4.7.2.7.3.8.2.8.3 1 .2.7.2 1 .2h.7l1 .2h.8l1 .2h4.6l.7-.2h1l.8-.3h.8l1-.3.7-.2.8-.3.8-.2.8-.3.7-.4.8-.3.7-.4.7-.3.5 1-.7.3-.7.4-.8.4-.7.3-1 .4-.7.3-.7.3-1 .2-.7.2-1 .2h-.8l-1 .2h-1l-.8.2h-4.6l-1-.2h-.8l-1-.2-.8-.2-1-.2-.7-.2-.8-.3-.8-.3-.8-.3-.8-.2-.8-.4-.7-.4-.7-.4z"
        />
        <g id="prefix__b">
          <path
            fill="#edb92e"
            d="M363 212c-2-4-.3-9.8.3-11 .3-.8-.6-2.2-1-2.8-13-18.3-13.2-20-4.3-26.8 8-6 26.2-12 39.2-16.2 2.7-2 4.4-5 6.8-7.2-25 1.8-52 12-65.5 23.8-7.2 6.2 1.5 19 12.2 38 6.7 5 9.8 7 12.3 2.3z"
          />
          <path
            fill="#21231e"
            d="M362.8 200.7l1 .4v.2l-.2.2v.3l-.2.3v.5l-.2.2v.6l-.2.4v.7l-.2.3v1.6l-.2.4v2.5l.2.4v.4l.2.4v.4l.2.4v.3l.3.4-1 .3v-.4l-.3-.5v-.4l-.2-.4v-.4l-.2-.5v-.8l-.2-.6v-2.9l.2-.4v-1.2l.2-.3v-.4l.2-.2v-.6l.2-.3v-.6l.2-.2v-.2l.2-.2zm-1-2.2l1-.6v.2h.2v.4h.2v.4h.2v.2l.2.2v.4h.2v1.2l-1-.3v-.6l-.2-.2v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2zm-4-27.5l.5 1-.8.5-.7.6-.7.6-.5.6-.6.5-.6.5-.5.6-.5.5-.3.4-.3.5-.3.5v.5l-.3.5v1.7l.2.6.2.8.2.7.4.8.4.8.4 1 .5 1 .6 1 .7 1 .7 1.3 1 1.2.7 1.3 1 1.4 1 1.5 1 1.5 1.3 1.7-.8.5-1.3-1.7-1-1.5-1-1.5-1-1.4-1-1.3-.8-1.2-.8-1.2-.7-1-.6-1-.7-1-.4-1-.6-1-.3-.7-.2-1-.2-.7v-.7l-.2-.7v-1.4l.2-.6.2-.6.2-.6.3-.6.4-.6.5-.5.5-.5.5-.5.6-.6.7-.5.7-.7.7-.6.7-.7zm39-16.2l.7.8h-.2l-1.2.5-1.2.5-1.2.4-1.4.3-1.3.4-1.4.5-1.4.4-1.3.5-1.5.5-1.4.5-1.3.5-1.3.5-1.4.5-1.4.5-1.3.5-1.4.5-1.4.5-1.3.6-1.3.6-1.3.5-1.2.7-1.2.5-1.2.6-1 .5-1.2.6-1 .4-1 .6-1 .6-1 .5-1 .7-.7.6-.7.6-.6-1 .8-.5 1-.6.8-.7 1-.6 1-.6 1-.4 1-.6 1.2-.6 1.2-.5 1-.7 1.4-.6 1.3-.5 1.3-.6 1.3-.5 1.2-.4 1.4-.5 1.3-.5 1.3-.5 1.4-.5 1.3-.5 1.4-.5 1.4-.5 1.4-.4 1.4-.5 1.3-.4 1.3-.4 1.3-.4 1.3-.5 1.2-.4 1.3-.5 1.3-.4 1.2-.3zm.7.8h-.2.2zm6.6-7v-1l.4.8-.2.2-.3.2-.3.3-.2.3-.2.2-.2.2v.3l-.3.2-.2.2-.2.2-.2.3-.3.3-.2.3-.2.2-.2.3v.3l-.3.2-.2.3-.2.2-.3.2-.2.3-.2.2-.2.2h-.2l-.3.4-.3.2-.2.2-.3.2-.2.2-.3.2-.2.2-.6-.8v-.2l.3-.2.3-.2.2-.2.2-.2.2-.2.3-.2.2-.2.2-.2v-.2l.3-.3.2-.2.2-.2.2-.2v-.2l.3-.2.2-.2.2-.3.2-.3v-.3l.3-.2.2-.2.2-.3.2-.2v-.2l.4-.3.2-.2.2-.2.2-.3.2-.2h.3l.2-.3.4.8zm0-1l1.4-.2-1 1-.4-1zM338.8 172l-.7-.8 1.5-1 1.4-1.2 1.4-1 1.5-1.2 1.5-1 1.7-1 1.7-1 1.7-1 2-1 1.8-1 2-1 2-1 2-.8 2-1 2.2-.7 2-.8 2.3-.8 2.3-1 2.2-.6 2.3-.7 2.3-.6 2.4-.5 2.3-.6 2.4-.7 2.4-.5 2.4-.4 2.4-.4 2.4-.4 2.3-.3 2.3-.3 2.4-.3 2.3-.2v1l-2.3.2-2.3.3-2.3.3-2.3.3-2.4.4-2.3.4-2.4.4-2.3.5-2.3.6-2.3.5-2.3.6-2.3.7-2.2.7-2.2.7-2.2.8-2.2.8-2.2.8-2 1-2 .7-2.2 1-2 1-2 1-1.8.8-1.8 1-1.8 1-1.7 1-1.6 1-1.5 1-1.6 1-1.5 1.2-1.4 1-1.2 1.2zm12.2 37.3l-.5.8-.2-.2-1-1.6-1-1.8-1-1.7-1-1.7-.8-1.7-1-1.6-.8-1.5-.8-1.5-1-1.5-.7-1.5-.8-1.4-.7-1.3-.7-1.4-.5-1.3-.6-1.3-.6-1.2-.4-1.2-.5-1.2-.3-1-.3-1-.4-1.2v-1l-.2-1v-2.8l.3-.8.3-.8.4-.7.5-.8.5-.7.6-.6.8.8-.6.5-.5.6-.4.7-.3.6-.3.7-.2.8v4.5l.4 1v1l.5 1 .4 1 .4 1.3.5 1.2.4 1.2.6 1.3.7 1.3.7 1.4.7 1.4 1 1.4.7 1.5 1 1.5.8 1.5 1 1.6.8 1.7 1 1.7 1 1.7 1 2 1 1.6h-.3zm-.5.8l-.2-.2.2.3zm12.5 1.3v1l.5-.2-.3.4-.2.4-.3.4-.3.3-.3.2-.2.3-.3.2-.3.2h-.3l-.5.2h-2.1l-.4-.2-.5-.2-.4-.2-.3-.2-.5-.2-.4-.3-.5-.3-.5-.3-.4-.4-.6-.3-.5-.3-.5-.4-.6-.4-.5-.4-.6-.4-.5-.5.5-.8.7.4.5.3.6.5.6.3.5.5.4.4.5.2.4.3.4.3.5.3.4.3.4.2.5.2.4.2h.5l.3.2h1.5l.2-.2h.3l.2-.3.2-.2.3-.2.2-.3v-.3l.4-.4.2-.4.4-.4zm-.4.3v-.4h.4l-.4.3zm.4.6v-1l.5.3-.5.6zm.5-.7l.3.6h-.8l.5-.7z"
          />
          <path
            fill="#edb92e"
            d="M359 213.6a34 34 0 0 1-1-4.7c-.7-2.8-.4-5.7.5-8.3-3-4.2-6.4-8.8-8.8-13.3-1.7-3.3-3-7-2-10.6 1-4 4.5-6.6 7.6-9 3.7-2.8 8.6-5.3 13.6-7.5 11-4.6 20-7 26.5-7l-4.2 3.8c-12 4-26.4 9.2-33.3 14.5-9 6.8-8.6 8.4 4.3 26.7.4.6 1.3 2 1 2.7-.6 1.2-1.8 7.2 0 11.4-1 2-2.6 1-4.2 1.2z"
          />
          <path
            fill="#21231e"
            d="M357.4 209l1-.2v.7l.2.2v.7h.2v.8l.2.3v.3l.2.3v.7h.2v.6h.2l-1 .4v-.3l-.2-.3v-.2l-.2-.3v-.5l-.2-.3v-.6h-.2v-.5l-.2-.3v-.7l-.2-.3v-.2zm1-.2zm-.4-7.8l1-.6v.5l-.2.4v.2l-.2.2v1l-.2.2v.8l-.2.2v4.7l.2.3-1 .2v-.6l-.2-.2V203h.2v-1l.2-.2v-.5l.2-.2v-.2l.2-.3v.5zm1-.6v.5-.6zm-9.7-12.8l1-.5v.6l.3.4.3.4v.4l.4.5.2.4.3.4v.5l.4.4.3.4.2.4.2.4.3.4.2.4.3.5.3.4.3.3.3.4.2.4.2.5.3.5.3.4.3.4.3.4.3.4.2.4.3.4.2.4.3.4.3.4.3.4.3.4-1 .6-.2-.4-.3-.4-.3-.4-.3-.4-.4-.4-.3-.4-.2-.4-.2-.4-.3-.4-.3-.4-.3-.5-.4-.4-.3-.3-.3-.4-.2-.4-.3-.5-.3-.5-.3-.4-.4-.4-.3-.4-.2-.5-.2-.4-.3-.5-.2-.4-.3-.4-.3-.4-.2-.4-.3-.5-.2-.4-.2-.5-.3-.5-.2-.4zm-2-11l1 .4-.2.3v4.1l.2.4v.3l.2.3v.7l.3.3v.4l.2.4v.6l.3.3v.3l.3.3v.2l.3.3v.3l.2.3-1 .6v-.3l-.2-.3-.2-.3v-.3l-.3-.4v-.3l-.3-.3v-.3l-.3-.3-.2-.3v-.3l-.2-.2v-.4l-.2-.3v-.3l-.2-.3v-.7l-.2-.4V180l-.2-.4V178l.2-.2v-.7l.2-.3zm7.7-9.2l.6.8-.3.2-.3.3-.3.2h-.3l-.3.3-.2.3-.2.2-.3.3-.3.3-.3.2-.3.3-.2.2-.3.3-.4.3-.2.2-.3.3v.3l-.4.3-.2.3-.2.2-.3.3-.3.3-.2.3-.2.4v.3l-.3.3-.2.3v.3l-.3.3v.3l-.2.3v.4l-1-.3v-.4l.2-.4v-.4l.2-.4.2-.4v-.3l.3-.4.2-.2.2-.3.2-.3v-.3l.4-.5.2-.3.2-.2.3-.3.4-.3.2-.3.3-.2.2-.2.3-.3.2-.3.3-.2.3-.3.3-.2.3-.3.2-.2.3-.2.3-.3.3-.2h.4l.3-.4.3-.2zm13.7-7.5l.4.8-.4.2-.4.2-.5.2-.5.2-.4.2-.5.2-.4.3-.6.2-.5.2-.5.2h-.5l-.4.3-.5.3-.3.2-.4.2-.5.3-.4.2-.4.2-.4.3-.5.2-.3.2-.4.3-.4.2-.5.2-.4.2-.2.3-.4.2-.4.2-.4.2-.3.3-.4.3-.4.2-.6-.8.3-.3h.4l.4-.4.4-.3.4-.2.4-.2.4-.2.4-.3.4-.2.4-.2.4-.2.4-.3.5-.2.5-.2.4-.2.4-.2.4-.3h.4l.5-.3.4-.3.6-.2.4-.2.5-.2.5-.3.4-.2.5-.2h.4l.4-.3.5-.2.5-.2.4-.2h.5zm0 0zm27-6.4l-.6-.7.5.7H394l-.6.2h-1.8l-.7.2h-.8l-.7.2h-.7l-.8.3-.8.2h-.7l-.8.2-.8.2-1 .2-.8.2-.8.3-1 .3-.8.3-1 .3-.8.2-1 .3-.8.3-1 .3-1 .5-1 .3-.8.4-1 .4-1 .4-1 .4-1 .4-.5-1 1-.4 1-.4 1-.4 1-.4 1-.3 1-.5 1-.3 1-.4 1-.3.8-.3 1-.3.8-.4 1-.2.8-.3h1l.8-.4.8-.2.8-.2.8-.2h.8l.8-.3.8-.2h.7l.7-.2h.8l.7-.2h1.4l.5-.2h1.9l.4.8zm-.3-1h1.4l-1 1-.4-1zm-4.4 4l4-3.7.8.6-4 3.8-.3.2-.5-1zm.7.8l-.2.2.2-.2zM358.3 172l-.6-1 .7-.5.7-.5 1-.5.7-.5.8-.5 1-.5.8-.4 1-.5 1-.4.8-.5 1.2-.4 1-.5 1-.3 1-.5 1.2-.5 1-.4 1.3-.5 1-.4 1.2-.5 1-.5 1.3-.5 1-.4 1.3-.4 1.2-.5 1.2-.4 1.2-.4 1.2-.5 1-.4 1.3-.3 1.2-.4 1-.3 1.2-.4.3 1-1.2.3-1 .3-1.3.4-1 .4-1.3.5-1.2.4-1.2.3-1.2.4-1 .4-1.2.6-1.2.4-1 .4-1.3.5-1 .3-1.3.5-1 .4-1.2.5-1 .4-1 .6-1.2.5-1 .5-1 .5-1 .5-1 .5-.8.5-1 .4-.8.4-.8.5-.8.4-.7.5-.7.4-.7.5zm4.4 26l-.8.5-1.3-1.7-1-1.5-1-1.5-1-1.4-1-1.3-.8-1.2-.8-1.2-.7-1-.6-1-.7-1-.4-1-.5-1-.4-.7-.2-1-.2-.7v-.7l-.2-.7v-1.4l.2-.6.2-.6.2-.6.3-.6.4-.6.5-.5.5-.5.5-.5.6-.6.7-.5.7-.7.7-.6.7-.7.6 1-.8.5-.7.6-.7.6-.5.6-.6.5-.6.5-.5.6-.5.5-.3.4-.3.5-.3.5v.5l-.2.6v2.2l.3.8.3.7.4.8.4.8.4 1 .6 1 .5 1 .7 1 .7 1.3 1 1.2.7 1.3 1 1.4 1 1.5 1 1.5 1.3 1.7zm1 3l-1-.3v-1h-.2v-.2l-.2-.2v-.2h-.2v-.4l.7-.7.2.2v.4h.2v.2l.2.2v.2l.2.2v.4h.2v1.4zm.2 11.6l-1-.5v.6l-.2-.4-.2-.5v-.4l-.2-.4v-.6l-.2-.4v-.5l-.2-.4v-5.4l.2-.4v-.7l.2-.4v-.5l.2-.3v-.4l.2-.2 1 .3v.2l-.2.2v.6l-.2.2v.6l-.2.3v1.1l-.2.4v5.1l.2.4v.8l.3.4v.4l.2.4.2.4v.4zm0-.4v.4-.4zm-5 1v1-1h.2l.2-.2h1.4v.2h1.5l.2-.2h.2v-.2h.2v-.2l.2-.2.2-.3 1 .6-.2.2-.2.2v.2l-.2.2h-.2v.2l-.3.2h-.4l-.2.2h-.3v.2h-3v-1zm0 1v-1l.6.2-.5.7zm.6-.8l.2.7h-.7l.6-.6z"
          />
          <path
            fill="#edb92e"
            d="M468 132.2c.3-2.3 0-2-.3 1.6-.3-.7-.8-1-1.4-1-1 0-1.7 1.6-1.8 5.2l.2 2.8c-33-.7-52.7 4.3-57.7 14-4.2 7.8 3 21 13.6 36 1.3 1.8 1.2 1.6 0 3-1.8 2.3-3.8 6-2.3 9.2a24.3 24.3 0 0 1-21 1.5c-1-3-3.4-4.4-5.4-5.8-.5-.2-2-1-2-1.4l-10.2-31.6c-9.5-30.7 75.3-33.5 88.3-33.5z"
          />
          <path
            fill="#21231e"
            d="M467.3 134l1-.4-1 .2V132h.2v-1.2l.2-.2.6-.3.3.3v1.6h-1V131l.4.2h.6v-.2 1l-.2.2v1.8h-1zm1 0l-.2 1.6-.7-1.5h1zm-2-.7v-1h.7v.2h.4v.2h.2v.2h.2v.2h.2v.2h.2v.2l-1 .5v-.2h-.2v-.2h-.2v-.2h-.4zm0 0zM465 138h-1v-1.8l.2-.3v-.9l.2-.3v-.7h.2v-.3l.2-.3.2-.3.2-.2h.2v-.2h.2v-.2h.5v1h-.2v.2h-.2v.2l-.2.2v.3l-.2.3v.6l-.2.2v2l-.2.3v.4zm-1 0zm.7 3.3v-1l-.5.5v-2.3h-.2v-.4l1-.2v1.8l.2.2v1l-.5.5zm.5-.5v.5h-.5l.5-.5zM407.4 155l-1-.5.7-1 .7-.8.7-1 .8-.7 1-.8 1-.8 1-.8 1-.7 1.3-.7 1.2-.7 1.4-.6 1.6-.6 1.5-.5 1.7-.7 1.7-.5 1.8-.4 2-.5 1.8-.5 2-.3 2.2-.4 2.2-.3 2.2-.2 2.4-.3 2.4-.2 2.5-.2h2.5l2.7-.2h2.7l2.8-.2h9v1H453l-2.8.2h-2.6l-2.6.2-2.5.2-2.4.2-2.3.3-2.2.2-2.2.3-2 .4-2 .3-2 .4-1.8.4-1.8.4-1.7.5-1.6.5-1.5.6-1.5.5-1.3.5-1.3.7-1.2.6-1 .7-1 .7-1 .7-1 .7-.6.8-.7.8-.6.8-.6 1zm13.6 35.5l-.8.6-1-1.3-1-1.4-1-1.4-1-1.5-.8-1.3-.8-1.4-1-1.3-.7-1.3-.8-1.3-.8-1.4-.7-1.2-.7-1.3-.6-1-.6-1.3-.5-1.2-.5-1.2-.5-1.2-.4-1-.5-1-.3-1.2-.3-1-.3-1-.2-1.2v-1l-.2-1V158l.3-.8.3-1 .2-.7.3-.8 1 .5-.4.7-.2.7-.2.8-.2.8v4.5l.2 1 .3 1v1l.5 1 .3 1.2.4 1 .5 1.2.5 1 .5 1.2.6 1.2.6 1.2.6 1.3.7 1 .7 1.4.8 1.3.8 1.3.8 1.3 1 1.3.8 1.4 1 1.3.8 1.4 1 1.4 1 1.5zm0 3.8l-.8-.7.2-.3.2-.2h.2v-.2l.2-.2v-.4l-.2-.2v-.2h-.2v-.3h-.2v-.3h-.2l.8-.7.2.3.2.3v.2h.2v.4h.2v.2l.2.2v1l-.2.2v.2h-.2v.2l-.2.2-.2.2-.2.3zm-2.5 9l-.4-.8-.2.7v-.3l-.2-.5v-.3l-.2-.3v-3.5l.2-.3v-.3l.2-.4.2-.3v-.3l.2-.3.2-.3v-.3l.3-.2v-.3l.3-.2.2-.3v-.2l.3-.3.2-.2v-.3l.3-.2.2-.2.8.7-.2.2-.2.2v.2h-.3v.3l-.3.3-.2.2v.3l-.3.3v.3l-.2.2-.2.3v.7l-.2.2v.2l-.2.3v.6l-.2.4v2.7l.2.3.2.3-.3.6zm.3-.5v.4l-.3.2.3-.6zm-22 1.8l1-.3-.2-.3.6.2.7.3.5.2.6.2h.8l.6.2.6.2h.7l.6.2h5.7l.7-.2h.5l.7-.3h.6l.7-.2.6-.2.7-.2.7-.2.6-.2.6-.3.6-.3.6-.2.7-.4.6-.3.5 1-.6.2-.7.4-.6.4-.7.2-.6.3-.7.2-.6.2-.6.2-.7.2-.6.2h-.6l-.7.3h-.7l-.6.2h-.7l-.7.2h-5l-.7-.2h-.7l-.6-.3h-.7l-.7-.3-.6-.3-.7-.3-.6-.2-.8-.3-.3-.4zm.4.3l-.2-.2v-.2l.2.3zm-5.6-5.8l.6-1 .2.2.2.2h.2l.2.2.2.2h.2l.2.2v.2h.3v.3h.3l.2.3h.2l.2.3.3.3.2.2.2.2.2.2v.2l.3.2v.2l.3.2.2.2v.2l.3.3.2.2.2.2v.2l.3.3v.3l.2.3-1 .3-.2-.2v-.3h-.2v-.3l-.2-.3-.2-.2v-.2l-.2-.2-.2-.2v-.2l-.3-.2-.2-.2-.3-.3-.2-.2-.3-.3h-.2l-.2-.3v-.2l-.3-.2h-.2v-.3h-.3l-.2-.2h-.2l-.2-.2h-.2l-.2-.3h-.2l-.2-.2h-.2zm-2-1.7l.8-.3h.2v.2h.2l.2.2h.2v.2h.4v.2h.2l.2.2h.2l-.6 1-.2-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2zm-10.2-31.7l1-.3.2 1 .3 1 .2.8.3 1 .3 1 .3.8.4 1 .3 1 .3 1 .3 1 .3 1 .3.8.2 1 .4 1 .3 1 .2 1 .3 1 .3 1 .4 1 .3 1 .3 1 .3 1 .5 1 .3 1 .3 1 .5 1 .3 1 .3 1 .4 1.2.4 1 .3 1 .4 1.2-1 .3-.3-1-.2-1.2-.3-1-.4-1-.2-1-.3-1-.3-1.2-.4-1-.3-1-.3-1-.4-1-.3-1-.3-1-.3-1-.4-1-.4-1-.3-1-.4-1-.3-1-.3-.8-.3-1-.4-1-.3-1-.3-1-.3-.8-.3-1-.2-1-.3-1-.3-.8-.3-1-.4-.8-.2-1zm88.2-33.6h1l-.5.5h-5.4l-2.5.2h-2.8l-3 .2-3.3.2-3.5.2-3.7.3-3.8.3-4 .4-4 .5-4 .6-4.2.6-4 .7-4.2 1-4 .8-4 1-3.7 1-3.7 1.3-3.4 1.4-3.3 1.4-3 1.5-2.6 1.6-2.3 1.7-2 2-1.6 1.8-1.2 2.2-.8 2.2-.4 2.3v2.5l.7 2.7-1 .3-.6-2.8v-2.8l.3-2.6 1-2.4 1.2-2.2 1.8-2 2-2 2.5-2 2.7-1.6 3-1.5 3.3-1.6 3.5-1.3 3.6-1 4-1.2 3.8-1 4-1 4-.7 4.2-.6 4.2-.6 4-.6 4-.5 4-.4 4-.4 3.7-.4 3.5-.2 3.3-.2 3-.2h3l2.4-.2h5.4l-.6.4zm1 0v.5h-.5l.7-.5zm-.5 0h-.4.5zm.7 0v.5h-.6l.7-.5z"
          />
          <path
            fill="#fff"
            d="M405 190.2c3.5 0 6.4 2.8 6.4 6.4 0 3.5-3 6.4-6.4 6.4s-6.4-3-6.4-6.4c0-3.6 3-6.4 6.4-6.4z"
          />
          <path
            fill="#21231e"
            d="M412 196.6h-1a6 6 0 0 0-3.4-5.3 5.8 5.8 0 0 0-2.6-.6v-1c2.3 0 4.6 1.2 5.8 3.2a7 7 0 0 1 1 3.6zm-7 7v-1c2.2 0 4.3-1.4 5.2-3.4a6 6 0 0 0 .7-2.6h1c0 2.3-1.4 4.6-3.4 6a7 7 0 0 1-3.6 1zm-7-7h1c0 2.2 1.4 4.3 3.4 5.3a5.8 5.8 0 0 0 2.6.5v1a7 7 0 0 1-5.8-3.3 7 7 0 0 1-1-3.6zm7-7v1a6 6 0 0 0-5.2 3.3 6 6 0 0 0-.7 2.6h-1c0-2.4 1.4-4.7 3.4-6a6.8 6.8 0 0 1 3.6-1z"
          />
          <path
            fill="#fff"
            d="M350.8 203.6c3.2 0 6 2.7 6 6s-2.8 6-6 6c-3.3 0-6-2.7-6-6s2.7-6 6-6z"
          />
          <path
            fill="#21231e"
            d="M357.2 209.6h-1c0-2-1-4-2.8-4.8a5.4 5.4 0 0 0-2.6-.7v-1a7 7 0 0 1 5.4 3 6.5 6.5 0 0 1 1 3.6zm-6.4 6.4v-1c2 0 4-1.2 4.8-3a5.5 5.5 0 0 0 .6-2.4h1c0 2-1.2 4.3-3 5.4a6.4 6.4 0 0 1-3.4 1zm-6.5-6.4h1c0 2 1.2 4 3 4.8.8.4 1.6.6 2.5.6v1a6.6 6.6 0 0 1-5.5-3 6.5 6.5 0 0 1-1-3.4zm6.5-6.5v1c-2 0-4 1.3-5 3a5.5 5.5 0 0 0-.5 2.6h-1c0-2.2 1.2-4.4 3-5.5a6.4 6.4 0 0 1 3.5-1z"
          />
          <path
            fill="#fff"
            d="M345 192.7c3.4 0 6 2.7 6 6s-2.6 6-6 6c-3.2 0-5.8-2.7-5.8-6s2.6-6 6-6z"
          />
          <path
            fill="#21231e"
            d="M351.5 198.7h-1c0-2-1.2-4-3-5a5.3 5.3 0 0 0-2.4-.5v-1c2.3 0 4.4 1.2 5.5 3a6.5 6.5 0 0 1 1 3.5zM345 205v-1c2 0 4-1 4.8-2.7a5.5 5.5 0 0 0 .7-2.6h1c0 2.2-1.2 4.3-3 5.5a6.4 6.4 0 0 1-3.4 1zm-6.3-6.3h1c0 2 1.2 4 3 4.8a5 5 0 0 0 2.4.6v1c-2 .2-4.2-1-5.3-3a6.5 6.5 0 0 1-1-3.3zm6.4-6.5v1c-1.8 0-3.7 1-4.6 2.8a5.5 5.5 0 0 0-.7 2.7h-1c0-2.2 1.2-4.4 3-5.5a6.4 6.4 0 0 1 3.4-1z"
          />
          <path
            fill="#fff"
            d="M339.8 181.7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6z"
          />
          <path
            fill="#21231e"
            d="M346.2 187.7h-1c0-2-1.2-4-3-5a5.4 5.4 0 0 0-2.4-.5v-1c2.2 0 4.3 1.2 5.4 3a6.5 6.5 0 0 1 1 3.5zm-6.4 6.4v-1c2 0 3.8-1 4.7-2.7.5-.8.7-1.7.7-2.6h1c0 2-1 4.3-3 5.4a6.4 6.4 0 0 1-3.4 1zm-6.4-6.3h1c0 2 1 4 3 4.8.7.4 1.5.6 2.4.6v1a6 6 0 0 1-5.4-3 6.5 6.5 0 0 1-1-3.3zm6.4-6.5v1c-2 0-4 1.2-4.8 3a5.5 5.5 0 0 0-.6 2.5h-1c0-2.2 1-4.4 3-5.5a6.4 6.4 0 0 1 3.4-1z"
          />
          <path
            fill="#edb92e"
            d="M444.3 202.2c3.4-.3 2.5 5.8 2 7.2-1 1.8-1.8 1.8-3 .2-.8-1.3-2.4-7.2 1-7.5z"
          />
          <path
            fill="#21231e"
            d="M446.6 209.6l-1-.4h.2v-.7l.2-.3v-.5l.2-.3V204h-.2v-.3l-.2-.2v-.2l-.2-.2h-.2l-.3-.2h-.2l-.2-.2h-.3v-1h.7l.3.2h.3l.3.2v.2l.3.3.2.2.2.3v.2l.2.3v.7l.2.3v3.7l-.2.3v.5l-.2.3v.5h-.2zm-3.7.3l.8-.7.2.3v.2h.2v.2h.2v.2h.7l.2-.2v-.2h.2v-.2h.2v-.3l1 .3v.2l-.2.2v.3h-.2v.2l-.2.2-.2.2h-.4v.2H444v-.2h-.2v-.2h-.2v-.2h-.2v-.3h-.2v-.3h-.3zm1.2-8.4v1h-.4v.2h-.3v.2h-.3v.3l-.2.2v.4h-.2v3.2l.2.2v.6l.2.2v.3l.2.2v.2l.2.2v.2h.2l-1 .7v-.5l-.2-.2v-.2l-.2-.4v-.2l-.2-.3v-.2l-.2-.3v-.7l-.2-.3v-3l.2-.3v-.3l.3-.3.2-.2.2-.3h.2l.2-.3.3-.2h.4l.2-.2z"
          />
          <path
            fill="#fff"
            d="M444.5 205.5c8-.6 6 13.8 4.4 17-2 4.2-4 4.3-6.7.5-2-3-5.8-17 2.2-17.5z"
          />
          <path
            fill="#21231e"
            d="M449.4 222.7l-1-.4.2-.3.2-.4v-.4l.3-.5.2-.5v-.6l.2-.6.2-.7V217l.2-.7v-5.1l-.3-.7v-.6l-.3-.7-.3-.6-.3-.5-.3-.5-.3-.4-.3-.4-.4-.4-.5-.2-.5-.2-.5-.2h-1.4v-1h1.5l.6.2.7.2.5.4.6.4.4.4.4.5.4.7.3.6v.7l.3.6.2.7v.7l.3.8v6.3l-.3.7v.7l-.2.6v.6l-.3.6v.5l-.3.5v.4l-.3.3zm-7.5.5l.8-.5.2.3.2.3.3.3.2.3h.2v.4h.3l.2.3.2.2h.4l.2.2h1v-.2h.3l.2-.3v-.2l.2-.2.2-.2h.2l.2-.4v-.3l.3-.3.3-.3.2-.4 1 .4-.3.4-.2.5-.2.3-.2.4-.2.3-.2.3-.2.2-.2.2-.2.3-.3.2h-.2v.3h-.4l-.2.2H445l-.4-.2h-.2l-.3-.3v-.2l-.4-.2-.2-.2-.2-.2-.3-.2-.3-.3-.3-.4-.2-.4-.3-.4zm2.5-17.2v-1 1h-.6l-.7.2-.5.2-.5.3-.4.3-.5.4-.3.4-.3.4-.3.6-.2.5v.6l-.2.5v.7l-.2.7v.6l.2.7v1.4l.2.7v.8l.3.7v.6l.3.7.2.6.2.5.2.6.2.7.2.5.2.4.2.4.2.4.2.3-1 .5v-.3l-.3-.5-.2-.4-.2-.4v-.6l-.4-.5-.2-.7-.2-.6-.2-.7-.2-.7v-.7l-.3-.6v-.8l-.2-.7V213l-.2-.7v-.8l.2-.7v-.6l.2-.7v-.7l.4-.6.2-.6.4-.6.4-.5.4-.5.5-.4.6-.3.7-.3.7-.2h.8v1zm0-1v1-1z"
          />
          <path
            fill="#edb92e"
            d="M379.7 210.8c3.3-1 4 5 3.6 6.6-.4 2-1.2 2.2-2.7 1-1-1.2-4-6.5-1-7.6z"
          />
          <path
            fill="#21231e"
            d="M383.8 217.5l-1-.2v-2.8l-.2-.3v-.7l-.2-.3v-.3l-.2-.2v-.3l-.3-.2-.2-.2-.3-.3-.3-.3h-.3l-.3-.2h-.6l-.4-1h1.5l.2.2.3.2.2.2.3.2.2.3.2.2v.3l.3.3v.4l.2.3v.3l.2.3v.3l.2.4v.6l.2.3v2.5zm-3.5 1l.7-.6h.2v.2h.2l.2.2h.2v.2h.4l.2-.2v-.2h.2v-.6h.2v-.3l1 .2v.4h-.2v.4l-.2.3v.2h-.2l-.2.2-.2.2h-.2l-.2.2h-1v-.2h-.3l-.2-.2h-.2v-.2h-.2l-.2-.2v-.2zm-.7-8.2l.3 1h-.3l-.2.2h-.2v.2l-.2.2v.2l-.2.2v1.8l.2.4v.3l.2.3v.2l.2.3.2.3v.3l.2.3.2.3v.2l.3.2v.2l.2.2.3.3.2.2-.7.6h-.2v-.4l-.3-.2v-.2l-.3-.2v-.3l-.3-.2v-.2l-.2-.3v-.3l-.3-.3v-.4l-.2-.3v-.3l-.3-.3v-.7l-.2-.3V212l.3-.2.2-.3.2-.3.3-.2.2-.2h.2l.4-.3z"
          />
          <path
            fill="#fff"
            d="M380.7 214c7.7-2.5 9.2 12 8.4 15.5-1 4.5-2.8 5-6.2 2-2.6-2.4-9.7-15-2-17.5z"
          />
          <path
            fill="#21231e"
            d="M389.6 229.6l-1-.2v-.8l.2-.4v-2.9l-.2-.7V223l-.3-.7v-.7l-.3-.8-.2-.7-.2-.6-.2-.7-.3-.7-.2-.6-.3-.6-.3-.4-.4-.5-.3-.4-.4-.3-.4-.4-.4-.4-.5-.2h-.5l-.5-.2h-1.1l-.6.3-.4-1 .7-.2h2.2l.7.2.7.2.5.4.5.5.5.4.4.5.4.5.4.6.3.7.3.6.3.6.3.7.2.8.2.8.2.7v.8l.3.7v1.5l.2.7v4.4zm-7 2.3l.5-1 .5.4.2.2.3.3h.3l.3.3h.2l.3.3h.3l.2.2h1.4l.2-.2.2-.2.2-.3.3-.3v-.6l.2-.2v-.3l.2-.4v-.2l.2-.4 1 .2v.4l-.2.4v.4l-.2.4-.2.3v.3l-.2.3-.2.4v.3l-.3.2h-.2v.3l-.3.2h-.2l-.2.3h-.8l-.3.2h-.5l-.3-.2h-.2l-.3-.2h-.4l-.3-.3-.3-.2h-.3l-.3-.3-.3-.3-.2-.2-.3-.3zm-2-18.5l.3 1-.7.2-.6.3-.4.3-.4.4-.4.4-.3.5-.2.5v.5l-.2.6v2.5l.2.6.2.7.2.6.2.7.3.7v.7l.4.6.3.7.4.6.4.6.3.6.4.6.4.5.3.4.3.4.4.4.2.4.3.3-.5 1-.3-.4-.3-.3-.4-.4-.4-.5-.3-.5-.4-.5-.4-.6-.3-.7-.5-.6-.3-.6-.4-.6-.3-.6-.3-.7-.3-.7-.3-.7-.3-.7-.2-.8-.2-.8v-.7l-.2-.7V218l.2-.7.2-.6.2-.6.3-.5.4-.5.6-.5.6-.4.7-.2.6-.3zm0 .5v-.5.5z"
          />
          <path
            fill="#edb92e"
            d="M464.2 137.8c-17.2-1.6-35 .2-52.3 7-14.8 6-13.4 23.2 4.6 47-1.7 3-2.6 6.8-2.7 11h4.8c-1.3-2.8 0-6.4 1.8-9 1-1.5 1.3-1.2 0-3-10.7-15-17.8-28.2-13.6-36 5-9.7 24.6-14.7 57.7-14 0-1 0-1.8-.2-2.7 0 0-.2 0-.3-.2z"
          />
          <path
            fill="#21231e"
            d="M412 145.4l-.3-1 1.7-.6 1.6-.6 1.7-.6 1.6-.5 1.6-.4 1.6-.5 1.6-.4 1.7-.4 1.5-.4 1.7-.4 1.6-.4 1.7-.3 1.6-.3 1.8-.3h1.6l1.7-.3 1.7-.2 1.7-.2 1.6-.2h3.3l1.6-.2h11.5l1.6.2h1.6l1.6.3v1l-1.7-.2h-4.9l-1.6-.2h-9.7l-1.6.2H443l-1.5.3-1.7.2-1.6.2-1.6.2H435l-1.7.4-1.6.3-1.7.3-1.6.4-1.6.3-1.7.5-1.5.4-1.6.4-1.8.5-1.6.6-1.6.6-1.7.6-1.6.6-1.6.6zm5 46.7l-1-.4.2.5-1.7-2-1.5-2.3-1.5-2-1.3-2.2-1.3-2-1.2-2-1-2-1-2-1-2-.7-1.7-.6-1.8-.5-1.8-.6-1.7-.4-1.6-.3-1.7-.2-1.6v-4.4l.2-1.3.3-1.3.4-1.2.5-1.2.5-1.2.7-1 .8-1 .8-1 1-.7 1-.8 1.3-.8 1.4-.6 1.3-.5.4 1-1.2.5-1.2.6-1 .7-1 .8-1 1-1 .8-.6 1-.7 1-.5 1-.5 1-.3 1.2-.3 1.2-.2 1.2v3.8l.2 1.5.3 1.7.3 1.6.5 1.6.6 1.6.7 1.8.8 1.8 1 2 .8 1.8 1 2 1.2 2 1.2 2 1.4 2 1.4 2.2 1.5 2 1.7 2.3v.6zm0-.5l.2.3-.2.3v-.5zm-3 11v1l-.6-.6v-2.5l.2-.4v-1l.2-.4v-.7l.2-.5v-.4l.2-.2v-.4l.2-.3v-.3l.2-.3v-.4l.2-.3v-.3l.2-.3v-.3l.3-.3v-.3l.2-.2.2-.3v-.3l.3-.3v-.4l1 .5v.4l-.3.2v.3l-.2.2-.2.3v.3l-.2.3v.4l-.2.3v.3l-.2.4v.3l-.2.3v.3l-.2.4v.7l-.2.3v.8l-.2.4v.8l-.2.4v1.4l-.2.4v.7l-.5-.6zm0 1h-.6v-.6l.5.5zm4.3-.4l1-.4-.5.8h-4.6v-1h4.6l-.5.7zm1-.4l.3.7h-.8l.4-.7zm1-9l.7.6-.2.2v.3l-.2.2-.2.2v.2l-.3.3v.4l-.2.3-.2.2v.3l-.2.3v.2l-.2.3v.7l-.2.2v.5l-.2.3v2.2l.2.3v.4l.2.2-1 .5v-.5l-.2-.3v-.7l-.2-.3v-2.7l.2-.3v-.3l.2-.2v-.3l.2-.3v-.3l.2-.4v-.3l.2-.3.2-.3v-.2l.2-.3.2-.3v-.3l.3-.3v-.3h.3l.2-.3zm0-2.5l.7-.5.2.3.2.3v.2h.2v.4h.2v.4l.2.2v.5l-.2.2v.2h-.2v.2l-.2.2v.2h-.2v.3l-.2.2-.8-.6v-.2l.2-.2.2-.2v-.2h.2v-.4h.2v-.2h-.2v-.2l-.2-.2v-.3h-.2v-.3h-.2zm-13.8-36.5l1 .5-.4.7-.2.7-.2.8-.2.8v4.5l.2 1 .3 1v1l.5 1 .3 1.2.4 1 .5 1.2.5 1 .5 1.2.6 1.2.6 1.2.6 1.3.7 1 .7 1.4.8 1.3.8 1.3.8 1.3 1 1.3.8 1.4 1 1.3.8 1.4 1 1.4 1 1.5-.8.6-1-1.3-1-1.4-1-1.4-1-1.5-.8-1.3-.8-1.4-1-1.3-.7-1.3-.8-1.3-.8-1.4-.7-1.2-.7-1.3-.6-1-.6-1.3-.5-1.2-.5-1.2-.5-1.2-.4-1-.5-1-.3-1.2-.3-1-.3-1-.2-1.2v-1l-.2-1V158l.3-.8.3-1 .2-.7.3-.8zm57.7-13.7h1l-.5.5h-14.5l-2.6.2H445l-2.5.3-2.4.2-2.3.3-2.2.2-2.2.3-2 .4-2 .3-2 .4-1.8.4-1.8.4-1.7.5-1.6.5-1.5.6-1.5.5-1.3.5-1.3.7-1.3.6-1 .7-1 .7-1 .7-.8.7-.8.8-.7.8-.6.8-.6 1-1-.5.7-1 .7-.8.7-1 .8-.7 1-.8 1-.8 1-.8 1-.7 1.2-.7 1.3-.7 1.4-.6 1.6-.6 1.5-.5 1.7-.7 1.7-.5 1.8-.4 2-.5 1.8-.5 2-.3 2.2-.4 2.2-.3 2.2-.2 2.4-.3 2.4-.2 2.5-.2h2.5l2.7-.2h2.7l2.8-.2h9l-.6.6zm1 0v.5h-.5l.5-.5zm-1-2.3l.7-.7v1.9h.2v1h-1v-2.3l-.2-.2v-.4.3zm.7-.7v.3-.2zm-1.2-.4l.8.7v-.6.2h.2v.2l-.7.7v-.4h-.2v-.6zm0 .7l-.3-.2.3-.4v.7zm.8 0l-.8-.6h.4l.4.7zm-.4-.7h1l-.6.8-.4-.7z"
          />
          <path
            fill="#fff"
            d="M380.6 142.7c3.4 0 6 2.7 6 6s-2.6 6.3-6 6.3-6.2-2.7-6.2-6.2a6 6 0 0 1 6.2-6z"
          />
          <path
            fill="#21231e"
            d="M387.2 148.8h-1c0-2-1.2-4-3-5a5.6 5.6 0 0 0-2.6-.6v-1c2.2 0 4.5 1.2 5.6 3a6.7 6.7 0 0 1 1 3.6zm-6.6 6.7v-1c2 0 4-1.2 5-3a7 7 0 0 0 .6-2.7h1a7 7 0 0 1-3 5.7 6.6 6.6 0 0 1-3.6 1zm-6.7-6.7h1c0 2 1.2 4.2 3 5a5.6 5.6 0 0 0 2.6.7v1a6.6 6.6 0 0 1-5.6-3 6.7 6.7 0 0 1-1-3.7zm6.6-6.7v1.2c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.6h-1c0-2.2 1-4.4 3-5.6a6.6 6.6 0 0 1 3.6-1z"
          />
          <path
            fill="#fff"
            d="M392.6 138.7c3.4 0 6.2 2.8 6.2 6.2 0 3.3-2.8 6-6.2 6a6 6 0 0 1-6-6c0-3.5 2.6-6.3 6-6.3z"
          />
          <path
            fill="#21231e"
            d="M399.3 145h-1c0-2.2-1.3-4.3-3.2-5.2a5.6 5.6 0 0 0-2.4-.6v-1a7 7 0 0 1 5.7 3 6.7 6.7 0 0 1 1 3.7zm-6.7 6.6v-1c2 0 4-1.3 5-3a5.7 5.7 0 0 0 .7-2.7h1c0 2.2-1.2 4.4-3.2 5.6a6.6 6.6 0 0 1-3.4 1zM386 145h1c0 2 1.2 4 3 5a5.6 5.6 0 0 0 2.6.6v1a6.7 6.7 0 0 1-5.6-3.2 6.7 6.7 0 0 1-1-3.5zm6.6-6.8v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.7h-1c0-2.4 1.2-4.7 3.2-5.8a6.6 6.6 0 0 1 3.4-1z"
          />
          <path
            fill="#edb92e"
            d="M394.2 144a261.2 261.2 0 0 0 2 2.4c-9.8 5.4-14 11-13 16.7.2 1 3.2 11.5 9.8 31.7 4.5 3 7.8 6 10 8.4-.2.4.8 1.2.5 1.5.7 3-2.8 2.4-5 1.7-1.2-3-4.6-6-6.6-7.5-.5-.2-2-1-2-1.4l-10.2-31.6c-3-9.8 3.6-16.8 14.4-21.7z"
          />
          <path
            fill="#21231e"
            d="M396.3 147l-.5-1v.7h-.2v-.2h-.2v-.2l-.2-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2h-.2l.8-.7.2.2h.2v.4h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2h.2v.2l.2.2v1zm.2-1l.3.6-.5.3.2-1zm-12.7 17l-1 .2v-3.9l.2-.6.2-.5.2-.6.2-.5.3-.5.2-.5.3-.6.4-.5.3-.6.4-.6.5-.5.4-.6.6-.5.5-.5.6-.5.6-.6.5-.5.7-.4.7-.5.6-.5.8-.5.8-.5 1-.5.7-.5.8-.5.5 1-1 .4-.7.5-.8.4-.8.5-.8.4-.7.5-.7.4-.6.5-.7.4-.6.5-.6.4-.5.5-.6.4-.5.6-.5.5-.4.5-.3.5-.3.5-.3.5-.2.5-.2.5-.2.5-.2.5-.2.5v.5l-.2.5v3.1zm0 0zm9.5 31.3l-.6.8-.2-.2-.6-1.8-.7-1.8-.5-1.8-.6-1.7-.5-1.6-.5-1.5-.5-1.5-.5-1.5-.4-1.4-.4-1.2-.4-1.3-.4-1.3-.4-1-.3-1.3-.4-1-.3-1-.3-1-.3-1-.3-.8-.2-.8-.2-.8-.2-.6-.2-.7v-.5l-.3-.5v-.5l-.2-.4v-.8h-.2v-.3h1v.3l.2.3v.4l.2.3v.5l.2.5.2.6.2.7.2.7.2.7.2 1 .3.7.2 1 .2 1 .3 1 .3 1 .4 1 .4 1.2.3 1.2.3 1.3.5 1.3.4 1.4.5 1.5.4 1.5.7 1.6.5 1.6.5 1.7.6 2 .6 1.7.5 1.8-.2-.2zm-.6.8l-.2-.2.2.3zm10.7 8.4l-.7-.6v.6l-.2-.2-.2-.2-.3-.3-.2-.2-.2-.2-.3-.3-.2-.2-.2-.2-.2-.3-.3-.2-.3-.2-.2-.2-.3-.3-.3-.3-.3-.2-.4-.3-.3-.2-.4-.3-.4-.3-.3-.2-.4-.3-.4-.3-.4-.3-.3-.3-.5-.3-.4-.2-.3-.3-.4-.2-.4-.3-.5-.3-.4-.3-.3-.3.6-.7.4.3.4.3h.5l.4.4.3.3.4.3.4.3.5.3.3.2.4.3.3.4.4.3.2.2.4.2.3.3.2.2.3.3.3.3.3.2.4.3.3.2.3.3.3.3.2.2.3.3.3.3.3.3.2.2.3.2.2.3.2.2.2.3v.6zm0-.6l.3.3-.3.4v-.6zm.6 1.6l-1 .2.2-.5v.2h-.2v.2-.2l-.2-.2v-.2h-.2v-1.2l.8.6v-.2h.2v.2l.2.2v.2l.2.2v.7l-.2.2.2-.6zm-1 .2v-.3l.2-.2-.2.6zm-5 1.8l1-.4-.4-.3h.4l.2.2h.7l.4.2h2.3v-.2h.2v-1.4l1-.2v1.6l-.2.3v.2l-.2.2h-.2l-.2.2h-.4l-.2.2h-3l-.3-.2h-.5l-.3-.2h-.5l-.3-.4zm.2.3h-.2v-.3l.2.3zm-6.6-7.5l.6-1 .2.3h.2l.2.3h.2l.3.3.2.3.2.2.2.2.2.2h.2l.2.3.3.2v.3l.4.2.2.3.2.2.3.3.3.2.2.3.3.3.2.2.2.3.2.4.2.3.2.3.2.2.2.3v.3l.3.3v.4l.3.3v.3l-1 .4v-.3l-.2-.4-.2-.3v-.2l-.3-.2v-.3l-.2-.2-.2-.3-.2-.3-.2-.2-.2-.3-.2-.2-.2-.3-.3-.2-.2-.3v-.2l-.3-.3-.3-.2-.2-.2-.2-.2-.3-.2-.2-.2-.2-.2h-.2l-.2-.3h-.2l-.2-.3h-.2l-.2-.3h-.2l-.2-.2zm.6-1l.3.3-.3-.2zm-2.7-.7l1-.3.2.2h.2v.2h.2v.2h.4v.2h.2l.2.2h.2l-.6 1-.2-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2zm-10-31.7l.8-.3.3 1 .3 1 .2.8.3 1 .3 1 .3.8.4 1 .3 1 .3 1 .3 1 .3 1 .3.8.2 1 .4 1 .3 1 .2 1 .3 1 .3 1 .4 1 .3 1 .3 1 .3 1 .5 1 .3 1 .3 1 .5 1 .3 1 .3 1 .4 1.2.4 1 .3 1 .4 1.2-1 .3-.3-1-.2-1.2-.3-1-.4-1-.2-1-.3-1-.3-1.2-.4-1-.3-1-.3-1-.4-1-.3-1-.3-1-.3-1-.4-1-.4-1-.3-1-.4-1-.3-1-.3-.8-.3-1-.4-1-.3-1-.3-1-.3-.8-.3-1-.2-1-.3-1-.3-.8-.3-1-.4-.8-.2-1zm15-22l-.7.5h.6l-1 .6-1 .4-1 .5-.8.4-1 .5-.7.4-1 .5-.7.5-.8.5-.7.6-.7.6-.5.6-.7.6-.5.6-.6.7-.5.6-.4.7-.4.6-.4.7-.3.7-.3.7-.3.7v.8l-.2.7v.7l-.2.8v2.6l.3.8v1l.3.7-1 .3-.2-1v-.8l-.3-1V159l.2-1 .2-.7.2-.6.3-.8.4-.7.5-1 .4-.6.4-.7.6-.7.5-.7.6-.6.8-.6.6-.6.8-.6.7-.6.7-.5.8-.6 1-.5.7-.5 1-.5 1-.5.8-.5 1-.5 1-.5.6.2zm-.5-.3l.4-.2.2.4-.6-.2z"
          />
          <path
            fill="#edb92e"
            d="M356 217l-.4 2c-2.8.5-5.3.7-7.3.3 3.4-3.3 6-4 7.6-2.4z"
          />
          <path
            fill="#21231e"
            d="M355 218.8l.4-2 1 .2-.3 2-.3.4-.6-.6zm1 0v.5h-.3l.4-.4zm-8 .2l.7.7-.3-1 .2.2h4.1l.3-.2h1l.2-.2h.7l.2-.2h.3l.2 1h-.8l-.4.2h-.5l-.4.2h-1.3v.2h-3.7l-.4-1zm.2 1l-1-.3.8-.7.2 1zm8.2-3l-1-.2.2.5v-.2h-.6v-.2h-.6l-.2-.2H353v.2h-.6l-.2.3-.2.2h-.3l-.2.2-.3.2-.2.2-.3.2-.3.2-.2.2-.3.2-.4.3h-.3l-.3.4-.3.3-.7-.7.3-.3.3-.3.3-.3.2-.2.3-.2.3-.2.3-.3h.4l.3-.3h.3l.2-.3h.3l.3-.3h.6l.3-.2h.5l.4-.2h1.3l.2.2h.3l.2.2h.2l.2.2.3.3v.5zm0-.5v.5-.5zm-.5.4h.4-.5zm.3-.5l.2.2v.3l-.2-.5z"
          />
          <path
            fill="#edb92e"
            d="M355.6 212.3c1.8.4 2 .7 2.7 1 1 0 2.4 0 3.3-1 4-2.2 4 2 2.5 5-1 2.4-.5 5 .6 7 1.2 2.2 1 3.2 0 4l-1.6 1c-1 1.2-1.8 1-2-.6-3.8-1.6-5-5.3-6.2-8.6-1.7-4.7-7.8-5.8.8-7.7z"
          />
          <path
            fill="#21231e"
            d="M358.4 212.7v1h-.7v-.2h-.4l-.2-.2h-.4l-.2-.2h-.8l-.3-.2.2-1h.4l.2.2h.4l.2.2h.4v.2h.8v.2h.4zm3-.7l.5 1v-.2l-.2.2h-.3v.2h-.2l-.2.2h-.2l-.2.2h-2.1v-1h2.2l.2-.2h.2v-.2h.2l.2-.2zm0 0zm3 5.6l-.8-.4v-.3l.3-.4v-.5l.2-.2v-.6l.2-.3v-2.2h-.2v-.2h-.2v-.2h-1.2l-.3.2-.3.2-.3.2-.6-1 .4-.2.3-.2h.5l.3-.2h1.8l.2.2.2.2v.2l.2.3v.4l.2.3v2.4l-.2.3v.3l-.2.4v.3l-.2.3v.3l-.3.3zm.6 6.3l-1 .4v-.4l-.2-.2v-.4l-.2-.2v-.2l-.2-.2v-.5l-.2-.2v-.8l-.2-.2v-2.3l.2-.2v-.3l.2-.3v-.3l.2-.2 1 .4-.2.2v.4l-.2.2v.8l-.2.2v2l.2.2v.5l.2.2v.4h.2v.2l.2.2v.4h.2zm0 4.6l-.6-1h.2v-.2h.2v-1.6l-.2-.3v-.3l-.2-.2v-.2l-.2-.2v-.2l.8-.5v.2l.2.2v.2l.2.2v.2l.2.2v.2l.2.3v1.7l-.2.2v.2h-.2v.2h-.2v.2l-.2.2zm0 0zm-1.6 1l-.8-.7v-.2h.2l.2-.2h.2v-.2h.4v-.2h.2v-.2h.4v-.2h.2l.6.8h-.2v.2h-.4v.2h-.2l-.2.2h-.2v.2h-.2l-.2.2zm-.8-.7v-.2zm-1.8 0l.4-.8.3.4v.5h.2v.2h.4v-.2h.2v-.2h.2l.8.6-.2.2-.2.2-.3.2h-.2v.2h-1.1l-.2-.2v-.2l-.2-.2v-.4h-.2v-.7l.2.4zm.4-.8h.3v.4l-.3-.4zm-7-8l1-.3.2.2v.3l.2.3v.4l.2.3v.3l.3.3.2.4v.3l.2.3.2.3v.3l.3.3v.2l.2.3v.2l.3.3.2.3.2.2v.3l.3.2.2.3.2.2.2.2.2.2h.2l.3.3.3.2.3.2.3.2h.3l.2.2-.4 1-.3-.2-.4-.2-.2-.2-.4-.2-.3-.2-.2-.3-.3-.3-.2-.2-.3-.3-.3-.2-.2-.3-.2-.3-.2-.3-.3-.4-.2-.3-.2-.3-.2-.3v-.4l-.2-.3v-.3l-.3-.3v-.3l-.3-.2v-.3l-.2-.4v-.2l-.2-.3-.2-.3v-.3l-.2-.4v-.3zm1.4-8.4v1l-.6.2-.7.2h-.6l-.5.3h-.4l-.4.3h-.3v.3l-.2.2v.2h-.2v.2l.2.3.3.2.2.3.2.2.2.3.3.2v.3l.4.3.2.3.3.5.2.3.2.4.3.4.2.4v.5l.3.4-1 .3v-.4l-.3-.5-.2-.4-.2-.3-.3-.3-.2-.3v-.2l-.4-.3-.2-.3-.3-.3v-.4l-.3-.2-.3-.3-.3-.4v-.2l-.2-.3-.2-.4v-.6l.3-.3v-.2l.3-.3h.3l.4-.3.4-.3.5-.2h.4l.7-.3.8-.2.7-.2zm0 0zm0 1v-1 1zm0-1z"
          />
          <path
            fill="#edb92e"
            d="M357 212.5c3.5 1.2 4-.7 6-.6-.8 5-1.7 7.7-7 5-3-1.6-6.7.7-7.4 2.3-.3.6-2-.6-2.6-2-2.6-5.8 6.7-6.4 11-4.8z"
          />
          <path
            fill="#21231e"
            d="M363.6 212l-1-.2.5.6H362v.2h-.3l-.2.2h-.2l-.3.2h-.3v.2h-.7l-.2.2h-2l-.4-.2h-.3l-.3-.2.3-1h.3l.3.2h.4l.2.2h1.3l.2-.2h.2l.2-.2h.5l.2-.2h.2l.3-.2h.5l.2-.2h.4l.6.6zm-.5-.6h.7v.6l-.6-.6zm-7.2 6l.4-1 .5.4.5.2h.4l.4.3h.3l.4.2h1.7l.2-.2.3-.3.2-.3v-.2l.2-.2.2-.3v-.3l.2-.3v-.3l.2-.2v-.4l.2-.4v-.4l.2-.4v-.9l.2-.5 1 .2v.5l-.2.5v.8l-.2.5v.4l-.2.4v.4l-.3.4v.3l-.2.4-.2.4v.2l-.3.3-.2.3-.2.2-.3.2-.2.2h-.2l-.3.2h-.3l-.3.2h-1.6l-.4-.2-.4-.2h-.4l-.4-.3-.5-.3-.5-.3zm-6.8 2l-1-.3h.2v-.3h.3v-.3l.3-.2v-.2l.3-.2h.3l.2-.3.2-.2h.3l.2-.3h.3l.2-.3h.3l.3-.2h.3l.2-.2h.3l.4-.2h2.3l.3.2h.3l.3.2h.2l-.4 1h-.3l-.2-.2h-.5l-.3-.2h-1.8l-.3.2h-.3l-.3.2h-.3l-.2.3h-.2l-.3.2h-.2l-.2.2h-.2v.2l-.2.2h-.2v.3h-.2v.2h-.2v.2h-.2zm-3.5-2l1-.3v.4h.2v.4h.2v.2l.2.2h.2v.2l.2.2h.2v.2h.4v.2l.8.5v.2l-.3.2h-1v-.2h-.2l-.3-.2h-.2v-.2l-.2-.2-.2-.2h-.2v-.3h-.2v-.2h-.2v-.3h-.2v-.4h-.2v-.3zm11.8-5.4l-.3 1-.4-.2h-.5l-.3-.2h-.5l-.5-.2h-5l-.5.2-.4.2h-.4l-.4.3-.4.3-.3.2v.2l-.4.2-.2.2v.3l-.3.2v1.6l.3.4.2.5-1 .5-.2-.5-.2-.6V215l.2-.6.2-.4.2-.4.3-.3.2-.4.3-.3.4-.3.4-.2.4-.2.5-.2h.5l.5-.3h1.1l.5-.2h3.3l.6.2h.5l.4.2.5.2h.3zm0 .5v-.5.5z"
          />
          <path
            fill="#fff"
            d="M458.8 124.5c3.4 0 6.2 2.7 6.2 6 0 3.5-2.8 6.3-6.2 6.3s-6-2.8-6-6.2a6 6 0 0 1 6-6z"
          />
          <path
            fill="#21231e"
            d="M465.5 130.6h-1c0-2-1.3-4.2-3.3-5a5.5 5.5 0 0 0-2.4-.6v-1a7 7 0 0 1 5.7 3 6.7 6.7 0 0 1 1 3.6zm-6.7 6.7v-1c2 0 4-1.2 5-3a5.6 5.6 0 0 0 .6-2.7h1c0 2.3-1 4.5-3 5.7a6.6 6.6 0 0 1-3.6 1zm-6.6-6.7h1c0 2 1.3 4.2 3.2 5a5.5 5.5 0 0 0 2.4.7v1a6.6 6.6 0 0 1-5.6-3.2 6.7 6.7 0 0 1-1-3.4zm6.6-6.6v1c-2 0-4 1.2-5 3a5.6 5.6 0 0 0-.6 2.6h-1c0-2.2 1.2-4.4 3.2-5.6a6.6 6.6 0 0 1 3.4-1z"
          />
          <path
            fill="#fff"
            d="M446.3 124.5a6 6 0 0 1 6 6c0 3.5-2.6 6.3-6 6.3s-6-2.8-6-6.2c0-3.4 2.6-6 6-6z"
          />
          <path
            fill="#21231e"
            d="M453 130.6h-1c0-2-1.3-4-3.2-5a5.5 5.5 0 0 0-2.5-.6v-1c2.3 0 4.5 1.2 5.6 3a6.7 6.7 0 0 1 1 3.6zm-6.7 6.7v-1c2 0 4-1.3 5-3a7 7 0 0 0 .6-2.7h1c0 2.3-1.3 4.5-3.2 5.7a6.6 6.6 0 0 1-3.5 1zm-6.6-6.7h1c0 2 1.2 4.2 3 5a5.5 5.5 0 0 0 2.6.7v1a6.5 6.5 0 0 1-5.6-3.2 6.7 6.7 0 0 1-1-3.4zm6.6-6.6v1c-2 0-4 1.2-5 3a5.6 5.6 0 0 0-.6 2.6h-1a7 7 0 0 1 3-5.6 6.6 6.6 0 0 1 3.6-1z"
          />
          <path
            fill="#fff"
            d="M433.8 125.5a6 6 0 0 1 6 6c0 3.5-2.6 6.3-6 6.3s-6-2.8-6-6.2 2.6-6 6-6z"
          />
          <path
            fill="#21231e"
            d="M440.4 131.6h-1c0-2-1.2-4-3-5a5.5 5.5 0 0 0-2.6-.6v-1a7 7 0 0 1 5.6 3 6.7 6.7 0 0 1 1 3.6zm-6.6 6.7v-1c2 0 4-1.3 5-3a5.7 5.7 0 0 0 .6-2.7h1a7 7 0 0 1-3 5.7 6.6 6.6 0 0 1-3.6 1zm-6.6-6.7h1c0 2.2 1.3 4.3 3.2 5.2a5.5 5.5 0 0 0 2.4.5v1a6.4 6.4 0 0 1-5.6-3.2 6.7 6.7 0 0 1-1-3.4zm6.6-6.6v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.6h-1c0-2.3 1.3-4.6 3.3-5.7a6.6 6.6 0 0 1 3.3-1z"
          />
          <path
            fill="#fff"
            d="M422.3 127.7c3.3 0 6 2.8 6 6.2 0 3.3-2.7 6-6 6s-6.2-2.7-6.2-6 3-6.3 6.3-6.3z"
          />
          <path
            fill="#21231e"
            d="M429 134h-1a6 6 0 0 0-3.3-5.2 5.5 5.5 0 0 0-2.4-.6v-1c2.2 0 4.4 1.2 5.6 3.2a6.7 6.7 0 0 1 1 3.5zm-6.7 6.5v-1c2 0 4-1.2 5-3 .4-1 .6-1.8.6-2.6h1c0 2-1.3 4.3-3.3 5.5a6.6 6.6 0 0 1-3.4 1zm-6.7-6.6h1c0 2 1.2 3.8 3 4.8a5 5 0 0 0 2.7.7v1a7 7 0 0 1-5.7-3 6.7 6.7 0 0 1-1-3.6zm6.7-6.8v1c-2 0-4.2 1.3-5 3.2a5.7 5.7 0 0 0-.7 2.5h-1c0-2.5 1.3-4.7 3.3-6a6.6 6.6 0 0 1 3.3-.8z"
          />
          <path
            fill="#fff"
            d="M346.3 159.4a6 6 0 0 1 6 6.2c0 3.4-2.6 6.2-6 6.2s-6-2.8-6-6.2a6 6 0 0 1 6-6.2z"
          />
          <path
            fill="#21231e"
            d="M353 165.6h-1c0-2-1.3-4-3.2-5a5.6 5.6 0 0 0-2.5-.7v-1c2.2 0 4.5 1 5.6 3a6.7 6.7 0 0 1 1 3.6zm-6.7 6.7v-1c2 0 4-1.2 5-3a7 7 0 0 0 .6-2.7h1c0 2.3-1.3 4.5-3.2 5.7a6.6 6.6 0 0 1-3.5 1zm-6.7-6.7h1c0 2 1.3 4.2 3.2 5a5.6 5.6 0 0 0 2.5.7v1a7 7 0 0 1-5.6-3 6.7 6.7 0 0 1-1-3.7zm6.7-6.7v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.6h-1a7 7 0 0 1 3-5.7 6.6 6.6 0 0 1 3.6-1z"
          />
          <path
            fill="#fff"
            d="M356.8 152.8c3.4 0 6.2 2.7 6.2 6 0 3.6-2.8 6.3-6.2 6.3-3.4 0-6-2.6-6-6a6 6 0 0 1 6-6.2z"
          />
          <path
            fill="#21231e"
            d="M363.5 159h-1c0-2.2-1.3-4.2-3-5a5.6 5.6 0 0 0-2.7-.7v-1a7 7 0 0 1 5.7 3 6.7 6.7 0 0 1 1 3.6zm-6.7 6.6v-1a5.7 5.7 0 0 0 5.7-5.7h1a7 7 0 0 1-3 5.6 6.6 6.6 0 0 1-3.7 1zm-6.6-6.7h1c0 2 1.2 4 3 5a5.6 5.6 0 0 0 2.6.6v1a7 7 0 0 1-5.6-3 6.7 6.7 0 0 1-1-3.7zm6.6-6.8v1c-2 0-4 1.3-5 3.2a5.7 5.7 0 0 0-.6 2.5h-1c0-2.3 1.2-4.6 3-5.8a6.6 6.6 0 0 1 3.6-1z"
          />
          <path
            fill="#fff"
            d="M368.8 147c3.4 0 6 3 6 6.3 0 3.4-2.6 6.2-6 6.2s-6-2.8-6-6.2a6 6 0 0 1 6-6.2z"
          />
          <path
            fill="#21231e"
            d="M375.4 153.3h-1c0-2-1.2-4.2-3-5a5.6 5.6 0 0 0-2.6-.7v-1a7 7 0 0 1 5.6 3 6.7 6.7 0 0 1 1 3.7zm-6.6 6.7v-1c2 0 4-1.3 5-3a5.7 5.7 0 0 0 .6-2.7h1a7 7 0 0 1-3 5.7 6.6 6.6 0 0 1-3.6 1zm-6.7-6.7h1c0 2 1.4 4 3.2 5a5.6 5.6 0 0 0 2.6.7v1a6.9 6.9 0 0 1-5.7-3.2 6.7 6.7 0 0 1-1-3.5zm6.8-6.7v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.7h-1c0-2.3 1-4.5 3-5.7a6.6 6.6 0 0 1 3.6-1z"
          />
          <path
            fill="#fff"
            d="M338.2 169.5a6 6 0 0 1 6 6.2c0 3.4-2.6 6.2-6 6.2s-6.2-3-6.2-6.3 2.8-6.2 6.2-6.2z"
          />
          <path
            fill="#21231e"
            d="M344.8 175.7h-1c0-2-1.3-4.2-3.2-5a5.6 5.6 0 0 0-2.4-.7v-1a7 7 0 0 1 5.6 3 6.7 6.7 0 0 1 1 3.7zm-6.6 6.7v-1c2 0 4-1.3 5-3a5.7 5.7 0 0 0 .6-2.7h1c0 2.3-1.2 4.5-3.2 5.7a6.6 6.6 0 0 1-3.4 1zm-6.7-6.7h1c0 2 1.2 4 3 5a5.6 5.6 0 0 0 2.7.7v1a6.9 6.9 0 0 1-5.7-3.2 6.7 6.7 0 0 1-1-3.5zm6.7-6.7v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.7 2.7h-1c0-2.3 1.2-4.5 3.2-5.7a6.6 6.6 0 0 1 3.5-1z"
          />
          <path fill="#edb92e" d="M454.2 276.3l-22 12.8-23.4-10 22-12.8z" />
          <path
            fill="#21231e"
            d="M431 266.7l-22 12.8-.4-1 22-12.7h.5v1zm-.4-1h.5-.4zm23.5 11l-23.3-10 .4-1 23.4 10v1h-.3zm.4-1l1 .5-1 .5v-1zm-22.4 13l22-13 .5 1-22 12.8h-.5v-.8zm.5.8l-.2.2h-.3l.5-.2zm-23.4-11l23.4 10-.4 1-23.3-10v-1h.4zm-.3 1l-1-.4 1-.4v1z"
          />
          <path
            fill="#c6363c"
            d="M431 270.6c5.8-.3 10.5 2.5 10.8 6.3.2 3.7-4.2 7-9.8 7.4-5.7.3-10.4-2.5-10.7-6.3-.2-3.6 4.2-7 9.8-7.4z"
          />
          <path
            fill="#21231e"
            d="M442.3 277h-1v-.7l-.2-.3v-.6l-.3-.3v-.2l-.3-.2-.2-.3-.2-.3-.3-.2-.3-.3-.2-.2-.3-.2h-.5l-.3-.3-.3-.2-.5-.2-.4-.2h-.3l-.4-.2h-.4l-.5-.3h-.9l-.5-.2h-.8l-.5-.2h-1l-.5.2v-1h3.6l.4.2.5.2h.5l.4.2.5.2.5.2.4.2.3.2.4.2.4.2.4.2.4.3.3.3.4.3.3.3.3.3.2.4.2.3.2.3.2.4v.3l.3.4.2.4v.8zm-10.3 8v-1l.4-.2h.9l.5-.2h.4l.4-.2h.5l.4-.3h.5l.4-.2.4-.2.4-.2.3-.2.4-.2.4-.3.4-.2.3-.2.3-.3.3-.2.3-.3v-.3l.3-.3.2-.4.2-.2v-.3l.2-.2v-.6l.2-.3v-1.1l1-.2v1.6l-.2.4v.3l-.3.5v.3l-.3.4-.3.3v.3l-.4.4-.3.3-.3.3-.3.2-.3.3-.4.3-.4.2-.4.3-.4.3-.4.2-.4.2-.5.2h-.4l-.4.2-.5.2h-.4l-.5.2h-.4l-.5.2h-1zm-11.2-6.8h1v.5l.2.3v.3l.2.3.2.3v.2l.3.3.2.2v.3l.4.2.2.3.3.2.2.2.3.2.4.2.2.2h.4l.4.3h.4l.4.2.4.2h.4l.5.2h1l.4.2h2.3v1H428l-.5-.2h-.4l-.5-.3h-.6l-.4-.3h-.4l-.5-.3-.3-.2-.3-.3-.4-.2-.4-.2-.3-.3-.3-.2-.3-.3-.3-.3-.3-.3v-.3l-.3-.3-.2-.3-.2-.4-.2-.3v-1l-.2-.4zm10.3-8l.2 1h-1.5l-.5.2h-.5l-.5.2-.4.2h-.5l-.4.3-.5.2-.4.2-.3.2-.4.2-.3.2-.3.3-.4.2-.3.3-.3.2-.2.3-.3.2-.2.3-.2.3-.2.4-.2.3v.3l-.3.3v.8l-.2.3v.6l-1 .2V277l.2-.4v-.3l.2-.4v-.5l.3-.3.2-.4.3-.3.2-.3.3-.3.2-.4.4-.3.4-.3.3-.3.4-.3.5-.2.3-.3.5-.3.4-.2.4-.2.6-.2h.4l.5-.2h.5l.5-.3h.5l.5-.2h1.1l.5-.2z"
          />
          <path
            fill="#edb92e"
            d="M382.4 270l23.8 9-19.7 13c-5-1.6-9-19-4-22z"
          />
          <path
            fill="#21231e"
            d="M406 279.4l-23.8-9 .4-1 23.7 9v1h-.3zm.3-1l1 .4-1 .5v-1zm-20 13.3l19.6-13.2.4.8-19.6 13.3h-.4v-1zm.5 1h-.4.4zm-4.2-23.3l-.4 1h.5l-.4.2-.4.3-.4.4-.2.5-.2.4-.2.7-.2.8v1.5l-.2.8v2.8l.3.8v1l.2.8.2 1 .2 1 .3.7v1l.5 1 .3.7.3.7.5.8.4.6.3.6.4.6.4.5.5.4.4.2.3.3.4.2-.3 1-.6-.3-.5-.3-.5-.3-.5-.5-.4-.6-.6-.6-.4-.7-.4-.7-.4-.7-.4-1-.3-.8-.3-1-.3-.8-.4-1-.2-.8-.2-1-.2-1v-.8l-.3-1v-5.2l.3-.8.2-.7.3-.6.3-.6.4-.5.4-.5.5-.4h.6zm-.5 0h.6-.5zm.4.4l.2-.4-.2.5zm-.3-.4h.6-.5z"
          />
          <path
            fill="#0c4076"
            d="M382.8 274.3c5.7-.6 10.5 2 11 5.8.3 3.8-4 7.4-9.6 8-3.6.3-6-3-6.3-6.3-.5-3.4 1-7 4.8-7.4z"
          />
          <path
            fill="#21231e"
            d="M394.2 280h-1v-.5l-.2-.3v-.3l-.2-.4-.2-.3-.2-.2-.2-.2-.2-.3-.2-.2-.3-.3-.2-.2-.3-.2-.3-.2-.4-.2-.3-.2-.4-.2-.3-.2h-.4l-.5-.3h-.4l-.4-.2h-.8l-.5-.2h-3.6l-.2-1h3.8l.4.2h.5l.4.2.4.2h.4l.5.3.4.2h.5l.4.3.2.2.4.3.3.2.2.3.3.3.3.3.2.2.3.3.2.3.2.3v.5l.3.4v.2l.2.4v.4zm-10 8.4v-1h1l.5-.2h.4l.6-.2.5-.2h.5l.4-.3.4-.2h.4l.4-.3.3-.3.4-.2.2-.2.4-.3.3-.2.2-.3.3-.2.2-.3.3-.3.2-.3.2-.2.2-.3v-.4l.3-.3v-.8l.2-.4v-1h1v1.6l-.2.3v.3l-.2.4-.2.3-.2.4-.2.3-.2.4-.3.4-.2.3-.3.3-.3.3-.5.3-.3.3h-.4l-.4.4-.4.2-.4.3h-.4l-.4.3-.5.2h-.5l-.4.3-.5.2h-.6l-.5.2h-.7l-.5.2h-.5zm-6.8-6.7h1v.7l.2.3v.3l.2.4v.3l.2.2v.2l.2.3.2.2v.3l.3.2.2.3v.2l.2.2h.2l.2.3h.2l.2.3.2.2h.3l.2.2h.2l.2.2h.2l.3.2h1.4v1h-2.1l-.3-.2h-.4l-.3-.3-.3-.2-.3-.2-.3-.2-.2-.2-.3-.2-.3-.2-.2-.2-.3-.3-.2-.2v-.2l-.3-.3-.2-.3v-.2l-.3-.4v-.3l-.3-.3-.2-.3v-.3l-.2-.3v-.6l-.2-.3v-.3zm5.4-8v1h-.2l-.4.2h-.8l-.3.3-.3.2-.3.2-.2.2h-.2l-.2.2v.2l-.3.2v.3h-.3v.3l-.2.3-.2.2v.7l-.2.3v.4l-.2.3v2.2h-1V279l.2-.3v-.3l.2-.2v-.3l.2-.3.2-.3v-.4l.3-.3.2-.3.2-.2v-.3l.3-.2.3-.2h.2l.3-.3.4-.2.3-.2h.3l.3-.2h.7l.4-.2h.4z"
          />
          <path
            fill="#fff"
            d="M457.5 280.4c1.7 0 3.2 1.5 3.2 3.2 0 1.8-1.5 3.3-3.2 3.3-1.8 0-3.2-1.6-3.2-3.4 0-1.7 1.4-3.2 3.2-3.2z"
          />
          <path
            fill="#21231e"
            d="M461.2 283.6h-1v-.6l-.2-.2v-.2l-.2-.3v-.2h-.2v-.2h-.2v-.2h-.2l-.2-.2-.3-.2h-.2l-.2-.2h-.7v-1h1l.3.2.2.2h.2l.3.2v.2h.2v.2h.2v.3h.2v.2l.2.2v.2h.2v.2l.2.3v.5l.2.2v.2zm-3.7 3.8v-1h.4l.3-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2.2-.2v-.2l.2-.2v-1h1.2v.8l-.2.2v.3l-.2.2v.2l-.2.2-.2.3h-.2v.3h-.3l-.2.2-.3.2-.3.2h-.6v.2h-.6v.2h-.3zm-3.7-3.8h1v1h.2v.2l.2.2v.2l.2.2h.2v.2h.2v.2h.2l.2.2h.2v.2h1v1.2h-.7l-.2-.2h-.5v-.2h-.3l-.2-.2-.3-.2-.2-.2h-.2v-.3h-.2l-.2-.3-.2-.3v-.2l-.2-.3v-.3l-.2-.3v-.8zm3.7-3.7v1h-.9l-.2.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2l-.2.3v.5h-.2v.8h-1v-1.2l.2-.2v-.3h.2v-.3l.2-.2.2-.2v-.2h.4v-.2l.2-.2h.2v-.2h.5v-.2h.4v-.2h1z"
          />
          <path
            fill="#fff"
            d="M408.7 283c1.8 0 3.2 1.6 3.2 3.4 0 1.7-1.5 3.2-3.3 3.2a3.2 3.2 0 0 1-3.2-3.2c0-1.8 1.4-3.3 3.2-3.3z"
          />
          <path
            fill="#21231e"
            d="M412.4 286.4h-1v-.9l-.2-.2v-.2l-.2-.2v-.2l-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.4l-.2-.2h-.8v-1.2h.7v.2h.7v.2h.3v.2h.3v.2h.3l.2.2.2.3h.2l.2.3.2.3v.3h.2v.6l.2.2v.9zm-3.7 3.7v-1h1v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.3h.2v-.5l.2-.2v-.4h1v.8l-.2.2v.3l-.2.2v.3h-.2v.3h-.2l-.2.3h-.2v.2h-.3l-.2.2h-.2v.2h-.3v.2h-.5l-.2.2h-.8zm-3.7-3.6h1v.8h.2v.5h.2v.2h.2v.2h.2v.2h.2l.2.2h.2v.2h.5v.2h.7v1h-1.2v-.2h-.3v-.2h-.2l-.2-.2-.2-.2h-.2v-.2h-.2v-.3h-.3v-.3h-.2v-.3l-.2-.2v-.2l-.2-.3v-.8zm3.7-3.8v1h-.7v.2h-.5v.2h-.2l-.2.2v.2h-.2l-.2.2v.2l-.2.2v.2h-.2v.7l-.2.3v.4h-1v-1l.2-.2v-.3l.2-.3.2-.3v-.3h.3v-.3h.2l.2-.2.2-.2h.2v-.2h.6l.3-.2h.5l.3-.2h.2z"
          />
          <path
            fill="#fff"
            d="M407 268.3c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2a3.2 3.2 0 0 1-3.2-3.2c0-1.8 1.4-3.2 3.2-3.2z"
          />
          <path
            fill="#21231e"
            d="M410.7 271.5h-1v-.7l-.2-.2v-.3l-.2-.2h-.2v-.4h-.2v-.2h-.2l-.2-.2h-.2l-.2-.2h-.5v-.2h-.4v-1h.8v.2h.3l.3.2h.2l.3.2h.2v.2l.3.2.2.2.3.3.2.3v.3h.2v.4l.2.2v1zm-3.7 3.7v-1h1v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2.2-.2v-.4h.2v-1h1v1.2l-.2.2-.2.3v.3h-.2l-.2.3h-.2v.3h-.3v.2h-.2v.2h-.2l-.2.2h-.5l-.3.2h-.7zm-3.7-3.7h1v.8l.2.2v.4h.2v.2l.2.2v.2h.2v.2h.2v.2h.2l.2.2h.5l.2.2h.5v1h-.9l-.3-.2h-.2l-.3-.2-.3-.2h-.2l-.2-.2-.2-.3h-.3v-.3l-.2-.3v-.3h-.2v-.4l-.2-.2v-.8zm3.7-3.7v1h-.8v.2h-.5l-.2.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2l-.2.2v.3l-.2.2v.7h-1v-1.2h.2v-.6h.2v-.3h.2v-.3h.3l.2-.2v-.2h.3v-.2h.3l.2-.2h.4v-.2h.5l.2-.2h.7z"
          />
          <path
            fill="#fff"
            d="M457.3 266.2c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2a3.2 3.2 0 0 1-3.2-3.2c0-1.8 1.6-3.2 3.3-3.2z"
          />
          <path
            fill="#21231e"
            d="M461 269.4h-1v-.8h-.2v-.3l-.2-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2h-.2l-.2-.2h-.2l-.3-.2h-.7v-1h1.1l.2.2h.3l.3.2.3.2.2.3h.2v.2h.2v.2h.2v.3h.2v.3l.2.2v.5l.2.2v.7zm-3.7 3.7v-1h1.2v-.2h.2l.2-.2.2-.2v-.2h.2v-.2h.2v-.2l.2-.2v-.5h.2v-.8h1v1.1l-.2.2v.2l-.2.2-.2.3-.2.3-.2.2-.2.2-.2.2h-.2v.2h-.3v.2h-.4l-.2.2h-1zm-3.7-3.6h1v.5l.2.2v.3l.2.2v.2h.2l.2.2v.2h.2v.2h.2l.3.2h.2l.2.2h.7v1h-1l-.3-.2h-.3l-.3-.2-.3-.2v-.2l-.3-.2-.2-.2v-.2h-.2v-.3h-.2v-.6l-.2-.2v-.7l-.2-.2v-.2zm3.7-3.7v1h-.7v.2h-.4l-.2.2h-.2v.2h-.2v.2l-.2.2-.2.2v.4h-.2v.8h-1.2v-.5l.2-.3v-.4l.2-.2v-.2h.2v-.3h.2v-.3h.2v-.2h.3v-.3l.3-.2.3-.2h.3l.2-.2h1z"
          />
          <path
            fill="#edb92e"
            d="M371 237.4c2.3-.8 6 4.6 7 4.5 1.2-3-1.2-10.5-5.5-16.3-3-1-3.2-3-3.8-7.3-.2-1.3-2.7-.4-2.7 2 0 2.3-.3 3.6.3 5.6.2.8 0 1.6-.8 2.3 4.5 1.8 5.6 4 5.4 9z"
          />
          <path
            fill="#21231e"
            d="M377.6 241.8l1 .3-.5.4h-.4l-.3-.2-.2-.2-.3-.3-.2-.2-.2-.2-.2-.2-.3-.3-.3-.2-.2-.2-.2-.3-.3-.2-.2-.2-.3-.2-.2-.3h-.3l-.3-.3h-.2l-.3-.3-.3-.2h-.2l-.3-.2h-.4l-.2-.2h-.4l-.4-1h1.3l.3.2h.3l.3.2.2.2h.3l.3.3.2.2h.3l.3.3.3.3v.2l.4.2.2.3.3.2v.2l.4.3.2.2.2.2.2.2.2.2.2.2h.2v.2h.3v.2l-.4.3zm1 .3l-.2.4h-.3l.5-.3zm-6.3-15.8l.4-1 .2.2.3.5.4.5.4.6.4.7.4.5.3.6.5.6.3.6.3.6.4.6.3.6.2.6.2.6.2.5.2.6.2.7.2.5v.6l.3.5v.6l.2.4v.5l.2.4v3.3l-.2.3-1-.2v-.3l.2-.3v-3.6l-.3-.5v-.4l-.2-.5-.2-.5-.2-.5v-.5l-.4-.6-.2-.7-.2-.5-.3-.6-.2-.6-.3-.5-.3-.5-.4-.6-.3-.7-.4-.5-.4-.6-.4-.6-.3-.5-.5-.5-.4-.5.3.2zm.4-1l.2.2-.3-.2zm-4.5-6.7h1v.7l.2.3v1l.2.3v.5l.2.3v.5l.2.2v.4h.2v.3l.2.2v.2h.2v.3h.2l.2.2v.2h.2l.2.2h.2l.2.2h.2l.2.2h.2l.3.2-.4 1h-.2l-.2-.2-.3-.2h-.2l-.2-.2h-.2l-.2-.3-.2-.2h-.2v-.2l-.3-.2-.2-.2-.2-.2v-.2l-.2-.2v-.2l-.2-.3v-.2l-.2-.2v-.3l-.2-.2v-.9l-.2-.3v-.6l-.2-.3V219l-.2-.5zm-1.7 1.8h-1v-1l.2-.2.2-.2v-.4h.2l.2-.3h.2l.2-.2.3-.2h.2l.2-.2h1.2v.2h.2v.3l.2.2v.2h-1.6v.2h-.2v.2h-.2v.2h-.2v.3l-.2.2v.8zm.3 5.6l-1 .2v-.6l-.2-.2V224h-.2v-3.6h1v4.2l.2.2v.7l.2.2zm-1 2l-.5.8v-1l.2-.2v-.2h.2v-.4h.2v-.4l-.2-.2v-.2l1-.3v1.8h-.2v.4h-.2v.2h-.2v.2l-.2.2h-.2v-.7zm-.5.8l-.8-.3.7-.6v.8zm5 8.6h1-1v-.5l.2-.5v-2l-.2-.3v-.7l-.2-.3v-.6l-.2-.3v-.2l-.2-.3-.2-.3v-.2l-.3-.3v-.2l-.3-.2-.2-.2-.3-.2-.2-.2-.3-.2h-.3l-.3-.3-.2-.2-.3-.2-.4-.2h-.3l-.4-.2.4-1 .4.2.5.2.4.2.3.2.3.2.4.2.3.2.3.2.3.2v.2l.4.3.2.3.3.3v.2l.3.3v.4l.3.3v.3l.3.3v.7l.2.3v.7l.2.4v2.9h-1zm1 0h-1l.5-.5.6.4zm-1 0v-.4h.5l-.4.4z"
          />
          <path
            fill="#edb92e"
            d="M368.8 218.5c-.4 1-.6 1.8-.7 3.4 0 1 .5 2 1.2 3 .8 1 1.8 2 3 2.6.8.5 1.6 1.7 2.3 3 .7 1.4 1.2 3 1.2 4 0 3.5.8 6.7 2.4 7.3 1.2.3 1.6.2 2.4 0-.2-.6 0-1.5-.7-2.4a8 8 0 0 1-1.4-3.7c0-1-.5-1.6-.2-3.3.4-1.2 1-1.6 1-2.7-.3-2-2-6-4.3-6s-3.4-.3-4.6-3.4c-.3-1-1-1.6-1.2-2z"
          />
          <path
            fill="#21231e"
            d="M368.6 222l-1-.2v-1.2l.2-.2v-1h.2v-.7h.2v-.4l1 .3v.4h-.2v1l-.2.2v1.5l-.2.3zm1 2.8l-.8.6v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.4h-.2v-.5l-.2-.2v-.7l-.2-.2v-.7h1v1.1h.2v.7h.2v.4h.2v.4h.2v.2h.2v.2zm3 2.4l-.6 1v-.2h-.4v-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.3v-.2h-.2l-.2-.2v-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2-.2-.2.8-.6.2.2.2.2v.2h.2l.2.2v.2h.2l.2.2.2.2h.2v.2h.2v.2h.3l.2.2.2.2h.2v.2zm2.4 3.2l-1 .4v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2h-.2l-.2-.2h-.2l.5-1h.2v.2h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2h.2v.2l.2.2v.2l.2.2v.2h.2v.3h.2v.3h.2zm1.2 4.2h-1v-.8l-.2-.2v-.8h-.2v-.5h-.2v-.4h-.2v-.5h-.2v-.2l-.2-.2 1-.4v.4h.2v.4h.2v.5l.2.2v.3h.2v.6h.2v1h.2v.7zm-1 0zm3 6.8l-.3 1h-.3l-.2-.2-.3-.3v-.2l-.3-.2h-.2l-.2-.3v-.2h-.2v-.3l-.2-.2v-.3l-.2-.2v-.3l-.2-.2v-.5l-.2-.3v-.8l-.2-.3V236l-.2-.3v-1.5h1v2.1l.2.3v1.4l.2.2v.8l.2.2v.2l.2.2v.4l.2.2v.2l.2.2.2.2v.2h.2v.2h.2l.2.2zm1.7.8l1-.3-.5.5h-.4v.2h-1.4l-.2-.2h-.4l.3-1h.7v.2h1.2v-.2l-.3.7zm1-.3v.4h-.5l.4-.5zm-1.7-2l.8-.7h.2v.4h.2v.4h.2v.8l.2.2v1l-1 .4V241l-.2-.2v-.8h-.2v-.2zm-1.5-4h1v.8h.2v.8l.2.2v.2l.2.2v.2h.2v.5h.2v.2h.2v.2l-.7.7v-.2l-.2-.2v-.4h-.2v-.5h-.2v-.2l-.2-.3v-.2l-.2-.2v-.2l-.2-.3v-.4l-.2-.2v-.5zm1 0zm-1.2-3.4l1 .2v3l.2.2-1 .2v-.8l-.2-.2v-2.6zm1-2.5h1v.7h-.2v.6l-.2.2v.2l-.2.2v.2h-.2v.6h-.2v.2l-1-.2v-.4h.2v-.4l.2-.2v-.2l.2-.2v-.2l.2-.2v-.9zm-4-5.5v-1h1.1l.3.2h.2l.2.2h.3l.2.2.2.2v.2l.3.2v.2l.3.2.2.3v.2l.3.3.2.2.2.3v.2l.2.3v.2l.2.3v.3l.2.2v.3l.2.2v.5l.2.3v.8h-1v-1l-.2-.2v-.4l-.2-.3-.2-.4v-.2l-.2-.2v-.3l-.3-.3v-.2l-.2-.2v-.3l-.2-.2-.3-.3-.2-.2-.3-.3-.3-.2-.3-.2h-.8zm-5-3.7l1-.4v.3l.2.3v.2l.2.2v.2l.2.2v.2l.2.2.2.2v.2h.2v.2h.2v.2h.4v.2h.7v.2h1.7v1H373l-.3-.2h-.4v-.2h-.3v-.2h-.3v-.3h-.3v-.2l-.2-.2-.2-.3-.2-.2v-.2l-.2-.2-.2-.4-.2-.2v-.3l-.2-.2zm-.4-2l-1-.5h1.2v.4h.2v.2h.2v.2h.2v.4h.2v.2l.2.2v.2l.2.2-1 .4v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2h-.2v-.2h.8zm-1-.5l.5-1 .5 1h-1zm.6.2l.4.2-.4-.2zm-.5-.2l.4-1 .5 1h-1z"
          />
          <path
            fill="#edb92e"
            d="M360 227l2-1a6 6 0 0 1 4-.2c5.5 1.7 8 11.6 1.8 14-1.2.2-2.3-1-3.4-3.3a20.5 20.5 0 0 0-4-6.8c-1-1-1-2-.4-2.6z"
          />
          <path
            fill="#21231e"
            d="M362 225.5l.3 1h-.4v.2h-.4v.2h-.8v.2h-.2l-.2.2-.7-.7.2-.2v-.2h.4v-.2h.8v-.2h.4v-.2h.4zm4-.2l-.2 1h-.5v-.2h-2.1v.2h-.7l-.2.2-.5-1h.4l.3-.2h.8v-.2h1.6l.2.2h.4zm2 15l-.2-1h-.2l.5-.2h.6l.4-.4.4-.3.3-.4.3-.5.2-.4.2-.3.2-.5v-.5l.2-.5V232l-.3-.4-.2-.5-.2-.5v-.5l-.4-.4-.2-.5-.4-.3-.3-.5-.4-.3-.3-.5-.4-.3-.5-.3-.3-.4-.5-.2h-.4l.2-1h.6l.5.3.7.3.4.4.6.3.5.4.5.6.3.4.4.5.3.5.3.6.3.5.3.7.2.6v.6l.3.5v3.4l-.2.5-.2.6-.3.6-.2.5-.3.5-.4.5-.4.4-.4.3-.6.3-.6.3zm0 0zm-4-3.6l1-.4v.4l.2.2.2.3.2.3v.2h.2v.5h.2v.2l.2.2.2.2h.2v.2h.2l.2.2h.8v1.2h-.8v-.2h-.5l-.2-.2-.2-.2-.2-.2-.2-.2v-.2h-.2l-.2-.2v-.2h-.2v-.3l-.2-.2v-.2h-.2v-.2l-.2-.2v-.2l-.2-.3-.3-.3zm0 0zm-4-6.6l.7-.6.2.2v.2h.2l.2.3v.3h.2l.2.3v.2l.2.2h.2v.3l.3.2v.2l.2.2.2.2v.4l.2.2.2.3v.3l.2.2.2.3v.3l.2.3v.3l.3.3.2.4v.3l.3.3v.3l-1 .4v-.6l-.2-.2v-.3l-.3-.2v-.3l-.2-.2v-.5l-.3-.3v-.2l-.2-.2v-.3l-.3-.2-.2-.3v-.2l-.3-.2v-.2h-.2v-.3h-.3v-.3l-.2-.2-.3-.3v-.2l-.2-.2h-.2v-.2l-.2-.2zm0 0zm0-3.4v1l.3-.2v.2h-.2v.8h.2v.4l.2.2.2.2v.2l-.7.7h-.2v-.2l-.2-.2-.2-.2v-.3h-.2V227h.2v-.2h.2l.4-.2zm-.4 0h.4-.4zm.4 1v-1l.3 1h-.3zm.3 0h-.2.3z"
          />
          <path
            fill="#edb92e"
            d="M362.8 227.7c5.4-2 9.4 8.3 4.3 10.2-2.6 1-2.8-2.4-3.4-4.3-.7-2.5-6-4-.8-6z"
          />
          <path
            fill="#21231e"
            d="M367.3 238.4l-.4-1h.3l.3-.3.3-.2.2-.3.2-.3.2-.3v-.5l.2-.4v-2.7l-.2-.4-.2-.5-.2-.4-.2-.4-.3-.4-.3-.4-.2-.3-.4-.4-.3-.2-.3-.2-.4-.2-.4-.2h-.4l-.3-.2h-1.3l-.4.2-.4-1h.6l.5-.2h1.6l.5.3.5.2.4.2.4.4.5.4.4.4.3.4.3.5.2.4.3.6.3.5.2.6.2.6v.5l.2.5v1.6l-.2.5v.5l-.3.5-.2.4-.3.5-.4.3-.4.4-.4.2-.5.2zM363 234l1-.4.2.2v.6l.2.2v.8l.2.2v.4l.2.2v.2l.2.3.2.3v.2h.2v.2h.2l.2.2h1.2l.3.8h-.3l-.3.2h-1.2l-.2-.2h-.2v-.2l-.3-.2-.3-.3v-.2l-.2-.2v-.2h-.2v-.3l-.2-.2v-.4h-.2v-.8l-.2-.2v-.8l-.2-.2v-.2zm-.4-6.7l.4 1h-.5l-.3.3h-.4l-.2.3h-.2l-.2.2v.2h-.2v.4h.2v.3l.2.2v.2h.3v.3l.3.2h.2l.2.2.2.2.2.2.2.2.2.3.2.3.2.2v.3l.3.2v.6l-1 .3v-.7l-.2-.2h-.2v-.3l-.3-.2h-.2v-.3l-.3-.2-.2-.2-.2-.2-.2-.2v-.2l-.2-.2h-.2v-.3l-.3-.3v-.2l-.2-.2v-.8l.2-.3v-.3l.3-.2.2-.2.3-.3.3-.2h.4l.4-.3.6-.2z"
          />
          <path
            fill="#0c4076"
            d="M363.4 229.3c2.6-1 6.2 5 3 6.5-2.3 1-4-.3-4.8-2-.7-2 0-3.8 1.7-4.5z"
          />
          <path
            fill="#21231e"
            d="M366.5 236.3l-.4-1h.3l.2-.2h.2v-.2l.2-.2v-2l-.2-.3v-.3h-.2v-.4l-.3-.3-.2-.2-.3-.4-.2-.2-.2-.2h-.2v-.2l-.3-.2h-1.1l-.3-1h1.5l.4.3.3.2.2.3.2.2.3.2.2.2.2.3v.3l.3.3.2.4.2.3v.4l.2.4v2.6l-.2.3-.2.4-.2.3-.2.2h-.4l-.3.3zm-5.4-2.5l1-.3.2.3.2.3v.2l.2.3.2.2.2.2h.3v.2h.2l.3.2h.4v.2h1.3l.3-.2.5 1h-.7l-.2.2h-1.9l-.2-.2h-.2v-.2h-.3l-.2-.2-.3-.2-.3-.3-.3-.3h-.2v-.3l-.2-.3-.2-.3v-.2l-.2-.2v-.2zm2.2-5l.3 1h-.3l-.2.2-.2.2-.2.2-.2.2-.2.2v.2h-.2v.7l-.2.2v1.1l.2.2v.3l-1 .3v-.7l-.2-.3v-1.5l.2-.2v-.3l.2-.2.2-.3.2-.3v-.2l.3-.2v-.2h.3l.2-.2.3-.2h.2l.2-.2zm.2.5l-.2-.5.2.5z"
          />
          <path
            fill="#fff"
            d="M400 179.7c3.6 0 6.4 2.8 6.4 6.4 0 3.6-2.8 6.5-6.3 6.5s-6.3-3-6.3-6.4 3-6.3 6.4-6.3z"
          />
          <path
            fill="#21231e"
            d="M407 186h-1c0-2-1.4-4.3-3.3-5.2a5.8 5.8 0 0 0-2.6-.6v-1c2.4 0 4.7 1.2 6 3.2a7 7 0 0 1 1 3.7zm-7 7v-1a6 6 0 0 0 5.3-3.3 6 6 0 0 0 .6-2.6h1c0 2.4-1.3 4.7-3.3 6a6.8 6.8 0 0 1-3.6 1zm-6.8-7h1a6 6 0 0 0 3.3 5.4 5.8 5.8 0 0 0 2.6.6v1a6.8 6.8 0 0 1-5.7-3.3 7 7 0 0 1-1-3.6zm7-7v1.2a5.9 5.9 0 0 0-5.3 3.2 6 6 0 0 0-.8 2.7h-1a7 7 0 0 1 3.3-5.8 6.8 6.8 0 0 1 3.6-1z"
          />
          <path
            fill="#fff"
            d="M395.4 169c3.5 0 6.4 3 6.4 6.4 0 3.6-3 6.4-6.4 6.4s-6.3-2.8-6.3-6.4c0-3.5 3-6.4 6.4-6.4z"
          />
          <path
            fill="#21231e"
            d="M402.3 175.4h-1c0-2.2-1.3-4.3-3.2-5.3a5.8 5.8 0 0 0-2.6-.5v-1c2.4 0 4.6 1.3 6 3.2a7 7 0 0 1 1 3.7zm-7 7v-1c2.3 0 4.4-1.4 5.4-3.3a6 6 0 0 0 .6-2.6h1c0 2.4-1.2 4.7-3.2 6a6.8 6.8 0 0 1-3.6 1zm-6.7-7h1a6 6 0 0 0 3.2 5.3c.8.4 1.7.6 2.6.6v1a6.8 6.8 0 0 1-5.8-3.2 7 7 0 0 1-1-3.6zm6.8-7v1c-2 0-4.2 1.4-5.2 3.3a6 6 0 0 0-.6 2.7h-1c0-2.3 1.2-4.6 3.2-6a7 7 0 0 1 3.6-1z"
          />
          <path
            fill="#fff"
            d="M410.7 131.5c3.4 0 6 2.7 6 6s-2.6 6.3-6 6.3-6.2-2.7-6.2-6.2a6 6 0 0 1 6.2-6z"
          />
          <path
            fill="#21231e"
            d="M417.3 137.7h-1c0-2.2-1.2-4.2-3-5a5.6 5.6 0 0 0-2.6-.7v-1a7 7 0 0 1 5.6 3 6.7 6.7 0 0 1 1 3.7zm-6.6 6.6v-1c2 0 4-1.2 5-3 .4-1 .6-1.8.6-2.6h1c0 2.2-1.2 4.5-3 5.6a6.6 6.6 0 0 1-3.6 1zm-6.7-6.7h1c0 2.2 1.3 4.2 3.2 5a5.6 5.6 0 0 0 2.5.7v1a6.6 6.6 0 0 1-5.6-3 6.7 6.7 0 0 1-1-3.6zm6.7-6.6v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.7 2.6h-1a7 7 0 0 1 3-5.6 6.6 6.6 0 0 1 3.7-1z"
          />
          <path
            fill="#fff"
            d="M400.4 136.2c3.5 0 6.3 3 6.3 6.4 0 3.5-2.8 6.4-6.3 6.4s-6.4-3-6.4-6.4c0-3.5 2.8-6.4 6.4-6.4z"
          />
          <path
            fill="#21231e"
            d="M407.2 142.6h-1a6 6 0 0 0-3.3-5.3 5.8 5.8 0 0 0-2.6-.6v-1c2.3 0 4.6 1.2 5.8 3.2a7 7 0 0 1 1 3.6zm-6.8 7v-1c2 0 4.2-1.4 5.2-3.3a6 6 0 0 0 .6-2.7h1c0 2.3-1.2 4.7-3.2 6a6.8 6.8 0 0 1-3.6 1zm-7-7h1c0 2.2 1.4 4.3 3.3 5.3a5.8 5.8 0 0 0 2.7.5v1a7.2 7.2 0 0 1-6-3.2 7 7 0 0 1-1-3.7zm7-7v1a6.2 6.2 0 0 0-5.3 3.3 6 6 0 0 0-.5 2.6h-1c0-2.4 1.2-4.7 3.2-6a6.8 6.8 0 0 1 3.7-1z"
          />
          <path
            fill="#fff"
            d="M392.8 145.3c3.5 0 6.3 2.8 6.3 6.4 0 3.5-2.7 6.4-6.2 6.4s-6.4-2.8-6.4-6.3c0-3.6 3-6.4 6.4-6.4z"
          />
          <path
            fill="#21231e"
            d="M399.6 151.7h-1a6 6 0 0 0-3.2-5.3 5.8 5.8 0 0 0-2.6-.6v-1c2.3 0 4.6 1.2 5.8 3.2a7 7 0 0 1 1 3.7zm-6.8 7v-1c2 0 4.2-1.4 5.2-3.4a6 6 0 0 0 .6-2.6h1c0 2.3-1.2 4.6-3.2 6a6.8 6.8 0 0 1-3.6 1zm-7-7h1c0 2 1.4 4.3 3.3 5.2a5.8 5.8 0 0 0 2.8.6v1a7.4 7.4 0 0 1-6-3.3 7 7 0 0 1-1-3.6zm7-7v1a6 6 0 0 0-5.3 3.3 6 6 0 0 0-.6 2.7h-1c0-2.4 1-4.7 3.2-6a7 7 0 0 1 3.6-1z"
          />
          <path
            fill="#fff"
            d="M391.5 156.7c3.6 0 6.4 2.8 6.4 6.4s-3 6.5-6.5 6.5-6.3-3-6.3-6.4 2.8-6.3 6.3-6.3z"
          />
          <path
            fill="#21231e"
            d="M398.4 163h-1c0-2-1.3-4.2-3.2-5.2a5.8 5.8 0 0 0-2.7-.6v-1c2.4 0 4.7 1.2 6 3.2a7 7 0 0 1 1 3.7zm-7 7v-1a6 6 0 0 0 5.4-3.3 6 6 0 0 0 .6-2.6h1c0 2.5-1.3 5-3.4 6a6.8 6.8 0 0 1-3.5 1zm-6.7-7h1c0 2.3 1.3 4.4 3.2 5.4.7.4 1.6.6 2.5.6v1a7 7 0 0 1-5.8-3.2 7 7 0 0 1-1-3.7zm6.8-6.8v1c-2 0-4.2 1.3-5.2 3.2a6 6 0 0 0-.6 2.7h-1c0-2.3 1.2-4.6 3.2-5.8a7 7 0 0 1 3.5-1z"
          />
          <path
            fill="#edb92e"
            d="M474.4 198c-2.7-5-5.6-8.2-8.6-9.6 4.2-13.2 5.2-30.2 2.7-51-.2-3.3-1-4.6-2.2-4.6-1 0-1.7 1.6-1.8 5.2.8 11.6 1.7 21.6 1.2 30.2-.5 7.6-2.3 14-4.2 21.2-.3 1 .4 1.7 3.8 3.7 2.6 1.5 4.2 3.3 4.7 5 .7-.2 1.2 0 1.5 0 2.5.8 3.6.6 3 0z"
          />
          <path
            fill="#21231e"
            d="M465.3 188.2l1 .3-.3-.6h.3l.3.2.3.2.2.2h.3l.3.3h.3l.4.4.2.2.3.2.2.3.3.3.3.3.3.3.3.2.3.3.3.3.2.3.2.5.3.3.3.4.2.3.3.4.3.3.2.4.3.4.3.5.2.5.3.4.3.4.3.5.3.5-1 .5-.3-.5-.2-.4-.3-.5-.2-.5-.3-.4-.3-.3-.2-.4-.3-.4-.3-.5-.3-.4-.2-.2-.3-.4-.4-.3-.2-.2-.3-.3v-.3l-.4-.3-.3-.4-.2-.3-.2-.2-.3-.2-.2-.2-.3-.2-.3-.2-.2-.2-.3-.2-.3-.2-.3-.2h-.3l-.3-.3-.4-.2-.3-.6zm.3.6h-.4v-.6l.4.6zm2.4-51.5h1l.2 2 .2 1.8.2 2 .2 2v1.8l.2 1.8v1.8l.2 1.8v15l-.3 1.5-.2 1.5v1.5l-.3 1.5-.2 1.5-.2 1.4-.2 1.5-.2 1.3-.3 1.4-.3 1.3-.3 1.4-.3 1.3-.4 1.3-.3 1.3-.4 1.2-1-.3.4-1.2.4-1.3.4-1.3.3-1.3.3-1.2.3-1.3.3-1.4.2-1.3.3-1.4.3-1.5.2-1.4V172l.3-1.6V169l.2-1.7v-1.6l.2-1.6v-13.6l-.2-1.8v-2l-.2-1.7-.2-2-.2-1.8-.2-2-.2-2zm0 0zm-1.7-4v-1h.6v.2h.3v.2h.2l.2.3h.2v.5h.2v.3l.2.2v.3l.2.2v.4l.2.4v.9l.2.3v.4h-1v-.9l-.2-.2v-.6l-.2-.2v-.5h-.2v-.5h-.2v-.2l-.2-.2h-.2v-.2h-.4zM465 138h-1v-1.7l.2-.3v-1l.2-.3v-.7h.2v-.3l.2-.3v-.3h.2l.2-.2.3-.2.2-.2h.5v1h-.2v.2h-.2v.2l-.2.2v.3l-.2.3v.6l-.2.2v1.6l-.2.4v.7zm-1 0zm2.2 30.2h-1V154l-.2-1v-2.8l-.2-1v-2l-.2-1v-1l-.2-1v-2l-.2-1V139l-.2-1 1-.2v1l.2 1.2v2l.2 1v2.2l.2 1v2l.2 1v2l.2 1v2.8l.2 1v12zm-4.3 21.3l-1-.3.2-.6v-.7l.3-.8.2-.6.2-.7v-.7l.2-.7.2-.6.2-.7v-.6l.3-.6v-.6l.2-.6.2-.7v-.5l.2-.6.2-.8v-.6l.2-.7.2-.7v-.7l.2-.6v-.7l.2-.6v-.7l.2-.7v-.7l.2-.6V169l.2-.8h1v1.5l-.2.7v1.5l-.2.6v.7l-.2.8v.7l-.2.6v.8l-.2.7-.2.6v.8l-.2.6-.2.7v.7l-.3.7v.6l-.3.7v.6l-.3.6-.2.6v.6l-.3.7-.2.5-.2.7v.6l-.3.7-.2.7-.2.6v.7zm3.6 3l-.5 1-.2-.2h-.3l-.3-.3-.3-.2h-.4l-.2-.3h-.2l-.3-.3h-.3v-.2l-.3-.2h-.2l-.2-.2-.2-.3h-.2v-.2h-.2l-.2-.2v-.2l-.2-.2v-1l1 .2v.5h.2v.2l.2.2h.2v.2h.2l.2.2.3.3h.2l.2.2.2.2h.2l.2.3h.3l.3.3.3.2h.3zm0 0zm4.2 5.2l.4 1-.7-.4v-.2l-.2-.2v-.3l-.2-.2v-.3l-.2-.3-.3-.3-.2-.3-.3-.2-.3-.3v-.2h-.3v-.2h-.3v-.2l-.3-.2h-.2v-.3h-.3l-.2-.2h-.3l-.2-.2-.2-.2h-.2l.6-1 .2.2h.2l.3.3.2.2.2.2h.2v.3h.4l.2.3.3.3.3.3.2.2.3.3v.3l.3.2h.2v.3l.3.2v.2h.2v.3l.2.2v.2l.2.3v.3l.2.2v.2l-.6-.3zm.4 1h-.5l-.2-.4.7.3zm1.4-1.2l-.3 1h-1l-.4-.8h.2l.2-.2h1.4zm3.3.5h-1l.7-.4.2.2v.8l-.2.2h-.2v.2h-1.8l-.2-.2h-.3l-.2-.2h-.5l.3-1h.7l.2.2h1v.2h.7v.4l.7-.4zm-1 0v-1l.7.6-.8.4zm0 0h1l-1 .3v-.3z"
          />
          <path
            fill="#edb92e"
            d="M458.4 214.6c1.6-1 2-.8 2.4-1.4.6-.8.6-2.2.4-3.5-.8-5.3 2.4-4.6 6-2.2 1.7 1 3.5 4 5 5.3s2.8 1.5 3.2 2v9.2c-.4.6-1.7.7-3.2 2-1.5 1.5-3.3 4.2-5 5.4-3.6 2.3-6.8 3-6-2.2.2-1.3.2-2.7-.4-3.5-.5-.7-.8-.4-2.4-1.4a7 7 0 0 1-2.3-2.2c-.4-.8 0-1.7 0-2.6 0-1-.4-1.8 0-2.6.6-.8 1.4-1.6 2.4-2.2z"
          />
          <path
            fill="#21231e"
            d="M460.4 213l.8.5-.2.2-.2.2h-.4v.2h-.4l-.2.2h-.2l-.2.2h-.2v.2h-.5v.2l-.7-1h.6v-.2h.2l.2-.2h.2l.2-.2h.4v-.2h.4v-.2h.2zm.3-3.2l1-.2v2.9l-.2.3v.2h-.2v.2l-1-.5v-.2h.2v-.4h.2v-2.6zm6.7-2.8l-.6 1-.3-.3-.3-.2-.3-.2-.4-.2h-.3l-.3-.2h-.3l-.3-.2h-.3v-.2h-.4l-.2-.2h-1.1v.2h-.2v.2l-.2.2v.6l-.2.3v2l-1 .2v-3l.2-.4v-.3l.3-.2.3-.2.2-.2h.2l.2-.2h.2l.2-.2h1.5v.2h.5l.3.2h.3l.4.3h.3l.3.2.4.2.3.2.3.2.4.2zm5 5.4l-.6.7-.3-.2-.3-.3-.3-.3-.2-.2-.2-.2-.3-.3-.2-.2v-.2h-.2v-.3l-.3-.2-.3-.3-.2-.2v-.2l-.3-.2v-.2h-.3l-.2-.3-.3-.2-.2-.2h-.2l-.2-.2v-.2h-.3v-.2h-.2l.6-1 .2.2.3.2v.2h.3v.3h.3l.2.2.2.2v.2l.3.2h.2v.3l.3.3.2.2v.2l.3.2.3.3h.2v.3l.3.2.2.2.2.2.3.3v.2h.3v.3h.3v.3h.2zm3.5 2.4h-1.2v.3h-.2l-.2-.2h-.2v-.2h-.4l-.2-.2h-.2v-.2h-.3v-.2h-.3v-.2l-.3-.2-.3-.2-.2-.3.7-.6h.2v.2h.2v.2h.2v.2h.2v.2h.3l.2.2.2.2h.2l.2.2h.2l.2.2h.2v.2h.4v.2l.2.2v.2zm-.2-.2v.2-.2zm0 4.8h-1v-4.5l1-.2v4.5zm-1 0zm0 0h1-1zm0 0zm1 5l-1-.7v.3-4.4h1v4.7zm0-.4v.2-.2zm-3.3 2.5l-.7-.8h.2v-.2l.3-.2.3-.2h.3v-.2h.3v-.2h.2l.2-.2h.2v-.2h.4v-.2h.4v-.2l1 .5-.2.2-.2.2h-.2v.2h-.4l-.2.2h-.2v.2h-.4v.2h-.3v.2h-.2l-.2.2-.2.2v.2h-.3zm-5 5.3l-.7-.8h.2v-.2l.3-.2.3-.2.2-.2.3-.3.2-.2.2-.2.2-.2v-.2h.3v-.3l.2-.3.2-.2v-.2l.3-.2.3-.2v-.2l.3-.2.2-.2v-.2h.3v-.3l.3-.2.2-.2h.2v-.3h.3v-.3l.8.8-.2.2-.2.2-.2.2v.2h-.3v.3l-.3.2-.3.2-.2.2-.2.2-.2.2v.2l-.3.2v.2l-.2.2h-.2v.3h-.3l-.2.3v.2h-.2l-.2.3-.2.2-.3.3-.3.3-.3.2zm-6.8-2.7l1 .3v2.6l.2.2v.2h.2v.2h1.7v-.2h.4l.3-.2h.3l.3-.3.3-.3h.3l.2-.3.3-.2.3-.2.6.8-.4.2-.3.3-.3.2h-.4l-.3.3-.3.2h-.3l-.2.3h-.4l-.3.2h-.4l-.3.2h-.9l-.3-.2h-.3l-.2-.3-.2-.2-.2-.2v-.3l-.2-.2v-.7l-.2-.3V229zm-.3-3l.8-.6v.2h.2v.4h.2v.6l.2.2v2.4l-1-.2v-2.5h-.2v-.4h-.2v-.2zm-2.3-1.3l.7-.8h.2l.2.2h.2l.2.2h.2l.2.2h.4v.2h.2v.2h.2l.2.2.2.2-.8.6-.2-.2h-.2v-.2h-.4l-.2-.2h-.4v-.2h-.2l-.2-.2h-.2v-.2h-.3zm.7-.8l.5.2-.5-.3zm-3-1.7l.8-.5.2.2v.2h.2v.4h.2v.2h.2v.2h.2v.2h.2l.2.2.2.2h.2v.2h.2l-.5 1v-.2h-.2l-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2zm-.3-3h1v2.4l-.7.5v-.2h-.2v-.4l-.2-.2v-2.1zm.3-2.8l.8.6v.4l-.2.2v1.8h-1V217h.2v-.4h.2zm2.4-2.4l.7 1h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2-.2.2-.2.2v.2h-.2v.2h-.2v.2l-1-.5h.2v-.2l.2-.2.2-.2v-.2h.2l.2-.2v-.2h.2v-.2h.2l.2-.2h.2v-.2l.2-.2h.2v-.2h.2zm.7 1l.5-.3-.5.3z"
          />
          <path
            fill="#21231e"
            d="M475.5 220.2v1c-4 .4-7 2-9.7 4.3 1.8-2.7 5.7-4.7 9.7-5.3zm0-1.6v-.8c-4-.5-7-2-9.7-4.4 1.8 2.7 5.7 4.6 9.7 5.2z"
          />
          <path
            fill="#edb92e"
            d="M461.2 207.3c1 .4 2.3 1 3.4 2 1.6 1.5.6 4-1.5 6.6-.6.7-1 2-1 3.5 0 1.3.5 2.7 1 3.5 2.2 2.5 3.2 5 1.6 6.6-1 1-2.3 1.5-3.4 2v-2.4c.2-1.3.2-2.7-.4-3.5-.5-.7-.8-.4-2.4-1.4a7 7 0 0 1-2.3-2.2c-.4-.8 0-1.7 0-2.6 0-1-.4-1.8 0-2.6.6-.8 1.4-1.6 2.4-2.2 1.6-1 2-.8 2.4-1.4.6-.8.6-2.2.4-3.5v-2.4z"
          />
          <path
            fill="#21231e"
            d="M465 209l-.8.6-.2-.2-.2-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.4v-.2h-.5v-.2h-.2l-.2-.2h-.2l-.2-.2h-.2l.4-1h.2l.2.2h.2l.2.2h.3l.2.2h.2v.2h.3l.2.2h.2v.2h.3v.2h.2l.2.2.2.2.2.2zm-1.5 7.2l-.8-.6.2-.3v-.2h.2l.2-.3.2-.3v-.2l.3-.2v-.5l.2-.2v-.2h.2v-.3l.2-.2v-.4h.2v-1.6l-.2-.3-.2-.2-.2-.2.7-.7.3.3v.2l.2.2v.2h.2v.5l.2.2v1l-.2.2v.4l-.2.2v.5l-.2.3v.3l-.3.2v.5l-.3.2v.3l-.3.2-.2.3v.2l-.3.2-.3.3-.2.2zm-1 3.3h-1v-.7l.2-.2v-1.2h.2v-1h.2v-.4l.2-.2v-.2h.2v-.2l1 .6h-.2v.4h-.2v.2l-.2.2v.9h-.2v1.4h-.2v.5zm1 3.2l-.8.6v-.2h-.2v-.2h-.2v-.4h-.2v-1.1l-.2-.3V220h-.2v-.5h1v1.1l.2.2v.4l.2.2v.4l.2.2v.2h.2v.2zm1.5 7.3l-.8-.8h.2v-.2h.2v-.3l.2-.2v-1.9l-.2-.2v-.2l-.2-.2v-.2l-.2-.3v-.2l-.2-.2-.3-.3v-.3l-.3-.2-.2-.2v-.2l-.3-.3-.3-.2.8-.6.2.2h.2v.4l.2.2.2.3h.2v.3l.3.3v.5l.3.3v.3l.2.2v.5l.2.2v.5l.2.2v.7l-.2.4v.4l-.2.2v.2l-.2.2v.2l-.3.2v.2zm-4.3 1.7l1-.2-.7-.4h.7v-.2h.4l.2-.2h.2l.2-.2h.2v-.2h.4v-.2h.2l.2-.2.2-.2h.2v-.2h.2v-.2l.8.8h-.2v.2h-.2v.2h-.2l-.2.2-.2.2h-.2l-.2.2h-.2v.2h-.4v.2h-.4v.2h-.5v.2h-.2l-.2.2h-.2l-.7-.3zm.7.4l-.6.3v-.6l.6.4zm-.7-3l1 .3v2l-1 .3v-2.4zm-.3-3l.8-.6v.2h.2v.4h.2v.6l.2.2v2.4l-1-.2v-2.4h-.2v-.4h-.2v-.2zm-2.3-1.3l.7-.8h.2l.2.2h.2l.2.2h.2l.2.2h.4v.2h.2l.2.2.2.2.2.2-.8.6-.2-.2h-.2v-.2h-.4l-.2-.2h-.4v-.2h-.2l-.2-.2h-.2v-.2h-.3zm0 0l-.3-.2.4.2zm-2.3-2.4l.8-.5.2.2v.2h.2v.4h.2v.2h.2v.2h.2v.2h.2l.2.2h.2v.2h.2v.2h.2l-.5 1v-.2h-.2l-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2zm0 0l.3.5-.3-.5zm-.3-3h1v2.4l-.7.5v-.2h-.2v-.4l-.2-.2v-2.2zm.3-2.8l.8.6v.4l-.2.2v1.8h-1V217h.2v-.4h.2zm2.4-2.4l.7 1h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2-.2.2-.2.2v.2h-.2v.2h-.2v.2l-1-.5h.2v-.2l.2-.2.2-.2v-.2h.2l.2-.2v-.2h.2v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2h.2zm2.4-1l.8.5-.2.2-.2.2h-.4v.2h-.4l-.2.2h-.2l-.2.2h-.2v.2h-.5v.2l-.7-1h.6v-.2h.2l.2-.2h.2l.2-.2h.4v-.2h.4v-.2h.2zm.3-3.2l1-.2v2.9l-.2.2v.2h-.2v.2l-1-.5v-.2h.2v-.4h.2V210zm.5-2v-1l.5.6v2.1l-1 .2V207l.5.6zm0-1h.6v.6l-.6-.6zm0 0v1h-.2l.2-1zM361 226.3l.7-.3c-1.6-2.2-2-4.2-1.3-6.3-1.3 1.6-1 4.2.6 6.6z"
          />
          <path
            fill="#edb92e"
            d="M410.7 200c1.4 1.6 1.2 2 2 2.5 1 .6 2 .4 3.3 0 5-2 5 2 3.5 6.4-.7 2-2.8 4.3-3.7 6.2-1 1.7-.7 3-1 3.5a95.4 95.4 0 0 1-4 .6l-4 .5c-.6-.3-1-1.6-2.6-3s-4.4-3-6-4.6c-3-3.5-4.6-6.8.2-6.7 1.2 0 2.4-.2 3-1 .4-.7 0-1 .4-3 .3-1.2.8-2.3 1.4-3 .6-.8 1.5-.6 2.3-.7 1-.2 1.6-.7 2.5-.2 1 .4 2 1.2 2.7 2.3z"
          />
          <path
            fill="#21231e"
            d="M413 202l-.6 1-.2-.2-.2-.2-.2-.2v-.2h-.2v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.3-.3-.3.8-.6.3.2.2.3v.2h.2v.4h.2v.4h.2v.2l.2.2v.2h.2v.2l.2.2zm-.6 1zm3.5-1l.2 1h-.5l-.2.2h-.8v.2h-1.2l-.3-.2h-.2l-.2-.2h-.2l.5-1v.2h.8v.2h1l.2-.2h.4l.2-.2h.3zm4 7l-1-.3v-.4l.2-.4v-.5l.2-.4v-.3l.2-.3v-.7l.2-.4v-1.7l-.2-.2v-.4h-.2l-.2-.3h-.2l-.3-.2H417l-.4.3h-.4l-.3-.8.3-.2h.5l.4-.2h1.8l.3.2h.3l.2.3.2.4v.2l.3.3.2.4v3.3l-.2.4v.4l-.2.4v.4l-.2.4v.4zm-3.7 6.4l-1-.5v-.2l.2-.2.2-.2v-.2l.2-.2v-.4l.2-.2.2-.2v-.2l.2-.2.2-.2.2-.3.2-.2.2-.3.2-.2v-.2l.2-.2h.2v-.3l.2-.2v-.2l.2-.2.2-.3v-.2l.2-.2v-.2l.2-.3 1 .3v.2l-.2.3v.2l-.2.2-.2.3v.2l-.2.2v.3l-.3.2-.2.2v.2l-.2.2-.2.2v.2l-.2.2-.2.2v.2l-.3.2v.2l-.2.2-.2.2v.2l-.2.2v.4h-.3v.3l-.2.2-.2.2v.2zm-1.5 3.8l-.2-1-.3.2v-.4h.2v-1l.2-.2v-.4l.2-.3v-.4l.2-.3v-.2h.2l1 .4-.2.2-.2.3v.3h-.2v.7h-.2v.9l-.2.2v.4l-.2.2v.2l-.4.2zm.3 0h-.2.3zm-4.3.6v-1h1.1v-.2h1.2v-.2h1.1l.3-.2.2 1h-.4l-.3.2h-.9l-.2.2h-1.3v.2h-.7zm0 0zm0 0v-1 .5-.5 1-.5.5zm0-1zm-4 1.5l.4-1h-.2 1.3l.3-.2h1.9l.2-.2.2 1h-.8v.2h-1.4v.2h-2zm.2 0h-.3.2zm-3-3l.5-1 .2.3.3.3h.2l.2.3.2.2.2.3.2.2v.2h.2v.2h.2v.2l.2.2v.2h.2v.2h.2v.2l-.4 1v-.2h-.2l-.2-.2-.2-.2v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.2-.2-.2-.2-.3v-.2h-.2v-.2h-.3v-.3zm-6-4.8l.7-.6.2.2.3.3.3.3h.2v.3l.3.2h.3l.2.3h.2l.2.3.3.3.2.2.2.2h.2v.2l.3.2h.2l.2.3.2.2.3.3h.2l.2.3.3.2.2.2h.2v.2l-.5.8h-.3v-.2l-.3-.2h-.2v-.2l-.3-.2h-.3l-.2-.2-.2-.2h-.2v-.2l-.3-.2h-.2l-.2-.3h-.2v-.2h-.3l-.2-.2-.2-.2h-.2v-.3h-.3l-.2-.3-.2-.2h-.2v-.3h-.3v-.3l-.3-.2h-.2v-.3l-.3-.2zm.4-7.5v1H397l-.2.2h-.4l-.2.2v.2h-.2v1.5l.2.3v.3l.2.2.2.3.2.4.2.3.2.3.2.3.2.3.3.3v.2l.4.3.3.4-.8.5-.4-.3-.3-.3-.2-.4-.2-.4-.2-.3-.3-.4-.2-.3v-.4l-.3-.4v-.3l-.3-.3v-.3l-.3-.3V206l.2-.2.2-.2.2-.2.3-.2h.2l.3-.2h.7l.4-.2h.8zm2.5-.8l.8.5-.2.2-.2.2h-.2v.2h-.2l-.2.2h-.2l-.2.2h-.5l-.2.2h-1.1v-1h1.4l.2-.2h.2l.2-.2h.2v-.2h.2v-.2zm0 0zm.4-2.8l1 .2v.4h-.2v2h-.2v.4l-.2.2-1-.4h.2v-1.4l.2-.3v-.8l.2-.2zm1.4-3.2l.8.6-.2.2v.2h-.2v.4h-.2v.4h-.2v.4l-.2.2v.4l-.2.2v.4l-1-.2v-.7l.2-.2v-.4l.2-.2v-.4h.2v-.4h.2v-.4h.2v-.2h.2v-.4h.2zm.8.6l.5-.7-.4.8zm1.8-1.5l.2 1H404v.2h-.4v.2h-.2l-.8-.5.2-.2.2-.2h.2v-.2h.4l.2-.2h1.4zm.2 1h-.7.6zm2.7-1.2l-.5 1H406l-.2.2h-.4l-.2-1h.8l.2-.2h2.1zm3 3h-1v.2-.2h-.2v-.2l-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2l-.2-.2-.2-.2h-.2l-.2-.2.5-1v.2h.2l.2.2h.2v.2h.2v.2h.2l.2.2.2.2.2.2h.2v.2h.2v.2l.2.2.2.2.2.2v.2l.3.3zm-.2-.4h.2v.3-.4zm-.8.3h1l-1 .2v-.3zm0 .2v-.3.2z"
          />
          <path
            fill="#21231e"
            d="M410 219.4h-.7c-1.4-3.8-3.5-7-6.3-9.5 2.8 1.4 5.5 5.3 7 9.4zm1.4-.2c.3 0 .5 0 .8-.2-.5-4 0-7.5 1.5-11-2 2.5-2.8 7-2.3 11.2z"
          />
          <path
            fill="#edb92e"
            d="M418.3 202c-.2 1.4-.4 3-1 4.3-1 2-3.8 1.3-6.6-.7-.8-.6-2.2-.8-3.4-.6-1.3.3-2.4.8-3 1.7-1.5 2.6-3.4 4-5.2 2.6-1-1-2-2.3-2.7-3.5.5-.2 1.2-.3 2-.3 1.3 0 2.5-.2 3-1 .5-.7 0-1 .6-3 0-1.2.6-2.3 1.2-3 .6-.8 1.5-.6 2.3-.7 1-.2 1.6-.7 2.5-.2 1 .4 2 1.2 2.7 2.3 1.4 1.6 1.2 2 2 2.5 1 .6 2.2.4 3.3 0 1-.4 1.7-.6 2.3-.5z"
          />
          <path
            fill="#21231e"
            d="M417.7 206.5l-1-.4.2-.2v-.5l.2-.2v-.4l.2-.2v-.9l.2-.2v-1.2h.2v-.4h1v1.1l-.2.3v1h-.2v.7h-.2v.7h-.2v.3l-.2.3v.2zm-7.2-.5l.5-.8.3.2h.2l.3.3h.2l.3.3h.2l.3.2.2.2h.2l.3.2h.4v.2h.7l.2.2h1v-.2h.2l.2-.2.2-.3.2-.2 1 .5-.2.2-.2.3-.3.3v.2h-.2l-.2.2h-.2l-.3.2h-2l-.2-.2h-.2l-.3-.2h-.2l-.2-.2h-.2l-.3-.2-.2-.2h-.2l-.3-.3-.2-.2h-.3l-.3-.3-.2-.2zm-3-.4l-.3-1h1.1v-.2h1.3v.2h.6v.2h.4v.2h.2l.2.2-.5.8h-.2v-.2h-.4v-.2h-2.4zm-2.7 1.3l-.8-.6v-.2h.2v-.2h.2v-.2l.2-.2h.2v-.2h.2l.2-.2h.2l.2-.2h.3v-.2h.8l.2-.2h.5l.2 1h-.7v.2h-.4v.2h-.4l-.2.2h-.2v.2h-.2v.2h-.2v.2h-.2zm-6 2.7l.6-.8h.3v.2h.5l.2.2h.5l.3-.2h.3v-.2h.3v-.2h.2v-.3h.3v-.3h.3v-.3l.3-.3.2-.2.2-.2v-.2h.3v-.4l.3-.2.8.5v.2l-.3.2v.3l-.3.2h-.2v.3l-.3.2-.2.2-.2.2-.3.3h-.2l-.2.3h-.2v.3h-.3l-.3.2h-.4l-.3.2h-1.2l-.2-.2h-.2l-.2-.2-.2-.2h-.2zm-2.7-4.4l.5 1 .3-.8v.3h.2v.2l.2.2v.2h.2v.2l.2.2v.2h.2v.2l.2.2.2.2.2.2v.2h.2v.2h.2v.2h.2v.2h.2v.2h.2l-.6 1-.2-.2-.2-.2-.2-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.3h-.2v-.2h-.2v-.2h-.2v-.3h-.2v-.2h-.2v-.4h-.2v-.2h-.2V205zm0 .8l-.4-.4.5-.3v.8zm2.4-1v1H397v.2h-.4l-.5-1h1.2v-.2h1.2zm2.5-.8l.8.5-.2.2-.2.2h-.2v.2h-.2l-.2.2h-.2l-.2.2h-.7l-.2.2h-1.2v-1h1.4l.2-.2h.4v-.2h.2v-.2h.2v-.2zm0 0zm.4-2.8l1 .3v.3l-.2.3v1.7h-.2v.7h-.2l-1-.4h.2v-1.4h.2v-1.3l.2-.2zm1.4-3.2l.8.6-.2.2v.2h-.2v.4h-.2v.4h-.2v.4l-.2.2v.7h-.2v.5l-1-.3v-.7l.2-.2v-.4l.2-.2v-.4h.2v-.4h.2v-.4h.2v-.2h.2v-.4h.2zm0 0l.4-.5-.4.5zm2.6-1l.2 1h-.6v.2h-1v.2h-.2l-.2.2-.8-.6.2-.2.2-.2h.2v-.2h.4l.2-.2h1.4zm0 0h.6-.6zm3 0l-.6.8H406v.2h-.5l-.2-1h.8v-.2h2.1zm-.6.8l.3.2-.2-.2zm3.3 1.6l-.6.6-.2-.2h-.2v-.2l-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.2l-.2-.2.5-1v.2h.2l.2.2h.2v.2h.2v.2h.2l.2.2.2.2.2.2h.2v.2h.2v.2l.2.2.2.2.2.2v.2zm2 2.5l-.6 1-.2-.2-.2-.2-.2-.2v-.2h-.2v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.3-.2-.3.7-.6.3.2.2.3v.2h.2v.2l.2.2v.4h.2v.2l.2.2v.2h.2v.2l.2.2zm-.6 1l-.2-.2h.2zm3.5-1l.2 1h-.5l-.2.2h-.8v.2h-1.3l-.2-.2h-.2l-.2-.2h-.2l.5-1v.2h.6l.2.2h1.1l.2-.2h.4l.2-.2h.2zm2.8 0h-1l.5.5h-1l-.2.2h-.4l-.2.2h-.2l-.3-1 .2-.2h.8v-.2h1.5l.5.4zm-.5-.5h.6l-.2.5-.5-.5z"
          />
          <path
            fill="#edb92e"
            d="M391.8 221.2c.7-1 1-.8 1.2-1.3.2-1-.3-2-1-3.2-2.2-4.6.3-4.2 3.6-2.4 1 .4 2 1.2 3 2 1 1 1.8 1.8 2.7 2.4 1.6 1.2 2.7 1.2 3 1.7 1 2 1.5 3.5 1.8 4.2.3.7 1 2.3 1.6 4.2 0 .4-1 .5-1.8 2-.7 1.2-1.2 3.5-2 4.7-1.4 1.6-2.5 2.6-3.4 2.4-1 0-1.6-1.3-1.8-4.2a4 4 0 0 0-1.5-3c-.5-.6-.6-.4-2-1.2a9.3 9.3 0 0 1-2.4-2c-.6-.6-.7-1.3-1-2-.3-1-.8-1.6-.7-2.4a3.8 3.8 0 0 1 .8-2z"
          />
          <path
            fill="#21231e"
            d="M392.5 219.7l1 .3v.2l-.2.2v.2h-.2v.2h-.2v.2h-.2l-.2.2v.2h-.2l-.8-.5v-.2l.2-.2.2-.2.2-.2h.2v-.2h.2v-.2zm1 .3zm-1.8-3l1-.5v.4l.2.2v.4l.2.3v.2l.2.2v2l-1-.3v-1.2l-.2-.2v-.4h-.2v-.4h-.2v-.4zm4.2-3l-.6.8h-.3l-.2-.3h-.3l-.3-.3h-.3l-.3-.2h-.3l-.2-.2h-.5l-.2-.2h-.6v1.5l.3.4.2.3.2.4.2.5-1 .5v-.4l-.3-.4-.2-.4v-.7l-.2-.2v-1.5l.2-.2h.2l.2-.2h.2l.2-.2h1.2l.2.2h.6l.3.3.3.2h.3l.3.2.2.2.4.2h.3zm2.8 2l-.7 1v-.4h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.2l-.2-.2-.2-.2h-.2l-.2-.2.5-1v.2h.2v.2h.2l.2.2h.2v.2h.2l.2.2h.2v.2h.2v.2h.2l.2.2.2.2.2.2h.2v.2h.2zm2.8 2.4l-.6.8h-.2v-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2l-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.2l.6-1v.2h.2l.2.2v.2h.2l.2.2.2.2h.2v.2h.2v.2h.2v.2h.2l.2.2.2.2h.2v.2h.2l.2.2zm3.3 2l-1 .3v.2-.2h-.2v-.2h-.4l-.2-.2h-.2l-.2-.2h-.3l-.2-.2h-.3v-.2h-.3v-.2h-.3v-.2h-.3v-.2l.6-.8.2.2h.2v.2h.3l.2.2h.2l.2.2h.2v.2h.4l.2.2h.4v.2h.2l.2.2h.2v.3zm-.2-.3v.2zm1.7 4.5l-1 .4v-.7l-.2-.2v-.4l-.2-.2v-.5h-.2v-.4l-.2-.3v-.3h-.2v-.5h-.2v-.5h-.2v-.3l1-.4v.4l.2.3v.2l.2.3v.2l.2.3v.3l.2.3v.4h.2v.4l.2.2v.4h.2v.4zm0 0zm0 0l-1 .4h.3l.3.2-.5-.5.6.5-.5-.5.6.5-.5-.5.2.4-.2-.3v.2l1-.5v.2-.4.4l-.4-.5.6.5-.5-.5.6.5-.5-.5h.4v.3zm0-.2v.2-.2zm1.6 4.7l-1-.2v.3-.5l-.2-.3v-.2l-.2-.3v-.3l-.2-.3v-.2l-.2-.2v-.4l-.2-.2v-.2l-.2-.2v-.4l-.2-.2 1-.5v.4h.2v.5h.2v.5l.2.2v.3l.2.3v.5l.2.2v.3l.2.2v.2l.2.2v.6zm0-.3v.3-.3zm-1.7 2.4l-1-.4.2-.2v-.2h.2v-.2l.2-.2v-.2h.2v-.2h.2l.2-.2h.2v-.2h.2v-.2l1 .2v.4h-.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2-.2.2v.2zm-2.2 5l-.7-.7.2-.3v-.2h.2v-.3l.2-.2v-.4l.2-.2v-.5h.2v-.4h.2v-.5h.2v-.2l.2-.3v-.2l.2-.3v-.2l.2-.2 1 .5-.2.2v.3h-.2v.4h-.2v.5l-.2.2v.3l-.2.2v.3l-.2.2v.3l-.2.2v.3l-.2.2v.3h-.2v.3h-.2v.3l-.2.2v.2zm-3.7 2.7l.2-1h.4v-.2h.2l.2-.2h.2v-.2h.2l.2-.2.2-.2.2-.2.2-.2.2-.3.2-.2v-.2h.2v-.3l1 .7h-.2v.3h-.3v.3h-.2v.3h-.4v.4h-.2v.2h-.2l-.2.2-.2.2-.2.2h-.3v.2h-.4v.2h-1zm-2.2-5h1v.3l.2.2v1.1h.2v.5l.2.2v.3l.2.2v.2h.2v.2h.2v.2h.2v1h-.8v-.2h-.2l-.2-.2-.2-.2v-.3h-.2v-.2l-.2-.2v-.3l-.2-.3v-.4h-.2v-1l-.2-.2v-1zm-1.2-2.6l.7-.6.2.2v.2h.2v.2l.2.2v.2h.2v.3l.2.2v.2h.2v.7h.2v.6l-1 .2v-1h-.2v-.4l-.2-.2v-.2h-.2v-.2h-.2v-.4h-.2v-.2h-.2zm-2-1l.4-.8h.3v.2h.4v.2h.4v.2h.4v.2h.4v.2h.2v.2l-.6.7h-.2l-.2-.2h-.4v-.2h-.4l-.2-.2h-.2l-.2-.2h-.3zm-2.5-2l.7-.6.2.2.2.2.2.2.2.2h.2v.2h.2v.2h.2l.2.2h.2v.2h.2l.2.2-.5 1v-.2h-.2v-.2h-.4v-.2l-.2-.2h-.2l-.2-.2-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2v-.2zm-1.2-2.3l1-.4v.2h.2v.4h.2v.5h.2v.4h.2v.2l.2.2-.7.7h-.2v-.4h-.2v-.4h-.2v-.4l-.2-.2v-.8h-.2v-.2zm-.6-2.5h1v.8h.2v.4l.2.2v.2l.2.2v.2l-1 .5v-1h-.2v-.4h-.2v-.6h-.2v-.8zm1 0v.2zm.4-1.5v-1l.3.8v.4h-.2v.2h-.2v.8h-.2v.2h-1v-.9l.2-.2v-.4l.2-.2v-.2h.2v-.4h.2v-.2h.2l.4.7zm0-1h1l-.7.8-.2-.8zm0 0v1l-.4-.8.4-.3zm0 1h-1l.6-.8.4.7z"
          />
          <path
            fill="#21231e"
            d="M406.5 226l.2 1c-1.4.4-2.6 1-3.6 1.8s-1.7 2-2.3 3.2c.2-1.4 1-2.7 2-3.7s2.3-1.8 3.8-2.2zm-.6-1.6l-.5-1c-1.6 0-3.2-.4-4.7-1-1.5-.7-3-1.6-4.4-2.8 1 1.3 2.6 2.4 4.3 3.3 1.6.7 3.5 1.3 5.2 1.5z"
          />
          <path
            fill="#edb92e"
            d="M391.4 213.8c1 .4 1.6.8 2.8 1.8.8.7 1.3 1.7 1.5 3 0 1 0 2.5-.3 3.8-.2.8 0 2.2.5 3.6.4 1.4 1 2.8 2 3.5 2.3 2.5 4 5 3.4 6.7a4 4 0 0 1-1.5 1.8c-.4-.6-1-1.2-1.4-2.2a8 8 0 0 0-1.5-3.5c-.5-.6-.7-1.3-2-2.2-1-.5-2-.3-2.6-1-1.2-1.6-3-5.5-1.3-7.2 1.7-1.7 2.3-2.7 1-5.6-.5-1-.5-1.8-.6-2.4z"
          />
          <path
            fill="#21231e"
            d="M394.5 215.2l-.7.8-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2h-.2l-.2-.2h-.4l.3-1h.4v.2h.4v.2h.4v.2h.4v.2h.2v.2h.2l.2.2.2.2h.2v.2h.2v.2zm1.7 3.2l-1 .2v-.6h-.2v-.7h-.2v-.4l-.2-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2l.7-.8h.2v.2l.2.2v.2h.2v.2l.2.2v.2h.2v.4l.2.2v.4h.2v.8h.2v.2zm-.3 4h-1V221h.2v-2.4l1-.2v3.3l-.2.2v.5zm-1 0v-.3.3zm1.4 3.5l-1 .2v-.5l-.2-.3v-.4l-.2-.3v-.8h-.2v-1.4h1v1.9h.2v.7h.2v.7h.2v.3zm1.8 3.2l-.7.7v-.2l-.2-.2h-.2v-.4h-.2v-.2l-.2-.3v-.2h-.2v-.2l-.2-.3v-.2h-.2v-.5l-.2-.2-.2-.3v-.4h-.2l1-.4v.2l.2.2v.2l.2.3.2.2v.3l.2.2v.2h.2v.2h.2v.4h.2v.2h.2v.2h.2v.2zm3.6 7.2l-1-.4.2-.2v-1.3l-.2-.2v-.4l-.2-.2v-.2l-.2-.2-.2-.2v-.2l-.2-.2-.2-.2v-.2l-.3-.2-.2-.3v-.3l-.3-.2-.2-.2-.2-.3-.2-.2-.2-.2-.2-.2-.3-.3h-.2l.7-.8.3.2.2.2.2.3.3.4.3.2.2.2v.3l.3.3.3.2.2.3v.2l.3.2.2.3v.2l.2.2.2.2v.2l.2.2v.2l.2.3v.7l.2.2v1.2l-.2.2zm-2.4 1.8l1-.4-.8-.2.2-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.2l1 .4v.2l-.2.2v.2l-.2.2v.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2h-.2l-.2.2-.8-.2zm.8.2l-.5.3-.3-.5.8.2zm-2-2.5l1-.3v.4h.2v.4h.2v.2h.2v.2l.2.2v.2h.2v.4l-.8.4v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2h-.2v-.4l-.2-.2v-.2l-.2-.2v-.3zm-1.5-3.3l.8-.7v.2h.2v.2l.2.2v.2l.2.2v.2h.2v.5h.2v.4l.2.2v.4l.2.3v.7l-.8.2v-.4h-.2v-.5l-.2-.2v-.5h-.2v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2zm0 0zm-2-2.2l.4-1 .3.2.2.2h.2l.2.2.2.2.2.2v.2h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2l-.7.7-.2-.2v-.2h-.2v-.2h-.2v-.4h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2zm-2.7-1.3l.8-.6h.2v.2h.2v.2h.9l.2.2h.4l.2.2h.2l.2.2-.4 1v-.2h-.4l-.2-.2h-.9v-.2h-.4l-.2-.2h-.2l-.2-.2-.2-.2-.2-.2zm-1.2-7.8l.7.7v.3h-.2v.3h-.2v2.2l.2.3v.5l.2.2v.2l.2.3v.2l.2.2v.2l.2.2v.2l.3.2v.2h.2v.3l.2.2-.7.7-.2-.3-.2-.3v-.2l-.2-.2v-.2h-.3v-.3l-.2-.3-.2-.4v-.2l-.2-.3v-.2l-.2-.2v-.6l-.2-.3v-2.1l.2-.3v-.2h.2l.2-.3.2-.3zm.7-5l1-.5v.5l.2.2v.3l.2.2v.7h.2v1.7l-.2.2v.2l-.2.2v.2h-.2v.3h-.2v.2l-.2.2-.3.3h-.2l-.2.3-.8-.6.2-.3h.2l.2-.3.2-.3.2-.2v-.3l.2-.2v-.2l.2-.3v-.7l-.2-.2v-.5l-.2-.2-.2-.4v-.2zm0-3v1l.4-.7v1.4h.2v1.1h.2l-1 .6v-.9h-.2v-.7l-.2-.2v-1l.4-.7zm-.6.5l-.3-.7h.7l-.5.6zm.4.3v-1 1zm0-1z"
          />
          <path
            fill="#edb92e"
            d="M434 226.2c-1.2 1-1.5 1-2 1.6-.3.8 0 2 .3 3.3 1.5 5-1.4 4.4-5 2.6-1.6-1-3.6-3.2-5.2-4.4-1.5-1-2.6-1-3-1.6a118.7 118.7 0 0 1-1-4.3c0-.7-.5-2.4-1-4.4.4-.7 1.4-1 2.5-2.5 1-1.7 2.2-4.7 3.6-6 3-3.2 6-4.5 6 1.3 0 1.4.3 3 1 3.6.6.6 1 .3 2.5 1 1 .6 2 1.3 2.6 2 .7 1 .5 2 .7 2.8 0 1 .5 1.7.2 2.6-.5 1-1 1.7-2 2.4z"
          />
          <path
            fill="#21231e"
            d="M432.6 228l-1-.5h.2v-.4h.4v-.2h.4v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.8.8-.2.2h-.2v.2h-.2l-.2.2-.2.2h-.2v.2h-.4v.2h-.2v.2zm-1-.5zm1 3.4l-.8.3v-.2l-.2-.2v-.7h-.2v-2.3h.2v-.2l1 .4v.2h-.2v2.1h.2v.7zm-5.4 3l.5-.8h.3l.3.3h.3l.3.3h.2l.3.2h.2l.3.2h.7l.2.2h.7v-.2h.2v-.4l.2-.3v-1.1l-.2-.3v-.3l-.2-.4 1-.4v.4l.2.4v.8l.2.3v1.1l-.2.4v.2l-.3.2-.2.2h-.2l-.2.2-.4.2h-1.2l-.3-.2h-.6l-.3-.3-.2-.2h-.3l-.3-.2-.4-.2-.3-.2h-.3zm-5.4-4.3l.6-1 .2.2.3.2.2.3h.2v.3h.3v.3l.3.2.2.2h.2v.3h.3l.2.3.2.3.2.2.3.3h.2v.2l.2.2h.2l.2.2v.2h.3v.2h.2l.2.2.3.2-.5 1-.2-.2h-.2v-.2l-.3-.2h-.2l-.2-.2-.2-.3h-.2l-.2-.2h-.2v-.3h-.3l-.3-.3h-.2v-.3l-.3-.3h-.2l-.2-.3-.3-.3h-.2v-.2h-.3l-.2-.3-.3-.3-.3-.2-.3-.2h-.2zm.6-1zm-4-1l1-.2v-.2h.2v.2h.4l.2.2h.4v.2h.7l.2.2h.2l.2.2.3.2h.2l.2.2-.6 1v-.2h-.3v-.2h-.2l-.2-.2-.2-.2h-.3l-.2-.2h-.2v-.2h-.4l-.2-.2h-.2l-.2-.2h-.2v-.2h-.2v-.3zm.2.3v-.3.3zm-.6-4.2v-1l.5.4v.4l.2.2v1h.2v1.3h.2v1h.2v.5l-1 .2v-.7l-.2-.3v-.7l-.2-.3v-.7h-.2v-.8l-.2-.2v-.6l.4.4zm0-1h.5v.4l-.5-.4zm-.5.6l1-.2v-.2l-.5-.2v1h-.3l-.2-.5zm1-.2zm-1.8-4.5l1 .4v-.2 1.1h.2v1.1l.2.3v.8l.2.2v.9l-1 .2V222l-.2-.2v-.8l-.2-.3v-.7h-.2v-.8l-.2-.2v-.3zm0 .3v-.3.3zm2.4-2.8l1 .5-.2.2-.2.2-.2.3-.2.2-.2.2h-.2v.2h-.2l-.2.2h-.2v.2h-.2v.2h-.2v.2h-.2l-1-.3h.2v-.4h.2v-.2h.4v-.2h.2l.2-.2.2-.2.2-.2h.2v-.2l.2-.2.2-.2v-.2h.2v-.2zm3.7-6.2l.8.7h-.2v.3h-.2v.3l-.3.3v.2l-.2.2v.2h-.2v.3l-.2.3v.4l-.3.2v.2l-.2.2v.2l-.2.2v.2l-.2.2v.3l-.2.3v.2l-.2.2v.2h-.2v.2l-.2.2-.2.2-1-.4.2-.2.2-.3v-.2h.2v-.3l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.3l.2-.2v-.2h.2l.2-.3v-.2l.2-.2v-.3l.2-.2v-.2l.3-.2v-.2l.2-.2.2-.3v-.2l.2-.2h.2v-.3zm6.8 1.8h-1v-1.4l-.2-.4v-.6l-.2-.2v-.4l-.2-.2h-.3v-.2h-1.2l-.3.2-.3.2h-.2l-.3.3-.2.3-.3.2-.2.2-.3.2-.2.2-.3.2-.2.3-.8-.7.3-.3.3-.3.3-.2.2-.3.3-.3.4-.2.3-.2.2-.2h.2l.3-.3h.2l.3-.2h.3l.2-.2h1.2l.3.2.3.3.2.2.2.2.2.3v.6l.2.5v.4l.2.3v1.5zm1 3.3l-.8.8-.2-.2v-.2h-.2v-.2l-.2-.2v-.6l-.2-.2v-.7l-.2-.2V212h1v2h.2v.3l.2.2v.2h.2v.2l.2.2zm0 0zm2.2 1l-.4 1-.3-.2h-.2l-.3-.2h-.4v-.2h-.9v-.2h-.4v-.2h-.2v-.2l.6-.7v.2h.4v.2h.8l.2.2h.4l.2.2h.2l.2.2zm2.8 2.2l-.8.6h-.2v-.2l-.2-.2h-.2v-.4h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2.3-1 .3.2h.2l.2.2.2.2h.2v.2h.2l.2.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2zm-.8.6l.4.5-.3-.5zm1.5 2.3l-1 .2V220l-.2-.2v-.8h-.2v-.4l.7-.6v.2l.2.2v.2l.2.2v2.2h.2v.2zm0 3l-.8-.4v-2.1l-.2-.2v-.4h1v1l.2.2v1.8zm-1.8 2.6l-.7-.8h.2v-.2l.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.2h.2v-.2l1 .4-.2.2v.2l-.2.2v.2h-.2v.4h-.2v.2h-.2v.2l-.2.2-.2.2v.2h-.2l-.2.2-.2.2zm-.7-.8z"
          />
          <path
            fill="#21231e"
            d="M418 222.6l-.2-1a14 14 0 0 0 7.8-5.3c-1.2 3-4.3 5.3-7.7 6.3zm.2 1.5c0 .4.2.7.3 1 3.4 0 6.4 1 9.2 3-2-2.3-5.8-3.8-9.5-4z"
          />
          <path
            fill="#edb92e"
            d="M432.7 233.3a11 11 0 0 1-3.4-1.5c-1.6-1.3-1.2-3.8.3-6.4.4-.8.5-2.2.2-3.5a6.3 6.3 0 0 0-1.4-3.5c-2.4-2.3-3.8-4.8-2.6-6.6.8-1.3 2-2 2.8-2.7.3.6.4 1.5.4 2.5 0 1.4.3 3 1 3.6.6.6 1 .3 2.5 1 1 .7 2 1.3 2.6 2 .7 1 .6 2 .7 2.8 0 1 .5 1.7.2 2.6-.5 1-1 1.7-2 2.4-1.2 1-1.5 1-2 1.6-.3.8 0 2 .3 3.3.3 1 .4 1.7.4 2.3z"
          />
          <path
            fill="#21231e"
            d="M429 232.2l.6-.8h.2v.2h.2l.2.2h.2l.2.2h.2l.2.2h.4v.2h.4l.2.2h.4l.2.2h.2l-.3 1h-.4v-.2h-.4l-.2-.2h-.3v-.2h-.4l-.2-.2h-.2l-.2-.2h-.2v-.2h-.2l-.3-.2h-.2v-.2zm0-7l1 .5v.2h-.2l-.2.4v.2l-.2.2v.2l-.2.3v.4l-.2.2v.5l-.2.2v1.5l.2.3v.2h.2v.3l.2.2.2.2-.6.8-.2-.2-.3-.3v-.2h-.2v-.3l-.2-.2v-.4l-.2-.3V228h.2v-.7l.2-.3.2-.3v-.3l.2-.2v-.3l.3-.3v-.5zm.3-3.3l1-.2v.8h.2v1.9l-.2.2v.7h-.2v.2l-1-.4h.2v-.6h.2V222zm-1.3-3.2l.7-.7v.2h.2v.4h.2v.2l.2.2v.2l.2.2v.2l.2.2v.5h.2v.7l.2.2v.8h-1v-1.2l-.2-.2v-.4h-.2v-.4h-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2zm0 0zm-2.7-7.2l1 .6h-.2v.7l-.2.2v.7l.2.2v.4l.2.2v.2l.2.2v.2l.2.2v.2l.3.2v.2l.2.2.2.2v.2l.3.3.2.3v.2l.3.2.2.2h.2l-.7.8-.2-.2-.2-.2-.3-.2-.2-.2v-.3l-.2-.2-.2-.2-.2-.2-.2-.2v-.2l-.3-.2-.2-.3h-.2v-.3l-.2-.2v-.3l-.2-.2v-.2l-.2-.3v-.4l-.2-.2v-1l.2-.3v-.2l.2-.2v-.2zm3.8-2.5l-.8.4.7.3h-.2l-.2.2h-.2l-.2.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2-.2.2v.2h-.2v.2l-.2.2-1-.6h.2v-.2l.2-.2.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2h.2l.2-.2.2-.2h.2v-.2h.2l.2-.2.2-.2h.2v-.2h1.1zm-.6 0l.5-.5v.6h-.6zm1 2.8h-1v-2.1h-.2v-.4l1-.3v1h.2v2zm1 3.3l-.7.8-.2-.2v-.2h-.2v-.2l-.2-.2v-.7l-.2-.2v-.7l-.2-.2V212h1v1.7h.2v.6l.2.2v.2h.2v.2l.2.2zm2.3 1l-.4 1-.3-.2h-.2l-.3-.2h-.4v-.2h-.9v-.2h-.4v-.2h-.2v-.2l.6-.7v.2h.4v.2h.8l.2.2h.4l.2.2h.2l.2.2zm2.8 2.2l-.8.6h-.2v-.2l-.2-.2h-.2v-.4h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2.3-1 .3.2h.2l.2.2.2.2h.2v.2h.2l.2.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2zm-.8.6l.4.5-.3-.5zm1.5 2.3l-1 .2V220h-.2v-.8h-.2v-.4l.7-.6v.2l.2.2v.2l.2.2v2h.2v.2zm0 3l-.8-.4v-2.2l-.2-.2v-.4h1v1l.2.2v1.8zm-1.8 2.6l-.7-.8h.2v-.2l.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.2h.2v-.4h.2v-.2l1 .4-.2.2v.2l-.2.2v.2l-.2.2v.2h-.2v.2h-.2v.2l-.2.2-.2.2v.2h-.2l-.2.2-.2.2zm-.7-.8zm-1 2.2l-1-.5v-.2h.2v-.2h.2v-.2h.4v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.8.8-.2.2h-.2v.2h-.2l-.2.2-.2.2h-.2l-.2.2h-.2v.2h-.2v.2zm-1-.5zm1 3.4l-1 .3v-.7h-.2v-3h.2l1 .4h-.2v2.6h.2v.2zm-1 .3zm.8 2.5l.3-1-.6.5v-1h-.2v-.9l-.2-.2 1-.5v.9h.2v1h.2v.7l-.7.5zm.7-.5v.7l-.7-.2.7-.5zm-.5 0l-.2.5.2-.5zm.5 0v.7l-.7-.2.7-.5z"
          />
          <path
            fill="#edb92e"
            d="M410.6 216.4c4 0 8 3.4 8.4 7.7.6 4.4-2.2 7.7-6 7.8-4 0-7.5-3-8.3-7.3-.7-4 1.8-8 6-8z"
          />
          <path
            fill="#21231e"
            d="M419.5 224l-1 .2v-.8l-.2-.4v-.3l-.2-.4v-.3l-.2-.4-.2-.3-.2-.3-.2-.4-.2-.3-.2-.3-.3-.2-.2-.3-.3-.3-.2-.2-.3-.3-.3-.2-.3-.2-.4-.2h-.3l-.3-.3h-.4l-.3-.3h-.3l-.4-.2h-.3l-.3-.2h-1.5v-1h1.9l.4.2h.3l.4.3h.4l.4.3.4.2.3.2.5.2.3.3.3.2.4.2.3.3.3.3.3.3.3.4.2.3.2.4.3.4.2.4.2.4.2.4v.4l.2.4v.4l.2.4v.8zm-6.6 8.3v-1h.9l.2-.2h.6l.3-.2h.4l.2-.2.3-.2h.2l.2-.3h.2l.2-.3.3-.3.3-.2v-.2l.3-.3.2-.2v-.3l.3-.3.2-.4v-.3l.2-.3v-.7l.2-.3V224l1-.2v2.5l-.2.4v.8l-.3.4v.3l-.2.3v.4l-.3.3-.2.3-.3.3h-.2l-.2.4-.3.2-.3.3h-.3l-.3.3-.3.2h-.2l-.3.3h-.4l-.2.2h-.4l-.3.2H413zm-8.7-7.7l1-.2v.7l.2.5v.3l.3.4v.3l.3.3.2.4.2.3.2.3.2.3.2.3.3.3.2.3h.3l.2.3.3.3.2.2.3.2.3.2h.4l.3.3.3.2h.3l.3.2h.7l.3.2h1.2v1h-2l-.3-.2h-.4l-.4-.3h-.4l-.4-.3-.3-.2-.4-.2-.3-.2-.4-.2-.4-.2-.3-.3-.2-.2-.2-.2-.3-.3-.2-.3-.3-.3-.2-.4-.2-.3-.2-.3-.2-.4-.2-.3-.2-.4v-.4l-.2-.4-.2-.4v-.8zm6.2-8.7v1h-1l-.3.2h-.4l-.3.2h-.3l-.3.3h-.2l-.2.3-.3.2-.2.2v.2l-.3.2-.2.2-.2.3-.2.3v.2l-.2.3v.4l-.3.3v.6l-.2.3v.7l-.2.3v.7l.2.4v.8l-1 .2v-3.3l.2-.3v-.3l.2-.4v-.3l.3-.4v-.3l.3-.3.2-.3.2-.3.2-.3h.2l.2-.4.3-.2.3-.2.3-.2.3-.2.3-.2.3-.2h.3l.4-.2h.4l.3-.2h.9z"
          />
          <path
            fill="#edb92e"
            d="M411 218.6c2.8-.2 5.7 2.4 6 5.5.5 3.3-1.5 5.8-4.4 5.8-2.8 0-5.5-2.3-6-5.3s1.3-5.8 4.3-6z"
          />
          <path
            fill="#21231e"
            d="M417.6 224l-1 .2v-.6l-.2-.3v-.2l-.2-.3v-.4l-.2-.2v-.2l-.2-.3-.2-.3v-.2l-.3-.2-.2-.2-.2-.3-.2-.2-.2-.2h-.2l-.2-.3h-.2l-.3-.3h-.2l-.2-.2-.4-.2h-.5v-.2h-1.1v-1h1.1l.4.2h.3l.2.2h.2l.3.2h.3l.2.3h.3l.2.2.3.2h.2l.3.3.2.3.2.2.2.2v.2l.3.3h.2v.4l.3.3v.3l.3.2.2.3v.3l.2.3v.8l.2.3zm-5 6.3v-1h1.1l.2-.2h.4l.2-.2h.2v-.2l.3-.2h.3v-.2l.3-.2v-.2h.2l.2-.3v-.2l.2-.2.2-.3v-.7l.2-.2v-1.6h1v2.2l-.2.3v.2l-.2.3v.2l-.3.3-.2.2v.3l-.3.2-.2.2-.2.2-.3.2-.2.2-.2.2h-.2l-.2.2h-.2l-.3.2h-.2l-.2.2h-1.5zm0-1zm-6.5-4.8h1l.2.4.2.4v.2l.2.3.2.3v.3l.3.2.2.2.2.2v.2l.3.2.2.2.3.3.2.2.2.2h.2v.3h.3l.2.2h.7l.2.2h1.1v1H411l-.4-.2h-.2l-.3-.2h-.2l-.2-.3h-.3l-.2-.3-.4-.3-.2-.3-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.3v-.2l-.3-.2-.2-.2-.2-.3v-.3l-.2-.3v-.3l-.2-.2v-.7zm1 0zm4-6.4v1h-.6l-.2.2h-.5l-.2.2h-.2l-.2.2-.2.2h-.2l-.2.3v.2l-.3.2-.2.3v.2h-.2v.3l-.2.2v.2l-.2.2v.7l-.2.2v1.7h-1V222h.2v-.4l.2-.3v-.2l.2-.2v-.2l.3-.3v-.2h.2l.2-.3.2-.2.2-.2.2-.2h.2l.2-.2h.3l.2-.3h.2l.2-.2h.6l.3-.2h.6z"
          />
          <path
            fill="#0c4076"
            d="M411.2 220.7c2 0 3.6 1.5 4 3.5.2 2-1 3.6-3 3.6a4 4 0 0 1-3.7-3.4c-.3-2 1-3.6 2.7-3.7z"
          />
          <path
            fill="#21231e"
            d="M415.6 224l-1 .3v-.4l-.2-.2v-.4h-.2v-.3l-.2-.2-.2-.3-.2-.2-.2-.2h-.2l-.2-.2-.2-.2h-.2l-.2-.2h-.6v-.2h-.6v-1h1l.2.2h.2l.3.2h.3v.2h.3l.2.3v.2h.3l.2.2.2.2.2.3.3.2v.4h.2v.3l.2.3v.4l.2.2zm-3.3 4.3v-1h.7l.2-.2h.4v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.5l.2-.2v-1.1l1-.3v2h-.2v.3l-.2.3-.2.3-.2.2h-.2v.2l-.2.2h-.2v.2h-.3l-.2.2h-.4v.2h-1zm-4.3-3.8l1-.2v.5l.2.3v.4h.2v.2l.2.2.2.2.2.3.2.2.2.2h.3v.2h.4l.3.2h.8v1h-1.3l-.2-.2h-.2l-.3-.2h-.2v-.2h-.2v-.2l-.3-.2-.3-.2v-.2h-.2v-.3h-.3v-.3l-.2-.2v-.2h-.2v-.5l-.2-.2v-.5zm2.7-3.8h1l-.5.5h-.7l-.2.2h-.2v.2h-.2l-.2.2-.2.2-.2.2v.2h-.2v.5h-.2v1.3l-1 .3v-1.8h.2v-.5h.2v-.3h.2v-.3h.3v-.3h.3v-.2h.3v-.2h.3v-.2h1l.2-.2h.4l-.5.5zm1 0v.5h-.5l.5-.5zm0 0h-1l.5-.5.5.5zm-1 0v-.5h.5l-.5.5z"
          />
        </g>
        <path
          fill="#fff"
          d="M482 183c4 0 7 3 7 7s-3 6.7-7 6.7c-3.6 0-6.7-3-6.7-6.8 0-4 3-7 6.8-7z"
        />
        <path
          fill="#21231e"
          d="M489.5 189.8h-1c0-2.3-1.4-4.6-3.5-5.6a6.3 6.3 0 0 0-3-.7v-1c2.6 0 5 1.3 6.4 3.5a7.4 7.4 0 0 1 1 3.8zm-7.4 7.4v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.6-1.5 5.2-3.7 6.5a7.3 7.3 0 0 1-3.7 1zM475 190h1a6.4 6.4 0 0 0 6.3 6.2v1a7.1 7.1 0 0 1-6-3.4 7.4 7.4 0 0 1-1.2-4zm7.3-7.5v1a6.3 6.3 0 0 0-5.5 3.5 6.4 6.4 0 0 0-.7 3h-1c0-2.7 1.4-5 3.5-6.4a7.3 7.3 0 0 1 3.8-1z"
        />
        <path
          fill="#fff"
          d="M482 171c4 0 7 3 7 7a6.8 6.8 0 1 1-13.7-.2c0-3.7 3-6.7 6.8-6.7z"
        />
        <path
          fill="#21231e"
          d="M489.5 178h-1c0-2.4-1.4-4.7-3.6-5.8a6.3 6.3 0 0 0-3-.6v-1c2.6 0 5 1.3 6.4 3.4a7.4 7.4 0 0 1 1 4zm-7.4 7.3v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.5-1.5 5-3.7 6.4a7.3 7.3 0 0 1-3.7 1zM475 178h1a6.4 6.4 0 0 0 6.3 6.3v1a7.1 7.1 0 0 1-6-3.4 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.3 6.3 0 0 0-5.5 3.5 6.4 6.4 0 0 0-.7 3h-1c0-2.6 1.4-5 3.5-6.3a7.3 7.3 0 0 1 3.8-1z"
        />
        <path
          fill="#fff"
          d="M482 159.6c4 0 7 3 7 7a6.8 6.8 0 1 1-13.7-.2c0-3.7 3-6.8 6.8-6.8z"
        />
        <path
          fill="#21231e"
          d="M489.5 166.5h-1c0-2.4-1.4-4.7-3.6-5.7a6.3 6.3 0 0 0-3-.7v-1c2.6 0 5 1.5 6.4 3.6a7.4 7.4 0 0 1 1 4zM482 174v-1c2.5 0 4.7-1.5 5.8-3.6.4-1 .7-2 .7-3h1c0 2.6-1.4 5-3.5 6.4a7.3 7.3 0 0 1-4 1zm-7.2-7.5h1c0 2.4 1.4 4.7 3.6 5.7a6.3 6.3 0 0 0 2.7.7v1a7.2 7.2 0 0 1-6-3.6 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.4 6.4 0 0 0-5.5 3.6 6.4 6.4 0 0 0-.7 3h-1c0-2.6 1.4-5 3.5-6.4a7.3 7.3 0 0 1 3.8-1z"
        />
        <path
          fill="#fff"
          d="M482 127c4 0 7 3.2 7 7s-3 6.8-7 6.8a7 7 0 0 1 .1-13.8z"
        />
        <path
          fill="#21231e"
          d="M489.5 134h-1c0-2.4-1.4-4.7-3.6-5.8a6.3 6.3 0 0 0-3-.6v-1c2.6 0 5 1.3 6.4 3.4a7.4 7.4 0 0 1 1 4zm-7.4 7.3v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.5-1.5 5-3.7 6.3a7.3 7.3 0 0 1-3.7 1zM475 134h1c0 2.3 1.4 4.6 3.5 5.6a6.3 6.3 0 0 0 2.8.7v1a7.3 7.3 0 0 1-6-3.4 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.3 6.3 0 0 0-5.5 3.5 6.4 6.4 0 0 0-.7 3h-1c0-2.6 1.4-5 3.5-6.3a7.3 7.3 0 0 1 3.8-1z"
        />
        <path
          fill="#fff"
          d="M482 137.2c4 0 7 3 7 6.8s-3 7-7 7c-3.6 0-6.7-3.2-6.7-7s3-6.8 6.8-6.8z"
        />
        <path
          fill="#21231e"
          d="M489.5 144h-1c0-2.3-1.4-4.6-3.5-5.7a6.3 6.3 0 0 0-3-.6v-1c2.7 0 5.2 1.4 6.5 3.6a7.4 7.4 0 0 1 1 3.7zm-7.4 7.4v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.6-1.5 5-3.7 6.4a7.3 7.3 0 0 1-3.7 1zM475 144h1c0 2.4 1.4 4.7 3.5 5.7a6.3 6.3 0 0 0 2.8.7v1a7 7 0 0 1-6-3.5 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.4 6.4 0 0 0-5.5 3.6c-.5 1-.7 2-.7 2.8h-1c0-2.5 1.4-5 3.5-6.2a7.3 7.3 0 0 1 3.8-1.2z"
        />
        <path
          fill="#fff"
          d="M482 148.2c4 0 7 3 7 6.8s-3 7-7 7c-3.6 0-6.7-3.2-6.7-7s3-6.8 6.8-6.8z"
        />
        <path
          fill="#21231e"
          d="M489.5 155h-1c0-2.3-1.4-4.6-3.6-5.7a6.3 6.3 0 0 0-3-.6v-1c2.6 0 5 1.3 6.4 3.4a7.4 7.4 0 0 1 1 4zm-7.4 7.4v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.6-1.5 5-3.7 6.4a7.3 7.3 0 0 1-3.7 1zM475 155h1c0 2.4 1.4 4.7 3.5 5.7a6.3 6.3 0 0 0 2.8.7v1a7.3 7.3 0 0 1-6-3.4 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.5 6.5 0 0 0-5.5 3.5 6.4 6.4 0 0 0-.7 3h-1c0-2.5 1.4-5 3.5-6.3a7.3 7.3 0 0 1 3.8-1z"
        />
        <path
          fill="#edb92e"
          d="M487 195.5c1 1.6.7 2 1.4 2.4.8.6 2 .6 3.4.4 5.3-1 4.5 2.3 2.2 6-1 1.7-3.8 3.5-5.2 5-1.4 1.5-1.6 2.8-2 3.2h-9.2c-.5-.4-.7-1.7-2-3.2-1.5-1.5-4.2-3.3-5.3-5-2.4-3.7-3-7 2.2-6 1.3.2 2.6.2 3.4-.5.6-.6.3-1 1.3-2.5a7 7 0 0 1 2.2-2.3c1-.5 1.8-.2 2.6-.2 1 0 2-.3 2.8.2a7 7 0 0 1 2.2 2.3z"
        />
        <path
          fill="#21231e"
          d="M488.7 197.5l-.7.8-.2-.2h-.2v-.4h-.2v-.4h-.2v-.4l-.2-.2v-.2l-.2-.2-.2-.3v-.2l.8-.6v.2h.2v.3l.2.2v.2h.2v.4h.2v.4h.2v.4h.2zm-.7.8l-.3-.3.3.3zm3.8-.4v1h-2.4l-.2-.2h-.2l-.2-.2h-.3l-.2-.2.7-1v.2h.2v.2h.8l.2.2h1.9zm2.6 6.6l-.8-.6.2-.3.2-.3.2-.4.2-.3v-.3l.3-.3v-.2l.2-.2v-.6l.2-.2v-1.3l-.2-.2h-.2v-.2h-.5l-.2-.2h-2l-.2-1h2.8l.3.2h.2l.2.2.2.2.2.2.2.2v.3l.2.3v1.7l-.2.3v.3l-.3.2v.4l-.3.3v.2l-.3.4v.3l-.3.2-.3.4zm-5.3 5.2l-.6-.7.3-.2v-.2h.3l.2-.3v-.2h.3l.2-.2h.2v-.3h.2l.2-.3.2-.2h.2l.2-.3h.2v-.3l.3-.2h.2l.2-.3v-.2l.2-.2.2-.2h.2v-.3h.3v-.4h.3v-.3h.2v-.3l1 .6-.2.2-.2.3v.3l-.2.2h-.2l-.2.3v.2l-.3.2-.3.3v.2h-.3l-.2.3-.2.2h-.2l-.2.3-.2.2-.3.3-.3.3h-.2v.3l-.3.2h-.2v.3l-.3.2h-.2v.3h-.2l-.2.3zm-2.3 3.3v-1l-.3.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2h.2v-.2l.2-.2.2-.3.3-.3.8.6v.2l-.2.2-.2.2-.2.3v.2h-.2v.2l-.2.2v.2l-.2.2v.2h-.2v.4h-.2v.2l-.2.2v.2h-.5zm.3 0h-.2.2zm-5 .2v-1h4.7v1h-4.5zm0-1h.2zm0 0v1-1zm0 0zm-4.7.8l.6-.8h-.4 4.2l.2 1h-4.7l-.3-.2zm.3 0h-.2.2zm-2.4-3.2l.7-.7v.2l.2.2.2.3.2.3.2.2v.2h.2v.4h.2v.4h.2v.4h.2v.4h.2v.2l-.5.8-.2-.2v-.2l-.2-.2v-.2h-.2v-.4h-.2v-.4l-.2-.2v-.2h-.2v-.2l-.2-.3-.2-.2-.2-.3-.2-.2zm-5.4-5.2l1-.6v.2l.2.3h.2v.3l.2.2h.2v.3h.3v.3l.2.2h.2l.2.3.2.2v.2l.3.2h.3l.2.3h.2l.2.2v.2h.2l.2.3h.2l.2.3h.2v.3l.3.2h.2v.3h.3v.3l-.6.8-.2-.2-.3-.3-.3-.2-.3-.2v-.2l-.2-.2h-.2l-.2-.3h-.2l-.2-.2h-.2v-.3l-.3-.2h-.2l-.2-.3v-.2h-.3l-.2-.3v-.2h-.3l-.2-.3v-.2l-.3-.2h-.2v-.3l-.3-.2-.2-.2-.2-.2zm2.7-6.7v1l-.6-.2h-2.1l-.2.2h-.2v.2h-.2v.4l-.2.2v1.1l.2.2v.3l.2.3v.2l.2.3.2.4v.3l.3.3.3.4.2.3.2.3-1 .6v-.4l-.3-.3-.2-.4-.2-.4v-.3l-.3-.4v-.4l-.3-.3v-.4l-.2-.3v-.6l-.2-.3v-1l.2-.2v-.2l.3-.2.2-.2.2-.2.4-.2h.3l.3-.2h2.5zm3-.5l.8.8-.2.2h-.2l-.2.2h-.4l-.2.2h-3v-1h2.5l.2-.2h.4v-.2h.2zm1.4-2.3l.7.6v.3l-.2.2v.2h-.2v.4h-.2v.8h-.2v.2h-.2v.2l-.2.2-.8-.7h.2v-.4h.2v-.4h.2v-.2l.2-.2v-.4h.2v-.3h.2v-.3zm0 0l.2-.4-.3.4zm2.3-2.4l.5.8-.2.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2v.2h-.2v.2l-.2.2-.2.2v.2l-1-.6.2-.2.2-.2v-.2h.2v-.2l.2-.2h.2v-.2l.2-.2.2-.2h.2v-.2l.2-.2h.2v-.2h.2l.2-.2zm2.8-.3v1h-2.4l-.5-.7h.2v-.2h.4l.2-.2h2zm3 .3l-.5.8h-.4v-.2H482v-1h2.5l.2.2h.2l.2.2zm0 0l.3.2-.3-.2zm2 3.2v-1l-.4.8-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2v-.2l.4-.8h.2l.2.2.2.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2h.2v.2l-.4.8zm.4-.8l.5.8h-1l.4-.8zm-.4-.2v1l-.4-.2.4-.8zm-.4.8l-.5-.8h1l-.4.8z"
        />
        <path
          fill="#21231e"
          d="M481.4 212.8l-1-.2c-.4-3.7-2-7-4.3-9.6 2.8 1.8 4.8 5.7 5.4 9.8z"
        />
        <path
          fill="#edb92e"
          d="M494.2 198.3c-.5 1-1 2.4-2 3.5-1.5 1.6-4 .5-6.5-1.6-.8-.6-2.2-1-3.6-1a6 6 0 0 0-3.4 1c-2.5 2-5 3.2-6.6 1.6-1-1-1.5-2.4-2-3.5h2.5c1.3.3 2.6.3 3.4-.4.6-.6.3-1 1.3-2.5a7 7 0 0 1 2.2-2.3c1-.5 1.7-.2 2.6-.2 1 0 2-.3 2.8.2.8.5 1.5 1.3 2.2 2.3 1 1.6.7 2 1.3 2.4 1 .6 2.2.6 3.5.4 1-.2 1.8-.2 2.4 0z"
        />
        <path
          fill="#21231e"
          d="M492.6 202l-.7-.6v-.2l.2-.2.2-.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.3v-.4l1 .5v.4l-.2.2v.2l-.2.2v.4h-.2v.2l-.2.2v.3h-.2v.2h-.2v.2h-.2v.3l-.2.2-.2.2h-.2zm-7.3-1.4l.7-.7h.2l.2.2.3.2.2.2.3.3h.3l.2.2h.2l.2.2h.2l.2.2h.2l.2.2h.4l.2.2h1.6l.2-.2.2-.2h.2v-.2l.8.7-.2.3h-.2v.3h-.3l-.3.2h-.3l-.2.2h-1.9l-.3-.2h-.3l-.2-.2h-.3l-.2-.2h-.3l-.2-.2-.2-.2h-.3l-.2-.3h-.3l-.2-.3-.2-.2-.2-.2-.2-.2-.3-.2zm.7-.7l.5.3-.5-.4zm-4-.2v-1h2v.2h.7v.2h.4l.2.2h.2l.2.2h.2v.2h.2l-.7.8h-.2v-.2h-.2v-.2h-1v-.2h-1v-.2h-1zm-3 .8l-.7-.7v-.2h.2l.2-.2h.2v-.2h.2l.2-.2h.5v-.2h1.2v-.2h1v1h-1.5v.2h-.5l-.2.2h-.4v.2h-.2l-.2.2zm-7.3 1.5l.7-.6.3.2.2.2h.2v.2h1.7v-.2h.5l.2-.2h.2v-.2h.3l.2-.2.2-.2h.3l.2-.3h.2l.2-.3.3-.2v-.2h.3l.7.6-.3.2-.2.2-.3.2-.2.2-.2.2h-.3l-.2.3h-.3l-.2.2h-.2l-.3.2h-.2l-.2.2h-.2l-.2.2h-.3l-.3.2H473l-.4-.2h-.2l-.2-.2-.2-.2-.3-.3zm-1.7-4l.2 1 .3-.7v.2l.2.2v.3l.2.2v.4l.2.2v.2h.2v.4h.2v.4h.2v.2h.2v.2h.2v.2l.2.2-.7.7h-.2v-.2h-.2v-.2h-.2v-.5h-.2v-.2h-.2v-.3l-.2-.2v-.2h-.2v-.4h-.2v-.4l-.2-.2v-.4h-.2l.4-.8zm-.4.7l-.2-.6.6-.2-.4.7zm3-.6l-.2 1-.2-.2H470l-.2-1h2.4zm3-.5l.7.8-.2.2h-.2l-.2.2h-.4l-.2.2h-2.8v-1h2.3l.2-.2h.4v-.2h.2zm.7.8l-.5.4.5-.4zm.6-3l.7.5v.3l-.2.2v.2h-.2v.4h-.2v.8h-.2v.2h-.2v.2l-.2.2-.8-.7h.2v-.4h.2v-.4h.2v-.2l.2-.2v-.4h.2v-.3h.2v-.3zm2.3-2.5l.5.8-.2.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2v.2h-.2v.2l-.2.2-.2.2v.2l-1-.6.2-.2.2-.2v-.2h.2v-.2l.2-.2h.2v-.2l.2-.2.2-.2h.2v-.2l.2-.2h.2v-.2h.2l.2-.2zm2.8-.3v1h-2.3l-.5-.7h.2v-.2h.4l.2-.2h2zm3 .3l-.5.8h-.4v-.2H482v-1h2.5l.2.2h.2l.2.2zm0 0l.3.2-.3-.2zm2.4 2.4l-.8.6-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.2-.2-.2v-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2v-.2l.4-.8h.2l.2.2.2.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2h.2v.2zm1.3 2.3l-.7.8-.2-.2h-.2v-.4h-.2v-.4h-.2v-.4l-.2-.2v-.2l-.2-.2-.2-.3v-.2l.8-.6v.2h.2v.3l.2.2v.2h.2v.4h.2v.4h.2v.4h.2zm-.7.8l-.3-.3.3.3zm3.8-.4v1h-2.4l-.2-.2h-.2l-.2-.2h-.4v-.2h-.2l.7-1v.2h.2v.2h.8l.2.2h1.9zm3 .5l-1-.4.3.8H492l-.2-1h2.4l.5.7zm-.5-.7h.6l-.3.7-.4-.7zm0 .5l.4.2-.5-.2zm0-.5h.6l-.3.7-.4-.7z"
        />
        <path
          fill="#edb92e"
          d="M482 211.7c4.4 0 8 3.4 8 7.7s-3.6 7.8-8 7.8-7.6-3.5-7.6-7.8 3.5-7.8 7.7-7.8z"
        />
        <path
          fill="#21231e"
          d="M483 212.8l.8-.2c.5-3.7 2-7 4.3-9.6a14.7 14.7 0 0 0-5 9.8z"
        />
        <use
          width={1350}
          height={900}
          transform="matrix(-1 0 0 1 964.3 0)"
          xlinkHref="#prefix__b"
        />
        <path
          fill="#edb92e"
          stroke="#21231e"
          d="M577 293.6c2 .3 3 1.5 3 2.8 0 1.3-1 2.6-3 3a8.7 8.7 0 0 1-1.6.2c-60.8 5.2-125.7 5.2-186.5 0a8.7 8.7 0 0 1-1.6-.3c-2-.3-3-1.6-3-3 0-1.2 1-2.4 3-2.7a8.6 8.6 0 0 1 1.5-.3c60.7-5.2 125.6-5.2 186.4 0 .6 0 1 .2 1.5.3z"
        />
        <path
          fill="#21231e"
          d="M412 298.4h-.2v-.2h-.2v-1h.4v-.2.2-.2h2.3l.7-.2h3l.7-.2h3l.7-.2h3l.8-.2h3.3l.7-.2h3.8l.7-.2h.8v1.2h-2.9l-.7.2H428l-.7.2h-2.7l-.8.2H421l.7.2h3.7l.7.2h2.9l.7.2h3.7l.7.2h1.5v1.2h-3.7l-.7-.2h-3.8l-.7-.2h-2.9l-.7-.2H420l-.6-.2h-2.9l-.7-.2H413l-1-.2v-.2.2zm.2-.7zm46.6-2.6v1.3H453l-.7.2h-6.6l-.7.2h-5l-1 .2h-3.5v-1.2h3.5l.8-.2h5.2l.7-.2h5.9l.7-.2h6.8zm23.3 0v1h-13.7l-.7.2h-8.8v-1h1.4l.8-.2H482zm23.5 0v1.3h-11.1l-.7-.2H482v-1h23.6zm23.3 1v1h-5.2l-.8-.2h-5.2l-.7-.2h-6.5l-.8-.2h-4.3V295h.7l.7.2h7.5l.8.2h5l.8.2h5.1l.6.2h2.3zm23.4 1v.2h.4v1h-.2l-.2.2h-3l-.7.2h-2.2l-.7.2h-3.8l-.8.2h-2.8l-.7.2H534l-.8.2h-3.6l-.8.2v-1.2h2.2l.7-.2h3.7l.8-.2h3.7l.7-.2h1.8-1.4l-.8-.2h-2.7l-.7-.2H533l-.6-.2h-3.6V296h6.5l.7.2h3l.8.2h2.8l.7.2h3l.7.2h3l.7.2h1.5zm0 .7zm-116.7.7h.2l.2.2v.8h-.2v.2h-.2v-1.2zm93.3 1.2h-.2l-.2-.2v-.2h-.2v-.8h.2v-.2h.4v1.2zm-50.3-36.2v-1h3.8v1h-4zm0-1zm-1.2 0h1.2v1h-1.2v-1zm0 1zm-.6-1h.6v1h-.6v-1zm-1 0h1v1h-1v-1zm0 0zm-.8 0h.6v1h-.7v-1zm0 1zm-.5-1h.4v1h-.5v-1zm0 0zm-.8 0h.8v1h-.8v-1zm0 0zm-1.2 0h1.2v1h-1.2v-1zm-1 0h1v1h-1v-1zm0 0zm-.2 0h.2v1h-.2v-1zm-1 0h1v1h-1v-1zm-2.5 1v-1h2.6v1h-2.5zm0-1zm-.3 0h.2v1h-.2v-1zm0 1zm-.2-1h.2v1h-.2v-1zm0 0zm-1 0h1v1h-1v-1zm0 1zm-.5-1h.4v1h-.4v-1zm0 0zm-.4 0h.4v1h-.4v-1zm0 1zm-1.2-1h1.2v1h-1.2v-1zm0 0zm0 0v1-1zm0 1h-.2.2zm-1.2-1h1.2v1l-1.2.2v-1zm-.4 0h.4v1.2h-.4v-1zm-.8.2h.8v1h-.8v-1zm0 0h.3-.2zm-.3 0h.3v1h-.3v-1zm0 1h-.5.5zm-1-1h1v1h-1v-1zm-1 0h1v1h-1v-1zm0 0zm-.2 0v1-1zm0 1zm-1-1h1v1h-1v-1zm-.6 0h.5v1h-.4v-1zm0 0zm0 0v1-1zm0 1zm-4.2.2v-1h3.5v-.2h.4v1h-2.7l-.2.2h-.8zm0-1zm-.6 0h.5v1h-.6v-1zm0 0zm-1.7 0h1.6v1h-1.7v-1zm0 1zm-.2-1h.3v1h-.2v-1zm0 0zm-1.3 0h1.4v1h-1.3v-1zm-1 0h1v1h-1v-1zm-.6 0h.7v1h-.6v-1zm0 0zm0 0v1.2-1zm0 1.2zm-1.6-1h1.5v1h-1.5v-1zm0 1zm0-1v1-1zm0 0zm-1.2 0h1.2v1h-1.2v-1zm0 0zm0 0v1-1zm0 1zm-1.2-1h1l.2 1H444v-1zm-.8 0h.8v1h-.7v-1zm0 0zm-1.6.2h1.6v1h-1.5v-1zm0 1zm0-1v1-1zm0 0zm-6.2 1.3v-1h1.7l.2-.2h3.9v1H436l-.2.2zm0 0zm-.4-1h.3v1h-.2v-1zm0 0zm-9 1.4v-1h1.3l.3-.2h3.2l.3-.2h3.5v1h-5.1l-.3.2H426zm0 0zm-.3-1h.2v1h-.3v-1zm0 0zm-.5 0h.5v1h-.4v-1zm-18.2 2.2v-1h1.8l.5-.2h1.7l.5-.2h2.4l.6-.2h2.6l.6-.2h2.2l.6-.2h2.8l.6-.2h1.2v1h-2.1l-.6.2h-2.7l-.6.2h-2.3l-.6.2h-2.8l-.6.2h-2.2l-.5.2H408l-.6.2h-.6zm0 0zm-.3-1h.3v1h-.2v-1zm0 0zm0 0v1-1zm0 1zm-26.3 2.4v-1h.7l1-.2h.8l.8-.2h1.6l.8-.2h1l.7-.2h1.6l.8-.2h1.8l.8-.2h.8l1-.2h1.7l.7-.2h1.7l.8-.2h1.8l.7-.2h1.6l1-.2h1.5l1-.2v1H405l-.7.2h-1.7l-.8.2H400l-.7.2h-.8l-1 .2H396l-.8.2h-1.7l-.8.2H391l-.8.2h-.8l-.8.2H387l-1 .2h-.7l-.8.2H383l-1 .2h-.8l-.8.2zm0 0zm0-7v1h-.5l-.5.2h-.5l-.3.2-.4.2-.3.2h-.2l-.3.3-.2.2-.3.3v.5l-.2.2v1.1h.2v.3l.2.2.2.2.3.3.3.2h.2l.3.2h.3l.4.2h1v1h-1.6l-.4-.2-.4-.2-.3-.2-.3-.2-.3-.2-.4-.2-.2-.3-.2-.2v-.3l-.3-.3-.2-.3v-1.6l.2-.3.2-.3.2-.4.2-.3.2-.3.4-.3.3-.2.4-.2.3-.2h.4l.5-.2h.6l.5-.2zm0 1zm26.3-3.3v1H405l-.7.2h-1.7l-.8.2H400l-.7.2H396l-.8.2h-1l-.7.2H392l-1 .2h-1.6l-.8.2h-.8l-.8.2h-1.7l-.8.2h-.8l-.8.2H381l-.8.2v-1h1.7l.8-.2h.8l.8-.2h.8l.8-.2h1.7l.8-.2h1.6l1-.2h.8l.8-.2h1.8l.7-.2h1.7l1-.2h.7l.8-.2h1.8l.7-.2h1.6l1-.2h2.5zm0 1zm0 0v-1 1zm0-1zm37-2.2v1.2H439l-1 .2h-2.3l-1.3.2H431l-1.2.2h-2.2l-1.3.2H424l-1.2.2h-2.3l-1 .2H417l-1.2.2h-1.2l-1 .2h-2.3l-1.3.2h-1l-1.2.2h-1.2v-1h2.2l1.2-.2h1l1.2-.2h2.2l1.3-.2h1l1.2-.2h2.3l1-.2h2.3l1.3-.2h2.4l1.2-.2h2.3l1-.2h3.5l1.2-.2h3.5l1-.2h2.5zm1 1l-1 .2v-1h1v1zm0 0zm.2 0h-.3v-1l.2 1zm-.2-1zm.4 1h-.3l-.2-1h.4v1zm1.2 0h-1.2v-1h1.2v1zm0 0zm0 0v-1 1zm0-1zm15.4-.4v1h-5.5l-.5.2h-6.5l-.4.2h-2.6v-1h5l.5-.2h7.7l.5-.2h1.8zm.8 1h-.8v-1h.8v1zm0 0zm0 0v-1 1zm0-1zm1.4 1h-1.4v-1h1.4v1zm0 0zm.2 0h-.2v-1h.2v1zm0 0h-.2.2zm0 0v-1 1zm0-1zm1.2 1h-1.2v-1h1.2v1zm.5 0h-.6v-1h.4v1zm-.2-1zm.8 1h-.7l-.2-1h.8v1zm1 0h-1v-1h1v1zm0 0zm.2 0h-.3v-1h.2v1zm0-1zm.4 1h-.4v-1h.4v1zm3-1l.2 1H468v-1h3.3zm1.2 1h-1v-1l1-.2v1zm0 0v-1.2 1zm0-1.2zm1.3 1h-1.2v-1h1.2v1zm3.5-1v1h-3.5v-1h3.5zm0 0zm0 1v-1 1zm0 0zm1.3 0h-1.2v-1h1.2v1zm3.6-1v1h-3.5v-1h3.7zm3.8 0v1H482v-1h3.8zm1 1h-1v-1h1.2v1zm.2 0zm0 0v-1 1zm0-1zm3.6 0v1H487v-1h4zm1 1h-1v-1h1.2v1zm.2-1zm0 1v-1 1zm1 0h-1v-1h1v1zm3.3-1v1H493v-1h3zm.5 1h-.4v-1h.5v1zm0-1zm.3 1h-.3v-1h.3v1zm0 0zm1 0h-1v-1h1v1zm.6 0h-.7v-1h.8v1zm0-1zm.5 1.2h-.6v-1h.5v1zm1 0h-1v-1h1v1zm0-1zm0 1v-1 1zm0 0h.3-.2zm.3 0h-.2v-1h.3v1zm0 0zm1.3 0h-1.3v-1h1.4v1zm0-1zm0 1v-1 1zm0 0h.2zm1 0h-1v-1h1v1zm15.2-.6v1h-6l-.4-.2H504l-.6-.2h-.9v-1h6l.4.2h6.6l.4.2h1.7zm0 0zm0 1v-1 1zm0 0zm1.3 0h-1v-1h1v1zm.4 0h-.3v-1h.5v1zm0-1zm.2 1h-.2v-1h.2v1zm0 0zm1 .2h-1v-1h1v1zm37 1v1h-2.3l-1.2-.2h-1l-1.2-.2h-2.2l-1.3-.2H546l-1-.2h-1.3l-1-.2h-2.3l-1.3-.2H537l-1-.2h-4l-1-.2h-2.6l-1-.2H524l-1-.2h-2.4v-1h4.7l1.2.2h3.3l1.3.2h2.3l1.3.2h2.3l1 .2h2.4l1 .2h2.3l1.3.2h2.3l1 .2h2.3l1.2.2h1.2l1 .2h1.3l1 .2h1.3zm0 0zm0 1v-1 1zm0 0zm26.4 1.4v1H582l-.8-.2h-.8l-.8-.2H578l-.7-.2h-.8l-.8-.2H574l-.8-.2h-.8l-.8-.2h-1.8l-.7-.2h-1.5l-.8-.2H565l-.8-.2h-1.7l-.8-.2H560l-.8-.2h-1.6v-1h3.5l.8.2h1.6l1 .2h1.7l.7.2h1.7l.8.2h1.8l.7.2h.8l.8.2h1.8l.8.2h.8l.8.2h1.8l.7.2h.7l.8.2h1.8l.7.2zm0 1zm0 6v-1h1.6l.3-.2h.3l.3-.2.2-.2.2-.2h.2v-.3l.2-.2v-.2h.2v-1.4l-.2-.3v-.2h-.3l-.2-.3-.3-.2h-.2l-.3-.3-.4-.2h-.4l-.4-.2h-.4l-.5-.2v-1h.5l.6.2h.5l.5.3.4.3.4.2.3.2.4.3.3.3.2.3v.3l.3.2v.3l.2.3v1.3l-.3.3v.3l-.3.3-.3.4-.3.2-.3.2-.2.2-.3.2-.4.2h-.3l-.4.2H584zm0 0zm-26.5-2.4v-1h1.8l.8.2h1.8l.8.2h1.8l.7.2h1.7l1 .2h.7l.8.2h1.8l.7.2h1.6l.8.2h1l.8.2h1.6l.8.2h1l.7.2h1.5l.8.2h1l.7.2v1h-1l-.8-.2h-1.6l-.8-.2h-.8l-.8-.2h-1.7l-.8-.2h-.8l-1-.2h-1.6l-.8-.2h-.8l-1-.2h-1.4l-.8-.2H566l-.7-.2h-1.6l-1-.2H561l-1-.2h-1.6l-.8-.2zm0 0zm0-1v1-1zm0 0zm-.2 0h.3v1h-.4v-1zm0 1zM539 265v-1h2.9l.5.2h3l.5.2h2.3l.6.2h2.2l.6.2h2.3l.5.2h2.4l.5.2v1h-1.7l-.5-.2h-2.3l-.6-.2H550l-.7-.2H547l-.6-.2h-2.9l-.6-.2H540l-.6-.2h-.6zm-.4-1h.5v1h-.4v-1zm0 0zm-.2 0h.2v1h-.2v-1zm0 1zm-9.2-.5v-1h4l.3.2h3.2l.3.2h1.3v1h-1.6l-.3-.2H533l-.4-.2h-3.3zm0-1zm-.3 0h.2v1h-.3v-1zm0 1zm-6.4-.3v-1h4.5l.2.2h1.7v1h-4.4l-.2-.2h-1.7zm0-1zm0 0v1-1zm0 1zm-1.5-1h1.7v1H521v-1zm0 0zm-.7 0h.8v1h-.7v-1zm-1-.2h1v1H519l.2-1zm-.2 1zm0-1h.2v1-1zm0 0zm-1 0h1v1h-1v-1zm0 0zm-.2 0v1-1zm0 1zm-1.4-1h1.4v1h-1.4v-1zm0 1zm-.2-1h.2v1h-.2v-1zm0 0zm-.6 0h.6v1h-.7v-1zm-1 0h1v1h-1v-1zm-1.4-.2h1.4v1h-1.4v-1zm0 0zm-.2 0h.2v1h-.2v-1zm0 1zm-1.6-1h1.6v1h-1.6v-1zm0 0zm-.6 0h.6v1h-.6v-1zm-4.2 1v-1.2h3.3l.2.2h.8v1h-4.3zm0 0zm0-1.2v1-1zm0 0zm-.5 0h.6v1h-.5v-1zm-1 0h1v1h-1v-1zm0 1zm0-1v1-1zm0 0zm-1.3 0h1.2v1h-1.3v-1zm-1 0h1v1h-1v-1zm0 1h.6-.6zm-.2-1h.3v1h-.3v-1zm0 0h-.3.3zm-.8 0h.8v1h-.8v-1zm-.4 0h.4v1h-.4v-1zm-1.2 0h1.3v1H500v-1zm0 1h.2zm0-1v1-1zm0 0zm-1 0h1v1h-1v-1zm0 1zm-.5-1h.4v1h-.6v-1zm0 0zm-.4 0h.5v1h-.4v-1zm0 1zm-1-1h1v1h-1v-1zm0 0zm-.2 0h.2v1h-.2v-1zm0 1zm-.3-1h.3v1h-.3v-1zm0 0zm-2.6.8v-1h2.3v1H494zm-1-1h1v1h-1v-1zm-.2 0h.2v1h-.2v-1zm0 0zm-1 0h1v1h-1v-1zm-1.2 0h1.2v1h-1.3v-1zm0 0zm-.8 0h.8v1h-.8v-1zm0 0zm-.4 0h.4v1h-.5v-1zm0 1zm-.7-1h.7v1h-.7v-1zm0 0zm-1 0h1v1h-1v-1zm-.7 0h.6v1h-.6v-1zm0 1zm-1.2-1h1.2v1H486v-1zm0 0zm-3.7 1v-1h3.9v1h-4.1zm.4 1.8L460 276.6l-.4-1 22.7-11.3h.4v1zm-.5-1h.4-.5zm22.7 12.4l-23-11.4.4-1 22.7 11.5v1h-.3zm.4-1l1 .6-1 .4v-1zm-23 11.6l22.7-11.5.4 1-22.6 11.4h-.5v-.8zm.4 1h-.3.4zM460 275.7l22.8 11.5-.5 1-22.8-11.6v-1h.4zm-.4 1l-1-.5 1-.5v1z"
        />
        <path
          fill="#0c4076"
          d="M482 269c5.8 0 10.4 3.2 10.4 7s-4.6 7-10.3 7-10-3.2-10-7 4.5-7 10-7z"
        />
        <path
          fill="#21231e"
          d="M493 276h-1v-.3l-.2-.3v-.5l-.2-.3v-.3l-.3-.3-.2-.4v-.3l-.3-.2-.2-.2-.2-.3-.3-.2-.3-.3-.3-.2-.3-.2-.2-.2-.4-.2-.4-.2-.3-.2-.4-.2h-.5l-.4-.3h-.4l-.5-.2h-.8l-.5-.2h-1.9v-1.2h1.7l.6.2h.5l.5.2h.5l.5.2h.4l.5.3.4.2.5.2h.5l.4.3.3.2.4.2.3.3.4.3.3.2.3.3.3.3.2.4.3.3.2.4.2.4.2.4v.3l.2.5v.4l.2.2v.8zm-11 7.4v-1h1.6l.5-.2h1.1l.5-.2h.5l.4-.3h.4l.5-.3h.4l.3-.3h.4l.4-.3.3-.2.4-.3.3-.2.3-.2.3-.3.2-.3.2-.2.3-.3v-.3l.3-.3h.2v-.4l.2-.3v-.7l.2-.3v-.3h1v.4l-.2.4v.4l-.2.4v.3l-.2.3-.2.3-.2.4-.2.3-.3.3-.2.3-.3.2-.3.3-.3.3-.4.3-.3.3-.4.2-.4.3-.5.2-.4.2-.4.2h-.4l-.5.3h-.4l-.5.3h-.5l-.5.2h-1.1l-.5.2H482zm-10.6-7.4h1v1l.2.3v.3l.2.2.2.3v.4l.3.3.2.3.3.2.2.3.3.3.3.2.3.2.2.3.3.2.4.2h.2l.4.3h.4l.4.3h.5l.3.3h.9l.5.2h1.5l.6.2h.5v1h-1.9l-.5-.2h-.5l-.5-.2-.5-.2h-.4l-.5-.3h-.4l-.4-.3-.4-.2-.4-.2-.4-.3-.4-.2-.3-.2-.4-.2-.4-.3-.3-.3-.3-.3-.2-.4-.3-.3-.2-.3-.2-.4v-.3l-.2-.4-.2-.4v-.8l-.2-.4v-.4zm10.7-7.4v1h-1.3l-.5.2h-.3l-.5.2h-.5l-.4.2h-.4l-.6.3h-.4l-.4.3-.4.2-.3.2-.5.2-.3.2-.3.2-.4.2-.3.3-.3.2-.2.3-.3.3-.2.3-.2.3v.3l-.2.2v.3l-.2.3v.7l-.2.3v.3h-1V275l.2-.5.2-.4v-.2l.3-.4.3-.3.2-.3.3-.3.2-.3.3-.2.3-.3.3-.2.3-.3.3-.3.4-.2.4-.2.4-.2h.4l.4-.3.5-.2.5-.2h.5l.5-.2h1l.5-.2h1.1l.6-.2h.5z"
        />
        <path
          fill="#edb92e"
          d="M482 211.7c4.4 0 8 3.4 8 7.7s-3.6 7.8-8 7.8-7.6-3.5-7.6-7.8 3.5-7.8 7.7-7.8z"
        />
        <path
          fill="#21231e"
          d="M490.4 219.4h-1v-1l-.2-.3v-.4l-.2-.3v-.4l-.2-.4v-.3l-.3-.3-.2-.3-.2-.3v-.3l-.3-.2-.2-.3-.2-.2-.3-.2-.3-.2-.2-.2-.3-.2-.3-.2-.4-.2h-.3l-.3-.3h-.4l-.3-.2h-.4l-.4-.2H482V211l.6.2h1.2l.4.2h.4l.4.2.3.2.4.2h.4l.4.3.3.3.4.2.4.2.3.3.3.3.2.3.3.2.2.3.3.3.2.3.2.5.2.3v.4l.3.4v.8l.2.4v.8l.2.4v.4zm-8.3 8.3v-1h1.5l.3-.2h.3l.3-.2.4-.2h.3l.3-.2h.3l.2-.3.3-.2.2-.2.3-.2.3-.2.2-.3.2-.2.2-.2v-.3l.3-.3.2-.3.2-.4v-.3l.2-.4v-.7l.2-.4v-.8l.2-.4v-.4h1v1.2l-.2.4v.5l-.2.4v.3l-.3.4v.3l-.3.4-.2.3-.2.4-.3.4-.2.3-.3.3-.2.3-.3.3-.3.2-.3.3-.3.3-.3.2-.3.2-.3.2h-.4l-.3.2-.4.2h-.4l-.4.2H482zm-8-8.3h1v1.8l.2.3.2.3v.3l.2.3.2.3.2.2.2.3.2.3.2.3.2.3.2.3.3.2.2.3.3.3.3.2.4.2h.3l.3.3h.3l.4.3h.3l.3.2h.7l.4.2h.7v1h-1.6l-.4-.2h-.3l-.4-.3h-.4l-.4-.3-.4-.3-.3-.2-.5-.2-.3-.2-.3-.2-.4-.2-.3-.3-.3-.3-.2-.3-.3-.3-.2-.3-.2-.3v-.3l-.3-.4v-.3l-.3-.4v-.4l-.2-.5v-.4l-.2-.3v-1.4zm8-8.3v1.2h-1.3l-.4.2h-.3l-.3.2h-.4l-.3.3h-.3l-.3.2-.3.2-.2.2-.3.2-.2.3-.3.3-.2.2-.2.3-.2.3-.2.4-.2.3-.2.3-.2.3v.3l-.2.3-.2.3v.7l-.2.3v1.1h-1v-1.6l.2-.4v-.4l.2-.4.2-.4v-.4l.3-.3v-.4l.3-.2.2-.3.3-.3.2-.3.3-.4.3-.3.3-.3.2-.2.3-.2.4-.3.2-.2h.4l.3-.2.3-.2h.4l.4-.2h.5l.4-.2h1.1z"
        />
        <path
          fill="#edb92e"
          d="M482 213.7c3.3 0 5.8 2.6 5.8 5.7 0 3.2-2.5 5.8-5.7 5.8-3 0-5.5-2.6-5.5-5.8 0-3 2.5-5.7 5.6-5.7z"
        />
        <path
          fill="#21231e"
          d="M488.3 219.4h-1V218h-.2v-.7l-.2-.2v-.2l-.2-.3-.2-.2v-.2l-.3-.2-.2-.2-.2-.2-.2-.2h-.2l-.2-.3h-.4l-.2-.3h-.2l-.3-.2h-.6l-.2-.2H482v-1h1.8l.3.2h.3l.2.2h.3l.3.3h.4l.2.3h.2l.3.3.3.2.2.2.2.2.2.3v.2l.3.3v.2l.3.3v.2l.2.3.2.3v.6l.2.2v1.3zm-6.2 6.3v-1h1.1l.2-.2h.3l.2-.2h.2l.2-.2h.4l.2-.2.2-.2h.2l.2-.3.2-.2h.2v-.2l.3-.2v-.2l.3-.3.2-.3v-.2l.2-.3v-.2l.2-.3v-1.3h1v2l-.2.3-.2.3-.2.4-.2.3v.2l-.3.2v.2l-.3.2-.2.3h-.2l-.2.3h-.2l-.2.3-.3.2h-.2l-.2.3-.3.2h-.2l-.3.2h-.3l-.3.2h-1.4zm-6-6.3h1v1.3l.2.3v.2l.2.3v.2l.2.2.2.4.2.2v.2h.3l.2.3.2.3v.2h.3l.2.3h.3l.2.2h.2v.2h.4l.2.2h.2l.3.2h.9v1h-1.5l-.3-.2h-.3l-.3-.2h-.2l-.3-.3-.3-.2-.3-.2-.3-.2h-.2l-.2-.3h-.2l-.2-.4-.2-.2-.2-.2-.2-.3-.2-.3v-.3l-.2-.3h-.2v-.4l-.2-.3v-.6l-.2-.3v-.9zm6-6.2v1H481l-.2.2h-.4l-.3.2-.3.3h-.5l-.2.3h-.2v.3l-.3.2h-.2l-.2.3v.3l-.2.2v.2l-.2.3v.2l-.2.2v.2l-.2.3v.4l-.2.2v.7h-1V218l.2-.4v-.3l.2-.3.2-.3v-.2l.2-.3.2-.2.2-.3.2-.2.2-.3.2-.2.2-.2.2-.2.2-.2h.3l.2-.3h.2l.3-.2h.2l.3-.2h.3l.3-.2h.5l.3-.2h.6z"
        />
        <path
          fill="#0c4076"
          d="M482 215.8c2 0 3.7 1.6 3.7 3.6S484 223 482 223c-1.8 0-3.4-1.6-3.4-3.6s1.6-3.6 3.5-3.6z"
        />
        <path
          fill="#21231e"
          d="M486.2 219.4h-1v-.8h-.2v-.3l-.2-.2v-.2l-.2-.2-.2-.2-.2-.3h-.2l-.3-.2h-.2l-.2-.2h-.2v-.2H482v-1h1.4v.2h.5v.2h.3v.2h.3v.3h.3v.2l.2.2.2.3.2.3v.2l.2.2.2.3v.4l.2.2v.6zm-4 4.2v-1h.6v-.2h.5l.3-.2h.2l.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.4h.2v-1h1v1l-.2.2v.2l-.2.2v.2l-.2.2-.2.3-.2.2-.2.2-.3.2-.3.3h-.3l-.3.2-.3.2h-1l-.3.2zm-4-4.2h1v1.3l.2.2v.2l.2.2.2.2.2.2.2.2.2.2h.2v.2h.4l.2.2h.8v1.2h-.7l-.2-.2h-.3v-.2h-.5l-.2-.2-.3-.3h-.2v-.2l-.2-.2h-.2v-.2l-.2-.3-.2-.3v-.2l-.2-.2-.2-.3v-1.4zm4-4v1h-1l-.2.2h-.2l-.2.2h-.2v.2h-.2l-.2.3-.2.2-.2.2-.2.3v.4h-.2v1h-1V218l.2-.2.2-.3v-.2l.2-.2.2-.2.3-.3.2-.2.2-.2h.2l.2-.2h.2l.2-.2h.3l.3-.2h.9z"
        />
      </g>
      <path
        fill="#c6363c"
        d="M314.6 301.2v271.3c0 48.5 18.8 92.6 49.2 124.6A162.9 162.9 0 0 0 482 749a163 163 0 0 0 118.5-51.7c30.4-32 49.2-76 49.2-124.5V301.2h-335z"
      />
      <path
        fill="#fff"
        d="M313.4 300v277l.2 4.6.3 4.5.3 4.6.5 4.4.5 4.5.7 4.3.8 4.4 1 4.3 1 4.2 1 4.3 1.2 4.2 1.3 4 1.4 4.2 1.4 4 1.7 4 1.6 4 1.8 4 2 3.8 1.8 3.8 2 3.7 2 3.7 2.2 3.6 2.2 3.6 2.4 3.5 2.4 3.6 2.4 3.4 2.6 3.3 2.6 3.2 2.7 3.2 2.8 3 3 3.2 1.6-1.7-2.8-3-2.7-3-2.6-3.3-2.5-3.2-2.7-3.3-2.4-3.3-2.5-3.4-2.2-3.5-2.3-3.5-2-3.6-2-3.6-2-3.7-2-4-1.8-3.7-1.7-3.8-1.6-4-1.7-4-1.4-4-1.5-4-1.2-4-1.2-4.2-1-4-1-4.3-.8-4.3-.8-4.3-.7-4.3-.6-4.2-.4-4.5-.4-4.4-.2-4.5-.2-4.5V302.5h332.7V577l-.2 4.5-.3 4.4-.3 4.3-.5 4.5-.6 4.3-.7 4.4-1 4.3-.8 4.3-1 4.2-1 4-1.2 4.3-1.3 4-1.3 4-1.4 4-1.6 4-1.6 4-1.7 3.8-1.7 3.8-2 4-2 3.6-2 3.6-2 3.6-2.3 3.5-2.3 3.5-2.3 3.4-2.5 3.3-2.6 3.3-2.6 3.2-2.6 3.2-2.7 3-2.8 3-3 3-2.8 3-3 2.7-3 2.6-3.3 2.6-3 2.6-3.4 2.4-3.3 2.5-3.3 2.3-3.4 2.2-3.5 2.2-3.5 2-3.5 2-3.6 2-3.7 1.7-3.7 1.8-3.8 1.7-3.8 1.5-3.8 1.4-4 1.3-3.8 1.3-4 1-4 1-4 1-4 1-4.2.6-4 .6-4.3.5-4 .4-4.3.4-4.3.2H482v2.4h4.5l4.3-.2 4.3-.3 4.4-.4 4.2-.4 4.2-.6 4.2-.8 4-.8 4.2-1 4-1 4-1.2 4-1.2 4-1.4 4-1.4 3.8-1.6 3.7-1.6 3.8-1.7 3.7-2 3.7-1.8 3.5-2 3.5-2 3.6-2.3 3.4-2.2 3.4-2.4 3.3-2.5 3.3-2.4 3.2-2.6 3.2-2.7 3-2.7 3-2.8 3-3 3-3 2.8-3 2.8-3 2.7-3.3 2.6-3.2 2.5-3.3 2.5-3.4 2.4-3.5 2.3-3.4 2.3-3.6 2-3.6 2.2-3.7 2-3.7 2-3.8 1.7-4 1.8-3.8 1.6-4 1.6-4 1.4-4 1.4-4 1.3-4.2 1.2-4.2 1-4.3 1-4.2 1-4.3.7-4.4.7-4.3.5-4.5.5-4.4.4-4.5.3-4.4V577l.2-4.5V300z"
      />
      <g fill="#fff" stroke="#21231e">
        <path d="M483.7 734.8c1.4-.2 4 0 5.7-1.4 2.5-2 1.5-9.8 1.3-14.8-1-25.3-2.2-68-3.5-128-2-.2-3.6 0-5 .2a12 12 0 0 0-5 0c-1.4 59.8-2.5 102.5-3.6 127.8-.2 5-1.2 13 1.3 14.8 1.7 1.5 4.2 1 5.6 1.4h3z" />
        <path d="M499.6 734c-1.5 0-4 .5-6-.8-2.6-1.7-2.8-9.7-3-14.7a6148 6148 0 0 0-7.6-127.6c2-.6 3.6-.6 5-.5.3 0 .5 0 .7-.2 9.6 59.2 13.2 101.2 19.7 126.5 1 3.5 2.8 12.2-.2 15-1.7 1.7-4.2 1.6-5.6 2l-3 .3z" />
        <path d="M518.2 731.4c-1.5 0-3.8.8-6-.3-2.7-1.4-2.6-9.4-3.8-14.2-6.6-25.3-10.2-67.3-19.7-126.5 2-.7 3.6-.8 5-1h.2c15 57.6 19.6 98.2 31.4 123.2 1 3.5 4 12.7 1.2 16-1.5 1.7-4 1.8-5.4 2.3l-3 .6z" />
        <path d="M537 726c-1.5.3-4 1.6-6 .7-3-1.2-3.5-9.7-5.6-14.2-11.8-25-16.3-66-31.7-124 2-.8 3.5-1 5-1.3 1.3-.6 1-1 3-1.2 18 57.3 23.7 97 40.5 121.8 2.7 4 4.7 12 3 14.5-1.5 2-4 2.3-5.3 3l-3 .8zm-72.2 8c1.4 0 3.8.5 5.8-.8 2.7-1.7 3-9.7 3-14.7a7227 7227 0 0 1 7.7-127.6c-2-.6-3.6-.6-5-.5a25.4 25.4 0 0 0-.7-.2c-9.6 59.2-13.2 101.2-19.7 126.5-1 3.5-3 12.2 0 15 1.8 1.7 4.3 1.6 5.7 2l3 .3z" />
        <path d="M446 731.4c1.6 0 4 .8 6-.3 2.8-1.4 2.7-9.4 4-14.2 6.4-25.3 10-67.3 19.6-126.5-2-.7-3.6-.8-5-1h-.3c-15 57.6-19.6 98.2-31.4 123.2-1.2 3.5-4.2 12.7-1.3 16 1.5 1.7 4 1.8 5.4 2.3l3 .6z" />
        <path d="M427.3 726c1.5.3 4 1.6 6 .7 3-1.2 3.5-9.7 5.6-14.2 11.7-25 16.2-66 31.6-124-2-.8-3.5-1-5-1.3-1.3-.6-1-1-3-1.2-18 57.3-23.7 97-40.5 121.8-2.6 4-4.6 12-2.8 14.5 1.4 2 4 2.3 5.2 3l3 .8zm99.7-43c-1.3 0-3.3 1-5.4 0-2.8-1.4-4.6-9-6-14-12-23.5-23-65.3-40.8-123.4 1.8-.7 3-1 4.5-1 1-.5 2.4-1 4.3-1.2 19.3 57.5 28 99 46.7 122 3 3.8 5.4 12 4 14.4-1.2 1.8-3.4 2-4.6 2.6l-2.7.6z" />
        <path d="M512 685.8c-1.5 0-3.6.6-5.6-.5-2.6-1.6-3.5-9.4-4.5-14.3-5-25-13.7-67-26.3-126 1.8-.7 3.2-.8 4.5-.8 1.2-.4 2.6-.8 4.5-.8 15 58.7 18.3 102.6 32.4 125 2.6 4.2 4 12.5 2.3 14.8-1.3 1.7-3.5 1.7-4.8 2.2l-2.7.4z" />
        <path d="M496.4 687.6c-1.4-.2-3.5.3-5.4-1-2.4-1.7-2.4-9.6-2.8-14.6-2-25.3-6-68-11.6-127.6 2-.5 3.3-.4 4.6-.3 1.2-.2 2.6-.5 4.5-.4 8 59.6 12.8 102.8 18 127.2 1 5 2.4 12.6.4 14.8-1.4 1.5-3.6 1.4-5 1.8l-2.6.2z" />
        <path d="M437.2 682.8c1.4 0 3.4 1 5.5 0 2.8-1.4 4.6-9 6-14 12-23.5 23-65.3 40.8-123.4-1.8-.7-3-1-4.5-1-1-.5-2.4-1-4.3-1.2-19.3 57.5-28 99-46.7 122-3 3.8-5.4 12-4 14.4 1.2 1.8 3.4 2 4.6 2.6l2.6.6z" />
        <path d="M452.4 685.8c1.4 0 3.5.6 5.5-.5 2.5-1.6 3.4-9.4 4.4-14.3 4.8-25 13.6-67 26.2-126-1.8-.7-3.2-.8-4.5-.8a12 12 0 0 0-4.4-.8c-15 58.7-18.3 102.6-32.4 125-2.5 4.2-4 12.5-2.2 14.8 1.3 1.7 3.5 1.7 4.7 2.2l2.7.4z" />
        <path d="M468 687.6c1.3-.2 3.4.3 5.3-1 2.4-1.7 2.4-9.6 2.8-14.6 2-25.3 6-68 11.7-127.6-2-.5-3.3-.4-4.6-.3-1-.2-2.5-.5-4.4-.4-8 59.6-12.8 102.8-18 127.2-1 5-2.4 12.6-.4 14.8 1.5 1.5 3.7 1.4 5 1.8l2.7.2z" />
        <path d="M483.5 688c1.3 0 3.5.2 5.2-1.3 2.3-2 1.4-9.8 1.2-14.8-1.2-25.4-2-68-3.3-128a14 14 0 0 0-4.6 0c-1.2-.2-2.5-.3-4.4 0-1.2 60-2 102.6-3.2 128-.2 5-1 12.8 1.2 14.7 1.6 1.5 4 1 5.2 1.4h2.7z" />
        <path d="M516.5 648c-1 0-2.5 1-4 0-2.3-1.5-3.7-9.2-4.8-14-9.2-23.5-17.5-65.4-31.2-123.5 1.4-.7 2.4-1 3.4-1 .8-.5 1.8-1 3.3-1 14.7 57.4 21.3 99 35.7 121.8 2.4 3.8 4 12 3 14.5-.8 1.8-2.5 2-3.4 2.5l-2 .7z" />
        <path d="M505 651c-1 0-2.7.6-4.3-.6-2-1.5-2.7-9.4-3.4-14.3-3.7-25-10.5-67-20-126 1.3-.6 2.3-.7 3.4-.7 1-.4 2-.7 3.4-.8 11.5 58.7 14 102.6 25 125.2 2 4 3 12.4 1.6 14.6-1 1.7-2.7 1.8-3.6 2.2l-2 .5z" />
        <path d="M493 652.7c-1 0-2.6.4-4-1-2-1.7-2-9.6-2.2-14.5-1.5-25.4-4.5-68-9-127.7 1.5-.4 2.6-.4 3.6-.3 1-.3 2-.6 3.5-.4 6 59.6 9.7 102.7 13.6 127 .7 5 2 12.8.4 15-1.2 1.5-3 1.4-4 1.7l-2 .2z" />
        <path d="M447.8 648c1 0 2.5 1 4 0 2.3-1.5 3.7-9.2 4.8-14 9.2-23.5 17.5-65.4 31-123.5-1.2-.7-2.2-1-3.2-1-1-.5-2-1-3.4-1-14.7 57.4-21.3 99-35.7 121.8-2.4 3.8-4.2 12-3 14.5.8 1.8 2.5 2 3.4 2.5l2 .7z" />
        <path d="M459.4 651c1 0 2.6.6 4-.6 2.2-1.5 3-9.4 3.6-14.3 3.7-25 10.5-67 20-126a7.7 7.7 0 0 0-3.4-.7c-1-.4-2-.7-3.4-.8-11.4 58.7-14 102.6-24.8 125.2-2 4-3 12.4-1.7 14.6 1 1.7 2.7 1.8 3.6 2.2l2 .5z" />
        <path d="M471.3 652.7c1 0 2.6.4 4-1 2-1.7 2-9.6 2.2-14.5 1.5-25.4 4.5-68 9-127.7a9.5 9.5 0 0 0-3.6-.3c-1-.3-2-.6-3.6-.4-6.2 59.6-9.8 102.7-13.7 127-.7 5-2 12.8-.4 15 1.2 1.5 3 1.4 4 1.7l2 .2z" />
        <path d="M483.2 653.2c1-.2 2.7 0 4-1.4 1.7-2 1-9.7 1-14.7-1-25.3-1.6-68-2.5-128-1.5-.2-2.6 0-3.6.2-.8-.2-2-.4-3.4 0-1 59.8-1.6 102.5-2.4 128 0 5-.8 12.7 1 14.6 1.2 1.5 3 1.2 4 1.4h2z" />
        <path d="M475 559c-.2 4.4-.3 9-.3 14l-10.6 2.3c0 4.8 12 55.4 18 55.4 6.3 0 18.2-50.6 18.2-55.5l-10.6-2v-.2c0-5 0-9.6-.2-14-2.2 2-4.7 5.2-7.3 8-2.4-2.8-5-6-7-8z" />
      </g>
      <g id="prefix__d">
        <path
          fill="#edb92e"
          stroke="#21231e"
          d="M412 584.5c-3 .2-7 2-18.5 12-5 10.2-10 20.5-17 29.4-2.4 1.4-4.2 2.5-6 3.2a84 84 0 0 1-17-.5c-4.4-4-11.3-1.2-9 3.2-1.8 1.6 2.2 7.8 5.3 5.2 3-2.4 13-.2 16.4-1.4-1.3 3-10.4 5-16.8 5.5-5.8.2-5.4 6-3 10.5 2.7 1.8.5-.4 1.4.8 2.6 4 8.2 3.4 8.4-.4.2-4 13.8-9 15.8-12-2.5 6-8.2 11.5-11 17.3-3 3-5 3.7-1 10 4.4-.6 4.6-1.7 7.3.8 6-.6 7-2.4 6-7.2-1-5 3.2-14 4.6-16.6 1.2-2.4 1.5-4.8 2.8-6.3 2.2-2.5 12.6-7.7 15.2-6.3 5 2.7 8.7 1 9.3-3.7-1.6-1.2-.4-8-3.8-8.2-2.8-.3-4.4.6-7 2.7-4 3.2-6 5-7.4 4.6-3-.7 5.8-5 13.8-15.6 11-14.5 11.8-22 11.3-27z"
        />
        <use
          width={1350}
          height={900}
          transform="matrix(-1 0 0 1 801.6 0)"
          xlinkHref="#prefix__c"
        />
        <path
          fill="#edb92e"
          stroke="#21231e"
          d="M345.2 634.5c-4-2.3-6.3-2.2-8-.5-.7 1-1.8.5-1.2-1 2.7-6.3 7-7 10.7-4.2l2.8 2.7c-.6 1-3.8 2.3-4.3 3zm57.4-5.6c4.3-3 8.3-3.6 10.5-2 1.3 1 2.5.3 1.4-1.2-4.4-6.2-9.6-6.5-13.5-3-1.2 1-2 2-2.8 3 1.3 1.6 4.3 3.2 4.4 3zM369 664.4c.2-.2-1-5.4-2.6-7-1.4 1-3 2-4.3 3.5-4.2 4.5-4 11 2.5 16.7 1.6 1.5 2.4 0 1.7-1.7-1-2.7.3-6.3 3-11.5zM352.6 651c-4 1.6-5.4 3.7-5.2 6.4 0 1.5-1 2-1.5.3-4.8-11.2.2-13.3 7.5-13 .4 2-.7 6.2-.8 6.2z"
        />
        <path
          fill="#21231e"
          d="M384 621.3l1 .6h-.2v1.8h.2v.4h.2v.2h.2l.2.3.3.2v.2h.4l.2.3h.2l-.6 1h-.2l-.3-.2h-.2l-.2-.2-.2-.2-.3-.3-.3-.3v-.2h-.2v-.3l-.2-.2v-.2h-.2v-.2l-.2-.2V622l.2-.3v-.2zm6.5.8l-.8 1-.2-.2-.3-.2-.2-.2-.2-.2h-.3l-.2-.3-.2-.3-.3-.2-.2-.2-.3-.2h-.7l-.2-.2h-.7v.2h-.2l-.2.2v.2h-.2v.3l-.2.2-1-.7v-.3l.2-.2.2-.2.2-.2.3-.3h.3l.2-.2h.4v-.2h.8l.2.2h.4l.2.2h.2l.2.2h.2l.2.3h.2l.2.3h.2l.3.3.2.3.2.2.3.2.2.2h.3z"
        />
        <path
          fill="#21231e"
          d="M387.3 617.6l1 .6v.4h-.2v.8l.2.2v.2l.2.2v.2l.2.2.2.3.3.2h.2l.2.2h.2l.2.2.2.2h.2l-.6 1h-.2l-.3-.2-.3-.3h-.2l-.2-.2-.2-.2-.2-.3v-.2h-.2l-.2-.2v-.2h-.2v-.5h-.2V618h.2v-.3zm6.5.8l-.7 1-.2-.3h-.2l-.2-.3-.3-.2-.3-.3h-.2l-.2-.3-.2-.2-.3-.2-.3-.2h-.3v-.2h-.8l-.2.2-.2.2-.2.2v.2l-.3.2-1-.6.2-.3v-.2h.3v-.3h.3l.3-.3h.2l.2-.2h.2v-.2h1.4l.2.2h.2v.2h.3l.3.3h.2l.2.2h.2l.2.3h.2l.3.3v.2l.3.2.3.2.2.2z"
        />
        <path
          fill="#21231e"
          d="M391 612.8l1 .6-.2.2v.6h-.2v1l.2.3v.3h.2v.4h.2l.2.3v.2h.2l.2.2.2.2.3.3.3.2h.2l.2.2-.6 1-.3-.2-.2-.2-.2-.2-.3-.2-.2-.2v-.2l-.3-.2v-.2l-.3-.2v-.2l-.3-.2v-.4l-.2-.3v-.2h-.2v-.7h-.2v-1l.2-.3v-.4l.2-.3v-.2zm7 1l-.8 1-.3-.3-.3-.2-.3-.3-.3-.2v-.2l-.3-.2-.3-.2-.2-.2-.2-.2-.2-.2h-.2l-.2-.2-.3-.2h-.2l-.2-.2h-.7l-.2.2-.2.2-.3.3v.2h-.2v.4l-1-.6v-.3l.2-.2.2-.3v-.2l.3-.2.2-.2v-.2h.3l.2-.2h.3l.2-.2h1.2l.2.2h.2l.2.2.3.2h.3l.2.3.2.2h.3l.2.3.3.2.2.2.3.2.2.2.3.2.2.3.3.2z"
        />
        <path
          fill="#21231e"
          d="M394.8 607.7l1 .5v.5l-.2.3v1.7l.2.2v.3l.2.2v.2l.2.2.3.3v.2l.3.2.2.2h.2l.2.3.2.2.3.2v.2l-.6.8-.3-.2v-.2l-.4-.2-.2-.3-.3-.3v-.2l-.3-.3-.2-.2v-.2l-.3-.3v-.2l-.3-.2-.2-.2v-.2l-.2-.2v-.3l-.2-.3v-2.1l.2-.2v-.2l.2-.3zm7.6 1.3l-1 .8-.2-.3-.3-.3-.3-.2-.3-.3-.3-.3v-.2l-.4-.2-.2-.2-.2-.2-.2-.2-.2-.2h-.2l-.2-.2h-.2l-.2-.2h-.3v-.2h-.7v.2l-.3.2-.2.3-.2.2v.2l-.3.2v.2l-1.2-.5.2-.3.2-.3v-.2l.3-.3.2-.2.2-.2.3-.2.3-.2h.5l.3-.2h.8l.3.2h.2l.3.2h.2l.2.3.3.3.2.2.3.2.2.2h.3l.2.3.3.3.2.2.3.3.3.4.3.3.4.3z"
        />
        <path
          fill="#21231e"
          d="M399 602.6l1.2.6v.2l-.2.2-.2.3v2.1l.2.2v.2l.2.2.2.2v.2l.2.2.2.2.2.2v.2l.3.2.2.2.2.2.3.2.2.2.3.2-.8 1-.3-.3-.2-.3-.3-.2-.3-.3-.2-.2-.3-.2-.2-.3v-.2l-.3-.2-.2-.2v-.2l-.3-.2v-.3h-.2v-.4l-.2-.2v-.2l-.2-.3v-2.6l.2-.2v-.2l.2-.2v-.2zm7.7 1.4l-1 .8-.2-.3-.3-.3-.2-.3-.3-.3-.3-.3-.2-.2-.2-.3-.3-.3-.2-.2h-.2l-.2-.3-.2-.2h-.2v-.2h-1.3l-.3.2v.2h-.2v.3l-.3.2-.2.3v.2l-1.2-.6.3-.3.2-.3.2-.2.2-.3v-.2l.4-.2h.2l.2-.2h.2l.2-.2h1.7l.2.2.2.2h.2l.2.3h.3l.3.3.2.3h.3l.2.3.3.3.2.2.3.3.3.4.4.3.3.3z"
        />
        <path
          fill="#fff"
          stroke="#21231e"
          d="M462.6 580.6l-9.5-5.4c-4 3-6.8 13.5 0 22.2 8.5 11 12 18.7 14 27.5 6.2-8 8.3-16.3 4.4-24.5-5.3-11-8.7-17-8.8-20z"
        />
        <path
          fill="#fff"
          stroke="#21231e"
          d="M470.4 573l-9.5-5.4c-4 3-12.5 13.2-5.6 22 8.5 10.8 17.3 19 19.4 27.7 6.2-8 8.8-16.2 5-24.4-5.4-11-9.4-17.2-9.4-20z"
        />
        <path
          fill="#fff"
          stroke="#21231e"
          d="M449.4 569.2l-9.5-5.4c-4 3-7 13.5-.2 22.2a65 65 0 0 1 14 27.5c6.2-8 8.4-16.3 4.4-24.4-5.3-11-8.7-17-8.8-19.8z"
        />
        <path
          fill="#fff"
          d="M405.5 469c.2 8.7-1.4 66.5-1.8 74.7-.5 8.2-4 13.7-8 17-3.5-5-5.6-11.5-6-19.3-.4-4 .4-58.7.7-70 6.4-17 11.2-17.8 15-2.4z"
        />
        <path
          fill="#21231e"
          d="M404 543.8h-1l.2-1v-2.6l.2-1.7v-4l.2-2.3v-5l.2-2.7v-2.8l.2-3v-3l.2-3v-6.2l.2-3v-6.2l.2-3v-5.8l.2-2.7v-7.4l.2-2V469h1v11.7l-.2 2.5v8.3l-.2 2.8v6l-.2 3.2v3l-.2 3.2v6l-.2 3v3l-.2 2.8v5.3l-.2 2.5v2.3l-.2 2v3.6l-.2 1.5v2zm-8.7 17l.8-.5h-.6l.3-.4.4-.4.4-.3.4-.3.3-.4.5-.4.3-.3.3-.5.4-.4.4-.4.3-.4.4-.5.3-.4.2-.5.2-.5.3-.5.3-.5.2-.6.2-.5.3-.6.2-.5.2-.5v-.7l.3-.6v-.6l.3-.7v-.7l.2-.7v-.7l.2-.8v-1.5h1v2.3l-.2.7v.8l-.3.6v.8l-.3.7-.2.6-.2.8-.2.6-.2.6-.2.6-.3.6-.4.5-.2.6-.3.5-.2.5-.3.5-.3.5-.3.5-.4.4-.4.5-.3.4-.5.5-.3.4-.4.3-.3.4-.4.3-.2.4-.4.3-.4.3h-.7zm.7.2l-.4.3-.3-.4h.7zm-7-19.5h1v.6l.2.8v1.4l.2.7v.6l.2.7v.6l.3.6v1.5l.3.5v.7l.3.6.2.6.2.6.2.6.2.5.2.7.2.6.2.5.3.6.2.5.3.4.2.6.3.5.3.5.3.5.2.4.3.4.3.5.3.3-.7.6-.3-.6-.4-.4-.3-.5-.3-.5-.3-.5-.3-.6-.2-.6-.3-.5-.4-.7-.2-.5-.3-.6v-.6l-.3-.5-.3-.5-.2-.6-.2-.7-.2-.6v-.7l-.3-.6-.2-.6v-.7l-.3-.5v-.7l-.2-.7-.2-.6v-.6l-.2-.7v-1l-.2-.8v-1.5zm1-70.2l.8.3v8l-.2 2.3V492l-.2 2.7v11.6l-.2 3v19l-.2 2.2v11h-1v-20.9l.2-2.7v-14.6l.2-2.8V489l.2-2.6v-8.9l.2-2v-4.2zm0 0zm16-2.3h-1l-.4-1.3-.3-1.3-.4-1-.5-1.2-.4-1-.2-1-.4-.7-.4-.8-.4-.6-.4-.4-.4-.4-.4-.3-.3-.3h-.3l-.4-.2h-.7l-.4.3-.4.3-.5.5-.5.4-.5.5-.5.7-.5.7-.5.8-.5 1-.6 1-.5 1.2-.6 1.3-.6 1.3-.6 1.5-.6 1.6-1-.3.7-1.6.6-1.5.7-1.3.6-1.4.5-1.2.6-1 .5-1 .5-1 .5-.8.6-.7.5-.7.6-.6.6-.4.5-.4.6-.3.5-.2h1.1l.5.3.5.3.5.5.5.5.4.6.4.6.5.8.4.8.4 1 .5 1 .3 1 .4 1.4.4 1.3.4 1.4zm0 0z"
        />
        <path
          fill="#fff"
          d="M368 454.8l-2.6 79.6c-.8 7 8.4 49 13.5 57.4 12.3-5.3 15-33.8 12.6-61.6-2.4-27.8.4-51.8 2.3-56.8 0-6.3-1-12.8-1-19.3-8 .5-17.2.4-25 .8z"
        />
        <path
          fill="#21231e"
          d="M365 534.4l2.4-79.6h1l-2.5 79.6h-1zm1 0zm12.7 57l.3.8-.6-.2-.5-1-.6-1-.5-1.2-.7-1.4-.5-1.6-.6-1.6-.6-1.8-.6-2-.5-2-.6-2-.7-2.2-.6-2.2-.6-2.3-.4-2.3-.6-2.3-.5-2.3-.6-2.3-.6-2.3-.4-2.2-.5-2.2-.4-2.2-.3-2-.4-2.2-.3-2-.3-1.8-.3-1.7-.2-1.6v-1.4l-.3-1.3v-2.8h1v4.1l.2 1.5.2 1.6.3 1.7.3 1.8.3 2 .4 2 .4 2.2.5 2.2.4 2.2.4 2.3.5 2.2.4 2.3.6 2.3.5 2.4.6 2.3.7 2.2.5 2.2.6 2 .6 2.2.6 2 .6 2 .5 1.7.7 1.5.6 1.5.5 1.4.5 1.2.5 1 .5 1-.6-.3zm.3.8l-.4.2-.2-.4.6.2zm12-62h1l.3 2.5v2.7l.3 2.6v2.6l.2 2.6v12.5l-.3 2.4-.2 2.5-.2 2.3v2.3l-.4 2.3-.4 2.2-.3 2-.6 2-.4 2-.6 2-.5 1.7-.8 1.7-.6 1.5-.7 1.5-1 1.5-.7 1.3-1 1.2-1 1-1 1-1 1-1 .6-1.3.6-.3-1 1-.4 1-.7 1-.7 1-1 1-1 .7-1 .8-1.3.8-1.4.7-1.5.6-1.5.6-1.6.5-2 .5-1.7.5-2 .4-2 .3-2 .3-2 .3-2.3v-2.3l.4-2.3V558l.3-2.3V538l-.2-2.6-.2-2.6-.2-2.6zm2.4-56.8h1v.2l-.2.5-.2.7-.2.7-.2 1-.2.8-.2 1-.2 1.2v1.2l-.3 1.3-.2 1.3-.2 1.4v1.6l-.3 1.6v1.7l-.3 1.7v2l-.2 1.8v2l-.2 2V520l.2 2.5.2 2.5.2 2.6v2.5l-1 .2v-2.6l-.3-2.5-.2-2.5V520l-.2-2.5v-20.1l.2-2v-2l.3-2v-1.7l.2-1.7.2-1.8.2-1.6v-1.4l.3-1.5.2-1.3v-1.2l.3-1V477l.3-1 .2-.8.2-.7.2-.7.2-.5zm1 0v.2-.2zm-1.5-18.8v-1l.4.4v3.7l.2.6v2.5l.2.6v1.8l.2.6v2.4l.2.6v3.6l.2.6v2.4h-1V468l-.2-.5V465l-.2-.5v-1.9l-.2-.6v-1.7l-.2-.6v-3l-.2-.6V454l.5.6zm0-1h.4v.4l-.5-.4zm-24.6 1.2h-1l.4-.5h3.9l.8-.2h12.8l.8-.2h4.7l.8-.2h1.7v1h-4.1l-.7.2h-8l-.8.2h-7.1l-.8.2h-3.9l.4-.4zm-1 0v-.4h.4l-.4.4zm.5 0h.4-.5zm-.6 0v-.4h.4l-.4.4z"
        />
        <path
          fill="#fff"
          d="M353 468l1.8 79.5c-.4 7 11 48.5 16.4 56.5 12.6-9.8 10-49.8 8.2-62-4-24-3.2-52-2-56.5 0-6.3-.2-13.8-.6-20.4-8 1-15.8 2-23.7 2.8z"
        />
        <path
          fill="#21231e"
          d="M354.3 547.5l-1.7-79.6 1-.2 1.7 79.6h-1zm1 0zm15.6 56l.5 1-.7-.2-.5-1-.6-1-.6-1.2-.5-1.2-.7-1.6-.6-1.6-.7-1.8-.7-1.8-.7-2-.5-2-.7-2.2-.7-2.2-.6-2.2-.7-2.3-.7-2.2-.7-2.3-.6-2.3-.6-2.3-.5-2.3-.6-2.2-.6-2.2-.5-2-.6-2-.4-2-.4-2-.4-1.6-.3-1.6-.3-1.3-.2-1.3v-1.2l-.2-1v-.8h1v1.8l.2 1 .2 1.3.2 1.5.2 1.5.3 1.7.4 2 .4 1.8.4 2 .5 2 .6 2.2.4 2.2.6 2.3.7 2.3.6 2.3.7 2.2.6 2.3.7 2.3.7 2.3.7 2.2.7 2 .7 2.2.8 2 .7 1.8.6 1.7.8 1.7.6 1.4.6 1.3.6 1.2.5 1 .6.7h-.7zm.5 1l-.4.2-.2-.4h.7zM379 542l1-.2v1.2l.2 1.4.2 1.5.2 1.8.2 1.7v2l.3 2 .2 2v2l.2 2.3v12l-.2 2.4v2.3l-.3 2.4-.4 2.4-.3 2.4-.3 2.2-.4 2.2-.5 2.2-.4 2-.6 2-.7 2-.8 1.6-.8 1.7-1 1.5-1 1.3-1 1.4-1.2 1-.6-.8 1-1 1-1 1-1.4.8-1.4.8-1.6.8-1.7.6-1.8.6-2 .5-2 .6-2 .4-2.2.4-2.3.3-2.3.2-2.4v-2.3l.3-2.4V569l.2-2.2V560l-.2-2.3v-2.2l-.2-2v-2l-.2-2-.2-1.6-.2-1.8-.2-1.5v-1.3l-.3-1.2zm-2-56.7h1v.6l-.2.7-.2.7v1l-.2.8v2.4l-.2 1.3v2.8l-.2 1.6v15.2l.2 2v2.3l.3 2v2.4l.3 2.3v2.2l.3 2.2.4 2.3.2 2.4.3 2.2.2 2.3.3 2.2.4 2.3-1 .2-.5-2.3-.3-2.4-.3-2.3-.4-2.3-.2-2.4-.2-2.3-.2-2.3-.2-2.3-.2-2.2v-2.3l-.3-2.2V512l-.2-2v-16l.2-1.4v-1.3l.2-1.2v-2l.3-1v-.8l.2-.6v-.7.2zm1 0zm-1.2-20v-1l.5.6v3.4l.2.7v3.8l.2.6v6l.2.6v5.3h-1V480l-.2-.7v-5.7l-.2-.6v-4.5l-.2-.7v-2.4l.4.4zm0-1h.4v.6l-.5-.4zm-23.7 4v-1l.8-.2h.8l.7-.2h2.2l.7-.2h.8l.7-.2h.8l.7-.2h1.4l.7-.2h.8l.7-.2h.6l.8-.2h1.7l.6-.2h.7l.8-.2h.8l.7-.2h1.5l.8-.2h.7l.7-.2h.8l.7-.2v1h-.6l-.6.2h-.8l-.7.2h-1.6l-.7.2h-.8l-.8.2h-.8l-.7.2h-1.5l-.7.2h-.8l-.7.2h-.7l-.8.2H362l-.7.2h-.7l-.8.2h-.7l-.6.2H357l-1 .2h-.6l-.7.2h-.8l-.8.2zm.2 0zm0-1v1l-.6-.6.5-.6zm-.6.4v-.6h.5l-.4.5z"
        />
        <path
          fill="#fff"
          d="M342.2 486.7l21-.5c-2 8.6-.5 35.6 3.2 56.2 3.3 19.3 8 69.3-12 81.3-12.5-26.4-3-52-9.2-75-5-24.3-6-44.6-3-62z"
        />
        <path
          fill="#21231e"
          d="M363 486.7l-20.8.5v-1l21-.5.4.6-.5.4zm0-1h.7v.6l-.6-.6zm3.8 56.6l-1 .2-.3-2-.3-2-.3-2-.4-2-.3-2-.2-2-.2-2.2-.2-2-.2-2.2-.2-2-.2-2-.2-2-.2-2.2v-2l-.3-2v-2l-.2-2V499l-.2-1.7v-4.5l.2-1.4v-1.2l.2-1.2v-1l.3-1v-1l1 .3v.8l-.2 1v1l-.2 1.3v5.4l-.2 1.6v4.9l.2 1.8v4l.2 1.8v2l.3 2v2l.3 2 .2 2v2l.3 2.2.3 2 .2 2.2.3 2 .3 2 .3 2 .3 2.2.2 2 .3 2 .3 2zM354 624l.8-.6-.7-.2 2-1.2 1.5-1.4 1.5-1.6 1.4-1.8 1.3-2 1-2 1-2.3 1-2.6 1-2.5.6-2.8.6-2.7.4-2.8.4-3 .4-3 .3-3 .2-3v-3l.2-3v-6.2l-.2-3-.2-3v-3l-.4-3-.2-2.7-.3-2.7-.2-2.5-.4-2.5-.2-2.4-.3-2.2-.3-2-.3-2h.8l.4 1.8.3 2 .3 2.3.3 2.3.4 2.5.3 2.7.3 2.7.2 2.8.2 3 .2 2.8.2 3v15.5l-.3 3-.3 3.2-.4 3-.4 2.8-.5 3-.8 2.7-.7 2.7-.8 2.6-1 2.4-1 2.4-1.2 2.2-1.3 2-1.4 2-1.6 1.5-1.7 1.5-1.8 1.3h-.7zm.7 0l-.5.4-.3-.5h.7zm-10-75.2l1-.2.5 2.2.4 2.2.4 2.2.3 2.2.3 2.2.2 2.3v2l.2 2.4v25.4l.2 2.4v2.4l.3 2.4.3 2.4.3 2.4.5 2.4.4 2.4.5 2.4.7 2.5.7 2.4.8 2.5 1 2.5 1 2.4-.8.5-1.2-2.6-1-2.5-.8-2.6-.8-2.5-.7-2.5-.5-2.5-.5-2.4-.4-2.5-.2-2.3-.3-2.5-.2-2.4V594l-.2-2.4V564l-.2-2.3-.2-2.3-.2-2.2-.4-2.2-.3-2-.5-2.3-.5-2v-.2zm0 0zm-2.5-62.6v1l.5-.4-.3 1.6-.2 1.7-.2 1.7-.2 1.7-.2 1.7v1.8l-.3 1.8v3.5l-.2 2v7.3l.2 2v1.8l.2 2v2l.2 2 .2 2 .2 2 .2 2 .3 2 .2 2 .3 2.3.3 2 .3 2.2.4 2.2.4 2.2.4 2 .4 2.4.4 2.2-1 .2-.4-2.2-.4-2.3-.4-2.2-.4-2-.3-2.3-.4-2.2-.3-2-.3-2.2-.2-2-.3-2.2-.2-2-.2-2-.2-2v-2l-.2-2v-2l-.2-1.8v-13l.2-1.8v-1.8l.2-1.7.2-1.7.2-1.7.2-1.7.2-1.7.3-1.7.5-.4zm-.5.4v-.4h.5l-.5.4zm.5 0v-.4.5zm-.5 0v-.4h.5l-.5.4z"
        />
        <path
          fill="#fff"
          d="M422 454.4c0 8.7-3.2 66.5-4 74.6-.7 8-4.5 13.6-8.4 16.6-3.4-5-5.3-11.5-5.5-19.3 0-4 2.3-58.7 3-70 7-17 11.8-17.4 15-2z"
        />
        <path
          fill="#21231e"
          d="M418.5 529h-1v-1l.2-1v-1.5l.2-1.7v-2l.2-2v-2.3l.3-2.4v-2.5l.3-2.7.2-2.8v-3l.3-3 .2-3 .2-3v-3l.3-3.2.2-3 .2-3.2v-3l.3-3V474l.3-3v-2.5l.2-2.4V464l.2-2v-2l.2-1.8v-3.7h1v5.6l-.2 2v2l-.2 2.3v2.6l-.3 2.6-.2 2.7v2.8l-.3 3-.2 3v3l-.3 3-.2 3v3.2l-.3 3-.2 3.2-.2 3v3l-.2 2.7-.2 2.6v2.6l-.3 2.4v2.3l-.3 2v2l-.2 1.5v1.5l-.2 1.2v1zm-9.3 17l.8-.6-.7-.2.4-.2.3-.3.4-.4.3-.3.4-.3.4-.4.4-.3.3-.4.4-.4.4-.4.3-.5.4-.4.3-.6.3-.4.3-.5.3-.5.3-.5v-.5l.4-.6.2-.5.3-.7v-.6l.3-.6.2-.5.2-.7.2-.6V532l.3-.8v-.8l.2-.7v-.7h1v1.6l-.2.7-.2.7v.7l-.2.7-.2.7-.2.8-.2.6-.2.6-.2.6-.3.6-.2.6-.3.6-.3.5-.2.5-.3.5-.3.5-.5.5-.3.5-.3.4-.4.4-.4.4-.3.4-.5.4-.4.4-.2.4-.4.3-.4.4-.3.4-.4.3-.4.3h-.8zm.7 0l-.5.4-.3-.5h.7zm-6.4-19.7h1v2.8l.2.8v.7l.2.7v1.2l.3.6v.8l.2.6.2.7v.7l.3.6v.6l.3.5.2.6.2.6.2.6v.6l.3.5.3.6.2.4.2.5.3.5.3.5.2.5.3.4.4.4.3.5.3.4-.8.5-.3-.6-.4-.4-.3-.5-.3-.6-.3-.6-.3-.5-.3-.6v-.6l-.4-.5-.2-.6-.2-.6-.2-.4-.2-.6-.2-.6-.2-.6-.2-.6-.2-.7-.2-.6v-.7l-.3-.7v-.6l-.2-.7v-.6l-.2-.7v-1.4l-.2-.7v-1.5l-.2-.7v-1.5zm3-70l.8.3v-.2 2.6l-.2 1.6v2l-.2 2v2l-.2 2.4v2.5l-.2 2.6v2.8l-.3 2.8v2.8l-.2 3v2.8l-.2 3v3l-.2 2.8v3l-.3 2.7v2.7l-.2 2.7v7.3l-.2 2v3.8l-.2 1.6v3.3h-1v-6.8l.2-2V513l.2-2.4V508l.2-2.6.2-2.8v-2.8l.2-3V494l.2-3 .2-2.8v-3l.2-2.8v-3l.3-2.7V474l.2-2.5V469l.2-2.4v-4.2l.2-1.8V459l.2-1.5v-1.2zm-.2 0zm16.2-2h-1v.2l-.3-1.4-.3-1.2-.3-1.2-.4-1-.3-1-.4-1-.3-1-.4-.6-.5-.6-.4-.5-.2-.5-.4-.4h-.4l-.3-.2h-1.1l-.4.2-.5.2-.4.4-.5.5-.5.6-.6.7-.5.7-.5 1-.6.8-.5 1-.6 1.2-.7 1.2-.6 1.4-.6 1.4-.6 1.6-1-.4.7-1.6.8-1.4.6-1.4.6-1.2.6-1.2.6-1 .6-1 .6-1 .6-.7.5-.7.6-.6.6-.6.6-.4.5-.3h.6l.5-.3h1.2l.5.3.5.4.5.4.4.5.4.6.4.5.4.8.3 1 .4.8.3 1.2.3 1 .4 1.3.3 1.4.3 1.3zm0 0zm-.5 0h.6-.5zm.6 0z"
        />
        <path
          fill="#fff"
          d="M385 407.2c-.6 18.7-1 59-.8 62.6a51 51 0 0 0 6.7 22.6c4-3 7.7-8.5 8.4-16.6.6-6.7.8-39.5 1-56-4.3-2.6-8.7-6-12.2-9.7l-3.2-2.8z"
        />
        <path
          fill="#21231e"
          d="M384.7 469.8h-1v-23.4l.2-2.4v-19.6l.2-2.4v-9l.2-2v-3.8h1v7.8l-.2 2.4v9.4l-.2 2.5v12.5l-.2 2.4v25.4zm6 22.2l.5.8h-.7l-.3-.6-.3-.5-.4-.6-.4-.4-.3-.6-.4-.6-.3-.7-.3-.6-.2-.6-.3-.7-.3-.7-.3-.7-.3-.7-.3-.8-.2-.7-.3-.7-.3-.8-.2-.8-.2-.7-.2-.8v-.8l-.3-.8v-.8l-.3-.8v-.8l-.2-.8v-.8l-.2-.8v-.7l-.2-.7v-1.5h1v2.5l.2.8v.8l.3.7v.8l.2.8.2.8.2.8v.7l.2.7.3.8.2.7.2.8v.8l.4.7.2.7.3.7v.7l.4.6.3.7.3.7.2.6.3.6.3.5.3.6.4.6.3.6.3.5.3.4h-.7zm.5.8l-.4.3-.3-.3h.7zm7.7-17h1l-.2.8v.8l-.2.7v.8l-.3.7-.2.7v.7l-.2.5-.2.7-.2.6-.3.6v.6l-.4.6-.2.6-.3.5-.2.5-.3.6-.3.5-.3.5-.4.4-.4.5-.3.4-.5.6-.3.4-.4.4-.3.4-.4.4-.3.3-.3.4-.4.2-.4.3-.4.3-.6-.8.4-.3.3-.3.4-.3.4-.2.4-.4.4-.3.3-.3.4-.4.4-.4.3-.5.4-.4.3-.3.3-.5.3-.5.3-.4.3-.5.2-.6.3-.5.2-.5.3-.6.2-.6.2-.5.2-.6.2-.8.2-.6.2-.6v-.7l.3-.7v-.7l.2-.8v-.7l.2-.8zm1-55.5l.6-.8.2.4v18.8l-.2 2.2v14.6l-.2 2v8.9l-.2 1.5v4.3l-.2 1v2.6h-1V471l.2-1.5v-6.3l.2-1.8v-12l.2-2v-20.8l.2-1.7v-5.1l.2.3zm.6-.8h.2v.4l-.2-.5zm-12.4-9.8v1l.4-1 .3.4.2.5.4.3.3.3.3.5.3.3.4.3.3.4.4.4.3.3.4.4.4.3.4.3.3.3.4.3.3.4.4.3.4.3.5.3.3.2.4.2.4.3.4.3.4.3.4.3.4.3h.4l.4.4.4.3.4.2.4.2.4.3-.6.8-.4-.3-.4-.2-.4-.3-.4-.3-.4-.2-.4-.3-.4-.3-.4-.3-.4-.2-.4-.3-.4-.3-.4-.3-.4-.4-.3-.3-.4-.3-.3-.3-.4-.3-.4-.3-.5-.2-.4-.3-.2-.3-.4-.4-.4-.3-.3-.3-.4-.3-.4-.5-.4-.3-.4-.3-.3-.5-.5-.3-.3-.4-.3-.3.2-.8zm-.3.8l-1-.8h1.2l-.3.8zm-2.5-3.3h-1l1-.3.2.2.2.2v.2h.3v.3h.4v.2l.3.2.3.2v.2h.3v.2h.2v.2h.3l.2.2v.2h.2v.2l-.2.8v-1l-.3 1h-.2v-.2h-.2v-.2h-.2v-.2h-.2l-.2-.2v-.2h-.2l-.2-.2-.3-.3h-.3v-.3h-.3v-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2l1-.4zm-1 0v-1.4l1 1-1 .4z"
        />
        <path
          fill="#fff"
          d="M400 419.3c-.4 20-.2 51.7 0 54.3a34 34 0 0 0 5.4 19.3c4-3.2 8-8.8 8.8-17 .5-5 2-26.4 2-42.8-5.3-1.7-12-10.4-16.3-14z"
        />
        <path
          fill="#21231e"
          d="M400.4 473.5h-1v-12.9l-.2-1.7v-33.7l.2-2v-4h1v14.5l-.2 2v37.1l.2.5v.3zm4.7 19l.7.8h-.7l-.3-.6-.3-.5-.3-.5-.2-.5-.3-.5-.3-.5-.2-.6-.3-.5-.2-.5-.3-.5-.2-.6-.2-.6-.2-.6-.2-.6-.2-.6-.2-.6-.2-.6v-.6l-.3-.7v-.6l-.3-.8v-.6l-.2-.7v-.8l-.2-.6v-.7l-.2-.8v-1.5l-.2-.7v-1.4h1v2.8l.2.7v.7l.2.7v.7l.2.7v.7l.2.6v.7l.3.6v.6l.3.5v.6l.3.7.3.6.2.6.2.5.2.5v.6l.4.5.2.7.3.5v.5l.4.5.2.5.3.5.2.5.3.5.3.4h-.7zm.7.8l-.4.3-.3-.4h.7zm8-17.3h1v1.7l-.3.7v.7l-.3.8v.7l-.2.7-.2.7-.2.5-.3.7v.6l-.4.6-.2.6-.3.5-.2.6-.3.6-.4.6-.2.5-.3.5-.4.5-.2.4-.4.6-.3.4-.3.5-.3.4-.4.3-.4.3-.4.4-.3.3-.5.4-.4.3-.3.3-.6-.8.5-.3.3-.3.4-.4.4-.3.3-.4.3-.4.3-.4.4-.4.3-.4.4-.4.3-.5.3-.4.4-.4.3-.5.3-.3.3-.6.3-.4.2-.5.3-.5.2-.5.3-.6.2-.6.2-.6.2-.6.2-.7.2-.7.2-.7v-.7l.3-.8v-.7l.2-.7v-.8zm2.4-42.3l.4-1 .3.5v7.9l-.2 1.6v5.1l-.2 1.6v1.7l-.2 1.7v4.6l-.2 1.6v2.9l-.2 1.3v1.4l-.2 1.3v2.5l-.2 1v2.2l-.2 1v1.6l-.2.7v1.1h-1v-2l.2-.8v-1.8l.2-1v-2.2l.2-1.2v-2.7l.2-1.3v-1.5l.2-1.4V457l.2-1.6v-1.6l.2-1.6V449l.2-1.6V443l.2-1.6V433l.5.5zm.4-1h.3v.5l-.3-.5zm-16-13.4h-1l.8-.4.5.2.4.4.5.4.5.4.5.5.4.4.4.4.5.5.4.6.5.4.4.5.5.4.5.6.5.5.5.5.5.6.6.5.5.6.7.5.5.6.5.5.6.5.5.5.5.4.6.4.4.4.5.3.4.3.5.3.4.3.5.2.4.2-.3 1-.5-.2-.5-.3-.5-.2-.6-.3-.6-.4-.6-.3-.5-.4-.6-.4-.5-.4-.6-.5-.5-.5-.5-.5-.5-.5-.6-.5-.5-.5-.7-.5-.5-.6-.5-.5-.6-.5-.5-.6-.5-.4-.5-.5-.5-.5-.5-.5-.5-.5-.5-.4-.4-.4-.5-.4-.4-.5-.6-.4-.4-.3-.4-.4.8-.3zm-1 0v-1l.8.6-.8.2z"
        />
        <path
          fill="#fff"
          d="M387 405.6L373 385c-2.8 10.2-6.3 82.8-2.2 88.8a36 36 0 0 0 6.4 19.3c4-3 9.8-8.5 8-16.7-1.6-8.2.4-62.3 2-70.7z"
        />
        <path
          fill="#21231e"
          d="M373.3 384.7l14.2 20.6-.8.5-14.3-20.5v-.4l1-.3zm-1 .2l.4-1 .5.7-.8.2zm-1.2 88.7h-1l.2.3-.5-.8-.3-1.2-.3-1.5v-1.8l-.3-2-.2-2.5v-2.6l-.2-2.8v-20.3l.2-3.7V431l.2-4 .2-3.6v-3.8l.3-3.7.2-3.7.2-3.4.3-3.5.2-3.2.3-3 .2-3 .3-2.5.3-2.4.2-2 .3-2 .3-1.3.4-1 1 .2-.3 1-.2 1.5-.3 1.8-.3 2-.2 2.4-.3 2.5-.3 2.8-.2 3-.3 3.3-.3 3.3-.2 3.4-.2 3.6-.2 3.7v3.7l-.3 3.8v3.8l-.2 3.7v3.8l-.2 3.6v19.6l.2 2.6.2 2.3.2 2v1.8l.4 1.5.3 1 .3.7v.2zm0-.2v.2-.2zm5.7 19.2l.6.8-.7-.2-.3-.4-.3-.6-.3-.5-.3-.6-.3-.5-.2-.6-.3-.6-.3-.5-.3-.6-.4-.5-.2-.6-.3-.6v-.6l-.4-.6-.2-.6-.2-.6-.3-.6-.3-.6-.2-.7v-.6l-.3-.5-.2-.7v-.7l-.3-.6v-.6l-.2-.7v-.6l-.2-.7v-1.5l-.2-.7v-.7h1v1.4l.2.7v.6l.2.6v.7l.2.6v.7l.2.6.2.6v.6l.3.6.2.7.2.6.2.7v.6l.3.6.2.5.3.6.2.6.3.6.2.5.3.6.3.5.3.5.3.6.3.4.2.5.3.4.3.4.3.5.4.5h-.7zm.6.8l-.4.3-.4-.5.7.2zm7.4-17l1-.3v.8l.2.7v3l-.2.7-.2.7v.7l-.3.7-.2.6-.2.6-.2.6-.3.6-.3.5-.4.6-.3.4-.4.5-.5.4-.3.5-.4.4-.4.4-.4.4-.5.5-.4.4-.3.5-.4.3-.4.4-.5.3-.4.3-.3.4-.4.3-.6-.8.4-.3.5-.3.4-.2.3-.4.3-.3.4-.3.4-.4.4-.3.4-.4.4-.5.4-.3.4-.4.4-.5.3-.5.5-.5.3-.5.3-.5.4-.5.3-.5.2-.6v-.6l.3-.5.2-.5.2-.7v-.6l.2-.6v-3.1l-.2-.7v-.6zM387 406v-1l.6.7-.2 1-.2 1v1.4l-.3 1.7-.2 2-.2 2v2l-.3 2.4v2.5l-.3 2.6v2.8l-.2 2.7-.2 2.8v3l-.2 2.8v3l-.2 3v8.5l-.2 2.8v13.5l.2 2v1.5l.2 1.4v1l.2 1-1 .2v-1l-.2-1v-1.5l-.2-1.7v-4l-.2-2v-15.5l.2-3V441l.2-3v-2.8l.2-3 .2-2.7v-2.8l.2-2.7.2-2.5V419l.3-2.3v-2.2l.3-2v-2l.3-1.5.3-1.4v-1.2l.3-1 .5.7zm0-1h.7v.7l-.6-.6zm0 0v1l-.3-.2.4-.7zm0 1h-.2v-.2l.3.3z"
        />
        <path
          fill="#fff"
          d="M358 451.2c-.8 11.3-1.2 19-1 23 .2 7.6 2 14.2 5.5 19.2 4-3 9-8.5 8.4-16.6-2-31.5 1.4-61 5.4-89.6-3.4-2.5-9-5-12.5-7.6-6.8 38.3-9 62-6 71.6z"
        />
        <path
          fill="#21231e"
          d="M357.4 474h-1v-7.4l.2-.7V463l.2-.7V459l.2-1v-1.8l.2-1v-3l.2-1h1v2l-.2 1v2l-.2 1v2.8l-.2.7v3.2l-.2.7v4.2l-.2.6v4.3zm4.8 19l.6.8h-.7l-.3-.6-.3-.5-.3-.5-.2-.5-.2-.5-.3-.5-.3-.6-.2-.4-.3-.6-.2-.5-.3-.6-.2-.7-.2-.6-.2-.6-.2-.5-.2-.6v-.7l-.3-.6v-.7l-.3-.6v-.7l-.2-.6-.2-.6v-.7l-.2-.7v-1.4l-.2-.7v-1.5l-.2-.7v-.7h1v2.2l.2.7v1.2l.2.7v.6l.2.6v.7l.2.5.2.7v.6l.3.6v.6l.3.6.2.6.2.6.2.6.2.6.2.5.2.6.2.6.3.6.2.5.2.5.2.5.3.5.3.5.3.5.3.5.3.4h-.8zm.6.8l-.4.3-.3-.3h.8zm7.6-17h1v3.7l-.3.7v.6l-.2.7v.7l-.4.6-.2.6-.2.6-.3.6-.3.6-.3.5-.2.6-.3.5-.4.5-.2.5-.4.4-.4.5-.4.4-.3.6-.4.4-.5.4-.4.4-.3.4-.4.3-.4.3-.5.4-.4.3-.2.3-.6-.8.3-.3.4-.3.3-.3.3-.2.4-.4.4-.3.4-.3.4-.4.3-.4.4-.5.3-.4.3-.4.4-.4.3-.5.3-.5.3-.5.2-.5.3-.5.3-.5.2-.6.3-.6.2-.5.2-.6.2-.8v-.6l.2-.6v-.7l.2-.6v-3.1zm5.7-89.2l.7-.8.2.5-.5 2.6-.4 2.6-.3 2.7-.3 2.7-.4 2.7-.3 2.7-.3 2.7-.4 2.8-.3 2.8-.3 2.7-.3 2.8-.2 2.8-.2 2.8-.3 2.7-.2 2.8v3l-.3 2.7-.2 2.8-.2 2.8v2.8l-.2 3v8.5l-.2 3v8.6l.2 3v3l.2 2.8.2 3h-1l-.2-3v-3l-.2-2.8v-5.8l-.2-3V451l.2-2.8v-3l.2-2.7v-2.7l.3-3 .2-2.7.2-2.8V428l.3-2.7.3-2.8.3-2.8V417l.4-2.8.3-2.7.3-2.8.4-2.7.3-2.7.4-2.7.4-2.7.4-2.8.3-2.7.5-2.7.4-2.7v.6zm.7-.8l.2.2v.3l-.3-.5zm-12.3-7l-1-.3.8-.3.3.2.4.2.2.3h.3l.4.3.3.3.4.2.4.2.5.3.4.2.3.2.4.3.4.2.5.3.5.2.4.2.4.2.4.2.5.3.4.2.5.2.4.2.3.2.4.3h.4l.5.4.4.2.3.2.3.3.4.3.3.3.4.2-.6.8-.2-.2-.4-.3h-.3l-.3-.3-.3-.3-.4-.2-.4-.2-.4-.3-.4-.2-.4-.2-.4-.3-.4-.2-.4-.3-.5-.2-.4-.2-.4-.2-.5-.2-.5-.3-.4-.2-.4-.2-.4-.2-.4-.2-.4-.3h-.4l-.4-.4-.4-.2-.4-.2-.4-.3-.4-.3-.3-.3-.4-.2-.4-.2.8-.3zm-1-.3l.2-.8.6.5-.8.3zm-6 71.4l.8.6-.8-.2-.3-1v-1l-.3-1-.2-1.3v-1l-.2-1.4V443l-.2-1.6v-5l.2-1.8v-2l.2-2 .2-2 .2-2.3.2-2.3.2-2.5.3-2.4.3-2.5.3-2.6.4-2.8.4-2.8.4-3 .4-2.8.5-3 .6-3.2.5-3.2.6-3.3.6-3.5.6-3.5.6-3.5 1 .2-.6 3.5-.6 3.5-.6 3.4-.5 3.3-.4 3.3-.5 3-.4 3-.4 3-.4 3-.4 2.7-.3 2.7-.3 2.7-.3 2.5-.2 2.4-.3 2.4-.3 2.3v2.2l-.3 2v2l-.2 2v9.8l.2 1.4v1.2l.3 1 .2 1.2v1l.4 1-1-.3zm.8.6l-.5.6-.3-.8.8.2zm0 0l-.7-.7 1 .3-.3.3zm-.7-.7l1-1v1.3l-1-.4z"
        />
        <path
          fill="#fff"
          d="M343.6 471.8l4 14.7c.2 7.7 5 14 8.3 19 4-3 7.5-8 6.5-16-5.8-46.5-3.8-77.3 6-115-22 15-32.3 46.6-25 97.3z"
        />
        <path
          fill="#21231e"
          d="M347 486.6l-3.8-14.7 1-.3 3.8 14.6-1 .3zm1-.3zm7.6 19l.6.7h-.7l-.3-.6-.3-.5-.4-.5-.4-.5-.3-.5-.5-.6-.3-.6-.4-.5-.3-.7-.4-.5-.2-.6-.4-.5-.3-.6-.2-.5-.4-.6-.3-.7-.2-.6-.3-.6-.3-.5-.3-.7-.3-.6-.3-.7-.2-.7-.2-.6-.2-.7-.2-.7-.2-.7v-.6l-.2-.7v-.8l-.2-.8v-.7h1v1.4l.2.7v.7l.2.7.2.6v.6l.3.7v.5l.4.7.2.6.3.6v.6l.4.7.3.6.3.6.3.4.3.6.4.6.3.6.3.5.4.6.3.5.4.5.3.6.3.4.4.5.3.4.4.5.3.4.3.5.4.3h-.8zm.6.7l-.4.3-.3-.4h.8zm5.8-16.5h1v5.5l-.2.6v.7l-.3.6v.4l-.3.6-.2.6-.3.5-.2.6-.2.5-.3.6-.3.5-.3.6-.3.4-.2.4-.3.4-.4.5-.2.3-.3.4-.4.4-.3.3-.3.4-.4.4-.4.3-.3.3-.7-.8.4-.3.4-.4.3-.3.4-.3.4-.3.3-.4.4-.3.4-.4.3-.4.3-.4.3-.4.3-.4.3-.4v-.5l.4-.3.2-.5.2-.5.2-.5.2-.5.2-.5.2-.6v-.6l.2-.5v-.6l.2-.7v-5.1zm6.8-114.7l-.6-1 .8.7-1 3.5-.8 3.5-.8 3.4-.7 3.4-.7 3.4-.7 3.3-.6 3.5-.6 3.4-.4 3.2-.5 3.3-.3 3.4-.4 3.2-.4 3.4-.4 3.3-.2 3.3-.2 3.4-.2 3.4v3.6l-.2 3.5v14.7l.3 3.7.3 4 .2 3.8.3 4 .4 3.8.3 4 .5 4.2.4 4.3.6 4.4h-1l-.6-4.2-.4-4.3-.5-4.2-.3-4-.4-4-.3-4-.2-3.8-.2-3.8v-3.7l-.2-3.7v-14.3l.2-3.4.2-3.4.2-3.4.2-3.4.3-3.3.3-3.4.4-3.3.4-3.3.6-3.4.5-3.3.7-3.4.6-3.3.7-3.4.7-3.4.8-3.5.8-3.4.8-3.5 1-3.6.8.6zm-.6-1l1-.6-.2 1.3-.8-.6zm-24 98h-1l-.7-4.6-.5-4.6-.5-4.5-.3-4.3-.3-4.2-.2-4.2v-8l.2-3.8.2-3.7.3-3.7.4-3.4.5-3.4.6-3.3.8-3.3.7-3 1-3 1-3 1-2.8 1-2.8 1.2-2.5 1.3-2.5 1.4-2.4 1.5-2.3 1.4-2 1.6-2.2 1.7-2 1.7-2 2-1.6 1.8-1.7 2-1.6 2-1.5.6.8-2 1.4-2 1.6-1.8 1.6-1.8 1.7-1.8 2-1.6 2-1.6 2-1.5 2-1.4 2.3-1.4 2.4-1.4 2.4-1.2 2.6-1 2.7-1 2.7-1 3-1 3-.7 3-.7 3-.6 3.4-.5 3.3-.5 3.5-.3 3.6-.3 3.7-.2 3.8v12l.4 4.4.3 4.3.5 4.5.5 4.6.6 4.7zm-1 0zm.4 0h.5-.4zm-.4 0z"
        />
        <path
          fill="#fff"
          d="M344.8 486.2l-20.3-6.7c-2.5 20.2 1.4 45.6 7 79 4.6 29 2 51.6-1.5 66.2 21.6-3 30.7-30.7 20-83-3-13.7-5.8-31.3-5.2-55.5z"
        />
        <path
          fill="#21231e"
          d="M324.7 479l20.2 6.7-.4 1-20.2-6.7-.3-.6.7-.4zm-.6.4v-.6l.7.2-.6.4zm8 79l-1 .3-.6-3-.5-3.2-.6-3-.5-3-.5-3-.5-2.8-.4-3-.4-2.7-.4-2.7-.4-2.7-.4-2.7-.3-2.7-.4-2.6-.3-2.6-.3-2.4-.2-2.5-.3-2.3-.2-2.4-.2-2.4v-2.4l-.3-2.3V500l-.2-2v-10.7l.2-2 .2-2v-2l.4-2 1 .3-.2 2-.2 1.8v2l-.2 2v4l-.2 2v4.3l.2 2.3v2.3l.2 2.3.2 2.3.2 2.2.2 2.4.3 2.4.2 2.5.3 2.5.3 2.5.3 2.6.4 2.8.4 2.6.3 2.7.4 3 .6 2.7.4 2.8.4 3 .5 3 .4 2.8.5 3 .4 3 .5 3.2zm-2 65.8v1l-.5-.6.4-1.4.2-1.4.3-1.5.3-1.5.3-1.6.4-1.6.3-1.7.2-1.8.2-1.7.2-1.8.2-2 .2-1.8v-2l.3-2 .2-2v-2l.2-2v-13.4l-.2-2.3-.2-2.4-.2-2.4-.2-2.5-.3-2.5-.3-2.6-.3-2.6-.4-2.6-.4-2.7 1-.2.3 2.7.4 2.7.3 2.5.3 2.6.3 2.6.2 2.5.2 2.6v2.4l.3 2.4v6.8l.2 2.3v4.3l-.2 2v2l-.2 2v2l-.2 2-.2 2-.2 1.8-.3 1.8v1.8l-.4 1.7-.2 1.8-.3 1.6-.2 1.6-.3 1.5-.3 1.5-.4 1.5-.3 1.4-.5-.8zm0 1h-.6v-.6l.7.6zm19.4-83.5l1-.2 1 5 .8 4.6.7 4.6.5 4.5.5 4.3.4 4 .3 4 .2 4v7.2l-.2 3.4-.2 3.2-.4 3-.4 3-.6 3-.6 2.6-.7 2.6-1 2.4-1 2.3-1 2.2-1 2-1.2 1.8-1.3 1.7-1.4 1.5-1.4 1.4-1.5 1.3-1.5 1-1.8 1-1.8.7-2 .7-2 .5-2 .2v-1l2-.3 1.8-.6 1.8-.6 1.7-.8 1.6-1 1.5-1 1.5-1 1.4-1.5 1.3-1.5 1.3-1.6 1-1.8 1.2-2 1-2 1-2.2.7-2.3.6-2.4.7-2.7.5-3 .4-2.8.4-3 .2-3.3v-3.5l.2-3.5v-3.7l-.3-3.8-.3-4-.3-4-.4-4.3-.7-4.4-.8-4.5-.8-4.7-1-5zm-4.8-55l.3-1 .3.5V503l.2 2 .2 1.8v2l.2 1.8v1.8l.2 1.8.2 1.7.2 1.8.2 1.7.2 1.7.2 1.6.2 1.6.2 1.6.2 1.5.3 1.5.3 1.5.3 1.5.2 1.4.3 1.4.3 1.4.3 1.4.3 1.3v1.3l.4 1.2-1 .2-.2-1.3-.3-1.3-.4-1.2-.2-1.4-.3-1.4-.2-1.4-.2-1.4-.3-1.5-.2-1.5v-1.5l-.4-1.6-.2-1.5-.2-1.6-.2-1.7-.2-1.7-.2-1.7-.2-1.8-.2-1.8v-1.7l-.3-2-.2-1.7v-2l-.3-1.8v-4l-.2-2v-13l.3.5zm.3-1l.3.2v.2l-.4-.5z"
        />
        <path
          fill="#21231e"
          d="M343.6 584h1v.7h-.8v-.2h-.2v-.4zm-4.3-40l1-.4.4 1.2.2 1.2v1l.4 1.3.2 1.3.2 1.2.2 1.2.2 1.2.2 1.3.2 1.3.2 1.2.2 1.3.2 1.3.2 1.2.2 1.3v1.4l.3 1.3v2.6l.3 1.3v1.3l.2 1.2v2.6l.2 1.3v9.1h-1v-7.6l-.2-1.2v-2.7l-.2-1.3V570l-.2-1.3v-1.3l-.2-1.3v-1l-.3-1.4v-1.3l-.3-1.3-.2-1.3v-1.2l-.3-1.3-.2-1.3-.2-1.3-.2-1.3v-1.2l-.4-1.2-.2-1.2-.2-1.2-.2-1.2-.3-1.2-.2-1.2-.2-1.2zm-5.5-50.4h1.2v6.4l.2 1.5v3.3l.2 1.5v1.6l.2 1.5v1.6l.3 1.5v3.1l.3 1.5.2 1.7v1.5l.3 1.6.2 1.5.2 1.6.2 1.4.2 1.6.3 1.5v1.6l.4 1.6.2 1.6.3 1.6.2 1.5.3 1.6.3 1.5.3 1.5.4 1.6-1 .3-.5-1.7-.4-1.6-.3-1.6-.3-1.5-.3-1.5-.2-1.6-.3-1.6-.2-1.5-.3-1.6-.2-1.6-.2-1.4-.3-1.6-.2-1.5-.2-1.6v-1.7l-.3-1.5-.2-1.6v-1.5l-.2-1.6v-1.4l-.2-1.6-.2-1.6V508l-.2-1.7V503l-.2-1.4v-6.4l-.2-1.6zm1.2 0h-1.2v-.2h.2v-.2h.2v-.2h.8v.2h.2v.4z"
        />
        <path
          fill="#fff"
          d="M344 367.3l13.2 2.2-4.6 23.3c-5 24.3-8.2 53-4.5 84.2 1.5 11.7 4 21.2 7.6 28.5-14.6-1.6-24-15.8-22.7-40.6-2.6-29-1.5-52 3.2-69.4 1.4-5 5.8-24.2 7.8-28.3z"
        />
        <path
          fill="#21231e"
          d="M357 370l-13-2.3v-1l13.3 2.3.4.6-.6.4zm.3-1h.5v.6l-.5-.6zm-4.2 24l-1-.3.2-.3v-.4l.2-.5v-.6l.2-.7v-.6l.3-.7v-.8l.2-.8v-1l.3-.7.2-1 .2-1v-.8l.2-1 .2-1 .2-1 .2-1 .2-1 .2-.8v-1l.3-.7.2-1v-.7l.3-.7v-.7l.3-.6v-.6l.2-.5v-.4l.2-.3v-.3l1 .2v.6l-.2.5v.5l-.3.6v.5l-.2.7-.2.8-.2.8v1l-.3.7-.2 1v.8l-.2 1-.2 1-.2 1-.2.8-.2 1-.2 1v1l-.3 1-.2.7-.2 1v.7l-.2.7v1l-.2.5-.2.6v.7l-.2.5v.7zm-4.4 84h-1l-.3-2.8-.3-3-.3-3-.2-2.8v-2.8l-.3-3V457l-.2-3v-11l.2-2.7v-2.7l.2-2.7.2-2.8.2-2.6.2-2.6.3-2.6.2-2.6.3-2.6.3-2.5.4-2.5.4-2.5.4-2.5.3-2.4.4-2.4.3-2.4.5-2.4.4-2.3.5-2.3.4-2.3 1 .2-.4 2.2-.4 2.3-.5 2.3-.4 2.4-.4 2.4-.5 2.4-.4 2.4-.2 2.4-.4 2.5-.3 2.5-.2 2.5-.3 2.6-.3 2.5-.2 2.5-.2 2.7-.2 2.6-.2 2.6v2.6l-.2 2.7v2.7l-.2 2.7v11.5l.2 3v2.7l.3 3 .2 2.7.3 3 .3 2.8.3 3zm7 29v-1l-.4.8-.4-.7-.3-.6-.3-.8-.4-.7-.3-1-.3-.6-.3-.8-.4-.8-.3-.8-.2-.8-.2-.8-.3-1-.2-.7-.3-1-.2-.8-.3-1-.2-1-.2-.8v-1l-.3-1-.2-.8-.2-1-.2-1v-1l-.3-1-.2-1v-1l-.3-1-.2-1v-1l-.2-1.2-.2-1 1-.2v1l.3 1v1.2l.2 1v1l.3 1 .2 1 .2 1v1l.2 1 .2 1 .2 1 .2 1 .3.8.3 1 .2.8.2 1 .3.7.2 1 .3.7.2.8.3 1 .3.7.3.8.3.7v.8l.4.8.4.7.3.7.4.7.3.6.3.7-.5.7zm.4-.7l.4.8h-1l.6-.7zM332.4 465l1-.2v8.8l.2 2 .2 2 .3 2 .4 1.8.4 1.7.4 1.8.5 1.7.5 1.5.6 1.5.6 1.5.7 1.3.8 1.3.7 1.3.8 1 1 1 .8 1.2 1 1 1 .8 1 .8 1 .8 1 .7 1.2.6 1.2.4 1.2.5 1.2.3 1.2.3 1.3.3h1.4l-.2 1h-1.3l-1.4-.4-1.3-.4-1.3-.4-1.2-.5-1.2-.5-1.2-.7-1-.6-1.2-.8-1-.8-1-1-1-1-1-1-1-1.2-.7-1.2-.8-1.3-.8-1.2-.7-1.4-.7-1.5-.5-1.6-.6-1.6-.5-1.7-.4-1.6-.4-1.8-.3-2-.2-1.8-.2-2-.2-2v-8.9zm1-.2zm2.3-69.4l1 .3-.5 1.6-.4 1.7-.4 1.7-.3 1.7-.3 1.8-.3 1.8-.3 1.8-.2 2-.2 1.8-.3 2-.2 2v2l-.3 2v2l-.2 2-.2 2.3v4.3l-.2 2.2v9.6l.2 2.5v2.4l.2 2.5v2.5l.2 2.6.2 2.6.2 2.5.2 2.6.2 2.8h-1l-.2-2.6-.2-2.6-.2-2.7-.2-2.7v-2.5l-.2-2.6v-2.5l-.2-2.4v-18.5l.3-2v-2.2l.3-2v-2.2l.3-2 .3-2 .3-2 .2-1.8.3-2 .4-1.8.4-1.8.3-1.8.5-1.7.4-1.7.3-1.7.4-1.6zm8.3-28.6v1l.4-.3-.2.4-.2.4-.2.6-.2.6-.3.7-.2.8-.2 1-.2.8-.3 1-.3 1-.2 1-.3 1-.3 1-.3 1.2-.4 1-.3 1.2-.3 1-.2 1.2-.3 1-.3 1.2-.3 1-.3 1-.3 1-.2 1-.3 1-.3 1-.2.8-.2.8-.2.7v.6l-.2.6v.5l-1-.3v-.5l.2-.7.2-.6.2-.8v-1l.4-.7.2-1 .2-.8.3-1 .2-1 .3-1 .2-1.2.3-1 .3-1.2.3-1 .4-1 .2-1.2.3-1 .2-1.2.3-1 .3-1 .3-1 .4-1 .2-1 .3-1v-.8l.4-.8.2-.7.3-.7v-.6l.3-.5.2-.5.5-.2zm-.5.2l.2-.3h.3l-.5.3zm.5.3v-.5.5zm-.5-.3l.2-.3h.3l-.5.3z"
        />
        <path
          fill="#fff"
          d="M336 370.4l6.4 7.4c-1.8 1.4 1.3 7-.4 18-1 6.4-4.8 13.8-5.6 22-2.5 26.5-2.5 59.8 5.4 81-14.5-1.6-19.5-14.8-20-39.6-.4-20.6-.4-44.7 4.7-72.7 1-6.5 4.2-11.7 9.4-16z"
        />
        <path
          fill="#21231e"
          d="M342 378.2l-6.5-7.5.8-.6 6.5 7.5v.7h-.7zm.8-.7l.4.4-.5.2v-.7zm-.3 18.5h-1l.2-1.2v-1l.2-1V385l-.2-.6v-1.2l-.2-.6v-1l-.2-.4v-2.8l.2-.3.3-.4v-.2l.7.8v.2h-.2v.5h-.2v2.2l.2.4v1.1l.2.6v1.1l.2.7v8.1l-.2 1v1l-.3 1zm0 0zm-5.6 21.7h-1v-1.8l.2-.7.2-.7v-.7l.3-1v-.6l.3-.8.2-.7.2-.8.2-.7.2-.7.2-.7.2-.6.2-.7.2-.7.3-.7v-.7l.3-.6.2-.7.2-.7.2-.6v-.7l.3-.6.2-.6.2-.5.2-.7v-.6l.2-.6v-.6l.2-.6v-.5h1v1.2l-.3.6v.7l-.2.6v.7l-.3.7-.2.6-.2.6v.7l-.3.7-.2.6-.3.7-.2.6-.2.6-.2.7-.2.7-.2.7-.3.7-.3.7-.2.8-.2.7-.2.7v.7l-.2.6-.2.7v.7l-.3.8v.7l-.2.7v1.5zm4.8 81.6v-1l-.4.7-.8-2-.6-2-.7-2.3-.6-2.2-.5-2.3-.5-2.4-.5-2.4-.4-2.4-.4-2.5-.4-2.5-.3-2.5-.3-2.6-.2-2.7-.2-2.7-.2-2.6v-2.7l-.2-2.7V455l-.2-2.8v-10.9l.2-2.7V436l.2-2.8v-2.7l.3-2.6.3-2.7.2-2.6.2-2.6.2-2.4h1l-.3 2.6-.2 2.6-.2 2.5-.2 2.6v2.6l-.2 2.6v2.7l-.2 2.6v2.7l-.2 2.7V455l.2 2.7v2.7l.2 2.7.2 2.5.2 2.7.2 2.6.3 2.5.3 2.6.4 2.4.4 2.4.4 2.5.4 2.3.5 2.4.7 2.2.6 2.2.6 2.2.6 2 .7 2-.5.7zm.5-.6l.3.7h-.8l.5-.7zm-21-39.5h1v2.2l.2 2.3v2l.2 2.2.2 2v2l.3 1.7.3 1.8.3 1.8.2 1.6.4 1.5.4 1.6.4 1.5.5 1.4.4 1.2.6 1.3.6 1.2.6 1 .7 1 .6 1 .8 1 .8 1 .8.6 1 .7 1 .7 1 .6 1 .5 1 .4 1 .4 1.3.3 1.3.2 1.3.2-.2 1-1.4-.2-1.3-.3-1-.4-1.3-.4-1.2-.5-1-.6-1.2-.5-1-.7-1-.7-.8-.7-1-1-.7-1-.7-1-.6-1-.7-1.2-.6-1-.5-1.4-.5-1.3-.5-1.5-.5-1.5-.4-1.5-.3-1.7-.4-1.5-.4-1.8-.3-1.8-.2-2v-2l-.3-2v-2l-.2-2.3v-2.2l-.2-2.3zm4.7-72.8l1 .2-.5 2.6-.4 2.6-.3 2.5-.4 2.6-.3 2.4-.4 2.5-.3 2.4-.3 2.4-.2 2.4-.2 2.5-.3 2.3v2.4l-.3 2.4-.2 2.3v2.4l-.2 2.2v2.3l-.2 2v4.5l-.2 2.2V459h-1v-26.9l.2-2.2v-2l.2-2.4v-2.3l.2-2.3.2-2.3.2-2.4.2-2.3.2-2.4.2-2.5.3-2.3.3-2.4.3-2.5.4-2.5.3-2.6.4-2.5.4-2.6.6-2.6.4-2.6zm1 .2zm9.3-16.5l-.8.7h.7l-.4.5-.5.4-.5.4-.4.4-.4.5-.4.3-.4.4-.4.5-.4.4-.4.5-.3.5-.4.5-.3.5-.3.4-.3.4-.3.5-.2.4-.3.5-.2.4-.3.5-.2.4-.2.6-.2.5-.2.5-.2.6-.2.5-.2.7v.5l-.3.6v.6l-.2.6v.6l-1-.2v-.6l.2-.6.2-.6v-.6l.3-.6v-.6l.3-.5.2-.6.2-.6.2-.4.3-.6v-.5l.4-.5.2-.6.3-.5.2-.6.3-.5.3-.6.4-.5.3-.6.4-.5.2-.6.4-.4.4-.5.4-.4.4-.4.5-.4.4-.5.5-.4.4-.4.5-.6.6-.4h.7zm-.7 0l.4-.3.3.4h-.7z"
        />
        <path
          fill="#fff"
          d="M372.3 390l-13.4-1.6c-2.6 12.7-4.5 21.7-5 26.2-1 9 1.8 17 5 23 5-3 7.2-9.4 9.2-18.6 2-9.2 2.7-19.2 4-29z"
        />
        <path
          fill="#21231e"
          d="M359 388l13.3 1.5v1l-13.5-1.6-.4-.7.5-.4zm-.6.3v-.4h.5l-.6.3zm-4 26.4h-1l.2-.6v-.8l.2-.6v-1l.2-.6v-.7l.3-.6v-.7l.2-.7v-.7l.3-.7v-1l.2-.7.2-.8.2-1v-.7l.3-1 .2-.8v-1l.2-1 .2-1 .2-1 .2-1 .2-1 .3-1 .2-1 .2-1.2.2-1.2v-1l.4-1.3 1 .2-.3 1.2v1l-.3 1.3-.3 1-.2 1.2-.2 1-.2 1-.2 1-.2 1-.2 1-.2 1v1l-.3 1-.2.8-.2.8v1l-.3.7v.8l-.3.7v.8l-.2.7-.2.7v.6l-.2.7v1.3l-.2.5v1.1l-.2.5v.9zm4.3 22.6l.5.8h-.7l-.3-.7-.3-.6-.4-.6-.3-.5-.3-.6-.2-.7-.3-.7-.2-.6-.3-.7-.2-.7-.3-.7-.2-.8-.2-.7v-.7l-.3-.7-.2-.7-.2-.7v-.8l-.3-.7v-.7l-.2-.8v-.8l-.2-.7v-.8l-.2-.8v-6.1h1v6.6l.2 1v1.4l.3.7v1.6l.3.8.2.7v.8l.3.7.2.7.3.7.2.6.2.7.2.6.2.6.2.6.3.7.3.5.2.6.3.7.3.6.3.6.3.5-.7-.2zm.5.8l-.5.4-.2-.5h.7zm8.6-19h1l-.3 1-.2.8-.2 1v.7l-.3.8-.2.7-.2.8-.2.7v.8l-.4.7-.2.7-.3.6v.7l-.4.6-.2.7-.3.6-.2.5-.3.5-.3.6-.3.5-.4.7-.3.5-.4.5-.5.4-.3.6-.4.4-.4.4-.4.4-.5.3-.4.5-.4.3-.4.3-.5-.7.4-.3.5-.3.4-.3.3-.4.4-.3.4-.4.4-.4.4-.5.3-.4.4-.4.4-.5.3-.4.4-.5.2-.4.3-.6.2-.5.3-.6.2-.7.3-.7.2-.6.3-.7.2-.6.2-.7v-.8l.3-.7.3-.7.2-.8.2-.8.2-.8.2-.8.2-.8.2-1zm4.5-28.5v-1l.5.5v1l-.3 1v.8l-.2 1v1l-.2.8v1l-.2.8v1l-.2 1v.8l-.2 1v1l-.2.8v1l-.2.8v1l-.2.8v1l-.2 1-.2.8v1l-.2.8-.2 1v.8l-.2 1-.2.8-.2.8v1l-.3.8v1l-.3.7h-1l.3-1v-.8l.3-1 .2-.7v-1l.3-.8v-1l.3-.8.2-1v-1l.3-.8v-1l.2-.8v-1l.2-.8v-1.8l.2-1v-1l.2-.8v-1l.2-.8v-1l.3-1v-1.8l.2-1v-.8l.2-1v-.8l.3-1v-1l.6.7zm0-1h.6l-.2.5-.5-.5zm0 0v1-1zm0 1z"
        />
        <path
          fill="#fff"
          d="M407 418.6h-11.8c-.4 11-.7 18.5-.5 22.3.4 7.5 2.3 14 5.5 18.7 3.6-3 7-8.3 7.6-16.2.6-8-.6-16.5-.7-25z"
        />
        <path
          fill="#21231e"
          d="M395.2 418.2h12v1h-12l-.5-.5.5-.5zm-.5.5v-.5h.5l-.5.5zm.5 22.2h-1v-11.4l.2-.8v-4.4l.2-.8v-5h1v7.8l-.2.7v5.6l-.2.7v7.7zm4.7 18.4l.6.7h-.8l-.3-.5-.3-.4-.3-.4-.4-.5-.2-.4-.3-.5v-.4l-.4-.6-.2-.5-.3-.5v-.6l-.3-.6-.2-.5-.2-.6-.2-.6v-.5l-.2-.6-.2-.7-.2-.6v-.6l-.2-.6-.2-.6v-.7l-.2-.5v-.7l-.2-.7v-.5l-.2-.7v-2.6l-.2-.7h1v1.1l.2.7v1.4l.2.7v.7l.2.6v.7l.2.6v.6l.3.6v.7l.3.6v.7l.3.5v.6l.2.6.2.5.2.5.2.5.3.6.3.5.2.6.3.5.2.6.3.5.2.6.3.5.3.6.4.4.2.5h-.7zm.6.7l-.5.5-.2-.5h.8zm6.7-16.6h1v1.6l-.2.7v1.4l-.3.8v.6l-.3.7-.2.7-.2.6-.2.6-.2.5-.2.5-.3.6v.5l-.4.7-.2.5-.3.5-.2.5-.3.4-.3.5-.3.5-.4.4-.3.3-.4.4-.4.4-.3.5-.4.3-.4.4-.4.3-.3.3-.4.3-.7-.6.2-.3.4-.2.3-.3.2-.4.3-.2.4-.3.2-.4.3-.3.3-.4.3-.4.4-.5.3-.4.2-.4.2-.4.3-.5.2-.5.3-.5.2-.5.3-.5.2-.6.2-.4v-.6l.3-.6v-.6l.3-.6v-.7l.3-.6v-1.4l.2-.7V444zm0-24.3v-1l.4.6v5.6l.2 1v4.6l.2.8v2.8l.2.8v9.2h-1v-11.8l-.2-.8V429l-.2-1v-3l-.2-1v-5.3l.4.5zm0-1h.4v.6l-.5-.5z"
        />
        <path
          fill="#fff"
          d="M420 424.2l-12 .6c0 11 0 18.4.3 22.2a37 37 0 0 0 6.2 18.6c3.5-3 6.8-8.6 7-16.5.3-8-1-16.3-1.5-24.8z"
        />
        <path
          fill="#21231e"
          d="M408 424.3l12-.6v1l-12 .6-.4-.5.5-.5zm-.4.5v-.5h.5l-.4.5zm1.2 22.2h-1v-4l-.2-.6v-17.8h1V445l.2.4v1.6zm5.4 18.2l.6.8h-.7l-.2-.5-.3-.5-.3-.5-.3-.5-.4-.5-.3-.5-.3-.5-.2-.5-.3-.5-.3-.5-.2-.6-.2-.5-.3-.7-.2-.6-.2-.6v-.4l-.3-.6-.2-.6v-.7l-.3-.6-.2-.5v-.6l-.3-.8v-.6l-.2-.7v-.8l-.2-.6v-.7l-.2-.8v-2h.8v.7l.2.7v1.4l.2.7.2.7v.7l.2.7v.6l.3.6v.7l.2.6v.5l.3.6.2.7.2.5v.6l.3.6.2.5.2.5.2.5.2.5.2.6.2.6.3.5.2.6.2.4.3.5.3.5.3.4.3.5.3.3h-.8zm.6.8l-.4.4-.3-.5h.8zm6.2-17h1v2.3l-.2.7v.7l-.2.7-.2.6v.7l-.3.6v.6l-.2.5-.2.6-.2.7-.2.6-.3.5-.3.6-.3.5-.2.4-.3.5-.4.4-.3.4-.3.5-.3.4-.3.4-.3.5-.2.4-.3.3-.3.4-.4.3-.3.4-.3.3-.4.3-.6-.8.3-.3.3-.4.3-.3.4-.3.3-.4.4-.3.4-.4.2-.5.3-.4.2-.3.3-.4.3-.5.2-.4.3-.5.2-.6.3-.5.2-.6.2-.5.2-.6.2-.6.2-.6.2-.5.2-.6v-.5l.3-.7v-.6l.2-.7v-.6l.2-.8V449zm-1-25.3v1l.5-.5v2.4l.2.8v1.5l.2.7v3.4l.2.7v1.5l.2.8v.8l.2.8v2.5l.2.7v2.3l.2.8v5.3h-1v-7.4l-.2-.7v-1.6l-.2-.8V437l-.2-1v-1.5l-.2-.7v-1.6l-.2-.8v-1.6l-.2-.8v-1.6l-.2-.8v-2.2l.4-.6zm-.5.6v-.6h.5l-.5.6zm.5.4v-1 1z"
        />
        <path
          fill="#fff"
          d="M395 412.4l-12-.8c-1.2 11-2 18.2-2.2 22-.2 7.7 1 14.2 4 19.3 3.8-2.8 7.7-8 8.8-15.7 1.2-8 .8-16.4 1.4-25z"
        />
        <path
          fill="#21231e"
          d="M383 411l12 1v1l-12-1-.4-.5.5-.4zm-.4.5v-.5h.5l-.4.5zm-1.3 22.2h-1V431l.2-.4V429l.2-.6v-1.2l.2-.6v-2.2l.2-.7v-1.4l.2-.8v-.8l.2-.8v-1l.2-.8v-1l.2-.8v-1l.3-1v-1l.2-1v-1l1 .2v2l-.3 1v1l-.2 1v.8l-.2 1v.7l-.2 1v.8l-.2.8v.8l-.2.8v1.3l-.2.7v1.4l-.2.6v1.1l-.2.6v1.7l-.2.5v2.7zm3.2 18.8l.5.8-.7-.2-.2-.4-.2-.5-.2-.4-.3-.5-.2-.4v-.5l-.3-.5-.3-.5v-.6l-.3-.5v-.7l-.3-.6v-.6l-.3-.4v-.6l-.3-.7V443l-.2-.5v-.7l-.2-.6V440l-.2-.8v-5.5h1v6.8l.2.7v.7l.2.6v.6l.2.5v.6l.2.7.2.6v.6l.3.5v.5l.3.6.2.5.2.7.2.5.2.5.2.5.2.5.3.5.2.5.2.5.2.4h-.7zm.5.8l-.4.3-.3-.5.8.3zm8.2-16h1l-.2.8v.8l-.3.7v.7l-.3.7-.2.6-.2.6-.2.6-.3.6-.2.6-.3.6-.2.6-.3.5-.3.6-.3.5-.4.5-.3.5-.3.4-.3.5-.3.4-.4.6-.3.4-.4.4-.3.3-.4.4-.3.5-.4.3-.5.3-.3.4-.4.3-.4.3-.3.3-.5-.8.3-.3.4-.2.3-.3.4-.3.2-.3.4-.2.3-.4.3-.3.3-.3.3-.4.2-.4.4-.5.3-.4.2-.3.3-.5.3-.5.3-.4.4-.5.2-.5.3-.6v-.5l.4-.6.2-.5.2-.5.2-.6.2-.7.2-.7.2-.6.2-.7v-.7l.2-.7.2-.8zm1.8-24.4v-1l.5.5v1.5l-.2.8v5.6l-.2.7v9l-.2.8v2.2l-.2.8v.7l-.2.8v1l-.2.6v.8l-1-.2v-.7l.2-.8v-1.5l.2-.7V432l.2-.8V428l.2-.8V421l.2-.7v-4.8l.2-.8v-2.3l.6.5zm0-1h.5v.5l-.5-.6z"
        />
        <path
          fill="#fff"
          d="M384 399.6l-13.2-5.4c-2.2 8.8-5.2 37.8 0 50 4.5-3 9-8.4 10.3-17 1.6-9 2-18.2 3-27.6z"
        />
        <path
          fill="#21231e"
          d="M371 393.7l13 5.4-.3 1-13-5.4-.4-.6.7-.3zm-.7.3l.2-.5.5.2-.7.3zm.3 50l.6.7-.7-.2-.5-1.2-.5-1.3-.3-1.4-.4-1.5-.3-1.5-.3-1.6-.2-1.7-.2-1.7v-1.8l-.2-1.8v-3.6l-.2-2V418l.2-2v-1.8l.2-1.8.2-1.8V409l.3-1.8.2-1.7V404l.3-1.6.2-1.5.3-1.4.2-1.3.2-1.2.2-1v-1l.3-1 1 .3-.2 1v.8l-.3 1.2-.3 1.2-.2 1.3-.2 1.4-.2 1.5-.2 1.6-.2 1.6v1.7l-.3 1.7v1.7l-.2 1.8v1.8l-.2 1.8v3.8l-.2 2v5.4l.2 1.8v1.7l.2 1.8.2 1.7.2 1.6.3 1.6.3 1.5.3 1.3.5 1.4.4 1.2.4 1h-.8zm.6.7l-.5.3-.2-.5.7.2zm9.4-17.7h1v1l-.3.8-.2.8v.7l-.3.8-.2.8-.3.7-.2.7-.3.7-.3.5-.3.7-.2.6-.3.6-.3.6-.3.6-.5.5-.3.7-.4.5-.4.5-.3.5-.3.4-.4.5-.4.5-.5.4-.4.3-.3.4-.4.4-.4.4-.5.4-.5.3-.4.4-.4.3-.6-.8.4-.4.4-.3.4-.3.4-.3.4-.4.4-.3.4-.4.4-.4.4-.4.3-.4.4-.4.3-.5.3-.4.4-.4.3-.5.4-.4.3-.6.3-.5.3-.6.3-.6.2-.6.3-.7.3-.5.2-.6.3-.8.2-.7.2-.7.3-.7v-.7l.3-.7.2-.8v-.8zm3-27l.4-1 .4.6v1l-.2.8v1.7l-.2 1v1l-.2.8v1.8l-.2.8v1.7l-.2 1v1.7l-.2 1v1.6l-.2 1v.7l-.2 1v.8l-.2.8v1l-.2.7v.8l-.2 1v.8l-.2 1v.7l-.3.8v.8h-1v-.8l.2-1v-1.5l.2-.8v-1l.2-.8v-1l.2-.7v-1l.2-.7v-1l.2-.7v-1.6l.2-1v-.7l.2-1V410l.2-.8v-1.8l.2-.8v-1.8l.2-1v-1.5l.2-1v-.8l.2-1 .3.6zm.4-1l.4.3v.3l-.4-.5zm0 .6l-.3.4.2-.4zm0-.5l.4.3v.3l-.4-.5z"
        />
        <path
          id="prefix__c"
          fill="#edb92e"
          stroke="#21231e"
          d="M387.8 701.2c8 6.3 15.2-8.3 8-27.6-5-14.2-30.6-8.7-16.4 10.5.7 1 1.6.6 1.5-.4-1-4 1.6-6.3 5.5-5.5 10.5 2 11 22-.6 17.6-2.2-.2-.4 4 1.7 5.6z"
        />
        <path
          fill="#edb92e"
          stroke="#21231e"
          d="M400 639.2c-1 3.4-5 7.6-8 10.8-4.5 4.8-3.4 12.2-.2 16 3.5 4.4 5 9.2 5.8 13 .5 2.3 1.5 7.4.8 15.5-.4 4-2.7 6-5 7.7-1 1 .5 3 4.3 6 .4.2 1.5 1 2 3 .2.4 2 .4 2.2 0 .4-2 1.6-2.8 2-3 3.7-3 5.4-5 4.2-6-2.2-1.7-4.6-3.8-5-7.7-.6-8 .3-13.2.8-15.5.8-3.8 2.3-8.6 6-13 3-3.8 4.2-11.2-.5-16-3-3.2-7-7.4-8-10.7 0-.8-.3-1-.7-1-.3 0-.7.2-.7 1z"
        />
        <path
          fill="#edb92e"
          d="M395 685.5h11.6c2 0 3.6 1.6 3.6 3.5 0 2-1.6 3.5-3.6 3.5H395c-2 0-3.5-1.5-3.5-3.5s1.6-3.5 3.6-3.5z"
        />
        <path
          fill="#21231e"
          d="M406.6 686H395v-1h11.6v1zm4 3h-1v-1l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2h-.2v-.2h-.3v-.2h-.2v-.2h-.3l-.2-.2h-.5v-.2h-.6v-1h1l.2.2h.4v.2h.3l.2.2h.2v.2h.2v.2l.3.2.2.2v.2l.3.2.2.3v.3l.2.3v.4l.2.2v.8zm-1 0h1-1zm-3 4v-1h.8l.3-.2h.2l.2-.2.2-.2h.3v-.2l.2-.2v-.2l.2-.2.2-.3v-.3l.2-.2v-.8h1v1.2l-.2.2v.4h-.2v.3l-.2.3h-.2v.3h-.2v.3h-.3l-.3.2v.2h-.3l-.2.2h-.2l-.3.2h-.4l-.2.2h-.8zm-11.5-1h11.6v1H395v-1zm-4-3h1v1l.2.2v.3h.2v.2h.2v.2h.2v.2h.2v.2h.2l.3.2h.2l.2.2.3.2h.6v1h-1.2v-.2h-.3l-.2-.2h-.2l-.2-.2-.2-.2-.3-.2-.3-.3-.2-.3-.2-.3-.2-.2v-.2l-.2-.2v-.4l-.2-.2v-.8zm1 0h-1 1zm3-4v1H394v.2h-.3l-.2.2h-.2v.2h-.2v.2l-.2.2-.2.2-.2.2v.2l-.2.2v.5h-.2v.6h-1v-1.2l.2-.2v-.2h.2v-.3h.2v-.2l.2-.2v-.2h.2l.2-.2v-.2h.3v-.2h.3v-.2h.3l.3-.2h.2l.2-.2h.5l.2-.2h.7z"
        />
        <path
          fill="#fff"
          d="M417 579.2l.5-11c-4.4-2.2-15.2 0-19.7 10.2a64.7 64.7 0 0 1-18 25.2c10 1.8 18.4-.2 23.7-7.4 7.3-9.8 11.2-15.7 13.6-17z"
        />
        <path
          fill="#21231e"
          d="M418 568.3l-.4 11h-1l.4-11 .7-.5.3.5zm-.3-.5l.3.2v.3l-.3-.5zm-19.5 10.8l-1-.4.6-1 .5-.8.5-1 .6-.7.5-.8.5-.8.7-.7.6-.6.7-.7.7-.5.7-.6.6-.4.7-.5.8-.4.8-.4.7-.3.8-.3.7-.2.7-.3h.7l.8-.3h1.2l.7-.2h2l.7.2h.5l.6.2.5.2.4.2-.4 1-.4-.3h-.5l-.5-.2h-.5l-.5-.2h-3l-.7.2h-.6l-.7.3-.7.2-.7.2-.7.2-.8.3-.7.3-.7.4-.7.4-.5.5-.7.5-.7.6-.5.6-.6.6-.7.7-.6.6-.5.7-.6.8-.5 1-.3.7-.5 1zM380 603l-.2 1-.2-.8.6-.6.6-.5.7-.5.6-.6.7-.6.6-.6.5-.6.6-.6.6-.7.6-.7.5-.6.7-.7.5-.7.6-.7.5-.7.6-.8.4-.8.5-.7.5-.8.5-1 .5-.8.6-.8.6-1 .5-.8.6-1 .6-1 .5-1 .5-1 .5-1 .6-1 .5-1.2.5-1.2 1 .4-.6 1.2-.5 1-.6 1.2-.5 1-.4 1-.6 1-.5 1-.5 1-.6 1-.5 1-.6.8-.6.8-.5.8-.5.8-.6.8-.5.8-.6.7-.4.7-.6.8-.6.6-.5.7-.7.7-.6.6-.6.7-.4.6-.6.5-.6.6-.7.7-.6.5-.5.6-.6.6-.8.5-.2-1zm-.2 1h-1l.8-.8.2.8zm23.4-8l.8.5-.6.7-.5.6-.7.6-.6.6-.6.6-.5.5-.6.6-.7.5-.7.5-.7.4-.8.3-.7.4-.7.3-.7.3-.7.2-.7.3-.8.2-.8.2h-.8l-.8.2h-.8l-1 .2h-6.1l-1-.2-.8-.2-1-.2.2-1 1 .2.8.2h1l.8.2h6.6l.8-.3h.8l.7-.3.8-.2.7-.2.7-.3.7-.2.7-.2.8-.4.6-.3.7-.3.7-.4.6-.5.6-.5.5-.5.5-.5.6-.5.5-.6.7-.6.5-.7zm13.4-16.8h1l-.2.4-.2.2h-.2l-.3.3-.2.3-.3.2-.2.3-.3.3-.3.4-.3.3-.2.4-.4.5-.3.4-.3.3-.4.5-.3.5-.4.5-.5.6-.3.5-.4.5-.5.7-.5.6-.5.7-.5.7-.5.7-.5.6-.6.8-.6.8-.5.8-.6 1-.7.7-.7 1-.6.8-.8-.6.6-1 .7-1 .6-.7.7-1 .6-.7.6-.8.5-.7.5-.7.5-.7.5-.7.5-.8.5-.6.5-.6.4-.6.4-.6.4-.6.4-.5.4-.5.3-.5.3-.4.4-.5.3-.4.3-.4.3-.3.4-.3.3-.3.2-.2.3-.3.3-.2.4-.2h.2l.3-.2-.4.4zm1 0v.3h-.2l.2-.3z"
        />
        <path
          fill="#fff"
          d="M425.2 580.6l-11.8-5c-5 10-8.2 16.6-9.5 20.2-2.8 7-3.5 13.8-2.3 19.5a22 22 0 0 0 14-11.6c3.8-7 6-15.3 9.5-23z"
        />
        <path
          fill="#21231e"
          d="M413.6 575.2l11.7 5-.3 1-11.8-5-.3-.8.6-.2zm-.7.2v-.4l.6.2-.7.2zm-8.7 20.6l-1-.4.2-.3.2-.4.2-.5v-.4l.2-.3.2-.5.2-.4.2-.5.2-.5.3-.5.2-.5.3-.6.2-.5.3-.6.3-.5.3-.7.2-.6.3-.6.3-.7.4-.8.3-.7.4-.8.2-.7.4-.8.4-.8.4-.8.4-.8.4-.8.4-1 .4-.8.5-.8.4-1 .8.5-.4.8-.5 1-.5.8-.4.8-.3 1-.4.7-.4 1-.5.7-.4.7-.3.8-.3.7-.4.6-.3.7-.3.7-.3.6-.2.7-.3.6-.3.5-.3.6-.3.6-.3.6-.2.5-.3.5-.3.5-.2.5-.2.4-.2.5v.5l-.2.4-.2.3v.3l-.3.4zm-2.7 18.8l.2 1-.6-.4v-.5l-.2-.7v-.6l-.2-.5v-1.7l-.2-.5v-3.7l.2-.6v-1.2l.2-.7v-.6l.2-.5v-.7l.2-.6.2-.7v-.6l.3-.8v-.6l.3-.7.2-.7.2-.7.2-.7.2-.7.2-.7 1 .4-.3.6v.7l-.4.6-.2.6-.2.6-.2.7v.5l-.3.6v.8l-.3.6v.6l-.2.7v.6l-.2.6v.5l-.2.6v1.9l-.2.5v3.5l.2.5v1.2l.2.5v.7l.2.5-.6-.4zm.2 1h-.5v-.4l.5.4zm13.5-12.4l1 .5-.5.6-.3.6-.4.6-.3.6-.4.6-.4.5-.5.6-.5.6-.4.5-.4.6-.5.4-.4.5-.5.4-.5.3-.4.4-.6.4-.5.4-.5.4-.5.3-.5.4-.5.3-.4.2-.5.2-.4.2-.5.2-.4.3h-.4l-.5.2-.5.2h-.5l-.4.3h-.5l-.2-1h.9l.4-.3h.4l.4-.3h.5l.4-.3.5-.2.4-.2.5-.2.5-.2.5-.3.5-.3.4-.3.4-.4.4-.3.5-.4.4-.4.4-.4.6-.4.4-.5.4-.4.5-.6.3-.4.4-.5.4-.6.5-.6.4-.5.2-.7.4-.6.4-.6.3-.6zM425 581l.3-.8.3.6-.3.7-.3.8-.3.7-.3.7-.3.8-.2.7-.3.7-.2.7-.3.7-.3.8-.3.7-.2.6-.3.8-.4.7-.3 1-.2.6-.2.7-.3.8-.3.8-.2.7-.3.7-.3.8-.3.7-.2.7-.3.7-.3.8-.3.7-.5.7-.3.7-.3.6-.5.6-.3.7-1-.6.5-.6.3-.7.3-.6.3-.6.4-.7.3-.6.3-.7.3-.7.2-.7.3-.7.2-.7.3-1 .3-.6.3-.7.3-.7v-.8l.4-.7.3-.7.3-.8.2-.7.3-.7.3-.8.3-.7.3-.7.3-.7.3-.7.2-1 .3-.6.3-.8.3-.7.4-.8.3-.8.3.7zm.3-.8l.5.2-.2.4-.3-.6z"
        />
        <path
          fill="#fff"
          d="M428.6 580.6l-12.7-2c-2.4 10.8-4 18-4.4 22-1 7.5 0 14 2.7 19.4 4.3-2.3 8.8-7 10.7-14.7 2-7.8 2.2-16.3 3.6-24.7z"
        />
        <path
          fill="#21231e"
          d="M416 578.2l12.6 2v1l-12.8-2-.4-.6.6-.4zm-.6.4v-.5l.6.2-.6.4zm-3.3 22h-1l.2-.5V599l.2-.6v-.5l.2-.6v-.5l.2-.6v-.6l.2-.5v-.6l.2-.6v-.6l.2-.6.2-.7v-.6l.3-.7v-.7l.2-.8v-.8l.3-.8.2-.8v-.8l.3-1 .2-.7.2-1 .2-.8.2-1 .2-1 .2-1 .2-1 1 .3-.2 1-.2 1-.2 1-.2 1-.2.8-.2 1-.2.7-.2 1-.2.7v.8l-.3.8-.2.8v.8l-.2.7v.6l-.2.7-.2.7v.6l-.2.6-.2.7v.4l-.2.6v.6l-.2.5v1.1l-.2.6v.4l-.2.4v1.2zm2 19l.5.8-.7-.2-.2-.5-.3-.5-.2-.5v-.6l-.3-.4-.2-.5-.2-.5-.2-.6v-.6l-.2-.6v-.6l-.3-.6v-.6l-.2-.6v-.6l-.2-.6v-2.8l-.2-.6v-5.4l.2-.7v-1.5h1v3.1l-.2.7v5.1l.2.6v1.2l.2.6v.6l.2.6v.6l.3.6v.5l.2.6v.7l.3.5v.5l.3.6.2.5.2.5.2.5.3.5.2.5-.7-.2zm.5.8l-.5.3-.2-.5.7.2zm10-15.2l1 .2-.2.7-.2.8v.7l-.3.7-.3.7-.2.5-.3.6-.4.7-.3.6-.3.6-.3.4-.3.6-.4.5-.3.5-.4.5-.4.5-.4.4-.4.5-.4.3-.4.4-.4.4-.4.5-.4.3-.4.4-.4.3-.4.3-.4.3-.4.4-.5.3-.4.3-.4.2-.5.2-.5-.8.4-.2.4-.3h.4l.4-.4.4-.3.4-.3.4-.3.4-.3.4-.3.4-.3.3-.3.4-.4.4-.4.5-.4.3-.4.4-.5.3-.4.4-.6.2-.5.3-.6.3-.5.3-.6.4-.6.3-.5.3-.6.2-.6.3-.5.2-.6.3-.8.2-.7.2-.6.2-.8zm4-25v1l.5-.5v.8l-.2.8v.7l-.2.8v.8l-.2.8v.8l-.2.8v.7l-.2.8v.8l-.2.8v1.7l-.2.7v.8l-.2.8v.8l-.2.8v.7l-.2.8v1l-.2.6v.8l-.2.8-.2.7v.7l-.2.7-.2.8v.7l-.3.7-.2.7-1-.2.2-.8.2-.7v-.7l.2-.8v-.7l.3-.7v-.8l.2-.8v-.7l.2-.8v-1.5l.2-.8v-.7l.2-.8v-1l.2-.7v-.7l.2-.8v-1.6l.2-.8v-.8l.2-.7v-1l.2-.7v-.8l.2-.8v-.8l.2-1v-.7l.3-.8.5-.4zm-.4.3v-.4h.5l-.4.5zm.5.6v-1 1z"
        />
        <path
          fill="#fff"
          d="M430.4 563.4h7.6c4.4 2 9 12.2 3.7 22a65.8 65.8 0 0 0-9.5 29.2c-7.4-6.8-10.8-14.7-8.2-23.3 3.4-11.7 6.8-25.2 6.4-28z"
        />
        <path
          fill="#21231e"
          d="M438 564h-7.6v-1h7.8l-.2 1zm0-1h.2-.2zm4 22.5l-.8-.5.5-1 .4-.8.4-.8.3-1 .3-.8.2-1v-.7l.3-1V574l-.2-1v-.6l-.3-.8-.2-.7-.3-.8-.2-.7-.3-.6-.3-.7-.3-.6-.3-.6-.3-.4-.3-.5-.4-.3-.4-.4-.3-.4-.4-.4-.5-.3-.4-.3-.3-.2.5-1 .4.4.5.2.5.4.4.4.4.4.4.4.4.5.4.6.3.6.3.6.3.6.3.7.2.7.3.7.2.6.2.8v.7l.3 1v.8l.2.8v3.5l-.2 1v1l-.4.8-.3 1-.3 1-.4.8-.4 1-.5 1zM432 615l.5-.7-.8.3v-.8l.2-1v-2.3l.3-1v-.7l.2-.8.2-1 .2-.8v-1l.2-.7.3-1 .2-.8.2-1 .2-.7.3-1 .3-.8.3-1 .4-1 .4-.8.4-1 .4-1 .4-1 .4-1 .5-1 .4-1 .5-1 .5-1 .5-1.2.6-1 .6-1.2 1 .5-.7 1-.6 1.2-.7 1-.5 1-.5 1.2-.5 1-.4 1-.5 1-.5.8-.4 1-.3 1-.3 1-.4.8-.3 1-.3.8-.2.8-.3 1-.4.8-.2.8-.2 1-.2.7-.2 1v.7l-.3.8v1l-.3.7v.8l-.2.8v1l-.2.7v1.8l-1 .2zm.7-.3v1l-.8-.7.7-.3zm-9.2-23.6l1 .4-.3.8-.2.8v.8l-.2.7v.8l-.2.8v3l.2.8.2.8v.7l.3.7.3.7.2.8.3.7.4.7.4.6.3.7.5.7.4.7.4.7.5.6.4.7.5.7.4.6.6.7.6.6.6.7.7.6.5.7-.6.7-.8-.6-.7-.7-.6-.7-.7-.6-.6-.7-.6-.7-.4-.7-.6-.7-.4-.7-.5-.8-.3-.7-.5-.7-.3-.8-.5-.7-.3-.7-.3-.8-.4-.7-.2-.7-.2-.8-.2-.7v-.8l-.2-.8v-.8l-.2-.8v-2.5l.2-.8v-.8l.3-.8.3-1 .2-.7zm7-28v1l.4-.7v1.8l-.2.5v1.1l-.2.7-.2.7v.8l-.3.8v.8l-.2 1-.2.8-.2 1-.3 1v1l-.4 1-.2 1-.3 1-.2 1-.2 1-.3 1.2-.3 1-.3 1.2-.3 1-.3 1.2-.3 1.2-.3 1-.3 1.2-.2 1-.4 1.2-1-.3.4-1 .3-1 .5-1.2.3-1 .3-1.2.4-1.2.3-1 .3-1.2.3-1 .3-1.2.3-1 .2-1 .2-1 .3-1.2.2-1 .2-1 .2-1 .2-.8.2-1 .2-.8.2-.8v-.8l.3-.7v-.8l.2-.7v-.6l.2-.6v-2l.4-.6zm-.6.5v-.6h.4l-.5.5zm.4 0v-.6.4zm-.5 0v-.6h.4l-.5.5z"
        />
        <path
          fill="#fff"
          d="M433.8 558.2l-12-4.3c-4.3 10-7.2 16.8-8.4 20.5-2.3 7.3-2.6 14-1 19.6a21.3 21.3 0 0 0 14-11.6c3.3-7.3 4.5-16.3 7.4-24.2z"
        />
        <path
          fill="#21231e"
          d="M422 553.4l12 4.3-.4 1-12-4.4-.3-.6.6-.3zm-.7.3l.2-.4h.4l-.7.4zm-7.4 21l-1-.3v-.4l.2-.4v-.4l.3-.4v-.4l.3-.5.2-.5v-.5l.3-.5.2-.5.2-.6.3-.6.2-.5.2-.6.3-.6.2-.6.2-.6.3-.7.3-.6.3-.7.4-.7.3-.8.3-.8.3-.7.4-.8.3-1 .4-.8.3-1 .4-.8.5-1 .4-.8.3-1 1 .5-.5 1-.4 1-.4.8-.3 1-.4.8-.4.8-.4.8-.3.8-.4.8-.4.8-.3.7-.3.8-.3.8-.3.7-.3.6v.8l-.4.6-.2.6-.3.6v.6l-.3.6-.2.5-.2.5-.2.5v.5l-.3.5-.2.4v.5l-.3.4v.3l-.2.3v.4zm-1.8 19l.3 1-.6-.4-.3-.6v-.5l-.2-.6v-.5l-.2-.5v-.6l-.2-.7V583l.2-.7V581l.3-.6v-.7l.2-.6v-.6l.3-.6.2-.7v-.6l.3-.7.2-.6.2-.6 1 .3-.3.6-.2.7-.2.7-.2.6v.7l-.2.6v.7l-.2.6-.2.6v.6l-.2.6v1l-.2.7v6.5l.2.6v1.1l.2.4.2.6v.5l.2.5-.6-.3zm.3 1h-.5v-.4l.5.3zM426 582l.8.6-.3.6-.4.7-.2.5-.4.6-.4.7-.4.6-.4.5-.4.5-.4.5-.5.5-.5.5-.5.4-.4.4-.5.4-.4.4-.4.4-.5.3-.5.5-.5.3-.5.3-.5.4-.4.2-.5.3h-.5l-.5.4-.5.2-.5.2-.5.2h-.4l-.6.3-.4.2h-.5l-.3-.8.4-.2h.5l.5-.3.5-.2h.4l.5-.3.4-.2.4-.3.5-.2.5-.2.5-.3.4-.3.5-.3.5-.4.4-.3.6-.3.4-.4.5-.3.4-.4.4-.5.4-.4.4-.4.4-.4.4-.5.4-.5.4-.5.4-.5.4-.6.3-.6.3-.6.3-.6.3-.7zm7.6-23.4l.4-1 .3.7-.3.8-.3.8-.2.8-.3.7-.2.8-.2 1-.2.6-.2.8-.3.8v.8l-.3.7-.2.8-.2.8-.2.8v1l-.3.6-.2.8-.2.8-.2.8v.7l-.3.8-.2.8-.3.7-.2.8-.2.7-.3.8-.3.7-.2.7-.3.8-.3.7-.3.7-.2.6-1-.5.4-.5.3-.7.3-.7.3-.6.3-.7.3-.8.2-.8.2-.7.3-.8.2-.7.2-.8.2-.7v-.8l.4-.8.2-.8.2-.8.2-.8.2-.8.2-.7.2-.7.2-.8.2-.8.2-.8.2-1 .2-.6.2-.8.3-.8.3-.8.2-.7.3-.8.3-.8.3-.7.3.6zm.4-1l.4.3v.3l-.4-.6zm-.2.6l-.2.4.2-.4zm.2-.5l.4.2v.3l-.4-.6z"
        />
        <path
          fill="#fff"
          d="M425.6 549.7l-2.6-16.4c-2.8-.7-6.5 5.8-10 9.5-1 1-2 1.7-2.6 2.8a23.3 23.3 0 0 0-3.4 8 62.3 62.3 0 0 1-13 27.6c10.2-.2 18-3.8 21.8-12 5-11 7.7-17.7 9.8-19.5z"
        />
        <path
          fill="#21231e"
          d="M423.4 533.3l2.7 16.4h-1l-2.5-16.3.6-.6.4.5zm-.3-.4h.4v.2l-.3-.4zm-9.7 10.2l-.8-.7.4-.4.2-.2.3-.4.4-.4.2-.4.3-.4.4-.4.2-.5.3-.4.4-.5.2-.4.3-.3.4-.5.2-.4.3-.4.4-.3.2-.3.3-.4.3-.3.4-.3.3-.4.3-.2.3-.2.4-.2.4-.3h.3l.4-.3h.3l.4-.2h1.1l-.2 1h-1l-.3.2-.2.2-.3.2-.3.2-.3.2-.3.3v.4l-.5.3-.3.3-.3.3-.4.4-.3.4-.3.5-.4.4-.3.3-.3.4-.3.4-.4.5-.3.5-.3.4-.4.4-.3.4-.4.4-.3.4-.4.4-.4.4-.3.4zm-2.5 2.7l-.8-.7v-.2h.2l.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2h.2v-.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l1 .6h-.2l-.2.2v.2h-.2v.2h-.2l-.2.2v.2h-.2l-.2.2v.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2l-.2.2v.2h-.2zm-3.3 7.7l-1-.2v-.6l.2-.4v-.3l.2-.3v-.8l.2-.3v-.3l.2-.3v-.3h.2v-.4l.2-.3v-.2l.2-.2v-.2l.3-.3v-.2l.2-.2v-.2l.3-.2v-.3h.2v-.3l.3-.3v-.2l.3-.2v-.2l.2-.3.2-.2.8.6-.3.3v.2l-.2.2-.2.2v.4l-.2.2-.2.2v.3l-.2.3v.2l-.2.3-.2.2v.2l-.2.3v.2l-.2.3v.2l-.2.3v.2l-.2.3v.5l-.2.3v.2l-.2.3v.5l-.2.3v.7zm-13.4 27v1l-.3-.8.5-.8.5-.7.5-.6.5-.8.5-.7.5-.7.4-.6.6-.7.4-.7.5-.8.4-.7.4-.7.4-.8.4-.7.4-.7.4-.8.4-.8.4-.8.4-1 .4-1 .3-.8.3-1 .3-.8.4-1 .3-1 .4-1 .3-1 .3-1.2.3-1 .3-1.3.2-1.3.3-1.2 1 .2-.3 1.2-.3 1-.4 1.3-.3 1.2-.4 1-.4 1-.3 1.2-.4 1-.4 1-.4 1-.3 1-.5.8-.4 1-.3.8-.4.8-.4 1-.5.8-.4.8-.3.7-.5.8-.4.8-.5.8-.4.7-.6.7-.5.7-.5.7-.5.7-.5.8-.5.7-.5.6-.5.8-.5.7-.4-.8zm0 1h-1l.7-.8.4.7zm21.3-12.8l1 .4-.5.7-.4 1-.4.6-.4.7-.5.7-.4.6-.5.6-.5.6-.5.6-.6.5-.6.4-.6.5-.7.4-.6.4-.8.4-.7.4-.7.4-.7.3-.7.3-.8.3-.8.2-.8.2-1 .2-.7.2-1 .2-.7.2h-1l-.8.2h-1l-.8.2h-2v-1h2.8l1-.2h.8l.8-.2 1-.2h.7l1-.3.7-.2.7-.3.8-.2.7-.3.7-.3.7-.3.6-.3.7-.3.6-.4.7-.5.6-.4.6-.4.5-.4.6-.6.5-.5.5-.4.5-.6.5-.6.4-.7.5-.6.4-.6.3-.7.3-.8zm9.8-19.2h1v.3l-.3.3v.2l-.3.2-.2.2-.2.2-.2.3-.3.4-.2.2-.2.4v.4l-.4.5-.2.5-.3.5-.2.5-.3.6-.2.6-.3.6-.3.6-.4.7-.3.8-.3.8-.4.7-.3.8-.4 1-.4.7-.4 1-.4.8-.4 1-.4 1-.5.8-.3 1-.5 1-1-.4.6-1 .4-1 .5-1 .4-1 .5-1 .4-.8.3-1 .4-.7.4-.8.4-.8.4-1 .3-.6.4-.7.4-.7.3-.6.4-.7.3-.6.2-.4.2-.6.3-.5.2-.5.3-.4.2-.5.3-.3.2-.4.2-.3.2-.4.2-.3.2-.3.2-.2.3-.2.3-.2-.2.4zm1 0v.3-.3z"
        />
      </g>
      <use
        width={1350}
        height={900}
        transform="matrix(-1 0 0 1 964.3 0)"
        xlinkHref="#prefix__d"
      />
      <path
        fill="#fff"
        stroke="#21231e"
        d="M536.4 415a38 38 0 0 0 4.8-1.5 66.2 66.2 0 0 1-21.4-22c-7.8-12 3.3-33 8-44.3a53 53 0 0 0 21.2-31c1-7.3-19-4.7-33 2-17 8-19.3 5.7-25.4 7-2.2 10.5 2.4 11.4 6.7 11-9.4 15-13.3 29.8-15 51.4-2-21.6-6-36.5-15.3-51.5 4.3.6 9-.3 6.7-10.7-6-1.4-8.4.8-25.4-7.2-14-6.5-34-9-33-1.8 3 13.7 11.8 24 21.3 31 4.6 11.2 15.7 32.4 8 44.2a67.3 67.3 0 0 1-21.5 22c1.7.7 3.3 1.2 5 1.5-1.2 1.5-11 4.5-12.3 3.7-7.6-5.3-15-18-21.4-25.2-18.2-20.8-27.3-36.7-24-49.6 4.5-14 20.8-29.6-.8-27-21.7 2.8-39.6 32.5-45.4 68.3-2 13.2-3.3 24.4-4.7 33.5 11.8-4.3 17-8.5 20.2-13.7-1.4 5-2.5 9.7-3.2 14.2 9.7-1.7 16.7-6.4 19.2-15 1-3.6 2.3-6.5 3.6-9 3 1 7 1 11.6 0 1.7 4 15 19 22.2 30 8 12.2 20.2 21.6 24.2 22 2 .4 2.7-4 2.2-10.2 21 .2 42.3.3 63-.4 20.7.7 41.8.6 63 .4-.6 6 0 10.6 2 10.3 4-.5 16.2-10 24.3-22.2 7-10.8 20.5-25.7 22.2-30a20 20 0 0 0 11.6.2c1.3 2.5 2.5 5.4 3.5 9 2.5 8.6 9.5 13.3 19.2 15-.7-4.5-1.8-9-3.2-14 3.2 5 8.4 9.3 20.2 13.6-1.4-9-2.7-20.3-4.8-33.5-5.8-35.8-23.7-65.5-45.4-68.2-21.6-2.6-5.3 13-.7 27 3.3 12.8-5.8 28.7-24 49.5-6.5 7.3-13.8 20-21.4 25.2-1.2.8-11-2.2-12.2-3.8z"
      />
      <g id="prefix__e">
        <path
          fill="#edb92e"
          d="M440.6 356.8c-2 1.8-8.8 1.8-18 2.4-14.8.5-23.4-4-25.3-13.5 5.6 6.6 12.2 10 19.7 8 10.2-2.5 16-4.3 18.3-3.8 1.6.4 4 3.3 5.3 6.8z"
        />
        <path
          fill="#21231e"
          d="M422.6 359.7v-1h1.8l.7-.2h2.5l.8-.2h2.8l.8-.2h3l.5-.2h1l.4-.2h.5l.4-.2h.4l.5-.2h.3l.3-.2h.4l.3-.2h.2v-.3h.3l.6.7h-.3l-.3.3-.3.2h-.2l-.3.3h-.4l-.3.2h-.4l-.4.2h-.5l-.5.2h-1l-.5.2h-1.5l-.6.2H432l-.6.2h-2.8l-.8.2h-2.3l-1 .2H423zm0 0zm-25-14.3l-.7.6.8-.4.2 1 .2.7.3.8.3 1 .3.6.5.7.4.7.4.6.5.6.4.6.6.6.6.5.6.4.7.5.6.3.8.5.8.4.8.3 1 .4.8.2 1 .3 1 .2 1 .2h1l1 .3h1.2l1.2.3h6.6v1H416l-1-.2h-1.3l-1-.3h-1.2l-1-.3-1-.3-1-.3-1-.2-1-.4-.8-.3-.8-.4-1-.4-.7-.5-.7-.5-.7-.5-.7-.6-.6-.5-.6-.6-.4-.8-.5-.7-.3-.7-.4-.8-.4-.7-.4-1-.3-.7-.3-1-.2-.8 1-.4zm19.3 8l.2 1h-.8l-.7.2h-1.4l-.7.2h-2.8l-.6-.2-.7-.2h-.7l-.6-.3h-.7l-.6-.3-.8-.3-.6-.3-.6-.2-.6-.3-.6-.4-.6-.3-.6-.4-.6-.4-.6-.6-.6-.4-.6-.5-.5-.6-.6-.6-.4-.6-.6-.5-.5-.6-.6-.7.7-.6.5.6.5.6.6.6.5.5.5.5.6.5.4.5.6.5.6.4.5.5.7.4.6.3.6.3.4.3.6.2.6.3.6.2.7.2h.5l.6.3.7.2h.6l.7.2h4.7l.6-.3h.7zm18.5-4l-.3 1h-2.6l-.4.2h-.9l-.5.2-.5.2h-.5l-.6.2h-.5l-.6.3h-.5l-.7.3-.7.2h-.6l-.7.3-.7.2-.8.2-.8.2h-.8l-.8.3-1 .3-.8.2-1 .2-.8.3-.3-1 1-.2.8-.2 1-.2.7-.2 1-.2.7-.2.8-.2.7-.2.8-.2.7-.2.7-.2.6-.2h.6l.6-.3h.6l.6-.3h.6l.5-.2h.6l.5-.2h.6l.4-.2h.9l.3-.2h2zm0 0zm5.4 7.8l-.7-.8-.2.6v-.7l-.3-.3v-.3l-.3-.3v-.3l-.3-.2v-.3l-.2-.2-.2-.3v-.3l-.3-.2-.2-.3v-.2l-.2-.2-.2-.3v-.2l-.3-.2h-.2v-.3h-.2l-.2-.3v-.2h-.3l-.2-.2v-.2h-.2v-.2h-.4v-.2h-.2l.3-1h.2l.2.2.2.2h.2l.2.2.2.2h.2v.3l.3.2.2.2h.2l.2.3v.2l.2.2.2.2.2.2.2.2.2.3v.2l.3.2.2.3.2.3v.3l.3.4.2.3v.3l.3.3v.3l.3.3v.3l.2.3v.6zm0-.6l.2.3-.3.2v-.6zm-21.5-35.4v1.5h-.4v-.4h-.2v-.7l.2-.2h.2v-.2h.2zm15.3 4l-.5 1.3-.6-.2-.5-.2h-.6l-.5-.2-.4-.2-.5-.2-.4-.2-.5-.2-.4-.2h-.5l-.4-.3-.5-.2h-.4l-.4-.3h-.5l-.4-.3h-.5l-.4-.2h-.4l-.5-.2h-.4l-.3-.2h-1.3l-.4-.2H420v-2h2.9l.5.2h1l.4.2h.5l.3.2.5.2h.5l.4.2.5.2h.5l.4.3h.6l.5.3.6.2h.5l.6.3.5.2.6.2h.5l.6.3.6.2.5.2.6.2h.5zm9 2.5v1.5H442l-.3-.2h-.4l-.3-.2h-.3l-.4-.2h-.3l-.4-.2h-.4l-.3-.2h-.5l-.3-.2-.4-.2h-.3l-.4-.2h-.2l-.3-.2h-.3l-.3-.3h-.7l-.2-.2h-.4l-.2-.2.4-1.5h.2l.2.2h.2l.2.2h.3v.2h.4l.3.2h.3l.3.2h.4l.3.2.3.2h.4l.3.2h.4l.3.2h.4l.4.2h.3l.4.2h.4l.3.2h.6l.3.2h1zm0 1.5v-1.5h.4v.2h.2v.2h.2v.9h-.2v.2h-.2v.2h-.2zm23.4 7.5l.2-1.2h.2v.2h.2v.8h-.6zm-10-2l.4-1.2h.5l.3.2h.4l.3.2h1.1l.2.2h.6l.2.2h.6l.3.2h.7l.4.2h.8l.3.2h.9l.2.2h.9l.5.2h.8l-.2 1.3h-.9l-.4-.2h-.6l-.4-.2h-.7l-.4-.2h-1.4l-.3-.2h-.7l-.3-.2h-.6l-.3-.2h-.5l-.4-.2h-.5l-.3-.2h-.5l-.2-.2h-.5l-.2-.2zm.4-1.2l-.3 1h-.2v-.8h.8z"
        />
        <path
          fill="#21231e"
          d="M431.5 332l-.7 1.3-.4-.3-.4-.2-.4-.3-.3-.2-.4-.3-.4-.3-.3-.3-.4-.3-.4-.2-.3-.4-.3-.3-.2-.3-.3-.3-.3-.4-.2-.3-.3-.4-.2-.3-.3-.4-.2-.4-.2-.3-.3-.5-.2-.4-.2-.2v-.4l-.3-.4-.2-.3-.2-.4-.2-.3v-.4l-.2-.3-.2-.3-.2-.4 1.4-.7.2.2.2.4v.3l.3.2.2.4.2.3v.3l.3.3.2.4.2.3.2.4v.3l.3.4.3.3.2.4.2.4.2.4.3.3.2.4.3.4.2.3.3.4.3.3.3.3.3.2.3.3.3.3.2.2.4.3.3.2.2.2.3.2zm7.6-5.3l1.5.8-.2.4-.2.3-.2.4-.2.4-.3.5-.3.4-.2.2-.3.4-.3.3-.3.2-.3.3-.3.3-.3.3-.2.4-.3.2-.3.2-.4.2-.3.2-.3.2h-.3l-.5.2h-.3l-.3.2h-2.2l-.4-.2-.3-.2h-.2l.7-1.5h.5l.2.2h1.7l.3-.2h.2l.3-.2h.2l.3-.3.2-.2.3-.2h.2l.3-.3.2-.3.3-.2.2-.3.3-.4.2-.3.3-.3.2-.4.2-.3.3-.4.2-.5.2-.4v-.3z"
        />
        <path
          fill="#21231e"
          d="M429.6 331l-2.2-2.3c-1-1.3-.5-3 2-5.4 1.5.7 3 1.3 4.2 2-1 3-2.2 4.8-4 5.6zm-6.3 82l-.4 1h-.4v-1h.8zm23.8-3.6l1 1-.7.5-.6.4-.7.5-.6.4-.7.5-.7.3-.7.4-.7.4-.7.4-1 .3-.6.3-.8.2-.7.2-1 .2-.7.2h-.8l-.8.2h-5l-1-.2h-.8l-.8-.3h-1l-.8-.4h-1l-.7-.3-1-.3-.8-.3.3-1 .8.2 1 .3 1 .3.7.2 1 .2.7.2h.8l1 .2h.7l.7.2h4.8l.7-.2h1l.6-.3.7-.2h.7l.7-.4.7-.3.7-.3.8-.3.6-.4.7-.4.7-.5.6-.5.6-.5.5-.5.6-.6zm3-2.8l1 .8h-.2v.2h-.2l-.2.2v.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2v.2h-.2l-1-.8h.2v-.2h.2v-.2h.2l.2-.2.2-.2.2-.2v-.2h.2v-.2h.2l.2-.2.2-.2.2-.2v-.2h.2l.2-.2.2-.2v-.2h.2zm1 .8l-1-.8.2-.2h.7v.2h.2v.8z"
        />
        <path
          fill="#21231e"
          d="M452.2 401.3l-1.2-.2v-.2h.2l.2-.2h.6v.4h.2v.2zm-5.5 16l.3 1-.7-.8.2-.4.2-.4.2-.5v-.4l.3-.4.2-.5.2-.5v-.5l.3-.4.2-.5.2-.5v-.5l.3-.5v-.5l.3-.5v-.5l.3-.5v-.5l.3-.5v-.5l.2-.5.2-.6v-.5l.2-.6v-.5l.2-.4v-.6l.2-.6v-.5l.2-.7v-.6l.2-.6 1.2.3v.6l-.2.5v.6l-.2.6v.6l-.2.6v.5l-.2.6-.2.4v.6l-.2.5v.6l-.3.6v.5l-.3.6v.6l-.3.5v.5l-.2.5-.2.5v.5l-.3.5-.2.5v.5l-.2.4-.2.5-.2.6-.2.5-.2.6-.2.5-.2.5-.2.5-.7-.8zm-.4.2l1 .5v.2h-.2v.2h-.4l-.2-.2v-.2h-.2v-.4zm15.2-9.5l1 .7-.3.4-.4.6-.3.4-.4.4-.2.4-.4.4-.4.4-.4.4-.4.3-.4.4-.5.3-.4.4-.6.3-.4.3-.5.3-.5.3-.5.3-.5.2-.5.3-.5.3-.6.2-.5.3-.7.2-.5.3-.6.2-.6.2-.6.2-.6.2-.6.2-.6.2-.6.2-.6.2-.3-1.2.6-.2h.6l.5-.3.6-.2.6-.2.6-.2h.6l.5-.3.6-.3.4-.2.5-.2.4-.3.5-.2.4-.3.5-.3.4-.4.5-.3.3-.3.5-.3.4-.3.4-.3.4-.2.4-.4.4-.3.4-.3.4-.3.3-.4.3-.4.3-.4.3-.4.2-.4.3-.4zm1 .7l-1-.7h.2v-.2h.7v.2h.2v.7z"
        />
        <path
          fill="#21231e"
          d="M461.3 400.2H460v-.2h.2v-.2h1v.4zm4.4 15.7l.7 1-.8-.3-.3-.4-.3-.4-.2-.5-.3-.5-.2-.4-.3-.4-.2-.5-.3-.5-.2-.4-.2-.5v-.5l-.3-.5-.2-.5-.2-.5-.2-.5v-.5l-.2-.5-.2-.5v-.6l-.3-.5v-.5l-.3-.6v-.4l-.2-.6v-.6l-.2-.5v-.7l-.2-.6v-.6l-.2-.5v-1.2h1v.5l.2.6v.6l.2.5v1.4l.2.5.2.6v.5l.2.5v.6l.3.5v.4l.2.5.2.4v.5l.2.4.2.5.2.4.2.5.2.4.2.4.2.5.2.4.2.5.3.4.3.4.2.4.3.5.2.3.3.4.3.3h-1zm0 .7l1-.7v.8l-.2.2h-.2v.2h-.4v-.2h-.2zm7.6-12.6l1 .4v.6l-.2.5v.5l-.2.5-.2.5-.2.5-.2.5-.2.5-.2.4-.2.4-.2.4-.3.5v.4l-.4.4-.2.5-.3.4v.3l-.4.3-.3.4-.3.4-.2.3-.3.3-.3.4-.3.3-.4.3-.3.3-.3.3-.3.2-.3.3-.3.4-.3.2-.3.3-.7-1 .3-.3.3-.2.3-.3.3-.2.2-.3.3-.3.2-.2.3-.3.3-.4.3-.3.2-.4.3-.4.4-.3.2-.4.3-.4v-.4l.4-.3.2-.5.3-.4v-.3l.3-.4.2-.4.2-.6.2-.4v-.5l.3-.4.2-.4.2-.5v-.4l.3-.5v-.4l.3-.5zm1 .4l-1-.3v-.2h.8v.2h.2v.4z"
        />
        <path
          fill="#edb92e"
          d="M406 317.8c-16.7 1.8-16 12.6-.4 28 3 3 4 3 4.6-.2 1.2-5.3 7-8.5 10.2-4.4 2 2.7 1.6 4.3 8.6 3.3 9 7.5 16.2 12.8 4.5 12.3-5-.2-9 2.8-15.7 2.5 2 4 2.3 4.3 3.4 4.6 6.5 1.2 13.3-2.8 19.8-1.6 14.3 2.6-23-38.6-22.4-40.3 1-4-9-11.5-12.7-4.2z"
        />
        <path
          fill="#21231e"
          d="M406 345.5l-.7.7-1.4-1.5-1.5-1.4-1.2-1.4-1.2-1.4-1-1.3-1-1.3-.8-1.3-.8-1.2-.8-1.2-.6-1.2-.5-1-.5-1.2-.3-1-.3-1v-1l-.2-1v-1l.2-1 .2-.8.4-.8.4-.8.6-.7.6-.7.8-.6.8-.6 1-.5 1-.5 1-.4 1.4-.4 1.3-.3 1.3-.2 1.6-.2v1l-1.5.2-1.4.2-1.2.3-1.2.3-1 .4-1 .5-1 .4-.6.5-.7.7-.6.6-.4.6-.4.6-.4.7-.2.8-.2 1v1.7l.2.8.2 1 .4 1 .4 1 .5 1 .5 1.3.7 1 .8 1.3 1 1.4.8 1.2 1 1.3 1.2 1.3 1.2 1.3 1.4 1.4 1.4 1.5zm3.8 0l1 .2v.3l-.2.3v.5l-.2.2v.2l-.2.2v.2l-.2.2-.3.3v.2h-.3l-.2.2H408l-.2-.2h-.2l-.2-.2h-.2l-.2-.3-.2-.2h-.2l-.3-.4h-.2l-.2-.3-.3-.3-.2-.2.7-.7.2.2.3.3.2.2.3.2.2.2.2.2h.2l.2.2.2.2h.3v.2h.6l.2-.2v-.2l.2-.2v-.2l.2-.4v-.4l.2-.3zm11-4.6l-.8.5-.3-.4h-.3l-.3-.4-.2-.2-.3-.2h-.3l-.3-.2h-.5l-.3-.2h-1.5l-.3.2-.4.2h-.2l-.4.3-.3.2-.2.2-.4.2-.3.2-.2.3-.3.3-.2.4-.3.3-.2.4-.3.5-.2.4-.2.3v.5l-.2.4v.5l-1-.2v-.5l.2-.5.2-.5.2-.5.3-.5.2-.4.2-.4.3-.4.3-.4.3-.4.4-.3.4-.3.4-.3.4-.2.3-.2.3-.2.5-.2h.4l.4-.2h.4l.4-.2h1l.4.2h.6l.4.3.4.3.3.2.4.3.4.5.4.4zm8.6 3.2l-.7.7h.4-.5l-.6.2h-4.5l-.2-.2h-.3l-.2-.2h-.2l-.2-.2-.2-.2-.2-.2h-.2v-.3l-.3-.3v-.2l-.3-.2v-.2h-.3l-.2-.3-.2-.3v-.2l-.3-.2v-.3l-.3-.2.8-.6h.2v.4l.3.2.2.3.3.3v.2l.2.2.2.2.2.2.2.2.2.2h.2v.2h.3l.2.2h.2l.2.2h5.4zm-.4 0l.2-.2.2.2h-.4zm4.5 13v-1h4.1l.5-.2h.4l.3-.3h.2v-1l-.2-.3-.2-.4-.3-.5-.4-.4-.5-.4-.4-.4-.4-.5-.6-.5-.6-.6-.6-.6-.7-.5-.6-.6-.7-.7-.7-.7-.8-.6-.8-.7-.8-.7-1-.7.8-.8.8.7.8.5.8.7.8.7.7.5.8.6.8.7.7.6.6.6.7.4.6.6.5.5.5.5.4.5.4.4.4.4.3.4.2.4v2.3l-.4.3-.3.2-.4.3-.6.2h-.6l-.7.2h-3.6zm-15.2 2l-1 .4.5-.8h3.4l.6-.2h.5l.5-.2h.5l.5-.2h.5l.4-.2h.5l.5-.2.4-.2h.6l.4-.2.5-.2h.4l.4-.2h.5l.3-.2h.5l.4-.2h.5l.5-.2h2.6v1H431l-.4.2h-.9l-.4.3h-.8l-.4.2h-.5l-.4.3h-.6l-.5.2h-.5l-.5.3h-.5l-.5.2h-.5l-.5.2h-.5l-.6.2h-.6l-.6.2h-3l.5-.7zm-1 .4l-.3-.8h.8l-.4.8zm4 4l-.2.8h-.4v-.2h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2l-.2-.3-.2-.2-.3-.3-.2-.2v-.2h-.2v-.4l-.3-.2v-.3h-.3v-.4l-.3-.3v-.4l-.3-.4 1-.5v.5l.2.3.2.3v.4l.3.3.2.2v.2l.3.2v.2l.2.2v.2h.2v.3l.2.2v.2l.2.2h.2v.2h.4v.2h.4zm-.2.8zm20-2.5v1l-.7-.2h-4.7l-.6.2h-.7l-.6.2h-.7l-.6.2-.6.2h-.6l-.6.2h-.7l-.7.3-.6.2h-.6l-.6.2h-.6l-.6.2h-4.6l-.6-.2.3-1 .6.2h4.8l.6-.2h.6l.5-.2h.6l.7-.2.7-.2h.6l.6-.2.6-.2h.7l.5-.2h.6l.7-.2h.7l.6-.2h4.9zm-23-40l1 .3.3.3.5.7.6.8.8 1.2 1 1.2 1 1.3 1 1.5 1.3 1.5 1.3 1.7 1.4 1.8 1.4 1.8 1.5 1.8 1.5 2 1.5 1.8 1.4 2 1.4 2 1.3 1.7 1.3 2 1.2 1.7 1 1.7 1 1.6.8 1.5.6 1.4.4 1.3.3 1.2v2l-.6.7-.8.5H441v-1h2l.4-.3.3-.4V360l-.3-1.2-.4-1.2-.6-1.3-.8-1.5-1-1.6-1-1.7-1-1.8-1.3-1.8-1.4-2-1.4-2-1.4-1.8-1.5-2-1.4-1.8-1.5-1.8-1.4-1.8-1.3-1.8-1.3-1.6-1.2-1.6-1-1.5-1.2-1.3-1-1.2-.7-1-.6-1-.5-.7-.3-.4v-.6zm-12-3.7v-1l-.5.2.4-.6.3-.7.5-.6.5-.4.5-.3.6-.3.5-.2.5-.2h2.6l.6.2.6.2.5.3.6.2.6.3.4.4.5.2.4.4.4.4.5.5.4.4.3.4.3.4.3.5.2.5.2.5v.5l.2.5v1l-1-.3v-1l-.2-.4v-.4l-.3-.4-.2-.4-.3-.4-.3-.4-.5-.4-.3-.4-.5-.4-.4-.4-.5-.3-.4-.3-.5-.3h-.7l-.5-.3-.5-.2h-.5l-.6-.2h-2l-.4.3-.5.2-.4.3-.5.5-.4.4-.3.4-.3.6-.4.3zm.4-.3l-.2.2h-.2l.4-.2zm-.5-.2v.5-.5zm.4.2l-.2.2h-.2l.4-.2z"
        />
        <path
          fill="#21231e"
          d="M407 317.2l-1.3.4v-.6h.2v-.2h.8v.2h.2v.2zm7.6 10.6l-.8 1-.4-.4-.3-.4-.3-.3-.3-.3-.4-.3-.3-.2-.3-.4-.3-.3-.2-.2-.3-.4-.3-.3-.3-.2-.4-.4-.3-.3-.2-.2-.2-.4-.2-.3-.3-.3-.2-.3v-.4l-.4-.3-.2-.4-.2-.4-.2-.4-.2-.4v-.4l-.3-.3-.2-.4v-.3l-.3-.3v-.4l-.3-.4 1.2-.4v.7l.3.3v.3l.3.4v.3l.3.4v.3l.3.4.2.3.2.3.2.4v.3l.3.3.2.4.3.3.2.3.3.4.2.3.3.3.3.3.4.4.2.3.3.3.2.3.3.3.4.2.2.3.3.3.4.4.2.3.4.3zm-.8 1l.8-1v.2h.2v.7h-.4v.2h-.7zm-9.5-4.6c.8 0 1.3.7 1.2 1.5s-.8 1.3-1.5 1.2c-.8-.2-1.3-.8-1.2-1.6s.8-1.3 1.5-1.2zm-45.9 38.4h.2v-.2h.4v.2h.2v.2l.2.2v.4h-.2l-.8-.8zm-22.7 56l.2-1V416l.4-1.5.3-1.5.4-1.7.6-1.8.5-2 .7-2 .6-2 .6-2 .6-2.2.8-2.2.7-2.2 1-2 .7-2.3 1-2.3.7-2.2 1-2.2.8-2 1-2.2.8-2 1-2 .8-2 1-1.7.8-1.5 1-1.6.7-1.5 1-1.3.7-1.2.8-1 .8-.8.8-.6.7 1-.6.5-.7.8-.7 1-.8 1-1 1.3-.7 1.5-1 1.5-.7 1.7-1 1.7-.8 2-1 1.8-.8 2-1 2-.8 2.3-1 2-.7 2.3-1 2.3-.7 2.3-.8 2.2-.7 2.2-.8 2.2-.6 2-.6 2-.6 2.2-.6 2-.5 1.8-.4 1.8-.4 1.6-.5 1.6-.2 1.4-.2 1.3v1H336zm5.6 80.5l-.7-2-.7-2-.7-2.2-.6-2.2-.6-2.2-.4-2.4-.4-2.3-.5-2.4-.4-2.5-.3-2.4-.3-2.5-.3-2.7-.2-2.6-.3-2.6-.2-2.5-.2-2.6v-3l-.2-2.7v-18.5l.3-2.7v-2.5l.2-2.6v-2.7l.3-2.6.2-2.5.2-2.5h1.2l-.3 2.6-.2 2.5-.2 2.6-.2 2.6v2.6l-.2 2.6v2.6l-.2 2.7v18.8l.2 2.6v2.6l.3 2.6.3 2.6.3 2.6.3 2.5.2 2.5.3 2.5.4 2.4.3 2.5.5 2.3.5 2.3.5 2.3.6 2.2.6 2 .7 2.2.7 2-1 .4zm1-.4v.8h-.8v-.2l1-.6z"
        />
      </g>
      <use
        width={1350}
        height={900}
        transform="matrix(-1 0 0 1 964.3 0)"
        xlinkHref="#prefix__e"
      />
      <path
        fill="#21231e"
        d="M473 398.4h-.2v.5h-.2v.8l.2.7v1.6l.2.8.2.8v.7l.3.8v.8l.3.7.2.8.3.7.2.7.2.7.3.7.3.8.3.7.3.7.2.7.3.6.4.6.2.7.4.5.4.7.4.7.4.5.5.6.4.8.5.6.4.6.5.6.6.6.2.2h.8v-.2l.6-.6.5-.6.5-.6.4-.6.5-.7.5-.5.4-.6.3-.8.4-.6.3-.7.4-.8.4-.6.3-.7.4-.8.3-.7.3-.7.3-.7.3-.6.2-.7.3-.7.3-.7.2-.8v-.7l.3-.7.2-.7v-.7l.3-.8v-1.4l.2-.8v-2.1h-1v.4l-.2 1v1.4l-.2.7v.7l-.2.7-.2.7v.8l-.3.7-.2.7-.2.7v.6l-.3.7-.3.7-.2.7-.3.7-.4.6-.2.7-.4.7-.3.6-.3.7-.4.6-.4.7-.3.6-.4.6-.5.6-.4.6-.4.7-.4.7-.4.6-.5.6h-.2l-.5-.7-.4-.6-.4-.6-.4-.6-.4-.6-.4-.6-.4-.6-.4-.6-.3-.7-.4-.6-.4-.7-.3-.6-.3-.7-.4-.7-.2-.6-.3-.7-.2-.7-.2-.7-.2-.7-.2-.7-.2-.8-.2-.7-.2-.7v-.7l-.3-.6v-.8l-.2-.7v-2.3l-.2-.8v-.4h-.2v-.2h-.5z"
      />
      <path
        fill="#c6363c"
        d="M549.2 422v108.6a72 72 0 0 1-19.7 49.8 65 65 0 0 1-94.7.1 72.9 72.9 0 0 1-19.7-49.8V422h134.2z"
      />
      <use
        width={1350}
        height={900}
        transform="matrix(-1 0 0 1 964.3 -90)"
        xlinkHref="#prefix__f"
      />
      <path
        fill="#fff"
        stroke="#21231e"
        d="M549.2 488.6v28h-53v83a63.8 63.8 0 0 1-14 1.5 59 59 0 0 1-14-1.5v-83h-53v-28h53V422h28v66.6h53z"
      />
      <use
        width={1350}
        height={900}
        transform="translate(0 -90)"
        xlinkHref="#prefix__f"
      />
      <path
        id="prefix__f"
        fill="#fff"
        stroke="#21231e"
        d="M459 567.3V528c-8.4-2.3-29.3-10.6-30.3 7.6-.5 8.4 10.4 14 13.3 6.5 1.4-3.4 0-6-2-6.7-2.4-.8-4.6 1-4 3.6-8.8-4.7 8-14.6 15.5-1.7 2.2 3.7-3.7 7.6-3.7 10.4 0 2.7 5.8 7 3.7 10.3-7.7 12.8-24.3 3-15.5-1.6-.6 2.7 1.6 4.5 4 3.6 2-.8 3.4-3.3 2-6.8-3-7.5-13.8-2-13.3 6.5 1 18.2 22 10 30.4 7.6z"
      />
      <use
        width={1350}
        height={900}
        transform="matrix(-1 0 0 1 964.3 0)"
        xlinkHref="#prefix__f"
      />
      <path
        fill="#21231e"
        d="M414 421v113.3l.2 1.7v2l.4 1.7.2 1.8.3 1.7.4 1.8.3 1.8.4 1.7.6 1.7.5 1.7.6 1.5.6 1.7.5 1.6.7 1.6.7 1.6.7 1.6.8 1.6.8 1.5.8 1.5 1 1.5.8 1.5 1 1.4.8 1.4 1 1.4 1 1.4 1 1.3 1 1.5 1.2 1.2 1 1.3 1.2 1.2 1.2 1.2 1.2 1.2 1.2 1 1.3 1.3 1 1 1.4 1 1.3 1 1.4 1 1.5 1 1.4 1 1.3.8 1.4.8 1.5.8 1.4.8 1.6.7 1.5.6 1.5.7 1.5.6 1.6.5 1.6.5 1.5.5 1.6.5 1.8.4 1.6.4 1.7.4 1.8.2 1.7.3 1.7.2h1.7l1.6.2h8.9l1.7-.3 1.8-.3 1.7-.3 1.7-.2 1.7-.4 1.5-.4 1.7-.4 1.6-.5 1.6-.5 1.6-.5 1.5-.6 1.6-.7 1.6-.7 1.6-.7 1.5-.8 1.4-.8 1.6-.8 1.4-1 1.5-.7 1.4-1 1.2-1 1.4-1 1.3-1 1.2-1 1.3-1 1.2-1.3 1.2-1 1-1.3 1.3-1.2 1.2-1.2 1-1.3 1.2-1.2 1-1.4 1-1.2 1-1.4 1-1.4 1-1.4 1-1.4.7-1.5 1-1.5.7-1.5.8-1.5.8-1.6.7-1.6.6-1.6.6-1.6.6-1.6.5-1.7.5-1.6.5-1.8.4-1.7.6-1.7.3-1.8.2-1.8.3-1.7.3-1.8v-.9l.3-2 .2-1.7V421H414zm2.3 2.2H548V536l-.3 1.6-.2 1.8-.2 1.7-.3 1.8-.3 1.7-.4 1.7-.3 1.7-.5 1.5-.4 1.7-.4 1.6-.5 1.6-.5 1.6-.6 1.5-.8 1.6-.7 1.6-.7 1.5-.7 1.6-.7 1.4-.8 1.5-.8 1.4-1 1.3-.8 1.4-1 1.3-1 1.3-1 1.3-1 1.3-1 1.2-1.2 1.2-1 1.2-1.2 1-1.2 1.3-1.2 1-1.2 1-1.2 1-1.3 1-1.2 1-1.4 1-1.4 1-1.3.8-1.4 1-1.5.7-1.4.8-1.3.7-1.5.8-1.5.6-1.4.7-1.5.7-1.6.5-1.5.6-1.5.5-1.6.4-1.6.4-1.6.5-1.6.3-1.6.3-1.7.4H489l-1.8.3h-1.7l-1.6.2h-3.6l-1.6-.2H477l-1.6-.3h-1.6l-1.7-.4-1.5-.2-1.6-.3-1.7-.4-1.6-.3-1.6-.4-1.4-.5-1.6-.6-1.5-.5-1.5-.6-1.5-.6-1.4-.6-1.4-.8-1.4-.7-1.4-.8-1.4-.8-1.4-1-1.3-.7-1.4-1-1.3-1-1.2-1-1.3-1-1.2-1-1.2-1-1-1-1.3-1.3-1-1-1.2-1.3-1-1.2-1-1.3-1.2-1.4-1-1.3-1-1.3-1-1.3-.8-1.4-.8-1.4-1-1.5-.7-1.5-.8-1.4-.7-1.5-.8-1.4-.6-1.5-.6-1.5-.6-1.5-.5-1.6-.6-1.6-.5-1.6-.5-1.7-.4-1.6-.4-1.8-.4-1.7-.3-1.7-.3-1.7-.2-1.6-.2-1.8-.2-1.7v-5.4z"
      />
    </g>
  </svg>
	),
	RU: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#0039a6" d="M0 160h640v320H0z" />
      <path fill="#d52b1e" d="M0 320h640v160H0z" />
    </g>
  </svg>
	),
	RW: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#20603d" d="M0 0h640v480H0z" />
    <path fill="#fad201" d="M0 0h640v360H0z" />
    <path fill="#00a1de" d="M0 0h640v240H0z" />
    <g transform="translate(511 125.4) scale(.66667)">
      <g id="prefix__b">
        <path
          id="prefix__a"
          fill="#e5be01"
          d="M116.1 0L35.7 4.7l76.4 25.4-78.8-16.3L100.6 58l-72-36.2L82 82.1 21.9 28.6l36.2 72-44.3-67.3L30 112 4.7 35.7 0 116.1-1-1z"
        />
        <use
          width="100%"
          height="100%"
          transform="scale(1 -1)"
          xlinkHref="#prefix__a"
        />
      </g>
      <use
        width="100%"
        height="100%"
        transform="scale(-1 1)"
        xlinkHref="#prefix__b"
      />
      <circle r={34.3} fill="#e5be01" stroke="#00a1de" strokeWidth={3.4} />
    </g>
  </svg>
	),
	SA: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-85.3 0h682.6v512H-85.3z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(80) scale(.9375)"
    >
      <path fill="#199d00" d="M-128 0h768v512h-768z" />
      <path
        fill="#fff"
        d="M65.5 145.1c-.8 12-2 33 8.3 35.2 12.3 1.2 5.5-20.8 10-24.8.8-2 2.3-2 2.4.5v18.7c0 6 4 7.8 7 9 3.2-.2 5.4 0 6.6 3l1.6 32.3s7.4 2.2 7.8-18.1c.3-12-2.4-21.9-.8-24.2 0-2.3 3-2.4 5-1.3 3.2 2.2 4.6 5 9.6 4 7.6-2.2 12.2-5.9 12.3-11.7a47 47 0 0 0-3.5-16.6c.4-1-1.4-3.7-1-4.7 1.3 2.2 3.4 2 3.8 0-1.3-4.2-3.3-8.3-6.5-10-2.7-2.4-6.7-2-8 3-.8 5.7 2 12.4 6.1 18 .9 2.1 2.1 5.7 1.6 8.9-2.2 1.3-4.4.7-6.3-1.2 0 0-6-4.5-6-5.6 1.6-10.2.3-11.4-.6-14.3-.6-3.9-2.5-5.2-4-7.8-1.5-1.6-3.5-1.6-4.5 0-2.7 4.6-1.4 14.5.5 19 1.4 4.1 3.5 6.7 2.5 6.7-.8 2.3-2.5 1.7-3.8-1a66.6 66.6 0 0 1-2.1-17.4c-.5-4.6-1.1-14.4-4.2-17-1.8-2.4-4.5-1.2-5.5 1a82.4 82.4 0 0 0 .3 13.4c2 7.4 2.7 14 3.7 21.5.3 10.1-5.8 4.4-5.5-.7a45 45 0 0 0-.3-19.4c-1-2.6-2.1-3.2-4.6-2.8-1.9 0-6.8 5.3-8.2 14.3 0 0-1.2 4.6-1.7 8.7-.7 4.6-3.7 8-5.9-.6-1.8-6.3-3-21.6-6-18z"
      />
      <path
        fill="#fff"
        d="M99 194.2l-32 15.4c.3-7.3 15.1-20.4 25.3-20.5 6.5.1 4.9 2.5 6.6 5.1z"
      />
      <path
        fill="#fff"
        d="M93.3 204.2c-16.8 43.5 39.5 49.6 45.8 1.8.6-2 3-3.9 3.4-.7-1.3 43.3-43.6 46.2-50.8 32.6a41.9 41.9 0 0 1-2.5-14.6c-1-8.5-5.5-5.2-6.2 3.2-.7 4.7-.5 6-.5 10.5 2.2 34.2 56.7 19.5 65.6-8.7 4.7-15.6-.8-27.1 1.7-27.1 5.4 5.8 13 .8 14.7-1.2.7-1 2.5-1.7 3.7-.4 4.2 3 11.6 1.6 13.2-3.7.9-5.3 1.6-10.7 1.8-16.2-3.5 1-6 1.7-6.3 3.2l-.7 4.6c-.3 1.5-3.2 1.5-3.4-.4-1.3-6-6.7-6.7-10 2.5-2.1 1.8-6.1 2.2-6.5-.5.5-6.2-2-7-7-4.1l-4.8-36.2c2 0 4 1.5 5.9-.9-2-6.5-6.5-19.7-9-20.7-1.1-1.4-2.1-.5-3.7-.1-2.6.8-5 3-4.2 7.4 3 18.8 5 33.1 8.1 52 .5 2.1-1.3 5-3.7 4.7-4-2.7-5-8.2-12-8-5 0-10.6 5.5-11.3 10.7-.9 4.2-1.2 8.7 0 12.3 3.5 4.2 7.7 3.8 11.4 2.9 3-1.3 5.5-4.3 6.6-3.6.7.9.1 10.9-14.3 18.5-8.7 4-15.7 4.8-19.4-2.3-2.3-4.5.2-21.4-5.6-17.5z"
      />
      <path
        fill="#fff"
        d="M165 160c3.3-1.2 19.3-19.6 19.3-19.6l-2.4-2c-.9-.7-.8-1.5 0-2.2 4-2.4 2.7-7.4.7-9.8a9.7 9.7 0 0 0-8.7.1c-2.8 2.7-3.4 7-1.2 9.6 2.1 1 4.2 3.2 2.8 4.4-6.6 7-24.5 19.1-22.4 19.5.4.6 11.5.6 11.8 0zm-97 65c-6 9.6-6.5 23.9-3.2 28.2 1.8 2 4.7 2.9 6.8 2.2 3.8-1.6 5.5-9.3 4.6-12-1.3-2-2.3-2.3-3.6-.7-2.6 5.4-3.7 1.7-4-1.3a70 70 0 0 1 .8-15.2c.7-4.2 0-3-1.4-1.2zm257.1-15.3c-5.8-12.6-13.9-25-16.4-29.7a557.6 557.6 0 0 0-24.8-36c-6.2-7.4 10.2 3.1-2-11.7l-8.9-7.5c-2-1.4-6.8-4-7.6.2-.4 3.8-.2 5.8.4 8.9.5 2 3.5 5.5 5 7.5a565 565 0 0 1 53.8 86.5c2.6-1.3 2-16.1.5-18.2z"
      />
      <path
        fill="#fff"
        d="M299.6 251.5c-1.2 1.3 2.8 6.8 8 6.8 8.6-1 16.2-5.8 23.2-18.6a33 33 0 0 0 5.3-14.2 317 317 0 0 0-5.8-72.4c-.3-2 0-4.4.2-5 .6-.7 2.5 0 3.5-1.7 1.5-1.5-4-14-7-18.7-1-2.2-1.5-3.6-3.3.2a27 27 0 0 0-3 13.6c4.1 28.5 5.4 53.4 8 81.9.3 2.8-.1 6.8-2 8.4a80.2 80.2 0 0 1-27.1 19.7zm116.5-.1c-6.2 3.6-6.2 7.7-1.2 7.8 8.6-1 18.8-1.7 25.8-12.3a41 41 0 0 0 4.2-16 303 303 0 0 0-4.7-71.4c-.2-2-1.1-6.7-.8-7.3.6-1.4 3.4.1 4.4-1.5 1.4-1.5-7.3-12.7-10.4-17.5-1-2.2-1.4-3.6-3.3.2a22.3 22.3 0 0 0-1.8 13.6c4.6 31 8 54.2 8.7 81.6-.4 2.6-.5 4-1.7 7.3-2.7 3.4-5.7 7.8-8.5 9.9-2.8 2-8.8 4-10.7 5.6z"
      />
      <path
        fill="#fff"
        d="M420.7 223.7c0-7.3.1-13.5-.1-19a34 34 0 0 0-3-13.5c-1.8-4.1-.7-7.4-1.6-11.8-.8-4.4-.6-11-1.8-16.1-.4-2-1.4-8.5-1.1-9.2.5-1.4 2.4 0 3.4-1.6 1.4-1.5-5-18-8.2-22.7-1.1-2.1-3.3-1.4-5.8 2-2.5 2.3-1.6 7.4-.6 12.3 6.1 32.3 10.8 61.6 9.8 92.3-.4 2.6 9-7.8 9-12.7zm-45.7-40c-3.9-.2-12-7.7-14.4-12a8 8 0 0 1 .4-6.5c1.5-1 3.7-2 5.4-1 0 0 1.7 2.4 1.4 2.7 2 1 3 .5 3.2-.4.1-1.5-.6-2.4-.6-4 .9-4.6 6-5.3 8-2.4 1.4 1.8 2 5.5 2.1 8 0 1.3-2-.2-3.3 0-1.1.4-1.4 1.8-1.5 3-.2 3.3-.6 8.6-.7 12.5zm-71.8 48c1-9.8-.4-27.3-.5-33.1A477 477 0 0 0 299 154c-1.2-8.4 3.4.9 2.8-4-1.5-8.3-6.1-14-11.6-21.5-1.7-2.5-1.7-3-4.4.6-3 6.7-.4 11.4.4 16.7 3.9 17.2 6.2 33 7.3 48.7a393.4 393.4 0 0 1 .4 49c3 .1 7.6-4.7 9.3-11.8z"
      />
      <path
        fill="#fff"
        d="M434 216c-6.9-11.6-17.2-24-20-28.7a658 658 0 0 0-29.2-37.8c-8.5-9 4-1.5-1.6-8.5-4.7-5.1-6-6.8-10.1-9.9-2-1.3-3.2-3.8-4 .5a83 83 0 0 0-.2 11.2c0 1.7 1.8 5 3.4 7 20.7 25.5 43.4 51.5 61.6 84.2 2.6-1.3 1.7-16 0-18z"
      />
      <path
        fill="#1ba400"
        d="M122.6 194.7c-.5.9-1.6 2-1.2 3.1.7 1 1.4 1.3 2.6 1.3 1.1 0 2.7.3 3-.3.6-.7 1-2 .6-3.3-1.2-3-4.4-1.8-5-.8z"
      />
      <path
        fill="#fff"
        d="M354.2 362.5c9.2.4 15.2.5 23.3 1.4l9.6-1c10.6-1 11 15.1 11 15.1 0 9.5-3.7 10-8.4 11-2.7.4-4-1.6-5.5-3.6a14 14 0 0 1-7 .4c-3.9-.2-7.7-.2-11.5-.5-4-.3-6.2.5-10.3.1-.8 1.3-2 3.1-4.4 2.6-2-.3-4.5-6-3.8-10.5 1.5-3.2 1-2.1 1-3.5-37.6-1-75.5-2.7-112.3-2.2-28.8.1-57.2 1.3-85.7 2.5-15.2-.2-26.8-2.6-34.8-14.3.8 0 38.8 2.1 49.9 1.4 20.5-.2 39.3-1.9 60.2-2.5 41.2.7 82.1.7 123.3 3.6-4-2.7-4-9 2-10.6.5-.4.8 3.1 1.7 3 4.9-.3 2.7 6.3 1.7 7.6zM188.6 135.3c-6.2 17.8 3.6 37.4 10.4 35.5 5 2 8-7.4 10-17.6 1.5-2.9 2.5-3.2 3.2-1.7-.2 13.6 1 16.7 4.5 20.8 7.8 6 14.3.8 14.8.3l6-6.1c1.4-1.5 3.2-1.5 5.1-.3 1.9 1.7 1.6 4.6 5.6 6.6 3.4 1.4 10.5.4 12.2-2.5 2.2-3.9 2.8-5.2 3.8-6.6 1.6-2.1 4.3-1.2 4.3-.5-.3 1.2-1.9 2.3-.8 4.5 2 1.4 2.4.5 3.5.2 4-2 7-10.6 7-10.6.1-3.2-1.7-3-2.9-2.2l-3.1 2.1c-2 .3-5.7 1.6-7.6-1.3-1.9-3.4-1.9-8.3-3.3-11.8 0-.2-2.6-5.5-.2-5.8 1.2.2 3.7.9 4.1-1.2 1.2-2.1-2.6-8-5.3-11-2.3-2.5-5.5-2.8-8.6-.2-2.2 2-1.9 4.2-2.3 6.3a9.8 9.8 0 0 0 2 8.7c2.2 4.2 6.1 9.7 4.8 17.5 0 0-2.3 3.6-6.3 3.1-1.7-.3-4.4-1-5.8-11.8-1.1-8 .2-19.4-3.2-24.7-1.3-3.3-2.2-6.4-5.2-.9-.8 2.2-4.3 5.5-1.8 12.2a36 36 0 0 1 2 19c-1.5 2.2-1.8 2.9-3.7 5-2.6 3-5.5 2.2-7.7 1.1-2-1.3-3.6-2-4.6-6.5.2-7 .6-18.5-.7-20.9-1.9-3.8-5-2.4-6.3-1.2a47.7 47.7 0 0 0-11.5 23.5c-1.8 5.8-3.7 4.1-5 1.8-3.2-3-3.5-26.7-7.4-22.8z"
      />
      <path
        fill="#fff"
        d="M207.4 174.1c2.9-2 1.6-3.4 5.8.8a72 72 0 0 1 9.2 31.3c-.2 2.6 1.6 4.2 2.5 3.6.4-6 15.1-14.4 28.6-15.6 2-.5 1-4.4 1.3-6.4-.8-7.5 4.2-14.3 11.2-14.8 9.6 1.4 12.8 6.5 13 14.2-1.1 15-16.7 17.5-25.4 18.7-1.3.5-1.9 1.1 0 1.8l36.6.2 1.9 1c.2 1-.6.2-2 2.6a29.5 29.5 0 0 0-3.7 11.5c-10.9 3.6-22.2 5-33.6 6.5-4 2-6 4.7-5.2 7.7 1.4 3.3 10.2 6.7 10.2 6.8 1.7 1 3.6 3.5-.5 8.6-17.8-.8-31.7-8.4-36.5-19.1-1.4-1.1-3 0-4 1.4-7 9-13.8 17-25.7 21.4-7 1.8-14.3-1.1-17.7-5.7-2.3-2.7-2.2-5.6-3-6.2-3.9 1.7-36.9 15.7-32.7 9.1 8-8.5 22-14.9 34.2-23.3.9-2.9 2.5-12.5 7.3-15.6.3 0-.7 5.6-.6 8 0 2-.2 2.7.2 2.2.9-.5 15.7-12.2 17-15.8 1.4-2 .3-7.2.3-7.4-2.8-7.2-6.7-7.8-8.1-11.4-1.3-4.7-.7-10.1 2-11.7 2.4-2.1 5.2-1.9 7.9.5 3 2.7 5.6 8 6.4 11.9-.5 1.5-4-1-5-.3a16 16 0 0 1 3.7 7.8c2 8.2 1.4 11.4-.6 16.7-6.6 13.9-15 18-22.4 23.2-.2 0-.3 3.5 2.4 5.4 1 1 4.9 1.5 9.4 0a54.5 54.5 0 0 0 22.3-23.3 51 51 0 0 0-2.4-22.2c-2.9-6.7-6.3-16.2-6.3-16.4-.1-4.2.2-5.6 2-7.7zm-95.8-38.6c4.2 2 12.2 1.1 11.8-5.7l-.2-3.1c-.8-2-3.2-1.5-3.7.5-.2.7.3 1.8-.3 2.1-.4.4-1.7.2-1.7-1.7 0-.6-.4-1.2-.7-1.6-.2-.2-.4-.2-.9-.2-.6 0-.6.1-.9.6-.1.5-.3 1-.3 1.6 0 .7-.4.9-.8 1-.6 0-.5 0-1-.2-.2-.3-.5-.4-.5-1l-.3-1.6c-.2-.3-.6-.5-1-.6-2.3 0-2.5 2.7-2.3 3.7-.2.2-.3 4.9 2.8 6.2z"
      />
      <path
        fill="#fff"
        d="M235.1 187.7c4.2 2 14.3.9 11.8-5.6l-.2-3.2c-.9-2-3.2-1.5-3.7.6-.2.6.3 1.7-.4 2-.3.4-1.7.2-1.6-1.6 0-.6-.4-1.3-.7-1.7-.3-.1-.4-.2-1-.2-.5 0-.5.2-.8.7-.2.5-.3 1-.3 1.6-.1.6-.4.8-.9 1-.5 0-.4 0-.8-.3-.3-.3-.6-.4-.6-.9l-.3-1.6c-.2-.3-.6-.5-1-.6-2.3 0-2.5 2.6-2.4 3.6-.1.2-.2 5 3 6.2zm72-21.6c4.2 2 12.1 1.1 11.8-5.6l-.2-3.2c-.9-2-3.2-1.5-3.7.5-.2.7.3 1.8-.4 2.2-.3.3-1.7.1-1.6-1.8 0-.6-.4-1.2-.7-1.6-.3-.2-.4-.2-1-.2-.5 0-.5.2-.8.7l-.3 1.5c-.1.7-.4 1-.9 1s-.4 0-.8-.2c-.3-.3-.6-.4-.6-.9s-.1-1.3-.3-1.7c-.2-.3-.6-.4-1-.5-2.3 0-2.5 2.6-2.4 3.6-.1.2-.2 4.9 3 6.2zm37.3 54.3c-7.3 8.3-4.1 22-2.4 25 2.4 4.8 4.3 7.9 9 10.3 4.3 3.1 7.7 1.2 9.5-1 4.3-4.5 4.4-16 6.4-18.2 1.4-4.2 5-3.5 6.7-1.6a16.5 16.5 0 0 0 6.2 5.3c4 3.5 8.8 4.2 13.6 1 3.2-1.9 5.3-4.2 7.2-8.9 2-5.6 1-31.6.5-47l-4.2-21.5c0-.2-.5-10.2-1-12.5 0-1-.3-1.3.7-1.2 1.1 1 1.2 1 2 1.3 1 .2 2-1.7 1.3-3.3l-10-18.6c-.8-.8-1.9-1.6-3.2.2a7.3 7.3 0 0 0-2.4 5.5c.3 4.4 1 8.9 1.3 13.3l4 22.6c1.3 16 1.6 29.2 2.9 45.3-.2 6.8-2.3 12.7-4.3 13.6 0 0-3 1.7-5-.2-1.5-.6-7.4-9.9-7.4-9.9-3-2.7-5-2-7.1 0-6 5.8-8.6 16.4-12.7 23.8-1 1.7-4 3-7.2-.1-8.2-11.3-3.4-27.3-4.4-23.2zM309 126.7c3.8 1.5 6.4 9.2 5.6 13-.8 4.5-2.8 9.5-4.2 8.9-1.6-.6 1-4.6-.5-8.8-.8-2.8-6-7.8-5.4-9.2-1-3.1 2.2-4.5 4.5-4z"
      />
      <path
        fill="#fff"
        d="M356.6 225c.7-9.2-.6-14.8-.8-20.2s-6.1-46.6-7.3-50.6c-1.5-7.8 5.7-1 4.9-5.6-2.5-5.6-8.6-13.9-10.5-18.8-1.2-2-.7-4-3.3-.5a42.3 42.3 0 0 0-2.3 19.2c6.2 32.3 12.5 59.1 11.5 89.8 3 0 6.3-6.7 7.8-13.3zm64.4-85.3c3.5 1.7 5.5 11.3 5.1 14-.7 5-2.5 10.4-3.8 9.7-1.5-.6.3-7.4-.4-9.5-.8-3-5.5-8.4-5-10-1-3.4 2-4.8 4.1-4.2zm-255.7 67.9c3.3 1.3 5.3 8.3 5 10.3-.8 3.7-2.5 7.7-3.8 7.1-1.3-.4.3-5.4-.3-7-.3-3.7-4.9-5.7-4.8-7.3-.8-3 2-3.5 4-3.1z"
      />
      <path
        fill="#1b9d00"
        d="M244.9 218.2c4.2.2 6.3 3.6 2.4 5-4 1.3-7.7 2.4-7.8 8 1.5 8-2 5.2-4 4.2-2.4-1.8-9.2-6-10.2-15-.1-2.1 1.6-4 4.3-4 4 1.1 10 1.2 15.3 1.8z"
      />
      <path
        fill="#fff"
        d="M77.4 124.4c4.8 1.4 5.1 8.6 4.8 10.7-.7 3.8-2.4 7.9-3.6 7.4-1.4-.5 0-5.7-.7-7.3-.7-2.2-4.8-6.4-4.4-7.6-.9-2.5 2-3.7 3.9-3.2zm95.9 33.6c-3.8 2-5.2 8-2.9 11.6 2.2 3 5.6 1.9 6 1.9 3.7.4 5.9-6.9 5.9-6.9s.1-2-4.2 1.9c-1.9.3-2-.4-2.5-1.4a9 9 0 0 1 .5-5.7c.7-1.8-.7-2.6-2.8-1.4zm28-36.4c-2 1.3-5.7 5.2-5.8 9.6-.1 2.5-.6 2.5 1 4 1.3 1.8 2.4 1.7 4.8.4a5.1 5.1 0 0 0 2.3-3.4c.6-2.8-3 1.4-3.4-1.8-.8-3 1.5-4.2 3.7-7 0-2 0-3.3-2.7-1.8zm22.4 4a59.5 59.5 0 0 0-1.6 11.1c-.6 2.8 3 4 4.5.4 2.4-6.5 2.4-9.3 2.6-12-.7-4.3-3.6-4.2-5.5.5zm142 72.3c.4-.5 20-14.4 20-14.4 2-.7 1.5 7.2.6 7.1a77.8 77.8 0 0 1-20.7 14.3c-1 .7-1.9-5.3 0-7zm17.7-.2c3.5 1.7 4.9 11.8 4.5 14.5 0 5.4-3.3 9.6-4.7 9-1.4-.7.2-6.7-.5-8.8-.8-3-3.7-8.5-3.2-10.1-1-3.4 1.8-5.2 4-4.6zm-116 43.4a26 26 0 0 1 5.6-4.9c2-1 3.8.8 3.7.7.3 2-1.2 3.7-.7 6.3.4 1 .7 2.2 2.6 1.8 3.1-2.5 6-2.7 9-2.8 2.5.1 2.6 4.2 1 4.2-5.7 1.2-8.2 2.8-12.3 4.3-2 1.2-3.6-.3-3.6-.4s-1.1-1.1-.4-3.7c.2-2-.6-3.2-2.4-3-1.2.8-2.4 1.2-3-.3-.3-1-.4-1.6.5-2.2zm136.6 5.4c.8 1 1.4 2-.1 3.8l-3.7 3.2c-.6 1-1 2.8 1 3.3 3.6 1 12-4.5 12-4.6 1.4-1 1-3 .8-3-.8-.9-2.6-.3-3.8-.5-.6 0-2.5-.2-1.6-2a11.4 11.4 0 0 0 1.6-2.9c.5-1.2 0-2-2-2.7-2.1-.4-3-.2-5.3 0-1.2.2-1.6.8-1.9 2.3.1 2.3 1.5 2.2 3 3z"
      />
      <path
        fill="#259f00"
        d="M268.1 189.7c-.5 1-2.3 1-4 0s-2.7-2.6-2.1-3.5 2.3-.9 4 0 2.6 2.6 2.1 3.5zm-89-53.6c-1 .3-2.4-.6-3-2s-.3-2.6.7-2.9 2.3.7 3 2 .3 2.7-.8 3z"
      />
      <path
        fill="#209000"
        d="M355.2 375c9.4.4 18.2 0 27.5.5 1.7 1.5.5 5-.6 4.8l-7.8-.3c-.1-3-7.7-2.5-7.5.1-4.1.5-7.8-.1-12-.3-1.2-1.5-1-4.2.4-4.8z"
      />
    </g>
  </svg>
	),
	SB: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="scale(.9375)"
    >
      <path fill="#0000d6" d="M0 507.2L987.4 0H0v507.2z" />
      <path fill="#006000" d="M1024 0L27.2 512H1024V0z" />
      <path fill="#fc0" d="M1024 0h-54.9L0 485.4V512h54.9L1024 27.6V0z" />
      <path
        fill="#fff"
        d="M71.4 9.1l11.8 34.5h38.5L90.6 64.7l11.9 34.4L71.4 78 40.3 99.2l11.9-34.4-31.1-21.3h38.4zm191.1 0l11.9 34.5h38.5l-31.2 21.2 12 34.4L262.4 78l-31 21.3 11.9-34.4-31.2-21.3h38.5zm0 144.5l11.9 34.5h38.5l-31.2 21.2 12 34.4-31.2-21.3-31 21.3 11.9-34.4-31.2-21.3h38.5zm-95-71.4l11.9 34.4h38.4l-31 21.3 11.8 34.4-31-21.3-31.2 21.3 12-34.4-31.2-21.3h38.5zm-96.1 71.4l11.8 34.5h38.5l-31.1 21.2 11.9 34.4-31.1-21.3-31.1 21.3 12-34.4L21 188h38.4z"
      />
    </g>
  </svg>
	),
	SC: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="scale(.9375)"
    >
      <path fill="red" d="M0 0h992.1v512H0z" />
      <path fill="#090" d="M0 512l992.1-170.7V512H0z" />
      <path fill="#fff" d="M0 512l992.1-341.3v170.6L0 512z" />
      <path fill="#009" d="M0 512V0h330.7L0 512z" />
      <path fill="#ff0" d="M0 512L330.7 0h330.7L0 512z" />
    </g>
  </svg>
	),
	SD: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="scale(.9375)"
    >
      <path d="M0 341.3h1024V512H0z" />
      <path fill="#fff" d="M0 170.6h1024v170.7H0z" />
      <path fill="red" d="M0 0h1024.8v170.7H0z" />
      <path fill="#009a00" d="M0 0v512l341.3-256L0 0z" />
    </g>
  </svg>
	),
	SE: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-53.4 0h682.6v512H-53.4z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="translate(50) scale(.9375)">
      <g fillRule="evenodd" strokeWidth="1pt">
        <path
          fill="#006aa7"
          d="M-121.1.3h256v204.8h-256zm0 306.9h256V512h-256z"
        />
        <path fill="#fecc00" d="M-121.1 205h256v102.4h-256z" />
        <path fill="#fecc00" d="M133.8 0h102.4v512H133.8z" />
        <path fill="#fecc00" d="M233 205h460.8v102.4H233z" />
        <path
          fill="#006aa7"
          d="M236.2 307.2H697V512H236.2zm0-306.9H697v204.8H236.2z"
        />
      </g>
    </g>
  </svg>
	),
	SG: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h640v480H0z" />
      </clipPath>
    </defs>
    <g fillRule="evenodd" clipPath="url(#prefix__a)">
      <path fill="#fff" d="M-20 0h720v480H-20z" />
      <path fill="#df0000" d="M-20 0h720v240H-20z" />
      <path
        fill="#fff"
        d="M146 40.2a84.4 84.4 0 0 0 .8 165.2 86 86 0 0 1-106.6-59 86 86 0 0 1 59-106c16-4.6 30.8-4.7 46.9-.2z"
      />
      <path
        fill="#fff"
        d="M133 110l4.9 15-13-9.2-12.8 9.4 4.7-15.2-12.8-9.3 15.9-.2 5-15 5 15h15.8zm17.5 52l5 15.1-13-9.2-12.9 9.3 4.8-15.1-12.8-9.4 15.9-.1 4.9-15.1 5 15h16zm58.5-.4l4.9 15.2-13-9.3-12.8 9.3 4.7-15.1-12.8-9.3 15.9-.2 5-15 5 15h15.8zm17.4-51.6l4.9 15.1-13-9.2-12.8 9.3 4.8-15.1-12.9-9.4 16-.1 4.8-15.1 5 15h16zm-46.3-34.3l5 15.2-13-9.3-12.9 9.4 4.8-15.2-12.8-9.4 15.8-.1 5-15.1 5 15h16z"
      />
    </g>
  </svg>
	),
	SH: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#006" d="M640 480V0H0v480h640z" />
    <path
      fill="#fff"
      d="M0 73.3h76L0 26.8V0h43.5l106.4 64.8V0h59.9v64.8L316 0h44v26.8l-76.4 46.5H360v73.4h-76.4l76.4 46.6V220h-44l-106.4-64.7V220H150v-64.7L43.4 220H0v-26.7l76-46.6H0V73.3z"
    />
    <path
      fill="#ce1126"
      d="M331.7 0L211.5 73.4h28.8L360 0h-28.3zM360 220l-119.8-73.3H269l90.9 55.9V220zM120.4 73.4L0 0v17.5l91.4 55.9h29zm-.3 73.3L0 220h28.7L149 146.7h-29z"
    />
    <path
      fill="#ce1126"
      d="M0 88.6h162.6V0h35.2v88.6H360v43H197.8V220h-35.2v-88.5H0v-43z"
    />
    <path
      fill="#8fc5ff"
      stroke="#fff"
      strokeWidth={1.1}
      d="M399.7 640.8c0 16.3-2.6 33.9-23.8 42.3-21.1-8.4-23.7-26-23.8-42.3h47.6z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#366cc9"
      stroke="#000"
      strokeWidth={1.1}
      d="M375.9 683a34.3 34.3 0 0 0 18.8-16h-2c-.6-.1-20.3-2-22.7-3-2-.7-9.8.7-13.4 2a34 34 0 0 0 19.3 17z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#5d3100"
      stroke="#000"
      strokeWidth={0.1}
      d="M361.1 673h1.2c.3 0 .3 0 .4-.3s.4-.2.6-.1.6 0 .8-.2c.2-.2.2-.2.4 0s.3.1.5 0c.1 0 .5-.2.6-.5s.4-.4.5-.2.3.2.5.2.2.1.2.4c0 .2 0 .3.5-.1.4.4.5.2.5-.2s0-2-.2-2.1-.3-.8-.4-1.3c0-1 0-1-1-1.5 0-.3-.2-.4-1-.4.1-.1 0-.4-.2-.5s-.2-.2 0-.6c.2 0 .6 0 .7-.3.2-.2.8-.2 1.2 0s.8.2 1.5 0l1.2-.6c.5-.3.6-.4.6-.8 0-1-.3-2-.5-2.5-.3-.5-.3-1-.7-1.9-.4-.8-.4-1-.8-1.5-.2-.2-.3-.3-.3-.6a1.5 1.5 0 0 0-.5-1c-.8-.7-1-3-1.4-4.7-.2-1 0-3.3-.4-3.7-.7-.5-1-.4-1.5-.6-.4-.5-.5-1.4-.9-2.3-.5.1-.8.6-1.1.8s-.4.2-.4.7c0 .4-.3 1-.7 1.8s-1.3.5-2 1.6c-1.4-1.7-1.4-2.2-1.5-2.7 0-.5-.3-.6-1.1-1.3v-1.5c-.7-.5-1.1-.4-1.4 0-.3.3-.5.8-1 1-.2.4-1 1.2-1.6 2.3.6 9 2.6 18 8.7 25.2z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#ff0"
      stroke="#fff"
      strokeWidth={1.1}
      d="M399.7 640.8c0-6.2-.3-12.2-.2-17.4a63.6 63.6 0 0 0-23.6-4.3c-5.3 0-15.7.8-23.6 4.3.2 5.2-.2 11.2-.2 17.4h47.6z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#cf6200"
      d="M394.6 297.9c1.2 1.9 3.3 5 3.5 6.8.8-1.7 1.5-2.4 1.6-3.5s1.5-3 1-4.2-.8-2 .4-1.2c1.3.9 1 2.3.8 4.4-.8 5.7-3.1 6.8-3.5 10.7 3.4 8 .9 11 4.6 19 .6.3 2.1-.3 2.6-.2 2-1.4 3.5-1 6.3-.3 2.8.5 4.3 2.5 4.3 4.3s0 2.2.6 3.2 1.7 2.7 1.5 3.9c-.3 1.2.2 1.9.6 2.4s-.2 2-.5 2.7-.2 1.9 1.2 3.6c1.4 1.8 4.6 9.1 4.6 13.4 0 4.4.3 6.4 2 7.2 1.8.8 2.3 1.5 2.1 3.3s.8 11.6 1 13.1.9 1.2 1.6 2c.7.8 1.1 1.7 3.5 1.7s4.6-.3 6 0c2.2 2.9 3.5 6.8 4 9.3s.4 5.8 1.2 5.8 1.6 0 1.4-3-.5-3.4-1.5-5c-1.1-1.5-1.7-2.2-1.1-3.1s.7-2.4.5-3.6-.6-3 1.4-.6l3.1 3.7c.6.7.8 2.4.7 3.8-.1 1.4.1 2 1 1.2.8-.7 1.8.5 1.3 2s.2 2.5 1.6 3 2 .8 2.3 1.8 1.5 1.5 1.5-.6c0-2-.8-6.5-1.4-7.9-.6-1.4-1-4.4-1.2-6.2s-.4-2.2-1.2-2.5-1.6-1-1.7-1.8-.8-1.1-1.3-1.1-1-.4-1.3-1-.6-.6-1.2-.7-1.5.3-1.8-.6-.7-2.3-1.3-3-1-1-1.1-3.7c0-2.6-.1-3-1-3.9s-2.2-3.4-2.8-4.4c-.5-1-1.1-2.1-1.1.1s0 3.4 1.4 4.2c1.4.8 1.7.8 1.1 2s0 2 .3 2.8.7 1.6 0 2.4c-.7.8-1.4.6-1.3-.7a7.3 7.3 0 0 0-1-3.8c-.5-1-1-1.8-1.7-1.2s-1.3-.1-.8-.6.3-.8 0-1.1-.5-.7.1-1.4.6-1 .2-2.7c-.3-1.6-2.9-9.8-4-11.7s-1-3.2.4-1.4 2.8 3.5 3 5c0 1.6.4 2.5.9 3s.8.4 1-.9 1.2-.8-.4-3.2c-1.7-2.5-4.7-6.6-5.9-14s-1.6-12.1-2.8-14.1c-1.1-2-1.5-2.5-1.6-4.3s0-3.8-.8-5.2c-.8-1.4-1.4-1.6-1.5.5-.1 2 0 6.8.7 7.6s.2 2.9 0 4-1.9 2.4 2 4.7c1.5 1 1.2 2.2 1 3-.2.9-.5.8-1.3-.5s-1.6-2.4-2.4-3-1-1.2-.8-2.9.4-2.8 0-3.3c-.5-.6-.7-.2-1 .8-.2.9-.4 3.5-1 4.2s-.6.2-1-1.3.2-3.9 1-6.5 1.3-5.5.6-9c-.7-3.5-.4-4.6-3-7.5-2.7-2.9-5.8-5.7-7-9.3-1.3-3.6-1.6-6.8-3-8.4a19.4 19.4 0 0 0-4.6-4.3v-5.4c0-1.3-.6-2-2.1-1.8s-2.5 1.5-3.4 3.2c-1 1.8-1.6 1-3 4s-3 4.5-3 7.8z"
    />
    <path
      fill="#cf6200"
      d="M403 332c1 .7 1.9 1 3.3.3s3-2.7 5-.7c1.8 2 2.8 5.3 2.8 7.8 0 2.6 0 7.4 3 10 2.9 2.7 4.4 5.5 4.5 9a61 61 0 0 0 1.7 10.3c.4 1.4 1.2 3 2.1 4s1.7 3.6 1.8 6.4c.1 2.8-.4 4.7 0 6.1s0 2.6-1 2-1.3-1.1-2-2.3-1.2-1-.6.8 2.3 3.4 3.8 3.4 2 .2 3 1.2c.9.9 1 1.4 2.6 1.4s1.9 0 3.4.4 1.5.3 2.3 0 1.7.5 2.2 2 2 5.7 2 6.9 0 2.3.8 3.5.6 2.3-.3 1.6-1-.5-1.6-.3-1.2-.3-2.1-.9c-1-.5-.4-.4-1.3-1.8s-1.5-1.9-1.5-.8-.2 2.3-.9 1.7-1-.6-1.6 0-.8 1-1.5-.1-1.5-1.2-2.2-1.4-.7-.2-1-1.3c-.4-1-1.5-1.3-2.4-1.3s-1.4-.4-1.5-1.1c-.1-.7-.7-1.2-1.2-1.5s-.2-1.2-.3-2-.8-.5-1.3-.7-.8-.1-.8-1.3-.5-1.5-.8-2.3c-.4-.9 0-1.7.2-2.6.2-1 .1-1.5-.6-2.3-.7-.8-.1-1.7-2-3.3s-2.8-.2-3.4-4c-.5-4-1.7-11.9-2.8-13.1s-1.7-2.3-2.8-2.6-1.7-.1-1.8-2.3c-.1-2.2-.8-5-2.2-6.4l-2.7-2.5c-.7-.5-1-1.6 0-3.6s.6-4.7.5-6c-.2-1.2-.5-2.9-.3-4.3s.1-3.1-.2-4-.8-1.2-.2-2zm28.1-33a25.4 25.4 0 0 1-5.4 5.2c-2.2 1.6-5 2.8-3.4 5.4 1.5 2.7 2.8 3 3 5 .4 2 .9 3.8 2.4 4.2 1.6.5 2.2.2 2.2 3.4s0 4.6 1.4 5.8 1.2 2.5 1.8 5.4c.7 3 .7 9.4 2.5 13.7s6.1 12.6 5.6 14.3-1 3 .8 5c1.9 2 3.1 5 3.3 6.7.1 1.7.4 2.3 2.3 1.7a6.8 6.8 0 0 0 3.4-2c.6-.8 1.9-.6 3.6.3 1.7 1 4.4 1.8 6 1 1.5-1 2.2-2.4 3.6-2.4 2.2-1.6 3-4.8 3.5-5.8.4-.9.1-.9-.8-1.8s-.5-2.5-.6-4c-.2-1.6-.8-4-2.7-7.4-1.8-3.4-3-7.6-4.2-8.7-1.2-1-1.8-3.7-2-5-.1-1.2-1.5-2.3-2.5-3.2-1-1-1.8-2.4-3-7.8-1-5.4-1.8-9.3-1.8-10.3s-.2-1-1.1-1.4-1.4-1.8-1-2.6c.2-.8-.4-1.6-.7-2.5s0-2.6.6-3.6.5-3.5-.1-5.7-1.3-4-3.8-4.4c-2.4-.3-3-1-3.8-3-1-2-2-5.5-2.2-6.3-.3-.8-.8-1-2.7.6-1.8 1.6-2.5 2-2.5 5 0 1.9.4 2.5 1 3.6.6 1 .8 1.4 1.2 4.3s3.1 7.6-.3 10.3c-3.4 2.6-3 3.3-2.8 5.1.2 1.9-1 3.1-1.5.5-.7-2.7 0-4.2 1.8-5.5 1.9-1.2 3.6-2.8 2.4-4.5-1.3-1.7-1.8-5.7-2-7.6s-.4-2.5-1.5-1z"
    />
    <path
      fill="#00b800"
      d="M403.4 338.5c0 1.3.2 2.7.3 3.8.1 1.3.5 4-.5 6-.9 2-.7 3 0 3.6h.1c2-.6 2.2-2.7 1.7-3.7a3.7 3.7 0 0 1 .2-3.5c.6-1.1.6-1.7.1-2.5-.6-.8-.6-.8 0-3 .6-1.9-.8-1.9-1.9-.7zm20 30.2c-.4-1.4-1.7-6.8-1.8-10.3-.1-3.5-1.7-6.3-4.6-9-2.2-2-2.7-5.4-2.9-8-1.7-1-2.4-.6-2.2 1.4.1 2 2.2 3 2 6.1-.4 3-.4 2.3 1 3.7s2 3 1.3 3.5c-.8.6-.8 1.7.2 2.1 1.1.4 1.2 1.6 1 2.7-.1 1 1 1.3 1.5 2 .7.8.7 2.7.1 3.8-.6 1-.7 2.8.4 1.9 1-1 1.6-.1 2.4 1.4.7 1.2 1.4.8 2.2.5a9.8 9.8 0 0 1-.7-1.8zm15 27.1c-.6 1.4-1.4 1-2.1.3s-1.5-.7-1.2-2 .2-1.5-.7-2.2l-.3-.3h-1c-1.7 0-1.8-.4-2.8-1.4a7.8 7.8 0 0 0-.6-.5v.9c0 1.3 0 1-1.2 1.4s-1-1.3-1.3-2.3a3.9 3.9 0 0 0-.2-.7c-1.4-.2-3-1.7-3.4-3.3-.6-1.8 0-2 .7-.8s.8 1.5 1.8 2.2 1.4-.5 1-1.9a6 6 0 0 1 0-1.5c-.3-.5-.6-.8-1-1-2-.9-1.4-1-1.3-2.6.2-1.5-.2-1.5-1.4-.7-1.1.8-1.2-.1-1.2-2.5s-1.6-2.3-1.9-.7c-.4 1.7-1 .6-1.6-1.7s-1.7-3-1.8-.7c0 1.9-.6 2.3-1.8 1.3l.5 3.6c.6 3.8 1.5 2.4 3.4 4s1.3 2.5 2 3.3c.7.9.8 1.4.6 2.4-.3.9-.6 1.7-.3 2.5.4.9.9 1.2.9 2.4s.3 1 .8 1.3l1 .1.8-1.2c1.4-1.4 3.5.1 4.2 1.9s1.5 2.2 2.6.8.7-1.2 1.9.1 1.6 1 1.6 1 1.2-.4 2 .3 1.3.6 2.8-1.6c1.5-2.3-.7-1.6-1.4-.2zm4.2-64c.5-3.4.2-6.8 1.6-8 1.4-1.3 3-3.8 3 1.5-.2 5.3-.4 5-1.5 6.2-1 1.3-2 1.6-1 3.6 1.2 2 1.3 2.2 1.2 5.3-.2 3.1-.2 4.4 1 6 1.3 1.5 1.6 1.6 2 3.3.2 1.7 1.3 4 2.7 5.3s3 4.8 3.1 7.3c.2 2.5 2.4 3.1 4.4 4.9 2 1.7-.5 2.9-2 2.1-1.6-.7-1 0-1.9 1.1-1 1.1-1.2 1.3-2-.6s-3.4-3.1-4.7-3.6-2.3-2.5-3.4-4.5a6 6 0 0 0-4.5-3.1c.5 1.3.7 2.3.6 2.8-.5 1.7-1 3 .8 5 1.9 2 3.1 5 3.3 6.7.1 1.7.4 2.3 2.3 1.7a8.3 8.3 0 0 0 3.4-2c.6-.8 1.9-.7 3.6.3 1.7.9 4.3 1.8 5.9.9 1.5-1 2.3-2.3 3.7-2.3 2.2-1.6 3-4.9 3.4-5.8.5-1 .2-1-.7-1.9s-.5-2.5-.7-4c-.1-1.6-.7-3.9-2.6-7.3s-3-7.6-4.2-8.7c-1.2-1.1-1.9-3.7-2-5-.2-1.2-1.6-2.3-2.5-3.3-1-.9-1.9-2.3-3-7.7-.8-4.3-1.5-7.6-1.7-9.3-1.1 1.8-1.9 2.3-2.3 1-.5-1.4-1-2.1-1.7-1.2-.6 1-.8-.8-.8-1.6s-.1-.9-1-.9 0-1.2-.4-3.6c-.3-2.3-.8-2.6-1 .2-.4 2.8-2 4.5-1.3 5.1.6.6.3 1.9-.3 3.7-.6 1.9-.3 3 .1 4.2s-.3 3.6-.6 5.6c-.3 2 1.3 4 1.7.7zM414.2 304c-1.1.1-2 1.1-1.3 4.7.5 2.2-1.2 1.7-1.8.6-.6-1.1-1.1-3.4-2.4-5.4-1.2-2-.6 1.3-.7 3.2-.2 1.9 1 1.9 2.1 3.4 1.1 1.6.2 2.2-1 2.2s-.7 2.5-.4 4.2-.3 2-1.2.6c-1-1.4-.3-3.5-.2-6.2.2-2.6.4-2-1.4-2.6-1.7-.7-1.4-1-.7-2.5.6-1.6 1.2-2.4.4-3.1-.7-.8-.6-1.3.7-1.4 1.2-.2.7-1.1 1.8-1.4 1.1-.3 1.6.1 1.7-1.9.2-1.7.7-2.7 2-2.2.8 2.6 1.7 6.6 2.4 7.8zm15.7 18.4c0 3.2 0 4.5 1.4 5.7s1.2 2.5 1.8 5.4c.7 3 .7 9.4 2.5 13.7l2.1 4.7a8.8 8.8 0 0 0 2.3-3c.4-1-1-3.2-2-5-1.1-2 .1-2.6 1.2-5 1.1-2.2-.1-2.4-1.9-3-1.7-.6-1.7-2.2-2.6-4.7s-.8-3.6-.2-5 .2-2.5-1-2.8c-1.3-.3-1-1.2-.5-2.8.5-1.5.8-1.8-1.1-1.4-1.4.4-1.8.7-2.2 1.2l.2 2z"
    />
    <path
      fill="#5d3100"
      d="M447.8 328.8c-.2 1.8-.2 2.8-.7 3.4-.4.6-.1 1.5.4 2.5s.7 2.1.3 3.9.3 3 1.2 3.5 1.4 0 1.1 2.2a6.7 6.7 0 0 0 2 5.5c1.1.9 1.9 2.4 1.7 3.4-.1.9.8 1.8 1.9 2.3 1.1.5 1 .6 1 1.2s.4.7 1.6 1 2.2 1 3.6 2.8 3.4 2.6 3.1.8 0-3.2-1.8-4c-1.9-1-3.3-5.5-4-8.6-.9-3.2-3.3-7.3-4.7-8.1-.2-2.2.1-3.3-1.3-4.4a4.5 4.5 0 0 1-1.9-3.6c0-1-.7-2.4-1.4-2.8-.6-.3-.9-1-.9-2s-1-.8-1.2 1z"
    />
    <path
      fill="#00d860"
      d="M439.5 412.2a45 45 0 0 0 11.2-3.2c1.9 1.3 5.1 3 6.5 3-2.6.6-4.4.3-5-.2.3.8 1.2 2.1 1.8 2.2-2.6 0-5.5-.7-6.4-1.6-2.3 1-6 1.2-8-.2zm5 3.5c1 .3 6 1 6.6 1-1.6 1.5-.2 2.8 2.5 2.6-1.3.2-2.8.7-1.8.9a28 28 0 0 0 10.2-2c-2.2 2.8-13 5.5-17.5-2.5zm4.5 7c1.3-.6 4.6-.4 6.2.3-1.7.7-5.2.7-6.2-.2z"
    />
    <path d="M454 422.7c2.4-.4 9.1 1.2 11.5-.3-.8 2.2-5 2.5-6.5 2-1.5-.4-2.9-1-3.9-1 .6-.3-.3-.3-1.1-.7z" />
    <path
      fill="#00d860"
      d="M456.4 426a35 35 0 0 0 10.3-1.3c2 .7 6.2 1.8 7.2 1.7-2 1.2-5.8.5-7 0a12.5 12.5 0 0 1-10.5-.4z"
    />
    <path
      fill="#00d860"
      d="M459.5 427c2.6.6 4.8.2 7.4-.6.8.3 2.6.7 4.4.7 1.2.6 2.7 1.5 4.3 1.7a19 19 0 0 1-8.6-.7 22 22 0 0 0-9.1 1.7c0-.8.5-2 1.6-2.7z"
    />
    <path d="M456.4 414c2 .6 9.4.3 13-1.5 1.6-.7 2.5.5.8 1-6 2.2-10.9 3-14.3 1.1-1.4-.7-1.6-1.4.5-.7z" />
    <path
      fill="#00d860"
      d="M492.2 404c-9 4.2-14.9 5.5-27.4 1.6-1.1-.3-2 0-.7.8 1.3.9 8.2 2.7 9.8 2.9s1 .8 0 1.1-1.2 1 .1.5 8.9-.7 12 .9c1.3.7 1.6.5 1.5 0s.6-.9 1.6-1 1.6-.4.8-.7-.9-.5-.3-.8.7-.6-.2-.8-1.5-.4-.7-.8c.9-.4 2-.7 3-.8.2-.6-.2-2.3.5-2.9z"
    />
    <path d="M477.3 405c5.1.4 14.6-2 19.6-6.8 1.7 1 4.2 2.2 5.5 2.4s2.4 1.4.4 1.4-4.7-.8-6-1.4a33.8 33.8 0 0 1-19.4 5c-1.4 0-1.7-.6-.1-.5z" />
    <path
      fill="#00d860"
      d="M462.1 377c1.8 1.3 4.9 3.3 8.9 3a19.5 19.5 0 0 0 6.5 3.3c-2.7 1-5.6 2-6.4 2.9-1.2-1.2-2.8-1-3.2-1.6-1.2 1-1 1.5-.2 2s6.6 1.4 8 1 2 .8.7 1.3c-3.1 1-9.2 0-11.3-3.4-2.2-3.3-4-4.6-9.7-1.5-.6-1.7-.6-2-1.7-2s-3.2-1.5-1.6-1.5 6.2-.6 10-3.4z"
    />
    <path
      fill="#00d860"
      d="M463.5 384.6c-1 .2-3.7 1.7-4.7 1.8-1 .2-2.7 1.6-1 1.6 1.9 0 4.2-2 5.5-2s1.4-1.7.2-1.4zm5.7 5.9c-.7.1-3.7.8-4.5.8s-1.7.1-1.6.7.3 1-1 .8-2.2.4-2.5.7-.5.7.7.8 1.9.3 3.3-.4 2.7-1.6 4.2-1.7c1.5 0 3-2 1.4-1.7z"
    />
    <path d="M465 394c1.3 1 7.6 3 9.8 2.9s1.9.9.2 1.3a14 14 0 0 1-11-3.2c-1.4-1.1 0-1.6.9-1z" />
    <path
      fill="#00d860"
      d="M494.8 397.2c-4.8 1.5-9.7 1-11.7.4s-3.8-.6-2.4.7c1.3 1.3 5.6 2.1 8 1.5-8.6 2-10.9 1.8-13 1.5-2.2-.4-6.2-.3-8-.2-1.2.2-3 0-3.8-.5s-1-1.3 1.3-1c2.3.1 2.6-.3.6-.6s-4.7.5-2 2.2 8.5-.1 12.3 1a21.4 21.4 0 0 0 19.1-4.3c.4-.3 1-1.2-.4-.7zm-23.7-7.1c.2.6.2 1.2 0 1.6s-.1 1 .6.4 1.2-1.3 2-.9 2.7.4 3.6.2c.8 0 1.1-.3-.2-.8-1.2-.5-2.5-.7-3.2-.6s-1.6-.1-2.2-.4-.7 0-.6.5z"
    />
    <path
      fill="#00d860"
      d="M483.6 392.3c-1 0-2.8-.6-3.7-1s-2.3-.4-1.3 1 5.3 2 6.8 1.4 1-1.4 2.4-.4c1.5.9 3.1 1.5 4.2 1.5s1.5 0 .3-.7-1.8-.8-2-1.4-.2-1 1-.6 2.3 1 3.2.5 2.5-1.5 4-1.5l.3-.9c-2.1-.1-3.5.5-4 .7s-1.7.4-2.8.2-2.5-.3-2.9-.6-.3-.5.6-.7 1.2-.8 0-.6-4.8.2-6.6-.4c-1.8-.6-2.6-.7-3.3-.4-.8.3-.7 1.1.4 1.2s3.7.3 4.5 1.1.8.9-.2.5-2.8-.2-1 1.1z"
    />
    <path
      fill="#00d860"
      d="M498.8 390.2l-.4.9c2.2 0 7.4.5 9.1 1.5 1.7-1.3 1.4-1.7 2.5-1.4s2.7.6 3.3.3 1.1-.3 1.8-.2 2.2-.2 3.1-.7 2.7-1.2 3.7-1.2 2.3-.3.4-.6-4.8.3-5.8.7c-1 .3-4 .6-5.7.6s-4.1.8-6.1.3-4.8-.2-6-.2z"
    />
    <path d="M525.8 389.2c-3.5 2.6-7.7 3.1-12.7 3.5-1.5.1-1 .5.2.6 5.3.6 11.3-1.4 13.3-3.5.6-.6.5-1.6-.8-.6z" />
    <path
      fill="#00d860"
      d="M502 395.2a54 54 0 0 1 8.4 2c1.3-.2 1.7-.5 1.4-1s-.4-1 2-.8h8.6c.9-.3 2.7-1.7 3.5-1.7-2.1 0-10.9.5-12 .4s-1.7 0-2.4.4-1 .6-2 .2-2.4-.8-3.3-.2c-.8.5-2.7 0-4.2.7z"
    />
    <path
      fill="#00d860"
      d="M522.4 395.4c.8-.3 2.6-1.7 3.5-1.8 1.5-.1 3.2.5 4 .7s1.7-.1 1.2-.7-.1-1.8 2.3-1.5c2.4.3 3.6.7 6 .5s3.3 1.5 7.7-.3c-.3 1.8.5 1.9 1.3 1.6s1.8-.3 3.2.8 9.9 1.1 11.9.8c2-.4 3 .7 1.5 1.2-1.5.4-1.9 1.1-1.5 1.6.3.5.7 1-1.2.8-1.9-.2-2.2.4-3.1 1s-1.2 1-3.8.5c-2.5-.4-3-.1-4.4.1s-1.8.3-3.2-.2-4.4-1-6.3-.3-3.2 1.1-4.9.7-1.7-.3-.7-1.3 1.3-1 3.3-1.2c2-.2 3.5-.8 2.1-1.6s-1.8-.7-3.7.2-2.8 1.5-5 .4c-2-1.2-3-1-4.5-.6s-3.7-.5-5.7-1.4zm7 3.5c-2.7.4-3.4-1.3-6.2-1-.9.2-2.5 1.3-.3 1.1 2.1-.1 4.5 1 6.6.9s1.2-1.1 0-1zm-3 2c1.3-.5 4.2.5 5.5.3s2.4.5 1 1-4.3-.8-5.7-.4-2.8-.2-.9-.9zm-28 7.6c2 0 9-.3 11.7-6 .2-.5.4-.7 1.2-.1s4.1 2.5 10.1 3c1.7.1 3.5 1 .1.8s-8.7-1.2-10.5-2.3c-3 4.8-8.5 5.3-12.5 5.2-2.5 0-1.9-.7 0-.6z"
    />
    <path
      fill="#00d860"
      d="M513.5 400.5c-1 1.3-4.2 3.5-5.6 3.7-1.5 0-5.9-.3-7-.7s-2.4-.3-.9.8 5.5 1.8 7 1.5c1.7-.4 3.5-.9 4.7-.1s3.5 2.2 4.8 1.9c1.4-.3 4.1-.3 5 .1.9.4 2.4 1.7.1 1s-4.1-.2-5.2-.6c1.2 1.6 3.8 4.2 6 4.2.6 0 1 1-.1 1.5 1 .5 3.6 1 5-.3-.4.5-.2.8.4 1s1.3.7.2.9-3.4.4-4.1 0c2.2 1.5 8.1 3.9 14.1 2.7 1.2-.2 1.8-.7 0-.6-4 0-4.2 0-4.9-.4-.7-.4-.5-.8.6-1.1 1-.3 3.9-.8 5-.8s2.4-.4 0-.4-5.3 0-6.5-.4-2-1-.8-1.8 2.5-.6 3-1.3c-3.8 0-8.5-2.1-5.9-4 .6-.4.4-.5-.5-.6s-4-1-5.2-1.6-.4-1.3.6-1.5c-2.3.4-6.8-.8-9.8-3zm34.1 0c-2 1.5-6 2.2-7.7 2.2s-2 .6-.6.7 2.8.4 3.4.2 1-.2 1.8.2c.9.4 2.7.6 4.4.1s4.3-.8 5.4-.7 2.3.1.1-.5-5.8-.2-6.7 0-3.3 0-2-.3 2.4-1 3-1.6l-1-.3zm-1 4.5a13.5 13.5 0 0 1-7.1 2.7c2.4.9 4.4 3.4 6 3.3-.8.5-1.7 1.2-2.7 1.3 1.6.4 4.1 0 6.2-1.2 3.5 1 8 .3 9.6-1-2.3 0-5-.8-6.3-1.9 1.1 0 2.2-.6 2.7-1.3-2.6.5-7-.8-8.4-2z"
    />
    <path
      fill="#00d860"
      d="M542.8 412.3c1-.1 2-.8 2.7-1.3a22 22 0 0 1-12.8-2.9c-2.5-2.2-2.5-.5-.8 1s4.9 4 11 3.2zm6.2 5.3c-1 .6-6 1-7.7.6s-2.3-.2-2 .5.7 1.2-.7 1-3.7.2-4.7.5-2.2 1.2-.1.9 4-.8 5.6-.4 7.1.5 8.2 0 .4-.4-.1-.4-.8-.3 0-.7 1.3-1.3 1.5-2zm-48.5-6.7c-2.1.9-9.1 2.8-11 2.9-2.3 1-4.2 1.6-5.3 1.6.8.7 4 1.4 5.2 1-.7.8-2.3 1.6-2.9 2 1.9-.3 4 .2 5 .3a14 14 0 0 1-7.6 1.6c.6.8 1.4 1.6 2.5 1.6a13 13 0 0 1-6.3.2c.6 1.1 1.1 1.8 2 2-1.9.2-4.2.5-6.2-.6 1.5 2 4.9 2.6 9.9 2 5-.5 9.2-2.7 10.4-3.7-2.1.3-5 .4-6.3.1a37 37 0 0 0 9.9-4.3 5.6 5.6 0 0 1-3.2-1 31 31 0 0 0 9.1-1 6.7 6.7 0 0 1-4-2.6 39.2 39.2 0 0 0 19.5.6c1-.3 1-1.5-.8-1.3-3.2.2-9.5-.7-11.2-1.5a11.6 11.6 0 0 0 4.7 2c-3 .9-7.2 1.5-13.4-2z"
    />
    <path
      fill="#00d860"
      d="M486.5 418.4c.6-.4 2.2-1.2 2.9-2-1.3.4-4.4-.3-5.2-1 1.1 0 3-.5 5.3-1.6-4.2-.1-7-.1-8.6-1s-4.3-.5-5.4-.3-.7 2 3.8 1.5a15.4 15.4 0 0 1-8.8 1.3c.5 1.5.8 3 .4 3.9 2.4 1.4 8.8 3.1 12 2.9-2.8-1-4.3-2.2-2-2.5s3.6-.7 5.6-1.2z"
    />
    <path d="M479.3 426c5.5-.5 13-.6 19-5.7 1.5-1.2 2.5-.8 1 .5a33 33 0 0 1-18.4 6.8c-3 0-4.4-1.4-1.6-1.7z" />
    <path
      fill="#00d860"
      d="M521 416.7c-1.3.5-5.2 1.2-6.4 1-1.2-.2-2.9-.2-3.8.3s-1 1 .3 1l3.7.3a6.2 6.2 0 0 0-2 1.7c2-.4 5.4.4 6.4 1a3 3 0 0 1-2.3-.5c3.1 3.4 12.5 3.4 14 2.8-.7.5-1.4 1-2 1.2 2.6.5 5.6.4 8.6-1.3-1 .1-4-.1-4.8-.2a5.6 5.6 0 0 1 2.3-1.3c-1.2-.3-4.8-.2-5.7.3a4 4 0 0 1 1.7-1.9c-4.6 0-10.2 0-12.2-1.1 3.2.3 6.8-1.6 8.3-1.6-2.5 0-5.3-.6-6-1.7zm-11.6 2.5c-2.3.5-5.7 1.5-6.7 2s-1.9.8.1.8a125.5 125.5 0 0 1 .7-.2c-.8 0-1.7 0-.2-.5s3.5-1.5 6-2zm-4.6 5.5c.8 0 4.3 0 5.7-1.2 1.5 1 4.3 2.6 6 2.6 1.9 0 1.7.5.1.7a12 12 0 0 1-6.2-2c-2.1.8-3.8.2-5.7-.1zm-27 15.7c3.6 1.4 8.3 2.4 11.8 1.3 2 1.7 6.1 1.8 8.3 1.4 2.2-.5 4.2-.7 6.7 0 2.4.9 7.4 1 8.8 2.1-1.3 0-4 0-4.7.2-.6.2-.3.6 1 1.2-4-.2-10.9 1.5-13 3.3a7.3 7.3 0 0 1 6.8-4.3c-2-.7-8.8-.8-11 .6a6.7 6.7 0 0 1-1.4-2.4c-3.6 2-10.6-.9-13.4-3.4zm-9.3-6.6a16 16 0 0 0 8.5-3.2c.8.7 4 1.4 7.4.3-.7.5-.8 1.5-.5 2a26.2 26.2 0 0 0-8 2c-1.5.7-5.8 1.3-7.2.5-1.4-.7-1.4-1.4-.2-1.6z"
    />
    <path
      fill="#00d860"
      d="M483.9 433a26.2 26.2 0 0 0-8 2l.5 2a51 51 0 0 1 17.5-1.8c-1.8.1-5.1 2-7 2.1 4.6-.3 9 .6 10.2 1 1.1.2 1.4 1 .5 2s-1.3.8.6 1c1.8 0 5.7-.3 7.4-2-.7-.7-2.5-.4-3-1a8 8 0 0 0 3.1-1.9 29 29 0 0 1-5.3-.3c-1-.3-1.8-.6-.5-1.3a7.6 7.6 0 0 0 2.2-1.7c-2.2.6-5.8 1.2-8.8-1.2 1.1.3 3.8.1 4.7-.3a6 6 0 0 0-2.6-.9c2.4-1.2 7-2.2 13 .1 2.8-.2 6 0 8.2.5 1-1 2.9-3.2 4-3.7-7 .5-19.3-.7-19-4.4-2.3 3-7.4 4.6-9.6 4.1-.2 1 .7 2.4 1.5 3-2.3.5-6.3.9-8.2.5 1.1 1 3 2 4.2 1.9-2.4 0-3.7.5-5.6.3z"
    />
    <path
      fill="#00d860"
      d="M498.1 441.2c2 0 5.8-.2 7.5-1.9-.7-.7-2.5-.4-3-1a8 8 0 0 0 3.1-1.9c5-.4 9.3-.2 11.4-.8 2.1-.6 7.5-.3 8.5-.6-4.7.8-5.6 1.2-5.8 2s1.5 1.3 2.6 1.3c-2 0-4.7 2.1-5 3-2.8-1.6-4 .3-4.4 1-1.1-.5-5-.4-7 1.3-2.5-.8-4.2-1.2-6.8-.8 1.6-.3 1.3-1.4-1-1.6zm22.4-13.7c1.6 0 5 .2 6.3 0a7.5 7.5 0 0 0-2.1 1.5c4-.5 9.4-.8 11-.5-2-.3-4 1-5 1.6s-.4 1 1 1.2 3.1 1.2.7.9-7.3-.4-8.5-.2-1.8-.4 0-.7 2.8-.8 3.6-1.2c-1.4.3-4.1.3-5 0s-1.3-.6-.3-.9.3-.5-.7-.4-3.5 1.1-5 2.5c1.6-1.6 3-3 4-3.7z"
    />
    <path d="M502.8 430.2a10 10 0 0 0 7.8 3.5c.7 0 2.2 1 .3 1.1-4.9.2-7.3-1-9.5-4.1-.4-.7.4-1.6 1.4-.5zm29.2-40.8c2.6 1.2 7.7 2.3 11.8 2.1.7 0 2 .7.3.9a21 21 0 0 1-12.4-2.3c-1-.6-.7-1.2.3-.7z" />
    <path
      fill="#00d860"
      d="M534.6 389.4c4-.1 7 0 8.1 1 2.3-.6 6.4-1 7.3-.8s2-.3-.2-.8-7.1-.7-8.7-.4c-1.6.3-6.5.5-8 .3.6 0 1 .2 1.5.7zm15.4 1.5c1.8-1 7.2 0 8.8-.7-1.1 1.4 3.8 1.5 8 .4-1.6 1-5.1 1.2-6.6 1.9s-2.4.1-3.5-.4-4.2-1.6-6.7-1.2z"
    />
    <path
      fill="#00d860"
      d="M566.8 390.6c-4.2 1-9.1 1-8-.4-1.6.7-7-.3-8.8.7 2-1.1 3.4-.2 4.8-2.6.9.2 2.9.3 3.6-.6 1.2.3 3.4.8 4 1.4.6.7 1.6-.2.8-1.1 2-.7.7.8 5.2-.3 1-.3 3.2-.7 4-.7a27.6 27.6 0 0 1-5.6 3.6z"
    />
    <path
      fill="#ff0"
      stroke="#000"
      strokeWidth={0.1}
      d="M373.4 664.2l-.2-22.2c0-1-.5-.8-.5 0v22l.7.2zm7.2-23.4l.8 23.4-.1.2h-.5l-.5-23.6h.3zm6.8 19.8l-.4-19c0-.6-.5-.5-.5.1l.4 18.9h.5z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M376.6 644.7l-7-.1c-.3 1.4 1.4 1.3 2 1 .8.5 1.4.5 1.8 0 .6.5 1.4.4 1.7 0 .8.7 1.7 0 1.5-1zm.5 3.4h-7c-1.3 1.2.3 1.8 1.7 1 .2.4 1 .6 1.6.3.6.4 1.4.1 1.8-.3.7.3 1.6.4 2-1zm-.2 4.5h-6.8c-.1 1.1 1.3 1 1.8.7.5.8 1.7.6 2.1.1.7.5 1.3.4 1.6 0 .7.6 1.4-.2 1.3-.8zm.4 4.4l-7.7-.1c-.4 1.3.8 1.5 1.3 1.2.2.7 1.2.5 1.5 0 .4.3.9.1 1.1-.2.1.7 1 .8 1.7.2 1.4 1 2.7-.2 2-1.1zm6.7-1.8h-6.3c.3 1.2.9 1.5 1.9.8.8.8 2 .5 2.3.1 1.4 1.1 2.1-.2 2.1-1zm-.6-4.4l-6.2-.2c.1 1.6 1.6 1.5 2.4.9.5.7 1.5.5 2 0 .7.8 2 .3 1.8-.7zm.8-4.9h-6.6c0 1.1 1.5 1.7 2.6.7.3 1.3 1.5.9 2 .4.8 1 2.5-.2 2-1zm-.4-3.3l-6 .1c0 1 1.4 1.4 1.9.6.3.5 1.3.4 1.6 0 .4.7 1 .2 1.2 0 .7.5 1.4.2 1.3-.7zm6.9 2.2l-7.2-.1c0 .7.7 1 1.2.7 0 .8 1 1 1.7.4.4.7 1.7.8 2.2 0 1 .9 2.2.2 2-1zm-.1 5.9h-7c0 1 1.1 1.3 1.8.8.1.8 1 .9 1.5.4.7.7 1.7.8 2.3 0 .8.3 1.5-.4 1.4-1.2zm-.4 5.3h-5.6c0 1 1.2 1 1.7.5.6.7 1.4.7 1.9.2.7.6 1.9.4 2-.7z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M381.3 664.4c-3 0-6.1 0-8.2-.2s-2.7-.6-4.2-1.5l-5.6-3.4c-.5-.2-1 .1-.3.5l5.6 3.7c1.5 1 2.5 1.9 3.4 3 1.2 1.3 2 1.3 2.6 1.1s1.4-.5 2.3-.3c.8.2 2 .3 2.6.2.5.5 1.8.4 2.5.2s1.2-.2 1.7-.1h1.7c.5 0 1.8-.3 2.7-.2 1 .2 1.9 0 2.5 0a5 5 0 0 1 2-.1c.6-.4.8-.9 1-1.4.6-.1.8-.2.9-.5l.6-1.6h.2v-.6l-.4-.6.2-1 .5-.2-.2-1-8.8.2a2 2 0 0 0-.6 1.1l-2.6.4c-.3.1-.6.1-.9.5l-1.2 1.8z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M391.8 660.5l1.3-4.9c.2-.5-.3-.6-.5 0l-1.3 4.9h.5z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M396.9 655c-1.1.5-1.7.8-2.2.6-.5-.2-1.1-.3-1.5-.1a.5.5 0 0 1 0 .1 493.3 493.3 0 0 1-1.1 3.8c.8.3 2.2.3 2.5 0 .4-.4 1.3-.3 1.8-.3.3-.4.4-.9.3-1.1s0-.7 0-1 .4-1.4.2-2z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M371.7 645.6a53.2 53.2 0 0 1-8 14m2 1.2a54.5 54.5 0 0 0 11.4-12.6m-7 4.3c-.3 2.7-1.1 7.5-1.5 10m2.6-4c-1 1-2.3 2.6-3.4 3.5m12.7-8.9c-.8.8-1.7 1.8-2.6 2m3.1-1.8a7 7 0 0 0 2.7 1.9m-3.2-6.2a8.5 8.5 0 0 1-3 1.7m3.4-1.6c.6.6 1.3 1.3 2.2 1.7m-5.4-4.9a7 7 0 0 0 2.7-1.5m.3 0c.7.7 2 1.4 2.7 1.6m-5.5-3.3a4 4 0 0 0 2.4-1.4m.3-.2c.7.6 2 1.4 2.7 1.5m3.2.8c-.4.5-1.5 1.3-2.2 1.3m2.7-1.3c.3.5 1.1 1.3 1.6 1.3m-4.8 6a7.2 7.2 0 0 0 2.8-1.9m.5.1a5.6 5.6 0 0 0 1.9 1.8m-4.1 5.2c.4 0 1.5-.6 1.8-1.3m.6-.3a7 7 0 0 0 2 1.7m-18.7.9c1.3-.4 3.8-2 5.1-3.5m-2.4 1.9c1 .7 2.3 1.5 3.2 1.7m-6.2-4.5a8 8 0 0 0 2.4-1.5m.5-.1c.3.4 2.4 1.7 3.3 1.7m-3.8-5.9a9.8 9.8 0 0 1-2.5 1.4m3-1.4c.7.5 2.2 1.4 3.1 1.4m-3.6-5.4c-.6.6-1.6 1.6-2.4 1.9m2.9-1.8c.4.7 1.6 1.7 2.4 1.8m8 2.6c1.9 3.3 5.3 7.4 8.7 9.6m-14.1-13.3c2.8 4 8.2 12.7 13.4 15.9m1-3.4a18.4 18.4 0 0 1-4.9 4.6m4.5-3.5c-1.7-2.8-2.6-6.3-4-11m-14 12.4l2 6m-2.4-6.1l1.9 6m-2.4-6.3l1.8 6.2m-2-6.1l1.4 6.1m0-.2h1.7m-.2-.6h-1.6m1.4-.5h-1.6m1.4-.5H374m1.3-.6H374m-.1-.5h1.3m-1.4-.4h1.3m-1.4-.5h1.2m-1.3-.4h1.1m-1.2-.5h1m-1.1-.4h1m-1.1-.3h1m-1-.4h.9m-2.6 0l-1.2 5m1.5-5l-1 5.2m1.3-5.4l-.8 5.5m1.2-5.6l-.6 5.8m.7-.4h-2m2-.5h-2.3m2.3-.6h-2.1m2-.5h-1.9m2-.5h-1.9m1.9-.6H371m1.7-.5H371m1.6-.5h-1.5m1.5-.5h-1.3m1.3-.5h-1.2m1.2-.3h-1.1m1 5.5v-5.9m6.5-2l-4 8.1m4.3-8.2l-3.4 8.3m3.6-8.4l-2.7 8.4m3-8.2l-2.2 8.2m.1-.3h-2.5m2.7-.8h-2.4m2.5-.6h-2m2.4-.6h-2m2.1-.6h-1.9m2.1-.6h-1.8m2-.7h-1.6m1.7-.5h-1.5m1.7-.6h-1.4m1.5-.4H378m1.4-.4H378m1.3-.4h-1m1-.3h-.9m1-.4h-.8m1-.4h-.8m.8-.3h-.7m3.4-.1l1.7 5.6m-1.4-5.5l2.1 5.4m-1.8-5.4l2.5 5.3m.6-.5l-2.8-4.9m2.8 5h-2m1.8-.8h-2m1.7-.6h-1.9m1.5-.7h-1.7m1.3-.6h-1.5m1.1-.7H383m1-.7h-1.2m.8-.6h-1m3.2.1L384 662m2.3-5.4l-1.6 5.3m.7-.1l1.2-5m.3.2l-1 4.7m-1.7-.3h1.7m-1.5-.6h1.7m-1.5-.7h1.6m-1.3-.6h1.5m-1.3-.7h1.4m-1.2-.6h1.3m-1-.7h1.2m-1-.6h1m.9.1l.8 3.6m-.5-3.8l1.1 3.7m-.7-3.7l1.2 3.7m-.7-3.5l1.3 3.5m-.1-.3h-1.7m1.5-.5h-1.6m1.4-.5h-1.5m1.3-.6H388m1.2-.5h-1.4m1.2-.5h-1.3m1.1-.5h-1.2"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#00b800"
      d="M479.6 380.3c3.6-2.3 9.8-1.9 13 .5 3.7-2.1 10.5-1.5 13.6 1.3 4.8-3.3 8.9-3.8 13.5-.6a12 12 0 0 1 13.6.2c4.2-2 8.8-3.6 12.9.7a10.7 10.7 0 0 0-13 .8c-4-4-11.1-2.5-13.5.3a8.8 8.8 0 0 0-13.3.2c-4.2-3.5-10.4-3.6-13.8-1a15 15 0 0 0-13-2.4z"
    />
    <path
      fill="#cf6200"
      d="M543.3 375.3c-18.5 3.2-59 1-67.8-1.3-3-.7-2.2-1.8.4-1.2 10.2 2.3 32 2.3 44 1.7 2.3-3 6-8.3 7.1-9.8s1.6-1.6 4-2l10-1.7v1.4c-.2.3-.5.7-.8.8 0 2.4.5 8.2 1 10.3l1.3-.3c.8-.2 1.6 1.9.8 2.1z"
    />
    <path
      fill="#cf6200"
      d="M573.7 376.2h2.5c.7 0 1.8-.6 2.2-1.7l2.5-7.3-1.9-2.8 1-6.1 2.4-1c.1-.4-.1-1.9-.6-2.3l-36.2 1.2c-1.1 0-1.6 0-2 1.4a27 27 0 0 0 9.2 26.6c.6.5 1.4 0 .4-.8a29.8 29.8 0 0 1-5-6.5l6-.1c.4 2 1.9 6 2.2 6.8s1 .8.6-.3c-.8-2.4-1.2-5.2-1.5-6.6h6l.5 6c0 .8.7.8.7-.1v-6l5.5-.2-.5 6c-.1 1 .4 1.4.6 0l.8-6 3.8-.2c-.1 1.3-1.3 5-1.6 6s.2 1 .6.1a35 35 0 0 0 1.8-6z"
    />
    <path d="M547.2 375.3c-.6-1.3-2.6-5.9-2.8-9.2l8-.1c.3 2.5 1 7.9 1.5 9.1l-6.7.2zm6.6-9.4c.2 2 1.2 8.5 1.4 9.2l6.4-.1-.4-9.3-7.4.2zm-9-8.1a38 38 0 0 0-.3 6.8l7.7-.2-.6-6.8-6.8.2zm8.3-.2c0 1.6.4 5.6.5 6.8l7.6-.2-.4-6.9-7.7.3zm9.2-.3l.3 6.9c1.8 0 5.4 0 6.5-.2.1-1.5.3-5.9.2-7l-7 .3zm8.3-.3l-.2 7 7.1-.3c.3-1.5 1-5.4 1-7l-7.9.3zm7.2 8.3l-7.5.2-.7 9.2 7.2-.2a61.6 61.6 0 0 0 2.6-7c-.5-1-1-1.4-1.6-2.2zm-15.2.4l.2 9.2 5.5-.2.7-9.2-6.4.2zm-31-1.8l-3 .5a224.8 224.8 0 0 1-7.2 10.1l10.6-.3-.3-10.3zm1.4-.3l.4 10.5 6.4-.5-1-11-5.8 1z" />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M377.3 657h-7.7v-.2l7.7.1zm6-6.2c.1 0 .1 0 0 0l-6-.1c-.1 0-.1 0 0 0h6zm-6.4 1.7c.1 0 .1.1 0 .1h-6.8c-.1 0 0-.1 0-.1h6.8zm.2-4.4c.1 0 .1.1 0 .1H370c-.1 0-.1-.1 0-.1h7.1zm-.5-3.5c.1 0 .1.1 0 .1h-6.9c-.1 0 0-.2 0-.2l7 .1z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M383.8 642.6l-6 .1 6-.1z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M384.1 646c.1 0 .1 0 0 0h-6.5c-.1 0-.1 0 0 0h6.5zm6.5 4.6v.1h-7c-.2 0-.2 0 0 0h7zm0-5.9c.2 0 .2.1 0 .1h-7.1c-.1 0-.1-.1 0-.1h7.2zm-6.6 10.4c.1 0 .1.1 0 .1h-6.4v-.1h6.4zm6.2.9c.1 0 .1 0 0 0h-5.6 5.6z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#ef072d"
      stroke="#000"
      strokeWidth={0.1}
      d="M395.3 657a3 3 0 0 0 0-1.4 1.1 1.1 0 0 1-.6 0 3 3 0 0 0-.3-.2c0 .4-.2 1.5-.4 1.9-.3 0-1 0-1.3-.2l-.3 1a3.5 3.5 0 0 0 1.5 0c0 .6-.1 1.1-.4 1.5.5 0 1 0 1.1-.3.3-.4.3-1 .4-1.3l.5-.1.5-.2.7-.1v-.6l.2-.4-1.6.5z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M370.5 623.2c-.8 0-2.6 0-3 .2-.3.2-.4.3.2.4s1.7.5 2.3.8c.6.4 1 1 1 2a6 6 0 0 0 3 6.3c.1.1.2.2.1.6l-.3 1.1c0 .2-.1.4.2.3a20 20 0 0 1-1 1.6c-1.6-.2-3 0-3 1.8 0 .2 0 .4.2 0 .3-.4.6-.8 1.3-1-.4.7-.6 1.3-.5 1.7 0 .3.2.5.4 0 .1-.4.5-.8.8-1.1.2-.1.2-.1.1.2s.1.9.3 1.1c.2.2.3.1.2-.2 0-.4 0-1.1.5-1.3.6-.4 1.2-.2 1.4.2.3.5.5 0 .2-.4s-.6-.9-1-.9l1-1.7c0-.2.2-.3.4-.2 0 .1.2.1.3-.2l.7-1.4.6-.2 1 1.5v.6c0 .4-.4 1.3-.5 1.6-1.2 0-1.8 0-2.2.7-.2.3.1.4.4.3a2 2 0 0 1 1-.3c.2 0 .3.2 0 .3-.7.3-1.2.8-1.2 1.5 0 .2.2.3.3 0 .3-.5.8-.9 1.3-1 0 .5.1 1.3.5 1.5.3.2.3 0 .2-.3-.2-.5 0-1 .3-1.3.5-.6 1.7.2 2 .4.2.2.4.3.2-.3-.1-.7-1.1-1-2-1.2l1.2-4.2c.5.3 1-.5 1.8-.2 1.4.6 3.5 1.9 3.8 2.2.4.3.5.2.7 0 .2-.1.5 0 .8 0 .2.1.4.2.1-.4a7.2 7.2 0 0 0-2.4-2.6c.8 0 1.8 0 1.8-.2s-1.2-.6-1.7-.6a3.3 3.3 0 0 0 1.6-.8c.2-.2 0-.3-.8-.3-2.1 0-3.2 0-4.3-.6-1.8-1-2.9-2.2-3.8-2.6-.4-.3-.7-.9-1-1.4-.5-1.5-.5-2.3-1.8-2.8s-3 .1-3.7.8z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M370.6 623.6h-1.7s-.2 0 0 0l1.5.4c.3 0 .2.3 0 .2s-.4 0-.2.2c1 .7 1.2 1 1 3.7l.5.4c.2 0 .1.2 0 .1s-.5 0-.2.2.5.2.2.2-.6.2 0 .1c.5 0 .8.2 0 .3-.6 0-.4.2 0 .2.7 0 .5.2.3.2s-.3.2.2.2h.7c.1 0 .2 0 0 .1-.2 0-.2.2.1.2s.5 0 .2.1c-.1 0-.3.1 0 .2.7 0 .8.2.6.3s-.3.1 0 .1.6.1.3.2c-.2 0-.3.2 0 .2s.5.2.3.3-.3.2 0 .2.4.1.2.2c-.2.2-.3.2-.5 0 0-.2-.2-.2-.2 0l-.2-.3c-.1-.3-.3-.3-.3 0s-.2.1-.4 0a3.3 3.3 0 0 0 4 .8c.1 0 .2 0 .3.3l.6 1.1c.1.2.3 0 .3-.2l.6-1.7c0-.3.4-.5.3.3.3-.2 1.5-.3 2.5 0a12.2 12.2 0 0 1 2.7 1.5.6.6 0 0 0 .5.1c.3 0 .4 0-.1-.5s-.3-.7 0-.5c.3.2.5.1.2-.2l-1-.9c-.1 0-.1-.2-.6-.2h-1.5c-.2 0-.4 0 .2.2.6.2 1.7 1 2 1.2s.4.6-.1.2-2.4-1.5-3.6-2c-2.7.3-4.9.6-6.5-1.1-.8-.9-.8-2.8.5-3.6-.2-.2-.2-.4-.1-.4v-.6c-.2-.1-.4-.3-.4-.5-.3 0-.5-.5-1-.3s-.6 0-.8-.1c-.1-.2-.2-.2-.5-.2s-.5 0-.5-.2.2-.2.6 0c.7.3 1.3.5 1.8-.2.4-.6-.2-1.1-1-1.3-.9-.2-1.5.5-1.9.8z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M375 623.3a2.8 2.8 0 0 0-1-.6c-.3 0-.3.2-.2.3v.6c.2.1.3.3 0 .3-.2.2 0 .9.3.7h.2s0 .3.2.3 0 .2 0 .3h.2c.2 0 .1.4-.1.5.3 0 .4 0 .4.2.1.2.4.3.4.6s0 .3-.4.2-.4 0-.5.2-.2.3 0 .3.4.1.1.2-.6 0-.7.3c0 .3 0 .4.2.3l.7-.4.5.1c.2.1 0 .5-.2.3s-.4 0-.5.1l-.5.2c-.2 0-.4 0-.3.5 0 1.4 1.1 2.4 3.1 2.4h3.3c-.6-.4-1-.6-1.3-.6h-.3c.1-.1 0-.3-.1-.3s-.3-.2-.5 0l-1 .5c-.2 0-.5 0-.2-.2l.9-.4c.2 0 .1-.2.1-.2s0-.3.3-.2c.6.4 1.5.9 1.8.9s.4-.2.2-.3-.3-.3-.3-.4.1-.2.5 0c.4.3 1 .5 1.3.6s.5.1 0-.2l-2.3-1.7c-.3-.3-.3 0-.2.2s-.3.3-.5.1-.3-.3 0-.4.2-.2-.1-.5c-.4-.3-.5-.3-.4 0 .1.3.1.5-.2.4s-.6-.3-.3-.4c.2-.2.5-.3 0-.6s-.2 0-.3.2-.4.2-.5 0-.3-.3-.2-.4.1-.2.3 0 .4 0 .1-.3-.4-.2-.3 0-.2.4-.6 0c-.2-.1-.2-.3 0-.4.2 0 .2-.1 0-.3-.7-1.2-.4-2.1-1.2-3z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#cf6200"
      d="M491.6 188.4c-.3.5-.4.4-1 .8-.6.5-.8 1.8.4 1.7.8-.2 1.3-.6 1.6-1a10 10 0 0 0-1-1.5zm-3.6-2.9c-.9.9-1 1.3-.6 1.3.6 0 .3 0 0 .7-.5.6.7.9 1.2.4s.5-.6.8 0c.1.5 1 0 1.4-.4-.8-.8-1.9-1.5-2.8-2zm-1.6 5c-1.2.6-.8 3.7 1 2.8.6-.3 1-.1 1 .3-.1.3-.1.5 0 .8a5.4 5.4 0 0 0 2-1.4c1-1.3 0-1.2-1.6-1.2s-2-.3-.5-1.2c1.4-.9.4-1.4-1.5-1.2.3.4.2.8-.4 1.1zm6.7 6.9c-.9-1-.3-1.4.6-1.9a1.2 1.2 0 0 0 .5-.4l-.8-3c-.4.2-1 1.3-1.2 1.8-.2.8-.4 1.2-1.2 1-.7-.2-1.4.6-1.5 1.4h.5c.3.1.4.6.3 1 2.1 0 2.5 1.4 2.9 2.4.4 1.1.8 1 1.1.3.3-.6-.4-1.7-1.2-2.6z"
    />
    <path
      fill="#ff0"
      d="M493.7 209.6c-.4.9-.4.8-1.7.8-1.2.1-2.8.3-3.5 1-.3.4-2.5.6-2.5 1.5 0 1 0 1.7 1 1.8.9 0 1 .2.7.9-.4.7-.6 1.8 1 2 1.6 0 2.8-.4 3.2.5.4 1 0 2.4.3 3s1.4.9 3.1 1.4c1.2.3 5.5.6 6.8.4 1.3-.2.8-1-.5-1-1.3-.2-2.3-.4-2.6-1.3-.3-1-.6-1.5.2-2.3.7-.9 1.4-1.5 1-2.9-.4-1.3-1.1-2.9-2.7-3.3-1.5-.5-1-2.6-2.6-2.8-.6 0-1 0-1.2.3z"
    />
    <path
      fill="#cf6200"
      d="M486.1 222.2c1.4.2 2.5.6 1.4.9-1 .3-1.7.9-.3 1 1.4.1 2.6.7 1.5 1s-1.2 1 .1 1 1.9.6 1 1.2c-1 .5-1.6.8-2.2-.1-.6-1-1-1.2-1.1-.5-.2.7-.6.2-1-.8s-1.4-1.4-1.1-.6-.8 1-1.8.6c1 1 2 2 3.3 2.7 1.4-.5 3 0 3.5 0 .6 0 2.4.5 3.4 1s1.7-.4 1.3-1.5c-.5-1-.5-.7-1 0-.6.5-.7-.3-.6-1.5 0-1-.7-.8-.9-.2s-.8-.4-.5-1 0-.9-.5-.7-.6 0-.7-1.2-.6-1-.7-.5-.7-.2-1.4-1.1c-.6-.8-1.3-.3-2.5.1l.8.2z"
    />
    <path
      fill="#ff0"
      d="M500.3 229.5c-6.4 2.5-11 1.4-14.4-.9 1.4-.5 3 0 3.6 0 .5 0 2.4.5 3.3 1s1.7-.4 1.3-1.5c.8 1.1 1.5 1.9 2.5 1.8 1 0 2.8-.2 3.7-.4zM486.7 200c-.4-1.3-.8-1.6-1.5-1.5-.7 0-1-.1-1.8-.4-.7-.3-1.7 0-1.9 1.5s-1 2-2.2 3c-1.1.8-1.8 1.5-1.8 2.9s-.3 1.7-1.1 2.8l-1.3 1.5 1.4.8c.9.4.6 1-.2.8s-1.7.2-.3.5 2 1 .7 1c-1.4-.2-3 1-.3.7 2.6-.3 3.6 1 .6 1-3.1 0-2 1-.3 1 2.9 0 2 .9 1.2.9-.7 0-1 1 .9.8l.7-1.1c.3-1 .6-3.7 1.7-4.4 1-.8 1.6-2 1.6-2.7s1.7-4.2 2.7-5 1.6-2.7 1.2-4z"
    />
    <path
      fill="#cf6200"
      d="M484.4 200.2c-1-.8-2.1-.3-2.1 1s-.8 1.8-1.7 2.3a4 4 0 0 0-2 2.7c0 1.1.2 1.8-.5 2.7-.8.8-.9 1.5-.4 2 .6.5.6.5.8 1.2.3.7 1.6 0 1.6-.8s.3-.8 1.1-1.3c.9-.4 2.3-2.7 2-3.3-.3-.6-1.1-1.2 0-2 1-.9 2-1 2-1.8 0-.9.3-1.2.6-1.5.3-.3-.7-.8-1.4-1.2z"
    />
    <path d="M484.4 199c-.7-.2-1.1 1.3-.1 1.5s1.1-1 .1-1.4zm-.1 2c-.8.1-1.7 1.1-.4 1s1.8-1.1.3-1zm-1.6 1.9c-.8.4-.6 1.5.6.7s1.4-1.7-.6-.7zm-1.2 1.6c-.8.4-.7 1.5.5.7 1.2-.7 1.5-1.7-.5-.7z" />
    <path d="M479.9 205.3c-.8.4-.3 1.4.8.7s1.1-1.7-.8-.7zm1 1c-.9.4-.4 1.4.8.7s1.1-1.7-.9-.7z" />
    <path d="M479.4 206.7c-.7.4-.2 1.4 1 .7s1-1.7-1-.7zm1 1.1c-.9.4-.4 1.4.8.7 1.2-.8 1.1-1.7-.9-.7z" />
    <path d="M479 208.5c-.8.4-.3 1.4.9.7s1-1.7-.9-.7z" />
    <path d="M479 209.5c-.7.4-.2 1.5 1 .7s1-1.7-1-.7z" />
    <path
      fill="#cf6200"
      d="M478.5 219.3c-.8.1-1.4 1.3-.4 1.5s1.3.3 1.3 1 .3 2 1.4 2c1 .1 2-1.1 1-1.5-.9-.4-1.7-.7-1.8-1.6 0-.8-1-1.4-1.5-1.4z"
    />
    <path
      fill="#ff0"
      d="M507 212.6l.6.6c.8.6 2.2 0 2-.5s-1-2.3 1-.9l10.6 7.4c2.2 1.6.8 1.8-.2 1.3s-4-1.7-5.7-2.7c-1.7-1-2-.6-2.2-.3-.2.3 0 1 .6 1.6-1 .1-2.7 0-3.2-1.2-.6-1.3-2-3-3-4.2-.4-.5-.5-.8-.4-1z"
    />
    <path
      fill="#00d860"
      d="M564.9 403.6c-1.4 1-3.4 2.8-2.1 5.2l.5-.2a142.4 142.4 0 0 0 14.7-21.7l.1-.7a20.5 20.5 0 0 1-5.2 3.1c.7 1.9-2.6 4.3-4.3 5 .7 1.2.5 3-1 3.3.3 1-.9 1-2.3 1.6s-2 1-2.5 1.8c.7-.5 1.8-.8 2.3-.6s.7 1-.3 1.3-1.7.8-2.1 1.2c1.5-.5 3.7-.3 2.2.7z"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M376 628.4c-.4-.3-.5-.1-.4 0s0 .4-.3.5h-1c-.2 0-.5.4 0 .3l1.6-.3c.2 0 .4-.2 0-.5zm.7.6c-.3-.3-.4-.2-.3 0s-.1.3-.3.3l-1.4.4c-.4 0-.4.3.1.3s1.5-.5 1.6-.5.2-.3.3-.2.3 0 0-.3zm.3.8l-1 .5c-.3 0-.5.3 0 .3s1-.5 1.2-.6l.4-.2s.4-.1 0-.4-.8 0-.6.1 0 .3 0 .3z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path d="M482 187.5c-2.8-1.9-6 2-2.9 4.2 2.8 1.9 5.7-2.4 3-4.2z" />
    <path
      fill="#fff"
      d="M478.5 189.2h.8c-.1 1 .8 2.3 2 2-1 .8-3-.2-2.8-2zm11 42.5c.9.3 3.9.6 5 .6l-1.4 2.5c-.3.8-.4.9-.5-.3 0-1.2-.7-2-1.3-.7l-1.2 2.2c-.3.5-.8.7-.6-.6s.1-2.6 0-3.7z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M399.7 640.8c0 16.3-2.6 33.9-23.8 42.3-21.1-8.4-23.7-26-23.8-42.3h47.6zm0 0c0-6.2-.3-12.2-.2-17.4a63.6 63.6 0 0 0-23.6-4.3c-5.3 0-15.7.8-23.6 4.3.2 5.2-.2 11.2-.2 17.4h47.6z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
  </svg>
	),
	SI: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-15 0h682.6v512H-15.1z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="translate(14.1) scale(.9375)"
    >
      <path fill="#fff" d="M-62 0H962v512H-62z" />
      <path fill="#de2918" d="M-62 341.3H962V512H-62z" />
      <path fill="#08399c" d="M-62 170.7H962v170.6H-62z" />
      <path
        fill="#de2918"
        d="M228.4 93c-4 61.6-6.4 95.4-15.7 111-10.2 16.8-20 29.1-59.7 44-39.6-14.9-49.4-27.2-59.6-44-9.4-15.6-11.7-49.4-15.7-111l5.8-2c11.8-3.6 20.6-6.5 27.1-7.8 9.3-2 17.3-4.2 42.3-4.7 25 .4 33 2.8 42.3 4.8 6.4 1.4 15.6 4 27.3 7.7l5.9 2z"
      />
      <path
        fill="#08399c"
        d="M222.6 91c-3.8 61.5-7 89.7-12 103.2-9.6 23.2-24.8 35.9-57.6 48-32.8-12.1-48-24.8-57.7-48-5-13.6-8-41.7-11.8-103.3 11.6-3.6 20.6-6.4 27.1-7.7 9.3-2 17.3-4.3 42.3-4.7 25 .4 33 2.7 42.3 4.7a284 284 0 0 1 27.4 7.7z"
      />
      <path
        fill="#fc0"
        d="M153 109.8l1.5 3.7 7 1-4.5 2.7 4.3 2.9-6.3 1-2 3.4-2-3.5-6-.8 4-3-4.2-2.7 6.7-1 1.5-3.7z"
      />
      <path
        fill="#fff"
        d="M208.3 179.6l-3.9-3-2.7-4.6-5.4-4.7-2.9-4.7-5.4-4.9-2.6-4.7-3-2.3-1.8-1.9-5 4.3-2.6 4.7-3.3 3-3.7-2.9-2.7-4.8-10.3-18.3-10.3 18.3-2.7 4.8-3.7 2.9-3.3-3-2.7-4.7-4.9-4.3-1.9 1.8-2.9 2.4-2.6 4.7-5.4 4.9-2.9 4.7-5.4 4.7-2.7 4.6-3.9 3a65.8 65.8 0 0 0 18.6 36.3 107 107 0 0 0 36.6 20.5 104.1 104.1 0 0 0 36.8-20.5c5.8-6 16.6-19.3 18.6-36.3z"
      />
      <path
        fill="#fc0"
        d="M169.4 83.9l1.6 3.7 7 1-4.6 2.7 4.4 2.9-6.3 1-2 3.4-2-3.5-6-.8 4-3-4.2-2.7 6.6-1 1.6-3.7zm-33 0l1.6 3.7 7 .9-4.5 2.7 4.3 2.9-6.3 1-2 3.4-2-3.4-6-.9 4-3-4.2-2.7 6.7-1 1.5-3.7z"
      />
      <path
        fill="#08399c"
        d="M199.7 203h-7.4l-7-.5-8.3-4h-9.4l-8.1 4-6.5.6-6.4-.6-8.1-4H129l-8.4 4-6.9.6-7.6-.1-3.6-6.2.1-.2 11.2 1.9 6.9-.5 8.3-4.1h9.4l8.2 4 6.4.6 6.5-.6 8.1-4h9.4l8.4 4 6.9.6 10.8-2 .2.4-3.7 6.1zm-86.4 9.5l7.4-.5 8.3-4h9.4l8.2 4 6.4.5 6.4-.5 8.2-4h9.4l8.3 4 7.5.5 4.8-6h-.1l-5.2 1.4-6.9-.5-8.3-4h-9.4l-8.2 4-6.4.6-6.5-.6-8.1-4H129l-8.4 4-6.9.6-5-1.3v.2l4.5 5.6z"
      />
    </g>
  </svg>
	),
	SJ: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#ef2b2d" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M180 0h120v480H180z" />
    <path fill="#fff" d="M0 180h640v120H0z" />
    <path fill="#002868" d="M210 0h60v480h-60z" />
    <path fill="#002868" d="M0 210h640v60H0z" />
  </svg>
	),
	SK: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#ee1c25" d="M0 0h640v480H0z" />
    <path fill="#0b4ea2" d="M0 0h640v320H0z" />
    <path fill="#fff" d="M0 0h640v160H0z" />
    <path
      fill="#fff"
      d="M233 370.8c-43-20.7-104.6-61.9-104.6-143.2 0-81.4 4-118.4 4-118.4h201.3s3.9 37 3.9 118.4S276 350 233 370.8z"
    />
    <path
      fill="#ee1c25"
      d="M233 360c-39.5-19-96-56.8-96-131.4s3.6-108.6 3.6-108.6h184.8s3.5 34 3.5 108.6C329 303.3 272.5 341 233 360z"
    />
    <path
      fill="#fff"
      d="M241.4 209c10.7.2 31.6.6 50.1-5.6 0 0-.4 6.7-.4 14.4s.5 14.4.5 14.4c-17-5.7-38.1-5.8-50.2-5.7v41.2h-16.8v-41.2c-12-.1-33.1 0-50.1 5.7 0 0 .5-6.7.5-14.4 0-7.8-.5-14.4-.5-14.4 18.5 6.2 39.4 5.8 50 5.6v-25.9c-9.7 0-23.7.4-39.6 5.7 0 0 .5-6.6.5-14.4 0-7.7-.5-14.4-.5-14.4 15.9 5.3 29.9 5.8 39.6 5.7-.5-16.4-5.3-37-5.3-37s9.9.7 13.8.7c4 0 13.8-.7 13.8-.7s-4.8 20.6-5.3 37c9.7.1 23.7-.4 39.6-5.7 0 0-.5 6.7-.5 14.4 0 7.8.5 14.4.5 14.4a119 119 0 0 0-39.7-5.7v26z"
    />
    <path
      fill="#0b4ea2"
      d="M233 263.3c-19.9 0-30.5 27.5-30.5 27.5s-6-13-22.2-13c-11 0-19 9.7-24.2 18.8 20 31.7 51.9 51.3 76.9 63.4 25-12 57-31.7 76.9-63.4-5.2-9-13.2-18.8-24.2-18.8-16.2 0-22.2 13-22.2 13S253 263.3 233 263.3z"
    />
  </svg>
	),
	SL: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#0000cd" d="M0 320.3h640V480H0z" />
      <path fill="#fff" d="M0 160.7h640v159.6H0z" />
      <path fill="#00cd00" d="M0 0h640v160.7H0z" />
    </g>
  </svg>
	),
	SM: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#19b6ef" d="M0 240h640v240H0z" />
      <path fill="#fff" d="M0 0h640v240H0z" />
    </g>
    <path
      fill="#fd0"
      fillRule="evenodd"
      stroke="#7d6c00"
      strokeWidth={2.4}
      d="M317 339.2C369.6 300 426 220 359.9 177.8c-12.3-2.4-26-1.7-32.7 3.6-3.5-2-6.3-1.8-9.8 1.9-2.5-3-5-4.4-10-2.9a40.8 40.8 0 0 0-31.5-3C218 211.8 253.4 294 317 339.1z"
    />
    <g stroke="#3a9d4f">
      <path
        fill="#4fd46b"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeWidth={2.4}
        d="M414 250.1s6-8 6.2-8c5.9-3.4 6.5-7.9 6.5-7.9 5.9-1.8 4-6.7 4.5-7.3a6.4 6.4 0 0 0 1.4-7.1c0-.8 2-8.4-.8-9.4.1-8-4.8-7.3-8.8-2-4.2 1.2-5.1 4.7-3.6 8.5-5.5 0-5.7 8-4.1 12.4-7.3-.2-3.3 8-3.5 8.4-2.4 1.2 1.9 12.8 2.3 12.4zm-46 68.2l3.6 2.2c.8 2.8 3.4 4.6 5.3 4.1 1 4.3 5.6 3.7 9 1.2 2.7 4 6 4 10.6 2.7 4 3 9.3 1.7 12.8-1.4 3.7 3 6.2.8 8.1-2.5 3 .8 5.2.3 6.3-2.6 5.7-.5 2.9-5.9-1.8-8.2 3.7-3.2 7.9-10 2-11-1.8-1.3-5.3-1-7.9.2-.7-3-4.8-3.7-9.4-.4-1.5-3.3-7-1.7-9.5.6-3.3-2.8-7.2-2.8-12.9.4L368 318.3zm0-8.7c.6-3.8-2-10.6 2-11.2-.7-6.3.3-13.3 7.5-12.7 1.2-5.9 1-11.4 7.8-12.2 0 0 5.5-19.1 11.2-5.9 2.2 3.9 1.8 10.2-2.7 9 .9 4.7-.7 8.9-5.9 8.7 2.3 3.4 1.6 7.9-1 10l-19 14.3zm33.1-23.9l6-1.2c6-4 8.5-5.7 11.5-1.2 5.1-1 10-.6 9.8 3.4 6 .5 6 4.3 5.3 7.4 1 5.3-1.4 12.3-5 3.8-11.9-7.2-18.6-6.2-37.3-2l9.7-10.2zm3.1-5.9c.2-.2 17.5-4.7 15.7-10 4.9-.8 5.9-5.7 6-5.7 10.3-3.2 9.7-9.1 9.7-9.1 2.9-3.1 8-6.3 6.9-11.8.3-6.3.9-10.2-7.6-6.1-6.3-.6-8.5 3-10.3 8.5-3-3.5-7.8 2.1-8.4 7.1 0 0-7.7 7.6-7.7 7.8l-6.5 12 2.2 7.3z"
      />
      <path
        fill="#4fd46b"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeWidth={2.4}
        d="M404.5 266.4c-4.1-3.1-6.4-6.9-5.7-10.6-2.7-3.7-4.6-5.9-2-9.2l-2-7.5c-5.4-2-3.1-6.5-1.7-8.1-2.5-3.5-2.6-7.2-.2-10.4 0-6.5 4.6-4 8.3 0 0 0 6.4 4.5 1.7 8.5 4.7 1.7 6 5.7 3.4 7.4 4.1 1.8 4.7 5.5 2.5 8 4.1 3.2 2.6 7.4 3.8 11.1l-8.1 10.8z"
      />
      <path
        fill="#4fd46b"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeWidth={2.4}
        d="M411.8 236c-.2-.1-6.9-8.7-5-9.3-.5-2.6-2.5-5.5-1.3-8.1-3.3-3.4-3.4-7.3-.8-10.4-2.2-3-1.2-7.1 1.8-9.8-1-5 2.6-6.2 5.7-7.1 2.3-8 6-6 8.2.2 3.2 2.8 2.7 7 1.6 10.2 3.8 2.5 1.5 5.7-.2 7l-10 27.4z"
      />
      <path
        fill="#4fd46b"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeWidth={2.4}
        d="M410.8 193.1l-5.7-5.7c1.5-3 2.7-8.3-1.6-10.8-2.4-5.7-14.2-12.9-16.1.8-1.8-4.1-5.6-8.2-8.3-3.4-6.2-5.3-9.5-3.7-6.3 3 0 0-2.9 4.5 4.6 8 .6.6-2.4 8.1 6.6 8.3-1.7 2.6 1 6.2 4.6 6-2.5 3.1 1.8 6.5 4.5 5.2-1.1 3.5-1 5.2 3.9 5.7l5.5 6.3 4.5 6.1 3.8-29.5z"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeWidth={2.2}
        d="M414.3 246.5c.3-.3 11-24.8 12.4-32.2M415.4 203s1.8 20-3.1 34.6m-29.7-54.7s21.9 21 24 29.7m-8.7-32s1.4 17.3 7.5 34.3m31 28.4S414.6 261.8 404 278m11.8 30s-28.8 4-41.4 4.3m32 8s-35.8-.8-38.4-3.4m20.5-43c0 .4-18.2 30.3-18.8 40"
      />
    </g>
    <path
      fill="#65c7ff"
      fillRule="evenodd"
      stroke="#7d6c00"
      strokeWidth={2.4}
      d="M316.9 333.4c-37.8-35.6-76.5-102.4-38-136.2 6.8 3.8 14.9.4 26-4 3.4 3.7 7.7 4.6 12 1.8a9 9 0 0 0 10.7-2.1c11 6.3 24.9 9.6 28.2 3.3 37.8 36-.6 103.2-39 137.3z"
    />
    <path
      fill="#8fc753"
      fillRule="evenodd"
      d="M317 332.4a212.8 212.8 0 0 1-42.3-57.6c2-1.7 2.9-2.2 3.9-5 5.8.8 8.9 1 16.5-.4 1.6 5.8 1.9 10.6 5.5 15.4l7.7-15a33.6 33.6 0 0 0 16.5 0c3.2 4.2 2 10.7 7.7 15.6 3.4-10 6.7-10.6 10.1-16 5 1.8 8.2 1 12.3-.3 2 2.5 1 2.4 5 6a193.7 193.7 0 0 1-42.8 57.3z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M272.6 164.3a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.8 0zm-3.5-7.7a3.4 3.4 0 1 1-6.6 0 3.4 3.4 0 0 1 6.7 0zm-4-7.1a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-2.8-7a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm.5-7.6a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm17.6-12.5a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M273.8 123.6a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-7.3 4.3a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm22.4-5.4a3.4 3.4 0 1 1-6.6 0 3.4 3.4 0 0 1 6.6 0zm9.4.8a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm8.2-.5a3.4 3.4 0 1 1-6.6 0 3.4 3.4 0 0 1 6.7 0z"
    />
    <path
      fill="#fd0"
      fillRule="evenodd"
      stroke="#7d6c00"
      strokeWidth={1.1}
      d="M325.9 117.5a8.6 8.6 0 1 1-17.2 0 8.6 8.6 0 0 1 17.2 0z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M335 122.7a3.4 3.4 0 1 1-6.8 0 3.4 3.4 0 0 1 6.7 0zm8.6.7a3.4 3.4 0 1 1-6.6 0 3.4 3.4 0 0 1 6.7 0zm8.5-.4a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm7.1-.3a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm8.9 1a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm7 4.4a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0z"
    />
    <path
      fill="#e40000"
      fillRule="evenodd"
      stroke="#ac0000"
      strokeWidth={2.4}
      d="M269.4 151.7l8.6 16.5h79.2l9.2-15.9c-5.4-3.7-9-6.5-16.7-4.8-4.3-6.2-9-7.3-16-6.7-2.1-2.1-4-3.4-7.6-4l-16.6.5c-4.4.4-7.8 3.8-8 3.8-7-.9-13.5-.7-15.2 6.2-6.5-1.6-11 .2-16.9 4.4z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M378 135.3a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm.6 8a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-2.5 7.2a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-3 6a3.4 3.4 0 1 1-6.8 0 3.4 3.4 0 0 1 6.7 0zm-3.7 7.5a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-46.8-9.6a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M323.6 143a6 6 0 1 1-12 0 6 6 0 0 1 12 0z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#000"
      strokeWidth={1.1}
      d="M322.7 132a5.4 5.4 0 1 1-10.8 0 5.4 5.4 0 0 1 10.8 0z"
    />
    <path
      fill="#fd0"
      fillRule="evenodd"
      stroke="#7d6c00"
      strokeWidth={1.1}
      d="M315.5 109v-4.2l-3.6-.1.2-3.2h3v-2.8h4.5v2.5h3.5l-.1 3.4h-3.6v4.5h-4z"
    />
    <path
      fill="none"
      stroke="#fd0"
      strokeWidth={3.3}
      d="M277.6 168.2c-7.1-12-17.6-28.4-11-35.5 8.9-10.1 29.9-1 43.3-6.8 1 11.4-2.2 30.4 2.9 34.3l-4.8 4.2c-3-3.7-8.4-8.8-15.2.2-4-3.4-8.3-2.8-10.4 1.7-2 .3-1.9 1.1-4.8 1.9zm80-.5c7.2-12 17.6-28.3 11.1-35.4-9-10.1-30-1-43.3-6.9-1 11.5 2.2 30.5-3 34.4l4.8 4.2c4.7-6.5 10.4-6.7 15.3.2 3.9-3.4 7.9-3 10.4 1.7 2 .3 1.8 1 4.8 1.8z"
    />
    <path
      fill="#fd0"
      fillRule="evenodd"
      stroke="#7d6c00"
      strokeWidth={2.4}
      d="M277.3 177.1a437 437 0 0 1 79.3 0l3.1-9c-27.7-5-46.8-5.6-83-.6l.6 9.6z"
    />
    <path
      fill="#c76e2e"
      fillRule="evenodd"
      d="M314.1 329.4l.6-4.2c2.9.8 5 .5 7.4-.4l2.4-3.7-1.8-2.1c-1.6.3-3 1.8-4 3.1-1.6.1-3-.7-4.6-1l-1.5-6.4c-1.5-1.8-4.7-1.7-4 1.5l.3 2.5c.6 1.5.9 3.6 1.9 4.7v2.6l3.3 3.4zm1.2-18.3c-2 1-4.6-.8-7.3-1.9-2.5-.1-4.4 2-7.4 1.3.6-1.6 1.9-1.9 2.8-2.8-.7-4.1 1.5-5.5 2.1-5.5.6 0 3.1.6 3.1.6l2.4.3c1.5 2.7 3.5 5 4.3 8z"
    />
    <path
      fill="#ffe100"
      fillRule="evenodd"
      stroke="#e9bf00"
      strokeWidth={2.4}
      d="M300.8 366c7-11.4 56.2-34.4 102.4-84.2-47 45.3-76.4 56.4-114.8 84l12.4.3z"
    />
    <path
      fill="#9d4916"
      fillRule="evenodd"
      stroke="#68300e"
      strokeWidth={1.1}
      d="M368.4 313.2a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm34.4-34.9a4 4 0 1 1-8.1 0 4 4 0 0 1 8 0zm11.4-29.6a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0zM403 210.3a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#a9a9a9"
      strokeWidth={1.1}
      d="M279.1 269.6v-15.2l-1.5-1.2v-3.6l2.8-.3.5-17-1.8-1-.2-2.8s2 .8 2 .3l.5-3.4s-1.3-.2-1.3-.7 1.6-1.8 1.6-1.8-.8-.8-1-1.3l-.8-2.8.8-2.9-.5-1.5-1.3-2.3 1.8-1.8-.5-2.8a10 10 0 0 1 1.5-2.9c.3-.2 2.3-3 2.3-3l4.4-1 5.1.7 2.8 1.8.5 4.6s-.5 2.8-.7 2.8l-2.3 1s-2.6.3-2.9 0 .8 3.2.8 3.2v3l-.2 3.9s0 1.8-.3 2-.8 1-.8 1l-.2 4 4 1-.2 2.3-2.8.2.5 15.7 4.1.7v4.4l-1.8 1-.5 15.7h-14.4zm62.4.3v-15.2l-1.5-1.3v-3.6l2.8-.2.5-17-1.8-1-.2-2.8s2 .7 2 .2l.5-3.3s-1.3-.3-1.3-.8 1.6-1.8 1.6-1.8-.8-.7-1-1.3l-.8-2.8.8-2.8-.6-1.5-1.2-2.3 1.8-1.8-.6-2.9a10 10 0 0 1 1.6-2.8l2.3-3 4.4-1.1 5.1.8 2.8 1.8.5 4.6s-.5 2.8-.7 2.8l-2.3 1s-2.6.3-2.9 0 .8 3.1.8 3.1v3.1l-.3 3.9s0 1.7-.2 2l-.8 1-.2 3.9 4 1-.2 2.3-2.8.3.5 15.6 4.1.8v4.4l-1.8 1-.5 15.7h-14.4zm-31.6.5v-15.2l-1.5-1.2v-3.7l2.8-.2.5-17-1.8-1-.2-2.8s2 .8 2 .3l.5-3.4s-1.2-.2-1.2-.7 1.5-1.9 1.5-1.9-.8-.7-1-1.2l-.8-2.9.8-2.8-.5-1.5-1.3-2.3 1.8-1.8-.5-2.9a9 9 0 0 1 1.5-2.8c.3-.2 2.3-3 2.3-3l4.4-1 5.1.7 2.8 1.8.6 4.6s-.6 2.8-.8 2.8l-2.3 1s-2.6.3-2.8 0 .7 3.1.7 3.1v3.1l-.2 3.9s0 1.8-.3 2l-.8 1-.2 3.9 4 1-.2 2.3-2.8.3.5 15.7 4.1.7v4.4l-1.8 1-.5 15.7H310z"
    />
    <path
      fillRule="evenodd"
      d="M283 269.5v-12h6.6V270l-6.7-.5zm31.4 1l.3-12.2h6v11.9l-6.3.2zm31-.3l-.4-11.5 6.5-.2v12l-6-.3zm-60.8-36h3.8v6.1h-3.8zm30.3.2h5.3v6h-5.3zm31 .5h4.6v5.7H346z"
    />
    <path
      fill="none"
      stroke="#a8a8a8"
      strokeWidth={1.1}
      d="M286.6 207c4 4.6 4.3 4.6 4.3 4.6m26.2-4.6c.8 1.5 2 4.8 3.6 5.1m29.3-4.4s1.3 3.6 3 4.1"
    />
    <path
      fill="#b97700"
      fillRule="evenodd"
      d="M282.2 194c12-3.9-2.8-11.6-5.3 0-3.8.7-4.3 3.5-12.7 2.3-20.4 33-5.3 86.5 54.1 141.8-106.4-90.6-63.2-157.6-33.7-155 16 1 8 21-2.4 11z"
    />
    <path
      fill="none"
      stroke="#7d6c00"
      strokeWidth={2.4}
      d="M285.6 177s9.7 2.7 9.7 6.8m0-7.5s6.8 3 8.3 5.6m45.1-4.5s-8.6 1.2-10.5 3.8m-2.6-3s-5 4.1-4.5 5.3m3.4 12.7c-.8-.3-4.2-4.9-3.4-10.5m-29.8 7.5s2.3-2.6 2.3-7.5m13.5-1.9l.4 11m9.4-1.6c0-.7 3-7.9-.4-11.3m-20.3-1.5s-2.6 7.2-.7 13.2m20-6.8s-4.2 1.2-6 3m-11.8-1.9c0-.3 4.6-1 6 1.6"
    />
    <path
      fill="#c76e2e"
      fillRule="evenodd"
      d="M300.6 301.9c.2 0 3.8-.7 3.8-2.4 1.8-1.2.5-4.5.5-4.5l-3.4-.6-4.6-5.2c-.2-1.6.3-3.1-.7-4.8-3.2.8-5 3.5-6 6.5.7 1 .8 2 2.3 2.9 1.5.2 2.5-.7 3.9-.4.7 1.3.5 2.4.8 3.6 1.9 1.3 2.3 3.2 3.4 4.9zm-4.1-22.2v-6.2l-4.4-.2c-.6 1-1.6 1.4-2.2 2.2l-3.1 1.6c1.3 1.5 2.9 2.4 3.8 3.2 2.3.6 4.1.6 5.9-.6zm-13.8 9.1l-2.4-4a7.2 7.2 0 0 1 4.7.3s1 2.5.3 3.4c-.4.9-2.7.5-2.6.3zm36.5 4.1a4.6 4.6 0 0 0 2.7-3.3l-4.5-5.1-4-.1c-1-1-2.4-1.2-3.6-1.2 0 0 1.2 2 2.8 2.3 1.2 2.6 6.2 7.4 6.6 7.4zm4.3.6c0-.1 4-1.4 6-1.3-.1-1.6 3-5.3 3-5.3l5.6 7.3c-1 .8-2.8.6-4.2.8 0 0-2.7 2.6-3 2.7s-5.2 1.3-7.6-.2c-1-2 .3-4.3.2-4zm3.2-12.8a14 14 0 0 0 0-7.6h-6.4l-4.2 2s1.3 4.2 3 3.8c.7 2.1 2.9 1.6 4 2.4l3.6-.6zm24.9-6.4c-1 2.7-1.4 5.5-.2 8 1.2.3 2.6 1 3.6.8l5.1-9.2c-3.5-1.1-6.4-1-8.6.4z"
    />
    <path
      fill="#b97700"
      fillRule="evenodd"
      d="M353.1 193.2c-12-3.9 2.8-11.7 5.3 0 3.9.6 4.4 3.5 12.8 2.3 20.3 33 5.2 86.5-54.2 141.8 106.5-90.6 63.2-157.6 33.7-155.1-16 1-8 21 2.4 11z"
    />
    <path
      fill="#c76e2e"
      fillRule="evenodd"
      d="M354.3 284.7c-.2 0-3 2-3 2l-4.2 1.7-4.4.1-1-3 3.4-3c-2.8-.5-5.7.7-8 2.8 0 0 0 3.3 2 5 1.1 1.4 4.5 4 4.5 4a7 7 0 0 0 5.4-1l5.3-8.6zm-23.2 30.1c1.4.4 11.3-12.7 11.3-12.7a10 10 0 0 0-4.9-5.4s-4.8 5.7-4.9 7.6c-.8 1.7-3 8.3-2 9.2-.1.2-.5 2.9.5 1.3z"
    />
    <path
      fill="#006800"
      fillRule="evenodd"
      stroke="#004100"
      strokeLinejoin="round"
      strokeWidth={2.4}
      d="M266.4 317.4c-14.8-12.9-34.8-20-62.7-10.3 7.5 3.2 15.6 4.3 22.5 7.9l40.2 2.4z"
    />
    <path
      fill="none"
      stroke="#00a400"
      strokeLinecap="round"
      strokeWidth={2.2}
      d="M223.4 308.3c29.3.6 37.8 7.9 36.3 6.7"
    />
    <path
      fill="#006800"
      fillRule="evenodd"
      stroke="#004100"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M267 319c-8.8 1.6-20.8 10-24.4 9.7-9.5-1.1-18.5-5-27.7-8-3.8-1.2-7.7 0-11.6 0 32.8-15.5 44-13.4 63.7-1.8z"
    />
    <path
      fill="#006800"
      fillRule="evenodd"
      stroke="#004100"
      strokeLinejoin="round"
      strokeWidth={2.4}
      d="M245.4 296s-11 1.6-15.9 1.9c-4.8-.3-12-4.8-19.8-13-4-4.6-13.4-4-13.4-4 20.6-4.4 36.7-.2 49 15.2zm-15-21.2c-14.9-1-33.5-14.3-37.7-30.2 0 .2 5.5 3.5 4.6 4.3 24.4 6.2 26 11.2 33.1 25.9zm25 25.5c2.1-13.5 2.7-22.4-3.6-30.4-5.3-6-6.6-9.7-10.4-18.3-1.1 17.8-5 32.5 14 48.7zM232 263c11-16.1 13-28.3 11.2-47.5-.3 1.5-4 11-4.2 11-16.5 10.3-9.2 26.5-7 36.5z"
    />
    <path
      fill="#006800"
      fillRule="evenodd"
      stroke="#004100"
      strokeLinejoin="round"
      strokeWidth={2.4}
      d="M222.2 185c11 16.1 9.4 31.3 7.6 50.5-.3-1.5-4-11-4.2-11-16.5-10.3-5.5-29.5-3.4-39.5z"
    />
    <path
      fill="#006800"
      fillRule="evenodd"
      stroke="#004100"
      strokeLinejoin="round"
      strokeWidth={2.4}
      d="M231.3 210c26.8-13.6 16.5-30.7 21.4-44-18.6 13.9-21 28.6-21.3 44z"
    />
    <path
      fill="none"
      stroke="#00a400"
      strokeLinecap="round"
      strokeWidth={2.2}
      d="M235 206.6c3.4-9.5 10-25.6 10.7-25.6M227 226.4c-.6-6.7-4-24.7-4.3-26.5"
    />
    <path
      fill="#006800"
      fillRule="evenodd"
      stroke="#004100"
      strokeLinejoin="round"
      strokeWidth={2.4}
      d="M228.3 256.5c-15-1-31-21.3-35.3-37.1 0 .2 5.5 3.4 4.6 4.2 21.4 9.6 23.6 18.2 30.7 32.9zm-4.4-14c-11-16.1-13-28.3-11.3-47.5.3 1.5 4 11 4.3 11 16.4 10.3 9.1 26.5 7 36.5zm9.9-28.3c27.7-12.3 19.2-25.2 27.4-38.7-18.6 13.8-27.1 23.4-27.4 38.7z"
    />
    <path
      fill="none"
      stroke="#00a400"
      strokeLinecap="round"
      strokeWidth={2.2}
      d="M235 211.4a70.7 70.7 0 0 0 15.2-20.7"
    />
    <g fillRule="evenodd">
      <path
        fill="#ffe100"
        stroke="#e9bf00"
        strokeWidth={2.4}
        d="M333.6 366.4l13.4.2c-44.7-42-130.5-60.2-118.6-137.4-12.3 83.7 70.1 91.5 105.2 137.2z"
      />
      <path
        fill="#9d4916"
        stroke="#68300e"
        strokeWidth={1.1}
        d="M235.4 212.7a4.3 4.3 0 1 1-8.6 0 4.3 4.3 0 0 1 8.6 0zm-2.6 23.6a4 4 0 1 1-8.1 0 4 4 0 0 1 8 0zm3.8 33.7a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm31.3 37.2a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm4.5 10.7a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0z"
      />
    </g>
    <g fill="#fff" fillRule="evenodd">
      <g stroke="#000" strokeWidth={1.1}>
        <path d="M288.2 349a15.5 15.5 0 0 1-4.8-5.8l-14-1.5-.2 8 19-.7z" />
        <path
          strokeLinejoin="round"
          d="M185.3 339.6c8.2 1.5 20.5-.8 24.5 4.5 4.8 5.4-15.1 13.9-12.3 18.6 6.2 6.5 12.5 3.8 19.4.2 1.7-3.5 3-9.8 3.8-11.7-2.5-5.7-9.3-8.6-7.5-17.3 11.3-4.2 33.2-3.9 35.6-2.2 1.8 3.6.1 5.2.5 8.1-1.9 3.7-6.7 9.8-6.7 13.1 12 4.2 15-.6 25.8-.4 12.6.2 20.2 3.6 23-1.4-2-4.4-13.5-.8-17.8-3.6-2.2-.7-3.6-2.5-5.5-4.4s-7.2-2-8-6.9c2.2-10.2 17-8.6 19.3-10.2l38.4 2.7c7-.2 11 12.3 1.5 16-9.4 3.8-37.1-5.5-49.2.9-.6-2.6-9.3-6.6-9.9-6.7-3.7 1-10.9.7-10.9.7-1.7 3.2-3.8 5.6-5.5 8.9-8-3.5-15.5 2.7-24.2.9l-13.6 1.5-8.6-.8-13.2 3.8 9.4-8.3-8.3-6z"
        />
        <path d="M184.7 338a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm-1 18a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.3 0z" />
      </g>
      <g stroke="#000" strokeWidth={1.1}>
        <path d="M346.3 349.1c2.3-2.1 3.8-3.5 4.7-5.8l14-1.6.3 8-19-.6z" />
        <path
          strokeLinejoin="round"
          d="M449.1 339.6c-8.1 1.5-20.4-.7-24.4 4.5-4.9 5.5 15 14 12.2 18.6-6.2 6.6-12.5 3.9-19.4.3-1.6-3.5-2.9-9.8-3.8-11.7 2.6-5.8 9.3-8.6 7.6-17.3-11.4-4.3-33.3-4-35.6-2.3-1.9 3.7-.2 5.3-.6 8.2 2 3.6 6.8 9.8 6.8 13-12 4.3-15.1-.6-25.8-.3-12.6.2-20.3 3.5-23-1.5 1.9-4.3 13.4-.8 17.8-3.5 2.2-.8 3.6-2.5 5.5-4.5s7.2-2 8-6.8c-2.2-10.2-17-8.7-19.4-10.2l-38.4 2.6c-7-.2-10.9 12.3-1.5 16.1 9.4 3.8 37.2-5.6 49.2.8.7-2.6 9.3-6.5 10-6.7 3.6 1.1 10.8.7 10.8.7 1.8 3.3 3.8 5.7 5.6 9 8-3.6 15.5 2.7 24.2.8l13.5 1.5 8.7-.7 13.2 3.7-9.4-8.2 8.2-6z"
        />
        <path d="M449.7 338a3.6 3.6 0 1 0 7.3 0 3.6 3.6 0 0 0-7.3 0zm1 18a3.6 3.6 0 1 0 7.2 0 3.6 3.6 0 0 0-7.2 0z" />
      </g>
      <path d="M317 329.3c-3.2-.6-4.4-.4-6.6-.6l-5.1 15.8c8 .7 15.3.7 15.3.7-4.8-1-3.7-15.8-3.6-15.9z" />
    </g>
    <g fontFamily="Trebuchet MS" fontSize={9} fontWeight="bold">
      <text
        x={448.6}
        y={344.3}
        transform="translate(-465 -233.3) scale(1.6657)"
      >
        <tspan x={448.6} y={344.3}>
          {"L"}
        </tspan>
      </text>
      <text
        x={453.6}
        y={344.6}
        transform="translate(-465 -233.3) scale(1.6657)"
      >
        <tspan x={453.6} y={344.6}>
          {"I"}
        </tspan>
      </text>
      <text
        x={456.7}
        y={345.1}
        transform="translate(-465 -233.3) scale(1.6657)"
      >
        <tspan x={456.7} y={345.1}>
          {"B"}
        </tspan>
      </text>
      <text
        x={462.6}
        y={345.5}
        transform="translate(-465 -233.3) scale(1.6657)"
      >
        <tspan x={462.6} y={345.5}>
          {"E"}
        </tspan>
      </text>
      <text
        x={468.3}
        y={345.6}
        transform="translate(-465 -233.3) scale(1.6657)"
      >
        <tspan x={468.3} y={345.6}>
          {"R"}
        </tspan>
      </text>
      <text
        x={473.9}
        y={345.4}
        transform="translate(-465 -233.3) scale(1.6657)"
      >
        <tspan x={473.9} y={345.4}>
          {"T"}
        </tspan>
      </text>
      <text
        x={479.3}
        y={344.5}
        transform="translate(-465 -233.3) scale(1.6657)"
      >
        <tspan x={479.3} y={344.5}>
          {"A"}
        </tspan>
      </text>
      <text
        x={485.5}
        y={344.3}
        transform="translate(-465 -233.3) scale(1.6657)"
      >
        <tspan x={485.5} y={344.3}>
          {"S"}
        </tspan>
      </text>
    </g>
    <path
      fill="none"
      stroke="#00a400"
      strokeLinecap="round"
      strokeWidth={2.2}
      d="M231.3 318.6c10.1 1.2 24.1.3 30.2 0M216 284.2c8.6 6.7 27.1 10.7 26.8 10.7m10.7 1.8c-2.8-14-5.8-17.4-8.3-26.2m-43.5-15.8c14.3 6.4 16.5 10.6 25.6 17m5.2-14c1.2-17.3 3.6-21.9 7.9-25.9m-38.7-2c5.2 5.7 22.2 23.7 22.2 23.7m-7-39.6c6.4 4.5 6.4 21 6.4 21"
    />
  </svg>
	),
	SN: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#0b7226" d="M0 0h213.3v480H0z" />
      <path fill="#ff0" d="M213.3 0h213.3v480H213.3z" />
      <path fill="#bc0000" d="M426.6 0H640v480H426.6z" />
    </g>
    <path
      fill="#0b7226"
      d="M342 218.8h71.8l-56.6 43.6 20.7 69.3-56.6-43.6-56.6 41.6 20.7-67.3-56.6-43.6h69.8l22.7-71.3z"
    />
  </svg>
	),
	SO: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-85.3 0h682.6v512H-85.3z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(80) scale(.9375)"
    >
      <path fill="#40a6ff" d="M-128 0h768v512h-768z" />
      <path
        fill="#fff"
        d="M336.5 381.2L254 327.7l-82.1 54 30.5-87.7-82-54.2L222 239l31.4-87.5 32.1 87.3 101.4.1-81.5 54.7 31.2 87.6z"
      />
    </g>
  </svg>
	),
	SR: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#377e3f" d="M.1 0h640v480H.1z" />
    <path fill="#fff" d="M.1 96h640v288H.1z" />
    <path fill="#b40a2d" d="M.1 144h640v192H.1z" />
    <path
      fill="#ecc81d"
      d="M320 153.2l56.4 173.6-147.7-107.3h182.6L263.6 326.8z"
    />
  </svg>
	),
	SS: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#078930" d="M0 336h640v144H0z" />
    <path fill="#fff" d="M0 144h640v192H0z" />
    <path d="M0 0h640v144H0z" />
    <path fill="#da121a" d="M0 168h640v144H0z" />
    <path fill="#0f47af" d="M0 0l415.7 240L0 480z" />
    <path fill="#fcdd09" d="M200.7 194.8L61.7 240l139 45.1L114.9 167v146z" />
  </svg>
	),
	ST: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#12ad2b" d="M0 0h640v480H0z" />
    <path fill="#ffce00" d="M0 137.1h640V343H0z" />
    <path fill="#d21034" d="M0 0v480l240-240" />
    <g id="prefix__c" transform="translate(351.6 240) scale(.34286)">
      <g id="prefix__b">
        <path id="prefix__a" d="M0-200V0h100" transform="rotate(18 0 -200)" />
        <use
          width="100%"
          height="100%"
          transform="scale(-1 1)"
          xlinkHref="#prefix__a"
        />
      </g>
      <use
        width="100%"
        height="100%"
        transform="rotate(72)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(144)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(-144)"
        xlinkHref="#prefix__b"
      />
      <use
        width="100%"
        height="100%"
        transform="rotate(-72)"
        xlinkHref="#prefix__b"
      />
    </g>
    <use
      width="100%"
      height="100%"
      x={700}
      transform="translate(-523.2)"
      xlinkHref="#prefix__c"
    />
  </svg>
	),
	SV: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#0f47af" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M0 160h640v160H0z" />
    <g transform="matrix(.8 0 0 .8 -92.7 0)">
      <g fill="#fff" fillRule="evenodd" stroke="#000" strokeWidth={0.3}>
        <path d="M515 353.4c1.5 0 3.2 0 10.1-1.7 7-1.7 12.7-5.9 14-6.5 1.4-.6 3.3-.4 3.3-.4a8.4 8.4 0 0 0-5.8-2.8c-3 0-1.9 0-4.4 1.1-2.6 1-8 4.3-17 4.3h-.1c-9 0-14.7-3.2-17.2-4.3-2.6-1-1.4-1-4.4-1-3 0-5.1 1.9-6 2.7 0 0 2-.2 3.4.4 1.4.6 7.1 4.8 14 6.5 7 1.7 8.6 1.7 10.1 1.7z" />
        <path d="M488.4 347.4c.7-.4-.2-1.6-.2-1.6l2.7-.6c-1.3-.6-3.3-.4-3.3-.4-.5.4-.4.9-.5 1.3 0 .4 0 1 .2 1.3.3.3 1 0 1 0z" />
        <path d="M491 345.2l-2.8.6s.9 1.2.2 1.7l4.8-1-2.3-1.3zm50.7 2.2c-.7-.4.1-1.6.1-1.6l-2.7-.6c1.4-.6 3.3-.4 3.3-.4.6.4.5.9.6 1.3 0 .4 0 1-.3 1.3-.3.3-1 0-1 0z" />
        <path d="M539.1 345.2l2.7.6s-.8 1.2-.1 1.7l-4.8-1 2.2-1.3z" />
      </g>
      <path d="M495.8 343.3l-1.2 3 .6.3c.9.3 1.8.1 2.2-.9.4-1-.1-1.8-1-2.1l-.6-.3zm.3.6c.8.4 1.2.9.9 1.7-.3.8-1 .8-1.7.5h-.1l.9-2.2z" />
      <path fillRule="evenodd" d="M497.6 347.6l-.4-.1 1.4-3 .3.1-1.3 3z" />
      <path d="M500.2 345.3c-.6 0-1.2.4-1.5 1-.4 1 0 1.9.8 2.3.8.3 1.8 0 2.2-1a1.7 1.7 0 0 0-.9-2.2 1.5 1.5 0 0 0-.6-.1zm0 .5h.5c.6.3.8 1 .5 1.6-.2.6-1 1-1.5.7-.5-.3-.8-1-.5-1.6.2-.4.5-.7 1-.7z" />
      <path
        fillRule="evenodd"
        d="M503.8 347.4c0-.3-.1-.4-.3-.5-.3-.1-.6 0-.7.2l.2.6.3.2c.3.3.5.7.3 1.2a1 1 0 0 1-1.3.6 1 1 0 0 1-.6-1.2h.4c-.1.4 0 .7.4.9.3 0 .6-.1.7-.4.2-.4 0-.6-.2-.8l-.2-.2c-.3-.2-.5-.5-.3-1 .1-.5.7-.6 1-.5.4.2.6.4.7.8h-.4zm2.4.1l-.5 1.9c-.1.5-.1 1 .4 1.2.6.1.9-.3 1-.8l.6-1.9.3.2-.5 1.9c-.2.7-.8 1.1-1.5 1-.7-.3-1-1-.7-1.6l.6-2 .3.1zm4.4 4.5l-1.8-3-.5 2.4h-.4l.7-3.4 1.8 3 .4-2.4h.4zm.8 0l.4-3.2h.3l-.4 3.2z"
      />
      <path d="M514.2 348.9a1.6 1.6 0 0 0-1.7 1.6c0 1 .7 1.7 1.6 1.8.8 0 1.6-.7 1.6-1.7 0-.9-.7-1.7-1.5-1.7zm0 .5c.6 0 1 .6 1 1.2a1.1 1.1 0 0 1-1.1 1.2c-.6 0-1.1-.6-1.1-1.3 0-.6.5-1.2 1.1-1.2z" />
      <path
        fillRule="evenodd"
        d="M519 352.1l-2.4-2.3.1 2.4h-.4l-.2-3.4 2.5 2.4-.2-2.4h.4zm2.1-.5l-.6-3.2h.4l.6 2.8.9-.2v.4zm1.8-.3l-.8-3.2h.4l.7 3.1z"
      />
      <path d="M523.9 347.7h-.4l-.4.2.9 3.1.7-.1c.5-.2 1-.6.8-1.2-.1-.4-.4-.7-.8-.6l.1-.8c-.2-.5-.5-.6-1-.6zm0 .4c.2 0 .4 0 .5.4.2.4-.1.5-.4.6h-.1l-.3-1h.1a1 1 0 0 1 .2 0zm.5 1.3c.3 0 .6 0 .6.4.2.4-.1.5-.4.6l-.3.1-.3-1h.4z" />
      <path
        fillRule="evenodd"
        d="M527.2 348l.2.3-1.2.4.4 1.2 1.2-.5.1.4-1.5.6-1.1-3.1 1.6-.6v.3l-1.1.5.3.8z"
      />
      <path d="M528.6 346.2c-.3 0-.5 0-.8.2l-.4.1 1.2 3h.3l-.4-1.4 1.4.9.5-.1-1.5-1c.4-.2.6-.7.4-1.1a.9.9 0 0 0-.7-.6zm0 .4l.3.3c.2.5-.2.7-.5.8l-.5-1h.1l.5-.1z" />
      <path
        fillRule="evenodd"
        d="M529.2 345.8l1.7-.8.2.3-.7.3 1.2 2.7-.3.1-1.2-2.6-.7.3z"
      />
      <path d="M532.2 344.2l.2 3.7.4-.2v-.8l1.3-.7.6.6.4-.3-2.9-2.3zm.4.9l1 .8-.8.5-.1-1.3zm2.7-2.2l-1 .3-.5.3 1.7 2.8.5-.3c.9-.5 1.3-1.4.7-2.3-.4-.6-.9-.8-1.4-.8zm.2.5c.3 0 .6.2.8.5.4.8 0 1.3-.6 1.7l-1.3-1.9h.1l1-.3z" />
      <g id="prefix__a" stroke="#000" strokeMiterlimit={2.6}>
        <path
          fill="#e60000"
          fillRule="evenodd"
          strokeWidth={0.1}
          d="M485 355.2c.6 0 1-.4 1-1a.9.9 0 0 0-1-.8c-.4 0-.8.4-.8.9s.4.9.9.9zm-5 6.3c.5 0 .9-.4.9-1a1 1 0 0 0-1-.8 1 1 0 0 0-.9.9c0 .5.5.9 1 .9zm-12-19.9c.5 0 1-.4 1-.9a1 1 0 0 0-1-.9.9.9 0 0 0-.8 1c0 .4.3.8.9.8zm-7.3 3.7c.5 0 1-.4 1-1 0-.5-.5-1-1-1a1 1 0 0 0-1 1c0 .6.4 1 1 1zm-1.4-22.3a1 1 0 0 0 1-1c0-.5-.4-1-1-1a1 1 0 0 0-1 1 1 1 0 0 0 1 1zm-6.2 1.8a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1zm3.2-19.8a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1c0 .5.4 1 1 1zm-5.5-18.3c.5 0 1-.4 1-1a1 1 0 0 0-1-1 1 1 0 0 0-1 1c0 .6.4 1 1 1zm7 1.8a1 1 0 0 0 1-1c0-.5-.4-1-1-1a1 1 0 0 0-1 1 1 1 0 0 0 1 1zm7-15.2c.5 0 1-.4 1-1 0-.5-.5-1-1-1a1 1 0 1 0 0 2zm-5.3-4.2a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1zm10.5-10.3a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1zm-21.5 46.3c.6 0 1-.4 1-1s-.4-1-1-1a1 1 0 0 0-1 1c0 .6.5 1 1 1z"
        />
        <path
          fill="none"
          strokeWidth={0.3}
          d="M486 358.9s-.8-3.2-.7-3.9l.8-.6m-1.4 5.7s-2.8.1-3.7.4l-.3.8m-13.4-15.5s-.2-3.8.6-4c0 0 .7-.4 1.2-1m-4.7 3.8s-2.1-.3-2.7 0c0 0-.2.6-.6.8m-.8-23l-.7.5c-.8.3-2.3 4-2.3 4s-2.4-1.9-3.4-2h-1.1m-4.8-20.2s.6.6 1.2.3c0 0 3 2 3.1 2.7 0 0 3.2-3.2 3.8-2.9 0 0 .3.5 1-.1m-5.8-18.6s.3.5.9.8c0 0 1.4 2 1.4 3.5 0 0 2.5-2.3 3.3-2.1 0 0 .9.3 1.5 0m.3-19.5s.6.8 1 .2c0 0 1.8 2.2.8 4 0 0 2.5-.7 3.3-.3 0 0 .3 1 1.2.5"
        />
        <g fill="#1f601a" fillRule="evenodd" strokeWidth={0.3}>
          <path d="M532.8 378.3l-4.5-.3c-.6 0-2-2.7-2.6-3.1-.6-.5-10.8-5.5-17.5-6.5a95 95 0 0 1-19-6 88 88 0 0 1-26-19.2c-2.9-4.2-6-14-7.2-19.2-.7-2.5-4-12.4-4-19.2a84 84 0 0 1 2.2-19.4 111 111 0 0 1 15.3-26.8s-12 18.7-14.2 25.9a81 81 0 0 0-2.5 21.5c.1 4.2 3.6 19.6 8.7 30.9 4.1 9 7.7 10.2 14 15.2 3 2.4 8.8 6.2 13.6 8.6 4.8 2.4 15 5.5 17.8 5.9 2.7.5 16.4 4.5 18.2 5.4 1.8 1 6.5 5 7.7 6.3z" />
          <path d="M464.1 343.4c.3-1.4.4-2.4 1-2.8a14 14 0 0 0 2.2-3.5c.3-1.2 0-2.2 0-2.8l.4-2.7s-.7-2.5-1.3-3c-.6-.4-2.2-2.6-2.5-3.2 0 0 .2 1.3-.3 1.9a7 7 0 0 0-.6 3c0 .9.3 3 0 4-.3 1.2-.7 2.2-.4 3.5l1.5 5.6zm-.5-1.5s-3.4-4.4-3.4-6.2c0-1.8-.3-2.9-.6-3.3-.3-.4-2.3-2.7-.5-5.6.8-1.2 1-1 1.4-2.4.6-1.6 1.8-1.6 2-3.3 0 0 .4 2 .5 3.6.2 1.7-.1 2.3-.2 3.2-.2.9.4 2 .4 3.3 0 1.4-.2 1.9-.2 2.7 0 .4-.5 6.2.6 8zm38.6 23.5l-4-.5c-.7 0-2.5-.5-3.5-.9a10 10 0 0 1-4-2.8c-2.8-3-2.5-4.5-3-4.6-1-.2 1.5-.4 2.8-.3 1.1.2 2.8 1 3.8 2 1.2 1.1 3 2.3 3.5 2.7.6.5 1 .7 1.7 1.5.7 1 .6 1.5 2.7 3z" />
          <path d="M506.2 367.5s-7.2-3.2-8-3.8a25 25 0 0 1-2.8-2.6c-.7-.8-3.8-2.4-4.3-3.4-.3-.7-2.3-3.3-3.4-5.4-.5-1 4.9.3 4.9.3 4.4 1.8 2.4.6 4.8 2.4 1.5 1.1 2.5 2 2.9 2.9.6 1.3 1.2 3.5 1.9 4.7.6 1.2 1.7 2.7 4 5z" />
          <path d="M510.2 368.4s-6-1.5-8.8-5.2c-2-2.6-2-1.8-2.7-2.7-1-1-2.6-2.3-4-4.5.2.3-1.6-5.9-1.6-6.6 0-.4 2.3.3 4.2 1 1.5.7 2.4 2 3.8 2.8 1.6 1 1.8 3.7 2.5 4.9 1 1.8 1.2 2.7 1.2 3.5 0 1.4.8 1.8 1.2 3 .5 1.3 2.1 1 4.2 3.8zm-9.6-2l-5.9-2.4c-.8-.1-1-.6-2.1-.9-.9-.2-1.7-.9-3.8-.4-.9.2-4.6 1-5.5.6-1-.5 1.3 2.5 2.3 3.1 1.1.7 2.9 1 4.4.8h4.4c.7 0 1.2.2 2.3-.1 1-.3 1.3-.8 3.9-.7z" />
          <path d="M504 366.4s-5.7-1.4-6.7-1.4l-4.8.4c-1 .2-4.5-.2-5.5.4-1 .4-5.6 1-6.8.8-1.2-.3 2.4 3.2 3.9 3.6 4.6 1.3 3.2 1.1 6.2.4 1.8-.5 4.4-.6 5.4-.8.9-.1.7-.7 2-1.2 1.1-.5 3.2-1.8 6.3-2.2z" />
          <path d="M508.7 368.8s-5.7-2.4-10.2-1.1l-4.2 1c-1.4.1-2.6-.6-5 .4-1.2.4-6.2 2.5-7.5 2.4-1.3-.1 4 3.3 5.4 3.1 4.6-.6 9 1 11 0l4-1.5c1-.4 1.5-1.2 2.1-1.7.6-.4 1-1.6 4.4-2.6zm-30.6-13.1s-3.3-3.6-4-4.1l-3-2.4c-.6-.6-1.3-2-3.4-2.5-1-.2-3.1-.6-3.8-1.4-.6-.8.1 3 .8 4a8.1 8.1 0 0 0 3.6 2.5c1.5.5 3.3 1.5 4 1.9.6.3 1 .6 2 .8 1.1.2 1.6 0 3.8 1.2z" />
          <path d="M481.3 357.2s-5.7-4-6.5-4.4l-3.5-1.3c-1.1-.3-4-2.3-5-2.3-1.2 0-3.3-.1-4.3-.8-1-.8-.1 2.7 1 3.7 3.6 3.2 1.1 2.2 4.1 2.8l5.1 1.7c1 .3 1-.3 2.3-.2 1.3 0 3.8-.2 6.8.8z" />
          <path d="M482.6 358.3s-2.3-1.6-6.9-2.4c-3-.5-3-.6-4.1-1-1.4-.4-1.7-.4-4.3-.5-1.2-.1-6.2 1.5-7.4.8-1-.6 1.3 1.5 2.6 2 2 .8 1.8 2 4 2.8 2.2.7 4.7 1.6 6 1.4 1-.2 1.8-.7 3.3-.8 1.4-.2 4-2.3 6.8-2.4zm.5-1.2s1.1-5.5.1-6.8a5.2 5.2 0 0 1-1.2-2.9 11 11 0 0 0-1.6-4.3c-.6-.8-1.8-4.2-1.5-5.1 0 0-3.2 3.1-3 5.1v2.4c-.2.9.7 3.9 1.3 4.8.6 1 .3 3.6 1 4.2.5.6 4.1 3 4.9 2.6z" />
          <path d="M482.6 358.3c.3.1-2-1.8-3-2.3-1-.4-5.3-1.6-5.6-2.7-.3-1-3.7-4.6-3.9-5.6 0-.6-.7-2-.6-2.8.2-.7.5-2.6 1-3.6.4-1.1 1.4-3.6 2.5-4l1.2 3.8c.3 1 .6 2.3 1 2.9.5.6 2 3.4 2.1 4.5l1.1 5.3c.1.7 3 3.8 4.2 4.4zM464 343.4c.1.8-2.3-.8-3.5-.8-1.2 0-4.8.5-5.7-.4-.9-1-2.2-2.6-2.7-2.9-.5-.3-2.1-3-2.6-4.5-.4-1.5-3.6-4.2-4-4.5 0 0 4.3-.9 7 .9s3 1.4 3.5 1.6c.6.3 5.3 4.3 5.6 5.8.3 1.5 2.2 4 2.4 4.8z" />
          <path d="M464.1 343.4s-3.9-2.7-4.8-2.6c-1 .2-5.2-3-5.4-5-.2-1-2.2-2.5-2.6-3.1-1-1.8-1.7-5.9-3.2-7l5.2 1.3c2 .3 3.6.6 4.3 2.2.8 1.7 1.4 3 2 3.2.6.2 1.5 2.3 1.8 4.4a32 32 0 0 0 2.7 6.6zm-7.4-20.5c.7 1 .6-6 .9-6.8a11.3 11.3 0 0 1 1.7-2.8c.6-.6.6-2.7.9-3.3.3-.6.1-4.7-.3-5.8L458 306c-.6.7-1.7 1-2 2-.3.8-.9.8-1.3 1.8a5.6 5.6 0 0 0-.6 3.6c.3 1.2.1 1.6.1 2.7 0 1 1.5 5.6 2.4 6.9z" />
          <path d="M456.9 323.5s-.3-2 .4-2.7c.8-.8 1.5-.8 1.8-1.2.3-.5.2-1 .5-1.7.3-.6 1-1.6 1-2 .3-1.7 1.3-3.6.5-5.3 0 0-1.7.5-2.1.8-.5.3-1.8 1.6-2 2.8-.1 1.3-.3 1.5-.7 2.2-.5.8-1 3-.3 4.4a7.4 7.4 0 0 1 .9 2.7zm-4.4-23s-.3-4.4.9-5.8c1.2-1.3 1.5-3.9 4.2-5.3v1.9c.2.7.5 2.8 0 3.6-.4.7-2 2-2 2.7 0 .6-1 2.1-1.7 2.4l-1.4.5z" />
          <path d="M452.5 302.8s0-3 .9-4c.9-.9 1.4-1.4 1.8-2 .5-.5 1-2 2-2.7 1-.6 2.8-2.1 3-2.7 0 0 .4 3.8-.6 5.8s-1 3-2.3 3.4c-1.2.5-1.4.8-1.8 1-.5.4-1.2.8-1.8.8-.6 0-1.2.4-1.2.4zm3.5 20.6c.1.8.7-2-2.4-2-3.2 0-5.8-1.2-6.8-2.3l-2.1-2.3a9 9 0 0 1-1.8-3.1c-.2-.9-1-4.2-1-4.8 0 0 1.7.3 2.5.9.7.6 2 .6 2.8 1 .8.5 1.4 1.7 1.9 2.1.4.5 1.7.5 2.3 1.4.6.9 1.7 2.9 1.9 3.8 0 .9 1.2 1.8 2 2.2.6.5.5 2.3.6 3z" />
          <path d="M455.6 322.1s-2-2.5-3.1-2.5c-1 0-3.8-2.7-4-4 0-1.1-1-3.4-1.6-3.9a3.6 3.6 0 0 1-1.5-3.3c.2-1.8.2-4.8.2-4.8s.6 1.8 1.5 2.3c.9.4 2.5 1 2.8 1.6.3.6 1.5.6 2 2.5.5 1.7.5 1.6.8 2.2.3.6 1 1.4 1.3 2.6.3 1.2 2 4.3 1.7 7.3zm-3-16.6c-.2.8 1.1-1.6-1.7-2.4a9.6 9.6 0 0 1-5.6-4l-1.3-2.6a9 9 0 0 1-.7-3.4c0-.9.2-4.1.5-4.6 0 0 1.4.7 2 1.4.4.8 1.7 1.2 2.3 1.8.5.6.7 1.9 1 2.5.3.5 1.5.9 1.8 1.8.3 1 .7 3.1.6 4-.1.8.6 2 1.2 2.6.5.6-.1 2.2-.2 3z" />
          <path d="M452.6 304.3s-1.3-2.9-2.2-3.2c-1-.3-2.5-2.7-2.6-3.9-.1-1.2-.3-3.4-.7-4-.5-.6-1.3-2.4-.6-4l1.6-3.7 1.3 2.1c.8 1.6 1.6 1.7 1.7 2.3.1.7 1 1 1.4 2.3.5 1.7 0 1.6 0 2.3.2.6.7 1.5.6 2.7 0 1.1.6 4.5-.5 7.1zm2.3-18.2c.1-.4 1-.9 2.1-1.2 1-.3 2.7-2.7 3.5-3.3.7-.6 1-1.6 2-2.1.9-.5 1.4-2.4 1.7-4.2l-3.3.7a7.2 7.2 0 0 0-2.8 1.8c-.6.8-1.2 2-1.9 2.3-.6.3-1.3 2.1-1.3 3.3v2.7z" />
          <path d="M454.8 284.8l-.2-2.6c0-.9-.6-3.3.7-5.3 1-1.3 4.3-3.9 5.2-4 0 0 .6 2.4.4 3.1-.1.8-1 3.8-1.6 4.1-.7.3-2.4 3.9-4.5 4.7z" />
          <path d="M454 286.1c-.4.7-.1-2.2-1-3-1-.7-1-1.8-1-3s.2-2 .3-2.9c.2-.7 2.5-3.9 2.3-4.8l1.7 3.8c.4 1-.3 2.1-.2 3 .2.9.9 2.6.3 3.5L454 286zm8-15.5s.2-.4 1.5-.4 3.3-.1 3.9-.8c.6-.6 1.6-1.4 2.3-1.7a5.2 5.2 0 0 0 1.8-2.2c.1-.6 1.2-1.8 1.6-1.8 0 0-1.6-.2-3.4.3-1.8.5-4.4 1.4-5 2.6-.6 1.2-2.7 4-2.7 4z" />
          <path d="M462.5 270.3c.3 1 2.8-1 3.4-1.8l1.5-2 1.8-2.4c1-1.6.7-4.6.3-4.3a31 31 0 0 1-2.5 1.4c-.5 0-1.4.4-1.7 1.1-.3.8-.6 1.8-1 2.3-.5.5-3.2 2-1.8 5.7z" />
          <path d="M461.6 270.3s2-1.5 2.8-2.3c1-.8.5-2 1-2.6.3-.6 1.4-2 1.1-3l-.9-3.4-1.8 1.8c-.8.8-.9 1.4-1.2 2.3-.3.9-1 1.5-1.2 2.2-.3.8 0 2.3.2 3.2v1.8z" />
        </g>
        <g fill="none" strokeWidth={0.1}>
          <path d="M494.8 365.2s-10-.1-10.8-1.3m16.6 2.6s-6.5 1.7-10 1.3c-3.5-.4-5.1.3-5.9.3-.7 0-4.5-1.5-4.5-1.5m27 2.2l-6 1.3c-1 .3-6.2 2.2-7.7 2.2h-5a18 18 0 0 1-6.3-.4m6.2-15s3.7 2.3 4.4 3c.5.8 3.8 3.5 4.5 3.5m-9-11.1s6.5 5.6 7.6 6.3c1 .8 7.4 7 8.1 7.8M493.6 350s5.1 4 5.7 5.7c.6 1.7 2.2 3.6 2.2 3.6s2 4.2 2.8 4.8c.8.6 2.3 2.2 4.1 3.4m-44-21.3s5.4 4.6 6.9 5.4m-9.1-2.5s5.4 3.7 7.8 4.6c2.4 1 4.4 1.7 9.6 2.4m2.1 2.2s-6-.3-7 0-5.8-.8-7-1.1l-6.6-1.4m11.4-17.9s-.3 3.3.2 4.7c.4 1.3 2.6 5.3 2.4 6.2-.1.9 1.2 5 2.4 5.7m1.2-16s-1 3.3-.6 4.4c.5 1 1.2 3 1.2 4.2 0 1.2.8 3 1 3.8.4.7-.1 3.3.7 4l1.6 2.2m-36.1-26.3s4.8 1.9 5.4 3c.6 1.3 1.5 1.6 2 2.2m10.3-9.7s1.3 4.9 1 6c-.3 1.2-.3 3.7-.3 4.6 0 .9-1.4 4.5-1.3 5m-1.3-19.6l-.6 4c-.1 1.2 0 3.2-.3 4-.3.7-.8 4.8 0 6.6M449 326.2l4.8 4.2c.9 1 5 5.3 5.1 6.4.1 1 3 4.3 3.9 5m-20.5-32.5s4 4 4.2 4.9c.3.9 2 2.3 2.8 2.8m11.4-6s-1.5 2.3-1.5 3c0 .8-.6 2.7-1.2 3.5-.4.5-1.7 2.7-1.5 4m3-16.8l-1 3.6c-.2 1.5-1 3-1.3 4-.3.8-1.5 5.2-1 7.9m-10.4-15.7s.4 2.1 1.5 3.2c1 1 2.7 2.6 2.8 3.4.2 1 1.6 5.4 3 7a5.4 5.4 0 0 1 1.7 3m-10.5-32s.4 2.6.7 3.4c.3.7 1.5 4 2.7 5.1m9.5-7.7l-.9 3c-.1 1-1 2-1.2 2.4l-.7 2m5.5-5.3c-.1.9-1.8 3.6-2 4-.1.5-1 2.6-1.9 3.2-.9.6-3.6 2.6-3.4 3.4m-4.4-16.5s-.2 3.3.4 4.5a37.2 37.2 0 0 1 1.7 4c.3.9.3 2.4.4 3.4.2 1.1.6 3 1.2 3.8m11.8-25.9l-3.2 3.5c-1 1-4.8 5-5 5.8m4.6-11.6s-2.1 4.7-2.6 5.4l-.9 2m-2-7.5s.2 3.6 0 4.5a7.9 7.9 0 0 0 0 2.9c.2.4-.4 3.7-.5 4.5m18-21.3s-4.8 2.9-5.5 3.6m2.7-7.3l-3.3 4.8-.8 1.4m.3-6.7s-1 2.6-1.2 3.6a36 36 0 0 1-2.2 5.6" />
          <path strokeWidth={0.3} d="M469.2 258s-.4 1 1.4.7" />
        </g>
      </g>
      <use
        width="100%"
        height="100%"
        transform="matrix(-1 0 0 1 1030 0)"
        xlinkHref="#prefix__a"
      />
      <path
        fill="#00209f"
        fillRule="evenodd"
        d="M514.6 366.1s.7-1.8 2.2-.1c0 0 1.9 4.2.5 4.3-1.4.2-2.7.5-2.9-.3-.1-.7.2-3.9.2-3.9z"
      />
      <path
        fill="#00209f"
        fillRule="evenodd"
        d="M516.5 365.5s.5-6.4 1.4-6.7c.9-.3 3.6-1.8 5.3-.5 1.6 1.4 0 8-.5 8.7-.6.6-1.5 2.5-5 2l-.4-1.6s1.8-.2 3-.8c1.2-.6 1.6-1.2 1.5-1.8-.2-.9 0-4.2-1-4.5l-2.3-.8-1.7 6.5-.3-.5z"
      />
      <path
        fill="#00209f"
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.2}
        d="M514.4 370s-6.2 3.7-3 9l-2.1-1.3s-1.2 2.2-.1 3.4c0 0-4.3-3.8-1-8.3 3.4-4.6 6-4.3 6-4.3l.2 1.5z"
      />
      <path
        fill="#00209f"
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.2}
        d="M514.4 367s-2.7-1.8-6.6-.7c0 0-1.7-5.6-1-7.4.2-.8.8-.9.8-.9s-2-1.2-1.3 4c.6 5.4 1.6 6.8 1.6 6.8s5.2.3 6.4-.3l.1-1.4z"
      />
      <path
        fill="#00209f"
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.2}
        d="M514.4 367s-5.4-9-6.8-9c0 0-1.5-.2 2-.6 1.2-.1 3.2 0 4 1.7 1 1.6 1.7 5.5 2 6.1 0 0-1 .3-1.2 1.9z"
      />
      <path
        fill="#011322"
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.2}
        d="M514.4 367s-3.6-1.6-4-2c-.5-.5-1.2-5.6-.8-5.3 0 0-1.5-1.7-2-1.7-.3 0-1.3.8-1 2.6.3 1.8.7 4.5 1.2 5.7 0 0 2.9-1.2 6.6.8z"
      />
      <path
        fill="#00209f"
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.2}
        d="M517.7 370s2 1.3 2 3.5c0 2.3.9 6.4 2.7 7.3 0 0 .5-1.7 1-2 0 0 1.9 2.1 2.5 2.1 0 0-1-2-1-2.9 0-.9-1-4.3-2-5.2-.8-1-2.6-3-5.2-3.8v1z"
      />
      <path
        fill="#011322"
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.2}
        d="M518.5 359.5l-1.7 6.5.5 1.4s.6-.2.9-1c.3-.7 1.2-6.3 1.7-6.5l-1.4-.4z"
      />
      <path
        fill="#011d33"
        fillRule="evenodd"
        d="M514.4 369.3s-3 1-4.1 3.2c0 0-.4-1.5 4-3.6v.4zm3.4 0s2 .8 2.6 2l-2.6-1.5v-.5zm-3.4-1.7s-4.6.7-5.6.5c0 0 1.3.3 5.6 0v-.5zm7.4-2.8s.5 2.3.9 2.2c.4-.2 1.2-3.9 1.2-5.6 0-1.7-.7-2.1-1.4-2-.7 0-1 1.5-1 2.2a49 49 0 0 0 .3 3.2z"
      />
      <path
        fill="#011d33"
        fillRule="evenodd"
        d="M516.8 366s1.9 4.1.5 4.4c-1.4.2.6.1-.4-2.7-.4-1.1-1-2.5-1.3-2.5 0 0 1.1.4 1.2.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.2}
        d="M514.6 366.1s.7-1.8 2.2-.1c0 0 1.9 4.2.5 4.3-1.4.2-2.7.5-2.9-.3-.1-.7.2-3.9.2-3.9z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.2}
        d="M516.5 365.5s.5-6.4 1.4-6.7c.9-.3 3.6-1.8 5.3-.5 1.6 1.4 0 8-.5 8.7-.6.6-1.5 2.5-5 2l-.4-1.6s1.8-.2 3-.8c1.2-.6 1.6-1.2 1.5-1.8-.2-.9 0-4.2-1-4.5l-2.3-.8-1.7 6.5-.3-.5z"
      />
    </g>
    <g transform="matrix(.8 0 0 .8 -92.7 0)">
      <path
        fill="#00209f"
        fillRule="evenodd"
        d="M509.8 255.9c-.4-1-.4-7.4-.4-8.4a68 68 0 0 1 3.8-11.2c.6-1 .5-1.2.7-1.8l.9-1.2a10.9 10.9 0 0 1 1.3 4.1s-.6 4.1-1.1 6c-.4 1.7-1.6 4.3-1.8 4.8-.6 1.2-.5 2.4-.2 2.5l-3.2 5.2z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M515 247.3l.5.6c1.3-1.5 1.4-4.5 1.4-4.5l-.9-6s-.5 4-1 6c-.4 1.7-1.6 4.3-1.8 4.8-.9 2.2-.2 2.4-.2 2.5l2-3.3z"
      />
      <path
        fill="#00209f"
        fillRule="evenodd"
        d="M515.5 247.9c1.3-1.5 1.4-4.5 1.4-4.5s1 5 .4 6c-.5 1-.5.7-.4 1.3l-1.4-2.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.3}
        d="M517 250.7c-.2-.6-.2-.3.3-1.3s-.4-6-.4-6l-.9-6c0-1.3-.6-3-1.2-4.1l-.9 1.2c-.2.6 0 .8-.7 1.8-.6 1-3.6 9.5-3.8 11.2 0 1 0 7.5.4 8.4"
      />
      <path
        fill="#fc0"
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.1}
        d="M515 234.1l-.2-1.3c0-.2.6.9 1 .7.9.3 1.9 1.5 2.1 1.8-.4.5-1.3 1.6-2 1.4-.5-.2-.4-1-.5-1.5-.1-.3-.4-.6-.4-1z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.1}
        d="M515 233.3l.4.4c.2.2.4 0 .7.2.6.4.9.8 1.6 1.5m-2-1.4c.8.4 1.2 1 1.8 1.7"
      />
      <path
        fill="#fc0"
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.1}
        d="M514 233.4l1.3-.6c.1 0-.7.8-.4 1.2 0 .9-.7 2.2-1 2.5-.6-.1-1.2-.1-1.8-1.1-.2-.4.4-.8.8-1.1.2-.2.7-.8 1.2-.9z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.1}
        d="M514.9 233.2l-.3.5.1.7c-.2.7-.5 1-.9 2"
      />
      <path
        fill="none"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.1}
        d="M514.4 234c0 .9-.5 1.5-1 2.3h.2"
      />
      <path
        fill="#fc0"
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.1}
        d="M515.4 232.8c.6-.7 1.7-1.4 2.3-1l.6.6c.2.3.2.5 0 .8-.3.8-1.4.4-2 0-.2 0-.6-.4-.8-.3l-.3.1.3.1 1.8.9c.5.2 1.5-.5 1.4-1 0-.5-.9-1.5-1.3-1.5-1 0-1.8.6-2.5 1.4.2-.2.4 0 .5 0z"
      />
      <path
        fill="#fc0"
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.1}
        d="M514.9 232.8c-.6-.7-1.7-1.4-2.2-1l-.6.6c-.3.3-.3.5-.1.8.3.8 1.4.4 2 0 .2 0 .6-.4.8-.3l.4.1-.4.1-1.8.9c-.5.2-1.4-.5-1.4-1 0-.6 1-1.5 1.4-1.5 1 0 1.7.6 2.4 1.4-.1-.2-.4 0-.5 0z"
      />
      <path
        fill="#fc0"
        fillRule="evenodd"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.1}
        d="M515 232.4c-.2-.1-.5.1-.6.3 0 .2.1.6.4.6.3.2.8 0 .9-.3 0-.4-.3-.5-.6-.6z"
      />
      <path
        fill="#fc0"
        fillRule="evenodd"
        d="M515 226.3s.4 2.4 1.6 4c1.2 1.8-1.4 1.6-1.6 2.2 0 0-.8-1.7-1.6-2.2 0 0 1.3-2 1.6-4z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.1}
        d="M515 226.3s.4 2.4 1.6 4c0 0-1.4 1.6-1.6 2.2 0 0-.8-1.7-1.6-2.2 0 0 1.3-2 1.6-4"
      />
      <path
        fill="none"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.1}
        d="M515 228.8l.7 1.8s-.6.4-.7.7c0 0-.3-.8-.6-1 0 0 .6-.8.6-1.5z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M515 344.5l-.3-.2c-.4-.2-1.2-.2-1.3-.5-1-1.1-.4-3.4 0-4.8 1-2.6 1-5 1.6-7.4.6 2.4.7 4.8 1.6 7.4.4 1.4 1.1 3.7.1 4.8-.2.3-.9.3-1.3.5l-.4.2z"
      />
      <path
        fill="#00209f"
        fillRule="evenodd"
        d="M515 331.5c.6 2.5.7 5 1.6 7.6.4 1.3 1 3.4.3 4.5.4 0 .7-.1 1-.3.2 0 .3 0 .4-.2l.4-.5c.3-.2.6 0 .9-.2l.1-.2c.6-.3 1-.6 1.3-1.1.1-.4.2-.9 0-1.3 0-.3 0-.5-.2-.8l-.5-1.1-.6-1.2a2.4 2.4 0 0 0-.3-.5l-.3-.6-.4-.4-.4-.3s-.3-.1-.2-.2l-.3-.1-1-2a3 3 0 0 1-.2-1.1H515zm0 0c-.5 2.5-.7 5-1.6 7.6-.3 1.3-1 3.4-.2 4.5-.4 0-.7-.1-1.1-.3-.1 0-.3 0-.3-.2a1.4 1.4 0 0 0-.5-.5c-.2-.2-.5 0-.8-.2l-.2-.2c-.5-.3-1-.6-1.2-1.1a2.5 2.5 0 0 1-.1-1.3l.2-.8.6-1.1.6-1.2c0-.2.1-.4.3-.5l.3-.6.4-.4.4-.3.2-.2.2-.1 1-2c.2-.2.2-.8.2-1.1h1.6z"
      />
      <g id="prefix__b" fill="none" strokeMiterlimit={2.6} strokeWidth={0.2}>
        <path stroke="#011322" d="M514.3 331.6s-1 4-1.6 5c-.6 1.1-3 3-1.4 6" />
        <path
          stroke="#011d33"
          d="M514.4 331.6s-1 4-1.6 5.1c-.6 1.1-3 3-1.4 6"
        />
        <path
          stroke="#022743"
          d="M514.5 331.6s-1 4.1-1.6 5.2c-.6 1-2.9 3.1-1.3 6"
        />
        <path
          stroke="#033054"
          d="M514.6 331.6s-1 4.2-1.6 5.3c-.6 1-2.9 3-1.2 6.1"
        />
        <path
          stroke="#053a65"
          d="M514.7 331.6s-1 4.3-1.6 5.3c-.6 1-2.8 3.2-1.2 6.3"
        />
        <path stroke="#011d33" d="M514.2 331.6s-1 4-1.6 5c-.6 1.1-3 3-1.4 6" />
        <path stroke="#022743" d="M514 331.6s-.9 3.8-1.6 5c-.6 1-3 3-1.4 5.9" />
        <path stroke="#033054" d="M514 331.6s-1 3.7-1.7 5c-.5 1-3 3-1.4 5.9" />
        <path
          stroke="#053a65"
          d="M513.8 331.6s-.8 3.6-1.6 5c-.6 1-3 3-1.4 5.9"
        />
        <path
          stroke="#00209f"
          d="M513.8 331.6s-.9 3.4-1.7 5c-.6 1-3 2.9-1.4 5.8"
        />
        <path
          stroke="#00209f"
          d="M514.8 331.6s-1 4.3-1.6 5.4c-.6 1-2.8 3.3-1.1 6.3"
        />
      </g>
      <use
        width="100%"
        height="100%"
        transform="matrix(-1 0 0 1 1030 0)"
        xlinkHref="#prefix__b"
      />
      <path
        fill="none"
        stroke="#000"
        strokeMiterlimit={2.6}
        strokeWidth={0.2}
        d="M518.6 335.2l.5.5.3.5.3.5.6 1.2.5 1.1.3.8a2.5 2.5 0 0 1-.1 1.3c-.2.5-.8.8-1.3 1.1l-.1.2c-.3.2-.6 0-.9.2a1.9 1.9 0 0 0-.4.5l-.3.2c-.4.2-.7.3-1.1.3l-.2.3c-.2.2-1 .2-1.3.4l-.4.2-.3-.2c-.4-.2-1.2-.2-1.3-.4a.7.7 0 0 1-.2-.3l-1.2-.3s-.2 0-.3-.2a1.4 1.4 0 0 0-.4-.5c-.3-.2-.6 0-.8-.2l-.2-.2c-.6-.3-1-.6-1.2-1.1a2.5 2.5 0 0 1-.1-1.3l.2-.8.5-1.1.7-1.2c0-.2.1-.4.3-.5 0-.2.1-.4.3-.5 0-.2.3-.3.4-.5"
      />
      <g id="prefix__c">
        <g fillRule="evenodd">
          <path
            fill="#fff"
            d="M487.4 293.6c-1.5-3.7-3-11.3-3-13 .3-7.1.2-9.3.9-16.5l7.3 8.3c-.2 2.8-.2 3.7 0 5.5.1.7.5 3.9 1 5.1l-6.2 10.6z"
          />
          <path
            fill="#00209f"
            d="M493.6 283c-.5-1.3-.9-4.5-1-5.1-.2-1.8-.2-2.7 0-5.5l4.5 5-3.5 5.6zm-18.6 7a75.6 75.6 0 0 1-.3-4.4c0-5.1-.6-8 0-13.4.4-4.2 1.5-9.8 1.3-14.4-.1-1.3.1-2.6.2-3.9l9 10.1c-.6 7.3-.5 9.5-.8 16.6 0 1.7 1.5 9.3 3 13l-2 3.2-10.4-6.9zm6.3 13.7c-.6-1-1-3.9-1.2-4.5-.3-1.5-.3-2.3-.2-5l5 3.3-3.6 6.2zm-14.3 24a5.2 5.2 0 0 1-1.8-2.2c-.7-1.8-.5-1.7-1-3.6-.2-1.1-.2-2.3-.5-3.4-.2-1.2-1.8-4.8-1.8-6.2-.2-4.8-1.8-8-1.4-13.2.3-4 1.2-9.4.7-13.5l.1-3.6 10.3 6.7c-.4 6.8-.2 8.8-.2 15.4 0 1.6 1.3 8.1 3 11l-7.4 12.6zm17 3.8c1.9 1.7 5.4 2.6 6 3 1.2 1 3 2.3 6.3 2.4 2.3.2 3.3-.4 5.7-.7 2.8-.3-.3.1 2.3-.5 1.4-.3 1.4-.5 3.2-1 1.3-.3 2.7-.6 3.5-1.8.3-.4.6-.7.6-1.4h1.8c.2.5-.3 1.5-.5 1.8l-.5.7c-.2.6-.2.4-.7.9l-.8.6c-.4.3-.7.6-1.1.7-1.8.3-2.5.7-4.2 1.1-1.6.5-.7.4-2 .7l-2.4.7-2.4.6c-2.9.7-5.7.5-8.6.3-1.1 0-4-.7-5-1.4-1.8-1.2-5.7-1.7-7.4-2.9-.3-.2-1.4-.7-1.6-1-1.7-1.3-3-1.7-4.8-2.8H484z"
          />
          <path
            fill="#00209f"
            d="M497.7 331.5h14c-.1.7-.4 1-.7 1.5-.8 1-2.2 1.4-3.5 1.7-1.4.4-2.9-.4-4.4-.4-3.7-1.1-4.1-2.3-5.4-2.8z"
          />
          <path
            fill="#fff"
            d="M497.7 331.5c1.3.6 2 1.7 5.4 2.8 1.3 0 2.8.6 4 .6-1.5.3-1.5.5-2.8.8-2.6.6.5.2-2.3.5-2.4.3-3.4 1-5.7.8a11 11 0 0 1-6.3-2.5c-.6-.4-4.1-1.3-6-3h13.7z"
          />
        </g>
        <g fill="none" strokeMiterlimit={2.6} strokeWidth={0.2}>
          <path stroke="#022743" d="M476.6 259.7s1.7 15 7.5 14.4" />
          <path
            stroke="#022847"
            d="M484.2 274c-3 .2-4.9-3.5-6-7a46.3 46.3 0 0 1-1.5-7.3"
          />
          <path
            stroke="#032b4c"
            d="M484.2 274c-3-.1-4.9-3.8-5.8-7a43.6 43.6 0 0 1-1.7-7.4"
          />
          <path
            stroke="#032d4f"
            d="M484.2 274c-2.9-.3-4.9-4.1-5.8-7.2a48.2 48.2 0 0 1-1.7-7.2"
          />
          <path
            stroke="#032f53"
            d="M484.2 273.9c-2.9-.5-4.9-4.4-5.8-7.2a43 43 0 0 1-1.7-7.2"
          />
          <path
            stroke="#043258"
            d="M484.2 273.8c-3-.6-4.9-4.6-5.7-7.1-1.1-3.2-1.8-7.1-1.9-7.2"
          />
          <path
            stroke="#04345b"
            d="M484.2 273.8c-2.9-.9-4.9-4.9-5.6-7.2a46 46 0 0 1-2-7.2"
          />
          <path
            stroke="#04365e"
            d="M484.3 273.7c-3-1-5-5-5.7-7.3a48.7 48.7 0 0 1-1.9-7"
          />
          <path
            stroke="#043862"
            d="M484.3 273.7c-3-1.2-5-5.4-5.6-7.3a47.5 47.5 0 0 1-2-7.1"
          />
          <path
            stroke="#053b67"
            d="M484.3 273.6c-3-1.3-5-5.6-5.6-7.3-1-2.8-2-6.8-2-7"
          />
          <path
            stroke="#053d6a"
            d="M484.3 273.6c-3-1.6-5-6-5.5-7.4a50.3 50.3 0 0 1-2.1-7"
          />
          <path
            stroke="#053f6e"
            d="M484.3 273.5c-3-1.7-5-6.2-5.4-7.4a45.7 45.7 0 0 1-2.2-7"
          />
          <path
            stroke="#064172"
            d="M484.4 273.5c-3-2-5-6.4-5.5-7.5a66 66 0 0 1-2.2-7"
          />
          <path
            stroke="#00209f"
            d="M476.7 259a47 47 0 0 0 2.3 6.9c.3.8 2.4 5.4 5.4 7.5"
          />
          <path stroke="#022743" d="M476.9 256.3s4.8 12 8 10.6" />
          <path
            stroke="#022a49"
            d="M484.8 266.9c-1.3.5-3.3-1.8-5-4.6a65.2 65.2 0 0 1-3-6"
          />
          <path
            stroke="#032d4f"
            d="M484.8 266.8c-1.2.5-3.2-1.8-4.9-4.6a86 86 0 0 1-3-6"
          />
          <path
            stroke="#033054"
            d="M484.8 266.8c-1 .4-3.2-1.7-4.9-4.7a91.5 91.5 0 0 1-3-5.9"
          />
          <path
            stroke="#043359"
            d="M484.8 266.8c-.8.3-3.1-1.7-4.8-4.8-2-3.4-3-5.8-3-5.8"
          />
          <path
            stroke="#043760"
            d="M484.9 266.7c-.7.3-3.1-1.7-4.8-4.8l-3.1-5.8"
          />
          <path
            stroke="#053a65"
            d="M484.9 266.7c-.6.3-3-1.7-4.8-4.9a749.5 749.5 0 0 0-3.2-5.8"
          />
          <path
            stroke="#053d6a"
            d="M484.9 266.7c-.4.2-3-1.6-4.7-5a281 281 0 0 0-3.2-5.7"
          />
          <path stroke="#064171" d="M484.9 266.7c-.2 0-2.9-1.6-4.7-5L477 256" />
          <path
            stroke="#00209f"
            d="M477 255.9s1 1.4 3.3 5.7a13.6 13.6 0 0 0 4.5 5m8 12.1l3.8-.7m-4-3.1l4.1 2.2"
          />
          <path stroke="#064171" d="M492.5 275l4.2 2" />
          <path stroke="#053e6c" d="M492.5 275.2l4.2 2" />
          <path stroke="#053b67" d="M492.5 275.4l4.2 1.8" />
          <path stroke="#043862" d="M492.6 275.6l4.2 1.6" />
          <path stroke="#04355c" d="M492.6 275.8l4.2 1.4" />
          <path stroke="#043258" d="M492.6 276l4.3 1.2" />
          <path stroke="#032f53" d="M492.6 276.1l4.3 1.2" />
          <path stroke="#032c4d" d="M492.6 276.3l4.4 1" />
          <path stroke="#022a49" d="M492.6 276.5l4.4.9" />
          <path stroke="#064171" d="M492.8 278.5l3.9-.5" />
          <path stroke="#053e6c" d="M492.8 278.3l4-.4" />
          <path stroke="#053b67" d="M492.8 278.1l4-.3" />
          <path stroke="#043862" d="M492.8 278l4-.2" />
          <path stroke="#04355c" d="M492.8 277.7h4" />
          <path stroke="#043258" d="M492.8 277.5l4.1.2" />
          <path stroke="#032f53" d="M492.8 277.3l4.2.3" />
          <path stroke="#032c4d" d="M492.7 277.1l4.3.4" />
          <path stroke="#022a49" d="M492.7 276.9l4.4.6" />
          <path
            stroke="#022743"
            d="M492.7 276.7l4.4.7m-22.1.4s.2 3.2.9 4.5c1 1.9 3.9 4.7 7.2 6.8"
          />
          <path
            stroke="#022847"
            d="M483.2 289.1a27.2 27.2 0 0 1-5.5-4.6 13.7 13.7 0 0 1-1.7-2.3c-.7-1.4-1-4.5-1-4.5"
          />
          <path
            stroke="#032b4c"
            d="M483.3 289.1a27.2 27.2 0 0 1-5.4-4.7 9.3 9.3 0 0 1-1.7-2.3c-.8-1.4-1.2-4.5-1.2-4.5"
          />
          <path
            stroke="#032d4f"
            d="M483.3 289.1a31.3 31.3 0 0 1-5.3-4.7 12 12 0 0 1-1.7-2.4c-.8-1.5-1.3-4.5-1.3-4.5"
          />
          <path
            stroke="#032f53"
            d="M483.4 289a31.3 31.3 0 0 1-5.3-4.7 13.6 13.6 0 0 1-1.7-2.4c-.8-1.5-1.4-4.4-1.4-4.4"
          />
          <path
            stroke="#043258"
            d="M483.5 289c-2.1-1.3-4-3.5-5.3-4.8a10 10 0 0 1-1.6-2.4c-1-1.5-1.6-4.4-1.6-4.4"
          />
          <path
            stroke="#04345b"
            d="M483.6 289c-2.1-1.4-4-3.6-5.3-4.9a15.1 15.1 0 0 1-1.6-2.3 21.4 21.4 0 0 1-1.7-4.5"
          />
          <path
            stroke="#04365e"
            d="M483.6 289c-2-1.4-4-3.7-5.1-5a14 14 0 0 1-1.7-2.3c-1-1.7-1.8-4.5-1.8-4.5"
          />
          <path
            stroke="#043862"
            d="M483.7 289c-2-1.4-4-3.8-5.1-5a15 15 0 0 1-1.6-2.4 26 26 0 0 1-2-4.5"
          />
          <path
            stroke="#053b67"
            d="M483.8 289c-2-1.5-4-4-5-5.1a13.8 13.8 0 0 1-1.7-2.4c-1.1-1.8-2-4.5-2-4.5"
          />
          <path
            stroke="#053d6a"
            d="M483.9 289c-2-1.5-4-4-5-5.2a16.8 16.8 0 0 1-1.7-2.4c-1-1.8-2.1-4.5-2.1-4.5"
          />
          <path
            stroke="#053f6e"
            d="M484 289c-2-1.5-4-4.2-5-5.3a18.7 18.7 0 0 1-1.7-2.4l-2.2-4.4"
          />
          <path
            stroke="#064172"
            d="M484 289c-2-1.6-3.9-4.3-4.9-5.4a16.1 16.1 0 0 1-1.6-2.4l-2.4-4.4"
          />
          <path
            stroke="#00209f"
            d="M475 276.7s3 5.3 4.3 6.8c1 1 2.8 4 4.8 5.5"
          />
          <path stroke="#011d33" d="M475.2 290l10.2 6.6 2-3-1-2.7" />
          <path
            stroke="#011e34"
            d="M475.2 289.9l10.2 6.5h.1l1.7-3s0-.3-.3-.7l-.6-1.7"
          />
          <path
            stroke="#022037"
            d="M475.2 289.9c2.9 1.9 4.1 2.7 10.2 6.4l.1-.1 1.6-2.9-.2-.7a18.1 18.1 0 0 1-.6-1.6"
          />
          <path
            stroke="#022139"
            d="M475.2 289.9c2.8 1.8 4.3 2.8 10.2 6.3l.1-.1 1.5-2.9-.2-.7-.5-1.5"
          />
          <path
            stroke="#02223b"
            d="M475.2 289.8c2.7 1.8 4.5 2.9 10.2 6.3l.1-.2 1.4-2.8-.1-.7a8.2 8.2 0 0 1-.5-1.4"
          />
          <path
            stroke="#02233d"
            d="M475.3 289.8c2.5 1.7 4.6 3 10.1 6.1h.1c0-.3 1.3-2.9 1.3-3l-.1-.5a9.6 9.6 0 0 1-.4-1.5"
          />
          <path
            stroke="#022540"
            d="M475.3 289.8c2.4 1.6 4.7 3 10.2 6v-.1l1.2-2.8v-.6a5 5 0 0 1-.4-1.3"
          />
          <path
            stroke="#022541"
            d="M475.3 289.8c2.3 1.6 5 3 10.2 5.9v-.2l1.1-2.8v-.5a4.8 4.8 0 0 1-.4-1.3"
          />
          <path
            stroke="#022743"
            d="M475.3 289.8a110 110 0 0 0 10.2 5.8v-.2l1-2.8v-.5a4.1 4.1 0 0 1-.3-1.2"
          />
          <path
            stroke="#022847"
            d="M475.3 289.7a92.6 92.6 0 0 0 10.2 5.8v-.2c0-.3 1-2.8 1-2.8v-.5c-.3-.3-.3-.7-.3-1"
          />
          <path
            stroke="#022a49"
            d="M475.3 289.7a80.5 80.5 0 0 0 10.2 5.6.3.3 0 0 0 0-.1c0-.4.8-2.8.8-2.8s.2-.1 0-.4v-1"
          />
          <path
            stroke="#032a4a"
            d="M475.3 289.7a80 80 0 0 0 10.2 5.5v-.2l.7-2.7s.2-.1 0-.4v-1"
          />
          <path
            stroke="#032b4c"
            d="M475.4 289.7a67.8 67.8 0 0 0 10 5.4l.2-.2.5-2.7s.2-.1.1-.4c-.1-.3 0-.5 0-.8"
          />
          <path
            stroke="#032d4f"
            d="M475.4 289.7a62.4 62.4 0 0 0 10 5.3l.2-.2.4-2.8s.3 0 .2-.3c-.2-.3 0-.4 0-.7"
          />
          <path
            stroke="#032e50"
            d="M475.4 289.7c1.7 1 6 3.6 10.1 5.2v-.2l.4-2.7s.3 0 .2-.3c-.1-.3 0-.3.1-.7"
          />
          <path
            stroke="#032f53"
            d="M475.4 289.6a54.3 54.3 0 0 0 10.1 5.1.5.5 0 0 0 0-.2l.3-2.7.2-.2c-.1-.3 0-.3.2-.6"
          />
          <path
            stroke="#033156"
            d="M475.4 289.6c1.5 1 6.3 3.8 10.1 5a.5.5 0 0 0 0-.2l.2-2.7s.4 0 .3-.2c-.2-.3 0-.2.1-.6"
          />
          <path
            stroke="#043258"
            d="M475.4 289.6a45 45 0 0 0 10.1 4.9l.1-.2v-2.7s.4 0 .3-.2c-.1-.2.1-.1.3-.4"
          />
          <path
            stroke="#043359"
            d="M475.4 289.6c1.3.9 6.7 4 10.1 4.7l.1-.2-.1-2.6s.4 0 .3-.1c0-.3.2-.1.3-.4"
          />
          <path
            stroke="#04355c"
            d="M475.4 289.6c1.2.8 6.8 4 10.1 4.6l.1-.2-.3-2.6.5-.1c-.1-.3.2 0 .3-.4"
          />
          <path
            stroke="#04365e"
            d="M475.4 289.6c1.1.7 7 4 10.1 4.5l.1-.2c0-.7-.3-2.6-.4-2.6h.5c0-.3.2 0 .4-.3"
          />
          <path
            stroke="#043760"
            d="M475.4 289.6c1 .6 7.2 4.1 10.1 4.4l.1-.3c0-.6-.4-2.5-.5-2.6 0 0 .6.2.5 0 0-.1.3.2.5-.1"
          />
          <path
            stroke="#043862"
            d="M475.4 289.6c1 .5 7.3 4.2 10.1 4.3l.2-.3a12.5 12.5 0 0 0-.7-2.6s.6.2.5 0c0-.1.4.3.6 0"
          />
          <path
            stroke="#053a65"
            d="M475.5 289.5c.8.5 7.4 4.3 10 4.2l.2-.2c0-.8-.7-2.6-.8-2.6s.6.2.6 0c0 0 .3.4.6 0"
          />
          <path
            stroke="#053b67"
            d="M475.5 289.5c.7.5 7.6 4.4 10 4.1l.2-.3c0-.7-.8-2.4-.9-2.5l.6.1c0-.1.5.3.7 0"
          />
          <path
            stroke="#053c68"
            d="M475.5 289.5c.6.4 7.8 4.4 10 4l.2-.3a6 6 0 0 0-1-2.5l.7.1c0-.1.4.4.7.1"
          />
          <path
            stroke="#053e6c"
            d="M475.5 289.5c.5.3 8 4.5 10 3.9a.5.5 0 0 0 .2-.3c0-.8-1-2.5-1.1-2.5l.7.1s.5.6.8.3"
          />
          <path
            stroke="#053f6e"
            d="M475.5 289.5c.4.2 8 4.6 10 3.8l.2-.4c0-.8-1.1-2.4-1.2-2.5l.7.3s.6.6.9.2"
          />
          <path
            stroke="#053f6f"
            d="M475.5 289.5c.3.2 8.2 4.6 10 3.6l.2-.3c0-.9-1.2-2.4-1.3-2.5l.7.3s.6.6 1 .4"
          />
          <path
            stroke="#064171"
            d="M475.5 289.4c.2.2 8.4 4.8 10 3.6a.7.7 0 0 0 .2-.3c0-1-1.3-2.4-1.4-2.5l.8.3s.6.7 1 .4"
          />
          <path
            stroke="#064374"
            d="M475.5 289.4c.1 0 8.6 4.9 10 3.5l.2-.3c0-1-1.4-2.4-1.6-2.5l1 .3s.6.8 1 .6"
          />
          <path
            stroke="#00209f"
            d="M475.6 289.4s9.7 5.5 10.1 3c0-1-1.6-2.4-1.6-2.4l.9.3s.6 1 1 .6"
          />
          <path
            stroke="#011d33"
            d="M474.4 315.1l-7.5 12.6a5.2 5.2 0 0 1-1.8-2.2c-.6-1.7-.5-1.7-1-3.6l-.4-3.4c-.3-1.2-1.9-4.8-2-6.2"
          />
          <path
            stroke="#011d33"
            d="M461.8 312.3c0 1.4 1.6 5 1.9 6 .2 1.2.2 2.4.5 3.5.4 1.9.3 1.8 1 3.6a5.2 5.2 0 0 0 1.7 2.2l7.5-12.5"
          />
          <path
            stroke="#011e34"
            d="M461.8 312.3c0 1.4 1.6 5 1.8 6 .3 1.2.3 2.3.6 3.4.4 1.8.3 1.8 1 3.6.2.8 1.2 1.8 1.7 2.1l7.5-12.3"
          />
          <path
            stroke="#011e34"
            d="M461.8 312.3c0 1.4 1.6 4.9 1.8 6 .3 1 .3 2.2.6 3.3.4 1.8.3 1.8 1 3.5a5.5 5.5 0 0 0 1.7 2.2l7.5-12.2"
          />
          <path
            stroke="#011f36"
            d="M461.8 312.3c0 1.3 1.6 4.8 1.8 5.9.3 1.1.3 2.3.6 3.3.4 1.8.3 1.8 1 3.5a5.5 5.5 0 0 0 1.7 2.1l7.5-12"
          />
          <path
            stroke="#011f36"
            d="M461.8 312.3c0 1.3 1.6 4.8 1.8 5.9.3 1 .3 2.2.6 3.3.4 1.7.3 1.7 1 3.4.2.8 1.2 1.8 1.7 2.1l7.5-11.9"
          />
          <path
            stroke="#022037"
            d="M461.8 312.3c0 1.3 1.5 4.7 1.8 5.8.3 1 .3 2.2.6 3.3.4 1.7.3 1.7 1 3.4.2.8 1.2 1.7 1.7 2 .2.1 7.4-11.6 7.5-11.7"
          />
          <path
            stroke="#022037"
            d="M461.8 312.3c0 1.3 1.5 4.6 1.8 5.7l.6 3.3c.4 1.7.4 1.7 1 3.3.2.8 1.2 1.8 1.7 2.1.2 0 7.3-11.5 7.5-11.6"
          />
          <path
            stroke="#022139"
            d="M461.8 312.3c0 1.3 1.5 4.6 1.8 5.7.3 1 .3 2.2.6 3.2.4 1.7.4 1.7 1 3.3.3.8 1.2 1.7 1.7 2 .2.1 7.3-11.3 7.5-11.4"
          />
          <path
            stroke="#022139"
            d="M461.8 312.3c0 1.3 1.5 4.6 1.8 5.6.3 1 .3 2.2.6 3.2.4 1.7.4 1.7 1 3.3a5.4 5.4 0 0 0 1.7 2c.3 0 7.3-11.2 7.5-11.3"
          />
          <path
            stroke="#022139"
            d="M461.8 312.3c0 1.3 1.5 4.5 1.8 5.6.3 1 .3 2 .6 3.1.5 1.7.4 1.7 1 3.3.3.8 1.2 1.7 1.7 2 .3 0 7.2-11 7.5-11.2"
          />
          <path
            stroke="#02223b"
            d="M461.8 312.3c0 1.3 1.5 4.4 1.8 5.5.3 1 .3 2.1.6 3 .5 1.8.4 1.8 1 3.3a5 5 0 0 0 1.7 2c.3.1 7.2-10.9 7.5-11"
          />
          <path
            stroke="#02223b"
            d="M461.8 312.3c0 1.2 1.5 4.4 1.8 5.4.3 1 .3 2.2.6 3.1.5 1.7.4 1.7 1 3.2a5.2 5.2 0 0 0 1.7 2c.3.1 7.2-10.8 7.5-10.9"
          />
          <path
            stroke="#02233d"
            d="M461.8 312.3c0 1.2 1.5 4.3 1.8 5.4l.6 3c.5 1.7.4 1.7 1 3.2a5.1 5.1 0 0 0 1.8 2c.3 0 7-10.6 7.4-10.8"
          />
          <path
            stroke="#02233d"
            d="M461.8 312.3c0 1.2 1.4 4.3 1.8 5.3l.6 3 1 3.2a7 7 0 0 0 1.8 2c.3 0 7-10.6 7.4-10.7"
          />
          <path
            stroke="#02233e"
            d="M461.8 312.3c0 1.2 1.4 4.3 1.8 5.3l.6 3 1 3a6 6 0 0 0 1.8 2c.3.1 7-10.3 7.4-10.5"
          />
          <path
            stroke="#02233e"
            d="M461.8 312.3c0 1.1 1.4 4.2 1.8 5.2l.6 3 1 3a5 5 0 0 0 1.8 2c.4 0 7-10.3 7.4-10.4"
          />
          <path
            stroke="#022540"
            d="M461.8 312.2c0 1.2 1.4 4.2 1.8 5.3l.6 2.9 1 3a5.2 5.2 0 0 0 1.8 2c.4 0 7-10.1 7.4-10.3"
          />
          <path
            stroke="#022540"
            d="M461.8 312.2c0 1.2 1.4 4.2 1.8 5.2l.6 2.9 1 3c.4.7 1.3 1.5 1.8 1.8.4.2 7-9.8 7.4-10"
          />
          <path
            stroke="#022540"
            d="M461.8 312.2c0 1.2 1.4 4.1 1.8 5.1l.7 2.9c.4 1.5.4 1.6 1 3a5 5 0 0 0 1.7 1.8c.4.1 7-9.7 7.4-9.9"
          />
          <path
            stroke="#022541"
            d="M461.8 312.2c0 1.2 1.4 4 1.8 5l.7 3 1 2.9a5.2 5.2 0 0 0 1.7 1.8c.4.1 6.9-9.6 7.4-9.8"
          />
          <path
            stroke="#022541"
            d="M461.8 312.2c0 1.1 1.4 4 1.8 5l.7 2.8 1 3c.3.6 1.2 1.5 1.7 1.8.5 0 6.9-9.5 7.4-9.7"
          />
          <path
            stroke="#022743"
            d="M461.8 312.2c0 1.1 1.4 4 1.8 5l.7 2.7c.4 1.5.5 1.5 1 2.9a6 6 0 0 0 1.7 1.8c.5.1 6.8-9.3 7.4-9.5"
          />
          <path
            stroke="#022743"
            d="M461.8 312.2c0 1.1 1.4 4 1.8 5l.7 2.6 1 3a5 5 0 0 0 1.7 1.6c.5.2 6.8-9 7.4-9.3"
          />
          <path
            stroke="#022845"
            d="M461.8 312.2c0 1.1 1.4 3.9 1.8 4.8l.7 2.8 1 2.8a4.9 4.9 0 0 0 1.7 1.7c.6.2 6.8-9 7.4-9.2"
          />
          <path
            stroke="#022845"
            d="M461.8 312.2c0 1.1 1.4 3.8 1.8 4.8l.7 2.7c.4 1.4.5 1.4 1 2.7a5.3 5.3 0 0 0 1.7 1.8c.6.2 6.7-8.9 7.4-9"
          />
          <path
            stroke="#022847"
            d="M461.8 312.2c0 1 1.3 3.7 1.8 4.7l.7 2.7 1 2.7a4.8 4.8 0 0 0 1.7 1.7c.6.2 6.7-8.7 7.4-8.9"
          />
          <path
            stroke="#022847"
            d="M461.8 312.2c0 1 1.3 3.7 1.8 4.6l.7 2.7 1.1 2.7a5 5 0 0 0 1.6 1.7c.7.2 6.7-8.6 7.4-8.8"
          />
          <path
            stroke="#022847"
            d="M461.8 312.2c0 1 1.3 3.7 1.8 4.6l.7 2.6 1.1 2.7a5 5 0 0 0 1.6 1.7c.7.1 6.7-8.4 7.4-8.7"
          />
          <path
            stroke="#022a49"
            d="M461.8 312.2c0 1 1.3 3.6 1.8 4.6l.7 2.5 1.1 2.7c.4.6 1.1 1.3 1.7 1.6.6.2 6.6-8.2 7.3-8.5"
          />
          <path
            stroke="#022a49"
            d="M461.8 312.2c0 1 1.3 3.5 1.8 4.5l.7 2.5 1.1 2.6c.4.6 1.1 1.4 1.7 1.6.7.3 6.5-8 7.3-8.3"
          />
          <path
            stroke="#032a4a"
            d="M461.8 312.2c0 1 1.3 3.5 1.8 4.4l.7 2.5c.5 1.3.5 1.4 1.2 2.6.3.6 1 1.4 1.6 1.6.7.2 6.5-8 7.3-8.2"
          />
          <path
            stroke="#032a4a"
            d="M461.8 312.2c0 1 1.3 3.4 1.7 4.4l.8 2.4 1.2 2.6a5 5 0 0 0 1.6 1.6c.7.2 6.5-7.8 7.3-8.1"
          />
          <path
            stroke="#032b4c"
            d="M461.8 312.2c0 1 1.2 3.4 1.7 4.3.4.8.5 1.7.8 2.4l1.2 2.6c.3.6 1 1.2 1.6 1.5.7.3 6.4-7.6 7.3-8"
          />
          <path
            stroke="#032b4c"
            d="M461.8 312.2c0 1 1.2 3.3 1.7 4.3.4.7.5 1.6.8 2.3l1.2 2.6c.3.5 1 1.2 1.6 1.5.8.2 6.4-7.5 7.3-7.8"
          />
          <path
            stroke="#032c4d"
            d="M461.8 312.2c0 1 1.2 3.3 1.7 4.2.4.8.5 1.6.8 2.4l1.2 2.4c.3.6 1 1.3 1.6 1.6.8.2 6.4-7.4 7.3-7.7"
          />
          <path
            stroke="#032c4d"
            d="M461.8 312.2c0 .9 1.2 3.2 1.7 4.1l.9 2.4c.4 1.2.5 1.3 1.1 2.4a5.2 5.2 0 0 0 1.6 1.5c.8.3 6.3-7.2 7.3-7.5"
          />
          <path
            stroke="#032c4d"
            d="M461.8 312.2a13 13 0 0 0 1.7 4l.9 2.4c.4 1.2.5 1.2 1.1 2.4a4.7 4.7 0 0 0 1.6 1.4c.9.4 6.3-7 7.3-7.3"
          />
          <path
            stroke="#032d4f"
            d="M461.8 312.2c0 .9 1.2 3.1 1.7 4 .4.8.5 1.6.9 2.3.4 1.2.5 1.3 1.1 2.3.3.6 1 1.3 1.6 1.5.9.3 6.3-6.8 7.3-7.2"
          />
          <path
            stroke="#032d4f"
            d="M461.8 312.2c0 .8 1.2 3 1.7 4 .4.7.5 1.5.9 2.2.4 1.2.6 1.2 1.1 2.4a5 5 0 0 0 1.6 1.4c1 .3 6.3-6.7 7.3-7.1"
          />
          <path
            stroke="#032e50"
            d="M461.8 312.2c0 .8 1.2 3 1.7 4 .4.6.5 1.4.9 2.1.4 1.2.6 1.2 1.1 2.3a5.4 5.4 0 0 0 1.6 1.5c1 .2 6.3-6.6 7.3-7"
          />
          <path
            stroke="#032e50"
            d="M461.8 312.2c0 .8 1.1 3 1.7 3.8.4.8.5 1.5.9 2.2.4 1.2.6 1.3 1.1 2.3a4.8 4.8 0 0 0 1.6 1.4c1 .3 6.2-6.4 7.3-6.8"
          />
          <path
            stroke="#032f53"
            d="M461.8 312.2c0 .8 1.1 3 1.7 3.8.4.7.5 1.5.9 2.1.4 1.1.6 1.2 1.2 2.3a5 5 0 0 0 1.5 1.4c1 .3 6.2-6.3 7.3-6.7"
          />
          <path
            stroke="#032f53"
            d="M461.8 312.2a11 11 0 0 0 1.7 3.7c.4.7.5 1.5.9 2.2l1.2 2.1a5 5 0 0 0 1.5 1.4c1 .3 6.2-6 7.3-6.5"
          />
          <path
            stroke="#033054"
            d="M461.8 312.2a12 12 0 0 0 1.7 3.7c.4.6.5 1.4.9 2l1.2 2.2a5.1 5.1 0 0 0 1.6 1.4c1 .3 6-6 7.2-6.4"
          />
          <path
            stroke="#033054"
            d="M461.8 312.2c0 .7 1 2.7 1.7 3.6.4.7.5 1.4 1 2l1 2.2a4.5 4.5 0 0 0 1.7 1.3c1 .4 6-5.8 7.2-6.2"
          />
          <path
            stroke="#033054"
            d="M461.8 312.2c0 .7 1 2.7 1.7 3.6l1 2c.4 1 .6 1.1 1.1 2a5.4 5.4 0 0 0 1.6 1.4c1 .3 6-5.7 7.2-6.1"
          />
          <path
            stroke="#033156"
            d="M461.8 312.2c0 .7 1 2.7 1.7 3.5l1 2c.3 1 .6 1.1 1.1 2a5.4 5.4 0 0 0 1.5 1.4c1.1.3 6-5.6 7.3-6"
          />
          <path
            stroke="#033156"
            d="M461.8 312.2c0 .7 1 2.6 1.7 3.4l1 2c.3 1 .6 1.1 1.1 2a5.4 5.4 0 0 0 1.5 1.3c1.2.3 6-5.3 7.3-5.8"
          />
          <path
            stroke="#043258"
            d="M461.8 312.2c0 .7 1 2.6 1.7 3.4l1 1.9c.3 1 .6 1 1.2 2 .3.5 1 1 1.4 1.3 1.2.3 6-5.2 7.3-5.7"
          />
          <path
            stroke="#043258"
            d="M461.8 312.2a8 8 0 0 0 1.7 3.3l1 2c.3.9.6 1 1.2 2 .3.4 1 1 1.4 1.1 1.2.4 6-5 7.3-5.5"
          />
          <path
            stroke="#043359"
            d="M461.8 312.2c0 .6 1 2.4 1.7 3.3l1 1.8c.4 1 .6 1.1 1.2 2 .3.5 1 1 1.4 1.2 1.3.3 6-5 7.3-5.4"
          />
          <path
            stroke="#043359"
            d="M461.8 312.2c0 .6 1 2.4 1.7 3.2l1 1.9c.4.8.6 1 1.2 1.8.4.5 1 1 1.5 1.2 1.2.4 5.8-4.7 7.2-5.2"
          />
          <path
            stroke="#04345b"
            d="M461.8 312.2c0 .6 1 2.4 1.7 3.1l1 1.9c.4.9.7 1 1.2 1.8.4.5 1 1 1.5 1.2 1.2.4 5.8-4.6 7.2-5.1"
          />
          <path
            stroke="#04345b"
            d="M461.8 312.2c0 .6 1 2.3 1.7 3l1 1.9c.4.8.7 1 1.2 1.8.4.5 1 1 1.5 1.2 1.3.4 5.8-4.5 7.2-5"
          />
          <path
            stroke="#04345b"
            d="M461.8 312.2c0 .6 1 2.2 1.7 3l1 1.8c.4.9.7 1 1.2 1.8.4.4 1 1 1.5 1.1 1.3.4 5.8-4.3 7.2-4.8"
          />
          <path
            stroke="#04355c"
            d="M461.8 312.2c0 .5 1 2.2 1.7 3l1 1.7c.4.8.7 1 1.2 1.8.4.4 1 .9 1.5 1 1.3.5 5.7-4.1 7.2-4.6"
          />
          <path
            stroke="#04355c"
            d="M461.8 312.2c0 .5 1 2.1 1.7 3l1 1.6c.4.8.7 1 1.3 1.7.3.5 1 1 1.4 1.1 1.3.5 5.7-4 7.2-4.5"
          />
          <path
            stroke="#04365e"
            d="M461.8 312.2c0 .5 1 2.1 1.7 2.9l1 1.6c.4.9.7 1 1.3 1.7.3.5 1 .9 1.4 1.1 1.4.4 5.7-3.9 7.2-4.4"
          />
          <path
            stroke="#04365e"
            d="M461.8 312.2c0 .5 1 2 1.7 2.8l1 1.6c.4.8.7 1 1.3 1.7.3.4 1 .9 1.4 1 1.4.5 5.6-3.7 7.2-4.2"
          />
          <path
            stroke="#043760"
            d="M461.8 312.2c0 .5 1 2 1.7 2.8l1 1.5c.4.8.7 1 1.3 1.7.3.4 1 .8 1.4 1 1.4.4 5.6-3.6 7.2-4.1"
          />
          <path
            stroke="#043760"
            d="M461.8 312.2c0 .5 1 2 1.7 2.7l1 1.6c.4.7.7.8 1.3 1.6.3.4 1 .8 1.4 1 1.5.4 5.6-3.5 7.2-4"
          />
          <path
            stroke="#043862"
            d="M461.8 312.2c0 .5 1 1.9 1.7 2.6l1 1.6c.4.7.7.9 1.3 1.5.3.4 1 .8 1.4 1 1.5.5 5.5-3.3 7.2-3.9"
          />
          <path
            stroke="#043862"
            d="M461.8 312.2c0 .4 1 1.8 1.7 2.6l1 1.5c.4.7.7.9 1.3 1.5l1.4 1c1.5.4 5.5-3.2 7.2-3.8"
          />
          <path
            stroke="#043862"
            d="M461.8 312.2c0 .4.9 1.8 1.7 2.5l1 1.5c.4.7.8.8 1.3 1.5l1.4 1c1.5.4 5.5-3 7.2-3.7"
          />
          <path
            stroke="#043963"
            d="M461.8 312.2c0 .4.9 1.7 1.7 2.4l1 1.5c.4.7.8.8 1.3 1.5l1.4.9c1.5.5 5.5-2.8 7.2-3.5"
          />
          <path
            stroke="#043963"
            d="M461.8 312.2c0 .4.9 1.7 1.7 2.4l1 1.4c.4.7.8.8 1.3 1.5l1.4.9c1.6.5 5.5-2.7 7.2-3.4"
          />
          <path
            stroke="#053a65"
            d="M461.8 312.2c0 .4.9 1.6 1.7 2.3l1 1.4 1.3 1.4 1.4 1c1.6.4 5.4-2.6 7.2-3.3"
          />
          <path
            stroke="#053a65"
            d="M461.8 312.2c0 .3.8 1.6 1.7 2.3l1 1.3c.5.7.8.8 1.4 1.4.3.4.9.7 1.4.9 1.6.5 5.3-2.4 7.1-3"
          />
          <path
            stroke="#053b67"
            d="M461.8 312.2c0 .3.8 1.5 1.7 2.2l1 1.3 1.4 1.4c.4.3.9.7 1.4.8 1.6.5 5.3-2.2 7.1-2.9"
          />
          <path
            stroke="#053b67"
            d="M461.8 312.2c0 .3.8 1.5 1.7 2.1.3.5.6 1 1 1.3.5.7.8.8 1.4 1.4l1.4.8c1.6.5 5.2-2 7.1-2.8"
          />
          <path
            stroke="#053c68"
            d="M461.8 312.2c0 .3.8 1.4 1.7 2.1l1 1.3 1.4 1.3c.4.3.9.6 1.4.7 1.7.6 5.2-1.9 7.1-2.6"
          />
          <path
            stroke="#053c68"
            d="M461.8 312.2c0 .3.8 1.4 1.7 2l1 1.3 1.4 1.2 1.4.8c1.7.5 5.2-1.8 7.1-2.5"
          />
          <path
            stroke="#053c68"
            d="M461.8 312.2a6 6 0 0 0 1.7 2l1 1.2 1.4 1.2a6 6 0 0 0 1.4.8c1.7.5 5.1-1.7 7.1-2.4"
          />
          <path
            stroke="#053d6a"
            d="M461.8 312.2c0 .2.8 1.2 1.7 2l1 1 1.4 1.3a6 6 0 0 0 1.4.8c1.8.5 5.1-1.5 7.1-2.3"
          />
          <path
            stroke="#053d6a"
            d="M461.8 312.2a6 6 0 0 0 1.7 1.9l1 1.1 1.4 1.1 1.4.8c1.8.5 5.1-1.3 7.1-2"
          />
          <path
            stroke="#053e6c"
            d="M461.8 312.2c0 .2.7 1.1 1.7 1.8l1 1.1c.5.5 1 .7 1.5 1.1l1.3.8c1.8.5 5.1-1.2 7.1-2"
          />
          <path
            stroke="#053e6c"
            d="M461.8 312.2c0 .2.7 1.1 1.6 1.8l1.1 1c.5.5 1 .7 1.5 1.1l1.3.7c1.8.6 5-1 7.1-1.8"
          />
          <path
            stroke="#053f6e"
            d="M461.8 312.2c0 .1.7 1 1.6 1.7l1.1 1c.5.5 1 .7 1.5 1 .4.4.8.6 1.3.8 1.8.6 5-1 7.1-1.7"
          />
          <path
            stroke="#053f6e"
            d="M461.8 312.2c0 .1.7 1 1.6 1.6a14.2 14.2 0 0 0 1.2 1c.4.5.9.7 1.4 1 .4.3.9.6 1.3.7 1.9.6 5-.7 7.1-1.5"
          />
          <path
            stroke="#053f6f"
            d="M461.8 312.2c0 .1.7 1 1.6 1.6l1.2 1 1.4 1 1.3.6c2 .5 5-.6 7.1-1.4"
          />
          <path
            stroke="#053f6f"
            d="M461.8 312.2c0 .1.7.9 1.6 1.5l1.2 1 1.4 1 1.3.6c2 .5 5-.5 7.1-1.3"
          />
          <path
            stroke="#053f6f"
            d="M461.8 312.2c0 .1.7.8 1.6 1.5l1.2.9 1.4 1 1.3.5c2 .6 5-.3 7.1-1"
          />
          <path
            stroke="#064171"
            d="M461.8 312.2s.7.8 1.6 1.4l1.2.9 1.5.9 1.2.6c2 .6 4.9-.2 7.1-1"
          />
          <path
            stroke="#064171"
            d="M461.8 312.2l1.6 1.4 1.2.8 1.5.9 1.3.5c2 .6 4.8 0 7-.8"
          />
          <path
            stroke="#064172"
            d="M461.8 312.2s.7.7 1.6 1.3l1.2.8 1.5.8 1.3.6c2 .6 4.7.2 7-.7"
          />
          <path
            stroke="#064172"
            d="M461.8 312.1c0 .1.7.7 1.6 1.3l1.2.8 1.5.8 1.3.6c2 .6 4.7.3 7-.6"
          />
          <path
            stroke="#064374"
            d="M461.8 312.1c0 .1.6.7 1.6 1.3l1.2.7a12.7 12.7 0 0 0 2.8 1.3c2 .6 4.7.5 7-.4"
          />
          <path
            stroke="#064374"
            d="M461.8 312.1s.6.6 1.6 1.2l1.2.7a15.7 15.7 0 0 0 2.8 1.3c2 .6 4.7.6 7-.3"
          />
          <path
            stroke="#00209f"
            d="M461.8 312.1l1.6 1.2 1.2.7 1.5.6a12 12 0 0 0 8.3.4m-12.6-2.9s6.5 5.1 12.6 3"
          />
          <path
            stroke="#022743"
            d="M461.6 292.2s1.2 8 1.7 9.3c.4 1 3 5.6 6.9 6.7"
          />
          <path
            stroke="#022a49"
            d="M461.6 292.2s1.3 8 1.8 9.2c.5 1 2.8 5.4 6.8 6.8"
          />
          <path
            stroke="#032b4c"
            d="M461.6 292.1s1.4 8 1.9 9.2a14 14 0 0 0 6.7 6.9"
          />
          <path
            stroke="#032e50"
            d="M461.6 292.1s1.5 8 2 9.1c.5 1 2.5 5 6.6 7"
          />
          <path
            stroke="#033054"
            d="M461.6 292.1s1.6 7.9 2 9a15.2 15.2 0 0 0 6.7 7"
          />
          <path
            stroke="#043359"
            d="M461.6 292.1s1.6 7.8 2.2 9a15.8 15.8 0 0 0 6.5 7"
          />
          <path
            stroke="#04355c"
            d="M461.6 292s1.7 7.8 2.3 9c.5 1.1 2 4.3 6.4 7"
          />
          <path
            stroke="#043760"
            d="M461.7 292s1.7 7.8 2.3 9c.5 1 1.9 4 6.3 7"
          />
          <path
            stroke="#053a65"
            d="M461.7 292s1.8 7.7 2.4 8.9c.5 1 1.7 3.8 6.2 7.1"
          />
          <path
            stroke="#053c68"
            d="M461.7 292s1.9 7.7 2.5 8.8c.6 1.1 1.6 3.5 6.1 7.2"
          />
          <path
            stroke="#053f6e"
            d="M461.7 292s2 7.6 2.6 8.8c.5 1 1.4 3.2 6 7.2"
          />
          <path
            stroke="#064172"
            d="M461.8 292s2 7.5 2.6 8.7c.6 1.1 1.3 3 6 7.2"
          />
          <path
            stroke="#00209f"
            d="M461.8 292s2.1 7.5 2.7 8.6c.6 1.1 1.1 2.8 5.9 7.3"
          />
          <path stroke="#022743" d="M462 287.2s1.1 11.4 9.3 14.6" />
          <path
            stroke="#022a49"
            d="M462 287.2c.1 0 .5 3.7 2.2 7.2 1.3 2.8 3.5 5.9 7 7.4"
          />
          <path
            stroke="#032b4c"
            d="M462.1 287.2s.5 3.8 2.2 7.2a15 15 0 0 0 7 7.4"
          />
          <path
            stroke="#032e50"
            d="M462.1 287.2s.7 3.9 2.3 7.1c1.1 2.3 3.3 5.7 6.9 7.4"
          />
          <path
            stroke="#033054"
            d="M462.2 287.2s.7 4 2.3 7c1 2.2 3.2 5.7 6.8 7.5"
          />
          <path
            stroke="#043359"
            d="M462.2 287.2c0 .1.8 4 2.4 7 1 2 3.1 5.6 6.7 7.5"
          />
          <path
            stroke="#04355c"
            d="M462.2 287.2c0 .1 1 4.2 2.5 7a18 18 0 0 0 6.6 7.4"
          />
          <path
            stroke="#043760"
            d="M462.2 287.1c0 .3 1 4.4 2.6 7 .8 1.5 3 5.4 6.5 7.5"
          />
          <path
            stroke="#053a65"
            d="M462.2 287.1a30 30 0 0 0 2.6 6.9c.8 1.4 3 5.4 6.5 7.5"
          />
          <path
            stroke="#053c68"
            d="M462.3 287.1c0 .3 1.2 4.5 2.6 6.8.7 1.3 2.8 5.4 6.4 7.7"
          />
          <path
            stroke="#053f6e"
            d="M462.3 287.1a30 30 0 0 0 2.8 6.8c.6 1 2.6 5.2 6.2 7.6"
          />
          <path
            stroke="#064172"
            d="M462.3 287.1a31 31 0 0 0 2.9 6.7c.5.8 2.5 5.2 6 7.7"
          />
          <path
            stroke="#00209f"
            d="M462.3 287.1c0 .3 1.6 4.9 3 6.6.4.7 2.4 5.2 6 7.8"
          />
          <path stroke="#022743" d="M462.2 284s2.4 9.2 9 11.5" />
          <path
            stroke="#022847"
            d="M462.2 284s.9 3.3 3 6.4c1.5 2.2 3.6 4.2 6 5"
          />
          <path
            stroke="#032a4a"
            d="M462.2 284s1 3.2 3 6.4c1.6 2.1 3.7 4.3 6 5"
          />
          <path
            stroke="#032c4d"
            d="M462.2 284s1 3.1 3.2 6.3c1.5 2.2 3.7 4.4 5.8 5.1"
          />
          <path
            stroke="#032f53"
            d="M462.2 283.9s1 3.1 3.3 6.3a15 15 0 0 0 5.7 5.2"
          />
          <path
            stroke="#033156"
            d="M462.2 283.9s1 3 3.3 6.2c1.7 2.3 4 4.7 5.7 5.3"
          />
          <path
            stroke="#043359"
            d="M462.2 283.8s1 3 3.4 6.2a17 17 0 0 0 5.6 5.4"
          />
          <path stroke="#04355c" d="M462.2 283.8a27.1 27.1 0 0 0 9 11.6" />
          <path
            stroke="#043760"
            d="M462.3 283.8s1 2.9 3.5 6.1a21 21 0 0 0 5.4 5.4"
          />
          <path
            stroke="#043963"
            d="M462.3 283.8s1 2.8 3.5 6a23 23 0 0 0 5.4 5.5"
          />
          <path
            stroke="#053b67"
            d="M462.3 283.7s1.1 2.8 3.6 6a28 28 0 0 0 5.3 5.6"
          />
          <path
            stroke="#053e6c"
            d="M462.3 283.7s1.2 2.7 3.7 6a39 39 0 0 0 5.2 5.6"
          />
          <path
            stroke="#053f6f"
            d="M462.3 283.7s1.2 2.7 3.8 5.9a44 44 0 0 0 5.1 5.7"
          />
          <path
            stroke="#064172"
            d="M462.3 283.6s1.3 2.7 3.9 6c2 2.5 4.9 5.6 5 5.7"
          />
          <path
            stroke="#00209f"
            d="M462.3 283.6s1.3 2.6 3.9 5.8c2.1 2.7 5 5.9 5 5.9m8.7 1.3l4.6.8m-4.1 2.6l4-1.7"
          />
          <path stroke="#064171" d="M479.9 296.7l4.5.7" />
          <path stroke="#053e6c" d="M479.9 296.9l4.6.5" />
          <path stroke="#053b67" d="M479.9 297l4.6.4" />
          <path stroke="#043862" d="M479.9 297.2l4.7.3" />
          <path stroke="#04355c" d="M479.9 297.4h4.7" />
          <path stroke="#043258" d="M480 297.6h4.6" />
          <path stroke="#032f53" d="M480 297.7l4.7-.2" />
          <path stroke="#032c4d" d="M480 297.9l4.7-.3" />
          <path stroke="#022a49" d="M480 298l4.8-.5" />
          <path stroke="#064171" d="M480.3 299.8l4.2-1.6" />
          <path stroke="#053e6c" d="M480.3 299.6l4.3-1.5" />
          <path stroke="#053b67" d="M480.3 299.5l4.3-1.4" />
          <path stroke="#043862" d="M480.3 299.3l4.3-1.3" />
          <path stroke="#04355c" d="M480.2 299.1l4.5-1.2" />
          <path stroke="#043258" d="M480.2 299l4.5-1.2" />
          <path stroke="#032f53" d="M480.2 298.7l4.6-.9" />
          <path stroke="#032c4d" d="M480.1 298.6l4.7-.9" />
          <path stroke="#022a49" d="M480.1 298.4l4.7-.7" />
          <path stroke="#022743" d="M480 298.2l4.9-.6" />
          <path stroke="#032b4c" d="M484.2 331.6l-2.6.2-9.9-.2" />
          <path stroke="#032e50" d="M484.3 331.6l-2.7.3-9.8-.2" />
          <path stroke="#033054" d="M484.3 331.6l-2.8.4c-.5.1-9.6-.3-9.6-.3" />
          <path stroke="#043359" d="M484.3 331.7l-2.8.5c-.7.1-9.6-.5-9.6-.5" />
          <path stroke="#04355c" d="M484.3 331.7l-3 .6c-.7.2-9.3-.5-9.3-.5" />
          <path stroke="#043760" d="M484.3 331.7l-3 .7c-.8.3-9.2-.6-9.2-.6" />
          <path stroke="#053a65" d="M484.4 331.8l-3.1.8c-1 .2-9.1-.7-9.1-.7" />
          <path stroke="#053c68" d="M484.4 331.8l-3.1 1c-1.2.2-9-.8-9-.8" />
          <path stroke="#053f6e" d="M484.4 331.9l-3.2 1c-1.2.3-8.9-.9-8.9-.9" />
          <path
            stroke="#064172"
            d="M484.4 332s-1.8.7-3.2 1c-1.4.3-8.8-1-8.8-1"
          />
          <path
            stroke="#00209f"
            d="M472.5 332s7.1 1.4 8.6 1.1c1.5-.3 3.3-1.1 3.3-1.1"
          />
          <path stroke="#022a49" d="M486 337l4.8.7 2.7-.2 2.2-.5" />
          <path stroke="#032d4f" d="M485.8 337s4.7.7 5 .6l2.7-.1 2-.5" />
          <path stroke="#033054" d="M485.5 336.9s4.9.8 5.3.7l2.6-.2 2-.4" />
          <path
            stroke="#043359"
            d="M485.3 336.7s4.9.9 5.6.8a56.9 56.9 0 0 1 2.5-.2l1.7-.3"
          />
          <path stroke="#043760" d="M485 336.6s5 1 5.9.8l2.5-.2 1.5-.3" />
          <path stroke="#053a65" d="M484.8 336.5s5.1 1 6.1.8l2.4-.2 1.4-.2" />
          <path
            stroke="#053d6a"
            d="M484.5 336.4s5.3 1 6.4.9c.7-.2 2-.3 2.4-.3a24.4 24.4 0 0 0 1.2-.2"
          />
          <path
            stroke="#064171"
            d="M484.2 336.3s5.4 1.1 6.8.9c.7-.2 1.7-.3 2.2-.3h1.1"
          />
          <path stroke="#022743" d="M486.3 337.2l4.4.6 2.9-.1 2.4-.6" />
          <path stroke="#00209f" d="M484 336.2s5.5 1.2 7 .9c1.5-.3 3-.3 3-.3" />
          <g>
            <path stroke="#00209f" d="M505.8 336.8l4.3-1.6c2.6-1 3-3.6 3-3.6" />
            <path
              stroke="#00209f"
              d="M505.5 336l3.1-1.3c3.8-1.4 3.4-3.2 3.4-3.2"
            />
            <path
              stroke="#053e6c"
              d="M505.2 336.1l3.4-1.3 1.8-.8c.5-.3 1.2-1 1.3-1.2.4-.5.4-1.3.4-1.3"
            />
            <path
              stroke="#043862"
              d="M505 336.3l3.6-1.4 1.8-.7 1.4-1.2c.3-.5.4-1.5.4-1.5"
            />
            <path
              stroke="#043258"
              d="M504.7 336.5l4-1.5 1.6-.7a6 6 0 0 0 1.5-1.2c.2-.3.5-1.6.5-1.6"
            />
            <path
              stroke="#032c4d"
              d="M504.4 336.7l4.2-1.5 1.7-.7 1.6-1.3.6-1.6"
            />
            <path
              stroke="#053e6c"
              d="M505.5 336.9l4.6-1.8c.8-.3 1.7-1 2-1.5.6-.9.9-2 .9-2"
            />
            <path
              stroke="#043862"
              d="M505.1 336.9l5-2c.6-.1 1.7-1 2-1.4.4-.6.7-2 .7-2"
            />
            <path
              stroke="#043258"
              d="M504.8 336.9l5.4-2a8.1 8.1 0 0 0 1.9-1.4c.3-.5.6-2 .6-2"
            />
            <path stroke="#032c4d" d="M504.5 336.9l5.7-2.1 1.8-1.4.7-1.8" />
            <path stroke="#022743" d="M504.2 336.9l6-2.3 1.7-1.2.6-1.8" />
          </g>
          <g>
            <path stroke="#032b4c" d="M511.3 331.6l-2.8.2-10.3-.2" />
            <path stroke="#032e50" d="M511.3 331.6l-2.8.3-10.2-.2" />
            <path stroke="#033054" d="M511.3 331.6l-2.9.4c-.5.1-10-.3-10-.3" />
            <path stroke="#043359" d="M511.3 331.7l-3 .5c-.6.1-9.8-.5-9.8-.5" />
            <path stroke="#04355c" d="M511.4 331.7l-3 .6c-.9.2-9.8-.5-9.8-.5" />
            <path
              stroke="#043760"
              d="M511.4 331.7l-3.1.7c-1 .3-9.7-.6-9.7-.6"
            />
            <path
              stroke="#053a65"
              d="M511.4 331.8l-3.2.8c-1 .2-9.5-.7-9.5-.7"
            />
            <path
              stroke="#053c68"
              d="M511.4 331.8l-3.3 1c-1.1.2-9.3-.8-9.3-.8"
            />
            <path
              stroke="#053f6e"
              d="M511.4 331.9l-3.3 1c-1.3.2-9.2-.9-9.2-.9"
            />
            <path
              stroke="#064172"
              d="M511.4 332s-1.9.7-3.3 1c-1.5.3-9.2-1-9.2-1"
            />
            <path
              stroke="#00209f"
              d="M499 332s7.5 1.4 9 1.1c1.6-.3 3.5-1.1 3.5-1.1"
            />
          </g>
        </g>
        <path
          fill="none"
          stroke="#000"
          strokeMiterlimit={2.6}
          strokeWidth={0.2}
          d="M475 290a34 34 0 0 1-.2-3.3c0-5.2-.7-9-.1-14.5.4-4.2 1.5-9.8 1.3-14.4-.1-1.3.1-2.6.2-3.9l21 23.5M467 327.7a5.2 5.2 0 0 1-1.9-2.2c-.6-1.7-.4-1.7-.9-3.6-.2-1.1-.2-2.3-.5-3.4-.2-1.2-1.8-4.8-1.9-6.2-.1-4.8-1.7-8-1.3-13.1.3-4 1.2-9.5.7-13.6l.1-3.6 23.6 15.6m28.5 33.9c.2.5-.3 1.5-.5 1.9l-.5.6c-.2.6-.2.4-.7.9l-.8.6c-.4.3-.7.6-1.1.7-1.8.3-2.5.7-4.2 1.1-1.6.5-.8.4-2 .7l-2.4.7-2.4.6c-2.9.7-5.7.5-8.6.3-1.1 0-4-.7-5-1.4-1.8-1.2-5.7-1.7-7.4-2.9-.3-.2-1.4-.7-1.6-1-1.7-1.3-3-1.7-4.8-2.8"
        />
        <g stroke="#000" strokeMiterlimit={2.6} strokeWidth={0.1}>
          <path
            fill="#fc0"
            fillRule="evenodd"
            d="M484.9 297.6l.6-.8-24-15.6-.4.6zm-23.7-16.7c-.2-1 0-2.1.7-2.3 0 0 .5-.1.8 0 .4 0 .5 0 .7.4.3.8-.7 1.3-1.4 1.6-.2 0-.6.1-.7.3l-.1.4.3-.3 1.7-.7c.6-.3.7-1.4.3-1.7-.4-.4-1.8-.3-2 0-.7.7-.8 1.7-.6 2.7 0-.2.3-.1.3-.4z"
          />
          <path
            fill="#fc0"
            fillRule="evenodd"
            d="M460.8 281.3c-1 0-2.1.4-2.2 1v.9c0 .4.2.5.6.6.8.2 1.2-.8 1.4-1.6 0-.1 0-.6.2-.7l.4-.2-.3.3-.5 1.9c-.2.6-1.3.8-1.6.4-.5-.3-.6-1.7-.3-2 .7-.7 1.7-1 2.7-1-.2.1-.2.5-.4.4z"
          />
          <path
            fill="#fc0"
            fillRule="evenodd"
            d="M460.6 281c-.3 0-.3.4-.1.6 0 .2.5.3.6.2.4-.2.6-.6.4-1-.2-.3-.6 0-.9.1z"
          />
          <path
            fill="#fc0"
            fillRule="evenodd"
            d="M455.6 277.8s2.5 1 4.5 1c0 0 .1 1.8.5 2.3 0 0-1.8-.3-2.6 0 0 0-1.1-2.4-2.4-3.3z"
          />
          <path
            fill="none"
            d="M457.6 279s1 .4 1.8.4c0 0 0 .8.2 1 0 0-.7-.2-1 0 0 0-.4-1-1-1.4z"
          />
          <path
            fill="#fc0"
            fillRule="evenodd"
            d="M460.8 282.9l.6-1.1c0-.2 0 1 .4 1 .5.8.7 2.3.7 2.7-.7.2-1.3.6-2.3.2-.3-.3 0-1 0-1.4.2-.3.3-1 .6-1.4z"
          />
          <path
            fill="none"
            d="M461.3 282.2v.6c0-.2.3.2.3.3.3.7.5 1.1.6 2.4m-.7-2.2c.2 1 .4 1 .4 2.4v-.1m-.5-1.4l.2 1.4-.3.2"
          />
          <path
            fill="#fc0"
            fillRule="evenodd"
            d="M497.1 277.4l.7-.6-21.4-23.7-.4.5z"
          />
          <path
            fill="#fc0"
            fillRule="evenodd"
            d="M476.6 253c0-.9.6-2 1.2-2l.9.1c.3.1.4.3.5.6.1.9-1 1.2-1.7 1.3l-.8.1-.2.3.3-.1c.6-.2 1.2-.2 2-.3.5-.1.9-1.3.6-1.6-.3-.5-1.6-.8-2-.5-.8.5-1 1.5-1.2 2.5 0-.2.4-.1.4-.3z"
          />
          <path
            fill="#fc0"
            fillRule="evenodd"
            d="M476.1 253.4c-.9-.3-2.1-.2-2.3.5l-.2.8c0 .4 0 .5.4.7.7.4 1.4-.5 1.7-1.2 0-.2.2-.6.4-.7h.4l-.3.2-1 1.7c-.2.5-1.4.5-1.7 0-.3-.4 0-1.7.3-2 .8-.6 1.8-.5 2.8-.2-.2 0-.3.3-.5.2z"
          />
          <path
            fill="#fc0"
            fillRule="evenodd"
            d="M476 253c-.3 0-.3.4-.3.6 0 .2.4.4.6.3.4-.1.7-.4.6-.8-.1-.4-.6-.2-.9-.1z"
          />
          <path
            fill="#fc0"
            fillRule="evenodd"
            d="M472 248.7s2 1.6 4 2c0 0-.3 1.9 0 2.4 0 0-1.7-.7-2.6-.5 0 0-.4-2.6-1.5-4z"
          />
          <path
            fill="none"
            d="M473.6 250.4s.8.6 1.6.9v.9s-.7-.3-1-.2c0 0-.2-1-.6-1.6z"
          />
          <path
            fill="#fc0"
            fillRule="evenodd"
            d="M475.7 254.9l1-1c0-.1-.4 1 0 1.3.4.8.1 2.3 0 2.7-.7 0-1.3.3-2-.4-.4-.3 0-.9.3-1.3 0-.3.4-1 .7-1.3z"
          />
          <path
            fill="none"
            d="M476.4 254.4v.5l.2.7v2.2m-.3-2.5c.2.9 0 1.6-.1 2.5m0-1c-.2.4-.2.6-.2 1h-.3"
          />
        </g>
      </g>
      <use
        width="100%"
        height="100%"
        transform="matrix(-1 0 0 1 1030 0)"
        xlinkHref="#prefix__c"
      />
    </g>
    <path
      fill="#fc0"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.3}
      d="M319.3 197.9l-40.2 67.3h80.5z"
    />
    <path
      fill="#fff"
      stroke="#fff"
      strokeMiterlimit={2.6}
      strokeWidth={0.1}
      d="M319.3 202.3L283 263h72.7z"
    />
    <path
      fill="#007e93"
      stroke="#007e93"
      strokeMiterlimit={2.6}
      strokeWidth={0.2}
      d="M293.8 245L283 263h72.7l-10.9-18z"
    />
    <g fill="none" strokeMiterlimit={2.6} strokeWidth={0.1}>
      <path
        stroke="#086aad"
        d="M313 212.9a9 9 0 0 1 6.2-2.2h.2c2.3 0 4.7.6 6.3 2.2"
      />
      <path
        stroke="#0863aa"
        d="M313 213a9 9 0 0 1 6.2-2.2h.2c2.4 0 4.8.5 6.3 2.2"
      />
      <path
        stroke="#095fa8"
        d="M313 213a8.8 8.8 0 0 1 6.2-2.2h.2c2.4 0 4.9.6 6.4 2.3"
      />
      <path
        stroke="#0a58a5"
        d="M312.9 213.1a8.7 8.7 0 0 1 6.3-2.2h.2c2.5 0 5 .6 6.5 2.3"
      />
      <path
        stroke="#0a52a2"
        d="M312.8 213.2c1.6-1.7 4-2.3 6.5-2.3h.1c2.6 0 5 .7 6.5 2.4"
      />
      <path
        stroke="#0b4d9f"
        d="M312.8 213.3c1.6-1.7 4-2.3 6.5-2.3h.2c2.5 0 5 .6 6.5 2.4"
      />
      <path
        stroke="#0c479d"
        d="M312.7 213.4c1.6-1.8 4-2.4 6.6-2.4h.2c2.6 0 5 .7 6.6 2.5"
      />
      <path
        stroke="#270a7f"
        d="M312.3 214c1.9-2 4.2-2.5 7-2.5h.2c3.1 0 5.7 1 7.3 3.2"
      />
      <path
        stroke="#241183"
        d="M312.3 214c1.9-2 4.2-2.6 7-2.6h.2c3 0 5.6 1 7.2 3.2"
      />
      <path
        stroke="#221786"
        d="M312.4 214c1.8-2 4.1-2.6 7-2.6 3 0 5.7 1 7.2 3"
      />
      <path
        stroke="#1f1f8a"
        d="M312.4 213.8c1.8-1.9 4.2-2.5 6.9-2.5h.1c3 0 5.6 1 7.2 3"
      />
      <path
        stroke="#1a258d"
        d="M312.5 213.7c1.7-1.8 4-2.4 6.8-2.4h.1c3 0 5.5.8 7 2.9"
      />
      <path
        stroke="#172d91"
        d="M312.5 213.7c1.7-1.9 4.1-2.5 6.7-2.5h.2c2.9 0 5.4.8 7 2.8"
      />
      <path
        stroke="#143393"
        d="M312.5 213.6c1.7-1.8 4-2.4 6.7-2.4h.2c2.8 0 5.3.7 7 2.7"
      />
      <path
        stroke="#113b97"
        d="M312.6 213.5c1.6-1.8 4-2.4 6.6-2.4h.1c2.8 0 5.4.7 7 2.7"
      />
      <path
        stroke="#ff0a00"
        d="M315.3 209a6.5 6.5 0 0 1 4-1.2c1.5 0 2.8.3 4 1"
      />
      <path stroke="#f10" d="M315.3 209a6.6 6.6 0 0 1 4-1 7 7 0 0 1 4 1" />
      <path stroke="#ff1500" d="M315.3 209a6.8 6.8 0 0 1 4-1c1.5 0 2.9.2 4 1" />
      <path
        stroke="#ff1a00"
        d="M315.2 209.2a6.6 6.6 0 0 1 4.1-1.2c1.5 0 3 .3 4.1 1"
      />
      <path
        stroke="#ff2000"
        d="M315.2 209.2a6.7 6.7 0 0 1 4.1-1.1c1.5 0 3 .3 4.1 1"
      />
      <path
        stroke="#ff2700"
        d="M315.1 209.3a6.8 6.8 0 0 1 4.2-1.2c1.5 0 3 .3 4.2 1.1"
      />
      <path
        stroke="#ff2f00"
        d="M315.1 209.4a6.9 6.9 0 0 1 4.2-1.2c1.5 0 3 .3 4.2 1"
      />
      <path
        stroke="#f30"
        d="M315 209.4a6.8 6.8 0 0 1 4.3-1.1 7.7 7.7 0 0 1 4.3 1"
      />
      <path
        stroke="#ff3c00"
        d="M315 209.5a6.9 6.9 0 0 1 4.3-1.2c1.6 0 3.1.3 4.3 1.1"
      />
      <path
        stroke="#ff4100"
        d="M315 209.6a7 7 0 0 1 4.3-1.2 8 8 0 0 1 4.3 1.1"
      />
      <path
        stroke="#ff4600"
        d="M315 209.7a7 7 0 0 1 4.3-1.3 8 8 0 0 1 4.4 1.2"
      />
      <path stroke="#fff500" d="M314 211.2a9.7 9.7 0 0 1 10.7 0" />
      <path
        stroke="#ffeb00"
        d="M314.1 211.1a9 9 0 0 1 5.2-1.5c2 0 4 .5 5.3 1.6"
      />
      <path
        stroke="#ffe000"
        d="M314.1 211a9 9 0 0 1 5.2-1.5c1.9 0 4 .5 5.3 1.6"
      />
      <path
        stroke="#ffd600"
        d="M314.2 211a9 9 0 0 1 5.1-1.6c1.9 0 3.9.5 5.2 1.6"
      />
      <path
        stroke="#ffcf00"
        d="M314.2 210.9a9 9 0 0 1 5.1-1.5 9 9 0 0 1 5.2 1.5"
      />
      <path
        stroke="#ffc400"
        d="M314.3 210.8c1.3-1 3.3-1.5 5-1.5a8 8 0 0 1 5.1 1.5"
      />
      <path stroke="#ffba00" d="M314.3 210.7c1.4-1 3.3-1.5 5-1.5s3.7.5 5 1.5" />
      <path
        stroke="#ffb000"
        d="M314.4 210.6a8.4 8.4 0 0 1 5-1.4c1.7 0 3.6.4 5 1.4"
      />
      <path
        stroke="#ffa600"
        d="M314.4 210.5a8.1 8.1 0 0 1 5-1.4 8 8 0 0 1 4.8 1.4"
      />
      <path
        stroke="#ff9c00"
        d="M314.5 210.4a8 8 0 0 1 4.8-1.4c1.7 0 3.6.4 4.9 1.4"
      />
      <path
        stroke="#ff9100"
        d="M314.6 210.3a8 8 0 0 1 4.7-1.4c1.7 0 3.5.5 4.8 1.4"
      />
      <path
        stroke="#ff8700"
        d="M314.6 210.2a8 8 0 0 1 4.7-1.3c1.7 0 3.5.4 4.8 1.3"
      />
      <path
        stroke="#ff7d00"
        d="M314.6 210.2a7.7 7.7 0 0 1 4.7-1.4c1.7 0 3.4.4 4.7 1.3"
      />
      <path
        stroke="#ff7500"
        d="M314.7 210a7.6 7.6 0 0 1 4.6-1.2c1.7 0 3.4.4 4.7 1.2"
      />
      <path
        stroke="#ff6b00"
        d="M314.8 210a7.6 7.6 0 0 1 4.5-1.3 8 8 0 0 1 4.6 1.2"
      />
      <path
        stroke="#ff6100"
        d="M314.8 209.9a7.3 7.3 0 0 1 4.5-1.3c1.6 0 3.3.4 4.6 1.3"
      />
      <path
        stroke="#ff5700"
        d="M314.9 209.8a7.3 7.3 0 0 1 4.4-1.3 8 8 0 0 1 4.5 1.3"
      />
      <path
        stroke="#ebf605"
        d="M313.9 211.4a9.5 9.5 0 0 1 5.4-1.7c2 0 4.1.6 5.5 1.7"
      />
      <path
        stroke="#d6ec09"
        d="M313.8 211.5a9.1 9.1 0 0 1 5.5-1.7c2 0 4.2.6 5.6 1.7"
      />
      <path
        stroke="#c2e30e"
        d="M313.8 211.6a9 9 0 0 1 5.5-1.7c2 0 4.2.5 5.6 1.7"
      />
      <path
        stroke="#add912"
        d="M313.7 211.7a8.8 8.8 0 0 1 5.6-1.8c2 0 4.2.6 5.6 1.8"
      />
      <path
        stroke="#99cf16"
        d="M313.6 211.8a8.8 8.8 0 0 1 5.7-1.8c2 0 4.3.6 5.7 1.8"
      />
      <path
        stroke="#85c61a"
        d="M313.6 211.9a8.7 8.7 0 0 1 5.7-1.9c2 0 4.3.7 5.7 1.9"
      />
      <path
        stroke="#70bc1f"
        d="M313.5 212a8.4 8.4 0 0 1 5.8-1.9c2 0 4.4.6 5.8 1.8"
      />
      <path
        stroke="#5cb323"
        d="M313.5 212.1a8.4 8.4 0 0 1 5.8-2c2.1 0 4.4.7 5.8 2"
      />
      <path
        stroke="#47a928"
        d="M313.4 212.2a8.4 8.4 0 0 1 5.9-2c2.1 0 4.4.7 5.9 1.9"
      />
      <path
        stroke="#0d74a4"
        d="M313.1 212.7a8.8 8.8 0 0 1 6.2-2 9 9 0 0 1 6.3 2"
      />
      <path
        stroke="#127a97"
        d="M313.1 212.7a8.7 8.7 0 0 1 6.2-2.2 9 9 0 0 1 6.2 2.1"
      />
      <path
        stroke="#17808b"
        d="M313.2 212.6a8.7 8.7 0 0 1 6.2-2 9 9 0 0 1 6 2"
      />
      <path
        stroke="#1a847d"
        d="M313.2 212.6a8.7 8.7 0 0 1 6.1-2.1 9 9 0 0 1 6.1 2"
      />
      <path
        stroke="#1e8a6d"
        d="M313.2 212.5a8.5 8.5 0 0 1 6.1-2c2.3 0 4.6.6 6 2"
      />
      <path
        stroke="#238f5e"
        d="M313.3 212.5a8.5 8.5 0 0 1 6-2.1c2.2 0 4.6.6 6 2"
      />
      <path
        stroke="#2b944e"
        d="M313.3 212.4a8.3 8.3 0 0 1 6-2c2.2 0 4.6.6 6 2"
      />
      <path stroke="#2f9b3e" d="M313.3 212.3c2-1.6 3.7-2 6-2 2.2 0 4.5.7 6 2" />
      <path
        stroke="red"
        d="M323.2 208.8a6.8 6.8 0 0 0-3.9-1 6.6 6.6 0 0 0-4 1"
      />
      <path
        stroke="#2a007c"
        d="M326.9 214.9c-1.6-2.3-4.3-3.4-7.5-3.4-3 0-5.2.7-7.2 2.7"
      />
      <path
        stroke="#0671b0"
        d="M325.6 212.7c-1.5-1.5-4-2-6.3-2a9 9 0 0 0-6.2 2.1"
      />
      <path
        stroke="#0c419a"
        d="M326.2 213.7c-1.6-2-4.1-2.6-6.9-2.6-2.6 0-5 .6-6.7 2.3"
      />
      <path
        stroke="#ff0"
        d="M324.8 211.3a9.1 9.1 0 0 0-5.5-1.6c-1.8 0-4 .5-5.4 1.6"
      />
      <path
        stroke="#ff4d00"
        d="M323.7 209.7a8.1 8.1 0 0 0-4.4-1.2 7 7 0 0 0-4.4 1.2"
      />
      <path
        stroke="#33a02c"
        d="M325.2 212.2a9.5 9.5 0 0 0-5.9-2 8.3 8.3 0 0 0-6 2"
      />
    </g>
    <g fill="none" strokeMiterlimit={2.6} strokeWidth={0.1}>
      <path
        stroke="#fef2ec"
        d="M312 214.5a16.3 16.3 0 0 1 7.3-1.8c2.6 0 5.4 1 7.6 2.1l7.7 13a15.3 15.3 0 0 1-30.6 0l8-13.3z"
      />
      <path
        stroke="#fef2ea"
        d="M319.3 212.9c2.6 0 5.3 1 7.5 2.1l7.6 12.7c0 8.3-6.8 15.2-15 15.2-8.4 0-15.1-6.7-15.2-15.1l7.9-13a15.8 15.8 0 0 1 7.2-2z"
      />
      <path
        stroke="#fef0e6"
        d="M319.3 213.3c2.5 0 5.2 1 7.3 2l7.4 12.4c0 8.1-6.6 14.9-14.7 14.9a14.7 14.7 0 0 1-14.7-14.8l7.6-12.7a15.6 15.6 0 0 1 7-1.8z"
      />
      <path
        stroke="#feede3"
        d="M319.3 213.7c2.4 0 5 .9 7 2 .2 0 7.3 11.9 7.3 12a14.4 14.4 0 0 1-14.3 14.4c-7.9 0-14.2-6.3-14.3-14.3 0-.2 7.3-12.3 7.4-12.4a16 16 0 0 1 6.9-1.7z"
      />
      <path
        stroke="#fee8dc"
        d="M319.3 214.3c2.3 0 4.8.9 6.8 2 .2 0 6.8 11.2 6.8 11.5 0 7.5-6.1 13.7-13.6 13.7s-13.6-6-13.7-13.7c0-.3 6.9-11.7 7.1-11.8 2-1 4.2-1.7 6.6-1.7z"
      />
      <path
        stroke="#fee6d5"
        d="M319.3 214.7c2.3 0 4.7.8 6.6 1.9.2.2 6.6 10.8 6.6 11.2 0 7.3-6 13.3-13.2 13.3s-13.2-6-13.2-13.3c0-.4 6.5-11.3 6.8-11.5 2-1 4-1.6 6.4-1.6z"
      />
      <path
        stroke="#fee3cf"
        d="M319.3 215.3c2.2 0 4.5.8 6.2 1.8.4.2 6.4 10.2 6.4 10.7 0 7-5.7 12.7-12.6 12.7-7 0-12.6-5.6-12.7-12.7 0-.4 6.2-10.7 6.6-11a13.3 13.3 0 0 1 6-1.5z"
      />
      <path
        stroke="#fee0cc"
        d="M319.3 215.7c2.1 0 4.3.8 6 1.8a76 76 0 0 1 6.2 10.3c0 6.7-5.5 12.3-12.2 12.3a12.2 12.2 0 0 1-12.3-12.3c0-.5 6-10.3 6.4-10.6 1.8-1 3.7-1.5 5.9-1.5z"
      />
      <path
        stroke="#fedec6"
        d="M319.3 216.1c2 0 4.2.8 5.9 1.7.4.3 6 9.4 6 10a12 12 0 0 1-12 11.9 11.8 11.8 0 0 1-11.7-11.9c0-.6 5.6-10 6-10.2a12.5 12.5 0 0 1 5.8-1.5z"
      />
      <path
        stroke="#fdcdaa"
        d="M319.3 218.8c1.6 0 3.2.5 4.5 1.3.9.5 4.6 6.7 4.6 7.7a9.2 9.2 0 0 1-9.1 9.2 9.2 9.2 0 0 1-9.2-9.2c0-1 3.9-7.4 4.7-8a9.6 9.6 0 0 1 4.5-1z"
      />
      <path
        stroke="#fdcdaa"
        d="M319.3 219a9 9 0 0 1 4.4 1.2c1 .6 4.5 6.6 4.5 7.6a9 9 0 1 1-17.9 0c0-1 3.7-7.2 4.6-7.7a9.2 9.2 0 0 1 4.4-1.1z"
      />
      <path
        stroke="#fdc59e"
        d="M319.3 220a8 8 0 0 1 4 1.1c1 .6 4 5.5 4 6.7a8 8 0 0 1-8 8 8 8 0 0 1-8-8c0-1.2 3-6.3 4.1-6.8 1.2-.7 2.5-1 3.9-1z"
      />
      <path
        stroke="#fdc59e"
        d="M319.3 220.2a7.8 7.8 0 0 1 3.9 1 16 16 0 0 1 3.8 6.6 7.8 7.8 0 0 1-7.7 7.8 7.7 7.7 0 0 1-7.8-7.7c0-1.4 3-6.1 4-6.8a7.9 7.9 0 0 1 3.8-1z"
      />
      <path
        stroke="#fef0e9"
        d="M319.3 213c2.5 0 5.2 1 7.4 2.2l7.5 12.5a15 15 0 0 1-14.9 15 15 15 0 0 1-14.9-14.9l7.7-13a15.6 15.6 0 0 1 7.2-1.7z"
      />
      <path
        stroke="#feede3"
        d="M319.3 213.5c2.5 0 5.1 1 7.1 2 .2.1 7.4 12.1 7.4 12.3a14.5 14.5 0 0 1-29 0l7.5-12.6a15.1 15.1 0 0 1 7-1.7z"
      />
      <path
        stroke="#feebdf"
        d="M319.3 214c2.4 0 5 .8 7 1.9.1 0 7 11.6 7 11.9 0 7.7-6.3 14.1-14 14.1s-14-6.3-14-14.1c0-.2 7-12.1 7.2-12.2a14.9 14.9 0 0 1 6.8-1.7z"
      />
      <path
        stroke="#feebdd"
        d="M319.3 214c2.4 0 4.9 1 6.9 2 .1.2 7 11.5 7 11.8a14 14 0 0 1-14 14 14 14 0 0 1-13.8-14c0-.2 7-11.9 7.2-12 2-1 4.2-1.7 6.7-1.7z"
      />
      <path
        stroke="#fee8d9"
        d="M319.3 214.5c2.3 0 4.8.9 6.7 2 .2 0 6.7 11 6.7 11.3 0 7.4-6 13.5-13.4 13.5s-13.4-6-13.5-13.5c0-.3 6.7-11.5 7-11.7 2-1 4.1-1.6 6.5-1.6z"
      />
      <path
        stroke="#fee6d3"
        d="M319.3 215c2.2 0 4.6.7 6.5 1.8.3.1 6.5 10.6 6.5 11 0 7.1-5.9 13.1-13 13.1a13.1 13.1 0 0 1-13-13c0-.5 6.4-11.3 6.7-11.4a13.8 13.8 0 0 1 6.3-1.6z"
      />
      <path
        stroke="#fee3d2"
        d="M319.3 215.1c2.2 0 4.5.8 6.4 1.8.3.2 6.4 10.5 6.4 10.9 0 7-5.8 13-12.8 13a13 13 0 0 1-12.9-13c0-.4 6.3-11 6.7-11.1a13.8 13.8 0 0 1 6.2-1.6z"
      />
      <path
        stroke="#fee0cc"
        d="M319.3 215.5c2.2 0 4.4.8 6.1 1.8.5.2 6.3 10 6.3 10.5 0 6.8-5.6 12.5-12.4 12.5a12.5 12.5 0 0 1-12.5-12.5c0-.5 6-10.6 6.5-10.8a13 13 0 0 1 6-1.5z"
      />
      <path
        stroke="#fedec8"
        d="M319.3 216c2 0 4.2.7 6 1.6.4.3 6 9.6 6 10.2a12 12 0 0 1-12 12 12 12 0 0 1-12-12 88 88 0 0 1 6.2-10.4c1.7-1 3.6-1.5 5.8-1.5z"
      />
      <path
        stroke="#fddbc5"
        d="M319.3 216.3c2 0 4.1.8 5.8 1.7a87 87 0 0 1 5.8 9.8c0 6.4-5.2 11.7-11.6 11.7-6.4 0-11.6-5.2-11.6-11.7 0-.6 5.5-9.7 6-10a12.1 12.1 0 0 1 5.6-1.5z"
      />
      <path
        stroke="#fddbc2"
        d="M319.3 216.5c2 0 4 .8 5.7 1.7.5.3 5.7 9 5.7 9.6 0 6.3-5.1 11.5-11.4 11.5s-11.4-5.1-11.5-11.5c0-.7 5.4-9.6 6-9.9a12 12 0 0 1 5.5-1.4z"
      />
      <path
        stroke="#fdd9bf"
        d="M319.3 216.7c2 0 4 .7 5.6 1.6.5.4 5.6 8.8 5.6 9.5a11.2 11.2 0 0 1-22.4 0c0-.7 5.2-9.4 5.8-9.7a11.9 11.9 0 0 1 5.4-1.4z"
      />
      <path
        stroke="#fdd9bf"
        d="M319.3 217c2 0 3.9.6 5.4 1.5a55 55 0 0 1 5.6 9.3c0 6-5 11-11 11s-11-4.8-11-11c0-.7 5-9.2 5.7-9.5a11.5 11.5 0 0 1 5.3-1.4z"
      />
      <path
        stroke="#fdd6bc"
        d="M319.3 217.1c1.9 0 3.8.7 5.3 1.6.7.3 5.5 8.3 5.5 9.1 0 6-4.9 10.9-10.8 10.9a10.8 10.8 0 0 1-10.8-10.9c0-.8 5-9 5.6-9.3a11 11 0 0 1 5.2-1.4z"
      />
      <path
        stroke="#fdd6b9"
        d="M319.3 217.3c1.8 0 3.7.7 5.2 1.5.7.4 5.3 8.2 5.3 9 0 5.8-4.7 10.7-10.5 10.7a10.6 10.6 0 0 1-10.6-10.7c0-.8 4.8-8.8 5.5-9.2a11 11 0 0 1 5-1.3z"
      />
      <path
        stroke="#fdd4b8"
        d="M319.3 217.6c1.8 0 3.7.6 5.2 1.4.6.4 5.2 8 5.2 8.8 0 5.7-4.7 10.5-10.4 10.5s-10.4-4.7-10.4-10.5c0-.8 4.6-8.6 5.3-9a10.8 10.8 0 0 1 5-1.2z"
      />
      <path
        stroke="#fdd4b6"
        d="M319.3 217.7c1.8 0 3.6.7 5 1.5.8.4 5.2 7.7 5.2 8.6 0 5.6-4.6 10.3-10.2 10.3a10.2 10.2 0 0 1-10.2-10.3c0-.9 4.5-8.4 5.2-8.8a10.8 10.8 0 0 1 5-1.3z"
      />
      <path
        stroke="#fdd2b2"
        d="M319.3 218c1.7 0 3.5.6 5 1.4.7.4 5 7.5 5 8.4 0 5.5-4.6 10-10 10s-10-4.4-10-10a39 39 0 0 1 5.1-8.6 10.7 10.7 0 0 1 4.9-1.3z"
      />
      <path
        stroke="#fdd1b0"
        d="M319.3 218.2c1.7 0 3.5.6 4.9 1.4.7.4 4.9 7.3 4.9 8.2 0 5.4-4.5 9.9-9.8 9.9s-9.8-4.4-9.8-9.9c0-.9 4.2-8 5-8.4a9.8 9.8 0 0 1 4.8-1.3z"
      />
      <path
        stroke="#fdd0b0"
        d="M319.3 218.4c1.7 0 3.4.6 4.8 1.3.8.5 4.7 7.1 4.7 8.1a9.5 9.5 0 1 1-19.1 0c0-1 4.1-7.8 5-8.3a9.8 9.8 0 0 1 4.6-1.1z"
      />
      <path
        stroke="#fdd0ad"
        d="M319.3 218.6a9.8 9.8 0 0 1 4.7 1.3c.8.5 4.6 7 4.6 8 0 5-4.2 9.3-9.3 9.3s-9.4-4.1-9.4-9.4c0-1 4-7.6 4.8-8a9.6 9.6 0 0 1 4.6-1.2z"
      />
      <path
        stroke="#fdcaa6"
        d="M319.3 219.2c1.5 0 3 .5 4.4 1.2.9.5 4.3 6.3 4.3 7.4a8.8 8.8 0 0 1-8.7 8.8 8.8 8.8 0 0 1-8.8-8.7c0-1.2 3.6-7.1 4.5-7.7a9.1 9.1 0 0 1 4.3-1z"
      />
      <path
        stroke="#fdcaa4"
        d="M319.3 219.4a9.1 9.1 0 0 1 4.3 1.2c.9.5 4.2 6 4.2 7.2a8.6 8.6 0 0 1-8.5 8.6 8.6 8.6 0 0 1-8.6-8.5c0-1.2 3.5-7 4.4-7.5a9 9 0 0 1 4.2-1z"
      />
      <path
        stroke="#fdc8a4"
        d="M319.3 219.6c1.5 0 3 .5 4.2 1.2a19 19 0 0 1 4.1 7 8.4 8.4 0 0 1-16.7.1c0-1.2 3.3-6.7 4.3-7.3a8.5 8.5 0 0 1 4-1z"
      />
      <path
        stroke="#fdc8a1"
        d="M319.3 219.8c1.4 0 2.9.5 4 1.1 1 .6 4.1 5.7 4.1 7a8.2 8.2 0 0 1-8.1 8.1 8.2 8.2 0 0 1-8.2-8.1c0-1.3 3.2-6.6 4.2-7.1 1.2-.6 2.5-1 4-1z"
      />
      <path
        stroke="#fdc39b"
        d="M319.3 220.4c1.3 0 2.7.4 3.7 1a15 15 0 0 1 3.8 6.4 7.5 7.5 0 0 1-7.5 7.6 7.5 7.5 0 0 1-7.6-7.5c0-1.4 2.8-6 3.9-6.6a7.7 7.7 0 0 1 3.7-1z"
      />
      <path
        stroke="#fdc398"
        d="M319.3 220.6c1.3 0 2.6.4 3.6 1a13 13 0 0 1 3.7 6.3c0 4-3.3 7.3-7.3 7.3a7.3 7.3 0 0 1-7.4-7.3 14 14 0 0 1 3.8-6.4 7.7 7.7 0 0 1 3.6-1z"
      />
      <path
        stroke="#fdc097"
        d="M319.3 220.8a7.5 7.5 0 0 1 3.6 1 13 13 0 0 1 3.5 6c0 4-3.2 7.2-7.1 7.2a7.1 7.1 0 0 1-7.2-7.1c0-1.5 2.5-5.6 3.7-6.3a7.3 7.3 0 0 1 3.5-.8z"
      />
      <path
        stroke="#fdc095"
        d="M319.3 221a7 7 0 0 1 3.5 1c1.1.7 3.4 4.4 3.4 5.9a7 7 0 0 1-7 7 7 7 0 0 1-6.9-7c0-1.5 2.4-5.4 3.6-6a6.8 6.8 0 0 1 3.4-.9z"
      />
      <path
        stroke="#fdbe92"
        d="M319.3 221.2a7 7 0 0 1 3.4 1c1.1.6 3.3 4.2 3.3 5.7a6.7 6.7 0 1 1-13.5 0c0-1.5 2.3-5.2 3.5-5.9 1-.5 2-.8 3.3-.8z"
      />
      <path
        stroke="#fdbe90"
        d="M319.3 221.4c1.1 0 2.3.4 3.3 1 1.1.6 3.2 4 3.2 5.5a6.5 6.5 0 0 1-6.5 6.5 6.5 6.5 0 0 1-6.6-6.5c0-1.6 2.1-5 3.4-5.7a6.6 6.6 0 0 1 3.2-.8z"
      />
      <path
        stroke="#fdbb8f"
        d="M319.3 221.6c1.1 0 2.2.3 3.2.9 1.2.7 3 3.8 3 5.4a6.3 6.3 0 0 1-6.2 6.3 6.3 6.3 0 0 1-6.4-6.3 9 9 0 0 1 3.3-5.5c1-.5 2-.8 3-.8z"
      />
      <path
        stroke="#fdbb8d"
        d="M319.3 221.8c1 0 2.2.3 3 .9a8 8 0 0 1 3 5.2 6.1 6.1 0 0 1-6 6 6.1 6.1 0 0 1-6.1-6c0-1.6 1.8-4.6 3-5.3a6 6 0 0 1 3-.8z"
      />
      <path
        stroke="#fdb98a"
        d="M319.3 222a5.8 5.8 0 0 1 3 .8c1.2.8 2.9 3.5 2.9 5a6 6 0 0 1-6 6 6 6 0 0 1-5.8-6c0-1.6 1.6-4.3 3-5a6 6 0 0 1 2.9-.8z"
      />
      <path
        stroke="#fdb98a"
        d="M319.3 222.2a5.8 5.8 0 0 1 2.8.8 7 7 0 0 1 2.9 4.9 5.7 5.7 0 0 1-11.4 0 7 7 0 0 1 2.9-5 5.5 5.5 0 0 1 2.8-.7z"
      />
      <path
        stroke="#fcb687"
        d="M319.3 222.4c1 0 2 .3 2.8.8a6.5 6.5 0 0 1 2.6 4.7 5.5 5.5 0 1 1-11 0c0-1.7 1.5-4 2.9-4.8a6 6 0 0 1 2.7-.7z"
      />
      <path
        stroke="#fcb685"
        d="M319.3 222.6c1 0 1.9.3 2.7.8a5.9 5.9 0 0 1 2.5 4.5 5.3 5.3 0 0 1-5.2 5.3 5.3 5.3 0 0 1-5.3-5.3 5.9 5.9 0 0 1 2.7-4.6 5 5 0 0 1 2.6-.7z"
      />
      <path
        stroke="#fcb485"
        d="M319.3 222.8c1 0 1.8.3 2.6.7a5.3 5.3 0 0 1 2.4 4.4 5 5 0 1 1-10.1 0c0-1.8 1.1-3.6 2.6-4.4a5 5 0 0 1 2.5-.7z"
      />
      <path
        stroke="#fcb482"
        d="M319.3 232.8a4.9 4.9 0 0 0 4.8-4.9c0-2.7-2.2-4.9-4.8-4.9a4.9 4.9 0 0 0-5 4.9 4.9 4.9 0 0 0 5 4.9z"
      />
    </g>
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#fff"
      strokeMiterlimit={2.6}
      strokeWidth={0.1}
      d="M319.3 232.8a4.9 4.9 0 0 0 4.9-4.9 4.9 4.9 0 0 0-4.9-4.8 4.9 4.9 0 0 0-4.9 4.8 4.9 4.9 0 0 0 5 4.9z"
    />
    <g stroke="#000" strokeWidth={0.1}>
      <path
        fill="none"
        d="M320.4 223.1l.5-2.6m-1 2.6l.2-2.7m-.8 2.6v-2.6m-.5 2.7l-.3-2.7m-.2 2.7l-.6-2.6m.1 2.8l-.8-2.6m.3 2.7l-1-2.4m.6 2.6l-1.4-2.3m1 2.6l-1.6-2.1m1.2 2.5l-1.9-2m1.5 2.3l-2-1.8m1.7 2.2l-2.2-1.5m1.8 2l-2.2-1.4m2 1.8l-2.4-1m2.2 1.5l-2.5-.9m2.4 1.4l-2.6-.6m2.5 1l-2.6-.2m2.6.8h-2.7m2.7.5l-2.6.3m2.7.2l-2.6.6m2.7-.1l-2.5.8m2.7-.3l-2.4 1m2.6-.6l-2.8 1.8m3.1-1.3l-5.7 4m6-3.6l-6.1 5.4m6.5-5l-5.1 5.6m5.5-5.3l-3.9 5.1m4.3-4.8l-4 7m4.5-6.8l-2.3 5m2.7-4.8l-2.2 7m2.7-6.9l-1 4.7m1.6-4.6l-.7 7.2m1.7-7.2l.2 2.6m.3-2.7l1.5 6.8m-1-7l1.3 4.1m-.8-4.2l3 6.7m-2.6-7l3.3 5.8m-2.8-6l4.7 6.2m-4.3-6.5l4.1 4.8m-3.8-5.2l6.2 5.7m-5.9-6l3.4 2.4m-3-2.9l2.2 1.3m-2-1.7l2.4 1m-2.2-1.5l2.5.8M324 229l2.6.5m-2.5-1l2.6.2m-2.6-.8h2.6m-2.6-.5l2.6-.2m-2.7-.3l2.6-.5m-2.7 0l2.5-.8m-2.7.4l2.4-1.1m-2.6.6l2.3-1.3m-2.6.9l2.1-1.6m-2.4 1.1l2-1.7m-2.4 1.4l1.8-2m-2.2 1.6l1.6-2m-2 1.8l1.3-2.3m-1.8 2l1.1-2.4m-1.6 2.3l.9-2.5m-2.4-4v-2M317 217l-.4-2m-1.8 2.7l-.8-1.8m-1.2 3l-1.2-1.7m-.5 3.2l-1.6-1.3m.2 3.2l-1.8-1m.8 3.2l-2-.7m1.5 3l-2-.3m2 2.5l-2 .2m2.5 2.1l-2 .7m22.2 1.5l1.8 1m-.8-3.1l1.9.6m-1.5-2.9l2 .2m-2-2.5l2-.2m-2.4-2.1l2-.6m-3-1.5l1.8-1m-3.1-.9l1.5-1.4m-3.2-.2l1.2-1.6m-3.2.5l.8-1.9m-3 1.1l.4-2"
      />
      <path
        fill="#e60000"
        fillRule="evenodd"
        strokeMiterlimit={2.6}
        d="M322.1 230.2s-.7-.4-1-.4l-3 .1c-.5.1-.8.5-.8.5s.5.5 1.4.6c1 0 1.7 0 2.2-.2l1.2-.6z"
      />
      <path
        fill="#e60000"
        fillRule="evenodd"
        strokeMiterlimit={2.6}
        d="M317.4 229.5s.1-1.4 1-3l-.4.8s-.6.3-.9 0c-.3-.4-.1-.5.1-1 .2-.4.2-.8.5-1 .2-.3.4-.3 1-.3.7 0 1.2 0 1.7.8l1 1.7c.6.8.6 1.9.6 1.9l.2.8s-.7-.4-1.1-.4l-3 .1-.8.5s-.3-.6.1-1z"
      />
      <path
        fill="none"
        strokeMiterlimit={2.6}
        d="M317.4 229.5s.6-.3 2.3-.3c2 0 2.1.2 2.3.3"
      />
      <path
        fill="#fc0"
        fillRule="evenodd"
        strokeMiterlimit={2.6}
        d="M319.2 237.1v-7.2s.2-.2.8 0v7.1s.2 5.5-.4 5.5c-.7 0-.4-1.3-.4-5.4z"
      />
    </g>
    <g fill="#e60000">
      <path
        fillRule="evenodd"
        d="M311.8 231l.1.3-1.4.6.2.5h-.2c-.1-.2-.2-.3-.6-.3v-.2l1.9-.8zm-1.5-.5a.6.6 0 0 1-.3-.4c0-.4.1-.7.6-.8.2-.1.7-.1.9.5 0 .3 0 .7-.5.8v-.2c.2-.1.3-.3.2-.6 0-.2-.3-.3-.6-.3-.3.1-.4.3-.3.6a.5.5 0 0 0 .3.3v.2l-1.2.1-.2-1h.3l.2.8h.6zm-.6-4c-.3 0-.5.3-.5.6 0 .2 0 .5.3.5s.3-.1.4-.2l.2-.6c0-.3.2-.5.6-.5.5 0 .6.6.5 1l-.2.6c-.2.1-.4.2-.6.1v-.2c.4 0 .6-.3.6-.6 0-.2 0-.5-.3-.6-.3 0-.3 0-.4.4l-.2.5c0 .1-.1.4-.5.4s-.7-.3-.6-.8c0-.8.5-.8.7-.8v.3zm0-1.3l.5.2.4-1.1h.3l-.4 1.2.7.3.4-1.3h.2l-.4 1.6-2.1-.7.5-1.5.2.1z"
      />
      <path d="M311 222a.7.7 0 0 0-.4.4l-.5.8 1.9 1.1.1-.2-.8-.5.4-.6c.2-.4 0-.7-.2-.9a.6.6 0 0 0-.5 0zm.2.4a.4.4 0 0 1 .1 0c.2.2.2.3.1.6l-.3.4-.6-.3.3-.5c.1-.2.2-.3.4-.2z" />
      <path
        fillRule="evenodd"
        d="M313.6 222.1l-.2.2-1.4-1.3-.5.5-.2-.1 1.2-1.3.2.2-.5.5zm.7-.6l-1.3-1.7.2-.2 1.3 1.7zm0-2.3l.3.6 1-.5.2.2-1 .6.2.6 1.2-.6.1.2-1.4.8-1-2 1.4-.7.1.2zm4 .6l-.3-1.2v-.6l-.3 2h-.3l-1-1.6.2.5.2 1.3h-.2l-.5-2.1h.4l1 1.6.2-2h.4l.5 2-.3.1z"
      />
      <path d="M319 217.6v2.2h.8c.5 0 .8-.2.8-.6 0-.3-.2-.4-.4-.5.3-.1.3-.3.3-.5 0-.3-.1-.5-.5-.6h-1zm.3.3h.5c.3 0 .4.2.4.4s-.1.3-.4.2h-.5v-.6zm0 .9h.5c.2 0 .5.1.5.4 0 .2-.2.4-.5.4l-.5-.1v-.7zm2.1-1l-.5 2.1.2.1.3-.9.7.2c.3.1.3.3.2.5v.5l.3.1v-.7c.1-.2 0-.3 0-.4 0 0 .3-.1.3-.4.2-.5-.1-.7-.5-.8l-1-.3zm.3.4l.6.2c.2 0 .4 0 .3.4 0 .3-.3.3-.5.2l-.6-.1.2-.7z" />
      <path
        fillRule="evenodd"
        d="M324 219l-.3.6 1 .6-.1.2-1-.5-.4.6 1.1.6-.1.2-1.4-.8 1-1.8 1.5.8-.2.2z"
      />
      <path d="M326.6 220.7L325 222l.6.7c.4.5 1 .3 1.4 0 .5-.4.6-1 .2-1.4l-.5-.7zm0 .4l.3.4c.3.3.3.6-.1 1-.4.3-.8.3-1 0l-.3-.4 1.1-1z" />
      <path
        fillRule="evenodd"
        d="M328.2 223l-.7.4.6 1-.3.2-.5-1.1-.6.3.6 1.2h-.3l-.7-1.3 2-1 .7 1.4-.3.1zm-.8 4v-.3l1.5-.2-.1-.5h.2c0 .3.1.4.5.5v.2l-2.1.3z"
      />
      <path d="M328 227.6l-.4.2a.9.9 0 0 0-.2.5c0 .5.3.8.6.8.2 0 .4 0 .6-.3 0 0 .1.2.4.2.3 0 .6 0 .6-.6 0-.5-.3-.7-.6-.7-.2 0-.3.1-.4.4 0-.3-.3-.4-.5-.5zm0 .4c.2 0 .4.1.4.4 0 .2-.1.4-.4.4-.3 0-.3-.3-.3-.5 0-.3.2-.3.4-.3zm1 0c.2 0 .3.1.3.4 0 .3-.2.4-.3.4a.4.4 0 0 1-.3-.4c0-.2.1-.3.3-.3z" />
      <path
        fillRule="evenodd"
        d="M328.7 229.5c.7.2.6.7.6 1-.1.3-.4.5-.8.4-.4 0-.5-.3-.6-.7v-.2c0-.4-.2-.5-.3-.5l-.3 1.1h-.3l.4-1.4c.4.1.6.3.7.7v.3c.2.2.2.4.5.5.1 0 .4 0 .5-.4 0-.3-.3-.4-.4-.5v-.3zm-2.1 2.1l.1-.3 1.4.7.2-.5.2.1c-.1.4-.2.5.1.7v.2l-2-.9z"
      />
    </g>
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={2.6}
      strokeWidth={0.2}
      d="M319.3 202.3L283 263h72.7z"
    />
    <g fill="none" strokeMiterlimit={2.6}>
      <path
        stroke="#000"
        strokeWidth={0.1}
        d="M321.3 255.5a6.3 6.3 0 0 0 3.2 0c1.5-.3 3-1.2 4.8-1 1.4 0 3.2 1.2 5.3 1.2 2.2 0 3-.7 4.8-1.1 1.3-.3 2-.2 3.4.2 1.6.3 2.5 1.2 5.2 1"
      />
      <path
        stroke="#fff"
        strokeWidth={0.4}
        d="M293.2 258.1c1.3-1 3.4-1.3 5-1 2.2.5 3.1 1 5.4 1 1.7 0 3.2-1.1 5-1.1 2.8 0 2.9.6 5.4 1a5.6 5.6 0 0 0 2.2 0 9.5 9.5 0 0 0 2.5-.8c.8-.4 2.8-.4 3.8-.3 1.8.2 2.6.9 3 1 1 .2 2 .4 3.2 0 1.5-.4 3-1.4 4.9-1.2 1.3.2 3 1.4 5.2 1.4s3-.8 4.8-1.2c1.4-.3 2-.2 3.4.1 1.6.4 2.5 1.5 5.2 1.2"
      />
      <path
        stroke="#fff"
        strokeWidth={0.3}
        d="M289.1 256a7.6 7.6 0 0 1 5-.8c2.2.4 3.1 1 5.4 1 1.7-.1 3.2-1.1 5-1.1 2.8 0 2.9.5 5.4 1h2.2a9.4 9.4 0 0 0 2.5-.9c.8-.3 2.8-.3 3.8-.2 1.8.2 2.6.8 3 .9 1 .2 2 .3 3.2 0 1.5-.4 3-1.2 4.9-1 1.3 0 3.1 1.2 5.2 1.2 2.2 0 3-.8 4.8-1.1 1.4-.3 2-.1 3.4.1 1.6.4 2.5 1.3 5.2 1"
      />
      <path
        stroke="#fff"
        strokeWidth={0.5}
        d="M285.4 262a6.3 6.3 0 0 1 5-1c2.1.5 3 1.1 5.4 1 1.7 0 3.2-1.3 4.9-1.3 2.9 0 3 .7 5.5 1.3a5.8 5.8 0 0 0 2.2 0 8.4 8.4 0 0 0 2.5-1c.8-.5 2.8-.4 3.8-.3 1.8.2 2.5 1 2.9 1 1 .3 2 .5 3.3.2 1.5-.6 3-1.6 4.8-1.4 1.3.1 3.1 1.6 5.3 1.6 2.1 0 3-1 4.7-1.5 1.4-.3 2-.1 3.5.2 1.6.4 2.5 1.6 5.2 1.3"
      />
      <path
        stroke="#fff"
        strokeWidth={0.3}
        d="M286.4 258.6c1.2-.9 3.4-1.2 5-.9 2.1.5 3 1 5.4 1 .7 0 1.4-.3 2.2-.5"
      />
      <path
        stroke="#000"
        strokeWidth={0.2}
        d="M297.4 255c.3 0 1.3-.5 2.8-.5 2.9 0 1 0 3.6.5.7 0 2.5 0 3-.4m25.4 8.2c1-.2 1.8-.5 2.6-.8.7-.3 2.7-.3 3.8-.2 1.8.2 2.5.8 2.9.8a6.3 6.3 0 0 0 3.2 0c1.6-.3 3-1.2 5-1 1.2.1 3 1.3 5.2 1.3"
      />
      <path
        stroke="#fff"
        strokeWidth={0.3}
        d="M336.7 254.8c2.1 0 2.9-.8 4.8-1.2 1.3-.2 2 0 3.3.2 1.7.3 2.5 1.3 5.2 1"
      />
      <path
        stroke="#000"
        strokeWidth={0.1}
        d="M285.5 262.2a7.7 7.7 0 0 1 5-.8c2.2.4 3.1.9 5.4.9 1.7 0 3.2-1.1 5-1.1 2.8 0 2.9.6 5.4 1a7.5 7.5 0 0 0 2.2 0 9.8 9.8 0 0 0 2.5-.8c.8-.4 2.8-.3 3.8-.2 1.8.1 2.5.7 3 .8"
      />
      <path
        stroke="#000"
        strokeWidth={0.5}
        d="M290 259.6c1.3-.9 3.5-1.2 5.1-.9 2.2.4 3.1 1 5.4.9 1.7 0 3.1-1 4.8-1 3 0 3 .5 5.6 1a7.4 7.4 0 0 0 2.2 0 11.3 11.3 0 0 0 2.5-.9c.7-.3 2.8-.3 3.8-.2 1.8.2 2.5.8 3 .9.9.2 2 .3 3.2 0 1.5-.4 3-1.3 4.8-1 1.5 0 3.3 1.2 5.3 1.2 2.2 0 3-.8 4.8-1.2 1.3-.2 2 0 3.4.2 1.6.3 2.5 1.3 5.2 1"
      />
    </g>
    <g fill="#fc0" fillRule="evenodd" stroke="#000" strokeWidth={0.2}>
      <path d="M291 249.5c.4 0 1.2-.6 1.5-.8.3-.2.5-.7.8-1l1.5-1a10.8 10.8 0 0 0 3.5-3.1 17.8 17.8 0 0 1 5.7-5.2c.8-.4 1.9-.3 2.7 0l.8.7c1 .7 2.3 1.3 3.9 1.8 1.5.4 1.9 1.4 3 2.5.7.5 1.3 1 2 1.3l.4.4 2 1.4a67 67 0 0 1 3.2 3.1l.4.7c.8.7 1.6 1.5 2.6 2l2.7 1.6c-9.2.4-17.7-.2-27 0H299l-1.8.1h-8.8l2.7-4.5z" />
      <path d="M327.3 253.7l-2.3-1.4c-1-.5-1.8-1.3-2.6-2l-.4-.7a67 67 0 0 0-3.2-3.1l-2-1.4-.3-.4a8.5 8.5 0 0 1-2-1.3l-1.9-2a7.5 7.5 0 0 1 1.3-.7c.6-.4 1.5-.3 2.2 0l.7.5c.8.7 1.9 1.1 3.2 1.5 1.3.4 1.6 1.2 2.6 2.1.5.5 1 .8 1.6 1.1l.3.3 1.7 1.3 2.7 2.5.3.6c.7.6 1.3 1.3 2.1 1.6l2.3 1.4h-6.2z" />
      <path d="M319.1 242.4l.9.3c1.3.4 1.6 1.2 2.6 2.1.5.5 1 .8 1.6 1.1l.3.3 1.7 1.3a63 63 0 0 1 2.7 2.5l.3.6c.7.6 1.3 1.3 2.1 1.6.7.3 1.3.8 2 1.2l5-.1c-.6-.4-1.2-1-2-1.3-.7-.3-1.3-1-1.9-1.5l-.3-.5-2.4-2.3-1.6-1.1-.2-.3a6.2 6.2 0 0 1-1.5-1c-1-.8-1.2-1.6-2.4-2a9 9 0 0 1-2.9-1.3c-.2-.1-.4-.4-.6-.4-.6-.3-1.5-.4-2 0a9.8 9.8 0 0 0-1.4.8z" />
      <path d="M327.6 244.4l.8.9 1.5 1 .2.3 1.6 1 2.4 2.4.3.5c.6.6 1.2 1.2 2 1.5l1.3.8h6c-.6-.4-1-.8-1.7-1l-1.5-1.3-.3-.4a93.8 93.8 0 0 0-2-1.9l-1.2-.9-.2-.2a5 5 0 0 1-1.2-.8c-.7-.7-1-1.3-1.9-1.6a7.3 7.3 0 0 1-2.4-1l-.4-.4c-.6-.2-1.2-.3-1.7 0a9.5 9.5 0 0 0-1.6 1v.1z" />
      <path d="M343.3 252.5a7.4 7.4 0 0 0-1.3-.8l-1.5-1.2-.3-.4c-.6-.7-1.2-1.3-2-1.9l-1.2-.9-.2-.2a5.7 5.7 0 0 1-1.2-.8c-.6-.6-.9-1-1.5-1.4a6.3 6.3 0 0 1 1-.7c.5-.2 1 0 1.5 0l.4.4c.5.4 1.2.7 2 1 .9.2 1 .7 1.7 1.3.3.2.6.5 1 .6l.2.3 1 .7 1.7 1.6.2.4 1.3 1 1.5.9h-4.3z" />
    </g>
    <path
      fill="none"
      stroke="#00633b"
      strokeWidth={0.1}
      d="M303.2 239c.4 0 .2-.2.6 0m-1.5.5c.5 0 .7-.4 1 0m-1.4.3c.2 0 .3-.2 1 .2m-1.5.4h1m-1.6.4c.5-.1.7.2 1.3.1m-1.9.5h1.4m-2 .6h.7c.5 0 .4.1.8 0m-1.9.5c.7 0 1 0 1.4.2m-2.3 1.1h1.4m-11 10c1.8-.4 4 0 6-.3m3.8-10.3c.5-.2.4 0 1 0h.7m-2.4 1.1c.5-.2 1 0 1.5 0m-.3.5c-.5-.1-1 0-1.6 0m1.2.6a2.9 2.9 0 0 0-1.7 0m-.8.4c.7 0 1.4-.2 2.1 0m-2.6.6c.7-.3 1.4 0 2.2 0m-3 .4h2.3c.1 0 .4-.2.5 0m-.2.4c-1.2.2-2.3 0-3.5.1m2.8.5c-.3 0-1 .2-1.5.1h-.3a4.2 4.2 0 0 0-1.7.1m-.2.4a1 1 0 0 1 .7 0h2.1l.6.3m-3.9 0h1.6l2 .4m-4 0c.5 0 1 0 1.6.2l2.1.1m-4.4 0c.7.3 1.5 0 2.2.2l2.1.2m-4.8.2c1.1 0 2.2 0 3.4.2.3 0 .8.2 1.2.1m-5 .2c1.1.2 2.2 0 3.3.3l1.5.2m-5.2.3l.3-.1h2.6c.7 0 1.5 0 2.2.2m-5.5.5c1.7-.2 3.5 0 5.2 0m-5.5.5c1.8.2 3.7 0 5.5.1m-5.8.4c.8.2 1.6 0 2.4.1.6.1 1.1.2 1.7.1h1.5m7.4-7.6h.2m-.4.2h.2m-.4.3h.4m-.5.2h.4m-.8.3l.8.1m-1 .4l1-.1h-.1m-1.3.5h1.3m-1.6.4h1.4m-1.6.4h1.6m-2 .5l1 .2c.3.1.6 0 .8 0m-1.8.2l1.6.2m-2 .2c.5 0 1 0 1.4.2h.6m-2.5.4c.5-.2 1.2 0 1.8.1h.6m-2.5.4c.6-.2 1.3-.2 2 0h.3m-2.7.5c.8.1 1.7-.1 2.6.1m-2.9.2c.7.3 1.5 0 2.2.2.3.1.5.1.8 0m-3.5.4c.3-.1.7-.2 1-.1.8.2 1.6.1 2.3.2m-3.6.4c.1 0 .3.1.4 0h3.2m-4 .4c1 .3 1.8 0 2.7.3h1.2m-4.1.3c1.3 0 2.5 0 4 .2m3.3-7.5h.3m-.5.3h.5m-.6.4h.6m-.8.5h.8m-1 .5l1-.1m-1.1.4h1m-1.2.6h1.3m-1.3.4h1.4m-1.6.6h1.5m-1.7.5c.2 0 .4-.2.6-.1h1m-1.7.6c.6-.2 1.2.2 1.8-.2m-2 .8h2m-2 .5c.6-.2 1.4 0 2 0m-2.5.5l2.8-.2m-2.7.7c1-.2 2 0 3.1-.1m-3.3.7c1 .1 1.3 0 2.3-.1l1.2-.2h.6m-4 .6c1.5-.2 3 .1 4.6-.3m-11.3 0h1.2m4.7.3c.2 0 .3-.1.4 0m5.4-.1c1.3-.2 2.5.2 3.8 0m-4.4-.5c.8-.2 1.5 0 2.3.1l.1.2h2m-8.9-.3h-.8m-4.1-.2l-1.7.1m12.1-11.8h.3m-.2.3h.3m-.2.6l.4-.1m-.3.4h.6m0 .4h-.5m.3.6a.8.8 0 0 1 .5-.1m.3.4h-.8m.2.4l.8-.1m.2.6h-.9m.2.6c.4 0 .7 0 1-.2m0 .3l-.9.2m.2.6c.4-.2.9 0 1.2-.2m.1.5h-.9l-.3.1m.2.8c.3-.1.5-.3.8-.3h.6m.2.4l-1.4.2m.1.6l1.6-.3m-1.5 1l1.8-.4m.4.4c-.7.1-1.4 0-2 .3m.2.6s.1.1.2 0a4 4 0 0 1 2-.3m0 .4c-.5.4-1.3.2-2 .3h-.2m.2.5l2.3-.2m.5.5h-1.8c-.3 0-.5.2-.8.3m0 .5h.4c.8-.5 1.6-.4 2.5-.4m.2.5c-.7 0-1.4-.2-2.1 0-.3.1-.5.3-.8.3m.3.5l1-.3h2.4m0 .4c-.4-.1-1-.2-1.3 0-.7.1-1.3.3-2 .3m.4.4c.5 0 1-.3 1.6-.4h1.3m-3 .7c1-.1 1.7 0 2.6-.3h.9m0-.3c1.4.1 2.8-.1 4.1.2m-3.8.3l.4-.1h3.4m-.4-2.9h.2m-.1.4c.1 0 .2-.2.4 0m-.3.4h.7m-.5.6c.2-.3.6 0 .8-.2m-.6.8c.3-.3.7 0 1-.3m-1 .7c.5-.2 1 0 1.4-.3m-1.2.7c.7-.3 1.5.1 2.1-.4m-2 .7c.8-.2 1.7 0 2.6 0m.6 0h4.6m-5.3-.6c1.4.2 3.4 0 5.1.2m-12.6-10.6l1.1-.2m-.8.4l1.2-.1m-.7.6l.8-.2h.4m-.9.4h1.5m.2.3l-1.2.1m.8.5l1-.2m.5.4h-1.2m.6.5l1-.2m.6.5h-1m.5.5l1.2-.1m.4.2l-1 .2m.5.5c.3-.2.9 0 1.3-.2m.4.5h-1l-.4.1m2.6.8l-1.5.1m.5.6c.5-.2 1.1-.2 1.6-.3m-.4 1.7h.8c.8-.2 1-.4 1.7-.3m.5.4l-2.2.2-.4.1m.4.4c.8-.2 2-.1 2.7-.3m.8.5l-2 .1-1 .1m.7.5h.3c.6-.4 1.7-.4 2.6-.4m.5.5h-1.9l-.9.2m.8.5c.8-.2 2.3-.3 1.4-.3h1.9m.2.3a4.3 4.3 0 0 0-1.5 0c-.4.2-.3.3-1.4.3m.4.2l1.2-.1 1.5-.1m-2.4.4h2.7m-16.2-11h.7c0-.2.2 0 .3-.2h.3m-1.7-.2h.8c-.1-.2.2 0 .2-.1h.4m5.5 6c.2-.1.2-.2.6-.1-.1-.2.3 0 .4-.1h.5m0 1.5c.5 0 1.2 0 1.7-.3m.8.6c-.6.1-1.6 0-2.1.3m-8-8.4c-.6 0-.7.2-1.1.2m8 1.6l1-.2m-.7.5c.4-.1.7 0 1-.2m-.7.5l.7-.1h.4m-.7.4h1.2m.3.2a4 4 0 0 0-1.2.2m.4.4l1.3-.2m.5.3l-1.3.1m.4.4c.3 0 1.2 0 1.3-.2m.5.5h-1.2m.4.4l1.3-.1m.4.2c-.2.2-.9.2-1.1.3m.6.4c.3-.2.8 0 1.2-.2m.4.4h-1c0 .1-.1.2-.3.1m2.4.8l-1.4.1m.5.5c.4-.2 1-.2 1.5-.3m-.3 1.7l.6-.1c.8-.1.9-.3 1.6-.3m.4.4l-2 .2-.4.1m.4.3c.7 0 1.8 0 2.5-.2m.7.4l-1.7.1-1 .2m.6.4h.3c.6-.4 1.5-.3 2.4-.3m.5.4H332l-.9.2m.6.4l1.5-.2h1.7m.2.3h-1.4c-.2 0-.3.2-1.5.2m.4.3l1.3-.2h1.4m-2.1.4l1.7-.1h.7m-15-10.1c.3-.1.2-.2.5-.1l.5-.1h.3m-1.7 0c.2-.2.2-.3.6-.2l.4-.1h.4m5.2 5.5c.2-.1 0-.2.4-.1-.1-.2.3 0 .4-.1h.5m0 1.5l1.5-.4m.8.6c-.6.1-1.4 0-1.8.2m-7.5-7.6a2.3 2.3 0 0 0-1.4.5m8.6 2.5l.9-.1m-.7.3l1-.1m-.7.4l.7-.1h.3m-.7.3h1.1m.2.2h-.9m.5.4l.8-.2m.4.3h-1m.3.4l1-.2m.4.4h-1m.4.3l1-.1m.3.2l-.9.2m.3.3l1.1-.1m.3.3h-1m1.9.7l-1.2.1m.4.3l1.2-.2m-.3 1.2h.6l1.2-.2m.3.3l-1.5.2h-.4m.3.3l2-.2m.6.3H336a7.3 7.3 0 0 1-.9.2m.5.4l.6-.2 1.6-.1m.3.3H337l-.9.3m.6.2l1.2-.2h1.3m.2.2h-1c-.3.1-.5.2-1.3.2m.3.2l1-.1 1.1-.1m-1.7.4h1.4l.5-.1m-11.5-7.7c.2 0 .2-.2.5-.2h.6m-1.4 0c.2-.1.2-.2.5-.2h.6m3.8 4.2l.5-.1h.3c0-.1.3 0 .4 0m0 1c.3 0 .8 0 1.1-.2m.6.4c-.4.1-1 0-1.5.2m-5.6-5.9c-.4 0-.5.2-.8.4m7 .9l1-.1m-.7.3l.9-.1m-.6.4l.6-.1h.3m-.6.4l1-.2m.2.2c-.2 0-1 0-1 .2m.4.2s.7-.2.9-.1m.4.2l-1 .1m.3.2l1-.1m.3.3l-1 .1m.4.3l1-.1m.3.1l-1 .2m.4.3l1-.1m.3.3h-1m1.8.6l-1 .1m.2.3l1.3-.2m-.4 1.2l.5-.1c.6 0 .7-.2 1.2-.1m.2.2a12.4 12.4 0 0 1-1.7.2m.2.3a36.3 36.3 0 0 1 1.9-.2m.5.3H342l-.8.2m.4.3l.5-.1 1.5-.2m.4.3h-1.2l-1 .2m.6.3l1.2-.2h1.2m.2.2a3 3 0 0 0-1 0 3 3 0 0 1-1.2.2m.3.1l1-.1h1m-1.7.3h1.3l.5-.1m-10.6-7.1l.4-.1h.6m-1.3-.1c.2 0 .2-.2.4-.1h.4l.2-.1m3.6 3.9h.4c0-.2.2 0 .3-.1h.3m0 1c.3 0 .8 0 1.1-.2m.6.4l-1.5.1m-5-5.4c-.5 0-.6.2-.9.3"
    />
    <g fill="#fc0">
      <path d="M287.6 298.6l.6 4.5c-1.1-.4-2.2.2-2.7 1.2-.9 1.7-.1 3 1.5 3.7l2.1 1.2 4-7.8-1.6-.8-1.6 3.1-.4-4.1-1.9-1zm.6 5.9l.9.3h.1l-1 2.2-.3-.1c-.7-.4-1.2-.9-.8-1.7.3-.6.7-.8 1.1-.7z" />
      <path
        fillRule="evenodd"
        d="M280.7 302.7l1-1.6-2.3-1.6.8-1.2 2.3 1.6 1.4-2-2.5-1.6.9-1.3 3.8 2.7-4.8 7.2-3.9-2.6.8-1.2z"
      />
      <path d="M279 292.5l-2 2.5-.7-.6c-1.4-1.2-2.8-1.2-4 .2-1.3 1.5-.8 2.9.6 4.1l1.9 1.6 5.6-6.7-1.3-1.1zm-4.4 2.8c.3 0 .7.3 1 .6l.3.2-1.6 1.8-.2-.2c-.7-.6-1-1-.4-1.9.4-.4.6-.5 1-.5z" />
      <path
        fillRule="evenodd"
        d="M268.4 294.6l-1.2-1.3 3.6-3.3c.8-.7 1.9-1.8.9-3-1-1-2.3 0-3 .6L265 291l-1.2-1.3 3.9-3.5c1.6-1.4 3.4-1.8 5 0 1.7 1.8 1.1 3.6-.5 5l-3.8 3.5z"
      />
      <path d="M265.1 278.1c-.5 0-1 .1-1.5.5-.8.5-1.4 1.5-.9 2.5-.6-.3-1.3 0-1.9.3-1.4 1-1.4 2.2-.4 3.6l1.3 1.8 7.2-5-1.6-2.2c-.6-.8-1.3-1.4-2.2-1.5zm0 1.9c.5 0 1 .4 1.3.9l.2.3-1.8 1.2-.2-.2c-.4-.6-.9-1.4 0-2l.5-.2zm-2.5 2.5c.3 0 .6.2.8.6l.1.2-1.7 1.2v-.2c-.5-.6-.6-1 .1-1.5l.7-.3z" />
      <path
        fillRule="evenodd"
        d="M264.6 275.3l-7.7 4.2-.8-1.6 6.3-3.4-1.1-2.2 1.2-.7zm-11.4-3.5l8-3.5.6 1.6-8 3.5zm-1-9.5a2.7 2.7 0 0 0-.3 2.2c.6 1.5 2.3 2 3.7 1.5 1.4-.4 2.5-1.8 2-3.4a2.8 2.8 0 0 0-1.5-1.6l1.9-.6c.5.5 1 1 1.1 1.8a4.5 4.5 0 0 1-2.9 5.6c-2.4.7-5-.3-5.8-2.8a4.7 4.7 0 0 1-.2-2.1l2-.6z"
      />
      <path d="M256.4 250.6l-8.2 5 .2 1.3 9.4 2-.3-1.9-2-.4-.5-3.1 1.7-1-.3-1.9zm-2.7 3.6l.4 2.1-3.3-.4 2.9-1.7zm-2-19.9c-2.2 0-4 1.6-4.2 4l-.2 2.6 8.7.7.2-2.5a4.3 4.3 0 0 0-4-4.8h-.4zm-.3 2a3 3 0 0 1 .6 0c1.6.1 2.6 1 2.4 3v.2l-5.2-.4v-.3c.1-1.6.9-2.4 2.2-2.5z" />
      <path
        fillRule="evenodd"
        d="M250.2 229.5l1.9.4.6-2.8 1.4.3-.6 2.8 2.3.5.6-2.9 1.5.3-1 4.6-8.5-1.8 1-4.6 1.4.3zm3.3-11.4l1.8.6 1-2.6 1.4.6-1 2.6 2.2.8 1-2.7 1.4.5-1.7 4.4-8.1-3.1 1.7-4.4 1.4.5zm8.9-2.3l-7.8-4 .8-1.5 6.4 3.3 1.2-2.2 1.3.6zm1.9-15.9c-.6 0-1 .2-1.4.7a1 1 0 0 0 0 1.5c1.3.8 3-2.4 5.3-.7 1.4 1 1.7 2.7.6 4.2-.8 1-1.9 1.3-3 1.2l-.2-1.6c.7.3 1.5.1 2-.5.4-.6.2-1.3-.4-1.7-.7-.5-1.4 0-2 .4-1 .7-2 1-3.1.2a2.6 2.6 0 0 1-.6-3.6 3.9 3.9 0 0 1 2.3-1.5l.5 1.4z"
      />
      <path d="M268.1 192.3l-1 1 4 8.7 1.3-1.4-.7-1.7 2.1-2.3 1.8.8 1.3-1.4-8.7-3.8zm1.4 2.4l2.8 1.3-1.4 1.4-1.4-2.7z" />
      <path
        fillRule="evenodd"
        d="M278.3 195l-5.5-6.8 1.4-1.1 4.5 5.6 2-1.6 1 1.2zm4.5-14l1.6-1 1.8 9.5-.8.5-7.8-5.7 1.6-1 5 3.8z"
      />
      <path d="M290.6 176.8l-1.3.6.5 9.6 1.7-.7v-2l2.8-1.4 1.4 1.4 1.7-.7-6.8-6.8zm.3 2.9l2.2 2.2-1.8.8-.3-3zm9.4-6l-1.4.3-2.4.7 2.5 8.3 2.4-.6a4.3 4.3 0 0 0 3-5.5c-.6-1.9-2.1-3.1-4-3.1zm0 1.9c1 0 1.8.7 2.2 2 .4 1.4 0 2.7-2 3.2l-.2.1-1.5-5 .3-.1 1.2-.2zm10.5-4.3h-.5a4.4 4.4 0 0 0-3.8 5.1 4.4 4.4 0 0 0 5 4 4.5 4.5 0 0 0 3.9-5.1 4.5 4.5 0 0 0-4.6-4zm-.2 1.9c1.4-.2 2.5 1 2.7 2.3.2 1.1-.7 2.8-2 3-1.4.1-2.6-1.2-2.8-2.4-.1-1.3.7-2.7 2.1-2.9zm7.4-2.4v8.8h1.7V176l2.2 3.5h2.1l-2.5-3.7c1.2-.1 1.9-1.2 1.9-2.4 0-1.8-1.2-2.6-3-2.6H318zm1.8 1.6h.3c.8 0 1.5.2 1.4 1.2 0 1-.6 1.2-1.5 1.2h-.2v-2.4z" />
      <path
        fillRule="evenodd"
        d="M336.6 174.3l-.5 2 2.7.6-.3 1.4-2.8-.7-.5 2.3 2.8.8-.4 1.4-4.5-1.2 2.1-8.4 4.5 1.1-.3 1.5zm6.6 0l1.2.5 2.1 7.5 2.2-5.5 1.7.7-3.3 8.3-1.2-.5-2.2-7.5-2.2 5.5-1.6-.6zm9.3 14.3l4.7-7.4 1.5 1-3.9 6 2.1 1.4-.8 1.2z"
      />
      <path d="M365.4 186.6l-8.4 4.7 1.4 1.2 1.8-1 2.4 2-.6 2 1.5 1.1 3-9.1-1.1-.9zm-1.3 2.5l-1 3-1.6-1.3 2.6-1.7zm14.3 11.2l-9.2 2.3 1 1.5 2-.4 1.8 2.5-1 1.7 1 1.5 5.3-8-.9-1.2zm-1.8 2l-1.8 2.6-1.1-1.6 2.9-1z" />
      <path
        fillRule="evenodd"
        d="M375.4 211.9l-.8-1.6 8.7-2.7.6 1.1-4.1 4.6 6-.6.6 1.1-7.3 5.3-.9-1.6 4.6-3.1-6 .6-.2-.5 4-4.3zm11.6 8.3l-1.8.6 1 2.7-1.5.5-.9-2.7-2.2.7 1 2.8-1.5.5-1.5-4.5 8.3-2.7 1.5 4.4-1.4.5z"
      />
      <path d="M390.3 225.7l-8.6 1.8.4 1.8 3.4-.8-3 3 .6 2 3-3.2a2.2 2.2 0 0 0 2.7 1.2c1.9-.3 2.4-1.7 2-3.4l-.5-2.4zm-1.1 2.1v.2c.2.9.1 1.6-.8 1.7-1 .3-1.3-.3-1.5-1.2v-.2l2.3-.5z" />
      <path
        fillRule="evenodd"
        d="M392 236l-8.6 1-.2-1.7 8.7-1zm-1.8 9.5a3 3 0 0 0 .8-2c0-1.7-1.5-2.7-3-2.6-1.5 0-3 1-2.9 2.6 0 .8.4 1.5 1 2h-2a4.8 4.8 0 0 1-.6-2 4.5 4.5 0 0 1 4.4-4.5c2.5 0 4.7 1.7 4.8 4.4a4.4 4.4 0 0 1-.5 2h-2z"
      />
      <path d="M383.7 247.1l-.2 1.9 1.8.9-.4 3.1-2 .5-.2 1.8 9.3-2.2.2-1.4-8.5-4.6zm3 3.6l2.7 1.2-3 .7.3-2z" />
      <path
        fillRule="evenodd"
        d="M384 272.1a2.8 2.8 0 0 0 1.6-1.5c.7-1.6-.4-3-1.8-3.6-1.3-.5-3-.1-3.7 1.4a2.8 2.8 0 0 0 .2 2.2l-2-.7a4.9 4.9 0 0 1 .3-2.1 4.5 4.5 0 0 1 5.8-2.5c2.4.9 3.7 3.4 2.8 5.9a4.6 4.6 0 0 1-1.3 1.7l-1.9-.8zm-1.4 4.7l-1.7-.9-1.3 2.5-1.3-.7 1.3-2.5-2-1.1-1.5 2.6-1.3-.7 2.3-4.2 7.6 4.2-2.2 4.1-1.3-.7zm-1.7 6.4l-.7 1-7.7.3 4.7 3.5-1 1.4-7.3-5.2.8-1 7.7-.3-4.8-3.5 1.1-1.4zm-9 8.7l1.2-1.3 1 1-3.7 4-1-1 1.2-1.4-5.2-5 1.2-1.3z"
      />
      <path d="M362.8 290.7l-1.4 1.1 2.3 2.8-4-1.3-1.6 1.4 4.3 1.1c-.8 1-.6 2.2.2 3 1.1 1.5 2.6 1.3 4 .2l1.8-1.6-5.6-6.7zm1.7 5l1.5 1.8-.2.1c-.6.5-1.2.8-1.8 0-.7-.7-.3-1.3.4-1.8l.1-.2zm-7.1-.4l-1.6 1 .3 1.9-2.7 1.6-1.5-1.1-1.6 1 7.7 5.7 1.1-.7-1.7-9.5zm-1 4.5l.8 3h-.1l-2.4-2 1.7-1z" />
      <path
        fillRule="evenodd"
        d="M348.7 300.3l3.8 8-1.6.7-3-6.5-2.4 1-.6-1.3z"
      />
    </g>
  </svg>
	),
	SX: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="scale(.9375)">
      <path fill="#ed2939" fillRule="evenodd" d="M0 0h768v256H341.3L0 0z" />
      <path fill="#002395" fillRule="evenodd" d="M0 512h768V256H341.3L0 512z" />
      <path fill="#fff" fillRule="evenodd" d="M0 0l341.3 256L0 512V0z" />
      <path
        fill="#ff0"
        d="M172.3 193.2l.1-4s-2.1-3.4.4-7c0 0-5.3-2.8-4-7.2 0 0-4.8-1.2-4.5-6.4 0 0-5-.3-5.6-4.7 0 0-5.1.8-7.4-3.4 0 0-5 1-6.4-2.5 0 0-4.9 1.6-7.7-2.5 0 0-5.2 2.1-7.3-1.8-2.1 3.9-7.3 1.8-7.3 1.8-2.8 4.1-7.7 2.4-7.7 2.4-1.4 3.5-6.3 2.5-6.3 2.5-2.3 4.3-7.4 3.4-7.4 3.4-.5 4.4-5.6 4.8-5.6 4.8a6 6 0 0 1-4.4 6.4c1.3 4.3-4 7.1-4 7.1 2.6 3.7.5 7 .5 7l-.1 3.7 84.7.4"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="M377.2 843.1v-3.5s-1.8-3 .4-6c0 0-4.6-2.5-3.5-6.3 0 0-4.2-1-3.9-5.6 0 0-4.5-.3-5-4.1 0 0-4.4.7-6.3-3 0 0-4.4.8-5.6-2.2 0 0-4.3 1.5-6.8-2.1 0 0-4.5 1.8-6.3-1.6-1.9 3.4-6.4 1.6-6.4 1.6-2.4 3.5-6.7 2-6.7 2-1.2 3.1-5.5 2.3-5.5 2.3-2 3.7-6.5 3-6.5 3-.4 3.7-4.9 4-4.9 4a5.1 5.1 0 0 1-3.7 5.6c1 3.8-3.5 6.2-3.5 6.2 2.2 3.2.3 6.2.3 6.2v3.2l73.9.3z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="red"
        d="M170.3 188.2c-13.3-1.3-28.6-4.5-40.4 2.2-8-4.7-19-4.4-28.4-3.5-5.1 1-11.1 1-16.5 1.8l-.8.1c-9.7.7-18.5-2.2-27-6 2.8 15.2 5.7 30.7 7.2 46.6C67.6 253 53.3 272.7 59 296c3.5 11.2 15.8 17.7 27 19a214.7 214.7 0 0 1 32.2 4.5 32 32 0 0 1 5.5 1.9 19.7 19.7 0 0 1 6.6 4.7c6-6.3 15-8.1 23.7-9 15.8-1.9 35.3-.9 45-15.2v-.8c5.3-8 4.6-20 2.3-29-.2-3.1-1-5.9-1.5-8.9-9.6-25.5-1.3-54.2 2.8-80a61 61 0 0 1-16.4 5.5c-4.5.6-9.5.4-14 .1l-2-.5"
      />
      <path
        fill="#80cfe1"
        d="M190.2 261.5c0 1.6.9 3 1.2 4.5 1.9 11.2 3.6 26-7.8 32.9-12.8 8-29.4 4.6-44.1 8.9-3 .8-7 3.5-9 5.4-1.4-.9-2.7-2.2-4.4-3-12.1-6.4-27.9-4.3-41.5-7.8-6.9-2.1-14-7.5-15.8-14.5-4.4-18.4 6.2-34.1 5-52.4-.8-14-3.2-27.3-6.4-40.4 10.7 5 23 5.8 35 3.4A51.6 51.6 0 0 1 130 201c4.6-2 10-2.9 15-3.4 9.3 1 19.4 2.6 29.1 2.6 6.5-.4 12.4-2.2 18-4.7-3.3 21.6-9.8 44.2-1.9 66"
      />
      <path
        fill="#fff"
        d="M171 265.8v-20.4h2.4l-31-20-.1-10.5h3l-15.6-11-15.4 11h3v10.5l-30.9 20h2.5v20.3H171"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M376 906.5v-17.8h2.1l-27-17.5-.1-9h2.6l-13.6-9.8-13.5 9.7h2.6l.1 9.1-27 17.5h2.2v17.7H376z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path fill="#fff" d="M180.6 292.5v6.3H80.5v-6.4h100" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M384.4 929.8v5.5H297v-5.6h87.4z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#fff"
        d="M87.1 292.1v-21.5h4l-.2 21.7.2-21.6-5.8-.1v-4.7l89.4.2v4.5h-5.4v21.8l-.1-21.8h4l.2 21.6"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M302.8 929.4v-18.8h3.5l-.2 19 .2-18.8-5-.2v-4l78 .1v4h-4.8l.1 19-.2-19h3.6l.1 18.8"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M319.6 924.8v-13.1H309v13l10.5.1"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M312 914.4v7.6h4.8v-7.6h-4.9m59 10.4l-.1-13h-10.4v13h10.5"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M363.2 914.5v7.6h4.8v-7.6h-4.8m7.6-11v-13h-10.5v13h10.5z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M363.1 893.2v7.6h4.8v-7.6h-4.8m-43.6 10.3v-13.1H309v13h10.5z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M311.9 893.1v7.6h4.8v-7.6h-4.8m26.6 10.4v-13.1H328v13h10.5"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M330.8 893.1v7.6h4.8v-7.6h-4.8m22.3 10.4v-13l-10.5-.1v13l10.5.1"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M345.4 893.1v7.6h4.9v-7.6h-4.9"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path fill="#fff" d="M147.7 257.8l.2 34.6H113l-.1-34.6h34.7" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M355.7 899.5l.1 30.2h-30.3l-.1-30.2h30.3zm-30.5 8.6h30.6M329 929.7v-21.4m23.1 21.4v-21.3m14.7-21.8l-17-12.4h-19.3l-17 12.4h53.3M332 863.8v7.6h16.2v-7.6H332"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M336.4 865.7v3.8h7.4v-3.8h-7.4M340 855l9 6.4h-17.9l9-6.4"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#fff"
        d="M171.4 202c2.9 0 3.6 12 3.6 18 2.6.8 8.1 4.3 10.6 7.4h-28.2c2.4-3.1 7.9-6.6 10.4-7.3 0-6 .6-18.2 3.6-18"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.2}
        d="M376.3 850.8c2.6 0 3.2 10.5 3.2 15.8 2.2.6 7.1 3.7 9.2 6.4h-24.6c2.1-2.7 7-5.8 9.1-6.4 0-5.3.6-15.8 3.1-15.8m-49.5 49.5h2.2l-.6 1.2s1 1.4 0 3l.6 1h-2.2l.6-1s-1-1.8 0-3l-.6-1.2m4.5 0h2.2l-.6 1.2s1 1.4 0 3l.6 1h-2.2l.6-1s-1-1.8 0-3l-.6-1.2m5 0h2.1l-.6 1.2s1 1.4 0 3l.6 1h-2.1l.5-1s-1-1.8 0-3l-.6-1.2zm5.5 0h2.2l-.7 1.3s1.1 1.3 0 2.9l.6 1h-2.1l.6-1s-1-1.8 0-3l-.6-1.1zm4.9 0h2.2l-.7 1.3s1.1 1.3 0 2.9l.6 1h-2l.5-1s-1-1.8 0-3l-.6-1.1m4.9 0h2.2l-.7 1.2s1.1 1.3 0 2.9l.6 1h-2l.5-1s-1-1.8 0-3l-.6-1.1"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#ff0"
        d="M130.5 336.8c13 0 29-2.7 36.5-6.5l16.5-1.5.4 20.1c-14 7.7-46.2 9.4-53.3 9.3-7.1 0-39.7-1.6-53.8-9.3l.2-20.2 16.5 1.5a98 98 0 0 0 37 6.6"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="M340.7 968.4c11.4 0 25.3-2.3 31.9-5.7l14.3-1.2.3 17.5c-12.1 6.7-40.3 8.2-46.4 8.1-6.2 0-34.7-1.4-47-8.2l.2-17.5 14.4 1.3c6.6 3.4 21 5.7 32.3 5.7"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#ff0"
        d="M34.4 251l14.5 4.6-4.4 23.5-13.7 2.2s-2.3-12.4 3.6-30.3"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="M256.9 893.6l12.6 4-3.8 20.5-12 1.9s-2-10.8 3.2-26.4z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path fill="#7e7e7e" d="M44.5 278.9l-13.7 2.4 8.7-12.4 5 10" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="M265.7 917.9l-12 2 7.6-10.7 4.4 8.7"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#ff0"
        d="M25.7 268l14 1c.3 11.8 1.8 57 55.8 59.5L93.8 345c-65.7.6-70.7-55.5-68-77"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="M249.3 908.4l12.2.8c.3 10.4 1.5 49.8 48.7 52l-1.5 14.4c-57.4.6-61.7-48.4-59.4-67.2zm44.8 70.1l14.4-3.1"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#ff0"
        d="M225.4 251.2l-14.4 4.6 4.6 23.4 13.8 2.2s2.2-12.3-4-30.2"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="M423.5 893.7l-12.6 4 4 20.5 12 2s2-10.8-3.4-26.5z"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path fill="#7e7e7e" d="M215.6 279l13.7 2.5-8.8-12.4-5 9.9" />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="M414.9 918l12 2.1-7.7-10.7-4.3 8.6"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#ff0"
        d="M234.3 268.1l-14 1c-.2 11.8-1.3 57-55.3 59.5l2 16.4c65.7.8 70.2-55.4 67.4-76.9"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.3}
        d="M431.2 908.5l-12.2.8c-.2 10.4-1 49.9-48.2 52l1.6 14.3c57.4.7 61.3-48.3 58.8-67zm-44.2 70l-14.4-3"
        transform="matrix(1.1464 0 0 1.1461 -260 -773.1)"
      />
      <path
        fill="#009fc5"
        d="M121.8 346.7c-.4.2-1 .3-1.5.2l-2.6-.1.2-3.3 2.6.2c.5 0 1 .1 1.2.3.5.2.7.7.7 1.4 0 .6-.3 1-.7 1.3m-4.3 5l.2-3.9 3 .2c1 .1 1.8-.2 2.3-.7.5-.4.8-1 .8-1.8a2.5 2.5 0 0 0-.6-2 3.2 3.2 0 0 0-2-.9l-4.4-.3-.6 9.4h1.3m9.4-7.7h3.2l1.1.2c.5.3.7.7.7 1.4 0 .6-.1 1-.5 1.3a2.6 2.6 0 0 1-1.4.3h-3.1V344m0 8.2v-4l3 .1c.5 0 1 0 1.2.2.4.2.7.6.7 1.2v2.3l.2.3h1.6v-.2a.8.8 0 0 1-.4-.5 3.4 3.4 0 0 1-.1-.8v-1.3c0-.6-.2-1-.4-1.2a1.7 1.7 0 0 0-.8-.6c.4-.2.8-.5 1-.8.2-.4.4-.8.4-1.4 0-1-.5-1.8-1.4-2.2a4.7 4.7 0 0 0-1.8-.4h-4.5v9.4h1.3m10-2a4.5 4.5 0 0 1-1-2.6c0-1.3.2-2.3.8-3a3.1 3.1 0 0 1 2.4-1 3 3 0 0 1 2.4.8c.7.6 1 1.5 1.1 2.6a5 5 0 0 1-.6 2.8c-.5.8-1.3 1.3-2.5 1.3s-2-.2-2.7-.9m-1.5-5.9a6 6 0 0 0-.8 3.3c.1 1.4.5 2.6 1.4 3.4a4.6 4.6 0 0 0 3.6 1.3 4.4 4.4 0 0 0 3.5-1.8 6 6 0 0 0 1-3.6 5 5 0 0 0-1.2-3.1c-.9-1-2.2-1.5-3.9-1.4-1.6 0-2.8.7-3.6 1.9m44-13.5c1-.1 1.8-.1 2.5.1 1 .4 1.7 1.1 2.2 2.3l-1.3.2a2.4 2.4 0 0 0-1.2-1.3 3.5 3.5 0 0 0-2-.2 3 3 0 0 0-2 1.3c-.5.7-.7 1.7-.5 3a4.5 4.5 0 0 0 1.2 2.6c.6.6 1.5.8 2.6.7a3.2 3.2 0 0 0 2-1.1c.6-.6.7-1.4.5-2.5l-3 .5-.1-1 4.2-.7.8 5h-.9l-.5-1-1 1c-.5.5-1.2.7-2 .9a4.3 4.3 0 0 1-3.2-.7 5 5 0 0 1-1.9-3.4 5.1 5.1 0 0 1 .7-4 4.1 4.1 0 0 1 3-1.7m9.4-.7l3-1.1c.4-.2.8-.2 1.1-.2.6 0 1 .4 1.2 1 .2.6.2 1.1 0 1.5-.3.3-.7.6-1.3.8l-2.8 1-1.2-3m3 7.7l-1.4-3.7 2.8-1a3 3 0 0 1 1.1-.3c.5.1.9.4 1.2 1l.6 1.4.3.7.2.3 1.5-.6v-.2c-.3 0-.5-.1-.6-.4-.2-.1-.3-.4-.4-.7l-.5-1.2c-.2-.5-.5-.8-.7-1a2.4 2.4 0 0 0-1-.2l.6-1.2c0-.4 0-.9-.2-1.4-.4-1-1-1.6-2-1.6a4.5 4.5 0 0 0-1.9.3l-4.2 1.5 3.4 8.8 1.2-.4m11-4.7l-5.3-7.8 5.8-3.8.7 1-4.8 3 1.6 2.4 4.5-2.8.6.9-4.5 2.8 1.8 2.7 5-3.2.6 1-6 3.8m4.7-13.8l1.5-1.7c.8-.8 1.5-1.1 2.3-1 .9 0 1.7.5 2.6 1.3a4.7 4.7 0 0 1 1.4 2c.2.6.1 1.1 0 1.6a4 4 0 0 1-.7 1l-1.5 1.6-5.6-4.8m8.1 3.6c1.1-1.2 1.3-2.4.7-4a6.7 6.7 0 0 0-1.7-2.1 5.2 5.2 0 0 0-3.1-1.4c-1.2-.1-2.2.3-3.1 1.3l-2.6 2.8 7.2 6.3 2.6-2.8m5.6-7.3l-8.3-5 .7-1 8.3 4.9-.7 1m3.3-5.6l-9-3.6 2.6-6.3 1.1.4-2.1 5.2 2.7 1 2-4.7 1 .4-2 4.8 3 1.2 2.3-5.2 1 .4-2.6 6.4m4-11l-9.4-2 .4-1.5 8.7-3-7.7-1.7.3-1.1 9.4 2-.3 1.4-8.7 3 7.7 1.7-.3 1.2m-.8-12l.1-1.2c.6 0 1 0 1.4-.2.7-.4 1-1.1 1.2-2.1a3.7 3.7 0 0 0-.1-1.4c-.2-.7-.6-1.2-1.3-1.2-.6-.1-1 0-1.2.3-.3.3-.5.8-.7 1.5l-.5 1.2c-.2.8-.5 1.4-.8 1.7-.4.6-1 .8-1.8.7a2.8 2.8 0 0 1-2-1c-.6-.6-.8-1.5-.7-2.6.1-1 .4-1.8 1-2.4.5-.6 1.3-1 2.4-.8l-.1 1.2c-.5 0-1 0-1.2.3-.6.3-.9 1-1 1.9 0 .7 0 1.2.4 1.6.3.4.6.6 1 .6.5 0 .9 0 1.1-.4l.7-1.7.4-1.3c.2-.6.5-1 .8-1.4.5-.5 1.2-.7 2-.7 1.1.1 1.9.6 2.2 1.4.4.8.6 1.6.5 2.7a3.9 3.9 0 0 1-1.2 2.6c-.7.6-1.5.8-2.6.7m-195.6-.6l.3 1.2c-.6.1-1 .3-1.3.6-.5.5-.7 1.3-.5 2.4a4 4 0 0 0 .4 1.2c.4.7 1 1 1.7.9.5-.1.8-.3 1-.7l.3-1.6v-1.3c0-.8.2-1.5.3-1.8.3-.6.9-1 1.7-1.2.8-.1 1.6 0 2.2.6.7.4 1.1 1.2 1.3 2.2a4 4 0 0 1-.3 2.6c-.4.8-1 1.2-2.1 1.4l-.2-1.1a3 3 0 0 0 1-.6c.5-.5.6-1.2.5-2.1-.2-.8-.4-1.3-.8-1.5a1.5 1.5 0 0 0-1.2-.3 1 1 0 0 0-1 .7l-.1 1.8-.1 1.3a3.5 3.5 0 0 1-.4 1.6 2.2 2.2 0 0 1-1.7 1.2c-1 .2-2-.1-2.5-.8a5 5 0 0 1-1.2-2.4 3.8 3.8 0 0 1 .5-2.9 3 3 0 0 1 2.2-1.3m-.6 12.3l9.3-2.8 2.1 6.5-1.1.4-1.8-5.3-2.8.8 1.7 5-1.1.3-1.6-5-3.2 1 1.8 5.4-1 .3-2.3-6.6m4.1 11.3l8.5-4.5 1 1.6-5.9 6.1 8.5-1.4.9 1.5-8.5 4.5-.6-1 5-2.7.9-.4 1.3-.7-8.5 1.5-.6-1.1 5.8-6.2-.3.2-1 .5a7 7 0 0 1-.9.5l-5 2.6-.6-1m15.8 12.5c-.4-.1-.8-.4-1.2-.8l-1.8-1.8 2.4-2.2 1.8 1.8a3 3 0 0 1 .7 1c.2.5 0 1-.5 1.5-.5.4-1 .6-1.4.5m-6.8.8l3-2.7 2 2.1c.8.7 1.5 1 2.2 1a3 3 0 0 0 2-.8 3 3 0 0 0 .8-2c0-.6-.3-1.3-.9-1.9l-3-3-7 6.4 1 1m8.4 7.5l5.1-8 6 3.6-.6 1-5-3-1.5 2.5 4.5 2.7-.5 1-4.6-2.8-1.7 2.7 5 3-.6 1-6.1-3.7m15-1.6l3.1 1 1 .5c.4.4.5.9.2 1.5-.2.6-.4 1-.9 1.1l-1.5-.1-2.9-1 1-3m-2.6 7.9l1.3-3.8 2.8.9c.5.1 1 .3 1.1.5.3.3.4.8.3 1.4l-.5 1.5-.1.7v.3l1.5.5v-.2l-.2-.7.2-.7.4-1.2c.1-.6.2-1 0-1.2 0-.3-.3-.6-.6-.9.5 0 1-.2 1.3-.5.3-.3.6-.7.7-1.2.4-1 .2-1.9-.6-2.5a5.2 5.2 0 0 0-1.6-.9l-4.3-1.3-3 8.9 1.3.4"
      />
      <path
        fill="#bc715f"
        d="M78.5 175.6c1-2.7 11.3-10 44.8-6.8 0 0 5.7 3.5 9 3 2-.2-1 .2-3.6-1.9-2.5-2-3-6.3 2.7-6.1 5.8.1 27.3 1.3 27.7 3.3.4 1.9-11.4 2.7-15.7 2.6-4.4-.1-4 2.1.4 2 13.7-.6 28.6-5.4 44.3 5.8 1.9 1.3-4.7 1.5-9.8-.6 0 0-14 .7-20-.3 0 0-4.5 3.8-10.6 3.4.8 2-2.2 9.2-21 3.7-3.2 1-14.5 2.9-13.3-.5-3 0-8.2 1-9-.7-.8-1.7 9.2-4.2 11-6 0 0-21.2.2-25.2-1.3 0 0-12.5 2.8-11.7.4"
      />
      <path
        fill="#008737"
        d="M85.3 205.2c.4-.6.6-1.8 1.6-1.7 2 .5 3.5 4.4 6 1.9 1-.2 1.3 1 2 1.2.5 2.1 2.3-.5 3.5-.3 2.8-1.2 6.1-1.5 9.4-1 0 2.2-1.6 4.5-3.6 5.7 0 2 2 3.4 1.9 5.5-.3.8 0 2-1.2 2.3-1.6-.3-3-.4-4.3-1.3-.2-.1-.3-.4-.6-.3-.2.7 1 1.4 1.4 2.1-.8 1.3-2 .1-3.1.1-.3.8 0 1.7-.8 2.2-1.3 0-1.6-1.5-2.4-2.2-.9.9.6 1.4.8 2.1-.6 2.8-.5 5.5-3.2 7.3l-1.9.9c-.5-1.4-.2-3.5-.5-5-1 1.8-2 3.4-3.5 4.9-2-.6-3-2.8-3.4-4.7a5.8 5.8 0 0 1 1.3-6.2c-.5-1-2.5-.8-2.8-2.4-3-2-4.5 3.3-6.4.6a8.6 8.6 0 0 1 2-7.6c-.5-1-1.9-.8-2.7-1.4-1.8-1.6-4.5-3.2-4.3-6a14 14 0 0 1 14.7 3.3"
      />
      <path
        fill="#ff0"
        d="M87.9 204.9c-.1 2.3 1.5.6 2.8 2-1-.4-1.7 1.7-2.7.5l-.6.6c.4.8 1 .9.4 1.8-1 .4-1.3-1-1.8-1.5 0-.2.2-.6-.2-.8-.6.5-1.2.7-2 .6-.2-.4-.7-1-.2-1.4.8-1 2 .4 2.6-.3.1-.7-.5-1.5.3-2 .5.1 1.2-.2 1.4.5m6.2 1.9c.1.4-.2 1 .4 1.4.8-.4 1.6-.1 2 .6 0 .4.1 1-.4 1.2l-1.2-.3c.1-.2-.3-.3-.4-.6-.5-.1-.9.3-1.2.6.3.4 1 .7.8 1.2-.7.7-1-.6-1.8-.2-.6-.2.1-1.3-.7-1.7-1 0-.3 1.6-1.6 1-.4-.5-.8-1.2-.4-1.7a1.6 1.6 0 0 1 1.9.2c.8-.9.8-4.1 2.7-1.7m-7.8 3.3c.5.8-.2 1.8.5 2.6 1-2 2 .4 3.2.2.4.5.1 1.1.2 1.6-1.5.4-3.3.9-4.6-.3l-.4.4c.8.7 1.5 1.6.9 2.8-1.1.2-2.9.3-3.4-.9-.3-1 .7-1.6-.4-2.4-.7 1-.7 2.2-2.2 1.3a1.9 1.9 0 0 1-.8-2.5c1-1.6 2.8 0 3.8-.7.2-1.4-.3-2.6 1-3.3 1-.2 1.5.6 2.2 1.2"
      />
      <path
        fill="#fff"
        d="M90.6 211c-.5 2.3-2.2-.1-3-.2 1-2 1.7.6 3 .2m5.4 2.5c-1.2.3-1-1.2-1.6-1.8l.5-.4c.4.5.7 1.5 1.1 2.2"
      />
      <path
        fill="#ff0"
        d="M94.4 213c.3.8-.8 1.5.2 2l.8-.7c.9.2 1.8.4 2.4 1.2.6 1.7-1.1 1.7-2 2.2h-1c.2-.6-.5-.8-.6-1a1 1 0 0 0-1.1.3c.2 1 1.5 2 .2 2.9-1.2 0-3 .4-2.9-1.2-.4-1 1.2-2.3-.5-2.4-.6 1.3-1.2 2.4-2.7 1.3l.2-1.8c1.4 0 3.1.3 3.7-1.3.4-1.1-.7-2.2.3-3 1.5-.4 2.3.6 3 1.5"
      />
      <path d="M93.4 215.6c.3.9-.6 1-1.1 1.4-.6 0-1-.2-1.4-.6-.3-1 .5-1.2 1-1.6.7-.3 1 .5 1.5.8" />
      <path fill="#fff" d="M92.5 216.2c-.1.2-.4.1-.6.2l-.2-1c.5 0 1 .1.8.8" />
    </g>
  </svg>
	),
	SY: () => (
  <svg viewBox="0 0 640 480">
    <rect
      width={640}
      height={160}
      y={160}
      fill="#fff"
      fillRule="evenodd"
      rx={0}
      ry={0}
    />
    <rect width={640} height={160} y={320} fillRule="evenodd" rx={0} ry={0} />
    <path fill="red" fillRule="evenodd" d="M0 0h640v160H0z" />
    <path
      fill="#090"
      fillRule="evenodd"
      d="M201.9 281l-28.8-20.9-28.7 21.1 10.7-34.2-28.7-21.2 35.4-.3 11-34.1 11.3 34h35.4L191 246.9l10.9 34.2zm307.6 0l-28.8-20.9-28.7 21.1 10.7-34.2-28.6-21.2 35.4-.3 11-34.1 11.2 34h35.4l-28.5 21.4 11 34.2z"
    />
  </svg>
	),
	SZ: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-85.3 0h682.6v512H-85.3z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="translate(80) scale(.9375)">
      <path fill="#3e5eb9" fillRule="evenodd" d="M-128 0h768v512h-768z" />
      <path fill="#ffd900" fillRule="evenodd" d="M-128 91.4h768v329.2h-768z" />
      <path fill="#b10c0c" fillRule="evenodd" d="M-128 128h768v256h-768z" />
      <rect
        width={621.7}
        height={11}
        x={-51.4}
        y={250.5}
        fill="#ffd900"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={1.5}
        rx={5.8}
        ry={5.8}
      />
      <g stroke="#000" transform="translate(-757 -25.6) scale(1.0321)">
        <path
          fill="#fff"
          fillRule="evenodd"
          strokeWidth={4.2}
          d="M-106.3 265.8l-88.6 35.4 88.6 35.4 88.6-35.4-88.6-35.4z"
          transform="matrix(.34 0 0 .3 1256.8 136.4)"
        />
        <rect
          width={442.9}
          height={7.1}
          x={761.8}
          y={223.2}
          fill="#ffd900"
          fillRule="evenodd"
          strokeWidth={1.3}
          rx={4.1}
          ry={3.8}
        />
        <path
          fill="none"
          strokeWidth={2.7}
          d="M1224.4 280c-3.5 0-7-3.6-7-7.2s3.5-7 7-7"
          transform="matrix(-.50001 0 0 .5 1806.3 90.3)"
        />
        <path
          fill="none"
          strokeWidth={2.7}
          d="M1224.4 280c-3.5 0-7-3.6-7-7.2s3.5-7 7-7"
          transform="matrix(-.50001 0 0 .5 1802.8 90.3)"
        />
        <path
          fill="none"
          strokeWidth={2.7}
          d="M1224.4 280c-3.5 0-7-3.6-7-7.2s3.5-7 7-7"
          transform="matrix(-.50001 0 0 .5 1799.2 90.4)"
        />
      </g>
      <g stroke="#000" transform="translate(-786.3 -3.7) scale(1.0321)">
        <path
          fill="#fff"
          fillRule="evenodd"
          strokeWidth={4.2}
          d="M-106.3 265.8l-88.6 35.4 88.6 35.4 88.6-35.4-88.6-35.4z"
          transform="matrix(.34 0 0 .3 1256.8 136.4)"
        />
        <rect
          width={442.9}
          height={7.1}
          x={761.8}
          y={223.2}
          fill="#ffd900"
          fillRule="evenodd"
          strokeWidth={1.3}
          rx={4.1}
          ry={3.8}
        />
        <path
          fill="none"
          strokeWidth={2.7}
          d="M1224.4 280c-3.5 0-7-3.6-7-7.2s3.5-7 7-7"
          transform="matrix(-.50001 0 0 .5 1806.3 90.3)"
        />
        <path
          fill="none"
          strokeWidth={2.7}
          d="M1224.4 280c-3.5 0-7-3.6-7-7.2s3.5-7 7-7"
          transform="matrix(-.50001 0 0 .5 1802.8 90.3)"
        />
        <path
          fill="none"
          strokeWidth={2.7}
          d="M1224.4 280c-3.5 0-7-3.6-7-7.2s3.5-7 7-7"
          transform="matrix(-.50001 0 0 .5 1799.2 90.4)"
        />
      </g>
      <g fillRule="evenodd">
        <path
          fill="#3d5da7"
          stroke="#000"
          strokeWidth={1.4}
          d="M338-.4c-5.5 12.4 4.3-4.1 28.4 16.7 4.4 3.8 8.3 14 8.3 21.1-1.1-1-2-3-3.2-4.5-1.8 2.3 1.7 12.6 2.2 17.5-3.8-2.7-3.4-4-4.7-7.4.3 4-.6 15.2.9 19.4-3-1-2.8-4.1-4.3-4.8 1 4.9-1 10.1-.4 15.6-1.8-2.2-3.6-4-4.4-4.9-.1 2.6-3.3 9.4-3.4 11.9-1.5-1.2-1.9-3-2.1-4.2-1.8 3-8.3 14-8.7 17.2-5-5.7-17.8-19.5-19.5-26.9-1.5 4.2-3.6 5.6-7.8 8.7-1.7-11.7-8-24.8-4.6-34.8a84.4 84.4 0 0 0-6.6 5.9A67.9 67.9 0 0 1 338-.4z"
          transform="matrix(.9944 0 0 .77118 190.4 252)"
        />
        <path
          fill="#a70000"
          d="M505.9 299.2c2.3-4.6 4.4-6 5.9-9 2.6-5.2 3-9.4 5.3-8.8 2.3.6 2.3 2.8-.7 7.9-3 5-4.4 6.2-10.5 9.9zm15.5 11c-.3-3.6.8-5 .6-7.3-.3-4-2-6.7.1-6.9 2.1-.2 3.1 1.2 3.1 5.2s-.6 5-3.8 9zm11.8 6.8c-.9-5-.2-7-.8-10.2-1-5.6-3-9.2-1-9.7 1.9-.5 3 1.3 3.8 6.9.7 5.6.3 7.2-2 13zm12.3-34.3c-2.9-2.1-4.6-2.3-6.4-3.7-3.3-2.5-5-5.1-6-3.8-1 1.3-.3 2.7 3.1 5 3.5 2.3 4.6 2.5 9.3 2.5zm-2 16.3c-1.5-3.2-3.1-4-4.1-6-1.8-3.6-1.8-6.7-3.6-5.9-2 .8-2 2.4 0 5.9 2 3.4 3 4 7.7 6z"
        />
      </g>
      <g fillRule="evenodd">
        <path
          fill="#3d5da7"
          stroke="#000"
          strokeWidth={1.4}
          d="M329.6 20.7c-.3-2.7.3-3-1.3-5 2.2 1 2.3 3.7 5 1.8 1-.6 1.4-.6.2-3.5 2.8 0 12 3.5 13.4 3.6 3.9.2 10.9-4.4 15.7 1.2 4.7 5.1 3.1 10.4 3.1 17.5-1.8-1-1-1.4-3-4 1.6 6.2 0 17.4 0 24-.8-1.6-.7-1-1.4-2.6-2 6-4.4 7.3-4.4 14.3-.7-2.7 0-2.2-.8-3.6-2 4.5-15 8.4-10 13-4.4-2.8-6.4-2.5-8.5-5.1-.9.6-1.6 1.8-2.4 3.4-8-4-5-12.5-11.3-18.2-1 2.4-.6 2-1.8 5.9-1.2-5.4-1.6-8.9-3-12.8-1.2 2.2-1 1.3-3.3 4.7-1-6.6-2.4-8.2-1.8-12.5-2.4 1.8-.8 1-3.2 3.3 2.2-17 11.9-29.4 18.8-25.4z"
          transform="matrix(1.1372 0 0 1.0495 -399.4 239.2)"
        />
        <path
          fill="#a70000"
          d="M-35.7 289.8c2.3-5.7 4.4-7.5 6-11.2 2.6-6.4 3-11.6 5.2-10.8 2.3.8 2.2 3.4-.8 9.8a25 25 0 0 1-10.4 12.2zm8.8 14.3c1-5.1 2.4-7 3-10.3 1-5.8.5-10.1 2.6-9.9 2 .3 2.5 2.4 1.1 8.2-1.4 5.8-2.3 7.1-6.7 12zm10.5 9.9c.3-5 1.5-6.9 1.6-10 .3-5.7-.7-9.7 1.2-9.7 2 0 2.7 2 2.1 7.6-.6 5.6-1.3 7-4.9 12zm22.7-32.4c-4.4-4.3-7-5.1-9.8-8-4.9-4.8-7.3-9.4-9-7.7-1.8 1.6-.7 4 4.5 8.7 5.2 4.6 7 5.2 14.3 7zm-2.7 16.6C.8 294-1.2 292.8-3 290c-3.2-4.9-4.3-9.1-6-8-2 1-1.5 3.2 2 8 3.4 4.7 4.8 5.5 10.7 8.2z"
        />
      </g>
      <g fillRule="evenodd">
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth={2.1}
          d="M637.8 230.3c-53.1 59-124 177.2-265.8 177.2-124 0-212.6-118.1-265.7-177.2C159.4 171.3 248 53.2 372 53.2c141.8 0 212.6 118 265.8 177.1z"
          transform="matrix(.68807 0 0 .61926 0 113.4)"
        />
        <path d="M243.2 184.4c9.8 11 1.6 15.4 12 16.1 10.8.8 4.6 11.6 13.8 12 6.4.2-.7 25.7 5.5 34.2 6.3 8.7 11.5 2.5 11.6 8.9.1 6.5-17 5.9-17.3 26-.5 11.7-14.5 12.5-15.2 20-.8 7 27.5 11 27.2 17.3-.4 6.3-30.7 5.3-32 12.4-.6 6.5 41.6 11.8 45 30.4-6.3 2-24.3 4-37.8 4-85.3 0-146.3-73.1-182.9-109.7 36.6-36.6 97.6-109.7 182.9-109.7 0 0-25.3 23.1-12.8 38.2z" />
        <path
          fill="#fff"
          d="M141.4 217h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zm17.7-48.8h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zM177 217h8.8v29.2H177zm0 48.8h8.8V295H177zm17.7-48.8h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zm17.7-48.8h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zm17.8-48.8h8.8v29.2h-8.8zm0 48.8h8.8V295h-8.8z"
        />
        <path d="M275.5 217h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zm17.7-48.8h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zM311 217h8.8v29.2H311zm0 48.8h8.8V295H311zm17.7-48.8h8.9v29.2h-9zm0 48.8h8.9V295h-9zm17.7-48.8h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zm17.8-48.8h8.8v29.2h-8.8zm0 48.8h8.8V295h-8.8z" />
      </g>
      <g fillRule="evenodd">
        <path
          fill="#3d5da7"
          stroke="#000"
          strokeWidth={1.4}
          d="M338-.4c-5.5 12.4 9.8-4.1 33.8 16.7a51.2 51.2 0 0 1 10.9 26.2c-5.1-1.2-14.2-7-14.2-7s10.6 12.2 10.6 26.4c-3.7-2.7-5.6-2.3-6.8-5.6 0 4.5 3.3 7.5 3.3 14.6a49.8 49.8 0 0 0-7.3-5.7c3.5 7.1-6.5 20.9-1.5 25.5-8.7-1.5-17.7-8-21.2-15-1.9 1.4-2 3.7-2.2 6.2.3.2-13.3-11.7-12-16.3-1.9 3-2.1 4.6-2.5 8a44 44 0 0 1-11.3-18.8l-4.6 6.7c-1.6-11.7-1.6-11.3 1.7-21.3a84.4 84.4 0 0 0-6.6 5.9A67.8 67.8 0 0 1 338-.4z"
          transform="matrix(.9094 0 0 .78749 -110.6 166.1)"
        />
        <path
          fill="#a70000"
          d="M184.4 213.6c.8-6.7 2.5-9.3 3-13.6 1-7.7-.1-13.2 2.6-13.1 2.7.1 3.5 3 2.2 10.6-1.4 7.6-2.5 9.5-7.8 16.1zm14.1 12.4c-.5-5.7.5-8.1.2-11.8-.6-6.4-2.6-10.8-.3-11.2 2.4-.4 3.6 1.7 3.8 8.3.3 6.5-.3 8.2-3.7 14.7zm22.1 10c-2.4-4.8-4.5-6.3-6-9.5-2.8-5.6-3.3-10.1-5.4-9.3-2.2.8-2 3.2 1 8.7 3 5.4 4.5 6.5 10.4 10.2zm7.6-44c-6-3.3-9.2-3.3-13.2-5.4-6.9-3.6-11-7.7-12.4-5.5-1.4 2.3.5 4.5 7.7 7.8 7.1 3.3 9.3 3.5 18 3zm2.3 18.4c-4.5-3.7-7.1-4.3-10-6.7-5-4.1-7.6-8.2-9.3-6.6-1.6 1.7-.5 3.9 4.8 7.8 5.3 4 7.1 4.5 14.5 5.5z"
        />
      </g>
    </g>
  </svg>
	),
	TA: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#006" d="M640 480V0H0v480h640z" />
    <path
      fill="#fff"
      d="M0 73.3h76L0 26.8V0h43.5l106.4 64.8V0h59.9v64.8L316 0h44v26.8l-76.4 46.5H360v73.4h-76.4l76.4 46.6V220h-44l-106.4-64.7V220H150v-64.7L43.4 220H0v-26.7l76-46.6H0V73.3z"
    />
    <path
      fill="#ce1126"
      d="M331.7 0L211.5 73.4h28.8L360 0h-28.3zM360 220l-119.8-73.3H269l90.9 55.9V220zM120.4 73.4L0 0v17.5l91.4 55.9h29zm-.3 73.3L0 220h28.7L149 146.7h-29z"
    />
    <path
      fill="#ce1126"
      d="M0 88.6h162.6V0h35.2v88.6H360v43H197.8V220h-35.2v-88.5H0v-43z"
    />
    <path
      fill="#8fc5ff"
      stroke="#fff"
      strokeWidth={1.1}
      d="M399.7 640.8c0 16.3-2.6 33.9-23.8 42.3-21.1-8.4-23.7-26-23.8-42.3h47.6z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#366cc9"
      stroke="#000"
      strokeWidth={1.1}
      d="M375.9 683a34.3 34.3 0 0 0 18.8-16h-2c-.6-.1-20.3-2-22.7-3-2-.7-9.8.7-13.4 2a34 34 0 0 0 19.3 17z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#5d3100"
      stroke="#000"
      strokeWidth={0.1}
      d="M361.1 673h1.2c.3 0 .3 0 .4-.3s.4-.2.6-.1.6 0 .8-.2c.2-.2.2-.2.4 0s.3.1.5 0c.1 0 .5-.2.6-.5s.4-.4.5-.2.3.2.5.2.2.1.2.4c0 .2 0 .3.5-.1.4.4.5.2.5-.2s0-2-.2-2.1-.3-.8-.4-1.3c0-1 0-1-1-1.5 0-.3-.2-.4-1-.4.1-.1 0-.4-.2-.5s-.2-.2 0-.6c.2 0 .6 0 .7-.3.2-.2.8-.2 1.2 0s.8.2 1.5 0l1.2-.6c.5-.3.6-.4.6-.8 0-1-.3-2-.5-2.5-.3-.5-.3-1-.7-1.9-.4-.8-.4-1-.8-1.5-.2-.2-.3-.3-.3-.6a1.5 1.5 0 0 0-.5-1c-.8-.7-1-3-1.4-4.7-.2-1 0-3.3-.4-3.7-.7-.5-1-.4-1.5-.6-.4-.5-.5-1.4-.9-2.3-.5.1-.8.6-1.1.8s-.4.2-.4.7c0 .4-.3 1-.7 1.8s-1.3.5-2 1.6c-1.4-1.7-1.4-2.2-1.5-2.7 0-.5-.3-.6-1.1-1.3v-1.5c-.7-.5-1.1-.4-1.4 0-.3.3-.5.8-1 1-.2.4-1 1.2-1.6 2.3.6 9 2.6 18 8.7 25.2z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#ff0"
      stroke="#fff"
      strokeWidth={1.1}
      d="M399.7 640.8c0-6.2-.3-12.2-.2-17.4a63.6 63.6 0 0 0-23.6-4.3c-5.3 0-15.7.8-23.6 4.3.2 5.2-.2 11.2-.2 17.4h47.6z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#cf6200"
      d="M394.6 297.9c1.2 1.9 3.3 5 3.5 6.8.8-1.7 1.5-2.4 1.6-3.5s1.5-3 1-4.2-.8-2 .4-1.2c1.3.9 1 2.3.8 4.4-.8 5.7-3.1 6.8-3.5 10.7 3.4 8 .9 11 4.6 19 .6.3 2.1-.3 2.6-.2 2-1.4 3.5-1 6.3-.3 2.8.5 4.3 2.5 4.3 4.3s0 2.2.6 3.2 1.7 2.7 1.5 3.9c-.3 1.2.2 1.9.6 2.4s-.2 2-.5 2.7-.2 1.9 1.2 3.6c1.4 1.8 4.6 9.1 4.6 13.4 0 4.4.3 6.4 2 7.2 1.8.8 2.3 1.5 2.1 3.3s.8 11.6 1 13.1.9 1.2 1.6 2c.7.8 1.1 1.7 3.5 1.7s4.6-.3 6 0c2.2 2.9 3.5 6.8 4 9.3s.4 5.8 1.2 5.8 1.6 0 1.4-3-.5-3.4-1.5-5c-1.1-1.5-1.7-2.2-1.1-3.1s.7-2.4.5-3.6-.6-3 1.4-.6l3.1 3.7c.6.7.8 2.4.7 3.8-.1 1.4.1 2 1 1.2.8-.7 1.8.5 1.3 2s.2 2.5 1.6 3 2 .8 2.3 1.8 1.5 1.5 1.5-.6c0-2-.8-6.5-1.4-7.9-.6-1.4-1-4.4-1.2-6.2s-.4-2.2-1.2-2.5-1.6-1-1.7-1.8-.8-1.1-1.3-1.1-1-.4-1.3-1-.6-.6-1.2-.7-1.5.3-1.8-.6-.7-2.3-1.3-3-1-1-1.1-3.7c0-2.6-.1-3-1-3.9s-2.2-3.4-2.8-4.4c-.5-1-1.1-2.1-1.1.1s0 3.4 1.4 4.2c1.4.8 1.7.8 1.1 2s0 2 .3 2.8.7 1.6 0 2.4c-.7.8-1.4.6-1.3-.7a7.3 7.3 0 0 0-1-3.8c-.5-1-1-1.8-1.7-1.2s-1.3-.1-.8-.6.3-.8 0-1.1-.5-.7.1-1.4.6-1 .2-2.7c-.3-1.6-2.9-9.8-4-11.7s-1-3.2.4-1.4 2.8 3.5 3 5c0 1.6.4 2.5.9 3s.8.4 1-.9 1.2-.8-.4-3.2c-1.7-2.5-4.7-6.6-5.9-14s-1.6-12.1-2.8-14.1c-1.1-2-1.5-2.5-1.6-4.3s0-3.8-.8-5.2c-.8-1.4-1.4-1.6-1.5.5-.1 2 0 6.8.7 7.6s.2 2.9 0 4-1.9 2.4 2 4.7c1.5 1 1.2 2.2 1 3-.2.9-.5.8-1.3-.5s-1.6-2.4-2.4-3-1-1.2-.8-2.9.4-2.8 0-3.3c-.5-.6-.7-.2-1 .8-.2.9-.4 3.5-1 4.2s-.6.2-1-1.3.2-3.9 1-6.5 1.3-5.5.6-9c-.7-3.5-.4-4.6-3-7.5-2.7-2.9-5.8-5.7-7-9.3-1.3-3.6-1.6-6.8-3-8.4a19.4 19.4 0 0 0-4.6-4.3v-5.4c0-1.3-.6-2-2.1-1.8s-2.5 1.5-3.4 3.2c-1 1.8-1.6 1-3 4s-3 4.5-3 7.8z"
    />
    <path
      fill="#cf6200"
      d="M403 332c1 .7 1.9 1 3.3.3s3-2.7 5-.7c1.8 2 2.8 5.3 2.8 7.8 0 2.6 0 7.4 3 10 2.9 2.7 4.4 5.5 4.5 9a61 61 0 0 0 1.7 10.3c.4 1.4 1.2 3 2.1 4s1.7 3.6 1.8 6.4c.1 2.8-.4 4.7 0 6.1s0 2.6-1 2-1.3-1.1-2-2.3-1.2-1-.6.8 2.3 3.4 3.8 3.4 2 .2 3 1.2c.9.9 1 1.4 2.6 1.4s1.9 0 3.4.4 1.5.3 2.3 0 1.7.5 2.2 2 2 5.7 2 6.9 0 2.3.8 3.5.6 2.3-.3 1.6-1-.5-1.6-.3-1.2-.3-2.1-.9c-1-.5-.4-.4-1.3-1.8s-1.5-1.9-1.5-.8-.2 2.3-.9 1.7-1-.6-1.6 0-.8 1-1.5-.1-1.5-1.2-2.2-1.4-.7-.2-1-1.3c-.4-1-1.5-1.3-2.4-1.3s-1.4-.4-1.5-1.1c-.1-.7-.7-1.2-1.2-1.5s-.2-1.2-.3-2-.8-.5-1.3-.7-.8-.1-.8-1.3-.5-1.5-.8-2.3c-.4-.9 0-1.7.2-2.6.2-1 .1-1.5-.6-2.3-.7-.8-.1-1.7-2-3.3s-2.8-.2-3.4-4c-.5-4-1.7-11.9-2.8-13.1s-1.7-2.3-2.8-2.6-1.7-.1-1.8-2.3c-.1-2.2-.8-5-2.2-6.4l-2.7-2.5c-.7-.5-1-1.6 0-3.6s.6-4.7.5-6c-.2-1.2-.5-2.9-.3-4.3s.1-3.1-.2-4-.8-1.2-.2-2zm28.1-33a25.4 25.4 0 0 1-5.4 5.2c-2.2 1.6-5 2.8-3.4 5.4 1.5 2.7 2.8 3 3 5 .4 2 .9 3.8 2.4 4.2 1.6.5 2.2.2 2.2 3.4s0 4.6 1.4 5.8 1.2 2.5 1.8 5.4c.7 3 .7 9.4 2.5 13.7s6.1 12.6 5.6 14.3-1 3 .8 5c1.9 2 3.1 5 3.3 6.7.1 1.7.4 2.3 2.3 1.7a6.8 6.8 0 0 0 3.4-2c.6-.8 1.9-.6 3.6.3 1.7 1 4.4 1.8 6 1 1.5-1 2.2-2.4 3.6-2.4 2.2-1.6 3-4.8 3.5-5.8.4-.9.1-.9-.8-1.8s-.5-2.5-.6-4c-.2-1.6-.8-4-2.7-7.4-1.8-3.4-3-7.6-4.2-8.7-1.2-1-1.8-3.7-2-5-.1-1.2-1.5-2.3-2.5-3.2-1-1-1.8-2.4-3-7.8-1-5.4-1.8-9.3-1.8-10.3s-.2-1-1.1-1.4-1.4-1.8-1-2.6c.2-.8-.4-1.6-.7-2.5s0-2.6.6-3.6.5-3.5-.1-5.7-1.3-4-3.8-4.4c-2.4-.3-3-1-3.8-3-1-2-2-5.5-2.2-6.3-.3-.8-.8-1-2.7.6-1.8 1.6-2.5 2-2.5 5 0 1.9.4 2.5 1 3.6.6 1 .8 1.4 1.2 4.3s3.1 7.6-.3 10.3c-3.4 2.6-3 3.3-2.8 5.1.2 1.9-1 3.1-1.5.5-.7-2.7 0-4.2 1.8-5.5 1.9-1.2 3.6-2.8 2.4-4.5-1.3-1.7-1.8-5.7-2-7.6s-.4-2.5-1.5-1z"
    />
    <path
      fill="#00b800"
      d="M403.4 338.5c0 1.3.2 2.7.3 3.8.1 1.3.5 4-.5 6-.9 2-.7 3 0 3.6h.1c2-.6 2.2-2.7 1.7-3.7a3.7 3.7 0 0 1 .2-3.5c.6-1.1.6-1.7.1-2.5-.6-.8-.6-.8 0-3 .6-1.9-.8-1.9-1.9-.7zm20 30.2c-.4-1.4-1.7-6.8-1.8-10.3-.1-3.5-1.7-6.3-4.6-9-2.2-2-2.7-5.4-2.9-8-1.7-1-2.4-.6-2.2 1.4.1 2 2.2 3 2 6.1-.4 3-.4 2.3 1 3.7s2 3 1.3 3.5c-.8.6-.8 1.7.2 2.1 1.1.4 1.2 1.6 1 2.7-.1 1 1 1.3 1.5 2 .7.8.7 2.7.1 3.8-.6 1-.7 2.8.4 1.9 1-1 1.6-.1 2.4 1.4.7 1.2 1.4.8 2.2.5a9.8 9.8 0 0 1-.7-1.8zm15 27.1c-.6 1.4-1.4 1-2.1.3s-1.5-.7-1.2-2 .2-1.5-.7-2.2l-.3-.3h-1c-1.7 0-1.8-.4-2.8-1.4a7.8 7.8 0 0 0-.6-.5v.9c0 1.3 0 1-1.2 1.4s-1-1.3-1.3-2.3a3.9 3.9 0 0 0-.2-.7c-1.4-.2-3-1.7-3.4-3.3-.6-1.8 0-2 .7-.8s.8 1.5 1.8 2.2 1.4-.5 1-1.9a6 6 0 0 1 0-1.5c-.3-.5-.6-.8-1-1-2-.9-1.4-1-1.3-2.6.2-1.5-.2-1.5-1.4-.7-1.1.8-1.2-.1-1.2-2.5s-1.6-2.3-1.9-.7c-.4 1.7-1 .6-1.6-1.7s-1.7-3-1.8-.7c0 1.9-.6 2.3-1.8 1.3l.5 3.6c.6 3.8 1.5 2.4 3.4 4s1.3 2.5 2 3.3c.7.9.8 1.4.6 2.4-.3.9-.6 1.7-.3 2.5.4.9.9 1.2.9 2.4s.3 1 .8 1.3l1 .1.8-1.2c1.4-1.4 3.5.1 4.2 1.9s1.5 2.2 2.6.8.7-1.2 1.9.1 1.6 1 1.6 1 1.2-.4 2 .3 1.3.6 2.8-1.6c1.5-2.3-.7-1.6-1.4-.2zm4.2-64c.5-3.4.2-6.8 1.6-8 1.4-1.3 3-3.8 3 1.5-.2 5.3-.4 5-1.5 6.2-1 1.3-2 1.6-1 3.6 1.2 2 1.3 2.2 1.2 5.3-.2 3.1-.2 4.4 1 6 1.3 1.5 1.6 1.6 2 3.3.2 1.7 1.3 4 2.7 5.3s3 4.8 3.1 7.3c.2 2.5 2.4 3.1 4.4 4.9 2 1.7-.5 2.9-2 2.1-1.6-.7-1 0-1.9 1.1-1 1.1-1.2 1.3-2-.6s-3.4-3.1-4.7-3.6-2.3-2.5-3.4-4.5a6 6 0 0 0-4.5-3.1c.5 1.3.7 2.3.6 2.8-.5 1.7-1 3 .8 5 1.9 2 3.1 5 3.3 6.7.1 1.7.4 2.3 2.3 1.7a8.3 8.3 0 0 0 3.4-2c.6-.8 1.9-.7 3.6.3 1.7.9 4.3 1.8 5.9.9 1.5-1 2.3-2.3 3.7-2.3 2.2-1.6 3-4.9 3.4-5.8.5-1 .2-1-.7-1.9s-.5-2.5-.7-4c-.1-1.6-.7-3.9-2.6-7.3s-3-7.6-4.2-8.7c-1.2-1.1-1.9-3.7-2-5-.2-1.2-1.6-2.3-2.5-3.3-1-.9-1.9-2.3-3-7.7-.8-4.3-1.5-7.6-1.7-9.3-1.1 1.8-1.9 2.3-2.3 1-.5-1.4-1-2.1-1.7-1.2-.6 1-.8-.8-.8-1.6s-.1-.9-1-.9 0-1.2-.4-3.6c-.3-2.3-.8-2.6-1 .2-.4 2.8-2 4.5-1.3 5.1.6.6.3 1.9-.3 3.7-.6 1.9-.3 3 .1 4.2s-.3 3.6-.6 5.6c-.3 2 1.3 4 1.7.7zM414.2 304c-1.1.1-2 1.1-1.3 4.7.5 2.2-1.2 1.7-1.8.6-.6-1.1-1.1-3.4-2.4-5.4-1.2-2-.6 1.3-.7 3.2-.2 1.9 1 1.9 2.1 3.4 1.1 1.6.2 2.2-1 2.2s-.7 2.5-.4 4.2-.3 2-1.2.6c-1-1.4-.3-3.5-.2-6.2.2-2.6.4-2-1.4-2.6-1.7-.7-1.4-1-.7-2.5.6-1.6 1.2-2.4.4-3.1-.7-.8-.6-1.3.7-1.4 1.2-.2.7-1.1 1.8-1.4 1.1-.3 1.6.1 1.7-1.9.2-1.7.7-2.7 2-2.2.8 2.6 1.7 6.6 2.4 7.8zm15.7 18.4c0 3.2 0 4.5 1.4 5.7s1.2 2.5 1.8 5.4c.7 3 .7 9.4 2.5 13.7l2.1 4.7a8.8 8.8 0 0 0 2.3-3c.4-1-1-3.2-2-5-1.1-2 .1-2.6 1.2-5 1.1-2.2-.1-2.4-1.9-3-1.7-.6-1.7-2.2-2.6-4.7s-.8-3.6-.2-5 .2-2.5-1-2.8c-1.3-.3-1-1.2-.5-2.8.5-1.5.8-1.8-1.1-1.4-1.4.4-1.8.7-2.2 1.2l.2 2z"
    />
    <path
      fill="#5d3100"
      d="M447.8 328.8c-.2 1.8-.2 2.8-.7 3.4-.4.6-.1 1.5.4 2.5s.7 2.1.3 3.9.3 3 1.2 3.5 1.4 0 1.1 2.2a6.7 6.7 0 0 0 2 5.5c1.1.9 1.9 2.4 1.7 3.4-.1.9.8 1.8 1.9 2.3 1.1.5 1 .6 1 1.2s.4.7 1.6 1 2.2 1 3.6 2.8 3.4 2.6 3.1.8 0-3.2-1.8-4c-1.9-1-3.3-5.5-4-8.6-.9-3.2-3.3-7.3-4.7-8.1-.2-2.2.1-3.3-1.3-4.4a4.5 4.5 0 0 1-1.9-3.6c0-1-.7-2.4-1.4-2.8-.6-.3-.9-1-.9-2s-1-.8-1.2 1z"
    />
    <path
      fill="#00d860"
      d="M439.5 412.2a45 45 0 0 0 11.2-3.2c1.9 1.3 5.1 3 6.5 3-2.6.6-4.4.3-5-.2.3.8 1.2 2.1 1.8 2.2-2.6 0-5.5-.7-6.4-1.6-2.3 1-6 1.2-8-.2zm5 3.5c1 .3 6 1 6.6 1-1.6 1.5-.2 2.8 2.5 2.6-1.3.2-2.8.7-1.8.9a28 28 0 0 0 10.2-2c-2.2 2.8-13 5.5-17.5-2.5zm4.5 7c1.3-.6 4.6-.4 6.2.3-1.7.7-5.2.7-6.2-.2z"
    />
    <path d="M454 422.7c2.4-.4 9.1 1.2 11.5-.3-.8 2.2-5 2.5-6.5 2-1.5-.4-2.9-1-3.9-1 .6-.3-.3-.3-1.1-.7z" />
    <path
      fill="#00d860"
      d="M456.4 426a35 35 0 0 0 10.3-1.3c2 .7 6.2 1.8 7.2 1.7-2 1.2-5.8.5-7 0a12.5 12.5 0 0 1-10.5-.4z"
    />
    <path
      fill="#00d860"
      d="M459.5 427c2.6.6 4.8.2 7.4-.6.8.3 2.6.7 4.4.7 1.2.6 2.7 1.5 4.3 1.7a19 19 0 0 1-8.6-.7 22 22 0 0 0-9.1 1.7c0-.8.5-2 1.6-2.7z"
    />
    <path d="M456.4 414c2 .6 9.4.3 13-1.5 1.6-.7 2.5.5.8 1-6 2.2-10.9 3-14.3 1.1-1.4-.7-1.6-1.4.5-.7z" />
    <path
      fill="#00d860"
      d="M492.2 404c-9 4.2-14.9 5.5-27.4 1.6-1.1-.3-2 0-.7.8 1.3.9 8.2 2.7 9.8 2.9s1 .8 0 1.1-1.2 1 .1.5 8.9-.7 12 .9c1.3.7 1.6.5 1.5 0s.6-.9 1.6-1 1.6-.4.8-.7-.9-.5-.3-.8.7-.6-.2-.8-1.5-.4-.7-.8c.9-.4 2-.7 3-.8.2-.6-.2-2.3.5-2.9z"
    />
    <path d="M477.3 405c5.1.4 14.6-2 19.6-6.8 1.7 1 4.2 2.2 5.5 2.4s2.4 1.4.4 1.4-4.7-.8-6-1.4a33.8 33.8 0 0 1-19.4 5c-1.4 0-1.7-.6-.1-.5z" />
    <path
      fill="#00d860"
      d="M462.1 377c1.8 1.3 4.9 3.3 8.9 3a19.5 19.5 0 0 0 6.5 3.3c-2.7 1-5.6 2-6.4 2.9-1.2-1.2-2.8-1-3.2-1.6-1.2 1-1 1.5-.2 2s6.6 1.4 8 1 2 .8.7 1.3c-3.1 1-9.2 0-11.3-3.4-2.2-3.3-4-4.6-9.7-1.5-.6-1.7-.6-2-1.7-2s-3.2-1.5-1.6-1.5 6.2-.6 10-3.4z"
    />
    <path
      fill="#00d860"
      d="M463.5 384.6c-1 .2-3.7 1.7-4.7 1.8-1 .2-2.7 1.6-1 1.6 1.9 0 4.2-2 5.5-2s1.4-1.7.2-1.4zm5.7 5.9c-.7.1-3.7.8-4.5.8s-1.7.1-1.6.7.3 1-1 .8-2.2.4-2.5.7-.5.7.7.8 1.9.3 3.3-.4 2.7-1.6 4.2-1.7c1.5 0 3-2 1.4-1.7z"
    />
    <path d="M465 394c1.3 1 7.6 3 9.8 2.9s1.9.9.2 1.3a14 14 0 0 1-11-3.2c-1.4-1.1 0-1.6.9-1z" />
    <path
      fill="#00d860"
      d="M494.8 397.2c-4.8 1.5-9.7 1-11.7.4s-3.8-.6-2.4.7c1.3 1.3 5.6 2.1 8 1.5-8.6 2-10.9 1.8-13 1.5-2.2-.4-6.2-.3-8-.2-1.2.2-3 0-3.8-.5s-1-1.3 1.3-1c2.3.1 2.6-.3.6-.6s-4.7.5-2 2.2 8.5-.1 12.3 1a21.4 21.4 0 0 0 19.1-4.3c.4-.3 1-1.2-.4-.7zm-23.7-7.1c.2.6.2 1.2 0 1.6s-.1 1 .6.4 1.2-1.3 2-.9 2.7.4 3.6.2c.8 0 1.1-.3-.2-.8-1.2-.5-2.5-.7-3.2-.6s-1.6-.1-2.2-.4-.7 0-.6.5z"
    />
    <path
      fill="#00d860"
      d="M483.6 392.3c-1 0-2.8-.6-3.7-1s-2.3-.4-1.3 1 5.3 2 6.8 1.4 1-1.4 2.4-.4c1.5.9 3.1 1.5 4.2 1.5s1.5 0 .3-.7-1.8-.8-2-1.4-.2-1 1-.6 2.3 1 3.2.5 2.5-1.5 4-1.5l.3-.9c-2.1-.1-3.5.5-4 .7s-1.7.4-2.8.2-2.5-.3-2.9-.6-.3-.5.6-.7 1.2-.8 0-.6-4.8.2-6.6-.4c-1.8-.6-2.6-.7-3.3-.4-.8.3-.7 1.1.4 1.2s3.7.3 4.5 1.1.8.9-.2.5-2.8-.2-1 1.1z"
    />
    <path
      fill="#00d860"
      d="M498.8 390.2l-.4.9c2.2 0 7.4.5 9.1 1.5 1.7-1.3 1.4-1.7 2.5-1.4s2.7.6 3.3.3 1.1-.3 1.8-.2 2.2-.2 3.1-.7 2.7-1.2 3.7-1.2 2.3-.3.4-.6-4.8.3-5.8.7c-1 .3-4 .6-5.7.6s-4.1.8-6.1.3-4.8-.2-6-.2z"
    />
    <path d="M525.8 389.2c-3.5 2.6-7.7 3.1-12.7 3.5-1.5.1-1 .5.2.6 5.3.6 11.3-1.4 13.3-3.5.6-.6.5-1.6-.8-.6z" />
    <path
      fill="#00d860"
      d="M502 395.2a54 54 0 0 1 8.4 2c1.3-.2 1.7-.5 1.4-1s-.4-1 2-.8h8.6c.9-.3 2.7-1.7 3.5-1.7-2.1 0-10.9.5-12 .4s-1.7 0-2.4.4-1 .6-2 .2-2.4-.8-3.3-.2c-.8.5-2.7 0-4.2.7z"
    />
    <path
      fill="#00d860"
      d="M522.4 395.4c.8-.3 2.6-1.7 3.5-1.8 1.5-.1 3.2.5 4 .7s1.7-.1 1.2-.7-.1-1.8 2.3-1.5c2.4.3 3.6.7 6 .5s3.3 1.5 7.7-.3c-.3 1.8.5 1.9 1.3 1.6s1.8-.3 3.2.8 9.9 1.1 11.9.8c2-.4 3 .7 1.5 1.2-1.5.4-1.9 1.1-1.5 1.6.3.5.7 1-1.2.8-1.9-.2-2.2.4-3.1 1s-1.2 1-3.8.5c-2.5-.4-3-.1-4.4.1s-1.8.3-3.2-.2-4.4-1-6.3-.3-3.2 1.1-4.9.7-1.7-.3-.7-1.3 1.3-1 3.3-1.2c2-.2 3.5-.8 2.1-1.6s-1.8-.7-3.7.2-2.8 1.5-5 .4c-2-1.2-3-1-4.5-.6s-3.7-.5-5.7-1.4zm7 3.5c-2.7.4-3.4-1.3-6.2-1-.9.2-2.5 1.3-.3 1.1 2.1-.1 4.5 1 6.6.9s1.2-1.1 0-1zm-3 2c1.3-.5 4.2.5 5.5.3s2.4.5 1 1-4.3-.8-5.7-.4-2.8-.2-.9-.9zm-28 7.6c2 0 9-.3 11.7-6 .2-.5.4-.7 1.2-.1s4.1 2.5 10.1 3c1.7.1 3.5 1 .1.8s-8.7-1.2-10.5-2.3c-3 4.8-8.5 5.3-12.5 5.2-2.5 0-1.9-.7 0-.6z"
    />
    <path
      fill="#00d860"
      d="M513.5 400.5c-1 1.3-4.2 3.5-5.6 3.7-1.5 0-5.9-.3-7-.7s-2.4-.3-.9.8 5.5 1.8 7 1.5c1.7-.4 3.5-.9 4.7-.1s3.5 2.2 4.8 1.9c1.4-.3 4.1-.3 5 .1.9.4 2.4 1.7.1 1s-4.1-.2-5.2-.6c1.2 1.6 3.8 4.2 6 4.2.6 0 1 1-.1 1.5 1 .5 3.6 1 5-.3-.4.5-.2.8.4 1s1.3.7.2.9-3.4.4-4.1 0c2.2 1.5 8.1 3.9 14.1 2.7 1.2-.2 1.8-.7 0-.6-4 0-4.2 0-4.9-.4-.7-.4-.5-.8.6-1.1 1-.3 3.9-.8 5-.8s2.4-.4 0-.4-5.3 0-6.5-.4-2-1-.8-1.8 2.5-.6 3-1.3c-3.8 0-8.5-2.1-5.9-4 .6-.4.4-.5-.5-.6s-4-1-5.2-1.6-.4-1.3.6-1.5c-2.3.4-6.8-.8-9.8-3zm34.1 0c-2 1.5-6 2.2-7.7 2.2s-2 .6-.6.7 2.8.4 3.4.2 1-.2 1.8.2c.9.4 2.7.6 4.4.1s4.3-.8 5.4-.7 2.3.1.1-.5-5.8-.2-6.7 0-3.3 0-2-.3 2.4-1 3-1.6l-1-.3zm-1 4.5a13.5 13.5 0 0 1-7.1 2.7c2.4.9 4.4 3.4 6 3.3-.8.5-1.7 1.2-2.7 1.3 1.6.4 4.1 0 6.2-1.2 3.5 1 8 .3 9.6-1-2.3 0-5-.8-6.3-1.9 1.1 0 2.2-.6 2.7-1.3-2.6.5-7-.8-8.4-2z"
    />
    <path
      fill="#00d860"
      d="M542.8 412.3c1-.1 2-.8 2.7-1.3a22 22 0 0 1-12.8-2.9c-2.5-2.2-2.5-.5-.8 1s4.9 4 11 3.2zm6.2 5.3c-1 .6-6 1-7.7.6s-2.3-.2-2 .5.7 1.2-.7 1-3.7.2-4.7.5-2.2 1.2-.1.9 4-.8 5.6-.4 7.1.5 8.2 0 .4-.4-.1-.4-.8-.3 0-.7 1.3-1.3 1.5-2zm-48.5-6.7c-2.1.9-9.1 2.8-11 2.9-2.3 1-4.2 1.6-5.3 1.6.8.7 4 1.4 5.2 1-.7.8-2.3 1.6-2.9 2 1.9-.3 4 .2 5 .3a14 14 0 0 1-7.6 1.6c.6.8 1.4 1.6 2.5 1.6a13 13 0 0 1-6.3.2c.6 1.1 1.1 1.8 2 2-1.9.2-4.2.5-6.2-.6 1.5 2 4.9 2.6 9.9 2 5-.5 9.2-2.7 10.4-3.7-2.1.3-5 .4-6.3.1a37 37 0 0 0 9.9-4.3 5.6 5.6 0 0 1-3.2-1 31 31 0 0 0 9.1-1 6.7 6.7 0 0 1-4-2.6 39.2 39.2 0 0 0 19.5.6c1-.3 1-1.5-.8-1.3-3.2.2-9.5-.7-11.2-1.5a11.6 11.6 0 0 0 4.7 2c-3 .9-7.2 1.5-13.4-2z"
    />
    <path
      fill="#00d860"
      d="M486.5 418.4c.6-.4 2.2-1.2 2.9-2-1.3.4-4.4-.3-5.2-1 1.1 0 3-.5 5.3-1.6-4.2-.1-7-.1-8.6-1s-4.3-.5-5.4-.3-.7 2 3.8 1.5a15.4 15.4 0 0 1-8.8 1.3c.5 1.5.8 3 .4 3.9 2.4 1.4 8.8 3.1 12 2.9-2.8-1-4.3-2.2-2-2.5s3.6-.7 5.6-1.2z"
    />
    <path d="M479.3 426c5.5-.5 13-.6 19-5.7 1.5-1.2 2.5-.8 1 .5a33 33 0 0 1-18.4 6.8c-3 0-4.4-1.4-1.6-1.7z" />
    <path
      fill="#00d860"
      d="M521 416.7c-1.3.5-5.2 1.2-6.4 1-1.2-.2-2.9-.2-3.8.3s-1 1 .3 1l3.7.3a6.2 6.2 0 0 0-2 1.7c2-.4 5.4.4 6.4 1a3 3 0 0 1-2.3-.5c3.1 3.4 12.5 3.4 14 2.8-.7.5-1.4 1-2 1.2 2.6.5 5.6.4 8.6-1.3-1 .1-4-.1-4.8-.2a5.6 5.6 0 0 1 2.3-1.3c-1.2-.3-4.8-.2-5.7.3a4 4 0 0 1 1.7-1.9c-4.6 0-10.2 0-12.2-1.1 3.2.3 6.8-1.6 8.3-1.6-2.5 0-5.3-.6-6-1.7zm-11.6 2.5c-2.3.5-5.7 1.5-6.7 2s-1.9.8.1.8a125.5 125.5 0 0 1 .7-.2c-.8 0-1.7 0-.2-.5s3.5-1.5 6-2zm-4.6 5.5c.8 0 4.3 0 5.7-1.2 1.5 1 4.3 2.6 6 2.6 1.9 0 1.7.5.1.7a12 12 0 0 1-6.2-2c-2.1.8-3.8.2-5.7-.1zm-27 15.7c3.6 1.4 8.3 2.4 11.8 1.3 2 1.7 6.1 1.8 8.3 1.4 2.2-.5 4.2-.7 6.7 0 2.4.9 7.4 1 8.8 2.1-1.3 0-4 0-4.7.2-.6.2-.3.6 1 1.2-4-.2-10.9 1.5-13 3.3a7.3 7.3 0 0 1 6.8-4.3c-2-.7-8.8-.8-11 .6a6.7 6.7 0 0 1-1.4-2.4c-3.6 2-10.6-.9-13.4-3.4zm-9.3-6.6a16 16 0 0 0 8.5-3.2c.8.7 4 1.4 7.4.3-.7.5-.8 1.5-.5 2a26.2 26.2 0 0 0-8 2c-1.5.7-5.8 1.3-7.2.5-1.4-.7-1.4-1.4-.2-1.6z"
    />
    <path
      fill="#00d860"
      d="M483.9 433a26.2 26.2 0 0 0-8 2l.5 2a51 51 0 0 1 17.5-1.8c-1.8.1-5.1 2-7 2.1 4.6-.3 9 .6 10.2 1 1.1.2 1.4 1 .5 2s-1.3.8.6 1c1.8 0 5.7-.3 7.4-2-.7-.7-2.5-.4-3-1a8 8 0 0 0 3.1-1.9 29 29 0 0 1-5.3-.3c-1-.3-1.8-.6-.5-1.3a7.6 7.6 0 0 0 2.2-1.7c-2.2.6-5.8 1.2-8.8-1.2 1.1.3 3.8.1 4.7-.3a6 6 0 0 0-2.6-.9c2.4-1.2 7-2.2 13 .1 2.8-.2 6 0 8.2.5 1-1 2.9-3.2 4-3.7-7 .5-19.3-.7-19-4.4-2.3 3-7.4 4.6-9.6 4.1-.2 1 .7 2.4 1.5 3-2.3.5-6.3.9-8.2.5 1.1 1 3 2 4.2 1.9-2.4 0-3.7.5-5.6.3z"
    />
    <path
      fill="#00d860"
      d="M498.1 441.2c2 0 5.8-.2 7.5-1.9-.7-.7-2.5-.4-3-1a8 8 0 0 0 3.1-1.9c5-.4 9.3-.2 11.4-.8 2.1-.6 7.5-.3 8.5-.6-4.7.8-5.6 1.2-5.8 2s1.5 1.3 2.6 1.3c-2 0-4.7 2.1-5 3-2.8-1.6-4 .3-4.4 1-1.1-.5-5-.4-7 1.3-2.5-.8-4.2-1.2-6.8-.8 1.6-.3 1.3-1.4-1-1.6zm22.4-13.7c1.6 0 5 .2 6.3 0a7.5 7.5 0 0 0-2.1 1.5c4-.5 9.4-.8 11-.5-2-.3-4 1-5 1.6s-.4 1 1 1.2 3.1 1.2.7.9-7.3-.4-8.5-.2-1.8-.4 0-.7 2.8-.8 3.6-1.2c-1.4.3-4.1.3-5 0s-1.3-.6-.3-.9.3-.5-.7-.4-3.5 1.1-5 2.5c1.6-1.6 3-3 4-3.7z"
    />
    <path d="M502.8 430.2a10 10 0 0 0 7.8 3.5c.7 0 2.2 1 .3 1.1-4.9.2-7.3-1-9.5-4.1-.4-.7.4-1.6 1.4-.5zm29.2-40.8c2.6 1.2 7.7 2.3 11.8 2.1.7 0 2 .7.3.9a21 21 0 0 1-12.4-2.3c-1-.6-.7-1.2.3-.7z" />
    <path
      fill="#00d860"
      d="M534.6 389.4c4-.1 7 0 8.1 1 2.3-.6 6.4-1 7.3-.8s2-.3-.2-.8-7.1-.7-8.7-.4c-1.6.3-6.5.5-8 .3.6 0 1 .2 1.5.7zm15.4 1.5c1.8-1 7.2 0 8.8-.7-1.1 1.4 3.8 1.5 8 .4-1.6 1-5.1 1.2-6.6 1.9s-2.4.1-3.5-.4-4.2-1.6-6.7-1.2z"
    />
    <path
      fill="#00d860"
      d="M566.8 390.6c-4.2 1-9.1 1-8-.4-1.6.7-7-.3-8.8.7 2-1.1 3.4-.2 4.8-2.6.9.2 2.9.3 3.6-.6 1.2.3 3.4.8 4 1.4.6.7 1.6-.2.8-1.1 2-.7.7.8 5.2-.3 1-.3 3.2-.7 4-.7a27.6 27.6 0 0 1-5.6 3.6z"
    />
    <path
      fill="#ff0"
      stroke="#000"
      strokeWidth={0.1}
      d="M373.4 664.2l-.2-22.2c0-1-.5-.8-.5 0v22l.7.2zm7.2-23.4l.8 23.4-.1.2h-.5l-.5-23.6h.3zm6.8 19.8l-.4-19c0-.6-.5-.5-.5.1l.4 18.9h.5z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M376.6 644.7l-7-.1c-.3 1.4 1.4 1.3 2 1 .8.5 1.4.5 1.8 0 .6.5 1.4.4 1.7 0 .8.7 1.7 0 1.5-1zm.5 3.4h-7c-1.3 1.2.3 1.8 1.7 1 .2.4 1 .6 1.6.3.6.4 1.4.1 1.8-.3.7.3 1.6.4 2-1zm-.2 4.5h-6.8c-.1 1.1 1.3 1 1.8.7.5.8 1.7.6 2.1.1.7.5 1.3.4 1.6 0 .7.6 1.4-.2 1.3-.8zm.4 4.4l-7.7-.1c-.4 1.3.8 1.5 1.3 1.2.2.7 1.2.5 1.5 0 .4.3.9.1 1.1-.2.1.7 1 .8 1.7.2 1.4 1 2.7-.2 2-1.1zm6.7-1.8h-6.3c.3 1.2.9 1.5 1.9.8.8.8 2 .5 2.3.1 1.4 1.1 2.1-.2 2.1-1zm-.6-4.4l-6.2-.2c.1 1.6 1.6 1.5 2.4.9.5.7 1.5.5 2 0 .7.8 2 .3 1.8-.7zm.8-4.9h-6.6c0 1.1 1.5 1.7 2.6.7.3 1.3 1.5.9 2 .4.8 1 2.5-.2 2-1zm-.4-3.3l-6 .1c0 1 1.4 1.4 1.9.6.3.5 1.3.4 1.6 0 .4.7 1 .2 1.2 0 .7.5 1.4.2 1.3-.7zm6.9 2.2l-7.2-.1c0 .7.7 1 1.2.7 0 .8 1 1 1.7.4.4.7 1.7.8 2.2 0 1 .9 2.2.2 2-1zm-.1 5.9h-7c0 1 1.1 1.3 1.8.8.1.8 1 .9 1.5.4.7.7 1.7.8 2.3 0 .8.3 1.5-.4 1.4-1.2zm-.4 5.3h-5.6c0 1 1.2 1 1.7.5.6.7 1.4.7 1.9.2.7.6 1.9.4 2-.7z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M381.3 664.4c-3 0-6.1 0-8.2-.2s-2.7-.6-4.2-1.5l-5.6-3.4c-.5-.2-1 .1-.3.5l5.6 3.7c1.5 1 2.5 1.9 3.4 3 1.2 1.3 2 1.3 2.6 1.1s1.4-.5 2.3-.3c.8.2 2 .3 2.6.2.5.5 1.8.4 2.5.2s1.2-.2 1.7-.1h1.7c.5 0 1.8-.3 2.7-.2 1 .2 1.9 0 2.5 0a5 5 0 0 1 2-.1c.6-.4.8-.9 1-1.4.6-.1.8-.2.9-.5l.6-1.6h.2v-.6l-.4-.6.2-1 .5-.2-.2-1-8.8.2a2 2 0 0 0-.6 1.1l-2.6.4c-.3.1-.6.1-.9.5l-1.2 1.8z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M391.8 660.5l1.3-4.9c.2-.5-.3-.6-.5 0l-1.3 4.9h.5z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M396.9 655c-1.1.5-1.7.8-2.2.6-.5-.2-1.1-.3-1.5-.1a.5.5 0 0 1 0 .1 493.3 493.3 0 0 1-1.1 3.8c.8.3 2.2.3 2.5 0 .4-.4 1.3-.3 1.8-.3.3-.4.4-.9.3-1.1s0-.7 0-1 .4-1.4.2-2z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.1}
      d="M371.7 645.6a53.2 53.2 0 0 1-8 14m2 1.2a54.5 54.5 0 0 0 11.4-12.6m-7 4.3c-.3 2.7-1.1 7.5-1.5 10m2.6-4c-1 1-2.3 2.6-3.4 3.5m12.7-8.9c-.8.8-1.7 1.8-2.6 2m3.1-1.8a7 7 0 0 0 2.7 1.9m-3.2-6.2a8.5 8.5 0 0 1-3 1.7m3.4-1.6c.6.6 1.3 1.3 2.2 1.7m-5.4-4.9a7 7 0 0 0 2.7-1.5m.3 0c.7.7 2 1.4 2.7 1.6m-5.5-3.3a4 4 0 0 0 2.4-1.4m.3-.2c.7.6 2 1.4 2.7 1.5m3.2.8c-.4.5-1.5 1.3-2.2 1.3m2.7-1.3c.3.5 1.1 1.3 1.6 1.3m-4.8 6a7.2 7.2 0 0 0 2.8-1.9m.5.1a5.6 5.6 0 0 0 1.9 1.8m-4.1 5.2c.4 0 1.5-.6 1.8-1.3m.6-.3a7 7 0 0 0 2 1.7m-18.7.9c1.3-.4 3.8-2 5.1-3.5m-2.4 1.9c1 .7 2.3 1.5 3.2 1.7m-6.2-4.5a8 8 0 0 0 2.4-1.5m.5-.1c.3.4 2.4 1.7 3.3 1.7m-3.8-5.9a9.8 9.8 0 0 1-2.5 1.4m3-1.4c.7.5 2.2 1.4 3.1 1.4m-3.6-5.4c-.6.6-1.6 1.6-2.4 1.9m2.9-1.8c.4.7 1.6 1.7 2.4 1.8m8 2.6c1.9 3.3 5.3 7.4 8.7 9.6m-14.1-13.3c2.8 4 8.2 12.7 13.4 15.9m1-3.4a18.4 18.4 0 0 1-4.9 4.6m4.5-3.5c-1.7-2.8-2.6-6.3-4-11m-14 12.4l2 6m-2.4-6.1l1.9 6m-2.4-6.3l1.8 6.2m-2-6.1l1.4 6.1m0-.2h1.7m-.2-.6h-1.6m1.4-.5h-1.6m1.4-.5H374m1.3-.6H374m-.1-.5h1.3m-1.4-.4h1.3m-1.4-.5h1.2m-1.3-.4h1.1m-1.2-.5h1m-1.1-.4h1m-1.1-.3h1m-1-.4h.9m-2.6 0l-1.2 5m1.5-5l-1 5.2m1.3-5.4l-.8 5.5m1.2-5.6l-.6 5.8m.7-.4h-2m2-.5h-2.3m2.3-.6h-2.1m2-.5h-1.9m2-.5h-1.9m1.9-.6H371m1.7-.5H371m1.6-.5h-1.5m1.5-.5h-1.3m1.3-.5h-1.2m1.2-.3h-1.1m1 5.5v-5.9m6.5-2l-4 8.1m4.3-8.2l-3.4 8.3m3.6-8.4l-2.7 8.4m3-8.2l-2.2 8.2m.1-.3h-2.5m2.7-.8h-2.4m2.5-.6h-2m2.4-.6h-2m2.1-.6h-1.9m2.1-.6h-1.8m2-.7h-1.6m1.7-.5h-1.5m1.7-.6h-1.4m1.5-.4H378m1.4-.4H378m1.3-.4h-1m1-.3h-.9m1-.4h-.8m1-.4h-.8m.8-.3h-.7m3.4-.1l1.7 5.6m-1.4-5.5l2.1 5.4m-1.8-5.4l2.5 5.3m.6-.5l-2.8-4.9m2.8 5h-2m1.8-.8h-2m1.7-.6h-1.9m1.5-.7h-1.7m1.3-.6h-1.5m1.1-.7H383m1-.7h-1.2m.8-.6h-1m3.2.1L384 662m2.3-5.4l-1.6 5.3m.7-.1l1.2-5m.3.2l-1 4.7m-1.7-.3h1.7m-1.5-.6h1.7m-1.5-.7h1.6m-1.3-.6h1.5m-1.3-.7h1.4m-1.2-.6h1.3m-1-.7h1.2m-1-.6h1m.9.1l.8 3.6m-.5-3.8l1.1 3.7m-.7-3.7l1.2 3.7m-.7-3.5l1.3 3.5m-.1-.3h-1.7m1.5-.5h-1.6m1.4-.5h-1.5m1.3-.6H388m1.2-.5h-1.4m1.2-.5h-1.3m1.1-.5h-1.2"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#00b800"
      d="M479.6 380.3c3.6-2.3 9.8-1.9 13 .5 3.7-2.1 10.5-1.5 13.6 1.3 4.8-3.3 8.9-3.8 13.5-.6a12 12 0 0 1 13.6.2c4.2-2 8.8-3.6 12.9.7a10.7 10.7 0 0 0-13 .8c-4-4-11.1-2.5-13.5.3a8.8 8.8 0 0 0-13.3.2c-4.2-3.5-10.4-3.6-13.8-1a15 15 0 0 0-13-2.4z"
    />
    <path
      fill="#cf6200"
      d="M543.3 375.3c-18.5 3.2-59 1-67.8-1.3-3-.7-2.2-1.8.4-1.2 10.2 2.3 32 2.3 44 1.7 2.3-3 6-8.3 7.1-9.8s1.6-1.6 4-2l10-1.7v1.4c-.2.3-.5.7-.8.8 0 2.4.5 8.2 1 10.3l1.3-.3c.8-.2 1.6 1.9.8 2.1z"
    />
    <path
      fill="#cf6200"
      d="M573.7 376.2h2.5c.7 0 1.8-.6 2.2-1.7l2.5-7.3-1.9-2.8 1-6.1 2.4-1c.1-.4-.1-1.9-.6-2.3l-36.2 1.2c-1.1 0-1.6 0-2 1.4a27 27 0 0 0 9.2 26.6c.6.5 1.4 0 .4-.8a29.8 29.8 0 0 1-5-6.5l6-.1c.4 2 1.9 6 2.2 6.8s1 .8.6-.3c-.8-2.4-1.2-5.2-1.5-6.6h6l.5 6c0 .8.7.8.7-.1v-6l5.5-.2-.5 6c-.1 1 .4 1.4.6 0l.8-6 3.8-.2c-.1 1.3-1.3 5-1.6 6s.2 1 .6.1a35 35 0 0 0 1.8-6z"
    />
    <path d="M547.2 375.3c-.6-1.3-2.6-5.9-2.8-9.2l8-.1c.3 2.5 1 7.9 1.5 9.1l-6.7.2zm6.6-9.4c.2 2 1.2 8.5 1.4 9.2l6.4-.1-.4-9.3-7.4.2zm-9-8.1a38 38 0 0 0-.3 6.8l7.7-.2-.6-6.8-6.8.2zm8.3-.2c0 1.6.4 5.6.5 6.8l7.6-.2-.4-6.9-7.7.3zm9.2-.3l.3 6.9c1.8 0 5.4 0 6.5-.2.1-1.5.3-5.9.2-7l-7 .3zm8.3-.3l-.2 7 7.1-.3c.3-1.5 1-5.4 1-7l-7.9.3zm7.2 8.3l-7.5.2-.7 9.2 7.2-.2a61.6 61.6 0 0 0 2.6-7c-.5-1-1-1.4-1.6-2.2zm-15.2.4l.2 9.2 5.5-.2.7-9.2-6.4.2zm-31-1.8l-3 .5a224.8 224.8 0 0 1-7.2 10.1l10.6-.3-.3-10.3zm1.4-.3l.4 10.5 6.4-.5-1-11-5.8 1z" />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M377.3 657h-7.7v-.2l7.7.1zm6-6.2c.1 0 .1 0 0 0l-6-.1c-.1 0-.1 0 0 0h6zm-6.4 1.7c.1 0 .1.1 0 .1h-6.8c-.1 0 0-.1 0-.1h6.8zm.2-4.4c.1 0 .1.1 0 .1H370c-.1 0-.1-.1 0-.1h7.1zm-.5-3.5c.1 0 .1.1 0 .1h-6.9c-.1 0 0-.2 0-.2l7 .1z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M383.8 642.6l-6 .1 6-.1z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M384.1 646c.1 0 .1 0 0 0h-6.5c-.1 0-.1 0 0 0h6.5zm6.5 4.6v.1h-7c-.2 0-.2 0 0 0h7zm0-5.9c.2 0 .2.1 0 .1h-7.1c-.1 0-.1-.1 0-.1h7.2zm-6.6 10.4c.1 0 .1.1 0 .1h-6.4v-.1h6.4zm6.2.9c.1 0 .1 0 0 0h-5.6 5.6z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#ef072d"
      stroke="#000"
      strokeWidth={0.1}
      d="M395.3 657a3 3 0 0 0 0-1.4 1.1 1.1 0 0 1-.6 0 3 3 0 0 0-.3-.2c0 .4-.2 1.5-.4 1.9-.3 0-1 0-1.3-.2l-.3 1a3.5 3.5 0 0 0 1.5 0c0 .6-.1 1.1-.4 1.5.5 0 1 0 1.1-.3.3-.4.3-1 .4-1.3l.5-.1.5-.2.7-.1v-.6l.2-.4-1.6.5z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M370.5 623.2c-.8 0-2.6 0-3 .2-.3.2-.4.3.2.4s1.7.5 2.3.8c.6.4 1 1 1 2a6 6 0 0 0 3 6.3c.1.1.2.2.1.6l-.3 1.1c0 .2-.1.4.2.3a20 20 0 0 1-1 1.6c-1.6-.2-3 0-3 1.8 0 .2 0 .4.2 0 .3-.4.6-.8 1.3-1-.4.7-.6 1.3-.5 1.7 0 .3.2.5.4 0 .1-.4.5-.8.8-1.1.2-.1.2-.1.1.2s.1.9.3 1.1c.2.2.3.1.2-.2 0-.4 0-1.1.5-1.3.6-.4 1.2-.2 1.4.2.3.5.5 0 .2-.4s-.6-.9-1-.9l1-1.7c0-.2.2-.3.4-.2 0 .1.2.1.3-.2l.7-1.4.6-.2 1 1.5v.6c0 .4-.4 1.3-.5 1.6-1.2 0-1.8 0-2.2.7-.2.3.1.4.4.3a2 2 0 0 1 1-.3c.2 0 .3.2 0 .3-.7.3-1.2.8-1.2 1.5 0 .2.2.3.3 0 .3-.5.8-.9 1.3-1 0 .5.1 1.3.5 1.5.3.2.3 0 .2-.3-.2-.5 0-1 .3-1.3.5-.6 1.7.2 2 .4.2.2.4.3.2-.3-.1-.7-1.1-1-2-1.2l1.2-4.2c.5.3 1-.5 1.8-.2 1.4.6 3.5 1.9 3.8 2.2.4.3.5.2.7 0 .2-.1.5 0 .8 0 .2.1.4.2.1-.4a7.2 7.2 0 0 0-2.4-2.6c.8 0 1.8 0 1.8-.2s-1.2-.6-1.7-.6a3.3 3.3 0 0 0 1.6-.8c.2-.2 0-.3-.8-.3-2.1 0-3.2 0-4.3-.6-1.8-1-2.9-2.2-3.8-2.6-.4-.3-.7-.9-1-1.4-.5-1.5-.5-2.3-1.8-2.8s-3 .1-3.7.8z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M370.6 623.6h-1.7s-.2 0 0 0l1.5.4c.3 0 .2.3 0 .2s-.4 0-.2.2c1 .7 1.2 1 1 3.7l.5.4c.2 0 .1.2 0 .1s-.5 0-.2.2.5.2.2.2-.6.2 0 .1c.5 0 .8.2 0 .3-.6 0-.4.2 0 .2.7 0 .5.2.3.2s-.3.2.2.2h.7c.1 0 .2 0 0 .1-.2 0-.2.2.1.2s.5 0 .2.1c-.1 0-.3.1 0 .2.7 0 .8.2.6.3s-.3.1 0 .1.6.1.3.2c-.2 0-.3.2 0 .2s.5.2.3.3-.3.2 0 .2.4.1.2.2c-.2.2-.3.2-.5 0 0-.2-.2-.2-.2 0l-.2-.3c-.1-.3-.3-.3-.3 0s-.2.1-.4 0a3.3 3.3 0 0 0 4 .8c.1 0 .2 0 .3.3l.6 1.1c.1.2.3 0 .3-.2l.6-1.7c0-.3.4-.5.3.3.3-.2 1.5-.3 2.5 0a12.2 12.2 0 0 1 2.7 1.5.6.6 0 0 0 .5.1c.3 0 .4 0-.1-.5s-.3-.7 0-.5c.3.2.5.1.2-.2l-1-.9c-.1 0-.1-.2-.6-.2h-1.5c-.2 0-.4 0 .2.2.6.2 1.7 1 2 1.2s.4.6-.1.2-2.4-1.5-3.6-2c-2.7.3-4.9.6-6.5-1.1-.8-.9-.8-2.8.5-3.6-.2-.2-.2-.4-.1-.4v-.6c-.2-.1-.4-.3-.4-.5-.3 0-.5-.5-1-.3s-.6 0-.8-.1c-.1-.2-.2-.2-.5-.2s-.5 0-.5-.2.2-.2.6 0c.7.3 1.3.5 1.8-.2.4-.6-.2-1.1-1-1.3-.9-.2-1.5.5-1.9.8z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#fff"
      stroke="#000"
      strokeWidth={0.1}
      d="M375 623.3a2.8 2.8 0 0 0-1-.6c-.3 0-.3.2-.2.3v.6c.2.1.3.3 0 .3-.2.2 0 .9.3.7h.2s0 .3.2.3 0 .2 0 .3h.2c.2 0 .1.4-.1.5.3 0 .4 0 .4.2.1.2.4.3.4.6s0 .3-.4.2-.4 0-.5.2-.2.3 0 .3.4.1.1.2-.6 0-.7.3c0 .3 0 .4.2.3l.7-.4.5.1c.2.1 0 .5-.2.3s-.4 0-.5.1l-.5.2c-.2 0-.4 0-.3.5 0 1.4 1.1 2.4 3.1 2.4h3.3c-.6-.4-1-.6-1.3-.6h-.3c.1-.1 0-.3-.1-.3s-.3-.2-.5 0l-1 .5c-.2 0-.5 0-.2-.2l.9-.4c.2 0 .1-.2.1-.2s0-.3.3-.2c.6.4 1.5.9 1.8.9s.4-.2.2-.3-.3-.3-.3-.4.1-.2.5 0c.4.3 1 .5 1.3.6s.5.1 0-.2l-2.3-1.7c-.3-.3-.3 0-.2.2s-.3.3-.5.1-.3-.3 0-.4.2-.2-.1-.5c-.4-.3-.5-.3-.4 0 .1.3.1.5-.2.4s-.6-.3-.3-.4c.2-.2.5-.3 0-.6s-.2 0-.3.2-.4.2-.5 0-.3-.3-.2-.4.1-.2.3 0 .4 0 .1-.3-.4-.2-.3 0-.2.4-.6 0c-.2-.1-.2-.3 0-.4.2 0 .2-.1 0-.3-.7-1.2-.4-2.1-1.2-3z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path
      fill="#cf6200"
      d="M491.6 188.4c-.3.5-.4.4-1 .8-.6.5-.8 1.8.4 1.7.8-.2 1.3-.6 1.6-1a10 10 0 0 0-1-1.5zm-3.6-2.9c-.9.9-1 1.3-.6 1.3.6 0 .3 0 0 .7-.5.6.7.9 1.2.4s.5-.6.8 0c.1.5 1 0 1.4-.4-.8-.8-1.9-1.5-2.8-2zm-1.6 5c-1.2.6-.8 3.7 1 2.8.6-.3 1-.1 1 .3-.1.3-.1.5 0 .8a5.4 5.4 0 0 0 2-1.4c1-1.3 0-1.2-1.6-1.2s-2-.3-.5-1.2c1.4-.9.4-1.4-1.5-1.2.3.4.2.8-.4 1.1zm6.7 6.9c-.9-1-.3-1.4.6-1.9a1.2 1.2 0 0 0 .5-.4l-.8-3c-.4.2-1 1.3-1.2 1.8-.2.8-.4 1.2-1.2 1-.7-.2-1.4.6-1.5 1.4h.5c.3.1.4.6.3 1 2.1 0 2.5 1.4 2.9 2.4.4 1.1.8 1 1.1.3.3-.6-.4-1.7-1.2-2.6z"
    />
    <path
      fill="#ff0"
      d="M493.7 209.6c-.4.9-.4.8-1.7.8-1.2.1-2.8.3-3.5 1-.3.4-2.5.6-2.5 1.5 0 1 0 1.7 1 1.8.9 0 1 .2.7.9-.4.7-.6 1.8 1 2 1.6 0 2.8-.4 3.2.5.4 1 0 2.4.3 3s1.4.9 3.1 1.4c1.2.3 5.5.6 6.8.4 1.3-.2.8-1-.5-1-1.3-.2-2.3-.4-2.6-1.3-.3-1-.6-1.5.2-2.3.7-.9 1.4-1.5 1-2.9-.4-1.3-1.1-2.9-2.7-3.3-1.5-.5-1-2.6-2.6-2.8-.6 0-1 0-1.2.3z"
    />
    <path
      fill="#cf6200"
      d="M486.1 222.2c1.4.2 2.5.6 1.4.9-1 .3-1.7.9-.3 1 1.4.1 2.6.7 1.5 1s-1.2 1 .1 1 1.9.6 1 1.2c-1 .5-1.6.8-2.2-.1-.6-1-1-1.2-1.1-.5-.2.7-.6.2-1-.8s-1.4-1.4-1.1-.6-.8 1-1.8.6c1 1 2 2 3.3 2.7 1.4-.5 3 0 3.5 0 .6 0 2.4.5 3.4 1s1.7-.4 1.3-1.5c-.5-1-.5-.7-1 0-.6.5-.7-.3-.6-1.5 0-1-.7-.8-.9-.2s-.8-.4-.5-1 0-.9-.5-.7-.6 0-.7-1.2-.6-1-.7-.5-.7-.2-1.4-1.1c-.6-.8-1.3-.3-2.5.1l.8.2z"
    />
    <path
      fill="#ff0"
      d="M500.3 229.5c-6.4 2.5-11 1.4-14.4-.9 1.4-.5 3 0 3.6 0 .5 0 2.4.5 3.3 1s1.7-.4 1.3-1.5c.8 1.1 1.5 1.9 2.5 1.8 1 0 2.8-.2 3.7-.4zM486.7 200c-.4-1.3-.8-1.6-1.5-1.5-.7 0-1-.1-1.8-.4-.7-.3-1.7 0-1.9 1.5s-1 2-2.2 3c-1.1.8-1.8 1.5-1.8 2.9s-.3 1.7-1.1 2.8l-1.3 1.5 1.4.8c.9.4.6 1-.2.8s-1.7.2-.3.5 2 1 .7 1c-1.4-.2-3 1-.3.7 2.6-.3 3.6 1 .6 1-3.1 0-2 1-.3 1 2.9 0 2 .9 1.2.9-.7 0-1 1 .9.8l.7-1.1c.3-1 .6-3.7 1.7-4.4 1-.8 1.6-2 1.6-2.7s1.7-4.2 2.7-5 1.6-2.7 1.2-4z"
    />
    <path
      fill="#cf6200"
      d="M484.4 200.2c-1-.8-2.1-.3-2.1 1s-.8 1.8-1.7 2.3a4 4 0 0 0-2 2.7c0 1.1.2 1.8-.5 2.7-.8.8-.9 1.5-.4 2 .6.5.6.5.8 1.2.3.7 1.6 0 1.6-.8s.3-.8 1.1-1.3c.9-.4 2.3-2.7 2-3.3-.3-.6-1.1-1.2 0-2 1-.9 2-1 2-1.8 0-.9.3-1.2.6-1.5.3-.3-.7-.8-1.4-1.2z"
    />
    <path d="M484.4 199c-.7-.2-1.1 1.3-.1 1.5s1.1-1 .1-1.4zm-.1 2c-.8.1-1.7 1.1-.4 1s1.8-1.1.3-1zm-1.6 1.9c-.8.4-.6 1.5.6.7s1.4-1.7-.6-.7zm-1.2 1.6c-.8.4-.7 1.5.5.7 1.2-.7 1.5-1.7-.5-.7z" />
    <path d="M479.9 205.3c-.8.4-.3 1.4.8.7s1.1-1.7-.8-.7zm1 1c-.9.4-.4 1.4.8.7s1.1-1.7-.9-.7z" />
    <path d="M479.4 206.7c-.7.4-.2 1.4 1 .7s1-1.7-1-.7zm1 1.1c-.9.4-.4 1.4.8.7 1.2-.8 1.1-1.7-.9-.7z" />
    <path d="M479 208.5c-.8.4-.3 1.4.9.7s1-1.7-.9-.7z" />
    <path d="M479 209.5c-.7.4-.2 1.5 1 .7s1-1.7-1-.7z" />
    <path
      fill="#cf6200"
      d="M478.5 219.3c-.8.1-1.4 1.3-.4 1.5s1.3.3 1.3 1 .3 2 1.4 2c1 .1 2-1.1 1-1.5-.9-.4-1.7-.7-1.8-1.6 0-.8-1-1.4-1.5-1.4z"
    />
    <path
      fill="#ff0"
      d="M507 212.6l.6.6c.8.6 2.2 0 2-.5s-1-2.3 1-.9l10.6 7.4c2.2 1.6.8 1.8-.2 1.3s-4-1.7-5.7-2.7c-1.7-1-2-.6-2.2-.3-.2.3 0 1 .6 1.6-1 .1-2.7 0-3.2-1.2-.6-1.3-2-3-3-4.2-.4-.5-.5-.8-.4-1z"
    />
    <path
      fill="#00d860"
      d="M564.9 403.6c-1.4 1-3.4 2.8-2.1 5.2l.5-.2a142.4 142.4 0 0 0 14.7-21.7l.1-.7a20.5 20.5 0 0 1-5.2 3.1c.7 1.9-2.6 4.3-4.3 5 .7 1.2.5 3-1 3.3.3 1-.9 1-2.3 1.6s-2 1-2.5 1.8c.7-.5 1.8-.8 2.3-.6s.7 1-.3 1.3-1.7.8-2.1 1.2c1.5-.5 3.7-.3 2.2.7z"
    />
    <path
      stroke="#000"
      strokeWidth={0.1}
      d="M376 628.4c-.4-.3-.5-.1-.4 0s0 .4-.3.5h-1c-.2 0-.5.4 0 .3l1.6-.3c.2 0 .4-.2 0-.5zm.7.6c-.3-.3-.4-.2-.3 0s-.1.3-.3.3l-1.4.4c-.4 0-.4.3.1.3s1.5-.5 1.6-.5.2-.3.3-.2.3 0 0-.3zm.3.8l-1 .5c-.3 0-.5.3 0 .3s1-.5 1.2-.6l.4-.2s.4-.1 0-.4-.8 0-.6.1 0 .3 0 .3z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
    <path d="M482 187.5c-2.8-1.9-6 2-2.9 4.2 2.8 1.9 5.7-2.4 3-4.2z" />
    <path
      fill="#fff"
      d="M478.5 189.2h.8c-.1 1 .8 2.3 2 2-1 .8-3-.2-2.8-2zm11 42.5c.9.3 3.9.6 5 .6l-1.4 2.5c-.3.8-.4.9-.5-.3 0-1.2-.7-2-1.3-.7l-1.2 2.2c-.3.5-.8.7-.6-.6s.1-2.6 0-3.7z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeWidth={0.3}
      d="M399.7 640.8c0 16.3-2.6 33.9-23.8 42.3-21.1-8.4-23.7-26-23.8-42.3h47.6zm0 0c0-6.2-.3-12.2-.2-17.4a63.6 63.6 0 0 0-23.6-4.3c-5.3 0-15.7.8-23.6 4.3.2 5.2-.2 11.2-.2 17.4h47.6z"
      transform="matrix(4.4862 0 0 4.4867 -1190.9 -2609)"
    />
  </svg>
	),
	TC: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#006" d="M640 480V0H0v480h640z" />
    <path fill="#006" fillRule="evenodd" d="M0 0h373.7v232.2H0z" />
    <g strokeWidth="1pt">
      <path
        fill="#fff"
        d="M0 0v26l331.9 206.2h41.8v-26L41.7 0H0zm373.7 0v26l-332 206.2H0v-26L331.9 0h41.8z"
      />
      <path
        fill="#fff"
        d="M155.7 0v232.2H218V0h-62.3zM0 77.4v77.4h373.7V77.4H0z"
      />
      <path
        fill="#c00"
        d="M0 92.9v46.4h373.7V92.9H0zM168.2 0v232.2h37.3V0h-37.4zM0 232.2l124.6-77.4h27.8L27.8 232.2H0zM0 0l124.6 77.4H96.7L0 17.3V0zm221.3 77.4L345.8 0h27.9L249 77.4h-27.8zm152.4 154.8L249 154.8h28l96.7 60v17.4z"
      />
    </g>
    <path
      fill="#fff"
      d="M612.5 212.4v80c0 65.6-25.7 125.6-102.2 162.1C434 418 408.1 358 408.1 292.3v-79.8h204.5z"
    />
    <path
      fill="#fdc300"
      d="M605.7 220.6V295c0 61.2-24 117.2-95.3 151.3-71.3-34-95.4-90-95.4-151.3v-74.5h190.7z"
    />
    <g stroke="#000" strokeWidth={0.1}>
      <path
        fill="#ff9e3d"
        d="M206 52.9a2 2 0 0 0-1.3-.5c.1-1.3-.8-1.8-1.5-2-.7-.3-1-.6-1-1.1-.1-.5-.5-.9-1.1-1-.6-.2-1.2-.8-1.4-1.1-.2-.3-.3-.3-.5.2s-.9 1.5-.2 1.5c-.5.4-.8.8-.5 1.4-.3.3-.5.7-.1.8l.6.4c-.4 0-.5.8.4 1-.2 0-.3.6.1.6-.5 0-1 .8-1.6.8-.7 0-1 .2-1 .5l-.6.8c.5 0 .8 0 1-.2s.7-.3 1 0c.3.2 1 .3 1.2.2-.6.5-1 1-1.1 1.6 0 .6-.5 1.2-1 1.4-.3.2-1 .6-1.1 1.2.5 1.4 1.3 1.7 2.1 2.1 1.4.6 2.3 1.1 2.9 1.8.6.6.8.1 1.7 1.3.9 1 1.7 3.2 2.6 3.5.9.4 2 .2 2.6-1 .7-1 1-12.4-2.2-14.3z"
        transform="matrix(3.909 0 0 3.9094 -339.1 46.6)"
      />
      <path
        fill="#ff927f"
        d="M207.5 48.1c-.9 1-2 1.8-1.7 3.4s.3 4.2-1.2 5c-1.4 1-2.1 3.2-.4 4.5 1.8 1.3 1.9 2.9 2.1 4.3.3 1.5 1.1 2.7 2.3 1.7 1.2.2 1.8-.3 1.8-1.3s0-1.4 1-1.7c.8-.3 1-.6 1.5-1.4.4-.8.6-1.2.4-1.6a3.7 3.7 0 0 1-.2-2.2c.2-.7-.2-1-.4-1.5a1.9 1.9 0 0 1-.2-1.4c0-.6-.2-1-.6-1.3-.4-.3-.6-.6-.5-1 0-.5-.3-.8-.8-1.2s-.7-.8-.7-1.5-1.4-2.3-2.4-2.8z"
        transform="matrix(3.909 0 0 3.9094 -339.1 46.6)"
      />
      <path
        fill="#ff9ee1"
        d="M207.8 67.3c2-.5 1.8-3.7 1.5-5-.3-1.4-1-3.3-.5-4.9.8-2.1-1-4.2-.5-5 .5-.9.4-1.3.3-1.6 0-.2-.5-.4-.5.1 0 .6-.2.8-.5 1.1s-.3 1.2 0 2c.2.9.8 2.2 0 3.9-1 1.7-.6 2.4-.3 3.2.6 1.3 1.8 5.6.5 6.2z"
        transform="matrix(3.909 0 0 3.9094 -339.1 46.6)"
      />
      <path
        fill="none"
        d="M199 48.9c.2 0 .6 0 .6.2m-1 1.2c.2-.2.7 0 1.1-.2m-.7 1.4c.3 0 .8 0 1.3-.4m-.9 1.4c.4 0 1-.2 1.1-.7m-1 1.3c.7 0 1.5.2 1.6 0m-1.5 2.1c.4-.4 1.4-.7 1.7-1m-.6-5.5c.7.2.4.7.8 1 .6.4 0 1 .6 1.1.5.2.5.3.3.9-.1.7.5.7.3 1.2m2-.5c-.3 0-1.2 0-1.5.8m-4.8 7.7c.4 0 .5-.1.6-.3.1-.2.2-.4.5-.4s.8-.1.9-.3c0-.3.4 0 .7-.7.4-.6.6-1.3 1.4-1.6"
        transform="matrix(3.909 0 0 3.9094 -339.1 46.6)"
      />
    </g>
    <g stroke="#000" strokeWidth={0.1}>
      <path
        fill="#00a728"
        d="M221.8 73.8c.3.4 0 1 .5 1.2.7.2.1 1 .9 1.4.7.3 0 1 .7 1.5.7.3 0 1 .8 1.5 1 .5-.2 1.5.5 1.9.7.4-.2 1.4.6 1.8.7.4-.4 1.1.4 1.7.7.5-.2 1.4.5 1.9s-.4 1.2.3 1.9c.6.5-.2 1 .2 2 .3.5-.3 2.7-1.8 2.5-.6 1-2.7 1.8-3.5 1.5-.8.6-3.3 1.3-4.6.1-1.3 1.2-3.8.5-4.6 0-.8.2-3-.7-3.5-1.6-1.6.2-2.1-2-1.8-2.6.4-.8-.4-1.4.2-2 .7-.6-.5-1.3.3-1.8s-.2-1.4.5-2c.8-.5-.4-1.3.4-1.6.8-.4-.1-1.4.6-1.8.6-.4-.4-1.4.5-1.9.9-.4 0-1.2.8-1.5.7-.4 0-1.2.7-1.5.8-.3.2-1.2.9-1.4.6-.3.2-.8.5-1.3 1.7.7 6.8 1.2 9 0z"
        transform="matrix(3.909 0 0 3.9094 -339.1 46.6)"
      />
      <path
        fill="#fdc300"
        d="M213.5 76.7c0 .2 0 .5-.2.8-.5.6.2 1-.4 1.7-.5.7.1 1.2-.5 1.8-.6.6.1 1.2-.5 1.8-.6.7.1 1.2-.5 1.8-.6.6.1 1.3-.5 1.9-.6.6.1 1.4-.5 2-.7.8 0 1.4-.5 2-.5.5 0 1-.4 1.4.6-.5.6-1.3 1.1-1.6.5-.4-.1-1 .2-1.3s0-1.4.5-2 0-1.7.5-2 .1-1.6.7-2 0-1.3.4-1.8c.5-.5 0-1.3.5-2 .4-.5 0-1.1.3-1.6.2-.2.2-1.8-.2-1zm1.6.7c-.4.7.3.9-.2 1.6s.3 1.3-.3 2 .3 1.1-.2 1.8c-.5.8.2 1.2-.2 1.7-.5.6.3 1.1-.2 1.8-.6.7.2 1.2-.3 1.8-.4.6.2 1.3-.2 1.8s.3 1.2-.3 1.9.1 1-.2 1.5c.7-.2.4-1.1.7-1.3.2-.2-.1-1.5.3-1.8.4-.4-.3-1.4 0-1.8.7-.8.2-1.3.5-1.9.4-.6-.1-1.3.2-1.7.5-.7-.2-1.3.1-1.8.5-.7 0-1.2.3-1.7.5-.7 0-1.4.1-1.8.3-.3.6-1.9 0-2.1zm2.2.6c-.4 1 .3 1.3 0 2.1-.2.8.3 1.4 0 2.2-.3.9.4 1.5 0 2.6s.3 1.4 0 2.5c-.3 1.2.5 1.9 0 2.8-.6.9.6 1.2 0 2.1-.2.5 0 1.6.5.2.5-1.3-.3-1.5 0-2 .5-.6 0-2 .1-2.9.2-.7-.4-1.8 0-2.6.3-.9-.6-1.8-.2-2.5.3-.7-.2-1.6.2-2.2.3-.6-.3-1.4-.2-1.7.2-.3-.1-1.6-.4-.6z"
        transform="matrix(3.909 0 0 3.9094 -339.1 46.6)"
      />
      <path
        fill="#ef072d"
        d="M221.5 74.4c0-6.3-1-8.5-4.2-8.5-3.3 0-4.2 2.2-4.2 8.5h8.4z"
        transform="matrix(3.909 0 0 3.9094 -339.1 46.6)"
      />
      <path
        fill="none"
        d="M214.3 73.9c-.6.6.1 1-.5 1.8-.6.7 0 1.1-.5 1.8s.2 1-.4 1.7c-.5.7.2 1.2-.5 1.8-.6.6.1 1.2-.5 1.8-.6.7.1 1.2-.5 1.8-.6.6.1 1.2-.5 1.9-.6.6.1 1.4-.5 2-.7.8 0 1.4-.5 2s0 1-.4 1.4c-.4.4-.5 1-.3 1.2m6.3-19c-.6.8.3 1-.2 1.7-.5.6.2.8-.2 1.6s.3.9-.2 1.6.3 1.3-.3 2 .3 1.1-.2 1.8c-.5.8.2 1.2-.2 1.7-.5.6.3 1.1-.3 1.8-.5.7.3 1.2-.2 1.8-.4.6.2 1.3-.2 1.8s.3 1.2-.3 1.9.1 1-.2 1.5c-.3.5-.6 1.1-.3 1.3m4.6-19.8c-.3 1.2.4 2.2 0 3.2s.3 1.3 0 2.1c-.2.8.3 1.4 0 2.2-.3.9.4 1.5 0 2.6s.3 1.4 0 2.5c-.3 1.2.6 1.9 0 2.8-.6.9.5 1.1 0 2.1-.4 1 .3 1.4 0 2.4m3-20.8c.6.6-.2 1 .5 1.8.6.7 0 1.1.5 1.8s-.2 1 .3 1.7c.6.7 0 1.2.5 1.8.7.6 0 1.2.5 1.8.7.7 0 1.2.6 1.8.6.6-.2 1.2.5 1.9.6.6-.1 1.4.5 2 .7.8-.1 1.4.5 2 .5.5 0 1 .4 1.4.4.4.5 1 .3 1.2m-6.3-19c.5.8-.3 1 .2 1.7.5.6-.2.8.2 1.6.4.7-.3.9.2 1.6s-.3 1.3.3 2-.3 1.1.2 1.8c.5.8-.2 1.2.2 1.7.5.6-.3 1.1.2 1.8.6.7-.2 1.2.3 1.8.4.6-.2 1.3.2 1.8s-.3 1.2.3 1.9-.1 1 .2 1.5c.3.5.6 1.1.3 1.3"
        transform="matrix(3.909 0 0 3.9094 -339.1 46.6)"
      />
      <path
        d="M213.1 74.4c0-6.3 1-8.5 4.2-8.5-1.5 0-2.4 1.2-2.7 2s-.1.7.2.4.2.4 0 .7c-.3.4-.6 1.4-.2 1 .4-.2.7.1.2.7s-.7 2-.3 1.5c.4-.5.5.3.2.7-.2.4-.2.7 0 .6.3-.2.2.6 0 1h-1.6zm7.7-.3c0-5-.6-6.5-1.8-7-.7-.3-.7-.2-.4.3s.3 1 0 .6-.4-.5-.6-.3l.8 2c.3.6 0 1-.4.3s-.4-.1 0 .5c.5.7.4 2.9.4 3.8l2-.2z"
        transform="matrix(3.909 0 0 3.9094 -339.1 46.6)"
      />
      <path
        fill="#ef072d"
        d="M217.3 75.3c1.3 0 2.7-.2 3.7-.6 1.1-.4 1.2-.8.8-1.3-.3-.4-.9-.2-1.5.1a11.2 11.2 0 0 1-6 0c-.6-.2-1.2-.5-1.5-.1-.4.5-.4.9.8 1.3 1 .4 2.4.6 3.7.6z"
        transform="matrix(3.909 0 0 3.9094 -339.1 46.6)"
      />
    </g>
    <g fill="#b95a1e" fillRule="evenodd">
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.4 912.6v179.2c.1 75.7 19.8 105 54.3 103.6 34.4-1.3 41-58.8 34.5-92-6.6-33.3-53.2-199-53.2-199l-35.6 8.2z"
        transform="matrix(.053 -.03423 .03246 .0559 489 284.2)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.4 912.6v179.2c.1 75.7 19.8 105 54.3 103.6 34.4-1.3 41-58.8 34.5-92-6.6-33.3-53.2-199-53.2-199l-35.6 8.2z"
        transform="matrix(.0608 -.01361 .0129 .06412 500 261)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.4 912.6v179.2c.1 75.7 19.8 105 54.3 103.6 34.4-1.3 41-58.8 34.5-92-6.6-33.3-53.2-199-53.2-199l-35.6 8.2z"
        transform="matrix(.06216 0 0 .06555 509.3 249.3)"
      />
      <path
        stroke="#000"
        strokeWidth={8.1}
        d="M779.5 255.1c159.6-1.4 177.2-35.4 177.2-35.4s35.4-70.9 17.7-88.6c-17.7-17.7-194.9-17.7-194.9-17.7V255z"
        transform="matrix(.03857 0 0 .06555 527.7 292.3)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c106.3 0 124-35.4 124-35.4s35.5-70.9 17.8-88.6c-17.7-17.7-141.8-17.7-141.8-17.7V255z"
        transform="matrix(.06216 0 0 .06555 509.3 287.7)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c88.6 0 141.8-35.4 141.8-35.4s35.4-70.9 17.7-88.6c-17.7-17.7-159.5-17.7-159.5-17.7v141.7z"
        transform="matrix(.06216 0 0 .06555 509.3 283)"
      />
      <path
        stroke="#000"
        strokeWidth={5.7}
        d="M832.7 113.4s70.8-88.6 194.9-177.2c124-88.6 213.7-156.7 230.3-141.7 0 17.7-106.3 106.3-195 177.2-88.5 70.8-194.8 177.1-194.8 177.1l-35.4-35.4z"
        transform="matrix(.07714 0 0 .06555 497.2 249.5)"
      />
      <path
        stroke="#000"
        strokeWidth={5.7}
        d="M832.7 113.4s70-52 204.4-124c132.2-64 318.9-53.2 318.9-35.5-17.8 17.8-177.2 17.8-283.5 70.9C971 75.5 868 148.8 868 148.8l-35.4-35.4z"
        transform="matrix(.07714 0 0 .06555 497.9 254.1)"
      />
      <path
        stroke="#000"
        strokeWidth={5.7}
        d="M832.7 113.4s61.6-35 204.4-88.6c141.7-53.1 329.8-17.7 329.8 0-17.7 17.7-170.4 7-276.7 35.4-110 27.8-222 88.6-222 88.6l-35.5-35.4z"
        transform="matrix(.07714 0 0 .06555 498 262.1)"
      />
      <path
        stroke="#000"
        strokeWidth={5.7}
        d="M832.7 113.4s71-71 222.4-88.6c152.3-17.7 276.3 88.6 276.3 106.3-17.7 17.7-159.5-78-265.7-64.3-112.6 13.7-197.6 82-197.6 82l-35.5-35.4z"
        transform="matrix(.07714 0 0 .06555 498.4 270.3)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c159.6-1.4 159.5-45.5 159.5-45.5s35.4-70.8 17.7-88.6c-17.7-17.7-177.2-7.6-177.2-7.6V255z"
        transform="matrix(.06216 0 0 .06555 509.3 277.2)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c159.6-1.4 177.2-35.4 177.2-35.4s35.4-70.9 17.7-88.6c-17.7-17.7-194.9-17.7-194.9-17.7V255z"
        transform="matrix(.06216 0 0 .06555 509.3 272.6)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c159.6-1.4 195-35.4 195-35.4s35.3-70.9 17.6-88.6c-17.7-17.7-212.6-17.7-212.6-17.7V255z"
        transform="matrix(.06216 0 0 .06555 509.3 266.8)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c159.6-1.4 212.6-35.4 212.6-35.4s17.7-70.9 0-88.6c-17.7-17.7-212.6-17.7-212.6-17.7V255z"
        transform="matrix(.06216 0 0 .06555 509.3 261)"
      />
      <path
        stroke="#000"
        strokeWidth={5.7}
        d="M832.7 113.4S946.9 24.8 946.9-46.1c0-70.8-50.4-141.7-64.6-177.1 28.5 0 93.1 106.3 93.1 177.1 0 77.5-107.3 195-107.3 195l-35.4-35.5z"
        transform="matrix(.07714 0 0 .06555 495.7 244.7)"
      />
      <path
        stroke="#000"
        strokeWidth={5.7}
        d="M832.7 113.4s-14.3-53.2-14.3-159.5a355 355 0 0 1 85.7-230.3C910-249 847-152.4 847-46c0 77.5 21.1 195 21.1 195l-35.4-35.5z"
        transform="matrix(.07714 0 0 .06555 495.7 244.7)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c159.6-1.4 212.6-35.4 212.6-35.4s0-70.9-17.7-88.6c-17.7-17.7-194.9-17.7-194.9-17.7v141.7z"
        transform="matrix(.06216 0 0 .06555 509.3 255.2)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c159.6-1.4 195-35.4 195-35.4s0-70.9-17.8-88.6c-17.7-17.7-177.2-17.7-177.2-17.7V255z"
        transform="matrix(.06216 0 0 .06555 509.3 249.3)"
      />
      <path
        stroke="#fdc301"
        strokeWidth={16.1}
        d="M318.9 1318.1c55-122.3 70.9-336.6 70.9-372 0-99.8-33-585.2-35.5-779.6s124-301.2 248-301.2c106.4 0 177.2 71 177.2 177.2h-53.1a121 121 0 0 0-124-124c-106.3 0-188 83.7-195 248-7.5 190 21.4 683 17.8 815S374 1231.2 318.9 1318z"
        transform="matrix(-.06216 0 0 .06555 606.2 249.3)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.4 912.6v179.2c.1 75.7 19.8 105 54.3 103.6 34.4-1.3 41-58.8 34.5-92-6.6-33.3-53.2-199-53.2-199l-35.6 8.2z"
        transform="matrix(-.053 -.03423 -.03246 .0559 626.5 284.2)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 32.9C903.7 33 957.3 135.3 957 133.2l-35.7 33.3c-19 17.8-141.8 17.8-140.2 17.7l-1.6-151.3z"
        transform="matrix(.06216 0 0 .06555 509.3 249.3)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.4 912.6v179.2c.1 75.7 19.8 105 54.3 103.6 34.4-1.3 41-58.8 34.5-92-6.6-33.3-53.2-199-53.2-199l-35.6 8.2z"
        transform="matrix(-.0608 -.01361 -.0129 .06412 615.5 261)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.4 912.6v179.2c.1 75.7 19.8 105 54.3 103.6 34.4-1.3 41-58.8 34.5-92-6.6-33.3-53.2-199-53.2-199l-35.6 8.2z"
        transform="matrix(-.06216 0 0 .06555 606.2 249.3)"
      />
      <path
        stroke="#000"
        strokeWidth={8.1}
        d="M779.5 255.1c159.6-1.4 177.2-35.4 177.2-35.4s35.4-70.9 17.7-88.6c-17.7-17.7-194.9-17.7-194.9-17.7V255z"
        transform="matrix(-.03857 0 0 .06555 587.8 292.3)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c106.3 0 124-35.4 124-35.4s35.5-70.9 17.8-88.6c-17.7-17.7-141.8-17.7-141.8-17.7V255z"
        transform="matrix(-.06216 0 0 .06555 606.2 287.7)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c88.6 0 141.8-35.4 141.8-35.4s35.4-70.9 17.7-88.6c-17.7-17.7-159.5-17.7-159.5-17.7v141.7z"
        transform="matrix(-.06216 0 0 .06555 606.2 283)"
      />
      <path
        stroke="#000"
        strokeWidth={5.7}
        d="M832.7 113.4s70.8-88.6 194.9-177.2c124-88.6 213.7-156.7 230.3-141.7 0 17.7-106.3 106.3-195 177.2-88.5 70.8-194.8 177.1-194.8 177.1l-35.4-35.4z"
        transform="matrix(-.07714 0 0 .06555 618.3 249.5)"
      />
      <path
        stroke="#000"
        strokeWidth={5.7}
        d="M832.7 113.4s70-52 204.4-124c132.2-64 318.9-53.2 318.9-35.5-17.8 17.8-177.2 17.8-283.5 70.9C971 75.5 868 148.8 868 148.8l-35.4-35.4z"
        transform="matrix(-.07714 0 0 .06555 617.6 254.1)"
      />
      <path
        stroke="#000"
        strokeWidth={5.7}
        d="M832.7 113.4s61.6-35 204.4-88.6c141.7-53.1 329.8-17.7 329.8 0-17.7 17.7-170.4 7-276.7 35.4-110 27.8-222 88.6-222 88.6l-35.5-35.4z"
        transform="matrix(-.07714 0 0 .06555 617.6 262.1)"
      />
      <path
        stroke="#000"
        strokeWidth={5.7}
        d="M832.7 113.4s71-71 222.4-88.6c152.3-17.7 276.3 88.6 276.3 106.3-17.7 17.7-159.5-78-265.7-64.3-112.6 13.7-197.6 82-197.6 82l-35.5-35.4z"
        transform="matrix(-.07714 0 0 .06555 617 270.3)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c159.6-1.4 159.5-45.5 159.5-45.5s35.4-70.8 17.7-88.6c-17.7-17.7-177.2-7.6-177.2-7.6V255z"
        transform="matrix(-.06216 0 0 .06555 606.2 277.2)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c159.6-1.4 177.2-35.4 177.2-35.4s35.4-70.9 17.7-88.6c-17.7-17.7-194.9-17.7-194.9-17.7V255z"
        transform="matrix(-.06216 0 0 .06555 606.2 272.6)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c159.6-1.4 195-35.4 195-35.4s35.3-70.9 17.6-88.6c-17.7-17.7-212.6-17.7-212.6-17.7V255z"
        transform="matrix(-.06216 0 0 .06555 606.2 266.8)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c159.6-1.4 212.6-35.4 212.6-35.4s17.7-70.9 0-88.6c-17.7-17.7-212.6-17.7-212.6-17.7V255z"
        transform="matrix(-.06216 0 0 .06555 606.2 261)"
      />
      <path
        stroke="#000"
        strokeWidth={5.7}
        d="M832.7 113.4S946.9 24.8 946.9-46.1c0-70.8-50.4-141.7-64.6-177.1 28.5 0 93.1 106.3 93.1 177.1 0 77.5-107.3 195-107.3 195l-35.4-35.5z"
        transform="matrix(-.07714 0 0 .06555 619.8 244.7)"
      />
      <path
        stroke="#000"
        strokeWidth={5.7}
        d="M832.7 113.4s-14.3-53.2-14.3-159.5a355 355 0 0 1 85.7-230.3C910-249 847-152.4 847-46c0 77.5 21.1 195 21.1 195l-35.4-35.5z"
        transform="matrix(-.07714 0 0 .06555 619.8 244.7)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c159.6-1.4 212.6-35.4 212.6-35.4s0-70.9-17.7-88.6c-17.7-17.7-194.9-17.7-194.9-17.7v141.7z"
        transform="matrix(-.06216 0 0 .06555 606.2 255.2)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 255.1c159.6-1.4 195-35.4 195-35.4s0-70.9-17.8-88.6c-17.7-17.7-177.2-17.7-177.2-17.7V255z"
        transform="matrix(-.06216 0 0 .06555 606.2 249.3)"
      />
      <path
        stroke="#fdc301"
        strokeWidth={16.1}
        d="M318.9 1318.1c55-122.3 70.9-336.6 70.9-372 0-99.8-33-585.2-35.5-779.6s124-301.2 248-301.2c106.4 0 177.2 71 177.2 177.2h-53.1a121 121 0 0 0-124-124c-106.3 0-188 83.7-195 248-7.5 190 21.4 683 17.8 815S374 1231.2 318.9 1318z"
        transform="matrix(.06216 0 0 .06555 509.3 249.3)"
      />
      <path
        stroke="#000"
        strokeWidth={6.4}
        d="M779.5 32.9C903.7 33 957.3 135.3 957 133.2l-35.7 33.3c-19 17.8-141.8 17.8-140.2 17.7l-1.6-151.3z"
        transform="matrix(-.06216 0 0 .06555 606.2 249.3)"
      />
    </g>
  </svg>
	),
	TD: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#000067" d="M0 0h214v480H0z" />
      <path fill="red" d="M426 0h214v480H426z" />
      <path fill="#ff0" d="M214 0h212v480H214z" />
    </g>
  </svg>
	),
	TG: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g fillRule="evenodd" clipPath="url(#prefix__a)" transform="scale(.9375)">
      <path fill="#ffe300" d="M0 0h767.6v512H0z" />
      <path fill="#118600" d="M0 208.1h767.6V311H0zM0 .2h767.6v102.9H0z" />
      <path fill="#d80000" d="M0 .3h306.5v310.6H0z" />
      <path
        fill="#fff"
        d="M134.4 128.4c0-.8 18.9-53 18.9-53l17 52.2s57.4 1.7 57.4.8-45.3 34.3-45.3 34.3 21.4 60 20.5 58.2c-.8-1.7-49.6-36-49.6-36s-49.7 34.3-48.8 34.3c.8 0 18.8-56.5 18.8-56.5l-44.5-33.4 55.6-.9z"
      />
      <path fill="#118600" d="M0 409.2h767.6V512H0z" />
    </g>
  </svg>
	),
	TH: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#f4f5f8" d="M0 0h640v480H0z" />
      <path fill="#2d2a4a" d="M0 162.5h640v160H0z" />
      <path fill="#a51931" d="M0 0h640v82.5H0zm0 400h640v80H0z" />
    </g>
  </svg>
	),
	TJ: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#060" d="M0 0h640v480H0z" />
    <path fill="#fff" d="M0 0h640v342.9H0z" />
    <path fill="#c00" d="M0 0h640v137.1H0z" />
    <path
      fill="#f8c300"
      d="M300.8 233.6a8.6 8.6 0 0 1 16 4V272h6.4v-34.3a8.6 8.6 0 0 1 16-4 20.2 20.2 0 1 0-38.4 0"
    />
    <path
      fill="#fff"
      d="M305.4 224.7a13.7 13.7 0 0 1 14.6 6.5 13.7 13.7 0 0 1 14.6-6.5 14.7 14.7 0 0 0-29.2 0"
    />
    <path
      id="prefix__a"
      fill="#f8c300"
      d="M316.8 258.3a26 26 0 0 1-43.8 16.6 27 27 0 0 1-41 12c2.5 25 40 19.9 42.8-4.4 11.7 20.7 37.6 14.7 45.2-10.6z"
    />
    <use
      width="100%"
      height="100%"
      fill="#f8c300"
      transform="matrix(-1 0 0 1 640 0)"
      xlinkHref="#prefix__a"
    />
    <path
      id="prefix__b"
      fill="#f8c300"
      d="M291.8 302.6c-5.3 11.3-15.7 13.2-24.8 4.1 0 0 3.6-2.6 7.6-3.3-.8-3.1.7-7.5 2.9-9.8a15 15 0 0 1 6.1 8.1c5.5-.7 8.2 1 8.2 1z"
    />
    <use
      width="100%"
      height="100%"
      fill="#f8c300"
      transform="rotate(9.4 320 551.3)"
      xlinkHref="#prefix__b"
    />
    <use
      width="100%"
      height="100%"
      fill="#f8c300"
      transform="rotate(18.7 320 551.3)"
      xlinkHref="#prefix__b"
    />
    <path
      fill="none"
      stroke="#f8c300"
      strokeWidth={11}
      d="M253.5 327.8a233.1 233.1 0 0 1 133 0"
    />
    <g fill="#f8c300" transform="translate(320 164.6) scale(.68571)">
      <path
        id="prefix__c"
        d="M301930 415571l-790463-574305h977066l-790463 574305L0-513674z"
        transform="scale(.00005)"
      />
    </g>
    <g
      id="prefix__d"
      fill="#f8c300"
      transform="translate(320 260.6) scale(.68571)"
    >
      <use
        width="100%"
        height="100%"
        transform="translate(-70 -121.2)"
        xlinkHref="#prefix__c"
      />
      <use
        width="100%"
        height="100%"
        transform="translate(-121.2 -70)"
        xlinkHref="#prefix__c"
      />
      <use
        width="100%"
        height="100%"
        transform="translate(-140)"
        xlinkHref="#prefix__c"
      />
    </g>
    <use
      width="100%"
      height="100%"
      fill="#f8c300"
      transform="matrix(-1 0 0 1 640 0)"
      xlinkHref="#prefix__d"
    />
  </svg>
	),
	TK: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#00247d" d="M0 0h640v480H0z" />
    <path
      fill="#fed100"
      d="M108.1 354.6c-6.7-.1 62.8-37 120.9-84.4 76.2-62.1 240.3-161.4 288.6-177.6 5-1.7-10.3 8.6-12.3 11.9-51.5 61-10.4 176 54 233.9 19.4 14.8 18.4 15.6 54.3 17v3.4l-505.5-4.2zm-4.2 6.7s-4.9 3.5-4.9 6.1c0 2.9 5.5 6.7 5.5 6.7l498.5 5.5 9.2-6.1-12.8-7.9-495.5-4.3z"
    />
    <path
      fill="#fff"
      d="M106.8 109.1l-4 12.2 10.4-7.5 10.3 7.5-3.9-12.2 10.3-7.5h-12.8l-3.9-12.2-4 12.2H96.4zm78.1 57.4l8.6-6.3h-10.7l-3.3-10.1-3.3 10.1h-10.6l8.6 6.3-3.3 10.1 8.6-6.3 8.7 6.3zm-145.2 13l-4-12.2-3.9 12.2H19l10.3 7.5-3.9 12.2 10.3-7.5 10.4 7.5-4-12.2 10.4-7.5zm78.1 122.3l-4.6-14.2-4.6 14.2h-15l12.1 8.7-4.6 14.3 12.1-8.8 12.1 8.8-4.7-14.3 12.1-8.7z"
    />
  </svg>
	),
	TL: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g fillRule="evenodd" clipPath="url(#prefix__a)" transform="scale(.9375)">
      <path fill="#cb000f" d="M0 0h1031.2v512H0z" />
      <path fill="#f8c00c" d="M0 0c3.2 0 512 256.7 512 256.7L0 512V0z" />
      <path d="M0 0c2.1 0 340.6 256.7 340.6 256.7L0 512V0z" />
      <path
        fill="#fff"
        d="M187.7 298.2L127 284.7l-31 52.8-5-59.7-60.7-13.3 54.9-24.9-3.3-59.3 40.2 43.4 55.4-25.3-28.9 54 39.2 45.8z"
      />
    </g>
  </svg>
	),
	TM: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M42.7 0h682.6v512H42.7z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(-40) scale(.9375)"
    >
      <path fill="#28ae66" d="M0 0h768v512H0z" />
      <g fill="#fff" strokeWidth="1pt">
        <path d="M263.3 137.5c27.9 13.4 61.1 0 73.1-18.6 12.4-17.4 13.9-46.5-7.4-73.2 33 27.4 40.4 58.5 23.9 84.1-22 29.3-70.6 28.4-89.6 7.7z" />
        <path d="M312.8 69.4l5.6.1L314 73l1.7 5.6-4.7-3.3-4.5 3.3 1.5-5.5-4.5-3.5 5.6-.1L311 64zm-27.7 34.8h5.6l-4.4 3.6 1.7 5.5-4.7-3.3-4.6 3.4 1.6-5.6-4.5-3.4 5.6-.2 1.8-5.5zm1.8-27.4h5.7l-4.5 3.6 1.7 5.5-4.6-3.3-4.6 3.4 1.6-5.6-4.5-3.5 5.6-.1 1.8-5.5zm0-27.5h5.7L288 53l1.7 5.5-4.6-3.2-4.6 3.3 1.6-5.5-4.5-3.5 5.6-.1L285 44zm-30.7 34.8h5.6l-4.5 3.6 1.7 5.5-4.6-3.3-4.6 3.4 1.6-5.6-4.5-3.4 5.6-.2 1.8-5.5z" />
      </g>
      <path fill="#ca3745" d="M47.5 0h164.6v512H47.5z" />
      <g fill="#faae29" strokeWidth="1pt">
        <path d="M47.5 133.5v-3.7l6.8-9.1-1.3-1.9 4-5.4-1.3-1.9-2.7 3.7-1.4-1.8 9.6-12.8 1.4 1.8-1.4 1.8L64 108l6.8-9.2-6.9-8.9-2.7 3.4 1.4 1.9-1.4 1.8-9.6-12.8 1.4-1.8 2.7 3.6 1.4-1.8-4.1-5.5 1.3-1.8-6.8-9.2V64l9.6 12.8-1.4 1.8 4.1 5.5-2.7 3.7 2.7 3.6L64 86l9.7 13-9.7 12.6-4-5.5-2.8 3.7 2.7 3.7-4 5.4 1.3 1.9-9.6 12.8z" />
        <path d="M47.5 87.8l1.4 3.6V97H53l2.8 1.8-2.8 1.9h-4v5.4l-1.4 3.7v-22z" />
      </g>
      <g fill="#faae29" strokeWidth="1pt">
        <path d="M47.5 221.3v-3.7l6.8-9.1-1.3-1.9 4-5.5-1.3-1.8L53 203l-1.4-1.9 9.6-12.8 1.4 1.9-1.4 1.8 2.8 3.7 6.8-9.2-6.9-8.9-2.7 3.4 1.4 1.9-1.4 1.8-9.6-12.8L53 170l2.7 3.6 1.4-1.8-4.1-5.5 1.3-1.8-6.8-9.2v-3.6l9.6 12.8-1.4 1.8 4.1 5.5-2.7 3.6 2.7 3.7 4.1-5.5 9.7 13-9.7 12.6-4-5.5-2.8 3.7 2.7 3.6-4 5.5 1.3 1.9-9.6 12.8z" />
        <path d="M47.5 175.5l1.4 3.7v5.5H53l2.8 1.8-2.8 1.8h-4v5.5l-1.4 3.7v-22z" />
      </g>
      <g fill="#faae29" strokeWidth="1pt">
        <path d="M47.5 309v-3.6l6.8-9.2-1.3-1.8 4-5.5-1.3-1.8-2.7 3.6-1.4-1.8 9.6-12.8 1.4 1.8-1.4 1.9 2.8 3.7 6.8-9.2-6.9-9-2.7 3.5 1.4 1.8-1.4 1.8-9.6-12.8 1.4-1.8 2.7 3.7 1.4-1.9-4.1-5.4 1.3-1.9-6.8-9.1v-3.7l9.6 12.8-1.4 1.9 4.1 5.4-2.7 3.7 2.7 3.7 4.2-5.5 9.6 13-9.7 12.6-4-5.5-2.8 3.6 2.7 3.7-4 5.5 1.3 1.8-9.6 12.8z" />
        <path d="M47.5 263.3L49 267v5.5h4l2.8 1.8L53 276h-4v5.5l-1.4 3.7v-22z" />
      </g>
      <g fill="#faae29" strokeWidth="1pt">
        <path d="M47.5 391.3v-3.7l6.8-9.1-1.3-1.8 4-5.5-1.3-1.8L53 373l-1.4-1.8 9.6-12.8 1.4 1.8-1.4 1.8 2.8 3.7 6.8-9.1-6.9-9-2.7 3.5 1.4 1.8-1.4 1.8-9.6-12.8 1.4-1.8 2.7 3.7 1.4-1.9-4.1-5.5 1.3-1.8-6.8-9.1v-3.7l9.6 12.8-1.4 1.8 4.1 5.5-2.7 3.7 2.7 3.6 4.2-5.4 9.6 13-9.7 12.6-4-5.5-2.8 3.6 2.7 3.7-4 5.5 1.3 1.8-9.6 12.8z" />
        <path d="M47.5 345.6l1.4 3.6v5.5H53l2.8 1.9-2.8 1.8h-4v5.5l-1.4 3.6v-22z" />
      </g>
      <g fill="#faae29" strokeWidth="1pt">
        <path d="M212.1 133.5v-3.7l-6.8-9.1 1.4-1.9-4.1-5.4 1.3-1.9 2.8 3.7 1.4-1.8-9.6-12.8-1.4 1.8 1.4 1.8-2.9 3.7-6.7-9.2 6.8-8.9 2.8 3.4-1.4 1.9 1.3 1.8 9.6-12.8-1.3-1.8-2.8 3.6-1.3-1.8 4-5.5-1.3-1.8 6.8-9.2V64l-9.5 12.8 1.3 1.8-4 5.5 2.7 3.7-2.8 3.6-4.1-5.5-9.7 13 9.7 12.6 4.1-5.5 2.8 3.7-2.8 3.7 4.1 5.4-1.3 1.9 9.5 12.8z" />
        <path d="M212.1 87.8l-1.4 3.6V97h-4l-2.8 1.8 2.7 1.9h4.1v5.4l1.4 3.7v-22z" />
      </g>
      <g fill="#faae29" strokeWidth="1pt">
        <path d="M212.6 221.3v-3.7l-6.8-9.1 1.3-1.9-4-5.5 1.3-1.8 2.7 3.7 1.4-1.9-9.6-12.8-1.4 1.9 1.4 1.8-2.8 3.7-6.8-9.2 6.9-8.9 2.7 3.4-1.4 1.8 1.4 1.9 9.6-12.8-1.4-1.9-2.7 3.7-1.4-1.8 4.1-5.5-1.3-1.8 6.8-9.2v-3.6l-9.6 12.8 1.4 1.8-4.1 5.5 2.7 3.6-2.7 3.7-4.1-5.5-9.7 13 9.7 12.6 4-5.5 2.8 3.7-2.7 3.6 4 5.5-1.3 1.8 9.6 12.8z" />
        <path d="M212.6 175.5l-1.4 3.7v5.5H207l-2.8 1.8 2.8 1.8h4v5.5l1.5 3.7v-22z" />
      </g>
      <g fill="#faae29" strokeWidth="1pt">
        <path d="M212.1 309v-3.6l-6.8-9.2 1.4-1.8-4.1-5.5 1.3-1.8 2.8 3.6 1.4-1.8-9.6-12.8-1.4 1.8 1.4 1.9-2.9 3.7-6.7-9.2 6.8-9 2.8 3.5-1.4 1.8 1.3 1.8 9.6-12.8-1.3-1.8-2.8 3.7-1.3-1.9 4-5.4-1.3-1.9 6.8-9.1v-3.7l-9.5 12.8 1.3 1.9-4 5.4 2.7 3.7-2.8 3.7-4.1-5.5-9.7 13 9.7 12.6 4.1-5.5 2.8 3.6-2.8 3.7 4.1 5.5-1.3 1.8L212 309z" />
        <path d="M212.1 263.3l-1.4 3.7v5.5h-4l-2.8 1.8 2.7 1.8h4.1v5.5l1.4 3.7v-22z" />
      </g>
      <g fill="#faae29" strokeWidth="1pt">
        <path d="M212.1 391.3v-3.7l-6.8-9.1 1.4-1.8-4.1-5.5 1.3-1.8 2.8 3.6 1.4-1.8-9.6-12.8-1.4 1.8 1.4 1.8-2.9 3.7-6.7-9.1 6.8-9 2.8 3.5-1.4 1.8 1.3 1.8L208 342l-1.3-1.8-2.8 3.7-1.3-1.9 4-5.5-1.3-1.8 6.8-9.1v-3.7l-9.5 12.8 1.3 1.8-4 5.5 2.7 3.7-2.8 3.6-4.1-5.4-9.7 13 9.7 12.6 4.1-5.5 2.8 3.6-2.8 3.7 4.1 5.5-1.3 1.8 9.5 12.8z" />
        <path d="M212.1 345.6l-1.4 3.6v5.5h-4l-2.8 1.9 2.7 1.8h4.1v5.5l1.4 3.6v-22z" />
      </g>
      <path
        fill="#faae29"
        d="M47.5 34.7v-3.6l6.8-9.2-1.3-1.8 4-5.5-1.3-1.8-2.7 3.7-1.4-1.9 9.6-12.8 1.4 1.9-1.4 1.8L64 9.2 70.8 0h2.8L64 12.8l-4.2-5.5-2.7 3.7 2.7 3.6-4 5.5L57 22l-9.5 12.8zm0-34.7h8.3L53 1.8h-4v5.5L47.4 11V0zm164.6 34.7v-3.6l-6.8-9.2 1.4-1.8-4.1-5.5 1.3-1.8 2.8 3.7 1.3-1.9-9.6-12.8-1.3 1.9 1.3 1.8-2.8 3.7-6.8-9.2H186l9.7 12.8 4.1-5.5 2.8 3.7-2.8 3.6 4.1 5.5-1.3 1.8 9.5 12.8zm0-34.7h-8.2l2.7 1.8h4.1v5.5l1.4 3.7V0zM116.1 504.7s6-10.4 20.8-13.5c14.9-3.2 17.5 6.9 26 6.9s22-7 22-7-13.5 13.3-24 13c-10.3-.3-13.8-7-24.5-6-10.6 1-20.3 6.9-20.3 6.6z"
      />
      <path
        fill="#faae29"
        d="M144.8 504.7s-5.9-10.4-20.7-13.5c-15-3.2-17.5 6.9-26 6.9s-22-7-22-7 13.5 13.3 23.9 13c10.4-.3 14-7 24.5-6 10.7 1 20.3 6.9 20.3 6.6z"
      />
      <g fill="#faae29" strokeWidth="1pt">
        <path d="M96.2 487.5c-1.3-2.7-4.6-14.7-2.9-16.2 2.7-1 9.7 11.3 9 22.2-4.6 2.5-20-1-19.9-4.2 1.1-4.5 9.9-3 13.8-1.8z" />
        <path d="M86.8 477c-.8-3-2.2-15.6-.2-16.6 2.7-.2 7.6 13.7 5.3 24.2-4.9 1.2-19.5-6.5-18.8-9.6 1.8-4 10-.2 13.7 2z" />
        <path d="M79.2 465.4c-.6-3.2-.8-16 1.2-16.6 2.7.2 6.4 14.8 3.2 24.9-5 .4-18.8-9.6-17.8-12.5 2-3.8 10 1.3 13.4 4.2z" />
        <path d="M73.2 453c-.2-3.3 1-16 3.1-16.2 2.7.7 4.6 15.9.2 25.2-4.9-.6-17.4-13.3-16-16 2.4-3.3 9.7 3.4 12.7 7z" />
        <path d="M69 439.9c.2-3.3 2.8-15.5 4.9-15.4 2.5 1.3 2.8 16.6-2.5 25-4.8-1.6-15.9-16.5-14.3-19 2.9-2.8 9.3 5.3 12 9.4z" />
        <path d="M70.2 425c-.3 13-2.7 13.2-7 3.6-2-3.7-2.2-18.7-.5-19.3 2.5 0 7.4 10.7 7.5 15.7z" />
      </g>
      <g fill="#faae29" strokeWidth="1pt">
        <path d="M164 489c1.3-2.8 4.6-14.8 2.9-16.3-2.7-1-9.6 11.2-9 22.2 4.6 2.5 20.1-1 19.9-4.2-1.1-4.5-9.8-3-13.8-1.8z" />
        <path d="M173.4 478.4c.9-3 2.2-15.6.3-16.6-2.7-.2-7.7 13.6-5.3 24.2 4.8 1.2 19.5-6.5 18.7-9.6-1.7-4.1-10-.2-13.7 2z" />
        <path d="M181 466.8c.6-3.2.8-16-1.2-16.6-2.7.2-6.4 14.7-3.1 24.8 5 .4 18.8-9.5 17.8-12.5-2.2-3.8-10 1.4-13.5 4.3z" />
        <path d="M187 454.3c.2-3.2-1-15.9-3.1-16.1-2.7.7-4.6 15.9-.2 25.2 5-.6 17.4-13.3 16.1-16-2.5-3.4-9.7 3.4-12.8 6.9z" />
        <path d="M191.2 441.2c-.1-3.2-2.8-15.5-4.8-15.3-2.6 1.2-2.9 16.6 2.5 25 4.8-1.6 15.8-16.5 14.2-19-2.9-2.8-9.3 5.3-12 9.3z" />
        <path d="M190 426.4c.4 13 2.7 13.1 7 3.5 2-3.6 2.2-18.7.5-19.2-2.5 0-7.4 10.7-7.5 15.7z" />
      </g>
      <g transform="matrix(.99985 0 0 1.26515 188.3 -77)">
        <path
          fill="#ca3745"
          stroke="#000"
          strokeWidth={0.1}
          d="M-3.5 290.6H-9v3.5h-5.3v3.5h-21.2l-3.6 3.6 1.8 1.8h8.9l1.7-1.8h-8.8l1.7-1.8h12.4l-5.3 5.3H-39l-3.5-1.7-3.6 1.7h-12.4l-5.3-5.3h12.4l1.8 1.8h-8.9l1.8 1.8h8.9l1.7-1.8-3.5-3.6h-19.5v-3.5h-5.3v-3.5h-5.3v-16h5.3v-3.5h5.3v-3.6h19.5l3.5-3.5-1.7-1.8h-8.9l-1.8 1.8h8.9l-1.8 1.7h-12.4l5.3-5.3H-46l3.6 1.8 3.5-1.8h12.4l5.3 5.3h-12.4l-1.7-1.7h8.8l-1.8-1.8h-8.8L-39 264l3.6 3.5h21.2v3.6h5.3v3.5h5.4v16z"
          transform="matrix(1.4884 0 0 1.24 3.5 -39.5)"
        />
        <path
          fill="#28ae66"
          stroke="#faae29"
          strokeWidth={1.4}
          d="M375.6 499.7v24.8h10.6v7h10.6v7h35.5l14.2 10.7 14.1-10.6h39v-7l10.6-.1v-7H521v-24.9h-10.7v-7h-10.6v-7.2h-39l-14.1-10.6-14.2 10.6h-35.5v7.2h-10.6v7h-10.6z"
          transform="matrix(.74419 0 0 .62 -392 -6.5)"
        />
        <path
          fill="#ca3745"
          d="M-75.6 296.6l-15.8 11v-11h15.8zm31.6 0l15.9 11v-11H-44zm-31.6 28.6l-15.8-11v11h15.8zm31.6 0l15.9-11v11H-44zm5.3-22l-5.3 4.4h10.6l-5.3-4.4zm-42.2 0l-5.2 4.4h10.5l-5.3-4.4zm0 15.4l-5.2-4.4h10.5l-5.3 4.4zm42.2 0l-5.3-4.4h10.6l-5.3 4.4z"
        />
        <path
          fill="#faae29"
          d="M-59.8 329.6l-5.3-4.4h10.6l-5.3 4.4zm0-22l-5.3-4.4h10.6l-5.3 4.4zm0-15.4l-5.3 4.5h10.6l-5.3-4.5zm0 22l-5.3 4.4h10.6l-5.3-4.4z"
        />
        <path
          fill="#faae29"
          stroke="#000"
          strokeWidth={0.1}
          d="M467.7 506.7H482v3.5h-14.2z"
          transform="matrix(.74419 0 0 .62 -392 -6.5)"
        />
        <path
          fill="#c00"
          stroke="#000"
          strokeWidth={0.1}
          d="M414.6 510.2h7v3.6h-7zm56.7 0h7v3.6h-7z"
          transform="matrix(.74419 0 0 .62 -392 -6.5)"
        />
        <path
          fill="#900"
          stroke="#000"
          strokeWidth={0.1}
          d="M439.4 489h14.1v3.5h-14.1zm0 7h14.1v3.6h-14.1z"
          transform="matrix(.74419 0 0 .62 -392 -6.5)"
        />
        <path
          fill="#900"
          stroke="#000"
          strokeWidth={0.1}
          d="M435.8 492.5h21.3v3.6h-21.3zm3.6 32h14.1v3.4h-14.1zm0 7h14.1v3.5h-14.1zm-3.6-3.5h21.3v3.5h-21.3z"
          transform="matrix(.74419 0 0 .62 -392 -6.5)"
        />
        <path
          fill="#faae29"
          stroke="#000"
          strokeWidth={0.1}
          d="M467.7 513.8H482v3.5h-14.2zm-56.7-7.1h14.2v3.5H411zm0 7h14.2v3.6H411zm-3.5-3.5h7v3.6h-7zm14.2 0h7v3.6h-7zm42.5 0h7v3.6h-7zm14.2 0h7v3.6h-7z"
          transform="matrix(.74419 0 0 .62 -392 -6.5)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -374.1 -39)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -367.6 -39)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -361 -39)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -371.5 -41.1)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -363.7 -41.1)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -371.6 -36.8)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -363.7 -36.7)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -353.2 -50)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -346.6 -50)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -340 -50)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -350.5 -52.2)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -342.7 -52.2)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -350.6 -47.9)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -342.7 -47.8)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -374.2 -60.9)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -367.6 -60.9)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -361 -61)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -371.6 -63.1)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -363.7 -63.1)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -371.6 -58.8)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -363.7 -58.7)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -395.3 -49.8)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -388.7 -49.8)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -382.1 -49.9)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -392.6 -52)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -384.8 -52)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -392.7 -47.7)"
        />
        <ellipse
          cx={413.7}
          cy={582}
          fill="#fff"
          rx={0.9}
          ry={0.9}
          transform="matrix(.74419 0 0 .62 -384.8 -47.6)"
        />
      </g>
      <path
        fill="#fff"
        d="M138.9 255.8l4.5-2.2 4.6 2.2h-9.1zm-13.6 0l4.5-2.2 4.6 2.2h-9.1zm-13.6 0l4.5-2.2 4.6 2.2h-9.1zm27.2-49l4.5 2.2 4.6-2.1h-9.1zm-13.6 0l4.5 2.2 4.6-2.1h-9.1zm-13.6 0l4.5 2.2 4.6-2.1h-9.1z"
      />
      <path
        fill="#28ae66"
        d="M135.1 262.1l-5.3 4.3-5.3-4.3-5.3 4.3-5.3-4.3v2.2l3.6 2-1.8 2.2v2.1h1.8l1.7-2 1.8 2h1.8v-2l-1.8-2.2 3.5-2.1 3.6 2-1.8 2.2v2.1h1.8l1.7-2 1.8 2h1.7v-2l-1.7-2.2 3.5-2.1 3.5 2-1.7 2.2v2.1h1.7l1.8-2 1.8 2h1.7v-2l-1.7-2.2 3.5-2.1V262l-5.3 4.3-5.3-4.3zm0-61.6l-5.3-4.3-5.3 4.3-5.3-4.3-5.3 4.3v-2.1l3.6-2.2-1.8-2V192h1.8l1.7 2.1 1.8-2.1h1.8v2.1l-1.8 2.2 3.5 2 3.6-2-1.8-2.2V192h1.8l1.7 2.1 1.8-2.1h1.7v2.1l-1.7 2.2 3.5 2 3.5-2-1.7-2.2V192h1.7l1.8 2.1 1.8-2.1h1.7v2.1l-1.7 2.2 3.5 2v2.2l-5.3-4.3-5.3 4.3zm40 35.4l5.8-4.6-5.7-4.6 5.7-4.6-5.7-4.6h2.8l2.9 3 2.8-1.5h2.8v1.6l-2.8 1.5 2.8 1.5v1.6h-2.8l-2.8-1.6-2.9 3.1 2.9 3 2.8-1.4h2.8v1.5l-2.8 1.5 2.8 1.5v1.6h-2.8l-2.8-1.6-2.9 3.1 2.9 3 2.8-1.5h2.8v1.6l-2.8 1.5 2.8 1.6v1.5h-2.8l-2.8-1.5-2.9 3h-2.8l5.7-4.6-5.7-4.6zm-90.6 0l-5.7-4.6 5.7-4.6-5.7-4.6 5.7-4.6h-2.9l-2.8 3L76 219h-3v1.6l3 1.4-2.9 1.5v1.6H76l2.8-1.6 2.8 3.1-2.8 3-2.8-1.4h-3v1.5l2.9 1.5-2.9 1.5v1.6h3l2.8-1.6 2.8 3.1-2.8 3.1-2.8-1.5h-3v1.5l2.9 1.5L73 242v1.5h3l2.8-1.5 2.8 3h2.9l-5.7-4.6 5.7-4.6z"
      />
      <path
        fill="#28ae66"
        stroke="#000"
        strokeWidth={0.3}
        d="M-26.6 214.4h1.8v1.7h-1.8zm-1.8 1.7h1.8v1.8h-1.7zm-8.8 8.9h1.8v1.8h-1.8zm1.8-1.8h1.7v1.8h-1.7zm-58.5 0h1.8v1.8H-94zm-8.9-8.8h1.8v1.7h-1.8zm1.8 1.7h1.8v1.8h-1.8zm0-39h1.8v1.8h-1.8zm-1.8 1.8h1.8v1.8h-1.8zm10.7-10.6h1.7v1.8H-92zm-1.8 1.8h1.8v1.8H-94zm56.7-1.8h1.8v1.8h-1.8zm1.8 1.8h1.7v1.8h-1.7zm7 7h1.8v1.8h-1.7zm1.8 1.9h1.8v1.7h-1.8zM-92 225h1.7v1.8H-92z"
        transform="matrix(1.2798 0 0 1.1995 211.4 -5.6)"
      />
      <path
        fill="#fff"
        d="M122.9 231.3h-6.7v-4.2h4.5v-3.9h4.4v-3.6h4.5v4.5c-3.7 0-6.7 3-6.7 7.2z"
      />
      <path
        fill="#faae29"
        d="M136.3 231.3h6.7v-4.2h-4.5v-3.9H134v-3.6h-4.4v4.5c3.7 0 6.7 3 6.7 7.2z"
      />
      <path
        fill="#fff"
        d="M136.3 231.3h6.7v4.2h-4.5v3.9H134v3.6h-4.4v-4.5c3.7 0 6.7-3 6.7-7.2z"
      />
      <path
        fill="#faae29"
        d="M122.9 231.3h-6.7v4.2h4.5v3.9h4.4v3.6h4.5v-4.5c-3.7 0-6.7-3-6.7-7.2z"
      />
      <path fill="#28ae66" d="M136.3 231.3h-6.7v-7.2c3.7 0 6.7 3.3 6.7 7.2z" />
      <path fill="#ca3745" d="M136.3 231.3h-6.7v7.2c3.7 0 6.7-3.2 6.7-7.2z" />
      <path fill="#28ae66" d="M122.9 231.3h6.7v7.2c-3.7 0-6.7-3.2-6.7-7.2z" />
      <path fill="#ca3745" d="M122.9 231.3h6.7v-7.2c-3.7 0-6.7 3.3-6.7 7.2z" />
      <path
        fill="#28ae66"
        d="M136.6 257.9l-6.8-4.3-6.8 4.3-6.8-4.3-6.8 4.3v-2.1l4.5-2.2-2.2-2.1v-2.1h2.2l2.3 2.1 2.3-2.1h2.3v2.1l-2.3 2.1 4.5 2.2 4.6-2.2-2.3-2.1v-2.1h2.3l2.2 2.1 2.3-2.1h2.3v2.1l-2.3 2.1 4.5 2.2 4.6-2.2-2.3-2.1v-2.1h2.3l2.2 2.1 2.3-2.1h2.3v2.1l-2.3 2.1 4.5 2.2v2l-6.8-4.2-6.8 4.3zm0-53.1l-6.8 4.2-6.8-4.2-6.8 4.2-6.8-4.2v2l4.5 2.2-2.2 2.1v2.2h2.2l2.3-2.2 2.3 2.2h2.3V211l-2.3-2 4.5-2.2 4.6 2.1-2.3 2.1v2.2h2.3l2.2-2.2 2.3 2.2h2.3V211l-2.3-2 4.5-2.2 4.6 2.1-2.3 2.1v2.2h2.3l2.2-2.2 2.3 2.2h2.3V211l-2.3-2 4.5-2.2v-2.1l-6.8 4.2-6.8-4.2zm25 31.8l-3.4-5.3 3.4-5.3-3.4-5.3 3.4-5.3h-1.7l-1.7 3.5-1.7-1.8h-1.7v1.8l1.7 1.8-1.7 1.8v1.7h1.7l1.7-1.7 1.7 3.5-1.7 3.5-1.7-1.7h-1.7v1.7l1.7 1.8-1.7 1.8v1.8h1.7l1.7-1.8 1.7 3.5-1.7 3.6-1.7-1.8h-1.7v1.8l1.7 1.7-1.7 1.8v1.8h1.7l1.7-1.8 1.7 3.6h1.7l-3.4-5.4 3.4-5.3z"
      />
      <path
        fill="#28ae66"
        stroke="#000"
        strokeWidth={0.4}
        d="M-101 177.2l-7 7v26.6l7 7.1h32l7-7v-26.6l-7.1-7.1H-101zm-1.8-5.4l-17.7 17.8v16l17.8 17.6h35.4l17.7-17.7v-16l-17.7-17.7h-35.4z"
        transform="matrix(1.2798 0 0 1.1995 238.7 -5.6)"
      />
      <path
        fill="#faae29"
        stroke="#000"
        strokeWidth={0.3}
        d="M-93.9 147l3.5 5.4 3.6-5.4H-94z"
        transform="matrix(1.02384 0 0 .79966 215 140.3)"
      />
      <path
        fill="#faae29"
        stroke="#000"
        strokeWidth={0.3}
        d="M-93.9 147l3.5 5.4 3.6-5.4H-94z"
        transform="matrix(1.02384 0 0 -.79966 215 322.3)"
      />
      <path
        fill="#faae29"
        stroke="#000"
        strokeWidth={0.3}
        d="M-93.9 147l3.5 5.4 3.6-5.4H-94z"
        transform="matrix(1.02384 0 0 -.79966 229.6 322.3)"
      />
      <path
        fill="#faae29"
        stroke="#000"
        strokeWidth={0.3}
        d="M-93.9 147l3.5 5.4 3.6-5.4H-94z"
        transform="matrix(1.02384 0 0 .79966 229.6 140.3)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-93.9 147l3.5 5.4 3.6-5.4H-94z"
        transform="matrix(1.02384 0 0 -.79966 207.8 322.3)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-93.9 147l3.5 5.4 3.6-5.4H-94z"
        transform="matrix(1.02384 0 0 -.79966 222.3 322.3)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-93.9 147l3.5 5.4 3.6-5.4H-94z"
        transform="matrix(1.02384 0 0 -.79966 236.8 322.3)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-104.5 180.7l3.5-3.5h-3.5v3.5z"
        transform="matrix(1.9196 0 0 -1.7991 303.3 576.6)"
      />
      <path
        fill="#28ae66"
        d="M98 236.6l3.5-5.3L98 226l3.4-5.3-3.4-5.3h1.7l1.7 3.5 1.7-1.8h1.7v1.8l-1.7 1.8 1.7 1.8v1.7h-1.7l-1.7-1.7-1.7 3.5 1.7 3.5 1.7-1.7h1.7v1.7l-1.7 1.8 1.7 1.8v1.8h-1.7l-1.7-1.8-1.7 3.5 1.7 3.6 1.7-1.8h1.7v1.8l-1.7 1.7 1.7 1.8v1.8h-1.7l-1.7-1.8-1.7 3.6H98l3.4-5.4-3.4-5.3z"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z"
        transform="matrix(1.2798 0 0 1.07958 261.3 59.2)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.4}
        d="M-99.2 180.7l-3.6 3.6v26.5l3.6 3.6h-5.3v-33.7h5.3z"
        transform="matrix(1.2798 0 0 1.1995 229.6 -5.6)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-93.9 147l3.5 5.4 3.6-5.4H-94z"
        transform="matrix(1.02384 0 0 .79966 207.8 140.3)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-93.9 147l3.5 5.4 3.6-5.4H-94z"
        transform="matrix(1.02384 0 0 .79966 222.3 140.3)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-93.9 147l3.5 5.4 3.6-5.4H-94z"
        transform="matrix(1.02384 0 0 .79966 236.8 140.3)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.4}
        d="M-99.2 180.7l-3.6 3.6v26.5l3.6 3.6h-5.3v-33.7h5.3z"
        transform="matrix(-1.2798 0 0 1.1995 30 -5.6)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-104.5 180.7l3.5-3.5h-3.5v3.5z"
        transform="matrix(-1.9196 0 0 -1.7991 -43.6 576.6)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-104.5 180.7l3.5-3.5h-3.5v3.5z"
        transform="matrix(-1.9196 0 0 1.7991 -43.6 -114)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-104.5 180.7l3.5-3.5h-3.5v3.5z"
        transform="matrix(1.9196 0 0 1.7991 303.3 -114)"
      />
      <path
        fill="#28ae66"
        stroke="#000"
        strokeWidth={0.4}
        d="M-101 177.2l-7 7v26.6l7 7.1h32l7-7v-26.6l-7.1-7.1H-101zm0-1.8l-8.8 8.8v26.6l8.8 8.9h32l8.8-8.9v-26.6l-8.9-8.8H-101z"
        transform="matrix(1.2798 0 0 1.1995 238.7 -5.6)"
      />
      <path
        fill="#faae29"
        stroke="#000"
        strokeWidth={0.3}
        d="M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z"
        transform="matrix(1.2798 0 0 1.07965 261.3 63)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z"
        transform="matrix(1.2798 0 0 1.07958 261.3 66.8)"
      />
      <path
        fill="#faae29"
        stroke="#000"
        strokeWidth={0.3}
        d="M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z"
        transform="matrix(1.2798 0 0 1.07965 261.3 70.6)"
      />
      <path
        fill="#faae29"
        stroke="#000"
        strokeWidth={0.3}
        d="M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z"
        transform="matrix(1.2798 0 0 1.07965 261.3 55.3)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z"
        transform="matrix(-1.2798 0 0 1.07958 -1.7 59.2)"
      />
      <path
        fill="#faae29"
        stroke="#000"
        strokeWidth={0.3}
        d="M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z"
        transform="matrix(-1.2798 0 0 1.07965 -1.7 63)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z"
        transform="matrix(-1.2798 0 0 1.07958 -1.7 66.8)"
      />
      <path
        fill="#faae29"
        stroke="#000"
        strokeWidth={0.3}
        d="M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z"
        transform="matrix(-1.2798 0 0 1.07965 -1.7 70.6)"
      />
      <path
        fill="#faae29"
        stroke="#000"
        strokeWidth={0.3}
        d="M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z"
        transform="matrix(-1.2798 0 0 1.07965 -1.7 55.3)"
      />
      <path
        fill="#970000"
        stroke="#000"
        strokeWidth={0.3}
        d="M-101 179v37h8.9v8.9h56.7V216h8.8v-37h-8.8v-8.8h-56.7v8.8h-8.9zm1.8 1.7v33.7h8.8v8.8h53.2v-8.8h8.9v-33.7h-8.9V172h-53.2v8.8h-8.8z"
        transform="matrix(1.2798 0 0 1.1995 211.4 -5.6)"
      />
      <path
        fill="#ca3745"
        stroke="#000"
        strokeWidth={0.3}
        d="M-28.4 69.1l-5.3-7.1v-5.3l-5.3-5.3h-10.6l-8.9-5.3h-28.3l-8.9 5.3h-10.6l-5.3 5.3V62l-5.3 7v14.3l5.3 7v5.4l5.3 5.3h10.6l8.9 5.3h28.3l8.9-5.3H-39l5.4-5.3v-5.3l5.3-7.1V69z"
        transform="matrix(1.2798 0 0 1.1535 222.8 -36.7)"
      />
      <path
        fill="#faae29"
        d="M75.4 51.2v6.1l6.8 8.2v6.1l6.8 6.2h13.6l11.4 6h15.8V51.3H75.4z"
      />
      <path
        fill="#ca3745"
        d="M110.7 65.5l-8.3 5.3h-5l1.7 1.7-3.3 3.5 1.7 1.8 5-1.8 1.6 1.8.7-4.7 9.2-5.6-3.3-2z"
      />
      <path
        fill="#ca3745"
        d="M101.6 61.4l-8.3 5.3h-4.9l1.6 1.7-3.2 3.5 1.6 1.8 5-1.8 1.6 1.8.8-4.7 9.1-5.5-3.3-2zm-4.5-8.2l-8.3 5.3h-5l1.7 1.8-3.3 3.5 1.7 1.7 5-1.8 1.6 1.8.7-4.7 9.2-5.5-3.3-2z"
      />
      <path
        fill="#faae29"
        d="M184.2 51.2v-6.1l-6.8-8.2v-6.1l-6.8-6.2H157l-11.3-6.1h-15.9v32.7h54.4z"
      />
      <path
        fill="#ca3745"
        d="M129.8 83.9h-4.2l-4.8-4.1H113l-4.2-2 2.1-2 4.2 2h4.2l4.2-6.2 6.3 2v4.2h-6.3l6.3 6z"
      />
      <path
        fill="#fff"
        d="M75.4 51.2v-6.1l6.8-8.2v-6.1l6.8-6.2h13.6l11.4-6.1h15.8v32.7H75.4z"
      />
      <path
        fill="#ca3745"
        d="M129.8 18.5h-4.2l-4.8 4H113l-4.2 2.1 2.1 2 4.2-2h4.2l4.2 6.2 6.3-2v-4.2h-6.3l6.3-6.1z"
      />
      <path
        fill="#ca3745"
        d="M129.8 18.5h4.2l4.9 4h7.7l4.2 2.1-2 2-4.3-2h-4.2l-4.2 6.2-6.3-2v-4.2h6.3l-6.3-6.1z"
      />
      <path
        fill="#fff"
        d="M184.2 51.2v6.1l-6.8 8.2v6.1l-6.8 6.2H157l-11.3 6h-15.9V51.3h54.4z"
      />
      <path
        fill="#ca3745"
        d="M129.8 83.9h4.2l4.9-4.1h7.7l4.2-2-2-2-4.3 2h-4.2l-4.2-6.2-6.3 2v4.2h6.3l-6.3 6zm-28.2-43l-8.3-5.2h-4.9L90 34l-3.2-3.5 1.6-1.8 5 1.8 1.6-1.8.8 4.7 9.1 5.5-3.3 2zm47.4-4l8.2-5.3h5l-1.7-1.7 3.3-3.5-1.6-1.8-5 1.8-1.6-1.8-.8 4.7-9.1 5.6 3.3 2z"
      />
      <path
        fill="#ca3745"
        d="M110.7 36.9l-8.3-5.3h-5l1.7-1.7-3.3-3.5 1.7-1.8 5 1.8 1.6-1.8.7 4.7 9.2 5.5-3.3 2zM97 49.2l-8.3-5.3h-5l1.7-1.8-3.3-3.5L84 37l5 1.8 1.6-1.8.7 4.7 9.2 5.5-3.3 2z"
      />
      <path
        fill="#fff"
        d="M79.5 51.2h2l2.1 2 2.1-2h44.1v28.6h-2l2 2V84l-6.3-6.1v-2h2.1v2h2.1v-2l-17-9H96.3v-9L90 53.4h-4.2l-2.1 2 2 2h-2l-4.2-6z"
      />
      <path
        fill="#faae29"
        d="M79.5 51.2h2l2.1-2 2.1 2h44.1V22.6h-2l2-2v-2.1l-6.3 6.1v2h2.1v-2h2.1v2l-17 9.1H96.3v8.9L90 49.2h-4.2l-2.1-2 2-2.1h-2l-4.2 6.1z"
      />
      <path
        fill="#28ae66"
        d="M89 51.2h40.8v24.5l-18.1-10.2H98.1v-8.2l-9-6.1z"
      />
      <path
        fill="#ca3745"
        d="M158 41l8.3-5.3h5l-1.7-1.7 3.3-3.5-1.6-1.8-5 1.8-1.6-1.8-.8 4.7-9.1 5.5 3.2 2zm4.6 8.2l8.3-5.3h4.9l-1.7-1.8 3.3-3.5-1.6-1.7-5 1.8-1.6-1.8-.8 4.7-9.1 5.5 3.3 2z"
      />
      <path
        fill="#fff"
        d="M180.2 51.2h-2.1l-2.1-2-2.1 2h-44.1V22.6h2.1l-2.1-2v-2.1l6.3 6.1v2H134v-2h-2.1v2l17 9.1h14.4v8.9l6.4 4.6h4.2l2-2-2-2.1h2l4.3 6.1z"
      />
      <path
        fill="#28ae66"
        d="M170.6 51.2h-40.8V26.7L148 36.9h13.6v8.2l9.1 6.1z"
      />
      <path
        fill="#ca3745"
        d="M149 65.5l8.2 5.3h5l-1.7 1.7 3.3 3.5-1.6 1.8-5-1.8-1.6 1.8-.8-4.7-9.1-5.6 3.3-2z"
      />
      <path
        fill="#ca3745"
        d="M158 61.4l8.3 5.3h5l-1.7 1.7 3.3 3.5-1.6 1.8-5-1.8-1.6 1.8-.8-4.7-9.1-5.5 3.2-2zm4.6-8.2l8.3 5.3h4.9l-1.7 1.7 3.3 3.5-1.6 1.8-5-1.8-1.6 1.8-.8-4.7-9.1-5.5 3.3-2z"
      />
      <path
        fill="#faae29"
        d="M180.2 51.2h-2.1l-2.1 2-2.1-2h-44.1v28.6h2.1l-2.1 2V84l6.3-6.1v-2H134v2h-2.1v-2l17-9h14.4v-9l6.4-4.5h4.2l2 2-2 2h2l4.3-6z"
      />
      <path
        fill="#ca3745"
        d="M170.6 51.2h-40.8v24.5L148 65.5h13.6v-8.2l9.1-6.1zm-81.6 0h40.8V26.7l-18.1 10.2H98.1v8.2l-9 6.1z"
      />
      <path
        fill="#ca3745"
        d="M134.3 51.2l11.4-6.1h6.8l-2.3-2 4.6-4.2-2.3-2-6.8 2-2.3-2-1 5.5-12.6 6.4 4.5 2.4zm-9 0L114 57.3h-6.8l2.2 2-4.5 4.2 2.3 2 6.8-2 2.2 2 1-5.5 12.6-6.4-4.5-2.4z"
      />
      <path
        fill="#28ae66"
        d="M125.3 51.2L114 45.1h-6.8l2.3-2-4.5-4.2 2.3-2 6.8 2 2.2-2 1 5.5 12.6 6.4-4.5 2.4zm9 0l11.4 6.1h6.8l-2.3 2 4.6 4.2-2.3 2-6.8-2-2.3 2-1-5.5-12.6-6.4 4.5-2.4z"
      />
      <path
        fill="#fff"
        d="M116.2 51.2L129.8 41l13.6 10.2-13.6 10.2-13.6-10.2z"
      />
      <path
        fill="#ca3745"
        d="M85.7 55.3l2.1 2-2 2h-2.2l-6.3-8.1h2.1l4.2 6.1h2.1l-2-2 2-2H90v2h-4.2z"
      />
      <path
        fill="#ca3745"
        d="M85.7 47.1l2.1-2-2-2h-2.2l-6.3 8.1h2.1l4.2-6.1h2.1l-2 2 2 2H90v-2h-4.2zm88.2 8.2l-2 2 2 2h2.1l6.3-8.1h-2l-4.3 6.1h-2l2-2-2-2h-4.3v2h4.2z"
      />
      <path
        fill="#ca3745"
        d="M174 47.1l-2.2-2 2.1-2h2.1l6.3 8.1h-2l-4.3-6.1h-2l2 2-2 2h-4.3v-2h4.2zm-46.3-4h4.2v16.3h-4.2z"
      />
      <path fill="#ca3745" d="M121.4 47.1h16.8v8.2h-16.8z" />
      <path
        fill="#28ae66"
        stroke="#000"
        strokeWidth={0.1}
        d="M333 170l-10.6 5.4v8.8l10.7 5.4h10.6l10.6-5.4v-8.8l-10.6-5.3h-10.6z"
        transform="matrix(3.555 0 0 3.847 -1073.2 -292.2)"
      />
      <path
        fill="#c00"
        d="M87.2 396.3h2.2V392H94v4.2h2.3v-9.8H94v4.2h-4.5v-4.2h-2.3v9.8zm57.9 32.6h2.3v-4.2h4.5v4.2h2.3V419H152v4.2h-4.6V419h-2.2v9.8zm-36.6-49h2.3v-4.1h4.6v4.2h2.2v-9.8h-2.2v4.2h-4.6v-4.2h-2.3v9.8zm33.5 0h2.3v-4.1h4.6v4.2h2.3v-9.8h-2.3v4.2h-4.6v-4.2H142v9.8zm21.4 16.4h2.2V392h4.6v4.2h2.3v-9.8h-2.3v4.2h-4.6v-4.2h-2.2v9.8zm0 16.3h2.2v-4.2h4.6v4.2h2.3v-9.8h-2.3v4.2h-4.6v-4.2h-2.2v9.8z"
      />
      <path
        fill="#faae29"
        d="M129.8 435.4v-35.9h54.9v16.3L148 435.4h-18.3zm0-71.7v35.8H75v-16.3l36.5-19.5h18.3z"
      />
      <path
        fill="#fff"
        d="M129.8 363.7v35.8h54.9v-16.3L148 363.7h-18.3zm0 71.7v-35.9H75v16.3l36.5 19.6h18.3z"
      />
      <path
        fill="#faae29"
        stroke="#000"
        strokeWidth={0.1}
        d="M-177.2 368.5h21.3l-21.3-10.6v10.6zm24.8-1.8v17.7H-186v-14.1h-7.1l-8.9-5.3v-12.4l5.4-5.4h-7.1V365h-1.8v-19.5h17.7l35.4 21.2z"
        transform="matrix(1.0321 0 0 .92 342 45.9)"
      />
      <path
        fill="#ca3745"
        d="M111.5 388.1V411h5.5l12.8 6.6 12.8-6.6h5.5v-22.8h-5.5l-12.8-6.5-12.8 6.5h-5.5z"
      />
      <path
        fill="#faae29"
        stroke="#000"
        strokeWidth={0.1}
        d="M-177.2 368.5h21.3l-21.3-10.6v10.6zm24.8-1.8v17.7H-186v-14.1h-7.1l-8.9-5.3v-12.4l5.4-5.4h-7.1V365h-1.8v-19.5h17.7l35.4 21.2z"
        transform="matrix(-1.0321 0 0 -.92 -82.3 753.2)"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={0.1}
        d="M-177.2 368.5h21.3l-21.3-10.6v10.6zm24.8-1.8v17.7H-186v-14.1h-7.1l-8.9-5.3v-12.4l5.4-5.4h-7.1V365h-1.8v-19.5h17.7l35.4 21.2z"
        transform="matrix(-1.0321 0 0 .92 -82.3 45.9)"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={0.1}
        d="M-177.2 368.5h21.3l-21.3-10.6v10.6zm24.8-1.8v17.7H-186v-14.1h-7.1l-8.9-5.3v-12.4l5.4-5.4h-7.1V365h-1.8v-19.5h17.7l35.4 21.2z"
        transform="matrix(1.0321 0 0 -.92 342 753.2)"
      />
      <path
        fill="#ca3745"
        d="M86 412.6h2.2v-5h4.6v5h2.3v-11.4h-2.3v4.9h-4.6v-5H86v11.5zm21.9 16.3h2.3v-5h4.5v5h2.3v-11.4h-2.3v4.9h-4.5v-5h-2.3V429zm-22-42.4h2.3v4.9h4.6v-5h2.3V398h-2.3v-5h-4.6v4.9H86v-11.4zm22-16.3h2.3v4.9h4.5v-5h2.3v11.5h-2.3v-4.9h-4.5v5h-2.3v-11.5zm34.7 58.7h2.3v-5h4.6v5h2.3v-11.4h-2.3v4.9h-4.6v-5h-2.3V429zm22-31h2.3V393h4.5v5h2.3v-11.5h-2.3v4.9H167v-5h-2.3V398z"
      />
      <path
        fill="#ca3745"
        d="M142.6 428.9h2.3v-5h4.6v5h2.3v-11.4h-2.3v4.9h-4.6v-5h-2.3V429z"
      />
      <path
        fill="#ca3745"
        d="M142.6 428.9h2.3v-5h4.6v5h2.3v-11.4h-2.3v4.9h-4.6v-5h-2.3V429zm22-16.3h2.3v-5h4.5v5h2.3v-11.4h-2.3v4.8H167v-4.9h-2.3v11.5zm-22-31h2.3v-4.9h4.6v5h2.3v-11.5h-2.3v4.9h-4.6v-5h-2.3v11.5z"
      />
      <path
        fill="#fff"
        d="M131.7 399.5l7.3-6h3.6v3H139v1.5h5.5v-5.9H139v-4.5h-7.3v4.5h1.8v-3h3.6v3l-7.3 6-7.3-6v-3h3.7v3h1.8v-4.5h-7.3v4.5h-5.5v6h5.5v-1.5H117v-3h3.7l7.3 6-7.3 5.9H117v-3h3.7V401h-5.5v6h5.5v4.4h7.3V407h-1.8v3h-3.7v-3l7.3-6 7.3 6v3h-3.6v-3h-1.8v4.4h7.3V407h5.5v-6H139v1.5h3.6v3H139l-7.3-6z"
      />
      <g transform="matrix(1.0321 0 0 .95838 204.8 18.2)">
        <path
          fill="#ca3745"
          d="M-122.3 134.3l3.4-3.8h20.6l15.4-16.7h20.6l15.4 16.8h20.6l3.4 3.7-3.4 3.7H-47l-15.4 16.8H-83L-98.3 138H-119l-3.4-3.7z"
        />
        <path
          fill="#ca3745"
          stroke="#000"
          strokeWidth={0.3}
          d="M372 391.5l2-2h22.8l17.1-19.4h19l17.2 19.5h22.8l1.9 2-1.9 1.9h-22.8L434.8 411H412l-15.2-17.5h-22.9l-1.9-2z"
          transform="matrix(.93104 0 0 .90908 -466.9 -221.3)"
        />
        <path
          fill="#faae29"
          d="M-64 136.2l6.8 7.4-3.4 3.7-1.8-1.8H-64v1.8l1.7 1.9h3.5l3.4-3.7v-3.8l-6.9-7.4 6.9-7.5v-3.7l-3.4-3.7h-3.5l-1.7 1.8v1.9h1.7l1.8-1.9 3.4 3.8-6.9 7.4-6.8-7.4 6.8-7.5v-1.9h-1.7l-6.8 7.5-6.9-7.5h-1.7v1.9l6.8 7.5-6.8 7.4-6.9-7.4 3.5-3.8 1.7 1.9h1.7v-1.9l-1.7-1.8h-3.5l-3.4 3.7v3.7l6.9 7.5-6.9 7.4v3.8l3.4 3.7h3.5l1.7-1.9v-1.8H-83l-1.7 1.8-3.5-3.7 6.9-7.4 6.8 7.4-6.8 7.5v1.8h1.7l6.9-7.4 6.8 7.4h1.7v-1.8l-6.8-7.5 6.8-7.4zm-8.6-9.4l-6.9 7.5 6.9 7.4 6.8-7.4-6.8-7.5zm-10.3 28v15l1.7-2 1.7 2 1.7-2 1.7 2 1.8-2 1.7 2 1.7-2 1.7 2 1.7-2 1.7 2 1.7-2 1.8 2v-15H-83zm20.6-41v-15l-1.8 2-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2v15h20.6zm29 16.8v-15l-1.6 2-1.7-2-1.7 2-1.8-2-1.7 2-1.7-2-1.7 2-1.7-2v15h13.7zm-65 0v-15l-1.8 2-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2v15h13.7zm65.1 7.4v15l-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2-1.7 2-1.7-2-1.7 2v-15h13.7zm-65.2 0v15l-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2-1.7 2-1.8-2-1.7 2v-15h13.7z"
        />
        <path
          fill="#28ae66"
          d="M-62.4 154.8v9.3l1.8-1.9 1.7 2 1.7-2 1.7 2 1.7-2 1.7 2 1.8-2 1.7 2 1.7-2V138l-15.5 16.8zm-20.5 0v9.3l-1.8-1.9-1.7 2-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2-1.7 2-1.8-2V138l15.5 16.8zm0-41v-9.3l-1.8 1.8-1.7-1.8-1.7 1.8-1.7-1.8-1.7 1.8-1.7-1.8-1.7 1.8-1.7-1.8-1.8 1.8v24.3l15.5-16.8zm20.5 0v-9.3l1.8 1.8 1.7-1.8 1.7 1.8 1.7-1.8 1.7 1.8 1.7-1.8 1.7 1.8 1.8-1.8 1.7 1.8v24.3l-15.5-16.8zm-49.7 35.4l-1.7-1.9-1.7 2-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2-1.7 2v-30l1.7 2 1.7-2 1.8 2 1.7-2 1.7 2 1.7-2 1.7 2 1.7-2v11.3h-6.8l-3.5 3.7 3.5 3.7h6.8v11.2zm78.9 0l1.7-1.9 1.7 2 1.7-2 1.8 2 1.7-2 1.7 2 1.7-2 1.7 2v-30l-1.7 2-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2-1.7 2-1.7-2v11.3h6.9l3.4 3.7-3.4 3.7h-6.9v11.2z"
        />
        <path
          fill="#fff"
          d="M-91.4 156s-1.4 1.4-1.4 2.2c0 .7 1.5 2.2 2.2 2.2.8 0 2.1-1.5 2.1-2.2s-1.4-2.2-1.4-2.2v-3s3 5.1 3 2.9c0-1.6-3-4.3-3-4.3h-1.5s-3 3.2-3 4.3c0 2.2 3-2.9 3-2.9v3z"
        />
        <path
          fill="#ca3745"
          d="M-73.5 161.7s-1.7 2-1.7 3 1.8 3.2 2.6 3.2c1 0 2.5-2.1 2.5-3.1s-1.7-3.1-1.7-3.1v-4.2s3 6.8 3 3.7c0-2-3-5.7-3-5.7h-1.7s-3.5 4.6-3 5.7c0 3.1 3-3.7 3-3.7v4.2z"
        />
        <ellipse
          cx={403.9}
          cy={391.5}
          fill="#28ae66"
          rx={3.5}
          ry={1.8}
          transform="matrix(.96774 0 0 1.0526 -482.4 -277.9)"
        />
        <ellipse
          cx={403.9}
          cy={391.5}
          fill="#28ae66"
          rx={3.5}
          ry={1.8}
          transform="matrix(.96774 0 0 1.0526 -463.5 -277.9)"
        />
        <ellipse
          cx={403.9}
          cy={391.5}
          fill="#28ae66"
          rx={3.5}
          ry={1.8}
          transform="matrix(.96774 0 0 1.0526 -444.7 -277.9)"
        />
        <path
          fill="#fff"
          d="M-91.7 112.8s-1.4-1.5-1.4-2.2c0-.7 1.5-2.3 2.1-2.3.8 0 2.1 1.5 2.1 2.2 0 .8-1.4 2.3-1.4 2.3v3s3.1-5.2 3.1-3c0 1.6-3 4.4-3 4.4h-1.5s-3.1-3.2-3.1-4.3c0-2.2 3 2.8 3 2.8v-3z"
        />
        <path
          fill="#ca3745"
          d="M-73.9 107s-1.7-2-1.7-3 1.9-3.1 2.6-3.1c1 0 2.6 2 2.6 3s-1.7 3.2-1.7 3.2v4s3-6.7 3-3.6c0 2-3 5.8-3 5.8H-74s-3.5-4.7-3-5.8c0-3 3 3.7 3 3.7V107z"
        />
        <path
          fill="#fff"
          d="M-54.9 156s-1.4 1.4-1.4 2.2c0 .7 1.5 2.2 2.2 2.2.8 0 2.1-1.5 2.1-2.2s-1.4-2.2-1.4-2.2v-3s3 5.1 3 2.9c0-1.6-3-4.3-3-4.3H-55s-3 3.2-3 4.3c0 2.2 3-2.9 3-2.9v3zm-.3-43.2s-1.4-1.5-1.4-2.3c0-.6 1.5-2.2 2.1-2.2.8 0 2.1 1.5 2.1 2.2 0 .8-1.4 2.3-1.4 2.3v3s3.1-5.2 3.1-3c0 1.6-3 4.4-3 4.4h-1.5s-3.1-3.2-3.1-4.3c0-2.2 3 2.8 3 2.8v-3z"
        />
        <path
          fill="#ca3745"
          d="M-106.3 145.6s-1.9 1.4-1.9 2c0 .7 2 2.2 2.9 2.1 1 0 2.8-1.3 2.8-2s-1.9-2.1-1.9-2.1v-2.8s3.4 4.5 3.4 2.5c0-1.4-3.4-3.9-3.4-3.9h-1.9s-3.9 3.2-3.3 3.9c0 2 3.3-2.5 3.3-2.5v2.8zm-.4-21.1s-1.9-1.4-1.9-2.1c0-.7 2-2.1 2.9-2 1 0 2.8 1.3 2.8 2s-1.9 2-1.9 2v2.8s3.4-4.5 3.4-2.4c0 1.3-3.4 3.8-3.4 3.8h-1.9s-3.9-3.1-3.3-3.8c0-2 3.3 2.4 3.3 2.4v-2.7zm66.3 20.6s-2 1.4-2 2.1c0 .7 2.1 2.1 3 2.1 1 0 2.8-1.4 2.8-2 0-.8-2-2.2-2-2.2v-2.7s3.4 4.5 3.4 2.4c0-1.3-3.3-3.8-3.3-3.8h-2s-3.8 3.1-3.3 3.8c0 2.1 3.4-2.4 3.4-2.4v2.8zm-.4-21s-2-1.4-2-2.1c0-.7 2.1-2.1 3-2.1 1 0 2.8 1.4 2.8 2 0 .8-2 2.1-2 2.1v2.8s3.4-4.5 3.4-2.5c0 1.4-3.3 3.9-3.3 3.9h-2s-3.8-3.1-3.3-3.8c0-2.1 3.4 2.4 3.4 2.4V124z"
        />
        <path
          fill="#fff"
          d="M-120.3 145.4c-.6-1.3-.4-1.9-.4-2.6 0-.7 1.7-2 2.3-2 .8 0 2.1 1.4 2.1 2.2 0 .7 0 1.3-.3 2.6l-.8-2.1c-1.1 3-1.2 3-1.8-.1l-1 2zm0-21.5c-.5 1.3-.4 1.9-.4 2.6 0 .7 1.7 2 2.4 2 .8 0 2.1-1.4 2.1-2.2 0-.7 0-1.3-.3-2.6l-.9 2.1c-1-3-1.1-3-1.8.1l-1-2zm92.5 21.2c-.6-1.3-.5-1.9-.5-2.6 0-.7 1.8-2 2.4-2 .8 0 2.1 1.5 2.1 2.2 0 .7 0 1.4-.3 2.6l-.9-2.1c-1 3-1.1 3.1-1.8 0l-1 1.9zm0-21.4c-.6 1.2-.4 1.8-.4 2.6 0 .6 1.7 2 2.3 2 .8 0 2.2-1.5 2.2-2.2 0-.8 0-1.4-.3-2.7l-1 2.2c-1-3.1-1-3.2-1.7 0l-1-2z"
        />
        <path
          fill="#ca3745"
          stroke="#000"
          strokeWidth={0.1}
          d="M115.2 177.2v-5.4h-16v-10.6H85v-3.5H72.6v-32H85v-3.5h14.2v-10.6h16v-5.3h21.2v5.3h16v10.6h14.1v3.6H179v31.9h-12.4v3.5h-14.1v10.6h-16v5.3h-21.2zm-1.8 1.7v-5.3h-16V163H83.3v-3.6H70.9V124h12.4v-3.5h14.1v-10.7h16v-5.3h24.8v5.3h16v10.7h14.1v3.5h12.4v35.4h-12.4v3.6h-14.2v10.6h-16v5.3h-24.7z"
          transform="matrix(1 0 0 .99999 -198.4 -7)"
        />
      </g>
    </g>
  </svg>
	),
	TN: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-85.3 0h682.6v512H-85.3z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(80) scale(.9375)"
    >
      <path fill="#e70013" d="M-128 0h768v512h-768z" />
      <path
        fill="#fff"
        d="M385.8 255.8a129.1 129.1 0 1 1-258.2 0 129.1 129.1 0 0 1 258.2 0z"
      />
      <path
        fill="#e70013"
        d="M256.7 341.4a85.7 85.7 0 0 1 0-171.3c11.8 0 25.3 2.8 34.4 9.5-62.6 2.3-78.5 55.5-78.5 76.9s10.1 69.1 78.5 76.2c-7.8 5-22.6 8.7-34.4 8.7z"
      />
      <path
        fill="#e70013"
        d="M332.1 291.8l-38.9-14.2-25.7 32.4 1.5-41.3-38.8-14.5 39.8-11.4 1.7-41.3 23.2 34.3 39.8-11-25.5 32.5z"
      />
    </g>
  </svg>
	),
	TO: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#c10000" d="M0 0h640v480H0z" />
      <path fill="#fff" d="M0 0h250v200.3H0z" />
      <g fill="#c10000">
        <path d="M102.8 31.2h39.9v139.6h-39.8z" />
        <path d="M192.6 81v40H53V81z" />
      </g>
    </g>
  </svg>
	),
	TR: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#e30a17" d="M0 0h640v480H0z" />
      <path
        fill="#fff"
        d="M407 247.5c0 66.2-54.6 119.9-122 119.9s-122-53.7-122-120 54.6-119.8 122-119.8 122 53.7 122 119.9z"
      />
      <path
        fill="#e30a17"
        d="M413 247.5c0 53-43.6 95.9-97.5 95.9s-97.6-43-97.6-96 43.7-95.8 97.6-95.8 97.6 42.9 97.6 95.9z"
      />
      <path
        fill="#fff"
        d="M430.7 191.5l-1 44.3-41.3 11.2 40.8 14.5-1 40.7 26.5-31.8 40.2 14-23.2-34.1 28.3-33.9-43.5 12-25.8-37z"
      />
    </g>
  </svg>
	),
	TT: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path
      fill="#e00000"
      fillRule="evenodd"
      d="M463.7 480L0 1v478.8l463.7.2zM176.3 0L640 479V.2L176.3 0z"
    />
    <path fillRule="evenodd" d="M27.7.2h118.6l468.2 479.3H492.2L27.7.2z" />
  </svg>
	),
	TV: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h640v480H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)">
      <g
        fill="#009fca"
        fillRule="evenodd"
        strokeWidth="1pt"
        transform="matrix(.64508 0 0 .92059 0 23.3)"
      >
        <path d="M506-19.8h486V496H506z" />
        <rect width={523.5} height={521.4} y={-25.3} ry={0} />
      </g>
      <path fill="#fff" fillRule="evenodd" d="M0 0h396v196.6H0z" />
      <path fill="#c00" d="M0 0v14.8l94.5 48.5 35.5 1L0 0z" />
      <path fill="#006" d="M40.5 0L155 59.8V0H40.5z" />
      <path
        fill="#c00"
        d="M170.3 0v76.4H0V120h170.3v76.4h52.3V120H393V76.4H222.7V0h-52.4z"
      />
      <path fill="#006" d="M238 0v56.4l112-56L238 0z" />
      <path fill="#c00" d="M241.5 62.5l31.5-.2L395.4.4l-32.5.6-121.4 61.5z" />
      <path fill="#006" d="M0 132.7v41.9l78.6-41.4-78.6-.5z" />
      <path
        fill="#c00"
        d="M302.6 134.5l-32.8-.3 123.5 61.5-.8-14-90-47.2zM30.7 196.7L146.5 136l-30.4.2L0 196.6"
      />
      <path
        fill="#006"
        d="M394.6 17.3L301 63.6l92.3.4v69h-78.6l77.9 42.3 1.1 21.4-41.6-.5-113.8-55.8v56.3h-82.9v-56.3L48.6 196.6l-48.2.1v196.4h785.8V.3L395.4 0M.4 22.2L0 63l82.7 1L.4 22.2z"
      />
      <g fill="#009fca" fillRule="evenodd" transform="scale(.79241 .79977)">
        <path d="M496 0h496.1v496h-496z" />
        <rect width={525.8} height={251.4} x={-2.3} y={244.6} rx={0} ry={0} />
      </g>
      <path
        fill="#fff40d"
        fillRule="evenodd"
        d="M593.3 122.7H621l-22.3 15.2 8.5 24.7-22.3-15.3-22.2 15.3 8.5-24.7-22.3-15.2h27.5l8.5-24.7zm-69.2 196.8h27.6l-22.3 15.2 8.5 24.7-22.3-15.3-22.3 15.3 8.6-24.7-22.3-15.2H507l8.5-24.7zm69.2-44.6H621l-22.3 15.2 8.5 24.7-22.3-15.3-22.2 15.3 8.5-24.7-22.3-15.2h27.5l8.5-24.7zM295.8 417.7h27.6L301 432.8l8.6 24.6-22.3-15.2-22.3 15.2 8.6-24.6-22.4-15.3h27.6l8.5-24.6zm62.6-76.5h-27.6l22.3-15.3-8.5-24.6 22.3 15.2 22.3-15.2-8.6 24.6 22.3 15.3h-27.5l-8.5 24.6zm81.3-112.5H412l22.3-15.2-8.5-24.7 22.3 15.3 22.3-15.3-8.6 24.7 22.3 15.2h-27.5l-8.5 24.7zm68.3-23.3h-27.6l22.4-15.3-8.6-24.6 22.3 15.2 22.3-15.2-8.6 24.6 22.4 15.3H525l-8.5 24.6zM439.7 400H412l22.3-15.2L426 360l22.3 15.2 22.3-15.2-8.6 24.7 22.3 15.2h-27.5l-8.5 24.7zm-81.3 19.9h-27.6l22.3-15.2-8.5-24.7 22.3 15.2 22.3-15.2-8.6 24.6L403 420h-27.5l-8.5 24.7z"
      />
    </g>
  </svg>
	),
	TW: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="scale(.9375)"
    >
      <path fill="#fe0000" d="M0 0h768v512H0z" />
      <path fill="#000095" d="M0 0h385.7v256H0z" />
      <path
        fill="#fff"
        d="M282.1 178.6l-47.3-9.8 10 47.3-36-32.1-15 46-15.2-45.9-36 32.4 9.8-47.4-47.2 10.1 32-36.1-46-15 46-15.2-32.4-35.8 47.3 9.7-10-47.3 36 32.1 15-46 15.2 45.9 35.9-32.4-9.7 47.4 47.2-10.1-32 36.1 45.9 15-45.9 15.2z"
      />
      <path
        fill="#000095"
        d="M238.5 175l-15 7.9-14.5 8.6-17-.6-16.9.2-14.3-9L146 174l-8-15-8.6-14.5.6-16.8-.2-17 9-14.2 8.3-14.8 14.9-7.9 14.6-8.6 16.9.6 17-.2 14.3 9 14.7 8.2 8 14.9 8.6 14.5-.6 16.9.2 16.9-9 14.3z"
      />
      <path
        fill="#fff"
        d="M244.6 128.3a51.9 51.9 0 1 1-103.7 0 51.9 51.9 0 0 1 103.7 0z"
      />
    </g>
  </svg>
	),
	TZ: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M10 0h160v120H10z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      strokeWidth="1pt"
      clipPath="url(#prefix__a)"
      transform="matrix(4 0 0 4 -40 0)"
    >
      <path fill="#09f" d="M0 0h180v120H0z" />
      <path fill="#090" d="M0 0h180L0 120V0z" />
      <path d="M0 120h40l140-95V0h-40L0 95v25z" />
      <path
        fill="#ff0"
        d="M0 91.5L137.2 0h13.5L0 100.5v-9zM29.3 120L180 19.5v9L42.8 120H29.3z"
      />
    </g>
  </svg>
	),
	UA: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#ffd500" d="M0 0h640v480H0z" />
      <path fill="#005bbb" d="M0 0h640v240H0z" />
    </g>
  </svg>
	),
	UG: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-85.3 0h682.6v512H-85.3z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="translate(80) scale(.9375)">
      <path fill="#ffe700" fillRule="evenodd" d="M-128 341.4h768v85.3h-768z" />
      <path fillRule="evenodd" d="M-128 256h768v85.3h-768z" />
      <path fill="#de3908" fillRule="evenodd" d="M-128 170.7h768V256h-768z" />
      <path fill="#ffe700" fillRule="evenodd" d="M-128 85.4h768v85.3h-768z" />
      <path fillRule="evenodd" d="M-128 0h768v85.3h-768z" />
      <path
        fill="#fffdff"
        fillRule="evenodd"
        stroke="#000"
        d="M335.7 256a79.7 79.7 0 1 1-159.4 0 79.7 79.7 0 0 1 159.4 0z"
      />
      <path
        fill="#de3108"
        fillRule="evenodd"
        stroke="#000"
        d="M242 194.9l-5.2-9.5c2-2 5.3-3.6 10.7-3.6l-.6 10.5-5 2.6z"
      />
      <path
        fill="#ffe700"
        fillRule="evenodd"
        stroke="#000"
        d="M247 192.3l.7-10.5s10.7-.6 16.5 6.4l-5.7 8.2-11.6-4z"
      />
      <path
        fill="#de3108"
        fillRule="evenodd"
        stroke="#000"
        d="M258.6 196.3l5.3-8.2c3.5 3.7 5 6.3 5.5 10.3.1.1-8.3 2.1-8.3 2l-2.5-4.1z"
      />
      <path
        fillRule="evenodd"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.9}
        d="M244.6 331.1s9.9-11.3 29.1-8.9c-2.9-4.7-12.3-4.1-12.3-4.1s-2.8-22-.6-23.2 12 .1 12 .1c1.2 0 3.4-3.4 1.6-5.6-1.7-2.2-6.8-10.5-4.7-12.2 2.1-1.6 13.4 1 13.4 1l-32-41s-3.3-15.5 3.3-23c7.9-6.5 7-13.6 6.8-13.5-1.1-7.2-12-12.3-19.4-5.7-4.3 5.2-1.4 9.2-1.4 9.2s-11.5 3.1-11.9 5.1c-.5 2 12.9-.3 12.9-.3l-1.3 9.1s-26 23.6-6 44l.6-.8s7 8.6 14.3 10.5c7 7 6.3 6 6.3 6s1.3 11.1 0 13.3c-1.7-.5-19.3-1.2-21.9-.2-2.4.8-11.4.3-9.2 15.1l3.3-7.5s-.3 5.3 1.9 7.2c-.4-5.6 2.1-9.4 2.1-9.4s.4 6.2 1.8 7c1.4 1 1.4-10 9-9 7.4.9 12.9.6 12.9.6s2.5 21.4 1.7 23.4c-5.4-1.3-18.4.5-19.2 3.8 7.6-.5 11.1.4 11.1.4s-6.1 5.5-4.2 8.6z"
      />
      <path
        fill="#9ca69c"
        fillRule="evenodd"
        stroke="#9ca69c"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.9}
        d="M247.6 214.8s-18.9 20.8-10.7 36.7c.4-2.2.2-3.6.5-3.5-.5-.3 2.3 1.9 2.1 1.5 0-1.2-.8-3.7-.8-3.7l2.5.7-1.5-2.8 3.7.4s-1.3-3.4-.9-3.4l3 .2c-5.4-9.6-.3-17.6 2.1-26.2z"
      />
      <path
        fill="#9ca69c"
        fillRule="evenodd"
        stroke="#9ca69c"
        d="M254.2 196.9s1 7.2-3 9.2c-.5.5-3 1.3-2.6 2.8.4 2 1.5 1.6 3 1.2 4.1-.7 8.9-9.4 2.6-13.2z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M247.2 203a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
      />
      <path
        fill="#de3108"
        fillRule="evenodd"
        stroke="#000"
        d="M241.1 209c-1 .9-6.2 6.3-1 8.3 5.3-1.4 3.8-2.4 5-3.6 0-2.5-2.6-3.1-4-4.6z"
      />
      <path
        fill="#9ca69c"
        fillRule="evenodd"
        stroke="#9ca69c"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.9}
        d="M252.6 260.5c-.3 1.2-1.5 5.6.1 9 4.6-2 6.7-1.4 8.2-.4-3.7-3-5.2-4.3-8.3-8.6z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.9}
        d="M260.4 281.1l.2 10.2s3.6.6 5.2 0 0-7-5.4-10.2z"
      />
      <path
        fill="#9ca69c"
        fillRule="evenodd"
        stroke="#000"
        d="M286 282.4s-6.5-15.8-23.2-19.8-14.5-21.8-13.2-22.9c.8-1.5 1.3-3.9 6.1-1.6s27 13.4 30.2 14 .4 30.7.2 30.3z"
      />
      <path
        fill="#de3108"
        fillRule="evenodd"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={0.9}
        d="M270.2 262.5c-.3.2 22.3 13.4 15.5 24.7 6.4-4.3 4.4-11.7 4.4-11.7s5.2 13.7-7.6 20.4c1.4 1.2 2.3 1 2.3 1l-2.2 2.1s-1 1.7 7.6-2.5c-2.3 1.9-2.5 3.3-2.5 3.3s.6 1.8 6.2-3.1c-4.5 4.9-5.5 7.4-5.5 7.3 12.3-1 39-41-8.4-52.7l2.1 2.2-12 9z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.9}
        d="M271.2 258.6c3 2.2 4.1 3 4.5 4-2.8-.6-5.3-.4-5.3-.4s-6.1-5.8-7.2-6.3c-.8 0-5.6-3-5.6-3-2.3-1.2-4.5-9.3 4.2-7a93 93 0 0 0 10.3 4.6l10.7 3.4 6.2 6.9s-11-5.4-12.4-5.5c3 2.4 4.7 5.8 4.7 5.8-3.5-1-6.5-2-10.1-2.5z"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={0.9}
        d="M228.4 209.9s10.5-2.6 11.8-2.2"
      />
      <path fill="#de3908" fillRule="evenodd" d="M-128 426.7h768V512h-768z" />
    </g>
  </svg>
	),
	US: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <g strokeWidth="1pt">
        <path
          fill="#bd3d44"
          d="M0 0h912v36.938H0zm0 73.875h912v36.938H0zm0 73.781h912v37.031H0zm0 73.875h912v36.938H0zm0 73.875h912v36.938H0zm0 73.781h912v36.938H0zm0 73.875h912V480H0z"
        />
        <path
          fill="#fff"
          d="M0 36.938h912v36.937H0zm0 73.874h912v36.844H0zm0 73.782h912v36.937H0zm0 73.875h912v36.937H0zm0 73.875h912v36.937H0zm0 73.781h912v36.938H0z"
        />
      </g>
      <path fill="#192f5d" d="M0 0h364.781v258.469H0z" />
      <path
        fill="#fff"
        d="M30.375 11.063L33.75 21.28h10.688l-8.626 6.282 3.282 10.312-8.719-6.375-8.625 6.281 3.281-10.218-8.718-6.282h10.874zm60.844 0L94.5 21.28h10.781l-8.719 6.282 3.282 10.312-8.625-6.375-8.719 6.281 3.281-10.218-8.625-6.282h10.688zm60.75 0l3.375 10.218h10.593l-8.625 6.282 3.282 10.312-8.719-6.375-8.625 6.281 3.281-10.218-8.719-6.282h10.782zm60.844 0l3.28 10.218h10.782l-8.719 6.282 3.375 10.312-8.719-6.375-8.718 6.281 3.375-10.218-8.719-6.282h10.687zm60.75 0l3.375 10.218h10.687L279 27.563l3.281 10.312-8.719-6.375-8.625 6.281 3.282-10.218-8.625-6.282h10.687zm60.843 0l3.281 10.218h10.782l-8.719 6.282 3.375 10.312-8.719-6.375-8.719 6.281 3.375-10.218-8.718-6.282h10.781zM60.844 36.936l3.281 10.22h10.781l-8.719 6.28 3.188 10.22-8.438-6.282-8.718 6.281 3.093-10.218-8.437-6.282h10.687zm60.75 0l3.375 10.22h10.687l-8.719 6.28 3.375 10.22-8.718-6.282-8.719 6.281 3.375-10.219-8.719-6.28h10.781zm60.843 0l3.282 10.22H196.5l-8.719 6.28 3.281 10.22-8.625-6.282-8.718 6.281L177 53.438l-8.625-6.282h10.687zm60.75 0l3.375 10.22h10.688l-8.719 6.28 3.375 10.22-8.719-6.282-8.625 6.281 3.282-10.218-8.719-6.282H240zm60.844 0l3.281 10.22h10.782l-8.719 6.28 3.281 10.22-8.625-6.282-8.719 6.281 3.282-10.218-8.625-6.282h10.687zM30.375 62.72l3.375 10.406h10.687l-8.625 6.281 3.282 10.219-8.719-6.375-8.625 6.375 3.281-10.313-8.719-6.28h10.875zm60.844 0L94.5 73.03h10.781l-8.719 6.281 3.282 10.22-8.625-6.376-8.719 6.375 3.281-10.312-8.625-6.281h10.688zm60.75 0l3.375 10.312h10.593l-8.625 6.281 3.282 10.22-8.719-6.376-8.625 6.375 3.281-10.312-8.719-6.281h10.782zm60.843 0l3.282 10.312h10.781l-8.719 6.281 3.375 10.22-8.719-6.376-8.718 6.375 3.375-10.312-8.719-6.281h10.687zm60.75 0l3.375 10.312h10.688L279 79.312l3.281 10.22-8.719-6.376-8.625 6.375 3.282-10.312-8.625-6.281h10.687zm60.844 0l3.281 10.312h10.782l-8.719 6.281 3.375 10.22-8.719-6.376-8.719 6.375 3.375-10.312-8.718-6.281h10.781zM60.844 88.594l3.281 10.219h10.781l-8.719 6.28 3.282 10.313-8.625-6.375-8.719 6.281 3.281-10.218-8.625-6.281H57.47zm60.75 0l3.375 10.219h10.687l-8.719 6.28 3.376 10.313-8.72-6.375-8.718 6.281 3.375-10.218-8.719-6.281h10.781zm60.844 0l3.28 10.219H196.5l-8.719 6.28 3.281 10.313-8.625-6.375-8.718 6.281L177 105.094l-8.625-6.281h10.688zm60.75 0l3.375 10.219h10.687l-8.625 6.28 3.281 10.313-8.719-6.375-8.625 6.281 3.282-10.218-8.719-6.281H240zm60.843 0l3.281 10.219h10.782l-8.719 6.28 3.281 10.313-8.625-6.375-8.719 6.281 3.282-10.218-8.625-6.281h10.687zM30.375 114.469l3.375 10.219h10.688l-8.625 6.28 3.28 10.313-8.718-6.375-8.625 6.281 3.281-10.218-8.718-6.281h10.875zm60.844 0l3.281 10.219h10.781l-8.719 6.28 3.282 10.22-8.625-6.282-8.719 6.281 3.281-10.218-8.625-6.281h10.688zm60.75 0l3.375 10.219h10.594l-8.625 6.28 3.28 10.313-8.718-6.375-8.625 6.281 3.281-10.218-8.718-6.281h10.78zm60.844 0l3.28 10.219h10.782l-8.719 6.28 3.375 10.313-8.718-6.375-8.72 6.281 3.376-10.218-8.719-6.281h10.688zm60.75 0l3.375 10.219h10.687l-8.625 6.28 3.281 10.313-8.719-6.375-8.625 6.281 3.282-10.218-8.625-6.281h10.687zm60.843 0l3.281 10.219h10.782l-8.719 6.28 3.375 10.313-8.719-6.375-8.719 6.281 3.375-10.218-8.718-6.281h10.781zM60.844 140.344l3.281 10.219h10.781l-8.718 6.28 3.28 10.22-8.624-6.375-8.719 6.375 3.281-10.313-8.625-6.281H57.47zm60.75 0l3.375 10.219h10.687l-8.718 6.28 3.375 10.22-8.72-6.375-8.718 6.375 3.375-10.313-8.719-6.281h10.782zm60.844 0l3.28 10.219H196.5l-8.719 6.28 3.282 10.22-8.625-6.375-8.72 6.375L177 156.75l-8.625-6.281h10.688zm60.75 0l3.375 10.219h10.687l-8.625 6.28 3.281 10.22-8.718-6.375-8.625 6.375 3.28-10.313-8.718-6.281H240zm60.843 0l3.282 10.219h10.78l-8.718 6.28 3.281 10.22-8.625-6.375-8.718 6.375 3.28-10.313-8.624-6.281h10.687zM30.375 166.125l3.375 10.313h10.688l-8.625 6.28 3.28 10.126-8.718-6.281-8.625 6.28 3.281-10.218-8.718-6.281h10.875zm60.844 0l3.281 10.313h10.781l-8.718 6.28 3.375 10.126-8.72-6.281-8.718 6.28 3.375-10.218-8.719-6.281h10.688zm60.75 0l3.375 10.313h10.594l-8.625 6.28 3.28 10.126-8.718-6.281-8.625 6.28 3.281-10.218-8.718-6.281h10.78zm60.844 0l3.28 10.313h10.782l-8.719 6.28 3.375 10.126-8.718-6.281-8.72 6.28 3.376-10.218-8.719-6.281h10.688zm60.75 0l3.375 10.313h10.687l-8.625 6.28 3.281 10.126-8.718-6.281-8.625 6.28 3.28-10.218-8.624-6.281h10.687zm60.843 0l3.282 10.313h10.78l-8.718 6.28 3.375 10.126-8.719-6.281-8.718 6.28 3.375-10.218-8.72-6.281h10.782zM60.844 192l3.281 10.219h10.781l-8.718 6.281 3.28 10.313-8.624-6.375-8.719 6.28 3.281-10.218-8.625-6.281H57.47zm60.75 0l3.375 10.219h10.687l-8.718 6.281 3.375 10.313-8.72-6.375-8.718 6.28 3.375-10.218-8.719-6.281h10.782zm60.844 0l3.28 10.219H196.5l-8.719 6.281 3.282 10.313-8.625-6.375-8.72 6.28L177 208.5l-8.625-6.281h10.688zm60.75 0l3.375 10.219h10.687l-8.625 6.281 3.281 10.313-8.718-6.375-8.625 6.28 3.28-10.218-8.718-6.281H240zm60.843 0l3.282 10.219h10.78l-8.718 6.281 3.281 10.313-8.625-6.375-8.718 6.28 3.28-10.218-8.624-6.281h10.687zM30.375 217.875l3.375 10.219h10.688l-8.625 6.281 3.28 10.219-8.718-6.281-8.625 6.28 3.281-10.312L16.313 228h10.875zm60.844 0l3.281 10.219h10.781l-8.718 6.281 3.375 10.219-8.72-6.281-8.718 6.28 3.375-10.312L77.156 228h10.688zm60.75 0l3.375 10.219h10.594l-8.438 6.281 3.281 10.219-8.718-6.281-8.625 6.28 3.28-10.312L138 228h10.781zm60.844 0l3.28 10.219h10.782l-8.719 6.281 3.375 10.219-8.718-6.281-8.72 6.28 3.376-10.312L198.75 228h10.688zm60.75 0l3.375 10.219h10.687L279 234.375l3.281 10.219-8.718-6.281-8.625 6.28 3.28-10.312-8.624-6.281h10.687zm60.843 0l3.282 10.219h10.78l-8.718 6.281 3.375 10.219-8.719-6.281-8.718 6.28 3.375-10.312-8.72-6.281h10.782z"
      />
    </g>
  </svg>
	),
	UY: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path
      fill="#0038a8"
      d="M266 53.3h374v53.4H266zm0 106.7h374v53.3H266zM0 266.7h640V320H0zm0 106.6h640v53.4H0z"
    />
    <g
      fill="#fcd116"
      stroke="#000"
      strokeMiterlimit={20}
      strokeWidth={0.6}
      transform="translate(133.3 133.3) scale(2.93333)"
    >
      <g id="prefix__c">
        <g id="prefix__b">
          <g id="prefix__a">
            <path
              strokeLinecap="square"
              d="M1.5 9L6 12c-8 13 1 15-6 21 3-7-3-5-3-17"
              transform="rotate(22.5)"
            />
            <path
              fill="none"
              d="M0 11c-2 13 4.5 17 0 22"
              transform="rotate(22.5)"
            />
            <path d="M0 0h6L0 33-6 0h6v33" />
          </g>
          <use
            width="100%"
            height="100%"
            transform="rotate(45)"
            xlinkHref="#prefix__a"
          />
        </g>
        <use
          width="100%"
          height="100%"
          transform="rotate(90)"
          xlinkHref="#prefix__b"
        />
      </g>
      <use
        width="100%"
        height="100%"
        transform="scale(-1)"
        xlinkHref="#prefix__c"
      />
      <circle r={11} />
    </g>
    <g transform="translate(133.3 133.3) scale(.29333)">
      <g id="prefix__d">
        <path d="M81-44c-7 8-11-6-36-6S16-35 12-38s21-21 29-22 31 7 40 16m-29 9c7 6 1 19-6 19S26-28 32-36" />
        <path d="M19-26c1-12 11-14 27-14s23 12 29 15c-7 0-13-10-29-10s-16 0-27 10m3 2c4-6 9 6 20 6s17-3 24-8-10 12-21 12-26-6-23-10" />
        <path d="M56-17c13-7 5-17 0-19 2 2 10 12 0 19M0 43c6 0 8-2 16-2s27 11 38 7c-23 9-14 3-54 3h-5m63 6c-4-7-3-5-11-16 8 6 10 9 11 16M0 67c25 0 21-5 54-19-24 3-29 11-54 11h-5m5-29c7 0 9-5 17-5s19 3 24 7c1 1-3-8-11-9S25 9 16 7c0 4 3 3 4 9 0 5-9 5-11 0 2 8-4 8-9 8" />
      </g>
      <use
        width="100%"
        height="100%"
        transform="scale(-1 1)"
        xlinkHref="#prefix__d"
      />
      <path d="M0 76c-5 0-18 3 0 3s5-3 0-3" />
    </g>
  </svg>
	),
	UZ: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#1eb53a" d="M0 320h640v160H0z" />
    <path fill="#0099b5" d="M0 0h640v160H0z" />
    <path fill="#ce1126" d="M0 153.6h640v172.8H0z" />
    <path fill="#fff" d="M0 163.2h640v153.6H0z" />
    <circle cx={134.4} cy={76.8} r={57.6} fill="#fff" />
    <circle cx={153.6} cy={76.8} r={57.6} fill="#0099b5" />
    <g fill="#fff" transform="matrix(1.92 0 0 1.92 261.1 122.9)">
      <g id="prefix__e">
        <g id="prefix__d">
          <g id="prefix__c">
            <g id="prefix__b">
              <path id="prefix__a" d="M0-6L-1.9-.3 1 .7" />
              <use
                width="100%"
                height="100%"
                transform="scale(-1 1)"
                xlinkHref="#prefix__a"
              />
            </g>
            <use
              width="100%"
              height="100%"
              transform="rotate(72)"
              xlinkHref="#prefix__b"
            />
          </g>
          <use
            width="100%"
            height="100%"
            transform="rotate(-72)"
            xlinkHref="#prefix__b"
          />
          <use
            width="100%"
            height="100%"
            transform="rotate(144)"
            xlinkHref="#prefix__c"
          />
        </g>
        <use width="100%" height="100%" y={-24} xlinkHref="#prefix__d" />
        <use width="100%" height="100%" y={-48} xlinkHref="#prefix__d" />
      </g>
      <use width="100%" height="100%" x={24} xlinkHref="#prefix__e" />
      <use width="100%" height="100%" x={48} xlinkHref="#prefix__e" />
      <use width="100%" height="100%" x={-48} xlinkHref="#prefix__d" />
      <use width="100%" height="100%" x={-24} xlinkHref="#prefix__d" />
      <use width="100%" height="100%" x={-24} y={-24} xlinkHref="#prefix__d" />
    </g>
  </svg>
	),
	VA: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#fff" d="M320 0h320v480H320z" />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={1.2}
        d="M282.4-735.1c0 .6 56 222.8 118.2 300.5 69.4 87.3 113.2 87.4 113.2 87.4l70.9-17.8s-41.6 2.1-123.9-104.2c-83.4-107.7-109.4-286-108.1-282.8l-70.3 16.9z"
        transform="matrix(-.24 0 0 .1991 534 334.4)"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={1.2}
        d="M285-727.6c-1.5-9.4 33.9 221 140.2 327.2 53.1 53.1 88.6 53.1 88.6 53.1l88.6-17.7s-51.7 3.8-134-102.5c-83.5-107.8-108.6-263.3-108-263.9l-75.4 3.8z"
        transform="matrix(.24 0 0 .1991 381.9 336.2)"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={1.2}
        d="M282.4-735.1c0 .6 56 222.8 118.2 300.5 69.4 87.3 113.2 87.4 113.2 87.4l70.9-17.8s-41.6 2.1-123.9-104.2c-83.4-107.7-109.4-286-108.1-282.8l-70.3 16.9z"
        transform="matrix(.24 0 0 .1991 381.9 336.2)"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={1.2}
        d="M285-727.6c-1.5-9.4 33.9 221 140.2 327.2 53.1 53.1 88.6 53.1 88.6 53.1l88.6-17.7s-51.7 3.8-134-102.5c-83.5-107.8-108.6-263.3-108-263.9l-75.4 3.8z"
        transform="matrix(-.24 0 0 .1991 534 334.4)"
      />
      <path
        fill="#fff133"
        stroke="#000"
        strokeWidth={1.2}
        d="M344.5-596.3l9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z"
        transform="matrix(.23995 .00428 -.00516 .19905 380 342.3)"
      />
      <g fill="#b00" stroke="#000" strokeWidth={12.8}>
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01763 .00275 .01016 -.01162 411 329.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.0173 .00313 .01036 -.0116 409.4 331)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01763 .00275 .01016 -.01162 407.3 332.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01789 -.0011 .00628 -.01341 429.5 312.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.0177 -.00038 .0068 -.01331 428.4 313.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01791 -.00081 .0066 -.0133 426.8 315.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01769 .00056 .0078 -.01292 425.8 316.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01765 -.00269 .00455 -.0139 433.9 305.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.0175 -.00223 .00475 -.01392 433 307.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01765 -.00269 .00455 -.0139 431.7 309.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01754 -.00195 .00507 -.01384 430.5 311.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01784 .00155 .009 -.01227 418 324)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01754 .00195 .0092 -.01225 416.4 325.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01784 .00155 .009 -.01227 414.5 327.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.0173 .00313 .01036 -.0116 413.1 328)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01794 .00014 .00759 -.01293 424 318.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01769 .00056 .0078 -.01292 422.7 319.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01784 .00155 .009 -.01227 421.4 320.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01754 .00195 .0092 -.01225 419.9 322.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01668 -.00552 .00122 -.01437 443.6 284.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01707 -.00392 .00278 -.01429 443.6 284.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01715 -.00439 .00258 -.01424 442.7 287)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01707 -.00392 .00278 -.01429 442 288.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01664 -.00505 .0014 -.01443 445.7 277.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01668 -.00552 .00122 -.01437 445 280)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01664 -.00505 .0014 -.01443 444.4 282)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01752 -.00323 .00393 -.01402 438 298.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01738 -.00277 .00413 -.01406 437.1 300)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01752 -.00323 .00393 -.01402 436 302.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.0175 -.00223 .00475 -.01392 435.2 303.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01715 -.00439 .00258 -.01424 441 291.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01738 -.00277 .00413 -.01406 441.3 292.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01752 -.00323 .00393 -.01402 440.1 294.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01738 -.00277 .00413 -.01406 439.2 296.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01541 -.00768 -.00154 -.01435 448.9 266.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01656 -.00577 .0009 -.01438 448.9 268)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01653 -.0053 .0011 -.01445 448.4 269.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01546 -.0072 -.00136 -.01443 449.6 259.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01541 -.00768 -.00154 -.01435 449.4 262.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01546 -.0072 -.00136 -.01443 449.1 264.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01656 -.00577 .0009 -.01438 447.7 272.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01664 -.00505 .0014 -.01443 447 273.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01668 -.00552 .00122 -.01437 446.3 275.8)"
        />
      </g>
      <g fill="#b00" stroke="#000" strokeWidth={12.8}>
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01781 .00178 -.00923 -.01216 503.2 324)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0175 .00217 -.00943 -.01214 504.7 325.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01781 .00178 -.00923 -.01216 506.6 327.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01776 -.00209 -.00521 -.01373 486 305.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01762 -.00135 -.00574 -.01366 487.1 307.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0178 -.0018 -.00554 -.01364 488.5 309.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0177 -.00041 -.00676 -.01332 489.5 310)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0174 -.00365 -.00345 -.01411 482.2 299)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01728 -.00319 -.00365 -.01415 483 300.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0174 -.00365 -.00345 -.01411 484.1 303)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01735 -.0029 -.00398 -.01409 485.2 304.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01792 .00057 -.00802 -.01274 496.7 318)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01766 .00098 -.00823 -.01273 498.1 319.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01792 .00057 -.00802 -.01274 499.9 321.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0175 .00217 -.00943 -.01214 501.2 322.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0179 -.00085 -.00656 -.01332 491 312)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0177 -.00041 -.00676 -.01332 492.3 313.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01792 .00057 -.00802 -.01274 493.5 314.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01766 .00098 -.00823 -.01273 495 316.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01621 -.00642 -.00009 -.0144 474.2 276.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01672 -.00485 -.00165 -.01441 474.1 277.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01677 -.00532 -.00146 -.01435 475 279.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01672 -.00485 -.00165 -.01441 475.5 281.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0162 -.00595 -.00027 -.01447 472.6 270.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01621 -.00642 -.00009 -.0144 473.2 272.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0162 -.00595 -.00027 -.01447 473.6 274.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01723 -.00419 -.00282 -.01421 478.6 291.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01713 -.00372 -.00302 -.01425 479.4 293)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01723 -.00419 -.00282 -.01421 480.4 295.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01728 -.00319 -.00365 -.01415 481.1 296.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01677 -.00532 -.00146 -.01435 476.3 283.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01713 -.00372 -.00302 -.01425 475.9 285)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01723 -.00419 -.00282 -.01421 476.9 287.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01713 -.00372 -.00302 -.01425 477.6 289)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01478 -.0085 .00266 -.01423 470.4 259)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01607 -.00667 .00022 -.0144 470.2 260.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01608 -.0062 .00004 -.01448 470.6 262.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01486 -.00804 .00249 -.01433 470 252.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01478 -.0085 .00266 -.01423 470.2 254.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01486 -.00804 .00249 -.01433 470.3 256.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01607 -.00667 .00022 -.0144 471 264.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0162 -.00595 -.00027 -.01447 471.6 266)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01621 -.00642 -.00009 -.0144 472.2 268.4)"
        />
      </g>
      <path
        fill="#fff133"
        stroke="#000"
        strokeWidth={1.2}
        d="M344.5-596.3l9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z"
        transform="matrix(-.23995 .00428 .00516 .19905 536 340.5)"
      />
      <g transform="matrix(.14437 0 0 .12085 423.6 295.3)">
        <path fill="silver" d="M324.6-255.4l-50.2 50.1L449.8-29.9l50.1-50z" />
        <ellipse
          cx={354.3}
          cy={-1428}
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          rx={35.4}
          ry={35.4}
          transform="scale(-1 1) rotate(45 -177.9 -1104.6)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M-402-957l37.5 37.7-25 25-37.6-37.6c-12.5-12.5 12.5-37.5 25-25z"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M-346.6-926.5l-50.1 50a25 25 0 0 1-25-25c10.8-25.8 25-38.4 50-50a26.9 26.9 0 0 1 25 25z"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M-352-931.9l37.7 37.6-50.2 50.1-37.5-37.5c5-20 30-45.1 50-50.1z"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M-309-889l-50.1 50.1a25.1 25.1 0 0 1-25-25c10.8-25.9 25-38.4 50-50.1a26.9 26.9 0 0 1 25 25z"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M-314.4-894.3L28.4-551.5l-50 50.1-342.9-342.8c5-20 30.1-45 50.1-50z"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M49-531l-50.2 50.1a25.1 25.1 0 0 1-25-25c10.8-25.9 25-38.5 50-50.1A26.9 26.9 0 0 1 49-531z"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M49-531l225.4 225.5-50 50.1L-1.3-480.9c5-20 30.1-45 50.1-50z"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M186.7-418.2l-75.1 75.1a25.1 25.1 0 0 1-25-25s0-25 25-50.1 50-25 50-25c11.7 1.5 21.5 12.4 25.1 25z"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M186.7-418.2l50.2 75.1-50.1 50.1-75.2-50c-2.8-2.5 0-25.1 25-50.2s49-24.4 50.1-25z"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M336.6-506.7c0-35.4 0-86.6 17.7-130C372-593.3 372-542 372-506.7h-35.4z"
          transform="rotate(135 434.8 18.7) scale(1 -.81782)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M318.9-506.7h17.7V-550c0-43.3-35.4-65-35.4-65l17.7 108.3z"
          transform="rotate(-45 399.4 -194.2) scale(1 .81782)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M318.9-506.7h17.7V-550c0-43.3-35.4-65-35.4-65l17.7 108.3z"
          transform="rotate(135 434.8 18.7) scale(1 -.81782)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M-314.4-894.3l37.6 37.6c25 25 112.8 137.8 112.8 137.8s117.3 92.3 142.3 117.3L16-564c-25-25-180-129.8-180-129.8S-71.7-551.5-34.1-514l-37.6-37.6c-25-25-117.3-142.3-117.3-142.3S-289.3-769-314.4-794.1l-50-50c25 25 175.3 125.2 175.3 125.2s-100.2-150.3-125.3-175.4z"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M299.5-230.3A907.4 907.4 0 0 0 412.2-92.5a83 83 0 0 0 50.1 25s0-25-25-50a899 899 0 0 0-137.8-112.8zm-62.6-112.8c87.6 87.7 187.9 137.8 250.5 200.5 50.1 50 15.4 88.4 1.4 100.6-14 12.1-52 50.3-101.6-.4C324.5-105 274.4-205.3 186.7-293c0-25 25.1-50 50.1-50z"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M218.3 257.9h23v73h-23z"
          transform="matrix(-1.2487 -1.4214 -1.3593 1.3175 1166.1 -102.6)"
        />
        <g fill="silver" stroke="#000">
          <path
            strokeWidth={0.6}
            d="M301.2 396.9l17.7 17.7-17.7 17.7 8.8 8.8 17.7-17.7 35.5 35.5-17.7 17.7 8.8 8.8 17.7-17.7 17.8 17.7-53.2 53.2-35.4-35.4 17.7-17.8 8.9 8.9 8.8-8.9-35.4-35.4-8.9 8.9 8.9 8.8-17.7 17.7-17.7-17.7 8.8-8.8-8.8-8.9-35.5 35.4 8.9 8.9 8.8-8.9 17.8 17.8-17.8 17.7-8.8-8.9-8.9 8.9 35.5 35.4 8.8-8.9-8.8-8.8 17.7-17.7 35.4 35.4-53.1 53.1-17.8-17.7 17.8-17.7-9-8.8-17.6 17.7-35.5-35.5 17.8-17.7-8.9-8.8-17.7 17.7-17.7-17.7 124-124z"
            transform="matrix(-2.2946 0 0 2.2438 360.6 -1733.7)"
          />
          <path
            strokeWidth={1.1}
            d="M318.9 786.6V822l88.6 88.6v-70.8L389.8 822h-35.5L319 786.6z"
            transform="matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
          />
          <path
            strokeWidth={1.1}
            d="M230.4 698.8l70.4 70.4.8 35.2-71.2-71.3v-34.3z"
            transform="matrix(-1.1473 0 0 1.1219 157.4 -1288.5)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3l35.4-35.4v-35.4l-35.4 35.4v35.4z"
            transform="matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3l35.4-35.4v-35.4l-35.4 35.4v35.4z"
            transform="matrix(-1.1473 0 0 1.1219 259 -1387.9)"
          />
          <path
            strokeWidth={1.1}
            d="M248 644.9v35.4l17.8-17.7-17.8-17.7z"
            transform="matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
          />
          <path
            strokeWidth={1.1}
            d="M248 644.9v35.4l17.8-17.7-17.8-17.7z"
            transform="matrix(-1.1473 0 0 1.1219 55.7 -1189.1)"
          />
          <path
            strokeWidth={1.1}
            d="M230.4 698.8l35.8 35.4v35.4l-35.8-36.5v-34.3z"
            transform="matrix(-1.1473 0 0 1.1219 218.8 -1349)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3l35.4-35.4v-35.4l-35.4 35.4v35.4z"
            transform="matrix(-1.1473 0 0 1.1219 55.7 -1507.1)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3l35.4-35.4v-35.4l-35.4 35.4v35.4z"
            transform="matrix(-1.1473 0 0 1.1219 137 -1427.6)"
          />
          <path
            strokeWidth={1.1}
            d="M283.5 822l53.1-53.1v-35.4l-70.9 70.8 17.8 17.8z"
            transform="matrix(-1.1473 0 0 1.1219 137 -1546.9)"
          />
          <path
            strokeWidth={1.1}
            d="M248 644.9v35.4l17.8-17.7-17.8-17.7z"
            transform="matrix(-1.1473 0 0 1.1219 35.4 -1447.5)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3L265.8 769v-35.4l35.4 35.4v35.4z"
            transform="matrix(-1.1473 0 0 1.1219 55.7 -1507.1)"
          />
          <path
            strokeWidth={1.1}
            d="M389.8 822l-53.2-53v-35.4l70.9 70.8-17.7 17.8z"
            transform="matrix(-1.1473 0 0 1.1219 55.7 -1546.9)"
          />
          <path
            strokeWidth={1.1}
            d="M230.4 698l70.9 71h35.4l17.7 17.6v70.9l-124-124.4v-35z"
            transform="matrix(-1.1473 0 0 1.1219 -66.2 -1387.9)"
          />
          <path
            strokeWidth={1.1}
            d="M354.3 822l106.3-106.3h35.5L389.8 822h-35.5zm53.2 17.8l106.3-106.3-17.7-17.7L389.8 822l17.7 17.7z"
            transform="matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
          />
          <path
            strokeWidth={1.1}
            d="M407.5 839.8v70.8l106.3-106.3v-70.8L407.5 839.8z"
            transform="matrix(-1.1473 0 0 1.1219 157.3 -1288.5)"
          />
          <path
            strokeWidth={1.1}
            d="M354.3 822l106.3-106.3h35.5L389.8 822h-35.5zm53.2 17.8l106.3-106.3-17.7-17.7L389.8 822l17.7 17.7z"
            transform="matrix(-1.1473 0 0 1.1219 -5.3 -1447.5)"
          />
          <path
            strokeWidth={1.1}
            d="M407.5 839.8v70.8l106.3-106.3v-70.8L407.5 839.8z"
            transform="matrix(-1.1473 0 0 1.1219 -5.3 -1447.5)"
          />
          <path
            strokeWidth={1.1}
            d="M318.9 786.6l17.7-17.7v-35.4l-35.4 35.4 17.7 17.7z"
            transform="matrix(-1.1473 0 0 1.1219 -86.6 -1527)"
          />
          <path
            strokeWidth={1.1}
            d="M318.9 786.6l17.7-17.7v-35.4l-35.4 35.4 17.7 17.7z"
            transform="matrix(-1.1473 0 0 1.1219 15 -1626.4)"
          />
          <path
            strokeWidth={1.1}
            d="M265.8 768.9v-35.4l17.7 17.7-17.7 17.7z"
            transform="matrix(-1.1473 0 0 1.1219 55.7 -1348.1)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3L265.8 769l17.7-17.7 17.7 17.7v35.4z"
            transform="matrix(-1.1473 0 0 1.1219 137 -1427.6)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3l-17.7-17.7 17.7-17.7v35.4z"
            transform="matrix(-1.1473 0 0 1.1219 15 -1586.6)"
          />
        </g>
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M196.5 254.2h25.2v80.2h-25.2z"
          transform="matrix(-1.2509 -1.4194 -1.3614 1.3153 1166.1 -102.6)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M336.6 166.5c0 14.7 35.4 35.5 35.4-17.7h-35.4v17.7z"
          transform="matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M242.1 24.8c-147 0-113.1 164.2-100.4 124 9.4-29.5 35.5-70.8 65-80.2C246.9 55.8 233.4 78 248 78c14.7 0 1.2-22.2 41.4-9.4 29.5 9.4 55.6 50.7 65 80.2 12.7 40.3 53-124-112.3-124z"
          transform="matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M389.8 166.5a141.8 141.8 0 0 1-283.5 0v-17.7c0-29 35.4 124 141.7 124s141.8-124.7 141.8-124v17.7z"
          transform="matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M336.6 166.5c0 14.7 35.4 35.5 35.4-17.7h-35.4v17.7z"
          transform="matrix(1.8992 0 0 1.8865 224 -100.5)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M389.8 148.8a141.8 141.8 0 1 1-283.6 0 141.8 141.8 0 0 1 283.6 0zm-53.2 0c0 14.7 22.8 3 9.4 43a81 81 0 0 1-56.6 55c-40.2 12.7-26.7-9.4-41.4-9.4-14.6 0-1.1 22.1-41.3 9.4a80.2 80.2 0 0 1-56.6-56.6c-12.8-40.2 9.3-26.7 9.3-41.4s-22-1.1-9.3-41.3a80.2 80.2 0 0 1 56.6-56.6c40.2-12.8 26.7 9.3 41.3 9.3 14.7 0 1.2-22 41.4-9.3a80.3 80.3 0 0 1 56.6 56.6c12.7 40.2-9.4 26.6-9.4 41.3z"
          transform="matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M126.5 157.7c-20.2 0-1.9 67.6-9 51.7a126.5 126.5 0 0 1 0-103.4c7.1-16-11.2 51.7 9 51.7z"
          transform="matrix(-1.6618 0 0 1.7607 1107.2 -99.5)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M372 140a88 88 0 0 1-9.7 44.8c-8 13.7 9.8-44.8-8-44.8 17.7 0 1.7-58.6 8-44.8a107.7 107.7 0 0 1 9.8 44.8z"
          transform="matrix(-1.8992 0 0 2.0316 1166.1 -106.2)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M296.3 263a123.5 123.5 0 0 1-96.5 0c-14.9-6.2 48.2 9.8 48.2-7.9 0 17.7 63.1 1.7 48.3 8zM248 42.6c0-17.7-63-1.7-48.2-8a123 123 0 0 1 96.5 0c14.8 6.3-48.3-9.7-48.3 8z"
          transform="matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
        />
        <ellipse
          cx={82.1}
          cy={160.9}
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          rx={18.4}
          ry={20.1}
          transform="matrix(-1.2929 -1.3819 -1.3912 1.2842 1257.6 -120)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z"
          transform="matrix(-1.2929 -1.3819 1.3912 -1.2842 808.9 712)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z"
          transform="matrix(-1.2929 -1.3819 -1.3912 1.2842 1223.2 329.9)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M267.7 308.5c-9.2 1.9-20.2 1-30 1-9.7 0-19.3-2.7-28.5-4.6l8.8-10.3a149.3 149.3 0 0 0 60 0l-10.3 14z"
          transform="matrix(-1.2929 -1.3819 -1.3912 1.2842 1223.2 329.9)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z"
          transform="matrix(-1.3912 1.2842 1.2929 1.3819 847.4 -345.2)"
        />
        <ellipse
          cx={82.1}
          cy={160.9}
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          rx={18.4}
          ry={20.1}
          transform="matrix(-1.2929 -1.3819 -1.3912 1.2842 789.1 314.4)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M267.6 281.5c-9.2 1.9-17.1 3-26.9 3s-23-.8-32.3-2.7l9.6 12.8a149.5 149.5 0 0 0 60 0l-10.4-13.1z"
          transform="matrix(-1.3912 1.2842 1.2929 1.3819 850.6 -315.2)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M174 271.8l-.9 14.8-3.2 4.5 1-15 3-4.3zm156.5-6.2l3.6 4.2 1 13.6-2.9-3-1.7-14.8z"
          transform="matrix(-1.8992 0 0 1.8865 1166.1 -102.6)"
        />
        <ellipse
          cx={82.1}
          cy={160.9}
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          rx={18.4}
          ry={20.1}
          transform="matrix(-1.2929 -1.3819 -1.3912 1.2842 1237.6 329.9)"
        />
      </g>
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={1.2}
        d="M513.8-790.2l35.4-17.7 35.4 17.7s-73.3 35.5-73.3 159.5c0 88.6 125.2 106.3 125.2 212.6 0 45.6-34.1 88.6-69.6 88.6s-88.6-17.7-141.7-70.9c35.4 17.7 76 37.3 106.3 36 19.6-.3 55-17.7 55-53 0-71-122.8-107-122.8-213.3 0-124 50-159.4 50-159.4z"
        transform="matrix(-.24 0 0 .1991 534 334.4)"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={1.2}
        d="M520.3-790.2l46.6-17.7 10 17.7s-70.6 35.5-70.6 159.5c0 88.6 125.9 106.3 125.9 212.6 0 45.6-26.7 87.4-65.3 88.6-73.4 2.3-90.4-24-141.7-70.9 43.1 32.3 105 46.8 129 34.2 29.4-15.4 35-36 35-53.8 0-70.9-120.9-104.4-120.9-210.7 0-124 52-159.4 52-159.4z"
        transform="matrix(-.24 0 0 .1991 534 334.4)"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={1.2}
        d="M513.3-789.7c7-2.4 36-18.2 71.3 17.3 17.8 17.7 17.8 53.1 17.8 70.8l53.1-53.1s-29-86.9-107.6-53.6a334.8 334.8 0 0 0-34.5 18.6z"
        transform="matrix(-.24 0 0 .1991 534 334.4)"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={1.2}
        d="M523.8-796c8.8-2.8 36.7-6.3 64.6 18.6 17.7 17.7 19 42.9 19 60.6l40.6-38c3.4-3.1-24.8-81.2-99.2-54a154 154 0 0 0-25 12.9z"
        transform="matrix(-.24 0 0 .1991 534 334.4)"
      />
      <path
        fill="#fff133"
        stroke="#000"
        strokeWidth={1.2}
        d="M344.5-596.3l9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z"
        transform="matrix(-.19534 -.02065 -.06668 .17315 439.6 337.1)"
      />
      <path
        fill="#fff133"
        stroke="#000"
        strokeWidth={1.2}
        d="M344.5-596.3l9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z"
        transform="matrix(.17775 .02412 .0031 -.13262 320.6 95.2)"
      />
      <g transform="matrix(.14437 0 0 .12085 423.6 295.3)">
        <g transform="rotate(45 478.1 -504.6)">
          <ellipse
            cx={354.3}
            cy={-1428}
            fill="silver"
            stroke="#000"
            strokeWidth={1.2}
            rx={35.4}
            ry={35.4}
            transform="translate(124 283.5)"
          />
          <path
            fill="#fff133"
            stroke="#000"
            strokeWidth={1.2}
            d="M460.6-1126.8v53.2h35.5v-53.2c0-17.7-35.5-17.7-35.5 0z"
          />
          <path
            fill="silver"
            stroke="#000"
            strokeWidth={1.2}
            d="M443-1066h70.8a25.1 25.1 0 0 0 0-35.5c-26-10.6-44.9-9.5-70.9 0a27 27 0 0 0 0 35.4z"
          />
          <path
            fill="#fff133"
            stroke="#000"
            strokeWidth={1.2}
            d="M443-1073.6v53.1h70.8v-53.1c-17.7-10.6-53.2-10.6-70.9 0z"
          />
          <path
            fill="silver"
            stroke="#000"
            strokeWidth={1.2}
            d="M443-1013h70.8a25.1 25.1 0 0 0 0-35.4c-26-10.6-44.9-9.5-70.9 0a27 27 0 0 0 0 35.5z"
          />
          <path fill="#fff133" d="M443-117h70.8v248.1h-70.9z" />
          <path
            fill="#fff133"
            stroke="#000"
            strokeWidth={1.2}
            d="M443-1020.5v484.8h70.8v-484.8c-17.7-10.6-53.2-10.6-70.9 0z"
          />
          <path
            fill="silver"
            stroke="#000"
            strokeWidth={1.2}
            d="M443-506.7h70.8a25.1 25.1 0 0 0 0-35.4c-26-10.6-44.9-9.5-70.9 0a27 27 0 0 0 0 35.4z"
          />
          <path
            fill="#fff133"
            stroke="#000"
            strokeWidth={1.2}
            d="M443-506.7v318.9h70.8v-318.9c-17.7-10.6-53.2-10.6-70.9 0z"
          />
          <path
            fill="#fff133"
            stroke="#000"
            strokeWidth={1.2}
            d="M425.2-329.5h106.3a25 25 0 0 0 0-35.5s-17.7-17.7-53.2-17.7-53.1 17.7-53.1 17.7c-7.1 9.4-6.3 24 0 35.5z"
          />
          <path
            fill="#fff133"
            stroke="#000"
            strokeWidth={1.2}
            d="M425.2-329.5l17.7 88.6h70.9l17.7-88.6c.3-3.8-17.7-17.7-53.2-17.7s-51.9 17.3-53.1 17.7z"
          />
          <path
            fill="#fff133"
            stroke="#000"
            strokeWidth={1.2}
            d="M336.6-506.7c0-35.4 0-86.6 17.7-130C372-593.3 372-542 372-506.7h-35.4z"
            transform="matrix(1 0 0 .81782 124 173.4)"
          />
          <path
            fill="#fff133"
            stroke="#000"
            strokeWidth={1.2}
            d="M318.9-506.7h17.7V-550c0-43.3-35.4-65-35.4-65l17.7 108.3z"
            transform="matrix(-1 0 0 .81782 832.7 173.4)"
          />
          <path
            fill="#fff133"
            stroke="#000"
            strokeWidth={1.2}
            d="M318.9-506.7h17.7V-550c0-43.3-35.4-65-35.4-65l17.7 108.3z"
            transform="matrix(1 0 0 .81782 124 173.4)"
          />
          <path
            fill="#fff133"
            stroke="#000"
            strokeWidth={1.2}
            d="M478.3-117a908.6 908.6 0 0 1 17.8 177.2 83 83 0 0 1-17.8 53.2s-17.7-17.7-17.7-53.2c0-17.7 0-88.6 17.7-177.1zM443-241c0 124-35.4 230.4-35.4 319 0 70.8 51.6 73.4 70 72.1 18.6-1.3 72.4-1.2 71.7-72.2 0-88.5-35.4-194.8-35.4-318.9-17.7-17.7-53.2-17.7-70.9 0z"
          />
          <path
            fill="silver"
            stroke="#000"
            strokeWidth={1.2}
            d="M443-1020.5v53.2c0 35.4 17.6 177.1 17.6 177.1S443-642 443-606.6v53.2c0-35.4 35.4-219 35.4-219s35.5 165.9 35.5 219v-53.2c0-35.4-17.7-183.6-17.7-183.6s17.7-124 17.7-159.4v-70.9c0 35.4-35.4 212.6-35.4 212.6S443-985.1 443-1020.5z"
          />
        </g>
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M218.3 257.9h23v73h-23z"
          transform="matrix(1.2487 -1.4214 1.3593 1.3175 -662.5 -102.6)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M336.6 166.5c0 14.7 35.4 35.5 35.4-17.7h-35.4v17.7z"
          transform="matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M242.1 24.8c-147 0-113.1 164.2-100.4 124 9.4-29.5 35.5-70.8 65-80.2C246.9 55.8 233.4 78 248 78c14.7 0 1.2-22.2 41.4-9.4 29.5 9.4 55.6 50.7 65 80.2 12.7 40.3 53-124-112.3-124z"
          transform="matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M389.8 166.5a141.8 141.8 0 0 1-283.5 0v-17.7c0-29 35.4 124 141.7 124s141.8-124.7 141.8-124v17.7z"
          transform="matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
        />
        <ellipse
          cx={82.1}
          cy={160.9}
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          rx={18.4}
          ry={20.1}
          transform="matrix(1.2929 -1.3819 1.3912 1.2842 -753.9 -120)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M196.5 254.2h25.2v80.2h-25.2z"
          transform="matrix(1.2509 -1.4194 1.3614 1.3153 -662.5 -102.6)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M336.6 166.5c0 14.7 35.4 35.5 35.4-17.7h-35.4v17.7z"
          transform="matrix(-1.8992 0 0 1.8865 279.7 -100.5)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M389.8 148.8a141.8 141.8 0 1 1-283.6 0 141.8 141.8 0 0 1 283.6 0zm-53.2 0c0 14.7 22.8 3 9.4 43a81 81 0 0 1-56.6 55c-40.2 12.7-26.7-9.4-41.4-9.4-14.6 0-1.1 22.1-41.3 9.4a80.2 80.2 0 0 1-56.6-56.6c-12.8-40.2 9.3-26.7 9.3-41.4s-22-1.1-9.3-41.3a80.2 80.2 0 0 1 56.6-56.6c40.2-12.8 26.7 9.3 41.3 9.3 14.7 0 1.2-22 41.4-9.3a80.3 80.3 0 0 1 56.6 56.6c12.7 40.2-9.4 26.6-9.4 41.3z"
          transform="matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M126.5 157.7c-20.2 0-1.9 67.6-9 51.7a126.5 126.5 0 0 1 0-103.4c7.1-16-11.2 51.7 9 51.7z"
          transform="matrix(1.6618 0 0 1.7607 -603.6 -99.5)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M372 140a88 88 0 0 1-9.7 44.8c-8 13.7 9.8-44.8-8-44.8 17.7 0 1.7-58.6 8-44.8a107.7 107.7 0 0 1 9.8 44.8z"
          transform="matrix(1.8992 0 0 2.0316 -662.5 -106.2)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M296.3 263a123.5 123.5 0 0 1-96.5 0c-14.9-6.2 48.2 9.8 48.2-7.9 0 17.7 63.1 1.7 48.3 8zM248 42.6c0-17.7-63-1.7-48.2-8a123 123 0 0 1 96.5 0c14.8 6.3-48.3-9.7-48.3 8z"
          transform="matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z"
          transform="matrix(1.2929 -1.3819 -1.3912 -1.2842 -305.2 712)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z"
          transform="matrix(1.2929 -1.3819 1.3912 1.2842 -719.6 329.9)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M267.7 308.5c-9.2 1.9-20.2 1-30 1-9.7 0-19.3-2.7-28.5-4.6l8.8-10.3a149.3 149.3 0 0 0 60 0l-10.3 14z"
          transform="matrix(1.2929 -1.3819 1.3912 1.2842 -719.6 329.9)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M276.6 287.7a142 142 0 0 1-57.1 0l-1.5 7a149 149 0 0 0 60 0l-1.4-7z"
          transform="matrix(1.3912 1.2842 -1.2929 1.3819 -343.8 -345.2)"
        />
        <ellipse
          cx={82.1}
          cy={160.9}
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          rx={18.4}
          ry={20.1}
          transform="matrix(1.2929 -1.3819 1.3912 1.2842 -285.5 314.4)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M267.6 281.5c-9.2 1.9-17.1 3-26.9 3s-23-.8-32.3-2.7l9.6 12.8a149.5 149.5 0 0 0 60 0l-10.4-13.1z"
          transform="matrix(1.3912 1.2842 -1.2929 1.3819 -347 -315.2)"
        />
        <path
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          d="M174 271.8l-.9 14.8-3.2 4.5 1-15 3-4.3zm156.5-6.2l3.6 4.2 1 13.6-2.9-3-1.7-14.8z"
          transform="matrix(1.8992 0 0 1.8865 -662.5 -102.6)"
        />
        <ellipse
          cx={82.1}
          cy={160.9}
          fill="silver"
          stroke="#000"
          strokeWidth={1.2}
          rx={18.4}
          ry={20.1}
          transform="matrix(1.2929 -1.3819 1.3912 1.2842 -733.9 329.9)"
        />
        <g fill="#fff133" stroke="#000">
          <path
            strokeWidth={0.6}
            d="M301.2 396.9l17.7 17.7-17.7 17.7 8.8 8.8 17.7-17.7 35.5 35.5-17.7 17.7 8.8 8.8 17.7-17.7 17.8 17.7-53.2 53.2-35.4-35.4 17.7-17.8 8.9 8.9 8.8-8.9-35.4-35.4-8.9 8.9 8.9 8.8-17.7 17.7-17.7-17.7 8.8-8.8-8.8-8.9-35.5 35.4 8.9 8.9 8.8-8.9 17.8 17.8-17.8 17.7-8.8-8.9-8.9 8.9 35.5 35.4 8.8-8.9-8.8-8.8 17.7-17.7 35.4 35.4-53.1 53.1-17.8-17.7 17.8-17.7-9-8.8-17.6 17.7-35.5-35.5 17.8-17.7-8.9-8.8-17.7 17.7-17.7-17.7 124-124z"
            transform="matrix(2.2946 0 0 2.2438 143.1 -1733.7)"
          />
          <path
            strokeWidth={1.1}
            d="M318.9 786.6V822l88.6 88.6v-70.8L389.8 822h-35.5L319 786.6z"
            transform="matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
          />
          <path
            strokeWidth={1.1}
            d="M230.4 698.8l70.4 70.4.8 35.2-71.2-71.3v-34.3z"
            transform="matrix(1.1473 0 0 1.1219 346.3 -1288.5)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3l35.4-35.4v-35.4l-35.4 35.4v35.4z"
            transform="matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3l35.4-35.4v-35.4l-35.4 35.4v35.4z"
            transform="matrix(1.1473 0 0 1.1219 244.7 -1387.9)"
          />
          <path
            strokeWidth={1.1}
            d="M248 644.9v35.4l17.8-17.7-17.8-17.7z"
            transform="matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
          />
          <path
            strokeWidth={1.1}
            d="M248 644.9v35.4l17.8-17.7-17.8-17.7z"
            transform="matrix(1.1473 0 0 1.1219 448 -1189.1)"
          />
          <path
            strokeWidth={1.1}
            d="M230.4 698.8l35.8 35.4v35.4l-35.8-36.5v-34.3z"
            transform="matrix(1.1473 0 0 1.1219 284.9 -1349)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3l35.4-35.4v-35.4l-35.4 35.4v35.4z"
            transform="matrix(1.1473 0 0 1.1219 448 -1507.1)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3l35.4-35.4v-35.4l-35.4 35.4v35.4z"
            transform="matrix(1.1473 0 0 1.1219 366.7 -1427.6)"
          />
          <path
            strokeWidth={1.1}
            d="M283.5 822l53.1-53.1v-35.4l-70.9 70.8 17.8 17.8z"
            transform="matrix(1.1473 0 0 1.1219 366.7 -1546.9)"
          />
          <path
            strokeWidth={1.1}
            d="M248 644.9v35.4l17.8-17.7-17.8-17.7z"
            transform="matrix(1.1473 0 0 1.1219 468.3 -1447.5)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3L265.8 769v-35.4l35.4 35.4v35.4z"
            transform="matrix(1.1473 0 0 1.1219 448 -1507.1)"
          />
          <path
            strokeWidth={1.1}
            d="M389.8 822l-53.2-53v-35.4l70.9 70.8-17.7 17.8z"
            transform="matrix(1.1473 0 0 1.1219 448 -1546.9)"
          />
          <path
            strokeWidth={1.1}
            d="M230.4 698l70.9 71h35.4l17.7 17.6v70.9l-124-124.4v-35z"
            transform="matrix(1.1473 0 0 1.1219 569.8 -1387.9)"
          />
          <path
            strokeWidth={1.1}
            d="M354.3 822l106.3-106.3h35.5L389.8 822h-35.5zm53.2 17.8l106.3-106.3-17.7-17.7L389.8 822l17.7 17.7z"
            transform="matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
          />
          <path
            strokeWidth={1.1}
            d="M407.5 839.8v70.8l106.3-106.3v-70.8L407.5 839.8z"
            transform="matrix(1.1473 0 0 1.1219 346.4 -1288.5)"
          />
          <path
            strokeWidth={1.1}
            d="M354.3 822l106.3-106.3h35.5L389.8 822h-35.5zm53.2 17.8l106.3-106.3-17.7-17.7L389.8 822l17.7 17.7z"
            transform="matrix(1.1473 0 0 1.1219 509 -1447.5)"
          />
          <path
            strokeWidth={1.1}
            d="M407.5 839.8v70.8l106.3-106.3v-70.8L407.5 839.8z"
            transform="matrix(1.1473 0 0 1.1219 509 -1447.5)"
          />
          <path
            strokeWidth={1.1}
            d="M318.9 786.6l17.7-17.7v-35.4l-35.4 35.4 17.7 17.7z"
            transform="matrix(1.1473 0 0 1.1219 590.3 -1527)"
          />
          <path
            strokeWidth={1.1}
            d="M318.9 786.6l17.7-17.7v-35.4l-35.4 35.4 17.7 17.7z"
            transform="matrix(1.1473 0 0 1.1219 488.6 -1626.4)"
          />
          <path
            strokeWidth={1.1}
            d="M265.8 768.9v-35.4l17.7 17.7-17.7 17.7z"
            transform="matrix(1.1473 0 0 1.1219 448 -1348.1)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3L265.8 769l17.7-17.7 17.7 17.7v35.4z"
            transform="matrix(1.1473 0 0 1.1219 366.7 -1427.6)"
          />
          <path
            strokeWidth={1.1}
            d="M301.2 804.3l-17.7-17.7 17.7-17.7v35.4z"
            transform="matrix(1.1473 0 0 1.1219 488.6 -1586.6)"
          />
        </g>
      </g>
      <g fill="#b00" stroke="#000" strokeWidth={18}>
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 452 279.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 452.1 277.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 452.1 275)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 452.1 273.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 452 287.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 452 286)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 452 283.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 452 281.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 452.3 262.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 452.3 260.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 452.3 257.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 452.3 256)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 452.2 270.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 452.2 268.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 452.2 266.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 452.2 264.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.7 313.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.8 311.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.8 309.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.8 307.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.6 322.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.7 320.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.7 317.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.7 316)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.9 296.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 452 294.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 452 292.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 452 290.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.8 305)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.8 303)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.9 300.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.9 298.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.4 347.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.4 345.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.4 343.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.4 341.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.3 354.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.3 352)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.4 350.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.5 330.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.6 328.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.6 326.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.6 324.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.4 339.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.5 337.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.5 335)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.5 333)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.1 369.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.2 367.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.2 365)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.2 363.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451 376)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.1 373.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.1 371.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.2 360.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01446 .00854 -.00318 .01423 451.3 358.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01435 .009 -.00335 .01413 451.3 356.5)"
        />
      </g>
      <g fill="#b00" stroke="#000" strokeWidth={18}>
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455 279.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455 277.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455 275.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455 273.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455 288.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455 286.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455 283.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455 282)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455 262.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455 260.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455 258.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455 256.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455 271)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455 269)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455 266.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455 264.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.1 313.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.1 312)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.1 309.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.1 307.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.1 322.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.1 320.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.1 318.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.1 316.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455 296.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455 294.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455 292.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455 290.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455 305.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.1 303.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455 301)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455 299)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.2 348)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.2 346.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.2 343.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.2 341.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.3 354.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.2 352.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.3 350.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.2 331)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.2 329)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.1 326.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.2 324.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.2 339.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.2 337.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.2 335.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.2 333.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.3 369.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.3 367.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.3 365.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.3 363.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.3 376.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.3 373.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.3 372)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.3 361)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01457 .0084 -.003 .01426 455.3 359.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01447 .00887 -.00316 .01416 455.3 356.8)"
        />
      </g>
      <g fill="#b00" stroke="#000" strokeWidth={12.8}>
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01804 .0045 .00258 .01426 466.7 266.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.00502 .01448 -.01369 .00945 463 262.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01316 .01078 -.0063 .01351 464.4 265)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.011 .01222 -.01787 -.00248 462.7 259.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0104 .0123 -.018 -.00234 465.1 259.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01155 .01189 -.01775 -.003 452.2 259)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01097 .01198 -.01788 -.00286 454.6 259.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01155 .01189 -.01775 -.003 457.6 259.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0104 .0123 -.018 -.00234 459.7 259.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01155 .01189 -.01775 -.003 448.7 258.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01268 .01087 -.01732 -.00452 450.4 258.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01676 .00696 -.01454 -.00862 449.5 257)"
        />
      </g>
      <g fill="#b00" stroke="#000" strokeWidth={12.8}>
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01456 -.00876 -.0151 .00691 500.9 356.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01407 -.00899 -.01526 .0068 503 355.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01456 -.00876 -.0151 .00691 505.8 355)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01407 -.00899 -.01526 .0068 508 354.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01737 .00284 -.00405 .01407 524 347.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01147 .01155 .00717 .0131 526 341.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0175 .0033 -.00385 .01404 525.1 345.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0136 -.00978 -.01575 .0058 490.8 358.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0131 -.00997 -.0159 .00568 493 357.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01493 -.00832 -.0148 .00736 496.4 357.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01254 -.01046 -.0162 .00507 497.3 356.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01456 -.00876 -.0151 .00691 510.6 353.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01407 -.00899 -.01526 .0068 512.8 353)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01096 -.01188 -.01683 .003 458.7 360)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01041 -.01198 -.01695 .00287 461 360)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01096 -.01188 -.01683 .003 463.8 360)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01041 -.01198 -.01695 .00287 466.1 360)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01096 -.01188 -.01683 .003 448.5 360.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01041 -.01198 -.01695 .00287 450.8 360.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01096 -.01188 -.01683 .003 453.6 360.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01041 -.01198 -.01695 .00287 455.9 360.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01244 -.01081 -.01634 .00452 480 359.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01231 -.01064 -.0163 .00483 482.5 359.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01284 -.01048 -.01616 .00495 485.3 359)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0131 -.00997 -.0159 .00568 488 358.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01096 -.01188 -.01683 .003 469 359.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0113 -.0114 -.0167 .00377 471.6 359.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0125 -.01076 -.01631 .0046 474.8 359.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01107 -.01156 -.01677 .00353 476.6 359.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00824 -.01334 -.0172 .00043 416.7 358.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00768 -.01335 -.01729 .00028 419 358.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00983 -.01256 -.01706 .0019 422.4 359.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00927 -.01262 -.01717 .00176 424.6 359.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00768 -.01335 -.01729 .00028 408.8 357.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00824 -.01334 -.0172 .00043 411.6 357.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00768 -.01335 -.01729 .00028 413.9 357.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00983 -.01256 -.01706 .0019 437.7 359.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00927 -.01262 -.01717 .00176 440 360)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01096 -.01188 -.01683 .003 443.4 360.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01041 -.01198 -.01695 .00287 445.7 360.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00983 -.01256 -.01706 .0019 427.5 359.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00927 -.01262 -.01717 .00176 429.8 359.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00983 -.01256 -.01706 .0019 432.6 359.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00927 -.01262 -.01717 .00176 434.9 359.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01773 -.00226 .00503 -.01378 399.9 338.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.0141 -.00895 -.00376 -.01413 397.1 342.6)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.00947 -.01275 -.00925 -.01215 397 346.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.00376 -.01448 -.01383 -.00869 397.7 350.2)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01766 .00094 .00819 -.01275 405.4 333)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01793 .00053 .00798 -.01276 403.7 334.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01757 -.0018 .00523 -.0138 401.2 336.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.001 -.01499 -.0159 -.0055 399.7 353.5)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00438 -.01435 -.01702 -.00258 402.7 355.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.00824 -.01334 -.0172 .00043 406.5 356.8)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0174 -.00361 -.01096 .0111 516.7 351.7)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.0168 -.00469 -.0118 .01058 516.9 352.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01764 -.00272 -.01013 .01164 521.7 349.4)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(-.01667 -.00498 -.01207 .01037 518.6 351)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01634 -.0062 .01318 .00926 511.5 341)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.0159 -.0065 .01336 .00919 509.6 340)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01686 -.00512 .01228 .01009 506.4 338.9)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.0159 -.0065 .01336 .00919 518.5 344.3)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.01634 -.0062 .01318 .00926 516 343.1)"
        />
        <path
          d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
          transform="matrix(.0159 -.0065 .01336 .00919 514 342.2)"
        />
      </g>
      <g transform="matrix(.08053 0 0 .0956 438.4 288)">
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M212.6-1995v53.2h-53.1v35.5h53.1v106.3H248v-106.3h53.2v-35.5H248v-53.1h-35.4z"
        />
        <ellipse
          cx={239.2}
          cy={-1813.5}
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          rx={62}
          ry={57.3}
          transform="matrix(.57143 0 0 .61816 93.6 -679)"
        />
        <path
          fill="#fff"
          stroke="#000"
          strokeWidth={1.2}
          d="M602.4-1119.4c0 68.5-10.5 145.7-29.3 205-120-26.4-268-39.7-339-39.7-87.6 0-246.2 13.3-345.3 26.5a630.8 630.8 0 0 1-30.5-191.8c0-273.8 105.2-390.2 367.5-496 233.3 105.8 376.6 222.2 376.6 496z"
          transform="matrix(1.0576 0 0 1.3394 -5.8 363.7)"
        />
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z"
          transform="matrix(1.1715 0 0 .74463 -32.8 -634.9)"
        />
        <g fill="#fff133" stroke="#000" strokeWidth={1.2}>
          <path
            d="M230.3-825.6l-53.1 53.2 35.4 35.4-17.7 17.7-35.5-35.4-53.1 53.1 53.1 53.2L195-684l17.7 17.8v53.1H248v-53.1l17.7-17.8 35.5 35.5 53.1-53.2-53.1-53.1-35.4 35.4L248-737l35.5-35.5-53.2-53.1z"
            transform="matrix(1.1725 0 0 .74463 -33 -766.8)"
          />
          <path
            d="M221-825.6l-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z"
            transform="matrix(1.13516 -.18643 .29356 .72091 -190 -703.6)"
          />
          <path
            d="M221-825.6l-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z"
            transform="matrix(1.1416 .16986 -.26746 .725 182.2 -778.4)"
          />
          <path
            d="M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z"
            transform="matrix(.92597 -.09509 .18717 .73508 28.8 -521.9)"
          />
          <path
            d="M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z"
            transform="matrix(.92699 .091 -.17909 .7359 124.8 -554)"
          />
          <path
            d="M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z"
            transform="matrix(1.1725 0 0 .74463 -33 -674.5)"
          />
        </g>
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z"
          transform="matrix(1.0735 0 0 .74463 -9.3 -386.9)"
        />
        <g fill="#fff133" stroke="#000" strokeWidth={1.2}>
          <path
            d="M230.3-825.6l-53.1 53.2 35.4 35.4-17.7 17.7-35.5-35.4-53.1 53.1 53.1 53.2L195-684l17.7 17.8v53.1H248v-53.1l17.7-17.8 35.5 35.5 53.1-53.2-53.1-53.1-35.4 35.4L248-737l35.5-35.5-53.2-53.1z"
            transform="matrix(1.1042 0 0 .74463 -12.9 -518.8)"
          />
          <path
            d="M221-825.6l-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z"
            transform="matrix(1.06903 -.18643 .27645 .72092 -160.7 -455.6)"
          />
          <path
            d="M221-825.6l-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z"
            transform="matrix(1.0751 .16986 -.25188 .725 189.8 -530.4)"
          />
          <path
            d="M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z"
            transform="matrix(.87203 -.09509 .17626 .73508 45.4 -273.9)"
          />
          <path
            d="M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z"
            transform="matrix(.873 .091 -.16866 .7359 135.8 -306)"
          />
          <path
            d="M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z"
            transform="matrix(1.1042 0 0 .74463 -12.9 -426.4)"
          />
        </g>
        <path
          fill="#fff133"
          stroke="#000"
          strokeWidth={1.2}
          d="M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z"
          transform="matrix(1.105 0 0 .74463 -16.1 -865.2)"
        />
        <g fill="#fff133" stroke="#000" strokeWidth={1.2}>
          <path
            d="M230.3-825.6l-53.1 53.2 35.4 35.4-17.7 17.7-35.5-35.4-53.1 53.1 53.1 53.2L195-684l17.7 17.8v53.1H248v-53.1l17.7-17.8 35.5 35.5 53.1-53.2-53.1-53.1-35.4 35.4L248-737l35.5-35.5-53.2-53.1z"
            transform="matrix(1.0799 0 0 .70238 -6.2 -1031.3)"
          />
          <path
            d="M221-825.6l-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z"
            transform="matrix(1.0455 -.17585 .27037 .68 -150.8 -971.8)"
          />
          <path
            d="M221-825.6l-8.4 53.2v35.4l-17.7 17.7v-35.4l-17.7 53.1 17.7 53.2V-684l17.7 17.8v53.1h17.7v-53.1L248-684v35.5l17.8-53.2-17.8-53.1v35.4L230.3-737v-35.4l-9.3-53.2z"
            transform="matrix(1.05143 .16022 -.24634 .68386 192.1 -1042.3)"
          />
          <path
            d="M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z"
            transform="matrix(.85284 -.0897 .17238 .69338 50.8 -800.3)"
          />
          <path
            d="M141.7-1020.5a38.1 38.1 0 0 1 35.5-35.4c17.7 0 35.4 17.7 35.4 35.4s-17.7 35.4-17.7 35.4l70.8 70.9h-35.4l-53.1-53.1-53.2 53.1H88.6l70.9-70.9s-17.8-17.7-17.8-35.4z"
            transform="matrix(.85378 .08583 -.16494 .69414 139.3 -830.7)"
          />
          <path
            d="M567-657.3c0-44-150.9-79.7-336.7-79.7s-336.6 35.7-336.6 79.7v26.6c0-44 150.8-70.9 336.6-70.9S567-657 567-613v-44.3z"
            transform="matrix(1.0799 0 0 .70238 -6.2 -944.2)"
          />
        </g>
        <ellipse
          cx={234.1}
          cy={-822.1}
          fill="#b90000"
          rx={375.9}
          ry={120.5}
          transform="matrix(.96627 0 0 .41385 13 -517.5)"
        />
      </g>
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={1.2}
        d="M513.8-790.2l35.4-17.7 35.4 17.7s-73.3 35.5-73.3 159.5c0 88.6 125.2 106.3 125.2 212.6 0 45.6-34.1 88.6-69.6 88.6s-88.6-17.7-141.7-70.9c35.4 17.7 76 37.3 106.3 36 19.6-.3 55-17.7 55-53 0-71-122.8-107-122.8-213.3 0-124 50-159.4 50-159.4z"
        transform="matrix(.24 0 0 .1991 381.9 336.2)"
      />
      <path
        fill="#b00"
        stroke="#000"
        strokeWidth={18}
        d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
        transform="matrix(.02071 -.00148 .00948 .02238 454.4 384)"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={1.2}
        d="M520.3-790.2l46.6-17.7 10 17.7s-70.6 35.5-70.6 159.5c0 88.6 125.9 106.3 125.9 212.6 0 45.6-26.7 87.4-65.3 88.6-73.4 2.3-90.4-24-141.7-70.9 43.1 32.3 105 46.8 129 34.2 29.4-15.4 35-36 35-53.8 0-70.9-120.9-104.4-120.9-210.7 0-124 52-159.4 52-159.4z"
        transform="matrix(.24 0 0 .1991 381.9 336.2)"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={1.2}
        d="M513.3-789.7c7-2.4 36-18.2 71.3 17.3 17.8 17.7 17.8 53.1 17.8 70.8l53.1-53.1s-29-86.9-107.6-53.6a334.8 334.8 0 0 0-34.5 18.6z"
        transform="matrix(.24 0 0 .1991 381.9 336.2)"
      />
      <path
        fill="#fff"
        stroke="#000"
        strokeWidth={1.2}
        d="M523.8-796c8.8-2.8 36.7-6.3 64.6 18.6 17.7 17.7 19 42.9 19 60.6l40.6-38c3.4-3.1-24.8-81.2-99.2-54a154 154 0 0 0-25 12.9z"
        transform="matrix(.24 0 0 .1991 381.9 336.2)"
      />
      <path
        fill="#fff133"
        stroke="#000"
        strokeWidth={1.2}
        d="M344.5-596.3l9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z"
        transform="matrix(.19534 -.02065 .06668 .17315 476.4 339)"
      />
      <path
        fill="#fff133"
        stroke="#000"
        strokeWidth={1.2}
        d="M344.5-596.3l9.2 22.1s1.5-9.7 8.5-11.5l7-1.7s27 49.3 32.3 58.1c5.3 8.8-3.6 16.8-1.8 16.8s26.5-11.5 26.5-11.5-10.6.9-15-6.2-34.8-60-34.8-60 6.1-2.6 11.4-5.2c5.3-2.7 10.6 8 10.6 8L385.2-614s0 8.9-4.4 10.6c-4.4 1.8-8 3.6-8 3.6s-3.5-6.2-8-13.3c-4.4-7 4.5-14.1 4.5-14.1l-23 11.5s8 4.4 10.6 8.8l5.3 8.8s-3.2 1.8-8.2 3.5c-3.6 1.9-7.7 0-9.5-1.7z"
        transform="matrix(-.17775 .02412 -.0031 -.13262 595.4 97)"
      />
      <path
        fill="#b00"
        stroke="#000"
        strokeWidth={18}
        d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
        transform="matrix(.02071 -.00148 .00948 .02238 457.9 383.8)"
      />
      <path
        fill="#b00"
        stroke="#000"
        strokeWidth={18}
        d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
        transform="matrix(.03487 -.00148 .01595 .02238 452.7 386.7)"
      />
      <path
        fill="#b00"
        stroke="#000"
        strokeWidth={18}
        d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
        transform="matrix(.03487 -.00148 .01595 .02238 456 386.5)"
      />
      <path
        fill="#b00"
        stroke="#000"
        strokeWidth={18}
        d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
        transform="matrix(.04323 -.00148 .01978 .02238 451.4 389.9)"
      />
      <path
        fill="#b00"
        stroke="#000"
        strokeWidth={18}
        d="M212.6-453.5c-35.4 0-70.9 35.4-70.9 70.8s35.5 70.9 70.9 70.9h194.9c35.4 0 70.9-35.4 70.9-70.9 0-37-35.5-70.8-71-70.8H212.7z"
        transform="matrix(.04323 -.00148 .01978 .02238 455.4 389.6)"
      />
      <path fill="#ffe000" d="M0 0h320v480H0z" />
    </g>
  </svg>
	),
	VC: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd">
      <path fill="#f4f100" d="M0 0h640v480H0z" />
      <path fill="#199a00" d="M490 0h150v480H490z" />
      <path fill="#0058aa" d="M0 0h150v480H0z" />
      <path
        fill="#199a00"
        d="M259.3 130l-46.4 71.3 44.7 74.4 43.8-73.7-42.1-72zm121.2 0l-46.3 71.3 44.7 74.4 43.8-73.7-42.2-72zm-61.2 97.3l-46.4 71.4 44.8 74.4 43.8-73.7-42.2-72z"
      />
    </g>
  </svg>
	),
	VE: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <g id="prefix__d" transform="translate(0 -36)">
        <g id="prefix__c">
          <g id="prefix__b">
            <path id="prefix__a" fill="#fff" d="M0-5L-1.5-.2l2.8.9z" />
            <use
              width={180}
              height={120}
              transform="scale(-1 1)"
              xlinkHref="#prefix__a"
            />
          </g>
          <use
            width={180}
            height={120}
            transform="rotate(72)"
            xlinkHref="#prefix__b"
          />
        </g>
        <use
          width={180}
          height={120}
          transform="rotate(-72)"
          xlinkHref="#prefix__b"
        />
        <use
          width={180}
          height={120}
          transform="rotate(144)"
          xlinkHref="#prefix__c"
        />
      </g>
    </defs>
    <path fill="#cf142b" d="M0 0h640v480H0z" />
    <path fill="#00247d" d="M0 0h640v320H0z" />
    <path fill="#fc0" d="M0 0h640v160H0z" />
    <g id="prefix__f" transform="matrix(4 0 0 4 320 336)">
      <g id="prefix__e">
        <use
          width={180}
          height={120}
          transform="rotate(10)"
          xlinkHref="#prefix__d"
        />
        <use
          width={180}
          height={120}
          transform="rotate(30)"
          xlinkHref="#prefix__d"
        />
      </g>
      <use
        width={180}
        height={120}
        transform="rotate(40)"
        xlinkHref="#prefix__e"
      />
    </g>
    <use
      width={180}
      height={120}
      transform="rotate(-80 320 336)"
      xlinkHref="#prefix__f"
    />
  </svg>
	),
	VG: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <linearGradient id="prefix__a">
        <stop offset={0} stopColor="red" />
        <stop offset={1} stopColor="#ff0" />
      </linearGradient>
      <linearGradient
        id="prefix__c"
        x1={103.1}
        x2={92.5}
        y1={111.3}
        y2={107.8}
        gradientTransform="matrix(.64274 0 0 1.4534 -94.7 29.2)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__d"
        x1={103.1}
        x2={92.5}
        y1={111.3}
        y2={107.8}
        gradientTransform="matrix(.64274 0 0 1.4534 -94.7 30.2)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__e"
        x1={103.1}
        x2={92.5}
        y1={111.3}
        y2={107.8}
        gradientTransform="matrix(.64274 0 0 1.4534 -98 31)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__f"
        x1={103.1}
        x2={92.5}
        y1={111.3}
        y2={107.8}
        gradientTransform="matrix(.64274 0 0 1.4534 -94.7 32)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__g"
        x1={103.1}
        x2={92.5}
        y1={111.3}
        y2={107.8}
        gradientTransform="matrix(.64274 0 0 1.4534 -94.8 32.8)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__h"
        x1={103.1}
        x2={92.5}
        y1={111.3}
        y2={107.8}
        gradientTransform="matrix(.64274 0 0 1.4534 -94.8 33.8)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__i"
        x1={103.1}
        x2={92.5}
        y1={111.3}
        y2={107.8}
        gradientTransform="matrix(.64274 0 0 1.4534 -98 33.7)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__j"
        x1={103.1}
        x2={92.5}
        y1={111.3}
        y2={107.8}
        gradientTransform="matrix(.64274 0 0 1.4534 -98 32.8)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__k"
        x1={103.1}
        x2={92.5}
        y1={111.3}
        y2={107.8}
        gradientTransform="matrix(.64274 0 0 1.4534 -98 32)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__l"
        x1={103.1}
        x2={92.5}
        y1={111.3}
        y2={107.8}
        gradientTransform="matrix(.8281 0 0 1.8726 602.8 148.2)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__m"
        x1={103.1}
        x2={92.5}
        y1={111.3}
        y2={107.8}
        gradientTransform="matrix(.64274 0 0 1.4534 -98 30.1)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <linearGradient
        id="prefix__n"
        x1={103.1}
        x2={92.5}
        y1={111.3}
        y2={107.8}
        gradientTransform="matrix(.64274 0 0 1.4534 -95.3 31)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#prefix__a"
      />
      <clipPath id="prefix__b">
        <path fillOpacity={0.7} d="M0 0h640v480H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__b)">
      <path fill="#006" d="M0 0h960v480H0z" />
      <path fill="#006" fillRule="evenodd" d="M0 0h350v175H0z" />
      <g strokeWidth="1pt">
        <path
          fill="#fff"
          d="M0 0v19.6L310.9 175H350v-19.6L39.1 0H0zm350 0v19.6L39.1 175H0v-19.6L310.9 0H350z"
        />
        <path
          fill="#fff"
          d="M145.8 0v175h58.4V0h-58.4zM0 58.3v58.4h350V58.3H0z"
        />
        <path
          fill="#c00"
          d="M0 70v35h350V70H0zM157.5 0v175h35V0h-35zM0 175l116.7-58.3h26L26.2 175H0zM0 0l116.7 58.3H90.6L0 13V0zm207.3 58.3L323.9 0H350L233.3 58.3h-26zM350 175l-116.7-58.3h26.1L350 162v13z"
        />
      </g>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M378.5 154.5l219.3-.9-.4 195.4s7.7 29.7-92 74.9c35.9-3.7 75-42 75-42s15.8-20.3 23.5-9a87 87 0 0 0 20.8 21.7c5.7 4.4 10.2 16.6 1.6 25.6-8.5 9-22 10.2-25.6-.8-5.7 2.8-40.7 45.2-112.3 47.2A159 159 0 0 1 375.6 419s-9.7 15.4-23.6 3.2c-13.4-15.8-3.2-26-3.2-26s11.4-6.5 14.6-11c5.3-6.1 7-14.2 15.9-14.2 10.6.8 14.7 9.3 14.7 9.3s36.6 38.7 76 43.5c-89-42.7-92.3-69.1-92-75.6l.5-193.7z"
      />
      <path
        fill="#006129"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={1.7}
        d="M383.8 159.7l209.1-1.2v188c.4 24.4-40.7 49.3-105 81-66.3-34.2-104.5-55-105-81.4l.9-186.4z"
      />
      <path
        fill="none"
        stroke="#f7c600"
        strokeWidth={1.7}
        d="M409 366.9l12.3-18.1 12.4 18.1"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M423.7 360.1a2.5 2.5 0 1 1-4.9 0 2.5 2.5 0 0 1 5 0z"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M411.2 380.3h19.2s.3-2.4-2-4c10-1.3 7.4-10.2 15.8-10.7 1.6.3-4.4 3.8-4.4 3.8s-5 3.6-2.8 5.4c1.9 1.4 2.7-.9 3-2.7.2-1.7 8-2.8 7-7.9-2-4-13 2.8-13 2.8h-7.8c-.5-1-2.7-4.5-5-4.5-2.6.1-4.4 4.5-4.4 4.5H399s-.6 4.6 8.4 5.5c2 2.6 3.6 3.4 5.3 4-1.1 1-1.5 2.2-1.5 3.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.8}
        d="M412.6 376.4h16m-23.3-9.4s1.3 7.5 7.2 9.2"
      />
      <path
        fill="url(#prefix__c)"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.6}
        d="M66.3 170.5c.5-2.1 1.3-2.5 2.2-5.2.1-2.7-2.2-2.4-1.5-4.1 1.2-1.9.6-3.6-1.6-5 .4 2.4-3 4.7-3 6.7s1.8 1.6 1.6 4.6c0 1.8-.5 1.3-.6 3h3z"
        transform="translate(316.6 141.4) scale(1.3225)"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M423.5 349.2a2.3 2.3 0 1 1-4.5 0 2.3 2.3 0 0 1 4.5 0z"
      />
      <path
        fill="none"
        stroke="#f7c600"
        strokeWidth={1.7}
        d="M408.2 329.6l12.4-18.2 12.4 18.2"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M423 322.8a2.5 2.5 0 1 1-4.9 0 2.5 2.5 0 0 1 5 0z"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M410.5 343h19.2s.3-2.4-2-4c10-1.3 7.4-10.2 15.8-10.7 1.6.3-4.4 3.8-4.4 3.8s-5 3.5-2.8 5.4c1.9 1.4 2.7-1 3-2.7.2-1.7 8-2.9 7-7.9-2-4.1-13 2.8-13 2.8h-7.8c-.5-1-2.7-4.5-5-4.5-2.6.1-4.4 4.5-4.4 4.5h-17.8s-.6 4.6 8.4 5.4c2 2.7 3.6 3.4 5.3 4.1-1.1 1-1.5 2.2-1.5 3.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.8}
        d="M412 339h15.9m-23.3-9.3s1.3 7.4 7.2 9.2"
      />
      <path
        fill="url(#prefix__d)"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.6}
        d="M66.3 170.5c.5-2.1 1.3-2.5 2.2-5.2.1-2.7-2.2-2.4-1.5-4.1 1.2-1.9.6-3.6-1.6-5 .4 2.4-3 4.7-3 6.7s1.8 1.6 1.6 4.6c0 1.8-.5 1.3-.6 3h3z"
        transform="translate(316 104) scale(1.3225)"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M422.8 311.9a2.3 2.3 0 1 1-4.5 0 2.3 2.3 0 0 1 4.5 0z"
      />
      <path
        fill="none"
        stroke="#f7c600"
        strokeWidth={1.7}
        d="M539.4 295.6l12.3-18 12.4 18"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M554.2 288.9a2.5 2.5 0 1 1-4.9 0 2.5 2.5 0 0 1 4.9 0z"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M541.7 309l19.1.1s.3-2.5-2-4c10-1.4 7.5-10.2 15.9-10.7 1.6.2-4.4 3.8-4.4 3.8s-5 3.5-2.8 5.3c1.9 1.5 2.7-.8 2.9-2.6.3-1.8 8.2-2.9 7-7.9-1.9-4.1-12.9 2.8-12.9 2.8h-7.9c-.4-1-2.6-4.5-4.9-4.5-2.6 0-4.5 4.5-4.5 4.5h-17.8s-.6 4.5 8.4 5.4c2 2.7 3.6 3.4 5.4 4-1.2 1-1.5 2.3-1.5 3.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.8}
        d="M543 305.2h16m-23.2-9.4s1.3 7.4 7.1 9.2"
      />
      <path
        fill="url(#prefix__e)"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.6}
        d="M66.3 170.5c.5-2.1 1.3-2.5 2.2-5.2.1-2.7-2.2-2.4-1.5-4.1 1.2-1.9.6-3.6-1.6-5 .4 2.4-3 4.7-3 6.7s1.8 1.6 1.6 4.6c0 1.8-.5 1.3-.6 3h3z"
        transform="translate(447 70.1) scale(1.3225)"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M554 278a2.3 2.3 0 1 1-4.5 0 2.3 2.3 0 0 1 4.5 0z"
      />
      <path
        fill="none"
        stroke="#f7c600"
        strokeWidth={1.7}
        d="M411.3 259.4l12.3-18.2 12.4 18.2"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M426.1 252.6a2.5 2.5 0 1 1-4.9 0 2.5 2.5 0 0 1 4.9 0z"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M413.6 272.8h19.1s.3-2.5-2-4c10-1.4 7.5-10.2 15.9-10.7 1.6.3-4.4 3.8-4.4 3.8s-5.1 3.5-2.8 5.4c1.8 1.4 2.6-1 2.9-2.7.2-1.7 8.1-2.9 7-7.9-1.9-4.1-12.9 2.8-12.9 2.8h-7.9c-.5-1-2.6-4.5-4.9-4.5-2.6.1-4.5 4.5-4.5 4.5h-17.8s-.6 4.6 8.4 5.4c2 2.7 3.6 3.4 5.4 4.1-1.2 1-1.5 2.2-1.5 3.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.8}
        d="M415 268.9h16m-23.3-9.4s1.3 7.4 7.1 9.2"
      />
      <path
        fill="url(#prefix__f)"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.6}
        d="M66.3 170.5c.5-2.1 1.3-2.5 2.2-5.2.1-2.7-2.2-2.4-1.5-4.1 1.2-1.9.6-3.6-1.6-5 .4 2.4-3 4.7-3 6.7s1.8 1.6 1.6 4.6c0 1.8-.5 1.3-.6 3h3z"
        transform="translate(319 33.8) scale(1.3225)"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M425.9 241.7a2.3 2.3 0 1 1-4.5 0 2.3 2.3 0 0 1 4.5 0z"
      />
      <path
        fill="none"
        stroke="#f7c600"
        strokeWidth={1.7}
        d="M411.6 223.7l12.3-18.1 12.4 18.2"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M426.4 217a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M413.9 237.1H433s.3-2.4-2-4c10-1.3 7.4-10.1 15.8-10.6 1.7.2-4.4 3.7-4.4 3.7s-5 3.6-2.7 5.4c1.8 1.4 2.6-.9 2.9-2.6.2-1.8 8.1-3 7-8-1.9-4-13 2.8-13 2.8h-7.8c-.5-.9-2.7-4.4-4.9-4.5-2.6.1-4.5 4.5-4.5 4.5h-17.8s-.6 4.6 8.4 5.5c2 2.6 3.6 3.4 5.4 4-1.2 1-1.5 2.2-1.5 3.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.8}
        d="M415.3 233.2h15.9m-23.2-9.4s1.2 7.5 7.1 9.2"
      />
      <path
        fill="url(#prefix__g)"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.6}
        d="M66.3 170.5c.5-2.1 1.3-2.5 2.2-5.2.1-2.7-2.2-2.4-1.5-4.1 1.2-1.9.6-3.6-1.6-5 .4 2.4-3 4.7-3 6.7s1.8 1.6 1.6 4.6c0 1.8-.5 1.3-.6 3h3z"
        transform="translate(319.3 -1.8) scale(1.3225)"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M426.2 206a2.3 2.3 0 1 1-4.5 0 2.3 2.3 0 0 1 4.5 0z"
      />
      <path
        fill="none"
        stroke="#f7c600"
        strokeWidth={1.7}
        d="M412.2 187.5l12.4-18.1 12.4 18.2"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M427 180.8a2.5 2.5 0 1 1-4.8 0 2.5 2.5 0 0 1 4.9 0z"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M414.6 201h19s.4-2.5-2-4c10.1-1.4 7.5-10.2 16-10.7 1.5.2-4.5 3.7-4.5 3.7s-5 3.6-2.7 5.4c1.8 1.5 2.6-.9 2.9-2.6.2-1.8 8-2.9 7-8-2-4-13 2.8-13 2.8h-7.8c-.5-.9-2.7-4.4-5-4.4-2.6 0-4.4 4.5-4.4 4.5h-17.8s-.6 4.5 8.4 5.4a10.8 10.8 0 0 0 5.4 4c-1.2 1-1.5 2.2-1.5 3.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.8}
        d="M416 197h15.9m-23.3-9.4s1.3 7.5 7.2 9.3"
      />
      <path
        fill="url(#prefix__h)"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.6}
        d="M66.3 170.5c.5-2.1 1.3-2.5 2.2-5.2.1-2.7-2.2-2.4-1.5-4.1 1.2-1.9.6-3.6-1.6-5 .4 2.4-3 4.7-3 6.7s1.8 1.6 1.6 4.6c0 1.8-.5 1.3-.6 3h3z"
        transform="translate(320 -38) scale(1.3225)"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M426.9 169.9a2.3 2.3 0 1 1-4.5 0 2.3 2.3 0 0 1 4.5 0z"
      />
      <path
        fill="none"
        stroke="#f7c600"
        strokeWidth={1.7}
        d="M540.4 188.1l12.3-18.1 12.4 18.2"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M555.2 181.3a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M542.7 201.5h19.1s.3-2.4-2-4c10-1.3 7.4-10.1 15.8-10.6 1.7.2-4.4 3.7-4.4 3.7s-5 3.6-2.7 5.4c1.8 1.4 2.6-.9 2.9-2.6.2-1.8 8.1-3 7-8-1.9-4-13 2.8-13 2.8h-7.8c-.5-.9-2.6-4.4-4.9-4.4-2.6 0-4.5 4.4-4.5 4.4h-17.8s-.6 4.6 8.4 5.5a10.8 10.8 0 0 0 5.4 4c-1.2 1-1.5 2.2-1.5 3.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.8}
        d="M544 197.6h16m-23.3-9.4s1.3 7.5 7.2 9.3"
      />
      <path
        fill="url(#prefix__i)"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.6}
        d="M66.3 170.5c.5-2.1 1.3-2.5 2.2-5.2.1-2.7-2.2-2.4-1.5-4.1 1.2-1.9.6-3.6-1.6-5 .4 2.4-3 4.7-3 6.7s1.8 1.6 1.6 4.6c0 1.8-.5 1.3-.6 3h3z"
        transform="translate(448 -37.4) scale(1.3225)"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M555 170.4a2.3 2.3 0 1 1-4.5 0 2.3 2.3 0 0 1 4.5 0z"
      />
      <path
        fill="none"
        stroke="#f7c600"
        strokeWidth={1.7}
        d="M539.2 223.6l12.3-18.1 12.4 18.2"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M554 216.8a2.5 2.5 0 1 1-4.9 0 2.5 2.5 0 0 1 5 0z"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M541.5 237h19.1s.3-2.4-2-4c10-1.3 7.5-10.1 15.9-10.6 1.6.2-4.4 3.7-4.4 3.7s-5 3.6-2.8 5.4c1.9 1.5 2.7-.9 2.9-2.6.3-1.8 8.2-2.9 7-8-1.9-4-12.9 2.9-12.9 2.9h-7.8c-.5-1-2.7-4.5-5-4.5-2.6 0-4.5 4.4-4.5 4.4h-17.8s-.6 4.6 8.4 5.5c2 2.7 3.6 3.4 5.4 4-1.2 1-1.5 2.2-1.5 3.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.8}
        d="M542.9 233.2l16-.1m-23.3-9.4s1.3 7.5 7.1 9.3"
      />
      <path
        fill="url(#prefix__j)"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.6}
        d="M66.3 170.5c.5-2.1 1.3-2.5 2.2-5.2.1-2.7-2.2-2.4-1.5-4.1 1.2-1.9.6-3.6-1.6-5 .4 2.4-3 4.7-3 6.7s1.8 1.6 1.6 4.6c0 1.8-.5 1.3-.6 3h3z"
        transform="translate(446.9 -1.9) scale(1.3225)"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M553.8 206a2.3 2.3 0 1 1-4.5 0 2.3 2.3 0 0 1 4.5 0z"
      />
      <path
        fill="none"
        stroke="#f7c600"
        strokeWidth={1.7}
        d="M537.6 260l12.4-18.2 12.4 18.2"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M552.4 253.2a2.5 2.5 0 1 1-4.9 0 2.5 2.5 0 0 1 5 0z"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M540 273.3h19s.4-2.4-2-4c10.1-1.3 7.5-10.1 15.9-10.6 1.6.2-4.4 3.7-4.4 3.7s-5 3.6-2.8 5.4c1.9 1.5 2.7-.9 3-2.6s8-2.9 7-8c-2-4-13 2.8-13 2.8H555c-.5-.9-2.7-4.4-5-4.4-2.6 0-4.4 4.4-4.4 4.4h-17.8s-.6 4.6 8.4 5.5a10.8 10.8 0 0 0 5.3 4c-1.1 1-1.5 2.2-1.5 3.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.8}
        d="M541.3 269.4h16M534 260s1.3 7.4 7.2 9.2"
      />
      <path
        fill="url(#prefix__k)"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.6}
        d="M66.3 170.5c.5-2.1 1.3-2.5 2.2-5.2.1-2.7-2.2-2.4-1.5-4.1 1.2-1.9.6-3.6-1.6-5 .4 2.4-3 4.7-3 6.7s1.8 1.6 1.6 4.6c0 1.8-.5 1.3-.6 3h3z"
        transform="translate(445.3 34.4) scale(1.3225)"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M552.2 242.3a2.3 2.3 0 1 1-4.5 0 2.3 2.3 0 0 1 4.5 0z"
      />
      <path
        fill="none"
        stroke="#f7c600"
        strokeWidth={1.3}
        d="M539.2 367.3l12.3-18.2 12.4 18.2"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M554 360.5a2.5 2.5 0 1 1-4.9 0 2.5 2.5 0 0 1 4.9 0z"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M541.5 380.7h19.1s.3-2.5-2-4c10-1.3 7.5-10.2 15.9-10.7 1.6.3-4.4 3.8-4.4 3.8s-5 3.5-2.8 5.4c1.9 1.4 2.7-1 2.9-2.7.3-1.7 8.2-2.9 7-7.9-1.9-4.1-12.9 2.8-12.9 2.8h-7.9c-.4-1-2.6-4.5-4.9-4.5-2.6.1-4.5 4.5-4.5 4.5h-17.8s-.6 4.6 8.4 5.4c2 2.7 3.6 3.4 5.4 4.1-1.2 1-1.5 2.2-1.5 3.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.8}
        d="M542.9 376.8h16m-23.3-9.4s1.3 7.4 7.1 9.2"
      />
      <path
        fill="url(#prefix__l)"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M814.5 330.3c.6-2.8 1.6-3.3 2.8-6.8.2-3.5-2.8-3-2-5.3 1.6-2.4.8-4.7-2-6.5.5 3.2-3.8 6.1-3.8 8.7 0 2.6 2.2 2 2 6 .1 2.2-.6 1.7-.8 3.9h3.8z"
        transform="translate(-301.5 28.3) scale(1.0265)"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M553.8 349.6a2.3 2.3 0 1 1-4.5 0 2.3 2.3 0 0 1 4.5 0z"
      />
      <path
        fill="none"
        stroke="#f7c600"
        strokeWidth={1.7}
        d="M539 331.4l12.3-18.2 12.4 18.2"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M553.8 324.6a2.5 2.5 0 1 1-4.9 0 2.5 2.5 0 0 1 5 0z"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M541.3 344.8h19.1s.3-2.5-2-4c10-1.4 7.5-10.2 15.9-10.7 1.6.2-4.4 3.8-4.4 3.8s-5 3.5-2.8 5.3c1.9 1.5 2.7-.8 3-2.6.2-1.7 8-2.9 7-7.9-2-4.1-13 2.8-13 2.8h-7.9c-.4-1-2.6-4.5-4.9-4.5-2.6 0-4.5 4.5-4.5 4.5H529s-.6 4.5 8.4 5.4c2 2.7 3.7 3.4 5.4 4.1-1.2 1-1.5 2.2-1.5 3.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.8}
        d="M542.7 340.9h16m-23.3-9.4s1.3 7.4 7.2 9.2"
      />
      <path
        fill="url(#prefix__m)"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.6}
        d="M66.3 170.5c.5-2.1 1.3-2.5 2.2-5.2.1-2.7-2.2-2.4-1.5-4.1 1.2-1.9.6-3.6-1.6-5 .4 2.4-3 4.7-3 6.7s1.8 1.6 1.6 4.6c0 1.8-.5 1.3-.6 3h3z"
        transform="translate(446.7 105.8) scale(1.3225)"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M553.6 313.7a2.3 2.3 0 1 1-4.5 0 2.3 2.3 0 0 1 4.5 0z"
      />
      <path
        fill="none"
        stroke="#f7c600"
        strokeWidth={1.7}
        d="M434.7 298l12.3-18.1 12.4 18.1"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M449.5 291.2a2.5 2.5 0 1 1-4.9 0 2.5 2.5 0 0 1 4.9 0z"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M437 311.4h19.1s.3-2.4-2-4c10-1.3 7.5-10.2 15.9-10.7 1.6.3-4.4 3.8-4.4 3.8s-5 3.6-2.8 5.4c1.8 1.4 2.6-1 2.9-2.7s8.1-2.8 7-7.9c-1.9-4-12.9 2.8-12.9 2.8H452c-.5-1-2.6-4.5-4.9-4.5-2.6.1-4.5 4.5-4.5 4.5h-17.8s-.6 4.6 8.4 5.4a10.8 10.8 0 0 0 5.4 4.1c-1.2 1-1.5 2.2-1.5 3.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={0.8}
        d="M438.4 307.5h16M431 298s1.2 7.5 7.1 9.2"
      />
      <path
        fill="url(#prefix__n)"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.6}
        d="M66.3 170.5c.5-2.1 1.3-2.5 2.2-5.2.1-2.7-2.2-2.4-1.5-4.1 1.2-1.9.6-3.6-1.6-5 .4 2.4-3 4.7-3 6.7s1.8 1.6 1.6 4.6c0 1.8-.5 1.3-.6 3h3z"
        transform="translate(342.4 72.5) scale(1.3225)"
      />
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={0.8}
        d="M449.3 280.3a2.3 2.3 0 1 1-4.5 0 2.3 2.3 0 0 1 4.5 0z"
      />
      <g stroke="#000">
        <path
          fill="#f7c600"
          fillRule="evenodd"
          strokeWidth={0.8}
          d="M500.7 384.2s5 11.5 10.7 4.4 3.6-10.1 3.6-10.1l-12.7-7-3.8 8 2.2 4.7z"
        />
        <path
          fill="#ffc6b5"
          fillRule="evenodd"
          strokeWidth={0.8}
          d="M511.7 382.6s.8.2 1.5-1-1.5-1.9-2.5-3.3l-1 2.3 2 2zm-28.9-3l-11.2 6.1s-5.6 1.1-6 0c-.4-1.1.2-2 3-2.2 3-.2 10.9-7.4 10.9-7.4l3.3 3.5zm.2-199.7l.4 4c.1 1.4-2.2 4.4-2.4 4.2s-1.2.2-1 1 1.7 1.1 1.7 1.1-.7 3 0 3c.7.2-1.8 3.8 0 4.8s4.9 2.2 6.3 2c1.4-.4 0 5.3 0 5.3l-4 8.3 21.5-2.2-4.5-7s-2-1.4-1.5-5.5c.6-4-.3-22.2-.3-22.2l-15.2-2-1 5.2zm-4 31.7s-6.9 3.2-6.6 11.8c-1.8 8.3-2.7 16.6-2.7 16.6s-8.2 9.3-10.7 12.6-6.3 10.2-7.7 12-6.8 7.7-6.6 10c.1 2.2-1.3 12 4.1 13.1 1.4.6 5.9-11.3 5.9-11.3s.2-5.2-1.3-6.1 3.3-4.3 3.3-4.3l11.4-8.5c2.1-1.7 7.8-8 7.8-8l3.2-38z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          strokeWidth={0.8}
          d="M487 205s1.8 4.9 5.8 4c4-.8 8.8-4.5 8.8-4.5s3.7-.1 4.3.4c.5.6 10.1 9.9 9.8 12.8-.3 2.9-4.4 2-6 4s-4 6.8-3.3 10.4 2.8 8.3 2.5 10.1-1.8 2.4-1.8 3.4 1.3 2.6 1.3 4.4-1.7 4.4-1.4 6.3c.3 1.7.4 7 .4 7l-.4 24.4s1.4.9 1.5 2.3c.1 1.4 9.4 41.7 9.4 41.7s-.4 1.3-1.4 1.1 3.8 6.3 4 8 4.8 16 4.7 18c-.2 2-.9 6.2-1.3 6.4-.4.1 3 8.9 2.5 10.2-.6 1.4-6.2 1.3-6.2 1.3l-1.6-.3s.2 1.8-1 2-9.2-.5-9.2-.5-2.4 3.6-3.8 3.5c-1.4-.1-3.2-2.6-3.6-2.2-.4.4 1.3 2.8.8 3.5-.4.7-7.5 2.2-8.8-1.2-1.4-3.3.8-2.5.4-3.2-.4-.6-3.6-2.4-4.6-1.9s2.5 1.4 2.4 2.8c-.2 1.4-3 3.5-4.2 3.5s-3.8-5.2-7.6-4.6c-4 .5-6.4 1.5-6.4 1.5s-4.6 2-6.5 1.5c-2-.4-2.8-2-2.8-2.8 0-.8 1.4-4.4 1.2-5.5s-1.2-2.2-1.2-3.9c0-1.6 3.2-7.3 3.2-7.3l-.2-25.6s-2.9 0-3-1.8 4.4-40.4 5.1-42.9c.7-2.5 2.5-11.3 2.5-11.3s-2 1-2.2 0 6.2-23 6.2-23 1.1-11 1.1-14c0-2.9-.5-6.9-.5-6.9s-5.7-2.4-5.8-6c-.6-6 5.4-9.2 6-11.2l2.8-7.8s3.1-5.2 8.1-6z"
        />
        <path
          fill="#f7c600"
          fillRule="evenodd"
          strokeWidth={0.8}
          d="M485 381.3s-13.5 7-15.5 7.6c-2 .6-3.2-2.4-1.2-3 2-.5 5-.8 5-.8s-4.6-3.6-4.5-3.7l6.4-2.4c.1 0 2 3.6 3.2 3.4s4.9-3 4.9-3l1.6 1.9z"
        />
        <path
          fill="#ffc6b5"
          fillRule="evenodd"
          strokeWidth={0.8}
          d="M503.9 385.1c1.3 1.7 1.8 4.5 4.7 2.9s-1.5-4.8-1.5-4.8l-3.2 2zm5.3-.2s1.4 1 2.6-.2-2.5-3.9-2.5-3.9l-1.8 2.1 1.7 2z"
        />
        <path
          fill="none"
          strokeWidth={0.8}
          d="M505 210.5s-12.3 7.9-12 10.6m14.8-9.3L505 215m6.7.3s-6.1 5-5.2 8.2m-23.7-13.6s-1.8 3.7-1.4 5c.4 1.2 3.5 6 3.9 8.8.4 3 0 5 0 5m-5.7-11.9s.6 4.4 1.4 5.3c.8.8 3 4.6 3.3 6m-5.8 7.2s3.6 1.8 7-5.2m5.3-4.8c-.1 0-2.6 6.8 1.8 9.3s7.8 2.2 9.8 1.5c1.9-.7 4-2 4-2m-17.5-.5s.3 9.2 13.8 18.2m-13.2-9.6s-.2 8 5.1 11.7m-8-21.1s-4 11.9-7.1 13.1m6-4.4s-.2 8.6-1.3 11.7m-1.1 2s2.8 3.5 5.8 3.2c3-.2 4.3-3.9 6.4-3.3 2 .6 4 2.2 8.9 1.8m-7 3.6s0 7 1.3 7.8.7 7.2.7 7.2m-19-18.5s-.1 6.6-1 9c-.8 2.4-2.5 6.4-2.2 9.8m-5.3 4c.7-.3 3-2.4 3-2.4m1.3 1.5s-6 25.5-4.3 40.8m5.7-39.5s-3 19.1-1.6 22.7m.1-23.3l11.7.8m1.6-1.5s3.2 1.7 7.6 1.4m-9 7.9s-.5 32.7-1.4 40m18.5-32.5s3.6 28.7 5.7 31.3M498 299.4s2.2 25.4 3.4 27.6m-35 8.9s4.4-1.4 8.3-5.6c4.4 6 11.2.3 11.2.3s10.5 7.2 15.3-.8c7.2 4.7 10.8-.7 10.8-.7s2.6 4 4.6 3.6m-11.6 2.8s5.5 25.4 13.5 32.6m-41.3-35.3s.7 21.3 1.9 36.2m-3-12.2s-.6 14-1.4 14.9M468 373s1.5 6 9.2.4 7.7 2 8 3c.3.7 1.5 6.7 4.4 1.7m6.1-8.2s-1.2 12.4 9.8 3.3c11-9 12.7 0 13 2.7"
        />
        <path
          fill="#9c5100"
          fillRule="evenodd"
          strokeWidth={0.8}
          d="M482.6 179.1s3 .4 4.7-.6c1.6-1 3.6-1.4 5 .6s2.3 1.8 2.3 1.8-2 5.1 0 5.7c2.1.6 3 .6 3.2 1.2.2.7-1.8 2.3-1.2 3 .5.6 1.5 1.5 1.6 2 .2.6-1.2 3-.8 3.5.4.6 1.7 2.8 2.5 2.8s.3 3.5 2.8 2.6 2.3-3 2.3-3 2.7-.4 3.4-2.8c.7-2.4 2.3-3 2.3-3s3.4-1.7-1-4.5c0-19.4-12.8-17.4-12.8-17.4s-1.6-3.4-4-3c-2.6.4-2.7 3.3-4.5 3-1.8-.2-2.2-1.5-2.4-1.3-.1.1-1.6 2.9-1.6 3.6 0 .7-4.9-1-4.5 2.6s2.8 3.5 2.7 3.2z"
        />
        <path
          fill="none"
          strokeWidth={0.8}
          d="M495.9 174.4s-1 6 5.5 5.5c-.8 3.4 1.7 4.5 1.7 4.5m4.8 3.7c.2 0 3 1.8 0 4m-9.4.9s1.4 1.6 3 1.2c1.5-.4 4 1.6 4 1.6s2 .7 2.3.2m-17.7 2.3s4.7 1.8 7.7-5.7m-16.5-2.3l2.8.2"
        />
        <path
          fill="none"
          strokeLinejoin="round"
          strokeWidth={0.8}
          d="M481.7 193.1h2.5l-2.2 1"
        />
        <path
          fill="none"
          strokeLinejoin="round"
          strokeWidth={1.4}
          d="M485.2 185.3c.4 0 2-.5 2.2 0 .3.3-1.6.6-2.2 0z"
        />
        <path
          fill="#ffc6b5"
          fillRule="evenodd"
          strokeWidth={0.8}
          d="M515.2 218.3c.1 0 4.5 13.7 5.1 17.2a112 112 0 0 1 1.7 19.3c-.7 2-7.8 11.2-8.6 13.6-.9 2.4-5.9 11.4-5.9 11.4s-1.2 8.9-1.8 9.3c-.5.4 1.5 2.6 1.3 3.3-.3.8-4 4.7-5.7 4.3-1.7-.4-4.3-2.4-4.4-4.2s0-7.7 1.3-9.3 7.8-16.9 8.2-17.9c.4-1 6-13 6.1-15 .2-2.2-1.7-7-3.7-8.7-4.3-12.9-2.6-20.6 6.4-23.3z"
        />
        <path
          fill="none"
          strokeWidth={0.8}
          d="M450.5 277.8l.2 6.1m-5.9-6.5s4 6.5 3.6 10"
        />
        <path
          fill="none"
          strokeLinejoin="round"
          strokeWidth={0.8}
          d="M497 291s3-.3 2.9 4.6c1.9-6 5.7-6.2 5.7-6.2"
        />
      </g>
      <path
        fill="#f7c600"
        fillRule="evenodd"
        stroke="#000"
        strokeWidth={1.7}
        d="M487.1 430c58.6-1.7 96.5-44 96-44.4-.4-.4 7.8-11.8 14.3-10.2 6.5 1.6 15.9 20.8 27.3 24.8 5.7 9-1.7 17.1-4.1 18.8-2.5 1.6-13.4 6-15-.4-1.7-6.6-5-5.3-5-5.3s-52 50.8-112.3 48.8c-62.2.4-113.5-48.8-113.5-48.8l-4.5 4.8s-4.9 5.3-7.3 5c-2.4-.5-13-7.4-13.8-14.3-.8-7 6.5-11.4 6.5-11.4s17.9-13.8 20-21.2c4-4 11.7 2.9 11.7 2.9s47.2 54.1 99.7 50.8z"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.7}
        d="M354.5 398.5s4.8-1.3 6.6.7c1.8 2 14 14 14 14"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.7}
        d="M365.5 404.1l-4.8 3.6s12.2 2.5 9.4 10.5M620.3 398s-2.4-1.3-6.2 1.5a158.5 158.5 0 0 0-13.4 13.6"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth={1.7}
        d="M609.4 403.8l5.3 4s-11 .8-8.6 11.2"
      />
      <path d="M416.5 411.4l-.4.5a3.6 3.6 0 0 0-2.5-.2c-.7.2-2 .8-3.9 2l-16.1 9.3-.4-.3 4-18.8c.5-2.3.7-3.7.7-4.2s-.4-1-1-1.6l.3-.5 8.7 6.2-.3.5-.3-.2c-.8-.5-1.4-.8-1.8-.8a.8.8 0 0 0-.8.3 2.4 2.4 0 0 0-.3.7l-.5 2.3-2.6 11.7 9.3-5.4a26 26 0 0 0 2.2-1.4l.8-.8c.2-.2.3-.5.3-.8l-.3-1a5.2 5.2 0 0 0-1.4-1.3l.4-.5 5.9 4.3m5.8 28l-.3.5-10.2-5.6.3-.5.6.4c.6.3 1.1.4 1.6.4.3 0 .6-.1 1-.4l1-1.7 7-12.8c.6-1 1-1.7 1-2a1.6 1.6 0 0 0-.3-1 3 3 0 0 0-1.2-1l-.6-.4.3-.5 10.2 5.6-.3.5-.7-.3a3 3 0 0 0-1.5-.5c-.3 0-.6.1-1 .4a6.8 6.8 0 0 0-1.1 1.7l-7 12.9a7.3 7.3 0 0 0-1 2c0 .3.2.6.4 1 .2.3.6.7 1.1 1l.7.3m37.3-8.8L457 438l-.6-.2a10 10 0 0 0-1.5-5.7 7.8 7.8 0 0 0-4-3.2 6.2 6.2 0 0 0-4.3 0 7.5 7.5 0 0 0-3.5 2.9 19.4 19.4 0 0 0-2.4 4.6c-.7 2-1.1 3.8-1.2 5.5s.3 3.1 1.1 4.2a7 7 0 0 0 3.4 2.4 8.6 8.6 0 0 0 1.6.4l1.8.1 1.6-4.4.4-1.6c0-.3-.2-.6-.5-1a2.8 2.8 0 0 0-1.2-.7l-.5-.2.2-.6 10.2 3.7-.2.6c-.8-.3-1.4-.4-1.8-.3-.3 0-.7.2-1 .5l-.6 1.4-1.6 4.4c-1.5.1-3 0-4.6-.2a22.8 22.8 0 0 1-4.7-1 14.1 14.1 0 0 1-4.7-2.7 13.6 13.6 0 0 1-2.7-3.3 10.9 10.9 0 0 1-1.3-3.9 11 11 0 0 1 .6-5.1 11.4 11.4 0 0 1 6.2-6.8 12 12 0 0 1 9.5-.3c1 .3 2 .8 2.8 1.2l2 1.5a10 10 0 0 0 1.5 1.2h1a3 3 0 0 0 1-1l.6.2m15.7 25.3v.6l-11.6-1.8.1-.6.8.1a3 3 0 0 0 1.6 0l.7-.7c.2-.3.3-1 .5-2l2.2-14.5c.2-1.2.2-1.9.1-2.2a1.6 1.6 0 0 0-.6-.8c-.3-.3-.8-.5-1.4-.6h-.7v-.7l11.6 1.8-.1.6-.7-.1a3 3 0 0 0-1.6 0l-.8.7a7 7 0 0 0-.5 2l-2.2 14.5a7.3 7.3 0 0 0-.1 2.2c0 .3.3.6.6.8.3.3.8.5 1.4.6h.7m30-7.2l-.5 7.9-19.8 1v-.6h.7a3 3 0 0 0 1.6-.5c.3-.2.5-.4.6-.8v-2l-.7-14.7a7.3 7.3 0 0 0-.3-2.1c-.1-.3-.4-.5-.7-.7-.4-.2-1-.3-1.5-.3h-.8v-.6l11.9-.6v.6l-1 .1a3 3 0 0 0-1.5.4c-.3.2-.5.5-.6.8-.2.3-.2 1-.1 2.1l.7 14.2c0 1.1.2 1.8.3 2.2.2.3.4.5.8.6h3.9a6.3 6.3 0 0 0 2.9-.8 5.5 5.5 0 0 0 2-2c.4-1 1-2.4 1.4-4.1h.6m21.6-3.8l-7.5 2.2-.3 2.4v1.8c.3.6.6 1 1.2 1.1.3.1 1 0 2.2-.2l.2.6-7.1 2-.2-.5a3.3 3.3 0 0 0 1.6-1.5c.4-.7.6-2 .9-3.8l2.5-19.3h.3l13 15.1c1.2 1.5 2 2.3 2.7 2.6.4.2 1 .3 1.7.1l.1.6-10.3 3.1-.2-.6.5-.1c.8-.3 1.4-.5 1.6-.9a.9.9 0 0 0 .1-.8 2 2 0 0 0-.2-.6l-.8-1-2-2.3m-.9-1l-5.3-6.4-1.1 8.3 6.4-2m28.5-29l2.9 5.4-.6.3a9.3 9.3 0 0 0-2.4-2.1 4.5 4.5 0 0 0-2.2-.5 5 5 0 0 0-2.1.8l-1.5.8 8.2 15.1 1.1 1.8c.3.2.6.3 1 .3.5 0 1-.1 1.5-.4l.7-.4.3.6L551 442l-.3-.5.7-.4a3 3 0 0 0 1.2-1l.2-1c0-.3-.3-1-.8-2l-8.2-15-1.4.7c-1.3.7-2.1 1.5-2.4 2.4a6.3 6.3 0 0 0 .2 4.2l-.6.3-2.8-5.4 17.6-9.4m13.4-8l5.4 7.3.4-.3c1.1-.8 1.7-1.8 1.6-2.9s-.5-2.4-1.4-3.9l.5-.3 7 9.3-.4.4a8.6 8.6 0 0 0-2.6-2 3.5 3.5 0 0 0-2.1-.4c-.7 0-1.4.4-2.2 1l3.7 5a9.6 9.6 0 0 0 1.5 1.8l.9.2c.3 0 .7-.3 1.3-.6l1-.8a8 8 0 0 0 3.1-4.2 8 8 0 0 0-.5-5.2l.5-.3 3.5 6.2-15.4 11.6-.3-.5.6-.4c.5-.4.8-.8 1-1.2v-1a6.8 6.8 0 0 0-1-1.8l-8.9-11.7-1.2-1.4a1.6 1.6 0 0 0-1-.4c-.5 0-1 .3-1.6.7l-.6.4-.4-.4 14.9-11.3 4 5.3-.6.4a7.8 7.8 0 0 0-3.1-2 5 5 0 0 0-2.9.2c-.6.2-1.6.9-3 1.9l-1.7 1.4" />
      <path fill="none" d="M380.5 413c72.8 59.1 144.2 60.2 214 0" />
    </g>
  </svg>
	),
	VI: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path
      fill="#369443"
      stroke="#010002"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M204.3 315s-.5-3.6 6.2-6.1c6.6-2.6 7.2-12.2 5.8-18.6 0 0-3.4 6-7.7 8.1 0 0-6.8 3.6-7.2 10.4 0 0 0 2.5-.5 4.5-.3 1-3.4-8.6 2.4-15.8 6-7.3 7.6-13.3 2.9-25 0 0-.5 7-5.1 11.1-4.7 4-5.3 4.4-5.2 14 0 0 0 3.4-1.7 4.5 0 0-3.6-5.3-4.6-8.8-1-3.5-1.4-5 2.8-9 0 0 13.2-8.7 3.7-27.4 0 0-.3 6.4-5 10.2-4.5 3.9-4.2 6.4-4.4 13-.2 6.7-.6 6.2-1.1 7.2 0 0-8.5-15.6-2-23.8 6.5-8.3 10.2-10 3-25.4 0 0 .3 8-5.5 11.8-5.7 4-4.4 13-4.4 13s.4 3.5-.8 6c0 0-8.1-15.9-.4-24.4 6.6-7.3 7-12.4 3.5-22.6 0 0-.4 4.7-4 7.3-3.7 2.6-6.6 5.1-5.9 15 0 0 .3 7-.6 9 0 0-3.4-6.4-4.4-10.5-1-4.2-1.3-6.6 1.2-10.7s12.5-16 .6-33c0 0-.3 5.5-3.4 10.5-3 5-1.6 10.9-1 15.4.7 4.5-1.5 8.9-1.5 8.9s-5.2-9.5-4-20.4c1-11-3.4-20-13.5-26.4 0 0-7.3 17 2.7 25.7 0 0 8.5 8.4 10.7 18.6 0 0-6.5-.6-12.3-12-5.9-11.4-18-9.6-18.8-9.7 0 0 2 17.6 20.6 22.6 0 0 12 2 14.2 10.8 0 0 2 6 2.8 9.2 0 0-3.8-1.5-7.3-6.7-3.5-5-3-5.7-14.8-6.9 0 0-4.7-.5-7.2-3.9 0 0 5 18.6 17.7 18.5 0 0 11.6-1.3 18 14l-2.9-2c-1.7-1.1-6-3.3-14.5-2.3s-10.9-.4-13-1c0 0 8.6 15.7 20.7 11 12.2-4.7 18 12.4 18.2 12.7 0 0-1.7-1.2-3.8-3.3-2.2-2.1-6.6-4.7-15-2 0 0-6.1 2.3-12.3.4 0 0 6 11.5 19.8 9.5a15.1 15.1 0 0 1 17.3 10.2s-1.8-1-3-2c-1.3-1-6-3.7-16-.8-10 3-13.6-.4-13.6-.4s5.5 10 16.2 11.3c0 0 6-.1 8.4-1 2.5-1 9.2-2.5 13.8 4.2 0 0-1.3.2-3.2-.7 0 0-7-2.5-12.5 2 0 0-4.8 4.9-11.6 4 0 0 8.8 8.5 22.8 1.3 0 0 4.7-3.4 8.2-.8 3.5 2.7 11.5-2.6 11.5-2.6z"
    />
    <g fill="#f4c53d" stroke="#010002" strokeMiterlimit={10} strokeWidth={1.5}>
      <path d="M282.2 103.7s-1.6-14.5 10-16a38 38 0 0 1 18 1.2l5.5 10.6-2 7.2-7.4 3.4s1.3-11-8.8-11.2c-2.6 0-4 1-8.1.3s-6.3 3.8-7.2 4.5z" />
      <path d="M363.8 139.6c-1.8 2.2-8.7 3-8.7 3s7.1 5.5 10.2 13.3c3 7.7-82.4 0-82.4 0s3.8-2.6 6.3-7.6c0 0-3.8 1.4-7.6-2.4 0 0 2.8 1 6.5-4.6 0 0 5.5-7 9.4-9 0 0-1.8 1.2-6.1-1.2 0 0 7.4-1 10-13.5 0 0 .5-2.8 3.3-7 2.8-4 2.2.9 7.4-5.4 0 0 2.4-4.4.3-7-2-2.8-4.3-1.8-8.6-4.4-4.4-2.6-6.3-4-4.8-8s5.3-3.4 5.9-3.4.8-3.5 5.5-5.9 17.4-1.3 19.2-.3c2 1 9.5 3.3 14 14.5 4.4 11.2-1.2 15.4 10.8 32.4 0 0-4.8 1-7.9 0 0 0 6.3 11.2 17.3 16.5z" />
      <path fill="none" d="M311 92.2c-10-.5-6.1-9.8-6.1-9.8" />
      <path d="M328 93.5s-1.7-.8-3.2-2.8c-2-2.7-6.7-4-9.1-1.4 0 0-2.5 2.8-4.8 3 0 0 2.6.7 4.3 2.3 1.7 1.6 3.5 2.8 6.1 2.4 2.6-.3 3-1.7 4.2-2.5 1.3-.8 2.5-1 2.5-1z" />
    </g>
    <path
      fill="#369443"
      stroke="#010002"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M202.8 336.5s-.2-6.4 7.8-6.8l23.5 32.7s-.9 2.1-11.5 1.9c0 0-1.2 0-1.8 1.2-.9 2-18-29-18-29z"
    />
    <g
      id="prefix__a"
      fill="#f4c53d"
      stroke="#010002"
      strokeWidth={10}
      transform="translate(3.6 26.2) scale(.15055)"
    >
      <path d="M1495 1807.9s-49.9 85.6-110.2 87c0 0-103.7-12.6-133 14.5-20.5 18.9-41.4 34.5-50 82.8-8.4 48.3 16.5 58.7 22.4 60.8 0 0 4.6 34.5 38.7 25.5 0 0 2 36 62.2 18.7 60.3-17.3 85.3-11.8 97-71.8 11.9-60.1 22.8-59.1 33.5-66.3 14.4-9.7 41.5-18.8 61.6-30.4 18-10.4 87.2-45.6 110.8-48.3 23.6-2.8 18.4-82.2 18.4-82.2h-61l-29.5-43.5-61 53.2zm192-429.4s-61 49.7-112.2 0c0 0-20.6 24.8-62 17.6-41.2-7.3-48.1-29-52-41.4 0 0-35.8 20.8-66 4.3-30-16.4-30-41.3-30-41.3s-52.5 10.4-79.4-25.2c-26.9-35.5-10.5-70.7 4-74.9 0 0-56.7 14.9-72.2-33.8a56 56 0 0 1 16.4-62.8s-119.4-.6-168.4-38c0 0-40.7-25.6-16.4-52.5 0 0-107.5-17.2-134.4-60 0 0-11.8-11.8-7.9-32.5 0 0 .7-11.7 12.5-12.4 0 0-122.6-19-158-59.4 0 0-17-18.6-8.5-43.5 0 0 1.8-6.5 4.7-11 0 0-111.6-23.5-166.6-73.2 0 0-31.8-28.3-15.4-66.3 0 0-186.5-51-143.3-133.2 0 0-87.2-28.3-59.6-107 0 0-72.1-36.6-40.7-94.6 30.1-55.5 122.6 9.7 232 40 0 0 296.4 93.2 442.3 118l414.6 617.3 241.9 93.2 24.5 172.6z" />
      <path d="M1689.9 923.9s-38.9-29.2-108.2 5.1c0 0-23.3 16.1-41.7-1.5a37.3 37.3 0 0 1 4.3-57.5c51.7-38.3 70.8-153.2-7.8-200.9 0 0-114-67.6-532.3-174 0 0-35-9.8-53.8-5.1a52 52 0 0 0-37.6 37.8S894 581.1 957 611.6c0 0 28.4 13 57.7 21.4 0 0-32.2-7-46 24.8-13 30.4 6 61.5 65 81.5 0 0 16 6.2 38.7 11.7 0 0-50.5 14.5-26.2 55.3 0 0 21.6 42.8 98 50.4 0 0-57 6.2-16.8 60.4 0 0 17.7 29.7 73.4 40.7 0 0-42.2 1.4-21 39.3 21.4 38 71.5 59.4 120.9 62.9 0 0 26.7 1.4 45.4-2.8 0 0-47 23.5-19.4 62.8 0 0 20.3 28 71.1 26.6 0 0-13.1 44 24.1 60.6 29 13 53.1-7.8 53.1-7.8s-9.8 47.1 32.5 63.7c0 0 21.1 10.9 52.6 0 0 0 24 53.9 109.6 16 85.6-37.7 20.2-355.1 20.2-355.1zm5 489.4s-12.5 67.4-112 152.2c0 0-76.8 67.7-74.9 145.7 2 79.5-13.7 88.4-43.9 115.3 0 0 62.3 4.9 92.4-36.6 0 0-1.3 69-10.5 75.3 0 0 19.6 1.2 47.9-29.7 0 0 17-18 32.8-24.9 0 0-18.4 47.7-4 91.9 0 0 4.6-17.3 28.9-24.9 0 0 44-9 61-72.5 0 0 11.1-42 80-79.4 0 0 78-29.4 76-67.8-2-38.5-173.6-244.6-173.6-244.6z" />
      <path
        strokeMiterlimit={10}
        d="M2056.5 2282.2s-17.9 78.8-80 72.5c0 0-43.9-4.2-40.6-77.4 0 0-64.9 34.6-75.4-51 0 0-59 13.7-58.3-66.3 0 0-55 9.6-48.5-61.5 0 0-59.7 16-59.7-51 0 0-139.6-23.2 151.4-288.6l259.6 154.6-48.5 368.7z"
      />
      <path d="M2085.4 1928.3s-43.3 38.4-74.1-19c0 0-42-2-48.5-33.8 0 0-34.1-3.4-40.7-35.9 0 0-46.5-4.8-45.2-44.1 0 0-84.6-6.6 0-102.4 84.6-95.8 228.1 159 228.1 159l-19.6 76.2zm48.2-23.8c42 0 89.5 262 77.2 419.9-4.5 57.3-35.2 104.1-77.2 104.1s-72.6-46.8-77-104.1c-12.4-157.9 35.1-419.9 77-419.9" />
      <ellipse cx={2133.6} cy={1902.5} rx={58} ry={86} />
      <path
        fill="none"
        strokeMiterlimit={10}
        d="M1935.9 2277.3s6.6-138.7 126.8-337.6m-202.2 286.6s-18.7-80.1 150.8-317c0 0-19.7-56.5 40.6-92.8M1802.2 2160s-5.3-86.7 160.6-284.5c0 0-14.7-51 45.4-91.8m-254.5 314.8s6.2-87.6 168.4-258.9c0 0-8-52.4 50-84.9m-278 292.8s11.7-100.1 182.8-252c0 0-5.9-39.4 51.1-79.4"
      />
      <path
        fill="none"
        d="M372.3 432s134.3 77.8 552.9 155.6M431.9 539S795.6 657.6 965 672.2m-389.9 0s213.4 67 463.3 109.3m-281.2 30.3s241 57.9 356.2 67.5M919 925.6s203.9 42.5 255.5 47.6m-125.7 57.3s148.8 22.6 208 21.4m-23.2 69s60.2-2.8 89.1-7.6m-33.4 104.3s51.2-13.8 81.3-33.1m-5.9 133.2s39.4-15.2 58.4-56.6m37.7 93.6s30.4-27.3 32.4-57.7m81.6 81.5s-11.4-9.9-3.6-52.7m-11.1-62.8s-6-12.2-4-31.6m-211-581.3s68.8 27.6 91.7 65.6c23 38 7.9 74.9 0 96-3.9 10.7-52.4 104.2 4.6 171.9M1346 1057s.4-.3 24.6-8m-169.8-91.4s41 8.2 81.3 8.6m-138-109.8s48.2 4.9 93.5 4.2m-165.2-109.8s69.5 13.8 106.8 14.5M1014.7 633s85.7 24.4 149.4 33.1m141.6 50.4s-61.6 57.3 12.5 110.5c0 0-30.8 48.3 30.8 98.7m-16.4 23.8s-9.2 92.2 103.6 92.2c0 0-21.7 82.1 87.2 79.4 0 0 12.4 65.6 91 52.4M1441.3 1895s-17.9 4-56.6 0m-108.8 48.3s-54.4-8.3-51.8 109.8m84.6-82.9s-49.2-6.2-46 108.4m520.7-384.5s-23.6 4.8-40 23.5c-16.3 18.6-47.8 15.1-47.8 15.1s17-13.8 23-48.3c5.8-34.5 24.9-44.9 24.9-44.9m-56.3-32.6s-23.6 4.8-40 23.4c-16.4 18.7-47.9 15.2-47.9 15.2s17-13.8 23-48.3c5.9-34.5 24.9-44.9 24.9-44.9m23.7 188.5s-20.6 4.3-34.9 20.5c-14.3 16.3-41.8 13.3-41.8 13.3s15-12 20-42.2c5.2-30.1 21.8-39.2 21.8-39.2"
      />
    </g>
    <use
      width="100%"
      height="100%"
      stroke="#010002"
      strokeWidth={10}
      transform="matrix(-1 0 0 1 647.2 0)"
      xlinkHref="#prefix__a"
    />
    <path
      fill="#0081c6"
      stroke="#010002"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M466 256l-14.3 61.7-5.9-4.2 14-59.2-9.8.2 23.1-42.3 1.5 48.7zm37 13l-43 50.8-4.6-5.2 42.8-50.2-8.7-4.6 39.2-26-20.3 43.8z"
    />
    <path
      fill="#0081c6"
      stroke="#010002"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M492.6 242l-38.5 74-5.9-3.5 38.7-73.8-9.4-2.4 32.7-34.6-10.5 47.5zm-48 96.6l-2.9 11.7 8 8-11.2 47-10-13.3-14.6 6.8 11.1-47 10.4-3 2.6-11.7s3.2-1.2 6.6 1.5z"
    />
    <path
      fill="#0081c6"
      stroke="#010002"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M447.3 330.8l-5.7 10.6 5.7 9.7-22.4 42.5-6.3-15.6-15.9 2.6 22.4-42.4h10.7l5.5-10.6s4 0 6 3.2z"
    />
    <path
      fill="#0081c6"
      stroke="#010002"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M448.2 333.9l-15 19.2 3.4 10.8-30.9 36-2.8-16.6-16-1.2 30.8-36 10.4 2.5 16-20.4s4.4 2.2 4.1 5.7zm-382.7-45c3.6-1.5 6.2-2.9 6.2-6.7 0-1-.5-3-1.5-6.1L46 202a59 59 0 0 0-3-7.9c-1.1-2-3.2-2.9-6.1-4h30.7c-3.3 1.5-6.4 2.7-6.3 6.3 0 1.3.4 3.2 1.1 5.7l18.6 58 18.5-58a20 20 0 0 0 1.1-5.7c0-3.7-3.2-5-6.3-6.4h29.8c-2.7 1.1-5 2-6 4.1a63 63 0 0 0-3.1 8L90.8 276a37.9 37.9 0 0 0-1.5 6.1s-1.1 4.7 6.2 6.7h-30zm515.3-7.6v-83.7c0-1.4-.3-2.5-.8-3.3s-2.5-3-5.5-4.2h27.7a11.5 11.5 0 0 0-5.5 4.2c-.5.8-.7 1.9-.7 3.3v83.7c0 1.5.2 2.6.7 3.4.5.8 2.5 2.8 5.5 4.2h-27.7c3-1.4 5-3.4 5.5-4.2.5-.8.8-1.9.8-3.4z"
    />
    <path
      fill="#fff"
      stroke="#010002"
      strokeWidth={1.5}
      d="M324.8 309.8S399 276.9 399.1 201H250.5c.2 76 74.3 108.8 74.3 108.8z"
    />
    <path
      fill="#a60032"
      stroke="#010002"
      strokeWidth={1.5}
      d="M262 201v48.5s5.6 11.3 11.4 18.3V201H262zm22.8 0v80s7.2 7 11.4 10.4V201h-11.4zm22.9 0v98.9s8.1 5.2 11.4 7v-106h-11.4zm80 0v48.5s-5.7 11.3-11.5 18.3V201h11.5zm-22.9 0v80s-7.1 7-11.4 10.4V201h11.4zm-22.8 0v98.9s-8.2 5.2-11.5 7v-106H342z"
    />
    <path
      fill="#162667"
      stroke="#010002"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M399.1 145.8s-36.4 19-74.3-1.6c-37.9 20.6-74.3 1.6-74.3 1.6V201h148.6v-55.2z"
    />
  </svg>
	),
	VN: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-85.3 0h682.6v512H-85.3z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(80) scale(.9375)"
    >
      <path fill="#ec0015" d="M-128 0h768v512h-768z" />
      <path
        fill="#ff0"
        d="M349.6 381L260 314.3l-89 67.3L204 272l-89-67.7 110.1-1 34.2-109.4L294 203l110.1.1-88.5 68.4 33.9 109.6z"
      />
    </g>
  </svg>
	),
	VU: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M0 0h682.7v512H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="scale(.9375)">
      <g fillRule="evenodd">
        <path d="M0 0l347.4 219.4H768v73.2H347.4L0 512V0z" />
        <path
          fill="#ff0"
          d="M0 493.7L354.7 267H768v-22H354.7L0 18.3v32.9L332.8 256 0 460.8v32.9z"
        />
        <path fill="#40aa40" d="M0 512l354.7-226.7H768V512H0z" />
        <path fill="#ce0000" d="M0 0l354.7 226.7H768V0H0z" />
        <path
          fill="#ff0"
          d="M95.8 266.6c1.2.3 1.6.6 2.8-1.1.2-1 1-2.2 1.7-3.3.8-1.5 1.2-2 2-1 .6.7 2.8-.5 3.6.1 1.4 1 .6.8 1.7-.2.9-1.8.1-1.6-1-2.4-1-.6-3.1.6-4 0 .3-1.8.9-2 2-2.4.8.5 3.1-.4 3.8-.4 1 .2 2 .3 2.3-1.2.5-1 .3-.3-.2-1-.8-.7-3 .5-3.9 0-1-.9-.9-1.2-.2-2.6.8-.5 1.5-.3 2.6.4 1 .8 2.8-.7 3.8-.8.9-1 1.9-1.3 1.2-2.5-.3-1-.6-1-1.8-1.3-1.2-.8-2.8.7-3.3-.5 1-1.4 1.3-1.1 2.5-.3.8.2 3-1.1 3.8-1.2 1.1-.3.6 1 1.4-1.8-.3-1.2-2.3.7-3.4.4-1 .2-2-.2-2-1.4 0-1.5.8-1.6 1.9-1.4 1 .2 3.1-1 4-1 1 .6 1.5.4 2.4-1 .6-1.7-.1-1-1.3-2-.8-.5-3 .7-3.9.1.2-.6.5-1.4 1-1.7.9.2 1.6.2 2.7.8 1 .5 2.8-1.5 3.7-2.2-.2-1-2 .4-3-.3-.6-.5-1.5-1-1.7-1.5.6-1.7.3-1.6 2-1 .8-.3 2.3-.3 1.3-1.9-.2-.2-1-.2-1.8-.5-.9-.6-1.7-1.3-2.7-1.5-.7-.1-1.7-.4-2.2-.2 0 1 .2 1.6.1 2.8.5.7 1.3.7 1.5 1-.9.8-1.4.4-2.3.4-1.2-.7-.5-3.1-1.9-2.6.3.7.2 3.4.8 4 .6.4 1.4.8 1.5 1.3-1 1.5-1.3 1.4-2.5.7-1-.6-.6-2.8-1.5-2.7-1 .8-1 .7-.8 1.8 0 1.4-.5 3.4.7 4.2 1.3 1 1.5.8.4 2.7-.7.9-1.1.7-2 .3-.9-.6-.7-3-1.4-3.7-1.4-.8-.6-.8-1.7.2-.3 1.3 0 1.6.5 2.7.4.7.4 3 1.2 3.2 1.2.7 1.3.6-.2 2-1 0-1.6.3-2.4-.7-1-.8-.4-3.2-1.7-3.2-1.2.1-1.5.1-1.4 1.8.3 1.5-.3 3.8.9 4.7 1.1.5 1.8.4 2.2 1.1-.4.3-1 1.3-1.4 1.5-.8 0-1.6-.5-2.5-.7-1-.5-.5-1.4-1.4-2-1 .3-1-1-1.5.3.2 1.2-.2 2.6 1 3.4.8.5 1.5 1.7 2.4 2.3 1 1.2.6 1.4 0 3-.9.1-1.8-.5-2.7-1-.9-.7-.7-3-1.6-3.5-.7-.8-.5-1.4-1.7.2 0 1 .1 1.2.4 2 0 1-.2 3.2.8 3.9 1 .2 2.2.7 3 1 .8 1 .1.8-.8 2.2-.5 1.4-.5 1.7-1.4 2.4-.8 1-1 1.5-.4 2.8z"
        />
        <path
          fill="#ff0"
          d="M121 267.9c.7-1.2 1.1-1.4 0-3.4-.8-.7-1.6-2-2.4-3.1-1-1.6-1.3-2.2 0-2.7.8-.3.6-3 1.5-3.7 1.4-1.1 1-.3.5-1.9-1.4-1.7-1.5-.8-2.7.2-1 .7-.7 3.5-1.5 4.2-1.6-1-1.6-1.8-1.5-3 .9-.7.9-3.6 1.2-4.3.6-1 1-2-.2-2.9-.8-1-.2-.4-1-.3-1 .7-.7 3.5-1.6 4.2-1.2.8-1.4.5-2.4-.8-.1-1 .3-1.7 1.4-2.6 1.1-.8.5-3.3.8-4.3-.6-1.4-.5-2.6-1.8-2.4-1 0-1.2.3-2 1.5-1.2 1-.4 3.2-1.8 3.2-.9-1.6-.4-1.8.8-2.8.5-.7.2-3.7.4-4.5.2-1.2 1-.2-1.1-2-1.2-.3-.2 2.6-1 3.6-.3 1.2-1 2-2 1.6-1.5-.6-1.2-1.5-.6-2.5s.3-3.8.7-4.7c1-1 1-1.4 0-3-1.3-1.4-1-.3-2.2.6-1 .7-.7 3.5-1.6 4.2-.5-.5-1-1-1.1-1.8.5-.8.7-1.6 1.8-2.5.8-.9-.4-3.5-.6-4.8-1-.2-.4 2.2-1.5 3-.7.5-1.4 1.2-2 1.2-1.3-1.3-1.4-1-.2-2.5.1-1 .7-2.5-1.2-2-.3 0-.5 1-1.1 1.6-1 .7-1.9 1.3-2.5 2.2-.4.7-1 1.7-1 2.3.8.5 1.5.5 2.6 1 .8-.2 1.2-1 1.5-1.1.3 1.2-.2 1.6-.5 2.6-1.2 1-3.2-.7-3.2 1 .8-.1 3.2 1 4 .7.6-.5 1.3-1.2 1.8-1 1 1.5.8 1.9-.3 2.8-1 .8-3-.4-3.1.5.3 1.4.2 1.4 1.3 1.6 1.3.5 2.9 1.9 4 1 1.5-1 1.5-1.3 2.7.6.6 1.1.3 1.5-.5 2.2-.9.8-3-.4-4 0-1.2 1.2-.9.4-.4 2 1 .8 1.4.7 2.7.5.8-.2 3 .8 3.4 0 1.1-1 1-1.1 1.7 1-.4 1.2-.3 1.8-1.6 2.3-1.1.8-3-.9-3.6.5-.4 1.4-.5 1.7 1.1 2.2 1.5.3 3.4 1.8 4.7 1 .9-1 1-1.8 1.9-2 .1.6.7 1.6.7 2.1-.2.9-1 1.5-1.6 2.4-.8.9-1.5 0-2.3.7-.1 1.1-1.4.6-.3 1.7 1 .2 2.3 1.2 3.4.4.9-.7 2.3-1 3.1-1.7 1.5-.6 1.5 0 2.8 1.2-.3 1-1.2 1.7-2 2.4-1 .7-3-.4-3.9.3-1 .5-1.4 0-.5 1.9 1 .5 1.2.3 2 .3 1 .5 2.8 1.6 3.9.8.6-1 1.6-2 2.2-2.8 1.1-.4.7.2 1.6 1.7 1.1 1.2 1.4 1.3 1.7 2.5.6 1.2 1 1.7 2.4 1.5z"
        />
        <path
          fill="#ff0"
          d="M98 314.5c0-5.3-.8-10.6 0-10.6 46.8 0 58.5-32 58.5-53.2S140.3 208 109.7 208c-35 0-46.8 20.8-46.8 42.6A37 37 0 0 0 98 287.9c23.4 0 29.3-5.3 46.8-26.6-5.8 26.6-35 37.2-46.8 37.2-23.4 0-46.8-16-46.8-47.8 0-26.6 17.5-53.2 58.5-53.2 35.1 0 58.5 26.6 58.5 53.2 0 37.2-29.2 63.8-70.2 63.8z"
        />
      </g>
    </g>
  </svg>
	),
	WF: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#00267f" d="M0 0h213.3v480H0z" />
      <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	WS: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#ce1126" d="M0 0h640v480H0z" />
      <path fill="#002b7f" d="M0 0h320v240H0z" />
      <path
        fill="#fff"
        d="M180 229.3l-20.7-14-19.9 14.1 6.5-24.9-19-15.2 24.5-1.5 8.1-23.6 8.8 24 24 .7-19 16.3zm-3.6-165.6L159.8 53l-16 10.4 4.4-20-14.6-12.7 19.4-1.6 7.2-18.6 7.4 18.7 19.1 1.7L172 44.3zm-73 59.5l-16-11-16.7 11 5.2-19.4L60.8 91 80 90l7-19 6.8 18.9 19.6 1.1-15 12.5zM250 110l-15.4-10-15 10 4.4-18.3-14-11.8 18.3-1.5 6.3-17.2 7 17.4 17.7 1-13.7 12.3zm-43.1 43.4l-10.3-6.4-10.3 6.6 2.7-12.3-9.2-8.3 12-1 4.6-11.6 4.9 11.6 11.9 1-9.1 8.3z"
      />
    </g>
  </svg>
	),
	XK: () => (
  <svg viewBox="0 0 640 480">
    <path fill="#244AA5" d="M0 0h640v480H0z" />
    <path
      fill="#D0A650"
      d="M253 224.8s1.2-.8 1.6-.9c.5 0 2-.6 2-.6s1-.5 1.5-.5c.6 0 1.6.6 2 1.1.3.5 2 1.4 2 1.4s1.2.4 1.5 0c.2-.4.7-.7 1.3-.7.5 0 .6-.5.6-.9s.2-.9.6-1.4c.5-.5 1.3-.8 1.3-.8s1.2-.5 1.3-1.2c.2-.7 1.3-1.2 2-1.3.7 0 0-.4 1.8-.2 1.7.2 2-.4 2-.9.1-.5 0-1 1.1-1 1.1.2 1.6.2 1.6-.4 0-.6 1-1-.7-1.4-1.8-.5-1.6-.1-1.8-1 0-.7 0-.6-1.1-.7-1.2-.1-.6-.7-.7-1.3-.1-.6-.4-1-.6-1.3-.3-.4-.9-.4-.9-1s-.1-1-.7-1c-.7 0-1 0-1-.5 0-.6.2-1 .8-1 .7 0 1-.6 1-1.2-.2-.6-.2-1.9-.2-1.9l.9-1s2.6-2.1 2.8-2.5c.2-.4 1.1-.7 1.5.1.4.8.6 1 1 1.4.3.4 1.3.1 1.5-.3.2-.4.3-1.9.9-2.7.6-.7 1-1.1 1.1-1.8s.5-1.2 1.2-1.2c.6 0 1-.9 1-1.4 0-.5.4-1 1.2-1.2.8-.1 1.3-.6 1.6.2s.6.7 1.1 1c.6.3 1.4.6 1.8.3.5-.4.7-1 1.3-.7.6.4 1 0 1.2-.7l.3-1.9s.1-.5 1.1-.5.3-.6.8-1c.6-.4.6-.8 1.3-.6.7.3 1.8-.3 1.3-1-.6-.6-1.8-1.6-1.1-2.4.7-.8 1-2 .3-2.2-.7-.1-1.8.1-1.9-.6-.1-.8-.4-1.4.5-1.5.8-.1 2.2-.1 2.7-.5.4-.4 1.8-.7 1.8-1.8 0-1.2.4-1.3.6-2 .1-.6.1-2-.5-2.6-.6-.7-1.4-1.6-1.5-2-.2-.4-.7-1-1.6-1.3-.8-.2-1.6-.4-1.6-1 0-.7.6.1.6-1.6 0-1.7-1.1-2-1.1-2l-1.7-1s-3-.8-3.8-.8-1.8-.8-.9-1.4c1-.5 1.2-1.5.9-2.2-.4-.7-.6-1.3-1.9-1.6-1.3-.3-1.6-.6-1-1.4.5-.7.7-1.3 1.4-.7.6.5 1.8.7 2.7.3 1-.4 1.3-.8 1.8-.3.4.4 1 .8 1.7.2.7-.7 2-.8 2.6-.5.5.4 2 .3 2.4 0 .4-.2 1.4-1 1.4-1.3s.6-1.2 1.1-1.5c.6-.4 1.3-1.4 1.9-1.4.6 0 .8-.7.8-1 0-.5.5-1.4.6-1.7 0-.3 1.2-.8 2 0 .9.5 2 .8 2 .8s1 .2 1.7 0c.5-.3 1.3-.5 2.1 0 .9.6 2 .6 2 .6l.3-1.3c0-.4.2-1.2-.3-1.5-.4-.3-1-.7-.1-1.4 1-.6 1-.5 1.9-.5l2.2.1c.7 0 1.8.7 1.8 1.3 0 .6.5 1 1 1.4.6.3 1.3.6 1 1.2-.1.5-.1 1 .6.8.7-.1.9.3.9.9 0 .5.2.8 1 1 .6.2 1 .7 1 1.2s-.2.9 0 1.4l1 1.4s1.3 1.5-.4.7c-1.6-.7-2-1-2.5-1l-1 .5-1.3.2c-.6 0-1.2 1.2-.2 1.4.9.2 1.2.4 1.2 1.2s-.3.5-.8 1c-.4.6-.8.2-1.6.2s-1 .7-1 1.3.3.6.6 1c.4.6 1 .7 1.6.2.5-.5 1-.9 1.3.1.4 1 .9 1 1.5 1 .7 0 1 0 1.6-.4.5-.3 1.2 0 1.3.9.2.8.7 1 1.3 1.3.6.3 1 .5 1 1 .2.6.5.8 1.1.5.6-.4 1.5-.6 1.9-.1l.9 1.2v1.1l2.3.8.2 1c0 .3.4.6 1 .4h1.6s.8-.3.8-1c0-.6.3-.8 1-.8.5 0 1.8.5 2.1-.2.4-.6 1.4-.8 2.2-.5l3 1.2s-.3 0 .4 1.1 2 1.1 2 1.1 0 1 .3 1.4c.2.4 1.3.6 1.8.2.6-.4 1.4-1 2.1-1s1.2 0 1.2-.4-.7-.7-.7-1.4.7-.6.8-1.3c.1-.6.8 0 1.3.4s1 .8 1 1.2c0 .5 1 2 1.5 2.2.6.2 2.1.3 2.6-.2.4-.6 1.6-.8 1.5.5-.1 1.3-.4 1.4.4 1.8.8.4 1 2 .3 2.4-.7.4-1 .5-1 1.2s-.2 1.6.4 2c.6.5 1 .8 1 1.2 0 .5.6 2.4.6 2.4s.4 1.9.2 2.3c0 .5-.3 1.2.7 1.1 1-.1 1.3-.1 1.3.7s.4 1.2-.2 1.5c-.6.4-1 1.4-.4 1.6.6.2 1 .6 1.2 1 .1.4 1 1.2 1.6.7.6-.4.7-.6 1.2-.7.4-.1.8-.4.3-1-.4-.5-.6-1-.1-1.4.5-.3.7-1.3.7-1.3s.7-1 1.5 0 1 .6 1.5.6.8.5.8 1c0 .6 1.2.5 1.2 1.3l.2 3s0 1.1.7 1.5c.7.5.6.6.2 1-.3.6-.2 1.5-.2 2s.2.5-.3 1c-.6.4-.9 1-.5 1.6.3.6.2 1 1.1 1.8 1 .7.9 1 .9 1.6 0 .5.9 1.3.9 1.8s.7 1.2 1.3 1.3 1.2 1 1.2 1.6l.1 1.9s0 .3.6.3c.7 0 1.2.8 1.4 0 .2-1 1-1 1.4-1.3s1.4-.6 1.9-.3 1 .3 1.5.3l2.6.1s.6 0 1 .8c.3.8 1.3 1.8.8 2.2-.6.5-.6 1.3 0 1.3s1.5 0 1.5.5c0 .6 0 1 .7.7.5-.3.9-.4 1.1 0 .3.4.7.4 1.3.7.6.4.8.1 1.2-.3.3-.4 1.7-.8 1.7-.8s1.8-.5 2.5-.3l1.7.7s.4 1 .2 1.7c-.2.6-.5.5-.2 1.5.2 1-.3 1-.7 1-.5-.2-1-.2-1 .7 0 .8-.4 1-.4 1.8s0 .6-.5 1c-.4.3-.6.8.1 1 .7 0 .5.8.5 1.2l-.1 1.4s0 .5-.7.5-1.5 0-1.6.5c-.2.5-1 1.3-.3 1.9.8.5.6.8.1 1-.4.3-.8 1.3.2 1.6.9.4.8.7.2 1.1-.6.4-1.7.8-1.7 1.4s-.3.6-1 .7c-.7.1-1 1-.2 2 .8 1.1 1 1 1.6 1 .6 0 .6-1 .6-1l2.5.2c.6 0 1.4 0 1.9-.3.5-.4 1.7-.9 1.7 0 0 1 .3 1 .8 1.3.6.5.7.1 1.2.8.5.6.6 0 1-.7.3-.7 1-1.4 1.6-.6.5.9.5.6 1.2.6s1 .4 1 .9.6.5 1.5.4c.8 0 .9.5 1.2 1s.5.4 1 .4c.4 0 .9 0 1.2-.4.4-.4.8-1 1.3-.3.5.6 1.4.5 1.6-.2.3-.8 1.3-1.4 1.9-.6.6.9 1 .9 1.6 1 .6 0 1.4 0 1.7.6.4.6 1.5 1.4.7 2-.8.7-1.7 1.5-1 1.8a3 3 0 0 1 1.6 1c.5.4 2 .7 2.7.8.7 0 1.2.2 2-.5.9-.6 1.7-.6 1.6.3-.1.8.3 1.8.3 1.8s.6 1.4.6 1.9-.1.6 1 1.3c1 .6.8 1 1.7.4.8-.6 1-1 1-1.5v-1.7s1.2-.2 1.6-.5c.5-.4 2.3-1.3 2.8-.9s1 .3 1.5.1c.5-.2 1.4-.2 1.9-.2.4 0 1.2.1 2.2-.6.9-.8.9-.6 1.5 0 .5.5.5 1.1.2 1.6-.4.4 0 1.3.8 1.3s1 .5 1 1l.3 1.7c0 .4 0 .7 1.4 1 1.2.3 1 1 1.2 1.6.3.5.3 1-.4 1s-1 .3-1 .8c-.2.5-1.2.7-1.2.7l-1-.2s-.8 0-1.1.4c-.4.5-1 1.3-.6 2 .5.8.5 1.2 0 1.6-.4.3-.7 1.9-1.1 1.6-.5-.4-1 0-1.5.3-.5.2-.4 1.7.5 2.2 1 .6 1.2 1.3 1.2 1.3l1 1.6s-.3.3-.5.9c-.3.5-1 1.6-.3 1.8.7.2.4 1.4-.3 1.4s-1.5-.4-1.6.5-.5.6-1.2.5c-.7 0-2.4-.5-2.9.3-.5.9-.6 1.2-1.4 1.1-.8 0-.5 1.3-.2 1.8l1 1.3s.7.5.7 1.6c0 1-.5 1-1 .2-.4-.7-1.3-.6-1.4.2-.1.9-.3 2.2-1 2.2-.9 0-1.2.2-1.6.6-.3.4-.9 1.2-.9 1.6s-.1.9-.7 1-.7 1.2-.7 1.2-1.4.3-1.5.8c-.1.5.1 1.4-1 1.5a3 3 0 0 0-2.2 1.4c-.4.5-.5 1 0 1.5s.8 2.2 1.4 2.5c.5.3 1 .5.9 1.3-.1.9-.8 1.5.1 1.5 1 0 1.5.2 1.2 1-.4.7-.4.8-1 1.1-.8.4-1.1.4-1.1 1.2s.2.9-.4 1.2-.6.7-.6 1.4-.2.4-.9 1.1c-.7.8-1.6.8-2.2.6s-.7-.2-.8-.9c-.1-.6-1.1-.6-1.7-.5-.6 0-1.4.7-1.4.7s-1 .7-.6 1.2c.5.5.2 1.4-.6 1.3-.8-.1-2.6.8-3.2-.1-.6-1-2.2-1.6-2.5-.3-.2 1.2.7 1.1.6 2.4 0 1.3-.3 1.3-.8 1.7-.4.4-.4.8-.6 1.3 0 .5-.2 1.7.6 2.1.8.5 1.2 1.6 1.2 2.3 0 .6 0 1.3.8 1.3s1.5-.2 1.6-.9c.1-.7 1.7-1.2 1.9.3 0 1.5 0 2.3.7 2.9.5.6 1 1.5 1.5 1.8.4.3 1.2 3 1.2 3-1.1.3-1.4 1.8-2.1 2-.4.2-.9 0-1.3.3-.2.3-.2.7-.6.8-.9.4-.7-.9-1.8-.4-.9.4-1 1.5-2.3 1-.7-.2-1.1-3-1.3-3.6l-1.1-1.8c-.8-1.2-2.3 0-2.8-.4-.8-.5-.5-1.4-1.7-1.5-2.4-.2-.7 1.5-1.7 1.8-2 .7-2-1.8-3.4-.6-.5.4 1 .7.6 1.4-.3.6-1.7 1.6-1.7 2.3.2 1 1.2 1.3 1.5 2 1 2.3-.5 3.8-2.7 2-1.2-.9-1.5-2.7-3.3-2.5-.5 0-.6.4-1 .5-.5 0-.8-.4-1.3-.3-.7.3 0 .8-.2 1.2 0 0-1 .7-1 1-.6.6-.4 1.2-1.2 1.8-.6.5-1.1.2-1.8 1-.7.7-.8 1.9-1.7 2.6-.5.4-.8-1.1-1.4-.1l-.2.4c-.2.3-.2.4 0 .7 1.2 2.4-1.4 3.2-2.2 4.9-.3.7.6 1.3.3 1.9l-1.5 1.7c0 .2-.2.8-.4 1-.2.2-1 0-1 .4s.8.7 1 .9c.2.3-.2.7 0 .8 1.2 1.3.5.9 1.1 2 .1.2.5-.1.7.3.1.4-.4.4-.2.8 0 .2 1 1.4 1 1.4 0 .4-1.8 1.2-2.2 1.2-1.1 0 1-2.2-.8-2.2-.8 0-.9 1.7-1 2h-1c-1.2 0-2 1.4-2.4 1.5-.3.1-1-.2-1.5 0-.4 0-1 .5-1.4.5-.3 0-.4-.2-.7-.4-.5-.3-1.5-.4-2-.6-.4 0-1 .4-1.2.3-.3-.2.3-1-.6-1.4l-.7-1.7c.3-1 .6-2 .5-3.1-.2-1.1-2-2-2.4-3-.3-.6-.6-2.4-1.3-2.8a6.2 6.2 0 0 1-1.8-2.2c0-.2.3-.6 0-1-.3-.3-.8-.5-1-1-.1-.4 0-1.8-.5-2.1-.5-.3-4-.8-5-.9-.4 0-.7 0-1-.3l-.6-.7-1 .2c-.3 0-.8-.2-1 0-1.1.7-1.4 1.7-2.5 2.6-1.1.8-2.3.8-3.4 1.7-.7.6-1.2 2.1-1.9 2.8-.3.3-.7 0-.8.1-.6.7-1.4 1.2-2 1.8-.1.2 0 .4-.2.5l-1.3.4h-1.2c-.5.2-.5.8-2.5 1.2l-.5.3-.6.5h-.9c-.5 0-.8.5-1.2.5-1 .2-2.8-.5-3.6-.1-.5.1-1.8 1.7-2.3 1.8-.3.1-.6 0-1-.1l-.6 2.2-2.4 2.1c-.3.3-.4.7-.8 1-.2.3-.6.5-1 .5s-1.1-.4-1.6-.4c-.8-.2-3.3-.3-4-.1-.9.1-.6 2.4-2.6 2.6l-3.3.4c-.1 0-.8-.4-1.5-.3-.3.1-1.1 1-1.1 1.2v.5l.2.4c-.4.5-1.4 1.3-1.7 2l-.4.4c-.2.2-1.6.7-1.7.9-.3.8 1 1.6.8 1.9-.3 1-1.7 2-2.2 3-.1.4.5 1.7.5 2.1-.2 1.3-.6 2.9-.5 4.1l.2 1.7.7.5 1.8 3.6c.3 2.2-3 1.4-1 3.6.2.4.4.7.8 1l2.8 2.3c0 .4-2 .7-2.3 1-1 1-1.7 2.6-2.6 3.6-.6.5-1-.1-1.8 1.3-.2.5 0 1.6-.3 2-.5.4-.8-.2-1.3 0-.2 0-.3.7-.5.8-.5.5-5.2 3-5.6 2.7-.2-.1-.5-.9-.5-1.1 0-.3-.4-.9-.6-1-1.2-1-3-1.3-4.2 0-.3.3-.3.8-.7 1l-2 1.6-.5.5c-.5 0-1.6-1.3-2-1.7-.4-.6-2-2-2.1-2.7 0-2.4-1.9-4.9-2.6-7.2h1.1c1.3-.9 1-3 3.3-2.2.3-.4.3-.8.8-1 .2-.2.6-.3.7-.5.8-1.2 1.7-5.8.9-7-.7-1-1.5-1-2-2.7-.2-.5 0-1 0-1.6l-1-3.1c-.2-.3-.7-.5-.7-.7l-.2-3.1c-.7-2.2-3.4-3.5-3.5-3.8l-1-1.7c-.4-.7-.4-1-.6-1.6-.1-.3-.6-.6-.6-.9 0-.6 1.6-1.7 1.5-2.7 0-.3-1-1.3-.8-1.8.2-.6 1.2-1.8 1.2-2.5 0-.8-1.6-2.6-1.8-3.4-.1-.5.6-.8.4-1.1-.2-.4-1.8-1.9-2-2.3-.3-.3.5-.7 0-1.3-.6-.5-.1-.4-.3-.8-.2-.5-.7-1-1-1.5-.2-.5-1.6-5.5-1.5-5.8-.3-.3-.7-.6-.9-1l-.4-1.2s-1.6-.5-1.9-1c-.2-.3-.3-1.6-.7-2.2-.2-.3-.5-.2-.7-.4-.2-.2-.2-.5-.3-.7-.5-.6-1.4 0-2-2.4-1-.6-1.7-1-2.4-1.8l-.4-.4c-.6-.2-1.5-.3-2-.7-.3 0-1.8 0-2-.2l-.4-.8c-.8-.1-2.2 0-2.9-.6-.5-.5-.6-2.8-1.6-2.5a.7.7 0 0 0-.4 0c-.7-1-2.9-1-3.8-1.6-.2-.1-1 0-1-.2l.1-1.3-1.1-1.4c-.9-.2-.6-.3-1-.6-1.5 0-1.7.2-2.6 1-.2.2-.7.3-1 .4-.5.3-.6 1.2-1.3.8l-.6-.5c-.4-.4-.6-.2-.8-.8-1.2-.7-4.5 1.5-5.2 0-.6-.3-1 0-1.5-.4-.2-.2.7-3-1.7-4l1.6-1.1c.2-.3 0-.8 0-1 0-.5.3-1.4.2-1.7 0-.3-.4-.6-.5-1-.2-.3 0-.8-.2-1.2l-.8-.4c-.6-.5-1.2-.8-1.7-1.4l-.4-.5c-.4-.3-1.8-.8-1.8-1.4 0-.2.4-.3.4-.5.1-.3 0-.6.3-.8.6-1 2.1-.5 1.9-2.2-.1-.8-.7-1.4-.8-2.2-.3-.2-.3-.5-.5-.7-1.5-.1-1.3-1.6-1.8-2-1.5-1-2.7-.4-1-2.4.2-.7-1.5-1.8-1.8-2.1-.6-.6-.3-1.9-.6-2.5 0-.3-1.1-.9-1.4-1.3l-.5-1v-.1c.3-.3.2-.8 0-1-.1-.3-.6-.2-.7-.4-1.4-1.2-3-1.8-4.9-2.5-.5-.2-.3-.6-.8-.8l-3-1.2c-.2 0-.4-1.1-.6-1.5l-.9-1c0-1-.6-1-1.4-1.6v-.6l.6-2.1c.1-.4.6-.8.5-1.2l-.4-2.3c-.8-2-1.7-1.8-1.2-4.5 0-.6-.1-.9.3-1.4l.2-.3 1.2-.9c.4-.6.7-1.9 1.2-2.3l1.8-1.2c.2-.2.4-.9.3-1.2-.4-.2-.8-.1-1.2-.2-.2 0-.7-.4-1.1-.4-.1-.2-.3-.3-.3-.5l-.2-.2c-.5 0-1-.3-1.4-.5-.5-.2-1.2-.2-1.7-.5-1-.5-2-2-2.9-2.2-1.2-.3-2 .1-3.2.2-.7 0-.7-.4-1.3-.6-.8-.3-.2.4-2-.2-.3-.2 0-.8 0-1h-1c-1.4-.4-.9-1.8-1.3-2.7-.1-.2-.8-.2-1-.2-.2 0-.2-.2-.2-.2l.2-.1c.2-.4-.7-1.4-.7-1.6.1-.3 2-.6 2.2-.6.1-.3-.1-.5-.2-.7 0-.5.3-1.2.5-1.7v-.2c-.6-.3-.7-.7-1.2-1 0-.3.3-.4.4-.7.9-2.5 2.3-.5 3.5-2.8.1-.2.5-.7.6-1.1h.2c.2 0 .6.2.8 0 .2-.2.5-.2.8-.3h.5c2.2-.4 1.7-1.2 3-2.1.4-.3 1.4-.4 1.8-.6.5.3 1.2 1 2.1 1.4.7.2 3 .7 3.4 1 .5.2.6.8 1 1 1.3.8.5-.4 1.8-.2 1.3.3 2.3 1.4 3.5 1.9l1-.1c.3-.1 2.3-.5 2.5-.4l.8.3c.3.1.5-.5.8-.5.8.2.8.5 2 .4 0 0 .6-3.3 1.2-3.4.3-.1 1.2.7 1.4.8.4.1 0-.7 0-.7-.2-.3-.8-2.3-.7-2.5 0 0 .5.2.8.1.6-.2 1.5-.4 2-.9l1-1.5c.1-.2-.2-.8 0-1l.9-.6c.4-.4.4-1 1-1.3 2-.2 2.7-1.8 4.6-2h.6l.4.6c0 .1 1.3.9 1.5.8.2 0 .3-.3.5-.4.3.1 1.4-.5 1.5-.9 0 0-.2-.3-.1-.6a12 12 0 0 1 1.6-1.2h1.4c.2.2.2.6.5.6h1.2c.2 0 .3-.5.7-.5z"
    />
    <g fill="#FFF">
      <path d="M351.9 73.4L368 123l-42.2-30.7H378L335.8 123l16-49.6zM414.7 84.5l16 49.6-42.1-30.7h52.1l-42.2 30.7 16.2-49.6zM474.6 106.3l16 49.6-42.1-30.7h52.1L458.4 156l16.2-49.6z" />
    </g>
    <path
      fill="#FFF"
      d="M288.1 73.4L272 123l42.2-30.7H262l42.2 30.7-16-49.6zM225.3 84.5l-16 49.6 42.1-30.7h-52.1l42.2 30.7-16.2-49.6zM165.7 106.3l16.2 49.6-42.2-30.7h52.1l-42.2 30.7 16.1-49.6z"
    />
  </svg>
	),
	YE: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v472.8H0z" />
      <path fill="#f10600" d="M0 0h640v157.4H0z" />
      <path d="M0 322.6h640V480H0z" />
    </g>
  </svg>
	),
	YT: () => (
  <svg viewBox="0 0 640 480">
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#00267f" d="M0 0h213.3v480H0z" />
      <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
    </g>
  </svg>
	),
	ZA: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-71.9 0h682.7v512H-71.9z" />
      </clipPath>
    </defs>
    <g clipPath="url(#prefix__a)" transform="translate(67.4) scale(.93748)">
      <g fillRule="evenodd" strokeWidth="1pt">
        <path d="M-71.9 407.8V104.4L154 256.1-72 407.8z" />
        <path fill="#00c" d="M82.2 512.1l253.6-170.6H696V512H82.2z" />
        <path fill="red" d="M66 0h630v170.8H335.7S69.3-1.7 66 0z" />
        <path
          fill="#fc0"
          d="M-71.9 64v40.4L154 256-72 407.8v40.3l284.5-192L-72 64z"
        />
        <path
          fill="#093"
          d="M-71.9 64V0h95l301.2 204h371.8v104.2H324.3L23 512h-94.9v-63.9l284.4-192L-71.8 64z"
        />
        <path
          fill="#fff"
          d="M23 0h59.2l253.6 170.7H696V204H324.3L23 .1zm0 512.1h59.2l253.6-170.6H696v-33.2H324.3L23 512z"
        />
      </g>
    </g>
  </svg>
	),
	ZM: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <path fillOpacity={0.7} d="M-170.7 0H512v512h-682.7z" />
      </clipPath>
    </defs>
    <g
      fillRule="evenodd"
      clipPath="url(#prefix__a)"
      transform="translate(160) scale(.9375)"
    >
      <path fill="#198a00" d="M-256 0h768v512h-768z" />
      <path fill="#ef7d00" d="M421.9 184H512v328h-90.1z" />
      <path d="M331.9 183.8h90v328h-90z" />
      <path fill="#de2010" d="M240 184h91.9v328h-92z" />
      <g fill="#ef7d00" stroke="#000">
        <path
          strokeLinejoin="round"
          d="M451.6 65.6s34-14.5 37.2-17.5c1.5 1.8-13.6 20-42.9 26.7 26.6-6.2 49.3-26 54-25.4 1.3.3 1 19.3-60 35.8 42.2-11 66.7-31.4 66.4-29.2.3.5-4.2 16-41.1 28.1 10.3-2.4 38.3-19.4 38-16.1.9 1.3-27 37.2-77.6 25.5 40.4 10.5 66.5-14.8 70.2-14.3.8.1-7.4 22-58.2 23.4 24.3-2.5 17.3-.1 17.3-.1s-14.3 11.2-31.7 3.6c13.6 3.7 15.1 3.9 15.4 5-.9 1.6-12 3.8-22.9-2 8.7 3.6 16.5 4.2 16.6 5.5-.1.4-5.6 3.6-10.6 1.3-4.9-2.2-50.3-30.1-50.3-30.1l77.4-21.3 2.8 1zm-91 75.6c-6.8 0-7 6-7 6s-.5.5-.2 3.4l1.7-2.6c.8.1 3.9 1 8.8-2.8-4.5 4.7-1.8 6.4-1.8 6.4s-1 3.7 2.4 4.4c-1-1.5-.4-2.8-.4-2.8s4.8-.5 4.5-6.3c.1 5.3 3 6.6 3 6.6s0 2.9 3.1 3.2c-1.6-1.5-1.3-3.8-1.3-3.8s4-3 .7-8c2-1.2 3.7-4.5 3.7-4.5s-2.8-1.2-4.1-2.2c-.6-1.3 0-8.5 0-8.5l-1.8-9.3-4.8 14.5c.2-2 .3 6.3-6.5 6.3z"
        />
        <path
          strokeLinejoin="round"
          d="M394.2 120.3c.2.1 5.1 5.6 9.9 5.3 1.8-1.5-3.7-4.7-3.7-5.5 2 1.8 10.1 8.8 15.4 6.3 2-3-3.8-2.5-10.2-10.6 4.5 3 15.7 9.5 21 7 2.1-2.4-11.7-9.9-16.4-15.7l-12-6.1-16.2 13.3 12.3 6z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M375.9 74.8s5.5-3.2 27.6-1.6c2.4.3 15-4.3 19.1-5.7 6.4-1.2 27-5.6 32.4-9.8 4-.5-1 7.1-6 9-5.2 2.3-24.1 8.9-30.9 8 8.1.1 3.6 6.7-9.8 3.6 6.4 3.6 4 4.2 4 4.2s-11.3.6-14.3-2c7.6 2.9 4.4 4 4.4 4s-7.7.7-11.3-1c5.5 1.7 2.7 2.7 2.7 2.7s-4.5.8-8.2-.6c-3.8-1.3-9.4-10.7-9.7-10.7z"
        />
        <path
          strokeLinejoin="round"
          d="M384.7 123.4l.8 14.6-.8 1.2c-.3.4-10.3-1.6-9 6 0 3.2 0 4 2.2 5.7-.5-2-.4-3.5-.4-3.5s2.9 1.7 5.6-3c-1.9 4.6-.6 6.3-.1 6.4.4.8-.8 4.5 3 4.4-1.5-1.4-.8-3.4-.8-3.4s4-.6 2.6-7.7c1.4-1.4 2 0 2 0s.4 4.2 3.9 3.3c1.5.9-.3 3.2-.3 3.2s2.5 0 3.3-2c.7-2.2 1.6-6-2.5-7.6-.5-1.5 1.6-1.6 1.6-1.6s2.6.9 3.4 2.2.5-3.4-2.8-4c-4 0-4.2-.9-4.2-1l-1-13.7-6.5.5z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.1}
          d="M398.6 135.8c0-.7-6.8-9.9-5-11 1.7.3 4.5 4.5 6.9 3.1-.7-1.6-2.8-.7-5.1-4.9-2.4-4.8-2.7-11.9-11-19.6 5.4 8.2 17.4 13 18 10.6s-10.7-11.4-10.1-13.6c2.2 4.4 13.4 14.4 21.6 13.6.6-2-6.7-5.8-8.6-9.4-5.3-3.6-19.4-15.7-19.6-18.5a33.3 33.3 0 0 0-9.9-10.6 5 5 0 0 1-.8-1.7c-3.2-7.5 1-10 3.5-10.3 2-.3 2.6 0 4-.7l-5.1-2c2.3 1.7 8 .2 6.8 5 2.5-1 7.9-7.4-6.1-8.8-4.6-5.2-23.3-8.2-28 14.6.4.3.6.6 1.8 1.4-6-2.8-21.9-5-27.6-6-15.6-4.4-31.7-15.2-33.2-13.9-2 1 9.4 11.6 8.8 11.8a263 263 0 0 0-27.5-13.6c-6-2.2-11.9-7.4-12.5-6.4-2.2 4.5 9.5 15.9 11.7 17.2 2.2 1.3 19.3 9.3 19 9.4-25.8-11.7-30-13.9-31.4-15.2-2.3-.5-7.8-8-9.3-7.5-.9.8.8 12.6 13.1 18 2 1.4 26.4 10.1 26.2 10.8 0 .2-28-11.5-29-12-5.4-2-12-9.4-13.2-8.6-1.2.8 3 8.8 8.4 11.3 2.9 1.2 13.8 6.6 23.6 10 .6.3-17.7-6.9-26.5-10.5-4-2.2-5.8-5-6.4-4.4-1 .6 1.4 12.4 29.7 19 .7.4 10-2.1 9.5-1.8a113.3 113.3 0 0 1-15.8 2.8c-.3.8 1.8 5 16.4 4.2 1.8-.1 12-3.7 11.1-3a174 174 0 0 1-14.8 4.9c-.9 0-5.6.6-5.8 1-.2.8 3.5 3.8 11.3 4.2 7 .4 20.2-4.2 20-3.9-.4.3-12.8 4.6-13.1 4.8-.5.3-5 .5-5.2.9-.4.9 6.6 7.4 27.1.4-2 2.8-12 4.7-12 5.2 0 .4 2.2 2.5 5.7 3.3 1.7.4 4.1.3 6.3 0 4-.8 8-2.3 13.3-7.2.6 1.5-13.1 8.5-12.5 9.1 3 2.8 12.9-.3 13.5-.7.7-.3 19-10.7 19-12 .3 1.6-23.7 14.7-23.4 15.2 1.5 2.4 9.7-.1 10-.4l10.8-5.8c.3-.1-11.8 7-10.8 8.2-.5 4.7 19-3.2 20.5-4.2.7-.5-9.4 4.4-9.4 6.7 3.3 5.5 13.7 3.8 15.3 2.6.8-.6-1 4-.4 3.6a16 16 0 0 0 3-4.3c-.2 1.6-1.4 4-2 6.8-.7 2.7-.9 5.9-1.8 9.2-.2 1.4 6.4-2.9 5.4-13.2.6 5.4-2 15.4-1.3 16 1.3 1 5.2-5 5.6-9.1 1.1 2 3.5 6.3 5.6 7.3-.2-3.1 0-3-1-6 .6-4.1.7-9.7.8-16.1 5.6 10.7 7.9 15.3 6.3 23.5 1.7.7 4.3-5.8 4.1-9a13.3 13.3 0 0 0 11.5 10.2z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.1}
          d="M305.4 67.7s-3.9 2.9-8.6 2.7c1.2 4.8 11 1.1 11 1.1s-4.7 5.3-8.1 6.1c2 1.7 10.6 1.1 12 .3 1.4-.9 4-4.2 4-4.2s-8.8 10.2-10 10.1c-.3 1.2 9.1.8 11-1 2-1.8 7-4.4 7-4.4s-13 9-13.5 9c4.8 1.2 14.5-1.6 20.7-5.4-9.2 6.1-10 7.2-14.7 9.3 4.2.9 6.3 3.7 20.3-2.4 8-3.8 12.6-10.8 12.6-10.8a81.7 81.7 0 0 1-21.6 18c-.5 1 9.4 5.2 21.9-7.9"
        />
        <path
          strokeLinecap="round"
          strokeWidth={1.1}
          d="M373.4 96s.9 4 4.3 7 3.6 6 3.6 6m-9.5-39s1.1 3.7 4.6 6c3.6 2.2 9 9.4 9.3 10.7.4 1.5 2.5 12.6 2.3 13.8m-37.8-25c.2 1.5-5 8.3 2.2 16.4-6.6 8-6.6 9-6.6 9s3.7 2 10.2-3.6c10.8 13.2 7.2 19.2 7.2 19.2"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.1}
          d="M362.3 107.2s-1-1.4.8-6.7c1.6 2 3.4 2.3 4.1 3 .8.9 9 2 9.4 7.5"
        />
        <path
          strokeWidth={1.1}
          d="M371.9 57.5c0-.4-1.7-4-7.8.4 3.3.2 6.5 2.1 7.8-.4z"
        />
        <path
          strokeLinejoin="round"
          strokeWidth={1.1}
          d="M430.1 73.5c.3.2 18.2 4 24.2 2.1-7.6 10.2-22.9 3.3-22.9 3.3 7.5 2.2 7.8 2 10.2 4.2.8 2-13.8 1-18.5-1.7 13.3 4.2 13.6 4 14 5.5.6 2.3-21.8-.6-23.7-3.5 6 4.6 9.2 5.5 12.5 7.6-4 1.8-11.5 3.6-25.2-6.1 18 16.4 34.3 15.4 36.9 18.3-6.3 9.3-30.7-5.5-41.9-13s24.5 18.1 27.8 17.7c-1.6 2.5-13.4.3-14.2-1"
        />
        <path
          strokeLinecap="round"
          strokeWidth={1.1}
          d="M434.7 90.7c-2 .3-8.3.3-9.2.1"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.1}
          d="M300.1 65s13.6 7.2 19.4 6.7a10 10 0 0 1-3.8 2c1.4.6 5.4 2.7 11.4 1.4l-3.3 3s5.2 2 11-1a46.4 46.4 0 0 0-2.8 3.7l4.1.3"
        />
      </g>
    </g>
  </svg>
	),
	ZW: () => (
  <svg viewBox="0 0 640 480">
    <defs>
      <clipPath id="prefix__a">
        <rect
          width={546}
          height={420.1}
          x={1.9}
          y={0.1}
          fill="#00f"
          fillRule="evenodd"
          ry={0}
        />
      </clipPath>
    </defs>
    <g
      clipPath="url(#prefix__a)"
      transform="matrix(1.1722 0 0 1.1426 -2.3 -.1)"
    >
      <path fill="#006400" d="M0 0h840v420H0z" />
      <path fill="#ffd200" d="M0 60h840v300H0z" />
      <path fill="#d40000" d="M0 120h840v180H0z" />
      <path d="M0 180h840v60H0z" />
      <path stroke="#000" strokeWidth={20} d="M0 0v420l280-210z" />
      <path fill="#fff" d="M0 0v420l280-210z" />
      <path
        fill="#d40000"
        d="M106.5 104.4L162 275.1 16.8 169.6h179.5L51 275.1z"
      />
      <path
        fill="#fc0"
        d="M82.8 253.7l9.8-1.8 18.1-.7 6.7.6 15 2.5 1.1-1.5V242l1.8-9.3 3-9.4 3.3-7.5 4.2-7.8 6.8 1.7h1.8l.2-1.3-14.4-12.3-15-11.5-21.7-16.2-2-.5-2.3-17-1.7-5.1-2.3-2-4.3-1.4-4.8.2-2.2 1.2-4.6 1-2.4.4-1.6 1.9-.2 2.4 6.7.2 1.7.7-.2.7-3.8.5-1.8.6 2.1 1.6 2.2.8 2.8 1 .6 2 .2 25.8-1.5 4-.5 7.5 2.2 9-5.6 6.4L77 216l-.6 3.5-1.7 3.5-.2 2.2 1.1 2.4 4.3 14.2 2.2 11.7z"
      />
      <path d="M88 142c-1.8 0-2.6.2-4.3 1.1a10.8 10.8 0 0 1-4.6 1.4c-2.5 0-4.5 1.8-4.5 4.1v1.5l3.6-.1c10.6.3 1 1.3.2 1.4-2.6.5.6 2.6 3.7 3.7 3.3 1 3.1.4 3.1 15 0 11.9 0 13.6-1 16.3-1.3 4-1.3 10 0 14 .6 1.6 1 3 1 3.3 0 .2-1.6 2.1-3.5 4.3-3.5 4-5.6 8.1-5.6 11a6 6 0 0 1-1 2.6c-1.3 1.7-1.3 4.6-.1 5.7 1.3 1.2 6.6 21.8 6.7 25.7 0 1.4.2 1.4 8.3-.2 6.6-1.3 22.1-1.6 30-.6 3.6.5 7.8 1.3 9.3 1.6 4.8 1.3 4.6 1.5 4.6-4.3a74 74 0 0 1 5.1-26.7 94.7 94.7 0 0 1 6.9-14s1.8.2 4 .8c4.1 1 5.3.9 5.3-1 0-1-4.3-4.6-25.4-21a432.2 432.2 0 0 0-26.3-19.9c-.6 0-1.2-.3-1.3-.7l-1.5-9.5c-.7-4.9-1.7-9.7-2.1-10.7-1.4-3-4.1-4.5-8.6-4.8a31.2 31.2 0 0 0-2 0zm.1 1h2c6.6.4 7.8 2.2 9.6 14a173 173 0 0 1 1.2 9.4c0 .8-.9 1.8-3.2 3.3a46.8 46.8 0 0 0-10 9.5l-1.3 1.8-.3-4.2V165c.3-8.7 0-9.5-2.8-10.5-2.3-.8-5.3-1.6-4.5-2.1 1-.6 2-.2 4.4-.9 1-.2.9-.1.7-.9-.2-1.3-1.6-2-5.3-1.8-3 .2-3.3.1-3.1-.7.4-1.6 2-2.6 4.5-2.9a13.4 13.4 0 0 0 4.4-1.3 7 7 0 0 1 3.7-1zm14.9 25.8h.4c1.7.3 50.8 38.7 50.8 39.8 0 .4-.4.7-1 .7-.4 0-12.9-3.5-27.7-7.8-23.6-7-27-8-28-9.3a5.1 5.1 0 0 1-.1-6.2 5 5 0 0 0 1-2c0-1.2-2.5 1.8-3 3.5-.5 2 .5 5.4 2 6.5.6.5 5.1 2 10 3.5 8.4 2.4 9 2.7 9.4 4.1 1 3.3-2.5 7.2-7.5 8.3a14.6 14.6 0 0 0-5.2 2.4 68.2 68.2 0 0 1-17.2 10.4c-.4.3-.9 1.9-1.2 3.4-.6 3.3-.8 3.8-1.8 3.8-.5 0-.6-.3-.2-1.4.7-2 .6-4.4-.1-4.4-.5 0-.7.7-.7 1.8 0 1-.3 2.2-.7 2.5-.5.6-.6.2-.4-2.3.2-1.7.1-3-.1-3-.5 0-1.4 2.5-1.7 4.7-.2 1.3-.2 1.3-.6-.3-.3-1.2-.2-2 .7-3.5a9 9 0 0 0 1-3.5c0-1.3 1-2.6 5.7-7.3 3-3.1 6.7-7 8-8.7 2.3-2.8 2.4-3 2.3-5.9 0-1.6-.2-3.1-.4-3.3-.6-.6-1.4 2.6-1 4.3.2 1.6 0 2.1-3.3 6a113.2 113.2 0 0 1-7.5 7.8c-3.9 3.6-5.3 5.6-5.3 7.4 0 .6-.4 2-1 3.3s-.8 2.6-.6 2.9c.2.3 0 .3-.3 0-.5-.5-.5-1.3-.1-3a7 7 0 0 0 .2-2.6c-.5-1-1.2.2-1.5 2.7-.2 1.4-.5 2.5-.8 2.3-.7-.4-.5-3 .4-4.4.5-.7 1-2.3 1.3-3.6.7-3.7 2.3-6.7 5.8-10.7a57.5 57.5 0 0 0 3.2-3.8l-1-3.3a25 25 0 0 1-.2-13.7c1.3-3.8 3.9-7.6 8-11.7 4-3.9 7.9-6.3 10-6.4zm15 32.2a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm2.5.3a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm2.6.5a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm2.4.5a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm-6.3.6a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm2.4.4a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm5.2.2a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm-2.7 0a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm5 .6c.1 0 3.7.8 8 2l7.9 2.3-1.5 2.7a96.2 96.2 0 0 0-2.4 4.4c-1 2-1.2 2-6 .9-5.2-1.2-13.4-2.3-21.8-3l-8-.7 3-1.1a50.4 50.4 0 0 0 5.3-2.4c2-1.1 2.8-1.3 5.9-1 4.5.3 7.5-.6 8.7-2.4l1-1.7zm-8.8.6a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm5.6 0a.9.6 0 0 1 1 .6.9.6 0 0 1-1.6 0 .9.6 0 0 1 .7-.6zm-8 0a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.5zm5.3.2a.9.6 0 0 1 1 .5.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.5zm-6.6 1.1a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm2.5 0a.9.6 0 0 1 1 .7.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm2.6.2a.9.6 0 0 1 1 .5.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.5zm2.8 0a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm-20.3 8.1a191.2 191.2 0 0 1 35.1 4.2c.1.1-.6 2.5-1.7 5.4l-2 6c-.1.5-.8.5-2.5.3-8.3-1.3-32.3-1.2-41.5.2-5.3.8-6 .7-5.6-.4l1-3.5.6-2.7L93 221a63.4 63.4 0 0 0 10.2-6.5h.9zm-27 14.2c.3 0 .9.3 1.6.8 1 .6 2.2 1.1 2.7 1.1 2.6 0 4 3.7 6.2 16l.8 4.4c.2 1 0 1.2-2.3 1.7-2.8.6-3.5.7-3.5.3 0-1-2.8-13.7-4-18.2a96.9 96.9 0 0 1-1.6-6 .1.1 0 0 1 .1 0zm28.6 2h2.9l-1 1c-1.7 2-2.5 2.1-3.7.8a5 5 0 0 1-1-1.5c0-.2 1.3-.4 2.8-.4zm6.1 0h5.4l-1.2 1.2c-1.4 1.6-1.5 1.6-3 0l-1.2-1.3zm8.2 0h1.3c.7 0 2 0 2.8.2l1.5.3-1.4 1.3c-.8.7-1.5 1.3-1.6 1.2l-1.4-1.6-1.2-1.5zm8.5.3l1.2.3c.7.2 2.2.3 3.3.4h2l-1.5 1.3a8.9 8.9 0 0 1-1.8 1.3c-.1 0-1-.8-1.7-1.7l-1.5-1.6zm-30.2.1h.2c.1.2-.3 1-1 1.7l-1 1.4-1.5-1.2-1.5-1.3 2.4-.3 2.4-.3zm2.3.2l1.6 1.4 1.6 1.5-3 .2-3 .1 1.4-1.5 1.4-1.7zm18 0c.3 0 .5.1.8.3a6.6 6.6 0 0 1 1.3 1.7c.4.8.3 1-1 1l-2.5-.5-1.2-.3 1.3-1.3c.6-.6 1-1 1.4-1zm-8.3 0c.5 0 1 .3 1.6 1.3.7 1.1.7 1.1-2 1.1h-2.7l1.4-1.3c.7-.7 1.3-1 1.7-1zm17 .2l1.2 1.2c1.4 1.3 1.6 2.1.6 2l-2.8-.3-2.2-.2 1.6-1.3 1.6-1.4zm-35.2.7c.2 0 1 .5 1.6 1.2l1.2 1.3-2.5.4-3.5.5c-.7.2-.5-.3 1-1.6 1-1 2-1.8 2.2-1.8zm-3.7 0h.4c.8.2.8.4-.6 1.8l-1.5 1.5-.5-1.3c-.4-1-.3-1.3.6-1.7a4.8 4.8 0 0 1 1.6-.3zm46 1.8c.2 0 .2.2 0 .6-.2.8-1.1 1-1.1.2 0-.2.3-.5.7-.7h.3zm-21.4 1.6c7.7 0 15.5.2 17.4.4 3.1.4 3.4.5 3.4 1.7 0 1.4-.4 1.5-4.6.8-1.2-.3-6.3-.7-11.2-1.1a149.6 149.6 0 0 0-28.5 1c-1.9.2-2.4 0-2.4-.6 0-1.3 10.2-2.2 25.9-2.2zm-10.3 2.9h5.4l-1.2 1.3c-1.5 1.6-1.6 1.6-3 0l-1.2-1.3zm7 0l1.4 1.4 1.4 1.6-2.9.1h-2.9l1.5-1.6 1.4-1.5zm2.1 0h5.4l-1.2 1.3c-1.4 1.6-1.5 1.6-3 0l-1.2-1.3zm-12.8 0c.2 0 0 .5-.7 1.5-.7.9-1.4 1.6-1.5 1.6-.2 0-.9-.6-1.5-1.3l-1.2-1.3H96a9 9 0 0 0 2.7-.4 1 1 0 0 1 .4 0zm2 .5l1.3 1.2 1.5 1.3-2.6.2-2.9.2 1.4-1.5 1.3-1.4zm17.4 0l1.4 1.6c1.6 1.7 1.5 1.8-2.1 1.1l-1.7-.3 1.2-1.2 1.2-1.2zm2 0h2.4c2.6 0 2.9.4 1.4 1.8-1.2 1-1.2 1-2.6-.5l-1.2-1.3zm-30.6.5c1.2 0 1.1.1-.4 1.6-1.1 1.1-1.2 1.1-1.6.3-.3-1 .6-1.8 2-1.9zm38.8.2c.4 0 1.2 0 2 .2l2.3.4-1.3 1.2-1.2 1.2-1.1-1.4-1-1.6h.3zm-36 .5c.3 0 .6.2 1.1.7 1 1 1 1 .2 1.4a8 8 0 0 1-2.4.4H90l1.3-1.4c.7-.7 1-1 1.3-1.1zm34.1.3c.4 0 .7.2 1.2 1l.9 1.2h-2.1c-1.4 0-2-.2-2-.6.2-.4.7-1 1.3-1.3l.7-.3zm6.4 1.3c.2 0 .2.2.2.5 0 1-.9 1.7-1.3 1-.1-.3.1-.8.5-1.1l.6-.4zm-25.9 1.2c8.7 0 18.3.6 24 1.6l1.6.3v4.4c0 3.3-.2 4.4-.7 4.4l-5-1a126 126 0 0 0-35-1l-2.3.3-.6-3.7a21 21 0 0 1-.4-3.8s2.3-.5 5-.8c3.3-.5 8.2-.7 13.4-.7z" />
      <path
        id="prefix__b"
        d="M124.8 217.8c-3 0-5.1 2.1-5.1 5.2 0 4.8 5.4 7.2 8.6 3.8s1-9-3.5-9zm0 1.2a4 4 0 0 1 4 4c0 3-3.3 5-6 3.7-2.7-1.5-2.5-6.1.4-7.3a4.3 4.3 0 0 1 1.5-.4z"
      />
      <use
        width="100%"
        height="100%"
        x={-20.1}
        y={-0.6}
        xlinkHref="#prefix__b"
      />
      <path d="M88 145.3a1.7 1.8 0 0 0-1.6 1.7 1.7 1.8 0 1 0 3.5 0 1.7 1.8 0 0 0-1.9-1.7zm.1.6a1.2 1.1 0 0 1 1.2 1.1 1.2 1.1 0 1 1-2.4 0 1.2 1.1 0 0 1 1.2-1.1z" />
    </g>
  </svg>
	)
}